{
  "app": {
    "name": "އެންޓަރޕްރައިޒްއޭއައި އީއާރްޕީ ކްލައުޑް",
    "shortName": "އެންޓަރޕްރައިޒްއޭއައި އީއާރްޕީ",
    "mark": "އީއޭ",
    "skipToContent": "ފުންމާލާ އަށް މައުލޫމާތު"
  },
  "common": {
    "actions": {
      "add": "އިތުރުކުރޭ",
      "apply": "ބޭނުންކުރޭ",
      "approve": "ފާސްކުރޭ",
      "back": "ފަހަތަށް",
      "backToSignIn": "ސައިން އިން އަށް އެނބުރި ދާން",
      "cancel": "ކެންސަލްކުރޭ",
      "clear": "ސާފުކުރޭ",
      "clearFilters": "ފިލްޓަރތައް ސާފުކުރޭ",
      "close": "ބަންދުކުރޭ",
      "copy": "ކޮޕީކުރޭ",
      "create": "އުފައްދާ",
      "delegate": "ހަވާލުކުރޭ",
      "delete": "ޑިލީޓްކުރޭ",
      "detail": "ތަފްޞީލު",
      "dismiss": "ފޮރުވާ",
      "done": "ނިމިއްޖެ",
      "download": "ޑައުންލޯޑްކުރޭ",
      "edit": "އެޑިޓްކުރޭ",
      "exportCsv": "ސީއެސްވީ އެކްސްޕޯޓްކުރޭ",
      "next": "ދެން",
      "open": "ހުޅުވާ",
      "previous": "ކުރީގެ",
      "refresh": "ރިފްރެޝްކުރޭ",
      "reject": "ބޭރުކުރޭ",
      "remove": "ނަގާ",
      "reset": "ރީސެޓްކުރޭ",
      "retry": "އަލުން މަސައްކަތްކުރޭ",
      "revoke": "ބާޠިލުކުރޭ",
      "save": "ރައްކާކުރޭ",
      "saveChanges": "ބަދަލުތައް ރައްކާކުރޭ",
      "search": "ހޯދާ",
      "showPassword": "ޕާސްވޯޑް ދައްކާ",
      "signIn": "ސައިން އިން",
      "signOut": "ސައިން އައުޓް",
      "submit": "ހުށަހަޅާ"
    },
    "labels": {
      "actions": "އަމަލުތައް",
      "active": "ހަރަކާތްތެރި",
      "all": "ހުރިހާ",
      "confirmPassword": "ޕާސްވޯޑް ޔަގީންކުރޭ",
      "description": "ތަފްޞީލު",
      "email": "އީމެއިލް",
      "fullName": "ފުރިހަމަ ނަން",
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "jobTitle": "ވަޒީފާގެ ނަން",
      "language": "ބަސް",
      "lastSignIn": "އެންމެފަހުން ސައިން އިން ވި ވަގުތު",
      "loading": "ލޯޑްވަނީ",
      "name": "ނަން",
      "never": "ދުވަހަކުވެސް ނުވޭ",
      "newPassword": "އައު ޕާސްވޯޑް",
      "no": "ނޫން",
      "noneAssigned": "އެއްވެސް އެއްޗެއް ހަވާލުކޮށްފައެއް ނުވޭ",
      "note": "ނޯޓް",
      "password": "ޕާސްވޯޑް",
      "permissions": "ހުއްދަތައް",
      "phone": "ފޯނު",
      "refreshing": "ރިފްރެޝްވަނީ…",
      "role": "ރޯލް",
      "roles": "ރޯލްތައް",
      "search": "ހޯދާ",
      "selectedCount": "{count} ހޮވާފައި",
      "status": "ސްޓޭޓަސް",
      "timezone": "ޓައިމްޒޯން",
      "total": "ޖުމްލަ",
      "workspace": "ވޯކްސްޕޭސް",
      "yes": "އާދެ"
    },
    "languages": {
      "en": "އިނގިރޭސި",
      "dv": "ދިވެހި"
    },
    "validation": {
      "passwordMismatch": "ދެ ޕާސްވޯޑް އެއްގޮތެއް ނުވޭ.",
      "password": {
        "blank": "ޕާސްވޯޑެއް އެތެރެކުރޭ.",
        "tooShort": "މަދުވެގެން {min} އަކުރު ބޭނުންކުރޭ.",
        "tooLong": "އެންމެ ގިނަވެގެން {max} އަކުރު ބޭނުންކުރޭ.",
        "allSame": "އެއް އަކުރެއް ތަކުރާރުކުރުމަކީ ޕާސްވޯޑެއް ނޫނެވެ."
      }
    },
    "loadingLabels": {
      "exporting": "އެކްސްޕޯޓްކުރަނީ",
      "loading": "ލޯޑްވަނީ",
      "refreshing": "ރިފްރެޝްކުރަނީ",
      "saving": "ރައްކާކުރަނީ",
      "sending": "ފޮނުވަނީ",
      "updating": "އަޕްޑޭޓްކުރަނީ",
      "verifying": "ޔަގީންކުރަނީ"
    }
  },
  "ui": {
    "button": {
      "working": "މަސައްކަތްކުރަނީ"
    },
    "field": {
      "required": "(ލާޒިމު)",
      "optional": "އިޚްތިޔާރީ"
    },
    "money": {
      "negative": "މައިނަސް {amount}"
    },
    "select": {
      "placeholder": "އިޚްތިޔާރުކުރޭ…",
      "clear": "އެއްވެސް އެއްޗެއް ނެތް"
    },
    "pagination": {
      "label": "ޞަފުޙާތައް",
      "previousPage": "ކުރީގެ ޞަފުޙާ",
      "nextPage": "ދެން އޮތް ޞަފުޙާ",
      "empty": "ރެކޯޑެއް ނެތް",
      "showing": "ދައްކަނީ {range}",
      "showingOfTotal": "ޖުމުލަ {total} ގެ ތެރެއިން {range} ދައްކަނީ",
      "perPage": "ޞަފުޙާއަކަށް {size}"
    },
    "table": {
      "recordCountOne": "{count} ރެކޯޑް",
      "recordCountOther": "{count} ރެކޯޑް",
      "columns": "ކޮލަމްތައް",
      "chooseColumns": "ކޮލަމްތައް އިޚްތިޔާރުކުރޭ",
      "visibleColumns": "ފެންނަ ކޮލަމްތައް",
      "selectAllRows": "މި ޞަފުޙާގެ ހުރިހާ ރޯއެއް ހޮވާ",
      "selectRow": "ރޯ {index} ހޮވާ",
      "emptyTitle": "އަދި ދައްކާނެ އެއްޗެއް ނެތް",
      "filteredTitle": "މި ފިލްޓަރތަކާ ގުޅޭ ރެކޯޑެއް ނެތް",
      "filteredDescription": "ތާރީޚުގެ މުއްދަތު ފުޅާކުރޭ، ނުވަތަ ފިލްޓަރެއް ސާފުކުރޭ."
    },
    "panel": {
      "emptyTitle": "އަދި މިތާ އެއްވެސް އެއްޗެއް ނެތް"
    }
  },
  "errors": {
    "generic": "ކޮންމެވެސް ގޯހެއް ދިމާވެއްޖެ.",
    "loadTitle": "އެ ލޯޑެއް ނުވި",
    "reference": "ރެފަރެންސް {traceId}",
    "codes": {
      "ERR_PERIOD_CLOSED": "އެ އެކައުންޓިންގ މުއްދަތު ބަންދުކޮށްފައިވާތީ، އެއަށް އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެ. މުއްދަތު އަލުން ހުޅުވާ، ނުވަތަ ހުޅުވިފައިވާ މުއްދަތަކަށް ޕޯސްޓްކުރޭ.",
      "ERR_BUDGET_EXCEEDED": "މިއީ ބަޖެޓުގެ ޙައްދު ފަހަނައަޅާ ދާނެ ކަމެކެވެ. ބަޖެޓް އަލުން މުރާޖަޢާކުރަން އެދޭ، ނުވަތަ އަދަދު ކުޑަކުރޭ.",
      "ERR_DUPLICATE_INVOICE": "އެ އިންވޮއިސް ނަންބަރު މި ވިޔަފާރިވެރިޔާއަށް މިހާރުވެސް ރެކޯޑްކޮށްފައިވެއެވެ.",
      "ERR_STATEMENT_DUPLICATE": "މި ސްޓޭޓްމަންޓް މި ބޭންކް އެކައުންޓަށް މިހާރުވެސް އިމްޕޯޓްކޮށްފައިވާތީ، މި ކޮޕީ ބާތިލްކޮށްލެވިއްޖެއެވެ. ފުރަތަމަ އިމްޕޯޓް ތަފްޞީލުގައި ބަޔާންކޮށްފައިވެއެވެ.",
      "ERR_STATEMENT_LATE_UNACKNOWLEDGED": "މި ސްޓޭޓްމަންޓް މި އެކައުންޓަށް ކަނޑައެޅިފައިވާ ޙައްދަށްވުރެ ލަސްވެ ލިބިފައިވެއެވެ. ލަސްވި ސަބަބު ލިޔުއްވައި އަލުން އިމްޕޯޓްކުރައްވާ.",
      "ERR_STATEMENT_LINE_DUPLICATE": "މި ސްޓޭޓްމަންޓް ލައިނަކީ މި އެކައުންޓުގައި މިހާރުވެސް ރެކޯޑުގައިވާ ލައިނެއްގެ ތަކުރާރެކެވެ. އެހެންކަމުން މިއީ ރިފަރެންސަށް އެކަނި ބަހައްޓާފައިވާ ލައިނެއް ކަމަށްވާތީ، ރިކޮންސައިލް ނުވަތަ އެހެން އެއްވެސް ކަމެއް ނުކުރެވޭނެއެވެ.",
      "ERR_SCREENING_RESULT_CHANGED": "ތިޔަ ބޭފުޅާ ބެއްލެވިފަހުން ސްކްރީނިންގެ ނަތީޖާ ބަދަލުވެއްޖެއެވެ. އެހެންކަމުން އެއްވެސް އެއްޗެއް ނައްތާލެވިފައެއް ނުވެއެވެ. މިހާރު ހުރި ފެނުންތައް ބައްލަވާފައި އަލުން މަސައްކަތް ކުރައްވާ.",
      "ERR_CREDIT_LIMIT": "މިއީ ކަސްޓަމަރުގެ ކްރެޑިޓް ޙައްދު ފަހަނައަޅާ ދާ ކަމެކެވެ. ކްރެޑިޓް އޯވަރައިޑް ހުއްދަ ލިބިފައިވާ ފަރާތަކުން މިކަން ފާސްކުރަން ޖެހެއެވެ.",
      "ERR_SOD_VIOLATION": "މަސްއޫލިއްޔަތު ވަކިކުރުމުގެ އުޞޫލު މިކަން ހުއްޓުވައެވެ: އެއް ފަރާތަކަށް މިކަން ހުށަހަޅައި އަދި ފާސްވެސް ނުކުރެވޭނެއެވެ.",
      "ERR_ROW_VERSION": "ތިޔަ ފަރާތުން މި ރެކޯޑް ހުޅުވައިގެން ހުއްޓައި އެހެން ފަރާތަކުން މިއަށް ބަދަލު ގެނެސްފިއެވެ. އެއްވެސް އެއްޗެއް ފުހެވިފައެއް ނުވެއެވެ — އަލުން ލޯޑްކޮށް، ތިޔަ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "ERR_VALIDATION": "އެތެރެކުރި ބައެއް މަޢުލޫމާތު ޞައްޙައެއް ނޫނެވެ. އެ ފީލްޑްތައް ފާހަގަކޮށްފައިވެއެވެ.",
      "ERR_FORBIDDEN": "މިކަމަށް ބޭނުންވާ ހުއްދަ ތިޔަ ފަރާތުގެ ރޯލްތަކުގައި ނުހިމެނެއެވެ.",
      "ERR_UNAUTHENTICATED": "ސައިން އިން ވުން ކާމިޔާބުނުވި، ނުވަތަ ސެޝަން ނިމިއްޖެއެވެ. މަޢުލޫމާތު ބަލައި އަލުން ސައިން އިން ވޭ.",
      "ERR_NOT_FOUND": "އެ ރެކޯޑް މިހާރު ނެތެވެ، ނުވަތަ ތިޔަ ފަރާތަށް އެ ނުފެންނާނެއެވެ.",
      "ERR_RATE_LIMITED": "ކުޑަ ވަގުތުކޮޅެއްގެ ތެރޭގައި މާ ގިނަ ރިކުއެސްޓް ފޮނުވިއްޖެއެވެ. ހިނދުކޮޅަކު މަޑުކޮށްފައި އަލުން މަސައްކަތްކުރޭ.",
      "ERR_STEP_UP_REQUIRED": "މި ޢަމަލު ކުރިއަށް ގެންދިއުމުގެ ކުރިން އައު ޓޫ-ފެކްޓަރ ކޯޑެއް ބޭނުންވެއެވެ.",
      "ERR_PASSWORD_CHANGE_REQUIRED": "ތިޔަ ފަރާތުގެ ޕާސްވޯޑް ކަނޑައެޅީ އިދާރީ ފަރާތަކުންނެވެ. އިތުރު އެއްޗެއް ހުޅުވުމުގެ ކުރިން އަމިއްލަ ޕާސްވޯޑެއް އިޚްތިޔާރުކުރޭ.",
      "ERR_TENANT_SUSPENDED": "މި ވޯކްސްޕޭސް ސަސްޕެންޑްކޮށްފައިވާތީ، ބަދަލު ގެނައުން ހުއްޓުވާފައިވެއެވެ. މިހާރު ހުރި ރެކޯޑްތައް ކިޔޭނެއެވެ.",
      "ERR_MFA_REQUIRED": "މި އެކައުންޓް ޓޫ-ފެކްޓަރ އޮތެންޓިކޭޝަނުން ރައްކާތެރިކޮށްފައިވެއެވެ. އޮތެންޓިކޭޓަރ އެޕުން ކޯޑް އެތެރެކުރޭ.",
      "ERR_ILLEGAL_TRANSITION": "އެހެން ފަރާތަކުން ކުރިން މިކަން ކޮށްފިއެވެ، އެހެންކަމުން މިހާރު މިއީ އެކަން ކުރެވޭ ޙާލަތެއްގައި އޮތް އެއްޗެއް ނޫނެވެ.",
      "ERR_SESSION_ENDED": "ތިބާގެ ސެޝަން ނިމިއްޖެ. ކުރިއަށް ދިއުމަށް އަލުން ސައިން އިން ކުރައްވާ.",
      "ERR_JOURNAL_APPROVAL_REQUIRED": "މި ޖާނަލް ބާވަތް ޕޯސްޓްކުރުމުގެ ކުރިން ފާސްކުރުން ބޭނުންވެއެވެ. ފާސްކުރުމަށް ހުށަހަޅާ.",
      "ERR_JOURNAL_APPROVAL_UNRESOLVABLE": "މި ޖާނަލަށް ފާސްކުރާ ފަރާތެއް ކަނޑައަޅާފައެއް ނުވެއެވެ. އޮތޯރިޓީ މެޓްރިކްސްގައި ފާސްކުރާ ސިލްސިލާއެއް ސެޓްއަޕްކުރޭ.",
      "ERR_JOURNAL_APPROVAL_NOT_REQUIRED": "މި ޖާނަލް ބާވަތަށް ފާސްކުރުން ބޭނުމެއް ނުވެއެވެ. ސީދާ ޕޯސްޓްކުރޭ.",
      "ERR_OPENING_BALANCE_SIGNED_OFF": "މި ހުޅުވުމުގެ ބާކީ ކުރިން ސޮއިކޮށްފައިވެއެވެ. އޭގެ ރިކޮންސިލިއޭޝަން ފައިނަލްވެއްޖެއެވެ.",
      "ERR_MFG_TOOL_UNAVAILABLE": "ބޭނުންވާ ޓޫލެއް ލިބެން ނެތެވެ، އުމުރު ހަމަވެފައިވެއެވެ ނުވަތަ ސާވިސްކުރަން ޖެހިފައިވެއެވެ.",
      "ERR_RATE_OVERRIDE_TOLERANCE": "ޖަމާކުރި އެކްސްޗޭންޖް ރޭޓަކީ ސިސްޓަމް ރޭޓާ އަޅާބަލާއިރު ހުއްދަކުރެވޭ ހައްދުން ބޭރުގައިވާ ރޭޓެކެވެ. ސިސްޓަމް ރޭޓް ބޭނުންކުރައްވާ ނުވަތަ އޯވަރރައިޑެއް އެދެއްވާ.",
      "ERR_JOURNAL_ATTACHMENT_REQUIRED": "މި ޖާނަލް ބާވަތަށް ހުށަހެޅުމުގެ ނުވަތަ ޕޯސްޓްކުރުމުގެ ކުރިން ސަޕޯޓިން ޢިލްވަޅެއް ބޭނުންވެއެވެ.",
      "ERR_JOURNAL_AUTO_REVERSAL_PENDING": "މި ޖާނަލްގެ އޮޓޯ ރިވާސަލް އަދި ފުރިހަމަނުވާތީ، އަތުން ބަދަލުކުރެވޭކަށް ނުވަތަ ރިވާސްކުރެވޭކަށް ނެތެވެ.",
      "ERR_JOURNAL_OWNED_BY_SOURCE": "މި ޖާނަލް ޕޯސްޓްކުރީ އެހެން މޮޑިއުލެކެވެ. ޖާނަލުގެ ބަދަލުގައި އޭގެ ސޯސް ޑޮކިއުމަންޓް ރިވާސްކުރޭ.",
      "ERR_BANK_ACCOUNT_DUPLICATE": "މި ކުންފުނިއަށް އެއް ބޭންކާއި އެއް އެކައުންޓް ނަންބަރުގެ ބޭންކް އެކައުންޓެއް ކުރިންވެސް އެބަހުއްޓެވެ.",
      "ERR_BANK_ACCOUNT_NOT_ACTIVE": "މި ބޭންކް އެކައުންޓް އެކްޓިވް ނޫން ކަމުން މި ކަމަށް ބޭނުންކުރެވޭކަށް ނެތެވެ.",
      "ERR_BANK_ACCOUNT_STATE": "ބޭންކް އެކައުންޓް އޮތީ މި ފިޔަވަޅު އުފުލުމަށް ހުއްދަ ލިބޭ ހާލަތެއްގައެއް ނޫނެވެ.",
      "ERR_ACCOUNT_ACTIVATION_BLOCKED": "މި ބޭންކް އެކައުންޓް އަދި އެކްޓިވް ނުކުރެވޭނެއެވެ. ވެރިފައިވެފައިވާކަމާއި ފާސްކުރުންތައް ފުރިހަމަވެފައިވާކަން ޗެކްކުރައްވާ.",
      "ERR_ACCOUNT_CLOSE_BLOCKED": "ބާކީއެއް ނުވަތަ ނުނިމި އޮތް ކަންތައްތަކެއް އޮތްހާ ހިނދަކު މި ބޭންކް އެކައުންޓް ބަންދުކުރެވޭކަށް ނެތެވެ.",
      "ERR_BANK_ACCOUNT_AMENDMENT_REQUIRED": "މި ބޭންކް ތަފްސީލުތައް ބަދަލުކުރުމަށް ފުރަތަމަ ފާސްކުރަންޖެހޭ އެމެންޑްމަންޓް ރިކުއެސްޓެއް ބޭނުންވެއެވެ.",
      "ERR_BENEFICIARY_COOLING_OFF": "މި ބެނެފިޝަރީގެ ތަފްސީލުތައް ދިޔަ ދުވަސްކޮޅުގައި ބަދަލުކުރެވިފައިވާތީ ކޫލިންގ އޮފް މުއްދަތުގައި ވެއެވެ. އެ މުއްދަތު ނިމެންދެން އެމީހަކަށް ދައްކުމުގެ ކަންތައް ހުއްޓުވިފައިވެއެވެ.",
      "ERR_BENEFICIARY_UNVERIFIED": "މި ބެނެފިޝަރީގެ ތަފްސީލުތައް ވެރިފައި ނުކުރެވިފައިވާތީ، އެމީހަކަށް ދައްކުމުގެ ކަންތައް ހުއްޓުވިފައިވެއެވެ.",
      "ERR_WALLET_MAX_BALANCE": "މިކަމުން ވޮލެޓް އޭގެ އެންމެ ބޮޑު ބާކީއަށްވުރެ ވެރިވެގެންދާނެއެވެ.",
      "ERR_WALLET_FUNDING_DESTINATION": "އެ ވޮލެޓަށް މި ސޯސްއިން ފައިސާ ލިބެން ނުކުރެވޭނެއެވެ.",
      "ERR_MANDATE_NOT_PENDING": "ފާސްކުރަން އެއްވެސް ކަމެއް ނެތެވެ: މި މޭންޑޭޓް ވާރޝަން ޕެންޑިންގ ނޫނެވެ.",
      "ERR_RATE_OVERRIDE_NO_BOOK_RATE": "މި ކަރަންސީ ޕެއަރަށް އަދި މި ތާރީޚަށް ސިސްޓަމް ރޭޓެއް ރެކޯޑުކުރެވިފައެއް ނުވާތީ، އޯވަރރައިޑް އެއާ އަޅާބަލައިނުވޭނެއެވެ. ފުރަތަމަ ރޭޓް ރެކޯޑުކުރައްވާ.",
      "ERR_WALLET_TXN_FUNDED_BY_TRANSFER": "މި ވޮލެޓް މޫވްމަންޓް ހެދިފައިވަނީ ފަންޑިންގ ޓްރާންސްފަރަކުންނެވެ. އޭގެ ބަދަލުގައި ޓްރާންސްފަރު ބަދަލުކުރައްވާ ނުވަތަ ރިވާސްކުރައްވާ.",
      "ERR_WALLET_FUNDS_IN_TRANSIT": "މި ވޮލެޓަށް ފައިސާ އަދި ޓްރާންސިޓްގައި ހުއްޓެވެ. ބަންދުކުރުމުގެ ކުރިން ޓްރާންސްފަރު ސެޓްލްވާންދެން މަޑުކުރައްވާ.",
      "ERR_MANDATE_SUPERSEDE_REQUIRED": "މިއަށް ހިމެނޭ އެކްޓިވް މޭންޑޭޓެއް ހުއްޓެވެ. އެ މޭންޑޭޓް އެޑިޓްކުރުމުގެ ބަދަލުގައި އެއަށް ބަދަލުވާ އައު ވާރޝަނެއް ހުށަހަޅުއްވާ.",
      "ERR_YEAR_HAS_OPEN_PERIODS": "މި މާލީ އަހަރުގެ ބައެއް ޕީރިއަޑްތައް އަދިވެސް ހުޅުވިފައިވޭ. އަހަރު ބަންދުކުރުމުގެ ކުރިން ހުރިހާ ޕީރިއަޑެއް ބަންދުކުރައްވާ.",
      "ERR_YEAR_ALREADY_CLOSED": "މި މާލީ އަހަރު ވަނީ ކުރިން ބަންދުކުރެވިފައި.",
      "ERR_YEAR_END_CLOSE_APPROVAL_UNRESOLVABLE": "އަހަރު ބަންދުކުރުމަށް އެޕްރޫވަލް ދޭނެ މީހަކު ނުފެނުނު. އެޕްރޫވަލް ސިޔާސަތު ތައްޔާރުކުރައްވާ.",
      "ERR_NEXT_YEAR_PERIOD_CLOSED": "ދެން އަންނަ އަހަރުގެ ޕީރިއަޑެއް ބަންދުކުރެވިފައިވާތީ މި ބަންދުކުރުން ރިވަރސް ނުކުރެވޭނެ.",
      "ERR_YEAR_CLOSED_REVERSE_FIRST": "މި އަހަރު ބަންދުކުރެވިފައިވޭ. ޕީރިއަޑެއް ހުޅުވުމުގެ ކުރިން އަހަރު ބަންދުކުރުން ރިވަރސް ކުރައްވާ.",
      "ERR_PAN_NOT_MASKED": "ކާޑު ނަންބަރު މާސްކުކޮށް ލިޔުއްވާ. ފަހު 4 ޑިޖިޓް އެކަނި ފެންނާނެ؛ އެހެން ހުރިހާ ތަނެއް * ނުވަތަ X ކަމުގައި ވާންޖެހޭނެ. ފުރިހަމަ ކާޑު ނަންބަރު ރައްކާކުރެވެނީ ނޫނެވެ.",
      "ERR_CARD_HAS_OPEN_LINES": "މި ކާޑުގައި އަދިވެސް މެޗްނުކުރެވި ހުރި ސްޓޭޓްމަންޓް ލައިންތަކެއް ހުއްޓެވެ. ކާޑު ނުހިނގާ ކުރުމުގެ ކުރިން އެ ލައިންތައް މެޗްކުރައްވާ، ނުވަތަ ޑިސްޕޯޒްކުރައްވާ.",
      "ERR_CARD_INACTIVE": "މި ކާޑު ނުހިނގާ ޙާލަތުގައި ވާތީ، އެއަށް ސްޓޭޓްމަންޓެއް އިމްޕޯޓްކުރެވޭނެ ނޫނެވެ. ކާޑު ފުރަތަމަ އަލުން ހިނގާ ޙާލަތަށް ގެނެސްދެއްވާ.",
      "ERR_REBATE_NO_PAYEE": "މި ކަސްޓަމަރަށް ފައިސާ ދެއްކޭނެ ވެންޑަރ ރޯލެއް ނެތް. ކްރެޑިޓް ނޯޓަކުން ސެޓަލް ކުރައްވާ ނުވަތަ ވެންޑަރ ރޯލް ގުޅުއްވާ.",
      "ERR_REBATE_PAYEE_UNUSABLE": "ފައިސާ ލިބޭ ވެންޑަރ ބްލޮކްކޮށްފައިވޭ ނުވަތަ މި ފައިސާ ބަލައިނުގަނެއެވެ.",
      "ERR_REBATE_PAYABLES_UNAVAILABLE": "ފައިސާ ދެއްކުމުގެ ޚިދުމަތް މިހާރު ލިބެން ނެތް.",
      "ERR_CREDIT_HOLD": "މި ކަސްޓަމަރު ކްރެޑިޓް ހޯލްޑްގައި ވާތީ، ހޯލްޑް ރިލީސްކުރެވެންދެން އައު އިންވޮއިސް، އޯޑަރު އަދި ޑެލިވަރީ ހުއްޓުވިފައިވޭ.",
      "ERR_AR_CREDIT_OVERRIDE_APPROVAL_UNRESOLVABLE": "ކްރެޑިޓް އޯވަރައިޑަށް އެޕްރޫވަލް ދޭނެ މީހަކު ނުފެނުނު. ފުރަތަމަ އެޕްރޫވަލް ސިޔާސަތު ތައްޔާރުކުރައްވާ.",
      "ERR_USE_CREDIT_HOLD_ACTION": "ސްޓޭޓަސް ބަދަލުކޮށްގެން ކްރެޑިޓް ހޯލްޑް ޖެހޭކަށް ނުވަތަ ނަގާކަށް ނުކެރޭނެ. ސަބަބު ލިޔެވޭ ހޯލްޑް ޖެހުމާއި ރިލީސްކުރުމުގެ އެކްޝަންތައް ބޭނުންކުރައްވާ.",
      "ERR_USE_CREDIT_LIMIT_REQUEST": "ކަސްޓަމަރު އެޑިޓްކޮށްގެން ކްރެޑިޓް ޙައްދު ބަދަލެއް ނުކުރެވޭނެ. އައު ޙައްދަށް އެދުއްވާ؛ ފާސްކުރެވުމުން އެ ބަދަލު ހިނގާނެ.",
      "ERR_AR_CREDIT_LIMIT_APPROVAL_UNRESOLVABLE": "ކްރެޑިޓް ޙައްދު ބަދަލުކުރުމަށް އެޕްރޫވަލް ދޭނެ މީހަކު ނުފެނުނު. ފުރަތަމަ އެޕްރޫވަލް ސިޔާސަތު ތައްޔާރުކުރައްވާ.",
      "ERR_BUDGET_CYCLE_CLOSED": "މި ބަޖެޓް ސައިކަލް ބަންދުކުރެވިފައިވާތީ، އޭގެ ވަރޝަންތަކާއި ލައިންތައް ބަދަލުކުރެވޭކަށް ނެތެވެ. އިތުރު ރޭވުމަށް އައު ބަޖެޓް މޮޑެލެއް ފަށާ.",
      "ERR_BUDGET_CYCLE_NOT_OPEN": "މި ބަޖެޓް ސައިކަލް އަދި ހުޅުވިފައެއް ނުވާތީ، ކޮސްޓް ސެންޓަރ އޯނަރުންނަށް އަދަދު ލިޔެވޭކަށް ނެތެވެ. ސައިކަލް މެނޭޖަރަކު ފުރަތަމަ ހުޅުވަން ޖެހެއެވެ.",
      "ERR_BUDGET_CYCLE_SUBMITTED": "މި ކޮސްޓް ސެންޓަރ ހުށަހަޅާފައިވާތީ ތަޅުލެވިފައިވެއެވެ. ބަދަލުކުރުމުގެ ކުރިން ސައިކަލް މެނޭޖަރަކު އަލުން ހުޅުވަން ޖެހެއެވެ.",
      "ERR_BUDGET_NOTHING_TO_SUBMIT": "މި ކޮސްޓް ސެންޓަރަށް މިހާރު ގެންގުޅޭ ވަރޝަންގައި ބަޖެޓް ލައިންއެއް އަދި ނެތެވެ. ހުށަހެޅުމުގެ ކުރިން އަދަދުތައް ލިޔުއްވާ.",
      "ERR_APPROVAL_UNRESOLVABLE": "މި ކަމަށް ތިބާ ނޫން އެހެން މީހަކު ފާސްކުރަން ޖެހޭ، އަދި އެފަދަ އެޕްރޫވަލް ދޭނެ މީހަކު ނުފެނުނު. ފުރަތަމަ އެޕްރޫވަލް ސިޔާސަތެއް ތައްޔާރުކުރުމަށް އެޑްމިނިސްޓްރޭޓަރަކަށް އެދުއްވާ.",
      "ERR_CONTROL_NO_EMERGENCY": "މި އެދުމަކީ ކޮންޓްރޯލެއް ކަމުން، އެމަޖެންސީއެއްގެ ގޮތުގައި ފާސްނުކުރެވޭނެ. އެދުނު މީހާ ނޫން އެހެން މީހަކު އެޕްރޫވަލް ޗެއިން މެދުވެރިކޮށް ފާސްކުރަން ޖެހޭ.",
      "ERR_DUNNING_LEVEL_IN_USE": "މި ޑަނިންގ ލެވަލުން ނޯޓިސްތައް ފޮނުވާފައިވާތީ ނުވަތަ އިންވޮއިސްތައް އޮތީތީ، ޑިލީޓްކުރެވިގެން ނުވަތަ ނަންބަރު ބަދަލުކުރެވިގެން ނުވާނެއެވެ.",
      "ERR_DUNNING_LEVEL_ORDER": "ޑަނިންގ ލެވަލްތައް އިތުރުވަމުން ދާންޖެހެއެވެ: މަތީ ލެވަލަކަށް ތިރީ ލެވަލްތަކަށްވުރެ ގިނަ ދުވަސް ފާއިތުވެފައިވާން ޖެހެއެވެ.",
      "ERR_DUNNING_LEVEL_FINAL": "ފައިނަލް ކުރެވޭނީ އެންމެ މަތީ ލެވަލް އެކަންޏެވެ، އަދި އެއް ލެވަލް ފިޔަވައި ނުވާނެއެވެ.",
      "ERR_DUNNING_AS_OF_FUTURE": "ޑަނިންގ ރަންއެއް މިއަދަށްފަހު ތާރީޚެއްގައި ނުކުރެވޭނެއެވެ. އެ ތާރީޚަށް ޕްރިވިއު ބަލާށެވެ.",
      "ERR_CLOSE_RECON_ALREADY_CERTIFIED": "މި ރިކޮންސިލިއޭޝަން މި ކްލޯޒް ރަންގައި މިހާރުވެސް ސެޓިފައިކުރެވިފައިވެއެވެ.",
      "ERR_RECON_EXCEPTION_CLOSED": "މި އެކްސެޕްޝަން މިހާރުވެސް ހައްލުކުރެވިފައި ނުވަތަ ރައިޓްއޮފްކުރެވިފައިވެއެވެ. އަނެއްކާވެސް މެޗްނުވެއްޖެނަމަ ހުޅުވޭނެއެވެ.",
      "ERR_RECON_EXCEPTION_OUTSTANDING": "މި އައިޓަމް އަދިވެސް މެޗްނުވެ، ބަޔާންކުރެވޭނެ ކަމެއްވެސް ނެތެވެ. ހައްލުކުރުމުގެ ކުރިން މެޗްކުރާ، ނުވަތަ އޭގެ ސޯސް ޑޮކިއުމަންޓް ރިވާސްކުރާ.",
      "ERR_RECON_EXCEPTION_MATCH_INVALID": "އެ މެޗަކުން މި އެކްސެޕްޝަން ހައްލުނުކުރެވޭނެއެވެ. އެއީ ދިރޭ މެޗެއް، އެއް ބޭންކް އެކައުންޓެއްގައި، އަދި އައިޓަމް ނިޔަލާ ފުރިހަމަވާ އެއްގޮތަށް ހުންނަންޖެހެއެވެ.",
      "ERR_RECON_EXCEPTION_WRITE_OFF_REFUSED": "ރައިޓްއޮފް ކުރެވޭނީ މިސިންގ އެންޓްރީ ޕޯސްޓިންގއަކުން ކްލިއަރުކުރެވިފައިވާ ސްޓޭޓްމަންޓް ލައިނެވެ. ލެޖަރ އައިޓަމް އޭގެ ސޯސްގައި ރިވާސްކުރާ.",
      "ERR_IC_PRICING_EVIDENCE_REQUIRED": "މި އިންޓަރކޮމްޕެނީ އިންސްޓްރޫމަންޓް ހުށަހެޅުމުގެ ކުރިން ޕްރައިސިންގ ގޮތާއި އޭގެ ހެކި ރެކޯޑްކުރާ.",
      "ERR_SCREENING_REPORT_NOT_REQUIRED": "މި ޓްރާންސްފަރ ރިޕޯޓިންގ ވާޖިބެއްގައި ހިފެހެއްޓިފައެއް ނުވޭ، ނުވަތަ ރިޕޯޓް މިހާރުވެސް ރެކޯޑްކުރެވިފައިވެއެވެ.",
      "ERR_SCREENING_REPORT_PENDING": "މި ޓްރާންސްފަރއަށް ރެގިއުލޭޓަރީ ރިޕޯޓެއް އަދިވެސް ބާކީއެވެ. ހޯލްޑް ކްލިއަރުކުރުމުގެ ކުރިން އޭގެ ރިފަރެންސް ރެކޯޑްކުރާ.",
      "ERR_FACILITY_CLOSE_BLOCKED": "މި ފެސިލިޓީގައި ޕްރިންސިޕަލް، އެކްރޫޑް އިންޓްރަސްޓް، ޓްރާންސިޓްގައިވާ ޑްރޯޑައުން، ނުނިމޭ ބަދަލެއް ނުވަތަ ކޮވެނަންޓް ވާޖިބެއް އޮތުމުން ބަންދުކުރެވޭކަށް ނެތެވެ.",
      "ERR_FACILITY_ROLLOVER_BLOCKED": "މި ފެސިލިޓީ އަދި ރޯލްއޯވަރ ކުރެވޭކަށް ނެތެވެ. ހުރަސްކުރަނީ ކޮންކަމެއްކަން ތަފްސީލުގައި އެވަނީއެވެ.",
      "ERR_FACILITY_AUTHORISATION_REQUIRED": "މި ބަދަލަށް ދެވަނަ މީހެއްގެ ހުއްދަ ބޭނުންވެއެވެ. އެތަނަށް ވަކި އެދުމެއް ކުރާށެވެ، އެހެން މީހަކު އެކަން ފާސްކުރާނެއެވެ.",
      "ERR_FACILITY_IC_INSTRUMENT_REQUIRED": "އިންޓަރކޮމްޕެނީ ލޯނަކަށް ފާސްކުރުމާއި ޑްރޯކުރުމުގެ ކުރިން ފާސްކުރެވިފައިވާ ޕްރައިސްކޮށްފައިވާ އިންޓަރކޮމްޕެނީ އިންސްޓްރޫމަންޓެއް ބޭނުންވެއެވެ.",
      "ERR_DEBT_EVIDENCE_MISMATCH": "އެ ސްޓޭޓްމަންޓް ލައިނުން މި މޫވްމަންޓަށް ހެކިނުދެއެވެ. އޭގެ ބޭންކް އެކައުންޓް، ދިމާ، އަދަދު، ކަރަންސީ، އަދި ކުރިން ބޭނުންކުރެވިފައި ނުވާކަން ޗެކްކުރާ.",
      "ERR_COVENANT_ALREADY_TESTED": "އެ ތާރީޚަށް މި ކޮވެނަންޓަށް ނަތީޖާއެއް މިހާރުވެސް އެބައޮތެވެ. ރެކޯޑްކުރެވިފައިވާ ބްރީޗެއް ކްލިއަރުކުރެވޭނީ ސަބަބާއެކު ވޭވަރަކުންނެވެ.",
      "ERR_DEBT_APPROVAL_PENDING": "މިއީ އޮތޯރިޓީ ބޭންޑްގެ މަތީގައިވާތީ ދެވަނަ މީހެއްގެ ފާސްކުރުމަށް އިންތިޒާރުކުރަމުން ގެންދެއެވެ. ދެން ކުރިއަށް ނުދެވޭނެއެވެ.",
      "ERR_SCHEDULE_SUM_MISMATCH": "ޝެޑިއުލްގެ ޕްރިންސިޕަލް މެޗިއުރިޓީގައި ޑްރޯކުރި ޕްރިންސިޕަލާ ހަމަނުވެއެވެ. ތަފާތު ތަފްސީލުގައި ބަޔާންކުރެވިފައިވެއެވެ.",
      "ERR_DEBT_TERMS_CHANGED": "ހުށަހެޅުމަށްފަހު ޝަރުތުތަކަށް ބަދަލު އައިސްފި. މިހާރުގެ ޝަރުތުތައް ބަލާ އަލުން ހުށަހަޅާ.",
      "ERR_CASH_ACCOUNT_PLEDGED": "މި ބޭންކް އެކައުންޓް ޑެޓް ފެސިލިޓީއަކަށް ގަރޑުކޮށްފައިވެއެވެ. ފުރަތަމަ ގަރޑު ދޫކުރާ.",
      "ERR_CASH_ACCOUNT_NOT_PLEDGED": "މި ބޭންކް އެކައުންޓް ގަރޑުކޮށްފައެއް ނުވެއެވެ.",
      "ERR_POSITION_STALE_RATE": "ޓްރާންސްލޭޝަން ރޭޓެއް ޓޮލަރެންސްއަށްވުރެ ގިނަދުވަހެއް ވެފައިވާތީ މި ޕޮޒިޝަން ޕަބްލިޝްކުރެވޭނެ ނޫން. މިހާރުގެ ރޭޓެއް ފައިލްކުރޭ، ނުވަތަ ޓްރެޒަރީ ސެޓިންގްސްގައި ޓޮލަރެންސް އިތުރުކުރޭ.",
      "ERR_AP_STATEMENT_DUPLICATE": "މި ސަޕްލަޔަރ ސްޓޭޓްމަންޓް މިހާރުވެސް ރެކޯޑްކުރެވިފައިވެއެވެ. އެއް ތާރީޚަށް ދެވަނަ ސްޓޭޓްމަންޓެއް ރެކޯޑްކުރަން ބޭނުންނަމަ ސަޕްލަޔަރުގެ ސްޓޭޓްމަންޓް ނަންބަރު ދޭށެވެ.",
      "ERR_PAYMENT_RUN_APPROVAL_UNRESOLVABLE": "މި ޕޭމަންޓް ރަން ތައްޔާރުކުރި މީހާ ނޫން އެހެން އެޕްރޫވަރަކު ކޮންފިގާކުރެވިފައެއް ނުވާތީ އެ ސަބްމިޓްކުރެވޭނެ ނޫން. ޕޭމަންޓް ރަންތަކަށް އެޕްރޫވަލް ސިޔާސަތެއް ތައްޔާރުކުރުމަށް އެޑްމިނިސްޓްރޭޓަރަކަށް އެދުއްވާ.",
      "ERR_ASSET_IC_RULE_MISSING": "މި ލީގަލް އެންޓިޓީތަކާ ދޭތެރޭ ޓްރާންސްފަރ ތާރީޚުގައި އިންޓަރކޮމްޕެނީ ރޫލެއް ހިނގަމުން ނުދާތީ ޕޯސްޓްކުރާނެ ޑިއު-ޓު ނުވަތަ ޑިއު-ފްރޮމް އެކައުންޓެއް ނެތެވެ. ފުރަތަމަ ލީގަލް އެންޓިޓީތަކުގެ އިންޓަރކޮމްޕެނީ ރޫލްތައް ކޮންފިގާކުރައްވާ.",
      "ERR_ASSET_IC_TRANSFER_BLOCKED": "މި އެސެޓް މިހާރު ހުރިގޮތަށް އެހެން ލީގަލް އެންޓިޓީއަކަށް ޓްރާންސްފަރ ކުރެވޭނެ ނޫން: އެއީ ޑިސްޕޯޒަލް ބާކީ ހުރި، ނުވަތަ އިމްޕެއަރމަންޓް ފާސްކުރުމަށް ބާކީ ހުރި، ނުވަތަ ކޮމްޕޯނަންޓް ބެހިފައިވާ ބައްޕަ އެސެޓެކެވެ. ފުރަތަމަ އެ ކަންތައް ސާފުކުރައްވާ.",
      "ERR_ASSET_IMPAIRMENT_APPROVAL_UNRESOLVABLE": "މި އިމްޕެއަރމަންޓަށް އެޕްރޫވަލް ބޭނުންވެއެވެ. ތިބާ ނޫން އެހެން އެޕްރޫވަރަކު ކޮންފިގާކުރެވިފައެއް ނުވެއެވެ. އެސެޓް އިމްޕެއަރމަންޓްތަކަށް އެޕްރޫވަލް ސިޔާސަތެއް ތައްޔާރުކުރުމަށް އެޑްމިނިސްޓްރޭޓަރަކަށް އެދުއްވާ.",
      "ERR_ASSET_CAPITALIZE_EXCEEDS_BALANCE": "ކެޕިޓަލައިޒްކުރަން އުޅޭ ކޮސްޓަކީ ސާރވިސްއަށް ވެއްދި ތާރީޚުގެ ސޯސްގެ ބެލެންސްއަށްވުރެ ބޮޑު އަދަދެކެވެ. ކޮސްޓް ކުޑަކުރައްވާ، ނުވަތަ ބެލެންސް ފުދޭ ސޯސެއް ޗޫސްކުރައްވާ.",
      "ERR_FORCE_MATCH_RESIDUAL_EXCEEDS_TOLERANCE": "ސްޓޭޓްމަންޓް ލައިނާއި ލެޖަރ ލައިންތަކާ ދެމެދުގެ ތަފާތު މި ބޭންކް އެކައުންޓަށް ފޯސްޑް މެޗަކުން ހިފޭ ހައްދަށްވުރެ ބޮޑެވެ. އެއްގޮތްވާ ލައިންތައް މެޗްކުރައްވާ، ނުވަތަ ޓޮލަރެންސް އަލުން ބަލައި ބަދަލުކުރުމަށް އެދުއްވާ.",
      "ERR_RECON_HELD_LINES": "މި ރިކޮންސިލިއޭޝަނުގެ ސްޓޭޓްމަންޓް ލައިނެއް ކުރިމަތީގައި ހިފެހެއްޓިފައި ނުވަތަ އިންޓްރާޑޭ-އެކަނި ކަމުގައި ވެއެވެ. ސްޓޭޓްމަންޓް ދޫކުރާ ނުވަތަ ބާތިލްކުރާ، ހިފެހެއްޓިފައިވާ ލައިންތައް ނިންމާ، ނުވަތަ ދުވަހުގެ ނިމުމުގެ ސްޓޭޓްމަންޓް އިމްޕޯޓްކޮށް، ދެން ރިކޮންސިލިއޭޝަން ނިންމާލާ.",
      "ERR_CONSOL_UNMAPPED_BALANCE": "މި ގްރޫޕްގައި ގްރޫޕް އެކައުންޓެއް ބަނދެވިފައި ނުވާ އެކައުންޓް ބެލެންސްތަކެއް އެބަހުއްޓެވެ. އެކައުންޓް މެޕުގައި އެތަކެތި މެޕްކޮށް ކޮންސޮލިޑޭޝަން އަލުން ހިންގާށެވެ.",
      "ERR_DEBT_LIMIT_EXCEEDED": "އެއީ ފެސިލިޓީގެ ލިމިޓް ފަހަނައަޅާ ގޮތެވެ.",
      "ERR_COVENANT_BREACHED": "މި ފެސިލިޓީގައި ވޭވް ނުކުރެވޭ ކޮވެނަންޓު ޚިލާފުވުމެއް އެބައޮތް.",
      "ERR_COVENANT_WAIVER_REF": "ވޭވަރެއްގައި ލޯނުދޭ ފަރާތުގެ ވޭވަރ ލިޔުން ބަޔާންކުރަން ޖެހޭ.",
      "ERR_BUDGET_CONTROL_LEVEL_APPROVAL_UNRESOLVABLE": "ބަޖެޓް ކޮންޓްރޯލް ލެވެލް ބަދަލުކުރުމަށް ހުއްދަދޭނެ މީހަކު ކަނޑައެޅިފައެއް ނެތީމަ، ލުއި ލެވެލެއް އެދެވޭނެ ގޮތެއް ނެތެވެ.",
      "ERR_WRITEOFF_EVIDENCE_REQUIRED": "ރައިޓް އޮފް ހުށަހެޅުމުގެ ކުރިން، އެ ރައިޓް އޮފާ ގުޅިފައިވާ ލިޔުމެއް އަދި ވަސޫލުކުރުމަށް ކުރި މަސައްކަތުގެ ރެކޯޑެއް ބޭނުންވެއެވެ.",
      "ERR_AR_WRITEOFF_APPROVAL_UNRESOLVABLE": "ރައިޓް އޮފްތަކަށް ހުއްދަދޭނެ މީހަކު ކަނޑައެޅިފައެއް ނެތީމަ، މިއީ ހުށަހެޅޭނެ ގޮތެއް ނެތެވެ.",
      "ERR_WHT_ALREADY_REMITTED": "މި ވިތްހޯލްޑިންގ ކުރިން އެހެން ރެމިޓެންސަކުން ފޮނުވާފައިވެއެވެ.",
      "ERR_SWEEP_SETOFF_EVIDENCE_REQUIRED": "ލީގަލް އެންޓިޓީތަކާ ދެމެދު ނޯޝަނަލް ޕޫލް ހެދުމަށް ސެޓް-އޮފްގެ ޙައްޤުގެ ހެކިވެސް ބޭނުންވެއެވެ. ފުރަތަމަ އެ ހެކި ސްޓްރަކްޗަރާ ގުޅުއްވާ.",
      "ERR_SWEEP_NOT_CONFIGURED": "މި ސްވީޕް ސްޓްރަކްޗަރ ފުރިހަމައަށް ތައްޔާރުކޮށްފައެއް ނުވެއެވެ. ކޮންމެ ބައިވެރިއެއްގެ ޓާގެޓް ނުވަތަ ތްރެޝޯލްޑް ކަނޑައަޅާ، އަދި ލީގަލް އެންޓިޓީތަކާ ދެމެދުގެ ކޮންމެ މޫވްމަންޓަކަށް އިންޓަރކޮމްޕެނީ އިންސްޓްރޫމަންޓެއް ކަނޑައަޅާ.",
      "ERR_SWEEP_MANDATE_MISSING": "މި ސްވީޕްގެ މޫވްމަންޓެއް ބޭންކް މެންޑޭޓަކުން ނުހިމެނޭތީ ޓްރާންސްފަރ ހުށަހެޅޭނެ ނޫން. ފުރަތަމަ މެންޑޭޓް ތައްޔާރުކުރައްވާ.",
      "ERR_SWEEP_CUTOFF_PASSED": "މި ތާރީޚަށް ބޭންކުގެ ކަޓް-އޮފް ވަޤުތު ފާއިތުވެފައިވެއެވެ. ސްވީޕް ފަސްކުރެވުނު ގޮތަށް ރެކޯޑްކުރެވިފައިވާއިރު އެ ހިންގިފައެއް ނުވެއެވެ.",
      "ERR_SWEEP_SIMULATION_STALE": "މި ސިމިއުލޭޝަން ހިންގުނުފަހުން ބެލެންސް ނުވަތަ ޝަރުތުތަކަށް ބަދަލު އައިސްފިއެވެ. ހިންގުމުގެ ކުރިން އަލުން ސިމިއުލޭޓްކުރައްވާ.",
      "ERR_SWEEP_SIMULATION_EXPIRED": "މި ސިމިއުލޭޝަނުގެ މުއްދަތު ހަމަވެއްޖެއެވެ. ހިންގުމުގެ ކުރިން އަލުން ސިމިއުލޭޓްކުރައްވާ.",
      "ERR_BUDGET_TRANSFER_EXCEEDS_AVAILABLE": "ކޮމިޓްމަންޓާއި އެކްޗުއަލްތަކުގެ ފަހުން ސޯސްގައި އެކަޑަށް ބަޖެޓް ބާކީ ނެތުމުން ޓްރާންސްފަރ ކުރެވޭނެ ނޫން. އަދަދު ކުޑަކުރައްވާ.",
      "ERR_BUDGET_TRANSFER_APPROVAL_UNRESOLVABLE": "ބަޖެޓް ޓްރާންސްފަރތަކަށް ތިބާ ނޫން އެހެން އެޕްރޫވަރަކު ކޮންފިގާކުރެވިފައެއް ނުވާތީ މިއީ ހުށަހެޅޭނެ ނޫން. ބަޖެޓް ޓްރާންސްފަރތަކަށް އެޕްރޫވަލް ސިޔާސަތެއް ތައްޔާރުކުރުމަށް އެޑްމިނިސްޓްރޭޓަރަކަށް އެދުއްވާ.",
      "ERR_BUDGET_SUPPLEMENTARY_APPROVAL_UNRESOLVABLE": "އިތުރު ބަޖެޓް އެދުންތަކަށް ތިބާ ނޫން އެހެން އެޕްރޫވަރަކު ކޮންފިގާކުރެވިފައެއް ނުވާތީ މިއީ ހުށަހެޅޭނެ ނޫން. އެޕްރޫވަލް ސިޔާސަތެއް ތައްޔާރުކުރުމަށް އެޑްމިނިސްޓްރޭޓަރަކަށް އެދުއްވާ.",
      "ERR_BUDGET_VERSION_NOT_IN_FORCE": "މި އެދުނު ބަޖެޓް ވާރޝަން މިހާރު ހިނގަމުންދާ ވާރޝަން ނޫނެވެ. މިހާރުގެ ވާރޝަން ބަލާ އަލުން އެދުއްވާ.",
      "ERR_CONSOL_RUN_ALREADY_PUBLISHED": "މި މުއްދަތަށް ކޮންސޮލިޑޭޝަނެއް ކުރިން ޕަބްލިޝްކުރެވިފައިވޭ. ބަދަލުކުރުމަށް އެ ރަން އަލުން ބަޔާންކުރައްވާ.",
      "ERR_CONSOL_RUN_IMMUTABLE": "ޕަބްލިޝްކުރެވިފައިވާ ކޮންސޮލިޑޭޝަނެއް ބަދަލުކުރެވޭނެ ނޫން. އިސްލާހުކުރުމަށް އެ އަލުން ބަޔާންކުރައްވާ (ރީސްޓޭޓް).",
      "ERR_CONSOL_GROUP_CHART_REQUIRED": "ގްރޫޕް ޗާޓް އޮފް އެކައުންޓްސް ބޭނުންވެއެވެ. ގްރޫޕުގައި އެއް ހޮވާ، ދެން ކޮންސޮލިޑޭޝަން އަލުން ހިންގާ.",
      "ERR_CONSOL_INTERCO_MISMATCH": "އިންޓަރކޮމްޕެނީ ބެލެންސްތައް ގްރޫޕުގެ ޓޮލަރެންސްއަށްވުރެ ގިނައިން ތަފާތުވެއެވެ. ތަފްސީލުގައި ކޮންމެ ޕެއަރެއް ބަޔާންކުރެވިފައިވެއެވެ. ޕަބްލިޝްކުރުމުގެ ކުރިން އެ ހައްލުކުރައްވާ.",
      "ERR_CONSOL_ELIMINATIONS_UNDECIDED": "ހުށަހެޅިފައިވާ އެލިމިނޭޝަން ބައެއް އަދި ނިންމާފައެއް ނުވެއެވެ. ޕަބްލިޝްކުރުމުގެ ކުރިން ކޮންމެއް ޤަބޫލުކުރުން ނުވަތަ ދެކޮޅުހެދުން ކުރައްވާ.",
      "ERR_CONSOL_ADJUSTMENTS_PENDING": "ގްރޫޕް އެޑްޖަސްޓްމަންޓް ބައެއް އަދި ފާސްކުރެވިފައެއް ނުވެއެވެ. ޕަބްލިޝްކުރުމުގެ ކުރިން ކޮންމެއް ފާސްކުރުން ނުވަތަ ފަހަތަށް ނެގުން ކުރައްވާ.",
      "ERR_CONSOL_ADJUSTMENT_APPROVAL_UNRESOLVABLE": "ގްރޫޕް އެޑްޖަސްޓްމަންޓްތަކަށް ތިބާ ނޫން އެހެން އެޕްރޫވަރަކު ކޮންފިގާކުރެވިފައެއް ނުވާތީ މިއީ ހުށަހެޅޭނެ ނޫން. އެޕްރޫވަލް ސިޔާސަތެއް ތައްޔާރުކުރުމަށް އެޑްމިނިސްޓްރޭޓަރަކަށް އެދުއްވާ.",
      "ERR_CONSOL_NOT_READY": "ގްރޫޕްގެ މެމްބަރަކު މި މުއްދަތަށް ކޮންސޮލިޑޭޓްކުރުމަށް ތައްޔާރެއް ނޫނެވެ: އޭގެ މުއްދަތު އަދި ހުޅުވިފައި، ނުވަތަ ކްލޯޒް ސެޓިފައިކުރެވިފައެއް ނުވޭ، ނުވަތަ އިންޓަރކޮމްޕެނީ ތަފާތު ޓޮލަރެންސްއަށްވުރެ ބޮޑެވެ. ތަފްސީލުގައި ކޮންމެއް ބަޔާންކުރެވިފައިވެއެވެ.",
      "ERR_OWNERSHIP_INCONSISTENT": "ސަބްސިޑިއަރީއެއްގެ ގްރޫޕް ބައްޕަ ކުންފުނީގެ މިލްކުވުން 100% އަށްވުރެ މަތިވެއެވެ. މިލްކުވާ ފަރާތްތަކުގެ ފަސްދަރަޖަ ބަލާލައްވާ.",
      "ERR_CONSOL_NOT_MEMBER": "އެ ކުންފުނި އެދުނު ތާރީޚުގައި ގްރޫޕްގެ މެމްބަރެއް ނޫނެވެ.",
      "ERR_CONSOL_WINDOW_TOO_LARGE": "ރޭޓްތަކުގެ އެވަރޭޖް ހިސާބުކުރުމަށް މުއްދަތު ދިގުވެގެން ގޮސްފިއެވެ. ކުރު މުއްދަތެއް ހޮވާ.",
      "ERR_EINVOICE_NOT_CONFIGURED": "މި ލީގަލް އެންޓިޓީގެ ޖުރިސްޑިކްޝަނަށް އީ-އިންވޮއިސިންގ ކޮންފިގާކުރެވިފައެއް ނުވެއެވެ. އެހެން ޑެލިވަރީ ޗެނަލެއް ހޮވާ، ނުވަތަ އީ-އިންވޮއިސިންގ ނެޓްވޯކެއް ތައްޔާރުކޮށް އެކްޓިވޭޓްކުރުމަށް އެޑްމިނިސްޓްރޭޓަރަކަށް އެދުއްވާ.",
      "ERR_CLOSE_STATEMENTS_STALE": "މި ސްޓޭޓްމަންޓް ސެޓްގެ ޢަދަދުތައް ލެޖަރުން މިހާރު ނުފެނެއެވެ، މިސާލަކަށް ލަސްވެ ޕޯސްޓްކުރުމަކުން. އާ ވާރޝަނެއް ބިނާކޮށް އެ ޕަބްލިޝްކުރައްވާ.",
      "ERR_PERIOD_NOT_CLOSED": "މިއަށް މުއްދަތު ކްލޯޒްކުރެވިފައި ހުންނަންޖެހެއެވެ، އެކަމަކު އަދި ކްލޯޒްކުރެވިފައެއް ނުވެއެވެ. ފުރަތަމަ މުއްދަތު ކްލޯޒްކޮށް، ދެން އަލުން މަސައްކަތް ކުރައްވާ.",
      "ERR_AR_PROMISE_CLOSED": "މި ވަޢުދު މިހާރު ހުޅުވިފައެއް ނުވާތީ ބަދަލެއް ނުކުރެވޭނެ.",
      "ERR_EXIT_BLOCKED": "މި ބޭރުވުން އަދި ނިންމިފައެއް ނުވެއެވެ. މުވައްޒަފާ އަދިވެސް އަނބުރާ ހަވާލުކުރަން ބާކީ އެއްޗެއް އެބަހުއްޓެވެ، މިސާލަކަށް ކޭޝް ވޮލެޓެއް. ތަފްސީލުގައި ކޮންމެ އެއްޗެއް ބަޔާންކުރެވިފައިވެއެވެ.",
      "ERR_WALLET_CASH_BOOK_HELD": "މި ކޭޝް ބުކްތަކުގެ އެއް ބުކް އަދިވެސް އެހެން ވޮލެޓަކަށް ނިސްބަތްވެއެވެ. ވޮލެޓެއްގައި ނެތް ކޭޝް ބުކެއް ހޮވާ.",
      "ERR_WALLET_NOT_RECONCILED": "މި ވޮލެޓްގެ ފަހުގެ ރީކޮންސިލިއޭޝަނުން ތަފާތެއް ބާކީ ދޫކޮށްފިއެވެ. ފުރަތަމަ އޭގެ ކޭޝް ބުކްތައް ރީކޮންސައިލްކޮށް ތަފާތު ސާފުކުރައްވާ.",
      "ERR_WALLET_CLOSE_BLOCKED": "މި ވޮލެޓްގައި އަދިވެސް ހުޅުވިފައިވާ އައިޓަމްތަކެއް ހުރެއެވެ. ތަފްސީލުގައި ކޮންމެ އެއްޗެއްގެ އަގާއި ވެރިފަރާތް ބަޔާންކުރެވިފައިވެއެވެ. ބަންދުކުރުމުގެ ކުރިން އެތަކެތި ނިންމާލައްވާ.",
      "ERR_WALLET_HANDOVER_NOT_A_PARTY": "މި ހަވާލުކުރުމަށް އެކްނޮލެޖްކުރެވޭނީ ބޭރުވާ ނުވަތަ ވަދެވޭ ކަސްޓޯޑިއަނަކަށް ކަމުގައި ވާ ފަރާތަކުންނެވެ.",
      "ERR_WALLET_RECOVERY_EXCEEDS_BALANCE": "އަދަދު ވޮލެޓްގައި ހުރި އަދަދަށްވުރެ ބޮޑުވެއެވެ. ބެލެންސަށްވުރެ ގިނައިން ރިކަވަރ ނުކުރައްވާ.",
      "ERR_WALLET_NOT_ACTIVE": "މި ވޮލެޓް އެކްޓިވް ނޫނެވެ، އެހެންކަމުން އޭގެ މައްޗަށް އެއްޗެއް ރެކޯޑްކުރެވޭނެ ނޫން.",
      "ERR_USE_DEBT_SCHEDULE": "ލޯނުގެ ބަދަލުތައް އަންނަނީ ފެސިލިޓީގެ ދަރަނި އަނބުރާ ދެއްކުމުގެ ޝެޑިއުލުންނެވެ. ލޯނު ރެކޯޑުކުރާނީ ދަރަނީގެ ފެސިލިޓީއެއްގެ ގޮތުގައެވެ، ތަކުރާރުވާ ފައިސާގެ އައިޓަމެއްގެ ގޮތުގައި ނޫނެވެ.",
      "ERR_BUDGET_MATERIALITY_APPROVAL_UNRESOLVABLE": "ބަޖެޓް މެޓީރިއަލިޓީ ހައްދަށް ބަދަލުގެނައުމަށް ތިބާ ނޫން އެހެން އެޕްރޫވަރަކު ކޮންފިގާކުރެވިފައެއް ނުވާތީ، ލުއި ހައްދެއް އެދެވޭނެ ގޮތެއް ނެތެވެ. އެޕްރޫވަލް ސިޔާސަތެއް ތައްޔާރުކުރުމަށް އެޑްމިނިސްޓްރޭޓަރަކަށް އެދުއްވާ.",
      "ERR_CLOSE_NOT_READY": "ސަބް-ލެޖަރަކީ އޭގެ ކޮންޓްރޯލް އެކައުންޓާ އެއްގޮތެއް ނޫނެވެ.",
      "ERR_RECORD_LOCKED": "މި ރެކޯޑަށް އިތުރަށް އެޓޭޗްމަންޓް ބަލައެއް ނުގަނެވެ.",
      "ERR_LEASE_APPROVAL_UNRESOLVABLE": "ލީސް ކޮންޓްރެކްޓްތަކަށް އެޕްރޫވަރެއް ކަނޑައަޅާފައެއް ނުވޭ: ލީސް ކޮންޓްރެކްޓް އެޕްރޫވަލް ޕޮލިސީއެއް އިތުރުކުރޭ.",
      "ERR_IC_DIFFERENCE_EVIDENCE_REQUIRED": "މި އިންޓަރކޮމްޕެނީ ތަފާތު ހައްލުކުރުމުގެ ކުރިން، ހައްލުކުރި ގޮތުގެ ހެކިތަކެއް އެޓޭޗްކުރޭ.",
      "ERR_EXPENSE_PAYROLL_SETTLEMENT": "މި ކްލެއިމް ނުވަތަ އެޑްވާންސް ޕޭރޯލް މެދުވެރިކޮށް ސެޓްލްކުރެވޭކަށް ނެތް: އެއީ ޕޭރޯލް ރަންއެއްގައި ހިމެނިފައި ވުން، މުވައްޒަފު މި ކުންފުނީގެ ޕޭރޯލްގައި ނެތުން، ކްލެއިމް ކުންފުނީގެ ކަރެންސީގައި ނޫން ކަމުގައި ވުން، ނުވަތަ ރީއިމްބަރސްމަންޓް ކްލިއަރިންގ އެކައުންޓް ނެތުން ކަމުގައި ވެދާނެ.",
      "ERR_EXPENSE_PAYROLL_NOTHING_TO_PAY": "މި ކްލެއިމްގައި ޕޭރޯލުން ރިއިމްބަރސްކުރަން ޖެހޭ މުވައްޒަފު ދެއްކި ޚަރަދެއް ނެތް.",
      "ERR_REVALUATION_EXISTS": "މި މުއްދަތަށް ކުންފުނީގެ އެފްއެކްސް ރިވެލިއުއޭޝަނެއް އެބަހުރި. އެހެން އެއް ތައްޔާރުކުރުމަށް ޑްރާފްޓް ބާތިލްކުރޭ، ނުވަތަ ޕޯސްޓްކުރެވިފައިވާ އެއް ލެޖަރުން ރިވާސްކުރޭ.",
      "ERR_REVALUATION_STALE": "މި ރިވެލިއުއޭޝަން ތައްޔާރުކުރުމަށްފަހު ފޮތްތައް ބަދަލުވެއްޖެ. އެ ބާތިލްކޮށް އައު އެއް ތައްޔާރުކުރޭ.",
      "ERR_REVALUATION_NOTHING": "އަލުން އަގުކުރަން އެއްޗެއް ނެތް: އެއްވެސް ފޮރިން ކަރެންސީ ބާކީއެއް އޭގެ ބުކް ވެލިއުއިން ތަފާތެއް ނުވޭ.",
      "ERR_REVALUATION_NOT_CONFIGURED": "ރިވެލިއުއޭޝަނެއް ހިންގުމުގެ ކުރިން ކުންފުނީގެ އަންރިއަލައިޒްޑް އެފްއެކްސް ގެއިން އަދި ލޮސް އެކައުންޓްތައް ކަނޑައަޅާ.",
      "ERR_USE_PROMOTE": "ސިނާރިއޯއެއް ބޭސް ކަމުގައި ވާނީ އެޕްރޫވަލްއިން ހަމައެކަނި. އެކަމަށް އެދުމަށް ޕްރޮމޯޓް ބޭނުންކުރޭ.",
      "ERR_SCENARIO_BASE_LOCKED": "އެޕްރޫވްކުރެވިފައިވާ ބޭސް އޭގައިވެސް ބަދަލުކުރެވޭކަށް ނެތް. އޭގެ ބަދަލުގައި ބަދަލު ސިނާރިއޯއެއް ޕްރޮމޯޓްކުރޭ.",
      "ERR_SCENARIO_PROMOTION_PENDING": "މި ސިނާރިއޯ ޕްރޮމޯޝަން ނިންމުމަށް އިންތިޒާރުކުރަމުންދާތީ ބަދަލުކުރެވޭކަށް ނެތް. ފުރަތަމަ އެދުން ވަދާޢުކުރޭ.",
      "ERR_SCENARIO_NOT_APPROVED": "ޕަބްލިޝްކުރެވޭ ލިކުވިޑިޓީ އެނަލިސިސްގެ އަސާސް ކަމުގައި ވާނީ އެޕްރޫވްކުރެވިފައިވާ ބޭސް ހަމައެކަނި. ފުރަތަމަ މި ސިނާރިއޯ ޕްރޮމޯޓްކުރޭ، ނުވަތަ ހޯދުމެއްގެ ގޮތުގައި ބައްލަވާލާ.",
      "ERR_SCENARIO_NO_FORECAST": "ބޭސްއާ އަޅާކިޔާލުމަށް މި ސިނާރިއޯގައި މިހާރު ޕަބްލިޝްކުރެވިފައިވާ ފޮރކާސްޓެއް ނެތުމުން އަދި ޕްރޮމޯޓްކުރެވޭކަށް ނެތް.",
      "ERR_ATTENTION_APPROVAL_RESOLVE": "އެޕްރޫވަލެއް އެޓެންޝަން ލިސްޓުން ބަލައިގަތުމަށް ނުވަތަ ހައްލުކުރުމަށް ނުކުރެވޭނެއެވެ. އޭގެ ބަދަލުގައި އެޕްރޫވަލް އިންބޮކްސްގައި ފިޔަވަޅު އަޅުއްވާ.",
      "ERR_REVPOLICY_APPROVAL_UNRESOLVABLE": "ރެވެނިއު ޕޮލިސީއަށް ތިޔަބޭފުޅާ ފިޔަވައި އެޕްރޫވަރަކު ނުފެނެއެވެ. އެޕްރޫވް ހުއްދަ އެއްވެސް މީހަކަށް ދިނުމަށް ޓެނަންޓް އެޑްމިންގެ އެހީ ހޯއްދަވާ.",
      "ERR_REVPOLICY_IN_FORCE": "ރެވެނިއު ޕޮލިސީއެއް ކުރިން ޢަމަލުގައި އެބަހުއްޓެވެ. އައު ވާރޝަނަކުން އެ ބަދަލުކުރައްވާ.",
      "ERR_REVPOLICY_DRAFT_OPEN": "ރެވެނިއު ޕޮލިސީ ވާރޝަނެއް ކުރިން ހުޅުވިފައިވެއެވެ. އަނެއް ވާރޝަން ފެށުމުގެ ކުރިން އެ ނިންމާ ނުވަތަ ފޮހެލައްވާ.",
      "ERR_REVPOLICY_NO_RULES": "ރެވެނިއު ޕޮލިސީ ވާރޝަން ހުށަހެޅުމުގެ ކުރިން އެއް ގަވާއިދު މަދުވެގެން ބޭނުންވެއެވެ.",
      "ERR_TP_NO_POLICY": "އެ ތާރީޚުގައި މި ދެކޮޅަށް ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތެއް ނެތް.",
      "ERR_TP_POLICY_NOT_APPROVED": "މި ތާރީޚަށް ސިޔާސަތެއް އޮތް ނަމަވެސް އެއްވެސް ސިޔާސަތެއް އެޕްރޫވްވެފައެއް ނެތް.",
      "ERR_TP_POLICY_OVERLAP": "މި މުއްދަތު ހަމަ އެ ދެކޮޅާއި ބާވަތުގެ އެހެން ސިޔާސަތަކާ ފުށުއަރާ. އޭގެ ބަދަލުގައި އެޕްރޫވްކުރެވިފައިވާ ސިޔާސަތު ބަދަލުކުރޭ.",
      "ERR_TP_APPROVAL_UNRESOLVABLE": "މި ސިޔާސަތަށް ފެތޭ އެޕްރޫވަލް ގަވާއިދެއް ނެތް. ހުށަހެޅުމުގެ ކުރިން ގަވާއިދެއް ސެޓްކުރޭ.",
      "ERR_TP_SUCCESSOR_WINDOW": "ބަދަލަށް އަންނަ ސިޔާސަތު ފެށެންވާނީ ކުރީގެ ސިޔާސަތަށް ފަހުން، ހަމަ އެ ދެކޮޅާއި ބާވަތަށް.",
      "ERR_BANK_LIMIT_APPROVAL_UNRESOLVABLE": "މި ބޭންކު ހައްދު ލުއިކުރުމަށް ތިޔަބޭފުޅާ ފިޔަވައި އެޕްރޫވަރަކު ނުފެނެއެވެ. ބޭންކު ހައްދުގެ އެޕްރޫވަލް ޕޮލިސީ ބަލައިދިނުމަށް ޓެނަންޓް އެޑްމިންގެ އެހީ ހޯއްދަވާ.",
      "ERR_EXPORT_TOO_LARGE": "އެކްސްޕޯޓް ވަރަށް ބޮޑުވެއްޖެ. ތާރީޚު ނުވަތަ ފިލްޓަރު ކުޑަކޮށް އަލުން މަސައްކަތް ކުރައްވާ."
    }
  },
  "metrics": {
    "treasury": {
      "debtServiceCoverage": {
        "label": "ޑެޓް ސާވިސް ކަވަރޭޖް",
        "description": "ފާއިތުވެދިޔަ ބާރަ މަހުގެ އޮޕަރޭޓިންގ އާމްދަނީން، އެ މުއްދަތުގައި ދައްކަންޖެހޭ ޕްރިންސިޕަލާއި އިންޓްރަސްޓް ކިތައް ފަހަރު ކަވަރުކުރޭތޯއެވެ. ލެޖަރާއި ފެސިލިޓީގެ ޝެޑިއުލްތަކުން ހިސާބުކުރާ ކޮވެނަންޓް މެޓްރިކެކެވެ.",
        "formula": "ފާއިތުވި 12 މަހުގެ EBITDA ÷ (ފާއިތުވި 12 މަހުގައި ދައްކަންޖެހޭ ޕްރިންސިޕަލް + އިންޓްރަސްޓް)"
      },
      "netDebtToEbitda": {
        "label": "ނެޓް ޑެޓް ޓު EBITDA",
        "description": "ޑްރޯކުރި ޤަރުޟުން، ފަހުގެ ޕަބްލިޝްކުރި ޓްރެޒަރީ ޕޮޒިޝަނުގެ ކޭޝް ނެގުމުން ފާއިތުވި ބާރަ މަހުގެ އޮޕަރޭޓިންގ އާމްދަނީގެ ގިނަކަމެއްގެ ގޮތުގައެވެ. ކޮވެނަންޓް މެޓްރިކެކެވެ.",
        "formula": "(ހުރިހާ ފެސިލިޓީތަކުން ޑްރޯކުރި ޖުމްލަ − ޕަބްލިޝްކުރި ކޭޝް) ÷ ފާއިތުވި 12 މަހުގެ EBITDA"
      },
      "interestCover": {
        "label": "އިންޓްރަސްޓް ކަވަރ",
        "description": "ފާއިތުވި ބާރަ މަހުގެ އޮޕަރޭޓިންގ އާމްދަނީން، އެ މުއްދަތުގެ އިންޓްރަސްޓް ޚަރަދު ކިތައް ފަހަރު ކަވަރުކުރޭތޯއެވެ. ކޮވެނަންޓް މެޓްރިކެކެވެ.",
        "formula": "ފާއިތުވި 12 މަހުގެ EBITDA ÷ ފާއިތުވި 12 މަހުގެ އިންޓްރަސްޓް ޚަރަދު"
      },
      "currentRatio": {
        "label": "ކަރަންޓް ރޭޝިއޯ",
        "description": "ޓެސްޓްކުރާ ދުވަހު އެސެޓްތަކާއި ލައިބިލިޓީތަކުގެ ނިސްބަތެވެ. ޗާޓް އޮފް އެކައުންޓްސްގައި ކަރަންޓް އަދި ނޮން ކަރަންޓް ބައިވެރިކުރުމެއް އަދި ނެތުމުން ޖުމްލަ އެސެޓްތަކާއި ޖުމްލަ ލައިބިލިޓީތައް ބޭނުންކުރެވެއެވެ.",
        "formula": "ޖުމްލަ އެސެޓް ÷ ޖުމްލަ ލައިބިލިޓީ"
      },
      "tangibleNetWorth": {
        "label": "ޓެންޖިބަލް ނެޓް ވޯތް",
        "description": "ޓެސްޓްކުރާ ދުވަހުގެ އިކުއިޓީއެވެ. އިންޓެންޖިބަލް އެސެޓް ބައިވެރިކުރުމެއް އަދި ނެތުމުން ޖުމްލަ އިކުއިޓީއާ އެއްވަރެވެ.",
        "formula": "ޖުމްލަ އިކުއިޓީ (އިންޓެންޖިބަލް އެސެޓް އަދި ނުކެނޑެއެވެ)"
      },
      "autoMatchRate": {
        "label": "އޮޓޮ-މެޗް ރޭޓް",
        "description": "ވިންޑޯގައި ހުރި ބޭންކު ސްޓޭޓްމަންޓް ލައިންތަކުގެ ތެރެއިން އޮޓޮ-މެޗް އިންޖިނުން މެޗްކުރި ބައި. އަތުން ކުރި މެޗެއް ނުގުނޭ.",
        "formula": "އޮޓޮ-މެޗްކުރެވުނު ސްޓޭޓްމަންޓް ލައިންތައް ÷ ވިންޑޯގައި ހުރި ހުރިހާ ލައިވް ސްޓޭޓްމަންޓް ލައިންތައް"
      },
      "daysToReconcile": {
        "label": "ރިކަންސައިލް ކުރުމަށް ދުވަސް",
        "description": "ސްޓޭޓްމަންޓް މުއްދަތު ނިމޭ ދުވަހުން ރިކަންސިލިއޭޝަން ސެޝަން ބަންދުކުރި ދުވަހާ ހަމައަށް ދިޔަ އެވްރެޖް ދުވަސް.",
        "formula": "ވިންޑޯގައި ބަންދުކުރި ސެޝަންތަކުގެ (ބަންދުކުރި ދުވަސް − ސްޓޭޓްމަންޓް މުއްދަތު ނިމޭ ދުވަސް) ގެ އެވްރެޖް"
      },
      "forecastAccuracy": {
        "label": "ފޯކާސްޓްގެ ޚިޔާލު ސައްހަކަން",
        "description": "ޝާއިއުކުރެވުނު ކޭޝް ފޯކާސްޓަކީ ހަލުވެފައިވާ ކޭޝްއާ ކިހާ ގާތްތޯ. ބައެއް ފަހަރު ކަމުނުދާނެ: ފޯކާސްޓެއް ދެނެގަނެ ސެޓިފައި ނުކުރެވޭ.",
        "formula": "100 − ވިންޑޯގައި ބެލި ފޯކާސްޓް ބަކެޓްތަކުގެ މެދުމިނުގެ ސައްހަ ޕަސެންޓް ކުށް"
      },
      "idleBalance": {
        "label": "ބޭނުންނުކުރާ ބެލެންސް",
        "description": "ބޭންކު އެކައުންޓްތަކާއި ވޮލެޓްތަކުގައި އިންޒުވަރުކުރާ މުއްދަތަށް ވުރެ ގިނަ ދުވަހު ހަރަކާތެއް ނެތި ހުރި ފައިސާ، ކޮމިޓްމަންޓްތަކާއި ވޮލެޓްގެ މިނިމަމް ކެނޑުމަށްފަހު.",
        "formula": "އައިޑަލް ކޭޝް ރިޕޯޓްގެ ރިކަވަރުކުރެވޭނެ އަގުގެ ޖުމްލަ"
      },
      "floatUtilisation": {
        "label": "ފްލޯޓް ބޭނުންކުރުން",
        "description": "ހުއްދަކުރެވިފައިވާ ފްލޯޓް ބަޔާންކޮށްފައިވާ ވޮލެޓްތަކުގެ ތެރެއިން ފްލޯޓުގެ ބޭރުގައި ހުރި ބައި.",
        "formula": "(ހުއްދަކުރެވިފައިވާ ފްލޯޓް − ކަށަވަރުކުރެވިފައިވާ ބެލެންސް) ÷ ހުއްދަކުރެވިފައިވާ ފްލޯޓް"
      }
    }
  },
  "routes": {
    "documentTitle": "{title} · އެންޓަރޕްރައިޒްއޭއައި އީއާރްޕީ",
    "titles": {
      "login": "ސައިން އިން",
      "ssoCallback": "ސިންގަލް ސައިން-އޮން",
      "forgotPassword": "ޕާސްވޯޑް ރީސެޓްކުރޭ",
      "resetPassword": "އައު ޕާސްވޯޑެއް އިޚްތިޔާރުކުރޭ",
      "changePassword": "އަމިއްލަ ޕާސްވޯޑެއް އިޚްތިޔާރުކުރޭ",
      "acceptInvite": "ދައުވަތު ޤަބޫލުކުރޭ",
      "dashboard": "ޑޭޝްބޯޑް",
      "approvals": "ފާސްކުރުންތައް",
      "users": "ބޭނުންކުރާ ފަރާތްތައް",
      "roles": "ރޯލްތައް",
      "audit": "އޮޑިޓް އެކްސްޕްލޯރަރ",
      "profile": "ޕްރޮފައިލް އަދި ސެކިއުރިޓީ",
      "forbidden": "ހުއްދައެއް ނެތް",
      "notFound": "ޞަފުޙާއެއް ނުފެނުނު",
      "taxCodes": "ޓެކްސް ކޯޑުތައް",
      "taxReport": "ޓެކްސް ޕޮޒިޝަން",
      "currencies": "ފައިސާގެ ބާވަތްތައް",
      "fxRates": "ބަދަލުކުރާ ރޭޓުތައް",
      "orgHierarchy": "އިދާރީ އޮނިގަނޑު",
      "orgFiscalPeriods": "ފިސްކަލް މުއްދަތުތައް",
      "orgAccounts": "ހިސާބުތަކުގެ ޗާޓް",
      "orgOpeningBalances": "ފެށޭ ބެލެންސްތައް",
      "orgGoLive": "ގޯ-ލައިވް ޗެކްލިސްޓް",
      "glJournalEntries": "ޖާނަލް އެންޓްރީތައް",
      "glJournalEntry": "ޖާނަލް އެންޓްރީ",
      "glJournalEntryNew": "އައު ޖާނަލް އެންޓްރީ",
      "glTrialBalance": "ޓްރަޔަލް ބެލެންސް",
      "glIncomeStatement": "އާމްދަނީގެ ބަޔާން",
      "glBalanceSheet": "ބެލެންސް ޝީޓް",
      "glLedger": "ޖީއެލް ތަފްޞީލު",
      "glRecurringTemplates": "ތަކުރާރު ޖާނަލްތައް",
      "apVendor": "ވިއްކާފަރާތް",
      "apInvoices": "ވިއްކާފަރާތުގެ އިންވޮއިސްތައް",
      "apCreditNotes": "ވިއްކާފަރާތުގެ ކްރެޑިޓް ނޯޓުތައް",
      "apDebitNotes": "ވިއްކާފަރާތުގެ ޑެބިޓް ނޯޓުތައް",
      "apInvoiceNew": "އައު އޭޕީ ލިޔުން",
      "apInvoice": "އޭޕީ ލިޔުން",
      "apPaymentRun": "ފައިސާ ދެއްކުމުގެ ރަން",
      "cashAccount": "ބޭންކް ނުވަތަ ފައިސާގެ އެކައުންޓް"
    }
  },
  "nav": {
    "landmark": "މޮޑިއުލްތައް",
    "home": "ހޯމް",
    "breadcrumbLandmark": "މަގު",
    "groups": {
      "workspace": "ވޯކްސްޕޭސް",
      "self": "އަމިއްލަ ޚިދުމަތް",
      "account": "އެކައުންޓް"
    },
    "parts": {
      "home": "ހޯމް",
      "me": "އަހަރެން",
      "enterprise": "1 އެންޓަރޕްރައިޒް",
      "finance": "2 މާލީ",
      "treasury": "3 ޓްރެޜަރީ",
      "procurement": "4 ޕްރޮކިއުމަންޓް",
      "sales": "5 ސޭލްސް",
      "crm": "6 ސީއާރްއެމް",
      "inventory": "7 ސްޓޮކް",
      "manufacturing": "8 އުފެއްދުން",
      "hcm": "9 އިންސާނީ ވަސީލަތުގެ މެނޭޖްމަންޓް",
      "pointOfSale": "10 ޕޮއިންޓް އޮފް ސޭލް",
      "propertyManagement": "11 ޕްރޮޕަޓީ މެނޭޖްމަންޓް",
      "projects": "12 ޕްރޮޖެކްޓްތައް",
      "service": "13 ޚިދުމަތް",
      "eam": "14 އެސެޓް މެނޭޖްމަންޓް",
      "revenueManagement": "15 ރެވެނިއު މެނޭޖްމަންޓް",
      "platform": "D · 17 ޕްލެޓްފޯމް"
    },
    "items": {
      "dashboard": {
        "label": "ޑޭޝްބޯޑް",
        "description": "ޓެނަންޓްގެ ޙާލަތާއި ސަމާލުކަން ބޭނުންވާ ކަންކަން",
        "keywords": "ހޯމް ޚުލާޞާ ކޭޕީއައި"
      },
      "approvals": {
        "label": "ފާސްކުރުންތައް",
        "description": "ތިޔަ ފަރާތުގެ ނިންމުމަށް އިންތިޒާރުކުރާ ހުރިހާ ކަމެއް",
        "keywords": "އިންބޮކްސް ފާސްކުރުން ބޭރުކުރުން މަސައްކަތްތައް"
      },
      "users": {
        "label": "ބޭނުންކުރާ ފަރާތްތައް",
        "description": "ޓެނަންޓްގެ ބޭނުންކުރާ ފަރާތްތަކުގެ އެކައުންޓް، ދައުވަތު އަދި ރޯލްތައް",
        "keywords": "މީހުން މުވައްޒަފުން ދައުވަތު އެކައުންޓް"
      },
      "roles": {
        "label": "ރޯލްތައް",
        "description": "ރޯލްތަކާއި އެ ރޯލްތަކުން ދޭ ހުއްދަތައް",
        "keywords": "އާރްބީއޭސީ ހުއްދަތައް އެކްސެސް"
      },
      "audit": {
        "label": "އޮޑިޓް އެކްސްޕްލޯރަރ",
        "description": "ކޮންމެ ބަދަލެއްގެ ބަދަލުނުކުރެވޭ ރެކޯޑް",
        "keywords": "ލޮގް ރެކޯޑް ހެކި ކާކުކުރީ ކޮންކަމެއް"
      },
      "profile": {
        "label": "ޕްރޮފައިލް އަދި ސެކިއުރިޓީ",
        "description": "ތިޔަ ފަރާތުގެ މަޢުލޫމާތު، ޕާސްވޯޑް، އެމްއެފްއޭ އަދި ހިނގަމުންދާ ސެޝަންތައް",
        "keywords": "ޕާސްވޯޑް އެމްއެފްއޭ ސެޝަން އަހަރެން"
      },
      "taxCodes": {
        "label": "ޓެކްސް ކޯޑުތައް",
        "keywords": "ޓެކްސް ޖީއެސްޓީ ޓީޖީއެސްޓީ ވެޓް ލެވީ ރޭޓް ފުރިހަމަކުރުން",
        "description": "ކޮންމެ ޓެކްސް ކޯޑެއްގެ ރޭޓާއި، ބާވަތާއި، އަމަލުކުރާ ތާރީޚުތައް."
      },
      "taxReport": {
        "label": "ޓެކްސް ޕޮޒިޝަން",
        "keywords": "ޓެކްސް ރިޕޯޓް ޖީއެސްޓީ ރިޓަރން މީރާ",
        "description": "މުއްދަތެއްގެ އިންޕުޓް އަދި އައުޓްޕުޓް ޓެކްސް، ސީއެސްވީ އެކްސްޕޯޓާއެކު."
      },
      "currencies": {
        "label": "ފައިސާގެ ބާވަތްތައް",
        "keywords": "ފައިސާ ރުފިޔާ ޑޮލަރު ޔޫރޯ ކޯޑް ނިޝާން",
        "description": "މި ވަރކްސްޕޭސްގައި މުޢާމަލާތްކުރާ ފައިސާގެ ބާވަތްތައް."
      },
      "fxRates": {
        "label": "ބަދަލުކުރާ ރޭޓުތައް",
        "keywords": "އެފްއެކްސް ބަދަލުކުރާ ރޭޓް ބަދަލުކުރުން އިދިކޮޅު ޖޯޑު",
        "description": "ޖޯޑާއި ތާރީޚުން ރެކޯޑްކޮށްފައިވާ ރޭޓުތަކާއި، ދުވަހަކަށް އަމަލުކުރާ ރޭޓް."
      },
      "orgHierarchy": {
        "label": "ޑިޕާޓްމަންޓްތަކާއި ކޮސްޓް ސެންޓަރުތައް",
        "description": "ގޮފިތައް، ޑިޕާޓްމަންޓްތައް، ކޮސްޓް އަދި ޕްރޮފިޓް ސެންޓަރުތައް",
        "keywords": "ގޮފި ޑިޕާޓްމަންޓް ކޮސްޓް ސެންޓަރ ޕްރޮފިޓް ޔުނިޓް"
      },
      "orgFiscalPeriods": {
        "label": "ފިސްކަލް މުއްދަތުތައް",
        "description": "ކަލަންޑަރުތައް، މުއްދަތުތައް އަދި މުއްދަތު ބަންދުކުރުން",
        "keywords": "ކަލަންޑަރު މުއްދަތު ބަންދު އަހަރު"
      },
      "orgAccounts": {
        "label": "ޖީއެލް އެކައުންޓްތައް",
        "description": "ކޮންމެ ޕޯސްޓިންގއެއް ޖެހޭ ހިސާބުތަކުގެ ގަސް",
        "keywords": "ހިސާބު ލެޖަރ ކޯޑް ޗާޓް"
      },
      "orgOpeningBalances": {
        "label": "ފެށޭ ބެލެންސްތައް",
        "description": "ފެށޭ ބެލެންސްތައް އިމްޕޯޓްކުރޭ",
        "keywords": "ފެށޭ ބެލެންސް އިމްޕޯޓް ސީއެސްވީ"
      },
      "orgGoLive": {
        "label": "ގޯ-ލައިވް ޗެކްލިސްޓް",
        "description": "ސެޓަޕްވެފައިވަނީ ކޮންކަމެއްކަމާއި އަދި ނުނިމޭ ކަންކަން",
        "keywords": "ޗެކްލިސްޓް ސެޓަޕް ތައްޔާރީ އޮންބޯޑިންގ"
      },
      "glJournalEntries": {
        "label": "ޖާނަލް އެންޓްރީތައް",
        "keywords": "ޖާނަލް އެންޓްރީ ލެޖަރ ޕޯސްޓިންގ ވައުޗަރ ޑަބަލް",
        "description": "ޖާނަލް އެންޓްރީ އުފެއްދުން، ޕޯސްޓްކުރުން އަދި ރިވާސްކުރުން"
      },
      "glTrialBalance": {
        "label": "ޓްރަޔަލް ބެލެންސް",
        "keywords": "ޓްރަޔަލް ބެލެންސް ޑެބިޓް ކްރެޑިޓް",
        "description": "ހުރިހާ ހިސާބެއް، އަދި ލެޖަރ ސުމަކަށް ދާކަމުގެ ހެކި"
      },
      "glIncomeStatement": {
        "label": "އާމްދަނީގެ ބަޔާން",
        "keywords": "އާމްދަނީ ބަޔާން ފައިދާ ގެއްލުން ޚަރަދު",
        "description": "މުއްދަތެއްގައި އާމްދަނީން ޚަރަދު އުނިކުރުމުން، އަޅާކިޔުމާއެކު"
      },
      "glBalanceSheet": {
        "label": "ބެލެންސް ޝީޓް",
        "keywords": "ބެލެންސް ޝީޓް މުދާ ދަރަނި އިކުއިޓީ",
        "description": "ތާރީޚެއްގައި ހުރި ޙާލަތު، މުދާ ހަމަވާކަން ޔަޤީންކުރުމާއެކު"
      },
      "glLedger": {
        "label": "ޖީއެލް ތަފްޞީލު",
        "keywords": "ލެޖަރ ތަފްޞީލު ހިސާބު މުޢާމަލާތް",
        "description": "އެއް ހިސާބެއްގެ ހުރިހާ ޕޯސްޓިންގއެއް، ހިނގަމުންދާ ބެލެންސާއެކު"
      },
      "glRecurringTemplates": {
        "label": "ތަކުރާރު ޖާނަލްތައް",
        "keywords": "ތަކުރާރު ޓެމްޕްލޭޓް ޝެޑިއުލް ތަކުރާރުވާ",
        "description": "ޝެޑިއުލްއަކަށް ވޯކަރ ޕޯސްޓްކުރާ ޖާނަލްތައް"
      },
      "apVendors": {
        "description": "ސަޕްލަޔަރުން، އެފަރާތްތަކުގެ ޝަރުޠުތައް އަދި ބޭންކް މަޢުލޫމާތު"
      },
      "apInvoices": {
        "description": "ވިއްކާފަރާތްތަކުގެ ބިލުތައް: ވެއްދުން، ފާސްކުރުން، ޕޯސްޓްކުރުން، ދެއްކުން"
      },
      "apPaymentRuns": {
        "description": "ސަޕްލަޔަރުންނަށް ފައިސާ ދެއްކުން ހުށަހެޅުން، ފާސްކުރުން އަދި ތަންފީޒުކުރުން"
      },
      "apAging": {
        "description": "ސަޕްލަޔަރުންނަށް ދޭންޖެހޭ ފައިސާ، ލަސްވެފައިވާ މުއްދަތުން ބަހާލައިގެން"
      },
      "apSettings": {
        "label": "ދޭންޖެހޭ ހިސާބުގެ ސެޓިންގްސް",
        "keywords": "ދޭންޖެހޭ ހިސާބު ސެޓިންގްސް ދުއްވެވޭ ބިލު ވިއްކާފަރާތް ފައިސާ ދެއްކުން",
        "description": "ސަޕްލަޔަރު ބިލުތަކާއި ފައިސާ ދެއްކުމަށް ކުންފުނީގެ ޑިފޯލްޓް އަދި ކޮންޓްރޯލްތައް"
      },
      "closeYearEndPlan": {
        "label": "އަހަރު ނިމުމުގެ ކްލޯޒް ޕްލޭން",
        "keywords": "އަހަރު ނިމުން ކްލޯޒް ޕްލޭން ރިޓެއިންޑް އާނިންގްސް މާލީ އަހަރު",
        "description": "އަހަރު ނިމުމުގެ ކްލޯޒް ދުއްވުމުގެ ކުރިން ޕޯސްޓްކުރާނެ ކަންތައްތައް ސަތުރުން ސަތުރަށް"
      },
      "arCustomers": {
        "description": "ކަސްޓަމަރުން، އެފަރާތްތަކުގެ ކްރެޑިޓް ލިމިޓް އަދި ޝަރުޠުތައް"
      },
      "arInvoices": {
        "description": "ކަސްޓަމަރުންނަށް ބިލްކޮށް ލެޖަރަށް ޕޯސްޓްކުރޭ"
      },
      "arReceipts": {
        "description": "ލިބުނު ފައިސާ ރެކޯޑްކޮށް އިންވޮއިސްތަކަށް ބަހާލާ"
      },
      "arAging": {
        "description": "ކަސްޓަމަރުން ދޭންޖެހޭ ފައިސާ، ލަސްވެފައިވާ މުއްދަތުން ބަހާލައިގެން"
      },
      "cashAccounts": {
        "description": "ބޭންކާއި ފައިސާގެ އެކައުންޓްތައް، ލެޖަރާ ގުޅުވާފައި."
      },
      "cashTransferInstructions": {
        "description": "ގަވަރންޑް ލައިފްސައިކަލް: އެދުން، ފާސްކުރުން، ސޮއިކުރުން، ދޫކުރުން، ކަށަވަރުކުރުން."
      },
      "cashFundsInTransit": {
        "description": "ފޮނުވިފައި ނަމަވެސް އަދި ނުލިބޭ ފައިސާ، ބޭރުގައި ހުރި މުއްދަތުން ބަހާލައިގެން."
      },
      "treasuryPositions": {
        "description": "އެއްފަހަރު ކަނޑައަޅާ، ދެން ބަދަލުނުކުރެވޭ ފައިސާގެ ޕޮޒިޝަންތައް."
      },
      "treasuryBeneficiaries": {
        "description": "ފައިސާ ދޫކުރެވޭނެ ފަރާތްތަކާއި، ކޫލިންގ-އޮފް ހާލަތު."
      },
      "treasuryMandates": {
        "description": "ބޭންކް މެންޑޭޓްތަކާއި، ކުންފުނިން ސޮއިކުރެވޭނެ ފަރާތްތައް."
      },
      "treasuryWallets": {
        "description": "ކުޑަ ފައިސާގެ ފަންޑުތަކާއި، އެ ބަލަހައްޓާ ފަރާތްތަކާއި، ގުނުންތައް."
      },
      "treasuryFacilities": {
        "description": "ލޯނުތަކާއި އޯވަޑްރާފްޓާއި ރިވޯލްވަރ، އަދި ކޮވެނަންޓްތައް."
      },
      "treasuryForecasts": {
        "description": "ރައްކާކުރެވިފައިވާ 13 ހަފުތާގެ ފޯކާސްޓް ރަންތަކާއި، ސައްޙަކަން."
      },
      "treasurySettings": {
        "description": "ޓްރާންސްފަރ މޯޑާއި، އެލާޓް ލިމިޓާއި، ޓްރެޜަރީ ޕޯސްޓްކުރާ އެކައުންޓްތައް."
      },
      "crmAccounts": {
        "description": "ވިޔަފާރީގެ އެކައުންޓްތަކާއި، ކޮންޓެކްޓުންނާއި، ސެގްމަންޓްތައް."
      },
      "crmCampaigns": {
        "description": "މާކެޓިންގ ކެމްޕޭންތަކާއި، ފޮނުވުންތަކާއި، ޖަވާބުތައް."
      },
      "partyParties": {
        "description": "ކޮންމެ މީހަކަށް ނުވަތަ ޖަމިއްޔާއަކަށް އެއް ރެކޯޑް، އެއިން ކުޅޭ ކޮންމެ ދައުރެއް ގުޅުވައިދޭ"
      },
      "partyMerges": {
        "description": "ތަކުރާރުވެފައިވާ ފަރާތްތައް މާރޖްކުރަން ހުށަހަޅާފައިވާ ކަންކަމާއި، މާރޖްގެ ތާރީޚް"
      },
      "partyConsent": {
        "description": "ކޮންމެ ފަރާތަކުން ގުޅުމަށް ރުހިފައިވަނީ ކޮންކަމަކަށްތޯއާއި، ކިހިނެއްތޯ"
      },
      "partySuppressions": {
        "description": "ރުހުން އޮތްނަމަވެސް ދުވަހަކުވެސް ގުޅައިގެންނުވާނެ އެޑްރެސްތައް"
      },
      "partyLoyalty": {
        "description": "ލޮޔަލްޓީ ޕްރޮގްރާމްތަކާއި، ފަންތިތަކާއި، މެންބަރުންނާއި، ލިބޭ ޕޮއިންޓް."
      },
      "arDunning": {
        "description": "މުއްދަތު ހަމަވެފައިވާ އިންވޮއިސްތައް ހަނދާންކޮށްދިނުމުގެ ތާވަލަކުން ފޮލޯކުރޭ"
      },
      "bankrecSessions": {
        "description": "ސްޓޭޓްމަންޓް ލައިންތައް ލެޖަރާ ގުޅުވައި މުއްދަތު ބަންދުކުރޭ."
      },
      "bankrecImports": {
        "description": "ބޭންކް ސްޓޭޓްމަންޓް ސީއެސްވީ ނުވަތަ އެމްޓީ940 ގޮތުގައި އިމްޕޯޓްކުރޭ."
      },
      "bankrecProfiles": {
        "description": "ރައްކާކޮށްފައިވާ ކޮލަމް މެޕިންގތައް، ކޮންމެ ބޭންކަކަށް އެކެއް."
      },
      "budgetModels": {
        "description": "ބަޖެޓް މޮޑެލްތައް، ވަރޝަންތައް އަދި އޭގެ ލައިންތައް"
      },
      "budgetVariance": {
        "description": "ބަޖެޓާ އަޅާކިޔައި ކޮމިޓްމަންޓް، އެކްޗުއަލް އަދި ބާކީ"
      },
      "budgetCommitments": {
        "description": "ކޮމިޓްކޮށްފައިވާ ނަމަވެސް އަދި ޚަރަދުނުކުރާ"
      },
      "budgetControlLevels": {
        "description": "ކޮންމެ ކޮސްޓް ސެންޓަރެއްގެ ބަޖެޓް ހިފެހެއްޓޭ ލެވެލް، އަދި ލީގަލް އެންޓިޓީގެ ޑިފޯލްޓް."
      },
      "assetsRegister": {
        "description": "ހުރިހާ ފިކްސްޑް އެސެޓެއް، އޭގެ އަގު އަދި ފޮތުގެ އަގު"
      },
      "assetsClasses": {
        "description": "ބޭނުންކުރެވޭ މުއްދަތު، ގޮތް އަދި ކޮންމެ ކްލާހެއް ޕޯސްޓްކުރާ އެކައުންޓްތައް"
      },
      "assetsDepreciation": {
        "description": "ޑިޕްރިސިއޭޝަން ރަންތަކާއި ކޮންމެ ރަނަކުން ޗާޖްކުރި މިންވަރު"
      },
      "assetsMovement": {
        "description": "ފެށޭ، އިތުރުކުރުން، ޑިޕްރިސިއޭޝަން، ނައްތާލުން، ނިމޭ"
      },
      "invItems": {
        "description": "ސާމާނު، އޭގެ ޔުނިޓް، ބާކޯޑް އަދި ކޮސްޓިންގ ގޮތް."
      },
      "invStockLevels": {
        "description": "ހުރި މިންވަރު، އަދި ކުރިން ދޭން ހަމަޖެހިފައިވާ މިންވަރު."
      },
      "invLedger": {
        "description": "ސްޓޮކްގެ ހުރިހާ ހަރަކާތެއް، ހިނގި ތަރުތީބުން."
      },
      "invValuation": {
        "description": "ސްޓޮކްގެ އަގު، ލެޖަރާ ދިމާކޮށްފައި."
      },
      "invCycleCounts": {
        "description": "ބްލައިންޑް ގުނުންތަކާއި އެއިން ފެނުނު ތަފާތުތައް."
      },
      "procRequisitions": {
        "description": "މީހުން ގަންނަން އެދިފައިވާ ތަކެތި."
      },
      "procRfqs": {
        "description": "ސަޕްލަޔަރުންގެ އަގުތައް، އަޅާކިޔާފައި."
      },
      "procOrders": {
        "description": "ޕަރޗޭސް އޯޑަރުތަކާއި އެއަށް ލިބިފައިވާ ތަކެތި."
      },
      "procReceipts": {
        "description": "ޕަރޗޭސް އޯޑަރަށް ލިބުނު ތަކެތި."
      },
      "procMatches": {
        "description": "އިންވޮއިސް، އޯޑަރު އަދި ލިބުނު ތަކެތި އަޅާކިޔުން."
      },
      "procGrIr": {
        "description": "ލިބިފައިވާ ނަމަވެސް އަދި އިންވޮއިސް ނުކުރާ ތަކެތި."
      },
      "procScorecards": {
        "description": "ކޮންމެ ސަޕްލަޔަރެއްގެ ޙަޤީޤީ ޚިދުމަތުގެ ފެންވަރު."
      },
      "salesQuotes": {
        "description": "އަގު ހުށަހެޅުންތަކާއި އެ ޤަބޫލުކުރެވުނުތޯ."
      },
      "salesOrders": {
        "description": "ކަށަވަރުކުރެވުނު އޯޑަރުތައް، ދޭން ހަމަޖެހިފައިވާ އަދި ފޮނުވިފައިވާ."
      },
      "salesShipments": {
        "description": "ނަގައި ފޮނުވި ތަކެއްޗާއި ބާކީ ހުރި ބެކްއޯޑަރު."
      },
      "salesReturns": {
        "description": "އަނބުރާ ލިބުނު ތަކެތި، ދިޔަ އަގުގައި އަލުން ސްޓޮކަށް."
      },
      "pricingPriceLists": {
        "description": "ކޮންޓްރެކްޓް، ޓިއަރ އަދި ޢަދަދުގެ އަގުތައް."
      },
      "salesSubscriptions": {
        "description": "ތަކުރާރު ޕްލޭންތަކާއި އާކުރެވޭ ތާރީޚުތައް."
      },
      "salesMrr": {
        "description": "މަހުގެ އަދި އަހަރުގެ ތަކުރާރު އާމްދަނީ."
      },
      "crmLeads": {
        "description": "ގަނެފާނެ ފަރާތްތަކާއި ތަކުރާރުވެދާނެ ރެކޯޑްތައް."
      },
      "crmOpportunities": {
        "description": "ހިނގަމުންދާ ޑީލްތައް، މަރުޙަލާ އަދި ބަރުދަން ދެވިފައިވާ އަގު."
      },
      "crmCases": {
        "description": "ސަޕޯޓް ކޭސްތަކާއި އޭގެ އެސްއެލްއޭ ގަޑިތައް."
      },
      "crmKb": {
        "description": "އޭޖެންޓުންނާއި ކަސްޓަމަރުން ހޯދާ ލިޔުންތައް."
      },
      "hrEmployees": {
        "description": "މި ވަރކްސްޕޭސްގައި ވަޒީފާ އަދާކުރާ ފަރާތްތަކާއި، އެފަރާތްތަކުގެ ކޮންޓްރެކްޓާއި އިދާރީ ޙަވާލުކުރުން.",
        "keywords": "މުވައްޒަފު މުވައްޒަފުން މީހުން ކޮންޓްރެކްޓް ވަޒީފާ އެޗްއާރު"
      },
      "hrWorkPermits": {
        "description": "ވޯކް ޕަރމިޓާއި ވިސާ، މުއްދަތު ހަމަވާ ތަރުތީބުން.",
        "keywords": "ވޯކް ޕަރމިޓް ވިސާ ބިދޭސީ މުއްދަތު އައުކުރުން"
      },
      "hrLeaveRequests": {
        "description": "އެދިފައިވާ، ނިންމިފައިވާ އަދި ނަގާފައިވާ ޗުއްޓީ، އަދި އޭގެ ބާކީ.",
        "keywords": "ޗުއްޓީ އަހަރީ ޗުއްޓީ ބަލި ޗުއްޓީ އެދުން ބާކީ"
      },
      "hrLeaveCalendar": {
        "description": "ކޮން ފަރާތެއް، ކޮން ދުވަހަކު ނެތްކަން.",
        "keywords": "ޗުއްޓީ ކަލަންޑަރު ނެތުން ދުވަސް ތާވަލު"
      },
      "hrAttendance": {
        "description": "މަސައްކަތްކުރި ގަޑިއިރު، އަދި އެއިން މުސާރައަށް އަގުކުރާ އިތުރުގަޑި.",
        "keywords": "ހާޒިރީ ގަޑިއިރު އިތުރުގަޑި އިމްޕޯޓް ދުވަސް"
      },
      "payrollRuns": {
        "description": "މުސާރައިގެ މުއްދަތެއް ހިސާބުކުރުން، ފާސްކުރުން، ޕޯސްޓްކުރުން އަދި ދޫކުރުން.",
        "keywords": "މުސާރަ ޕޭސްލިޕް އެމްޕީއޭއޯ ޕެންޝަން ބޭންކް ފައިލް ސާފު މުސާރަ"
      },
      "hrRequisitions": {
        "description": "ފާސްކުރެވިފައިވާ ބޭނުންވާ އަދަދާއި، އެއަށް ހުށަހެޅުނު ކެންޑިޑޭޓުން.",
        "keywords": "ވަޒީފާގެ އެދުން ބޭނުންވާ އަދަދު ހުސް މަޤާމް ވަޒީފާދިނުން"
      },
      "hrCandidates": {
        "description": "ވިސްނަމުންދާ ފަރާތްތަކާއި، ކޮންމެ ފަރާތެއް ދެވިފައިވާ މަރުޙަލާ.",
        "keywords": "ކެންޑިޑޭޓް ހުށަހެޅި ފަރާތް އިންޓަވިއު ވަޒީފާދިނުން"
      },
      "hrOffers": {
        "description": "ހުށަހަޅާފައިވަނީ ކޮން އެއްޗެއް، ކާކަށް، އަދި ނިމުނީ ކިހިނެއްކަން.",
        "keywords": "ހުށަހެޅުން ސިޓީ ޤަބޫލުކުރި ދޫކޮށްލި މުސާރަ"
      },
      "hrLeaveTypes": {
        "description": "މި ވަރކްސްޕޭސްއިން ދޫކުރާ ޗުއްޓީގެ ބާވަތްތަކާއި، މަހަކު ޖަމާވާ މިންވަރު.",
        "keywords": "ޗުއްޓީގެ ބާވަތް އުޞޫލު ޖަމާވުން ޙައްޤު ބާކީ"
      },
      "hrOvertimeRules": {
        "description": "އިތުރަށް މަސައްކަތްކުރި ގަޑިއިރު މުސާރައަށް ބަދަލުކުރާ ގޮތް.",
        "keywords": "އިތުރުގަޑި ގަވާއިދު ގުނަ ރޭޓް ބަންދު ދުވަސް"
      },
      "payrollComponents": {
        "description": "ލިބޭ ފައިސާ، އުނިކުރުންތައް އަދި ވަޒީފާދޭ ފަރާތުގެ ޚަރަދު — ފޯމިއުލާތަކެއްގެ ގޮތުގައި.",
        "keywords": "މުސާރައިގެ ބައި އެލަވަންސް އުނިކުރުން އެމްޕީއޭއޯ ފޯމިއުލާ ޤާނޫނީ ރޭޓް"
      },
      "projects": {
        "description": "ފިޔަވަހިތަކާއި މަސައްކަތްތަކަށް ބަހާލެވިފައިވާ ޕްރޮޖެކްޓްތައް، ޓައިމްޝީޓުން ޚަރަދު ބަލައި ކަސްޓަމަރަށް ބިލްކުރެވެއެވެ.",
        "keywords": "ޕްރޮޖެކްޓް މަސައްކަތް ފިޔަވަހި މައިލްސްޓޯން ތާވަލު ފައިދާ"
      },
      "projectsTimesheets": {
        "label": "އަހަރެންގެ ޓައިމްޝީޓްތައް",
        "description": "ތިޔަ ފަރާތުގެ ހަފްތާ ލިޔެ، ފާސްކުރުމަށް ހުށަހަޅާ.",
        "keywords": "ޓައިމްޝީޓް ގަޑިއިރު ހަފްތާ ވަގުތު ހުށަހެޅުން"
      },
      "serviceTickets": {
        "description": "ޚިދުމަތުގެ މަސައްކަތާއި، އޭގެ އެސްއެލްއޭ ގަޑިއާއި، ބޭނުންކުރި ތަކެއްޗާއި ވަގުތު.",
        "keywords": "ޓިކެޓް ޚިދުމަތް އެސްއެލްއޭ މަރާމާތު ޓެކްނީޝަން ކޭސް"
      },
      "serviceWorkOrders": {
        "description": "ފީލްޑް ވަޒީފާ: އިރުޝާދު، ބޭނުންވާ ހުނަރު، ސާމާނު، މަސައްކަތު ގަޑި އަދި ނިންމުމުގެ ޝީޓް.",
        "keywords": "ވޯކް އޯޑަރ ފީލްޑް ޑިސްޕެޗް ޓެކްނީޝަން ވިޒިޓް ނިންމުން"
      },
      "serviceDispatch": {
        "description": "ދުވަހާއި ހަފްތާގެ ބޯޑް: ހުސްކޮށްހުރީ ކާކުކަން، ޝަރުތު ފުރިހަމަވަނީ ކާކުކަން، ފޮނުވިދާނީ ކާކުކަން.",
        "keywords": "ޑިސްޕެޗް ބޯޑް ތާވަލު ޓެކްނީޝަން ހުނަރު ގަޑި"
      },
      "serviceContracts": {
        "description": "ކަވަރޭޖާއި ކޯޓާ، ރޭޓް ކާޑް އަދި ރިނިއުވަލް ކިއު.",
        "keywords": "ކޮންޓްރެކްޓް އެންޓައިޓަލްމަންޓް ކަވަރޭޖް ކޯޓާ ރިނިއުވަލް"
      },
      "serviceRateCards": {
        "description": "މަސައްކަތެއްގެ އަގު، ހުނަރަކުން ހުނަރަކަށް، ވަރޝަނުން ވަރޝަނަކަށް.",
        "keywords": "ރޭޓް ކާޑް އަގު ވަރޝަން ޕަބްލިޝް ސާމާނު"
      },
      "serviceVans": {
        "description": "ވޭނުގައި ހުރި ސާމާނާއި، ހުންނަންޖެހޭ މިންވަރާއި، ފުރިހަމަކުރުމުގެ ހުށަހެޅުން.",
        "keywords": "ވޭން ސްޓޮކް ޕާ ލެވެލް ރީޕްލެނިޝްމަންޓް ފީލްޑް ގުދަން"
      },
      "serviceProblems": {
        "description": "އެނގިފައިވާ މައްސަލަތަކާއި، ވަގުތީ ހައްލުތަކާއި، އުފެއްދި އާޓިކަލްތައް.",
        "keywords": "މައްސަލަ ނޯވްން އެރަރ ވޯކްއަރައުންޑް ނޮލެޖް ބޭސް"
      },
      "serviceCustomerAssets": {
        "description": "ކަސްޓަމަރުގެ މިލްކުވެރިކަމުގައި ހުރެ، މި ޑެސްކުން ޚިދުމަތްދޭ ތަކެތި.",
        "keywords": "ކަސްޓަމަރުގެ ތަކެތި ސީރިއަލް މޮޑެލް މެޝިން"
      },
      "servicePmSchedules": {
        "description": "ދުވަސް ޖެހޭ މަރާމާތާއި، އެއިން އުފައްދާ ޓިކެޓްތައް.",
        "keywords": "ރައްކާތެރިކުރުމުގެ މަރާމާތު ތާވަލު ދުވަސް ޖެހުން ޚިދުމަތް"
      },
      "serviceReports": {
        "description": "ފުރަތަމަ ފަހަރު ރަނގަޅުކުރި ނިސްބަތާއި، އެސްއެލްއޭ ފުރިހަމަކުރުމާއި، ކަސްޓަމަރުންގެ ހިތްހަމަޖެހުން.",
        "keywords": "ޚިދުމަތުގެ ރިޕޯޓް އެސްއެލްއޭ ސީސެޓް ފުރަތަމަ ފަހަރު ރަނގަޅުކުރި"
      },
      "serviceAssignmentRules": {
        "description": "އައު ޓިކެޓެއް ދާނީ ކާކަށްކަމާއި، އެއީ ކީއްވެކަން.",
        "keywords": "ޙަވާލުކުރުން ޤަވާޢިދު ޓެކްނީޝަން ކިއު އަމިއްލައަށް"
      },
      "projectsSettings": {
        "description": "ޓައިމްޝީޓްގެ ޚަރަދު ޕޯސްޓްކުރާ ޑަބްލިއުއައިޕީ އަދި ޕޭރޯލް ކްލިއަރިންގ ހިސާބުތައް.",
        "keywords": "ޕްރޮޖެކްޓް ސެޓިންގ ޑަބްލިއުއައިޕީ ޕޭރޯލް ކްލިއަރިންގ ހިސާބު"
      },
      "serviceSettings": {
        "description": "ތަކެތި ނަގާ ޑިފޯލްޓް ގުދަނާއި، ޚިދުމަތުގެ އިންވޮއިސް ކްރެޑިޓްކުރާ އެކައުންޓް.",
        "keywords": "ޚިދުމަތުގެ ސެޓިންގ ގުދަން އާމްދަނީ އެކައުންޓް ބިލްކުރުން"
      },
      "eamAssets": {
        "description": "ސީރިއަސްކަން، މިލްކުވެރިކަން، ލިންކްތައް، މީޓަރު، ފެއިލިއަރ އަދި ކޮމްޕްލައަންސް ހާލަތު",
        "keywords": "އެސެޓް އިކުއިޕްމަންޓް ރަޖިސްޓަރީ ސީރިއަސްކަން ލައިފްސައިކަލް"
      },
      "eamLocations": {
        "description": "ފެކްޓަރީގެ ހަޔަރކީ: ބްލޮކް، ރޫމް، ޔުނިޓް، އެސެޓާ ހަމައަށް",
        "keywords": "ފަންކްޝަނަލް ލޮކޭޝަން ހަޔަރކީ ޓްރީ ސައިޓް ބްލޮކް"
      },
      "eamMaintenance": {
        "description": "ސްޓްރެޓަޖީތަކާއި، ޕީއެމް ޕްލޭންތަކާއި، ޓާސްކް ލިސްޓާއި، ދެން އަންނަ ޖެނެރޭޝަނުގެ ޕްރިވިއު",
        "keywords": "މަރާމާތު ސްޓްރެޓަޖީ ޕީއެމް ޕްލޭން ޓާސްކް ލިސްޓް ރައްކާތެރި"
      },
      "eamMeters": {
        "description": "ކިޔުމިލޭޓިވް ރީޑިངތަކާއި، ރޯލްއޯވަރ، އަދި ސީއެސްވީ އިމްޕޯޓް",
        "keywords": "މީޓަރު ރީޑިންގ ގޭޖް ކިޔުމިލޭޓިވް ރޯލްއޯވަރ"
      },
      "eamFailures": {
        "description": "ހަލާކުވި އެއްޗަކާއި، ކޮންއިރަކުކަން، ފަހަރު ރަނގަޅުކުރަން ނެގުނު ވަގުތު",
        "keywords": "ފެއިލިއަރ ބްރޭކްޑައުން އެމްޓީބީއެފް އެމްޓީޓީއާރް ރިލައިބިލިޓީ ޑައުންޓައިމް"
      },
      "eamCompliance": {
        "description": "ކޮމްޕްލައަންސް ކަލަންޑަރ: ޖެހޭ ދުވަހާއި، ވޯނިންގ އަދި އޯވަރޑިއު ރިކުއަޔަރމަންޓް",
        "keywords": "ކޮމްޕްލައަންސް އިންސްޕެކްޝަން ސެޓްފިކެޓް ސްޓެޓިއުޓަރީ ކަލަންޑަރ"
      },
      "eamPermits": {
        "description": "މަސައްކަތުގެ ހުއްދަ، ތިން ސޮއިގެ ސްޓްރިޕް، އަދި ކުރަނީ ކާކުކަން",
        "keywords": "ޕަރމިޓް ވޯކް އައިސޮލޭޝަން ހޮޓް ވޯކް ކޮންފައިންޑް ސްޕޭސް"
      },
      "eamDowntime": {
        "description": "ރާވާފައިވާ އަދި ނުރާވާ ވިންޑޯތަކާއި، އެސެޓް ނުލިބޭ ސަބަބު",
        "keywords": "ޑައުންޓައިމް އަންއެވެއިލަބްލް ވިންޑޯ އައުޓޭޖް ބްލޮކިންގ"
      },
      "eamReconciliation": {
        "description": "ކޮންމެ އޮޕަރޭޝަނަލް އެސެޓެއް ފައިނޭންޝަލް ރަޖިސްޓަރީއާ، ދެ ފަރާތުންވެސް",
        "keywords": "ރިކޮންސިލިއޭޝަން އެސެޓް ރަޖިސްޓަރީ ފައިނޭންސް މިސްމެޗް"
      },
      "reportingDailyOperating": {
        "description": "ކޮންމެ އޮޕަރޭޓިން ޔުނިޓަކާއި ބިޒްނަސް ތާރީޚަކަށް އެއް ރިޕޯޓް: އާމްދަނީ، ޚަރަދު، ލޭބަރ، ފައިސާ އަދި އިސްތިސްނާތައް، ލެޖަރއާ ގުޅުވާފައި",
        "keywords": "ދުވަހުގެ އޮޕަރޭޓިން ރިޕޯޓް އާމްދަނީ ޚަރަދު ލޭބަރ ފައިސާ އިސްތިސްނާ ލެޖަރ"
      },
      "reportingBoard": {
        "description": "މަހުގެ ގްރިޑް: ވަގުތަށް ޝާއިޢުކުރި، ލަހުން ޝާއިޢުކުރި، ނުވަތަ ގެއްލިފައިވާ، ކޮންމެ ޔުނިޓަކާއި ތާރީޚަކަށް އެއް ސެލް",
        "keywords": "ބޯޑް މަހުގެ ގްރިޑް ޝާއިޢުކުރި ލަސް ގެއްލިފައި"
      },
      "reportingMetrics": {
        "description": "ކޮންމެ ކޭޕީއައި އެއްގެ މާނައަކީ ކޮބާތޯ، އެއީ ކާކުގެ ހައްޤެއްތޯ، އަދި އެއީ ސެޓިފައި ކުރެވިފައިވާ އެއްޗެއްތޯ",
        "keywords": "މެޓްރިކް ޑިކްޝަނަރީ ޑެފިނިޝަން އޯނަރ ސެޓިފިކޭޝަން ފޯމިއުލާ ސޯސް"
      },
      "reportingExceptionViews": {
        "description": "ރޯލެއްގެ ރައްކާކުރެވިފައިވާ ސުވާލުތައް: އެޓެންޝަން، ރިކޮންސިލިއޭޝަން، އެޕްރޫވަލްސް އަދި ލަފާތަކުގެ ތެރެއިން",
        "keywords": "އެކްސެޕްޝަން ވިއު ރައްކާކުރި އެޓެންޝަން ރިކޮންސިލިއޭޝަން އެޕްރޫވަލްސް"
      },
      "aiBriefings": {
        "description": "ޝެޑިއުލްކުރެވިފައިވާ އޭޖެންޓުތަކަށް ފެނުނު ކަންތައް، ފުރަތަމަ ފައިގަރސް ދެން ނެރޭޓިވް",
        "keywords": "ބްރީފިން އޭޖެންޓް ސީއެފްއޯ ޕްރޮކިއުމަންޓް ސޭލްސް އިންވެންޓްރީ ނެރޭޓިވް"
      },
      "aiAutonomy": {
        "description": "ކޮންމެ އޭއައި ކެޕަބިލިޓީއަކަށް އަމިއްލައަށް ކުރެވޭނީ ކޮންކަމެއްތޯ، އަދި ލެވެލްއެއް ނުލިބެންޏާ ސަބަބަކީ ކޮބާތޯ",
        "keywords": "މިނިވަންކަން ކެޕަބިލިޓީ ޑެލިގޭޓެޑް ސުޕަވައިޒްޑް ޓޮލަރެންސް ތްރެޝްހޯލްޑް"
      },
      "aiRecommendations": {
        "description": "ކޮންމެ އޭއައި ލަފައަކާއި، އޭގެ ނަތީޖާ، ބާވަތުން — ބަލައިގަތުމުގެ ރޭޓާއި ސައްޙަކަން އެއްކޮށް",
        "keywords": "ލަފާގެ ލެޖަރ ނަތީޖާ ސައްޙަކަން ބަލައިގަތް ބޭރުކުރި ފޮނުވި"
      },
      "aiConfigAnomalies": {
        "description": "ބަދަލުތައް ފެންނަނީ ތަކުރާރުކުރުމެއް، ފްލިޕް-ފްލޮޕެއް، ބަލިކަށިކުރެވުނު ކޮންޓްރޯލެއް، ނުވަތަ ބޮޑު ބަދަލެއްގެ ގޮތުގައި",
        "keywords": "ކޮންފިގް ތަފާތު ތަކުރާރު ފްލިޕް ބަލިކަށި ބޮޑު އޮޑިޓް"
      },
      "essProfile": {
        "description": "ތިޔަ ބޭފުޅާގެ އަމިއްލަ ވަޒީފާގެ ރެކޯޑް — ކޮންޓްރެކްޓް، ޑިޕާޓްމަންޓް އަދި މެނޭޖަރު.",
        "keywords": "އަހަރެންގެ ޕްރޮފައިލް ވަޒީފާ ކޮންޓްރެކްޓް ޑިޕާޓްމަންޓް މެނޭޖަރު އަމިއްލަ"
      },
      "essPayslips": {
        "description": "ތިޔަ ބޭފުޅާއަށް ހަދާފައިވާ ހުރިހާ ޕޭސްލިޕަކާއި، ސާފު މުސާރައިގެ ފަހަތުގައިވާ ޢަދަދުތައް.",
        "keywords": "ޕޭސްލިޕް ޕޭސްލިޕްތައް މުސާރަ ސާފު އެމްޕީއޭއޯ ޕެންޝަން އަހަރެންގެ"
      },
      "essLeave": {
        "description": "ތިޔަ ބޭފުޅާގެ ޗުއްޓީގެ ބާކީތަކާއި، ހުށަހަޅާފައިވާ އެދުންތައް.",
        "keywords": "ޗުއްޓީ އަހަރީ ބަލި ބާކީ އެދުން އަހަރެންގެ"
      },
      "essAttendance": {
        "description": "ތިޔަ ބޭފުޅާގެ ނަމުގައި ރެކޯޑްކޮށްފައިވާ ގަޑިއިރާއި، އެއިން އަގުކުރާ އިތުރުގަޑި.",
        "keywords": "ހާޒިރީ ގަޑިއިރު އިތުރުގަޑި ދުވަސް އަހަރެންގެ"
      },
      "essDocuments": {
        "description": "ތިޔަ ބޭފުޅާގެ އަމިއްލަ އެޗްއާރު ފައިލުގައިވާ ލިޔުންތައް، ބެލުމަށާއި ޑައުންލޯޑްކުރުމަށް.",
        "keywords": "ލިޔުންތައް ފައިލް ކޮންޓްރެކްޓް ސެޓްފިކެޓް ޑައުންލޯޑް އެޗްއާރު އަހަރެންގެ"
      },
      "mfgProductionOrders": {
        "description": "އުފައްދަމުންދާ ތަކެއްޗާއި، ކުރިއަށްގޮސްފައިވާ މިންވަރާއި، ހޭދަވެފައިވާ އަގު",
        "keywords": "އުފެއްދުމުގެ އޯޑަރު އުފެއްދުން ވިޕް ދޫކުރުން ފުރިހަމަ މުދާ"
      },
      "mfgBoms": {
        "description": "ފުރިހަމަ ތަކެތި އުފައްދާ ބައިތަކާއި އޭގެ ޢަދަދުތައް",
        "keywords": "ތަކެތީގެ ލިސްޓު ބައިތައް އޮނިގަނޑު ބީ.އޯ.އެމް ވާޝަން"
      },
      "mfgRoutings": {
        "description": "ތަކެތި ފުރިހަމަވުމަށް ފުރިހަމަކުރާ އޮޕަރޭޝަންތަކާއި، ކޮންމެ އެއްޗަކަށް ހޭދަވާ މިނެޓް",
        "keywords": "ރޫޓިންގ އޮޕަރޭޝަންތައް މަސައްކަތު ސެންޓަރު މިނެޓް"
      },
      "mfgWorkCenters": {
        "description": "މަސައްކަތްކުރާ ތަން، އޭގެ ކެޕޭސިޓީ އަދި އެތާ ގަޑިއިރަކަށް ދާ ޚަރަދު",
        "keywords": "މަސައްކަތު ސެންޓަރު ކެޕޭސިޓީ ރޭޓް އޯވަހެޑް މެޝިން"
      },
      "mfgMrp": {
        "description": "ސްޓޮކާއި އަންނަން ހުރި އޯޑަރުތަކާ އަޅާކިޔުމަށްފަހު، އުފައްދަންވީ އަދި ގަންނަންވީ ތަކެތި",
        "keywords": "އެމް.އާރު.ޕީ ހުށަހެޅުންތައް ރޭވުން ސްޓޮކް ގަތުން"
      },
      "mfgCapacity": {
        "description": "ހަފްތާއަކަށް ކޮންމެ މަސައްކަތު ސެންޓަރެއްގެ ބުރަ، އެތަނުން ނަގައިދެވޭ ގަޑިއިރާ އަޅާކިޔައިގެން",
        "keywords": "ކެޕޭސިޓީ ބުރަ މަސައްކަތު ސެންޓަރު ހަފްތާ ގަޑިއިރު"
      },
      "mfgWipClearing": {
        "description": "ބަންދުކުރި ކޮންމެ އޯޑަރެއްގެ ވިޕް ސުމަކަށް ސާފުވެފައިވާކަމުގެ ހެކި",
        "keywords": "ވިޕް މަސައްކަތުގައި ސާފުކުރުން ތަފާތު ބަންދުކުރުން"
      },
      "mfgStandardCosts": {
        "description": "ތަކެތި ރާވާފައިވާ އަގާއި، އެއާ އަޅާކިޔައި ބަލާ ތަފާތުތައް",
        "keywords": "ސްޓޭންޑަޑް އަގު ތަފާތު މަސައްކަތް އޯވަހެޑް ރޭޓް"
      },
      "mfgSettings": {
        "description": "އުފެއްދުމުން ޕޯސްޓްކުރާ ވިޕް، ހިމެނުނު ޚަރަދު އަދި ތަފާތުގެ އެކައުންޓްތައް",
        "keywords": "އުފެއްދުމުގެ ސެޓިންގތައް ވިޕް އެކައުންޓް ތަފާތު ހިމެނުނު"
      },
      "consolGroups": {
        "description": "ކޮން ކުންފުންޏެއް ކޮން ކުންފުންޏަކަށް ކޮންސޮލިޑޭޓްވާކަމާއި، މިލްކުވެރިކަމުގެ އިންސައްތަ",
        "keywords": "ކޮންސޮލިޑޭޝަން ގްރޫޕް މައި ކުންފުނި ދަށު މިލްކުވެރިކަން މައިނޯރިޓީ އިންޓަރެސްޓް"
      },
      "consolRuns": {
        "description": "އެއް މުއްދަތަކަށް ގްރޫޕެއް ފައިސާ ބަދަލުކޮށް، އިލިމިނޭޓްކޮށް، ކޮންސޮލިޑޭޓްކުރޭ",
        "keywords": "ކޮންސޮލިޑޭޝަން ރަން ބަންދު ރޭޓް އެވަރެޖް އިލިމިނޭޝަން މައިނޯރިޓީ އިންޓަރެސްޓް ތަފާތު"
      },
      "attention": {
        "description": "ފާސްކުރުމާއި އިސްތިސްނާތަކާއި އިންޒާރުތައް، އެއް ލިސްޓަކުން."
      },
      "opcalDayBoard": {
        "description": "ވިޔަފާރި ދުވަސް ހުޅުވުމާއި ބަންދުކުރުމާއި އަލުން ހުޅުވުން."
      },
      "orgLocations": {
        "description": "ކުންފުނިތަކާއި ގޮފިތަކާއި ގުދަންތަކުގެ އެޑްރެސް ފޮތް، ޤައުމަށް ފެތޭ ސައްޚަކުރުމާއެކު."
      },
      "orgPositions": {
        "description": "މަޤާމުތަކުގެ ޗާޓު: ބޮލުގެ ޢަދަދާއި ރިޕޯޓިންގ ލައިންތަކާއި މިހާރު ހުރި ފަރާތް."
      },
      "orgJobs": {
        "description": "ކޮންމެ ވަޒީފާއެއްގައި ކުރަންޖެހޭ މަސައްކަތް، ފަރުދާ ވަކިން."
      },
      "orgJobGrades": {
        "description": "ދަރަޖަތަކާއި މުސާރައިގެ ރޭންޖުތައް."
      },
      "orgDesignations": {
        "description": "ޖުރިސްޑިކްޝަނަކަށްފަހު ޕޭރޯލް އަދި ޓެކްސް ރިޕޯޓިންގ ޔުނިޓް ކަނޑައެޅުންތައް."
      },
      "orgFilingCalendar": {
        "description": "ރަޖިސްޓްރޭޝަނާއި މުއްދަތަށް ފެތޭ ފައިލްކުރަންޖެހޭ ސްޓޭޓިއުޓަރީ ރިޓާންތައް."
      },
      "opcalCalendars": {
        "description": "ކޮންމެ އޮޕަރޭޓިންގ ޔުނިޓެއްގެ މަސައްކަތު ދުވަސްތަކާއި ޝިފްޓާއި ބަންދު ދުވަސްތައް."
      },
      "authorityMatrix": {
        "description": "ޢަދަދާއި މަޤާމާއި ޑޮކިއުމަންޓް ބާވަތަށް ބިނާކޮށް ފާސްކުރެވޭނީ ކާކުކަން"
      },
      "authorityDelegations": {
        "description": "ވަގުތީ ގޮތުން އެހެން މީހަކަށް ދޫކުރެވޭ ފާސްކުރުމުގެ ބާރު"
      },
      "authorityAbsences": {
        "description": "ޙާޟިރުނުވުމުގައި ފާސްކުރުންތައް އަލުން ބަދަލުކުރުން"
      },
      "authorityMateriality": {
        "description": "އަލުން ފާސްކުރުމެއް ބޭނުންވާ ބަދަލެއްކަން ކަނޑައަޅާ ޙައްދުތައް"
      },
      "rulesControls": {
        "description": "ކޮންމެ ކޮންޓްރޯލެއް ބްލޮކްކުރޭތޯ ނުވަތަ ހަމައެކަނި އިންޒާރުދޭތޯ"
      },
      "rulesReasonCodes": {
        "description": "ފަހަނައެޅުމަށް ބޭނުންކުރެވޭ ސަބަބުތައް، ކޮންޓްރޯލަކަށްފަހު"
      },
      "rulesOverrides": {
        "description": "ރެކޯޑްކުރެވިފައިވާ ކޮންމެ ފަހަނައެޅުމަކާއި ފާސްކުރި ފަރާތާއި ސަބަބު"
      },
      "rulesQueues": {
        "description": "ހައްލުކުރަން ބާކީ ހުރި އިސްތިސްނާތައް"
      },
      "attentionPolicies": {
        "description": "ކޮންމެ ބާވަތެއްގެ އިންޒާރު ފޮނުވޭ ގޮތް"
      },
      "fxHolds": {
        "description": "ތަފާތު ބޮޑުކަމުން ހިފަހައްޓާފައިވާ ބަދަލު ރޭޓް ބެލުންތައް."
      },
      "taxSimulator": {
        "label": "ޓެކްސް ސިމިއުލޭޓަރު",
        "keywords": "ޓެކްސް ސިމިއުލޭޓް ބެލުން އަގު ޖުރިސްޑިކްޝަން",
        "description": "ލިޔުން ހެދުމުގެ ކުރިން ހުށަހަޅާ ލައިނެއްގެ ޓެކްސް ބަލާލާށެވެ."
      },
      "rvmOnTheBooks": {
        "keywords": "އޮން ދަ ބުކްސް ސްނެޕްޝޮޓް އޮކިއުޕަންސީ އޭޑީއާރް ރެވްޕާރ ކޮޓަރި ވިކުނު",
        "description": "ވަކި ރެއެއްގެ ސްނެޕްޝޮޓުން، އެ ރެއާ ހަމައަށް ވިކިފައިވާ މިންވަރު."
      },
      "rvmPace": {
        "keywords": "ޕޭސް ޕިކްއަޕް މިދިޔަ އަހަރު ލީޑް ޓައިމް ބުކިން ކަރވް ލަފާކުރުން",
        "description": "މިއަދުގެ އޮން ދަ ބުކްސް، މިދިޔަ އަހަރާއި ލަފާކުރުމާ އަޅާބަލައި."
      },
      "rvmCommercial": {
        "keywords": "ކޮމަރޝަލް ރިޕޯޓް ދުވަހު އޮކިއުޕަންސީ އޭޑީއާރް ރެވްޕާރ ހޯދުމުގެ ޚަރަދު ކޮމިޝަން",
        "description": "އެއް ޕްރޮޕަޓީ، އެއް ދުވަސް: ވީ ކަންތައް، ކުރިއަށް އޮތް މިންވަރު، ހޯދުމުގެ ޚަރަދު."
      },
      "rvmForecasts": {
        "keywords": "ލަފާކުރުން ބަޖެޓް ވަރޝަން ޝާއިޢުކުރުން ތަފާތު ތަފްޞީލު ފާސްކުރުން ތަޅުލުން",
        "description": "ލަފާކުރުމުގެ ވަރޝަންތައް، އޭގެ ލައިންތައް، އަދި ޝާއިޢުކުރުމުގެ ކުރިން ތަފްޞީލު ދޭން ޖެހޭ ތަފާތު."
      },
      "rvmAccuracy": {
        "keywords": "ސައްޙަކަން އެމްއޭޕީއީ އެމްއޭއީ ބަޔަސް ހޮރައިޒަން ޝާއިޢުކުރި ލަފާކުރުން",
        "description": "ޝާއިޢުކުރި ކޮންމެ ލަފާކުރުމެއް ޙަޤީޤަތާ ކިހާ ކައިރިވިތޯ، ލީޑް ޓައިމުން."
      },
      "rvmDisplacements": {
        "keywords": "ޑިސްޕްލޭސްމަންޓް ގްރޫޕް ވަޒަންކުރުން ސާފު ފައިދާ ހަރޑްލް ނިންމުން ނަތީޖާ",
        "description": "ގްރޫޕަކުން ބޭރުކުރާ ވިޔަފާރިއަށްވުރެ އޭގެ އަގު ބޮޑުތޯ."
      },
      "rvmHurdles": {
        "keywords": "ހަރޑްލް ރޭޓް ފްލޯ އެންމެ ދަށް އޭޑީއާރް ކޮންޓްރިބިއުޝަން ޓެސްޓަރ",
        "description": "ރޭޓް ޓެސްޓްކުރެވޭ ފްލޯ، އަދި ވަކި ރެއެއްގައި ކާމިޔާބުކުރާ ހަރޑްލް."
      },
      "rvmCompetitorRates": {
        "keywords": "ވާދަވެރިޔާ ރޭޓް ކޮމްޕް ސެޓް ފެނުނު ރޭޓް ޝީޓް އިމްޕޯޓް",
        "description": "މީހަކު ދުށް ރޭޓްތައް، އަތުން ވެއްދި ނުވަތަ ޝީޓަކުން އިމްޕޯޓްކުރި."
      },
      "rvmDimensions": {
        "keywords": "ސެގްމަންޓް ސްޓްރީމް މެޕިން ރޫލް މާކެޓް ސޯސް ޗެނަލް މެޕްނުކުރެވޭ ޑައިމެންޝަން ގިންތިކުރުން",
        "description": "ބުކިންތައް ގިންތިކުރެވޭ ސެގްމަންޓްތަކާއި، އެކަން ކުރާ ރޫލްތަކާއި، ލަފާކުރުން ލިޔެވޭ އާމްދަނީ ސްޓްރީމްތައް."
      },
      "rvmSettings": {
        "keywords": "ރެވެނިއު ސެޓިންގްސް ހޮރައިޒަން މުހިންމުކަން ތަފާތު މިންވަރު ހަރޑްލް ތަންފީޒު މެޕްނުކުރެވޭ ސެގްމަންޓް",
        "description": "މި ޕްރޮޕަޓީގެ ސްނެޕްޝޮޓް ކުރިއަށް ދާ މުއްދަތު، މުހިންމު ކަމަށް ބަލާ މިންވަރު، އަދި ހަރޑްލްއަށްވުރެ ދަށް ރޭޓެއް ދޫކުރެވޭނެތޯ."
      },
      "reportingDashboards": {
        "description": "ރޯލް ޑޭޝްބޯޑްތައް: މި ބިލްޑުން ހިސާބުކުރާ ކޮންމެ ކޭޕީއައި އެއް، ކޮންމެ އެއްޗެއްގެ ފަހަތުގައިވާ ރޯތަކަށް ވަދެވޭ ގޮތަށް.",
        "keywords": "ޑޭޝްބޯޑް ކޭޕީއައި އެގްޒެކެޓިވް ފައިނޭންސް ސޭލްސް އިންވެންޓަރީ ޕްރޮކިއުމަންޓް ޑްރިލް އެކްސްޕޯޓް"
      },
      "reportingSavedFilters": {
        "description": "ގިނައިން ހިންގާ ރިޕޯޓްތަކަށް ނަން ދެވިފައިވާ ޕެރެމިޓަރު ސެޓްތައް، ހިއްސާކުރެވިފައި ނުވަތަ އަމިއްލަ",
        "keywords": "ރައްކާކުރި ފިލްޓަރު ސެޓް ރިޕޯޓް ޕެރެމިޓަރު ހިއްސާ"
      },
      "projectWipRuns": {
        "description": "މުއްދަތު ނިމޭއިރު ހުޅުވިފައިވާ ކޮންމެ ކޮންޓްރެކްޓެއްގެ އަގު، އަދި ކުރި މަސައްކަތާއި ބިލްކުރި މަސައްކަތުގެ ތަފާތު ދެނެގަންނަ ޖާނަލް.",
        "keywords": "ޑަބްލިއުއައިޕީ ކޮންޓްރެކްޓް އެސެޓް ލައިބިލިޓީ ގެއްލުން ޕްރޮވިޜަން މުއްދަތު ޕޯސްޓް ރިވާސް"
      },
      "projectRetentions": {
        "description": "ވަކި ތާރީޚަކާ ހަމައަށް ކޮންމެ ކްލެއިމަކުން ހިފަހައްޓާ ފައިސާ، ދޫކުރުމުގެ ކަލަންޑަރާއި ގެއްލުވާލުންތަކާއެކު.",
        "keywords": "ރިޓެންޝަން ހިފެހެއްޓި ދޫކުރުން ގެއްލުވާލުން ކްލެއިމް ކަލަންޑަރު"
      },
      "projectAdvances": {
        "description": "މަސައްކަތުގެ ކުރިން ނެގި ފައިސާ، އަދި ކޮންމެ ކްލެއިމަކުން އަނބުރާ ހިފާ ބައި.",
        "keywords": "އެޑްވާންސް އަނބުރާ ހިފުން ކުރިއަށް ދެއްކުން ކްލެއިމް ކްރެޑިޓް ނޯޓް"
      },
      "projectVariations": {
        "description": "ކޮންޓްރެކްޓަށް އަންނަ ބަދަލުތައް، ޚަރަދާއި އާމްދަނީއާއި ޝެޑިއުލްއަށް އަންނަ އަސަރާއެކު، އެތެރޭގެ ފާސްކުރުމާއި ކަސްޓަމަރުގެ ޤަބޫލުކުރުމާއެކު.",
        "keywords": "ވެރިއޭޝަން ބަދަލު ސްކޯޕް އަސަރު ޤަބޫލުކުރުން ރައްދުކުރުން ބޭސްލައިން"
      },
      "projectSubcontracts": {
        "description": "މަސައްކަތްކުރަނީ ކާކުތޯ، ކިހާ އަގަކަށްތޯ، އަދި ކިހާ މިންވަރެއް ސެޓިފައި ކުރެވިއްޖެތޯ.",
        "keywords": "ސަބްކޮންޓްރެކްޓް ސަބްކޮންޓްރެކްޓަރު ވެންޑަރު ސެޓިފައި ރިޓެންޝަން ޕަރޗޭސް އޯޑަރު"
      },
      "projectRisks": {
        "description": "ޕްރޮޖެކްޓެއްގައި ގޯސްވެދާނެ ކަންކަން، އެކަން ވުމުގެ ފުރުޞަތު، ޚަރަދު، އަދި ޒިންމާވަނީ ކާކުކަން.",
        "keywords": "ރިސްކް ރަޖިސްޓަރީ މެޓްރިކްސް ފުރުޞަތު އަސަރު އެކްސްޕޯޜަރ ކުޑަކުރުން"
      },
      "projectResources": {
        "description": "ވަގުތު ޕްލޭންކުރެވޭ މީހުން، އެ މީހުންގެ ޕްލޭނިން ޚަރަދު ރޭޓް އަދި ހަފްތާގެ ކެޕޭސިޓީ.",
        "keywords": "ރިސޯސް ކެޕޭސިޓީ ޕްލޭނިން ޚަރަދު ރޭޓް މުވައްޒަފު ގަޑި ހަފްތާ"
      },
      "projectAllocations": {
        "description": "ހަފްތާއަކަށް ރިސޯސް، ލިބެންހުރި ގަޑިއާ އަޅާކިޔާފައި ބުކްކުރި ގަޑި، ސާވަރުގެ އަމިއްލަ ކޮންފްލިކްޓްތަކާއެކު.",
        "keywords": "ހަވާލުކުރުން ބޯޑް ރިސޯސް ހަފްތާ ގަޑި ކެޕޭސިޓީ ކޮންފްލިކްޓް ބޭނުންކުރުން"
      },
      "projectContractAccounts": {
        "description": "ކޮންޓްރެކްޓް ޕޯސްޓިންތަކުން ބޭނުންކުރާ ހަ އެކައުންޓް: ކޮންޓްރެކްޓް އެސެޓާއި ލައިބިލިޓީ، ރިޓެންޝަން، އެޑްވާންސް އަދި ގެއްލުމުގެ ޕްރޮވިޜަން",
        "keywords": "ކޮންޓްރެކްޓް އެކައުންޓް މެޕިން އެސެޓް ލައިބިލިޓީ ރިޓެންޝަން އެޑްވާންސް ގެއްލުން ޕްރޮވިޜަން"
      }
    },
    "apps": {
      "home": {
        "label": "ހޯމް",
        "description": "މިއަދު: އެޕްރޫވަލްތައް، ސަމާލުކަމާއި ހަމަވާ ކަންތައްތައް"
      },
      "enterprise": {
        "label": "އެންޓަރޕްރައިޒް",
        "description": "ގާނޫނީ ފަރާތްތައް، އޮނިގަނޑުތަކާއި ހައިރާކީތައް"
      },
      "finance": {
        "label": "މާލީ",
        "description": "ލެޖަރ، ދައްކަންޖެހޭ، ލިބެންޖެހޭ، ކްލޯޒް"
      },
      "treasury": {
        "label": "ޓްރެޜަރީ",
        "description": "ފައިސާ، ބޭންކުތަކާއި ލިކުއިޑިޓީ"
      },
      "procurement": {
        "label": "ޕްރޮކިއުމަންޓް",
        "description": "ރިކުއިޒިޝަނުން ފެށިގެން ސަޕްލަޔަރަށް ފައިސާ ދެއްކުމާހަމައަށް"
      },
      "sales": {
        "label": "ސޭލްސް",
        "description": "ކޯޓޭޝަން، އޯޑަރ، އަގުތަކާއި ރިޓާރން"
      },
      "crm": {
        "label": "ސީއާރްއެމް",
        "description": "ލީޑް، ފުރުޞަތުތަކާއި ކޭސްތައް"
      },
      "inventory": {
        "label": "ސްޓޮކް",
        "description": "އައިޓަމް، ސްޓޮކް، ގުދަންތަކާއި ގުނުން"
      },
      "manufacturing": {
        "label": "އުފެއްދުން",
        "description": "ބީއޯއެމް، ރައުޓިންގ، އުފެއްދުމާއި ކޮލިޓީ"
      },
      "hcm": {
        "label": "މުވައްޒަފުން",
        "description": "މުވައްޒަފުން، ޗުއްޓީ، ރޮސްޓަރާއި މުސާރަ"
      },
      "pos": {
        "label": "ޕޮއިންޓް އޮފް ސޭލް",
        "description": "އައުޓްލެޓް، ޓަރމިނަލް، ޓިލްތަކާއި މެނޫ"
      },
      "pms": {
        "label": "ޕްރޮޕަޓީ",
        "description": "ރިޒަރވޭޝަން، ކޮޓަރިތަކާއި ފްރަންޓް ޑެސްކް"
      },
      "projects": {
        "label": "ޕްރޮޖެކްޓްތައް",
        "description": "ރޭވުން، ޓައިމްޝީޓް، ބިލިންގއާއި މާޖިން"
      },
      "service": {
        "label": "ޚިދުމަތް",
        "description": "ޓިކެޓް، އެސްއެލްއޭއާއި ފީލްޑް މަސައްކަތް"
      },
      "eam": {
        "label": "އެސެޓް މެނޭޖްމަންޓް",
        "description": "އެސެޓް، މެއިންޓެނެންސްއާއި ވޯކް އޯޑަރ"
      },
      "revenue": {
        "label": "ރެވެނިއު މެނޭޖްމަންޓް",
        "description": "ޑިމާންޑް، ރޭޓްތަކާއި ޔީލްޑް"
      },
      "platform": {
        "label": "ޕްލެޓްފޯމް",
        "description": "ޔޫޒަރުން، ރޯލް، ރިޕޯޓިންގ، އޭއައިއާއި އޮޑިޓް"
      },
      "me": {
        "label": "އަހަރެން",
        "description": "ޕޭސްލިޕް، ޗުއްޓީ، ލިޔެކިޔުމާއި ޕްރޮފައިލް"
      }
    },
    "fsd": {
      "overview": "ޚުލާޞާ",
      "s1_2_1": {
        "short": "އެންޓަރޕްރައިޒް",
        "full": "އެންޓަރޕްރައިޒް ތަޢާރަފާއި ޢާންމު ޑިފޯލްޓްތައް"
      },
      "s1_2_2": {
        "short": "ޑިވިޜަންތައް",
        "full": "ޑިވިޜަންތަކާއި މެނޭޖްމަންޓް ހައިރާކީ"
      },
      "s1_2_3": {
        "short": "ލީގަލް އެންޓިޓީތައް",
        "full": "ލީގަލް އެންޓިޓީތަކާއި ގިނަ އެންޓިޓީގެ މެނޭޖްމަންޓް"
      },
      "s1_2_4": {
        "short": "ބިޒްނަސް ޔުނިޓްތައް",
        "full": "ބިޒްނަސް ޔުނިޓްތަކާއި ބިޒްނަސް ފަންކްޝަންތައް"
      },
      "s1_2_5": {
        "short": "ވަޒީފާ",
        "full": "ވަޒީފާގެ ބިނާ — ޑިޕާޓްމަންޓް، ވަޒީފާ، މަޤާމާއި ގްރޭޑްތައް"
      },
      "s1_2_6": {
        "short": "ރެފަރެންސް ޑޭޓާ",
        "full": "ރެފަރެންސް ޑޭޓާ ސެޓްތައް (SetID)"
      },
      "s1_2_7": {
        "short": "މާލީ ބިނާ",
        "full": "މާލީ ބިނާ — އެކައުންޓްތަކުގެ ޗާޓް، ލެޖަރ، ކަލަންޑަރާއި ފައިސާ"
      },
      "s1_2_8": {
        "short": "ލޯކަލައިޒޭޝަން",
        "full": "ލޮކޭޝަން، ޖުގުރާފީއާއި ލޯކަލައިޒޭޝަން"
      },
      "s1_2_9": {
        "short": "ހައިރާކީތައް",
        "full": "އިދާރީ ހައިރާކީތަކާއި ނާފިޛުވާ ތާރީޚު"
      },
      "s1_1": {
        "short": "ގަވަރނަންސް",
        "full": "ޝަރުޠުތަކުގެ ކެޓަލޮގް"
      },
      "s2_2_1": {
        "short": "ޢާންމު ލެޖަރ",
        "full": "ޢާންމު ލެޖަރ"
      },
      "s2_2_2": {
        "short": "ދޭންޖެހޭ ފައިސާ",
        "full": "ދޭންޖެހޭ ފައިސާ"
      },
      "s2_2_3": {
        "short": "ލިބެންޖެހޭ ފައިސާ",
        "full": "ލިބެންޖެހޭ ފައިސާ"
      },
      "s2_2_4": {
        "short": "ފިކްސްޑް އެސެޓްސް",
        "full": "ފިކްސްޑް އެސެޓްސް"
      },
      "s2_2_5": {
        "short": "ބަޖެޓުކުރުން",
        "full": "ބަޖެޓުކުރުމާއި ކޮމިޓްމަންޓް ކޮންޓްރޯލް"
      },
      "s2_2_6": {
        "short": "ކޮސްޓް އެކައުންޓިންގ",
        "full": "ކޮސްޓް އެކައުންޓިންގ"
      },
      "s2_2_7": {
        "short": "ކޮންސޮލިޑޭޝަން",
        "full": "ކޮންސޮލިޑޭޝަން"
      },
      "s2_2_8": {
        "short": "ޕީރިއަޑް ކްލޯޒް",
        "full": "ޕީރިއަޑް ކްލޯޒްއާއި މާލީ ރިޕޯޓިންގ"
      },
      "s2_1": {
        "short": "ޝަރުޠުތައް",
        "full": "ޝަރުޠުތަކުގެ ކެޓަލޮގް"
      },
      "s3_2_1": {
        "short": "ކޭޝް މެނޭޖްމަންޓް",
        "full": "ކޭޝް މެނޭޖްމަންޓް"
      },
      "s3_2_2": {
        "short": "ވޯލެޓް މެނޭޖްމަންޓް",
        "full": "ވޯލެޓް މެނޭޖްމަންޓް"
      },
      "s3_2_3": {
        "short": "ދަރަނި މެނޭޖްމަންޓް",
        "full": "ދަރަނި މެނޭޖްމަންޓް"
      },
      "s3_2_4": {
        "short": "ޓްރެޜަރީ ފޯކާސްޓިންގ",
        "full": "ޓްރެޜަރީ ފޯކާސްޓިންގ"
      },
      "s4_2_1": {
        "short": "ޕަރޗޭސް ރިކުއިޖިޝަން",
        "full": "ޕަރޗޭސް ރިކުއިޖިޝަން"
      },
      "s4_2_2": {
        "short": "ސަޕްލަޔަރ މެނޭޖްމަންޓް",
        "full": "ސަޕްލަޔަރ މެނޭޖްމަންޓާއި ވަޒަންކުރުން"
      },
      "s4_2_3": {
        "short": "ސޯސިންގ",
        "full": "ސޯސިންގއާއި ކޯޓޭޝަނަށް އެދުން"
      },
      "s4_2_5": {
        "short": "ޕަރޗޭސް އޯޑަރާއި އިޞްލާޙު",
        "full": "ޕަރޗޭސް އޯޑަރާއި އިޞްލާޙު"
      },
      "s4_2_6": {
        "short": "މުދާ ލިބުމާއި ޗެކްކުރުން",
        "full": "މުދާ ލިބުމާއި ޗެކްކުރުން"
      },
      "s4_2_7": {
        "short": "ތިން ގޮތަކަށް މެޗްކުރުން",
        "full": "ތިން ގޮތަކަށް މެޗްކުރުމާއި ތަފާތު ހައްލުކުރުން"
      },
      "s4_2_8": {
        "short": "ކޮންޓްރެކްޓާއި ބްލޭންކެޓް އޯޑަރ",
        "full": "ކޮންޓްރެކްޓް، ބްލޭންކެޓް އޯޑަރާއި ޕްރޮކިއުމަންޓް އެނަލިޓިކްސް"
      },
      "s5_2_1": {
        "short": "ކޯޓޭޝަން މެނޭޖްމަންޓް",
        "full": "ކޯޓޭޝަން މެނޭޖްމަންޓް"
      },
      "s5_2_2": {
        "short": "ސޭލްސް އޯޑަރ މެނޭޖްމަންޓް",
        "full": "ސޭލްސް އޯޑަރ މެނޭޖްމަންޓް"
      },
      "s5_2_3": {
        "short": "ޕްރައިސިންގ އިންޖިން",
        "full": "ޕްރައިސިންގ އިންޖިން"
      },
      "s5_2_4": {
        "short": "ޑިސްކައުންޓް އިންޖިން",
        "full": "ޑިސްކައުންޓް އިންޖިނާއި މާޖިން ކޮންޓްރޯލް"
      },
      "s5_2_5": {
        "short": "ފުލްފިލްމަންޓް އޯކެސްޓްރޭޝަން",
        "full": "ފުލްފިލްމަންޓް އޯކެސްޓްރޭޝަން"
      },
      "s5_2_6": {
        "short": "އިންވޮއިސްކުރުމާއި ރިޓަރން",
        "full": "އިންވޮއިސްކުރުން، ރިޓަރންއާއި ކްރެޑިޓް ނޯޓް"
      },
      "s5_2_7": {
        "short": "އާމްދަނީ ހިސާބަށް ނެގުން",
        "full": "އާމްދަނީ ހިސާބަށް ނެގުން"
      },
      "s5_2_8": {
        "short": "ސަބްސްކްރިޕްޝަން",
        "full": "ސަބްސްކްރިޕްޝަނާއި ތަކުރާރު ބިލިންގ"
      },
      "s5_1": {
        "short": "ޝަރުޠުތައް",
        "full": "ޝަރުޠުތަކުގެ ކެޓަލޮގް"
      },
      "s6_2_1": {
        "short": "ލީޑް މެނޭޖްމަންޓް",
        "full": "ލީޑް މެނޭޖްމަންޓް"
      },
      "s6_2_2": {
        "short": "ފުރުޞަތު މެނޭޖްމަންޓް",
        "full": "ފުރުޞަތު މެނޭޖްމަންޓް"
      },
      "s6_2_3": {
        "short": "އެކައުންޓް މެނޭޖްމަންޓް",
        "full": "އެކައުންޓް މެނޭޖްމަންޓް"
      },
      "s6_2_4": {
        "short": "ކޮންޓެކްޓް މެނޭޖްމަންޓާއި ރުހުން",
        "full": "ކޮންޓެކްޓް މެނޭޖްމަންޓާއި ރުހުން"
      },
      "s6_2_5": {
        "short": "ކެމްޕެއިން މެނޭޖްމަންޓް",
        "full": "ކެމްޕެއިން މެނޭޖްމަންޓް"
      },
      "s7_2_1": {
        "short": "ގުދަނާއި ބިން ބިނާ",
        "full": "ގުދަނާއި ބިން ބިނާ"
      },
      "s7_2_2": {
        "short": "ލޮޓް، ބެޗާއި ސީރިއަލް ޓްރެކިންގ",
        "full": "ލޮޓް، ބެޗާއި ސީރިއަލް ޓްރެކިންގ"
      },
      "s7_2_3": {
        "short": "ސްޓޮކް ހަރަކާތްތަކާއި ބަދަލުކުރުން",
        "full": "ސްޓޮކް ހަރަކާތްތަކާއި ބަދަލުކުރުން"
      },
      "s7_2_4": {
        "short": "ރިޒަރވޭޝަނާއި ހަވާލުކުރުން",
        "full": "ރިޒަރވޭޝަން، ހަވާލުކުރުމާއި ވަޢުދުވެވޭ މިންވަރު"
      },
      "s7_2_5": {
        "short": "އެޑްޖަސްޓްމަންޓާއި ރައިޓްއޮފް",
        "full": "އެޑްޖަސްޓްމަންޓް، ރައިޓްއޮފްއާއި ސްޓޮކް ގުނުން"
      },
      "s7_2_6": {
        "short": "ވެލުއޭޝަނާއި ކޮސްޓިންގ",
        "full": "ވެލުއޭޝަން، ކޮސްޓިންގއާއި ރިކޮންސިލިއޭޝަން"
      },
      "s7_2_7": {
        "short": "ރިޕްލެނިޝްމަންޓް ރޭވުން",
        "full": "ރިޕްލެނިޝްމަންޓް ރޭވުމާއި ސްޓޮކް އޮޕްޓިމައިޒޭޝަން"
      },
      "s7_2_8": {
        "short": "ލޭންޑެޑް ކޮސްޓް މެނޭޖްމަންޓް",
        "full": "ލޭންޑެޑް ކޮސްޓް މެނޭޖްމަންޓް"
      },
      "s7_1": {
        "short": "ޝަރުޠުތައް",
        "full": "ޝަރުޠުތަކުގެ ކެޓަލޮގް"
      },
      "s8_2_1": {
        "short": "ބިލް އޮފް މެޓީރިއަލް",
        "full": "ބިލް އޮފް މެޓީރިއަލްއާއި އިންޖިނިއަރިންގ ބަދަލުތަކުގެ ކޮންޓްރޯލް"
      },
      "s8_2_2": {
        "short": "ރައުޓިންގއާއި ވޯކް ސެންޓަރ",
        "full": "ރައުޓިންގ، ވޯކް ސެންޓަރާއި ކެޕޭސިޓީ މޮޑެލް"
      },
      "s8_2_3": {
        "short": "މެޓީރިއަލް ރިކުއަރމަންޓްސް ޕްލޭނިންގ",
        "full": "މެޓީރިއަލް ރިކުއަރމަންޓްސް ޕްލޭނިންގ"
      },
      "s8_2_4": {
        "short": "ކެޕޭސިޓީ ޕްލޭނިންގ",
        "full": "ކެޕޭސިޓީ ޕްލޭނިންގއާއި އުފެއްދުމުގެ ޝެޑިއުލިންގ"
      },
      "s8_2_5": {
        "short": "ޕްރޮޑަކްޝަން އޯޑަރ",
        "full": "ޕްރޮޑަކްޝަން އޯޑަރާއި މެޓީރިއަލް ދޫކުރުން"
      },
      "s8_2_7": {
        "short": "ކޮލިޓީ މެނޭޖްމަންޓް",
        "full": "ކޮލިޓީ މެނޭޖްމަންޓާއި ނޮން-ކޮންފޯމަންސް"
      },
      "s8_2_8": {
        "short": "ޕްރޮޑަކްޝަން ކޮސްޓިންގ",
        "full": "ޕްރޮޑަކްޝަން ކޮސްޓިންގއާއި އޯޑަރ ސެޓްލްމަންޓް"
      },
      "s9_2_1": {
        "short": "މުވައްޒަފުގެ ދައުރު",
        "full": "މުވައްޒަފުގެ ދައުރާއި މަޤާމު މެނޭޖްމަންޓް"
      },
      "s9_2_2": {
        "short": "ރިކްރޫޓްމަންޓް",
        "full": "ރިކްރޫޓްމަންޓާއި އެޕްލިކަންޓް ޓްރެކިންގ"
      },
      "s9_2_3": {
        "short": "ޙާޟިރީ، ވަގުތާއި ރޮސްޓަރ",
        "full": "ޙާޟިރީ، ވަގުތާއި ރޮސްޓަރ"
      },
      "s9_2_4": {
        "short": "ޗުއްޓީއާއި ހާޒިރުނުވުމުގެ މެނޭޖްމަންޓް",
        "full": "ޗުއްޓީއާއި ހާޒިރުނުވުމުގެ މެނޭޖްމަންޓް"
      },
      "s9_2_5": {
        "short": "މުސާރަ",
        "full": "މުސާރަ"
      },
      "s9_2_7": {
        "short": "ތަމްރީނު",
        "full": "ތަމްރީނާއި ކޮމްޕްލަޔަންސް ޓްރޭނިންގ"
      },
      "s9_1": {
        "short": "ޝަރުޠުތައް",
        "full": "ޝަރުޠުތަކުގެ ކެޓަލޮގް"
      },
      "s10_2_1": {
        "short": "ޕީއޯއެސް ކޯއާއި ޗެކްއައުޓް",
        "full": "ޕީއޯއެސް ކޯއާއި ޗެކްއައުޓް"
      },
      "s10_2_2": {
        "short": "އޮފްލައިން އޮޕަރޭޝަން",
        "full": "އޮފްލައިން އޮޕަރޭޝަނާއި ސިންކްރޮނައިޒޭޝަން"
      },
      "s10_2_4": {
        "short": "ރެސްޓޯރަންޓް އޮޕަރޭޝަންސް",
        "full": "ރެސްޓޯރަންޓް އޮޕަރޭޝަންސްއާއި ބަދިގޭ ޑިސްޕްލޭ"
      },
      "s10_2_5": {
        "short": "ޕްރައިސިންގއާއި ޕްރޮމޯޝަން",
        "full": "ޕްރައިސިންގ، ޕްރޮމޯޝަނާއި މެނޫ މެނޭޖްމަންޓް"
      },
      "s10_2_7": {
        "short": "ކޭޝް މެނޭޖްމަންޓް",
        "full": "ކޭޝް މެނޭޖްމަންޓާއި ޝިފްޓް ކްލޯޒް"
      },
      "s10_2_8": {
        "short": "ވިޔަފާރި ދުވަސް ބަންދުކުރުން",
        "full": "ވިޔަފާރި ދުވަސް ބަންދުކުރުމާއި އާމްދަނީ ޕޯސްޓްކުރުން"
      },
      "s10_2_9": {
        "short": "ރީޓެއިލް ވިއްކުން",
        "full": "ރީޓެއިލް ވިއްކުން"
      },
      "s11_2_1": {
        "short": "ރިޒަރވޭޝަންތައް",
        "full": "ރިޒަރވޭޝަންތައް"
      },
      "s11_2_2": {
        "short": "ގްރޫޕް، ބްލޮކާއި އެލޮޓްމަންޓް",
        "full": "ގްރޫޕް، ބްލޮކާއި އެލޮޓްމަންޓް"
      },
      "s11_2_3": {
        "short": "ފްރަންޓް ޑެސްކް އޮޕަރޭޝަންސް",
        "full": "ފްރަންޓް ޑެސްކް އޮޕަރޭޝަންސް"
      },
      "s11_2_4": {
        "short": "ހައުސްކީޕިންގއާއި ކޮޓަރީގެ ހާލަތު",
        "full": "ހައުސްކީޕިންގއާއި ކޮޓަރީގެ ހާލަތު"
      },
      "s11_2_5": {
        "short": "ފޯލިއޯއާއި ބިލިންގ",
        "full": "ފޯލިއޯއާއި ބިލިންގ"
      },
      "s11_2_6": {
        "short": "ރޭޓާއި އިންވެންޓަރީ މެނޭޖްމަންޓް",
        "full": "ރޭޓާއި އިންވެންޓަރީ މެނޭޖްމަންޓް"
      },
      "s11_2_7": {
        "short": "ޑިސްޓްރިބިއުޝަން",
        "full": "ޑިސްޓްރިބިއުޝަނާއި ޗެނަލް މެނޭޖްމަންޓް"
      },
      "s11_2_8": {
        "short": "ނައިޓް އޮޑިޓާއި ރިކޮންސިލިއޭޝަން",
        "full": "ނައިޓް އޮޑިޓާއި ރިކޮންސިލިއޭޝަން"
      },
      "s11_2_9": {
        "short": "އިތުރު އާމްދަނީ",
        "full": "އިތުރު އާމްދަނީއާއި އެކްޓިވިޓީ މެނޭޖްމަންޓް"
      },
      "s11_2_10": {
        "short": "ބޯޑް ބޭސިސް",
        "full": "ބޯޑް ބޭސިސްއާއި ކެއުމުގެ ޕްލޭން މެނޭޖްމަންޓް"
      },
      "s11_2_11": {
        "short": "ގެސްޓް ޚިދުމަތާއި އެދުންތައް",
        "full": "ގެސްޓް ޚިދުމަތް، އެދުންތަކާއި ޚިދުމަތް ރަނގަޅުކުރުން"
      },
      "s11_2_12": {
        "short": "އަރައިވަލް ލޮޖިސްޓިކްސް",
        "full": "އަރައިވަލް ލޮޖިސްޓިކްސްއާއި ޓްރާންސްފަރ"
      },
      "s12_2_1": {
        "short": "ޕްރޮޖެކްޓް ކަނޑައެޅުން",
        "full": "ޕްރޮޖެކްޓް ކަނޑައެޅުމާއި ރޭވުން"
      },
      "s12_2_2": {
        "short": "ބަދަލުތަކުގެ ކޮންޓްރޯލާއި ވޭރިއޭޝަން",
        "full": "ބަދަލުތަކުގެ ކޮންޓްރޯލާއި ވޭރިއޭޝަން"
      },
      "s12_2_3": {
        "short": "ރިސޯސް ރޭވުން",
        "full": "ރިސޯސް ރޭވުމާއި ހަވާލުކުރުން"
      },
      "s12_2_4": {
        "short": "ވަގުތާއި ޚަރަދު ރެކޯޑްކުރުން",
        "full": "ވަގުތާއި ޚަރަދު ރެކޯޑްކުރުން"
      },
      "s12_2_6": {
        "short": "އާމްދަނީ ހިސާބަށް ނެގުން",
        "full": "އާމްދަނީ ހިސާބަށް ނެގުމާއި ވޯކް އިން ޕްރޮގްރެސް"
      },
      "s12_2_7": {
        "short": "ޕްރޮޖެކްޓް ބިލިންގ",
        "full": "ޕްރޮޖެކްޓް ބިލިންގ"
      },
      "s12_1": {
        "short": "ޝަރުޠުތައް",
        "full": "ޝަރުޠުތަކުގެ ކެޓަލޮގް"
      },
      "s13_2_1": {
        "short": "ޓިކެޓް ލިބުމާއި ޓްރިއާޖް",
        "full": "ޓިކެޓް ލިބުމާއި ޓްރިއާޖް"
      },
      "s13_2_2": {
        "short": "އެންޓައިޓަލްމަންޓް",
        "full": "އެންޓައިޓަލްމަންޓާއި ސަރވިސް ކޮންޓްރެކްޓް"
      },
      "s13_2_3": {
        "short": "ސަރވިސް ލެވެލް މެނޭޖްމަންޓް",
        "full": "ސަރވިސް ލެވެލް މެނޭޖްމަންޓް"
      },
      "s13_2_4": {
        "short": "ނޮލެޖް މެނޭޖްމަންޓް",
        "full": "ނޮލެޖް މެނޭޖްމަންޓް"
      },
      "s13_2_5": {
        "short": "ފީލްޑް ސަރވިސް ވޯކް އޯޑަރ",
        "full": "ފީލްޑް ސަރވިސް ވޯކް އޯޑަރ"
      },
      "s13_2_6": {
        "short": "ޝެޑިއުލިންގއާއި ޑިސްޕެޗް",
        "full": "ޝެޑިއުލިންގއާއި ޑިސްޕެޗް"
      },
      "s13_2_7": {
        "short": "ސަރވިސް ޕާޓްސްއާއި ވޭން ސްޓޮކް",
        "full": "ސަރވިސް ޕާޓްސްއާއި ވޭން ސްޓޮކް"
      },
      "s13_2_8": {
        "short": "ސަރވިސް ބިލިންގ",
        "full": "ސަރވިސް ބިލިންގއާއި ޚަރަދު ހޯދުން"
      },
      "s13_1": {
        "short": "ޝަރުޠުތައް",
        "full": "ޝަރުޠުތަކުގެ ކެޓަލޮގް"
      },
      "s14_2_1": {
        "short": "އެސެޓް ރަޖިސްޓަރާއި ހައިރާކީ",
        "full": "އެސެޓް ރަޖިސްޓަރާއި ހައިރާކީ"
      },
      "s14_2_3": {
        "short": "މެއިންޓެނެންސް ސްޓްރެޓެޖީ",
        "full": "މެއިންޓެނެންސް ސްޓްރެޓެޖީއާއި ޕްރިވެންޓިވް ޕްލޭން"
      },
      "s14_2_4": {
        "short": "ކޮންޑިޝަން މޮނިޓަރިންގ",
        "full": "ކޮންޑިޝަން މޮނިޓަރިންގއާއި ޕްރެޑިކްޓިވް މެއިންޓެނެންސް"
      },
      "s14_2_5": {
        "short": "މެއިންޓެނެންސް ވޯކް އޯޑަރ",
        "full": "މެއިންޓެނެންސް ވޯކް އޯޑަރ"
      },
      "s14_2_6": {
        "short": "ފެއިލިއަރ އެނަލިސިސް",
        "full": "ފެއިލިއަރ އެނަލިސިސްއާއި ރިލަޔަބިލިޓީ"
      },
      "s14_2_8": {
        "short": "އެސެޓް ޕަރފޯމަންސް",
        "full": "އެސެޓް ޕަރފޯމަންސް، ކޮމްޕްލަޔަންސްއާއި ބަދަލުކުރުމުގެ ނިންމުން"
      },
      "s15_2_1": {
        "short": "ބަޖެޓް، ފޯކާސްޓާއި ޕޭސް",
        "full": "ބަޖެޓް، ފޯކާސްޓާއި ޕޭސް"
      },
      "s15_2_2": {
        "short": "ގްރޫޕާއި ކޮންޓްރެކްޓް ވަޒަންކުރުން",
        "full": "ގްރޫޕާއި ކޮންޓްރެކްޓް ވަޒަންކުރުން"
      },
      "s15_1": {
        "short": "ޝަރުޠުތައް",
        "full": "ޝަރުޠުތަކުގެ ކެޓަލޮގް"
      },
      "sD_2": {
        "short": "ބާރާއި ފާސްކުރުން",
        "full": "ބާރު، ފާސްކުރުމާއި ހަވާލުކުރުން"
      },
      "sD_3": {
        "short": "އޮޑިޓާއި ސަބަބުގެ ކޯޑު",
        "full": "އޮޑިޓް، ސަބަބުގެ ކޯޑު، ރިވަރސްކުރުމާއި ރަނގަޅުކުރުން"
      },
      "sD_4": {
        "short": "ނޯޓިފިކޭޝަނާއި ޓާސްކް",
        "full": "ނޯޓިފިކޭޝަން، ޓާސްކާއި ސަމާލުކަމުގެ މެނޭޖްމަންޓް"
      },
      "sD_5": {
        "short": "ޔޫޒަރ އެކްސްޕީރިއަންސްގެ މިންގަނޑު",
        "full": "ޔޫޒަރ އެކްސްޕީރިއަންސްގެ މިންގަނޑު"
      },
      "sD_6": {
        "short": "މާސްޓަރ ޑޭޓާ ބާރު",
        "full": "މާސްޓަރ ޑޭޓާ ބާރާއި ގަވަރނަންސް"
      },
      "sD_8": {
        "short": "ރިޕޯޓިންގ",
        "full": "ރިޕޯޓިންގ، މެޓްރިކް ގަވަރނަންސްއާއި އެންޓަރޕްރައިޒް ވިއު"
      },
      "sD_9_1": {
        "short": "އިސްތިސްނާ",
        "full": "އިސްތިސްނާއާއި ދަށްވެފައިވާ އޮޕަރޭޝަން މެނޭޖްމަންޓް"
      },
      "sD_9_2": {
        "short": "ބާރާއި ހަވާލުކުރުން",
        "full": "ބާރާއި ހަވާލުކުރުމުގެ މެނޭޖްމަންޓް"
      },
      "s17": {
        "short": "އާޓިފިޝަލް އިންޓެލިޖެންސް",
        "full": "އާޓިފިޝަލް އިންޓެލިޖެންސްގެ ފަންކްޝަނަލް ޝަރުޠުތައް"
      }
    }
  },
  "shell": {
    "sidebar": {
      "favourites": "ފެވަރިޓްސް",
      "recent": "އެންމެފަހުގެ",
      "collapse": "ކުޑަކުރޭ",
      "collapseNav": "ނެވިގޭޝަން ކުޑަކުރޭ",
      "expandNav": "ނެވިގޭޝަން ބޮޑުކުރޭ",
      "addFavourite": "{name} ފެވަރިޓްސް އަށް އިތުރުކުރޭ",
      "removeFavourite": "{name} ފެވަރިޓްސް އިން ނަގާ",
      "pinned": "ޕިން ކޮށްފައި",
      "fsdPart": "FSD ބައި {n}",
      "filterPlaceholder": "ސްކްރީން، FSD ނަންބަރު ނުވަތަ ކޯޑު…",
      "filterLabel": "{app} މެނޫ ފިލްޓަރ ކުރޭ",
      "noMatches": "“{query}” އާ ގުޅޭ ސްކްރީނެއް ނެތް",
      "noMatchesHint": "{app} ގައި އެ ނަމުގައި އެއްވެސް އެއްޗެއް ނެތް. އެހެން ލަފްޒެއް ބޭނުންކޮށްލާ، ނުވަތަ ހުރިހާ އެޕަކާއި ރެކޯޑެއް ހޯދާ.",
      "searchEverything": "ހުރިހާ އެއްޗެއް ހޯދާ",
      "flaggedTooltip": "{name} (FSD ގައި ނެތް)",
      "expandAll": "ހުރިހާ ބައެއް ބޮޑުކުރޭ",
      "collapseAll": "ހުރިހާ ބައެއް ކުޑަކުރޭ",
      "sectionCount": "ސްކްރީން {n} | ސްކްރީން {n}"
    },
    "topbar": {
      "searchLabel": "ހުރިހާ އެއްޗެއް ހޯދާ",
      "searchPlaceholder": "ލިޔުން، މީހުން، ރިޕޯޓް އަދި ޢަމަލުތައް ހޯދާ",
      "shortcuts": "ކީބޯޑް ޝޯޓްކަޓްތައް",
      "insights": "އިންސައިޓްސް ޕެނަލް",
      "toggleInsights": "އިންސައިޓްސް ޕެނަލް ދައްކާ/ފޮރުވާ",
      "appMenu": "{app} މެނޫ",
      "goHome": "ހޯމް އަށް ދާ",
      "openAppHome": "{app} ހުޅުވާ"
    },
    "quickCreate": {
      "trigger": "އުފައްދާ",
      "menuLabel": "އުފައްދާ",
      "unavailable": "އުފެއްދުން (ނުލިބޭ)"
    },
    "theme": {
      "menuLabel": "ފެންނަގޮތް",
      "trigger": "ފެންނަގޮތް ބަދަލުކުރޭ",
      "current": "މިހާރު",
      "tooltip": "ފެންނަގޮތް: {choice}",
      "light": "އަލި",
      "dark": "އަނދިރި",
      "system": "ސިސްޓަމާ އެއްގޮތަށް"
    },
    "locale": {
      "menuLabel": "ބަސް",
      "trigger": "ބަސް ބަދަލުކުރޭ",
      "current": "މިހާރު"
    },
    "userMenu": {
      "menuLabel": "އެކައުންޓް",
      "trigger": "{name} ގެ އެކައުންޓް މެނޫ",
      "signedIn": "ސައިން އިން ވެފައި",
      "account": "އެކައުންޓް",
      "noName": "—"
    },
    "banner": {
      "suspended": "މި ވޯކްސްޕޭސް ސަސްޕެންޑްކޮށްފައިވާތީ، ބަދަލު ގެނައުން ހުއްޓުވާފައިވެއެވެ. މިހާރު ހުރި ރެކޯޑްތައް ކިޔޭނެއެވެ. އަލުން ހުޅުވުމަށް އިދާރީ ފަރާތާ ގުޅުއްވާ.",
      "sessionEnded": "ތިޔަ ފަރާތުގެ ސެޝަން ނިމިއްޖެއެވެ. ކުރިއަށް ދިއުމަށް އަލުން ސައިން އިން ވޭ."
    },
    "readOnly": {
      "reason": "މި ވޯކްސްޕޭސް ސަސްޕެންޑްކޮށްފައިވާތީ، ބަދަލު ގެނައުން ހުއްޓުވާފައިވެއެވެ. އިދާރީ ފަރާތާ ގުޅުއްވާ."
    },
    "rail": {
      "landmark": "އިންސައިޓްސް",
      "title": "އިންސައިޓްސް",
      "close": "އިންސައިޓްސް ބަންދުކުރޭ",
      "sections": "އިންސައިޓް ބައިތައް",
      "tabs": {
        "activity": "ޙަރަކާތް",
        "audit": "އޮޑިޓް ރެކޯޑް",
        "session": "ސެޝަން"
      },
      "linked": "ގުޅިފައި",
      "emptyTitle": "އެއްވެސް އެއްޗެއް ހޮވާފައެއް ނުވޭ",
      "emptyDescription": "ކާކު، ކޮންއިރަކު، ކޮން ބަދަލެއް ގެނައިކަން ބެލުމަށް ރެކޯޑެއް ހުޅުވާ.",
      "changesSince": {
        "label": "ތިޔަ ފަހުން ޢަމަލުކުރި ފަހުން ގެނައި ބަދަލުތައް",
        "heading": "ތިޔަ ފަހުން ޢަމަލުކުރި {since} ން ފެށިގެން {count} ބަދަލު ގެނެވިއްޖެ",
        "upToDate": "ތިޔަ ފަހުން ޢަމަލުކުރި ފަހުން މީގައި އެއްވެސް ބަދަލެއް ނާދޭ.",
        "neverActed": "ތިޔަ ފަރާތުން މި ރެކޯޑުގައި އަދި ޢަމަލެއް ނުކުރައްވާ.",
        "unknownBaseline": "ތިޔަ ފަރާތުން މީގައި އެންމެ ފަހުން ޢަމަލުކުރި ވަގުތު، މިތާ ލޯޑްކުރެވިފައިވާ ތާރީޚަށްވުރެ ދުވަސްވެފައި — ތިރީގައިވާ ފުރިހަމަ އޮޑިޓް ޓްރެއިލް ހުޅުވާ ބަދަލުތައް ބެލުމަށް.",
        "more": "އަދި {count} ގިނަ",
        "emptyValue": "ހުހެއް",
        "changedTo": "ބަދަލުވެފައި"
      },
      "signedInAs": "ސައިން އިން ވެފައިވަނީ",
      "facts": {
        "name": "ނަން",
        "email": "އީމެއިލް",
        "workspace": "ވޯކްސްޕޭސް",
        "roles": "ރޯލްތައް",
        "permissions": "ހުއްދަތައް",
        "tokenExpires": "ޓޯކަން މުއްދަތު ހަމަވާ ވަގުތު",
        "permissionsGranted": "{count} ދީފައި"
      }
    },
    "timeline": {
      "emptyTitle": "ރެކޯޑްކޮށްފައިވާ ޙަރަކާތެއް ނެތް",
      "emptyDescription": "މި ރެކޯޑަށް ބަދަލެއް އައުމާއެކު ޙަރަކާތް މިތާ ފެންނާނެއެވެ."
    },
    "attachments": {
      "title": "އެޓޭޗްމަންޓްތައް",
      "description": "މި ރެކޯޑާ ގުޅޭ ރަސީދުތަކާއި ސަޕޯޓިންގ ޑޮކިއުމަންޓްތައް. PDF، ފޮޓޯ، Excel، Word ނުވަތަ CSV، ކޮންމެ ފައިލެއް {max} MB އާ ހަމައަށް.",
      "upload": "އަޕްލޯޑް",
      "uploading": "އެޓޭޗްމަންޓްތައް އަޕްލޯޑް ކުރަނީ",
      "loadFailed": "އެޓޭޗްމަންޓްތައް ލޯޑް ނުކުރެވުނު.",
      "dropHint": "ފައިލްތައް މިތަނަށް ދޫކޮށްލާ، ނުވަތަ އަޕްލޯޑް އިޚްތިޔާރު ކުރޭ.",
      "accepted": "ބަލައިގަންނަނީ: PDF، PNG، JPG، XLSX، DOCX، CSV — {max} MB އާ ހަމައަށް. ފައިލްގެ ނަން އެކަނި ނޫން، ތެރޭގައިވާ އެއްޗެހިވެސް ޗެކް ކުރެވޭނެ.",
      "progress": "{total} ގެ ތެރެއިން {done} އަޕްލޯޑް ކުރަނީ: {name}",
      "rejected": "{name} އެޓޭޗް ނުކުރެވުނު",
      "dismiss": "{name} ގެ މެސެޖް ނައްތާލާ",
      "conflict": "ތިބާ ޑިލީޓް ކުރުމުގެ ކުރިން މި އެޓޭޗްމަންޓްތަކަށް އެހެން މީހަކު ބަދަލު ގެނެސްފި. ލިސްޓް އަލުން ލޯޑް ކުރެވިއްޖެ — ބަލާފައި އަލުން މަސައްކަތް ކުރޭ.",
      "emptyTitle": "އަދި އެއްވެސް އެޓޭޗްމަންޓެއް ނެތް",
      "emptyDescription": "ރަސީދު ނުވަތަ ސަޕޯޓިންގ ޑޮކިއުމަންޓް މިތަނަށް އެޓޭޗް ކުރޭ — ފައިލެއް މި ޕެނަލަށް ދޫކޮށްލާ ނުވަތަ އަޕްލޯޑް އިޚްތިޔާރު ކުރޭ. މި ރެކޯޑް ރިވިއު ކުރާ މީހާއަށް އެ މިތާ ފެންނާނެ.",
      "emptyReadOnly": "މި ރެކޯޑަށް އެއްވެސް އެއްޗެއް އެޓޭޗްކޮށްފައެއް ނުވެއެވެ.",
      "downloadName": "{name} ޑައުންލޯޑް ކުރޭ",
      "deleteName": "{name} ޑިލީޓް ކުރޭ",
      "deleteTitle": "އެޓޭޗްމަންޓް ޑިލީޓް ކުރަންތޯ؟",
      "deleteMessage": "{name} މި ރެކޯޑުން ނައްތާލެވޭނެ. ޑިލީޓް ކުރި ކަން އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑް ކުރެވޭނެ.",
      "uploaded": "ފައިލް {count} އެޓޭޗް ކުރެވިއްޖެ",
      "deleted": "އެޓޭޗްމަންޓް ޑިލީޓް ކުރެވިއްޖެ",
      "uploadFailed": "ފައިލް އެޓޭޗް ނުކުރެވުނު.",
      "downloadFailed": "ޑައުންލޯޑް ލިންކް ހުޅުވިއެއް ނުދިޔައެވެ.",
      "deleteFailed": "އެޓޭޗްމަންޓް ޑިލީޓް ނުކުރެވުނު.",
      "bySystem": "ސިސްޓަމުން",
      "byYou": "ތިބާ",
      "byUser": "ޔޫޒަރ #{id}",
      "portal": {
        "badge": "ޕޯރޓަލްގައި ފެންނާނެ",
        "share": "ޕޯރޓަލާ ޝެއަރ ކުރޭ",
        "withdraw": "ޕޯރޓަލުން ފޮރުވާ",
        "shareName": "{name} ޕޯރޓަލާ ޝެއަރ ކުރޭ",
        "withdrawName": "{name} ޕޯރޓަލުން ފޮރުވާ",
        "confirmTitle": "މި ފައިލް ޝެއަރ ކުރަންތަ؟",
        "confirmMessage": "{party} ގެ ފަރާތުން މި ފައިލް ({name}) ފެނިވަޑައިގަންނާނެ.",
        "party": {
          "customer": "ކަސްޓަމަރ",
          "supplier": "ސަޕްލައިޔަރ",
          "contractor": "ކޮންޓްރެކްޓަރ",
          "counterparty": "ކައުންޓަރޕާޓީ"
        },
        "shared": "ފައިލް ޕޯރޓަލާ ޝެއަރ ކުރެވުނު",
        "withdrawn": "ފައިލް ޕޯރޓަލުން ފޮރުވިފައި",
        "failed": "ޕޯރޓަލްގައި ފެންނަ ގޮތް ބަދަލު ނުކުރެވުނު."
      }
    },
    "cheatSheet": {
      "title": "ކީބޯޑް ޝޯޓްކަޓްތައް",
      "description": "މި ސްކްރީނުގައި މިހާރު ބަނދެފައިވާ ހުރިހާ ކީއެއް.",
      "empty": "މި ސްކްރީނުގައި ވަކި ޝޯޓްކަޓެއް ބަނދެފައެއް ނުވެއެވެ.",
      "groups": {
        "global": "ޢާންމު",
        "navigation": "ނެވިގޭޝަން",
        "document": "ލިޔުންތައް",
        "grid": "ލައިން ގްރިޑްތައް",
        "list": "ލިސްޓްތައް",
        "approvals": "ފާސްކުރުންތައް"
      }
    },
    "shortcuts": {
      "palette": "ކޮމާންޑް ޕެލެޓް ހުޅުވާ",
      "search": "ހުރިހާ އެއްޗެއް ހޯދާ",
      "cheatSheet": "މި ޝޯޓްކަޓް ލިސްޓް ދައްކާ",
      "quickCreate": "އަވަހަށް އުފައްދާ",
      "insights": "އިންސައިޓްސް ޕެނަލް ދައްކާ/ފޮރުވާ",
      "apps": "އެޕް ލޯންޗަރ ހުޅުވާ"
    },
    "fsd": {
      "notInFsd": "އެފްއެސްޑީގައި ނެތް",
      "notInFsdHint": "މި ސްކްރީނަށް އެފްއެސްޑީގައި ފީޗަރ ސްޕެސިފިކޭޝަނެއް ނެތް. ސްކޯޕް ރިވިއުއަށް ފާހަގަކޮށްފައި.",
      "chipLabel": "FSD {ref}",
      "featureLabel": "ފީޗަރ {code}",
      "identification": "FSD ދެނެގަތުން"
    },
    "launcher": {
      "trigger": "އެޕްތައް",
      "triggerHint": "އެޕްތައް ({shortcut})",
      "title": "އެޕްތައް",
      "searchPlaceholder": "އެޕްތަކާއި ސްކްރީންތައް ހޯދާ",
      "searchLabel": "އެޕްތަކާއި ސްކްރީންތައް ހޯދާ",
      "resultsLabel": "ގުޅޭ އެޕްތަކާއި ސްކްރީންތައް",
      "appsGroup": "އެޕްތައް",
      "screensGroup": "ސްކްރީންތައް",
      "gridLabel": "ހުރިހާ އެޕެއް",
      "emptyTitle": "“{query}” އާ ގުޅޭ އެއްވެސް އެއްޗެއް ނެތް",
      "emptyHint": "ކުރު ލަފްޒެއް ބޭނުންކޮށްލާ، ނުވަތަ ރެކޯޑްތަކާއި ޢަމަލުތައް ހޯދުމަށް މަތީ ބާރުގައިވާ ހޯދާ ބޭނުންކުރޭ.",
      "openApp": "{app} ހުޅުވާ",
      "paletteGroup": "އެޕްތައް"
    }
  },
  "palette": {
    "title": "ކޮމާންޑް ޕެލެޓް",
    "listLabel": "ކޮމާންޑްތައް",
    "placeholder": "ސްކްރީން، ޢަމަލު އަދި އުފައްދާނެ އެއްޗެހި ހޯދާ…",
    "empty": "އެއާ ގުޅޭ އެއްޗެއް ނެތެވެ. މޮޑިއުލްގެ ނަމެއް، ނުވަތަ ލިޔުމުގެ ނަންބަރެއް ލިޔެލާ.",
    "hint": {
      "navigate": "ދަތުރުކުރަން",
      "run": "ހިންގަން",
      "close": "ބަންދުކުރަން",
      "escKey": "އެސްކޭޕް"
    },
    "groups": {
      "goTo": "ދާންވީ",
      "create": "އުފައްދާ",
      "actions": "އަމަލުތައް"
    },
    "commands": {
      "insights": "އިންސައިޓްސް ޕެނަލް ދައްކާ/ފޮރުވާ",
      "insightsKeywords": "ކަނާތު ޕެނަލް ޓައިމްލައިން އެސިސްޓަންޓް",
      "shortcuts": "ކީބޯޑް ޝޯޓްކަޓްތައް",
      "shortcutsKeywords": "އެހީ ކީތައް ޗީޓް ޝީޓް",
      "signOut": "ސައިން އައުޓް",
      "signOutKeywords": "ލޮގްއައުޓް ނުކުތުން",
      "createKeywords": "އައު އިތުރުކުރުން"
    }
  },
  "quickCreate": {
    "inviteUser": {
      "label": "ބޭނުންކުރާ ފަރާތަކަށް ދައުވަތު ދޭ",
      "description": "ދައުވަތެއް ފޮނުވައި ރޯލްތައް ހަވާލުކުރޭ"
    }
  },
  "auth": {
    "login": {
      "title": "ސައިން އިން",
      "subtitle": "ކުރިއަށް ދިއުމަށް ތިޔަ ފަރާތުގެ ވޯކްސްޕޭސް މަޢުލޫމާތު ބޭނުންކުރޭ.",
      "workspaceHint": "އިދާރީ ފަރާތުން ދިން ކުރު ނަން، މިސާލަކަށް velaa",
      "workspacePlaceholder": "ވޯކްސްޕޭސް",
      "emailPlaceholder": "you{'@'}company.mv",
      "totpLabel": "އޮތެންޓިކޭޝަން ކޯޑް",
      "totpHint": "އޮތެންޓިކޭޓަރ އެޕުން ހަ އަދަދު",
      "totpPlaceholder": "000000",
      "submitting": "ސައިން އިން ވަނީ",
      "forgotPassword": "ޕާސްވޯޑް ހަނދާން ނެތުނީތަ؟",
      "haveInvitation": "އަހަންނަށް ދައުވަތެއް ލިބިފައިވޭ",
      "sessionExpired": "ތިބާގެ ސެޝަން ހަމަވެގެން ސައިން އައުޓް ކުރެވިއްޖެ. ކުރިއަށް ދިއުމަށް އަލުން ސައިން އިން ކުރައްވާ."
    },
    "sso": {
      "sectionLabel": "ސިންގަލް ސައިން-އޮން",
      "orDivider": "ނުވަތަ",
      "signInWith": "{provider} މެދުވެރިކޮށް ސައިން އިން ކުރޭ",
      "starting": "ސައިން އިން ފޯރުކޮށްދޭ ފަރާތް ހުޅުވަނީ",
      "startFailed": "ސިންގަލް ސައިން-އޮން ފެށޭކަށް ނެތް. އަލުން މަސައްކަތްކުރައްވާ، ނުވަތަ ޕާސްވޯޑް ބޭނުންކޮށް ސައިން އިން ކުރައްވާ.",
      "callback": {
        "title": "ސިންގަލް ސައިން-އޮން",
        "subtitle": "ތިބާގެ ސައިން އިން ނިންމަނީ.",
        "working": "ސައިން އިން ކުރަނީ"
      },
      "errors": {
        "providerDenied": "ސައިން އިން ފޯރުކޮށްދޭ ފަރާތުން ސައިން އިން ނިންމާފައެއް ނުވޭ. ސައިން އިން ސަފްހާއިން އަލުން މަސައްކަތްކުރައްވާ.",
        "invalidRequest": "ސައިން އިން ފޯރުކޮށްދޭ ފަރާތުގެ ޖަވާބު ފުރިހަމައެއް ނޫން. ސައިން އިން ސަފްހާއިން އަލުން ފައްޓަވާ.",
        "expiredOrInvalidState": "މި ސައިން އިން އަށް ގިނަ ވަގުތު ނެގުނު، ނުވަތަ މީގެ ކުރިން ބޭނުންކުރެވިފައިވޭ. ސައިން އިން ސަފްހާއިން އަލުން ފައްޓަވާ.",
        "internalError": "ސައިން އިން ނިންމަމުންދަނިކޮށް މައްސަލައެއް ދިމާވެއްޖެ. ކުޑަ ވަގުތަކަށްފަހު އަލުން މަސައްކަތްކުރައްވާ.",
        "accountNotActive": "މި ވޯކްސްޕޭސްގައި ތިބާގެ އެކައުންޓް އެކްޓިވް ނޫން. އަލުން އެކްޓިވްކުރުމަށް އިދާރީ ފަރާތާ ގުޅުއްވާ.",
        "noAccount": "މި ވޯކްސްޕޭސްގައި ތިބާއަށް އެކައުންޓެއް ނެތް. ދައުވަތެއް ފޮނުވުމަށް އިދާރީ ފަރާތާ ގުޅުއްވާ.",
        "emailNotVerified": "ސައިން އިން ފޯރުކޮށްދޭ ފަރާތުން ތިބާގެ އީމެއިލް އެޑްރެސް ޔަގީންކޮށްފައި ނުވާތީ، މިތާނގައި ސައިން އިން ކުރުމަށް އެ ބޭނުންކުރެވޭކަށް ނެތް.",
        "domainNotAllowed": "ތިބާގެ އީމެއިލް އެޑްރެހުގެ ޑޮމެއިން އަށް މި ފަރާތް މެދުވެރިކޮށް މި ވޯކްސްޕޭސްއަށް ސައިން އިން ކުރުމުގެ ހުއްދައެއް ނެތް.",
        "providerUnavailable": "މި ސައިން އިން ފޯރުކޮށްދޭ ފަރާތް މި ވޯކްސްޕޭސްއަށް މިހާރު ލިބޭކަށް ނެތް. އެހެން ގޮތަކަށް ސައިން އިން ކުރައްވާ، ނުވަތަ އިދާރީ ފަރާތާ ގުޅުއްވާ.",
        "ssoFailed": "ސިންގަލް ސައިން-އޮން ކާމިޔާބެއް ނުވި. ސައިން އިން ސަފްހާއިން އަލުން ފައްޓަވާ.",
        "notStartedHere": "މި ސައިން އިން ފެށީ މި ބްރައުޒަރ ޓެބުން ނޫންކަމުން، އެ ނިންމާފައެއް ނުވޭ. ސައިން އިން ސަފްހާއިން އަލުން ފައްޓަވާ.",
        "missingTicket": "މިތާނގައި ނިންމާނެ ސައިން އިނެއް ނެތް. ސައިން އިން ސަފްހާއިން ފައްޓަވާ.",
        "ticketInvalid": "މި ސައިން އިން ލިންކުގެ މުއްދަތު ހަމަވެފައި، ނުވަތަ މީގެ ކުރިން ބޭނުންކުރެވިފައިވޭ. ސައިން އިން ސަފްހާއިން އަލުން ފައްޓަވާ.",
        "tenantMismatch": "މި ސައިން އިން ނިސްބަތްވަނީ ތިބާ އިޚްތިޔާރުކުރި ވޯކްސްޕޭސް ނޫން އެހެން ވޯކްސްޕޭސްއަކަށް ކަމުން، އެ ނިންމާފައެއް ނުވޭ. ސައިން އިން ސަފްހާއިން އަލުން ފައްޓަވާ.",
        "sessionEnded": "މި ޓެބުގައި އެހެން ސައިން އިނެއް ކުރެވުމުން މި ސައިން އިން ބަދަލުވެއްޖެ. ސައިން އިން ސަފްހާއިން އަލުން ފައްޓަވާ."
      }
    },
    "forgot": {
      "title": "ޕާސްވޯޑް ރީސެޓްކުރޭ",
      "subtitle": "އައު ޕާސްވޯޑެއް އިޚްތިޔާރުކުރެވޭނެ ލިންކެއް އީމެއިލްކުރާނަމެވެ.",
      "sent": "އެ އެޑްރެހަކީ މި ވޯކްސްޕޭސްގެ އެކައުންޓަކާ ގުޅިފައިވާ އެޑްރެހެއް ނަމަ، ރީސެޓް ލިންކެއް ފޮނުވިއްޖެއެވެ. ލިންކުގެ މުއްދަތު ކުރެވެ — ނުލިބިއްޖެނަމަ ސްޕޭމް ބައްލަވާ.",
      "submit": "ރީސެޓް ލިންކް ފޮނުވާ"
    },
    "reset": {
      "title": "އައު ޕާސްވޯޑެއް އިޚްތިޔާރުކުރޭ",
      "subtitle": "އައު ޕާސްވޯޑް ވަގުތުން ޢަމަލުކުރަން ފަށާނެއެވެ.",
      "done": "ޕާސްވޯޑް އަޕްޑޭޓްކުރެވިއްޖެ. އެހެން ހުރިހާ ސެޝަނެއް ސައިން އައުޓްކުރެވިއްޖެ.",
      "tokenLabel": "ރީސެޓް ޓޯކަން",
      "tokenHint": "ތިޔަ ފަރާތުގެ އީމެއިލް ލިންކުން ކޮޕީކުރި",
      "newPasswordHint": "މަދުވެގެން 12 އަކުރު. ދިގުވުން، އުނދަގޫވުމަށްވުރެ ރަނގަޅު.",
      "confirmLabel": "އައު ޕާސްވޯޑް ޔަގީންކުރޭ",
      "submit": "ޕާސްވޯޑް އަޕްޑޭޓްކުރޭ"
    },
    "changePassword": {
      "title": "އަމިއްލަ ޕާސްވޯޑެއް އިޚްތިޔާރުކުރޭ",
      "subtitle": "އެންމެ ފިޔަވަޅެއް، އަދި ވޯކްސްޕޭސްގެ ބާކީ ބައި ހުޅުވޭނެއެވެ.",
      "why": "މި އެކައުންޓުގެ ޕާސްވޯޑް ކަނޑައެޅީ އެހެން ފަރާތަކުންނެވެ. އެހެންކަމުން މި ސްކްރީން ފިޔަވައި ހުރިހާ އެއްޗެއް ހުއްޓުވާފައިވަނީ އެ ޕާސްވޯޑް ބަދަލުކުރަންދެންނެވެ.",
      "currentLabel": "ތިޔަ ފަރާތަށް ދިން ޕާސްވޯޑް",
      "currentHint": "އިދާރީ ފަރާތުން ދިން ޕާސްވޯޑް، ނުވަތަ ދައުވަތުން ލިބުނު ޕާސްވޯޑް.",
      "newHint": "މަދުވެގެން {min} އަކުރު. ދިގުވުން، އުނދަގޫވުމަށްވުރެ ރަނގަޅު.",
      "submit": "ޕާސްވޯޑް ބަދަލުކޮށް ކުރިއަށް ދޭ"
    },
    "invite": {
      "title": "ދައުވަތު ޤަބޫލުކުރޭ",
      "subtitle": "ޕާސްވޯޑެއް އިޚްތިޔާރުކުރުމުން ވަގުތުން ވޯކްސްޕޭސް ހުޅުވޭނެއެވެ.",
      "tokenLabel": "ދައުވަތުގެ ޓޯކަން",
      "tokenHint": "ތިޔަ ފަރާތުގެ ދައުވަތު އީމެއިލުން ކޮޕީކުރި",
      "nameLabel": "ތިޔަ ފަރާތުގެ ނަން",
      "nameHint": "އިދާރީ ފަރާތުން ލިޔުނު ނަން ބަހައްޓަން ބޭނުންނަމަ ހުސްކޮށް ބާއްވާ",
      "passwordHint": "މަދުވެގެން 12 އަކުރު.",
      "submitting": "ތައްޔާރުކުރަނީ",
      "submit": "ދައުވަތު ޤަބޫލުކުރޭ"
    }
  },
  "dashboard": {
    "greeting": "ފެނުނީތީ އުފާކުރަން، {name}",
    "greetingFallback": "އެކުވެރިޔާ",
    "subtitle": "ވޯކްސްޕޭސް {slug}. ކަންކަން އޮތްގޮތް މިއޮތީ.",
    "protected": "އެކައުންޓް ރައްކާތެރިކުރެވިފައި",
    "unprotected": "ޓޫ-ފެކްޓަރ ނިއްވާލާފައި",
    "summaryFailed": "ވޯކްސްޕޭސްގެ ޚުލާޞާ ލޯޑެއް ނުވި",
    "kpi": {
      "activeUsers": "ހަރަކާތްތެރި ބޭނުންކުރާ ފަރާތްތައް",
      "activeUsersHelp": "މިހާރު ސައިން އިން ވެވޭ މީހުން.",
      "activeUsersDrill": "ހަރަކާތްތެރި ފަރާތްތައް ބައްލަވާ",
      "invitations": "ޖަވާބު ނުލިބޭ ދައުވަތުތައް",
      "invitationsHelp": "ދައުވަތު ދެވިފައި، ނަމަވެސް އަދި ފުރަތަމަ ފަހަރަށް ސައިން އިން ނުވާ.",
      "invitationsDrill": "ޖަވާބު ނުލިބޭ ދައުވަތުތައް ބައްލަވާ",
      "withMfa": "ޓޫ-ފެކްޓަރ ހުރި އެކައުންޓްތައް",
      "withMfaHelp": "ވޯކްސްޕޭސްގެ ކޮންމެ ބޭނުންކުރާ ފަރާތެއް ހިމަނައިގެން ގުނާފައި.",
      "allUsersDrill": "ހުރިހާ ފަރާތްތައް ބައްލަވާ",
      "withoutRole": "ރޯލެއް ނެތް ފަރާތްތައް",
      "withoutRoleHelp": "ސައިން އިން ވެވޭ ނަމަވެސް އެއްވެސް ހުއްދައެއް ނެތް. ޢާންމުކޮށް މިއީ ނުނިމޭ ދައުވަތެއް.",
      "roles": "ކަނޑައަޅާފައިވާ ރޯލްތައް",
      "rolesHelp": "ފެށުމުގައި ދެވުނު ރޯލްތަކާއި ވޯކްސްޕޭސުން އިތުރުކުރި ރޯލްތައް.",
      "rolesDrill": "ރޯލްތައް ބައްލަވާ",
      "sessions": "ތިޔަ ފަރާތުގެ ހިނގަމުންދާ ސެޝަންތައް",
      "sessionsHelp": "މިހާރު ތިޔަ ފަރާތުގެ ނަމުގައި ސައިން އިން ވެފައިވާ ޑިވައިސްތައް. ނޭނގޭ އެއްޗެއް ވާނަމަ ބާޠިލުކުރޭ.",
      "sessionsDrill": "ތިޔަ ފަރާތުގެ ސެޝަންތައް ބައްލަވާ"
    },
    "usersByStatus": {
      "title": "ސްޓޭޓަސް އަށް ބަހާލެވިފައިވާ ފަރާތްތައް",
      "description": "މުޅި ޑައިރެކްޓަރީ ގުނާފައި.",
      "emptyTitle": "އަދި އެއްވެސް ފަރާތެއް ނެތް",
      "emptyDescription": "މި ވޯކްސްޕޭސް ފުރާލަން ފުރަތަމަ ބައިވެރިޔާއަށް ދައުވަތު ދޭ.",
      "inviteFirst": "ފުރަތަމަ ބައިވެރިޔާއަށް ދައުވަތު ދޭ",
      "chartLabel": "ސްޓޭޓަސް އަށް ބަހާލެވިފައިވާ ފަރާތްތަކުގެ ބާ ޗާޓް"
    },
    "checklist": {
      "title": "ފެށުން",
      "description": "ޙަޤީޤަތުގައި ސެޓަޕްކުރެވިފައިވާ ގޮތުން ގުނާފައި.",
      "done": "ނިމިއްޖެ",
      "todo": "ކުރަންޖެހޭ",
      "mfa": "އޮތެންޓިކޭޓަރ އެޕަކުން ތިޔަ ފަރާތުގެ އެކައުންޓް ރައްކާތެރިކުރޭ",
      "invite": "ޓީމުގެ ބާކީ ފަރާތްތަކަށް ދައުވަތު ދޭ",
      "roles": "ކޮންމެ ފަރާތަކަށްވެސް ރޯލެއް ދޭ — އެއްވެސް ހުއްދައެއް ނެތި އެއްވެސް ފަރާތެއް ސައިން އިން ވެގެން ނުވާނެ",
      "accept": "ޖަވާބު ނުލިބޭ ދައުވަތުތައް ފަހަތުން ދާ"
    }
  },
  "users": {
    "list": {
      "title": "ބޭނުންކުރާ ފަރާތްތައް",
      "description": "މި ވޯކްސްޕޭސް އަށް ސައިން އިން ވެވެނީ ކޮން ފަރާތްތަކަކަށްކަމާއި، އެ ފަރާތްތަކަށް ކުރެވެނީ ކޮންކަމެއްކަން.",
      "tableLabel": "ޓެނަންޓްގެ ބޭނުންކުރާ ފަރާތްތައް",
      "loadFailed": "ބޭނުންކުރާ ފަރާތްތަކުގެ ލިސްޓް ލޯޑެއް ނުވި",
      "searchPlaceholder": "ނަން ނުވަތަ އީމެއިލް ހޯދާ",
      "searchLabel": "ބޭނުންކުރާ ފަރާތްތައް ހޯދާ",
      "filterByStatus": "ސްޓޭޓަސް އިން ފިލްޓަރކުރޭ",
      "emptyTitle": "އަދި އެއްވެސް ފަރާތެއް ނެތް",
      "emptyDescription": "ފުރަތަމަ ބައިވެރިޔާއަށް ދައުވަތު ދޭ، ޤަބޫލުކުރުމުން މިތާ ފެންނާނެއެވެ.",
      "inviteFirst": "ފުރަތަމަ ބައިވެރިޔާއަށް ދައުވަތު ދޭ",
      "shareHint": "މި ވިއު އެޑްރެސް ބާރުގައި އެބައޮތެވެ — ތިޔަ ފަރާތަށް ފެންނަ ގޮތް ހިއްސާކުރަން ޔޫއާރްއެލް ކޮޕީކުރޭ.",
      "noRoles": "ރޯލެއް ހަވާލުކޮށްފައެއް ނުވޭ",
      "columns": {
        "name": "ނަން",
        "status": "ސްޓޭޓަސް",
        "roles": "ރޯލްތައް",
        "mfa": "އެމްއެފްއޭ",
        "lastLogin": "އެންމެފަހުން ސައިން އިން ވި ވަގުތު",
        "added": "އިތުރުކުރި"
      },
      "mfaOn": "ދިއްލާފައި",
      "mfaOff": "ނިއްވާލާފައި",
      "bulk": {
        "disable": "ހުއްޓާލާ",
        "reinstate": "އަލުން ހުޅުވާ",
        "resend": "ދައުވަތު އަލުން ފޮނުވާ",
        "updated": "{count} ފަރާތެއް އަޕްޑޭޓްކުރެވިއްޖެ | {count} ފަރާތެއް އަޕްޑޭޓްކުރެވިއްޖެ",
        "resendDetail": "އައު ދައުވަތު ލިންކްތައް ފޮނުވިއްޖެ.",
        "partialFailure": "{total} ގެ ތެރެއިން {failed} އަޕްޑޭޓެއް ނުކުރެވުނު"
      },
      "export": {
        "success": "{count} ފަރާތެއް އެކްސްޕޯޓްކުރެވިއްޖެ | {count} ފަރާތެއް އެކްސްޕޯޓްކުރެވިއްޖެ",
        "truncated": "އެކްސްޕޯޓް ހުއްޓުނީ ފުރަތަމަ 4,000 ރޯއިންނެވެ. ބާކީ ބައި ހޯދަން ފިލްޓަރ ހަނިކުރޭ.",
        "failed": "އެކްސްޕޯޓް ނާކާމިޔާބުވި",
        "columns": {
          "name": "ނަން",
          "email": "އީމެއިލް",
          "status": "ސްޓޭޓަސް",
          "roles": "ރޯލްތައް",
          "mfa": "އެމްއެފްއޭ",
          "jobTitle": "ވަޒީފާގެ ނަން",
          "phone": "ފޯނު",
          "locale": "ބަސް",
          "lastLogin": "އެންމެފަހުން ސައިން އިން ވި ވަގުތު",
          "created": "އުފެއްދި"
        },
        "mfaEnabled": "ދިއްލާފައި",
        "mfaDisabled": "ނިއްވާލާފައި"
      },
      "views": {
        "trigger": "ވިއުތައް",
        "label": "ރައްކާކުރި ވިއުތައް",
        "empty": "ލިސްޓް ފިލްޓަރކޮށްފައި، އެއް ކްލިކުން އެނބުރި އައުމަށް މިތާ ރައްކާކުރޭ.",
        "namePlaceholder": "މި ވިއު އަށް ނަމެއް ދޭ",
        "nameLabel": "މި ވިއު އަށް ނަމެއް ދޭ",
        "delete": "ވިއު {name} ޑިލީޓްކުރޭ",
        "saved": "ވިއު ރައްކާކުރެވިއްޖެ",
        "savedDetail": "\"{name}\" މިހާރު ތިޔަ ފަރާތުގެ ރައްކާކުރި ވިއުތަކުގައި ފެންނާނެއެވެ."
      },
      "rail": {
        "lastSeen": "އެންމެފަހުން ފެނުނު",
        "lastLogin": "އެންމެފަހުން ސައިން އިން ވި",
        "passwordChanged": "ޕާސްވޯޑް އެންމެފަހުން ބަދަލުކުރި",
        "created": "އެކައުންޓް އުފެއްދި",
        "subtitle": "{email} · {status}",
        "rolesLink": "ރޯލްތަކާއި ހުއްދަތައް"
      }
    },
    "status": {
      "active": "ހަރަކާތްތެރި",
      "invited": "ދައުވަތު ދެވިފައި",
      "disabled": "ހުއްޓާލެވިފައި"
    },
    "invite": {
      "title": "ބޭނުންކުރާ ފަރާތަކަށް ދައުވަތު ދޭ",
      "description": "ބައިވެރިޔަކަށް އެކައުންޓެއް އުފައްދައި، ފުރަތަމަ ފަހަރު ސައިން އިން ވާނެ ގޮތް އިޚްތިޔާރުކުރޭ.",
      "emailPlaceholder": "name{'@'}company.mv",
      "namePlaceholder": "ޢާއިޝަތު އަޙްމަދު",
      "noRolePermission": "މި ފަރާތަށް މިހާރު ދައުވަތު ދެވިދާނެއެވެ؛ ރޯލް އިދާރީ ހުއްދަ ލިބިފައިވާ ބައިވެރިޔަކަށް ފަހުން ރޯލްތައް ހަވާލުކުރެވޭނެއެވެ.",
      "submit": "ދައުވަތު ފޮނުވާ",
      "submitting": "ދައުވަތު ފޮނުވަނީ",
      "sent": "ދައުވަތު ފޮނުވިއްޖެ",
      "sentDetail": "{email} އަށް މިހާރު ޕާސްވޯޑް ކަނޑައަޅައި ސައިން އިން ވެވޭނެއެވެ.",
      "failed": "ދައުވަތު ފޮނުވޭގޮތެއް ނުވި",
      "credential": {
        "legend": "ފުރަތަމަ ފަހަރު ސައިން އިން ވާނެ ގޮތް",
        "invite": "ދައުވަތެއް ފޮނުވާ",
        "inviteHint": "ލިންކެއް ހިމެނޭ އީމެއިލެއް ލިބި، އަމިއްލަ ޕާސްވޯޑެއް އިޚްތިޔާރުކުރާނެއެވެ. ދައުވަތު ޤަބޫލުކުރަންދެން އެއްވެސް ކަމެއް ނުކުރެވޭނެއެވެ.",
        "set": "ޕާސްވޯޑެއް ކަނޑައަޅާ",
        "setHint": "އަދި އީމެއިލް އެޑްރެހެއް ނެތް ފަރާތަކަށެވެ. އީމެއިލުން ނުފޮނުވައި، ސީދާ ދިމާވެގެން ހަވާލުކުރޭ.",
        "generate": "ޕާސްވޯޑެއް އުފައްދާ",
        "generateHint": "ވަރުގަދަ ޕާސްވޯޑެއް އުފައްދައި، ހަމައެކަނި އެއް ފަހަރު ދައްކާނެއެވެ."
      },
      "passwordHint": "މަދުވެގެން {min} އަކުރު. އީމެއިލުން ނުފޮނުވައި، ސީދާ ދިމާވެގެން ހަވާލުކުރޭ.",
      "mustChange": {
        "label": "ފުރަތަމަ ސައިން އިން ވުމުގައި ޕާސްވޯޑް ބަދަލުކުރަން ލާޒިމުކުރޭ",
        "hint": "އެކަން ކުރަންދެން ސައިން އިން ވެވޭނެ ނަމަވެސް އިތުރު އެއްވެސް ކަމެއް ނުކުރެވޭނެއެވެ. ސަބަބެއް ނެތްނަމަ މިކަން ދިއްލާފައި ބާއްވާ — ތިޔަ ފަރާތަށް ޕާސްވޯޑް އެނގުން ވަގުތީކޮށްދެނީ މިކަމެވެ."
      },
      "submitCreate": "ބޭނުންކުރާ ފަރާތް އުފައްދާ",
      "submittingCreate": "ބޭނުންކުރާ ފަރާތް އުފައްދަނީ",
      "created": "ބޭނުންކުރާ ފަރާތް އުފެއްދިއްޖެ",
      "createdDetail": "{email} އަށް މިހާރު ސައިން އިން ވެވޭނެއެވެ.",
      "handover": {
        "warning": "މި ޕާސްވޯޑް ދައްކާނީ ހަމައެކަނި މި ފަހަރުއެވެ. އަލުން ކިޔޭނެ އެއްވެސް ތަނެއްގައި ރައްކާކޮށްފައެއް ނުވެއެވެ — ގެއްލިއްޖެނަމަ އައު ޕާސްވޯޑެއް ކަނޑައަޅަން ޖެހޭނެއެވެ.",
        "label": "{name} ގެ ޕާސްވޯޑް",
        "acknowledge": "މި ޕާސްވޯޑް ލިޔެފިން ނުވަތަ ހަވާލުކޮށްފިން",
        "copied": "ޕާސްވޯޑް ކޮޕީކުރެވިއްޖެ",
        "copiedDetail": "ހަވާލުކުރާ ތަނުގައި ޕޭސްޓްކޮށްފައި، ކްލިޕްބޯޑް ސާފުކުރޭ.",
        "copyBlocked": "ކޮޕީކުރުން ހުއްޓުވިއްޖެ",
        "copyBlockedDetail": "އޭގެ ބަދަލުގައި ސްކްރީނުން ކިޔާ — ދައްކާނީ ހަމައެކަނި މި ފަހަރުއެވެ."
      }
    },
    "edit": {
      "fallbackTitle": "ބޭނުންކުރާ ފަރާތް",
      "mfaEnabled": "އެމްއެފްއޭ ދިއްލާފައި",
      "mfaDisabled": "އެމްއެފްއޭ ނެތް",
      "lastSignedIn": "އެންމެފަހުން ސައިން އިން ވި",
      "staleTitle": "ތިޔަ ފަރާތުން ހުޅުވައިގެން ހުއްޓައި އެހެން ފަރާތަކުން މި ފަރާތުގެ މަޢުލޫމާތު ބަދަލުކޮށްފިއެވެ.",
      "staleDetail": "އެއްވެސް އެއްޗެއް ފުހެވިފައެއް ނުވެއެވެ. އެ ފަރާތުގެ ބަދަލު ބެލުމަށް އަލުން ލޯޑްކޮށް، ދެން ތިޔަ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "މި ފަރާތް އަލުން ލޯޑްކުރޭ",
      "timezoneHint": "އައިއޭއެންއޭ ނަން، މިސާލަކަށް Indian/Maldives. ހުސްކޮށް ބާއްވައިފިނަމަ ވޯކްސްޕޭސްގެ ޓައިމްޒޯން ބޭނުންކުރެވޭނެ.",
      "resend": "ދައުވަތު އަލުން ފޮނުވާ",
      "disable": "އެކައުންޓް ހުއްޓާލާ",
      "reinstate": "އެކައުންޓް އަލުން ހުޅުވާ",
      "saved": "ފަރާތުގެ މަޢުލޫމާތު އަޕްޑޭޓްކުރެވިއްޖެ",
      "savedDetail": "{name} ރައްކާކުރެވިއްޖެ.",
      "saveFailed": "އެ ރައްކާއެއް ނުވި",
      "disabled": "ފަރާތް ހުއްޓާލެވިއްޖެ",
      "disabledDetail": "އެ އެކައުންޓްގެ ހިނގަމުންދިޔަ ހުރިހާ ސެޝަނެއް ބާޠިލުކުރެވިއްޖެ.",
      "reinstated": "ފަރާތް އަލުން ހުޅުވިއްޖެ",
      "reinstatedDetail": "{name} އަށް އަލުން ސައިން އިން ވެވޭނެއެވެ.",
      "resent": "ދައުވަތު އަލުން ފޮނުވިއްޖެ",
      "resentDetail": "{email} އަށް އައު ލިންކެއް ފޮނުވިއްޖެ.",
      "actionFailed": "އެ ޢަމަލު ނާކާމިޔާބުވި"
    },
    "roleEditor": {
      "legend": "ރޯލްތައް",
      "loading": "ރޯލްތައް ލޯޑްވަނީ…",
      "conflictTitle": "މި ރޯލްތައް އެއްކޮށްލުމުން މަސްއޫލިއްޔަތު ވަކިކުރުމުގެ ފުށުއެރުމެއް އުފެދެއެވެ",
      "conflictNote": "އެހެންނަމަވެސް ހަވާލުކުރެވިދާނެއެވެ، ނަމަވެސް ސަބަބު އެ ބަދަލާއެކު ރެކޯޑްކުރެވި އޮޑިޓަރުންނަށް ފެންނާނެއެވެ.",
      "reasonLabel": "އޯވަރައިޑްކުރާ ސަބަބު",
      "reasonHint": "ފުށުއެރުން ޤަބޫލުކުރުމަށް ލާޒިމު. އޮޑިޓް ރެކޯޑްގައި ރައްކާކުރެވޭނެ.",
      "reasonPlaceholder": "މިސާލަކަށް: ދެ މީހުންގެ ފައިނޭންސް ޓީމެއް؛ ބަދަލުގައި ސީއެފްއޯ މަހަކު އެއްފަހަރު މުރާޖަޢާކުރާނެ."
    },
    "servicePrincipal": {
      "badge": "ސާވިސް ޕްރިންސިޕަލް",
      "new": "އާ ސާވިސް ޕްރިންސިޕަލް",
      "title": "އާ ސާވިސް ޕްރިންސިޕަލް",
      "description": "އަމިއްލަ ރޯލްތަކުގެ ދަށުން ފަހަތުގައި ދުވާ މަސައްކަތްތައް ކުރާ އެކައުންޓެއް. މިއަށް ޕާސްވޯޑެއް ނެތް، އީމެއިލެއް ނުލިބޭ، އަދި ދުވަހަކުވެސް ސައިން އިން ނުވޭ.",
      "nameLabel": "ނަން",
      "namePlaceholder": "މިސާލަކަށް، ރޭގަނޑުގެ ބޭންކް އިމްޕޯޓް",
      "submit": "ސާވިސް ޕްރިންސިޕަލް ހަދާ",
      "submitting": "ހަދަނީ…",
      "created": "ސާވިސް ޕްރިންސިޕަލް ހެދިއްޖެ",
      "createdDetail": "{name} އަށް އަދި އެއްވެސް ރޯލެއް ދީފައެއް ނުވޭ. އޭގެ މަސައްކަތްތަކަށް ބޭނުންވާ ރޯލްތައް ދީ.",
      "failed": "ސާވިސް ޕްރިންސިޕަލް ނުހެދުނު",
      "explanation": "މިއީ ސާވިސް ޕްރިންސިޕަލެއް: ފަހަތުގައި ދުވާ މަސައްކަތްތައް ކުރާ، ދުވަހަކުވެސް ސައިން އިން ނުވާ އެކައުންޓެއް. އެހެންކަމުން ދައުވަތު، ޕާސްވޯޑް އަދި އެމްއެފްއޭ މިއަށް ނުގުޅޭ. އެ މަސައްކަތްތަކަށް ކުރެވޭނީ ކޮންކަމެއްތޯ ނިންމަނީ އޭގެ ރޯލްތަކުން.",
      "notApplicable": "ނުގުޅޭ",
      "bulkSkipped": "{count} ސާވިސް ޕްރިންސިޕަލް ދޫކޮށްލެވިއްޖެ: ސާވިސް ޕްރިންސިޕަލްތަކަށް ދައުވަތު ނުފޮނުވޭ | {count} ސާވިސް ޕްރިންސިޕަލް ދޫކޮށްލެވިއްޖެ: ސާވިސް ޕްރިންސިޕަލްތަކަށް ދައުވަތު ނުފޮނުވޭ"
    }
  },
  "roles": {
    "list": {
      "title": "ރޯލްތައް",
      "description": "ކޮންމެ ރޯލަކީ ނަން ދެވިފައިވާ ހުއްދަތަކުގެ ބައެކެވެ. ބޭނުންކުރާ ފަރާތްތަކުގެ ސްކްރީނުން މީހުންނަށް ހަވާލުކުރޭ.",
      "loadFailed": "ރޯލްތައް ލޯޑެއް ނުވި",
      "tableLabel": "ރޯލްތައް",
      "toolbarHint": "ރޯލް ލިބިފައިވަނީ ކާކަށްކަން ބެލުމަށް ރޯލެއް ހޮވާ.",
      "emptyTitle": "ކަނޑައަޅާފައިވާ ރޯލެއް ނެތް",
      "emptyDescription": "ވޯކްސްޕޭސް އުފެއްދުމުގައި ރޯލްތައް ދެވެއެވެ. މި ލިސްޓް ހުސްނަމަ، އުފެއްދުން ފުރިހަމައެއް ނުވެއެވެ.",
      "columns": {
        "role": "ރޯލް",
        "purpose": "ބޭނުމަކީ",
        "origin": "އަސްލު",
        "holders": "ލިބިފައިވާ ފަރާތްތައް"
      },
      "builtIn": "ބިލްޓް-އިން",
      "custom": "ކަސްޓަމް"
    },
    "detail": {
      "fallbackTitle": "ރޯލްގެ ތަފްޞީލު",
      "noneSelectedTitle": "ރޯލެއް ހޮވާފައެއް ނުވޭ",
      "noneSelectedDescription": "ރޯލް ލިބިފައިވާ ފަރާތްތައް ބެލުމަށް ލިސްޓުން ރޯލެއް ހުޅުވާ.",
      "needsDirectory": "މި ރޯލް ލިބިފައިވާ ފަރާތްތައް ދެއްކުމަށް ބޭނުންކުރާ ފަރާތްތަކުގެ ޑައިރެކްޓަރީގެ ހުއްދަ ބޭނުންވެއެވެ.",
      "holders": "ލިބިފައިވާ ފަރާތްތައް ({count})",
      "noHoldersTitle": "މި ރޯލް އެއްވެސް ފަރާތަކަށް ލިބިފައެއް ނުވޭ",
      "noHoldersDescription": "ބޭނުންކުރާ ފަރާތްތަކުގެ ސްކްރީނުން އެ ފަރާތުގެ ޑްރޯއަރުން ހަވާލުކުރޭ.",
      "manage": "ހަވާލުކުރުންތައް ބަލަހައްޓާ"
    }
  },
  "approvals": {
    "inbox": {
      "title": "ފާސްކުރުންތައް",
      "description": "{name} އަށް އިންތިޒާރުކުރާ ހުރިހާ ކަމެއް. މި ސްކްރީނުން ނުނިކުމެ ނިންމާ.",
      "descriptionFallbackName": "ތިޔަ ފަރާތް",
      "loadFailed": "އިންބޮކްސް ލޯޑެއް ނުވި",
      "panelTitle": "ތިޔަ ފަރާތާ ހަވާލުކުރެވިފައި",
      "taskCount": "{count} މަސައްކަތް | {count} މަސައްކަތް",
      "emptyTitle": "ތިޔަ ފަރާތަށް އިންތިޒާރުކުރާ ކަމެއް ނެތް",
      "emptyDescription": "ތިޔަ ފަރާތުގެ ނަން ހިމެނޭ ލިޔުމެއް ހުށަހެޅުމާއެކު ފާސްކުރުމުގެ މަސައްކަތްތައް މިތާ ފެންނާނެއެވެ. އެއްޗެއް ފެންނަން ޖެހޭކަމަށް ދެކޭނަމަ، އެ ބާވަތުގެ ލިޔުމުގެ ފާސްކުރުމުގެ ސިޔާސަތު ބައްލަވާ — ކާކުގެ ކިބައިން ކޮން ތަރުތީބަކުން އެދޭނެކަން ކަނޑައަޅަނީ އެ ސިޔާސަތެވެ.",
      "selectAll": "މި ޞަފުޙާގެ ހުރިހާ އެއްޗެއް ހޮވާ",
      "selectOne": "{document} ހޮވާ",
      "overdue": "މުއްދަތު ފަހަނައަޅާފައި",
      "due": "މުއްދަތު",
      "step": "ފިޔަވަޅު {step}",
      "approveSelected": "ހޮވާފައިވާ ތަކެތި ފާސްކުރޭ",
      "approving": "ފާސްކުރަނީ",
      "previewTitle": "ކުރިން ބަލާލުން",
      "requestLoadFailed": "އެ ރިކުއެސްޓް ލޯޑެއް ނުވި",
      "cycle": "ސައިކަލް {cycle}",
      "viaDelegation": "{from} ހަވާލުކޮށްފައި",
      "unavailableTitle": "މި ރިކުއެސްޓް ތިބާއަށް ނުފެނޭނެ",
      "unavailableDescription": "މި ރިކުއެސްޓް ނެތް ނުވަތަ އެހެން މީހެއްގެ ކިއުގައި ހުރި ރިކުއެސްޓެއް ކަމަށް ވެދާނެ. ލިސްޓުން ޓާސްކެއް ހޮވައިލައްވާ.",
      "alreadyDecided": "މި ރިކުއެސްޓަށް ވަނީ ނިންމުމެއް ނިންމިފައި ({status}). ތިބާ ކުރަންޖެހޭ އެއްވެސް ކަމެއް ނެތް.",
      "notYours": "މި ރިކުއެސްޓް އިންތިޒާރު ކުރަނީ އެހެން މީހަކަށް. އެހެންވެ ތިބާގެ ކިއުގައި ނެތް، އަދި މިތަނުން ނިންމުމެއް ނުނިންމޭނެ."
    },
    "bulk": {
      "staleNote": "އިންބޮކްސް އަލުން ލޯޑްކުރެވިއްޖެއެވެ، އެހެންކަމުން އެހެން ފަރާތްތަކުން ނިންމި ރޯތައް ފެންނާކަށް ނުހުންނާނެއެވެ.",
      "allApproved": "{count} ރިކުއެސްޓް ފާސްކުރެވިއްޖެ | {count} ރިކުއެސްޓް ފާސްކުރެވިއްޖެ",
      "noneApproved": "{requested} ގެ ތެރެއިން އެއްވެސް އެއްޗެއް ފާހެއް ނުކުރެވުނު",
      "partial": "{requested} ގެ ތެރެއިން {approved} ފާސްކުރެވިއްޖެ، {failed} ބޭރުކުރެވިއްޖެ",
      "reasonsListed": "ކޮންމެ އެއްޗެއްގެ ސަބަބު އިންބޮކްސްގެ މަތީގައި ލިޔެފައިވެއެވެ.",
      "failed": "ބެޗް ހިނގާގޮތެއް ނުވި",
      "resultLabel": "ބަލްކް ފާސްކުރުމުގެ ނަތީޖާ",
      "succeededLabel": "{count} ފާސްކުރެވިއްޖެ",
      "failedLabel": "{count} ބޭރުކުރެވިއްޖެ، އަދިވެސް ސިލެކްޓްކުރެވިފައި",
      "allFailedLabel": "އެއްވެސް އެއްޗެއް ފާހެއް ނުކުރެވުނު — {count} ބޭރުކުރެވިއްޖެ",
      "retryLabel": "ބޭރުކުރެވުނު ތަކެތި އަލުން ފޮނުވާ",
      "reason": {
        "alreadyDecided": "އެހެން ފަރާތަކުން ކުރިން ނިންމައިފި.",
        "selfApproval": "ތިޔަ ފަރާތުން ހުށަހެޅި އެއްޗެއް ތިޔަ ފަރާތަކަށް ފާހެއް ނުކުރެވޭނެ.",
        "refused": "ސާވަރުން މިއަށް ދެކޮޅު ހަދައިފި."
      }
    },
    "decisions": {
      "approved": "ފާސްކުރެވިއްޖެ",
      "approvedDetail": "{document} ދެން އޮތް ފިޔަވަޅަށް ފޮނުވިއްޖެ.",
      "approveFailed": "އެ ފާސްކުރުން ފުރިހަމައެއް ނުވި",
      "rejected": "ބޭރުކުރެވިއްޖެ",
      "rejectedDetail": "ހުށަހެޅި ފަރާތަށް ސަބަބު އަންގައިފި.",
      "rejectFailed": "އެ ބޭރުކުރުން ފުރިހަމައެއް ނުވި",
      "delegated": "ހަވާލުކުރެވިއްޖެ",
      "delegatedDetail": "މަސައްކަތް މިހާރު އޮތީ އެ ފަރާތުގެ އިންބޮކްސްގައެވެ، ތިޔަ ފަރާތުގެ އިންބޮކްސްގައެއް ނޫނެވެ.",
      "delegateFailed": "އެ ހަވާލުކުރުން ފުރިހަމައެއް ނުވި",
      "requestFallback": "ރިކުއެސްޓް #{id}"
    },
    "reject": {
      "title": "މި ރިކުއެސްޓް ބޭރުކުރޭ",
      "description": "ސަބަބު ހުށަހެޅި ފަރާތަށް ފޮނުވި، އޮޑިޓް ލޮގްގައި ރެކޯޑްކުރެވޭނެއެވެ.",
      "reasonLabel": "ސަބަބު",
      "reasonPlaceholder": "މިކަން ފާސްކުރެވޭނީ ކޮން ބަދަލެއް ގެނެސްގެންތޯ؟",
      "commentRequired": "ބޭރުކުރާ ސަބަބު ލިޔޭ — ހުށަހެޅި ފަރާތަށް ފެންނާނީ މި ނޯޓް އެކަންޏެވެ.",
      "submitting": "ބޭރުކުރަނީ"
    },
    "delegate": {
      "title": "މި މަސައްކަތް އެހެން ފަރާތަކާ ހަވާލުކުރޭ",
      "description": "މި ރިކުއެސްޓަށް އެކަނި ތިޔަ ފަރާތުގެ ބަދަލުގައި އެ ފަރާތުން ނިންމާނެއެވެ. ދެ ނަންވެސް ރެކޯޑްގައި ހުންނާނެއެވެ.",
      "toLabel": "ހަވާލުކުރާ ފަރާތް",
      "toPlaceholder": "ބައިވެރިޔަކު އިޚްތިޔާރުކުރޭ",
      "noteLabel": "ނޯޓް",
      "notePlaceholder": "މިކަން ނަގާ ފަރާތަށް ބޭނުންވާ މަޢުލޫމާތު",
      "submitting": "ހަވާލުކުރަނީ"
    },
    "preview": {
      "loading": "ރިކުއެސްޓް ލޯޑްވަނީ",
      "emptyTitle": "ރިކުއެސްޓެއް ހޮވާފައެއް ނުވޭ",
      "emptyDescription": "ލިޔުމާއި، ފާސްކުރުމުގެ ތަރުތީބާއި، ނިންމުމުގެ ބަޓަންތައް މިތާ ބެލުމަށް ވާތްފަރާތުން މަސައްކަތެއް ހޮވާ. ލިސްޓް ހުރިތާ ހުންނާނެއެވެ.",
      "amount": "އަދަދު",
      "notMonetary": "ފައިސާގެ ރިކުއެސްޓެއް ނޫން",
      "submittedBy": "ހުށަހެޅި ފަރާތް",
      "submitted": "ހުށަހެޅި",
      "currentStep": "މިހާރުގެ ފިޔަވަޅު",
      "stepOf": "{total} ގެ ތެރެއިން {current}",
      "decided": "ނިންމި",
      "comment": "ކޮމެންޓް",
      "chainHeading": "ފާސްކުރުމުގެ ތަރުތީބު",
      "historyHeading": "ތާރީޚް",
      "historyEmpty": "ހުށަހެޅި ފަހުން މި ރިކުއެސްޓަށް އެއްވެސް ކަމެއް ވެފައެއް ނުވެއެވެ.",
      "decidedBy": "ނިންމި",
      "delegatedBy": "{name} ހަވާލުކުރި",
      "forBehalf": "{name} ގެ ފަރާތުން",
      "stepMeta": "ފިޔަވަޅު {step}"
    },
    "errors": {
      "stale": "އެހެން ފަރާތަކުން ކުރިން މިކަން ނިންމައިފިއެވެ، އެހެންކަމުން ތިޔަ ފަރާތުގެ ނިންމުން ރެކޯޑެއް ނުވިއެވެ. އިންބޮކްސް އަލުން ލޯޑްކުރެވިއްޖެއެވެ.",
      "selfApproval": "މި ރިކުއެސްޓް ހުށަހެޅީ ތިޔަ ފަރާތުންނެވެ، އެހެންކަމުން ތިޔަ ފަރާތަކަށް މިއެއް ފާހެއް ނުކުރެވޭނެއެވެ. މަސްއޫލިއްޔަތު ވަކިކުރުމުގެ އުޞޫލުން އެހެން ފަރާތެއް ބޭނުންވެއެވެ."
    },
    "taskStatus": {
      "pending": "އިންތިޒާރުގައި",
      "approved": "ފާސްކުރެވިއްޖެ",
      "rejected": "ބޭރުކުރެވިއްޖެ",
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "delegated": "ހަވާލުކުރެވިފައި",
      "skipped": "ދޫކޮށްލެވިފައި",
      "expired": "މުއްދަތު ހަމަވެފައި"
    },
    "assignee": {
      "anyoneInRole": "{role} ގެ ކޮންމެ ފަރާތެއް",
      "userById": "ބޭނުންކުރާ ފަރާތް #{id}",
      "unassigned": "ހަވާލުކޮށްފައެއް ނުވޭ"
    },
    "document": {
      "fallback": "{docType} #{docId}",
      "genericType": "ލިޔުން",
      "types": {
        "liabilitySettings": "ލައިބިލިޓީ ބްރޭކޭޖް ޕޮލިސީ ބަދަލު"
      }
    },
    "reroute": {
      "lead": "މި ލިޔުން އޮތީ ފާސްކުރުމުގެ {cycle} ވަނަ ސައިކަލްގައެވެ. ބަދަލުކުރުމުން ކުރީގެ ސިލްސިލާ ބާޠިލުކުރެވުނެވެ.",
      "cycle": "ސައިކަލް {cycle}",
      "foot": "ބާޠިލުކުރެވުނު ސައިކަލްގައި ދެވުނު ފާސްކުރުންތައް ނިސްބަތްވަނީ މި ލިޔުމުގެ އެހެން ވަރޜަނަކަށެވެ، އެހެންވެ އެ ފާސްކުރުންތައް ކުރިއަށް ނުގެންދެވުނެވެ."
    },
    "emergency": {
      "action": "ކުއްލި ފާސްކުރުން",
      "title": "ސިލްސިލާއިން ބޭރުން ފާސްކުރޭ",
      "consequence": "މިއީ ޢާންމު ސިލްސިލާގެ ކުރިން ލިޔުން ފާސްކުރުމެވެ. ތިޔަބޭފުޅާގެ ނަމުގައި ރެކޯޑްކުރެވެއެވެ، ތިރީގައިވާ މުއްދަތުގެ ތެރޭގައި އެހެން މީހަކު ތަޞްދީޤުކުރަންޖެހެއެވެ، އަދި އެކަން ނުވަނީސް އިތުރު ކުއްލި ފާސްކުރުމެއް ނުހެދޭނެއެވެ.",
      "reason": "ސިލްސިލާ ފަހަނައަޅާ ދާ ސަބަބު",
      "ratifyWithin": "ތަޞްދީޤުކުރަންޖެހޭ މުއްދަތު (ގަޑިއިރު)",
      "ratifyWithinHint": "މީގެ ފަހުން، މި ފާސްކުރުން ތަޞްދީޤުނުވާ ކިޔޫއަށް އަރައެވެ.",
      "confirm": "ކުއްލި ފާސްކުރުމެއްގެ ގޮތުގައި ފާސްކުރޭ",
      "raised": "ކުއްލި ފާސްކުރުން ރެކޯޑްކުރެވިއްޖެ",
      "outstanding": "ކުރީގެ ކުއްލި ފާސްކުރުމެއް އަދި ތަޞްދީޤުނުވެއެވެ. އިތުރު އެއްޗެއް ހެދުމުގެ ކުރިން އެކަން ނިންމަންޖެހެއެވެ."
    },
    "writeOffPreview": {
      "heading": "ރައިޓް-އޮފް",
      "noAccess": "ތިޔަބޭފުޅާއަށް ރައިޓް-އޮފްތައް ނުކިޔެވޭތީ ތަފްޞީލު މިތާނގައި ނުދައްކާނެ. މަތީގައިވާ އަދަދަކީ އެދުމުގެ އަމިއްލަ އަދަދެވެ.",
      "loadFailed": "ރައިޓް-އޮފް ލޯޑެއް ނުވި",
      "customer": "ކަސްޓަމަރު",
      "reason": "ސަބަބު",
      "total": "ރައިޓް-އޮފްކުރި ޖުމްލަ",
      "provisionUsed": "ޕްރޮވިޝަނުން ފޫބައިފައި",
      "expense": "ބެޑް ޑެބްޓަށް ޗާޖްކުރި",
      "taxRelief": "ޓެކްސް ރިލީފް",
      "evidenceComplete": "ހެކި އެޓޭޗްކޮށްފައި ({count})",
      "evidenceMissing": "ހެކި ނުފުރިހަމަ",
      "invoice": "އިންވޮއިސް",
      "dueDate": "ދައްކަންޖެހޭ ތާރީޚް",
      "dunning": "ޑަނިންގ ނޯޓިސް",
      "amount": "އަދަދު",
      "open": "ރައިޓް-އޮފް ހުޅުވާ"
    },
    "writeOffSettingsPreview": {
      "heading": "ރައިޓް-އޮފް ތްރެޝޯލްޑް",
      "loadFailed": "ތްރެޝޯލްޑް ލޯޑެއް ނުވި",
      "threshold": "ތްރެޝޯލްޑް",
      "inForce": "އަމަލުގައިވާ",
      "requested": "އެދިފައިވާ",
      "none": "ނެތް",
      "pending": "ނިންމުމަށް އިންތިޒާރުކުރަނީ",
      "requestedBy": "ޔޫޒަރ {id} އެދިފައި.",
      "open": "ތްރެޝޯލްޑް ހުޅުވާ"
    }
  },
  "audit": {
    "explorer": {
      "title": "އޮޑިޓް އެކްސްޕްލޯރަރ",
      "description": "ކޮންމެ ބަދަލެއް، އެ ބަދަލު ގެނައި ފަރާތާއި ވަގުތު. ލޮގަކީ ހޭޝް-ޗެއިންކޮށްފައިވާ އެއްޗެއް ކަމުން، އިދާރީ ފަރާތަކަށްވެސް އެޑިޓް ނުވަތަ ޑިލީޓެއް ނުކުރެވޭނެއެވެ.",
      "verify": "ޗެއިން ޔަގީންކުރޭ",
      "export": "ހެކީގެ އެކްސްޕޯޓް",
      "loadFailed": "އޮޑިޓް ލޮގް ލޯޑެއް ނުވި",
      "tableLabel": "އޮޑިޓް ލޮގް",
      "emptyTitle": "ގުޅޭ އޮޑިޓް އެންޓްރީއެއް ނެތް",
      "emptyDescription": "މި ވޯކްސްޕޭސްގައި ކުރެވޭ ކޮންމެ އުފެއްދުމެއް، އަޕްޑޭޓެއް، ޑިލީޓެއް، ފާސްކުރުމެއް، ސައިން އިން ވުމެއް އަދި އެކްސްޕޯޓެއް ލޮގްގައި ރެކޯޑްކުރެއެވެ. އެންމެފަހުގެ ޙަރަކާތް ބެލުމަށް ތާރީޚުގެ މުއްދަތު ފުޅާކުރޭ، ނުވަތަ ފިލްޓަރތައް ސާފުކުރޭ.",
      "retryActions": "ޢަމަލުތަކުގެ ލިސްޓް އަލުން ލޯޑްކުރޭ",
      "columns": {
        "when": "ކޮންއިރަކު",
        "who": "ކާކު",
        "action": "ޢަމަލު",
        "record": "ރެކޯޑް",
        "note": "ނޯޓް"
      },
      "filters": {
        "entityLabel": "ރެކޯޑްގެ ބާވަތް",
        "entityHint": "ޓޭބަލްގެ ނަން، މިސާލަކަށް users ނުވަތަ journal_entries",
        "entityPlaceholder": "ކޮންމެ ބާވަތެއް",
        "entityIdLabel": "ރެކޯޑް އައިޑީ",
        "entityIdHint": "އެ ޓޭބަލްގެ އެއް ރޯއަށް ހަނިކުރެއެވެ",
        "entityIdPlaceholder": "ކޮންމެ ރެކޯޑެއް",
        "actionLabel": "ޢަމަލު",
        "actionPlaceholder": "ކޮންމެ ޢަމަލެއް",
        "actionsFailed": "ޢަމަލުތަކުގެ ލިސްޓް ލޯޑެއް ނުވި. ތިރިން އަލުން މަސައްކަތްކުރޭ.",
        "actorLabel": "ޢަމަލުކުރި ފަރާތް",
        "actorPlaceholder": "ކޮންމެ ފަރާތެއް",
        "fromLabel": "ފެށޭ",
        "toLabel": "ނިމޭ",
        "businessDateHint": "{zone} ގެ ވިޔަފާރި ތާރީޚް",
        "docNoLabel": "ލިޔުމުގެ ނަންބަރު",
        "docNoHint": "ސީދާ އެއްގޮތް، މިސާލަކަށް INV-2026-000123",
        "docNoPlaceholder": "ކޮންމެ ލިޔުމެއް"
      }
    },
    "chain": {
      "okTitle": "ޗެއިން ފުރިހަމަ.",
      "okBody": "ހުރިހާ {rows} އެންޓްރީއެއް އޭގެ ކުރީގެ ހޭޝްއާ ދިމާވެއެވެ. މި ވޯކްސްޕޭސްގެ އޮޑިޓް ލޮގުން އެއްވެސް އެއްޗެއް ބަދަލުކޮށްފައެއް ނުވެއެވެ.",
      "brokenTitle": "ޗެއިން ބުރިވެފައި.",
      "brokenBody": "{rows} ގެ ތެރެއިން އެންޓްރީ #{firstBadId} ގައި ޔަގީންކުރުން ނާކާމިޔާބުވިއެވެ. މި ވޯކްސްޕޭސްގެ ލޮގަކީ ސަލާމަތްކަން ގެއްލިފައިވާ އެއްޗެއް ކަމަށް ބަލައި، ވަގުތުން މަތީ ފަރާތަށް އަންގާ.",
      "verifyFailed": "ޗެއިން ޔަގީނެއް ނުކުރެވުނު"
    },
    "attestation": {
      "title": "ހެކީގެ ތަޞްދީޤު",
      "description": "މި އަދަދުތައް ސީއެސްވީއާއެކު އޮޑިޓަރަށް ދޭ. ޗެއިން ހޭޝްއަކީ އެކްސްޕޯޓްކުރި ރޯތަކުގެ ހޭޝްތަކުގެ މައްޗަށް ހަދާފައިވާ SHA-256 އެކެވެ.",
      "missing": "ސާވަރުން ފައިލް ދިން ނަމަވެސް ތަޞްދީޤުގެ ހެޑަރތައް ނުދިނެވެ، އެހެންކަމުން މި ބަނޑްލްގައި ފުރިހަމަކަމުގެ ހެއްކެއް ނެތެވެ. އެކްސްޕޯޓް އަލުން ހިންގާ؛ އަދިވެސް އެހެންވާނަމަ، ލޮގް ފުރިހަމަކަމުގައި ވިޔަސް، މި ފައިލް ހެއްކެއްގެ ގޮތުގައި ހުށަހަޅައިގެން ނުވާނެއެވެ.",
      "rows": "އެކްސްޕޯޓްކުރި ރޯތައް",
      "firstEntry": "ފުރަތަމަ އެންޓްރީ",
      "lastEntry": "ފަހު އެންޓްރީ",
      "chainHash": "ޗެއިން ހޭޝް",
      "exported": "{count} ރޯ އެކްސްޕޯޓްކުރެވިއްޖެ",
      "exportedDetail": "ޗެއިން ތަޞްދީޤު ސްކްރީނުގައި އެބައޮތެވެ — ފައިލާއެކު އޮޑިޓަރަށް ދޭ.",
      "withoutTitle": "ތަޞްދީޤަކާ ނުލައި އެކްސްޕޯޓްކުރެވިއްޖެ",
      "withoutDetail": "ސާވަރުން ޗެއިން ހެޑަރތައް ނުދިނުމުން، މި ފައިލް ޗެއިންއާ އަޅާކިޔައި ސާބިތެއް ނުކުރެވޭނެއެވެ.",
      "exportFailed": "ހެކީގެ އެކްސްޕޯޓް ނާކާމިޔާބުވި"
    },
    "entry": {
      "fallbackTitle": "އޮޑިޓް އެންޓްރީ",
      "recordFallback": "{entity} #{entityId}",
      "entryNumber": "އެންޓްރީ #{id}",
      "when": "ކޮންއިރަކު",
      "who": "ކާކު",
      "whoWithType": "{actor} ({actorType})",
      "record": "ރެކޯޑް",
      "note": "ނޯޓް",
      "from": "ފެށޭ",
      "client": "ކްލައިންޓް",
      "diffHeading": "ބަދަލުވީ ކޮންއެއްޗެއް",
      "diffEmpty": "މި ޢަމަލުގައި އެއްވެސް ފީލްޑެއްގެ އަގު ރެކޯޑްކޮށްފައެއް ނުވެއެވެ — މިއީ ޙާދިސާއެކެވެ، އެޑިޓެއް ނޫނެވެ.",
      "field": "ފީލްޑް",
      "before": "ކުރިން",
      "after": "ފަހުން",
      "chainHeading": "ޗެއިން",
      "thisRow": "މި ރޯ",
      "previous": "ކުރީގެ",
      "firstRow": "މި ވޯކްސްޕޭސްގެ ފުރަތަމަ ރޯ"
    },
    "trail": {
      "loading": "ރެކޯޑްގެ ތާރީޚް ލޯޑްވަނީ",
      "emptyTitle": "ރެކޯޑްކޮށްފައިވާ ޙަރަކާތެއް ނެތް",
      "emptyDescription": "މި ރެކޯޑަށް ގެނެވޭ ކޮންމެ ބަދަލެއް ހޭޝް-ޗެއިންކޮށްފައިވާ އޮޑިޓް ލޮގްގައި ލިޔެވެއެވެ. އަދި މިއާ ގުޅޭ އެއްވެސް އެއްޗެއް ރެކޯޑްކޮށްފައެއް ނުވެއެވެ.",
      "actorUser": "ބޭނުންކުރާ ފަރާތް #{id}",
      "changed": "ބަދަލުވީ: {fields}"
    },
    "actors": {
      "system": "ސިސްޓަމް ޖޮބް",
      "platformAdmin": "ޕްލެޓްފޯމް ސަޕޯޓް",
      "assistant": "އޭއައި އެސިސްޓަންޓް",
      "unattributed": "ނޭނގޭ ފަރާތެއް",
      "userById": "ބޭނުންކުރާ ފަރާތް #{id}"
    }
  },
  "profile": {
    "title": "ޕްރޮފައިލް އަދި ސެކިއުރިޓީ",
    "tabsLabel": "އެކައުންޓްގެ ބައިތައް",
    "tabs": {
      "profile": "ޕްރޮފައިލް",
      "security": "ސެކިއުރިޓީ",
      "sessions": "ސެޝަންތައް"
    },
    "details": {
      "title": "ތިޔަ ފަރާތުގެ މަޢުލޫމާތު",
      "suspended": "މި ވޯކްސްޕޭސް ސަސްޕެންޑްކޮށްފައިވާތީ، އަލުން ހުޅުވަންދެން ބަދަލު ގެނައުން ހުއްޓުވާފައިވެއެވެ.",
      "timezoneHint": "އައިއޭއެންއޭ ނަން، މިސާލަކަށް Indian/Maldives. ހުސްކޮށް ބާއްވައިފިނަމަ ވޯކްސްޕޭސްގެ ޓައިމްޒޯން ބޭނުންކުރެވޭނެ.",
      "nameBlank": "ތިޔަ ފަރާތުގެ ނަން ހުސްކޮށެއް ނުބޭއްވޭނެއެވެ.",
      "timezoneInvalid": "އެއީ އައިއޭއެންއޭ ޓައިމްޒޯނެއް ނޫނެވެ. Indian/Maldives ނުވަތަ Asia/Colombo ފަދަ ނަމެއް ލިޔޭ.",
      "localeInvalid": "ބޭނުންކުރެވޭ ބަސްތަކުގެ ތެރެއިން ބަހެއް އިޚްތިޔާރުކުރޭ.",
      "saved": "ޕްރޮފައިލް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "އެ ރައްކާއެއް ނުވި"
    },
    "account": {
      "title": "އެކައުންޓް",
      "memberSince": "ބައިވެރިވި ތާރީޚް",
      "firstSignIn": "މިއީ ތިޔަ ފަރާތުގެ ފުރަތަމަ ފަހަރު"
    },
    "password": {
      "title": "ޕާސްވޯޑް ބަދަލުކުރޭ",
      "currentLabel": "މިހާރުގެ ޕާސްވޯޑް",
      "newHint": "މަދުވެގެން 12 އަކުރު. ދިގުވުން، ޚާއްޞަ ފާހަގަތަކަށްވުރެ ރަނގަޅު.",
      "submit": "ޕާސްވޯޑް ބަދަލުކުރޭ",
      "changed": "ޕާސްވޯޑް ބަދަލުކުރެވިއްޖެ",
      "changedDetail": "އެހެން ސެޝަންތައް ސައިން އައުޓްކުރެވިއްޖެ.",
      "failed": "ޕާސްވޯޑް ބަދަލެއް ނުކުރެވުނު"
    },
    "mfa": {
      "title": "ޓޫ-ފެކްޓަރ އޮތެންޓިކޭޝަން",
      "description": "ފައިސާ ދެއްކުމާއި، ބޭންކުގެ މަޢުލޫމާތާއި، މުއްދަތު ބަންދުކުރުމުގެ ޢަމަލުތަކަށް ދެވަނަ ފިޔަވަޅެއް ލާޒިމެވެ.",
      "enabled": "ދިއްލާފައި",
      "notSetUp": "ސެޓަޕްކޮށްފައެއް ނުވޭ",
      "explanation": "އޮތެންޓިކޭޓަރ އެޕެއް ރަޖިސްޓަރީކޮށްފައިވާނަމަ، ސައިން އިން ވުމުގައި ޕާސްވޯޑާއެކު ހަ އަދަދުގެ ކޯޑަކަށްވެސް އެދޭނެއެވެ، އަދި ނާޒުކު ޢަމަލުތަކުގައި އަލުން އެދިދާނެއެވެ.",
      "setUp": "އޮތެންޓިކޭޓަރ ސެޓަޕްކުރޭ",
      "turnOff": "ޓޫ-ފެކްޓަރ ނިއްވާލާ",
      "disableTitle": "ޓޫ-ފެކްޓަރ އޮތެންޓިކޭޝަން ނިއްވާލާ",
      "disableDescription": "ތިޔަ ފަރާތުގެ ޕާސްވޯޑާއި މިހާރުގެ ކޯޑަކުން ޔަގީންކުރޭ.",
      "currentCodeLabel": "މިހާރުގެ ކޯޑް",
      "keepOn": "ދިއްލާފައި ބާއްވާ",
      "disableSubmit": "ނިއްވާލާ",
      "disabling": "ނިއްވާލަނީ",
      "disabled": "ޓޫ-ފެކްޓަރ އޮތެންޓިކޭޝަން ނިއްވާލެވިއްޖެ",
      "disabledDetail": "ތިޔަ ފަރާތުގެ އެކައުންޓް މިހާރު ބަރޯސާވަނީ ހަމައެކަނި ޕާސްވޯޑަށެވެ.",
      "disableFailed": "އެމްއެފްއޭ ނިއްވައެއް ނުލެވުނު",
      "stepUpReason": "ތިޔަ ފެށި ޢަމަލަކަށް ދެވަނަ ފެކްޓަރެއް ބޭނުންވާތީ މިތަނަށް ފޮނުވުނީއެވެ. އޮތެންޓިކޭޓަރެއް ސެޓަޕްކޮށްފައި، އެނބުރި ގޮސް އަލުން މަސައްކަތްކުރޭ."
    },
    "sessions": {
      "loadFailed": "ތިޔަ ފަރާތުގެ ސެޝަންތައް ލޯޑެއް ނުވި",
      "title": "ސައިން އިން ވެފައިވާ ތަންތަން",
      "description": "ސެޝަނެއް ބާޠިލުކުރުމުން އެ ޑިވައިސް ވަގުތުން ސައިން އައުޓްވާނެއެވެ.",
      "emptyTitle": "އެހެން ސެޝަނެއް ނެތް",
      "emptyDescription": "ތިޔަ ފަރާތުގެ އެކައުންޓަށް ސައިން އިން ވެފައިވަނީ ހަމައެކަނި މި ބްރައުޒަރެވެ.",
      "unnamedDevice": "ނަން ނެތް ޑިވައިސް",
      "thisDevice": "މި ޑިވައިސް",
      "unknownAddress": "ނޭނގޭ އެޑްރެސް",
      "lastUsed": "އެންމެފަހުން ބޭނުންކުރި",
      "revoked": "ސެޝަން ބާޠިލުކުރެވިއްޖެ",
      "revokedDetail": "އެ ޑިވައިސް އަލުން ސައިން އިން ވާން ޖެހޭނެއެވެ.",
      "revokeFailed": "ސެޝަން ބާޠިލެއް ނުކުރެވުނު"
    }
  },
  "mfaEnrol": {
    "title": "ޓޫ-ފެކްޓަރ އޮތެންޓިކޭޝަން ސެޓަޕްކުރޭ",
    "description": "އޮތެންޓިކޭޓަރ އެޕަކުން ކޮންމެ 30 ސިކުންތަކުން އައު ހަ އަދަދުގެ ކޯޑެއް އުފައްދައެވެ.",
    "qrAlt": "އޮތެންޓިކޭޓަރ ސެޓަޕް ކީ ހިމެނޭ ކިއުއާރް ކޯޑް",
    "scanHint": "Google Authenticator، 1Password، Aegis ނުވަތަ އެހެންވެސް TOTP އެޕަކުން މި ސްކޭންކުރޭ.",
    "secretLabel": "ނުވަތަ މި ކީ އަތުން ލިޔޭ",
    "secretHint": "ހުސްތަންތަން ނުލައި، ސީދާ އެގޮތަށް ލިޔޭ.",
    "secretAria": "ސެޓަޕް ކީ",
    "codeLabel": "އެޕުން ލިބޭ ކޯޑް",
    "codePlaceholder": "000000",
    "verify": "ޔަގީންކޮށް ދިއްލާ",
    "verifying": "ޔަގީންކުރަނީ",
    "recoveryWarning": "މި ރިކަވަރީ ކޯޑްތައް ދައްކާނީ އެންމެ ފަހަރަކުއެވެ. ފޯނު ގެއްލިއްޖެނަމަ ކޮންމެ ކޯޑަކުން އެއް ފަހަރު ސައިން އިން ވެވޭނެއެވެ. ޕާސްވޯޑެއް ރައްކާކުރާ ފަދައިން މި ކޯޑްތައް ރައްކާކުރޭ.",
    "acknowledge": "މި ރިކަވަރީ ކޯޑްތައް ރައްކާތެރި ތަނެއްގައި ބަހައްޓައިފިން",
    "codesFileHeading": "އެންޓަރޕްރައިޒްއޭއައި އީއާރްޕީ ކްލައުޑްގެ ރިކަވަރީ ކޯޑްތައް",
    "codesFileAccount": "އެކައުންޓް: {email}",
    "copied": "ރިކަވަރީ ކޯޑްތައް ކޮޕީކުރެވިއްޖެ",
    "copiedDetail": "ހަމައެކަނި ތިޔަ ފަރާތަށް ފޯރާ ތަނެއްގައި ޕޭސްޓްކުރޭ.",
    "copyBlocked": "ކޮޕީކުރުން ހުއްޓުވިއްޖެ",
    "copyBlockedDetail": "އޭގެ ބަދަލުގައި ޑައުންލޯޑް ބޭނުންކުރޭ، ނުވަތަ ކޯޑްތައް އަތުން ހޮވާ.",
    "startFailed": "ރަޖިސްޓަރީވުން ނުފެށުނު",
    "codeRejected": "އެ ކޯޑް ޤަބޫލެއް ނުކުރެވުނު"
  },
  "stepUp": {
    "title": "ތިޔައީ ތިޔަ ފަރާތްކަން ޔަޤީންކުރޭ",
    "reasons": {
      "payment": "ސަޕްލަޔަރުންނަށް ފައިސާ ދެއްކުމަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ.",
      "bankApprove": "ސަޕްލަޔަރެއްގެ ބޭންކުގެ މަޢުލޫމާތު ބަދަލުކުރުން ފާސްކުރުމަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ.",
      "reveal": "އެކައުންޓް ނަންބަރު ފުރިހަމައަށް ދެއްކުމަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ.",
      "bankChange": "ސަޕްލަޔަރެއްގެ ބޭންކުގެ މަޢުލޫމާތު ބަދަލުކުރުމަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ.",
      "periodClose": "މުއްދަތެއް ބަންދުކުރުމަށް ނުވަތަ އަލުން ހުޅުވުމަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ.",
      "writeOff": "ރައިޓް-އޮފެއް ޕޯސްޓްކުރުން ނުވަތަ ރިވާސްކުރުން، ނުވަތަ ރައިޓް-އޮފް ތްރެޝޯލްޑް ބަދަލުކުރުމަށް ތިޔަބޭފުޅާގެ އޮތެންޓިކޭޓަރ ބޭނުންވޭ.",
      "generic": "މި ޢަމަލަށް އޮތެންޓިކޭޓަރ ބޭނުންވެއެވެ."
    },
    "description": "އޮތެންޓިކޭޓަރ އެޕުން ހަ އަދަދުގެ ކޯޑް އެތެރެކުރޭ. ކޯޑް ޤަބޫލުކުރެވުމާއެކު ތިޔަ ފެށި މަސައްކަތް ކުރިއަށް ދާނެއެވެ، އަދި އެތެރެކުރި އެއްވެސް އެއްޗެއް ގެއްލިގެން ނުދާނެއެވެ.",
    "codeLabel": "އެޕުން ލިބޭ ކޯޑް",
    "codePlaceholder": "000000",
    "submit": "ޔަގީންކުރޭ",
    "verifying": "ޔަގީންކުރަނީ",
    "waiting": "މިއަށް މަޑުކުރަނީ އެއް ޢަމަލެކެވެ. | މިއަށް މަޑުކުރަނީ {count} ޢަމަލެވެ.",
    "attemptsWarning": "ނުބައި ކޯޑުތައް ގުނަނީ ސައިން އިން ވުމަށް އޮންނަ ހަމަ އެ ލޮކްއައުޓް ހަމައިގެ ތެރެއަށެވެ.",
    "errors": {
      "code": "އެ ކޯޑް ޤަބޫލެއް ނުކުރެވުނެވެ. ދެންމެ މި ކޯޑް ބޭނުންކުރިނަމަ، އެޕުން ދެން ދައްކާ ކޯޑަށް މަޑުކުރޭ.",
      "lockout": "މާ ގިނަ ނުބައި ކޯޑު ޖަހައިފިއެވެ. މި އެކައުންޓް ކުޑަ ވަގުތުކޮޅަކަށް ބަންދުވެއްޖެއެވެ — ސައިން އިން ވުމަށް އޮންނަ ހަމަ އެ ހަމައެވެ.",
      "lockoutUntil": "މާ ގިނަ ނުބައި ކޯޑު ޖަހައިފިއެވެ. {time} ގެ ފަހުން އަލުން މަސައްކަތްކުރޭ.",
      "other": "ކޯޑް ޗެކްކުރެވޭ ގޮތެއް ނުވިއެވެ. ހިނދުކޮޅަކު ފަހުން އަލުން މަސައްކަތްކުރޭ."
    },
    "enrol": {
      "title": "ފުރަތަމަ އޮތެންޓިކޭޓަރ ސެޓަޕްކުރޭ",
      "body": "މި ޢަމަލަށް ދެވަނަ ފެކްޓަރެއް ބޭނުންވެއެވެ، އަދި މި އެކައުންޓުގައި އެއެއް ރަޖިސްޓަރީކޮށްފައެއް ނުވެއެވެ. އޮތެންޓިކޭޓަރ އެޕެއް ސެޓަޕްކުރުމަށް ނަގާނީ މިނިޓެއްހާއިރެވެ، އަދި އެއަށްފަހު މި ޢަމަލު އަލުން ކުރެވިދާނެއެވެ.",
      "action": "ޓޫ-ފެކްޓަރ އޮތެންޓިކޭޝަން ސެޓަޕްކުރޭ",
      "routedTitle": "ކުރިއަށް ދިއުމަށް އޮތެންޓިކޭޓަރެއް ސެޓަޕްކުރޭ",
      "routedDetail": "ތިޔަ ފެށި ޢަމަލަށް ދެވަނަ ފެކްޓަރެއް ބޭނުންވެއެވެ، އަދި މި އެކައުންޓުގައި އަދި އެއެއް ނެތެވެ."
    }
  },
  "errorPages": {
    "forbidden": {
      "title": "އެ ސްކްރީނަށް ތިޔަ ފަރާތަށް ވަދެވޭކަށް ނެތެވެ",
      "description": "{screen} އަށް ބޭނުންވާ ހުއްދަ ތިޔަ ފަރާތުގެ ރޯލްތަކުގައި ނުހިމެނެއެވެ. ސައިން އިން ވެފައިވަނީ {account} ގެ ގޮތުގައި، {roles} އާއެކުއެވެ. ވޯކްސްޕޭސްގެ އިދާރީ ފަރާތަކަށް އެ ހުއްދަ ދެވިދާނެއެވެ.",
      "thatScreen": "އެ ސްކްރީން",
      "thisAccount": "މި އެކައުންޓް",
      "noRoles": "އަދި ރޯލެއް ނެތް",
      "goDashboard": "ޑޭޝްބޯޑަށް ދޭ",
      "seeRoles": "އަހަރެންގެ ރޯލްތައް ބަލާ"
    },
    "notFound": {
      "title": "އެ ޞަފުޙާއެއް ނެތެވެ",
      "description": "{path} ގައި އެއްވެސް އެއްޗެއް ނެތެވެ. ނަން ބަދަލުކުރެވިފައި، ނުވަތަ ލިންކް ބުރިވެފައި އޮވެދާނެއެވެ.",
      "goDashboard": "ޑޭޝްބޯޑަށް ދޭ",
      "search": "ބޭނުންވި އެއްޗެއް ހޯދާ"
    }
  },
  "tax": {
    "kinds": {
      "VAT": "ވެޓް / ޖީއެސްޓީ",
      "WHT": "ހިފެހެއްޓޭ ޓެކްސް",
      "LEVY": "ލެވީ"
    },
    "bases": {
      "percent": {
        "label": "ލައިންގެ އިންސައްތަ",
        "summary": "ޓެކްސް އަކީ ލައިންގެ އަދަދަށް ރޭޓް ބޭނުންކޮށްގެން ނެރޭ އަދަދެވެ."
      },
      "per_unit": {
        "label": "ޔުނިޓަކަށް އަދަދު",
        "summary": "ކޮންމެ ޔުނިޓަކަށް ކަނޑައެޅިފައިވާ އަދަދެއް، މިސާލަކަށް ރެއަކަށް ނަގާ ގްރީން ޓެކްސް."
      }
    },
    "treatments": {
      "standard": {
        "label": "އާންމު ރޭޓް",
        "summary": "މި ކޯޑުގެ ރޭޓުން ޓެކްސް ނަގާ ސަޕްލައި އެކެވެ.",
        "reporting": "ޓެކްސް ނަގާ ވިޔަފާރީގެ ގޮތުގައި ރިޕޯޓްކުރެވޭ، އަދި ނެގުނު ޓެކްސް އެއާއެކު ދެއްކޭ."
      },
      "zero_rated": {
        "label": "ސުމެއް ރޭޓް",
        "summary": "0% އިން ޓެކްސް ނަގާ ސަޕްލައި އެކެވެ. މިއީ އާންމު ކޯޑެއްގައި 0% ރޭޓް ބޭއްވުމާ އެއް އެއްޗެއް ނޫނެވެ.",
        "reporting": "ޓެކްސް ނަގާ ވިޔަފާރީގެ ތެރޭގައި ގުނޭ، އަދި އޭގެ ޚަރަދުތަކުގެ އިންޕުޓް ޓެކްސް އަނބުރާ ހޯދޭގޮތަށް ބާއްވައެވެ."
      },
      "exempt": {
        "label": "އިސްތިސްނާ",
        "summary": "މިއީ ޓެކްސް ނަގާ ސަޕްލައި އެއް ނޫނެވެ.",
        "reporting": "ވަކި ލައިނެއްގައި ރިޕޯޓްކުރެވޭ، އަދި އާންމުކޮށް އެއާ ގުޅޭ އިންޕުޓް ޓެކްސް އަނބުރާ ހޯދުން ހުއްޓުވައެވެ."
      },
      "reverse_charge": {
        "label": "ރިވަރސް ޗާޖް",
        "summary": "ޓެކްސް ދެފަރާތުންވެސް ހިސާބުކުރަނީ ގަންނަ ފަރާތުންނެވެ.",
        "reporting": "ގަންނަ ފަރާތުގެ ރިޓަރނުގައި އައުޓްޕުޓް އަދި އިންޕުޓް ޓެކްސްގެ ގޮތުގައި ދެފަހަރު ދެއްކޭ."
      },
      "out_of_scope": {
        "label": "ދާއިރާއިން ބޭރު",
        "summary": "މުޅިން ޓެކްސްގެ ދާއިރާއިން ބޭރެވެ.",
        "reporting": "ރިޓަރނުގެ އެއްވެސް ބައެއްގައި ނުދެއްކޭ."
      }
    },
    "rounding": {
      "levelLabel": "ފުރިހަމަކުރާ އުޞޫލު",
      "modeLabel": "ބައި ލާރީގައި ނިންމާ ގޮތް",
      "levels": {
        "line": {
          "label": "ކޮންމެ ލައިނެއް ފުރިހަމަކުރޭ",
          "summary": "ކޮންމެ ލައިނެއްގެ ޓެކްސް ލާރިއަކަށް ފުރިހަމަކޮށް، އެއަށްފަހު ލައިންތައް އެއްކުރެވެއެވެ."
        },
        "document": {
          "label": "ލިޔުން ފުރިހަމަކުރޭ",
          "summary": "ފުރަތަމަ ލައިންތައް އެއްކޮށް، ލިޔުމުގެ ޓެކްސް އެއްފަހަރު ފުރިހަމަކުރެވެއެވެ."
        }
      },
      "modes": {
        "half_up": {
          "label": "ބައި މައްޗަށް",
          "summary": "ސީދާ ބައި ލާރިއެއް ސުމަކުން ދުރަށް ފުރިހަމަކުރެވެއެވެ. ގިނަ ޤާނޫނުތަކުގައި ބުނަނީ މިހެންނެވެ."
        },
        "half_even": {
          "label": "ބައި ހަމަ ޢަދަދަށް",
          "summary": "ސީދާ ބައި ލާރިއެއް އެންމެ ކައިރި ހަމަ ލާރިއަށް ފުރިހަމަކުރެވެއެވެ. މިގޮތުން އެތައް ހާސް ލައިނެއްގައި ޖުމުލަތައް މައްޗަށް ނުދެއެވެ."
        }
      },
      "exampleIntro": "މިސާލެއް: {line} ގެ {count} ލައިން، {rate}% އިން.",
      "tableCaption": "ކޮންމެ ފުރިހަމަކުރާ އުޞޫލެއްގެ ދަށުން އެއް ތިން ލައިން",
      "columns": {
        "policy": "އުޞޫލު",
        "working": "ހިސާބު",
        "total": "ލިޔުމުގެ ޓެކްސް"
      },
      "lineWorking": "{line} × {rate}% = {raw} → {count} ލައިނުގެ ކޮންމެ އެއްޗަކަށް {each}",
      "documentWorking": "{document} × {rate}% = {raw}، އެއްފަހަރު ފުރިހަމަކުރެވިފައި",
      "chosen": "ހޮވިފައި",
      "agree": "{rate}% ގައި ދެ އުޞޫލު އެއްގޮތްވެއެވެ. އެހެންކަމުން މިއަދު މި ހޮވުމުން ބަދަލެއް ނާދެއެވެ. ހަމަހަމައަށް ބެހިގެން ނުދާ ރޭޓެއްގައި މުހިންމުވާނެއެވެ.",
      "differ": "ދެ އުޞޫލުގެ ދެމެދުގައި ތަފާތަކީ",
      "applied": "މި ކޯޑު ބޭނުންކުރަނީ {policy}، އެހެންވެ ޕޯސްޓްކުރާނީ {total} އެވެ."
    },
    "tabs": {
      "label": "ޓެކްސް ސެޓަޕްގެ ބައިތައް",
      "codes": "ކޯޑުތައް",
      "coverage": "ފުރިހަމަކަން",
      "groups": "ގްރޫޕުތައް",
      "preview": "ކުރިން ބަލާލުން"
    },
    "list": {
      "title": "ޓެކްސް ކޯޑުތައް",
      "description": "ކޮންމެ ރޮނގަކީ ކޯޑެއްގެ އެއް ވަރޝަނެވެ. ރޭޓް ބަދަލުވުމަކީ އައު ވަރޝަނެކެވެ. އެހެންކަމުން ކުރީގެ ރޭޓުގެ ދަށުން ތާރީޚު ޖެހިފައިވާ ލިޔުންތައް އެ ރޭޓަށް ދެމިއޮވެއެވެ.",
      "tableLabel": "ޓެކްސް ކޯޑު ވަރޝަންތައް",
      "loadFailed": "ޓެކްސް ކޯޑުތައް ނުލޯޑްވިއެވެ",
      "newCode": "އައު ޓެކްސް ކޯޑު",
      "createFirst": "ފުރަތަމަ ޓެކްސް ކޯޑު އުފައްދާ",
      "emptyTitle": "އަދި ޓެކްސް ކޯޑެއް ނެތެވެ",
      "emptyDescription": "ޓެކްސް ކޯޑަކުން ރޭޓާއި، ޕޯސްޓްކުރާ އެކައުންޓުތަކާއި، އަމަލުކުރާ ތާރީޚުތައް ކަނޑައަޅައެވެ. ދިވެހިރާއްޖޭގެ ލޯކަލައިޒޭޝަން ޕެކުން ޖީޖީއެސްޓީ، ޓީޖީއެސްޓީ އަދި ގްރީން ޓެކްސް އިތުރުކުރެއެވެ. އެއިން ނުހިމެނޭ އެއްޗެއް އަމިއްލައަށް އިތުރުކުރައްވާ.",
      "searchPlaceholder": "ކޯޑު ނުވަތަ ނަން ހޯއްދަވާ",
      "searchLabel": "ޓެކްސް ކޯޑުތައް ހޯއްދަވާ",
      "filterByKind": "ބާވަތުން ފިލްޓަރކުރޭ",
      "onDateLabel": "އަމަލުކުރާ ތާރީޚު",
      "onDateHint": "ދައްކަނީ އެ ދުވަހު އަމަލުކުރާ ވަރޝަންތައް އެކަންޏެވެ.",
      "columns": {
        "code": "ކޯޑު",
        "kind": "ބާވަތް",
        "treatment": "ޓެކްސް ބާވަތް",
        "rate": "ރޭޓް",
        "effective": "އަމަލުކުރާ މުއްދަތު",
        "rounding": "ފުރިހަމަކުރުން",
        "status": "ޙާލަތު"
      },
      "roundingSummary": "{level}، ބައި {mode}",
      "windowOpen": "{from} އިން ފެށިގެން",
      "windowClosed": "{from} އިން {to} އަށް",
      "active": "ހިނގަމުންދާ",
      "inactive": "ހުއްޓިފައި",
      "truncated": "ކިޔުނީ ފުރަތަމަ ހާސްބައެއް ވަރޝަން އެކަނި ކަމުން، ތިރީގައިވާ ފުރިހަމަކަމުގެ ބެލުން ފުރިހަމަ ނުވެދާނެއެވެ.",
      "coverageWarning": "{count} ޓެކްސް ކޯޑުގެ ވަރޝަންތަކުގެ ދެމެދުގައި ހުސްތަނެއް ނުވަތަ ފުށުއެރުމެއް އެބައޮތެވެ. | {count} ޓެކްސް ކޯޑުގެ ވަރޝަންތަކުގެ ދެމެދުގައި ހުސްތަނެއް ނުވަތަ ފުށުއެރުމެއް އެބައޮތެވެ.",
      "coverageLink": "ފުރިހަމަކަމުގެ ޓައިމްލައިންތައް ދައްކާ",
      "export": {
        "done": "ޓެކްސް ކޯޑުތައް އެކްސްޕޯޓްކުރެވިއްޖެ",
        "failed": "އެކްސްޕޯޓް ފުރިހަމައެއް ނުވިއެވެ",
        "effectiveFrom": "އަމަލުކުރަން ފަށާ",
        "effectiveTo": "އަމަލުކުރުން ނިމޭ",
        "inputAccount": "އިންޕުޓް އެކައުންޓް",
        "outputAccount": "އައުޓްޕުޓް އެކައުންޓް",
        "payableAccount": "ދައްކަންޖެހޭ އެކައުންޓް",
        "roundingMode": "ފުރިހަމަކުރާ ގޮތް"
      }
    },
    "timeline": {
      "label": "{code} ގެ ވަރޝަން ތާރީޚު",
      "windowOpen": "{from} އިން ފެށިގެން، ނިމުމެއް ނެތި",
      "windowClosed": "{from} އިން {to} އަށް",
      "status": {
        "inForce": "މިއަދު އަމަލުކުރެވޭ",
        "scheduled": "ކުރިއަށް ރޭވިފައި",
        "ended": "ނިމިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "issue": {
        "gap": "ފުރިހަމަކަމުގައި ހުސްތަނެއް",
        "overlap": "ފުށުއަރާ ވަރޝަންތައް",
        "ends": "ފުރިހަމަކަން ނިމިއްޖެ"
      },
      "gapDetail": "{days} ދުވަހަށް، {from}، {code} އަށް އެއްވެސް ރޭޓެއް ނުލިބެއެވެ. އެ ތާރީޚުގައި ލިޔުމެއް ޕޯސްޓެއް ނުކުރެވޭނެއެވެ. | {days} ދުވަހަށް، {from} އިން {to} އަށް، {code} އަށް އެއްވެސް ރޭޓެއް ނުލިބެއެވެ. އެ މުއްދަތުގައި ލިޔުމެއް ޕޯސްޓެއް ނުކުރެވޭނެއެވެ.",
      "overlapDetail": "{from} އިން {to} އަށް {code} ގެ ދެ ވަރޝަން އެއްފަހަރާ އަމަލުކުރެއެވެ. އެހެންކަމުން އެ ދުވަސްތަކުގެ ރޭޓް ސާފެއް ނޫނެވެ.",
      "overlapDetailOpen": "{from} ގައި ދެން އަންނަ ވަރޝަން ފެށޭއިރު {code} ގެ ނިމުމެއް ނެތް ވަރޝަނެއް އަދިވެސް އަމަލުކުރެއެވެ. އޭގެ ކުރީ ދުވަހު އެ ބަންދުކުރައްވާ.",
      "endsDetail": "{on} ގެ ފަހުން {code} އެއްވެސް ދުވަހެއް ނުހިމަނައެވެ. އޭގެ ފަހުގެ ތާރީޚެއްގެ ލިޔުމަކަށް ރޭޓެއް ނުލިބޭނެއެވެ."
    },
    "coverage": {
      "emptyTitle": "ބަލާނެ ޓެކްސް ކޯޑެއް ނެތެވެ",
      "emptyDescription": "ކޯޑެއް އުފެދުމުން، އޭގެ ވަރޝަންތަކުގައި ހުސްތަނާއި ފުށުއެރުން ހުރިތޯ މިތާ ބެލެވޭނެއެވެ.",
      "inForce": "{date} ގައި ވަރޝަނެއް އަމަލުކުރެއެވެ.",
      "noneInForce": "{date} ގައި އެއްވެސް ވަރޝަނެއް އަމަލެއް ނުކުރެއެވެ.",
      "addVersion": "{code} ގެ ވަރޝަނެއް އިތުރުކުރޭ"
    },
    "editor": {
      "createTitle": "އައު ޓެކްސް ކޯޑު ވަރޝަން",
      "createDescription": "ޤާނޫނީ ރޭޓް ބަދަލުވުމަކީ އައު ވަރޝަނެކެވެ؛ އެޑިޓެއް ނޫނެވެ. ފެށޭ ތާރީޚެއް ދެއްވާ، އަދި ކުރީގެ ވަރޝަން އޭގެ ކުރީ ދުވަހު ބަންދުކުރައްވާ.",
      "editTitle": "{code} އެޑިޓްކުރޭ",
      "editDescription": "ކޯޑާއި، ބާވަތާއި، ދާއިރާއާއި، ފެށޭ ތާރީޚުން މި ވަރޝަން ފާހަގަކުރެވެއެވެ. އެއިން އެއްޗެއް ބަދަލެއް ނުކުރެވޭނެއެވެ؛ ބަދަލުކުރުމުން މީގެ ދަށުން ހިނގި ލިޔުންތައް ބަދަލުވެދާނެއެވެ.",
      "fields": {
        "code": "ކޯޑު",
        "codeHint": "ކުރު އަދި ބަދަލުނުވާ، މިސާލަކަށް GGST ނުވަތަ TGST.",
        "codeLocked": "ވަރޝަން ފާހަގަކުރެއެވެ؛ އެޑިޓެއް ނުކުރެވޭނެއެވެ.",
        "name": "ނަން",
        "kind": "ބާވަތް",
        "kindHint": "ހިފެހެއްޓޭ ޓެކްހާއި ލެވީތައް ޕޯސްޓްވަނީ ޖީއެސްޓީއާ ތަފާތުކޮށެވެ.",
        "jurisdiction": "ދާއިރާ",
        "jurisdictionHint": "ދެ އަކުރުގެ ޤައުމީ ކޯޑު، މިސާލަކަށް MV.",
        "jurisdictionLocked": "ވަރޝަން ފާހަގަކުރެއެވެ؛ އެޑިޓެއް ނުކުރެވޭނެއެވެ.",
        "treatment": "ޓެކްސް ބާވަތް",
        "basis": "ހިސާބުކުރާ ގޮތް",
        "rate": "ރޭޓް",
        "rateHint": "8.75% އަށް 8.75 ލިޔުއްވާ.",
        "rateRange": "އިންސައްތަ 0 އާއި 100 އާ ދެމެދު ހުންނަންވާނެއެވެ.",
        "rateNotApplicable": "މި ބާވަތުގައި ރޭޓެއް ނުހިމެނެއެވެ. މިއީ ސުމެއްގެ ރޭޓަކާ ތަފާތު ކަމެކެވެ.",
        "amountPerUnit": "ޔުނިޓަކަށް އަދަދު",
        "amountPerUnitHint": "ކޮންމެ ޔުނިޓަކަށް ނަގާ ކަނޑައެޅިފައިވާ އަދަދު.",
        "unitCurrency": "ޔުނިޓް ފައިސާ",
        "unitCurrencyHint": "ޔުނިޓަކަށް ނަގާ ލެވީއެއްގައި، އެ އަދަދު ހުރީ ކޮން ފައިސާއަކުންކަން ބުނަންޖެހެއެވެ.",
        "unitLabel": "ޔުނިޓްގެ ނަން",
        "unitLabelHint": "އެއް ޔުނިޓަކީ ކޮބައިކަން، މިސާލަކަށް ރޭ.",
        "effectiveFrom": "އަމަލުކުރަން ފަށާ",
        "effectiveFromHint": "މި ވަރޝަނަށް ލިޔުންތައް ރުޖޫޢަވާން ފަށާ ފުރަތަމަ ދުވަސް.",
        "effectiveFromLocked": "ވަރޝަން ފާހަގަކުރެއެވެ؛ އެޑިޓެއް ނުކުރެވޭނެއެވެ.",
        "effectiveTo": "އަމަލުކުރުން ނިމޭ",
        "effectiveToHint": "މިއީ މިހާރުގެ ރޭޓް ކަމުގައިވާނަމަ ހުސްކޮށް ބާއްވާ. ދެން އަންނަ ވަރޝަން ފެށޭ ދުވަހުގެ ކުރީ ދުވަހަށް ސެޓްކުރައްވާ.",
        "inputAccount": "އިންޕުޓް ޓެކްސް އެކައުންޓް",
        "inputAccountHint": "ގަތުންތަކުގައި ޑެބިޓްކުރެވެއެވެ.",
        "outputAccount": "އައުޓްޕުޓް ޓެކްސް އެކައުންޓް",
        "outputAccountHint": "ވިއްކުންތަކުގައި ކްރެޑިޓްކުރެވެއެވެ.",
        "payableAccount": "ދައްކަންޖެހޭ އެކައުންޓް",
        "payableAccountHint": "ސާފު އަދަދު ހަމަޖެހޭ ތަން.",
        "recoverable": "އިންޕުޓް ޓެކްސް އަނބުރާ ހޯދޭ",
        "recoverableHint": "ވިޔަފާރިއަށް އަނބުރާ ނުހޯދޭ ޓެކްހަކަށް މި ނަގާލައްވާ.",
        "active": "އައު ލިޔުންތަކުގައި ބޭނުންކުރެވޭ",
        "activeHint": "މި ނިއްވާލުމުން އައު ލިޔުންތަކުން ކޯޑު ފޮރުވެއެވެ. ޕޯސްޓްކޮށްފައިވާ ލިޔުންތަކުގައި ދެމިހުންނާނެއެވެ.",
        "description": "ތަފްޞީލު"
      },
      "timelineTitle": "މި ބަދަލަށްފަހު {code}",
      "invertedWindow": "ނިމޭ ތާރީޚު ފެށޭ ތާރީޚުގެ ކުރިން ކަމުން، މި ވަރޝަނުން އެއްވެސް ދުވަހެއް ނުހިމެނޭނެއެވެ.",
      "overlapOpen": "{from} އިން ފެށޭ {code} ގެ ނިމުމެއް ނެތް ވަރޝަނަކުން މި ދުވަސްތައް މިހާރުވެސް ހިމަނައެވެ. ރައްކާކުރުމުގެ ކުރިން އެ ބަންދުކުރައްވާ.",
      "overlapClosed": "{code} ގެ ވަރޝަނަކުން {from} އިން {to} އަށް މިހާރުވެސް ހިމަނައެވެ. އެއް ދުވަހެއްގައި ދެ ވަރޝަނަކަށް އަމަލެއް ނުކުރެވޭނެއެވެ.",
      "gapWarning": "މިގޮތަށް ރައްކާކުރުމުން އެއްވެސް ރޭޓެއް ނެތް ދުވަސްތަކެއް ދޫވެއެވެ. ހުސްތަނެއްގެ ތެރޭގައި ތާރީޚު ޖެހިފައިވާ ލިޔުމެއް ޕޯސްޓެއް ނުކުރެވޭނެއެވެ.",
      "gapRange": "{from} އިން {to} އަށް",
      "gapAfter": "{on} ގެ ފަހުން ހުރިހާ ދުވަހެއް",
      "gapAcknowledged": "އެ ހުސްތަނާއެކު ވަރޝަން ރެކޯޑްކުރަން އަލުން ރައްކާކުރޭ އަށް ފިއްތަވާ.",
      "saveAnyway": "ހުސްތަނާއެކު ރައްކާކުރޭ",
      "created": "ޓެކްސް ކޯޑު ވަރޝަން އުފެއްދިއްޖެ",
      "createdDetail": "{code} މިހާރު ލިޔުންތަކުގައި ބޭނުންކުރެވޭނެއެވެ.",
      "saved": "ޓެކްސް ކޯޑު ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{code} އަޕްޑޭޓްކުރެވިއްޖެއެވެ.",
      "saveFailed": "ޓެކްސް ކޯޑު ރައްކާއެއް ނުކުރެވުނެވެ",
      "staleConflict": "މި ވަރޝަން ހުޅުވިފައި ހުއްޓާ އެހެން މީހަކު ބަދަލުކޮށްފިއެވެ. އެ ބަދަލު ބެއްލެވުމަށް ބަންދުކޮށް އަލުން ހުޅުއްވާ، އެއަށްފަހު ތިޔަ ބަދަލު އަލުން ގެންނަވާ."
    },
    "groups": {
      "loadFailed": "ޓެކްސް ގްރޫޕުތައް ނުލޯޑްވިއެވެ",
      "inactive": "ހުއްޓިފައި",
      "created": "ޓެކްސް ގްރޫޕް އުފެއްދިއްޖެ",
      "createdDetail": "{code} މިހާރު ޤަވާޢިދެއްގައި ބޭނުންކުރެވޭނެއެވެ.",
      "fields": {
        "code": "ކޯޑު",
        "codeHint": "ކުރު އަދި ބަދަލުނުވާ، މިސާލަކަށް STD ނުވަތަ EXPORT.",
        "name": "ނަން",
        "active": "ޤަވާޢިދުތަކުގައި ބޭނުންކުރެވޭ"
      },
      "party": {
        "title": "ފަރާތްތަކުގެ ގްރޫޕުތައް",
        "description": "ސަޕްލަޔަރުންނާއި ކަސްޓަމަރުން ގިންތިކުރެއެވެ، މިސާލަކަށް ރާއްޖެތެރެ، އެކްސްޕޯޓް، އިސްތިސްނާ ފަރާތް.",
        "emptyTitle": "ފަރާތްތަކުގެ ގްރޫޕެއް ނެތެވެ",
        "emptyDescription": "ޤަވާޢިދަކަށް އެއްފަރާތުގައި ފަރާތްތަކުގެ ގްރޫޕެއް ބޭނުންވެއެވެ. ސަޕްލަޔަރުންނާއި ކަސްޓަމަރުން ގިންތިކުރަން ފެށުމަށް އެއް ގްރޫޕް އިތުރުކުރައްވާ.",
        "add": "ފަރާތްތަކުގެ ގްރޫޕެއް އިތުރުކުރޭ"
      },
      "item": {
        "title": "ތަކެތީގެ ގްރޫޕުތައް",
        "description": "ތަކެތި ގިންތިކުރެއެވެ، މިސާލަކަށް އާންމު މުދާ، ސުމެއް ރޭޓްގެ ކާނާ، ޚިދުމަތްތައް.",
        "emptyTitle": "ތަކެތީގެ ގްރޫޕެއް ނެތެވެ",
        "emptyDescription": "ޤަވާޢިދަކަށް އަނެއް ފަރާތުގައި ތަކެތީގެ ގްރޫޕެއް ބޭނުންވެއެވެ. ތަކެތި ގިންތިކުރަން ފެށުމަށް އެއް ގްރޫޕް އިތުރުކުރައްވާ.",
        "add": "ތަކެތީގެ ގްރޫޕެއް އިތުރުކުރޭ"
      }
    },
    "preview": {
      "title": "ލައިނެއް ކުރިން ބަލާލުން",
      "description": "ލިޔުމެއް ހިންގާނެ ސީދާ އެ ހިސާބު ހިންގައެވެ، އަދި އެއްވެސް އެއްޗެއް ނުލިޔެއެވެ.",
      "movedTitle": "ކުރިން ބަލާލުން ބަދަލުވީ ޓެކްސް ސިމިއުލޭޓަރަށެވެ",
      "movedDescription": "ލައިނެއްގެ ޓެކްހަކީ މިހާރު އެންމެ ކޯޑަކާއި ރޭޓެއް ނޫނެވެ: ސަޕްލައި ހިނގާ ތަނުން ކޮން ދާއިރާއެއް ވެރިވާނެކަން ކަނޑައަޅައެވެ، އަދި އެއް ލައިނަކަށް އެއް ރެޖީމަށްވުރެ ގިނަ ރެޖީމް ބާރު ފޯރުވިދާނެއެވެ. ސިމިއުލޭޓަރު މުޅި ސުވާލު ކުރެއެވެ، އަދި ކޮންމެ މަރުޙަލާއެއް، ކޮންމެ ރެޖީމެއް، އަދި ލިޔުމަކުން ޕޯސްޓްކުރާނެ އަދަދު ދައްކައެވެ.",
      "openSimulator": "ޓެކްސް ސިމިއުލޭޓަރު ހުޅުވާ"
    },
    "report": {
      "title": "ޓެކްސްގެ ހާލަތު",
      "description": "މުއްދަތެއްގެ އިންޕުޓް އަދި އައުޓްޕުޓް ޓެކްސް، ލިޔުންތަކުން ޙަޤީޤަތުގައި ޕޯސްޓްކުރެވުނު ޓެކްސް ލައިންތަކުން ހިސާބުކުރެވިފައި.",
      "notTheReturn": "މިއީ ދިފާޢުކުރެވޭ ޖީއެސްޓީ ޚުލާޞާއެކެވެ؛ ރަސްމީ ރިޓަރން ފޯމުގެ ނަކަލެއް ނޫނެވެ. އެއްވެސް އެއްޗެއް ހުށަހެޅުމުގެ ކުރިން މީރާގެ މިހާރުގެ ފޯމާ އަޅާކިޔައި ބައިތައް ކަށަވަރުކުރައްވާ.",
      "periodTitle": "މުއްދަތު",
      "fields": {
        "from": "ފެށޭ",
        "to": "ނިމޭ",
        "company": "ކުންފުނި",
        "companyHint": "ހުރިހާ ކުންފުންޏެއް ހިމެނުމަށް ހުސްކޮށް ބާއްވާ."
      },
      "allCompanies": "ހުރިހާ ކުންފުނިތައް",
      "loadFailed": "ޚުލާޞާ ނުލޯޑްވިއެވެ",
      "netPayable": "ސާފުކޮށް ދައްކަންޖެހޭ ({currency})",
      "netPayableHelp": "މުއްދަތުގެ އައުޓްޕުޓް ޓެކުހުން، އަނބުރާ ހޯދޭ އިންޕުޓް ޓެކްސް އުނިކުރުމުން.",
      "totalsTitle": "ފައިސާގެ ބާވަތުން ޙާލަތު",
      "totalsCaption": "މުއްދަތުގެ ޓެކްސް ޙާލަތު، ފައިސާގެ ބާވަތުން",
      "noTotals": "މި މުއްދަތުގައި އެއްވެސް ޓެކްސް ލައިނެއް ޕޯސްޓްކޮށްފައެއް ނުވެއެވެ.",
      "totals": {
        "outputBase": "އައުޓްޕުޓް އަސާސް",
        "outputTax": "އައުޓްޕުޓް ޓެކްސް",
        "inputBase": "އިންޕުޓް އަސާސް",
        "inputTax": "އިންޕުޓް ޓެކްސް",
        "recoverable": "އަނބުރާ ހޯދޭ އިންޕުޓް",
        "netPayable": "ސާފުކޮށް ދައްކަންޖެހޭ"
      },
      "columns": {
        "code": "ޓެކްސް ކޯޑު",
        "currency": "ފައިސާ",
        "base": "އަސާސީ އަދަދު",
        "tax": "ޓެކްސް",
        "recoverable": "އަނބުރާ ހޯދޭ",
        "documents": "ލިޔުންތައް"
      },
      "recoverable": "އަނބުރާ ހޯދޭ",
      "notRecoverable": "އަނބުރާ ނުހޯދޭ",
      "outputTableLabel": "ކޯޑުން އައުޓްޕުޓް ޓެކްސް",
      "outputCaption": "ވިއްކުންތަކުގައި ނެގުނު ޓެކްސް. ސުމެއް ރޭޓް، އިސްތިސްނާ އަދި ދާއިރާއިން ބޭރު ސަޕްލައިތަކަށް ވަކި ރޮނގުތަކެއް ބޭއްވެއެވެ.",
      "outputEmptyTitle": "މި މުއްދަތުގައި އައުޓްޕުޓް ޓެކްހެއް ނެތެވެ",
      "outputEmptyDescription": "މި ތާރީޚުތަކުގެ ދެމެދުގައި ވިއްކުމުގެ ޓެކްސް ލައިނަކާއެކު އެއްވެސް އެއްޗެއް ޕޯސްޓްކޮށްފައެއް ނުވެއެވެ.",
      "inputTableLabel": "ކޯޑުން އިންޕުޓް ޓެކްސް",
      "inputCaption": "ގަތުންތަކުގައި ތިޔަ ފަރާތުން ނެގުނު ޓެކްސް. ސާފު ޙާލަތު ކުޑަކުރަނީ އަނބުރާ ހޯދޭ ރޮނގުތަކުން އެކަންޏެވެ.",
      "inputEmptyTitle": "މި މުއްދަތުގައި އިންޕުޓް ޓެކްހެއް ނެތެވެ",
      "inputEmptyDescription": "މި ތާރީޚުތަކުގެ ދެމެދުގައި ގަތުމުގެ ޓެކްސް ލައިނަކާއެކު އެއްވެސް އެއްޗެއް ޕޯސްޓްކޮށްފައެއް ނުވެއެވެ.",
      "generatedAt": "ހިސާބުކުރެވުނީ",
      "export": {
        "action": "ޚުލާޞާ ސީއެސްވީ އެކްސްޕޯޓްކުރޭ",
        "done": "ޚުލާޞާ ޑައުންލޯޑްކުރެވިއްޖެ",
        "doneDetail": "{filename} ގެ ނަމުގައި ރައްކާކުރެވިއްޖެ. މިއީ ޖީއެސްޓީ ޚުލާޞާއެކެވެ؛ ޤާނޫނީ ރިޓަރން ފޯމެއް ނޫނެވެ.",
        "failed": "އެކްސްޕޯޓް ފުރިހަމައެއް ނުވިއެވެ"
      }
    },
    "spine": {
      "levels": {
        "country": "ޤައުމު",
        "subdivision": "ސަރަޙައްދު",
        "locality": "ރަށް / ސިޓީ"
      },
      "sources": {
        "pack": {
          "label": "ޕެކް",
          "summary": "ޝާއިޢުކުރެވިފައިވާ ޤައުމީ ޓެކްސް ޕެކަކުން ޤަބޫލުކުރެވިފައިވާ މަޢުލޫމާތު. ސިންކް ކުރުމުން ބަދަލުވާނެ."
        },
        "tenant": {
          "label": "ތިޔަބޭފުޅުންގެ",
          "summary": "މި ވޯކްސްޕޭސްގައި ހަދާފައިވާ ރޯ. ޕެކް ސިންކް ކުރުމުން ބަދަލެއް ނާންނާނެ."
        },
        "legacy": {
          "label": "ކުރީގެ",
          "summary": "ޓެކްސް ސްޕައިންގެ ކުރިން އޮތް ރޯއެއް. އަދިވެސް މަސައްކަތްކުރޭ، އެކަމަކު ޕެކަކުން ބަލަހައްޓާ ނުދޭ."
        }
      },
      "regimeKinds": {
        "VAT": {
          "label": "ވެޓް / ޖީއެސްޓީ",
          "summary": "މުދަލާއި ޚިދުމަތުގެ މައްޗަށް ނަގާ، ގަތުމުގައި އަނބުރާ ހޯދޭ ޓެކްސް."
        },
        "WHT": {
          "label": "ހިފެހެއްޓޭ ޓެކްސް",
          "summary": "ފައިސާ ދެއްކުމުގައި ކަނޑައި، ފައިސާ ލިބޭ ފަރާތުގެ ބަދަލުގައި ދައްކާ ޓެކްސް."
        },
        "LEVY": {
          "label": "ލެވީ",
          "summary": "ޤާނޫނީ ޗާޖެއް، ގިނަފަހަރު އަގުގެ ބަދަލުގައި ޔުނިޓަކަށް — ރެއަކަށް ނަގާ ގްރީން ޓެކްސް ފަދަ."
        },
        "CHARGE": {
          "label": "ސާވިސް ޗާޖް",
          "summary": "ޓެކްސް ފަދައިން ހިސާބުކުރެވޭ، އިންވޮއިސްގެ ޖުމްލައިގައި ހިމެނޭ، އަދި ފަހުން އަންނަ ޓެކުހުގެ ބޭހުގައި ހިމެނޭ، ނަމަވެސް އެއްވެސް ރިޓާނެއްގައި ނުހިމެނޭ ޗާޖެއް."
        },
        "SALES_TAX": {
          "label": "ސޭލްސް ޓެކްސް",
          "summary": "ވިއްކާ ހިސާބުގައި ނަގާ، ގަތުމުގައި އަނބުރާ ނުހޯދޭ ޓެކްސް."
        }
      },
      "activation": {
        "statuses": {
          "active": {
            "label": "ހިނގަމުންދޭ",
            "summary": "މިވަގުތު ޓެކްސް ހިސާބުކުރަނީ މި ވަރޝަނުން."
          },
          "update_available": {
            "label": "އަޕްޑޭޓެއް އެބައޮތް",
            "summary": "އައު ވަރޝަނެއް ޝާއިޢުކޮށްފި. ޤަބޫލުކުރަންދެން އެއްވެސް ބަދަލެއް ނާންނާނެ."
          },
          "validating": {
            "label": "ބަލަމުންދޭ",
            "summary": "ތިޔަބޭފުޅުންގެ ލިޔުންތައް ސޭންޑްބޮކްސްގައި އަލުން ހިސާބުކުރަމުން ދަނީ."
          },
          "validated": {
            "label": "ބެލިއްޖެ",
            "summary": "ސޭންޑްބޮކްސް ނިމިއްޖެ. ފެނުނު ތަފާތުތައް ބެއްލެވުމަށްފަހު ޤަބޫލުކުރައްވާ."
          },
          "validation_failed": {
            "label": "ބެލުން ނާކާމިޔާބު",
            "summary": "ސޭންޑްބޮކްސް ފުރިހަމަ ނުކުރެވުނު. ސަބަބު ތިރީގައި."
          },
          "withdrawn_upstream": {
            "label": "އަނބުރާ ގެންގޮސްފި",
            "summary": "ޝާއިޢުކުރި ފަރާތުން މި ވަރޝަން އަނބުރާ ގެންގޮސްފި. ރިޓާން ހުށަހެޅުމުގެ ކުރިން އޮޕަރޭޓަރާ ގުޅުއްވާ."
          }
        },
        "fields": {
          "version": "ހިނގަމުންދާ ވަރޝަން",
          "effectiveFrom": "ފެށޭ ތާރީޚް",
          "activatedAt": "އެކްޓިވޭޓްކުރި",
          "contentHash": "ކޮންޓެންޓް ހޭޝް"
        },
        "pending": "ވަރޝަން {version} ޝާއިޢުކޮށްފި؛ ތިޔަބޭފުޅުން ތިއްބެވީ ވަރޝަން {current} ގައި. ޤަބޫލުކުރަންދެން ބަދަލެއް ނާންނާނެ.",
        "pendingSeen": "ފުރަތަމަ ފެނުނީ",
        "sandboxRanAt": "ސޭންޑްބޮކްސް އެންމެފަހުން ހިންގީ",
        "reviewUpdate": "އަޕްޑޭޓް ބައްލަވާ",
        "viewDetail": "ތަފްޞީލް"
      },
      "registration": {
        "statuses": {
          "pending": "އިންތިޒާރުގައި",
          "active": "ހިނގަމުންދޭ",
          "suspended": "ހުއްޓާލެވިފައި",
          "deregistered": "ރަޖިސްޓްރީ ބާތިލް"
        },
        "schemes": {
          "standard": "އާދައިގެ",
          "simplified": "ސާދާ",
          "flat_rate": "ފްލެޓް ރޭޓް",
          "svat": "އެސްވެޓް",
          "non_resident": "ރެޒިޑެންޓް ނޫން",
          "group": "ގްރޫޕް"
        },
        "frequencies": {
          "monthly": "މަހުން މަހަށް",
          "quarterly": "ކުއާޓަރުން",
          "biannual": "އަހަރަކު ދެފަހަރު",
          "annual": "އަހަރަކު އެއްފަހަރު"
        },
        "designations": {
          "none": "ނެތް",
          "psu": "ޕޭރޯލް ސްޓެޓިއުޓަރީ ޔުނިޓް",
          "tru": "ޓެކްސް ރިޕޯޓިން ޔުނިޓް",
          "both": "ޕޭރޯލް އަދި ޓެކްސް ރިޕޯޓިން ޔުނިޓް"
        },
        "title": "ޓެކްސް ރަޖިސްޓްރޭޝަން",
        "description": "އެއް ކުންފުނި، އެއް ރެޖީމްގެ ދަށުގައި: ނަންބަރު، ސްކީމް، އަދި ހިނގާ މުއްދަތު.",
        "create": "އައު ރަޖިސްޓްރޭޝަން",
        "createTitle": "އައު ޓެކްސް ރަޖިސްޓްރޭޝަން",
        "editTitle": "ރަޖިސްޓްރޭޝަން އިޞްލާޙްކުރެއްވުން",
        "editorDescription": "ރަޖިސްޓްރޭޝަން ހެދުމަށްފަހު، އޭގެ އަޞްލު މަޢުލޫމާތު ބަދަލެއް ނުކުރެވޭނެ؛ ނަމަވެސް އޭގެ ޒިންމާ އިޞްލާޙްކުރެވިދާނެ.",
        "identityImmutable": "ކުންފުނި، ރެޖީމް، ނަންބަރު އަދި ފެށޭ ތާރީޚް ބަދަލެއް ނުކުރެވޭނެ. އެހެން ރަޖިސްޓްރޭޝަނަކީ އައު ރޯއެއް.",
        "loadFailed": "ރަޖިސްޓްރޭޝަން ލިސްޓް ނުލިބުނު",
        "tableLabel": "ކުންފުނީގެ ޓެކްސް ރަޖިސްޓްރޭޝަން",
        "emptyTitle": "އަދި ރަޖިސްޓްރޭޝަނެއް ނެތް",
        "emptyDescription": "ރަޖިސްޓްރޭޝަނެއް ނެތި ހިސާބުކުރުމެއް ނުކުރެވޭނެ: ލައިނެއް ދާނީ ރެޖީމްގެ ރަޖިސްޓްރީ ނުކުރާ ކޯޑަށް، ނުވަތަ ހުއްޓޭނެ. ކޮންމެ ކުންފުންޏެއްގެ ރަޖިސްޓްރޭޝަން އިތުރުކުރައްވާ.",
        "attention": "މި ޞަފްޙާގައި {count} ރަޖިސްޓްރޭޝަނެއްގެ މުއްދަތު ހަމަވެއްޖެ، ނުވަތަ ހަމަވާން ކައިރިވެއްޖެ، ނުވަތަ ތާރީޚްތަކާ ދިމައެއް ނުވޭ.",
        "columns": {
          "number": "ރަޖިސްޓްރޭޝަން",
          "status": "ޙާލަތު",
          "validity": "ހިނގާ މުއްދަތު",
          "frequency": "މުއްދަތު",
          "scheme": "ސްކީމް",
          "filingCurrency": "ފައިސާ",
          "designation": "ދަރަޖަ",
          "primary": "މައިގަނޑު"
        },
        "primary": "މައިގަނޑު",
        "filters": {
          "company": "ކުންފުނި",
          "regime": "ރެޖީމް",
          "status": "ޙާލަތު"
        },
        "fields": {
          "company": "ކުންފުނި",
          "regime": "ރެޖީމް",
          "number": "ރަޖިސްޓްރޭޝަން ނަންބަރު",
          "status": "ޙާލަތު",
          "scheme": "ސްކީމް",
          "effectiveFrom": "ފެށޭ ތާރީޚް",
          "effectiveTo": "ނިމޭ ތާރީޚް",
          "effectiveToHint": "މުއްދަތެއް ނެތްނަމަ ހުސްކޮށް ބާއްވަވާ.",
          "frequency": "ރިޓާން ހުށަހަޅާ މުއްދަތު",
          "frequencyHint": "މި ރަޖިސްޓްރޭޝަންގެ ދަށުން ރިޓާން ހުށަހަޅަންޖެހޭ ދުވަސްވަރު.",
          "firstPeriodStart": "ފުރަތަމަ މުއްދަތު ފެށޭ",
          "firstPeriodStartHint": "ފުރަތަމަ ރިޓާން ފުރިހަމަ މުއްދަތަކަށް ނުވާނަމަ އެކަނި.",
          "filingCurrency": "ހުށަހަޅާ ފައިސާ",
          "filingCurrencyHint": "ތިން އަކުރުގެ އައިއެސްއޯ 4217 ކޯޑް.",
          "designation": "ޤާނޫނީ ދަރަޖަ",
          "designationHint": "މި ރަޖިސްޓްރޭޝަނަކީ ޕޭރޯލް ސްޓެޓިއުޓަރީ ޔުނިޓްތޯ، ޓެކްސް ރިޕޯޓިން ޔުނިޓްތޯ، ނުވަތަ ދެގޮތްތޯ.",
          "isPrimary": "މި ކުންފުނީގެ މައިގަނޑު ރަޖިސްޓްރޭޝަން",
          "isPrimaryHint": "އެއް ނަންބަރު ދައްކަންޖެހޭ ޤާނޫނީ ލިޔުންތަކުގައި ޗާޕުކުރެވޭނެ.",
          "notes": "ނޯޓް"
        },
        "numberHintFallback": "މި ރެޖީމުން ނަންބަރުގެ ފޯމެޓެއް ބަޔާންކޮށްފައި ނުވާތީ، ސާވަރުން ބަލާނެ.",
        "numberMatches": "ރެޖީމްގެ ފޯމެޓާ ދިމާވޭ",
        "numberMismatch": "މިއީ މި ރެޖީމަށް ޕެކްގައި ބަޔާންކޮށްފައިވާ ފޯމެޓާ ({pattern}) ދިމާވާ ނަންބަރެއް ނޫން. ޔަޤީންނަމަ ރައްކާކުރައްވާ — ނިންމާނީ ސާވަރު.",
        "numberUncheckable": "ޕެކްގެ ފޯމެޓް މި ބްރައުޒަރަށް ކިޔޭގޮތެއް ނުވި، އެހެންކަމުން ބަލާނީ ސާވަރު އެކަނި.",
        "savedTitle": "ރަޖިސްޓްރޭޝަން ރައްކާކުރެވިއްޖެ",
        "savedDetail": "ފެށޭ ތާރީޚުން ފެށިގެން ހިސާބުކުރުމުގައި ބޭނުންކުރެވޭނެ."
      },
      "certificate": {
        "scopes": {
          "full": {
            "label": "ހުރިހާ މުޢާމަލާތެއް",
            "summary": "މި ފަރާތުގެ ކޮންމެ ލައިނަކަށްވެސް ހިނގާނެ."
          },
          "item_group": {
            "label": "އެއް އައިޓަމް ގްރޫޕް",
            "summary": "ބުނެވިފައިވާ އައިޓަމް ގްރޫޕްގެ ލައިންތަކަށް އެކަނި ހިނގާނެ."
          },
          "tax_code": {
            "label": "އެއް ޓެކްސް ކޯޑް",
            "summary": "ބުނެވިފައިވާ ޓެކްސް ކޯޑް އެކަނި ބަދަލުކުރާނެ. އެންމެ ޚާއްޞަ ސްކޯޕަށް އިސްކަން ދެވޭނެ."
          }
        },
        "statuses": {
          "draft": "ދެލިކޮޕީ",
          "active": "ހިނގަމުންދޭ",
          "revoked": "ބާތިލްކުރެވިފައި",
          "expired": "މުއްދަތު ހަމަވެފައި"
        },
        "partyKinds": {
          "customer": "ކަސްޓަމަރު",
          "vendor": "ސަޕްލަޔަރު",
          "employee": "މުވައްޒަފު",
          "party": "އެހެން ފަރާތެއް"
        },
        "title": "އިސްތިސްނާ ސެޓްފިކެޓް",
        "description": "ސެޓްފިކެޓަކުން ޓެކްސް ސުމަކަށް ނުހަދާ — ރޫލުން ހޮވާނެ ކޯޑް ބަދަލުކުރަނީ، އެހެންވެ ލައިން އަދިވެސް ރިޓާނުގައި ހިމެނޭނެ.",
        "create": "އައު ސެޓްފިކެޓް",
        "createTitle": "އައު އިސްތިސްނާ ސެޓްފިކެޓް",
        "editTitle": "ސެޓްފިކެޓް އިޞްލާޙްކުރެއްވުން",
        "editorDescription": "ސެޓްފިކެޓް ހެދުމަށްފަހު ސްކޯޕާއި ޓްރީޓްމަންޓް ބަދަލެއް ނުކުރެވޭނެ؛ ނިމޭ ތާރީޚް، ޙާލަތު އަދި ނޯޓް ބަދަލުކުރެވޭނެ.",
        "identityImmutable": "ސެޓްފިކެޓްގެ ސްކޯޕް ބަދަލުކުރުމުން، ކުރީގެ ލިޔުންތަކުގައި ހުންނަންވީ އެއްޗެއް ފަހަތަށް ބަދަލުވާނެ. އެއީ އައު ސެޓްފިކެޓެއް، އިޞްލާޙެއް ނޫން.",
        "loadFailed": "ސެޓްފިކެޓް ލިސްޓް ނުލިބުނު",
        "tableLabel": "އިސްތިސްނާ ސެޓްފިކެޓްތައް",
        "sortCaption": "މުހިންމުކަމުގެ ތަރުތީބުން: ފުރަތަމަ މުއްދަތު ހަމަވެފައިވާ، ދެން ހަމަވާން ކައިރިވެފައިވާ.",
        "emptyTitle": "އިސްތިސްނާ ސެޓްފިކެޓެއް ނެތް",
        "emptyDescription": "ސެޓްފިކެޓް މިތާ ރައްކާކުރެއްވުމުން، ދިމާވާ ކޮންމެ ލައިނެއްގައި އިންޖީނުން އޭގެ ޓްރީޓްމަންޓް ބޭނުންކުރާނެ، އަދި ޓެކްސް ޕެނަލްގައި ސެޓްފިކެޓް ދައްކާނެ.",
        "attention": "މި ޞަފްޙާގައި {count} ސެޓްފިކެޓެއްގެ މުއްދަތު ހަމަވެއްޖެ، ނުވަތަ ހަމަވާން ކައިރިވެއްޖެ، ނުވަތަ ތާރީޚްތަކާ ދިމައެއް ނުވޭ.",
        "alreadyExpired": "ނިމޭ ތާރީޚް ފާއިތުވެއްޖެ، އެހެންކަމުން މިއަދުން ފެށިގެން މި ސެޓްފިކެޓަށް އެއްވެސް އަސަރެއް ނުކުރާނެ.",
        "columns": {
          "number": "ސެޓްފިކެޓް",
          "validity": "މުއްދަތު",
          "status": "ޙާލަތު",
          "scope": "ސްކޯޕް",
          "treatment": "ޓްރީޓްމަންޓް",
          "issuedBy": "ދޫކުރި ފަރާތް"
        },
        "filters": {
          "partyKind": "ފަރާތުގެ ބާވަތް",
          "partyId": "ފަރާތުގެ އައިޑީ",
          "partyIdHint": "އެއް ފަރާތަކަށް ފިލްޓަރކުރައްވާ.",
          "status": "ޙާލަތު"
        },
        "fields": {
          "partyKind": "ފަރާތުގެ ބާވަތް",
          "party": "ފަރާތް",
          "partySearch": "ހޯއްދަވާ",
          "partySearchHint": "ކޯޑް ނުވަތަ ނަމުން.",
          "partyId": "ފަރާތުގެ އައިޑީ",
          "partyIdHint": "މި ބާވަތުގެ ފަރާތްތަކުގެ ލިސްޓެއް ނެތުމުން، އައިޑީ ސީދާ ލިޔުއްވާ.",
          "jurisdiction": "ސަރަޙައްދު",
          "regime": "ރެޖީމް",
          "regimeHint": "ހުރިހާ ރެޖީމަކަށް ހިނގާނަމަ ހުސްކޮށް ބާއްވަވާ.",
          "company": "ކުންފުނި",
          "companyHint": "ހުރިހާ ކުންފުންޏަކަށް ހިނގާނަމަ ހުސްކޮށް ބާއްވަވާ.",
          "number": "ސެޓްފިކެޓް ނަންބަރު",
          "scope": "ސްކޯޕް",
          "itemGroup": "އައިޓަމް ގްރޫޕް އައިޑީ",
          "itemGroupHint": "އައިޓަމް ގްރޫޕް ސެޓްފިކެޓަކަށް ބޭނުންވާނެ.",
          "taxCode": "ޓެކްސް ކޯޑް",
          "taxCodeHint": "މި ސެޓްފިކެޓުން ބަދަލުކުރާ ސީދާ ކޯޑް.",
          "treatment": "ދޭ ޓްރީޓްމަންޓް",
          "treatmentHint": "އިސްތިސްނާ، ޒީރޯ ރޭޓް އަދި ދާއިރާއިން ބޭރު — މިއީ ރިޓާނުގައި ތިން ބޮކްސް، އެއް ސުމެއް ނޫން.",
          "exemptTaxCode": "ބަދަލުގައި ބޭނުންކުރާ ކޯޑް",
          "exemptTaxCodeHint": "ހުސްކޮށް ބާއްވަވައިފިނަމަ، އެ ޓްރީޓްމަންޓަށް ރެޖީމްގައި އޮތް ކޯޑް ބޭނުންކުރެވޭނެ.",
          "validFrom": "ފެށޭ ތާރީޚް",
          "validTo": "ނިމޭ ތާރީޚް",
          "validToHint": "މުއްދަތެއް ނެތްނަމަ ހުސްކޮށް ބާއްވަވާ. ލިޔުއްވައިފިނަމަ، ހަމަވުމުގެ ކުރިން ލިސްޓުން އިންޒާރު ދޭނެ.",
          "status": "ޙާލަތު",
          "issuedBy": "ދޫކުރި ފަރާތް",
          "notes": "ނޯޓް"
        },
        "partyPlaceholder": "ހޯއްދަވާފައި ހޮއްވަވާ",
        "searching": "ހޯދަނީ…",
        "allRegimes": "ހުރިހާ ރެޖީމެއް",
        "allCompanies": "ހުރިހާ ކުންފުންޏެއް",
        "savedTitle": "ސެޓްފިކެޓް ރައްކާކުރެވިއްޖެ",
        "savedDetail": "މުއްދަތުގެ ތެރޭގައި ދިމާވާ ލައިންތަކުގައި، މީގެ ޓްރީޓްމަންޓް ބޭނުންކުރެވޭނެ.",
        "delete": "ސެޓްފިކެޓް ފޮހެލައްވާ",
        "deleting": "ފޮހެލަނީ",
        "deletedTitle": "ސެޓްފިކެޓް ފޮހެލެވިއްޖެ",
        "deletedDetail": "{number} މިހާރު ނުހިނގާނެ. ޕޯސްޓްކޮށްފައިވާ ލިޔުންތަކުގައި ހުރި ޓްރީޓްމަންޓް ބަދަލެއް ނުވާނެ.",
        "deleteFailed": "ސެޓްފިކެޓް ފޮހެލެވޭ ގޮތެއް ނުވި"
      },
      "return": {
        "statuses": {
          "draft": {
            "label": "ދެލިކޮޕީ",
            "summary": "ރިޓާން ހުޅުވިއްޖެ، ސުންގަޑިވެސް ކަނޑައެޅިއްޖެ. އަދި ޢަދަދުތަކެއް ނެތް."
          },
          "reconciled": {
            "label": "ހިސާބު ދިމާވެއްޖެ",
            "summary": "މުއްދަތުގެ ޓެކްސް ލައިންތަކުން ޢަދަދުތައް ހިސާބުކޮށް، ލެޖަރާ އަޅާކިޔައިފި."
          },
          "submitted": {
            "label": "ހުށަހަޅައިފި",
            "summary": "ފާސްކުރުމަށް ފޮނުވައިފި. ރިޓާން ނަންބަރު ދޫކުރެވިއްޖެ."
          },
          "approved": {
            "label": "ފާސްކޮށްފި",
            "summary": "އެތެރޭގައި ފާސްކޮށްފި، އިދާރާއަށް ހުށަހެޅުމަށް ތައްޔާރު."
          },
          "filed": {
            "label": "ފައިލްކޮށްފި",
            "summary": "އިދާރާއަށް ހުށަހަޅައިފި، ރެފަރެންސް ރައްކާކުރެވިއްޖެ."
          },
          "paid": {
            "label": "ފައިސާ ދައްކައިފި",
            "summary": "ފައިސާ ދައްކައި، ފައިސާގެ ލިޔުމާ ގުޅުވައިފި."
          },
          "superseded": {
            "label": "ބަދަލުކުރެވިފައި",
            "summary": "އެ މުއްދަތަށް ފަހުން ހެދި ރިޓާނަކުން ބަދަލުކުރެވިއްޖެ."
          }
        },
        "title": "ޓެކްސް ރިޓާން",
        "description": "މުއްދަތުގެ ޙާލަތު، ބޮކްސްތައް، ލެޖަރާ ދިމާވުން، އަދި ފައިލްކުރުން.",
        "loadFailed": "ރިޓާން ނުލިބުނު",
        "tableLabel": "ޓެކްސް ރިޓާންތައް",
        "emptyTitle": "އަދި ރިޓާނެއް ނެތް",
        "emptyDescription": "ރަޖިސްޓްރޭޝަނަކާއި މުއްދަތަކަށް ރިޓާނެއް ހުޅުއްވާ: ހުޅުވުމުން ސުންގަޑި ކަނޑައެޅޭނެ، އަދި ހިސާބު ދިމާކުރުމުން މުއްދަތުގެ ޓެކްސް ލައިންތަކުން ބޮކްސްތައް ފުރޭނެ.",
        "numberAtSubmit": "ހުށަހަޅާއިރު ދޫކުރެވޭނެ",
        "overdue": "{days} ދުވަސް ފަހަނައަޅައިފި",
        "dueIn": "{days} ދުވަހުން ސުންގަޑި",
        "overdueSummary": "މި ޞަފްޙާގައި {count} ރިޓާނެއްގެ ސުންގަޑި ފަހަނައަޅައިފި.",
        "detailTitle": "ރިޓާން {number} · {code}",
        "detailDescription": "މުއްދަތު {from} އިން {to} އަށް",
        "lifecycleLabel": "ރިޓާންގެ މަރުޙަލާތައް",
        "supersededBy": "ރިޓާން #{id} އިން ބަދަލުކުރެވިއްޖެ.",
        "columns": {
          "return": "ރިޓާން",
          "period": "މުއްދަތު",
          "due": "ސުންގަޑި",
          "status": "ޙާލަތު",
          "netPayable": "ދައްކަންޖެހޭ ޖުމްލަ",
          "currency": "ފައިސާ"
        },
        "filters": {
          "registration": "ރަޖިސްޓްރޭޝަން",
          "status": "ޙާލަތު",
          "from": "މުއްދަތު ފެށޭ",
          "to": "މުއްދަތު ނިމޭ"
        },
        "fields": {
          "period": "މުއްދަތު",
          "dueDate": "ސުންގަޑި",
          "filingCurrency": "ހުށަހަޅާ ފައިސާ",
          "returnNo": "ރިޓާން ނަންބަރު"
        },
        "prepare": {
          "title": "ރިޓާނެއް ހުޅުއްވުން",
          "description": "ރިޓާން ހުޅުވައި ސުންގަޑި ކަނޑައަޅާނެ. ޢަދަދުތައް އަންނާނީ ހިސާބު ދިމާކުރުމުން.",
          "action": "ރިޓާނެއް ހުޅުއްވާ",
          "preparing": "ހުޅުވަނީ",
          "registration": "ރަޖިސްޓްރޭޝަން",
          "registrationSummary": "ހުށަހަޅަނީ {frequency}، {currency} އިން.",
          "returnDefCode": "ރިޓާން ތަޢާރަފް",
          "returnDefCodeHint": "ހުށަހަޅާ ފޯމަށް ޕެކްގައި ދީފައިވާ ކޯޑް، މިސާލަކަށް ރެޖީމްގެ މަހުގެ ރިޓާން.",
          "periodStart": "މުއްދަތު ފެށޭ",
          "periodEnd": "މުއްދަތު ނިމޭ",
          "periodOutOfOrder": "މުއްދަތު ނިމޭ ތާރީޚް، ފެށޭ ތާރީޚަށްވުރެ ކުރީގައި.",
          "whatHappens": "ސުންގަޑި ނެރެވޭނީ މި ރިޓާނަށް ޕެކްގައި އޮތް ރޫލުން، ތިޔަބޭފުޅުންގެ ގަޑިން.",
          "doneTitle": "ރިޓާން ހުޅުވިއްޖެ",
          "doneDetail": "މުއްދަތުގެ ޓެކްސް ލައިންތަކުން ބޮކްސްތައް ފުރުމަށް، ހިސާބު ދިމާކުރައްވާ."
        },
        "reconciliation": {
          "title": "ލެޖަރާ ދިމާވުން",
          "description": "މުއްދަތުގައި ރެޖީމްގެ ކޮންޓްރޯލް އެކައުންޓަށް އައި ބަދަލާއި، ރިޓާނުގެ ޢަދަދުތައް.",
          "caption": "ރިޓާނުގެ ޖުމްލަތަކާއި ލެޖަރު",
          "notYetRun": "މި ރިޓާނުގެ ހިސާބު އަދި ދިމާކޮށްފައެއް ނެތް، އެހެންކަމުން އަޅާކިޔާނެ ޢަދަދެއް ނެތް.",
          "outputBase": "އައުޓްޕުޓް ބޭސް",
          "outputTax": "އައުޓްޕުޓް ޓެކްސް",
          "inputBase": "އިންޕުޓް ބޭސް",
          "inputTax": "އިންޕުޓް ޓެކްސް",
          "recoverable": "އަނބުރާ ހޯދޭ އިންޕުޓް ޓެކްސް",
          "netPayable": "ދައްކަންޖެހޭ ޖުމްލަ",
          "glMovement": "ކޮންޓްރޯލް އެކައުންޓްގެ ބަދަލު",
          "difference": "ތަފާތު",
          "ties": "ރިޓާނާއި ލެޖަރު ލާރިއަކާ ހަމައަށް ދިމާވޭ.",
          "doesNotTie": "މި ރިޓާނާއި ލެޖަރު ދިމައެއް ނުވޭ. ތަފާތަކީ {amount} {currency}.",
          "causes": "ގިނަފަހަރު: ޓެކްސް ލައިނެއް ނެތި ސީދާ ކޮންޓްރޯލް އެކައުންޓަށް ޖެހި ޖާނަލެއް، ހިސާބު ދިމާކުރި ފަހުން މުއްދަތުގެ ތެރެއަށް ޕޯސްޓްކުރި ލިޔުމެއް، އަތުން ހެދި އެޖަސްޓްމަންޓެއް، ނުވަތަ ރަޖިސްޓްރޭޝަނާ ދިމާނުވާ މުއްދަތެއް. ތަފާތު ފޮރުވުމުގެ ބަދަލުގައި ދައްކަނީ."
        },
        "boxes": {
          "title": "ރިޓާނުގެ ބޮކްސްތައް",
          "description": "ފޯމުގައި ޗާޕުވާ ތަރުތީބުން. ހިސާބުކުރެވޭ ބޮކްސްއަކީ ބޮކްސްތަކުގެ ހިސާބެއް، އެއްކުރުމެއް ނޫން.",
          "caption": "ރިޓާން ބޮކްސްތައް، {currency} އިން",
          "columns": {
            "box": "ބޮކްސް",
            "label": "ނަން",
            "base": "ބޭސް",
            "tax": "ޓެކްސް",
            "value": "ޢަދަދު",
            "lines": "ޓެކްސް ލައިން"
          },
          "computed": "ހިސާބުކުރި",
          "fromTaxLines": "ޓެކްސް ލައިންތަކުން އެއްކުރި",
          "emptyTitle": "އަދި ބޮކްސްތަކެއް ނެތް",
          "emptyDescription": "މުއްދަތުގެ ޓެކްސް ލައިންތަކުން ބޮކްސްތައް ހިސާބުކުރުމަށް، ރިޓާނުގެ ހިސާބު ދިމާކުރައްވާ."
        },
        "actions": {
          "reconcile": "ހިސާބު ދިމާކުރައްވާ",
          "reconciling": "ހިސާބު ދިމާކުރަނީ",
          "reconciledTitle": "ހިސާބު ދިމާކުރެވިއްޖެ",
          "reconciledDetail": "ބޮކްސްތަކާއި ލެޖަރު އަޅާކިޔުން އަލުން ހިސާބުކުރެވިއްޖެ.",
          "reconcileFailed": "ހިސާބު ދިމާނުކުރެވުނު",
          "note": "ނޯޓް",
          "noteHint": "އޮޑިޓް ރެކޯޑްގައި ރައްކާކުރެވޭނެ.",
          "submit": "ފާސްކުރުމަށް ހުށަހަޅުއްވާ",
          "submitDialogTitle": "ފާސްކުރުމަށް ހުށަހެޅުން",
          "submitDialogDescription": "މިހާރު ރިޓާން ނަންބަރު ދޫކުރެވި، ފާސްކުރާ ފަރާތަށް ޢަދަދުތައް ހަރުކުރެވޭނެ.",
          "submitDoneTitle": "ރިޓާން ހުށަހަޅައިފި",
          "submitDoneDetail": "މިހާރު އިންތިޒާރުކުރަނީ ފާސްކުރާ ފަރާތަށް.",
          "approve": "ފާސްކުރައްވާ",
          "approveDialogTitle": "މި ރިޓާން ފާސްކުރެއްވުން",
          "approveDialogDescription": "ފާސްކުރުމަކީ ޢަދަދުތައް ރަނގަޅުކަން ކަށަވަރުކުރުން. ރިޓާން ތައްޔާރުކުރި ފަރާތަށް ފާހެއް ނުކުރެވޭނެ.",
          "approveDoneTitle": "ރިޓާން ފާސްކޮށްފި",
          "approveDoneDetail": "އިދާރާއަށް ހުށަހެޅުމަށް ތައްޔާރު.",
          "file": "ފައިލްކުރިކަން ރައްކާކުރައްވާ",
          "fileDialogTitle": "ފައިލްކުރިކަން ރައްކާކުރެއްވުން",
          "fileDialogDescription": "މިއީ ޓެކްސް އިދާރާއަކަށް ދެވުނު ބަޔާނެއް ރައްކާކުރުން، އެހެންވެ ރެފަރެންސާއެކު ބަހައްޓާނެ.",
          "fileDoneTitle": "ފައިލްކުރިކަން ރައްކާކުރެވިއްޖެ",
          "fileDoneDetail": "ރެފަރެންސް ރިޓާނާއެކު ރައްކާކުރެވިއްޖެ.",
          "filedOn": "ފައިލްކުރި ތާރީޚް",
          "reference": "އިދާރާގެ ރެފަރެންސް",
          "referenceHint": "އިދާރާއިން ދިން އެކްނޮލެޖްމަންޓް ނަންބަރު.",
          "acknowledgement": "އެކްނޮލެޖްމަންޓް",
          "acknowledgementHint": "ފައިލްކުރުމާއެކު ބަހައްޓަން ބޭނުންވާ އިތުރު މަޢުލޫމާތު.",
          "pay": "ފައިސާ ދެއްކިކަން ރައްކާކުރައްވާ",
          "payDialogTitle": "ފައިސާ ދެއްކިކަން ރައްކާކުރެއްވުން",
          "payDialogDescription": "ފައިސާ ދެއްކި ލިޔުމާ ރިޓާން ގުޅުވާނެ.",
          "payDoneTitle": "ފައިސާ ދެއްކިކަން ރައްކާކުރެވިއްޖެ",
          "payDoneDetail": "ރިޓާން ނިމިއްޖެ.",
          "paidOn": "ފައިސާ ދެއްކި ތާރީޚް",
          "paymentDocType": "ފައިސާގެ ލިޔުމުގެ ބާވަތް",
          "paymentDocTypeHint": "މިސާލަކަށް ކޭޝް ޕޭމަންޓް ނުވަތަ ބޭންކް ޕޭމަންޓް.",
          "paymentDocId": "ފައިސާގެ ލިޔުމުގެ އައިޑީ",
          "paymentDocIdHint": "ފައިސާ ދެއްކި ލިޔުމުގެ އައިޑީ.",
          "supersede": "ބަދަލުކުރައްވާ",
          "supersedeDialogTitle": "މި ރިޓާން ބަދަލުކުރެއްވުން",
          "supersedeDialogDescription": "މި ރިޓާން ބަދަލުކުރެވުނުކަމަށް ފާހަގަކޮށް، އެ މުއްދަތަށް އައު ރިޓާނެއް ހުޅުވާނެ. ފައިލްކޮށްފައިވާ އެއްޗެއް ނުފޮހެވޭނެ.",
          "supersedeDoneTitle": "ރިޓާން ބަދަލުކުރެވިއްޖެ",
          "supersedeDoneDetail": "އެ މުއްދަތަށް ބަދަލު ރިޓާނެއް ހުޅުވިއްޖެ.",
          "supersedeReason": "ސަބަބު",
          "supersedeReasonHint": "އޮޑިޓް ރެކޯޑްގައި ރައްކާކުރެވޭނެ. މަދުވެގެން ދިހަ އަކުރު.",
          "stepUpNotice": "މިކަން ރައްކާކުރުމުގެ ކުރިން، ތިޔަބޭފުޅުންގެ އޮތެންޓިކޭޝަން ކޯޑަށް އެދޭނެ.",
          "exportCsv": "ސީއެސްވީ ނަންގަވާ",
          "exportXlsx": "އެކްސެލް ނަންގަވާ",
          "exportedTitle": "ރިޓާން ނެގިއްޖެ",
          "exportedDetail": "{filename} ގެ ނަމުގައި ރައްކާކުރެވިއްޖެ.",
          "exportFailed": "ނެގުން ނާކާމިޔާބުވި",
          "evidence": "ހެކީގެ ބަނޑލް",
          "evidenceTitle": "ހެކީގެ ބަނޑލް ނެގިއްޖެ",
          "evidenceDetail": "{filename} ގެ ނަމުގައި ރައްކާކުރެވިއްޖެ. މި ނެގުމަކީވެސް އޮޑިޓްކުރެވޭ ޢަމަލެއް.",
          "evidenceFailed": "ހެކީގެ ބަނޑލް ނުނެގުނު"
        }
      },
      "via": {
        "explicit": {
          "label": "ޓައިޕްކުރި",
          "summary": "ލައިންގައި ސީދާ ކޯޑް ލިޔެފައިވާތީ، ރޫލް މެޗިންގ ފަހަނައަޅައިފި."
        },
        "rule": {
          "label": "ގްރޫޕް ރޫލް",
          "summary": "ޓެކްސް ގްރޫޕް ރޫލަކާ ދިމާވި — ސްޕައިންގެ ކުރީގެ މަގު."
        },
        "regime": {
          "label": "ރެޖީމް ރޫލް",
          "summary": "ތަރުތީބުކުރެވިފައިވާ ރެޖީމް ރޫލަކާ ދިމާވި؛ މިއީ އާދައިގެ މަގު."
        },
        "certificate": {
          "label": "ސެޓްފިކެޓް",
          "summary": "އިސްތިސްނާ ސެޓްފިކެޓަކުން، ރޫލުން ހޮވި ކޯޑް ބަދަލުކޮށްފި."
        },
        "unregistered": {
          "label": "ރަޖިސްޓްރީ ނުކުރޭ",
          "summary": "ރަޖިސްޓްރޭޝަނެއް ނެތުމުން، ރެޖީމްގެ ރަޖިސްޓްރީ ނުކުރާ ކޯޑް ބޭނުންކުރެވިއްޖެ."
        }
      },
      "baseKinds": {
        "net": {
          "label": "ނެޓްގެ މައްޗަށް",
          "summary": "ބޭހަކީ ހަމައެކަނި ލައިންގެ ނެޓް ޢަދަދު."
        },
        "net_plus_prior": {
          "label": "އެއްކުރެވޭ",
          "summary": "ބޭހަކީ ނެޓާއި، މި ފައިސާއިން ކުރިން އައި ކޮންމެ ސްޓެޕެއްގެ ބުރެއް ނުޖަހާ ސީދާ ޢަދަދު އެއްކޮށްފައި."
        }
      },
      "supplyTypes": {
        "goods": "މުދާ",
        "services": "ޚިދުމަތް",
        "accommodation": "ތިބުމުގެ ޚިދުމަތް",
        "fnb": "ކެއުމާއި ބުއިން",
        "digital": "ޑިޖިޓަލް",
        "transport": "ދަތުރުފަތުރު",
        "other": "އެހެނިހެން"
      },
      "channels": {
        "backOffice": "ބެކް އޮފީސް",
        "pos": "ޕޮއިންޓް އޮފް ސޭލް",
        "portal": "ޕޯޓަލް",
        "web": "ވެބް",
        "b2b": "ވިޔަފާރިން ވިޔަފާރިއަށް",
        "hospitality": "ހޮސްޕިޓާލިޓީ"
      },
      "priceBases": {
        "exclusive": {
          "label": "ޓެކްސް ނުހިމަނާ",
          "summary": "ޢަދަދަކީ ނެޓް؛ ޓެކްސް އޭގެ މައްޗަށް އިތުރުވާނެ."
        },
        "inclusive": {
          "label": "ޓެކްސް ހިމަނައިގެން",
          "summary": "ޢަދަދަކީ ކަސްޓަމަރަށް ބުނި ޖުމްލަ؛ ނެޓް އެއިން ނެރެވޭ، އަދި ބާކީ އަރާ ބައި ނެޓަށް ދާނެ."
        }
      },
      "partyClasses": {
        "registered": "ރަޖިސްޓްރީކޮށްފައި",
        "unregistered": "ރަޖިސްޓްރީ ނުކުރޭ",
        "export": "އެކްސްޕޯޓް",
        "government": "ސަރުކާރު",
        "exempt": "އިސްތިސްނާ",
        "non_resident": "ރެޒިޑެންޓް ނޫން"
      },
      "directions": {
        "output": "އައުޓްޕުޓް (ވިއްކުން)",
        "input": "އިންޕުޓް (ގަތުން)",
        "any": "ދެގޮތުންވެސް"
      },
      "placeBases": {
        "origin": {
          "label": "ފެށޭ ތަން",
          "summary": "މުދާ ނުވަތަ ޚިދުމަތް ދޫކުރެވޭ ތަނުގައި ޓެކްސް ނެގޭ."
        },
        "destination": {
          "label": "ދާ ތަން",
          "summary": "މުދާ ނުވަތަ ޚިދުމަތް ލިބޭ ތަނުގައި ޓެކްސް ނެގޭ."
        },
        "hybrid": {
          "label": "ދެގޮތް އެކުވެފައި",
          "summary": "ގަންނަ ފަރާތް އެތަނުގައި ރަޖިސްޓްރީކޮށްފައިވާނަމަ ދާ ތަން؛ އެހެންނޫނީ ފެށޭ ތަން."
        }
      },
      "warnings": {
        "TAX_POS_FALLBACK": "ދާ ތަނުގައި ރަޖިސްޓްރޭޝަނެއް ނެތުމުން، ފެށޭ ތަނުގެ ރޫލްތައް ބޭނުންކުރެވިއްޖެ.",
        "TAX_POS_OUT_OF_SCOPE": "މި ރެޖީމުން އެއްވެސް އެއްޗެއް ނާދޭ: ދާ ތަން އޭގެ ދާއިރާއިން ބޭރު.",
        "TAX_COMPOUND_SKIPPED_CURRENCY": "ކުރިން އައި ހުރިހާ ސްޓެޕެއް އެހެން ފައިސާއަކުން ވުމުން، މި ސްޓެޕް ހަމައެކަނި ނެޓްގެ މައްޗަށް ހިސާބުކުރެވިއްޖެ."
      },
      "routeTitles": {
        "packs": "ޤައުމީ ޓެކްސް ޕެކްތައް",
        "packUpdate": "ޓެކްސް ޕެކް އަޕްޑޭޓް",
        "jurisdictions": "ޓެކްސް ސަރަޙައްދުތައް",
        "registrations": "ޓެކްސް ރަޖިސްޓްރޭޝަންތައް",
        "certificates": "އިސްތިސްނާ ސެޓްފިކެޓްތައް",
        "returns": "ޓެކްސް ރިޓާންތައް",
        "return": "ޓެކްސް ރިޓާން",
        "simulator": "ޓެކްސް ސިމިއުލޭޓަރު",
        "charges": "ސާވިސް ޗާޖް ޕޫލްތައް"
      },
      "nav": {
        "packs": {
          "label": "ޓެކްސް ޕެކްތައް",
          "keywords": "ޕެކް ޤައުމު އެކްޓިވޭޝަން ޤާނޫނީ އަޕްޑޭޓް ޤަބޫލުކުރުން",
          "description": "ޤައުމެއްގެ ޕެކް އެކްޓިވޭޓްކޮށް، ޤާނޫނީ އަޕްޑޭޓްތައް ޤަބޫލުކުރައްވާ"
        },
        "jurisdictions": {
          "label": "ސަރަޙައްދުތަކާއި ރެޖީމްތައް",
          "keywords": "ސަރަޙައްދު ރެޖީމް ތަރުތީބު ޤައުމު ރަށް އަތޮޅު",
          "description": "ޓެކްސް ނަގާ ތަރުތީބާއި، އޭގައި ނަގާ ޓެކްސްތައް"
        },
        "registrations": {
          "label": "ޓެކްސް ރަޖިސްޓްރޭޝަން",
          "keywords": "ރަޖިސްޓްރޭޝަން ޖީއެސްޓީ ޓިން ނަންބަރު ކުންފުނި ރެޖީމް",
          "description": "ރަޖިސްޓްރޭޝަން ނަންބަރު، ސްކީމް އަދި ހުށަހަޅާ މުއްދަތުތައް"
        },
        "certificates": {
          "label": "އިސްތިސްނާ ސެޓްފިކެޓް",
          "keywords": "އިސްތިސްނާ ސެޓްފިކެޓް ޒީރޯ ރޭޓް މުއްދަތު",
          "description": "ޓެކްސް ކޯޑް ބަދަލުކުރާ ސެޓްފިކެޓްތަކާއި، މުއްދަތު ހަމަވާ ދުވަސް"
        },
        "returns": {
          "label": "ޓެކްސް ރިޓާން",
          "keywords": "ރިޓާން ފައިލިން ޖީއެސްޓީ ބޮކްސް ހިސާބު ސުންގަޑި",
          "description": "ރިޓާން ތައްޔާރުކޮށް، ހިސާބު ދިމާކޮށް، ފާސްކޮށް، ފައިލްކޮށް، ފައިސާ ދައްކާ"
        },
        "simulator": {
          "label": "ޓެކްސް ސިމިއުލޭޓަރު",
          "keywords": "ސިމިއުލޭޓް ޕްރިވިއު ތަފްޞީލް ވޯޓަރފޯލް",
          "description": "ލައިނަކަށް އަރާނެ ޓެކްސް ބަލައި، ހިސާބުކުރި ގޮތް ދެކިލައްވާ"
        },
        "charges": {
          "label": "ސާވިސް ޗާޖް ޕޫލް",
          "keywords": "ސާވިސް ޗާޖް ޕޫލް އައުޓްލެޓް ބެހުން",
          "description": "މުއްދަތެއްގައި ޕޫލަކަށް ޖަމާވި ސާވިސް ޗާޖް"
        }
      },
      "packs": {
        "title": "ޤައުމީ ޓެކްސް ޕެކްތައް",
        "description": "މި ވޯކްސްޕޭސްގައި ޓެކްސް ހިސާބުކުރަނީ ކޮން ޤައުމެއްގެ ޤާނޫނީ ރޫލްތަކުންކަމާއި، ނިންމުމަކަށް އިންތިޒާރުކުރާ ކަންކަން.",
        "loadFailed": "އެކްޓިވޭޝަން ލިސްޓް ނުލިބުނު",
        "emptyTitle": "އަދި އެއްވެސް ޤައުމީ ޕެކެއް ހިނގަމުން ނުދޭ",
        "emptyDescription": "ޕެކެއް އެކްޓިވޭޓް ނުކުރާހާ ހިނދަކު ސަރަޙައްދުތަކެއް، ރެޖީމްތަކެއް، ރަޖިސްޓްރޭޝަނެއް އަދި ރިޓާނެއްވެސް ނުހެދޭނެ — ޓެކްސް ހިސާބުކުރެވޭނީ ކުރީގެ ގްރޫޕް ރޫލްތަކުން. ޤާނޫނީ ސްޕައިން ހޯއްދެވުމަށް ޤައުމެއް އެކްޓިވޭޓް ކުރައްވާ.",
        "pendingSummary": "{count} ޤައުމީ ޕެކަކަށް އައު ވަރޝަނެއް، ތިޔަބޭފުޅުންގެ ނިންމުމަށް އިންތިޒާރުކުރަނީ."
      },
      "activate": {
        "title": "ޤައުމީ ޕެކެއް އެކްޓިވޭޓް ކުރައްވާ",
        "description": "ޝާއިޢުކުރެވިފައިވާ ޕެކްގެ ސަރަޙައްދު، ރެޖީމް، ކޯޑް އަދި ރޫލްތައް މި ވޯކްސްޕޭސްއަށް ކޮޕީކުރާނެ.",
        "action": "ޤައުމެއް އެކްޓިވޭޓް ކުރައްވާ",
        "activating": "އެކްޓިވޭޓް ކުރަނީ",
        "country": "ޤައުމުގެ ކޯޑް",
        "countryHint": "ދެ އަކުރުގެ އައިއެސްއޯ 3166-1 ކޯޑް. އެ ޤައުމަށް ޕެކެއް ޝާއިޢުކޮށްފައި އޮންނަންވާނެ.",
        "countryPlaceholder": "މިސާލު: MV",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "effectiveFromHint": "މި ދުވަހުން ފެށިގެން ތާރީޚް ޖެހޭ ލިޔުންތައް ޕެކުން ހިސާބުކުރެވޭނެ.",
        "whatHappens": "ތިޔަބޭފުޅުން އަމިއްލައަށް ހެއްދެވި ރޯތަކަށް، އެކްޓިވޭޝަނުން ނުވަތަ ފަހުން ސިންކްކުރުމުން، އެއްވެސް ބަދަލެއް ނާންނާނެ.",
        "done": "ޤައުމީ ޕެކް އެކްޓިވޭޓްކޮށްފި",
        "doneDetail": "ސަރަޙައްދު، ރެޖީމް، ކޯޑް އަދި ރޫލްތައް މި ވޯކްސްޕޭސްއަށް ކޮޕީކުރެވިއްޖެ."
      },
      "update": {
        "title": "{country} ޓެކްސް ޕެކް",
        "description": "އަޕްޑޭޓުން ބަދަލުވާ ކަންކަން، ތިޔަބޭފުޅުންގެ ޕޯސްޓްކޮށްފައިވާ ލިޔުންތަކަށް ކުރާނެ އަސަރު، އަދި ނިންމުން.",
        "currentTitle": "މިހާރު ހިނގަމުންދޭ",
        "pendingVersion": "އިންތިޒާރުކުރާ ވަރޝަން",
        "upToDate": "ތިޔަބޭފުޅުން ތިއްބެވީ ޝާއިޢުކުރެވިފައިވާ އެންމެ އައު ވަރޝަނުގައި.",
        "diffTitle": "ބަދަލުވާ ކަންކަން",
        "diffDescription": "ފުރަތަމަ ޓެކްސް ކޯޑާއި ރޫލްތައް، ސަބަބަކީ ރޭޓް ބަދަލުވުމަކީ ނިންމުމަކަށްވާތީ.",
        "diffFailed": "އަޅާކިޔުން ނުލިބުނު",
        "notActivatedTitle": "{country} ގެ ޕެކެއް މިތާ އެކްޓިވޭޓްކޮށްފައެއް ނެތް",
        "notActivatedDescription": "މި ޤައުމުގެ ޕެކެއް މި ވޯކްސްޕޭސްގައި އެކްޓިވޭޓް ކުރަންދެން ބަލާނެ އެއްޗެއް ނެތް.",
        "backToPacks": "ޤައުމީ ޕެކްތަކަށް"
      },
      "diff": {
        "sections": {
          "taxCodes": "ޓެކްސް ކޯޑްތައް",
          "rules": "ރޫލްތައް",
          "regimes": "ރެޖީމްތައް",
          "jurisdictions": "ސަރަޙައްދުތައް",
          "posRules": "ދޫކުރެވޭ ތަން",
          "priceBasis": "އަގުގެ ބިންގާ",
          "returnDefs": "ރިޓާން ތަޢާރަފް",
          "returnBoxes": "ރިޓާން ބޮކްސްތައް",
          "docRules": "ލިޔުމުގެ ރޫލްތައް",
          "payrollRules": "ޕޭރޯލް ރޫލްތައް"
        },
        "added": "{count} އިތުރުކުރި",
        "changed": "{count} ބަދަލުކުރި",
        "withdrawn": "{count} އުނިކުރި",
        "rowAdded": "އައު",
        "rowWithdrawn": "އުނިކުރި",
        "movesMoney": "ފައިސާއަށް އަސަރުކުރޭ",
        "unnamedRow": "(ނަން ނެތް ރޯ)",
        "emptyTitle": "ބަދަލެއް ނެތް",
        "emptyDescription": "އިންތިޒާރުކުރާ ވަރޝަނާއި ހިނގަމުންދާ ވަރޝަން، ކޮންމެ ރޯއެއްވެސް އެއްގޮތް."
      },
      "sandbox": {
        "title": "ސޭންޑްބޮކްސް ބެލުން",
        "description": "ތިޔަބޭފުޅުންގެ ޕޯސްޓްކޮށްފައިވާ ލިޔުންތަކުގެ ސާމްޕަލެއް، އިންތިޒާރުކުރާ ޕެކުން އަލުން ހިސާބުކޮށްފައި.",
        "action": "ސޭންޑްބޮކްސް ހިންގަވާ",
        "running": "ލިޔުންތައް އަލުން ހިސާބުކުރަނީ",
        "ranAt": "ހިންގި ވަގުތު",
        "sampleSize": "ބެލި ލިޔުންތައް",
        "differences": "ތަފާތުތައް",
        "treatmentChanges": "ޓްރީޓްމަންޓް ބަދަލުވި",
        "clean": "ބެލި {count} ލިޔުމުގެ ތެރެއިން އެއްވެސް ލިޔުމެއް ތަފާތުކޮށް ހިސާބެއް ނުކުރެވޭނެ.",
        "dirty": "{count} ލިޔުމެއް ތަފާތުކޮށް ހިސާބުކުރެވޭނެ. ރޭޓް ބަދަލުވުމުން ތަފާތު އަންނާނެ — ނިންމުމުގެ ކުރިން ބޮޑުމިނާއި މިސްރާބު ބައްލަވާ.",
        "notRunTitle": "ސޭންޑްބޮކްސް ހިންގާފައެއް ނެތް",
        "notRunDescription": "އަދި އެއްވެސް އެއްޗެއް ބަލާފައެއް ނެތް. \"ނުބަލަން\" އާއި \"ބެލީމަ ރަނގަޅު\" އަކީ ދެ ތަފާތު ޙަޤީޤަތެއް.",
        "tableCaption": "އިންތިޒާރުކުރާ ޕެކުން ޓެކްސް ބަދަލުވާނެ ލިޔުންތައް",
        "columns": {
          "document": "ލިޔުން",
          "taxCode": "ޓެކްސް ކޯޑް",
          "treatment": "ޓްރީޓްމަންޓް",
          "oldAmount": "މިހާރު",
          "newAmount": "ފަހުން",
          "reason": "ސަބަބު"
        },
        "doneTitle": "ސޭންޑްބޮކްސް ނިމިއްޖެ",
        "doneDetail": "ފެނުނު ތަފާތުތައް ތިރީގައި.",
        "failedTitle": "ސޭންޑްބޮކްސް ނާކާމިޔާބުވި"
      },
      "accept": {
        "title": "{country} ޕެކް އަޕްޑޭޓް ޤަބޫލުކުރެއްވުން",
        "description": "މިއިން، ފެށޭ ތާރީޚުން ފެށިގެން ކޮންމެ ލިޔުމެއް ހިސާބުކުރާ ޤާނޫނީ ރޫލްތައް ބަދަލުވާނެ. ފީލްޑެއް އެޑިޓްކޮށްގެން އަނބުރާ ނުގެނެވޭނެ.",
        "open": "އަޕްޑޭޓް ޤަބޫލުކުރައްވާ…",
        "summaryHeading": "ޤަބޫލުކުރައްވަނީ",
        "versionMove": "ވަރޝަން",
        "rowsChanged": "ރޯތައް",
        "rowsBreakdown": "{added} އިތުރު · {changed} ބަދަލު · {withdrawn} އުނި",
        "movesMoney": "އޭގެތެރެއިން ފައިސާއަށް އަސަރުކުރާ",
        "sandbox": "ސޭންޑްބޮކްސް",
        "sandboxNotRun": "ނުހިންގާ",
        "sandboxClean": "{count} ލިޔުމުގައި ތަފާތެއް ނެތް",
        "sandboxDirty": "{count} ތަފާތު",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "effectiveFromHint": "މި ދުވަހުން ފެށިގެން ތާރީޚް ޖެހޭ ލިޔުންތައް އައު ވަރޝަނުން ހިސާބުކުރެވޭނެ.",
        "backdatedWarning": "މި ތާރީޚަކީ މިއަދު ނުވަތަ އޭގެ ކުރީގެ ދުވަހެއް، އެހެންކަމުން ޕޯސްޓްކޮށްފައިވާ ލިޔުންތައްވެސް އައު ރޫލްތަކުގެ ދަށަށް ދާނެ. ޤާނޫނީ ބަދަލަކީ ސީދާ ފަހަތަށް ހިނގާ ބަދަލެއްނަމަ އެކަނި މިގޮތަށް ހައްދަވާ.",
        "note": "ޤަބޫލުކުރައްވާ ސަބަބު",
        "noteHint": "އޮޑިޓް ރެކޯޑްގައި ރައްކާކުރެވޭނެ. މަދުވެގެން ދިހަ އަކުރު.",
        "forceExplainDirty": "ސޭންޑްބޮކްސްއިން {count} ލިޔުމެއްގެ ޓެކްސް ބަދަލުވާނެކަން ފެނިއްޖެ. އެހެންވިޔަސް ޤަބޫލުކުރެއްވިދާނެ، ނަމަވެސް ވަކި ސަބަބެއް ބޭނުންވާނެ.",
        "forceExplainNotRun": "މި ވަރޝަނަށް ސޭންޑްބޮކްސް ހިންގާފައި ނުވާތީ، ތިޔަބޭފުޅުންގެ ލިޔުންތަކަށް ކުރާނެ އަސަރު އެނގޭކަށް ނެތް.",
        "forceLabel": "ސޭންޑްބޮކްސް ސާފު ނަތީޖާއެއް ނެތި ޤަބޫލުކުރައްވަން",
        "forceReason": "އެހެންވިޔަސް ޤަބޫލުކުރައްވާ ސަބަބު",
        "forceReasonHint": "ނޯޓާ ވަކިން ރައްކާކުރެވޭނެ. މަދުވެގެން ދިހަ އަކުރު.",
        "confirmLabel": "ޔަޤީންކުރެއްވުމަށް {country} ޓައިޕްކުރައްވާ",
        "confirmHint": "ނުބައިކޮށް ކްލިކްކޮށްގެން ނުކުރެވޭނެ އެންމެ ކުޑަ ޢަމަލު.",
        "stepUpNotice": "މިކަން ފުރިހަމަކުރުމުގެ ކުރިން، ތިޔަބޭފުޅުންގެ އޮތެންޓިކޭޝަން ކޯޑަށް އެދޭނެ.",
        "confirmAction": "ވަރޝަން {version} ޤަބޫލުކުރައްވާ",
        "accepting": "އަޕްޑޭޓް ހިންގަނީ",
        "doneTitle": "ޕެކް އަޕްޑޭޓް ޤަބޫލުކުރެވިއްޖެ",
        "doneDetail": "ފެށޭ ތާރީޚުން ފެށިގެން ތާރީޚް ޖެހޭ ލިޔުންތައް، މިހާރު އައު ވަރޝަނުން ހިސާބުކުރެވޭނެ."
      },
      "jurisdictions": {
        "title": "ސަރަޙައްދުތަކާއި ރެޖީމްތައް",
        "description": "މި ވޯކްސްޕޭސްގައި ޓެކްސް ހިސާބުކުރާ ތަރުތީބާއި، ކޮންމެ ދަރަޖައެއްގައި ނަގާ ޓެކްސްތައް.",
        "country": "ޤައުމު",
        "packVersionHint": "ޕެކް v{version}",
        "treeTitle": "ތަރުތީބު",
        "treeDescription": "ޤައުމުގެ ދަރަޖައިގައި އޮންނަ ރެޖީމެއް، އޭގެ ދަށުގައިވާ ހުރިހާ ދަރަޖައަކަށް ހިނގާނެ؛ ރަށުގެ ދަރަޖައިގައި އޮންނަ ރެޖީމަކަށް އެހެނެއް ނުވާނެ.",
        "treeLabel": "ޓެކްސް ސަރަޙައްދުތަކުގެ ތަރުތީބު",
        "treeFailed": "ތަރުތީބު ނުލިބުނު",
        "inactive": "ނުހިނގާ",
        "emptyTreeTitle": "މި ޤައުމުގައި ސަރަޙައްދުތަކެއް ނެތް",
        "emptyTreeDescription": "މި ޤައުމަށް އެކްޓިވޭޓްކުރި ޕެކްގައި ޓެކްސް ނަގާ ދަރަޖައެއް ބަޔާންކޮށްފައެއް ނެތް. އޮޕަރޭޓަރާ ގުޅުއްވާ.",
        "noPackTitle": "އެއްވެސް ޤައުމީ ޕެކެއް ހިނގަމުން ނުދޭ",
        "noPackDescription": "ފުރަތަމަ ޤައުމީ ޕެކެއް އެކްޓިވޭޓް ކުރައްވާ؛ ސަރަޙައްދުތަކުގެ ތަރުތީބު ކޮޕީވާނީ އެއިން."
      },
      "regimes": {
        "tableLabel": "ޓެކްސް ރެޖީމްތައް",
        "loadFailed": "ރެޖީމް ލިސްޓް ނުލިބުނު",
        "orderCaption": "ސޯޓް އޯޑަރުން ތަރުތީބުކޮށްފައި — އެއް ރެޖީމް އަނެއް ރެޖީމްގެ މައްޗަށް އެއްކުރެވެނީ އެ ތަރުތީބުގެ ސަބަބުން.",
        "columns": {
          "code": "ރެޖީމް",
          "kind": "ބާވަތް",
          "jurisdiction": "ނަގާ ދަރަޖަ",
          "sortOrder": "ސޯޓް އޯޑަރު",
          "filingCurrency": "ހުށަހަޅާ ފައިސާ",
          "unregistered": "ރަޖިސްޓްރީ ނުކުރާނަމަ",
          "active": "ޙާލަތު"
        },
        "unregisteredRefused": "ހިސާބުކުރުން ހުއްޓޭނެ",
        "active": "ހިނގަމުންދޭ",
        "inactive": "ނުހިނގާ",
        "emptyTitle": "ރެޖީމެއް ނެތް",
        "emptyDescription": "ރެޖީމްތައް މި ވޯކްސްޕޭސްއަށް ގެނައުމަށް ޤައުމީ ޕެކެއް އެކްޓިވޭޓް ކުރައްވާ."
      },
      "expiry": {
        "expired": "{days} ދުވަސް ކުރިން މުއްދަތު ހަމަވެއްޖެ",
        "expiring": "{days} ދުވަހުން މުއްދަތު ހަމަވާނެ",
        "future": "{days} ދުވަހުން ފެށޭނެ",
        "open": "ނިމޭ ތާރީޚެއް ނެތް",
        "statusDisagrees": "ރައްކާކޮށްފައިވާ ޙާލަތާއި މި ތާރީޚްތަކާ ދިމައެއް ނުވޭ"
      },
      "waterfall": {
        "lineLabel": "ލައިން {lineNo} ގެ ޓެކްސް ތަރުތީބު",
        "tableCaption": "ލައިން {lineNo} ގެ ތަރުތީބުކުރެވިފައިވާ ޓެކްސް ސްޓެޕްތައް",
        "line": "ލައިން {lineNo}",
        "net": "ނެޓް",
        "gross": "ޖުމްލަ",
        "inclusive": "ޓެކްސް ހިމަނައިގެން",
        "columns": {
          "seq": "ސްޓެޕް",
          "code": "ޓެކްސް ކޯޑް",
          "base": "ބޭސް",
          "rate": "ރޭޓް",
          "amount": "ޢަދަދު"
        },
        "units": "ޔުނިޓް",
        "orderedBy": "{level} {jurisdiction} · ރެޖީމް ސޯޓް {sortOrder}",
        "viaCertificate": "ސެޓްފިކެޓް {number} އިން، ރޫލްގެ ކޯޑް ބަދަލުކޮށްފި.",
        "reverseChargePair": "ރިވާސް ޗާޖް: ދެ ފަހަރު ނެރެވޭ — އެއްފަހަރު އިންޕުޓް، އަނެއްފަހަރު އައުޓްޕުޓް.",
        "perUnitNote": "ޔުނިޓަކަށް ނަގާ ކޯޑަކުން ލައިންގެ އަގަށް ނުބަލާ؛ {base} ރައްކާކުރެވެނީ އޮޑިޓަށް.",
        "currencyExcluded": "ރޮނގު ދަމާލެވިފައިވާ ބައި ވަނީ އެހެން ފައިސާއަކުން، އެހެންވެ މި ބޭހުގައި ނުހިމަނާ.",
        "baseDoesNotTie": "މި ބޭސް، އޭގެ ބައިތަކުގެ ޖުމްލައާ ދިމައެއް ނުވޭ. ތަފާތަކީ {amount}.",
        "inclusiveResidual": "ދައްކާފައިވާ ނެޓާ {amount} ގެ ތަފާތެއް: ޓެކްސް ހިމަނައިގެން އޮތް ލައިނެއްގައި ބޭސްތައް ހެދެނީ ސީދާ ނެރެވުނު ނެޓުން، އަދި ބާކީ އަރާ ބައި ފަހުން ނެޓަށް ދާނެ.",
        "documentRounded": "ލިޔުމުގައި އެއްފަހަރު ބުރެއް ޖަހާފައި",
        "vatFraction": "ބޭސް × ރޭޓް ≠ ޓެކްސް",
        "vatFractionTooltip": "ޓެކްސް ހިމަނައިގެން އަގު ކަނޑައަޅާއިރު، ރައްކާކުރެވޭ ބޭހާއި ޓެކްސް ވަކިވަކިން ރަނގަޅު، ނަމަވެސް އެ ދޭތީގެ ނިސްބަތަކީ ރޭޓެއް ނޫން.",
        "doesNotFoot": "ޖުމްލަ ދިމައެއް ނުވޭ: ތަފާތު {amount}",
        "lineTax": "މި ލައިންގެ ޓެކްސް",
        "postedOnTop": "މީގެ އިތުރުން",
        "totalNet": "ޖުމްލަ ނެޓް",
        "totalTax": "ޖުމްލަ ޓެކްސް",
        "totalGross": "ޖުމްލަ"
      },
      "simulator": {
        "title": "ޓެކްސް ސިމިއުލޭޓަރު",
        "description": "ލައިނަކަށް އަރާނެ ޓެކްސް އިންޖީނުން ބައްލަވައި، ހިސާބުކުރި ގޮތްވެސް ދެކިލައްވާ.",
        "writesNothing": "ސިމިއުލޭޓްކުރުމުން، ލިޔުމަކަށް ހިނގާ ފަސް މަރުޙަލާ ހިނގާނެ، އަދި އެއްޗެއް ރައްކާނުކުރާނެ.",
        "preset": "ރިސޯޓް ރެއެއްގެ މިސާލު ލޯޑްކުރައްވާ",
        "run": "ސިމިއުލޭޓް ކުރައްވާ",
        "running": "އިންޖީނު ހިންގަނީ",
        "failed": "ސިމިއުލޭޝަން ނާކާމިޔާބުވި",
        "contextTitle": "ޙާލަތު",
        "lineTitle": "ލައިން",
        "lineDescription": "އެއްކުރުމާއި، ޓެކްސް ހިމަނައިގެން އޮތް އަގާއި، ޔުނިޓަކަށް ނަގާ ލެވީ ބެލުމަށް އެއް ލައިން ފުދޭނެ.",
        "placeTitle": "ދޫކުރެވޭ ތަން",
        "placeDescription": "ހިނގާނީ ކޮން ސަރަޙައްދެއް، ބަނދެވެނީ ކޮން ރެޖީމްތަކެއް، އަދި ކޮން ރަޖިސްޓްރޭޝަނެއްގެ ދަށުން.",
        "governing": "ހިނގާ ސަރަޙައްދު",
        "chain": "ތަރުތީބު",
        "fallback": "ދާ ތަނުގައި ރަޖިސްޓްރޭޝަނެއް ނެތުމުން، ފެށޭ ތަނުގެ ރޫލްތައް ބޭނުންކުރެވިއްޖެ. ޢަދަދުތަކުން މިކަން ނުފެންނާނެ.",
        "bindingsCaption": "މި މުޢާމަލާތާ ބަނދެވުނު ރެޖީމްތައް",
        "columns": {
          "regime": "ރެޖީމް",
          "basis": "ތަނުގެ ރޫލް",
          "jurisdiction": "ބަނދެވުނު ތަން",
          "registration": "ރަޖިސްޓްރޭޝަން"
        },
        "unregistered": "ރަޖިސްޓްރީ ނުކުރާ ކޯޑް ބޭނުންކުރި",
        "resultTitle": "ޓެކްސް ނެރުނު ގޮތް",
        "resultDescription": "ކޮންމެ ކޯޑެއް، އޭގެ ބޭސް ބައިބައިން، ރޭޓް އަދި ޢަދަދު — ހިސާބުކުރި ތަރުތީބުން.",
        "emptyTitle": "އަދި ސިމިއުލޭޓް ކޮށްފައެއް ނެތް",
        "emptyDescription": "ޙާލަތަކާއި ލައިނެއް ކަނޑައަޅުއްވާފައި ސިމިއުލޭޓް ކުރައްވާ. އެއްޗެއް ރައްކާނުކުރާތީ، ކޮންމެ އެއްޗެއްވެސް ބައްލަވާލެއްވިދާނެ.",
        "fields": {
          "company": "ކުންފުނި",
          "direction": "މިސްރާބު",
          "supplyType": "މުޢާމަލާތުގެ ބާވަތް",
          "supplyTypeHint": "ދޫކުރެވެނީ ކޯއްޗެއް — ދޫކުރެވޭ ތަނުގެ ރޫލް ބިނާވަނީ މީގެ މައްޗަށް.",
          "channel": "ޗެނަލް",
          "channelHint": "ލިޔުން ހެދި ތަން.",
          "date": "ވިޔަފާރީގެ ތާރީޚް",
          "dateHint": "ކޮންމެ ކޯޑެއް، ރޫލެއް، ރަޖިސްޓްރޭޝަނެއް އަދި ސެޓްފިކެޓެއްގެ ހިނގާ ވަރޝަން ހޮވަނީ މީގެ މައްޗަށް.",
          "currency": "ފައިސާ",
          "priceBasis": "އަގުގެ ބިންގާ",
          "partyClass": "އަނެއް ފަރާތުގެ ދަރަޖަ",
          "partyClassHint": "ޕެކުން ދަރަޖަކުރާ ގޮތުން، އަނެއް ފަރާތުގެ ޤާނޫނީ ޙާލަތު.",
          "partyRegistered": "އަނެއް ފަރާތް ދާ ތަނުގައި ރަޖިސްޓްރީކޮށްފައި",
          "partyRegisteredHint": "ދެގޮތް އެކުވެފައިވާ ރޫލެއްގައި، ދާ ތަނަށް ފޮނުވޭނީ މިކަން ތެދުވެއްޖެނަމަ އެކަނި.",
          "shipTo": "ފޮނުވާ ޤައުމު",
          "shipToHint": "ދެ އަކުރުގެ ކޯޑް. ރާއްޖޭގައި ދޫކުރާނަމަ ހުސްކޮށް ބާއްވަވާ.",
          "property": "ޕްރޮޕަޓީގެ ސަރަޙައްދު",
          "propertyHint": "ތިބުމުގެ ނުވަތަ ކެއިންބުއިމުގެ ޚިދުމަތް ދެވޭ ސީދާ ތަން. މިއިން ފޮނުވާ ތަން ބަދަލުކުރާނެ.",
          "amount": "ޢަދަދު",
          "amountExclusive": "ނެޓް؛ ޓެކްސް އޭގެ މައްޗަށް އިތުރުވާނެ.",
          "amountInclusive": "ކަސްޓަމަރަށް ބުނި ޖުމްލަ؛ ނެޓް ނެރެވޭނީ އެއިން.",
          "quantity": "ޢަދަދު (ކޮޅު)",
          "levyUnits": "ލެވީ ޔުނިޓް",
          "levyUnitsHint": "ޔުނިޓަކަށް ނަގާ ކޯޑަކުން ގުނަކުރާ ޢަދަދު — ގެސްޓް ނައިޓް، ލީޓަރު. ސުމެއްނަމަ ކޮޅުގެ ޢަދަދު ބޭނުންކުރެވޭނެ.",
          "taxCode": "ޓެކްސް ކޯޑް ބަދަލުކުރުން",
          "taxCodeHint": "މިތާ ކޯޑެއް ލިޔުއްވައިފިނަމަ ރޫލް މެޗިންގ ދޫކޮށް، ސީދާ އެއް ސްޓެޕް ދޭނެ.",
          "itemClass": "އައިޓަމް ކްލާސް",
          "itemClassHint": "ރޫލެއް ބިނާވެފައިވާނަމަ، ޕެކްގެ އަމިއްލަ އައިޓަމް ދަރަޖަކުރުން."
        }
      },
      "charges": {
        "title": "ސާވިސް ޗާޖް ޕޫލް",
        "description": "މުއްދަތެއްގައި ޕޫލަކަށް ޖަމާވި ޢަދަދު، ބެހުމަށް ތައްޔާރު.",
        "notATax": "ސާވިސް ޗާޖަކީ ޓެކުހެއް ނޫން. ޓެކްސް ފަދައިން ހިސާބުކުރެވި، އިންވޮއިސްގެ ޖުމްލައާއި ފަހުގެ ޓެކުހުގެ ބޭހުގައި ހިމެނޭ، ނަމަވެސް އެއްވެސް ރިޓާން ބޮކްސްއެއްގައި ނުހިމެނޭ — މިއީ އެހެން ބައެއްގެ ބަދަލުގައި ނަގާ ފައިސާ.",
        "loadFailed": "ޗާޖް ޕޫލްތައް ނުލިބުނު",
        "tableLabel": "ސާވިސް ޗާޖް ޕޫލްތައް",
        "emptyTitle": "މި މުއްދަތުގައި ސާވިސް ޗާޖެއް ނެތް",
        "emptyDescription": "މި ދެ ތާރީޚް ދެމެދު، ޗާޖް ބާވަތުގެ ކޯޑެއް ހިމެނޭ އެއްޗެއް ޕޯސްޓްވެފައެއް ނެތް. މުއްދަތު ފުޅާކުރައްވާ، ނުވަތަ އައުޓްލެޓްގެ ލިޔުންތަކުގައި ޕޫލް ކީ ހިމެނޭތޯ ބައްލަވާ.",
        "unpooled": "(ޕޫލް ކީއެއް ނެތް)",
        "thisMonth": "މި މަސް",
        "filters": {
          "company": "ކުންފުނި",
          "from": "އިން",
          "to": "އަށް",
          "poolKey": "ޕޫލް ކީ",
          "poolKeyHint": "އައުޓްލެޓް، ބްރާންޗް ނުވަތަ ކޮސްޓް ސެންޓަރު.",
          "taxCode": "ޓެކްސް ކޯޑް"
        },
        "columns": {
          "pool": "ޕޫލް",
          "currency": "ފައިސާ",
          "base": "ބޭސް",
          "amount": "ޖަމާވި",
          "lines": "ލައިން",
          "documents": "ލިޔުން"
        }
      }
    }
  },
  "fx": {
    "fields": {
      "base": "އަސާސީ ފައިސާ",
      "baseHint": "އެއް ޔުނިޓުގެ އަގު ކިޔޭ ފައިސާ.",
      "quote": "ކޯޓް ފައިސާ",
      "quoteHint": "އަގު ބަޔާންކުރެވޭ ފައިސާ.",
      "rate": "ރޭޓް",
      "rateHint": "ލިޔުއްވި ގޮތަށް ސީދާ، {decimals} ދިހަގުނަ ޖާގައަށް ރައްކާކުރެވެއެވެ.",
      "asOf": "ތާރީޚު",
      "asOfHint": "މި ރޭޓް ފެނުނު ދުވަސް. ފަހުގެ ރޭޓެއް ވެއްދެންދެން މި ރޭޓް ދެމިއޮންނާނެއެވެ.",
      "note": "ނޯޓް"
    },
    "sources": {
      "manual": "އަތުން ވެއްދި",
      "api": "އަމިއްލައަށް ގެނެވުނު"
    },
    "methods": {
      "direct": {
        "label": "ސީދާ ކޯޓް",
        "summary": "މި ޖޯޑު ކޯޓްކުރެވިފައިވެއެވެ، އަދި ރޭޓަކީ އެ ފެނުނު އަދަދެވެ."
      },
      "inverse": {
        "label": "އިދިކޮޅުކުރެވިފައި",
        "summary": "ކޯޓްކުރެވިފައިވަނީ އިދިކޮޅު ޖޯޑު އެކަނި ކަމުން، މި ރޭޓަކީ އޭގެ އިދިކޮޅު އަދަދެވެ. ސީދާވަނީ އަށް ދިހަގުނަ ޖާގައަށެވެ؛ އެއަށްވުރެ ދުރަކަށް ނޫނެވެ."
      },
      "identity": {
        "label": "އެއް ފައިސާ",
        "summary": "ފައިސާއެއް އޭގެ އަމިއްލަ ނަފްސާ އަޅާކިޔުމަށް އެއްވެސް ރެކޯޑެއް ބޭނުމެއް ނުވެއެވެ."
      }
    },
    "currencies": {
      "title": "ފައިސާގެ ބާވަތްތައް",
      "description": "މި ވަރކްސްޕޭސްގައި މުޢާމަލާތްކުރާ ފައިސާގެ ބާވަތްތައް. ލޯކަލައިޒޭޝަން ޕެކުން އިތުރުކުރެވި، ފަހުން އެޑިޓްކުރެވެއެވެ.",
      "tableLabel": "ފައިސާގެ ބާވަތްތައް",
      "loadFailed": "ފައިސާގެ ބާވަތްތައް ނުލޯޑްވިއެވެ",
      "add": "ފައިސާއެއް އިތުރުކުރޭ",
      "editTitle": "{code} އެޑިޓްކުރޭ",
      "upsertNote": "މިހާރު އޮތް ކޯޑެއް ރައްކާކުރުމުން، ދެވަނަ އެއްޗެއް ނުއުފައްދައި އެ އަޕްޑޭޓްކުރެއެވެ.",
      "columns": {
        "code": "ކޯޑު",
        "symbol": "ނިޝާން",
        "minorUnits": "ދިހަގުނަ ޖާގަ"
      },
      "codeHint": "ތިން އަކުރު، އައިއެސްއޯ 4217، މިސާލަކަށް MVR.",
      "symbolHint": "އަދަދުތަކުގެ ކައިރީގައި ދެއްކޭ، މިސާލަކަށް ރ ނުވަތަ $.",
      "minorUnitsHint": "މި ފައިސާ ކޯޓްކުރެވެނީ ކިތައް ދިހަގުނަ ޖާގައަށްކަން: ރުފިޔާއަށް 2، ޔެންއަށް 0، ދީނާރަށް 3.",
      "activeLabel": "ލިޔުންތަކުގައި ބޭނުންކުރެވޭ",
      "activeHint": "މި ނިއްވާލުމުން އައު ލިޔުންތަކުން ފައިސާ ފޮރުވެއެވެ. ޕޯސްޓްކޮށްފައިވާ ލިޔުންތަކުގައި ދެމިހުންނާނެއެވެ.",
      "active": "ހިނގަމުންދާ",
      "inactive": "ހުއްޓިފައި",
      "activeOnly": "ހިނގަމުންދާ އެކަނި",
      "searchPlaceholder": "ކޯޑު ނުވަތަ ނަން ހޯއްދަވާ",
      "searchLabel": "ފައިސާގެ ބާވަތްތައް ހޯއްދަވާ",
      "emptyTitle": "އަދި ފައިސާއެއް ނެތެވެ",
      "emptyDescription": "ކޮންމެ އަދަދެއް ބެހެއްޓެނީ ފައިސާއެއްގައި ކަމުން، މަދުވެގެން ކުންފުނީގެ އަސާސީ ފައިސާ އޮންނަންޖެހެއެވެ. މިތަނުން އިތުރުކުރައްވާ.",
      "added": "ފައިސާ އިތުރުކުރެވިއްޖެ",
      "updated": "ފައިސާ އަޕްޑޭޓްކުރެވިއްޖެ",
      "savedDetail": "{code} ލިޔުންތަކުގައި ބޭނުންކުރެވޭނެއެވެ.",
      "saveFailed": "ފައިސާ ރައްކާއެއް ނުކުރެވުނެވެ"
    },
    "rates": {
      "title": "ބަދަލުކުރާ ރޭޓުތައް",
      "description": "ރޭޓް ކިޔެނީ މިހެންނެވެ: އަސާސީ ފައިސާގެ އެއް ޔުނިޓުން، ކޯޓް ފައިސާގެ މިވަރު ޔުނިޓް ގަނެވެއެވެ.",
      "tableLabel": "ރެކޯޑްކޮށްފައިވާ ބަދަލުކުރާ ރޭޓުތައް",
      "loadFailed": "ރޭޓުތައް ނުލޯޑްވިއެވެ",
      "record": "ރޭޓެއް ރެކޯޑްކުރޭ",
      "recordFirst": "ފުރަތަމަ ރޭޓް ރެކޯޑްކުރޭ",
      "anyBase": "ކޮންމެ އަސާސެއް",
      "anyQuote": "ކޮންމެ ކޯޓެއް",
      "fromLabel": "ތާރީޚު ފެށޭ",
      "toLabel": "ތާރީޚު ނިމޭ",
      "columns": {
        "pair": "ޖޯޑު",
        "rate": "ރޭޓް",
        "asOf": "ތާރީޚު",
        "source": "މަޞްދަރު",
        "note": "ނޯޓް"
      },
      "emptyTitle": "ރެކޯޑްކޮށްފައިވާ ރޭޓެއް ނެތެވެ",
      "emptyDescription": "ރޭޓެއް ނެތި، ބޭރު ފައިސާއެއްގެ ލިޔުމަކަށް އަގު ނުކުރެވޭނެއެވެ — ސިސްޓަމުން 1:1 ކަމަށް ނުބަލައެވެ. ފުރަތަމަ ރޭޓް ރެކޯޑްކުރައްވާ.",
      "export": {
        "done": "ރޭޓުތައް އެކްސްޕޯޓްކުރެވިއްޖެ",
        "failed": "އެކްސްޕޯޓް ފުރިހަމައެއް ނުވިއެވެ"
      }
    },
    "rateEditor": {
      "title": "ބަދަލުކުރާ ރޭޓެއް ރެކޯޑްކުރޭ",
      "description": "އެއް ދުވަހެއްގައި އެއް ޖޯޑެއް އަލުން ރެކޯޑްކުރުމުން، ދެވަނަ އެއްޗެއް ނުއިތުރުކޮށް އެ ރެކޯޑް އިޞްލާޙުކުރެއެވެ.",
      "correctTitle": "މި ރޭޓް އިޞްލާޙުކުރޭ",
      "correctDescription": "ޖޯޑާއި ތާރީޚުން ރެކޯޑް ފާހަގަކުރެވޭތީ، ބަދަލުކުރެވޭނީ ރޭޓާއި ނޯޓް އެކަންޏެވެ.",
      "correct": "އިޞްލާޙު ރައްކާކުރޭ",
      "sameCurrency": "ފައިސާއެއް އޭގެ އަމިއްލަ ނަފްސާ އަޅާކިޔުމުން އަބަދުވެސް 1 އެވެ. އެހެންކަމުން ރެކޯޑްކުރާނެ އެއްޗެއް ނެތެވެ.",
      "reading": "1 {base} އިން {rate} {quote} ގަނެވެއެވެ.",
      "recorded": "ރޭޓް ރެކޯޑްކުރެވިއްޖެ",
      "corrected": "ރޭޓް އިޞްލާޙުކުރެވިއްޖެ",
      "savedDetail": "{asOf} ގައި {base} އިން {quote} އަށް.",
      "saveFailed": "ރޭޓް ރައްކާއެއް ނުކުރެވުނެވެ",
      "heldTitle": "ރޭޓް މަޑުޖައްސާލެވިއްޖެ",
      "heldDetail": "{base}/{quote} {movePct}% ބަދަލުވެއްޖެ، ކަނޑައެޅިފައިވާ ޓޮލަރެންސަށްވުރެ ބޮޑަށް. އެހެންކަމުން ބޭނުމެއް ނުކުރެވެއެވެ.",
      "heldExplain": "އެއްވެސް ކަމެއް ފެއިލެއް ނުވޭ، އަދި އެއްވެސް އެއްޗެއް ރައްކާވެސް ނުވެއެވެ: މި ރެކޯޑް އިންތިޒާރުކުރަނީ ޤަބޫލުކުރާނެ ނުވަތަ ބޭރުކުރާނެ މީހަކަށެވެ.",
      "heldLink": "މަޑުޖައްސާލެވިފައިވާ ރޭޓްތައް ހުޅުވާ"
    },
    "resolver": {
      "title": "އަމަލުކުރާ ރޭޓް",
      "description": "ވަކި ދުވަހެއްގައި ތާރީޚު ޖެހިފައިވާ ލިޔުމަކުން ޙަޤީޤަތުގައި ބޭނުންކުރާނެ އަދަދާއި، އެ އަދަދު އައި ތަން.",
      "onLabel": "ތާރީޚު",
      "onHint": "މި ތާރީޚަށްވުރެ ފަހުގެ ރޭޓެއް ބޭނުމެއް ނުކުރެވެއެވެ؛ އެއިން ފާއިތުވި ދުވަސްތަކުގެ އަގު ބަދަލުވެދާނެއެވެ.",
      "run": "ހިސާބުކުރޭ",
      "running": "ހިސާބުކުރަނީ",
      "empty": "ޖޯޑަކާއި ތާރީޚެއް ހޮއްވަވައިގެން، އަމަލުކުރާ ރޭޓާއި އެ ލިބުނު ގޮތް ބައްލަވާ.",
      "result": {
        "rate": "ރޭޓް",
        "method": "ލިބުނު ގޮތް",
        "asOf": "ފެނުނު ތާރީޚު",
        "noObservation": "ރެކޯޑެއް ބޭނުމެއް ނުވިއެވެ.",
        "source": "މަޞްދަރު",
        "derivation": "ގޮތް"
      },
      "reading": "1 {base} އިން {rate} {quote} ގަނެވެއެވެ.",
      "carriedForward": "{asOf} ގައި ވެއްދި، އަދި {on} ގައިވެސް އަމަލުކުރެއެވެ.",
      "missing": "{base} → {quote} އަށް {on} ގައި ނުވަތަ އޭގެ ކުރިން ރޭޓެއް ނެތެވެ، އަދި އިދިކޮޅުކުރާނެ {quote} → {base} ރޭޓެއްވެސް ނެތެވެ.",
      "enterMissing": "{base} → {quote} ރޭޓެއް ރެކޯޑްކުރޭ"
    },
    "rateType": "ރޭޓްގެ ބާވަތް",
    "rateTypeHint": "މި ރެކޯޑް ނިސްބަތްވަނީ ކޮން ފޮތަކަށްކަން.",
    "rateTypes": {
      "spot": "ސްޕޮޓް",
      "corporate": "ކޯޕަރޭޓް",
      "historical": "ތާރީޚީ"
    },
    "rateTypeHints": {
      "spot": "ސެޓްލްމަންޓް ހަޤީޤަތުގައި ހިނގި ރޭޓް. ޑިފޯލްޓް.",
      "corporate": "މުއްދަތަކަށް ކަނޑައަޅާ މެނޭޖްމަންޓް ރޭޓެއް، އެތެރޭގެ ރިޕޯޓިންގ އަޅާކިޔޭ ގޮތަށް.",
      "historical": "ފައިސާ ނޫން މުދަލެއް ފުރަތަމަ ރެކޯޑްކުރި ރޭޓް؛ އެ ރޭޓް ދެން ބަދަލެއް ނުވާނެއެވެ."
    },
    "hold": {
      "routeTitle": "އެފްއެކްސް ރޭޓް ހޯލްޑްތައް",
      "title": "މުރާޖަޢާއަށް މަޑުޖައްސާލެވިފައިވާ ރޭޓްތައް",
      "description": "ޖޯޑަށް ކަނޑައެޅިފައިވާ ޓޮލަރެންސަށްވުރެ ބޮޑަށް ބަދަލުވި ރެކޯޑްތައް. މަޑުޖައްސާލެވިފައި، ބޭނުންނުކުރެވި.",
      "openCount": "{count} ރޭޓް ނިންމުމަކަށް އިންތިޒާރުކުރެއެވެ. ނިންމުމެއް އަންނަންދެން އެ ދުވަސްތަކަށް އެ ޖޯޑަށް ރޭޓެއް ނެތެވެ.",
      "pair": "ޖޯޑު",
      "asOf": "ތާރީޚް",
      "priorRate": "ކުރީގެ",
      "newRate": "ހުށަހެޅި",
      "move": "ބަދަލު",
      "source": "މަޞްދަރު",
      "decide": "ނިންމާ",
      "decideTitle": "މަޑުޖައްސާލެވިފައިވާ ރޭޓަކާމެދު ނިންމާ",
      "decision": "ނިންމުން",
      "accept": "ޤަބޫލުކުރޭ",
      "acceptHint": "ރެކޯޑް ލިޔެއެވެ. އެ ދުވަހުގެ ރޭޓަކަށް ވެގެންދެއެވެ.",
      "reject": "ބޭރުކުރޭ",
      "rejectHint": "ދޫކޮށްލައެވެ. އެ ދުވަހަށް އެ ޖޯޑަށް ރޭޓެއް ނުހުންނާނެއެވެ، އަދި ގޯސް ފީޑަކަށް އެއީ ތެދު ނަތީޖާއެވެ.",
      "accepted": "ރޭޓް ޤަބޫލުކުރެވިއްޖެ",
      "rejected": "ރޭޓް ބޭރުކުރެވިއްޖެ",
      "reason": "ސަބަބު",
      "tableLabel": "އެފްއެކްސް ރޭޓް ހޯލްޑްތައް",
      "emptyTitle": "މަޑުޖައްސާލެވިފައި އެއްވެސް އެއްޗެއް ނެތް",
      "emptyDescription": "ރޭޓް މަޑުޖައްސާލެވެނީ ޖޯޑަށް ޓޮލަރެންސެއް ކަނޑައަޅާފައިވާ އަދި އެ ފަހަނައަޅާ ރެކޯޑެއް އައުމުންނެވެ.",
      "loadFailed": "މަޑުޖައްސާލެވިފައިވާ ރޭޓްތައް ލޯޑެއް ނުވި",
      "statuses": {
        "held": "މަޑުޖައްސާލެވިފައި",
        "accepted": "ޤަބޫލުކުރެވިފައި",
        "rejected": "ބޭރުކުރެވިފައި"
      }
    },
    "exposure": {
      "routeTitle": "ބޭރު ފައިސާގެ ހުށަހެޅުމާއި ރީވެލުއޭޝަން",
      "navLabel": "ބޭރު ފައިސާގެ ހުށަހެޅުން",
      "navDescription": "ބޭރު ފައިސާއިން ހުޅުވާލެވިފައިވާ ބާކީތަކާއި، މުއްދަތު ނިމުމުގެ ރީވެލުއޭޝަންތަކާއި، އޭގެ ސެޓިންގްސް.",
      "title": "ބޭރު ފައިސާގެ ހުށަހެޅުމާއި ރީވެލުއޭޝަން",
      "description": "ޤާނޫނީ ފަރާތުގެ އަތުގައި ބޭރު ފައިސާއިން ހުރި އެއްޗެހި، ނިމުމުގެ ރޭޓުން އޭގެ އަގު، އަދި ތަފާތު ބުކްކުރާ މުއްދަތު ނިމުމުގެ ރީވެލުއޭޝަންތައް.",
      "baseCurrency": "ބޭސް ފައިސާ {currency}",
      "entitiesFailed": "ޤާނޫނީ ފަރާތްތައް ލޯޑެއް ނުވި",
      "noEntityTitle": "ދައްކާނެ ޤާނޫނީ ފަރާތެއް ނެތް",
      "noEntityDescription": "ހުށަހެޅުމާއި ރީވެލުއޭޝަން ބަހައްޓަނީ ކޮންމެ ޤާނޫނީ ފަރާތަކަށް ވަކިން. ފުރަތަމަ އެއް ފަރާތެއް ހަދާ ނުވަތަ އެކްޓިވް ކުރޭ.",
      "tabs": {
        "exposure": "ހުށަހެޅުން",
        "runs": "ރީވެލުއޭޝަން ރަންތައް",
        "settings": "ސެޓިންގްސް"
      },
      "fields": {
        "asOf": "ތާރީޚު",
        "asOfHint": "ބާކީތައް ދައްކަނީ މި ދުވަހުގެ ނިޔަލަށް، މި ދުވަހު ނުވަތަ ކުރިން އޮތް އެންމެ ފަހުގެ ރޭޓުން.",
        "company": "ޤާނޫނީ ފަރާތް",
        "period": "މާލީ މުއްދަތު",
        "periodHint": "ބާކީތައް އަގުކުރަނީ މުއްދަތުގެ ފަހު ދުވަހު.",
        "periodPlaceholder": "މުއްދަތެއް ހޮވާ",
        "rateTypeDefault": "ޤާނޫނީ ފަރާތުގެ ޑިފޯލްޓް",
        "rateTypeDefaultHint": "ސެޓިންގްސްގައިވާ ރޭޓުގެ ބާވަތް ބޭނުންކުރުމަށް ހުސްކޮށް ބާއްވާ."
      },
      "sources": {
        "ap": "ދައްކަންޖެހޭ",
        "ar": "ލިބެންޖެހޭ",
        "bank": "ބޭންކު",
        "gl": "ލެޖަރ އެކައުންޓް"
      },
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "discarded": "ދޫކޮށްލެވިފައި"
      },
      "reversalStatuses": {
        "draft": "ދެން އަންނަ މުއްދަތަށް މަޑުކުރަނީ",
        "posted": "ރިވަރސްކުރެވިފައި"
      },
      "periodStatuses": {
        "open": "ހުޅުވިފައި",
        "soft_closed": "ލުއިކޮށް ބަންދުކުރެވިފައި",
        "closed": "ބަންދުކުރެވިފައި"
      },
      "columns": {
        "currency": "ފައިސާ",
        "rate": "ނިމުމުގެ ރޭޓް",
        "rateSource": "ރޭޓުގެ ބިންގާ",
        "assets": "މުދާ",
        "liabilities": "ދަރަނި",
        "netExposure": "ސާފު ހުށަހެޅުން",
        "carriedBase": "ބަހައްޓާފައިވާ (ބޭސް)",
        "revaluedBase": "އަލުން އަގުކުރެވުނު (ބޭސް)",
        "unrealised": "ނުހާސިލުވާ",
        "source": "މަސްދަރު",
        "account": "އެކައުންޓް",
        "counterparty": "އަނެއް ފަރާތް",
        "items": "އައިޓަމް",
        "foreignAmount": "ބޭރު ފައިސާގެ އަދަދު",
        "period": "މުއްދަތު",
        "asOf": "ތާރީޚު",
        "netAmount": "ސާފު ފައިދާ ނުވަތަ ގެއްލުން",
        "journal": "ޖާނަލް",
        "reversal": "ރިވަރސަލް",
        "derivation": "ހޯދި ގޮތް",
        "difference": "ތަފާތު",
        "document": "ޑޮކިއުމަންޓް",
        "oldRate": "ކުރީގެ ރޭޓް",
        "newRate": "އައު ރޭޓް"
      },
      "report": {
        "loadFailed": "ހުށަހެޅުން ލޯޑެއް ނުވި",
        "byCurrencyTitle": "ފައިސާގެ ބާވަތުން ހުށަހެޅުން",
        "byCurrencyDescription": "ބޭރު އަދަދުތައް ކޮންމެ ފައިސާއަކުން؛ ބަހައްޓާފައިވާ، އަލުން އަގުކުރެވުނު އަދި ނުހާސިލުވާ އަދަދުތައް {currency} އިން، {date} ގެ ނިޔަލަށް. ރޭޓަކީ އެއް ބޭރު ޔުނިޓަކަށް ބޭސް ފައިސާގެ ޔުނިޓް.",
        "emptyTitle": "ބޭރު ފައިސާގެ ހުށަހެޅުމެއް ނެތް",
        "emptyDescription": "މި ތާރީޚުގައި ބޭރު ފައިސާއިން ހުޅުވާލެވިފައިވާ ބާކީއެއް ނެތް، އެހެންކަމުން ރޭޓާއެކު ބަދަލުވާ އެއްޗެއް ނެތް.",
        "totalUnrealised": "ޖުމްލަ ނުހާސިލުވާ ({currency})",
        "byAccountTitle": "މަސްދަރާއި އެކައުންޓުން ހުށަހެޅުން",
        "byAccountDescription": "އެ އަދަދުތަކެއް ސަބް-ލެޖަރާއި އެކައުންޓުން، އަދި ދައްކަންޖެހޭ އަދި ލިބެންޖެހޭ ފައިސާއަށް އަނެއް ފަރާތުން."
      },
      "runs": {
        "create": "ރީވެލުއޭޝަނެއް ތައްޔާރުކުރޭ",
        "loadFailed": "ރީވެލުއޭޝަން ރަންތައް ލޯޑެއް ނުވި",
        "emptyTitle": "އަދި ރީވެލުއޭޝަން ރަނެއް ނެތް",
        "emptyDescription": "މުއްދަތު ނިމުމުން އެއް ތައްޔާރުކުރޭ: އެއީ ބޭރު ފައިސާއިން ހުޅުވާލެވިފައިވާ ކޮންމެ ބާކީއެއް ނިމުމުގެ ރޭޓުން އަގުކުރުން، އަދި ދެވަނަ މީހަކު ޕޯސްޓްކުރަންދެން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެ.",
        "tableLabel": "މުއްދަތުގެ ރީވެލުއޭޝަން ރަންތައް"
      },
      "create": {
        "title": "މުއްދަތުގެ ރީވެލުއޭޝަނެއް ތައްޔާރުކުރޭ",
        "description": "ޑްރާފްޓަކީ އަގުކުރުމެއް ހަމައެކަނި. އެ ޕޯސްޓްކުރާނީ ތިބާ ނޫން މީހެއް.",
        "done": "ރީވެލުއޭޝަން ތައްޔާރުކުރެވިއްޖެ",
        "doneDetail": "{period} ގެ ޑްރާފްޓް ދެވަނަ މީހަކު ޕޯސްޓްކުރުމަށް ތައްޔާރު.",
        "noPeriodPermission": "ތިބާއަށް މާލީ މުއްދަތުތައް ކިޔޭކަށް ނުލިބޭ، އެހެންކަމުން މިތާނގައި މުއްދަތެއް ހޮވޭކަށް ނެތް.",
        "nothingPosted": "ޑްރާފްޓެއް ތައްޔާރުކުރާއިރު އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭ. ޕޯސްޓްކުރުމުގެ ކުރިން ފޮތްތަކަށް ބަދަލު އައިސްފިނަމަ، އެ ދޫކޮށްލާފައި އަލުން ތައްޔާރުކުރަން ޖެހޭނެ.",
        "submit": "ޑްރާފްޓް ތައްޔާރުކުރޭ"
      },
      "run": {
        "routeTitle": "ބޭރު ފައިސާގެ ރީވެލުއޭޝަން ރަން",
        "title": "ބޭރު ފައިސާގެ ރީވެލުއޭޝަން، {period}",
        "description": "ބޭނުންކުރި ނިމުމުގެ ރޭޓުތަކާއި، ކޮންމެ އެކައުންޓަކަށް ގެނެވުނު ބަދަލާއި، އަލުން އަގުކުރެވުނު ކޮންމެ އައިޓަމެއް.",
        "back": "ހުރިހާ ރީވެލުއޭޝަން ރަނެއް",
        "discard": "ޑްރާފްޓް ދޫކޮށްލާ",
        "post": "ރީވެލުއޭޝަން ޕޯސްޓްކުރޭ",
        "posted": "ރީވެލުއޭޝަން ޕޯސްޓްކުރެވިއްޖެ",
        "discarded": "ރީވެލުއޭޝަން ޑްރާފްޓް ދޫކޮށްލެވިއްޖެ",
        "loadFailed": "ރީވެލުއޭޝަން ރަން ލޯޑެއް ނުވި",
        "preparerNote": "މި ރީވެލުއޭޝަން ތައްޔާރުކުރީ ތިބާ، އެހެންކަމުން އެ ޕޯސްޓްކުރަންވާނީ އެހެން މީހެއް.",
        "summaryTitle": "ޚުލާސާ",
        "totalGain": "ޖުމްލަ ފައިދާ",
        "totalLoss": "ޖުމްލަ ގެއްލުން",
        "openJournal": "ޖާނަލް ހުޅުވާ",
        "noJournal": "ޕޯސްޓްކުރެވިފައެއް ނުވޭ",
        "openReversal": "ރިވަރސަލް ހުޅުވާ",
        "noReversal": "ނެތް",
        "discardReason": "ދޫކޮށްލާ ސަބަބު",
        "ratesTitle": "ނިމުމުގެ ރޭޓުތައް",
        "ratesDescription": "ކޮންމެ ފައިސާއެއްގެ އެއް ޔުނިޓަކަށް {currency} ގެ ޔުނިޓް، އަދި ކޮންމެ ރޭޓެއް އައި ތަން.",
        "noRates": "އެއްވެސް ރޭޓެއް ބޭނުންނުވި.",
        "adjustmentsTitle": "ބަދަލުތައް",
        "adjustmentsDescription": "ނުހާސިލުވާ ފައިދާ ނުވަތަ ގެއްލުމުގެ އެކައުންޓާ ޚިލާފަށް، ޖާނަލުން ކޮންމެ އެކައުންޓަކަށް ޑެބިޓް (ޕޮޒިޓިވް) ނުވަތަ ކްރެޑިޓް (ނެގެޓިވް) ކުރާ އަދަދު.",
        "noAdjustments": "ބަދަލުކުރާނެ އެއްޗެއް ނެތް.",
        "linesTitle": "އަލުން އަގުކުރެވުނު އައިޓަމް ({count})",
        "linesDescription": "ހުޅުވާލެވިފައިވާ ކޮންމެ އައިޓަމެއް، އެ ބަހައްޓާފައިވި ރޭޓާއި، ނިމުމުގެ ރޭޓާއި، ތަފާތާއެކު.",
        "linesFailed": "އަލުން އަގުކުރެވުނު އައިޓަމްތައް ލޯޑެއް ނުވި",
        "noLines": "އެއްވެސް އައިޓަމެއް އަލުން އަގުނުކުރެވޭ.",
        "linesCaption": "މި ރަނުން އަލުން އަގުކުރެވުނު އައިޓަމްތައް",
        "discardTitle": "މި ރީވެލުއޭޝަން ޑްރާފްޓް ދޫކޮށްލާ",
        "discardDescription": "ދެން މުއްދަތު އަލުން ރީވެލުއޭޓް ކުރެވޭނެ. ޕޯސްޓްކުރެވިފައިވާ ރީވެލުއޭޝަނެއް ދޫކޮށެއް ނުލެވޭ؛ އެ ރިވަރސްކުރަނީ ލެޖަރ މެދުވެރިކޮށް."
      },
      "settings": {
        "loadFailed": "ރީވެލުއޭޝަން ސެޓިންގްސް ލޯޑެއް ނުވި",
        "title": "ރީވެލުއޭޝަން ސެޓިންގްސް",
        "description": "މުއްދަތުގެ ރީވެލުއޭޝަނެއް ބުކްކުރާ އެކައުންޓުތަކާއި، ދައްކަންޖެހޭ، ލިބެންޖެހޭ އަދި ބޭންކާއެކު އަލުން އަގުކުރާ ލެޖަރ އެކައުންޓުތައް.",
        "unconfigured": "އަދި ސެޓްއަޕް ނުކުރެވޭ. ނުހާސިލުވާ ފައިދާއާއި ގެއްލުމުގެ އެކައުންޓުތައް ކަނޑައަޅަންދެން ރީވެލުއޭޝަނެއް ތައްޔާރެއް ނުކުރެވޭނެ.",
        "staleHint": "މި ސެޓިންގްސް ފުރަތަމަ ސޭވްކުރީ އެހެން މީހެއް.",
        "reload": "ސެޓިންގްސް އަލުން ލޯޑްކުރޭ",
        "noAccountPermission": "ތިބާއަށް އެކައުންޓުތަކުގެ ޗާޓް ކިޔޭކަށް ނުލިބޭ، އެހެންކަމުން އެކައުންޓް ހޮވާ ތަންތަން ބޭނުންނުކުރެވޭނެ.",
        "gainAccount": "ނުހާސިލުވާ ބޭރު ފައިސާގެ ފައިދާގެ އެކައުންޓް",
        "gainAccountHint": "ދައްކަންޖެހޭ އަދި ލިބެންޖެހޭ ފައިސާއިން ހާސިލުވާ ފައިދާ ބުކްކުރާ އެކައުންޓަކަށް ނުވާންވާނެ.",
        "lossAccount": "ނުހާސިލުވާ ބޭރު ފައިސާގެ ގެއްލުމުގެ އެކައުންޓް",
        "lossAccountHint": "ދައްކަންޖެހޭ އަދި ލިބެންޖެހޭ ފައިސާއިން ހާސިލުވާ ގެއްލުން ބުކްކުރާ އެކައުންޓަކަށް ނުވާންވާނެ.",
        "defaultRateType": "ޑިފޯލްޓް ރޭޓުގެ ބާވަތް",
        "defaultRateTypeHint": "ރަނެއް ތައްޔާރުކުރާއިރު ބާވަތެއް ނުހޮވައިފިނަމަ ބޭނުންކުރެވޭނެ.",
        "monetaryAccounts": "މޮނިޓަރީ ލެޖަރ އެކައުންޓުތައް",
        "monetaryAccountsHint": "ސީދާ އަލުން އަގުކުރާ ބޭރު ފައިސާގެ ލެޖަރ އެކައުންޓުތައް، މިސާލަކަށް ލޯނު. ކޮންޓްރޯލް އެކައުންޓުތަކާއި ބޭންކް އެކައުންޓުތައް އަގުކުރަނީ އެ ސަބް-ލެޖަރުތަކުން، އެހެންކަމުން މިތާނގައި ބަލައެއް ނުގަނެވޭނެ.",
        "remove": "ނަގާލާ",
        "noMonetary": "ނެތް",
        "addMonetary": "މޮނިޓަރީ އެކައުންޓެއް އިތުރުކުރޭ",
        "save": "ސެޓިންގްސް ސޭވްކުރޭ",
        "saved": "ރީވެލުއޭޝަން ސެޓިންގްސް ސޭވްކުރެވިއްޖެ",
        "notSet": "ކަނޑައަޅާފައެއް ނުވޭ"
      }
    }
  },
  "org": {
    "common": {
      "company": "ކުންފުނި",
      "companyPlaceholder": "ކުންފުންޏެއް ޚިޔާރުކުރޭ",
      "legalEntityPlaceholder": "ޤާނޫނީ ފަރާތެއް ޚިޔާރުކުރޭ",
      "allLegalEntities": "ހުރިހާ ޤާނޫނީ ފަރާތްތައް",
      "noLegalEntity": "ލިބެން ހުރި ޤާނޫނީ ފަރާތެއް ނެތް",
      "chooseCompanyTitle": "ފުރަތަމަ ކުންފުންޏެއް ޚިޔާރުކުރޭ",
      "chooseCompanyDescription": "މި ސްކްރީނުގައިވާ ހުރިހާ އެއްޗެއް ނިސްބަތްވަނީ އެއް ކުންފުންޏަކަށެވެ — އޭގެ ކަލަންޑަރު، ހިސާބުތައް އަދި އޮނިގަނޑު.",
      "created": "އުފެއްދި",
      "updated": "އެންމެފަހުން ބަދަލުކުރި",
      "close": "ބަންދުކުރޭ",
      "collapse": "ފޮރުވާ",
      "expand": "ފުޅާކުރޭ",
      "none": "ނެތް",
      "note": "ނޯޓް"
    },
    "nav": {
      "label": "އިދާރީ ބައިތައް",
      "hierarchy": "ގޮފިތަކާއި ޕްރޮފިޓް ސެންޓަރުތައް",
      "fiscalPeriods": "ފިސްކަލް މުއްދަތުތައް",
      "accounts": "ހިސާބުތަކުގެ ޗާޓް",
      "openingBalances": "ފެށޭ ބެލެންސްތައް",
      "goLive": "ގޯ-ލައިވް",
      "locations": "ތަންތަން",
      "jobs": "މަސައްކަތްތައް",
      "grades": "ދަރަޖަތައް",
      "positions": "މަޤާމުތައް",
      "designations": "ކަނޑައެޅުންތައް",
      "filings": "ފައިލްކުރުމުގެ ކަލަންޑަރު"
    },
    "companies": {
      "title": "ކުންފުނިތައް",
      "description": "މި ވޯކްސްޕޭސްގައި ހިސާބު ބަލަހައްޓާ ޤާނޫނީ ފަރާތްތައް. ކޮންމެ ފަރާތެއްގައި އަމިއްލަ އަސާސީ ފައިސާ، ފިސްކަލް ކަލަންޑަރު އަދި ހިސާބުތަކުގެ ޗާޓް ހުރެއެވެ.",
      "tableLabel": "ކުންފުނިތައް",
      "loadFailed": "ކުންފުނިތަކުގެ ލިސްޓް ލޯޑެއް ނުވި",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން ހޯދާ",
      "searchLabel": "ކުންފުނިތައް ހޯދާ",
      "emptyTitle": "އަދި އެއްވެސް ކުންފުންޏެއް ނެތް",
      "emptyDescription": "ފުރަތަމަ ކުންފުނި ރަޖިސްޓްރީކުރޭ — ކުންފުންޏެއް ނެތި ލެޖަރުގެ އެއްވެސް ބައެއް ސެޓަޕެއް ނުކުރެވޭނެއެވެ.",
      "createFirst": "ފުރަތަމަ ކުންފުނި ރަޖިސްޓްރީކުރޭ",
      "createTitle": "އައު ކުންފުނި",
      "editTitle": "ކުންފުނި އެޑިޓްކުރޭ",
      "formDescription": "ޤާނޫނީ ނަން ލިޔެކިޔުންތަކުގައި ބޭނުންކުރެވޭނެއެވެ؛ ކުރު ނަން ފެންނާނީ ލިސްޓުތަކުގައެވެ.",
      "created": "ކުންފުނި ރަޖިސްޓްރީކުރެވިއްޖެ",
      "createdDetail": "{name} ސެޓަޕްކުރަން ތައްޔާރު.",
      "saved": "ކުންފުނި ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{name} އަޕްޑޭޓްކުރެވިއްޖެ.",
      "saveFailed": "ކުންފުނި ރައްކާއެއް ނުކުރެވުނު",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "exported": "އެއް ކުންފުނި އެކްސްޕޯޓްކުރެވިއްޖެ | {count} ކުންފުނި އެކްސްޕޯޓްކުރެވިއްޖެ",
      "railSubtitle": "{code} · އަސާސީ ފައިސާ {currency}",
      "columns": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "country": "ޤައުމު",
        "baseCurrency": "އަސާސީ ފައިސާ"
      },
      "fields": {
        "code": "ކޯޑް",
        "codeHint": "ކުރު، ބޮޑު އަކުރުން، އަދި ލިޔެކިޔުމުގެ ނަންބަރުތަކުގައި ބޭނުންކުރެވޭ.",
        "codeLocked": "ކުންފުނި އުފެއްދުމަށްފަހު ކޯޑް ބަދަލެއް ނުކުރެވޭނެއެވެ.",
        "country": "ޤައުމު",
        "countryHint": "ދެ އަކުރުގެ އައިއެސްއޯ ކޯޑް، މިސާލަކަށް MV.",
        "legalName": "ޤާނޫނީ ނަން",
        "legalNameHint": "ރަޖިސްޓްރީކޮށްފައިވާ ގޮތަށް. އިންވޮއިސްތަކުގައި ޗާޕުވާނީ މިއެވެ.",
        "name": "ކުރު ނަން",
        "nameHint": "ދުވަހުން ދުވަހަށް މީހުން ކިޔާ ނަން.",
        "baseCurrency": "އަސާސީ ފައިސާ",
        "baseCurrencyHint": "ކުންފުނިން އެއްޗެއް ޕޯސްޓްކުރުމަށްފަހު މިއީ ބަދަލުނުކުރެވޭ އެއްޗެކެވެ: ރައްކާކުރެވިފައިވާ ކޮންމެ އަދަދެއް ބަދަލުކުރެވިފައިވަނީ އެ ލިޔުމުގެ އަމިއްލަ ރޭޓުންނެވެ.",
        "baseCurrencyPlaceholder": "ފައިސާއެއް ޚިޔާރުކުރޭ",
        "baseCurrencyLocked": "މި ކުންފުނިން ކުރިންވެސް ޕޯސްޓްކޮށްފައިވާތީ އަސާސީ ފައިސާ ބަދަލެއް ނުކުރެވޭނެއެވެ. ބަދަލުކޮށްފިނަމަ އެ ލިޔުމުގެ އަމިއްލަ ރޭޓުން ބަދަލުކުރެވިފައިވާ އަދަދުތައް ބަދަލުވާނެއެވެ.",
        "address": "އެޑްރެސް",
        "addressLine1": "އެޑްރެސް ފުރަތަމަ ސަތުރު",
        "addressLine2": "އެޑްރެސް ދެވަނަ ސަތުރު",
        "city": "ސިޓީ",
        "postalCode": "ޕޯސްޓަލް ކޯޑް",
        "taxRegistrations": "ޓެކްސް ރަޖިސްޓްރޭޝަންތައް",
        "taxRegistrationsHint": "ހުއްދަދިން އިދާރާ އަދި ދޫކުރި ނަންބަރު، މިސާލަކަށް މީރާ އަދި ޓިން ނަންބަރު.",
        "taxAuthority": "އިދާރާ",
        "taxNumber": "ރަޖިސްޓްރޭޝަން ނަންބަރު",
        "addRegistration": "ރަޖިސްޓްރޭޝަނެއް އިތުރުކުރޭ",
        "removeRegistration": "ރަޖިސްޓްރޭޝަން {index} ނަގާ",
        "active": "ހަރަކާތްތެރި",
        "activeHint": "ހަރަކާތްތެރި ނޫން ކުންފުންޏެއް ޕިކަރުތަކުން ފޮރުވޭނެއެވެ، ނަމަވެސް އޭގެ ތާރީޚު ބާކީ ހުންނާނެއެވެ.",
        "skipOpeningBalances": "މި ކުންފުނި ފަށަނީ ސުމަކުން",
        "skipOpeningBalancesHint": "މިއީ ގަސްދުގައި ނިންމި ނިންމުމެއް ކަމަށް ރެކޯޑްކުރެއެވެ، އޭރުން ގޯ-ލައިވް ޗެކްލިސްޓަށް ނުނިމޭ މަސައްކަތާ ތަފާތުކުރެވޭނެއެވެ.",
        "skipReason": "ސަބަބު",
        "skipReasonHint": "ފަހުން މިކަން އޮޑިޓްކުރާ ފަރާތުން މި ކިޔާނެއެވެ."
      },
      "dissolved": "ކުންފުނި އުވާލެވިއްޖެ",
      "dissolvedDetail": "{name} އުވާލެވުނީ {on} ގައެވެ.",
      "dissolveFailed": "ކުންފުނި އުވައެއް ނުލެވުނު",
      "dissolution": {
        "legend": "އުވާލުން",
        "description": "ޤާނޫނީ ފަރާތް ނިމުމަކަށް ގެނައުން، މިއީ ހަމައެކަނި ނުހިނގާ ގޮތަށް ބަދަލުކުރުމެއް ނޫނެވެ.",
        "consequence": "އެނބުރި ނުގެނެވޭނެއެވެ. ދެއްވާ ތާރީޚުން ފެށިގެން ކުންފުނި ނުހިނގާނެއެވެ، ސަބަބު ރެކޯޑްވާނެއެވެ، އަދި އޭގެ ފަހުން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެއެވެ.",
        "action": "މި ކުންފުނި އުވާލައްވާ",
        "confirm": "އުވާލައްވާ",
        "on": "އުވާލެވޭ ތާރީޚް",
        "reason": "ސަބަބުގެ ކޯޑް",
        "reasonHint": "ކުންފުންޏާއެކު ރެކޯޑްވެ، ބަންދުކުރި ސަބަބު އޮޅުންފިލުވާ ކޮންމެ ބޭފުޅަކަށް ފެންނާނެއެވެ.",
        "stated": "{on} ގައި އުވާލެވިފައި ({reason}). މި ކުންފުންޏަށް އިތުރު އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެއެވެ."
      }
    },
    "hierarchy": {
      "title": "އިދާރީ އޮނިގަނޑު",
      "description": "ގޮފިތައް، ޑިޕާޓްމަންޓްތައް، ކޮސްޓް ސެންޓަރުތައް، ޕްރޮފިޓް ސެންޓަރުތައް އަދި ބިޒްނަސް ޔުނިޓްތައް — ކޮންމެ ޕޯސްޓިންގއެއްގައި ޓެގްކުރެވޭ ބައިތައް.",
      "loadFailed": "އޮނިގަނޑު ލޯޑެއް ނުވި",
      "kindTabsLabel": "ޔުނިޓްގެ ބާވަތް",
      "addRoot": "އައު {kind}",
      "addChild": "ދަށު ބައެއް އިތުރުކުރޭ",
      "delete": "ފޮހެލާ",
      "deleted": "ފޮހެލެވިއްޖެ",
      "deletedDetail": "{name} މިހާރު އޮނިގަނޑުގައެއް ނެތް.",
      "deleteFailed": "ފޮހެއެއް ނުލެވުނު",
      "deleteHasChildren": "ފުރަތަމަ އޭގެ ދަށުގައިވާ ޔުނިޓްތައް ބަދަލުކުރޭ ނުވަތަ ފޮހެލާ — ފޮހެލެވޭ މައި ބައެއްގެ ސަބަބުން އެތަކެތި މުޅިން ފޮރުވޭނެއެވެ.",
      "moveFailed": "ބަދަލުކުރުން ބަލައެއް ނުގަނެވުނު",
      "noSelection": "އެއްވެސް އެއްޗެއް ޚިޔާރުކޮށްފައެއް ނުވޭ",
      "noSelectionHint": "ބަލާލައި ބަދަލުކުރަން ގަހުން ބައެއް ޚިޔާރުކުރޭ.",
      "childCount": "އޭގެ ދަށުގައި އެއް ޔުނިޓް | އޭގެ ދަށުގައި {count} ޔުނިޓް",
      "moveGroup": "ޚިޔާރުކުރި ޔުނިޓް ބަދަލުކުރޭ",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "emptyKind": "އަދި މިތާ އެއްވެސް އެއްޗެއް ނެތް.",
      "createTitle": "އައު {kind}",
      "editTitle": "{kind} އެޑިޓްކުރޭ",
      "formDescription": "ކޯޑެއް، ނަމެއް، އަދި ގަހުގައި އޮންނަ ތަން.",
      "created": "{kind} އުފެއްދިއްޖެ",
      "saved": "{kind} ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ރައްކާއެއް ނުކުރެވުނު",
      "loadUnitFailed": "އެ ޔުނިޓް ކިޔައެއް ނުލެވުނު",
      "unitsScreen": {
        "title": "ގޮފިތަކާއި ޕްރޮފިޓް ސެންޓަރުތައް",
        "description": "ގޮފިތަކާއި ޕްރޮފިޓް ސެންޓަރުތައް — ކޮންމެ ޕޯސްޓިންގއެއްގައި ޓެގްކުރެވޭ، އެހެން އެއްވެސް ރަޖިސްޓަރެއްގައި ބެލެހެއްޓިފައި ނުވާ ބައިތައް.",
        "elsewhere": "މި ބައިތައް ބަލަހައްޓަނީ އެބައިތަކުގެ އަމިއްލަ ރަޖިސްޓަރުތަކުގައި:",
        "navLabel": "ގޮފިތަކާއި ޕްރޮފިޓް ސެންޓަރުތައް",
        "navDescription": "ގޮފިތަކާއި ޕްރޮފިޓް ސެންޓަރުތަކުގެ ގަސްތައް",
        "navKeywords": "ގޮފި ޕްރޮފިޓް ސެންޓަރު ޔުނިޓް ބައި"
      },
      "kinds": {
        "branch": "ގޮފިތައް",
        "department": "ޑިޕާޓްމަންޓްތައް",
        "cost_center": "ކޮސްޓް ސެންޓަރުތައް",
        "profit_center": "ޕްރޮފިޓް ސެންޓަރުތައް",
        "business_unit": "ބިޒްނަސް ޔުނިޓްތައް"
      },
      "kindsSingular": {
        "branch": "ގޮފި",
        "department": "ޑިޕާޓްމަންޓް",
        "cost_center": "ކޮސްޓް ސެންޓަރ",
        "profit_center": "ޕްރޮފިޓް ސެންޓަރ",
        "business_unit": "ބިޒްނަސް ޔުނިޓް"
      },
      "fields": {
        "code": "ކޯޑް",
        "codeHint": "މި ކުންފުނީގެ ތެރޭގައި ތަފާތު.",
        "parent": "ދަށުގައި އޮންނަނީ",
        "parentHint": "އެންމެ މަތީ ދަރަޖައިގައި ބާއްވަން ހުސްކޮށް ބާއްވާ.",
        "noParent": "އެންމެ މަތީ ދަރަޖަ",
        "active": "ހަރަކާތްތެރި",
        "activeHint": "ހަރަކާތްތެރި ނޫން ޔުނިޓްތައް ރިޕޯޓުތަކުގައި ހުންނާނެއެވެ، ނަމަވެސް އައު ލިޔެކިޔުމުގައި ނުދައްކާނެއެވެ."
      },
      "a11y": {
        "help": "އެރޯ ކީތަކުން ޔުނިޓްތަކުގެ މެދުގައި ދަތުރުކުރެވެއެވެ. ސްޕޭސް އިން ޔުނިޓެއް ނަގައި ބާއްވައެވެ؛ ނަގާފައިވާއިރު އެރޯ ކީތަކުން ބަދަލުކުރެވެއެވެ، އަދި އެސްކޭޕުން ހުއްޓެއެވެ. އޯލްޓާއެކު އެރޯ ކީއެއް ބޭނުންކޮށްގެން ނުނަގައި ބަދަލުކުރެވެއެވެ.",
        "movingStart": "{name} ނަގައިފި. އެރޯ ކީތަކުން ބަދަލުކުރެވޭނެއެވެ އަދި ކޮންމެ ބަދަލެއް ރައްކާކުރެވޭނެއެވެ. ނިންމަން އެސްކޭޕް ނުވަތަ ސްޕޭސް.",
        "movingStop": "{name} ބާއްވައިފި.",
        "movingBadge": "ބަދަލުކުރަނީ",
        "movedRoot": "{name} އެންމެ މަތީ ދަރަޖައިގައި {total} ގެ ތެރެއިން {index} ވަނަ މަޤާމަށް ބަދަލުވެއްޖެ.",
        "movedUnder": "{name} {parent} ގެ ދަށުގައި {total} ގެ ތެރެއިން {index} ވަނަ މަޤާމަށް ބަދަލުވެއްޖެ.",
        "blocked": "{name} އިތުރަށް {direction} ބަދަލެއް ނުކުރެވޭނެއެވެ.",
        "dropRefused": "{name} އެތަނަކަށް ނުބޭއްވޭނެއެވެ.",
        "moveFailed": "ބަދަލުކުރުން ބަލައިނުގަނެ އޮނިގަނޑު ކުރީގެ ގޮތަށް އަނބުރާ ގެނެވިއްޖެ. {reason}",
        "deleted": "{name} ފޮހެލެވިއްޖެ.",
        "expand": "{name} ފުޅާކުރޭ",
        "collapse": "{name} ކުޑަކުރޭ",
        "directions": {
          "up": "މައްޗަށް",
          "down": "ތިރިއަށް",
          "in": "އެތެރެއަށް",
          "out": "ބޭރަށް"
        }
      }
    },
    "periods": {
      "title": "ފިސްކަލް މުއްދަތުތައް",
      "description": "ކުންފުނީގެ ފިސްކަލް ކަލަންޑަރު އަދި ޕޯސްޓިންގތައް ޖެހޭ މުއްދަތުތައް. މުއްދަތެއް ބަންދުކުރުމުން އެހެން އެންމެންނަށް އެ މުއްދަތަށް ޕޯސްޓެއް ނުކުރެވޭނެއެވެ.",
      "loadFailed": "ކަލަންޑަރު ލޯޑެއް ނުވި",
      "calendarLabel": "ކަލަންޑަރު",
      "yearLabel": "ފިސްކަލް އަހަރު",
      "allYears": "ހުރިހާ އަހަރެއް",
      "noCalendarTitle": "އަދި ފިސްކަލް ކަލަންޑަރެއް ނެތް",
      "noCalendarDescription": "ފިސްކަލް އަހަރެއް ނެތި އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެއެވެ. ކަލަންޑަރާއި އޭގެ ފުރަތަމަ އަހަރު އެކުގައި އުފައްދާ.",
      "noPeriodsTitle": "މި ކަލަންޑަރުގައި އަދި މުއްދަތެއް ނެތް",
      "noPeriodsDescription": "މުއްދަތުތައް އުފެއްދުމަށް ފިސްކަލް އަހަރެއް ޖެނެރޭޓްކުރޭ.",
      "yearHeading": "ފިސްކަލް އަހަރު {year}",
      "tableCaption": "ފިސްކަލް އަހަރު {year} ގެ މުއްދަތުތައް",
      "createCalendarTitle": "އައު ކަލަންޑަރު",
      "createCalendarDescription": "ކަލަންޑަރުން ފިސްކަލް އަހަރު ފެށޭ މަސް ކަނޑައަޅައެވެ؛ އޭގެ ފުރަތަމަ އަހަރުވެސް އެއާއެކު އެކުލަވާލެވެއެވެ.",
      "generateTitle": "އަހަރެއް ޖެނެރޭޓްކުރޭ",
      "generateDescription": "މި ކަލަންޑަރުގައި އިތުރު ފިސްކަލް އަހަރެއް އެކުލަވާލާ.",
      "generateConfirm": "ޖެނެރޭޓްކުރޭ",
      "calendarCreated": "ކަލަންޑަރު އުފެއްދިއްޖެ",
      "calendarCreatedDetail": "{name}، {count} މުއްދަތާއެކު.",
      "periodsGenerated": "މުއްދަތުތައް ޖެނެރޭޓްކުރެވިއްޖެ",
      "periodsGeneratedDetail": "{year} އަށް {count} މުއްދަތު.",
      "calendarFailed": "އެއެއް ނުއުފެއްދުނު",
      "columns": {
        "no": "ނަންބަރު",
        "name": "މުއްދަތު",
        "start": "ފެށޭ",
        "end": "ނިމޭ",
        "reason": "ސަބަބު"
      },
      "status": {
        "open": "ހުޅުވިފައި",
        "soft_closed": "މަޑުމަޑުން ބަންދު",
        "closed": "ބަންދު",
        "permanently_closed": "ދާއިމީކޮށް ބަންދު"
      },
      "statusMeaning": {
        "open": "ޕޯސްޓިންގތައް ބަލައިގަނެވޭ",
        "soft_closed": "ޕޯސްޓިންގތަކުން އިންޒާރު ދެވޭ، ނަމަވެސް ބަލައިގަނެވޭ",
        "closed": "ޕޯސްޓިންގތައް ބަލައެއް ނުގަނެވޭ",
        "permanently_closed": "ޕޯސްޓިންގ ދޫނުކުރެވޭ؛ އަލުން ނުހުޅުވޭނެ"
      },
      "actions": {
        "softClose": "މަޑުމަޑުން ބަންދުކުރޭ",
        "close": "ބަންދުކުރޭ",
        "reopen": "އަލުން ހުޅުވާ",
        "permanentClose": "ދާއިމީކޮށް ބަންދުކުރޭ"
      },
      "months": {
        "1": "ޖެނުއަރީ",
        "2": "ފެބްރުއަރީ",
        "3": "މާރިޗު",
        "4": "އޭޕްރީލް",
        "5": "މޭ",
        "6": "ޖޫން",
        "7": "ޖުލައި",
        "8": "އޯގަސްޓް",
        "9": "ސެޕްޓެމްބަރު",
        "10": "އޮކްޓޯބަރު",
        "11": "ނޮވެމްބަރު",
        "12": "ޑިސެމްބަރު"
      },
      "fields": {
        "calendarName": "ކަލަންޑަރުގެ ނަން",
        "calendarNameHint": "މިސާލަކަށް: އާދައިގެ އަހަރު.",
        "startMonth": "ފިސްކަލް އަހަރު ފެށެނީ",
        "startMonthHint": "ކަލަންޑަރު އަހަރަކަށް ޖެނުއަރީ؛ އެހެން ގޮތްގޮތަށް އޭޕްރީލް، ޖުލައި ނުވަތަ އޮކްޓޯބަރު.",
        "fiscalYear": "ފިސްކަލް އަހަރު",
        "fiscalYearHint": "މިހާރު އެކުލަވާލާނެ އަހަރު.",
        "periodCount": "އަހަރުގެ މުއްދަތުތައް",
        "periodCountDivisors": "ހަމައެކަނި 1، 2، 3، 4، 6 އަދި 12 ބޭނުންކުރެވެއެވެ: އަހަރު ބަހާލެވެނީ ހަމަހަމަ ފުރިހަމަ މަސްތަކަކަށެވެ.",
        "periodCountOption": "{count} މުއްދަތު",
        "periodCountHint": "ކޮންމެ އެއްޗެއް {months} މަސް",
        "preview": "ފިސްކަލް އަހަރު {year} ފެށެނީ {month} ގައެވެ، އަދި އެކުލަވާލެވެނީ {count} މުއްދަތަށެވެ."
      },
      "transitions": {
        "subject": "މުއްދަތު {period}",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "ލާޒިމު. މިއީ އޮޑިޓް ރެކޯޑަށް އަރާ އެއްޗެކެވެ، އަދި ފަހުން ސުވާލުކުރާ ފަރާތުން ކިޔާނެއެވެ.",
        "reasonRequired": "ސަބަބެއް ލާޒިމު: މުއްދަތެއް ބަންދުކުރުމުން ނުވަތަ އަލުން ހުޅުވުމުން އެހެން އެންމެންނަށް ޕޯސްޓްކުރެވޭ ގޮތް ބަދަލުވެއެވެ.",
        "mfaNotEnrolled": "މުއްދަތެއް ބަންދުކުރުމަށް ދެވަނަ ފެކްޓަރެއް ބޭނުންވެއެވެ، އަދި މި އެކައުންޓުގައި އަދި އެއެއް ނެތެވެ.",
        "mfaLink": "އޮތެންޓިކޭޓަރެއް ސެޓަޕްކުރޭ",
        "stepUpRequired": "މިކަން ހުއްދަކުރުމުގެ ކުރިން ސާވަރުން ތިޔައީ ތިޔަ ފަރާތްކަން އަލުން ސާބިތުކުރަން އެދިއްޖެއެވެ. ދެވަނަ ފެކްޓަރު ޔަޤީންކޮށް، އަލުން މަސައްކަތްކުރޭ.",
        "failed": "އެކަން ނުކުރެވުނު",
        "doneDetail": "މުއްދަތު {period}.",
        "close": {
          "title": "މި މުއްދަތު ބަންދުކުރޭ",
          "consequence": "މި މުއްދަތަށް އިތުރު ޕޯސްޓިންގއެއް ނުކުރެވޭނެއެވެ. އިޞްލާޙުތައް ދާންޖެހޭނީ ހުޅުވިފައިވާ މުއްދަތަކަށެވެ.",
          "confirm": "މުއްދަތު ބަންދުކުރޭ",
          "done": "މުއްދަތު ބަންދުކުރެވިއްޖެ"
        },
        "soft_close": {
          "title": "މި މުއްދަތު މަޑުމަޑުން ބަންދުކުރޭ",
          "consequence": "ޕޯސްޓިންގތަކުން އިންޒާރު ދޭނެއެވެ، ނަމަވެސް ބަލައިގަނެވޭނެއެވެ. މަސް ރިވިއުކުރެވެމުންދާއިރު މި ބޭނުންކުރޭ.",
          "confirm": "މަޑުމަޑުން ބަންދުކުރޭ",
          "done": "މުއްދަތު މަޑުމަޑުން ބަންދުކުރެވިއްޖެ"
        },
        "reopen": {
          "title": "މި މުއްދަތު އަލުން ހުޅުވާ",
          "consequence": "މި މުއްދަތުން އަލުން ޕޯސްޓިންގތައް ބަލައިގަންނާނެއެވެ، އެހެންކަމުން ކުރިން ރިޕޯޓްކުރެވިފައިވާ އަދަދުތައް ބަދަލުވެދާނެއެވެ.",
          "confirm": "މުއްދަތު އަލުން ހުޅުވާ",
          "done": "މުއްދަތު އަލުން ހުޅުވިއްޖެ"
        },
        "permanent_close": {
          "title": "މި މުއްދަތު ދާއިމީކޮށް ބަންދުކުރޭ",
          "consequence": "މިއިން ދެ ފާސްކުރާ މީހަކަށް މުއްދަތު އަބަދަށް ބަންދުކުރުމަށް އެދެއެވެ. ފާސްވުމަށްފަހު އަލުން ހުޅުވުމެއް ނެތެވެ — އެޑްމިނިސްޓްރޭޓަރަކަށްވެސް، ސަޕޯޓަށްވެސް.",
          "confirm": "ދާއިމީ ބަންދުކުރުމަށް އެދޭ",
          "done": "ދާއިމީ ބަންދުކުރުމަށް އެދިއްޖެ",
          "codeLabel": "ސަބަބުގެ ކޯޑް",
          "codeHint": "މުއްދަތުގައި ރެކޯޑްވާ ކުރު ކޯޑެއް، މިސާލަކަށް year_end_signed_off.",
          "dualControl": "ދެ މީހުންގެ ފާސްކުރުމަށް ފޮނުވިއްޖެ. ހުރިހާ ފާސްކުރާ މީހުން ސޮއިކުރަންދެން މުއްދަތު ބަންދެއް ނުވެއެވެ."
        }
      },
      "terminal": "ބަންދުކުރެވިފައި",
      "reopenedWith": "އަލުން ހުޅުވިފައި: {code}",
      "permanentPending": "ދާއިމީ ބަންދުކުރުން ފާސްކުރުމަށް އިންތިޒާރުގައި (ރިކުއެސްޓް #{id})"
    },
    "accounts": {
      "title": "ހިސާބުތަކުގެ ޗާޓް",
      "description": "ކޮންމެ ޕޯސްޓިންގއެއް ޖެހެނީ މީގެ ތެރެއިން އެއްޗަކަށެވެ. ސުރުޚީތަކުން ޗާޓަށް ބައްޓަން ދެއެވެ؛ ޖާނަލްތަކުން ބޭނުންކުރެވެނީ ޕޯސްޓްކުރެވޭ ހިސާބުތަކެވެ.",
      "loadFailed": "ޗާޓް ލޯޑެއް ނުވި",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން ހޯދާ",
      "searchLabel": "ހިސާބުތަކުގެ ޗާޓް ހޯދާ",
      "emptyTitle": "އަދި އެއްވެސް ހިސާބެއް ނެތް",
      "emptyDescription": "ޤާނޫނާ އެއްގޮތް ޗާޓަކުން ފެށުމަށް ޓެމްޕްލޭޓެއް ބޭނުންކުރޭ، ނުވަތަ ފުރަތަމަ ހިސާބު އަމިއްލައަށް އިތުރުކުރޭ.",
      "createTitle": "އައު ހިސާބު",
      "editTitle": "ހިސާބު އެޑިޓްކުރޭ",
      "formDescription": "އޮންނަ ތަން، އެއީ ކޮން އެއްޗެއްކަން، އަދި ބޭނުންކުރުމަށް ޖާނަލްގައި ހުންނަންޖެހޭ ބައިތައް.",
      "created": "ހިސާބު އުފެއްދިއްޖެ",
      "saved": "ހިސާބު ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ހިސާބު ރައްކާއެއް ނުކުރެވުނު",
      "treeTitle": "ހިސާބުތައް",
      "treeCount": "އެއް ހިސާބު | {count} ހިސާބު",
      "noSelection": "އެއްވެސް އެއްޗެއް ޚިޔާރުކޮށްފައެއް ނުވޭ",
      "noSelectionHint": "ބޭނުންކުރެވޭ ގޮތް ބެލުމަށް ހިސާބެއް ޚިޔާރުކުރޭ.",
      "noMatches": "އެއާ ގުޅޭ ހިސާބެއް ނެތް.",
      "postable": "ޕޯސްޓްކުރެވޭ",
      "heading": "ސުރުޚީ",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "anyCurrency": "ކޮންމެ ފައިސާއެއް",
      "noDimensions": "އެއްވެސް އެއްޗެއް ލާޒިމެއް ނޫން",
      "addChild": "ދަށު ހިސާބެއް އިތުރުކުރޭ",
      "requiresDimensions": "ޖާނަލްގައި ހުންނަންޖެހޭ ބައިތައް",
      "types": {
        "ASSET": "މުދާ",
        "LIABILITY": "ދަރަނި",
        "EQUITY": "ހިއްސާ",
        "INCOME": "އާމްދަނީ",
        "EXPENSE": "ޚަރަދު"
      },
      "a11y": {
        "expand": "{name} ފުޅާކުރޭ",
        "collapse": "{name} ކުޑަކުރޭ"
      },
      "fields": {
        "code": "ކޯޑް",
        "codeHint": "މި ކުންފުނީގެ ޗާޓުގައި ތަފާތު، އަދި ހިސާބު ތަރުތީބުވާ ގޮތް.",
        "type": "ބާވަތް",
        "parent": "ދަށުގައި އޮންނަނީ",
        "parentHint": "މައި ހިސާބާއި އޭގެ ދަށު ހިސާބުތަކުގެ ބާވަތް އެއްގޮތްވާންޖެހެއެވެ.",
        "noParent": "އެންމެ މަތީ ދަރަޖަ",
        "postable": "ޖާނަލްތަކުން ޕޯސްޓްކުރެވޭ",
        "postableHint": "ޕޯސްޓްކުރެވޭ ހިސާބެއްގެ ދަށުގައި އެހެން ހިސާބުތަކެއް ނުހުރެވޭނެއެވެ.",
        "currency": "ފައިސާގެ ހުރަސް",
        "currencyHint": "ކޮންމެ ފައިސާއެއް ހުއްދަކުރަން ހުސްކޮށް ބާއްވާ.",
        "dimensions": "ލާޒިމު ބައިތައް",
        "dimensionsHint": "މިތާ ފާހަގަޖަހާފައިވާ އެއްޗެހި ނެތި މި ހިސާބުގެ ޖާނަލް ސަތުރެއް ބަލައެއް ނުގަނެވޭނެއެވެ.",
        "requiresCostCenter": "ކޮސްޓް ސެންޓަރ",
        "requiresProfitCenter": "ޕްރޮފިޓް ސެންޓަރ",
        "requiresBranch": "ގޮފި",
        "requiresDepartment": "ޑިޕާޓްމަންޓް",
        "requiresProject": "ޕްރޮޖެކްޓް",
        "active": "ހަރަކާތްތެރި",
        "activeHint": "ހަރަކާތްތެރި ނޫން ހިސާބުތަކުގެ ތާރީޚު ބާކީ ހުންނާނެއެވެ، ނަމަވެސް އައު ޕޯސްޓިންގތަކެއް ނުނަގާނެއެވެ."
      },
      "rules": {
        "parentMissing": "އެ ހިސާބު މިހާރު މި ޗާޓުގައެއް ނެތް.",
        "cycle": "{code} އޮތީ މި ހިސާބުގެ ދަށުގައި، އެހެންވެ އެއީ މީގެ މައި ހިސާބަކަށް ނުވެވޭނެއެވެ.",
        "postableParent": "{code} އަކީ ޕޯސްޓްކުރެވޭ ހިސާބެއް، އެހެންވެ ދަށު ހިސާބުތަކެއް ނުހުރެވޭނެއެވެ — ފުރަތަމަ އެއީ ސުރުޚީއަކަށް ހަދާ.",
        "typeMismatch": "{code} އަކީ {type}؛ ދަށު ހިސާބުވެސް އެ ބާވަތުގައި ވާންޖެހެއެވެ.",
        "postableHasChildren": "މި ހިސާބުގެ ދަށުގައި {count} ހިސާބު ހުރުމުން، ސީދާ ޖާނަލްތަކުން ޕޯސްޓެއް ނުކުރެވޭނެއެވެ.",
        "typeHasChildren": "ފުރަތަމަ އޭގެ {count} ދަށު ހިސާބު ބަދަލުކުރޭ: މައި ހިސާބާއި ދަށު ހިސާބުތަކުގެ ބާވަތް އެއްގޮތްވާންޖެހެއެވެ.",
        "blocked": "ރައްކާކުރުމުގެ ކުރިން ފާހަގަކުރެވިފައިވާ ޚިޔާރު އިޞްލާޙުކުރޭ."
      },
      "template": {
        "title": "ޓެމްޕްލޭޓެއް ބޭނުންކުރޭ",
        "description": "ޓެމްޕްލޭޓަކުން މުޅި ޗާޓް އެއްފަހަރާ އެކުލަވާލައެވެ. މިއީ ފެށޭ ހިސާބެއް، އެއްކޮށްލުމެއް ނޫނެވެ.",
        "chooseLabel": "ޓެމްޕްލޭޓް",
        "confirm": "ޗާޓް އެކުލަވާލާ",
        "applied": "ހިސާބުތަކުގެ ޗާޓް އުފެއްދިއްޖެ",
        "appliedDetail": "{count} ހިސާބު.",
        "failed": "ޓެމްޕްލޭޓް ބޭނުމެއް ނުކުރެވުނު",
        "alreadyHasChart": "މި ކުންފުނީގައި ކުރިންވެސް ހިސާބުތައް ހުރުމުން ޓެމްޕްލޭޓް ބަލައެއް ނުގަނެވޭނެއެވެ. އޭގެ ބަދަލުގައި ނެތް އެއްޗެހި އަމިއްލައަށް އިތުރުކުރޭ.",
        "systemHint": "ފޯރުކޮށްދެވިފައިވާ ޓެމްޕްލޭޓް {code}"
      }
    },
    "openingBalances": {
      "title": "ފެށޭ ބެލެންސްތައް",
      "description": "މި ކުންފުނި ފަށާ ބެލެންސްތައް. މިތަކެތި އެއްކޮށް ބެލެވި، ދެ ފަރާތަކުން ފާސްކުރެވި، ބެލެންސްވެފައިވާ އެއް ޖާނަލްގެ ގޮތުގައި ޕޯސްޓްކުރެވެއެވެ.",
      "uploadTitle": "ސީއެސްވީއެއް އަޕްލޯޑްކުރޭ",
      "uploadDescription": "ފައިލް އެއްކޮށް ބެލެވެއެވެ، އަދި ހުށަހަޅަންދެން އެއްވެސް އެއްޗެއް ނުލިޔެވެއެވެ.",
      "columnsHint": "ކޮލަމްތައް: accountCode، debit، credit، އަދި ބޭނުންނަމަ description، costCenter، profitCenter، branch، department.",
      "validate": "ފައިލް ބަލާ",
      "validating": "ބަލަނީ",
      "uploadFailed": "ފައިލް ކިޔައެއް ނުލެވުނު",
      "reportTitle": "ބެލި ރިޕޯޓް",
      "submitForApproval": "ފާސްކުރުމަށް ހުށަހަޅާ",
      "fixAndRetry": "މަތީގައިވާ ސަތުރުތައް އިޞްލާޙުކޮށް ފައިލް އަލުން އަޕްލޯޑްކުރޭ.",
      "submitted": "ފާސްކުރުމަށް ހުށަހެޅިއްޖެ",
      "submittedDetail": "މިހާރު އެއީ {status}.",
      "submitFailed": "ހުށަހެޅުމެއް ނުކުރެވުނު",
      "loadFailed": "އިމްޕޯޓް ތާރީޚު ލޯޑެއް ނުވި",
      "emptyTitle": "އަދި ފެށޭ ބެލެންސްއެއް އިމްޕޯޓްކޮށްފައެއް ނުވޭ",
      "emptyDescription": "ގެންނަން ބޭނުންވާ ޓްރައަލް ބެލެންސް އަޕްލޯޑްކުރޭ، ނުވަތަ ކުންފުނި ފަށަނީ ސުމަކުން ކަމަށް ރެކޯޑްކުރޭ.",
      "historyTitle": "އިމްޕޯޓްތައް",
      "awaitingApproval": "ފާސްކުރާ ފަރާތްތަކުގެ އިންތިޒާރުގައި",
      "postJournal": "ފެށޭ ޖާނަލް ޕޯސްޓްކުރޭ",
      "posting": "ޕޯސްޓްކުރަނީ",
      "posted": "ފެށޭ ޖާނަލް ޕޯސްޓްކުރެވިއްޖެ",
      "postedDetail": "ޖާނަލް {entryNo} ގެ ދެފަރާތުގައިވެސް {amount}.",
      "postFailed": "ފެށޭ ޖާނަލް ޕޯސްޓެއް ނުކުރެވުނު",
      "awaitingPosting": "ފާސްކުރެވިއްޖެ — ޕޯސްޓްކުރުމުގެ އިންތިޒާރުގައި",
      "viewJournal": "ފެށޭ ޖާނަލް ބަލާ",
      "lineCount": "އެއް ސަތުރު | {count} ސަތުރު",
      "fields": {
        "file": "ސީއެސްވީ ފައިލް",
        "fileHint": "ކޮންމެ ހިސާބަކަށް އެއް ސަތުރު، ޑެބިޓެއް ނުވަތަ ކްރެޑިޓަކާއެކު — ދެއެއްޗެއް އެއްފަހަރާ ނޫން.",
        "asOfDate": "ތާރީޚް",
        "asOfDateHint": "ޕޯސްޓްކުރަން ފަށާ ފުރަތަމަ މުއްދަތުގެ ކުރީ ދުވަސް.",
        "currency": "ފައިސާ",
        "currencyHint": "ޢާންމުކޮށް ކުންފުނީގެ އަސާސީ ފައިސާ.",
        "note": "ނޯޓް"
      },
      "columns": {
        "file": "ފައިލް",
        "asOf": "ތާރީޚް",
        "debit": "ޑެބިޓް",
        "credit": "ކްރެޑިޓް"
      },
      "status": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "ހުށަހެޅިފައި",
        "approved": "ފާސްކުރެވިފައި",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "rejected": "ބޭރުކުރެވިފައި"
      },
      "report": {
        "label": "ބެލި ރިޕޯޓް",
        "valid": "ފައިލް ބެލެންސްވެއެވެ. {count} ސަތުރު ހުށަހަޅަން ތައްޔާރު.",
        "invalid": "ފައިލް ބަލައެއް ނުގަނެވުނު. އިޞްލާޙުކުރަންޖެހޭ {count} މައްސަލަ.",
        "rows": "ސަތުރުތައް",
        "totalDebit": "ޖުމްލަ ޑެބިޓް",
        "totalCredit": "ޖުމްލަ ކްރެޑިޓް",
        "difference": "ތަފާތު",
        "unbalanced": "ޑެބިޓާއި ކްރެޑިޓް ހަމައެއް ނުވޭ، އެހެންކަމުން އެއްވެސް އެއްޗެއް ނުލިޔެވެއެވެ. މަތީގައިވާ ތަފާތަކީ ސީދާ ޢަދަދެވެ.",
        "fileError": "ފައިލް",
        "line": "ސަތުރު",
        "column": "ކޮލަމް",
        "problem": "މައްސަލަ",
        "account": "ހިސާބު",
        "debit": "ޑެބިޓް",
        "credit": "ކްރެޑިޓް",
        "errorsCaption": "އިޞްލާޙުކުރަންޖެހޭ ސަތުރުތައް",
        "linesCaption": "ފައިލުން ކިޔުނު ސަތުރުތައް"
      }
    },
    "routeTitles": {
      "locations": "ތަންތަން",
      "jobs": "މަސައްކަތްތައް",
      "grades": "މަސައްކަތުގެ ދަރަޖަތައް",
      "positions": "މަޤާމުތައް",
      "designations": "ޕީ.އެސް.ޔޫ / ޓީ.އާރް.ޔޫ ކަނޑައެޅުންތައް",
      "filings": "ފައިލްކުރުމުގެ ކަލަންޑަރު"
    },
    "effdate": {
      "groupLabel": "ބާރުގައި ހުންނަ ތާރީޚް",
      "asAt": "ތާރީޚް",
      "from": "ބާރުގައި ފެށޭ",
      "to": "ބާރުގައި ނިމޭ",
      "window": "ބާރުގައި",
      "backToToday": "މިއަދަށް އެނބުރި",
      "previousDay": "ކުރީ ދުވަސް",
      "nextDay": "ޖެހިގެން އަންނަ ދުވަސް",
      "futureNotice": "ކުރިއަށް އޮތް ތާރީޚެއް ދައްކަނީ",
      "pastNotice": "ފާއިތުވި ތާރީޚެއް ދައްކަނީ",
      "history": "ތާރީޚް ({count})",
      "states": {
        "current": "ބާރުގައި",
        "future": "އަދި ބާރުގައެއް ނޫން",
        "past": "ބަދަލުވެފައި"
      }
    },
    "address": {
      "legend": "އެޑްރެސް",
      "country": "ޤައުމު",
      "countryPlaceholder": "ދެ އަކުރުގެ ކޯޑް، މިސާލަކަށް MV",
      "line1": "އެޑްރެސް ލައިން 1",
      "line2": "އެޑްރެސް ލައިން 2",
      "line3": "އެޑްރެސް ލައިން 3",
      "locality": "ރަށް ނުވަތަ ސިޓީ",
      "subdivision": "އަތޮޅު ނުވަތަ ޕްރޮވިންސް",
      "postalCode": "ޕޯސްޓަލް ކޯޑް",
      "geoHint": "ރަޖިސްޓްރީވެފައިވާ ތަނަކާ ދިމާވާންޖެހެއެވެ، ހަމައެކަނި ލިޔުމަކުން ނުފުދެއެވެ — ޓެކްސް އިޚްތިޞާޞް ނެރެވެނީ މިއިންނެވެ.",
      "check": "އެޑްރެސް ބަލާ",
      "checkFailed": "މިވަގުތު އެޑްރެސް ބެލޭ ގޮތެއް ނުވި. އެޑްރެސް ބެލިފައެއް ނުވެއެވެ.",
      "valid": "އެޑްރެސް ސައްޙަ.",
      "jurisdiction": "އިޚްތިޞާޞް #{id} އަށް ނެރެވިއްޖެ.",
      "invalidEnforced": "މި ޤައުމުން ސައްޙަ އެޑްރެހެއް ލާޒިމުކުރެއެވެ. ރައްކާކުރުމަށް ދޫކުރުމުގެ ސަބަބެއް ބޭނުންވެއެވެ.",
      "invalidWarned": "މި ޤައުމުގެ ޤަވާޢިދުތަކާ އެޑްރެސް ދިމައެއް ނުވެއެވެ. އެކަމަކު ރައްކާކުރެވިދާނެއެވެ.",
      "missing": "ނެތް: {fields}.",
      "levels": {
        "enforce": "ބެލުން ލާޒިމު",
        "warn": "ބެލުން އިރުޝާދެއް",
        "allow": "ބެލުން ނިއްވާލެވިފައި"
      },
      "status": {
        "unvalidated": "ބަލާފައެއް ނުވޭ",
        "validated": "ބެލިފައި",
        "waived": "ދޫކުރެވިފައި",
        "invalid": "ސައްޙައެއް ނޫން"
      }
    },
    "location": {
      "title": "ތަންތަން",
      "description": "ކުންފުނިތަކާއި، ބްރާންޗްތަކާއި ގުދަންތައް ނިސްބަތްވާ ޙިއްޞާކުރެވޭ ތަންތަން. ތަނެއްގެ އެޑްރެހުން އެ ތަނުގެ ޓެކްސް އިޚްތިޞާޞް ނެރެވެއެވެ.",
      "create": "އައު ތަނެއް",
      "createTitle": "އައު ތަން",
      "editTitle": "ތަން އެޑިޓްކުރޭ",
      "editorDescription": "ތަނެއް އެއް ކުންފުންޏަށް ނިސްބަތްވެދާނެ، ނުވަތަ މުޅި ގްރޫޕުން ޙިއްޞާކުރެވިދާނެއެވެ.",
      "code": "ކޯޑް",
      "name": "ނަން",
      "type": "ބާވަތް",
      "company": "ކުންފުނި",
      "companyHint": "މުޅި ގްރޫޕުން ޙިއްޞާކުރާ ތަނަކަށް ހުހަށް ބާއްވަވާ.",
      "shared": "ކުންފުނިތަކުގެ މެދުގައި ޙިއްޞާކުރެވޭ",
      "parent": "ހިމެނޭ ތަން",
      "address": "އެޑްރެސް",
      "addressStatus": "އެޑްރެސް",
      "addressRejected": "މި ޤައުމުން އެޑްރެސް ބެލުން ލާޒިމުކުރާތީ އެޑްރެސް ދޫނުކުރެވުނެވެ. ރައްކާކުރުމަށް ދޫކުރުމުގެ ސަބަބެއް ރެކޯޑްކުރައްވާ.",
      "waiverLabel": "ދޫކުރުމުގެ ސަބަބު",
      "jurisdictionColumn": "އިޚްތިޞާޞް",
      "noJurisdiction": "ނުނެރެވޭ",
      "timezone": "ޓައިމްޒޯން",
      "timezoneHint": "އައި.އޭ.އެން.އޭ ނަން، މިސާލަކަށް Indian/Maldives. ކުންފުނީގެ އެއްޗެއް ބޭނުންކުރުމަށް ހުހަށް ބާއްވަވާ.",
      "openedOn": "ހުޅުވުނު ތާރީޚް",
      "inventory": "މުދާ ބަހައްޓައެވެ",
      "inventoryHint": "މުދާ ބަހައްޓާ ގުދަންތަކާއި ފިހާރަތައް.",
      "searchHint": "ކޯޑް، ނަން ނުވަތަ ރަށް",
      "tableLabel": "ތަންތަން",
      "treeLabel": "ތަންތަން، ގޮފިތަކެއްގެ ގޮތުގައި",
      "tabsLabel": "ތަންތަން ދައްކާ ގޮތް",
      "tabs": {
        "list": "ލިސްޓް",
        "tree": "ގޮފި"
      },
      "emptyTitle": "އަދި ތަނެއް ނެތް",
      "emptyDescription": "ވިޔަފާރިކުރާ ތަންތަން އިތުރުކުރައްވާ. ތަނުން ޓެކްސް އިޚްތިޞާޞެއް ނުނެރެވެނީސް ކުންފުންޏެއް ހަރަކާތްތެރި ނުކުރެވޭނެއެވެ.",
      "attention": "{count} ތަނެއްގެ އެޑްރެސް ބެލިފައެއް ނުވެއެވެ. އެ ތަނަކަށް ނިސްބަތްވާ ކުންފުންޏަކަށް ޓެކްސް ނުނެރެވޭނެއެވެ.",
      "loadFailed": "ތަންތަން ލޯޑެއް ނުވި",
      "saved": "ތަން ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ތަން ރައްކާއެއް ނުކުރެވުނު",
      "types": {
        "office": "އޮފީސް",
        "warehouse": "ގުދަން",
        "outlet": "ފިހާރަ",
        "property": "ޕްރޮޕަޓީ",
        "plant": "ޕްލާންޓް",
        "site": "ސައިޓް",
        "virtual": "ވާރޗުއަލް"
      },
      "statuses": {
        "planned": "ރޭވިފައި",
        "active": "ހަރަކާތްތެރި",
        "closed": "ބަންދު"
      }
    },
    "division": {
      "title": "ޑިވިޜަންތައް",
      "description": "މެނޭޖްމަންޓް ރިޕޯޓިންގގެ ބައެއް. ޑިވިޜަން އޮންނަނީ ޖާނަލް ލައިންގައި، ލިޔުމުގެ ހެޑަރުގައެއް ނޫން، ވުމާއެކު އެއް ލިޔުމަކުން ދެ ޑިވިޜަނަށް ފެތިދާނެއެވެ.",
      "create": "އައު ޑިވިޜަނެއް",
      "createTitle": "އައު ޑިވިޜަން",
      "editTitle": "ޑިވިޜަން އެޑިޓްކުރޭ",
      "editorDescription": "ޑިވިޜަންތަކުން މެނޭޖްމަންޓް ރިޕޯޓިންގއަށް ނަތީޖާ އެއްކުރެއެވެ. މިއީ ޤާނޫނީ ނުވަތަ ކޮސްޓިންގ އެންޓިޓީއެއް ނޫނެވެ.",
      "code": "ކޯޑް",
      "name": "ނަން",
      "parent": "މަތީ ޑިވިޜަން",
      "manager": "ޒިންމާދާރު މެނޭޖަރު",
      "managerHint": "މީހެއް ނޫން، މަޤާމެއް: މީހާ ބަދަލުވިޔަސް ޒިންމާ ބަދަލެއް ނުވެއެވެ.",
      "managerAfterCreate": "ޒިންމާދާރު މެނޭޖަރު ކަނޑައެޅެނީ ޑިވިޜަން އުފެދުމަށްފަހުއެވެ.",
      "noManager": "ހަވާލުކޮށްފައެއް ނުވޭ",
      "activeOnly": "ހަރަކާތްތެރި އެކަނި",
      "isActive": "ހަރަކާތްތެރި",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތެއް ނެތް",
      "delete": "ފޮހެލާ",
      "deleteTitle": "ޑިވިޜަން ފޮހެލާ",
      "deleteConsequence": "ޕޯސްޓްކުރެވިފައިވާ ޖާނަލް ލައިނެއްގައި ބޭނުންކޮށްފައިވާ ޑިވިޜަނެއް ނުފޮހެވޭނެއެވެ؛ އޭގެ ބަދަލުގައި ހަރަކާތް ހުއްޓުވާ.",
      "deleted": "ޑިވިޜަން ފޮހެލެވިއްޖެ",
      "tableLabel": "ޑިވިޜަންތައް",
      "emptyTitle": "އަދި ޑިވިޜަނެއް ނެތް",
      "emptyDescription": "މިހާރު ހުރި ފަސް ބައިން ނުދެވޭ ގޮތަކަށް މެނޭޖްމަންޓް ރިޕޯޓިންގއަށް ބޭނުންވާނަމަ އެކަތި އުފައްދަވާ.",
      "loadFailed": "ޑިވިޜަންތައް ލޯޑެއް ނުވި",
      "saved": "ޑިވިޜަން ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޑިވިޜަން ރައްކާއެއް ނުކުރެވުނު"
    },
    "ledger": {
      "title": "ލެޖަރުތައް",
      "description": "ކޮންމެ ކުންފުންޏެއްވެސް ބަލަހައްޓަނީ އެންމެ އެއް މައި ފޮތެކެވެ. ކޮންމެ ޕޯސްޓިންގއެއް ދަނީ އެ ފޮތަށް، އަދި ކޮންމެ ރިޕޯޓެއް ފިލްޓަރުކުރެވެނީ އެއަށެވެ.",
      "inactive": "ހަރަކާތެއް ނެތް",
      "emptyTitle": "ލެޖަރެއް ނެތް",
      "emptyDescription": "މައި ލެޖަރު އުފެދެނީ ކުންފުންޏާއެކުއެވެ. މިތަން ހުސްނަމަ، ކުންފުނި އުފެދިފައިވަނީ ލެޖަރު މައިގްރޭޝަންގެ ކުރިންނެވެ.",
      "roles": {
        "primary": "މައި",
        "secondary": "ދެވަނަ"
      }
    },
    "designation": {
      "title": "ޕީ.އެސް.ޔޫ / ޓީ.އާރް.ޔޫ ކަނޑައެޅުންތައް",
      "description": "ކުންފުނި ދައުލަތުގެ ބަޔާންތައް ފައިލްކުރަނީ ކޮން ހައިސިއްޔަތަކުންކަން، އިޚްތިޞާޞަކަށް އަދި ވަގުތާއެކު.",
      "create": "އައު ކަނޑައެޅުމެއް",
      "createTitle": "އައު ކަނޑައެޅުން",
      "createDescription": "އެއް އިޚްތިޞާޞެއްގައި ކުންފުންޏަކީ ޕޭރޯލް ސްޓެޓިއުޓަރީ ޔުނިޓަކާއި ޓެކްސް ރިޕޯޓިންގ ޔުނިޓަކަށްވެސް ވެދާނެއެވެ.",
      "supersede": "އައު ވަރޜަނެއް",
      "supersedeTitle": "ކަނޑައެޅުމުގެ އައު ވަރޜަން",
      "supersedeDescription": "ތާރީޚަކުން ފެށިގެން ޙަޤީޤަތެއް ބަދަލުވިކަން ރެކޯޑްކުރެއެވެ. ކުރީގެ ވަރޜަން ރެކޯޑްގައި ދެމިހުރެއެވެ.",
      "kind": "ކަނޑައެޅުން",
      "jurisdiction": "އިޚްތިޞާޞް",
      "identifier": "އައިޑެންޓިފަޔަރ",
      "identifierHint": "މި ކަނޑައެޅުމުން ފައިލްކުރާ ނަންބަރު، ދޫކުރެވިފައިވާނަމަ.",
      "noIdentifier": "ދޫކުރެވިފައެއް ނުވޭ",
      "registration": "ރަޖިސްޓްރޭޝަން",
      "pendingRegistration": "ގުޅުވާފައެއް ނުވޭ",
      "retroactive": "އައު ވަރޜަނެއް ފެށެންޖެހޭނީ މިހާރު ބާރުގައި އޮތް ވަރޜަނަށްފަހުއެވެ. ތާރީޚް ރަނގަޅުކުރަންޖެހެނީ އޮޑިޓް އެޖަސްޓްމަންޓަކުން، މިތަނަކުން ނޫނެވެ.",
      "tableLabel": "ކުންފުނީގެ ކަނޑައެޅުންތައް",
      "emptyTitle": "ކަނޑައެޅުމެއް ނެތް",
      "emptyDescription": "މި ކުންފުންޏަށް ޕޭރޯލް ނުވަތަ ޓެކްސް ބަޔާން ތައްޔާރުކުރުމުގެ ކުރިން ފައިލްކުރާ ހައިސިއްޔަތު ކަނޑައަޅުއްވާ.",
      "loadFailed": "ކަނޑައެޅުންތައް ލޯޑެއް ނުވި",
      "saved": "ކަނޑައެޅުން ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ކަނޑައެޅުން ރައްކާއެއް ނުކުރެވުނު",
      "kinds": {
        "PSU": "ޕޭރޯލް ސްޓެޓިއުޓަރީ ޔުނިޓް",
        "TRU": "ޓެކްސް ރިޕޯޓިންގ ޔުނިޓް",
        "LE": "ޤާނޫނީ ފަރާތް"
      },
      "kindHints": {
        "PSU": "ޕޭރޯލްގެ ދައުލަތުގެ ބަޔާންތަކާއި ފައިސާ ދައްކައެވެ.",
        "TRU": "އިޚްތިޞާޞަށް ޓެކްސް ބަޔާން ފައިލްކުރެއެވެ.",
        "LE": "އިޚްތިޞާޞްގައި ޤާނޫނީ ފަރާތެއްގެ ގޮތުގައި ބަލައިގަނެވިފައި."
      }
    },
    "filing": {
      "title": "ފައިލްކުރުމުގެ ކަލަންޑަރު",
      "description": "ޓެކްސް އިދާރާއަށް ދައްކަންޖެހޭ އެއްޗެއްސާއި، ލަސްވެފައިވާ އެއްޗެހި.",
      "return": "ބަޔާން",
      "due": "ދައްކަންޖެހޭ",
      "dueBefore": "ދައްކަންޖެހޭ ތާރީޚް ކުރިން",
      "dueIn": "{days} ދުވަހުން ދައްކަންޖެހޭ",
      "overdueBy": "{days} ދުވަސް ލަސްވެފައި",
      "waivedReason": "ދޫކުރުން",
      "waive": "ދޫކުރޭ",
      "waiveTitle": "ފައިލްކުރުމުގެ ވާޖިބެއް ދޫކުރޭ",
      "waiveConsequence": "ވާޖިބު ދޫކުރެވިފައިވާ ކަމަށް ރެކޯޑްގައި ދެމިހުރެއެވެ. ދުވަހަކުވެސް ނުފޮހެވެއެވެ — ނެތް ރޯއަކާއި ދޫކުރެވުނު ރޯއެއް އޮޑިޓަރަކަށް އެއްގޮތް، އަދި އޭގެ ތެރެއިން އެކަތި އެކަނި މީހަކު ނިންމި ނިންމުމެކެވެ.",
      "waiveReason": "ދޫކުރުމުގެ ސަބަބުގެ ކޯޑް",
      "waiveReasonHint": "އޮޑިޓް ރެކޯޑްގައި އެގޮތަށް ރެކޯޑްކުރެވެއެވެ. މި ފީލްޑަށް އަދި ކަނޑައެޅިފައިވާ ސެޓެއް ނެތެވެ.",
      "waiveNoteHint": "ދޫކުރުން ބިނާވަނީ ކޮން ކަމެއްގެ މައްޗަށްކަން، އަހަރެއް ފަހުން މި ކިޔާ މީހަކަށް.",
      "waived": "ވާޖިބު ދޫކުރެވިއްޖެ",
      "kpiOverdue": "ލަސްވެފައި",
      "kpiOverdueHelp": "ދައްކަންޖެހޭ ތާރީޚް ފާއިތުވެ، ފައިލްނުކުރެވި، ނުދައްކާ އަދި ދޫނުކުރެވޭ ވާޖިބުތައް.",
      "kpiDueSoon": "ހަފުތާއެއްގެ ތެރޭގައި",
      "kpiDueSoonHelp": "ކުރިއަށް އޮތް ހަތް ދުވަހުގެ ތެރޭގައި ދައްކަންޖެހޭ ވާޖިބުތައް.",
      "tableLabel": "ފައިލްކުރުމުގެ ވާޖިބުތައް",
      "emptyTitle": "ކަލަންޑަރުގައި އެއްޗެއް ނެތް",
      "emptyDescription": "ވާޖިބުތައް އުފެދެނީ މިހާރުގެ މުއްދަތުން ފެށިގެން ކުރިއަށް ކަމުން، އަލަށް އަޕްގްރޭޑްކުރި ޓެނަންޓެއް ފެށެނީ ހުހަށެވެ، އަދި މުއްދަތުތައް ހުޅުވެމުން ފުރެއެވެ.",
      "loadFailed": "ފައިލްކުރުމުގެ ވާޖިބުތައް ލޯޑެއް ނުވި",
      "statuses": {
        "pending": "އިންތިޒާރުގައި",
        "prepared": "ތައްޔާރުކުރެވިފައި",
        "filed": "ފައިލްކުރެވިފައި",
        "paid": "ދައްކާފައި",
        "waived": "ދޫކުރެވިފައި",
        "overdue": "ލަސްވެފައި"
      }
    },
    "job": {
      "title": "މަސައްކަތްތައް",
      "description": "މަސައްކަތަކީ ކޮބައިކަން، ކުންފުންޏާއި، ޢަދަދާއި މުސާރައާ ވަކިން.",
      "create": "އައު މަސައްކަތެއް",
      "createTitle": "އައު މަސައްކަތް",
      "editTitle": "މަސައްކަތް އެޑިޓްކުރޭ",
      "editorDescription": "މަސައްކަތެއްގެ ނަން ބަދަލުކުރެވެއެވެ، ވަރޜަނެއް ނުހެދެއެވެ — މިދިޔަ އަހަރު އޭގެ ނަން ކިޔުނު ގޮތަކަށް ލެޖަރުގައި އެއްވެސް އެއްޗެއް ބިނާވެފައެއް ނުވެއެވެ.",
      "code": "ކޯޑް",
      "name": "ނަން",
      "family": "ޢާއިލާ",
      "familyHint": "ފައިނޭންސް ނުވަތަ ފްރޮންޓް އޮފީސް ފަދަ ބައެއް.",
      "defaultGrade": "ޑިފޯލްޓް ދަރަޖަ",
      "defaultGradeHint": "މި މަސައްކަތުގެ އައު މަޤާމަކަށް ލިބޭ ދަރަޖަ، ބަދަލުނުކުރާނަމަ.",
      "activeOnly": "ހަރަކާތްތެރި އެކަނި",
      "isActive": "ހަރަކާތްތެރި",
      "isActiveHint": "ފޮހެލުމުގެ ބަދަލުގައި ހަރަކާތް ހުއްޓުވާ: މަޤާމުތައް މަސައްކަތްތަކަށް ނިސްބަތްވެއެވެ.",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތެއް ނެތް",
      "searchHint": "ކޯޑް ނުވަތަ ނަން",
      "tableLabel": "މަސައްކަތްތައް",
      "emptyTitle": "އަދި މަސައްކަތެއް ނެތް",
      "emptyDescription": "މަސައްކަތްކުރާ މަޤާމުތައް އުފެއްދުމުގެ ކުރިން މަސައްކަތް ކަނޑައަޅުއްވާ.",
      "loadFailed": "މަސައްކަތްތައް ލޯޑެއް ނުވި",
      "saved": "މަސައްކަތް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "މަސައްކަތް ރައްކާއެއް ނުކުރެވުނު"
    },
    "grade": {
      "title": "މަސައްކަތުގެ ދަރަޖަތައް",
      "description": "ސީނިއަރކަމުގެ ބޭންޑްތަކާއި އެ ބޭންޑްތަކުގެ މުސާރައިގެ ރޭންޖް. ރޭންޖަކީ ވަރޜަންކުރެވޭ އެއްޗެއް؛ ދަރަޖައެއް ނޫން.",
      "create": "އައު ދަރަޖައެއް",
      "createTitle": "އައު މަސައްކަތުގެ ދަރަޖަ",
      "createDescription": "ދަރަޖައިގެ ފުރަތަމަ ވަރޜަން، ތިޔަ ދެއްވާ ތާރީޚުން ފެށިގެން ބާރުގައި.",
      "supersedeTitle": "ދަރަޖައިގެ އައު ވަރޜަން",
      "supersedeDescription": "އަހަރީ މުސާރައިގެ ބޭންޑް އަލުން ކަނޑައެޅުން. މިދިޔަ އަހަރުގެ ބޭންޑް ރެކޯޑްގައި ދެމިހުރެއެވެ، ސަބަބަކީ ޕޭރޯލުން ބޭންޑް ކިޔަނީ މުސާރަ ދޭ މުއްދަތުގެ ތާރީޚަށެވެ.",
      "newVersion": "އައު ވަރޜަނެއް",
      "code": "ކޯޑް",
      "name": "ނަން",
      "level": "ދަރަޖަ {level}",
      "levelColumn": "ދަރަޖަ",
      "levelHint": "މަތިވުމުން ސީނިއަރކަން ބޮޑެވެ. ބާރުގެ ފިޔަވަޅުތަކުން މިއާ އަޅާކިޔާތީ، އޮޅުމަކުން ލެވޭ ދަރަޖައަކީ ބާރުގެ ފަޅުކަމެކެވެ.",
      "currency": "ފައިސާ",
      "min": "އެންމެ ދަށް",
      "mid": "މެދު",
      "max": "އެންމެ މަތި",
      "effectiveFromNew": "އައު ވަރޜަން ބާރުގައި ފެށޭ",
      "effectiveFromHint": "މިހާރު ބާރުގައި އޮތް ވަރޜަން ފެށުނު ތާރީޚަށްފަހު ވާންޖެހެއެވެ.",
      "retroactive": "އައު ވަރޜަނެއް ފެށެންޖެހޭނީ މިހާރު ބާރުގައި އޮތް ވަރޜަނަށްފަހުއެވެ.",
      "history": "ތާރީޚް",
      "historyTitle": "މި ދަރަޖައިގެ ހުރިހާ ވަރޜަނެއް",
      "activeOnly": "ހަރަކާތްތެރި އެކަނި",
      "tableLabel": "މަސައްކަތުގެ ދަރަޖަތައް",
      "emptyTitle": "އަދި ދަރަޖައެއް ނެތް",
      "emptyDescription": "ބާރުގެ މެޓްރިކްސްއިން ބޭނުންކުރާނެ ސީނިއަރކަމުގެ ބޭންޑްތައް އިތުރުކުރައްވާ.",
      "loadFailed": "މަސައްކަތުގެ ދަރަޖަތައް ލޯޑެއް ނުވި",
      "saved": "ދަރަޖަ ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ދަރަޖަ ރައްކާއެއް ނުކުރެވުނު"
    },
    "position": {
      "title": "މަޤާމުތައް",
      "description": "ޖަމާޢަތުގައި ހުރި މަޤާމުތައް، އެ މަޤާމުތަކުގައި ތިބެނީ ކާކުކަމާ ނުބަލައި.",
      "create": "އައު މަޤާމެއް",
      "createTitle": "އައު މަޤާމު",
      "createDescription": "މަޤާމުގެ ފުރަތަމަ ވަރޜަން، ތިޔަ ދެއްވާ ތާރީޚުން ފެށިގެން ބާރުގައި.",
      "supersede": "އައު ވަރޜަނެއް ހުޅުވާ",
      "supersedeTitle": "މަޤާމުގެ އައު ވަރޜަން",
      "supersedeDescription": "ރީއޯގަނައިޒޭޝަނެއް: ތާރީޚަކުން ފެށިގެން އައު މެނޭޖަރެއް، ޑިޕާޓްމަންޓެއް، ދަރަޖައެއް ނުވަތަ ޢަދަދެއް. ކޯޑް ދުވަހަކުވެސް ބަދަލެއް ނުވެއެވެ.",
      "versionNote": "ބާރުގައި އޮތް ވަރޜަން ފެށުނީ {from} ގައެވެ. ރައްކާކުރުމުން ތިރީގައިވާ ތާރީޚުން އައު ވަރޜަނެއް ހުޅުވި، އެ ވަރޜަން ރެކޯޑްގައި ދެމިހުންނާނެއެވެ.",
      "code": "ކޯޑް",
      "name": "ނަން",
      "company": "ކުންފުނި",
      "job": "މަސައްކަތް",
      "grade": "ދަރަޖަ",
      "gradeHint": "ހުހަށް ބާއްވަވާނަމަ މަސައްކަތުން ލިބެއެވެ.",
      "reportsTo": "ރިޕޯޓްކުރާ ތަން",
      "reportsToHint": "ބާރުގެ ފިޔަވަޅަކުން ހިނގާ އަދި ޙާޟިރުނުވުމެއްގައި ދޫވާ ލައިން.",
      "headcount": "ޢަދަދު",
      "headcountHint": "އެއްފަހަރާ މި މަޤާމުގައި ތިބެވޭނެ މީހުންގެ ޢަދަދު. ޙައްދެއް ނެތް މަޤާމަކީ މަޤާމެއް ނޫން، މަސައްކަތެކެވެ.",
      "headcountShort": "{count} ގޮނޑި",
      "holders": "ތިބީ",
      "seats": "ފުރިފައި",
      "effectiveFromNew": "އައު ވަރޜަން ބާރުގައި ފެށޭ",
      "effectiveFromHint": "މިހާރު ބާރުގައި އޮތް ވަރޜަން ފެށުނު ތާރީޚަށްފަހު ވާންޖެހެއެވެ.",
      "retroactive": "އައު ވަރޜަނެއް ފެށެންޖެހޭނީ މިހާރު ބާރުގައި އޮތް ވަރޜަނަށްފަހުއެވެ.",
      "showHistory": "ތާރީޚް ދައްކާ",
      "hideHistory": "ތާރީޚް ފޮރުވާ",
      "vacantOnly": "ހުސް އެކަނި",
      "searchHint": "ކޯޑް ނުވަތަ ނަން",
      "assign": "ހަވާލުކުރޭ",
      "abolish": "އުވާލާ",
      "abolishTitle": "މަޤާމެއް އުވާލާ",
      "abolishConsequence": "މިއީ ނިމުމެކެވެ. ދެއްވާ ތާރީޚުގައި މަޤާމު ބަންދުވެ، އިތުރު ހަވާލުކުރުމެއް ނުބަލައިގަނެއެވެ. މީހަކު އަދިވެސް ހުރިނަމަ ދޫނުކުރެއެވެ.",
      "abolishDate": "އުވާލެވޭ ތާރީޚް",
      "abolishReason": "ސަބަބު",
      "abolished": "މަޤާމު އުވާލެވިއްޖެ",
      "created": "މަޤާމު އުފެދިއްޖެ",
      "superseded": "އައު ވަރޜަން އުފެދިއްޖެ",
      "saveFailed": "މަޤާމު ރައްކާއެއް ނުކުރެވުނު",
      "loadFailed": "މަޤާމުތައް ލޯޑެއް ނުވި",
      "tableLabel": "މަޤާމުތައް",
      "tabsLabel": "މަޤާމުތައް ދައްކާ ގޮތް",
      "tabs": {
        "list": "ލިސްޓް",
        "chart": "ރިޕޯޓިންގ ލައިން"
      },
      "emptyTitle": "އަދި މަޤާމެއް ނެތް",
      "emptyDescription": "ފާސްކުރުމުގެ މެޓްރިކްސްއިން ދާނެ މަޤާމުތައް އުފައްދަވާ. އެއްވެސް މީހަކު ނެތް މަޤާމަކަށް ދާ ސިލްސިލާއެއް ފުރިހަމައެއް ނުވާނެއެވެ.",
      "statuses": {
        "draft": "ދެލި ކޮޕީ",
        "active": "ހަރަކާތްތެރި",
        "frozen": "ހުއްޓިފައި",
        "abolished": "އުވާލެވިފައި"
      },
      "statusHints": {
        "draft": "ތައްޔާރުކުރެވެނީ. ބާރެއް ނުހިފައި، ހަވާލުކުރުމެއް ނުބަލައިގަނެއެވެ.",
        "active": "ޢާންމު.",
        "frozen": "މިހާރު ހުރި މީހާއަށް ބާރު ދެމިހުރެއެވެ، އައު ހަވާލުކުރުމެއް ނުބަލައިގަނެއެވެ.",
        "abolished": "ބަންދު."
      },
      "placement": "ތަން",
      "placementHint": "މި މަގާމު ޖަމާޢަތުގައި އޮންނަ ތަން. މި މަގާމަށް ޙަވާލުކުރެވޭ ކޮންމެ ބޭފުޅަކަށްވެސް މި މަޢުލޫމާތު ލިބެއެވެ.",
      "placementEditHint": "އައު ވަރޝަނަކުން މަގާމު ބަދަލުކުރެވިދާނެއެވެ. ނަމަވެސް މިހާރު ފުރިހަމަކޮށްފައިވާ ބައެއް ހުހެއް ނުކުރެވޭނެއެވެ.",
      "placementPlaceholder": "އިޚްތިޔާރުކުރައްވާ",
      "department": "ޑިޕާޓްމަންޓް",
      "departmentHint": "ބޭނުންވޭ: ޙަވާލުކުރުމުގެ ޑިޕާޓްމަންޓް ލިބެނީ މަގާމުންނެވެ.",
      "branch": "ބްރާންޗް",
      "costCenter": "ޚަރަދު މަރުކަޒު",
      "costCenterHint": "މި މަގާމުގެ މުސާރައިގެ ޚަރަދު ޖެހޭ ތަން.",
      "businessUnit": "ވިޔަފާރި ޔުނިޓް",
      "division": "ޑިވިޜަން",
      "location": "ތަން (ލޮކޭޝަން)",
      "locationHint": "މަސައްކަތްކުރާ ތަން، ޗުއްޓީ ކަލަންޑަރާއި މަސައްކަތު ދުވަސް ކަނޑައަޅައެވެ.",
      "headcountOverride": "މި ވަރޝަނުގައި ފާސްކުރެވިފައިވާ ޢަދަދު {from} އިން {to} އަށް ބަދަލުވެއެވެ. ސަބަބު ލިޔުއްވާ.",
      "headcountReason": "ޢަދަދު ބަދަލުކުރި ސަބަބު"
    },
    "assignment": {
      "title": "މި މަޤާމުގައި ތިބީ ކާކު",
      "employee": "މުވައްޒަފު",
      "employeePlaceholder": "މުވައްޒަފަކު ހޮއްވަވާ",
      "type": "ހަވާލުކުރުން",
      "fte": "އެފް.ޓީ.އީ",
      "fteHint": "ފުލް-ޓައިމް އެކުއިވަލަންޓްގެ ބައި، މިސާލަކަށް ބައި މަޤާމަކަށް 0.5000.",
      "toHint": "ނިމުމެއް ނެތް ހަވާލުކުރުމަކަށް ހުހަށް ބާއްވަވާ.",
      "assign": "ހަވާލުކުރޭ",
      "assigned": "ހަވާލުކުރުން ރެކޯޑްކުރެވިއްޖެ",
      "headcount": "{headcount} ގޮނޑިން {filled} ފުރިފައި",
      "full": "ފުރިފައި",
      "holders": "ހަވާލުކުރުންތައް",
      "none": "މި މަޤާމުގައި އެއްވެސް މީހަކު ނެތް.",
      "end": "ނިންމާ",
      "endDate": "ނިމޭ ތާރީޚް",
      "endReason": "ސަބަބު",
      "endConfirm": "ހަވާލުކުރުން ނިންމާ",
      "endExplain": "ދެއްވާ ތާރީޚުގައި ހަވާލުކުރުން ބަންދުވެއެވެ. {name} ތާރީޚުގައި ދެމިހުންނާނެއެވެ — ޕޭރޯލާއި ބާރު ދެ ފަރާތުންވެސް ތާރީޚަކަށް ބަލައި ކިޔައެވެ.",
      "ended": "ހަވާލުކުރުން ނިމިއްޖެ",
      "overrideExplain": "ސާވަރުން މި ހަވާލުކުރުން ދޫނުކުރިއެވެ. ކަނޑައެޅިފައިވާ ސަބަބަކާއެކު ރެކޯޑްކުރެވިދާނެއެވެ، އަދި އަހަރު ނިމުމުން އެ ސަބަބުތައް ގުނެއެވެ.",
      "overrideLabel": "ފަހަނައެޅުމުގެ ސަބަބު",
      "failed": "ހަވާލުކުރުން ރައްކާއެއް ނުކުރެވުނު",
      "types": {
        "primary": "މައި",
        "secondary": "ދެވަނަ",
        "acting": "ބަދަލުގައި"
      },
      "typeHints": {
        "primary": "މީހާގެ އަޞްލު މަޤާމު. އެއްފަހަރާ އެކަތި އެކަނި.",
        "secondary": "މައި މަޤާމާއެކު ހިފަހައްޓާ އިތުރު މަޤާމެއް.",
        "acting": "ވަގުތީ ގޮތުން މަޤާމު ބަލަހައްޓަނީ."
      }
    },
    "chart": {
      "treeLabel": "ރިޕޯޓިންގ ލައިން",
      "vacant": "ހުސް",
      "openSeats": "{count} ހުސް",
      "vacancies": "މި ޗާޓްގެ {count} ގޮނޑި ފުރިފައެއް ނުވެއެވެ. އެ ގޮނޑިއަކަށް ދާ ފާސްކުރުމެއް ފުރިހަމައެއް ނުވާނެއެވެ.",
      "chooseCompany": "ރިޕޯޓިންގ ލައިން ދެއްކުމަށް ކުންފުންޏެއް ހޮއްވަވާ.",
      "emptyTitle": "ޗާޓްކުރާނެ މަޤާމެއް ނެތް",
      "emptyDescription": "މަޤާމުތައް އުފައްދައި ރިޕޯޓިންގ ލައިނެއް ދެއްވުމުން މިތާނގައި އޮނިގަނޑު ފެންނާނެއެވެ.",
      "loadFailed": "ރިޕޯޓިންގ ލައިން ލޯޑެއް ނުވި"
    },
    "obSignOff": {
      "title": "ރިކޮންސައިލްކުރުމާއި ސައިން އޮފް",
      "description": "މި ބެޗް، ސޯސް ސިސްޓަމުގެ ޓްރަޔަލް ބެލެންސާ ރިކޮންސައިލް ކުރައްވާ. ތަފާތު ސުމަށް ވުމުން ސައިން އޮފް ކުރެވޭނެއެވެ. ބެޗް ސައިން އޮފް ކުރުމަށް ފަހުގައި މެނުވީ އެންޓިޓީއަށް މުއާމަލާތް ނުކުރެވޭނެއެވެ.",
      "open": "ރިކޮންސައިލް",
      "close": "ބަންދުކުރޭ",
      "loadFailed": "މި އޯޕަނިންގ ބެލެންސް އިމްޕޯޓް ލޯޑް ނުކުރެވުނު",
      "notReady": "މި އިމްޕޯޓް ރިކޮންސައިލް ކުރެވޭނީ އެޕްރޫވް ކުރުމަށް ފަހުގައެވެ.",
      "importStatus": "އިމްޕޯޓް",
      "reconStatus": "ރިކޮންސިލިއޭޝަން",
      "chips": {
        "notReconciled": "ރިކޮންސައިލް ނުކުރެވޭ",
        "variance": "ތަފާތު ހުރި",
        "clean": "ރިކޮންސައިލް ކުރެވިފަ، ސައިން އޮފް ކުރެވޭނެ",
        "signedOff": "ސައިން އޮފް ކުރެވިފަ"
      },
      "fields": {
        "sourceTotal": "ސޯސް ޖުމްލަ",
        "sourceTotalHint": "އިމްޕޯޓްގެ ތާރީޚުގައި ސޯސް ސިސްޓަމުގެ ޓްރަޔަލް ބެލެންސްގެ ޖުމްލަ ޑެބިޓް.",
        "note": "ރިކޮންސިލިއޭޝަން ނޯޓް"
      },
      "reconcile": "ރިކޮންސިލިއޭޝަން ރެކޯޑްކުރޭ",
      "reconciling": "ރިކޮންސައިލް ކުރަނީ…",
      "reconciled": "ރިކޮންސިލިއޭޝަން ރެކޯޑްކުރެވިއްޖެ",
      "reconcileFailed": "ރިކޮންސިލިއޭޝަން ރެކޯޑް ނުކުރެވުނު",
      "notReconciledYet": "މި ބެޗް ރިކޮންސައިލް ކުރުމަށް ސޯސް ޖުމްލަ ލިޔުއްވާ. ދައްކާ ތަފާތަކީ ސާވަރުން ހިސާބުކުރާ ތަފާތެވެ.",
      "totals": {
        "source": "ސޯސް ޖުމްލަ",
        "loaded": "ލޯޑްކުރެވުނު ޖުމްލަ",
        "variance": "ތަފާތު"
      },
      "reconciledAt": "ރިކޮންސައިލް ކުރެވުނީ",
      "linesTitle": "އެކައުންޓް ކޮޅަށް ލޯޑްކުރެވުނު ބެލެންސް",
      "linesHint": "ސާވަރުން ރިކޮންސައިލް ކުރަނީ ބެޗްގެ ޖުމްލައެވެ. ތަފާތެއް ހޯދުމަށް މި ބެލެންސްތައް ސޯސް ޓްރަޔަލް ބެލެންސާ އެކައުންޓް ކޮޅަށް އަޅާކިޔާލައްވާ.",
      "columns": {
        "account": "އެކައުންޓް",
        "debit": "ޑެބިޓް",
        "credit": "ކްރެޑިޓް"
      },
      "signOff": "ސައިން އޮފް",
      "signingOff": "ސައިން އޮފް ކުރަނީ…",
      "signedOff": "އޯޕަނިންގ ބެލެންސް ސައިން އޮފް ކުރެވިއްޖެ",
      "signOffFailed": "އޯޕަނިންގ ބެލެންސް ސައިން އޮފް ނުކުރެވުނު",
      "signOffBlocked": "ރިކޮންސިލިއޭޝަންގައި ތަފާތެއް ނެތް ނަމަ ސައިން އޮފް ކުރެވޭނެއެވެ.",
      "confirmTitle": "އޯޕަނިންގ ބެލެންސް ސައިން އޮފް ކުރަންތަ؟",
      "confirmMessage": "މިއީ ބެޗް ސޯސް ސިސްޓަމާ ދިމާވާކަން ރެކޯޑްކުރުމެވެ. މިކަން އަނބުރާ ނުބަދަލުކުރެވޭނެއެވެ. އޭގެ ފަހުން އެންޓިޓީއަށް މުއާމަލާތް ފެށޭނެއެވެ.",
      "confirmLabel": "ސައިން އޮފް",
      "cancelLabel": "ކެންސަލް",
      "signedOffByLabel": "ސައިން އޮފް ކުރީ",
      "you": "ތިބާ",
      "userId": "ޔޫޒަރ #{id}",
      "auditTrail": "އޯޑިޓް ޓްރެއިލް",
      "railTitle": "އޯޕަނިންގ ބެލެންސް {file}",
      "events": {
        "created": "އިމްޕޯޓްކުރެވުނު",
        "reconciled": "ސޯސާ ރިކޮންސައިލް ކުރެވުނު",
        "signedOff": "ސައިން އޮފް ކުރެވުނު",
        "posted": "ލެޖަރަށް ޕޯސްޓްކުރެވުނު"
      },
      "reloaded": "ބެޗްގެ އެންމެ ފަހުގެ ވަރޝަން ލޯޑްކުރެވިއްޖެ؛ ތިޔަ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "errors": {
        "unsigned": "ތަފާތެއް ނެތި ރިކޮންސައިލް ކުރުމަށް ފަހުގައި މެނުވީ މި ބެޗް ސައިން އޮފް ނުކުރެވޭނެއެވެ.",
        "signedOffAlready": "މި ބެޗް ކުރިން ސައިން އޮފް ކުރެވިފައިވާތީ، މީގެ ރިކޮންސިލިއޭޝަން ނިމިއްޖެއެވެ. އަލުން ރިކޮންސައިލް ނުކުރެވޭނެއެވެ.",
        "illegalTransition": "މި ބެޗް މިހާރު ހުރީ މި ފިޔަވަޅު އެޅޭ ހާލަތެއްގައި ނޫނެވެ. ކުރިން ސައިން އޮފް ކުރެވިފައި، ނުވަތަ އަދި އެޕްރޫވް ނުކުރެވިފައި ވެދާނެއެވެ.",
        "rowVersion": "ތިބާ މަސައްކަތް ކުރަމުން ދަނިކޮށް އެހެން މީހަކު މި ބެޗް ބަދަލުކޮށްފިއެވެ.",
        "validation": "ފާހަގަކޮށްފައިވާ ފީލްޑް ބައްލަވާފައި އަލުން މަސައްކަތް ކުރައްވާ.",
        "forbidden": "މިކަން ކުރުމުގެ ހުއްދައެއް ތިބާއަކަށް ނެތެވެ.",
        "notFound": "މި އޯޕަނިންގ ބެލެންސް އިމްޕޯޓް މިހާރު ނެތެވެ.",
        "mfaRequired": "ސައިން އޮފް ކުރުމަށް ޓޫ-ފެކްޓަރ އޮތެންޓިކޭޝަން ބޭނުންވެއެވެ. ފުރަތަމަ ޕްރޮފައިލްގައި އޮތެންޓިކޭޓަރެއް ރަޖިސްޓަރ ކުރައްވާ."
      }
    }
  },
  "gl": {
    "statuses": {
      "draft": "ދެލިކޮޕީ",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "reversed": "ރިވާސްކުރެވިފައި",
      "submitted": "ހުށަހެޅިފައި",
      "approved": "ފާސްކުރެވިފައި",
      "rejected": "ނުފާސްކުރެވިފައި"
    },
    "sources": {
      "manual": "އަތުން",
      "recurring": "ތަކުރާރު",
      "reversal": "ރިވާސަލް",
      "allocation": "ބެހުން",
      "opening_balance": "ފެށޭ ބެލެންސް",
      "ap": "ދައްކަންޖެހޭ ފައިސާ",
      "ar": "ލިބެންޖެހޭ ފައިސާ",
      "cash": "ފައިސާ އަދި ބޭންކް",
      "inventory": "މުދާ",
      "payroll": "މުސާރަ",
      "assets": "ހަރުމުދާ",
      "sales": "ވިއްކުން",
      "projects": "ޕްރޮޖެކްޓްތައް",
      "service": "ޚިދުމަތް",
      "mfg": "އުފެއްދުން",
      "cost": "ޚަރަދުގެ ހިސާބު",
      "expense": "ޚަރަދުތައް",
      "interco": "ކުންފުނިތަކުގެ މެދު",
      "treasury": "ޓްރެޜަރީ",
      "pos": "ވިއްކާ ކައުންޓަރު",
      "pms": "ޕްރޮޕަޓީ މެނޭޖްމަންޓް",
      "year_end_close": "އަހަރު ބަންދުކުރުން",
      "template": "ސޭވްކުރި ޓެމްޕްލޭޓް"
    },
    "accountTypes": {
      "ASSET": "މުދާ",
      "LIABILITY": "ދަރަނި",
      "EQUITY": "އިކުއިޓީ",
      "INCOME": "އާމްދަނީ",
      "EXPENSE": "ޚަރަދު"
    },
    "list": {
      "title": "ޖާނަލް އެންޓްރީތައް",
      "description": "ލެޖަރގައިވާ ހުރިހާ ޖާނަލްއެއް، އަދި އެއަށް ދާން ތައްޔާރުވެފައިވާ ދެލިކޮޕީތައް.",
      "filtersTitle": "ފިލްޓަރތައް",
      "searchHint": "އެންޓްރީ ނަންބަރާއި މެމޯއާ ދިމާކުރެއެވެ.",
      "allCompanies": "ހުރިހާ ކުންފުންޏެއް",
      "from": "އެންޓްރީ ތާރީޚް، ފެށޭ",
      "to": "އެންޓްރީ ތާރީޚް، ނިމޭ",
      "newEntry": "އައު ޖާނަލް އެންޓްރީ",
      "tableLabel": "ޖާނަލް އެންޓްރީތައް",
      "emptyTitle": "އަދި ޖާނަލް އެންޓްރީއެއް ނެތް",
      "emptyDescription": "މިތަނުން އެއް އުފައްދާ، ނުވަތަ ސަބް-ލެޖަރއަކުން ފުރަތަމަ ޕޯސްޓް ކުރަންދެން މަޑުކުރޭ.",
      "loadFailed": "ޖާނަލް ލިސްޓް ލޯޑްނުވި",
      "exported": "އެކްސްޕޯޓް ތައްޔާރު",
      "exportedDetail": "{count} ޖާނަލް އެންޓްރީ ފައިލަށް ލިޔެވިއްޖެ.",
      "columns": {
        "entryNo": "އެންޓްރީ ނަންބަރު",
        "entryDate": "އެންޓްރީ ތާރީޚް",
        "source": "މަޞްދަރު",
        "memo": "މެމޯ",
        "currency": "ފައިސާ"
      }
    },
    "entry": {
      "title": "ޖާނަލް އެންޓްރީ {entryNo}",
      "newTitle": "އައު ޖާނަލް އެންޓްރީ",
      "draftTitle": "ދެލިކޮޕީ",
      "description": "ޖާނަލްގެ ކޮންމެ ސަޠުރެއްގައި ވަނީ ޑެބިޓެއް ނުވަތަ ކްރެޑިޓެއް، އަދި ޕޯސްޓްކުރެވޭނީ ސެންޓާ ހަމައަށް ހަމަވުމުންނެވެ.",
      "backToList": "ޖާނަލް އެންޓްރީތަކަށް އެނބުރި",
      "headerTitle": "އެންޓްރީ",
      "loadFailed": "އެ ޖާނަލް އެންޓްރީ ލޯޑްނުވި",
      "actionsLabel": "ލިޔުމުގެ އަމަލުތައް",
      "balanceLabel": "ޑެބިޓުން ކްރެޑިޓް އުނިކުރުމުން",
      "balanced": "ހަމަވެފައި",
      "outOfBalance": "ހަމަނުވޭ",
      "readyToPost": "ސަޠުރުތައް ހަމަވެފައި ހުރިހާ ހިސާބަކަށް ޕޯސްޓްކުރެވޭތީ، މި އެންޓްރީ ލެޖަރއަށް ދެވިދާނެއެވެ.",
      "posting": "ޕޯސްޓްކުރަނީ",
      "postedImmutable": "މި އެންޓްރީ ވަނީ ލެޖަރގައެވެ. ޕޯސްޓްކުރެވިފައިވާ އެންޓްރީއެއް ރަނގަޅުކުރަނީ ރިވާސަލްއަކުން، ބަދަލުކޮށްގެން ނުވަތަ ފޮހެލައިގެން ނޫނެވެ.",
      "stale": "މި އެންޓްރީ ހުޅުވާފައި އޮއްވާ އެހެން މީހަކު ބަދަލުކޮށްފިއެވެ. އެއްވެސް އެއްޗެއް ފުހެވިފައެއް ނުވެއެވެ.",
      "reload": "އަލުން ލޯޑްކޮށް ބަދަލުތައް ލާ",
      "railSubtitle": "{status}، ތާރީޚް {date}",
      "fields": {
        "company": "ކުންފުނި",
        "companyPlaceholder": "ކުންފުންޏެއް ހޮވާ",
        "entryNo": "އެންޓްރީ ނަންބަރު",
        "entryDate": "އެންޓްރީ ތާރީޚް",
        "entryDateHint": "މުޢާމަލާތް ނިސްބަތްވާ ތާރީޚް. މުއްދަތު ކަނޑައަޅަނީ މިއިންނެވެ.",
        "postingDate": "ޕޯސްޓްކުރި ތާރީޚް",
        "postingDateHint": "ފޮތްތަކަށް ވަން ތާރީޚް. ލަހުން ވެއްދި ލިޔުމަކަށް ތަފާތުވާނެއެވެ.",
        "currency": "ފައިސާ",
        "currencyHint": "ކުންފުނީގެ ފޮތްތައް ބަހައްޓަނީ {base} އިންނެވެ.",
        "memo": "މެމޯ",
        "source": "މަޞްދަރު",
        "sourceDoc": "މަޞްދަރު ލިޔުން",
        "postedAt": "ޕޯސްޓްކުރި"
      },
      "actions": {
        "save": "ދެލިކޮޕީ ރައްކާކުރޭ",
        "post": "ޕޯސްޓްކުރޭ",
        "reverse": "ރިވާސްކުރޭ",
        "discard": "ދެލިކޮޕީ އުކާލާ",
        "print": "ޕްރިންޓްކުރޭ"
      },
      "blockers": {
        "noLines": "ހިސާބަކާއި އަދަދެއް ހިމެނޭ މަދުވެގެން އެއް ސަޠުރު އިތުރުކުރޭ.",
        "tooFewLines": "ޖާނަލްއަކަށް މަދުވެގެން ދެ ސަޠުރު ބޭނުންވެއެވެ: އެއްޗެއް ޑެބިޓްކުރެވި އަނެއް އެއްޗެއް ކްރެޑިޓްކުރެވެއެވެ.",
        "lineIssues": "ބައެއް ސަޠުރުތަކަށް އަދިވެސް ސަމާލުކަން ބޭނުންވެއެވެ. އެ ގޮޅިތައް ފާހަގަކުރެވިފައިވެއެވެ.",
        "unbalanced": "ޑެބިޓާއި ކްރެޑިޓް އަދި ހަމައެއް ނުވެއެވެ، އެހެންކަމުން މި ޕޯސްޓެއް ނުކުރެވޭނެއެވެ."
      },
      "timeline": {
        "created": "ދެލިކޮޕީ އުފެއްދި",
        "posted": "{entryNo} ގެ ގޮތުގައި ޕޯސްޓްކުރި",
        "reversed": "މިރަރ އެންޓްރީއަކުން ރިވާސްކުރެވިފައި"
      },
      "links": {
        "reverses": "މި އެންޓްރީ ރިވާސްކުރާ އެންޓްރީ",
        "reversedBy": "މި އެންޓްރީ ރިވާސްކުރި އެންޓްރީ"
      },
      "shortcuts": {
        "save": "ޖާނަލް އެންޓްރީ ރައްކާކުރޭ"
      },
      "toasts": {
        "saved": "ދެލިކޮޕީ ރައްކާކުރެވިއްޖެ",
        "savedDetail": "އަދި ލެޖަރގައެއް ނުވެއެވެ. ހަމަވުމުން ޕޯސްޓްކުރައްވާ.",
        "saveFailed": "ދެލިކޮޕީ ރައްކާނުކުރެވުނު",
        "posted": "{entryNo} ގެ ގޮތުގައި ޕޯސްޓްކުރެވިއްޖެ",
        "postedDetail": "ލެޖަރގައި ވެއެވެ. ގޯހެއް ވާނަމަ ރިވާސަލްއަކުން ރަނގަޅުކުރައްވާ.",
        "postFailed": "އެ އެންޓްރީ ޕޯސްޓްނުކުރެވުނު",
        "discarded": "ދެލިކޮޕީ އުކާލެވިއްޖެ",
        "discardedDetail": "ލެޖަރއަށް އެއްވެސް އެއްޗެއް ނުދާތީ، ރިވާސްކުރާނެ އެއްޗެއް ނެތެވެ.",
        "discardFailed": "ދެލިކޮޕީ ނުއުކާލެވުނު"
      },
      "unsavedGuard": {
        "title": "ރައްކާނުކުރާ ބަދަލުތައް ދޫކޮށްލާނަންތޯ؟",
        "message": "މި އެންޓްރީގައި ރައްކާނުކުރެވޭ ބަދަލުތަކެއް އެބަހުރި. މިހާރު ދޫކޮށްލައިފިނަމަ، އެ ބަދަލުތައް ގެއްލޭނެ.",
        "confirm": "ބަދަލުތައް ދޫކޮށްލާ",
        "cancel": "އިތުރަށް އެޑިޓްކުރޭ"
      }
    },
    "lines": {
      "title": "ސަޠުރުތައް",
      "caption": "ޖާނަލް ސަޠުރުތައް: ހިސާބެއް، ބޭނުންނަމަ ޑައިމެންޝަންތަކެއް، އަދި ޑެބިޓް ނުވަތަ ކްރެޑިޓް ކޮލަމްގައި އެއް އަދަދެއް.",
      "totals": "ޖުމްލަ",
      "baseOnly": "ރިވެލިއުއޭޝަން (ބޭސް ފްލޫސް ބޭނުންކުރުން ޚާއްސަ)",
      "accountPlaceholder": "ކޯޑު ނުވަތަ ނަން",
      "noAccountMatch": "އެއާ ދިމާވާ ހިސާބެއް ނެތެވެ.",
      "createAccount": "{code} ހިސާބު އުފައްދާ",
      "matchCount": "{count} ހިސާބު ދިމާވެއެވެ",
      "noTaxCode": "ޓެކްސް ކޯޑެއް ނެތް",
      "keyboardHint": "އެންޓަރއިން އެއް ސަޠުރު ތިރިއަށް ދެއެވެ. އޯލްޓާއި ތިރި އެރޯއިން ސަޠުރެއް ކޮޕީކުރެއެވެ. އޯލްޓާއި ބެކްސްޕޭސްއިން ސަޠުރެއް ނަގައެވެ.",
      "columns": {
        "no": "ނަންބަރު",
        "account": "ހިސާބު",
        "description": "ތަފްޞީލު",
        "dimensions": "ޑައިމެންޝަން",
        "taxCode": "ޓެކްސް ކޯޑު",
        "debit": "ޑެބިޓް",
        "credit": "ކްރެޑިޓް",
        "rowActions": "ސަޠުރުގެ އަމަލުތައް"
      },
      "actions": {
        "add": "ސަޠުރެއް އިތުރުކުރޭ",
        "duplicate": "މި ސަޠުރު ކޮޕީކުރޭ",
        "remove": "މި ސަޠުރު ނަގާ"
      },
      "aria": {
        "account": "ސަޠުރު {line} ގެ ހިސާބު",
        "description": "ސަޠުރު {line} ގެ ތަފްޞީލު",
        "taxCode": "ސަޠުރު {line} ގެ ޓެކްސް ކޯޑު",
        "debit": "ސަޠުރު {line} ގެ ޑެބިޓް",
        "credit": "ސަޠުރު {line} ގެ ކްރެޑިޓް",
        "duplicate": "ސަޠުރު {line} ކޮޕީކުރޭ",
        "remove": "ސަޠުރު {line} ނަގާ"
      },
      "issues": {
        "bothSides": "ސަޠުރެއްގައި ވާނީ ޑެބިޓެއް ނުވަތަ ކްރެޑިޓެއް، ދެ އެއްޗެއް އެއްފަހަރާ ނުވާނެއެވެ.",
        "invalidAmount": "އެއީ އަދަދެއް ނޫނެވެ.",
        "negative": "މައިނަސް އަދަދަކީ އަނެއް ކޮލަމް އެއްފުށުން އަނެއްފުށަށް ލިޔުމެވެ. އަނެއް ކޮލަމްގައި ލިޔުއްވާ.",
        "noAmount": "މި ސަޠުރަށް ސުމަކަށްވުރެ ބޮޑު ޑެބިޓެއް ނުވަތަ ކްރެޑިޓެއް ބޭނުންވެއެވެ.",
        "noAccount": "މި ސަޠުރަށް ހިސާބެއް ހޮވާ.",
        "notPostable": "ހިސާބު {account} އަކީ ސުރުޚީއެއް، ޕޯސްޓްކުރެވޭ ހިސާބެއް ނޫނެވެ. އޭގެ ދަށު ހިސާބަކަށް ޕޯސްޓްކުރައްވާ.",
        "inactive": "ހިސާބު {account} ވަނީ ނުހިނގާ ޙާލަތުގައެވެ.",
        "requiresCostCenter": "ހިސާބު {account} އަށް ކޮންމެ ސަޠުރެއްގައި ކޮސްޓް ސެންޓަރެއް ބޭނުންވެއެވެ.",
        "requiresProfitCenter": "ހިސާބު {account} އަށް ކޮންމެ ސަޠުރެއްގައި ޕްރޮފިޓް ސެންޓަރެއް ބޭނުންވެއެވެ.",
        "requiresBranch": "ހިސާބު {account} އަށް ކޮންމެ ސަޠުރެއްގައި ބްރާންޗެއް ބޭނުންވެއެވެ.",
        "requiresDepartment": "ހިސާބު {account} އަށް ކޮންމެ ސަޠުރެއްގައި ޑިޕާޓްމަންޓެއް ބޭނުންވެއެވެ.",
        "requiresProject": "ހިސާބު {account} އަށް ކޮންމެ ސަޠުރެއްގައި ޕްރޮޖެކްޓެއް ބޭނުންވެއެވެ."
      },
      "dimensions": {
        "title": "ޑައިމެންޝަންތައް",
        "costCenter": "ކޮސްޓް ސެންޓަރ",
        "profitCenter": "ޕްރޮފިޓް ސެންޓަރ",
        "branch": "ބްރާންޗް",
        "department": "ޑިޕާޓްމަންޓް",
        "businessUnit": "ބިޒްނަސް ޔުނިޓް",
        "project": "ޕްރޮޖެކްޓް",
        "projectHint": "ލެޖަރގައި ރެކޯޑްކުރާނެ ޕްރޮޖެކްޓް އައިޑީ. ޕްރޮޖެކްޓް މޮޑިއުލް އަންނާނީ ފަހުންކަމުން، އަދި ހޮވާނެ ލިސްޓެއް ނެތެވެ.",
        "unset": "ކަނޑައަޅާފައެއް ނުވޭ",
        "none": "ޑައިމެންޝަނެއް ނެތް",
        "assigned": "{count} ކަނޑައަޅާފައި",
        "requiredShort": "{dimension} ބޭނުންވޭ",
        "requiredBy": "ހިސާބު {account} އަށް ބޭނުންވެއެވެ.",
        "triggerLabel": "މި ސަޠުރުގެ ޑައިމެންޝަންތައް: {summary}",
        "clear": "މި ސަޠުރުގެ ޑައިމެންޝަންތައް ސާފުކުރޭ"
      }
    },
    "createAccount": {
      "title": "ހިސާބެއް އުފައްދާ",
      "description": "މި ކުންފުނީގެ ހިސާބުތަކުގެ ޗާޓަށް އިތުރުކުރެވި، ލިޔަމުންދިޔަ ސަޠުރުގައި ހޮވޭނެއެވެ.",
      "code": "ހިސާބުގެ ކޯޑު",
      "name": "ހިސާބުގެ ނަން",
      "type": "ބާވަތް",
      "postableNote": "އުފެއްދެނީ ޑައިމެންޝަން ބޭނުންނުވާ، ޕޯސްޓްކުރެވޭ ހިސާބެއްގެ ގޮތުގައެވެ. ބެލެނިވެރި ހިސާބެއް، ފައިސާގެ ހުއްދަ ނުވަތަ ޑައިމެންޝަން ސިޔާސަތު ކަނޑައަޅަނީ ހިސާބުތަކުގެ ޗާޓުންނެވެ."
    },
    "reverse": {
      "title": "{entryNo} ރިވާސްކުރޭ",
      "description": "މިއިން މި އެންޓްރީ ބާޠިލުކުރާ އައު އެންޓްރީއެއް ޕޯސްޓްކުރެއެވެ. އެއްވެސް އެއްޗެއް ބަދަލެއް ނުކުރެވޭ، ފުހެއެއްވެސް ނުލެވެއެވެ.",
      "mirrorHeadline": "ރިވާސަލްއަކީ މިރަރ އެންޓްރީއެކެވެ.",
      "mirrorBody": "ކޮންމެ ޑެބިޓެއް ކްރެޑިޓަކަށް، ކޮންމެ ކްރެޑިޓެއް ޑެބިޓަކަށް، ހަމަ އެ އަދަދުތަކާއި ހަމަ އެ ބަދަލުކުރާ ރޭޓުތަކުގައި ބަދަލުވެއެވެ. އަދަދުތައް ބަދަލުކުރެވެނީ ދެ ފަރާތް ބަދަލުކޮށްގެން، މައިނަސްކޮށްގެނެއް ނޫނެވެ. އެހެންކަމުން ދެ އެންޓްރީވެސް ޢާންމު ޖާނަލްއެއްގެ ގޮތުގައި ކިޔޭނެ، އަދި ދެ އެންޓްރީ އެއްކޮށްލުމުން ސުމަކަށް ދާނެއެވެ.",
      "originalKept": "އަޞްލު އެންޓްރީ ރިވާސްކުރެވިފައިވާ ކަމަށް ފާހަގަކުރެވިގެން ލެޖަރގައި ދެމިހުންނާނެ، އަދި ދެ އެންޓްރީ އެކަތި އަނެކައްޗާ ގުޅުވާލެވޭނެއެވެ.",
      "dateLabel": "ރިވާސްކުރާ ތާރީޚް",
      "dateHint": "ޖެހޭނީ ހުޅުވިފައިވާ ހިސާބުކުރުމުގެ މުއްދަތެއްގައެވެ.",
      "reasonLabel": "ސަބަބު",
      "reasonHint": "ދެ އެންޓްރީގައާއި އޮޑިޓް ރެކޯޑްގައި ރައްކާކުރެވެއެވެ.",
      "confirm": "ރިވާސަލް ޕޯސްޓްކުރޭ",
      "submitting": "ރިވާސަލް ޕޯސްޓްކުރަނީ",
      "periodClosedHeadline": "އެ ތާރީޚް ޖެހެނީ ބަންދުކުރެވިފައިވާ މުއްދަތެއްގައެވެ.",
      "doneTitle": "ރިވާސަލް ޕޯސްޓްކުރެވިއްޖެ",
      "doneDetail": "މިރަރ އެންޓްރީއަކީ {entryNo} އެވެ."
    },
    "checks": {
      "versus": "އާ ދެކޮޅަށް",
      "difference": "ތަފާތަކީ",
      "advice": "މިއީ ސާވަރއިން ލެޖަރއިން ހިސާބުކުރި އަދަދެވެ. ދެއްކުމަށްޓަކައި އެއްވެސް ބަދަލެއް ގެނެވިފައެއް ނުވެއެވެ. މި ރިޕޯޓަށް ބަރޯސާވުމުގެ ކުރިން އެކައުންޓެންޓަކަށް ދައްކަވާ.",
      "filtered": "ޑައިމެންޝަނަކުން ހަނިކުރެވިފައިވާ ރިޕޯޓަކީ ލެޖަރގެ ބައެއްކަމުން، ހަމަވާން ޖެހޭ ލާޒިމުކަމެއް ނެތެވެ. މިތާނގައި ސުމަކަށްދާ ޗެކެއް ދަޢުވާއެއް ނުކުރެއެވެ.",
      "tbIdentity": "ޑެބިޓް ޖުމްލަ",
      "tbOk": "ޑެބިޓާއި ކްރެޑިޓް ހަމަވެއެވެ. ލެޖަރ ސުމަކަށް ދެއެވެ.",
      "tbFail": "މި ޓްރަޔަލް ބެލެންސް ސުމަކަށް ނުދެއެވެ.",
      "openingOk": "ފެށޭ ކޮލަމް ހަމަވެއެވެ.",
      "openingFail": "ފެށޭ ކޮލަމް ހަމައެއް ނުވެއެވެ.",
      "movementOk": "ޙަރަކާތުގެ ކޮލަމް ހަމަވެއެވެ.",
      "movementFail": "ޙަރަކާތުގެ ކޮލަމް ހަމައެއް ނުވެއެވެ.",
      "bsIdentity": "މުދަލުގެ ޖުމްލަ",
      "bsOk": "މުދާ، ދަރަންޏާއި އިކުއިޓީގެ ޖުމްލައާ ހަމަވެއެވެ.",
      "bsFail": "މުދާ، ދަރަންޏާއި އިކުއިޓީގެ ޖުމްލައާ ހަމައެއް ނުވެއެވެ.",
      "bsRefused": "ބެލެންސް ޝީޓް ހަމަނުވާތީ ދެއްކުން ހުއްޓުވިއްޖެއެވެ."
    },
    "reports": {
      "scope": "ދާއިރާ",
      "period": "މުއްދަތު",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "asOf": "ތާރީޚަށް",
      "wholeLedger": "ލެޖަރ ހުޅުވުނު ފަހުން",
      "ledgerStart": "ލެޖަރ ހުޅުވުނު ދުވަސް",
      "basisLabel": "ތާރީޚުގެ އަސާސް",
      "basisHint": "އެންޓްރީގެ ދެ ވިޔަފާރި ތާރީޚުން މި ރިޕޯޓް ކިޔަނީ ކޮން ތާރީޚެއްކަން.",
      "basis": {
        "entry": "އެންޓްރީ ތާރީޚް",
        "posting": "ޕޯސްޓްކުރި ތާރީޚް"
      },
      "includeZeroLabel": "ބެލެންސެއް ނެތް ހިސާބުތައްވެސް ހިމަނާ",
      "chooseCompany": "މި ރިޕޯޓް ހިންގުމަށް ކުންފުންޏެއް ހޮވާ.",
      "filteredNote": "ޑައިމެންޝަން ފިލްޓަރެއް ބޭނުންކުރެވިފައިވާތީ، މި ރިޕޯޓަކީ ލެޖަރގެ ބައެއް، އަދި ސުމަކަށްދާ ދަޢުވާއެއް ނުކުރެއެވެ.",
      "generatedAt": "ހިސާބުކުރި",
      "exportDone": "އެކްސްޕޯޓް ތައްޔާރު",
      "exportDoneDetail": "{filename} ގެ ގޮތުގައި ރައްކާކުރެވިއްޖެ.",
      "exportFailed": "އެކްސްޕޯޓް ނުހިނގި"
    },
    "tb": {
      "title": "ޓްރަޔަލް ބެލެންސް",
      "description": "ކޮންމެ ހިސާބެއްގެ ފެށޭ ބެލެންސް، ޙަރަކާތް އަދި ނިމޭ ބެލެންސް، އަދި މުޅި ލެޖަރ ސުމަކަށް ދާކަމުގެ ހެކި.",
      "caption": "ޓްރަޔަލް ބެލެންސް: ކޮންމެ ހިސާބެއްގެ ފެށޭ، ޙަރަކާތް އަދި ނިމޭ ޑެބިޓާއި ކްރެޑިޓް.",
      "periodHint": "މުއްދަތެއް ހޮވުމުން ދާއިރާ ކަނޑައެޅި ތާރީޚުތަކުގެ މައްޗަށް އިސްކަންދެވެއެވެ.",
      "fromHint": "ލެޖަރ ފެށުނު ހިސާބުން ފަށަން ބޭނުންނަމަ ހުސްކޮށް ބާއްވާ.",
      "convention": "ޑެބިޓް ޕޮޒިޓިވް، {from} އިން {asOf} އަށް، {currency} އިން. މުދަލެއް ނުވަތަ ޚަރަދެއް ޕޮޒިޓިވްކޮށް، ދަރަނި، އިކުއިޓީ ނުވަތަ އާމްދަނީ ހިސާބެއް މައިނަސްކޮށް ފެންނާނެއެވެ.",
      "empty": "މި ދާއިރާގައި އެއްވެސް ހިސާބެއްގައި ބެލެންސެއް ނެތެވެ.",
      "loadFailed": "ޓްރަޔަލް ބެލެންސް ލޯޑްނުވި",
      "columns": {
        "account": "ހިސާބު",
        "net": "ނިމޭ ސާފު"
      },
      "groups": {
        "opening": "ފެށޭ",
        "movement": "ޙަރަކާތް",
        "closing": "ނިމޭ"
      }
    },
    "statement": {
      "incomeTitle": "އާމްދަނީގެ ބަޔާން",
      "balanceTitle": "ބެލެންސް ޝީޓް",
      "incomeDescription": "ދެ ތާރީޚެއް ދެމެދު ހިނގި ކަންކަން: އާމްދަނީން ޚަރަދު އުނިކުރުމުން، ބޭނުންވާނަމަ އަޅާކިޔުމާއެކު.",
      "balanceDescription": "ތާރީޚެއްގައި ހުރި ޙާލަތު، މުދާ ދަރަންޏާއި އިކުއިޓީއާ ހަމަވާކަން ބެލުމާއެކު.",
      "incomeConvention": "ޠަބީޢީ ބެލެންސް ޕޮޒިޓިވް، {from} އިން {to} އަށް، {currency} އިން. ހިސާބުގައި ޠަބީޢީ ބެލެންސް ހުރިއިރު އާމްދަނީއާއި ޚަރަދު ޕޮޒިޓިވްކޮށް ފެންނާނެ، އަދި ގެއްލުމަކީ މައިނަސް ސާފު އާމްދަނީއެވެ.",
      "balanceConvention": "{asOf} ގައި ޠަބީޢީ ބެލެންސް ޕޮޒިޓިވް، {currency} އިން. މުދަލަކީ ޑެބިޓް ޕޮޒިޓިވް، ދަރަންޏާއި އިކުއިޓީއަކީ ކްރެޑިޓް ޕޮޒިޓިވެވެ.",
      "loadFailed": "އެ ބަޔާން ލޯޑްނުވި",
      "compareLabel": "އަޅާކިޔާ",
      "compareHint": "ހަމަ އެ ބަޔާން، ކުރީގެ މުއްދަތަށް، ހަމަ އެ ގޮތަށް ހިސާބުކުރެވިފައި.",
      "noComparative": "އަޅާކިޔުމެއް ނެތް",
      "sectionTotal": "{section} ގެ ޖުމްލަ",
      "retainedEarnings": "މުއްދަތުގެ ބާކީ ފައިދާ",
      "compare": {
        "priorPeriod": "ކުރީގެ މުއްދަތު",
        "priorYear": "މިދިޔަ އަހަރުގެ ހަމަ އެ މުއްދަތު"
      },
      "columns": {
        "amount": "އަދަދު {currency}",
        "comparative": "އަޅާކިޔުން",
        "variance": "ތަފާތު",
        "variancePct": "ތަފާތުގެ އިންސައްތަ"
      },
      "sections": {
        "income": "އާމްދަނީ",
        "expense": "ޚަރަދު",
        "asset": "މުދާ",
        "liability": "ދަރަނި",
        "equity": "އިކުއިޓީ"
      },
      "summary": {
        "totalIncome": "އާމްދަނީގެ ޖުމްލަ",
        "totalExpense": "ޚަރަދުގެ ޖުމްލަ",
        "netIncome": "ސާފު އާމްދަނީ",
        "totalAssets": "މުދަލުގެ ޖުމްލަ",
        "totalLiabilities": "ދަރަނީގެ ޖުމްލަ",
        "retainedEarningsPeriod": "މުއްދަތުގެ ބާކީ ފައިދާ",
        "totalEquity": "އިކުއިޓީގެ ޖުމްލަ",
        "totalLiabilitiesAndEquity": "ދަރަންޏާއި އިކުއިޓީގެ ޖުމްލަ"
      }
    },
    "ledger": {
      "title": "ޖީއެލް ތަފްޞީލު",
      "description": "އެއް ހިސާބެއްގެ ހުރިހާ ޕޯސްޓިންގއެއް، ތަރުތީބުން، ހިނގަމުންދާ ބެލެންސާއި ކޮންމެ ސަޠުރެއްގެ ފަހަތުގައިވާ ޖާނަލްއަށް ލިންކާއެކު.",
      "caption": "އެއް ހިސާބެއްގެ ޢާންމު ލެޖަރ ތަފްޞީލު.",
      "chooseAccount": "ހިސާބެއް ހޮވާ",
      "chooseScope": "ޕޯސްޓިންގތައް ބެލުމަށް ކުންފުންޏަކާއި ހިސާބެއް ހޮވާ.",
      "convention": "ޑެބިޓް ޕޮޒިޓިވް، {currency} އިން. އެންމެ ފަހު ހިނގަމުންދާ ބެލެންސް، ޓްރަޔަލް ބެލެންސްގައި މި ހިސާބުގެ ނިމޭ ބެލެންސާ ހަމަވާނެއެވެ.",
      "openingBalance": "ފެށޭ ބެލެންސް",
      "rangeTotals": "މި ދާއިރާގެ ޖުމްލަ",
      "empty": "މި ދާއިރާގައި މި ހިސާބުގައި ޕޯސްޓިންގއެއް ނެތެވެ.",
      "loadFailed": "ލެޖަރ ތަފްޞީލު ލޯޑްނުވި",
      "columns": {
        "date": "ތާރީޚް",
        "sourceDoc": "މަޞްދަރު ލިޔުން",
        "running": "ހިނގަމުންދާ ބެލެންސް"
      }
    },
    "drilldown": {
      "recurringTemplate": "ތަކުރާރު ޓެމްޕްލޭޓް",
      "allocationRule": "ބެހުމުގެ ޤަވާޢިދު",
      "openingBalance": "ފެށޭ ބެލެންސް އިމްޕޯޓް",
      "pendingShort": "އަދި ސްކްރީނެއް ނެތް",
      "pendingTooltip": "މި ޖާނަލް އުފެއްދީ {module} އިންނެވެ. އެ ބައި އަދި މި ބިލްޑްގައި ނުހިމެނެއެވެ. ޑޭޓާބޭސްއިން ސިލްސިލާ ބެލޭނެގޮތަށް ލިޔުމުގެ ބާވަތާއި އައިޑީ ދައްކާލެވިފައިވެއެވެ.",
      "modules": {
        "ap": "ދައްކަންޖެހޭ ފައިސާގެ ބައި",
        "ar": "ލިބެންޖެހޭ ފައިސާގެ ބައި",
        "cash": "ފައިސާއާއި ބޭންކްގެ ބައި",
        "inventory": "މުދަލުގެ ބައި",
        "payroll": "މުސާރައިގެ ބައި",
        "assets": "ދާއިމީ މުދަލުގެ ބައި",
        "projects": "ޕްރޮޖެކްޓްގެ ބައި",
        "mfg": "އުފެއްދުމުގެ ބައި",
        "unknown": "މި ސްކްރީނަށް ނޭނގޭ ބައެއް"
      },
      "sourceDoc": "މި ޕޯސްޓްވި ލިޔުން"
    },
    "run": {
      "action": "ހިންގާ",
      "title": "{name} ހިންގާ",
      "generatedHeadline": "ޖާނަލް އުފެއްދިއްޖެއެވެ.",
      "generatedBody": "އުފެއްދުނީ {entryNo} ގެ ގޮތުގައެވެ.",
      "amount": "އަދަދު",
      "openEntry": "ޖާނަލް އެންޓްރީ ހުޅުވާ",
      "alreadyHeadline": "އެ މުއްދަތުގެ ޖާނަލް މިހާރު ވެސް ވެއެވެ.",
      "alreadyBody": "މި ހިންގުންތައް ޤަޞްދުގައި ވަނީ ކޮންމެ މުއްދަތަކަށް އެއްފަހަރު ކަމަށްވާތީ، ދެވަނަ ފަހަރު ހިންގުމުން އެއްވެސް ބަދަލެއް ނާދެއެވެ. ލެޖަރ މިހާރު ވެސް އޮތީ ބޭނުންވި ޙާލަތުގައެވެ.",
      "failed": "ހިންގުން ފުރިހަމައެއް ނުވި"
    },
    "templates": {
      "title": "ތަކުރާރު ޖާނަލްތައް",
      "description": "ޝެޑިއުލްއަކަށް ވޯކަރ ޖާނަލްއަށް ބަދަލުކުރާ ޓެމްޕްލޭޓްތައް. ޕޯސްޓްކުރެވޭ ޖާނަލްއެއް އުފެއްދޭ ނުވާ ޓެމްޕްލޭޓަކީ ޝެޑިއުލްކުރެވިފައިވާ ނާކާމިޔާބީއެއް ކަމުން، މިތާނގައި ހަމަވާން ޖެހެއެވެ.",
      "newTemplate": "އައު ޓެމްޕްލޭޓް",
      "editTemplate": "ޓެމްޕްލޭޓް އެޑިޓްކުރޭ",
      "editorDescription": "ސަޠުރުތަކަކީ ޖާނަލްއެއް ކަމުން، ހަމަ އެ ޤަވާޢިދު ހިނގާނެއެވެ: ކޮންމެ ސަޠުރެއްގައި ޑެބިޓެއް ނުވަތަ ކްރެޑިޓެއް، އަދި ދެ ކޮލަމް ހަމަވުން.",
      "tableLabel": "ތަކުރާރު ޖާނަލް ޓެމްޕްލޭޓްތައް",
      "emptyTitle": "އަދި ތަކުރާރު ޖާނަލްއެއް ނެތް",
      "emptyDescription": "ކުއްޔެއް، ބަރޯސާވުމެއް ނުވަތަ ކޮންމެ މަހަކު ޕޯސްޓްކުރާ ޖާނަލްއަކަށް އެއް އުފައްދާ.",
      "loadFailed": "ޓެމްޕްލޭޓްތައް ލޯޑްނުވި",
      "active": "ހިނގާ",
      "inactive": "ނުހިނގާ",
      "activeLabel": "ހިނގާ",
      "interval": "ކޮންމެ",
      "intervalHint": "ހިންގުންތަކުގެ ދެމެދުގައި ހޮވި ޔުނިޓުން ކިތައް.",
      "dayOfMonth": "މަހުގެ ދުވަސް",
      "dayOfMonthHint": "ފެށޭ ތާރީޚުގެ ދުވަސް ބަހައްޓަން ބޭނުންނަމަ ހުސްކޮށް ބާއްވާ.",
      "startDate": "ފުރަތަމަ ހިންގުން",
      "endDate": "ފަހު ހިންގުން",
      "endDateHint": "ނިއްވާލަންދެން ހިންގަން ބޭނުންނަމަ ހުސްކޮށް ބާއްވާ.",
      "postAutomatically": "އަމިއްލައަށް ޕޯސްޓްކުރޭ",
      "postAutomaticallyHint": "ދެލިކޮޕީއެއްގެ ގޮތުގައި ބެހެއްޓުމުގެ ބަދަލުގައި ވޯކަރ އުފެއްދި ޖާނަލް ޕޯސްޓްކުރެއެވެ.",
      "saved": "ޓެމްޕްލޭޓް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "ޓެމްޕްލޭޓް {code} ރައްކާކުރެވިއްޖެއެވެ.",
      "saveFailed": "ޓެމްޕްލޭޓް ރައްކާނުކުރެވުނު",
      "delete": "ފޮހެލާ",
      "deleteTitle": "މި ޓެމްޕްލޭޓް ފޮހެލާ",
      "deleteDescription": "ޓެމްޕްލޭޓް {code} އިން ޖާނަލް އުފެއްދުން ހުއްޓޭނެއެވެ.",
      "deleteBody": "މިހާތަނަށް އުފެއްދި ޖާނަލްތައް ލެޖަރގައި ދެމިހުންނާނެއެވެ. ދަނީ ހަމައެކަނި ޓެމްޕްލޭޓެވެ.",
      "deleted": "ޓެމްޕްލޭޓް ފޮހެލެވިއްޖެ",
      "deletedDetail": "ޓެމްޕްލޭޓް {code} އަލުން ނުހިނގާނެއެވެ.",
      "deleteFailed": "ޓެމްޕްލޭޓް ފޮހެނުލެވުނު",
      "columns": {
        "code": "ކޯޑު",
        "frequency": "ތަކުރާރުވާ މިންވަރު",
        "nextRun": "ދެން ހިންގާ",
        "lastRun": "ފަހުން ހިންގި",
        "runCount": "ހިންގުންތައް"
      },
      "frequencies": {
        "daily": "ކޮންމެ ދުވަހަކު",
        "weekly": "ކޮންމެ ހަފުތާއަކު",
        "monthly": "ކޮންމެ މަހަކު",
        "quarterly": "ކޮންމެ ކުއާޓަރަކު",
        "annually": "ކޮންމެ އަހަރަކު",
        "onDemand": "ބޭނުންވާ ހިނދަކު"
      },
      "onDemandHint": "ޕޯސްޓްވަނީ ހަމައެކަނި ތިޔަ ހިންގާ ހިނދު. ޝެޑިއުލަރ އިން މީގެން ދުވަހަކުވެސް ޖާނަލެއް ނުއުފައްދާނެ، އެހެންކަމުން ދެން ހިންގާނެ ތާރީޚެއް ނެތް."
    },
    "routeTitles": {
      "journalTypes": "ޖާނަލް ބާވަތްތައް",
      "dimensionPolicies": "ޑައިމެންޝަން ޕޮލިސީ",
      "suspense": "ސަސްޕެންސް",
      "accruals": "އެކްރޫއަލްތައް",
      "assertions": "ޕޯސްޓިންގ އެސާޝަންތައް"
    },
    "governanceNav": {
      "label": "ޕޯސްޓިންގ ގަވަރނަންސްގެ ބައިތައް",
      "journalTypes": "ޖާނަލް ބާވަތްތައް",
      "dimensionPolicies": "ޑައިމެންޝަން ޕޮލިސީ",
      "suspense": "ސަސްޕެންސް",
      "accruals": "އެކްރޫއަލްތައް",
      "assertions": "ޕޯސްޓިންގ އެސާޝަންތައް"
    },
    "reversalPolicies": {
      "manual": "އަތުން",
      "next_period": "ޖެހިގެން އަންނަ މުއްދަތު",
      "on_match": "މެޗްވުމުން"
    },
    "requirements": {
      "required": "ބޭނުންވޭ",
      "optional": "އިޚްތިޔާރީ",
      "forbidden": "މަނާ"
    },
    "dimensions": {
      "cost_center": "ކޮސްޓް ސެންޓަރު",
      "profit_center": "ޕްރޮފިޓް ސެންޓަރު",
      "branch": "ބްރާންޗް",
      "department": "ޑިޕާޓްމަންޓް",
      "business_unit": "ބިޒްނަސް ޔުނިޓް",
      "division": "ޑިވިޜަން",
      "project": "ޕްރޮޖެކްޓް"
    },
    "suspenseStatuses": {
      "open": "ހުޅުވިފައި",
      "partially_cleared": "ބައެއް ސާފުކުރެވިފައި",
      "cleared": "ސާފުކުރެވިފައި",
      "written_off": "ރައިޓް-އޯފް ކުރެވިފައި"
    },
    "accrualStatuses": {
      "open": "ހުޅުވިފައި",
      "partially_matched": "ބައެއް މެޗްވެފައި",
      "matched": "މެޗްވެފައި",
      "reversed": "ރިވާސްކުރެވިފައި",
      "written_off": "ރައިޓް-އޯފް ކުރެވިފައި"
    },
    "accrualKinds": {
      "goods_received": "ލިބުނު މުދާ",
      "services_received": "ލިބުނު ޚިދުމަތް",
      "expense_accrued": "ޚަރަދު އެކްރޫކުރެވިފައި",
      "revenue_unbilled": "ބިލްނުކުރެވޭ އާމްދަނީ",
      "payroll_accrued": "މުސާރަ އެކްރޫކުރެވިފައި",
      "other": "އެހެނިހެން"
    },
    "assertionStatuses": {
      "pass": "ފާސް",
      "fail": "ފެއިލް",
      "not_run": "ދުވަހަކުވެސް ނުހިނގާ",
      "accepted": "ބަލައިގަނެފައި"
    },
    "journalTypes": {
      "title": "ޖާނަލް ބާވަތްތައް",
      "description": "ޕޯސްޓްވާ އެއްޗެހި ކުންފުނިން ބަހާލާ ގޮތް. މިއީ އެންޓްރީގެ ސޯސް އެއް ނޫން.",
      "sourceHint": "ސޯސް އަކީ ސާވަރުގެ ބަންދު ލިސްޓެއް. ޖާނަލް ބާވަތަކީ ކުންފުނީގެ އަމިއްލަ އެއްޗެއް.",
      "loadFailed": "ޖާނަލް ބާވަތްތައް ލޯޑެއް ނުކުރެވުނު",
      "create": "އައު ޖާނަލް ބާވަތެއް",
      "createTitle": "އައު ޖާނަލް ބާވަތް",
      "editTitle": "ޖާނަލް ބާވަތް އެޑިޓްކުރޭ",
      "dialogDescription": "ކޯޑަކީ ޕޯސްޓިންގ ޕާތުތަކުން މި ބާވަތް ހޯދާ ގޮތް، އެހެންވެ ފަހުން ބަދަލެއް ނުކުރެވޭނެ.",
      "created": "ޖާނަލް ބާވަތް ހެދިއްޖެ",
      "updated": "ޖާނަލް ބާވަތް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޖާނަލް ބާވަތް ރައްކާއެއް ނުކުރެވުނު",
      "code": "ކޯޑް",
      "name": "ނަން",
      "allowedSources": "ހުއްދަ ސޯސްތައް",
      "allowedSourcesHint": "ކޮމާއިން ވަކިކުރެވިފައި. ހުސްކޮށް ބެހެއްޓުމުން ހުރިހާ ސޯސްއަކަށް ހުއްދަ.",
      "anySource": "ކޮންމެ ސޯސްއެއް",
      "allowsManual": "އަތުން ޖާނަލް ހެދުމަށް ހުއްދަ",
      "allowsManualHint": "ނިއްވާލުމުން ހަމައެކަނި ސިސްޓަމުން ޕޯސްޓްކުރެވޭނެ.",
      "manualYes": "އަތުން ހުއްދަ",
      "manualNo": "ހަމައެކަނި ސިސްޓަމް",
      "reversalPolicy": "ރިވާސަލް",
      "requiresApproval": "ހުއްދަ",
      "approvalYes": "ބޭނުންވޭ",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓިފައި",
      "system": "ސިސްޓަމް",
      "tableLabel": "ޖާނަލް ބާވަތްތައް",
      "emptyTitle": "ޖާނަލް ބާވަތެއް ނެތް",
      "emptyDescription": "އެއް ހަދާ، ނުވަތަ ޗާޓް އޮފް އެކައުންޓްސްއާއެކު ސީޑްވާ ޑިފޯލްޓްތަކަށް އިންތިޒާރުކުރޭ.",
      "approvalNo": "ބޭނުންއެއް ނުވޭ",
      "approvalEffect": "މި ބާވަތުގެ އަތުން ހަދާ އަދި ތަކުރާރުވާ ޖާނަލްތައް ޕޯސްޓްކުރުމުގެ ކުރިން ހުށަހަޅައި ފާސްކުރަން ޖެހޭނެ.",
      "noApprovalEffect": "މި ބާވަތުގެ ޖާނަލްތައް ފާސްކުރުމެއް ނެތި ސީދާ ޕޯސްޓްކުރެވޭނެ.",
      "reversalEffect": {
        "manual": "އެނބުރޭނީ މީހަކު އެނބުރުވައިފިނަމަ އެކަންޏެވެ.",
        "next_period": "ދެން އަންނަ ޕީރިއަޑުގައި އަމިއްލައަށް އެނބުރޭނެ.",
        "on_match": "އެ އަންދާޒާކުރާ ޑޮކިއުމަންޓް މެޗްވުމުން އެނބުރޭނެ."
      },
      "delete": "ފޮހެލާ",
      "deleteConfirm": "ބާވަތް ފޮހެލާ",
      "deleteTitle": "މި ޖާނަލް ބާވަތް ފޮހެލަންތޯ؟",
      "deleteMessage": "{code} އިތުރަށް އާ ޖާނަލްތަކުގައި ހުށަނޭޅޭނެ. މިހާރު އޭގެ ދަށުން ހެދިފައިވާ އެންޓްރީތަކުގައި އެ ބާވަތް ހުރެއެވެ.",
      "deleted": "ޖާނަލް ބާވަތް ފޮހެލެވިއްޖެ",
      "deleteFailed": "ޖާނަލް ބާވަތް ފޮހެލެވިފައެއް ނުވޭ",
      "staleTitle": "މި ޖާނަލް ބާވަތަށް ބަދަލު އައިސްފި",
      "staleDetail": "ތިބާ ހުޅުވާފައި ހުއްޓައި އެހެން މީހަކު މި ޖާނަލް ބާވަތް ސޭވްކޮށްފި. އަލުން ލޯޑްކުރެވުނު، އަދި އެއްވެސް އެއްޗެއް މައްޗަށް ނުލިޔެވޭ. ތިބާގެ ބަދަލުތައް ބަލާފައި އަލުން ސޭވްކުރާށެވެ.",
      "attachmentAbove": "މިއަށްވުރެ މަތީގައި އެޓޭޗްމަންޓް ލާޒިމު",
      "attachmentAboveHint": "މި ބާވަތުގެ އަތުން ހަދާ ޖާނަލެއްގެ ޖުމްލަ، ބޭސް ފައިސާއިން، މި އަދަދަށްވުރެ ބޮޑުނަމަ، ސަޕޯޓިންގ އެޓޭޗްމަންޓެއް ނެތި ޕޯސްޓެއް ނުކުރެވޭނެއެވެ. ލާޒިމުކުރުމެއް ނެތްނަމަ ހުސްކޮށް ބާއްވާ.",
      "attachmentAboveInvalid": "10000.00 ފަދަ، ސުމަށްވުރެ ބޮޑު އަދަދެއް ޖައްސާށެވެ.",
      "attachmentNone": "ބޭނުންއެއް ނުވޭ",
      "attachmentEffect": "{amount} އަށްވުރެ މަތީގައި ސަޕޯޓިންގ އެޓޭޗްމަންޓެއް ބޭނުންވޭ"
    },
    "dimensionPolicies": {
      "title": "އެކައުންޓަކަށް ޑައިމެންޝަން ޕޮލިސީ",
      "description": "އެކައުންޓަކަށް ކޮން ޑައިމެންޝަނެއް ބޭނުންވޭތޯ، ހުއްދަތޯ ނުވަތަ މަނާތޯ — ތާރީޚުން ފެށިގެން.",
      "forbiddenHint": "މަނާ ޑައިމެންޝަނަކީ ފަހުން ރިޕޯޓަކުން ފެނިދާނެ ހަމައެކަނި އެއްޗެއް.",
      "loadFailed": "އެކައުންޓްގެ ޕޮލިސީ ލޯޑެއް ނުކުރެވުނު",
      "account": "އެކައުންޓް",
      "chooseTitle": "އެކައުންޓެއް ހޮވާ",
      "chooseDescription": "ޕޮލިސީ އަކީ އެކައުންޓަކަށް. ފުރަތަމަ ކުންފުނި، ދެން އެކައުންޓް ހޮވާ.",
      "gridTitle": "ޑައިމެންޝަންތައް",
      "gridDescription": "ޕޮލިސީއެއް ނެތް ޑައިމެންޝަނަކީ އިޚްތިޔާރީ އެއްޗެއް.",
      "dimension": "ޑައިމެންޝަން",
      "requirement": "ބޭނުންވާ މިންވަރު",
      "effectiveFrom": "ފެށޭ ތާރީޚު",
      "note": "ނޯޓް",
      "saved": "ޑައިމެންޝަން ޕޮލިސީ ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޑައިމެންޝަން ޕޮލިސީ ރައްކާއެއް ނުކުރެވުނު"
    },
    "suspense": {
      "title": "ސަސްޕެންސް",
      "description": "އެކައުންޓް އަދި ނޭނގޭ ފައިސާ. ސާފުކުރުމަކީ އާދައިގެ ބުކްކީޕިންގ؛ ރައިޓް-އޯފް ކުރުމަކީ ގެއްލުމެއް.",
      "loadFailed": "ސަސްޕެންސް އައިޓަމްތައް ލޯޑެއް ނުކުރެވުނު",
      "reportFailed": "ސަސްޕެންސް ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު",
      "tabItems": "އައިޓަމްތައް",
      "tabReport": "ޕޮޒިޝަނުން",
      "tabsLabel": "ސަސްޕެންސް ވިއުތައް",
      "position": "ޕޮޒިޝަން",
      "anyPosition": "ކޮންމެ ޕޮޒިޝަނެއް",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "entryDate": "ތާރީޚު",
      "source": "ނަގާފައިވަނީ",
      "noDescription": "ތަފްސީލެއް ނެތް",
      "amount": "އަދަދު",
      "amountHint": "ޑިފޯލްޓަކީ ބާކީ ހުރި ހުރިހާ އެއްޗެއް. ބައެއް ސާފުކުރަން ކުޑަ އަދަދެއް ލިޔޭ.",
      "cleared": "ސާފުކުރެވިފައި",
      "remaining": "ބާކީ",
      "openCount": "ހުޅުވިފައި",
      "agedCount": "ދުވަސްވެފައި",
      "agedRemaining": "ދުވަސްވި ބާކީ",
      "blocksClose": "ކްލޯޒް ހުއްޓުވާ",
      "blocksCloseColumn": "ކްލޯޒް",
      "tableLabel": "ސަސްޕެންސް އައިޓަމްތައް",
      "emptyTitle": "ސަސްޕެންސްގައި އެއްޗެއް ނެތް",
      "emptyDescription": "ފައިސާ އެނގި އެކައުންޓް ނޭނގޭ ހާލަތުގައި އަދަދު މިތަނަށް އަންނާނެ.",
      "reportTitle": "ޕޮޒިޝަނުން ސަސްޕެންސް",
      "reportDescription": "ދުވަސްވި ބާކީ ފުރަތަމަ: ލިމިޓަށްވުރެ ދުވަސްވި އައިޓަމަކީ މަސް ހުއްޓުވާނެ އެއްޗެއް.",
      "reportEmptyTitle": "ސަސްޕެންސް ޕޮޒިޝަނެއް ނެތް",
      "reportEmptyDescription": "ޕޮޒިޝަނަކީ ސަސްޕެންސް އަދަދު އިށީންނަ ތަން.",
      "clear": "ސާފުކުރޭ",
      "clearTitle": "ސަސްޕެންސް އައިޓަމެއް ސާފުކުރޭ",
      "clearDescription": "އަދަދު އޭގެ ހަގީގީ އެކައުންޓަށް ބަދަލުކުރޭ.",
      "clearingAccount": "ސާފުކުރާ އެކައުންޓް",
      "clearFailed": "އައިޓަމް ސާފެއް ނުކުރެވުނު",
      "writeOff": "ރައިޓް-އޯފް",
      "writeOffTitle": "ސަސްޕެންސް އައިޓަމެއް ރައިޓް-އޯފް ކުރޭ",
      "writeOffDescription": "މި އަދަދު ދުވަހަކުވެސް ދެނެގަނެވޭނެ ކަމަށް ނުބެލެވޭ، އެހެންވެ ޚަރަދަކަށް ވާނެ.",
      "writeOffWarning": "މިއީ ގެއްލުމެއް، އަލުން ބަހާލުމެއް ނޫން. ފައިސާގެ އަދަދުން އޮތޯރިޓީއަކަށް ބަނދެވި، ނަމުގައި ރެކޯޑުވާނެ.",
      "expenseAccount": "ޚަރަދު އެކައުންޓް",
      "writtenOff": "އައިޓަމް ރައިޓް-އޯފް ކުރެވިއްޖެ",
      "writeOffFailed": "އައިޓަމް ރައިޓް-އޯފެއް ނުކުރެވުނު",
      "reason": "ސަބަބު",
      "clearedItem": "އައިޓަމް ސާފުކުރެވިއްޖެ",
      "newPosition": "އާ ޕޮޒިޝަން",
      "postItem": "ސަސްޕެންސަށް ޕޯސްޓްކުރޭ",
      "postNeedsPosition": "ފުރަތަމަ ސަސްޕެންސް ޕޮޒިޝަނެއް ހަދާށެވެ.",
      "positionTitle": "އާ ސަސްޕެންސް ޕޮޒިޝަން",
      "positionDescription": "ސަސްޕެންސް އެކައުންޓެއްގެ މައްޗަށް ނަން ދީފައިވާ ތަނެއް. ކްލިއަރުކުރެވެންދެން ގިންތި ނުކުރެވޭ އަދަދުތައް ހުންނަނީ މިތާގައެވެ.",
      "positionCode": "ކޯޑް",
      "positionName": "ނަން",
      "positionAccount": "ސަސްޕެންސް އެކައުންޓް",
      "positionAccountHint": "ޕޮޒިޝަންގެ ބެލެންސް ހުންނަ ލެޖަރ އެކައުންޓް.",
      "maxAgeDays": "ހައްދު (ދުވަސް)",
      "maxAgeDaysHint": "މިއަށްވުރެ ބާވާ އައިޓަމަކީ ދުވަސްވީ އައިޓަމެކެވެ. ޑިފޯލްޓަށް ހުސްކޮށް ބާއްވާ.",
      "maxAgeDaysInvalid": "ދުވަސްތަކުގެ ފުރިހަމަ އަދަދެއް ޖައްސާށެވެ.",
      "blocksCloseLabel": "ދުވަސްވީ ބެލެންސަކުން ޕީރިއަޑް ކްލޯޒްކުރުން ހުއްޓުވާ",
      "blocksCloseHint": "ކްލޯޒް ކޮކްޕިޓް މިއެއްޗެހި ކިޔައެވެ: ހުއްޓުވާ ޕޮޒިޝަނެއްގައި ދުވަސްވީ އައިޓަމެއް ހުރެއްޖެނަމަ މަސް ބަންދުނުކުރެވޭނެ.",
      "positionCreated": "ސަސްޕެންސް ޕޮޒިޝަން ހެދިއްޖެ",
      "positionCreateFailed": "ސަސްޕެންސް ޕޮޒިޝަން ހެދިފައެއް ނުވޭ",
      "postTitle": "ސަސްޕެންސަށް އަދަދެއް ޕޯސްޓްކުރޭ",
      "postDescription": "އެކައުންޓް އަދި ނޭނގޭ ފައިސާ ރެކޯޑްކުރޭ. ޕޮޒިޝަންގެ އެކައުންޓާއި ކައުންޓަރ އެކައުންޓާ ދެމެދު ޕޯސްޓްވެ، ކްލިއަރުކުރެވެންދެން އެތާ ހުންނާނެ.",
      "postAmountHint": "ދެ ދިހަވަރު ތަނަށް ވާ ޑެސިމަލް އަދަދެއް.",
      "postAmountInvalid": "1250.00 ފަދަ އަދަދެއް ޖައްސާށެވެ.",
      "counterAccount": "ކައުންޓަރ އެކައުންޓް",
      "counterAccountHint": "ޕޯސްޓިންގެ އަނެއް ފަރާތް، އާންމުކޮށް ފައިސާ އައި ބޭންކް ނުވަތަ ކްލިއަރިންގ އެކައުންޓް.",
      "itemPosted": "ސަސްޕެންސަށް ޕޯސްޓްކުރެވިއްޖެ",
      "postFailed": "އަދަދު ސަސްޕެންސަށް ޕޯސްޓެއް ނުކުރެވުނު",
      "item_opened": "ސަސްޕެންސް އެކައުންޓެއްގައި ޢަދަދެއް ހިފެހެއްޓިފައި ވޭ."
    },
    "accruals": {
      "title": "އެކްރޫއަލްތައް",
      "description": "GR-IR އާންމުކުރެވިފައި: މުއްދަތު ނިމުމުން ނަގާ އަންދާޒާއެއް، ލިޔުމާ މެޗްކުރެވޭ ނުވަތަ ރިވާސްކުރެވޭ.",
      "loadFailed": "އެކްރޫއަލް އައިޓަމްތައް ލޯޑެއް ނުކުރެވުނު",
      "agingFailed": "އެކްރޫއަލް އޭޖިންގ ލޯޑެއް ނުކުރެވުނު",
      "tabItems": "އައިޓަމްތައް",
      "tabAging": "އޭޖިންގ",
      "tabsLabel": "އެކްރޫއަލް ވިއުތައް",
      "position": "ޕޮޒިޝަން",
      "anyPosition": "ކޮންމެ ޕޮޒިޝަނެއް",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "raisedOn": "ނެގި ތާރީޚު",
      "raisedFor": "ނެގީ",
      "noDescription": "ތަފްސީލެއް ނެތް",
      "reversal": "ރިވާސްވަނީ",
      "movedFrom": "{date} އިން ބަދަލުކުރެވިފައި — އެ މުއްދަތު ބަންދު",
      "amount": "އަދަދު",
      "matched": "މެޗްވެފައި",
      "remaining": "ބާކީ",
      "maxAgeDays": "ލިމިޓް (ދުވަސް)",
      "openCount": "ހުޅުވިފައި",
      "agedCount": "ދުވަސްވެފައި",
      "agedRemaining": "ދުވަސްވި ބާކީ",
      "tableLabel": "އެކްރޫއަލް އައިޓަމްތައް",
      "emptyTitle": "އެކްރޫއަލްއެއް ނެތް",
      "emptyDescription": "ލިޔުން އައުމުގެ ކުރިން ޚަރަދު ހިނގުމުން އެކްރޫއަލްއެއް ނަގާނެ.",
      "agingTitle": "އެކްރޫއަލް އޭޖިންގ",
      "agingDescription": "ލިމިޓަށްވުރެ ދުވަސްވި އައިޓަމަކީ އެއްވެސް ފަރާތަކުން މެޗްނުކުރި އަންދާޒާއެއް.",
      "agingEmptyTitle": "އެކްރޫއަލް ޕޮޒިޝަނެއް ނެތް",
      "agingEmptyDescription": "ޕޮޒިޝަނަކުން އެއް ބާވަތެއްގެ އެކްރޫއަލްތައް އެއްކުރެވޭ.",
      "reverse": "ރިވާސްކުރޭ",
      "reverseTitle": "އެކްރޫއަލްއެއް ރިވާސްކުރޭ",
      "reverseDescription": "މިރާ އެންޓްރީން އަންދާޒާ ދޫކޮށްލެވޭ.",
      "reverseOn": "ރިވާސްކުރާ ތާރީޚު",
      "reverseOnHint": "ސަބަބެއް ނެތްނަމަ ތާވަލުކުރެވިފައިވާ ގޮތަށް ބާއްވާ.",
      "closedPeriodHint": "ހޮވާ ތާރީޚު ބަންދު މުއްދަތެއްގައި ވާނަމަ، ރިވާސަލް ޖެހިގެން ހުޅުވިފައިވާ މުއްދަތަށް ދާނެ.",
      "reversed": "އެކްރޫއަލް ރިވާސްކުރެވިއްޖެ",
      "reversedMoved": "ރިވާސްކުރެވިއްޖެ — މުއްދަތު ބަންދުވުމުން ތާރީޚު ބަދަލުވި",
      "reverseFailed": "އެކްރޫއަލް ރިވާސްއެއް ނުކުރެވުނު",
      "writeOff": "ރައިޓް-އޯފް",
      "writeOffTitle": "އެކްރޫއަލްއެއް ރައިޓް-އޯފް ކުރޭ",
      "writeOffDescription": "މި އަންދާޒާ ދުވަހަކުވެސް ބިލްކުރެވޭނެ ކަމަށް ނުބެލެވޭ.",
      "writeOffWarning": "އެކްރޫއަލް ރައިޓް-އޯފް ކުރުމުން ކުރިން ރެކޯޑްކުރި ޚަރަދެއް ދޫވެ، މި މުއްދަތުގައި އާމްދަނީއެއްގެ ގޮތުގައި ފެންނާނެ.",
      "writtenOff": "އެކްރޫއަލް ރައިޓް-އޯފް ކުރެވިއްޖެ",
      "writeOffFailed": "އެކްރޫއަލް ރައިޓް-އޯފެއް ނުކުރެވުނު",
      "reason": "ސަބަބު",
      "newPosition": "އާ ޕޮޒިޝަން",
      "positionTitle": "އާ އެކްރޫއަލް ޕޮޒިޝަން",
      "positionDescription": "އެއް ބާވަތެއްގެ އެކްރޫއަލްތައް، އެނބުރުވާ ގަވާއިދާއެކު، އެކްރޫއަލް އެކައުންޓެއްގެ ދަށުގައި ގުޅުވާލައެވެ.",
      "positionCode": "ކޯޑް",
      "positionName": "ނަން",
      "kind": "ބާވަތް",
      "positionAccount": "އެކްރޫއަލް އެކައުންޓް",
      "positionAccountHint": "މެޗްވުމަށް ނުވަތަ އެނބުރުމަށް ދާންދެން އެކްރޫއަލް ހުންނަ ބެލެންސް ޝީޓް އެކައުންޓް.",
      "counterAccount": "ކައުންޓަރ އެކައުންޓް",
      "counterAccountHint": "އިޚްތިޔާރީ. އެކްރޫއަލް ހަދާ ޚަރަދު ނުވަތަ އާމްދަނީގެ ފަރާތް.",
      "reversePolicy": "އެނބުރޭނީ",
      "reversePolicies": {
        "on_match": "މެޗްވުމުން",
        "on_date": "ތާރީޚެއްގައި",
        "manual": "އަތުން"
      },
      "reversePolicyEffect": {
        "on_match": "ކޮންމެ އައިޓަމެއް އެނބުރޭނީ އޭގެ ޑޮކިއުމަންޓް މެޗްވުމުންނެވެ، GR-IR ގެ ގޮތަށް.",
        "on_date": "ކޮންމެ އައިޓަމެއް އެނބުރޭނީ ތާވަލުކުރި ތާރީޚުގައެވެ. އެ ޕީރިއަޑް ބަންދުނަމަ ކުރިއަށް ޖެހޭނެ.",
        "manual": "މީހަކު އެނބުރުވާ ނުވަތަ ރައިޓްއޮފްކުރާންދެން އައިޓަމްތައް ހުންނާނެ."
      },
      "maxAgeDaysHint": "މިއަށްވުރެ ބާވާ އައިޓަމަކީ ދުވަސްވީ އައިޓަމެކެވެ. ޑިފޯލްޓަށް ހުސްކޮށް ބާއްވާ.",
      "maxAgeDaysInvalid": "ދުވަސްތަކުގެ ފުރިހަމަ އަދަދެއް ޖައްސާށެވެ.",
      "blocksCloseLabel": "ދުވަސްވީ ބެލެންސަކުން ޕީރިއަޑް ކްލޯޒްކުރުން ހުއްޓުވާ",
      "positionCreated": "އެކްރޫއަލް ޕޮޒިޝަން ހެދިއްޖެ",
      "positionCreateFailed": "އެކްރޫއަލް ޕޮޒިޝަން ހެދިފައެއް ނުވޭ"
    },
    "assertions": {
      "title": "ޕޯސްޓިންގ ފުރިހަމަކަން",
      "description": "ޕޯސްޓްވާން ޖެހޭ ހުރިހާ އެއްޗެއް ޕޯސްޓްވިތޯ؟ ކޮންމެ މޮޑިއުލްއަކަށް ކޮންމެ ދުވަހަކަށް އެއް ޖަވާބު.",
      "loadFailed": "ޕޯސްޓިންގ އެސާޝަންތައް ލޯޑެއް ނުކުރެވުނު",
      "modules": {
        "ap": "ދޭންޖެހޭ ފައިސާ",
        "ar": "ލިބެންޖެހޭ ފައިސާ",
        "inventory": "އިންވެންޓަރީ",
        "sales": "ވިޔަފާރި",
        "cash": "ކޭޝް"
      },
      "module": "މޮޑިއުލް",
      "anyModule": "ކޮންމެ މޮޑިއުލްއެއް",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "businessDate": "ވިޔަފާރި ތާރީޚު",
      "from": "އިން",
      "to": "އަށް",
      "expected": "އުންމީދުކުރި",
      "posted": "ޕޯސްޓްވި",
      "unposted": "ޕޯސްޓްނުވާ",
      "difference": "ތަފާތު",
      "failingBanner": "{count} އެސާޝަން ފެއިލްވެއްޖެ. ޕޯސްޓްކުރުން ހުއްޓުނު ސަބް-ލެޖަރެއް އެހެން ރިޕޯޓަކުން ނުފެންނާނެ.",
      "tableLabel": "ޕޯސްޓިންގ އެސާޝަންތައް",
      "emptyTitle": "އެސާޝަނެއް ރެކޯޑްވެފައި ނެތް",
      "emptyDescription": "ތާރީޚަކަށް ހިންގާ، ނުވަތަ ރޭގަނޑުގެ ސްވީޕަށް އިންތިޒާރުކުރޭ.",
      "run": "މިހާރު ހިންގާ",
      "runTitle": "ޕޯސްޓިންގ އެސާޝަން ހިންގާ",
      "runDescription": "ހޮވާ ތާރީޚަށް ރަޖިސްޓްރީވެފައިވާ ހުރިހާ މޮޑިއުލްއެއް ބެލޭނެ.",
      "ran": "އެސާޝަން ހިނގައިފި",
      "ranWithFailures": "އެސާޝަން ހިނގައިފި — ބައެއް ފެއިލްވި",
      "runFailed": "އެސާޝަން ނުހިންގުނު",
      "accept": "ބަލައިގަނޭ",
      "acceptTitle": "ފެއިލްވި އެސާޝަނެއް ބަލައިގަނޭ",
      "acceptDescription": "ތަފާތު ބެލި ކަމާއި ކްލޯޒް ކުރިއަށްދާނެކަން ރެކޯޑްކުރޭ.",
      "acceptWarning": "މިއިން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުވާނެ. ތަފާތު ދެމިހުންނާނެ؛ ބަދަލުވަނީ އޭގެ ޒިންމާ ނަގާ ފަރާތް.",
      "acceptSubject": "{module}، {date} — {unposted} ލިޔުމެއް ޕޯސްޓެއް ނުވި.",
      "accepted": "އެސާޝަން ބަލައިގަނެވިއްޖެ",
      "acceptFailed": "އެސާޝަން ބަލައެއް ނުގަނެވުނު",
      "reason": "ސަބަބު"
    },
    "approval": {
      "actions": {
        "submit": "ފާސްކުރުމަށް ހުށަހަޅާ",
        "returnToDraft": "ޑްރާފްޓަށް އަނބުރާ ގެންދާ"
      },
      "submitting": "ހުށަހަޅަނީ",
      "returning": "ޑްރާފްޓަށް އަނބުރާ ގެންދަނީ",
      "readyToSubmit": "ލައިންތައް ބެލެންސްވެ، ކޮންމެ އެކައުންޓެއް ޕޯސްޓްކުރެވޭތީ، މި އެންޓްރީ ފާސްކުރުމަށް ހުށަހެޅޭނެ.",
      "notes": {
        "submitted": "މި ޖާނަލް ފާސްކުރުމަށް މަޑުކުރަނީ، އަދި އެޑިޓްކުރެވޭކަށް ނެތް. ބަދަލުކުރަން ބޭނުންނަމަ ޑްރާފްޓަށް އަނބުރާ ގެންދާށެވެ.",
        "approved": "މި ޖާނަލް ފާސްކުރެވިފައިވާތީ ޕޯސްޓްކުރެވޭނެ. ޑްރާފްޓަށް އަނބުރާ ގެންދިއުމުން ފާސްކުރުން ބާޠިލުވާނެ.",
        "rejected": "މި ޖާނަލް ނުފާސްކުރެވިއްޖެ. އެޑިޓްކޮށް ސޭވްކުރުމުން ޑްރާފްޓަށް ރުޖޫޢަވާނެ، ދެން އަލުން ހުށަހަޅާށެވެ، ނުވަތަ ދޫކޮށްލާށެވެ.",
        "gated": "މި ޖާނަލް ބާވަތަށް ފާސްކުރުން ބޭނުންވޭ: ޑްރާފްޓް ސޭވްކޮށް ހުށަހަޅާށެވެ. ފާސްކުރެވުމުން ޕޯސްޓްކުރެވޭނެ."
      },
      "openInbox": "އެޕްރޫވަލް އިންބޮކްސް ހުޅުވާ",
      "openAuthorityMatrix": "އޮތޯރިޓީ މެޓްރިކްސް ހުޅުވާ",
      "errors": {
        "required": "މި ޖާނަލް ބާވަތަށް ފާސްކުރުން ބޭނުންވޭ. ފާސްކުރުމަށް ހުށަހަޅާ، ފާސްވުމުން ޕޯސްޓްކުރާށެވެ.",
        "notRequired": "މި ޖާނަލް ބާވަތަށް ފާސްކުރުން ބޭނުންއެއް ނުވޭ. ސީދާ ޕޯސްޓްކުރާށެވެ.",
        "unresolvable": "ޖާނަލްތައް ފާސްކުރާނެ މީހަކު ކަނޑައަޅާފައެއް ނެތް. އޮތޯރިޓީ މެޓްރިކްސްގައި gl.journal ޑޮކިއުމަންޓް ބާވަތަށް އެޕްރޫވަލް ޗެއިނެއް ހަދާފައި އަލުން ހުށަހަޅާށެވެ."
      },
      "toasts": {
        "submitted": "ފާސްކުރުމަށް ހުށަހެޅިއްޖެ",
        "submittedDetail": "އެޕްރޫވަލް އިންބޮކްސްގައި މަޑުކުރަނީ. ފާސްވުމުން ޕޯސްޓްކުރާށެވެ.",
        "submitFailed": "ޖާނަލް ހުށަހެޅިފައެއް ނުވޭ",
        "returned": "ޑްރާފްޓަށް އަނބުރާ ގެނެވިއްޖެ",
        "returnedDetail": "އަލުން އެޑިޓްކުރެވޭނެ. ތައްޔާރުވުމުން ފާސްކުރުމަށް ހުށަހަޅާށެވެ.",
        "returnFailed": "ޖާނަލް ޑްރާފްޓަށް އަނބުރާ ނުގެނެވުނު"
      }
    },
    "entryType": {
      "label": "ޖާނަލް ބާވަތް",
      "placeholder": "ޖާނަލް ބާވަތެއް ޚިޔާރުކުރޭ",
      "hint": "އެންޓްރީއަށް ފާސްކުރުން ބޭނުންވޭތޯއާއި، އެނބުރޭނެ ގޮތް ކަނޑައަޅަނީ މިއިންނެވެ.",
      "fixedHint": "އެންޓްރީ ހެދިއިރު ކަނޑައެޅުނު. ސޭވްކުރެވިފައިވާ އެންޓްރީއެއްގައި ބަދަލެއް ނުކުރެވޭނެ.",
      "unreadable": "ތިބާގެ ރޯލަށް ޖާނަލް ބާވަތްތައް ނުކިޔެވޭތީ، އެންޓްރީ ބޭނުންކުރަނީ ސްޓޭންޑަޑް ބާވަތެވެ.",
      "requiresApproval": "ފާސްކުރުން ބޭނުންވޭ",
      "noApproval": "ފާސްކުރުން ބޭނުންއެއް ނުވޭ",
      "reversal": "އެނބުރޭނީ: {policy}",
      "postLocked": "މި ޖާނަލް ފާސްކުރެވުމުން ޕޯސްޓްކުރެވޭނެ. ފުރަތަމަ ފާސްކުރުމަށް ހުށަހަޅާށެވެ.",
      "column": "ބާވަތް"
    },
    "entryExtras": {
      "documentDate": "ޑޮކިއުމަންޓްގެ ތާރީޚު",
      "documentDateHint": "އަސްލު ޑޮކިއުމަންޓްގައިވާ ތާރީޚު، އެންޓްރީގެ ތާރީޚާ ތަފާތުނަމަ. އިޚްތިޔާރީ.",
      "reversalDate": "އެނބުރޭ ތާރީޚު",
      "reversalDateHint": "މި ޖާނަލް ބާވަތް އަމިއްލައަށް އެނބުރޭނެއެވެ. އެނބުރުން ޕޯސްޓްކުރެވޭނީ މި ތާރީޚުގައެވެ. މި ތާރީޚު އެންޓްރީގެ ތާރީޚަށްވުރެ ފަހުން ވާން ޖެހޭނެއެވެ.",
      "reversalDateRequired": "އެނބުރޭ ތާރީޚު ޖައްސާށެވެ: މި ޖާނަލް ބާވަތް އެނބުރޭނީ ދެން އަންނަ ޕީރިއަޑުގައެވެ.",
      "autoReversal": {
        "label": "އަމިއްލައަށް އެނބުރުން",
        "open": "އެނބުރުން ހުޅުވާ",
        "statuses": {
          "draft": "ޑްރާފްޓެއްގެ ގޮތުގައި މަޑުކުރަނީ",
          "posted": "ޕޯސްޓްކުރެވިއްޖެ",
          "discarded": "ދޫކޮށްލެވިއްޖެ"
        }
      },
      "check": {
        "action": "ޗެކްކުރޭ",
        "hint": "ސޭވްކުރެވިފައިވާ ޖާނަލް، ސޭވްކުރުމެއް ނުވަތަ ޕޯސްޓްކުރުމެއް ނެތި، ކޮންމެ ޕޯސްޓިންގ ގަވާއިދަކާ އަޅާކިޔާލައެވެ.",
        "running": "ޗެކްކުރަނީ",
        "title": "ޗެކްގެ ނަތީޖާ",
        "ok": "އެއްވެސް މައްސަލައެއް ނުފެނުނު. ސޭވްކުރެވިފައިވާ ޖާނަލް ހުރިހާ ޕޯސްޓިންގ ގަވާއިދަކުން ފާސްވެއެވެ.",
        "issues": "ފެނުނު މައްސަލަތައް: {count}. މިއީ ހައްލުކުރެވެންދެން ޖާނަލް ޕޯސްޓެއް ނުކުރެވޭނެއެވެ.",
        "where": "ކޮންތާކު",
        "code": "ކޯޑް",
        "message": "ފެނުނު ކަންތައް",
        "header": "ހެޑަރ",
        "line": "ލައިން {lineNo}",
        "lineField": "ލައިން {lineNo} · {field}",
        "savedVersion": "ސޭވްނުކުރާ ބަދަލުތައް އެބަހުއްޓެވެ. މި ނަތީޖާއަކީ ޖާނަލްގެ ސޭވްކުރެވިފައިވާ ވާޝަނުގެ ނަތީޖާއެވެ؛ އެ ބަދަލުތައް ހިމެނުމަށް ސޭވްކޮށް އަލުން ޗެކްކުރާށެވެ.",
        "failed": "ޗެކް ހިންގޭކަށް ނުވި."
      },
      "attachments": {
        "requirement": "ޖާނަލްގެ ޖުމްލަ {amount} އަށްވުރެ ބޮޑުނަމަ، މި ޖާނަލް ބާވަތަށް ޕޯސްޓްކުރުމުގެ ކުރިން ސަޕޯޓިންގ ޑޮކިއުމަންޓެއް ބޭނުންވޭ.",
        "saveFirst": "ސަޕޯޓިންގ ޑޮކިއުމަންޓްތައް އެޓޭޗްކުރުމަށް ފުރަތަމަ ޖާނަލް ސޭވްކުރާށެވެ.",
        "required": "މި ޖާނަލް ޕޯސްޓްކުރުމުގެ ކުރިން ސަޕޯޓިންގ ޑޮކިއުމަންޓެއް ބޭނުންވެއެވެ. އެއް އެޓޭޗްކޮށް، އަލުން ޕޯސްޓްކުރައްވާށެވެ."
      }
    },
    "approvalPreview": {
      "heading": "ޖާނަލް ލައިންތައް",
      "noAccess": "ތިބާގެ ރޯލަށް ޖާނަލް އެންޓްރީތައް ނުކިޔެވޭތީ ލައިންތައް ނުދައްކާނެ. މަތީގައިވާ އަދަދަކީ ޖާނަލްގެ ޖުމްލައެވެ.",
      "loadFailed": "ޖާނަލްގެ ލައިންތައް ލޯޑެއް ނުކުރެވުނު",
      "accountById": "އެކައުންޓް #{id}",
      "dated": "ތާރީޚު {date}",
      "account": "އެކައުންޓް",
      "description": "ތަފްޞީލް",
      "totals": "ޖުމްލަ",
      "open": "ޖާނަލް ހުޅުވާ"
    },
    "ft10": {
      "warnings": {
        "title": {
          "posted": "ބަޖެޓް އިންޒާރާއެކު ޕޯސްޓްކުރެވިއްޖެ",
          "check": "މިހާރު ޕޯސްޓްކުރެވިއްޖެނަމަ ލިބޭ ބަޖެޓް އިންޒާރު"
        },
        "summary": {
          "posted": "ޖޯނަލް ޕޯސްޓްކުރެވިއްޖެ. {count} ލައިނެއް އިންޒާރު ލެވެލުގައި ބަޖެޓް ހިނގާފައިވޭ؛ ތިރީގެ އަދަދުތައް ބައްލަވާ. | ޖޯނަލް ޕޯސްޓްކުރެވިއްޖެ. {count} ލައިނެއް އިންޒާރު ލެވެލުގައި ބަޖެޓް ހިނގާފައިވޭ؛ ތިރީގެ އަދަދުތައް ބައްލަވާ.",
          "check": "ޕޯސްޓްކުރެވޭނެ، {count} ބަޖެޓް އިންޒާރެއްގެ ޒަރިއާއިން. | ޕޯސްޓްކުރެވޭނެ، {count} ބަޖެޓް އިންޒާރުގެ ޒަރިއާއިން."
        },
        "codes": {
          "WARN_BUDGET_EXCEEDED": "މި ޖޯނަލަށް {account} ގެ ބަޖެޓް ހިނގާފައިވޭ."
        },
        "budget": "ބަޖެޓް",
        "committed": "ކޮމިޓްކުރެވިފައި",
        "actuals": "ހަޤީޤީ ޚަރަދު",
        "available": "ލިބެން ހުރި",
        "requested": "މި ޖޯނަލް",
        "overspend": "ހިނގާފައިވާ ޢަދަދު",
        "tolerance": "ޓޮލަރަންސް"
      }
    },
    "entryRate": {
      "rateType": "ރޭޓުގެ ބާވަތް",
      "rateTypeHint": "މި ބޭރު ފައިސާގެ އެންޓްރީ ބަދަލުކުރެވޭނީ މި ރޭޓް ފޮތުންނެވެ.",
      "types": {
        "spot": "ސްޕޮޓް",
        "corporate": "ކޯޕަރޭޓް",
        "historical": "ތާރީޚީ"
      },
      "rate": "ރޭޓް ބަދަލުކުރުން",
      "rateHint": "އިޚްތިޔާރީ. އެއް {currency} ގެ އަގު {base} އިން، އެންމެ ގިނަވެގެން ދިހައިގެ ފަހުން އަށް ދަރަޖަ. ރޭޓް ފޮތް ބޭނުންކުރުމަށް ހުސްކޮށް ބާއްވާށެވެ. ބަދަލުކުރާ ރޭޓް ހުންނަންވާނީ ކަނޑައަޅާފައިވާ ޓޮލަރެންސްގެ ތެރޭގައެވެ.",
      "ratePlaceholder": "ރޭޓް ފޮތުން",
      "invalid": "ސުމެއްށްވުރެ ބޮޑު، ދިހައިގެ ފަހުން އެންމެ ގިނަވެގެން އަށް ދަރަޖަ ހުންނަ ރޭޓެއް ޖައްސާށެވެ، މިސާލަކަށް 15.42.",
      "clearRemovesSaved": "ސޭވްކުރާއިރު ސޭވްކުރެވިފައިވާ ބަދަލު ރޭޓް {rate} ފޮހެވޭނެއެވެ، އަދި އެންޓްރީ ބަދަލުކުރެވޭނީ ރޭޓް ފޮތުގެ ރޭޓުންނެވެ. ބަދަލު ރޭޓެއް ބާއްވާނަމަ ރޭޓެއް ޖައްސާށެވެ."
    },
    "entryActions": {
      "copy": {
        "action": "އާ އެއްޗަކަށް ކޮޕީކުރޭ",
        "hint": "މި އެންޓްރީގެ ލައިންތަކާއެކު، މިއަދުގެ ތާރީޚުގައި އާ ޑްރާފްޓެއް ހުޅުވޭނެއެވެ. ކޮޕީ ސޭވްކުރުމާހަމައަށް އެއްވެސް އެއްޗެއް ސޭވެއް ނުކުރެވޭނެއެވެ.",
        "note": "{source} އިން ކޮޕީކުރެވިފައި. ތާރީޚުތަކަކީ މިއަދުގެ ތާރީޚު، އަދި އަދި އެއްވެސް އެއްޗެއް ސޭވެއް ނުކުރެވެއެވެ."
      },
      "autoBalance": {
        "action": "އޮޓޯ ބެލެންސް",
        "hint": "އެންޓްރީ ބެލެންސްކުރާ އެއް ލައިން ސަސްޕެންސް އެކައުންޓަށް އިތުރުކުރާނެއެވެ.",
        "title": "ސަސްޕެންސަށް އޮޓޯ ބެލެންސްކުރުން",
        "description": "ތަފާތަށް ކުންފުނީގެ ސަސްޕެންސް އެކައުންޓަށް އެއް ލައިން އިތުރުކުރާނެއެވެ. ސޭވްކުރުމުގެ ކުރިން އެ ބައްލަވާށެވެ.",
        "difference": "ތަފާތު",
        "alreadyBalanced": "އެންޓްރީ މިހާރުވެސް ބެލެންސްވެފައި ވެއެވެ.",
        "invalidAmounts": "ފުރަތަމަ ލައިންތަކުގެ އަދަދުތައް ރަނގަޅުކުރައްވާށެވެ. ކޮންމެ އަދަދަކީ އެއް ފަރާތުގައި އެކަނި ހުންނަ ޕޮޒިޓިވް އަދަދަކަށް ވާންޖެހެއެވެ.",
        "forbidden": "ތިބާގެ ރޯލަށް ސަސްޕެންސް ޕޮޒިޝަންތައް ކިޔޭކަށް ނުކެރޭތީ، ސަސްޕެންސް އެކައުންޓް ހޯދޭކަށް ނެތެވެ. އޭގެ ބަދަލުގައި އެންޓްރީ އަތުން ބެލެންސްކުރައްވާށެވެ.",
        "loadFailed": "ސަސްޕެންސް ޕޮޒިޝަންތައް ލޯޑެއް ނުކުރެވުނެވެ.",
        "retry": "އަލުން މަސައްކަތްކުރޭ",
        "noSuspense": "މި ކުންފުންޏަށް ހަރަކާތްތެރި ސަސްޕެންސް ޕޮޒިޝަނެއް ނެތީތީ، ބެލެންސްކުރާނެ ސަސްޕެންސް އެކައުންޓެއް ނެތެވެ.",
        "openSuspense": "ސަސްޕެންސް ދަށުން އެއް ޤާއިމުކުރައްވާ",
        "position": "ސަސްޕެންސް ޕޮޒިޝަން",
        "positionHint": "މި ކުންފުންޏަށް އެއްއަށްވުރެ ގިނަ ޕޮޒިޝަން ހުރެއެވެ. ތަފާތު ކްލިއަރކުރެވެންދެން ހުންނާނެ ތަން ޚިޔާރުކުރައްވާށެވެ.",
        "positionPlaceholder": "ޕޮޒިޝަނެއް ޚިޔާރުކުރައްވާ",
        "accountById": "އެކައުންޓް #{id}",
        "lineDescription": "ސަސްޕެންސް {position} އަށް އޮޓޯ ބެލެންސް",
        "previewHeading": "އިތުރުކުރާ ލައިން",
        "side": "ފަރާތް",
        "amount": "އަދަދު",
        "after": "ލައިން އިތުރުކުރުމަށްފަހު ޖުމްލަ (ޑެބިޓް އަދި ކްރެޑިޓް):",
        "notSaved": "ލައިން އިތުރުކުރެވެނީ ގްރިޑަށް އެކަނިއެވެ. އެ ބެހެއްޓުމަށް އެންޓްރީ ސޭވްކުރައްވާށެވެ.",
        "confirm": "ލައިން އިތުރުކުރޭ"
      },
      "validate": {
        "split": "ޖާނަލްގައި {header}، ލައިންތަކުގައި {lines}.",
        "linesMarked": "ލައިންތަކާ ބެހޭ ފެނުންތައް އެ ލައިންތަކުގައިވެސް ފާހަގަކުރެވިފައި ވެއެވެ.",
        "linesNotMarked": "ސްކްރީނުގައިވާ ލައިންތައް ޗެކްކުރެވުނު ސޭވްކުރެވިފައިވާ ވަރޝަނާ ތަފާތުވާތީ، ލައިންތަކާ ބެހޭ ފެނުންތައް ގްރިޑުގައި ފާހަގަ ނުކުރެވެއެވެ.",
        "gotoLine": "ލައިން {lineNo} އަށް ދާ"
      }
    },
    "ft6": {
      "routeTitles": {
        "journalRegister": "ޖާނަލް ރަޖިސްޓަރު",
        "manualJournals": "އަތުން ލިޔުނު ޖާނަލްތަކުގެ ތަޙުލީލު",
        "cashFlow": "ކޭޝް ފްލޯ ސްޓޭޓްމަންޓް",
        "journalTemplates": "ޖާނަލް ޓެމްޕްލޭޓްތައް"
      },
      "register": {
        "title": "ޖާނަލް ރަޖިސްޓަރު",
        "description": "ކޮންމެ ޖާނަލެއްގެ ބާވަތް، ތައްޔާރުކުރި މީހާ، އެޕްރޫވްކުރި މީހާ، ހާލަތާއި އަގު. ފިލްޓަރުކޮށް، ފިލްޓަރުތަކުން ހޮވާ ރެކޯޑުތައް ހަމަ އެގޮތަށް އެކްސްޕޯޓް ކުރައްވާ.",
        "filters": {
          "journalType": "ޖާނަލްގެ ބާވަތް",
          "anyType": "ކޮންމެ ބާވަތެއް",
          "typeCodePlaceholder": "ބާވަތުގެ ކޯޑު، މިސާލަކަށް STD",
          "preparer": "ތައްޔާރުކުރި މީހާ",
          "approver": "އެޕްރޫވްކުރި މީހާ",
          "anyone": "ކޮންމެ މީހަކު"
        },
        "columns": {
          "entryNo": "ޖާނަލް",
          "entryDate": "ތާރީޚު",
          "journalType": "ބާވަތް",
          "source": "މަސްދަރު",
          "status": "ހާލަތު",
          "preparer": "ތައްޔާރުކުރި މީހާ",
          "approver": "އެޕްރޫވްކުރި މީހާ",
          "approvedAt": "އެޕްރޫވްކުރި ވަގުތު",
          "value": "އަގު"
        },
        "userById": "ޔޫޒަރު {id}",
        "exportCsv": "CSV އެކްސްޕޯޓް",
        "exportXlsx": "XLSX އެކްސްޕޯޓް",
        "exportDone": "ރަޖިސްޓަރު އެކްސްޕޯޓް ކުރެވިއްޖެ",
        "exportDoneDetail": "{filename} ގެ ނަމުގައި ރައްކާކުރެވިއްޖެ.",
        "exportFailed": "ރަޖިސްޓަރު އެކްސްޕޯޓް ނުކުރެވުނު",
        "exportTooLarge": "އެއް ފައިލަކަށް އެކްސްޕޯޓް ކުރެވޭވަރަށް ވުރެ ގިނަ ޖާނަލްތަކެއް ފިލްޓަރުތަކާ ދިމާވޭ. ތާރީޚުގެ މުއްދަތު ނުވަތަ ފިލްޓަރުތައް ކުޑަކޮށް، އަލުން އެކްސްޕޯޓް ކުރައްވާ.",
        "emptyTitle": "ދިމާވާ ޖާނަލެއް ނެތް",
        "emptyDescription": "ތާރީޚުގެ މުއްދަތު ބޮޑުކުރައްވާ ނުވަތަ ފިލްޓަރެއް ފޮހެލައްވާ. ޖާނަލެއް ރައްކާކުރެވުނު ވަގުތުން މިތާ ފެންނާނެ.",
        "loadFailed": "ޖާނަލް ރަޖިސްޓަރު ލޯޑް ނުވި"
      },
      "manual": {
        "title": "އަތުން ލިޔުނު ޖާނަލްތަކުގެ ތަޙުލީލު",
        "description": "އަތުން ލިޔުނު ޖާނަލްތައް ކިހާވަރެއް، ލިޔުނީ ކާކު، ނުވަތަ ކޮން އެކައުންޓްތަކަށް، އަދި ހުރިހާ ޖާނަލްތަކުގެ ތެރެއިން ހިއްސާ. ހިއްސާ އިތުރުވުމަކީ ކޮންޓްރޯލްގެ ސިގްނަލެކެވެ.",
        "groupBy": "ގުރޫޕްކުރާނީ",
        "groupByPreparer": "ތައްޔާރުކުރި މީހާ",
        "groupByAccount": "އެކައުންޓް",
        "summary": {
          "entries": "އަތުން ލިޔުނު ޖާނަލްތައް",
          "lines": "އަތުން ލިޔުނު ލައިންތައް",
          "value": "އަތުން ލިޔުނު އަގު",
          "reversed": "ރިވާސްކުރެވުނު",
          "share": "ހުރިހާ ޖާނަލްތަކުގެ ތެރެއިން ހިއްސާ"
        },
        "shareOf": "{all} ޖާނަލްގެ ތެރެއިން {share}%",
        "columns": {
          "preparer": "ތައްޔާރުކުރި މީހާ",
          "account": "އެކައުންޓް",
          "entries": "ޖާނަލްތައް",
          "lines": "ލައިންތައް",
          "totalDebit": "ޑެބިޓް ({currency})",
          "totalCredit": "ކްރެޑިޓް ({currency})",
          "average": "ޖާނަލެއްގެ އެވަރެޖް",
          "reversed": "ރިވާސްކުރެވުނު",
          "share": "އަގުގެ ހިއްސާ"
        },
        "valueNote": "އަގުތައް ވަނީ ކުންފުނީގެ ބޭސް ފައިސާ، {currency} އިން.",
        "emptyTitle": "މި މުއްދަތުގައި އަތުން ލިޔުނު ޖާނަލެއް ނެތް.",
        "emptyDescription": "މި މުއްދަތުގެ ހުރިހާ ޖާނަލެއް އައީ ސަބް ލެޖަރަކުން، ޓެމްޕްލޭޓަކުން ނުވަތަ އެލޮކޭޝަނަކުން. އަޅާކިޔުމަށް ތާރީޚުތައް ބޮޑުކުރައްވާ.",
        "loadFailed": "ތަޙުލީލު ލޯޑް ނުވި"
      },
      "cashFlow": {
        "title": "ކޭޝް ފްލޯ ސްޓޭޓްމަންޓް",
        "description": "އިންޑައިރެކްޓް ގޮތް: ފައިސާ ނޫން ކަންކަމާއި ވޯކިންގ ކެޕިޓަލަށް ބަދަލުގެނެވުނު ނެޓް ފައިދާ، ދެން އިންވެސްޓިންގ އާއި ފައިނޭންސިންގ، ކޭޝްގެ ބަދަލާ ދިމާކުރެވިފައި.",
        "tabs": {
          "statement": "ސްޓޭޓްމަންޓް",
          "mapping": "އެކައުންޓް މެޕިންގ"
        },
        "compare": {
          "label": "އަޅާކިޔުން",
          "none": "އަޅާކިޔުމެއް ނެތް",
          "priorPeriod": "ކުރީގެ މުއްދަތު",
          "priorYear": "ކުރީގެ އަހަރު",
          "custom": "ހޮވާ ތާރީޚުތައް",
          "from": "އަޅާކިޔަނީ މި ތާރީޚުން",
          "thru": "އަޅާކިޔަނީ މި ތާރީޚާ ހަމައަށް"
        },
        "columns": {
          "line": "ލައިން",
          "amount": "އަދަދު ({currency})",
          "comparative": "އަޅާކިޔުން"
        },
        "sections": {
          "operating": "އޮޕަރޭޓިންގ ހަރަކާތްތައް",
          "investing": "އިންވެސްޓިންގ ހަރަކާތްތައް",
          "financing": "ފައިނޭންސިންގ ހަރަކާތްތައް"
        },
        "groups": {
          "adjustment": "ފައިސާ ނޫން ކަންކަމަށް ގެނެވުނު ބަދަލު",
          "working_capital": "ވޯކިންގ ކެޕިޓަލްގެ ބަދަލު"
        },
        "categories": {
          "operating": "އޮޕަރޭޓިންގ",
          "investing": "އިންވެސްޓިންގ",
          "financing": "ފައިނޭންސިންގ",
          "cash": "ކޭޝް",
          "non_cash": "ފައިސާ ނޫން"
        },
        "sectionTotal": "{section} އިން ލިބުނު ނެޓް ކޭޝް",
        "netChange": "ކޭޝްގެ ނެޓް ބަދަލު",
        "openingCash": "ފެށުނު ކޭޝް",
        "closingCash": "ނިމުނު ކޭޝް",
        "cashMovement": "ކޭޝް އެކައުންޓްތަކުގެ ބަދަލު",
        "reconciles": "ސްޓޭޓްމަންޓް ކޭޝް އެކައުންޓްތަކުގެ ބަދަލާ ދިމާވޭ.",
        "doesNotReconcile": "ސްޓޭޓްމަންޓް ކޭޝް އެކައުންޓްތަކުގެ ބަދަލާ ދިމާނުވޭ. އެކައުންޓް މެޕިންގ ބައްލަވާ.",
        "differenceLabel": "ތަފާތު:",
        "compareDoesNotReconcile": "އަޅާކިޔާ ކޮލަމް، އޭގެ މުއްދަތުގެ ކޭޝް އެކައުންޓްތަކުގެ ބަދަލާ ދިމާނުވޭ.",
        "unmappedTitle": "ކޭޝް ފްލޯ މެޕިންގ ނެތް އެކައުންޓްތައް: {count}",
        "unmappedBody": "މި އެކައުންޓްތަކުގައި މި މުއްދަތުގައި ބަދަލު އައި، އަދި ޑިފޯލްޓް ބައިގައި ބެހެއްޓުނު. ބޭނުންވާ ތަނުގައި ފެންނާނޭ ގޮތަށް މެޕް ކުރައްވާ.",
        "unmappedColumns": {
          "account": "އެކައުންޓް",
          "defaultCategory": "ބޭނުންކުރެވުނު ޑިފޯލްޓް",
          "movement": "ބަދަލު"
        },
        "openMapping": "މި އެކައުންޓްތައް މެޕް ކުރައްވާ",
        "convention": "{from} އިން {to} އަށް، {currency} އިން. ޕޮޒިޓިވް އަދަދުތަކުން ކޭޝް އިތުރުވޭ؛ ނެގެޓިވް އަދަދުތަކުން ކޭޝް ބޭނުންވޭ.",
        "loadFailed": "ކޭޝް ފްލޯ ސްޓޭޓްމަންޓް ލޯޑް ނުވި",
        "mapping": {
          "description": "ކޮންމެ އެކައުންޓެއްގެ ބަދަލު ފެންނާނެ ބައި ހޮއްވަވާ. މެޕް ނުކުރެވޭ އެކައުންޓްތަކަށް ޑިފޯލްޓް ބޭނުންކުރެވޭ.",
          "columns": {
            "account": "އެކައުންޓް",
            "category": "ބައި",
            "lineCode": "ލައިން ކޯޑު",
            "source": "މެޕިންގ"
          },
          "categoryAria": "{code} ގެ ކޭޝް ފްލޯ ބައި",
          "lineCodeAria": "{code} ގެ ލައިން ކޯޑު",
          "lineCodePlaceholder": "އިޚްތިޔާރީ",
          "sourceExplicit": "މެޕްކުރެވިފައި",
          "sourceDefault": "ޑިފޯލްޓް",
          "save": "ރައްކާކުރޭ",
          "saved": "މެޕިންގ ރައްކާކުރެވިއްޖެ",
          "savedDetail": "{code} މިހާރު މެޕްވެފައިވަނީ {category} އަށް.",
          "saveFailed": "މެޕިންގ ރައްކާ ނުކުރެވުނު",
          "stale": "މި ލިސްޓު ލޯޑުވުމަށްފަހު {code} ގެ މެޕިންގ އެހެން މީހަކު ބަދަލުކޮށްފި. މިހާރުގެ މެޕިންގ ދައްކާފައި. ތިޔަ ބަދަލު އަލުން ގެންނަވާ.",
          "loadFailed": "އެކައުންޓް މެޕިންގ ލޯޑް ނުވި",
          "emptyTitle": "ޕޯސްޓް ކުރެވޭ އެކައުންޓެއް ނެތް.",
          "emptyDescription": "ޗާޓް އޮފް އެކައުންޓްސްއަށް ޕޯސްޓް ކުރެވޭ އެކައުންޓްތައް އިތުރުކޮށް، މިތާ މެޕް ކުރައްވާ."
        }
      },
      "templates": {
        "title": "ޖާނަލް ޓެމްޕްލޭޓްތައް",
        "description": "ރައްކާކުރެވިފައިވާ ޖާނަލްތައް. ރިކަރިންގ ޓެމްޕްލޭޓަކުން އޭގެ ޝެޑިއުލްގައި ޖާނަލެއް އުފައްދާ. އޮން ޑިމާންޑް ޓެމްޕްލޭޓެއް ޕޯސްޓްވަނީ ރަން ކުރައްވާއިރު އެކަނި. އާ ޖާނަލެއްގައި ޓެމްޕްލޭޓުން ގެ ފަރާތުން ބޭނުން ކުރެވޭނެ."
      },
      "entry": {
        "fromTemplate": {
          "action": "ޓެމްޕްލޭޓުން",
          "hint": "ރައްކާކުރެވިފައިވާ ޓެމްޕްލޭޓެއްގެ ލައިންތައް އިތުރުކުރޭ، އަދަދުތައް ހުސްކޮށް.",
          "title": "ޓެމްޕްލޭޓަކުން ލައިންތައް އިތުރުކުރުން",
          "description": "ޓެމްޕްލޭޓުގެ އެކައުންޓްތަކާއި ތަފްޞީލާއި ޑައިމެންޝަންތައް މި ޖާނަލަށް އިތުރުކުރެވޭނެ. ޖާނަލް ރައްކާ ކުރައްވަންދެން އެއްވެސް ކަމެއް ރައްކާނުކުރެވޭ.",
          "template": "ޓެމްޕްލޭޓް",
          "templatePlaceholder": "ޓެމްޕްލޭޓެއް ހޮއްވަވާ",
          "noTemplates": "މި ކުންފުނީގައި އެކްޓިވް ޓެމްޕްލޭޓެއް ނެތް. ލައިންތައް އަލުން ބޭނުންކުރުމަށް ޖާނަލެއް ޓެމްޕްލޭޓެއްގެ ގޮތުގައި ރައްކާ ކުރައްވާ.",
          "openTemplates": "ޖާނަލް ޓެމްޕްލޭޓްތައް ހުޅުވާ",
          "currencyDiffers": "މި ޓެމްޕްލޭޓް ރައްކާކުރެވިފައިވަނީ {templateCurrency} އިން. މި ޖާނަލް ވަނީ {currency} އިން، އަދި ލައިންތައް އިތުރުކުރެވޭނީ {currency} އިން.",
          "amountsBlank": "އަދަދުތައް ވަނީ ހުސްކޮށް. ރައްކާ ކުރެއްވުމުގެ ކުރިން ލިޔުއްވާ.",
          "confirm": "ލައިންތައް އިތުރުކުރޭ",
          "loadFailed": "ޓެމްޕްލޭޓްތައް ލޯޑް ނުވި",
          "loadTemplateFailed": "އެ ޓެމްޕްލޭޓް ލޯޑް ނުވި.",
          "applied": "{code} އިން ލައިންތައް އިތުރުކުރެވިއްޖެ",
          "appliedDetail": "އަދަދުތައް ލިޔުއްވައި، ރައްކާ ކުރައްވާ."
        },
        "saveTemplate": {
          "action": "ޓެމްޕްލޭޓެއްގެ ގޮތުގައި ރައްކާކުރޭ",
          "hint": "މި ޖާނަލްގެ ލައިންތައް އޮން ޑިމާންޑް ޓެމްޕްލޭޓެއްގެ ގޮތުގައި ރައްކާކުރޭ.",
          "recurringAction": "ރިކަރިންގ ކުރޭ",
          "recurringHint": "މި ޖާނަލްގެ ލައިންތައް ޝެޑިއުލްއެއްގައި ޖާނަލް އުފައްދާ ޓެމްޕްލޭޓެއްގެ ގޮތުގައި ރައްކާކުރޭ.",
          "titleTemplate": "ޓެމްޕްލޭޓެއްގެ ގޮތުގައި ރައްކާކުރުން",
          "titleRecurring": "ރިކަރިންގ ކުރުން",
          "descriptionTemplate": "މި ޖާނަލްގެ ލައިންތަކާއި ޑައިމެންޝަންތައް ޓެމްޕްލޭޓެއްގެ ގޮތުގައި ރައްކާކުރޭ.",
          "descriptionRecurring": "މި ޖާނަލްގެ ލައިންތަކާއި ޑައިމެންޝަންތައް، ފެށޭ ތާރީޚުން ނިމޭ ތާރީޚާ ހަމައަށް ކޮންމެ މުއްދަތަކަށް ޖާނަލެއް އުފައްދާ ޓެމްޕްލޭޓެއްގެ ގޮތުގައި ރައްކާކުރޭ.",
          "onDemandNote": "މި ޓެމްޕްލޭޓަކީ އޮން ޑިމާންޑް ޓެމްޕްލޭޓެއް: އެއްވެސް މީހަކު ރަން ކުރަންދެން އެއްވެސް ކަމެއް ޕޯސްޓެއް ނުކުރެވޭ.",
          "savedVersion": "މި ޖާނަލްގައި ރައްކާނުކުރެވޭ ބަދަލުތައް ހުރި. ޓެމްޕްލޭޓް ހެދެނީ ރައްކާކުރެވިފައިވާ ވަރޝަނުން.",
          "name": "ނަން",
          "code": "ކޯޑު",
          "codeHint": "އިޚްތިޔާރީ. ހުސްކޮށް ބާއްވައިފިނަމަ، ކޯޑު ހެދޭނީ މި ޖާނަލްގެ ނަންބަރުން.",
          "frequency": "ފްރީކުއެންސީ",
          "startOn": "ފެށުން",
          "startOnHint": "ޖާނަލެއް އުފައްދާ ފުރަތަމަ މުއްދަތު.",
          "endOn": "ނިމުން",
          "endOnHint": "އިޚްތިޔާރީ. ހުސްކޮށް ބާއްވައިފިނަމަ، ހުއްޓުވަންދެން ކުރިއަށް ދާނެ.",
          "confirm": "ޓެމްޕްލޭޓް ރައްކާކުރޭ",
          "confirmRecurring": "ރިކަރިންގ ކުރޭ",
          "saved": "ޓެމްޕްލޭޓް ރައްކާކުރެވިއްޖެ",
          "savedDetail": "{code} ވަނީ ޖާނަލް ޓެމްޕްލޭޓްތަކުގައި."
        },
        "importLines": {
          "action": "ލައިންތައް އިމްޕޯޓް ކުރޭ",
          "hint": "CSV ފައިލަކުން މި ޑްރާފްޓަށް ލައިންތައް އިތުރުކުރޭ.",
          "saveFirst": "ފުރަތަމަ ތިޔަ ބަދަލުތައް ރައްކާ ކުރައްވާ. އިމްޕޯޓް ކުރެވޭ ލައިންތައް އިތުރުވަނީ މި ޖާނަލްގެ ރައްކާކުރެވިފައިވާ ވަރޝަނަށް.",
          "title": "ފައިލަކުން ލައިންތައް އިމްޕޯޓް ކުރުން",
          "description": "CSV ފައިލެއްގައިވާ ލައިންތައް މި ޑްރާފްޓް ޖާނަލްގެ ފަހަތަށް އިތުރުކުރޭ.",
          "rowByRow": "ރަނގަޅު ކޮންމެ ރޯއެއް އިމްޕޯޓް ކުރެވޭނެ. މައްސަލައެއް ހުރި ރޯއެއް ދޫކޮށްލައި ލިސްޓުކުރެވޭނެތީ، ފަހުން ރަނގަޅުކުރި ރޯތައް އެކަނި އިމްޕޯޓް ކުރެވޭނެ. ހެޑަރ ރޯ ރަނގަޅު ނޫންނަމަ ނުވަތަ ފައިލުގައި ވަރަށް ގިނަ ރޯތައް ހުރިނަމަ، އެއްވެސް ލައިނެއް އިމްޕޯޓް ނުކުރެވޭނެ.",
          "fileLabel": "CSV ފައިލު",
          "fileHint": "accountCode ނުވަތަ accountId، އަދި debit ނުވަތަ credit ހިމެނޭ ހެޑަރ ރޯއެއް ބޭނުންވޭ. އިޚްތިޔާރީ ކޮލަމްތައް: description، taxCode، costCenterId، profitCenterId، branchId، departmentId، businessUnitId، projectId.",
          "upload": "އިމްޕޯޓް ކުރޭ",
          "uploading": "އިމްޕޯޓް ކުރަނީ",
          "notDraft": "ލައިންތައް އިމްޕޯޓް ކުރެވޭނީ ޑްރާފްޓް ޖާނަލަކަށް އެކަނި. ފުރަތަމަ ޖާނަލް ޑްރާފްޓަށް އަނބުރާ ގެންނަވާ.",
          "refusedTitle": "އެއްވެސް ލައިނެއް އިމްޕޯޓް ނުކުރެވުނު",
          "refusedLead": "ފައިލުގައި މައްސަލަ {count} ހުރި. އެ ރަނގަޅުކޮށް ފައިލު އަލުން އިމްޕޯޓް ކުރައްވާ. ޖާނަލް ބަދަލެއް ނުވޭ.",
          "partialTitle": "އިމްޕޯޓް ނުކުރެވުނު ރޯތައް: {count}",
          "partialLead": "މި ރޯތައް ދޫކޮށްލެވުނު. އެހެން ރޯތައް މިހާރުވެސް ޖާނަލުގައި ހުރުމުން، ރަނގަޅުކުރި ރޯތައް އެކަނި އިމްޕޯޓް ކުރައްވާ. މުޅި ފައިލު އަލުން އިމްޕޯޓް ކުރައްވައިފިނަމަ އެ ލައިންތައް ދެ ފަހަރު އިތުރުވާނެ.",
          "errorsCaption": "ފައިލުގައިވާ މައްސަލަތައް",
          "columns": {
            "row": "ރޯ",
            "field": "ކޮލަމް",
            "problem": "މައްސަލަ"
          },
          "codes": {
            "malformed": "ރޯ CSV ގެ ގޮތުގައި ކިޔޭކަށް ނެތް.",
            "missing_column": "ހެޑަރ ރޯގައި ބޭނުންވާ ކޮލަމެއް ނެތް.",
            "required": "އަގެއް ބޭނުންވޭ.",
            "numeric": "ނަންބަރެއް ނޫން.",
            "scale": "ދެ ޑެސިމަލް ތަނަށް ވުރެ ގިނަ.",
            "negative": "އަދަދުތައް ނެގެޓިވް ނުވާނެ.",
            "debit_xor_credit": "ޑެބިޓެއް ނުވަތަ ކްރެޑިޓެއް ލިޔުއްވާ، ދެކަމެއް ވެސް ނޫން، އަދި ހުސްކޮށް ވެސް ނޫން.",
            "max": "ވަރަށް ދިގު.",
            "too_many_rows": "ފައިލުގައި ވަރަށް ގިނަ ރޯތައް ހުރި. ބައިބައިކޮށް ކޮންމެ ބައެއް ވަކިން އިމްޕޯޓް ކުރައްވާ.",
            "empty": "ފައިލުގައި ޑޭޓާ ރޯއެއް ނެތް.",
            "unknown_account": "މި ކުންފުނީގައި މި ކޯޑުގެ އެކައުންޓެއް ނެތް.",
            "wrong_company": "އެކައުންޓް ނިސްބަތްވަނީ އެހެން ކުންފުންޏަކަށް.",
            "inactive_account": "އެކައުންޓް އިނެކްޓިވް.",
            "not_postable": "އެކައުންޓަށް ޕޯސްޓިންގ ނުބަލައިގަނޭ.",
            "unknown_dimension": "މި ކުންފުނީގައި މި ނަންބަރުގެ ޑައިމެންޝަނެއް ނެތް.",
            "policy": "އެކައުންޓްގެ ޑައިމެންޝަން ގަވާއިދުތައް ފުރިހަމަ ނުވޭ.",
            "forbidden": "މި އެކައުންޓުގައި މި ޑައިމެންޝަން ހުއްދަ ނުވޭ."
          },
          "doneTitle": "އިމްޕޯޓް ކުރެވުނު ލައިންތައް: {count}",
          "doneLead": "ލައިންތައް މި ޖާނަލަށް އިތުރުކުރެވިއްޖެ."
        }
      }
    },
    "ft7": {
      "entry": {
        "reversedThroughSource": "ރިވާސްކުރެވެނީ އޭގެ ސޯސް ޑޮކިއުމަންޓުންނެވެ"
      }
    },
    "assertion": {
      "failed": "ޕޯސްޓިންގ ފުރިހަމަކަން ބެލުން ފެއިލްވެއްޖެ: ލެޖަރު އެ މަސްދަރާ ދިމާނުވޭ."
    },
    "accrual": {
      "reversal_due": "އެކްރޫއަލެއް ރިވާސްކުރަންޖެހިފައި ވޭ.",
      "aged": "އެކްރޫއަލެއް ހުއްދަ ދެވިފައިވާ މުއްދަތަށްވުރެ ގިނައިން ހުޅުވިފައި ވޭ."
    },
    "journal": {
      "auto_reversal_blocked": "އޮޓޯ ރިވާސަލް ޕޯސްޓްކުރެވެން ނެތް."
    }
  },
  "ap": {
    "vendors": {
      "title": "ސަޕްލަޔަރުން",
      "description": "Everyone business ދަރާފައި ފައިސާ އަށް, އަދި ޝަރުތުތައް އެ ދަރާފައި އެ މަތީގައި.",
      "oneTitle": "ސަޕްލަޔަރު",
      "oneDescription": "ޕްރޮފައިލް, ބޭންކް ތަފްޞީލުތައް, ލިޔުންތައް އަދި ލެޖަރ ފަހަތުގައި އެފަރާތްތަކަށް.",
      "tableLabel": "ސަޕްލަޔަރުން",
      "loadFailed": "ސަޕްލަޔަރު ލިސްޓް ނުކުރެވުނު ނޫން ލޯޑް",
      "oneLoadFailed": "މި ސަޕްލަޔަރު ނުކުރެވުނު ނޫން ލޯޑް",
      "notFound": "މި ސަޕްލަޔަރު ނެތް longer އެބައޮތް, ނުވަތަ ތިޔަ ހުއްދަ ނޫން ބަލާ އެ.",
      "newVendor": "އައު ސަޕްލަޔަރު",
      "createFirst": "އިތުރުކުރޭ ފުރަތަމަ ސަޕްލަޔަރު",
      "backToList": "ފަހަތަށް އަށް ސަޕްލަޔަރުން",
      "emptyTitle": "ނެތް ސަޕްލަޔަރުން އަދި",
      "emptyDescription": "އިތުރުކުރޭ އެއް މިތާ, އަދި ބިލްތައް, ފައިސާ ދެއްކުން ރަންތައް އަދި އޭޕީ އުމުރު ހުރިހާ ފަށާ އިން އެ.",
      "searchPlaceholder": "ކޯޑް, ނަން ނުވަތަ ޤާނޫނީ ނަން",
      "searchLabel": "ހޯދާ ސަޕްލަޔަރުން",
      "filterByStatus": "ސްޓޭޓަސް އިން ފިލްޓަރކުރޭ",
      "termsDays": "{days} ދުވަސް",
      "discountTerms": "{percent}% ތެރޭގައި {days} ދުވަސް",
      "delete": "ފޮހެލާ މި ސަޕްލަޔަރު",
      "deleteHint": "ހަމައެކަނި ވެދާނެ ދަނޑިވަޅުގައި އެ އެބަހުރި ނެތް ލިޔުންތައް. ސަޕްލަޔަރު އާއެކު ތާރީޚް އީ ބްލޮކްކުރެވިފައި ބަދަލުގައި.",
      "deleted": "ސަޕްލަޔަރު ފޮހެލެވިފައި",
      "deleteFailed": "މި ސަޕްލަޔަރު could ނޫން ވުން ފޮހެލެވިފައި",
      "statuses": {
        "active": "ހަރަކާތްތެރި",
        "blocked": "ބްލޮކްކުރެވިފައި"
      },
      "columns": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "currency": "ފައިސާގެ ބާވަތް",
        "terms": "ޝަރުތުތައް",
        "taxRegistrationNo": "ޓެކްސް ރަޖިސްޓްރީ"
      },
      "fields": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "legalName": "ޤާނޫނީ ނަން",
        "defaultCurrency": "Default ފައިސާގެ ބާވަތް",
        "paymentTerms": "ފައިސާ ދެއްކުން ޝަރުތުތައް",
        "discountPercent": "ސެޓްލްމަންޓް ޑިސްކައުންޓް",
        "discountDays": "ޑިސްކައުންޓް ދުވަސް",
        "taxGroup": "ޓެކްސް ގްރޫޕް",
        "whtTaxCode": "ހިފެހެއްޓޭ ޓެކްސް ޓެކްސް ކޯޑް",
        "taxRegistrationNo": "ޓެކްސް ރަޖިސްޓްރީ ނަންބަރު",
        "email": "އީމެއިލް",
        "phone": "ފޯނު",
        "address": "އެޑްރެސް",
        "notes": "ނޯޓްތައް"
      },
      "tabs": {
        "profile": "ޕްރޮފައިލް",
        "bank": "ބޭންކް އެކައުންޓްތައް",
        "documents": "ލިޔުންތައް",
        "ledger": "ލެޖަރ އަދި ސްޓޭޓްމަންޓް"
      },
      "tabsLabel": "ސަޕްލަޔަރު sections",
      "rail": {
        "created": "ސަޕްލަޔަރު އިތުރުކުރެވިއްޖެ",
        "subtitle": "{status} · ދައްކާ ގައި {currency}",
        "documentsLink": "ލިޔުންތައް އިން މި ސަޕްލަޔަރު"
      },
      "form": {
        "createTitle": "އައު ސަޕްލަޔަރު",
        "editTitle": "އެޑިޓްކުރޭ ސަޕްލަޔަރު",
        "description": "ބޭންކް ތަފްޞީލުތައް އީ އިތުރުކުރެވިއްޖެ ވަކިން, އަދި ބޭނުންވޭ ދެވަނަ ފަރާތްގެ ފާސްކުރުން.",
        "create": "އުފައްދާ ސަޕްލަޔަރު",
        "created": "ސަޕްލަޔަރު އުފެއްދިއްޖެ",
        "updated": "ސަޕްލަޔަރު އަޕްޑޭޓްކުރެވިއްޖެ",
        "codeHint": "Short, permanent, އަދި ކިހިނެއް ފަރާތްތައް ވާނެ ބަލާ މި ސަޕްލަޔަރު މައްޗަށް.",
        "codeRequired": "ސަޕްލަޔަރު ބޭނުންވޭ ކޯޑް.",
        "nameRequired": "ސަޕްލަޔަރު ބޭނުންވޭ ނަން.",
        "currencyHint": "ފައިސާގެ ބާވަތް އޭގެ އިންވޮއިސްތައް normally arrive ގައި.",
        "currencyInvalid": "ބޭނުންކުރޭ ތިން-އަކުރު ISO 4217 ކޯޑް, ފަދަ ގޮތުގައި MVR.",
        "paymentTermsHint": "ދުވަސް އިން އިންވޮއިސް ތާރީޚް އަށް މުއްދަތު ތާރީޚް.",
        "discountHint": "Percentage ކަނޑާލާ އަށްޓަކައި ސެޓްލްކުރުން ތެރޭގައި ޑިސްކައުންޓް ދުވަސް.",
        "whtHint": "ބޭނުންކުރެވިފައި މަތީގައި މި ސަޕްލަޔަރުގެ އިންވޮއިސްތައް, އަދި ހިފެހެއްޓި ވަގުތު އެފަރާތްތައް އީ ދައްކާފައި.",
        "noTaxGroup": "ނެތް ޓެކްސް ގްރޫޕް",
        "noWht": "ނެތް ހިފެހެއްޓޭ ޓެކްސް",
        "statusHint": "Blocking ހުއްޓުވާ އައު ލިޔުންތައް. ޕޯސްޓްކުރެވިފައި ones އީ untouched.",
        "stale": "އެހެން ފަރާތެއް އެހެން ރައްކާކުރެވިއްޖެ މި ސަޕްލަޔަރު ދަނޑިވަޅުގައި އެ ވި ހުޅުވާ. ބަންދުކުރޭ މި, reopen އެ, އަދި ހަދާ ބަދަލު އަލުން.",
        "bankElsewhere": "ބޭންކް ތަފްޞީލުތައް live މަތީގައި ސަޕްލަޔަރުގެ އަމިއްލަ ސްކްރީން: adding ނުވަތަ changing އެއް އީ އެދުން އެ ދެވަނަ ފަރާތް އެބަހުރި އަށް ފާސްކުރޭ."
      },
      "export": {
        "done": "އެކްސްޕޯޓް ތައްޔާރު",
        "doneDetail": "{count} ސަޕްލަޔަރުން ވި ލިޔެފައި އަށް ފައިލް.",
        "failed": "އެކްސްޕޯޓް ނުކުރެވުނު ނޫން ނިންމާ"
      },
      "views": {
        "label": "ރައްކާކުރި ވިއުތައް",
        "trigger": "ވިއުތައް",
        "empty": "ނެތް ރައްކާކުރެވިއްޖެ ވިއުތައް އަދި. ފިލްޓަރ ލިސްޓް, އެއަށްފަހު ނަން ކޮން ތިޔަ ބަލާ.",
        "saved": "ވިއު ރައްކާކުރެވިއްޖެ",
        "namePlaceholder": "މި ވިއު އަށް ނަމެއް ދޭ",
        "nameLabel": "ވިއު ނަން",
        "delete": "ފޮހެލާ ވިއު {name}"
      }
    },
    "bank": {
      "title": "ބޭންކް އެކައުންޓްތައް",
      "description": "ކޮންތާކު މި ސަޕްލަޔަރު އީ ދައްކާފައި. ނަންބަރުތައް އީ ފޮރުވިފައި, އަދި ކޮންމެ ބަދަލު ބޭނުންވޭ ދެ ފަރާތްތައް.",
      "loadFailed": "ބޭންކް އެކައުންޓްތައް ނުކުރެވުނު ނޫން ލޯޑް",
      "noPermission": "ތިޔަ ހުއްދަ ނޫން ބަލާ މި ސަޕްލަޔަރުގެ ބޭންކް ތަފްޞީލުތައް.",
      "maskedExplainer": "އެކައުންޓް ނަންބަރުތައް އީ ދައްކާފައި ފޮރުވިފައި. ދައްކަނީ އެއް ގައި ފުރިހަމަ އީ ވަކި ޢަމަލު, އަދި އެ އީ ރެކޯޑްކުރެވިފައި އާ ދެކޮޅަށް ތިޔަ ނަން.",
      "emptyTitle": "ނެތް ބޭންކް އެކައުންޓް މަތީގައި ފައިލް",
      "emptyDescription": "އެދުން އެއް މިތާ. އެ ފަށާ ފައިސާ ދައްކަނީ ހަމައެކަނި އެއްފަހަރު އެހެން ފަރާތެއް އެހެން އެބަހުރި ފާސްކުރެވިއްޖެ އެ.",
      "primary": "މައިގަނޑު",
      "inactive": "ބޭނުންކުރުމުން ހުއްޓާލާފައި",
      "fields": {
        "label": "ލޭބަލް",
        "bankName": "ބޭންކް",
        "branch": "ބްރާންޗް",
        "accountName": "އެކައުންޓް ނަން",
        "accountNo": "އެކައުންޓް ނަންބަރު",
        "iban": "IBAN",
        "swift": "SWIFT / BIC",
        "currency": "ފައިސާގެ ބާވަތް"
      },
      "actions": {
        "reveal": "ދައްކާ ނަންބަރު",
        "requestNew": "އެދުން އައު އެކައުންޓް",
        "requestChange": "އެދުން ބަދަލު",
        "requestRetire": "އެދުން ހުއްޓާލުން",
        "allChanges": "ހުރިހާ ބޭންކް-ތަފްޞީލު ބަދަލުތައް"
      },
      "pending": {
        "headline": "ބަދަލު އަށް މި ތަފްޞީލުތައް އީ މަޑުކުރަނީ ފާސްކުރުން.",
        "explainer": "އެއްވެސް އެއްޗެއް އެބަހުރި ބަދަލުވެފައި އަދި: ފައިސާ ދެއްކުންތައް އަދިވެސް ދޭ އަށް ތަފްޞީލުތައް ދައްކާފައި ތިރީގައި ވަންދެން އެހެން ފަރާތެއް އެހެން ވުރެ އެދުނު ފަރާތް ފާސްކުރޭ އެ.",
        "requested": "އެދިފައި: {action} — {bank}, {masked}"
      },
      "pendingAdditions": {
        "title": "އެދިފައި އެކައުންޓްތައް",
        "explainer": "މި އެކައުންޓް ކުރޭ ނޫން އޮތުން އަދި އަދި އެއްވެސް އެއްޗެއް އީ ދައްކާފައި ތެރެއަށް އެ. އެ އީ މަޑުކުރަނީ އަށްޓަކައި ދެވަނަ ފަރާތް އަށް ފާސްކުރޭ އެ."
      },
      "changeStatuses": {
        "pending": "މަޑުކުރަނީ ފާސްކުރުން",
        "applied": "ބޭނުންކުރެވިފައި",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "cancelled": "ކެންސަލްކުރެވިފައި",
        "approved": "ހުއްދަ ދެވިފައި، ކޫލިންގ-އޯފްގައި"
      },
      "changeActions": {
        "create": "އިތުރުކުރޭ އެކައުންޓް",
        "update": "ބަދަލު ތަފްޞީލުތައް",
        "deactivate": "retire އެކައުންޓް"
      },
      "stepUp": {
        "required": "ޔަޤީންކުރޭ ތިޔަ ދެވަނަ ފެކްޓަރ އަލުން ކުރިން މި އީ allowed, އެއަށްފަހު try އެއްފަހަރު އިތުރު.",
        "notEnrolled": "މި ޢަމަލު ބޭނުންވޭ ދެ-ފެކްޓަރ authentication, އަދި ތިޔަ އެކައުންޓް އެބަހުރި އެއްވެސް އެއްޗެއް ނެތް enrolled އަދި.",
        "link": "Set އެ މައްޗަށް ގައި ތިޔަ ޕްރޮފައިލް"
      },
      "form": {
        "createTitle": "އެދުން އައު ބޭންކް އެކައުންޓް",
        "updateTitle": "އެދުން ބަދަލު އަށް މި ބޭންކް ތަފްޞީލުތައް",
        "subject": "އަށްޓަކައި {vendor}",
        "submit": "ފޮނުވާ އެދުން އަށްޓަކައި ފާސްކުރުން",
        "working": "ފޮނުވަނީ އެދުން",
        "dualApproval": "މި އުފައްދާ އެދުން, ނޫން ބޭންކް އެކައުންޓް. އެއްވެސް އެއްޗެއް ބެހޭގޮތުން ކޮންތާކު މި ސަޕްލަޔަރު އީ ދައްކާފައި ބަދަލުތައް ވަންދެން އެހެން ފަރާތެއް އެހެން ވުރެ ތިޔަ ފާސްކުރޭ އެ.",
        "labelHint": "ކިހިނެއް ފަރާތްތައް ވާނެ recognise މި އެކައުންޓް, e.g. \"BML މިހާރު\".",
        "bankNameRequired": "ނަން ބޭންކް.",
        "accountNameHint": "ނަން ބޭންކް holds އެކައުންޓް ދަށުގައި, ސްޕެލްކުރެވިފައި ގޮތުގައި ބޭންކް ސްޕެލްކުރޭ އެ.",
        "accountNameRequired": "ނަން އެކައުންޓް holder.",
        "accountNoHint": "ޓައިޕްކުރި އެއްފަހަރު މިތާ, encrypted ވަގުތުން, އަދި ފޮރުވިފައި everywhere އޭގެފަހުން.",
        "accountNoRetype": "ޓައިޕްކުރޭ އެކައުންޓް ނަންބަރު އަލުން ގައި ފުރިހަމަ. އެކުވެރިޔާ އީ ނެތް ރައްކާކުރެވިފައި plaintext އަށް prefill, އަދި retyping އެ އީ ކޮން ހަދާ ބަދަލު deliberate.",
        "accountNoRequired": "އެކައުންޓް ނަންބަރު އީ ލާޒިމު.",
        "currencyInvalid": "ބޭނުންކުރޭ ތިން-އަކުރު ISO 4217 ކޯޑް, ފަދަ ގޮތުގައި MVR.",
        "primary": "ހަދާ މި އެކައުންޓް މި ސަޕްލަޔަރު އީ ދައްކާފައި ތެރެއަށް",
        "primaryHint": "ފައިސާ ދެއްކުން ރަންތައް ބޭނުންކުރޭ މައިގަނޑު އެކައުންޓް unless އެއް އީ އިޚްތިޔާރުކުރެވިފައި އަށްޓަކައި އެފަރާތްތަކަށް.",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "ބުނޭ ކާކު އެދިފައި އަށްޓަކައި މި އަދި ކިހިނެއް ތިޔަ ޔަޤީންކުރެވިފައި އެ. ފާސްކުރާ ފަރާތް ކިޔާ މި, އަދި އެހެންކަމުން ވާނެ އޮޑިޓަރު.",
        "reasonRequired": "ސަބަބު އީ ލާޒިމު.",
        "requested": "އެދުން ފޮނުވިއްޖެ އަށްޓަކައި ފާސްކުރުން",
        "requestedDetail": "އެއްވެސް އެއްޗެއް އެބަހުރި ބަދަލުވެފައި އަދި އަށްޓަކައި {vendor}. ދެވަނަ ފަރާތް އެބަހުރި އަށް ފާސްކުރޭ އެ ފުރަތަމަ."
      },
      "reveal": {
        "title": "ދައްކާ އެކައުންޓް ނަންބަރު",
        "subject": "{label} — {vendor}",
        "recorded": "މި ވާނެ ވުން ރެކޯޑްކުރެވިފައި ގައި audit ލޮގް ދަށުގައި ތިޔަ ނަން, {name}, އެކުގައި އާއެކު ސަބަބު ތިޔަ ދޭ ތިރީގައި.",
        "reasonLabel": "ކީއްވެ do ތިޔަ ބޭނުންވޭ އަށް ބަލާ މި ނަންބަރު?",
        "reasonHint": "އަށްޓަކައި example: confirming ފައިސާ ދެއްކުން ބޭންކް ބޭރުކުރެވިއްޖެ. އޮޑިޓަރު ވާނެ ކިޔާ މި.",
        "reasonRequired": "ސަބަބު އީ ލާޒިމު ކުރިން ނަންބަރު ކުރެވޭ ވުން ދައްކާފައި.",
        "confirm": "ދައްކާ އެ",
        "working": "ދައްކަނީ",
        "countdown": "މި ވާނެ disappear ގައި {seconds} seconds. އެ އީ ނޫން copied ނުވަތަ ރައްކާކުރެވިފައި anywhere.",
        "hideNow": "Hide އެ މިހާރު",
        "done": "ނިމިއްޖެ"
      },
      "retire": {
        "title": "އެދުން އެ މި އެކައުންޓް ވުން ބޭނުންކުރުމުން ހުއްޓާލާފައި",
        "subject": "{label} — {vendor}",
        "consequence": "މި އުފައްދާ އެދުން. އެކައުންޓް ދަމަހައްޓާ މަސައްކަތްކުރަނީ, އަދި ދަމަހައްޓާ ވަނީ ދައްކާފައި ތެރެއަށް, ވަންދެން އެހެން ފަރާތެއް އެހެން ފާސްކުރޭ ހުއްޓާލުން.",
        "reasonHint": "ބުނޭ ކީއްވެ މި އެކައުންޓް ޖެހޭ ހުއްޓުވާ ވަނީ ބޭނުންކުރި.",
        "reasonRequired": "ސަބަބު އީ ލާޒިމު.",
        "confirm": "ފޮނުވާ އެދުން",
        "requested": "އެދުން ފޮނުވިއްޖެ އަށްޓަކައި ފާސްކުރުން",
        "requestedDetail": "އެކައުންޓް އީ އަދިވެސް ހަރަކާތްތެރި ވަންދެން ދެވަނަ ފަރާތް ފާސްކުރޭ މި."
      }
    },
    "bankChanges": {
      "title": "ސަޕްލަޔަރު ބޭންކް-ތަފްޞީލު ބަދަލުތައް",
      "description": "ކާކު އެބަހުރި އެދިފައި އަށް ބަދަލު ކޮންތާކު ސަޕްލަޔަރު އީ ދައްކާފައި, ކީއްވެ, އަދި ކޮން އީ އަދިވެސް މަޑުކުރަނީ.",
      "loadFailed": "ބަދަލު އެދުންތައް ނުކުރެވުނު ނޫން ލޯޑް",
      "filterByStatus": "ސްޓޭޓަސް އިން ފިލްޓަރކުރޭ",
      "empty": "އެއްވެސް އެއްޗެއް އީ މަޑުކުރަނީ. ކޮންމެ އެދިފައި ބަދަލު އެބަހުރި ވެފައި ނިންމިއްޖެ.",
      "requestedAt": "އެދިފައި",
      "openVendor": "ހުޅުވާ ސަޕްލަޔަރު",
      "ownRequest": "ތިޔަ އުފައްދާފައި މި އެދުން, އެހެންކަމުން އެހެން ފަރާތެއް އެހެން އެބަހުރި އަށް ފާސްކުރޭ އެ.",
      "awaitingApprover": "އިންތިޒާރުގައި އަށްޓަކައި އެހެން ފަރާތެއް އާއެކު ފާސްކުރުން rights އަށް ނިންމާ.",
      "approveTitle": "ފާސްކުރޭ މި ބަދަލު",
      "rejectTitle": "ބޭރުކުރޭ މި ބަދަލު",
      "decisionSubject": "ފާސްކުރަނީ applies ބަދަލު ވަގުތުން.",
      "approveConsequence": "އެއްފަހަރު ފާސްކުރެވިއްޖެ, މި ސަޕްލަޔަރު އީ ދައްކާފައި ތެރެއަށް މި ތަފްޞީލުތައް. ޔަޤީންކުރޭ އެދުން އާއެކު ސަޕްލަޔަރު މަތީގައި ނަންބަރު ތިޔަ ކުރިންވެސް ހުރި — ނޫން އެއް އިން އީމެއިލް އެ އެދިފައި އަށްޓަކައި ބަދަލު.",
      "rejectConsequence": "ތަފްޞީލުތައް ދެމިހުރޭ ގޮތުގައި އެފަރާތްތައް އީ އަދި އެދުނު ފަރާތް އީ told.",
      "commentLabel": "ކޮމެންޓް",
      "commentHint": "ކޮން ތިޔަ ބެލި, އަދި ކިހިނެއް. މި އީ kept އާއެކު ނިންމުން.",
      "approved": "ބަދަލު ފާސްކުރެވިއްޖެ އަދި ބޭނުންކުރެވިފައި",
      "approvedDetail": "ސަޕްލަޔަރު އީ މިހާރު ދައްކާފައި ތެރެއަށް އައު ތަފްޞީލުތައް.",
      "rejected": "ބަދަލު ބޭރުކުރެވިއްޖެ",
      "rejectedDetail": "އެއްވެސް އެއްޗެއް ބެހޭގޮތުން މި ސަޕްލަޔަރުގެ ބޭންކް ތަފްޞީލުތައް އެބަހުރި ބަދަލުވެފައި."
    },
    "documents": {
      "titles": {
        "invoice": "ސަޕްލަޔަރު އިންވޮއިސްތައް",
        "credit_note": "ސަޕްލަޔަރު ކްރެޑިޓް ނޯޓްތައް",
        "debit_note": "ސަޕްލަޔަރު ޑެބިޓް ނޯޓްތައް"
      },
      "descriptions": {
        "invoice": "ބިލްތައް received އިން ސަޕްލަޔަރުން, މަތީގައި އެފަރާތްތަކުގެ way އިން ދެލިކޮޕީ އަށް ދައްކާފައި.",
        "credit_note": "ކޮން ސަޕްލަޔަރުން އެބަހުރި ކްރެޑިޓްކުރެވިފައި ފަހަތަށް, netted އާ ދެކޮޅަށް ކޮން އެފަރާތްތައް އީ ދަރަނި.",
        "debit_note": "އަދަދުތައް ޗާޖްކުރެވިފައި ފަހަތަށް އަށް ސަޕްލަޔަރު."
      },
      "newTitles": {
        "invoice": "އައު ސަޕްލަޔަރު އިންވޮއިސް",
        "credit_note": "އައު ކްރެޑިޓް ނޯޓް",
        "debit_note": "އައު ޑެބިޓް ނޯޓް"
      },
      "emptyTitles": {
        "invoice": "ނެތް ސަޕްލަޔަރު އިންވޮއިސްތައް އަދި",
        "credit_note": "ނެތް ކްރެޑިޓް ނޯޓްތައް އަދި",
        "debit_note": "ނެތް ޑެބިޓް ނޯޓްތައް އަދި"
      },
      "emptyDescriptions": {
        "invoice": "ލިޔޭ އެއް މިތާ. އެ becomes އަދަދު ގައި ލެޖަރ އެއްފަހަރު އެ އީ ހުށަހަޅާފައި, ފާސްކުރެވިއްޖެ އަދި ޕޯސްޓްކުރެވިފައި.",
        "credit_note": "އުފައްދާ އެއް އާ ދެކޮޅަށް ޕޯސްޓްކުރެވިފައި އިންވޮއިސް, އަދި އެ nets ކަނޑާލާ ގައި ދެން ފައިސާ ދެއްކުން ރަން.",
        "debit_note": "އުފައްދާ އެއް އަށް charge އަދަދު ފަހަތަށް އަށް ސަޕްލަޔަރު."
      },
      "filtersTitle": "ފިލްޓަރތައް",
      "searchHint": "ދިމާވޭ ލިޔުން ނަންބަރު, ސަޕްލަޔަރުގެ އަމިއްލަ ނަންބަރު އަދި ތަފްޞީލު.",
      "allCompanies": "ކޮންމެ ކުންފުނި",
      "allVendors": "ކޮންމެ ސަޕްލަޔަރު",
      "openOnly": "ހަމައެކަނި ކޮން އީ އަދިވެސް ދަރަނި",
      "from": "އިންވޮއިސް ތާރީޚް އިން",
      "to": "އިންވޮއިސް ތާރީޚް އަށް",
      "draft": "ދެލިކޮޕީ",
      "loadFailed": "ލިޔުން ލިސްޓް ނުކުރެވުނު ނޫން ލޯޑް",
      "tableLabel": "އޭޕީ ލިޔުންތައް",
      "noPermission": "ތިޔަ ހުއްދަ ނޫން ބަލާ މި ސަޕްލަޔަރުގެ ލިޔުންތައް.",
      "seeAll": "ބަލާ ކޮންމެ ލިޔުން އިން މި ސަޕްލަޔަރު",
      "firstPageOnly": "Showing most އެންމެފަހުގެ ލިޔުންތައް ހަމައެކަނި — ހުޅުވާ ފުރިހަމަ ލިސްޓް އަށްޓަކައި ބާކީ.",
      "vendorPanelTitle": "ލިޔުންތައް",
      "vendorEmptyTitle": "އެއްވެސް އެއްޗެއް އިން މި ސަޕްލަޔަރު އަދި",
      "vendorEmptyDescription": "އިންވޮއިސްތައް, ކްރެޑިޓް ނޯޓްތައް އަދި ޑެބިޓް ނޯޓްތައް އުފައްދާފައި އާ ދެކޮޅަށް މި ސަޕްލަޔަރު appear މިތާ.",
      "vendorPlaceholder": "ޓައިޕްކުރޭ ސަޕްލަޔަރު ކޯޑް ނުވަތަ ނަން",
      "noVendorMatch": "ނެތް ސަޕްލަޔަރު ދިމާވޭ އެ.",
      "matchCount": "{count} ސަޕްލަޔަރުން ދިމާވުން",
      "vendorTerms": "ދައްކާ ގައި {days} ދުވަސް",
      "whtHint": "ހިފެހެއްޓި ވަގުތު މި ލިޔުން އީ ދައްކާފައި, ނޫން ވަގުތު އެ އީ ޕޯސްޓްކުރެވިފައި.",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "މަޑުކުރަނީ ފާސްކުރުން",
        "approved": "ފާސްކުރެވިއްޖެ",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "paid": "ދައްކާފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި",
        "reversed": "ރިވަރސްކުރެވިފައި"
      },
      "kinds": {
        "invoice": "އިންވޮއިސް",
        "credit_note": "ކްރެޑިޓް ނޯޓް",
        "debit_note": "ޑެބިޓް ނޯޓް"
      },
      "columns": {
        "docNo": "ލިޔުން ނެތް.",
        "vendorInvoiceNo": "ސަޕްލަޔަރުގެ ނެތް.",
        "vendor": "ސަޕްލަޔަރު",
        "kind": "ބާވަތް",
        "invoiceDate": "އިންވޮއިސް ތާރީޚް",
        "dueDate": "މުއްދަތު",
        "currency": "ފައިސާގެ ބާވަތް",
        "subtotal": "ސާފު",
        "tax": "ޓެކްސް",
        "total": "ޖުމްލަ",
        "wht": "ހިފެހެއްޓޭ ޓެކްސް",
        "outstanding": "ނުދެއްކިހުރި",
        "fxRate": "ރޭޓް",
        "postedAt": "ޕޯސްޓްކުރެވިފައި",
        "hold": "ހިފެހެއްޓުން"
      },
      "fields": {
        "company": "ކުންފުނި",
        "companyPlaceholder": "އިޚްތިޔާރުކުރޭ ކުންފުނި މި އީ ބިލްކުރެވުނު އަށް",
        "vendor": "ސަޕްލަޔަރު",
        "vendorInvoiceNo": "ސަޕްލަޔަރުގެ އިންވޮއިސް ނަންބަރު",
        "vendorInvoiceNoHint": "ނަންބަރު printed މަތީގައި ބިލް. ދެ ލިޔުންތައް ނުކުރެވޭ share އެއް އަށްޓަކައި same ސަޕްލަޔަރު.",
        "invoiceDate": "އިންވޮއިސް ތާރީޚް",
        "dueDate": "މުއްދަތު ތާރީޚް",
        "dueDateHint": "Filled ގައި އިން ސަޕްލަޔަރުގެ ފައިސާ ދެއްކުން ޝަރުތުތައް. ބަދަލު އެ ނަމަ ބިލް ބުނޭ otherwise.",
        "currency": "ފައިސާގެ ބާވަތް",
        "currencyHint": "ކުންފުނިގެ އަސާސީ ފައިސާގެ ބާވަތް އީ {base}.",
        "description": "ތަފްޞީލު",
        "memo": "މެމޯ",
        "originalInvoice": "އާ ދެކޮޅަށް އިންވޮއިސް",
        "originalInvoiceHint": "ޕޯސްޓްކުރެވިފައި އިންވޮއިސް މި ކްރެޑިޓް ނޯޓް relates އަށް.",
        "originalInvoicePlaceholder": "ނޫން އާ ދެކޮޅަށް ވަކި އިންވޮއިސް",
        "dueDateOverrideReason": "ޑިއު ތާރީޚު ބަދަލުކުރި ސަބަބު",
        "dueDateOverrideReasonHint": "ވެންޑަރގެ ޝަރުޠުތަކުން ލިބޭ ތާރީޚަކީ {terms}. ތަފާތު ޑިއު ތާރީޚެއްނަމަ ސަބަބު ބުނަން ޖެހޭނެ.",
        "dueDateOverrideReasonHintBare": "މި ޑޮކިއުމަންޓްގެ ޑިއު ތާރީޚު ވެންޑަރގެ ޝަރުޠުތަކާ ތަފާތުވި ސަބަބު.",
        "purchaseOrder": "ޕަރޗޭސް އޯޑަރ",
        "purchaseOrderHint": "އިޚްތިޔާރީ. މި ވެންޑަރާއި ކުންފުނީގެ، މި ފައިސާއިން ހުރި ހުޅުވިފައިވާ އޯޑަރެއް.",
        "purchaseOrderNeedsVendor": "ފުރަތަމަ ވެންޑަރ ޚިޔާރުކުރޭ",
        "purchaseOrderNone": "މި ވެންޑަރަށް ހުޅުވިފައިވާ އޯޑަރެއް ނެތް",
        "purchaseOrderPlaceholder": "ޕަރޗޭސް އޯޑަރެއް ނެތް"
      },
      "export": {
        "done": "އެކްސްޕޯޓް ތައްޔާރު",
        "doneDetail": "{count} ލިޔުންތައް ވި ލިޔެފައި އަށް ފައިލް.",
        "failed": "އެކްސްޕޯޓް ނުކުރެވުނު ނޫން ނިންމާ"
      },
      "views": {
        "label": "ރައްކާކުރި ވިއުތައް",
        "trigger": "ވިއުތައް",
        "empty": "ނެތް ރައްކާކުރެވިއްޖެ ވިއުތައް އަދި. ފިލްޓަރ ލިސްޓް, އެއަށްފަހު ނަން ކޮން ތިޔަ ބަލާ.",
        "saved": "ވިއު ރައްކާކުރެވިއްޖެ",
        "namePlaceholder": "މި ވިއު އަށް ނަމެއް ދޭ",
        "nameLabel": "ވިއު ނަން",
        "delete": "ފޮހެލާ ވިއު {name}"
      },
      "poLineOption": "ލައިން {no} · {description} · {quantity} × {price}",
      "poStatuses": {
        "draft": "ޑްރާފްޓް",
        "submitted": "ހުށަހެޅިއްޖެ",
        "approved": "ފާސްކުރެވިއްޖެ",
        "rejected": "ރައްދުކުރެވިއްޖެ",
        "issued": "ފޮނުވިއްޖެ",
        "confirmed": "ކަށަވަރުކުރެވިއްޖެ",
        "partially_received": "ބައެއް ލިބިއްޖެ",
        "received": "ލިބިއްޖެ",
        "closed": "ބަންދުކުރެވިއްޖެ",
        "cancelled": "ކެންސަލްކުރެވިއްޖެ"
      }
    },
    "document": {
      "title": "{kind} {docNo}",
      "kindDescriptions": {
        "invoice": "ބިލް އިން ސަޕްލަޔަރު: ލިޔެފައި, ފާސްކުރެވިއްޖެ, ޕޯސްޓްކުރެވިފައި, އެއަށްފަހު ދައްކާފައި.",
        "credit_note": "ކްރެޑިޓް އިން ސަޕްލަޔަރު. އަދަދުތައް އީ ޕޮޒިޓިވް; ބާވަތް ގެންދޭ ނިޝާން.",
        "debit_note": "އަދަދު ޗާޖްކުރެވިފައި ފަހަތަށް އަށް ސަޕްލަޔަރު. އަދަދުތައް އީ ޕޮޒިޓިވް."
      },
      "headerTitle": "ލިޔުން",
      "backToList": "ފަހަތަށް އަށް ލިސްޓް",
      "loadFailed": "މި ލިޔުން ނުކުރެވުނު ނޫން ލޯޑް",
      "actionsLabel": "ލިޔުން ޢަމަލުތައް",
      "subtotalLabel": "ސާފު ޖުމްލަ",
      "taxAtSubmit": "ޓެކްސް އަދި ހިފެހެއްޓޭ ޓެކްސް އީ worked ބޭރަށް ވަގުތު މި އީ ހުށަހަޅާފައި.",
      "postingDate": "ޕޯސްޓްކުރުން ތާރީޚް",
      "posting": "ޕޯސްޓްކުރުން",
      "submitting": "ހުށަހަޅަނީ",
      "readyToSubmit": "ތައްޔާރު އަށް ހުށަހަޅާ.",
      "stale": "އެހެން ފަރާތެއް އެހެން ރައްކާކުރެވިއްޖެ މި ލިޔުން ދަނޑިވަޅުގައި އެ ވި ހުޅުވާ. އަލުން ލޯޑްކުރޭ އެފަރާތްތަކުގެ ވަރޝަން, ބަލާ ގައި ކޮން ބަދަލުވެފައި, އަދި ބޭނުންކުރޭ ތިޔަ edits އަލުން — ރައްކާކުރަނީ މިހާރު ވީސް overwrite އެފަރާތްތަކުގެ work.",
      "reload": "އަލުން ލޯޑްކުރޭ ރައްކާކުރެވިއްޖެ ވަރޝަން",
      "railSubtitle": "{status} · {vendor}",
      "locked": {
        "submitted": "މި ލިޔުން އީ މަޑުކުރަނީ އަށްޓަކައި ފާސްކުރުން އަދި ނުކުރެވޭ ވުން އެޑިޓްކުރެވިފައި. ބޭރުކުރޭ އެ އަށް ފޮނުވާ އެ ފަހަތަށް އަށް ދެލިކޮޕީ.",
        "approved": "މި ލިޔުން އީ ފާސްކުރެވިއްޖެ އަދި ނުކުރެވޭ ވުން އެޑިޓްކުރެވިފައި. އެ އީ މަޑުކުރަނީ އަށް ވުން ޕޯސްޓްކުރެވިފައި.",
        "posted": "ޕޯސްޓްކުރެވިފައި ލިޔުން އީ ރަނގަޅުކުރެވިފައި އާއެކު ކްރެޑިޓް ނޯޓް ނުވަތަ ރިވަރސަލް, ދުވަހަކުވެސް ނުވޭ އެޑިޓްކުރެވިފައި.",
        "paid": "މި ލިޔުން އެބަހުރި ވެފައި ދައްކާފައި. ރަނގަޅުކުރޭ އެ އާއެކު ކްރެޑިޓް ނޯޓް.",
        "cancelled": "މި ލިޔުން ވި ކެންސަލްކުރެވިފައި.",
        "reversed": "މި ލިޔުން ވި ރިވަރސްކުރެވިފައި. އޭގެ މިރާ ޖާނަލް އީ ގައި ލެޖަރ."
      },
      "blockers": {
        "noCompany": "އިޚްތިޔާރުކުރޭ ކުންފުނި މި އީ ބިލްކުރެވުނު އަށް.",
        "noVendor": "އިޚްތިޔާރުކުރޭ ސަޕްލަޔަރު މި ބިލް came އިން.",
        "noVendorInvoiceNo": "ލިޔޭ ސަޕްލަޔަރުގެ އަމިއްލަ އިންވޮއިސް ނަންބަރު.",
        "noInvoiceDate": "ލިޔޭ އިންވޮއިސް ތާރީޚް.",
        "noCurrency": "ލިޔޭ ތިން-އަކުރު ފައިސާގެ ބާވަތް ކޯޑް.",
        "noLines": "އިތުރުކުރޭ ގައި least އެއް ރޮނގު.",
        "lineIssues": "Some ރޮނގުތައް އަދިވެސް ބޭނުންވޭ attention.",
        "zeroTotal": "ރޮނގުތައް އެބަހުރި އަށް ޖުމްލަ އިތުރު ވުރެ ސުމެއް."
      },
      "actions": {
        "save": "ރައްކާކުރޭ ދެލިކޮޕީ",
        "submit": "ހުށަހަޅާ އަށްޓަކައި ފާސްކުރުން",
        "approve": "ފާސްކުރޭ",
        "reject": "ބޭރުކުރޭ",
        "post": "ޕޯސްޓްކުރޭ އަށް ލެޖަރ",
        "reverse": "ރިވަރސްކުރޭ",
        "discard": "އުކާލާ ދެލިކޮޕީ",
        "pdf": "PDF ތައްޔާރުކުރޭ",
        "hold": "ހިފަހައްޓާ",
        "releaseHold": "ހިފެހެއްޓުން ދޫކޮށްލާ",
        "matchToPo": "ޕީއޯއާ އަޅާކިޔާ"
      },
      "pdfWorking": "އުފައްދަނީ",
      "pdfOpen": "PDF ހުޅުވާ",
      "pdfNotReady": "PDF އަދި އުފައްދަނީ. މަދު ވަގުތުކޮޅެއް ފަހުން އަލުން ބައްލަވާ.",
      "shortcuts": {
        "save": "ރައްކާކުރޭ ލިޔުން"
      },
      "unsavedGuard": {
        "title": "ރައްކާނުކުރާ ބަދަލުތައް ދޫކޮށްލާނަންތޯ؟",
        "message": "މި ލިޔުމުގައި ރައްކާނުކުރެވޭ ބަދަލުތަކެއް އެބަހުރި. މިހާރު ދޫކޮށްލައިފިނަމަ، އެ ބަދަލުތައް ގެއްލޭނެ.",
        "confirm": "ބަދަލުތައް ދޫކޮށްލާ",
        "cancel": "އިތުރަށް އެޑިޓްކުރޭ"
      },
      "reject": {
        "title": "ބޭރުކުރޭ މި ލިޔުން",
        "description": "އެ ދޭ ފަހަތަށް އަށް ދެލިކޮޕީ އެހެންކަމުން mistake ކުރެވޭ ވުން ރަނގަޅުކުރެވިފައި.",
        "consequence": "ބޭރުކުރުމުން returns ލިޔުން އަށް ދެލިކޮޕީ. އެއްވެސް އެއްޗެއް އީ ފޮހެލެވިފައި އަދި އެއްވެސް އެއްޗެއް އީ ޕޯސްޓްކުރެވިފައި.",
        "commentLabel": "ކޮމެންޓް",
        "commentHint": "ކޮން އީ wrong އާއެކު އެ. ފަރާތް ކާކު އުފައްދާފައި އެ ކިޔާ މި."
      },
      "timeline": {
        "created": "ލިޔެފައި",
        "submitted": "ހުށަހަޅާފައި ގޮތުގައި {docNo}",
        "approved": "ފާސްކުރެވިއްޖެ",
        "posted": "ޕޯސްޓްކުރެވިފައި އަށް ލެޖަރ"
      },
      "links": {
        "journal": "ޖާނަލް މި ޕޯސްޓްކުރެވިފައި",
        "original": "އިންވޮއިސް މި އީ އާ ދެކޮޅަށް",
        "reversedBy": "ލިޔުން އެ ރިވަރސްކުރެވިފައި މި",
        "vendor": "ސަޕްލަޔަރު"
      },
      "toasts": {
        "saved": "ދެލިކޮޕީ ރައްކާކުރެވިއްޖެ",
        "savedDetail": "އެއްވެސް އެއްޗެއް އީ ގައި ލެޖަރ އަދި: ހުށަހަޅާ އެ, ފާސްކުރޭ އެ, އެއަށްފަހު ޕޯސްޓްކުރޭ އެ.",
        "saveFailed": "ދެލިކޮޕީ ވި ނޫން ރައްކާކުރެވިއްޖެ",
        "submitted": "ހުށަހަޅާފައި ގޮތުގައި {docNo}",
        "submittedDetail": "ނަންބަރު, ޓެކްސް އަދި exchange ރޭޓް އީ މިހާރު fixed.",
        "submitFailed": "މި ލިޔުން ވި ނޫން ހުށަހަޅާފައި",
        "approved": "ފާސްކުރެވިއްޖެ",
        "approvedDetail": "އެ ކުރެވޭ ވުން ޕޯސްޓްކުރެވިފައި އަށް ލެޖަރ މިހާރު.",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "rejectedDetail": "އެ އީ ފަހަތަށް ގައި ދެލިކޮޕީ އަދި ކުރެވޭ ވުން ރަނގަޅުކުރެވިފައި.",
        "decideFailed": "ނިންމުން ވި ނޫން ރެކޯޑްކުރެވިފައި",
        "posted": "ޕޯސްޓްކުރެވިފައި ގޮތުގައި {docNo}",
        "postedDetail": "ޖާނަލް އީ ގައި ލެޖަރ އަދި ސަޕްލަޔަރުގެ ބެލެންސް އެބަހުރި ގުޑައިފި.",
        "postFailed": "މި ލިޔުން ވި ނޫން ޕޯސްޓްކުރެވިފައި",
        "discarded": "ދެލިކޮޕީ އުކާލެވިފައި",
        "discardedDetail": "އެއްވެސް އެއްޗެއް ވި ޕޯސްޓްކުރެވިފައި, އެހެންކަމުން އެއްވެސް އެއްޗެއް ވި ބާކީ ފަހަތުގައި.",
        "discardFailed": "ދެލިކޮޕީ ވި ނޫން އުކާލެވިފައި"
      },
      "hold": {
        "badge": "ހިފަހައްޓާފައި",
        "lead": "ފައިސާ ދެއްކުން ހިފަހައްޓާފައި. މި ޑޮކިއުމަންޓް އޭޖިންގައި ހުރި ނަމަވެސް، ހިފެހެއްޓުން ދޫކޮށްލާންދެން ފައިސާ ނުދެއްކޭނެ.",
        "by": "ހިފެހެއްޓީ ޔޫޒަރ {id}",
        "placed": "ފައިސާ ދެއްކުން ހިފަހައްޓައިފި",
        "released": "ފައިސާ ދެއްކުމުގެ ހިފެހެއްޓުން ދޫކޮށްލައިފި",
        "saveFirst": "ފުރަތަމަ ތިބާގެ ބަދަލުތައް ސޭވްކުރޭ ނުވަތަ ދޫކޮށްލާ.",
        "holdTitle": "ފައިސާ ދެއްކުން ހިފަހައްޓާ",
        "holdDescription": "ހިފަހައްޓާފައިވާ ޑޮކިއުމަންޓެއް ޕޭމަންޓް ހުށަހެޅުންތަކުން ދޫކޮށްލެވޭނެ، އަދި އެ ޑޮކިއުމަންޓް ހިމެނޭ ޕޭމަންޓް ރަނެއް ހިންގޭކަށް ނުވާނެ.",
        "releaseTitle": "ފައިސާ ދެއްކުމުގެ ހިފެހެއްޓުން ދޫކޮށްލާ",
        "releaseDescription": "ޑޮކިއުމަންޓަށް އަލުން ފައިސާ ދެއްކޭނެ. ހިފެހެއްޓީ ކާކުކަމާއި ދޫކޮށްލީ ކާކުކަން އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑްވޭ.",
        "currentReason": "ހިފެހެއްޓި ސަބަބު: {reason}",
        "reason": "ސަބަބު",
        "reasonHint": "ލާޒިމު. އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑްވޭ."
      },
      "attachments": {
        "requirement": "މި ޑޮކިއުމަންޓް ހުށަހެޅުމުގެ ނުވަތަ ޕޯސްޓްކުރުމުގެ ކުރިން ސަޕޯޓިންގ ޑޮކިއުމަންޓެއް އެޓޭޗްކުރަން ޖެހޭނެ. ކަނޑައެޅިފައިވާ އަދަދަކަށް ނުވަތަ އެއަށްވުރެ ދަށުގެ ޑޮކިއުމަންޓްތައް ތިބާގެ ކުންފުނިން ނިކުތުން ހުއްދަކޮށްފާނެ.",
        "saveFirst": "ސަޕޯޓިންގ ޑޮކިއުމަންޓްތައް އެޓޭޗްކުރުމަށް ފުރަތަމަ ޑޮކިއުމަންޓް ސޭވްކުރާށެވެ."
      }
    },
    "lines": {
      "title": "ރޮނގުތައް",
      "caption": "ލިޔުން ރޮނގުތައް: އެކައުންޓް, ތަފްޞީލު, އަދަދު, ޔުނިޓް އަގު އަދި އަދަދު.",
      "subtotal": "ސާފު ޖުމްލަ",
      "computed": "އަދަދު × އަގު",
      "noTaxCode": "ނެތް ޓެކްސް ކޯޑް",
      "keyboardHint": "ލިޔޭ އަށްޓަކައި ދެން ރޯ, އޯލްޓް+↓ އަށް ކޮޕީކުރޭ, އޯލްޓް+Backspace އަށް ނަގާ.",
      "columns": {
        "no": "#",
        "account": "އެކައުންޓް",
        "description": "ތަފްޞީލު",
        "dimensions": "ޑައިމެންޝަންތައް",
        "taxCode": "ޓެކްސް ކޯޑް",
        "quantity": "ޢަދަދު",
        "unitPrice": "ޔުނިޓް އަގު",
        "amount": "އަދަދު",
        "tax": "ޓެކްސް",
        "rowActions": "ރޯ ޢަމަލުތައް",
        "poLine": "ޕީއޯ ލައިން"
      },
      "actions": {
        "add": "އިތުރުކުރޭ ރޮނގު",
        "duplicate": "ކޮޕީކުރޭ މި ރޮނގު",
        "remove": "ނަގާ މި ރޮނގު"
      },
      "aria": {
        "account": "އެކައުންޓް, ރޮނގު {line}",
        "description": "ތަފްޞީލު, ރޮނގު {line}",
        "taxCode": "ޓެކްސް ކޯޑް, ރޮނގު {line}",
        "quantity": "އަދަދު, ރޮނގު {line}",
        "unitPrice": "ޔުނިޓް އަގު, ރޮނގު {line}",
        "lineAmount": "އަދަދު, ރޮނގު {line}",
        "duplicate": "ކޮޕީކުރޭ ރޮނގު {line}",
        "remove": "ނަގާ ރޮނގު {line}",
        "poLine": "ލައިން {line} ގެ ޕަރޗޭސް އޯޑަރ ލައިން"
      },
      "issues": {
        "invalidQuantity": "އެ އީ ނޫން ނަންބަރު.",
        "invalidPrice": "އެ އީ ނޫން ނަންބަރު.",
        "invalidAmount": "އެ އީ ނޫން އަދަދު.",
        "negativeAmount": "އަދަދުތައް އީ ޕޮޒިޓިވް މަތީގައި ކޮންމެ ބާވަތް ގެ ލިޔުން; ބާވަތް ގެންދޭ ނިޝާން.",
        "zeroAmount": "ރޮނގު އެބަހުރި އަށް ވުން އަގު އިތުރު ވުރެ އެއްވެސް އެއްޗެއް.",
        "noAccount": "އިޚްތިޔާރުކުރޭ އެކައުންޓް މި ރޮނގު އީ ޗާޖްކުރެވިފައި އަށް.",
        "notPostable": "އެކައުންޓް {account} އީ ސުރުޚީ, ނޫން ޕޯސްޓްކުރެވޭ އެކައުންޓް.",
        "inactive": "އެކައުންޓް {account} އީ ހަރަކާތްތެރި ނޫން.",
        "requiresCostCenter": "އެކައުންޓް {account} ބޭނުންވޭ ޚަރަދު ސެންޓަރ.",
        "requiresProfitCenter": "އެކައުންޓް {account} ބޭނުންވޭ ފައިދާ ސެންޓަރ.",
        "requiresBranch": "އެކައުންޓް {account} ބޭނުންވޭ ބްރާންޗް.",
        "requiresDepartment": "އެކައުންޓް {account} ބޭނުންވޭ ޑިޕާޓްމަންޓް.",
        "requiresProject": "އެކައުންޓް {account} ބޭނުންވޭ ޕްރޮޖެކްޓް."
      },
      "noPoLine": "ޕީއޯ ލައިނެއް ނެތް"
    },
    "reverse": {
      "title": "ރިވަރސްކުރޭ މި ލިޔުން",
      "subject": "{docNo} — {vendor}",
      "consequence": "އެއްވެސް އެއްޗެއް އީ ފޮހެލެވިފައި. މިރާ ޖާނަލް އީ ލިޔެފައި, އަޞްލު ދެމިހުރޭ ގައި ލެޖަރ marked ރިވަރސްކުރެވިފައި, އަދި ދެބައި point ގައި ކޮންމެ އެހެން.",
      "settled": "މި ލިޔުން އެބަހުރި ވެފައި ދައްކާފައި, ގައި whole ނުވަތަ ގައި part. Unwind ފައިސާ ދެއްކުން ފުރަތަމަ — އެ ނުކުރެވޭ ވުން ރިވަރސްކުރެވިފައި ދަނޑިވަޅުގައި ސެޓްލްމަންޓް stands އާ ދެކޮޅަށް އެ.",
      "dateLabel": "ރިވަރސަލް ތާރީޚް",
      "dateHint": "މިރާ ޖާނަލް ޕޯސްޓްކުރޭ މަތީގައި މި ތާރީޚް, އެހެންކަމުން އޭގެ މުއްދަތު އެބަހުރި އަށް ވުން ހުޅުވާ.",
      "reasonLabel": "ސަބަބު",
      "reasonHint": "ކީއްވެ މި އީ ވަނީ ރިވަރސްކުރެވިފައި. އެ ދެމިހުރޭ އާއެކު ދެބައި ލިޔުންތައް.",
      "reasonRequired": "ސަބަބު އީ ލާޒިމު.",
      "confirm": "ރިވަރސްކުރޭ އެ",
      "working": "ރިވަރސްކުރުން",
      "doneTitle": "ރިވަރސްކުރެވިފައި",
      "doneDetail": "މިރާ ލިޔުން {docNo} އީ ގައި ލެޖަރ."
    },
    "runs": {
      "title": "ފައިސާ ދެއްކުން ރަންތައް",
      "description": "ކޮން އީ ވަނީ ދައްކާފައި, އަށް whom, އަދި ބޭރަށް ގެ ކޮން ބޭންކް އެކައުންޓް.",
      "oneTitle": "ފައިސާ ދެއްކުން ރަން",
      "oneDescription": "ޕްލޭން ވަންދެން އެ އީ ތަންފީޒުކުރެވިފައި: ހުށަހެޅުން, އޭގެ ފާސްކުރުން, އަދި ފައިލް ބޭންކް receives.",
      "draftTitle": "ނަންބަރު ނުދޭ ރަން",
      "backToList": "ފަހަތަށް އަށް ފައިސާ ދެއްކުން ރަންތައް",
      "loadFailed": "ފައިސާ ދެއްކުން ރަން ނުކުރެވުނު ނޫން ލޯޑް",
      "emptyTitle": "ނެތް ފައިސާ ދެއްކުން ރަންތައް އަދި",
      "emptyDescription": "ހުށަހަޅާ އެއް އަދި ނުދެއްކިހުރި ބިލްތައް މުއްދަތު ފަރާތުން ތިޔަ ކަޓްއޮފް އީ އެއްކުރެވިފައި އަށްޓަކައި ފާސްކުރުން.",
      "filterByStatus": "ސްޓޭޓަސް އިން ފިލްޓަރކުރޭ",
      "summaryTitle": "ރަން",
      "paymentsTitle": "ފައިސާ ދެއްކުންތައް",
      "paymentsCaption": "އެއް ރޯ ކޮންމެ ސަޕްލަޔަރު, އާއެކު ލިޔުންތައް ކޮންމެ ފައިސާ ދެއްކުން ސެޓްލްކުރޭ.",
      "noPayments": "މި ރަން އެބަހުރި ނެތް ފައިސާ ދެއްކުންތައް.",
      "remittance": "ފައިސާ ދެއްކުމުގެ ލިޔުން",
      "remittanceWorking": "އުފައްދަނީ",
      "remittanceOpen": "އެންމެ ފަހުގެ ފައިސާ ދެއްކުމުގެ ލިޔުން ހުޅުވާ",
      "remittanceNotReady": "ފައިސާ ދެއްކުމުގެ ލިޔުން އަދި އުފައްދަނީ. މަދު ވަގުތުކޮޅެއް ފަހުން އަލުން ބައްލަވާ.",
      "noBankAccount": "ނެތް ބޭންކް އެކައުންޓް މަތީގައި ފައިލް",
      "totalLabel": "ޖުމްލަ",
      "paymentCount": "{count} ސަޕްލަޔަރުން",
      "actionsLabel": "ފައިސާ ދެއްކުން ރަން ޢަމަލުތައް",
      "executedAt": "ތަންފީޒުކުރެވިފައި",
      "propose": "ހުށަހަޅާ ފައިސާ ދެއްކުން ރަން",
      "proposing": "ހުށަހަޅަނީ",
      "created": "ފައިސާ ދެއްކުން ރަން ހުށަހަޅާފައި",
      "createdDetail": "އެއްވެސް އެއްޗެއް އެބަހުރި ވެފައި ދައްކާފައި. އެ އީ މަޑުކުރަނީ އަށްޓަކައި ފާސްކުރުން.",
      "createTitle": "ހުށަހަޅާ ފައިސާ ދެއްކުން ރަން",
      "createDescription": "އެއްކުރޭ ކޮން އީ ނުދެއްކިހުރި އަދި ހުށަހަޅާ އެ އަށްޓަކައި ފާސްކުރުން. ނެތް ފައިސާ ގުޑާ.",
      "proposalNote": "މި proposes ރަން އަދި ހުށަހަޅާ އެ އަށްޓަކައި ފާސްކުރުން. އެއްވެސް އެއްޗެއް އީ ޕޯސްޓްކުރެވިފައި, އެއްވެސް އެއްޗެއް އީ ސެޓްލްކުރެވިފައި, އަދި ނެތް ފައިސާ ގުޑާ ވަންދެން އެހެން ފަރާތެއް executes އެ.",
      "planNote": "މި ރަން އީ ޕްލޭން. އެއްވެސް އެއްޗެއް އެބަހުރި ވެފައި ޕޯސްޓްކުރެވިފައި ނުވަތަ ސެޓްލްކުރެވިފައި އަދި.",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "މަޑުކުރަނީ ފާސްކުރުން",
        "approved": "ފާސްކުރެވިއްޖެ",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "executed": "ތަންފީޒުކުރެވިފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "methods": {
        "bank_transfer": "ބޭންކް ޓްރާންސްފަރ",
        "cheque": "ޗެކް",
        "cash": "ފައިސާ"
      },
      "columns": {
        "runNo": "ރަން ނެތް.",
        "paymentDate": "ފައިސާ ދެއްކުން ތާރީޚް",
        "method": "ގޮތް",
        "vendor": "ސަޕްލަޔަރު",
        "bankAccount": "ދައްކާފައި ތެރެއަށް",
        "documents": "ސެޓްލްކުރޭ",
        "gross": "ޖުމްލަ",
        "wht": "ހިފެހެއްޓި",
        "discount": "ޑިސްކައުންޓް",
        "net": "ސާފު ދައްކާފައި",
        "reference": "ރެފަރެންސް",
        "remittance": "ފައިސާ ދެއްކުމުގެ ލިޔުން"
      },
      "fields": {
        "company": "ކުންފުނި",
        "paymentDate": "ފައިސާ ދެއްކުން ތާރީޚް",
        "paymentDateHint": "ތާރީޚް ޖާނަލް ޕޯސްޓްކުރޭ މަތީގައި, އެހެންކަމުން އޭގެ މުއްދަތު އެބަހުރި އަށް ވުން ހުޅުވާ.",
        "currency": "ފައިސާގެ ބާވަތް",
        "currencyHint": "ރަން ދައްކާ އެއް ފައިސާގެ ބާވަތް. ލިޔުންތައް ގައި others އީ ނޫން picked މައްޗަށް.",
        "method": "ގޮތް",
        "bankAccount": "ބޭންކް އެކައުންޓް",
        "bankAccountHint": "ލެޖަރ އެކައުންޓް މި ރަން އީ ކްރެޑިޓްކުރެވިފައި އަށް.",
        "bankAccountPlaceholder": "އިޚްތިޔާރުކުރޭ އެކައުންޓް ފައިސާ leaves",
        "bankFileProfile": "ބޭންކް ފައިލް ލޭއައުޓް",
        "bankFileProfileHint": "ކޮން ލޭއައުޓް ބޭންކް ފައިލް އީ ރެންޑަރކުރެވިފައި އާއެކު. އެޑިޓްކުރެވޭ ޑޭޓާ, ނޫން ކޯޑް.",
        "bankFileProfilePlaceholder": "ނިންމާ later",
        "dueOnOrBefore": "މުއްދަތު މަތީގައި ނުވަތަ ކުރިން",
        "dueOnOrBeforeHint": "ކަޓްއޮފް. ދޫކޮށްލާ އެ ހުސް އަށް ހުށަހަޅާ ހުރިހާ އެއްޗެއް ނުދެއްކިހުރި.",
        "reference": "ރެފަރެންސް",
        "memo": "މެމޯ",
        "takeDiscounts": "Take ސެޓްލްމަންޓް ޑިސްކައުންޓްތައް ކޮންތާކު އެފަރާތްތައް އީ އަދިވެސް available",
        "takeDiscountsHint": "ދައްކާ ލިޔުން ސާފު ގެ ޑިސްކައުންޓް އޭގެ ސަޕްލަޔަރު ޝަރުތުތައް offer, ދަނޑިވަޅުގައި ޑިސްކައުންޓް މުއްދަތު އީ ހުޅުވާ.",
        "vendors": "Limit އަށް ވަކި ސަޕްލަޔަރުން",
        "vendorsHint": "ދޫކޮށްލާ ހުރިހާ އެއްޗެއް unticked އަށް ހުށަހަޅާ ކޮންމެ ސަޕްލަޔަރު އާއެކު އެއްޗެއް ނުދެއްކިހުރި.",
        "vendorSearch": "ހޯދާ ސަޕްލަޔަރުން",
        "allVendors": "ކޮންމެ ސަޕްލަޔަރު އާއެކު އެއްޗެއް ނުދެއްކިހުރި.",
        "vendorsChosen": "{count} ސަޕްލަޔަރުން އިޚްތިޔާރުކުރެވިފައި."
      },
      "execute": {
        "title": "ތަންފީޒުކުރޭ މި ފައިސާ ދެއްކުން ރަން",
        "subject": "{runNo}",
        "headline": "މި އީ step އެ ދައްކާ.",
        "consequence": "އެ ސެޓްލްކުރޭ ކޮންމެ ލިޔުން ގައި ރަން, ޕޯސްޓްކުރޭ ޖާނަލް — ދަރަނިތައް އެކައުންޓް debited, ބޭންކް ކްރެޑިޓްކުރެވިފައި, ހިފެހެއްޓޭ ޓެކްސް އަދި ސެޓްލްމަންޓް ޑިސްކައުންޓްތައް recognised — އަދި ނުކުރެވޭ ވުން undone ފަރާތުން editing. Correcting އެ އޭގެފަހުން means ރިވަރސްކުރުން ޖާނަލް.",
        "referenceLabel": "ބޭންކް ރެފަރެންސް",
        "referenceHint": "ކޮން ބޭންކް ވާނެ ދައްކާ އާ ދެކޮޅަށް މި ޓްރާންސްފަރ, ނަމަ ތިޔަ ކުރިންވެސް know އެ.",
        "confirm": "ތަންފީޒުކުރޭ ރަން",
        "working": "ތަންފީޒުކުރަނީ"
      },
      "reject": {
        "title": "ބޭރުކުރޭ މި ފައިސާ ދެއްކުން ރަން",
        "description": "އެއްވެސް އެއްޗެއް އީ ދައްކާފައި އަދި ރަން އީ ބަންދު.",
        "commentHint": "ކީއްވެ މި ރަން ޖެހޭ ނޫން ދޭ ahead."
      },
      "timeline": {
        "created": "ހުށަހަޅާފައި",
        "submitted": "ހުށަހަޅާފައި އަށްޓަކައި ފާސްކުރުން",
        "approved": "ފާސްކުރެވިއްޖެ",
        "executed": "ތަންފީޒުކުރެވިފައި"
      },
      "links": {
        "journal": "ޖާނަލް މި ޕޯސްޓްކުރެވިފައި"
      },
      "railSubtitle": "{status} · ފައިސާ ދައްކަނީ {date}",
      "actions": {
        "execute": "ތަންފީޒުކުރޭ ރަން",
        "bankFile": "ބޭންކް ފައިލް"
      },
      "toasts": {
        "approved": "ފައިސާ ދެއްކުން ރަން ފާސްކުރެވިއްޖެ",
        "approvedDetail": "އެ ކުރެވޭ ވުން ތަންފީޒުކުރެވިފައި މިހާރު. އެއްވެސް އެއްޗެއް އެބަހުރި ވެފައި ދައްކާފައި އަދި.",
        "rejected": "ފައިސާ ދެއްކުން ރަން ބޭރުކުރެވިއްޖެ",
        "rejectedDetail": "އެއްވެސް އެއްޗެއް ވި ދައްކާފައި.",
        "decideFailed": "ނިންމުން ވި ނޫން ރެކޯޑްކުރެވިފައި",
        "executed": "ތަންފީޒުކުރެވިފައި ގޮތުގައި {runNo}",
        "executedDetail": "ޖާނަލް އީ ޕޯސްޓްކުރެވިފައި އަދި ލިޔުންތައް އީ ސެޓްލްކުރެވިފައި.",
        "executeFailed": "މި ރަން ވި ނޫން ތަންފީޒުކުރެވިފައި",
        "remittanceFailed": "ފައިސާ ދެއްކުމުގެ ލިޔުމެއް ނުއުފެއްދުނު"
      },
      "sod": {
        "preparer": "މި ރަން ތައްޔާރުކުރީ ތިބާ، އެހެންވީމާ ހުއްދަ ދޭންވާނީ އެހެން މީހަކު.",
        "noTask": "މި ރަނުގައި ތިބާއަށް ހުއްދަ ދޭން އެއްޗެއް ނެތް: ތިބާ ތައްޔާރުކުރި، ތިބާގެ ފިޔަވަޅަށް ހުއްދަ ދީފައި، ނުވަތަ އެހެން މީހަކަށް މަޑުކުރަނީ.",
        "approvedByYou": "މި ރަނަށް ހުއްދަ ދިނީ ތިބާ، އެހެންވީމާ ހިންގަންވާނީ އެހެން މީހަކު."
      },
      "errors": {
        "sodApprove": "ޕޭމަންޓް ރަނެއް ތައްޔާރުކުރި މީހާއަށް އެއަށް ހުއްދަ ނުދެވޭނެ. އެހެން މީހަކު ހުއްދަ ދޭންވާނެ.",
        "sodExecute": "ޕޭމަންޓް ރަނަކަށް ހުއްދަ ދިނުމުގައި ބައިވެރިވި މީހަކަށް އެ ރަން ދޫކުރެވޭކަށް ނެތް. ހުއްދަ ދިނުމުގައި ބައިވެރި ނުވާ އެހެން މީހަކާ ރަން ހިންގުމަށް އެދޭ.",
        "unresolvable": "މި ރަން ތައްޔާރުކުރި މީހާ ފިޔަވައި އެހެން ހުއްދަދޭ މީހަކު ކަނޑައަޅާފައި ނެތުމުން، މިއަށް ހުއްދަ ނުދެވޭނެ. މި ރަން ބާތިލުކޮށް، ޕޭމަންޓް ރަނަށް ހުއްދަ ދޭ ސިޔާސަތެއް ހެދުމަށް އެޑްމިނިސްޓްރޭޓަރަކާ އެދޭ."
      },
      "void": {
        "action": "ބާތިލުކުރޭ",
        "title": "މި ޕޭމަންޓް ރަން ބާތިލުކުރޭ",
        "description": "އެއްވެސް ފައިސާއެއް ދައްކާފައެއް ނުވޭ. ރަން ބަންދުވެ، އޭގެ ޑޮކިއުމަންޓްތައް އަލުން ދެއްކޭ ހާލަތަށް ދާނެ.",
        "consequence": "މި ރަނުން ހުށަހެޅި ކޮންމެ ޑޮކިއުމަންޓެއް އަލުން ފައިސާ ދެއްކުމަށް މަޑުކުރާ ހާލަތަށް ދާނެ، އަދި ދެން އަންނަ ރަނުގައި ހިމެނިދާނެ. ހިންގާފައިވާ ރަނެއް މިތަނުން ބާތިލެއް ނުކުރެވޭނެ: އޭގެ ބަދަލުގައި ޕޭމަންޓް އެކްސެޕްޝަނެއް ހުށަހަޅާ.",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "ރަނުގެ އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑްކުރެވޭނެ.",
        "reasonRequired": "މި ރަން ބާތިލުކުރާ ސަބަބު ލިޔޭ.",
        "confirm": "ރަން ބާތިލުކުރޭ",
        "done": "ޕޭމަންޓް ރަން ބާތިލުކުރެވިއްޖެ",
        "doneDetail": "އެއްވެސް ފައިސާއެއް ނުދެއްކުނު. އޭގެ ޑޮކިއުމަންޓްތައް އަލުން ދެއްކޭނެ.",
        "failed": "ރަން ބާތިލެއް ނުކުރެވުނު"
      },
      "anomalies": {
        "title": "ހުއްދަ ދިނުމުގެ ކުރިން ކިޔަންވީ {count} ފާހަގަ",
        "description": "ކޮންމެ ޕޭމަންޓެއްގެ މައްޗަށް ކަނޑައެޅިފައިވާ ގަވާއިދުތަކުން އުފެދޭ ފާހަގަ. މިއީ ރަން ހުއްޓުވާ އެއްޗެއް ނޫން؛ ހުއްދަދޭ މީހާ ފުރަތަމަ ބަލަންވީ ކަންތައް.",
        "none": "މި ރަނުގައި އެއްވެސް ފާހަގައެއް ނެތް.",
        "codes": {
          "new_bank_account_cooling_off": "އައު ބޭންކް އެކައުންޓް، އަދި ކޫލިންގ-އޮފްގައި",
          "round_amount": "ފުރިހަމަ އަދަދެއް",
          "first_payment_to_vendor": "މި ވެންޑަރަށް ދައްކާ ފުރަތަމަ ފައިސާ",
          "above_vendor_average": "ވެންޑަރުގެ އެވްރެޖަށް ވުރެ {multiple} ގުނަ ބޮޑު"
        }
      },
      "funds": {
        "shortTitle": "ފައިސާ ދައްކާ އެކައުންޓުގައި ފުދޭވަރަކަށް ފައިސާ ނެތް",
        "shortBody": "މިހާރު އޮތް ގޮތަށް ހިންގައިފިނަމަ އެކައުންޓް ނެގެޓިވްވާނެ. ހުއްދަ ދިނުމުގެ ކުރިން އެކައުންޓަށް ފައިސާ ޖަމާކުރޭ، ނުވަތަ ރަނުން ޕޭމަންޓްތައް ނަގާ.",
        "balance": "ބެލެންސް",
        "covered": "ފައިސާ ދައްކާ އެކައުންޓުގައި މި ރަނަށް ފުދޭ ފައިސާ އެބައޮތް. ބެލެންސް:",
        "unknown": "ފައިސާ ދައްކާ އެކައުންޓުގެ ބެލެންސް ޗެކް ނުކުރެވުނު"
      }
    },
    "bankFile": {
      "title": "ބޭންކް ފައިލް",
      "subject": "އަށްޓަކައި ފައިސާ ދެއްކުން ރަން {runNo}",
      "notVerified": "މި ލޭއައުޓް އީ ނޫން verified statutory format.",
      "editable": "column mapping ގެ \"{profile}\" އީ އެޑިޓްކުރެވޭ ޑޭޓާ, ނޫން ކޯޑް: ބަލާ އެ އާ ދެކޮޅަށް specification ތިޔަ ބޭންކް gave ތިޔަ އަދި ރަނގަޅުކުރޭ ލޭއައުޓް ނަމަ އެ differs. ނެތް release އީ needed.",
      "plaintext": "މި ފައިލް އެކުލެވޭ beneficiary އެކައުންޓް ނަންބަރުތައް ގައި ފުރިހަމަ. އުފައްދަނީ އެ އީ ރެކޯޑްކުރެވިފައި އާ ދެކޮޅަށް ތިޔަ ނަން. ބަލަހައްޓާ އެ like ފައިސާ ދެއްކުން instruction އެ އީ.",
      "profile": "ލޭއައުޓް",
      "filename": "ފައިލް ނަން",
      "rows": "ރޯތައް",
      "sha256": "SHA-256",
      "previewLabel": "ފުރަތަމަ ރޮނގުތައް, exactly ގޮތުގައި ބޭންކް ވާނެ ކިޔާ އެފަރާތްތަކަށް:",
      "previewTruncated": "ހަމައެކަނި ފުރަތަމަ ރޮނގުތައް އީ ދައްކާފައި. ޑައުންލޯޑްކުރޭ ފައިލް އަށްޓަކައި ބާކީ.",
      "download": "ޑައުންލޯޑްކުރޭ ފައިލް",
      "downloaded": "ފައިލް ޑައުންލޯޑްކުރެވިއްޖެ",
      "retry": "އަލުން މަސައްކަތްކުރޭ",
      "working": "Rendering ފައިލް"
    },
    "reports": {
      "company": "ކުންފުނި",
      "companyPlaceholder": "އިޚްތިޔާރުކުރޭ ކުންފުނި",
      "from": "ފެށޭ",
      "to": "ނިމޭ"
    },
    "aging": {
      "title": "އޭޕީ އުމުރު",
      "description": "ކޮން އީ ދަރަނި, އަދި ކިހިނެއް މުއްދަތު ފަހަނައަޅާފައި އެ އީ, ކޮންމެ ސަޕްލަޔަރު.",
      "noPermission": "ތިޔަ ހުއްދަ ނޫން ބަލާ އޭޕީ ރިޕޯޓްތައް.",
      "loadFailed": "އުމުރު schedule ނުކުރެވުނު ނޫން ލޯޑް",
      "caption": "އަދަދުތައް ދަރަނި ކޮންމެ ސަޕްލަޔަރު, ގައި bands ގެ ދުވަސް ފާއިތުވި މުއްދަތު.",
      "asOf": "ގޮތުގައި ގައި",
      "asOfHint": "ދުވަސް ފާއިތުވި މުއްދަތު އީ measured އިން މި ތާރީޚް. މިއަދު, ނަމަ ބާކީ ހުސް.",
      "currencyFilter": "ލިޔުން ފައިސާގެ ބާވަތް",
      "currencyHint": "Narrows އަށް ލިޔުންތައް އުފައްދާފައި ގައި އެއް ފައިސާގެ ބާވަތް. އަދަދުތައް ދެމިހުރޭ ގައި ކުންފުނިގެ އަސާސީ ފައިސާގެ ބާވަތް.",
      "header": "ގޮތުގައި ގައި {date}, ގައި {currency}",
      "tiesTo": "Converted ގައި ކޮންމެ ލިޔުންގެ އަމިއްލަ ޕޯސްޓްކުރެވިފައި ރޭޓް, އެހެންކަމުން grand ޖުމްލަ ties އަށް ދަރަނިތައް ކޮންޓްރޯލް އެކައުންޓް.",
      "empty": "އެއްވެސް އެއްޗެއް އީ ނުދެއްކިހުރި.",
      "drillHint": "ސަޕްލަޔަރުގެ ނަން ހުޅުވާ އެފަރާތްތަކުގެ ލެޖަރ އަދި ސްޓޭޓްމަންޓް, ކޮންތާކު ކޮންމެ ލިޔުން ގެންދޭ ދުވަސް ފާއިތުވި މުއްދަތު އެ put އެ ގައި band. ރޯ ޖުމްލަ ހުޅުވާ ކޮން އެފަރާތްތައް އީ އަދިވެސް ދަރަނި.",
      "columns": {
        "vendor": "ސަޕްލަޔަރު",
        "total": "ޖުމްލަ"
      }
    },
    "ledger": {
      "title": "ލެޖަރ އަދި ސްޓޭޓްމަންޓް",
      "description": "ކޮންމެ ހަރަކާތް އާއެކު ހިނގަމުންދާ ބެލެންސް, އަދި ކޮން އީ އަދިވެސް ހުޅުވާ.",
      "noPermission": "ތިޔަ ހުއްދަ ނޫން ބަލާ އޭޕީ ރިޕޯޓްތައް.",
      "loadFailed": "ސަޕްލަޔަރު ލެޖަރ ނުކުރެވުނު ނޫން ލޯޑް",
      "caption": "ހަރަކާތްތައް މަތީގައި {vendor}'s އެކައުންޓް, އެންމެ ދުވަސްވީ ފުރަތަމަ.",
      "tabsLabel": "ލެޖަރ ނުވަތަ ސްޓޭޓްމަންޓް",
      "tabs": {
        "ledger": "ލެޖަރ",
        "statement": "ސްޓޭޓްމަންޓް"
      },
      "fromHint": "ތިން މަސް ފަހަތަށް, ނަމަ ބާކީ ހުސް.",
      "window": "{from} އަށް {to}",
      "opening": "ހުޅުވުނު ބެލެންސް",
      "closing": "ބަންދުވި ބެލެންސް",
      "empty": "އެއްވެސް އެއްޗެއް ގުޑައިފި ގައި މި މުއްދަތު.",
      "unnumbered": "ނަންބަރު ނުދޭ",
      "viewJournal": "ޖާނަލް",
      "columns": {
        "date": "ތާރީޚް",
        "document": "ލިޔުން",
        "description": "ތަފްޞީލު",
        "debit": "ޑެބިޓް",
        "credit": "ކްރެޑިޓް",
        "balance": "ބެލެންސް",
        "journal": "ޕޯސްޓްކުރެވިފައި ފަރާތުން"
      }
    },
    "statement": {
      "loadFailed": "ސްޓޭޓްމަންޓް ނުކުރެވުނު ނޫން ލޯޑް",
      "caption": "ލިޔުންތައް ގެ {vendor} އެ އީ އަދިވެސް ހުޅުވާ.",
      "asOf": "ހުޅުވާ ލިޔުންތައް ގޮތުގައި ގައި {date}",
      "empty": "އެއްވެސް އެއްޗެއް އީ ހުޅުވާ.",
      "totalFor": "ޖުމްލަ ގައި {currency}",
      "columns": {
        "document": "ލިޔުން",
        "date": "ތާރީޚް",
        "dueDate": "މުއްދަތު",
        "currency": "ފައިސާގެ ބާވަތް",
        "total": "ޖުމްލަ",
        "paid": "ދައްކާފައި",
        "outstanding": "ނުދެއްކިހުރި",
        "daysPastDue": "ދުވަސް ލަސް"
      }
    },
    "routeTitles": {
      "signals": "އޭޕީ ސިގްނަލްތައް",
      "paymentExceptions": "ޕޭމަންޓް އެކްސެޕްޝަންތައް",
      "supplierStatement": "ސަޕްލަޔަރުގެ ސްޓޭޓްމަންޓް",
      "statementReconciliation": "ސްޓޭޓްމަންޓް ރިކޮންސައިލްކުރުން",
      "withholding": "ވިތްހޯލްޑިންގ ޓެކްސް ރަޖިސްޓަރު",
      "duplicatePayments": "ދެފަހަރު ދެއްކުނު ފައިސާގެ ތަހުލީލު",
      "settings": "އޭޕީ ސެޓިންގްސް"
    },
    "coolingOff": {
      "requested": "ބަދަލަށް އެދިފައި",
      "approved": "ހުއްދަ ދެވިފައި",
      "effective": "ފައިސާ ދެއްކޭ ތާރީޚު",
      "applied": "ވެންޑަރަށް ލެވިފައި",
      "releasedEarly": "ކޫލިންގ-އޯފް ކުރުކުރެވިފައި",
      "releasedMeta": "{at} — {reason}",
      "notYet": "އަދި ނުވޭ",
      "waiting": "{at} — ބާކީ {hours} ގަޑިއިރު",
      "window": "{hours} ގަޑިއިރުގެ ދޮރު",
      "activeBanner": "މި އެކައުންޓަށް އަދި {hours} ގަޑިއިރު ފައިސާއެއް ނުދެއްކޭނެ. {account} ހިމެނޭ ޕޭމަންޓް ރަން ގަބޫލެއް ނުކުރެވޭނެ.",
      "release": "އަވަހަށް ދޫކުރޭ",
      "releaseTitle": "ކޫލިންގ-އޯފް ކުރުކުރޭ",
      "releaseDescription": "އެކައުންޓަށް ވަގުތުން ފައިސާ ދެއްކޭނެ.",
      "releaseWarning": "ކޫލިންގ-އޯފް ދޮރަކީ ހަގީގީ ވެންޑަރަށް މަކަރުވެރި ބަދަލެއް ފާހަގަކުރަން ލިބޭ ވަގުތު. އަވަހަށް ދޫކުރުން ނަމުގައި ރެކޯޑްވާނެ، އަދި އަމިއްލައަށް ހުއްދަ ދިން ބަދަލެއް ދޫކުރެވޭކަށް ނޯންނާނެ.",
      "reason": "ސަބަބު",
      "released": "ކޫލިންގ-އޯފް ދޫކުރެވިއްޖެ",
      "releaseFailed": "ކޫލިންގ-އޯފް ދޫކުރެވޭގޮތެއް ނުވި"
    },
    "signals": {
      "title": "އޭޕީ ސިގްނަލްތައް",
      "description": "ހުށަހަޅާ ކޮންމެ އިންވޮއިސްއަކަށް އެގާރަ ޗެކް. ސްކޯއެއް ނޫން — ކޮންމެ އެއްޗަކީ ކަށަވަރުކުރެވޭ ބަޔާނެއް.",
      "loadFailed": "ސިގްނަލްތައް ލޯޑެއް ނުކުރެވުނު",
      "tabInbox": "އިންބޮކްސް",
      "tabSettings": "ސެޓިންގ",
      "tabsLabel": "ސިގްނަލް ވިއުތައް",
      "signal": "ސިގްނަލް",
      "severity": "ބާރުމިން",
      "enabled": "ހުޅުވިފައި",
      "invoice": "އިންވޮއިސް",
      "related": "ގުޅުންހުރި",
      "detectedAt": "ފެނުނު",
      "anySignal": "ކޮންމެ ސިގްނަލެއް",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "blockingBanner": "{count} ހުއްޓުވާ ސިގްނަލް ހުޅުވިފައި. ކޮންމެ އެއްޗަކުން އިންވޮއިސްއެއް ޕޭމަންޓް ރަންއިން ބޭރުގައި ހިފަހައްޓާ.",
      "tableLabel": "އޭޕީ އިންވޮއިސް ސިގްނަލްތައް",
      "emptyTitle": "ފާހަގަކުރެވުނު އެއްޗެއް ނެތް",
      "emptyDescription": "ސިގްނަލް ނަގަނީ ހުށަހަޅާ ވަގުތު. ހުސް އިންބޮކްސްއަކީ ހުރިހާ އިންވޮއިސްއެއް އާދައިގެ ކަމުގެ ނިޝާނެއް.",
      "dispose": "ނިންމާ",
      "disposeTitle": "ސިގްނަލްއެއް ނިންމާ",
      "disposeHint": "ސިގްނަލްއަކީ ދޮގު ފާހަގައެއް ނުވަތަ ހަގީގަތެއް. ކޮންއެއްޗެއްކަން ބުނުމުން މަހެއްގެ އަދަދު ގުނޭ.",
      "disposition": "ނަތީޖާ",
      "dispositions": {
        "cleared": "ދޮގު ފާހަގައެއް",
        "confirmed": "ކަށަވަރު — ހަގީގަތެއް"
      },
      "clearedHint": "އިންވޮއިސް ކުރިއަށްދާނެ.",
      "confirmedHint": "އިންވޮއިސް ހުއްޓިފައި ހުންނާނެ، އަދި ހޯދުން ރެކޯޑްވާނެ.",
      "reason": "ސަބަބު",
      "disposed": "ސިގްނަލް ނިންމިއްޖެ",
      "disposeFailed": "ސިގްނަލް ނުނިންމުނު",
      "statuses": {
        "open": "ހުޅުވިފައި",
        "cleared": "ސާފުކުރެވިފައި",
        "confirmed": "ކަށަވަރުކުރެވިފައި"
      },
      "severities": {
        "info": "ފާހަގަ",
        "warn": "އިންޒާރު",
        "block": "ހުއްޓުވާ"
      },
      "settingsTitle": "ކޮން ސިގްނަލެއް ހިނގާނެކަމާއި ކިހާ ބާރަށް",
      "settingsDescription": "އެގާރަ ސިގްނަލް، ދުވަހަކުވެސް ނުހިނގާ ސިގްނަލްތައް ހިމެނޭގޮތަށް.",
      "settingsSaved": "ސިގްނަލް ސެޓިންގ ރައްކާކުރެވިއްޖެ",
      "settingsSaveFailed": "ސިގްނަލް ސެޓިންގ ރައްކާއެއް ނުކުރެވުނު",
      "chooseCompanyTitle": "ކުންފުންޏެއް ހޮވާ",
      "chooseCompanyDescription": "ސިގްނަލް ސެޓިންގ އަކީ ކުންފުންޏަކަށް ވަކިން.",
      "codes": {
        "duplicate_exact": "ސީދާ ޑުޕްލިކޭޓް",
        "near_duplicate_number": "ދާދި އެއްގޮތް ނަންބަރު",
        "duplicate_amount_date": "އެއް އަދަދު، އެއް ތާރީޚު",
        "round_sum": "ޝައްކުވާ ވަރަށް ސާފު އަދަދު",
        "fresh_vendor": "މުޅިން އައު ވެންޑަރު",
        "bank_change_recent": "ދާދިފަހުން ބޭންކް ބަދަލުވެފައި",
        "just_below_threshold": "ހުއްދައިގެ މިންގަނޑަށްވުރެ ކުޑަކޮށް ދަށުގައި",
        "non_business_day_entry": "ބަންދު ދުވަހެއްގައި އެންޓަރކުރެވިފައި",
        "sequential_numbering": "ތަރުތީބުން ދާ އިންވޮއިސް ނަންބަރު",
        "no_po_over_threshold": "ޕީއޯއެއް ނެތި، މިންގަނޑަށްވުރެ މަތީގައި",
        "tax_without_registration": "ރަޖިސްޓްރީނުވެ ޓެކްސް ނަގާފައި"
      },
      "explain": {
        "duplicate_exact": "ފައިލްގައި އޮތް އިންވޮއިސްއަކާ އެއް ވެންޑަރެއް، އެއް ނަންބަރެއް.",
        "near_duplicate_number": "މިހާރު އޮތް ނަންބަރަކާ އެއް އަކުރު ތަފާތު ނަންބަރެއް.",
        "duplicate_amount_date": "އެއް ވެންޑަރު، އެއް އަދަދު، އެއް ތާރީޚު.",
        "round_sum": "ސެންޓެއް ނެތް، އޮނަހިރި ޑިޖިޓެއް ނެތް އަދަދެއް.",
        "fresh_vendor": "ދުވަސްކޮޅެއް ކުރިން ހަދާފައިވާ ވެންޑަރަކަށް މިހާރު ފައިސާ ދެއްކެނީ.",
        "bank_change_recent": "މި އިންވޮއިސްގެ ކުޑަ ދުވަސްކޮޅެއް ކުރިން ވެންޑަރުގެ އެކައުންޓް ބަދަލުވެފައި.",
        "just_below_threshold": "ހުއްދައިގެ ބޭންޑް ފަހަނައަޅާ ނުދާ ވަރަށް ދަށުގައި އޮތް އަދަދެއް.",
        "non_business_day_entry": "ބިޒްނަސް ކަލަންޑަރުން ބަންދު ދުވަހެއްގައި އެންޓަރކުރެވިފައި.",
        "sequential_numbering": "މި ވެންޑަރުގެ ނަންބަރުތައް ތަރުތީބުން އައުމުން، އަހަރެމެންނަކީ އެމީހުންގެ ހަމައެކަނި ކަސްޓަމަރު ކަމަށް ބެލެވޭ.",
        "no_po_over_threshold": "ޕީއޯ ބޭނުންވާ އަދަދަށްވުރެ މަތީގައި، ޕީއޯއެއް ނެތި.",
        "tax_without_registration": "ޓެކްސް ރަޖިސްޓްރީއެއް ނެތް ވެންޑަރަކުން ޓެކްސް ނަގާފައި."
      },
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ސިގްނަލް ސެޓިންގްސް ބަދަލުކޮށްފި. ކަމެއް ނުފޮހެވޭ. ރައްކާކުރެވިފައިވާ ސެޓިންގްސް އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ރައްކާކުރެވިފައިވާ ސެޓިންގްސް އަލުން ލޯޑްކުރޭ"
    },
    "exceptions": {
      "title": "ޕޭމަންޓް އެކްސެޕްޝަންތައް",
      "description": "އަނބުރާ އައި، އަނބުރާ ގެނެވުނު، ނުވަތަ ނުދިޔަ ޕޭމަންޓެއް. ކޮންމެ ބާވަތެއް ޕޯސްޓްވަނީ ތަފާތުކޮށް.",
      "loadFailed": "ޕޭމަންޓް އެކްސެޕްޝަންތައް ލޯޑެއް ނުކުރެވުނު",
      "raisedOn": "ނެގި",
      "kind": "ބާވަތް",
      "kindHint": "ހަގީގަތުގައި ވީގޮތް ބަޔާންކުރާ ބާވަތް ހޮވާ — ޕޯސްޓިންގ އަންނަނީ އެއިން.",
      "payment": "ޕޭމަންޓް",
      "amount": "އަދަދު",
      "reason": "ސަބަބު",
      "bankReasonCode": "ބޭންކުގެ ސަބަބު ކޯޑް",
      "bankReasonHint": "ބޭންކުން ދިން އެއްޗެއް އެގޮތަށް. ބޭންކާ ދެކޮޅަށް ދައުވާކުރެވެނީ މިއިން.",
      "bankSaid": "ބޭންކް: {code}",
      "reference": "ރެފަރެންސް",
      "journal": "ޖާނަލް",
      "nothingPosted": "އެއްޗެއް ޕޯސްޓްވެފައި ނުވޭ",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "note": "ނޯޓް",
      "tableLabel": "އޭޕީ ޕޭމަންޓް އެކްސެޕްޝަންތައް",
      "emptyTitle": "ޕޭމަންޓް އެކްސެޕްޝަނެއް ނެތް",
      "emptyDescription": "ހުރިހާ ޕޭމަންޓެއް ސެޓްލްވެއްޖެ. ބޭންކުން ފައިސާ އަނބުރާ އައުމުން މިތާ އެއް ނަގާ.",
      "raise": "އެކްސެޕްޝަނެއް ނަގާ",
      "raiseTitle": "ޕޭމަންޓް އެކްސެޕްޝަނެއް ނަގާ",
      "raiseDescription": "މިއިން ވެންޑަރަށް ދޭންޖެހޭ އަދަދު ބަދަލުވާތީ ދެވަނަ ފެކްޓަރު ބޭނުންވާނެ.",
      "raised": "ޕޭމަންޓް އެކްސެޕްޝަން ނެގިއްޖެ",
      "raiseFailed": "ޕޭމަންޓް އެކްސެޕްޝަން ނުނެގުނު",
      "resolve": "ހައްލުކުރޭ",
      "resolveTitle": "ޕޭމަންޓް އެކްސެޕްޝަން ހައްލުކުރޭ",
      "resolved": "ޕޭމަންޓް އެކްސެޕްޝަން ހައްލުކުރެވިއްޖެ",
      "resolveFailed": "ޕޭމަންޓް އެކްސެޕްޝަން ހައްލެއް ނުކުރެވުނު",
      "kinds": {
        "returned": "އަނބުރާ އައި",
        "recalled": "އަނބުރާ ގެނެވުނު",
        "rejected": "ބޭރުކުރެވުނު",
        "stopped": "ހުއްޓުވުނު",
        "restored": "އިއާދަކުރެވުނު"
      },
      "posting": {
        "returned": "ސެޓްލްވުމަށްފަހު ބޭންކުން ފައިސާ އަނބުރާ ފޮނުވި. ދޭންޖެހޭ އަދަދު ސީދާ އިއާދަވާނެ.",
        "recalled": "އަހަރެމެން އެދިގެން ބޭންކުން އަނބުރާ ގެނައި. ދޭންޖެހޭ އަދަދު ސީދާ އިއާދަވާނެ.",
        "rejected": "ވެލިއު ޑޭޓްގެ ކުރިން ބޭންކުން އިންސްޓްރަކްޝަން ބޭރުކުރި. ދޭންޖެހޭ އަދަދު އިއާދަވާނެ.",
        "stopped": "ފައިސާ ދިއުމުގެ ކުރިން އިންސްޓްރަކްޝަން ނެގުނު. އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުވާނެ.",
        "restored": "ކުރީގެ އެކްސެޕްޝަނެއް ބަންދުކުރާ އިސްލާހު."
      },
      "statuses": {
        "open": "ހުޅުވިފައި",
        "resolved": "ހައްލުކުރެވިފައި",
        "cancelled": "ބާތިލްކުރެވިފައި"
      }
    },
    "reportsFt10": {
      "export": "ސީއެސްވީ އެކްސްޕޯޓްކުރޭ",
      "rangeInvalid": "ފެށޭ ތާރީޚު ނިމޭ ތާރީޚަށް ވުރެ ފަހު.",
      "chooseCompanyTitle": "ގާނޫނީ ފަރާތެއް ހޮވާ"
    },
    "supplierStatement": {
      "title": "ސަޕްލަޔަރުގެ ސްޓޭޓްމަންޓް",
      "description": "ސަޕްލަޔަރެއްގެ ޑޮކިއުމަންޓްތައް، އިންވޮއިސްކުރި، ދެއްކި އަދި ބާކީ އޮތް އަދަދާއެކު، ތާރީޚަކަށް.",
      "toReconciliation": "ސަޕްލަޔަރެއްގެ ސްޓޭޓްމަންޓް ރިކޮންސައިލްކުރޭ",
      "fromHint": "މި ދުވަހު ނުވަތަ އޭގެ ފަހުން ތާރީޚުކޮށްފައިވާ ޑޮކިއުމަންޓްތައް. ހުސްކޮށް ބާއްވައިފިނަމަ ހުރިހާ އެއްޗެއް.",
      "asOf": "ތާރީޚަށް",
      "asOfHint": "ހުސްކޮށް ބާއްވައިފިނަމަ މިއަދު.",
      "openOnly": "ބާކީ ހުރި އައިޓަމް އެކަނި",
      "openOnlyHint": "މުޅިން ދައްކާފައިވާ ޑޮކިއުމަންޓްތައް ދޫކޮށްލާ.",
      "tableTitle": "ސްޓޭޓްމަންޓް",
      "chooseTitle": "ސަޕްލަޔަރެއް ހޮވާ",
      "chooseDescription": "ސްޓޭޓްމަންޓް ބެލުމަށް މަތިން ގާނޫނީ ފަރާތާއި ސަޕްލަޔަރު ހޮވާ: ކޮންމެ ޑޮކިއުމަންޓެއް، އޭގެ ތެރެއިން ދެއްކި އަދަދު އަދި އަދިވެސް ބާކީ އޮތް އަދަދު.",
      "emptyTitle": "މި ސްޓޭޓްމަންޓުގައި އެއްޗެއް ނެތް",
      "emptyOpenTitle": "މި ސަޕްލަޔަރަށް ބާކީ އޮތް އެއްޗެއް ނެތް",
      "emptyDescription": "މި މުއްދަތުގައި ޕޯސްޓްކުރެވިފައިވާ ޑޮކިއުމަންޓެއް ނެތް. ތާރީޚުތައް ފުޅާކުރޭ، ނުވަތަ ސަޕްލަޔަރުގެ ޑޮކިއުމަންޓްތައް ސަޕްލަޔަރ އިންވޮއިސްތަކުގައި ބަލާ.",
      "header": "{vendor}، {date} އަށް"
    },
    "duplicatePayments": {
      "title": "ދެފަހަރު ދެއްކުނު ފައިސާގެ ތަހުލީލު",
      "description": "ހަމަ އެއް ފައިސާ ދެފަހަރު ދެއްކި ކަމަށް ފެންނަ ޕޭމަންޓްތައް، ޝައްކުކުރި ސަބަބާއެކު، އަދި ހުއްޓުވުނު ދެފަހަރުގެ ޕޭމަންޓްތައް.",
      "toExceptions": "ޕޭމަންޓް އެކްސެޕްޝަންތައް",
      "toHint": "ހުސްކޮށް ބާއްވައިފިނަމަ މިއަދު.",
      "window": "އަޅާކިޔާ މުއްދަތު (ދުވަސް)",
      "windowHint": "އެއް ވެންޑަރަށް މިހާ ދުވަހުގެ ތެރޭގައި ދައްކާ ހަމަ އެއް އަދަދުގެ ޕޭމަންޓްތައް އަޅާކިޔޭނެ. {min} އިން {max} އަށް؛ ހުސްނަމަ 7.",
      "windowInvalid": "{min} އިން {max} އަށް ފުރިހަމަ ދުވަހުގެ އަދަދެއް ލިޔޭ، ނުވަތަ ޑިފޯލްޓަށް ހުސްކޮށް ބާއްވާ.",
      "chooseDescription": "ހިންގާފައިވާ ޕޭމަންޓްތަކުގައި ދެފަހަރު ދެއްކުނު ފައިސާ ހޯދުމަށް މަތިން ގާނޫނީ ފަރާތެއް ހޮވާ.",
      "loadFailed": "ދެފަހަރު ދެއްކުނު ފައިސާގެ ތަހުލީލު ލޯޑުނުވި",
      "scope": "{from} އިން {to} އަށް، އެކަކު އަނެކަކާ {days} ދުވަހުގެ ތެރޭގައި ދައްކާ ޕޭމަންޓް: {suspected} ޝައްކު، {prevented} ހުއްޓުވުނު.",
      "suspectedTitle": "ދެފަހަރު ދެއްކިކަމަށް ޝައްކުކުރެވޭ ({count})",
      "suspectedDescription": "އެއް ވެންޑަރަށް، އެއް ފައިސާއިން، އެއް ނެޓް އަދަދަށް، މުއްދަތުގެ ތެރޭގައި ނުވަތަ އެއް ރެފަރެންސްގައި ހިންގާފައިވާ ޕޭމަންޓްތައް. އެކަކު ފިޔަވައި ހުރިހާ އެއްޗަކީ ދެފަހަރުގެ ޕޭމަންޓްނަމަ ގެއްލޭނެ އަދަދަކީ ރިސްކު.",
      "suspectedEmptyTitle": "ޝައްކުކުރެވޭ ދެފަހަރުގެ ޕޭމަންޓެއް ނެތް",
      "suspectedEmptyDescription": "މި މުއްދަތުގައި ހިންގާފައިވާ ދެ ޕޭމަންޓެއް ހަމަ އެއް ފައިސާ ދެފަހަރު ދެއްކި ކަމަށް ނުފެނޭ. މުއްދަތު ބޮޑުކޮށްފިނަމަ ދުރުގައި ހުރި ޕޭމަންޓްތައް އަޅާކިޔޭނެ.",
      "suspectedCaption": "ދެފަހަރު ދެއްކިކަމަށް ޝައްކުކުރެވޭ ޕޭމަންޓްތަކުގެ ގްރޫޕްތައް، ސަބަބާއެކު.",
      "preventedTitle": "ހުއްޓުވުނު ދެފަހަރުގެ ޕޭމަންޓް ({count})",
      "preventedDescription": "ޕޭމަންޓަކީ އެހެން ޕޭމަންޓެއްގެ ތަކުރާރު ކަމުގައިވާތީ ހުށަހެޅި ޕޭމަންޓް އެކްސެޕްޝަންތައް.",
      "preventedEmptyTitle": "ހުއްޓުވުނު ދެފަހަރުގެ ޕޭމަންޓެއް ނެތް",
      "preventedEmptyDescription": "ދެފަހަރުގެ ޕޭމަންޓެއް ހިފުމުން، 'ދެފަހަރުގެ ޕޭމަންޓް' ސަބަބާއެކު ޕޭމަންޓް އެކްސެޕްޝަނެއް ހުށަހަޅާ، އޭރުން އެ މިތަނުގައި ގުނޭނެ.",
      "preventedCaption": "ދެފަހަރުގެ ޕޭމަންޓަށް ހުށަހެޅި ޕޭމަންޓް އެކްސެޕްޝަންތައް.",
      "columns": {
        "reason": "ފާހަގަވި ސަބަބު",
        "payments": "ޕޭމަންޓްތައް",
        "exposure": "ރިސްކު"
      },
      "reasons": {
        "same_reference": "ހަމަ އެއް ރެފަރެންސް",
        "same_amount_within_window": "{days} ދުވަހުގެ ތެރޭގައި ހަމަ އެއް އަދަދު"
      }
    },
    "withholding": {
      "title": "ވިތްހޯލްޑިންގ ޓެކްސް ރަޖިސްޓަރު",
      "description": "ސަޕްލަޔަރުންގެ ކިބައިން ހިފެހެއްޓި ޓެކްސް، މުއްދަތާއި އޮތޯރިޓީގެ ދަށުން، އަދި އެ ދައްކާފައިވޭތޯ.",
      "noPermission": "ވިތްހޯލްޑިންގ ޓެކްސް ރަޖިސްޓަރު ބެލުމުގެ ހުއްދައެއް ނެތް.",
      "authorityHint": "އޮތޯރިޓީގެ ކޯޑު، މިސާލަކަށް MIRA. ހުސްނަމަ ހުރިހާ އޮތޯރިޓީއެއް.",
      "filterByState": "ރެމިޓަންސް ހާލަތުން ފިލްޓަރކުރޭ",
      "states": {
        "unremitted": "ނުދައްކާ",
        "draft": "ޑްރާފްޓް ރެމިޓަންސެއްގައި",
        "remitted": "ދައްކާފައި"
      },
      "chooseDescription": "ހިފެހެއްޓި ޓެކްސާއި ދައްކާފައިވާ އަދަދު ބެލުމަށް މަތިން ގާނޫނީ ފަރާތެއް ހޮވާ.",
      "registerTitle": "ހިފެހެއްޓި",
      "selection": "{authority} އަށް {count} ހޮވިފައި",
      "clearSelection": "ފޮހެލާ",
      "draftRemittance": "ރެމިޓަންސެއްގެ ޑްރާފްޓް ހަދާ",
      "loadFailed": "ވިތްހޯލްޑިންގ ރަޖިސްޓަރު ލޯޑުނުވި",
      "emptyTitle": "މި މުއްދަތުގައި އެއްވެސް ޓެކްސެއް ހިފެހެއްޓިފައެއް ނުވޭ",
      "emptyDescription": "ވިތްހޯލްޑިންގ ރެކޯޑްކުރެވެނީ އެ ކަނޑާ ޕޭމަންޓް ރަނެއް ހިންގުމުން. ތާރީޚުތައް ފުޅާކުރޭ ނުވަތަ ފިލްޓަރތައް ފޮހެލާ.",
      "header": "{from} އިން {to} އަށް؛ ބޭސް ފައިސާގެ އަދަދުތައް {currency} އިން",
      "caption": "ސަޕްލަޔަރުންނަށް ދައްކާ ފައިސާއިން ކެނޑި ވިތްހޯލްޑިންގ، ރެމިޓަންސް ހާލަތާއެކު.",
      "totalsCaption": "އޮތޯރިޓީގެ ދަށުން ވިތްހޯލްޑިންގ: ހިފެހެއްޓި، ދައްކާފައި، ޑްރާފްޓްގައި އަދި ބާކީ.",
      "oneAuthority": "ރެމިޓަންސެއްގައި ދައްކަނީ އެއް އޮތޯރިޓީއަކަށް. އެހެން އޮތޯރިޓީއެއް ހޮވުމަށް ހޮވާފައިވާ އެއްޗެއް ފޮހެލާ.",
      "selectRow": "{invoice} ހޮވާ",
      "selectAuthority": "ނުދައްކާ ހުރިހާ އެއްޗެއް ހޮވާ",
      "termsMissing": "ރޭޓެއް ރެކޯޑުގައި ނެތް",
      "termsMissingHint": "މި ރެކޯޑަކީ ރޭޓް އޭނާއާއެކު ރައްކާކުރަން ފެށުމުގެ ކުރީގެ ރެކޯޑެއް؛ އަދަދަކީ ހިފެހެއްޓި އަދަދު.",
      "exportFailed": "ރަޖިސްޓަރު އެކްސްޕޯޓްނުކުރެވުނު",
      "columns": {
        "select": "ހޮވާ",
        "withheldOn": "ހިފެހެއްޓި ތާރީޚު",
        "period": "މުއްދަތު",
        "invoice": "އިންވޮއިސް",
        "code": "ކޯޑާއި ރޭޓް",
        "authority": "އޮތޯރިޓީ",
        "base": "ބޭސް",
        "withheld": "ހިފެހެއްޓި",
        "withheldBase": "ހިފެހެއްޓި ({currency})",
        "state": "ރެމިޓަންސް",
        "records": "ރެކޯޑްތައް",
        "remitted": "ދައްކާފައި",
        "inDraft": "ޑްރާފްޓްގައި",
        "outstanding": "ބާކީ"
      },
      "create": {
        "title": "{authority} އަށް ރެމިޓަންސެއްގެ ޑްރާފްޓް ހަދާ",
        "description": "އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭ. ތިބާ ނޫން މީހަކު ޕޯސްޓްކުރުމުން، ބޭންކުން އޮތޯރިޓީއަށް ފައިސާ ދެއްކޭނެ.",
        "selection": "ވިތްހޯލްޑިންގ ރެކޯޑް {count} ހޮވިފައި.",
        "preview": "ހޮވާފައިވާ، ބޭސް ފައިސާއިން:",
        "previewNote": "މިއީ ޕްރިވިއު އެކެވެ. ސަރވަރު އަދަދު ރެކޯޑްކުރަނީ ކޮންމެ ރެކޯޑެއްގެ ޕޯސްޓްކުރެވިފައިވާ ބައިން، އަދި ޕޯސްޓްވާނީ އެ އަދަދު.",
        "period": "މުއްދަތު",
        "periodHint": "ދައްކާ މަސް، YYYY-MM ގޮތަށް. ކޮންމެ ރެކޯޑެއް އޭގެ ނިމުމާ ހަމައަށް ހިފެހެއްޓިފައި ހުންނަންވާނެ.",
        "periodInvalid": "މަސް YYYY-MM ގޮތަށް ލިޔޭ، މިސާލަކަށް 2026-08.",
        "bankAccount": "ދައްކާ އެކައުންޓް",
        "bankAccountHint": "{currency} ގެ ހަރަކާތްތެރި ބޭންކް އެކައުންޓެއް.",
        "noBankRead": "ބޭންކް އެކައުންޓްތައް ލިސްޓު ނުކުރެވޭނެ. ކޭޝް އަދި ބޭންކް އެކައުންޓް ކިޔުމުގެ ހުއްދައަށް އެދޭ.",
        "bankAccountPlaceholder": "ފައިސާ ނިކުންނަ އެކައުންޓް ހޮވާ",
        "bankRequired": "ރެމިޓަންސް ދައްކާ ބޭންކް އެކައުންޓް ހޮވާ.",
        "remittanceDate": "ރެމިޓަންސް ތާރީޚު",
        "remittanceDateHint": "އޮތޯރިޓީއަށް ފައިސާ ދައްކާ ދުވަސް. އެއްވެސް ރެކޯޑެއް ހިފެހެއްޓުމުގެ ކުރިން ނުވާނެ.",
        "dateRequired": "ތާރީޚު ލިޔޭ.",
        "reference": "ރެފަރެންސް",
        "memo": "މެމޯ",
        "confirm": "ރެމިޓަންސްގެ ޑްރާފްޓް ހަދާ",
        "done": "ރެމިޓަންސް {number} ގެ ޑްރާފްޓް ހެދިއްޖެ",
        "doneDetail": "އެހެން މީހަކު ޕޯސްޓްކުރާނދެން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެ."
      },
      "remittances": {
        "title": "ރެމިޓަންސްތައް",
        "description": "އެކަކު ޑްރާފްޓްކޮށް، އަނެކަކު ޕޯސްޓްކުރޭ. ޕޯސްޓްކުރުމުން ބޭންކުން އޮތޯރިޓީއަށް ފައިސާ ދެއްކޭ؛ ރިވަރސްކުރުމުން އެ އަނބުރާ ލިބޭ.",
        "filterByStatus": "ހާލަތުން ފިލްޓަރކުރޭ",
        "loadFailed": "ރެމިޓަންސްތައް ލޯޑުނުވި",
        "emptyTitle": "އަދި ރެމިޓަންސެއް ނެތް",
        "emptyDescription": "މަތީގައިވާ ރަޖިސްޓަރުން އޮތޯރިޓީއަކަށް ދައްކަންޖެހޭ ރެކޯޑްތައް ހޮވައި ރެމިޓަންސެއްގެ ޑްރާފްޓް ހަދާ.",
        "draftNo": "ޑްރާފްޓް #{id}",
        "viewJournal": "ޖާރނަލް",
        "statuses": {
          "draft": "ޑްރާފްޓް",
          "posted": "ޕޯސްޓްކުރެވިފައި",
          "cancelled": "ކެންސަލްކުރެވިފައި",
          "reversed": "ރިވަރސްކުރެވިފައި"
        },
        "columns": {
          "number": "ރެމިޓަންސް",
          "date": "ތާރީޚު",
          "items": "ރެކޯޑްތައް",
          "amount": "އަދަދު",
          "journal": "ޖާރނަލް",
          "actions": "ޢަމަލުތައް"
        },
        "post": "ޕޯސްޓްކުރޭ",
        "cancel": "ޑްރާފްޓް ކެންސަލްކުރޭ",
        "reverse": "ރިވަރސްކުރޭ",
        "postTitle": "މި ރެމިޓަންސް ޕޯސްޓްކުރޭ",
        "cancelTitle": "މި ޑްރާފްޓް ކެންސަލްކުރޭ",
        "reverseTitle": "މި ރެމިޓަންސް ރިވަރސްކުރޭ",
        "postConsequence": "ޕޯސްޓްކުރުމުން ވިތްހޯލްޑިންގ ޓެކްސް ދައްކަންޖެހޭ އެކައުންޓް ޑެބިޓްވެ ބޭންކް ކްރެޑިޓްވާނެ: އޮތޯރިޓީއަށް ފައިސާ ދެއްކޭނެ. ދެވަނަ ފެކްޓަރެއް ބޭނުންވޭ.",
        "cancelConsequence": "ޑްރާފްޓް ބަންދުވެ، އޭގެ ރެކޯޑްތައް އެހެން ޑްރާފްޓަކުން ދެއްކޭނެ. އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވުނު.",
        "reverseConsequence": "މިރަރ ޖާރނަލަކުން ފައިސާ އަނބުރާ ބޭންކަށް، އަދި ލައިބިލިޓީ އަނބުރާ ވިތްހޯލްޑިންގ ޓެކްސް ދައްކަންޖެހޭ އެކައުންޓަށް ލާނެ. ދެވަނަ ފެކްޓަރެއް ބޭނުންވޭ.",
        "referenceHint": "އޮތޯރިޓީގެ ރަސީދު ނުވަތަ ބޭންކް ރެފަރެންސް، އެނގޭނަމަ.",
        "reason": "ސަބަބު",
        "reasonRequired": "ސަބަބު ލިޔޭ.",
        "reversalDate": "ރިވަރސްކުރާ ތާރީޚު",
        "reversalDateHint": "ހުސްކޮށް ބާއްވައިފިނަމަ މިއަދު.",
        "postConfirm": "ރެމިޓަންސް ޕޯސްޓްކުރޭ",
        "cancelConfirm": "ޑްރާފްޓް ކެންސަލްކުރޭ",
        "reverseConfirm": "ރެމިޓަންސް ރިވަރސްކުރޭ",
        "posted": "ރެމިޓަންސް ޕޯސްޓްކުރެވިއްޖެ",
        "postedDetail": "އޮތޯރިޓީއަށް ފައިސާ ދެއްކި، ރެކޯޑްތައް ދައްކާފައިވާ ހާލަތަށް ދިޔައީ.",
        "cancelled": "ޑްރާފްޓް ކެންސަލްކުރެވިއްޖެ",
        "cancelledDetail": "އޭގެ ރެކޯޑްތައް އަލުން ދެއްކޭނެ.",
        "reversed": "ރެމިޓަންސް ރިވަރސްކުރެވިއްޖެ",
        "reversedDetail": "އޭގެ ރެކޯޑްތައް އަލުން އޮތޯރިޓީއަށް ދައްކަންޖެހޭ.",
        "preparedByYou": "މި ރެމިޓަންސް ތައްޔާރުކުރީ ތިބާ، އެހެންވީމާ ޕޯސްޓްކުރަންވާނީ އެހެން މީހަކު.",
        "postedByYou": "މި ރެމިޓަންސް ޕޯސްޓްކުރީ ތިބާ، އެހެންވީމާ ރިވަރސްކުރަންވާނީ އެހެން މީހަކު."
      },
      "errors": {
        "sodPost": "ރެމިޓަންސެއް ޕޯސްޓްކުރަންވާނީ އެ ތައްޔާރުކުރި މީހާ ނޫން އެހެން މީހަކު.",
        "sodReverse": "ރެމިޓަންސެއް ރިވަރސްކުރަންވާނީ އެ ޕޯސްޓްކުރި މީހާ ނޫން އެހެން މީހަކު.",
        "alreadyRemitted": "މި ރެކޯޑްތަކުގެ ތެރެއިން އެއްޗެއް އެހެން ރެމިޓަންސަކުން ދައްކާފައިވޭ. ރަޖިސްޓަރު ރިފްރެޝްކޮށް އަލުން ޑްރާފްޓް ހަދާ."
      }
    },
    "statementRecon": {
      "title": "ސްޓޭޓްމަންޓް ރިކޮންސައިލްކުރުން",
      "description": "ސަޕްލަޔަރު ބުނާ ގޮތުގައި އަހަރެމެން ދައްކަންޖެހޭ އަދަދު، ސްޓޭޓްމަންޓް ތާރީޚަށް އަހަރެމެންގެ ލެޖަރާ އަޅާކިޔައި، ކޮންމެ ތަފާތެއް ވަކިވަކިން.",
      "toStatement": "ސަޕްލަޔަރުގެ ސްޓޭޓްމަންޓް",
      "vendorHint": "ހުސްނަމަ ހުރިހާ ސަޕްލަޔަރެއް.",
      "dateRangeHint": "ސްޓޭޓްމަންޓް ތާރީޚުން ލިސްޓު ކުޑަކުރޭ.",
      "chooseDescription": "ރެކޯޑްކުރެވިފައިވާ ސަޕްލަޔަރ ސްޓޭޓްމަންޓްތައް ބެލުމަށް، ނުވަތަ އެއްޗެއް ރެކޯޑްކުރުމަށް، މަތިން ގާނޫނީ ފަރާތެއް ހޮވާ.",
      "loadFailed": "ސަޕްލަޔަރ ސްޓޭޓްމަންޓްތައް ލޯޑުނުވި",
      "listTitle": "ރެކޯޑްކުރެވިފައިވާ ސަޕްލަޔަރ ސްޓޭޓްމަންޓްތައް",
      "emptyTitle": "އަދި އެއްވެސް ސަޕްލަޔަރ ސްޓޭޓްމަންޓެއް ރެކޯޑްކޮށްފައެއް ނުވޭ",
      "emptyDescription": "ސަޕްލަޔަރަކު ފޮނުވި ސްޓޭޓްމަންޓެއް ރެކޯޑްކުރޭ — ލައިން ލައިނުން، ނުވަތަ ސީއެސްވީ ފައިލް — އޭރުން އެ ވަގުތުން އަހަރެމެންގެ ލެޖަރާ ރިކޮންސައިލްކުރެވޭނެ.",
      "emptyDescriptionReadOnly": "ރެކޯޑްކުރެވޭ ސްޓޭޓްމަންޓްތައް މިތަނުގައި ފެންނާނެ. ރެކޯޑްކުރުމަށް ސްޓޭޓްމަންޓް ރިކޮންސައިލްކުރުމުގެ ހުއްދަ ބޭނުންވޭ.",
      "pickHint": "ރިކޮންސައިލްކުރުމަށް ސްޓޭޓްމަންޓެއް ހޮވާ.",
      "reconcile": "ރިކޮންސައިލްކުރޭ",
      "sources": {
        "json": "ލިޔެފައި",
        "csv": "ސީއެސްވީ ފައިލް"
      },
      "kinds": {
        "invoice": "އިންވޮއިސް",
        "credit_note": "ކްރެޑިޓް ނޯޓް",
        "debit_note": "ޑެބިޓް ނޯޓް",
        "payment": "ޕޭމަންޓް",
        "other": "އެހެނިހެން"
      },
      "bases": {
        "reference_and_amount": "ރެފަރެންސާއި އަދަދު",
        "amount_and_date": "އަދަދާއި ތާރީޚު"
      },
      "columns": {
        "statementDate": "ސްޓޭޓްމަންޓް ތާރީޚު",
        "statementRef": "ސްޓޭޓްމަންޓް ނަންބަރު",
        "lines": "ލައިންތައް",
        "reportedBalance": "ސަޕްލަޔަރުގެ ބެލެންސް",
        "source": "މަސްދަރު",
        "date": "ތާރީޚު",
        "reference": "ރެފަރެންސް",
        "description": "ތަފްސީލު",
        "kind": "ބާވަތް",
        "amount": "އަދަދު",
        "ourDocument": "އަހަރެމެންގެ ޑޮކިއުމަންޓް",
        "supplierAmount": "ސަޕްލަޔަރުގެ އަދަދު",
        "ourAmount": "އަހަރެމެންގެ އަދަދު",
        "difference": "ތަފާތު",
        "basis": "ދިމާވީ",
        "settlementDifference": "ސެޓްލްމަންޓް ތަފާތު"
      },
      "record": {
        "action": "ސްޓޭޓްމަންޓެއް ރެކޯޑްކުރޭ",
        "title": "ސަޕްލަޔަރ ސްޓޭޓްމަންޓެއް ރެކޯޑްކުރޭ",
        "description": "ސަޕްލަޔަރު ބުނާ ގޮތުގައި އަހަރެމެން ދައްކަންޖެހޭ އަދަދު. އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭ؛ ރެކޯޑްކުރެވުނު ސްޓޭޓްމަންޓެއް ދުވަހަކުވެސް އެޑިޓެއް ނުކުރެވޭ.",
        "modeLabel": "ސްޓޭޓްމަންޓް ލިޔާނެ ގޮތް",
        "modeLines": "ލައިންތައް ލިޔޭ",
        "modeCsv": "ސީއެސްވީ އަޕްލޯޑްކުރޭ",
        "currency": "ފައިސާ",
        "currencyHint": "ސަޕްލަޔަރު ބަޔާންކުރާ ފައިސާ.",
        "statementDate": "ސްޓޭޓްމަންޓް ތާރީޚު",
        "statementDateHint": "ސަޕްލަޔަރުގެ ބެލެންސް ކަނޑައަޅާ ތާރީޚު.",
        "reportedBalance": "ސަޕްލަޔަރުގެ ބެލެންސް",
        "reportedBalanceHint": "އެ ތާރީޚަށް އަހަރެމެން ދައްކަންޖެހޭ ކަމަށް އެމީހުން ބުނާ އަދަދު. ޕޮޒިޓިވް ނަމަ އަހަރެމެން ދައްކަންޖެހޭ.",
        "periodFrom": "ލައިންތައް ފެށޭ ތާރީޚު",
        "periodFromHint": "ސްޓޭޓްމަންޓުގައި ހުރިހާ އެއްޗެއް ހިމެނޭނަމަ ހުސްކޮށް ބާއްވާ.",
        "openingBalance": "އޯޕަނިންގ ބެލެންސް",
        "openingBalanceHint": "އެ ދުވަހުގެ ކުރިން އަހަރެމެން ދައްކަންޖެހުނު ކަމަށް އެމީހުން ބުނާ އަދަދު. ހުސްނަމަ ސުމެއް.",
        "statementRef": "ސްޓޭޓްމަންޓް ނަންބަރު",
        "notes": "ނޯޓްސް",
        "linesCaption": "ސަޕްލަޔަރުގެ ސްޓޭޓްމަންޓުގައިވާ ލައިންތައް.",
        "removeLine": "ނަގާލާ",
        "removeLineN": "ލައިން {line} ނަގާލާ",
        "lineDate": "ލައިން {line} ގެ ތާރީޚު",
        "lineReference": "ލައިން {line} ގެ ރެފަރެންސް",
        "lineDescription": "ލައިން {line} ގެ ތަފްސީލު",
        "lineKind": "ލައިން {line} ގެ ބާވަތް",
        "lineAmount": "ލައިން {line} ގެ އަދަދު",
        "linesTotal": "ލައިންތަކުގެ ޖުމްލަ",
        "addLine": "ލައިނެއް އިތުރުކުރޭ",
        "signHint": "އަދަދުތަކުގައި ސައިން ހިމެނޭ: އިންވޮއިހަކުން ސަޕްލަޔަރަށް ދައްކަންޖެހޭ އަދަދު އިތުރުވޭ، ޕޭމަންޓަކުން ނުވަތަ ކްރެޑިޓް ނޯޓަކުން މަދުވޭ (ނެގެޓިވްކޮށް ލިޔޭ).",
        "file": "ސްޓޭޓްމަންޓް ފައިލް",
        "fileHint": "ހެޑަރ ރޯއެއް ހުންނަ ސީއެސްވީއެއް: date (YYYY-MM-DD) އާއި amount ލާޒިމު؛ reference، description އަދި kind އިޚްތިޔާރީ. ނުބައި ރޯއެއް ހުރި ފައިލަކުން އެއްވެސް އެއްޗެއް ރެކޯޑެއް ނުކުރެވޭ.",
        "lineErrorsTitle": "ލައިން {count} ގަބޫލުނުކުރެވުނު. އެއްވެސް އެއްޗެއް ރެކޯޑެއް ނުކުރެވުނު.",
        "confirm": "ސްޓޭޓްމަންޓް ރެކޯޑްކުރޭ",
        "confirmCsv": "އަޕްލޯޑްކޮށް ރެކޯޑްކުރޭ",
        "duplicate": "މި ސަޕްލަޔަރު، ފައިސާ އަދި ތާރީޚަށް މި ސްޓޭޓްމަންޓް ރެކޯޑްކޮށްފައިވޭ. ހަމަ އެ ތާރީޚަށް ދެވަނަ އެއްޗެއް ރެކޯޑްކުރުމަށް ސަޕްލަޔަރުގެ ސްޓޭޓްމަންޓް ނަންބަރު ލިޔޭ.",
        "vendorRequired": "ސަޕްލަޔަރު ހޮވާ.",
        "currencyInvalid": "ތިން އަކުރުގެ ފައިސާގެ ކޯޑެއް ލިޔޭ، މިސާލަކަށް MVR.",
        "dateRequired": "ތާރީޚު ލިޔޭ.",
        "periodFromAfter": "މިއީ ސްޓޭޓްމަންޓް ތާރީޚުގެ ފަހުން ނުވާނެ.",
        "moneyInvalid": "1250.00 ނުވަތަ -300.00 ފަދަ އަދަދެއް ލިޔޭ.",
        "lineAmountInvalid": "ސުން ނޫން އަދަދެއް ލިޔޭ، މިސާލަކަށް 1250.00 ނުވަތަ -300.00.",
        "fileRequired": "ސީއެސްވީ ފައިލް ހޮވާ.",
        "done": "ސްޓޭޓްމަންޓް ރެކޯޑްކުރެވިއްޖެ",
        "doneDetail": "ލައިން {count} ރެކޯޑްކުރެވިއްޖެ. އޭގެ ރިކޮންސިލިއޭޝަން ތިރީގައި."
      },
      "recon": {
        "title": "ރިކޮންސިލިއޭޝަން",
        "subtitle": "{vendor}، {date} އަށް، {currency} އިން",
        "loadFailed": "ރިކޮންސިލިއޭޝަން ލޯޑުނުވި",
        "supplierBalance": "ސަޕްލަޔަރު ބުނާ ގޮތުގައި ދައްކަންޖެހޭ",
        "ledgerBalance": "އަހަރެމެންގެ ލެޖަރު ބުނާ ގޮތުގައި ދައްކަންޖެހޭ",
        "difference": "ތަފާތު",
        "periodFrom": "ލައިންތައް ފެށޭ ތާރީޚު",
        "identityCaption": "ތަފާތު، ވަކިވަކިން.",
        "terms": {
          "opening": "އޯޕަނިންގ ބެލެންސްތަކުގެ ތަފާތު",
          "supplierOnly": "ސަޕްލަޔަރު އެކަނި ލިސްޓުކުރާ ލައިންތައް",
          "oursOnly": "އަހަރެމެންގެ ލެޖަރުގައި އެކަނި ހުރި އައިޓަމްތައް",
          "amountDifferences": "ހަމަ އެއް ރެފަރެންސް، ތަފާތު އަދަދު",
          "settlementDifferences": "ދިމާވި ޕޭމަންޓްތަކުގެ ސެޓްލްމަންޓް ތަފާތު",
          "unexplained": "ސަޕްލަޔަރުގެ އަމިއްލަ ލައިންތަކުން ބަޔާންނުވާ"
        },
        "termsSum": "ހިސާބުކުރެވިފައި",
        "identityHolds": "މަތީގައިވާ އައިޓަމްތަކުން މުޅި ތަފާތު ހިސާބުކުރެވޭ.",
        "identityBroken": "މަތީގައިވާ އައިޓަމްތައް ޖަމާވަނީ {sum} އަށް، {difference} ގެ ތަފާތަށް ނޫން. މި ރިޕޯޓްކުރޭ: ރިކޮންސިލިއޭޝަނުން އަބަދުވެސް މުޅި ތަފާތު ހިސާބުކުރެވެންވާނެ.",
        "fullyMatched": "ސްޓޭޓްމަންޓުގެ ކޮންމެ ލައިނެއް އަހަރެމެންގެ ލެޖަރުގެ އައިޓަމަކާ ދިމާވޭ.",
        "supplierOnlyTitle": "ސަޕްލަޔަރުގެ ސްޓޭޓްމަންޓުގައި އެކަނި",
        "supplierOnlyEmpty": "ސަޕްލަޔަރުގެ ކޮންމެ ލައިނެއް އަހަރެމެންގެ އެއްޗަކާ ދިމާވޭ.",
        "oursOnlyTitle": "އަހަރެމެންގެ ލެޖަރުގައި އެކަނި",
        "oursOnlyEmpty": "އަހަރެމެންގެ ކޮންމެ އައިޓަމެއް ސްޓޭޓްމަންޓުގައި ހިމެނޭ.",
        "amountDifferencesTitle": "ހަމަ އެއް ރެފަރެންސް، ތަފާތު އަދަދު",
        "amountDifferencesEmpty": "އަހަރެމެންގެ އެއްޗަކާ ހަމަ އެއް ރެފަރެންސް ހުރެ ތަފާތު އަދަދެއްގައިވާ ލައިނެއް ނެތް.",
        "matchedTitle": "ދިމާވި",
        "matchedEmptyTitle": "އެއްވެސް އެއްޗެއް ދިމާނުވި",
        "matchedEmptyDescription": "ސަޕްލަޔަރުގެ އެއްވެސް ލައިނެއް، ރެފަރެންސުން ނުވަތަ ދުވަސްކޮޅެއްގެ ތެރޭގައި އަދަދުން، އަހަރެމެންގެ އައިޓަމަކާ ދިމާނުވި. ސްޓޭޓްމަންޓަކީ މި ގާނޫނީ ފަރާތާއި ފައިސާއަށް ކަން ޔަގީންކުރޭ.",
        "settlementTotal": "ސެޓްލްމަންޓް ތަފާތު"
      }
    },
    "settings": {
      "attachmentsTitle": "ސަޕޯޓިންގ ޑޮކިއުމަންޓްތައް",
      "attachmentsDescription": "ކޮންމެ އޭޕީ ޑޮކިއުމަންޓަކަށް ހުށަހެޅުމުގެ ނުވަތަ ޕޯސްޓްކުރުމުގެ ކުރިން ސަޕޯޓިންގ އެޓޭޗްމަންޓެއް ބޭނުންވޭ. އަދަދަކަށް ނުވަތަ އެއަށްވުރެ ދަށުގެ ޑޮކިއުމަންޓްތަކަށް ކުންފުންޏަކަށް އެ ލުއިކޮށްދެވޭނެ.",
      "fields": {
        "attachmentAbove": "މިއަށްވުރެ މަތީގައި އެޓޭޗްމަންޓް ލާޒިމު",
        "attachmentAboveAlways": "ހުސްނަމަ: ކޮންމެ ޑޮކިއުމަންޓަކަށް އެޓޭޗްމަންޓެއް ބޭނުންވޭ.",
        "attachmentAboveHint": "ބޭސް ފައިސާއިން ޖުމްލަ މި އަދަދު ނުވަތަ އެއަށްވުރެ ދަށްނަމަ، އެޓޭޗްމަންޓެއް ނެތި ހުށަހަޅައި ޕޯސްޓްކުރެވޭނެ.",
        "attachmentAbovePlaceholder": "އަބަދުވެސް ލާޒިމު",
        "apControl": "އޭޕީ ކޮންޓްރޯލް އެކައުންޓް",
        "whtPayable": "ވިތްހޯލްޑިންގ ޓެކްސް ދައްކަންޖެހޭ އެކައުންޓް",
        "fxGain": "ފޮރިން އެކްސްޗޭންޖް ފައިދާގެ އެކައުންޓް",
        "fxLoss": "ފޮރިން އެކްސްޗޭންޖް ގެއްލުމުގެ އެކައުންޓް",
        "discount": "ކުރިން ދެއްކުމުގެ ޑިސްކައުންޓް އެކައުންޓް",
        "coolingHours": "ކޫލިންގ-އޮފް މުއްދަތު (ގަޑިއިރު)",
        "coolingHoursHint": "0 އިން 720 އަށް ފުރިހަމަ ގަޑިއިރު. ޑިފޯލްޓަކީ 48.",
        "coolingActive": "ކޫލިންގ-އޮފް މުއްދަތު ހިންގާ",
        "coolingActiveHint": "ހުޅުވިފައިވާނަމަ، ވެންޑަރެއްގެ އާ ބޭންކް އެކައުންޓަށް ފައިސާ ދެއްކުން މަތީގައިވާ މުއްދަތު ހަމަވާންދެން މަޑުކުރޭ."
      },
      "errors": {
        "attachmentAbove": "5000.00 ފަދަ، ސުމް ނުވަތަ އެއަށްވުރެ ބޮޑު އަދަދެއް ޖައްސާ، ނުވަތަ ހުސްކޮށް ބާއްވާ.",
        "hoursRange": "0 އިން 720 އަށް ފުރިހަމަ ގަޑިއިރު ޖައްސަވާ."
      },
      "title": "ދައްކަންޖެހޭ ފައިސާގެ ސެޓިންގްސް",
      "description": "ޕޯސްޓިންގ އެކައުންޓްތައް އަދި ބޭންކް ބަދަލުކުރުމުގެ ކޫލިންގ-އޮފް މުއްދަތު، ކޮންމެ ކުންފުންޏަކަށް ވަކިން.",
      "chooseCompanyTitle": "ކުންފުންޏެއް ހޮވާ",
      "chooseCompanyDescription": "އޭޕީ ސެޓިންގްސް ބަހައްޓަނީ ކޮންމެ ކުންފުންޏަކަށް ވަކިން. ސެޓިންގްސް ބަލައި ބަދަލުކުރުމަށް މަތިން ކުންފުންޏެއް ހޮވާ.",
      "noPermissionTitle": "އޭޕީ ސެޓިންގްސް ބެލެހެއްޓުމުގެ ހުއްދައެއް ނެތް",
      "noPermissionDescription": "މި ސެޓިންގްސް ބެލުމާއި ބަދަލުކުރުމަށް އޭޕީ ސެޓިންގްސްގެ ހުއްދަ ބޭނުންވޭ. ޓެނަންޓް އެޑްމިނިސްޓްރޭޓަރަކާ ސުވާލުކުރޭ.",
      "loadFailed": "އޭޕީ ސެޓިންގްސް ލޯޑުނުކުރެވުނު",
      "noChart": "އެކައުންޓްތަކުގެ ޗާޓު ކިޔުމުގެ ހުއްދައެއް ނެތުމުން، މިތަނުން އެކައުންޓެއް ނުހޮވޭނެ. އެކައުންޓްތަކުގެ ޗާޓު ކިޔުމުގެ ހުއްދަ ހޯދާ.",
      "accountsTitle": "ޕޯސްޓިންގ އެކައުންޓްތައް",
      "accountsDescription": "އޭޕީން ޕޯސްޓްކުރާ އެކައުންޓްތައް ބަދަލުކުރޭ. ހުސްކޮށް ބާއްވާ ފީލްޑަކަށް ބޭނުންކުރާނީ ޗާޓުގެ ސްޓޭންޑަރޑް އެކައުންޓް.",
      "clearHint": "ފީލްޑެއް ހުސްކޮށް ސޭވްކުރުމުން އޯވަރައިޑް ފުހެވި، ޕޯސްޓިންގ ދާނީ ޗާޓުގެ ސްޓޭންޑަރޑް އެކައުންޓަށް.",
      "coolingTitle": "ބޭންކް ބަދަލުކުރުމުގެ ކޫލިންގ-އޮފް",
      "coolingDescription": "ވެންޑަރެއްގެ ބޭންކް މަޢުލޫމާތު ބަދަލުކުރުމަށްފަހު، އައު އެކައުންޓަށް ފައިސާ ދެއްކުން މި މުއްދަތަށް މަޑުކުރޭ.",
      "resolved": {
        "configured": "ބޭނުންކުރަނީ: {code}",
        "defaulted": "ކަނޑައަޅާފައެއް ނެތް. ޕޯސްޓިންގ ދަނީ ޗާޓުގެ {code} އަށް.",
        "none": "ކަނޑައަޅާފައެއް ނެތް، އަދި ޗާޓުގައި ބޭނުންކުރެވޭނެ ސްޓޭންޑަރޑް އެކައުންޓެއް ނެތް."
      },
      "stale": {
        "body": "ތިޔަ ބަދަލުކުރަމުންދިޔަ ވަގުތު މި ސެޓިންގްސް އެހެން ތަނަކުން ބަދަލުކޮށްފި، ގިނަވެގެން ޓްރެޜަރީން. ބޭންކް ބަދަލުކުރުމުގެ ކޫލިންގ-އޮފް ވެސް ޓްރެޜަރީން ކަނޑައެޅޭ. ސޭވްކުރެވިފައިވާ ވަރޝަން ރީލޯޑްކޮށް، ތިޔަ ބަދަލުތައް އަލުން ގެންނަވާ.",
        "reload": "ސޭވްކުރެވިފައިވާ ވަރޝަން ރީލޯޑްކުރޭ"
      },
      "toasts": {
        "saved": "އޭޕީ ސެޓިންގްސް ސޭވްކުރެވިއްޖެ",
        "savedDetail": "މިހިންދިން ފެށިގެން އައު ޕޯސްޓިންގއާއި ފައިސާ ދެއްކުމަށް މި ސެޓިންގްސް ބޭނުންކުރާނެ.",
        "saveFailed": "އޭޕީ ސެޓިންގްސް ސޭވްނުކުރެވުނު"
      }
    },
    "capture": {
      "title": "ބިލުން ކިޔުން (އޭއައި)",
      "description": "ވެންޑަރގެ ޕީޑީއެފް ނުވަތަ ފޮޓޯ އަޕްލޯޑްކުރޭ. އޭއައި ކިޔާ ކަންތައްތައް ޔަޤީންކަމާއެކު ދައްކާނެ. ތިޔަބޭފުޅާ ކަށަވަރުކުރުމާހަމައަށް މި ފޯމަށް އެއްވެސް އެއްޗެއް ނުލިބޭނެ، އަދި ސޭވްކުރުމާހަމައަށް އެއްވެސް އެއްޗެއް ސޭވެއް ނުވާނެ.",
      "fileLabel": "ވެންޑަރ ބިލު",
      "fileHint": "ޕީޑީއެފް، ޕީއެންޖީ ނުވަތަ ޖޭޕެގް. 10 އެމްބީއަށް ވުރެ ބޮޑު ޕީޑީއެފް ޤަބޫލެއް ނުކުރެވޭނެ.",
      "read": "ޑޮކިއުމަންޓް ކިޔާ",
      "reading": "ޑޮކިއުމަންޓް ކިޔަމުން. މިއަށް ސިކުންތު ކިހާވަރެއް ނަގާފާނެ.",
      "loading": "އެކްސްޓްރެކްޝަން ލޯޑުކުރަމުން.",
      "pendingPlaceholder": "ނުވަތަ ހުއްޓިފައިވާ އެކްސްޓްރެކްޝަނެއް ކުރިއަށް ގެންދޭ",
      "pendingLead": "ކިޔުމަށް އަޕްލޯޑްކޮށް، އަދި އެއްވެސް މީހަކު ރިވިއު ނުކުރާ ބިލުތައް.",
      "pendingHint": "{confidence}% ޔަޤީންކަން · #{id}",
      "overall": "ޖުމްލަ {confidence}%",
      "model": "ކިޔީ {model}",
      "statuses": {
        "pending": "ރިވިއުއަށް މަޑުކުރަނީ",
        "confirmed": "ކަށަވަރުކުރެވިއްޖެ",
        "discarded": "ދޫކޮށްލެވިއްޖެ"
      },
      "lowNote": "{count} އަގު ކިޔުނީ ދަށް ޔަޤީންކަމަކާއެކު. އެއަގުތައް ފާހަގަކޮށް، ޓިކް ނުޖަހާ ފެށެނީ — ޑޮކިއުމަންޓާ އަޅާކިޔާ ބައްލަވާ.",
      "headerTable": "ބިލުގެ ހެޑަރުން ކިޔުނު އަގުތައް",
      "linesTable": "ބިލުން ކިޔުނު ލައިންތައް",
      "columns": {
        "use": "ބޭނުންކުރޭ",
        "field": "ފީލްޑް",
        "value": "ކިޔުނު ގޮތް",
        "confidence": "ޔަޤީންކަން"
      },
      "useField": "{field} ބޭނުންކުރޭ",
      "useLine": "ލައިން {line} ބޭނުންކުރޭ",
      "checkOnly": "ބެލުމަށް ހަމައެކަނި",
      "unusable": "ބޭނުންކުރެވޭ ގޮތަކަށް ނޫން — އަތުން ޖައްސަވާ",
      "percentTitle": "ޔަޤީންކަން {value}%",
      "fields": {
        "vendorName": "ވެންޑަރ",
        "vendorTaxId": "ވެންޑަރގެ ޓެކްސް ނަންބަރު",
        "invoiceNumber": "ވެންޑަރގެ އިންވޮއިސް ނަންބަރު",
        "invoiceDate": "އިންވޮއިސް ތާރީޚު",
        "dueDate": "ޑިއު ތާރީޚު",
        "currency": "ފައިސާ",
        "notes": "ނޯޓު (މެމޯއަށް)",
        "subtotal": "ސަބްޓޮޓަލް",
        "taxAmount": "ޓެކްސް",
        "totalAmount": "ޖުމްލަ"
      },
      "lineFields": {
        "description": "ތަފްޞީލު",
        "quantity": "އަދަދު",
        "unitPrice": "އެއް އަދަދެއްގެ އަގު",
        "lineAmount": "އަދަދު ފައިސާ",
        "taxCode": "ޓެކްސް ކޯޑު"
      },
      "noLines": "މި ޑޮކިއުމަންޓުން އެއްވެސް ލައިނެއް ނުކިޔުނު.",
      "accountsNote": "ލައިންތައް އަންނަނީ އެކައުންޓެއް ނެތި: ސޭވްކުރުމުގެ ކުރިން ކޮންމެ ލައިނަކަށް އެކައުންޓެއް ޚިޔާރުކުރޭ. ޓެކްސް ހޯދަނީ ހުށަހަޅާއިރު ސާވަރުން، އެހެންކަމުން މިތާ ކިޔުނު ޓެކްސް އާއި ޖުމްލަ ހަމައެކަނި ބެލުމަށް.",
      "applied": "ކަށަވަރުކޮށް ފުރިއްޖެ. ފޯމު ބައްލަވާ، ކޮންމެ ލައިނަކަށް އެކައުންޓެއް ޚިޔާރުކުރައްވާ، ދެން ޑްރާފްޓް ސޭވްކުރައްވާ.",
      "alreadyReviewed": "މި އެކްސްޓްރެކްޝަން ރިވިއުކުރެވިފައިވާތީ، މިއަށް ފޯމެއް ފުރިނުދެވޭނެ. ޑޮކިއުމަންޓް އަލުން ކިޔުމަށް ފެށުމުން ފައްޓަވާ.",
      "needsReviewer": "ފޯމު ފުރުމުގެ ކުރިން، އޭއައި އެކްސްޓްރެކްޝަން ރިވިއުކުރުމުގެ ހުއްދަ ލިބިފައިވާ މީހަކު މިއީ ކަށަވަރުކުރަން ޖެހޭނެ.",
      "startOver": "އަލުން ފަށާ",
      "discard": "ދޫކޮށްލާ",
      "confirm": "ކަށަވަރުކޮށް ފޯމު ފުރާ",
      "discarded": "އެކްސްޓްރެކްޝަން ދޫކޮށްލެވިއްޖެ",
      "discardedDetail": "އެއްވެސް އެއްޗެއް ނުފުރުނު. ކިޔުނު ކަންތައްތަކުގެ ރެކޯޑު އޮޑިޓް ޓްރެއިލްގައި ހުންނާނެ.",
      "reviewedElsewhere": "ތިޔަބޭފުޅާ މި އެކްސްޓްރެކްޝަން ހުޅުވާލައްވައިގެން ހުއްޓައި އެހެން މީހަކު ރިވިއުކޮށްފި. މިހާރު ފައިލްގައި ހުރީ މިއީ.",
      "disabledTitle": "އޭއައި ކެޕްޗަރ ނިއްވާލާފައި",
      "disabledDetail": "މި ކުންފުންޏަށް އޭއައި ނިއްވާލާފައިވާތީ، ބިލުތައް ޖައްސަނީ އަތުން.",
      "tooLargeHint": "ޕީޑީއެފް ބައިބައިކުރައްވާ، ނުވަތަ ޞަފްޙާތައް ފޮޓޯގެ ގޮތުގައި އަޕްލޯޑްކުރައްވާ.",
      "appliedTitle": "ޑޮކިއުމަންޓުން ފުރިއްޖެ",
      "appliedDetail": "އަދި އެއްވެސް އެއްޗެއް ސޭވެއް ނުވޭ. ކޮންމެ ފީލްޑެއް ބައްލަވާ، ދެން ޑްރާފްޓް ސޭވްކުރައްވާ.",
      "vendorUnmatched": "ޑޮކިއުމަންޓުގައި ވެންޑަރގެ ނަމަކަށް \"{name}\" ވާއިރު، ފައިލްގައިވާ އެއްވެސް ވެންޑަރަކާ އެކަނި ދިމައެއް ނުވޭ. ވެންޑަރ އަމިއްލައަށް ޚިޔާރުކުރައްވާ."
    },
    "invoiceSignals": {
      "title": "ފްރޯޑް އާއި ޑުޕްލިކޭޓް ސިގްނަލްތައް",
      "description": "ހުށަހަޅާއިރު އެގާރަ ޔަޤީން ޗެކެއް ހިންގޭ. ބްލޮކްކުރާ ސިގްނަލެއް ސިގްނަލް އިންބޮކްސްގައި ނިންމާލުމާހަމައަށް މި ޑޮކިއުމަންޓް ހިފަހައްޓާ.",
      "inbox": "ސިގްނަލް އިންބޮކްސް",
      "rescan": "އަލުން ސްކޭންކުރޭ",
      "rescanned": "ސިގްނަލްތައް އަލުން ސްކޭންކުރެވިއްޖެ",
      "rescannedDetail": "މި ޑޮކިއުމަންޓުގައި ހުޅުވިފައިވާ ސިގްނަލް {count}.",
      "loadFailed": "ސިގްނަލްތައް ލޯޑެއް ނުކުރެވުނު",
      "blocking": "ބްލޮކްކުރާ ސިގްނަލް {count} ހުޅުވިފައިވާތީ، މި ޑޮކިއުމަންޓް ހުށަނާޅައި ނުވާނެ.",
      "disposeThere": "އެއީ ސިގްނަލް އިންބޮކްސްގައި ނިންމާލައްވާ.",
      "refusedRescan": "ބްލޮކްކުރާ ސިގްނަލަކާހުރެ ހުށަހެޅުން ރައްދުކުރެވުނު. ރައްދުކުރެވޭ ހުށަހެޅުމަކުން ފެނުނު އެއްޗެއް ބަހައްޓާކަށް ނުބަހައްޓާތީ، މިތަނުގައި ސިގްނަލްތައް ރެކޯޑުކުރުމަށް އަލުން ސްކޭންކޮށް، ދެން ސިގްނަލް އިންބޮކްސްގައި ނިންމާލައްވާ.",
      "warnings": "ހުޅުވިފައިވާ ވޯނިންގ ސިގްނަލް {count}. އެއީ ހުށަހެޅުން ހުއްޓުވާ އެއްޗެއް ނޫން، ނަމަވެސް ފާސްކުރާ މީހާއަށް ފެންނާނެ.",
      "empty": "މި ޑޮކިއުމަންޓުގައި ސިގްނަލެއް ނެތް. ސިގްނަލް އުފެދެނީ ހުށަހަޅާއިރު؛ މިހާރު ބެލުމަށް އަލުން ސްކޭންކުރޭ.",
      "listLabel": "މި ޑޮކިއުމަންޓުގެ ސިގްނަލްތައް",
      "related": "ގުޅިފައިވާ ޑޮކިއުމަންޓް ހުޅުވާ"
    },
    "poMatch": {
      "title": "{po} އާ އަޅާކިޔާ",
      "description": "މި ބިލުގެ ކޮންމެ ލައިނެއް އޯޑަރުކުރި އެއްޗަކާއި ލިބުނު އެއްޗަކާ އަޅާކިޔާ. އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެ؛ ޓޮލަރެންސްއިން ބޭރު ލައިނެއް ޑިސްޕިއުޓެއްގެ ގޮތުގައި ރެކޯޑުކުރެވޭނެ.",
      "matched": "ޓޮލަރެންސްގެ ތެރޭގައި އަޅާކިޔިއްޖެ",
      "disputed": "ޑިސްޕިއުޓްތަކާއެކު އަޅާކިޔިއްޖެ",
      "doneDetail": "{po} އާ ދެކޮޅަށް ތިން-ގޮތުގެ މެޗް ފައިލްގައި ހުރި.",
      "existing": "މި ބިލު ކުރިން އަޅާކިޔާފައި.",
      "open": "މެޗް ހުޅުވާ",
      "all": "ހުރިހާ މެޗްތައް",
      "disputedLead": "އެއް ނުވަތަ އެއަށްވުރެ ގިނަ ލައިން ޓޮލަރެންސްއިން ބޭރު. މެޗްގައި ޑިސްޕިއުޓްތައް ހައްލުކުރައްވާ.",
      "resultTable": "ލައިން ލައިނަށް މެޗްގެ ނަތީޖާ",
      "pairTable": "ބިލުގެ ލައިންތަކާއި އެއީ ކޮން ޕީއޯ ލައިނަކަށްކަން",
      "columns": {
        "invoiceLine": "ބިލުގެ ލައިން",
        "poLine": "ޕީއޯ ލައިން",
        "quantities": "އަދަދު: ބިލު / ޕީއޯ / ލިބުނު",
        "prices": "އަގު: ބިލު / ޕީއޯ",
        "qtyVariance": "އަދަދުގެ ތަފާތު",
        "priceVariance": "އަގުގެ ތަފާތު",
        "tolerance": "ޓޮލަރެންސް",
        "amount": "އަދަދު ފައިސާ"
      },
      "within": "ތެރޭގައި",
      "outside": "ބޭރުގައި",
      "statuses": {
        "matched": "އަޅާކިޔިއްޖެ",
        "disputed": "ޑިސްޕިއުޓްވެފައި"
      },
      "disputeStatuses": {
        "open": "ހުޅުވިފައި",
        "resolved": "ހައްލުކުރެވިއްޖެ"
      },
      "invoiceLine": "ލައިން {no} · {description}",
      "cannotCreate": "މި ބިލަށް އެއްވެސް މެޗެއް ފައިލްގައި ނެތް، އަދި މެޗެއް ހިންގުމަށް މެޗް އުފެއްދުމުގެ ހުއްދަ ބޭނުންވޭ.",
      "pairLead": "ބިލުގެ ކޮންމެ ލައިނެއް ގުޅުވާފައިވަނީ އެއީ ކޮން ޕީއޯ ލައިނަކަށްކަން. މި އޯޑަރަކަށް ނުވާ ލައިނެއް ދޫކޮށްލައްވާ.",
      "pairAria": "ބިލުގެ ލައިން {no} ގެ ޕީއޯ ލައިން",
      "leaveOut": "ދޫކޮށްލާ",
      "nonePaired": "މެޗް ހިންގުމަށް މަދުވެގެން އެއް ލައިން ޕީއޯ ލައިނަކާ ގުޅުވާ.",
      "run": "މެޗް ހިންގާ"
    },
    "signal": {
      "duplicate_exact": "ފައިލްގައި ހުރި އިންވޮއިސްއެއްގެ ވެންޑަރާއި އިންވޮއިސް ނަންބަރު އެއްގޮތް.",
      "near_duplicate_number": "އިންވޮއިސް ނަންބަރު ކުރީގެ އެއްގެ ކައިރިން އެއްގޮތް.",
      "duplicate_amount_date": "ފައިލްގައި ހުރި އިންވޮއިސްއެއްގެ ވެންޑަރާއި ޢަދަދާއި ތާރީޚު އެއްގޮތް.",
      "round_sum": "އިންވޮއިސްގެ ޖުމްލަ ޢަދަދަކީ ރަނގަޅަށް ރައުންޑް ވެފައިވާ ޢަދަދެއް.",
      "fresh_vendor": "އިންވޮއިސް އައިސްފައިވަނީ ވަރަށް ގިނަ ދުވަހެއް ނުވާ ވެންޑަރަކު.",
      "bank_change_recent": "މި އިންވޮއިސްގެ ކުރިން ވެންޑަރގެ ބޭންކް ތަފްސީލް ބަދަލުވެފައި ވޭ.",
      "just_below_threshold": "ޢަދަދަކީ ފާސްކުރުމުގެ ތްރެޝޯލްޑުގެ ދަށުން ކައިރީގައި ހުރި ޢަދަދެއް.",
      "non_business_day_entry": "އިންވޮއިސް ލިޔެފައިވަނީ ވިޔަފާރި ނުކުރާ ދުވަހެއްގައި.",
      "sequential_numbering": "ވެންޑަރގެ އިންވޮއިސް ނަންބަރުތައް ނުތަނަވަސް ގޮތަކަށް ތަރުތީބުން އޮތް.",
      "no_po_over_threshold": "ތްރެޝޯލްޑުން މަތީ އިންވޮއިސްއަކަށް ޕަރޗޭސް އޯޑަރެއް ނެތް.",
      "tax_without_registration": "ޓެކްސް ރަޖިސްޓްރޭޝަނެއް ނެތް ވެންޑަރަކު ޓެކްސް ޗާޖްކޮށްފައި ވޭ."
    },
    "payment_exception": {
      "returned": "ބޭންކުން ޕޭމަންޓެއް އެނބުރި ފޮނުވާފައި ވޭ.",
      "recalled": "ޕޭމަންޓެއް ރިކޯލްކުރެވިފައި ވޭ.",
      "rejected": "ޕޭމަންޓެއް ރިޖެކްޓުކުރެވިފައި ވޭ.",
      "stopped": "ޕޭމަންޓެއް ހުއްޓުވާފައި ވޭ.",
      "restored": "ހުއްޓުވާފައިވާ ޕޭމަންޓެއް އަލުން ރެސްޓޯރުކުރެވިފައި ވޭ."
    }
  },
  "ar": {
    "routeTitles": {
      "arCustomers": "ކަސްޓަމަރުން",
      "arCustomer": "ކަސްޓަމަރު",
      "arInvoices": "ސޭލްސް އިންވޮއިސްތައް",
      "arInvoiceNew": "އައު ސޭލްސް އިންވޮއިސް",
      "arInvoice": "ސޭލްސް އިންވޮއިސް",
      "arCreditNotes": "ކްރެޑިޓް ނޯޓްތައް",
      "arCreditNoteNew": "އައު ކްރެޑިޓް ނޯޓް",
      "arCreditNote": "ކްރެޑިޓް ނޯޓް",
      "arReceipts": "ރަސީދުތައް",
      "arReceiptNew": "ރަސީދެއް ރެކޯޑްކުރޭ",
      "arReceipt": "ރަސީދު",
      "arDunning": "ފައިސާ ހޯދުމުގެ ނޯޓިސް",
      "arAging": "ލިބެންޖެހޭ ފައިސާގެ އޭޖިންގ",
      "arDso": "ފައިސާ ލިބުމަށް ނަގާ ދުވަސް (DSO)",
      "arStatement": "ކަސްޓަމަރު ސްޓޭޓްމަންޓް",
      "eclMatrices": "އީސީއެލް މެޓްރިކްސްތައް",
      "eclRuns": "އީސީއެލް ރަންތައް",
      "eclRun": "އީސީއެލް ރަން",
      "eclAssessments": "އީސީއެލް އެސެސްމަންޓްތައް",
      "eclMovement": "އެލަވަންސްގެ ހަރަކާތް",
      "customerPosition": "ކަސްޓަމަރުގެ ޕޮޒިޝަން",
      "collections": "ފައިސާ ހޯދުމުގެ މަސައްކަތު ލިސްޓު",
      "cei": "ފައިސާ ހޯދުމުގެ ފައިދާހުރިމިން",
      "unallocatedReceipts": "ހަވާލުނުކުރެވި ހުރި ރަސީދުތައް",
      "writeOffs": "ރައިޓް-އޮފްތައް",
      "writeOff": "ރައިޓް-އޮފް",
      "writeOffNew": "އައު ރައިޓް-އޮފް",
      "writeOffSettings": "ރައިޓް-އޮފްގެ ހައްދުތައް",
      "eclSettings": "އީސީއެލް ސެޓިންގްސް",
      "creditControl": "ކްރެޑިޓް ކޮންޓްރޯލް",
      "dunningEffectiveness": "ޑަނިންގެ ނަތީޖާ"
    },
    "list": {
      "filtersTitle": "ފިލްޓަރުތައް",
      "allCompanies": "ހުރިހާ ކުންފުނިތައް",
      "from": "އިން",
      "to": "އަށް",
      "openOnly": "ދައްކަން ޖެހޭ ތަކެތި އެކަނި",
      "searchHint": "ލިޔުމުގެ ނަންބަރު، ރެފަރެންސް ނުވަތަ ކަސްޓަމަރު",
      "loadFailed": "މި ލިޔުންތައް ލޯޑެއް ނުކުރެވުނު",
      "exported": "އެކްސްޕޯޓްކޮށްފި",
      "exportedDetail": "{count} ސަފުހާ CSV ފައިލަކަށް ލިޔެފި.",
      "views": {
        "trigger": "ވިއުތައް",
        "unsaved": "ރައްކާނުކުރި ވިއު",
        "save": "މި ވިއު ރައްކާކުރޭ",
        "namePlaceholder": "މި ވިއު އަށް ނަމެއް ދޭ",
        "defaultBadge": "ޑިފޯލްޓް",
        "setDefault": "ޑިފޯލްޓަކަށް ހަދާ",
        "clearDefault": "ޑިފޯލްޓް ފޮހެލާ",
        "remove": "ފޮހެލާ",
        "empty": "ނެތް ރައްކާކުރެވިއްޖެ ވިއުތައް އަދި. ފިލްޓަރ ލިސްޓް, އެއަށްފަހު ރައްކާކުރޭ.",
        "panelLabel": "ރައްކާކުރި ވިއުތައް",
        "saved": "ވިއު ރައްކާކުރެވިއްޖެ"
      },
      "columns": {
        "customer": "ކަސްޓަމަރު",
        "dueDate": "ދައްކަންޖެހޭ ތާރީޚް",
        "settlement": "ދެއްކުން",
        "currency": "ފައިސާ",
        "total": "ޖުމްލަ",
        "balance": "ދައްކަން ޖެހޭ"
      },
      "invoice": {
        "title": "ސޭލްސް އިންވޮއިސްތައް",
        "description": "ކަސްޓަމަރުންނަށް ބިލްކުރެވިފައިވާ މިންވަރާއި، އަދިވެސް ދައްކަން ޖެހޭ މިންވަރު.",
        "new": "އައު އިންވޮއިސް",
        "tableLabel": "ސޭލްސް އިންވޮއިސްތައް",
        "emptyTitle": "އަދި ސޭލްސް އިންވޮއިސްއެއް ނެތް",
        "emptyDescription": "‘އައު އިންވޮއިސް’ އިން އެއް އުފައްދާ، ނުވަތަ ކުރިން ހުރި އެއްޗެއް ބަލަން ބޭނުންނަމަ ފިލްޓަރުތައް ބަދަލުކުރޭ.",
        "columns": {
          "docNo": "އިންވޮއިސް ނަންބަރު",
          "date": "އިންވޮއިސް ތާރީޚް"
        }
      },
      "creditNote": {
        "title": "ކްރެޑިޓް ނޯޓްތައް",
        "description": "ކަސްޓަމަރުންނަށް އަނބުރާ ދެވިފައިވާ އަދަދުތަކާއި، އޭގެ ތެރެއިން އަދިވެސް ހަމަނުޖައްސާ ހުރި މިންވަރު.",
        "new": "އައު ކްރެޑިޓް ނޯޓް",
        "tableLabel": "ކްރެޑިޓް ނޯޓްތައް",
        "emptyTitle": "އަދި ކްރެޑިޓް ނޯޓެއް ނެތް",
        "emptyDescription": "ކްރެޑިޓް ނޯޓަކުން ކަސްޓަމަރު ދައްކަން ޖެހޭ މިންވަރު ކުޑަކުރެވެއެވެ. ‘އައު ކްރެޑިޓް ނޯޓް’ އިން އުފައްދާ، އެއަށްފަހު އެ ކަސްޓަމަރުގެ ދައްކަން ޖެހޭ އިންވޮއިސްތަކަށް ހަމަޖައްސާ.",
        "columns": {
          "docNo": "ކްރެޑިޓް ނޯޓް ނަންބަރު",
          "date": "ކްރެޑިޓް ނޯޓް ތާރީޚް"
        }
      }
    },
    "doc": {
      "headerTitle": "ލިޔުން",
      "draftTitle": "ދެލިކޮޕީ",
      "loadFailed": "މި ލިޔުން ލޯޑެއް ނުކުރެވުނު",
      "actionsLabel": "ލިޔުމުގެ ޢަމަލުތައް",
      "subtotalLabel": "ސަބްޓޯޓަލް",
      "totalLabel": "ޖުމްލަ",
      "confirming": "ކަށަވަރުކުރަނީ",
      "posting": "ޕޯސްޓްކުރަނީ",
      "readyToConfirm": "ކަށަވަރުކުރުމުން ލިޔުމުގެ ނަންބަރު ދޫކުރެވި، ކަސްޓަމަރުގެ ކްރެޑިޓް ޗެކް ހިންގޭނެއެވެ.",
      "confirmedImmutable": "މި ލިޔުން ކަށަވަރުކުރެވި ނަންބަރު ދޫކުރެވިފައިވާތީ، ސަފުތައް އިތުރަށް ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "stale": "ތިޔަ ހުޅުވައިގެން ހުއްޓާ އެހެން މީހަކު މި ލިޔުން ރައްކާކޮށްފިއެވެ. ތިޔަ ބަދަލުތައް އަދިވެސް ސްކްރީނުގައި އެބަހުއްޓެވެ — ކިޔާލައި، އަލުން ލޯޑްކޮށް، ބޭނުންވި ބަދަލު އަލުން ގެންނަވާ.",
      "reload": "ސާވަރުން އަލުން ލޯޑްކުރޭ",
      "railSubtitle": "{status}، ތާރީޚް {date}",
      "shortcuts": {
        "save": "މި ލިޔުން ރައްކާކުރޭ"
      },
      "unsavedGuard": {
        "title": "ރައްކާނުކުރާ ބަދަލުތައް ދޫކޮށްލާނަންތޯ؟",
        "message": "މި ލިޔުމުގައި ރައްކާނުކުރެވޭ ބަދަލުތަކެއް އެބަހުރި. މިހާރު ދޫކޮށްލައިފިނަމަ، އެ ބަދަލުތައް ގެއްލޭނެ.",
        "confirm": "ބަދަލުތައް ދޫކޮށްލާ",
        "cancel": "އިތުރަށް އެޑިޓްކުރޭ"
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "confirmed": "ކަށަވަރުކޮށްފި",
        "posted": "ޕޯސްޓްކޮށްފި",
        "cancelled": "ބާތިލްކޮށްފި"
      },
      "settlements": {
        "unpaid": "ނުދައްކާ",
        "partial": "ބައެއް ދައްކާފައި",
        "paid": "ދައްކާފައި"
      },
      "blockers": {
        "noLines": "އަދަދެއް ހިމެނޭ މަދުވެގެން އެއް ސަފު އިތުރުކުރޭ.",
        "lineIssues": "ފުރަތަމަ ފާހަގަކޮށްފައިވާ ސަފުތައް ރަނގަޅުކުރޭ.",
        "zeroTotal": "މި ލިޔުމުގެ ޖުމްލައަކީ ސުމެކެވެ. ކަށަވަރުކުރުމުގެ ކުރިން އަދަދެއް ހިމެނޭ ސަފެއް އިތުރުކުރޭ."
      },
      "fields": {
        "company": "ކުންފުނި",
        "companyPlaceholder": "ކުންފުންޏެއް ޚިޔާރުކުރޭ",
        "customer": "ކަސްޓަމަރު",
        "dueDate": "ދައްކަންޖެހޭ ތާރީޚް",
        "dueDateHint": "ފައިސާ ލިބޭނެ ކަމަށް ބެލެވޭ ތާރީޚް. އޭޖިންގ އަދި ނޯޓިސް ފޮނުވުމުގެ ސައިކަލް މިއިން ކަނޑައެޅެއެވެ.",
        "currency": "ފައިސާ",
        "currencyHint": "ކުންފުނީގެ އަސާސީ ފައިސާއަކީ {base}.",
        "reference": "ރެފަރެންސް",
        "referenceHint": "ކަސްޓަމަރު ދީފައިވާ އޯޑަރު ނުވަތަ އެއްބަސްވުމުގެ ނަންބަރު.",
        "memo": "ނޯޓު",
        "taxTotal": "ޓެކްސް",
        "total": "ޖުމްލަ",
        "allocated": "ދެއްކިފައި",
        "balance": "ދައްކަން ޖެހޭ",
        "postedAt": "ޕޯސްޓްކުރި",
        "dunningLevel": "ނޯޓިސް ލެވެލް"
      },
      "actions": {
        "save": "ދެލިކޮޕީ ރައްކާކުރޭ",
        "confirm": "ކަށަވަރުކުރޭ",
        "post": "ޕޯސްޓްކުރޭ",
        "pdf": "PDF ތައްޔާރުކުރޭ",
        "discard": "ދެލިކޮޕީ އުނިކުރޭ"
      },
      "pdfWorking": "އުފައްދަނީ",
      "pdfOpen": "PDF ހުޅުވާ",
      "pdfNotReady": "PDF އަދި އުފައްދަނީ. މަދު ވަގުތުކޮޅެއް ފަހުން އަލުން ބައްލަވާ.",
      "timeline": {
        "created": "އުފެއްދި",
        "confirmed": "{docNo} ގެ ގޮތުގައި ކަށަވަރުކޮށްފި",
        "posted": "ލެޖަރަށް ޕޯސްޓްކޮށްފި",
        "override": "ކްރެޑިޓް އޯވަރައިޑް ދެވިއްޖެ",
        "dunning": "ނޯޓިސް ފޮނުވައިފި — ލެވެލް {level}"
      },
      "links": {
        "customer": "ކަސްޓަމަރު",
        "journal": "ޖާނަލް އެންޓްރީ",
        "originalInvoice": "އަސްލު އިންވޮއިސް"
      },
      "toasts": {
        "savedDetail": "ދެލިކޮޕީ ރައްކާކުރެވިއްޖެ. ކަށަވަރުކުރަންދެން ނަންބަރެއް ނުދެވޭނެއެވެ.",
        "saveFailed": "މި ލިޔުން ރައްކާއެއް ނުކުރެވުނު",
        "confirmedDetail": "ނަންބަރު ދޫކުރެވި، ކްރެޑިޓް ޗެކް ފުރިހަމަވެއްޖެ.",
        "confirmFailed": "މި ލިޔުން ކަށަވަރެއް ނުކުރެވުނު",
        "postedDetail": "ޖާނަލް ލިޔެވި، ސަބް-ލެޖަރ އަޕްޑޭޓްވެއްޖެ.",
        "postFailed": "މި ލިޔުން ޕޯސްޓެއް ނުކުރެވުނު",
        "discarded": "ދެލިކޮޕީ އުނިކޮށްފި",
        "discardedDetail": "އެއްވެސް އެއްޗެއް ޕޯސްޓްކޮށްފައި ނުވާތީ، ރިވާސްކުރަން ޖެހޭ އެއްޗެއް ނެތެވެ.",
        "discardFailed": "މި ދެލިކޮޕީ އުނިއެއް ނުކުރެވުނު"
      },
      "invoice": {
        "title": "އިންވޮއިސް {docNo}",
        "newTitle": "އައު ސޭލްސް އިންވޮއިސް",
        "description": "ކަސްޓަމަރަކަށް ބިލްކުރޭ. ކަށަވަރުކުރުމުން ނަންބަރު ދޫކުރެވި ކްރެޑިޓް ޗެކް ހިނގާނެ؛ ޕޯސްޓްކުރުމުން ޖާނަލް ލިޔެވޭނެއެވެ.",
        "backToList": "ހުރިހާ އިންވޮއިސްތައް",
        "postedImmutable": "ޕޯސްޓްކޮށްފައިވާ އިންވޮއިސް ރަނގަޅުކުރަނީ ކްރެޑިޓް ނޯޓަކުންނެވެ؛ އެއްވެސް އިރެއްގައި އުނިކުރުމެއް ނުވަތަ ބަދަލުކުރުމެއް ނުހިމެނެއެވެ.",
        "fields": {
          "date": "އިންވޮއިސް ތާރީޚް"
        },
        "toasts": {
          "saved": "އިންވޮއިސް ދެލިކޮޕީ ރައްކާކޮށްފި",
          "confirmed": "އިންވޮއިސް {docNo} ކަށަވަރުކޮށްފި",
          "posted": "އިންވޮއިސް {docNo} ޕޯސްޓްކޮށްފި"
        }
      },
      "creditNote": {
        "title": "ކްރެޑިޓް ނޯޓް {docNo}",
        "newTitle": "އައު ކްރެޑިޓް ނޯޓް",
        "description": "ކަސްޓަމަރަކަށް އަދަދެއް އަނބުރާ ދީ، ދެން އެ ކަސްޓަމަރުގެ ދައްކަން ޖެހޭ އިންވޮއިސްތަކަށް ހަމަޖައްސާ.",
        "backToList": "ހުރިހާ ކްރެޑިޓް ނޯޓްތައް",
        "postedImmutable": "ޕޯސްޓްކޮށްފައިވާ ކްރެޑިޓް ނޯޓެއް ބަދަލެއް ނުވަތަ އުނިއެއް ނުކުރެވެއެވެ. އިންވޮއިސްތަކަށް ހަމަޖައްސާ، ނުވަތަ ރިވާސްކުރަން އިންވޮއިސެއް އުފައްދާ.",
        "fields": {
          "date": "ކްރެޑިޓް ނޯޓް ތާރީޚް"
        },
        "toasts": {
          "saved": "ކްރެޑިޓް ނޯޓް ދެލިކޮޕީ ރައްކާކޮށްފި",
          "confirmed": "ކްރެޑިޓް ނޯޓް {docNo} ކަށަވަރުކޮށްފި",
          "posted": "ކްރެޑިޓް ނޯޓް {docNo} ޕޯސްޓްކޮށްފި"
        }
      },
      "pdfUnsafe": "ސާވަރުން ފޮނުވި ޕީޑީއެފް ލިންކަކީ ވެބް އެޑްރެހެއް ނޫނީމާ އެ ލިންކް ނުހުޅުވުނު. އަލުން މަސައްކަތްކޮށްލާ، ތަކުރާރުވެއްޖެނަމަ ސަޕޯޓާ ގުޅުއްވާ."
    },
    "lines": {
      "title": "ސަފުތައް",
      "caption": "ލިޔުމުގެ ސަފުތައް: އާމްދަނީ އެކައުންޓް، ޢަދަދު، ޔުނިޓް އަގު، ޑިސްކައުންޓް އަދި އެއިން ނިކުންނަ އަދަދު",
      "subtotal": "ސަބްޓޯޓަލް",
      "noTaxCode": "ޓެކްސް ނެތް",
      "keyboardHint": "Enter އިން ތިރީ ސަފަށް ދެއެވެ، އަދި އެންމެ ފަހު ސަފުގައި އައު ސަފެއް އިތުރުކުރެއެވެ. Alt+↓ އިން ކޮޕީ، Alt+Backspace އިން އުނިކުރެއެވެ.",
      "columns": {
        "no": "ނަންބަރު",
        "account": "އާމްދަނީ އެކައުންޓް",
        "description": "ތަފްޞީލު",
        "dimensions": "ޑައިމެންޝަންތައް",
        "taxCode": "ޓެކްސް",
        "quantity": "ޢަދަދު",
        "unitPrice": "ޔުނިޓް އަގު",
        "discount": "ޑިސްކައުންޓް %",
        "amount": "އަދަދު",
        "rowActions": "ސަފުގެ ޢަމަލުތައް"
      },
      "actions": {
        "add": "ސަފެއް އިތުރުކުރޭ",
        "duplicate": "މި ސަފު ކޮޕީކުރޭ",
        "remove": "މި ސަފު އުނިކުރޭ"
      },
      "aria": {
        "account": "އާމްދަނީ އެކައުންޓް، ސަފު {line}",
        "description": "ތަފްޞީލު، ސަފު {line}",
        "taxCode": "ޓެކްސް ކޯޑް، ސަފު {line}",
        "quantity": "ޢަދަދު، ސަފު {line}",
        "unitPrice": "ޔުނިޓް އަގު، ސަފު {line}",
        "discount": "ޑިސްކައުންޓް ޕަސެންޓް، ސަފު {line}",
        "duplicate": "ސަފު {line} ކޮޕީކުރޭ",
        "remove": "ސަފު {line} އުނިކުރޭ"
      },
      "issues": {
        "noAccount": "މި ސަފުން ކްރެޑިޓްކުރާ އާމްދަނީ އެކައުންޓް ޚިޔާރުކުރޭ.",
        "invalidQuantity": "އެއީ ނަންބަރެއް ނޫން.",
        "quantityNotPositive": "ޢަދަދު ސުމަށްވުރެ ބޮޑުވާން ޖެހެއެވެ.",
        "invalidUnitPrice": "އެއީ ނަންބަރެއް ނޫން.",
        "negativeUnitPrice": "ޔުނިޓް އަގު މައިނަސް ވެގެން ނުވާނެއެވެ. ކްރެޑިޓް ނޯޓުގައި އަދަދުތައް ހުންނަނީ ޕޮޒިޓިވްކޮށް، ދެފަރާތް ބަދަލުވެގެންނެވެ.",
        "invalidDiscount": "އެއީ ނަންބަރެއް ނޫން.",
        "discountRange": "ސަފުގެ ޑިސްކައުންޓަކީ 0 އާއި 100 އާ ދެމެދުގެ ޕަސެންޓެކެވެ."
      }
    },
    "credit": {
      "panelTitle": "ކްރެޑިޓް ހާލަތު",
      "panelDescription": "ޓެނަންޓުގެ ހުރިހާ ކުންފުންޏެއް ހިމަނައިގެން، މި ކަސްޓަމަރު މިހާރު ހުރި ހާލަތު.",
      "passing": "ކްރެޑިޓް ޝަރުޠުތަކުގެ ތެރޭގައި",
      "failing": "ކްރެޑިޓް ޗެކުން ފެއިލްވެއްޖެ",
      "limit": "ކްރެޑިޓް ލިމިޓް",
      "noLimit": "ލިމިޓެއް ރެކޯޑްކޮށްފައި ނެތް",
      "exposure": "ބޭނުންކޮށްފައިވާ ކްރެޑިޓް",
      "available": "ބާކީ އޮތް ކްރެޑިޓް",
      "overage": "ލިމިޓަށްވުރެ އިތުރުވެފައި",
      "overdue": "މުއްދަތު ފަހަނައަޅާފައި",
      "overdueDays": "{days} ދުވަހާ ހަމައަށް",
      "utilisation": "ލިމިޓުގެ {percent}%",
      "overrideGranted": "މި ލިޔުމަށް ކްރެޑިޓް އޯވަރައިޑް ދެވިފައިވެއެވެ.",
      "unavailable": "އަދި ދައްކާނެ ކްރެޑިޓް ހާލަތެއް ނެތް.",
      "conditions": {
        "credit_limit": "މި ލިޔުމުން ކަސްޓަމަރު ކްރެޑިޓް ލިމިޓް ފަހަނައަޅައި ދެއެވެ.",
        "overdue": "ކަސްޓަމަރުގެ ބާކީ އެއްބަސްވެފައިވާ މުއްދަތަށްވުރެ ފަހަނައަޅާފައިވެއެވެ.",
        "customer_status": "ކަސްޓަމަރުގެ އެކައުންޓް އެކްޓިވެއް ނޫން."
      }
    },
    "creditBlock": {
      "title": "މި ލިޔުން ކަސްޓަމަރުގެ ކްރެޑިޓް ޗެކުން ފެއިލްވެއްޖެ",
      "pendingTitle": "ކްރެޑިޓް އޯވަރައިޑަށް އެދިފައި",
      "pendingBody": "ތިޔަ އެދުން ފާސްކުރުމުގެ ސިލްސިލާއަށް ފޮނުވިއްޖެއެވެ. މީހަކު ފާސްކުރަންދެން މި ލިޔުން ދެލިކޮޕީއެއްގެ ގޮތުގައި އޮންނާނެއެވެ، އަދި ފާސްކުރުމަށްފަހު އަލުން ކަށަވަރުކުރުމުން ނަންބަރު ދޫކުރެވޭނެއެވެ.",
      "noPermission": "މިއަށްފަހުވެސް މި ލިޔުން ކަށަވަރުކުރުމަށް ކްރެޑިޓް އޯވަރައިޑް ހުއްދަ ބޭނުންވެއެވެ، އެ ހުއްދަ ތިޔަގެ އަތުގައި ނެތެވެ. މި ކަސްޓަމަރުގެ ކްރެޑިޓް ކޮންޓްރޯލް ބަލަހައްޓާ ފަރާތާ މަޝްވަރާކުރޭ.",
      "requestOverride": "ކްރެޑިޓް އޯވަރައިޑަކަށް އެދޭ",
      "reasonLabel": "މި ލިޔުން ފާސްވާން ޖެހޭ ސަބަބަކީ ކޮބާ؟",
      "reasonHint": "ލާޒިމު، އަދި ތިޔަގެ ނަމުގައި އޮޑިޓް ލޮގުގައި ރެކޯޑްކުރެވެއެވެ. ސަބަބެއް ނުލިޔެ ދެވޭ އޯވަރައިޑަކީ ހަމައެކަނި ބައިޕާސްއެކެވެ.",
      "reasonPlaceholder": "މިސާލު: 3 އޯގަސްޓުގައި ކަސްޓަމަރާއެކު އެއްބަސްވެފައިވާ ފައިސާ ދެއްކުމުގެ ޕްލޭން؛ ފުރަތަމަ ބައި މިހާރު ލިބިއްޖެ.",
      "submitOverride": "އެދުން ފޮނުވާ",
      "viewApprovals": "ފާސްކުރުމުގެ އިންބޮކްސް ހުޅުވާ",
      "pendingWait": "އެދުން ފާސްކުރާ މީހުންގެ އަތުގައި އޮތްހާ ހިނދަކު ކަށަވަރުކުރުމާއި އޯވަރައިޑް ބަންދުކުރެވިފައި ހުންނާނެއެވެ. އެމީހުން ނިންމުމަށްފަހު މި ލިޔުން އަލުން ލޯޑްކުރައްވާ."
    },
    "customers": {
      "title": "ކަސްޓަމަރުން",
      "description": "ބިލްކުރަނީ ކާކަށްކަން، ކޮން ޝަރުޠުތަކެއްގައިކަން، އަދި ކިހާ ކްރެޑިޓެއް ދެވިދާނެކަން.",
      "detailDescription": "ޝަރުޠުތައް، ކްރެޑިޓް ހާލަތު، ލެޖަރ އަދި ފައިސާ ހޯދުމުގެ ހާލަތު.",
      "dialogDescription": "މިތާ ހުރި ވިޔަފާރީގެ ޝަރުޠުތައް ތަންފީޒުކުރެވެނީ އިންވޮއިސް ކަށަވަރުކުރާ ވަގުތުއެވެ.",
      "createTitle": "އައު ކަސްޓަމަރު",
      "editTitle": "ކަސްޓަމަރު އިޞްލާޙުކުރޭ",
      "new": "އައު ކަސްޓަމަރު",
      "backToList": "ހުރިހާ ކަސްޓަމަރުން",
      "tableLabel": "ކަސްޓަމަރުން",
      "searchHint": "ކޯޑް، ނަން ނުވަތަ އީމެއިލް",
      "loadFailed": "ކަސްޓަމަރުން ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ކަސްޓަމަރެއް ނެތް",
      "emptyDescription": "‘އައު ކަސްޓަމަރު’ އިން ފުރަތަމަ ކަސްޓަމަރު އިތުރުކުރޭ — އިންވޮއިސެއް އުފެއްދުމުގެ ކުރިން ކަސްޓަމަރެއް ބޭނުންވާނެއެވެ.",
      "pickerPlaceholder": "ކަސްޓަމަރެއް ޚިޔާރުކުރޭ",
      "termsTitle": "ޝަރުޠުތައް",
      "quickLinks": "ދާންވީ ތަން",
      "ledgerTitle": "ލެޖަރ",
      "ledgerCaption": "މި ކަސްޓަމަރުގެ ޕޯސްޓްކޮށްފައިވާ ކޮންމެ ލިޔުމެއް، ހިނގަމުންދާ ބާކީއާއެކު",
      "ledgerFailed": "މި ކަސްޓަމަރުގެ ލެޖަރ ލޯޑެއް ނުކުރެވުނު",
      "termsDays": "{days} ދުވަސް",
      "noOverdueBlock": "ޗެކްނުކުރޭ",
      "noPriceTier": "އާދައިގެ",
      "portalOn": "ހުޅުވާލެވިފައި",
      "portalOff": "ހުޅުވާލެވިފައި ނުވޭ",
      "statuses": {
        "active": "އެކްޓިވް",
        "on_hold": "މަޑުޖައްސާލާފައި",
        "blocked": "ބްލޮކްކޮށްފައި"
      },
      "columns": {
        "terms": "ޝަރުޠުތައް",
        "dunning": "ނޯޓިސް"
      },
      "fields": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "legalName": "ޤާނޫނީ ނަން",
        "currency": "ވިޔަފާރީގެ ފައިސާ",
        "currencyHint": "އިންވޮއިސްތަކުގައި ޑިފޯލްޓްކޮށް ބޭނުންކުރެވޭ ފައިސާ.",
        "creditLimit": "ކްރެޑިޓް ލިމިޓް",
        "creditLimitHint": "ސުމަކީ ލިމިޓެއް ރެކޯޑްކޮށްފައި ނުވުމެވެ؛ ހުރިހާ އެއްޗެއް ހުއްޓުވުމެއް ނޫނެވެ. ވިޔަފާރި ހުއްޓުވަން ބޭނުންނަމަ ސްޓޭޓަސް ބްލޮކްކުރޭ.",
        "creditLimitCurrency": "ލިމިޓުގެ ފައިސާ",
        "creditLimitCurrencyHint": "އެހެން ފައިސާތަކުން ހުރި ކްރެޑިޓް، އަޅާކިޔުމުގެ ކުރިން މި ފައިސާއަށް ބަދަލުކުރެވެއެވެ.",
        "creditLimitLockedHint": "ކްރެޑިޓް ލިމިޓާއި އޭގެ ފައިސާ ބަދަލުވަނީ ފާސްކުރެވިފައިވާ ކްރެޑިޓް ލިމިޓް އެދުމަކުން އެކަންޏެވެ.",
        "statusHoldHint": "ކްރެޑިޓް ހޯލްޑް ޖަހައި ނަގަނީ ސަބަބު ރެކޯޑްކުރާ ކްރެޑިޓް ހޯލްޑް އެކްޝަންތަކުންނެވެ.",
        "paymentTermsCode": "ޝަރުޠުގެ ކޯޑް",
        "paymentTermsDays": "ޝަރުޠު (ދުވަސް)",
        "paymentTermsDaysHint": "އިންވޮއިސްގެ ދައްކަންޖެހޭ ތާރީޚް ޑިފޯލްޓްކުރަން ބޭނުންކުރެވެއެވެ.",
        "overdueBlockDays": "މުއްދަތު ފަހަނައެޅުމުގެ ލުއި (ދުވަސް)",
        "overdueBlockDaysHint": "އައު އިންވޮއިސްތައް ހުއްޓުވުމުގެ ކުރިން ބާކީ ލަސްވެވޭނެ މުއްދަތު. ސުމަކީ ޗެކްނުކުރުމެވެ.",
        "priceTier": "އަގުގެ ފަންތި",
        "portalAccess": "ޕޯޓަލް އެކްސެސް",
        "portalAccessHint": "މި ކަސްޓަމަރަށް އޯޑަރުތަކާއި، އިންވޮއިސްތަކާއި، ސްޓޭޓްމަންޓް ބެލުމަށް ސައިން-އިން ކުރެވޭނެއެވެ.",
        "notes": "ނޯޓުތައް"
      },
      "links": {
        "invoices": "އިންވޮއިސްތައް",
        "openInvoices": "ދައްކަން ޖެހޭ އިންވޮއިސްތައް",
        "creditNotes": "ކްރެޑިޓް ނޯޓްތައް",
        "receipts": "ރަސީދުތައް",
        "recordReceipt": "ރަސީދެއް ރެކޯޑްކުރޭ",
        "statement": "ސްޓޭޓްމަންޓް",
        "aging": "އޭޖިންގ",
        "position": "ފުރިހަމަ އެކްސްޕޯޜަރ"
      },
      "timeline": {
        "created": "ކަސްޓަމަރު އުފެއްދި",
        "dunningPaused": "ނޯޓިސް ފޮނުވުން މަޑުޖައްސާލެވިއްޖެ"
      },
      "toasts": {
        "created": "ކަސްޓަމަރު އުފައްދައިފި",
        "updated": "ކަސްޓަމަރު އަޕްޑޭޓްކޮށްފި"
      }
    },
    "ledger": {
      "opening": "ފެށޭ ބާކީ",
      "closing": "ނިމޭ ބާކީ",
      "empty": "މި ކުންފުނީގައި މި ކަސްޓަމަރަށް އަދި އެއްވެސް އެއްޗެއް ޕޯސްޓްކޮށްފައި ނުވޭ.",
      "columns": {
        "date": "ތާރީޚް",
        "doc": "ލިޔުން",
        "memo": "ނޯޓު",
        "debit": "ޑެބިޓް",
        "credit": "ކްރެޑިޓް",
        "balance": "ބާކީ"
      }
    },
    "receipts": {
      "listTitle": "ރަސީދުތައް",
      "listDescription": "ކަސްޓަމަރުންގެ ފަރާތުން ލިބުނު ފައިސާ، އަދި އޭގެ ތެރެއިން ހަމަޖައްސާފައިވާ މިންވަރު.",
      "title": "ރަސީދު {receiptNo}",
      "newTitle": "ރަސީދެއް ރެކޯޑްކުރޭ",
      "description": "ލިބިފައިވާ ފައިސާ ރެކޯޑްކޮށް، އެއިން ދައްކާނެ އިންވޮއިސްތައް ކަނޑައަޅާ.",
      "headerTitle": "ރަސީދު",
      "new": "ރަސީދެއް ރެކޯޑްކުރޭ",
      "backToList": "ހުރިހާ ރަސީދުތައް",
      "tableLabel": "ރަސީދުތައް",
      "searchHint": "ރަސީދު ނަންބަރު ނުވަތަ ފައިސާގެ ރެފަރެންސް",
      "openOnly": "ހަމަނުޖައްސާ ކްރެޑިޓް އެކަނި",
      "posted": "ޕޯސްޓްކޮށްފި",
      "loadFailed": "މި ރަސީދު ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ރަސީދެއް ނެތް",
      "emptyDescription": "‘ރަސީދެއް ރެކޯޑްކުރޭ’ އިން ފުރަތަމަ ރަސީދު އުފައްދާ — ރަސީދަކީ މިހާރު ލިބިފައިވާ ފައިސާ ކަމުން، ރެކޯޑްކުރާ ވަގުތު ޕޯސްޓްވެއެވެ.",
      "immutable": "ރެކޯޑްކުރާ ވަގުތު ރަސީދު ޕޯސްޓްވާތީ، ހެޑަރ ބަދަލެއް ނުކުރެވެއެވެ. އަދިވެސް ހުޅުވިފައި އޮންނަނީ އެއިން ހަމަޖައްސާ މިންވަރެވެ.",
      "appliedTitle": "ކުރިން ހަމަޖައްސާފައި",
      "appliedCaption": "މި ރަސީދުން ކުރިން ދައްކާފައިވާ އިންވޮއިސްތައް",
      "actionsLabel": "ރަސީދުގެ ޢަމަލުތައް",
      "railSubtitle": "{date} ގައި {method} އިން ލިބުނު",
      "methods": {
        "bank_transfer": "ބޭންކް ޓްރާންސްފަރ",
        "cash": "ފައިސާ",
        "cheque": "ޗެކް",
        "card": "ކާޑް",
        "other": "އެހެނިހެން"
      },
      "columns": {
        "receiptNo": "ރަސީދު ނަންބަރު",
        "date": "ތާރީޚް",
        "method": "ގޮތް",
        "reference": "ރެފަރެންސް",
        "amount": "ލިބުނު",
        "allocated": "ހަމަޖައްސާފައި",
        "unallocated": "ހަމަނުޖައްސާ"
      },
      "fields": {
        "date": "ރަސީދުގެ ތާރީޚް",
        "amount": "ލިބުނު އަދަދު",
        "amountHint": "ޙަޤީޤަތުގައި ލިބުނު މިންވަރު. އިންވޮއިސްތަކަށް ހަމަޖެއްސުމަކީ ދެން އޮތް ފިޔަވަޅެވެ.",
        "depositAccount": "ޖަމާކުރި އެކައުންޓް",
        "depositAccountHint": "ދެއްކިފައިވަނީ މި ރަސީދުގެ ފައިސާގެ އެކައުންޓްތައް އެކަނިއެވެ.",
        "depositAccountPlaceholder": "ބޭންކް ނުވަތަ ކޭޝް އެކައުންޓެއް ޚިޔާރުކުރޭ",
        "method": "ގޮތް",
        "reference": "ފައިސާގެ ރެފަރެންސް",
        "referenceHint": "އިންވޮއިސް ނަންބަރެއް ހިމެނޭނަމަ، އެ އިންވޮއިސް އެންމެ ފުރަތަމަ ހުށަހެޅޭނެއެވެ.",
        "allocated": "ހަމަޖައްސާފައި",
        "unallocated": "ހަމަނުޖައްސާ",
        "postedAt": "ޕޯސްޓްކުރި"
      },
      "actions": {
        "record": "ރަސީދު ރެކޯޑްކުރޭ",
        "apply": "އިންވޮއިސްތަކަށް ހަމަޖައްސާ"
      },
      "timeline": {
        "created": "އުފެއްދި",
        "posted": "{receiptNo} ގެ ގޮތުގައި ޕޯސްޓްކޮށްފި"
      },
      "links": {
        "customer": "ކަސްޓަމަރު",
        "journal": "ޖާނަލް އެންޓްރީ"
      },
      "toasts": {
        "recorded": "ރަސީދު {receiptNo} ރެކޯޑްކޮށްފި",
        "recordedDetail": "ފައިސާ ޕޯސްޓްކުރެވި، ޚިޔާރުކުރި ހަމަޖެއްސުންތައް ތަންފީޒުވެއްޖެ.",
        "recordFailed": "މި ރަސީދު ރެކޯޑެއް ނުކުރެވުނު",
        "applied": "ހަމަޖެއްސުންތައް ތަންފީޒުކޮށްފި",
        "appliedDetail": "އެ މިންވަރަށް އިންވޮއިސްތައް ދެއްކިއްޖެ.",
        "applyFailed": "މި ހަމަޖެއްސުންތައް ތަންފީޒެއް ނުކުރެވުނު"
      }
    },
    "alloc": {
      "title": "އިންވޮއިސްތަކަށް ހަމަޖައްސާ",
      "description": "ހުށަހެޅުންތައް ތަރުތީބުކުރަނީ ސާވަރުންނެވެ. ކޮންމެ އަދަދެއްވެސް ބަދަލުކުރެވިދާނެ؛ ޖުމްލަ ރަސީދަށްވުރެ އިތުރެއް ނުވެވޭނެއެވެ.",
      "caption": "މި ކަސްޓަމަރުގެ ދައްކަން ޖެހޭ އިންވޮއިސްތަކާއި، ކޮންމެއަކަށް ހަމަޖެއްސޭ ރަސީދުގެ އަދަދު",
      "loadFailed": "މި ކަސްޓަމަރުގެ ދައްކަން ޖެހޭ އިންވޮއިސްތައް ލޯޑެއް ނުކުރެވުނު",
      "pickCustomer": "ދައްކަން ޖެހޭ އިންވޮއިސްތައް ބެލުމަށް ކަސްޓަމަރެއް ޚިޔާރުކުރޭ.",
      "noOpenItems": "މި ކަސްޓަމަރުގެ ދައްކަން ޖެހޭ އިންވޮއިސްއެއް ނެތެވެ. މުޅި ރަސީދު އެ ކަސްޓަމަރުގެ އެކައުންޓުގައި ކްރެޑިޓެއްގެ ގޮތުގައި އޮންނާނެއެވެ.",
      "available": "ރަސީދު",
      "allocated": "ހަމަޖައްސާފައި",
      "remaining": "ބާކީ",
      "overAllocated": "ރަސީދުގައި ހުރި މިންވަރަށްވުރެ އިތުރަށް ހަމަޖައްސާފައިވެއެވެ.",
      "overpayment": "ބާކީވާ މިންވަރު ކަސްޓަމަރުގެ އެކައުންޓުގައި ކްރެޑިޓެއްގެ ގޮތުގައި އޮންނާނެއެވެ.",
      "columns": {
        "apply": "ހަމަޖައްސާ",
        "invoice": "އިންވޮއިސް",
        "dueDate": "ދައްކަންޖެހޭ",
        "reason": "ހުށަހެޅި ސަބަބު",
        "balance": "ދައްކަން ޖެހޭ",
        "suggested": "ހުށަހެޅި",
        "amount": "ހަމަޖައްސާ",
        "allocatedOn": "ހަމަޖެއްސި ތާރީޚް"
      },
      "reasons": {
        "reference": "ފައިސާގެ ރެފަރެންސްގައި ބަޔާންކޮށްފައި",
        "exact_amount": "ބާކީ ލިބުނު އަދަދާ ދިމާވޭ",
        "oldest_first": "އެންމެ ދުވަސްވީ ދައްކަން ޖެހޭ",
        "manual": "އަމިއްލައަށް ޚިޔާރުކުރި"
      },
      "issues": {
        "invalidAmount": "އެއީ އަދަދެއް ނޫން.",
        "notPositive": "ހަމަޖައްސާ އަދަދު ސުމަށްވުރެ ބޮޑުވާން ޖެހެއެވެ.",
        "exceedsBalance": "މި އިންވޮއިސްގައި ދައްކަން ޖެހޭ މިންވަރަށްވުރެ އިތުރު.",
        "duplicateInvoice": "މި އިންވޮއިސް ދެފަހަރު އެބައޮތެވެ. ދެ އަދަދު އެއްކޮށްލާ."
      },
      "blockers": {
        "nothingSelected": "މި ރަސީދު ހަމަޖައްސާނެ މަދުވެގެން އެއް އިންވޮއިސް ޚިޔާރުކުރޭ.",
        "rowIssues": "ފުރަތަމަ ފާހަގަކޮށްފައިވާ އަދަދުތައް ރަނގަޅުކުރޭ.",
        "overAllocated": "ހަމަޖައްސާފައިވާ ޖުމްލަ ރަސީދަށްވުރެ ބޮޑެވެ. ކުރިއަށް ދިޔުމުގެ ކުރިން އަދަދެއް ކުޑަކުރޭ."
      },
      "actions": {
        "reset": "ހުށަހެޅި ގޮތަށް އަނބުރާ ގެންދޭ",
        "clear": "ހުރިހާ އެއްޗެއް ސާފުކުރޭ"
      },
      "aria": {
        "apply": "މި ރަސީދު އިންވޮއިސް {invoice} އަށް ހަމަޖައްސާ",
        "amount": "އިންވޮއިސް {invoice} އަށް ހަމަޖައްސާ އަދަދު"
      },
      "proposal": {
        "note": "ސިސްޓަމުން ހުށަހަޅާފައި: {basis}. ކޮންމެ ޢަދަދެއް ބަދަލުކޮށްލުމަށްފަހު ހަވާލުކުރައްވާ.",
        "none": "މި ރަސީދުގެ ފައިސާއިން އޭގެ ހަވާލުނުކުރެވި ހުރި ކްރެޑިޓް ނަގާނެ ހުޅުވިފައިވާ އިންވޮއިހެއް ނެތް. އެ ކްރެޑިޓް ކަސްޓަމަރުގެ އެކައުންޓުގައި ބާކީވާނެ."
      }
    },
    "dunning": {
      "title": "ފައިސާ ހޯދުމުގެ ނޯޓިސް",
      "panelTitle": "ފައިސާ ހޯދުން",
      "panelDescription": "އޮޓޮމެޓިކް ސައިކަލުން މި ކަސްޓަމަރު ފަހަތުން ދަނީތޯ.",
      "paused": "މަޑުޖައްސާލާފައި",
      "active": "އެކްޓިވް",
      "pausedState": "މި ކަސްޓަމަރަށް ނޯޓިސް ފޮނުވުން މަޑުޖައްސާލެވިފައިވެއެވެ. އިތުރު ނޯޓިސްއެއް ނުފޮނުވޭނެއެވެ.",
      "activeState": "މި ކަސްޓަމަރުގެ މުއްދަތު ފަހަނައަޅާފައިވާ އިންވޮއިސްތަކަށް ނޯޓިސް ފޮނުވެމުންދެއެވެ.",
      "noPermission": "ފައިސާ ހޯދުން މަޑުޖެއްސުމަށާއި އަލުން ފެށުމަށް ބޭނުންވާ ހުއްދަ ތިޔަގެ އަތުގައި ނެތެވެ.",
      "pauseTitle": "ނޯޓިސް ފޮނުވުން މަޑުޖައްސާ",
      "pauseDescription": "އަލުން ފަށަންދެން {customer} އަށް އިތުރު ނޯޓިސްއެއް ނުފޮނުވޭނެއެވެ.",
      "pauseAction": "ނޯޓިސް ފޮނުވުން މަޑުޖައްސާ",
      "resumeAction": "ނޯޓިސް ފޮނުވުން އަލުން ފަށާ",
      "reasonLabel": "ފައިސާ ހޯދުން މަޑުޖައްސާލަނީ ކީއްވެ؟",
      "reasonHint": "ލާޒިމު، އަދި އޮޑިޓް ލޮގުގައި ރެކޯޑްކުރެވެއެވެ. ސަބަބެއް ނުލިޔެ މަޑުޖެއްސުމަކީ، ނޭނގުމެއްގައި ފައިސާ ހޯދުން ހުއްޓާލުމާ އެއްފަދަ ކަމެކެވެ.",
      "reasonPlaceholder": "މިސާލު: 30 ސެޕްޓެމްބަރާ ހަމައަށް އެއްބަސްވެފައިވާ ފައިސާ ދެއްކުމުގެ ޕްލޭން؛ ބައިތައް މަހުން މަހަށް ލިބެމުންދޭ.",
      "pausedTitle": "ނޯޓިސް ފޮނުވުން މަޑުޖައްސާލައިފި",
      "pausedDetail": "{customer} އަށް އިތުރު ނޯޓިސްއެއް ނުފޮނުވޭނެއެވެ.",
      "resumedTitle": "ނޯޓިސް ފޮނުވުން އަލުން ފަށައިފި",
      "resumedDetail": "{customer} އަލުން ފައިސާ ހޯދުމުގެ ސައިކަލަށް ވަދެއްޖެ.",
      "resumeFailed": "ނޯޓިސް ފޮނުވުން އަލުން ނުފެށުނު",
      "noReason": "ސަބަބެއް ރެކޯޑްކޮށްފައި ނެތް",
      "runOn": "ވިޔަފާރީގެ ތާރީޚް",
      "pausedDescription": "ސައިކަލުން ފަހަތުން ނުދާ ކަސްޓަމަރުންނާއި، އޭގެ ސަބަބު.",
      "pausedCaption": "ނޯޓިސް ސައިކަލް މަޑުޖައްސާލެވިފައިވާ ކަސްޓަމަރުން",
      "nonePaused": "އެއްވެސް ކަސްޓަމަރެއްގެ ފައިސާ ހޯދުމުގެ ސައިކަލް މަޑުޖައްސާލެވިފައި ނުވޭ.",
      "columns": {
        "level": "ލެވެލް",
        "lastSent": "އެންމެ ފަހު ނޯޓިސް",
        "pausedSince": "މަޑުޖެއްސި ފެށިގެން",
        "reason": "ސަބަބު"
      },
      "pausedListTitle": "މަޑުޖައްސާލެވިފައިވާ ކަސްޓަމަރުން"
    },
    "aging": {
      "title": "ލިބެންޖެހޭ ފައިސާގެ އޭޖިންގ",
      "description": "ދައްކަން ޖެހޭ މިންވަރު، ކަސްޓަމަރުން ބަހާލައި، މުއްދަތު ފަހަނައަޅާފައިވާ މިންވަރަށް ބަލައި.",
      "asOf": "ތާރީޚަށް",
      "asOfHint": "ބާކީތައް ނަގަނީ މި ތާރީޚުގައި ހުރި ގޮތަށެވެ.",
      "tableTitle": "{asOf} އަށް ލިބެންޖެހޭ ފައިސާގެ އޭޖިންގ",
      "caption": "ކަސްޓަމަރުންނާއި އޭޖިންގ ބަކެޓަށް ބަހާލެވިފައިވާ ލިބެންޖެހޭ ފައިސާ",
      "loadFailed": "އޭޖިންގ ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު",
      "empty": "އެ ތާރީޚުގައި މި ކުންފުންޏަށް ދައްކަން ޖެހޭ އެއްޗެއް ނެތް.",
      "totals": "ޖުމްލަ",
      "statement": "ސްޓޭޓްމަންޓް",
      "buckets": {
        "current": "އަދި ދައްކަން ނުޖެހޭ",
        "1-30": "1–30 ދުވަސް",
        "31-60": "31–60 ދުވަސް",
        "61-90": "61–90 ދުވަސް",
        "91-120": "91–120 ދުވަސް",
        "121+": "121+ ދުވަސް"
      },
      "columns": {
        "customer": "ކަސްޓަމަރު",
        "total": "ޖުމްލަ",
        "credit": "އެކައުންޓުގައި ހުރި ކްރެޑިޓް",
        "net": "ސާފުކޮށް ދައްކަން ޖެހޭ"
      },
      "kpi": {
        "total": "ދައްކަން ޖެހޭ",
        "totalHelp": "ކަސްޓަމަރުންގެ އެކައުންޓުގައި ހުރި ކްރެޑިޓް ނުކަނޑައި، ދައްކަން ޖެހޭ ހުރިހާ މިންވަރު.",
        "credit": "އެކައުންޓުގައި ހުރި ކްރެޑިޓް",
        "creditHelp": "އަދި އިންވޮއިސްއަކަށް ހަމަނުޖައްސާ ހުރި ރަސީދުތަކާއި ކްރެޑިޓް ނޯޓްތައް.",
        "net": "ސާފުކޮށް ދައްކަން ޖެހޭ",
        "netHelp": "ދައްކަން ޖެހޭ މިންވަރުން އެކައުންޓުގައި ހުރި ކްރެޑިޓް ކެނޑުމުން. ފައިސާ ހޯދުމުގެ ގުޅުމުގައި ބުނަންވީ މި އަދަދެވެ.",
        "customers": "ދައްކަން ޖެހޭ ކަސްޓަމަރުން",
        "customersHelp": "ދައްކަން ޖެހޭ އެއްޗެއް އޮތް ކަސްޓަމަރުންގެ ޢަދަދު."
      }
    },
    "dso": {
      "title": "ފައިސާ ލިބުމަށް ނަގާ ދުވަސް (DSO)",
      "description": "ބިލްކުރެވުނު ފައިސާ ހޯދުމަށް އެވްރެޖްކޮށް ނަގާ މުއްދަތު.",
      "days": "ދުވަސް",
      "window": "މުއްދަތު",
      "formula": "ފޯމިއުލާ",
      "workingTitle": "މި ހިސާބުކުރި ގޮތް",
      "workingDescription": "އިންޕުޓްތައް ނުދައްކާ ބުނާ DSO އަކީ ހިސާބެއް ނޫން، ދަޢުވާއެކެވެ.",
      "loadFailed": "DSO ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު",
      "kpi": {
        "dso": "DSO (ދުވަސް)",
        "dsoHelp": "ނިމޭ ލިބެންޖެހޭ ފައިސާ، ކްރެޑިޓް ސޭލްސްއިން ބަހާ، މުއްދަތުގެ ދުވަސްތަކުން ގުނަކުރެވެއެވެ.",
        "creditSales": "ކްރެޑިޓް ސޭލްސް",
        "creditSalesHelp": "މި މުއްދަތުގައި އިންވޮއިސްކުރެވި، ކްރެޑިޓް ނޯޓްތައް ކެނޑުމަށްފަހު.",
        "receivables": "ނިމޭ ލިބެންޖެހޭ ފައިސާ",
        "receivablesHelp": "މުއްދަތު ނިމުނުއިރު އަދިވެސް ދައްކަން ޖެހޭ މިންވަރު.",
        "days": "މުއްދަތުގެ ދުވަސް",
        "daysHelp": "ހިސާބުކުރެވޭ މުއްދަތުގެ ދިގުމިން."
      },
      "links": {
        "openInvoices": "މީގެ ފަހަތުގައިވާ އިންވޮއިސްތައް",
        "aging": "މުއްދަތު ނިމުނުއިރުގެ އޭޖިންގ"
      },
      "groupBy": {
        "label": "ތަޙުލީލުކުރާ ގޮތް",
        "hint": "ހަމަ މި އަދަދުތައް ބިޒްނަސް ޔުނިޓް ނުވަތަ ކަސްޓަމަރު ސެގްމަންޓަށް ބަހާލުން.",
        "none": "ކުންފުނި ހަމައެކަނި",
        "business_unit": "ބިޒްނަސް ޔުނިޓް",
        "segment": "ކަސްޓަމަރު ސެގްމަންޓް",
        "description": "ސާވަރުން ކޮންމެ ޑޮކިއުމަންޓެއް އޭގެ ގްރޫޕްތަކަށް ބަހާލާތީ، ގްރޫޕްތައް ޖަމާކުރީމާ ޖުމްލަ ލައިނުގައިވާ ކުންފުނީގެ އަދަދުތަކަށް ވާސިލުވޭ.",
        "empty": "މި މުއްދަތުގައި ބަހާލާނެ އެއްޗެއް ނެތް.",
        "unassigned": "ހަވާލުނުކުރެވި",
        "noSales": "ވިއްކުމެއް ނެތް",
        "title": {
          "business_unit": "ބިޒްނަސް ޔުނިޓަށް DSO",
          "segment": "ކަސްޓަމަރު ސެގްމަންޓަށް DSO"
        },
        "columns": {
          "code": "ކޯޑު",
          "name": "ނަން"
        }
      }
    },
    "statement": {
      "title": "ކަސްޓަމަރު ސްޓޭޓްމަންޓް",
      "description": "ކަސްޓަމަރަށް ފޮނުވޭ ލިޔުން: ދައްކަން ޖެހޭ މިންވަރާއި، ކޮންއިރެއްސުރެކަން.",
      "pdf": "PDF ތައްޔާރުކުރޭ",
      "pdfWorking": "އުފައްދަނީ",
      "pdfOpen": "PDF ހުޅުވާ",
      "pdfNotReady": "ސްޓޭޓްމަންޓް PDF އަދި އުފައްދަނީ. މަދު ވަގުތުކޮޅެއް ފަހުން އަލުން ބައްލަވާ.",
      "openOnly": "ދައްކަން ޖެހޭ ތަކެތި އެކަނި",
      "pickCustomer": "ސްޓޭޓްމަންޓް އުފެއްދުމަށް ކަސްޓަމަރެއް ޚިޔާރުކުރޭ.",
      "loadFailed": "މި ސްޓޭޓްމަންޓް ލޯޑެއް ނުކުރެވުނު",
      "empty": "އެ ތާރީޚުގައި މި ކަސްޓަމަރު ދައްކަން ޖެހޭ އެއްޗެއް ނެތް.",
      "asOf": "ތާރީޚަށް",
      "generatedAt": "އުފެއްދި",
      "totalDue": "ދައްކަން ޖެހޭ ޖުމްލަ",
      "unappliedCredit": "އެކައުންޓުގައި ހުރި ކްރެޑިޓް",
      "agingTitle": "ބާކީ ދުވަސްވެފައިވާ ގޮތް",
      "caption": "ހިނގަމުންދާ ބާކީއާއެކު ސްޓޭޓްމަންޓް ސަފުތައް",
      "columns": {
        "date": "ތާރީޚް",
        "docType": "ބާވަތް",
        "docNo": "ރެފަރެންސް",
        "dueDate": "ދައްކަންޖެހޭ",
        "daysDue": "ދުވަސް",
        "amount": "އަދަދު",
        "balance": "ބާކީ"
      },
      "docTypes": {
        "invoice": "އިންވޮއިސް",
        "credit_note": "ކްރެޑިޓް ނޯޓް",
        "receipt": "ރަސީދު"
      }
    },
    "ecl": {
      "matricesTitle": "އީސީއެލް މެޓްރިކްސްތައް",
      "matricesDescription": "ކޮންމެ ސެގްމަންޓަކަށް، ކޮންމެ އޭޖިންގ ބަކެޓަކަށް ގެއްލުމުގެ ރޭޓެއް.",
      "matricesLoadFailed": "އީސީއެލް މެޓްރިކްސްތައް ލޯޑެއް ނުކުރެވުނު",
      "matrixHint": "ހަ ބަކެޓް ސާބިތު. ކޮލަމް ބަދަލުވެއްޖެނަމަ މުއްދަތުތައް އަޅާކިޔޭކަށް ނޯންނާނެ.",
      "matrixPanelTitle": "މެޓްރިކްސްތައް",
      "matrixPanelDescription": "ކޮންމެ ސެގްމަންޓަކަށް އެއް، ތާރީޚުން ފެށިގެން.",
      "matrixEmptyTitle": "މެޓްރިކްސްއެއް ނެތް",
      "matrixEmptyDescription": "ސެގްމަންޓެއް ހަދާ، ދެން މެޓްރިކްސްއެއް، ދެން ކޮންމެ ބަކެޓަކަށް ރޭޓް ލިޔޭ.",
      "tabMatrices": "މެޓްރިކްސް",
      "tabSegments": "ސެގްމަންޓް",
      "tabsLabel": "އީސީއެލް ސެޓިންގ",
      "matrix": "މެޓްރިކްސް",
      "segment": "ސެގްމަންޓް",
      "effectiveFrom": "ފެށޭ ތާރީޚު",
      "macroFactor": "މެކްރޯ ފެކްޓަރ",
      "macroFactorHint": "މުސްތަގުބަލަށް ބަލައި ހުރިހާ ރޭޓަކަށް ގުނަކުރެވޭ އަދަދެއް. 1 ދިނުމުން ބަދަލެއް ނާންނާނެ.",
      "editRates": "ރޭޓްތައް",
      "activate": "ހަރަކާތްތެރިކުރޭ",
      "activated": "މެޓްރިކްސް ހަރަކާތްތެރިކުރެވިއްޖެ",
      "activateFailed": "މެޓްރިކްސް ހަރަކާތްތެރިއެއް ނުކުރެވުނު",
      "newMatrix": "އައު މެޓްރިކްސް",
      "newMatrixDescription": "ސެގްމަންޓާއި ފެށޭ ތާރީޚު ހޮވާ.",
      "matrixCreated": "މެޓްރިކްސް ހެދިއްޖެ",
      "matrixCreateFailed": "މެޓްރިކްސް ނުހެދުނު",
      "matrixStatuses": {
        "draft": "ދެލިކޮޕީ",
        "active": "ހަރަކާތްތެރި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "ratesTitle": "ގެއްލުމުގެ ރޭޓް — {code}",
      "ratesDescription": "ކޮންމެ ބަކެޓެއްގައި ހުރި ފައިސާއިން ގެއްލޭނެ ކަމަށް ބެލެވޭ މިންވަރު.",
      "ratesHint": "ރޭޓަކީ ޑެސިމަލް ބައެއް: 0.035 އަކީ 3.5%. ފްލޯޓިންގ ޕޮއިންޓަކުން ނޫން، ޑެސިމަލްއިން ގުނަކުރެވޭ.",
      "ratesSaved": "ގެއްލުމުގެ ރޭޓް ރައްކާކުރެވިއްޖެ",
      "ratesSaveFailed": "ގެއްލުމުގެ ރޭޓް ރައްކާއެއް ނުކުރެވުނު",
      "bucket": "ބަކެޓް",
      "lossRate": "ގެއްލުމުގެ ރޭޓް",
      "buckets": {
        "current": "އަދި ސުންގަޑި ނުޖެހޭ",
        "d1_30": "1–30 ދުވަސް",
        "d31_60": "31–60 ދުވަސް",
        "d61_90": "61–90 ދުވަސް",
        "d91_120": "91–120 ދުވަސް",
        "d120_plus": "120 ދުވަހަށްވުރެ ގިނަ"
      },
      "segmentPanelTitle": "ސެގްމަންޓްތައް",
      "segmentPanelDescription": "މެޓްރިކްސް ހިނގާ ކަސްޓަމަރުން. ހުރިހާ ކަސްޓަމަރުންގެ ސެގްމަންޓް އަބަދުވެސް އެންމެ ފަހަތުގައި.",
      "segmentEmptyTitle": "ސެގްމަންޓެއް ނެތް",
      "segmentEmptyDescription": "ފުރަތަމަ ހުރިހާ ކަސްޓަމަރުން ހިމެނޭ ސެގްމަންޓެއް ހަދާ.",
      "newSegment": "އައު ސެގްމަންޓް",
      "newSegmentDescription": "ކަސްޓަމަރުން އެއް ގްރޫޕަކަށް ލާ ގަވާއިދެއް.",
      "segmentCreated": "ސެގްމަންޓް ހެދިއްޖެ",
      "segmentCreateFailed": "ސެގްމަންޓް ނުހެދުނު",
      "matchKind": "ދިމާވަނީ",
      "matchKindHint": "ހުރިހާ ކަސްޓަމަރުންގެ ސެގްމަންޓް އަބަދުވެސް އެންމެ ފަހަތަށް ދާނެ.",
      "matchValue": "އަގު",
      "priority": "އިސްކަން",
      "priorityHint": "ކުޑަ އަދަދު ފުރަތަމަ. ދިމާވާ ފުރަތަމަ ސެގްމަންޓަށް ކަސްޓަމަރު ދާނެ.",
      "matchKinds": {
        "all": "ހުރިހާ ކަސްޓަމަރުން",
        "customer_group": "ކަސްޓަމަރު ގްރޫޕް",
        "price_tier": "އަގުގެ ދަރަޖަ",
        "country": "ގައުމު",
        "customer": "އެއް ކަސްޓަމަރު"
      },
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓިފައި",
      "runsTitle": "އީސީއެލް ރަންތައް",
      "runsDescription": "އެލަވަންސް ހުންނަން ޖެހޭ މިންވަރާއި މިހާރު ހުރި މިންވަރު، އަދި ތަފާތު.",
      "runsLoadFailed": "އީސީއެލް ރަންތައް ލޯޑެއް ނުކުރެވުނު",
      "runsTableLabel": "އީސީއެލް ރަންތައް",
      "runsEmptyTitle": "އީސީއެލް ރަންއެއް ނެތް",
      "runsEmptyDescription": "މުއްދަތު ނިމުމަށް އެއް ހިސާބުކުރޭ. ހިސާބުކުރުމުން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުވާނެ.",
      "movementHint": "ލެޖަރަށް ދަނީ ހަމައެކަނި ހަރަކާތް. ކުރީގެ 404,000 މައްޗަށް 412,000 އަކީ 8,000 ގެ ޚަރަދެއް.",
      "runTitle": "އީސީއެލް — {asOf}",
      "runDescription": "ކޮންމެ ކަސްޓަމަރެއް، އޭޖިންގ ބަކެޓުން.",
      "runLoadFailed": "މި އީސީއެލް ރަން ލޯޑެއް ނުކުރެވުނު",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "runStatuses": {
        "draft": "ދެލިކޮޕީ",
        "calculated": "ހިސާބުކުރެވިފައި",
        "posted": "ޕޯސްޓްވެފައި",
        "reversed": "ރިވާސްކުރެވިފައި"
      },
      "asOf": "ތާރީޚު",
      "asOfHint": "ޑިފޯލްޓަކީ ހުޅުވިފައިވާ މުއްދަތުގެ ނިމުން.",
      "grossReceivables": "ޖުމްލަ ލިބެންޖެހޭ",
      "collective": "ޖުމްލަ ގޮތުން",
      "individual": "ވަކިން ބެލި",
      "individualShort": "ވަކިން",
      "priorAllowance": "ކުރީގެ އެލަވަންސް",
      "totalEcl": "ބޭނުންވާ އެލަވަންސް",
      "movement": "ހަރަކާތް",
      "calculate": "ހިސާބުކުރޭ",
      "calculateTitle": "އީސީއެލް ރަންއެއް ހިސާބުކުރޭ",
      "calculateDescription": "އޭޖިންގ ކިޔައި، ސެގްމަންޓަށް ހަރަކާތްތެރި މެޓްރިކްސް ބޭނުންކުރެ، ވަކިން ބެލި އެސެސްމަންޓް މަތިން ލާނެ.",
      "calculateHint": "ހިސާބުކުރުމުން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުވާނެ. ބޭނުން އަދަދަކަށް ތަކުރާރުކުރެވޭނެ.",
      "calculated": "އީސީއެލް ހިސާބުކުރެވިއްޖެ",
      "calculateFailed": "އީސީއެލް ރަން ހިސާބެއް ނުކުރެވުނު",
      "post": "ހަރަކާތް ޕޯސްޓްކުރޭ",
      "posted": "އީސީއެލް ހަރަކާތް ޕޯސްޓްވެއްޖެ",
      "postFailed": "އީސީއެލް ހަރަކާތް ޕޯސްޓެއް ނުކުރެވުނު",
      "postedJournal": "ޖާނަލް #{id} ގެ ގޮތުގައި ޕޯސްޓްވެފައި.",
      "zeroMovement": "އެލަވަންސް މިހާރުވެސް ހުންނަން ޖެހޭ ތަނުގައި، އެހެންވެ މި ރަން ޕޯސްޓްކުރުމުން އެއްޗެއް ބަދަލެއް ނުވާނެ. މިއީ ނަތީޖާއެއް، ފެއިލްވުމެއް ނޫން.",
      "customer": "ކަސްޓަމަރު",
      "gross": "ޖުމްލަ",
      "creditApplied": "ބޭނުންކުރި ކްރެޑިޓް",
      "exposure": "އެކްސްޕޯޜަރ",
      "eclAmount": "އީސީއެލް",
      "linesTableLabel": "ކަސްޓަމަރާއި ބަކެޓުން އީސީއެލް",
      "linesEmptyTitle": "ލައިނެއް ނެތް",
      "linesEmptyDescription": "މި ރަންއަށް ޕްރޮވިޜަން ކުރާނެ ލިބެންޖެހޭ ފައިސާއެއް ނުފެނުނު.",
      "assessmentsTitle": "ވަކިން ބެލި އެސެސްމަންޓްތައް",
      "assessmentsDescription": "މެޓްރިކްސް ރޭޓަކަށްވުރެ ރަނގަޅަށް ގެއްލުން އެނގޭ ކަސްޓަމަރެއް.",
      "assessmentsLoadFailed": "އެސެސްމަންޓްތައް ލޯޑެއް ނުކުރެވުނު",
      "assessmentsTableLabel": "ވަކިން ބެލި އީސީއެލް އެސެސްމަންޓްތައް",
      "assessmentsEmptyTitle": "ވަކިން ބެލި އެސެސްމަންޓެއް ނެތް",
      "assessmentsEmptyDescription": "ހުރިހާ އެންމެންވެސް ޖުމްލަ ގޮތުން. މެޓްރިކްސްއަށް ނޭނގޭ އެއްޗެއް އެނގޭނަމަ އެސެސްމަންޓެއް ނަގާ.",
      "assessmentHint": "އެސެސްމަންޓަކުން މެޓްރިކްސް ބަދަލުވަނީ އެ ކަސްޓަމަރަށް އެކަނި.",
      "newAssessment": "އައު އެސެސްމަންޓް",
      "newAssessmentDescription": "ތަފާސްހިސާބުގެ މޮޑެލްއެއް އިންސާނީ އަދަދަކުން ބަދަލުކުރުމަކީ އޮޑިޓަރު ފުރަތަމަ އަހާނެ ސުވާލު.",
      "assessmentWarning": "މިއިން މެޓްރިކްސް ބަދަލުވަނީ މި ކަސްޓަމަރަށް އެކަނި.",
      "assessmentCreated": "އެސެސްމަންޓް ރެކޯޑްކުރެވިއްޖެ",
      "assessmentFailed": "އެސެސްމަންޓް ރެކޯޑެއް ނުކުރެވުނު",
      "assessmentAsOfHint": "ޑިފޯލްޓަކީ ޖެހިގެން އަންނަ ރަންގެ ތާރީޚު.",
      "assessedAmount": "ބެލެވޭ ގެއްލުން",
      "basis": "އަސާސް",
      "basisHint": "އަދަދު ނެރުނު ގޮތް — ލިބޭނެ ކަމަށް ބެލެވޭ މިންވަރު، ހުރި ސެކިއުރިޓީ، ބަރޯސާވި ސިޓީ.",
      "reason": "ސަބަބު",
      "approvedAt": "ހުއްދަ ދިން",
      "awaitingApproval": "ހުއްދައަށް އިންތިޒާރުގައި",
      "movementTitle": "އެލަވަންސްގެ ހަރަކާތް",
      "movementDescription": "IFRS 7 އިން އެދޭ ލޮސް އެލަވަންސް ރިކޮންސިލިއޭޝަން: ފެށުން، ހަރަކާތް، ނިމުން.",
      "movementLoadFailed": "ހަރަކާތުގެ ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު",
      "movementPanelTitle": "ރަންއިން",
      "movementPanelDescription": "ޕޯސްޓްވި ކޮންމެ ރަންއަކަށް އެއް ރޯ، ދުވަސްވީ ފުރަތަމަ.",
      "movementEmptyTitle": "އަދި އެއްޗެއް ޕޯސްޓްވެފައި ނުވޭ",
      "movementEmptyDescription": "ރަންތައް ޕޯސްޓްވަމުން ރިޕޯޓް ފުރޭނެ.",
      "closingAllowance": "ނިމޭ އެލަވަންސް",
      "notPosted": "ޕޯސްޓްވެފައި ނުވޭ",
      "postedAt": "ޕޯސްޓްވި",
      "from": "އިން",
      "to": "އަށް",
      "note": "ނޯޓް"
    },
    "position": {
      "title": "{customer} — ޕޮޒިޝަން",
      "description": "އެއް ކަސްޓަމަރަކަށް އޮތް ހުރިހާ އެކްސްޕޯޜަރއެއް އެއް ތަނެއްގައި.",
      "crumb": "ޕޮޒިޝަން",
      "customers": "ކަސްޓަމަރުން",
      "loadFailed": "ކަސްޓަމަރުގެ ޕޮޒިޝަން ލޯޑެއް ނުކުރެވުނު",
      "totalExposure": "ޖުމްލަ އެކްސްޕޯޜަރ",
      "creditLimit": "ކްރެޑިޓް ލިމިޓް",
      "headroom": "ބާކީ ޖާގަ",
      "noLimit": "ލިމިޓެއް ކަނޑައެޅިފައި ނުވޭ",
      "overdue": "ލަސްވެފައި",
      "currentEcl": "ޕްރޮވިޜަން ކުރެވިފައި",
      "overLimit": "މި ކަސްޓަމަރު ކްރެޑިޓް ލިމިޓް ފަހަނައަޅައިފި. ކްރެޑިޓް އޯވަރައިޑް ހުއްދަ އޮތް ފަރާތަކުން ދޫނުކުރާހާ ހިނދަކު އައު އޯޑަރު ގަބޫލެއް ނުކުރެވޭނެ.",
      "overdueDays": "އެންމެ ދުވަސްވީ ލަސްވެފައިވާ އައިޓަމަށް {days} ދުވަސް؛ {block} ދުވަހަށްވުރެ ގިނަވުމުން އޯޑަރު ހުއްޓޭނެ.",
      "sourcesTitle": "އެކްސްޕޯޜަރ ހުރި ތަން",
      "sourcesDescription": "ކޮންމެ ސޯސްއެއް ވަކިން، ޖުމްލައާ ބެހޭގޮތުން ބަހުސްކުރެވޭ ގޮތަށް.",
      "sourcesEmptyTitle": "އެކްސްޕޯޜަރއެއް ނެތް",
      "sourcesEmptyDescription": "މި ކަސްޓަމަރު ދަރާފައެއް ނެތް، އޯޑަރެއްވެސް ނެތް.",
      "source": "ސޯސް",
      "amount": "އަދަދު",
      "asOf": "{asOf} އަށް"
    },
    "collections": {
      "title": "ފައިސާ ހޯދުމުގެ މަސައްކަތު ލިސްޓު",
      "description": "މުއްދަތު ހަމަވެފައިވާ އިންވޮއިސްތައް ހުރި ކަސްޓަމަރުން، މިއަދު އެންމެ ބޭނުންތެރި ތަރުތީބުން.",
      "toDunning": "ޑަނިންގ",
      "asOf": "މި ތާރީޚަށް",
      "asOfHint": "މުއްދަތު ހަމަވެފައިވާކަން ބަލަނީ މި ތާރީޚަށް. މިއަދަށް ހުސްކޮށް ދޫކޮށްލައްވާ.",
      "tableTitle": "ތަރުތީބުކުރެވިފައިވާ ލިސްޓު",
      "formula": "ސްކޯ = ގެއްލުމުގެ ނުރައްކަލުގައިވާ އަގު × (1 + 0.25 × ފުއްދައިނުލެވުނު ވަޢުދު، 4 އަށް + 0.10 × ޑަނިންގ ލެވެލް، 5 އަށް). ގެއްލުމުގެ ނުރައްކަލުގައިވާ އަގަކީ މުއްދަތު ހަމަވެފައިވާ ކޮންމެ ބާކީއެއް އުމުރަށް ބަލައި ބަރުކުރުން: 1–30 ދުވަސް ×1.0، 31–60 ×1.5، 61–90 ×2.0، 91–120 ×3.0، 121+ ×4.0. ފުއްދައިނުލެވުނު ވަޢުދު ގުނަނީ ފާއިތުވި 180 ދުވަހުގެ. އެއްވަރުވެއްޖެނަމަ ކުޑަ ކަސްޓަމަރު ނަންބަރު ކުރިއަށް.",
      "loadFailed": "ފައިސާ ހޯދުމުގެ ލިސްޓު ލޯޑް ނުކުރެވުނު",
      "empty": "މި ތާރީޚަށް މުއްދަތު ހަމަވެފައިވާ އިންވޮއިހެއް އެއްވެސް ކަސްޓަމަރަކު ނުހުރޭ. ފަހަތުން ދާންޖެހޭ ކަމެއް ނެތް.",
      "caption": "މުއްދަތު ހަމަވެފައިވާ އިންވޮއިސްތައް ހުރި ކަސްޓަމަރުން، އެންމެ މަތީ ސްކޯ ފުރަތަމަ",
      "onHold": "ކްރެޑިޓް ހިފަހައްޓާފައި",
      "daysOverdue": "{days} ދުވަސް",
      "columns": {
        "rank": "ތަރުތީބު",
        "overdue": "މުއްދަތު ހަމަވެފައި",
        "valueAtRisk": "ނުރައްކަލުގައިވާ އަގު",
        "score": "ސްކޯ",
        "invoices": "އިންވޮއިސް",
        "oldest": "އެންމެ ބާ",
        "broken": "ފުއްދައިނުލެވުނު ވަޢުދު",
        "promise": "ހުޅުވިފައިވާ ވަޢުދު"
      },
      "drill": {
        "title": "ފައިސާ ދެއްކުމުގެ ވަޢުދު: {customer}",
        "description": "މި ކަސްޓަމަރުގެ ފައިސާ ދެއްކުމުގެ ވަޢުދުތައް. ފުއްދައިލެވުނުތޯ ނިންމަނީ ކޮންމެ ދުވަހަކު ލިބުނު ފައިސާއަށް ބަލައި.",
        "customer": "ކަސްޓަމަރުގެ ރެކޯޑް",
        "statement": "ސްޓޭޓްމަންޓް",
        "openInvoices": "ހުޅުވިފައިވާ އިންވޮއިސްތައް",
        "dunning": "ޑަނިންގ"
      },
      "promises": {
        "loadFailed": "މި ކަސްޓަމަރުގެ ވަޢުދުތައް ލޯޑް ނުކުރެވުނު",
        "empty": "މި ކަސްޓަމަރުގެ ފައިސާ ދެއްކުމުގެ ވަޢުދެއް އަދި ރެކޯޑްކޮށްފައެއް ނުވޭ. ކަސްޓަމަރު ތާރީޚަކަށް ވަޢުދުވުމުން ތިރީގައި ރެކޯޑްކުރައްވާ.",
        "caption": "{customer} ގެ ފައިސާ ދެއްކުމުގެ ވަޢުދުތައް",
        "onAccount": "އެކައުންޓާ ދެކޮޅަށް",
        "closed": "މި ވަޢުދު މިހާރު ހުޅުވިފައެއް ނުވާތީ ބަދަލެއް ނުކުރެވޭނެ. އޭގެ ބަދަލުގައި އާ ވަޢުދެއް ރެކޯޑްކުރައްވާ.",
        "stale": "މި ވަޢުދަށް އެހެން މީހަކު ކުރިން ބަދަލު ގެނެސްފި. އަލުން ލޯޑްކުރެވިއްޖެ؛ ބައްލަވައިގެން ބަދަލު އަލުން ސޭވްކުރައްވާ.",
        "createTitle": "ފައިސާ ދެއްކުމުގެ ވަޢުދެއް ރެކޯޑްކުރުން",
        "moreOpen": "ހުޅުވިފައިވާ އިތުރު ވަޢުދުތައް ދައްކާ",
        "moreHistory": "އިތުރު ތާރީޚު ދައްކާ",
        "columns": {
          "promisedDate": "ދައްކާނެ ތާރީޚު",
          "invoice": "އިންވޮއިސް",
          "amount": "ޢަދަދު",
          "status": "ހާލަތު",
          "received": "ލިބިފައި",
          "note": "ނޯޓު"
        },
        "statuses": {
          "open": "ހުޅުވިފައި",
          "kept": "ފުއްދައިފި",
          "broken": "ފުއްދައިނުލެވުނު",
          "cancelled": "ކެންސަލްކުރެވިފައި"
        },
        "fields": {
          "invoice": "އިންވޮއިސް",
          "invoiceHint": "އިޚްތިޔާރީ. ކަސްޓަމަރުގެ މުޅި އެކައުންޓާ ދެކޮޅަށް ވަޢުދަކަށް ހުސްކޮށް ދޫކޮށްލައްވާ.",
          "amount": "ވަޢުދުވި ޢަދަދު",
          "amountHint": "އިންވޮއިސްގެ ފައިސާއިން، ނުވަތަ އެކައުންޓް ވަޢުދަކަށް ކަސްޓަމަރުގެ ފައިސާއިން.",
          "date": "ދައްކާނެ ތާރީޚު",
          "dateHint": "މިއަދު ނުވަތަ އޭގެ ފަހުން.",
          "note": "ނޯޓު"
        },
        "actions": {
          "change": "ބަދަލުކުރުން",
          "cancel": "ވަޢުދު ކެންސަލްކުރުން",
          "record": "ވަޢުދު ރެކޯޑްކުރުން"
        },
        "toasts": {
          "created": "ވަޢުދު ރެކޯޑްކުރެވިއްޖެ",
          "createdDetail": "{customer} {date} ގެ ކުރިން {amount} ދައްކާނެކަމަށް ވަޢުދުވެއްޖެ.",
          "updated": "ވަޢުދު އަޕްޑޭޓްކުރެވިއްޖެ",
          "cancelled": "ވަޢުދު ކެންސަލްކުރެވިއްޖެ"
        }
      }
    },
    "cei": {
      "title": "ފައިސާ ހޯދުމުގެ ފައިދާހުރިމިން",
      "description": "ހޯދަން ލިބެން ހުރި ފައިސާއާ އަޅާބަލާއިރު ހޯދުނު ފައިސާ، މުއްދަތަށް.",
      "loadFailed": "ފައިސާ ހޯދުމުގެ ފައިދާހުރިމިނުގެ ރިޕޯޓު ލޯޑް ނުކުރެވުނު",
      "periodInvalid": "މުއްދަތު ނިމޭ ތާރީޚަކީ ފެށޭ ތާރީޚުގެ ކުރީގެ ތާރީޚަކަށް ނުވާނެ.",
      "period": "މުއްދަތު",
      "workingTitle": "މިއީ ހިސާބުކުރެވުނު ގޮތް",
      "workingDescription": "CEI ގެ ތަފާތު ގޮތްތައް އެއްގޮތެއް ނުވާތީ، ނަތީޖާއާއެކު އިންޕުޓްތަކާއި ސާވަރުގެ ފޯމިއުލާ ދައްކައެވެ.",
      "nothingCollectable": "މި މުއްދަތުގައި ހޯދަން ލިބެން ހުރި ފައިސާއެއް ނެތީތީ ދައްކާނެ އިންޑެކްސެއް ނެތް.",
      "noRatio": "ނިސްބަތެއް ނެތް",
      "bar": "އިންޑެކްސް",
      "trendTitle": "ޓްރެންޑް",
      "trendFailed": "މި މުއްދަތު ލޯޑް ނުކުރެވުނު",
      "trendDescription": {
        "month": "ފާއިތުވި {count} މަސް، އެންމެ އާ މަސް ބަލަނީ މަތީގައިވާ މުއްދަތު ނިމޭހާ ހިސާބަށް.",
        "quarter": "ފާއިތުވި {count} ކުއާޓަރ، އެންމެ އާ ކުއާޓަރ ބަލަނީ މަތީގައިވާ މުއްދަތު ނިމޭހާ ހިސާބަށް."
      },
      "granularity": {
        "label": "ޓްރެންޑް ބަލާ ގޮތް",
        "month": "މަސް",
        "quarter": "ކުއާޓަރ"
      },
      "kpi": {
        "cei": "CEI % (އިންޑެކްސް)",
        "ceiHelp": "(B + S − E) ÷ (B + S − C) × 100. 100% ގެ މާނައަކީ ހޯދަން ލިބެން ހުރި ހުރިހާ ރިސީވަބަލެއް ހޯދުނުކަމެވެ؛ 100% އަށްވުރެ މަތީގެ މާނައަކީ ބާކީވެފައިވާ ފައިސާވެސް ހޯދުނުކަމެވެ.",
        "cash": "ހޯދުނު ފައިސާ",
        "cashHelp": "މުއްދަތުގެ ތެރޭގައި ތާރީޚުކުރެވިފައިވާ ރަސީދުތައް، މަޢުލޫމާތަށް. އިންޑެކްސް ހަދަނީ ރިސީވަބަލްގެ ހާލަތުން، މިއިން ނޫން.",
        "available": "ހޯދަން ލިބެން ހުރި",
        "availableHelp": "B + S − C: މުއްދަތުގައި ހޯދިދާނެ ވަރު."
      },
      "inputs": {
        "b": "B · ފެށުނު ރިސީވަބަލް",
        "s": "S · ކްރެޑިޓް ވިއްކުން",
        "e": "E · ނިމުނު ރިސީވަބަލް",
        "c": "C · އަދި މުއްދަތު ހަމަނުވާ ނިމުނު ރިސީވަބަލް",
        "numerator": "ހޯދުނު (B + S − E)",
        "denominator": "ހޯދިދާނެ (B + S − C)"
      },
      "links": {
        "aging": "މުއްދަތު ނިމޭއިރު އޭޖިންގ"
      }
    },
    "unallocated": {
      "title": "ހަވާލުނުކުރެވި ހުރި ރަސީދުތައް",
      "description": "ލިބުނު ނަމަވެސް އަދި އިންވޮއިހަކާ ހަވާލުނުކުރެވި ހުރި ފައިސާ، އޭގެ އުމުރާއި ސިސްޓަމުން ހުށަހަޅާ ހަވާލުކުރުމާއެކު.",
      "toReceipts": "ހުރިހާ ރަސީދެއް",
      "minAge": "މަދުވެގެން (ދުވަސް)",
      "minAgeHint": "އިޚްތިޔާރީ. މަދުވެގެން މިހާ ދުވަސް ވީ ރަސީދުތައް ހަމައެކަނި.",
      "minAgeInvalid": "0 އިން 3650 އަށް ދުވަހުގެ އަދަދެއް ލިޔުއްވާ.",
      "tableTitle": "އެކައުންޓުގައި ހުރި ރަސީދުތައް",
      "tableDescription": "އެންމެ ބާ ފުރަތަމަ. ހުށަހެޅުމެއް ހަވާލުކުރާއިރު ދައްކާފައިވާ ލައިންތައް ހަމައެކަނި ހަވާލުކުރެވޭ؛ ހަވާލުކުރާއިރު ކޮންމެ ޢަދަދެއް އަލުން ޗެކްކުރެވޭ.",
      "loadFailed": "ހަވާލުނުކުރެވި ހުރި ރަސީދުތައް ލޯޑް ނުކުރެވުނު",
      "empty": "މި ލީގަލް އެންޓިޓީގެ ހުރިހާ ރަސީދެއް ފުރިހަމައަށް ހަވާލުކުރެވިފައި.",
      "caption": "އަދިވެސް ހަވާލުނުކުރެވި ކްރެޑިޓް ހުރި ރަސީދުތައް، އެންމެ ބާ ފުރަތަމަ",
      "ageDays": "{days} ދުވަސް",
      "overMaxAge": "އުމުރުގެ ހައްދު ފަހަނައަޅާފައި",
      "noProposal": "ރަސީދުގެ ފައިސާއިން މި ފައިސާ ނަގާނެ ހުޅުވިފައިވާ އިންވޮއިހެއް ނެތް.",
      "unproposed": "ކްރެޑިޓްގެ ގޮތުގައި ބާކީވާނެ:",
      "apply": "ހުށަހެޅުން ހަވާލުކުރުން",
      "applied": "ރަސީދު {receiptNo} ހަވާލުކުރެވިއްޖެ",
      "appliedDetail": "އަދިވެސް ހަވާލުނުކުރެވި: {unallocated}.",
      "columns": {
        "age": "އުމުރު",
        "base": "ހަވާލުނުކުރެވި (ބޭސް)",
        "proposal": "ހުށަހަޅާ ހަވާލުކުރުން"
      },
      "basis": {
        "reference": "ފައިސާ ދެއްކި ރެފަރެންސްގައި ބުނެފައި",
        "exact_amount": "ބާކީ ޢަދަދާ އެއްގޮތް",
        "oldest_first": "އެންމެ ބާ ބާކީ ފުރަތަމަ",
        "none": "އެއްގޮތްވާ އެއްޗެއް ނެތް"
      },
      "confidence": {
        "high": "ވަރަށް ޔަޤީން",
        "medium": "މެދުމިނުގެ ޔަޤީން",
        "low": "ދަށް ޔަޤީން",
        "none": "ހުށަހެޅުމެއް ނެތް"
      },
      "settings": {
        "title": "އެލާޓްގެ ހައްދުތައް",
        "description": "އެކައުންޓުގައި ހުރި ރަސީދުތައް މި ޢަދަދު ނުވަތަ މި އުމުރު ފަހަނައަޅައިފިނަމަ ކޮންމެ ދުވަހަކު ފައިނޭންސަށް އެލާޓްކުރެވޭ. 0 އިން ޓެސްޓެއް ނިއްވާލެވޭ.",
        "loadFailed": "އެލާޓްގެ ހައްދުތައް ލޯޑް ނުކުރެވުނު",
        "threshold": "ޢަދަދުގެ ހައްދު",
        "thresholdHint": "ހަވާލުނުކުރެވި ހުރި ޖުމްލަ، {currency} އިން. 0 އިން ޢަދަދުގެ ޓެސްޓް ނިއްވާލެވޭ.",
        "thresholdInvalid": "ޢަދަދެއް ލިޔުއްވާ، މިސާލަކަށް 25000.00.",
        "maxAge": "އެންމެ ގިނަ އުމުރު",
        "maxAgeHint": "ރަސީދެއް ހަވާލުނުކޮށް ހުރެވޭނެ ދުވަސް. 0 އިން އުމުރުގެ ޓެސްޓް ނިއްވާލެވޭ.",
        "maxAgeInvalid": "0 އިން 3650 އަށް ދުވަހުގެ އަދަދެއް ލިޔުއްވާ.",
        "days": "{days} ދުވަސް",
        "notConfigured": "ސެޓްކޮށްފައެއް ނުވޭ",
        "notConfiguredHint": "ހައްދުތައް ސޭވްކުރަންދެން މި ލީގަލް އެންޓިޓީއަށް އެއްވެސް އެލާޓެއް ނުކުރެވޭނެ.",
        "edit": "ހައްދުތައް ބަދަލުކުރުން",
        "saved": "އެލާޓްގެ ހައްދުތައް ސޭވްކުރެވިއްޖެ",
        "stale": "މި ހައްދުތަކަށް އެހެން މީހަކު ކުރިން ބަދަލު ގެނެސްފި. އަލުން ލޯޑްކުރެވިއްޖެ؛ ބައްލަވައިގެން އަލުން ސޭވްކުރައްވާ."
      }
    },
    "dunningFilter": {
      "title": "ކަސްޓަމަރު",
      "hint": "އިޚްތިޔާރީ. މި ސްކްރީން އެއް ކަސްޓަމަރަކަށް ހާއްސަކުރުން.",
      "state": "ފައިސާ ހޯދުން",
      "notPaused": "މި ކަސްޓަމަރުގެ ފައިސާ ހޯދުމުގެ ސައިކަލް ހުއްޓާލާފައެއް ނުވޭ."
    },
    "cnAlloc": {
      "noProposalPermission": "ކްރެޑިޓް ނޯޓުތައް ކިޔުމުގެ ހުއްދަ ނެތީތީ މިތަނުން ހަވާލުކުރުމެއް ހުށަނާޅައެވެ. ކްރެޑިޓް ނޯޓު ކިޔުމުގެ ހުއްދަ ހޯއްދަވާ.",
      "title": "އިންވޮއިސްތަކަށް ބޭނުންކުރޭ",
      "description": "މި ކްރެޑިޓް ނޯޓުގައި ބާކީ ހުރި އަދަދު ކަސްޓަމަރުގެ ހުޅުވާފައިވާ އިންވޮއިސްތަކަށް ބޭނުންކުރޭ. ދެ ޑޮކިއުމެންޓް ތަފާތު ރޭޓެއްގައި ޕޯސްޓްކޮށްފައި ނުވާނަމަ ލެޖަރުގައި އެއްވެސް ބަދަލެއް ނާދޭ.",
      "loadFailed": "ކަސްޓަމަރުގެ ހުޅުވާފައިވާ އިންވޮއިސްތައް ލޯޑުނުކުރެވުނު",
      "empty": "މި ކަސްޓަމަރަށް ކްރެޑިޓް ނޯޓު ބޭނުންކުރެވޭނެ ހުޅުވާފައިވާ އިންވޮއިހެއް ނެތް. އިންވޮއިހެއް ޕޯސްޓްކުރެވެންދެން މިއީ އެ ކަސްޓަމަރުގެ ކްރެޑިޓެއްގެ ގޮތުގައި ހުންނާނެ.",
      "reload": "ހުޅުވާފައިވާ އިންވޮއިސްތައް ރީލޯޑްކުރޭ",
      "caption": "މި ކްރެޑިޓް ނޯޓު ބޭނުންކުރެވޭނެ ހުޅުވާފައިވާ އިންވޮއިސްތައް",
      "available": "ކްރެޑިޓް ނޯޓުގައި ބާކީ",
      "remaining": "ބޭނުންކުރުމަށްފަހު ބާކީ",
      "overAllocated": "ކްރެޑިޓް ނޯޓުގައި ހުރި އަދަދަށްވުރެ ގިނައިން ބޭނުންކޮށްފި.",
      "apply": "ކްރެޑިޓް ނޯޓު ބޭނުންކުރޭ",
      "applying": "ބޭނުންކުރަނީ…",
      "serverGuard": "އެއްވެސް އަދަދެއް ބޭނުންކުރުމުގެ ކުރިން ސާވަރުން އިންވޮއިހާއި ކްރެޑިޓް ނޯޓާ އަޅާކިޔައި ބަލާނެ.",
      "blockers": {
        "nothingSelected": "ކްރެޑިޓް ނޯޓު ބޭނުންކުރުމަށް މަދުވެގެން އެއް އިންވޮއިހެއް ހޮވާ.",
        "rowIssues": "ބޭނުންކުރުމުގެ ކުރިން ފާހަގަކޮށްފައިވާ އަދަދުތައް ރަނގަޅުކުރޭ.",
        "overAllocated": "ބޭނުންކުރި ޖުމްލަ، ކްރެޑިޓް ނޯޓުގައި ހުރި އަދަދަށްވުރެ ގިނަ. ބޭނުންކުރުމުގެ ކުރިން އަދަދެއް ކުޑަކުރޭ."
      },
      "toasts": {
        "applied": "ކްރެޑިޓް ނޯޓު {docNo} ބޭނުންކުރެވިއްޖެ",
        "appliedDetail": "އިންވޮއިސްތަކާއި ކްރެޑިޓް ނޯޓުގެ ބެލެންސް އަޕްޑޭޓްކުރެވިއްޖެ.",
        "failed": "ކްރެޑިޓް ނޯޓު ބޭނުން ނުކުރެވުނު"
      }
    },
    "people": {
      "userById": "ޔޫޒަރ #{id}"
    },
    "writeOffs": {
      "newTitle": "އައު ރައިޓް-އޮފް",
      "title": "ރައިޓް-އޮފް {no}",
      "draftTitle": "ޑްރާފްޓް",
      "description": "ކަސްޓަމަރެއްގެ ނުލިބޭނެ އިންވޮއިސްތައް ފޮތުން ނަގާލުން. ފުރަތަމަ ފައިސާ ހޯދުމަށް ކުރި މަސައްކަތުގެ ހެކި، ދެން ހުއްދަ، ދެން ތިންވަނަ މީހަކު ޕޯސްޓް ކުރުން.",
      "backToList": "ހުރިހާ ރައިޓް-އޮފްތައް",
      "loadFailed": "މި ރައިޓް-އޮފް ލޯޑް ނުކުރެވުނު",
      "stale": "ތިޔަ ބަލަހައްޓަމުން ދިޔަ ވަގުތު އެހެން މީހަކު މި ރައިޓް-އޮފް ބަދަލުކޮށްފި. އެއްވެސް ކަމެއް އޮވަރރައިޓް ނުވެއެވެ. އަލުން ލޯޑްކޮށް ބަދަލު އަލުން ކުރައްވާ.",
      "reload": "އަލުން ލޯޑް",
      "notProposer": "މި ޑްރާފްޓް ހުށަހެޅީ {name}. ޑްރާފްޓެއް އެޑިޓް ކުރެވޭނީ ހުށަހަޅާ މީހަކަށް ކަމަށްވާތީ، އައު ރައިޓް-އޮފްއެއް ހުށަހަޅުއްވާ.",
      "rejectedNote": "މި ރައިޓް-އޮފް ބާތިލުވެ ނުވަތަ މުއްދަތު ހަމަވެ ބަންދުވެއްޖެ.",
      "awaiting": "ހުއްދަ ދޭ މީހާގެ ގަޑިއަށް ހުއްދަތަކުގެ އިންބޮކްސްގައި މަޑުކުރަނީ.",
      "awaitingDual": "ދެ ތަފާތު މީހުންގެ ހުއްދައަށް ހުއްދަތަކުގެ އިންބޮކްސްގައި މަޑުކުރަނީ: ދެ ހުއްދައަށް ބޭނުންވާ ހައްދުން މަތިވެފައި.",
      "toApprovals": "ހުއްދަތަކުގެ އިންބޮކްސް ހުޅުވާ",
      "listTitle": "ރައިޓް-އޮފްތައް",
      "listDescription": "ނުލިބޭނެ ލިބެންހުރި ފައިސާގެ ހުށަހަޅާފައިވާ، ހުއްދަ ދެވިފައިވާ، ޕޯސްޓްކުރެވިފައިވާ އަދި ރިވަރސްކުރެވިފައިވާ ރައިޓް-އޮފްތައް.",
      "toSettings": "ހައްދުތައް",
      "new": "އައު ރައިޓް-އޮފް",
      "allStatuses": "ހުރިހާ ހާލަތްތައް",
      "search": "ހޯދާ",
      "searchPlaceholder": "ނަންބަރު، ކަސްޓަމަރުގެ ނަން ނުވަތަ ކޯޑު",
      "tableTitle": "ރައިޓް-އޮފްތައް، އެންމެ ފަހުގެ ފުރަތަމަ",
      "listLoadFailed": "ރައިޓް-އޮފްތައް ލޯޑް ނުކުރެވުނު",
      "empty": "ގުޅޭ ރައިޓް-އޮފްއެއް ނެތް. ކަސްޓަމަރެއްގެ މުއްދަތު ހަމަވެފައިވާ އިންވޮއިސްތަކުން، ފައިސާ ހޯދުމަށް ކުރި މަސައްކަތުގެ ހެކި ގުޅުވާ، ހުށަހަޅުއްވާ.",
      "caption": "ރައިޓް-އޮފްތައް، އެތަކުގެ ހާލަތާއި ބޭސް ކަރަންސީގެ ޖުމްލަ",
      "headerTitle": "ރައިޓް-އޮފް",
      "actionsLabel": "ރައިޓް-އޮފްގެ އަމަލުތައް",
      "tabs": {
        "register": "ރަޖިސްޓަރު",
        "report": "ރިޕޯޓް"
      },
      "columns": {
        "no": "ނަންބަރު",
        "date": "ތާރީޚް",
        "customer": "ކަސްޓަމަރު"
      },
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "submitted": "ހުށަހެޅިފައި",
        "approved": "ހުއްދަ ދެވިފައި",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "rejected": "ބާތިލުކުރެވިފައި",
        "reversed": "ރިވަރސްކުރެވިފައި"
      },
      "flags": {
        "dual": "ދެ ހުއްދަ",
        "committee": "އޯޑިޓް ކޮމިޓީ"
      },
      "reasons": {
        "insolvency": "ފައިސާ ނުދެވޭ ހާލަތް",
        "untraceable": "ކަސްޓަމަރު ހޯދޭކަށް ނެތް",
        "uncollectable": "ހޯދޭކަށް ނެތް",
        "disputed": "ޑިސްޕިއުޓް ކުރެވިފައި",
        "statute_barred": "ޤާނޫނުގެ މުއްދަތު ހަމަވެފައި",
        "other": "އެހެން"
      },
      "fields": {
        "date": "ރައިޓް-އޮފްގެ ތާރީޚް",
        "reasonCode": "ސަބަބު",
        "reasonCodeHint": "ކޮންޓްރޯލްކުރެވިފައިވާ ސަބަބެއް؛ ލިޔުމުން އެ ސަބަބު ފުރިހަމަކުރެވޭނެ.",
        "reasonCodePlaceholder": "ސަބަބެއް ޗޫސްކުރައްވާ",
        "reason": "ތަފްސީލު",
        "reasonHint": "އެހެން ސަބަބު ނޫން ހުރިހާ ސަބަބަކަށް އިޚްތިޔާރީ.",
        "reasonRequired": "ސަބަބު އެހެން ކަމަށްވާނަމަ ބޭނުންވޭ.",
        "totalBase": "ބޭސް ކަރަންސީގައި ޖުމްލަ",
        "status": "ހާލަތް"
      },
      "lines": {
        "title": "ރައިޓް-އޮފް ކުރެވޭ އިންވޮއިސްތައް",
        "description": "މި ކަސްޓަމަރުގެ ޕޯސްޓްކުރެވިފައިވާ ކޮންމެ އިންވޮއިސަކަށް އެއް ސަފް. ހުރި ބާކީ އެކަކުން ރައިޓް-އޮފް ކުރަން އަދަދު ހުސްކޮށް ދޫކޮށްލައްވާ.",
        "caption": "މި ރައިޓް-އޮފް ފޮތުން ނަގާ އިންވޮއިސްތައް",
        "invoice": "އިންވޮއިސް",
        "dates": "އިންވޮއިސްގެ އަދި ދައްކަންޖެހޭ ތާރީޚް",
        "balance": "ބާކީ",
        "amount": "އަދަދު",
        "estimate": "ބޭސް ތަޚްމީނު",
        "base": "ބޭސް އަދަދު",
        "taxRelief": "ޓެކްސް ރިލީފް",
        "notices": "ޑަނިންގ ނޯޓިސް",
        "remove": "ނަގާ",
        "pick": "އިންވޮއިސްއެއް ޗޫސްކުރައްވާ",
        "wholeBalance": "ހުރިހާ ބާކީ",
        "add": "އިންވޮއިސްއެއް އިތުރުކުރޭ",
        "noInvoices": "މި ކަސްޓަމަރަށް ބާކީ ހުރި ޕޯސްޓްކުރެވިފައިވާ އިންވޮއިސްއެއް ނެތް.",
        "optionHint": "ދައްކަންޖެހޭ {due} · ބާކީ {currency} {balance}",
        "issues": {
          "badAmount": "ސުމެއްސަށްވުރެ ބޮޑު އަދަދެއް ލިޔުއްވާ.",
          "overBalance": "އިންވޮއިސްގެ ބާކީއަށްވުރެ ބޮޑު."
        }
      },
      "preview": {
        "title": "ޕޯސްޓިންގގެ ޕްރީވިއު",
        "description": "ރައިޓް-އޮފް ކަސްޓަމަރުގެ އަމިއްލަ ECL ޕްރޮވިޝަނާއި ބެޑް-ޑެބްޓް ޚަރަދާ ދެމެދު ބެހޭގޮތް.",
        "empty": "ބެހޭގޮތް ބެލުމަށް ކަސްޓަމަރަކާއި އިންވޮއިސްއެއް ޗޫސްކުރައްވާ.",
        "total": "ރައިޓް-އޮފް ކުރި ޖުމްލަ",
        "provision": "ECL ޕްރޮވިޝަނުން",
        "expense": "ބެޑް-ޑެބްޓް ޚަރަދު",
        "unavailable": "ކަސްޓަމަރުގެ ޕްރޮވިޝަން މި ކަރަންސީގައި ނުހުރުމުން މިތަނުގައި ބެހުމެއް ތަޚްމީނު ނުކުރެވެއެވެ. ބެހުން ކަނޑައަޅާނީ ރައިޓް-އޮފް ޕޯސްޓް ކުރުމުން ސަރވަރުން.",
        "estimateNote": "ތަޚްމީނެއް. ޙަޤީޤީ ބެހުން ސަރވަރު ކަނޑައަޅާނީ ރައިޓް-އޮފް ޕޯސްޓް ކުރާއިރު، އެދުވަހު ލެޖަރުގައި ހުރި އެލަވަންސުން، އަދި ކަސްޓަމަރަށް ލިބިފައިވާ ޕްރޮވިޝަނަށްވުރެ ބޮޑަށް ނުބޭނުންކުރެވޭ.",
        "taxReliefOn": "ރައިޓް-އޮފް ކުރެވޭ ބާކީގެ އައުޓްޕުޓް ޓެކްސް މި ލީގަލް އެންޓިޓީއަށް ރިލީފް ކުރެވޭ.",
        "taxReliefOff": "އައުޓްޕުޓް ޓެކްސް މި ލީގަލް އެންޓިޓީއަށް ރިލީފް ނުކުރެވޭ.",
        "taxRelief": "ޓެކްސް ރިލީފް",
        "provisionAvailable": "ކަސްޓަމަރގެ ލިބެންހުރި ޕްރޮވިޒަން",
        "notAvailable": "މި ލައިންތަކަށް ބައިބައިކުރުން ކުރިން ދައްކާލެވިފައެއް ނުވޭ. ލިޔުން ޕޯސްޓްކުރުމުން އެއީ ކަނޑައެޅޭނެ."
      },
      "posting": {
        "title": "ޕޯސްޓިންގ",
        "provision": "ECL އެލަވަންސަށް ޗާޖްކުރި",
        "expense": "ބެޑް-ޑެބްޓް ޚަރަދަށް ޗާޖްކުރި",
        "taxRelief": "ރިލީފް ކުރި އައުޓްޕުޓް ޓެކްސް",
        "journal": "ޖޯރނަލް",
        "openJournal": "ޖޯރނަލް ހުޅުވާ",
        "reversalJournal": "ރިވަރސަލް ޖޯރނަލް"
      },
      "evidence": {
        "title": "ފައިސާ ހޯދުމަށް ކުރި މަސައްކަތުގެ ހެކި",
        "description": "ހުށަހެޅުމުގެ ކުރިން ރައިޓް-އޮފްއާ ގުޅާފައިވާ ލިޔުމެއް އަދި ރައިޓް-އޮފް ކުރެވޭ ކޮންމެ އިންވޮއިސަކަށްވެސް ޑަނިންގ ނޯޓިސް ރެކޯޑުކުރެވިފައިވުން، ދެކަމަކީ ބޭނުންވޭ.",
        "met": "ފުރިހަމަ",
        "missing": "ނެތް",
        "attachments": "{count} ލިޔުން ގުޅާފައި",
        "dunning": "ކޮންމެ އިންވޮއިސަކަށްވެސް ޑަނިންގ ނޯޓިސް ރެކޯޑުކުރެވިފައި.",
        "withoutDunning": "ނޯޓިސް ނެތް:",
        "toDunning": "ޑަނިންގ ހުޅުވާ",
        "requirement": "ފައިސާ ހޯދުމަށް ކުރި މަސައްކަތުގެ ހެކި ގުޅުއްވާ: ޚަތުކިތާބު، ޤާނޫނީ ނޯޓިސް، ހޯދުމުގެ ރިޕޯޓް.",
        "saveFirst": "ފުރަތަމަ ޑްރާފްޓް ސޭވްކޮށް، ދެން ހެކި ގުޅުއްވާ."
      },
      "hands": {
        "title": "ކާކު ކޮން ކަމެއް ކުރި",
        "description": "ހުށަހަޅާ މީހާ، ހުއްދަ ދޭ މީހުން، އަދި ޕޯސްޓް ކުރާ މީހާ ތަފާތު މީހުންނެވެ.",
        "proposedBy": "ހުށަހެޅީ",
        "submittedBy": "ސަބްމިޓް ކުރީ",
        "approver1": "ފުރަތަމަ ހުއްދަ ދޭ މީހާ",
        "approver2": "ދެވަނަ ހުއްދަ ދޭ މީހާ",
        "postedBy": "ޕޯސްޓް ކުރީ",
        "reversedBy": "ރިވަރސް ކުރީ",
        "reverseReason": "ރިވަރސްކުރި ސަބަބު"
      },
      "actions": {
        "save": "ޑްރާފްޓް ސޭވް",
        "submit": "ހުއްދައަށް ހުށަހަޅާ",
        "submitting": "ހުށަހަޅަނީ",
        "post": "ރައިޓް-އޮފް ޕޯސްޓް",
        "posting": "ޕޯސްޓް ކުރަނީ",
        "reverse": "ރިވަރސް"
      },
      "blockers": {
        "noCustomer": "ލީގަލް އެންޓިޓީއަކާއި ކަސްޓަމަރަކު ޗޫސްކުރައްވާ.",
        "noReason": "ސަބަބެއް ޗޫސްކުރައްވާ.",
        "reasonText": "އެހެން ސަބަބަށް ތަފްސީލެއް ބޭނުންވޭ.",
        "noLines": "އިންވޮއިސް އެއްވެސް އިތުރުކުރައްވާ.",
        "badAmount": "ރަތްކުރެވިފައިވާ އަދަދު ރަނގަޅުކުރައްވާ.",
        "overBalance": "އަދަދެއް އިންވޮއިސްގެ ބާކީއަށްވުރެ ބޮޑު."
      },
      "submitBlockers": {
        "unsaved": "ފުރަތަމަ ބަދަލުތައް ސޭވްކުރައްވާ.",
        "evidence": "ހުށަހެޅުމުގެ ކުރިން ލިޔުމެއް ގުޅުވާ، ކޮންމެ އިންވޮއިސަކަށްވެސް ޑަނިންގ ނޯޓިސް ރެކޯޑުކުރެވިފައިވާކަން ޔަޤީންކުރައްވާ."
      },
      "postBlocked": {
        "proposer": "މި ރައިޓް-އޮފް ހުށަހެޅީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ ޕޯސްޓް ނުކުރެވޭ. ޕޯސްޓް ހުއްދަ ލިބިފައިވާ އެހެން މީހަކު ކުރަންވާނެ.",
        "submitter": "މި ރައިޓް-އޮފް ސަބްމިޓް ކުރީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ ޕޯސްޓް ނުކުރެވޭ. ޕޯސްޓް ހުއްދަ ލިބިފައިވާ އެހެން މީހަކު ކުރަންވާނެ.",
        "approver": "މި ރައިޓް-އޮފްއަށް ހުއްދަ ދިނީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ ޕޯސްޓް ނުކުރެވޭ. ހުއްދަ ދިނުމުގައި ބައިވެރި ނުވި މީހަކު ކުރަންވާނެ."
      },
      "reverseBlocked": {
        "poster": "މި ރައިޓް-އޮފް ޕޯސްޓް ކުރީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ ރިވަރސް ނުކުރެވޭ. ޕޯސްޓް ހުއްދަ ލިބިފައިވާ އެހެން މީހަކު ކުރަންވާނެ."
      },
      "toasts": {
        "saved": "ރައިޓް-އޮފް ސޭވްކުރެވުނު",
        "savedDetail": "ޑްރާފްޓް ސޭވްވެއްޖެ. ހެކި ގުޅުވާ، ދެން ހުށަހަޅުއްވާ.",
        "saveFailed": "ރައިޓް-އޮފް ސޭވް ނުކުރެވުނު",
        "submitted": "ރައިޓް-އޮފް {no} ހުށަހެޅުނު",
        "submittedDetail": "މިހާރު ހުއްދަ ދޭ މީހުންގެ އަތުގައި.",
        "submitFailed": "ރައިޓް-އޮފް ހުށަހެޅެން ނުޖެހުނު",
        "lapsed": "ރައިޓް-އޮފް ބަންދުކުރެވުނު، ޕޯސްޓް ނުކުރެވުނު",
        "posted": "ރައިޓް-އޮފް {no} ޕޯސްޓްކުރެވުނު",
        "postedDetail": "ލިބެންހުރި ފައިސާ ފޮތުން ނަގާލެވުނު.",
        "postFailed": "ރައިޓް-އޮފް ޕޯސްޓް ނުކުރެވުނު",
        "reversed": "ރައިޓް-އޮފް {no} ރިވަރސްކުރެވުނު",
        "reversedDetail": "އިންވޮއިސްތަކުގެ ބާކީ އަލުން ހުރި."
      },
      "reverse": {
        "title": "މި ރައިޓް-އޮފް ރިވަރސްކުރޭ",
        "description": "ރައިޓް-އޮފް {no} ރިވަރސް ކުރެވެނީ މިރަރ ޖޯރނަލަކުން؛ އިންވޮއިސްތަކުގެ ބާކީ އަލުން ހުރެއެވެ.",
        "restores": "މި ލިބެންހުރި ފައިސާ އަލުން ފޮތަށް ޖަހާނީ:",
        "reason": "ސަބަބު",
        "reasonHint": "ބޭނުންވޭ: ރިވަރސް ކުރުމުން ލިބެންހުރި ފައިސާ އަލުން ފޮތަށް ޖެހޭ.",
        "date": "ރިވަރސްގެ ތާރީޚް",
        "dateHint": "ރައިޓް-އޮފްއަށްވުރެ ކުރީގެ ނޫން ({date}).",
        "dateTooEarly": "ރައިޓް-އޮފްއަށްވުރެ ކުރިން ތާރީޚް ނުކުރެވޭ ({date}).",
        "action": "ރައިޓް-އޮފް ރިވަރސް"
      },
      "report": {
        "title": "ރައިޓް-އޮފް ރިޕޯޓް",
        "pickEntity": "ރައިޓް-އޮފް ރިޕޯޓް ބެލުމަށް އެއް ލީގަލް އެންޓިޓީ ޗޫސްކުރައްވާ.",
        "from": "ފެށިގެން",
        "to": "ހަމަޔަށް",
        "status": "ހާލަތް",
        "postedDefault": "ޕޯސްޓްކުރެވިފައި (ޑިފޯލްޓް)",
        "loadFailed": "ރައިޓް-އޮފް ރިޕޯޓް ލޯޑް ނުކުރެވުނު",
        "total": "ޖުމްލަ",
        "committee": "ކޮމިޓީގެ ހައްދުން މަތި",
        "byReason": "ސަބަބުގެ ގޮތުން ރައިޓް-އޮފްތައް",
        "count": "ޢަދަދު",
        "empty": "މި މުއްދަތުގައި ރައިޓް-އޮފް ނެތް.",
        "rows": "މުއްދަތުގެ ތެރޭގެ ރައިޓް-އޮފްތައް",
        "hands": "މީހުން",
        "journal": "ޖޯރނަލް"
      }
    },
    "writeOffSettings": {
      "title": "ރައިޓް-އޮފްގެ ހައްދުތައް",
      "description": "ދެ ހުއްދައިގެ ހައްދުން މަތީގެ ރައިޓް-އޮފްއަކަށް ދެ ތަފާތު މީހުންގެ ހުއްދަ ބޭނުންވޭ؛ ކޮމިޓީގެ ހައްދުން މަތީގެ ރައިޓް-އޮފް އޯޑިޓް ކޮމިޓީއަށް ރިޕޯޓްކުރެވޭ.",
      "toWriteOffs": "ރައިޓް-އޮފްތައް",
      "entityTitle": "ލީގަލް އެންޓިޓީ",
      "loadFailed": "ރައިޓް-އޮފް ސެޓިންގސް ލޯޑް ނުކުރެވުނު",
      "unconfigured": "މި ލީގަލް އެންޓިޓީއަށް އަދި ރައިޓް-އޮފް ސެޓިންގސް ނެތް. މިހާރު ކަނޑައަޅާ ހައްދުތައް ވަގުތުން ހިނގާނެ، ސަބަބަކީ ލޫސްކުރެވޭނެ ކަމެއް ހިނގަމުން ނުދާތީ.",
      "stale": "ތިޔަ ބަލަހައްޓަމުން ދިޔަ ވަގުތު އެހެން މީހަކު މި ސެޓިންގސް ބަދަލުކޮށްފި. އެއްވެސް ކަމެއް އޮވަރރައިޓް ނުވެއެވެ. އަލުން ލޯޑްކޮށް ބަދަލު އަލުން ކުރައްވާ.",
      "reload": "އަލުން ލޯޑް",
      "noThreshold": "ހައްދެއް ނެތް",
      "formTitle": "ހައްދުތަކާއި އެކައުންޓްތައް",
      "loosening": "މިކަމުން ހައްދެއް އުފުލޭ ނުވަތަ ނަގާލެވޭ، ރައިޓް-އޮފްތައް މަދު ބެލުމަކާއެކު ފާސްވާނެ. މިއީ އެދުމެއް، ހިންގުމެއް ނޫން: ދެވަނަ މީހަކު ހުއްދަ ދެއްވާ ހިނދު އެކަނި ހިނގާނެ.",
      "tightening": "މިކަމުން ހައްދެއް ދަށްކުރޭ ނުވަތަ ނެތްތާކަށް ހައްދެއް ކަނޑައަޅާ. ވަގުތުން ހިނގާ، އަދި މަޑުކުރަމުންދާ ލޫސްކުރުމެއް ވަދަޅު ކުރާ.",
      "actionsLabel": "ރައިޓް-އޮފް ސެޓިންގސްގެ އަމަލުތައް",
      "readOnly": "މި ސެޓިންގސް ކިޔަން ލިބޭ ނަމަވެސް ބަދަލުކުރެވޭކަށް ނެތް.",
      "pending": {
        "title": "ބަދަލެއް ހުއްދައަށް މަޑުކުރަނީ",
        "description": "މި ހައްދުތައް އަދި ހިނގަމުން ނުދޭ. ތިރީގައިވަނީ ތާ ހިނގަމުންދާ ހައްދުތަކެވެ.",
        "badge": "މަޑުކުރަނީ",
        "requestedBy": "އެދުނީ",
        "yours": "މިއަށް އެދުނީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ ހުއްދަ ނުދެވޭ. އެހެން ހުއްދަ ދޭ މީހަކު ނިންމަންވާނެ.",
        "theirs": "ހުއްދަ ދިނުމުގެ ހުއްދަ ލިބިފައިވާ ދެވަނަ މީހަކު ނިންމާނެ.",
        "toApprovals": "ހުއްދަތަކުގެ އިންބޮކްސް ހުޅުވާ"
      },
      "fields": {
        "dual": "ދެ ހުއްދައިގެ ހައްދު",
        "dualHint": "{currency} ގައި. މި ހައްދުން މަތީގެ ރައިޓް-އޮފްއަކަށް ދެ ތަފާތު މީހުންގެ ހުއްދަ ބޭނުންވޭ. ހުސް ނަމަ އެއްވެސް ރައިޓް-އޮފްއަކަށް ނުބޭނުންވޭ.",
        "committee": "އޯޑިޓް ކޮމިޓީގެ ހައްދު",
        "committeeHint": "{currency} ގައި. މި ހައްދުން މަތީގެ ރައިޓް-އޮފް އޯޑިޓް ކޮމިޓީއަށް ރިޕޯޓްކުރެވޭ. ހުސް ނަމަ އެއްވެސް ރައިޓް-އޮފް ރިޕޯޓް ނުކުރެވޭ.",
        "badDebt": "ބެޑް-ޑެބްޓް ޚަރަދު އެކައުންޓް",
        "badDebtHint": "ECL ޕްރޮވިޝަނުން ނުހިމެނޭ ބައި ޗާޖްކުރެވޭ ތަން. ހުސް ނަމަ ECL ޚަރަދު އެކައުންޓް ބޭނުންކުރެވޭ.",
        "badDebtPlaceholder": "ECL ޚަރަދު އެކައުންޓް",
        "taxRelief": "އައުޓްޕުޓް ޓެކްސް ރިލީފް",
        "taxReliefHint": "ޤާނޫނުން ހުއްދަ ދޭ ތަނެއްގައި، ރައިޓް-އޮފް ކުރެވޭ ބާކީގެ އައުޓްޕުޓް ޓެކްސް ރިލީފް ކުރޭ."
      },
      "actions": {
        "save": "ސޭވް",
        "request": "ބަދަލަށް އެދޭ"
      },
      "blockers": {
        "invalid": "ހައްދަކީ ސުމެއްސަށްވުރެ ބޮޑު ނުވަތަ ހަމަހަމަ އަދަދެއް، ނުވަތަ ހުސްކަމެއް ކަމުގައި ވާންވާނެ.",
        "nothing": "އެއްވެސް ބަދަލެއް ނެތް.",
        "pendingExists": "ލޫސްކުރުމެއް ހުއްދައަށް މަޑުކުރަނީ. އެހެން އެއްކަމަށް އެދުމުގެ ކުރިން އެކަން ނިންމަންވާނެ، ނުވަތަ ހައްދެއް ދަށްކޮށް ވަދަޅުކުރަންވާނެ."
      },
      "toasts": {
        "requested": "ބަދަލަށް އެދުނު",
        "requestedDetail": "ދެވަނަ މީހަކު ހުއްދަ ދެއްވާ ހިނދު އެކަނި ހިނގާނެ.",
        "saved": "ސެޓިންގސް ސޭވްކުރެވުނު",
        "savedDetail": "މިހާރުން ފެށިގެން ހުށަހަޅާ ރައިޓް-އޮފްތަކަށް ހައްދުތައް ހިނގާނެ.",
        "saveFailed": "ސެޓިންގސް ސޭވް ނުކުރެވުނު"
      }
    },
    "delivery": {
      "title": "ފޮނުވުން",
      "description": "މި އިންވޮއިސް ކަސްޓަމަރަށް ދާ ގޮތާއި، ފޮނުވުމުގެ ހާލަތް.",
      "channel": "ފޮނުވާ ޗެނަލް",
      "channelHint": "އެހެން ޗެނަލަކުން ފޮނުވުމަކީ އައު މަސައްކަތެއް.",
      "channelHintConfirmed": "ޕޯސްޓް އެންޑް ޑެލިވަރ އިންވޮއިސް ޕޯސްޓްކޮށް، ދެން މި ޗެނަލުން ފޮނުވާ.",
      "channelPlaceholder": "ޗެނަލެއް ޗޫސްކުރައްވާ",
      "draftChannelHint": "ޕޯސްޓްކުރެވޭ އިންވޮއިސް ކަސްޓަމަރަށް ދާނެ ގޮތް.",
      "storedChannel": "އިންވޮއިސްގައިވާ ޗެނަލް",
      "none": "އެއްވެސް ޗެނަލެއް ނެތް",
      "status": "ފޮނުވުމުގެ ހާލަތް",
      "attempts": "މަސައްކަތްތައް",
      "lastAttempt": "ފަހުގެ މަސައްކަތް",
      "sentAt": "ފޮނުވި",
      "deliveredAt": "ލިބުނު",
      "reference": "ފޮނުވި ރެފަރެންސް",
      "referenceHint": "ކޮރިއަރ ނުވަތަ ޕޯސްޓް ސްލިޕް ނަންބަރު، ޕޯސްޓުން ފޮނުވުމާއެކު ރެކޯޑުކުރެވޭ.",
      "lastError": "ފަހުގެ މައްސަލަ:",
      "waiting": "އީމެއިލް ފޮނުވެނީ އިންވޮއިސްގެ PDF ތައްޔާރުވުމުން. ހާލަތް ބެލުމަށް ރިފްރެޝް ކުރައްވާ.",
      "delivering": "ފޮނުވަނީ",
      "chooseChannel": "ޕޯސްޓްކޮށް ފޮނުވުމަށް ފޮނުވާ ޗެނަލެއް ޗޫސްކުރައްވާ.",
      "postedNotDelivered": "އިންވޮއިސް ޕޯސްޓްވެއްޖެ، ނަމަވެސް ފޮނުވުން ނިމުނީ ނޫން. ސަބަބު ރަނގަޅުކޮށް ތިރީގައި އަލުން ފޮނުވާ.",
      "channels": {
        "email": "އީމެއިލް",
        "portal": "ކަސްޓަމަރު ޕޯޓަލް",
        "post": "ޕޯސްޓް",
        "einvoice": "އީ-އިންވޮއިސް"
      },
      "statuses": {
        "pending": "މަޑުކުރަނީ",
        "sent": "ފޮނުވިފައި",
        "delivered": "ލިބިފައި",
        "failed": "ފެއިލްވި"
      },
      "actions": {
        "postAndDeliver": "ޕޯސްޓް އެންޑް ޑެލިވަރ",
        "deliver": "ފޮނުވާ",
        "retry": "ފޮނުވުން އަލުން މަސައްކަތްކުރޭ",
        "deliverBy": "{channel} ފޮނުވާ",
        "refresh": "ރިފްރެޝް"
      },
      "toasts": {
        "postedNotDelivered": "ޕޯސްޓްވި، ނަމަވެސް ފޮނުވެން ނުޖެހުނު",
        "deliverFailed": "އިންވޮއިސް ފޮނުވެން ނުޖެހުނު",
        "failed": "ފޮނުވުން ފެއިލްވި",
        "pending": "{channel} ފޮނުވުމަށް އެދުނު",
        "sent": "{channel} ފޮނުވިފައި",
        "delivered": "{channel} ލިބިފައި",
        "recorded": "ނަތީޖާ އިންވޮއިސްގައި ރެކޯޑުކުރެވިފައި."
      }
    },
    "reallocation": {
      "title": "އަލުން ބެހުން",
      "description": "ރަސީދު {receiptNo} ގައި އެއް އިންވޮއިސަކުން އެހެން އިންވޮއިސަކަށް ފައިސާ ބަދަލުކުރޭ. އަސްލު ބެހުން ހިސްޓްރީގައި ހުރެއެވެ.",
      "from": "ނަގާނީ",
      "fromPlaceholder": "ބެހުމެއް ޗޫސްކުރައްވާ",
      "to": "ބަދަލުކުރާނީ",
      "toHint": "ރަސީދުގެ ކަރަންސީގައިވާ މި ކަސްޓަމަރުގެ ހުޅުވިފައިވާ އިންވޮއިސްތަކާއި، ކޮންމެ އެއްކަމުގެ ބާކީ.",
      "toPlaceholder": "އިންވޮއިސްއެއް ޗޫސްކުރައްވާ",
      "noDestination": "މި ކަރަންސީގައި ފައިސާ ބަދަލުކުރެވޭނެ އެހެން ހުޅުވިފައިވާ އިންވޮއިސްއެއް މި ކަސްޓަމަރަށް ނެތް.",
      "amount": "އަދަދު",
      "amountHint": "ބެހުމުގައި ހުރިހާ ފައިސާ ބަދަލުކުރަން ހުސްކޮށް ދޫކޮށްލައްވާ.",
      "amountHintOpen": "ހުރިހާ {currency} {open} ބަދަލުކުރަން ހުސްކޮށް ދޫކޮށްލައްވާ.",
      "date": "ތާރީޚް",
      "dateHint": "{date} އަށްވުރެ ކުރީގެ ނޫން، މުސްތަޤްބަލުގެ ނޫން، އަދި ހުޅުވިފައިވާ މުއްދަތެއްގައި.",
      "reason": "ސަބަބު",
      "reasonHint": "ބޭނުންވޭ: އިންވޮއިސްތަކާ ދެމެދު ފައިސާ ބަދަލުކުރުމަކީ އެއްވެސް މީހަކު ޒިންމާ ނަގަންޖެހޭ ނިންމުމެއް.",
      "summary": "ބަދަލުކުރާ",
      "action": "އަލުން ބަހާ",
      "openHint": "{currency} {open} ހުޅުވިފައި",
      "availableHint": "{currency} {balance} ދައްކަންޖެހޭ",
      "blockers": {
        "badAmount": "ސުމެއްސަށްވުރެ ބޮޑު އަދަދެއް ލިޔުއްވާ.",
        "overSource": "ބެހުމުގައި ހުރިއަށްވުރެ ބޮޑު.",
        "overDestination": "ބަދަލުކުރާ އިންވޮއިސްގެ ބާކީއަށްވުރެ ބޮޑު.",
        "dateTooEarly": "ތާރީޚަކީ ރަސީދުގެ، ހިސްޓްރީގައި ހުރި ލިޔެކިއުމެއްގެ، ނުވަތަ ބަދަލުކުރާ އިންވޮއިސްގެ ތާރީޚަށްވުރެ ކުރީ.",
        "dateInFuture": "އަލުން ބެހުމެއް މުސްތަޤްބަލުގެ ތާރީޚަކަށް ނުކުރެވޭ."
      },
      "historyTitle": "ބެހުމުގެ ހިސްޓްރީ",
      "historyDescription": "މި ރަސީދުގެ ކޮންމެ ބެހުމާއި، ރިވަރސަލާއި، އަލުން ބެހުން، އެންމެ ކުރީގެ ފުރަތަމަ. އެއްވެސް ކަމެއް އެޑިޓް ނުވެ ނުވަތަ ނުނަގާ.",
      "historyLoadFailed": "ބެހުމުގެ ހިސްޓްރީ ލޯޑް ނުކުރެވުނު",
      "historyEmpty": "މި ރަސީދުން އަދި އެއްވެސް ބެހުމެއް ނުކުރެވޭ.",
      "historyCaption": "ރަސީދުގެ ބެހުމުގެ ލެޖަރު، ރިވަރސަލްތައް ނެގެޓިވް ސަފްތަކެއްގެ ގޮތުގައި",
      "columns": {
        "entry": "އެންޓްރީ",
        "open": "އަދި ހުޅުވިފައި",
        "fx": "ރިއަލައިޒްކުރި FX",
        "who": "ކުރީ",
        "actions": "އަމަލުތައް"
      },
      "kinds": {
        "allocation": "ބެހުން",
        "reversal": "ރިވަރސަލް",
        "reallocation": "އަލުން ބެހުން"
      },
      "movedTo": "{invoice} އަށް ބަދަލުކުރި",
      "movedFrom": "{invoice} އިން ބަދަލުކުރި",
      "journal": "ޖޯރނަލް",
      "done": "އަލުން ބެހިއްޖެ.",
      "fxNet": "ނެޓް FX {amount}",
      "open": "ފައިސާ އަލުން ބަހާ"
    },
    "eclSettings": {
      "title": "ލިބޭނެކަމަށް ނުބެލެވޭ ދަރަނީގެ ގެއްލުމުގެ ސެޓިންގްސް",
      "description": "އީސީއެލް ރަންއެއް ޕޯސްޓްކުރާ އެކައުންޓްތައް، ބޭނުން ނުކުރާ ކްރެޑިޓުން ހުރި ނިސްބަތް ކުޑަކުރާ ގޮތް، އަދި އީސީއެލް ހިންގާތޯ — ކޮންމެ ކުންފުންޏަކަށް ވަކިން.",
      "chooseCompanyTitle": "ކުންފުންޏެއް ހޮވާ",
      "chooseCompanyDescription": "އީސީއެލް ކަނޑައަޅަނީ ކޮންމެ ކުންފުންޏަކަށް ވަކިން. ސެޓިންގްސް ބަލައި ބަދަލުކުރުމަށް މަތިން ކުންފުންޏެއް ހޮވާ.",
      "loadFailed": "އީސީއެލް ސެޓިންގްސް ލޯޑުނުކުރެވުނު",
      "unconfigured": "މި ކުންފުންޏަށް އީސީއެލް އަދި ކަނޑައަޅާފައެއް ނުވޭ. އެލަވަންސް އެކައުންޓާއި ޚަރަދުގެ އެކައުންޓް މިތަނުން ސޭވްކުރުމާހަމައަށް ރަންއެއް ހިސާބުކުރެވޭނެ ނަމަވެސް ޕޯސްޓެއް ނުކުރެވޭނެ.",
      "disabledNote": "މި ކުންފުންޏަށް އީސީއެލް ނިއްވާލާފައި. ރަންތައް ހިސާބުކުރެވޭނެ ނަމަވެސް ހުޅުވާލުމާހަމައަށް ޕޯސްޓެއް ނުކުރެވޭނެ.",
      "stale": "ތިޔަ ބަދަލުކުރަމުންދިޔަ ވަގުތު މި ސެޓިންގްސް އެހެން މީހަކު ބަދަލުކޮށްފި. ސޭވްކުރެވިފައިވާ ވަރޝަން ރީލޯޑްކޮށް، ތިޔަ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ސޭވްކުރެވިފައިވާ ވަރޝަން ރީލޯޑްކުރޭ",
      "noChart": "އެކައުންޓްތަކުގެ ޗާޓު ކިޔުމުގެ ހުއްދައެއް ނެތުމުން، މިތަނުން އެކައުންޓެއް ނުހޮވޭނެ. އެކައުންޓްތަކުގެ ޗާޓު ކިޔުމުގެ ހުއްދަ ހޯދާ.",
      "accountsTitle": "ޕޯސްޓިންގ އެކައުންޓްތައް",
      "accountsDescription": "ރަންއަކުން ޕޯސްޓްކުރަނީ އެލަވަންސްގައި އައި ބަދަލު އެކަނި: ޚަރަދުގެ އެކައުންޓް ޑެބިޓް، އެލަވަންސް އެކައުންޓް ކްރެޑިޓް — އެލަވަންސް ދަށްވާނަމަ މީގެ ފުރަގަސް.",
      "fields": {
        "allowance": "އެލަވަންސް އެކައުންޓް",
        "expense": "އިމްޕެއަރމަންޓް ޚަރަދުގެ އެކައުންޓް",
        "creditApplication": "ބޭނުން ނުކުރާ ކްރެޑިޓް",
        "enabled": "އީސީއެލް ހިންގާ"
      },
      "hints": {
        "allowance": "އެލަވަންސް ބަހައްޓާ ކޮންޓްރާ-ރިސީވަބަލް. މި ކުންފުނީގެ ޕޯސްޓްކުރެވޭ އެކައުންޓަކަށް ވާންޖެހޭ.",
        "expense": "ޗާޖް ނުވަތަ ރިލީސް ފައިދާއާއި ގެއްލުމަށް ވައްދާ ތަން. މި ކުންފުނީގެ ޕޯސްޓްކުރެވޭ އެކައުންޓަކަށް ވާންޖެހޭ.",
        "creditApplication": "ކަސްޓަމަރެއްގެ ބޭނުން ނުކުރާ ކްރެޑިޓުން ޕްރޮވިޜަން ކުރާ ނިސްބަތް ކުޑަކުރާ ގޮތް.",
        "enabled": "ނިއްވާލާފައިވާނަމަ ރަންތައް ބެލުމަށް ހިސާބުކުރެވޭނެ ނަމަވެސް ޕޯސްޓެއް ނުކުރެވޭނެ."
      },
      "notConfigured": "ކަނޑައަޅާފައެއް ނެތް",
      "creditApplications": {
        "oldest_first": "އެންމެ ބާ ބެލެންސުން ފެށިގެން",
        "newest_first": "އެންމެ އާ ބެލެންސުން ފެށިގެން",
        "pro_rata": "ބަކެޓްތަކަށް ނިސްބަތުން ބަހާ",
        "none": "ކްރެޑިޓް ނުކަނޑާ"
      },
      "actionsLabel": "އީސީއެލް ސެޓިންގްސްގެ އަމަލުތައް",
      "auditNote": "ކޮންމެ ސޭވެއް، ކުރިން އަދި ފަހުން ހުރި އަގުތަކާއެކު އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑުކުރެވޭ.",
      "readOnlyNote": "މި ސެޓިންގްސް ތިޔަ ބެލޭނީ ހަމައެކަނި ކިޔުމަށް. ބަދަލުކުރުމަށް އީސީއެލް މެނޭޖްކުރުމުގެ ހުއްދަ ބޭނުންވޭ.",
      "saved": "އީސީއެލް ސެޓިންގްސް ސޭވްކުރެވިއްޖެ",
      "savedDetail": "ދެން ހިންގާ ރަންއަކުން މި އެކައުންޓްތައް ބޭނުންކުރާނެ. ކުރިން ޕޯސްޓްކުރެވިފައިވާ ރަންތަކަށް ބަދަލެއް ނާދޭ.",
      "saveFailed": "އީސީއެލް ސެޓިންގްސް ސޭވްނުކުރެވުނު"
    },
    "customerCredit": {
      "creditControlLink": "ކްރެޑިޓް ކޮންޓްރޯލް",
      "onHold": "ކްރެޑިޓް ހޯލްޑްގައި: ހޯލްޑް ނައްތާލުމާއި ހަމައަށް އައު އިންވޮއިސް، އޯޑަރު އަދި ޑެލިވަރީ ބަންދު.",
      "noHold": "ކްރެޑިޓް ހޯލްޑެއްގައި ނޫން."
    },
    "creditControl": {
      "title": "ކްރެޑިޓް ކޮންޓްރޯލް",
      "description": "ކަސްޓަމަރުން ކޮންމެ މީހެއްގެ ކްރެޑިޓް ލިމިޓް، އެކްސްޕޯޝަރ، ލަސްވެފައިވާ އަދަދު އަދި ބާކީ ކްރެޑިޓް، ހޯލްޑް، ރިލީސް އަދި ލިމިޓް ބަދަލުތަކާއެކު.",
      "company": "ކުންފުނި",
      "filters": {
        "onHold": "ހޯލްޑްގައިވާ ބައި އެކަނި",
        "overLimit": "ލިމިޓަށްވުރެ މަތީ ބައި އެކަނި"
      },
      "tableTitle": "ކްރެޑިޓް އެކްސްޕޯޝަރ",
      "tableDescription": "އަދަދުތަކަކީ މުޅި ކަސްޓަމަރުގެ، ކްރެޑިޓް ލިމިޓްގެ ފައިސާއިން: ކްރެޑިޓް ޗެކް ބޭނުންކުރާ ހަމަ އެ އަދަދުތައް.",
      "loadFailed": "ކްރެޑިޓް އެކްސްޕޯޝަރ ލޯޑް ނުކުރެވުނު",
      "empty": "އަދި ކަސްޓަމަރެއް ނެތް. ކަސްޓަމަރުން ހެދުމުން މިތާނގައި ފެންނާނެ.",
      "emptyFiltered": "މި ފިލްޓަރުތަކާ ގުޅޭ ކަސްޓަމަރެއް ނެތް. އިތުރަށް ފެނުމަށް ފިލްޓަރެއް ފޮހެލާ.",
      "caption": "ކަސްޓަމަރުން ކޮންމެ މީހެއްގެ ކްރެޑިޓް އެކްސްޕޯޝަރ",
      "columns": {
        "hold": "ކްރެޑިޓް ހާލަތު"
      },
      "states": {
        "onHold": "ހޯލްޑްގައި",
        "overLimit": "ލިމިޓަށްވުރެ މަތީ",
        "clear": "ސާފު"
      },
      "sources": {
        "manual": "މީހަކު ލި",
        "dunning": "ޑަނިންގ ލި",
        "limit": "ލިމިޓް ކުޑަކުރުމުން ލި"
      },
      "stale": "ލިސްޓު ލޯޑްކުރިފަހުން މި ކަސްޓަމަރަށް ބަދަލެއް އައިސްފި. ލިސްޓު އަލުން ލޯޑްކޮށްފި؛ އަދަދުތައް ބަލާފައި އަލުން ފޮނުވާ.",
      "reasonHint": "ލާޒިމު، އަދި ތިބާގެ ނަމުގައި އޮޑިޓް ލޮގްގައި ރެކޯޑްކުރެވޭނެ.",
      "hold": {
        "title": "ކްރެޑިޓް ހޯލްޑްގައި ލުން",
        "description": "ހޯލްޑް ނައްތާލުމާއި ހަމައަށް {customer} އަށް އައު އިންވޮއިސް، ސޭލްސް އޯޑަރު، ޝިޕްމަންޓް އަދި އެކައުންޓް ވިއްކުން ރިޖެކްޓްކުރެވޭނެ. ސޭލްސް ވެރިންނަށް އަންގާނެ.",
        "reasonLabel": "މި ކަސްޓަމަރު ހޯލްޑްގައި ލަނީ ކީއްވެ؟",
        "action": "ހޯލްޑްގައި ލާ",
        "doneTitle": "ކްރެޑިޓް ހޯލްޑް ލައިފި",
        "doneDetail": "{customer} ކްރެޑިޓް ހޯލްޑްގައި."
      },
      "release": {
        "title": "ކްރެޑިޓް ހޯލްޑް ނައްތާލުން",
        "description": "{customer} އަށް އަލުން އައު އިންވޮއިސް، އޯޑަރު އަދި ޑެލިވަރީ ލިބިދާނެ.",
        "reasonLabel": "ހޯލްޑް ނައްތާލަނީ ކީއްވެ؟",
        "action": "ހޯލްޑް ނައްތާ",
        "sodNote": "މީހަކު ލި ހޯލްޑެއް ނައްތާލަން ޖެހެނީ އެހެން މީހަކު. ޑަނިންގ ނުވަތަ ލިމިޓް ކުޑަކުރުމުން ލި ހޯލްޑެއް ހޯލްޑް ނައްތާލުމުގެ ހުއްދަ ހުރި ކޮންމެ މީހަކަށް ނައްތާލެވޭނެ.",
        "doneTitle": "ކްރެޑިޓް ހޯލްޑް ނައްތާލައިފި",
        "doneDetail": "{customer} މިހާރު ކްރެޑިޓް ހޯލްޑެއްގައި ނޫން."
      },
      "limit": {
        "open": "ކްރެޑިޓް ލިމިޓް",
        "title": "ކްރެޑިޓް ލިމިޓް",
        "description": "{customer} އަށް އައު ކްރެޑިޓް ލިމިޓެއް އެދޭ. ތިބާ ނޫން މީހަކު އެޕްރޫވްކުރުމުން އެކަނި އެ ހިނގާނެ.",
        "submitted": "އެޕްރޫވަލަށް އެދުން ފޮނުވައިފި:",
        "pendingExists": "މި ކަސްޓަމަރުގެ ކްރެޑިޓް ލިމިޓް ބަދަލެއް ވަނީ އެޕްރޫވަލަށް މަޑުކުރަމުން. އެހެން އެދުމެއް ކުރުމުގެ ކުރިން އެ ނިންމަން ޖެހޭ.",
        "compareCaption": "އެދިފައިވާ ބަދަލުގެ ކުރިންނާއި ފަހުން ކްރެޑިޓް ލިމިޓާއި ބާކީ ޖާގަ",
        "before": "މިހާރު",
        "after": "އެދިފައި",
        "projectionNote": "ބަދަލަށްފަހު ބާކީ ޖާގައަކީ އެދިފައިވާ ލިމިޓުން މިއަދުގެ އެކްސްޕޯޝަރ އުނިކުރުމުން ލިބޭ އަދަދު. ބަދަލު އެޕްރޫވްކުރުމުން ސާވަރު ހާލަތު އަލުން ހިސާބުކުރާނެ.",
        "newLimit": "އައު ކްރެޑިޓް ލިމިޓް ({currency})",
        "newLimitHint": "ސުމެއް ޖެހުމުން ލިމިޓް ނައްތާލެވޭނެ. ދިހަވަނަ ދެ ތަނަށް.",
        "invalid": "ސުމެއް ނުވަތަ އެއަށްވުރެ ބޮޑު އަދަދެއް ޖައްސަވާ، ދިހަވަނަ ދެ ތަނަށް.",
        "reasonLabel": "ލިމިޓް ބަދަލުކުރަންވީ ކީއްވެ؟",
        "noPermission": "ކްރެޑިޓް ލިމިޓް ބަދަލަކަށް އެދުމަށް ކްރެޑިޓް ލިމިޓް ރިކުއެސްޓްގެ ހުއްދަ ބޭނުން، އެ ހުއްދަ ތިބާގެ ނެތް.",
        "historyTitle": "ލިމިޓް ބަދަލުގެ އެދުންތައް",
        "historyFailed": "ލިމިޓް ބަދަލުގެ އެދުންތައް ލޯޑް ނުކުރެވުނު",
        "historyEmpty": "މި ކަސްޓަމަރަށް ލިމިޓް ބަދަލަކަށް އެދިފައެއް ނުވޭ.",
        "requestedAt": "އެދުނު",
        "statuses": {
          "pending": "އެޕްރޫވަލަށް މަޑުކުރަނީ",
          "applied": "ހިންގައިފި",
          "rejected": "ރިޖެކްޓްކުރެވިފި"
        },
        "action": "ބަދަލަށް އެދޭ",
        "doneTitle": "ކްރެޑިޓް ލިމިޓް ބަދަލަކަށް އެދިއްޖެ",
        "doneDetail": "އެދުން އެޕްރޫވަލް ޗޭނަށް ފޮނުވައިފި. އެޕްރޫވްކުރުމުން ލިމިޓް ބަދަލުވާނެ."
      }
    },
    "dunningLevels": {
      "title": "ޑަނިންގ ލެވެލްތައް",
      "description": "ކުރިއަށް ދާ ތަރުތީބު: ކޮންމެ ނޯޓިހަކަށް އިންވޮއިހެއް ކިތައް ދުވަސް ލަސްވާން ޖެހޭ، ކޮން ޗެނަލަކުން، އަދި ފަހު ލެވެލަކީ ކޮބާ.",
      "add": "ލެވެލެއް އިތުރުކުރޭ",
      "loadFailed": "ޑަނިންގ ލެވެލްތައް ލޯޑް ނުކުރެވުނު",
      "empty": "ޑަނިންގ ލެވެލެއް ހަމަޖައްސާފައެއް ނުވާތީ ސައިކަލުން އެއްވެސް އެއްޗެއް ނުފޮނުވާނެ.",
      "emptyManage": "ޑަނިންގ ލެވެލެއް ހަމަޖައްސާފައެއް ނުވާތީ ސައިކަލުން އެއްވެސް އެއްޗެއް ނުފޮނުވާނެ. ލަސްވެފައިވާ އިންވޮއިސްތައް ފަހަތުން ދިއުމަށް ފުރަތަމަ ލެވެލް އިތުރުކުރޭ.",
      "fields": {
        "levelNo": "ލެވެލް",
        "code": "ކޯޑު",
        "name": "ނަން",
        "minDaysOverdue": "ލަސްވެފައިވާ ދުވަސް",
        "channel": "ޗެނަލް",
        "template": "ޓެމްޕްލޭޓް",
        "isFinal": "ފަހު ލެވެލް",
        "isActive": "އެކްޓިވް"
      },
      "hints": {
        "minDaysOverdue": "ޑިއު ތާރީޚުން މިހާ ދުވަސް ފަހަނައަޅައިގެން ދިއުމުން އިންވޮއިހެއް މި ލެވެލަށް ދެއެވެ.",
        "template": "ފޮނުވާނެ ނޯޓިސް ޓެމްޕްލޭޓް. ޑިފޯލްޓަށް ހުސްކޮށް ބާއްވާ.",
        "isFinal": "ފަހު ލެވެލުގެ ނޯޓިހަކުން ކަސްޓަމަރު ކްރެޑިޓް ހޯލްޑްގައި ލާނެ. ފަހު ލެވެލަކަށް ހެދޭނީ އެންމެ މަތީ ލެވެލް އެކަނި.",
        "isActive": "އިނެކްޓިވް ލެވެލެއް ސައިކަލުން ދޫކޮށްލާނެ. ނޯޓިސް ފޮނުވާފައިވާ ލެވެލެއް އިނެކްޓިވް ކުރެވޭނެ ނަމަވެސް ފޮހެލެވޭކަށް ނެތް."
      },
      "channels": {
        "email": "އީމެއިލް",
        "phone": "ފޯނު"
      },
      "final": "ފަހު",
      "inUse": "ބޭނުންކުރެވިފައި",
      "createTitle": "ޑަނިންގ ލެވެލެއް އިތުރުކުރުން",
      "editTitle": "ޑަނިންގ ލެވެލް ބަދަލުކުރުން",
      "dialogDescription": "ލެވެލްތައް މައްޗަށް ދާން ޖެހޭ: މަތީ ލެވެލަކަށް ދަށުގެ ލެވެލަށްވުރެ ގިނަ ލަސްވި ދުވަސް ބޭނުން.",
      "stale": "ތިބާ ބަދަލުކުރަމުން ދަނިކޮށް އެހެން މީހަކު މި ލެވެލަށް ބަދަލެއް ގެނެސްފި. ސޭވްކުރެވިފައިވާ ވަރޝަން އަލުން ލޯޑްކޮށް، ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ސޭވްކުރެވިފައިވާ ވަރޝަން އަލުން ލޯޑްކުރޭ",
      "savedTitle": "ޑަނިންގ ލެވެލް ސޭވްކުރެވިއްޖެ",
      "savedDetail": "{name} ސޭވްކުރެވިއްޖެ. ދެން ހިންގާ ރަނުގައި އެ ބޭނުންކުރާނެ.",
      "deletedTitle": "ޑަނިންގ ލެވެލް ފޮހެލެވިއްޖެ",
      "deletedDetail": "{name} ތަރުތީބުން ނައްތާލެވިއްޖެ.",
      "deleteFailed": "ޑަނިންގ ލެވެލް ފޮހެލެވެން ނެތް",
      "deleteTitle": "ޑަނިންގ ލެވެލް ފޮހެލުން",
      "deleteMessage": "{name} ތަރުތީބުން ނައްތާލެވޭނެ. މިކަން އަނބުރާ ނުކުރެވޭނެ."
    },
    "dunningRun": {
      "pageDescription": "ޑަނިންގ ތަރުތީބު، ޕްރީވިއުއާއެކު ރަނެއް، ފޮނުވި ނޯޓިސްތަކާއި ލިބުނު ޖަވާބުތައް، އަދި ހުއްޓާލެވިފައިވާ ކަސްޓަމަރުން.",
      "effectivenessLink": "ޑަނިންގެ ނަތީޖާ",
      "creditControlLink": "ކްރެޑިޓް ކޮންޓްރޯލް",
      "pauseCustomerLabel": "ކަސްޓަމަރެއް ހުއްޓާލުން",
      "title": "ޑަނިންގ ހިންގުން",
      "description": "ސައިކަލުން ފޮނުވާނެ އެއްޗެއް ޕްރީވިއުކޮށްލާފައި، ހަމަ އެ އެއްޗެއް ފޮނުވާ. ވޯކަރު ކޮންމެ ރޭއަކު ވެސް މި ހިންގާ. އަލުން ހިންގުން ރައްކާތެރި: ލެވެލަކަށް ފޮނުވާފައިވާ ނޯޓިހެއް ދޫކޮށްލާނެ.",
      "noPermission": "ޑަނިންގ ހިންގުމަށް ޑަނިންގ މެނޭޖް ހުއްދަ ބޭނުން، އެ ހުއްދަ ތިބާގެ ނެތް.",
      "asOfHint": "ރަނުން މިއަދު ކަމުގައި ބަލާނެ ދުވަސް. ޕްރީވިއުއަކުން ކުރިއަށް ބެލޭނެ؛ ހަގީގީ ރަނަކަށް މިއަދަށްވުރެ ފަހުގެ ތާރީޚެއް ނުޖެހޭނެ.",
      "levelsLegend": "ލެވެލްތައް",
      "noActiveLevels": "އެކްޓިވް ޑަނިންގ ލެވެލެއް ނެތް. މަތީގައި އެއް އިތުރުކޮށް ނުވަތަ އެކްޓިވް ކުރޭ.",
      "levelsHint": "އެއްވެސް އެއްޗެއް ނުޖެހިއްޔާ ހުރިހާ އެކްޓިވް ލެވެލެއް.",
      "customersLabel": "ކަސްޓަމަރުން",
      "customersHint": "އެއްވެސް މީހަކު ނުޚިޔާރުކުރިއްޔާ ހުރިހާ ކަސްޓަމަރުން.",
      "removeCustomer": "{customer} ނައްތާލާ",
      "previewAction": "ޕްރީވިއު",
      "commitAction": "ނޯޓިސް {count} ފޮނުވާ",
      "futureNote": "މި ތާރީޚަކީ މިއަދަށްވުރެ ފަހުގެ ތާރީޚެއް. ޕްރީވިއު ކުރެވޭނެ ނަމަވެސް ކުރިއަށް އޮތް ތާރީޚަކަށް ހަގީގީ ރަނެއް ނުފޮނުވޭނެ.",
      "result": "{on} ގެ ރަން: ނޯޓިސް {noticed} ފޮނުވައިފި، {skipped} ދޫކޮށްލައިފި.",
      "previewSummary": "{on} ގެ ޕްރީވިއު: ނޯޓިސް {noticed} ފޮނުވާނެ، {skipped} ދޫކޮށްލާނެ. އަދި އެއްވެސް އެއްޗެއް ފޮނުވާފައެއް ނުވޭ.",
      "totalLine": "ނޯޓިސް {count} ން ހޯދަނީ",
      "finalWarning": "ނޯޓިސް {count} ވަނީ ފަހު ލެވެލުގައި. އެ ފޮނުވުމުން އެ ކަސްޓަމަރުން ކްރެޑިޓް ހޯލްޑްގައި ލާނެ.",
      "nothingToSend": "މި ޚިޔާރަށް އެއްވެސް އެއްޗެއް ނުފޮނުވާނެ.",
      "noticesCaption": "މި ރަނުން ފޮނުވާނެ ނޯޓިސްތައް",
      "columns": {
        "recipient": "ލިބޭ ފަރާތް",
        "daysOverdue": "ލަސްވި ދުވަސް",
        "amountDue": "ދައްކަންޖެހޭ އަދަދު",
        "nextAction": "ދެން ކުރާނެ ކަން"
      },
      "placesHold": "ހޯލްޑްގައި ލާނެ",
      "skipsCaption": "މި ރަނުން ދޫކޮށްލާނެ އިންވޮއިސްތައް",
      "skipReasons": {
        "customer_paused": "ކަސްޓަމަރުގެ ޑަނިންގ ހުއްޓާލެވިފައި",
        "no_recipient": "މި ޗެނަލަށް ލިބޭނެ ފަރާތެއް ފައިލުގައި ނެތް",
        "already_sent": "މި ލެވެލުގައި ކުރިން ފޮނުވިފައި"
      },
      "doneTitle": "ޑަނިންގ ރަން ނިމުނީ",
      "doneDetail": "ނޯޓިސް {noticed} ފޮނުވައިފި، {skipped} ދޫކޮށްލައިފި."
    },
    "dunningEvents": {
      "title": "ފޮނުވި ނޯޓިސްތައް",
      "description": "ކޮންމެ ނޯޓިހެއް އޭގެ ލެވެލް، ޗެނަލް އަދި ލިބޭ ފަރާތާއެކު، ކަސްޓަމަރުގެ ރެކޯޑްކުރެވުނު ޖަވާބު އަދި ފައިސާ ދެއްކިތޯ.",
      "filters": {
        "response": "ޖަވާބު",
        "responded": "ޖަވާބު ދީފައި ނުވަތަ ދައްކާފައި",
        "unanswered": "ޖަވާބެއް ނެތް އަދި ނުދައްކާ"
      },
      "loadFailed": "ނޯޓިސްތައް ލޯޑް ނުކުރެވުނު",
      "empty": "މި ފިލްޓަރުތަކާ ގުޅޭ ނޯޓިހެއް ނެތް. ރަނަކުން ފޮނުވުމުން ނޯޓިސްތައް މިތާނގައި ފެންނާނެ.",
      "caption": "ފޮނުވި ޑަނިންގ ނޯޓިސްތައް",
      "columns": {
        "sentOn": "ފޮނުވި",
        "response": "ޖަވާބު",
        "paid": "ދައްކާފައި"
      },
      "responses": {
        "promise_to_pay": "ދައްކާނެކަމުގެ ވަޢުދު",
        "dispute": "ޚިލާފު",
        "no_response": "ޖަވާބެއް ނެތް",
        "other": "އެހެނިހެން"
      },
      "promisedFor": "{date} ގައި ދައްކާނެކަމަށް ވަޢުދުވި",
      "noResponseYet": "އެއްވެސް އެއްޗެއް ރެކޯޑްކޮށްފައެއް ނުވޭ",
      "respond": {
        "open": "ޖަވާބު ރެކޯޑްކުރޭ",
        "title": "ކަސްޓަމަރުގެ ޖަވާބު ރެކޯޑްކުރުން",
        "description": "{customer}، އިންވޮއިސް {invoice}.",
        "noticeLine": "{on} ގައި ފޮނުވި {level} ނޯޓިސް،",
        "responseLabel": "ކަސްޓަމަރު ބުނީ ކީކޭ؟",
        "promisedDate": "ދައްކާނެކަމަށް ވަޢުދުވި ތާރީޚު",
        "promisedDateHint": "ލާޒިމް. ކަސްޓަމަރު ދައްކާނެކަމަށް ބުނި ދުވަސް؛ މިއަދުގެ ކުރިން ނޫން.",
        "action": "ޖަވާބު ރެކޯޑްކުރޭ",
        "doneTitle": "ޖަވާބު ރެކޯޑްކުރެވިއްޖެ",
        "doneDetail": "{invoice} ގެ ނޯޓިހަށް ދިން ޖަވާބު ރެކޯޑްކުރެވިއްޖެ.",
        "promisedDateRequired": "ކަސްޓަމަރު ދައްކާނެކަމަށް ވަޢުދުވި ތާރީޚު ޖައްސަވާ.",
        "promisedDatePast": "ވަޢުދުވި ތާރީޚަކީ މިއަދުގެ ކުރީގެ ދުވަހެއް ކަމުގައި ނުވާނެ.",
        "promisedAmount": "ވަޢުދުވި ޢަދަދު",
        "promisedAmountHint": "އިޚްތިޔާރީ. ދޫކޮށްލައިފިނަމަ އިންވޮއިސްގެ ފުރިހަމަ ބާކީ ހިމެނޭ.",
        "promisedAmountInvalid": "ޕޮޒިޓިވް ޢަދަދެއް ލިޔުއްވާ، މިސާލަކަށް 1250.50."
      },
      "promisedAmountFor": "ވަޢުދުވި ޢަދަދު",
      "promiseStatus": {
        "open": "ވަޢުދު ހުޅުވިފައި",
        "kept": "ވަޢުދު ފުއްދައިފި",
        "broken": "ވަޢުދު ގެއްލުނު",
        "cancelled": "ވަޢުދު ކެންސަލްކުރެވިފައި"
      }
    },
    "dunningEffectiveness": {
      "title": "ޑަނިންގެ ނަތީޖާ",
      "description": "ޑަނިންގ ލެވެލާއި ޗެނަލުން ޖަވާބުދިނުމާއި ފައިސާ ހޯދުނު މިންވަރު.",
      "toDunning": "ޑަނިންގ",
      "sentHint": "މި މުއްދަތުގައި ފޮނުވި ނޯޓިސްތައް.",
      "window": "ނިސްބަތްކުރާ މުއްދަތު (ދުވަސް)",
      "windowHint": "ނޯޓިހަކަށްފަހު ކިހާ ދުވަހަކާ ހަމައަށް ދައްކާ ފައިސާ އެ ނޯޓިހުން ހޯދުނު ކަމަށް ގުނާނީ. ހުސްނަމަ ޑިފޯލްޓް.",
      "windowInvalid": "1 އިން 365 އާ ހަމައަށް ދުވަހުގެ ފުރިހަމަ އަދަދެއް ޖައްސަވާ.",
      "tableTitle": "ލެވެލާއި ޗެނަލުން",
      "windowLine": "ނޯޓިހަކަށްފަހު {days} ދުވަހުގެ ތެރޭގައި ދައްކާ ފައިސާ އެ ނޯޓިހުން ހޯދުނު ކަމަށް ގުނާނެ.",
      "loadFailed": "ޑަނިންގެ ނަތީޖާގެ ރިޕޯޓް ލޯޑް ނުކުރެވުނު",
      "empty": "މި މުއްދަތުގައި އެއްވެސް ނޯޓިހެއް ފޮނުވާފައެއް ނުވޭ.",
      "caption": "ލެވެލް، ޗެނަލް އަދި ފައިސާއިން ޑަނިންގ ޖަވާބާއި ހޯދުނު އަދަދު",
      "columns": {
        "currency": "ފައިސާ",
        "sent": "ފޮނުވި",
        "responded": "ޖަވާބުދިން",
        "noResponse": "ޖަވާބެއް ނެތް",
        "paid": "ދެއްކި",
        "responseRate": "ޖަވާބުދިން މިންވަރު",
        "noticed": "ހޯދަން ދިޔަ އަދަދު",
        "recovered": "ހޯދުނު",
        "recoveryRate": "ހޯދުނު މިންވަރު"
      }
    },
    "creditRefusal": {
      "hold": {
        "title": "މި ކަސްޓަމަރަކީ ކްރެޑިޓް ހޯލްޑްގައި ހުރި ކަސްޓަމަރެކެވެ",
        "body": "މި ކަސްޓަމަރަށް އައު ކަމެއް ކަށަވަރުނުކުރެވޭނެއެވެ، އަދި ހޯލްޑެއް އެއް ލިޔުމެއްގައި އޯވަރައިޑް ނުކުރެވޭނެއެވެ. ހޯލްޑެއް ނައްތާލެވެނީ ކަސްޓަމަރުގެ ރެކޯޑުގައި ރިލީޒްކުރުމުންނެވެ.",
        "reasonLabel": "ހޯލްޑްގެ ސަބަބު"
      },
      "unresolvable": {
        "title": "ކްރެޑިޓް އޯވަރައިޑަށް ފާސްކުރުމުގެ ޕޮލިސީއެއް ނެތް",
        "body": "ކްރެޑިޓް އޯވަރައިޑެއް ނިންމަންޖެހެނީ ފާސްކުރާ މީހެއްގެ ފަރާތުންނެވެ، އެކަމަކު އެކަމަށް ފާސްކުރުމުގެ ޕޮލިސީއެއް ކޮންފިގަރ ނުކުރެވިފައިވާތީ އެދުން ބަލައެއް ނުގަނެވުނެވެ. މި ލިޔުން ލިމިޓުން މަތިން ކަށަވަރުކުރުމުގެ ކުރިން ކްރެޑިޓް އޯވަރައިޑަށް ފާސްކުރުމުގެ ޕޮލިސީއެއް ކޮންފިގަރ ކުރަންޖެހެއެވެ."
      }
    }
  },
  "cash": {
    "filtersTitle": "ފިލްޓަރތައް",
    "allCompanies": "ހުރިހާ ކުންފުނިތައް",
    "fields": {
      "company": "ކުންފުނި",
      "companyBase": "ކުންފުނީގެ އަސާސީ ފައިސާ",
      "code": "ކޯޑް",
      "currency": "ފައިސާ"
    },
    "accounts": {
      "title": "ބޭންކް އަދި ކޭޝް އެކައުންޓްތައް",
      "description": "ފައިސާ ހުރި ތަން، އަދި ކޮންމެ އެކައުންޓެއް ޕޯސްޓްކުރާ ލެޖަރ އެކައުންޓް.",
      "tableLabel": "ބޭންކް އަދި ކޭޝް އެކައުންޓްތައް",
      "searchHint": "ކޯޑް، ނަން، ބޭންކް އަދި އައިބޭން އާ ދިމާވެއެވެ.",
      "loadFailed": "އެ އެކައުންޓްތައް ނުލޯޑްވި",
      "emptyTitle": "އަދި ބޭންކް ނުވަތަ ކޭޝް އެކައުންޓެއް ނެތް",
      "emptyDescription": "ފުރަތަމަ އެކައުންޓް އިތުރުކޮށް، މިހާރުވެސް އެ ބާކީ ހިމެނޭ މުދަލުގެ ލެޖަރ އެކައުންޓާ ގުޅުވާލާ.",
      "newTitle": "އެކައުންޓެއް އިތުރުކުރޭ",
      "newDescription": "އެއް ލެޖަރ އެކައުންޓް، އެއް ބޭންކް އެކައުންޓަށް — މިއީ އެ ދެ ބާކީ އަޅާކިޔޭ ސަބަބެވެ.",
      "editTitle": "އެކައުންޓް އެޑިޓްކުރޭ",
      "editDescription": "އެކައުންޓް އުފެދުމަށްފަހު ލެޖަރ ގުޅުމާއި ފައިސާ ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "detailDescription": "ބޭންކް ނުވަތަ ކޭޝް އެކައުންޓް، އަދި އެ ގުޅިފައިވާ ލެޖަރ އެކައުންޓް.",
      "detailsPanel": "ތަފްޞީލު",
      "kind": "ބާވަތް",
      "kinds": {
        "bank": "ބޭންކް",
        "bankHint": "ބޭންކުގައި ހުރި ފައިސާ؛ އޭގެ ސްޓޭޓްމަންޓް އިމްޕޯޓްކުރެވެއެވެ.",
        "cash": "ކޭޝް",
        "cashHint": "ފޮށި ނުވަތަ ޕެޓީ ކޭޝް — ޙަޤީޤީ ފައިސާ، ބޭންކެއް ނެތް، ސްޓޭޓްމަންޓެއް ނެތް."
      },
      "codeHint": "ކުރު، ދާއިމީ، އަދި އަލުން ބޭނުމެއް ނުކުރެވޭނެ. ފަހުން ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "glAccount": "ލެޖަރ އެކައުންޓް",
      "glAccountHint": "މި އެކައުންޓުގެ ބާކީ މިހާރުވެސް ހުރި ޕޯސްޓްކުރެވޭ މުދަލުގެ އެކައުންޓް.",
      "glAccountPlaceholder": "މުދަލުގެ އެކައުންޓެއް ޚިޔާރުކުރޭ",
      "currencyHint": "އެކައުންޓް އުފެދުމަށްފަހު ބަދަލެއް ނުކުރެވޭނެ — ޕޯސްޓްކުރެވިފައިވާ ކޮންމެ އަދަދެއް މީގެ މައްޗަށް ބިނާވެއެވެ.",
      "immutable": "ލެޖަރ ގުޅުމާއި ފައިސާ ބަދަލެއް ނުކުރެވޭނެއެވެ: މި އެކައުންޓް މެދުވެރިކޮށް ޕޯސްޓްކުރެވިފައިވާ ކޮންމެ އަދަދެއް އެ ދޭއްޗަށް ބިނާވެއެވެ. ބަދަލުކުރަން ބޭނުންނަމަ އައު އެކައުންޓެއް އިތުރުކޮށް، މި އެކައުންޓް ހުއްޓާލާ.",
      "bankName": "ބޭންކް",
      "branchName": "ބްރާންޗް",
      "accountNumber": "އެކައުންޓް ނަންބަރު",
      "accountNumberHint": "އެންކްރިޕްޓްކޮށް ރައްކާކުރެވެއެވެ. އަލުން ފުރިހަމައަށް ނުދައްކާނެ — ހަމައެކަނި ފަހު އަކުރުތައް، އަދި އޮޑިޓްކުރެވޭ ދެއްކުމެއް މެދުވެރިކޮށެވެ.",
      "accountNumberEditHint": "ރައްކާކުރެވިފައިވާ ނަންބަރު ބަދަލުނުކޮށް ބޭއްވުމަށް ހުސްކޮށް ބާއްވާ.",
      "clearNumber": "ރައްކާކުރެވިފައިވާ އެކައުންޓް ނަންބަރު ނަގާ",
      "iban": "އައިބޭން",
      "swift": "ސްވިފްޓް / ބީއައިސީ",
      "openingBalance": "ފެށޭ ބާކީ",
      "openingBalanceHint": "ފެށޭ ތާރީޚުގައި މި އެކައުންޓުގައި ހުރި ބާކީ، އޭގެ އަމިއްލަ ފައިސާއިން.",
      "openingDate": "ފެށޭ ތާރީޚު",
      "openingInvalid": "އެ ފެށޭ ބާކީއަކީ ޢަދަދެއް ނޫނެވެ.",
      "createdAt": "އިތުރުކުރެވުނު",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓާލެވިފައި",
      "numberPanel": "އެކައުންޓް ނަންބަރު",
      "numberPanelDescription": "އެންކްރިޕްޓްކޮށް ރައްކާކުރެވެއެވެ (އޭއީއެސް-256-ޖީސީއެމް). އެނބުރި އަންނަނީ ފޮރުވިފައިވާ އަދަދު އެކަނި؛ ނަންބަރު ދެއްކުމަކީ ވަކި، އޮޑިޓްކުރެވޭ ޢަމަލެކެވެ.",
      "noNumber": "އެކައުންޓް ނަންބަރެއް ރައްކާކުރެވިފައި ނެތް",
      "revealDenied": "ރައްކާކުރެވިފައިވާ އެކައުންޓް ނަންބަރު ދެއްކުމުގެ ހުއްދަ ތިޔަބޭފުޅާއަށް ނެތެވެ.",
      "railSubtitle": "{currency} އިން ބެލެހެއްޓޭ",
      "railCreated": "އެކައުންޓް އިތުރުކުރެވުނު",
      "backToList": "ހުރިހާ އެކައުންޓްތައް",
      "lifecycleStatus": "ހާލަތު",
      "lifecycle": {
        "draft": "ޑްރާފްޓް",
        "pending_approval": "ފާސްކުރުމަށް ބަދަލުކުރެވިފައި",
        "active": "ހަރަކާތްތެރި",
        "suspended": "ހުއްޓުވިފައި",
        "dormant": "ނިދާފައި",
        "closing": "ބަންދުވަމުންދާ",
        "closed": "ބަންދު"
      },
      "created": "އެކައުންޓް އިތުރުކުރެވިއްޖެ",
      "createdDetail": "{name} ހަރަކާތްތައް ބަލައިގަތުމަށް ތައްޔާރު.",
      "saved": "އެކައުންޓް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{name} އަށް ގެނެވުނު ބަދަލުތައް ރެކޯޑްކުރެވިއްޖެ.",
      "saveFailed": "އެ އެކައުންޓް ރައްކާނުކުރެވުނު"
    },
    "reveal": {
      "action": "ދައްކާ",
      "title": "ރައްކާކުރެވިފައިވާ އެކައުންޓް ނަންބަރު ދައްކާ",
      "subject": "އެކައުންޓް: {name}",
      "consequence": "މިއީ ރައްކާކުރެވިފައިވާ ބޭންކް އެކައުންޓް ނަންބަރެއް ޑިކްރިޕްޓްކުރުމެވެ. ތިރީގައި ދެއްވާ ސަބަބާއެކު، ތިޔަބޭފުޅާގެ ނަމުގައި މި ޢަމަލު އޮޑިޓް ލޮގުގައި ރެކޯޑްކުރެވޭނެއެވެ.",
      "reasonLabel": "މި ބޭނުންވަނީ ކީއްވެ؟",
      "reasonHint": "މި ޖުމްލައަކީ އޮޑިޓް ރެކޯޑެވެ. “ބަލާލަން” ނޫން، “މާރޗް މަހުގެ ސަޕްލަޔަރ ޕޭމަންޓް ފައިލް ތައްޔާރުކުރުމަށް”.",
      "reasonRequired": "ސަބަބެއް ބޭނުންވެއެވެ — އޮޑިޓް ސަފުހާގައި ސަބަބު ބަޔާންކުރަން ޖެހެއެވެ.",
      "masked": "މިހާރު ދައްކާ ގޮތް",
      "confirm": "ދައްކާ އަދި ރެކޯޑްކުރޭ",
      "recorded": "އެއްފަހަރު ދެއްކި އަދި ރެކޯޑްކުރެވިއްޖެ. މި ފޮށި އަލުން ހުޅުވިޔަސް، އައު އަދި ވަކިން ރެކޯޑްކުރެވޭ ދެއްކުމަކާ ނުލައި އަލުން ނުދައްކާނެއެވެ.",
      "autoHide": "{seconds} ސިކުންތު ފަހުން މި ސްކްރީނުން ފޮހެވޭނެއެވެ.",
      "hide": "މިހާރު ފޮރުވާ",
      "failed": "އެ ނަންބަރު ނުދެއްކުނު",
      "stepUpRequired": "މި ޢަމަލަށް ދާދިފަހުގެ ދެވަނަ ސަނަދެއް ބޭނުންވެއެވެ. އޮތެންޓިކޭޓަރ ބޭނުންކޮށްގެން އަލުން ސައިން އިން ވެ، އަލުން މަސައްކަތްކުރައްވާ.",
      "mfaNotEnrolled": "ރައްކާކުރެވިފައިވާ އެކައުންޓް ނަންބަރު ދެއްކުމަށް ދެ ފިޔަވަހީގެ އޮތެންޓިކޭޝަން ބޭނުންވެއެވެ، އަދި އެއީ ތިޔަބޭފުޅާގެ އެކައުންޓުގައި ސެޓަޕްކުރެވިފައި ނުވާ އެއްޗެކެވެ.",
      "mfaLink": "ޕްރޮފައިލްގައި ސެޓަޕްކުރޭ"
    },
    "recurring": {
      "title": "ތަކުރާރުވާ ފައިސާގެ އައިޓަމްތައް",
      "description": "އިންވޮއިސްއެއް ނުއުފެދޭނެ ނަމަވެސް ލަފާކުރެވޭ ފައިސާގެ ހަރަކާތްތައް — ކުލި، އިންސްޓޯލްމަންޓް، ޓެކްސް. ލަފާގައި މި ފުޅާކުރެވެއެވެ.",
      "tableLabel": "ތަކުރާރުވާ ފައިސާގެ އައިޓަމްތައް",
      "loadFailed": "އެ އައިޓަމްތައް ނުލޯޑްވި",
      "emptyTitle": "ތަކުރާރުވާ ފައިސާގެ އައިޓަމެއް ނެތް",
      "emptyDescription": "ޝެޑިއުލްއަކަށް ހިނގާ ނަމަވެސް އެއްވެސް ލިޔުމެއް ނުއުފައްދާ ދެއްކުންތަކާއި ލިބުންތައް އިތުރުކުރޭ، އެއިރުން ލަފާގައި އެ ހިމެނޭނެއެވެ.",
      "emptyAction": "ފުރަތަމަ ތަކުރާރު އައިޓަމް އިތުރުކުރޭ",
      "newTitle": "އައު ތަކުރާރު އައިޓަމް",
      "editTitle": "ތަކުރާރު އައިޓަމް އެޑިޓްކުރޭ",
      "drawerDescription": "ލަފާގައި ފުޅާކުރެވޭ ލަފާކުރެވޭ ފައިސާގެ ހަރަކާތެއް.",
      "postsNothing": "މިއިން ލެޖަރަށް އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުވެއެވެ. މިއިން ބުނެދެނީ ހަމައެކަނި ފައިސާ ލިބޭނެ ނުވަތަ ދާނެ ކަމަށް ލަފާގައި ބަލަން ޖެހޭ ކަމެވެ.",
      "direction": "ދިމާ",
      "directionHint": "އަދަދު ވިޔަފާރިން ނުކުންނަނީތޯ ނުވަތަ ވަންނަނީތޯ.",
      "directions": {
        "inflow": "ވަންނަ ފައިސާ",
        "outflow": "ނުކުންނަ ފައިސާ"
      },
      "amount": "އަދަދު",
      "cadence": "ތަކުރާރުވާ ގޮތް",
      "cadences": {
        "once": "އެއްފަހަރު",
        "weekly": "ހަފްތާއަކު",
        "fortnightly": "ދެ ހަފްތާއަކުން",
        "monthly": "މަހަކު",
        "quarterly": "ތިން މަހަކުން",
        "annually": "އަހަރަކު"
      },
      "nextDate": "ދެން އަންނަ ފަހަރު",
      "nextDateHint": "މި ތާރީޚުން ފެށިގެން ލަފާ ކުރިއަށް ފުޅާކުރެއެވެ.",
      "endDate": "ހުއްޓޭ ތާރީޚު",
      "endDateHint": "ދާއިމީކޮށް ތަކުރާރުވުމަށް ހުސްކޮށް ބާއްވާ.",
      "bankAccount": "ބޭންކް އެކައުންޓް",
      "bankAccountHint": "އަބަދުވެސް އެއް އެކައުންޓަކުން ހިނގާނަމަ، އެ އެކައުންޓް.",
      "anyAccount": "ކޮންމެ އެކައުންޓެއް",
      "notes": "ނޯޓް",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓާލެވިފައި",
      "delete": "ފުހެލާ",
      "deleted": "އައިޓަމް ފުހެލެވިއްޖެ",
      "deletedDetail": "{name} ދެން ލަފާގައި ނުފެންނާނެއެވެ.",
      "deleteFailed": "އެ އައިޓަމް ނުފުހެވުނު",
      "saved": "އައިޓަމް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{name} ރެކޯޑްކުރެވިއްޖެ.",
      "saveFailed": "އެ އައިޓަމް ރައްކާނުކުރެވުނު",
      "kind": "ބާވަތް",
      "reviewKind": "ބާވަތް ރިވިއު ކުރޭ",
      "needsReview": "ރިވިއު ބޭނުން",
      "reviewHint": "މިއީ ލޯނެއް ކަހަލައެވެ — އެ ބާވަތް ޚިޔާރުކުރައްވާ.",
      "kinds": {
        "other": "އެހެނިހެން",
        "rent": "ކުލި",
        "payroll": "މުސާރަ",
        "tax": "ޓެކުސް",
        "utilities": "ޚިދުމަތްތައް",
        "subscription": "ސަބްސްކްރިޕްޝަން",
        "loan": "ލޯނު"
      },
      "loansFromSchedule": "ލޯނުތައް ލިބެނީ ދަރަނީގެ ޝެޑިއުލުން.",
      "toFacilities": "ފެސިލިޓީތައް ބައްލަވާ",
      "useDebtSchedule": "ލޯނުގެ ބަދަލުތައް ރެކަރިންގ އައިޓަމްގެ ގޮތުގައި ލިޔެވެން ނުޖެހޭ. އެއީ ޓްރެޒަރީ ފެސިލިޓީތަކުގެ ދަރަނީގެ ޝެޑިއުލުން ލިބޭ ބައެކެވެ.",
      "toTreasuryForecasts": "މި އައިޓަމްތަކުން ލިބޭ ފައިސާގެ ފޯކާސްޓްތައް"
    },
    "anomaly": {
      "driver": {
        "amountOutlier": "{movement}، {windowDays} ދުވަހުގެ އެވަރެޖް {mean} އާ އަޅާބަލާއިރު (z-ސްކޯ {z}، ހައްދު {threshold}، ކުރީގެ {historyCount} ޙަރަކާތް)",
        "firstCounterparty": "މި ފަރާތަށް ދައްކާ ފުރަތަމަ ފައިސާ: ކުންފުނީގެ ކުރީގެ {priorOutflows} ފައިސާ ދެއްކުމުގެ ތެރެއިން އެއްވެސް ފައިސާއެއް މި ފަރާތަކަށް ނުދޭ ({movement})",
        "unusualTime": "{postedAt} ގައި ޕޯސްޓްކުރެވިފައި، މި އެކައުންޓުގެ އާދައިގެ ވަގުތު {windowFrom} އިން {windowTo} އަށް ބޭރުން ({windowDays} ދުވަހުގެ ތެރޭގައި {historyCount} ޕޯސްޓިންގ)"
      }
    },
    "movementAnomalies": {
      "routeTitle": "ޙަރަކާތުގެ ނާއާދައިގެ ކަންކަން",
      "title": "ޓްރެޜަރީ ޙަރަކާތުގެ ނާއާދައިގެ ކަންކަން",
      "description": "އެކައުންޓު، ފަރާތް، އަދަދު ނުވަތަ ވަގުތަށް ބަލާއިރު ނާއާދައިގެ ބޭންކް ޙަރަކާތްތައް. ކޮންމެ ފައިންޑިންގއެއްގައި އަޅާބެލި ކަމެއް ބުނެދޭ؛ އެއީ ބަޔާންކުރެވޭ ކަމެއްތޯ މީހަކު ރެކޯޑުކުރާނެ.",
      "caption": "ޙަރަކާތުގެ ނާއާދައިގެ ފައިންޑިންގތައް",
      "loadFailed": "ޙަރަކާތުގެ ނާއާދައިގެ ކަންކަން ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އެއްވެސް ފައިންޑިންގއެއް ނެތް",
      "emptyDescription": "މި ފިލްޓަރުތަކާ ގުޅޭ ޙަރަކާތެއް ނެތް. އެންމެ ފަހުގެ ޙަރަކާތްތައް ބެލުމަށް ސްކޭނެއް ހިންގާ.",
      "you": "ތިބާ",
      "userRef": "ޔޫޒަރ #{id}",
      "accountRef": "ބޭންކް އެކައުންޓް #{id}",
      "journalRef": "ޖާރނަލް #{id}",
      "expected": "އާދައިގެ:",
      "recorderUnknown": "ޖޮބަކުން ޕޯސްޓްކޮށްފައި",
      "filters": {
        "legalEntity": "ޤާނޫނީ ފަރާތް",
        "bankAccount": "ބޭންކް އެކައުންޓް #{id} އެކަނި ދައްކަނީ",
        "clearBankAccount": "ހުރިހާ އެކައުންޓެއް ދައްކާ"
      },
      "columns": {
        "kind": "ޑިޓެކްޓަރު",
        "severity": "ބޮޑުމިން",
        "account": "ބޭންކް އެކައުންޓް",
        "movement": "ޙަރަކާތް",
        "amount": "އަދަދު",
        "status": "ހާލަތު",
        "recordedBy": "ރެކޯޑުކުރީ",
        "actions": "ޢަމަލުތައް"
      },
      "kinds": {
        "amount_outlier": "ނާއާދައިގެ އަދަދު",
        "first_counterparty": "ފަރާތަކަށް ދައްކާ ފުރަތަމަ ފައިސާ",
        "unusual_time": "ނާއާދައިގެ ޕޯސްޓިންގ ވަގުތު"
      },
      "severities": {
        "high": "މަތި",
        "medium": "މެދު",
        "low": "ދަށް"
      },
      "statuses": {
        "open": "ހުޅުވިފައި",
        "dispositioned": "ނިންމިފައި"
      },
      "directions": {
        "in": "ލިބުނު ފައިސާ",
        "out": "ދެއްކި ފައިސާ"
      },
      "outcomes": {
        "explained": "ބަޔާންކުރެވިފައި",
        "false_positive": "ގޯސް ފައިންޑިންގ"
      },
      "outcomeHints": {
        "explained": "ޙަރަކާތް ރަނގަޅު؛ ނާއާދައިގެ ވީ ސަބަބު ސަބަބުގައި ބުނެދޭ.",
        "false_positive": "އަޅާބެލުން މި އެކައުންޓަކަށް ނުވަތަ ފަރާތަކަށް ނުގުޅޭ."
      },
      "scan": {
        "action": "ސްކޭން ހިންގާ",
        "actionAll": "ހުރިހާ ޤާނޫނީ ފަރާތަކަށް ސްކޭން ހިންގާ",
        "done": "ސްކޭން ނިމުނީ",
        "doneDetail": "{scanned} ޙަރަކާތް ބެލިއްޖެ، {newFindings} އާ ފައިންޑިންގ، {newHigh} މަތީ ބޮޑުމިން.",
        "failed": "ސްކޭން ނުހިންގުނު",
        "asOf": "މި ތާރީޚަށް",
        "scanned": "ބެލި ޙަރަކާތްތައް",
        "newFindings": "އާ ފައިންޑިންގތައް",
        "newHigh": "އާ މަތީ ބޮޑުމިން"
      },
      "disposition": {
        "action": "ނިންމާ",
        "title": "ފައިންޑިންގ ނިންމާ",
        "description": "މި ޙަރަކާތާ ބެހޭގޮތުން ތިބާ ނިންމި ކަމެއް ރެކޯޑުކުރޭ. އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުވަތަ ރިވާސެއް ނުކުރެވޭ.",
        "outcome": "ނަތީޖާ",
        "reason": "ސަބަބު",
        "reasonHint": "ތިބާގެ އަމިއްލަ ބަހުން: ޙަރަކާތް ނާއާދައިގެ ވީ ސަބަބު، ނުވަތަ އަޅާބެލުން ނުގުޅޭ ސަބަބު.",
        "final": "ނިންމުމަކީ ފައިނަލް ކަމެއް. ގޯސް ޕޯސްޓިންގއެއް ރަނގަޅުކުރަނީ އޭގެ ޖާރނަލް ރިވާސްކޮށް، މިތާނގައެއް ނޫން.",
        "confirm": "ނިންމުން ރެކޯޑުކުރޭ",
        "done": "ނިންމުން ރެކޯޑުކުރެވިއްޖެ",
        "failed": "ނިންމުން ރެކޯޑެއް ނުކުރެވުނު",
        "recorderBlocked": "މި ޙަރަކާތް ރެކޯޑުކުރީ ތިބާ؛ އެހެން މީހަކު ނިންމަން ޖެހޭ"
      },
      "errors": {
        "sod": "މި ޙަރަކާތް ރެކޯޑުކުރީ ތިބާ ކަމުން ފައިންޑިންގ ތިބާއަށް ނުނިންމޭނެ. ބޭންކް އެކައުންޓް އަޕްޑޭޓްކުރުމުގެ ހުއްދަ ލިބިފައިވާ އެހެން މީހަކު ނިންމަން ޖެހޭ.",
        "alreadyDispositioned": "މި ފައިންޑިންގ ކުރިން އެހެން މީހަކު ނިންމައިފި. ލިސްޓު އަލުން ލޯޑުކުރެވިއްޖެ.",
        "stale": "ތިބާ މަސައްކަތްކުރަމުން ދިޔައިރު މި ފައިންޑިންގ ބަދަލުވެއްޖެ. އަލުން ލޯޑުކުރެވިއްޖެ؛ ބަލައިފައި ނިންމުން އަލުން ރެކޯޑުކުރޭ."
      }
    },
    "acct": {
      "allLegalEntities": "ހުރިހާ ޤާނޫނީ ފަރާތްތައް",
      "positionLink": "ޓްރެޜަރީ ޕޮޒިޝަން",
      "reloaded": "ތިޔަ މަސައްކަތްކުރަމުން ދިޔައިރު މި އެކައުންޓަށް އެހެން މީހަކު ބަދަލެއް ގެނެސްފި. އެކައުންޓް އަލުން ލޯޑްކުރެވިއްޖެ — މިހާރުގެ ހާލަތު ބަލާފައި ތިޔަ ބަދަލު އަލުން ގެންނަވާ.",
      "createdDraft": "{name} ޑްރާފްޓެއްގެ ގޮތުގައި ރައްކާކުރެވިއްޖެ. ފައިސާ ބަދަލުކުރެވޭނީ އެ ހުށަހަޅައި، އެހެން މީހުން ވެރިފައިކޮށް އެކްޓިވޭޓްކުރުމަށް ފަހުގައެވެ.",
      "immutable": "ލެޖަރ މެޕިންގ އާއި ފައިސާގެ ބާވަތް ބަދަލެއް ނުކުރެވޭނެ: މި އެކައުންޓުން މިހާތަނަށް ޕޯސްޓްކުރެވިފައިވާ ކޮންމެ އަދަދެއް ބިނާވެފައިވަނީ އެއަށެވެ. އެއިން އެއްޗެއް ބަދަލުކުރަން ބޭނުންނަމަ އައު އެކައުންޓެއް ހަދައި މިއެކައުންޓް ބަންދުކުރައްވާ.",
      "glAccountUniqueHint": "މި އެކައުންޓުގެ ބެލެންސް ހުންނަ ޕޯސްޓްކުރެވޭ އެސެޓް އެކައުންޓް. އެހެން ބޭންކް އެކައުންޓަކަށް ނުވަތަ ވޯލެޓަކަށް އެ ބޭނުން ނުކުރެވޭނެ — އެކްޓިވޭޓްކުރާއިރު މިކަން ޗެކްކުރެވޭނެ.",
      "detailsFrozen": "މި އެކައުންޓް ހުށަހެޅުމާއެކު ބޭންކުގެ މަޢުލޫމާތު ބަދަލުނުކުރެވޭ ގޮތަށް ހަދައިފި. ބޭންކް، ބްރާންޗް، IBAN، SWIFT ނުވަތަ އެކައުންޓް ނަންބަރު ބަދަލުކުރަން، އެމެންޑްމެންޓްސް ޓެބުން އެމެންޑްމެންޓެއް ހުށަހަޅުއްވާ؛ އެ ނިންމާނީ އެހެން މީހެކެވެ.",
      "tabs": {
        "label": "އެކައުންޓުގެ ބައިތައް",
        "details": "ތަފްޞީލު",
        "amendments": "އެމެންޑްމެންޓްތައް",
        "mandate": "މެންޑޭޓް",
        "profile": "ޕްރޮފައިލް"
      },
      "bank": {
        "placeholder": "ރަޖިސްޓަރުން ބޭންކެއް ހޮވާ",
        "add": "ބޭންކެއް އިތުރުކުރޭ",
        "emptyCanAdd": "ބޭންކް ރަޖިސްޓަރު ހުސް. މި އެކައުންޓް ހުރި ބޭންކް އިތުރުކުރައްވާ.",
        "emptyAskAdmin": "ބޭންކް ރަޖިސްޓަރު ހުސް. ބޭންކްތައް ބެލެހެއްޓުމުގެ ހުއްދަ ހުރި މީހަކަށް އެ އިތުރުކުރުމަށް އެދޭ.",
        "name": "ބޭންކުގެ ނަން",
        "bic": "ބީއައިސީ (BIC)",
        "country": "ޤައުމު",
        "countryHint": "ދެ އަކުރުގެ ISO ކޯޑު، މިސާލަކަށް MV.",
        "save": "ރަޖިސްޓަރަށް އިތުރުކުރޭ",
        "unregistered": "މިހާރު ރެކޯޑުކުރެވިފައިވަނީ \"{name}\" ގެ ނަމުގައި، އެއީ ބޭންކް ރަޖިސްޓަރުގައި ނެތް ނަމެކެވެ."
      },
      "liquidity": {
        "title": "ލިކުއިޑިޓީ ކްލެސިފިކޭޝަން",
        "fieldHint": "މި ބެލެންސް މިނިވަންކަމާއެކު ބޭނުންކުރެވޭތޯ. އަންރިސްޓްރިކްޓެޑް ނޫން ކޮންމެ ބެލެންސެއް ލިބެން ހުރި ލިކުއިޑިޓީން ބޭރުކުރެވޭނެ.",
        "unrestricted": "މިނިވަން",
        "restricted": "ހަނިކުރެވިފައި",
        "pledged": "ރަހުނުކުރެވިފައި",
        "escrowed": "އެސްކްރޯގައި",
        "trapped": "ބޭރަށް ނުގެނެވޭ"
      },
      "liquidityHint": {
        "unrestricted": "ކޮންމެ ފައިސާ ދެއްކުމަކަށް ބޭނުންކުރެވޭނެ.",
        "restricted": "ބުނެވިފައިވާ މަޤްޞަދަކަށް ހަމައެކަނި ބޭނުންކުރެވޭނެ.",
        "pledged": "ފެސިލިޓީއެއްގެ ޟަމާނަތެއްގެ ގޮތުގައި ހިފެހެއްޓިފައި.",
        "escrowed": "އެހެން ފަރާތެއްގެ ނަމުގައި ހިފެހެއްޓިފައި.",
        "trapped": "އޭގެ ޤައުމުން ނުވަތަ ފަރާތުން ބޭރަށް ނުގެނެވޭ."
      },
      "fields": {
        "valueDateTolerance": "ވެލިއު-ޑޭޓް ޓޮލެރެންސް",
        "valueDateToleranceHint": "ލައިން ފްލެގްކުރުމުގެ ކުރިން ބޭންކުގެ ވެލިއު ޑޭޓާއި ބުކިންގ ޑޭޓާ ތަފާތުވެދާނެ ދުވަސްތައް (0–30).",
        "dormancyDays": "ޑޯމަންސީ މުއްދަތު",
        "dormancyDaysHint": "އެއްވެސް މޫވްމަންޓެއް ނެތި ކިހާ ދުވަހުން އެކައުންޓް ޑޯމަންޓަށް ބަދަލުވާނެ. 0 އިން ޗެކް ހުއްޓުވޭ (3650 އަށް).",
        "days": "{n} ދުވަސް",
        "dormancyOff": "ޗެކް ނުކުރެވޭ",
        "lastMovement": "އެންމެ ފަހުގެ މޫވްމަންޓް",
        "toleranceInvalid": "0 އިން 30 އާ ދެމެދުގެ ފުރިހަމަ ދުވަސް ޖަހާ.",
        "dormancyInvalid": "0 އިން 3650 އާ ދެމެދުގެ ފުރިހަމަ ދުވަސް ޖަހާ.",
        "statementStaleness": "ސްޓޭޓްމަންޓް ލަސްވާ ހައްދު (ދުވަސް)",
        "statementStalenessHint": "ސްޓޭޓްމަންޓެއްގެ ކްލޯޒިންގ ތާރީޚުން ފެށިގެން ލަސްވެފައިވާ ސްޓޭޓްމަންޓެއްގެ ގޮތުގައި ބެލުމުގެ ކުރިން ދުވަސްތައް. ލަސްވެފައިވާ ސްޓޭޓްމަންޓެއް އިމްޕޯޓްކުރުމަށް ސަބަބެއް ބުނަން ޖެހޭ (1–31، ޑިފޯލްޓް 2).",
        "stalenessInvalid": "1 އާއި 31 އާ ދެމެދުގެ ފުރިހަމަ ދުވަސްތަކުގެ އަދަދެއް ޖައްސަވާ."
      },
      "verification": {
        "title": "ވެރިފިކޭޝަން",
        "unverified": "ވެރިފައިނުކުރެވޭ",
        "verified": "ވެރިފައިކުރެވިފައި",
        "failed": "ފެއިލްވެފައި",
        "channel": "ވެރިފިކޭޝަން ޗެނަލް",
        "verifiedAt": "ވެރިފައިކުރެވުނު"
      },
      "channels": {
        "callback": "ބޭންކަށް އަނބުރާ ގުޅުން",
        "bank_letter": "ބޭންކުގެ ސިޓީ",
        "test_credit": "ޓެސްޓް ކްރެޑިޓް",
        "bank_portal": "ބޭންކް ޕޯޓަލް",
        "in_person": "ޝަޚްޞީގޮތުން"
      },
      "coolingOff": {
        "title": "ކޫލިންގ-އޮފް ނިމޭނީ",
        "running": "ހިނގަމުންދޭ",
        "elapsed": "ނިމިއްޖެ",
        "notStarted": "ފަށާނީ މަޢުލޫމާތު ވެރިފައިކުރުމުންނެވެ"
      },
      "lifecycle": {
        "title": "ލައިފްސައިކަލް",
        "description": "ކޮންމެ ފިޔަވަޅެއް އަޅާނީ ތަފާތު މީހެކެވެ. ސާވަރ ކޮންމެ ފިޔަވަޅެއް ޗެކްކުރޭ.",
        "statusReason": "ސަބަބު",
        "activatedAt": "އެކްޓިވޭޓްކުރެވުނު",
        "closedAt": "ބަންދުކުރެވުނު",
        "blockedLead": "މި އެކައުންޓް އަދި އެކްޓިވޭޓެއް ނުކުރެވޭނެ:",
        "doneDetail": "{code} އަޕްޑޭޓްކުރެވިއްޖެ.",
        "submitted": "އެޕްރޫވަލަށް ހުށަހެޅިއްޖެ",
        "verified": "މަޢުލޫމާތު ވެރިފައިކުރެވިއްޖެ",
        "activated": "އެކައުންޓް އެކްޓިވޭޓްކުރެވިއްޖެ",
        "reactivated": "އެކައުންޓް އަލުން އެކްޓިވޭޓްކުރެވިއްޖެ",
        "suspended": "އެކައުންޓް ހުއްޓާލެވިއްޖެ"
      },
      "checklist": {
        "verified": "މަޢުލޫމާތު ވެރިފައިކުރެވިފައި",
        "coolingOff": "ކޫލިންގ-އޮފް ނިމިފައި",
        "mandate": "އެކްޓިވް، އެޕްރޫވްކުރެވިފައިވާ މެންޑޭޓެއް (އެކްޓިވޭޓްކުރާއިރު ޗެކްކުރެވޭ)",
        "glControl": "ލެޖަރ އެކައުންޓް ހިއްސާނުކުރެވޭ (އެކްޓިވޭޓްކުރާއިރު ޗެކްކުރެވޭ)"
      },
      "actions": {
        "submit": "ހުށަހަޅާ",
        "verify": "މަޢުލޫމާތު ވެރިފައިކުރޭ",
        "activate": "އެކްޓިވޭޓްކުރޭ",
        "reactivate": "އަލުން އެކްޓިވޭޓްކުރޭ",
        "suspend": "ހުއްޓާލާ",
        "close": "ބަންދުކުރުމަށް އެދޭ",
        "authoriseClose": "ބަންދުކުރުމަށް ހުއްދަދޭ"
      },
      "sod": {
        "recorderVerify": "މި އެކައުންޓް ރެކޯޑުކުރީ ތިޔަ ބޭފުޅާ ކަމުން، އޭގެ މަޢުލޫމާތު ވެރިފައިކުރަންވާނީ އެހެން މީހެކެވެ.",
        "activator": "މި އެކައުންޓް ރެކޯޑުކުރީ ނުވަތަ ހުށަހެޅީ ތިޔަ ބޭފުޅާ ކަމުން، އެ އެކްޓިވޭޓްކުރަންވާނީ އެހެން މީހެކެވެ."
      },
      "verify": {
        "title": "ބޭންކުގެ މަޢުލޫމާތު ވެރިފައިކުރުން",
        "description": "މަޢުލޫމާތު ދިން ފަރާތާ ނުގުޅޭ ޗެނަލަކުން މަޢުލޫމާތު ކަށަވަރުކުރައްވާ.",
        "reference": "ރެފަރެންސް",
        "referenceHint": "ހެކި: ކޯލްގެ ރެފަރެންސް، ސިޓީގެ ނަންބަރު، ޓެސްޓް ކްރެޑިޓްގެ މުޢާމަލާތް.",
        "coolingNote": "ވެރިފައިކުރުމާއެކު ކޫލިންގ-އޮފް ފެށޭނެ. އެކައުންޓް އެކްޓިވޭޓްކުރެވޭނީ އެ ނިމުމުންނެވެ.",
        "confirm": "ވެރިފިކޭޝަން ރެކޯޑުކުރޭ"
      },
      "suspend": {
        "title": "އެކައުންޓް ހުއްޓާލުން",
        "description": "ހުއްޓާލެވިފައިވާ އެކައުންޓަކުން އަލުން އެކްޓިވޭޓްކުރަންދެން ޓްރާންސްފަރ ނުކުރެވޭނެ.",
        "reason": "ސަބަބު"
      },
      "blockers": {
        "not_verified": "ބޭންކުގެ މަޢުލޫމާތު ވެރިފައިކުރެވިފައެއް ނުވޭ.",
        "cooling_off": "ކޫލިންގ-އޮފް މުއްދަތު އަދި ނުނިމޭ.",
        "no_active_mandate": "މި އެކައުންޓަށް އެކްޓިވް، އެޕްރޫވްކުރެވިފައިވާ މެންޑޭޓެއް ނެތް.",
        "gl_control_shared": "މިއީ އެހެން ބޭންކް އެކައުންޓަކުން ނުވަތަ ވޯލެޓަކުން ބޭނުންކުރާ ލެޖަރ އެކައުންޓެއް.",
        "non_zero_balance": "އެކައުންޓުގައި އަދިވެސް ބެލެންސް އެބަހުރި.",
        "unreconciled_lines": "ރިކޮންސައިލްނުކުރެވޭ ސްޓޭޓްމަންޓް ލައިންތައް އެބަހުރި.",
        "in_flight_transfers": "ނުނިމި ހުރި ޓްރާންސްފަރތައް އެބަހުރި.",
        "active_mandate": "މެންޑޭޓެއް އަދިވެސް އެކްޓިވް — ފުރަތަމަ އެ ނިންމާ."
      },
      "close": {
        "requested": "ބަންދުކުރުމަށް އެދިއްޖެ",
        "requestedDetail": "{code} މިހާރު ބަންދުކުރަމުންދަނީ. ބަންދުކުރުމަށް ހުއްދަދޭންވާނީ އެހެން މީހެކެވެ.",
        "authorised": "އެކައުންޓް ބަންދުކުރެވިއްޖެ",
        "authorisedDetail": "{code} ބަންދުކުރެވިއްޖެ.",
        "requestTitle": "އެކައުންޓް ބަންދުކުރުމަށް އެދުން",
        "requestDescription": "އެކައުންޓް މިހާރު ބަންދުކުރުމުގެ ހާލަތަށް ބަދަލުވެ ޓްރާންސްފަރތަކުން ބޭރުވާނެ. ބަންދުކުރުމަށް ހުއްދަދޭނީ ދެވަނަ މީހެކެވެ.",
        "authoriseTitle": "އެކައުންޓް ބަންދުކުރުމަށް ހުއްދަދިނުން",
        "authoriseDescription": "އެކައުންޓުގައި ބެލެންސް ހުރިއިރު، ރިކޮންސައިލްނުކުރެވޭ ލައިން ހުރިއިރު، ނުނިމި ހުރި ޓްރާންސްފަރ ހުރިއިރު ނުވަތަ އެކްޓިވް މެންޑޭޓެއް ހުރިއިރު ބަންދެއް ނުކުރެވޭނެ.",
        "consequence": "އެދުމަށް ފަހު، އަލުން އެކްޓިވޭޓްނުކުރާހާ ހިނދަކު މި އެކައުންޓުން ޓްރާންސްފަރ ނުކުރެވޭނެ.",
        "reason": "ބަންދުކުރާ ސަބަބު",
        "reasonHint": "މިއީ އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑުކުރެވޭ ސަބަބު.",
        "requestedAt": "އެދުނު",
        "ownRequest": "މި ބަންދުކުރުމަށް އެދުނީ ތިޔަ ބޭފުޅާ ކަމުން، ހުއްދަދޭންވާނީ އެހެން މީހެކެވެ.",
        "blockedLead": "މި އެކައުންޓް އަދި ބަންދެއް ނުކުރެވޭނެ:",
        "request": "ބަންދުކުރުމަށް އެދޭ",
        "authorise": "ބަންދުކުރުމަށް ހުއްދަދޭ",
        "pending": "ބަންދުކުރުމަށް އެދިފައިވޭ: {reason}"
      },
      "amend": {
        "listTitle": "އެމެންޑްމެންޓްތައް",
        "listDescription": "ހިނގަމުންދާ އެކައުންޓެއްގެ ބޭންކް މަޢުލޫމާތަށް ގެންނަ ބަދަލުތައް. ކޮންމެ ބަދަލެއް ނިންމާނީ ހުށަހެޅި މީހާ ނޫން މީހެކެވެ.",
        "loadFailed": "އެމެންޑްމެންޓްތައް ލޯޑެއް ނުވި",
        "empty": "އަދި އެއްވެސް އެމެންޑްމެންޓެއް ނެތް.",
        "emptyDraft": "އެކައުންޓް ޑްރާފްޓެއް ނުވަތަ އެޕްރޫވަލަށް ހުށަހެޅިފައިވާއިރު، މަޢުލޫމާތު ސީދާ ބަދަލުކުރައްވާ.",
        "requestedAt": "ހުށަހެޅުނު",
        "changes": "ބަދަލުތައް",
        "reason": "ސަބަބު",
        "reasonHint": "މަޢުލޫމާތު ބަދަލުވާ ސަބަބާއި، އެއަށް ހުރި ހެކި.",
        "review": "ރިވިއުކުރޭ",
        "status": {
          "pending": "ނިންމަން ބާކީ",
          "approved": "އެޕްރޫވްކުރެވިފައި",
          "rejected": "ރިޖެކްޓްކުރެވިފައި"
        },
        "proposeTitle": "އެމެންޑްމެންޓެއް ހުށަހެޅުން",
        "proposeDescription": "ބޭންކް މަޢުލޫމާތު ބަދަލުކުރުން. ދެ ކޮލަމް އަޅާކިޔައި ނިންމާނީ އެހެން މީހެކެވެ.",
        "decideTitle": "އެމެންޑްމެންޓް ނިންމުން",
        "decideDescription": "މިހާރު އެކައުންޓުގައި ހުރި ގޮތާއި ބަދަލުވާނެ ގޮތް އަޅާކިޔާ.",
        "consequence": "އެޕްރޫވްކުރުމާއެކު ބަދަލު ހިންގައި، ވެރިފިކޭޝަނާއި ކޫލިންގ-އޮފް އަލުން ފަށައި، އަލުން ވެރިފައިކުރަންދެން އެކައުންޓް ހުއްޓާލެވޭނެ.",
        "diffCaption": "މިހާރުގެ އަދި ހުށަހެޅި ބޭންކް މަޢުލޫމާތު",
        "field": "ފީލްޑް",
        "current": "މިހާރު",
        "proposed": "ހުށަހެޅި",
        "unchanged": "ބަދަލެއް ނެތް",
        "numberPlaceholder": "މިހާރުގެ ނަންބަރު ބާއްވަން ހުސްކޮށް ބަހައްޓާ",
        "noChanges": "އެމެންޑްމެންޓެއް ހުށަހަޅަން މަދުވެގެން އެއް ފީލްޑް ބަދަލުކުރައްވާ.",
        "makerReason": "ދީފައިވާ ސަބަބު",
        "ownProposal": "މި އެމެންޑްމެންޓް ހުށަހެޅީ ތިޔަ ބޭފުޅާ ކަމުން، ނިންމަންވާނީ އެހެން މީހެކެވެ.",
        "decisionReason": "ނިންމުމުގެ ނޯޓު",
        "decisionReasonHint": "ރިޖެކްޓްކުރާނަމަ ލާޒިމު.",
        "rejectReasonRequired": "އެމެންޑްމެންޓް ރިޖެކްޓްކުރާ ސަބަބު ބުނެދީ.",
        "propose": "ހުށަހަޅާ",
        "approve": "އެޕްރޫވްކުރޭ",
        "reject": "ރިޖެކްޓްކުރޭ",
        "proposedToast": "އެމެންޑްމެންޓް ހުށަހެޅިއްޖެ",
        "proposedDetail": "މިހާރު އެ ނިންމަންވާނީ އެހެން މީހެކެވެ.",
        "approved": "އެމެންޑްމެންޓް އެޕްރޫވްކުރެވިއްޖެ — އަލުން ވެރިފައިކުރަންދެން އެކައުންޓް ހުއްޓާލެވިފައި",
        "rejected": "އެމެންޑްމެންޓް ރިޖެކްޓްކުރެވިއްޖެ",
        "requiredHint": "މި އެކައުންޓް ޑްރާފްޓް ނޫން: އޭގެ ބޭންކް މަޢުލޫމާތު ބަދަލުކުރެވޭނީ އެމެންޑްމެންޓްސް ޓެބުގެ އެމެންޑްމެންޓަކުންނެވެ."
      },
      "profile": {
        "title": "ޓްރެޜަރީ ޕްރޮފައިލް",
        "description": "ޓްރެޜަރީން މި އެކައުންޓް ގުނާ ގޮތް: ބާވަތް، ލިމިޓްތައް، ބްލޮކްކުރެވިފައިވާ އަދަދުތައް، ކްލިއަރިންގ އަދި ޕޫލިންގ.",
        "denied": "ޓްރެޜަރީ ސެޓިންގްސް ކިޔުމުގެ ހުއްދަ ތިޔަ ބޭފުޅާގެ ކިބައިގައި ނެތް.",
        "loadFailed": "ޓްރެޜަރީ ޕްރޮފައިލް ލޯޑެއް ނުވި",
        "notAmount": "އެއީ އަދަދެއް ނޫން.",
        "saved": "ޓްރެޜަރީ ޕްރޮފައިލް ރައްކާކުރެވިއްޖެ",
        "inForce": "ހިނގަމުންދާ",
        "minimumAwaiting": "ހުއްދަ ލިބުމަށް މަޑުކުރަނީ",
        "minimumPendingBy": "{by} އެދުނު",
        "minimumPendingNote": "{amount} {currency} އަށް ކުޑަކުރުމަށް ދެވަނަ މީހެއްގެ ހުއްދަ މަޑުކުރަނީ. ހުއްދަ ލިބެންދެން ހިނގަމުންދާ މިނިމަމް ބަދަލެއް ނުވޭ.",
        "minimumReason": "މިނިމަމް ކުޑަކުރާ ސަބަބު",
        "minimumReasonHint": "މިނިމަމް ކުޑަކުރުމުން ބްރީޗެއް ބަލާ ހައްދު ލުއިވާތީ ދެވަނަ މީހެއްގެ ހުއްދަ ބޭނުންވެއެވެ. އިތުރުކުރުން ވަގުތުން ހިނގައެވެ.",
        "savedPending": "ޓްރެޝަރީ ޕްރޮފައިލް ސޭވްކުރެވުނު"
      },
      "mandate": {
        "title": "މެންޑޭޓްތައް",
        "description": "މި އެކައުންޓަށް ސޮއިކުރެވޭނެ މީހުން. މެންޑޭޓްތައް ރެކޯޑުކޮށް އެޕްރޫވްކުރެވެނީ މެންޑޭޓް ރަޖިސްޓަރުގައެވެ.",
        "register": "މެންޑޭޓް ރަޖިސްޓަރު ހުޅުވާ",
        "denied": "މެންޑޭޓްތައް ކިޔުމުގެ ހުއްދަ ތިޔަ ބޭފުޅާގެ ކިބައިގައި ނެތް.",
        "loadFailed": "މެންޑޭޓްތައް ލޯޑެއް ނުވި",
        "empty": "މި އެކައުންޓަށް އެއްވެސް މެންޑޭޓެއް ރެކޯޑުކުރެވިފައެއް ނުވޭ. އެކްޓިވޭޓްކުރުމުގެ ކުރިން އެކްޓިވް، އެޕްރޫވްކުރެވިފައިވާ މެންޑޭޓެއް ބޭނުންވޭ.",
        "rule": "ސޮއިކުރުމުގެ ޤަވާޢިދު",
        "band": "އަދަދުގެ ބޭންޑް",
        "window": "ހިނގާ މުއްދަތު",
        "signatories": "މިހާރުގެ ސޮއިކުރާ ފަރާތްތައް",
        "noCeiling": "ހަދެއް ނެތް",
        "approval": {
          "pending_approval": "އެޕްރޫވަލަށް ބާކީ",
          "approved": "އެޕްރޫވްކުރެވިފައި"
        }
      }
    },
    "queue": {
      "transit_break_item": "ޓްރާންސްފަރެއް ހުއްދަ މުއްދަތަށްވުރެ ދިގު ވަގުތެއް ޓްރާންސިޓްގައި ހުރި.",
      "bank_limit_breach_item": "މި ބޭންކުގައި ހުރި ފައިސާ އޭގެ ކައުންޓަރޕާޓީ ހައްދަށް ވުރެ ގިނައެވެ."
    }
  },
  "bankrec": {
    "filtersTitle": "ފިލްޓަރތައް",
    "routeTitles": {
      "sessions": "ބޭންކް ރިކޮންސިލިއޭޝަން",
      "session": "ރިކޮންސިލިއޭޝަން",
      "imports": "ބޭންކް ސްޓޭޓްމަންޓްތައް",
      "import": "ބޭންކް ސްޓޭޓްމަންޓް",
      "profiles": "ސްޓޭޓްމަންޓް މެޕިންގ ޕްރޮފައިލްތައް",
      "importLines": "ސްޓޭޓްމަންޓުގެ ލައިންތައް"
    },
    "nav": {
      "label": "ބޭންކް ރިކޮންސިލިއޭޝަން ބައިތައް",
      "sessions": "ރިކޮންސިލިއޭޝަންތައް",
      "imports": "ސްޓޭޓްމަންޓްތައް",
      "profiles": "މެޕިންގ ޕްރޮފައިލްތައް"
    },
    "accountTypes": {
      "ASSET": "މުދާ",
      "LIABILITY": "ދަރަނި",
      "EQUITY": "އިކުއިޓީ",
      "INCOME": "އާމްދަނީ",
      "EXPENSE": "ޚަރަދު"
    },
    "sessions": {
      "title": "ބޭންކް ރިކޮންސިލިއޭޝަން",
      "description": "ބޭންކް އެކައުންޓަކަށް ހިންގި ކޮންމެ ރިކޮންސިލިއޭޝަނެއް — މިހާރު ހުޅުވިފައިވާ އެކަކާއި، ބާކީ ދިމާވެގެން ބަންދުކުރެވުނު ތަކެތި.",
      "tableLabel": "ރިކޮންސިލިއޭޝަން ސެޝަންތައް",
      "loadFailed": "އެ ރިކޮންސިލިއޭޝަންތައް ނުލިބުނު",
      "emptyTitle": "އަދި ރިކޮންސިލިއޭޝަނެއް ނެތް",
      "emptyDescription": "ފުރަތަމަ ބޭންކް ސްޓޭޓްމަންޓެއް އިމްޕޯޓްކުރައްވާ، އެއަށްފަހު އެ ދުވަސްތަކަށް ރިކޮންސިލިއޭޝަނެއް ހުޅުވާ. ސްޓޭޓްމަންޓާއި ލެޖަރ ދިމާކުރެވެނީ ސެޝަނުގެ ތެރޭގައި."
    },
    "session": {
      "headerTitle": "{account} ރިކޮންސައިލްކުރުން",
      "headerDescription": "ބޭންކްގެ ސްޓޭޓްމަންޓާއި ލެޖަރ، {from} އިން {to} އަށް.",
      "railTitle": "ރިކޮންސިލިއޭޝަން {from} އިން {to} އަށް",
      "loadFailed": "އެ ރިކޮންސިލިއޭޝަން ނުލިބުނު",
      "backToList": "ހުރިހާ ރިކޮންސިލިއޭޝަންތައް",
      "accountById": "ބޭންކް އެކައުންޓް #{id}",
      "statusOpen": "ހުޅުވިފައި",
      "statusClosed": "ބަންދުކުރެވިފައި",
      "opened": "ހުޅުވި ވަގުތު",
      "closed": "ބަންދުކުރި ވަގުތު",
      "reopened": "އަލުން ހުޅުވި ވަގުތު",
      "standingTitle": "މިހާރު އޮތްގޮތް",
      "closedTitle": "ބަންދުކުރެވުނު އަދަދުތައް",
      "openingStatement": "ފެށޭ ބާކީ (ސްޓޭޓްމަންޓް)",
      "expectedClosing": "ސްޓޭޓްމަންޓުން ދައްކާ ނިމޭ ބާކީ",
      "linesMatched": "ގުޅުވުނު ސްޓޭޓްމަންޓް ސަޠުރުތައް",
      "unmatchedStatement": "ސްޓޭޓްމަންޓުގައި ނުގުޅުވާ",
      "unmatchedLedger": "ލެޖަރުގައި ނުގުޅުވާ",
      "unexplained": "ބަޔާންނުކުރެވޭ ތަފާތު",
      "balancedHelp": "ދެފަރާތުގައިވެސް ބާކީ އެއްޗެއް ނެތް. މި މުއްދަތުގައި ސްޓޭޓްމަންޓާއި ލެޖަރ ދައްކަނީ އެއް ފައިސާއެއް.",
      "unbalancedHelp": "{statementCount} ސްޓޭޓްމަންޓް ސަޠުރާއި {ledgerCount} ލެޖަރ ސަޠުރު އަދިވެސް ނުގުޅުވާ. މަތީގައިވާ ތަފާތަކީ އެތަކެތީގެ ޖުމުލަ.",
      "newTitle": "ރިކޮންސިލިއޭޝަނެއް ހުޅުވާ",
      "newDescription": "އެއް ބޭންކް އެކައުންޓް، އެއް މުއްދަތު. އެއް ފަހަރާ އެކައުންޓަކަށް ހުޅުވިފައި ބެހެއްޓޭނީ އެއް ރިކޮންސިލިއޭޝަން.",
      "bankAccount": "ބޭންކް އެކައުންޓް",
      "bankAccountHint": "ދައްކަނީ ހަމައެކަނި ބޭންކް އެކައުންޓްތައް: ކޭޝް ފްލޯޓަކަށް ރިކޮންސައިލްކުރާނެ ސްޓޭޓްމަންޓެއް ނޯވޭ.",
      "bankAccountPlaceholder": "ބޭންކް އެކައުންޓެއް ޚިޔާރުކުރޭ",
      "fromDate": "އިން",
      "fromDateHint": "ސްޓޭޓްމަންޓް ފެށޭ ފުރަތަމަ ދުވަސް.",
      "toDate": "އަށް",
      "toDateHint": "ސްޓޭޓްމަންޓް ނިމޭ ފަހު ދުވަސް. ދެ ބާކީވެސް ބަލަނީ މި ތާރީޚަށް.",
      "openingBalance": "ސްޓޭޓްމަންޓުގައިވާ ފެށޭ ބާކީ",
      "openingBalanceIn": "ސްޓޭޓްމަންޓުގައިވާ ފެށޭ ބާކީ ({currency})",
      "openingBalanceHint": "ފުރަތަމަ ދުވަހު އެކައުންޓުގައި ހުރި ކަމަށް ބޭންކުން ބުނާ އަދަދު — ލެޖަރުން ބުނާ އަދަދެއް ނޫން. ތަފާތުވާ ސަބަބު ހޯދުމަކީ މި މަސައްކަތުގެ ބޭނުން.",
      "openingNotANumber": "އެ ފެށޭ ބާކީއަކީ ނަންބަރެއް ނޫން.",
      "note": "ނޯޓް",
      "create": "ރިކޮންސިލިއޭޝަން ހުޅުވާ",
      "created": "ރިކޮންސިލިއޭޝަން ހުޅުވިއްޖެ",
      "createdDetail": "ސްޓޭޓްމަންޓް ސަޠުރުތައް ލެޖަރާ ގުޅުވުމަށްފަހު ބަންދުކުރައްވާ.",
      "createFailed": "އެ ރިކޮންސިލިއޭޝަން ނުހުޅުވުނު",
      "alreadyOpen": "މި ބޭންކް އެކައުންޓަށް މިހާރުވެސް ރިކޮންސިލިއޭޝަނެއް ހުޅުވިފައިވޭ. ފުރަތަމަ އެ ނިންމަވާ ނުވަތަ އަލުން ހުޅުއްވާ.",
      "columns": {
        "period": "މުއްދަތު",
        "account": "ބޭންކް އެކައުންޓް",
        "opening": "ފެށޭ",
        "closingStatement": "ނިމޭ (ސްޓޭޓްމަންޓް)",
        "closingLedger": "ނިމޭ (ލެޖަރ)"
      }
    },
    "workspace": {
      "statementTitle": "ބޭންކުން ބުނި ގޮތް",
      "statementDescription": "އިމްޕޯޓްކުރި ގޮތަށް ހުރި ސަޠުރުތައް. މިތާ އެއްވެސް އެއްޗެއް އުނިއިތުރެއް ނުކުރެވޭނެ.",
      "ledgerTitle": "ފޮތުގައި އޮތް ގޮތް",
      "ledgerDescription": "މި މުއްދަތުގައި، މި ބޭންކް އެކައުންޓުގެ ލެޖަރ އެކައުންޓަށްވާ ޖާނަލް ސަޠުރުތައް.",
      "linesFailed": "ސްޓޭޓްމަންޓް ސަޠުރުތައް ނުލިބުނު",
      "ledgerFailed": "ލެޖަރ ސަޠުރުތައް ނުލިބުނު",
      "showMatched": "ގުޅުވިފައިވާ ސަޠުރުތައްވެސް ދައްކާ",
      "toImports": "މި އެކައުންޓަށް އިމްޕޯޓްކުރި ސްޓޭޓްމަންޓްތައް",
      "matchSelected": "ޚިޔާރުކުރި ދެ ސަޠުރު ގުޅުވާ",
      "manualHelp": "ބަލައިގަންނަން ރަނގަޅު ހުށަހެޅުމެއް ނެތްތޯ؟ ދެފަރާތުން ސަޠުރެއް ޚިޔާރުކުރައްވާ އަމިއްލައަށް ގުޅުވާ — އެ ރެކޯޑްވާނީ އަމިއްލައަށް ގުޅުވި ގޮތެއްގެ ގޮތުގައި.",
      "noStatementLines": "ސްޓޭޓްމަންޓުގައި ބާކީ އެއްޗެއް ނެތް",
      "noStatementLinesHelp": "މި މުއްދަތުގައި ބޭންކުން ދެއްކި ކޮންމެ ސަޠުރެއް ގުޅުވިފައި ނުވަތަ ބަޔާންކުރެވިފައި.",
      "noLedgerLines": "ލެޖަރުގައި ބާކީ އެއްޗެއް ނެތް",
      "noLedgerLinesHelp": "މި މުއްދަތުގައި މި އެކައުންޓަށްވާ ކޮންމެ ޕޯސްޓިންގއެއް ސްޓޭޓްމަންޓް ސަޠުރަކާ ގުޅުވިފައި."
    },
    "line": {
      "valueDate": "ފައިސާ ބަދަލުވި ތާރީޚް",
      "reference": "ރެފަރެންސް",
      "narrative": "ތަފްޞީލު",
      "amount": "އަދަދު",
      "matched": "ގުޅުވިފައި",
      "unmatched": "ނުގުޅުވާ",
      "noDescription": "މި ސަޠުރުގައި ތަފްޞީލެއް ނެތް",
      "noReference": "ރެފަރެންސެއް ނެތް",
      "entry": "އެންޓްރީ #{id}"
    },
    "suggestions": {
      "title": "މިއީ ގުޅޭ އެއްޗަކަށް ވެދާނެ ސަބަބު",
      "description": "އިންޖީނުން ތަރުތީބުކޮށްފައި. ތިޔަ ބޭފުޅާ ބުނަންދެން އެއްވެސް އެއްޗެއް ނުހިނގާނެ.",
      "pickTitle": "ސްޓޭޓްމަންޓް ސަޠުރެއް ޚިޔާރުކުރައްވާ",
      "pickDescription": "ވާތްފަރާތުން ސަޠުރެއް ޚިޔާރުކުރެއްވުމުން، އެއާ ގުޅޭ ޕޯސްޓިންގ ހޯދާނެ — ފުރަތަމަ ރެފަރެންސުން، ދެން އަދަދާއި ތާރީޚުން، ދެން ފަރާތުގެ ނަމުން.",
      "deniedTitle": "ހުށަހެޅުންތައް ތިޔަ ބޭފުޅާއަށް ނުފެންނާނެ",
      "deniedDescription": "ދެފަރާތުން ސަޠުރެއް ޚިޔާރުކުރައްވައިގެން އަމިއްލައަށް ގުޅުވިދާނެ.",
      "loadFailed": "ހުށަހެޅުންތައް ނުލިބުނު",
      "emptyTitle": "މި ސަޠުރާ ގުޅޭ އެއްޗެއް ލެޖަރުގައި ނެތް",
      "emptyDescription": "މި އެކައުންޓުގައި އެ އަދަދުގެ ޕޯސްޓިންގއެއް ނެތް. ލިޔުމެއް ނެތި ބޭންކުން ފައިސާ ބަދަލުކުރި ނަމަ — ޗާޖެއް، އިންޓަރެސްޓެއް — ލެޖަރުގައި ނެތް އެންޓްރީ ޕޯސްޓްކުރައްވާ.",
      "neverAutomatic": "ތިރީގައިވާ އެއްވެސް އެއްޗެއް އަދި ނުހިންގާ. ގުޅުވުމަކުން ދެ ސަޠުރުވެސް ހިފަހައްޓާތީ، އެކަން ކުރެވެނީ ހަމައެކަނި ބަޓަނަކަށް ފިއްތުމުން.",
      "rank": "ތަރުތީބުކުރި ސްކޯރ {percent}%",
      "confirm": "މި ގުޅުވުން ކަށަވަރުކުރޭ"
    },
    "tiers": {
      "exact_reference": "އެއް ރެފަރެންސް",
      "exact_referenceWhy": "ބޭންކާއި ލެޖަރުގައި އެއް ރެފަރެންސެއް، އަދި އަދަދު ލާރިއަކާ ހަމައަށް އެއްވަރު. މިއީ އިންޖީނުން ކުރާ އެންމެ ވަރުގަދަ ދަޢުވާ.",
      "amount_date": "އަދަދާއި ތާރީޚް",
      "amount_dateWhy": "އަދަދު ލާރިއަކާ ހަމައަށް އެއްވަރު، އަދި ތާރީޚުގެ ފަރަގަކީ {days} ދުވަސް. މީގެ އިތުރުން ގުޅުމެއް ނެތް — ދާދި އެއްގޮތް ދެވަނަ ފައިސާއެއް ނޫންކަން ޔަޤީންކުރައްވާ. | އަދަދު ލާރިއަކާ ހަމައަށް އެއްވަރު، އަދި ތާރީޚުގެ ފަރަގަކީ {days} ދުވަސް. މީގެ އިތުރުން ގުޅުމެއް ނެތް — ދާދި އެއްގޮތް ދެވަނަ ފައިސާއެއް ނޫންކަން ޔަޤީންކުރައްވާ.",
      "fuzzy_name": "އެއްގޮތް ނަން",
      "fuzzy_nameWhy": "އަދަދު އެއްވަރު އަދި ފަރާތުގެ ނަންތައް އެއްގޮތްކަން ދޭހަވޭ، ތާރީޚުގެ ފަރަގަކީ {days} ދުވަސް. ނަމަކީ މިތާ އެންމެ ބަލިކަށި ހެކި — ބަލައިގަތުމުގެ ކުރިން ތަފްޞީލު ކިޔުއްވާ. | އަދަދު އެއްވަރު އަދި ފަރާތުގެ ނަންތައް އެއްގޮތްކަން ދޭހަވޭ، ތާރީޚުގެ ފަރަގަކީ {days} ދުވަސް. ނަމަކީ މިތާ އެންމެ ބަލިކަށި ހެކި — ބަލައިގަތުމުގެ ކުރިން ތަފްޞީލު ކިޔުއްވާ.",
      "manual": "އަމިއްލައަށް ޚިޔާރުކުރި",
      "manualWhy": "މި ދެ ސަޠުރު ގުޅުވީ މީހަކު އަމިއްލައަށް.",
      "created": "މި ސަޠުރުން ޕޯސްޓްކުރި",
      "createdWhy": "މިއަށް ލެޖަރުގައި އެންޓްރީއެއް ނެތުމުން، ސްޓޭޓްމަންޓް ސަޠުރުން އެންޓްރީއެއް ޕޯސްޓްކުރެވުނު."
    },
    "match": {
      "matching": "ގުޅުވަނީ",
      "matched": "ގުޅުވިއްޖެ",
      "matchedDetail": "ސްޓޭޓްމަންޓް ސަޠުރާއި ޕޯސްޓިންގ މިހާރު ގުޅިފައި، އަދި ދެއެތި މި ރިކޮންސިލިއޭޝަނަށް ހިފެހެއްޓިފައި.",
      "failed": "އެ ގުޅުވުން ނުކުރެވުނު",
      "alreadyMatched": "އެ ސަޠުރު މިހާރުވެސް ގުޅުވިފައި",
      "alreadyMatchedDetail": "އެހެން މީހަކު ކުރިން ގުޅުވައިފި، ނުވަތަ މި ސްކްރީނުގައި ހުރީ ބާ މަޢުލޫމާތު. މިހާރު އާކުރެވިއްޖެ.",
      "release": "ދޫކޮށްލާ",
      "releasing": "ދޫކުރަނީ",
      "released": "ގުޅުވުން ދޫކުރެވިއްޖެ",
      "releasedDetail": "ދެ ސަޠުރުވެސް އަނެއްކާ ބާކީގައި.",
      "releaseFailed": "އެ ގުޅުވުން ދޫނުކުރެވުނު",
      "recentTitle": "މިފަހަރު ގުޅުވި ތަކެތި",
      "recentDescription": "ގޯސްކޮށް ފިއްތުނު ނަމަ މިތަނުން ދޫކޮށްލެވިދާނެ. ކުރީގެ ފަހަރެއްގައި ގުޅުވި އެއްޗެއް ދޫކުރަން، ރިކޮންސިލިއޭޝަން އަލުން ހުޅުއްވަން ޖެހޭނެ — އެކަން އޮޑިޓް ލޮގްގައި ރެކޯޑްވާނެ.",
      "recentLabel": "{date} ގުޅުވުނީ {entry} އާ"
    },
    "missing": {
      "action": "ނެތް އެންޓްރީ ޕޯސްޓްކުރޭ",
      "title": "ލެޖަރުގައި ނެތް އެންޓްރީ ޕޯސްޓްކުރުން",
      "description": "ލިޔުމެއް ނެތި ބޭންކުން ބަދަލުކުރި ފައިސާއަށް — ޗާޖެއް، އިންޓަރެސްޓެއް، ޗެކް އަނބުރާލި ފީއެއް.",
      "postsForReal": "މިއިން މިހާރު ލެޖަރަށް ޙަޤީޤީ ޖާނަލެއް ޕޯސްޓްވެ، މި ސްޓޭޓްމަންޓް ސަޠުރު އެއާ ގުޅުވޭނެ. މިއީ ރިކޮންސިލިއޭޝަން އެޑްޖަސްޓްމަންޓެއް ނޫން: މިއީ ކުރިންވެސް ހުންނަންވީ އެންޓްރީ، އަދި އެ އަނބުރާލެވޭނީ ކޮންމެ ޕޯސްޓްކުރި ޖާނަލެއްހެން ރިވާސްކޮށްގެން.",
      "offsetAccount": "އަނެއް ފަރާތް ޕޯސްޓްކުރާނީ",
      "offsetHint": "މިއީ ނިސްބަތްވާ ޚަރަދު، އާމްދަނީ ނުވަތަ ދަރަނީގެ އެކައުންޓް. ބޭންކްގެ އެކައުންޓަށް ދާނީ އަނެއް ފަރާތް.",
      "offsetPlaceholder": "އެކައުންޓެއް ޚިޔާރުކުރޭ",
      "offsetRequired": "މި އެންޓްރީގެ އަނެއް ފަރާތް ނިސްބަތްވާ އެކައުންޓް ޚިޔާރުކުރައްވާ.",
      "needsAccountRead": "ޗާޓް އޮފް އެކައުންޓްސް ބެލުމުގެ ހުއްދަ ނެތުމުން، އަނެއް ފަރާތް ޕޯސްޓްކުރާނެ އެކައުންޓެއް ނުދެއްކޭނެ. އެ ހުއްދައަށް އެދިވަޑައިގަންނަވާ.",
      "previewTitle": "ޕޯސްޓްވާނެ ގޮތް",
      "account": "އެކައުންޓް",
      "debit": "ޑެބިޓް",
      "credit": "ކްރެޑިޓް",
      "bankAccount": "މި ބޭންކް އެކައުންޓުގެ ލެޖަރ އެކައުންޓް",
      "confirm": "ޕޯސްޓްކޮށް ގުޅުވާ",
      "posting": "ޕޯސްޓްކުރަނީ",
      "posted": "އެންޓްރީ ޕޯސްޓްވެއްޖެ",
      "postedDetail": "ޖާނަލް ލެޖަރުގައި، އަދި މި ސްޓޭޓްމަންޓް ސަޠުރު އެއާ ގުޅުވިއްޖެ.",
      "failed": "އެ އެންޓްރީ ޕޯސްޓެއް ނުކުރެވުނު"
    },
    "close": {
      "action": "ރިކޮންސިލިއޭޝަން ބަންދުކުރޭ",
      "title": "މި ރިކޮންސިލިއޭޝަން ބަންދުކުރުން",
      "description": "ދެ ބާކީވެސް ބަލަނީ {date} އަށް.",
      "rule": "ރިކޮންސިލިއޭޝަން ބަންދުވާނީ ސްޓޭޓްމަންޓުގެ ނިމޭ ބާކީއާއި މި ބޭންކް އެކައުންޓުގެ ލެޖަރ ބާކީ ލާރިއަކާ ހަމައަށް ދިމާވުމުން އެކަނި. ދިމާނުވާނަމަ އެއްވެސް އެއްޗެއް ބަންދެއް ނުވާނެ، އަދި ތަފާތު ތިރީގައި ދައްކާނެ.",
      "closingBalanceLabel": "ސްޓޭޓްމަންޓުގައިވާ ނިމޭ ބާކީ",
      "closingBalanceHint": "ސްޓޭޓްމަންޓުގައި ޗާޕުކޮށްފައިވާ އަދަދު، ލެޖަރުގައި ހުންނާނެކަމަށް އުއްމީދުކުރާ އަދަދެއް ނޫން.",
      "suggestedFrom": "މި މުއްދަތަށް އިމްޕޯޓްކުރި ސަޠުރުތަކުގެ ޖުމުލައަކީ",
      "notANumber": "އެ ނިމޭ ބާކީއަކީ ނަންބަރެއް ނޫން.",
      "confirm": "ރިކޮންސިލިއޭޝަން ބަންދުކުރޭ",
      "checking": "ބާކީތައް ބަލަނީ",
      "closed": "ރިކޮންސިލިއޭޝަން ބަންދުވެއްޖެ",
      "closedDetail": "ސްޓޭޓްމަންޓާއި ލެޖަރ ލާރިއަކާ ހަމައަށް ދިމާވި.",
      "failed": "އެ ރިކޮންސިލިއޭޝަން ބަންދެއް ނުކުރެވުނު",
      "statementSays": "ސްޓޭޓްމަންޓް {date} ގައި",
      "ledgerSays": "ލެޖަރ {date} ގައި",
      "difference": "ތަފާތު",
      "stillOpen": "{statementCount} ސްޓޭޓްމަންޓް ސަޠުރާއި {ledgerCount} ލެޖަރ ސަޠުރު އަދިވެސް ނުގުޅުވާ.",
      "showUnmatched": "ނުގުޅުވާ ތަކެތި ދައްކާ",
      "certifyFirst": "ބަންދުކުރުމުގެ ކުރިން ސެޓްފައިކުރޭ",
      "needsCertificate": "މި ރިކަންސިލިއޭޝަން އަދި ސެޓްފައިއެއް ނުކުރެވޭ. ސެޝަނެއް ބަންދުކުރެވެނީ މެޗްކުރި މީހާ ނޫން މީހަކު ސެޓްފައިކުރުމަށްފަހުގައެވެ.",
      "requestReopen": "އަލުން ހުޅުވުމަށް އެދޭ"
    },
    "imports": {
      "title": "ބޭންކް ސްޓޭޓްމަންޓްތައް",
      "description": "ބޭންކް އެކައުންޓަކަށް އިމްޕޯޓްކުރި ސްޓޭޓްމަންޓްތައް. ސްޓޭޓްމަންޓެއް އިމްޕޯޓްވާނީ ފުރިހަމައަށް، ނުވަތަ އެއްވެސް ވަރަކަށް ނޫން.",
      "uploadTitle": "ސްޓޭޓްމަންޓެއް އިމްޕޯޓްކުރޭ",
      "uploadDescription": "ރައްކާކުރެވިފައިވާ މެޕިންގ ޕްރޮފައިލަކުން CSV، ނުވަތަ MT940.",
      "wholeFileRule": "މި އިމްޕޯޓަރަށް އެއްގޮތަކަށްވެސް ނުކިޔޭ ފައިލެއް ބާޠިލްކުރެވި، އެއްވެސް އެއްޗެއް ނުލިޔެވޭނެ — ބާޠިލްކުރި ސަބަބުގައި ސަޠުރު ނަންބަރާއި ގޯސް ބަޔާންކުރެވޭނެ. ކިޔޭ ނަމަވެސް ޗެކެއް ފާސްނުވާ ފައިލެއް ރައްކާކުރެވި، މުޅި ފައިލް ކުއަރަންޓީންގައި ހިފެހެއްޓޭނެ: އޯޕަނިންގ ބެލެންސް ކުރީގެ ސްޓޭޓްމަންޓާ ގުޅިފައި ނުވުން ނުވަތަ ތާރީޚުތައް ރެކޯޑުގައި ހުރި ސްޓޭޓްމަންޓަކާ އެއްގޮތްވުން، ސްޓޭޓްމަންޓް ނަންބަރެއް ދަތިވުން، ހަމަ ފައިލް ކުރިން އިމްޕޯޓްކުރެވިފައިވުން، ފައިސާ އެކައުންޓުގެ ފައިސާ ނޫންވުން، ސަޠުރުތަކުގެ ޖުމްލަ ހަމަނުވުން، އެކައުންޓް ނަންބަރު މި އެކައުންޓުގެ ނޫންވުން، ނުވަތަ ޗެކްސަމް އެއްގޮތް ނުވުން. ދެވަނަ މީހަކު ރިލީސްކުރަންދެން ކުއަރަންޓީންކުރި ސްޓޭޓްމަންޓެއްގެ އެއްވެސް ސަޠުރެއް މެޗެއް ނުވަތަ ރިކޮންސައިލެއް ނުކުރެވޭނެ.",
      "accountHint": "މި ސްޓޭޓްމަންޓް ނިސްބަތްވާ އެކައުންޓް. ސަޠުރުތައް ދެފަހަރު ނުވަނީ އެކައުންޓަކަށް ބަލައިގެން.",
      "format": "ފޯމެޓް",
      "formats": {
        "csv": "CSV",
        "csvHint": "މި ބޭންކަށް ރައްކާކުރެވިފައިވާ މެޕިންގ ޕްރޮފައިލެއް ބޭނުންވޭ",
        "mt940": "MT940",
        "mt940Hint": "އަމިއްލަ އޮނިގަނޑާއި ބާކީތައް ހިމެނޭ",
        "camt053": "CAMT.053"
      },
      "profile": "މެޕިންގ ޕްރޮފައިލް",
      "profileHint": "މި ބޭންކްގެ ކޮލަމްތައް ތާރީޚް، އަދަދު އަދި ރެފަރެންސަށް ގުޅުވާ ގޮތް.",
      "profilePlaceholder": "މެޕިންގ ޕްރޮފައިލެއް ޚިޔާރުކުރޭ",
      "noProfiles": "މި ކުންފުންޏަށް އަދި މެޕިންގ ޕްރޮފައިލެއް ނެތް، އަދި އެއާ ނުލައި CSV އެއް ނުކިޔޭނެ.",
      "createProfile": "އެއް ހަދާ",
      "openingBalance": "ފެށޭ ބާކީ",
      "openingBalanceHint": "ހަމައެކަނި CSV އަށް، އަދި ފައިލުގައި ނެތްނަމަ. MT940 ގައި އަމިއްލައަށް ހިމެނޭ.",
      "file": "ސްޓޭޓްމަންޓް ފައިލް",
      "fileHint": "ގިނަވެގެން 25 MB. UTF-8 ޓެކްސްޓް.",
      "import": "ސްޓޭޓްމަންޓް އިމްޕޯޓްކުރޭ",
      "importing": "އިމްޕޯޓްކުރަނީ",
      "imported": "ސްޓޭޓްމަންޓް އިމްޕޯޓްވެއްޖެ",
      "importedDetail": "އައު {imported} ސަޠުރު، {duplicates} ކުރިންވެސް ހުރި.",
      "refused": "ސްޓޭޓްމަންޓް ބާޠިލްކުރެވުނު",
      "refusedAt": "ބާޠިލްކުރެވުނީ {format} ސަޠުރު {line} ގައި",
      "refusedGeneric": "ސްޓޭޓްމަންޓް އިމްޕޯޓެއް ނުކުރެވުނު.",
      "alreadyImported": "މި ސްޓޭޓްމަންޓް ކުރިންވެސް އިމްޕޯޓްކުރެވިފައި",
      "nothingWritten": "އެއްވެސް އެއްޗެއް ނުލިޔެވޭ. ފައިލް ނުވަތަ މެޕިންގ ޕްރޮފައިލް ރަނގަޅުކުރުމަށްފަހު އަލުން އިމްޕޯޓްކުރައްވާ.",
      "outcome": {
        "new": "ހުރިހާ ސަޠުރެއްވެސް އައު",
        "partial": "ބައެއް ސަޠުރުތައް ކުރިންވެސް ހުރި",
        "none": "މި ފައިލުގައި އައު އެއްޗެއް ނެތް"
      },
      "outcomeCounts": "އައު {imported}، ކުރިން އެނގޭ {duplicates}، ފައިލުގައި {total}",
      "viewLines": "އިމްޕޯޓްވި ސަޠުރުތައް ބައްލަވާ",
      "historyTitle": "އިމްޕޯޓްކުރެވުނު ސްޓޭޓްމަންޓްތައް",
      "loadFailed": "އެ ސްޓޭޓްމަންޓްތައް ނުލިބުނު",
      "emptyTitle": "އަދި ސްޓޭޓްމަންޓެއް އިމްޕޯޓްކޮށްފައި ނެތް",
      "emptyDescription": "އެކައުންޓަކަށް ބޭންކްގެ ސްޓޭޓްމަންޓް ފައިލް އިމްޕޯޓްކުރައްވާ. އެއެއް ނެތްހާ ހިނދަކު ލެޖަރާ ދިމާކުރާނެ އެއްޗެއް ނޯންނާނެ.",
      "columns": {
        "file": "ފައިލް",
        "period": "މުއްދަތު",
        "opening": "ފެށޭ",
        "closing": "ނިމޭ",
        "lines": "ސަޠުރުތައް",
        "format": "ފޯމެޓް",
        "status": "ހާލަތު",
        "kind": "ބާވަތް",
        "integrity": "އިންޓެގްރިޓީ"
      },
      "status": {
        "quarantined": "ކުއަރަންޓީންކުރެވިފައި",
        "released": "ރިލީސްކުރެވިފައި",
        "accepted": "ގަބޫލުކުރެވިފައި",
        "rejected": "ރިޖެކްޓްކުރެވިފައި"
      },
      "quarantine": {
        "title": "ކުއަރަންޓީންގައި ހިފެހެއްޓިފައި — އަދި އެއްވެސް އެއްޗެއް ރިކޮންސައިލް ނުކުރެވޭ",
        "held": "ސްޓޭޓްމަންޓާއި އޭގެ ސަޠުރުތައް ރެކޯޑުގައި ހުރި ނަމަވެސް، ދެވަނަ މީހަކު ފައިލް ރިލީސްކުރަންދެން އެއްވެސް ސަޠުރެއް މެޗްކުރެވިގެނެއް، ހުށަހެޅިގެނެއް، ރިކޮންސިލިއޭޝަނަކަށް ގުނެވިގެނެއް ނުވާނެ. އިމްޕޯޓްކުރި މީހާއަށް އެ ރިލީސް ނުކުރެވޭނެ.",
        "reasonsHeading": "ހިފެހެއްޓި ސަބަބު",
        "rules": {
          "continuity_break": "މީގެ އޯޕަނިންގ ބެލެންސް ކުރީގެ ސްޓޭޓްމަންޓުގެ ކްލޯޒިންގ ބެލެންސާ ގުޅިފައެއް ނުވޭ، ނުވަތަ މީގެ ތާރީޚުތައް ރެކޯޑުގައި ހުރި ސްޓޭޓްމަންޓަކާ އެއްގޮތްވޭ.",
          "sequence_gap": "މީގެ ސްޓޭޓްމަންޓް ނަންބަރު ފަހުން ގަބޫލުކުރި ސްޓޭޓްމަންޓާ ގުޅިފައެއް ނުވާތީ، ސްޓޭޓްމަންޓެއް ދަތިވެފައި ހުރެދާނެ.",
          "duplicate_statement": "މި ހަމަ ފައިލް މި އެކައުންޓަށް ކުރިންވެސް އިމްޕޯޓްކުރެވިފައި.",
          "currency_mismatch": "ސްޓޭޓްމަންޓުގެ ފައިސާ ބޭންކް އެކައުންޓުގެ ފައިސާއާ ތަފާތު. އެއްވެސް ބަދަލުކުރުމެއް ނުކުރެވޭ.",
          "sum_mismatch": "މީގެ ސަޠުރުތަކުގެ ޖުމްލަ އޯޕަނިންގ އާއި ކްލޯޒިންގ ބެލެންސްގެ ތަފާތާ އެއްވަރެއް ނުވޭ.",
          "unknown_account": "ފައިލްގައިވާ އެކައުންޓް ނަންބަރަކީ މި ބޭންކް އެކައުންޓުގެ ނަންބަރެއް ނޫން.",
          "integrity_failure": "ފައިލާއެކު ބަޔާންކުރި ޗެކްސަމާ ފައިލް އެއްގޮތެއް ނުވާތީ، ފައިލް ނުކިޔެވުނު.",
          "unparseable_line": "ފައިލުގެ ލައިނެއް ކިޔައިނުލެވުނު، އެހެންކަމުން އޭގެ އެއްވެސް ލައިނެއް އިމްޕޯޓް ނުކުރެވުނު.",
          "late_statement": "ސްޓޭޓްމަންޓް ލިބުނީ މި އެކައުންޓުގެ ލަސްވުމުގެ ހައްދަށް ފަހުގައެވެ.",
          "value_date_out_of_tolerance": "ވެލިއު ޑޭޓެއް އޭގެ ބުކިންގ ޑޭޓުގެ ކުރިން، ނުވަތަ މި އެކައުންޓުގެ ޓޮލެރެންސް ހުއްދަކުރާ މިންވަރަށްވުރެ ފަހުން."
        }
      },
      "kind": {
        "end_of_day": "ދުވަހުގެ ނިޔަލަށް",
        "intraday": "ދުވަހުގެ ތެރޭގައި",
        "intradayNote": "ދުވަހުގެ ތެރޭގެ ސްޓޭޓްމަންޓަކުން މައުލޫމާތު ދެނީ ކޭޝް ޕޮޒިޝަނަށް އެކަންޏެވެ. އޭގެ ލައިންތަކުން ރިކަންސިލިއޭޝަނެއް ނިންމައެއް ނުވަތަ ބަދަލުކޮށްއެއް ނުދޭނެ."
      },
      "integrity": {
        "verified": "ޗެކްސަމް ވެރިފައިކުރެވިފައި",
        "unverified": "ވެރިފައި ނުކުރެވޭ",
        "failed": "ޗެކްސަމް ފެއިލްވެއްޖެ"
      },
      "tabs": {
        "label": "ސްޓޭޓްމަންޓް ބައިތައް",
        "imports": "އިމްޕޯޓްތައް",
        "gaps": "ހުސްތަނާއި ލަސްވުން"
      },
      "statusFilter": {
        "label": "ދައްކާ",
        "all": "ހުރިހާ ސްޓޭޓަސްއެއް"
      },
      "review": "ރިލީސް ނުވަތަ ރިޖެކްޓް",
      "reviewProposed": "ރިލީސްކުރަން ހުށަހަޅާފައި، ދެވަނަ މީހަކަށް އިންތިޒާރުކުރަނީ",
      "reviewQuarantine": "{file} އޭގެ ކަރަންޓީން ޕެނަލުގައި ރިވިއުކުރޭ",
      "late": {
        "title": "މި ސްޓޭޓްމަންޓް ލަސްވެއްޖެ",
        "delay": "މިއީ {closing} ގައި ނިމޭ ސްޓޭޓްމަންޓެއް، {delay} ދުވަސް ފަހުން ލިބިފައިވަނީ، މި އެކައުންޓުގެ {threshold} ދުވަހުގެ ހައްދު ފަހަނައަޅައިގެންނެވެ. ސަބަބެއް ބުނެގެން އިމްޕޯޓްކުރެވޭނެ، އެ ސަބަބު އިސްތިސްނާއެއްގެ ގޮތުގައި ރެކޯޑްކުރެވޭނެ.",
        "label": "މި ސްޓޭޓްމަންޓް ލަސްވީ ކީއްވެ؟",
        "hint": "ލަސްވި މުއްދަތާއެކު އިމްޕޯޓަށް ރެކޯޑްކުރެވޭނެ. 400 އަކުރާ ހަމައަށް.",
        "required": "އަލުން އިމްޕޯޓްކުރުމުގެ ކުރިން ސްޓޭޓްމަންޓް ލަސްވި ސަބަބު ބުނޭ.",
        "recorded": "ލަސްވި ސްޓޭޓްމަންޓުގެ އިސްތިސްނާ"
      },
      "duplicate": {
        "title": "މި ސްޓޭޓްމަންޓް ކުރިން އިމްޕޯޓްކޮށްފައިވޭ",
        "nothingStored": "މި ކޮޕީ ދޫކޮށްލެވިއްޖެ. އެއްވެސް އެއްޗެއް ރައްކާ ނުކުރެވޭ.",
        "open": "އަސްލު އިމްޕޯޓް #{id} ހުޅުވާ"
      }
    },
    "import": {
      "description": "ބޭންކުން ފޮނުވި ގޮތަށް، އިމްޕޯޓްކުރި އެއް ސްޓޭޓްމަންޓް.",
      "railSubtitle": "{from} އިން {to} އަށް",
      "imported": "އިމްޕޯޓްކުރި ވަގުތު",
      "loadFailed": "އެ ސްޓޭޓްމަންޓް ނުލިބުނު",
      "linesFailed": "އެ ސްޓޭޓްމަންޓް ސަޠުރުތައް ނުލިބުނު",
      "backToList": "ހުރިހާ ސްޓޭޓްމަންޓްތައް",
      "detailsTitle": "ތަފްޞީލު",
      "period": "މުއްދަތު",
      "newLines": "އައު ސަޠުރުތައް",
      "duplicateLines": "ކުރިންވެސް ހުރި",
      "statementNo": "ސްޓޭޓްމަންޓް ނަންބަރު",
      "immutable": "ސްޓޭޓްމަންޓް ސަޠުރުތައް އުނިއިތުރެއް ނުކުރެވޭނެ. ބަދަލުވާ ހަމައެކަނި ކަމަކީ ގުޅުވިފައިވޭތޯ ނުވަތަ ނޫންތޯ.",
      "linesTitle": "ސަޠުރުތައް",
      "linesDescription": "ފައިލުގައި އޮތް ތަރުތީބުން."
    },
    "profiles": {
      "title": "ސްޓޭޓްމަންޓް މެޕިންގ ޕްރޮފައިލްތައް",
      "description": "ކޮންމެ ބޭންކެއްގެ CSV ފައިލް، ތާރީޚް، އަދަދު އަދި ރެފަރެންސަށް ގުޅުވާ ގޮތް. ބޭންކަކަށް އެއް ފަހަރު ލިޔެލަނީ.",
      "listTitle": "މެޕިންގ ޕްރޮފައިލްތައް",
      "loadFailed": "އެ ޕްރޮފައިލްތައް ނުލިބުނު",
      "emptyTitle": "އަދި މެޕިންގ ޕްރޮފައިލެއް ނެތް",
      "emptyDescription": "CSV ސްޓޭޓްމަންޓަކަށް މިއެއް ބޭނުންވަނީ، ކޮން ކޮލަމެއްކަން ތާރީޚަކީ އަދި ކޮން ކޮލަމެއްކަން އަދަދަކީ އެނގުމަށް. MT940 ފައިލްތަކަށް ބޭނުމެއް ނުވޭ — އެއަށް އަމިއްލަ އޮނިގަނޑެއް އޮވޭ.",
      "newTitle": "އައު މެޕިންގ ޕްރޮފައިލް",
      "editTitle": "މެޕިންގ ޕްރޮފައިލް އުނިއިތުރުކުރޭ",
      "dialogDescription": "މި ބޭންކްގެ ފައިލް އެއް ފަހަރު ބަޔާންކުރައްވާ؛ އެ ބޭންކުން ކުރާ ކޮންމެ އިމްޕޯޓަކަށް މިއެއް ބޭނުންކުރެވޭނެ.",
      "name": "ޕްރޮފައިލްގެ ނަން",
      "company": "ކުންފުނި",
      "bankAccount": "ބޭންކް އެކައުންޓް",
      "bankAccountHint": "ކުންފުނީގެ ކޮންމެ އެކައުންޓަކަށްވެސް ބޭނުންކުރަން ބޭނުންނަމަ ހުސްކޮށް ބާއްވަވާ.",
      "anyAccount": "ކޮންމެ އެކައުންޓެއް",
      "hasHeader": "ހެޑަރ ސަޠުރު",
      "hasHeaderHint": "ފުރަތަމަ ސަޠުރުގައި ކޮލަމްތަކުގެ ނަން އޮވޭތޯ. އޮތްނަމަ ކޮލަމްތައް ގުޅުވާނީ ނަމުން؛ ނެތްނަމަ ތަރުތީބުން.",
      "hasHeaderLabel": "ފައިލުގައި ހެޑަރ ސަޠުރެއް އޮވޭ",
      "dateFormat": "ތާރީޚް ފޯމެޓް",
      "dateFormatHint": "މި ބޭންކްގެ ފައިލުގައި ތާރީޚް ލިޔެފައި އޮންނަ ގޮތް.",
      "decimalSeparator": "ޑެސިމަލް ވަކިކުރާ ފާހަގަ",
      "decimalSeparatorHint": "އާންމުކޮށް ފުލްސްޓޮޕެއް.",
      "thousandsSeparator": "ހާސް ވަކިކުރާ ފާހަގަ",
      "thousandsSeparatorHint": "ފައިލުގައި ވަކިކޮށްފައި ނެތްނަމަ ހުސްކޮށް ބާއްވަވާ.",
      "amountMode": "އަދަދުތައް",
      "amountModeHint": "އެއް ކޮލަމުގައި ސޮއިކުރި އަދަދެއްތޯ، ނުވަތަ ދެ ކޮލަމުގައި ޑެބިޓާއި ކްރެޑިޓްތޯ.",
      "amountModes": {
        "signed": "ސޮއިކުރި އެއް ކޮލަމް",
        "debit_credit": "ވަކިވަކިން ޑެބިޓް އަދި ކްރެޑިޓް ކޮލަމް"
      },
      "columnsByName": "ކޮންމެ ކޮލަމެއްގެ ނަން، ފައިލުގެ ހެޑަރުގައި އޮތްގޮތަށް ލިޔުއްވާ. ބޮޑު ކުޑަ އަކުރު މުހިއްމެއް ނޫން.",
      "columnsByIndex": "ކޮންމެ ކޮލަމެއްގެ ތަން، ސުމަކުން ފެށިގެން ދެއްވާ.",
      "headerPlaceholder": "ކޮލަމް ހެޑަރ",
      "header": "ހެޑަރ",
      "headerYes": "ނަމުން",
      "headerNo": "ތަރުތީބުން",
      "notes": "ނޯޓް",
      "delete": "ފޮހެލާ",
      "deleted": "ޕްރޮފައިލް ފޮހެވިއްޖެ",
      "deletedDetail": "{name} އިމްޕޯޓްކުރާއިރު ދެން ނުދައްކާނެ.",
      "deleteFailed": "އެ ޕްރޮފައިލް ނުފޮހެވުނު",
      "saved": "ޕްރޮފައިލް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "ދެން އިމްޕޯޓްކުރާއިރު {name} ބޭނުންކުރެވޭނެ.",
      "saveFailed": "އެ ޕްރޮފައިލް ރައްކާނުކުރެވުނު",
      "fields": {
        "valueDate": "ފައިސާ ބަދަލުވި ތާރީޚް ކޮލަމް",
        "entryDate": "ބޭންކުން ފޮތަށްލި ތާރީޚް ކޮލަމް",
        "description": "ތަފްޞީލު ކޮލަމް",
        "reference": "ރެފަރެންސް ކޮލަމް",
        "counterpartyName": "ފަރާތުގެ ނަން ކޮލަމް",
        "amount": "އަދަދު ކޮލަމް",
        "debit": "ޑެބިޓް ކޮލަމް",
        "credit": "ކްރެޑިޓް ކޮލަމް"
      },
      "fieldHints": {
        "valueDate": "ފައިސާ ޙަޤީޤަތުގައި ބަދަލުވި ތާރީޚް. ބޭނުންވޭ.",
        "entryDate": "ފައިލުގައި ދެ ތާރީޚް ވަކިވެފައިވާނަމަ، ބޭންކުން ފޮތަށްލި ތާރީޚް.",
        "description": "ބޭންކުން ޗާޕުކުރި ތަފްޞީލު. ބޭނުންވޭ — މީހަކު ކިޔާނީ މިއެއް.",
        "reference": "ބޭންކްގެ އަމިއްލަ ރެފަރެންސް. އެންމެ ވަރުގަދަ ގުޅުވުމުގައި ބަލަނީ މިއަށް.",
        "counterpartyName": "ފައިލުގައި ނަން އޮތްނަމަ، ފައިސާ ދިޔަ ނުވަތަ އައި ފަރާތް.",
        "amount": "ފައިސާ ދިޔަނަމަ މައިނަސް، އައިނަމަ ޕްލަސް.",
        "debit": "އެކައުންޓުން ދާ ފައިސާ.",
        "credit": "އެކައުންޓަށް އަންނަ ފައިސާ."
      }
    },
    "exceptions": {
      "hypothesis": {
        "timing_difference": "ވަގުތުގެ ތަފާތު",
        "bank_charge": "ބޭންކުގެ ފީ",
        "duplicate": "ދެފަހަރު ލިބިފައިވާ",
        "fx_difference": "ބަދަލުކުރުމުގެ ރޭޓުގެ ތަފާތު",
        "unrecorded_receipt": "ރެކޯޑުނުކުރާ ލިބުމެއް",
        "unrecorded_payment": "ރެކޯޑުނުކުރާ ފައިސާދިނުމެއް",
        "unpresented_item": "ބޭންކަށް ނުދައްކާ އައިޓަމެއް"
      }
    },
    "ai": {
      "prediction": {
        "column": "ލަފާކުރާ ނުރައްކާ",
        "risk": {
          "unknown": "ލަފާއެއް ނުކުރެވޭ",
          "low": "ދަށް",
          "elevated": "މަތިވެފައި",
          "high": "މަތި"
        },
        "expectedBy": "ދެން ސްޓޭޓްމަންޓް އަންނާނެކަމަށް ލަފާކުރާ ތާރީޚު {date}",
        "basis": "ބިންގާ: {basis}"
      },
      "hypothesis": {
        "column": "ލަފާ",
        "title": "ލަފާ",
        "confidence": "ޔަގީންކަން {percent}%",
        "basis": "ބިންގާ: {basis}",
        "none": "ލަފާއެއް ނެތް",
        "advisory": "މި އެކައުންޓުގެ ސްޓޭޓްމަންޓް ލައިންތަކާއި ޕޯސްޓިންގްތައް ހަމަޖެހިފައިވާ ގޮތަކަށް އަޅާކިޔައިގެން ހޯދާ ލަފާއެކެވެ. ސަބަބެއް ހުށަހަޅައެވެ؛ ތިބާ ނިންމަންދެން އެއްވެސް އެއްޗެއް ރެކޯޑެއް ނުކުރެވޭނެއެވެ.",
        "decision": {
          "label": "ލަފާއާ މެދު ތިބާގެ ނިންމުން",
          "later": "ފަހުން ނިންމާނަން",
          "accept": "ލަފާ ގަބޫލުކުރޭ",
          "acceptHint": "ސަބަބަކީ {label} ކަމުގައި ރެކޯޑުކުރޭ",
          "override": "ބަދަލުކުރޭ",
          "overrideHint": "ތިބާ ހޯދި ސަބަބު ބުނެ، ނޯޓުގައި ސަބަބު ލިޔޭ"
        },
        "overrideCode": "ތިބާގެ ސަބަބު",
        "overrideCodeHint": "ހުށަހެޅި ލަފާ މި ލިސްޓުގައި ނެތް: އެ ގަބޫލުކުރޭ.",
        "overrideCodePlaceholder": "ސަބަބު އިޚްތިޔާރުކުރޭ",
        "recorded": {
          "accepted": "ގަބޫލުކުރެވުނު: {label}",
          "overridden": "ބަދަލުކުރެވުނު: {offered} ގެ ބަދަލުގައި {chosen}",
          "by": "{name}، {at}",
          "on": "{at}"
        }
      },
      "learned": {
        "basis": "ބިންގާ: {detail}",
        "neverApplies": "ކުރީގެ ކަށަވަރުކުރުންތަކުން ދަސްކުރުމަކީ މި ހުށަހެޅުންތައް ތަރުތީބުކޮށް ސްކޯ ބަދަލުކުރުން އެކަނި. އެއީ އަމިއްލައަށް މެޗެއް ހިންގާ ކަމެއް ނޫން، އަދި އޮޓޮމެޓިކް މެޗިންގަށް ނުގުނެވޭ."
      }
    },
    "importLines": {
      "title": "ސްޓޭޓްމަންޓުގެ ލައިންތައް",
      "titleFor": "{file} ގެ ލައިންތައް",
      "description": "އިމްޕޯޓްކުރެވުނު އެއް ސްޓޭޓްމަންޓެއްގެ ހުރިހާ ލައިނެއް، ފައިލުގައިވާ ތަރުތީބުން. ލައިނެއް ބަދަލެއް ނުކުރެވޭނެއެވެ؛ ރައްކާކުރެވުނު ގޮތަށް ރެކޯޑު ބެއްލެވުމަށް ލައިނެއް ހުޅުއްވާ.",
      "backToImport": "ސްޓޭޓްމަންޓަށް އެނބުރި",
      "deniedTitle": "ސްޓޭޓްމަންޓުގެ ލައިންތައް ތިޔަ ބޭފުޅާއަށް ނުފެންނާނެ",
      "deniedDescription": "އިމްޕޯޓްކުރެވުނު ސްޓޭޓްމަންޓް ލައިންތައް ކިޔުމަށް ސްޓޭޓްމަންޓް ކިޔުމުގެ ހުއްދަ ބޭނުންވެއެވެ.",
      "emptyTitle": "މި ސްޓޭޓްމަންޓުގައި އެއްވެސް ލައިނެއް ނެތް",
      "emptyDescription": "ފައިލުގައިވާ ހުރިހާ ލައިނެއް މި އެކައުންޓަށް ކުރިން ވެސް ރެކޯޑުކުރެވިފައިވާތީ އެއްވެސް ލައިނެއް އިތުރު ނުކުރެވުނެވެ. ސްޓޭޓްމަންޓުގައި އޭގެ ބެލެންސްތައް ރެކޯޑުކުރެވިފައި ހުރެއެވެ.",
      "lineNo": "ލައިން",
      "actions": "ޢަމަލުތައް",
      "viewRaw": "އަސްލު",
      "viewRawFor": "ލައިން {line} ގެ ރައްކާކުރެވުނު ރެކޯޑު ދައްކާ",
      "drawerTitle": "ރައްކާކުރެވުނު ގޮތަށް ލައިން {line}",
      "drawerFallback": "ސްޓޭޓްމަންޓް ލައިން",
      "drawerDescription": "ވަކިކުރެވުނު ފީލްޑުތައް، ދެން ސާވަރުން ފޮނުވި ގޮތަށް ރެކޯޑު.",
      "entryDate": "އެންޓްރީގެ ތާރީޚު",
      "direction": "ދިމާ",
      "directions": {
        "in": "ފައިސާ ވަދެފައި",
        "out": "ފައިސާ ނިކުމެފައި"
      },
      "counterparty": "އަނެއް ފަރާތް",
      "bankTransactionCode": "ބޭންކް މުޢާމަލާތު ކޯޑު",
      "rawHeading": "ފޮނުވި ގޮތަށް ރެކޯޑު",
      "openLines": "މި ސްޓޭޓްމަންޓުގެ {count} ލައިން ހުޅުވާ"
    },
    "connectors": {
      "title": "ބޭންކް އެކައުންޓްތަކާއި ކަނެކްޓަރުތައް",
      "description": "ކޮންމެ އެކައުންޓެއްގެ ސްޓޭޓްމަންޓް ލިބޭ ގޮތް. ފެޗް ދައްކަނީ އެކައުންޓުގެ ކަނެކްޓަރަށް ސްޓޭޓްމަންޓެއް ލިބިގަނެވޭ ތަންތަނުގައި އެކަންޏެވެ؛ އެހެން ހުރިހާ އެއްޗެއް މައްޗަށް އަޕްލޯޑުކުރެވޭނެއެވެ.",
      "currency": "ފައިސާ",
      "connector": "ކަނެކްޓަރު",
      "actions": "ޢަމަލުތައް",
      "unknown": "ތިޔަ ބޭފުޅާއަށް ނުފެންނާނެ",
      "notRegistered": "މި އިންސްޓޮލޭޝަނުގައި ނެތް",
      "uploadOnly": "އަޕްލޯޑު އެކަނި",
      "fetch": "ސްޓޭޓްމަންޓް ފެޗްކުރޭ",
      "fetching": "ފެޗްކުރަނީ",
      "fetchFailed": "ފެޗް ރަދުކުރެވުނު",
      "fetched": "{count} ސްޓޭޓްމަންޓް ލިބިއްޖެ",
      "openFetched": "ސްޓޭޓްމަންޓް #{id} ގެ ލައިންތައް ހުޅުވާ"
    },
    "autoMatch": {
      "action": "އޮޓޯ-މެޗް",
      "notConfigured": "އޮޓޯ-މެޗް ބޭނުންކުރުމަށް، ރިކަންސިލިއޭޝަން ސެޓިންގްސްގައި މި އެކައުންޓަށް އޮޓޯ-އެޕްލައި ކޮންފިޑެންސެއް ކަނޑައަޅާ.",
      "summary": "އޮޓޯ-މެޗުން {applied} މެޗް ހެދިއްޖެ. {ambiguous} ލައިނަށް ޝަރުތު ހަމަވާ ކެންޑިޑޭޓް އެކެއްވުރެ ގިނަ، އަދި {below} ލައިން ހައްދަށްވުރެ ދަށް؛ އެއީ ސަޖެޝަންތަކެއްގެ ގޮތުގައި ހުންނާނެ.",
      "failed": "އޮޓޯ-މެޗް ރިޖެކްޓްކުރެވުނު"
    },
    "continuity": {
      "heldCanRelease": "މި ބްރޭކްގެ ސަބަބުން ފައިލު ކަރަންޓީނުގައި ހިފެހެއްޓިފައިވޭ. ކަރަންޓީން ޕެނަލުން ރިލީސް ނުވަތަ ރިޖެކްޓް ކުރޭ؛ ތިބާ އިމްޕޯޓްކުރި ފައިލެއް ތިބާއަށް ރިލީސް ނުކުރެވޭނެ.",
      "heldNeedsReleaser": "ސްޓޭޓްމަންޓް ރިލީސްކުރެވޭ، އިމްޕޯޓްކުރި މީހާ ނޫން މީހަކު ރިލީސް ނުވަތަ ރިޖެކްޓް ކުރުމާއި ހަމައަށް، މި ބްރޭކްގެ ސަބަބުން ފައިލު ކަރަންޓީނުގައި ހިފެހެއްޓިފައިވާނެ.",
      "openQuarantine": "ކަރަންޓީން ޕެނަލް ހުޅުވާ",
      "settled": {
        "released": "މި ބްރޭކް ދެވަނަ މީހަކު ކަރަންޓީނުން ރިލީސްކޮށްފިއެވެ.",
        "rejected": "މި ބްރޭކް ހުރި ފައިލު ރިޖެކްޓްކޮށްފިއެވެ؛ ރަނގަޅުކުރެވިފައިވާ ސްޓޭޓްމަންޓް އިމްޕޯޓްކުރެވެނީ އައު ފައިލެއްގެ ގޮތުގައެވެ."
      }
    },
    "quarantine": {
      "panelTitle": "ކަރަންޓީން",
      "release": "ރިލީސް",
      "reject": "ރިޖެކްޓް",
      "releaseTitle": "މި ސްޓޭޓްމަންޓް ރިލީސްކުރޭ",
      "releaseDescription": "އޭގެ ލައިންތައް ރިކަންސައިލް ކުރެވޭނެ. ތިބާއަކީ އިމްޕޯޓްކުރި މީހާ، ފޮނުވި ކަނެކްޝަނުގެ ވެރިއެއް، ނުވަތަ ރިލީސްކުރަން ހުށަހެޅި މީހާ ނުވާން ޖެހޭ.",
      "rejectTitle": "މި ސްޓޭޓްމަންޓް ރިޖެކްޓްކުރޭ",
      "rejectDescription": "ފައިލާއި އޭގެ ލައިންތައް ރެކޯޑުގައި ހުންނާނެ، އަދި ދުވަހަކުވެސް ރިކަންސައިލް ނުކުރެވޭނެ. ރަނގަޅުކުރެވިފައިވާ ސްޓޭޓްމަންޓް އިމްޕޯޓްކުރެވެނީ އައު ފައިލެއްގެ ގޮތުގައެވެ.",
      "reasonLabel": "ސަބަބު",
      "reasonRequired": "ސަބަބެއް ބޭނުންވޭ. އެއީ ތިބާގެ ނަމުގައި އޯޑިޓް ލޮގުގައި ރެކޯޑްކުރެވޭނެ އެއްޗެކެވެ.",
      "proposalTitle": "ހުށަހެޅުން ރެކޯޑްކުރެވިއްޖެ",
      "proposalBody": "މި ސްޓޭޓްމަންޓުގެ އެއްވެސް ލައިނެއް ރިކަންސައިލް ކުރެވޭނީ ދެވަނަ މީހަކު އެ ރިލީސްކުރުމަށްފަހުގައެވެ.",
      "proposedBy": "ހުށަހެޅީ ޔޫޒަރ #{user}، {at} ގައި.",
      "released": "ސްޓޭޓްމަންޓް ރިލީސްކުރެވިއްޖެ",
      "releasedDetail": "މިހާރު އޭގެ ލައިންތައް މެޗްކުރެވޭނެ.",
      "rejected": "ސްޓޭޓްމަންޓް ރިޖެކްޓްކުރެވިއްޖެ",
      "rejectedDetail": "އެ ރެކޯޑުގައި ހުންނާނެ. ރަނގަޅުކުރެވިފައިވާ ފައިލު އިމްޕޯޓްކުރޭ.",
      "sod": "ތިބާއަށް މި ސްޓޭޓްމަންޓް ރިލީސް ނުކުރެވޭނެ: އިމްޕޯޓްކުރި މީހާ، ކަނެކްޝަނުގެ ވެރިން، އަދި ރިލީސްކުރަން ހުށަހެޅި މީހާ އެންމެން އިސްތިސްނާވެއެވެ. އެހެން މީހަކަށް ރިލީސްކުރަން އެދޭ. {detail}",
      "notReleasable": "މި ސްޓޭޓްމަންޓް ރިޖެކްޓްކުރެވޭނީ އެކަންޏެވެ. {detail}",
      "decidedElsewhere": "ތިބާ މަސައްކަތްކުރަމުންދަނިކޮށް އެހެން މީހަކު މި ސްޓޭޓްމަންޓް ނިންމައިފި. އަލުން ލޯޑްކުރެވިއްޖެ.",
      "rejectOnly": "މި ފައިލު ރިޖެކްޓްކުރެވޭނީ އެކަންޏެވެ: އޭގެ ކަރަންސީއަކީ އެކައުންޓުގެ ކަރަންސީ ނޫން، އިންޓެގްރިޓީ ޗެކް ފެއިލްވެފައި، ނުވަތަ ލައިނެއް ކިޔައިނުލެވުނު. ރިޖެކްޓްކޮށް ރަނގަޅުކުރެވިފައިވާ ފައިލު އިމްޕޯޓްކުރޭ.",
      "youImported": "މި ފައިލު އިމްޕޯޓްކުރީ ތިބާ، އެހެންކަމުން އެހެން މީހަކު ރިލީސްކުރަން ޖެހޭ. ތިބާއަށް އަދިވެސް ރިޖެކްޓްކުރެވޭނެ.",
      "youProposed": "މި ފައިލު ރިލީސްކުރަން ހުށަހެޅީ ތިބާ، އެހެންކަމުން ދެވަނަ މީހަކު ރިލީސްކުރަން ޖެހޭ.",
      "decidedAt": "ނިންމި ވަގުތު",
      "decidedBy": "ނިންމީ",
      "decisionReason": "ސަބަބު",
      "linesFailed": "މި ސްޓޭޓްމަންޓުގެ ލައިންތައް ލޯޑް ނުކުރެވުނު",
      "heldLinesTitle": "ރިވިއުއަށް ހިފެހެއްޓިފައިވާ ލައިންތައް",
      "heldLinesDescription": "މިތާ ހުރި ކޮންމެ ލައިނެއް ހިފެހެއްޓިފައިވަނީ ގަބޫލުކުރެވިފައިވާ ފައިލެއްގެ ތެރޭގައި އޭގެ އަމިއްލަ ގަވާއިދަކުންނެވެ. އިމްޕޯޓްކުރި މީހާ ނޫން މީހަކު ރިލީސްކުރުމާއި ހަމައަށް މެޗެއް ނުކުރެވޭނެ.",
      "heldLinesFileFirst": "ފުރަތަމަ ފައިލު ނިންމާ. ހިފެހެއްޓިފައިވާ ލައިނެއް ރިލީސް ނުވަތަ ރިޖެކްޓް ކުރެވޭނީ އޭގެ ސްޓޭޓްމަންޓް ލައިވްވުމުންނެވެ.",
      "lineNo": "ލައިން",
      "dates": "ބުކިންގ / ވެލިއު ތާރީޚު",
      "amount": "އަދަދު",
      "why": "ހިފެހެއްޓި ސަބަބު",
      "actions": "ޢަމަލުތައް",
      "lineRules": {
        "FIN_T01_V030": "ވެލިއު ޑޭޓް ބުކިންގ ޑޭޓުގެ ކުރިން، ނުވަތަ މި އެކައުންޓުގެ ޓޮލެރެންސް ހުއްދަކުރާ މިންވަރަށްވުރެ ފަހުން."
      },
      "lineOutcome": {
        "released": "ރިލީސްކުރެވިއްޖެ",
        "rejected": "ރިޖެކްޓްކުރެވިއްޖެ، ރެކޯޑުގައި ބަހައްޓާފައި",
        "proposed": "ހުށަހެޅުން ރެކޯޑްކުރެވިއްޖެ، ދެވަނަ މީހަކު ނިންމަން ޖެހޭ"
      },
      "lineReleaseTitle": "މި ލައިން ރިލީސްކުރޭ",
      "lineReleaseDescription": "ލައިން ރިކަންސައިލް ކުރެވޭނެ. ހިފެހެއްޓި ސަބަބު ތާރީޚެއްގެ ގޮތުގައި ހުންނާނެ.",
      "lineRejectTitle": "މި ލައިން ރިޖެކްޓްކުރޭ",
      "lineRejectDescription": "ލައިން ރެކޯޑުގައި ހުންނާނެ، އަދި ދުވަހަކުވެސް ރިކަންސައިލް ނުކުރެވޭނެ.",
      "lineProposalBody": "މި ލައިން ރިކަންސައިލް ކުރެވޭނީ ދެވަނަ މީހަކު ނިންމުމަށްފަހުގައެވެ.",
      "lineReleased": "ލައިން ރިލީސްކުރެވިއްޖެ",
      "lineRejected": "ލައިން ރިޖެކްޓްކުރެވިއްޖެ",
      "lineSod": "ތިބާއަށް މި ލައިން ނުނިންމޭނެ: އިމްޕޯޓްކުރި މީހާ، ކަނެކްޝަނުގެ ވެރިން، އަދި ނިންމުމަށް ހުށަހެޅި މީހާ އިސްތިސްނާވެއެވެ. {detail}",
      "lineAlreadyDecided": "މި ލައިން ކުރިން ނިންމާފައިވޭ. {detail}",
      "duplicateLinesTitle": "ރެކޯޑުގައި ބަހައްޓާފައިވާ ޑުޕްލިކޭޓް ލައިންތައް",
      "duplicateOf": "ލައިވް ލައިނެއްގެ (#{id}) ޑުޕްލިކޭޓެއް، ރެކޯޑުގައި ބަހައްޓާފައި. ދުވަހަކުވެސް ރިކަންސައިލް ނުކުރެވޭނެ."
    },
    "gaps": {
      "title": "ސްޓޭޓްމަންޓް ހުސްތަންތަން",
      "description": "ގަބޫލުކުރެވިފައިވާ އެއްވެސް ސްޓޭޓްމަންޓަކުން ކަވަރު ނުކުރާ އެކައުންޓެއްގެ ތާރީޚުގެ ބައިތައް. ކޮންމެ އެއްޗެއް ހައްލުކުރެވެނީ އެ ފުރާ ސްޓޭޓްމަންޓަކުން، ނުވަތަ ސަބަބަކާއެކު ދޫކޮށްލެވެނީ.",
      "loadFailed": "ސްޓޭޓްމަންޓް ހުސްތަންތަން ލޯޑް ނުކުރެވުނު",
      "emptyTitle": "ހުސްތަނެއް ނެތް",
      "emptyDescription": "މި ވިއުގައިވާ ކޮންމެ އެކައުންޓެއްގެވެސް ސްޓޭޓްމަންޓްތައް ކެނޑިފައި ނެތް. ނެތް ސްޓޭޓްމަންޓެއް، ބެލެންސް ބްރޭކެއް ނުވަތަ ފަހަނައަޅާފައިވާ ނަންބަރެއް މިތާ ފެންނާނެ.",
      "columns": {
        "dates": "ތާރީޚުތައް",
        "kind": "ބާވަތް",
        "detail": "ތަފްސީލު"
      },
      "kind": {
        "continuity": "ބެލެންސް ބްރޭކް",
        "sequence": "ނެތް ސްޓޭޓްމަންޓް ނަންބަރު",
        "coverage": "ކަވަރު ނުކުރެވޭ ބޭންކިންގ ދުވަސް",
        "stale": "ސްޓޭޓްމަންޓްތައް ލަސްވެފައި"
      },
      "status": {
        "all": "ހުރިހާ",
        "open": "ހުޅުވިފައި",
        "resolved": "ހައްލުކުރެވިފައި",
        "waived": "ދޫކޮށްލެވިފައި"
      },
      "sourceImport": "ފެނުނީ އިމްޕޯޓް #{id} އިން",
      "filledBy": "ފުރީ އިމްޕޯޓް #{id} އިން",
      "proposalRow": "ދޫކޮށްލަން ހުށަހަޅާފައި، ދެވަނަ މީހަކަށް އިންތިޒާރުކުރަނީ",
      "resolve": "ހައްލުކުރޭ",
      "waive": "ދޫކޮށްލާ",
      "resolveTitle": "މި ހުސްތަން ހައްލުކުރޭ",
      "resolveDescription": "އެ ފުރާ ސްޓޭޓްމަންޓް ނަންކިޔާ. އެއީ ތާރީޚުތައް ކަވަރުކުރާ، ކޮންޓިނިއުއިޓީ އަނބުރާ ގެނެސްދޭ، ނުވަތަ ނެތް ނަންބަރެއް ހިމެނޭ، އެ އެކައުންޓުގެ ލައިވް ދުވަހުގެ ނިޔަލަށް ސްޓޭޓްމަންޓެއް ކަމުގައި ވާން ޖެހޭ.",
      "waiveTitle": "މި ހުސްތަން ދޫކޮށްލާ",
      "waiveDescription": "އެއްވެސް އެއްޗަކުން މި ނުފުރޭނެކަން ރެކޯޑްކުރޭ. ހުސްތަން ފެނުނު އިމްޕޯޓް ކުރި މީހާއަށާއި އެކައުންޓުގެ ކަނެކްޝަނުގެ ވެރިންނަށް ދޫކޮށްނުލެވޭނެ.",
      "fillingImport": "ފުރާ ސްޓޭޓްމަންޓް",
      "fillingImportHint": "މި އެކައުންޓުގެ ލައިވް ދުވަހުގެ ނިޔަލަށް ސްޓޭޓްމަންޓްތައް.",
      "fillingImportPlaceholder": "ހުސްތަން ފުރާ ސްޓޭޓްމަންޓް އިޚްތިޔާރުކުރޭ",
      "importRequired": "ހުސްތަން ފުރާ ސްޓޭޓްމަންޓް އިޚްތިޔާރުކުރޭ.",
      "noCandidates": "މި އެކައުންޓުގެ އެއްވެސް ލައިވް ދުވަހުގެ ނިޔަލަށް ސްޓޭޓްމަންޓެއް ރެކޯޑުގައި ނެތް. ނެތް ސްޓޭޓްމަންޓް އިމްޕޯޓްކުރޭ، ނުވަތަ ހުސްތަން ދޫކޮށްލާ.",
      "proposalTitle": "ހުށަހެޅުން ރެކޯޑްކުރެވިއްޖެ",
      "proposalBody": "މި ހުސްތަން ދޫކޮށްލަން ޖެހޭނީ ދެވަނަ މީހަކު. އޭރާ ހަމައަށް ހުޅުވިފައި ހުންނާނެ.",
      "resolved": "ހުސްތަން ހައްލުކުރެވިއްޖެ",
      "waived": "ހުސްތަން ދޫކޮށްލެވިއްޖެ",
      "sod": "ތިބާއަށް މި ހުސްތަން ދޫކޮށްނުލެވޭނެ: އެ ފެނުނު އިމްޕޯޓް ކުރި މީހާ، އެކައުންޓުގެ ކަނެކްޝަނުގެ ވެރިން، އަދި ދޫކޮށްލަން ހުށަހެޅި މީހާ އިސްތިސްނާވެއެވެ. {detail}",
      "decidedElsewhere": "ތިބާ މަސައްކަތްކުރަމުންދަނިކޮށް އެހެން މީހަކު މި ހުސްތަން ނިންމައިފި. ލިސްޓު އަލުން ލޯޑްކުރެވިއްޖެ."
    },
    "staleness": {
      "title": "ސްޓޭޓްމަންޓް ލަސްވުން",
      "description": "ކޮންމެ އެކައުންޓެއްގެ އެންމެ އައު ގަބޫލުކުރެވިފައިވާ ދުވަހުގެ ނިޔަލަށް ސްޓޭޓްމަންޓުން ފެށިގެން ދުވަސްތައް، އެކައުންޓުގެ އަމިއްލަ ހައްދާ އަޅާކިޔައި.",
      "loadFailed": "ލަސްވުމުގެ ރިޕޯޓް ލޯޑް ނުކުރެވުނު",
      "emptyTitle": "އެކްޓިވް ބޭންކް އެކައުންޓެއް ނެތް",
      "emptyDescription": "ލަސްވުން ރިޕޯޓްކުރެވެނީ އެކްޓިވް ބޭންކް އެކައުންޓްތަކަށެވެ.",
      "lastStatement": "ފަހު ސްޓޭޓްމަންޓް",
      "daysStale": "މުއްދަތު",
      "threshold": "ހައްދު",
      "openGaps": "ހުޅުވިފައިވާ ހުސްތަންތަން",
      "quarantined": "ކަރަންޓީން",
      "never": "އަދި ނެތް",
      "noStatement": "ސްޓޭޓްމަންޓެއް ނެތް",
      "days": "{n} ދުވަސް"
    },
    "signals": {
      "title": "ޙިއްސާވާ ސިގްނަލްތައް",
      "reference": "ރެފަރެންސް",
      "date": "ތާރީޚު",
      "name": "ފަރާތުގެ ނަން",
      "value": "{score}% × ވަޒަން {weight} = {contribution} ޕޮއިންޓް",
      "learned": "ކަށަވަރުކުރެވިފައިވާ މެޗުތަކުން ދަސްކުރެވުނު"
    },
    "forceMatch": {
      "action": "މަޖުބޫރުން މެޗްކުރުން",
      "openAction": "މަޖުބޫރުން މެޗްކުރުން…",
      "openQueue": "މަޖުބޫރު މެޗްތައް ހުޅުވާ",
      "pendingInSession": "މި ސެޝަނުގައި {count} މަޖުބޫރު މެޗެއް ދެވަނަ ހުއްދަދޭ މީހަކަށް އިންތިޒާރުކުރަނީ؛ އެހިނދަކު ސްޓޭޓްމަންޓް ލައިން މެޗްނުވެ ހުންނާނެ. | މި ސެޝަނުގައި {count} މަޖުބޫރު މެޗް ދެވަނަ ހުއްދަދޭ މީހަކަށް އިންތިޒާރުކުރަނީ؛ އެހިނދަކު ސްޓޭޓްމަންޓް ލައިންތައް މެޗްނުވެ ހުންނާނެ.",
      "pickHint": "މަޖުބޫރުން މެޗްކުރުމަށް، ހަމައެކަނި އެއް ސްޓޭޓްމަންޓް ލައިނާއި، އޭގެ ލެޖަރ ލައިންތައް ޓިކްކުރައްވާ.",
      "dialogTitle": "މި މެޗް މަޖުބޫރުން ކުރުން",
      "dialogDescription": "އިންޖިން ހުށަނާޅާ ނަމަވެސް ސްޓޭޓްމަންޓް ލައިން ޓިކްކުރި ލެޖަރ ލައިންތަކާ ގުޅާލާނެ. ސަބަބުގެ ކޯޑާއި ސަބަބު ތިޔަބޭފުޅާގެ ނަމުގައި ރެކޯޑުކުރެވޭނެ.",
      "bandNote": "{band} އަށްވުރެ މަތީގައި، އެހެން މީހަކު ހުއްދަދޭންދެން މި މެޗް ހިނގާނެ ނޫން. {tolerance} އަށްވުރެ ބޮޑު ތަފާތެއް ރިޖެކްޓްކުރެވޭނެ؛ އޭގެ ބަދަލުގައި ނެތް އެންޓްރީ ޕޯސްޓްކުރައްވާ.",
      "reasonCode": "ސަބަބުގެ ކޯޑު",
      "reasonCodePlaceholder": "މެޗް މަޖުބޫރުކުރާ ސަބަބު ހޮވާ",
      "reason": "ސަބަބު",
      "reasonHint": "ތިޔަބޭފުޅާގެ އަމިއްލަ ބަހުން. 500 އަކުރަށް.",
      "submit": "މަޖުބޫރުން މެޗްކުރުން",
      "reasons": {
        "timing_difference": "ވަގުތުގެ ތަފާތު",
        "bank_error": "ބޭންކުގެ ކުށް",
        "ledger_error": "ލެޖަރގެ ކުށް",
        "fx_difference": "ބަދަލުކުރުމުގެ ތަފާތު",
        "partial_settlement": "ބައެއް ފައިސާ ދެއްކުން",
        "other": "އެހެނިހެން"
      },
      "appliedTitle": "މެޗް މަޖުބޫރުން ކުރެވިއްޖެ",
      "appliedDetail": "އެއީ އަގުގެ ބޭންޑުގެ ތެރޭގައި ހުރި މެޗެއް ކަމުން ހިނގައިފި.",
      "heldTitle": "ހުއްދައަށް ހިފަހައްޓައިފި",
      "heldDetail": "އޭގެ އަގު {band} ބޭންޑަށްވުރެ މަތި ކަމުން، ދެވަނަ މީހަކު ހުއްދަދޭންދެން އެއްވެސް ކަމެއް ނުހިނގާނެ.",
      "residualRefused": "ސްޓޭޓްމަންޓް ލައިނާއި ލެޖަރ ލައިންތަކާ ދެމެދުގެ ތަފާތު، މި އެކައުންޓުގައި މަޖުބޫރު މެޗަކަށް ހުއްދަ ދޭ މިންވަރަށްވުރެ ބޮޑު.",
      "queueTitle": "މަޖުބޫރު މެޗްތައް",
      "queueDescription": "މި ސެޝަނުގެ ހުރިހާ މަޖުބޫރު މެޗެއް. އަގުގެ ބޭންޑަށްވުރެ މަތީގެ މެޗެއް، އެ މެޗް ކުރި މީހާ ނޫން މީހަކަށް މިތާނގައި އިންތިޒާރުކުރާނެ.",
      "queueLoadFailed": "މަޖުބޫރު މެޗްތައް ލޯޑެއް ނުކުރެވުނު",
      "queueEmpty": "މި ސެޝަނުގައި އެއްވެސް މެޗެއް މަޖުބޫރުން ކުރެވިފައެއް ނުވޭ.",
      "columns": {
        "line": "ސްޓޭޓްމަންޓް ލައިން",
        "statement": "ސްޓޭޓްމަންޓް",
        "ledger": "ލެޖަރ ލައިންތައް",
        "residual": "ތަފާތު",
        "value": "އަގު",
        "reason": "ސަބަބު",
        "requested": "މަޖުބޫރުކުރީ"
      },
      "lineRef": "ލައިން #{line}، {count} ލެޖަރ ލައިނާ ދެކޮޅަށް",
      "aboveBand": "{band} ބޭންޑަށްވުރެ މަތި",
      "withinBand": "{band} ބޭންޑުގެ ތެރޭގައި",
      "status": {
        "pending": "ހުއްދައަށް އިންތިޒާރުކުރަނީ",
        "applied": "ހިނގައިފި",
        "declined": "ރިޖެކްޓްކުރެވިފި"
      },
      "decidedBy": "ނިންމީ {name}",
      "ownRequest": "މި މެޗް މަޖުބޫރުކުރެއްވީ ތިޔަބޭފުޅާ ކަމުން، އެހެން މީހަކު ހުއްދަ ދޭންޖެހޭނެ.",
      "authorise": "ހުއްދަދޭ",
      "decline": "ރިޖެކްޓްކުރޭ",
      "declineReason": "ރިޖެކްޓްކުރަނީ ކީއްވެ؟",
      "authorised": "މަޖުބޫރު މެޗަށް ހުއްދަދީ ހިންގައިފި",
      "declined": "މަޖުބޫރު މެޗް ރިޖެކްޓްކުރެވިފި؛ އެއްވެސް ކަމެއް ނުހިނގާ",
      "reloaded": "ތިޔަބޭފުޅާ ބައްލަވަމުން ދަނިކޮށް އެހެން މީހަކު މި މަޖުބޫރު މެޗް ބަދަލުކޮށްފި. އަލުން ލޯޑުކޮށްފި؛ އަލުން ނިންމަވާ.",
      "sodRefused": "ތިޔަބޭފުޅާ މަޖުބޫރުކުރެއްވި މެޗަކަށް ހުއްދަ ނުދެއްވޭނެ.",
      "inboxTitle": "ތިޔަބޭފުޅާގެ ހުއްދައަށް އިންތިޒާރުކުރާ މަޖުބޫރު މެޗްތައް",
      "inboxDescription": "ހުރިހާ ސެޝަނެއްގައި، އަގުގެ ބޭންޑަށްވުރެ މަތީގެ މަޖުބޫރު މެޗްތައް. ކޮންމެ މެޗެއް ނިންމަނީ އޭގެ ސެޝަނުގެ މެޗް ސްކްރީނުގައި، މަޖުބޫރުކުރި މީހާ ނޫން މީހަކު.",
      "inboxLoading": "މަޖުބޫރު މެޗްތައް ލޯޑުކުރަނީ…",
      "inboxEmpty": "ދެވަނަ ހުއްދަދޭ މީހަކަށް އެއްވެސް ކަމެއް އިންތިޒާރެއް ނުކުރޭ.",
      "yours": "ތިޔަބޭފުޅާގެ، އެހެން މީހަކު ނިންމަންޖެހޭ",
      "review": "ބަލައި ނިންމަވާ"
    },
    "heldLines": {
      "title": "ކުއަރަންޓީން ކުރެވިފައިވާ ސްޓޭޓްމަންޓް ލައިންތައް",
      "description": "ސްޓޭޓްމަންޓުގެ އެއްވެސް ލައިނެއް ކުއަރަންޓީނުގައި ހުރިހާ ހިނދަކު މި ރިކޮންސިލިއޭޝަން ނިންމޭނެ ނޫން.",
      "loadFailed": "ކުއަރަންޓީން ސްޓޭޓްމަންޓްތައް ޗެކެއް ނުކުރެވުނު",
      "blocked": "މި މުއްދަތު ހިމެނޭ {statements} ކުއަރަންޓީން ސްޓޭޓްމަންޓެއް ހުރި، {lines} ލައިން ހިފަހައްޓައިގެން. ރިކޮންސިލިއޭޝަން ނިންމުމުގެ ކުރިން ކޮންމެ ސްޓޭޓްމަންޓެއް އޭގެ ކުއަރަންޓީން ޕެނަލުން ރިލީސް ނުވަތަ ރިޖެކްޓް ކުރައްވާ.",
      "statement": "{file}، {from} އިން {to} އަށް",
      "noReasonStated": "މި ސްޓޭޓްމަންޓުގައި އެއްވެސް ސަބަބެއް ރެކޯޑުކުރެވިފައެއް ނުވޭ.",
      "linesCaption": "ސެޝަނުގެ މުއްދަތުގައި ހިފަހައްޓާފައިވާ މި ސްޓޭޓްމަންޓުގެ ލައިންތައް",
      "lineNo": "ލައިން",
      "valueDate": "ވެލިއު ތާރީޚު",
      "reference": "ރެފަރެންސް",
      "amount": "އަދަދު",
      "linesUnavailable": "މި ކުއަރަންޓީން ސްޓޭޓްމަންޓުގެ ލައިންތައް ކިޔައެއް ނުލެވުނު، އެހެންކަމުން އޭގެ އެއްވެސް ލައިނެއް މި މުއްދަތުގައި ހުރިތޯ ނޭނގެ. ބަންދުކުރުން އަދިވެސް ހުޅުވާލެވިފައި؛ މުއްދަތުގައި ހިފަހައްޓާފައިވާ ލައިނެއް ހުރިނަމަ، ރިފިއުސަލްގައި އެ ލިސްޓުކުރާނެ.",
      "serverListsRest": "ގަބޫލުކުރެވިފައިވާ ސްޓޭޓްމަންޓެއްގެ ތެރޭގައި އަމިއްލަ ގަވާއިދަކުން ހިފަހައްޓާފައިވާ ލައިނެއް، ނުވަތަ ދުވަހުގެ ނިމުމުގެ ސްޓޭޓްމަންޓެއް ނުހިމެނޭ އިންޓްރާޑޭ ލައިނެއްވެސް ނިންމުން ހުއްޓުވާނެ؛ ބަންދުކުރަން އުޅުއްވާއިރު ރިފިއުސަލްގައި އެ ލައިންތައް ލިސްޓުކުރާނެ.",
      "closeBlocked": "މި މުއްދަތު ހިމެނޭ ކުއަރަންޓީން ސްޓޭޓްމަންޓެއް ހުރި. ފުރަތަމަ އެ ރިލީސް ނުވަތަ ރިޖެކްޓް ކުރައްވާ.",
      "closeRefusedTitle": "މި ސްޓޭޓްމަންޓް ލައިންތައް ހިފަހައްޓާފައި ހުރިހާ ހިނދަކު ރިކޮންސިލިއޭޝަން ނިންމޭނެ ނޫން",
      "openImports": "ރިލީސް ނުވަތަ ރިޖެކްޓް ކުރުމަށް މި އެކައުންޓުގެ ސްޓޭޓްމަންޓްތައް ހުޅުވާ"
    },
    "reopenQueue": {
      "title": "ހުއްދައަށް އިންތިޒާރުކުރާ އަލުން ހުޅުވުމުގެ އެދުންތައް",
      "description": "އަލުން ހުޅުވަން އެދިފައިވާ ބަންދުކުރެވިފައިވާ ރިކޮންސިލިއޭޝަންތައް. ކޮންމެ އެދުމެއް ނިންމަނީ އޭގެ ސެޓްފިކެޓް ސްކްރީނުގައި، އެދުނު، ނިންމި، ނުވަތަ ސެޓްފައި ކުރި މީހަކު ނޫން މީހަކު.",
      "loadFailed": "އަލުން ހުޅުވުމުގެ އެދުންތައް ލޯޑެއް ނުކުރެވުނު",
      "loading": "އަލުން ހުޅުވުމުގެ އެދުންތައް ލޯޑުކުރަނީ…",
      "empty": "އެއްވެސް އަލުން ހުޅުވުމުގެ އެދުމެއް އިންތިޒާރެއް ނުކުރޭ.",
      "sessionRef": "ސެޝަން #{id}",
      "badge": "އަލުން ހުޅުވަން އެދިފައި",
      "pendingOnSession": "އަލުން ހުޅުވަން އެދިފައި؛ ދެވަނަ މީހަކަށް އިންތިޒާރުކުރަނީ"
    },
    "certificateHistory": {
      "title": "ސެޓްފިކެޓުގެ ތާރީޚު",
      "description": "މި ސެޝަނަށް ލިބިފައިވާ ހުރިހާ ސެޓްފިކެޓެއް. ސެޓްފިކެޓެއް ދުވަހަކުވެސް ބަދަލެއް ނުކުރެވޭނެ: އަލުން ހުޅުވުމުން އޭގެ ބަދަލުގައި އާ ސެޓްފިކެޓެއް ދޫކުރެވޭނެ.",
      "loadFailed": "ސެޓްފިކެޓުގެ ތާރީޚު ލޯޑެއް ނުކުރެވުނު",
      "empty": "މި ސެޝަން އަދި ސެޓްފައި ކުރެވިފައެއް ނުވޭ.",
      "current": "މިހާރުގެ",
      "supersededStatus": "ބަދަލުކުރެވިފައި",
      "superseded": "ބަދަލުކުރެވުނީ",
      "matchedSet": "މެޗްކުރެވުނު ސެޓް",
      "matchedSetValue": "{count} މެޗް، ހޭޝް {hash}",
      "lines": "{count} މެޗް | {count} މެޗް",
      "declineReason": "ރިޖެކްޓްކުރައްވާނަމަ، ސަބަބު",
      "reopenExcluded": "މި އަލުން ހުޅުވުމަށް ދެވަނަ މީހަކު ހުއްދަ ދޭންޖެހޭނެ. އެދުނު މީހާއާއި، ރިކޮންސިލިއޭޝަން ނިންމި މީހާއާއި، ސެޓްފައި ކުރި މީހާއަކަށް ނުކުރެވޭނެ.",
      "reopenRequestedBy": "އެދުނީ {name}، {at} ގައި.",
      "reopenReloaded": "ތިޔަބޭފުޅާ ބައްލަވަމުން ދަނިކޮށް މި އެދުން ބަދަލުވެއްޖެ. އަލުން ލޯޑުކޮށްފި؛ އަލުން ނިންމަވާ.",
      "column": "ސެޓްފިކެޓް",
      "certified": "ސެޓްފައި ކުރެވިފައި {no}",
      "notCertified": "ސެޓްފައި ނުކުރެވޭ"
    },
    "ruleApproval": {
      "view": "ދައްކާ",
      "viewAll": "ހުރިހާ ގަވާއިދެއް",
      "viewPending": "އެޕްރޫވަލަށް އިންތިޒާރުކުރާ",
      "formNote": "އާ ގަވާއިދެއް، ނުވަތަ އޭގެ އާ ވަރޝަނެއް ހިނގަނީ، ތިޔަބޭފުޅާ ނޫން މީހަކު ޕްރިވިއު ބައްލަވައި އެޕްރޫވް ކުރުމަށްފަހުގައި.",
      "savedPending": "އެހެން މީހަކު އެޕްރޫވް ކުރުމުން ހިނގާނެ.",
      "counterpartyPattern": "ފަރާތުގެ ނަމުގެ ޕެޓަރން",
      "state": {
        "pending": "އެޕްރޫވަލަށް އިންތިޒާރުކުރަނީ",
        "live": "ހިނގަމުންދާ",
        "declined": "ރިޖެކްޓްކުރެވިފި",
        "superseded": "ބަދަލުކުރެވިފައި",
        "inactive": "ހުއްޓާފައި"
      },
      "proposedFrom": "{count} ފަހަރު ތަކުރާރުކުރެވުނު އަތުން ކުރި މުއާމަލާތަކުން ސިސްޓަމުން ހުށަހެޅި | {count} ފަހަރު ތަކުރާރުކުރެވުނު އަތުން ކުރި މުއާމަލާތަކުން ސިސްޓަމުން ހުށަހެޅި",
      "previewLine": "ޕްރިވިއު: {examined} ލައިނުން {matched} ލައިން ހިމެނުނީސް",
      "approvedBy": "އެޕްރޫވް ކުރީ {name}",
      "ownRule": "މި ގަވާއިދު ހެއްދެވީ ތިޔަބޭފުޅާ ކަމުން، އެހެން މީހަކު އެޕްރޫވް ކުރަންޖެހޭނެ.",
      "needsAuto": "ބަލަހައްޓާ މީހަކު ނެތި ޕޯސްޓްކުރާ ގަވާއިދެއް އެޕްރޫވް ކުރުމަށް، އެކަމުގެ ހުއްދަ ބޭނުންވޭ.",
      "approve": "އެޕްރޫވް ކުރޭ",
      "decline": "ރިޖެކްޓްކުރޭ",
      "approveTitle": "ގަވާއިދު {code} އެޕްރޫވް ކުރުން",
      "declineTitle": "ގަވާއިދު {code} ރިޖެކްޓްކުރުން",
      "approveDescription": "ގަވާއިދު ހިނގައި، ޕްރިވިއުގައި ދެއްކި ގޮތަށް ސްޓޭޓްމަންޓް ލައިންތައް ހިންގަން ފަށާނެ.",
      "declineDescription": "ގަވާއިދު ރެކޯޑުގައި ހުންނާނެ، ނަމަވެސް ދުވަހަކުވެސް ނުހިނގާނެ. ރިޖެކްޓްކުރެވުނު ހުށަހެޅުމެއް އަލުން ހުށަނާޅާނެ.",
      "previewOnApprove": "މި ގަވާއިދަށް އަދި ޕްރިވިއުއެއް ނެތް. އެޕްރޫވް ކުރާއިރު ކަނޑައަޅާފައިވާ މުއްދަތަށް ޕްރިވިއުއެއް ނަގައި، އެޕްރޫވަލާއެކު ރެކޯޑުކުރެވޭނެ.",
      "proposedNote": "މި ގަވާއިދު ހުށަހެޅުނީ ތަކުރާރުކުރެވުނު އަތުން ކުރި މުއާމަލާތަކުން. އެ މުއާމަލާތް ކުރި އެއްވެސް މީހަކަށް މި ގަވާއިދު އެޕްރޫވް ނުކުރެވޭނެ.",
      "approveNote": "ނޯޓް (އިޚްތިޔާރީ)",
      "declineReason": "ރިޖެކްޓްކުރަނީ ކީއްވެ؟",
      "approved": "ގަވާއިދު {code} އެޕްރޫވްކޮށް ހިނގަމުންދަނީ",
      "declined": "ގަވާއިދު {code} ރިޖެކްޓްކުރެވިފި",
      "reloaded": "ތިޔަބޭފުޅާ މަސައްކަތްކުރައްވަމުން ދަނިކޮށް މި ގަވާއިދު ބަދަލުވެއްޖެ. އަލުން ލޯޑުކޮށްފި؛ ބައްލަވައި އަލުން ނިންމަވާ.",
      "sodRefused": "ތިޔަބޭފުޅާއަށް މި ގަވާއިދު އެޕްރޫވް ނުކުރެވޭނެ.",
      "emptyPendingTitle": "އެޕްރޫވަލަށް އިންތިޒާރުކުރާ އެއްވެސް އެއްޗެއް ނެތް",
      "emptyPendingDescription": "އާ ގަވާއިދުތަކާއި، ބަދަލު ވަރޝަންތަކާއި، ތަކުރާރު މުއާމަލާތުން ސިސްޓަމުން ހުށަހަޅާ ގަވާއިދުތައް ދެވަނަ މީހަކަށް މިތާނގައި އިންތިޒާރުކުރާނެ."
    },
    "queue": {
      "continuity_break": "ބޭންކް ސްޓޭޓްމަންޓްގެ ކޮންޓިނިއުޓީ ބްރޭކްތައް"
    }
  },
  "assets": {
    "filtersTitle": "ފިލްޓަރތައް",
    "allCompanies": "ހުރިހާ ކުންފުނިތައް",
    "months": "{count} މަސް",
    "routeTitles": {
      "classes": "އެސެޓް ކްލާސްތައް",
      "register": "ފިކްސްޑް އެސެޓް ރަޖިސްޓްރީ",
      "asset": "ފިކްސްޑް އެސެޓް",
      "acquire": "ހޯދާ އެސެޓް",
      "capitalize": "ކެޕިޓަލައިޒްކުރޭ އިންވޮއިސް ސަޠުރު",
      "depreciation": "ޑިޕްރިސިއޭޝަން ރަންތައް",
      "movement": "އެސެޓް މޫވްމަންޓް",
      "books": "ޑިޕްރިސިއޭޝަން ފޮތްތައް",
      "componentise": "ބައިބަޔަށް ބަހާ",
      "impairments": "އިމްޕެއަރމަންޓް",
      "verifications": "ފިޒިކަލް ވެރިފިކޭޝަން",
      "verification": "ގުނުމުގެ ޝީޓް",
      "bookComparison": "ފޮތްތަކުގެ އަޅާކިޔުން",
      "capexVsBudget": "ބަޖެޓާ އަޅާބަލާއިރު ކެޕިޓަލް ޚަރަދު",
      "depreciationForecast": "ޑިޕްރިސިއޭޝަންގެ ލަފާކުރުން",
      "depreciationPreview": "ޑިޕްރިސިއޭޝަންގެ ކުރިން ބެލުން",
      "disposals": "ނައްތާލުންތައް",
      "icTransfer": "ކުންފުނިތަކުގެ ދެމެދު ބަދަލުކުރުން",
      "settings": "މުދަލުގެ ސެޓިންގްސް"
    },
    "fields": {
      "company": "ކުންފުނި",
      "companyPlaceholder": "ޚިޔާރުކުރޭ ކުންފުނި",
      "class": "އެސެޓް ކްލާސް",
      "classPlaceholder": "ޚިޔާރުކުރޭ ކްލާސް",
      "accountPlaceholder": "ޚިޔާރުކުރޭ ހިސާބު",
      "none": "ނެތް",
      "method": "ގޮތް",
      "life": "ބޭނުންކުރެވޭ މުއްދަތު",
      "cost": "އަގު",
      "salvage": "ސެލްވޭޖް އަގު",
      "accumulated": "ޖަމާވެފައިވާ ޑިޕްރިސިއޭޝަން",
      "nbv": "ސާފު ފޮތުގެ އަގު",
      "location": "ތަން",
      "custodian": "ބަލަހައްޓާ ފަރާތް",
      "branch": "ގޮފި",
      "costCenter": "ކޮސްޓް ސެންޓަރ",
      "inServiceDate": "ބޭނުންކުރަން ފެށީ",
      "disposalDate": "ނައްތާލި ތާރީޚު",
      "periodsDepreciated": "ޗާޖްކުރެވުނު މުއްދަތުތައް",
      "reason": "ސަބަބު",
      "from": "އިން",
      "to": "އަށް"
    },
    "methods": {
      "SL": "ސީދާ ރޮނގު",
      "SLHint": "ކޮންމެ މުއްދަތެއްގައި އެއް އަދަދެއް",
      "DB": "ދަށްވަމުންދާ ބެލެންސް",
      "DBHint": "ދަށްވަމުންދާ އަގުގެ ސާބިތު ރޭޓެއް",
      "SYD": "އަހަރުތަކުގެ ޖުމްލަ",
      "SYDHint": "ފުރަތަމަ އަހަރުތަކުގައި ބޮޑަށް، ބާކީ އަހަރުތަކުން ބަރުދަން ދީގެން",
      "UOP": "އުފެއްދުމުގެ ޔުނިޓް",
      "UOPHint": "ވަގުތުގެ ބަދަލުގައި ބޭނުންކުރި މިންވަރުން"
    },
    "status": {
      "in_service": "ބޭނުންކުރަނީ",
      "disposed": "ނައްތާލެވިފައި"
    },
    "notDepreciating": {
      "disposed": "ނައްތާލެވިފައި",
      "lifeExhausted": "މުއްދަތު ހަމަވެއްޖެ",
      "fullyDepreciated": "ފުރިހަމައަށް ޑިޕްރިސިއޭޓްކުރެވިއްޖެ"
    },
    "periodStatus": {
      "open": "ހުޅުވިފައި",
      "soft_closed": "މަޑުން ބަންދުކުރެވިފައި",
      "closed": "ބަންދުކުރެވިފައި"
    },
    "apStatus": {
      "draft": "ދެލިކޮޕީ",
      "submitted": "ހުށަހަޅާފައި",
      "approved": "ފާސްކުރެވިފައި",
      "rejected": "ބޭރުކުރެވިފައި",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "paid": "ދައްކާފައި",
      "cancelled": "ބާޠިލްކުރެވިފައި",
      "reversed": "ރިވާސްކުރެވިފައި"
    },
    "accountTypes": {
      "ASSET": "އެސެޓް",
      "LIABILITY": "ދަރަނި",
      "EQUITY": "އިކުއިޓީ",
      "INCOME": "އާމްދަނީ",
      "EXPENSE": "ޚަރަދު"
    },
    "errors": {
      "periodClosed": "ތާރީޚު ވެއްޓޭ ބަންދުކުރެވިފައި ހިސާބުކުރުމުގެ މުއްދަތު, އެއްވެސް އެއްޗެއް ޕޯސްޓްކުރެވިފައި. އަލުން ހުޅުވާ މުއްދަތު, ޚިޔާރުކުރޭ ތާރީޚު ތެރޭގައި ހުޅުވިފައި."
    },
    "classes": {
      "title": "އެސެޓް ކްލާސްތައް",
      "description": "ޓެމްޕްލޭޓް އެސެޓް ކޮޕީކުރެއެވެ ގައި ހޯދުން: ގޮތް, ޑިފޯލްޓް މުއްދަތު ސެލްވޭޖް, ހަތަރު ލެޖަރ ހިސާބުތައް ދިމާކުރޭ އާ ދެކޮޅަށް ބާކީ މުއްދަތު.",
      "permanenceNote": "ކްލާސް ފޮހެލެވިފައި އެއްފަހަރު އެސެޓް ބޭނުންކުރެވިފައި — ޑިޕްރިސިއޭޝަން ލެޖަރ މޫވްމަންޓް ރިޕޯޓް ގްރޫޕްކުރެއެވެ. ބޭނުންކުރުން ހުއްޓާލާ ބަދަލުގައި: ހަރަކާތްތެރި ނޫން ކްލާސް ހުއްޓުވައެވެ ވުން ހުށަހެޅޭ އައު އެސެޓްތައް ދޫކޮށްލައެވެ ޕޯސްޓްކުރެވިފައި އަދަދު ސަލާމަތުން.",
      "tableLabel": "އެސެޓް ކްލާސްތައް",
      "searchHint": "ކޯޑް ނަން",
      "loadFailed": "އެސެޓް ކްލާސްތައް ވެދާނެ ލޯޑްކުރެވުނު",
      "emptyTitle": "އެސެޓް ކްލާސްތައް",
      "emptyDescription": "އުފައްދާ އާއިލާ އެސެޓްތައް ޑިޕްރިސިއޭޓްކުރޭ — އުޅަނދުތައް, ސާމާނު, ފަރުނީޗަރު. ނަންދެއެވެ ގޮތް, ޑިފޯލްޓް މުއްދަތު, ހަތަރު ހިސާބުތައް އެސެޓްތައް ޕޯސްޓްކުރޭ އަށް.",
      "newTitle": "އައު އެސެޓް ކްލާސް",
      "newDescription": "ހިސާބުތައް ޚިޔާރުކުރެވުނު ކޮޕީކުރެވިފައި އެސެޓް ހޯދިފައި އާ ދެކޮޅަށް ކްލާސް, ފިކްސްޑް އެއްފަހަރު ކްލާސް އޮވެއެވެ.",
      "editTitle": "އުނިއިތުރު އެސެޓް ކްލާސް",
      "editDescription": "ޑިފޯލްޓްތައް ބޭނުންކުރޭ އަށް އެސެޓްތައް ހޯދިފައި އިން. އެސެޓްތައް ރަޖިސްޓްރީ ބަހައްޓާ ޝެޑިއުލް ހިސާބުތައް ރަޖިސްޓްރީކުރެވިފައި.",
      "created": "އެސެޓް ކްލާސް އުފެއްދިއްޖެ",
      "updated": "އެސެޓް ކްލާސް އަޕްޑޭޓްކުރެވިއްޖެ",
      "saveFailed": "އެސެޓް ކްލާސް ވެދާނެ ރައްކާކުރެވިއްޖެ",
      "active": "ހަރަކާތްތެރި",
      "retired": "ބޭނުންކުރުން ހުއްޓާލާފައި",
      "accountById": "ހިސާބު #{id}",
      "noAccounts": "ކުންފުނި ޕޯސްޓްކުރެވޭ ހިސާބުތައް. ބިނާކުރޭ ހިސާބުތަކުގެ ޗާޓް ފުރަތަމަ — ކްލާސް ހުރެއެވެ ނެތި ހަތަރު ހިސާބުތައް އެސެޓްތައް ޕޯސްޓްކުރޭ އަށް.",
      "accountsNote": "ހަތަރު ހިސާބުތައް, ސީދާ §8.8 ނަންދެއެވެ. އަގު އަލުން ކަނޑައެޅުން ޕޯސްޓްކުރޭ މެދުވެރިކޮށް ފައިދާ ނުވަތަ ގެއްލުން ހިސާބު ނައްތާލުން; ވަކި އަގު އަލުން ކަނޑައެޅުން ރިޒާވް.",
      "retireNote": "ބޭނުންކުރުން ހުއްޓާލުން ކްލާސް ހުއްޓުވައެވެ ވުން ހުށަހެޅޭ އައު އެސެޓްތައް. އެސެޓް ރަޖިސްޓްރީކުރެވިފައި އާ ދެކޮޅަށް ބަހައްޓައެވެ ޑިޕްރިސިއޭޓްވަނީ, އަދަދުތައް ދެމިހުރެއެވެ މޫވްމަންޓް ރިޕޯޓް.",
      "columns": {
        "code": "ކޯޑް",
        "life": "މުއްދަތު",
        "salvage": "ސެލްވޭޖް",
        "assetAccount": "އެސެޓް",
        "accumulatedAccount": "ޖަމާވި. ޑިޕް.",
        "expenseAccount": "ޚަރަދު",
        "gainLossAccount": "ފައިދާ / ގެއްލުން"
      },
      "fields": {
        "code": "ކޯޑް",
        "codeHint": "ކުރު އަދި ދާއިމީ، މިސާލަކަށް VEH ނުވަތަ IT-EQ",
        "codeFixed": "ފިކްސްޑް އެއްފަހަރު ކްލާސް އޮވެއެވެ",
        "methodHint": "އެސެޓްތައް ވެދާނެ އޯވަރައިޑްކުރޭ",
        "life": "ޑިފޯލްޓް ބޭނުންކުރެވޭ މުއްދަތު (މަސް)",
        "lifeHint": "60 މަސް ފަހެއް އަހަރު",
        "salvagePercent": "ޑިފޯލްޓް ސެލްވޭޖް (%)",
        "salvagePercentHint": "ނިމުމުގައި ބާކީވާނެ ކޮސްޓްގެ އިންސައްތަ. 10% އަށް 10 ލިޔުއްވާ.",
        "salvagePercentRange": "އިންސައްތަ 0 އާއި 100 އާ ދެމެދު ހުންނަންވާނެއެވެ.",
        "assetAccount": "އެސެޓް ހިސާބު",
        "assetAccountHint": "އަގު އިންނަ ބެލެންސް ޝީޓް",
        "accumulatedAccount": "ޖަމާވެފައިވާ ޑިޕްރިސިއޭޝަން ހިސާބު",
        "accumulatedAccountHint": "ކޮންޓްރާ ހިސާބު ކްރެޑިޓްކުރެވޭ ޑިޕްރިސިއޭޝަން ޗާޖް",
        "expenseAccount": "ޑިޕްރިސިއޭޝަން ޚަރަދު ހިސާބު",
        "expenseAccountHint": "ޑެބިޓްކުރެވޭ ޑިޕްރިސިއޭޝަން ޗާޖް",
        "gainLossAccount": "ފައިދާ ނުވަތަ ގެއްލުން ނައްތާލުން ހިސާބު",
        "gainLossAccountHint": "އުފުލައެވެ އަގު އަލުން ކަނޑައެޅުން އެޑްޖަސްޓްމަންޓް",
        "active": "ލިބެންހުރިކަން",
        "activeHint": "ހަރަކާތްތެރި ކްލާސްތައް ހުށަހެޅޭ އައު އެސެޓްތައް",
        "activeToggle": "ލިބެންހުރި އައު އެސެޓްތައް"
      }
    },
    "register": {
      "title": "ފިކްސްޑް އެސެޓް ރަޖިސްޓްރީ",
      "description": "އެސެޓް ފޮތްތައް: އަގު, ޗާޖްކުރެވިފައި އާ ދެކޮޅަށް, ބާކީ.",
      "tableLabel": "ފިކްސްޑް އެސެޓް ރަޖިސްޓްރީ",
      "searchHint": "އެސެޓް ނަންބަރު ނަން",
      "narrowedHere": "ހަނިކުރެވިފައި އިން ލޯޑްކުރެވުނު ރަޖިސްޓްރީ",
      "loadFailed": "ރަޖިސްޓްރީ ވެދާނެ ލޯޑްކުރެވުނު",
      "emptyTitle": "ފިކްސްޑް އެސެޓްތައް",
      "emptyDescription": "ރަޖިސްޓްރީ އަމިއްލައަށް, ކެޕިޓަލައިޒްކުރޭ ސަޠުރު ސަޕްލަޔަރ އިންވޮއިސް ޕޯސްޓްކުރެވިފައި — ދެވަނަ މަގު އިތުރުކުރެއެވެ ޖާނަލް, ފައިސާ ފޮތްތައް.",
      "classById": "ކްލާސް #{id}",
      "truncated": "ދައްކަނީ ފުރަތަމަ {count} އެސެޓްތައް. ތަން ބަލަހައްޓާ ފަރާތް ފިލްޓަރތައް ބައްލަވާ, ހަނިކުރޭ ކުންފުނި ކްލާސް ފުރަތަމަ ހޯދަނީ އެއްޗެއް.",
      "exported": "އެކްސްޕޯޓްކުރެވިއްޖެ {count} އެސެޓްތައް",
      "columns": {
        "assetNo": "އެސެޓް."
      }
    },
    "detail": {
      "loadFailed": "އެސެޓް ވެދާނެ ލޯޑްކުރެވުނު",
      "factsPanel": "އެސެޓް",
      "journalsPanel": "ޖާނަލްތައް",
      "journalsDescription": "އެސެޓް ޕޯސްޓްކުރެވިފައި ސީދާ — ހޯދުން, އަގު އަލުން ކަނޑައެޅުން, ނައްތާލުން.",
      "noJournals": "އެއްވެސް އެއްޗެއް ޕޯސްޓްކުރެވިފައި އާ ދެކޮޅަށް އެސެޓް.",
      "depreciationJournalsElsewhere": "ޑިޕްރިސިއޭޝަން ޖާނަލްތައް ލިސްޓްކުރެވިފައި. ރަން ޕޯސްޓްކުރޭ ޖާނަލް ހިމަނައިގެން އެސެޓް ޗާޖްކުރެވިފައި, ޖާނަލްތައް ނިސްބަތްވެއެވެ އަށް ރަން އަށް އެސެޓް — ބައްލަވާ ޑިޕްރިސިއޭޝަން ރަންތައް ސްކްރީން.",
      "capitalizedBadge": "ކެޕިޓަލައިޒްކުރެވިފައި",
      "capitalizedNoJournal": "އެސެޓް ކެޕިޓަލައިޒްކުރެވިފައި އިން ޕޯސްޓްކުރެވިފައި ސަޕްލަޔަރ އިންވޮއިސް ސަޠުރު, ހޯދުން ޖާނަލް: އަގު ހަމަވެއްޖެ ލެޖަރ އިންވޮއިސް ޕޯސްޓްކުރެވިފައި.",
      "sourceLine": "ސަޕްލަޔަރ އިންވޮއިސް ސަޠުރު #{id}",
      "acquisitionJournal": "ހޯދުން ޖާނަލް",
      "journalById": "ޖާނަލް #{id}",
      "classLink": "އެސެޓް ކްލާސްތައް",
      "registered": "ރަޖިސްޓްރީކުރެވިފައި",
      "inService": "ޚިދުމަތް",
      "disposedOn": "ނައްތާލެވިފައި",
      "backToRegister": "ފިކްސްޑް އެސެޓްތައް",
      "saved": "އެސެޓް އަޕްޑޭޓްކުރެވިއްޖެ",
      "saveFailed": "ބަދަލު ވެދާނެ ރައްކާކުރެވިއްޖެ"
    },
    "schedule": {
      "title": "ހިސާބުކުރެވުނު",
      "description": "ޤަވާޢިދު, އިންޕުޓްތައް, އަދަދުތައް ސާވަރު ހިސާބުކުރެވިފައި އިން.",
      "ruleSl": "ސީދާ ރޮނގު: (އަގު − ސެލްވޭޖް) ÷ {life} މަސް, އަދަދު މުއްދަތު, ފަހު ޗާޖްކުރެވޭ މުއްދަތު ހިމަނައިގެން ރައުންޑިންގ ބާކީ ޖަމާވެފައިވާ ޑިޕްރިސިއޭޝަން ޖެހޭ ސީދާ އަގު − ސެލްވޭޖް.",
      "ruleDb": "ދަށްވަމުންދާ ބެލެންސް: {rate} ސާފު ފޮތުގެ އަގު މުއްދަތު — 2 ÷ {life} މަސް — ދަށްވަމުންދާ ފޮތް އަގު ވެއްޓޭ, ހިފެހެއްޓިފައި ދުވަހަކުވެސް ނުވާނެ ގެންދެއެވެ އެސެޓް ދަށަށް ސެލްވޭޖް އަގު.",
      "depreciableBase": "ޑިޕްރިސިއޭޓްކުރެވޭ އަސާސް (އަގު − ސެލްވޭޖް)",
      "monthlyRate": "މަހުން މަހަށް ރޭޓް (2 ÷ މުއްދަތު)",
      "ofPeriods": "{done} {total}",
      "remainingBase": "އަށް ޗާޖް",
      "remainingPeriods": "މުއްދަތުތައް ބާކީ",
      "progressLabel": "ބޭނުންކުރެވޭ މުއްދަތު ބޭނުންކުރެވުނު",
      "progressCaption": "{done} {total} މުއްދަތުތައް ޗާޖްކުރެވިފައި",
      "stillCharging": "ދެން ޑިޕްރިސިއޭޝަން ރަން ކުންފުނި ޗާޖް އެސެޓް.",
      "stopped": {
        "disposed": "އެސެޓް ނައްތާލެވިފައި, ބާކީކުރެވިފައި އިން ކުރިއަށް އޮތް ރަން. ނޯޓު ނައްތާލުން ޗާޖް މުއްދަތު ހިނގި — ކޮންމެ އެއްޗެއް ފަހު ފުރިހަމަކުރެވުނު ރަން ޗާޖްކުރެވިފައި.",
        "lifeExhausted": "ބޭނުންކުރެވޭ މުއްދަތު ބޭނުންކުރެވިފައި. މުއްދަތު ކައުންޓަރ ހަމަވެއްޖެ އެސެޓް'ގެ މުއްދަތު މަސް, ކުރިއަށް އޮތް ރަން ޗާޖް, ނަމަވެސް ފޮތް އަގު ބާކީ ހުރެއެވެ — ދަށްވަމުންދާ ބެލެންސް ޝެޑިއުލް އާންމުކޮށް ދޫކޮށްލައެވެ ބާކީ, ނައްތާލުން ޙައްލުކުރެއެވެ.",
        "fullyDepreciated": "އެއްވެސް އެއްޗެއް ބާކީ އަށް ޗާޖް: ޖަމާވެފައިވާ ޑިޕްރިސިއޭޝަން ހަމަވެއްޖެ އަގު މައިނަސް ސެލްވޭޖް."
      },
      "noPeriodTable": "ޗާޖްތައް ދައްކާފައި ޖުމްލަތައް މުއްދަތު މުއްދަތު. ވަކިވަކި އެންޓްރީތައް ދިރިހުރި ތާވަލު އޭޕީއައި ދައްކައެއް ނުދޭ, ޑިޕްރިސިއޭޝަން ޖާނަލްތައް އުފުލާ ޕޯސްޓްކުރެވިފައި ރަން — ހިމަނައިގެން ބެޗް އެސެޓްތައް — ކުއެރީ ގެންދާ އިން އެސެޓް އަށް ޗާޖްތައް.",
      "noProjection": "ކުރިއަށް ލަފާކުރުން ކުރަހާފައި ދެގޮތުންވެސް. ބާކީ ޝެޑިއުލް ހިސާބުކުރެވިފައި ސާވަރު ސީދާ ޑެސިމަލްތައް, ކޮމްޕައުންޑްވަމުން ފޮތް އަގު ދަށްވަމުންދާ ބެލެންސް ހިފެހެއްޓުން ފަހު މުއްދަތު ޖަމާވެފައިވާ ޑިޕްރިސިއޭޝަން ޖެހޭ ސީދާ އަގު މައިނަސް ސެލްވޭޖް; އަލުން ހިސާބުކުރުން ދެވަނަ ޖަވާބު އަށް ސުވާލު ސާވަރު ވެދާނެ ޖަވާބު, ފުރަތަމަ ލާރި ތަފާތުވުން ފެންނާނެ ސީދާ ފަދަ ޕޯސްޓިންގ ކުށް."
    },
    "acquire": {
      "action": "ހޯދާ އެސެޓް",
      "title": "ހޯދާ އެސެޓް",
      "description": "ރަޖިސްޓްރީ އެސެޓް ޕޯސްޓްކުރޭ ހޯދުން ފިޔަވަޅު.",
      "orCapitalize": "ކެޕިޓަލައިޒްކުރޭ އިންވޮއިސް ސަޠުރު ބަދަލުގައި",
      "postsImmediately": "ދެލިކޮޕީ. ހުށަހެޅުން ޕޯސްޓްކުރޭ ހޯދުން ޖާނަލް — ޑެބިޓް ކްލާސް'ގެ އެސެޓް ހިސާބު, ކްރެޑިޓް ހިސާބު ނަން — ތާރީޚުކުރެވިފައި ބޭނުންކުރަން ފެށި ތާރީޚު. ބަންދުކުރެވިފައި މުއްދަތު ބަލައެއް ނުގަނެވޭ.",
      "identityPanel": "މިއީ ކޮން އެއްޗެއް",
      "postingPanel": "އަގު, ދައްކާފައި",
      "postingDescription": "ކްރެޑިޓް ފަރާތް ދުވަހަކުވެސް ނުވާނެ ބެލެވޭ: ނަން ބޭންކް, ފައިސާ ދައްކަންޖެހޭ ހިސާބު ފައިސާ ބާކީ.",
      "schedulePanel": "ޑިޕްރިސިއޭޓްކުރޭ",
      "scheduleDescription": "ހުސްކޮށް މާނައަކީ ކްލާސް ޑިފޯލްޓް. ކޮންމެ އެއްޗެއް ރައްކާކުރެވިއްޖެ ކޮޕީކުރެވިފައި އެސެޓް, އުނިއިތުރުކުރުން ކްލާސް ފަހުން ދުވަހަކުވެސް ނުވާނެ ބަދަލުތައް.",
      "fromClass": "އިން ކްލާސް",
      "classHint": "{method}, {months} މަސް",
      "submit": "ރަޖިސްޓްރީ ޕޯސްޓްކުރޭ",
      "posting": "ޕޯސްޓިންގ",
      "done": "އެސެޓް ރަޖިސްޓްރީކުރެވިފައި",
      "doneDetail": "{assetNo} ރަޖިސްޓްރީ ހޯދުން ޕޯސްޓްކުރެވިފައި.",
      "failed": "އެސެޓް ވެދާނެ ރަޖިސްޓްރީކުރެވިފައި",
      "fields": {
        "classHint": "ކަނޑައަޅައެވެ ހިސާބުތައް ޑިފޯލްޓް ޝެޑިއުލް",
        "creditAccount": "ކްރެޑިޓް ހިސާބު",
        "creditAccountHint": "ބޭންކް, ފައިސާ ދައްކަންޖެހޭ ހިސާބު ފައިސާ އައި އިން",
        "inServiceHint": "ޖާނަލް ތާރީޚުކުރެވިފައި ދުވަސް, ޑިޕްރިސިއޭޝަން ފަށައެވެ އިން",
        "lifeHint": "މަސް. ހުސްކޮށް ބޭނުންކުރެއެވެ ކްލާސް ޑިފޯލްޓް.",
        "salvageHint": "ހުސްކޮށް ބޭނުންކުރެއެވެ ކްލާސް ޑިފޯލްޓް އިންސައްތަ އަގު",
        "memo": "ނޯޓު"
      }
    },
    "capitalize": {
      "action": "ކެޕިޓަލައިޒްކުރޭ އިންވޮއިސް ސަޠުރު",
      "title": "ކެޕިޓަލައިޒްކުރޭ ސަޕްލަޔަރ އިންވޮއިސް ސަޠުރު",
      "description": "ބަދަލުކުރޭ ސަޠުރު ޕޯސްޓްކުރެވިފައި ސަޕްލަޔަރ އިންވޮއިސް އެސެޓް ރަޖިސްޓްރީ.",
      "orManual": "ހޯދާ އަމިއްލައަށް ބަދަލުގައި",
      "postsNothing": "ޕޯސްޓްކުރޭ އެއްވެސް އެއްޗެއް. ފައިސާ ހަމަވެއްޖެ ލެޖަރ އިންވޮއިސް ޕޯސްޓްކުރެވިފައި, ރަޖިސްޓްރީކުރުން އެސެޓް ފަށައެވެ ޑިޕްރިސިއޭޝަން ގަޑި އަގު ފޮތްތައް.",
      "accountFromLine": "އެސެޓް'ގެ އެސެޓް ހިސާބު ނަގާފައި އިން އިންވޮއިސް ސަޠުރު, އިން ކްލާސް ޑިފޯލްޓް, ދިމާވެއެވެ އާ ދެކޮޅަށް ހިސާބު ފައިސާ ޙަޤީޤަތުގައި ޖެހުނު.",
      "invoicePanel": "އިންވޮއިސް",
      "invoiceDescription": "ޕޯސްޓްކުރެވިފައި ދައްކާފައި ސަޕްލަޔަރ އިންވޮއިސްތައް. ރިވާސްކުރެވިފައި އިންވޮއިސް އިތުރަށް އުފުލައެވެ ދިރިހުރި ޕޯސްޓިންގ އަށް ކެޕިޓަލައިޒްކުރޭ އާ ދެކޮޅަށް.",
      "searchHint": "އިންވޮއިސް ނަންބަރު ސަޕްލަޔަރ",
      "invoicesFailed": "އިންވޮއިސްތައް ވެދާނެ ލޯޑްކުރެވުނު",
      "linesPanel": "ސަޠުރު",
      "linesDescription": "ސަޠުރު ވެއެވެ އެސެޓް. ސަޠުރު އެސެޓް ވުން ދެވަނަ.",
      "assetPanel": "އެސެޓް",
      "assetDescription": "ޑިފޯލްޓްތައް އާދޭ އިން ސަޠުރު ކްލާސް; ބަދަލު ރަޖިސްޓްރީކުރުން.",
      "tableCaption": "ސަޠުރުތައް ޚިޔާރުކުރެވުނު ސަޕްލަޔަރ އިންވޮއިސް, ތޯ ލިބެންހުރި އަށް ކެޕިޓަލައިޒްކުރޭ",
      "chooseLine": "ޚިޔާރުކުރޭ",
      "chooseLineNo": "ކެޕިޓަލައިޒްކުރޭ ސަޠުރު {line}",
      "lineTakenLabel": "ސަޠުރު {line} އެސެޓް {assetNo}",
      "lineAvailable": "ލިބެންހުރި",
      "lineTaken": "އެސެޓް",
      "noLines": "އިންވޮއިސް ސަޠުރުތައް.",
      "allTaken": "ސަޠުރު އިންވޮއިސް އެސެޓް. އެއްވެސް އެއްޗެއް ބާކީ އަށް ކެޕިޓަލައިޒްކުރޭ.",
      "indexTruncated": "އެސެޓްތައް ހުރެއެވެ ވެދާނެ ބެލެވުނު ފަހަރު, ސަޠުރު ދައްކާފައި ލިބެންހުރި ވެދާނެ ނަގާފައި. ސާވަރު ބަލައެއް ނުގަނެވޭ ޑުޕްލިކޭޓް ދެގޮތުންވެސް ގޮތް.",
      "submit": "ރަޖިސްޓްރީ އެސެޓް",
      "done": "އެސެޓް ރަޖިސްޓްރީކުރެވިފައި",
      "doneDetail": "{assetNo} ރަޖިސްޓްރީ. ޖާނަލް ޕޯސްޓްކުރެވިފައި — އަގު ލެޖަރ.",
      "failed": "އެސެޓް ވެދާނެ ރަޖިސްޓްރީކުރެވިފައި",
      "raceLost": "މީހަކު ރަޖިސްޓްރީކުރެވިފައި އެސެޓް އާ ދެކޮޅަށް ސަޠުރު ދަނިކޮށް ފޯމު ހުޅުވިފައި. ލިސްޓް އާކުރެވިއްޖެ; ސަޠުރު ދައްކައެވެ އެސެޓް ވި.",
      "columns": {
        "line": "ސަޠުރު",
        "account": "ހިސާބު",
        "amount": "އަދަދު"
      },
      "fields": {
        "invoice": "ސަޕްލަޔަރ އިންވޮއިސް",
        "invoiceHint": "ޕޯސްޓްކުރެވިފައި ދައްކާފައި އިންވޮއިސްތައް އުފުލާ ޕޯސްޓިންގ އަށް ކެޕިޓަލައިޒްކުރޭ",
        "invoicePlaceholder": "ޚިޔާރުކުރޭ އިންވޮއިސް",
        "costHint": "ހުސްކޮށް ބޭނުންކުރެއެވެ ސަޠުރު އަދަދު",
        "inServiceHint": "ހުސްކޮށް ބޭނުންކުރެއެވެ އިންވޮއިސް ތާރީޚު"
      }
    },
    "relocate": {
      "action": "ބަދަލުކުރޭ",
      "title": "ބަދަލުކުރޭ {assetNo}",
      "description": "ބަދަލު އެސެޓް, ހިފަހައްޓައެވެ, ބައިތައް ކުރިއަށް އޮތް ޗާޖްތައް އުފުލާ.",
      "noPosting": "ޕޯސްޓްކުރޭ އެއްވެސް އެއްޗެއް — ފިކްސްޑް އެސެޓް'ގެ ލެޖަރ ހިސާބުތައް ބަދަލުކުރޭ. ރެކޯޑްކުރޭ ބެލެހެއްޓުން, އޮޑިޓް ޓްރެއިލް.",
      "done": "އެސެޓް ބަދަލުކުރެވިއްޖެ",
      "doneDetail": "{assetNo} އަޕްޑޭޓްކުރެވިއްޖެ.",
      "failed": "ބަދަލުކުރޭ ވެދާނެ ރެކޯޑްކުރެވިފައި",
      "fields": {
        "dimensionHint": "ހިނގައެވެ އަށް ޗާޖްތައް ޕޯސްޓްކުރެވިފައި އިން",
        "reasonHint": "ރެކޯޑްކުރެވިފައި އޮޑިޓް ޓްރެއިލް"
      }
    },
    "revalue": {
      "action": "އަގު އަލުން ކަނޑައަޅާ",
      "title": "އަގު އަލުން ކަނޑައަޅާ {assetNo}",
      "description": "ބަދަލު އަގު, ބޭނުންކުރެވޭ މުއްދަތު ސެލްވޭޖް އަގު.",
      "currentCost": "މިހާރުގެ އަގު",
      "currentSalvage": "މިހާރުގެ ސެލްވޭޖް އަގު",
      "currentLife": "މިހާރުގެ ބޭނުންކުރެވޭ މުއްދަތު",
      "postsNote": "ބަދަލުކުރުން އަގު ޕޯސްޓްކުރޭ ތަފާތު އާ ދެކޮޅަށް ކްލާސް'ގެ ފައިދާ ނުވަތަ ގެއްލުން ހިސާބު, ތާރީޚުކުރެވިފައި ދުވަސް ނަން. ބަންދުކުރެވިފައި މުއްދަތު ބަލައެއް ނުގަނެވޭ.",
      "prospectiveNote": "ބަދަލުކުރުން ބޭނުންކުރެވޭ މުއްދަތު ސެލްވޭޖް އަގު ޕޯސްޓްކުރޭ އެއްވެސް އެއްޗެއް. މުއްދަތުތައް ޗާޖްކުރެވިފައި ދެމިހުރެއެވެ ސީދާ ޗާޖްކުރެވިފައި; އައު އަދަދުތައް ބޭނުންކުރޭ އިން ދެން ރަން ފެށިގެން ކުރިއަށް.",
      "done": "އެސެޓް އަގު އަލުން ކަނޑައެޅިއްޖެ",
      "doneDetail": "{assetNo} އަގު އަލުން ކަނޑައެޅިއްޖެ.",
      "failed": "އަގު އަލުން ކަނޑައެޅުން ވެދާނެ ޕޯސްޓްކުރެވިފައި",
      "fields": {
        "on": "ފެށޭ ތާރީޚު",
        "onHint": "އަގު ބަދަލު ތާރީޚުކުރެވިފައި ދުވަސް ޖެހޭ މުއްދަތު",
        "newCost": "އައު އަގު",
        "newCostHint": "ދޫކޮށްލާ ހުސްކޮށް އަށް ބަހައްޓާ މިހާރުގެ އަގު",
        "newSalvage": "އައު ސެލްވޭޖް އަގު",
        "newSalvageHint": "ދޫކޮށްލާ ހުސްކޮށް އަށް ބަހައްޓާ މިހާރުގެ ސެލްވޭޖް އަގު",
        "newLife": "އައު ބޭނުންކުރެވޭ މުއްދަތު (މަސް)",
        "newLifeHint": "ދޫކޮށްލާ ހުސްކޮށް އަށް ބަހައްޓާ މިހާރުގެ މުއްދަތު",
        "reasonHint": "ރެކޯޑްކުރެވިފައި އޮޑިޓް ޓްރެއިލް ޖާނަލް"
      }
    },
    "dispose": {
      "action": "ނައްތާލާ",
      "title": "ނައްތާލާ {assetNo}",
      "description": "ފޮތުން ނަގާ އަގު ޖަމާވެފައިވާ ޑިޕްރިސިއޭޝަން, ޕޯސްޓްކުރޭ ފައިދާ ނުވަތަ ގެއްލުން އާ ދެކޮޅަށް ލިބުނު ފައިސާ.",
      "carryingAmount": "ފޮތުގައިވާ އަގު",
      "gainLoss": "ފައިދާ ނުވަތަ ގެއްލުން",
      "noCatchUp": "ނައްތާލުން ޗާޖް ޑިޕްރިސިއޭޝަން މުއްދަތު ހިނގާ. އެސެޓް ބަހައްޓައެވެ ކޮންމެ އެއްޗެއް ފަހު ފުރިހަމަކުރެވުނު ރަން ޗާޖްކުރެވިފައި, ފައިދާ ނުވަތަ ގެއްލުން ކަނޑައެޅޭ އާ ދެކޮޅަށް ފޮތް އަގު.",
      "noCatchUpAdvice": "މުއްދަތު ޖެހޭ ޗާޖްކުރެވިފައި ފުރަތަމަ, ރަން ޑިޕްރިސިއޭޝަން އާދޭ އެނބުރި.",
      "posting": "ޕޯސްޓިންގ",
      "done": "އެސެޓް ނައްތާލެވިފައި",
      "doneDetail": "{assetNo} ފޮތުން ނެގިއްޖެ.",
      "failed": "ނައްތާލުން ވެދާނެ ޕޯސްޓްކުރެވިފައި",
      "fields": {
        "date": "ނައްތާލުން ތާރީޚު",
        "dateHint": "ޖާނަލް ތާރީޚުކުރެވިފައި ދުވަސް",
        "proceeds": "ލިބުނު ފައިސާ",
        "proceedsHint": "ދޫކޮށްލާ ހުސްކޮށް ފޮހެލުން އެއްވެސް އެއްޗެއް ލިބުނު",
        "proceedsAccount": "ލިބުނު ފައިސާ ހިސާބު",
        "proceedsAccountHint": "ފައިސާ އައި — ބޭންކް ލިބެންޖެހޭ ހިސާބު",
        "reasonHint": "ވިއްކުނު, ސްކްރެޕްކުރެވުނު, ވަގަށް ނެގުނު, ލިޔެވުނު — ރެކޯޑްކުރެވިފައި އޮޑިޓް ޓްރެއިލް"
      }
    },
    "runs": {
      "action": "ރަން ޑިޕްރިސިއޭޝަން",
      "bookRunsTitle": "ފޮތުން ފޮތަށް — {count} ފޮތް ހިނގައިފި",
      "columns": {
        "journal": "ޖާނަލް",
        "date": "ޕޯސްޓްކުރެވިފައި",
        "memo": "ނޯޓު",
        "charged": "ޗާޖްކުރެވިފައި"
      },
      "description": "ޗާޖް ޝަރުތު ފުރިހަމަވާ އެސެޓް މުއްދަތު, ބައްލަވާ ސީދާ ޗާޖްކުރެވިފައި ދޫކޮށްލެވުނު.",
      "dialogDescription": "ޗާޖްތައް ޝަރުތު ފުރިހަމަވާ ބޭނުންކުރަން ފެށި އެސެޓް ކުންފުނި މުއްދަތު ތާރީޚު ވެއްޓޭ.",
      "dialogTitle": "ރަން ޑިޕްރިސިއޭޝަން",
      "doneDetail": "{count} އެސެޓްތައް ޗާޖްކުރެވިފައި {period}.",
      "doneTitle": "ޑިޕްރިސިއޭޝަން ޕޯސްޓްކުރެވިފައި",
      "eligibilityNote": "ބާކީކުރުންތައް ދުވަހަކުވެސް ނުވާނެ ފެންނާނެ ލިސްޓް, ރަން ފިލްޓަރތައް ބަލައެވެ: ނައްތާލެވިފައި އެސެޓް, އެ ފަރާތުގެ މުއްދަތު ކައުންޓަރ ހަމަވެއްޖެ ބޭނުންކުރެވޭ މުއްދަތު. ރަޖިސްޓްރީ'ގެ ސްޓޭޓަސް ކޮލަމް ބުނެދެއެވެ ހިނގައެވެ އަށް ދެވިފައިވާ އެސެޓް.",
      "failed": "ރަން ވެދާނެ ފުރިހަމަކުރެވުނު",
      "fields": {
        "on": "ތާރީޚު",
        "onHint": "ހުސްކޮށް މާނައަކީ މިއަދު ވޯކްސްޕޭސްގެ ޓައިމްޒޯން. މުއްދަތު ވެއްޓޭ މުއްދަތު ޗާޖްކުރެވިފައި."
      },
      "hideCharges": "ފޮރުވާ ޗާޖްތައް",
      "historyCaption": "ޑިޕްރިސިއޭޝަން ޖާނަލްތައް ކުންފުނި",
      "historyDescription": "ރަން'ގެ ޖާނަލް, އިން ލެޖަރ — ރެކޯޑް ޙަޤީޤަތުގައި ޕޯސްޓްކުރެވިފައި.",
      "historyEmpty": "ޑިޕްރިސިއޭޝަން ޕޯސްޓްކުރެވިފައި ކުންފުނި މުއްދަތު.",
      "historyFailed": "ތާރީޚު ވެދާނެ ލޯޑްކުރެވުނު",
      "historySkipsNote": "ވޭތުވެދިޔަ ރަން ދޫކޮށްލެވުނު ދައްކާފައި: ލިސްޓް އޮވެއެވެ ޖަވާބު އަށް ކޯލް ހިންގި. އެންޑްޕޮއިންޓް ރައްކާކުރެވިފައިވާ ރަންތައް އުފުލާ, ޢަދަދުތައް ރެކޯޑްކުރެވިފައި ސާވަރުގައި.",
      "historyTitle": "ވޭތުވެދިޔަ ރަންތައް",
      "idempotencyNote": "ހިންގުން ދެފަހަރު ރައްކާތެރި. ދެވަނަ ރަން ފެނެއެވެ އެސެޓް ނެތި ޗާޖް މުއްދަތު ޕޯސްޓްކުރޭ ޖާނަލް ގައި.",
      "idempotencyNoteTwo": "މުއްދަތުގެ މެދުތެރޭގައި އެސެޓެއް އިތުރުކޮށް އަލުން ރަން ހިންގުމުން، ސީދާ އެ އެސެޓް ޗާޖްކުރެވޭނެއެވެ، އެއް މުއްދަތަކަށް ދެވަނަ ޖާނަލްއެއްގައި. ދެ ޖާނަލްވެސް ޙަޤީޤީ އަދި ރަނގަޅެވެ.",
      "landsIn": "ތާރީޚު ޖެހޭ {period}.",
      "moreHistory": "ކުރީގެ ރަންތައް ބޭރުގައި ޞަފްޙާ. ހަނިކުރޭ ތާރީޚު ދާއިރާ އަށް ހަމައަށް.",
      "noCharges": "ޖާނަލް ޑެބިޓް ސަޠުރުތައް.",
      "noOpDetail": "ޝަރުތު ފުރިހަމަވާ އެސެޓް ޗާޖް {period}, ޖާނަލް ޕޯސްޓްކުރެވިފައި.",
      "noOpExplained": "ޖާނަލް ޕޯސްޓްކުރެވިފައި: ޝަރުތު ފުރިހަމަވާ އެސެޓް ޗާޖް {period}. ރައްކާތެރި ނަތީޖާ ހިންގުން, ނާކާމިޔާބުވުން.",
      "noOpTitle": "އެއްވެސް އެއްޗެއް އަށް ޗާޖް",
      "noPeriod": "ފިސްކަލް މުއްދަތު ހިމަނައެވެ ތާރީޚު ކުންފުނި. އުފައްދާ ފިސްކަލް އަހަރު ފުރަތަމަ.",
      "noSkips": "އެއްވެސް އެއްޗެއް ދޫކޮށްލެވުނު: އެސެޓް ރަން ބެލެވުނު ޗާޖްކުރެވިފައި.",
      "periodClosedWarning": "މުއްދަތު ބަންދުކުރެވިފައި, ރަން ބަލައިނުގަނެވުނު. އަލުން ހުޅުވާ, ޚިޔާރުކުރޭ ތާރީޚު ތެރޭގައި ހުޅުވިފައި މުއްދަތު.",
      "processed": "އެސެޓްތައް ޗާޖްކުރެވިފައި",
      "processedCount": "ޕްރޮސެސްކުރެވުނު",
      "processedHelp": "އެސެޓްތައް ޗާޖް މުއްދަތު ޑިޕްރިސިއޭޓްކުރެވޭ އަސާސް މުއްދަތު ބާކީ",
      "resultDescription": "ރަން ޗާޖްކުރެވިފައި, ދޫކޮށްލެވުނު.",
      "resultTitle": "ރަން {period}",
      "running": "ހިންގުން",
      "showCharges": "ދައްކާ ޗާޖްތައް",
      "skippedCount": "ދޫކޮށްލެވުނު",
      "skippedHelp": "އެސެޓްތައް ރަން ބެލެވުނު ޗާޖް, ސަބަބު",
      "skippedTitle": "{count} އެސެޓްތައް ބެލެވުނު ޗާޖްކުރެވިފައި",
      "title": "ޑިޕްރިސިއޭޝަން ރަންތައް",
      "totalAmount": "ޖުމްލަ އަދަދު",
      "totalCharged": "ޖުމްލަ ޗާޖްކުރެވިފައި",
      "totalChargedHelp": "ޑެބިޓް ޖުމްލަ ޖާނަލް ރަން ޕޯސްޓްކުރެވިފައި",
      "viewJournal": "ބައްލަވާ ޖާނަލް"
    },
    "movement": {
      "title": "އެސެޓް މޫވްމަންޓް",
      "description": "ފެށޭ, އިތުރުކުރުންތައް, ޑިޕްރިސިއޭޝަން, ނައްތާލުންތައް ނިމޭ, ކްލާސް — ދިމާކުރެވިފައި އާ ދެކޮޅަށް ލެޖަރ ހިސާބުތައް ފަހަތުގައިވާ.",
      "needsWindow": "ޚިޔާރުކުރޭ ކުންފުނި ތާރީޚު ދާއިރާ އަށް ރަން ރިޕޯޓް.",
      "loadFailed": "ރިޕޯޓް ވެދާނެ ލޯޑްކުރެވުނު",
      "tableTitle": "މޫވްމަންޓް ކްލާސް",
      "tableDescription": "އިން {from} އަށް {to}.",
      "tableCaption": "އެސެޓް މޫވްމަންޓް ކްލާސް: ފެށޭ, އިތުރުކުރުންތައް, ޑިޕްރިސިއޭޝަން, ނައްތާލުންތައް ނިމޭ",
      "empty": "އެސެޓްތައް ބަދަލުކުރެވިއްޖެ މުއްދަތު.",
      "total": "ޖުމްލަ",
      "generated": "އުފެއްދި {at}",
      "reconciles": "ކްލާސް ހަމަވެއެވެ އަށް ކޮންޓްރޯލް ހިސާބުތައް, ސަޠުރު ހިނގައެވެ އިން ފެށޭ އަށް ނިމޭ, ސަޠުރުތައް އިތުރުކުރޭ އަށް ޖުމްލަތައް.",
      "controlMismatch": "{count} ކޮންޓްރޯލް ހިސާބު ސަބް-ލެޖަރާ އެއްގޮތެއް ނުވެއެވެ.",
      "rowsBroken": "{count} ސަޠުރުތައް ހިނގުން އިން ފެށޭ އަށް ނިމޭ.",
      "totalsBroken": "ޖުމްލަތައް ހަމަހަމަ ޖުމްލަ ސަޠުރުތައް: {columns}.",
      "controlTitle": "ކޮންޓްރޯލް ހިސާބު ރިކޮންސިލިއޭޝަން",
      "controlDescription": "ސާވަރު ޖަމާކުރެވުނު ލެޖަރ ކްލާސް'ގެ އެސެޓް ޖަމާވެފައިވާ ޑިޕްރިސިއޭޝަން ހިސާބުތައް އަޅާކިޔުނު ރަޖިސްޓްރީ.",
      "controlCaption": "ސަބް-ލެޖަރ ޖުމްލަތައް، ޢާންމު ލެޖަރގެ ކޮންޓްރޯލް ހިސާބުތަކާ އަޅާކިޔުން",
      "reconciled": "ހަމަވެއެވެ",
      "notReconciled": "ހަމަވުން",
      "noControls": "ކޮންޓްރޯލް ހިސާބުތައް ދިމާކުރެވިފައި މުއްދަތު.",
      "columns": {
        "class": "ކްލާސް",
        "openingCost": "ފެށޭ އަގު",
        "additions": "އިތުރުކުރުންތައް",
        "disposalsCost": "ނައްތާލުންތައް",
        "closingCost": "ނިމޭ އަގު",
        "openingAccum": "ފެށޭ ޖަމާވި.",
        "charge": "ޑިޕްރިސިއޭޝަން",
        "disposalsAccum": "ނައްތާލުންތައް ޖަމާވި.",
        "closingAccum": "ނިމޭ ޖަމާވި.",
        "closingNbv": "ނިމޭ ސާފު ފޮތުގެ އަގު",
        "account": "ހިސާބު",
        "subLedger": "ރަޖިސްޓްރީ",
        "control": "ލެޖަރ",
        "difference": "ތަފާތު"
      }
    },
    "bookKinds": {
      "accounting": "އެކައުންޓިންގ",
      "tax": "ޓެކްސް",
      "management": "މެނޭޖްމަންޓް",
      "other": "އެހެނިހެން"
    },
    "bookSources": {
      "tenant": "އަމިއްލަ",
      "pack": "ޕެކުން"
    },
    "conventions": {
      "full_month": "ފުރިހަމަ މަސް",
      "half_year": "ބައި އަހަރު",
      "mid_month": "މެދު މަސް",
      "mid_quarter": "މެދު ކުއާޓަރު",
      "actual_days": "ހަގީގީ ދުވަސް"
    },
    "assetBookStatuses": {
      "in_service": "ޚިދުމަތުގައި",
      "fully_depreciated": "ފުރިހަމައަށް ޑިޕްރިސިއޭޓްވެފައި",
      "disposed": "ނައްތާލެވިފައި"
    },
    "componentKinds": {
      "whole": "ފުރިހަމަ އެސެޓް",
      "parent": "މައި",
      "component": "ބައި"
    },
    "indicators": {
      "market_value_decline": "މާކެޓް އަގު ދަށްވެފައި",
      "physical_damage": "ގެއްލުންވެފައި",
      "obsolescence": "ބޭނުންނުކުރެވޭ ވަރަށް ބާވެފައި",
      "idle": "ބޭނުންނުކޮށް ހުރި",
      "disposal_planned": "ނައްތާލަން ރޭވިފައި",
      "adverse_regulation": "ގަވާއިދުގެ ނޭދެވޭ އަސަރު",
      "economic_performance": "އިގްތިސާދީ ނަތީޖާ",
      "reversal_indicator": "ހާލަތު ރަނގަޅުވެފައި",
      "other": "އެހެނިހެން"
    },
    "indicatorOutcomes": {
      "pending": "އަދި ބެލިފައި ނުވޭ",
      "no_impairment": "ބެލިއްޖެ — އިމްޕެއަރމަންޓެއް ނެތް",
      "impaired": "އިމްޕެއަރވެފައި",
      "reversed": "ރިވާސްކުރެވިފައި"
    },
    "impairmentKinds": {
      "loss": "ގެއްލުން",
      "reversal": "ރިވާސަލް"
    },
    "verificationStatuses": {
      "draft": "ދެލިކޮޕީ",
      "in_progress": "ކުރިއަށްދަނީ",
      "completed": "ނިމިފައި",
      "cancelled": "ބާތިލްކުރެވިފައި"
    },
    "dispositions": {
      "none": "ކުރާނެ ކަމެއް ނެތް",
      "relocated": "ތަން ބަދަލުކުރޭ",
      "recustodied": "ބަލަހައްޓާ ފަރާތް ބަދަލުކުރޭ",
      "impair": "އިމްޕެއަރމަންޓެއް ނަގާ",
      "dispose": "ނައްތާލާ",
      "write_off": "ރައިޓް-އޯފް ކުރޭ",
      "investigate": "ތަހުގީގުކުރޭ"
    },
    "books": {
      "title": "ޑިޕްރިސިއޭޝަން ފޮތްތައް",
      "description": "ކުންފުނިން ޕޯސްޓްކުރާ އެއް އެކައުންޓިންގ ފޮތާއި، ޕޯސްޓްނުކުރާ ޓެކްސް ފޮތްތައް ބެހެއްޓޭނެ.",
      "primaryHint": "ކޮންމެ ކުންފުންޏަކަށް ހަމަ އެއް ފޮތް ޕްރައިމަރީވާނެ. ޖީއެލްއަށް ޕޯސްޓްކުރާ ފޮތް އެކަނި ޖާނަލްއެއް ހަދާނެ.",
      "loadFailed": "ޑިޕްރިސިއޭޝަން ފޮތްތައް ލޯޑެއް ނުކުރެވުނު",
      "create": "އައު ފޮތެއް",
      "createTitle": "އައު ޑިޕްރިސިއޭޝަން ފޮތް",
      "createDescription": "އަމިއްލަ ގޮތެއް، އަމިއްލަ ކޮންވެންޝަނެއް، އަމިއްލަ އަގުތަކެއް.",
      "created": "ފޮތް ހެދިއްޖެ",
      "createFailed": "ފޮތް ނުހެދުނު",
      "code": "ކޯޑް",
      "name": "ނަން",
      "kind": "ބާވަތް",
      "convention": "ކޮންވެންޝަން",
      "conventionHint": "ފުރަތަމަ މުއްދަތުގައި ބައި މަހެއް ބަލާ ގޮތް.",
      "role": "ދައުރު",
      "primary": "ޕްރައިމަރީ",
      "posts": "ޖީއެލްއަށް ޕޯސްޓްކުރޭ",
      "doesNotPost": "ޕޯސްޓެއް ނުކުރޭ",
      "postsHint": "ޓެކްސް ފޮތަކަށް ނިއްވާލާފައި ބަހައްޓާ. ކުންފުންޏަކަށް ޕޯސްޓްކުރަން ޖެހޭނީ އެއް ފޮތް.",
      "source": "ސޯސް",
      "descriptionLabel": "ތަފްސީލް",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓިފައި",
      "tableLabel": "ޑިޕްރިސިއޭޝަން ފޮތްތައް",
      "emptyTitle": "ފޮތެއް ނެތް",
      "emptyDescription": "ކޮންމެ ކުންފުންޏެއްގައި ޕްރައިމަރީ ފޮތެއް ހުންނާނެ. ޓެކްސް ފޮތެއް އިތުރުކުރޭ."
    },
    "assetBooks": {
      "title": "ފޮތްތައް",
      "description": "މި އެސެޓް ހިމެނޭ ކޮންމެ ފޮތެއްގައި އޭގެ އަގު. ތަފާތުވުމަކީ ޓެމްޕަރަރީ ޑިފަރެންސް.",
      "loadFailed": "މި އެސެޓްގެ ފޮތްތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އެއްވެސް ފޮތެއްގައި ނެތް",
      "emptyDescription": "އެސެޓް ހޯދުމުން ޕްރައިމަރީ ފޮތަށް އަރާނެ.",
      "book": "ފޮތް",
      "method": "ގޮތް",
      "life": "އުމުރު (މަސް)",
      "lifeHint": "ހުސްކޮށް ބެހެއްޓުމުން ކްލާހުގެ އުމުރު ނަގާނެ.",
      "cost": "އަގު",
      "salvage": "ސެލްވޭޖް",
      "salvageHint": "ހުސްކޮށް ބެހެއްޓުމުން ކްލާހުގެ ސެލްވޭޖް ނަގާނެ.",
      "accumulated": "ޖަމާ ޑިޕްރިސިއޭޝަން",
      "impairment": "ޖަމާ އިމްޕެއަރމަންޓް",
      "carrying": "ކެރީއިންގ",
      "add": "ފޮތެއް އިތުރުކުރޭ",
      "addTitle": "މި އެސެޓް އެހެން ފޮތެއްގައި ބަހައްޓާ",
      "addDescription": "އެހެން ގޮތަކަށް ނުބުނާހާ ހިނދަކު އެއް އަގަކުން ފަށާނެ.",
      "added": "އެސެޓް ފޮތަށް އިތުރުކުރެވިއްޖެ",
      "addFailed": "އެސެޓް ފޮތަށް އިތުރެއް ނުކުރެވުނު",
      "change": "ގޮތް ބަދަލުކުރޭ",
      "changeTitle": "ގޮތް، އުމުރު ނުވަތަ ސެލްވޭޖް ބަދަލުކުރޭ",
      "changeDescription": "މިއީ IAS 8 ގެ ދަށުން އަންދާޒާގެ ބަދަލެއް.",
      "prospectiveWarning": "މިއީ ކުރިއަށް އޮތް ތަނަށް. ބާކީ އަގު ބާކީ އުމުރަށް ބަހާލެވޭނެ، ކުރިން ޕޯސްޓްވި އެއްޗެއް ބަދަލެއް ނުވާނެ.",
      "reason": "ސަބަބު",
      "changed": "ފޮތުގެ އަސާސް ބަދަލުކުރެވިއްޖެ",
      "changeFailed": "ފޮތުގެ އަސާސް ބަދަލެއް ނުކުރެވުނު"
    },
    "impairment": {
      "title": "އިމްޕެއަރމަންޓް",
      "description": "އިންޑިކޭޓަރުން ބަލަން ބުނޭ؛ އެސެސްމަންޓުން ނިންމާ؛ ގެއްލުން ނުވަތަ ރިވާސަލް ޕޯސްޓްވޭ.",
      "tabIndicators": "އިންޑިކޭޓަރުތައް",
      "tabImpairments": "އިމްޕެއަރމަންޓްތައް",
      "tabsLabel": "އިމްޕެއަރމަންޓް ވިއުތައް",
      "indicatorHint": "އިންޑިކޭޓަރަކީ އިމްޕެއަރމަންޓެއް ނޫން. ބަލައި އެއްވެސް މައްސަލައެއް ނުފެނުމަކީވެސް ނަތީޖާއެއް.",
      "capHint": "ރިވާސަލްއަކުން އެސެޓްގެ އަގު، އިމްޕެއަރ ނުވިނަމަ ހުންނާނެ އަގަށްވުރެ މައްޗަށް ނުދާނެ.",
      "indicatorsFailed": "އިމްޕެއަރމަންޓް އިންޑިކޭޓަރުތައް ލޯޑެއް ނުކުރެވުނު",
      "impairmentsFailed": "އިމްޕެއަރމަންޓްތައް ލޯޑެއް ނުކުރެވުނު",
      "assessedOn": "ނެގި ތާރީޚު",
      "subject": "ބެހޭ",
      "wholeClass": "މުޅި ކްލާސް {code}",
      "raisedBy": "ނެގީ",
      "byJob": "ރޭގަނޑުގެ ސްވީޕް",
      "byPerson": "މީހެއް",
      "outcome": "ނަތީޖާ",
      "anyOutcome": "ކޮންމެ ނަތީޖާއެއް",
      "indicatorsTableLabel": "އިމްޕެއަރމަންޓް އިންޑިކޭޓަރުތައް",
      "indicatorsEmptyTitle": "އިންޑިކޭޓަރެއް ނެތް",
      "indicatorsEmptyDescription": "އެސެޓް ބޭނުންނުކޮށް ހުރުން ފަދަ ހާލަތްތަކުގައި ރޭގަނޑުގެ ސްވީޕުން އެއް ނަގާނެ.",
      "impairmentsTableLabel": "އިމްޕެއަރމަންޓްތައް",
      "impairmentsEmptyTitle": "އިމްޕެއަރމަންޓެއް ނެތް",
      "impairmentsEmptyDescription": "އިންޑިކޭޓަރެއް ބަލައި މީގެ އެއް ނަގާ.",
      "impairedOn": "ތާރީޚު",
      "asset": "އެސެޓް",
      "kind": "ބާވަތް",
      "carrying": "ކެރީއިންގ",
      "recoverable": "ރިކަވަރ ކުރެވޭ",
      "recoverableHint": "ވިއްކުމުން ލިބޭ އަގާއި ބޭނުންކުރުމުގެ އަގުން މަތީ އަދަދު.",
      "amount": "އަދަދު",
      "cap": "ރިވާސަލް ސީލިންގ",
      "capIs": "ރިވާސަލްއިން {amount} އަށްވުރެ މައްޗަށް ނުދެވޭނެ.",
      "journal": "ޖާނަލް",
      "notPosted": "ޕޯސްޓްވެފައި ނުވޭ",
      "book": "ފޮތް",
      "bookHint": "އިމްޕެއަރމަންޓަކީ ފޮތަކަށް ވަކިން؛ ޓެކްސް ފޮތުގައި އަގު ތަފާތުވެދާނެ.",
      "assess": "ބަލާ",
      "assessTitle": "އިންޑިކޭޓަރެއް ބަލާ",
      "assessDescription": "ކެރީއިންގ އަގާއި ރިކަވަރ ކުރެވޭ އަގު އަޅާކިޔާ.",
      "assessed": "އިންޑިކޭޓަރު ބެލިއްޖެ",
      "assessFailed": "އިންޑިކޭޓަރު ނުބެލުނު",
      "note": "ނޯޓް",
      "post": "ޕޯސްޓްކުރޭ",
      "posted": "އިމްޕެއަރމަންޓް ޕޯސްޓްވެއްޖެ",
      "postFailed": "އިމްޕެއަރމަންޓް ޕޯސްޓެއް ނުކުރެވުނު",
      "reverse": "ރިވާސްކުރޭ",
      "reverseTitle": "އިމްޕެއަރމަންޓެއް ރިވާސްކުރޭ",
      "reverseDescription": "ހާލަތު ރަނގަޅުވެ، އެސެޓުން ލިބޭ އަދަދު އިތުރުވެއްޖެ.",
      "reverseCapWarning": "ރިވާސަލް ސީލިންގއަކީ އިމްޕެއަރ ނުވިނަމަ މިއަދު ހުންނާނެ އަގު. އެއަށްވުރެ މައްޗަށް ސާވަރުން ގަބޫލެއް ނުކުރާނެ.",
      "reverseOn": "ރިވާސްކުރާ ތާރީޚު",
      "reversed": "އިމްޕެއަރމަންޓް ރިވާސްކުރެވިއްޖެ",
      "reverseFailed": "އިމްޕެއަރމަންޓް ރިވާސްއެއް ނުކުރެވުނު"
    },
    "verification": {
      "listTitle": "ފިޒިކަލް ވެރިފިކޭޝަން",
      "listDescription": "ރަޖިސްޓްރީ ހަގީގަތާ އަޅާކިޔުން. ބްލައިންޑް ގުނުމަކީ ހަމައެކަނި ބޭނުންހުރި ގޮތް.",
      "loadFailed": "ވެރިފިކޭޝަން ރަންތައް ލޯޑެއް ނުކުރެވުނު",
      "create": "އައު ރަން",
      "createTitle": "އައު ވެރިފިކޭޝަން ރަން",
      "createDescription": "ތަނަކުން ނުވަތަ ބަލަހައްޓާ ފަރާތަކުން ދާއިރާ ކަނޑައަޅާ.",
      "created": "ވެރިފިކޭޝަން ރަން ހެދިއްޖެ",
      "createFailed": "ވެރިފިކޭޝަން ރަން ނުހެދުނު",
      "code": "ކޯޑް",
      "name": "ނަން",
      "scheduledOn": "ތާވަލުކުރެވިފައި",
      "scope": "ދާއިރާ",
      "scopeHint": "ހުސްކޮށް ބެހެއްޓުމުން މުޅި ރަޖިސްޓްރީ.",
      "wholeRegister": "މުޅި ރަޖިސްޓްރީ",
      "location": "ތަން",
      "custodian": "ބަލަހައްޓާ ފަރާތް",
      "blind": "ބްލައިންޑް",
      "blindYes": "ބްލައިންޑް ގުނުން",
      "blindLabel": "ބްލައިންޑް ގުނުން",
      "blindHint": "ބްލައިންޑް ރަންއެއްގައި، ފެނުނުތޯ ބުނުމުގެ ކުރިން ހުންނަން ޖެހޭ ތަން ނުދައްކާނެ.",
      "blindSheetHint": "މިއީ ބްލައިންޑް ގުނުމެއް. ފުރަތަމަ ފެނުނުތޯ ރެކޯޑްކުރޭ؛ އޭގެ ފަހުން ހުންނަން ޖެހޭ ތަން ފެންނާނެ.",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "counts": "ފެނުނު",
      "missing": "ނުފެންނަ",
      "counted": "ގުނިފައި",
      "note": "ނޯޓް",
      "tableLabel": "ވެރިފިކޭޝަން ރަންތައް",
      "emptyTitle": "ވެރިފިކޭޝަން ރަންއެއް ނެތް",
      "emptyDescription": "ތަނަކަށް ނުވަތަ ފަރާތަކަށް ތާވަލުކުރުމުން ގުނުމުގެ ޝީޓް އުފެދޭނެ.",
      "sheetTitle": "ގުނުމުގެ ޝީޓް — {code}",
      "sheetPanelTitle": "ލައިންތައް",
      "sheetPanelDescription": "ކޮންމެ ލައިނަކަށް ފެނުނުތޯ؛ ދެން ކުރާނެ ކަމަކީ ޑިސްޕޮޒިޝަން.",
      "sheetEmptyTitle": "ލައިނެއް ނެތް",
      "sheetEmptyDescription": "ރަން ފެށުމުން ރަޖިސްޓްރީން ލައިންތައް އުފެދޭނެ.",
      "asset": "އެސެޓް",
      "found": "ފެނުނު",
      "foundYes": "ފެނުނު",
      "foundNo": "ނުފެނުނު",
      "expected": "ހުންނަން ޖެހޭ",
      "hidden": "ގުނަންދެން ފޮރުވިފައި",
      "actualLocation": "ހަގީގީ ތަން",
      "actualCustodian": "ހަގީގީ ބަލަހައްޓާ ފަރާތް",
      "condition": "ހާލަތު",
      "disposition": "ޑިސްޕޮޒިޝަން",
      "record": "ރެކޯޑްކުރޭ",
      "recorded": "ލައިންތައް ރެކޯޑްކުރެވިއްޖެ",
      "recordFailed": "ލައިންތައް ރެކޯޑެއް ނުކުރެވުނު",
      "complete": "ރަން ނިންމާ",
      "completed": "ވެރިފިކޭޝަން ރަން ނިމިއްޖެ",
      "completeFailed": "ރަން ނުނިންމުނު"
    },
    "componentise": {
      "title": "{assetNo} ބައިބަޔަށް ބަހާ",
      "description": "ތަފާތު ދުވެއްޔެއްގައި ބާވާ ބައިތަކަށް އެއް އެސެޓް ބަހާލާ.",
      "crumb": "ބައިބަޔަށް ބަހާ",
      "register": "ރަޖިސްޓްރީ",
      "loadFailed": "އެސެޓް ލޯޑެއް ނުކުރެވުނު",
      "parentCost": "މައި އަގު",
      "allocated": "ބަހާލެވިފައި",
      "residual": "ބަހާނުލެވޭ",
      "unbalanced": "ބައިތަކުގެ ޖުމްލަ މައި އަގާ ސެންޓަކަށް ދާންދެން ދިމާވާން ޖެހޭނެ.",
      "incomplete": "ކޮންމެ ބަޔަކަށް ނަމަކާއި އަގުގެ ބައެއް ބޭނުންވޭ.",
      "alreadySplit": "މި އެސެޓަކީ މިހާރުވެސް {kind}.",
      "effectiveOn": "ފެށޭ ތާރީޚު",
      "gridTitle": "ބައިތައް",
      "gridDescription": "މަދުވެގެން ދޭއް. ކޮންމެ ބަޔަކަށް އަމިއްލަ ގޮތަކާއި އުމުރެއް.",
      "addRow": "ބައެއް އިތުރުކުރޭ",
      "removeRow": "ނަގާ",
      "name": "ނަން",
      "costShare": "އަގުގެ ބައި",
      "note": "ނޯޓް",
      "submit": "އެސެޓް ބަހާލާ",
      "done": "އެސެޓް ބައިބަޔަށް ބެހިއްޖެ",
      "failed": "އެސެޓް ބައިބަޔަށް ނުބެހުނު"
    },
    "comparison": {
      "title": "ފޮތްތަކުގެ އަޅާކިޔުން",
      "description": "ދެ ފޮތެއްގެ އަގުތައް ކައިރި ކައިރީގައި. ތަފާތު ކޮލަމަކީ ޑިފަރޑް ޓެކްސްގެ އަސާސް.",
      "loadFailed": "އަޅާކިޔުން ލޯޑެއް ނުކުރެވުނު",
      "bookA": "ފޮތް އޭ",
      "bookB": "ފޮތް ބީ",
      "asOf": "ތާރީޚު",
      "chooseTitle": "ދެ ފޮތަކާއި ތާރީޚެއް ހޮވާ",
      "chooseDescription": "އާންމުކޮށް އެކައުންޓިންގ ފޮތާއި ޓެކްސް ފޮތް، މުއްދަތު ނިމުމުގައި.",
      "tableTitle": "އެސެޓުން",
      "tableDescription": "ދެ ފޮތުގައިވެސް ހިމެނޭ ކޮންމެ އެސެޓެއް.",
      "emptyTitle": "އަޅާކިޔާނެ އެއްޗެއް ނެތް",
      "emptyDescription": "އެ ތާރީޚުގައި ދެ ފޮތުގައިވެސް ހިމެނޭ އެސެޓެއް ނެތް.",
      "asset": "އެސެޓް",
      "assetName": "ނަން",
      "cost": "އަގު",
      "accumulated": "ޖަމާ ޑިޕްރިސިއޭޝަން",
      "impairment": "ޖަމާ އިމްޕެއަރމަންޓް",
      "carrying": "ކެރީއިންގ",
      "difference": "ތަފާތު"
    },
    "ft13": {
      "asset": {
        "booksTab": "ފޮތްތައް",
        "months": "{months} މަސް",
        "openPendingDisposal": "އިންތިޒާރުގައިވާ ނައްތާލުން ހުޅުވާ",
        "reloaded": "ތިޔަ ބޭފުޅާ ބަދަލުކުރަމުން ގެންދިޔައިރު މި މުދާ އެހެން މީހަކު ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑުކޮށްފިއެވެ؛ ތިޔަ ބަދަލުތައް ތިރީގައި ރައްކާވެފައިވެއެވެ. ބަލާފައި އަލުން ސޭވްކުރައްވާ.",
        "unitById": "ޔުނިޓް #{id}"
      },
      "capex": {
        "account": "މުދަލުގެ ހިސާބު",
        "additions": "ކެޕިޓަލައިޒްކުރި އިތުރުކުރުންތައް",
        "additionsCount": "އިތުރުކުރުންތައް (އަދަދު)",
        "additionsCountShort": "{count} އިތުރުކުރުން",
        "budget": "ކެޕިޓަލް ބަޖެޓް",
        "description": "މި މުއްދަތުގައި ކެޕިޓަލައިޒްކުރި މުދާ، މުދަލުގެ ހިސާބުން، އެ މުއްދަތުތަކަށް ހުއްދަދީފައިވާ ކެޕިޓަލް ބަޖެޓާ އަޅާކިޔައިގެން.",
        "emptyDescription": "މި މުއްދަތުގައި އެއްވެސް އެއްޗެއް ކެޕިޓަލައިޒްކޮށްފައެއް ނުވެއެވެ، އަދި އެއްވެސް ކެޕިޓަލް ބަޖެޓެއް މީގެ ތެރޭގައެއް ނުވެއެވެ.",
        "emptyTitle": "މި މުއްދަތުގައި ކެޕިޓަލް ޚަރަދެއް ނެތް",
        "loadFailed": "ބަޖެޓާ އަޅާބަލާއިރު ކެޕިޓަލް ޚަރަދު ލޯޑު ނުކުރެވުނު",
        "noBudget": "މި ޤާނޫނީ ފަރާތަށް ހުއްދަދީފައިވާ ކެޕިޓަލް ބަޖެޓެއް ނެތެވެ. ބަޖެޓުގެ ހުރިހާ އަދަދަކީ ސުމެވެ، އެހެންކަމުން ކެޕިޓަލައިޒްކުރި އިތުރުކުރުންތައް އެކަނި ދައްކައެވެ.",
        "percent": "{value}%",
        "title": "ބަޖެޓާ އަޅާބަލާއިރު ކެޕިޓަލް ޚަރަދު",
        "utilisation": "ބޭނުންކުރި މިންވަރު",
        "variance": "ތަފާތު"
      },
      "capitalize": {
        "cipNotConfigured": "މި ޤާނޫނީ ފަރާތަށް ބިނާކުރަމުންދާ މަސައްކަތުގެ ހިސާބެއް ކަނޑައަޅާފައެއް ނުވެއެވެ، އެހެންކަމުން ކެޕިޓަލައިޒްކުރާނެ CIP ބެލެންސެއް ނެތެވެ. މުދަލުގެ ސެޓިންގްސްގައި ކަނޑައަޅުއްވާ."
      },
      "chooseEntityDescription": "މަތީގައި ޤާނޫނީ ފަރާތެއް ޚިޔާރުކުރައްވާ. އަދަދުތަކަކީ އެ ފަރާތުގެ ބޭސް ފައިސާއިންނެވެ.",
      "chooseEntityTitle": "ޤާނޫނީ ފަރާތެއް ޚިޔާރުކުރައްވާ",
      "dispose": {
        "needsApproval": "މި ނައްތާލުމަކީ ހައްދުން މައްޗަށް ހުރި އެއްޗެކެވެ: ހުއްދައަށް ހުށަހެޅޭނެއެވެ، އަދި ދެވަނަ މީހަކު ހުއްދަދެންދެން އެއްވެސް ޕޯސްޓިންއެއް ނުކުރެވޭނެއެވެ.",
        "submitForApproval": "ހުއްދައަށް ހުށަހަޅާ",
        "threshold": "ލިބޭ ފައިސާ ނުވަތަ ނެޓް ބުކް ވެލިއު މި އަދަދަށް ވުރެ ބޮޑު ނައްތާލުމަށް ދެވަނަ މީހެއްގެ ހުއްދަ ބޭނުންވެއެވެ:"
      },
      "disposalStatus": {
        "cancelled": "ބާތިލުކުރެވިފައި",
        "lapsed": "މުއްދަތު ހަމަވެފައި",
        "pending_approval": "ހުއްދައަށް އިންތިޒާރުގައި",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "rejected": "ރައްދުކުރެވިފައި"
      },
      "disposals": {
        "allAssets": "ހުރިހާ މުދަލެއް ދައްކާ",
        "approval": "ހުއްދަ",
        "assetFilter": "ދައްކަނީ މުދާ #{id} ގެ ނައްތާލުންތައް އެކަނި.",
        "caption": "މުދާ ނައްތާލުންތައް، އެންމެ އާ އެއްޗެއް ފުރަތަމަ",
        "count": "ނައްތާލުންތައް",
        "decidedBy": "ނިންމި ފަރާތް",
        "decisionNote": "ނިންމުމުގެ ނޯޓް",
        "description": "ޕޯސްޓްކުރެވިފައިވާ ނުވަތަ ހުއްދައަށް އިންތިޒާރުކުރާ ހުރިހާ ނައްތާލުމެއް، ގޮތާއި، ލިބުނު ފައިސާއާއި، ރަސީދާއި، ފައިދާ ނުވަތަ ގެއްލުމާއެކު.",
        "detailFailed": "މި ނައްތާލުން ލޯޑު ނުކުރެވުނު",
        "detailTitle": "ނައްތާލުން",
        "details": "ތަފްސީލު",
        "emptyDescription": "ނައްތާލުން ހަދަނީ މުދަލުގެ އަމިއްލަ ސްކްރީނުންނެވެ. ހައްދުން މައްޗަށް ހުރި ނައްތާލުމެއް ދެވަނަ މީހަކު ހުއްދަދެންދެން މިތަނުގައި އިންތިޒާރުގައި ފެންނާނެއެވެ.",
        "emptyTitle": "ދިމާވާ ނައްތާލުމެއް ނެތް",
        "gainLossChooseEntity": "ފައިދާއާއި ގެއްލުމުގެ ތަހުލީލަކީ އެއް ފަހަރާ އެއް ޤާނޫނީ ފަރާތަކަށެވެ. މަތީގައި ޚިޔާރުކުރައްވާ.",
        "gainLossDescription": "މި މުއްދަތުގައި ޕޯސްޓްކުރި ކޮންމެ ނައްތާލުމެއްގެ ލިބުނު ފައިސާ، ނެޓް ބުކް ވެލިއުއާ އަޅާކިޔައިގެން. ހުއްދައަށް އިންތިޒާރުކުރާ ނައްތާލުމެއް މިތާ ނުހިމެނެއެވެ.",
        "gainLossEmptyDescription": "މި ޤާނޫނީ ފަރާތަށް މި މުއްދަތުގައި އެއްވެސް ނައްތާލުމެއް ޕޯސްޓްކޮށްފައެއް ނުވެއެވެ.",
        "gainLossEmptyTitle": "ޕޯސްޓްކުރި ނައްތާލުމެއް ނެތް",
        "gainLossFailed": "ފައިދާއާއި ގެއްލުމުގެ ތަހުލީލު ލޯޑު ނުކުރެވުނު",
        "gainLossTitle": "ނައްތާލުމުގެ ފައިދާއާއި ގެއްލުން",
        "loadFailed": "ނައްތާލުންތައް ލޯޑު ނުކުރެވުނު",
        "netGainLoss": "ސާފު ފައިދާ ނުވަތަ ގެއްލުން",
        "openInbox": "ހުއްދަތަކުގެ އިންބޮކްސް ހުޅުވާ",
        "pendingDetail": "ދެވަނަ މީހެއްގެ ހުއްދައަށް އިންތިޒާރުކުރަމުން. އެއްވެސް ޕޯސްޓިންއެއް ނުކުރެވެއެވެ؛ މުދާ އަދިވެސް ބޭނުންކުރަމުންދެއެވެ، އަދި އަދަދުތަކަކީ އެދުނު ވަގުތުގެ އަދަދުތަކެވެ.",
        "projectionNote": "ހުއްދައަށް އިންތިޒާރުކުރާ ނައްތާލުމެއްގެ ނެޓް ބުކް ވެލިއު އާއި ފައިދާ ނުވަތަ ގެއްލުމަކީ އެދުނު ވަގުތުގެ ލަފާއެކެވެ. ޕޯސްޓްކުރުމުން ނިމުނު އަދަދަށް ވާނެއެވެ.",
        "requestedBy": "އެދުނު ފަރާތް",
        "searchHint": "މުދަލުގެ ނަންބަރު ނުވަތަ ނަން، ނުވަތަ ރަސީދުގެ ރެފަރެންސް",
        "tabs": {
          "gainLoss": "ފައިދާއާއި ގެއްލުން",
          "label": "ނައްތާލުމުގެ ބެލުންތައް",
          "list": "ނައްތާލުންތައް"
        },
        "title": "ނައްތާލުންތައް",
        "totalGain": "ޖުމްލަ ފައިދާ",
        "totalLoss": "ޖުމްލަ ގެއްލުން",
        "totalNbv": "ނެޓް ބުކް ވެލިއު",
        "totalProceeds": "ލިބުނު ފައިސާ"
      },
      "entityById": "ޤާނޫނީ ފަރާތް #{id}",
      "events": {
        "approvedBy": "ހުއްދަދިން ފަރާތް",
        "recordedBy": "ރެކޯޑުކުރި ފަރާތް",
        "truncated": "ދައްކަނީ އެންމެ އާ {count} ހާދިސާ އެކަނި. ކުރީގެ ހާދިސާތައް ބެލުމަށް ހާދިސާގެ ބާވަތުން ދަތިކުރައްވާ."
      },
      "forecast": {
        "assetCount": "މުދާ",
        "charge": "ލަފާކުރާ ޗާޖް",
        "description": "މި މުއްދަތުގެ ތެރޭގައި ކޮންމެ މުދަލެއްގެ އުމުރު ނިމެންދެން ލަފާކުރާ ޑިޕްރިސިއޭޝަން، މުއްދަތު، ކްލާސް ނުވަތަ ކޮސްޓް ސެންޓަރުން.",
        "emptyDescription": "މި ފޮތުގައި ބޭނުންކުރަމުންދާ އެއްވެސް މުދަލަކަށް މި މުއްދަތުގައި ޗާޖެއް ލަފާކުރެވިފައެއް ނުވެއެވެ.",
        "emptyTitle": "ލަފާކުރާނެ އެއްޗެއް ނެތް",
        "groupBy": {
          "class": "މުދަލުގެ ކްލާސް",
          "cost_centre": "ކޮސްޓް ސެންޓަރު",
          "period": "މުއްދަތު"
        },
        "groupByLabel": "ގްރޫޕްކުރާނީ",
        "loadFailed": "ޑިޕްރިސިއޭޝަންގެ ލަފާކުރުން ލޯޑު ނުކުރެވުނު",
        "primaryBook": "މައި ފޮތް",
        "title": "ޑިޕްރިސިއޭޝަންގެ ޝެޑިއުލާއި ލަފާކުރުން",
        "total": "ޖުމްލަ"
      },
      "ic": {
        "approvalNote": "އެހެން ނައްތާލުމެއް ފަދައިން، ފޮނުވާ ޤާނޫނީ ފަރާތުގެ ނައްތާލުމުގެ ހައްދުން އަގު ނުވަތަ ނެޓް ބުކް ވެލިއު މައްޗަށް ހުރި ބަދަލުކުރުމެއް ދެވަނަ މީހަކު ހުއްދަދެންދެން ޕޯސްޓް ނުކުރެވޭނެއެވެ.",
        "asset": "މުދާ",
        "assetHint": "ފޮނުވާ ޤާނޫނީ ފަރާތުގެ ބޭނުންކުރަމުންދާ މުދަލެއް",
        "assetPlaceholder": "މުދަލެއް ޚިޔާރުކުރައްވާ",
        "caption": "ކުންފުނިތަކުގެ ދެމެދު މުދާ ބަދަލުކުރުން",
        "chooseSender": "ބަދަލުކުރުމެއް ފެށުމަށް މަތީގައި ފޮނުވާ ޤާނޫނީ ފަރާތް ޚިޔާރުކުރައްވާ.",
        "description": "ޤާނޫނީ ފަރާތްތަކުގެ ދެމެދު ބަދަލުކުރި މުދާ. ފޮނުވާ ފަރާތުގެ ނައްތާލުމުގެ ހައްދުން މައްޗަށް ހުރި ބަދަލުކުރުމެއް ދެވަނަ މީހެއްގެ ހުއްދައަށް މިތާ އިންތިޒާރުކުރެއެވެ.",
        "emptyDescription": "މަތިން، ނުވަތަ މުދަލުގެ އަމިއްލަ ސްކްރީނުން ބަދަލުކުރުމެއް ފައްޓަވާ.",
        "emptyTitle": "ކުންފުނިތަކުގެ ދެމެދު ބަދަލުކުރުމެއް ނެތް",
        "entityHint": "ފޮނުވާ ޤާނޫނީ ފަރާތް",
        "fromEntity": "ފޮނުވާ ފަރާތް",
        "listTitle": "ބަދަލުކުރުންތައް",
        "loadFailed": "ކުންފުނިތަކުގެ ދެމެދު ބަދަލުކުރުންތައް ލޯޑު ނުކުރެވުނު",
        "noAssets": "މި ޤާނޫނީ ފަރާތުގައި ބަދަލުކުރެވޭނެ ބޭނުންކުރަމުންދާ މުދަލެއް ނެތް.",
        "pendingEmptyTitle": "ހުއްދައަށް އިންތިޒާރުކުރާ ބަދަލުކުރުމެއް ނެތް",
        "pendingNote": "މި ބަދަލުކުރުންތައް އަދި ޕޯސްޓްކޮށްފައެއް ނުވެއެވެ. ދެވަނަ މީހަކު ހުއްދަދެންދެން ކޮންމެ މުދަލެއް ފޮނުވާ ޤާނޫނީ ފަރާތުގައި ބޭނުންކުރަމުން ގެންދާނެއެވެ.",
        "pendingTitle": "ހުއްދައަށް އިންތިޒާރުގައި",
        "startDescription": "ފޮނުވާ ޤާނޫނީ ފަރާތުގެ މުދަލެއް ޚިޔާރުކޮށް، ލިބޭ ފަރާތާއި، ތާރީޚާއި، އަގު ކަނޑައަޅުއްވާ.",
        "startTitle": "ބަދަލުކުރުމެއް ފަށާ",
        "submittedDetail": "{assetNo} ގެ ބަދަލުކުރުމަކީ ނައްތާލުމުގެ ހުއްދައިގެ ހައްދުން މައްޗަށް ހުރި އެއްޗެކެވެ. ދެވަނަ މީހަކު ހުއްދަދެންދެން ދެ ޤާނޫނީ ފަރާތުގައިވެސް އެއްވެސް ޕޯސްޓިންއެއް ނުކުރެވޭނެއެވެ.",
        "title": "ކުންފުނިތަކުގެ ދެމެދު ބަދަލުކުރުން",
        "toClass": "ލިބޭ ފަރާތުގެ މުދަލުގެ ކްލާސް",
        "toClassDefault": "އެއް ކޯޑުގެ ކްލާސް",
        "toClassHint": "އިޚްތިޔާރީ. ހުސްކޮށް ބާއްވައިފިނަމަ، ލިބޭ ޤާނޫނީ ފަރާތުގެ އެއް ކޯޑުގެ ހަރަކާތްތެރި ކްލާސް ބޭނުންކުރެވޭނެއެވެ."
      },
      "people": {
        "userById": "ޔޫޒަރު #{id}"
      },
      "preview": {
        "account": "ހިސާބު",
        "action": "ކުރިން ބަލާ",
        "allBooks": "ހުރިހާ ހަރަކާތްތެރި ފޮތެއް",
        "book": "ފޮތް",
        "bookHint": "ހުރިހާ ހަރަކާތްތެރި ފޮތަކަށް ހުސްކޮށް ބާއްވާ",
        "bookTitle": "ފޮތް {book}",
        "bookTotal": "{count} ޗާޖް، ޖުމްލަ",
        "charge": "ޗާޖް",
        "chargeCount": "ޗާޖްތައް",
        "closingNbv": "ނިމޭއިރު ނެޓް ބުކް ވެލިއު",
        "confirm": "{period} ގެ ޑިޕްރިސިއޭޝަން، ކުރިން ބެލި ގޮތަށް ޕޯސްޓްކުރަންތޯ؟",
        "confirmPost": "ކަށަވަރުކޮށް ޕޯސްޓްކުރޭ",
        "credit": "ކްރެޑިޓް",
        "debit": "ޑެބިޓް",
        "description": "ޑިޕްރިސިއޭޝަން ރަނެއް ޗާޖްކުރާނެ ގޮތް، ކޮންމެ މުދަލަކާއި ފޮތަކަށް، އެއްވެސް ޕޯސްޓިންއެއް ކުރުމުގެ ކުރިން ބައްލަވާ.",
        "differs": "ޕޯސްޓްކުރި ޖުމްލަ ކުރިން ބެލި ޖުމްލައާ ތަފާތެވެ: ދެމެދުގައި އެއްޗެއް ބަދަލުވެއްޖެއެވެ.",
        "emptyDescription": "ޤާނޫނީ ފަރާތާއި، ރަން ހަދާ ތާރީޚާއި، ބޭނުންފުޅުނަމަ އެއް ފޮތެއް ޚިޔާރުކުރައްވާ. ދެން ކުރިން ބައްލަވާ.",
        "emptyTitle": "އަދި އެއްވެސް އެއްޗެއް ކުރިން ބަލާފައެއް ނުވޭ",
        "failed": "ކުރިން ބެލުން ނާކާމިޔާބުވެއްޖެ",
        "journalLines": "ޖާނަލް ސަތުރުތައް",
        "noCharges": "މި މުއްދަތަށް މި ފޮތުގައި ޗާޖްކުރާނެ އެއްޗެއް ނެތް.",
        "noGl": "ޕޯސްޓް ނުކުރޭ",
        "noLines": "ޖާނަލެއް ނެތް",
        "on": "ރަން ހަދާ ތާރީޚު",
        "onHint": "ރަން ހަދާ ތާރީޚު؛ ޗާޖްކުރަނީ އޭގެ މުއްދަތަށް",
        "openingNbv": "ފަށާއިރު ނެޓް ބުކް ވެލިއު",
        "period": "މުއްދަތު",
        "periodNo": "މުއްދަތުގެ ނަންބަރު",
        "post": "ޑިޕްރިސިއޭޝަން ޕޯސްޓްކުރޭ",
        "postExplain": "ޕޯސްޓްކުރުމުން ކުރިން ބެލި ތާރީޚާއި ފޮތަށް ޑިޕްރިސިއޭޝަން ހަދާނެއެވެ. މުއްދަތަށް ކުރިން ރަން ހަދާފައިވާނަމަ ރައްދުކުރެވޭނެއެވެ.",
        "postFailed": "ޑިޕްރިސިއޭޝަން ރަން ނާކާމިޔާބުވެއްޖެ",
        "posted": "ޑިޕްރިސިއޭޝަން ޕޯސްޓްކުރެވިއްޖެ",
        "postedDetail": "{period} ގެ ޑިޕްރިސިއޭޝަން ޕޯސްޓްކުރެވިއްޖެއެވެ.",
        "postsToGl": "ލެޖަރަށް ޕޯސްޓްކުރޭ",
        "primary": "މައި",
        "resultCount": "{count} މުދަލަށް ޗާޖްކުރެވިއްޖެ",
        "resultNothing": "އެއްވެސް އެއްޗެއް ޗާޖް ނުކުރެވުނު: ހުރިހާ މުދަލަކަށްވެސް މި މުއްދަތަށް ކުރިން ޗާޖްކުރެވިފައިވެއެވެ.",
        "resultTitle": "ރަންގެ ނަތީޖާ",
        "runDate": "ރަން ތާރީޚު",
        "showLines": "{count} ސަތުރު ދައްކާ",
        "skipped": "ޗާޖް ނުކުރެވުނު {count} މުދާ:",
        "stale": "މި ކުރިން ބެލުމަށްފަހު މަޢުލޫމާތު ބަދަލުވެއްޖެއެވެ. ޕޯސްޓްކުރުމުގެ ކުރިން އަލުން ކުރިން ބައްލަވާ.",
        "title": "ޑިޕްރިސިއޭޝަންގެ ކުރިން ބެލުން",
        "totalCharge": "ޖުމްލަ ޗާޖް",
        "writesNothing": "ކުރިން ބެލުމަކުން އެއްވެސް އެއްޗެއް ނުލިޔެއެވެ: ރަނެއް، ޖާނަލެއް ނުވަތަ އޮޑިޓް އެންޓްރީއެއް ނޫން. ބަންދުކޮށްފައިވާ މުއްދަތަކަށް ރަން ރައްދުކުރާ ގޮތަށް މިވެސް ރައްދުކުރެވޭނެއެވެ."
      },
      "register": {
        "book": "ފޮތް",
        "bookFailed": "އެ ފޮތުގެ އަދަދުތައް ލޯޑު ނުކުރެވުނު.",
        "bookHint": "އަގާއި، ޑިޕްރިސިއޭޝަނާއި، ނެޓް ބުކް ވެލިއު އެހެން ފޮތެއްގައި ދައްކާ",
        "bookLoading": "ފޮތުގެ އަދަދުތައް ލޯޑުކުރަނީ.",
        "bookNote": "އަގާއި، ޖަމާވެފައިވާ ޑިޕްރިސިއޭޝަނާއި، ނެޓް ބުކް ވެލިއު ދައްކަނީ ފޮތް {book} ގައި، {asOf} ގެ ނިޔަލަށް. އެ ފޮތުގައި ނެތް މުދަލަކަށް ދައްކަނީ ޑޭޝެކެވެ.",
        "costCentreHint": "ޑިޕްރިސިއޭޝަން ޗާޖް ޕޯސްޓްކުރާ ތަން",
        "expiringHint": "މި ތާރީޚު ނުވަތަ އޭގެ ކުރިން",
        "insuranceExpiringBefore": "އިންޝުއަރެންސް ނިމޭނީ",
        "insuranceExpiry": "އިންޝުއަރެންސްގެ މުއްދަތު ހަމަވާ ތާރީޚު",
        "insurancePolicy": "އިންޝުއަރެންސް ޕޮލިސީ",
        "notInBook": "މި ފޮތުގައި ނެތް",
        "primaryBook": "މައި ފޮތް",
        "serialNo": "ސީރިއަލް ނަންބަރު",
        "serialNoHint": "ހަދާ ފަރާތުގެ ސީރިއަލް، ގުނުމުގެ ވެރިފިކޭޝަނަށް",
        "sourceRef": "އަސްލުގެ ރެފަރެންސް",
        "sourceRefHint": "މުދާ އައި ގަނޑުއަމުރު، އިންވޮއިސް، ޕްރޮޖެކްޓް ނުވަތަ ބިނާކުރަމުންދާ މަސައްކަތުގެ ރެކޯޑު",
        "tagNo": "މުދަލުގެ ޓެގް",
        "tagNoHint": "ފިޒިކަލް ޓެގް؛ ޤާނޫނީ ފަރާތުގެ ތެރޭގައި އެކަތި",
        "tagSerial": "ޓެގް / ސީރިއަލް",
        "warrantyExpiringBefore": "ވޮރަންޓީ ނިމޭނީ",
        "warrantyExpiry": "ވޮރަންޓީގެ މުއްދަތު ހަމަވާ ތާރީޚު"
      },
      "schedulePreview": {
        "description": "މަތީގައިވާ އަދަދުތަކުން، މި މުދަލުގެ މައި ފޮތުގައި އުމުރު ނިމެންދެން ކޮންމެ މުއްދަތަކަށް ހުންނާނެ ޝެޑިއުލް. ކަށަވަރުކުރައްވަންދެން އެއްވެސް އެއްޗެއް ސޭވެއް ނުކުރެވޭނެ.",
        "incomplete": "ޝެޑިއުލް ބެލުމަށް ކްލާސެއް ޚިޔާރުކޮށް، އަގާއި ބޭނުންކުރަން ފަށާ ތާރީޚު ލިޔުއްވާ.",
        "residual": "އުމުރު ނިމޭއިރު ނެޓް ބުކް ވެލިއު",
        "showAll": "ހުރިހާ {count} މުއްދަތު ދައްކާ",
        "title": "ޑިޕްރިސިއޭޝަން ޝެޑިއުލްގެ ކުރިން ބެލުން",
        "total": "ޖުމްލަ ޑިޕްރިސިއޭޝަން",
        "updating": "ބަދަލުކުރެއްވި އަދަދުތަކަށް އަޕްޑޭޓްކުރަނީ."
      },
      "settings": {
        "accountById": "ހިސާބު #{id}",
        "amountHint": "ޤާނޫނީ ފަރާތުގެ ބޭސް ފައިސާއިން، ސުން ނުވަތަ އެއަށްވުރެ ގިނަ",
        "amountInvalid": "އަދަދު ސާދާ ޑެސިމަލް ނަންބަރަކަށް ލިޔުއްވާ",
        "amountNegative": "ހައްދަކީ ނެގެޓިވް އަދަދަކަށް ނުވާނެ",
        "awaitsApproval": "ހުއްދައަށް އިންތިޒާރުގައި",
        "awaitsApprovalDetail": "މި ބަދަލަކީ ކޮންޓްރޯލެއް ލުއިކުރާ ބަދަލެކެވެ، އެހެންކަމުން އަދި ހިނގަމުންނުދެއެވެ. ހިނގާނީ ދެވަނަ މީހަކު ހުއްދަދިނުމުންނެވެ.",
        "cip": {
          "description": "ކެޕިޓަލައިޒްކުރުމުގައި ބިނާކުރަމުންދާ މަސައްކަތުގެ ގޮތުގައި ބެލެންސް ހުށަހަޅާ ލެޖަރ ހިސާބު. އެއް ނެތްނަމަ CIP އަސްލެއް ނެތް.",
          "field": "ބިނާކުރަމުންދާ މަސައްކަތުގެ ހިސާބު",
          "none": "ކަނޑައަޅާފައެއް ނެތް",
          "remove": "ހިސާބު ނައްތާލާ",
          "title": "ބިނާކުރަމުންދާ މަސައްކަތުގެ ހިސާބު"
        },
        "controlRule": "ހައްދެއް ދަތިކުރުން (ކަނޑައެޅުން، ނުވަތަ ދަށްކުރުން) ވަގުތުން ހިނގައެވެ. ލުއިކުރުން (މައްޗަށް އެރުވުން، ނުވަތަ ނައްތާލުން) ދެވަނަ މީހެއްގެ ހުއްދައަށް އިންތިޒާރުކުރެއެވެ، އަދި އެހިނދަށް ތިރީގައި ފެންނާނެއެވެ.",
        "description": "ކޮންމެ ޤާނޫނީ ފަރާތަކަށް: ނައްތާލުމަކަށް ނުވަތަ އިމްޕެއަރމަންޓަކަށް ދެވަނަ މީހެއްގެ ހުއްދަ ބޭނުންވާ އަދަދުތަކާއި، ބިނާކުރަމުންދާ މަސައްކަތުގެ ހިސާބު.",
        "disposal": {
          "description": "ލިބޭ ފައިސާ ނުވަތަ ނެޓް ބުކް ވެލިއު (ބޮޑު އަދަދު) މި އަދަދަށް ވުރެ ބޮޑު ނައްތާލުމަކީ ދެވަނަ މީހަކު ހުއްދަދިނުމުން އެކަނި ޕޯސްޓްކުރެވޭ އެދުމެކެވެ.",
          "field": "ނައްތާލުމުގެ ހުއްދައިގެ ހައްދު",
          "title": "ނައްތާލުމުގެ ހުއްދައިގެ ހައްދު"
        },
        "impairment": {
          "description": "މި އަދަދަށް ވުރެ ބޮޑު އިމްޕެއަރމަންޓް ގެއްލުމެއް ހިނގާނީ ދެވަނަ މީހަކު ހުއްދަދިނުމުން އެކަނިއެވެ.",
          "field": "އިމްޕެއަރމަންޓްގެ ހުއްދައިގެ ހައްދު",
          "title": "އިމްޕެއަރމަންޓްގެ ހުއްދައިގެ ހައްދު"
        },
        "inForce": "ހިނގަމުންދާ",
        "loadFailed": "މުދަލުގެ ސެޓިންގްސް ލޯޑު ނުކުރެވުނު",
        "noThreshold": "ހައްދެއް ނެތް: ހުއްދައެއް ބޭނުމެއް ނުވޭ",
        "pendingBadge": "ބަދަލު ހުއްދައަށް އިންތިޒާރުގައި",
        "pendingRule": "ދެވަނަ މީހަކު ހުއްދަދެންދެން ނުހިނގާނެއެވެ. މިހާރު ހައްދު ދަތިކޮށްފިނަމަ މި އެދުން ބާތިލުވާނެއެވެ.",
        "proposed": "ހުށަހެޅި:",
        "proposedBy": "{name} ހުށަހެޅީ",
        "proposedRemoval": "ހައްދު ނައްތާލުން",
        "readOnly": "މި ސެޓިންގްސް ކިޔޭނެއެވެ. ބަދަލުކުރުމަށް މުދަލުގެ ސެޓިންގްސްގެ ހުއްދަ ބޭނުންވެއެވެ.",
        "reloaded": "ތިޔަ ބޭފުޅާ ބަދަލުކުރަމުން ގެންދިޔައިރު މި ސެޓިންގްސް އެހެން މީހަކު ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑުކޮށްފިއެވެ؛ ތިޔަ އަދަދު ރައްކާވެފައިވެއެވެ. ބަލާފައި އަލުން ސޭވްކުރައްވާ.",
        "removeThreshold": "ހައްދު ނައްތާލާ",
        "saveFailed": "ސެޓިންގްސް ސޭވް ނުކުރެވުނު",
        "saved": "ސެޓިންގްސް ސޭވްކުރެވިއްޖެ",
        "title": "މުދަލުގެ ސެޓިންގްސް"
      },
      "windowInvalid": "ނިމޭ ތާރީޚަކީ ފަށާ ތާރީޚު ނުވަތަ އޭގެ ފަހުގެ ތާރީޚަކަށް ވާން ޖެހޭ"
    },
    "bookEdit": {
      "edit": "ބަދަލުކުރޭ",
      "title": "ފޮތް {code} ބަދަލުކުރޭ",
      "description": "ނަން، ކޮންވެންޝަން، ތަފްޞީލު، ނުވަތަ ފޮތް ހިންގާތޯ ބަދަލުކުރޭ.",
      "loadFailed": "މި ފޮތުގެ އެންމެ ފަހުގެ ވަރޝަން ލޯޑުނުކުރެވުނު.",
      "stale": "ތިޔަ ބަދަލުކުރަމުންދިޔަ ވަގުތު މި ފޮތް އެހެން މީހަކު ސޭވްކޮށްފި. ސޭވްކުރެވިފައިވާ ވަރޝަން ރީލޯޑްކޮށް، ތިޔަ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ސޭވްކުރެވިފައިވާ ވަރޝަން ރީލޯޑްކުރޭ",
      "fixedHint": "ފޮތެއް ހެދުމަށްފަހު، އެ ފޮތުގެ ބާވަތާއި، ޕްރައިމަރީ ފޮތްތޯއާއި، ޖީއެލްއަށް ޕޯސްޓްކުރާތޯ ބަދަލެއް ނުކުރެވޭނެ.",
      "conventionHint": "މިހިން ފެށިގެން ހިސާބުކުރާ ޑިޕްރީޝިއޭޝަނަށް ހިނގާނެ. ކުރިން ޗާޖްކުރެވިފައިވާ މުއްދަތުތަކަށް ބަދަލެއް ނާދޭ.",
      "active": "ހިނގަމުންދާ",
      "activeHint": "ނުހިނގާ ފޮތަކަށް އިތުރު އެސެޓެއް ނުވެއްދޭނެ. މިހާރު އޭގައި ހުރި އެސެޓްތައް ޑިޕްރީޝިއޭޓްވުން ކުރިއަށްދާނެ.",
      "saved": "ފޮތް ސޭވްކުރެވިއްޖެ",
      "saveFailed": "ފޮތް ސޭވްނުކުރެވުނު"
    },
    "assetBookAccounts": {
      "edit": "އެކައުންޓްތައް",
      "title": "ޖީއެލް އެކައުންޓްތައް — {book}",
      "description": "މި ފޮތުގައި މި އެސެޓް ބޭނުންކުރާ އެކައުންޓްތައް ބަދަލުކުރޭ. ބަދަލުވާނީ ކުރިއަށް އޮތް ޕޯސްޓިންގތައް އެކަނި.",
      "stale": "ތިޔަ ބަދަލުކުރަމުންދިޔަ ވަގުތު މި އެސެޓުގެ ފޮތް އެހެން މީހަކު ބަދަލުކޮށްފި. ސޭވްކުރެވިފައިވާ ވަރޝަން ރީލޯޑްކޮށް، ތިޔަ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ސޭވްކުރެވިފައިވާ ވަރޝަން ރީލޯޑްކުރޭ",
      "noChart": "އެކައުންޓްތަކުގެ ޗާޓު ކިޔުމުގެ ހުއްދައެއް ނެތުމުން، މިތަނުން އެކައުންޓެއް ނުހޮވޭނެ. އެކައުންޓްތަކުގެ ޗާޓު ކިޔުމުގެ ހުއްދަ ހޯދާ.",
      "clearHint": "އެސެޓް ކްލާހުގެ އެކައުންޓް ބޭނުންކުރުމަށް ފީލްޑް ހުސްކޮށް ބާއްވާ. ޕޯސްޓްނުކުރެވޭ ނުވަތަ އެހެން ކުންފުންޏެއްގެ އެކައުންޓެއް ސާވަރުން ބަލައެއް ނުގަންނާނެ.",
      "classDefault": "ކްލާހުގެ ޑިފޯލްޓް",
      "fields": {
        "assetAccountId": "އެސެޓް (ކޮސްޓް) އެކައުންޓް",
        "accumulatedDepreciationAccountId": "ޖަމާވި ޑިޕްރީޝިއޭޝަންގެ އެކައުންޓް",
        "depreciationExpenseAccountId": "ޑިޕްރީޝިއޭޝަން ޚަރަދުގެ އެކައުންޓް",
        "impairmentExpenseAccountId": "އިމްޕެއަރމަންޓް ގެއްލުމުގެ އެކައުންޓް",
        "impairmentReversalAccountId": "އިމްޕެއަރމަންޓް ރިވާސަލްގެ އެކައުންޓް",
        "gainLossAccountId": "ނައްތާލުމުގެ ފައިދާ ނުވަތަ ގެއްލުމުގެ އެކައުންޓް"
      },
      "saved": "އެކައުންޓްތައް ސޭވްކުރެވިއްޖެ",
      "saveFailed": "އެކައުންޓްތައް ސޭވްނުކުރެވުނު"
    },
    "bookSchedule": {
      "show": "ޝެޑިއުލް",
      "hide": "ޝެޑިއުލް ފޮރުވާ",
      "loadFailed": "ޑިޕްރީޝިއޭޝަން ޝެޑިއުލް ލޯޑުނުކުރެވުނު.",
      "title": "ޑިޕްރީޝިއޭޝަން ޝެޑިއުލް — {book}، {asset}",
      "empty": "މި ފޮތުގައި ދައްކާނެ މުއްދަތެއް އަދި ނެތް. އެސެޓް ބޭނުންކުރަން ފެށުމުން ޝެޑިއުލް ފުރިގެންދާނެ.",
      "period": "މުއްދަތު",
      "when": "މުއްދަތު ނުވަތަ ތާރީޚް",
      "opening": "ފެށުނު ކެރީއިންގ އަދަދު",
      "charge": "ޑިޕްރީޝިއޭޝަން",
      "closing": "ނިމުނު ކެރީއިންގ އަދަދު",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "projected": "ލަފާކުރެވޭ"
    },
    "impairmentCreate": {
      "open": "އިމްޕެއަރމަންޓް ރެކޯޑުކުރޭ",
      "title": "އިމްޕެއަރމަންޓެއް ރެކޯޑުކުރޭ",
      "description": "އެއް ފޮތުގައި އެއް އެސެޓުގެ ގެއްލުން މިނޭ: ކެރީއިންގ އަދަދު، ރިކަވަރ ކުރެވޭނެ އަދަދާ އަޅާކިޔައި.",
      "twoStep": "ރެކޯޑުކުރުމުން ޕޯސްޓެއް ނުކުރެވޭ. ޕޯސްޓްކުރުމަކީ އިމްޕެއަރމަންޓް ޕޯސްޓްކުރުމުގެ ހުއްދަ ލިބިފައިވާ މީހަކު ކުރާ ވަކި ފިޔަވަޅެއް، އެހެންކަމުން ގެއްލުން މިނުމާއި ބުކްކުރުން ކުރަނީ ދެ މީހުން.",
      "noAssetRead": "އެސެޓް ރަޖިސްޓަރު ކިޔުމުގެ ހުއްދައެއް ނެތުމުން، މިތަނުން އެސެޓެއް ނުހޮވޭނެ. އެސެޓް ކިޔުމުގެ ހުއްދަ ހޯދާ.",
      "assetPlaceholder": "ބޭނުންކުރަމުންދާ އެސެޓެއް ހޮވާ",
      "amountInvalid": "ދެ ޑެސިމަލަށްވުރެ ގިނަ ނޫން ސާދާ އަދަދެއް ޖައްސަވާ، މިސާލަކަށް 90000.00.",
      "reasonCode": "ސަބަބުގެ ކޯޑު",
      "confirm": "އިމްޕެއަރމަންޓް ރެކޯޑުކުރޭ",
      "created": "އިމްޕެއަރމަންޓް ރެކޯޑުކުރެވިއްޖެ — ޕޯސްޓްކުރުމަށް މަޑުކުރަނީ",
      "failed": "އިމްޕެއަރމަންޓް ރެކޯޑުނުކުރެވުނު",
      "booksFailed": "ކުންފުނީގެ ޑިޕްރީޝިއޭޝަން ފޮތްތައް ލޯޑުނުކުރެވުމުން، މި ކުންފުންޏަށް އިމްޕެއަރމަންޓްތައް ނުދެއްކޭނެ."
    },
    "indicatorCreate": {
      "open": "އިންޑިކޭޓަރެއް ފާހަގަކުރޭ",
      "title": "އިމްޕެއަރމަންޓް އިންޑިކޭޓަރެއް ފާހަގަކުރޭ",
      "description": "އެސެޓަކަށް — ނުވަތަ މުޅި ކްލާހަކަށް — އިމްޕެއަރމަންޓެއް ވެދާނެކަމުގެ ނިޝާނެއް ރެކޯޑުކުރޭ. ދެން މި އިންޑިކޭޓަރު ބަލާނީ ރޭގަނޑު ޗެކުން ފާހަގަކުރާ އިންޑިކޭޓަރެއް ފަދައިން.",
      "scope": "ކަމާބެހޭ",
      "scopeAsset": "އެއް އެސެޓް",
      "scopeClass": "މުޅި އެސެޓް ކްލާހެއް",
      "class": "އެސެޓް ކްލާސް",
      "classPlaceholder": "ކްލާހެއް ހޮވާ",
      "indicator": "އިންޑިކޭޓަރު",
      "confirm": "އިންޑިކޭޓަރު ފާހަގަކުރޭ",
      "created": "އިންޑިކޭޓަރު ފާހަގަކުރެވިއްޖެ",
      "failed": "އިންޑިކޭޓަރު ފާހަގަ ނުކުރެވުނު"
    },
    "disposeFt6": {
      "alreadyPending": "މި މުދަލުގެ ނައްތާލުމެއް މިހާރުވެސް ހުއްދައަށް އިންތިޒާރުކުރަމުންދެއެވެ. އެ އެދުން ނިންމަންދެން މި މުދާ ބޭނުންކުރަމުން ގެންދާނެއެވެ؛ އެ ދުވަސްވަރު އެހެން ނައްތާލުމެއް ނުހެދޭނެއެވެ.",
      "errors": {
        "approvalUnresolvable": "މި ނައްތާލުން ހުއްދައަށް ބޭނުންވާ ހައްދުން މައްޗެވެ، އަދި މުދާ ނައްތާލުމަށް ތިޔަ ބޭފުޅާ ނޫން ހުއްދަދޭނެ މީހަކު ކަނޑައަޅާފައެއް ނުވެއެވެ. މުދާ ނައްތާލުމަށް ހުއްދަ ސިޔާސަތެއް ނުވަތަ ބާރުގެ ޖަދުވަލުގެ ޤަވާއިދެއް އެޑްމިނިސްޓްރޭޓަރަކު ހަދަންވާނެއެވެ."
      },
      "fields": {
        "method": "ނައްތާލާ ގޮތް",
        "methodDefault": "ލިބުނު ފައިސާއިން (ވިއްކުން، ނުވަތަ ނުލިބިއްޖެނަމަ ސްކްރެޕް)",
        "methodHint": "ވިއްކުމުގައި ފައިސާ ލިބެއެވެ؛ ރައިޓް-އޮފް ނުވަތަ ހަދިޔާގައި ނުލިބެއެވެ؛ ސްކްރެޕްގައި ސްކްރެޕް އަގު ލިބިދާނެއެވެ",
        "receiptRef": "ލިބުނު ފައިސާގެ ރަސީދު ރެފަރެންސް",
        "receiptRefHint": "ފައިސާ ލިބުނު ރަސީދު ނުވަތަ ބޭންކް ރެފަރެންސް"
      },
      "methods": {
        "donation": "ހަދިޔާ",
        "sale": "ވިއްކުން",
        "scrap": "ސްކްރެޕް",
        "write_off": "ރައިޓް-އޮފް",
        "ic_transfer": "އިންޓަރކޮމްޕެނީ ބަދަލު"
      },
      "pendingBadge": "ނައްތާލުން ހުއްދައަށް އިންތިޒާރުގައި",
      "submitted": "ހުއްދައަށް ހުށަހަޅައިފި",
      "submittedDetail": "{assetNo} އަކީ ނައްތާލުމުގެ ހުއްދައަށް ބޭނުންވާ ހައްދުން މައްޗަށް ހުރި މުދަލެކެވެ. އެދުން ހުއްދަދެވެންދެން މި މުދާ ބޭނުންކުރަމުން ގެންދާނެ، އަދި އެއްވެސް ޕޯސްޓިންއެއް ނުކުރެވޭނެއެވެ."
    },
    "ft9": {
      "approval": {
        "approved": "ހުއްދަ ދެވިފައި",
        "cancelled": "ބާތިލުކުރެވިފައި",
        "column": "ހުއްދަ",
        "lapsed": "ބާޠިލުވެފައި",
        "none": "ބޭނުމެއް ނެތް",
        "pending": "ހުއްދައަށް އިންތިޒާރުގައި",
        "rejected": "ބާރުލާފައި",
        "submitted": "ހުއްދައަށް ހުށަހަޅައިފި",
        "submittedDetail": "{assetNo} ގެ އިމްޕެއަރމަންޓް ގެއްލުން ހުއްދައަށް ބޭނުންވާ ހައްދުން މައްޗެވެ. ދެވަނަ މީހަކު ހުއްދަ ނުދެއްވަންދެން އެއްވެސް ބަދަލެއް ނުގެނެވޭނެ، އަދި އެއްވެސް ޕޯސްޓިންއެއް ނުކުރެވޭނެއެވެ.",
        "unresolvable": "މި އިމްޕެއަރމަންޓް ހުއްދައަށް ބޭނުންވާ ހައްދުން މައްޗެވެ، އަދި މުދަލުގެ އިމްޕެއަރމަންޓްތަކަށް ތިޔަ ބޭފުޅާ ނޫން ހުއްދަދޭނެ މީހަކު ކަނޑައަޅާފައެއް ނުވެއެވެ. އެޑްމިނިސްޓްރޭޓަރަކު ހުއްދަ ސިޔާސަތެއް ހަދަންވާނެއެވެ."
      },
      "capitalize": {
        "balanceDescription": {
          "cip": "ލެޖަރުގައި ބާކީއެއް ހުރި ބިނާކުރުމުގެ ޚަރަދުތައް. ބާކީ ނެތް ސޯސްއެއް ނުދައްކާނެއެވެ.",
          "project": "ލެޖަރުގައި ވޯކް އިން ޕްރޮގްރެސް ބާކީއެއް ހުރި ނިމިފައިވާ ޕްރޮޖެކްޓްތައް. ބާކީ ނެތް ޕްރޮޖެކްޓެއް ނުދައްކާނެއެވެ."
        },
        "balanceIs": "{account} ގައި ހުރި ލެޖަރު ބާކީ:",
        "balancePanel": "ސޯސްގެ ބާކީ",
        "costHint": "ލާޒިމް. ކެޕިޓަލައިޒްކުރާ ޚަރަދު، ސޯސްގެ ބާކީއަށްވުރެ ބޮޑެއް ނުވާނެ",
        "exceedsBalance": "ޚަރަދަކީ މި ސޯސްގައި ބާކީ ހުރި ޢަދަދަށްވުރެ ބޮޑު ޢަދަދެކެވެ. ޚަރަދު ދައްކާފައިވާ ބާކީއަށް ހެޔޮ ކުރާށެވެ.",
        "inServiceHint": "ލާޒިމް. ޚަރަދު މުދަލުގެ އެކައުންޓަށް ބަދަލުވާ ތާރީޚް",
        "kind": "ޚަރަދުގެ ސޯސް",
        "kinds": {
          "cip": "ބިނާކުރަމުންދާ މުދާ",
          "cipHint": "ބިނާކުރަމުންދާ މުދަލުގެ އެކައުންޓުގައި ހުރި ޚަރަދު",
          "project": "ނިމިފައިވާ ޕްރޮޖެކްޓް",
          "projectHint": "ނިމިފައިވާ ޕްރޮޖެކްޓެއްގެ ވޯކް އިން ޕްރޮގްރެސް",
          "purchase": "ގަނެވުން (އޭޕީ އިންވޮއިސް ލައިން)",
          "purchaseHint": "ޕޯސްޓްކުރެވިފައިވާ ސަޕްލައަރ އިންވޮއިސް ލައިނެއް؛ އެއްވެސް ޕޯސްޓިންއެއް ނުކުރެއެވެ"
        },
        "noSources": "މި ލީގަލް އެންޓިޓީއަށް މި ސޯސްއިން ކެޕިޓަލައިޒްކުރަން އިންތިޒާރުކުރާ އެއްވެސް ކަމެއް ނެތެވެ.",
        "postsFromSource": "މިއީ ޖާނަލެއް ޕޯސްޓްކުރާ ކަމެކެވެ: ޚަރަދު މުދަލުގެ އެކައުންޓަށް ޑެބިޓް، ޕްރޮޖެކްޓް ވޯކް އިން ޕްރޮގްރެސް ނުވަތަ ބިނާކުރަމުންދާ މުދަލުގެ އެކައުންޓުން ކްރެޑިޓް ކުރެވި، ބޭނުންކުރަން ފަށާ ތާރީޚުގައި ބަދަލުވެއެވެ.",
        "sourceDescription": "އާ މުދަލުގެ ޚަރަދު ކޮންތާކުން އަންނަނީ ކަމެވެ.",
        "sourceHint": "ލެޖަރުގައި ޙަޤީޤީ ބާކީއެއް ހުރި ސޯސްތައް ކަނޑައެޅެއެވެ",
        "sourceLabel": {
          "cip": "ބިނާކުރަމުންދާ މުދަލުގެ އެކައުންޓް",
          "project": "ޕްރޮޖެކްޓް"
        },
        "sourcePanel": "ސޯސް",
        "sourcePlaceholder": "ސޯސްއެއް އިޚްތިޔާރުކުރައްވާ",
        "sourceSearchHint": "ކޯޑް ނުވަތަ ނަން",
        "sourcesFailed": "ކެޕިޓަލައިޒްކުރެވޭނެ ސޯސްތައް ލޯޑްކުރެވެނީ ނުވެ"
      },
      "eventTypes": {
        "acquire": "ލިބުނު",
        "book_change": "ބުކް ބަދަލު",
        "capitalise": "ކެޕިޓަލައިޒްކުރެވުނު",
        "componentise": "ބައިތަކަށް ބެހުނު",
        "depreciate": "ޑިޕްރީޝިއޭޓްކުރެވުނު",
        "dispose": "ނައްތާލެވުނު",
        "ic_transfer": "އިންޓަރކޮމްޕެނީ ބަދަލު",
        "impair": "އިމްޕެއަރކުރެވުނު",
        "impair_reverse": "އިމްޕެއަރމަންޓް ރިވާސްކުރެވުނު",
        "revalue": "ރިވެލިއުކުރެވުނު",
        "transfer": "ތަން ބަދަލުކުރެވުނު",
        "update": "އެޑިޓްކުރެވުނު"
      },
      "events": {
        "amount": "ޢަދަދު",
        "caption": "މި މުދަލުގެ އިވެންޓްތައް، އެންމެ އައު ފުރަތަމަ",
        "change": "ބަދަލު",
        "date": "ތާރީޚް",
        "description": "މި މުދަލަށް ގެނައި ކޮންމެ ބަދަލެއް، އެންމެ އައު ފުރަތަމަ. ޤައިދުތައް ބަދަލުނުކުރެވޭނެއެވެ.",
        "empty": "މި މުދަލަށް އަދި އެއްވެސް އިވެންޓެއް ރެކޯޑްކުރެވިފައެއް ނުވެއެވެ.",
        "journal": "ޖާނަލް",
        "loadFailed": "އިވެންޓް ލޮގް ލޯޑްކުރެވެނީ ނުވެ",
        "title": "އިވެންޓް ލޮގް",
        "type": "އިވެންޓް"
      },
      "ic": {
        "action": "ލީގަލް އެންޓިޓީއަކަށް ބަދަލުކުރައްވާ",
        "date": "ބަދަލުކުރާ ތާރީޚް",
        "dateHint": "ދެ ލީގަލް އެންޓިޓީގެވެސް ހުޅުވިފައިވާ މުއްދަތެއްގައި ހުންނަންވާނެ",
        "description": "މި މުދާ ޓެނަންޓްގެ އެހެން ލީގަލް އެންޓިޓީއަކަށް ބަދަލުކުރައްވާ.",
        "done": "މުދާ ބަދަލުކުރެވިއްޖެ",
        "doneDetail": "{from} ބަދަލުކުރެވި، ލިބޭ ލީގަލް އެންޓިޓީގައި {to} ގެ ގޮތުގައި ރަޖިސްޓްރީކުރެވިއްޖެއެވެ.",
        "errors": {
          "blocked": "މި މުދާ މިހާރުގެ ގޮތުގައި އޭގެ ލީގަލް އެންޓިޓީއިން ނުނިކުމެވޭނެއެވެ: ހުއްދައަށް އިންތިޒާރުކުރާ ނައްތާލުމެއް، ފޮތުގައި ހުރި ނުވަތަ ހުއްދައަށް އިންތިޒާރުކުރާ އިމްޕެއަރމަންޓެއް، ނުވަތަ ބައިތައް ފުރަތަމަ ސާފުކުރަންވާނެއެވެ.",
          "ruleMissing": "ފޮނުވާ ނުވަތަ ލިބޭ ލީގަލް އެންޓިޓީއަށް މި ތާރީޚުގައި އަނެކާ ޙައްޤުގައި އިންޓަރކޮމްޕެނީ ޤަވާއިދެއް ނެތީމަ ޕޯސްޓްކުރާނެ ޑިއު-ޓު ނުވަތަ ޑިއު-ފްރޮމް އެކައުންޓެއް ނެތެވެ. ލީގަލް އެންޓިޓީތަކުގެ އިންޓަރކޮމްޕެނީ ޤަވާއިދުގައި އެއް ހަދާށެވެ."
        },
        "failed": "ބަދަލުކުރުން ފެއިލްވެއްޖެ",
        "postsBoth": "މިއީ ކޮންމެ ލީގަލް އެންޓިޓީއެއްގައިވެސް ޖާނަލެއް ޕޯސްޓްކުރާ ކަމެކެވެ: ފޮނުވާ ފަރާތް ލިބޭ ފަރާތުގެ ޑިއު-ފްރޮމްއާ ދެކޮޅަށް މުދާ ދެމަހައްޓަން ބާއްވައި، ލިބޭ ފަރާތް ފޮނުވާ ފަރާތުގެ ޑިއު-ޓުއާ ދެކޮޅަށް މުދާ ރަޖިސްޓްރީކުރެއެވެ. ފޮނުވާ މުދާ ނައްތާލެވޭނެއެވެ.",
        "price": "އަގު",
        "priceHint": "ފޮނުވާ ލީގަލް އެންޓިޓީގެ ބޭސް ކަރަންސީއިން، ސުން އަށްވުރެ ބޮޑަށް",
        "priceInvalid": "އަގު ސާދާ ދެސިމަލް ނަންބަރަކަށް ލިޔުއްވާ",
        "priceZero": "އަގު ސުން އަށްވުރެ ބޮޑުވާންވާނެ",
        "title": "{assetNo} އެހެން ލީގަލް އެންޓިޓީއަކަށް ބަދަލުކުރައްވާ",
        "toEntity": "ލީގަލް އެންޓިޓީ",
        "toEntityHint": "ލިބޭ ލީގަލް އެންޓިޓީ",
        "toEntityPlaceholder": "ލީގަލް އެންޓިޓީއެއް އިޚްތިޔާރުކުރައްވާ"
      },
      "note": {
        "justification": "ސަބަބު",
        "justificationHint": "މުދާ އިމްޕެއަރވި ސަބަބު. ލާޒިމް.",
        "required": "ސަބަބެއް ލާޒިމްވެއެވެ"
      },
      "source": {
        "ap_invoice_line": "އޭޕީ އިންވޮއިސް ލައިން",
        "cip": "ބިނާކުރަމުންދާ މުދާ",
        "ic_transfer": "އިންޓަރކޮމްޕެނީ ބަދަލު",
        "label": "ލިބުނު ގޮތް",
        "manual": "މެނުއަލް ލިބުން",
        "project": "ނިމިފައިވާ ޕްރޮޖެކްޓް"
      },
      "tabs": {
        "details": "ތަފްސީލު",
        "events": "އިވެންޓްތައް",
        "label": "މުދަލުގެ ބައިތައް"
      }
    }
  },
  "budget": {
    "routeTitles": {
      "budgetModels": "ބަޖެޓް މޮޑެލްތައް",
      "budgetModel": "ބަޖެޓް މޮޑެލް",
      "budgetVersion": "ބަޖެޓް ވަރޝަން",
      "budgetVariance": "ބަޖެޓް ތަފާތު",
      "budgetCommitments": "ކޮމިޓްމަންޓްތައް",
      "budgetControlLevels": "ބަޖެޓް ކޮންޓްރޯލް ލެވެލްތައް",
      "budgetForecastVsBudget": "ލަފާކުރެވޭ ބަޖެޓާ ބަޖެޓް",
      "budgetSettings": "ބަޖެޓް ސެޓިންގްސް",
      "budgetTransfers": "ބަޖެޓް ޓްރާންސްފަރ",
      "budgetTransferNew": "ބަޖެޓް ޓްރާންސްފަރއަކަށް އެދުން",
      "budgetTransfer": "ބަޖެޓް ޓްރާންސްފަރ",
      "budgetSupplementary": "އިތުރު ބަޖެޓް އެދުންތައް",
      "budgetSupplementaryNew": "އިތުރު ބަޖެޓަކަށް އެދުން",
      "budgetSupplementaryRequest": "އިތުރު ބަޖެޓް އެދުން",
      "budgetForecasts": "ރިވައިސްކުރި ފޯކާސްޓްތައް",
      "budgetCycles": "ބަޖެޓް ސައިކަލްތައް",
      "budgetCycle": "ބަޖެޓް ސައިކަލް",
      "budgetVersions": "ބަޖެޓް ވަރޝަންތައް",
      "budgetCompare": "ބަޖެޓް ވަރޝަންތައް އަޅާކިޔުން",
      "budgetAvailability": "ލިބެން ހުރި ބަޖެޓް"
    },
    "nav": {
      "label": "ބަޖެޓްކުރުމުގެ ބައިތައް",
      "models": "މޮޑެލްތައް",
      "variance": "ތަފާތު",
      "commitments": "ކޮމިޓްމަންޓްތައް",
      "controlLevels": "ކޮންޓްރޯލް ލެވެލްތައް",
      "forecastVsBudget": "ލަފާކުރެވޭ ބަޖެޓާ ބަޖެޓް",
      "settings": "ސެޓިންގްސް",
      "transfers": "ޓްރާންސްފަރ",
      "supplementary": "އިތުރު ބަޖެޓް",
      "forecasts": "ރިވައިސްކުރި ފޯކާސްޓްތައް",
      "cycles": "ސައިކަލްތައް",
      "versions": "ވަރޝަންތައް",
      "availability": "ލިބެން ހުރި"
    },
    "models": {
      "title": "ބަޖެޓް މޮޑެލްތައް",
      "description": "މޮޑެލްއެއްގައި ހިމެނެނީ އެއް ކުންފުނީގެ އެއް ފިސްކަލް އަހަރުގެ ޕްލޭން. އަދަދުތައް ހުންނާނީ އޭގެ ވަރޝަންތަކުގައި.",
      "detailDescription": "މި ޕްލޭންގެ ވަރޝަންތައް. އެއްފަހަރާ އަމަލުކުރެވެނީ ހަމައެކަނި އެއް ވަރޝަނަށް.",
      "factsTitle": "މޮޑެލް",
      "listTitle": "މޮޑެލްތައް",
      "backToList": "ހުރިހާ މޮޑެލްތައް",
      "loadFailed": "ބަޖެޓް މޮޑެލްތައް ލޯޑެއް ނުވި",
      "emptyTitle": "އަދި ބަޖެޓް މޮޑެލްއެއް ނެތް",
      "emptyDescription": "މޮޑެލްއަކީ ކޮންޓޭނަރެއް: އެއް ކުންފުނި، އެއް ފިސްކަލް އަހަރު، އަދި އޮޕަރޭޓިންގ ނުވަތަ ކެޕިޓަލް ފަދަ ބޭނުމެއް. އެއް ހަދާފައި ވަރޝަނެއް އިތުރުކޮށް އަދަދުތައް އެއަށް ލޯޑްކުރޭ.",
      "openVariance": "މި އަހަރުގެ ތަފާތު ރިޕޯޓް ހުޅުވާ",
      "inForceNote": "{name} އަށް އަމަލުކުރެވެއެވެ — ބަޖެޓް ޗެކްތަކުން ބަލަނީ އެ ވަރޝަން.",
      "noneInForceNote": "މި މޮޑެލްގެ އެއްވެސް ވަރޝަނަކަށް އަމަލެއް ނުކުރެވެއެވެ. އެހެންކަމުން މިތާ އެއްވެސް ޚަރަދެއް ކޮންޓްރޯލެއް ނުކުރެއެވެ. ވަރޝަނެއް ހުށަހަޅާ ފާސްކުރުވާ.",
      "columns": {
        "name": "ނަން",
        "company": "ކުންފުނި",
        "fiscalYear": "ފިސްކަލް އަހަރު",
        "purpose": "ބޭނުން"
      },
      "actions": {
        "create": "އައު މޮޑެލް"
      },
      "create": {
        "title": "އައު ބަޖެޓް މޮޑެލް",
        "description": "އެއް ކުންފުނި، އެއް ފިސްކަލް އަހަރު. ވަރޝަންތަކާއި އަދަދުތައް ދެން އަންނާނެ.",
        "nameHint": "މި ޕްލޭނަށް މީހުން ކިޔާނެ ނަން، މިސާލަކަށް އޮޕަރޭޓިންގ ބަޖެޓް.",
        "yearHint": "ހަތަރު އަދަދު، ކުންފުނީގައި މުއްދަތުތައް ހުރި ފިސްކަލް އަހަރަކާ އެއްގޮތަށް.",
        "yearInvalid": "ހަތަރު އަދަދުގެ ފިސްކަލް އަހަރެއް ލިޔޭ.",
        "purposeHint": "މިނިވަން ލިޔުން، މިސާލަކަށް އޮޕަރޭޓިންގ ނުވަތަ ކެޕިޓަލް."
      },
      "toasts": {
        "created": "{name} ހެދިއްޖެ",
        "createdDetail": "އަދަދުތައް ލޯޑްކުރަން ފެށުމަށް ވަރޝަނެއް އިތުރުކުރޭ.",
        "createFailed": "މޮޑެލް ނުހެދުނު"
      }
    },
    "versions": {
      "title": "{model} · {version} (v{no})",
      "description": "ދެލިކޮޕީ، ފާސްކުރުމަށް ހުށަހެޅުން، ދެން ތަޅުލުން. ލައިންތައް އުނިއިތުރު ކުރެވޭނީ ދެލިކޮޕީއެއްގައި އެކަނި.",
      "listTitle": "ވަރޝަންތައް",
      "factsTitle": "ވަރޝަން",
      "backToModel": "މޮޑެލްއަށް އެނބުރި",
      "loadFailed": "ބަޖެޓް ވަރޝަން ލޯޑެއް ނުވި",
      "emptyTitle": "އަދި ވަރޝަނެއް ނެތް",
      "emptyDescription": "ވަރޝަނުގައި ހުންނަނީ އަދަދުތަކާއި ހާލަތު. އެއް ހަދާފައި އަދަދުތައް ލިޔޭ، ސީއެސްވީއެއް އިމްޕޯޓްކުރޭ، މިދިޔަ އަހަރު ކޮޕީކުރޭ، ނުވަތަ ޖުމްލައެއް މުއްދަތުތަކަށް ބަހާ.",
      "actionsLabel": "ވަރޝަނުގެ ޢަމަލުތައް",
      "awaitingApproval": "ހުށަހަޅައިފި. ފާސްކުރާ މީހަކު ފާސްކުރުމުގެ އިންބޮކްސްއިން ނިންމާނެ؛ ނިންމުމުން މި ސްކްރީނުން ފެންނާނެ.",
      "railSubtitle": "{status} · {model}",
      "inForceTag": "އަމަލުކުރެވެނީ",
      "totalMismatch": "ރައްކާކުރެވިފައިވާ ޖުމްލަ ({stored}) އާއި ސްކްރީނުގައިވާ ލައިންތަކުގެ ޖުމްލަ ({computed}) ދިމަލެއް ނުވޭ. އަލުން ލޯޑްކުރޭ؛ އަދިވެސް ދިމާނުވާނަމަ މިއީ ޑޭޓާގެ މައްސަލައެއް ކަމުން ރިޕޯޓްކުރޭ.",
      "inForce": {
        "approved": "މި ވަރޝަނަށް އަމަލުކުރެވެއެވެ. ލިޔުމެއް ހުށަހަޅާއިރު ބަޖެޓް ޗެކްތަކުން ބަލަނީ މިއަށެވެ.",
        "locked": "މި ވަރޝަނަށް އަމަލުކުރެވޭ އަދި ތަޅުލެވިފައި. ބަދަލުކުރެވޭނީ ތަޅު ހުޅުވުމަށްފަހު."
      },
      "otherInForce": "އަމަލުކުރެވެނީ {name} އަށް، މިއަކަށް ނޫން. މި ވަރޝަން ފާސްވަންދެން މިތާ އެއްވެސް ބަޖެޓް ޗެކަކަށް އަސަރެއް ނުކުރާނެ.",
      "openInForce": "އެ ހުޅުވާ",
      "noneInForce": "މި މޮޑެލްގެ އެއްވެސް ވަރޝަނަކަށް އަމަލެއް ނުކުރެވޭ، އެހެންކަމުން މި މޮޑެލްއިން ޚަރަދެއް ކޮންޓްރޯލެއް ނުކުރެއެވެ.",
      "readOnly": {
        "draft": "ބަޖެޓް ލައިންތައް އުނިއިތުރު ކުރުމުގެ ހުއްދައެއް ނެތް.",
        "submitted": "ފާސްކުރުމަށް ހުށަހަޅާފައި. ނިންމުމެއް އަންނަންދެން ލައިންތައް ބަދަލެއް ނުކުރެވޭނެ.",
        "approved": "ފާސްކުރެވި އަމަލުކުރެވެނީ. މިހާރު ބަދަލުކުރުމުން އެއްވެސް މީހަކު އަލުން ފާސްނުކުރާ ކޮންޓްރޯލް އަދަދެއް ބަދަލުވާނެ — އޭގެ ބަދަލުގައި ސުޕަރސީޑްކޮށް އައު ވަރޝަނެއް ފާސްކުރޭ.",
        "rejected": "ރިޖެކްޓްކޮށްފައި. މި ރެކޯޑް ބަދަލުކުރުމުގެ ބަދަލުގައި އައު ވަރޝަނެއް ހަދާ.",
        "locked": "ތަޅުލެވިފައި. އެއްވެސް ބަދަލެއް ގެނައުމުގެ ކުރިން ތަޅު ހުޅުވާ.",
        "superseded": "ފަހުގެ ވަރޝަނަކުން ބަދަލުކޮށްފައި. ކުރިން އަމަލުކުރެވުނު ގޮތުގެ ރެކޯޑެއްގެ ގޮތުގައި ބަހައްޓާފައި."
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "ހުށަހަޅާފައި",
        "approved": "ފާސްކޮށްފައި",
        "rejected": "ރިޖެކްޓްކޮށްފައި",
        "locked": "ތަޅުލެވިފައި",
        "superseded": "ސުޕަރސީޑްކޮށްފައި"
      },
      "columns": {
        "versionNo": "ވަރޝަން",
        "total": "ޖުމްލަ",
        "note": "ނޯޓް",
        "lastChange": "އެންމެ ފަހު ބަދަލު"
      },
      "actions": {
        "create": "އައު ވަރޝަން",
        "submit": "ފާސްކުރުމަށް ހުށަހަޅާ",
        "discard": "ދެލިކޮޕީ އުކާލާ"
      },
      "create": {
        "title": "އައު ވަރޝަން",
        "description": "އައު ދެލިކޮޕީއެއް. އަދަދުތައް ފަހުން ލޯޑްކުރޭ.",
        "defaultName": "ވަރޝަން {no}",
        "nameHint": "މިސާލަކަށް ދެލިކޮޕީ 2 ނުވަތަ ބޯޑަށް ހުށަހަޅާ ފޮތް."
      },
      "timeline": {
        "created": "ހަދާފައި",
        "submitted": "ފާސްކުރުމަށް ހުށަހަޅާފައި",
        "approved": "ފާސްކޮށްފައި",
        "rejected": "ރިޖެކްޓްކޮށްފައި",
        "locked": "ތަޅުލެވިފައި",
        "superseded": "ސުޕަރސީޑްކޮށްފައި"
      },
      "links": {
        "model": "ބަޖެޓް މޮޑެލް",
        "variance": "ތަފާތު ރިޕޯޓް",
        "approval": "ފާސްކުރުމުގެ އިންބޮކްސް"
      },
      "toasts": {
        "submitted": "ފާސްކުރުމަށް ހުށަހަޅައިފި",
        "submittedDetail": "ފާސްކުރާ މީހަކު ފާސްކުރުމުގެ އިންބޮކްސްއިން ނިންމާނެ.",
        "submitFailed": "ވަރޝަން ހުށަހެޅިފައެއް ނުވޭ",
        "createFailed": "ވަރޝަން ނުހެދުނު",
        "discarded": "ދެލިކޮޕީ އުކާލައިފި",
        "discardedDetail": "އޭގެ ލައިންތައްވެސް ދިޔައީ.",
        "discardFailed": "ދެލިކޮޕީ އުކާނުލެވުނު"
      }
    },
    "transitions": {
      "reasonLabel": "ސަބަބު",
      "reasonHint": "އޮޑިޓް ރެކޯޑްގައި ރައްކާކުރެވޭނެ. ކީއްވެކަން ލިޔޭ، ކޮންކަމެއްކަން ނޫން.",
      "lock": {
        "title": "މި ވަރޝަން ތަޅުލާ",
        "description": "އަދަދުތައް ފްރީޒްކުރޭ. އަމަލުކުރެވެމުން ދާނެ.",
        "consequence": "ތަޅުލެވިފައިވާ ވަރޝަނެއް ތަޅު ހުޅުވަންދެން ބަދަލެއް ނުވަތަ ސުޕަރސީޑެއް ނުކުރެވޭނެ.",
        "action": "ތަޅުލާ",
        "doneTitle": "ވަރޝަން ތަޅުލެވިއްޖެ",
        "doneDetail": "ފްރީޒްކުރެވި އަދިވެސް އަމަލުކުރެވެއެވެ."
      },
      "unlock": {
        "title": "މި ވަރޝަނުގެ ތަޅު ހުޅުވާ",
        "description": "ސުޕަރސީޑް ކުރެވޭގޮތަށް ފާސްކުރެވިފައިވާ ހާލަތަށް އަނބުރާ ގެންދޭ.",
        "consequence": "އަމަލުކުރެވެމުން ދާނެ؛ ތަޅު ހުޅުވުމުން ބަދަލުކުރެވޭގޮތް އެކަނި ވާނީ.",
        "action": "ތަޅު ހުޅުވާ",
        "doneTitle": "ވަރޝަނުގެ ތަޅު ހުޅުވިއްޖެ",
        "doneDetail": "ފާސްކުރެވި އަމަލުކުރެވެއެވެ."
      },
      "supersede": {
        "title": "މި ވަރޝަން ސުޕަރސީޑްކުރޭ",
        "description": "އެހެން ވަރޝަނަކުން ބަދަލުކުރެވޭގޮތަށް މި ވަރޝަނަށް އަމަލުކުރުން ހުއްޓާލާ.",
        "consequence": "އެހެން ވަރޝަނެއް ފާސްވަންދެން މި މޮޑެލްއިން އެއްވެސް ބަޖެޓް ލައިނެއް ނުދޭނެ. ކުންފުނީގެ ލައިން-ނެތް އުޞޫލަކީ ހުދޫދެއް ނެތް ކަމުގައިވާނަމަ، އެ އެކައުންޓްތައް ކޮންޓްރޯލްކުރުން ހުއްޓޭނެ.",
        "action": "ސުޕަރސީޑްކުރޭ",
        "doneTitle": "ވަރޝަން ސުޕަރސީޑްކޮށްފި",
        "doneDetail": "އަލުން ބަޖެޓެއް އަމަލުކުރުމަށް ބަދަލު ވަރޝަނެއް ފާސްކުރޭ."
      }
    },
    "lines": {
      "title": "ބަޖެޓް ލައިންތައް",
      "caption": "ފިސްކަލް މުއްދަތުތަކުގައި އެކައުންޓާއި ޑައިމެންޝަން އަށް ބަޖެޓް ލައިންތައް",
      "loadFailed": "ބަޖެޓް ލައިންތައް ލޯޑެއް ނުވި",
      "totalsLabel": "ޖުމްލަ",
      "emptyRow": "އަދި ލައިނެއް ނެތް. ރޯއެއް އިތުރުކުރޭ، ނުވަތަ އިމްޕޯޓް، ކޮޕީ ނުވަތަ ސްޕްރެޑަކުން އަދަދުތައް ލޯޑްކުރޭ.",
      "noPeriods": "މި ކުންފުނީގައި {year} ގެ ފިސްކަލް މުއްދަތުތަކެއް ނެތުމުން ބަޖެޓްކުރާނެ ކޮލަމެއް ނެތް. ފުރަތަމަ ފިސްކަލް އަހަރު ހަދާ.",
      "keyboardHint": "އެންޓަރ އިން ތިރިއަށް · Alt+↓ އިން ކޮޕީ · Alt+Backspace އިން ފޮހެލުން · ހުސް ގޮޅިއަކުން އެ ލައިން ފޮހެލެވޭ",
      "columns": {
        "account": "އެކައުންޓް",
        "dimensions": "ޑައިމެންޝަންތައް",
        "total": "އަހަރު"
      },
      "dimensions": {
        "costCenter": "ކޮސްޓް ސެންޓަރ",
        "costCenterAny": "ކޮސްޓް ސެންޓަރެއް ނެތް",
        "profitCenter": "ޕްރޮފިޓް ސެންޓަރ",
        "profitCenterAny": "ޕްރޮފިޓް ސެންޓަރެއް ނެތް",
        "branch": "ގޮފި",
        "branchAny": "ގޮތްޕެއް ނެތް"
      },
      "issues": {
        "duplicateKey": "މި އެކައުންޓާއި މި ޑައިމެންޝަންތަކަށް އެހެން ރޯއެއްގައި ބަޖެޓްކޮށްފައި އެބައޮތް. ޑައިމެންޝަނެއް ބަދަލުކުރޭ، ނުވަތަ ދެ ރޯއިން އެއް ރޯ ފޮހެލާ — ދެ ރޯވެސް ރައްކާކުރުމުން އެކަތި އަނެކަތީގެ މައްޗަށް ސިއްރުން ލިޔެވޭނެ.",
        "keyIsFixed": "މި ރޯގެ ކޮންމެ ލައިނެއް ދެނެގަންނަނީ އެކައުންޓާއި ޑައިމެންޝަންތަކުން ކަމަށްވާތީ މިތާ އެ ބަދަލެއް ނުކުރެވޭނެ. ބޭނުންވާ ރޯ އިތުރުކޮށް، މި ރޯ ސާފުކުރޭ.",
        "accountRequired": "އަދަދެއް ލިޔުމުގެ ކުރިން އެކައުންޓެއް ޚިޔާރުކުރޭ."
      },
      "actions": {
        "add": "ރޯއެއް އިތުރުކުރޭ",
        "duplicate": "މި ރޯ ކޮޕީކުރޭ",
        "remove": "މި ރޯ ފޮހެލާ"
      },
      "aria": {
        "account": "އެކައުންޓް، ރޯ {row}",
        "cell": "{account}، {period}",
        "duplicate": "ރޯ {row} ކޮޕީކުރޭ",
        "remove": "ރޯ {row} ފޮހެލާ"
      },
      "toasts": {
        "rowRemoved": "ރޯ ފޮހެލައިފި",
        "rowRemovedDetail": "އޭގެ ބަޖެޓް ލައިންތައް ފޮހެވިއްޖެ، އެއީ ސުމަކަށް ބަޖެޓްކުރުމެއް ނޫން.",
        "writeFailed": "ބަދަލު ރައްކާނުކުރެވުނު"
      }
    },
    "import": {
      "action": "ސީއެސްވީ އިމްޕޯޓް",
      "title": "ބަޖެޓް ލައިންތައް އިމްޕޯޓްކުރޭ",
      "description": "ސީއެސްވީއެއް އަޕްލޯޑްކޮށް، ކޮންމެ ކޮލަމެއްގެ މާނަ ކަށަވަރުކުރޭ. ސާވަރުން ކޮންމެ ރޯއެއް ޗެކްކުރުމަށްފަހު ނޫނީ އެއްވެސް އެއްޗެއް ނުލިޔާނެ.",
      "fileLabel": "ސީއެސްވީ ފައިލް",
      "fileHint": "ކޮންމެ އެކައުންޓަކަށް، މުއްދަތަކަށް އަދި އަދަދަކަށް އެއް ރޯ. ޑައިމެންޝަންތަކާއި ނޯޓަކީ އިޚްތިޔާރީ.",
      "unreadable": "އެ ފައިލް ސީއެސްވީގެ ގޮތުގައި ކިޔޭގޮތެއް ނުވި. ސްޕްރެޑްޝީޓް ވޯކްބުކެއްގެ ބަދަލުގައި ޓެކްސްޓް ސީއެސްވީއެއްކަން ޔަޤީންކުރޭ.",
      "mappingTitle": "ކޮލަމްތައް",
      "mappingRecognised": "ތިރީގައިވާ ހުރިހާ ކޮލަމެއް ދެނެގަނެވިއްޖެ. ހެޑަރެއްގެ މާނަ ތަފާތުނަމަ ބަދަލުކުރޭ.",
      "mappingAdjusted": "މެޕިންގ ބަދަލުކޮށްފި. ބަދަލުވަނީ ހަމައެކަނި ހެޑަރ ރޯ؛ ޑޭޓާ ރޯތައް ހުރިގޮތަށް އަޕްލޯޑްވާނެ.",
      "mapAria": "{column} ކޮލަމުގެ މާނަ",
      "ignoreColumn": "މި ކޮލަމް ދޫކޮށްލާ",
      "unnamedColumn": "(ނަމެއް ނެތް)",
      "previewTruncated": "ދައްކަނީ ފުރަތަމަ ބައެއް ރޯތައް އެކަނި. އަޕްލޯޑްވާނީ ހުރިހާ ރޯއެއް.",
      "missingRequired": "{fields} އަށް ކޮލަމެއް މެޕްކުރޭ — އެއާ ނުލައި އިމްޕޯޓެއް ނުހިނގާނެ.",
      "duplicateMapping": "{fields} އެއް ކޮލަމަށްވުރެ ގިނަ ކޮލަމަށް މެޕްކޮށްފައި. އެކަތި ޚިޔާރުކުރޭ.",
      "upload": "ޗެކްކޮށް އިމްޕޯޓްކުރޭ",
      "uploading": "އިމްޕޯޓްކުރަނީ",
      "doneTitle": "{count} ލައިން އިމްޕޯޓްކޮށްފި",
      "doneLead": "އަދަދުތައް ގްރިޑްގައި އެބަހުރި.",
      "refusedTitle": "{count} ރޯގައި މައްސަލައެއް",
      "refusedLead": "އެއްވެސް އެއްޗެއް ނުލިޔެވޭ. ފައިލް ރަނގަޅުކޮށް އަލުން އަޕްލޯޑްކުރޭ — އިމްޕޯޓް ބަލައިނުގަންނަނީ މުޅިން، ބައެއް ނޫން.",
      "rowsRead": "{count} ރޯ ކިޔައިފި، ޖުމްލަ",
      "errorsCaption": "އިމްޕޯޓް ބަލައިނުގަތް ރޯތައް",
      "columns": {
        "inFile": "ތިޔަ ފައިލްގައި",
        "meaning": "މާނައަކީ",
        "sample": "މިސާލު އަގުތައް",
        "line": "ލައިން",
        "column": "ކޮލަމް",
        "problem": "މައްސަލަ"
      },
      "fields": {
        "accountCode": "އެކައުންޓް ކޯޑު",
        "period": "މުއްދަތު ނަންބަރު",
        "amount": "އަދަދު",
        "costCenterCode": "ކޮސްޓް ސެންޓަރ ކޯޑު",
        "profitCenterCode": "ޕްރޮފިޓް ސެންޓަރ ކޯޑު",
        "branchCode": "ގޮފީގެ ކޯޑު",
        "note": "ނޯޓް"
      }
    },
    "copy": {
      "action": "މިދިޔަ އަހަރު ކޮޕީކުރޭ",
      "title": "އެހެން ވަރޝަނަކުން ކޮޕީކުރޭ",
      "description": "ކޮންމެ ލައިނެއް މުއްދަތު ނަންބަރަށް ބަލައި މުއްދަތުން މުއްދަތަށް ކޮޕީވެ، އަޕްލިފްޓުން ބަދަލުވާނެ.",
      "sourceLabel": "ކޮޕީކުރަނީ",
      "sourceHint": "އެއް ކުންފުނީގެ ކޮންމެ މޮޑެލްއެއްގެ ކޮންމެ ވަރޝަނަކުން.",
      "sourcePlaceholder": "ވަރޝަނެއް ޚިޔާރުކުރޭ",
      "upliftLabel": "އަޕްލިފްޓް %",
      "upliftHint": "5 އިން ކޮންމެ އަދަދެއް ފަހެއް އިންސައްތަ އިތުރުވާނެ؛ -10 އިން ދިހަ އިންސައްތަ މަދުވާނެ. ބަދަލެއް ނުގެނެސް ކޮޕީކުރަން ހުސްކޮށް ބާއްވާ.",
      "upliftInvalid": "އަދަދެއް ލިޔޭ، މިސާލަކަށް 5 ނުވަތަ -10.",
      "previewLabel": "{base} ބަދަލުވާނީ",
      "doneTitle": "{count} ލައިން ކޮޕީކޮށްފި | {count} ލައިން ކޮޕީކޮށްފި",
      "doneLead": "އުނިއިތުރު ކުރެވޭގޮތަށް ގްރިޑްގައި އެބަހުރި.",
      "skippedTitle": "މިތަކެތި ދޫކޮށްލެވުނު:"
    },
    "spread": {
      "action": "ޖުމްލައެއް ބަހާ",
      "title": "އަހަރަށް ޖުމްލައެއް ބަހާ",
      "description": "އެއް އެކައުންޓް، އެއް އަދަދު، ކޮންމެ މުއްދަތަކަށް ބަހާލެވޭ.",
      "replacesWarning": "މިއިން އެ އެކައުންޓާއި ޑައިމެންޝަންތަކަށް އަހަރުގެ ކޮންމެ މުއްދަތެއްގައި މިހާރު ބަޖެޓްކޮށްފައިވާ އެއްޗެއް ބަދަލުވާނެ.",
      "totalLabel": "އަހަރުގެ ޖުމްލަ",
      "totalHint": "މުއްދަތުތަކުގެ ޖުމްލަ ވާނީ ހަމަ މި އަދަދު.",
      "totalInvalid": "އަދަދެއް ލިޔޭ.",
      "modeLabel": "ބަހާނެ ގޮތް",
      "modes": {
        "even": "ހަމަހަމައަށް",
        "evenHint": "ކޮންމެ މުއްދަތަކަށް އެއްވަރު؛ ފަހު މުއްދަތުން ރައުންޑިންގ ހަމަކުރާނެ.",
        "profile": "މޫސުމީ ޕްރޮފައިލަކުން",
        "profileHint": "ކޮންމެ މުއްދަތަކަށް އިންސައްތައެއް. ޖުމްލަ 100 ވާންޖެހޭނެ."
      },
      "percentHint": "%",
      "profileSum": "ޕްރޮފައިލްގެ ޖުމްލަ {sum}%.",
      "profileMustSum": "މި ހިންގުމުގެ ކުރިން ސީދާ 100 ވާންޖެހޭނެ.",
      "previewTitle": "ލިޔެވޭނެ އެއްޗެއް",
      "done": "{count} ލައިން ލިޔެފި | {count} ލައިން ލިޔެފި"
    },
    "variance": {
      "title": "ބަޖެޓް ތަފާތު",
      "description": "އެކައުންޓާއި ޑައިމެންޝަނަށް ބަޖެޓާއި ކޮމިޓްމަންޓާއި ޙަޤީޤީ ޚަރަދު. ކޮންމެ އަދަދަކުން އޭގެ އަސްލު ހުޅުވޭ.",
      "scope": "ދާއިރާ",
      "choosePlaceholder": "ކުންފުންޏެއް ޚިޔާރުކުރޭ",
      "chooseScope": "ރިޕޯޓް ހިންގުމަށް ކުންފުންޏަކާއި ފިސްކަލް އަހަރެއް ޚިޔާރުކުރޭ.",
      "loadFailed": "ތަފާތު ރިޕޯޓް ލޯޑެއް ނުވި",
      "emptyTitle": "މި އަހަރަށް ރިޕޯޓްކުރާނެ އެއްޗެއް ނެތް",
      "emptyDescription": "މި ކުންފުނީގެ މި ފިސްކަލް އަހަރަށް އަދި ބަޖެޓް ލައިނެއް، ކޮމިޓްމަންޓެއް ނުވަތަ ޕޯސްޓްކުރެވިފައިވާ ޚަރަދެއް ނެތް.",
      "caption": "އެކައުންޓަށް ބަޖެޓް، ކޮމިޓްމަންޓް، ޙަޤީޤީ އަދި ލިބެންހުރި",
      "convention": "ލިބެންހުރި އަދަދަކީ ބަޖެޓުން ކޮމިޓްމަންޓާއި ޙަޤީޤީ ޚަރަދު އުނިކުރުމުން ސާވަރު ގުނާފައިވާ އަދަދު. މައިނަސް އަދަދަކީ ބަޖެޓަށްވުރެ އިތުރު ޚަރަދު، އަދި ދައްކާނީ ރަތް ބްރެކެޓްގައި.",
      "totalsLabel": "ޖުމްލަ",
      "unbudgeted": "ބަޖެޓްކޮށްފައެއް ނުވޭ",
      "columns": {
        "budget": "ބަޖެޓް",
        "commitment": "ކޮމިޓްކޮށްފައި",
        "actual": "ޙަޤީޤީ",
        "available": "ލިބެންހުރި",
        "percent": "ލިބެންހުރި %"
      }
    },
    "commitments": {
      "title": "ކޮމިޓްމަންޓްތައް",
      "description": "ކުރިއާލާ ކަނޑައެޅިފައިވާ ފައިސާ: ރިކުއިޒިޝަން ލައިނެއް ފާސްވުމުން ސޮފްޓް، އަދި އޭގެ ޕާޗޭސް އޯޑަރު ފާސްވުމުން ހާޑް.",
      "loadFailed": "ކޮމިޓްމަންޓްތައް ލޯޑެއް ނުވި",
      "emptyTitle": "ކޮމިޓްމަންޓެއް ނެތް",
      "emptyDescription": "ކޮމިޓްމަންޓްތައް އުފެދެނީ ޕާޗޭސް ރިކުއިޒިޝަނާއި އޯޑަރުތަކުން، އެއީ ޕްރޮކިއުމަންޓް މޮޑިއުލްއާއެކު އަންނާނެ ބައެއް. އޭގެ ކުރިން މި ލިސްޓް ހުހަށް، އަދި ތަފާތު ރިޕޯޓްގެ ކޮމިޓްކޮށްފައި ކޮލަމް ސުމަކަށް ދައްކާނެ.",
      "scopedToAccount": "ތަފާތު ރިޕޯޓުން ހުޅުވުނު ގޮތަށް، އެކައުންޓް {id} އަށް ފިލްޓަރކޮށްފައި.",
      "docLine": "{type} ލައިން {line}",
      "kinds": {
        "soft": "ސޮފްޓް",
        "hard": "ހާޑް"
      },
      "statuses": {
        "open": "ހުޅުވިފައި",
        "released": "ދޫކޮށްލާފައި"
      },
      "columns": {
        "document": "ލިޔުން",
        "kind": "ބާވަތް",
        "amount": "ކޮމިޓްކޮށްފައި",
        "released": "ދޫކޮށްލާފައި",
        "remaining": "ބާކީ",
        "raised": "އުފެއްދި"
      }
    },
    "outcome": {
      "unknownAccount": "އެކައުންޓް {id}",
      "onLines": "ލައިން {lines} ގައި | ލައިން {lines} ގައި",
      "openVariance": "ތަފާތު ރިޕޯޓް ހުޅުވާ",
      "columns": {
        "account": "އެކައުންޓް",
        "budget": "ބަޖެޓް",
        "committed": "ކޮމިޓްކޮށްފައި",
        "actuals": "ޙަޤީޤީ",
        "available": "ލިބެންހުރި",
        "requested": "މި ލިޔުން"
      },
      "blocked": {
        "title": "މި ލިޔުމުން ބަޖެޓް ފަހަނައަޅައެވެ",
        "lead": "މި ހުށަހެޅިފައެއް ނުވޭ. ތިރީގައިވާ އެކައުންޓްތަކުގައި މި ލިޔުމަށް ބޭނުންވާ ވަރަށްވުރެ މަދުން ފައިސާ ލިބެންހުރީ.",
        "caption": "ބަޖެޓް ފަހަނައެޅި އެކައުންޓްތައް",
        "advice": "އެ އެކައުންޓްތަކުގެ ލައިންތައް ކުޑަކުރޭ، ނުވަތަ އަލުން ހުށަހެޅުމުގެ ކުރިން ބަޖެޓް އިތުރުކޮށް ފާސްކުރުވާ."
      },
      "warned": {
        "title": "މި ލިޔުމުން ބަޖެޓް ފަހަނައަޅައެވެ",
        "lead": "މި ކުންފުނީގެ އުޞޫލަކީ ހުއްޓުވުމުގެ ބަދަލުގައި އިންޒާރުދިނުން ކަމަށްވާތީ ހުށަހެޅިއްޖެ، އަދި ތިރީގައި މިވަނީ ޗެކުން ފެނުނު އަދަދުތައް.",
        "caption": "ބަޖެޓް ފަހަނައެޅި އެކައުންޓްތައް",
        "advice": "ތިޔަ ބޭފުޅާ ކުރަންޖެހޭ ކަމެއް ނެތް. ފާސްކުރާ ބޭފުޅުންނަށްވެސް ހަމަ މި އަދަދުތައް ފެންނާނެ."
      }
    },
    "controlLevels": {
      "title": "ބަޖެޓް ކޮންޓްރޯލް ލެވެލްތައް",
      "description": "ލިޔުމަކުން ލިބެން ހުރި ބަޖެޓް ފަހަނައަޅާ ދާއިރު ވާނެ ގޮތް: ކޮންމެ ކޮސްޓް ސެންޓަރަކަށް، ލީގަލް އެންޓިޓީގެ ޑިފޯލްޓް ވާރުތަވެ، ކޮންޓްރޯލް ހިނގުމުގެ ކުރިން ކެތްކުރެވޭ އިތުރު ޚަރަދާއެކު.",
      "choosePlaceholder": "ލީގަލް އެންޓިޓީއެއް ޚިޔާރުކުރައްވާ",
      "chooseTitle": "ލީގަލް އެންޓިޓީއެއް ޚިޔާރުކުރައްވާ",
      "chooseDescription": "ކޮންޓްރޯލް ލެވެލްތައް ނިސްބަތްވަނީ އެއް ލީގަލް އެންޓިޓީއަކަށް: އޭގެ ޑިފޯލްޓާއި، އަމިއްލަ ލެވެލެއް ހުރި ކޮންމެ ކޮސްޓް ސެންޓަރެއް.",
      "loadFailed": "ކޮންޓްރޯލް ލެވެލްތައް ލޯޑެއް ނުވި",
      "defaultTitle": "ލީގަލް އެންޓިޓީގެ ޑިފޯލްޓް",
      "defaultScope": "ލީގަލް އެންޓިޓީގެ ޑިފޯލްޓް",
      "defaultPending": "ޑިފޯލްޓަށް ގެނެވޭ ބަދަލެއް އެޕްރޫވަލަށް މަޑުކުރަމުން ދަނީ. އެ ނިންމުމަށްފަހު އަލުން ބަދަލުކުރެވޭނެ.",
      "defaultExplainer": "އަމިއްލަ ލެވެލެއް ނެތް ކޮންމެ ކޮސްޓް ސެންޓަރަކާއި، ކޮސްޓް ސެންޓަރެއް ނެތް ލިޔުމުގެ ލައިނަކަށް މި ލެވެލް ވާރުތަވާނެ.",
      "costCentresTitle": "ކޮސްޓް ސެންޓަރުތައް",
      "costCentresFooter": "ވާރުތަވާ ކަމަށް ދައްކާ ކޮސްޓް ސެންޓަރަކީ ޑިފޯލްޓަށް ތަބާވާ އެއްޗެއް، ފަހުން ގެނެވޭ ބަދަލުތަކާއެކު.",
      "noCostCentresTitle": "ދައްކާނެ ކޮސްޓް ސެންޓަރެއް ނެތް",
      "noCostCentresDescription": "މި ލީގަލް އެންޓިޓީގައި އެކްޓިވް ކޮސްޓް ސެންޓަރެއް ނެތީތީ ކޮންމެ ލިޔުމެއް ކޮންޓްރޯލްކުރެވެނީ ޑިފޯލްޓް ލެވެލުގައި.",
      "noUnitTree": "ލިސްޓުކުރެވިފައިވަނީ އަމިއްލަ ލެވެލެއް ހުރި ކޮސްޓް ސެންޓަރުތައް ހަމައެކަނި: ފުރިހަމަ ކޮސްޓް ސެންޓަރު ގަސް ކިޔުމަށް އޯގަނައިޒޭޝަން ޔުނިޓްތައް ކިޔުމުގެ ހުއްދަ ބޭނުންވޭ.",
      "pendingTitle": "އެޕްރޫވަލަށް މަޑުކުރާ ބަދަލުތައް",
      "noPending": "އެޕްރޫވަލަށް މަޑުކުރާ އެއްވެސް ބަދަލެއް ނެތް.",
      "pendingExplainer": "ކޮންޓްރޯލެއް ލުއިކުރުން (ބަލިކަށި ލެވެލެއް ނުވަތަ މައްޗަށް ޓޮލަރެންސް) އަމަލުކުރެވެނީ އެދުނު މީހާ ނޫން މީހަކު އެޕްރޫވަލް އިންބޮކްސްގައި އެޕްރޫވްކުރުމުން. ހަރުކަށިކުރުން އަމަލުކުރެވެނީ އެވަގުތުން.",
      "pendingLine": "{from} ({fromPct}%) އިން {to} ({toPct}%) އަށް",
      "awaitingApproval": "އެޕްރޫވަލަށް މަޑުކުރަނީ",
      "requestedAt": "އެދުނީ {at}",
      "approvalRequest": "އެޕްރޫވަލް ރިކުއެސްޓް {id}",
      "reasonGiven": "ސަބަބު: {reason}",
      "percent": "{pct}%",
      "fields": {
        "company": "ލީގަލް އެންޓިޓީ",
        "level": "ކޮންޓްރޯލް ލެވެލް",
        "tolerance": "ޓޮލަރެންސް",
        "reason": "ބަދަލުގެ ސަބަބު"
      },
      "columns": {
        "costCentre": "ކޮސްޓް ސެންޓަރު",
        "level": "ކޮންޓްރޯލް ލެވެލް",
        "tolerance": "ޓޮލަރެންސް",
        "source": "އަންނަނީ",
        "pending": "މަޑުކުރާ ބަދަލު"
      },
      "levels": {
        "none": "ކޮންޓްރޯލެއް ނެތް",
        "advisory": "ހަމައެކަނި ލަފާ",
        "warn": "ފަހަނައަޅާނަމަ އިންޒާރު",
        "block": "ފަހަނައަޅާނަމަ ހުއްޓުވުން"
      },
      "levelHints": {
        "none": "ބަޖެޓް އަދަދުތައް ރިޕޯޓްކުރެވޭނެ؛ އެއްވެސް އެއްޗެއް ޗެކެއް ނުކުރެވޭނެ.",
        "advisory": "ހުށަހަޅާ މީހާއަށް އަދަދުތައް ދައްކާނެ؛ އެއްވެސް އެއްޗެއް ރަދުނުކުރެ، އިންޒާރެއްވެސް ނުދޭނެ.",
        "warn": "ބަޖެޓާއި ޓޮލަރެންސް ފަހަނައަޅާ ލިޔުމެއް އިންޒާރަކާއެކު ކުރިއަށްދާނެ.",
        "block": "ބަޖެޓާއި ޓޮލަރެންސް ފަހަނައަޅާ ލިޔުމެއް ރަދުކޮށް، ލިބެން ހުރި އަދަދު އަނބުރާ ދޭނެ."
      },
      "sources": {
        "cost_center": "އޭގެ އަމިއްލަ ލެވެލް",
        "company_default": "ލީގަލް އެންޓިޓީގެ ޑިފޯލްޓުން ވާރުތަވި"
      },
      "defaultBuiltIn": "މި ލީގަލް އެންޓިޓީއަށް އަދި ޑިފޯލްޓެއް ކަނޑައަޅާފައެއް ނުވޭ: ރައްކާކުރަންދެން ބިލްޓް-އިން ލެވެލް އަމަލުކުރެވޭނެ.",
      "noLine": {
        "label": "ބަޖެޓް ލައިނެއް ނެތްނަމަ",
        "hint": "އެއްވެސް މީހަކު ބަޖެޓްކޮށްފައި ނުވާ އެކައުންޓް، މުއްދަތު އަދި ކޮސްޓް ސެންޓަރަކަށް. މުޅި ކުންފުންޏަށް؛ ކަނޑައަޅަނީ ޑިފޯލްޓުގައި ހަމައެކަނި.",
        "unlimited": "ކޮންޓްރޯލްނުކުރެވޭ",
        "unlimitedHint": "އެއްވެސް އެއްޗެއް ބަޖެޓްކޮށްފައި ނުވާތީ އެއްވެސް ކޮންޓްރޯލެއް ނުހިނގާނެ.",
        "zero": "އެއްވެސް އެއްޗެއް ލިބެން ނެތް",
        "zeroHint": "ބަޖެޓްނުކުރާ އެއްވުމަކަށް ކުރާ ކޮންމެ ޚަރަދެއް ބަޖެޓް ފަހަނައަޅައި ކޮންޓްރޯލް ލެވެލަށް ދިމާވާނެ."
      },
      "pendingNoLine": "ބަޖެޓް ލައިނެއް ނެތުން: {from} އިން {to} އަށް",
      "actions": {
        "setOwn": "އަމިއްލަ ލެވެލް ކަނޑައަޅާ",
        "change": "ބަދަލުކުރޭ"
      },
      "form": {
        "title": "{scope} ގެ ކޮންޓްރޯލް ލެވެލް",
        "description": "ހަރުކަށިކުރުން އަމަލުކުރެވެނީ ރައްކާކުރާ ވަގުތުން. ލުއިކުރުން އެޕްރޫވަލަށް ފޮނުވޭނެ، އަދި އަމަލުކުރެވެނީ އެހެން މީހަކު އެޕްރޫވްކުރުމުން.",
        "reloaded": "ތިބާ ހުޅުވާފައި ތިއްބަވަނިކޮށް އެހެން މީހަކު މި ކޮންޓްރޯލް ލެވެލް ބަދަލުކޮށްފި. އަލުން ލޯޑްކުރެވިއްޖެ؛ ބައްލަވާފައި ބަދަލު އަލުން ރައްކާކުރައްވާ.",
        "currently": "މިހާރު {level}، ޓޮލަރެންސް {pct}%.",
        "toleranceHint": "8.75% އަށް 8.75 ޖައްސަވާ. ކޮންޓްރޯލް ހިނގުމުގެ ކުރިން ހުއްދަ އިތުރު ޚަރަދު.",
        "toleranceUnused": "މި ލެވެލް ދުވަހަކުވެސް ނުހިނގާތީ ޓޮލަރެންސެއް ނެތް.",
        "toleranceRange": "0 އިން 100 އާ ހަމައަށް އިންސައްތައެއް ޖައްސަވާ، މިސާލަކަށް 8.75.",
        "reasonRequired": "ކޮންޓްރޯލް ލެވެލް ބަދަލުވާ ސަބަބު ބުނެދެއްވާ.",
        "unchanged": "މިއީ މިތާނގައި މިހާރު އަމަލުކުރާ ލެވެލް. އެހެން ލެވެލެއް ނުވަތަ ޓޮލަރެންސެއް ޚިޔާރުކުރައްވާ.",
        "tighten": "މިއީ ކޮންޓްރޯލް ހަރުކަށިކުރުން. ރައްކާކުރާ ވަގުތުން އަމަލުކުރެވޭނެ.",
        "loosen": "މިއީ ކޮންޓްރޯލް ލުއިކުރުން. އެޕްރޫވަލަށް ފޮނުވޭނެ، އަދި އަމަލުކުރެވެނީ ތިބާ ނޫން މީހަކު އެޕްރޫވްކުރުމުން.",
        "submitForApproval": "އެޕްރޫވަލަށް ހުށަހަޅާ",
        "apply": "އަމަލުކުރޭ"
      },
      "toasts": {
        "applied": "ކޮންޓްރޯލް ލެވެލް އަމަލުކުރެވިއްޖެ",
        "appliedDetail": "މި ބަޖެޓާ ޗެކްކުރެވޭ ދެން އަންނަ ލިޔުމަށް އަމަލުކުރެވޭނެ.",
        "pending": "އެޕްރޫވަލަށް ފޮނުވިއްޖެ",
        "pendingDetail": "ތިބާ ނޫން މީހަކު ބަދަލު އެޕްރޫވްކުރަންދެން މިހާރުގެ ލެވެލް އަމަލުކުރެވޭނެ."
      }
    },
    "drivers": {
      "title": "ލިއްކުރެވުނު ތަފްސީލު: ޑްރައިވަރުތަކާއި ސަބަބު",
      "derivedHint": "މި އަދަދަކީ ލިޔުމުގެ ޑްރައިވަރ ޢަދަދާއި ރޭޓުން ހިސާބުކުރެވިފައިވާ އަދަދެކެވެ. ޑްރައިވަރުތައް ތިރީގައިވާ ތަފްސީލުން ބަދަލުކުރައްވާ.",
      "derived": "ހިސާބުކުރެވިފައި",
      "filterLabel": "ދައްކާ",
      "filters": {
        "all": "ހުރިހާ ލިޔުންތައް",
        "drivers": "ޑްރައިވަރު ލިޔުންތައް",
        "flagged": "ސަމާލުކަމަށް ބޭނުންވާ ލިޔުންތައް"
      },
      "explainer": "ޑްރައިވަރު ލިޔުމަކަށް ޢަދަދާއި ރޭޓު ދެޢަދަދުވެސް ބޭނުންވެއެވެ. އަދަދު ހިސާބުކުރަނީ ސާވަރުންނެވެ. ކުރީ އަހަރާ އަޅާބަލާއިރު ބޮޑު ބަދަލަކަށް ސަބަބެއް ބޭނުންވެއެވެ.",
      "caption": "ކޮންމެ ބަޖެޓް ލިޔުމެއްގެ ޑްރައިވަރުތަކާއި ސަބަބު",
      "columns": {
        "period": "މުއްދަތު",
        "amount": "އަދަދު",
        "driverQty": "ޑްރައިވަރ ޢަދަދު",
        "driverRate": "ޑްރައިވަރ ރޭޓް",
        "justification": "ސަބަބު"
      },
      "actualToDate": "ޕޯސްޓްކުރެވިފައިވާ ޙަޤީޤީ",
      "aria": {
        "driverQty": "ޑްރައިވަރ ޢަދަދު، އެކައުންޓް {account}، {period}",
        "driverRate": "ޑްރައިވަރ ރޭޓް، އެކައުންޓް {account}، {period}",
        "justification": "ސަބަބު، އެކައުންޓް {account}، {period}"
      },
      "malformed": {
        "qty": "ދަޝްމަލަވު 4 އަށް ހަމަވާނެ، ޢަދަދު ފިޔަވައި ނުލާ.",
        "rate": "ދަޝްމަލަވު 6 އަށް ހަމަވާނެ، ޢަދަދު ފިޔަވައި ނުލާ."
      },
      "empty": "ދައްކާނެ ލިޔުމެއް ނެތް.",
      "truncated": "ފުރަތަމަ {max} ލިޔުން ދައްކަނީ.",
      "threshold": {
        "both": "ކުރީ އަހަރުގެ އަދަދުގެ {pct}% އަށްވުރެ ބޮޑުވެ {amount} އަށްވުރެ ބޮޑު",
        "pct": "ކުރީ އަހަރުގެ އަދަދުގެ {pct}% އަށްވުރެ ބޮޑު",
        "amount": "{amount} އަށްވުރެ ބޮޑު"
      },
      "basis": {
        "budget": "ކުރީ އަހަރުގެ ބަޖެޓް",
        "actuals": "ކުރީ އަހަރުގެ ޙަޤީޤީ"
      },
      "issues": {
        "justification": "މި ލިޔުމުން {basis} ގެ {prior} އާ އަޅާބަލާއިރު {movement} ބަދަލުވެއެވެ ({threshold}). ސަބަބެއް ބޭނުންވެއެވެ.",
        "driverQty": "ޑްރައިވަރު ލިޔުމަކަށް ޑްރައިވަރ ޢަދަދު ބޭނުންވެއެވެ.",
        "driverRate": "ޑްރައިވަރު ލިޔުމަކަށް ޑްރައިވަރ ރޭޓް ބޭނުންވެއެވެ.",
        "summary": "މި ވަރޝަން ފޮނުވުމުގެ ކުރިން {count} ލިޔުމަށް ސަމާލުކަން ދޭންޖެހެއެވެ."
      }
    },
    "assumptions": {
      "label": "އަސާސީ ޚިޔާލުތައް",
      "hintBudget": "މި ބަޖެޓް ބިނާކުރެވިފައިވާ ޚިޔާލުތައް. ފޮނުވުމުގެ ކުރިން ބޭނުންވެއެވެ.",
      "hintForecast": "މި ލަފާކުރެވޭ ބަޖެޓް ބިނާކުރެވިފައިވާ ޚިޔާލުތައް. އިޚްތިޔާރީ.",
      "requiredError": "ފޮނުވުމުގެ ކުރިން މި ބަޖެޓުގެ އަސާސީ ޚިޔާލުތައް ލިޔުއްވާ.",
      "none": "އަސާސީ ޚިޔާލެއް ނެތް.",
      "save": "ރައްކާކުރޭ",
      "saved": "އަސާސީ ޚިޔާލުތައް ރައްކާކުރެވުނު",
      "requiredToSubmit": "މި ބަޖެޓް ފޮނުވުމުގެ ކުރިން އަސާސީ ޚިޔާލުތައް ލިޔުއްވާ.",
      "saveFirst": "ފޮނުވުމުގެ ކުރިން އަސާސީ ޚިޔާލުތައް ރައްކާކުރައްވާ."
    },
    "forecast": {
      "kinds": {
        "budget": "ބަޖެޓް",
        "forecast": "ލަފާކުރެވޭ"
      },
      "banner": "މިއީ އިސްލާޙުކުރެވިފައިވާ ލަފާކުރުމެކެވެ. {asOf} އަށް ޙަޤީޤީ އަދަދާއި އޭގެ ފަހުން ޕްލޭން. ލަފާކުރެވޭ ބަޖެޓެއް ޚަރަދު ކޮންޓްރޯލް ނުކުރެއެވެ.",
      "openSource": "މޫލީ ވަރޝަން ހުޅުވާ",
      "revise": {
        "title": "ލަފާކުރުން އިސްލާޙުކުރޭ",
        "description": "މި ވަރޝަނުން ނުވަ ޑްރާފްޓް ލަފާކުރުމެއް ހަދައެވެ. ހަމަޖެހުނު މުއްދަތުތަކަށް ޙަޤީޤީ އަދަދު ލައެވެ. މި ވަރޝަން ބަދަލެއް ނުވެއެވެ.",
        "action": "ލަފާކުރުން އިސްލާޙުކުރޭ",
        "name": "ނަން",
        "nameHint": "ނަމެއް ނުލިޔެވިއްޖެނަމަ ޑިފޯލްޓް ނަން.",
        "asOf": "ޙަޤީޤީ އަދަދު ހަމަވަނީ",
        "asOfHint": "ހުސްކޮށް ބާއްވައިފިނަމަ މިއަދު.",
        "asOfInvalid": "ތާރީޚެއް ލިޔުއްވާ.",
        "assumptions": "އަސާސީ ޚިޔާލުތައް",
        "assumptionsHint": "އިޚްތިޔާރީ. ފަހުން އިތުރުކުރެވޭނެ.",
        "note": "ނޯޓް",
        "doneTitle": "ލަފާކުރުން ހެދިއްޖެ",
        "doneDetail": "ނުވަ ލަފާކުރުން އެޑިޓްކުރުމަށް ހުޅުވިފައި."
      },
      "baseline": {
        "title": "ބޭސްލައިނެއް ފިޔަވަޅުލާ",
        "description": "މި ވަރޝަނުގެ ލިޔުންތަކުގެ ބަދަލުނުވާ ކޮޕީއެއް ހަދައެވެ.",
        "action": "ބޭސްލައިން ހަދާ",
        "label": "ލޭބަލް",
        "labelHint": "ހުސްކޮށް ބާއްވައިފިނަމަ \"Baseline N\".",
        "doneTitle": "ބޭސްލައިން ހެދިއްޖެ",
        "doneDetail": "ބޭސްލައިން {no} ގައި {count} ލިޔުން ހިމެނެއެވެ."
      }
    },
    "forecastReport": {
      "title": "ލަފާކުރެވޭ ބަޖެޓާ ބަޖެޓް",
      "description": "ޚަރަދު ކޮންޓްރޯލްކުރާ ބަޖެޓާ އިސްލާޙުކުރެވިފައިވާ ލަފާކުރުން އަޅާބަލުން.",
      "company": "ޤާނޫނީ ޙައިސިއްޔަތު",
      "choosePlaceholder": "ޤާނޫނީ ޙައިސިއްޔަތެއް ހޮވާ",
      "chooseTitle": "ޤާނޫނީ ޙައިސިއްޔަތާއި މާލީ އަހަރެއް ހޮވާ",
      "chooseDescription": "ރިޕޯޓުގައި އެއް ޤާނޫނީ ޙައިސިއްޔަތާއި އެއް މާލީ އަހަރު ހިމެނެއެވެ.",
      "loadFailed": "ރިޕޯޓް ލޯޑެއް ނުވި",
      "noneTitle": "މި އަހަރަށް ލަފާކުރުމެއް ނެތް",
      "noneDescription": "ތަސްދީޤުކުރެވިފައިވާ ބަޖެޓެއް ލަފާކުރުމަކަށް އިސްލާޙުކުރައްވާ.",
      "forecastTitle": "ލަފާކުރުން",
      "forecast": "ލަފާކުރުމުގެ ވަރޝަން",
      "asOf": "ޙަޤީޤީ އަދަދު ހަމަވަނީ",
      "budgetVersion": "އަޅާބަލާ ބަޖެޓް",
      "openBudget": "ހިނގަމުންދާ ބަޖެޓް ހުޅުވާ",
      "noBudget": "ހިނގަމުންދާ ބަޖެޓެއް ނެތް",
      "baseline": "ފަހުގެ ބޭސްލައިން",
      "noBaseline": "ނެގިފައެއް ނެތް",
      "rowsTitle": "އެކައުންޓާއި މުއްދަތުން",
      "onlyMoved": "ބަޖެޓާ ތަފާތު ކީތަކެއް ކުރަނީ",
      "caption": "އެކައުންޓާއި މުއްދަތުން ލަފާކުރެވޭ ބަޖެޓާ ބަޖެޓް",
      "columns": {
        "budget": "ބަޖެޓް",
        "forecast": "ލަފާކުރެވޭ",
        "variance": "ތަފާތު",
        "variancePct": "ތަފާތު %",
        "baseline": "ބޭސްލައިން",
        "changeSinceBaseline": "ބޭސްލައިނުން ފަހުން ބަދަލު",
        "drivers": "ޑްރައިވަރު (ޢަދަދު × ރޭޓް)"
      },
      "forecastDrivers": "ލަފާކުރެވޭ",
      "budgetDrivers": "ބަޖެޓް",
      "emptyRows": "ދައްކާނެ ކީ ނެތް."
    },
    "settings": {
      "title": "ބަޖެޓް ސެޓިންގްސް",
      "description": "ކުރީ އަހަރާ އަޅާބަލާއިރު ބަދަލަކީ ބޮޑު ބަދަލެއްކަމުގައި ވާނީ ކޮން ހައްދަކުން ފެށިގެންކަން ކަނޑައަޅާ.",
      "company": "ޤާނޫނީ ޙައިސިއްޔަތު",
      "choosePlaceholder": "ޤާނޫނީ ޙައިސިއްޔަތެއް ހޮވާ",
      "chooseTitle": "ޤާނޫނީ ޙައިސިއްޔަތެއް ހޮވާ",
      "chooseDescription": "ބަޖެޓް ސެޓިންގްސް އެއް ޤާނޫނީ ޙައިސިއްޔަތަކަށް ނިސްބަތްވެއެވެ.",
      "loadFailed": "ބަޖެޓް ސެޓިންގްސް ލޯޑެއް ނުވި",
      "materialityTitle": "ބޮޑު ބަދަލުގެ ހައްދު",
      "isDefault": "ޑިފޯލްޓް ބޭނުންކުރަނީ",
      "explainer": "ކަނޑައެޅިފައިވާ ހުރިހާ ހައްދަކަށްވުރެ ބޮޑުވާ ބަދަލަކީ ބޮޑު ބަދަލެކެވެ. ހައްދެއް ނަގާލަން ފީލްޑް ހުސްކުރައްވާ. މަދުވެގެން އެއް ހައްދު ބޭނުންވެއެވެ.",
      "pct": "ކުރީ އަހަރުގެ އަދަދުގެ ޕަސެންޓް",
      "pctHint": "8.75% އަށް 8.75 ލިޔުއްވާ",
      "pctRange": "0 އާ 100 ދެމެދު ޕަސެންޓެއް ލިޔުއްވާ.",
      "amount": "އަދަދު ({currency})",
      "amountHint": "ޤާނޫނީ ޙައިސިއްޔަތުގެ ބޭސް ކަރަންސީން.",
      "amountInvalid": "ނެގެޓިވް ނޫން އަދަދެއް ލިޔުއްވާ.",
      "needOne": "ޕަސެންޓް، އަދަދު، ނުވަތަ ދެމީހުން ކަނޑައަޅާ.",
      "save": "ސެޓިންގްސް ރައްކާކުރޭ",
      "readOnly": "މި ސެޓިންގްސް ބަލާލެވޭނެ، ނަމަވެސް ބަދަލުކުރެވޭކަށް ނޫން.",
      "awaitingApproval": "ތަސްދީޤަށް މަޑުކުރަނީ",
      "inForce": "ހިނގަމުންދާ:",
      "requested": "އެދިފައިވަނީ:",
      "requestedBy": "ބޭނުންކުރާ {user} ގެ ފަރާތުން {at} ގައި އެދުނު",
      "openApprovals": "ތަސްދީޤު އިންބޮކްސް ހުޅުވާ (އެދުން {id})",
      "approvalUnresolvable": "މި ބަދަލަށް ތިމަންނާއާ ތަފާތު ތަސްދީޤުކުރާ މީހަކު ނުފެނުނު. ފިނޭންސް މެނޭޖަރަކު ކަނޑައެޅުމަށް އެޑްމިނިސްޓްރޭޓަރަށް ދަންނަވާ.",
      "off": "ނިއްވާފައި",
      "toasts": {
        "pending": "ބަދަލު ތަސްދީޤަށް ފޮނުވިއްޖެ",
        "pendingDetail": "ހައްދު ލުއިކުރުމަކީ އެހެން މީހަކު ތަސްދީޤުކުރާހާ ހިނދަކު ހިނގާނެ ބަދަލެއް ނޫން. މިހާރުގެ ހައްދު ހިނގަމުންދާނެ.",
        "saved": "ސެޓިންގްސް ރައްކާކުރެވުނު",
        "savedDetail": "ނުވަ ހައްދު ފަހުން ފޮނުވާ އެއްޗަކަށް ގެންގުޅޭނެ."
      }
    },
    "movements": {
      "fields": {
        "company": "ޤާނޫނީ އެންޓިޓީ",
        "amount": "އަދަދު",
        "amountHint": "ދެ ދިހަ އަކުރާ ހަމައަށް ޕޮޒިޓިވް އަދަދެއް.",
        "amountInvalid": "ދެ ދިހަ އަކުރަށްވުރެ ގިނައެއް ނުވާ ޕޮޒިޓިވް އަދަދެއް ޖައްސަވާ.",
        "reason": "ސަބަބު",
        "reasonRequired": "ސަބަބެއް ބޭނުންވޭ.",
        "fiscalYear": "މާލީ އަހަރު",
        "period": "މުއްދަތު",
        "account": "އެކައުންޓް",
        "costCentre": "ކޮސްޓް ސެންޓަރު",
        "noCostCentre": "ކޮސްޓް ސެންޓަރެއް ނެތް"
      },
      "statuses": {
        "pending": "އެޕްރޫވަލަށް މަޑުކުރަނީ",
        "approved": "އެޕްރޫވްކުރެވިފައި",
        "rejected": "ރިޖެކްޓްކުރެވިފައި"
      },
      "columns": {
        "requested": "އެދުނު ތާރީޚު",
        "approval": "އެޕްރޫވަލް",
        "requestedBy": "އެދުނީ",
        "decidedBy": "ނިންމީ",
        "appliedAt": "ހިނގި ވަގުތު"
      },
      "approvalRequest": "އެޕްރޫވަލް އެދުން {id}",
      "history": "އެދި މީހާއާއި ނިންމުން",
      "decisionNote": "ނިންމުމުގެ ނޯޓް: {note}",
      "userFallback": "ޔޫޒަރު {id}",
      "availability": {
        "noPermission": "ބާކީ ބެލުމުގެ ހުއްދަ ނެތުމުން ބާކީ ނުދައްކާ. ސަރވަރު އަދިވެސް ބަލާނެ.",
        "pick": "ބާކީ ބެލުމަށް މުއްދަތާއި އެކައުންޓް އިޚްތިޔާރުކުރައްވާ.",
        "loading": "ބާކީ ލޯޑުކުރަނީ...",
        "unbudgeted": "މި ކީއަށް ޚާއްސަ ބަޖެޓް ލައިނެއް ނެތް. ދައްކާ އަދަދުތަކަކީ ނޯ-ލައިން ސިޔާސަތުގެ އަދަދުތަކެވެ.",
        "budget": "ބަޖެޓް",
        "commitments": "ކޮމިޓްމަންޓް",
        "actuals": "އެކްޗުއަލް",
        "available": "ބާކީ"
      },
      "chain": {
        "title": "އެޕްރޫވަލް ޗެއިން",
        "none": "މި ރެކޯޑަށް އެޕްރޫވަލް އެދުމެއް ގުޅިފައެއް ނުވޭ.",
        "unavailable": "އެޕްރޫވަލް ޗެއިން ލޯޑުނުކުރެވުނު. ނިންމުން އަދިވެސް ނިންމާނީ އެޕްރޫވަލް އިންބޮކްސްއިންނެވެ.",
        "step": "ފިޔަވަޅު {n}",
        "unassigned": "ހޯލްޑަރެއް ނުނިމުނު",
        "sodNote": "އެދި މީހަކު އެޕްރޫވަރަކަށް ނުވާނެ. ފިޔަވަޅެއް އެޕްރޫވްކުރި މީހަކު އެދި މީހަކަށް ނުވާނެ.",
        "openInbox": "އެޕްރޫވަލް އިންބޮކްސް ހުޅުވާ",
        "statuses": {
          "pending": "މަޑުކުރަނީ",
          "active": "ކުރިއަށްދަނީ",
          "approved": "އެޕްރޫވްކުރެވިފައި",
          "completed": "ނިމިފައި",
          "rejected": "ރިޖެކްޓްކުރެވިފައި",
          "skipped": "ދޫކޮށްލެވިފައި",
          "voided": "ބާޠިލުކުރެވިފައި"
        }
      }
    },
    "transfers": {
      "title": "ބަޖެޓް ޓްރާންސްފަރ",
      "description": "ކޮސްޓް ސެންޓަރުތަކާ ނުވަތަ އެކައުންޓްތަކުގެ ދެމެދު ބަޖެޓް ބަދަލުކުރުން. އެދި މީހާ ނޫން މީހަކު އެޕްރޫވްކުރުމުން ހަމައެކަނި ޓްރާންސްފަރ ހިނގާނެ.",
      "actions": {
        "request": "ޓްރާންސްފަރއަށް އެދުން"
      },
      "totalsTitle": "ރަޖިސްޓަރގެ ޖުމްލަ",
      "truncated": "ރަޖިސްޓަރ ރިޕޯޓް އޭގެ ސަފުގެ ހިދުމަތުގައި ކެނޑުނީ، އެހެންކަމުން މި ޖުމްލަތަކުގައި ފެންނަނީ ދީފައިވާ ސަފުތަކެވެ.",
      "loadFailed": "ބަޖެޓް ޓްރާންސްފަރ ލޯޑުނުކުރެވުނު",
      "emptyTitle": "ބަޖެޓް ޓްރާންސްފަރއެއް ނެތް",
      "emptyDescription": "މި ފިލްޓަރތަކާ ގުޅޭ ޓްރާންސްފަރއެއް ނެތް. ބަޖެޓް ހުރި ކީއަކުން ބޭނުންވާ ކީއަކަށް ބަދަލުކުރުމަށް އެދުއްވާ.",
      "columns": {
        "number": "ޓްރާންސްފަރ",
        "from": "ކޮންތާކުން",
        "to": "ކޮންތާކަށް"
      },
      "toasts": {
        "requested": "ޓްރާންސްފަރ {no} އެދިފި",
        "requestedDetail": "ތިބާ ނޫން މީހަކު އެޕްރޫވްކުރުމުން ހިނގާނެ.",
        "requestFailed": "ޓްރާންސްފަރއަށް އެދެވެނީ ނޫން"
      },
      "request": {
        "title": "ބަޖެޓް ޓްރާންސްފަރއަކަށް އެދުން",
        "description": "އެއް މާލީ އަހަރުގެ ތެރޭގައި އެއް ބަޖެޓް ކީއަކުން އަނެއް ކީއަކަށް އަދަދެއް ބަދަލުކުރައްވާ.",
        "from": "ކޮންތާކުން (ސޯސް)",
        "to": "ކޮންތާކަށް (މަންޒިލް)",
        "noPermission": "ބަޖެޓް ޓްރާންސްފަރއަށް އެދުމުގެ ހުއްދަ ތިބާގައި ނެތް.",
        "overAvailable": "މިއީ ސޯސްގައި މިހާރު ހުރި ބާކީއަށްވުރެ ބޮޑު އަދަދެއް. ސަރވަރު ރަދުކުރާނެ، އަދި އެޕްރޫވްކުރާއިރުވެސް އަލުން ބަލާނެ.",
        "approvalNote": "ޓްރާންސްފަރ އެޕްރޫވަލަށް މަޑުކުރާނީ ތިބާ ނޫން މީހަކުންނެވެ. އެ ހިނދާ ހަމައަށް އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވޭ. ސޯސްގައި އޭގެ ޚާއްސަ ބަޖެޓް ލައިނެއް ހުންނަންވާނެ.",
        "submit": "ޓްރާންސްފަރއަށް އެދުން"
      },
      "detail": {
        "title": "ބަޖެޓް ޓްރާންސްފަރ",
        "description": "ދެ ކީ، ސޯސްގައި ހުރި ބާކީ، އަދި އެޕްރޫވަލް ޗެއިން.",
        "back": "ޓްރާންސްފަރތަކަށް ފަހަތަށް",
        "loadFailed": "މި ޓްރާންސްފަރ ލޯޑުނުކުރެވުނު",
        "summary": "ޓްރާންސްފަރ",
        "availableAtRequest": "އެދުމުގައި ސޯސްގެ ބާކީ",
        "availableAtApproval": "އެޕްރޫވްކުރުމުގައި ސޯސްގެ ބާކީ",
        "sourceBudget": "ސޯސް ބަޖެޓް، ކުރިންނާއި ފަހުން",
        "targetBudget": "މަންޒިލް ބަޖެޓް، ކުރިންނާއި ފަހުން"
      }
    },
    "supplementary": {
      "title": "އިތުރު ބަޖެޓް އެދުންތައް",
      "description": "އެއް ކީއަށް ސަބަބާއެކު ބަޖެޓް އިތުރުކުރުމަށް އެދުންތައް. އެޕްރޫވަލް ވަނީ އަގުގެ ބޭންޑުން، އެދި މީހާއަށް ނޫން.",
      "actions": {
        "request": "އިތުރު ބަޖެޓަކަށް އެދުން"
      },
      "loadFailed": "އިތުރު ބަޖެޓް އެދުންތައް ލޯޑުނުކުރެވުނު",
      "emptyTitle": "އިތުރު ބަޖެޓް އެދުމެއް ނެތް",
      "emptyDescription": "މި ފިލްޓަރތަކާ ގުޅޭ އެދުމެއް ނެތް. ކީއަކަށް ހުރިއަށްވުރެ ގިނަ ބަޖެޓް ބޭނުންވާ ހިނދު އެދުއްވާ.",
      "columns": {
        "number": "އެދުން",
        "key": "ބަޖެޓް ކީ"
      },
      "toasts": {
        "requested": "އެދުން {no} ހުށަހެޅުނު",
        "requestedDetail": "އޭގެ އަގަށް ބަލައި އެޕްރޫވަލް ޗެއިން އެޕްރޫވްކުރުމުން ހިނގާނެ.",
        "requestFailed": "އެދުން ހުށަހެޅެނީ ނޫން"
      },
      "request": {
        "title": "އިތުރު ބަޖެޓަކަށް އެދުން",
        "description": "އެއް ކީއަށް ބަޖެޓް އިތުރުކޮށް ސަބަބު ބުނެދެއްވާ.",
        "target": "އިތުރުކުރަންވީ ބަޖެޓް ކީ",
        "noPermission": "އިތުރު ބަޖެޓަށް އެދުމުގެ ހުއްދަ ތިބާގައި ނެތް.",
        "justification": "ސަބަބު",
        "justificationRequired": "ސަބަބެއް ބޭނުންވޭ.",
        "approvalNote": "އެދުން އެޕްރޫވަލަށް މަޑުކުރާނީ ތިބާ ނޫން މީހަކުންނެވެ. އެ ހިނދާ ހަމައަށް ބަޖެޓް ބަދަލެއް ނުވޭ.",
        "submit": "އެދުން ހުށަހަޅާ",
        "band": {
          "finance_manager": "100,000 އަށްވުރެ ކުޑަ: ފިނޭންސް މެނޭޖަރު އެޕްރޫވްކުރާނެ ކަމަށް ލަފާކުރެވޭ. ހައްލުވި ޗެއިން ތަފްސީލުގައި ފެންނާނެ.",
          "cfo": "100,000 ނުވަތަ އެއަށްވުރެ ބޮޑު: ފިނޭންސް މެނޭޖަރާއެކު ސީއެފްއޯވެސް ބޭނުންވާނެ ކަމަށް ލަފާކުރެވޭ. ހައްލުވި ޗެއިން ތަފްސީލުގައި ފެންނާނެ."
        }
      },
      "detail": {
        "title": "އިތުރު ބަޖެޓް އެދުން",
        "description": "ކީ، އަދަދު، ސަބަބު އަދި އެޕްރޫވަލް ޗެއިން.",
        "back": "އިތުރު ބަޖެޓް އެދުންތަކަށް ފަހަތަށް",
        "loadFailed": "މި އެދުން ލޯޑުނުކުރެވުނު",
        "summary": "އެދުން",
        "budgetChange": "ބަޖެޓް، ކުރިންނާއި ފަހުން"
      }
    },
    "forecastRegister": {
      "title": "ރިވައިސްކުރި ފޯކާސްޓްތައް",
      "description": "ބަޖެޓް ސައިކަލްތަކުގެ ހުރިހާ ރިވައިސްކުރި ފޯކާސްޓެއް: އޭޒް-އޮފް ތާރީޚާ ހަމައަށް ހިނގި ޢަދަދުތަކާއި، އޭގެ ފަހުގެ ރޭވުން. ފޯކާސްޓަކުން ޚަރަދު ކޮންޓްރޯލެއް ނުކުރެއެވެ.",
      "cycle": "ބަޖެޓް ސައިކަލް",
      "hint": "އެޕްރޫވްކުރި ނުވަތަ ލޮކްކުރި ފޯކާސްޓެއް ކުރިއަށް ގެންދިއުމަށް ރިވައިސްކުރޭ؛ ރިވައިސްކުރާ ފޯކާސްޓަށް ބަދަލެއް ނާދެއެވެ.",
      "loadFailed": "ފޯކާސްޓްތައް ލޯޑެއް ނުވި",
      "emptyTitle": "ދިމާވާ ފޯކާސްޓެއް ނެތް",
      "emptyDescription": "ފޯކާސްޓެއް ހެދުމަށް އެޕްރޫވްކުރި ބަޖެޓެއް އޭގެ ވާޝަން ސްކްރީނުން ރިވައިސްކުރޭ، ނުވަތަ ފިލްޓަރުތައް ފޮހެލާ.",
      "version": "ފޯކާސްޓް",
      "versionNo": "v{no}",
      "revisedFrom": "ރިވައިސްކުރީ މީގެން",
      "preparer": "ތައްޔާރުކުރި މީހާ",
      "asOf": "ހިނގި ޢަދަދު، މި ތާރީޚާ ހަމައަށް",
      "updated": "އެންމެ ފަހުގެ ބަދަލު",
      "actions": "ޢަމަލުތައް"
    },
    "cycles": {
      "title": "ބަޖެޓް ސައިކަލްތައް",
      "description": "ސައިކަލަކީ އެއް ލީގަލް އެންޓިޓީއެއްގެ އެއް މާލީ އަހަރަށް ރޭވުމުގެ މަރުހަލާއެވެ: މެތަޑޮލޮޖީއެއް، ހުށަހަޅަންޖެހޭ ސުންގަޑިއެއް، އަދި ކޮސްޓް ސެންޓަރުތައް ހުށަހަޅާ ވެރިން.",
      "detailDescription": "ސައިކަލްގެ ތަފްސީލު، ހުށަހަޅާފައިވާ ފަރާތްތައް، އަދި ވަރޝަންތައް. އެއް ފަހަރާ ނާފިޒުވާނީ އެއް ވަރޝަނެވެ.",
      "factsTitle": "ސައިކަލް",
      "backToList": "ހުރިހާ ސައިކަލެއް",
      "loadFailed": "ބަޖެޓް ސައިކަލްތައް ލޯޑެއް ނުވި",
      "emptyTitle": "އަދި ބަޖެޓް ސައިކަލެއް ނެތް",
      "emptyDescription": "ސައިކަލަކީ ކޮންޓެއިނަރެކެވެ: އެއް ލީގަލް އެންޓިޓީ، އެއް މާލީ އަހަރު، މެތަޑޮލޮޖީއެއް އަދި ސުންގަޑިއެއް. އެއް ސައިކަލް ހަދާ، ކޮސްޓް ސެންޓަރުގެ ވެރިން ކަނޑައަޅާ، ހުޅުވާ، ދެން ވަރޝަނެއް އިތުރުކޮށް އަދަދުތައް ލޯޑްކުރައްވާ.",
      "reloaded": "ތިޔަ ސައިކަލް ހުޅުވައިގެން ހުއްޓައި އެހެން މީހަކު އެއަށް ބަދަލު ގެނެސްފި. އަލުން ލޯޑްކުރެވިއްޖެ؛ ބައްލަވާފައި ތިޔަ ބަދަލު އަލުން ކުރައްވާ.",
      "compareVersions": "ވަރޝަންތައް އަޅާކިޔާ",
      "actions": {
        "create": "އައު ސައިކަލް",
        "open": "ސައިކަލް ހުޅުވާ",
        "close": "ސައިކަލް ބަންދުކުރޭ",
        "edit": "ބަދަލުކުރޭ"
      },
      "fields": {
        "methodology": "މެތަޑޮލޮޖީ",
        "methodologyHint": "ސައިކަލް ހުޅުވުމުން ބަދަލެއް ނުކުރެވޭނެ.",
        "deadline": "ހުށަހަޅަންޖެހޭ ސުންގަޑި",
        "deadlineHint": "ވެރިން ހުށަހަޅަންޖެހޭ ތާރީޚު. ސައިކަލް ހުޅުވުމުން ވެރިންނަށް މި ތާރީޚު އަންގާނެ.",
        "openedAt": "ހުޅުވި",
        "closedAt": "ބަންދުކުރި"
      },
      "methodologies": {
        "incremental": "އިންކްރިމެންޓަލް",
        "zero_based": "ޒީރޯ-ބޭސްޑް",
        "driver_based": "ޑްރައިވަރ-ބޭސްޑް",
        "rolling": "ރޯލިންގ ފޯކާސްޓް"
      },
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "open": "ހުޅުވިފައި",
        "closed": "ބަންދުކޮށްފައި"
      },
      "create": {
        "title": "އައު ބަޖެޓް ސައިކަލް",
        "description": "އެއް ލީގަލް އެންޓިޓީ، އެއް މާލީ އަހަރު. ވެރިން، ވަރޝަންތައް އަދި އަދަދުތައް ދެން."
      },
      "edit": {
        "title": "ސައިކަލް ބަދަލުކުރޭ",
        "description": "ބަދަލުތައް އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑުކުރެވޭނެ.",
        "methodologyFixed": "ސައިކަލް ހުޅުވިފައި ނުވަތަ ބަންދުކޮށްފައިވާތީ މެތަޑޮލޮޖީ ބަދަލެއް ނުކުރެވޭނެ.",
        "deadlineHint": "ސުންގަޑި ނައްތާލަން ހުސްކޮށް ބާއްވާ.",
        "deadlineFixed": "ސައިކަލް ބަންދުކޮށްފައިވާތީ ސުންގަޑި ބަދަލެއް ނުކުރެވޭނެ."
      },
      "open": {
        "title": "މި ސައިކަލް ހުޅުވަންތޯ؟",
        "message": "ހުޅުވުމުން ކަނޑައަޅާފައިވާ {count} ކޮސްޓް ސެންޓަރުގެ ވެރިންނަށް އަންގައި ހުށަހެޅުމުގެ މުއްދަތު ފަށާނެ. އެއަށްފަހު މެތަޑޮލޮޖީ ބަދަލެއް ނުކުރެވޭނެ."
      },
      "close": {
        "title": "މި ސައިކަލް ބަންދުކުރަންތޯ؟",
        "message": "{outstanding} ކޮސްޓް ސެންޓަރު އަދި ހުށަނާޅާ. ބަންދުކުރުމުން ސައިކަލް ނިމޭނެ: ވެރިން ބަދަލެއް ނުކުރެވޭނެ، އަދި އެއްވެސް އެއްޗެއް ހުށަނާޅެވޭނެ. މިކަން އަނބުރާ ނުކުރެވޭނެ."
      },
      "board": {
        "title": "ހުށަހެޅުންތައް",
        "assign": "ވެރިއަކު ކަނޑައަޅާ",
        "loadFailed": "ހުށަހެޅުމުގެ ހާލަތު ލޯޑެއް ނުވި",
        "emptyTitle": "އެއްވެސް ވެރިއަކު ކަނޑައަޅާފައެއް ނެތް",
        "emptyDescription": "ބަޖެޓް ތައްޔާރުކުރާ ކޮންމެ ކޮސްޓް ސެންޓަރަކަށް ވެރިއަކު ކަނޑައަޅާ. ސައިކަލް ހުޅުވުމުން އެމީހުންނަށް އަންގާނެ، އަދި އެމީހުންގެ ކޮސްޓް ސެންޓަރު މިތަނުން ހުށަހަޅާނެ.",
        "progress": "{total} ކޮސްޓް ސެންޓަރުން {submitted} ހުށަހަޅާފައި",
        "costCentre": "ކޮސްޓް ސެންޓަރު",
        "owner": "ވެރިފަރާތް",
        "submittedAt": "ހުށަހެޅި",
        "submit": "ހުށަހަޅާ",
        "reopen": "އަލުން ހުޅުވާ",
        "reassign": "އެހެން މީހަކަށް ދޭ",
        "remove": "ނައްތާލާ",
        "states": {
          "pending": "ބާކީ",
          "submitted": "ހުށަހަޅާފައި"
        }
      },
      "assign": {
        "title": "ކޮސްޓް ސެންޓަރުގެ ވެރިއަކު ކަނޑައަޅާ",
        "description": "ކޮންމެ ކޮސްޓް ސެންޓަރަކަށް އެއް ވެރިއެއް. ހުޅުވިފައިވާ ސައިކަލެއްނަމަ ވެރިފަރާތަށް އަވަހަށް އަންގާނެ."
      },
      "reassign": {
        "title": "{code} އެހެން މީހަކަށް ދޭ",
        "description": "މިހާރު ވެރިފަރާތަކީ {owner}. ސައިކަލް ހުޅުވިފައިވާނަމަ އައު ވެރިފަރާތަށް އަންގާނެ."
      },
      "remove": {
        "title": "މި ވެރިފަރާތް ނައްތާލަންތޯ؟",
        "message": "މި ސައިކަލްގައި {code} ގެ ވެރިފަރާތަކަށް {owner} ނުވާނެ."
      },
      "errors": {
        "nothingToSubmit": "މި ކޮސްޓް ސެންޓަރަށް މަސައްކަތްކުރާ ވަރޝަންގައި އަދި އެއްވެސް ލައިނެއް ނެތް. އަދަދުތައް ޖައްސަވާފައި ހުށަހަޅުއްވާ.",
        "rowVersion": "މީގެ ކުރިން އެހެން މީހަކު ބަދަލުކޮށްފި. އަލުން ލޯޑްކުރެވިއްޖެ؛ ތިޔަ ބަދަލު އަލުން ކުރައްވާ."
      },
      "toasts": {
        "createdDetail": "ވެރިން ކަނޑައަޅާފައި ސައިކަލް ހުޅުއްވާ.",
        "createFailed": "ސައިކަލް ނުހެދުނު",
        "saved": "ސައިކަލް ސޭވްކުރެވިއްޖެ",
        "saveFailed": "ސައިކަލް ސޭވެއް ނުކުރެވުނު",
        "opened": "ސައިކަލް ހުޅުވިއްޖެ",
        "openedDetail": "ކަނޑައަޅާފައިވާ ހުރިހާ ވެރިންނަށް އަންގައިފި.",
        "closed": "ސައިކަލް ބަންދުކުރެވިއްޖެ",
        "openFailed": "ސައިކަލް ނުހުޅުވުނު",
        "closeFailed": "ސައިކަލް ބަންދެއް ނުކުރެވުނު",
        "submitted": "{code} ހުށަހެޅިއްޖެ",
        "reopened": "{code} ވެރިފަރާތަށް އަލުން ހުޅުވިއްޖެ",
        "submitFailed": "ކޮސްޓް ސެންޓަރު ހުށަނާޅުނު",
        "reopenFailed": "ކޮސްޓް ސެންޓަރު އަލުން ނުހުޅުވުނު",
        "assigned": "ވެރިފަރާތް ކަނޑައެޅިއްޖެ",
        "assignFailed": "ވެރިފަރާތް ކަނޑައެއް ނާޅުނު",
        "reassigned": "{code} އެހެން މީހަކަށް ދެވިއްޖެ",
        "reassignFailed": "ކޮސްޓް ސެންޓަރު އެހެން މީހަކަށް ނުދެވުނު",
        "removed": "{code} ގެ ވެރިފަރާތް ނައްތާލެވިއްޖެ",
        "removeFailed": "ވެރިފަރާތް ނައްތައެއް ނުލެވުނު"
      }
    },
    "versionList": {
      "title": "ބަޖެޓް ވަރޝަންތައް",
      "description": "ހުރިހާ ސައިކަލެއްގެ ހުރިހާ ވަރޝަނެއް. އަޅާކިޔަން އެއް ލީގަލް އެންޓިޓީއެއްގެ ދެ ވަރޝަން ޓިކްކުރައްވާ.",
      "compareSelected": "އަޅާކިޔާ ({count}/2)",
      "compareHint": "އެއް ލީގަލް އެންޓިޓީއެއްގެ ދެ ވަރޝަން ޓިކްކޮށް، އަޅާކިޔާ އަށް ފިއްތަވާ.",
      "differentEntities": "މި ދެ ވަރޝަނަކީ ތަފާތު ލީގަލް އެންޓިޓީތަކުގެ ވަރޝަންތައް. އަޅާކިޔޭނީ އެއް ލީގަލް އެންޓިޓީއެއްގެ ވަރޝަންތަކެވެ.",
      "loadFailed": "ބަޖެޓް ވަރޝަންތައް ލޯޑެއް ނުވި",
      "emptyTitle": "ގުޅޭ ވަރޝަނެއް ނެތް",
      "emptyDescription": "ވަރޝަންތައް ހެދެނީ ބަޖެޓް ސައިކަލެއްގެ ތެރޭގައެވެ. ސައިކަލެއް ހުޅުވައި ވަރޝަނެއް އިތުރުކުރައްވާ، ނުވަތަ ފިލްޓަރުތައް ސާފުކުރައްވާ.",
      "pick": "އަޅާކިޔަން ނަގާ",
      "pickAria": "{name} އަޅާކިޔަން ނަގާ",
      "cycle": "ސައިކަލް"
    },
    "compare": {
      "title": "ބަޖެޓް ވަރޝަންތައް އަޅާކިޔުން",
      "description": "އެއް ލީގަލް އެންޓިޓީއެއްގެ ދެ ވަރޝަން، ލައިނަށް ލައިނަށް. ހުރިހާ އަދަދެއް، ތަފާތެއް އަދި ޖުމްލައެއް ހިސާބުކުރަނީ ސާވަރުންނެވެ.",
      "versionA": "ވަރޝަން A",
      "versionB": "ވަރޝަން B",
      "apply": "އަޅާކިޔާ",
      "swap": "A އާއި B ބަދަލުކުރޭ",
      "samePicked": "ތަފާތު ދެ ވަރޝަން ނަންގަވާ.",
      "emptyTitle": "ދެ ވަރޝަން ނަންގަވާ",
      "emptyDescription": "ލީގަލް އެންޓިޓީއެއް، ދެން ވަރޝަން A އާއި ވަރޝަން B ނަންގަވާ. ތަފާތަކީ B އިން A އުނިކުރުމުން ލިބޭ އަދަދު.",
      "loadFailed": "އަޅާކިޔުން ލޯޑެއް ނުވި",
      "summaryTitle": "ޚުލާސާ",
      "totalA": "ޖުމްލަ A",
      "totalB": "ޖުމްލަ B",
      "totalDelta": "ޖުމްލަ ބަދަލު (B − A)",
      "changedCount": "ތަފާތު ލައިންތައް",
      "changedOnly": "ތަފާތު ލައިންތައް އެކަނި ދައްކާ",
      "noDifferencesTitle": "އެއްވެސް ތަފާތެއް ނެތް",
      "noDifferencesDescription": "ކޮންމެ ލައިނެއްގެ އަދަދު ދެ ވަރޝަނުގައިވެސް އެއްގޮތް. ހުރިހާ ލައިނެއް ބަލަން ފިލްޓަރު ނައްތާލައްވާ.",
      "account": "އެކައުންޓް",
      "period": "މުއްދަތު",
      "dimensions": "ޑައިމެންޝަންތައް",
      "amountA": "A",
      "amountB": "B",
      "delta": "ބަދަލު",
      "change": "ހަރަކާތް",
      "changes": {
        "unchanged": "ބަދަލެއް ނުވޭ",
        "changed": "ބަދަލުވެފައި",
        "added": "B ގައި އިތުރުކޮށްފައި",
        "removed": "B ގައި ނައްތާލާފައި"
      }
    },
    "availability": {
      "title": "ލިބެން ހުރި ބަޖެޓް",
      "description": "އެއް އެކައުންޓަކާއި މުއްދަތަކަށް ބަޖެޓް، ކޮމިޓްމަންޓްތައް، ހަޤީޤީ ޚަރަދު އަދި އަދިވެސް ލިބެން ހުރި އަދަދު — ބަޖެޓް ޗެކެއް ބޭނުންކުރާ އެއް އަދަދުތައް.",
      "account": "އެކައުންޓް",
      "period": "މުއްދަތު",
      "costCentre": "ކޮސްޓް ސެންޓަރު",
      "anyCostCentre": "ކޮންމެވެސް (މުޅި އެކައުންޓް)",
      "check": "ޗެކްކުރޭ",
      "emptyTitle": "އިންޓަރސެކްޝަނެއް ނަންގަވާ",
      "emptyDescription": "ލީގަލް އެންޓިޓީ، މާލީ އަހަރު، އެކައުންޓް އަދި މުއްދަތު ނަންގަވާ، ބޭނުންނަމަ ކޮސްޓް ސެންޓަރެއްވެސް، ދެން ޗެކްކުރައްވާ.",
      "loadFailed": "ލިބެން ހުރި އަދަދު ލޯޑެއް ނުވި",
      "unbudgeted": "މި އިންޓަރސެކްޝަނާ ގުޅޭ ބަޖެޓް ލައިނެއް ނެތް. ދައްކާފައިވާ ބަޖެޓަކީ ރޭވުމަކުން އައި އަދަދެއް ނޫން، ލީގަލް އެންޓިޓީގެ ނޯ-ލައިން ސިޔާސަތުން އައި އަދަދެކެވެ.",
      "resultTitle": "މާލީ އަހަރު {year}",
      "controlLevels": {
        "none": "ކޮންޓްރޯލެއް ނެތް",
        "advisory": "ލަފާދިނުން ކަނޑައެކަނި",
        "warn": "ބޮޑުވެއްޖެނަމަ އިންޒާރުދޭ",
        "block": "ބޮޑުވެއްޖެނަމަ މަނާކުރޭ"
      },
      "controlSources": {
        "cost_center": "ކޮސްޓް ސެންޓަރުގެ ސެޓިންގ",
        "company_default": "ލީގަލް އެންޓިޓީގެ ޑިފޯލްޓް"
      },
      "controlSource": "ކޮންޓްރޯލް ކަނޑައެޅީ",
      "tolerance": "ޓޮލަރަންސް",
      "toleranceValue": "{pct}%",
      "budget": "ބަޖެޓް",
      "commitments": "ކޮމިޓްމަންޓްތައް",
      "actuals": "ހަޤީޤީ ޚަރަދު",
      "available": "ލިބެން ހުރި",
      "openVariance": "މި އެކައުންޓުގެ ވޭރިއަންސް ރިޕޯޓު ހުޅުވާ"
    }
  },
  "inventory": {
    "filtersTitle": "ފިލްޓަރތައް",
    "active": "ހަރަކާތްތެރި",
    "inactive": "ހަރަކާތްތެރި ނޫން",
    "itemPickerTruncated": "ލޯޑްވީ ފުރަތަމަ ދެހާސް ތަކެތި އެކަނިކަމުން، ތަކެތި ޚިޔާރުކުރާ ލިސްޓް ފުރިހަމަ ނުވެދާނެއެވެ. ހޯދައިގެން ކުޑަކުރައްވާ.",
    "routeTitles": {
      "items": "ތަކެތި",
      "item": "ތަކެތި",
      "serials": "ސީރިއަލް ރަޖިސްޓަރީ",
      "warehouses": "ގުދަންތައް",
      "warehouse": "ގުދަން",
      "stockLevels": "ސްޓޮކް ލެވެލްތައް",
      "stockLedger": "ސްޓޮކް ލެޖަރ",
      "adjustments": "ސްޓޮކް އެޖަސްޓްމަންޓްތައް",
      "adjustment": "ސްޓޮކް އެޖަސްޓްމަންޓް",
      "reasonCodes": "އެޖަސްޓްމަންޓް ސަބަބުގެ ކޯޑުތައް",
      "cycleCounts": "ސައިކަލް ކައުންޓްތައް",
      "cycleCount": "ސައިކަލް ކައުންޓް",
      "transfers": "ސްޓޮކް ޓްރާންސްފަރތައް",
      "transfer": "ސްޓޮކް ޓްރާންސްފަރ",
      "revaluations": "ރީވެލުއޭޝަންތައް",
      "reorderSuggestions": "ރީއޯޑަރ ހުށަހެޅުންތައް",
      "valuation": "މުދަލުގެ ވެލުއޭޝަން",
      "lots": "ލޮޓުތައް",
      "lot": "ލޮޓު",
      "recalls": "ރީކޯލްތައް",
      "recall": "ރީކޯލް",
      "warehouseLayout": "ގުދަނުގެ ތަރުތީބު",
      "settings": "އިންވެންޓަރީ ސެޓިންގްސް",
      "reservations": "ރިޒަވޭޝަންތައް",
      "shortages": "މަދުވުންތައް",
      "substitutes": "ބަދަލުތައް",
      "countReview": "ގުނުމުގެ މުރާޖައާ",
      "parLevels": "ޕާރ ލެވެލް",
      "requisitions": "ރެކުއިޒިޝަންތައް",
      "requisition": "ރެކުއިޒިޝަން",
      "waste": "އުކާލުން",
      "shrinkage": "ގެއްލުން",
      "recipes": "ރެސިޕީތައް",
      "recipe": "ރެސިޕީ",
      "usageVariance": "ބޭނުންކުރުމުގެ ތަފާތު",
      "depletions": "ސްޓޮކުން އުނިކުރުންތައް",
      "haccp": "ކާނާގެ ސަލާމަތް",
      "shipments": "ލޭންޑަޑް ކޮސްޓް",
      "landedCostSetup": "ލޭންޑަޑް ކޮސްޓް ސެޓަޕް",
      "shipment": "ޝިޕްމަންޓް",
      "landedCostAging": "ކްލިއަރިން އޭޖިން",
      "replenishment": "ސްޓޮކް އިތުރުކުރުން",
      "classification": "ލަސް އަދި ބޭނުންނުކުރާ ސްޓޮކް",
      "recon": "ވެލުއޭޝަން ރިކޮންސިލިއޭޝަން",
      "reconRun": "ރިކޮންސިލިއޭޝަން ރަން"
    },
    "fields": {
      "sku": "އެސް.ކޭ.ޔޫ",
      "item": "ތަކެތި",
      "itemPlaceholder": "ޚިޔާރުކުރޭ ތަކެތި",
      "type": "ބާވަތް",
      "baseUom": "އަސާސީ ޔުނިޓް",
      "uomCode": "ޔުނިޓް",
      "conversionFactor": "ބަދަލުކުރާ ނިސްބަތް",
      "defaults": "ޑިފޯލްޓްތައް",
      "purchaseDefault": "ގަތުމުގެ ޑިފޯލްޓް",
      "salesDefault": "ވިއްކުމުގެ ޑިފޯލްޓް",
      "barcode": "ބާކޯޑް",
      "taxGroup": "ޓެކްސް ގްރޫޕް",
      "tracking": "ޓްރެކިންގ",
      "trackBatch": "ބެޗް ޓްރެކްކުރޭ",
      "trackSerial": "ސީރިއަލް ޓްރެކްކުރޭ",
      "reorderMin": "ރީއޯޑަރ އެންމެ ދަށް",
      "reorderPoint": "ރީއޯޑަރ ޕޮއިންޓް",
      "reorderMax": "ރީއޯޑަރ އެންމެ މަތި",
      "costingMethod": "އަގު ބަލާ ގޮތް",
      "inventoryAccount": "މުދަލުގެ ހިސާބު",
      "cogsAccount": "ސީ.އޯ.ޖީ.އެސް ހިސާބު",
      "adjustmentAccount": "އެޖަސްޓްމަންޓް ފައިދާ/ގެއްލުމުގެ ހިސާބު",
      "accountPlaceholder": "ޚިޔާރުކުރޭ ހިސާބު",
      "company": "ކުންފުނި",
      "companyPlaceholder": "ޚިޔާރުކުރޭ ކުންފުނި",
      "warehouse": "ގުދަން",
      "warehousePlaceholder": "ޚިޔާރުކުރޭ ގުދަން",
      "fromWarehouse": "ފޮނުވާ ގުދަން",
      "toWarehouse": "ލިބޭ ގުދަން",
      "bin": "ބިން",
      "fromBin": "ފޮނުވާ ބިން",
      "toBin": "ލިބޭ ބިން",
      "code": "ކޯޑު",
      "negativeStockPolicy": "ނެގެޓިވް ސްޓޮކް",
      "onHand": "ހުރި ޢަދަދު",
      "reserved": "ރިޒަރވްކޮށްފައި",
      "reservedSoft": "ރިޒަރވް (ސޮފްޓް)",
      "reservedHard": "ރިޒަރވް (ހާޑް)",
      "available": "ލިބެންހުރި",
      "avgUnitCost": "އެވްރެޖް ޔުނިޓް އަގު",
      "unitCost": "ޔުނިޓް އަގު",
      "newUnitCost": "އައު ޔުނިޓް އަގު",
      "value": "ވެލިއު",
      "valueChange": "ވެލިއުގެ ބަދަލު",
      "quantity": "ޢަދަދު",
      "qtyDelta": "ޢަދަދުގެ ބަދަލު",
      "systemQty": "ސިސްޓަމް",
      "countedQty": "ގުނުނު",
      "variance": "ތަފާތު",
      "runningQty": "ހިނގަމުންދާ ޢަދަދު",
      "runningValue": "ހިނގަމުންދާ ވެލިއު",
      "movementType": "ހަރަކާތް",
      "document": "ލިޔުން",
      "documentNo": "ނަންބަރު",
      "lines": "ސަފުތައް",
      "lotNo": "ލޮޓް",
      "serialNos": "ސީރިއަލް ނަންބަރުތައް",
      "journal": "ޖާނަލް",
      "businessDate": "ތާރީޚު",
      "date": "ތާރީޚު",
      "adjustmentDate": "އެޖަސްޓްމަންޓް ތާރީޚު",
      "transferDate": "ޓްރާންސްފަރ ތާރީޚު",
      "countDate": "ގުނާ ތާރީޚު",
      "createdAt": "އުފެއްދި",
      "memo": "ނޯޓު",
      "reason": "ސަބަބު",
      "reasonCode": "ސަބަބުގެ ކޯޑު",
      "reasonPlaceholder": "ޚިޔާރުކުރޭ ސަބަބު",
      "fromInTransitAccount": "އިން-ޓްރާންސިޓް ހިސާބު (ފޮނުވާ ކުންފުނި)",
      "toInTransitAccount": "އިން-ޓްރާންސިޓް ހިސާބު (ލިބޭ ކުންފުނި)",
      "none": "ނެތް",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "amount": "އަދަދު",
      "asOf": "ތާރީޚަށް",
      "currency": "ފައިސާ",
      "fxRate": "ފައިސާ ބަދަލުކުރާ ރޭޓް",
      "note": "ނޯޓު"
    },
    "itemTypes": {
      "stocked": "ސްޓޮކްކުރާ",
      "non_stock": "ސްޓޮކް ނުކުރާ",
      "service": "ޚިދުމަތް"
    },
    "itemTypeHints": {
      "stocked": "ސްޓޮކް ލެޖަރުގައި ހަރަކާތްކުރެއެވެ، އަދި ބާކީއެއް ބަހައްޓައެވެ.",
      "non_stock": "ގަނެ ސީދާ ޚަރަދަށް ލައެވެ، ސްޓޮކް ލެޖަރަށް ނުދެއެވެ.",
      "service": "މަސައްކަތް ނުވަތަ ޚިދުމަތެއް، ސްޓޮކް ލެޖަރަށް ނުދެއެވެ."
    },
    "movementTypes": {
      "receipt": "ލިބުނު",
      "issue": "ދޫކުރި",
      "transfer_out": "ޓްރާންސްފަރ ބޭރަށް",
      "transfer_in": "ޓްރާންސްފަރ އެތެރެއަށް",
      "adjustment_in": "އެޖަސްޓްމަންޓް އެތެރެއަށް",
      "adjustment_out": "އެޖަސްޓްމަންޓް ބޭރަށް",
      "revaluation": "ރީވެލުއޭޝަން",
      "reversal": "ރިވަރސަލް",
      "landed_cost": "ލޭންޑަޑް ކޮސްޓް",
      "waste": "އުކާލުން"
    },
    "docTypes": {
      "adjustment": "އެޖަސްޓްމަންޓްތައް",
      "cyclecount": "ސައިކަލް ކައުންޓްތައް",
      "transfer": "ޓްރާންސްފަރތައް",
      "revaluation": "ރީވެލުއޭޝަންތައް"
    },
    "negativeStock": {
      "block": "ހުއްޓުވާ",
      "blockHint": "ބާކީ ސުމަށްވުރެ ދަށްވާ ކޮންމެ ހަރަކާތެއް ބަލައިނުގަނެއެވެ.",
      "blockStatement": "މި ގުދަނުގައި ނެގެޓިވް ސްޓޮކް ހުއްޓުވިފައެވެ: ބާކީ ސުމަށްވުރެ ދަށްކުރާ ހަރަކާތެއް، އެއްވެސް އެއްޗެއް ލިޔުމުގެ ކުރިން ބަލައިނުގަނެއެވެ.",
      "allow": "ހުއްދަ",
      "allowHint": "ބާކީ ސުމަށްވުރެ ދަށްކުރާ ހަރަކާތެއް ބަލައިގަނެއެވެ.",
      "allowStatement": "މި ގުދަނުގައި ނެގެޓިވް ސްޓޮކް ހުއްދައެވެ: ހަރަކާތަކުން ބާކީ ސުމަށްވުރެ ދަށްވެދާނެއެވެ."
    },
    "costing": {
      "MA": "މޫވިންގ އެވްރެޖް",
      "MAHint": "ގުދަނަކަށް އެއް އެވްރެޖް އަގު، ކޮންމެ ހަރަކާތަކަށްފަހު ވެލިއު ÷ ޢަދަދު ގޮތަށް އަލުން ބަލައެވެ. ދޫކުރުމުން މިހާރުގެ އެވްރެޖް ނަގައި، އެ އެވްރެޖަށް ބަދަލެއް ނާދެއެވެ.",
      "FIFO": "ފީފޯ",
      "FIFOHint": "ކޮންމެ ލިބުމަކުން އެއަށް ޚާއްޞަ އަގުގައި ލޭޔަރެއް އުފެދެއެވެ. ދޫކުރުމުން އެންމެ ދުވަސްވީ ލޭޔަރުން ފެށިގެން ބޭނުންކުރެއެވެ، އެހެންކަމުން އެއް ދޫކުރުމަކުން އެކި އަގުތަކުގައި ގިނަ ސަފުތަކެއް ޕޯސްޓްވެދާނެއެވެ.",
      "panelTitle": "އަގު ބެލުމާއި ޕޯސްޓްކުރުން",
      "panelDescription": "ކުންފުންޏަކަށް ވަކިން ކަނޑައެޅެއެވެ: ތަކެއްޗަކީ މުޅި ޓެނަންޓަށް ހުރި އެއްޗެއް ނަމަވެސް، ކުންފުންޏަކުން އޭގެ އަގު ބަލާ ގޮތާއި ޕޯސްޓްކުރާ ހިސާބުތައް ވަކިވެއެވެ.",
      "title": "{sku} ގެ އަގުގެ ސެޓިންގތައް",
      "description": "{company} އިން މި ތަކެތީގެ އަގު ބަލާ ގޮތާއި ހަރަކާތްތައް ޕޯސްޓްވާ ތަން.",
      "methodHint": "މި ތަކެތީގެ ކުރިއަށްއޮތް ކޮންމެ އަގެއް ނަގާނެ ތަން ކަނޑައަޅައެވެ.",
      "configure": "ސެޓްކުރޭ",
      "change": "ބަދަލުކުރޭ",
      "inventoryAccountHint": "ލިބުމުން ޑެބިޓް، ދޫކުރުމުން ކްރެޑިޓް. ބާވަތަކީ އެސެޓް ކަމުގައި ވާންޖެހެއެވެ.",
      "cogsAccountHint": "ސްޓޮކް ދޫކުރުމުން ޗާޖްވެއެވެ. ބާވަތަކީ ޚަރަދު ކަމުގައި ވާންޖެހެއެވެ.",
      "adjustmentAccountHint": "އެޖަސްޓްމަންޓް، ކައުންޓް ތަފާތު ނުވަތަ ރީވެލުއޭޝަން ތަފާތު ދާ ތަން. އާމްދަނީ ނުވަތަ ޚަރަދު.",
      "requiredNote": "ކުންފުންޏަކަށް އަގުގެ ސެޓިންގތައް ނެތް ތަކެއްޗެއް، އެ ކުންފުނީގެ އެއްވެސް ގުދަނަކަށް ނުލިބޭނެއެވެ — ސާވަރުން ބަލައިނުގަނެ މި ސްކްރީނަށް އިޝާރާތްކުރެއެވެ. ޑިފޯލްޓެއް ނެތެވެ.",
      "dangerTitle": "މި ތަކެތީގައި މިހާރުވެސް ސްޓޮކް ހަރަކާތްތައް ހުއްޓެވެ",
      "dangerBody": "މިހާރު އަގު ބަލާ ގޮތް ބަދަލުކުރުމުން، ފޮތުގައި މިހާރު ހުރި ސްޓޮކްގެ އަގުގެ އަސާސް އެހެން ގޮތަކަށް މާނަކުރެވެއެވެ. މޫވިންގ އެވްރެޖްގައި ލިބުނު ސްޓޮކަށް ފީފޯއަށް ބޭނުންކުރާނެ ލޭޔަރެއް ނުހުންނާނެއެވެ.",
      "dangerDetail": "ސްޓޮކް ލެޖަރުގައި މިހާރު ހުރި އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވާނެއެވެ — ލެޖަރަކީ ހަމައެކަނި އިތުރުކުރެވޭ އެއްޗެކެވެ. ނަތީޖާއަކީ ތާރީޚް އެއް ގޮތަކަށް، މުސްތަޤްބަލް އެހެން ގޮތަކަށް ބަލާ ވެލުއޭޝަނެކެވެ. މިއީ ގަސްދުގައި ނިންމާ އެކައުންޓިންގ ސިޔާސަތުގެ ނިންމުމެއް ކަމުގައި ނޫނީ ބަދަލުނުކުރައްވާ.",
      "acknowledge": "މިހާރު ހުރި ސްޓޮކްގެ އަގުގެ އަސާސް އެހެން ގޮތަކަށް މާނަކުރެވޭކަން އަހަރެން ދަންނަމެވެ.",
      "changeBeforeMovements": "މި ތަކެތީގައި އަދި ހަރަކާތެއް ނެތުމުން، އަގު ބަލާ ގޮތް މިނިވަންކަމާއެކު ބަދަލުކުރެވިދާނެއެވެ.",
      "hasMovementsNote": "މި ތަކެތީގައި ސްޓޮކް ހަރަކާތްތައް ހުއްޓެވެ. މިހާރުން ފެށިގެން އަގު ބަލާ ގޮތަކީ މުހިންމު އެއްޗެކެވެ — ބަދަލުކުރުމުން ފޮތުގައި ހުރި ސްޓޮކްގެ އަގުގެ އަސާސް އެހެން ގޮތަކަށް މާނަކުރެވެއެވެ.",
      "noMovementsNote": "މި ތަކެތީގައި އަދި ހަރަކާތެއް ނެތުމުން، އަގު ބަލާ ގޮތް ނަތީޖާއެއް ނެތި ބަދަލުކުރެވިދާނެއެވެ.",
      "notConfigured": "{company} އިން މި ތަކެތި ސެޓްކޮށްފައެއް ނުވެއެވެ.",
      "notConfiguredConsequence": "ސެޓްކުރަންދެން، މި ތަކެތި އެ ކުންފުނީގެ އެއްވެސް ގުދަނަކަށް ނުލިބޭނެއެވެ.",
      "saved": "އަގުގެ ސެޓިންގތައް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{company} އަށް ބޭނުންކުރެވިއްޖެ.",
      "saveFailed": "އަގުގެ ސެޓިންގތައް ރައްކާނުކުރެވުނު",
      "loadFailed": "އަގުގެ ސެޓިންގތައް ނުލިބުނު"
    },
    "items": {
      "title": "ތަކެތި",
      "description": "ވިޔަފާރިން ގަންނަ، ބަހައްޓާ ނުވަތަ ވިއްކާ ހުރިހާ އެއްޗެއް. އަގު ބެލުން ކުންފުންޏަކަށް ވަކިން ސެޓްކުރެއެވެ.",
      "create": "އައު ތަކެތި",
      "createDescription": "އެސް.ކޭ.ޔޫ، ބާވަތް އަދި އަސާސީ ޔުނިޓް، ތަކެތި އުފެދުމުން ބަދަލެއް ނުކުރެވެއެވެ.",
      "edit": "ތަކެތި އެޑިޓްކުރޭ",
      "editDescription": "އެސް.ކޭ.ޔޫ، ބާވަތް، އަސާސީ ޔުނިޓް އަދި ޓްރެކިންގ ފްލެގްތައް ބަދަލެއް ނުކުރެވެއެވެ.",
      "immutableNote": "އެސް.ކޭ.ޔޫ، ބާވަތް، އަސާސީ ޔުނިޓް އަދި ބެޗް/ސީރިއަލް ފްލެގްތައް ފައްކާވެފައެވެ: ސްޓޮކް ލެޖަރުގެ ކޮންމެ ޢަދަދެއް ބުނެފައިވަނީ އަސާސީ ޔުނިޓުންނެވެ.",
      "skuHint": "ތަކެތީގެ އައިޑެންޓިޓީ. ފަހުން ބަދަލެއް ނުކުރެވެއެވެ.",
      "typeHint": "ސްޓޮކް ލެޖަރަށް ދަނީ ހަމައެކަނި ސްޓޮކްކުރާ ތަކެއްޗެވެ.",
      "baseUomHint": "ލެޖަރުގެ ކޮންމެ ޢަދަދެއް ބުނާ ޔުނިޓް. ތަކެތި އުފެދުމުން ފައްކާވެއެވެ.",
      "taxHint": "މި ތަކެތީގެ ލިޔުމުގެ ސަފުތަކަށް ބޭނުންކުރާ ޑިފޯލްޓް ޓެކްސް ކޯޑް.",
      "trackingHint": "ބެޗް ޓްރެކިންގއިން ކޮންމެ ހަރަކާތެއްގައި ލޮޓް ނަންބަރެއް އުފުލައެވެ؛ ސީރިއަލް ޓްރެކިންގއިން ލިބޭއިރު ކޮންމެ ޔުނިޓެއް ވަކިން ރަޖިސްޓްރީކުރެއެވެ. ދެކަންވެސް އުފެއްދުމުގައި ފައްކާވެއެވެ.",
      "reorderMinHint": "މިއަށްވުރެ ދަށްވުމުން ސްޓޮކް ނުރައްކާތެރި ދަށްވަރެއްގައެވެ.",
      "reorderPointHint": "ލިބެންހުރި ސްޓޮކް މިއަށް ނުވަތަ މިއަށްވުރެ ދަށްވުމުން، ރޭގަނޑުގެ ސްކޭނުން ރީއޯޑަރެއް ހުށަހަޅައެވެ.",
      "reorderMaxHint": "ރީއޯޑަރަކުން ބާކީ ގެންދަން ބޭނުންވާ މިންވަރު.",
      "reorderOrderWarning": "އެންމެ މަތި، އެންމެ ދަށަށްވުރެ ދަށެވެ. މިއީ ބަލައިގަނެވޭ ކަމެއް ނަމަވެސް، ގިނަފަހަރު ޓައިޕޯއެކެވެ.",
      "costingNextStep": "ދެން: މި ތަކެތި ބަހައްޓާނެ ކޮންމެ ކުންފުންޏަކަށް، އަގު ބަލާ ގޮތާއި ޕޯސްޓްކުރާ ހިސާބުތައް ސެޓްކުރައްވާ. އެހާތަނަށް މި ތަކެތި ނުލިބޭނެއެވެ.",
      "searchHint": "އެސް.ކޭ.ޔޫ، ނަން ނުވަތަ ބާކޯޑް",
      "tableLabel": "ތަކެތި",
      "emptyTitle": "އަދި ތަކެއްޗެއް ނެތެވެ",
      "emptyDescription": "ސްޓޮކް ލިބުން، ދޫކުރުން އަދި ގުނުން ފެށުމަށް އެއް ތަކެތި އުފައްދަވާ.",
      "truncated": "ލޯޑްވީ ފުރަތަމަ {count} ތަކެތި އެކަނިއެވެ. ބާކީ ބެލުމަށް ބާވަތުން ނުވަތަ ހޯދުމުން ކުޑަކުރައްވާ.",
      "loadFailed": "ތަކެތި ނުލިބުނު",
      "created": "ތަކެތި އުފެދިއްޖެ",
      "createdDetail": "{sku} ސެޓްކުރަން ތައްޔާރެވެ.",
      "createFailed": "ތަކެތި ނުއުފެއްދުނު",
      "saved": "ތަކެތި ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{sku} އަޕްޑޭޓްވެއްޖެ.",
      "saveFailed": "ތަކެތި ރައްކާނުކުރެވުނު",
      "exported": "{count} ތަކެތި އެކްސްޕޯޓްކުރެވިއްޖެ",
      "factsTitle": "ތަކެތި",
      "notStockedNote": "މިއީ {type} ތަކެއްޗެއް ކަމުން ސްޓޮކް ލެޖަރަށް ނުދެއެވެ: މި ނަން ބޭނުންކުރާ ލިބުމެއް ނުވަތަ ދޫކުރުމެއް ބަލައިނުގަނެއެވެ.",
      "stockTitle": "ގުދަނުން ސްޓޮކް",
      "stockDescription": "ހުރި ޢަދަދު، މިހާރު ވަޢުދުވެފައިވާ މިންވަރު، އަދި ބާކީ ވަޢުދުވެވޭ މިންވަރު.",
      "stockCaption": "މި ތަކެތީގެ ގުދަނުން ހުރި ބާކީތައް",
      "noStock": "މި ތަކެތި އެއްވެސް ތަނެއްގައި ނެތެވެ.",
      "viewMovements": "ހަރަކާތްތައް",
      "backToList": "ތަކެއްޗަށް އެނބުރި"
    },
    "serials": {
      "title": "ސީރިއަލް ރަޖިސްޓަރީ",
      "description": "ސްޓޮކަށް ބަލައިގަނެފައިވާ ސީރިއަލް ހުރިހާ ޔުނިޓަކާއި، މިހާރު އެ ޔުނިޓް އޮތް ތަން.",
      "tableTitle": "ސީރިއަލް ޔުނިޓްތައް",
      "caption": "މިހާރުގެ ފިލްޓަރުތަކާ ގުޅޭ ސީރިއަލް ޔުނިޓްތައް",
      "searchLabel": "ސީރިއަލް ނަންބަރު",
      "searchPlaceholder": "ސީރިއަލް ނަންބަރު ސްކޭންކުރައްވާ ނުވަތަ އޭގެ ބައެއް ލިޔުއްވާ",
      "loadFailed": "ސީރިއަލް ރަޖިސްޓަރީ ލޯޑެއް ނުކުރެވުނު",
      "empty": "އަދި ސީރިއަލް ޔުނިޓެއް ނެތް. ސީރިއަލް ޓްރެކްކުރާ ބާވަތެއް ބަލައިގަތުމުން ޔުނިޓް މިތަނުގައި ފެންނާނެއެވެ.",
      "emptyFiltered": "މި ފިލްޓަރުތަކާ ގުޅޭ ސީރިއަލް ޔުނިޓެއް ނެތް.",
      "openLedger": "ހަރަކާތްތައް",
      "lotsLink": "ލޮޓް ރަޖިސްޓަރީ",
      "historyNote": "ހަރަކާތްތަކުން ހުޅުވެނީ އެ ޔުނިޓްގެ ބާވަތާއި ގުދަނުގެ ސްޓޮކް ލެޖަރެވެ. ކޮންމެ ހަރަކާތެއްގައި ސީރިއަލް ނަންބަރުތައް ލެޖަރުގައި ރެކޯޑްކުރެވޭ ނަމަވެސް، އެއް ސީރިއަލްއަކަށް ފިލްޓަރެއް އަދި ނުކުރެވެއެވެ. އެހެންކަމުން މިއީ އެ ޔުނިޓް އެކަނި ނޫން، އެ ޖޯޑުގެ ފުރިހަމަ ލިސްޓެވެ.",
      "columns": {
        "serialNo": "ސީރިއަލް ނަންބަރު",
        "lot": "ލޮޓް"
      },
      "statuses": {
        "in_stock": "ސްޓޮކްގައި",
        "issued": "ދޫކޮށްފައި"
      }
    },
    "uoms": {
      "panelTitle": "މިންކުރާ ޔުނިޓްތައް",
      "panelDescription": "އިތުރު ޔުނިޓްތައް، ކޮންމެއެއް {base} އަށް ބަދަލުކުރާ ނިސްބަތެއްގެ ގޮތުގައި.",
      "caption": "މި ތަކެތީގެ މިންކުރާ ޔުނިޓްތައް",
      "base": "އަސާސީ",
      "add": "ޔުނިޓެއް އިތުރުކުރޭ",
      "edit": "ޔުނިޓް އެޑިޓްކުރޭ",
      "description": "މި ޔުނިޓްގެ އެކަތީގައި ހުންނަނީ ކިތައް {base} ކަން.",
      "codeHint": "ކުރު ކޯޑެއް، މިސާލަކަށް CARTON.",
      "factorHint": "މި ޔުނިޓްގެ އެކަތީގައި ހުންނަ {base} ގެ ޢަދަދު.",
      "factorMustBePositive": "ބަދަލުކުރާ ނިސްބަތް ސުމަށްވުރެ ބޮޑުވާން ޖެހެއެވެ.",
      "directionNote": "ނިސްބަތަކީ މި ޔުނިޓްގެ އެކަތީގައި ހުންނަ {base} ގެ ޢަދަދެވެ — ބާރަ ހުންނަ ކާޓަނަކީ 12 އެވެ، 1/12 އެއް ނޫނެވެ. އަނެއްކޮޅަށް ޖެހުމުން، ބަލާބެލުމަށް ރަނގަޅު އޯޑަރުތަކެއް އެ ނިސްބަތުން ގޯސްވެއެވެ.",
      "saved": "ޔުނިޓް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{code} އަޕްޑޭޓްވެއްޖެ.",
      "saveFailed": "ޔުނިޓް ރައްކާނުކުރެވުނު"
    },
    "warehouses": {
      "title": "ގުދަންތައް",
      "description": "ސްޓޮކް ބަހައްޓާ ތަންތަނާއި، ކޮންމެ ތަނަކުން ތަންފީޒުކުރާ ނެގެޓިވް ސްޓޮކްގެ ޤަވާޢިދު.",
      "create": "އައު ގުދަން",
      "edit": "ގުދަން އެޑިޓްކުރޭ",
      "dialogDescription": "ކުންފުނި އުފެއްދުމުގައި ފައްކާވެއެވެ: ހަރަކާތްތައް ޕޯސްޓްވަނީ އެ ކުންފުނީގެ ހިސާބުތަކުންނެވެ.",
      "companyHint": "ގުދަން އުފެދުމުން ފައްކާވެއެވެ.",
      "policyHint": "އެއްވެސް އެއްޗެއް ލިޔުމުގެ ކުރިން ބަލައެވެ، އެހެންކަމުން ހުއްޓުވާ ހަރަކާތެއް ލެޖަރުގައި ނުޖެހެއެވެ.",
      "allowConsequence": "ނެގެޓިވް ސްޓޮކް ހުއްދަކުރުމުން، ފީފޯ ލޭޔަރުތައް ހުސްވާ ތަކެތީގެ މަދުވާ މިންވަރު، ބަލައިނުގަތުމުގެ ބަދަލުގައި، މިހާރުގެ އެވްރެޖް އަގުގައި ޗާޖްކުރެއެވެ.",
      "allowingNegative": "މީގެ ތެރެއިން {count} ގުދަނުގައި ނެގެޓިވް ސްޓޮކް ހުއްދައެވެ.",
      "tableTitle": "ގުދަންތައް",
      "tableCaption": "ގުދަންތަކާއި އެތަންތަނުގެ ނެގެޓިވް ސްޓޮކް ސިޔާސަތު",
      "binsNote": "ބިންތައް ހުންނަނީ ގުދަނުގެ ތެރޭގައެވެ؛ ބެލެހެއްޓުމަށް ގުދަނެއް ހުޅުވާ.",
      "viewStock": "ސްޓޮކް",
      "empty": "އަދި ގުދަނެއް ނެތެވެ.",
      "emptyFiltered": "މި ފިލްޓަރތަކާ ގުޅޭ ގުދަނެއް ނެތެވެ.",
      "loadFailed": "ގުދަންތައް ނުލިބުނު",
      "saved": "ގުދަން ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{code} އަޕްޑޭޓްވެއްޖެ.",
      "saveFailed": "ގުދަން ރައްކާނުކުރެވުނު",
      "stockTitle": "މިތާ ހުރި ސްޓޮކް",
      "stockDescription": "ތަކެއްޗަކަށް ހުރި ޢަދަދު، ރިޒަރވް އަދި ލިބެންހުރި.",
      "stockCaption": "މި ގުދަނުގައި ހުރި ބާކީތައް",
      "noStock": "މި ގުދަނުގައި އެއްވެސް އެއްޗެއް ނެތެވެ."
    },
    "bins": {
      "blockHint": "ބްލޮކްކޮށްފައިވާ ބިންއަކަށް ޕުޓްއަވޭއެއް ނުކުރެވޭނެ، ޕިކެއްވެސް ނުދެވޭނެއެވެ. އޭގައި ހުރި ސްޓޮކް ހުންނާނެއެވެ.",
      "blockLabel": "މި ބިން ބްލޮކްކުރޭ",
      "blockReasonRequired": "ސޭވްކުރުމުގެ ކުރިން ބިން ބްލޮކްކުރި ސަބަބު ލިޔުއްވާ.",
      "blockedReason": "ބްލޮކްކުރި ސަބަބު",
      "capacityHint": "ބިން ފުރެނީ އެންމެ ފުރަތަމަ ހަމަވާ ލިމިޓަކުންނެވެ. ލިމިޓެއް ނެތްކަން ދެއްކުމަށް ހުސްކޮށް ބާއްވާށެވެ.",
      "kindHint": "ބިން ބޭނުންކުރާ ގޮތް. ޕިކިން ފޭސްއަށް ބަލްކުން ފުރާލެވެއެވެ، ސީދާ ބަލައިގަނެވެނީއެއް ނޫނެވެ.",
      "maxQty": "އެންމެ ގިނަ އަދަދު",
      "maxVolumeM3": "އެންމެ ބޮޑު ވޮލިއުމް (މ³)",
      "maxWeightKg": "އެންމެ ބަރު (ކިލޯ)",
      "panelTitle": "ބިންތައް",
      "panelDescription": "މި ގުދަނުގެ ތެރޭގައި ހުރި ތަންތަން. ބިންއަކީ ތަނެއް، ބާކީއެއް ނޫނެވެ.",
      "caption": "މި ގުދަނުގެ ބިންތައް",
      "add": "ބިންއެއް އިތުރުކުރޭ",
      "edit": "ބިން އެޑިޓްކުރޭ",
      "dialogDescription": "ބިންއިން ރައްކާކުރި ނުވަތަ ނެގި ތަން ރެކޯޑްކުރެއެވެ؛ ބާކީ ބަހައްޓަނީ ގުދަނަކަށެވެ.",
      "codeHint": "ކުރު ކޯޑެއް، މިސާލަކަށް A-01-3.",
      "empty": "އަދި ބިންއެއް ނެތެވެ. ބިންއެއް ނެތަސް ސްޓޮކް ބެހެއްޓިދާނެއެވެ.",
      "pickSequenceHint": "ޕިކަރު މި ބިންއަށް ދާ ތަރުތީބު، އެންމެ ކުޑަ ނަންބަރު ފުރަތަމަ.",
      "saved": "ބިން ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{code} އަޕްޑޭޓްވެއްޖެ.",
      "saveFailed": "ބިން ރައްކާނުކުރެވުނު",
      "blocked": "ހިފެހެއްޓިފައި",
      "capacity": "ޖާގަ",
      "description": "ބޭނުންކުރެވިފައިވާ މިންވަރަކީ ކަނޑައެޅި ޖާގައާ އަޅާކިޔާ މިންވަރެވެ. ޖާގަ ކަނޑައަޅާފައި ނުވާ ބިނަކަށް މިންވަރެއް ނެތެވެ.",
      "kind": "ބާވަތް",
      "kinds": {
        "bulk": "ބަލްކް",
        "picking": "ނަގާ ތަން",
        "quarantine": "ކަރަންޓީނު",
        "staging": "ސްޓޭޖިން",
        "storage": "ރައްކާކުރުން"
      },
      "loadFailed": "ބިންތައް ލޯޑެއް ނުވި",
      "noCapacity": "ޖާގަ ކަނޑައަޅާފައެއް ނުވޭ",
      "onHand": "ގުދަނުގައި",
      "open": "ހުޅުވިފައި",
      "storageClassHint": "މި ބިން ދޭ ކްލާސް ނޫން ކްލާހެއް ބޭނުންވާ ބާވަތެއް ޕުޓްއަވޭ ގަބޫލެއް ނުކުރެއެވެ.",
      "title": "ބިންތައް",
      "utilisation": "ބޭނުންކުރެވިފައި",
      "zoneHint": "މި ބިން އޮތް ޒޯން. ޒޯނެއް ނެތް ބިންތަކަށް ގުދަނުގެ ޑިފޯލްޓް ބޭނުންކުރެވެއެވެ."
    },
    "stockLevels": {
      "title": "ސްޓޮކް ލެވެލްތައް",
      "description": "ހުރި ޢަދަދަކީ ޢިމާރާތުގައި ހުރި މިންވަރެވެ. ލިބެންހުރި މިންވަރަކީ އަދިވެސް ވަޢުދުވެވޭ މިންވަރެވެ.",
      "itemHint": "އަޅާކިޔޭ ޢަދަދުގެ ޖުމްލައެއް ބެލުމަށް އެއް ތަކެތި ޚިޔާރުކުރައްވާ.",
      "tableTitle": "ބާކީތައް",
      "tableDescription": "ތަކެއްޗާއި ގުދަނަކަށް އެއް ސަފު، އެ ބާކީ ސާބިތުކުރާ ލެޖަރ ސަފުތަކާ އެއް ޓްރާންސެކްޝަނެއްގައި ބެލެހެއްޓެއެވެ.",
      "tableCaption": "ތަކެއްޗާއި ގުދަނުން ހުރި، ރިޒަރވް އަދި ލިބެންހުރި ސްޓޮކް",
      "total": "ޖުމްލަ",
      "mixedUnits": "އެކި ޔުނިޓްތައް",
      "holds": "ހިފެހެއްޓުންތައް",
      "movements": "ހަރަކާތްތައް",
      "atCap": "ފަސްސަތޭކަ ސަފު އައިސްފައިވެއެވެ، އެއީ މި އެންޑްޕޮއިންޓްގެ ކެޕެވެ. އިތުރު ހުރެދާނެއެވެ؛ ޔަޤީންކުރުމަށް ތަކެތިން ނުވަތަ ގުދަނުން ކުޑަކުރައްވާ.",
      "overCommitted": "{count} ބާކީއެއްގައި، ހުރި މިންވަރަށްވުރެ ގިނައިން ރިޒަރވްކޮށްފައެވެ.",
      "projectionNote": "ހުރި ޢަދަދަކީ ސްޓޮކް ލެޖަރުގެ ޕްރޮޖެކްޝަނެކެވެ، އޭގެ ފަހަތުގައިވާ ހަރަކާތްތަކާ އެއް ޓްރާންސެކްޝަނެއްގައި ލިޔެވެއެވެ.",
      "empty": "އަދި އެއްވެސް ތަނެއްގައި ސްޓޮކެއް ނެތެވެ.",
      "emptyFiltered": "މި ފިލްޓަރތަކަށް ހުރި އެއްޗެއް ނެތެވެ.",
      "loadFailed": "ސްޓޮކް ލެވެލްތައް ނުލިބުނު",
      "itemById": "ތަކެތި #{id}",
      "warehouseById": "ގުދަން #{id}"
    },
    "reservations": {
      "title": "ރިޒަރވްކޮށްފައިވާ ސްޓޮކް",
      "description": "ރިޒަރވޭޝަނަކީ ވަޢުދެކެވެ، ހަރަކާތެއް ނޫނެވެ: ސްޓޮކް ލެޖަރަށް އެއްޗެއް ނުލިޔެއެވެ.",
      "caption": "{sku} ގެ ހަރަކާތްތެރި ރިޒަރވޭޝަންތައް",
      "noneActive": "މި ސްޓޮކް ހިފަހައްޓާ އެއްޗެއް ނެތެވެ.",
      "truncated": "ދެހާސް ރިޒަރވޭޝަން އައިސްފައިވެއެވެ، އަދި އިތުރު ހުރެއެވެ. ބާކީ ބެލުމަށް ތަކެތިން ނުވަތަ ގުދަނުން ކުޑަކުރައްވާ.",
      "release": "ދޫކުރޭ",
      "released": "ރިޒަރވޭޝަން ދޫކުރެވިއްޖެ",
      "releaseFailed": "ރިޒަރވޭޝަން ދޫނުކުރެވުނު",
      "loadFailed": "ރިޒަރވޭޝަންތައް ނުލިބުނު",
      "lineNo": "ސަފު {no}",
      "historyToggle": "ދޫކުރެވުނު ނުވަތަ ބޭނުންކުރެވުނު {count} ހިފެހެއްޓުން ދައްކާ",
      "historyCaption": "ދެން ހަރަކާތްތެރި ނޫން ރިޒަރވޭޝަންތައް",
      "columns": {
        "document": "ލިޔުން",
        "kind": "ބާވަތް"
      },
      "anyLot": "ކޮންމެ ލޮޓެއް",
      "document": "ލިޔުން",
      "empty": "ގުޅޭ ރިޒަވޭޝަނެއް ނެތް.",
      "expiresAt": "މުއްދަތު ހަމަވަނީ",
      "expiringBefore": "މުއްދަތު ހަމަވަނީ މީގެ ކުރިން",
      "expiringBeforeHint": "ކޮންމެ ގަޑިއިރަކު ސްވީޕުން މިތަކެތި ދޫކުރެއެވެ.",
      "kind": "ބާވަތް",
      "kinds": {
        "hard": "ހަރު",
        "soft": "މަޑު"
      },
      "link": "ރިޒަވޭޝަން",
      "moreUrgent": "އިތުރަށް އަވަސް",
      "priority": "އިސްކަން",
      "releasedByOperator": "އޮޕަރޭޓަރު ދޫކުރި",
      "tableTitle": "ރިޒަވޭޝަންތައް",
      "updateFailed": "ރިޒަވޭޝަން އަޕްޑޭޓެއް ނުކުރެވުނު"
    },
    "reservationKinds": {
      "soft": "ސޮފްޓް",
      "hard": "ހާޑް"
    },
    "reservationStatus": {
      "active": "ހަރަކާތްތެރި",
      "released": "ދޫކުރެވިފައި",
      "consumed": "ބޭނުންކުރެވިފައި"
    },
    "ledger": {
      "title": "ސްޓޮކް ލެޖަރ",
      "description": "މިހާތަނަށް ހިނގި ކޮންމެ ހަރަކާތެއް، އެންމެ ފަހުގެ ފުރަތަމައަށް.",
      "appendOnly": "ސްޓޮކް ލެޖަރަކީ ހަމައެކަނި އިތުރުކުރެވޭ އެއްޗެކެވެ. ޑޭޓާބޭސް ޓްރިގަރއަކުން ކޮންމެ ސަފެއްގެ އަޕްޑޭޓް ނުވަތަ ޑިލީޓް ބަލައިނުގަނެއެވެ — މި ސޮފްޓްވެއަރގެ އަމިއްލަ ކޯޑަށްވެސް. އިޞްލާޙަކީ އައު، އިދިކޮޅު ސަފެކެވެ.",
      "runningBalanceNeedsBoth": "ހިނގަމުންދާ ބާކީ ބަހައްޓަނީ ތަކެއްޗާއި ގުދަނަކަށެވެ. ބެލުމަށް ކޮންމެއަކުން އެކަތި ޚިޔާރުކުރައްވާ؛ އެއްކޮށްފައިވާ ލިސްޓަކުން ގުޅުމެއް ނެތް ބާކީތަކެއް އެއްވެގެންދާނެއެވެ.",
      "tableTitle": "ހަރަކާތްތައް",
      "tableCaption": "ސްޓޮކް ލެޖަރ އެންޓްރީތައް",
      "pageTotal": "މި ޞަފުޙާ",
      "viewJournal": "ޖާނަލް ބައްލަވާ",
      "noJournal": "ޖާނަލެއް ނެތް — އެއް ކުންފުނީގެ ޓްރާންސްފަރއަކުން އެއް ހިސާބެއް ޑެބިޓް ކްރެޑިޓްކޮށް، ޕޯސްޓެއް ނުކުރެއެވެ.",
      "empty": "އަދި ހަރަކާތެއް ނެތެވެ.",
      "emptyFiltered": "މި ފިލްޓަރތަކާ ގުޅޭ ހަރަކާތެއް ނެތެވެ.",
      "loadFailed": "ސްޓޮކް ލެޖަރ ނުލިބުނު"
    },
    "adjustments": {
      "title": "ސްޓޮކް އެޖަސްޓްމަންޓްތައް",
      "description": "ރައިޓް-އޮފް، ރައިޓް-އޮން އަދި އިޞްލާޙުތައް، ކޮންމެއެއް ސަބަބުގެ ކޯޑެއްގެ ދަށުން.",
      "create": "އައު އެޖަސްޓްމަންޓް",
      "createDescription": "އިތުރުކުރުމަކަށް ޔުނިޓް އަގެއް ބޭނުންވެއެވެ؛ މަދުކުރުމުގެ އަގު ނަގަނީ ނަގާ ސްޓޮކުންނެވެ.",
      "reasonHint": "ސަބަބުން ކަނޑައަޅަނީ ވަގުތުން ޕޯސްޓްވާނީތޯ ނުވަތަ ފާސްކުރުމަށް މަޑުކުރާނީތޯއެވެ.",
      "dateHint": "ހަރަކާތް ޕޯސްޓްވާ ވިޔަފާރީގެ ތާރީޚު؛ ހުޅުވިފައިވާ މުއްދަތެއްގައި ވާންޖެހެއެވެ.",
      "addLine": "ސަފެއް އިތުރުކުރޭ",
      "removeLine": "ސަފު {line} ނަގާ",
      "duplicateLine": "ސަފު {line} ކޮޕީކުރޭ",
      "qtyAria": "ޢަދަދުގެ ބަދަލު، ސަފު {line}",
      "costAria": "ޔުނިޓް އަގު، ސަފު {line}",
      "lotAria": "ލޮޓް ނަންބަރު، ސަފު {line}",
      "increase": "އިތުރުވުން",
      "decrease": "މަދުވުން",
      "costFromLayers": "ސްޓޮކުން އަގު ނަގާ",
      "noTotalNote": "ޖުމްލަ އަދަދެއް ގަސްދުގައި ނުދައްކައެވެ. މަދުކުރުމެއްގެ އަގަކީ އޭގެ ބޭނުންކުރާ ފީފޯ ލޭޔަރުތަކުގެ ޖުމްލައެވެ، ނުވަތަ ތަކެތީގެ މިހާރުގެ އެވްރެޖެވެ — އެ ޢަދަދު ދެވޭނީ ސާވަރަށެވެ. ޕޯސްޓްވި އަދަދުތައް ފެންނާނީ މި އެޖަސްޓްމަންޓް ލިޔާ ލެޖަރ ސަފުތަކުންނެވެ.",
      "warehouseAllowsNegative": "މި ގުދަނުގައި ނެގެޓިވް ސްޓޮކް ހުއްދަކަމުން، ބާކީއަށްވުރެ ބޮޑު މަދުކުރުމެއް ބަލައިގަނެވޭނެއެވެ.",
      "willPost": "މި ސަބަބުގެ ކޯޑުން ވަގުތުން ޕޯސްޓްކުރެއެވެ: ހުށަހެޅުމުން ހަރަކާތާއި، ޖާނަލާއި، ލެޖަރ ސަފުތައް ލިޔެއެވެ.",
      "willAwaitApproval": "މި ސަބަބުގެ ކޯޑަށް ފާސްކުރުން ބޭނުންވެއެވެ: ފާސްކުރުމުގެ ހުއްދަ އޮތް މީހަކު ޕޯސްޓްކުރަންދެން ލެޖަރަށް އެއްޗެއް ނުލިޔެއެވެ.",
      "postAction": "ޕޯސްޓްކުރޭ",
      "submitted": "އެޖަސްޓްމަންޓް ފާސްކުރުމަށް ހުށަހެޅިއްޖެ",
      "posted": "އެޖަސްޓްމަންޓް ޕޯސްޓްކުރެވިއްޖެ",
      "createdDetail": "{no}",
      "createFailed": "އެޖަސްޓްމަންޓް ނުއުފެއްދުނު",
      "tableTitle": "އެޖަސްޓްމަންޓްތައް",
      "caption": "ސްޓޮކް އެޖަސްޓްމަންޓްތައް",
      "linesCaption": "އެޖަސްޓްމަންޓް ސަފުތައް",
      "pendingCount": "{count} އެޖަސްޓްމަންޓް ފާސްކުރުމަށް މަޑުކުރަނީއެވެ.",
      "pendingMeaning": "މީގެ އެއްވެސް ކަމެއް ލެޖަރަށް ނުދެއެވެ: ފޮތުގައި އަދިވެސް އެ ސްޓޮކް ހުއްޓެވެ.",
      "empty": "އަދި އެޖަސްޓްމަންޓެއް ނެތެވެ.",
      "emptyFiltered": "މި ފިލްޓަރތަކާ ގުޅޭ އެޖަސްޓްމަންޓެއް ނެތެވެ.",
      "loadFailed": "އެޖަސްޓްމަންޓްތައް ނުލިބުނު",
      "factsTitle": "އެޖަސްޓްމަންޓް",
      "linesTitle": "ސަފުތައް",
      "linesDescription": "ހުށަހެޅި ގޮތް. މަދުކުރުމެއްގައި ޔުނިޓް އަގެއް ނުހުންނަނީ ސާވަރުން އެ ނަގާތީއެވެ.",
      "noLines": "މި އެޖަސްޓްމަންޓްގައި ސަފެއް ނެތެވެ.",
      "nothingPostedYet": "އަދި އެއްޗެއް ޕޯސްޓްވެފައެއް ނުވެއެވެ. މި އެޖަސްޓްމަންޓުން ހަރަކާތެއް، ޖާނަލެއް އަދި ލެޖަރ ސަފެއް ނުލިޔެއެވެ.",
      "rejectedNote": "މި އެޖަސްޓްމަންޓް ބޭރުކުރެވިއްޖެއެވެ. އެއްވެސް އެއްޗެއް ޕޯސްޓްވެފައި ނުވާތީ، އަނބުރާލާނެ އެއްޗެއް ނެތެވެ.",
      "movementsTitle": "ޕޯސްޓްވި ގޮތް",
      "movementsDescription": "މި އެޖަސްޓްމަންޓް ލިޔުނު ސްޓޮކް ލެޖަރ ސަފުތައް، ސާވަރުން ނެގި އަގުތަކުގައި.",
      "movementsCaption": "މި އެޖަސްޓްމަންޓުން އުފެދުނު ލެޖަރ ސަފުތައް",
      "movementTotal": "ޖުމްލަ",
      "noMovements": "މި އެޖަސްޓްމަންޓަށް ލެޖަރ ސަފެއް ނުފެނުނެވެ.",
      "approveAction": "ފާސްކޮށް ޕޯސްޓްކުރޭ",
      "approveMeaning": "ފާސްކުރުމުން ހަރަކާތާއި، ޖާނަލާއި، ލެޖަރ ސަފުތައް ޕޯސްޓްކުރެއެވެ.",
      "approved": "އެޖަސްޓްމަންޓް ފާސްކޮށް ޕޯސްޓްކުރެވިއްޖެ",
      "approveFailed": "އެޖަސްޓްމަންޓް ފާސްނުކުރެވުނު",
      "approvedAt": "ފާސްކުރި",
      "rejectTitle": "މި އެޖަސްޓްމަންޓް ބޭރުކުރޭ",
      "rejectDescription": "އެއްވެސް އެއްޗެއް ޕޯސްޓްވެފައި ނުވާތީ، އަނބުރާލުމެއް ނެތެވެ. ރެކޯޑަށްޓަކައި ސަބަބު ލިޔުއްވާ.",
      "rejected": "އެޖަސްޓްމަންޓް ބޭރުކުރެވިއްޖެ",
      "rejectFailed": "އެޖަސްޓްމަންޓް ބޭރުނުކުރެވުނު",
      "sodNote": "އެޖަސްޓްމަންޓް އުފެއްދުމާއި ފާސްކުރުމަކީ ގަސްދުގައި ވަކިކުރެވިފައިވާ ދެ ހުއްދައެވެ: ރައިޓް-އޮފް ހުށަހަޅާ މީހާ، އެ ލެޖަރަށް ލާ މީހާއަށް ވެގެން ނުވާނެއެވެ."
    },
    "adjustmentStatus": {
      "pending_approval": "ފާސްކުރުމަށް",
      "posted": "ޕޯސްޓްކުރި",
      "rejected": "ބޭރުކުރެވިފައި"
    },
    "reasonCodes": {
      "title": "އެޖަސްޓްމަންޓް ސަބަބުގެ ކޯޑުތައް",
      "description": "ސްޓޮކް އެޖަސްޓްކުރި ސަބަބާއި، ދެވަނަ ސޮޔެއް ބޭނުންވާ ސަބަބުތައް.",
      "create": "އައު ސަބަބުގެ ކޯޑު",
      "edit": "ސަބަބުގެ ކޯޑު އެޑިޓްކުރޭ",
      "dialogDescription": "ސަބަބުގެ ކޯޑުތަކަކީ ތިޔަބޭފުޅުންގެ އަމިއްލަ ޑޭޓާއެވެ؛ މިތާ ފައްކާ ލިސްޓެއް ނެތެވެ.",
      "codeHint": "ކުރު ކޯޑެއް، މިސާލަކަށް DAMAGE.",
      "requiresApproval": "ޕޯސްޓްކުރުމުގެ ކުރިން ފާސްކުރަންޖެހޭ",
      "requiresApprovalHint": "މި ސަބަބުގެ ދަށުން ހުށަހަޅާ އެޖަސްޓްމަންޓްތައް، ފާސްކުރުމުގެ ހުއްދަ އޮތް މީހަކު ޕޯސްޓްކުރަންދެން ލެޖަރަށް އެއްޗެއް ނުލިޔެއެވެ.",
      "noApprovalConsequence": "މި ސަބަބުގެ ދަށުން ހުށަހަޅާ އެޖަސްޓްމަންޓްތައް، ދެވަނަ ސޮޔެއް ނެތި، ހުށަހަޅާ ވަގުތު ޖެނެރަލް ލެޖަރަށް ޕޯސްޓްވާނެއެވެ.",
      "approvalColumn": "ފާސްކުރުން",
      "approvalRequired": "ފާސްކުރަންޖެހޭ",
      "postsImmediately": "ވަގުތުން ޕޯސްޓްވޭ",
      "unapprovedCount": "ހަރަކާތްތެރި {count} ސަބަބުގެ ކޯޑަކުން، ދެވަނަ ސޮޔެއް ނެތި ވަގުތުން ޕޯސްޓްކުރެއެވެ.",
      "tableTitle": "ސަބަބުގެ ކޯޑުތައް",
      "caption": "އެޖަސްޓްމަންޓް ސަބަބުގެ ކޯޑުތައް",
      "empty": "އަދި ސަބަބުގެ ކޯޑެއް ނެތެވެ. އެޖަސްޓްމަންޓަކަށް އެއް ބޭނުންވެއެވެ.",
      "footnote": "ބޭނުންކުރަނީ",
      "loadFailed": "ސަބަބުގެ ކޯޑުތައް ނުލިބުނު",
      "saved": "ސަބަބުގެ ކޯޑު ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{code} އަޕްޑޭޓްވެއްޖެ.",
      "saveFailed": "ސަބަބުގެ ކޯޑު ރައްކާނުކުރެވުނު"
    },
    "cycleCounts": {
      "title": "ސައިކަލް ކައުންޓްތައް",
      "description": "ހަރު ގުނާ، ފޮތާ އަޅާކިޔާ، ތަފާތު ޕޯސްޓްކުރޭ.",
      "create": "އައު ކައުންޓް",
      "createDescription": "ޚިޔާރުކުރާ ކޮންމެ ތަކެއްޗެއްގެ ބާކީ މިހާރު ސްނެޕްޝޮޓްކުރެއެވެ، އަދި ތަފާތު ބަލަނީ އެއާއެވެ.",
      "dateHint": "ތަފާތު ޕޯސްޓްވާ ވިޔަފާރީގެ ތާރީޚު.",
      "blind": "ބްލައިންޑް ކައުންޓް",
      "blindHint": "ސެޝަން ޕޯސްޓްވަންދެން، ބެލެވޭ ޢަދަދު ގުނާ މީހާއަށް ނުދައްކާ.",
      "blindBadge": "ބްލައިންޑް",
      "openBookBadge": "ހުޅުވިފައިވާ ފޮތް",
      "notBlindConsequence": "ބްލައިންޑް މޯޑް ނެތި، ސިސްޓަމުން ބެލެވޭ ޢަދަދު ގުނާ މީހާއަށް ފެންނާނެއެވެ، އަދި އެ ޢަދަދަށް ބަރޯސާވެ ގުނާ ގުނުމެއްގެ ހެއްކެއްގެ ބާރު ވަރަށް ދަށެވެ.",
      "itemsLabel": "ގުނާނެ ތަކެތި",
      "itemsHint": "މި ގުދަނުގައި ބާކީ ހުރި ހުރިހާ ސްޓޮކްކުރާ ތަކެތި ގުނުމަށް ހުސްކޮށް ބާއްވާ.",
      "addItem": "ތަކެއްޗެއް އިތުރުކުރޭ",
      "removeItem": "{item} ނަގާ",
      "fullCountNote": "ތަކެއްޗެއް ޚިޔާރުކޮށްފައި ނުވާތީ، މިއީ ގުދަނުގައި ބާކީ ހުރި ހުރިހާ ސްޓޮކްކުރާ ތަކެތީގެ ފުރިހަމަ ކައުންޓަކަށް ވާނެއެވެ.",
      "snapshotNote": "ސެޝަން ހުޅުވޭ ވަގުތު ކޮންމެ ތަކެއްޗެއްގެ ބެލެވޭ ޢަދަދު ރެކޯޑްކުރެއެވެ، އެހެންކަމުން ތަފާތު ބަލަނީ އޭރުގެ ބާކީއާއެވެ.",
      "open": "ކައުންޓް ހުޅުވާ",
      "created": "ކައުންޓް ސެޝަން ހުޅުވިއްޖެ",
      "createdDetail": "{no}",
      "createFailed": "ކައުންޓް ސެޝަން ނުހުޅުވުނު",
      "tableTitle": "ސެޝަންތައް",
      "caption": "ސައިކަލް ކައުންޓް ސެޝަންތައް",
      "mode": "މޯޑް",
      "progress": "ގުނުނު",
      "progressTitle": "ކުރިއެރުން",
      "progressValue": "{total} ން {counted} ގުނިއްޖެ",
      "empty": "އަދި ސައިކަލް ކައުންޓެއް ނެތެވެ.",
      "emptyFiltered": "މި ފިލްޓަރތަކާ ގުޅޭ ސެޝަނެއް ނެތެވެ.",
      "loadFailed": "ސައިކަލް ކައުންޓްތައް ނުލިބުނު",
      "blindNotice": "މިއީ ބްލައިންޑް ކައުންޓެކެވެ: ސެޝަން ޕޯސްޓްވަންދެން ބެލެވޭ ޢަދަދު ނުދައްކައެވެ.",
      "blindNoticeVariance": "ތަފާތުވެސް ނުދައްކައެވެ — ގުނުނު ޢަދަދުން ތަފާތު އުނިކުރުމުން ބެލެވޭ ޢަދަދު ލިބޭތީއެވެ.",
      "linesTitle": "ކައުންޓް ޝީޓް",
      "linesDescription": "ބެލެވޭ، ގުނުނު އަދި އެ ދެމެދުގެ ތަފާތު.",
      "linesBlindDescription": "ގުނުނު ޢަދަދު ލިޔުއްވާ. މި ޞަފުޙާއިން ސިސްޓަމުން ބެލެވޭ ޢަދަދު ނުފެންނާނެއެވެ.",
      "linesCaption": "ސައިކަލް ކައުންޓް ސަފުތައް",
      "noLines": "މި ސެޝަނުގައި ސަފެއް ނެތެވެ.",
      "countAria": "{item} ގެ ގުނުނު ޢަދަދު، ސަފު {line}",
      "varianceTotal": "ސާފު ތަފާތު",
      "found": "އިތުރުވި",
      "short": "މަދުވި",
      "linesDiffering": "ތަފާތުވި ސަފުތައް",
      "valueNote": "ތަފާތެއްގެ އަގު ކަނޑައަޅަނީ އަގު ބަލާ ގޮތުންނެވެ — އެންމެ ދުވަސްވީ ފީފޯ ލޭޔަރުތަކުން، ނުވަތަ ތަކެތީގެ މިހާރުގެ އެވްރެޖުން — އަދި ފެންނާނީ ޕޯސްޓްކުރުމުން އުފެދޭ ލެޖަރ ސަފުތަކުންނެވެ.",
      "incompleteNote": "{count} ސަފެއް އަދި ނުގުނައެވެ. ކޮންމެ ސަފެއް ގުނަންދެން ސެޝަން ޕޯސްޓެއް ނުކުރެވެއެވެ.",
      "saveCounts": "{count} ކައުންޓް ރައްކާކުރޭ",
      "countsSaved": "{count} ކައުންޓް ރައްކާކުރެވިއްޖެ",
      "countsFailed": "ކައުންޓްތައް ރައްކާނުކުރެވުނު",
      "readyToPost": "ކޮންމެ ސަފެއް ގުނިއްޖެއެވެ؛ ޕޯސްޓްކުރުމުން ތަފާތުތައް ލެޖަރަށް ލިޔެވޭނެއެވެ.",
      "notReady": "ޕޯސްޓްކުރުމުގެ ކުރިން ކޮންމެ ސަފެއް ގުނާ.",
      "postAction": "ތަފާތުތައް ޕޯސްޓްކުރޭ",
      "posted": "ސައިކަލް ކައުންޓް ޕޯސްޓްކުރެވިއްޖެ",
      "postFailed": "ސައިކަލް ކައުންޓް ޕޯސްޓްނުކުރެވުނު",
      "postedTitle": "ޕޯސްޓްކުރެވިފައި",
      "postedNote": "ތަފާތުތައް ލެޖަރުގައެވެ. މުޅި ސެޝަނަށް އެއް ޖާނަލް ޕޯސްޓްކުރެވުނެވެ؛ ތަފާތު ނެތް ސަފުތައް ދޫކޮށްލެވުނެވެ.",
      "noJournal": "ޖާނަލެއް ޕޯސްޓެއް ނުވިއެވެ — ގުނުނު ކޮންމެ ސަފެއް ސިސްޓަމްގެ ޢަދަދާ ދިމާވިއެވެ."
    },
    "countStatus": {
      "open": "ހުޅުވިފައި",
      "posted": "ޕޯސްޓްކުރި",
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "counting": "ގުނަނީ",
      "recount": "އަލުން ގުނަންޖެހޭ",
      "review": "މުރާޖައާގައި"
    },
    "transfers": {
      "title": "ސްޓޮކް ޓްރާންސްފަރތައް",
      "description": "ގުދަންތަކުގެ މެދުގައި ސްޓޮކް ބަދަލުކުރޭ. ކުންފުނިތަކުގެ މެދުގައި ދެ ފަޔަށްވެސް އެއްފަހަރާ ޕޯސްޓްކުރެއެވެ.",
      "create": "އައު ޓްރާންސްފަރ",
      "createDescription": "ސްޓޮކް ބަދަލުވަނީ އަގުގައެވެ؛ ލިޔަންޖެހޭ ޔުނިޓް އަގެއް ނެތެވެ.",
      "addLine": "ސަފެއް އިތުރުކުރޭ",
      "removeLine": "ސަފު {line} ނަގާ",
      "qtyAria": "ޢަދަދު، ސަފު {line}",
      "lotAria": "ލޮޓް ނަންބަރު، ސަފު {line}",
      "submitAction": "ޓްރާންސްފަރކުރޭ",
      "sameWarehouse": "ފޮނުވާ ތަނާއި ލިބޭ ތަނަކީ އެއް ގުދަނެކެވެ.",
      "sameCompanyNote": "ދެ ގުދަން އެއް ކުންފުންޏަކަށް ވުމުން، މި ޓްރާންސްފަރއަކުން ޖާނަލެއް ޕޯސްޓެއް ނުކުރެއެވެ: އެއް މުދަލުގެ ހިސާބު ޑެބިޓް ކްރެޑިޓްވެ ސުމަކަށްވެއެވެ.",
      "crossCompanyNote": "މި ގުދަންތައް ވަނީ އެކި ކުންފުނިތަކަށެވެ، އެހެންކަމުން ދެ ފައި ޕޯސްޓްވެއެވެ: ފޮނުވުން (ޑރ އިން-ޓްރާންސިޓް / ކރ ފޮނުވާ މުދާ) އަދި ލިބުން (ޑރ ލިބޭ މުދާ / ކރ އިން-ޓްރާންސިޓް).",
      "crossCompanyPosting": "ދެ އިން-ޓްރާންސިޓް ހިސާބު ބޭނުންވެއެވެ، ކުންފުންޏަކަށް އެކަތި — ދެ ކުންފުނީގެ ފޮތްތައް ވަކިކަމުން، އެކެއްގެ ހިސާބަކީ އަނެކެއްގެ ހިސާބެއް ނޫނެވެ.",
      "inTransitHint": "އެ ކުންފުނީގެ އެސެޓް ހިސާބެއް.",
      "costNote": "ޓްރާންސްފަރއަކުން ސްޓޮކް ބަދަލުވަނީ އަގުގައެވެ: ފޮނުވާ ފަރާތުން އެންމެ ދުވަސްވީ ފީފޯ ލޭޔަރުތަކުން، ނުވަތަ ތަކެތީގެ މިހާރުގެ މޫވިންގ އެވްރެޖުން. ލިޔަންޖެހޭ އަގެއް ނެތެވެ.",
      "noInTransitLifecycle": "ލިބުނުކަން ޔަޤީންކުރާ ވަކި ފިޔަވަޅެއް ނެތެވެ: މިކަން ކާމިޔާބުވާ ވަގުތު ސްޓޮކް ބަދަލުވެއެވެ.",
      "created": "ޓްރާންސްފަރ ޕޯސްޓްކުރެވިއްޖެ",
      "createdDetail": "{no}",
      "createFailed": "ޓްރާންސްފަރ ޕޯސްޓްނުކުރެވުނު",
      "tableTitle": "ޓްރާންސްފަރތައް",
      "caption": "ސްޓޮކް ޓްރާންސްފަރތައް",
      "postingColumn": "ޕޯސްޓްކުރުން",
      "sameCompanyBadge": "އެއް ކުންފުނި",
      "crossCompanyBadge": "ކުންފުނިތަކުގެ މެދުގައި",
      "empty": "އަދި ޓްރާންސްފަރއެއް ނެތެވެ.",
      "emptyFiltered": "މި ފިލްޓަރތަކާ ގުޅޭ ޓްރާންސްފަރއެއް ނެތެވެ.",
      "loadFailed": "ޓްރާންސްފަރތައް ނުލިބުނު",
      "factsTitle": "ޓްރާންސްފަރ",
      "shipJournal": "ފޮނުވުމުގެ ޖާނަލް",
      "receiveJournal": "ލިބުމުގެ ޖާނަލް",
      "noJournalNote": "މިއީ އެއް ކުންފުނީގެ ޓްރާންސްފަރއެއް ކަމުން ޖާނަލެއް ޕޯސްޓެއް ނުވިއެވެ: ދެ ގުދަން އެއް މުދަލުގެ ހިސާބެއް ބޭނުންކުރާތީ އެންޓްރީ ސުމަކަށްވެއެވެ.",
      "linesTitle": "ސަފުތައް",
      "linesDescription": "ޔުނިޓް އަގަކީ ސްޓޮކް ބަދަލުވިއިރު ސާވަރުން ނެގި އަގެވެ، މީހަކު ލިޔުނު އަގެއް ނޫނެވެ.",
      "linesCaption": "ޓްރާންސްފަރ ސަފުތައް",
      "noLines": "މި ޓްރާންސްފަރގައި ސަފެއް ނެތެވެ.",
      "movementsTitle": "ލެޖަރ ސަފުތައް",
      "movementsDescription": "ސަފަކަށް ދެ ސަފު: އެކަތި ފޮނުވާ ތަނުން، އަނެކަތި ލިބޭ ތަނަށް.",
      "movementsCaption": "މި ޓްރާންސްފަރއިން އުފެދުނު ލެޖަރ ސަފުތައް",
      "movementTotal": "ޖުމްލަ",
      "movementBalanceNote": "ފުރިހަމަ ޓްރާންސްފަރއެއްގައި ޢަދަދާއި ވެލިއުގެ ޖުމްލަ ސުމަކަށްވެއެވެ: އެއްޗެއް އުފެދުނު ނުވަތަ ނެތިގެންދިޔައީއެއް ނޫނެވެ، ހަމައެކަނި ބަދަލުވީއެވެ.",
      "noMovements": "މި ޓްރާންސްފަރއަށް ލެޖަރ ސަފެއް ނުފެނުނެވެ.",
      "autoReceive": "އެއްފަހަރާ ބަލައިގަންނަ",
      "autoReceiveHint": "ދެ ފަޔާއި ދެ ޖާނަލްވެސް ލިޔެވޭނެއެވެ. މިއިން ސަލާމަތްވަނީ ދެވަނަ ފަހަރު ފޮނުވުމުންނެވެ.",
      "autoReceived": "ޓްރާންސްފަރ ފޮނުވައި ބަލައިގަނެވިއްޖެ",
      "backToBoard": "ޓްރާންސްފަރތަކަށް",
      "boardDescription": "މަގުމަތީގައިވާ ސްޓޮކަކީ އެއް ގުދަނުން ނުކުމެ އަނެއް ގުދަނަށް ނުދާ ސްޓޮކެވެ. އެއީ ދެ ގުދަނުގައިވެސް ނުވާ ސްޓޮކެއް ކަމުން ވަކި ލޭނެއް ދީފައި ވެއެވެ.",
      "cancelDefaultReason": "އޮޕަރޭޓަރު ކެންސަލްކުރި",
      "cancelFailed": "ޓްރާންސްފަރ ކެންސަލެއް ނުކުރެވުނު",
      "cancelled": "ޓްރާންސްފަރ ކެންސަލްކުރެވިއްޖެ",
      "carrier": "އުފުލާ ފަރާތް",
      "carrierReference": "އުފުލާ ފަރާތުގެ ރެފަރެންސް",
      "columns": {
        "carrier": "އުފުލާ ފަރާތް",
        "count": "ޓްރާންސްފަރ",
        "despatchQty": "ފޮނުވާ ޢަދަދު",
        "despatched": "ފޮނުވި",
        "despatchedQty": "ފޮނުވި ޢަދަދު",
        "expected": "ލިބެންވީ",
        "inTransitValue": "މަގުމަތީގައިވާ އަގު",
        "oldest": "އެންމެ ދުވަސްވީ (ދުވަސް)",
        "overdue": "ލަސްވެފައި",
        "receiveQty": "ލިބުނު ޢަދަދު",
        "received": "ލިބުނު",
        "receivedQty": "ލިބުނު ޢަދަދު",
        "shortageQty": "މަދުވި",
        "shortageReason": "މަދުވި ސަބަބު",
        "stillInTransit": "އަދިވެސް މަގުމަތީގައި",
        "total": "ޖުމުލަ",
        "value": "އަގު"
      },
      "despatch": "ފޮނުވުން",
      "despatchAction": "ފޮނުވާ",
      "despatchConsequence": "މިއަށްފަހު ސްޓޮކް ހުންނާނީ ދެ ގުދަނުގައިވެސް ނޫން؛ އޭގެ އަގު ހުންނާނީ މަގުމަތީގައިވާ މުދަލުގެ އެކައުންޓުގައެވެ.",
      "despatchDescription": "މިހާރު ލެޖަރުގެ ދެ ފަޔާއި ޖާނަލެއް ލިޔެވޭނެއެވެ: ފޮނުވާ ގުދަނުން ނުކުމެ މަގުމަތީގެ ގުދަނަށެވެ.",
      "despatchFailed": "ޓްރާންސްފަރ ނުފޮނުވުނު",
      "despatchJournal": "ފޮނުވުމުގެ ޖާނަލް",
      "despatchLinesCaption": "ފޮނުވާ ސަފުތައް",
      "despatchQtyAria": "ފޮނުވާ ޢަދަދު، {item}",
      "despatched": "ޓްރާންސްފަރ ފޮނުވިއްޖެ",
      "despatchedOn": "ފޮނުވި ތާރީޚު",
      "documentDescription": "ދެ ޕޯސްޓިން، ލެޖަރުގެ ހަތަރު ފައި.",
      "draftDescription": "މިއިން އުފެދެނީ ދެލިކޮޕީއެކެވެ. ފޮނުވަންދެން އެއްޗެއް ނުހިނގާނެއެވެ.",
      "draftFailed": "ޓްރާންސްފަރ ނުއުފެއްދުނު",
      "draftMovesNothing": "މި ރައްކާކުރުމުން ސްޓޮކެއް ނުހިނގާނެއެވެ. ސްޓޮކް ހިނގަނީ ފޮނުވުމުންނެވެ؛ އެއީ ވަކި ހުއްދައެކެވެ.",
      "drafted": "ދެލިކޮޕީ ޓްރާންސްފަރ އުފެދިއްޖެ",
      "driver": "ދުއްވާ މީހާ",
      "empty_all": "ޓްރާންސްފަރެއް އަދި ނެތް.",
      "empty_cancelled": "ކެންސަލްކުރި ޓްރާންސްފަރެއް ނެތް.",
      "empty_draft": "ދެލިކޮޕީ ޓްރާންސްފަރެއް ނެތް.",
      "empty_in_transit": "މަގުމަތީގައި އެއްޗެއް ނެތް.",
      "empty_received": "ލިބިފައިވާ ޓްރާންސްފަރެއް ނެތް.",
      "expectedArrival": "ލިބެންވީ ތާރީޚު",
      "expectedArrivalHint": "ލަސްވުން ބަލާ ސްވީޕުން ބޭނުންކުރެއެވެ.",
      "inTransitAccountMissing": "މި ކުންފުންޏަށް މަގުމަތީގައިވާ މުދަލުގެ އެކައުންޓެއް ކަނޑައަޅާފައެއް ނުވެއެވެ. އިންވެންޓަރީ ސެޓިންގްސް ސްކްރީނުން ކަނޑައަޅާ.",
      "inTransitAccountNote": "މި އަގު ހުންނަނީ މަގުމަތީގައިވާ މުދަލުގެ އެކައުންޓުގައެވެ؛ އިންވެންޓަރީގައެއް ނޫނެވެ.",
      "inTransitCaption": "ކުންފުނިން މަގުމަތީގައިވާ ސްޓޮކްގެ ޚުލާސާ",
      "inTransitDescription": "ކުންފުނީގެ މިލްކުގައި، ނަމަވެސް ދެ ގުދަނުގައިވެސް ނުވާ ސްޓޮކްގެ އަގާއި ދުވަސް.",
      "inTransitEmpty": "މަގުމަތީގައި އެއްޗެއް ނެތް.",
      "inTransitExplanation": "މި ސްޓޮކް ފޮނުވި ގުދަނުން ނުކުމެ ލިބެންވީ ގުދަނަށް ނުދެއެވެ. ދެ ތަނުންވެސް ނުގުނާށެވެ.",
      "inTransitTitle": "މަގުމަތީގައި",
      "laneNote": "މި ލޭނުގައި ވަނީ ދެ ގުދަނުންވެސް ނުގުނޭ ސްޓޮކެވެ.",
      "legsTitle": "ޕޯސްޓިންތައް",
      "loadOneFailed": "ޓްރާންސްފަރ ލޯޑެއް ނުވި",
      "lotAuto": "އުކުޅުން ނަގާ",
      "lotRefused": "އެ ލޮޓު ދޫނުކުރެވޭނެއެވެ. ކަރަންޓީނު، ހިފެހެއްޓި، ރީކޯލްކުރި އަދި މުއްދަތު ހަމަވި ލޮޓުތައް ބަލައެއް ނުގަނެއެވެ.",
      "notDespatched": "މި ޓްރާންސްފަރ ފޮނުވާފައެއް ނުވެއެވެ.",
      "notFound": "އެ ޓްރާންސްފަރެއް ނެތް.",
      "notPostedYet": "އަދި ޕޯސްޓްކޮށްފައެއް ނުވޭ",
      "overReceipt": "ފޮނުވި މިންވަރަށްވުރެ ގިނައިން ބަލައިގަނެވިއްޖެ.",
      "overdueBanner": "{count} ޓްރާންސްފަރ ލަސްވެފައި. ނުފެންނަ ސްޓޮކަކީ ނުހޯދޭ ސްޓޮކެކެވެ.",
      "overdueNote": "ލިބެންވީ ތާރީޚު ފަހަނައަޅާފައިވާތީ ލަސްވެފައިވާ ކަމަށް ފާހަގަކުރެވިފައި.",
      "receive": "ބަލައިގަތުން",
      "receiveAction": "ބަލައިގަންނަ",
      "receiveDescription": "ލިބުނު އަދި މަދުވި އަދަދަކީ ދެ އެއްޗެކެވެ. ދެ ތަނުގައިވެސް ނުވާ މިންވަރު އަދިވެސް ވަނީ މަގުމަތީގައެވެ.",
      "receiveFailed": "ޓްރާންސްފަރ ބަލައެއް ނުގަނެވުނު",
      "receiveLinesCaption": "ބަލައިގަންނަ ސަފުތައް",
      "receiveQtyAria": "ލިބުނު ޢަދަދު، {item}",
      "received": "ޓްރާންސްފަރ ބަލައިގަނެވިއްޖެ",
      "receivedOn": "ލިބުނު ތާރީޚު",
      "saveDraft": "ދެލިކޮޕީ ރައްކާކުރޭ",
      "shortageMeaning": "މަދުވުމަކީ ނުކުމެ ދުވަހަކުވެސް ނުލިބޭނެ މިންވަރެވެ. އެއަށް ޖާނަލް ޖެހެއެވެ. ބައެއް ލިބުމަކީ އެހެން ކަމެކެވެ؛ ބާކީ ހުންނާނީ މަގުމަތީގައެވެ.",
      "shortageNeedsReason": "މަދުވުމަކަށް ސަބަބުގެ ކޯޑެއް ބޭނުންވެއެވެ.",
      "shortageQtyAria": "މަދުވި ޢަދަދު، {item}",
      "shortageReasonPlaceholder": "ސަބަބެއް ނަގާ",
      "showOverdue": "ދައްކާ",
      "vehicle": "އުޅަނދު"
    },
    "revaluations": {
      "title": "ސްޓޮކް ރީވެލިއުކުރޭ",
      "description": "ހުރި ސްޓޮކްގެ ޔުނިޓް އަގު އަލުން ކަނޑައަޅާ. ޢަދަދު ބަދަލެއް ނުވެއެވެ؛ ވެލިއު ބަދަލުވެއެވެ.",
      "listTitle": "ރީވެލުއޭޝަންތައް",
      "listDescription": "ސްޓޮކް ލެޖަރުން ކިޔެއެވެ، ކޮންމެ ރީވެލުއޭޝަނަކީ ސަފެކެވެ.",
      "action": "ރީވެލިއުކުރޭ",
      "costHint": "މިހާރުން ފެށިގެން ހުރި ކޮންމެ ޔުނިޓަކުން އުފުލާނެ އަގު.",
      "reasonHint": "ލެޖަރ ސަފުގައްޔާއި އޮޑިޓް ރެކޯޑްގައި ރެކޯޑްވެއެވެ.",
      "postsNote": "ކުރީގެ އަދި އައު ވެލިއުގެ ތަފާތު، ތަކެތީގެ އެޖަސްޓްމަންޓް ފައިދާ/ގެއްލުމުގެ ހިސާބަށް، މަތީގައިވާ ތާރީޚުގައި ޕޯސްޓްވެއެވެ.",
      "noPreviewNote": "ނަތީޖާގެ ވެލިއު މިތާ ކުރިން ނުދައްކައެވެ: އެ ބަލަނީ ސާވަރުންނެވެ، އަދި ބްރައުޒަރުން ސެންޓަކުން ތަފާތުވާ ޢަދަދެއް ދެއްކުމުން، ޕޯސްޓިންގ ގޯހަކާ ވަކިކުރެވޭނެ ގޮތެއް ނޯންނާނެއެވެ.",
      "noBalance": "މި ގުދަނުގައި މި ތަކެތި ނެތުމުން، ރީވެލިއުކުރާނެ އެއްޗެއް ނެތެވެ.",
      "done": "ސްޓޮކް ރީވެލިއުކުރެވިއްޖެ",
      "doneDetail": "ތަފާތު ޕޯސްޓްކުރެވިއްޖެ.",
      "failed": "ސްޓޮކް ރީވެލިއު ނުކުރެވުނު",
      "tableTitle": "ރީވެލުއޭޝަންތައް",
      "caption": "ސްޓޮކް ލެޖަރުގެ ރީވެލުއޭޝަން އެންޓްރީތައް",
      "pageTotal": "މި ޞަފުޙާ",
      "filterNote": "މި ލިސްޓަކީ ސްޓޮކް ލެޖަރުގެ ޞަފުޙާއެއްގެ ރީވެލުއޭޝަން ސަފުތަކެވެ، އެހެންކަމުން ޞަފުޙާއެއްގައި ޞަފުޙާގެ ސައިޒަށްވުރެ މަދު ސަފު ހުއްޓަސް، އިތުރު ސަފުތައް ތިރީގައި ހުރެދާނެއެވެ.",
      "empty": "މި މުއްދަތުގައި ރީވެލުއޭޝަނެއް ނެތެވެ.",
      "loadFailed": "ރީވެލުއޭޝަންތައް ނުލިބުނު"
    },
    "reorder": {
      "title": "ރީއޯޑަރ ހުށަހެޅުންތައް",
      "description": "ރޭގަނޑުގެ ސްކޭނުން ހުށަހެޅި ގޮތާއި، އެ ހުށަހެޅި ޢަދަދުތައް.",
      "rule": "ސްކޭން ހިނގަނީ ތިޔަބޭފުޅުންގެ ގަޑިން 04:00 ގައެވެ. ރީއޯޑަރ ޕޮއިންޓެއް ހުރި ކޮންމެ ތަކެއްޗަކަށް، ލިބެންހުރި = ހުރި ޢަދަދު − ރިޒަރވް ބަލައި، ލިބެންހުރި މިންވަރު ރީއޯޑަރ ޕޮއިންޓަށް ނުވަތަ އެއަށްވުރެ ދަށްވުމުން ހުށަހެޅުމެއް އުފައްދާ، ބާކީ އެންމެ މައްޗަށް (ނުވަތަ އެންމެ މަތި ނެތްނަމަ ރީއޯޑަރ ޕޮއިންޓަށް) ގެންދަން ހުށަހަޅައެވެ.",
      "noInboundNote": "ސްކޭނުން ޕާޗޭސް އޯޑަރުތަކަށް ނުބަލައެވެ، އެހެންކަމުން ހުޅުވިފައިވާ އޯޑަރަކުން ފުއްދާ އެއްޗެއް އަލުން އޯޑަރުކުރަން ހުށަހަޅައިފާނެއެވެ. އޯޑަރުކުރުމުގެ ކުރިން ބައްލަވާ.",
      "target": "ގެންދާ މިންވަރު",
      "suggested": "ހުށަހެޅި",
      "generatedAt": "ސްކޭންކުރި",
      "statusOpen": "ހުޅުވިފައި",
      "statusDismissed": "ދޫކޮށްލެވިފައި",
      "status_open": "ހުޅުވިފައި",
      "status_dismissed": "ދޫކޮށްލެވިފައި",
      "dismissed": "ހުށަހެޅުން ދޫކޮށްލެވިއްޖެ",
      "dismissFailed": "ހުށަހެޅުން ދޫނުކޮށްލެވުނު",
      "tableTitle": "ހުށަހެޅުންތައް",
      "caption": "ރީއޯޑަރ ހުށަހެޅުންތަކާއި އޭގެ ފަހަތުގައިވާ ޢަދަދުތައް",
      "emptyOpen": "ރީއޯޑަރކުރަންޖެހޭ އެއްޗެއް ނެތެވެ.",
      "emptyDismissed": "ދޫކޮށްލެވުނު ހުށަހެޅުމެއް ނެތެވެ.",
      "loadFailed": "ރީއޯޑަރ ހުށަހެޅުންތައް ނުލިބުނު"
    },
    "valuation": {
      "title": "މުދަލުގެ ވެލުއޭޝަން",
      "description": "ސްޓޮކް ސަބް-ލެޖަރުގައި ހުރި މިންވަރު، ޖެނެރަލް ލެޖަރުން ބުނާ މިންވަރާ އަޅާކިޔާ.",
      "needsCompany": "ވެލުއޭޝަން ހިންގުމަށް ކުންފުންޏެއް ޚިޔާރުކުރައްވާ.",
      "tableTitle": "މުދަލުގެ ކޮންޓްރޯލް ހިސާބުތައް",
      "tableDescription": "މުދަލުގެ ހިސާބަކަށް އެއް ސަފު: އެއަށް ޕޯސްޓްވާ ހުރި ސްޓޮކްގެ ވެލިއުގެ ޖުމްލަ، އަދި އެ ހިސާބުގެ އަމިއްލަ ޕޯސްޓްކުރެވިފައިވާ ބާކީ.",
      "tableCaption": "ޖެނެރަލް ލެޖަރާ އަޅާކިޔާފައިވާ މުދަލުގެ ވެލުއޭޝަން",
      "total": "ޖުމްލަ",
      "reconciled": "ދިމާވޭ",
      "notReconciled": "ދިމައެއް ނުވޭ",
      "reconcilesBody": "ސްޓޮކް ސަބް-ލެޖަރ، ކޮންމެ މުދަލުގެ ކޮންޓްރޯލް ހިސާބަކާ ސެންޓަކާ ހަމައަށް ދިމާވެއެވެ.",
      "alarmTitle": "މުދާ ޖެނެރަލް ލެޖަރާ ދިމައެއް ނުވެއެވެ",
      "alarmBody": "ސްޓޮކް ސަބް-ލެޖަރާއި މުދަލުގެ ކޮންޓްރޯލް ހިސާބުތަކުގެ ތަފާތަކީ",
      "alarmAccount": "ސަބް-ލެޖަރ {subLedger}، ޖެނެރަލް ލެޖަރ {control}، ތަފާތު {difference}",
      "alarmNextStep": "ކޮންމެ ހިސާބެއްގެ ލެޖަރ ހުޅުވައި، އެ ބާކީގެ ފަހަތުގައިވާ ޕޯސްޓިންގތައް ހޯއްދަވާ، އަދި ސަބް-ލެޖަރ ޢަދަދުގެ ފަހަތުގައިވާ ސްޓޮކް ލެވެލްތައް ބައްލަވާ. ދިމާވަންދެން، ސްޓޮކް ވެލުއޭޝަނަށްވެސް، ބެލެންސް ޝީޓަށްވެސް ބަރޯސާވެވެން ނެތެވެ.",
      "totalBroken": "ދައްކާފައިވާ ޖުމްލައަކީ މަތީގައިވާ ސަފުތަކުގެ ޖުމްލައެއް ނޫނެވެ، އެހެންކަމުން މި ރިޕޯޓް އެތެރެއިންވެސް ދިމައެއް ނުވެއެވެ.",
      "howItIsBuilt": "ސަބް-ލެޖަރ ޢަދަދަކީ އެ ހިސާބަށް ޕޯސްޓްވާ ކޮންމެ ތަކެއްޗެއްގެ ހުރި ސްޓޮކްގެ ވެލިއުގެ ޖުމްލައެވެ. ކޮންޓްރޯލް ޢަދަދަކީ އެ ހިސާބުގެ ޕޯސްޓްކުރެވިފައިވާ ޖާނަލް ސަފުތަކުގެ ޖުމްލައެވެ. §16 އިން މި ދޭތި އެއްވަރުވާން ލާޒިމުކުރެއެވެ — މި ރިޕޯޓަކީ އެކަން ބަލާ ތަނެވެ.",
      "openStockLevels": "ސްޓޮކް ލެވެލްތައް",
      "generated": "އުފެއްދީ {at}",
      "empty": "މި ކުންފުންޏަށް އަދި މުދަލުގެ ހިސާބެއް ސެޓްކޮށްފައެއް ނުވެއެވެ.",
      "loadFailed": "ވެލުއޭޝަން ރިޕޯޓް ނުހިންގުނު",
      "columns": {
        "account": "ހިސާބު",
        "subLedger": "ސްޓޮކް ސަބް-ލެޖަރ",
        "control": "ޖެނެރަލް ލެޖަރ",
        "difference": "ތަފާތު"
      }
    },
    "errors": {
      "periodClosed": "މިކަން ޕޯސްޓްވާ މުއްދަތު ބަންދުވެފައެވެ. އަލުން ހުޅުވާ، ނުވަތަ ހުޅުވިފައިވާ މުއްދަތެއްގެ ތާރީޚެއް ބޭނުންކުރައްވާ.",
      "itemNotConfigured": "މީގެ ތެރެއިން ތަކެއްޗަކަށް މި ކުންފުނީގެ އަގުގެ ސެޓިންގތައް ނެތުމުން، މުދަލުގެ ތެރެއިން ހަރަކާތެއް ނުކުރެވެއެވެ. ފުރަތަމަ ތަކެތީގައި އެ ސެޓްކުރައްވާ.",
      "negativeStock": "މި ހަރަކާތުން ބާކީ ސުމަށްވުރެ ދަށްވާނެއެވެ، އަދި މި ގުދަނުން އެކަން ހުއްޓުވައެވެ. ސްޓޮކް ގުނާ، ނުވަތަ ގުދަނުގެ ނެގެޓިވް ސްޓޮކް ސިޔާސަތު ބަދަލުކުރައްވާ."
    },
    "chargeKind": {
      "disbursement": "ބަދަލުގައި ދެއްކި",
      "fee": "ފީ"
    },
    "chargeState": {
      "billed": "ބިލްކުރެވިފައި",
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "estimated": "ލަފާކުރި"
    },
    "classification": {
      "action": "ފިޔަވަޅު އަޅާ",
      "actionFailed": "ފިޔަވަޅު ނޭޅުނު",
      "actioned": "ނިންމުމަށް ފިޔަވަޅު އެޅިއްޖެ",
      "caption": "އިންވެންޓަރީ ބައިކުރުން",
      "classes": {
        "expired": "މުއްދަތު ހަމަވެފައި",
        "expiring": "މުއްދަތު ހަމަވަނީ",
        "fast": "އަވަސް",
        "obsolete": "ބޭނުންނުކުރާ",
        "slow": "ލަސް"
      },
      "classification": "ބައި",
      "coverage": "ފުދޭ ދުވަސް",
      "daysSinceIssue": "ނުހިނގާ ދުވަސް",
      "decideFailed": "ނިންމުން ރެކޯޑެއް ނުކުރެވުނު",
      "description": "ނުހިނގާ ސްޓޮކާއި، މުއްދަތު ހަމަވާން އުޅޭ ސްޓޮކާއި، އެއާމެދު ކުރާ ކަންތައް.",
      "disposition": "ނިންމުން",
      "dispositionHints": {
        "donate": "ހަދިޔާކޮށް، ލިޔެ ކަނޑާ.",
        "markdown": "ނިންމުން ރެކޯޑްކުރެއެވެ. އަގު ބަދަލުކުރުމަކީ ޕްރައިސިން މޮޑިއުލްގެ ކަމެކެވެ.",
        "none": "އަދި ނިންމުމެއް ނެތް.",
        "return_to_vendor": "ސަޕްލަޔަރަށް އަނބުރާ ފޮނުވާ.",
        "transfer": "ވިއްކޭ ގުދަނަކަށް ބަދަލުކުރޭ.",
        "write_off": "ސްޓޮކް އެޑްޖަސްޓްމަންޓެއް ހަދައެވެ."
      },
      "dispositionStatus": "ނިންމުމުގެ ހާލަތު",
      "dispositions": {
        "donate": "ހަދިޔާކުރޭ",
        "markdown": "އަގު ދަށްކުރޭ",
        "none": "ނެތް",
        "return_to_vendor": "ސަޕްލަޔަރަށް އަނބުރާ",
        "transfer": "ބަދަލުކުރޭ",
        "write_off": "ލިޔެ ކަނޑާ"
      },
      "empty": "ބައިކޮށްފައި އެއްޗެއް ނެތް. ނުހިނގާ ސްޓޮކް ބެލުމަށް ހިންގާ.",
      "link": "ބައިކުރުން",
      "loadFailed": "ބައިކުރުން ލޯޑެއް ނުވި",
      "markdownNote": "އަގު ދަށްކުރުމަކުން މިތަނުން އެއްޗެއް ޕޯސްޓެއް ނުވެއެވެ؛ އަގު ބަދަލުކުރުމަކީ ޕްރައިސިން މޮޑިއުލްގެ ކަމެކެވެ. މިތަނުން ރެކޯޑްވަނީ ނިންމުމާއި ގުޅުމެވެ.",
      "ran": "ބައިކުރުމުގެ ރަން ނިމިއްޖެ",
      "ranDetail": "{lines} ސަފު، {value} ނުރައްކަލުގައި",
      "run": "މިހާރު ހިންގާ",
      "runFailed": "ބައިކުރުން ނުހިންގުނު",
      "statuses": {
        "actioned": "ފިޔަވަޅު އެޅި",
        "open": "ހުޅުވިފައި",
        "waived": "ދޫކޮށްލި"
      },
      "tableTitle": "ބައިކުރުން",
      "title": "ލަސް އަދި ބޭނުންނުކުރާ ސްޓޮކް"
    },
    "countMethod": {
      "abc": "އޭބީސީ",
      "expiring": "މުއްދަތު ހަމަވާ ސްޓޮކް",
      "full": "ފުރިހަމަ ގުނުން",
      "item": "ކަނޑައެޅި ބާވަތްތައް",
      "spot": "ކުއްލި ބެލުން",
      "zone": "ޒޯން"
    },
    "counting": {
      "accepted": "ޕޯސްޓްކުރީ",
      "acceptedSource": {
        "count": "ފުރަތަމަ ގުނުން",
        "recount": "އަލުން ގުނުން"
      },
      "attachment": "ހެކީގެ ފައިލް",
      "attachmentHint": "ބައެއް ސަބަބުތަކަށް ބޭނުންވެއެވެ.",
      "backToSheet": "ގުނުމުގެ ސަފުހާއަށް",
      "blindHidden": "ނުދައްކާ",
      "cancelDefaultReason": "އޮޕަރޭޓަރު ކެންސަލްކުރި",
      "cancelFailed": "ސެޝަން ކެންސަލެއް ނުކުރެވުނު",
      "cancelled": "ސެޝަން ކެންސަލްކުރެވިއްޖެ",
      "counted": "ގުނި ޢަދަދު",
      "countedBy": "ގުނީ",
      "differentCounter": "އެހެން މީހަކު އަލުން ގުނުން",
      "differentCounterHint": "ސާވިސްއިންނާއި ޑޭޓާބޭހުން ބަލައެއް ނުގަނެއެވެ.",
      "differentCounterNote": "ފުރަތަމަ ގުނި މީހާ އަލުން ގުނުން ބަލައެއް ނުގަނެއެވެ — ސާވިސްއިންނާއި ޑޭޓާބޭހުންވެސްމެ.",
      "evidenceRequired": "މި ސަބަބަށް ހެކީގެ ފައިލެއް ބޭނުންވެއެވެ.",
      "explain": "ތަފްސީލު",
      "explainDescription": "'ގެއްލުން' ގެ ނަމުގައި ގްރޫޕްކުރި ރިޕޯޓަކުން ބަލަންވީ ތަނެއް ނޭނގޭނެއެވެ.",
      "explainFailed": "ތަފްސީލު ރައްކާނުކުރެވުނު",
      "explainTitle": "ތަފާތު ތަފްސީލުކުރޭ",
      "factsTitle": "ސެޝަން",
      "freezeActive": "މި ސެޝަނުން {count} ސްކޯޕެއް ފްރީޒްކޮށްފައި.",
      "freezeConsequence": "ސެޝަން ޕޯސްޓް ނުވަތަ ކެންސަލްކުރަންދެން މި ސްކޯޕުގައި ނެގުމާއި ބެހެއްޓުމާއި ބަދަލުކުރުން އެއްވެސް މީހަކަށް ނުކުރެވޭނެއެވެ.",
      "freezeReleased": "ފްރީޒް ދޫކޮށްލެވިއްޖެ.",
      "freezeScope": "ސްކޯޕް ފްރީޒްކުރޭ",
      "freezeScopeHint": "ސެޝަން ޕޯސްޓް ނުވަތަ ކެންސަލްކުރަންދެން އެ ސްކޯޕަށް އަރާ ހުރިހާ ހަރަކާތެއް ބަލައެއް ނުގަނެއެވެ.",
      "loadFailed": "ސެޝަން ލޯޑެއް ނުވި",
      "method": "އުކުޅު",
      "methodHint": {
        "abc": "އަގުން ބައިކުރި ލިސްޓެއް.",
        "expiring": "މުއްދަތު ހަމަވާން ކައިރިވެފައިވާ ސްޓޮކް.",
        "full": "ބެލެންސް ހުރި ހުރިހާ ބާވަތެއް.",
        "item": "ނެގި ބާވަތްތައް އެކަނި.",
        "spot": "ކުއްލި ބެލުމެއް.",
        "zone": "ގުދަނުގެ އެއް ޒޯން."
      },
      "methodLabelHint": "ސަފުތައް ނެގުނު ގޮތް ރެކޯޑްކުރެއެވެ.",
      "noLines": "މި ސެޝަނުގައި ސަފެއް ނެތް.",
      "openReview": "އަލުން ގުނުމާއި ތަފާތު",
      "post": "ޕޯސްޓްކުރޭ",
      "postFailed": "ސެޝަން ޕޯސްޓެއް ނުކުރެވުނު",
      "posted": "ސެޝަން ޕޯސްޓްކުރެވިއްޖެ",
      "postedDetail": "ތަފާތުގެ ޖާނަލް ލެޖަރުގައި، އަދި ފްރީޒް ދޫކޮށްލެވިއްޖެ.",
      "queueCaption": "އަލުން ގުނަން ޖެހޭ ސަފުތައް",
      "queueDescription": "ހައްދު ފަހަނައެޅި، އަދި އަލުން ނުގުނާ ސަފުތައް.",
      "queueEmpty": "އަލުން ގުނަން ޖެހޭ ސަފެއް ނެތް.",
      "queueTitle": "އަލުން ގުނާ ލިސްޓު",
      "reason": "ސަބަބު",
      "recordRecounts": "އަލުން ގުނި ޢަދަދު ރެކޯޑްކުރޭ",
      "recountAria": "އަލުން ގުނި ޢަދަދު، {item}",
      "recountFailed": "އަލުން ގުނުން ރެކޯޑެއް ނުކުރެވުނު",
      "recountQty": "އަލުން ގުނި ޢަދަދު",
      "recountedCount": "{count} ސަފު އަލުން ގުނިއްޖެ.",
      "recountsOutstanding": "ބައެއް ސަފުތައް އަދިވެސް އަލުން ގުނަން ޖެހެއެވެ.",
      "recountsRecorded": "އަލުން ގުނުން ރެކޯޑްކުރެވިއްޖެ",
      "reportCounts": "{counted} ގުނި · {recounted} އަލުން ގުނި",
      "reportTotals": "ޖުމުލަ",
      "review": "މުރާޖައާއަށް",
      "reviewDescription": "އަލުން ގުނަންޖެހޭ ލިސްޓާއި ތަފާތުގެ މުރާޖައާ. ހައްދު ފަހަނައެޅި ސަފެއް، އެހެން މީހަކު އަލުން ނުގުނާހާ ހިނދަކު ޕޯސްޓެއް ނުކުރެވޭނެއެވެ.",
      "reviewFailed": "ސެޝަން މުރާޖައާއަށް ނުގެންދެވުނު",
      "reviewTitle": "މުރާޖައާ — {no}",
      "reviewed": "ސެޝަން މުރާޖައާއަށް ބަދަލުކުރެވިއްޖެ",
      "rootCause": "އަސްލު ސަބަބު",
      "rootCauseHint": "ބަލައިގަތުމުގެ ކުށް، ނެގުމުގެ ކުށް، ވައްކަން، ފިނިވުން ފަދަ ކަންކަން.",
      "sameCounter": "އެއް މީހަކަށް އޭނާގެ އަމިއްލަ ސަފު އަލުން ނުގުނޭނެއެވެ.",
      "system": "ސިސްޓަމް",
      "thresholdPct": "އަލުން ގުނާ ހައްދު %",
      "thresholdPctHint": "ހުސްކޮށް ބާއްވައިފިނަމަ ކުންފުނީގެ ސެޓިން ބޭނުންކުރެއެވެ.",
      "thresholdValue": "އަލުން ގުނާ ހައްދު އަގު",
      "thresholdValueHint": "ދެ ހައްދުން ކުރެ އެއް ހައްދު ފަހަނައެޅުމުން އަލުން ގުނަން ޖެހެއެވެ.",
      "varianceCaption": "ގުނުމުގެ ތަފާތު",
      "varianceDescription": "ސަބަބުން ބުނަނީ ކޮންކަމެއްކަން؛ އަސްލު ސަބަބުން ބުނަނީ ކީއްވެކަން. އެއީ ދެ ސުވާލެކެވެ.",
      "varianceExplained": "ތަފާތު ތަފްސީލުކުރެވިއްޖެ",
      "varianceTitle": "ތަފާތުގެ މުރާޖައާ",
      "varianceValue": "ތަފާތުގެ އަގު",
      "zoneHint": "ގުނުން އެއް ޒޯނަށް ހަނިކުރެއެވެ."
    },
    "depletions": {
      "businessDate": "ވިޔަފާރީގެ ތާރީޚު",
      "caption": "ސްޓޮކުން އުނިކުރުންތައް",
      "component": "ބައި",
      "componentsCaption": "އުނިކުރި ބައިތައް",
      "componentsDescription": "ސްޓޮކުން ހަގީގަތުގައި ދިޔަ ތަކެތީގެ އަގާއި، އައި ލޮޓު.",
      "componentsTitle": "ބޭނުންކުރި ބައިތައް",
      "description": "ވިއްކުމަކާ ގުޅިގެން ސްޓޮކުން އުނިވި ތަކެތި: ކޮން ބައިތަކެއް، ކޮން އަގެއްގައި، ކޮން ލޮޓަކުން.",
      "empty": "އަދި އެއްވެސް ރަނެއް ނެތް.",
      "firstSeen": "ފުރަތަމަ ފެނުނު",
      "issuedQty": "ދޫކުރި",
      "lastSeen": "ފަހުން ފެނުނު",
      "linesCaption": "ވިއްކުމުގެ ސަފުތައް",
      "link": "ސްޓޮކުން އުނިކުރުން",
      "loadFailed": "ރަންތައް ލޯޑެއް ނުވި",
      "noComponents": "މި ރަނުގައި ބައެއް ނެތް.",
      "occurrences": "ފަހަރު",
      "reason": "ސަބަބު",
      "resolution": "ނަތީޖާ",
      "resolutions": {
        "resolved": "ހޯދުނު",
        "skipped": "ދޫކޮށްލި",
        "unresolved": "ނުހޯދުނު"
      },
      "reverse": "އަނބުރާ ގެންނަ",
      "reverseDefaultReason": "އޮޕަރޭޓަރު އަނބުރާ ގެނައި",
      "reverseFailed": "އަނބުރާ ނުގެނެވުނު",
      "reversed": "ސްޓޮކުން އުނިކުރުން އަނބުރާ ގެނެވިއްޖެ",
      "saleLine": "ސަފު",
      "shortfall": "މަދުވި",
      "skippedLines": "ދޫކޮށްލި",
      "soldItem": "ވިއްކި ބާވަތް",
      "soldQty": "ވިއްކި ޢަދަދު",
      "sourceDoc": "އަސްލު ލިޔުން",
      "status": {
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "reversed": "އަނބުރާ ގެނެވިފައި"
      },
      "tableTitle": "ރަންތައް",
      "theoreticalQty": "ނަޒަރީ",
      "title": "ސްޓޮކުން އުނިކުރުންތައް",
      "unresolvedCaption": "ނުހޯދުނު ސަފުތައް",
      "unresolvedDescription": "ރެސިޕީއެއް ނުފެނުނު ވިއްކި ބާވަތްތައް، ބާވަތާއި އައުޓްލެޓުން ގްރޫޕްކޮށްފައި.",
      "unresolvedEmpty": "ވިއްކި ހުރިހާ ބާވަތަކަށް ރެސިޕީއެއް ފެނުނެވެ.",
      "unresolvedLines": "ނުހޯދުނު",
      "unresolvedMeaning": "ނުހޯދުނު ސަފަކީ ލެޖަރުގައި ނުޖެހި ސްޓޮކުން ދިޔަ ތަކެއްޗެވެ. އެއިން ވިއްކުމެއް ނުހުއްޓުވެއެވެ؛ ނަމަވެސް ފޮރުވިފައި ބޭއްވުމަކީ ގޯހެކެވެ.",
      "unresolvedTitle": "ރެސިޕީއެއް ނުފެނުނު ބާވަތްތައް"
    },
    "expiry": {
      "inDays": "{days} ދުވަސް",
      "past": "{days} ދުވަސް ފަހަނައަޅާފައި",
      "today": "މިއަދު މުއްދަތު ހަމަވޭ",
      "undated": "މުއްދަތެއް ނެތް"
    },
    "fixedBins": {
      "assign": "ބިނެއް ކަނޑައަޅާ",
      "caption": "ކަނޑައެޅި ބިންތަކުގެ ލިސްޓު",
      "deleteFailed": "ކަނޑައެޅި ބިން ނުނެގުނު",
      "description": "ބާވަތެއް ބަހައްޓާ ތަން: ޕުޓްއަވޭގައި ފުރަތަމަ ބަލާ، ނެގުމުގައިވެސް ފުރަތަމަ ބަލާ ތަނެވެ.",
      "dialogDescription": "ކޮންމެ ބާވަތަކާއި ގުދަނަކަށް އެއް މައި ބިން. ދެ ތަނެއް ކަނޑައަޅައިފިނަމަ ތަނެއް ނެތެވެ.",
      "empty": "ކަނޑައެޅި ބިނެއް އަދި ނެތް.",
      "minQty": "އެންމެ ދަށް ޢަދަދު",
      "primaryReplaces": "މިއީ މައި ބިނަށް ހަދައިފިނަމަ، މި ގުދަނުގައި މިހާރު ހުރި މައި ބިން ބަދަލުވާނެއެވެ.",
      "remove": "ކަނޑައެޅި ބިން ނަގާ",
      "role": "ދައުރު",
      "roleHints": {
        "overflow": "މައި ބިން ފުރުމުން ބެލޭ.",
        "primary": "ނަގާ ތަން. ކޮންމެ ބާވަތަކާއި ގުދަނަކަށް އެކެއް."
      },
      "roles": {
        "overflow": "އިތުރު",
        "primary": "މައި"
      },
      "saveFailed": "ކަނޑައެޅި ބިން ރައްކާނުކުރެވުނު",
      "saved": "ކަނޑައެޅި ބިން ރައްކާކުރެވިއްޖެ",
      "strategyNote": "ފުރަތަމަ ކަނޑައެޅި ބިންތައް ބަލާނީ ގުދަނުގެ ޕުޓްއަވޭ އުކުޅުންނެވެ. ޑިފޯލްޓަކީ 'ފުރަތަމަ ކަނޑައެޅި، ދެން ކޮންމެ ތަނެއް' އެވެ.",
      "targetQty": "އަމާޒު ޢަދަދު",
      "title": "ކަނޑައެޅި ބިންތައް"
    },
    "genealogy": {
      "depthCapped": "ޓްރޭސް ހުއްޓުނީ {depth} މަރުހަލާގައެވެ. ދައްކާފައިވާ އަދަދަށްވުރެ ގިނަ ލޮޓު ހުރެދާނެއެވެ.",
      "description": "މި ލޮޓުން އުފެދުނު ތަކެތި. ސާވަރުން ފުންމިން ކަނޑައަޅާ؛ ފުންމިނަށް ދިޔަނަމަ އެކަން ދައްކާނެއެވެ.",
      "empty": "މި ލޮޓު އަލުން ބަންދުކޮށް، ބައިކޮށް ނުވަތަ އެއްކޮށްފައެއް ނުވެއެވެ.",
      "parents": "އައީ",
      "title": "ދަރިފަސްކޮޅު"
    },
    "haccp": {
      "checkpoint": "ޗެކްޕޮއިންޓް",
      "checkpointFailed": "ޗެކްޕޮއިންޓް ރައްކާނުކުރެވުނު",
      "checkpointSaved": "ޗެކްޕޮއިންޓް ރައްކާކުރެވިއްޖެ",
      "checkpointsCaption": "ހެކްޕް ޗެކްޕޮއިންޓުތައް",
      "checkpointsDescription": "ޗެކްޕޮއިންޓަކީ ޝެޑިއުލެކެވެ: މި ފްރިޖު، ޝިފްޓަކު ދެ ފަހަރު.",
      "checkpointsEmpty": "ޗެކްޕޮއިންޓެއް އަދި ނެތް.",
      "checkpointsLoadFailed": "ޗެކްޕޮއިންޓުތައް ލޯޑެއް ނުވި",
      "checkpointsTitle": "ޗެކްޕޮއިންޓުތައް",
      "correctiveAction": "އިސްލާހީ ފިޔަވަޅު",
      "correctiveActionHint": "ރީޑިން ދާއިރާއިން ބޭރުވެއްޖެނަމަ ކުރަންވީ ކަންތައް. މިއީ ބަދިގޭގެ އަމިއްލަ އިޖުރާއަތެވެ.",
      "correctiveRequiredHint": "ފެއިލްވެއްޖެނަމަ ބޭނުންވެއެވެ.",
      "csv": "ސީއެސްވީ",
      "csvHint": "checkpointCode,recordedOn,shiftCode,reading,outcome,correctiveActionTaken — ދިވެހި ތަރުޖަމާއެއް ނުހިމެނެއެވެ.",
      "description": "ޗެކްޕޮއިންޓް ޝެޑިއުލާއި އެއަށް ނަގާ ރީޑިންތައް. އަތުންނާއި ސީއެސްވީ އަކުން އެކަނި.",
      "failNeedsAction": "ފެއިލްވި ރީޑިންއަކަށް އިސްލާހީ ފިޔަވަޅެއް ބޭނުންވެއެވެ. ސަބަބެއް ނެތި ފެއިލްވެފައިވާ ލޮގަކީ ލޮގެއް ނެތުމަށްވުރެ ދެރަ ހެއްކެކެވެ.",
      "frequencies": {
        "daily": "ކޮންމެ ދުވަހަކު",
        "on_receipt": "ބަލައިގަންނަ ވަގުތު",
        "per_shift": "ކޮންމެ ޝިފްޓަކު",
        "twice_daily": "ދުވާލަކު ދެ ފަހަރު",
        "weekly": "ހަފުތާއަކު"
      },
      "frequency": "ތަކުރާރުވުން",
      "import": "ސީއެސްވީ އިމްޕޯޓް",
      "importDescription": "ކޮންމެ ރޯއަކަށް އެއް ރީޑިން. ފެއިލްވާ ރޯތައް ސަފު ނަންބަރާއެކު ދައްކާނެއެވެ.",
      "importFailed": "ރީޑިންތައް އިމްޕޯޓެއް ނުކުރެވުނު",
      "importPartial": "{imported} އިމްޕޯޓްވި، {failed} ބަލައިނުގަނެވުނު",
      "imported": "{imported} ރީޑިން އިމްޕޯޓްކުރެވިއްޖެ",
      "kind": "ބާވަތް",
      "kinds": {
        "cleaning": "ސާފުކުރުން",
        "cooking": "ކެއްކުން",
        "cooling": "ފިނިކުރުން",
        "humidity": "ތެތްކަން",
        "receiving": "ބަލައިގަތުން",
        "temperature": "ފިނިހޫނުމިން",
        "visual": "ލޮލުން ބެލުން"
      },
      "maxValue": "އެންމެ މަތި",
      "minValue": "އެންމެ ދަށް",
      "newCheckpoint": "އައު ޗެކްޕޮއިންޓް",
      "newCheckpointDescription": "އަދަދީ ރީޑިންއެއް ފާސްވޭތޯ ނިންމަނީ މި ދާއިރާއިންނެވެ.",
      "newRecord": "ރީޑިންއެއް ލިޔޭ",
      "newRecordDescription": "އަދަދީ ބާވަތެއްނަމަ ނަތީޖާ ހިސާބުކުރަނީ ޗެކްޕޮއިންޓުގެ ދާއިރާއިންނެވެ.",
      "noAutoQuarantine": "ލޮޓެއް ނެގުމުން ރީކޯލް ޓްރޭސްއަށް ބޭނުންވާ ގުޅުން ރެކޯޑްވެއެވެ. އެއިން ލޮޓު ކަރަންޓީނެއް ނުވެއެވެ؛ އެއީ އިންސާނީ ނިންމުމެކެވެ.",
      "noRange": "ދާއިރާއެއް ނެތް",
      "outcome": "ނަތީޖާ",
      "outcomes": {
        "fail": "ފެއިލް",
        "not_applicable": "ނުހިމެނޭ",
        "pass": "ފާސް"
      },
      "range": "ދާއިރާ",
      "reading": "ރީޑިން",
      "readingHint": "ލޮލުން ބަލާ ޗެކެއްނަމަ ހުސްކޮށް ބާއްވާ.",
      "recordFailed": "ރީޑިން ރެކޯޑެއް ނުކުރެވުނު",
      "recordSaved": "ރީޑިން ރެކޯޑްކުރެވިއްޖެ",
      "recordedOn": "ލިޔުނު ތާރީޚު",
      "recordsCaption": "ހެކްޕް ރީޑިންތައް",
      "recordsDescription": "ފެއިލްވުން ދައްކަނީ ފެއިލްވުމެއްގެ ގޮތުގައެވެ؛ އާދައިގެ ރޯއެއްގެ ގޮތުގައެއް ނޫނެވެ.",
      "recordsEmpty": "މި މުއްދަތުގައި ރީޑިންއެއް ނެތް.",
      "recordsTitle": "ރީޑިންތައް",
      "source": "އަސްލު",
      "sources": {
        "csv": "ސީއެސްވީ",
        "manual": "އަތުން"
      },
      "title": "ކާނާގެ ސަލާމަތް",
      "unit": "ޔުނިޓް"
    },
    "landedCost": {
      "absorb": "ސްޓޮކަށް އަރުވާ",
      "absorbFailed": "ޝިޕްމަންޓް ސްޓޮކަށް ނުއެރުވުނު",
      "absorbed": "ސްޓޮކަށް އަރުވައިފި",
      "absorbedDetail": "ސްޓޮކްގެ އަގު ބަދަލުވެއްޖެއެވެ. ވެލުއޭޝަން ހުރިހާ އަދަދެއް އައު ކުރެވިއްޖެއެވެ.",
      "accruedCaption": "ޗާޖުގެ ފަރާތުން ބަހާލެވިފައިވާ، އިންވޮއިސް ނުލިބޭ ބެލެންސް",
      "accruedDescription": "ކްލިއަރިން އެކައުންޓަށް ރެކޯޑްކުރެވިފައިވާ، ނަމަވެސް އަދި ސަޕްލަޔަރުގެ އިންވޮއިސް ނުލިބޭ ޗާޖުތައް.",
      "accruedTitle": "ފަރާތުން ބަހާލެވިފައި، އިންވޮއިސް ނުލިބޭ",
      "accruedTotal": "ޖުމުލަ",
      "addCharge": "ޚަރަދެއް އިތުރުކުރޭ",
      "addChargeDescription": "އެލެމަންޓުން ނިންމަނީ އެ ޚަރަދުގެ ޓެކްސް އަނބުރާ ލިބޭތޯ، އަދި އެއިން ސްޓޮކަށް އަރާނެތޯއެވެ.",
      "agingBreakBody": "ސަބް ލެޖަރު {subledger} އަދި ކޮންޓްރޯލް {control}: ތަފާތު {difference}. ދެ ފަރާތުން ކުރެ އެއް ފަރާތުގައި އަނެއް ފަރާތަށް ނުފެންނަ ޕޯސްޓިންއެއް ވެއެވެ.",
      "agingBreakTitle": "ކްލިއަރިން އެކައުންޓް ދިމައެއް ނުވޭ",
      "agingCaption": "ލޭންޑަޑް ކޮސްޓް ކްލިއަރިން އޭޖިން",
      "agingControl": "ކޮންޓްރޯލް އެކައުންޓް",
      "agingDescription": "ލިޔުނު ޚަރަދުން ސްޓޮކަށް އެރުވި މިންވަރު އުނިކުރުމުން ކްލިއަރިން ބެލެންސް ލިބެއެވެ. ހުޅުވިފައިވާ ޝިޕްމަންޓުތަކުގެ ޖުމުލައަކީ ކްލިއަރިން އެކައުންޓެވެ.",
      "agingEmpty": "ކްލިއަރިން ބެލެންސެއް އޮތް ޝިޕްމަންޓެއް ނެތް.",
      "agingLink": "ކްލިއަރިން އޭޖިން",
      "agingLoadFailed": "އޭޖިން ރިޕޯޓް ލޯޑެއް ނުވި",
      "agingReconciled": "ކްލިއަރިން އެކައުންޓް {total} ގައި ދިމާވެއެވެ.",
      "agingSubledger": "ސަބް ލެޖަރުގެ ޖުމުލަ",
      "agingTableTitle": "ކްލިއަރިން ބެލެންސުން ޝިޕްމަންޓުތައް",
      "agingTitle": "ކްލިއަރިން އޭޖިން",
      "allocate": "ބަހާލާ",
      "allocateFailed": "ބަހާލުން ހިސާބެއް ނުކުރެވުނު",
      "allocated": "ބަހާލުން ހިސާބުކުރެވިއްޖެ",
      "allocatedDetail": "އަދި އެއްޗެއް ޕޯސްޓްކޮށްފައެއް ނުވެއެވެ. ސްޓޮކަށް އަރުވަނީ ދެން އަންނަ ފިޔަވަޅުންނެވެ.",
      "allocationStale": "ބަހާލުމަށްފަހު ޚަރަދެއް ނުވަތަ ސަފެއް ބަދަލުވެއްޖެއެވެ. ސްޓޮކަށް އެރުވުމުގެ ކުރިން އަލުން ބަހާލާ.",
      "backToList": "ޝިޕްމަންޓުތަކަށް",
      "billOfLading": "ބިލް އޮފް ލޭޑިން",
      "buckets": {
        "closed": "ބަންދު",
        "current": "މިހާރު",
        "days30": "1–30 ދުވަސް",
        "days60": "31–60 ދުވަސް",
        "days90": "61–90 ދުވަސް",
        "over90": "90 ދުވަހަށްވުރެ ގިނަ"
      },
      "caption": "ލޭންޑަޑް ކޮސްޓް ޝިޕްމަންޓުތައް",
      "chargeAdded": "ޚަރަދު އިތުރުކުރެވިއްޖެ",
      "chargeBasisCaption": "ޚަރަދުގެ އަސާސާއި ސްޓޮކަށް އެރުވޭ އަދަދު",
      "chargeDeleteFailed": "ޚަރަދު ނުނެގުނު",
      "chargeFailed": "ޚަރަދު އިތުރެއް ނުކުރެވުނު",
      "chargesCaption": "ޝިޕްމަންޓުގެ ޚަރަދުތައް",
      "chargesTitle": "ޚަރަދުތައް",
      "cleared": "ކްލިއަރކުރި",
      "clearingNotZero": "ކްލިއަރިން ބެލެންސް {balance}. ބަންދުކުރެވޭނީ ސުމަކަށް ދިޔުމުންނެވެ.",
      "close": "ބަންދުކުރޭ",
      "closeFailed": "ޝިޕްމަންޓް ބަންދެއް ނުކުރެވުނު",
      "closed": "ޝިޕްމަންޓް ބަންދުކުރެވިއްޖެ",
      "cogsSplitExplainer": "މި ޝިޕްމަންޓުގެ ބައެއް ވިއްކުމުގެ ޚަރަދަށް އެރުވުނީ އެ ސްޓޮކް ކުރިން ވިއްކާފައި ވާތީއެވެ. ނިސްބަތް ބަލަނީ ބަލައިގަތް މިންވަރާއެވެ؛ މިހާރު ގުދަނުގައި ހުރި މިންވަރަކާ ނޫނެވެ.",
      "columns": {
        "absorbable": "ސްޓޮކަށް އެރުވޭ",
        "absorbed": "ސްޓޮކަށް އެރުވި",
        "absorbedInventory": "އިންވެންޓަރީއަށް",
        "accrued": "ބަހާލެވިފައި",
        "age": "ދުވަސް",
        "allocated": "ބަހާލި",
        "baseAmount": "އަސާސީ އަދަދު",
        "basis": "އަސާސް",
        "chargeCount": "ޗާޖުތައް",
        "chargeTotal": "ޚަރަދުގެ ޖުމުލަ",
        "charges": "ޚަރަދު",
        "clearing": "ކްލިއަރިން ބެލެންސް",
        "counterparty": "ފަރާތް",
        "country": "ގައުމު",
        "duty": "ޑިއުޓީ",
        "dutyRate": "ޑިއުޓީ %",
        "effectiveFrom": "ފެށޭ ތާރީޚު",
        "element": "އެލެމަންޓް",
        "goodsValue": "މުދަލުގެ އަގު",
        "kind": "ބާވަތް",
        "lineTotal": "ސަފުގެ ޖުމުލަ",
        "mode": "ގޮތް",
        "qty": "ޢަދަދު",
        "receiptLine": "ބަލައިގަތުމުގެ ސަފު",
        "recoverableTax": "އަނބުރާ ލިބޭ ޓެކްސް",
        "reference": "ރެފަރެންސް",
        "source": "އަސްލު",
        "state": "ހާލަތު",
        "toCogs": "ވިއްކުމުގެ ޚަރަދަށް"
      },
      "counterparty": "ޗާޖުގެ ފަރާތް",
      "counterpartyHint": "މި ޗާޖު ދައްކަންޖެހޭ ފަރާތް — ފޯވާޑަރު، ބްރޯކަރު، ބަނދަރު ނުވަތަ އިންޝުއަރެންސް، މުދާ ފޯރުކޮށްދިން ފަރާތެއް ނޫން.",
      "counterpartyUnset": "ފަރާތެއް ކަނޑައަޅާފައެއް ނުވޭ",
      "create": "އައު ޝިޕްމަންޓް",
      "createDescription": "އުފެއްދުމަށްފަހު ބަލައިގަތުންތަކާއި ޚަރަދުތައް ގުޅުވެއެވެ.",
      "createFailed": "ޝިޕްމަންޓް ނުއުފެއްދުނު",
      "created": "ޝިޕްމަންޓް އުފެދިއްޖެ",
      "customsEntry": "ކަސްޓަމްސް އެންޓްރީ",
      "customsValue": "ކަސްޓަމްސް އަގު",
      "description": "ފްރެއިޓް، އިންޝުއަރެންސް، ޑިއުޓީ އަދި ކްލިއަރިން ފީ، އެ ޚަރަދުތައް ނިސްބަތްވާ ބަލައިގަތުންތަކަށް ބަހާލައެވެ.",
      "directAmountAria": "ސީދާ އަދަދު، {item}",
      "directCaption": "ކޮންމެ ސަފަކަށް ސީދާ އަދަދު",
      "directExplainer": "ސީދާ ޚަރަދު ލިޔެވެނީ ކޮންމެ ސަފަކަށެވެ؛ ބަހާނުލެވެއެވެ. ލިޔުނު އަދަދުތަކުގެ ޖުމުލަ ސާވަރުން ބަލައެވެ.",
      "disbursementTaxRefused": "ބަދަލުގައި ދެއްކި އަދަދަކަށް އަނބުރާ ލިބޭ ޓެކްސެއް ނުހިމެނޭނެއެވެ. އޭޕީ ބިލުގެ ޓެކްސް ކޯޑިން ބައްލަވާ.",
      "documentDescription": "ބަހާލުމުން މެޓްރިކްސް ހިސާބުކުރެއެވެ؛ ސްޓޮކަށް އެރުވުމުން ސްޓޮކްގެ އަގު ބަދަލުވެއެވެ.",
      "dutyClassificationRefused": "ޑިއުޓީ ޚަރަދަކަށް ޓެރިފް ކްލެސިފިކޭޝަނަކާއި އުފެއްދި ގައުމު ބޭނުންވެއެވެ.",
      "dutyRateHint": "ކަސްޓަމްސް އަގުގެ އިންސައްތަ. ކޮންމެ ޝިޕްމަންޓަކަށް ޑިއުޓީ ލިޔާނަމަ ހުސްކޮށް ބާއްވާ.",
      "elementFailed": "އެލެމަންޓް ރައްކާނުކުރެވުނު",
      "elementSaved": "އެލެމަންޓް ރައްކާކުރެވިއްޖެ",
      "elementsCaption": "ލޭންޑަޑް ކޮސްޓް އެލެމަންޓް",
      "elementsDescription": "ބާވަތަކީ ލޭބަލެއް ނޫނެވެ؛ އެއިން ނިންމަނީ ޓެކްސް އަނބުރާ ލިބޭތޯ، އަދި ޚަރަދު ސްޓޮކަށް އަރާނެތޯއެވެ.",
      "elementsEmpty": "އެލެމަންޓެއް އަދި ނެތް — ފްރެއިޓް، އިންޝުއަރެންސް، ޑިއުޓީ އަދި ކްލިއަރިން ފީއަކީ އާންމު ސެޓެވެ.",
      "elementsLink": "އެލެމަންޓާއި ޓެރިފް",
      "elementsLoadFailed": "އެލެމަންޓުތައް ލޯޑެއް ނުވި",
      "elementsTitle": "ކޮސްޓް އެލެމަންޓް",
      "empty": "ޝިޕްމަންޓެއް އަދި ނެތް.",
      "factsTitle": "ޝިޕްމަންޓް",
      "fxHint": "ކުންފުނީގެ އަސާސީ ފައިސާއަށް ރޭޓު.",
      "includeClosed": "ބަންދުކުރި ހިމަނާ",
      "isAbsorbable": "ސްޓޮކަށް އެރުވިދާނެ",
      "isAbsorbableHint": "އަބަދު މުއްދަތުގެ ޚަރަދަކަށްވާ ޚަރަދެއްނަމަ ނުނަގާ؛ މިސާލަކަށް އަމިއްލަ ލަސްވުމުން އަރާ ޑިމަރޭޖް.",
      "isDuty": "މިއީ ކަސްޓަމްސް ޑިއުޓީއެއް",
      "isDutyHint": "ބާވަތް ބަދަލުގައި ދެއްކި އަދަދަށް ބަދަލުކޮށް، ޓެރިފާއި އުފެއްދި ގައުމު ލާޒިމުކުރެއެވެ.",
      "journal": "ސްޓޮކަށް އެރުވުމުގެ ޖާނަލް",
      "kindConsequence": {
        "disbursement": "ބަދަލުގައި ދެއްކި އަދަދަކީ އެތެރެކުރާ ފަރާތުގެ ބަދަލުގައި ތިންވަނަ ފަރާތަކަށް ދެއްކި އަދަދެކެވެ. އަނބުރާ ލިބޭ ޓެކްސެއް ނުހިމެނޭތީ ފުރިހަމަ އަދަދު ސްޓޮކަށް އަރައެވެ.",
        "fee": "ފީއަކީ ސަޕްލަޔަރުގެ އަމިއްލަ ޚިދުމަތެއް ކަމުން، އޭގެ އަނބުރާ ލިބޭ ޓެކްސް ސްޓޮކަކަށް ނާރައެވެ."
      },
      "kindHint": {
        "disbursement": "ތިންވަނަ ފަރާތަކަށް ދައްކާ، އަގުގައި އަލުން ޗާޖުކުރާ.",
        "fee": "ސަޕްލަޔަރުގެ އަމިއްލަ ޚިދުމަތުގެ ޚަރަދު."
      },
      "loadFailed": "ޝިޕްމަންޓުތައް ލޯޑެއް ނުވި",
      "loadOneFailed": "ޝިޕްމަންޓް ލޯޑެއް ނުވި",
      "matrixCaption": "ޚަރަދު، ބަލައިގަތުމުގެ ސަފުން",
      "matrixDescription": "ބެލުމަށް އެކަނި. ކޮންމެ އަދަދަކީ ސާވަރުން ބަހާލި އަދަދެވެ.",
      "matrixEmpty": "އަދި ބަހާލެވޭނެ އެއްޗެއް ނެތް — ފުރަތަމަ ބަލައިގަތުންތަކާއި ޚަރަދުތައް އިތުރުކުރޭ.",
      "matrixExplainer": "ބަހާލީ {basis} އަސާސުންނެވެ.",
      "matrixServerComputed": "އަދަދާ ޖެހިގެން ދައްކާ ހިއްސާއަކީ ތަފްސީލެވެ. އަދަދު މިތަނުން އަލުން ހިސާބެއް ނުކުރެއެވެ؛ ބްރައުޒަރުން ހިސާބުކޮށްފިނަމަ ލާރިއަކުން ތަފާތުވެދާނެއެވެ.",
      "matrixTitle": "ބަހާލުން",
      "newElement": "އައު އެލެމަންޓް",
      "newElementDescription": "ޑިއުޓީއަކީ ބަދަލުގައި ދެއްކި އަދަދެކެވެ؛ ފޯމުން ލާޒިމުކުރަނީ ޑޭޓާބޭހުން ލާޒިމުކުރާ ކަމެވެ.",
      "newTariff": "އައު ޓެރިފް",
      "newTariffDescription": "ދެ ގައުމުގެ 1006.30 އަކީ ދެ ރޯ އެވެ؛ ޑިއުޓީ ރޭޓު ތަފާތުވާތީއެވެ.",
      "noCharges": "ޚަރަދެއް އަދި ނެތް.",
      "noReceipts": "މި ޝިޕްމަންޓުގައި ބަހާލެވޭނެ ބަލައިގަތުމުގެ ސަފެއް ނެތެވެ.",
      "noReceiptsYet": "އަދި ބަލައިގަތުމެއް ގުޅުވާފައެއް ނުވޭ.",
      "notAbsorbable": "މި އެލެމަންޓް ސްޓޮކަކަށް ނާރައެވެ؛ ސީދާ ޚަރަދަށް ދެއެވެ.",
      "notFound": "އެ ޝިޕްމަންޓެއް ނެތް.",
      "originCountry": "އުފެއްދި ގައުމު",
      "receiptsCaption": "ޝިޕްމަންޓުގެ ބަލައިގަތުމުގެ ސަފުތައް",
      "receiptsDescription": "މި ޚަރަދުތައް ގުޅޭ ބަލައިގަތުމުގެ ހަރަކާތްތައް. އެއް ހަރަކާތެއް ނިސްބަތްވަނީ އެއް ޝިޕްމަންޓަކަށެވެ.",
      "receiptsTitle": "ބަލައިގަތުންތައް",
      "removeCharge": "ޚަރަދު ނަގާ",
      "searchLabel": "ހޯދާ",
      "setupDescription": "ކޮސްޓް އެލެމަންޓާއި ޓެރިފް ކްލެސިފިކޭޝަން.",
      "setupTitle": "ލޭންޑަޑް ކޮސްޓް ސެޓަޕް",
      "staleAllocation": "ބަހާލުން ބާވެފައި. ފުރަތަމަ އަލުން ބަހާލާ.",
      "tableTitle": "ޝިޕްމަންޓުތައް",
      "tariff": "ޓެރިފް ކްލެސިފިކޭޝަން",
      "tariffFailed": "ޓެރިފް ރައްކާނުކުރެވުނު",
      "tariffHint": "ކަސްޓަމްސްއިން ބޭނުންކުރާ އެޗްއެސް ނުވަތަ ގައުމީ ކޯޑު.",
      "tariffSaved": "ޓެރިފް ރައްކާކުރެވިއްޖެ",
      "tariffSource": {
        "pack": "ލޯކަލައިޒޭޝަން ޕެކް",
        "tenant": "ޓެނަންޓް"
      },
      "tariffsCaption": "ޓެރިފް ކްލެސިފިކޭޝަން",
      "tariffsDescription": "މިހާރު މިއީ ޓެނަންޓުގެ ޑޭޓާއެވެ؛ ފަހުން ލޯކަލައިޒޭޝަން ޕެކަކުން ރޭޓު އައުމަކީ އެކަށީގެންވާ ކަމެކެވެ.",
      "tariffsEmpty": "ޓެރިފް ކްލެސިފިކޭޝަނެއް އަދި ނެތް.",
      "tariffsLoadFailed": "ޓެރިފްތައް ލޯޑެއް ނުވި",
      "tariffsTitle": "ޓެރިފް ކްލެސިފިކޭޝަން",
      "title": "ލޭންޑަޑް ކޮސްޓް"
    },
    "landedCostBasis": {
      "direct": "ސީދާ",
      "quantity": "ޢަދަދު",
      "value": "އަގު",
      "volume": "ވޮލިއުމް",
      "weight": "ބަރުދަން"
    },
    "landedCostBasisHint": {
      "direct": "ކޮންމެ ސަފަކަށް ވަކިން ލިޔެވެއެވެ؛ ބަހާނުލެވެއެވެ. ޓެރިފް ސަފުން ހިސާބުކުރި ޑިއުޓީ ކުރިންވެސް ސަފަކަށް ކަނޑައެޅިފައި ވާތީއެވެ.",
      "quantity": "ލިބުނު ޢަދަދާ އެއްގޮތަށް ބަހާލެވެއެވެ.",
      "value": "ކޮންމެ ސަފެއްގެ މުދަލުގެ އަގާ އެއްގޮތަށް ބަހާލެވެއެވެ.",
      "volume": "ވޮލިއުމުން ބަހާލެވެއެވެ. ވޮލިއުމެއް ނެތްނަމަ ބަލައެއް ނުގަނެއެވެ.",
      "weight": "ސާފު ބަރުދަނުން ބަހާލެވެއެވެ. ބަރުދަނެއް ނެތްނަމަ ބަލައެއް ނުގަނެއެވެ."
    },
    "lotRelation": {
      "merge": "އެއްކުރި",
      "production": "އުފެއްދި",
      "repack": "އަލުން ބަންދުކުރި",
      "rework": "އަލުން ހެދި",
      "split": "ބައިކުރި",
      "transform": "ބަދަލުކުރި"
    },
    "lotSource": {
      "backfill": "ކުރީގެ ޑޭޓާ",
      "manual": "އަތުން",
      "production": "އުފެއްދުން",
      "receipt": "ބަލައިގަތުން",
      "repack": "އަލުން ބަންދުކުރުން",
      "transfer": "ޓްރާންސްފަރ"
    },
    "lotStatus": {
      "available": "ލިބެން ހުރި",
      "blocked": "ހިފެހެއްޓިފައި",
      "expired": "މުއްދަތު ހަމަވެފައި",
      "quarantine": "ކަރަންޓީނު",
      "recalled": "ރީކޯލްކުރެވިފައި"
    },
    "lots": {
      "addPart": "ބައެއް އިތުރުކުރޭ",
      "backToRegister": "ލޮޓު ރަޖިސްޓަރީއަށް",
      "balancesCaption": "ގުދަނާއި ބިނުން ލޮޓުގެ ބެލެންސް",
      "balancesDescription": "ބިން ފެންވަރުގައި ހުރި ތަންތަން؛ ލެޖަރާ އެއް މުއާމަލާތެއްގައި ބަލަހައްޓާ ޑޭޓާއިން.",
      "balancesEmpty": "މި ލޮޓުގައި ސްޓޮކެއް ނެތް.",
      "balancesTitle": "ހުރި ތަން",
      "bestBefore": "އެންމެ ރަނގަޅު މުއްދަތު",
      "bin": "ބިން",
      "caption": "ސްޓޮކް ލޮޓުތައް",
      "changeStatus": "ސްޓޭޓަސް ބަދަލުކުރޭ",
      "changeStatusAction": "ސްޓޭޓަސް ބަދަލުކުރޭ",
      "changeStatusDescription": "ދެއްކިފައި ވަނީ މިހާރުގެ ސްޓޭޓަހުން ދެވޭ ހާލަތްތައް އެކަންޏެވެ.",
      "childExpiry": "ދަރި ލޮޓުގެ މުއްދަތު",
      "childExpiryHint": "ހުސްކޮށް ބާއްވައިފިނަމަ މައި ލޮޓުގެ މުއްދަތު ލިބޭނެއެވެ. އަލުން ބަންދުކުރުމުން މުއްދަތެއް ނުއިތުރުވެއެވެ.",
      "childLotNo": "އައު ލޮޓު ނަންބަރު",
      "columns": {
        "expiry": "މުއްދަތު",
        "lotNo": "ލޮޓު ނަންބަރު",
        "onHand": "ގުދަނުގައި",
        "source": "އަސްލު",
        "supplierRef": "ސަޕްލަޔަރ ރެފް",
        "valueAtRisk": "ނުރައްކަލުގައިވާ އަގު"
      },
      "countryHint": "ދެ އަކުރުގެ ކޯޑު.",
      "countryOfOrigin": "އުފެއްދި ގައުމު",
      "create": "އައު ލޮޓު",
      "currentStatus": "މިހާރު",
      "description": "ސްޓޮކްގެ ކޮންމެ ބެޗެއް، އަދި އެ ސްޓޮކް ދޫކުރެވޭނެތޯ ނިންމާ ސްޓޭޓަސް.",
      "dialogDescription": "ލޮޓުގެ ސްޓޭޓަސް ބަދަލުކުރަނީ ވަކި ސްކްރީނަކުންނެވެ؛ އެއީ ވަކި ހުއްދައެކެވެ.",
      "edit": "ލޮޓު އުނިއިތުރު",
      "empty": "ލޮޓެއް އަދި ނެތް — ބެޗް ބަލަހައްޓާ ބާވަތެއް ފުރަތަމަ ބަލައިގަތުމުން އުފެދޭނެއެވެ.",
      "emptyFiltered": "މި ފިލްޓަރުތަކާ ގުޅޭ ލޮޓެއް ނެތް.",
      "expiringCaption": "މުއްދަތު ހަމަވާން ކައިރިވެފައިވާ ލޮޓުތައް",
      "expiringDescription": "މުއްދަތު ހަމަވާ ތަރުތީބުން ލޮޓުތައް، އަދި ނުނަގައިފިނަމަ ގެއްލޭނެ އަގު.",
      "expiringEmpty": "{days} ދުވަހުގެ ތެރޭގައި މުއްދަތު ހަމަވާ އެއްޗެއް ނެތް.",
      "expiringNote": "ސްޓޮކް ހުސްވެފައިވާ ލޮޓުތައް ނުދައްކައެވެ؛ އެއީ ބޭކާރު މައުލޫމާތެކެވެ.",
      "expiringTableTitle": "މުއްދަތުގެ ނުރައްކާ",
      "expiryHint": "ގޯސް ތާރީޚެއް ރަނގަޅުކުރުމަކީ މުއްދަތު ހަމަވި ލޮޓެއް އެ ހާލަތުން ނެރެވޭ ހަމައެކަނި ގޮތެވެ.",
      "factsTitle": "ލޮޓު",
      "firstReceived": "ފުރަތަމަ ލިބުނު",
      "horizon": "މުއްދަތު",
      "horizonOption": "ކުރިއަށް {days} ދުވަސް",
      "issuable": "މި ލޮޓު ދޫކުރެވިދާނެ.",
      "ledgerNote": "މި ބާވަތުގެ ހުރިހާ ހަރަކާތެއް ސްޓޮކް ލެޖަރުގައި ހުންނާނެއެވެ.",
      "loadFailed": "ލޮޓުތައް ލޯޑެއް ނުވި",
      "loadOneFailed": "ލޮޓު ލޯޑެއް ނުވި",
      "manufacturedOn": "އުފެއްދި ތާރީޚު",
      "merge": "އެއްކުރޭ",
      "mergeDone": "އެއްކުރުން ރެކޯޑްކުރެވިއްޖެ",
      "mergeFailed": "އެއްކުރުން ރެކޯޑެއް ނުކުރެވުނު",
      "mergeNoSiblings": "މި ބާވަތުގައި އެއްކުރެވޭނެ އެހެން ލޮޓެއް ނެތް.",
      "mergeWith": "އެއްކުރާ ލޮޓުތައް",
      "mergeWithHint": "އެއް ބާވަތުގެ އެހެން ލޮޓުތައް. މަދުވެގެން އެކެއް ބޭނުންވެއެވެ.",
      "mergedLotNo": "އެއްކުރި ލޮޓު ނަންބަރު",
      "newStatus": "އައު ސްޓޭޓަސް",
      "noBin": "ބިނެއް ނެތް",
      "notFound": "އެ ލޮޓެއް ނެތް.",
      "notIssuable": {
        "blocked": "ވިޔަފާރީގެ ސަބަބުތަކަށްޓަކައި ހިފެހެއްޓިފައި. ދޫކުރެވެންދެން އެއްޗެއް ނުދޫކުރެވޭނެއެވެ.",
        "expired": "މުއްދަތު ހަމަވެފައި. ތާރީޚު ގޯސްނަމަ ރަނގަޅުކުރޭ؛ ސްޓޭޓަސް ދަނީ ޑޭޓާއާ އެއްގޮތަށެވެ.",
        "quarantine": "ކަރަންޓީނުކޮށްފައި. ދޫކުރެވެންދެން މި ލޮޓުން އެއްޗެއް ނުދޫކުރެވޭނެއެވެ.",
        "recalled": "ރީކޯލެއްގެ ދަށުގައި. މިއީ ހިނގަމުންދާ ރީކޯލަކުން ކުރި ކަމަކަށްވާތީ މި ސްކްރީނުން ނުނެގޭނެއެވެ."
      },
      "occurredOn": "ހިނގި ތާރީޚު",
      "openLedger": "ސްޓޮކް ލެޖަރު ހުޅުވާ",
      "partLotAria": "ލޮޓު ނަންބަރު، ބައި {line}",
      "partQtyAria": "ޢަދަދު، ބައި {line}",
      "qtyConsumed": "ބޭނުންކުރި ޢަދަދު",
      "qtyConsumedHint": "މައި ލޮޓުން ދަރި ލޮޓަށް ދިޔަ މިންވަރު، މައި ލޮޓުގެ ޔުނިޓުން.",
      "removePart": "ބައި {line} ނަގާ",
      "reopensExpired": "މި ލޮޓުގެ މުއްދަތު ހަމަވެފައި. ތާރީޚު ބަދަލުކޮށްފިނަމަ ރޭގަނޑުގެ ސްވީޕަށްފަހު އަލުން ބޭނުންކުރެވޭނެއެވެ.",
      "repack": "އަލުން ބަންދުކުރޭ",
      "repackDone": "އަލުން ބަންދުކުރުން ރެކޯޑްކުރެވިއްޖެ",
      "repackFailed": "އަލުން ބަންދުކުރުން ރެކޯޑެއް ނުކުރެވުނު",
      "saveFailed": "ލޮޓު ރައްކާނުކުރެވުނު",
      "saved": "ލޮޓު ރައްކާކުރެވިއްޖެ",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ލޮޓު ނަންބަރު ނުވަތަ ސަޕްލަޔަރުގެ ރެފަރެންސް",
      "showExpiring": "މުއްދަތުގެ ނުރައްކާ",
      "showRegister": "ލޮޓު ރަޖިސްޓަރީ",
      "split": "ބައިކުރޭ",
      "splitCaption": "ބައިކުރާ ބައިތައް",
      "splitDone": "ބައިކުރުން ރެކޯޑްކުރެވިއްޖެ",
      "splitFailed": "ބައިކުރުން ރެކޯޑެއް ނުކުރެވުނު",
      "statusChangeFailed": "ސްޓޭޓަސް ބަދަލެއް ނުކުރެވުނު",
      "statusChanged": "ސްޓޭޓަސް ބަދަލުކުރެވިއްޖެ",
      "statusChangedAt": "ފަހުން ބަދަލުކުރީ {at}",
      "statusChangedDetail": "{lot} މިހާރު {status}",
      "statusMeaning": {
        "available": "ސްޓޮކް ދޫކުރެވޭނެ.",
        "blocked": "ވިޔަފާރީގެ ހިފެހެއްޓުމެއް. އަނބުރާ ގެނެވޭނެ.",
        "expired": "މުއްދަތުގެ ތާރީޚާ އެއްގޮތަށް.",
        "quarantine": "ނިންމުމަކަށް އިންތިޒާރުގައި. އަނބުރާ ގެނެވޭނެ.",
        "recalled": "ރީކޯލަކުން ކުރި ކަމެއް."
      },
      "statusNote": "ސަބަބު",
      "statusNoteOptional": "އިޚްތިޔާރީ.",
      "statusNoteRequired": "ބޭނުންވޭ — ސަބަބެއް ނެތި ހިފެހެއްޓި ލޮޓެއް އެއްވެސް މީހަކަށް ދޫނުކުރެވޭނެއެވެ.",
      "statusTerminal": {
        "available": "ބަދަލުކުރެވޭ ހާލަތެއް ނެތް.",
        "blocked": "ބަދަލުކުރެވޭ ހާލަތެއް ނެތް.",
        "expired": "މުއްދަތު ހަމަވި ލޮޓެއް މި ހާލަތުން ނުކުންނަނީ ތާރީޚު ރަނގަޅުކުރުމުންނެވެ.",
        "quarantine": "ބަދަލުކުރެވޭ ހާލަތެއް ނެތް.",
        "recalled": "ރީކޯލްކުރި ލޮޓުގެ ސްޓޭޓަސް ބަލަހައްޓަނީ ރީކޯލުންނެވެ. ދޫކުރުމަށް ރީކޯލް ކެންސަލްކުރޭ ނުވަތަ ބަންދުކުރޭ."
      },
      "statusTransitionRefused": "{from} އިން އެ ބަދަލެއް ނުގެނެވޭނެއެވެ.",
      "supplierRefHidden": "ނުދައްކާ — ސަޕްލަޔަރުގެ ބެޗް ރެފަރެންސް ބެލުމަށް ލޮޓު މެނޭޖްކުރުމުގެ ހުއްދަ ބޭނުންވެއެވެ.",
      "tableTitle": "ލޮޓު ރަޖިސްޓަރީ",
      "title": "ލޮޓުތައް",
      "transform": "އަލުން ބަންދު، ބައިކުރުން ނުވަތަ އެއްކުރުން",
      "transformDescription": "މި ތިން ކަމުންވެސް ރެކޯޑްކުރަނީ ދަރިފަސްކޮޅުގެ ގުޅުމެވެ. ޢަދަދުތައް ބަދަލުވަނީ އާދައިގެ އެޑްޖަސްޓްމަންޓް ނުވަތަ އުފެއްދުމުގެ ލިޔުމަކުންނެވެ.",
      "transformNoMovement": "މިއިން ރެކޯޑްކުރަނީ ގުޅުން އެކަންޏެވެ. ސްޓޮކެއް ނުއުޅޭނެ، ޖާނަލެއްވެސް ނުޖެހޭނެއެވެ.",
      "transformTitle": "ލޮޓު {lot}",
      "vendor": "ސަޕްލަޔަރު"
    },
    "no": "ނޫން",
    "par": {
      "asAt": "ތާރީޚަށް",
      "asAtHint": "އެ ތާރީޚުގައި ހިނގަމުންދިޔަ މިންވަރު ދައްކައެވެ.",
      "caption": "ބާވަތާއި އައުޓްލެޓުން ޕާރ ލެވެލް",
      "defaultSource": "ކުންފުނީގެ ޑިފޯލްޓް",
      "description": "ޚިދުމަތް ފެށޭއިރު އައުޓްލެޓުގައި ހުންނަންޖެހޭ މިންވަރު.",
      "effectiveFrom": "ފެށޭ ތާރީޚު",
      "effectiveFromHint": "ޕާރ ބަދަލުވަނީ މޫސުމުންނެވެ؛ ޑިސެމްބަރުގެ ރެކުއިޒިޝަން އަޅާކިޔަނީ ޑިސެމްބަރުގެ ޕާރ އާއެވެ.",
      "empty": "މި އައުޓްލެޓަށް ޕާރ ލެވެލެއް ނެތް.",
      "link": "ޕާރ ލެވެލް",
      "loadFailed": "ޕާރ ލެވެލްތައް ލޯޑެއް ނުވި",
      "minQty": "އެންމެ ދަށް ޢަދަދު",
      "minQtyHint": "މިއަށްވުރެ ދަށްވެއްޖެނަމަ ޚިދުމަތުގެ ކުރިންވެސް ފާހަގަކުރެއެވެ.",
      "noParLevels": "މި އައުޓްލެޓަށް ޕާރ ލެވެލެއް ކަނޑައަޅާފައެއް ނުވެއެވެ.",
      "notReorderPoint": "ޕާރ އިން އުފައްދަނީ މައި ގުދަނުން ހޯދާ ރެކުއިޒިޝަނެކެވެ. ރީއޯޑަރ ޕޮއިންޓުން އުފައްދަނީ ސަޕްލަޔަރެއްގެ ކިބައިން ގަތުމެކެވެ. މި ދޭތި އެއްކޮށްލުމަކީ ގުދަނުގައި ހަ ފުޅި ހުއްޓާ ބޭރުން ގަންނަން ޖެހޭ ސަބަބެވެ.",
      "onHand": "ގުދަނުގައި",
      "onOrder": "އަންނަނީ",
      "orderMultiple": "އޯޑަރު މަލްޓިޕަލް",
      "orderMultipleHint": "ލަފާދޭ ޢަދަދު މައްޗަށް ގެންދަނީ މި މިންވަރަށެވެ؛ މިސާލަކަށް 12 ގެ ކޭހެއް.",
      "outlet": "އައުޓްލެޓް",
      "parQty": "ޕާރ ޢަދަދު",
      "previewOnly": "މިއިން އެއްޗެއް ނުލިޔެވެއެވެ. ރެކުއިޒިޝަނަކަށް ބަދަލުކުރުމަކީ ވަކި ފިޔަވަޅެކެވެ.",
      "requisitionFailed": "ރެކުއިޒިޝަން ނުހެދުނު",
      "requisitionRaised": "ރެކުއިޒިޝަން ހެދިއްޖެ",
      "run": "ރަން ބަލާ",
      "runCaption": "ޕާރ ރަނުގެ ނަތީޖާ",
      "runDescription": "ހުރިހާ ބާވަތެއް ޕާރ އަށް ގެންދިޔުމަށް ރެކުއިޒިޝަނުގައި ހުންނަންޖެހޭ މިންވަރު.",
      "runEmpty": "ޕާރ އަށްވުރެ ދަށްވެފައި އެއްޗެއް ނެތް.",
      "runFailed": "ޕާރ ރަން ނުހިންގުނު",
      "runOn": "ޚިދުމަތުގެ ތާރީޚު",
      "runOnHint": "ޕާރ ލެވެލް ބަލަނީ މި ތާރީޚަށެވެ؛ މިއަދަކަށް ނޫނެވެ.",
      "runTitle": "ޕާރ ރަން",
      "saveFailed": "ޕާރ ލެވެލް ރައްކާނުކުރެވުނު",
      "saved": "ޕާރ ލެވެލް ރައްކާކުރެވިއްޖެ",
      "setLevel": "ޕާރ ލެވެލެއް ކަނޑައަޅާ",
      "setLevelDescription": "ތާރީޚަށް ބެހިފައި. ރައްކާކުރުމުން ނަގާ ތާރީޚުން ފެށިގެން އައު ވަރޝަނެއް އުފެދެއެވެ.",
      "shortfall": "މަދުވާ",
      "source": "ސޯސް",
      "sourceHint": "ސްޓޮކް އަންނަ ތަން. ހުސްކޮށް ބާއްވައިފިނަމަ ކުންފުނީގެ ޑިފޯލްޓް ބޭނުންކުރެއެވެ.",
      "suggested": "ލަފާދޭ",
      "tableTitle": "ޕާރ ލެވެލް",
      "title": "ޕާރ ލެވެލް",
      "toRequisition": "ރެކުއިޒިޝަނެއް ހަދާ",
      "unresolvedIntro": "{count} ބާވަތަކަށް ސޯހެއް ނުފެނުނު؛ ރަނުގައި ނުހިމެނެއެވެ:"
    },
    "recallAction": {
      "block_sales": "ވިއްކުން ހުއްޓުވާ",
      "dispose": "ނައްތާލާ",
      "notify_authority": "އޮތޯރިޓީއަށް އަންގާ",
      "notify_customer": "ކަސްޓަމަރަށް އަންގާ",
      "quarantine": "ސްޓޮކް ކަރަންޓީނުކުރޭ",
      "return_to_vendor": "ސަޕްލަޔަރަށް އަނބުރާ ފޮނުވާ",
      "verify_disposal": "ނައްތާލިކަން ކަށަވަރުކުރޭ"
    },
    "recallActionStatus": {
      "done": "ނިމިފައި",
      "open": "ހުޅުވިފައި",
      "waived": "ދޫކޮށްލެވިފައި"
    },
    "recallPosition": {
      "consumed": "ބޭނުންކޮށްފައި",
      "issued": "ދޫކުރެވިފައި",
      "on_hand": "އަދިވެސް ގުދަނުގައި",
      "returned": "އަނބުރާ ލިބިފައި",
      "sold": "ވިއްކާފައި",
      "transferred": "ބަދަލުކުރެވިފައި",
      "wasted": "އުކާލެވިފައި"
    },
    "recallSeverity": {
      "class_1": "ކްލާސް 1",
      "class_2": "ކްލާސް 2",
      "class_3": "ކްލާސް 3",
      "withdrawal": "ނެގުން"
    },
    "recallStatus": {
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "closed": "ބަންދުކުރެވިފައި",
      "contained": "ކޮންޓްރޯލްކުރެވިފައި",
      "draft": "ދެލިކޮޕީ",
      "tracing": "ޓްރޭސްކުރަނީ"
    },
    "recalls": {
      "action": "ކަން",
      "actionAdded": "ކަން އިތުރުކުރެވިއްޖެ",
      "actionCompleteFailed": "ކަން ނުނިންމުނު",
      "actionCompleted": "ކަން ނިމިއްޖެ",
      "actionFailed": "ކަން އިތުރެއް ނުކުރެވުނު",
      "actionHint": {
        "block_sales": "ވިއްކުން ހުއްޓުވާ.",
        "dispose": "ނައްތާލާ.",
        "notify_authority": "ރެގިއުލޭޓަރަށް އަންގާ.",
        "notify_customer": "ލިބުނު ކަސްޓަމަރުންނަށް އަންގާ.",
        "quarantine": "ހުރިހާ ގުދަނެއްގައި ސްޓޮކް ހަރަކާތްކުރުން ހުއްޓުވާ.",
        "return_to_vendor": "ސަޕްލަޔަރަށް އަނބުރާ ފޮނުވާ.",
        "verify_disposal": "ނައްތާލިކަން ކަށަވަރުކުރޭ."
      },
      "actionsCaption": "ރީކޯލްގެ ކަންކަން",
      "actionsDescription": "ހުޅުވިފައިވާ ކަމެއް އޮތްހާ ހިނދަކު ރީކޯލް ކޮންޓްރޯލެއް ނުކުރެވޭނެއެވެ.",
      "actionsEmpty": "އަދި ކަމެއް ނެތް.",
      "actionsOpen": "{count} ކަމެއް އަދިވެސް ހުޅުވިފައި.",
      "actionsTitle": "ކޮންޓްރޯލްކުރުމުގެ ލިސްޓު",
      "addAction": "ކަމެއް އިތުރުކުރޭ",
      "addActionDescription": "ކޮންމެ ކަމެއް ނިންމަން ނުވަތަ ސަބަބަކާއެކު ދޫކޮށްލަން ޖެހެއެވެ.",
      "affectedLots": "ލޮޓު",
      "affectedQty": "ޢަދަދު",
      "affectedValue": "އަގު",
      "backToBoard": "ރީކޯލް ބޯޑަށް",
      "buildPack": "ޕެކް އުފައްދާ",
      "cancelDefaultReason": "އޮޕަރޭޓަރު ކެންސަލްކުރި",
      "cancelFailed": "ރީކޯލް ކެންސަލެއް ނުކުރެވުނު",
      "cancelled": "ރީކޯލް ކެންސަލްކުރެވިއްޖެ",
      "caption": "ލޮޓު ރީކޯލްތައް",
      "close": "ބަންދުކުރޭ",
      "closeFailed": "ރީކޯލް ބަންދެއް ނުކުރެވުނު",
      "closed": "ރީކޯލް ބަންދުކުރެވިއްޖެ",
      "completeAction": "ކަން ނިންމާ",
      "completeActionDescription": "ދޫކޮށްލުމަށް ސަބަބެއް ބޭނުންވެއެވެ. ސަބަބެއް ނެތި ޑޭޓާބޭހުން ބަލައެއް ނުގަނެއެވެ.",
      "contain": "ކޮންޓްރޯލްކުރޭ",
      "containBy": "ކޮންޓްރޯލްކުރަންވީ",
      "containByHint": "ސުންގަޑިއެއް. ފަހަނައަޅާ ހުޅުވިފައިވާ ކަންކަން ހުރިނަމަ ފާހަގަކުރެވޭނެއެވެ.",
      "containFailed": "ރީކޯލް ކޮންޓްރޯލެއް ނުކުރެވުނު",
      "contained": "ރީކޯލް ކޮންޓްރޯލްކުރެވިއްޖެ",
      "counterparty": "އަނެއް ފަރާތް",
      "create": "ރީކޯލެއް ފަށާ",
      "createDescription": "އެނގޭ ލޮޓުތައް ނަގާށެވެ. ޓްރޭސްކުރުމުން ދަރިފަސްކޮޅުން އިތުރު ލޮޓުތައް ފެންނާނެއެވެ.",
      "createFailed": "ރީކޯލް ނުފެށުނު",
      "created": "ރީކޯލް ފެށިއްޖެ",
      "description": "ފުރަތަމަ ނިންމުމަކީ ނުރައްކަލުގެ ދަރަޖައެވެ: ކްލާސް 1 އަކީ ބޮޑު ގެއްލުމެއްގެ ފުރުސަތެވެ؛ ނެގުމަކީ ފެންވަރުގެ މައްސަލައެކެވެ.",
      "document": "ލިޔުން",
      "dueOn": "ސުންގަޑި",
      "empty": "ރީކޯލެއް ނެތް. އެއީ ރަނގަޅު ހާލަތެވެ.",
      "evidenceDescription": "ބޭރުގެ އޮޑިޓަރަކަށް ދޭ ލިޔެކިޔުން، އޭގެ ހޭޝްއާއެކު.",
      "evidenceTitle": "ހެކިތަކުގެ ޕެކް",
      "exposureTitle": "އަސަރު",
      "initiatedOn": "ފެށި ތާރީޚު",
      "loadFailed": "ރީކޯލްތައް ލޯޑެއް ނުވި",
      "loadOneFailed": "ރީކޯލް ލޯޑެއް ނުވި",
      "lots": "ލޮޓުތައް",
      "lotsDescription": "ނެގި ލޮޓުތަކާއި އެއިން ދަރިފަސްކޮޅުން ފެނުނު ހުރިހާ އެއްޗެއް.",
      "lotsHint": "މަދުވެގެން އެކެއް ބޭނުންވެއެވެ.",
      "lotsTitle": "އަސަރުކުރި ލޮޓުތައް",
      "manifestHash": "މެނިފެސްޓް ހޭޝް",
      "markDone": "ނިމިއްޖެ",
      "markWaived": "ދޫކޮށްލައިފި",
      "namedLotsOnly": "މިހާރު ރެކޯޑްވަނީ ނަގާ ލޮޓުތައް އެކަންޏެވެ. ފަހުގެ ލޮޓުތައް ފެންނާނީ ޓްރޭސްކުރުމުންނެވެ.",
      "noLots": "ގުޅޭ ލޮޓެއް ނެތް.",
      "noPackYet": "ހެކިތަކުގެ ޕެކެއް އުފައްދާފައެއް ނުވޭ.",
      "notFound": "އެ ރީކޯލެއް ނެތް.",
      "notTracedYet": "މި ރީކޯލް ޓްރޭސްކޮށްފައެއް ނުވެއެވެ. ޓްރޭސްކުރަންދެން ކަރަންޓީނު ނުކުރެވޭނެއެވެ.",
      "openActions": "ހުޅުވިފައިވާ ކަންކަން",
      "packBuilt": "ހެކިތަކުގެ ޕެކް އުފެދިއްޖެ",
      "packBytes": "ބައިޓް",
      "packEntries": "ފައިލް",
      "packFailed": "ހެކިތަކުގެ ޕެކް ނުއުފެއްދުނު",
      "packReproducible": "ހޭޝް އަލުން އުފެއްދޭނެއެވެ؛ ޕެކްގެ އެތެރޭގައި އުފެއްދި ވަގުތެއް ނުހިމެނެއެވެ.",
      "positionMeaning": {
        "consumed": "ކާނާއަކަށް ނުވަތަ އުފެއްދުމަކަށް ބޭނުންކޮށްފައި. ބާކީ އޮތީ ރެކޯޑް އެކަންޏެވެ.",
        "issued": "ލިޔުމަކަށް ދޫކޮށްފައި. ހޯދުމަށް އެ ލިޔުން ބަލާ.",
        "on_hand": "އަދިވެސް ގުދަނުގައި. ކަރަންޓީނުން ހުއްޓުވަނީ މިއެވެ.",
        "returned": "ކަސްޓަމަރު އަނބުރާ ދިން.",
        "sold": "ވިއްކާފައި. މިއަށް ބޭނުންވަނީ ކަސްޓަމަރަށް އެންގުމެވެ؛ ކަރަންޓީނެއް ނޫނެވެ.",
        "transferred": "އެހެން ގުދަނަކަށް ނުވަތަ ކުންފުންޏަކަށް ބަދަލުކޮށްފައި.",
        "wasted": "ކުރިންވެސް އުކާލެވިފައި."
      },
      "quarantine": "ހުރިހާ ލޮޓެއް ކަރަންޓީނުކުރޭ",
      "quarantineFailed": "ސްޓޮކް ކަރަންޓީނެއް ނުކުރެވުނު",
      "quarantined": "ސްޓޮކް ކަރަންޓީނުކުރެވިއްޖެ",
      "raise": "ފަށާ",
      "reason": "ސަބަބު",
      "recallTitle": "ސުރުޚީ",
      "retrace": "އަލުން ޓްރޭސްކުރޭ",
      "searchLabel": "ހޯދާ",
      "severity": "ދަރަޖަ",
      "severityHint": {
        "class_1": "ބޮޑު ގެއްލުމެއް ލިބުމުގެ އެކަށީގެންވާ ފުރުސަތެއް.",
        "class_2": "ވަގުތީ ނުވަތަ އަނބުރާ ރަނގަޅުވާ ގެއްލުމެއް.",
        "class_3": "ގެއްލުމެއް ލިބުމުގެ ފުރުސަތު ކުޑަ.",
        "withdrawal": "ފެންވަރުގެ ސަބަބުން ނެގުމެއް؛ ސަލާމަތުގެ ރީކޯލެއް ނޫން."
      },
      "tableTitle": "ރީކޯލް ބޯޑު",
      "title": "ރީކޯލްތައް",
      "trace": "ޓްރޭސްކުރޭ",
      "traceFailed": "ރީކޯލް ޓްރޭސެއް ނުކުރެވުނު",
      "traceFirst": "ކަރަންޓީނުކުރުމުގެ ކުރިން ޓްރޭސްކުރޭ.",
      "traced": "ރީކޯލް ޓްރޭސްކުރެވިއްޖެ",
      "tracedAt": "ޓްރޭސްކުރި",
      "tracesCaption": "ޓްރޭސްކުރި ތަންތަން",
      "tracesDescription": "ހާލަތުން ގްރޫޕްކޮށްފައި؛ ގުދަނުގައިވާ ސްޓޮކް ކަރަންޓީނުކުރެވުނަސް ވިއްކާފައިވާ ސްޓޮކް ނުކުރެވޭތީއެވެ.",
      "tracesEmpty": "އަދި ޓްރޭސްކުރެވިފައެއް ނުވޭ.",
      "tracesTitle": "ސްޓޮކް ދިޔަ ތަން",
      "viaGenealogy": "{depth} މަރުހަލާ ފަހަތުން",
      "waiveHint": "ސަބަބެއް ބޭނުންވެއެވެ.",
      "waivedReason": "ދޫކޮށްލި ސަބަބު",
      "waivedReasonHint": "ހެކިތަކުގެ ޕެކްގައި ރެކޯޑްވާނެއެވެ."
    },
    "recipeKind": {
      "batch": "ބެޗް",
      "modifier": "މޮޑިފަޔަރ",
      "plated": "ތައްޓަށް",
      "sub_recipe": "ސަބް ރެސިޕީ"
    },
    "recipes": {
      "addLine": "ބައެއް އިތުރުކުރޭ",
      "asAt": "ތާރީޚަށް",
      "asAtHint": "އެ ތާރީޚުގައި ހިނގަމުންދިޔަ ވަރޝަން ދައްކައެވެ.",
      "backToList": "ރެސިޕީތަކަށް",
      "caption": "ރެސިޕީތައް",
      "component": "ބާވަތް",
      "componentsCaption": "ރެސިޕީގެ ބައިތައް",
      "componentsDescription": "ސާފު ޢަދަދާއި އުކާލެވޭ އިންސައްތައަކީ ދެ އަދަދެކެވެ؛ ބަދިގޭގައި ވިސްނަނީ އެގޮތަށެވެ.",
      "componentsTitle": "ބައިތައް",
      "costAsOf": "ޚަރަދު ތާރީޚަށް",
      "costAsOfHint": "ހުސްކޮށް ބާއްވައިފިނަމަ މިއަދުގެ ޚަރަދު ބޭނުންކުރެއެވެ.",
      "costCaption": "ބަހާލި ރެސިޕީގެ ޚަރަދު",
      "costDescription": "އެންމެ ފުނަށް ބަހާލައިފައި. ކޮންމެ އަދަދަކީ ސާވަރުގެ އަދަދެކެވެ.",
      "costEmpty": "އަދި ޚަރަދު ހިސާބުކުރެވޭނެ އެއްޗެއް ނެތް.",
      "costPerOutput": "ޔުނިޓަކަށް ޚަރަދު",
      "costTitle": "ނަޒަރީ ޚަރަދު",
      "costTotal": "ޔީލްޑަށް ޖުމުލަ",
      "create": "އައު ރެސިޕީ",
      "createDescription": "އުފެއްދުމަށްފަހު ސަފުތައް އިތުރުކުރެވެއެވެ.",
      "createFailed": "ރެސިޕީ ނުއުފެއްދުނު",
      "created": "ރެސިޕީ އުފެދިއްޖެ",
      "cycleRefused": "ސަބް ރެސިޕީގެ ބުރެއް ބަލައެއް ނުގަނެވުނު.",
      "defaultWarehouse": "ޑިފޯލްޓް ސޯސް",
      "depthCapped": "ބަހާލުން ހުއްޓުނީ ފުންމިނުގެ ހައްދުގައެވެ. ބައެއް ބައިތައް ނުހިމެނިދާނެއެވެ.",
      "depthRefused": "ސަބް ރެސިޕީގެ ފުންމިން ހުއްދަ މިންވަރަށްވުރެ ފުނެވެ.",
      "description": "ވިއްކާ ބާވަތެއްގެ އެއް ޔުނިޓް ވިއްކުމުން ސްޓޮކުން ދާ ތަކެތި.",
      "effectiveBar": "މި ވަރޝަން ހިނގަނީ {from} އިން {to} އަށެވެ.",
      "effectiveFrom": "ފެށޭ ތާރީޚު",
      "effectiveFromHint": "ރެސިޕީތައް ތާރީޚަށް ބެހިފައި ވަނީ، ފާއިތުވި މަހުގެ ޚަރަދު އަލުން ހޯދޭނެ ގޮތަށެވެ.",
      "empty": "ރެސިޕީއެއް އަދި ނެތް.",
      "factsTitle": "ރެސިޕީ",
      "kind": "ބާވަތް",
      "kindHint": {
        "batch": "ބެޗެއް؛ ސަފުތަކުގައި ވަނީ ބެޗުގެ ޢަދަދެވެ. އިންޖީނުން ޔީލްޑަށް ބަހާލައެވެ.",
        "modifier": "އިތުރު އެއްޗެއް؛ މިސާލަކަށް އިތުރު ޗީޒް.",
        "plated": "އެއް ބާވަތެއްގެ ގޮތުގައި ވިއްކާ ކާނާ ނުވަތަ ބުއިން.",
        "sub_recipe": "އެހެން ރެސިޕީތަކުން ބޭނުންކުރާ؛ ސީދާ ނުވިއްކާ."
      },
      "linesSaved": "ބައިތައް ރައްކާކުރެވިއްޖެ",
      "link": "ރެސިޕީތައް",
      "loadFailed": "ރެސިޕީތައް ލޯޑެއް ނުވި",
      "loadOneFailed": "ރެސިޕީ ލޯޑެއް ނުވި",
      "modifierAria": "މޮޑިފަޔަރ ކޯޑު، ސަފު {line}",
      "modifierCode": "މޮޑިފަޔަރ ކޯޑު",
      "netQty": "ސާފު ޢަދަދު",
      "netQtyAria": "ސާފު ޢަދަދު، ސަފު {line}",
      "noLines": "ބައެއް އަދި ނެތް.",
      "notABom": "ރެސިޕީއަކީ ބިލް އޮފް މެޓީރިއަލްއެއް ނޫނެވެ. ބީއޯއެމަކުން އުފައްދާ އެއްޗެއް ސްޓޮކަށް ވަދެއެވެ؛ ރެސިޕީއަކުން ވިއްކާ ވަގުތު ބާވަތްތައް ބޭނުންކުރެއެވެ.",
      "notFound": "އެ ރެސިޕީއެއް ނެތް.",
      "oneComponentPerLine": "ސަފެއްގައި އޮންނާނީ ބާވަތެއް ނުވަތަ ސަބް ރެސިޕީއެއް؛ ދެ އެއްޗެއް ނޫނެވެ.",
      "openEnded": "ދެން އަންގަންދެން",
      "optional": "އިޚްތިޔާރީ",
      "output": "އުފައްދާ ބާވަތް",
      "outputHint": "އާންމުކޮށް ސްޓޮކް ނުކުރާ ބާވަތެއް؛ ބިރިޔާނި ތައްޓެއް ސްޓޮކެއް ނުކުރެއެވެ.",
      "path": "މަގު",
      "qtyPerOutput": "ޔުނިޓަކަށް ޢަދަދު",
      "removeLine": "ސަފު {line} ނަގާ",
      "saveFailed": "ބައިތައް ރައްކާނުކުރެވުނު",
      "searchLabel": "ހޯދާ",
      "subRecipe": "ސަބް ރެސިޕީ",
      "supersede": "އައު ވަރޝަން",
      "supersedeFailed": "އައު ވަރޝަން ނުހެދުނު",
      "supersedeNote": "އައު ވަރޝަނެއް ހަދާނީ މިއަދުން ފެށިގެންނެވެ؛ ކުރީގެ ވަރޝަން ބެލޭނެއެވެ.",
      "superseded": "އައު ވަރޝަން އުފެދިއްޖެ",
      "tableTitle": "ރެސިޕީ ލިސްޓު",
      "theoreticalCost": "ނަޒަރީ ޚަރަދު",
      "title": "ރެސިޕީތައް",
      "wasteAria": "އުކާލެވޭ އިންސައްތަ، ސަފު {line}",
      "wasteExplainer": "އުކާލެވޭ އިންސައްތައަކީ ކެނޑުމާއި ތޮށިލުމާއި ކެއްކުމުން އުނިވާ މިންވަރެވެ: 0.2500 ކިލޯގެ ބަޔަކަށް 10% ނަމަ ސްޓޮކުން ދާނީ 0.2750 ކިލޯއެވެ.",
      "wastePercent": "އުކާލެވޭ %",
      "yield": "ޔީލްޑް",
      "yieldHint": "މި ސަފުތަކުން އުފައްދާ ޔުނިޓުގެ އަދަދު.",
      "yieldUom": "ޔީލްޑް ޔުނިޓް"
    },
    "recon": {
      "account": "އެކައުންޓް",
      "accountsChecked": "ބެލި",
      "accountsDiffering": "ތަފާތުވި",
      "backToRuns": "ރަންތަކަށް",
      "blocksClose": "ބަންދުކުރުން ހުއްޓުވާ",
      "breakBody": "ސަބް ލެޖަރު {subledger} އަދި ކޮންޓްރޯލް {control}: ތަފާތު {difference}.",
      "breakTitle": "ސަބް ލެޖަރާއި ކޮންޓްރޯލް އެކައުންޓް ދިމައެއް ނުވޭ",
      "caption": "ރިކޮންސިލިއޭޝަން ރަންތައް",
      "cause": "ސަބަބު",
      "causeHints": {
        "in_transit": "މަގުމަތީގެ ގުދަނުގައިވާ ސްޓޮކް.",
        "manual_journal": "ކޮންޓްރޯލް އެކައުންޓަށް ސީދާ ޕޯސްޓްކުރި. ސަބް ލެޖަރަށް އެއެއް ނުފެންނާނެއެވެ.",
        "migration": "ޑޭޓާ ބަދަލުކުރުމުން އައި ފެށޭ ބެލެންސެއް.",
        "posting_error": "ލިޔުމެއްގައި ގޯސް އެކައުންޓެއް.",
        "timing": "ދެން އަންނަ މުއްދަތުގައި ޖެހޭ ޕޯސްޓިންއެއް.",
        "unknown": "އަދި ދެނެގަނެވިފައެއް ނުވޭ."
      },
      "causes": {
        "in_transit": "މަގުމަތީގައި",
        "manual_journal": "އަތުން ޖެހި ޖާނަލް",
        "migration": "ޑޭޓާ ބަދަލުކުރުން",
        "posting_error": "ޕޯސްޓިންގެ ކުށް",
        "timing": "ވަގުތުގެ ތަފާތު",
        "unknown": "ނޭނގޭ"
      },
      "clean": "ސަބް ލެޖަރާއި ކޮންޓްރޯލް {total} ގައި ދިމާވެއެވެ.",
      "clear": "ސާފުކުރޭ",
      "clearFailed": "ތަފާތު ސާފެއް ނުކުރެވުނު",
      "cleared": "ތަފާތު ސާފުކުރެވިއްޖެ",
      "closeReadsThisRun": "ބަންދުކުރުމުގެ ކޮކްޕިޓުން ބަލަނީ އެންމެ ފަހު ރަނެވެ؛ އަލުން ހިސާބެއް ނުކުރެއެވެ. އެހެންވެ ދެ އެއްޗެއް ތަފާތެއް ނުވާނެއެވެ.",
      "control": "ކޮންޓްރޯލް",
      "description": "އިންވެންޓަރީ ސަބް ލެޖަރާއި ކޮންޓްރޯލް އެކައުންޓް، ކޮންމެ ދުވަހަކު ހެއްކާއެކު.",
      "difference": "ތަފާތު",
      "empty": "ރަނެއް އަދި ނެތް.",
      "explain": "ތަފްސީލު",
      "explainDescription": "ސަބަބެއް ބޭނުންވެއެވެ. ސަބަބެއް ނެތި ޑޭޓާބޭހުން ބަލައެއް ނުގަނެއެވެ.",
      "explainFailed": "ތަފްސީލު ރައްކާނުކުރެވުނު",
      "explainTitle": "ތަފާތު ތަފްސީލުކުރޭ",
      "explained": "ތަފާތު ތަފްސީލުކުރެވިއްޖެ",
      "lineStatuses": {
        "cleared": "ސާފުކުރި",
        "explained": "ތަފްސީލުކުރި",
        "investigating": "ބަލަނީ",
        "open": "ހުޅުވިފައި"
      },
      "linesCaption": "އެކައުންޓުން ރިކޮންސިލިއޭޝަން",
      "linesEmpty": "އެއްވެސް އެކައުންޓެއް ބަލާފައެއް ނުވޭ.",
      "linesTitle": "އެކައުންޓުތައް",
      "loadFailed": "ރަންތައް ލޯޑެއް ނުވި",
      "loadOneFailed": "ރަން ލޯޑެއް ނުވި",
      "manualJournalNote": "އަތުން ޖެހި ޖާނަލެއްނަމަ، އިންވެންޓަރީން ބޭރުން އެ އެކައުންޓަށް ސީދާ ޖެހި ޖާނަލްތައް ބައްލަވާ. އެއީ އާންމު ސަބަބެވެ.",
      "owner": "ޒިންމާދާރު",
      "ran": "ރިކޮންސިލިއޭޝަން ނިމިއްޖެ",
      "ranDetail": "{checked} އެކައުންޓް ބެލި، {differing} ތަފާތުވި",
      "run": "މިހާރު ހިންގާ",
      "runAt": "ހިންގި",
      "runDescription": "ކޮންމެ އެކައުންޓަކަށް، ތަފާތެއް ވާނަމަ ސަބަބާއި ޒިންމާދާރު ފަރާތާއެކު.",
      "runFailed": "ރިކޮންސިލިއޭޝަން ނުހިންގުނު",
      "runTitle": "{asOf} ގެ ރިކޮންސިލިއޭޝަން",
      "statuses": {
        "differences": "ތަފާތު",
        "failed": "ފެއިލްވި",
        "reconciled": "ދިމާވި"
      },
      "subledger": "ސަބް ލެޖަރު",
      "tableTitle": "ރަންތައް",
      "title": "ވެލުއޭޝަން ރިކޮންސިލިއޭޝަން"
    },
    "replenishment": {
      "asRequisition": "ރެކުއިޒިޝަނެއްގެ ގޮތުގައި",
      "avgDemand": "އެވްރެޖް ޑިމާންޑް",
      "caption": "ރީއޯޑަރ ލަފާތައް",
      "convert": "{count} ބަދަލުކުރޭ",
      "convertAction": "ބަދަލުކުރޭ",
      "convertDescription": "އެއް ޕާރޗޭސް ރިކުއެސްޓް؛ ކޮންމެ ލަފައަކަށް އެއް ސަފު.",
      "convertFailed": "ލަފާތައް ބަދަލެއް ނުކުރެވުނު",
      "convertSummary": "{count} ލަފާ ރިކުއެސްޓަށް ގެންދެވޭނެއެވެ.",
      "convertTitle": "ޕާރޗޭސް ރިކުއެސްޓަކަށް ބަދަލުކުރޭ",
      "converted": "ޕާރޗޭސް ރިކުއެސްޓް ހެދިއްޖެ",
      "convertedPartly": "{requestNo} ހެދިއްޖެ، {failed} ލަފައެއް ބަލައިނުގަނެވުނު",
      "demandExclusions": "ބޭރަށް ދާ ޓްރާންސްފަރާއި އުކާލުން ޑިމާންޑަކަށް ނުގުނައެވެ؛ ގުނައިފިނަމަ ގުދަނުން އޯޑަރުކުރާނީ އަމިއްލަ ގެއްލުމަށެވެ.",
      "description": "ރީއޯޑަރ ލަފާތަކާއެކު އެ ލަފާ އުފެއްދި ހިސާބު.",
      "effectiveFrom": "ފެށޭ ތާރީޚު",
      "empty": "ލަފައެއް ނެތް.",
      "eoq": "އީއޯކިޔު",
      "everyWarehouse": "ހުރިހާ ގުދަނެއް",
      "inbound": "އަންނަނީ",
      "leadTime": "ލީޑް (ދުވަސް)",
      "link": "ސްޓޮކް އިތުރުކުރުން",
      "loadFailed": "ލަފާތައް ލޯޑެއް ނުވި",
      "method": "އުކުޅު",
      "methods": {
        "eoq": "އީއޯކިޔު",
        "min_max": "މިން–މެކްސް",
        "none": "ނެތް",
        "par": "ޕާރ",
        "rop": "ރީއޯޑަރ ޕޮއިންޓް"
      },
      "needBy": "ބޭނުންވާ ތާރީޚު",
      "notWired": "މި ބިލްޑުގައި ޕާރޗޭސިން ގުޅުވާފައެއް ނުވެއެވެ. މިއީ ޑިޕްލޯއިމަންޓުގެ މައްސަލައެކެވެ.",
      "onHand": "ގުދަނުގައި",
      "parNote": "ޕާރ އުކުޅުގެ ލަފައަކުން އުފެދެނީ މައި ގުދަނުން ހޯދާ ރެކުއިޒިޝަނެކެވެ؛ ސަޕްލަޔަރެއްގެ ކިބައިން ގަތުމެއް ނޫނެވެ. އެހެންކަމުން މިތަނުން ބަދަލެއް ނުކުރެވެއެވެ.",
      "partialConversionNote": "ރިކުއެސްޓަށް ނުގެންދެވޭ ލަފައެއް އޮތްނަމަ އެ ލަފާ ބުނެދެއެވެ؛ ހުރިހާ އެއްޗެއް ފެއިލެއް ނުކުރެއެވެ.",
      "policiesCaption": "ސްޓޮކް އިތުރުކުރުމުގެ ސިޔާސަތުތައް",
      "policiesDescription": "ތާރީޚަށް ބެހިފައި. ސިޔާސަތެއް ނެތްނަމަ ބާވަތުގެ އަމިއްލަ ރީއޯޑަރ ކޮލަމް ބޭނުންކުރެއެވެ.",
      "policiesEmpty": "ސިޔާސަތެއް ނެތް. ބާވަތުގެ އަމިއްލަ ކޮލަމް ހިނގަނީ.",
      "policiesTitle": "ސިޔާސަތުތައް",
      "ran": "ރީއޯޑަރ ރަން ނިމިއްޖެ",
      "ranDetail": "{created} އުފެދުނު، {updated} އަޕްޑޭޓްވި، {requisitions} ރެކުއިޒިޝަން ލަފާދިން",
      "rop": "އާރްއޯޕީ",
      "run": "މިހާރު ހިންގާ",
      "runFailed": "ރީއޯޑަރ ރަން ނުހިންގުނު",
      "safetyOverride": "ރައްކާތެރި ސްޓޮކް އޯވަރައިޑް",
      "safetyStock": "ރައްކާތެރި ސްޓޮކް",
      "selectAll": "ބަދަލުކުރެވޭ ހުރިހާ ލަފައެއް ނަގާ",
      "selectRow": "{item} ގެ ލަފާ ނަގާ",
      "serviceLevel": "ޚިދުމަތުގެ ފެންވަރު",
      "sigma": "ތަފާތުވުން",
      "status": {
        "converted": "ބަދަލުކުރެވިފައި",
        "dismissed": "ދޫކޮށްލެވިފައި",
        "open": "ހުޅުވިފައި"
      },
      "suggested": "ލަފާދޭ",
      "tableTitle": "ލަފާތައް",
      "title": "ސްޓޮކް އިތުރުކުރުން"
    },
    "requisitionOrigin": {
      "event": "ހަރަކާތް",
      "manual": "އަތުން",
      "par": "ޕާރ ރަން",
      "recipe_forecast": "ރެސިޕީ ލަފާކުރުން"
    },
    "requisitionStatus": {
      "approved": "ފާސްކުރެވިފައި",
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "closed": "ބަންދުކުރެވިފައި",
      "draft": "ދެލިކޮޕީ",
      "issued": "ދޫކުރެވިފައި",
      "partially_issued": "ބައެއް ދޫކުރެވިފައި",
      "rejected": "ރައްދުކުރެވިފައި",
      "submitted": "ހުށަހަޅާފައި"
    },
    "requisitions": {
      "addLine": "ސަފެއް އިތުރުކުރޭ",
      "approved": "ރެކުއިޒިޝަން ފާސްކުރެވިއްޖެ",
      "approvedQty": "ފާސްކުރި",
      "backToList": "ރެކުއިޒިޝަންތަކަށް",
      "cancelDefaultReason": "އެދުނު ފަރާތުން ކެންސަލްކުރި",
      "cancelFailed": "ރެކުއިޒިޝަން ކެންސަލެއް ނުކުރެވުނު",
      "cancelled": "ރެކުއިޒިޝަން ކެންސަލްކުރެވިއްޖެ",
      "caption": "ސްޓޮކް ރެކުއިޒިޝަންތައް",
      "costCentreDescription": "ދޫކުރުމުން އަގު ބަދަލުވަނީ އެއް ސެންޓަރުން އަނެއް ސެންޓަރަށެވެ.",
      "costCentreTitle": "ކޮސްޓް ސެންޓަރު",
      "create": "އައު ރެކުއިޒިޝަން",
      "createDescription": "ހުށަހެޅުމުން، ސިޔާސަތެއް ދިމާވާނަމަ ފާސްކުރުމުގެ މަރުހަލާއަށް ދެއެވެ.",
      "createFailed": "ރެކުއިޒިޝަން ނުއުފެއްދުނު",
      "created": "ރެކުއިޒިޝަން އުފެދިއްޖެ",
      "decideFailed": "ނިންމުން ރެކޯޑެއް ނުކުރެވުނު",
      "description": "އައުޓްލެޓަކުން މައި ގުދަނުން ސްޓޮކް އެދުން.",
      "documentDescription": "ދޫކުރުމުން އަގު ބަދަލުވަނީ ގުދަނުގެ ކޮސްޓް ސެންޓަރުން އައުޓްލެޓުގެ ކޮސްޓް ސެންޓަރަށެވެ.",
      "empty": "ރެކުއިޒިޝަނެއް ނެތް.",
      "expenseOnIssue": "ދޫކުރުމުން ޚަރަދު — ގުދަނުން ނުކުންނަ ވަގުތު އަގު ޚަރަދަކަށް ދެއެވެ.",
      "expenseOnIssueConsequence": "މި އައުޓްލެޓުގައި ސްޓޮކެއް ނުހުންނާނެއެވެ: ބެލެންސެއް ނުއުފެދޭނެ، ނުގުނޭނެ، އަދި އެއިން ސްޓޮކް އުނިއެއް ނުކުރެވޭނެއެވެ.",
      "factsTitle": "ރެކުއިޒިޝަން",
      "fromCostCentre": "އިން",
      "issue": "ދޫކުރޭ",
      "issueFailed": "ރެކުއިޒިޝަން ދޫނުކުރެވުނު",
      "issued": "ރެކުއިޒިޝަން ދޫކުރެވިއްޖެ",
      "issuedQty": "ދޫކުރި",
      "linesCaption": "ރެކުއިޒިޝަނުގެ ސަފުތައް",
      "linesTitle": "ސަފުތައް",
      "loadFailed": "ރެކުއިޒިޝަންތައް ލޯޑެއް ނުވި",
      "loadOneFailed": "ރެކުއިޒިޝަން ލޯޑެއް ނުވި",
      "noCostCentre": "ނެތް",
      "noLines": "މި ރެކުއިޒިޝަނުގައި ސަފެއް ނެތް.",
      "notApproved": "މި ރެކުއިޒިޝަން ފާސްކޮށްފައެއް ނުވެއެވެ.",
      "notFound": "އެ ރެކުއިޒިޝަނެއް ނެތް.",
      "onHandAtRequest": "އޭރު ގުދަނުގައި",
      "origin": "އަސްލު",
      "outletHoldsNoStock": "އެ އައުޓްލެޓުގައި ސްޓޮކެއް ނުހުންނާނެތީ އެއިން އެއްޗެއް ނުއުނިކުރެވޭނެއެވެ.",
      "parColumnNote": "ޕާރ ކޮލަމަކީ ރަނުން ހިސާބުކުރި މިންވަރެވެ؛ އިންސާނާ އެދުނު މިންވަރާ ޖެހިގެންނެވެ.",
      "perpetual": "ޕަރޕެޗުއަލް — އައުޓްލެޓުގައި ގުނޭ ސްޓޮކް ހުރެ، އަގު ދަނީ މަގުމަތިން.",
      "qtyAria": "ޢަދަދު، ސަފު {line}",
      "rejectDefaultReason": "ފާސްކުރާ ފަރާތުން ރައްދުކުރި",
      "rejected": "ރެކުއިޒިޝަން ރައްދުކުރެވިއްޖެ",
      "removeLine": "ސަފު {line} ނަގާ",
      "requestedQty": "އެދުނު",
      "requiredOn": "ބޭނުންވާ ތާރީޚު",
      "shift": "ޝިފްޓް",
      "shiftHint": "އުކާލުމާއި ބޭނުންކުރުމުގެ ރިޕޯޓަށްޓަކައި ޝިފްޓަކަށް ނިސްބަތްކުރެއެވެ.",
      "stockModel": "ސްޓޮކް މޮޑެލް",
      "submitFailed": "ރެކުއިޒިޝަން ނުހުށަހެޅުނު",
      "submitted": "ރެކުއިޒިޝަން ހުށަހެޅިއްޖެ",
      "tableTitle": "ރެކުއިޒިޝަންތައް",
      "title": "ރެކުއިޒިޝަންތައް",
      "toCostCentre": "އަށް",
      "transfersTitle": "ހެދި ޓްރާންސްފަރތައް"
    },
    "rootCauseCategory": {
      "external": "ބޭރުގެ",
      "people": "މުވައްޒަފުން",
      "physical": "ޖިސްމާނީ",
      "process": "އިޖުރާއަތު",
      "system": "ސިސްޓަމް"
    },
    "settings": {
      "accountsDescription": "ބޭނުންވާ ކޮންމެ ޕޯސްޓިންއެއް، ކަނޑައަޅަންދެން ނަން ބުނެ ބަލައި ނުގަނެއެވެ.",
      "accountsTitle": "އެކައުންޓުތައް",
      "accrualAccount": "ލޭންޑަޑް ކޮސްޓް އެކްރޫއަލް",
      "accrualAccountHint": "ބިލު އައުމުގެ ކުރިން ލަފާކުރި ޗާޖެއް ހިމަނާނަމަ ކްރެޑިޓްވެއެވެ.",
      "allowAutoReceive": "އެއްފަހަރާ ފޮނުވައި ބަލައިގަތުމަށް ހުއްދަދޭ",
      "allowAutoReceiveHint": "ދެ ގޮތުންވެސް ދެ ފަޔާއި ދެ ޖާނަލް ލިޔެވޭނެއެވެ.",
      "blocks": {
        "clearing": "ލޭންޑަޑް ކޮސްޓް ކްލިއަރިން — ޝިޕްމަންޓެއް ސްޓޮކަށް ނުއެރުވޭނެ.",
        "inTransit": "މަގުމަތީގައިވާ މުދާ — ޓްރާންސްފަރެއް ނުފޮނުވޭނެ.",
        "outlet": "އައުޓްލެޓް ބޭނުންކުރުން — ދޫކުރުމުން ޚަރަދުވާ އައުޓްލެޓަކަށް ދޫނުކުރެވޭނެ.",
        "waste": "އުކާލުން — އުކާލުމުގެ ރެކޯޑެއް ޕޯސްޓެއް ނުވާނެ."
      },
      "clearingAccount": "ލޭންޑަޑް ކޮސްޓް ކްލިއަރިން",
      "clearingAccountHint": "ޗާޖުތައް އައުމުން ޑެބިޓް، ސްޓޮކަށް އެރުވުމުން ކްރެޑިޓް. ކޮންމެ ޝިޕްމަންޓަކުން ސުމަކަށް ދެއެވެ.",
      "description": "ކުންފުނިން އެކައުންޓާއި ސިޔާސަތު. އެކައުންޓުތައް ފެށެނީ ކަނޑައެޅުމެއް ނެތިއެވެ؛ ކޯޑުން ދިމާކުރުމަކީ ސިއްރު ގޯހަކަށް ވެދާނެތީއެވެ.",
      "gapsIntro": "މި އެކައުންޓުތައް ކަނޑައަޅާފައެއް ނުވެއެވެ؛ ކޮންމެ އެއްޗަކުން ކަމެއް ހުއްޓުވައެވެ:",
      "inTransitAccount": "މަގުމަތީގައިވާ މުދާ",
      "inTransitAccountHint": "ފޮނުވުމުން ޑެބިޓް، ލިބުމުން ކްރެޑިޓް. ކޮންމެ ޓްރާންސްފަރަކުން ސުމަކަށް ދެއެވެ.",
      "link": "އިންވެންޓަރީ ސެޓިންގްސް",
      "loadFailed": "ސެޓިންގްސް ލޯޑެއް ނުވި",
      "missingRecipe": {
        "block": "ސްޓޮކުން ނުއުނިކުރޭ",
        "blockHint": "ސްޓޮކުން އުނިކުރުން ފެއިލްވެ، ވިއްކުން ރަނގަޅުކުރަން ޖެހޭނެއެވެ.",
        "record": "ނުހޯދުނު ކަމަށް ރެކޯޑްކުރޭ",
        "recordHint": "ޕޮއިންޓް އޮފް ސޭލްއަކަށް ކުރިއަށްދެވޭނެ ހަމައެކަނި ގޮތް."
      },
      "missingRecipePolicy": "ރެސިޕީއެއް ނެތް ވިއްކުން",
      "missingRecipePolicyHint": "ވިއްކި ބާވަތަކަށް ރެސިޕީއެއް ނުފެނުނުނަމަ ހަދާނެ ގޮތް.",
      "outletAccount": "އައުޓްލެޓް ބޭނުންކުރުން",
      "outletAccountHint": "ވިއްކުމުގެ ޚަރަދާ ތަފާތެވެ؛ މުވައްޒަފުންގެ ކެންޓީނަކީ ވިއްކުމުގެ ޚަރަދެއް ނޫނެވެ.",
      "policyDescription": "ކޮންމެ ގުނުމަކާއި ޓްރާންސްފަރަކަށް ލިބޭ ޑިފޯލްޓުތައް.",
      "policyTitle": "ސިޔާސަތު",
      "recountPct": "އަލުން ގުނާ ހައްދު %",
      "recountPctHint": "ސިސްޓަމް ޢަދަދުގެ އިންސައްތަ.",
      "recountValue": "އަލުން ގުނާ ހައްދު އަގު",
      "recountValueHint": "އަލުން ގުނަން ޖެހޭ ތަފާތުގެ އަގު.",
      "requireDifferentCounter": "އެހެން މީހަކު ގުނަން ލާޒިމުކުރޭ",
      "requireDifferentCounterHint": "މިއީ INV-FR-009 ގައި ބުނާ ކޮންޓްރޯލެވެ.",
      "saveFailed": "ސެޓިންގްސް ރައްކާނުކުރެވުނު",
      "saved": "ސެޓިންގްސް ރައްކާކުރެވިއްޖެ",
      "shrinkageTarget": "ގެއްލުމުގެ އަމާޒު %",
      "shrinkageTargetHint": "ދޫކުރި މިންވަރުގެ އިންސައްތައެއް. ގެއްލުމުގެ ރިޕޯޓް އަޅާކިޔަނީ މިއާއެވެ.",
      "title": "އިންވެންޓަރީ ސެޓިންގްސް",
      "transferOverdueDays": "ޓްރާންސްފަރ ލަސްވަނީ (ދުވަސް)",
      "transferOverdueDaysHint": "ލިބެންވީ ތާރީޚުން ފެށިގެން.",
      "wasteAccount": "އުކާލުމާއި ހަލާކުވުން",
      "wasteAccountHint": "ސަބަބުގެ ކޯޑަކުން މި ބަދަލުކުރެވިދާނެއެވެ."
    },
    "shipmentMode": {
      "air": "ވައި",
      "courier": "ކޫރިއަރ",
      "road": "މަގު",
      "sea": "ކަނޑު"
    },
    "shipmentStatus": {
      "absorbed": "ސްޓޮކަށް އަރުވާފައި",
      "allocated": "ބަހާލެވިފައި",
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "closed": "ބަންދުކުރެވިފައި",
      "draft": "ދެލިކޮޕީ"
    },
    "shortageCause": {
      "bin_blocked": "ބިން ހިފެހެއްޓިފައި",
      "expired_lot": "މުއްދަތު ހަމަވި ލޮޓު",
      "in_transit": "މަގުމަތިން ގެއްލުނު",
      "no_stock": "ސްޓޮކެއް ނެތް",
      "quarantined_lot": "ކަރަންޓީނުކުރި ލޮޓު",
      "reserved_elsewhere": "އެހެން ފަރާތަކަށް ރިޒާވްކޮށްފައި",
      "shelf_life": "މުއްދަތު ކުރު"
    },
    "shortageStatus": {
      "backordered": "ފަހުން ފޮނުވާގޮތަށް",
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "open": "ހުޅުވިފައި",
      "resolved": "ހައްލުކުރެވިފައި",
      "substituted": "ބަދަލުކުރެވިފައި"
    },
    "shortages": {
      "available": "ލިބެން ހުރި",
      "caption": "ސްޓޮކް މަދުވުންތައް",
      "cause": "ސަބަބު",
      "description": "ވެވުނު ވައުދު ނުފުއްދުނު ކަމުގެ ރެކޯޑް؛ ކިހާ މިންވަރަކަށްކަމާއި ކީއްވެކަން.",
      "detectedOn": "ފާހަގަކުރި",
      "empty": "މަދުވުމެއް ނެތް.",
      "link": "މަދުވުންތައް",
      "loadFailed": "މަދުވުންތައް ލޯޑެއް ނުވި",
      "noSubstitutes": "މި ބާވަތަށް ބަދަލެއް ކަނޑައަޅާފައެއް ނުވެއެވެ.",
      "outcome": "ނަތީޖާ",
      "releaseConsequence": "މިއިން ވައުދެއް އެއް ލިޔުމުން އަނެއް ލިޔުމަށް ބަދަލުވެއެވެ. އެއްވެސް މީހަކަށް ނޭނގޭނެތީ އިންޖީނުން އަމިއްލައަށް މިކަމެއް ނުކުރެއެވެ.",
      "releaseLowerPriority": "އިސްކަން ދަށް ރިޒަވޭޝަން ދޫކުރޭ",
      "releaseLowerPriorityHint": "އެންމެ ދަށް އިސްކަން ފުރަތަމަ، އެންމެ ފަހުން ހެދި ފުރަތަމަ.",
      "requested": "އެދުނު",
      "resolve": "ހައްލުކުރޭ",
      "resolveDescription": "ވީގޮތް ބުނެދޭ. އިސްކަން ދަށް ރިޒަވޭޝަނެއް ދޫކުރުމަކީ ވަކި ނިންމުމެކެވެ.",
      "resolveFailed": "މަދުވުން ހައްލެއް ނުކުރެވުނު",
      "resolved": "މަދުވުން ހައްލުކުރެވިއްޖެ",
      "shortfall": "މަދުވި",
      "substitute": "ބަދަލުކުރޭ",
      "substituteDescription": "މިއިން ރެކޯޑްވަނީ ނިންމުމެވެ. ސްޓޮކެއް ނުއުޅެއެވެ؛ ދޫކުރަނީ އެ ލިޔުމުގެ މޮޑިއުލުންނެވެ.",
      "substituteFailed": "ބަދަލުކުރުން ރެކޯޑެއް ނުކުރެވުނު",
      "substituteItem": "ބަދަލުގައި ދޭ ބާވަތް",
      "substituteItemHint": "މި ބާވަތަށް ކަނޑައެޅި ބަދަލުތައް، އިސްކަމުގެ ތަރުތީބުން.",
      "substituteNeedsApproval": "މި ބަދަލަށް ފާސްކުރުމެއް ބޭނުންވެއެވެ.",
      "substituteNoMovement": "ހަރަކާތެއް ޕޯސްޓެއް ނުވެއެވެ. ބަދަލުކުރުމުން ބަދަލުވަނީ ލިޔުމުން އެދޭ އެއްޗެވެ.",
      "substituted": "ބަދަލުކުރުން ރެކޯޑްކުރެވިއްޖެ",
      "substitutedWith": "{item} ގެ {qty}",
      "tableTitle": "މަދުވުމުގެ އިންބޮކްސް",
      "title": "މަދުވުންތައް"
    },
    "shrinkage": {
      "analysisCaption": "އުކާލުމުގެ ތަހުލީލު",
      "analysisDescription": "ގެއްލުމުގެ ގޮތުގައި ނުގުނާ އުކާލުން ވަކިން ދައްކައެވެ؛ ނުހިމަނާ ދޫކޮށެއް ނުލައެވެ.",
      "analysisEmpty": "މި މުއްދަތުގައި އުކާލުމެއް ނެތް.",
      "analysisTitle": "ސަބަބާއި އައުޓްލެޓާއި ޝިފްޓުން އުކާލުން",
      "caption": "އައުޓްލެޓުން ގެއްލުން",
      "chooseAPeriod": "ރިޕޯޓް ހިންގުމަށް މުއްދަތެއް ނަގާ.",
      "countedAsShrinkage": "ގެއްލުމުގެ ގޮތުގައި ގުނި",
      "description": "ރާވާފައިވާ މިންވަރަށްވުރެ ގިނައިން ގެއްލެނީތޯ، އަދި ކޮންތާކުންތޯ؟",
      "empty": "މި މުއްދަތުގައި ދޫކުރުމެއް ނެތް.",
      "issuesValue": "ދޫކުރި",
      "loadFailed": "ގެއްލުމުގެ ރިޕޯޓް ލޯޑެއް ނުވި",
      "notCountedAsShrinkage": "ގެއްލުމުގެ ގޮތުގައި ނުގުނާ",
      "overTarget": "އަމާޒުން މައްޗަށް",
      "pct": "ގެއްލުން %",
      "shrinkageValue": "ގެއްލުން",
      "tableTitle": "އަމާޒާ އަޅާކިޔައި ގެއްލުން",
      "target": "އަމާޒު %",
      "title": "ގެއްލުން",
      "verdict": "ނަތީޖާ",
      "withinTarget": "އަމާޒުގެ ތެރޭގައި"
    },
    "storageClass": {
      "ambient": "އާދައިގެ ފިނިހޫނުމިން",
      "bonded": "ބޮންޑެޑް",
      "chilled": "ފިނިކުރި",
      "dry": "ހިކި",
      "frozen": "ގަނޑުކުރި",
      "hazardous": "ނުރައްކާތެރި",
      "secure": "ރައްކާތެރި"
    },
    "substitutes": {
      "applies": {
        "both": "ދެ ގޮތަށްވެސް",
        "outbound": "ބޭރަށް",
        "production": "އުފެއްދުން"
      },
      "appliesHints": {
        "outbound": "ކަސްޓަމަރުގެ އޯޑަރު އެކަނި.",
        "production": "ބަދިގެއާއި އުފެއްދުން އެކަނި."
      },
      "appliesTo": "ހިނގާ ދާއިރާ",
      "approval": "ފާސްކުރުން",
      "caption": "ބާވަތުގެ ބަދަލުތައް",
      "create": "އައު ބަދަލެއް",
      "delete": "ބަދަލު ނަގާ",
      "deleteFailed": "ބަދަލު ނުނެގުނު",
      "description": "ކޮން އެއްޗެއްގެ ބަދަލުގައި ކޮން އެއްޗެއް، އަދި ކޮންތާކު.",
      "dialogDescription": "ފުށުގެ ބަދަލެއް ބަދިގޭގައި ރަނގަޅުވިޔަސް، ކަސްޓަމަރުގެ އޯޑަރުގައި ގޯސްވެދާނެއެވެ.",
      "empty": "ބަދަލެއް ކަނޑައަޅާފައެއް ނުވޭ.",
      "everyWarehouse": "ހުރިހާ ގުދަނެއް",
      "factor": "ފެކްޓަރު",
      "factorExplainer": "އަސްލުގެ އެކަކަށް ބޭނުންވާ ބަދަލުގެ ޔުނިޓު އަދަދު.",
      "factorHint": "×{factor}، އިސްކަން {preference}",
      "link": "ބަދަލުތައް",
      "loadFailed": "ބަދަލުތައް ލޯޑެއް ނުވި",
      "needsApproval": "ފާސްކުރަން ޖެހޭ",
      "needsApprovalHint": "މި ގަވާއިދުގެ ދަށުން ފާސްކުރާ ފަރާތެއް ނެތި ބަދަލެއް ބަލައެއް ނުގަނެއެވެ.",
      "notSelf": "ބާވަތެއް އޭގެ އަމިއްލަ ބަދަލަކަށް ނުވެވޭނެއެވެ.",
      "original": "އަސްލު",
      "preference": "އިސްކަން",
      "preferenceHint": "ކުޑަ އަދަދު ފުރަތަމަ ދައްކާ.",
      "saveFailed": "ބަދަލު ރައްކާނުކުރެވުނު",
      "saved": "ބަދަލު ރައްކާކުރެވިއްޖެ",
      "substitute": "ބަދަލު",
      "tableTitle": "ބަދަލުތަކުގެ މާސްޓަރ",
      "title": "ބަދަލުތައް",
      "warehouseHint": "ހުސްކޮށް ބާއްވައިފިނަމަ ހުރިހާ ތަނަކަށް."
    },
    "transferStatus": {
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "draft": "ދެލިކޮޕީ",
      "inTransitOverdue": "މަގުމަތީގައި — ލަސްވެފައި",
      "in_transit": "މަގުމަތީގައި",
      "received": "ލިބިފައި"
    },
    "usageVariance": {
      "actual": "ހަގީގަތް",
      "actualQty": "ހަގީގީ ޢަދަދު",
      "closing": "ނިމުން",
      "compute": "ހިސާބުކުރޭ",
      "computeFailed": "ރަން ހިސާބެއް ނުކުރެވުނު",
      "computeTitle": "ރަނެއް ހިސާބުކުރޭ",
      "computed": "ރަން ހިސާބުކުރެވިއްޖެ",
      "description": "ރެސިޕީން ބުނާ މިންވަރާއި، ހަގީގަތުގައި ދިޔަ މިންވަރު.",
      "detailDescription": "ފަސް މަސްދަރަކުން ފަސް އަދަދު؛ އެއިން ތަފާތާ ބެހޭގޮތުން ބަހުސްކުރެވޭނެއެވެ.",
      "detailTitle": "ރަނުގެ ތަފްސީލު",
      "identity": "ހަގީގަތް = ފެށުން + ލިބުނު − ނިމުން        ތަފާތު = ހަގީގަތް − ނަޒަރީ − އުކާލި",
      "linesCaption": "ބޭނުންކުރުމުގެ ތަފާތުގެ ސަފުތައް",
      "linesEmpty": "މި ރަނުގައި ސަފެއް ނެތް.",
      "link": "ބޭނުންކުރުމުގެ ތަފާތު",
      "loadFailed": "ރަންތައް ލޯޑެއް ނުވި",
      "openMeaning": "ނިމުމުގެ ގުނުމަކުން ހަގީގަތުގެ ބައި އަދި ކަނޑައެޅިފައެއް ނުވެއެވެ؛ އެހެންކަމުން މާނަހުރީ ނަޒަރީ އަދަދުތަކުގައި އެކަންޏެވެ.",
      "opening": "ފެށުން",
      "period": "މުއްދަތު",
      "received": "ލިބުނު",
      "runsCaption": "ބޭނުންކުރުމުގެ ތަފާތުގެ ރަންތައް",
      "runsEmpty": "ރަނެއް އަދި ނެތް.",
      "runsTitle": "ރަންތައް",
      "status": {
        "closed": "ބަންދު",
        "open": "ހުޅުވިފައި"
      },
      "theoretical": "ނަޒަރީ",
      "theoreticalQty": "ނަޒަރީ ޢަދަދު",
      "title": "ނަޒަރީއާއި ހަގީގަތް",
      "variancePct": "ތަފާތު %",
      "varianceValue": "ތަފާތުގެ އަގު",
      "wasteQty": "އުކާލި"
    },
    "waste": {
      "addLine": "ސަފެއް އިތުރުކުރޭ",
      "approveFailed": "އުކާލުން ފާހެއް ނުކުރެވުނު",
      "approved": "އުކާލުން ފާސްކުރެވިއްޖެ",
      "caption": "އުކާލުމުގެ ރެކޯޑުތައް",
      "category": "ބާވަތް",
      "costNote": "އަގަކީ ސާވަރުގެ އަދަދެވެ: އުކާލެވެނީ ބާވަތުގެ މިހާރުގެ އެވްރެޖް ނުވަތަ ފީފޯ އަގުގައެވެ.",
      "countsTowardShrinkage": "މި ސަބަބު ގެއްލުމުގެ އަމާޒަށް ގުނައެވެ.",
      "description": "ހަލާކުވުން، ތެޅުން އަދި މުވައްޒަފުންގެ ބޭނުންކުރުން؛ ސަބަބާއި އައުޓްލެޓާއި ޝިފްޓުން.",
      "doesNotCountTowardShrinkage": "މި ސަބަބު ގެއްލުމުގެ އަމާޒަކަށް ނުގުނައެވެ. މުވައްޒަފުންގެ ކެއުމަކީ ރާވައިގެން ކުރާ ކަމެކެވެ؛ ގެއްލުމެއް ނޫނެވެ.",
      "empty": "އުކާލުމެއް ރެކޯޑްކޮށްފައެއް ނުވޭ.",
      "isShrinkage": "ގުނާ",
      "linesCaption": "އުކާލި ސަފުތައް",
      "loadFailed": "އުކާލުމުގެ ރެކޯޑުތައް ލޯޑެއް ނުވި",
      "needsApproval": "މި ސަބަބަށް ޕޯސްޓްވުމުގެ ކުރިން ފާސްކުރުމެއް ބޭނުންވެއެވެ.",
      "needsAttachment": "މި ސަބަބަށް ފައިލެއް ބޭނުންވެއެވެ.",
      "notShrinkage": "ނުގުނާ",
      "qtyAria": "ޢަދަދު، ސަފު {line}",
      "reason": "ސަބަބު",
      "record": "އުކާލުން ލިޔޭ",
      "recordDescription": "ސަބަބުން ނިންމަނީ އެކައުންޓާއި، ފާސްކުރުމާއި، ގެއްލުމުގެ ގޮތުގައި ގުނާނެތޯއެވެ.",
      "recordFailed": "އުކާލުން ރެކޯޑެއް ނުކުރެވުނު",
      "recorded": "އުކާލުން ރެކޯޑްކުރެވިއްޖެ",
      "recordedOn": "ލިޔުނު ތާރީޚު",
      "rejectDefaultReason": "ފާސްކުރާ ފަރާތުން ރައްދުކުރި",
      "rejectFailed": "އުކާލުން ރައްދެއް ނުކުރެވުނު",
      "rejected": "އުކާލުން ރައްދުކުރެވިއްޖެ",
      "removeLine": "ސަފު {line} ނަގާ",
      "shiftHint": "ސަބަބު × އައުޓްލެޓް × ޝިފްޓް ރިޕޯޓުގައި ބޭނުންކުރެއެވެ.",
      "shrinkage": "ގެއްލުން",
      "shrinkageLink": "ގެއްލުމުގެ ރިޕޯޓް",
      "sodRefusal": "އުކާލުން ލިޔުނު މީހާއަށް އެ ފާހެއް ނުކުރެވޭނެއެވެ.",
      "tableTitle": "އުކާލުމުގެ ރެކޯޑުތައް",
      "title": "އުކާލުން"
    },
    "wasteCategory": {
      "breakage": "ތެޅުން",
      "complimentary": "ހިލޭ ދިން",
      "expiry": "މުއްދަތު ހަމަވުން",
      "over_production": "މާގިނައިން އުފެއްދުން",
      "preparation": "ތައްޔާރުކުރުން",
      "spoilage": "ހަލާކުވުން",
      "staff_meal": "މުވައްޒަފުންގެ ކެއުން",
      "theft": "ވައްކަން",
      "training": "ތަމްރީނު"
    },
    "wasteStatus": {
      "draft": "ދެލިކޮޕީ",
      "pending_approval": "ފާސްކުރުމަށް",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "rejected": "ރައްދުކުރެވިފައި"
    },
    "wms": {
      "description": "ޒޯނުތަކާއި ބިންތަކާއި އެތަންތަނުގައި ބަހައްޓާ ބާވަތްތައް. ސްޓޯރޭޖް ކްލާހާއި ޖާގަ ބޭނުންކުރަނީ ޕުޓްއަވޭ ޕްލޭނަރެވެ.",
      "title": "ގުދަނުގެ ތަރުތީބު"
    },
    "yes": "އާދެ",
    "zones": {
      "caption": "ގުދަނުގެ ޒޯނުތައް",
      "create": "އައު ޒޯން",
      "delete": "ޒޯން ފޮހެލާ",
      "deleteFailed": "ޒޯން ފޮހެލެވޭގޮތެއް ނުވި",
      "deleted": "ޒޯން ފޮހެލެވިއްޖެ",
      "description": "ޒޯނަކުން ސްޓޯރޭޖް ކްލާހަކާއި ނެގުމުގެ ތަރުތީބެއް ދެއެވެ. ގަނޑުކުރި ބާވަތެއް އާދައިގެ ބިނަކަށް ބަލައެއް ނުގަނެއެވެ.",
      "dialogDescription": "ސްޓޯރޭޖް ކްލާހާއި ފިނިހޫނުމިނުގެ ދާއިރާ ބޭނުންކުރަނީ ޕުޓްއަވޭ ޕްލޭނަރާއި ހެކްޕް ޗެކްޕޮއިންޓެވެ.",
      "edit": "ޒޯން އުނިއިތުރު",
      "empty": "ޒޯނެއް ނެތް — ސްޓޯރޭޖް ކްލާހުން ބިންތައް ގްރޫޕްކުރަން އެއް އިތުރުކުރޭ.",
      "loadFailed": "ޒޯނުތައް ލޯޑެއް ނުވި",
      "maxTemp": "އެންމެ މަތި °C",
      "minTemp": "އެންމެ ދަށް °C",
      "pickSequence": "ނެގުމުގެ ތަރުތީބު",
      "pickSequenceHint": "ކުޑަ އަދަދު ފުރަތަމަ.",
      "saveFailed": "ޒޯން ރައްކާނުކުރެވުނު",
      "saved": "ޒޯން ރައްކާކުރެވިއްޖެ",
      "storageClass": "ސްޓޯރޭޖް ކްލާސް",
      "storageClassHint": "މި ޒޯނުގެ ބިންތަކުން ދޭ ކްލާސް. އެހެން ކްލާހެއް ބޭނުންވާ ބާވަތެއް ބަލައެއް ނުގަނެއެވެ.",
      "tempHint": "ބަލަހައްޓާ ނުޖެހޭނަމަ ހުސްކޮށް ބާއްވާ.",
      "temperature": "ފިނިހޫނުމިން",
      "title": "ޒޯނުތައް",
      "unmonitored": "ބަލަހައްޓާ ނުޖެހޭ",
      "unzoned": "ޒޯނެއް ނެތް",
      "zone": "ޒޯން"
    }
  },
  "procurement": {
    "routeTitles": {
      "requisitions": "ގަތުމުގެ ރެކުއިޒިޝަންތައް",
      "requisitionNew": "New ގަތުމުގެ ރެކުއިޒިޝަން",
      "requisition": "ގަތުމުގެ ރެކުއިޒިޝަން",
      "rfqs": "އަގު ހުށަހެޅުމަށް އެދުންތައް",
      "rfqNew": "New އަގު ހުށަހެޅުމަށް އެދުން",
      "rfq": "އަގު ހުށަހެޅުމަށް އެދުން",
      "orders": "ގަތުމުގެ އޯޑަރުތައް",
      "orderNew": "New ގަތުމުގެ އޯޑަރު",
      "order": "ގަތުމުގެ އޯޑަރު",
      "receipts": "މުދާ ލިބުނު ރަސީދުތައް",
      "receiptNew": "ތަކެތި ބަލައިގަތުން",
      "receipt": "މުދާ ލިބުނު ރަސީދު",
      "matches": "ތިން ފަރާތުގެ މެޗްތައް",
      "matchNew": "Run a ތިން ފަރާތުގެ މެޗް",
      "match": "ތިން ފަރާތުގެ މެޗް",
      "grIrAging": "GR-IR ޢުމުރު",
      "scorecards": "ސަޕްލަޔަރު ސްކޯކާޑްތައް",
      "settings": "Procurement ސެޓިންގތައް"
    },
    "filtersTitle": "ފިލްޓަރތައް",
    "allCompanies": "ހުރިހާ ކުންފުނިތައް",
    "allVendors": "All ސަޕްލަޔަރުން",
    "export": {
      "done": "އެކްސްޕޯޓްކޮށްފި",
      "doneDetail": "{count} ސަތުރުތައް written to a ސީއެސްވީ ފައިލް.",
      "failed": "އެ އެކްސްޕޯޓެއް ނުހިނގި"
    },
    "blockers": {
      "noCompany": "ޚިޔާރުކުރޭ the ކުންފުނި this is for.",
      "noVendor": "ޚިޔާރުކުރޭ the ސަޕްލަޔަރު this އޯޑަރު goes to.",
      "noDate": "Give the ތާރީޚް މި ލިޔުން is dated.",
      "noCurrency": "Give a three-letter ފައިސާ ކޯޑު.",
      "noLines": "މަދުވެގެން އެއް ސަޠުރު އިތުރުކުރޭ.",
      "lineIssues": "މަތީގައި ފާހަގަކޮށްފައިވާ ސަޠުރުތައް ރަނގަޅުކުރޭ.",
      "zeroTotal": "This comes to nothing. Give a ޢަދަދު and a price."
    },
    "chain": {
      "label": "ގަތުމުން ފައިސާ ދެއްކުމާ ހަމައަށް",
      "notYet": "އަދި ނެތް",
      "draft": "ދެލިކޮޕީ",
      "count": "+{count}",
      "hopLabel": "{stage}, {label}, {state}",
      "hopLink": "{stage} {label}",
      "stages": {
        "pr": "ރެކުއިޒިޝަން",
        "rfq": "އަގު ހޯދުން",
        "po": "އޯޑަރު",
        "grn": "ރަސީދު",
        "inv": "އިންވޮއިސް",
        "pay": "ފައިސާ ދެއްކުން"
      },
      "states": {
        "none": "ނުފެށޭ",
        "open": "ހުޅުވިފައި",
        "partial": "part ނިމިއްޖެ",
        "done": "ނިމިއްޖެ",
        "disputed": "ދެބަސްވެފައި"
      },
      "scoped": {
        "pr": "ރެކުއިޒިޝަންތައް",
        "rfq": "އަގު ހުށަހެޅުން rounds",
        "po": "އޯޑަރުތައް",
        "grn": "ރަސީދުތައް",
        "inv": "އިންވޮއިސްތައް",
        "pay": "ފައިސާ ދެއްކުން ރަންތައް"
      },
      "next": {
        "pr": "ދެން: raise a ރެކުއިޒިޝަން.",
        "rfq": "ދެން: run a އަގު ހުށަހެޅުން round, or އޯޑަރު directly.",
        "po": "ދެން: raise the ގަތުމުގެ އޯޑަރު this authorises.",
        "grn": "ދެން: receive the goods when they arrive.",
        "inv": "ދެން: މެޗް the ސަޕްލަޔަރު's އިންވޮއިސް އާ ދެކޮޅަށް this އޯޑަރު and its ރަސީދުތައް.",
        "pay": "ދެން: pay the މެޗްކުރެވިފައި އިންވޮއިސް through a ފައިސާ ދެއްކުމުގެ ރަން."
      }
    },
    "budget": {
      "label": "{available} ލިބެންހުރި, this line asks for {requested}",
      "exceededLabel": "Only {available} ލިބެންހުރި and this line asks for {requested}",
      "availableSuffix": "ބާކީ",
      "exceeded": "Over ބަޖެޓް",
      "unbudgeted": "No ބަޖެޓް set for މި އެކައުންޓް",
      "none": "No ބަޖެޓް",
      "pending": "ބަޖެޓް ޗެކްނުކުރޭ yet",
      "checking": "ޔަގީންކުރަނީ ބަޖެޓް…",
      "noPermission": "ބަޖެޓް check unavailable — ތިޔަ ފަރާތް do not hold ބަޖެޓް.check",
      "noModule": "No ބަޖެޓް މޮޑެލް is configured for this ކުންފުނި"
    },
    "lines": {
      "prTitle": "What is being އެދިފައި",
      "poTitle": "އޯޑަރުކުރާ ތަކެތި",
      "prCaption": "ރެކުއިޒިޝަން lines: item, އެކައުންޓް, ޢަދަދު, އަންދާޒާ price and the ބަޖެޓް each line consumes.",
      "poCaption": "އޯޑަރު lines: item, އެކައުންޓް, ގުދަން, ޢަދަދު, price, and what has been ލިބުނު and މެޗްކުރެވިފައި.",
      "columns": {
        "no": "#",
        "item": "ތަކެތި",
        "description": "ތަފްޞީލު",
        "account": "އެކައުންޓް",
        "dimensions": "ޑައިމެންޝަން",
        "needBy": "ބޭނުންވާ ތާރީޚް",
        "quantity": "ޢަދަދު",
        "uom": "ޔުނިޓް",
        "estimatedPrice": "އަންދާޒާ އަގު",
        "unitPrice": "ޔުނިޓް އަގު",
        "amount": "އަދަދު",
        "budget": "ބަޖެޓް",
        "warehouse": "ގުދަން",
        "taxCode": "ޓެކްސް",
        "received": "ލިބުނު",
        "matched": "މެޗްކުރެވިފައި",
        "grIrRemaining": "GR-IR ގައި",
        "rowActions": "ސަޠުރުގެ އަމަލުތައް"
      },
      "actions": {
        "add": "ސަޠުރެއް އިތުރުކުރޭ",
        "duplicate": "ކޮޕީކުރޭ this line",
        "remove": "މި ސަޠުރު ނަގާ",
        "closeLine": "މި ސަޠުރު ކުރިއަށް ނުގޮސް ބަންދުކުރޭ",
        "closeLineShort": "ބަންދުކުރޭ"
      },
      "aria": {
        "item": "ސަޠުރު {line} ގެ ތަކެތި",
        "description": "ތަފްޞީލު on line {line}",
        "account": "އެކައުންޓް on line {line}",
        "needBy": "ސަޠުރު {line} ބޭނުންވާ ތާރީޚް",
        "quantity": "ޢަދަދު on line {line}",
        "unitPrice": "ޔުނިޓް އަގު on line {line}",
        "warehouse": "ގުދަން on line {line}",
        "taxCode": "ޓެކްސް ކޯޑު on line {line}",
        "duplicate": "ކޮޕީކުރޭ line {line}",
        "remove": "ސަޠުރު {line} ނަގާ",
        "closeLine": "ސަޠުރު {line} ކުރިއަށް ނުގޮސް ބަންދުކުރޭ",
        "adoptLastPrice": "Use the last price ދައްކާފައި, {price}, on line {line}"
      },
      "issues": {
        "invalidQuantity": "އެއީ ޢަދަދެއް ނޫން.",
        "invalidPrice": "އެއީ ޢަދަދެއް ނޫން.",
        "negativeQuantity": "A ޢަދަދު cannot be negative.",
        "zeroQuantity": "Give a ޢަދަދު above zero.",
        "negativePrice": "އަގަކީ މައިނަސް ޢަދަދަކަށް ނުވެވޭނެއެވެ.",
        "noAccount": "ޚިޔާރުކުރޭ the އެކައުންޓް this is ޗާޖްކުރެވިފައި to.",
        "notPostable": "{account} is a ސުރުޚީ, not an އެކައުންޓް ތިޔަ ފަރާތް can charge.",
        "inactive": "{account} މިހާރު ބޭނުމެއް ނުކުރެވެއެވެ.",
        "noDescription": "Say what this is, or ޚިޔާރުކުރޭ a ކެޓަލޮގް އައިޓަމް.",
        "notReceivable": "ޚިޔާރުކުރޭ a ގުދަން, or this line cannot be ލިބުނު.",
        "needByInPast": "That ތާރީޚް has passed."
      },
      "estimatedTotal": "އަންދާޒާ ޖުމްލަ",
      "orderSubtotal": "އޯޑަރު ސަބްޓޯޓަލް",
      "keyboardHint": "Enter އިން ސަޠުރެއް އިތުރުވޭ · Alt+↓ އިން ކޮޕީވޭ · Alt+Backspace އިން ނަގައިދޭ",
      "lastPaid": "އެންމެފަހުން ދެއްކި {price}",
      "itemPlaceholder": "ތަކެތި، ނުވަތަ އަމިއްލައަށް ލިޔުމަށް ހުސްކޮށް ބާއްވާ",
      "itemRetired": "ބޭނުންކުރުމުން ހުއްޓާލާފައި",
      "itemService": "ޚިދުމަތް",
      "noItemMatch": "No ކެޓަލޮގް އައިޓަމް މެޗްތައް. Leave it empty and describe it instead.",
      "matchCount": "{count} items މެޗް",
      "noWarehouse": "No ގުދަން",
      "noTaxCode": "ޓެކްސް ނެތް"
    },
    "pr": {
      "listTitle": "ގަތުމުގެ ރެކުއިޒިޝަންތައް",
      "listDescription": "Requests to buy, ކުރިން anybody has ކޮމިޓްކޮށްފައި to a ސަޕްލަޔަރު.",
      "title": "ރެކުއިޒިޝަން {docNo}",
      "newTitle": "New ރެކުއިޒިޝަން",
      "draftTitle": "ދެލިކޮޕީ",
      "description": "Say what ތިޔަ ފަރާތް need and when. Approval sets the money aside; it does not އޯޑަރު anything.",
      "headerTitle": "ރެކުއިޒިޝަން",
      "backToList": "All ރެކުއިޒިޝަންތައް",
      "loadFailed": "That ރެކުއިޒިޝަން did not load",
      "emptyTitle": "No ގަތުމުގެ ރެކުއިޒިޝަންތައް yet",
      "emptyDescription": "Raise one to ask for something to be bought — it goes for approval ކުރިން any ސަޕްލަޔަރު is involved.",
      "searchHint": "ރެކުއިޒިޝަން number or މެމޯ",
      "mineOnly": "ހަމައެކަނި އަހަރެންގެ",
      "estimatedLabel": "އަންދާޒާ",
      "actionsLabel": "ރެކުއިޒިޝަން އަމަލުތައް",
      "submitting": "ހުށަހަޅަނީ",
      "readyToSubmit": "Ready to ފާސްކުރުމަށް ހުށަހަޅާ.",
      "railSubtitle": "{status} · އުފެއްދި by {requester}",
      "stale": "Somebody else saved this ރެކުއިޒިޝަން while it was open. Nothing has been lost — reload it, look at their ވަރޝަން, and ބޭނުންކުރޭ your edits again.",
      "reload": "Reload the saved ވަރޝަން",
      "locked": {
        "submitted": "This ރެކުއިޒިޝަން is އިންތިޒާރުގައި for approval and cannot be edited. ބޭރުކުރޭ it to send it ފަހަތަށް for changes.",
        "approved": "This ރެކުއިޒިޝަން is ފާސްކުރެވިއްޖެ and its ބަޖެޓް is ކޮމިޓްކޮށްފައި. Raise an އޯޑަރު އާ ދެކޮޅަށް it, or close it to ދޫކޮށްލާ the ކޮމިޓްމަންޓް.",
        "closed": "Everything on this ރެކުއިޒިޝަން has been ordered.",
        "cancelled": "This ރެކުއިޒިޝަން was ކެންސަލްކުރެވިފައި."
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "މަޑުކުރަނީ ފާސްކުރުން",
        "approved": "ފާސްކުރެވިއްޖެ",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "closed": "ބަންދު",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "columns": {
        "docNo": "ރެކުއިޒިޝަން",
        "requester": "އެދިފައި by",
        "needBy": "ބޭނުންވާ ތާރީޚް",
        "lines": "ސަޠުރުތައް",
        "currency": "ފައިސާ",
        "total": "އަންދާޒާ ޖުމްލަ"
      },
      "fields": {
        "company": "ކުންފުނި",
        "companyPlaceholder": "ޚިޔާރުކުރޭ the ކުންފުނި this is for",
        "needBy": "ބޭނުންވާ ތާރީޚް",
        "needByHint": "When it has to be here. Buyers work to this ތާރީޚް.",
        "currency": "ފައިސާ",
        "currencyHint": "The ކުންފުނީގެ އަސާސީ ފައިސާ is {base}.",
        "department": "ޑިޕާޓްމަންޓް",
        "departmentHint": "ކޮންމެ ސަޠުރަކަށް ޑިފޯލްޓްކޮށް އެޅެއެވެ؛ ސަޠުރަކުން އެހެން ގޮތެއް ކަނޑައެޅިދާނެއެވެ.",
        "costCenter": "ކޮސްޓް ސެންޓަރ",
        "costCenterHint": "Which ބަޖެޓް this is ޗާޖްކުރެވިފައި އާ ދެކޮޅަށް.",
        "branch": "ގޮފި",
        "memo": "މިއީ ބޭނުންވާ ސަބަބު",
        "memoHint": "The ފާސްކުރާ ފަރާތް reads this ކުރިން they read the lines.",
        "requester": "އުފެއްދި by",
        "subtotal": "ސަބްޓޯޓަލް",
        "total": "އަންދާޒާ ޖުމްލަ",
        "approvedAt": "ފާސްކުރެވިއްޖެ"
      },
      "actions": {
        "save": "ދެލިކޮޕީ ރައްކާކުރޭ",
        "submit": "ފާސްކުރުމަށް ހުށަހަޅާ",
        "approve": "ފާސްކުރޭ",
        "reject": "ބޭރުކުރޭ",
        "cancel": "ކެންސަލްކުރޭ ރެކުއިޒިޝަން",
        "close": "Close ރެކުއިޒިޝަން",
        "discard": "ދެލިކޮޕީ އުކާލާ",
        "print": "ޕްރިންޓްކުރޭ",
        "raiseOrder": "Raise a ގަތުމުގެ އޯޑަރު",
        "raiseRfq": "Ask ސަޕްލަޔަރުން to އަގު ހުށަހެޅުން"
      },
      "reject": {
        "title": "ބޭރުކުރޭ this ރެކުއިޒިޝަން",
        "description": "It goes ފަހަތަށް to the person who އުފެއްދި it, with your ކޮމެންޓް.",
        "consequence": "ބޭރުކުރަނީ does not ފޮހެލާ anything. The ރެކުއިޒިޝަން returns to ދެލިކޮޕީ and can be corrected and ހުށަހެޅި again.",
        "commentLabel": "ސަބަބު",
        "commentHint": "The އެދުނު ފަރާތް sees this. Say what would make it approvable."
      },
      "cancel": {
        "title": "ކެންސަލްކުރޭ this ރެކުއިޒިޝަން",
        "description": "It stays on the ރެކޯޑް, marked ކެންސަލްކުރެވިފައި.",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "Recorded on the އޮޑިޓް ރެކޯޑް."
      },
      "close": {
        "title": "Close this ރެކުއިޒިޝަން",
        "description": "Nothing further will be ordered އާ ދެކޮޅަށް it.",
        "releasesCommitment": "This releases the ބަޖެޓް still set aside for this ރެކުއިޒިޝަން. Money nobody is going to spend goes ފަހަތަށް to the ޑިޕާޓްމަންޓް."
      },
      "timeline": {
        "created": "އުފެއްދި",
        "submitted": "ހުށަހެޅި as {docNo}",
        "approved": "ފާސްކުރެވިއްޖެ — ބަޖެޓް ކޮމިޓްކޮށްފައި",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "closed": "ބަންދު"
      },
      "shortcuts": {
        "save": "ރައްކާކުރޭ this ރެކުއިޒިޝަން"
      },
      "unsavedGuard": {
        "title": "ރައްކާނުކުރާ ބަދަލުތައް ދޫކޮށްލާނަންތޯ؟",
        "message": "This ރެކުއިޒިޝަން has ބަދަލުތައް that have not been ރައްކާކުރެވިފައި. Leaving now discards them.",
        "confirm": "ބަދަލުތައް ދޫކޮށްލާ",
        "cancel": "އިތުރަށް އެޑިޓްކުރޭ"
      },
      "toasts": {
        "saved": "ރެކުއިޒިޝަން saved",
        "savedDetail": "Still a ދެލިކޮޕީ. ހުށަހަޅާ it when it is ready.",
        "saveFailed": "That did not ރައްކާކުރޭ",
        "submitted": "ހުށަހެޅި as {docNo}",
        "submittedDetail": "It is now with its ފާސްކުރާ ފަރާތްތައް.",
        "submitFailed": "That did not ހުށަހަޅާ",
        "approved": "ރެކުއިޒިޝަން ފާސްކުރެވިއްޖެ",
        "approvedDetail": "Its ބަޖެޓް is now ކޮމިޓްކޮށްފައި. Raise an އޯޑަރު to spend it.",
        "rejected": "ރެކުއިޒިޝަން ބޭރުކުރެވިއްޖެ",
        "rejectedDetail": "It has gone ފަހަތަށް to the person who އުފެއްދި it.",
        "decideFailed": "That decision did not ރައްކާކުރޭ",
        "cancelled": "ރެކުއިޒިޝަން ބަންދު",
        "cancelledDetail": "Any ބަޖެޓް still ކޮމިޓްކޮށްފައި has been ދޫކޮށްލާފައި.",
        "cancelFailed": "އެ ބަންދެއް ނުވި",
        "discarded": "ދެލިކޮޕީ އުކާލެވިއްޖެ",
        "discardedDetail": "Nothing was ހުށަހެޅި, so nothing was lost.",
        "discardFailed": "އެ އުކައެއް ނުލެވުނު"
      }
    },
    "rfq": {
      "listTitle": "އަގު ހުށަހެޅުމަށް އެދުންތައް",
      "listDescription": "Ask several ސަޕްލަޔަރުން for a price, then compare what came ފަހަތަށް.",
      "title": "އަގު ހޯދުން {docNo}",
      "newTitle": "New އަގު ހުށަހެޅުމަށް އެދުން",
      "draftTitle": "ދެލިކޮޕީ",
      "description": "ފޮނުވާ to ސަޕްލަޔަރުން, ރެކޯޑް what they އަގު ހުށަހަޅާފައި, compare on the ބުރަދަންތައް ތިޔަ ފަރާތް set, and ދިނުން.",
      "backToList": "ހުރިހާ އަގު ހޯދުންތައް",
      "loadFailed": "އެ އަގު ހޯދުން ލޯޑެއް ނުވި",
      "emptyTitle": "No އަގު ހުށަހެޅުން rounds yet",
      "emptyDescription": "Start one from an ފާސްކުރެވިއްޖެ ރެކުއިޒިޝަން to ask several ސަޕްލަޔަރުން for a price ކުރިން committing.",
      "createTitle": "Set up the އަގު ހުށަހެޅުން round",
      "createDescription": "The ބުރަދަންތައް decide the recommendation, and they cannot be changed އެއްފަހަރު ސަޕްލަޔަރުން have އަގު ހުށަހަޅާފައި.",
      "createBlocked": "ޚިޔާރުކުރޭ at least one ސަޕްލަޔަރު, and make the ބުރަދަންތައް sum to 100.",
      "suppliersTitle": "ދައުވަތު ދެވިފައި ސަޕްލަޔަރުން",
      "linesTitle": "What is being އަގު ހުށަހަޅާފައި for",
      "comparisonTitle": "އަޅާކިޔުން",
      "comparisonDescription": "Every live އަގު ހުށަހެޅުން, scored on the ބުރަދަންތައް above. The މަސައްކަތްކުރަނީ is shown for each.",
      "comparisonFailed": "އަޅާކިޔުން ލޯޑެއް ނުވި",
      "comparisonCaption": "އަގު ހުށަހެޅުންތައް compared on price, ލިބޭ މުއްދަތު and ޝަރުތުތައް, with each criterion's contribution to the ބުރަދަން ދެވިފައިވާ ސްކޯ.",
      "whyCaption": "How {vendor}'s ބުރަދަން ދެވިފައިވާ ސްކޯ is made up",
      "noQuotes": "No ސަޕްލަޔަރު has އަގު ހުށަހަޅާފައި yet.",
      "recommended": "ހުށަހަޅާ",
      "relativeNote": "Price and lead-time scores are relative to the އަގު ހުށަހެޅުންތައް ލިބުނު: the cheapest scores 100 and the dearest 0. ޝަރުތުތައް are rated by the buyer.",
      "weightsSummary": "Weighted on price {price}%, ލިބޭ މުއްދަތު {leadTime}%, ޝަރުތުތައް {terms}%.",
      "term": "{score} × {weight}%",
      "termsDefaulted": "(ދަރަޖަ ނުދޭ — މެދުމިން)",
      "days": "{days} ދުވަސް",
      "quotedOf": "{invited} ން {quoted}",
      "fromRequisition": "އަގު ހުށަހެޅުން round for ރެކުއިޒިޝަން {docNo}",
      "railSubtitle": "{status} · {suppliers} ސަޕްލަޔަރުން ދައުވަތު ދެވިފައި",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "issued": "ފޮނުވިފައި",
        "closed": "ބަންދު",
        "awarded": "ދެވިފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "supplierStatuses": {
        "invited": "ދައުވަތު ދެވިފައި",
        "quoted": "އަގު ހުށަހަޅާފައި",
        "declined": "ދޫކޮށްލައިފި"
      },
      "criteria": {
        "price": "އަގު",
        "leadTime": "ލިބޭ މުއްދަތު",
        "terms": "ޝަރުތުތައް"
      },
      "columns": {
        "docNo": "އަގު ހޯދުން",
        "memo": "މައުޟޫޢު",
        "dueDate": "އަގު ހުށަހެޅުންތައް މުއްދަތު",
        "responses": "އަގު ހުށަހަޅާފައި",
        "supplier": "ސަޕްލަޔަރު",
        "total": "ޖުމްލަ އަގު ހުށަހަޅާފައި",
        "leadTime": "ލިބޭ މުއްދަތު",
        "terms": "ޝަރުތުތައް",
        "why": "How the ސްކޯ is made up",
        "score": "ބުރަދަން ދެވިފައިވާ ސްކޯ",
        "award": "ދިނުން"
      },
      "fields": {
        "dueDate": "އަގު ހުށަހެޅުންތައް މުއްދަތު by",
        "dueDateHint": "Shown to ސަޕްލަޔަރުން. އަގު ހުށަހެޅުންތައް ފަހުން it are still accepted.",
        "currency": "ފައިސާ",
        "suppliers": "ސަޕްލަޔަރުން to ask",
        "suppliersHint": "A ބްލޮކްކުރެވިފައި ސަޕްލަޔަރު cannot be ދައުވަތު ދެވިފައި.",
        "weights": "How the އަގު ހުށަހެޅުންތައް are weighed",
        "weightsHint": "އިންސައްތައިން، އަދި ޖުމްލަ 100 އަށް ވާންޖެހެއެވެ. ހުށަހަޅާ ފަރާތް ކަނޑައަޅަނީ މިއިންނެވެ.",
        "weightsMustSum": "The three ބުރަދަންތައް must sum to 100.",
        "memo": "މި ބުރު ބާއްވަނީ ކޮންކަމަކަށްކަން",
        "issuedAt": "ފޮނުވިފައި",
        "awardedTo": "ދެވިފައި to"
      },
      "actions": {
        "create": "އުފައްދާ the RFQ",
        "invite": "Invite ސަޕްލަޔަރުން",
        "issue": "ފޮނުވާ to ސަޕްލަޔަރުން",
        "recordQuote": "ރެކޯޑް a އަގު ހުށަހެޅުން",
        "award": "ދިނުން",
        "evaluate": "ޓެންޑަރު ވަޒަންކޮށް އެވޯޑްކުރޭ"
      },
      "invite": {
        "title": "Invite more ސަޕްލަޔަރުން",
        "description": "They are އިތުރުކުރި to this round and can އަގު ހުށަހެޅުން އެއްފަހަރު it is ފޮނުވިފައި."
      },
      "quote": {
        "title": "ރެކޯޑް a ސަޕްލަޔަރު's އަގު ހުށަހެޅުން",
        "description": "What they told ތިޔަ ފަރާތް. Until the ސަޕްލަޔަރު portal exists, a buyer keys this in.",
        "currency": "ފައިސާ",
        "leadTime": "ލިބޭ މުއްދަތު (ދުވަސް)",
        "leadTimeHint": "Scored އާ ދެކޮޅަށް the other އަގު ހުށަހެޅުންތައް: the quickest scores 100.",
        "terms": "ފައިސާ ދެއްކުން ޝަރުތުތައް",
        "termsHint": "In their words — 30 ދުވަސް ސާފު, 50% on އޯޑަރު, and so on.",
        "termsScore": "Your rating of those ޝަރުތުތައް (0–100)",
        "termsScoreHint": "Your judgement, not a ހިސާބުކުރެވުނީ figure. Left empty it counts as a neutral 50.",
        "unitPrice": "އަގު ހުށަހަޅާފައި ޔުނިޓް އަގު",
        "priceFor": "އަގު ހުށަހަޅާފައި ޔުނިޓް އަގު for {description}"
      },
      "award": {
        "title": "ދިނުން this round",
        "description": "A ގަތުމުގެ އޯޑަރު is އުފެއްދި for the ސަޕްލަޔަރު ތިޔަ ފަރާތް ޚިޔާރުކުރޭ.",
        "notRecommended": "This is not the ހުށަހަޅާ ސަޕްލަޔަރު. That is allowed, and the އޮޑިޓް ރެކޯޑް records both who was ހުށަހަޅާ and who ތިޔަ ފަރާތް chose.",
        "createsOrder": "A ދެލިކޮޕީ ގަތުމުގެ އޯޑަރު will be އުފެއްދި for {vendor}, from this RFQ's lines and their އަގު ހުށަހަޅާފައި prices."
      },
      "links": {
        "requisition": "ރެކުއިޒިޝަން",
        "order": "ދެވިފައި އޯޑަރު",
        "evaluation": "ޓެންޑަރު ވަޒަންކުރުން"
      },
      "timeline": {
        "created": "އުފެއްދި",
        "issued": "ފޮނުވިފައި as {docNo}",
        "closed": "ބަންދު to further އަގު ހުށަހެޅުންތައް",
        "awarded": "ދެވިފައި"
      },
      "toasts": {
        "created": "RFQ އުފެއްދި",
        "createdDetail": "ފޮނުވާ it when the ސަޕްލަޔަރު list is right.",
        "createFailed": "That RFQ was not އުފެއްދި",
        "invited": "ސަޕްލަޔަރުން ދައުވަތު ދެވިފައި",
        "invitedDetail": "They can އަގު ހުށަހެޅުން އެއްފަހަރު the round is ފޮނުވިފައި.",
        "inviteFailed": "Those invitations did not ރައްކާކުރޭ",
        "issued": "ފޮނުވިފައި as {docNo}",
        "issuedDetail": "ސަޕްލަޔަރުން can now އަގު ހުށަހެޅުން.",
        "issueFailed": "That did not ފޮނުވާ",
        "quoted": "އަގު ހުށަހެޅުން recorded",
        "quotedDetail": "Every ސްކޯ in the comparison has been recalculated އާ ދެކޮޅަށް it.",
        "awarded": "ދެވިފައި",
        "awardedDetail": "ގަތުމުގެ އޯޑަރު {docNo} was އުފެއްދި.",
        "awardFailed": "That ދިނުން did not go through"
      },
      "awardOnEvaluation": "Awarding happens on the evaluation screen: it scores the criteria, records the ސަބަބު, and asks for an override ސަބަބު when the އެވޯޑް is not the top-ranked ކޯޓޭޝަން."
    },
    "po": {
      "listTitle": "ގަތުމުގެ އޯޑަރުތައް",
      "listDescription": "What the ކުންފުނި has ކޮމިޓްކޮށްފައި to buy, and how much of it has arrived.",
      "title": "އޯޑަރު {docNo}",
      "newTitle": "New ގަތުމުގެ އޯޑަރު",
      "draftTitle": "ދެލިކޮޕީ",
      "description": "A ކޮމިޓްމަންޓް to a ސަޕްލަޔަރު. ފާސްކުރަނީ it holds the ބަޖެޓް; issuing it tells them.",
      "headerTitle": "އޯޑަރު",
      "backToList": "All އޯޑަރުތައް",
      "loadFailed": "That އޯޑަރު did not load",
      "emptyTitle": "No ގަތުމުގެ އޯޑަރުތައް yet",
      "emptyDescription": "Raise one directly, or convert an ފާސްކުރެވިއްޖެ ރެކުއިޒިޝަން — the ރެކުއިޒިޝަން then shows what became of it.",
      "searchHint": "އޯޑަރު number or މެމޯ",
      "subtotalLabel": "ސަބްޓޯޓަލް",
      "taxAtSubmit": "ޓެކްސް is resolved when this is ހުށަހެޅި.",
      "actionsLabel": "އޯޑަރު އަމަލުތައް",
      "submitting": "ހުށަހަޅަނީ",
      "readyToSubmit": "Ready to ފާސްކުރުމަށް ހުށަހަޅާ.",
      "railSubtitle": "{status} · {vendor} · ވަރޝަން {version}",
      "versionBadge": "ވަރޝަން {version}",
      "fromRequisition": "އުފެއްދި from ރެކުއިޒިޝަން {docNo}",
      "amendingNote": "ތިޔަ ފަރާތް are editing an އިޞްލާޙު. Change the lines, then ރައްކާކުރޭ the އިޞްލާޙު with a ސަބަބު.",
      "stale": "Somebody else saved this އޯޑަރު while it was open. Nothing has been lost — reload it, look at their ވަރޝަން, and ބޭނުންކުރޭ your edits again.",
      "reload": "Reload the saved ވަރޝަން",
      "locked": {
        "submitted": "This އޯޑަރު is އިންތިޒާރުގައި for approval and cannot be edited. ބޭރުކުރޭ it to send it ފަހަތަށް for changes.",
        "approved": "This އޯޑަރު is ފާސްކުރެވިއްޖެ and its ބަޖެޓް is ކޮމިޓްކޮށްފައި. ފޮނުވާ it to the ސަޕްލަޔަރު.",
        "issued": "The ސަޕްލަޔަރު has this އޯޑަރު. Changes go through a numbered އިޞްލާޙު so both sides can see what moved.",
        "confirmed": "The ސަޕްލަޔަރު has ކަށަވަރުކުރެވިފައި this އޯޑަރު. Changes go through a numbered އިޞްލާޙު, and ކަށަވަރުކުރުން is cleared.",
        "partially_received": "Some of this އޯޑަރު has arrived. Changes go through a numbered އިޞްލާޙު.",
        "received": "Everything on this އޯޑަރު has arrived.",
        "closed": "This އޯޑަރު is ބަންދު.",
        "cancelled": "This އޯޑަރު was ކެންސަލްކުރެވިފައި."
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "މަޑުކުރަނީ ފާސްކުރުން",
        "approved": "ފާސްކުރެވިއްޖެ",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "issued": "ފޮނުވިފައި",
        "confirmed": "ކަށަވަރުކުރެވިފައި",
        "partially_received": "Part ލިބުނު",
        "received": "ލިބުނު",
        "closed": "ބަންދު",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "columns": {
        "docNo": "އޯޑަރު",
        "vendor": "ސަޕްލަޔަރު",
        "orderDate": "އޯޑަރުކުރި",
        "expectedDate": "ލިބޭނެކަމަށް",
        "currency": "ފައިސާ",
        "total": "ޖުމްލަ"
      },
      "fields": {
        "company": "ކުންފުނި",
        "vendor": "ސަޕްލަޔަރު",
        "vendorTerms": "Pays in {days} ދުވަސް",
        "orderDate": "އޯޑަރު ތާރީޚް",
        "expectedDate": "ލިބޭނެކަމަށް ބެލެވޭ ތާރީޚް",
        "expectedDateHint": "What ތިޔަ ފަރާތް have asked for. The ސަޕްލަޔަރު's own ތާރީޚް replaces it on ކަށަވަރުކުރުން.",
        "currency": "ފައިސާ",
        "memo": "މެމޯ",
        "subtotal": "ސަބްޓޯޓަލް",
        "tax": "ޓެކްސް",
        "total": "ޖުމްލަ",
        "baseTotal": "ޖުމްލަ in އަސާސީ ފައިސާ",
        "fxRate": "ރޭޓް",
        "confirmedAt": "ކަށަވަރުކުރެވިފައި"
      },
      "actions": {
        "save": "ދެލިކޮޕީ ރައްކާކުރޭ",
        "submit": "ފާސްކުރުމަށް ހުށަހަޅާ",
        "approve": "ފާސްކުރޭ",
        "approveHint": "ފާސްކުރަނީ commits the ބަޖެޓް firmly އާ ދެކޮޅަށް this އޯޑަރު.",
        "reject": "ބޭރުކުރޭ",
        "issue": "ފޮނުވާ to ސަޕްލަޔަރު",
        "confirm": "ރެކޯޑް ކަށަވަރުކުރުން",
        "amend": "އިޞްލާޙުކުރޭ",
        "saveAmendment": "ރައްކާކުރޭ އިޞްލާޙު",
        "cancel": "ކެންސަލްކުރޭ އޯޑަރު",
        "receive": "ތަކެތި ބަލައިގަންނަވާ",
        "match": "މެޗް an އިންވޮއިސް",
        "print": "ޕްރިންޓްކުރޭ",
        "abandonAmendment": "Abandon އިޞްލާޙު",
        "deliverySchedule": "ޑެލިވަރީ ތާވަލު",
        "raiseAmendment": "ފާސްކުރުމަށް ހުށަހަޅާ"
      },
      "reject": {
        "title": "ބޭރުކުރޭ this އޯޑަރު",
        "description": "It goes ފަހަތަށް to the buyer, with your ކޮމެންޓް."
      },
      "confirm": {
        "title": "ރެކޯޑް the ސަޕްލަޔަރު's ކަށަވަރުކުރުން",
        "description": "What they came ފަހަތަށް with, so the receiving schedule reflects reality rather than hope.",
        "referenceLabel": "Their ރެފަރެންސް",
        "referenceHint": "Their own އޯޑަރު or acknowledgement number, if they gave one.",
        "expectedLabel": "ތާރީޚް they ކޮމިޓްކޮށްފައި to",
        "expectedHint": "Often not the ތާރީޚް ތިޔަ ފަރާތް asked for. This is the one everything downstream will use."
      },
      "amend": {
        "title": "އިޞްލާޙުކުރޭ this އޯޑަރު",
        "description": "A numbered އިޞްލާޙު, with a ސަބަބު, so both sides can see what moved.",
        "editFirst": "Start editing first — change the lines on the އޯޑަރު, then come ފަހަތަށް here and explain the change.",
        "beginEditing": "ސަޠުރުތައް އެޑިޓްކުރަން ފަށާ",
        "clearsConfirmation": "The ސަޕްލަޔަރު has ކަށަވަރުކުރެވިފައި this އޯޑަރު. Amending clears that ކަށަވަރުކުރުން: they ކަށަވަރުކުރެވިފައި a different ލިޔުން and will need to ކަށަވަރުކުރޭ again.",
        "reasonLabel": "ބަދަލުވީ ކޮންއެއްޗެއް and why",
        "reasonHint": "Kept with the ވަރޝަން. \"v3\" tells nobody anything; \"ސަޕްލަޔަރު short by 200 bags\" tells them everything.",
        "expectedHint": "Leave as it is unless the delivery ތާރީޚް moved.",
        "needsApproval": "The amended total crosses an authority band, so it cannot be applied here. Nothing has ބަދަލުވީ on the އޯޑަރު. Raise it as an އިޞްލާޙު instead: it keeps these ސަޠުރުތައް and this ސަބަބު, routes for ފާސްކުރުން, and is applied once ފާސްކުރެވިފައި.",
        "raiseHint": "Records the change as a standing އިޞްލާޙު and opens the އިޞްލާޙު register."
      },
      "cancel": {
        "title": "ކެންސަލްކުރޭ this އޯޑަރު",
        "description": "It stays on the ރެކޯޑް, marked ކެންސަލްކުރެވިފައި.",
        "releasesCommitment": "This releases the ބަޖެޓް ކޮމިޓްކޮށްފައި އާ ދެކޮޅަށް the އޯޑަރު. An އޯޑަރު nobody is going to receive should not be holding money."
      },
      "closeLine": {
        "title": "މި ސަޠުރު ކުރިއަށް ނުގޮސް ބަންދުކުރޭ",
        "description": "Nothing further is expected އާ ދެކޮޅަށް it.",
        "releasesCommitment": "This releases whatever ބަޖެޓް is still ކޮމިޓްކޮށްފައި on ސަޠުރު. The alternative is money held އާ ދެކޮޅަށް goods that will ދުވަހަކުވެސް ނުވޭ arrive.",
        "reasonLabel": "އިތުރަށް ނުލިބޭނެ ސަބަބު",
        "reasonHint": "Recorded on the އޮޑިޓް ރެކޯޑް — discontinued, ސަޕްލަޔަރު cannot fill it, ordered elsewhere."
      },
      "versions": {
        "title": "އިޞްލާޙު ތާރީޚް",
        "description": "ބަދަލުވީ ކޮންއެއްޗެއް ފަހުން the ސަޕްލަޔަރު had a ކޮޕީކުރޭ.",
        "version": "ވަރޝަން {version}",
        "original": "Original އޯޑަރު as ފޮނުވިފައި",
        "noReason": "No ސަބަބު was recorded",
        "auditHint": "Every އިޞްލާޙު is on the އޮޑިޓް ރެކޯޑް in the right rail, with who made it and when."
      },
      "links": {
        "matches": "އިންވޮއިސް މެޗްތައް އާ ދެކޮޅަށް this އޯޑަރު",
        "grIr": "GR-IR ބެލެންސް on this އޯޑަރު",
        "amendments": "އޯޑަރުގެ އިޞްލާޙުތައް",
        "deliverySchedule": "ޑެލިވަރީ ތާވަލު"
      },
      "timeline": {
        "created": "އުފެއްދި",
        "submitted": "ހުށަހެޅި",
        "approved": "ފާސްކުރެވިއްޖެ — ބަޖެޓް ކޮމިޓްކޮށްފައި firmly",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "issued": "ފޮނުވިފައި to ސަޕްލަޔަރު as {docNo}",
        "confirmed": "ސަޕްލަޔަރު ކަށަވަރުކުރެވިފައި",
        "closed": "ބަންދު",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "shortcuts": {
        "save": "ރައްކާކުރޭ this އޯޑަރު"
      },
      "unsavedGuard": {
        "title": "ރައްކާނުކުރާ ބަދަލުތައް ދޫކޮށްލާނަންތޯ؟",
        "message": "This އޯޑަރު has ބަދަލުތައް that have not been ރައްކާކުރެވިފައި. Leaving now discards them.",
        "confirm": "ބަދަލުތައް ދޫކޮށްލާ",
        "cancel": "އިތުރަށް އެޑިޓްކުރޭ"
      },
      "toasts": {
        "saved": "އޯޑަރު saved",
        "savedDetail": "Still a ދެލިކޮޕީ — the ސަޕްލަޔަރު has not been told anything.",
        "saveFailed": "That did not ރައްކާކުރޭ",
        "submitted": "ހުށަހެޅި as {docNo}",
        "submittedDetail": "It is now with its ފާސްކުރާ ފަރާތްތައް.",
        "submitFailed": "That did not ހުށަހަޅާ",
        "approved": "އޯޑަރު ފާސްކުރެވިއްޖެ",
        "approvedDetail": "The ބަޖެޓް is now firmly ކޮމިޓްކޮށްފައި އާ ދެކޮޅަށް it.",
        "rejected": "އޯޑަރު ބޭރުކުރެވިއްޖެ",
        "rejectedDetail": "It has gone ފަހަތަށް to the buyer.",
        "decideFailed": "That decision did not ރައްކާކުރޭ",
        "issued": "ފޮނުވިފައި as {docNo}",
        "issuedDetail": "The ސަޕްލަޔަރު can now ކަށަވަރުކުރޭ it.",
        "issueFailed": "That did not ފޮނުވާ",
        "confirmed": "ކަށަވަރުކުރުން recorded",
        "confirmedDetail": "The expected ތާރީޚް now reflects what the ސަޕްލަޔަރު ކޮމިޓްކޮށްފައި to.",
        "confirmFailed": "That did not ރައްކާކުރޭ",
        "amended": "Amended to ވަރޝަން {version}",
        "amendedDetail": "The ސަބަބު is kept with the ވަރޝަން.",
        "amendFailed": "That އިޞްލާޙު did not ރައްކާކުރޭ",
        "cancelled": "އޯޑަރު ކެންސަލްކުރެވިފައި",
        "cancelledDetail": "Its ބަޖެޓް ކޮމިޓްމަންޓް has been ދޫކޮށްލާފައި.",
        "cancelFailed": "That did not ކެންސަލްކުރޭ",
        "lineClosed": "Line ބަންދު",
        "lineClosedDetail": "The ބަޖެޓް still ކޮމިޓްކޮށްފައި on it has been ދޫކޮށްލާފައި.",
        "lineCloseFailed": "އެ ސަޠުރު ބަންދެއް ނުވި",
        "amendmentRaised": "އިޞްލާޙު {version} ހުށަހަޅާފައި ފާސްކުރުމަށް",
        "amendmentRaisedDetail": "The އޯޑަރު is unchanged until the އިޞްލާޙު is ފާސްކުރެވިފައި and applied."
      }
    },
    "grn": {
      "listTitle": "މުދާ ލިބުނު ރަސީދުތައް",
      "listDescription": "What has arrived, what it was worth, and what it put into GR-IR ސާފުކުރުން.",
      "title": "މުދާ ލިބުނު ރަސީދު",
      "titleWithNo": "ރަސީދު {docNo}",
      "draftTitle": "ދެލިކޮޕީ",
      "description": "A ޕޯސްޓްކުރެވިފައި ރަސީދު moved stock onto the ބެލެންސް ޝީޓް and the same value into GR-IR ސާފުކުރުން.",
      "headerTitle": "ރަސީދު",
      "linesTitle": "ލިބުނު ތަކެތި",
      "linesCaption": "Ordered, already ލިބުނު, ބާކީ, what is being ލިބުނު now, and the އިތުރަށް ލިބުން ޙައްދު.",
      "backToList": "ހުރިހާ ރަސީދުތައް",
      "loadFailed": "That ރަސީދު did not load",
      "emptyTitle": "Nothing ލިބުނު yet",
      "emptyDescription": "Receiving starts from a ގަތުމުގެ އޯޑަރު — open the އޯޑަރު the delivery is އާ ދެކޮޅަށް and receive from there.",
      "receiveTitle": "ތަކެތި ބަލައިގަތުން",
      "receiveDescription": "އާ ދެކޮޅަށް a ގަތުމުގެ އޯޑަރު: all of it, some of it, or ބޭރުކުރެވިފައި at the door.",
      "chooseOrder": "Open the ގަތުމުގެ އޯޑަރު the delivery is އާ ދެކޮޅަށް and receive from there.",
      "notReceivable": "This އޯޑަރު is {status} and cannot be ލިބުނު އާ ދެކޮޅަށް. ފޮނުވާ it to the ސަޕްލަޔަރު first.",
      "actionsLabel": "ރަސީދުގެ ޢަމަލުތައް",
      "linesReceiving": "Lines on this ރަސީދު",
      "posting": "ޕޯސްޓްކުރަނީ",
      "postsImmediately": "There is no ދެލިކޮޕީ: this posts the stock ޙަރަކާތް and the ޖާނަލް in one step.",
      "postingExplained": "ޕޯސްޓްކުރަނީ a ރަސީދު debits މުދާ and credits GR-IR ސާފުކުރުން at the އޯޑަރު's own އަގު. The GR-IR ބެލެންސް stays until an އިންވޮއިސް is މެޗްކުރެވިފައި އާ ދެކޮޅަށް it.",
      "tolerancePolicy": "This ކުންފުނި accepts up to {percent}% over the ordered ޢަދަދު. Beyond that the ރަސީދު is ބޭރުކުރެވިފައި.",
      "toleranceUnavailable": "The އިތުރަށް ލިބުން ޓޮލަރެންސް is not visible to ތިޔަ ފަރާތް, so the ޙައްދު per line cannot be shown. Ask somebody who holds procurement.ސެޓިންގތައް.manage.",
      "overCap": "Over the ޙައްދު",
      "capWarning": "One or more lines are over the އިތުރަށް ލިބުން ޙައްދު. The server will ބޭރުކުރޭ this ރަސީދު.",
      "noBin": "No ބިން",
      "noItem": "No ކެޓަލޮގް އައިޓަމް",
      "noWarehouse": "No ގުދަން",
      "blockedTitle": "Lines that cannot be ލިބުނު",
      "blockedDescription": "A line with no ކެޓަލޮގް އައިޓަމް or no ގުދަން cannot ޕޯސްޓްކުރޭ a stock ޙަރަކާތް. އިޞްލާޙުކުރޭ the އޯޑަރު to add them.",
      "rejectReasonPlaceholder": "Why it was ބޭރުކުރެވިފައި",
      "rejectedCount": "{count} line(s) ބޭރުކުރެވިފައި",
      "totalValue": "GR-IR އަށް ދިޔަ ވެލިއު",
      "lot": "ލޮޓް {lot}",
      "railSubtitle": "{status} · އާ ދެކޮޅަށް {poNo}",
      "reversedNote": "This ރަސީދު was ރިވާސްކުރެވިފައި: {reason}. The mirror stock ޙަރަކާތް and ޖާނަލް were written; the original stays on the ރެކޯޑް.",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "reversed": "ރިވާސްކުރެވިފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "lineStatuses": {
        "received": "ލިބުނު",
        "rejected": "ބޭރުކުރެވިފައި"
      },
      "blockers": {
        "noLines": "Enter a ޢަދަދު on at least one line, or mark a line ބޭރުކުރެވިފައި.",
        "noDate": "Give the ތާރީޚް the goods arrived.",
        "noReason": "Say why a ބޭރުކުރެވިފައި line was ބޭރުކުރެވިފައި."
      },
      "columns": {
        "docNo": "ރަސީދު",
        "order": "އޯޑަރު",
        "receiptDate": "ލިބުނު",
        "lines": "ސަޠުރުތައް",
        "memo": "މެމޯ",
        "ordered": "އޯޑަރުކުރި",
        "alreadyReceived": "މިހާރު ލިބިފައި",
        "outstanding": "ބާކީ",
        "receiving": "މިހާރު ބަލައިގަންނަނީ",
        "cap": "ޙައްދު",
        "putAway": "ބަހައްޓާ in",
        "reject": "ބޭރުކުރޭ",
        "quantity": "ޢަދަދު",
        "unitCost": "Unit އަގު",
        "value": "ވެލިއު"
      },
      "fields": {
        "receiptDate": "ތާރީޚް ލިބުނު",
        "receiptDateHint": "The day the goods arrived — the ޖާނަލް is dated by it.",
        "supplier": "ސަޕްލަޔަރު",
        "order": "އާ ދެކޮޅަށް އޯޑަރު",
        "memo": "މެމޯ",
        "postedAt": "ޕޯސްޓްކުރެވިފައި",
        "grIrValue": "Into GR-IR ސާފުކުރުން"
      },
      "aria": {
        "receiving": "ޢަދަދު being ލިބުނު of {description}",
        "rejectReason": "Why {description} was ބޭރުކުރެވިފައި"
      },
      "actions": {
        "receive": "Receive and ޕޯސްޓްކުރޭ",
        "reverse": "ރިވާސްކުރޭ this ރަސީދު",
        "inspection": "ބަލައިގަތުމުގެ އިންސްޕެކްޝަން"
      },
      "reverse": {
        "title": "ރިވާސްކުރޭ this ރަސީދު",
        "description": "The mirror stock ޙަރަކާތް and the mirror ޖާނަލް.",
        "consequence": "The ރަސީދު stays on the ރެކޯޑް, marked ރިވާސްކުރެވިފައި — nothing is ފޮހެލެވިއްޖެ. A ރަސީދު already މެޗްކުރެވިފައި އާ ދެކޮޅަށް an އިންވޮއިސް cannot be ރިވާސްކުރެވިފައި; unwind the މެޗް first.",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "Recorded on the އޮޑިޓް ރެކޯޑް and on the ރިވަރސްކުރުން ޖާނަލް."
      },
      "timeline": {
        "created": "ރެކޯޑްކުރި",
        "posted": "ޕޯސްޓްކުރެވިފައި to the ލެޖަރ",
        "reversed": "ރިވާސްކުރެވިފައި"
      },
      "toasts": {
        "posted": "ލިބުނު as {docNo}",
        "postedDetail": "Stock is in, and the value is sitting in GR-IR ސާފުކުރުން until an އިންވޮއިސް މެޗްތައް it.",
        "postFailed": "That ރަސީދު did not ޕޯސްޓްކުރޭ",
        "reversed": "ރަސީދު ރިވާސްކުރެވިފައި",
        "reversedDetail": "The mirror stock ޙަރަކާތް and ޖާނަލް were written.",
        "reverseFailed": "That ރިވާސަލް did not go through"
      },
      "quarantinedCount": "{count} line(s) ކަރަންޓީނުކުރެވިފައި",
      "inspection": {
        "lineLink": "ދޫކުރޭ or ބޭރުކުރޭ",
        "open": "ބަލައިގަތުމުގެ އިންސްޕެކްޝަން ހުޅުވާ",
        "quarantineNote": "{count} line(s) on this ރަސީދު are ކަރަންޓީނުކުރެވިފައި. The goods are in stock and their value is already in GR-IR clearing — what is held is the right to issue them."
      }
    },
    "match": {
      "listTitle": "ތިން ފަރާތުގެ މެޗްތައް",
      "listDescription": "އިންވޮއިސްތައް checked އާ ދެކޮޅަށް their އޯޑަރު and their ރަސީދުތައް.",
      "title": "މެޗް #{id}",
      "newTitle": "Run a ތިން ފަރާތުގެ މެޗް",
      "description": "އިންވޮއިސް, the އޯޑަރު and the ރަސީދު side by side — and why they agreed or did not.",
      "backToList": "All މެޗްތައް",
      "loadFailed": "That މެޗް did not load",
      "emptyTitle": "Nothing މެޗްކުރެވިފައި yet",
      "emptyDescription": "A މެޗް compares a ސަޕްލަޔަރު's އިންވޮއިސް އާ ދެކޮޅަށް the އޯޑަރު it ސެޓްލްކުރޭ and the goods actually ލިބުނު. Run one from an އޯޑަރު that has ލިބުނު something.",
      "chooseTitle": "What is being މެޗްކުރެވިފައި",
      "chooseDescription": "Pick އިންވޮއިސް, then say which އޯޑަރު line each އިންވޮއިސް line ސެޓްލްކުރޭ.",
      "sourcesTitle": "The three ލިޔުންތައް",
      "linesTitle": "ސަޠުރުން ސަޠުރަށް",
      "linesCaption": "Ordered, ލިބުނު and invoiced quantities with their ތަފާތު, the two prices with theirs, and the ޓޮލަރެންސް each was judged އާ ދެކޮޅަށް.",
      "pairCaption": "Each އިންވޮއިސް line, and the purchase-އޯޑަރު line it ސެޓްލްކުރޭ.",
      "noOrder": "No އޯޑަރު ހޮވިފައި",
      "unmatched": "Not މެޗްކުރެވިފައި",
      "runExplained": "ހިންގުން a މެޗް records the result either way. A line outside ޓޮލަރެންސް is recorded as a ދެބަސްވުން, not thrown away.",
      "postExplained": "ޕޯސްޓްކުރަނީ އިންވޮއިސް is ބޭރުކުރެވިފައި while any line is outside ޓޮލަރެންސް — the refusal names the lines, and it ވަންނަނީ ކުރިން the ޖާނަލް exists rather than ފަހުން.",
      "matchedLabel": "މެޗްކުރެވިފައި",
      "actionsLabel": "މެޗް އަމަލުތައް",
      "posting": "ޕޯސްޓްކުރަނީ",
      "railTitle": "މެޗް #{id}",
      "railSubtitle": "{status}",
      "percent": "{value}%",
      "ofTolerance": "ހުއްދަ {bound}% ން",
      "priceBounds": "ހުއްދަ: {percent}% ނުވަތަ {amount}",
      "within": "Within ޓޮލަރެންސް",
      "outside": "Outside ޓޮލަރެންސް",
      "disagreement": "This screen reads the ޓޮލަރެންސް rule differently from the server. The server's decision stands; please report this.",
      "refusedLine": "ބޭރުކުރެވިފައި: ޢަދަދު varies by {qty}%, price by {price}%.",
      "refusedLines": "Purchase-އޯޑަރު line(s) {lines} are outside ޓޮލަރެންސް.",
      "openDisputes": "{count} ދެބަސްވުން(s) still open",
      "disputedOnly": "Only ދެބަސްވެފައި",
      "ofLines": "{total} ން {outside}",
      "disputesTitle": "ދެބަސްވުންތައް",
      "disputesDescription": "Each one holds an އިންވޮއިސް out of the ލެޖަރ until somebody decides.",
      "toleranceSummary": "ޓޮލަރެންސް: ޢަދަދު within {qty}%; price within {pricePercent}% or {priceAmount}, whichever passes.",
      "toleranceUnavailable": "The ޓޮލަރެންސް އުޞޫލު is not visible to ތިޔަ ފަރާތް, so the bounds cannot be shown beside each ތަފާތު. Ask somebody who holds procurement.ސެޓިންގތައް.manage.",
      "statuses": {
        "matched": "މެޗްކުރެވިފައި",
        "disputed": "ދެބަސްވެފައި"
      },
      "disputeStatuses": {
        "open": "ހުޅުވިފައި",
        "resolved": "ނިންމާފައި"
      },
      "invoiceStatuses": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "މަޑުކުރަނީ ފާސްކުރުން",
        "approved": "ފާސްކުރެވިއްޖެ, not ޕޯސްޓްކުރެވިފައި",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "paid": "ދައްކާފައި",
        "reversed": "ރިވާސްކުރެވިފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "columns": {
        "match": "މެޗް",
        "order": "އޯޑަރު",
        "invoice": "އިންވޮއިސް",
        "vendor": "ސަޕްލަޔަރު",
        "invoiceLine": "އިންވޮއިސް line",
        "settlesPoLine": "ސެޓްލްކުރޭ އޯޑަރު line",
        "poQty": "އޯޑަރުކުރި",
        "grnQty": "ލިބުނު",
        "invoiceQty": "އިންވޮއިސްކުރި",
        "qtyVariance": "ޢަދަދު ތަފާތު",
        "poPrice": "އޯޑަރު price",
        "invoicePrice": "އިންވޮއިސް price",
        "priceVariance": "Price ތަފާތު",
        "verdict": "ނަތީޖާ",
        "outsideTolerance": "Outside ޓޮލަރެންސް",
        "openDisputes": "Open ދެބަސްވުންތައް"
      },
      "fields": {
        "order": "ގަތުމުގެ އޯޑަރު",
        "invoice": "ސަޕްލަޔަރ އިންވޮއިސް",
        "invoiceHint": "ފާސްކުރެވިއްޖެ އިންވޮއިސްތައް for this ސަޕްލަޔަރު that have not been ޕޯސްޓްކުރެވިފައި yet.",
        "invoicePlaceholder": "ޚިޔާރުކުރޭ އިންވޮއިސް to މެޗް",
        "invoiceStatus": "އިންވޮއިސް ސްޓޭޓަސް",
        "receipts": "ރަސީދުތައް އާ ދެކޮޅަށް the އޯޑަރު"
      },
      "actions": {
        "run": "Run the މެޗް",
        "post": "ޕޯސްޓްކުރޭ އިންވޮއިސް",
        "resolve": "ހިސާބުކުރޭ"
      },
      "resolve": {
        "title": "ހިސާބުކުރޭ this ދެބަސްވުން",
        "description": "Somebody has to decide: accept the ތަފާތު, or hold އިންވޮއިސް.",
        "outcomeLabel": "ނިންމުން",
        "accept": "Accept the ތަފާތު",
        "reject": "Hold އިންވޮއިސް",
        "acceptConsequence": "Accepting overrides the ޓޮލަރެންސް and މެޗްތައް ސަޠުރު at އިންވޮއިސް's figures. The ގަތުމުގެ އޯޑަރު and the ބަޖެޓް ކޮމިޓްމަންޓް are ދޫކޮށްލާފައި accordingly.",
        "rejectConsequence": "Holding ނުކުންނަނީ ސަޠުރު ނުގުޅުވާ and its GR-IR ބެލެންސް open. The ސަޕްލަޔަރު has to correct އިންވޮއިސް.",
        "noteLabel": "ސަބަބު",
        "noteHint": "Required. This is the ރެކޯޑް of why a ޓޮލަރެންސް was overridden, or why an އިންވޮއިސް was held."
      },
      "timeline": {
        "matched": "މެޗްކުރެވިފައި",
        "disputeOpened": "ދެބަސްވުން ހުޅުވި ވަގުތު: {reason}",
        "disputeResolved": "ދެބަސްވުން resolved"
      },
      "toasts": {
        "matched": "މެޗްކުރެވިފައި",
        "matchedDetail": "Every line was within ޓޮލަރެންސް. އިންވޮއިސް can be ޕޯސްޓްކުރެވިފައި.",
        "disputed": "މެޗްކުރެވިފައި with ދެބަސްވުންތައް",
        "disputedDetail": "Some lines are outside ޓޮލަރެންސް. They are recorded, and އިންވޮއިސް cannot ޕޯސްޓްކުރޭ until they are resolved.",
        "matchFailed": "That މެޗް did not run",
        "posted": "އިންވޮއިސް ޕޯސްޓްކުރެވިފައި",
        "postedDetail": "GR-IR ސާފުކުރުން has been debited and the payable އުފެއްދި.",
        "refused": "ޕޯސްޓްކުރަނީ ބޭރުކުރެވިފައި — outside ޓޮލަރެންސް",
        "postFailed": "That އިންވޮއިސް did not ޕޯސްޓްކުރޭ",
        "resolved": "ދެބަސްވުން resolved",
        "resolvedDetail": "Your ސަބަބު is on the ރެކޯޑް.",
        "resolveFailed": "That ނަތީޖާ did not ރައްކާކުރޭ"
      },
      "exception": {
        "price_variance": "އިންވޮއިސްގެ ރޭޓު އޯޑަރުގެ ރޭޓާ ތަފާތު.",
        "qty_variance": "އިންވޮއިސްގެ ޢަދަދު އޯޑަރުގެ ޢަދަދާ ތަފާތު.",
        "missing_receipt": "އިންވޮއިސްކުރެވިފައި ވީނަމަވެސް ލިބިފައެއް ނުވޭ.",
        "missing_order": "ޕަރޗޭސް އޯޑަރެއް ނެތި އިންވޮއިސްކުރެވިފައި ވޭ.",
        "tax_variance": "އިންވޮއިސްގެ ޓެކްސް ލަފާކުރި ޓެކްސްއާ ތަފާތު.",
        "freight_variance": "އޯޑަރު ނުކުރެވޭ ފްރެއިޓް ނުވަތަ ހަންޑްލިންގ ޗާޖެއް.",
        "duplicate_invoice": "ޑުޕްލިކޭޓް އިންވޮއިސްއެއް ކަމަށް ޝައްކުވޭ.",
        "over_invoice": "ޖުމްލަ އިންވޮއިސްކުރުން އޯޑަރަށްވުރެ ބޮޑު.",
        "currency_mismatch": "އިންވޮއިސާއި އޯޑަރު ތަފާތު ކަރަންސީއެއްގައި.",
        "inspection_failed": "މުދަލުން އިންސްޕެކްޝަން ފެއިލްވި."
      }
    },
    "grIr": {
      "title": "GR-IR ޢުމުރު",
      "description": "Goods ލިބުނު and not yet invoiced — and whether the ސަބް-ލެޖަރ and the ޢާންމު ލެޖަރ agree about it.",
      "loadFailed": "އެ ރިޕޯޓް ލޯޑެއް ނުވި",
      "rowsTitle": "ހުޅުވިފައިވާ ބާކީތައް",
      "chooseCompany": "ކުންފުންޏެއް ޚިޔާރުކުރޭ",
      "chooseCompanyFirst": "ކުންފުންޏެއް ޚިޔާރުކުރޭ ހިންގަން this report.",
      "asOf": "ތާރީޚް",
      "asOfHint": "Leave empty for today, in the ވޯކްސްޕޭސް ޓައިމްޒޯން.",
      "openOnly": "Only lines with a ބެލެންސް",
      "caption": "GR-IR balances by purchase-އޯޑަރު line ތާރީޚް {asOf}.",
      "generatedAt": "ތާރީޚް {asOf}.",
      "empty": "Nothing ލިބުނު އާ ދެކޮޅަށް any ގަތުމުގެ އޯޑަރު for this ކުންފުނި.",
      "emptyOpen": "Nothing ބާކީ. Every ރަސީދު has been މެޗްކުރެވިފައި to an އިންވޮއިސް — which is what this report exists to show.",
      "subLedgerBalance": "Procurement ސަބް-ލެޖަރ",
      "ledgerBalance": "ލެޖަރ {code} {name}",
      "difference": "ތަފާތު",
      "reconciled": "The ސަބް-ލެޖަރ and the ލެޖަރ agree. Everything ލިބުނު and not yet invoiced is accounted for in both.",
      "notReconciled": "The ސަބް-ލެޖަރ and the ލެޖަރ disagree by {amount}. Goods ލިބުނު but not invoiced are not accounted for the same way in both, and the ތަފާތު has to be explained ކުރިން this މުއްދަތު can be ބަންދު.",
      "totals": "ޖުމްލަ",
      "onlyThisVendor": "only this ސަޕްލަޔަރު",
      "matches": "މެޗްތައް",
      "days": "{days} ދު",
      "columns": {
        "order": "އޯޑަރު",
        "receivedQty": "ލިބުނު",
        "receivedValue": "ލިބުނު value",
        "matchedValue": "މެޗްކުރެވިފައި value",
        "balance": "GR-IR ގައި",
        "share": "ހިއްސާ",
        "age": "Oldest ރަސީދު",
        "lineStatus": "ސަޠުރު"
      }
    },
    "scorecards": {
      "title": "ސަޕްލަޔަރު ސްކޯކާޑްތައް",
      "description": "How ސަޕްލަޔަރުން actually performed: on time and in full, price އާ ދެކޮޅަށް އޯޑަރު, and ފެންވަރު at the door.",
      "loadFailed": "Those ސްކޯކާޑްތައް did not load",
      "emptyTitle": "No ސްކޯކާޑްތައް yet",
      "emptyDescription": "ސްކޯކާޑްތައް are ހިސާބުކުރެވުނީ nightly from delivered އޯޑަރުތައް and މެޗްކުރެވިފައި އިންވޮއިސްތައް. They appear އެއްފަހަރު a ސަޕްލަޔަރު has completed an އޯޑަރު.",
      "computedNightly": "ހިސާބުކުރެވުނީ nightly from ލިބުނު އޯޑަރުތައް, މެޗްކުރެވިފައި އިންވޮއިސްތައް and ބޭރުކުރެވިފައި deliveries.",
      "otifDetail": "{orders} ން {onTime} ވަޤުތަށް، {inFull} ފުރިހަމައަށް",
      "columns": {
        "vendor": "ސަޕްލަޔަރު",
        "period": "މުއްދަތު",
        "orders": "އޯޑަރުތައް",
        "otif": "ވަޤުތަށް އަދި ފުރިހަމައަށް",
        "priceVariance": "Price ތަފާތު",
        "quality": "ފެންވަރު"
      }
    },
    "settings": {
      "title": "Procurement ސެޓިންގތައް",
      "description": "Where ލިބުނު-but-uninvoiced value sits, and how much disagreement is absorbed without a person looking at it.",
      "loadFailed": "Those ސެޓިންގތައް did not load",
      "companyTitle": "ކުންފުނި",
      "accountTitle": "GR-IR ކްލިއަރިންގ ހިސާބު",
      "accountDescription": "ލިބުނު goods are debited to މުދާ and credited here until an އިންވޮއިސް މެޗްތައް them.",
      "toleranceTitle": "ޓޮލަރެންސްތައް",
      "toleranceDescription": "މީގެ ކޮންމެ އެއްޗަކުން ކަނޑައަޅަނީ ބައިވެރިންނަށް ކިހާ ގިނައިން މެދުކެނޑުމެއް އަންނާނެކަމާއި، ބެލުމަކާ ނުލައި ކިހާ މިންވަރެއް ދޫވާނެކަމެވެ.",
      "configuredAccount": "ރަސީދުތައް ކްރެޑިޓް ހިސާބު {code}.",
      "defaultedAccount": "No އެކައުންޓް is configured, so ރަސީދުތައް ކްރެޑިޓް {code} from the އާދައިގެ chart. Set one to be explicit.",
      "priceRule": "A price passes if it is within either bound — the އަދަދު or the percentage. Set the އަދަދު for small parts where a percentage would be noise, and the percentage for large ones where an އަދަދު would be.",
      "fields": {
        "grIrAccount": "GR-IR ކްލިއަރިންގ ހިސާބު",
        "grIrAccountHint": "Left empty, the އާދައިގެ chart's GR-IR ކްލިއަރިންގ ހިސާބު is used.",
        "grIrAccountPlaceholder": "Use the އާދައިގެ chart's އެކައުންޓް",
        "qtyTolerance": "ޢަދަދު ޓޮލަރެންސް (%)",
        "qtyToleranceHint": "How far an invoiced ޢަދަދު may differ from the ordered one ކުރިން a ދެބަސްވުން opens.",
        "overReceipt": "އިތުރަށް ލިބުން ޓޮލަރެންސް (%)",
        "overReceiptHint": "How much more than ordered may be ލިބުނު. Beyond it, the ރަސީދު is ބޭރުކުރެވިފައި at the door.",
        "pricePercent": "Price ޓޮލަރެންސް (%)",
        "pricePercentHint": "For large-value lines, where a fixed އަދަދު would be trivially exceeded.",
        "priceAmount": "Price ޓޮލަރެންސް (އަދަދު)",
        "priceAmountHint": "For small-value lines, where a percentage would open a ދެބަސްވުން over a few laari."
      },
      "toasts": {
        "saved": "ސެޓިންގތައް saved",
        "savedDetail": "New ރަސީދުތައް and މެޗްތައް are judged އާ ދެކޮޅަށް these from now on.",
        "saveFailed": "Those ސެޓިންގތައް did not ރައްކާކުރޭ"
      },
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ސެޓިންގްސް ބަދަލުކޮށްފި. ކަމެއް ނުފޮހެވޭ. ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކުރޭ"
    },
    "c7": {
      "filtersTitle": "ފިލްޓަރތައް",
      "common": {
        "remove": "ނަގާ"
      },
      "routeTitles": {
        "grnInspection": "ބަލައިގަތުމުގެ އިންސްޕެކްޝަން",
        "returns": "ސަޕްލަޔަރ ރިޓާންތައް",
        "return": "ސަޕްލަޔަރ ރިޓާން",
        "suppliers": "ސަޕްލަޔަރުން",
        "supplier": "ސަޕްލަޔަރ",
        "supplierPolicy": "ސަޕްލަޔަރ ޕޮލިސީ",
        "supplierRisk": "ސަޕްލަޔަރ ރިސްކް",
        "contracts": "ކޮންޓްރެކްޓްތައް",
        "contract": "ކޮންޓްރެކްޓް",
        "releases": "ކޮންޓްރެކްޓް ރިލީޒްތައް",
        "contractExpiry": "ކޮންޓްރެކްޓް އައުކުރުންތައް",
        "spendAnalysis": "ޚަރަދުގެ ދިރާސާ",
        "maverick": "ކޮންޓްރެކްޓުން ބޭރު ޚަރަދު",
        "spendFacts": "ޚަރަދުގެ ފެކްޓްތައް",
        "matchExceptions": "މެޗް އެކްސެޕްޝަންތައް",
        "matchCauses": "މެޗް ސަބަބުތައް",
        "amendments": "އޯޑަރުގެ އިޞްލާޙުތައް",
        "deliverySchedule": "ޑެލިވަރީ ތާވަލު",
        "incoterms": "އިންކޯޓާމްތައް",
        "rfqEvaluation": "ޓެންޑަރު ވަޒަންކުރުން"
      },
      "fields": {
        "businessDate": "ތާރީޚް",
        "code": "ކޯޑް",
        "company": "ކުންފުނި",
        "criticality": "މުހިންމުކަން",
        "currency": "ފައިސާގެ ބާވަތް",
        "detail": "ތަފްޞީލު",
        "documentNo": "ނަންބަރު",
        "effectivity": "ހިނގާ މުއްދަތު",
        "fromDate": "ފެށޭ",
        "incoterm": "އިންކޯޓާމް",
        "item": "ބާވަތް",
        "kind": "ބާވަތް",
        "lot": "ލޮޓު",
        "notes": "ނޯޓްތައް",
        "openEnded": "ހުޅުވިފައި",
        "qualification": "ކޮލިފިކޭޝަން",
        "quantity": "އަދަދު",
        "reason": "ސަބަބު",
        "title": "ސުރުޚީ",
        "toDate": "ނިމޭ",
        "unitCost": "ޔުނިޓް އަގު",
        "value": "އަގު",
        "vendor": "ސަޕްލަޔަރ"
      },
      "grnLineStatus": {
        "received": "ބަލައިގަނެފައި",
        "accepted": "ބަލައިގަނެފައި",
        "quarantined": "ކަރަންޓީނުކުރެވިފައި",
        "rejected": "ބަނދަރުގައި ބޭރުކުރެވުނު",
        "returned": "އަނބުރާ އައި"
      },
      "returnReason": {
        "quality": "ފެންވަރު",
        "over_delivery": "މާ ގިނައިން ފޮނުވުން",
        "wrong_item": "ނުބައި އެއްޗެއް",
        "damaged": "ގެއްލުންވެފައި",
        "expired": "މުއްދަތު ހަމަވެފައި",
        "commercial": "ވިޔަފާރީގެ"
      },
      "returnStatus": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "ހުށަހެޅި",
        "approved": "ފާސްކުރެވިއްޖެ",
        "despatched": "ފޮނުވި",
        "completed": "ނިމިފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "qualification": {
        "prospect": "ޕްރޮސްޕެކްޓް",
        "under_review": "މުރާޖަޢާކުރެވެމުންދޭ",
        "qualified": "ކޮލިފައިވެފައި",
        "preferred": "އިސްކަންދެވޭ",
        "suspended": "ސަސްޕެންޑްކޮށްފައި",
        "exited": "ދޫކޮށްލެވިފައި",
        "meaning": {
          "prospect": "ފާހަގަކުރެވިފައި، އަދި ދިރާސާ ނުކުރެވޭ",
          "under_review": "ދިރާސާކުރެވެމުންދޭ؛ ސަމާލުވެ ގަނޭ",
          "qualified": "އާދައިގެ ގަތުމަށް ފާސްކުރެވިފައި",
          "preferred": "ފާސްކުރެވިފައި، އަދި ހޯދުމުގައި އިސްކަންދެވޭ",
          "suspended": "ޕާޗޭސް އޯޑަރުތައް ބަލައެއް ނުގަނެވޭނެ",
          "exited": "މުޅިން ބޭނުންކުރުން ހުއްޓާލެވިފައި"
        },
        "dialogTitle": "ކޮލިފިކޭޝަން ބަދަލުކުރޭ",
        "dialogDescription": "ކޮލިފިކޭޝަން ބަދަލަކީ ކޮންޓްރޯލެއް، ލޭބަލެއް ނޫން. ސަބަބަކާއި ނިންމި ތާރީޚާއެކު ރެކޯޑްކުރެވޭ.",
        "current": "މިހާރުގެ ސްޓޭޓަސް",
        "newStatus": "އައު ސްޓޭޓަސް",
        "assessmentScore": "އެސެސްމަންޓް ސްކޯރ",
        "validUntil": "ކޮލިފައިވެފައި ވަނީ",
        "validUntilMeaning": "މި ތާރީޚަށްފަހު ކޮލިފިކޭޝަން ބާޠިލުވެ، ޕޮލިސީ އަލުން ހިނގާނެ.",
        "blocksOrders": "މި ސްޓޭޓަސްއިން މި ސަޕްލަޔަރަށް އައު ޕާޗޭސް އޯޑަރު ބަލައެއް ނުގަނެވޭނެ. ހުޅުވިފައިވާ އޯޑަރު ކެންސަލެއް ނުވާނެ، އެކަމަކު އޯވަރައިޑަކާ ނުލައި އައު އެއްޗެއް ނުހެދޭނެ.",
        "confirm": "ބަދަލު ރެކޯޑްކުރޭ",
        "change": "ކޮލިފިކޭޝަން ބަދަލުކުރޭ",
        "historyTitle": "ކޮލިފިކޭޝަންގެ ތާރީޚު",
        "historyCaption": "ކޮންމެ ކޮލިފިކޭޝަން ބަދަލަކާއި އޭގެ ސަބަބާއި ނިންމި ތާރީޚު.",
        "transition": "ބަދަލު",
        "decidedAt": "ނިންމި",
        "note": "ކޮލިފިކޭޝަން ނޯޓް",
        "empty": "ބަދަލެއް ރެކޯޑްކުރެވިފައެއް ނުވޭ. މި ސަޕްލަޔަރު ހުރީ މައިގްރޭޓްވި ޑިފޯލްޓްގައި.",
        "saved": "ކޮލިފިކޭޝަން އަޕްޑޭޓްކޮށްފި",
        "saveFailed": "ކޮލިފިކޭޝަން ބަދަލެއް ނުކުރެވުނު"
      },
      "criticality": {
        "standard": "އާދައިގެ",
        "important": "މުހިންމު",
        "critical": "ކްރިޓިކަލް",
        "single_source": "ހަމައެކަނި އެއް މަޞްދަރު"
      },
      "documentStatus": {
        "submitted": "ހުށަހެޅި",
        "verified": "ޔަޤީންކުރެވިފައި",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "expired": "މުއްދަތު ހަމަވެފައި"
      },
      "screeningList": {
        "sanctions": "ސެންކްޝަން",
        "pep": "ސިޔާސީގޮތުން ފާހަގަކުރެވޭ ފަރާތެއް",
        "adverse_media": "ނޭދެވޭ މީޑިއާ",
        "ubo": "ޙަޤީޤީ މިލްކުވެރިކަން"
      },
      "screeningOutcome": {
        "clear": "ސާފުކުރޭ",
        "potential_match": "ވެދާނެ ގުޅުމެއް",
        "confirmed_match": "ޔަގީން ގުޅުމެއް",
        "error": "ސްކްރީނިން ކުށެއް"
      },
      "screeningReview": {
        "false_positive": "ދޮގު ފާހަގައެއް",
        "true_match": "ޔަގީން ގުޅުމެއް"
      },
      "policyMode": {
        "block": "ހުއްޓުވާ",
        "warn": "އިންޒާރު",
        "ignore": "ފަރުވާލެއް ނުބަހައްޓާ"
      },
      "contractKind": {
        "price_agreement": "އަގުގެ އެއްބަސްވުން",
        "blanket_order": "ބްލޭންކެޓް އޯޑަރު",
        "framework": "ފްރޭމްވޯކް"
      },
      "contractStatus": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "ހުށަހެޅި",
        "active": "ހަރަކާތްތެރި",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "suspended": "ސަސްޕެންޑްކޮށްފައި",
        "expired": "މުއްދަތު ހަމަވެފައި",
        "terminated": "ނިމުމަކަށް ގެނެވިފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "priceBasis": {
        "exclusive": "ޓެކްސް ނުހިމަނާ",
        "inclusive": "ޓެކްސް ހިމަނައިގެން"
      },
      "rebateKind": {
        "volume_percent": "މިންވަރުގެ ޕަސެންޓޭޖް",
        "tiered_percent": "ދަރަޖަކުރެވިފައިވާ ޕަސެންޓޭޖް",
        "fixed_amount": "ސާބިތު އަދަދު"
      },
      "releaseStatus": {
        "open": "ހުޅުވިފައި",
        "consumed": "ބޭނުންކުރެވިފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "spendStage": {
        "committed": "ކޮމިޓްކޮށްފައި",
        "invoiced": "އިންވޮއިސްކުރި",
        "reversed": "ރިވަރސްކުރެވިފައި"
      },
      "spendContractStatus": {
        "on_contract": "ކޮންޓްރެކްޓުގައި",
        "off_contract": "ކޮންޓްރެކްޓުން ބޭރު",
        "no_contract": "ކޮންޓްރެކްޓެއް ލިބެން ނެތް",
        "contract_alternate": "އެހެން ސަޕްލަޔަރެއްގެ ކޮންޓްރެކްޓެއް އޮތް"
      },
      "sourcingRoute": {
        "direct": "ސީދާ",
        "rfq": "ޓެންޑަރު",
        "contract": "ކޮންޓްރެކްޓް",
        "catalogue": "ކެޓަލޮގު"
      },
      "exceptionStatus": {
        "open": "ހުޅުވިފައި",
        "resolved": "ހައްލުކުރެވިފައި",
        "accepted": "ބަލައިގަނެފައި",
        "rejected": "ބޭރުކުރެވިއްޖެ"
      },
      "ownerResolution": {
        "buyer": "ގަންނަ ފަރާތް",
        "requester": "އެދުނު ފަރާތް",
        "warehouse_manager": "ގުދަނުގެ މެނޭޖަރު",
        "role": "ކަނޑައެޅިފައިވާ ރޯލެއް",
        "user": "ނަން ބަޔާންކުރެވިފައިވާ މީހަކު",
        "finance": "މާލީ"
      },
      "amendmentChange": {
        "add": "އިތުރުކުރެވުނު",
        "update": "ބަދަލުވި",
        "cancel": "ކެންސަލްކުރެވިފައި"
      },
      "amendmentStatus": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "ހުށަހެޅި",
        "approved": "ފާސްކުރެވިއްޖެ",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "applied": "ބޭނުންކުރެވިފައި"
      },
      "criterionKind": {
        "price": "އަގު",
        "landed_cost": "ލޭންޑަޑް ކޮސްޓް",
        "lead_time": "ލިބޭ މުއްދަތު",
        "terms": "ފައިސާ ދެއްކުން ޝަރުތުތައް",
        "quality_score": "ކޮލިޓީ ސްކޯރ",
        "otif": "ވަޤުތަށް އަދި ފުރިހަމައަށް",
        "manual": "ޕެނަލުން ސްކޯރު ދޭ"
      },
      "borneBy": {
        "buyer": "ގަންނަ ފަރާތް",
        "seller": "ވިއްކާ ފަރާތް"
      },
      "receiving": {
        "title": "ބަލައިގަތުމުގެ އިންސްޕެކްޝަން",
        "description": "ލިބުނު އެއްޗެއް، ބަލައިގަތް އެއްޗެއް، ހިފެހެއްޓި އެއްޗެއް އަދި ބަލައިނުގަތް އެއްޗެއް.",
        "backToReceipt": "ބަލައިގަތުމަށް އެނބުރި",
        "loadFailed": "ބަލައިގަތުމުގެ އިންސްޕެކްޝަން ލޯޑެއް ނުވި",
        "linesTitle": "ބަލައިގަތުމުގެ ލައިންތައް",
        "linesCaption": "ކޮންމެ ބަލައިގަތުމުގެ ލައިނެއްގެ ތިން ބައިގެ ބެހުމާއި އޭގެ އިންސްޕެކްޝަން ލޮޓް.",
        "linesEmpty": "މި ބަލައިގަތުމުގައި ލައިނެއް ނެތް.",
        "splitCaption": "ލިބުނު މިންވަރު ބަލައިގަތް، ކަރަންޓީނުކުރި އަދި ބޭރުކުރި މިންވަރަށް ބަހާލެވިފައި.",
        "splitEmpty": "މި އޯޑަރުން ބަލައިގަންނާނެ އެއްޗެއް ނެތް.",
        "columns": {
          "delivered": "ފުއްދިފައި",
          "accepted": "ބަލައިގަނެފައި",
          "quarantined": "ކަރަންޓީނުކުރެވިފައި",
          "rejected": "ބޭރުކުރެވިއްޖެ",
          "returned": "އަނބުރާ އައި",
          "foots": "ދިމާވޭ",
          "inspection": "އިންސްޕެކްޝަން"
        },
        "acceptedMeaning": "ސްޓޮކަށް ބަލައިގަނެވިފައި، އަދި ދޫކުރެވެން ހުރި.",
        "quarantinedMeaning": "ސްޓޮކަށް ބަލައިގަނެ ހިފެހެއްޓިފައި: ބެލެންސް ޝީޓުގައި، ޖީއާރު-އައިއާރުގައި، އަދި ދޫކުރަންދެން ނުދޫކުރެވޭނެ.",
        "rejectedMeaning": "ބަނދަރުގައި ބަލައިނުގަނެވުނު. އެއްވެސް އެއްޗެއް ބަލައިގަނެފައެއް ނުވޭ، ޖީއާރު-އައިއާރަށް އެއްޗެއް ނުވަދޭ، އަދި އިންވޮއިސްއެއް ނުލިބޭނެ.",
        "footing": {
          "foots": "ދިމާވޭ",
          "short": "{qty} ހިސާބުނުކުރެވޭ",
          "over": "ލިބުނު މިންވަރަށްވުރެ {qty} ގިނަ",
          "invalid": "ނަންބަރެއް ނޫން"
        },
        "brokenSplit": "{count} ލައިނެއް ދިމައެއް ނުވޭ. މި ބަލައިގަތުން ރައްކާކުރެވޭނީ، ލިބުނު ކޮންމެ ޔުނިޓެއް ބަލައިގަތް، ކަރަންޓީނުކުރި ނުވަތަ ބޭރުކުރި ގޮތުގައި ހިސާބުކުރުމުން.",
        "splitOk": "ކޮންމެ ލައިނެއް ލިބުނު މިންވަރާ ދިމާވޭ.",
        "quarantineBanner": "{count} ލައިނެއް ކަރަންޓީނުކުރެވިފައި.",
        "quarantineMeaning": "ކަރަންޓީނުކުރެވިފައިވާ މުދާ ބަލައިގަނެވިފައިވޭ: އެއީ ބެލެންސް ޝީޓާއި ޖީއާރު-އައިއާރުގައި ހިމެނޭ، އަދި ސަޕްލަޔަރު އެއަށް އިންވޮއިސް ފޮނުވާނެ. ހިފެހެއްޓެނީ އެ ދޫކުރުމުގެ ޙައްޤު.",
        "inspectionBlocking": "ކަރަންޓީނުކުރެވިފައިވާ {count} ލައިނެއް ބްލޮކްކުރާ އިންސްޕެކްޝަނަކަށް މަޑުކޮށްފައި، އަދި އެ ފާސްވަންދެން ދޫނުކުރެވޭނެ.",
        "noInspection": "އިންސްޕެކްޝަނެއް ނެތް",
        "release": "ދޫކޮށްލާ",
        "releaseTitle": "ކަރަންޓީނުން ދޫކުރޭ",
        "releaseDescription": "ދޫކުރެވޭގޮތަށް މި މިންވަރު ބަލައިގަނެފައިވާ ސްޓޮކަށް ބަދަލުކުރޭ.",
        "released": "ސްޓޮކަށް ދޫކޮށްފި",
        "releaseFailed": "ލައިން ދޫނުކުރެވުނު",
        "reject": "ބޭރުކުރޭ",
        "rejectTitle": "ކަރަންޓީނުކުރެވިފައިވާ މުދާ ބޭރުކުރޭ",
        "rejectDescription": "މި މިންވަރު ބަލައިނުގަނެވޭކަން ރެކޯޑްކުރޭ.",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "rejectIsNotAReturn": "މިތާ ބޭރުކުރުމުން ބަލައިނުގަތުމެއް ރެކޯޑްކުރެވޭ. މުދާ އަނބުރައެއް ނުފޮނުވޭ، އަދި ބަލައިގަތުން އަނބުރައެއް ނުލެވޭ — މުދާ ބަލައިގަނެވިފައި ޖީއާރު-އައިއާރުގައި ހުރި، އެހެންވެ އަނބުރާ ފޮނުވުމަކީ އަމިއްލަ ލިޔުމަކާއި އަމިއްލަ ޑެބިޓް ނޯޓެއް އޮންނަ ސަޕްލަޔަރ ރިޓާނެއް.",
        "startReturn": "ސަޕްލަޔަރަށް އަނބުރާ ފޮނުވާ"
      },
      "returns": {
        "title": "ސަޕްލަޔަރ ރިޓާންތައް",
        "description": "އަނބުރާ ފޮނުވި މުދަލާއި އެއަށް ލިބޭނެ ކަމަށް ބެލެވޭ ކްރެޑިޓް.",
        "tableTitle": "އަނބުރާ އަންނަ",
        "caption": "ސަޕްލަޔަރ ރިޓާންތަކާއި އޭގެ ސަބަބު، އަގު އަދި ޑެބިޓް ނޯޓް.",
        "create": "އައު ރިޓާން",
        "dialogDescription": "ރިޓާނަކުން އަނބުރާލާ ބަލައިގަތުމުގެ ލައިން ބަޔާންކުރޭ، އެހެންކަމުން އެ ބަލައިގަތުމުން އުފެއްދި ލޭޔަރު އެ ލޭޔަރުގެ އަމިއްލަ އަގުގައި ނަގާ.",
        "searchLabel": "ހޯދާ",
        "searchPlaceholder": "ރިޓާން ނުވަތަ ސަޕްލަޔަރ",
        "loadFailed": "އަނބުރާ ދިނުންތައް ނުލޯޑްވި",
        "empty": "ސަޕްލަޔަރ ރިޓާނެއް ނެތް. ފެށެނީ ބަލައިގަތުމުގެ ލައިނަކުން، ކެޓަލޮގަކުން ނޫން.",
        "emptyFiltered": "މި ފިލްޓަރުތަކާ ގުޅޭ ރިޓާނެއް ނެތް.",
        "columns": {
          "returnDate": "އަނބުރާ ދިން ތާރީޚް",
          "debitNote": "ޑެބިޓް ނޯޓް"
        },
        "receiptId": "ރަސީދު",
        "receiptHint": "މި މުދާ ލިބުނު ބަލައިގަތުން.",
        "carrierRef": "އުފުލާ ފަރާތުގެ ރެފަރެންސް",
        "reasonNote": "ނޯޓްތައް",
        "returnQty": "ބަޔާން",
        "linesCaption": "އަނބުރާ ފޮނުވާނެ ސްޓޮކް އަދިވެސް ހުރި ބަލައިގަތުމުގެ ލައިންތައް.",
        "linesTitle": "ރިޓާނުގެ ލައިންތައް",
        "linesEmpty": "މި ރިޓާނުގައި ލައިނެއް ނެތް.",
        "noReturnableLines": "މި ބަލައިގަތުމުން އެއްވެސް އެއްޗެއް އަނބުރާ ނުފޮނުވޭނެ. ބޭރުކުރެވުނު ލައިނެއް ދުވަހަކުވެސް ބަލައިގަނެފައެއް ނުވޭ، އެހެންވެ އަނބުރާ ފޮނުވާނެ އެއްޗެއް ނެތް.",
        "replacementLabel": "ސަޕްލަޔަރު ބަދަލުގައި މުދާ ފޮނުވަނީ",
        "replacementMeaning": "ފައިސާ އަނބުރާ ދިނުމުގެ ބަދަލުގައި މުދާ ބަދަލުކުރެވެނީ.",
        "replacementNoCredit": "ބަދަލު — ކްރެޑިޓެއް ނެތް",
        "replacementNoCreditLong": "ބަދަލުގައި މުދާ ލިބޭ ރިޓާނަކުން ޑެބިޓް ނޯޓެއް ނުނަގާ. ސަޕްލަޔަރު ފައިސާ އަނބުރާ ދިނުމުގެ ބަދަލުގައި މުދާ އަލުން ފޮނުވަނީ، އެހެންވެ ކްރެޑިޓްކުރާނެ އެއްޗެއް ނެތް.",
        "saved": "ރިޓާން އުފައްދައިފި",
        "saveFailed": "ރިޓާން އުފެއްދިފައެއް ނުވޭ",
        "subtitle": "{vendor} އަށް",
        "factsTitle": "ބަޔާން",
        "sourceReceipt": "ބަލައިގަތުމުން",
        "noDebitNoteYet": "އަދި ނުނަގާ",
        "submitted": "ރިޓާން ހުށަހަޅައިފި",
        "submitFailed": "ރިޓާން ހުށަނޭޅުނު",
        "approved": "ރިޓާން ފާސްކޮށްފި",
        "rejected": "ރިޓާން ބޭރުކޮށްފި",
        "decideFailed": "ނިންމުން ވި ނޫން ރެކޯޑްކުރެވިފައި",
        "despatch": "ފޮނުވުން",
        "despatched": "މުދާ ފޮނުވައިފި",
        "despatchFailed": "ފޮނުވުން ރެކޯޑެއް ނުކުރެވުނު",
        "despatchMeaning": "ސްޓޮކް ނުކުންނަނީ ފޮނުވުމުން. އޭގެ ކުރީގެ ހުރިހާ ކަމަކީ ލިޔެކިޔުން.",
        "approvedNotGone": "ފާސްކުރެވިފައި، ފޮނުވިފައެއް ނުވޭ. ސްޓޮކް އަދިވެސް ގުދަނުގައި ހުރި، އަދި ގުނުމުގައި ހިމެނޭ.",
        "raiseDebitNote": "ޑެބިޓް ނޯޓް ނަގާ",
        "debitNoteRaised": "ޑެބިޓް ނޯޓް ނަގައިފި",
        "debitNoteFailed": "ޑެބިޓް ނޯޓް ނުނެގުނު",
        "backToList": "ސަޕްލަޔަރ ރިޓާންތަކަށް އެނބުރި"
      },
      "suppliers": {
        "title": "ސަޕްލަޔަރުން",
        "description": "ކޮލިފިކޭޝަން، ކޮމްޕްލަޔަންސް އަދި މުހިންމުކަން — އޯޑަރެއް ހެދުމުގެ ކުރިން ގަންނަ ފަރާތަށް ބޭނުންވާ ކަންކަން.",
        "tableTitle": "ސަޕްލަޔަރުން",
        "caption": "ސަޕްލަޔަރުންނާއި އޭގެ ކޮލިފިކޭޝަން، މުހިންމުކަން އަދި ސްކްރީނިންގެ ނަތީޖާ.",
        "searchLabel": "ހޯދާ",
        "searchPlaceholder": "ކޯޑް ނަން",
        "loadFailed": "ސަޕްލަޔަރުން ލޯޑެއް ނުވި",
        "empty": "އަދި ސަޕްލަޔަރެއް ނެތް.",
        "emptyFiltered": "މި ފިލްޓަރުތަކާ ގުޅޭ ސަޕްލަޔަރެއް ނެތް.",
        "notFound": "އެ ސަޕްލަޔަރު ނުފެނުނު، ނުވަތަ އެއީ ތިޔަ ބޭފުޅާގެ ސްކޯޕުން ބޭރު.",
        "neverScreened": "ދުވަހަކުވެސް ބެލިފައެއް ނުވޭ",
        "columns": {
          "qualifiedUntil": "ކޮލިފައިވެފައި ވަނީ",
          "screening": "ސްކްރީނިންގ"
        },
        "factsTitle": "ސަޕްލަޔަރ",
        "backToList": "ސަޕްލަޔަރުންނަށް އެނބުރި"
      },
      "documents": {
        "title": "ކޮމްޕްލަޔަންސް ލިޔުންތައް",
        "caption": "ކޮމްޕްލަޔަންސް ލިޔުންތަކާއި އޭގެ މުއްދަތާއި ޔަގީންކުރުމުގެ ޙާލަތު.",
        "add": "ލިޔުމެއް އިތުރުކުރޭ",
        "dialogDescription": "ބްލޮކްކުރާ ލިޔުމެއްގެ ބާވަތެއް ނެތްނަމަ ނުވަތަ މުއްދަތު ހަމަވެފައިވާނަމަ ޕާޗޭސް އޯޑަރުތައް ބަލައެއް ނުގަނެވޭނެ.",
        "type": "ލިޔުމުގެ ބާވަތް",
        "reference": "ރެފަރެންސް",
        "issuedOn": "ދޫކުރި",
        "expiresOn": "މުއްދަތު ހަމަވާ ތާރީޚު",
        "expiryHint": "މުއްދަތު ހަމަނުވާ ލިޔުމަކަށް ހުސްކޮށް ދޫކުރޭ.",
        "noExpiry": "މުއްދަތެއް ނެތް",
        "noExpiryMeaning": "މުއްދަތެއް ނެތްނަމަ މި ލިޔުން ދުވަހަކުވެސް ބާޠިލެއް ނުވާނެ، އަދި އޭގެ ފަހަތުން އެއްވެސް އެއްޗެއް ނާރާނެ.",
        "expiredOn": "{date} ގައި މުއްދަތު ހަމަވެއްޖެ",
        "expiresIn": "{days} ދުވަހުން މުއްދަތު ހަމަވާނެ",
        "blocking": "ހުއްޓުވާ",
        "blockingHint": "ނެތްނަމަ ނުވަތަ މުއްދަތު ހަމަވެފައިވާނަމަ އޯޑަރު ބަލައެއް ނުގަނެވޭނެ",
        "advisoryHint": "ރެކޯޑްކުރެވޭ، ނުހުއްޓުވާ",
        "blockingMeaning": "މި ބާވަތުން ހުއްޓުވާ: ލިޔުން ނެތްހާ ހިނދަކު ނުވަތަ މުއްދަތު ހަމަވެފައިވާހާ ހިނދަކު، މި ސަޕްލަޔަރަށް ދޭ ޕާޗޭސް އޯޑަރު ބަލައެއް ނުގަނެވޭނެ.",
        "blockingProblem": "ބްލޮކްކުރާ {count} ލިޔުމެއް ނެތް ނުވަތަ މުއްދަތު ހަމަވެއްޖެ. އޯވަރައިޑްނުކުރާހާ ހިނދަކު މި ސަޕްލަޔަރަށް ދޭ ޕާޗޭސް އޯޑަރު ބަލައެއް ނުގަނެވޭނެ.",
        "empty": "ކޮމްޕްލަޔަންސް ލިޔުމެއް ރެކޯޑްކުރެވިފައެއް ނުވޭ.",
        "verify": "ކަށަވަރުކުރޭ",
        "verified": "ލިޔުން ޔަގީންކޮށްފި",
        "verifyFailed": "ލިޔުން ޔަގީނެއް ނުކުރެވުނު",
        "rejectedByReviewer": "މުރާޖަޢާގައި ބޭރުކުރެވުނު",
        "saved": "ލިޔުން ރެކޯޑްކޮށްފި",
        "saveFailed": "ލިޔުން ރެކޯޑެއް ނުކުރެވުނު"
      },
      "screening": {
        "title": "ސްކްރީނިންގެ ތާރީޚު",
        "caption": "ސެންކްޝަން، ޕީއީޕީ، ނޭދެވޭ މީޑިއާ އަދި މިލްކުވެރިކަމުގެ ސްކްރީނިންތަކާއި އޭގެ ހެކި.",
        "add": "ސްކްރީނިން ރެކޯޑްކުރޭ",
        "dialogDescription": "ޝާއިޢުކޮށްފައިވާ ލިސްޓަކާ އަޅާކިޔައި ސްކްރީނިންއެއް ރެކޯޑްކުރޭ، ނަތީޖާއަށް ބާރުދޭ ހެއްކާއެކު.",
        "manualProvider": "ފޯރުކޮށްދޭ ފަރާތުގެ ގޮތުގައި ރެކޯޑްކުރެވެނީ `manual`: ޝާއިޢުކޮށްފައިވާ ލިސްޓެއް ކިޔާ މީހެއް. އެއީ ފުރިހަމަ ސްކްރީނިންއެއް، އަދި މެނުއަލްގެ ގޮތުގައި ރެކޯޑްކުރުމުން އަހަރުތަކެއް ފަހުންވެސް އޮޑިޓްކުރެވޭ.",
        "list": "ލިސްޓް",
        "screenedName": "ބެލި ނަން",
        "country": "ގައުމު",
        "outcome": "ނަތީޖާ",
        "outcomeMeaning": {
          "clear": "ގުޅުމެއް ނުފެނުނު",
          "potential_match": "މުރާޖަޢާ ބޭނުންވޭ؛ އެއްވެސް އެއްޗެއް ނުހުއްޓުވޭ",
          "confirmed_match": "ލިސްޓުގައި ޔަގީން ގުޅުމެއް",
          "error": "ސްކްރީނިން ފުރިހަމަނުކުރެވުނު"
        },
        "matchCount": "ގުޅުންތައް",
        "evidence": "އެވިޑެންސް",
        "evidenceHint": "ހޯދި އެއްޗެއް، ކޮންތާކުން، އަދި ލިބުނު ނަތީޖާ.",
        "reference": "ރެފަރެންސް",
        "provider": "ފޯރުކޮށްދޭ ފަރާތް",
        "review": "ބައްލަވާ",
        "screenedAt": "ބެލި ވަގުތު",
        "absoluteMeaning": "ސެންކްޝަން ލިސްޓާ ޔަގީންވެފައިވާ ގުޅުމެއް އޮތްނަމަ މި ސަޕްލަޔަރަށް ދޭ ހުރިހާ ޕާޗޭސް އޯޑަރެއް ބަލައެއް ނުގަނެވޭނެ، އަދި އޯވަރައިޑްކުރެވޭ ގޮތެއް ނެތް. އެހެން ހުރިހާ ސަޕްލަޔަރ ދެކޮޅުހެދުމަކާ ޚިލާފަށް، އެއްވެސް ޕޮލިސީއަކުން މިކަން ލުއިއެއް ނުކުރެވޭނެ.",
        "potentialMeaning": "ވެދާނެ ގުޅުމެއް ފޮނުވެނީ މުރާޖަޢާއަށް، އަދި އެއިން އެއްވެސް އެއްޗެއް ނުހުއްޓުވޭ. އެއީ އެއް ފަރާތެއްތޯ މީހަކު ނިންމަން ޖެހޭ.",
        "record": "ސްކްރީނިން ރެކޯޑްކުރޭ",
        "reviewed": "ސްކްރީނިން މުރާޖަޢާކޮށްފި",
        "reviewFailed": "މުރާޖަޢާ ރެކޯޑެއް ނުކުރެވުނު",
        "empty": "ސްކްރީނިންއެއް ރެކޯޑްކުރެވިފައެއް ނުވޭ.",
        "saved": "ސްކްރީނިން ރެކޯޑްކޮށްފި",
        "saveFailed": "ސްކްރީނިން ރެކޯޑެއް ނުކުރެވުނު"
      },
      "policy": {
        "title": "ސަޕްލަޔަރ ޕޮލިސީ",
        "description": "ސަޕްލަޔަރުގެ މައްސަލައަކުން ޕާޗޭސް އޯޑަރަކަށް ކުރާ އަސަރު.",
        "panelTitle": "ކުންފުނީގެ ޕޮލިސީ",
        "pickCompany": "ސަޕްލަޔަރ ޕޮލިސީ ބެލުމަށް ކުންފުންޏެއް ހޮވާ.",
        "loadFailed": "ސަޕްލަޔަރ ޕޮލިސީ ލޯޑެއް ނުވި",
        "unqualified": "ކޮލިފައި ނުވާ ސަޕްލަޔަރ",
        "unqualifiedMeaning": "ޕާޗޭސް އޯޑަރެއްގައި ކޮލިފައި ނުވާ ސަޕްލަޔަރެއް ބަޔާންކުރުމުން ވާނެ ގޮތް.",
        "expiredDocument": "މުއްދަތު ހަމަވެފައިވާ ކޮމްޕްލަޔަންސް ލިޔުން",
        "expiredDocumentMeaning": "ބްލޮކްކުރާ ލިޔުމެއް ނެތްނަމަ ނުވަތަ މުއްދަތު ހަމަވެފައިވާނަމަ ވާނެ ގޮތް.",
        "unscreened": "ސްކްރީން ނުކުރެވޭ ސަޕްލަޔަރ",
        "unscreenedMeaning": "ސަޕްލަޔަރެއް ދުވަހަކުވެސް ސްކްރީން ނުކުރެވޭނަމަ، ނުވަތަ ސްކްރީނިން ބާވެފައިވާނަމަ ވާނެ ގޮތް.",
        "modeMeaning": {
          "block": "އޯޑަރު ބަލައިނުގަނޭ؛ އޯވަރައިޑްކުރެވިދާނެ",
          "warn": "ދޫކޮށްލާ، އަދި އެކަން ބުނޭ",
          "ignore": "އެއްވެސް އެއްޗެއް ނުބުނޭ"
        },
        "screeningValidityDays": "ސްކްރީނިން ސައްޙަ މުއްދަތު (ދުވަސް)",
        "requalificationMonths": "އަލުން ކޮލިފައިކުރާ މުއްދަތު (މަސް)",
        "sanctionsAbsolute": "މީގެ އެއްވެސް ޑައަލަކުން ސެންކްޝަން ލިސްޓާ ޔަގީންވެފައިވާ ގުޅުމަކަށް އަސަރެއް ނުކުރޭ. އެ ދެކޮޅުހެދުން ފުރިހަމަ، އަދި އޯވަރައިޑްކުރެވޭ ގޮތެއް ނެތް.",
        "saved": "ސަޕްލަޔަރ ޕޮލިސީ ރައްކާކޮށްފި",
        "saveFailed": "ސަޕްލަޔަރ ޕޮލިސީ ރައްކާނުކުރެވުނު"
      },
      "supplierRisk": {
        "title": "ސަޕްލަޔަރ ރިސްކް",
        "description": "ސަޕްލައި ބޭސް ހުށަހެޅިފައިވާ ތަން: މުއްދަތު ހަމަވަމުންދާ ނުވަތަ ހަމަވެފައިވާ ލިޔެކިޔުންތައް، އަދި ދުވަހަކުވެސް ސްކްރީން ނުކުރާ ސަޕްލަޔަރުން.",
        "tableTitle": "ރިސްކުން ސަޕްލަޔަރުން",
        "caption": "ސަޕްލަޔަރުންނާއި، އޭގެ ކްރިޓިކަލިޓީ، ކޮލިފިކޭޝަން، ލިޔެކިޔުމުގެ ހާލަތު އަދި ސްކްރީނިންގ ނަތީޖާ.",
        "loadFailed": "ސަޕްލަޔަރ ރިސްކް ރިޕޯޓް ލޯޑެއް ނުވި",
        "singleSource": "ހަމައެކަނި އެއް މަޞްދަރު",
        "expiredDocuments": "މުއްދަތު ހަމަވެފައިވާ ލިޔުންތައް",
        "neverScreened": "ދުވަހަކުވެސް ބެލިފައެއް ނުވޭ",
        "suspended": "ސަސްޕެންޑްކޮށްފައި",
        "openSpend": "ހުޅުވިފައިވާ ކޮމިޓްމަންޓް",
        "empty": "މި ބެލުމާ ގުޅޭ ސަޕްލަޔަރެއް ނެތް.",
        "expiringDocuments": "މުއްދަތު ހަމަވަމުންދާ ލިޔެކިޔުންތައް",
        "openCapas": "ހުޅުވިފައިވާ CAPA"
      },
      "contracts": {
        "title": "ކޮންޓްރެކްޓްތައް",
        "description": "އަގުގެ އެއްބަސްވުންތައް، ބްލޭންކެޓް އޯޑަރުތައް އަދި ފްރޭމްވޯކްތައް، އަދި އެއާ ދެކޮޅަށް ބޭނުންކުރެވުނު މިންވަރު.",
        "tableTitle": "ކޮންޓްރެކްޓްތައް",
        "caption": "ކޮންޓްރެކްޓްތަކާއި އޭގެ ބާވަތް، މުއްދަތު، ކޮމިޓްމަންޓް އަދި ބޭނުންކުރެވުނު މިންވަރު.",
        "create": "އައު ކޮންޓްރެކްޓް",
        "edit": "ކޮންޓްރެކްޓް އެޑިޓްކުރޭ",
        "dialogDescription": "ބާވަތުން ލިޔުމުގެ ބާކީ ބައިގެ މާނަ ނިންމޭ، އެހެންވެ އެއްފަހަރު ހޮވެނީ.",
        "kindHint": "އެއްފަހަރު ހޮވޭ؛ ރިލީޒްތަކުން އެއްވެސް އެއްޗެއް ބޭނުންކުރޭތޯ މިއިން ނިންމޭ.",
        "kindMeaning": {
          "price_agreement": "އަގުތައް ކަނޑައަޅާ، މިންވަރެއް ކޮމިޓެއް ނުކުރޭ",
          "blanket_order": "ރިލީޒްތަކުން ބޭނުންކުރާ މިންވަރެއް ކޮމިޓްކުރޭ",
          "framework": "ސްކޯޕެއްގައި އަގުތައް ކަނޑައަޅާ އަދި މިންވަރެއް ކޮމިޓްކުރޭ"
        },
        "searchLabel": "ހޯދާ",
        "searchPlaceholder": "ކޮންޓްރެކްޓް ނުވަތަ ސަޕްލަޔަރ",
        "loadFailed": "ކޮންޓްރެކްޓްތައް ލޯޑެއް ނުވި",
        "empty": "އަދި ކޮންޓްރެކްޓެއް ނެތް. ކޮންޓްރެކްޓަކީ ވާހަކަދައްކައިގެން ކަނޑައެޅި އަގު، ސިސްޓަމުން އަމިއްލައަށް ބޭނުންކުރާ އަގަކަށް ބަދަލުކުރާ އެއްޗެއް.",
        "emptyFiltered": "މި ފިލްޓަރުތަކާ ގުޅޭ ކޮންޓްރެކްޓެއް ނެތް.",
        "draftNo": "ދެލިކޮޕީ",
        "subtitle": "{vendor} އާއެކު",
        "columns": {
          "window": "މުއްދަތު",
          "committed": "ކޮމިޓްކޮށްފައި",
          "released": "ދޫކޮށްލާފައި",
          "received": "ލިބުނު",
          "invoiced": "އިންވޮއިސްކުރި",
          "remaining": "ބާކީ",
          "minQuantity": "އެންމެ ދަށް މިންވަރު",
          "unitPrice": "ޔުނިޓް އަގު",
          "priceBasis": "އަސާސް",
          "leadTime": "ލިބޭ މުއްދަތު",
          "minShelfLife": "އެންމެ ދަށް ޝެލްފް ލައިފް"
        },
        "vendorReference": "ސަޕްލަޔަރުގެ ރެފަރެންސް",
        "startsOn": "ފެށޭ",
        "endsOn": "ނިމޭ",
        "noticePeriodDays": "ނޯޓިސް މުއްދަތު (ދުވަސް)",
        "renewalTermMonths": "އައުކުރުމުގެ މުއްދަތު (މަސް)",
        "leadTimeDays": "ލިބޭ މުއްދަތު (ދުވަސް)",
        "autoRenewLabel": "ކެންސަލްނުކުރާހާ ހިނދަކު އަމިއްލައަށް އައުވޭ",
        "autoRenewMeaning": "ނޯޓިސް ނުދޭހާ ހިނދަކު، މުއްދަތު ނިމުމުން ކޮންޓްރެކްޓް އަމިއްލައަށް ދިގުވާނެ.",
        "autoRenewOn": "{months} މަހަށް އައުވޭ، {days} ދުވަހުގެ ނޯޓިސް",
        "autoRenewOff": "އަމިއްލައަށް އައެއް ނުވާނެ",
        "linesTitle": "އަގުގެ ލައިންތައް",
        "linesCaption": "ތާރީޚަށް ބިނާވެފައިވާ ކޮންޓްރެކްޓް އަގުތަކާއި އޭގެ މިންވަރުގެ ބްރޭކްތައް.",
        "linesEmpty": "އަގުގެ ލައިނެއް ނެތް. މި ކޮންޓްރެކްޓުން މިންވަރެއް ކޮމިޓްކުރޭ، އެކަމަކު އަގެއް ނުކަނޑައަޅާ.",
        "linesMeaning": "އަގުތައް ބިނާވެފައިވަނީ ތާރީޚަށް، އަދި ހޮވެނީ މިންވަރުގެ ބްރޭކުން. އޭޕްރީލްގައި ބަދަލުވި އަގަކުން މާރިޗުގައި ހެދި އޯޑަރެއް ބަދަލެއް ނުކުރެވޭ.",
        "commitmentsTitle": "ކޮމިޓްމަންޓްތައް",
        "commitmentsEmpty": "މި ކޮންޓްރެކްޓުން އެއްވެސް އެއްޗެއް ކޮމިޓެއް ނުކުރޭ. މިއާ ދެކޮޅަށް ހަދާ ރިލީޒްތަކުން މިންވަރެއް ބޭނުމެއް ނުކުރެވޭ.",
        "commitmentPeriod": "{from} އަށް {to}",
        "gaugeLabel": "{label}: {total} ގެ ތެރެއިން {used}",
        "overCommitmentBlocks": "ކޮމިޓްމަންޓަށްވުރެ މަތި — އިތުރު ރިލީޒް ބަލައެއް ނުގަނެވޭނެ",
        "overCommitmentWarns": "ކޮމިޓްމަންޓަށްވުރެ މަތި — ރިލީޒް ހުއްދަ، އަދި ފާހަގަކުރެވޭ",
        "wholeContract": "މުޅި ކޮންޓްރެކްޓް",
        "scopeTitle": "ދާއިރާ",
        "scopeMeaning": "މި ކޮންޓްރެކްޓުން ހިމަނާ ބައި. ސްކޯޕުން ބޭރު ރިލީޒެއް ބަލައެއް ނުގަނެވޭނެ.",
        "scopeAll": "މި ސަޕްލަޔަރުގެ ހުރިހާ އެއްޗެއް",
        "scopesEmpty": "ސްކޯޕެއް ކަނޑައަޅާފައެއް ނުވޭ.",
        "exclusive": "ޚާއްޞަ",
        "consumptionTitle": "ބޭނުންކުރުން",
        "consumptionPending": "ބޭނުންކުރުން އަދި ހިސާބުކުރެވިފައެއް ނުވޭ.",
        "termsTitle": "ޝަރުތުތައް",
        "window": "މުއްދަތު",
        "notReleasable": "މި ކޮންޓްރެކްޓް މިހާރު އެކްޓިވެއް ނޫން. މިއާ ދެކޮޅަށް ހަދާ ރިލީޒް ބަލައެއް ނުގަނެވޭނެ.",
        "activate": "ހަރަކާތްތެރިކުރޭ",
        "activated": "ކޮންޓްރެކްޓް އެކްޓިވޭޓްކޮށްފި",
        "submitted": "ކޮންޓްރެކްޓް ހުށަހަޅައިފި",
        "submitFailed": "ކޮންޓްރެކްޓް ހުށަނޭޅުނު",
        "rejected": "ކޮންޓްރެކްޓް ބޭރުކޮށްފި",
        "decideFailed": "ނިންމުން ވި ނޫން ރެކޯޑްކުރެވިފައި",
        "suspend": "ސަސްޕެންޑްކުރޭ",
        "suspended": "ކޮންޓްރެކްޓް ސަސްޕެންޑްކޮށްފި",
        "suspendFailed": "ކޮންޓްރެކްޓް ސަސްޕެންޑެއް ނުކުރެވުނު",
        "suspendedByUser": "ކޮންޓްރެކްޓް ސްކްރީނުން ސަސްޕެންޑްކުރެވުނު",
        "saved": "ކޮންޓްރެކްޓް ރައްކާކޮށްފި",
        "saveFailed": "ކޮންޓްރެކްޓް ރައްކާނުކުރެވުނު",
        "backToList": "ކޮންޓްރެކްޓްތަކަށް އެނބުރި"
      },
      "rebates": {
        "title": "ރިބޭޓްތައް",
        "caption": "ރިބޭޓް ޝަރުޠުތަކާއި އޭގެ ހައްދުތަކާއި ޖަމާވެފައިވާ މިންވަރު.",
        "threshold": "ޙައްދު",
        "rate": "ރޭޓް",
        "accrued": "ޖަމާވެފައި",
        "settled": "ދެއްކުން",
        "retrospective": "ފަހަތަށް ހިނގާ",
        "retrospectiveMeaning": "ޓިއަރއެއް ހުރަސްކުރުމުން މުޅި މުއްދަތު އަލުން ހިސާބުކުރޭ",
        "empty": "މި ކޮންޓްރެކްޓުގައި ރިބޭޓް ޝަރުޠެއް ނެތް."
      },
      "releases": {
        "title": "ރިލީޒްތައް",
        "description": "މި ކޮންޓްރެކްޓާ ދެކޮޅަށް ބޭނުންކުރެވުނު މިންވަރު، އަދި ކޮން އޯޑަރަކުންކަން.",
        "tableTitle": "ރިލީޒްތައް",
        "caption": "ރިލީޒްތަކާއި އޭގެ އޯޑަރު، މިންވަރު އަދި އަގު.",
        "loadFailed": "ރިލީޒްތައް ލޯޑެއް ނުވި",
        "empty": "މި ކޮންޓްރެކްޓާ ދެކޮޅަށް އަދި އެއްވެސް އެއްޗެއް ދޫކުރެވިފައެއް ނުވޭ.",
        "noCommitment": "މި ކޮންޓްރެކްޓުން މިންވަރެއް ކޮމިޓެއް ނުކުރޭ، އެހެންވެ ރިލީޒްތަކުން އެއްވެސް އެއްޗެއް ބޭނުމެއް ނުކުރެވޭ.",
        "hardenMeaning": "ރިލީޒަކުން ކޮންޓްރެކްޓުން ކުރިން ކުރި ކޮމިޓްމަންޓް ހަރުކުރޭ — މިއީ ދެވަނަ ކޮމިޓްމަންޓެއް ނޫން، އެހެންކަމުން ބަހައްޓާފައި ހުރި ފައިސާއަކީ އޯޑަރުން ޚަރަދުކުރާ ފައިސާ.",
        "columns": {
          "no": "ނޫން",
          "order": "އޯޑަރު",
          "releasedOn": "ދޫކޮށްލާފައި"
        },
        "backToContract": "ކޮންޓްރެކްޓަށް އެނބުރި"
      },
      "contractExpiry": {
        "title": "ކޮންޓްރެކްޓް އައުކުރުންތައް",
        "description": "ނިމެން އުޅޭ އެއްޗެއް، އަދި އޭގެ ކުރިން ނިންމަން ޖެހޭ ކަންތައް.",
        "tableTitle": "ނިމެން އުޅޭ ކޮންޓްރެކްޓްތައް",
        "caption": "ކޮންޓްރެކްޓްތަކާއި އޭގެ ނިމޭ ތާރީޚު، ނޯޓިސް ދޭން ޖެހޭ ސުންގަޑި އަދި އައުކުރުމުގެ ގޮތް.",
        "loadFailed": "އައުކުރުމުގެ ކަލަންޑަރު ލޯޑެއް ނުވި",
        "horizonLabel": "މުއްދަތު",
        "horizon": "ކުރިއަށް {days} ދުވަސް",
        "daysToExpiry": "ނިމެން ދުވަސް",
        "daysToNotice": "ނޯޓިސްއަށް ދުވަސް",
        "noticeBy": "ނޯޓިސް ދޭން ޖެހޭ",
        "pastNotice": "{count} ކޮންޓްރެކްޓެއްގެ ނޯޓިސް ސުންގަޑި ފާއިތުވެއްޖެ. ދެން ވާނެ ގޮތް މިހާރު ނިމިއްޖެ.",
        "willRenew": "އައުވޭ",
        "willLapse": "ބާޠިލުވޭ",
        "empty": "ކުރިއަށް އޮތް {days} ދުވަހުގައި ނިމޭ ކޮންޓްރެކްޓެއް ނެތް.",
        "pastNoticeShort": "ނޯޓިސް މުއްދަތު ފާއިތުވެއްޖެ"
      },
      "spend": {
        "title": "ޚަރަދުގެ ދިރާސާ",
        "description": "ފައިސާ ދިޔަ ތަނާއި، އެއިން ކޮންޓްރެކްޓުގައި ހުރި މިންވަރު.",
        "tableTitle": "ސްޕެންޑް",
        "caption": "ގްރޫޕުން ޚަރަދު، އަދި އޭގެ ކޮންޓްރެކްޓުގައި، ކޮންޓްރެކްޓުން ބޭރު އަދި ކޮންޓްރެކްޓެއް ނެތް ބައިތައް.",
        "loadFailed": "ޚަރަދުގެ ދިރާސާ ލޯޑެއް ނުވި",
        "empty": "މި މުއްދަތުގައި ޚަރަދެއް ނެތް.",
        "groupByLabel": "ބަހާލާ ގޮތް",
        "groupBy": {
          "supplier": "ސަޕްލަޔަރ",
          "category": "ބައި",
          "cost_center": "ކޮސްޓް ސެންޓަރ"
        },
        "totalSpend": "ޖުމުލަ ޚަރަދު",
        "onContract": "ކޮންޓްރެކްޓުގައި",
        "maverick": "ކޮންޓްރެކްޓުން ބޭރު",
        "noContract": "ކޮންޓްރެކްޓެއް ނެތް",
        "noContractMeaning": "ކޮންޓްރެކްޓެއް ލިބެން ނެތް ޚަރަދު ވަކިން ދައްކާ، އަދި ކޮންޓްރެކްޓުން ބޭރު ޚަރަދެއްގެ ގޮތުގައި ނުގުނާ. ކޮންޓްރެކްޓެއް ނެތްތާ ކޮންޓްރެކްޓުން ބޭރުން ގަތުމަކީ ގަންނަ ފަރާތަށް ކުރެވެން އޮތް ހަމައެކަނި ކަންތައް.",
        "lineCount": "ރޮނގުތައް",
        "drill": "ފެކްޓްތައް",
        "stageMeaning": {
          "committed": "އޯޑަރުކުރެވުނު މިންވަރު",
          "invoiced": "ބިލްކުރެވުނު މިންވަރު",
          "reversed": "ކުރީގެ ފެކްޓްތައް އަނބުރާލުން"
        }
      },
      "maverick": {
        "title": "ކޮންޓްރެކްޓުން ބޭރު ޚަރަދު",
        "description": "އޮތް ކޮންޓްރެކްޓަކުން ބޭރުން ގަނެފައި.",
        "tableTitle": "ކޮންޓްރެކްޓުން ބޭރު ލައިންތައް",
        "caption": "ކޮންޓްރެކްޓުން ބޭރު ލައިންތަކާއި ބޭނުންކުރަން ޖެހުނު ކޮންޓްރެކްޓް.",
        "loadFailed": "ކޮންޓްރެކްޓުން ބޭރު ޚަރަދުގެ ރިޕޯޓް ލޯޑެއް ނުވި",
        "empty": "މި މުއްދަތުގައި ކޮންޓްރެކްޓުން ބޭރު ޚަރަދެއް ނެތް.",
        "scopeMeaning": "ހަމައެކަނި ކޮންޓްރެކްޓެއް ލިބެން އޮތް ލައިންތައް. މުޅިން ކޮންޓްރެކްޓެއް ނެތް ޚަރަދަކީ ކޮންޓްރެކްޓުން ބޭރު ޚަރަދެއް ނޫން، އަދި މިތާ ނުދައްކާ.",
        "shouldHaveUsed": "ލިބެން ހުރި ކޮންޓްރެކްޓް",
        "priceVariance": "ކޮންޓްރެކްޓާ އަޅާކިޔާ އަގުގެ ތަފާތު",
        "classification": "ބައިކުރުން"
      },
      "spendFacts": {
        "title": "ޚަރަދުގެ ފެކްޓްތައް",
        "description": "ކޮންމެ ޚަރަދުގެ ޢަދަދެއްގެ ފަހަތުގައިވާ، ހަމައެކަނި އިތުރުކުރެވޭ ރަޖިސްޓަރީ.",
        "tableTitle": "ފެކްޓްތައް",
        "caption": "ޚަރަދުގެ ފެކްޓްތަކާއި އޭގެ މަރުޙަލާ، ބާވަތް އަދި ހޯދި މަގު.",
        "loadFailed": "ޚަރަދުގެ ފެކްޓްތައް ލޯޑެއް ނުވި",
        "empty": "މި ފިލްޓަރުތަކާ ގުޅޭ ޚަރަދުގެ ފެކްޓެއް ނެތް.",
        "appendOnly": "ފެކްޓްތައް ދުވަހަކުވެސް ނުފޮހެވޭ. ކެންސަލްކުރުމެއް، ބަންދުކުރި ލައިނެއް ނުވަތަ އަނބުރާލި ބަލައިގަތުމަކުން، އަނބުރާލި ފެކްޓް ބަޔާންކުރާ މައިނަސް ފެކްޓެއް ލިޔެވޭ، އެހެންކަމުން ރަޖިސްޓަރީ ދާއިމަށް ލެޖަރާ ދިމާވޭ.",
        "stage": "މަރުޙަލާ",
        "route": "ރައުޓްކުރޭ",
        "reverses": "#{id} އަނބުރާލާ"
      },
      "exceptions": {
        "title": "މެޗް އެކްސެޕްޝަންތައް",
        "description": "އިންވޮއިސްގެ މައްސަލަތައް، ޖަވާބުދެވޭނެ ފަރާތަށް ފޮނުވިފައި.",
        "tableTitle": "ސަބަބުން ބަހާލެވިފައިވާ އެކްސެޕްޝަންތައް",
        "loadFailed": "މެޗް އެކްސެޕްޝަންތައް ލޯޑެއް ނުވި",
        "empty": "ހުޅުވިފައިވާ މެޗް އެކްސެޕްޝަނެއް ނެތް.",
        "notApprovals": "މިއީ ފާސްކުރުމުގެ އިންބޮކްސްއެއް ނޫން. އެކްސެޕްޝަނަކަށް ވެރިއަކު ހުރޭ، އަދި އެ ބެލެވޭ؛ ޓޮލަރެންސް ފަހަނައަޅައި ދިޔުމެއް ބަލައިގަތުމަކީ، ވަކި ހުއްދައަކާއެކު، މެޗުގައި ކުރެވޭ އެހެން ކަމެއް.",
        "cause": "ސަބަބު",
        "ownerHint": "{owner} އަށް ފޮނުވިފައި",
        "owner": "ވެރިފަރާތް",
        "unowned": "ހަވާލުކޮށްފައެއް ނުވޭ",
        "expected": "ހުންނަން ޖެހޭ",
        "actual": "ޙަޤީޤީ",
        "variance": "ތަފާތު",
        "due": "މުއްދަތު",
        "overdue": "މުއްދަތު ފަހަނައަޅާފައި",
        "overdueOnly": "މުއްދަތު ފާއިތުވީ އެކަނި",
        "mineOnly": "ހަމައެކަނި އަހަރެންގެ",
        "select": "އެކްސެޕްޝަން ހޮވާ",
        "previewTitle": "ކުރިން ބަލާލުން",
        "previewEmpty": "ލިސްޓުން ނުނިކުމެ ބެލުމަށް އެކްސެޕްޝަނެއް ހޮވާ.",
        "openMatch": "މެޗް ހުޅުވާ",
        "resolveTitle": "ހައްލުކުރޭ",
        "resolveMeaning": "މިކަން ބެލިކަމާއި ފެނުނު އެއްޗެއް ރެކޯޑްކުރޭ. ޓޮލަރެންސް ފަހަނައަޅައި ދިޔުމެއް ބަލައެއް ނުގަނޭ.",
        "resolutionNote": "ފެނުނު އެއްޗެއް",
        "resolveOne": "މިއެއް ޙައްލުކުރޭ",
        "resolveMany": "ހޮވިފައިވާ {count} ޙައްލުކުރޭ",
        "resolved": "އެކްސެޕްޝަންތައް ޙައްލުކޮށްފި",
        "resolveFailed": "އެކްސެޕްޝަން ޙައްލެއް ނުކުރެވުނު",
        "resolutionActionLabel": "ނިންމުނު ގޮތް",
        "resolutionActionHint": "ޙައްލާއެކު ރައްކާކުރެވޭ. \"ޙައްލުކޮށްފި\" އެކަނި ބުނުމުން އިންވޮއިސް ބަލައިގަތީތޯ ނުވަތަ ބޭރުކުރީތޯ ނޭނގޭ.",
        "goThere": "އެތަނަށް ދޭ",
        "closesRefused": "މިއިން އެކްސެޕްޝަން ބަންދުވަނީ ބޭރުކުރެވުނު ގޮތުގައި: މިހާރު އޮތްގޮތަށް އިންވޮއިސް ނުދެއްކޭނެ."
      },
      "causes": {
        "title": "މެޗް ސަބަބުތައް",
        "description": "ކޮންމެ ބާވަތެއްގެ އިންވޮއިސް މައްސަލައެއްގެ ވެރިފަރާތާއި، އެފަރާތަށް ލިބޭ ވަގުތު.",
        "tableTitle": "ސަބަބުތައް",
        "caption": "މެޗް ސަބަބުތަކާއި އޭގެ ވެރިފަރާތް ކަނޑައެޅުމާއި އެސްއެލްއޭ.",
        "loadFailed": "މެޗް ސަބަބުތައް ލޯޑެއް ނުވި",
        "ownerRole": "ދައުރުގެ ކޯޑް",
        "ownerMeaning": {
          "buyer": "އޯޑަރު ހެދި މީހާ",
          "requester": "އެދުނު މީހާ",
          "warehouse_manager": "ބަލައިގަންނަ ގުދަނުގެ މެނޭޖަރު",
          "role": "ބަޔާންކުރެވިފައިވާ ރޯލް އޮތް ކޮންމެ މީހެއް",
          "user": "ކަނޑައެޅިފައިވާ އެއް މީހެއް",
          "finance": "ކުންފުނީގެ ފައިނޭންސް މެނޭޖަރު"
        },
        "slaHours": "އެސްއެލްއޭ (ގަޑިއިރު)",
        "slaMeaning": "ސުންގަޑި ހިސާބުކުރެވެނީ ޓެނަންޓުގެ މަސައްކަތު ވަގުތުން، އެހެންވެ ހުކުރު ދުވަހުގެ ހަތަރެއްގައި ހުށަހެޅި 24 ގަޑިއިރުގެ އެސްއެލްއޭއެއްގެ ސުންގަޑި ޖެހޭނީ ހޮނިހިރު ދުވަހުގެ ބަދަލުގައި ހޯމަ ދުވަހުގެ މެންދުރުފަހު.",
        "autoResolvable": "އަމިއްލައަށް ސާފުވޭ",
        "autoResolvableYes": "ސަބަބު ނެތުމުން އަމިއްލައަށް ސާފުވޭ",
        "saved": "ސަބަބު ރައްކާކޮށްފި",
        "saveFailed": "ސަބަބު ރައްކާނުކުރެވުނު"
      },
      "amendments": {
        "title": "އޯޑަރުގެ އިޞްލާޙުތައް",
        "description": "އޯޑަރު ދޫކުރުމަށްފަހު، މުދާ ލިބުމަށްފަހުވެސް، ގެނެވޭ ބަދަލުތައް.",
        "tableTitle": "އިޞްލާޙުތައް",
        "caption": "އިޞްލާޙުތަކާއި އޭގެ ކުރީގެ އަދި ފަހުގެ ޖުމުލަތަކާއި ފާސްކުރުމުގެ ޙާލަތު.",
        "loadFailed": "އިޞްލާޙުތައް ލޯޑެއް ނުވި",
        "empty": "މި އޯޑަރު އިޞްލާޙުކުރެވިފައެއް ނުވޭ.",
        "create": "އައު އިޞްލާޙު",
        "drawerDescription": "ބަދަލުވާ އަގުތައް އެކަނި ލިޔޭ. ހުސްކޮށް ދޫކުރާ ހުރިހާ އެއްޗެއް ހުރިގޮތަށް ދެމިހުންނާނެ.",
        "drawerCaption": "އޯޑަރު ލައިންތަކާއި އޯޑަރުކުރި އަދި ލިބުނު މިންވަރު.",
        "afterReceiptMeaning": "މުދާ ލިބުމަށްފަހުވެސް އޯޑަރެއް އިޞްލާޙުކުރެވިދާނެ. ނުކުރެވޭނެ ކަމަކީ ލިބިފައިވާ މިންވަރަށްވުރެ ދަށަށް ލައިނެއް ކުޑަކުރުން.",
        "version": "ވަރޜަން",
        "totalBefore": "ކުރިން",
        "totalAfter": "ފަހުން",
        "band": "އިދާރާ",
        "crossesBand": "ބޭންޑެއް ހުރަސްކުރޭ",
        "change": "ބަދަލުކުރޭ",
        "expectedDate": "ހުންނަން ޖެހޭ",
        "ordered": "އޯޑަރުކުރި",
        "received": "ލިބުނު",
        "newQuantity": "އައު މިންވަރު",
        "newPrice": "އައު އަގު",
        "newDate": "އައު ތާރީޚު",
        "belowReceived": "{count} ލައިނެއް މިހާރު ލިބިފައިވާ މިންވަރަށްވުރެ ދަށް. ސާވަރުން އިޞްލާޙު ބަލައިނުގަނެ، ލިބުނު މިންވަރު ބުނާނެ.",
        "linesCaption": "އިޞްލާޙުގެ ލައިންތައް، ކުރިން އަދި ފަހުން.",
        "linesEmpty": "މި އިޞްލާޙުގައި ލައިނަށް ބަދަލެއް ނެތް.",
        "apply": "ހަމަޖައްސާ",
        "applied": "އިޞްލާޙު ހިންގައިފި",
        "applyFailed": "އިޞްލާޙު ނުހިންގުނު",
        "submitted": "އިޞްލާޙު ހުށަހަޅައިފި",
        "submitFailed": "އިޞްލާޙު ހުށަނޭޅުނު",
        "approved": "އިޞްލާޙު ފާސްކޮށްފި",
        "decideFailed": "ނިންމުން ވި ނޫން ރެކޯޑްކުރެވިފައި",
        "saved": "އިޞްލާޙު ޑްރާފްޓްކޮށްފި",
        "saveFailed": "އިޞްލާޙު ރައްކާނުކުރެވުނު",
        "backToOrder": "އޯޑަރަށް އެނބުރި"
      },
      "schedule": {
        "title": "ޑެލިވަރީ ތާވަލު",
        "description": "ކޮންމެ ލައިނެއް ލިބޭނެ ވަގުތު، އަދި ކިތައް ފަހަރަށް ބަހާލައިގެންކަން.",
        "caption": "ޑެލިވަރީގެ މަރުޙަލާތަކާއި އޭގެ ތާރީޚާއި މިންވަރު.",
        "loadFailed": "ޑެލިވަރީ ތާވަލު ލޯޑެއް ނުވި",
        "empty": "މި ލައިނުގައި ތާވަލެއް ނެތް — މުޅި މިންވަރު ލިބޭނެކަމަށް ބެލެވެނީ ލައިނުގެ އަމިއްލަ ތާރީޚުގައި.",
        "seq": "ނޫން",
        "scheduledDate": "ތާވަލުކުރެވިފައި",
        "addRung": "ޑެލިވަރީއެއް އިތުރުކުރޭ",
        "foots": "ލައިނާ ދިމާވޭ",
        "residual": "އޯޑަރުކުރި {ordered} ގެ ތެރެއިން {qty} ތާވަލުނުކުރެވޭ",
        "deferredMeaning": "މަރުޙަލާތަކުގެ ޖުމުލަ ލައިނުގެ މިންވަރާ ދިމާވާން ޖެހޭ، އަދި އެކަން ބެލެނީ ކޮންމެ ކީއެއް ފިތާލުމުން ނޫން، ތާވަލު ރައްކާކުރުމުން — އެހެންވެ އަދި ދިމާނުވާ ޙާލަތްތަކުން ތާވަލެއް އެޑިޓްކުރެވިދާނެ.",
        "saved": "ޑެލިވަރީ ތާވަލު ރައްކާކޮށްފި",
        "saveFailed": "ޑެލިވަރީ ތާވަލު ރައްކާނުކުރެވުނު"
      },
      "incoterms": {
        "title": "އިންކޯޓާމްތައް",
        "description": "ޑެލިވަރީގެ ޝަރުޠުތަކާއި ކޮން އަގެއް ކާކު އުފުލާނެކަން.",
        "tableTitle": "އިންކޯޓާމްތައް",
        "caption": "އިންކޯޓާމްތަކާއި އޭގެ އަގުގެ ޒިންމާތަކާއި ރިސްކް ބަދަލުވާ ހިސާބު.",
        "loadFailed": "އިންކޯޓާމްތައް ލޯޑެއް ނުވި",
        "empty": "އިންކޯޓާމެއް ކަނޑައަޅާފައެއް ނުވޭ.",
        "costMeaning": "ވަކިން ބުނާ ފްރެއިޓް ނުވަތަ ޑިއުޓީ އަގު މިހާރުވެސް އަގުގެ ތެރޭގައި ހިމެނޭތޯ ނިންމަނީ އިންކޯޓާމުން. ސީއައިއެފް އަގެއްގެ ފްރެއިޓް ހިމެނެނީ އަގުގެ ތެރޭގައި؛ އެފްއޯބީ އަގެއްގައި ނުހިމެނޭ — މިއީ ލޭންޑަޑް ކޮސްޓް އަޅާކިޔުން އިތުބާރުކުރެވޭ ސަބަބު.",
        "freight": "ފްރެއިޓް",
        "insurance": "އިންޝުއަރެންސް",
        "duty": "ޑިއުޓީ",
        "riskTransfer": "ރިސްކް ބަދަލުވަނީ",
        "namedPlace": "ބަޔާންކުރެވޭ ތަން",
        "required": "ބޭނުންވޭ",
        "notRequired": "ބޭނުމެއް ނުވޭ"
      },
      "rfq": {
        "evaluationTitle": "{no} ވަޒަންކުރަނީ",
        "evaluationDescription": "މިންގަނޑުތައް، ބިޑްތައް، ސާފުކުރުންތައް އަދި ދިނުން.",
        "backToRfq": "ޓެންޑަރަށް އެނބުރި",
        "loadFailed": "ޓެންޑަރު ލޯޑެއް ނުވި",
        "criteriaTitle": "ކްރައިޓީރިއާ",
        "criteriaCaption": "ސްކޯރު ދިނުމުގެ މިންގަނޑުތަކާއި އޭގެ ބަރުދަން، ދިމާ އަދި ގޭޓްތައް.",
        "criteriaEmpty": "މިންގަނޑެއް ކަނޑައަޅާފައެއް ނުވޭ.",
        "noCriteriaMeaning": "މިންގަނޑެއް ނެތްނަމަ ޓެންޑަރު ސްކޯރުކުރެވެނީ ކުރިންވެސް ކުރި ގޮތަށް، ހެޑަރުގައިވާ ތިން ބަރުދަނުން.",
        "weight": "ބަރުދަން",
        "direction": "ދިމާ",
        "lowerIsBetter": "ދަށްވުން ރަނގަޅު",
        "higherIsBetter": "މަތިވުން ރަނގަޅު",
        "gate": "ގޭޓް",
        "gateMeaning": "ސްކޯރު ދިނުމުގެ ބަދަލުގައި ބޭރުކުރޭ",
        "sealedTitle": "ބަންދުކުރެވިފައި",
        "sealedMeaning": "ބިޑްތައް {at} އާ ހަމައަށް ސީލްކޮށްފައި. މި ސްކްރީނަށް އެއްވެސް އަގެއް ފޮނުވިފައެއް ނުވޭ.",
        "sealLifted": "ސުންގަޑި ފާއިތުވެއްޖެ",
        "openableMeaning": "ސުންގަޑި ފާއިތުވެއްޖެ، އެހެންވެ މިހާރު ޓެންޑަރު ހުޅުވިދާނެ. މީހަކު ހެކިވެރިއަކާއެކު ހުޅުވަންދެން އެއީ ހުޅުވިފައިވާ އެއްޗެއް ނޫން، އަދި އެކަން އޮޑިޓްކުރެވޭ.",
        "bidderCount": "{count} ބިޑް ލިބިއްޖެ",
        "open": "ޓެންޑަރު ހުޅުވާ",
        "openTitle": "ސީލްކޮށްފައިވާ ޓެންޑަރު ހުޅުވާ",
        "openDescription": "ދެ މީހުން، އޭގެ ތެރެއިން އެކަކީ ތިޔަ ބޭފުޅާ.",
        "twoPersonMeaning": "ސީލްކޮށްފައިވާ ޓެންޑަރެއް އެކަނި ނުހުޅުވޭނެ. ހެކިވެރިޔަކީ ހުޅުވުމުގެ ބާރު ލިބިފައިވާ އެހެން މީހަކަށް ވާންޖެހޭ، އަދި ދެ ނަން ރެކޯޑްކުރެވޭ.",
        "witness": "ހެކިވެރިޔާ",
        "noWitnessAvailable": "ސީލްކޮށްފައިވާ ޓެންޑަރެއް ހުޅުވުމުގެ ބާރު އެހެން އެއްވެސް މީހަކަށް ލިބިފައެއް ނުވޭ. ދެވަނަ މީހަކަށް އެ ބާރު ދެވެންދެން ޓެންޑަރު ނުހުޅުވޭނެ.",
        "cannotOpen": "ސީލްކޮށްފައިވާ ޓެންޑަރެއް ހުޅުވުމުގެ ބާރު ތިޔަ ބޭފުޅާއަށް ލިބިފައެއް ނުވޭ.",
        "opened": "ޓެންޑަރު ހުޅުވައިފި",
        "openFailed": "ޓެންޑަރު ނުހުޅުވުނު",
        "comparisonTitle": "އަޅާކިޔުން",
        "comparisonCaption": "ބަރުދަން ދެވިފައިވާ ސްކޯރުން ތަރުތީބުކުރެވިފައިވާ ބިޑްތައް، ލޭންޑަޑް ޖުމުލައާއެކު.",
        "comparisonEmpty": "އަޅާކިޔާނެ ބިޑެއް ނެތް.",
        "comparisonFailed": "އަޅާކިޔުން ލޯޑެއް ނުވި",
        "rank": "ދަރަޖަ",
        "total": "ބުނި ޖުމުލަ",
        "landedTotal": "ލޭންޑަޑް ޖުމުލަ",
        "lowestLandedTotal": "އެންމެ ދަށް ލޭންޑަޑް ޖުމުލަ",
        "leadTime": "ލިބޭ މުއްދަތު",
        "score": "ސްކޯރ",
        "late": "ލަސް",
        "lateMeaning": "ލަސް",
        "pick": "ހޮވާ",
        "excludedBy": "ބޭރުކުރީ",
        "excludedCaption": "ގޭޓް މިންގަނޑަކުން ނަގާލެވުނު ބިޑްކުރާ ފަރާތްތައް.",
        "gateExclusionMeaning": "ސްކޯރުތައް ހަމަހަމަކުރުމުގެ ކުރިން ގޭޓްތަކުން ބިޑްކުރާ ފަރާތްތައް ނަގާލޭ، އެހެންވެ ބޭރުކުރެވުނު ބިޑަކުން އެހެން އެންމެންގެ ރޭންޖު ދިގެއް ނުކުރެވޭނެ. ސުމެއް ދިނުމުގެ ބަދަލުގައި ލިސްޓްކުރެވޭ.",
        "clarificationsTitle": "ސާފުކުރުންތައް",
        "clarificationAnonymity": "ޝާއިޢުކުރެވޭ ޖަވާބުތައް، ސުވާލުކުރި މީހާގެ ނަން ނުދީ، ހުރިހާ ބިޑްކުރާ ފަރާތަކަށް ދޭ.",
        "clarificationsEmpty": "މި ޓެންޑަރުގައި ސާފުކުރުމެއް ނެތް.",
        "question": "ސުވާލު",
        "answer": "ޖަވާބު",
        "saveAnswer": "ޖަވާބު ރައްކާކުރޭ",
        "publish": "ހުރިހާ ބިޑްކުރާ ފަރާތްތަކަށް ޝާއިޢުކުރޭ",
        "publishedAt": "ޝާއިޢުކުރީ {at}",
        "record": "ރެކޯޑްކުރޭ",
        "clarificationAsked": "ސާފުކުރުން ރެކޯޑްކޮށްފި",
        "clarificationAnswered": "ޖަވާބު ރައްކާކޮށްފި",
        "clarificationPublished": "ޖަވާބު ހުރިހާ ބިޑްކުރާ ފަރާތްތަކަށް ޝާއިޢުކޮށްފި",
        "clarificationFailed": "ސާފުކުރުން ރައްކާނުކުރެވުނު",
        "awardTitle": "ދިނުން",
        "awardDescription": "ކާމިޔާބުކުރާ ފަރާތާއި، އޭގެ ސަބަބު.",
        "pickFirst": "ފުރަތަމަ އަޅާކިޔުމުން ބިޑެއް ހޮވާ.",
        "rationale": "ސަބަބު ބަޔާންކުރުން",
        "overrideReason": "އޯވަރައިޑް ސަބަބު",
        "overrideMeaning": "މި ބިޑް ފުރަތަމަ ދަރަޖައިގައެއް ނެތް. މިއަށް ދިނުމަށް ސަބަބެއް ބޭނުންވޭ، އަދި އެ ސަބަބު ދިން ފަރާތުގެ ރެކޯޑްގައި ދާއިމަށް ބެހެއްޓޭ.",
        "awardAction": "ޓެންޑަރު ދޭ",
        "awarded": "ޓެންޑަރު ދީފި",
        "awardFailed": "ޓެންޑަރު ނުދެވުނު",
        "awardRecordTitle": "ދިން ފަރާތުގެ ރެކޯޑް",
        "recommended": "ލަފާދޭ"
      },
      "resolutionAction": {
        "accept_variance": "ތަފާތު ބަލައިގަންނަވާ",
        "correct_receipt": "ރަސީދު ރަނގަޅުކުރޭ",
        "amend_order": "އޯޑަރު އިޞްލާޙުކުރޭ",
        "raise_debit_note": "ޑެބިޓް ނޯޓެއް ހުށަހަޅާ",
        "dispute_invoice": "އިންވޮއިސްއާ ދެކޮޅު ހަދާ",
        "reject_invoice": "އިންވޮއިސް ބޭރުކުރޭ"
      },
      "resolutionActionHint": {
        "accept_variance": "އިންވޮއިސް ރަނގަޅު، އަދި ތަފާތު ހުރީ ބަލައިގަނެވޭ މިންވަރެއްގައި.",
        "correct_receipt": "ގޯސްވީ ރަސީދު، އިންވޮއިސްއެއް ނޫން.",
        "amend_order": "އޯޑަރުގައި ހުރީ ނުބައި އަގެއް ނުވަތަ ޢަދަދެއް.",
        "raise_debit_note": "އިތުރަށް އިންވޮއިސްކޮށްފައި، މަދުން ފޮނުވާފައި، ނުވަތަ ތަކެތި އަނބުރާ ފޮނުވާފައި.",
        "dispute_invoice": "ސަޕްލަޔަރަށް ސަބަބު އަންގައި ހިފެހެއްޓިފައި؛ ފައިސާ ނުދެވޭ.",
        "reject_invoice": "ނުދެއްކޭނެ ކަމަށް ސަޕްލަޔަރަށް އަނބުރާ ފޮނުވިފައި."
      },
      "resolutionActionNext": {
        "correct_receipt": "ރަނގަޅުކުރުން ކުރެވެނީ ރަސީދުގައި.",
        "amend_order": "އިޞްލާޙު ހުށަހެޅެނީ އޯޑަރުގައި، އަދި ހުއްދައިގެ މިންވަރު ފަހަނައަޅައިފިނަމަ ފާސްކުރުމަށް ފޮނުވޭ.",
        "raise_debit_note": "ޑެބިޓް ނޯޓް ހުށަހެޅެނީ ސަޕްލަޔަރ ރިޓާނާއެކު.",
        "dispute_invoice": "ދެކޮޅު ހެދުން ރެކޯޑްވަނީ މެޗުގައި، އަދި އެއިން އިންވޮއިސް ހިފެހެއްޓޭ.",
        "reject_invoice": "ބޭރުކުރުން ރެކޯޑްވަނީ މެޗުގައި، އަދި އެއިން އިންވޮއިސް ހިފެހެއްޓޭ."
      }
    }
  },
  "crm": {
    "routeTitles": {
      "leads": "ލީޑްތައް",
      "lead": "ލީޑް",
      "opportunities": "ފުރުޞަތުތައް",
      "opportunity": "ފުރުޞަތު",
      "cases": "ކޭސްތައް",
      "case": "ކޭސް",
      "slaPolicies": "އެސްއެލްއޭ އުޞޫލުތަކާއި މަސައްކަތު ގަޑިތައް",
      "kbArticles": "ނޮލެޖް ބޭސް",
      "kbArticle": "ނޮލެޖް ބޭސް ލިޔުން",
      "pipelineReport": "ޕައިޕްލައިނާއި ކާމިޔާބުވި ނިސްބަތް",
      "conversionReport": "ލީޑް ބަދަލުވުން",
      "serviceReport": "ޚިދުމަތާއި އެސްއެލްއޭ ފުއްދުން"
    },
    "nav": {
      "label": "ސީއާރްއެމްގެ ބައިތައް",
      "leads": "ލީޑްތައް",
      "opportunities": "ފުރުޞަތުތައް",
      "cases": "ކޭސްތައް",
      "kb": "ނޮލެޖް ބޭސް",
      "slaPolicies": "އެސްއެލްއޭ އުޞޫލުތައް",
      "reports": "ރިޕޯޓުތައް"
    },
    "list": {
      "filtersTitle": "ފިލްޓަރތައް",
      "exported": "އެކްސްޕޯޓްކުރެވިއްޖެ",
      "exportedDetail": "{count} ރޯ ސީއެސްވީ ފައިލަކަށް ލިޔެވިއްޖެއެވެ."
    },
    "leads": {
      "title": "ލީޑްތައް",
      "description": "ގުޅުން ޤާއިމުކޮށްފައިވާ، އަދި ކަސްޓަމަރަކަށް ނުވާ ކޮންމެ ފަރާތެއް. ލީޑެއް ރައްކާކުރާއިރު ޑުޕްލިކޭޓަކަށް ބެލެވޭ، މަސައްކަތްކުރުން ރަނގަޅު ނަމަ ފުރުޞަތަކަށް ކޮލިފައިކުރެވޭ، އަދި ހަމައެކަނި އެއް ފަހަރު ކަސްޓަމަރަކަށް ބަދަލުކުރެވެއެވެ.",
      "tableLabel": "ލީޑްތައް",
      "loadFailed": "އެ ލީޑްތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ލީޑެއް ނެތް",
      "emptyDescription": "ފުރަތަމަ ލީޑް ރައްކާކުރޭ، ނުވަތަ ވެބް ފޯމާއި އިމްޕޯޓުން ލީޑްތައް ގެންނަން ދޫކޮށްލާ. ކޮންމެ ލީޑެއް ރައްކާކުރާއިރު މިހާރު ހުރި ލީޑްތަކާ އަޅާކިޔޭނެއެވެ.",
      "searchHint": "ނަމާއި، ކުންފުންޏާއި، އީމެއިލް ހޯދައެވެ. ބަދަލުކުރެވުނު ލީޑަކުން އޭގެ ކަސްޓަމަރު އުފެއްދި އީމެއިލް ބަދަލެއް ނުވެއެވެ، ވީމާ ކަސްޓަމަރެއްގެ ފުރަގަހުގައިވާ ލީޑް ހޯދާނީވެސް މިގޮތަށެވެ.",
      "new": "ލީޑެއް ރައްކާކުރޭ",
      "newTitle": "ލީޑެއް ރައްކާކުރޭ",
      "newDescription": "ޑުޕްލިކޭޓަކަށް ޝައްކުކުރެވޭތީ މިތާ އެއްވެސް އެއްޗެއް ހުއްޓުވައެއް ނުލައެވެ. ފުރަތަމަ ލީޑް ރައްކާކުރެވި، އެއަށްފަހު ޑުޕްލިކޭޓަކަށް ވެދާނެ ލީޑްތައް ތިޔަ ފަރާތުން ބެލުމަށް ދައްކާލެވޭނެއެވެ.",
      "save": "ލީޑް ރައްކާކުރޭ",
      "saving": "ލީޑް ރައްކާކުރަނީ",
      "savedTitle": "ލީޑް ރައްކާކުރެވިއްޖެ — ފުރަތަމަ މިތަކެތި ބަލާ",
      "savedDescription": "ލީޑް ރައްކާކުރެވިއްޖެއެވެ. މިހާރު ހުރި މި ލީޑްތައް އެއް ފަރާތަކަށް ވެދާނެ ކަމަށް ބެލެވެއެވެ.",
      "savedNote": "{name} ރައްކާކުރެވިއްޖެއެވެ.",
      "savedMergeHint": "ލީޑް ހުޅުވައިގެން ދެ ރެކޯޑް ކައިރިކޮށް އަޅާކިޔައި، މަރޖްކުރާނަންތޯ ނިންމާ. މީހަކު ބުނަންދެން އެއްވެސް އެއްޗެއް މަރޖެއް ނުކުރެވޭނެއެވެ.",
      "openCreated": "ލީޑް ހުޅުވާ",
      "createdTitle": "ލީޑް ރައްކާކުރެވިއްޖެ",
      "createdDetail": "{name} ރައްކާކުރެވިއްޖެ، އަދި މިހާރު ހުރި އެއްވެސް ލީޑެއް ޑުޕްލިކޭޓަކަށް ނުބެލެވެއެވެ.",
      "createFailed": "އެ ލީޑް ރައްކާނުކުރެވުނު",
      "detailsTitle": "ތަފްޞީލު",
      "contactHint": "ޑުޕްލިކޭޓް ބެލުމުގައި އަޅާކިޔަނީ އީމެއިލާއި ފޯނު ނަންބަރެވެ.",
      "contactlessWarning": "އީމެއިލެއް އަދި ފޯނު ނަންބަރެއް ނެތް ލީޑެއް ޑުޕްލިކޭޓަކަށް އެއްގޮތަކަށްވެސް ބެލޭކަށް ނެތެވެ — އަޅާކިޔާނެ އެއްޗެއް ނެތެވެ. އެ ލީޑް ރައްކާކުރެވޭނެ، ނަމަވެސް އެއްވެސް ފަރާތަކާ ދެކޮޅަށް ޑުޕްލިކޭޓެއްގެ ގޮތުގައި ދުވަހަކުވެސް ނުދައްކާނެއެވެ.",
      "unassigned": "ހަވާލުކޮށްފައެއް ނުވޭ",
      "disqualify": "ޑިސްކޮލިފައިކުރޭ",
      "disqualifyTitle": "މި ލީޑް ޑިސްކޮލިފައިކުރޭ",
      "disqualifyDescription": "ސަބަބު ރެކޯޑްކުރެވިގެން ލީޑް ރައްކާވެފައި ހުންނާނެއެވެ. ފަނަލުން ބޭރުވަނީއެވެ؛ ފޮހެވެނީއެއް ނޫނެވެ.",
      "disqualifyReason": "މި ލީޑަށް މަސައްކަތްކުރުން ރަނގަޅު ނޫނީ ކީއްވެ؟",
      "disqualifiedTitle": "ލީޑް ޑިސްކޮލިފައިކުރެވިއްޖެ",
      "disqualifiedDetail": "ސަބަބު ރެކޯޑްކުރެވިގެން ރައްކާވެފައި ހުންނާނެއެވެ.",
      "disqualifyFailed": "އެ ލީޑް ޑިސްކޮލިފައެއް ނުކުރެވުނު",
      "disqualifiedBanner": "ޑިސްކޮލިފައިކުރެވިފައި: {reason}",
      "mergedBanner": "މި ލީޑް ލީޑް #{id} އަށް މަރޖްކުރެވިފައިވެއެވެ. އޭގެ ތާރީޚްވެސް އެއާއެކު ބަދަލުވެއްޖެ، އަދި މި ރެކޯޑަކީ މިހާރު ހަމައެކަނި ފާހަގައެކެވެ.",
      "openSurvivor": "ބާކީ އޮތް ލީޑް ހުޅުވާ",
      "fields": {
        "firstName": "ފުރަތަމަ ނަން",
        "lastName": "ފަހު ނަން",
        "companyName": "ކުންފުނި",
        "title": "ވަޒީފާގެ ނަން",
        "email": "އީމެއިލް",
        "phone": "ފޯނު",
        "source": "މަޞްދަރު",
        "owner": "ވެރިފަރާތް",
        "notes": "ނޯޓްތައް",
        "raised": "ރައްކާކުރި",
        "score": "ސްކޯރ"
      },
      "statuses": {
        "new": "އައު",
        "contacted": "ގުޅިފައި",
        "qualified": "ކޮލިފައިވެފައި",
        "converted": "ބަދަލުކުރެވިފައި",
        "disqualified": "ޑިސްކޮލިފައިކުރެވިފައި"
      },
      "sources": {
        "web_form": "ވެބް ފޯމް",
        "import": "އިމްޕޯޓް",
        "api": "އޭޕީއައި",
        "manual": "އަތުން ލިޔެފައި",
        "referral": "ރެފަރަލް",
        "event": "ޙަފްލާ"
      },
      "rail": {
        "captured": "ރައްކާކުރި",
        "converted": "ކަސްޓަމަރަކަށް ބަދަލުކުރެވުނު",
        "merged": "ލީޑް #{id} އަށް މަރޖްކުރެވުނު",
        "customerLink": "މި ލީޑުން އުފެދުނު ކަސްޓަމަރު",
        "survivorLink": "ބާކީ އޮތް ލީޑް #{id}"
      },
      "editTitle": "މި ލީޑް އެޑިޓްކުރޭ",
      "editDescription": "ހަމައެކަނި ތަފްޞީލީ ފީލްޑްތައް. ސްޓޭޓަސް ބަދަލުވަނީ ކޮލިފައިކުރުމުން، ޑިސްކޮލިފައިކުރުމުން، ބަދަލުކުރުމުން އަދި މަރޖްކުރުމުންނެވެ — މިތަނަކުން ނޫނެވެ.",
      "sourceFixed": "ލީޑެއް އައި ތަނަކީ ވޭތުވެދިޔަ ކަމަކާ ބެހޭ ޙަޤީޤަތެއް، އަދި އެއެތި އެޑިޓެއް ނުކުރެވެއެވެ.",
      "contactChangedNote": "އީމެއިލް ނުވަތަ ފޯނު ނަންބަރު ބަދަލުކުރުމުން، ޑުޕްލިކޭޓް ބެލުމުގައި އަޅާކިޔާ އެއްޗެހި ބަދަލުވެއެވެ. މިއެތި ރައްކާކުރުމާއެކު މި ލީޑްގެ ޑުޕްލިކޭޓްތައް އައު އެއްޗިއްސާ އަޅާކިޔައި އަލުން ބެލޭނެއެވެ.",
      "savedChangesTitle": "ލީޑް އަޕްޑޭޓްވެއްޖެ",
      "savedChangesDetail": "އައު ތަފްޞީލުތަކާ ދެކޮޅަށް ޑުޕްލިކޭޓް ބެލުން އަލުން ހިންގިއްޖެއެވެ.",
      "saveFailed": "އެ ބަދަލުތައް ރައްކާނުކުރެވުނު",
      "noScore": "އަދި ސްކޯރެއް ނުދެވޭ"
    },
    "dedupe": {
      "title": "ޑުޕްލިކޭޓަކަށް ވެދާނެ",
      "description": "މީގެ އީމެއިލް ނުވަތަ ފޯނު ނަންބަރާ ވައްތަރު، މިހާރު ހުރި ލީޑްތައް. މިތާ އެއްވެސް އެއްޗެއް މަރޖްކޮށްފައެއް ނުވޭ، އަދި ތިޔަ ފަރާތުން ބުނަންދެން މަރޖެއްވެސް ނުކުރެވޭނެއެވެ.",
      "loadFailed": "ޑުޕްލިކޭޓް ބެލުން ނުހިނގި",
      "emptyTitle": "ޑުޕްލިކޭޓަކަށް ބެލެވޭ އެއްޗެއް ނެތް",
      "emptyDescription": "އެހެން އެއްވެސް ލީޑެއްގެ އީމެއިލް ނުވަތަ ފޯނު ނަންބަރު، ދެވަނަ ފަހަރަށް ބަލާލުން ބޭނުންވާ މިންވަރަށް މީގެ އެއްޗިއްސާ ކައިރިއެއް ނޫނެވެ.",
      "neverAutomatic": "މި ސްކްރީނުގައި އެއްވެސް އެއްޗެއް މަރޖެއް ނުކުރެއެވެ. މަރޖްކުރުމުން އެއް ރެކޯޑް އަނެއް ރެކޯޑަށް ވަދެ، އޭގެ ހުރިހާ ތާރީޚެއް ބަދަލުވެ، މި އެޕުން އެކަން އަނބުރާ ނުގެނެވޭނެއެވެ — ވީމާ އެއީ އަބަދުވެސް މީހަކު ނިންމާ ނިންމުމެކެވެ، ސިސްޓަމުން އެ ފަރާތުގެ ބަދަލުގައި ނިންމާ ނިންމުމެއް ނޫނެވެ.",
      "scoreScale": "ޓްރައިގްރާމް ސްކޯ، 1.00 އިން މާނަކުރަނީ ދެ އަގު އެއްގޮތްކަމެވެ",
      "review": "އަޅާކިޔައި ނިންމާ",
      "matchedHere": "ދިމާވީ މިތާ",
      "blank": "—",
      "unnamed": "ނަމެއް ނެތް ލީޑް",
      "candidateRef": "ލީޑް #{id}",
      "tableCaption": "މި ލީޑް {name} އާ އަޅާކިޔާފައި",
      "columns": {
        "field": "ފީލްޑް",
        "thisLead": "މި ލީޑް",
        "candidate": "ޑުޕްލިކޭޓަކަށް ވެދާނެ",
        "name": "ނަން",
        "companyName": "ކުންފުނި",
        "email": "އީމެއިލް",
        "phone": "ފޯނު"
      },
      "bands": {
        "identical": "އެއްގޮތް",
        "close": "ކައިރި",
        "partial": "ބައެއް"
      },
      "evidence": {
        "identical": "ނޯމަލައިޒްކުރުމަށްފަހު {field} އަކުރުން އަކުރަށް އެއްގޮތެވެ. އާންމުކޮށް މިއީ އެއް ފޯމް ދެ ފަހަރު ހުށަހެޅުމެވެ — ނަމަވެސް ނިންމުމުގެ ކުރިން ނަމާއި ކުންފުނި ބަލާށެވެ.",
        "close": "{field} ބޮޑަށް ދިމާވެއެވެ، އެކަމަކު އެއް އަގެއް ނޫނެވެ. ދެއެތި ރަނގަޅަށް ކިޔާށެވެ: މި ސްކޯރުގައި ޓައިޕޯއަކާއި މުޅިން އެހެން މީހަކާ އެއްގޮތްހެން ހީވެދާނެއެވެ.",
        "partial": "{field} ގެ ބައެއް އެކަނި ދިމާވެއެވެ. މިއީ ފަސޭހައިން އިއްތިފާޤަކަށް ވެދާނެއެވެ — އެއް އޭރިއާ ކޯޑެއް ހިއްސާކުރާ ދެ ފޯނު ނަންބަރު މިފަދަ ސްކޯރެއް ހޯދައެވެ. މިއީ ބަލާލުމަށް ދެވޭ އިޝާރާތެއް ކަމަށް ބަލާށެވެ، ނިންމުމެއް ކަމަށް ނޫނެވެ."
      },
      "fields": {
        "email": "އީމެއިލް އެޑްރެސް",
        "phone": "ފޯނު ނަންބަރު"
      },
      "matchedOn": {
        "email": "ދިމާވީ އީމެއިލް އެޑްރެހުން",
        "phone": "ދިމާވީ ފޯނު ނަންބަރުން"
      },
      "agreement": {
        "same": "އެއްގޮތް",
        "different": "ތަފާތު",
        "missing": "އަޅާނުކިޔޭ"
      },
      "blocked": {
        "converted": "މި ލީޑް މިހާރު ކަސްޓަމަރަކަށް ވެފައިވާތީ، އެހެން ލީޑަކަށް ވެއްދޭކަށް ނެތެވެ. ހަމަ ޙަޤީޤަތުގައިވެސް އެއީ އެއް ފަރާތެއް ނަމަ، ކަސްޓަމަރު ރެކޯޑުގައި އެކަން ހަމަޖައްސާށެވެ.",
        "merged": "މި ލީޑް މިހާރު އެހެން ލީޑަކަށް މަރޖްކުރެވިފައިވެއެވެ."
      }
    },
    "merge": {
      "title": "ދެ ލީޑް މަރޖްކުރޭ",
      "description": "އެއް ރެކޯޑް ބާކީ ބެހެއްޓޭ، އަނެއް ރެކޯޑް ނިމުމަކަށް ގެނެވެއެވެ. ހޮވުމުގެ ކުރިން ދެއެތި ކިޔާށެވެ.",
      "leadColumn": "މި ލީޑް (#{id})",
      "candidateColumn": "ޑުޕްލިކޭޓަކަށް ވެދާނެ (#{id})",
      "raised": "ރައްކާކުރި",
      "consequence": "ނިމުމަކަށް ގެނެވޭ ލީޑް ބަންދުވެ، އޭގެ ހުރިހާ ޙަރަކާތެއް — ކޮންމެ ކޯލެއް، ނޯޓެއް އަދި އީމެއިލެއް — ބާކީ ބަހައްޓާ ރެކޯޑަށް ބަދަލުވާނެއެވެ. މި އެޕުން އެ ދެއެތި އަލުން ވަކިކުރެވޭނެ ގޮތެއް ނެތެވެ. މިއީ ދެ ފަރާތެއް ނަމަ، މަރޖް ނުކުރާށެވެ.",
      "survivorLabel": "ބާކީ ބަހައްޓަން ބޭނުމީ ކޮން ރެކޯޑެއް؟",
      "survivorHint": "އަނެއް ރެކޯޑް ނިމުމަކަށް ގެނެވޭނެއެވެ. ތިޔަ ފަރާތަށް އެއްވެސް އެއްޗެއް ކުރިން ހޮވާދީފައެއް ނުވެއެވެ: ދުވަސްވީ ރެކޯޑުގައި ގިނަފަހަރު ތާރީޚް ހުރެއެވެ، އައު ރެކޯޑުގައި ގިނަފަހަރު މިހާރުގެ ފޯނު ނަންބަރު ހުރެއެވެ.",
      "keepThis": "{name} ބާކީ ބަހައްޓާ (ލީޑް #{id})",
      "keepCandidate": "{name} ބާކީ ބަހައްޓާ (ލީޑް #{id})",
      "plan": "{retired} (ލީޑް #{id}) ލީޑް #{surviving} އަށް ވެއްދޭނެއެވެ.",
      "confirmLabel": "މި ދެ ރެކޯޑަކީ އެއް ފަރާތެކެވެ.",
      "confirmDescription": "ތިޔަ ފަރާތުން މިކަން ބުނަނީއެވެ، ހުށަހެޅުމަކަށް އެއްބަސްވަނީއެއް ނޫނެވެ. މަތީގައިވާ ސްކޯރަކީ ހެއްކެކެވެ، ނިންމުމެއް ނޫނެވެ.",
      "confirm": "މަރޖްކުރޭ",
      "merging": "މަރޖްކުރަނީ",
      "doneTitle": "ލީޑްތައް މަރޖްކުރެވިއްޖެ",
      "doneDetail": "ލީޑް #{retired}، ލީޑް #{surviving} އަށް ވެއްދި، އޭގެ ތާރީޚްވެސް އެއާއެކު ބަދަލުވެއްޖެއެވެ.",
      "refusedChain": "ބާކީ ބަހައްޓަން ހޮވި ރެކޯޑް ވަނީ އަމިއްލައަށް އެހެން ލީޑަކަށް މަރޖްކުރެވިފައެވެ. ބަދަލުގައި އެ ލީޑަށް މަރޖްކުރާށެވެ.",
      "refusedAlreadyMerged": "އެ ލީޑް މިހާރު މަރޖްކުރެވިއްޖެ — އެހެން މީހަކު ކުރިން އެކަން ކޮށްފިއެވެ. ދިޔަ ތަން ބެލުމަށް އަލުން ލޯޑްކުރާށެވެ.",
      "blocked": {
        "converted": "އެ ރެކޯޑް މިހާރު ކަސްޓަމަރަކަށް ވެފައިވާތީ ނިމުމަކަށް ނުގެނެވޭނެއެވެ. އަނެއް ދިމާ ހޮވާށެވެ، ނުވަތަ ދެއެތިވެސް އެގޮތުގައި ބަހައްޓާށެވެ.",
        "merged": "އެ ރެކޯޑް މިހާރު އެހެން ލީޑަކަށް މަރޖްކުރެވިފައިވެއެވެ."
      }
    },
    "qualify": {
      "action": "ކޮލިފައިކުރޭ",
      "title": "މި ލީޑް ކޮލިފައިކުރޭ",
      "description": "ކޮލިފައިކުރުމުން ލީޑް ކޮލިފައިވެފައި ކަމަށް ފާހަގަކުރެވި، އެއިން އުފެދޭ ފުރުޞަތު އެއް ފިޔަވަޅުން އުފެދެއެވެ.",
      "oneStep": "މި ދޭތި އެކުގައި ހިނގާ، ވަކިވުމެއް ނެތެވެ: އެއް ޓްރާންސެކްޝަނެއްގައި ލީޑް ކޮލިފައިވެފައި ކަމަށް ފާހަގަކުރެވި، ފުރުޞަތު އުފެދެއެވެ.",
      "nameHint": "ޑީލަށް ވަކި ނަމެއް ނެތްނަމަ އޮތްގޮތަށް ބަހައްޓާށެވެ.",
      "probabilityHint": "ހުސްކޮށް ދޫކޮށްލުމުން މަރުޙަލާގެ އަމިއްލަ ނިސްބަތް ނެގޭނެއެވެ.",
      "firstStage": "ޕައިޕްލައިންގެ ފުރަތަމަ މަރުޙަލާ",
      "confirm": "ކޮލިފައިކޮށް ފުރުޞަތު އުފައްދާ",
      "qualifying": "ކޮލިފައިކުރަނީ",
      "doneTitle": "ފުރުޞަތު އުފެދިއްޖެ",
      "doneDetail": "{name} މިހާރު ޕައިޕްލައިންގައެވެ.",
      "failed": "އެ ލީޑް ކޮލިފައެއް ނުކުރެވުނު"
    },
    "convert": {
      "action": "ކަސްޓަމަރަކަށް ބަދަލުކުރޭ",
      "title": "މި ލީޑް ކަސްޓަމަރަކަށް ބަދަލުކުރޭ",
      "description": "{name} އަށް ކަސްޓަމަރު ރެކޯޑެއް އުފެއްދޭނެއެވެ.",
      "onceOnly": "ލީޑެއް ކަސްޓަމަރަކަށް ބަދަލުވަނީ ހަމައެކަނި އެއް ފަހަރެވެ. މި ލީޑްގެ ސްޓޭޓަސް ބަދަލުވާ ހަމަ އެ ޓްރާންސެކްޝަނުގައި ކަސްޓަމަރު އުފެދެއެވެ — ދޭތިވެސް ހިނގާނެ ނުވަތަ ދޭތިވެސް ނުހިނގާނެއެވެ — އަދި އެއަށްފަހު މި ޢަމަލު އަލުން ދައްކާލެވިގެން ނުވާނެއެވެ.",
      "confirm": "ކަސްޓަމަރު އުފައްދާ",
      "converting": "ކަސްޓަމަރު އުފައްދަނީ",
      "doneTitle": "ކަސްޓަމަރު އުފެދިއްޖެ",
      "doneDetail": "ކަސްޓަމަރު {code} އުފެދި، ލީޑް ބަދަލުކުރެވިފައި ކަމަށް ފާހަގަކުރެވިއްޖެއެވެ.",
      "failed": "އެ ލީޑް ބަދަލެއް ނުކުރެވުނު",
      "refusedAlreadyConverted": "މި ލީޑް މިހާރު ކަސްޓަމަރަކަށް ވެއްޖެ — މިތަން ހުޅުވާފައި ހުއްޓާ އެހެން މީހަކު ބަދަލުކޮށްފިއެވެ. ވީ ކަސްޓަމަރު ބެލުމަށް އަލުން ލޯޑްކުރާށެވެ.",
      "refusedNotQualified": "ބަދަލުކުރެވޭނީ ކޮލިފައިވެފައިވާ ލީޑެކެވެ. ފުރަތަމަ ކޮލިފައިކުރާށެވެ.",
      "convertedTitle": "ކަސްޓަމަރަކަށް ބަދަލުކުރެވިފައި",
      "convertedNote": "މި ލީޑް ކަސްޓަމަރަކަށް ވެއްޖެއެވެ. އަލުން ބަދަލެއް ނުކުރެވޭނެއެވެ — ލީޑަކަށް ހަމައެކަނި އެއް ކަސްޓަމަރެއް އޮވެއެވެ، އަދި މި ދެ ރެކޯޑް ދެކޮޅަށްވެސް ގުޅުވައިދެނީ އެ ގުޅުމެވެ.",
      "convertedAt": "ބަދަލުކުރި",
      "customer": "ކަސްޓަމަރު",
      "customerRef": "ކަސްޓަމަރު #{id}",
      "fields": {
        "customerCode": "ކަސްޓަމަރު ކޯޑު",
        "customerCodeHint": "ލާޒިމު — ލިބެންޖެހޭ ފައިސާގެ ބައިގައި ކަސްޓަމަރު ކޯޑަށް ނަންބަރު ސީރީޒެއް ނެތެވެ، ވީމާ ކޮންމެ އިންވޮއިސްއެއްގައާއި ސްޓޭޓްމަންޓެއްގައި ފެންނާނީ މި ކޯޑެވެ.",
        "paymentTerms": "ފައިސާ ދެއްކުމުގެ މުއްދަތު (ދުވަސް)",
        "creditLimit": "ކްރެޑިޓް ލިމިޓް",
        "creditLimitCurrency": "ލިމިޓްގެ ފައިސާ",
        "portalAccess": "މި ކަސްޓަމަރަށް ޕޯޓަލް ބޭނުންކުރެވޭގޮތް ހަދާ",
        "portalAccessHint": "އެ ފަރާތުގެ އޯޑަރުތަކާއި، އިންވޮއިސްތަކާއި، ކޭސްތައް ބެލުމަށް ސައިން އިން ކުރެވޭނެއެވެ."
      },
      "unavailable": {
        "converted": "މިހާރުވެސް ކަސްޓަމަރެއް.",
        "merged": "މަރޖްކުރެވިފައިވާ ލީޑެއް ބަދަލެއް ނުކުރެވޭނެ — ބާކީ އޮތް ރެކޯޑަށް ޢަމަލުކުރާށެވެ.",
        "not_qualified": "ބަދަލުކުރުމުގެ ކުރިން މި ލީޑް ކޮލިފައިކުރާށެވެ."
      }
    },
    "activities": {
      "title": "ތާރީޚް",
      "loadFailed": "ތާރީޚް ލޯޑެއް ނުކުރެވުނު",
      "deniedTitle": "މި ތާރީޚް ތިޔަ ފަރާތަށް ނުކިޔޭނެ",
      "deniedDescription": "ރެކޯޑެއްގެ ޙަރަކާތުގެ ތާރީޚް ކިޔުމަށް ވަކި ހުއްދައެއް ބޭނުންވެއެވެ. ބޭނުންނަމަ އެޑްމިނިސްޓްރޭޓަރެއްގެ ކިބައިން އެދޭށެވެ.",
      "emptyTitle": "އަދި އެއްވެސް ކަމެއް ނުހިނގާ",
      "emptyDescription": "މިތާ ލިޔެވޭ ކޯލްތަކާއި، ނޯޓްތަކާއި، އީމެއިލްތަކާއި، ބައްދަލުވުންތައް މި ރެކޯޑާއެކު ދާނެއެވެ — ކޮލިފައިކުރުމުގައާއި، މަރޖްކުރުމުގައިވެސް.",
      "kindLabel": "ބާވަތް",
      "subjectLabel": "މައުޟޫޢު",
      "bodyLabel": "ހިނގި ކަންތައް",
      "log": "ލިޔޭ",
      "logging": "ލިޔަނީ",
      "failed": "އެ އެންޓްރީ ނުލިޔެވުނު",
      "internalOnly": "އެތެރޭގައި ލިޔެވެއެވެ. އެއްވެސް ފަރާތަކަށް ނުފޮނުވެއެވެ.",
      "public": "ކަސްޓަމަރަށް ފޮނުވި",
      "kinds": {
        "note": "ނޯޓް",
        "call": "ކޯލް",
        "email": "އީމެއިލް",
        "meeting": "ބައްދަލުވުން",
        "task": "މަސައްކަތް",
        "status_change": "ސްޓޭޓަސް ބަދަލުވުން",
        "system": "ސިސްޓަމް"
      },
      "authors": {
        "system": "ސިސްޓަމް",
        "customer": "ކަސްޓަމަރު",
        "user": "ބައިވެރިއެއް"
      }
    },
    "opportunities": {
      "title": "ފުރުޞަތުތައް",
      "description": "ޕައިޕްލައިންގައިވާ ޑީލްތަކާއި، ކޮންމެ އެއްޗެއްގެ އަގާއި، ބަންދުވުމުގެ ފުރުޞަތުން ބުރަދަން ދެވިފައިވާ އަގު.",
      "tableLabel": "ފުރުޞަތުތައް",
      "loadFailed": "އެ ފުރުޞަތުތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ފުރުޞަތެއް ނެތް",
      "emptyDescription": "ފުރަތަމަ ފުރުޞަތު އުފެއްދުމަށް ލީޑެއް ކޮލިފައިކުރޭ، ނުވަތަ މިހާރު ހުރި ކަސްޓަމަރަކަށް އަޕްސެލްއެއްގެ ގޮތުގައި އުފައްދާ.",
      "new": "އައު ފުރުޞަތު",
      "newTitle": "އައު ފުރުޞަތު",
      "newDescription": "މިއީ މިހާރު ހުރި ކަސްޓަމަރަކަށް ދެވޭ އަޕްސެލްއަށެވެ. ލީޑަކުން އަންނަ ފުރުޞަތެއް އުފެދެނީ އެ ލީޑް ކޮލިފައިކުރުމުންނެވެ.",
      "saving": "ރައްކާކުރަނީ",
      "createdTitle": "ފުރުޞަތު އުފެދިއްޖެ",
      "createdDetail": "{name} މިހާރު ޕައިޕްލައިންގައެވެ.",
      "createFailed": "އެ ފުރުޞަތު ނުއުފެއްދުނު",
      "noCustomer": "އަދި ކަސްޓަމަރެއް ނެތް",
      "openOnly": "ހުޅުވިފައިވާ ޑީލްތައް އެކަނި",
      "seePipeline": "ޕައިޕްލައިން ރިޕޯޓް ބަލާ",
      "valueTitle": "އަގަކީ",
      "weightedNote": "ބުރަދަން ދެވިފައިވާ އަގަކީ އަދަދު ފުރުޞަތުގެ ނިސްބަތުން ގުނުމުން ލިބޭ އަދަދެވެ، އެ ހިސާބުކޮށް ބުރެއް ދެނީ ޑޭޓާބޭހުންނެވެ. މި ސްކްރީނުގައި ދުވަހަކުވެސް އަލުން ހިސާބެއް ނުކުރެއެވެ، ވީމާ މިތާ އޮތް އަދަދާއި ޕައިޕްލައިން ރިޕޯޓުގައި އޮތް އަދަދު ތަފާތުވުމެއް ނެތެވެ.",
      "open": "ހުޅުވިފައި",
      "won": "ކާމިޔާބު",
      "lost": "ނާކާމިޔާބު",
      "moveTo": "ބަދަލުކުރާ މަރުޙަލާ",
      "moveStage": "މަރުޙަލާ ބަދަލުކުރޭ",
      "stageMoved": "މަރުޙަލާ ބަދަލުވެއްޖެ",
      "stageFailed": "އެ މަރުޙަލާ ބަދަލުކުރުން ޤަބޫލެއް ނުކުރެވުނު",
      "markWon": "ކާމިޔާބު ކަމަށް ފާހަގަކުރޭ",
      "markLost": "ނާކާމިޔާބު ކަމަށް ފާހަގަކުރޭ",
      "wonTitle": "ޑީލް ކާމިޔާބުވެއްޖެ",
      "wonDetail": "ސޭލްސް އަށް އަންގައިފި، ވީމާ އެއަށް ކޯޓޭޝަނެއް ނުވަތަ އޯޑަރެއް ހެދިދާނެއެވެ.",
      "lostTitle": "ޑީލް ނާކާމިޔާބުވެއްޖެ",
      "lostDetail": "ސަބަބު ރެކޯޑުގައި އެބައޮތެވެ.",
      "closeFailed": "އެ ޑީލް ބަންދެއް ނުކުރެވުނު",
      "loseTitle": "މި ޑީލް ނާކާމިޔާބު ކަމަށް ފާހަގަކުރޭ",
      "loseDescription": "ސަބަބެއް ލާޒިމު — ކާމިޔާބުވި ނިސްބަތުގެ ރިޕޯޓް ކިޔުން އަގުހުރި އެއްޗަކަށް ހަދަނީ އެއިންނެވެ.",
      "loseReason": "ނާކާމިޔާބުވީ ކީއްވެ؟",
      "lostBanner": "ނާކާމިޔާބު: {reason}",
      "closedNote": "މި ޑީލް ބަންދުވެފައެވެ. މި ސްކްރީނުން އަލުން ނުހުޅުވޭނެއެވެ؛ ބަދަލުގައި އައު ފުރުޞަތެއް އުފައްދާށެވެ.",
      "fromLead": "އުފެދުނީ",
      "fields": {
        "name": "ނަން",
        "customer": "ކަސްޓަމަރު",
        "company": "ކުންފުނި",
        "amount": "އަދަދު",
        "currency": "ފައިސާ",
        "probability": "ފުރުޞަތުގެ ނިސްބަތް",
        "probabilityShort": "ނިސްބަތް",
        "weighted": "ބުރަދަން ދެވިފައި",
        "expectedClose": "ބަންދުވާނެ ކަމަށް ބެލެވޭ",
        "stage": "މަރުޙަލާ",
        "forecastCategory": "ފޯކާސްޓް ބައި"
      },
      "rail": {
        "raised": "އުފެއްދި",
        "leadLink": "ލީޑް #{id}",
        "customerLink": "ކަސްޓަމަރު ރެކޯޑް"
      },
      "noForecastCategory": "ކަނޑައެޅިފައެއް ނެތް",
      "forecastCategorySet": "ފޯކާސްޓް ބައި އަޕްޑޭޓްކުރެވިއްޖެ",
      "forecastCategoryFailed": "އެ ފޯކާސްޓް ބައި ރައްކާއެއް ނުކުރެވުނު",
      "competitorsTitle": "ވާދަވެރިން",
      "competitorsDescription": "މި ޑީލްގައި ދެނެގަނެވިފައިވާ ވާދަވެރި ސަޕްލަޔަރުންނާއި، މިހާރު ކާމިޔާބުވަނީ ކާކުކަން.",
      "competitorsEmptyTitle": "ވާދަވެރިއެއް ރެކޯޑްކުރެވިފައެއް ނެތް",
      "competitorsEmptyDescription": "ވާދަވެރި ސަޕްލަޔަރަކު ފުރުޞަތުގައި ފެނިއްޖެނަމަ ރެކޯޑްކުރޭ.",
      "recordCompetitor": "ވާދަވެރިޔެއް ރެކޯޑްކުރޭ",
      "recordCompetitorDescription": "މި ޑީލްގެ ވާދަވެރިންގެ ލިސްޓަށް ސަޕްލަޔަރެއް އިތުރުކުރޭ.",
      "competitorField": "ވާދަވެރިޔާ",
      "competitorWinning": "މިހާރު ކާމިޔާބުވަނީ",
      "competitorNote": "ނޯޓު",
      "competitorAdded": "ވާދަވެރިޔާ ރެކޯޑްކުރެވިއްޖެ",
      "competitorAddFailed": "އެ ވާދަވެރިޔާ ރެކޯޑެއް ނުކުރެވުނު",
      "removeCompetitor": "ނައްތާލާ",
      "competitorRemoved": "ވާދަވެރިޔާ ނައްތާލެވިއްޖެ",
      "competitorRemoveFailed": "އެ ވާދަވެރިޔާ ނުނެއްތުނު",
      "winTitle": "މި ޑީލް ކާމިޔާބު ކަމަށް ފާހަގަކުރޭ",
      "winDescription": "ސަބަބަކީ އިޚްތިޔާރީ އެއްޗެއް، ނަމަވެސް ކާމިޔާބުވި ނިސްބަތުގެ ރިޕޯޓް ކިޔުން އަގުހުރި އެއްޗަކަށް ހަދަނީ އެ ރެކޯޑުކުރުމުންނެވެ.",
      "closeReason": "ބަންދުކުރި ސަބަބު",
      "closeReasonPlaceholder": "ކަނޑައެޅިފައިވާ ސަބަބެއް ނެތް",
      "closeNote": "ނޯޓު",
      "closeNoteRequiredHint": "މި ބަންދުކުރި ސަބަބަށް ނޯޓެއް ބޭނުންވެއެވެ.",
      "lossCompetitor": "ބަލިވީ ކާކަށް",
      "lossCompetitorHint": "މި ބަންދުކުރި ސަބަބަށް ވާދަވެރިޔާ ބޭނުންވެއެވެ."
    },
    "cases": {
      "title": "ކޭސްތައް",
      "description": "ކަސްޓަމަރުން އެހީއަށް އެދިފައިވާ ކޮންމެ ކަމަކާއި، ކޮންމެ ކަމެއްގައި ގަޑި ހިނގަމުންދާ ގޮތް.",
      "tableLabel": "ކޭސްތައް",
      "loadFailed": "އެ ކޭސްތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ކޭހެއް ނެތް",
      "emptyDescription": "ކޭސްތައް އަންނަނީ ޕޯޓަލުން، އީމެއިލުން، ނުވަތަ މިތާ އަތުން އުފެއްދުމުންނެވެ. ކޮންމެ ކޭހެއް އުފެދޭ ވަގުތު އޭގެ ޖަވާބާއި ޙައްލުގެ ގަޑިތައް ފެށެއެވެ.",
      "raise": "ކޭހެއް އުފައްދާ",
      "raising": "ކޭސް އުފައްދަނީ",
      "newTitle": "ކޭހެއް އުފައްދާ",
      "newDescription": "މި ރައްކާކުރުމާއެކު ކޭސް ނަންބަރާއި އެސްއެލްއޭގެ ދެ ސުންގަޑިވެސް ކަނޑައެޅޭނެއެވެ. އެއިން އެއްވެސް ސުންގަޑިއެއް ފަހުން ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "createdTitle": "ކޭސް އުފެދިއްޖެ",
      "createdDetail": "{no} ހުޅުވިފައި، އޭގެ ގަޑިތައް ހިނގަނީއެވެ.",
      "createFailed": "އެ ކޭސް ނުއުފެއްދުނު",
      "detailsTitle": "ތަފްޞީލު",
      "openOnly": "ހުޅުވިފައިވާ ކޭސްތައް އެކަނި",
      "unassigned": "ހަވާލުކޮށްފައެއް ނުވޭ",
      "noCustomer": "ކަސްޓަމަރެއް ނެތް",
      "noPolicy": "އުޞޫލެއް ނެތް",
      "priorityHint": "މި ކޭހަށް ޢަމަލުކުރާ އެސްއެލްއޭ އުޞޫލު ކަނޑައަޅަނީ އިސްކަމުންނެވެ، އަދި އެއިން ކަނޑައަޅާ ސުންގަޑިތައް ފަހުން ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "policyPreview": "\"{policy}\" އިން ވަޢުދުވަނީ {response} މިނެޓް ތެރޭ ފުރަތަމަ ޖަވާބާއި، {resolution} މިނެޓް ތެރޭ ޙައްލެއް ދިނުމަށެވެ.",
      "noPolicyForPriority": "މި އިސްކަމަށް ހަރަކާތްތެރި ޑިފޯލްޓް އެސްއެލްއޭ އުޞޫލެއް ކަނޑައަޅާފައެއް ނުވެއެވެ، ވީމާ ސާވަރުން މި ކޭސް އުފެއްދުން މުޅިންވެސް ޤަބޫލެއް ނުކުރާނެއެވެ — ވަޢުދުވާނެ ސުންގަޑިއެއް ނެތެވެ. ފުރަތަމަ މި އިސްކަމަށް ޑިފޯލްޓް އުޞޫލެއް ކަނޑައަޅާ، ނުވަތަ އެހެން އިސްކަމެއް ހޮވާށެވެ.",
      "seePolicies": "އުޞޫލުތައް ބަލާ",
      "assign": "ހަވާލުކުރޭ",
      "assignedTitle": "ކޭސް ހަވާލުކުރެވިއްޖެ",
      "assignFailed": "އެ ކޭސް ހަވާލެއް ނުކުރެވުނު",
      "replyTitle": "ކަސްޓަމަރަށް ޖަވާބުދޭ",
      "replyNote": "ޖަވާބުގެ އެސްއެލްއޭ ފުއްދެނީ ފުރަތަމަ ޢާންމު ޖަވާބުންނެވެ. ތިރީގައިވާ ތާރީޚުގައި ލިޔެވޭ އެތެރޭގެ ނޯޓަކުން އެ ގަޑި ނުހުއްޓޭނެއެވެ.",
      "replyLabel": "ތިޔަ ފަރާތުގެ ޖަވާބު",
      "replyPublic": "މިއެތި ކަސްޓަމަރަށް ފޮނުވާ",
      "replyPublicHint": "ޢާންމު ޖަވާބެއް ޕޯޓަލުން ފެންނާނެ، އަދި ޖަވާބުގެ ގަޑި ހުއްޓުވާނެއެވެ.",
      "replyPrivateHint": "ނުފޮނުވައި ޖަވާބު ރެކޯޑްކުރުމަށް ފާހަގަ ނަގާލާ — ޖަވާބުގެ ގަޑި ހިނގަހިނގާ ހުންނާނެއެވެ.",
      "reply": "ޖަވާބު ފޮނުވާ",
      "replying": "ފޮނުވަނީ",
      "repliedTitle": "ޖަވާބު ރެކޯޑްކުރެވިއްޖެ",
      "repliedDetail": "ޖަވާބުގެ ގަޑިއަށް ޖަވާބު ދެވިއްޖެއެވެ.",
      "replyFailed": "އެ ޖަވާބު ރެކޯޑެއް ނުކުރެވުނު",
      "resolve": "ޙައްލުކުރޭ",
      "resolveTitle": "މި ކޭސް ޙައްލުކުރޭ",
      "resolveDescription": "ޙައްލުގެ ގަޑި މިތާ ހުއްޓެއެވެ. ބަންދުކުރަންދެން ކޭސް ކަސްޓަމަރަށް ހުޅުވިފައި ހުންނާނެއެވެ.",
      "resolutionLabel": "ޙައްލުކުރީ ކިހިނެއް؟",
      "resolvedTitle": "ކޭސް ޙައްލުކުރެވިއްޖެ",
      "resolvedDetail": "ޙައްލުގެ ގަޑި ހުއްޓިއްޖެއެވެ.",
      "resolveFailed": "އެ ކޭސް ޙައްލެއް ނުކުރެވުނު",
      "close": "ބަންދުކުރޭ",
      "closedTitle": "ކޭސް ބަންދުކުރެވިއްޖެ",
      "closedDetail": "ކިޔޫން ނެގިއްޖެއެވެ.",
      "closeFailed": "އެ ކޭސް ބަންދެއް ނުކުރެވުނު",
      "reopen": "އަލުން ހުޅުވާ",
      "reopenTitle": "މި ކޭސް އަލުން ހުޅުވާ",
      "reopenDescription": "ސަބަބެއް ލާޒިމު، އަދި އެ ސަބަބު ރެކޯޑުގައި ލިޔެވޭނެއެވެ.",
      "reopenReason": "އަލުން ހުޅުވަނީ ކީއްވެ؟",
      "reopenKeepsDeadlines": "އަލުން ހުޅުވުމުން އަސްލު ސުންގަޑިތައް ބަދަލެއް ނުވެއެވެ. މި ކޭސް އުފެއްދިއިރު ވެވުނު ވަޢުދަކީ މިނެވޭ ވަޢުދެވެ — އެއާ ދެކޮޅަށް މިހާރު ރެކޯޑްކުރެވިފައިވާ ބްރީޗެއް ހިމެނިގެންނެވެ.",
      "reopenedTitle": "ކޭސް އަލުން ހުޅުވިއްޖެ",
      "reopenedDetail": "އަސްލު ސުންގަޑިތައް ބަދަލެއް ނުވެއެވެ.",
      "reopenFailed": "އެ ކޭސް އަލުން ނުހުޅުވުނު",
      "reopenedBanner": "މި ކޭސް {count} ފަހަރު އަލުން ހުޅުވިފައިވެއެވެ. | މި ކޭސް {count} ފަހަރު އަލުން ހުޅުވިފައިވެއެވެ.",
      "escalatedBanner": "މި ކޭސް އުޞޫލުގެ އިސްފަރާތަށް ފޮނުވުނީ",
      "csatSectionTitle": "ކަސްޓަމަރުގެ ހިތްހަމަޖެހުން",
      "csatAsk": "ކަސްޓަމަރު ހިތްހަމަޖެހުނުތޯ؟",
      "csatYes": "ހިތްހަމަޖެހުނު",
      "csatNo": "ހިތްހަމައެއް ނުޖެހުނު",
      "csatOnce": "ރެކޯޑްކުރެވެނީ އެއް ފަހަރު، އަދި ދުވަހަކުވެސް އެޑިޓެއް ނުކުރެވެއެވެ.",
      "csatTitle": "ރެކޯޑްކުރެވިއްޖެ",
      "csatDetail": "މިއެތި ސީސެޓް ރިޕޯޓަށް ދެއެވެ.",
      "csatFailed": "އެއެތި ރެކޯޑެއް ނުކުރެވުނު",
      "csatSatisfied": "ކަސްޓަމަރު ހިތްހަމަޖެހުނު",
      "csatUnsatisfied": "ކަސްޓަމަރު ހިތްހަމައެއް ނުޖެހުނު",
      "fields": {
        "caseNo": "ކޭސް",
        "subject": "މައުޟޫޢު",
        "description": "ހިނގި ކަންތައް",
        "priority": "އިސްކަން",
        "origin": "އައި ގޮތް",
        "category": "ބާވަތް",
        "customer": "ކަސްޓަމަރު",
        "assignee": "ހަވާލުކުރެވިފައި",
        "contactName": "ގުޅޭނެ ފަރާތް",
        "contactEmail": "ގުޅޭނެ އީމެއިލް",
        "contactPhone": "ގުޅޭނެ ފޯނު",
        "slaPolicy": "އެސްއެލްއޭ އުޞޫލު"
      },
      "statuses": {
        "new": "އައު",
        "open": "ހުޅުވިފައި",
        "pending": "އިންތިޒާރުގައި",
        "resolved": "ޙައްލުކުރެވިފައި",
        "closed": "ބަންދު"
      },
      "priorities": {
        "low": "ދަށް",
        "medium": "މެދު",
        "high": "މަތި",
        "urgent": "އަވަސް"
      },
      "origins": {
        "portal": "ޕޯޓަލް",
        "email": "އީމެއިލް",
        "manual": "އަތުން އުފެއްދި"
      },
      "rail": {
        "raised": "އުފެއްދި",
        "firstResponse": "ކަސްޓަމަރަށް ފުރަތަމަ ޖަވާބު",
        "escalated": "އިސްފަރާތަށް ފޮނުވި",
        "resolved": "ޙައްލުކުރި",
        "closed": "ބަންދުކުރި",
        "customerLink": "ކަސްޓަމަރު ރެކޯޑް",
        "otherCases": "މި ކަސްޓަމަރުގެ އެހެން ކޭސްތައް"
      }
    },
    "sla": {
      "title": "އެސްއެލްއޭ އުޞޫލުތަކާއި މަސައްކަތު ގަޑިތައް",
      "description": "ކޮންމެ އިސްކަމަކުން ވަޢުދުވާ އެއްޗަކާއި، އެއަށް ގުނާ ގަޑިތައް.",
      "loadFailed": "އެ އުޞޫލުތައް ލޯޑެއް ނުކުރެވުނު",
      "policiesTitle": "އުޞޫލުތައް",
      "policyDescription": "އުޞޫލެއް ހިނގަނީ އޭގެ އިސްކަމުގައި އުފެދޭ ކޮންމެ ކޭހަކަށް، އެ ކޭސް އުފެދޭ ވަގުތުން ފެށިގެންނެވެ.",
      "newPolicy": "އައު އުޞޫލު",
      "editPolicy": "އުޞޫލު އެޑިޓްކުރޭ",
      "policySavedTitle": "އުޞޫލު ރައްކާކުރެވިއްޖެ",
      "policySavedDetail": "މިހާރުން ފެށިގެން އުފެދޭ ކޭސްތަކަށް ހިނގާނެއެވެ.",
      "policySaveFailed": "އެ އުޞޫލު ރައްކާނުކުރެވުނު",
      "editingNote": "އުޞޫލެއް އެޑިޓްކުރުމުން މިހާރު ހުރި އެއްވެސް ކޭހެއްގެ ސުންގަޑި ބަދަލެއް ނުވެއެވެ. އެ ސުންގަޑިތައް ހިސާބުކުރެވުނީ ކޮންމެ ކޭހެއް އުފެދުނު ވަގުތު އެއް ފަހަރު، އަދި ޤަޞްދުގައި ދުވަހަކުވެސް އަލުން ހިސާބެއް ނުކުރެވެއެވެ.",
      "default": "ޑިފޯލްޓް",
      "defaultLabel": "އެހެން އުޞޫލެއް ނުދިމާވާނަމަ މި އުޞޫލު ބޭނުންކުރޭ",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓިފައި",
      "activeLabel": "ހަރަކާތްތެރި",
      "minutes": "{count} މިނެޓް",
      "minutesHint": "މިނެޓުން.",
      "businessHoursLabel": "ހަމައެކަނި މަސައްކަތު ގަޑިތައް ގުނާ",
      "businessHoursHint": "ގުނަނީ ތިރީގައިވާ ހަފްތާގެ ގަޑިތަކުގެ ތެރެއަށް ވަންނަ މިނެޓްތައް އެކަންޏެވެ. މިއެތި ނުޖައްސާ ދޫކޮށްލައިފިނަމަ ސުންގަޑިއަކީ ސީދާ ގަޑީގެ ވަގުތެވެ — ރޭގަނޑާއި ހަފްތާ ބަންދުވެސް ހިމެނިގެންނެވެ.",
      "countingBusiness": "މަސައްކަތު ގަޑި",
      "countingWallClock": "ސީދާ ގަޑި",
      "escalationHint": "މި އުޞޫލުގެ ދަށުން ކޭހެއް ބްރީޗްވުމުން، ހަވާލުވެފައިވާ ފަރާތުގެ އިތުރުން މި ފަރާތަށްވެސް އަންގާނެއެވެ.",
      "escalationUser": "ބޭނުންކުރާ ފަރާތް #{id}",
      "noEscalation": "އެއްވެސް ފަރާތެއް ނޫން",
      "columns": {
        "name": "އުޞޫލު",
        "response": "ފުރަތަމަ ޖަވާބު",
        "resolution": "ޙައްލު",
        "counting": "ގުނާ ގޮތް",
        "escalation": "އިސްފަރާތަކީ"
      },
      "hoursTitle": "މަސައްކަތު ގަޑިތައް",
      "hoursDescription": "މަސައްކަތު ގަޑީގެ އުޞޫލަކުން ގުނާ، ހަފްތާގެ މަސައްކަތު ގަޑިތައް. މިއީ މި ސިސްޓަމުގައި އޮތް ހަމައެކަނި ކަލަންޑަރެވެ.",
      "hoursTimezoneNote": "ގަޑިތައް ހުރީ މި ޓެނަންޓްގެ އަމިއްލަ ޓައިމްޒޯނުންނެވެ.",
      "hoursSavedTitle": "މަސައްކަތު ގަޑިތައް ރައްކާކުރެވިއްޖެ",
      "hoursSavedDetail": "މިހާރުން ފެށިގެން ހިސާބުކުރެވޭ ސުންގަޑިތަކަށް ހިނގާނެއެވެ.",
      "hoursInvalid": "{day} އަށް ފެށޭ ގަޑިއަކާއި ނިމޭ ގަޑިއެއް ބޭނުންވެއެވެ، ނިމޭ ގަޑި ފެށޭ ގަޑިއަށްފަހުގައެވެ.",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "closedDay": "ބަންދު",
      "runSweep": "ބްރީޗް ސްވީޕް ހިންގާ",
      "sweeping": "ސްވީޕްކުރަނީ",
      "sweptTitle": "ސްވީޕް ނިމިއްޖެ",
      "sweptDetail": "ޖަވާބުގެ {response} ބްރީޗާއި ޙައްލުގެ {resolution} ބްރީޗް ރެކޯޑްކުރެވި، {escalations} ފަހަރު އިސްފަރާތަށް ފޮނުވިއްޖެއެވެ.",
      "sweepFailed": "ސްވީޕް ނުހިނގި",
      "dueAt": "ސުންގަޑި",
      "recordedAt": "ބްރީޗް ރެކޯޑްކުރި",
      "notYetSwept": "މި ސުންގަޑި ފަހަނައަޅައިފި، ނަމަވެސް އަދި ބްރީޗެއް ރެކޯޑްކުރެވިފައެއް ނުވެއެވެ — އޭގެފަހުން ސްވީޕް ނުހިނގައެވެ. އެއްވެސް ފަރާތަކަށް އަންގާފައެއް ނުވޭ، އަދި އިސްފަރާތަށްވެސް ފޮނުވިފައެއް ނުވެއެވެ.",
      "kinds": {
        "response": "ފުރަތަމަ ޖަވާބު",
        "resolution": "ޙައްލު"
      },
      "answered": {
        "response": "ޖަވާބުދިން",
        "resolution": "ޙައްލުކުރި"
      },
      "states": {
        "met": "ފުއްދިއްޖެ",
        "missed": "ފާއިތުވި",
        "breached": "ބްރީޗްވެފައި",
        "overdue": "މުއްދަތު ފަހަނައަޅާފައި",
        "atRisk": "ނުރައްކަލުގައި",
        "pending": "ރަނގަޅަށް ދަނީ",
        "none": "އެސްއެލްއޭއެއް ނެތް"
      },
      "leftInDays": "{days}ދ {hours}ގ ބާކީ",
      "leftInHours": "{hours}ގ {minutes}މ ބާކީ",
      "leftInMinutes": "{minutes}މ ބާކީ",
      "pastByDays": "{days}ދ {hours}ގ ފަހަނައަޅާފައި",
      "pastByHours": "{hours}ގ {minutes}މ ފަހަނައަޅާފައި",
      "pastByMinutes": "{minutes}މ ފަހަނައަޅާފައި",
      "caveats": {
        "businessHours": "މި ސުންގަޑި ގުނަނީ ހަމައެކަނި ޓެނަންޓްގެ ހަފްތާގެ މަސައްކަތު ގަޑިތަކުގެ ތެރެއަށް ވަންނަ ގަޑިތަކެވެ. މި ސިސްޓަމުގައި އޮތް ހަމައެކަނި ކަލަންޑަރަކީ އެއީ — މި ބިލްޑުގައި އެއްވެސް ތަނެއްގައި ސަރުކާރު ބަންދު ދުވަސްތަކުގެ ކަލަންޑަރެއް ނެތެވެ — ވީމާ ސަރުކާރު ބަންދު ދުވަހެއް ހުރަސްކުރާ ސުންގަޑިއެއް، މީހަކު އަތުން މަސައްކަތު ގަޑި ގުނާނަމަ ކަނޑައަޅާނެ ވަގުތަށްވުރެ ކުރިން ޖެހޭނެއެވެ.",
        "wallClock": "މި ސުންގަޑިއަކީ ކޭސް އުފެދުނު ވަގުތުން ފެށިގެން ސީދާ ގަޑީގެ ވަގުތެވެ: ރޭގަނޑާއި، ހަފްތާ ބަންދާއި، ސަރުކާރު ބަންދު ދުވަސްތައްވެސް އެއަށް ގުނެއެވެ.",
        "noPolicy": "މި ކޭހަށް އެއްވެސް އެސްއެލްއޭ އުޞޫލެއް ނުހިނގާތީ، އެއްވެސް ސުންގަޑިއަކަށް ވަޢުދުވެފައެއް ނުވެއެވެ، އަދި އެއްވެސް އެއްޗެއް ނުމިނެއެވެ."
      },
      "weekdays": {
        "0": "އާދިއްތަ",
        "1": "ހޯމަ",
        "2": "އަންގާރަ",
        "3": "ބުދަ",
        "4": "ބުރާސްފަތި",
        "5": "ހުކުރު",
        "6": "ހޮނިހިރު"
      }
    },
    "kb": {
      "title": "ނޮލެޖް ބޭސް",
      "description": "ކޭހެއް ހުޅުވިފައި ހުއްޓާ މީހުން ހޯދާ ޖަވާބުތައް. ހޯދާއިރު ބަލަނީ ހަމައެކަނި ސުރުޚީ ނޫން، މުޅި ލިޔުމެވެ.",
      "loadFailed": "ނޮލެޖް ބޭސް ލޯޑެއް ނުކުރެވުނު",
      "new": "ލިޔުމެއް ލިޔޭ",
      "newTitle": "ލިޔުމެއް ލިޔޭ",
      "newDescription": "ރައްކާވާނީ ދެލިކޮޕީއެއްގެ ގޮތުގައެވެ. ދެލިކޮޕީއެއް ފެންނާނީ ނޮލެޖް ބޭސް ބަލަހައްޓާ ފަރާތްތަކަށް އެކަންޏެވެ؛ ކޭސްތަކަށް ޖަވާބުދޭ އެންމެންނަށް ލިބޭގޮތް ހަދަނީ ޝާއިޢުކުރުމުންނެވެ.",
      "saveDraft": "ދެލިކޮޕީއެއްގެ ގޮތުގައި ރައްކާކުރޭ",
      "createdTitle": "ދެލިކޮޕީ ރައްކާކުރެވިއްޖެ",
      "createdDetail": "ބަރޯސާވެވޭ ވަރަށް ތައްޔާރުވުމުން ޝާއިޢުކުރާށެވެ.",
      "createFailed": "އެ ލިޔުން ރައްކާނުކުރެވުނު",
      "savedTitle": "ލިޔުން ރައްކާކުރެވިއްޖެ",
      "savedDetail": "ބަދަލުތައް ދިރިއެވެ.",
      "saveFailed": "އެ ބަދަލުތައް ރައްކާނުކުރެވުނު",
      "publish": "ޝާއިޢުކުރޭ",
      "publishedTitle": "ލިޔުން ޝާއިޢުކުރެވިއްޖެ",
      "publishedDetail": "ކޭސްތަކަށް ޖަވާބުދޭ އެންމެންނަށް މިހާރު ފެންނާނެއެވެ.",
      "publishFailed": "އެ ލިޔުން ޝާއިޢެއް ނުކުރެވުނު",
      "archive": "އަރުޝީފުކުރޭ",
      "archivedTitle": "ލިޔުން އަރުޝީފުކުރެވިއްޖެ",
      "archivedDetail": "އެޑިޓަރުންނަށް ހޯދޭގޮތަށް ހުންނާނެ، އަދި އެހެން އެންމެންގެ ނަތީޖާތަކުން ގެއްލޭނެއެވެ.",
      "archiveFailed": "އެ ލިޔުން އަރުޝީފެއް ނުކުރެވުނު",
      "draftNote": "މިއީ ދެލިކޮޕީއެކެވެ. ނޮލެޖް ބޭސްގެ ހުއްދަ ނެތް އެއްވެސް ފަރާތަކަށް މިއެތި ނުކިޔޭނެ، އަދި އެހެން އެއްވެސް ފަރާތެއްގެ ހޯދުމުގެ ނަތީޖާތަކުން ނުފެންނާނެއެވެ.",
      "archivedNote": "މި ލިޔުން ވަނީ އަރުޝީފުކުރެވިފައެވެ. ދައުރުވުމުން ނެގިފައި، ނަމަވެސް ފޮހެވިފައެއް ނުވެއެވެ — އަލުން ގެނައުމަށް އަލުން ޝާއިޢުކުރާށެވެ.",
      "backToList": "ހުރިހާ ލިޔުންތައް",
      "searchLabel": "ހޯދާ",
      "searchHint": "ސުރުޚީއާއި، ބާވަތާއި، ލިޔުމުގެ މައިގަނޑުގައި ހިނގާ ފުލް-ޓެކްސްޓް ހޯދުމެކެވެ. ލިޔުމެއްގެ ތެރޭގައިވާ ބަސްތަކުން އެ ލިޔުން ފެންނާނެއެވެ.",
      "modeBrowse": "ހުރިހާ ލިޔުމެއް، އެންމެ އައު ފުރަތަމަ. ދިމާވާ މިންވަރުން ތަރުތީބުކުރުމަށް ހޯދާ ބަހެއް ލިޔާށެވެ.",
      "modeSearch": "\"{q}\" އަށް ތަރުތީބުކުރެވިފައިވާ ފުލް-ޓެކްސްޓް ނަތީޖާތައް — ހޯދެނީ ހަމައެކަނި ސުރުޚީ ނޫން، މުޅި ލިޔުމެވެ.",
      "rank": "ދަރަޖަ",
      "noMatchTitle": "އެއްވެސް އެއްޗެއް ނުދިމާވި",
      "noMatchDescription": "އެއްވެސް ލިޔުމެއްގެ ސުރުޚީގައި، ބާވަތުގައި ނުވަތަ މައިގަނޑުގައި \"{q}\" ނެތެވެ. މަދު ބަހަކުން ބަލާށެވެ.",
      "emptyTitle": "ނޮލެޖް ބޭސް ހުހަށް",
      "emptyDescription": "ފުރަތަމަ ލިޔުން ލިޔޭ. ކޭހެއް އައު ވަގުތު އެއް ފަހަރު ލިޔެވޭ ޖަވާބަކުން، ހަމަ އެ ޖަވާބު ބާރަ ފަހަރު އަލުން ހޯދުމުން ސަލާމަތްކޮށްދެއެވެ.",
      "byline": "ލިޔުނީ {author}، ތާރީޚް",
      "slugHint": "ހުސްކޮށް ދޫކޮށްލުމުން ސުރުޚީން އެއް ހެދޭނެއެވެ.",
      "tagsHint": "ކޮމާއިން ވަކިކޮށްފައި.",
      "bodyHint": "މީގައިވާ ކޮންމެ ބަހެއް ހޯދޭނެއެވެ.",
      "fields": {
        "title": "ސުރުޚީ",
        "slug": "ސްލަގް",
        "category": "ބާވަތް",
        "tags": "ޓެގްތައް",
        "body": "ލިޔުން"
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "published": "ޝާއިޢުކޮށްފައި",
        "archived": "އަރުޝީފުކޮށްފައި"
      },
      "rail": {
        "written": "ލިޔުނު",
        "published": "ޝާއިޢުކުރި",
        "allArticles": "ހުރިހާ ލިޔުންތައް"
      }
    },
    "reports": {
      "loadFailed": "އެ ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "rangeNote": "ތާރީޚުތަކަކީ މި ޓެނަންޓްގެ އަމިއްލަ ޓައިމްޒޯނުގެ ވިޔަފާރި ތާރީޚުތަކެވެ.",
      "share": "ހިއްސާ",
      "shareOf": "{stage} އިން ހިފަހައްޓާ ޕައިޕްލައިންގެ ހިއްސާ",
      "deals": "ޑީލްތައް",
      "pipelineTitle": "ޕައިޕްލައިނާއި ކާމިޔާބުވި ނިސްބަތް",
      "pipelineDescription": "މިހާރު ޕައިޕްލައިންގައި ހުރި އެއްޗެއް، މަރުޙަލާއިން، އަދި ކުރިން އޭގައި ހުރި އެއްޗެއްގެ ތެރެއިން ޙަޤީޤަތުގައި ލިބުނު މިންވަރު.",
      "byStage": "މަރުޙަލާއިން",
      "totalPipeline": "ޕައިޕްލައިން",
      "totalPipelineHelp": "ސާވަރުން ހިސާބުކުރި ގޮތަށް، ހުޅުވިފައިވާ ކޮންމެ ޑީލެއްގެ އަދަދުގެ ޖުމްލަ.",
      "totalWeighted": "ބުރަދަން ދެވިފައިވާ ޕައިޕްލައިން",
      "totalWeightedHelp": "ކޮންމެ ޑީލެއްގެ އަދަދު އޭގެ ފުރުޞަތުގެ ނިސްބަތުން ގުނާފައި، ޑޭޓާބޭހުން ޖުމްލަކޮށްފައި. ބްރައުޒަރުގައި ދުވަހަކުވެސް އަލުން ހިސާބެއް ނުކުރެއެވެ.",
      "currencyNote": "އަދަދުތައް ޖުމްލަކުރެވިފައިވަނީ ލިޔެވުނު ގޮތަށް، ފައިސާ ބަދަލުނުކޮށެވެ. އެއް ފައިސާއަށްވުރެ ގިނަ ފައިސާއިން ޑީލްތައް ލިޔެވޭނަމަ، މި ޖުމްލަތައް އެއް އަދަދެއްގެ ގޮތުގައި ނުކިޔައި، ފައިސާއިން ވަކިން ކިޔާށެވެ — ގްރޫޕެއް އެއް ފައިސާއަކަށް ބަދަލުކުރުމަކީ ކޮންސޮލިޑޭޝަނުން ކުރާ ކަމެކެވެ، މި ރިޕޯޓުން ކުރާ ކަމެއް ނޫނެވެ.",
      "winRateTitle": "ކާމިޔާބުވި ނިސްބަތް",
      "winRateDescription": "{from} އިން {to} އަށް ބަންދުވި ޑީލްތަކުން.",
      "winRateByCount": "އަދަދުން ކާމިޔާބުވި ނިސްބަތް",
      "winRateByCountHelp": "މި މުއްދަތުގައި ބަންދުވި ޑީލްތަކުގެ ތެރެއިން ކާމިޔާބުވި ޑީލްތަކުގެ ހިއްސާ.",
      "winRateByAmount": "އަގުން ކާމިޔާބުވި ނިސްބަތް",
      "winRateByAmountHelp": "ބަންދުވި އަގުގެ ތެރެއިން ކާމިޔާބުވި އަގުގެ ހިއްސާ. ލިބޭ ޑީލްތަކުގެ ބޮޑުމިން އެވްރެޖް ނޫން ކޮންމެ ފަހަރަކު މިއެތި އަދަދާ ތަފާތުވާނެއެވެ.",
      "wonCount": "ކާމިޔާބު",
      "lostCount": "ނާކާމިޔާބު",
      "wonAmount": "ކާމިޔާބުވި އަގު",
      "lostAmount": "ނާކާމިޔާބުވި އަގު",
      "conversionTitle": "ލީޑް ބަދަލުވުން",
      "conversionDescription": "ރައްކާކުރެވުނު ލީޑްތަކުގެ ތެރެއިން ކިތައް ލީޑް ކަސްޓަމަރުންނަށް ވެއްޖެކަމާއި، އެ ލީޑްތައް އައި ތަން.",
      "conversionMeaning": "މިތާ \"ބަދަލުވި\" ގެ މާނައަކީ ލީޑް ކަސްޓަމަރު ރެކޯޑަކަށް ވުމެވެ — ކޮލިފައިވުމެއް ނޫން، އަދި ޑީލެއް ކާމިޔާބުވުމެއްވެސް ނޫނެވެ. ބޮޑު ފުރުޞަތެއް ހުޅުވިފައި އޮތް ލީޑެއްވެސް ބަދަލުނުވާ ލީޑެއްގެ ގޮތުގައި ގުނެއެވެ.",
      "leadsCaptured": "ރައްކާކުރި ލީޑްތައް",
      "leadsConverted": "ކަސްޓަމަރުންނަށް ވި",
      "conversionRate": "ބަދަލުވި ނިސްބަތް",
      "conversionRateHelp": "ސާވަރުން ހިސާބުކުރި ގޮތަށް، މި މުއްދަތުގައި ރައްކާކުރި ލީޑްތަކުގެ ތެރެއިން ބަދަލުވި ލީޑްތަކުގެ ހިއްސާ.",
      "bySource": "މަޞްދަރުން",
      "noLeadsInRange": "މި މުއްދަތުގައި އެއްވެސް ލީޑެއް ރައްކާކޮށްފައެއް ނުވެއެވެ.",
      "serviceTitle": "ޚިދުމަތާއި އެސްއެލްއޭ ފުއްދުން",
      "serviceDescription": "ކޭސްތަކުގެ އަދަދާއި، ވަޢުދުވި ސުންގަޑިތައް ފުއްދުނު މިންވަރާއި، އެއަށްފަހު ކަސްޓަމަރުން ބުނި އެއްޗެއް.",
      "casesCreated": "އުފެއްދި",
      "casesResolved": "ޙައްލުކުރި",
      "casesClosed": "ބަންދުކުރި",
      "slaComplianceTitle": "އެސްއެލްއޭ ފުއްދުން",
      "responseCompliance": "ސުންގަޑީގެ ތެރޭ ފުރަތަމަ ޖަވާބު",
      "resolutionCompliance": "ސުންގަޑީގެ ތެރޭ ޙައްލުކުރި",
      "overCases": "(ސުންގަޑިއެއް އޮތް {total} ކޭހުގެ ތެރެއިން {met})",
      "complianceHolidayCaveat": "މަދުވެގެން އެއް ހަރަކާތްތެރި އުޞޫލަކުން މަސައްކަތު ގަޑި ގުނައެވެ. މަސައްކަތު ގަޑިއަކީ ހަފްތާއިން ހަފްތާއަށް ތަކުރާރުވާ ގަޑިތަކެއް، އެއަށްވުރެ އިތުރު އެއްޗެއް ނޫނެވެ — މި ސިސްޓަމުގައި ސަރުކާރު ބަންދު ދުވަސްތަކުގެ ކަލަންޑަރެއް ނެތެވެ — ވީމާ ސަރުކާރު ބަންދު ދުވަހެއް ހުރަސްކުރި ކޮންމެ ސުންގަޑިއެއް ކަނޑައެޅިފައިވަނީ، މީހަކު އަތުން މަސައްކަތު ގަޑި ގުނާނަމަ ކަނޑައަޅާނެ ވަގުތަށްވުރެ ކުރިން، އަދި އެއާ ދެކޮޅަށް މިނޭ ފުއްދުންވެސް އެ މިންވަރަށް ހަރުކަށިވާނެއެވެ.",
      "avgFirstResponse": "އެވްރެޖް ފުރަތަމަ ޖަވާބު",
      "avgResolution": "އެވްރެޖް ޙައްލު",
      "hoursMinutes": "{hours}ގ {minutes}މ",
      "minutesOnly": "{minutes}މ",
      "csatTitle": "ކަސްޓަމަރުގެ ހިތްހަމަޖެހުން",
      "csatDescription": "މި މުއްދަތުގައި ޙައްލުކުރި ކޭސްތަކާ ދެކޮޅަށް ރެކޯޑްކުރެވުނު ޖަވާބުތައް.",
      "csatRate": "ހިތްހަމަޖެހުނު",
      "csatRateHelp": "އުފެއްދި ކޭސްތަކުގެ ނިސްބަތުން ނޫން، ޖަވާބު ލިބުނު ކޭސްތަކުގެ ހިއްސާގެ ގޮތުގައި.",
      "csatResponses": "ޖަވާބުތައް",
      "csatSatisfied": "ހިތްހަމަޖެހުނު ކަމަށް ބުނި",
      "csatNoResponses": "މި މުއްދަތުގައި އެއްވެސް ފަރާތަކުން ކޭހަކަށް ދަރަޖައެއް ދީފައެއް ނުވެއެވެ، ވީމާ ކިޔޭނެ ހިތްހަމަޖެހުމުގެ އަދަދެއް ނެތެވެ."
    },
    "c5": {
      "routeTitles": {
        "accounts": "އެކައުންޓްތައް",
        "account": "އެކައުންޓް",
        "catalogues": "އެކައުންޓް ކެޓަލޮގްތައް",
        "contacts": "ކޮންޓެކްޓްތައް",
        "contact": "ކޮންޓެކްޓް",
        "segments": "މާކެޓިން ސެގްމަންޓްތައް",
        "segment": "ސެގްމަންޓް ބިލްޑަރ",
        "campaigns": "ކެމްޕޭންތައް",
        "campaign": "ކެމްޕޭން",
        "send": "ފޮނުވުން",
        "sendDetail": "ފޮނުވުން",
        "forecast": "ފޯކާސްޓް",
        "winLoss": "ކާމިޔާބު/ނާކާމިޔާބު",
        "scoring": "ލީޑް ސްކޯރިން",
        "routing": "ލީޑް ރައުޓިން"
      },
      "nav": {
        "label": "ސީއާރްއެމްގެ ބައިތައް",
        "accounts": "އެކައުންޓްތައް",
        "contacts": "ކޮންޓެކްޓްތައް",
        "catalogues": "ކެޓަލޮގްތައް",
        "segments": "ސެގްމަންޓްތައް",
        "campaigns": "ކެމްޕޭންތައް",
        "forecast": "ފޯކާސްޓް",
        "winLoss": "ކާމިޔާބު/ނާކާމިޔާބު",
        "scoring": "ސްކޯރިން",
        "routing": "ރައުޓިން"
      },
      "accountType": {
        "customer": "ކަސްޓަމަރ",
        "prospect": "ޕްރޮސްޕެކްޓް",
        "partner": "ޕާޓްނަރ",
        "competitor": "ވާދަވެރިޔާ",
        "supplier": "ސަޕްލަޔަރ",
        "other": "އެހެނިހެން"
      },
      "accountStatus": {
        "active": "ހިނގަމުންދާ",
        "inactive": "ނުހިނގާ",
        "archived": "އަރުޝީފުކުރެވިފައި"
      },
      "contactStatus": {
        "active": "ހިނގަމުންދާ",
        "inactive": "ނުހިނގާ",
        "left_company": "ކުންފުނިން ވަކިވެފައި"
      },
      "campaignStatus": {
        "draft": "ދެލިކޮޕީ",
        "scheduled": "ތާވަލުކުރެވިފައި",
        "sending": "ފޮނުވަމުންދަނީ",
        "sent": "ފޮނުވިފައި",
        "paused": "މަޑުޖައްސާލެވިފައި",
        "cancelled": "ބާޠިލުކުރެވިފައި",
        "completed": "ނިމިފައި"
      },
      "sendStatus": {
        "preparing": "ތައްޔާރުކުރަނީ",
        "ready": "ތައްޔާރު",
        "sending": "ފޮނުވަމުންދަނީ",
        "completed": "ނިމިފައި",
        "failed": "ނާކާމިޔާބު",
        "cancelled": "ބާޠިލުކުރެވިފައި"
      },
      "recipientState": {
        "sent": "ފޮނުވިފައި",
        "excluded": "ބޭރުކުރެވިފައި",
        "failed": "ނާކާމިޔާބު"
      },
      "exclusion": {
        "no_consent_record": "ރުހުމުގެ ރެކޯޑެއް ނެތް",
        "consent_withdrawn": "ރުހުން އަނބުރާ ގެންގޮސްފައި",
        "consent_expired": "ރުހުމުގެ މުއްދަތު ހަމަވެފައި",
        "consent_pending": "ޔަޤީންކުރުމަށް އިންތިޒާރުގައި",
        "suppressed": "އެޑްރެސް ހުއްޓުވާލެވިފައި",
        "no_destination": "ފައިލްގައި އެޑްރެހެއް ނެތް",
        "party_erased": "ފަރާތް ފޮހެލެވިފައި",
        "party_inactive": "ފަރާތް ބްލޮކްކުރެވިފައި ނުވަތަ ނުހިނގާ",
        "segment_excluded": "ސެގްމަންޓުން ބޭރުކުރެވިފައި",
        "unknown": "ނޭނގޭ ސަބަބެއް: {reason}"
      },
      "responseKind": {
        "replied": "ޖަވާބުދީފައި",
        "enquiry": "މަޢުލޫމާތު ހޯދުން",
        "meeting": "ބައްދަލުވުން",
        "unsubscribed": "ސަބްސްކްރިޕްޝަން ހުއްޓާލައިފި",
        "complained": "ޝަކުވާކޮށްފައި",
        "purchased": "ގަނެފައި",
        "declined": "ދޫކޮށްލައިފި"
      },
      "segmentField": {
        "party_kind": "ފަރާތުގެ ބާވަތް",
        "party_country_code": "ފަރާތުގެ ޤައުމު",
        "account_segment_code": "އެކައުންޓް ސެގްމަންޓް",
        "account_owner_user_id": "އެކައުންޓްގެ ވެރިޔާ",
        "opportunity_stage_code": "ފުރުޞަތުގެ މަރުޙަލާ",
        "customer_has_posted_invoice_since": "މި ތާރީޚުން ފެށިގެން ޕޯސްޓްކުރި އިންވޮއިސެއް އެބައޮތް",
        "lead_score_band": "ލީޑް ސްކޯރ ބޭންޑް",
        "campaign_received_since": "މި ތާރީޚުން ފެށިގެން ކެމްޕޭނެއް ލިބިފައި"
      },
      "segmentOp": {
        "eq": "އެއީ",
        "neq": "އެއީއެއް ނޫން",
        "in": "މީގެ ތެރެއިން އެއް",
        "not_in": "މީގެ ތެރެއިން އެއްވެސް އެއްޗެއް ނޫން",
        "gte": "މި ތާރީޚުގައި ނުވަތަ އޭގެ ފަހުން",
        "lte": "މި ތާރީޚުގައި ނުވަތަ އޭގެ ކުރިން",
        "is_true": "ތެދު",
        "is_false": "ދޮގު",
        "contains": "ހިމެނޭ"
      },
      "scoreField": {
        "source": "ލީޑްގެ މަޞްދަރު",
        "company_name_present": "ކުންފުނީގެ ނަން އެބައޮތް",
        "email_domain_kind": "އީމެއިލް ޑޮމެއިން",
        "has_phone": "ފޯނު ނަންބަރެއް އެބައޮތް",
        "country_code": "ޤައުމު",
        "campaign_response": "ކެމްޕޭނަކަށް ޖަވާބުދީފައި",
        "activity_count_7d": "ފާއިތުވި 7 ދުވަހުގެ ޙަރަކާތްތައް",
        "title_seniority": "މަޤާމުގެ ދަރަޖަ",
        "account_segment": "އެކައުންޓް ސެގްމަންޓް"
      },
      "scoreBand": {
        "hot": "ހޫނު",
        "warm": "ތާފަނާ",
        "cold": "ފިނި"
      },
      "account": {
        "title": "އެކައުންޓްތައް",
        "description": "ގުޅުމުގެ ރެކޯޑް. އެކައުންޓަކީ ކަސްޓަމަރެއް ނޫން — މި ދޭތި ގުޅެނީ ފަރާތެއްގެ ޒަރީޢާއިންނެވެ.",
        "notCustomerNote": "މަރުކަޒީކޮށް ބިލްކުރެވޭ ހަ ރިސޯޓަކީ އެއް ކަސްޓަމަރު އަދި ހަތް އެކައުންޓެވެ. އެއްވެސް އެއްޗެއް ނުގަންނަ ޕްރޮސްޕެކްޓަކީ އެކައުންޓެއް، ނަމަވެސް ކަސްޓަމަރެއް ނޫނެވެ. މި ދޭތި ގުޅެނީ ހަމައެކަނި ފަރާތެއްގެ ޒަރީޢާއިންނެވެ.",
        "create": "އައު އެކައުންޓް",
        "created": "އެކައުންޓް އުފެއްދިއްޖެ",
        "createTitle": "އައު އެކައުންޓް",
        "createDescription": "ކުރިން އޮތް ވަނަވަރަކާ ގުޅުވާލާ، ނުވަތަ ނަމުން އައު ވަނަވަރެއް އުފެއްދުމަށް ދޫކޮށްލާ.",
        "searchPlaceholder": "ނަން ނުވަތަ ދާއިރާ",
        "anyType": "ކޮންމެ ބާވަތެއް",
        "anyStatus": "ކޮންމެ ޙާލަތެއް",
        "anySegment": "ކޮންމެ ސެގްމަންޓެއް",
        "name": "ނަން",
        "type": "ބާވަތް",
        "status": "ޙާލަތު",
        "segment": "ސެގްމަންޓް",
        "owner": "ވެރިޔާ",
        "annualRevenue": "އަހަރީ އާމްދަނީ",
        "employeeCount": "މުވައްޒަފުން",
        "industry": "ދާއިރާ",
        "territory": "ސަރަޙައްދު",
        "website": "ވެބްސައިޓް",
        "noSegment": "ސެގްމަންޓެއް ނެތް",
        "noRole": "ދައުރެއް ނެތް",
        "findIdentity": "ކުރިން އޮތް ވަނަވަރެއް ހޯދާ",
        "identity": "ވަނަވަރު",
        "newIdentity": "އައު ވަނަވަރެއް އުފައްދާ",
        "identityHint": "ކުރިން އޮތް ވަނަވަރެއް ޚިޔާރުކުރުމުން، ކުރިން ލީޑެއްގެ ގޮތުގައި އޮތް ޕްރޮސްޕެކްޓެއް ދެވަނަ މީހަކަށް ވުން ހުއްޓުވެއެވެ.",
        "openIdentity": "ވަނަވަރު ހުޅުވާ",
        "emptyTitle": "އަދި އެކައުންޓެއް ނެތް",
        "emptyDescription": "އެކައުންޓަކީ ގުޅުން ބަލަހައްޓާ ތަން — އައު އެކައުންޓެއް އުފައްދާ، ނުވަތަ ޤާބިލު ލީޑެއް ބަދަލުކުރޭ.",
        "tabsLabel": "އެކައުންޓްގެ ބައިތައް",
        "tabContacts": "ކޮންޓެކްޓްތައް",
        "tabHierarchy": "ތަރުތީބު",
        "tabDetails": "ތަފުޞީލު",
        "contactsEmptyTitle": "ކޮންޓެކްޓެއް ގުޅުވާލެވިފައި ނެތް",
        "contactsEmptyDescription": "ކޮންޓެކްޓެއް ގުޅުވާލާ އަދި ދައުރެއް ދޭ — ނިންމުންތައް ނިންމާ ފަރާތް، ބިލިން، ނުވަތަ ފަންނީ ފަރާތް.",
        "attachContact": "ކޮންޓެކްޓް ގުޅުވާލާ",
        "attachTitle": "ކޮންޓެކްޓެއް ގުޅުވާލުން",
        "attachDescription": "ކޮންޓެކްޓް ކުރިން އޮންނަން ޖެހޭނެ. އެއް ކޮންޓެކްޓަކަށް ގިނަ އެކައުންޓްތަކުގައި ދައުރު އަދާކުރެވިދާނެ.",
        "findContact": "ކޮންޓެކްޓެއް ހޯދާ",
        "contact": "ކޮންޓެކްޓް",
        "role": "ދައުރު",
        "contactAttached": "ކޮންޓެކްޓް ގުޅުވާލެވިއްޖެ",
        "contactDetached": "ކޮންޓެކްޓް ވަކިކުރެވިއްޖެ",
        "detach": "ވަކިކުރޭ",
        "primaryContact": "މައިގަނޑު",
        "hierarchyNote": "ގްރޫޕަކާއި އޭގެ މެންބަރުން. ބެލެނިވެރިޔާ ބަދަލުކުރާއިރު ދަޢުރުވުން ބަލައި، ދޮގުކުރާ މެސެޖުގައި މަގު ބަޔާންކުރެއެވެ.",
        "reparent": "ބެލެނިވެރިޔާ ބަދަލުކުރޭ",
        "reparentTitle": "މި އެކައުންޓް ބަދަލުކުރުން",
        "reparentDescription": "ދަޢުރުވުމެއް ދޮގުކުރެވި، މެސެޖުގައި އޭގެން އުފެދޭ މަގު ބަޔާންކުރެވެއެވެ.",
        "reparented": "އެކައުންޓް ބަދަލުކުރެވިއްޖެ",
        "parent": "އައު ބެލެނިވެރިޔާ",
        "findParent": "އެކައުންޓެއް ހޯދާ",
        "detachToRoot": "ބެލެނިވެރިޔަކު ނެތް (އެންމެ މަތި)",
        "parentIs": "{name} ގެ ބައެއް"
      },
      "contact": {
        "title": "ކޮންޓެކްޓްތައް",
        "description": "އެކައުންޓްތަކުގައި ތިބި މީހުން. ކިތަންމެ އެކައުންޓަކަށް ޚިދުމަތްކުރި ނަމަވެސް، ކޮންމެ ވަނަވަރަކަށް އެއް ކޮންޓެކްޓް.",
        "onePerPartyNote": "ތިން އެކައުންޓެއްގައި ކޮންޓެކްޓަކަށް ހުންނަ މީހަކީ ތިން ދައުރު އޮތް އެއް ކޮންޓެކްޓެވެ. އެއީ ރުހުން އަނބުރާ ގެންދިއުމެއް، ހުއްޓުވުމެއް އަދި މަޢުލޫމާތުގެ ވެރިޔާގެ އެދުމެއް އެއްފަހަރާ ތިން އެކައުންޓަށް ފޯރުކޮށްދޭ ސަބަބެވެ.",
        "create": "އައު ކޮންޓެކްޓް",
        "created": "ކޮންޓެކްޓް އުފެއްދިއްޖެ",
        "createTitle": "އައު ކޮންޓެކްޓް",
        "createDescription": "ކުރިން އޮތް ވަނަވަރަކާ ގުޅުވާލާ، ނުވަތަ ނަމެއް ދީ އައު ވަނަވަރެއް އުފައްދާ.",
        "searchPlaceholder": "ނަން",
        "anyStatus": "ކޮންމެ ޙާލަތެއް",
        "name": "ނަން",
        "givenName": "ފުރަތަމަ ނަން",
        "familyName": "ޢާއިލީ ނަން",
        "email": "އީމެއިލް",
        "phone": "ފޯނު",
        "jobTitle": "މަޤާމު",
        "department": "ޑިޕާޓްމަންޓް",
        "status": "ޙާލަތު",
        "notes": "ނޯޓް",
        "contactDetailsHint": "މި ބޭނުންކުރެވެނީ އެންމެ ފަހަރަކު، މި ގޮވުމުން އުފެދިދާނެ ވަނަވަރު ފެށުމަށެވެ. އޭގެ ފަހުން އެޑިޓްކުރެވެނީ ފަރާތުގެ ސްކްރީނުންނެވެ.",
        "detailsLiveOnParty": "ނަން، އީމެއިލް އަދި ފޯނު ނަންބަރު ހުންނަނީ ވަނަވަރުގައި — އެތަނުން ރަނގަޅުކުރުމުން ހުރިހާ ތަނަކުން ރަނގަޅުވެއެވެ.",
        "findIdentity": "ކުރިން އޮތް ވަނަވަރެއް ހޯދާ",
        "identity": "ވަނަވަރު",
        "newIdentity": "އައު ވަނަވަރެއް އުފައްދާ",
        "identityHint": "މި މީހަކީ ކުރިން ލީޑެއް ނުވަތަ ކަސްޓަމަރެއްގެ ކޮންޓެކްޓެއް ނަމަ، ދެވަނަ ވަނަވަރެއް އުފެއްދުމުގެ ބަދަލުގައި މިތަނުން ޚިޔާރުކުރޭ.",
        "openIdentity": "ވަނަވަރު ހުޅުވާ",
        "detailsTitle": "ތަފުޞީލު",
        "saved": "ކޮންޓެކްޓް ރައްކާކުރެވިއްޖެ",
        "accountsTitle": "އެކައުންޓްތައް",
        "accountsDescription": "މި މީހާ ގުޅިފައިވާ ކޮންމެ އެކައުންޓެއް.",
        "accountsEmptyTitle": "އެކައުންޓަކާ ގުޅިފައި ނެތް",
        "accountsEmptyDescription": "މި ކޮންޓެކްޓް ގުޅުވާލެވޭނީ އެކައުންޓްގެ ސްކްރީނުންނެވެ.",
        "consentTitle": "ރުހުން",
        "consentDescription": "މިއަދާ ހަމައަށް މި މީހާ ރުހުން ދީފައިވާ ކަންކަން.",
        "consentEmptyTitle": "އެއްވެސް އެއްޗެއް ރެކޯޑްކުރެވިފައި ނެތް",
        "consentEmptyDescription": "އެއްވެސް ޗެނަލަކުން މި މީހާގެ ރުހުމެއް ނަގާފައެއް ނުވެއެވެ.",
        "openMatrix": "ފުރިހަމަ މެޓްރިކްސް ހުޅުވާ",
        "emptyTitle": "އަދި ކޮންޓެކްޓެއް ނެތް",
        "emptyDescription": "ކޮންޓެކްޓަކީ އެކައުންޓެއްގައި ހުންނަ މީހެއް. އައު އެއްޗެއް އުފައްދާ، ނުވަތަ ލީޑެއް ބަދަލުކުރޭ."
      },
      "catalogue": {
        "title": "އެކައުންޓް ކެޓަލޮގްތައް",
        "description": "އެކައުންޓްތައް ބަހާލެވޭ ގޮތާއި، އެކައުންޓެއްގައި ކޮންޓެކްޓަކަށް ވެވިދާނެ ދައުރުތައް.",
        "segments": "އެކައުންޓް ސެގްމަންޓްތައް",
        "roles": "ކޮންޓެކްޓް ދައުރުތައް",
        "code": "ކޯޑް",
        "name": "ނަން",
        "flags": "ފްލެގްތައް",
        "active": "ހިނގަމުންދާ",
        "activate": "ހިންގާ",
        "deactivate": "ހުއްޓާލާ",
        "yes": "އާނ",
        "no": "ނޫން",
        "addSegment": "ސެގްމަންޓް އިތުރުކުރޭ",
        "segmentAdded": "ސެގްމަންޓް އިތުރުކުރެވިއްޖެ",
        "segmentDescription": "ތަފުޞީލު",
        "addRole": "ދައުރު އިތުރުކުރޭ",
        "roleAdded": "ދައުރު އިތުރުކުރެވިއްޖެ",
        "roleFlagsNote": "ނިންމުންތައް ނިންމާ ފަރާތްތަކަށް އަމާޒުކުރާ ކެމްޕޭނަކާއި، ބިލިން ކޮންޓެކްޓެއް ބޭނުންވާ އިންވޮއިސެއް، މި ދެ ކަންތައްވެސް ބަލަނީ މި ކެޓަލޮގަށެވެ. ފްލެގްތަކަކީ ޒީނަތްތެރިކުރުމެއް ނޫން، ބޭނުންކުރެވޭ މަޢުލޫމާތެވެ.",
        "decisionMaker": "ނިންމުންތައް ނިންމާ ފަރާތް",
        "billing": "ބިލިން",
        "segmentsEmptyTitle": "ސެގްމަންޓެއް ނެތް",
        "segmentsEmptyDescription": "މުހިންމު އެކައުންޓް، ކުދި އަދި މެދު ފަންތި، ސަރުކާރު — ތިޔަ ސޭލްސް ޓީމުން ބުނާ ގޮތަށް.",
        "rolesEmptyTitle": "ދައުރެއް ނެތް",
        "rolesEmptyDescription": "ނިންމުންތައް ނިންމާ ފަރާތް، ބިލިން ކޮންޓެކްޓް އަދި ފަންނީ ކޮންޓެކްޓަކީ އާންމު ތިނެއް."
      },
      "segment": {
        "title": "މާކެޓިން ސެގްމަންޓްތައް",
        "description": "ކެމްޕޭނެއް ދާނީ ކާކަށްކަން — އަތުން ހޮވާ ލިސްޓެއް، ނުވަތަ ފިލްޓަރެއް.",
        "rebuildNote": "ފޮނުވުމެއްގައި އޯޑިއަންސް އަލުން ބިނާކޮށް، އޭގެ މައްޗަށް ރުހުމުގެ ގޭޓް ހިންގައެވެ. ތިރީގައިވާ އަދަދަކީ އެންމެ ފަހުން ބިނާކުރިއިރު ދިމާވި އަދަދު، އަދި ދެން ފޮނުވާއިރު ފޯރާނެ އަދަދެއް ނޫނެވެ.",
        "create": "އައު ސެގްމަންޓް",
        "created": "ސެގްމަންޓް އުފެއްދިއްޖެ",
        "createTitle": "އައު ސެގްމަންޓް",
        "createDescription": "ކްރައިޓީރިއާ ސެގްމަންޓަކުން ފިލްޓަރެއް ހިންގާ؛ ސްޓެޓިކް ސެގްމަންޓަކީ ތިޔަ އަތުން ބަލަހައްޓާ ލިސްޓެއް.",
        "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން",
        "anyKind": "ކޮންމެ ބާވަތެއް",
        "kind": "ބާވަތް",
        "kindStatic": "ސްޓެޓިކް",
        "kindCriteria": "ކްރައިޓީރިއާ",
        "kindStaticHint": "މެންބަރުން އިތުރުކޮށް ނަގަނީ ތިޔަ އަތުން.",
        "kindCriteriaHint": "ބިނާކުރާއިރު ފިލްޓަރާ ދިމާވާ ކޮންމެ މީހަކީ މެންބަރެއް.",
        "code": "ކޯޑް",
        "name": "ނަން",
        "lastBuiltCount": "އެންމެ ފަހުން ދިމާވި",
        "lastBuiltAt": "އެންމެ ފަހުން ބިނާކުރީ",
        "neverBuilt": "ބިނާކޮށްފައެއް ނުވޭ",
        "builtAtCount": "{at} ގައި {count} ދިމާވި",
        "active": "ހިނގަމުންދާ",
        "activeYes": "ހިނގަމުންދާ",
        "activeNo": "ނުހިނގާ",
        "emptyTitle": "ސެގްމަންޓެއް ނެތް",
        "emptyDescription": "ސެގްމަންޓަކީ ކެމްޕޭނެއް ފޮނުވާ ތަން. ފެށުމަށް އެއް ސެގްމަންޓް އުފައްދާ.",
        "criteriaTitle": "ކްރައިޓީރިއާ",
        "criteriaDescription": "ފިލްޓަރކުރެވޭނީ ހުއްދަ ލިސްޓުގައިވާ ދާނަތަކުން އެކަނި، އަދި ތިޔަ ބޭފުޅާއަށް ކިޔުމުގެ ހުއްދަ އޮތް ދާނަތަކުން އެކަނިއެވެ.",
        "criteriaSaved": "ކްރައިޓީރިއާ ރައްކާކުރެވިއްޖެ",
        "saveCriteria": "ކްރައިޓީރިއާ ރައްކާކުރޭ",
        "allTitle": "މި ހުރިހާ އެއްޗަކާ ދިމާވުން",
        "allDescription": "މިތާނގައިވާ ކޮންމެ ޤަވާޢިދެއް ތެދުވާން ޖެހޭނެ.",
        "noneTitle": "މީގެ ތެރެއިން އެއްވެސް އެއްޗަކާ ދިމާނުވުން",
        "noneDescription": "މިތާނގައިވާ ޤަވާޢިދަކާ ދިމާވާ ކޮންމެ މީހަކު ބާކީކުރެވޭނެ.",
        "addRule": "ޤަވާޢިދު އިތުރުކުރޭ",
        "build": "ބިނާކުރޭ",
        "buildSummary": "{at} ގައި {count} މެންބަރު — {added} އިތުރުކުރެވި، {removed} ނެގުނު.",
        "membersTitle": "މެންބަރުން",
        "membersDescription": "އެންމެ ފަހުން ބިނާކުރިއިރު ދިމާވި މީހުން، އަދި ބާކީކުރެވުނު މީހުން.",
        "membersEmptyTitle": "މެންބަރެއް ނެތް",
        "membersEmptyDescription": "ސެގްމަންޓް ބިނާކުރޭ، ނުވަތަ އަތުން މެންބަރުން އިތުރުކުރޭ.",
        "excluded": "ބޭރުކުރެވިފައި",
        "showExcluded": "ހަމައެކަނި ބޭރުކުރެވުނު މީހުން",
        "showAll": "ހުރިހާ އެންމެން"
      },
      "campaign": {
        "title": "ކެމްޕޭންތައް",
        "description": "ފޮނުވެނީ ކޮން އެއްޗެއް، ކާކަށް، އަދި ކޮން މަޤުޞަދެއްގައިކަން.",
        "create": "އައު ކެމްޕޭން",
        "created": "ކެމްޕޭން އުފެއްދިއްޖެ",
        "createTitle": "އައު ކެމްޕޭން",
        "createDescription": "ކެމްޕޭނެއްގައި މަޤުޞަދަކާއި ޗެނަލެއް ބަޔާންކުރަން ޖެހޭނެ — އެއާ ނުލައި ރުހުމުގެ ގޭޓަށް ސުވާލެއް ނުކުރެވޭނެ.",
        "searchPlaceholder": "ނަން ނުވަތަ ކޯޑް",
        "anyStatus": "ކޮންމެ ޙާލަތެއް",
        "name": "ނަން",
        "code": "ކޯޑް",
        "channel": "ޗެނަލް",
        "purpose": "މަޤުޞަދު",
        "purposeHint": "ގޭޓުން ސުވާލުކުރަނީ ކޮންމެ ފަރާތަކުން މި ޗެނަލުން މި މަޤުޞަދަށް ރުހުން ދީފައިވޭތޯއެވެ.",
        "essential": "ކޮންމެހެން ބޭނުންވާ މަޤުޞަދު",
        "essentialHint": "ރުހުމަކާ ނުލައި ހުއްދަ.",
        "essentialWarning": "ކޮންމެހެން ބޭނުންވާ މަޤުޞަދެއް ރުހުމަކާ ނުލައި ހުއްދަވެއެވެ، ސަބަބަކީ އޭގެ ޤާނޫނީ އަސާސަކީ ރުހުން ނޫން ކަމަށްވާތީއެވެ. މާކެޓިންއަށް އެފަދަ މަޤުޞަދެއް ޚިޔާރުކުރުމުން، ދެކޮޅު ހެދި މީހުންނަށްވެސް ފޮނުވެއެވެ.",
        "budget": "ބަޖެޓް",
        "budgetHint": "މިއީ ROI ރިޕޯޓަށް ބޭނުންވާ ރޭވުމުގެ އަދަދެކެވެ. ޙަޤީޤީ ޚަރަދު އަންނަނީ AP އިންވޮއިސްތަކުން، އަދި މިތަނުން އެއަށް އަތެއް ނުލެވެއެވެ.",
        "targetRevenue": "އަމާޒު އާމްދަނީ",
        "status": "ޙާލަތު",
        "approved": "ފާސްކުރެވިފައި",
        "notApproved": "ފާސްކުރެވިފައެއް ނުވޭ",
        "isApproved": "ފާސްކުރެވިފައި",
        "approvedToast": "ކެމްޕޭން ފާސްކުރެވިއްޖެ",
        "subject": "މައުޟޫޢު",
        "body": "މައުޟޫޢުގެ ތަފުޞީލު",
        "saved": "ކެމްޕޭން ރައްކާކުރެވިއްޖެ",
        "attributionWindow": "އެޓްރިބިއުޝަން މުއްދަތު (ދުވަސް)",
        "attributionWindowHint": "ކޮންމެ ޓަޗެއް ލިޔެވޭއިރު ފްރީޒްވެއެވެ. ބަދަލުކުރުމުން ކުރީގެ ރެކޯޑްތައް ބަދަލެއް ނުވެއެވެ.",
        "goToSend": "ފޮނުވުން",
        "tabsLabel": "ކެމްޕޭންގެ ބައިތައް",
        "tabContent": "ކޮންޓެންޓް",
        "tabSends": "ފޮނުވުންތައް",
        "tabResponses": "ޖަވާބުތައް",
        "tabRoi": "އާރްއޯއައި",
        "sendsEmptyTitle": "އަދި އެއްވެސް އެއްޗެއް ފޮނުވިފައެއް ނުވޭ",
        "sendsEmptyDescription": "ފުރަތަމަ ގޭޓް ޕްރިވިއު ކުރޭ — އެއިން އެއްވެސް އެއްޗެއް ނުލިޔެއެވެ — އަދި ދެން ފޮނުވާ.",
        "responsesEmptyTitle": "ޖަވާބެއް ނެތް",
        "responsesEmptyDescription": "ޖަވާބުތައް، ބައްދަލުވުންތައް، ގަތުންތައް އަދި ޝަކުވާތައް ރެކޯޑްކުރެވެނީ މިތާނގައެވެ.",
        "recordResponse": "ޖަވާބެއް ރެކޯޑްކުރޭ",
        "recordResponseDescription": "ލިބުނު ފަރާތުން ކުރި ކަމަކާއި، އެކަން ކުރި ވަގުތު.",
        "responseParty": "ފަރާތުގެ އައިޑީ",
        "responseKind": "ޖަވާބު",
        "responseNote": "ނޯޓް",
        "responseRecorded": "ޖަވާބު ރެކޯޑްކުރެވިއްޖެ",
        "emptyTitle": "ކެމްޕޭނެއް ނެތް",
        "emptyDescription": "ކެމްޕޭނުން ކޮންޓެންޓް، މަޤުޞަދު އަދި ބަޖެޓް ގެންދެއެވެ."
      },
      "send": {
        "title": "ފޮނުވުން",
        "backToCampaign": "ކެމްޕޭނަށް އެނބުރި",
        "notApproved": "މި ކެމްޕޭން ފާސްކުރެވިފައެއް ނުވެއެވެ. ފާސްކުރެވެންދެން ސާވަރުން ފޮނުވުން ދޮގުކުރެއެވެ.",
        "withheld": "ފޮނުވުމަކީ ކެމްޕޭން ކިޔުމާ ވަކި ހުއްދައެކެވެ. ތިޔަ ބޭފުޅާ އެ ހުއްދަ ނުހިއްޕަވައެވެ.",
        "audienceTitle": "އޯޑިއަންސް",
        "audienceDescription": "މި ފޮނުވުން ނަގަނީ ކޮން ސެގްމަންޓަކުންކަން.",
        "segment": "ސެގްމަންޓް",
        "lastBuilt": "އެންމެ ފަހުން ބިނާކުރިއިރު {count}",
        "isTest": "ޓެސްޓް ފޮނުވުން",
        "isTestDescription": "ދާނީ އެތެރޭގެ އެޑްރެސްތަކުގެ ލިސްޓަކަށެވެ. ޙަޤީޤީ ފަރާތްތަކާ ދެކޮޅަށް ރެކޯޑެއް ނުލިޔެވޭ އަދި އެ އެޑްރެސްތަކުގެ މައްޗަށް ރުހުމުގެ ގޭޓް ނުހިނގައެވެ.",
        "testRecipients": "ޓެސްޓް އެޑްރެސްތައް",
        "testRecipientsHint": "ކޮމާ ނުވަތަ ސްޕޭހުން ވަކިކުރޭ.",
        "previewTitle": "ރުހުމުގެ ގޭޓް",
        "previewDescription": "އެއްވެސް އެއްޗެއް ނުލިޔެއެވެ. ފޮނުވުމުގައި ހިނގާނެ ހަމަ އެ ގޭޓް ހިންގައެވެ.",
        "previewEmptyTitle": "އަދި ޕްރިވިއު ކުރެވިފައެއް ނުވޭ",
        "previewEmptyDescription": "ސެގްމަންޓެއް ޚިޔާރުކޮށް ޕްރިވިއު ހިންގާ، އަދި ގޭޓުން ބާކީކުރާނެ މީހުންނާއި އޭގެ ސަބަބު ބަލާ.",
        "runPreview": "ޕްރިވިއު ހިންގާ",
        "audienceTotal": "އޯޑިއަންސްގައި {count}",
        "allowed": "{count} ހުއްދަ",
        "excluded": "{count} ބާކީ",
        "previewNobody": "މި އޯޑިއަންސްގެ ހުރިހާ އެންމެން ގޭޓުން ބާކީކުރެއެވެ. ފޮނުވުން ދޮގުކުރެވޭނެ — ސެގްމަންޓް، މަޤުޞަދު އަދި ޗެނަލް ބައްލަވާ.",
        "previewIsNotAPromise": "ފޮނުވުމުގައި ގޭޓް ވަކިން އަލުން ހިންގައެވެ. މެދުތެރެއިން ރުހުމެއް ބަދަލުވެއްޖެ ނަމަ ދެ އަދަދު ތަފާތުވާނެއެވެ، އަދި އެއީ ނިޒާމު ރަނގަޅަށް މަސައްކަތްކުރުމެވެ.",
        "sendTitle": "ފޮނުވުން",
        "execute": "ފޮނުވާ",
        "executeTest": "ޓެސްޓް ފޮނުވާ",
        "started": "ފޮނުވުން ފެށިއްޖެ",
        "nobodyExplained": "މި ފޮނުވުން އެއްވެސް މީހަކަށް ނުފޯރާނެއެވެ. ސެގްމަންޓް، މަޤުޞަދު އަދި ޗެނަލް ބައްލަވާ.",
        "nobodyAbsolute": "މި ޤަވާޢިދު ފަހަނައަޅައި ދިއުމުގެ ފުރުޞަތެއް ނެތެވެ. އެއްވެސް މީހަކަށް ނުފޯރާ ފޮނުވުމަކީ ކޮންފިގަރޭޝަން މައްސަލައެއް، އަދި އެއީ ކާމިޔާބެއް ކަމަށް ދެއްކުން އެއަށްވުރެ ނުބައެވެ.",
        "resendWarning": "މި އޯޑިއަންސަށް ދާދި ފަހުން ފޮނުވިފައިވެއެވެ. މުއްދަތުގެ ތެރޭގައި އަލުން ފޮނުވުމަކީ ޚާއްޞަ އިސްތިސްނާއެކެވެ.",
        "number": "ފޮނުވުން #{no}",
        "test": "ޓެސްޓް",
        "testNote": "މިއީ ޓެސްޓް ފޮނުވުމެކެވެ. ޙަޤީޤީ ފަރާތްތަކުގެ ރެކޯޑެއް ނުލިޔެވޭ އަދި ރުހުމުގެ ގޭޓް ނުހިނގައެވެ.",
        "detailDescription": "ގޭޓުން ނިންމި ގޮތް، ކޮންމެ ފަރާތަކަށް ވަކިން.",
        "counts": "{audience} އޯޑިއަންސް · {sent} ފޮނުވި · {excluded} ބާކީ",
        "evaluatedAt": "ބެލެވުނީ {at}",
        "breakdownTitle": "ސަބަބުތަކުން ބާކީކުރުން",
        "breakdownDescription": "ގޭޓުން ދޭ ކޮންމެ ސަބަބެއް، ދިމާނުވި ސަބަބުތައްވެސް ހިމެނޭ ގޮތަށް.",
        "recipientsTitle": "ލިބުނު ފަރާތްތައް",
        "recipient": "ލިބުނު ފަރާތް",
        "state": "ޙާލަތު",
        "exclusionReason": "ބާކީކުރި ސަބަބު",
        "sentAt": "ފޮނުވި ވަގުތު",
        "anyState": "ކޮންމެ ޙާލަތެއް",
        "anyReason": "ކޮންމެ ސަބަބެއް",
        "recipientsEmptyTitle": "ލިބުނު ފަރާތެއް ނެތް",
        "recipientsEmptyDescription": "މި ފިލްޓަރާ އެއްވެސް އެއްޗެއް ދިމައެއް ނުވި."
      },
      "attribution": {
        "model": "މޮޑެލް",
        "firstTouch": "ފުރަތަމަ ޓަޗް",
        "evenSplit": "ހަމަހަމަ ބެހުން",
        "serverComputedNote": "ތިރީގައިވާ ކޮންމެ އަދަދެއް ހިސާބުކުރަނީ ސާވަރުންނެވެ. މިތަނުން އެއްވެސް ބައެއް އަލުން ހިސާބެއް ނުކުރެއެވެ.",
        "attributedRevenue": "ނިސްބަތްކުރެވުނު އާމްދަނީ",
        "budget": "ބަޖެޓް",
        "net": "ސާފު",
        "roiPercent": "އާރްއޯއައި %",
        "touchesTitle": "ޓަޗްތައް",
        "touchesDescription": "މި ކެމްޕޭނަށް ނިސްބަތްކުރެވޭ ކޮންމެ ލިޔުމަކާއި، ޚިޔާރުކުރި މޮޑެލްގެ ދަށުން އޭގެ ބައި.",
        "touchesEmptyTitle": "ނިސްބަތްކުރެވުނު އެއްޗެއް ނެތް",
        "touchesEmptyDescription": "ޓަޗެއް ލިޔެވެނީ ލިބުނު ފަރާތުގެ އޯޑަރެއް، ކޯޓޭޝަނެއް ނުވަތަ އިންވޮއިސެއް އެޓްރިބިއުޝަން މުއްދަތުގެ ތެރޭގައި އައުމުންނެވެ.",
        "share": "ބައި",
        "windowApplied": "{days} ދުވަހުގެ މުއްދަތު"
      },
      "forecast": {
        "title": "ފޯކާސްޓް",
        "description": "ޝާއިޢުކުރި އަދަދުތަކާއި، އެއާ ކިހާ ކައިރިވިކަން.",
        "immutableNote": "ޝާއިޢުކުރި ސްނެޕްޝޮޓެއް އެޑިޓް ނުވަތަ ފޮހެއެއް ނުލެވެއެވެ. ފަހުން އަލުން ހިސާބުކުރެވޭ އަދަދަކީ ޝާއިޢުކުރި އަދަދެއް ނޫނެވެ.",
        "categoriesTitle": "ފޯކާސްޓް ބައިތައް",
        "categoriesDescription": "ކޮމިޓާއި ބެސްޓް ކޭސްއަށް ވަންނަނީ ކޮން ބައިތަކެއްކަން.",
        "categoriesEmptyTitle": "ބައެއް ނެތް",
        "categoriesEmptyDescription": "ކޮމިޓް، ބެސްޓް ކޭސް އަދި ޕައިޕްލައިނަކީ އާންމު ތިނެއް.",
        "categoriesManagedNote": "ބައިތަކަކީ ކޮންފިގަރޭޝަނެވެ. ކޮމިޓުން އަބަދުވެސް ބެސްޓް ކޭސް ހިމެނެއެވެ — އެކަން ޑޭޓާބޭސުން ކަށަވަރުކުރެއެވެ.",
        "inCommit": "ކޮމިޓްގައި",
        "inBestCase": "ބެސްޓް ކޭސްގައި",
        "inactive": "ނުހިނގާ",
        "snapshotsTitle": "ޝާއިޢުކުރި ސްނެޕްޝޮޓްތައް",
        "snapshotsDescription": "ކޮންމެ ތާރީޚަކަށް، ކުންފުންޏަކަށް، ވެރިޔަކަށް އަދި މުއްދަތަކަށް އެއް ސަޠުރު.",
        "snapshotsEmptyTitle": "ޝާއިޢުކުރެވިފައެއް ނުވޭ",
        "snapshotsEmptyDescription": "ކޮންމެ ރެއަކު ސްނެޕްޝޮޓެއް ޝާއިޢުކުރެއެވެ. ތާރީޚު ފެށުމަށް މިހާރު އެއް ސްނެޕްޝޮޓް ނަގާ.",
        "snapshotNow": "މިހާރު ސްނެޕްޝޮޓް ނަގާ",
        "snapshotTaken": "ސްނެޕްޝޮޓް ޝާއިޢުކުރެވިއްޖެ",
        "snapshotOn": "ތާރީޚު",
        "period": "މުއްދަތު",
        "owner": "ވެރިޔާ",
        "allOwners": "ހުރިހާ ވެރިން",
        "pipeline": "ޕައިޕްލައިން",
        "bestCase": "ބެސްޓް ކޭސް",
        "commit": "ކޮމިޓް",
        "closedWon": "ކާމިޔާބުވި",
        "opportunities": "ޑީލްތައް",
        "accuracyTitle": "ޞައްޙަކަން",
        "accuracyDescription": "ކޮންމެ މުއްދަތެއްގެ ޙަޤީޤީ އަދަދު، ޝާއިޢުކުރި ކޮމިޓާ އަޅާކިޔައެވެ — އަލުން ހިސާބުކުރި އަދަދަކާ ނޫނެވެ.",
        "accuracyEmptyTitle": "އަޅާކިޔާނެ އެއްޗެއް ނެތް",
        "accuracyEmptyDescription": "ޞައްޙަކަން ބެލުމަށް ޝާއިޢުކުރި ސްނެޕްޝޮޓަކާއި ނިމިފައިވާ މުއްދަތެއް ބޭނުންވެއެވެ.",
        "publishedOn": "ޝާއިޢުކުރީ",
        "actual": "ޙަޤީޤީ",
        "absoluteError": "ތަފާތު",
        "percentError": "ތަފާތު %",
        "periodHint": "އަހަރެއް (2026)، ކުއާޓަރެއް (2026-Q1) ނުވަތަ މަހެއް (2026-03).",
        "company": "ކުންފުނި",
        "allCompanies": "ހުރިހާ ކުންފުނިތައް",
        "companyRef": "ކުންފުނި #{id}",
        "chooseCompany": "ކުންފުންޏެއް ޚިޔާރުކުރޭ",
        "ownerRef": "ވެރިޔާ #{id}",
        "currency": "ފައިސާ",
        "currencyHint": "ކުންފުނީގެ އަސާސީ ފައިސާ، ކޮންމެ ރެއަކު ހިނގާ ވަޒީފާ ސްނެޕްޝޮޓް ނަގަނީ ވެސް އެ ފައިސާއިންނެވެ.",
        "publish": "ޝާއިޢުކުރޭ",
        "snapshotDialogDescription": "ކޮންމެ ރެއަކު ހިނގާ ވަޒީފާ ހަދާ ހަމަ އެ ހިސާބު، މިހާރު ޝާއިޢުކުރެއެވެ. ލިޔުމަށްފަހު ބަދަލެއް ނުކުރެވެއެވެ.",
        "accuracyPeriodOnly": "ޞައްޙަކަން ދައްކަނީ މުއްދަތަށް އެކަންޏެވެ؛ މަތީގައިވާ ކުންފުނީގެ ފިލްޓަރު މިއަށް ނުހިނގައެވެ.",
        "accuracyNeedsPeriodTitle": "މުއްދަތެއް ޚިޔާރުކުރޭ",
        "accuracyNeedsPeriodDescription": "ޞައްޙަކަން އަޅާކިޔަނީ އެއް މުއްދަތެކެވެ، އެހެންކަމުން މަތީގައި މުއްދަތެއް ބޭނުންވެއެވެ."
      },
      "winLoss": {
        "title": "ކާމިޔާބު/ނާކާމިޔާބު",
        "description": "ޑީލްތައް ކާމިޔާބުވި އަދި ނާކާމިޔާބުވި ސަބަބު، ނިންމުމުގެ ސަބަބުން ބަހާލައިގެން.",
        "from": "ފެށޭ",
        "to": "ނިމޭ",
        "wonCount": "ކާމިޔާބު",
        "lostCount": "ނާކާމިޔާބު",
        "wonAmount": "ކާމިޔާބުވި އަގު",
        "lostAmount": "ނާކާމިޔާބުވި އަގު",
        "winRate": "ކާމިޔާބުވި ނިސްބަތް",
        "winRateHelp": "ސާވަރުން ކާމިޔާބު އަދި ނާކާމިޔާބުވި އަދަދުތަކުން ހިސާބުކުރެއެވެ.",
        "wonTitle": "ކާމިޔާބު",
        "lostTitle": "ނާކާމިޔާބު",
        "wonEmptyTitle": "މި މުއްދަތުގައި ކާމިޔާބުވި އެއްޗެއް ނެތް",
        "wonEmptyDescription": "ތާރީޚުގެ ދާއިރާ ފުޅާކުރޭ، ނުވަތަ ޑީލެއް ނިންމާ.",
        "lostEmptyTitle": "މި މުއްދަތުގައި ނާކާމިޔާބުވި އެއްޗެއް ނެތް",
        "lostEmptyDescription": "ތާރީޚުގެ ދާއިރާ ފުޅާކުރޭ.",
        "reason": "ސަބަބު",
        "opportunities": "ޑީލްތައް",
        "amount": "އަގު",
        "outcome_won": "ކާމިޔާބުވި ސަބަބު",
        "outcome_lost": "ނާކާމިޔާބުވި ސަބަބު",
        "requiresCompetitor": "ވާދަވެރިޔެއް ބޭނުންވޭ",
        "requiresNote": "ނޯޓެއް ބޭނުންވޭ",
        "cataloguesTitle": "ނިންމުމުގެ ސަބަބުތައް",
        "cataloguesDescription": "ސަބަބެއް ނިސްބަތްވަނީ އެއް ނަތީޖާއަކަށެވެ. ދެ ނަތީޖާއަށް އެއް ލިސްޓެއް ބޭނުންކުރުމުން، ކާމިޔާބެއްގައި ކުށުން ޚިޔާރުކުރި ސަބަބެއް އެންމެ ބޮޑު ނާކާމިޔާބީގެ ސަބަބަށް ވެދާނެއެވެ.",
        "competitorCount": "ފައިލްގައި {count} ވާދަވެރިޔެއް",
        "winRateByAmount": "އަގުން ކާމިޔާބުވި ނިސްބަތް",
        "winRateByAmountHelp": "ކާމިޔާބުވި އަގު، ކާމިޔާބާއި ނާކާމިޔާބުވި އަގުގެ ޖުމުލައާ އަޅާ — ސާވަރުން ހިސާބުކުރެއެވެ.",
        "window": "ނިމުނީ {from} އިން {to} އަށެވެ.",
        "noCompetitorBreakdown": "މި ރިޕޯޓު ބަހަނީ ނިންމުމުގެ ސަބަބުން އެކަންޏެވެ — ވާދަވެރިންގެ ތަފުޞީލެއް މީގައި ނުހިމެނެއެވެ."
      },
      "scoring": {
        "title": "ލީޑް ސްކޯރިން",
        "description": "ކަނޑައެޅިފައިވާ ޤަވާޢިދުތައް، ކޮންމެ ރަނަކަށް ވަރޝަނެއް، އަދި ފުރިހަމަ ތަފުޞީލެއް.",
        "oneActiveNote": "ހަމައެކަނި އެއް މޮޑެލް ހިނގަން ޖެހޭނެއެވެ. ދެ މޮޑެލް ހިނގާނަމަ ދެ ސްކޯރ ލިބި، ޖަވާބެއް ނުލިބޭނެއެވެ.",
        "emptyTitle": "ސްކޯރ މޮޑެލެއް ނެތް",
        "emptyDescription": "މޮޑެލަކީ ޕޮއިންޓް ލިބޭ ޤަވާޢިދުތަކުގެ ލިސްޓެކެވެ. ލީޑްތަކަށް ސްކޯރ ދިނުމަށް އެއް މޮޑެލް އުފައްދާ.",
        "newModel": "އައު މޮޑެލް",
        "newModelDescription": "ބޭންޑްތަކުން ހޫނު، ތާފަނާ އަދި ފިނި ކަނޑައަޅައެވެ. ހޫނު ބޭންޑް ތާފަނާއަށްވުރެ މަތިވާން ޖެހޭނެ.",
        "modelCreated": "މޮޑެލް އުފެއްދިއްޖެ",
        "model": "މޮޑެލް",
        "code": "ކޯޑް",
        "name": "ނަން",
        "hotThreshold": "ހޫނުވަނީ",
        "warmThreshold": "ތާފަނާވަނީ",
        "bandsInvalid": "ހޫނު ބޭންޑް ތާފަނާއަށްވުރެ މަތިވާން ޖެހޭ، ތާފަނާ ސުމެއް ނުވަތަ އެއަށްވުރެ މަތިވާން ޖެހޭ، އަދި ހޫނު 100 ނުވަތަ އެއަށްވުރެ ދަށްވާން ޖެހޭ.",
        "bands": "ހޫނު ≥ {hot}، ތާފަނާ ≥ {warm}",
        "active": "ހިނގަނީ",
        "activeHint": "މިހާރު ހިނގާ",
        "activate": "ހިންގާ",
        "activated": "މޮޑެލް ހިންގަން ފަށައިފި",
        "version": "ވަރޝަން {version}",
        "rulesTitle": "ޤަވާޢިދުތައް",
        "rulesDescription": "ތަރުތީބުން ބެލެވެއެވެ. ޕޮއިންޓްތައް އެއްކޮށްގެން ސްކޯރ އުފެދެއެވެ.",
        "rulesEmptyTitle": "ޤަވާޢިދެއް ނެތް",
        "rulesEmptyDescription": "ޤަވާޢިދެއް ނެތް މޮޑެލަކުން ކޮންމެ ލީޑަކަށްވެސް ސުމެއް ދެއެވެ.",
        "addRule": "ޤަވާޢިދު އިތުރުކުރޭ",
        "addRuleDescription": "ސްކޯރ ދެވެނީ ހުއްދަ ލިސްޓުގައިވާ ދާނަތަކަށެވެ. ނޭނގޭ ދާނައެއް ރައްކާކުރާއިރު ދޮގުކުރެވެއެވެ، ހިންގާއިރު ހިމޭނުން ދޫކޮށްލެވެނީއެއް ނޫނެވެ.",
        "ruleAdded": "ޤަވާޢިދު އިތުރުކުރެވިއްޖެ",
        "field": "ދާނަ",
        "operator": "އޮޕަރޭޓަރ",
        "value": "އަގު",
        "points": "ޕޮއިންޓް",
        "pointsHint": "-100 އާއި 100 އާ ދެމެދު. މައިނަސް ޕޮއިންޓަކީ ޞައްޙަ އެއްޗެއް.",
        "label": "ލޭބަލް",
        "traceTitle": "ތަފުޞީލު",
        "traceDescription": "އެއް ލީޑަކަށް އެ ސްކޯރ ލިބުނު ސަބަބު.",
        "traceEmptyTitle": "ދައްކާނެ ރަނެއް ނެތް",
        "traceEmptyDescription": "ލީޑްގެ އައިޑީ ޖަހައި އަލުން ސްކޯރ ދީގެން ކޮންމެ ޤަވާޢިދެއްގެ ބައި ބައްލަވާ.",
        "leadId": "ލީޑް އައިޑީ",
        "rescore": "އަލުން ސްކޯރ ދޭ",
        "ranAgainstVersion": "v{version} އާ ދެކޮޅަށް",
        "matched": "ދިމާވި",
        "notMatched": "ދިމައެއް ނުވި",
        "running": "ޖުމުލަ {score}",
        "clamped": "0–100 އަށް ހިފެހެއްޓިފައި"
      },
      "routing": {
        "title": "ލީޑް ރައުޓިން",
        "description": "އައު ލީޑެއް ދާނީ ކާކަށްކަން، އަދި ޤަވާޢިދުތައް ބެލޭ ތަރުތީބު.",
        "rescoreDoesNotRoute": "ކޮންމެ ރެއަކު ދެވޭ ސްކޯރުން ސްކޯރާއި ބޭންޑް ބަދަލުކުރެއެވެ، ނަމަވެސް ޤަޞްދުގައި އަލުން ރައުޓެއް ނުކުރެއެވެ. ބަރުދަނެއް ބަދަލުވުމުން ސޭލްސް މީހެއްގެ ލީޑްތައް ރޭގަނޑު ބަދަލުކުރުމަކީ އެއްވެސް މީހަކު އެދޭނެ ކަމެއް ނޫނެވެ.",
        "emptyTitle": "ރައުޓިން ޤަވާޢިދެއް ނެތް",
        "emptyDescription": "ޤަވާޢިދެއް ނެތި ލީޑެއް ރައުޓްކުރުން ދޮގުކުރެވެއެވެ. އެއް ޤަވާޢިދު އިތުރުކުރޭ — އަދި އެންމެ ފަހު ޤަވާޢިދު ހުރިހާ އެއްޗަކާ ދިމާވާ ޤަވާޢިދަކަށް ހަދާ.",
        "addRule": "ޤަވާޢިދު އިތުރުކުރޭ",
        "addRuleDescription": "ދިމާވުމުގެ ދާނަތައް ހުސްކޮށް ބެހެއްޓުމުން ހުރިހާ އެއްޗަކާ ދިމާވާ ޤަވާޢިދަކަށް ވެއެވެ. އެއީ އެންމެ ފަހު ޤަވާޢިދަށް ވާން ޖެހޭނެ.",
        "created": "ޤަވާޢިދު އިތުރުކުރެވިއްޖެ",
        "name": "ނަން",
        "matchBand": "ސްކޯރ ބޭންޑް",
        "matchSource": "ލީޑްގެ މަޞްދަރު",
        "matchCountry": "ޤައުމު",
        "matchSegment": "އެކައުންޓް ސެގްމަންޓް",
        "minScore": "އެންމެ ދަށް ސްކޯރ",
        "minScoreIs": "ސްކޯރ ≥ {score}",
        "anyBand": "ކޮންމެ ބޭންޑެއް",
        "anySegment": "ކޮންމެ ސެގްމަންޓެއް",
        "target": "ދޭނީ",
        "targetHint": "މީހަކު، ދައުރެއް ނުވަތަ އުކުޅެއް — މީގެ ތެރެއިން ހަމަ އެކަކު.",
        "targetUser": "ނަން ބަޔާންކުރެވިފައިވާ މީހަކު",
        "targetRole": "ދައުރެއް",
        "targetStrategy": "އުކުޅެއް",
        "assignUser": "ޔޫޒަރ އައިޑީ",
        "assignRole": "ދައުރުގެ ކޯޑް",
        "strategy": "އުކުޅު",
        "roundRobin": "ބުރު ބުރަށް",
        "leastLoaded": "އެންމެ ބުރަ ކުޑަ",
        "catchAll": "ހުރިހާ އެއްޗެއް",
        "inactive": "ނުހިނގާ",
        "catchAllNotLast": "ޤަވާޢިދު {position} ހުރިހާ އެއްޗަކާ ދިމާވެއެވެ، އަދި އެއީ އެންމެ ފަހު ޤަވާޢިދެއް ނޫނެވެ. އޭގެ ފަހުގައިވާ ކޮންމެ ޤަވާޢިދަކަށް ނުފޯރާނެއެވެ.",
        "draftIsCatchAll": "މި ޤަވާޢިދު ހުރިހާ އެއްޗަކާ ދިމާވެއެވެ، އެހެންކަމުން އެންމެ ފަހުން ބެލެވޭނެ އަދި އޭގެ ފަހުން އިތުރުކުރާ އެއްވެސް ޤަވާޢިދެއް ނުހިނގާނެއެވެ.",
        "moveUp": "މައްޗަށް",
        "moveDown": "ތިރިއަށް",
        "routeALead": "ލީޑެއް ރައުޓްކުރޭ",
        "route": "ރައުޓްކުރޭ",
        "routeDescription": "ޤަވާޢިދުތައް ތަރުތީބުން ހިންގައި ލީޑް ދޭނެއެވެ.",
        "leadId": "ލީޑް އައިޑީ",
        "routedToId": "“{rule}” ޤަވާޢިދުން ޔޫޒަރ #{id} އަށް ދެވިއްޖެ.",
        "noMatchExplained": "އެއްވެސް ޤަވާޢިދަކާ ދިމައެއް ނުވި އަދި ހުރިހާ އެއްޗަކާ ދިމާވާ ޤަވާޢިދެއް ނެތެވެ. އެފަދަ ޤަވާޢިދެއް އެންމެ ފަހަށް އިތުރުކުރޭ.",
        "userRef": "ބޭނުންވެރިޔާ #{id}",
        "ruleRef": "ޤަވާޢިދު #{id}"
      }
    }
  },
  "sales": {
    "filtersTitle": "ފިލްޓަރތައް",
    "allCompanies": "ހުރިހާ ކުންފުންޏެއް",
    "addLine": "ސަފެއް އިތުރުކުރޭ",
    "duplicateLine": "ކޮޕީކުރޭ",
    "chooseItem": "ތަކެތި ޚިޔާރުކުރޭ",
    "fields": {
      "company": "ކުންފުނި",
      "customer": "ކަސްޓަމަރު",
      "item": "ތަކެތި",
      "warehouse": "ގުދަން",
      "currency": "ފައިސާ",
      "quantity": "ޢަދަދު",
      "ordered": "އޯޑަރުކުރި",
      "shipped": "ފޮނުވިފައި",
      "reservedQty": "ރިޒަރވްކޮށްފައި",
      "unitPrice": "ޔުނިޓް އަގު",
      "unitCost": "ޔުނިޓް ޚަރަދު",
      "manualPrice": "އަމިއްލައަށް ލިޔާ އަގު",
      "discount": "ޑިސްކައުންޓް",
      "discountPercent": "ޑިސްކައުންޓް އިންސައްތަ",
      "discountTotal": "ޑިސްކައުންޓް ޖުމްލަ",
      "lineAmount": "ސަފުގެ އަދަދު",
      "lineNo": "ސަފު",
      "amount": "އަދަދު",
      "subtotal": "ސަބްޓޯޓަލް",
      "total": "ޖުމްލަ",
      "memo": "މެމޯ",
      "reference": "ރެފަރެންސް",
      "reason": "ސަބަބު",
      "description": "ތަފްޞީލު",
      "revenueAccount": "އާމްދަނީ އެކައުންޓް",
      "revRecTerm": "އާމްދަނީ ބަހާ މަސްތައް",
      "createdAt": "އުފެއްދި ވަގުތު"
    },
    "aria": {
      "quantity": "ޢަދަދު، ސަފު {line}",
      "discount": "ޑިސްކައުންޓް އިންސައްތަ، ސަފު {line}",
      "manualPrice": "އަމިއްލައަށް ލިޔާ ޔުނިޓް އަގު، ސަފު {line}",
      "description": "ތަފްޞީލު، ސަފު {line}",
      "revRecTerm": "އާމްދަނީ ބަހާ މަސްތައް، ސަފު {line}",
      "picking": "ނަގާ ޢަދަދު، ސަފު {line}",
      "returning": "{item} އިން އަނބުރާ ދޭ ޢަދަދު"
    },
    "reports": {
      "from": "ފެށޭ ތާރީޚް",
      "to": "ނިމޭ ތާރީޚް"
    },
    "routeTitles": {
      "priceLists": "އަގުތަކުގެ ލިސްޓް",
      "priceList": "އަގުތަކުގެ ލިސްޓް",
      "priceListNew": "އައު އަގުތަކުގެ ލިސްޓް",
      "promotions": "ޕްރޮމޯޝަންތައް",
      "quotes": "ވިއްކުމުގެ އަގު ހުށަހެޅުންތައް",
      "quote": "ވިއްކުމުގެ އަގު ހުށަހެޅުން",
      "quoteNew": "އައު ވިއްކުމުގެ އަގު ހުށަހެޅުން",
      "orders": "ވިއްކުމުގެ އޯޑަރުތައް",
      "order": "ވިއްކުމުގެ އޯޑަރު",
      "orderNew": "އައު ވިއްކުމުގެ އޯޑަރު",
      "shipments": "ފޮނުވުންތައް",
      "shipment": "ފޮނުވުން",
      "shipmentNew": "ނަގައި ފޮނުވުން",
      "backorders": "ބާކީ އޯޑަރުތައް",
      "returns": "އަނބުރާ ދިނުންތައް",
      "return": "އަނބުރާ ދިނުން",
      "returnNew": "އައު އަނބުރާ ދިނުން",
      "subscriptions": "ސަބްސްކްރިޕްޝަންތައް",
      "subscription": "ސަބްސްކްރިޕްޝަން",
      "subscriptionPlans": "ސަބްސްކްރިޕްޝަން ޕްލޭންތައް",
      "revRec": "ފަސްކުރެވިފައިވާ އާމްދަނީ",
      "revRecSchedule": "އާމްދަނީ ބަހާ ތާވަލު",
      "pipeline": "ވިއްކުމުގެ ޕައިޕްލައިން",
      "forecast": "ވިއްކުމުގެ ލަފާ",
      "salesBy": "ވިއްކުން ބަހާލައިގެން",
      "mrr": "މަހުގެ އަދި އަހަރުގެ ތަކުރާރު އާމްދަނީ",
      "settings": "ވިއްކުމުގެ ސެޓިންގތައް",
      "tradeAgreements": "ވިޔަފާރީގެ އެއްބަސްވުންތައް",
      "rebatePrograms": "ރިބޭޓް ޕްރޮގްރާމްތައް",
      "rebateAccruals": "ރިބޭޓް ޖަމާވުންތައް",
      "customerContracts": "ކަސްޓަމަރު ކޮންޓްރެކްޓްތައް",
      "discountPolicies": "ޑިސްކައުންޓް އުޞޫލުތައް",
      "obligations": "އާމްދަނީ ދެނެގަތުން"
    },
    "chain": {
      "label": "އޯޑަރުން ފައިސާއަށް ދާ ސިލްސިލާ",
      "notYet": "އަދި ނުވޭ",
      "draft": "ދެލިކޮޕީ",
      "count": "{count} ލިޔުން",
      "hopLabel": "{stage}، {label}، ޙާލަތު {state}",
      "stages": {
        "quote": "އަގު ހުށަހެޅުން",
        "order": "އޯޑަރު",
        "shipment": "ފޮނުވުން",
        "invoice": "އިންވޮއިސް",
        "return": "އަނބުރާ ދިނުން"
      },
      "states": {
        "done": "ފުރިހަމަ",
        "partial": "ބައެއް ފުރިހަމަ",
        "cancelled": "ކެންސަލްކޮށްފައި",
        "pending": "އަދި ނުނިމޭ"
      },
      "scoped": {
        "quote": "އަގު ހުށަހެޅުންތައް",
        "order": "އޯޑަރުތައް",
        "shipment": "ފޮނުވުންތައް",
        "invoice": "އިންވޮއިސްތައް",
        "return": "އަނބުރާ ދިނުންތައް"
      },
      "next": {
        "quote": "ދެން: މި ކަސްޓަމަރަށް އަގު ހުށަހެޅުމެއް ހަދާ.",
        "order": "ދެން: މި އަގު ހުށަހެޅުން ވިއްކުމުގެ އޯޑަރަކަށް ބަދަލުކުރޭ.",
        "shipment": "ދެން: މި އޯޑަރުން ވަޢުދުވި މުދާ ނަގައި ފޮނުވާ.",
        "invoice": "ދެން: ފޮނުވުނު މުދަލަށް ކަސްޓަމަރު އިންވޮއިސް ހަދާ.",
        "return": "މި އޯޑަރާ ދެކޮޅަށް އެއްވެސް އެއްޗެއް އަނބުރާ ދީފައެއް ނުވެއެވެ."
      }
    },
    "pricing": {
      "whyColumn": "މި އަގު މިހެން ވީ ސަބަބު",
      "why": "ކީއްވެ؟",
      "ruleUnknown": "ސާވަރުން ބުނި އަގު ކަނޑައެޅުމުގެ ޤަވާޢިދު މި ވަރޝަނަށް ނޭނގެއެވެ.",
      "promotionApplied": "ޕްރޮމޯޝަން އަޅާފައި",
      "ladderCaption": "ކާމިޔާބުވި އަގުތަކުގެ ލިސްޓުގައި މި ތަކެއްޗަށް ހުރި ޢަދަދުގެ ދަރަޖަތައް",
      "fromQty": "{qty} އިން ފެށިގެން",
      "marginFloorAt": "މި ތަކެތީގެ ފައިދާގެ އެންމެ ދަށް ޙައްދަކީ މިންގަނޑު ޚަރަދުގެ މައްޗަށް {percent}% އެވެ.",
      "manualOverridesEngine": "އަމިއްލައަށް ލިޔާ އަގަކުން މި ސަފަށް އަގު ކަނޑައަޅާ އިންޖީނުގެ ޖަވާބު ބަދަލުކުރެއެވެ.",
      "rules": {
        "contract": "އެއްބަސްވުމުގެ އަގު",
        "tier": "ކަސްޓަމަރުގެ ފަންތި",
        "qty_break": "ޢަދަދުގެ ދަރަޖަ",
        "base_list": "އަސާސީ ލިސްޓް",
        "manual": "އަތުން ލިޔެފައި"
      },
      "margin": {
        "ok": "ޙައްދުން މަތީގައި",
        "blocked": "ފައިދާގެ ޙައްދުން ދަށުގައި — ހުއްޓުވިފައި",
        "overridable": "ފައިދާގެ ޙައްދުން ދަށުގައި — ފާސްކުރަން ޖެހޭ",
        "ignored": "ޙައްދުން ދަށުގައި — ސިޔާސަތުން ފަރުވާލެއް ނުބަހައްޓާ",
        "unknown": "ޙައްދުން ދަށުގައި — ސިޔާސަތު ނޭނގޭ"
      }
    },
    "priceLists": {
      "listTitle": "އަގުތަކުގެ ލިސްޓް",
      "listDescription": "އެއްބަސްވުން، ފަންތި އަދި އަސާސީ ލިސްޓްތައް، އަގު ކަނޑައަޅާ އިންޖީނު ކިޔާ ތަރުތީބުން.",
      "orderNote": "އިސްކަން ދިނުމުގެ ތަރުތީބުން: އެއް ބާވަތެއްގެ ތެރެއިން، އެ ދުވަހު އަމަލުކުރާ އެންމެ އިސް ލިސްޓް ކާމިޔާބުވެއެވެ.",
      "new": "އައު ލިސްޓް",
      "newTitle": "އައު އަގުތަކުގެ ލިސްޓް",
      "newDescription": "ލިސްޓެއްގައި ކޮންމެ ތަކެއްޗަކަށް އެއް ސިޑިއެއް އޮވެއެވެ: އެންމެ ދަށް ޢަދަދާއި އެއިން ފެށިގެން ދާ އަގު.",
      "emptyTitle": "އަދި އަގުތަކުގެ ލިސްޓެއް ނެތް",
      "emptyDescription": "ފުރަތަމަ އަސާސީ ލިސްޓެއް ހަދާ — އެއާ ނުލައި އިންޖީނަށް އެއްވެސް އެއްޗެއްގެ އަގު ނުކިޔޭނެއެވެ، އަދި ދިމާކުރުމުގެ ބަދަލުގައި ދޫކޮށްލާނެއެވެ.",
      "loadFailed": "އަގުތަކުގެ ލިސްޓް ނުލޯޑްވި",
      "saveFailed": "އަގުތަކުގެ ލިސްޓް ރައްކާނުކުރެވުނު",
      "saved": "އަގުތަކުގެ ލިސްޓް ރައްކާކުރެވިއްޖެ",
      "created": "{code} އަގުތަކުގެ ލިސްޓް އުފެދިއްޖެ",
      "headerTitle": "ލިސްޓް",
      "laddersTitle": "ޢަދަދުގެ ސިޑިތައް",
      "laddersDescription": "ކޮންމެ ތަކެއްޗަކަށް އެއް ސިޑި، މައްޗަށް ދާ ތަރުތީބުން: ގިނައިން ގަނެ، މަދުން ދައްކާ.",
      "laddersCaption": "ތަކެއްޗާއި، އެއިން ކޮންމެ އެއްޗެއްގެ އެންމެ ދަށް ޢަދަދާއި އެއިން ފެށިގެން ދާ ޔުނިޓް އަގު",
      "ladderNote": "އިންޖީނު ނަގާނީ އޯޑަރުކުރި ޢަދަދަށްވުރެ މަތިނުވާ އެންމެ މަތީ ދަރަޖައެވެ. ހުރިހާ ދަރަޖައަކަށްވުރެ ދަށް ޢަދަދަކަށް މި ލިސްޓުން އަގެއް ނުކިޔައެވެ.",
      "addItem": "ތަކެއްޗެއް އިތުރުކުރޭ",
      "addRung": "ދަރަޖައެއް އިތުރުކުރޭ",
      "sameItem": "ހަމަ އެ ތަކެތި",
      "chooseItem": "ތަކެތި ޚިޔާރުކުރޭ",
      "noLines": "މި ލިސްޓުން އަދި އެއްވެސް އެއްޗެއްގެ އަގު ނުކިޔައެވެ.",
      "fromQty": "ފެށޭ ޢަދަދު",
      "startsAbove": "މި ސިޑި ފެށެނީ {qty} އިންކަމުން، އެއަށްވުރެ ދަށަށް މި ލިސްޓުން އަގެއް ނުކިޔައެވެ.",
      "risesWithQty": "މި ދަރަޖަ، ތިރީގައިވާ ދަރަޖައަށްވުރެ އަގު ބޮޑެވެ.",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "inForce": "މިއަދު އަމަލުކުރޭ",
      "notInForce": "މިއަދު އަމަލެއް ނުކުރޭ",
      "columns": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "kind": "ބާވަތް",
        "tier": "ފަންތި",
        "priority": "އިސްކަން",
        "window": "އަމަލުކުރާ މުއްދަތު",
        "lines": "ދަރަޖަ",
        "inForce": "މިއަދު"
      },
      "kinds": {
        "base": "އަސާސީ",
        "tier": "ފަންތި",
        "contract": "އެއްބަސްވުން"
      },
      "kindHints": {
        "base": "އެއްވެސް ފަރާތަކާ ވާހަކަ ނުދެކެވި އޮންނަ އަސާސް.",
        "tier": "އެއް އަގުގެ ފަންތިއެއްގައި ތިބި ހުރިހާ ކަސްޓަމަރުންނަށް.",
        "contract": "ވަކި ކަސްޓަމަރަކާއެކު އެއްބަސްވެފައި، އަދި އެހެން ހުރިހާ ލިސްޓަކަށްވުރެ އިސްވެއެވެ."
      },
      "fields": {
        "customerHint": "އެއްބަސްވުމުގެ ލިސްޓަކުން އަގު ކިޔަނީ ހަމައެކަނި މި ކަސްޓަމަރަށެވެ.",
        "tierHint": "ކަސްޓަމަރުގެ އަމިއްލަ އަގުގެ ފަންތިއާ އަޅާކިޔެއެވެ.",
        "priorityHint": "އެއް ބާވަތެއްގެ ތެރެއިން، އެ ދުވަހު އަމަލުކުރާ އެންމެ އިސް ލިސްޓް ކާމިޔާބުވެއެވެ.",
        "validFrom": "އަމަލުކުރަން ފަށާ",
        "validTo": "އަމަލުކުރުން ނިމޭ",
        "validToHint": "ދެ ތާރީޚުވެސް ހިމެނެއެވެ. ނިމުމެއް ނެތްނަމަ ހުސްކޮށް ބާއްވާ."
      },
      "aria": {
        "minQty": "{item} ގެ އެންމެ ދަށް ޢަދަދު",
        "unitPrice": "{item} ގެ ޔުނިޓް އަގު"
      }
    },
    "promotions": {
      "listTitle": "ޕްރޮމޯޝަންތައް",
      "listDescription": "ލިސްޓަކުން އަގު ކަނޑައެޅުމަށްފަހު އެ އަގު ބަދަލުކުރާ، މުއްދަތު ކަނޑައެޅިފައިވާ ހުށަހެޅުންތައް.",
      "new": "އައު ޕްރޮމޯޝަން",
      "newTitle": "އައު ޕްރޮމޯޝަން",
      "editTitle": "ޕްރޮމޯޝަން އެޑިޓްކުރޭ",
      "dialogDescription": "ޕްރޮމޯޝަނަކުން ޑިސްކައުންޓް ދެނީ ލިސްޓްތަކުން ކަނޑައެޅި އަގަށެވެ. އެ ލިސްޓްތަކުގެ ބަދަލަކަށް ނުވެއެވެ.",
      "emptyTitle": "ޕްރޮމޯޝަނެއް ނެތް",
      "emptyDescription": "ޚިޔާރުކުރި ތާރީޚުގައި އެއްވެސް އެއްޗެއް ނުހިނގައެވެ. ކުރިން ހިނގި އެއްޗެހި ބެލުމަށް ތާރީޚް ބަދަލުކުރޭ، ނުވަތަ އައު އެއްޗެއް ހަދާ.",
      "loadFailed": "ޕްރޮމޯޝަންތައް ނުލޯޑްވި",
      "saveFailed": "ޕްރޮމޯޝަން ރައްކާނުކުރެވުނު",
      "saved": "ޕްރޮމޯޝަން ރައްކާކުރެވިއްޖެ",
      "created": "{code} ޕްރޮމޯޝަން އުފެދިއްޖެ",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "activeOn": "ހިނގާ ތާރީޚް",
      "activeOnHint": "ޕްރޮމޯޝަނެއް އަޅަނީ އެއީ ހަރަކާތްތެރި އެއްޗަކަށްވެ، ލިޔުމުގެ ތާރީޚް އޭގެ މުއްދަތުގެ ތެރެއަށް ވަންނަ ނަމައެވެ.",
      "everyone": "ހުރިހާ ފަރާތެއް",
      "restrictedTo": "{customers} ކަސްޓަމަރު، {tiers} ފަންތި، {items} ތަކެތި",
      "unrestricted": "ކަސްޓަމަރެއް، ފަންތިއެއް ނުވަތަ ތަކެއްޗެއް ނުބުނާނަމަ، މި ޕްރޮމޯޝަން ވިއްކާ ހުރިހާ އެއްޗަކަށް އަޅާނެއެވެ.",
      "stacksNote": "ޕްރޮމޯޝަނެއް ހިނގަނީ އަގުތަކުގެ ލިސްޓަކުން އަގު ކަނޑައެޅުމަށްފަހުއެވެ. ސަފުގައި ދެ ކަންތައްވެސް ދެއްކެއެވެ: އަގު ކަނޑައެޅި ލިސްޓާއި، އެ އަގު ބަދަލުކުރި ޕްރޮމޯޝަން.",
      "editLimits": "ބަދަލުކުރެވޭނީ ހަމައެކަނި ނަމާއި، ނިމޭ ތާރީޚާއި، ހަރަކާތްތެރި ސުވިޗެވެ. މި ޕްރޮމޯޝަނުގެ ދަށުން އަގު ކިޔާފައިވާ ސަފުތައް އަގު ހުށަހެޅުންތަކުގައި މިހާރު ހުރެއެވެ، އަދި ޝަރުޠުތައް ބަދަލުކުރުމުން އެ ސަފުތައް ބަޔާންނުކުރެވޭނެއެވެ — އޭގެ ބަދަލުގައި ކުރިން ނިންމާލާ.",
      "columns": {
        "eligibility": "އަޅާ ފަރާތްތައް"
      },
      "kinds": {
        "percent": "އިންސައްތައިން ދޫކުރުން",
        "amount": "އަދަދަކުން ދޫކުރުން",
        "bundle": "ބަނޑްލް"
      },
      "kindHints": {
        "percent": "ކަނޑައެޅުނު އަގުން އިންސައްތައެއް.",
        "amount": "އެއް ފައިސާއަކުން ކަނޑައެޅިފައިވާ އަދަދެއް.",
        "bundle": "އިންސައްތައެއް، ނަމަވެސް ހަމައެކަނި ވަކި ޢަދަދެއް ނަގައިފިނަމަ."
      },
      "valueHints": {
        "percent": "އިންސައްތައެއް، މިސާލަކަށް ދިހަ އިންސައްތައަށް 10.",
        "amount": "ތިރީގައިވާ ފައިސާއިން އަދަދެއް.",
        "bundle": "އިންސައްތައެއް، ހަމައެކަނި ބަނޑްލްގެ ޢަދަދަށް ނުވަތަ އެއަށްވުރެ މައްޗަށް."
      },
      "fields": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "kind": "ބާވަތް",
        "value": "އަދަދު",
        "bundleMinQty": "ބަނޑްލްގެ ޢަދަދު",
        "bundleMinQtyHint": "ބަނޑްލް ޑިސްކައުންޓް ފެށޭ ޢަދަދު.",
        "minQty": "އެންމެ ދަށް ޢަދަދު",
        "minQtyHint": "މި ޢަދަދަށްވުރެ ދަށްވެއްޖެނަމަ ޕްރޮމޯޝަން އެއްގޮތަކަށްވެސް ނާޅައެވެ.",
        "startDate": "ފެށޭ",
        "endDate": "ނިމޭ",
        "endDateHint": "މި ތާރީޚް ހިމެނެއެވެ. ހިނގަމުންދާ ޕްރޮމޯޝަނެއް ހުއްޓުވަނީ މި ތާރީޚް ކުރިއަށް ގެނެސްގެންނެވެ.",
        "customerIds": "ކަސްޓަމަރުގެ އައިޑީތައް",
        "customerTiers": "ކަސްޓަމަރުގެ ފަންތިތައް",
        "itemIds": "ތަކެތީގެ އައިޑީތައް",
        "idListHint": "ކޮމާއިން ވަކިކޮށްފައި. ހުރިހާ އެއްޗަކަށް އެޅުމަށް ހުސްކޮށް ބާއްވާ.",
        "tierListHint": "ކޮމާއިން ވަކިކުރެވިފައިވާ ފަންތީގެ ކޯޑްތައް. ހުރިހާ ފަންތިއަކަށް ހުސްކޮށް ބާއްވާ."
      }
    },
    "quotes": {
      "listTitle": "ވިއްކުމުގެ އަގު ހުށަހެޅުންތައް",
      "listDescription": "މުއްދަތަކަށް ހުޅުވިފައި ބާއްވާ އަގުތައް. ތާރީޚް ފަހަނައަޅާފައިވާ އަގު ހުށަހެޅުމަކީ ދިރިހުރި ހުށަހެޅުމެއް ނޫނެވެ.",
      "new": "އައު އަގު ހުށަހެޅުން",
      "newTitle": "އައު ވިއްކުމުގެ އަގު ހުށަހެޅުން",
      "draftTitle": "ދެލިކޮޕީ އަގު ހުށަހެޅުން",
      "emptyTitle": "އަދި އަގު ހުށަހެޅުމެއް ނެތް",
      "emptyDescription": "ކަސްޓަމަރަކަށް އެއް ހަދާ، އަދި ކޮންމެ ސަފެއްގެ އަގު ކަނޑައެޅޭ ގޮތް އެ ވަގުތު ބަޔާންކުރެވޭނެއެވެ.",
      "searchPlaceholder": "އަގު ހުށަހެޅުމުގެ ނަންބަރު ނުވަތަ ރެފަރެންސް",
      "loadFailed": "އަގު ހުށަހެޅުންތައް ނުލޯޑްވި",
      "saveFailed": "އަގު ހުށަހެޅުން ރައްކާނުކުރެވުނު",
      "saved": "އަގު ހުށަހެޅުން ރައްކާކުރެވިއްޖެ",
      "created": "އަގު ހުށަހެޅުން އުފެދިއްޖެ",
      "headerTitle": "އަގު ހުށަހެޅުން",
      "linesTitle": "ސަފުތައް",
      "linesDescription": "ޢަދަދާއި ޑިސްކައުންޓެއް ވާނަމަ އެ ލިޔޭ. ކޮންމެ އަގަކީ ސާވަރުގެ ޖަވާބެވެ، އަދި އެ އަގު ނެރުނު ޤަވާޢިދާއެކުއެވެ.",
      "linesCaption": "އެޑިޓްކުރެވޭ ސަފުތައް: ތަކެތި، ޢަދަދު، ޑިސްކައުންޓް އަދި ބޭނުންނަމަ އަމިއްލައަށް ލިޔާ އަގު",
      "pricedCaption": "އަގު ކިޔާފައިވާ ސަފުތައް، ކޮންމެ އަގެއްގެ ފަހަތުގައިވާ ޤަވާޢިދާއެކު",
      "columns": {
        "quoteNo": "އަގު ހުށަހެޅުމުގެ ނަންބަރު",
        "quoteDate": "ހުށަހެޅި ތާރީޚް",
        "expiry": "މުއްދަތު ހަމަވުން"
      },
      "fields": {
        "expiryHint": "މި ތާރީޚަށްފަހު، ސްޓޭޓަސް ކޮންމެ އެއްޗެއް ބުންޏަސް، ހުށަހެޅުން ދިރިއެއް ނުހުންނާނެއެވެ."
      },
      "noExpiry": "މުއްދަތެއް ކަނޑައަޅާފައެއް ނެތް",
      "expiresInDays": "{days} ދުވަސް ތެރޭ",
      "lapsedDays": "{days} ދުވަސް ކުރިން މުއްދަތު ހަމަވެއްޖެ",
      "lapsedNote": "މި އަގު ހުށަހެޅުމުގެ މުއްދަތު {days} ދުވަސް ކުރިން ހަމަވެއްޖެއެވެ. ސާވަރުގެ މުއްދަތު ބެލުން އަދި ނުހިނގާތީ ފޮނުވިފައި ކަމަށް ދައްކައެވެ — ނަމަވެސް މިއީ ދިރިހުރި ހުށަހެޅުމެއް ނޫނެވެ.",
      "send": "ކަސްޓަމަރަށް ފޮނުވާ",
      "sent": "{quoteNo} އަގު ހުށަހެޅުން ފޮނުވިއްޖެ",
      "sendFailed": "އަގު ހުށަހެޅުން ނުފޮނުވުނު",
      "recordAccept": "ޤަބޫލުކުރިކަން ރެކޯޑްކުރޭ",
      "recordReject": "ބޭރުކުރިކަން ރެކޯޑްކުރޭ",
      "accepted": "ޤަބޫލުކުރިކަން ރެކޯޑްކުރެވިއްޖެ",
      "rejected": "ބޭރުކުރިކަން ރެކޯޑްކުރެވިއްޖެ",
      "decisionFailed": "ކަސްޓަމަރުގެ ނިންމުން ރެކޯޑްނުކުރެވުނު",
      "rejectTitle": "ކަސްޓަމަރު ބޭރުކުރިކަން ރެކޯޑްކުރޭ",
      "rejectDescription": "ސަބަބު އަގު ހުށަހެޅުމުގައާއި އޮޑިޓް ރެކޯޑްގައި ބާއްވާނެއެވެ. ބޭރުކުރީ ކާކުކަމާއި ސަބަބު ލިޔޭ.",
      "rejectionTitle": "ބޭރުކުރި ސަބަބު",
      "cancelTitle": "މި އަގު ހުށަހެޅުން ކެންސަލްކުރޭ",
      "cancelDescription": "ކެންސަލްކުރެވުނު އަގު ހުށަހެޅުމެއް ފޮނުވުމާއި، ޤަބޫލުކުރުމާއި، ބަދަލުކުރުން ނުކުރެވޭނެއެވެ.",
      "cancelQuote": "އަގު ހުށަހެޅުން ކެންސަލްކުރޭ",
      "cancelled": "އަގު ހުށަހެޅުން ކެންސަލްކުރެވިއްޖެ",
      "cancelFailed": "އަގު ހުށަހެޅުން ކެންސަލްނުކުރެވުނު",
      "convert": "އޯޑަރަކަށް ބަދަލުކުރޭ",
      "converted": "ވިއްކުމުގެ އޯޑަރަކަށް ބަދަލުކުރެވިއްޖެ",
      "convertFailed": "އަގު ހުށަހެޅުން ބަދަލުނުކުރެވުނު",
      "viewOrder": "މިއިން އުފެދުނު އޯޑަރު ބަލާ",
      "pdf": "ޕީޑީއެފަށް އެދޭ",
      "pdfReady": "ޕީޑީއެފް ތައްޔާރު",
      "pdfRequested": "ޕީޑީއެފް ތައްޔާރުކުރެވެނީ",
      "pdfFailed": "ޕީޑީއެފް ނުހެދުނު",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "sent": "ފޮނުވިފައި",
        "accepted": "ޤަބޫލުކޮށްފައި",
        "rejected": "ބޭރުކޮށްފައި",
        "expired": "މުއްދަތު ހަމަވެފައި",
        "cancelled": "ކެންސަލްކޮށްފައި",
        "converted": "ބަދަލުކޮށްފައި",
        "superseded": "ބަދަލުވެފައި"
      },
      "parkedToast": "ކޯޓް ފާސްކުރުމަށް މަޑުކުރެވިފައި"
    },
    "orders": {
      "one": "ވިއްކުމުގެ އޯޑަރު",
      "listTitle": "ވިއްކުމުގެ އޯޑަރުތައް",
      "listDescription": "ޔަގީންކުރެވިފައިވާ އޯޑަރަކުން ސްޓޮކް ހިފަހައްޓައެވެ. ހިފަހައްޓާ އެއްޗެއްސާއި، އެހިސާބަށް ދާން ދޫކުރި އެއްޗެހި ކޮންމެ ރޮނގެއްގައި ހުންނާނެއެވެ.",
      "new": "އައު އޯޑަރު",
      "newTitle": "އައު ވިއްކުމުގެ އޯޑަރު",
      "draftTitle": "ދެލިކޮޕީ އޯޑަރު",
      "emptyTitle": "އަދި ވިއްކުމުގެ އޯޑަރެއް ނެތް",
      "emptyDescription": "ސީދާ އެއް ހަދާ، ނުވަތަ ޤަބޫލުކުރެވުނު އަގު ހުށަހެޅުމެއް ބަދަލުކުރޭ — އެއަށްފަހު އަގު ހުށަހެޅުމުން އޭގެ ނަތީޖާ ދައްކާނެއެވެ.",
      "searchPlaceholder": "އޯޑަރު ނަންބަރު ނުވަތަ ރެފަރެންސް",
      "loadFailed": "އޯޑަރުތައް ނުލޯޑްވި",
      "saveFailed": "އޯޑަރު ރައްކާނުކުރެވުނު",
      "saved": "އޯޑަރު ރައްކާކުރެވިއްޖެ",
      "created": "އޯޑަރު އުފެދިއްޖެ",
      "headerTitle": "އޯޑަރު",
      "linesTitle": "ސަފުތައް",
      "linesDescription": "ކޮންމެ ސަފަކަށް ގުދަނަކާއި އާމްދަނީ އެކައުންޓެއް ބޭނުންވެއެވެ: އެކަތިން ވަޢުދުވެވޭ އެއްޗެއް ކަނޑައަޅައެވެ، އަނެކަތިން އިންވޮއިސްއިން ކްރެޑިޓްކުރާ އެއްޗެއް.",
      "linesCaption": "އެޑިޓްކުރެވޭ ސަފުތައް: ތަކެތި، ގުދަން، އާމްދަނީ އެކައުންޓް، ޢަދަދު އަދި ޑިސްކައުންޓް",
      "pricedCaption": "އަގު ކިޔާފައިވާ ސަފުތައް، ފޮނުވިފައިވާ އަދި ރިޒަރވްކޮށްފައިވާ ޢަދަދާއެކު",
      "columns": {
        "orderNo": "އޯޑަރު ނަންބަރު",
        "orderDate": "އޯޑަރު ތާރީޚް",
        "requestedDate": "ބޭނުންވާ ތާރީޚް",
        "overrides": "އޯވަރައިޑްތައް"
      },
      "fields": {
        "requestedDateHint": "ކަސްޓަމަރު އެދުނު ތާރީޚް. އެއަކުން އަމިއްލައަށް އެއްވެސް އެއްޗެއް ރިޒަރވެއް ނުކުރެއެވެ."
      },
      "confirm": "އޯޑަރު ޔަގީންކުރޭ",
      "confirmed": "{orderNo} އޯޑަރު ޔަގީންކުރެވި ސްޓޮކް ރިޒަރވްކުރެވިއްޖެ",
      "confirmFailed": "އޯޑަރު ޔަގީނެއް ނުކުރެވުނު",
      "cancelOrder": "އޯޑަރު ކެންސަލްކުރޭ",
      "cancelTitle": "މި އޯޑަރު ކެންސަލްކުރޭ",
      "cancelDescription": "މި އޯޑަރުން ހިފަހައްޓާ ހުރިހާ ރިޒަރވޭޝަނެއް ދޫކުރެވޭނެއެވެ. އެއްޗެއް ފޮނުވިފައިވާ އޯޑަރެއް ކެންސަލެއް ނުކުރެވޭނެއެވެ.",
      "cancelled": "އޯޑަރު ކެންސަލްކުރެވި ރިޒަރވޭޝަންތައް ދޫކުރެވިއްޖެ",
      "cancelFailed": "އޯޑަރު ކެންސަލްނުކުރެވުނު",
      "fromQuote": "މިއީ ބަދަލުކުރެވުނު އަގު ހުށަހެޅުން",
      "creditOverride": "ކްރެޑިޓް އޯވަރައިޑް",
      "discountOverride": "ޑިސްކައުންޓް އޯވަރައިޑް",
      "creditOverrideGranted": "މި އޯޑަރަށް ކްރެޑިޓް އޯވަރައިޑް ދެވިފައިވެއެވެ: {reason}",
      "discountOverrideGranted": "މި އޯޑަރަށް ޑިސްކައުންޓް އޯވަރައިޑް ދެވިފައިވެއެވެ: {reason}",
      "discountNeedsApproval": "ފާސްކުރުމުގެ {threshold}% ޙައްދު ފަހަނައަޅައެވެ — ޔަގީންކުރުމުން އޯވަރައިޑަކަށް އެދޭނެއެވެ.",
      "deferredNote": "ފަސްކުރެވިފައިވާ އާމްދަނީ އެކައުންޓަށް ބިލްކުރެވި، މި ޢަދަދު މަހަށް ބަހާލެވޭނެއެވެ.",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "pending_approval": "ފާސްކުރުމަށް އިންތިޒާރުގައި",
        "confirmed": "ޔަގީންކޮށްފައި",
        "partially_shipped": "ބައެއް ފޮނުވިފައި",
        "shipped": "ފޮނުވިފައި",
        "invoiced": "އިންވޮއިސްކޮށްފައި",
        "closed": "ބަންދުކޮށްފައި",
        "cancelled": "ކެންސަލްކޮށްފައި"
      },
      "parkedToast": "އޯޑަރު ފާސްކުރުމަށް މަޑުކުރެވިފައި"
    },
    "atp": {
      "title": "ވަޢުދުވެވޭ ސްޓޮކް",
      "description": "ހުރި ޢަދަދުން، އެހެން އޯޑަރުތަކުން ރިޒަރވްކޮށްފައިވާ މިންވަރު އުނިކޮށް، އަންނަން ހުރި މިންވަރު އިތުރުކުރެއެވެ. ހަމައެކަނި ހުރި ޢަދަދަކީ ލިބެންހުރި ޢަދަދެއް ނޫނެވެ.",
      "caption": "ކޮންމެ ތަކެއްޗަކާއި ގުދަނަކަށް: އެދުނު، ހުރި، ރިޒަރވް، އަންނަން ހުރި އަދި ލިބެންހުރި",
      "requested": "އެދުނު",
      "onHand": "ހުރި",
      "reserved": "ރިޒަރވްކޮށްފައި",
      "inbound": "އަންނަން ހުރި",
      "available": "ލިބެންހުރި",
      "checking": "ލިބެންހުރި މިންވަރު ބަލަނީ",
      "empty": "ތަކެއްޗަކާއި ގުދަނަކާއެކު ސަފެއް އިތުރުކުރުމުން، ލިބެންހުރި މިންވަރު މިތާ ފެންނާނެއެވެ.",
      "shortBy": "{qty} މަދު",
      "leansOnInbound": "ވަޢުދުވެވެނީ އަދި އަންނަން ހުރި ސްޓޮކްގެ ސަބަބުން އެކަނި",
      "overCommitted": "މި ގުދަނުގައި ސްޓޮކަށްވުރެ ގިނަ ވަޢުދު ހުއްޓެވެ: ހުސްކޮށް ހުރީ {qty} އެވެ.",
      "willRefuse": "އެއްވެސް ސަފެއް މަދުވާނަމަ ޔަގީންކުރުން ދޫކޮށްލެވޭނެއެވެ. ޢަދަދު މަދުކުރޭ، އެހެން ގުދަނެއް ޚިޔާރުކުރޭ، ނުވަތަ ސްޓޮކަށް އިންތިޒާރުކުރޭ.",
      "inboundNote": "މި އޯޑަރަށް ވަޢުދުވެވިދާނެއެވެ، ނަމަވެސް މިއަދު ނުފޮނުވޭނެއެވެ: އޭގެ ބައެއް ބިނާވެފައިވަނީ އަދި ނާންނަ ސްޓޮކްގެ މައްޗަށެވެ.",
      "unknownNote": "މަދުވެގެން އެއް ސަފަކަށް ލިބެންހުރި މިންވަރު ނޭނގުނުކަމުން، އޯޑަރުގެ ޙާލަތު ރަނގަޅު ކަމަށް ނުބަލައި، ނޭނގޭ ކަމަށް ބެލެވެއެވެ.",
      "notPermitted": "ސްޓޮކް ބެލުމުގެ ހުއްދަ ނެތުމުން ލިބެންހުރި މިންވަރު ނުދެއްކެއެވެ. އެއީ ސުމެއް ނޫނެވެ — އެއީ ނޭނގޭ އެއްޗެކެވެ.",
      "refused": "ވަޢުދުވާން ސްޓޮކް ނެތް",
      "verdicts": {
        "available": "ވަޢުދުވެވިދާނެ",
        "inbound": "އަންނަން ހުރި ސްޓޮކުން ވަޢުދުވެވިދާނެ",
        "short": "ވަޢުދުވާން ނުފުދޭ",
        "unknown": "ލިބެންހުރި މިންވަރު ނޭނގޭ"
      }
    },
    "credit": {
      "limit": "ކްރެޑިޓް ލިމިޓް",
      "noLimit": "ލިމިޓެއް ރެކޯޑްކޮށްފައެއް ނެތް",
      "exposure": "ބޭނުންކޮށްފައިވާ ކްރެޑިޓް",
      "available": "ބާކީ ޖާގަ",
      "overage": "ލިމިޓް ފަހަނައަޅާފައިވާ މިންވަރު",
      "overdue": "މުއްދަތު ފަހަނައަޅާފައި",
      "overdueDays": "{days} ދުވަހާ ހަމައަށް",
      "source": {
        "params": "އޯޑަރު ދޫކޮށްލި ވަގުތު ހުރި އަދަދުތައް.",
        "none": "ކްރެޑިޓްގެ އަދަދުތަކެއް ނުކިޔުނު."
      }
    },
    "creditBlock": {
      "title": "މި އޯޑަރު ކަސްޓަމަރުގެ ކްރެޑިޓް ބެލުމުން ފެއިލްވެއެވެ",
      "pendingTitle": "ކްރެޑިޓް އޯވަރައިޑަށް އެދިފައި",
      "pendingBody": "އެދުން އޮތީ ފާސްކުރާ ފަރާތެއްގެ އަތުގައެވެ. ދެވުމުން އަލުން ޔަގީންކުރޭ؛ ދެފަހަރު އެދުމުން އަވަހެއް ނުވާނެއެވެ.",
      "noPermission": "ތިޔަ ފަރާތަށް އޯޑަރު ޔަގީންކުރެވުނަސް ކްރެޑިޓް ޙައްދު ދޫކޮށްލެވޭކަށް ނެތެވެ. އެކަން ކުރެވޭ ފަރާތް ފާސްކުރުމުގެ ސިލްސިލާގައި ބަޔާންކުރެވިފައިވެއެވެ.",
      "requestOverride": "ކްރެޑިޓް އޯވަރައިޑަކަށް އެދޭ",
      "submitOverride": "އޯވަރައިޑް ހުށަހަޅާ",
      "submitted": "ކްރެޑިޓް އޯވަރައިޑް ފާސްކުރުމަށް ހުށަހެޅިއްޖެ",
      "reasonLabel": "ކޮންމެހެންވެސް މި އޯޑަރު ދާންވީ ސަބަބު",
      "reasonHint": "އޮޑިޓް ރެކޯޑްގައި ރައްކާކުރެވޭނެއެވެ. ސަބަބެއް ނުބުނާ އޯވަރައިޑަކީ ދޫކޮށްލުމެކެވެ.",
      "reasonPlaceholder": "މިސާލު: 3 އޯގަސްޓުގައި ކަސްޓަމަރާއެކު އެއްބަސްވެފައިވާ ފައިސާ ދެއްކުމުގެ ޕްލޭން؛ ފުރަތަމަ ބައި މިހާރު ލިބިއްޖެ."
    },
    "convert": {
      "title": "{quoteNo} ވިއްކުމުގެ އޯޑަރަކަށް ބަދަލުކުރޭ",
      "description": "އަގުތަކަކީ މިހާރުވެސް ކަސްޓަމަރުގެ އަގުތަކެވެ. އޯޑަރަކަށް ބޭނުންވެ، އަގު ހުށަހެޅުމުގައި ނުހުންނަނީ ކޮންމެ ސަފެއް ފޮނުވާ ތަނާއި، ކްރެޑިޓްކުރާ އެކައުންޓެވެ.",
      "whyNote": "އަގު ހުށަހެޅުމެއްގައި އާމްދަނީ އެކައުންޓެއް ނުހުރެއެވެ، އަދި އާންމުކޮށް ގުދަނެއްވެސް ނުހުރެއެވެ، އެހެންކަމުން ދިމާކުރުމުގެ ބަދަލުގައި މިތާ ދެ ސުވާލުވެސް ކުރެވެއެވެ. ވަޢުދުވެވޭ މިންވަރާއި، އޯޑަރުން ރިޒަރވްކުރާ ގުދަން ކަނޑައަޅަނީ ގުދަނުންނެވެ.",
      "caption": "ކޮންމެ ސަފެއް، އެ ސަފު ފޮނުވާ ގުދަނާއި ކްރެޑިޓްކުރާ އާމްދަނީ އެކައުންޓާއެކު",
      "chooseWarehouse": "ގުދަނެއް ޚިޔާރުކުރޭ",
      "allWarehouses": "ހުރިހާ ސަފަކަށް ގުދަން",
      "allWarehousesHint": "ގިނަ އޯޑަރުތައް ފޮނުވެނީ އެއް ގުދަނުންނެވެ.",
      "allAccounts": "ހުރިހާ ސަފަކަށް އާމްދަނީ އެކައުންޓް",
      "allAccountsHint": "ގިނަ އޯޑަރުތަކުން ކްރެޑިޓްކުރަނީ އެއް އެކައުންޓަކަށެވެ.",
      "applyToAll": "ހުރިހާ ސަފަކަށް އަޅާ",
      "noLines": "މި އަގު ހުށަހެޅުމުގައި ބަދަލުކުރާނެ ސަފެއް ނެތެވެ.",
      "missingWarehouse": "{count} ސަފަކަށް އަދިވެސް ގުދަނެއް ބޭނުންވެއެވެ.",
      "missingAccount": "{count} ސަފަކަށް އަދިވެސް އާމްދަނީ އެކައުންޓެއް ބޭނުންވެއެވެ.",
      "aria": {
        "warehouse": "ގުދަން، ސަފު {line}",
        "account": "އާމްދަނީ އެކައުންޓް، ސަފު {line}"
      }
    },
    "guardrail": {
      "title": "މި އޯޑަރަށް ޑިސްކައުންޓް ނުވަތަ ފައިދާގެ ޙައްދުގެ އޯވަރައިޑެއް ބޭނުންވެއެވެ",
      "pendingTitle": "ޑިސްކައުންޓް އޯވަރައިޑަށް އެދިފައި",
      "pendingBody": "އެދުން އޮތީ ފާސްކުރާ ފަރާތެއްގެ އަތުގައެވެ. ދެވުމުން އަލުން ޔަގީންކުރޭ.",
      "onLine": "ސަފު {line}",
      "hardBlock": "ބްލޮކް ސިޔާސަތުގެ ދަށުން ފައިދާގެ ޙައްދު ފަހަނައެޅުމަކަށް ދުވަހަކުވެސް އޯވަރައިޑެއް ނުދެވޭނެއެވެ. އަގު މަތިކުރޭ، ނުވަތަ މި ކުންފުނީގެ ސިޔާސަތު ބަދަލުކުރޭ.",
      "noPermission": "ތިޔަ ފަރާތަށް އޯޑަރު ޔަގީންކުރެވުނަސް ޑިސްކައުންޓް ނުވަތަ ފައިދާގެ ޤަވާޢިދު ދޫކޮށްލެވޭކަށް ނެތެވެ.",
      "requestOverride": "ޑިސްކައުންޓް އޯވަރައިޑަކަށް އެދޭ",
      "submitOverride": "އޯވަރައިޑް ހުށަހަޅާ",
      "submitted": "ޑިސްކައުންޓް އޯވަރައިޑް ފާސްކުރުމަށް ހުށަހެޅިއްޖެ",
      "reasonLabel": "މި ޑިސްކައުންޓް ދެމިއޮންނަންވީ ސަބަބު",
      "reasonHint": "އޮޑިޓް ރެކޯޑްގައި، އެއާ ގުޅޭ ސަފުތަކާއެކު ރައްކާކުރެވޭނެއެވެ.",
      "reasonPlaceholder": "މިސާލު: މި ޓެންޑަރަށް ވާދަވެރިއެއްގެ އަގާ އެއްވަރުކުރެވުނު؛ ސަރަޙައްދީ މެނޭޖަރު ފާސްކުރި.",
      "kinds": {
        "discount_threshold": "ޙައްދު ފަހަނައަޅާ ޑިސްކައުންޓް",
        "margin_floor": "ފައިދާގެ ޙައްދުން ދަށުގައި",
        "insufficient_stock": "ސްޓޮކް ނުފުދޭ"
      }
    },
    "shipments": {
      "one": "ފޮނުވުން",
      "listTitle": "ފޮނުވުންތައް",
      "listDescription": "ޙަޤީޤަތުގައި ގުދަނުން ނުކުތް މުދާ، ލެޖަރުން ބޭނުންކުރި ޚަރަދުގައި. ރިވަރސްކުރެވުނު ފޮނުވުންތައް ފާހަގަކުރެވިގެން ދެމިހުރެއެވެ.",
      "draftTitle": "ދެލިކޮޕީ ފޮނުވުން",
      "emptyTitle": "އަދި އެއްޗެއް ފޮނުވިފައެއް ނެތް",
      "emptyDescription": "ފޮނުވުން އަބަދުވެސް ވަނީ ވިއްކުމުގެ އޯޑަރަކާ ދެކޮޅަށެވެ، އެހެންކަމުން މަގަކީ އޯޑަރެވެ.",
      "loadFailed": "ފޮނުވުންތައް ނުލޯޑްވި",
      "columns": {
        "shipmentNo": "ފޮނުވުމުގެ ނަންބަރު",
        "shipDate": "ފޮނުވި ތާރީޚް",
        "lines": "ސަފު"
      },
      "pickAgainst": "ނަގައި ފޮނުވާ",
      "pickTitle": "{orderNo} އާ ދެކޮޅަށް ނަގާ",
      "pickDescription": "މިތާ ނަގާ އެއްޗެހި ގުދަނުން ނުކުމެ، އޭގެ ޖާނަލް ޕޯސްޓްކުރެއެވެ. ބާކީ ދޭން ޖެހޭ އެއްޗެހި ބާކީ އޯޑަރަކަށް ވެއެވެ.",
      "headerTitle": "ފޮނުވުން",
      "linesTitle": "ސަފުތައް",
      "linesDescription": "މި ފޮނުވުމުގައި ހިމެނޭނީ ޚިޔާރުކުރި ގުދަނުގައި ހުރި ސަފުތައް އެކަންޏެވެ.",
      "linesCaption": "އޯޑަރުކުރި، ފޮނުވިފައި، ބާކީ، ނަގާ ޢަދަދު އަދި ކޮންމެ ސަފަކުން ބާކީވާނެ ޢަދަދު",
      "fields": {
        "warehouseHint": "ފޮނުވުމެއް ނިސްބަތްވަނީ އެއް ގުދަނަކަށެވެ. އެހެން ތަނެއްގައި ހުރި ސަފުތައް ދެއްކުނަސް މިތާ ނުނެގޭނެއެވެ.",
        "invoiceDate": "އިންވޮއިސް ތާރީޚް",
        "autoPost": "ވަގުތުން ޕޯސްޓްކުރޭ",
        "autoPostHint": "ޕޯސްޓްކުރުމުގެ ކުރިން ހިސާބުތަކުގެ ޓީމުން ބަލާ ދެލިކޮޕީއެއް ހެދުމަށް، މި ނިއްވާލާފައި ބާއްވާ."
      },
      "remaining": "ބާކީ ދޭން ޖެހޭ",
      "picking": "މިހާރު ނަގާ",
      "shipEverything": "ހުރިހާ ސަފެއް ފުރާ",
      "otherWarehouse": "އެހެން ގުދަނެއްގައި",
      "overPicked": "މި ސަފުގައި ބާކީ ދޭން ޖެހޭ {qty} އަށްވުރެ ގިނަ.",
      "lineCloses": "މި ސަފު ބަންދުވެއެވެ",
      "post": "ފޮނުވުން ޕޯސްޓްކުރޭ",
      "posted": "{shipmentNo} ފޮނުވުން ޕޯސްޓްކުރެވިއްޖެ",
      "postFailed": "ފޮނުވުން ޕޯސްޓެއް ނުކުރެވުނު",
      "postConsequence": "ޕޯސްޓްކުރުމުން ސްޓޮކާއި އޭގެ ޖާނަލް އެކުގައި ހަރަކާތްކުރެއެވެ. އޭގެފަހުން އެޑިޓެއް ނުކުރެވޭނެއެވެ — ހަމައެކަނި ރިވަރސްކުރެވޭނެއެވެ.",
      "factsTitle": "ފޮނުވުން",
      "costDescription": "ޔުނިޓް ޚަރަދަކީ ލެޖަރުން ބޭނުންކުރި މިންވަރެވެ — ފީފޯ ފަށަލަތައް ނުވަތަ ދެމިހިނގާ މެދުމިން — އެއީ އެއްވެސް މީހަކު ލިޔުނު އަގެއް ނޫނެވެ.",
      "costCaption": "ޢަދަދު، ލެޖަރުން ބޭނުންކުރި ޔުނިޓް ޚަރަދު އަދި ކޮންމެ ސަފަކުން ޕޯސްޓްކުރި ވިއްކި މުދަލުގެ ޚަރަދު",
      "extendedCost": "ޖުމްލަ ޚަރަދު",
      "cogsTotal": "ވިއްކި މުދަލުގެ ޚަރަދު",
      "costNote": "މިއީ ޚަރަދެވެ، ކަސްޓަމަރު ދައްކާ އަދަދެއް ނޫނެވެ: އިންވޮއިސްގެ އަދަދު ފައިދާގެ މިންވަރުން ތަފާތުވާނެއެވެ. މި ފޮނުވުމާ ދެކޮޅަށް އަނބުރާ ދިނުމެއްގައި، ސީދާ މި ޚަރަދުތަކުގައި ސްޓޮކަށް އަނބުރާ ލެވޭނެއެވެ.",
      "noLines": "މި ފޮނުވުމުގައި ސަފެއް ނެތެވެ.",
      "reverse": "ފޮނުވުން ރިވަރސްކުރޭ",
      "reverseTitle": "މި ފޮނުވުން ރިވަރސްކުރޭ",
      "reverseDescription": "ސްޓޮކް އަނބުރާ ދާނެއެވެ އަދި ޖާނަލް އިދިކޮޅަށް ޕޯސްޓްކުރެވޭނެއެވެ. ހިނގައިދިޔަ ކަމުގެ ބައެއްކަމުން، ފޮނުވުން ފާހަގަކުރެވިގެން ލިސްޓުގައި ދެމިހުންނާނެއެވެ.",
      "reversed": "ފޮނުވުން ރިވަރސްކުރެވިއްޖެ",
      "reverseFailed": "ފޮނުވުން ރިވަރސްނުކުރެވުނު",
      "reversedNote": "މި ފޮނުވުން ރިވަރސްކުރެވިއްޖެ: {reason}",
      "invoice": "އިންވޮއިސް ހަދާ",
      "invoiceTitle": "ފޮނުވުނު މުދަލަށް އިންވޮއިސް",
      "invoiceDescription": "ކަސްޓަމަރު އިންވޮއިސް ހެދެނީ ޙަޤީޤަތުގައި ނުކުތް މުދަލަށެވެ، އޯޑަރުކުރި މުދަލަކަށް ނޫނެވެ.",
      "raiseInvoice": "އިންވޮއިސް ހަދާ",
      "invoiced": "{invoiceNo} އިންވޮއިސް ހެދިއްޖެ",
      "invoiceFailed": "އިންވޮއިސް ނުހެދުނު",
      "viewInvoice": "{invoiceNo} އިންވޮއިސް ބަލާ",
      "deferredNote": "އާމްދަނީ ބަހާ މުއްދަތެއް އޮތް ސަފެއް، އޭގެ އަމިއްލަ އެކައުންޓުގެ ބަދަލުގައި ފަސްކުރެވިފައިވާ އާމްދަނީ އެކައުންޓަށް އިންވޮއިސްކުރެއެވެ — އާމްދަނީ ފަސްވަނީ އެހެންވެއެވެ.",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "posted": "ޕޯސްޓްކޮށްފައި",
        "reversed": "ރިވަރސްކޮށްފައި",
        "cancelled": "ކެންސަލްކޮށްފައި"
      }
    },
    "backorders": {
      "title": "ބާކީ އޯޑަރުތައް",
      "description": "މި އޯޑަރުން އަދިވެސް ދޭން ޖެހޭ އެއްޗެހި، އޭގެ އަމިއްލަ ސަފުތަކުންނާއި ސާވަރުން ލިޔުނު ބާކީ ސަފުތަކުން.",
      "listDescription": "ވެފައިވާ ވަޢުދުތަކުގެ ތެރެއިން އަދި ނުފޮނުވާ ހުރި އެއްޗެހި. ފުރިހަމަކުރެވުނު އަދި ކެންސަލްކުރެވުނު ސަފުތަކަކީ ތާރީޚެވެ، ބާކީއެއް ނޫނެވެ.",
      "emptyTitle": "ބާކީ އެއްޗެއް ނެތް",
      "emptyDescription": "ޔަގީންކުރެވުނު ކޮންމެ އޯޑަރެއް ފުރިހަމައަށް ފޮނުވިއްޖެއެވެ، ނުވަތަ އަދި އެއްވެސް އެއްޗެއް އޯޑަރުކޮށްފައެއް ނުވެއެވެ.",
      "loadFailed": "ބާކީ އޯޑަރުތައް ނުލޯޑްވި",
      "caption": "ކޮންމެ ސަފެއްގެ ބާކީ ޢަދަދު، ނެރެވުނު ގޮތާއި ރެކޯޑްކުރެވިފައިވާ ގޮތް",
      "owing": "ބާކީ ދޭން ޖެހޭ",
      "since": "ބާކީ ވީ ތާރީޚް",
      "derived": "އޯޑަރުން",
      "recorded": "ބާކީ ސަފުތަކުން",
      "agrees": "ދިމާވޭ",
      "disagrees": "ދިމައެއް ނުވޭ",
      "reconcileNote": "މި ދެ އަދަދު ދިމާވާން ޖެހެއެވެ. ދިމާނުވާ ހިނދު، ދެ އަދަދުވެސް އައި ގޮތަށް ދެއްކޭނެއެވެ، އަދި އެއްވެސް އަދަދެއް ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "openTotal": "މި ޞަފުޙާގައި ހުޅުވިފައި",
      "willLeave": "ބާކީވާނެ",
      "previewTitle": "މި ފޮނުވުމުން {count} ސަފު ބާކީ ވާނެއެވެ.",
      "previewLine": "ސަފު {line}، {item}: {qty} ބާކީ ދޭން ޖެހެއެވެ.",
      "statuses": {
        "open": "ހުޅުވިފައި",
        "fulfilled": "ފުރިހަމަކޮށްފައި",
        "cancelled": "ކެންސަލްކޮށްފައި"
      }
    },
    "returns": {
      "listTitle": "އަނބުރާ ދިނުންތައް",
      "listDescription": "އަނބުރާ އަންނަ މުދަލާއި، ކޮންމެ އެއްޗަކުން ހެދި ކްރެޑިޓް ނޯޓް.",
      "emptyTitle": "އަނބުރާ ދީފައެއް ނެތް",
      "emptyDescription": "އަނބުރާ ދިނުމެއް އެންމެ ރަނގަޅީ އެ މުދާ ދިޔަ ފޮނުވުމުން ފެށުމެވެ — މުދާ ދިޔަ ޚަރަދު ރެކޯޑްކުރެވިފައި ހުންނަނީ އެތާނގައެވެ.",
      "loadFailed": "އަނބުރާ ދިނުންތައް ނުލޯޑްވި",
      "draftTitle": "ދެލިކޮޕީ އަނބުރާ ދިނުން",
      "newTitle": "އައު އަނބުރާ ދިނުން",
      "newDescription": "ސްޓޮކަށް އަނބުރާ ލެވޭ މުދާ ދާނީ އެ މުދާ ފޮނުވުނު ޚަރަދުގައެވެ، އަދި ސްޓޮކަށް ލެވޭ ސަފުތައް ފިޔަވައި އެހެން ސަފަކުން އިންވެންޓަރީއަށް އަސަރެއް ނުކުރެއެވެ.",
      "headerTitle": "އަނބުރާ ދިނުން",
      "factsTitle": "އަނބުރާ ދިނުން",
      "linesTitle": "ސަފުތައް",
      "linesCaption": "އަނބުރާ ދިން ޢަދަދު، ފޮނުވުނު ޚަރަދު، ކްރެޑިޓްކުރެވޭ އަދަދު އަދި ސްޓޮކަށް އަނބުރާ ލެވޭތޯ",
      "newLinesDescription": "އަނބުރާ އަންނަ އެއްޗެހި ލިޔޭ. ޚަރަދަކީ ފޮނުވުމުގެ އަމިއްލަ ޚަރަދެވެ، އަދި އެ ކިޔުނު ތަނެއްގައި އެއަށް ބަދަލެއް ނުގެނެވޭނެއެވެ.",
      "postedDescription": "ސްޓޮކަށް އަނބުރާ ދިޔަ މުދާ، އެ ދިޔަ ޚަރަދުގައި، އަދި ކަސްޓަމަރަށް ކްރެޑިޓްކުރެވުނު އަދަދު.",
      "columns": {
        "returnNo": "އަނބުރާ ދިނުމުގެ ނަންބަރު",
        "returnDate": "އަނބުރާ ދިން ތާރީޚް"
      },
      "returning": "އަނބުރާ ދޭ",
      "shippedCost": "ފޮނުވުނު ޚަރަދު",
      "restockValue": "ސްޓޮކަށް އަނބުރާ",
      "credited": "ކްރެޑިޓްކުރެވުނު",
      "restock": "ސްޓޮކަށް އަނބުރާ ލާ",
      "restocked": "ސްޓޮކަށް ލެވިފައި",
      "yes": "އާނއެކެވެ",
      "writtenOff": "ފޮތުން ކަނޑާލާފައި",
      "willRestock": "ފޮނުވުނު ޚަރަދުގައި ސްޓޮކަށް އަނބުރާ ދާނެ",
      "willWriteOff": "ސްޓޮކަށް ނުލެވޭނެ؛ ކަސްޓަމަރަށް ކްރެޑިޓްކުރެވި، ވިއްކި މުދަލުގެ ޚަރަދު ބަދަލެއް ނުކުރެވޭނެ",
      "costLocked": "ފޮނުވުމުން",
      "costTyped": "އަތުން ލިޔެފައި. ސީދާ މި އަދަދުގައި އިންވެންޓަރީއަށް ޑެބިޓްކުރެވޭނެއެވެ.",
      "restockTotal": "ސްޓޮކަށް އަނބުރާ ދާ އަގު",
      "creditTotal": "ކަސްޓަމަރަށް ދޭ ކްރެޑިޓް",
      "creditNote": "ކްރެޑިޓް ނޯޓް",
      "noCreditNote": "ހަދާފައެއް ނެތް",
      "addLine": "ސަފެއް އިތުރުކުރޭ",
      "noLines": "އަދި އެއްވެސް އެއްޗެއް އަނބުރާ ދީފައެއް ނުވެއެވެ.",
      "noShipmentSource": "ފޮނުވުމަކާ ނުލައި ފެށުނުކަމުން، އެއްވެސް ޚަރަދެއް ގެނެވިފައެއް ނުވެއެވެ. މިތާ ލިޔާ ކޮންމެ ޚަރަދަކީ އިންވެންޓަރީއަށް ޑެބިޓްކުރެވޭނެ އަދަދެވެ.",
      "writeOffNote": "{count} ސަފެއް ސްޓޮކަށް އަނބުރާ ނުލެވެއެވެ. އެ މުދާ ފޮތުން ކަނޑާލެވެއެވެ: ކަސްޓަމަރަށް ކްރެޑިޓްކުރެވި، ވިއްކި މުދަލުގެ ޚަރަދު ރަނގަޅަށް ބަދަލުނުކޮށް ބާއްވައެވެ.",
      "overReturned": "ސަފެއްގައި، އެ ފޮނުވުމުން ފޮނުވި މިންވަރަށްވުރެ ގިނައިން އަނބުރާ ދެއެވެ. މަދުކުރޭ، ނުވަތަ ރަނގަޅު ފޮނުވުމާ ދެކޮޅަށް އަނބުރާ ދިނުން ހަދާ.",
      "post": "އަނބުރާ ދިނުން ޕޯސްޓްކުރޭ",
      "posted": "{returnNo} އަނބުރާ ދިނުން ޕޯސްޓްކުރެވިއްޖެ",
      "postFailed": "އަނބުރާ ދިނުން ޕޯސްޓެއް ނުކުރެވުނު",
      "postConsequence": "އަނބުރާ ދިނުމެއް އުފެއްދުމުން ޕޯސްޓްވެއެވެ: ސްޓޮކާއި، ކްރެޑިޓް ނޯޓާއި، ޖާނަލް އެކުގައި ކޮމިޓްވެއެވެ. ދެލިކޮޕީއެއް ނޯވެއެވެ.",
      "costNote": "ސްޓޮކަށް ލެވުނު ސަފުތައް ބަލައިގަނެވުނީ އެ މުދާ އަސްލު ފޮނުވުނު ޚަރަދުގައެވެ، އަލުން ހިސާބުނުކޮށެވެ — އެހެންކަމުން މި ރިވަރސްކުރުމަކީ ފޮނުވުމުން ޕޯސްޓްކުރި އެއްޗެހީގެ ސީދާ އިދިކޮޅު ސޫރައެވެ.",
      "startFromShipment": "މި ފޮނުވުމާ ދެކޮޅަށް އަނބުރާ ދިނުން",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "posted": "ޕޯސްޓްކޮށްފައި",
        "cancelled": "ކެންސަލްކޮށްފައި"
      }
    },
    "subscriptions": {
      "listTitle": "ސަބްސްކްރިޕްޝަންތައް",
      "listDescription": "އައުކުރުމުގެ ވަޒީފާއިން ބިލްކުރާނެ އެއްޗެއްސާއި، ކޮންއިރަކުކަން. ތަކުރާރު އާމްދަނީ ނެގެނީ މިއިންނެވެ.",
      "new": "ސަބްސްކްރިޕްޝަނެއް ފަށާ",
      "newTitle": "ސަބްސްކްރިޕްޝަނެއް ފަށާ",
      "newDescription": "ޕްލޭނުން ސައިކަލާއި އަސާސީ އަގު ކަނޑައަޅައެވެ. މިތާ ލިޔާ އަގަކީ މި ކަސްޓަމަރަށް ވާހަކަދެކެވިފައިވާ އަގެކެވެ.",
      "start": "ފަށާ",
      "started": "ސަބްސްކްރިޕްޝަން ފެށިއްޖެ",
      "startFailed": "ސަބްސްކްރިޕްޝަން ނުފެށުނު",
      "emptyTitle": "ސަބްސްކްރިޕްޝަނެއް ނެތް",
      "emptyDescription": "ފުރަތަމަ ޕްލޭނެއް ހަދާ، ދެން ކަސްޓަމަރަކަށް އޭގެ މައްޗަށް ސަބްސްކްރިޕްޝަނެއް ފަށާ.",
      "loadFailed": "ސަބްސްކްރިޕްޝަންތައް ނުލޯޑްވި",
      "columns": {
        "subscriptionNo": "ސަބްސްކްރިޕްޝަން",
        "plan": "ޕްލޭން",
        "pricePerCycle": "ސައިކަލަކަށް އަގު",
        "monthly": "މަހަކަށް",
        "nextBilling": "ދެން ބިލްކުރާ",
        "startDate": "ފެށޭ",
        "endDate": "ނިމޭ"
      },
      "fields": {
        "priceHint": "އަސާސީގޮތުން ޕްލޭންގެ އަގެވެ. ބަދަލުކުރާނީ ޙަޤީޤަތުގައި ވާހަކަދެކެވިފައިވާ އަގަކަށް އެކަންޏެވެ.",
        "endDateHint": "ކޮންމެވެސް މީހަކު ކެންސަލްކުރަންދެން އައުކުރުމަށް ހުސްކޮށް ބާއްވާ."
      },
      "notScheduled": "ތާވަލުކޮށްފައެއް ނެތް",
      "pageMonthly": "މި ޞަފުޙާގައި ހަރަކާތްތެރި، މަހަކަށް",
      "subtotalNote": "ޞަފުޙާގެ ޖުމްލައިގައި ގުނަނީ މި ޞަފުޙާގައި ހަރަކާތްތެރި ސަފުތައް އެކަންޏެވެ. މިއީ އެމްއާރުއާރު ނޫނެވެ — ފިލްޓަރކުރެވި ޞަފުޙާތަކަށް ބަހާލެވިފައިވާ ލިސްޓަކުން ކުންފުނީގެ ތަކުރާރު އާމްދަނީ ނުނިކުމެއެވެ.",
      "billingTitle": "ބިލްކުރުން",
      "billingDescription": "ސައިކަލާއި، މިހާރު އޮތް މުއްދަތާއި، ދެން އަންނަ އައުކުރުމުގެ އިންވޮއިސް ހަދާނެ އަދަދު.",
      "currentPeriod": "މިހާރުގެ މުއްދަތު",
      "nextAmount": "ދެން އަންނަ އައުކުރުމުގެ އިންވޮއިސް",
      "pausedNote": "މަޑުޖައްސާލެވިފައިވާ ސަބްސްކްރިޕްޝަންތައް އައުކުރުމުގެ ބުރުން ދޫކޮށްލެވެއެވެ، އެހެންކަމުން ދެން ބިލްކުރާ ތާރީޚެއް ނޯވެއެވެ. މަޑުޖައްސާލުމުން ބިލްކުރުން ހުއްޓެއެވެ؛ ފޮރުވެނީއެއް ނޫނެވެ.",
      "change": "ޢަދަދު ނުވަތަ އަގު ބަދަލުކުރޭ",
      "changeTitle": "މި ސަބްސްކްރިޕްޝަން ބަދަލުކުރޭ",
      "changeDescription": "ބަދަލު، މިހާރުގެ މުއްދަތުގެ ބާކީ ބަޔަށް ބަހާލެވި، ދެން އަންނަ އައުކުރުމުގައި އަޅާނެއެވެ.",
      "applyChange": "ބަދަލު އަޅާ",
      "changed": "ސަބްސްކްރިޕްޝަން ބަދަލުކުރެވިއްޖެ",
      "changeFailed": "ސަބްސްކްރިޕްޝަން ބަދަލުނުކުރެވުނު",
      "prorationExplained": "މި މުއްދަތުގެ {period} ދުވަހުގެ ތެރެއިން {remaining} ދުވަސް ބާކީ އޮތުމުން، ބަދަލުގެ އަގަކީ ގާތްގަނޑަކަށް",
      "prorationEstimateNote": "މިއީ އޭޕީއައި އިން ދިން މުއްދަތުން ނެގުނު ލަފައެކެވެ. އިންވޮއިސްގެ އަދަދަކީ ސާވަރުގެ އަދަދެވެ.",
      "pause": "މަޑުޖައްސާ",
      "pauseTitle": "މި ސަބްސްކްރިޕްޝަން މަޑުޖައްސާ",
      "pauseDescription": "މަޑުޖައްސާލެވިފައި ހުންނަހާ ހިނދަކު އެއްވެސް އެއްޗެއް ބިލްކުރެވިގެން ނުވެއެވެ.",
      "pauseConsequence": "މަޑުޖައްސާލެވިފައިވާ ސަބްސްކްރިޕްޝަނެއް އައުކުރުމުގެ ވަޒީފާއިން ދޫކޮށްލައެވެ، އެހެންކަމުން އަލުން ފެށެންދެން ދެން ބިލްކުރާ ތާރީޚް ފޮހެވޭނެއެވެ.",
      "paused": "ސަބްސްކްރިޕްޝަން މަޑުޖައްސާލެވިއްޖެ",
      "pauseFailed": "ސަބްސްކްރިޕްޝަން މަޑުނުޖެއްސުނު",
      "resume": "އަލުން ފަށާ",
      "resumed": "ސަބްސްކްރިޕްޝަން އަލުން ފެށިއްޖެ",
      "resumeFailed": "ސަބްސްކްރިޕްޝަން އަލުން ނުފެށުނު",
      "cancel": "ސަބްސްކްރިޕްޝަން ކެންސަލްކުރޭ",
      "cancelTitle": "މި ސަބްސްކްރިޕްޝަން ކެންސަލްކުރޭ",
      "cancelDescription": "ކެންސަލްކުރުމުން ކުރިއަށް އޮތް ހުރިހާ އައުކުރުމެއް ހުއްޓެއެވެ. ސަބަބު އޮޑިޓް ރެކޯޑްގައި ބާއްވާނެއެވެ.",
      "cancelled": "ސަބްސްކްރިޕްޝަން ކެންސަލްކުރެވިއްޖެ",
      "cancelFailed": "ސަބްސްކްރިޕްޝަން ކެންސަލްނުކުރެވުނު",
      "statuses": {
        "active": "ހަރަކާތްތެރި",
        "paused": "މަޑުޖައްސާލާފައި",
        "cancelled": "ކެންސަލްކޮށްފައި",
        "expired": "މުއްދަތު ހަމަވެފައި"
      }
    },
    "plans": {
      "title": "ސަބްސްކްރިޕްޝަން ޕްލޭންތައް",
      "description": "ޕްލޭނެއްގެ އަގަކީ ސައިކަލަކަށެވެ، މަހަކަށް ނޫނެވެ. ބަހާ ޢަދަދާއެކު، ދެ އަދަދުވެސް ދެއްކެއެވެ.",
      "new": "އައު ޕްލޭން",
      "newTitle": "އައު ސަބްސްކްރިޕްޝަން ޕްލޭން",
      "newDescription": "ސައިކަލާއި އަގު އެކުގައި، މި ޕްލޭނުން ތަކުރާރު އާމްދަނީއަށް އިތުރުވާ މިންވަރު ކަނޑައަޅައެވެ.",
      "created": "{code} ޕްލޭން އުފެދިއްޖެ",
      "saveFailed": "ޕްލޭން ރައްކާނުކުރެވުނު",
      "loadFailed": "ޕްލޭންތައް ނުލޯޑްވި",
      "emptyTitle": "އަދި ޕްލޭނެއް ނެތް",
      "emptyDescription": "ސަބްސްކްރިޕްޝަނަކަށް ޕްލޭނެއް ބޭނުންވެއެވެ: ސައިކަލާއި، އަގާއި، އާމްދަނީ އެކައުންޓް ހުންނާނީ ޕްލޭނުގައެވެ.",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "columns": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "cycle": "ބިލްކުރާ ސައިކަލް",
        "price": "ސައިކަލަކަށް އަގު",
        "monthlyEquivalent": "މަހަކަށް"
      },
      "cycles": {
        "monthly": "މަހުން މަހަށް",
        "quarterly": "ތިން މަހުން",
        "semi_annual": "ހަ މަހުން",
        "annual": "އަހަރަކު އެއްފަހަރު"
      },
      "overMonths": "{months} މަހަށް",
      "unknownCycle": "ސައިކަލް ނޭނގޭ",
      "monthlyPreview": "{months} މަހަށް ބަހާލުމުން އެއީ",
      "immutableNote": "ޕްލޭންތައް އެޑިޓެއް ނުކުރެވޭނެއެވެ. ހިނގަމުންދާ ސަބްސްކްރިޕްޝަނެއްގައި، ފެށުނު އިރު ކޮޕީކުރެވުނު އަމިއްލަ އަގެއް ހުރެއެވެ، އެހެންކަމުން ޕްލޭން ބަދަލުކުރުމަކުން އޭގެ އަގު ބަދަލެއް ނުވާނެއެވެ — އޭގެ ބަދަލުގައި އައު ޕްލޭނެއް ހަދައި، ކޮންމެ ސަބްސްކްރިޕްޝަނެއް ބަދަލުކުރޭ.",
      "fields": {
        "priceHint": "އެއް ސައިކަލް ފުރިހަމައަށް، އެއް މަހަކަށް ނޫނެވެ.",
        "revenueAccountHint": "އައުކުރުމުގެ އިންވޮއިސް ޕޯސްޓްވުމުން ކްރެޑިޓްކުރެވެއެވެ.",
        "itemHint": "އިޚްތިޔާރީ. ރިޕޯޓްކުރުމަށްޓަކައި ޕްލޭން ކެޓަލޮގްގެ ތަކެއްޗަކާ ގުޅުވައެވެ."
      }
    },
    "revrec": {
      "listTitle": "ފަސްކުރެވިފައިވާ އާމްދަނީގެ ތާވަލުތައް",
      "listDescription": "މުއްދަތަކަށް ބިލްކުރެވުނު ކޮންމެ ލިޔުމަކުން، ދެނެގަނެވިފައިވާ އަދި ފަސްކުރެވިފައިވާ އާމްދަނީ.",
      "emptyTitle": "ތާވަލެއް ނެތް",
      "emptyDescription": "އާމްދަނީ ބަހާ މުއްދަތެއް އޮތް ސަފެއް އިންވޮއިސްކުރެވުމުން ތާވަލެއް އުފެދެއެވެ.",
      "loadFailed": "ތާވަލުތައް ނުލޯޑްވި",
      "docTitle": "{docType} #{docId} ގެ ތާވަލު",
      "docDescription": "ކޮންމެ މުއްދަތެއްގެ އާމްދަނީ ދެނެގަތުމުގެ ޖާނަލް ޕޯސްޓްކުރަނީ ވަޒީފާއިން، އޭގެ އަމިއްލަ ތާވަލުގައެވެ.",
      "positionTitle": "ދެނެގަނެވި އަދި ފަސްކުރެވިފައި",
      "recognised": "ދެނެގަނެވިފައި",
      "stillDeferred": "އަދިވެސް ފަސްކުރެވިފައި",
      "scheduleTotal": "ތާވަލުގެ ޖުމްލަ",
      "lineSum": "މުއްދަތުތަކުގެ ޖުމްލަ",
      "meterLabel": "މި ތާވަލުގެ {percent}% ދެނެގަނެވިއްޖެ",
      "driftNote": "މުއްދަތުތަކުގެ ޖުމްލަ، ތާވަލުގެ އަމިއްލަ ޖުމްލައާ ދިމައެއް ނުވެއެވެ. ދެ އަދަދުވެސް އައި ގޮތަށް ދެއްކިފައިވެއެވެ؛ ތަފާތަކީ",
      "nextPeriod": "ވަޒީފާއިން ދެން ޕޯސްޓްކުރާނެ މުއްދަތަކީ {from} އިން {to} އަށް، އަދަދަކީ",
      "periodsTitle": "މުއްދަތުތައް",
      "periodsDescription": "ކޮންމެ މުއްދަތަކަށް އެއް ސަފު، ވަޒީފާއިން ދެނެގަންނަ ވަރަކުން ފާހަގަކުރެވެއެވެ.",
      "periodsCaption": "ކޮންމެ މުއްދަތެއް، އޭގެ އަދަދު، ދެނެގަނެވުނުތޯ އަދި ކޮންއިރަކުކަން",
      "noLines": "މި ތާވަލުގައި މުއްދަތެއް ނެތެވެ.",
      "jobNote": "އާމްދަނީ ދެނެގަތުން ޕޯސްޓްކުރަނީ ރޭގަނޑުގެ ވަޒީފާއިން، ސިސްޓަމްގެ ނަމުގައެވެ. މިތާ ބަޓަނެއް ނެތީ، އަތުން ހިންގާ ބަޓަނަކަށް، މި މޮޑިއުލްގެ ބާރު ނުހިނގާ މޮޑިއުލެއްގެ ހުއްދައެއް ބޭނުންވާނެތީއެވެ.",
      "done": "ދެނެގަނެވިފައި",
      "pending": "އަދި ނުވޭ",
      "doneOf": "{total} މުއްދަތުގެ ތެރެއިން {done}",
      "columns": {
        "source": "މަޞްދަރު ލިޔުން",
        "term": "މުއްދަތު",
        "total": "ޖުމްލަ",
        "periods": "ދެނެގަނެވިފައި",
        "period": "މުއްދަތު",
        "recognised": "ސްޓޭޓަސް",
        "recognisedAt": "ދެނެގަތް ތާރީޚް"
      },
      "statuses": {
        "active": "ހިނގަނީ",
        "completed": "ފުރިހަމަ",
        "cancelled": "ކެންސަލްކޮށްފައި"
      }
    },
    "pipeline": {
      "title": "ޕައިޕްލައިން އަދި ކާމިޔާބުވި ނިސްބަތް",
      "description": "އެއް އަގު ހުށަހެޅުންތަކެއް ދެގޮތަކަށް: މިހާރުގެ ސްޓޭޓަސްއިން، އަދި ވަކި މުއްދަތެއްގައި ނިންމުނު އެއްޗެއްސަށް ވީގޮތުން.",
      "loadFailed": "ޕައިޕްލައިން ނުލޯޑްވި",
      "stagesTitle": "ސްޓޭޓަސްއިން",
      "stagesDescription": "ކޮންމެ ދަރަޖައަކުން، އޭގެ ފަހަތުގައިވާ އަގު ހުށަހެޅުންތަކަށް ދެވެއެވެ.",
      "caption": "ސްޓޭޓަސްއިން: އަގު ހުށަހެޅުމުގެ ޢަދަދު، އަގު އަދި ޖުމްލައިގެ ބައި",
      "count": "އަގު ހުށަހެޅުން",
      "share": "ބައި",
      "empty": "މި ކުންފުންޏަށް އަގު ހުށަހެޅުމެއް ހަދާފައެއް ނުވެއެވެ.",
      "openValue": "ހުޅުވިފައިވާ ޕައިޕްލައިން",
      "openValueHelp": "ހަމައެކަނި ދެލިކޮޕީ އަދި ފޮނުވިފައިވާ އަގު ހުށަހެޅުންތައް. ޤަބޫލުކުރެވުނު ނުވަތަ ގެއްލުނު އަގު ހުށަހެޅުމަކީ ނަތީޖާއެކެވެ، ފުރުޞަތެއް ނޫނެވެ.",
      "allQuotesValue": "ހުރިހާ އަގު ހުށަހެޅުމެއް",
      "allQuotesHelp": "ރެކޯޑްގައިވާ ކޮންމެ އަގު ހުށަހެޅުމެއް، އޭގެ ނަތީޖާ ކޮންމެ އެއްޗެއް ވިޔަސް.",
      "windowHint": "މުއްދަތު އަޅަނީ ކާމިޔާބުވި ނިސްބަތަށެވެ، ޕައިޕްލައިނަކަށް ނޫނެވެ: އެކަތިން މިހާރުގެ ޙާލަތު، އަނެކަތިން ފާއިތުވި ނިސްބަތެއް ދައްކައެވެ."
    },
    "winRate": {
      "title": "ކާމިޔާބުވި ނިސްބަތް",
      "description": "މުއްދަތުގެ ތެރޭގައި ނިންމުނު އަގު ހުށަހެޅުންތަކަށް ވީގޮތް.",
      "loadFailed": "ކާމިޔާބުވި ނިސްބަތް ނުލޯޑްވި",
      "accepted": "ޤަބޫލުކުރި",
      "rejected": "ބޭރުކުރި",
      "expired": "މުއްދަތު ހަމަވި",
      "decided": "ނިންމުނު",
      "rate": "ކާމިޔާބުވި ނިސްބަތް",
      "formulaLabel": "ސާވަރުގެ އަމިއްލަ ފޯމިއުލާ:",
      "expiredCounts": "މުއްދަތު ހަމަވި އަގު ހުށަހެޅުމެއް ގުނަނީ ގެއްލުމެއްގެ ގޮތުގައެވެ، ނެތް އެއްޗެއްގެ ގޮތުގައެއް ނޫނެވެ: ކަސްޓަމަރު އާނއެކޭ ނުބުނީއެވެ."
    },
    "forecast": {
      "title": "ވިއްކުމުގެ ލަފާ",
      "description": "ކަށަވަރުވެފައިވަނީ މިހާރު ޤަބޫލުކުރެވިފައިވާ އެއްޗެއްސެވެ. ބުރަދަން ދެވިފައިވަނީ ލަފައެކެވެ، އަދި އޭގައި އެއްވެސް މީހަކު އާނއެކޭ ނުބުނާ އަގު ހުށަހެޅުންތައް ހިމެނެއެވެ.",
      "loadFailed": "ލަފާ ނުލޯޑްވި",
      "committed": "ކަށަވަރުވެފައި",
      "committedHelp": "ހަމައެކަނި ޤަބޫލުކުރެވުނު އަގު ހުށަހެޅުންތައް. ގާތްގަނޑަކަށް ޔަގީން ފައިސާ.",
      "weighted": "ބުރަދަން ދެވިފައި",
      "weightedHelp": "ކޮންމެ ބައެއްގެ އަގު، އޭގެ އިޙްތިމާލުން ގުނަކުރެވިފައި. މިއީ ލަފައެކެވެ، ވަޢުދެއް ނޫނެވެ.",
      "bucketsTitle": "ސްޓޭޓަސްއިން",
      "bucketsDescription": "ކޮންމެ ބުރަދަނެއްގެ ފަހަތުގައިވާ އިޙްތިމާލު އޭގެ އަމިއްލަ ސަފުގައި އޮވެއެވެ، އެއީ ކިޔާ މީހަކަށް ޖުމްލައާ ދެބަސްވުމުގެ ބަދަލުގައި ވަކި ލަފައަކާ ދެބަސްވެވޭނެ ގޮތަށެވެ.",
      "caption": "ކޮންމެ ސްޓޭޓަސްއަކަށް: އަގު، އިޙްތިމާލު އަދި ބުރަދަން ދެވިފައިވާ އަގު",
      "value": "އަގު",
      "probability": "އިޙްތިމާލު",
      "weightedValue": "ބުރަދަން ދެވިފައި",
      "empty": "މި މުއްދަތުގެ ތެރެއަށް އެއްވެސް އަގު ހުށަހެޅުމެއް ނުވަދެއެވެ.",
      "driftNote": "ބައިތަކުގެ ޖުމްލަ، ރިޕޯޓްކުރެވުނު ބުރަދަން ދެވިފައިވާ ޖުމްލައާ ދިމައެއް ނުވެއެވެ. ދެ އަދަދުވެސް އައި ގޮތަށް ދެއްކިފައިވެއެވެ؛ ތަފާތަކީ",
      "assumptionNote": "ބުރަދަން ދެވިފައިވާ ޖުމްލައިގައި، އެއްވެސް މީހަކު ޤަބޫލުނުކުރާ އަގު ހުށަހެޅުންތައް ހިމެނެއެވެ. ރޭވުމުގައި ބަލާނީ ކަށަވަރުވެފައިވާ އަދަދަށެވެ؛ ވިއްކުމުގައި ބުރަދަން ދެވިފައިވާ އަދަދަށެވެ."
    },
    "salesBy": {
      "title": "ވިއްކުން ބަހާލައިގެން",
      "description": "ޕޯސްޓްކުރެވިފައިވާ ފޮނުވުންތަކުން ބިނާކުރެވިފައި: އަދި ނުފޮނުވާ އޯޑަރެއް މިތާ ނުހުންނާނެއެވެ، އަދި އިންވޮއިސް ނުކުރާ ފޮނުވުމެއް ހުންނާނެއެވެ.",
      "postedOnly": "މި ރިޕޯޓް ކިޔެނީ ކޮންސެންޓްރޭޝަން ބެލުމަށްކަމުން، އަދަދުގެ ބޮޑުމިނުން ތަރުތީބުކުރެވިފައި.",
      "loadFailed": "ރިޕޯޓް ނުލޯޑްވި",
      "groupBy": "ބަހާލާ ގޮތް",
      "groups": {
        "customer": "ކަސްޓަމަރު",
        "item": "ތަކެތި",
        "warehouse": "ގުދަން"
      },
      "caption": "ކޮންމެ ބައެއްގެ ޢަދަދު، އަދަދު އަދި ޖުމްލައިގެ ބައި",
      "empty": "މި ތާރީޚުތަކުގެ ދެމެދުގައި އެއްވެސް އެއްޗެއް ފޮނުވިފައެއް ނުވެއެވެ.",
      "driftNote": "ސަފުތަކުގެ ޖުމްލަ، ރިޕޯޓްކުރެވުނު ޖުމްލައާ ދިމައެއް ނުވެއެވެ. ދެ އަދަދުވެސް އައި ގޮތަށް ދެއްކިފައިވެއެވެ؛ ތަފާތަކީ"
    },
    "mrr": {
      "title": "މަހުގެ އަދި އަހަރުގެ ތަކުރާރު އާމްދަނީ",
      "description": "ސާވަރުގެ އަދަދުތައް، އޭގެ ފަހަތުގައިވާ ސަބްސްކްރިޕްޝަންތަކާ ސަފުން ސަފަށް އަޅާކިޔައިގެން.",
      "loadFailed": "ރިޕޯޓް ނުލޯޑްވި",
      "mrr": "މަހުގެ ތަކުރާރު އާމްދަނީ",
      "arr": "އަހަރުގެ ތަކުރާރު އާމްދަނީ",
      "mrrHelp": "ހަރަކާތްތެރި ކޮންމެ ސަބްސްކްރިޕްޝަނެއްގެ އަގު، އޭގެ ސައިކަލްގެ މަސްތަކުގެ ޢަދަދުން ބަހާލެވިފައި.",
      "arrHelp": "މަހުގެ ތަކުރާރު އާމްދަނީ ބާރަ ގުނަ، އެއަށްވުރެ ފުން އެއްޗެއް ނޫނެވެ.",
      "activeCount": "ހަރަކާތްތެރި ސަބްސްކްރިޕްޝަން",
      "activeHelp": "މަޑުޖައްސާލެވިފައިވާ އަދި ކެންސަލްކުރެވިފައިވާ ސަބްސްކްރިޕްޝަންތަކުން އެއްވެސް އެއްޗެއް އިތުރެއް ނުވެއެވެ: އައުކުރުމުގެ ވަޒީފާއިން އެ އެއްޗެހި ބިލެއް ނުކުރާނެއެވެ.",
      "asOf": "ބަލާ ތާރީޚް",
      "asOfHint": "މިއަދަށް ބަލަން ހުސްކޮށް ބާއްވާ.",
      "viewReport": "ތަކުރާރު އާމްދަނީގެ ރިޕޯޓް ހުޅުވާ",
      "viewSubscriptions": "ސަބްސްކްރިޕްޝަންތައް ބަލާ",
      "reconciliationTitle": "މި އަދަދު އަންނަނީ ކޮންތާކުންކަން",
      "reconciliationDescription": "ހަރަކާތްތެރި ކޮންމެ ސަބްސްކްރިޕްޝަނަކުން އިތުރުވާ މިންވަރު، ޖަމާކޮށް ސާވަރުގެ އަދަދާ އަޅާކިޔައިފައި.",
      "caption": "ކޮންމެ ސަބްސްކްރިޕްޝަނެއްގެ ޕްލޭން، ސައިކަލް، ޢަދަދު، އަގު އަދި މަހަކަށް އިތުރުވާ މިންވަރު",
      "contribution": "މަހަކަށް",
      "derivedMrr": "ސަފުތަކުން ޖަމާކުރެވިފައި",
      "derivedArr": "ސަފުތަކުން އަހަރަކަށް ބަދަލުކުރެވިފައި",
      "noSubscriptions": "އަޅާކިޔާނެ ހަރަކާތްތެރި ސަބްސްކްރިޕްޝަނެއް ނެތެވެ.",
      "reconcilesNote": "ސަފުތަކުގެ ޖުމްލަ، ރިޕޯޓްކުރެވުނު އަދަދާ ސީދާ ދިމާވެއެވެ.",
      "driftNote": "ސަފުތަކުގެ ޖުމްލަ، ރިޕޯޓްކުރެވުނު އަދަދާ ދިމައެއް ނުވެއެވެ. އެއްވެސް އަދަދެއް އަނެއް އަދަދާ ދިމާކުރުމަށް ބަދަލުކޮށްފައެއް ނުވެއެވެ؛ ތަފާތަކީ",
      "incompleteNote": "{count} ސަބްސްކްރިޕްޝަނެއްގެ ޕްލޭން މި ޞަފުޙާއަށް ނުކިޔުނުކަމުން، އަޅާކިޔުން ގޯހެއް ނޫނެވެ، ފުރިހަމަ ނުވަނީއެވެ.",
      "truncatedNote": "ހަރަކާތްތެރި ސަބްސްކްރިޕްޝަންތަކުގެ އެއް ޞަފުޙާއަށްވުރެ ގިނަ ހުރުމުން، ތިރީގައިވާ ސަފުތަކަކީ އެންމެ ދަށް މިންވަރެވެ، އަދި އަޅާނުކިޔޭނެއެވެ.",
      "arrMismatch": "ރިޕޯޓްކުރެވުނު އަހަރުގެ އަދަދަކީ، މަހުގެ އަދަދުގެ ބާރަ ގުނައެއް ނޫނެވެ. ދެ އަދަދުވެސް އައި ގޮތަށް ދެއްކިފައިވެއެވެ.",
      "contributionTitle": "މި ސަބްސްކްރިޕްޝަނުން އިތުރުވާ މިންވަރު",
      "contributionDescription": "ޢަދަދު އަގުން ގުނަކޮށް، ސައިކަލްގެ މަސްތަކުގެ ޢަދަދުން ބަހާލެވިފައި.",
      "contributionNote": "ރެކޯޑްގެ އަދަދަކީ ތަކުރާރު އާމްދަނީގެ ރިޕޯޓެވެ. މިއީ އެއް އެއްބަސްވުމަކަށް ހަމަ އެ ހިސާބެވެ، އެއީ ބައިތައް ޖުމްލައާ އަޅާކިޔޭ ގޮތަށެވެ."
    },
    "settings": {
      "title": "ވިއްކުމުގެ ސެޓިންގތައް",
      "description": "އެއް ކުންފުނީގެ އާމްދަނީ އެކައުންޓް، އަސާސީ ގުދަން، ޑިސްކައުންޓްގެ ޙައްދު އަދި ފައިދާގެ ޙައްދުގެ ސިޔާސަތު.",
      "forbidden": "ވިއްކުމުގެ ސެޓިންގތައް ބެލުމުގެ ހުއްދަ ތިޔަ ފަރާތަކަށް ނެތެވެ. ބެލުމަށާއި ބަދަލުކުރުމަށް ސާވަރުން ބަލަނީ އެއް ހުއްދައަކަށްކަމުން، ހަމައެކަނި ބެލޭ ގޮތެއް ދެއްކެން ނެތެވެ.",
      "loadFailed": "ސެޓިންގތައް ނުލޯޑްވި",
      "saved": "ވިއްކުމުގެ ސެޓިންގތައް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ސެޓިންގތައް ރައްކާނުކުރެވުނު",
      "revenueTitle": "އާމްދަނީ",
      "revenueDescription": "މުއްދަތަކަށް ބިލްކުރެވޭ ސަފެއް ކްރެޑިޓްކުރެވޭ ތަނާއި، އައު ސަފެއްގައި އަސާސީގޮތުން އޮންނާނެ ގުދަން.",
      "guardrailTitle": "ޑިސްކައުންޓާއި ފައިދާގެ ރައްކާތެރިކަން",
      "guardrailDescription": "ސަފެއްގެ ޑިސްކައުންޓް ޙައްދު ފަހަނައަޅައިފިނަމަ، ނުވަތަ ތަކެއްޗެއްގެ ފައިދާގެ ޙައްދުން ދަށުގައި އަގު ކިޔައިފިނަމަ ވާނެގޮތް.",
      "fields": {
        "deferredAccount": "ފަސްކުރެވިފައިވާ އާމްދަނީ އެކައުންޓް",
        "deferredAccountHint": "ދަރަނީގެ އެކައުންޓެއް. އިންވޮއިސް ވަގުތު އެއަށް ކްރެޑިޓްކުރުމުން އާމްދަނީ ފަސްވެއެވެ.",
        "deferredAccountPlaceholder": "ދަރަނީގެ އެކައުންޓެއް ޚިޔާރުކުރޭ",
        "defaultWarehouse": "އަސާސީ ގުދަން",
        "defaultWarehouseHint": "އައު ސަފެއްގައި ކުރިން ފުރާލެވެއެވެ. ކޮންމެ ސަފަކުންވެސް އަމިއްލަ ގުދަނެއް ބުނެވިދާނެއެވެ.",
        "discountThreshold": "ޑިސްކައުންޓް ފާސްކުރުމުގެ ޙައްދު %",
        "discountThresholdHint": "މިއަށްވުރެ ބޮޑު ޑިސްކައުންޓަކަށް އޯވަރައިޑެއް ބޭނުންވެއެވެ. ސީދާ މިއާ އެއްވަރު ޑިސްކައުންޓެއް ފާސްވެއެވެ.",
        "marginPolicy": "ފައިދާގެ ޙައްދުގެ ސިޔާސަތު",
        "marginPolicyHint": "ތަކެއްޗެއްގެ ފައިދާގެ ޙައްދުން ދަށު އަގަކުން، ޔަގީންކުރާއިރު ވާނެގޮތް.",
        "standardCost": "މިންގަނޑު ޚަރަދު",
        "standardCostHint": "މި ތަކެއްޗަށް ޙައްދު މިނެކިޔެނީ މިއާ އަޅާކިޔައިގެންނެވެ.",
        "marginFloorPercent": "ފައިދާގެ އެންމެ ދަށް ޙައްދު %",
        "marginFloorPercentHint": "މިންގަނޑު ޚަރަދުގެ މައްޗަށް އެންމެ ދަށްވެގެން ބޭނުންވާ ފައިދާ، އިންސައްތައިން."
      },
      "noDeferredAccount": "މި އެކައުންޓް ކަނޑައަޅާފައި ނުވާނަމަ، އާމްދަނީ ބަހާ މުއްދަތެއް އޮތް ސަފެއް އެއްގޮތަކަށްވެސް އިންވޮއިސް ނުކުރެވޭނެއެވެ — ސާވަރުން ދޫކޮށްލައި މި ގޮޅި ބަޔާންކުރެއެވެ.",
      "policies": {
        "block": {
          "label": "ހުއްޓުވާ",
          "summary": "ޔަގީންކުރުން މުޅިން ދޫކޮށްލައެވެ. އެއްވެސް އޯވަރައިޑަކުން ސާފެއް ނުކުރެވޭނެއެވެ."
        },
        "warn": {
          "label": "އިންޒާރުދޭ",
          "summary": "ދޫކޮށްލައެވެ، ނަމަވެސް ޑިސްކައުންޓް އޯވަރައިޑްގެ ހުއްދަ އޮތް ފަރާތަކަށް ފާސްކުރެވިދާނެއެވެ."
        },
        "ignore": {
          "label": "ފަރުވާލެއް ނުބަހައްޓާ",
          "summary": "ފައިދާގެ ޙައްދު އެއްގޮތަކަށްވެސް ނުބަލައެވެ."
        }
      },
      "blockConsequence": "ހުއްޓުވުމުގެ ދަށުން، ފައިދާގެ ޙައްދު ފަހަނައެޅުމަކަށް އެއްވެސް މީހަކަށް ދުވަހަކުވެސް އޯވަރައިޑެއް ނުދެވޭނެއެވެ. ބައެއް އޯޑަރުތައް އެއްގޮތަކަށްވެސް ނުދާނެއެވެ، އަދި އެ ހެދި ފަރާތަށް އަގު ބަދަލުކުރުން ފިޔަވައި އެހެން މަގެއް ނޯންނާނެއެވެ.",
      "itemFloorTitle": "ކޮންމެ ތަކެއްޗަކަށް ފައިދާގެ ޙައްދު",
      "itemFloorDescription": "ޙައްދު އޮންނަނީ ކޮންމެ ތަކެއްޗަކަށް ވަކިން، އެ ތަކެތީގެ މިންގަނޑު ޚަރަދުގެ މައްޗަށެވެ — މުޅި ކެޓަލޮގަށް އެއް ޙައްދެއް ކަނޑައެޅުމަކީ ތެދުވެރިކަމާއެކު ކުރެވޭނެ ކަމެއް ނޫނެވެ.",
      "saveItemFloor": "ތަކެތީގެ ޙައްދު ރައްކާކުރޭ",
      "itemSaved": "ތަކެތީގެ ފައިދާގެ ޙައްދު ރައްކާކުރެވިއްޖެ",
      "itemSaveFailed": "ތަކެތީގެ ފައިދާގެ ޙައްދު ރައްކާނުކުރެވުނު",
      "itemFloorMoved": "ފްލޯއާއި، އެ ބަލާ ސްޓޭންޑަޑް އަގު ކަނޑައަޅަނީ ކޮންމެ ތަކެއްޗަކަށް ވަކިން، އަގު ކަނޑައެޅުމުގެ އިންޖީނާއެކުގައެވެ.",
      "itemFloorLink": "ތަކެތީގެ އަގުކުރުމުގެ ސެޓިންގތައް ހުޅުވާ",
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ސެޓިންގްސް ބަދަލުކޮށްފި. ކަމެއް ނުފޮހެވޭ. ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކުރޭ"
    },
    "amend": {
      "title": "{orderNo} އިޞްލާޙުކުރޭ",
      "description": "ކަށަވަރުކުރި އޯޑަރެއް އެޑިޓެއް ނުކުރެވެއެވެ، އިޞްލާޙުކުރެވެއެވެ. ކޮންމެ ބަދަލެއް އަލުން ބަލައި، އައު ވަރޝަނެއްގެ ގޮތުގައި ރައްކާކުރެވެއެވެ.",
      "action": "އޯޑަރު އިޞްލާޙުކުރޭ",
      "submit": "އިޞްލާޙުކުރޭ",
      "revalidates": "އިޞްލާޙުކުރުމުން، ޑިސްކައުންޓް ޙައްދުތަކާއި، ކްރެޑިޓް ޗެކާއި، ލިބެންހުރިކަން ބަދަލުވި އޯޑަރާ ދެކޮޅަށް އަލުން ހިންގައެވެ.",
      "materiality": "ބަދަލަކީ މުހިންމު ބަދަލެއް ނަމަ، ކުރިން ދީފައިވާ ހުއްދަ ބާޠިލުވެ، މިހާރުގެ ބާރުގެ މެޓްރިކްސްއާ އެއްގޮތަށް އޯޑަރު އަލުން ހުއްދައަށް ފޮނުވެއެވެ.",
      "reasonCode": "ސަބަބުގެ ކޯޑް",
      "reasonCodeHint": "އިޞްލާޙާއެކު ރައްކާކުރެވޭ ކުރު ކޯޑެއް، ގިނަވެގެން 40 އަކުރު.",
      "note": "ނޯޓް",
      "promisedDate": "ވަޢުދުވި ތާރީޚް",
      "promisedDateHint": "ކުރިން ވަޢުދުވި ތާރީޚް ބަދަލުނުކުރާނަމަ ހުސްކޮށް ބާއްވާ.",
      "permitBackorder": "ބާކީ އޯޑަރަށް ހުއްދަދޭ",
      "permitBackorderHint": "ލިބެންހުރި ސްޓޮކަށް ނުފެތޭ ސަފުތައް ބާކީ އޯޑަރެއްގެ ގޮތުގައި ގެންދިއުމަށް ހުއްދަދޭ.",
      "backorderReasonCode": "ބާކީ އޯޑަރުގެ ސަބަބުގެ ކޯޑް",
      "linesCaption": "އިޞްލާޙުކުރި އޯޑަރުގެ ސަފުތައް",
      "priorTotal": "ކުރީގެ ޖުމްލަ",
      "newTotal": "އައު ޖުމްލަ",
      "noReprice": "އެއްވެސް ސަފެއް ބަދަލުވެފައެއް ނުވެއެވެ، އެހެންކަމުން އަގު އަލުން ނުކިޔޭނެއެވެ. ފޮނުވެނީ ހަމައެކަނި ތާރީޚްތަކާއި ބާކީ އޯޑަރުގެ ސެޓިންގ އެވެ.",
      "short": "މަދުވެގެން އެއް ސަފަކަށް ލިބެންހުރި ޢަދަދު ދަށެވެ. ބާކީ އޯޑަރަށް ހުއްދަދީ ސަބަބުގެ ކޯޑެއް ދޭށެވެ، ނުވަތަ ޢަދަދު ކުޑަކުރާށެވެ.",
      "historyTitle": "އިޞްލާޙުތަކުގެ ތާރީޚް",
      "historyDescription": "މި އޯޑަރުގެ ކޮންމެ ވަރޝަނެއް، ބަދަލުވި އެއްޗަކާއި އެ ބަދަލު ވަޒަންކުރި ގޮތާއެކު.",
      "historyCaption": "މި އޯޑަރާ ދެކޮޅަށް ރައްކާކުރެވިފައިވާ އިޞްލާޙުތައް",
      "columns": {
        "no": "ނަންބަރު",
        "changed": "ބަދަލުވި ގޮޅިތައް",
        "assessment": "ވަޒަންކުރުން",
        "rechecks": "އަލުން ބެލުން"
      },
      "material": "މުހިންމު",
      "immaterial": "މުހިންމު ނޫން",
      "rerouted": "ހުއްދަ ބާޠިލުކޮށް އަލުން ފޮނުވިފައި",
      "creditRecheck": "ކްރެޑިޓް: {outcome}",
      "atpRecheck": "ލިބެންހުރިކަން: {outcome}",
      "repriced": "{count} ސަފުގެ އަގު އަލުން ކިޔިފައި",
      "materialToast": "އިޞްލާޙު {no} އަކީ މުހިންމު ބަދަލެކެވެ — އޯޑަރަށް އަލުން ހުއްދަ ބޭނުންވެއެވެ",
      "doneToast": "އިޞްލާޙު {no} ރައްކާކުރެވިއްޖެ",
      "failed": "މި އޯޑަރު އިޞްލާޙެއް ނުކުރެވުނު"
    },
    "discountPolicies": {
      "title": "ޑިސްކައުންޓް ބާރުގެ މެޓްރިކްސް",
      "description": "ޗެނަލް، ކަސްޓަމަރު ސެގްމަންޓް އަދި ތަކެތީގެ ބާވަތަށް ބަހާލެވިފައިވާ ޑިސްކައުންޓް ޙައްދުތަކާއި މާރޖިން ފްލޯތައް.",
      "newPolicy": "އައު އުޞޫލެއް",
      "editTitle": "އުޞޫލު އެޑިޓްކުރޭ",
      "editorDescription": "އުޞޫލެއް ހިނގާނީ އޭގެ ޗެނަލް، ސެގްމަންޓް އަދި ބާވަތާ ދިމާވާ ކޮންމެ ސަފަކަށެވެ. ހުރިހާ އެއްޗަކާ ދިމާވުމަށް އެ ގޮޅި ހުސްކޮށް ބާއްވާށެވެ.",
      "supersede": "ބަދަލުކުރައްވާ",
      "supersedeTitle": "އުޞޫލު ބަދަލުކުރޭ",
      "supersedeDescription": "މި އުޞޫލު ނިންމައި، އައު ތާރީޚަކުން ފެށިގެން ބަދަލުގައި އަންނަ އުޞޫލު ހުޅުވާ. ސްކޯޕް ބަދަލެއް ނުކުރެވޭނެ.",
      "supersedeNote": "މިހާރުގެ އުޞޫލު ނިމޭނީ އައު އުޞޫލު ފެށޭ ދުވަހުގެ ކުރީ ދުވަހެވެ. އޭގެ ދަށުން ކުރިން ނިންމާފައިވާ އެއްވެސް ކަމެއް ބަދަލެއް ނުވާނެއެވެ.",
      "channel": "ޗެނަލް",
      "segment": "ސެގްމަންޓް",
      "category": "ބާވަތް",
      "any": "ކޮންމެ އެއްޗެއް",
      "anyHint": "ހުސްކޮށް ބޭއްވުމުން ހުރިހާ އެއްޗަކާ ދިމާވެއެވެ.",
      "asAt": "ބާރުގައި ހުރި ތާރީޚް",
      "asAtHint": "މި ތާރީޚުގައި ބާރުގައި ހުރި އުޞޫލުތައް އެކަނި ދައްކާ.",
      "effectiveFrom": "އަމަލުކުރަން ފަށާ",
      "amountHint": "ފައިސާއިން ދެވަނަ ޙައްދެއް، ބޭނުމިއްޔާ. ފައިސާގެ ބާވަތް ބޭނުންވާނެއެވެ.",
      "marginFloorHint": "ހުއްޓުވުމުން ވިޔަފާރި މުޅިން ދޫކޮށްލައެވެ؛ އިންޒާރުން އޯވަރައިޑަކަށް ޖާގަދެއެވެ؛ ފަރުވާލެއް ނުބަހައްޓާނަމަ އެއިން އެއްވެސް ކަމެއް ނުކުރެއެވެ.",
      "inForce": "ބާރުގައި",
      "superseded": "ބަދަލުކުރެވިފައި",
      "resolutionNote": "ބާރުގައި ހުރި އެންމެ ވަކިކަން ބޮޑު އުޞޫލު ކާމިޔާބުވެއެވެ: ބާވަތް ސެގްމަންޓަށްވުރެ، ސެގްމަންޓް ޗެނަލަށްވުރެ އިސްވެއެވެ. ވަކިކަން ހިސާބުކުރަނީ ޑޭޓާބޭސްއިންނެވެ، މި ސްކްރީނަކުން ނޫނެވެ.",
      "fallbackNote": "އެއްވެސް އުޞޫލަކާ ދިމާނުވާނަމަ، މުޅި ކުންފުންޏަށް އޮންނަ އެއް ޙައްދު ހިނގާނެއެވެ —",
      "emptyTitle": "އަދި ޑިސްކައުންޓް އުޞޫލެއް ނެތް",
      "emptyDescription": "އުޞޫލެއް ލިޔެވެންދެން ކޮންމެ ސަފެއްވެސް ރުޖޫޢަވާނީ މުޅި ކުންފުނީގެ ޑިސްކައުންޓް ޙައްދަށެވެ.",
      "loadFailed": "ޑިސްކައުންޓް އުޞޫލުތައް ނުގެނެވުނު",
      "saved": "އުޞޫލު ރައްކާކުރެވިއްޖެ",
      "saveFailed": "އުޞޫލު ރައްކާނުކުރެވުނު",
      "columns": {
        "scope": "ސްކޯޕް",
        "specificity": "ވަކިކަން",
        "thresholdPercent": "ޙައްދު %",
        "thresholdAmount": "ޙައްދުގެ އަދަދު",
        "marginFloor": "މާރޖިން ފްލޯ",
        "window": "އަމަލުކުރާ މުއްދަތު"
      },
      "marginPolicies": {
        "block": "ހުއްޓުވާ",
        "warn": "އިންޒާރު",
        "ignore": "ފަރުވާލެއް ނުބަހައްޓާ"
      },
      "authorityNote": "ޙައްދު ފަހަނައަޅާ ޑިސްކައުންޓެއް ދެވޭނީ ކާކަށްކަން އެއީ ވަކި ސުވާލެކެވެ، އަދި އެ ސުވާލު ކުރެވެނީ ފައިސާއިންނެވެ —",
      "authorityMatrix": "ބާރުގެ މެޓްރިކްސް"
    },
    "agreements": {
      "title": "ވިޔަފާރީގެ އެއްބަސްވުންތައް",
      "description": "ކަސްޓަމަރަކާ ނުވަތަ ސެގްމަންޓަކާއެކު ވަކި މުއްދަތަކަށް އެއްބަސްވެފައިވާ އަގުތަކާއި ލުއިތައް.",
      "newAgreement": "އައު އެއްބަސްވުމެއް",
      "editHeader": "އެއްބަސްވުން އެޑިޓްކުރޭ",
      "headerDescription": "އެއްބަސްވުމެއް ހިނގާނީ އެއް ކަސްޓަމަރަށް ނުވަތަ މުޅި ސެގްމަންޓަކަށެވެ، ދެ ފަރާތަށް އެއްފަހަރާ ނޫނެވެ.",
      "detailDescription": "އެއްބަސްވުމުގެ ސަފުތަކުން ކަސްޓަމަރުގެ އޯޑަރުތަކުގެ އަގު، ފަންތި އަދި އަސާސީ ލިސްޓްތަކަށްވުރެ ކުރިން ކިޔައެވެ.",
      "customerHint": "މުޅި ސެގްމަންޓަކަށް ޝަރުޠު ކަނޑައަޅާނަމަ ހުސްކޮށް ބާއްވާ.",
      "segment": "ސެގްމަންޓް",
      "bySegment": "ސެގްމަންޓުން",
      "category": "ބާވަތް",
      "anyItem": "ކޮންމެ ތަކެއްޗެއް",
      "kind": "ބާވަތް",
      "value": "ޢަދަދު",
      "minQty": "އެންމެ ދަށް ޢަދަދު",
      "priority": "އިސްކަން",
      "startsOn": "ފެށޭ ތާރީޚް",
      "endsOn": "ނިމޭ ތާރީޚް",
      "activatedAt": "ހަރަކާތްތެރިކުރި",
      "activate": "ހަރަކާތްތެރިކުރޭ",
      "activateTitle": "އެއްބަސްވުން ހަރަކާތްތެރިކުރޭ",
      "activateDescription": "ހަރަކާތްތެރި އެއްބަސްވުމަކުން މިހާރުން ފެށިގެން ދިމާވާ ކޮންމެ އޯޑަރެއްގެ އަގު ކިޔައެވެ. ދެލިކޮޕީއަކުން އެއްވެސް އަގެއް ނުކިޔައެވެ.",
      "activated": "އެއްބަސްވުން {code} ހަރަކާތްތެރިވެއްޖެ",
      "activateFailed": "އެއްބަސްވުން ހަރަކާތްތެރިއެއް ނުކުރެވުނު",
      "saveLines": "ސަފުތައް ރައްކާކުރޭ",
      "linesSaved": "އެއްބަސްވުމުގެ ސަފުތައް ރައްކާކުރެވިއްޖެ",
      "linesFailed": "އެއްބަސްވުމުގެ ސަފުތައް ރައްކާނުކުރެވުނު",
      "linesCaption": "މި އެއްބަސްވުމުން އަގު ކިޔާ ސަފުތައް",
      "noLines": "އަދި ސަފެއް ނެތް. ސަފެއް ނެތް އެއްބަސްވުމަކުން އެއްވެސް އަގެއް ނުކިޔައެވެ.",
      "precedenceNote": "ހަރަކާތްތެރި އެއްބަސްވުމުގެ ސަފެއް، ކަސްޓަމަރުގެ ފަންތި ލިސްޓާއި އަސާސީ ލިސްޓަށްވުރެ ކުރިން ނިންމައެވެ.",
      "readOnly": "މި އެއްބަސްވުން ކިޔާލެވިދާނެއެވެ، އެކަމަކު ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "rebatePrograms": "ރިބޭޓް ޕްރޮގްރާމްތައް",
      "emptyTitle": "އަދި ވިޔަފާރީގެ އެއްބަސްވުމެއް ނެތް",
      "emptyDescription": "ކަސްޓަމަރަކާއެކު އެއްބަސްވި އަގުތަކާއި ލުއިތައް ރައްކާކުރުމަށް އެއްބަސްވުމެއް ހަދާ.",
      "loadFailed": "ވިޔަފާރީގެ އެއްބަސްވުންތައް ނުގެނެވުނު",
      "saved": "އެއްބަސްވުން ރައްކާކުރެވިއްޖެ",
      "saveFailed": "އެއްބަސްވުން ރައްކާނުކުރެވުނު",
      "columns": {
        "code": "ކޯޑު",
        "name": "ނަން",
        "appliesTo": "ހިނގާ ފަރާތް",
        "window": "މުއްދަތު",
        "lines": "ސަފުތައް"
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "active": "ހަރަކާތްތެރި",
        "suspended": "ހުއްޓާލެވިފައި",
        "expired": "މުއްދަތު ހަމަވެފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "kinds": {
        "fixed_price": "ކަނޑައެޅިފައިވާ އަގު",
        "discount_percent": "ޑިސްކައުންޓް %",
        "discount_amount": "ޑިސްކައުންޓް އަދަދު"
      },
      "aria": {
        "category": "ސަފު {line} ގެ ބާވަތް",
        "minQty": "ސަފު {line} ގެ އެންމެ ދަށް ޢަދަދު",
        "value": "ސަފު {line} ގެ ޢަދަދު",
        "priority": "ސަފު {line} ގެ އިސްކަން"
      }
    },
    "rebates": {
      "title": "ރިބޭޓް ޕްރޮގްރާމްތައް",
      "description": "އިންވޮއިސްއިން ބޭރުގައި ދެވޭ ލުއިތަކާއި ކުރިއެރުމުގެ ޙައްޤުތައް، ލިބެމުންދާ ވަރަކަށް ޖަމާކުރެވެއެވެ.",
      "newProgram": "އައު ޕްރޮގްރާމެއް",
      "editProgram": "ޕްރޮގްރާމް އެޑިޓްކުރޭ",
      "formDescription": "ޕްރޮގްރާމެއް ނިސްބަތްވަނީ ވިޔަފާރީގެ އެއްބަސްވުމަކަށެވެ، އަދި ޕޯސްޓްކުރެވެނީ މިތާ ބުނެފައިވާ ދެ އެކައުންޓަށެވެ.",
      "ladderDescription": "ދައްކަންޖެހޭ ޢަދަދު ހިސާބުކުރާ ފަންތިތަކުގެ ސިޑި.",
      "ladderCaption": "ރިބޭޓް ފަންތިތައް، އެންމެ ދަށް ބޭންޑުން ފެށިގެން",
      "basis": "އަސާސް",
      "basisHint": "ސިޑި ކިޔަނީ އާމްދަނީއާ ދެކޮޅަށްތޯ ނުވަތަ ޢަދަދާ ދެކޮޅަށްތޯ.",
      "period": "މުއްދަތު",
      "periodStart": "މުއްދަތު ފެށޭ",
      "tierKind": "ފަންތީގެ ބާވަތް",
      "tierKindHint": "މާރޖިނަލްއިން ކޮންމެ ބޭންޑަކަށް އޭގެ އަމިއްލަ ރޭޓް ނަގައެވެ؛ ރެޓްރޮސްޕެކްޓިވްއިން މުޅި މުއްދަތު އަލުން ހިސާބުކުރެއެވެ.",
      "expenseAccount": "ރިބޭޓް ޚަރަދު އެކައުންޓް",
      "liabilityAccount": "ރިބޭޓް ދަރަނި އެކައުންޓް",
      "settlementMethod": "ސެޓްލްމަންޓް ގޮތް",
      "seq": "ބޭންޑް",
      "minValue": "ފެށޭ",
      "maxValue": "ނިމޭ",
      "ratePercent": "ރޭޓް %",
      "rateAmount": "ރޭޓް އަދަދު",
      "addTier": "ބޭންޑެއް އިތުރުކުރޭ",
      "saveTiers": "ސިޑި ރައްކާކުރޭ",
      "tiersSaved": "ފަންތިތަކުގެ ސިޑި ރައްކާކުރެވިއްޖެ",
      "tiersFailed": "ފަންތިތަކުގެ ސިޑި ރައްކާނުކުރެވުނު",
      "noTiers": "އަދި ބޭންޑެއް ނެތް. ސިޑިއެއް ނެތް ޕްރޮގްރާމަކުން އެއްވެސް އެއްޗެއް ޖަމައެއް ނުވެއެވެ.",
      "retrospectiveNote": "ރެޓްރޮސްޕެކްޓިވް ފަންތިތަކުން، ލިބުނު ބޭންޑުގެ ރޭޓުން މުޅި މުއްދަތު އަލުން ހިސާބުކުރާތީ، މުއްދަތު ނިމޭއިރު ޖަމާވުން ބޮޑަށް ބަދަލުވެދާނެއެވެ.",
      "accountsNote": "ޖަމާވަނީ ޚަރަދު އެކައުންޓް {expense} އަދި ދަރަނި އެކައުންޓް {liability} އަށެވެ.",
      "viewAccruals": "ޖަމާވުންތައް",
      "programSaved": "ޕްރޮގްރާމް ރައްކާކުރެވިއްޖެ",
      "programFailed": "ޕްރޮގްރާމް ރައްކާނުކުރެވުނު",
      "emptyTitle": "އަދި ރިބޭޓް ޕްރޮގްރާމެއް ނެތް",
      "emptyDescription": "ލިބެމުންދާ ވަރަކަށް ލުޔެއް ޖަމާކުރުމަށް ވިޔަފާރީގެ އެއްބަސްވުމަކާ ދެކޮޅަށް ޕްރޮގްރާމެއް ހަދާ.",
      "loadFailed": "ރިބޭޓް ޕްރޮގްރާމްތައް ނުގެނެވުނު",
      "accrualsTitle": "ރިބޭޓް ޖަމާވުންތައް",
      "accrualsDescription": "ކޮންމެ ކަސްޓަމަރަކަށް، ކޮންމެ މުއްދަތެއްގައި ލިބުނު ޢަދަދާއި އެ ޢަދަދު ދެއްކި ގޮތް.",
      "accrualsEmptyTitle": "އަދި ޖަމާވުމެއް ނެތް",
      "accrualsEmptyDescription": "ޕްރޮގްރާމެއްގެ މުއްދަތުގައި ޝަރުޠު ފުރިހަމަވާ އާމްދަނީ ޕޯސްޓްކުރުމުން ޖަމާވުމެއް ފެންނާނެއެވެ.",
      "accrualsLoadFailed": "ރިބޭޓް ޖަމާވުންތައް ނުގެނެވުނު",
      "detailTitle": "{period} އިން ފެށޭ ޖަމާވުން",
      "detailDescription": "ޝަރުޠު ފުރިހަމަވި ލިޔުންތަކާއި، އެއިން ސިޑިން ނެރުނު ނަތީޖާ.",
      "linesCaption": "މި ޖަމާވުމަށް ބައިވެރިވި މަޞްދަރު ލިޔުންތައް",
      "noLines": "މި މުއްދަތުގައި އަދި އެއްވެސް އެއްޗެއް ޝަރުޠު ފުރިހަމައެއް ނުވެއެވެ.",
      "qualifyingBase": "ޝަރުޠު ފުރިހަމަވި އަސާސް",
      "qualifyingAmount": "ޝަރުޠު ފުރިހަމަވި އަދަދު",
      "qualifyingQty": "ޝަރުޠު ފުރިހަމަވި ޢަދަދު",
      "accrued": "ޖަމާވެފައި",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "settledAmount": "ދެއްކިފައި",
      "alreadySettled": "މިހާރު ދެއްކިފައި",
      "remaining": "ބާކީ",
      "tier": "ބޭންޑް",
      "journal": "ޖާނަލް އެންޓްރީ",
      "sourceDoc": "މަޞްދަރު ލިޔުން",
      "openNote": "މި މުއްދަތު އަދި ހުޅުވިފައިވާތީ، ޖަމާވި ޢަދަދަކީ ހިނގަމުންދާ ޖުމްލައެކެވެ، ނިހާއީ ޢަދަދެއް ނޫނެވެ.",
      "close": "މުއްދަތު ބަންދުކުރޭ",
      "closeTitle": "ޖަމާވުމުގެ މުއްދަތު ބަންދުކުރޭ",
      "closeDescription": "ބަންދުކުރުމުން މި މުއްދަތުގެ ދަރަނި ކަނޑައެޅެއެވެ. އިތުރަށް އެއްވެސް އެއްޗެއް ޖަމައެއް ނުވާނެއެވެ.",
      "closed": "ޖަމާވުމުގެ މުއްދަތު ބަންދުކުރެވިއްޖެ",
      "closeFailed": "ޖަމާވުމުގެ މުއްދަތު ބަންދެއް ނުކުރެވުނު",
      "settle": "ދައްކާ",
      "settleTitle": "ރިބޭޓް ދައްކާ",
      "settleDescription": "ޖަމާވެފައިވާ ރިބޭޓް، ކްރެޑިޓް ނޯޓަކުން ނުވަތަ ޕޭމަންޓަކުން ދައްކާ.",
      "settleConsequence": "ދެއްކުމުން ރިބޭޓް ދަރަންޏާ ދެކޮޅަށް ޕޯސްޓްކޮށް، ކްރެޑިޓް ނޯޓް ނުވަތަ ޕޭމަންޓް އުފައްދައެވެ. މި ސްކްރީނުން އެ ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "settled": "ރިބޭޓް ސެޓްލްމަންޓް ރައްކާކުރެވިއްޖެ ({status})",
      "settleFailed": "ރިބޭޓް ނުދެއްކުނު",
      "overSettled": "ބާކީ ހުރި ޢަދަދަށްވުރެ ބޮޑު.",
      "columns": {
        "code": "ކޯޑު",
        "name": "ނަން",
        "agreement": "އެއްބަސްވުން",
        "shape": "ބައްޓަން",
        "tiers": "ބޭންޑްތައް",
        "program": "ޕްރޮގްރާމް"
      },
      "bases": {
        "revenue": "އާމްދަނީ",
        "quantity": "ޢަދަދު (ކޮޅު)"
      },
      "periods": {
        "monthly": "މަހުން މަހަށް",
        "quarterly": "ކުއާޓަރުން",
        "annual": "އަހަރަކު އެއްފަހަރު"
      },
      "tierKinds": {
        "flat": "އެއް ރޭޓް",
        "tiered_marginal": "ފަންތިކޮށް، މާރޖިނަލް",
        "tiered_retrospective": "ފަންތިކޮށް، ރެޓްރޮސްޕެކްޓިވް"
      },
      "methods": {
        "credit_note": "ކްރެޑިޓް ނޯޓް",
        "payment": "ޕޭމަންޓް"
      },
      "accrualStatuses": {
        "open": "ހުޅުވިފައި",
        "closed": "ބަންދު",
        "settled": "ދެއްކިފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "aria": {
        "minValue": "ބޭންޑް {tier} ފެށޭ",
        "maxValue": "ބޭންޑް {tier} ނިމޭ",
        "ratePercent": "ބޭންޑް {tier} ގެ ރޭޓް އިންސައްތަ",
        "rateAmount": "ބޭންޑް {tier} ގެ ރޭޓް އަދަދު"
      }
    },
    "contracts": {
      "title": "ކަސްޓަމަރު ކޮންޓްރެކްޓްތައް",
      "description": "ކަސްޓަމަރެއްގެ ކޯޓޭޝަން، އޯޑަރު އަދި އާމްދަނީ ތަބާވާ ޝަރުޠުތައް.",
      "newContract": "އައު ކޮންޓްރެކްޓެއް",
      "editContract": "ކޮންޓްރެކްޓް އެޑިޓްކުރޭ",
      "formDescription": "ކޮންޓްރެކްޓަކުން އެއް ކަސްޓަމަރެއް ވަކި މުއްދަތަކަށް ބަނދެވެއެވެ، ބޭނުމިއްޔާ ވިޔަފާރީގެ އެއްބަސްވުމެއްގެ ދަށުން.",
      "detailDescription": "އެއްބަސްވި އެއްޗެއް، މުރާޖައާކުރާ ތާރީޚް، އަދި އާކުރެވޭ ތާރީޚް.",
      "tradeAgreement": "ވިޔަފާރީގެ އެއްބަސްވުން",
      "tradeAgreementHint": "މި ކޮންޓްރެކްޓުގެ އަގުތައް ހިންގާ އެއްބަސްވުން.",
      "renewalNoticeDays": "އާކުރުމުގެ ނޯޓިސް (ދުވަސް)",
      "renewalNoticeHint": "ނިމޭ ތާރީޚުގެ ކިތައް ދުވަސް ކުރިން އާކުރުމުގެ ނިންމުން ބޭނުންވޭތޯ.",
      "autoRenew": "އަމިއްލައަށް އާވޭ",
      "autoRenewNote": "ނިމުމުގެ {days} ދުވަސް ކުރިން ނޯޓިސް ނުދޭނަމަ މި ކޮންޓްރެކްޓް އަމިއްލައަށް އާވާނެއެވެ.",
      "autoRenewsIn": "އަމިއްލައަށް އާވޭ، {days} ދުވަހުގެ ނޯޓިސް",
      "noticeDays": "{days} ދުވަހުގެ ނޯޓިސް",
      "expiringBefore": "މުއްދަތު ހަމަވަނީ މީގެ ކުރިން",
      "expiringBeforeHint": "މި ދުވަހުގެ ކުރިން ނިމޭ ކޮންޓްރެކްޓްތައް.",
      "reviewBefore": "އަގު މުރާޖައާ މީގެ ކުރިން",
      "reviewBeforeHint": "މި ދުވަހުގެ ކުރިން އަގު މުރާޖައާކުރަންޖެހޭ ކޮންޓްރެކްޓްތައް.",
      "activate": "ހަރަކާތްތެރިކުރޭ",
      "activateTitle": "ކޮންޓްރެކްޓް ހަރަކާތްތެރިކުރޭ",
      "activateDescription": "ހަރަކާތްތެރި ކޮންޓްރެކްޓަކުން ކަސްޓަމަރުގެ ލިޔުންތައް ހިންގައެވެ. ދެލިކޮޕީއަކުން އެއްވެސް އެއްޗެއް ނުހިންގައެވެ.",
      "activated": "ކޮންޓްރެކްޓް {code} ހަރަކާތްތެރިވެއްޖެ",
      "activateFailed": "ކޮންޓްރެކްޓް ހަރަކާތްތެރިއެއް ނުކުރެވުނު",
      "revRecObligations": "ޚިދުމަތުގެ ޒިންމާތައް",
      "obligationsTitle": "ޒިންމާތަކާއި ޙައްޤުތައް",
      "obligationsDescription": "ދެ ފަރާތުގެ މިނެކުރެވޭ ވަޢުދުތަކާއި، ކޮންމެ ވަޢުދެއް ފުއްދިފައިވާ މިންވަރު.",
      "obligationsCaption": "ކޮންޓްރެކްޓުގެ ޒިންމާތައް، އެ ޒިންމާތަކުގެ އަމާޒާއި މިނެކުރުމާއެކު",
      "addObligation": "ޒިންމާއެއް އިތުރުކުރޭ",
      "saveObligations": "ޒިންމާތައް ރައްކާކުރޭ",
      "obligationsSaved": "ޒިންމާތައް ރައްކާކުރެވިއްޖެ",
      "obligationsFailed": "ޒިންމާތައް ރައްކާނުކުރެވުނު",
      "noObligations": "މި ކޮންޓްރެކްޓާ ދެކޮޅަށް ޒިންމާއެއް ރައްކާކުރެވިފައެއް ނުވެއެވެ.",
      "measuredNote": "މިނެކުރެވުނު ޢަދަދާއި ސްޓޭޓަސް ބަލަހައްޓަނީ ލިޔުންތައް ޕޯސްޓްވަމުންދާ ވަރަކަށް ސާވަރުންނެވެ؛ މިތާ އެއިން އެއްޗެއް ނުލިޔެވޭނެއެވެ.",
      "seq": "ނަންބަރު",
      "kind": "ބާވަތް",
      "target": "އަމާޒު",
      "measured": "މިނެކުރެވުނު",
      "window": "މުއްދަތު",
      "dueOn": "މުއްދަތު",
      "emptyTitle": "އަދި ކަސްޓަމަރު ކޮންޓްރެކްޓެއް ނެތް",
      "emptyDescription": "ކަސްޓަމަރެއްގެ ލިޔުންތައް ހިންގާ ޝަރުޠުތައް ރައްކާކުރުމަށް ކޮންޓްރެކްޓެއް ހަދާ.",
      "loadFailed": "ކަސްޓަމަރު ކޮންޓްރެކްޓްތައް ނުގެނެވުނު",
      "saved": "ކޮންޓްރެކްޓް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ކޮންޓްރެކްޓް ރައްކާނުކުރެވުނު",
      "columns": {
        "code": "ކޯޑު",
        "name": "ނަން",
        "window": "މުއްދަތު",
        "renewal": "އާކުރުން",
        "priceReview": "އަގު މުރާޖައާ"
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "active": "ހަރަކާތްތެރި",
        "expiring": "މުއްދަތު ހަމަވަނީ",
        "expired": "މުއްދަތު ހަމަވެފައި",
        "terminated": "ނިމުމަކަށް ގެނެވިފައި"
      },
      "kinds": {
        "volume": "ވޮލިއުމް",
        "value": "ޢަދަދު",
        "service_level": "ޚިދުމަތުގެ ފެންވަރު",
        "price_review": "އަގު މުރާޖައާ",
        "other": "އެހެނިހެން"
      },
      "obligationStatuses": {
        "open": "ހުޅުވިފައި",
        "met": "ފުއްދިއްޖެ",
        "missed": "ފާއިތުވި",
        "waived": "ދޫކުރެވިފައި"
      },
      "aria": {
        "description": "ޒިންމާ {row} ގެ ތަފްޞީލު",
        "target": "ޒިންމާ {row} ގެ އަމާޒު",
        "periodStart": "ޒިންމާ {row} ގެ މުއްދަތު ފެށޭ ތާރީޚް",
        "periodEnd": "ޒިންމާ {row} ގެ މުއްދަތު ނިމޭ ތާރީޚް",
        "dueOn": "ޒިންމާ {row} ގެ މުއްދަތު ހަމަވާ ތާރީޚް",
        "progress": "ޒިންމާ {row} އޮތީ އަމާޒުގެ {percent} އިންސައްތައިގައި"
      }
    },
    "obligations": {
      "pageTitle": "އާމްދަނީ ދެނެގަތުން",
      "pageDescription": "ޚިދުމަތުގެ ޒިންމާތަކާއި، އެއިން ކޮންމެ ޒިންމާއެއްގެ އަމިއްލަ އަގާއި، ފުއްދާ ގޮތް.",
      "tabsLabel": "އާމްދަނީ ދެނެގަތުމުގެ ބައިތައް",
      "title": "ޚިދުމަތުގެ ޒިންމާތައް",
      "detailDescription": "ވަޢުދުވި އެއްޗާއި، އެއަށް ބަހާލެވުނު ޢަދަދާއި، ދެނެގަނެވުނު ޢަދަދު.",
      "method": "ގޮތް",
      "transactionPrice": "މުޢާމަލާތުގެ އަގު",
      "ssp": "އަމިއްލަ އަގު",
      "allocated": "ބަހާލެވިފައި",
      "recognised": "ދެނެގަނެވިފައި",
      "window": "މުއްދަތު",
      "schedule": "ފަސްކުރި އާމްދަނީގެ ތާވަލު",
      "share": "އަމިއްލަ އަގުތަކުގެ {share}",
      "residualHolder": "މި ޒިންމާއިން ބާކީ ނެގިއެވެ: އޭގެ ބައި ކަނޑައެޅުނީ އަނެއް ޒިންމާތަކުގެ އަގު ކަނޑައެޅުމަށްފަހު ބާކީވި ޢަދަދުންނެވެ.",
      "dueBefore": "މުއްދަތު ހަމަވަނީ މީގެ ކުރިން",
      "milestone": "މައިލްސްޓޯން",
      "milestonesCaption": "މައިލްސްޓޯންތަކާއި، ސެޓިފައިކުރުމުން ކޮންމެ އެއްޗަކުން ދެނެގަނެވޭ ޢަދަދު",
      "noMilestones": "މި ޒިންމާއާ ދެކޮޅަށް މައިލްސްޓޯނެއް ރައްކާކުރެވިފައެއް ނުވެއެވެ.",
      "percent": "ހިއްސާ %",
      "certifiedAt": "ސެޓިފައި ކުރި",
      "certify": "ސެޓިފައި ކުރޭ",
      "certifyTitle": "މައިލްސްޓޯން ސެޓިފައި ކުރޭ",
      "certifyDescription": "ދެނެގަނެވޭނީ ބަހާލެވުނު ޢަދަދުން މި މައިލްސްޓޯނުގެ ހިއްސާ އެކަންޏެވެ.",
      "certifiedOn": "ސެޓިފައި ކުރި ތާރީޚް",
      "certified": "މައިލްސްޓޯން ސެޓިފައި ކުރެވިއްޖެ",
      "certifyFailed": "މައިލްސްޓޯން ސެޓިފައެއް ނުކުރެވުނު",
      "satisfy": "ފުއްދާ",
      "satisfyTitle": "ޒިންމާ ފުއްދާ",
      "satisfyDescription": "ދެވުނު ތާރީޚުގައި ބަހާލެވުނު މުޅި ޢަދަދު ދެނެގަނެވެއެވެ.",
      "satisfiedOn": "ފުއްދި ތާރީޚް",
      "satisfied": "ޒިންމާ ފުއްދިއްޖެ",
      "satisfyFailed": "ޒިންމާ ނުފުއްދުނު",
      "overTimeNote": "މި ޒިންމާ ދެނެގަނެވެނީ އޭގެ މުއްދަތުގެ ތެރޭގައެވެ. ކޮންމެ ބައެއް ޕޯސްޓްކުރަނީ ވޯކަރެވެ؛ މިތާ ފަށަންޖެހޭ އެއްވެސް ކަމެއް ނެތެވެ.",
      "emptyTitle": "އަދި ޚިދުމަތުގެ ޒިންމާއެއް ނެތް",
      "emptyDescription": "އާމްދަނީގެ މުއްދަތެއް އޮތް އޯޑަރު ސަފެއް އިންވޮއިސްކުރުމުން ޒިންމާއެއް އުފެދެއެވެ.",
      "loadFailed": "ޚިދުމަތުގެ ޒިންމާތައް ނުގެނެވުނު",
      "columns": {
        "source": "މަޞްދަރު ސަފު"
      },
      "methods": {
        "point_in_time": "އެއް ވަގުތެއްގައި",
        "over_time": "މުއްދަތެއްގެ ތެރޭގައި",
        "milestone": "މައިލްސްޓޯން"
      },
      "statuses": {
        "pending": "އިންތިޒާރުގައި",
        "in_progress": "ކުރިއަށްދަނީ",
        "satisfied": "ފުއްދިއްޖެ",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      }
    },
    "ssp": {
      "title": "އަމިއްލަ ވަކިން ވިއްކާ އަގުތައް",
      "description": "ކޮންމެ ތަކެއްޗެއް ވަކިން ވިއްކާނެ އަގު — މުޢާމަލާތުގެ އަގު ބަހާލެވޭ އަސާސް.",
      "caption": "ތަކެއްޗާއި ފައިސާގެ ބާވަތަށް ބަހާލެވިފައިވާ އަމިއްލަ ވަކިން ވިއްކާ އަގުތައް",
      "newPrice": "އައު އަގެއް",
      "newDescription": "އަމިއްލަ އަގެއް ހިނގާނީ އެއް ތަކެއްޗަކަށް، އެއް ފައިސާއަކުން، ބުނެފައިވާ ތާރީޚަކުން ފެށިގެންނެވެ.",
      "amount": "އަމިއްލަ އަގު",
      "method": "ގޮތް",
      "methodHint": "ފެންނަން ހުރި އަގަކީ އެންމެ ވަރުގަދަ ހެއްކެވެ؛ ބާކީ ގޮތް ބޭނުންކުރެވޭނީ އަގު ވަރަށް ބޮޑަށް ބަދަލުވާ ޙާލަތުގައި އެކަންޏެވެ.",
      "asAt": "ބާރުގައި ހުރި ތާރީޚް",
      "asAtHint": "މި ތާރީޚުގައި ބާރުގައި ހުރި އަގުތައް އެކަނި ދައްކާ.",
      "window": "އަމަލުކުރާ މުއްދަތު",
      "inForce": "ބާރުގައި",
      "superseded": "ބަދަލުކުރެވިފައި",
      "supersede": "ބަދަލުކުރައްވާ",
      "supersedeTitle": "އަމިއްލަ އަގު ބަދަލުކުރޭ",
      "supersedeDescription": "މި އަގު ނިންމައި، އައު ތާރީޚަކުން ފެށިގެން ބަދަލުގައި އަންނަ އަގު ހުޅުވާ. ތަކެއްޗާއި ފައިސާގެ ބާވަތް ބަދަލެއް ނުކުރެވޭނެ.",
      "noteHint": "މި ޢަދަދަށް ދެވުނު ގޮތް. ބަހާލުން އޮޑިޓްކުރާ ފަރާތުން މި ކިޔާނެއެވެ.",
      "residualNote": "ބަހާލުމެއްގެ ބުރަދަން ބިނާވެފައިވަނީ އޭގެ ފަހަތުގައިވާ އަމިއްލަ އަގުތަކުގެ މައްޗަށެވެ، އެހެންކަމުން ކޮންމެ ޢަދަދަކާއެކު އެ ގޮތް ރައްކާކުރެވެއެވެ.",
      "empty": "އަދި އަމިއްލަ ވަކިން ވިއްކާ އަގެއް ރައްކާކުރެވިފައެއް ނުވެއެވެ.",
      "loadFailed": "އަމިއްލަ ވަކިން ވިއްކާ އަގުތައް ނުގެނެވުނު",
      "saved": "އަމިއްލަ އަގު ރައްކާކުރެވިއްޖެ",
      "saveFailed": "އަމިއްލަ އަގު ރައްކާނުކުރެވުނު",
      "methods": {
        "observable": "ފެންނަން ހުރި",
        "adjusted_market": "އިޞްލާޙުކުރި ބާޒާރު",
        "expected_cost_plus": "ލަފާކުރާ ޚަރަދާއި މާރޖިން",
        "residual": "ބާކީ"
      }
    },
    "approval": {
      "pending": {
        "title": "ފާސްކުރާ މީހެއްގެ މަޤްބޫލުކަމަށް މިނިވަންވެފައި",
        "viewApprovals": "ފާސްކުރުމުގެ އިންބޮކްސް ހުޅުވާ",
        "body": {
          "order": "މި އޯޑަރު ފާސްކުރުމަށް މަޑުކުރެވިފައި ހުރެއެވެ. އެދި ހުށަހެޅި މީހާ ނޫން އެހެން މީހަކު ފާސްކުރުމުގެ އިންބޮކްސްގައި ނިންމަންވާނެއެވެ. ފާސްކުރުމާއެކު އޮޓޯމެޓިކުން ކަށަވަރުވާނެއެވެ.",
          "quote": "މި ކޯޓް ޑްރާފްޓްގައި ހުންނާނީ ޑިސްކައުންޓް ފާސްކުރުމާ ހަމައަށެވެ. ފާސްކުރުމާއެކު އޮޓޯމެޓިކުން ފޮނުވޭނެއެވެ.",
          "amendment": "މި އިސްލާހު ފާސްކުރާ މީހެއްގެ ނިންމުމަށް މަޑުކުރެވިފައި ހުރެއެވެ. ނިންމަންދެން އޯޑަރު ފާސްކުރުމަށް މަޑުކުރެވިފައި ހުންނާނެއެވެ."
        }
      },
      "rejected": {
        "title": "ފާސްކުރުން ބާތިލްކުރެވި، ލިޔުން އަލުން ޑްރާފްޓަށް އެނބުރުނު",
        "noteLabel": "ފާސްކުރާ މީހާގެ ނޯޓް"
      },
      "unresolvable": {
        "title": "މި އޯވަރައިޑަށް ފާސްކުރުމުގެ ޕޮލިސީއެއް ނެތް",
        "body": "އޯވަރައިޑެއް ނިންމަންޖެހެނީ ތިބާ ނޫން އެހެން ފާސްކުރާ މީހެއްގެ ފަރާތުންނެވެ. އެކަމަކު ފާސްކުރާ މީހަކު ކަނޑައެޅޭ ޕޮލިސީއެއް ނެތުމުން އެދުން ބަލައެއް ނުގަނެވުނެވެ. ކުރިއަށް ދިއުމުގެ ކުރިން ފާސްކުރުމުގެ ޕޮލިސީއެއް ކޮންފިގަރ ކުރަންޖެހެއެވެ."
      }
    }
  },
  "hr": {
    "filtersTitle": "ފިލްޓަރތައް",
    "allCompanies": "ހުރިހާ ކުންފުނިތައް",
    "routeTitles": {
      "employees": "މުވައްޒަފުން",
      "employeeNew": "އައު މުވައްޒަފު",
      "employee": "މުވައްޒަފު",
      "workPermits": "ވޯކް ޕަރމިޓްތައް",
      "leaveRequests": "ޗުއްޓީގެ އެދުންތައް",
      "leaveCalendar": "ޗުއްޓީގެ ކަލަންޑަރު",
      "leaveTypes": "ޗުއްޓީގެ ބާވަތްތައް",
      "attendance": "ހާޒިރީ",
      "overtimeRules": "އިތުރުގަޑީގެ ގަވާއިދުތައް",
      "requisitions": "ވަޒީފާގެ އެދުންތައް",
      "requisition": "އެދުން",
      "candidates": "ކެންޑިޑޭޓުން",
      "candidate": "ކެންޑިޑޭޓް",
      "offers": "ހުށަހެޅުންތައް",
      "exit": "ވަކިވުން",
      "exits": "ވަކިވުންތައް",
      "leaveBlackouts": "ޗުއްޓީގެ ސިޔާސަތުގެ ތަފްޞީލު",
      "permitQuotas": "ހުއްދައިގެ ކޯޓާތައް",
      "workPermit": "މަސައްކަތު ހުއްދަ",
      "skills": "ހުނަރުތައް"
    },
    "fields": {
      "employee": "މުވައްޒަފު",
      "company": "ކުންފުނި",
      "companyPlaceholder": "އިޚްތިޔާރުކުރޭ ކުންފުނި",
      "department": "ޑިޕާޓްމަންޓް",
      "branch": "ބްރާންޗް",
      "costCenter": "ޚަރަދު ސެންޓަރު",
      "unassigned": "ނޫން assigned",
      "manager": "Reports އަށް",
      "managerHint": "މެނޭޖަރު ނުކުރެވޭ report އަށް ކޮންމެވެސް ފަރާތެއް ކާކު މިހާރުވެސް reports އަށް މި ފަރާތް — ސާވަރު ދެކޮޅު ހަދައެވެ loop.",
      "firstName": "ފުރަތަމަ ނަން",
      "lastName": "އެންމެފަހު ނަން",
      "preferredName": "Preferred ނަން",
      "workEmail": "މަސައްކަތް އީމެއިލް",
      "emailHint": "މުވައްޒަފު ބޭނުންވެއެވެ ގައި މަދުވެގެން އެއް address — މަސައްކަތް ނުވަތަ personal.",
      "personalEmail": "Personal އީމެއިލް",
      "employmentType": "ވަޒީފާ ބާވަތް",
      "joinedOn": "ގުޅުނު މަތީގައި",
      "basicSalary": "އަސާސީ މުސާރަ",
      "basicSalaryHint": "މަހަކު އެއްފަހަރު އަދަދު މުސާރަ ބަހާލައެވެ އިން. ލިޔެފައި އަދި ރައްކާކުރެވިފައި ސީދާ ގޮތުގައި ލިޔެފައި.",
      "currency": "ފައިސާގެ ބާވަތް",
      "pensionable": "ޕެންޝަން ސްކީމް",
      "pensionableLabel": "Enrolled ގައި MPAO",
      "pensionableHint": "ކޮންއިރަކު enrolled, MPAO's މުވައްޒަފު އަދި ވަޒީފާދޭ ފަރާތް ބައިވެރިވުންތައް އީ computed މަތީގައި ބަހާލެވިފައި އަސާސީ މުސާރަ. ކޮންއިރަކު ނޫން, ދެބައި come އަށް ސީދާ nil.",
      "nationality": "ޤައުމިއްޔަތު",
      "expatriate": "ވޯކް ޕަރމިޓް",
      "expatriateLabel": "Employed މަތީގައި ވޯކް ޕަރމިޓް",
      "expatriateHint": "Marks މި ފަރާތް އަށްޓަކައި ކޮންމެ ދުވަހަކު permit-expiry ސްވީޕް.",
      "workPermitNo": "ވޯކް ޕަރމިޓް ނަންބަރު",
      "workPermitHint": "ރައްކާތެރިކުރެވިފައި މަތީގައި ރައްކާކުރޭ އަދި ފޮރުވިފައި everywhere އޭގެފަހުން.",
      "workPermitReplaceHint": "ޗުއްޓީ ހުސްކޮށް އަށް ބަހައްޓާ ނަންބަރު މަތީގައި ފައިލް. Typing އެއް ބަދަލުކުރެއެވެ އެ.",
      "workPermitExpiry": "ޕަރމިޓް މުއްދަތު ހަމަވެއެވެ",
      "workPermitOnFile": "ޕަރމިޓް މަތީގައި ފައިލް",
      "notes": "ނޯޓްތައް"
    },
    "employees": {
      "one": "މުވައްޒަފު",
      "listTitle": "މުވައްޒަފުން",
      "listDescription": "މީހުން މި ވޯކްސްޕޭސް employs, އެފަރާތްތަކުގެ contracts އަދި އެފަރާތްތަކުގެ އިދާރީ ހަވާލުކުރުން.",
      "detailDescription": "ކޮންޓްރެކްޓް, compensation, އިދާރީ ހަވާލުކުރުން އަދި ނާޒުކު ތަފްޞީލުތައް.",
      "newTitle": "އައު މުވައްޒަފު",
      "newDescription": "ބޭންކް ތަފްޞީލުތައް އަދި ޤާނޫނީ ނަންބަރުތައް އީ ނޫން set މިތާ — އެފަރާތްތައް އީ raised ގޮތުގައި ބަދަލު second ފަރާތް approves.",
      "loadFailed": "މުވައްޒަފު ލިސްޓް ކުރި ނޫން load",
      "emptyTitle": "ނެތް މުވައްޒަފުން އަދި",
      "emptyDescription": "އިތުރުކުރޭ ފުރަތަމަ ފަރާތް, ނުވަތަ ވަޒީފާ ދިނުން އެއް through އެދުން އަދި ބަދަލުކުރޭ ކެންޑިޑޭޓް.",
      "searchPlaceholder": "ހޯދާ ނަން, ނަންބަރު ނުވަތަ އީމެއިލް",
      "pickerPlaceholder": "ބާވަތް ނަންބަރު ނުވަތަ ނަން",
      "noMatch": "ނެތް މުވައްޒަފު ގުޅެއެވެ އެ",
      "matchCount": "{count} މުވައްޒަފުން match",
      "railSubtitle": "މުވައްޒަފު {employeeNo} · {status}",
      "created": "މުވައްޒަފު އިތުރުކުރެވިފައި",
      "saved": "މުވައްޒަފު ރައްކާކުރެވިއްޖެ",
      "terminated": "ވަޒީފާ ended",
      "terminatedDetail": "leaving ތާރީޚު އީ ރެކޯޑްކުރެވިފައި. މުސާރަ ބަހާލައެވެ އެންމެފަހު މުއްދަތު އިން އެ.",
      "conflictTitle": "ކޮންމެވެސް ފަރާތެއް else ބަދަލުވެފައި މި މުވައްޒަފު while ތިޔަ ފަރާތް ހުރި އެ ހުޅުވާ",
      "conflictBody": "އެއްވެސް އެއްޗެއް ވި overwritten. އަލުން ލޯޑްކުރޭ އަށް ބަލާ އެފަރާތްތަކުގެ version, އެއަށްފަހު reapply ތިޔަ ފަރާތުގެ ބަދަލުތައް.",
      "tabsLabel": "މުވައްޒަފު sections",
      "columns": {
        "employeeNo": "ނަންބަރު",
        "name": "ނަން",
        "title": "ވަޒީފާގެ ނަން",
        "department": "ޑިޕާޓްމަންޓް",
        "employmentType": "ބާވަތް",
        "basicSalary": "އަސާސީ މުސާރަ",
        "joinedOn": "ގުޅުނު",
        "workPermit": "ޕަރމިޓް",
        "workPermitExpiry": "ޕަރމިޓް މުއްދަތު ހަމަވުން"
      },
      "tabs": {
        "contract": "ކޮންޓްރެކްޓް އަދި compensation",
        "details": "ބޭންކް އަދި ޤާނޫނީ ތަފްޞީލުތައް",
        "leave": "ޗުއްޓީގެ ބާކީތައް",
        "employment": "ވަޒީފާގެ ތާރީޚު",
        "skills": "ހުނަރުތައް"
      },
      "actions": {
        "add": "އިތުރުކުރޭ މުވައްޒަފު",
        "backToList": "ހުރިހާ މުވައްޒަފުން",
        "terminate": "ނިމުން ވަޒީފާ",
        "reload": "އަލުން ލޯޑްކުރޭ މި މުވައްޒަފު"
      },
      "timeline": {
        "joined": "ގުޅުނު",
        "created": "ރެކޯޑްކުރޭ އުފެއްދިއްޖެ",
        "left": "ބާކީ"
      },
      "terminate": {
        "title": "ނިމުން މި ވަޒީފާ",
        "subject": "Ending ވަޒީފާ އަށްޓަކައި {name}",
        "consequence": "މުވައްޒަފު ހުންނާނެއެވެ މަތީގައި ފައިލް އަދި ބަހައްޓައެވެ ކޮންމެ ޕޭސްލިޕް މިހާރުވެސް އުފައްދާފައި. މުސާރަ ވާނެ prorate އެންމެފަހު މުއްދަތު އަށް leaving ތާރީޚު އަދި ވާނެ ނޫން include އެފަރާތްތަކަށް އޭގެފަހުން.",
        "leftOn": "އެންމެފަހު ދުވަސް ގެ ވަޒީފާ",
        "leftOnHint": "އެންމެފަހު ދުވަސް މަސައްކަތްކުރި, ގައި މި ވޯކްސްޕޭސް's timezone.",
        "confirm": "ނިމުން ވަޒީފާ"
      },
      "statuses": {
        "active": "ބޭނުންކުރެވޭ",
        "on_leave": "މަތީގައި ޗުއްޓީ",
        "suspended": "ސަސްޕެންޑްކޮށްފައި",
        "terminated": "ބާކީ"
      },
      "types": {
        "full_time": "Full ވަގުތު",
        "part_time": "Part ވަގުތު",
        "contract": "ކޮންޓްރެކްޓް",
        "intern": "އިންޓަރން"
      }
    },
    "sensitive": {
      "bankTitle": "މުސާރަ ބޭންކް އެކައުންޓް",
      "statutoryTitle": "ޤާނޫނީ ނަންބަރުތައް",
      "loadFailed": "pending ބަދަލުތައް ކުރި ނޫން load",
      "noPermission": "ތިޔަ ފަރާތް ކުރޭ ނޫން އެބަހުރި ހުއްދަ އަށް ބަލާ މި employee's ބޭންކް ނުވަތަ ޤާނޫނީ ތަފްޞީލުތައް.",
      "maskedExplainer": "ބޭންކް އެކައުންޓް ނަންބަރުތައް އަދި ޤާނޫނީ ނަންބަރުތައް އީ ދައްކާފައި ފޮރުވިފައި. ބެލުން ބޭންކް ނަންބަރު ގައި full އީ ވަކި action, އަދި އެ އީ ރެކޯޑްކުރެވިފައި ދެކޮޅަށް ތިޔަ ފަރާތުގެ ނަން.",
      "bankEmptyTitle": "ނެތް ބޭންކް އެކައުންޓް މަތީގައި ފައިލް",
      "bankEmptyDescription": "އެދުން އެއް މިތާ. އެއްވެސް ފަރާތެއް އީ ދައްކާފައި މެދުވެރިކޮށް transfer ވަންދެން second ފަރާތް އެބަހުރި ފާސްކުރެވިއްޖެ އެ.",
      "statutoryEmptyTitle": "ނެތް ޤާނޫނީ ނަންބަރުތައް މަތީގައި ފައިލް",
      "statutoryEmptyDescription": "ދިވެހި ރައްޔިތެއްކަމުގެ ނަންބަރު އަދި ޓެކްސް ނަންބަރު ކުރެވޭ ވުން އެދިފައި މިތާ; second ފަރާތް ބޭނުންކުރެއެވެ އެފަރާތްތަކަށް.",
      "statutoryNoReveal": "ޤާނޫނީ ނަންބަރުތައް އެބަހުރި ނެތް ދައްކާ: އެފަރާތްތައް އީ ރައްކާކުރެވިފައި ރައްކާތެރިކުރެވިފައި އަދި ހަމައެކަނި ever ދައްކާފައި ފޮރުވިފައި, including އަށް ތިޔަ ފަރާތް.",
      "historyTitle": "ނިންމިފައި ބަދަލުތައް",
      "historyExplainer": "އެދުންތައް އެ އެބަހުރި މިހާރުވެސް ވެފައި ބޭނުންކުރެވިފައި ނުވަތަ ދެކޮޅު ހަދައިފި. full ރެކޯޑްކުރޭ, އާއެކު ކާކު އަދި ކޮންއިރަކު, އީ ގައި އޮޑިޓް ރެކޯޑް.",
      "statuses": {
        "pending": "Awaiting ފާސްކުރުން",
        "approved": "ފާސްކުރެވިއްޖެ",
        "applied": "ބޭނުންކުރެވިފައި",
        "rejected": "ބޭރުކުރެވިއްޖެ"
      },
      "kinds": {
        "bank": "ބޭންކް ތަފްޞީލުތައް",
        "statutory": "ޤާނޫނީ ނަންބަރުތައް"
      },
      "fields": {
        "bankName": "ބޭންކް",
        "branch": "ބްރާންޗް",
        "accountName": "އެކައުންޓް ނަން",
        "accountNo": "އެކައުންޓް ނަންބަރު",
        "ibanLabel": "International އެކައުންޓް ނަންބަރު",
        "swiftLabel": "ބޭންކް ނަންބަރު ކޯޑް",
        "currency": "ފައިސާގެ ބާވަތް",
        "nationalId": "ދިވެހި ރައްޔިތެއްކަމުގެ ނަންބަރު",
        "taxId": "ޓެކްސް ނަންބަރު"
      },
      "actions": {
        "reveal": "ދައްކާ ނަންބަރު",
        "requestBankNew": "އެދުން ބޭންކް އެކައުންޓް",
        "requestBankChange": "އެދުން ބަދަލު",
        "requestStatutoryChange": "އެދުން ބަދަލު",
        "approveChange": "ފާސްކުރޭ މި ބަދަލު",
        "rejectChange": "ބޭރުކުރޭ"
      },
      "pending": {
        "headline": "ބަދަލު އަށް މި ތަފްޞީލުތައް އީ awaiting ފާސްކުރުން.",
        "explainer": "އެއްވެސް އެއްޗެއް އެބަހުރި ބަދަލުވެފައި އަދި: މުސާރަ އަދިވެސް pays ތެރެއަށް އެކައުންޓް ދައްކާފައި ތިރީގައި ވަންދެން ކޮންމެވެސް ފަރާތެއް އެހެން ވުރެ އެދުނު ފަރާތް approves އެ.",
        "explainerStatutory": "އެއްވެސް އެއްޗެއް އެބަހުރި ބަދަލުވެފައި އަދި: ids ތިރީގައި އީ އަދިވެސް ones މަތީގައި ފައިލް ވަންދެން ކޮންމެވެސް ފަރާތެއް އެހެން ވުރެ އެދުނު ފަރާތް approves ބަދަލު.",
        "requestedBank": "އެދިފައި: {bank}, {masked}",
        "requestedStatutory": "އެދިފައި: ދިވެހި ރައްޔިތެއްކަމުގެ ނަންބަރު {nationalId}, ޓެކްސް ނަންބަރު {taxId}",
        "reason": "ސަބަބު ދީފައި: {reason}"
      },
      "form": {
        "bankTitle": "އެދުން ބަދަލު އަށް މުސާރަ ބޭންކް އެކައުންޓް",
        "statutoryTitle": "އެދުން ބަދަލު އަށް ޤާނޫނީ ނަންބަރުތައް",
        "subject": "އަށްޓަކައި {name}",
        "dualApprovalHeadline": "މި އުފައްދައެވެ އެދުން, ނޫން ބަދަލު.",
        "dualApproval": "އެއްވެސް އެއްޗެއް about ކޮންތާކު މި ފަރާތް އީ ދައްކާފައި ބަދަލުތައް ވަންދެން ކޮންމެވެސް ފަރާތެއް އެހެން ވުރެ ތިޔަ ފަރާތް approves އެ.",
        "accountNameHint": "ނަން ބޭންކް holds އެކައުންޓް under, spelled ގޮތުގައި ބޭންކް spells އެ.",
        "accountNoHint": "ލިޔެފައި އެއްފަހަރު މިތާ, ރައްކާތެރިކުރެވިފައި ވަގުތުން, އަދި ފޮރުވިފައި everywhere އޭގެފަހުން.",
        "accountNoAgain": "އެކައުންޓް ނަންބަރު އަލުން",
        "accountNoRetype": "ބާވަތް އެ second ވަގުތު. އެތާ އީ ނެތް ރައްކާކުރެވިފައި ފޮރުވިފައި ނުވާ އަށް prefill އިން, އަދި retyping އީ ކޮންއެއްޗެއް makes ބަދަލުވެފައި އަދަދު visible.",
        "accountNoRequired": "އެކައުންޓް ނަންބަރު އީ ލާޒިމު.",
        "accountNoMismatch": "ދެ އެކައުންޓް ނަންބަރުތައް ކުރޭ ނޫން match.",
        "currencyHint": "Three-letter ISO 4217 ކޯޑް, ފަދަ ގޮތުގައި MVR.",
        "statutoryHint": "ގައި މަދުވެގެން އެއް ގެ ދިވެހި ރައްޔިތެއްކަމުގެ ނަންބަރު ނުވަތަ ޓެކްސް ނަންބަރު އީ ލާޒިމު.",
        "statutoryRequired": "ދޭ ގައި މަދުވެގެން ދިވެހި ރައްޔިތެއްކަމުގެ ނަންބަރު ނުވަތަ ޓެކްސް ނަންބަރު.",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "ބުނޭ ކާކު asked އަށްޓަކައި މި އަދި ކިހިނެއް ތިޔަ ފަރާތް ޔަޤީންކުރެވިފައި އެ. ފާސްކުރާ ފަރާތް ކިޔައެވެ މި, އަދި އެހެންކަމުން ވާނެ އޮޑިޓަރު.",
        "reasonRequired": "ސަބަބު އީ ލާޒިމު.",
        "submit": "ފޮނުވާ އަށްޓަކައި ފާސްކުރުން",
        "working": "Sending އެދުން",
        "requested": "އެދުން ފޮނުވިއްޖެ އަށްޓަކައި ފާސްކުރުން",
        "requestedDetail": "އެއްވެސް އެއްޗެއް އެބަހުރި ބަދަލުވެފައި އަދި އަށްޓަކައި {name}. second ފަރާތް އެބަހުރި އަށް ފާސްކުރޭ އެ ފުރަތަމަ."
      },
      "reveal": {
        "title": "ދައްކާ އެކައުންޓް ނަންބަރު",
        "subject": "{name}, އެކައުންޓް {masked}",
        "recorded": "މި ވާނެ ވުން ރެކޯޑްކުރެވިފައި ގައި އޮޑިޓް ލޮގް under ތިޔަ ފަރާތުގެ ނަން, {name}, together އާއެކު ސަބަބު ތިޔަ ފަރާތް ދޭ ތިރީގައި.",
        "reasonLabel": "ކީއްވެ ކުރޭ ތިޔަ ފަރާތް ބޭނުންވޭ އަށް ބަލާ މި ނަންބަރު?",
        "reasonHint": "މިސާލަކަށް: ބޭންކް ބޭރުކުރެވިއްޖެ މުސާރަ transfer އަދި އަދަދުތައް ބޭނުންވޭ ބެލުން. އޮޑިޓަރު ވާނެ ކިޔާ މި.",
        "reasonRequired": "ސަބަބު އީ ލާޒިމު ކުރިން ނަންބަރު ކުރެވޭ ވުން ދައްކާފައި.",
        "confirm": "ދައްކާ އެ",
        "working": "ދައްކަނީ",
        "countdown": "މި disappears ގައި {seconds} ސިކުންތު. އެ އީ ނޫން copied ނުވަތަ ރައްކާކުރެވިފައި anywhere.",
        "hideNow": "ފޮރުވާ އެ މިހާރު",
        "done": "ނިމިއްޖެ"
      },
      "decide": {
        "approveTitle": "ފާސްކުރޭ މި ބަދަލު",
        "rejectTitle": "ބޭރުކުރޭ މި ބަދަލު",
        "subject": "pending ބަދަލު އަށްޓަކައި {name}",
        "approveConsequence": "ފާސްކުރުން ބޭނުންކުރެއެވެ އައު ތަފްޞީލުތައް ވަގުތުން. އިން މި moment މުވައްޒަފު އީ ދައްކާފައި ތެރެއަށް އެދިފައި އެކައުންޓް.",
        "rejectConsequence": "ބޭރުކުރުން ބާއްވައެވެ މިހާރުގެ ތަފްޞީލުތައް ގައި place. އެދުނު ފަރާތް އީ އަންގައިފި, އަދި ސަބަބު އީ ރެކޯޑްކުރެވިފައި.",
        "commentLabel": "ކޮމެންޓް",
        "commentHint": "އެދުނު ފަރާތް sees މި, އަދި އެ ހުންނާނެއެވެ މަތީގައި އޮޑިޓް ރެކޯޑް.",
        "notYours": "ތިޔަ ފަރާތް raised މި އެދުން, އެހެންކަމުން ކޮންމެވެސް ފަރާތެއް else އެބަހުރި އަށް ފާސްކުރޭ އެ.",
        "working": "ރެކޯޑްކުރުން ނިންމުން",
        "approved": "ބަދަލު ފާސްކުރެވިއްޖެ",
        "approvedDetail": "އައު ތަފްޞީލުތައް އީ ގައި effect.",
        "rejected": "ބަދަލު ބޭރުކުރެވިއްޖެ",
        "rejectedDetail": "ތަފްޞީލުތައް މަތީގައި ފައިލް އީ unchanged."
      },
      "stepUp": {
        "required": "ޔަޤީންކުރޭ ތިޔަ ފަރާތުގެ ދެވަނަ ފެކްޓަރ އަލުން ކުރިން މި އީ allowed, އެއަށްފަހު try އެއްފަހަރު އިތުރު.",
        "notEnrolled": "މި action ބޭނުންވެއެވެ ޓޫ-ފެކްޓަރ އޮތެންޓިކޭޝަން, އަދި ތިޔަ ފަރާތުގެ އެކައުންޓް އެބަހުރި އެއްވެސް އެއްޗެއް ނެތް enrolled އަދި.",
        "link": "Set އެ މައްޗަށް މަތީގައި ތިޔަ ފަރާތުގެ ޕްރޮފައިލް"
      }
    },
    "permits": {
      "listTitle": "ވޯކް ޕަރމިޓްތައް",
      "listDescription": "ކޮންމެ ޕަރމިޓް approaching ނުވަތަ past އޭގެ މުއްދަތު ހަމަވުން, worst ފުރަތަމަ.",
      "loadFailed": "ޕަރމިޓް ލިސްޓް ކުރި ނޫން load",
      "emptyTitle": "ނެތް ޕަރމިޓްތައް އަށް watch",
      "emptyDescription": "އެއްވެސް ފަރާތެއް މަތީގައި ފައިލް އެބަހުރި work-permit މުއްދަތު ހަމަވުން ރެކޯޑްކުރެވިފައި. އިތުރުކުރޭ އެއް މަތީގައި employee's ކޮންޓްރެކްޓް tab.",
      "noneOnFile": "ނެތް މުއްދަތު ހަމަވުން ރެކޯޑްކުރެވިފައި",
      "thresholdsExplainer": "ކޮންމެ ދުވަހަކު ޖޮބް alerts ގައި {thresholds} ދުވަސް ކުރިން މުއްދަތު ހަމަވުން, އަދި އަލުން އެއްފަހަރު ޕަރމިޓް އެބަހުރި މުއްދަތު ފަހަނައަޅާފައި. މި ސްކްރީން buckets މެދުވެރިކޮށް އެއް ދުވަސް, އެހެންކަމުން ކޮންއެއްޗެއް އީ އަވަސް މިތާ އީ ކޮންއެއްޗެއް ކޮންމެވެސް ފަރާތެއް އެބަހުރި މިހާރުވެސް ވެފައި އަންގައިފި about.",
      "bannerExpired": "މި ވޯކް ޕަރމިޓް މުއްދަތު ފަހަނައަޅާފައި {days} ދުވަސް ago.",
      "bannerCritical": "މި ވޯކް ޕަރމިޓް މުއްދަތު ހަމަވެއެވެ ގައި {days} ދުވަސް.",
      "columns": {
        "status": "ވަގުތު ބާކީ",
        "daysLeft": "ދުވަސް ބާކީ",
        "expiresOn": "ހަމަވާ ތާރީޚު",
        "kind": "ހުއްދައިގެ ބާވަތް",
        "medical": "ބޭސްފަރުވާގެ ހުއްދަ",
        "permitNo": "ހުއްދަ ނަންބަރު",
        "quotaCategory": "ކޯޓާގެ ބާވަތް"
      },
      "urgency": {
        "expired": "މުއްދަތު ފަހަނައަޅާފައި {days} ދުވަސް ago",
        "critical": "{days} ދުވަސް ބާކީ",
        "soon": "{days} ދުވަސް ބާކީ",
        "watch": "{days} ދުވަސް ބާކީ",
        "ok": "{days} ދުވަސް ބާކީ",
        "none": "ނެތް މުއްދަތު ހަމަވުން ރެކޯޑްކުރެވިފައި"
      },
      "kpi": {
        "expired": "މުއްދަތު ފަހަނައަޅާފައި",
        "expiredHelp": "ޕަރމިޓްތައް ކާކުގެ މުއްދަތު ހަމަވުން ތާރީޚު އެބަހުރި މިހާރުވެސް passed.",
        "critical": "ތެރޭގައި ހަފުތާ",
        "criticalHelp": "ޕަރމިޓްތައް expiring ތެރޭގައި seven ދުވަސް — sweep's loudest ބޭންޑް.",
        "soon": "ތެރޭގައި މަސް",
        "soonHelp": "ޕަރމިޓްތައް expiring ތެރޭގައި thirty ދުވަސް.",
        "medicalLapsed": "ބޭސްފަރުވާ ހަމަވެފައި",
        "medicalLapsedHelp": "ބޭސްފަރުވާގެ ހުއްދަ ހަމަވެފައިވާ ދިރިހުރި ހުއްދައަކުން މަސައްކަތްކުރުމުގެ ހުއްދައެއް ނުދެއެވެ."
      },
      "actions": {
        "activate": "ހަރަކާތްތެރިކުރޭ",
        "cancelPermit": "ހުއްދަ ކެންސަލްކުރޭ",
        "new": "އައު ހުއްދަ",
        "recordMedical": "ބޭސްފަރުވާގެ ހުއްދަ ރެކޯޑްކުރޭ",
        "reveal": "ހުއްދައިގެ ނަންބަރު ދައްކާ"
      },
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "create": {
        "description": "ކޯޓާގެ ހުދޫދު ފަހަނައަޅާ ހުއްދައެއް ބަލައެއް ނުގަނެވޭނެއެވެ.",
        "title": "އައު މަސައްކަތު ހުއްދަ"
      },
      "created": "ހުއްދަ އުފެއްދިއްޖެ",
      "detailDescription": "ހުއްދައާއި، އެ ބޭނުންކުރާ ކޯޓާއާއި، ބޭސްފަރުވާގެ ހުއްދައެވެ.",
      "detailTitle": "މަސައްކަތު ހުއްދަ",
      "expiringBefore": "ކުރިން ހަމަވާ",
      "fields": {
        "employeeId": "މުވައްޒަފުގެ އައިޑީ",
        "issuedOn": "ދޫކުރެވުނު ތާރީޚު",
        "jurisdictionId": "ޖުރިސްޑިކްޝަން އައިޑީ",
        "permitNo": "ހުއްދައިގެ ނަންބަރު",
        "permitNoHint": "ރައްކާކުރެވެނީ އެންކްރިޕްޓްކޮށެވެ. ކޮންމެ ޖަވާބަކާއި ލޮގެއްގައި އޮންނާނީ ހަމައެކަނި މާސްކެވެ.",
        "quotaHint": "ހުހަށް ބެހެއްޓުމުން ކޯޓާއެއް ބޭނުމެއް ނުކުރެއެވެ.",
        "sponsor": "ސްޕޮންސަރ"
      },
      "medical": {
        "clearedOn": "ހުއްދަ ދެވުނު ތާރީޚު",
        "description": "ދެ ތާރީޚެއް: ހުއްދަ ދެވުނު ތާރީޚާއި ހުއްދަ ހަމަވާ ތާރީޚެވެ.",
        "expiresOn": "ހުއްދަ ހަމަވާ ތާރީޚު",
        "lapsedExplainer": "މި ހުއްދައިގެ ބޭސްފަރުވާގެ ހުއްދަ ހަމަވެއްޖެއެވެ. އައުނުކުރެވެނީސް މި މީހާގެ ވަޒީފާގެ ޝަރުޠުތަކާއި ރޯސްޓަރ ސަފުހާތައް ބަލައެއް ނުގަނެވޭނެއެވެ.",
        "recorded": "ބޭސްފަރުވާގެ ހުއްދަ ރެކޯޑްކުރެވިއްޖެ",
        "reference": "ރިފަރެންސް",
        "title": "ބޭސްފަރުވާގެ ހުއްދަ ރެކޯޑްކުރޭ"
      },
      "medicalLapsed": "ބޭސްފަރުވާގެ ހުއްދަ ހަމަވެފައި",
      "noQuota": "ކޯޓާއެއް ނެތް",
      "quota": {
        "actions": {
          "new": "އައު ކޯޓާ"
        },
        "available": "ބާކީ",
        "cap": "ހުދޫދު",
        "consumed": "ބޭނުންކުރެވިފައި",
        "create": {
          "description": "އައު ހުދޫދަކުން ފެށޭ ތާރީޚުން ފެށިގެން ކުރީގެ ހުދޫދު ބަދަލުކުރެއެވެ؛ ކުރީގެ ހުދޫދުގެ ދަށުން ދޫކުރެވުނު ހުއްދަތައް ޤާނޫނީކޮށް ދެމިހުރެއެވެ.",
          "title": "އައު ހުއްދައިގެ ކޯޓާ"
        },
        "description": "މި ބާވަތުން މިހާރު ބޭނުންކުރެވިފައިވާ މިންވަރެވެ.",
        "edit": {
          "title": "ހުއްދައިގެ ކޯޓާ އެޑިޓްކުރޭ"
        },
        "emptyDescription": "ކޯޓާއެއް ނެތްނަމަ އެއްވެސް ހުދޫދެއް ނެތެވެ. ރެގިއުލޭޓަރު ކަނޑައަޅާ ކޮންމެ ބާވަތަކަށް އެއް ކޯޓާ އިތުރުކުރާށެވެ.",
        "emptyTitle": "ކޯޓާއެއް ކަނޑައެޅިފައެއް ނެތެވެ",
        "explainer": "ކޯޓާގެ ހުދޫދު ފަހަނައަޅާ ހުއްދައެއް ސީދާ ބަލައެއް ނުގަނެވޭނެއެވެ — އެއްވެސް މީހަކަށް އިސްތިސްނާއެއް ނެތެވެ.",
        "full": "މި ބާވަތް ފުރިއްޖެއެވެ. މީގައި ދެން އަންނަ ހުއްދަ ބަލައެއް ނުގަނެވޭނެއެވެ.",
        "loadFailed": "ކޯޓާތައް ލޯޑެއް ނުކުރެވުނެވެ",
        "packReadOnly": "ޕެކަކުން",
        "pageDescription": "ކޮންމެ ބާވަތަކަށް، ކުންފުންޏަކަށް، ޖުރިސްޑިކްޝަނަކަށް ހުދޫދެވެ — ޤަވާޢިދުން ހުދޫދު މުރާޖަޢާކުރެވޭތީ ތާރީޚަކުން ފެށޭ ގޮތަށެވެ.",
        "pageTitle": "ހުއްދައިގެ ކޯޓާތައް",
        "saved": "ކޯޓާ ރައްކާކުރެވިއްޖެ",
        "source": "މަޞްދަރު",
        "sources": {
          "pack": "ޕެކް",
          "tenant": "އަމިއްލަ ކޮންޓްރޯލް"
        },
        "title": "ކޯޓާ"
      },
      "quotasLink": "ކޯޓާތައް",
      "reveal": {
        "auditNote": "މިއިން ތިޔަ ފަރާތާއި ސަބަބު ބަޔާންކުރާ އޮޑިޓް ރެކޯޑެއް ލިޔެވެއެވެ.",
        "description": "ސާފު ލިޔުން ދެއްކެނީ އެއްފަހަރު، އަދި ދުވަހަކުވެސް ކެޝްއެއް ނުކުރެވެއެވެ.",
        "reasonHint": "އޮޑިޓަރަކު ތިޔަ ފަރާތުގެ ނަމާއެކު މި ކިޔާނެއެވެ.",
        "reasonLabel": "ބޭނުންވާ ސަބަބު",
        "stepUp": "ނަންބަރު ދެއްކުމުގެ ކުރިން އައު ދެވަނަ ފެކްޓަރެއް ބޭނުންވެއެވެ.",
        "temporary": "އެއްފަހަރު ދެއްކެއެވެ. ފޮހެލުމަށް މި ބަންދުކުރާށެވެ.",
        "title": "ހުއްދައިގެ ނަންބަރު ދައްކާ"
      },
      "status": {
        "confirm": "ހުއްދަ {status} އަށް ބަދަލުކުރަންވީތޯ؟",
        "description": "ހާލަތުން ކަނޑައަޅަނީ މި ހުއްދައިން މަސައްކަތްކުރުމުގެ ހުއްދަ ދޭތޯއެވެ.",
        "title": "ހުއްދައިގެ ހާލަތު ބަދަލުކުރޭ"
      },
      "statusChanged": "ހުއްދައިގެ ހާލަތު ބަދަލުވެއްޖެ",
      "statuses": {
        "active": "ހަރަކާތްތެރި",
        "cancelled": "ކެންސަލްކޮށްފައި",
        "expired": "ހަމަވެފައި",
        "pending": "އިންތިޒާރުގައި",
        "rejected": "ބޭރުކޮށްފައި"
      },
      "companyScopeHint": "މިއިން ބަދަލުވަނީ ދައްކާ މުވައްޒަފުންގެ ނަންތައް އެކަނިއެވެ، ރަޖިސްޓަރީއެއް ނޫނެވެ."
    },
    "leave": {
      "listTitle": "ޗުއްޓީގެ އެދުންތައް",
      "listDescription": "ކާކު އެބަހުރި asked އަށްޓަކައި ވަގުތު ނިއްވާލާފައި, ކޮންއެއްޗެއް އެ ޚަރަދުތައް އެފަރާތްތަކުގެ ބާކީ, އަދި ކޮންއެއްޗެއް ވި ނިންމިފައި.",
      "loadFailed": "ޗުއްޓީ ލިސްޓް ކުރި ނޫން load",
      "emptyTitle": "ނެތް ޗުއްޓީގެ އެދުންތައް އަދި",
      "emptyDescription": "Raise އެއް އަށްޓަކައި މުވައްޒަފު, ނުވަތަ wait އަށްޓަކައި theirs އަށް arrive މިތާ.",
      "calendarTitle": "ޗުއްޓީގެ ކަލަންޑަރު",
      "calendarDescription": "ކާކު އީ ޗުއްޓީގައި, އަދި ކޮންއިރަކު. ފާސްކުރެވިއްޖެ އަދި ހުށަހަޅާފައި ޗުއްޓީ ހަމައެކަނި.",
      "balancesDescription": "ކްރެޑިޓްކުރެވިފައި މެދުވެރިކޮށް މަހަކު އެއްފަހަރު ޖަމާވުން ޖޮބް އަދި reduced ކޮންއިރަކު ޗުއްޓީ އީ ފާސްކުރެވިއްޖެ.",
      "noBalancesTitle": "ނެތް ބާކީތައް އަދި",
      "noBalancesDescription": "ބާކީތައް ފެންނާނެ އެއްފަހަރު ޖަމާވުން ޖޮބް އެބަހުރި ކްރެޑިޓްކުރެވިފައި މަސް, ނުވަތަ ޗުއްޓީގެ ބާވަތް އެބަހުރި ވެފައި set މައްޗަށް.",
      "viewRequests": "ބަލާ މި employee's ޗުއްޓީގެ އެދުންތައް",
      "days": "ދުވަސް",
      "paid": "ދައްކާފައި",
      "unpaid": "މުސާރަ ނުލިބޭ",
      "cancelled": "ޗުއްޓީގެ އެދުން ކެންސަލްކުރެވިއްޖެ",
      "columns": {
        "requestNo": "އެދުން",
        "type": "ބާވަތް",
        "from": "އިން",
        "to": "އަށް",
        "days": "ދުވަސް",
        "paid": "ދައްކާފައި"
      },
      "fields": {
        "type": "ޗުއްޓީގެ ބާވަތް",
        "typePlaceholder": "އިޚްތިޔާރުކުރޭ ޗުއްޓީގެ ބާވަތް",
        "balance": "ބާކީ މިހާރު",
        "startDate": "ފުރަތަމަ ދުވަސް ޗުއްޓީގައި",
        "endDate": "އެންމެފަހު ދުވަސް ޗުއްޓީގައި",
        "unpaid": "މުސާރަ ނުލިބޭ ޗުއްޓީ",
        "unpaidLabel": "ނަގާ މި ގޮތުގައި މުސާރަ ނުލިބޭ ޗުއްޓީ",
        "unpaidHint": "މުސާރަ ނުލިބޭ ދުވަސް ކުޑަކުރޭ މުސާރަ ލިބޭ ދުވަސް މުސާރަ ބަހާލައެވެ މުއްދަތު މެދުވެރިކޮށް.",
        "reason": "ސަބަބު"
      },
      "actions": {
        "request": "އެދުން ޗުއްޓީ",
        "cancel": "ކެންސަލްކުރޭ"
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "Awaiting ނިންމުން",
        "approved": "ފާސްކުރެވިއްޖެ",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "cancelled": "ކެންސަލްކުރެވިއްޖެ"
      },
      "form": {
        "title": "އެދުން ޗުއްޓީ",
        "description": "ދުވަސް އީ ގުނާފައި way ބާކީ އީ ޗާޖްކުރެވިފައި: ކަލަންޑަރު ދުވަސް, ދެބައި ނިމެއެވެ included.",
        "daysCount": "{days} ކަލަންޑަރު ދުވަސް",
        "daysUnknown": "އިޚްތިޔާރުކުރޭ ފެށުން އަދި ނިމުން ތާރީޚު",
        "calendarDaysExplainer": "ހަފުތާ ބަންދުތައް އަދި public ބަންދު ދުވަސްތައް އީ ގުނާފައި: މި ވޯކްސްޕޭސް އެބަހުރި ނެތް ބަންދު ދުވަސް calendar, އެހެންކަމުން އެދުން spanning ހަފުތާ ބަންދު ޚަރަދުތައް އިތުރު ދުވަސް ވުރެ hand count ވާނެ.",
        "rangeInvalid": "އެންމެފަހު ދުވަސް ނުކުރެވޭ ވުން ކުރިން ފުރަތަމަ.",
        "employeeRequired": "އިޚްތިޔާރުކުރޭ މުވައްޒަފު.",
        "typeRequired": "އިޚްތިޔާރުކުރޭ ޗުއްޓީގެ ބާވަތް.",
        "typeUnpaidHint": "{name} އީ މުސާރަ ނުލިބޭ ޗުއްޓީ ބާވަތް — މި ދުވަސް ކުޑަކުރޭ މުސާރަ ލިބޭ ދުވަސް މުސާރަ ބަހާލައެވެ މެދުވެރިކޮށް.",
        "reasonHint": "Whoever ނިންމައެވެ މި ކިޔައެވެ އެ.",
        "submit": "ހުށަހަޅާ އެދުން",
        "created": "ޗުއްޓީ އެދިފައި",
        "createdDetail": "{requestNo} އަށްޓަކައި {days} ދުވަސް އީ awaiting ނިންމުން."
      },
      "decide": {
        "approveTitle": "ފާސްކުރޭ މި ޗުއްޓީ",
        "rejectTitle": "ބޭރުކުރޭ މި ޗުއްޓީ",
        "subject": "{requestNo} — {name}, {days} ދުވަސް",
        "approveConsequence": "ފާސްކުރުން ޗާޖްކުރެއެވެ ދުވަސް ދެކޮޅަށް employee's ބާކީ އަދި marks އެފަރާތްތަކަށް ޗުއްޓީގައި މަތީގައި calendar.",
        "rejectConsequence": "ބޭރުކުރުން ބާއްވައެވެ ބާކީ untouched. އެދުނު ފަރާތް sees ތިޔަ ފަރާތުގެ ސަބަބު.",
        "commentLabel": "ކޮމެންޓް",
        "commentHint": "އެދުނު ފަރާތް sees މި އަދި އެ ހުންނާނެއެވެ މަތީގައި އޮޑިޓް ރެކޯޑް.",
        "commentRequired": "ބުނޭ ކީއްވެ މި އީ being ބޭރުކުރެވިއްޖެ.",
        "approved": "ޗުއްޓީ ފާސްކުރެވިއްޖެ",
        "rejected": "ޗުއްޓީ ބޭރުކުރެވިއްޖެ"
      },
      "cancelDialog": {
        "title": "ކެންސަލްކުރޭ މި ޗުއްޓީގެ އެދުން",
        "consequence": "ކެންސަލްކުރުން އަނބުރާ ދެއެވެ ދުވަސް އަށް ބާކީ. އެދުން އެ އެބަހުރި މިހާރުވެސް ފެށިފައި ނުކުރެވޭ ވުން ކެންސަލްކުރެވިއްޖެ.",
        "confirm": "ކެންސަލްކުރޭ އެދުން"
      },
      "calendar": {
        "previousMonth": "ކުރީގެ މަސް",
        "nextMonth": "ދެން މަސް",
        "today": "މި މަސް",
        "inMonth": "{count} ގައި މި މަސް",
        "scopeExplainer": "ފާސްކުރެވިއްޖެ އަދި ހުށަހަޅާފައި ޗުއްޓީ ހަމައެކަނި. ބޭރުކުރެވިއްޖެ ނުވަތަ ކެންސަލްކުރެވިއްޖެ އެދުން އީ ނޫން ޣައިރު ހާޒިރީ އަދި އީ ނޫން drawn މިތާ.",
        "entryTitle": "{name} މަތީގައި ޗުއްޓީ — {type} ({status})",
        "weekdays": {
          "mon": "ހޯމަ",
          "tue": "އަންގާރަ",
          "wed": "ބުދަ",
          "thu": "ބުރާސްފަތި",
          "fri": "ހުކުރު",
          "sat": "ހޮނިހިރު",
          "sun": "އާދިއްތަ"
        }
      }
    },
    "leaveTypes": {
      "listTitle": "ޗުއްޓީގެ ބާވަތްތައް",
      "listDescription": "kinds ގެ ޗުއްޓީ މި ވޯކްސްޕޭސް grants, އަދި ކިހިނެއް much ގެ ކޮންމެ ޖަމާވެއެވެ per މަސް.",
      "loadFailed": "ޗުއްޓީގެ ބާވަތްތައް ކުރި ނޫން load",
      "emptyTitle": "ނެތް ޗުއްޓީގެ ބާވަތްތައް އަދި",
      "emptyDescription": "އިތުރުކުރޭ އެއް — annual ޗުއްޓީ އީ ޢާންމުކޮށް ފުރަތަމަ — އަދި މަހަކު އެއްފަހަރު ޖަމާވުން ވާނެ ފެށުން crediting އެ.",
      "saved": "ޗުއްޓީގެ ބާވަތް ރައްކާކުރެވިއްޖެ",
      "active": "ބޭނުންކުރެވޭ",
      "inactive": "ހުއްޓާލާފައި",
      "approvalRequired": "ބޭނުންވެއެވެ ފާސްކުރުން",
      "approvalNotRequired": "އޮޓޮމެޓިކް",
      "columns": {
        "code": "ކޯޑް",
        "accrual": "ދުވަސް ޖަމާވެފައި per މަސް",
        "maxBalance": "އެންމެ ގިނަވެގެން ބާކީ",
        "paid": "ދައްކާފައި",
        "approval": "ފާސްކުރުން"
      },
      "actions": {
        "add": "އިތުރުކުރޭ ޗުއްޓީގެ ބާވަތް",
        "runAccrual": "ހިންގާ ޖަމާވުން މިހާރު"
      },
      "form": {
        "createTitle": "އިތުރުކުރޭ ޗުއްޓީގެ ބާވަތް",
        "editTitle": "އެޑިޓްކުރޭ މި ޗުއްޓީގެ ބާވަތް",
        "description": "ޖަމާވުން އަދަދުތައް އީ ޑެސިމަލްތައް — 1.75 ދުވަސް މަސް އީ ޢާންމު ސިޔާސަތު.",
        "codeHint": "ކުރު އަދި ދާއިމީ, ފަދަ ގޮތުގައި ANNUAL. އެ ނުކުރެވޭ ވުން ބަދަލުވެފައި ފަހުން.",
        "accrualHint": "ކްރެޑިޓްކުރެވިފައި މެދުވެރިކޮށް މަހަކު އެއްފަހަރު ޖޮބް އަށް ކޮންމެ މުވައްޒަފު ބޭނުންކުރެވޭ during މަސް.",
        "maxBalanceHint": "ޗުއްޓީ ހުސްކޮށް އަށްޓަކައި ނެތް ޙައްދު.",
        "isPaid": "ދައްކާފައި ޗުއްޓީ",
        "isPaidHint": "މުސާރަ ނުލިބޭ ބާވަތްތައް ކުޑަކުރޭ މުސާރަ ލިބޭ ދުވަސް މުސާރަ ބަހާލައެވެ މުއްދަތު މެދުވެރިކޮށް.",
        "requiresApproval": "Requires ފާސްކުރުން",
        "requiresApprovalHint": "ކޮންއިރަކު ނިއްވާލާފައި, އެދުން ގެ މި ބާވަތް އީ granted ގޮތުގައި soon ގޮތުގައި އެ އީ raised.",
        "isActive": "ލިބެން ހުރި އަށްޓަކައި އައު އެދުންތައް",
        "isActiveHint": "Retiring ބާވަތް ބަހައްޓައެވެ މިހާރު ހުރި ބާކީތައް އަދި ހުއްޓާލައެވެ އައު އެދުންތައް ދެކޮޅަށް އެ."
      },
      "accrual": {
        "title": "ހިންގާ މަހަކު އެއްފަހަރު ޗުއްޓީ ޖަމާވުން",
        "description": "އެއް ޖޮބް ވޯކަރު ރަންތައް ކޮންމެ ރެއަކު, fired މިހާރު ދެކޮޅަށް ތާރީޚު ތިޔަ ފަރާތް އިޚްތިޔާރުކުރޭ.",
        "safeHeadline": "ހިންގުން މި ދެފަހަރު އީ ރައްކާތެރި.",
        "safeExplainer": "ގައި އެންމެ ގިނަ އެއް ކްރެޑިޓް exists per މުވައްޒަފު, ޗުއްޓީގެ ބާވަތް އަދި calendar މަސް, އަދި ޑޭޓާބޭސް ހުރަސް އީ ކޮންއެއްޗެއް guarantees އެ — ނޫން މި ސްކްރީން. second ހިންގާ reports ހުރިހާ އެއްޗެއް އެ ދޫކޮށްލެވިއްޖެ.",
        "onLabel": "ހިންގާ ގޮތުގައި ގެ",
        "onHint": "ޖަމާވުން ކްރެޑިޓްކުރޭ calendar މަސް މި ތާރީޚު falls ގައި.",
        "confirm": "ހިންގާ ޖަމާވުން",
        "working": "ހިންގުން",
        "resultTitle": "ޖަމާވުން އަށްޓަކައި {month}/{year}",
        "resultBody": "{processed} މުވައްޒަފުން ކްރެޑިޓްކުރެވިފައި, {skipped} ދޫކޮށްލެވިއްޖެ ސަބަބަކީ މަސް ވި މިހާރުވެސް ކްރެޑިޓްކުރެވިފައި."
      },
      "classes": {
        "annual": "އަހަރީ",
        "compassionate": "ހަމްދަރުދީގެ",
        "hajj": "ޙައްޖު",
        "maternity": "ވިހެއުން",
        "other": "އެހެނިހެން",
        "paternity": "ބައްޕަގެ ޗުއްޓީ",
        "sick": "ބަލި",
        "study": "ކިޔެވުން",
        "unpaid": "މުސާރަ ނުލިބޭ"
      },
      "coverage": {
        "block": "ބަލައިނުގަނޭ",
        "none": "ބެލުމެއް ނެތް",
        "warn": "އިންޒާރު"
      },
      "dayBasis": {
        "calendar": "ކަލަންޑަރު ދުވަސް",
        "working": "މަސައްކަތު ދުވަސް"
      },
      "depth": {
        "carryForward": "ކެރީ ފޯވާޑަށް ހުއްދަ ދޭ",
        "carryForwardExpiry": "ގެންދެވުނު ދުވަސްތައް ހަމަވަނީ (މަސް)",
        "carryForwardExpiryHint": "ދުވަހަކުވެސް ހަމަނުވާ ދުވަސްތަކަށް ހުހަށް ބާއްވާށެވެ.",
        "carryForwardHint": "ބޭނުންނުކުރެވޭ ދުވަސްތައް ޖެހިގެން އަންނަ ޗުއްޓީގެ އަހަރަށް ބަދަލުވެއެވެ.",
        "carryForwardMaxDays": "ގެންދެވޭ އެންމެ ގިނަ ދުވަސް",
        "certificateAfterDays": "ސެޓްފިކެޓް ބޭނުންވަނީ މީގެ ފަހުން",
        "certificateHint": "ބޭސްފަރުވާގެ ސެޓްފިކެޓެއް ހުށަހަޅަން ޖެހޭ ދުވަހުގެ ޢަދަދެވެ.",
        "coverageCheck": "ކަވަރޭޖު ބެލުން",
        "coverageHint": "ޑިޕާޓްމަންޓެއް މަދުވާ އެދުމަކަށް އިންޒާރު ދޭންވީތޯ ނުވަތަ ބަލައިނުގަންނަންވީތޯއެވެ.",
        "dayBasis": "ދުވަސް ގުނާ ގޮތް",
        "dayBasisExistingHint": "މި ބަދަލުކުރުމުން ކުރިއަށް އޮތް ކޮންމެ އެދުމެއް ގުނާ ގޮތް ބަދަލުވެއެވެ. މިހާރު ހުރި ބާކީތައް އަލުން ނުލިޔެވެއެވެ.",
        "dayBasisNewHint": "މަސައްކަތު ދުވަސްތަކުން ކަލަންޑަރުގެ މަސައްކަތްނުކުރާ ދުވަސްތަކާއި ބަންދު ދުވަސްތައް ނުހިމެނެއެވެ.",
        "encashable": "ފައިސާއަށް ބަދަލުކުރުމަށް ހުއްދަ ދޭ",
        "encashableHint": "މުސާރައިގެ ބައެއްގެ ތެރެއިން ދުވަސްތައް ފައިސާއަށް ބަދަލުކުރެވިދާނެއެވެ.",
        "encashmentComponent": "މުސާރައިގެ ބައިގެ ކޯޑު",
        "encashmentComponentHint": "ފައިސާއަށް ބަދަލުކުރުން ދެވޭ ބައެވެ. ފައިސާއަށް ބަދަލުކުރުމަށް ހުއްދަ ދީފައިވާނަމަ ލާޒިމެވެ.",
        "encashmentMaxDays": "ފައިސާއަށް ބަދަލުކުރެވޭ އެންމެ ގިނަ ދުވަސް",
        "leaveClass": "ޗުއްޓީގެ ގިންތި",
        "leaveClassHint": "ޖުރިސްޑިކްޝަން ޕެކުން ޤާނޫނީ އެންމެ މަދު މިންވަރު ދިމާކުރުމަށް ބޭނުންކުރެއެވެ.",
        "maxDaysPerInstance": "އެއް އެދުމަކަށް އެންމެ ގިނަ ދުވަސް",
        "qualifyingMonths": "ޤާބިލުވާ މަސްތައް",
        "qualifyingMonthsHint": "މި ޗުއްޓީ ނެގޭނެ ކުރިން ޚިދުމަތުގައި ހޭދަކުރަންޖެހޭ މަސްތަކެވެ.",
        "statutoryFloor": "ޤާނޫނީ އެންމެ މަދު މިންވަރު: އަހަރަކު {days} ދުވަސް",
        "statutoryFloorHint": "ޖުރިސްޑިކްޝަން ޕެކުންނެވެ. މި ބާވަތުން މިއަށްވުރެ އިތުރުކުރެވިދާނެ، ނަމަވެސް މަދެއް ނުކުރެވޭނެއެވެ.",
        "title": "ސިޔާސަތުގެ ތަފްޞީލު"
      }
    },
    "attendance": {
      "listTitle": "ހާޒިރީ",
      "listDescription": "ގަޑިއިރު މަސައްކަތްކުރި, އަދި އިތުރުގަޑި މުސާރަ ވާނެ price އިން އެފަރާތްތަކަށް.",
      "loadFailed": "ހާޒިރީ ލިސްޓް ކުރި ނޫން load",
      "emptyTitle": "ނެތް ހާޒިރީ ރެކޯޑްކުރެވިފައި",
      "emptyDescription": "Log ދުވަސް, ނުވަތަ އިމްޕޯޓްކުރޭ މަސް އިން ތިޔަ ފަރާތުގެ ވަގުތު ސިސްޓަމް ގޮތުގައި CSV.",
      "approved": "ފާސްކުރެވިއްޖެ",
      "notApproved": "ނޫން ފާސްކުރެވިއްޖެ",
      "approvedToast": "ހާޒިރީ ފާސްކުރެވިއްޖެ",
      "saved": "ހާޒިރީ ރައްކާކުރެވިއްޖެ",
      "columns": {
        "workDate": "ތާރީޚު",
        "hours": "ގަޑިއިރު",
        "overtime": "އިތުރުގަޑި",
        "rule": "ގަވާއިދު",
        "source": "އަސްލު"
      },
      "sources": {
        "manual": "އެތެރެކުރެވިފައި",
        "import": "އިމްޕޯޓްކުރެވިއްޖެ"
      },
      "fields": {
        "from": "އިން",
        "to": "އަށް",
        "approvedOnly": "ފާސްކުރުން"
      },
      "actions": {
        "log": "Log ދުވަސް",
        "import": "އިމްޕޯޓްކުރޭ CSV"
      },
      "form": {
        "logTitle": "Log day's ހާޒިރީ",
        "editTitle": "އެޑިޓްކުރޭ މި day's ގަޑިއިރު",
        "description": "އެތެރެކުރޭ ގަޑިއިރު މަސައްކަތްކުރި. އިތުރުގަޑި އީ މަސައްކަތްކުރި ބޭރަށް މެދުވެރިކޮށް ސާވަރު ދެކޮޅަށް ގުޅޭ ގަވާއިދު.",
        "hoursHint": "ޑެސިމަލް ގަޑިއިރު, ފަދަ ގޮތުގައި 8 ނުވަތަ 9.5.",
        "employeeRequired": "އިޚްތިޔާރުކުރޭ މުވައްޒަފު.",
        "overtimeExplainer": "އިތުރުގަޑީގެ ގަޑިއިރު އީ computed މަތީގައި ރައްކާކުރޭ, އިން ބޭނުންކުރެވޭ އިތުރުގަޑީގެ ގަވާއިދު އެ ގުޅެއެވެ މި ގަޑިއިރު. އެފަރާތްތައް އީ ނޫން ލިޔެފައި މިތާ, ސަބަބަކީ މުސާރަ prices ސީދާ ކޮންއެއްޗެއް ސާވަރު ރެކޯޑްކުރެވިފައި."
      },
      "approveDialog": {
        "title": "ފާސްކުރޭ މި ހާޒިރީ",
        "subject": "{name} މަތީގައި {date}, {overtime} އިތުރުގަޑީގެ ގަޑިއިރު",
        "consequence": "މުސާރަ ގުނައެވެ އިތުރުގަޑި ހަމައެކަނި އިން ފާސްކުރެވިއްޖެ ރޯތައް. ފާސްކުރުން މި makes މި ގަޑިއިރު ދައްކަންޖެހޭ."
      },
      "import": {
        "title": "އިމްޕޯޓްކުރޭ ހާޒިރީ އިން CSV",
        "description": "ކޮންމެ އިމްޕޯޓްކުރެވިއްޖެ ރޯ ފެށެއެވެ unapproved — މުސާރަ ދުވަހަކުވެސް ނުވޭ prices އިތުރުގަޑި އެއްވެސް ފަރާތެއް އެބަހުރި ބަލާފައި ގައި.",
        "formatTitle": "ލާޒިމު ކޮލަމްތައް",
        "formatBody": "ހެޑަރު ރޯ naming މުވައްޒަފު_ނެތް, މަސައްކަތް_ތާރީޚު އަދި ގަޑިއިރު_މަސައްކަތްކުރި. އެހެން ކޮލަމްތައް އީ ignored, އަދި އެފަރާތްތަކުގެ ތަރުތީބު ކުރެއެވެ ނޫން matter.",
        "sample": "މުވައްޒަފު_ނެތް,މަސައްކަތް_ތާރީޚު,ގަޑިއިރު_މަސައްކަތްކުރި\nEMP-2026-0012,2026-08-01,8\nEMP-2026-0012,2026-08-02,9.5",
        "fileLabel": "އިޚްތިޔާރުކުރޭ ފައިލް",
        "fileHint": "ފައިލް އީ ކިޔާ ގައި ބްރައުޒަރު އަދި އޭގެ text އީ ފޮނުވިއްޖެ as-is.",
        "contentLabel": "CSV ތެރޭގައިވާ ބައި",
        "confirm": "އިމްޕޯޓްކުރޭ",
        "working": "އިމްޕޯޓްކުރުން",
        "imported": "{count} ރޯތައް އިމްޕޯޓްކުރެވިއްޖެ",
        "skipped": "{count} ރޯތައް ވި ދޫކޮށްލެވިއްޖެ",
        "skipRow": "ރޯ {row}: {reason}"
      }
    },
    "overtimeRules": {
      "listTitle": "އިތުރުގަޑީގެ ގަވާއިދުތައް",
      "listDescription": "ކޮންމެ ދުވަހަކު ޙައްދުތައް އެ turn ގަޑިއިރު މަސައްކަތްކުރި ތެރެއަށް އިތުރުގަޑީގެ ގަޑިއިރު.",
      "loadFailed": "އިތުރުގަޑީގެ ގަވާއިދުތައް ކުރި ނޫން load",
      "emptyTitle": "ނެތް އިތުރުގަޑީގެ ގަވާއިދުތައް އަދި",
      "emptyDescription": "އިތުރުކުރޭ އެއް އަދި ހާޒިރީ logged ފަހުން އެ ވާނެ ވުން classified ދެކޮޅަށް އެ.",
      "saved": "އިތުރުގަޑީގެ ގަވާއިދު ރައްކާކުރެވިއްޖެ",
      "notRetroactive": "އެޑިޓްކުރުން ގަވާއިދު ކުރެއެވެ ނޫން reprice ހާޒިރީ މިހާރުވެސް ރެކޯޑްކުރެވިފައި: ގަޑިއިރު ވި classified ކޮންއިރަކު ދުވަސް ވި logged. އަލުން ހިސާބުކުރޭ މުސާރައިގެ ރަން އަށް pick މައްޗަށް newly logged ގަޑިއިރު.",
      "columns": {
        "code": "ކޯޑް",
        "threshold": "ކޮންމެ ދުވަހަކު ޙައްދު (ގަޑިއިރު)",
        "multiplier": "ގުނަ"
      },
      "actions": {
        "add": "އިތުރުކުރޭ ގަވާއިދު"
      },
      "form": {
        "createTitle": "އިތުރުކުރޭ އިތުރުގަޑީގެ ގަވާއިދު",
        "editTitle": "އެޑިޓްކުރޭ މި އިތުރުގަޑީގެ ގަވާއިދު",
        "description": "ޙައްދު ނިންމައެވެ ކޮންއިރަކު އިތުރުގަޑި ފެށެއެވެ; ގުނަ އީ carried އަށްޓަކައި reference, އަދި މުސާރައިގެ ބައި prices ގަޑިއިރު.",
        "codeHint": "ކުރު އަދި ދާއިމީ, ފަދަ ގޮތުގައި OT150. އެ އީ ބާސްކެޓް މުސާރައިގެ ބައި ނަންތައް.",
        "thresholdHint": "ގަޑިއިރު ގައި ދުވަސް ފަހަނައަޅާ ކޮން rest ގުނައެވެ ގޮތުގައި އިތުރުގަޑި.",
        "multiplierHint": "މިސާލަކަށް 1.5. އަދަދު ދައްކާފައި comes އިން މުސާރައިގެ ބައި, ނޫން އިން މިތާ.",
        "isActive": "ގައި use",
        "isActiveHint": "ހުއްޓާލާފައި ގަވާއިދު ހުއްޓާލައެވެ classifying އައު ހާޒިރީ އަދި ބާއްވައެވެ ބާ ރޯތައް alone."
      }
    },
    "requisitions": {
      "one": "އެދުން",
      "listTitle": "ވަޒީފާގެ އެދުންތައް",
      "listDescription": "ބޭނުންވާ އަދަދު އެދުންތައް, އަދި ކެންޑިޑޭޓުން raised ދެކޮޅަށް އެފަރާތްތަކަށް.",
      "detailTitle": "އެދުން",
      "loadFailed": "އެދުން ކުރި ނޫން load",
      "emptyTitle": "ނެތް އެދުންތައް އަދި",
      "emptyDescription": "Raise އެއް އަށް ފެށުން collecting ކެންޑިޑޭޓުން ދެކޮޅަށް named ބޭނުންވާ އަދަދު.",
      "created": "އެދުން raised",
      "saved": "އެދުން ރައްކާކުރެވިއްޖެ",
      "opened": "އެދުން ހުޅުވިއްޖެ",
      "openedDetail": "ކެންޑިޑޭޓުން ކުރެވޭ މިހާރު ވުން filed ދެކޮޅަށް އެ.",
      "candidatesDescription": "ހުރިހާ ފަރާތެއް filed ދެކޮޅަށް މި އެދުން.",
      "noCandidatesTitle": "ނެތް ކެންޑިޑޭޓުން އަދި",
      "noCandidatesDescription": "އިތުރުކުރޭ އެއް އިން ކެންޑިޑޭޓުން ސްކްރީން އަދި ފައިލް އެ ދެކޮޅަށް މި އެދުން.",
      "viewAllCandidates": "ބަލާ ހުރިހާ ކެންޑިޑޭޓުން އަށްޓަކައި މި އެދުން",
      "columns": {
        "requisitionNo": "އެދުން",
        "title": "ރޯލް",
        "headcount": "ބޭނުންވާ އަދަދު"
      },
      "fields": {
        "justification": "ސަބަބު"
      },
      "actions": {
        "add": "Raise އެދުން",
        "backToList": "ހުރިހާ އެދުންތައް",
        "open": "ހުޅުވާ އަށްޓަކައި ކެންޑިޑޭޓުން"
      },
      "form": {
        "title": "Raise ވަޒީފާގެ އެދުން",
        "description": "ބޭނުންވާ އަދަދު އެދުން. އެ becomes ހުޅުވާ އަށް ކެންޑިޑޭޓުން އެއްފަހަރު ހުށަހަޅާފައި.",
        "justificationHint": "ކީއްވެ މި ބޭނުންވާ އަދަދު އީ ބޭނުންވާ. Whoever approves އެ ކިޔައެވެ މި."
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "open": "ހުޅުވާ",
        "closed": "ބަންދުކުރެވިފައި",
        "cancelled": "ކެންސަލްކުރެވިއްޖެ"
      },
      "statusExplainers": {
        "draft": "އަދިވެސް ދެލިކޮޕީ. ހުޅުވާ އެ އަށްޓަކައި ކެންޑިޑޭޓުން ކޮންއިރަކު ބޭނުންވާ އަދަދު އީ agreed.",
        "open": "ހުޅުވާ — ކެންޑިޑޭޓުން ކުރެވޭ ވުން filed ދެކޮޅަށް މި އެދުން.",
        "closed": "ބަންދުކުރެވިފައި. ބޭނުންވާ އަދަދު އެބަހުރި ވެފައި filled ނުވަތަ އަނބުރާ ނަގާފައި.",
        "cancelled": "ކެންސަލްކުރެވިއްޖެ. އެއްވެސް އެއްޗެއް އިތުރު ކުރެވޭ ވުން raised ދެކޮޅަށް އެ."
      },
      "position": {
        "action": "އެސްޓަބްލިޝްމަންޓް",
        "title": "ރެކްރޫޓްކުރާ ގޮތް",
        "description": "މި ރެކުއިޒިޝަނުން ފުރާ މަޤާމާއި ގްރޭޑާއި ތަން، އަދި އިންޓަރވިއު ކުރާ ފަރާތްތަކުން މާކްސް ދޭ ކަންކަން.",
        "rangeNote": "މިތާ ގްރޭޑެއް ކަނޑައެޅުމުން، މި ރެކުއިޒިޝަނުން ދޭ އޮފަރގެ މުސާރަ ބަލާނެ ސެލެރީ ބޭންޑެއް ލިބެއެވެ. ކަނޑަނާޅައި ބެހެއްޓުމުން ބޭންޑް ޗެކަށް އަޅާކިޔާނެ އެއްޗެއް ނޯންނާނެއެވެ.",
        "unreadable": "މި ފީލްޑްތައް ކިޔާނެ އޭޕީއައި އެއް އަދި ނެތުމުން، ފޯމް ފެށޭނީ ހުސްކޮށެވެ. ރައްކާކުރުމުން ރެކޯޑްވެފައިވާ އެއްޗެއް ބަދަލުކުރެވޭނެއެވެ.",
        "position": "ޕޮޒިޝަން",
        "grade": "ދަރަޖަ",
        "gradeHint": "ސީދާ ގްރޭޑެއް ކަނޑައަޅާ، ނުވަތަ މަޤާމުގެ އަމިއްލަ ގްރޭޑަށް ދޫކޮށްލާ.",
        "location": "ތަން",
        "criteria": "ސްކޯކާޑް މިންގަނޑުތައް",
        "criteriaHint": "ކޮންމެ ފޮޅުވަތަކަށް އެކެއް. މިއީ އިންޓަރވިއު ކުރާ ފަރާތުން މާކްސް ދޭ ކަންކަމެވެ.",
        "saved": "އެސްޓަބްލިޝްމަންޓް ގުޅުވިއްޖެ"
      }
    },
    "candidates": {
      "one": "ކެންޑިޑޭޓް",
      "listTitle": "ކެންޑިޑޭޓުން",
      "listDescription": "މީހުން being considered, އަދި ކޮންތާކު ކޮންމެ ގެ އެފަރާތްތަކަށް އެބަހުރި got އަށް.",
      "detailTitle": "ކެންޑިޑޭޓް",
      "timelineTitle": "މަރުޙަލާގެ ތާރީޚު",
      "loadFailed": "ކެންޑިޑޭޓް ކުރި ނޫން load",
      "emptyTitle": "ނެތް ކެންޑިޑޭޓުން އަދި",
      "emptyDescription": "އިތުރުކުރޭ އެއް, ނުވަތަ ފައިލް އެދުނު ފަރާތް ދެކޮޅަށް ހުޅުވާ އެދުން.",
      "searchPlaceholder": "ހޯދާ ނަން ނުވަތަ އީމެއިލް",
      "created": "ކެންޑިޑޭޓް އިތުރުކުރެވިފައި",
      "saved": "ކެންޑިޑޭޓް ރައްކާކުރެވިއްޖެ",
      "advanced": "މަރުޙަލާ ރެކޯޑްކުރެވިފައި",
      "converted": "ކެންޑިޑޭޓް ބަދަލުކުރެވިއްޖެ އަށް މުވައްޒަފު",
      "convertedNote": "މި ކެންޑިޑޭޓް އެބަހުރި މިހާރުވެސް ވެފައި ބަދަލުކުރެވިއްޖެ ތެރެއަށް މުވައްޒަފު.",
      "notConverted": "ނޫން ބަދަލުކުރެވިއްޖެ",
      "viewEmployee": "View މުވައްޒަފު",
      "noTimelineTitle": "ނެތް މަރުޙަލާގެ ތާރީޚު އަދި",
      "noTimelineDescription": "ކޮންމެ މަރުޙަލާ ބަދަލު އީ ރެކޯޑްކުރެވިފައި މިތާ ގޮތުގައި އެ happens.",
      "columns": {
        "candidateNo": "ކެންޑިޑޭޓް",
        "source": "އަސްލު",
        "stage": "މަރުޙަލާ",
        "employee": "މުވައްޒަފު"
      },
      "fields": {
        "rating": "ރޭޓިންގ",
        "ratingHint": "ފުރިހަމަ ނަންބަރު, ޢާންމުކޮށް 1 އަށް 5."
      },
      "actions": {
        "add": "އިތުރުކުރޭ ކެންޑިޑޭޓް",
        "backToList": "ހުރިހާ ކެންޑިޑޭޓުން",
        "advance": "ބަދަލުކުރޭ މަރުޙަލާ",
        "convert": "ބަދަލުކުރޭ އަށް މުވައްޒަފު"
      },
      "form": {
        "title": "އިތުރުކުރޭ ކެންޑިޑޭޓް",
        "description": "Filing އެފަރާތްތަކަށް ދެކޮޅަށް އެދުން އީ އިޚްތިޔާރީ — އަމިއްލައަށް ފޮނުވި އެޕްލިކޭޝަން އީ އަދިވެސް ކެންޑިޑޭޓް.",
        "sourceHint": "ކޮންތާކު އެފަރާތްތައް came އިން, ފަދަ ގޮތުގައި ރެފަރަލް ނުވަތަ ވަޒީފާގެ ބޯޑު.",
        "noRequisition": "ނެތް އެދުން"
      },
      "advance": {
        "title": "ބަދަލުކުރޭ މި ކެންޑިޑޭޓް އަށް އެހެން މަރުޙަލާ",
        "description": "ކޮންމެ ބަދަލުކުރޭ އީ ރެކޯޑްކުރެވިފައި އާއެކު އޭގެ ނޯޓް އަދި ހުންނާނެއެވެ މަތީގައި މަރުޙަލާގެ ތާރީޚު.",
        "stageLabel": "އައު މަރުޙަލާ",
        "stagePlaceholder": "އިޚްތިޔާރުކުރޭ މަރުޙަލާ",
        "noteLabel": "ނޯޓް"
      },
      "convert": {
        "title": "ބަދަލުކުރޭ މި ކެންޑިޑޭޓް ތެރެއަށް މުވައްޒަފު",
        "subject": "ވަޒީފާ ދިނުން {name}",
        "consequenceHeadline": "މި އުފައްދައެވެ ދައްކާފައި މުވައްޒަފު.",
        "consequence": "މުވައްޒަފު ރެކޯޑްކުރޭ އީ އުފެއްދިއްޖެ އާއެކު މުސާރަ އެތެރެކުރެވިފައި ތިރީގައި, އަދި މުސާރަ ވާނެ include އެފަރާތްތަކަށް އިން އެފަރާތްތަކުގެ joining ތާރީޚު. ބޭންކް ތަފްޞީލުތައް އީ ނޫން set މިތާ — އެފަރާތްތައް އީ raised ވަކިން އަދި ފާސްކުރެވިއްޖެ މެދުވެރިކޮށް second ފަރާތް.",
        "confirm": "އުފައްދާ މުވައްޒަފު"
      },
      "stages": {
        "applied": "ބޭނުންކުރެވިފައި",
        "screening": "ސްކްރީނިންގ",
        "interview": "އިންޓަވިއު",
        "offer": "ހުށަހެޅުން",
        "hired": "ވަޒީފާ ދެވިފައި",
        "rejected": "ބޭރުކުރެވިއްޖެ"
      },
      "scorecards": {
        "title": "އިންޓަވިއު ސްކޯކާޑުތައް",
        "description": "ކޮންމެ އިންޓަވިއު ކުރާ ފަރާތަކަށް އެއް ސްކޯކާޑް، ވަކިވަކިން ނިސްބަތްކުރެވި، ހުށަހެޅުމުން ލޮކްވެއެވެ.",
        "emptyTitle": "އަދި ސްކޯކާޑެއް ނެތް",
        "emptyDescription": "އިންޓަވިއު ބާއްވާ ނިމުމުން އެއް ހުށަހަޅާ.",
        "draft": "ދެލިކޮޕީ",
        "submittedOn": "{date} ގައި ހުށަހެޅިއްޖެ",
        "saved": "ސްކޯކާޑް ދެލިކޮޕީއެއްގެ ގޮތުގައި ރައްކާކުރެވިއްޖެ",
        "submitted": "ސްކޯކާޑް ހުށަހެޅިއްޖެ",
        "actions": {
          "submit": "ސްކޯކާޑް ހުށަހަޅާ",
          "saveDraft": "ދެލިކޮޕީގެ ގޮތުގައި ރައްކާކުރޭ"
        },
        "fields": {
          "stage": "އިންޓަވިއު މަރުޙަލާ",
          "recommendation": "ލަފާ",
          "overallScore": "ޖުމްލަ ސްކޯ",
          "criteria": "މިންގަނޑުތައް",
          "criterion": "މިންގަނޑު",
          "score": "ސްކޯ",
          "criterionNote": "ހެކި"
        },
        "recommendations": {
          "strong_hire": "ވަރަށް ރަނގަޅު، ވަޒީފާ ދޭން",
          "hire": "ވަޒީފާ ދޭން",
          "no_hire": "ވަޒީފާ ނުދޭން",
          "strong_no_hire": "ވަރަށް ބޮޑަށް ވަޒީފާ ނުދޭން"
        },
        "form": {
          "title": "އިންޓަވިއު ސްކޯކާޑެއް ހުށަހަޅާ",
          "description": "ތިޔަ ފަރާތަށް ވަކިން ނިސްބަތްކުރެވި، ހުށަހެޅުމުން ލޮކްވާނެއެވެ.",
          "recommendationPlaceholder": "ލަފައެއް ހޮވާ",
          "addCriterion": "މިންގަނޑު އިތުރުކުރޭ",
          "removeCriterion": "މިންގަނޑު {line} ނައްތާލާ",
          "submitLabel": "މިހާރު ހުށަހަޅާ",
          "submitHint": "ސްކޯކާޑް ލޮކްކޮށް ތިޔަ ފަރާތަށް ނިސްބަތްކުރެއެވެ. ފަހުން ހުށަހެޅޭ ދެލިކޮޕީއެއް ރައްކާކުރަން ނުފިއްތާ ބަހައްޓާ."
        }
      },
      "references": {
        "title": "ރެފަރެންސްތައް",
        "description": "ރެފަރެންސް ހޯދުމަށް ފޮނުވާ ރަސްމީ އެދުމާއި ކޮންމެ ރެފަރީއެއް ބުނިއެއްޗެއް.",
        "emptyTitle": "އަދި ރެފަރެންސެއް ނުހޯދާ",
        "emptyDescription": "ކެންޑިޑޭޓް ދީފައިވާ ރެފަރީއަކަށް އެދޭށެވެ.",
        "requested": "ރެފަރެންސް ހޯދުމަށް އެދިއްޖެ",
        "recorded": "ޖަވާބު ރެކޯޑްކުރެވިއްޖެ",
        "actions": {
          "request": "ރެފަރެންސް ހޯދުމަށް އެދޭ",
          "record": "ޖަވާބު ރެކޯޑްކުރޭ"
        },
        "fields": {
          "refereeName": "ރެފަރީގެ ނަން",
          "refereeOrganisation": "ޖަމިއްޔާ",
          "refereeContact": "ގުޅޭނެ ގޮތް",
          "relationship": "ކެންޑިޑޭޓާ ހުރި ގުޅުން",
          "outcome": "ނަތީޖާ",
          "response": "ބުނިއެއްޗެއް"
        },
        "statuses": {
          "requested": "އެދިފައި",
          "received": "ލިބިއްޖެ"
        },
        "outcomes": {
          "positive": "ރަނގަޅު",
          "mixed": "މަސްހުނި",
          "negative": "ނުރަނގަޅު",
          "no_response": "ޖަވާބެއް ނުލިބޭ"
        },
        "form": {
          "title": "ރެފަރެންސް ހޯދުމަށް އެދޭ",
          "description": "ރަސްމީ ރެފަރެންސް އެދުމެއް ފޮނުވައި ކެންޑިޑޭޓާ ދެކޮޅަށް ރެކޯޑްކުރޭ."
        },
        "respond": {
          "title": "ރެފަރީ ބުނިއެއްޗެއް ރެކޯޑްކުރޭ",
          "outcomePlaceholder": "ނަތީޖާއެއް ހޮވާ"
        }
      }
    },
    "offers": {
      "listTitle": "ހުށަހެޅުންތައް",
      "listDescription": "ކޮންއެއްޗެއް އެބަހުރި ވެފައި offered, އަށް ކާކަށް, އަދި ކޮންއެއްޗެއް came ގެ އެ.",
      "loadFailed": "ހުށަހެޅުން ލިސްޓް ކުރި ނޫން load",
      "emptyTitle": "ނެތް ހުށަހެޅުންތައް އަދި",
      "emptyDescription": "ދެލިކޮޕީ އެއް އިން ކެންޑިޑޭޓް އެއްފަހަރު އެފަރާތްތައް reach ހުށަހެޅުން މަރުޙަލާ.",
      "created": "ހުށަހެޅުން drafted",
      "viewAll": "ހުރިހާ ހުށަހެޅުންތައް",
      "recordExplainer": "މި actions ރެކޯޑްކުރޭ ކޮންއެއްޗެއް happened. Marking ހުށަހެޅުން ޤަބޫލުކޮށްފި މާނައަކީ ކެންޑިޑޭޓް ޤަބޫލުކޮށްފި އެ — އެ އީ ނޫން އެތެރޭގެ ފާސްކުރުން.",
      "columns": {
        "offerNo": "ހުށަހެޅުން",
        "title": "Proposed ރޯލް",
        "salary": "Proposed މުސާރަ",
        "startDate": "ފެށުން ތާރީޚު"
      },
      "actions": {
        "draft": "ދެލިކޮޕީ ހުށަހެޅުން",
        "send": "Mark ގޮތުގައި ފޮނުވިއްޖެ",
        "accept": "ރެކޯޑްކުރޭ ޤަބޫލުކުރުން",
        "decline": "ރެކޯޑްކުރޭ ދެކޮޅު ހަދާ",
        "withdraw": "އަނބުރާ ނަގާ"
      },
      "done": {
        "send": "ހުށަހެޅުން marked ގޮތުގައި ފޮނުވިއްޖެ",
        "accept": "ޤަބޫލުކުރުން ރެކޯޑްކުރެވިފައި",
        "decline": "ދެކޮޅު ހަދާ ރެކޯޑްކުރެވިފައި",
        "withdraw": "ހުށަހެޅުން އަނބުރާ ނަގާފައި"
      },
      "confirm": {
        "sendTitle": "Mark މި ހުށަހެޅުން ގޮތުގައި ފޮނުވިއްޖެ",
        "sendConsequence": "ރެކޯޑްކުރެއެވެ އެ ހުށަހެޅުން އެބަހުރި ގޮސްފި އަށް ކެންޑިޑޭޓް. އެ ކުރެއެވެ ނޫން ފޮނުވާ އީމެއިލް.",
        "acceptTitle": "ރެކޯޑްކުރޭ އެ ކެންޑިޑޭޓް ޤަބޫލުކޮށްފި",
        "acceptConsequence": "ރެކޯޑްކުރެއެވެ candidate's ޤަބޫލުކުރުން. ބަދަލުކުރުން އެފަރާތްތަކަށް ތެރެއަށް މުވައްޒަފު އީ ވަކި ފިޔަވަޅު.",
        "declineTitle": "ރެކޯޑްކުރޭ އެ ކެންޑިޑޭޓް ދެކޮޅު ހަދައިފި",
        "declineConsequence": "ރެކޯޑްކުރެއެވެ candidate's refusal. ހުށަހެޅުން ނުކުރެވޭ ވުން revived އޭގެފަހުން.",
        "withdrawTitle": "އަނބުރާ ނަގާ މި ހުށަހެޅުން",
        "withdrawConsequence": "Withdraws ހުށަހެޅުން މަތީގައި މި side. އެ ނުކުރެވޭ ވުން revived އޭގެފަހުން.",
        "legalActions": "ރެކޯޑްކުރެވިފައި actions އީ: {actions}."
      },
      "form": {
        "title": "ދެލިކޮޕީ ހުށަހެޅުން",
        "description": "ދެލިކޮޕީ ރެކޯޑްކުރެއެވެ ކޮންއެއްޗެއް އީ being proposed. Sending, ޤަބޫލުކުރުން އަދި refusal އީ ރެކޯޑްކުރެވިފައި އޭގެފަހުން.",
        "salaryHint": "މަހަކު އެއްފަހަރު އަސާސީ މުސާރަ being offered, ސީދާ ގޮތުގައި ލިޔެފައި.",
        "draftExplainer": "Drafting ހުށަހެޅުން ކުރެއެވެ ނޫން އަންގާ anybody. Mark އެ ގޮތުގައި ފޮނުވިއްޖެ އެއްފަހަރު އެ އެބަހުރި ޙަޤީޤަތުގައި ގޮސްފި ބޭރަށް."
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "sent": "ފޮނުވިއްޖެ",
        "accepted": "ޤަބޫލުކޮށްފި",
        "declined": "ދެކޮޅު ހަދައިފި",
        "withdrawn": "އަނބުރާ ނަގާފައި"
      },
      "position": {
        "action": "އެސްޓަބްލިޝްމަންޓް",
        "title": "އޮފަރ ދެވޭ ގޮތް",
        "description": "މި އޮފަރ ދެވެނީ ކޮން ގްރޭޑަކާއި މަޤާމަކާއި ޕޭ ގްރޫޕަކަށްކަން.",
        "resetNote": "މި ރައްކާކުރުމުން އޮފަރގައި ރެކޯޑްވެފައިވާ ރޭންޖް ޗެކް ރީސެޓްވެއެވެ. ދެން ފޮނުވާއިރު އަލުން ބަލާނެއެވެ — ފާސްކުރެވިފައިވާ އޯވަރައިޑެއް ވިޔަސްމެއެވެ.",
        "unreadable": "މި ފީލްޑްތައް ކިޔާނެ އޭޕީއައި އެއް އަދި ނެތުމުން، ފޯމް ފެށޭނީ ހުސްކޮށެވެ. ރައްކާކުރުމުން ރެކޯޑްވެފައިވާ އެއްޗެއް ބަދަލުކުރެވޭނެއެވެ.",
        "grade": "ދަރަޖަ",
        "gradeHint": "ހުށަހަޅާ މުސާރަ އަޅާކިޔާ ބޭންޑް.",
        "position": "ޕޮޒިޝަން",
        "payGroup": "މުސާރައިގެ ގްރޫޕް",
        "saved": "އެސްޓަބްލިޝްމަންޓް ގުޅުވިއްޖެ"
      }
    },
    "assignments": {
      "dialog": {
        "changeFteLabel": "ފުލްޓައިމް އެކުއިވަލެންޓް ބަދަލުކުރޭ",
        "changeLocationLabel": "ލޮކޭޝަން ބަދަލުކުރޭ",
        "changeManagerLabel": "މެނޭޖަރ ބަދަލުކުރޭ",
        "changeNoticeLabel": "ނޯޓިސް މުއްދަތު ބަދަލުކުރޭ",
        "changeOrgLabel": "ޑިޕާޓްމަންޓް، ބްރާންޗް ނުވަތަ ކޮސްޓް ސެންޓަރ ބަދަލުކުރޭ",
        "changePayGroupLabel": "މުސާރައިގެ ގްރޫޕް ބަދަލުކުރޭ",
        "changePensionableLabel": "ޕެންޝަނުގައި ބައިވެރިވުން ބަދަލުކުރޭ",
        "changePositionLabel": "ޕޮޒިޝަން ބަދަލުކުރޭ",
        "changeProbationLabel": "ޕްރޮބޭޝަން ނިމޭ ތާރީޚު ބަދަލުކުރޭ",
        "changeSalaryLabel": "އަސާސީ މުސާރަ ބަދަލުކުރޭ",
        "changeShiftPatternLabel": "ޝިފްޓް ޕެޓަރން ބަދަލުކުރޭ",
        "changeTypeLabel": "ވަޒީފާގެ ބާވަތް ބަދަލުކުރޭ",
        "currentTitle": "މިއަދު ހިނގަމުންދާ",
        "description": "ބަދަލު ހިނގަން ފަށަނީ ތާރީޚަކުންނެވެ. އޭގެ ކުރީގައި އޮތް އެއްޗެއް ބާކީ ހުރެއެވެ.",
        "effectiveFromHint": "މުސާރަ ޕޯސްޓްކޮށްފައިވާ މުއްދަތެއްގެ ތެރޭގެ ތާރީޚަކުން ފަހުން ދޭ މުސާރަ އުފެދެއެވެ.",
        "noCompensation": "ތިޔަ ފަރާތުގެ ރޯލްތަކުގައި މުސާރަ ބެލުމާއި ކަނޑައެޅުން ނުހިމެނޭތީ، މުސާރައިގެ ގޮޅި ނުދައްކައެވެ.",
        "salaryHint": "ޕޭސްލިޕުގައި ފެންނަން ޖެހޭ ސީދާ ޢަދަދެވެ.",
        "saveWithRetro": "ރައްކާކޮށް ފަހުން ދޭ މުސާރަ އުފައްދާ",
        "title": "ވަޒީފާގެ ޝަރުޠުތައް ބަދަލުކުރޭ"
      },
      "fields": {
        "basicSalary": "އަސާސީ މުސާރަ",
        "branchId": "ބްރާންޗް",
        "costCenterId": "ކޮސްޓް ސެންޓަރ",
        "departmentId": "ޑިޕާޓްމަންޓް",
        "effectiveFrom": "ފެށޭ ތާރީޚު",
        "employmentStatus": "ވަޒީފާގެ ހާލަތު",
        "employmentType": "ވަޒީފާގެ ބާވަތް",
        "fte": "ފުލްޓައިމް އެކުއިވަލެންޓް",
        "locationId": "ލޮކޭޝަން",
        "managerId": "Reports އަށް",
        "noticeDays": "ނޯޓިސް މުއްދަތު (ދުވަސް)",
        "note": "ނޯޓު",
        "payGroupId": "މުސާރައިގެ ގްރޫޕް",
        "pensionable": "ޕެންޝަން ސްކީމުގައި ބައިވެރިވެފައި",
        "positionId": "ޕޮޒިޝަން",
        "probationEndOn": "ޕްރޮބޭޝަން ނިމޭ ތާރީޚު",
        "reasonCode": "ސަބަބު",
        "shiftPatternId": "ޝިފްޓް ޕެޓަރން"
      },
      "history": {
        "actions": {
          "change": "ޝަރުޠުތައް ބަދަލުކުރޭ"
        },
        "correctable": "މި ވަރޝަން އަދި ނުފެށޭތީ، މިހާރުވެސް އިޞްލާޙުކުރެވިދާނެއެވެ.",
        "description": "މި މީހާގެ ޝަރުޠުތަކުގެ ކޮންމެ ވަރޝަނެއް، އެންމެ ފަހުގެ ފުރަތަމައަށެވެ. ބަދަލުކުރެވިފައިވާ ވަރޝަނެއް ދުވަހަކުވެސް އެޑިޓެއް ނުކުރެވެއެވެ.",
        "emptyDescription": "މި މުވައްޒަފަށް އަދި ވަޒީފާގެ ޝަރުޠެއް ރެކޯޑްކުރެވިފައެއް ނުވެއެވެ.",
        "inForce": "ހިނގަމުންދާ",
        "loadFailed": "ވަޒީފާގެ ތާރީޚު ލޯޑެއް ނުކުރެވުނެވެ",
        "ongoing": "ކުރިއަށްދާ",
        "superseded": "ބަދަލުކުރެވިފައި",
        "title": "ވަޒީފާގެ ތާރީޚު"
      },
      "preview": {
        "checking": "ބަލަނީ…",
        "closesAt": "ހިނގަމުންދާ ވަރޝަން {date} ގައި ބަންދުވެއެވެ.",
        "description": "އެއްވެސް އެއްޗެއް ލިޔުމުގެ ކުރިން ސާވަރާ އަޅައި ބެލެއެވެ.",
        "diffCaption": "މި ބަދަލުން ބަދަލުވާނެ ގޮޅިތައް",
        "field": "ގޮޅި",
        "from": "ކުރިން",
        "noChanges": "އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވާނެއެވެ. ރައްކާކުރުމުގެ ކުރިން ގޮޅިއެއް ބަދަލުކުރާށެވެ.",
        "retroClear": "ޕޯސްޓްކުރެވިފައިވާ މުއްދަތަކަށް އަސަރެއް ނުކުރާތީ، ފަހުން ދޭ މުސާރައެއް ނުއުފެދެއެވެ.",
        "retroUnknown": "މި ޑިޕްލޯއިމަންޓުގައި ފަހުން ދޭ މުސާރައިގެ އިންޖީނެއް ގުޅިފައި ނުވާތީ، ޕޯސްޓްކުރެވިފައިވާ މުއްދަތަކަށް އަސަރުކުރޭތޯ ނޭނގެއެވެ.",
        "retroWarning": "މި ތާރީޚު ވަނީ މުސާރަ ޕޯސްޓްކޮށްފައިވާ މުއްދަތެއްގެ ތެރޭގައެވެ. ތަފާތު ފަހުން އަންނަ ރަނެއްގައި ފަހުން ދޭ މުސާރައިގެ ގޮތުގައި ދެވޭނެއެވެ؛ ޕޯސްޓްކުރެވިފައިވާ ޕޭސްލިޕް އަލުން ނުލިޔެވެއެވެ.",
        "title": "މިއިން ވާނެ ގޮތް",
        "to": "ފަހުން"
      },
      "reasons": {
        "contract_change": "އެއްބަސްވުމުގެ ބަދަލު",
        "correction_of_terms": "ޝަރުޠުތައް އިޞްލާޙުކުރުން",
        "demotion": "ދަރަޖަ ދަށްކުރުން",
        "other": "އެހެނިހެން",
        "pay_review": "މުސާރައިގެ މުރާޖަޢާ",
        "probation_completed": "ޕްރޮބޭޝަން ފުރިހަމަކުރި",
        "promotion": "ކުރިއެރުން",
        "transfer": "ބަދަލުކުރުން"
      },
      "saved": "ޝަރުޠުތައް ބަދަލުކުރެވިއްޖެ",
      "savedWithRetro": "ޝަރުޠުތައް ބަދަލުކުރެވިއްޖެ — ފަހުން ދޭ މުސާރަ އުފެދިއްޖެ"
    },
    "exits": {
      "actions": {
        "finalPay": "އެންމެ ފަހު މުސާރަ ހަދާ",
        "initiate": "ވަކިވުން ފަށާ",
        "settle": "ނިންމާ"
      },
      "blockedByClearance": "ލާޒިމު {count} ކަމެއް އަދިވެސް ހުޅުވިފައި",
      "blockingExplainer": "ލާޒިމު ކްލިއަރެންސް ކަމެއް ހުޅުވިފައި ވަނިކޮށް އެންމެ ފަހު މުސާރަ ދޫނުކުރެވޭނެއެވެ:",
      "clearance": {
        "actions": {
          "add": "ކަމެއް އިތުރުކުރޭ",
          "clear": "ކްލިއަރކުރޭ",
          "waive": "މާފުކުރޭ"
        },
        "add": {
          "description": "އަނބުރާ އަންނަން ޖެހޭ އެއްޗެއް، އަދި ކާކުގެ ފަރާތުންކަން.",
          "title": "ކްލިއަރެންސް ކަމެއް އިތުރުކުރޭ"
        },
        "added": "ކްލިއަރެންސް ކަން އިތުރުކުރެވިއްޖެ",
        "categories": {
          "access_revocation": "ހުއްދަ ބާޠިލުކުރުން",
          "asset_return": "މުދާ އަނބުރާ ދިނުން",
          "financial": "މާލީ",
          "handover": "ހަވާލުކުރުން",
          "other": "އެހެނިހެން",
          "statutory": "ޤާނޫނީ"
        },
        "cleared": "ކަން ކްލިއަރކުރެވިއްޖެ",
        "columns": {
          "category": "ބާވަތް",
          "item": "ކަން",
          "mandatory": "ލާޒިމު",
          "owner": "ޒިންމާދާރު ފަރާތް",
          "recoverable": "އަނބުރާ ހޯދޭ"
        },
        "description": "ސޮއިކުރަނީ މުދަލާއި، އައިޓީއާއި، ފައިނޭންސްގެ ފަރާތްތަކުން — އެއިން އެއްވެސް ފަރާތަކީ އެޗްއާރެއް ނޫނެވެ.",
        "emptyDescription": "އަދި ކްލިއަރެންސް ކަމެއް ނެތެވެ. އަނބުރާ އަންނަން ޖެހޭ މުދަލާއި، ހުއްދަތަކާއި، ބާކީ އިތުރުކުރާށެވެ.",
        "mandatoryHint": "ލާޒިމު ކަމަކުން ކްލިއަރ ނުވަތަ މާފުނުކުރެވެނީސް އެންމެ ފަހު މުސާރަ ހުއްޓުވައެވެ.",
        "noPermission": "ތިޔަ ފަރާތުގެ ރޯލްތަކުގައި ކްލިއަރެންސް ކަންކަން ސޮއިކުރުން ނުހިމެނެއެވެ.",
        "recoverableHint": "އެންމެ ފަހު މުސާރައިން އުނިކުރެވެއެވެ.",
        "statuses": {
          "cleared": "ކްލިއަރކުރެވިފައި",
          "open": "ހުޅުވިފައި",
          "waived": "މާފުކުރެވިފައި"
        },
        "title": "ކްލިއަރެންސް ޗެކްލިސްޓް",
        "waive": {
          "description": "މާފުކުރުމުން އެންމެ ފަހު މުސާރަ ދޫވެ، ތިޔަ ފަރާތުގެ ސަބަބާއެކު ރެކޯޑްކުރެވެއެވެ.",
          "reasonLabel": "މާފުކުރުމުގެ ސަބަބު",
          "title": "ކްލިއަރެންސް ކަމެއް މާފުކުރޭ"
        },
        "waived": "ކަން މާފުކުރެވިއްޖެ",
        "waiverReasons": {
          "item_not_applicable": "މި މީހާއަށް ނުހިނގާ",
          "other": "އެހެނިހެން",
          "recovered_by_deduction": "އުނިކުރުމުން އަނބުރާ ހޯދިއްޖެ",
          "written_off_approved": "ފާސްކުރުމާއެކު ދޫކޮށްލެވިއްޖެ"
        }
      },
      "clearanceProgress": "{total} ން {done} ކްލިއަރކުރެވިފައި",
      "columnEmpty": "މިތާ މީހަކު ނެތެވެ.",
      "create": {
        "description": "ކޮންމެ މީހަކަށް އެއް ދިރިހުރި ވަކިވުމެވެ. ދެވަނަ އެއްޗަކީ ޑޭޓާ އެންޓްރީގެ ކުށެއް، ދެވަނަ ވަކިވުމެއް ނޫނެވެ.",
        "title": "ވަކިވުމެއް ފަށާ"
      },
      "created": "ވަކިވުން ފެށިއްޖެ",
      "description": "ފެށުނު، ކްލިއަރެންސް، އެންމެ ފަހު މުސާރަ، ނިމުނު. ކޮންމެ ކޮލަމަކީ މީހަކު މީހަކަށް އިންތިޒާރުކުރުމެވެ.",
      "detailDescription": "ކްލިއަރެންސް ޗެކްލިސްޓުން ކަނޑައަޅަނީ އެންމެ ފަހު މުސާރަ ދޫކުރެވިދާނެތޯއެވެ.",
      "detailTitle": "ވަކިވުން",
      "fields": {
        "exitType": "ވަކިވުމުގެ ބާވަތް",
        "noticeGivenOn": "ނޯޓިސް ދެވުނު ތާރީޚު",
        "noticeInLieu": "ނޯޓިހުގެ ބަދަލުގައި ދެވޭ (ދުވަސް)",
        "reasonNote": "ސަބަބު",
        "recoverableTotal": "އަނބުރާ ހޯދޭ",
        "rehireEligible": "އަލުން ވަޒީފާދިނުމަށް ޤާބިލު",
        "terminationDate": "ވަޒީފާ ނިމޭ ތާރީޚު",
        "terminationHint": "އަބަދު އެންމެ ފަހު މަސައްކަތު ދުވަހެއް ނޫނެވެ — ނޯޓިހުގެ ބަދަލުގައި ފައިސާ ދެވޭނަމަ ފަހުން ނިމެއެވެ."
      },
      "finalPay": {
        "description": "ހަމައެކަނި މި މީހާއަށް ސައިކަލުން ބޭރު މުސާރައިގެ ރަނެކެވެ.",
        "explainer": "ނޯޓިހުގެ މުސާރަ، ޗުއްޓީ ފައިސާއަށް ބަދަލުކުރުން، އަދި އަނބުރާ ހޯދޭ އުނިކުރުންތައް މުސާރައިން ކުރިން ފުރައެވެ.",
        "payDate": "ފައިސާ ދޭ ތާރީޚު",
        "raised": "އެންމެ ފަހު މުސާރައިގެ ރަން {runNo} އުފެއްދިއްޖެ",
        "title": "އެންމެ ފަހު މުސާރަ ހަދާ"
      },
      "lastWorkingDay": "އެންމެ ފަހު މަސައްކަތު ދުވަސް",
      "loadFailed": "ވަކިވުންތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "no": "ނޫން",
      "settle": {
        "description": "ނިންމުމުން ވަކިވުން ބަންދުވެއެވެ. ފުރަތަމަ ލާޒިމު ކޮންމެ ކްލިއަރެންސް ކަމެއް ކްލިއަރ ނުވަތަ މާފުކުރަން ޖެހެއެވެ.",
        "title": "ވަކިވުން ނިންމާ"
      },
      "settled": "ވަކިވުން ނިމިއްޖެ",
      "statuses": {
        "cancelled": "ކެންސަލްކޮށްފައި",
        "clearance": "ކްލިއަރެންސް",
        "final_pay_pending": "އެންމެ ފަހު މުސާރަ އިންތިޒާރުގައި",
        "initiated": "ފެށިފައި",
        "settled": "ނިމިފައި"
      },
      "title": "ވަކިވުންތައް",
      "types": {
        "abandonment": "ވަޒީފާ ދޫކޮށްލުން",
        "death": "މަރު",
        "end_of_contract": "އެއްބަސްވުން ނިމުން",
        "redundancy": "ވަޒީފާ އުވާލުން",
        "resignation": "އިސްތިޢުފާ",
        "retirement": "ރިޓަޔަރމަންޓް",
        "termination": "ވަޒީފާއިން ވަކިކުރުން",
        "termination_for_cause": "ސަބަބަކާހުރެ ވަކިކުރުން"
      },
      "yes": "އާނ"
    },
    "leaveDepth": {
      "accrualDone": "އެކްރުއަލް ހިނގައިފި",
      "actions": {
        "carryForward": "ކެރީ ފޯވާޑް ހިންގާ",
        "encash": "ފައިސާއަށް ބަދަލުކުރޭ",
        "newBlackout": "އައު ބްލެކްއައުޓް",
        "newCoverage": "އައު އެންމެ މަދު ކަވަރޭޖު",
        "runAccrual": "އެކްރުއަލް ހިންގާ"
      },
      "asOfDate": "ތާރީޚަށް ބަލައި",
      "asOfDateHint": "ޖޮބްތައް ހިނގަނީ އިޚްތިޔާރުކުރެވުނު ތާރީޚަކަށް، ދުވަހަކުވެސް ގަޑިއަކަށް ނޫނެވެ.",
      "blackout": {
        "description": "މި ޗުއްޓީގެ ބާވަތް ފެށުން ނުވަތަ ދިގުދެމުން މަނާ ތާރީޚުތަކެވެ.",
        "severityHint": "ހުއްޓުވުމުން އެދުން ބަލައެއް ނުގަނެވެއެވެ؛ އިންޒާރުން ނޯޓަކާއެކު ފާސްވެއެވެ.",
        "title": "އައު ބްލެކްއައުޓް މުއްދަތު",
        "typeHint": "ހުރިހާ ޗުއްޓީގެ ބާވަތަކަށް ހިންގުމަށް ހުހަށް ބާއްވާށެވެ."
      },
      "blackoutRemoved": "ބްލެކްއައުޓް ނަގައިފި",
      "blackoutSaved": "ބްލެކްއައުޓް ރައްކާކުރެވިއްޖެ",
      "blackoutsEmptyDescription": "ބްލެކްއައުޓަކީ ޗުއްޓީގެ ބާވަތެއް ފެށުން ނުވަތަ ދިގުދެމުން މަނާ ތާރީޚުތަކެވެ — ބާރު ބޮޑު މޫސުން، ސްޓޮކް ގުނުން، ޤާނޫނީ އޮޑިޓް.",
      "blackoutsEmptyTitle": "ބްލެކްއައުޓް މުއްދަތެއް ނެތެވެ",
      "carryForward": {
        "description": "ހުއްދަ ބާކީ އައު ޗުއްޓީގެ އަހަރަށް ގެންގޮސް، ހަމަވެފައިވާ ބައި ބާޠިލުކުރެއެވެ.",
        "done": "{carried} ގެންދެވި، {expired} ހަމަވެ، {skipped} ދޫކޮށްލެވުނެވެ",
        "idempotent": "ދެފަހަރު ހިންގުން ރައްކާތެރިއެވެ: ކޮންމެ މީހަކަށް އަހަރަކު ގިނަވެގެން އެއް ކެރީ ފޯވާޑާއި އެއް ހަމަވުމެވެ.",
        "title": "ކެރީ ފޯވާޑް ހިންގާ"
      },
      "columns": {
        "amount": "ޢަދަދު",
        "days": "ދުވަސް",
        "department": "ޑިޕާޓްމަންޓް",
        "effectiveOn": "ތާރީޚު",
        "kind": "ހަރަކާތް",
        "leaveType": "ޗުއްޓީގެ ބާވަތް",
        "minOnDuty": "ޑިއުޓީގައި އެންމެ މަދު",
        "reason": "ސަބަބު",
        "severity": "ބުރަދަން",
        "weekdays": "ހަފުތާގެ ދުވަސްތައް",
        "window": "މުއްދަތު",
        "year": "ޗުއްޓީގެ އަހަރު"
      },
      "coverage": {
        "description": "ޗުއްޓީގެ ބެލުން ފާސްވުމަށް ޑިއުޓީގައި ތިބެންޖެހޭ މީހުންގެ ޢަދަދެވެ.",
        "maskHint": "ފުރަތަމަ ހޯމަ ދުވަހެވެ. ބެލެނީ ހަމައެކަނި ފާހަގަކުރެވިފައިވާ ދުވަސްތަކެވެ.",
        "title": "އައު އެންމެ މަދު ކަވަރޭޖު"
      },
      "coverageEmptyDescription": "އެންމެ މަދު ކަވަރޭޖުން ބުނަނީ ޑިއުޓީގައި ތިބެންޖެހޭ މީހުންގެ ޢަދަދެވެ، އެއިން އެ ފަހަނައަޅާ ޗުއްޓީގެ އެދުމެއް ބަލައިނުގަނެވޭނެއެވެ.",
      "coverageEmptyTitle": "އެންމެ މަދު ކަވަރޭޖެއް ނެތެވެ",
      "coverageExplainer": "ހަފުތާގެ ދުވަސްތަކަކީ ހޯމަ ދުވަހުން ފެށޭ މާސްކެއް، އޮޕަރޭޓިން ކަލަންޑަރު ބޭނުންކުރާ ހަމަ އެ ގޮތެވެ.",
      "coverageSaved": "އެންމެ މަދު ކަވަރޭޖު ރައްކާކުރެވިއްޖެ",
      "description": "ބްލެކްއައުޓް މުއްދަތުތައް، އެންމެ މަދު ކަވަރޭޖު، އަދި އަހަރީ ކެރީ ފޯވާޑެވެ.",
      "drawer": {
        "balanceTitle": "މިއަދުގެ ބާކީ",
        "description": "މި ބާކީ އުފެއްދި ހަރަކާތްތައް: އެކްރުއަލް، ކެރީ ފޯވާޑް، ހަމަވުން، އަދި ފައިސާއަށް ބަދަލުކުރުމެވެ.",
        "emptyDescription": "މަހުގެ އެކްރުއަލް ފިޔަވައި ހަރަކާތެއް ނެތެވެ.",
        "ledgerCaption": "ޗުއްޓީގެ ހަރަކާތްތައް، އެންމެ ފަހުގެ ފުރަތަމައަށް",
        "loadFailed": "ހަރަކާތްތައް ލޯޑެއް ނުކުރެވުނެވެ",
        "openHint": "ފަހަތުގައިވާ ހަރަކާތްތައް ބެލުމަށް ބާކީއެއް އިޚްތިޔާރުކުރާށެވެ.",
        "title": "{type} ބާކީ"
      },
      "encash": {
        "description": "ދުވަސްތައް ބާކީން އުނިވެ، މުސާރައިގެ ތެރެއިން ފައިސާ ދެވެއެވެ.",
        "noteLabel": "ނޯޓު",
        "paidThroughPayroll": "ދުވަސްތަކުގެ އަގު ކަނޑައަޅަނީ މުސާރައިންނެވެ. މި ސްކްރީނުން ފޮނުވަނީ ދުވަހާއި ސަބަބެވެ.",
        "reasonLabel": "ސަބަބު",
        "title": "ޗުއްޓީ ފައިސާއަށް ބަދަލުކުރޭ",
        "runLabel": "ޕޭރޯލް ރަން",
        "runHint": "އެންކޭޝްމަންޓް ލައިން އުފުލާނެ ރަން. ދުވަސްތަކުގެ އަގު ކަނޑައަޅަނީ ޕޭރޯލުންނެވެ."
      },
      "encashReasons": {
        "annual_encashment": "އަހަރީ ފައިސާއަށް ބަދަލުކުރުން",
        "exit_settlement": "ވަކިވުމުގެ ނިންމުން",
        "other": "އެހެނިހެން",
        "policy_cap_reached": "ސިޔާސަތުގެ ހުދޫދަށް ފޯރައިފި"
      },
      "encashed": "ޗުއްޓީ ފައިސާއަށް ބަދަލުކުރެވިއްޖެ",
      "everyDepartment": "ހުރިހާ ޑިޕާޓްމަންޓެއް",
      "everyLeaveType": "ހުރިހާ ޗުއްޓީގެ ބާވަތެއް",
      "fromDate": "އިން",
      "kinds": {
        "adjustment": "އިޞްލާޙު",
        "carry_forward": "ކުރިއަށް ގެންދެވުނު",
        "carry_forward_expiry": "ކުރިއަށް ގެންދެވުނު ބައި ހަމަވި",
        "encashment": "ފައިސާއަށް ބަދަލުކުރެވުނު",
        "opening": "ފެށޭ ބާކީ"
      },
      "loadFailed": "ޗުއްޓީގެ ސިޔާސަތު ލޯޑެއް ނުކުރެވުނެވެ",
      "severities": {
        "block": "ހުއްޓުވާ",
        "warn": "އިންޒާރު"
      },
      "tabs": {
        "blackouts": "ބްލެކްއައުޓް",
        "coverage": "އެންމެ މަދު ކަވަރޭޖު"
      },
      "title": "ޗުއްޓީގެ ސިޔާސަތުގެ ތަފްޞީލު",
      "toDate": "އަށް",
      "weekdays": {
        "fri": "ހުކުރު",
        "mon": "ހޯމަ",
        "sat": "ހޮނިހިރު",
        "sun": "އާދިއްތަ",
        "thu": "ބުރާސްފަތި",
        "tue": "އަންގާރަ",
        "wed": "ބުދަ"
      }
    },
    "skills": {
      "pageTitle": "ހުނަރުތަކާއި ސެޓްފިކެޓްތައް",
      "pageDescription": "މި ކުންފުނިން ބަލައިގަންނަ ހުނަރުތަކާއި، ސެޓްފިކެޓް މުއްދަތު ހަމަވާން ކައިރިވެފައިވާ ފަރާތްތައް.",
      "explainer": "ކެޓަލޮގް އެޑިޓްކުރުމާއި ފަރުދަކަށް ހުނަރެއް ދިނުމަކީ ޤަޞްދުގައި ވަކިކުރެވިފައިވާ ދެ ހުއްދައެވެ: ސެޓްފިކެޓެއް ބޭނުންވާކަން ނިންމާ ފަރާތަށް، އެ ސެޓްފިކެޓް އަމިއްލަ ނަފްސަށް ދެވިގެން ނުވާނެއެވެ.",
      "tabsLabel": "ހުނަރުތައް",
      "tabRegister": "ރަޖިސްޓްރީ",
      "tabExpiring": "މުއްދަތު ހަމަވަނީ",
      "loadFailed": "ހުނަރުގެ ކެޓަލޮގް ނުނެގުނު",
      "expiringFailed": "މުއްދަތު ހަމަވާ ލިސްޓް ނުނެގުނު",
      "expiringExplainer": "މި މުއްދަތުގެ ތެރޭގައި މި ހުއްދަތަކުގެ މުއްދަތު ހަމަވެއެވެ. ސެޓްފިކެޓް ހިމެނޭ މަސައްކަތަށް އެ ފަރާތް ރޯސްޓަރކުރުމުގެ ކުރިން އައުކުރުން ހަމަޖައްސާ.",
      "emptyTitle": "އަދި ހުނަރެއް ނެތް",
      "emptyDescription": "މި ކުންފުނިން ބަލައިގަންނަ ސެޓްފިކެޓްތަކާއި ހުނަރުތައް އިތުރުކުރޭ، އަދި ފަރުދުންގެ ރެކޯޑުން އެ ފަރާތްތަކަށް ދޭ.",
      "expiringEmptyTitle": "މި މުއްދަތުގައި މުއްދަތު ހަމަވާ އެއްޗެއް ނެތް",
      "expiringEmptyDescription": "މުއްދަތު ފުޅާކުރޭ، ނުވަތަ އެހެން ކުންފުންޏެއް ހޮވާ.",
      "saved": "ހުނަރު ރައްކާކުރެވިއްޖެ",
      "granted": "ހުނަރު ދެވިއްޖެ",
      "revoked": "ދިން ހުއްދަ ނިންމައިފި",
      "statutory": "ޤާނޫނީ",
      "expires": "އެކްސްޕިރެސް",
      "openEnded": "ނިމުމެއް ނެތް",
      "withinLabel": "މުއްދަތު (ދުވަސް)",
      "withinHint": "ކުރިއަށް ބަލާނެ މުއްދަތު. ހުސްކޮށް ބެހެއްޓުމުން ސާވަރުން 90 ދުވަސް ބޭނުންކުރެއެވެ.",
      "expiresLabel": "މި ހުނަރުގެ މުއްދަތު ހަމަވޭ",
      "expiresHint": "މި ދޭއިރު މުއްދަތު ހަމަވާ ތާރީޚެއް އޮންނަން ޖެހެއެވެ.",
      "statutoryLabel": "މިއީ ޤާނޫނީގޮތުން ލާޒިމް ހުނަރެއް",
      "statutoryHint": "ޤާނޫނީގޮތުން ލާޒިމް ހުނަރަކީ އެ މަސައްކަތަށް ޤާނޫނުން ލާޒިމްކުރާ ހުނަރެކެވެ. އޭގެ މުއްދަތު ހަމަވުމަކީ ކުޑަ ކަމެއް ނޫނެވެ.",
      "heldTitle": "ލިބިފައިވާ ހުނަރުތައް",
      "heldDescription": "މި ފަރާތަށް ލިބިފައިވަނީ ކޮން ހުނަރެއް، ކިހާ ދުވަހަކަށް، އަދި ކޮން ހެއްކެއްގެ މައްޗަށްކަން.",
      "heldCaption": "މި ފަރާތަށް ލިބިފައިވާ ހުނަރުތައް",
      "heldEmpty": "މި ފަރާތަށް އަދި އެއްވެސް ހުނަރެއް ދީފައެއް ނުވެއެވެ.",
      "heldFailed": "މި ފަރާތުގެ ހުނަރުތައް ނުނެގުނު",
      "grantDescription": "މި ފަރާތަށް ލިބިފައިވާ ހުނަރަކާއި އޭގެ ހެކި ރެކޯޑްކުރޭ.",
      "levelHint": "ފެންވަރުގެ ދަރަޖައެއް، މާކުހެއް ނޫން.",
      "validToHint": "މުއްދަތު ހަމަނުވާ ހުނަރަކަށް ހުސްކޮށް ބަހައްޓާ.",
      "referenceHint": "އިންސްޕެކްޓަރު އަހާނެ ސެޓްފިކެޓް ނަންބަރު.",
      "revokeTitle": "މި ދިން ހުއްދަ ނިންމަންތަ؟",
      "revokeConsequence": "މި ދިން ހުއްދަ މިއަދުގެ ތާރީޚުން ބަންދުކުރެވެއެވެ. ރޯ ދެމިއޮންނާނެއެވެ: އެއީ މަސައްކަތް ހަވާލުކުރިއިރު މި ފަރާތުގެ ޤާބިލުކަން ސާބިތުކޮށްދޭ ހެއްކެވެ.",
      "actions": {
        "new": "އައު ހުނަރު",
        "edit": "ހުނަރު އެޑިޓްކުރޭ",
        "grant": "ހުނަރެއް ދޭ",
        "end": "ނިންމާ"
      },
      "columns": {
        "code": "ކޯޑު",
        "name": "ނަން",
        "category": "ބައި",
        "statutory": "ޤާނޫނީ",
        "expires": "އެކްސްޕިރެސް",
        "source": "މަޞްދަރު",
        "employee": "މުވައްޒަފު",
        "skill": "ކޮމްޕެޓެންކްޔް",
        "level": "ލެވެލް",
        "validFrom": "ވަލިޑް ން",
        "validTo": "ވަލިޑް އަށް",
        "issuedBy": "ދޫކުރި ފަރާތް",
        "reference": "ރެފެރެންސް"
      }
    }
  },
  "payroll": {
    "filtersTitle": "ފިލްޓަރތައް",
    "allCompanies": "ހުރިހާ ކުންފުނިތައް",
    "routeTitles": {
      "runs": "މުސާރައިގެ ރަންތައް",
      "run": "މުސާރައިގެ ރަން",
      "payslip": "ޕޭސްލިޕް",
      "components": "މުސާރައިގެ ބައިތައް",
      "componentNew": "އައު މުސާރައިގެ ބައި",
      "component": "މުސާރައިގެ ބައި",
      "payGroups": "މުސާރައިގެ ގްރޫޕްތައް",
      "retro": "ފަހުން ދޭ މުސާރަ",
      "return": "ޤާނޫނީ ރިޓަރން",
      "returns": "ޤާނޫނީ ރިޓަރންތައް",
      "serviceCharge": "ޚިދުމަތުގެ އަގު",
      "serviceChargePool": "ޚިދުމަތުގެ އަގުގެ ޕޫލް",
      "serviceChargeSchemes": "ޚިދުމަތުގެ އަގުގެ ސްކީމްތައް",
      "statutoryMappings": "ޤާނޫނީ މެޕިންތައް",
      "statutoryRules": "ޤާނޫނީ ޤަވާޢިދުތައް",
      "wageBases": "މުސާރައިގެ އަސާސްތައް",
      "yearEnd": "އަހަރު ނިމުމުގެ ބަޔާންތައް"
    },
    "fields": {
      "company": "ކުންފުނި",
      "companyPlaceholder": "އިޚްތިޔާރުކުރޭ ކުންފުނި",
      "employee": "މުވައްޒަފު",
      "component": "މުސާރައިގެ ބައި",
      "notes": "ނޯޓްތައް"
    },
    "componentTypes": {
      "earning": "އާމްދަނީ",
      "deduction": "އުނިކުރުން",
      "employer_cost": "ވަޒީފާދޭ ފަރާތުގެ ޚަރަދު"
    },
    "componentTypeHints": {
      "earning": "Adds އަށް ޖުމުލަ މުސާރަ އަދި އަށް މުސާރަ ޚަރަދު ލެޖަރ އީ ޗާޖްކުރެވިފައި.",
      "deduction": "Comes ނިއްވާލާފައި employee's ޖުމުލަ މުސާރަ އަދި އީ ކްރެޑިޓްކުރެވިފައި އަށް ދަރަނި.",
      "employer_cost": "ޚަރަދު އަށް ކުންފުނި މަތީގައި top ގެ ޖުމުލަ މުސާރަ. އެ ދުވަހަކުވެސް ނުވޭ ކުޑަކުރެއެވެ ކޮންއެއްޗެއް މުވައްޒަފު އީ ދައްކާފައި."
    },
    "formulaTypes": {
      "fixed": "ސާބިތު އަދަދު",
      "percent_of_base": "އިންސައްތަ ގެ އަސްލު އަދަދު",
      "per_unit_overtime": "Per އިތުރުގަޑި ގަޑިއިރު",
      "slab": "ދަރަޖަކޮށް ބޭންޑްތައް"
    },
    "formulaHints": {
      "fixed": "އެއް އަދަދު ކޮންމެ މުއްދަތު, whoever މުވައްޒަފު އީ.",
      "percent_of_base": "އިންސައްތަ ގެ employee's ބަހާލެވިފައި އަސާސީ މުސާރަ ނުވަތަ ޕެންޝަން ލިބޭ މުސާރަ.",
      "per_unit_overtime": "ފާސްކުރެވިއްޖެ އިތުރުގަޑީގެ ގަޑިއިރު ގައި named ބާސްކެޓް, priced per ގަޑިއިރު.",
      "slab": "ދަރަޖަކޮށް ބޭންޑްތައް ބޭނުންކުރެވިފައި marginally: ކޮންމެ band's ރޭޓް ޗާޖްކުރެއެވެ ހަމައެކަނި ބައި ގެ އަސްލު އަދަދު އެތެރޭގައި އެ."
    },
    "runTypes": {
      "regular": "އާދައިގެ",
      "off_cycle": "ސައިކަލުން ބޭރު"
    },
    "runStatuses": {
      "draft": "ދެލިކޮޕީ",
      "calculated": "ހިސާބުކުރެވިފައި",
      "reviewed": "މުރާޖަޢާކުރެވިއްޖެ",
      "approved": "ފާސްކުރެވިއްޖެ",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "disbursed": "ދޫކުރެވިފައި"
    },
    "lifecycle": {
      "nextStep": "ދެން: {step}",
      "complete": "މި ހިންގާ އީ ޕޯސްޓްކުރެވިފައި އަދި ދޫކުރެވިފައި. އެތާ އީ އެއްވެސް އެއްޗެއް އިތުރު އަށް ކުރޭ.",
      "nothingPermitted": "އެއްވެސް އެއްޗެއް ނެތް ގެ remaining ފިޔަވަޅުތައް އީ yours އަށް ނަގާ.",
      "calculate": {
        "label": "ހިސާބުކުރޭ",
        "title": "ހިސާބުކުރޭ މި ހިންގާ",
        "willDo": "Works ބޭރަށް ކޮންމެ ބޭނުންކުރެވޭ employee's މުސާރަ އަށްޓަކައި މުއްދަތު އަދި ލިޔެއެވެ ޕޭސްލިޕް ކޮންމެ, އާއެކު full ހިސާބުކުރުން behind ކޮންމެ ލައިން. ހިންގުން އެ އަލުން ބަދަލުކުރެއެވެ މި run's އަމިއްލަ ޕޭސްލިޕްތައް, އެހެންކަމުން އަލުން ހިސާބުކުރުން ފަހުން ބަދަލު އީ ރައްކާތެރި.",
        "done": "ހިންގާ ހިސާބުކުރެވިފައި",
        "doneDetail": "ޕޭސްލިޕްތައް އެބަހުރި ވެފައި ލިޔެފައި. ބަލާ through އިސްތިސްނާތައް ކުރިން ހުށަހެޅުން އެ."
      },
      "review": {
        "label": "Mark މުރާޖަޢާކުރެވިއްޖެ",
        "title": "Mark މި ހިންގާ މުރާޖަޢާކުރެވިއްޖެ",
        "willDo": "ރެކޯޑްކުރެއެވެ އެ ކޮންމެވެސް ފަރާތެއް އެބަހުރި ބަލާފައި ގައި އިސްތިސްނާތައް. އެ ބަދަލުތައް ނެތް އަދަދު — އެ އީ statement އެ ހިންގާ އެބަހުރި ވެފައި ބަލާފައި, އަދި އެ އީ ކޮންއެއްޗެއް lets އެ ވުން ހުށަހަޅާފައި އަށްޓަކައި ފާސްކުރުން.",
        "commentLabel": "ކޮންއެއްޗެއް ކުރި ތިޔަ ފަރާތް ބަލާ?",
        "commentHint": "ރެކޯޑްކުރެވިފައި މަތީގައި އޮޑިޓް ރެކޯޑް އާއެކު ތިޔަ ފަރާތުގެ ނަން.",
        "exceptions": "މި ހިންގާ އެބަހުރި {count} ޕޭސްލިޕްތައް ފާހަގަކުރެވިފައި ގޮތުގައި އިސްތިސްނާތައް. ބަލާ ގައި އެ ކުރިން marking އެ މުރާޖަޢާކުރެވިއްޖެ.",
        "done": "ހިންގާ marked މުރާޖަޢާކުރެވިއްޖެ",
        "doneDetail": "އެ ކުރެވޭ މިހާރު ވުން ހުށަހަޅާފައި އަށްޓަކައި ފާސްކުރުން."
      },
      "submit": {
        "label": "ހުށަހަޅާ އަށްޓަކައި ފާސްކުރުން",
        "title": "ހުށަހަޅާ މި ހިންގާ އަށްޓަކައި ފާސްކުރުން",
        "willDo": "ފޮނުވައެވެ ހިންގާ ތެރެއަށް ފާސްކުރުން ތަރުތީބު އަށްޓަކައި އޭގެ އަދަދު އަދި ކުންފުނި. ނަމަ ނެތް ފާސްކުރުން ސިޔާސަތު ގުޅެއެވެ, އެ އީ ފާސްކުރެވިއްޖެ straight ޗުއްޓީގައި — ކޮން އީ ރަނގަޅު outcome އަށްޓަކައި ވޯކްސްޕޭސް އެ އެބަހުރި ނިންމިފައި މި document ބޭނުންވެއެވެ ނެތް ތަރުތީބު.",
        "done": "ހިންގާ ހުށަހަޅާފައި",
        "doneDetail": "އެ އީ އާއެކު ފާސްކުރާ ފަރާތްތައް މިހާރު, ނުވަތަ މިހާރުވެސް ފާސްކުރެވިއްޖެ ނަމަ ނެތް ސިޔާސަތު ގުޅިފައި."
      },
      "post": {
        "label": "ޕޯސްޓްކުރޭ އަށް ލެޖަރ",
        "title": "ޕޯސްޓްކުރޭ މި ހިންގާ އަށް ލެޖަރ",
        "willDo": "ލިޔެއެވެ އެއް ޖާނަލް އެންޓްރީ, dated އެންމެފަހު ދުވަސް ގެ މުއްދަތު rather ވުރެ ފައިސާ ދައްކާ ތާރީޚު — ޚަރަދު އަދި ދަރަނި އީ incurred ގޮތުގައި ގެ މުއްދަތު މަސައްކަތް ވި ނިމިއްޖެ ގައި. މުސާރަ އަދި ވަޒީފާދޭ ފަރާތް ޚަރަދުތައް އީ ޑެބިޓްކުރެވިފައި, ސާފު މުސާރަ އަދި ކޮންމެ ޤާނޫނީ ދަރަނި ކްރެޑިޓްކުރެވިފައި, އެއް ލައިން per މުވައްޒަފު އަދި ބައި. އެ އީ ދެކޮޅު ހަދައިފި ނަމަ އެ މުއްދަތު އީ ބަންދުކުރެވިފައި.",
        "done": "ހިންގާ ޕޯސްޓްކުރެވިފައި",
        "doneDetail": "ޖާނަލް އީ މަތީގައި ލެޖަރ އަދި ކުރެވޭ ވުން drilled ތެރެއަށް އިން މިތާ."
      },
      "disburse": {
        "label": "Mark ދޫކުރެވިފައި",
        "title": "Mark މި ހިންގާ ދޫކުރެވިފައި",
        "willDo": "ރެކޯޑްކުރެއެވެ އެ money އެބަހުރި ގޮސްފި. އެ ކުރެއެވެ ނޫން ބަދަލުކުރޭ އެއްވެސް money itself އަދި އެ ކުރެއެވެ ނޫން touch ލެޖަރ — ބޭންކް ފައިލް, އަޕްލޯޑްކުރެވިފައި އަށް ބޭންކް, އީ ކޮންއެއްޗެއް pays މީހުން.",
        "done": "ހިންގާ marked ދޫކުރެވިފައި",
        "doneDetail": "ހިންގާ އީ ބަންދުކުރެވިފައި."
      },
      "bankFile": {
        "label": "ބޭންކް ފައިލް",
        "title": "އުފައްދާ net-pay ބޭންކް ފައިލް",
        "willDo": "އުފައްދައެވެ net-pay ފައިލް އަށްޓަކައި އަޕްލޯޑްކުރޭ އަށް ބޭންކް. އެ contains އެކައުންޓް ނަންބަރުތައް ގައި ސާފުކޮށް, ބޭނުންވެއެވެ fresh ދެވަނަ ފެކްޓަރ, އަދި act ގެ އުފެއްދުން އެ އީ ރެކޯޑްކުރެވިފައި ދެކޮޅަށް ތިޔަ ފަރާތުގެ ނަން.",
        "done": "ބޭންކް ފައިލް އުފައްދާފައި",
        "doneDetail": "ބަލާ ލޭއައުޓް އިންޒާރު ކުރިން އަޕްލޯޑްކުރުން އެ."
      },
      "cancel": {
        "label": "ކެންސަލްކުރޭ ހިންގާ",
        "title": "ކެންސަލްކުރޭ މި ހިންގާ",
        "willDo": "ޑިލީޓްކުރެއެވެ ހިންގާ އަދި އޭގެ ޕޭސްލިޕްތައް. މި އީ ހަމައެކަނި ކުރެވޭނެ ކުރިން ފާސްކުރުން, ސަބަބަކީ އެއްވެސް އެއްޗެއް އެބަހުރި ޕޯސްޓްކުރެވިފައި އަދި އަދި އެތާ އީ ނެތް financial ރެކޯޑްކުރޭ އަށް preserve.",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "ރެކޯޑްކުރެވިފައި މަތީގައި އޮޑިޓް ރެކޯޑް. އެ އީ ހަމައެކަނި trace ހިންގާ ބާއްވައެވެ.",
        "reasonRequired": "ސަބަބު އީ ލާޒިމު އަށް ކެންސަލްކުރޭ ހިންގާ.",
        "done": "ހިންގާ ކެންސަލްކުރެވިއްޖެ",
        "doneDetail": "ހިންގާ އަދި އޭގެ ޕޭސްލިޕްތައް އެބަހުރި ވެފައި ޑިލީޓްކުރެވިފައި."
      }
    },
    "runs": {
      "one": "މުސާރައިގެ ރަން",
      "listTitle": "މުސާރައިގެ ރަންތައް",
      "listDescription": "ކޮންމެ މުސާރަ މުއްދަތު, ކޮންއެއްޗެއް އެ came އަށް, އަދި ކޮންތާކު އެ އެބަހުރި got އަށް.",
      "detailDescription": "ޕޭސްލިޕްތައް, އިސްތިސްނާތައް, އޯވަރައިޑްތައް އަދި lifecycle.",
      "summaryTitle": "މި ހިންގާ",
      "loadFailed": "މުސާރައިގެ ރަން ކުރި ނޫން load",
      "emptyTitle": "ނެތް މުސާރައިގެ ރަންތައް އަދި",
      "emptyDescription": "އުފައްދާ އެއް އަށްޓަކައި މުއްދަތު އަދި ހިސާބުކުރޭ އެ — ކޮންމެ ބޭނުންކުރެވޭ މުވައްޒަފު ލިބެއެވެ ޕޭސްލިޕް އާއެކު އޭގެ full ހިސާބުތައް.",
      "draftTitle": "ދެލިކޮޕީ ހިންގާ",
      "backToList": "ހުރިހާ މުސާރައިގެ ރަންތައް",
      "journal": "ލެޖަރ ޖާނަލް",
      "journalNo": "ޖާނަލް",
      "created": "ދެލިކޮޕީ ހިންގާ އުފެއްދިއްޖެ",
      "createdDetail": "އެއްވެސް އެއްޗެއް އީ ހިސާބުކުރެވިފައި އަދި. ހިސާބުކުރޭ އެ ކޮންއިރަކު period's ހާޒިރީ އަދި ޗުއްޓީ އީ ގައި.",
      "noCrossCompanyTotal": "ޖުމުލަތައް އީ per ހިންގާ: ދެ ކުންފުނިތައް ކުރެވިދާނެ state theirs ގައި different currencies, އެހެންކަމުން އެއްވެސް އެއްޗެއް އީ އިތުރުކުރެވިފައި across ރޯތައް.",
      "tabsLabel": "ހިންގާ sections",
      "railSubtitle": "{status} · {periodStart} އަށް {periodEnd}",
      "exceptionsFilter": "އިސްތިސްނާތައް",
      "exceptionsOnly": "ދައްކާ ހަމައެކަނި ފާހަގަކުރެވިފައި ޕޭސްލިޕްތައް",
      "exceptionsOnlyHint": "ޕޭސްލިޕް އީ ފާހަގަކުރެވިފައި ކޮންއިރަކު ސާފު މުސާރަ އީ ތިރީގައި nil ނުވަތަ ޖުމުލަ މުސާރަ އީ nil.",
      "exceptionsHeadline": "{count} ޕޭސްލިޕްތައް އީ ފާހަގަކުރެވިފައި",
      "exceptionsExplainer": "ސާފު މުސާރަ ތިރީގައި nil މާނައަކީ އުނިކުރުންތައް came އަށް އިތުރު ވުރެ ޖުމުލަ. ޖުމުލަ މުސާރަ ގެ nil މާނައަކީ މުވައްޒަފު ހުރި ނެތް މުސާރަ ލިބޭ ދުވަސް ގައި މުއްދަތު. ދެބައި އީ އަގު understanding ކުރިން ހިންގާ އީ ފާސްކުރެވިއްޖެ.",
      "reconciles": "{count} ޕޭސްލިޕްތައް loaded އިތުރުކުރޭ މައްޗަށް އަށް ސާފު ޖުމުލަ މަތީގައި.",
      "reconcileFailedHeadline": "ޕޭސްލިޕްތައް ކުރޭ ނޫން އިތުރުކުރޭ މައްޗަށް އަށް run's ސާފު ޖުމުލަ",
      "reconcileFailed": "ޕޭސްލިޕްތައް loaded come އަށް {total}.",
      "reconcileAuthority": "run's އަމިއްލަ ޖުމުލަތައް އީ އަދަދުތައް ގެ ރެކޯޑްކުރޭ — އެ އީ ކޮންއެއްޗެއް ލެޖަރ ވި ޕޯސްޓްކުރެވިފައި އިން. އަލުން ހިސާބުކުރުން ހިންގާ އީ way އަށް make އެފަރާތްތަކަށް agree.",
      "noPayslipsTitle": "ނެތް ޕޭސްލިޕްތައް އަދި",
      "noPayslipsDescription": "ހިސާބުކުރޭ ހިންގާ އަދި ޕޭސްލިޕް ފެންނާނެއެވެ މިތާ އަށްޓަކައި ކޮންމެ ބޭނުންކުރެވޭ މުވައްޒަފު ގައި މުއްދަތު.",
      "columns": {
        "runNo": "ހިންގާ",
        "period": "މުއްދަތު",
        "periodStart": "މުއްދަތު ފެށެއެވެ",
        "periodEnd": "މުއްދަތު ނިމެއެވެ",
        "paymentDate": "ފައިސާ ދައްކާ ތާރީޚު",
        "runType": "ބާވަތް",
        "employees": "މީހުން",
        "gross": "ޖުމުލަ",
        "deductions": "އުނިކުރުންތައް",
        "net": "ސާފު",
        "employerCost": "ވަޒީފާދޭ ފަރާތުގެ ޚަރަދު",
        "exceptions": "އިސްތިސްނާތައް"
      },
      "tabs": {
        "payslips": "ޕޭސްލިޕްތައް",
        "manualLines": "އޯވަރައިޑްތައް",
        "anomalies": "ބީރައްޓެހި ކަންކަން",
        "provenance": "މަޞްދަރު",
        "retro": "ފަހުން ދޭ",
        "variances": "ތަފާތުތައް"
      },
      "timeline": {
        "created": "ހިންގާ އުފެއްދިއްޖެ",
        "periodEnd": "މުއްދަތު ނިމެއެވެ — journal's ތާރީޚު",
        "paymentDate": "ފައިސާ ދައްކާ ތާރީޚު"
      },
      "fields": {
        "netPayAccount": "ސާފު މުސާރަ ދައްކަންޖެހޭ އެކައުންޓް",
        "bankFileProfile": "ބޭންކް ފައިލް ލޭއައުޓް"
      },
      "actions": {
        "add": "އައު މުސާރައިގެ ރަން"
      },
      "form": {
        "title": "އުފައްދާ މުސާރައިގެ ރަން",
        "description": "ދެލިކޮޕީ ހިންގާ. އެއްވެސް އެއްޗެއް އީ ހިސާބުކުރެވިފައި އަދި އެއްވެސް އެއްޗެއް އީ ޕޯސްޓްކުރެވިފައި ވަންދެން ތިޔަ ފަރާތް ބުނޭ އެހެންކަމުން.",
        "submit": "އުފައްދާ ދެލިކޮޕީ",
        "regularHint": "އާދައިގެ ހިންގާ ކުރެވިދާނެ މުސާރަ މުވައްޒަފު އެއްފަހަރު per މުއްދަތު; ޑޭޓާބޭސް ހުރަސް guarantees އެ.",
        "offCycleHint": "ސައިކަލުން ބޭރު ހިންގާ ކުރެވިދާނެ މުސާރަ ކޮންމެވެސް ފަރާތެއް second ވަގުތު އެތެރޭގައި މުއްދަތު — ބޯނަސް, ނުވަތަ ރަނގަޅުކުރުން.",
        "paymentDateHint": "ކޮންއިރަކު money moves. މި އީ ނޫން journal's ތާރީޚު.",
        "postingDateExplainer": "ޖާނަލް އީ dated އެންމެފަހު ދުވަސް ގެ މުއްދަތު, ނޫން ފައިސާ ދައްކާ ތާރީޚު: މުސާރަ ޚަރަދު އަދި ދަރަނި އަށް މުސާރަ އެ އީ incurred ގޮތުގައި ގެ މުއްދަތު މަސައްކަތް ވި ނިމިއްޖެ ގައި.",
        "netPayAccountHint": "ކްރެޑިޓްކުރެވިފައި އާއެކު ކޮންމެ employee's ސާފު މުސާރަ. ހަމައެކަނި postable ދަރަނި އެކައުންޓްތައް ގެ މި ކުންފުނި އީ offered, ސަބަބަކީ އެ އީ ހަމައެކަނި ones ސާވަރު accepts.",
        "accountPlaceholder": "އިޚްތިޔާރުކުރޭ ދަރަނި އެކައުންޓް",
        "chooseCompanyFirst": "އިޚްތިޔާރުކުރޭ ކުންފުނި ފުރަތަމަ",
        "bankFileProfileHint": "ލޭއައުޓް used ކޮންއިރަކު net-pay ފައިލް އީ އުފައްދާފައި. އެ ކުރެވޭ ވުން އިޚްތިޔާރުކުރެވިފައި ފަހުން.",
        "noProfile": "ނިންމާ ފަހުން",
        "periodDays": "{days} ކަލަންޑަރު ދުވަސް ގައި މި މުއްދަތު",
        "periodUnknown": "އިޚްތިޔާރުކުރޭ ފެށުން އަދި ނިމުން ތާރީޚު",
        "prorationExplainer": "ހުރިހާ އެއްޗެއް އީ ބަހާލެވިފައި ދެކޮޅަށް މި count: mid-period joiner, leaver އަދި anybody މަތީގައި މުސާރަ ނުލިބޭ ޗުއްޓީ އީ ހުރިހާ ދައްކާފައި އަށްޓަކައި ދުވަސް އެފަރާތްތައް ޙަޤީޤަތުގައި މަސައްކަތްކުރި, divided މެދުވެރިކޮށް މި ދުވަސް."
      },
      "reviewBlocked": {
        "anomaly": "މުރާޖަޢާ ބަލައެއް ނުގަނެވޭ: ބޮޑު ބުރަދަނުގެ ބީރައްޓެހި ކަމެއް ހުޅުވިފައިވެއެވެ.",
        "anomalyHint": "ބީރައްޓެހި ކަންކަމުގެ ޓެބް ހުޅުވައި، ބެލި ކަންތައް ބަޔާންކުރާ ނޯޓަކާއެކު ބަލައިގަންނާށެވެ.",
        "variance": "މުރާޖަޢާ ބަލައެއް ނުގަނެވޭ: ބުރަދަން ހުރި ތަފާތެއް ބަޔާންކުރެވިފައެއް ނުވެއެވެ.",
        "varianceHint": "ތަފާތުތަކުގެ ޓެބް ހުޅުވައި، ހުއްޓުވާ ކޮންމެ ސަފުހާއެއް ބަޔާންކުރާށެވެ. އިސްތިސްނާއެއް ނެތެވެ — ފާސްކުރުން ބިނާވެފައިވަނީ އެ ބަޔާނުގެ މައްޗަށެވެ."
      }
    },
    "payslip": {
      "one": "ޕޭސްލިޕް",
      "description": "ކޮންއެއްޗެއް މި ފަރާތް ވި ދައްކާފައި އަށްޓަކައި މި މުއްދަތު, އަދި ކިހިނެއް ކޮންމެ އަދަދު ވި arrived ގައި.",
      "headerTitle": "މުއްދަތު އަދި ދުވަސް",
      "totalsTitle": "ޖުމުލަތައް",
      "loadFailed": "ޕޭސްލިޕް ކުރި ނޫން load",
      "backToRun": "Back އަށް ހިންގާ",
      "viewEmployee": "މުވައްޒަފު ރެކޯޑްކުރޭ",
      "railSubtitle": "{employeeNo} · {periodStart} އަށް {periodEnd}",
      "pdf": "ޕޭސްލިޕް PDF",
      "pdfWorking": "ތައްޔާރުކުރަނީ",
      "pdfPending": "PDF އީ being rendered. އެ ފެންނާނެއެވެ ގައި މި payslip's attachments ކޮންއިރަކު އެ އީ ready.",
      "pdfReady": "ޕޭސްލިޕް PDF ready",
      "pdfReadyDetail": "އެ އީ attached އަށް މި ޕޭސްލިޕް.",
      "pdfFailed": "PDF ކުރެވިދާނެ ނޫން ވުން rendered.",
      "prorationExplainer": "އަސާސީ މުސާރަ އަދި ޕެންޝަން ލިބޭ މުސާރަ އީ ބަހާލެވިފައި ގޮތުގައި އަދަދު × މުސާރަ ލިބޭ ދުވަސް ÷ މުއްދަތު ދުވަސް, ރައުންޑްކުރެވިފައި އެއްފަހަރު. މުސާރަ ލިބޭ ދުވަސް އީ ދުވަސް މަސައްކަތްކުރި ގައި މުއްދަތު މަދު އެއްވެސް މުސާރަ ނުލިބޭ ޗުއްޓީ.",
      "employerCostExplainer": "ވަޒީފާދޭ ފަރާތުގެ ޚަރަދު sits ބޭރުގައި ސާފު މުސާރަ: އެ އީ ޚަރަދު އަށް ކުންފުނި އަދި ކްރެޑިޓް އަށް ދަރަނި, ދުވަހަކުވެސް ނުވޭ ކޮންމެވެސް އެއްޗެއ ނަގާފައި ނިއްވާލާފައި ކޮންއެއްޗެއް މުވައްޒަފު receives.",
      "exceptionHeadline": "މި ޕޭސްލިޕް އީ ފާހަގަކުރެވިފައި އަށްޓަކައި މުރާޖަޢާކުރޭ",
      "exceptionNoDetail": "ފާހަގަކުރެވިފައި, އާއެކު ނެތް އިތުރު ތަފްޞީލު ރެކޯޑްކުރެވިފައި.",
      "reconciles": "ހުރިހާ {count} ބައިތައް މަތީގައި މި ޕޭސްލިޕް އިތުރުކުރޭ މައްޗަށް އަށް ޖުމުލަތައް މަތީގައި.",
      "reconcileFailedHeadline": "ބައިތައް ކުރޭ ނޫން އިތުރުކުރޭ މައްޗަށް އަށް ޖުމުލަތައް",
      "reconcileFailed": "ލައިންތައް come އަށް {earnings} ޖުމުލަ, {deductions} ގައި އުނިކުރުންތައް އަދި {net} ސާފު.",
      "reconcileAuthority": "ޖުމުލަތައް printed މަތީގައި އީ އަދަދުތައް ގެ ރެކޯޑްކުރޭ — ލެޖަރ އަދި ބޭންކް ފައިލް ވި އުފައްދާފައި އިން އެ.",
      "fields": {
        "employeeNo": "މުވައްޒަފު ނަންބަރު",
        "period": "މުއްދަތު",
        "periodDays": "ދުވަސް ގައި މުއްދަތު",
        "payableDays": "މުސާރަ ލިބޭ ދުވަސް",
        "unpaidLeaveDays": "މުސާރަ ނުލިބޭ ޗުއްޓީ ދުވަސް",
        "gross": "ޖުމުލަ މުސާރަ",
        "deductions": "އުނިކުރުންތައް",
        "net": "ސާފު މުސާރަ",
        "employerCost": "ވަޒީފާދޭ ފަރާތުގެ ޚަރަދު"
      }
    },
    "trace": {
      "title": "ކިހިނެއް ކޮންމެ އަދަދު ވި މަސައްކަތްކުރި ބޭރަށް",
      "description": "އެއް އެންޓްރީ per ބައި, އާއެކު ފޯމިއުލާ އެ used, އިންޕުޓްތައް އެ used އަދި ކޮންއެއްޗެއް އެ came އަށް. މި އީ ރެކޯޑްކުރޭ ދެބަސްވެފައިވާ މުސާރަ އީ ނިންމިފައި ދެކޮޅަށް.",
      "emptyTitle": "ނެތް ބައިތައް fired އަށްޓަކައި މި ޕޭސްލިޕް",
      "emptyDescription": "ކޮންމެ ބައި came އަށް nil, އެހެންކަމުން ނެތް ލައިން ވި ލިޔެފައި. ބަލާ އެ މުސާރައިގެ ބައިތައް އީ ބޭނުންކުރެވޭ އަދި އެ މުވައްޒަފު ހުރި މުސާރަ ލިބޭ ދުވަސް.",
      "overridden": "އޯވަރައިޑްކުރެވިފައި",
      "manualOverride": "manual އޯވަރައިޑް އެތެރެކުރެވިފައި މަތީގައި ހިންގާ",
      "bandsCaption": "ކޮންމެ ބޭންޑް ޗާޖްކުރެއެވެ އޭގެ ރޭޓް މަތީގައި ބައި ގެ އަސްލު އަދަދު އެތެރޭގައި އެ, ނޫން މަތީގައި ފުރިހަމަ އަދަދު.",
      "bases": {
        "basic_salary": "އަސާސީ މުސާރަ",
        "pensionable_wage": "ޕެންޝަން ލިބޭ މުސާރަ"
      },
      "fields": {
        "formula": "ފޯމިއުލާ",
        "base": "އަސްލު އަދަދު",
        "baseAmount": "އަސްލު އަދަދު އަދަދު",
        "percent": "އިންސައްތަ",
        "fixedAmount": "ސާބިތު އަދަދު",
        "bucket": "އިތުރުގަޑި ބާސްކެޓް",
        "hours": "ގަޑިއިރު",
        "rate": "ރޭޓް",
        "bandRange": "ބައި ގެ އަސްލު އަދަދު",
        "bandAmount": "ޗާޖްކުރެވިފައި",
        "source": "އަސްލު",
        "overrideAmount": "އަދަދު އެތެރެކުރެވިފައި",
        "note": "ނޯޓް"
      },
      "summary": {
        "fixed": "ސާބިތު އަދަދު ގެ {amount}.",
        "percent_of_base": "{percent}% ގެ {base}, ކޮން ވި {baseAmount}.",
        "per_unit_overtime": "{hours} ގަޑިއިރު ގައި {bucket} ބާސްކެޓް, ގައި {rate} per ގަޑިއިރު.",
        "slab": "{bands} ދަރަޖަކޮށް ބޭންޑްތައް ބޭނުންކުރެވިފައި އަށް {base}, ކޮން ވި {baseAmount}.",
        "manual_override": "އޯވަރައިޑްކުރެވިފައި manually އަށް {amount}. ފޯމިއުލާ މި ބައި ވާނެ އެބަހުރި used ކުރި ނޫން ހިންގާ.",
        "unknown": "މި component's ހިސާބުތައް ވި ރެކޯޑްކުރެވިފައި ގައި form މި ސްކްރީން ކުރެއެވެ ނޫން recognise. ކޮންމެ އަގު ސާވަރު ރައްކާކުރެވިފައި އީ listed ތިރީގައި."
      }
    },
    "manualLines": {
      "title": "Manual އޯވަރައިޑްތައް",
      "description": "އަދަދުތައް އެތެރެކުރެވިފައި މެދުވެރިކޮށް hand އަށްޓަކައި އެއް މުވައްޒަފު އަދި އެއް ބައި މަތީގައި މި ހިންގާ — Ramadan އެލަވަންސް, service-charge share, ރަނގަޅުކުރުން.",
      "emptyTitle": "ނެތް އޯވަރައިޑްތައް މަތީގައި މި ހިންގާ",
      "emptyDescription": "އިތުރުކުރޭ އެއް އަށް މުސާރަ މުވައްޒަފު އަދަދު ފޯމިއުލާތައް ނުކުރެވޭ މަސައްކަތް ބޭރަށް މަތީގައި އެފަރާތްތަކުގެ އަމިއްލަ.",
      "locked": "އޯވަރައިޑްތައް ކުރެވޭ ހަމައެކަނި ވުން ބަދަލުވެފައި while ހިންގާ އީ އަދިވެސް ދެލިކޮޕީ ނުވަތަ freshly ހިސާބުކުރެވިފައި.",
      "saved": "އޯވަރައިޑް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "އަލުން ހިސާބުކުރޭ ހިންގާ އަށްޓަކައި އެ އަށް reach ޕޭސްލިޕްތައް.",
      "removed": "އޯވަރައިޑް ނަގާފައި",
      "removedDetail": "އަލުން ހިސާބުކުރޭ ހިންގާ އަށްޓަކައި ފޯމިއުލާ އަށް ނަގާ over އަލުން.",
      "columns": {
        "amount": "އަދަދު",
        "note": "ނޯޓް"
      },
      "actions": {
        "add": "އިތުރުކުރޭ އޯވަރައިޑް",
        "remove": "ނަގާ"
      },
      "form": {
        "addTitle": "އިތުރުކުރޭ manual އޯވަރައިޑް",
        "editTitle": "އެޑިޓްކުރޭ މި އޯވަރައިޑް",
        "description": "އެއް އަދަދު, އަށްޓަކައި އެއް މުވައްޒަފު, މަތީގައި އެއް ބައި ގެ މި ހިންގާ.",
        "replacesHeadline": "މި ބަދަލުކުރެއެވެ component's ފޯމިއުލާ އަށްޓަކައި މި މުވައްޒަފު.",
        "replaces": "ކޮންމެ އެއްޗެއް ފޯމިއުލާ ވާނެ އެބަހުރި computed ކުރެއެވެ ނޫން ހިންގާ. payslip's ހިސާބުތައް ވާނެ ބުނޭ އަދަދު ވި އެތެރެކުރެވިފައި manually.",
        "recalculateFirst": "އެ ނަގައެވެ effect މަތީގައި ދެން ހިސާބުކުރޭ. ހިންގާ މިހާރުވެސް ހިސާބުކުރެވިފައި ބަހައްޓައެވެ އޭގެ މިހާރުގެ އަދަދުތައް ވަންދެން އެ އީ އަލުން ހިސާބުކުރެވިފައި.",
        "employeePlaceholder": "އިޚްތިޔާރުކުރޭ މުވައްޒަފު",
        "componentPlaceholder": "އިޚްތިޔާރުކުރޭ މުސާރައިގެ ބައި",
        "componentContext": "{name} އީ {type} ކާކުގެ ފޯމިއުލާ އީ normally {formula}.",
        "amountHint": "ސީދާ ގޮތުގައި އެ ޖެހޭ ފެންނާނެ މަތީގައި ޕޭސްލިޕް.",
        "amountRequired": "އަދަދު އީ ލާޒިމު.",
        "amountShape": "އެތެރެކުރޭ plain ޑެސިމަލް އަދަދު, ފަދަ ގޮތުގައި 2500 ނުވަތަ 2500.00.",
        "noteHint": "ކީއްވެ މި އޯވަރައިޑް exists. އެ ފެންނާނެއެވެ ގައި payslip's ހިސާބުތައް."
      }
    },
    "components": {
      "one": "މުސާރައިގެ ބައި",
      "listTitle": "މުސާރައިގެ ބައިތައް",
      "listDescription": "ފޯމިއުލާތައް ކޮންމެ ޕޭސްލިޕް އީ built އިން. ޤާނޫނީ ރޭޓްތައް live މިތާ ގޮތުގައި ޑޭޓާ, ނޫން ގައި ކޯޑް.",
      "detailDescription": "އެއް ލައިން ގެ މުސާރަ ފޯމިއުލާ.",
      "newTitle": "އައު މުސާރައިގެ ބައި",
      "identityTitle": "ކޮންއެއްޗެއް މި ބައި އީ",
      "formulaTitle": "ކިހިނެއް އެ އީ މަސައްކަތްކުރި ބޭރަށް",
      "accountsTitle": "ލެޖަރ އެކައުންޓްތައް",
      "accountsDescription": "ކޮންތާކު ޕޯސްޓްކުރެވިފައި ހިންގާ ޗާޖްކުރެއެވެ އަދި ކްރެޑިޓްކުރޭ މި ބައި. ކޯޑްތައް އީ ގުޅިފައި ދެކޮޅަށް ކޮންމެ company's ޗާޓް ކޮންއިރަކު ހިންގާ އީ ޕޯސްޓްކުރެވިފައި.",
      "loadFailed": "މުސާރައިގެ ބައިތައް ކުރި ނޫން load",
      "emptyTitle": "ނެތް މުސާރައިގެ ބައިތައް އަދި",
      "emptyDescription": "އިތުރުކުރޭ އެއް — އަސާސީ މުސާރަ އީ ޢާންމުކޮށް ފުރަތަމަ — އަދި ކޮންމެ ހިސާބުކުރެވިފައި ޕޭސްލިޕް ވާނެ carry އެ.",
      "searchPlaceholder": "ހޯދާ ކޯޑް ނުވަތަ ނަން",
      "backToList": "ހުރިހާ މުސާރައިގެ ބައިތައް",
      "created": "މުސާރައިގެ ބައި އުފެއްދިއްޖެ",
      "saved": "މުސާރައިގެ ބައި ރައްކާކުރެވިއްޖެ",
      "reload": "އަލުން ލޯޑްކުރޭ މި ބައި",
      "active": "ގައި use",
      "inactive": "ހުއްޓާލާފައި",
      "activeOnly": "ގައި use",
      "inactiveOnly": "ހުއްޓާލާފައި",
      "conflictTitle": "ކޮންމެވެސް ފަރާތެއް else ބަދަލުވެފައި މި ބައި while ތިޔަ ފަރާތް ހުރި އެ ހުޅުވާ",
      "conflictBody": "އެއްވެސް އެއްޗެއް ވި overwritten. އަލުން ލޯޑްކުރޭ އަށް ބަލާ އެފަރާތްތަކުގެ version, އެއަށްފަހު reapply ތިޔަ ފަރާތުގެ ބަދަލުތައް.",
      "rulesAsDataExplainer": "ރޭޓްތައް އީ ޑޭޓާ, ނޫން ކޯޑް. MPAO's މުވައްޒަފު އަދި ވަޒީފާދޭ ފަރާތް ބައިވެރިވުންތައް އީ ދެ ރޯތައް މިތާ, އަދި ބަދަލުކުރުން ޤާނޫނީ ރޭޓް އީ އެޑިޓްކުރޭ މަތީގައި މި ސްކްރީން rather ވުރެ ރިލީޒް.",
      "effectExplainer": "އެޑިޓްކުރުން ބައި ބަދަލުތައް ކޮންއެއްޗެއް ކުރިއަށް އޮތް ހިސާބުކުރުންތައް އުފައްދާ. ޕޭސްލިޕްތައް މިހާރުވެސް ހިސާބުކުރެވިފައި ބަހައްޓާ އެފަރާތްތަކުގެ އަދަދުތައް ވަންދެން އެފަރާތްތަކުގެ ހިންގާ އީ އަލުން ހިސާބުކުރެވިފައި, އަދި ޕޯސްޓްކުރެވިފައި ރަންތައް ދުވަހަކުވެސް ނުވޭ ބަދަލު.",
      "columns": {
        "sequence": "ތަރުތީބު",
        "code": "ކޯޑް",
        "type": "ބާވަތް",
        "formula": "ފޯމިއުލާ",
        "accounts": "އެކައުންޓްތައް"
      },
      "fields": {
        "expenseAccount": "ޚަރަދު އެކައުންޓް ކޯޑް",
        "liabilityAccount": "ދަރަނި އެކައުންޓް ކޯޑް"
      },
      "actions": {
        "add": "އިތުރުކުރޭ މުސާރައިގެ ބައި"
      },
      "summary": {
        "fixed": "ސާބިތު {amount}",
        "percent_of_base": "{percent}% ގެ {base}",
        "per_unit_overtime": "{rate} per ގަޑިއިރު ގައި {bucket} ބާސްކެޓް",
        "slab": "{bands} ދަރަޖަކޮށް ބޭންޑްތައް މަތީގައި {base}",
        "unknown": "ނޭނގޭ ފޯމިއުލާ"
      },
      "form": {
        "codeHint": "ކުރު އަދި ދާއިމީ, ފަދަ ގޮތުގައި BASIC ނުވަތަ MPAO-EE. އެ ނުކުރެވޭ ވުން ބަދަލުވެފައި ފަހުން.",
        "sequenceHint": "ތަރުތީބު ބައިތައް ފެންނާނެ ގައި މަތީގައި ޕޭސްލިޕް. އެ ކުރެއެވެ ނޫން ބަދަލު އެއްވެސް ހިސާބު.",
        "fixedAmountHint": "އެއް އަދަދު ކޮންމެ މުއްދަތު, އަށްޓަކައި ކޮންމެ މުވައްޒަފު މި ބައި ބޭނުންކުރެއެވެ އަށް.",
        "percentHint": "ގޮތުގައި އިންސައްތަ, އެހެންކަމުން 7 މާނައަކީ seven per cent.",
        "bucketHint": "އިތުރުގަޑީގެ ގަވާއިދު ކޯޑް މި ގަޑިއިރު come އިން, ފަދަ ގޮތުގައި OT150.",
        "perUnitRateHint": "ކޮންއެއްޗެއް އެއް ގަޑިއިރު ގައި އެ ބާސްކެޓް އީ އަގު.",
        "expenseAccountHint": "ޑެބިޓްކުރެވިފައި ކޮންއިރަކު ހިންގާ އީ ޕޯސްޓްކުރެވިފައި. އާމްދަނީ އަދި ވަޒީފާދޭ ފަރާތް ޚަރަދުތައް ބޭނުންވޭ އެއް.",
        "liabilityAccountHint": "ކްރެޑިޓްކުރެވިފައި ކޮންއިރަކު ހިންގާ އީ ޕޯސްޓްކުރެވިފައި. އުނިކުރުންތައް އަދި ވަޒީފާދޭ ފަރާތް ޚަރަދުތައް ބޭނުންވޭ އެއް.",
        "isActive": "ގައި use",
        "isActiveHint": "ހުއްޓާލާފައި ބައި ހުއްޓާލައެވެ appearing މަތީގައި newly ހިސާބުކުރެވިފައި ޕޭސްލިޕްތައް އަދި ބާއްވައެވެ ޕޯސްޓްކުރެވިފައި ones alone."
      },
      "bands": {
        "upTo": "މައްޗަށް އަށް",
        "noUpperBound": "ހުރިހާ އެއްޗެއް މަތީގައި",
        "add": "އިތުރުކުރޭ ބޭންޑް",
        "remove": "ނަގާ",
        "shapeExplainer": "ބޭންޑްތައް ascend, އަދި އެންމެފަހު އެއް އެބަހުރި ނެތް upper bound — އެ ޗާޖްކުރެއެވެ ހުރިހާ އެއްޗެއް މަތީގައި ބޭންޑް ކުރިން އެ. ކޮންމެ band's ރޭޓް ބޭނުންކުރެއެވެ ހަމައެކަނި އަށް ބައި ގެ އަސްލު އަދަދު އެތެރޭގައި އެ.",
        "atLeastOne": "ދަރަޖަކޮށް ފޯމިއުލާ ބޭނުންވެއެވެ ގައި މަދުވެގެން އެއް ބޭންޑް.",
        "lastUnbounded": "އެންމެފަހު ބޭންޑް ޖެހޭ އެބަހުރި ނެތް upper bound.",
        "onlyLastUnbounded": "ހަމައެކަނި އެންމެފަހު ބޭންޑް ކުރެވިދާނެ އެބަހުރި ނެތް upper bound.",
        "ascending": "ބޭންޑް {index} ޖެހޭ އެބަހުރި higher upper bound ވުރެ ބޭންޑް ކުރިން އެ.",
        "upToAria": "Upper bound ގެ ބޭންޑް {index}",
        "rateAria": "ރޭޓް ގެ ބޭންޑް {index}",
        "rateHint": "8.75% އަށް 8.75 ލިޔުއްވާ.",
        "rateRange": "ބޭންޑް {index} ގެ ރޭޓް 0 އާއި 100 އާ ދެމެދު އިންސައްތައެއް ކަމުގައި ވާންވާނެއެވެ."
      }
    },
    "bankFile": {
      "title": "ސާފު މުސާރަ ބޭންކް ފައިލް",
      "subject": "އަށްޓަކައި ހިންގާ {runNo}",
      "notVerified": "މި ލޭއައުޓް އީ ނޫން ޔަޤީންކުރެވިފައި ބޭންކް specification.",
      "editable": "{profile} ލޭއައުޓް އީ editable ޑޭޓާ, އެހެންކަމުން ގޯސް ކޮލަމް ކުރެވޭ ވުން ރަނގަޅުކުރެވިފައި ނެތި ރިލީޒް.",
      "plaintext": "މި ފައިލް contains އެކައުންޓް ނަންބަރުތައް ގައި ސާފުކޮށް. އުފެއްދުން އެ އީ ރެކޯޑްކުރެވިފައި ދެކޮޅަށް ތިޔަ ފަރާތުގެ ނަން, އާއެކު ނަންބަރު ގެ ފައިސާ ލިބޭ ފަރާތްތައް އެ covered.",
      "stepUpRequired": "ޔަޤީންކުރޭ ތިޔަ ފަރާތުގެ ދެވަނަ ފެކްޓަރ އަލުން ކުރިން މި އީ allowed, އެއަށްފަހު try އެއްފަހަރު އިތުރު.",
      "stepUpLink": "Set އެ މައްޗަށް މަތީގައި ތިޔަ ފަރާތުގެ ޕްރޮފައިލް",
      "profile": "ލޭއައުޓް",
      "filename": "ފައިލް ނަން",
      "rows": "ފައިސާ ލިބޭ ފަރާތްތައް",
      "checksum": "ޗެކްސަމް",
      "previewLabel": "ފުރަތަމަ ލައިންތައް, އެހެންކަމުން shape ކުރެވޭ ވުން ބަލާފައި ކުރިން އެ އީ އަޕްލޯޑްކުރެވިފައި.",
      "previewTruncated": "ހަމައެކަނި ފުރަތަމަ ލައިންތައް އީ ދައްކާފައި. ޑައުންލޯޑްކުރޭ contains ކޮންމެ ރޯ.",
      "download": "ޑައުންލޯޑްކުރޭ ފައިލް",
      "downloaded": "ބޭންކް ފައިލް ޑައުންލޯޑްކުރެވިއްޖެ",
      "retry": "އުފައްދާ ފައިލް",
      "working": "އުފެއްދުން"
    },
    "anomalies": {
      "acknowledge": {
        "description": "ބެލި ކަންތައް ބަޔާންކުރާ ނޯޓެއް، ދެން ކިޔާ ފަރާތުން އަލުން ނުބަލާ ގޮތަށެވެ.",
        "noteHint": "ބެލި ޢަދަދާއި، އެ ރަނގަޅު ސަބަބު ބަޔާންކުރާށެވެ.",
        "noteLabel": "ބެލި ކަންތައް",
        "title": "ބީރައްޓެހި ކަން ބަލައިގަނޭ"
      },
      "acknowledged": "ބީރައްޓެހި ކަން ބަލައިގަނެވިއްޖެ",
      "actions": {
        "acknowledge": "ބަލައިގަނޭ"
      },
      "blocksReview": "ބޮޑު ބުރަދަނުގެ {count} ބީރައްޓެހި ކަމެއް ހުޅުވިފައިވެއެވެ",
      "blocksReviewWhy": "ޑިޓެކްޓަރަކީ ލަފާކުރުމެއް، އަދި ގިނަފަހަރު ގޯސްވެއެވެ، އެހެންކަމުން ނޯޓަކާއެކު ބަލައިގަތުމަކީ ކޮންޓްރޯލެވެ — ހިމޭނުން ފާސްކުރުމެއް ނޫނެވެ.",
      "clear": "ހުޅުވިފައިވާ ބޮޑު ބުރަދަނުގެ ބީރައްޓެހި ކަމެއް ނެތެވެ. މުރާޖަޢާ ކުރިއަށް ގެންދެވިދާނެއެވެ.",
      "columns": {
        "figures": "ޢަދަދުތައް",
        "kind": "ފެނުނު ކަންތައް",
        "note": "ނޯޓު",
        "severity": "ބުރަދަން"
      },
      "description": "މި ރަނުގެ މައްޗަށް ހިނގާ ކަނޑައެޅިފައިވާ ޑިޓެކްޓަރުތަކެވެ. ތިރީގައިވާ ކޮންމެ ޢަދަދަކީ ހިސާބުކުރެވުނު އެއްޗެއް، ލިޔެވުނު ވާހަކައެއް ނޫނެވެ.",
      "emptyDescription": "މި ރަނާ ދެކޮޅަށް އެއްވެސް ޑިޓެކްޓަރެއް ނުހިނގައެވެ.",
      "emptyTitle": "ފާހަގަކުރެވުނު އެއްޗެއް ނެތެވެ",
      "kinds": {
        "bank_changed_this_period": "މި މުއްދަތުގައި ބޭންކް އެކައުންޓް ބަދަލުވި",
        "duplicate_bank_destination": "ދެ މުވައްޒަފަކު އެއް ބޭންކް މަންޒިލެއް ބޭނުންކުރެއެވެ",
        "first_pay_above_grade_max": "ދަރަޖައިގެ އެންމެ މަތިން މަތީ ފުރަތަމަ މުސާރަ",
        "negative_net": "ސާފު މުސާރަ ނެގެޓިވް",
        "net_unchanged_despite_unpaid_leave": "މުސާރަ ނުލިބޭ ޗުއްޓީއެއް އޮތަސް ސާފު މުސާރަ ބަދަލެއް ނުވޭ",
        "net_zscore": "މި މީހާގެ އަމިއްލަ ދަރަޖައާ ދުރު ސާފު މުސާރަ",
        "new_component": "މިދިޔަ މުއްދަތުގައި ނެތް ބައެއް ފެނިއްޖެ",
        "pay_without_attendance": "ހާޒިރީއެއް ރެކޯޑްނުވެ ފައިސާ ދެވިފައި",
        "terminated_still_paid": "ވަޒީފާއިން ވަކިވުމަށްފަހު ފައިސާ ދެވިފައި",
        "vanished_component": "މިދިޔަ މުއްދަތުގައި ހުރި ބައެއް ނެތެވެ"
      },
      "loadFailed": "ބީރައްޓެހި ކަންކަން ލޯޑެއް ނުކުރެވުނެވެ",
      "runWide": "މުޅި ރަން",
      "severities": {
        "high": "މަތި",
        "low": "ދަށް",
        "medium": "މެދު"
      },
      "statuses": {
        "acknowledged": "ބަލައިގަނެފައި",
        "dismissed": "ފޮރުވިފައި",
        "open": "ހުޅުވިފައި"
      },
      "title": "ބީރައްޓެހި ކަންކަން"
    },
    "payGroups": {
      "actions": {
        "new": "އައު މުސާރައިގެ ގްރޫޕް"
      },
      "active": "ހަރަކާތްތެރި",
      "anchorHint": "މުއްދަތެއް ފެށޭ މަހުގެ ދުވަހެވެ.",
      "columns": {
        "anchor": "ފެށޭ ދުވަސް",
        "code": "ކޯޑު",
        "frequency": "ތަކުރާރުވުން",
        "lag": "ފައިސާގެ ލަސްވުން"
      },
      "create": {
        "description": "މުސާރައިގެ ރަނަކުން ކަލަންޑަރު ވާރުތަކުރާ ގްރޫޕެކެވެ.",
        "title": "އައު މުސާރައިގެ ގްރޫޕް"
      },
      "default": "ޑިފޯލްޓް",
      "defaultHint": "ރަނަކުން ގްރޫޕެއް ނުބުނާ ހާލަތުގައި ބޭނުންކުރެވެއެވެ.",
      "defaultMoves": "މި ކަނޑައެޅުމުން މިހާރު ޑިފޯލްޓް ހިފަހައްޓާ ގްރޫޕުން އެ ނެގޭނެއެވެ.",
      "description": "ރަނަކުން ވާރުތަކުރާ ތަކުރާރުވުމާއި، މުއްދަތުގެ ފެށޭ ދުވަހާއި، ފައިސާ ދިނުމުގެ ލަސްވުމެވެ.",
      "edit": {
        "title": "މުސާރައިގެ ގްރޫޕް އެޑިޓްކުރޭ"
      },
      "emptyDescription": "މުސާރައިގެ ކޮންމެ ރަނެއް ނިސްބަތްވަނީ މުސާރައިގެ ގްރޫޕަކަށެވެ. މަދުވެގެން މަހުގެ ސައިކަލަށް އެއް ގްރޫޕް އުފައްދާށެވެ.",
      "emptyTitle": "އަދި މުސާރައިގެ ގްރޫޕެއް ނެތެވެ",
      "frequencies": {
        "fortnightly": "ދެ ހަފުތާއިން",
        "monthly": "މަހުން މަހަށް",
        "weekly": "ހަފުތާއިން"
      },
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "lagHint": "މުއްދަތު ނިމުމާއި ފައިސާ ދިއުމާ ދެމެދު ދުވަހުގެ ޢަދަދެވެ.",
      "loadFailed": "މުސާރައިގެ ގްރޫޕްތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "saved": "މުސާރައިގެ ގްރޫޕް ރައްކާކުރެވިއްޖެ",
      "title": "މުސާރައިގެ ގްރޫޕްތައް"
    },
    "provenance": {
      "columns": {
        "citation": "ރިފަރެންސް",
        "effectiveFrom": "ފެށޭ ތާރީޚު",
        "lines": "ސަފުހާތައް",
        "reviewDue": "މުރާޖަޢާގެ ތާރީޚު",
        "rule": "ޤަވާޢިދު",
        "source": "މަޞްދަރު",
        "total": "ޖުމުލަ"
      },
      "description": "މި ރަނުން ހިންގި ކޮންމެ ޤަވާޢިދެއް، ފަހަތުގައިވާ ޕެކްގެ ވަރޝަނާއި މަޞްދަރާއެކުއެވެ.",
      "emptyDescription": "ރަން ހިސާބުކުރާށެވެ، ދެން ބޭނުންކުރި ޤަވާޢިދުތައް މިތާ ފެންނާނެއެވެ.",
      "emptyTitle": "ޤަވާޢިދެއް ނުހިނގައެވެ",
      "loadFailed": "މަޞްދަރު ލޯޑެއް ނުކުރެވުނެވެ",
      "noCitation": "މަޞްދަރެއް ރެކޯޑްވެފައެއް ނެތް",
      "notOverridable": "ޕެކް ޤަވާޢިދެއް އަމިއްލައަށް ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "overdue": "ލަސްވެފައި",
      "popover": {
        "label": "މި ސަފުހާ އައި ތަން",
        "trigger": "މަޞްދަރު"
      },
      "reviewOverdue": "{count} ޤަވާޢިދެއްގެ މުރާޖަޢާގެ ތާރީޚު ފަހަނައަޅައި ގޮސްފައިވެއެވެ.",
      "sources": {
        "legacy": "ކުރީގެ",
        "pack": "ޕެކް",
        "tenant": "އަމިއްލަ"
      },
      "title": "މަޞްދަރު",
      "unverifiedExplainer": "މި ސަފުހާތަކުގެ ފަހަތުގައިވާ ރޭޓުތައް އަޞްލު މަޞްދަރަކާ އަޅައި ސައްޙަކުރެވިފައެއް ނުވެއެވެ.",
      "unverifiedHeadline": "{count} ޤަވާޢިދެއްގައި ސައްޙަނުކުރެވޭ މަޞްދަރެއް ވެއެވެ"
    },
    "retro": {
      "actions": {
        "dismiss": "ފޮރުވާ"
      },
      "columns": {
        "affected": "އަސަރުކުރި މުއްދަތު",
        "change": "ބަދަލު",
        "component": "ބައި",
        "delta": "ތަފާތު",
        "field": "ގޮޅި",
        "kind": "ބަދަލުވި އެއްޗެއް",
        "originPeriod": "އަޞްލު މުއްދަތު",
        "original": "ކުރިން ދެވުނު",
        "recomputed": "އަލުން ހިސާބުކުރެވުނު"
      },
      "description": "ރަނެއް ޕޯސްޓްކޮށްފައިވާ މުއްދަތެއްގައި ޖެހުނު ބަދަލުތަކެވެ. ތަފާތު ދެނީ ދެން އަންނަ ރަނުންނެވެ.",
      "dismiss": {
        "consequence": "މި ބަދަލުގެ ތަފާތު އެއްވެސް މީހަކަށް ނުދެވޭނެއެވެ.",
        "description": "ފޮރުވުމުން ބުނެވެނީ މި ބަދަލަށް ފަހަތަށް ފައިސާ ދޭން ނުޖެހޭ ކަމަށެވެ.",
        "noteLabel": "ނޯޓު",
        "reasonLabel": "ސަބަބު",
        "title": "ފަހުން ދޭ މުސާރައިގެ ހަރަކާތް ފޮރުވާ"
      },
      "dismissReasons": {
        "already_settled_manually": "ކުރިންވެސް އަތުން ނިންމިފައި",
        "data_entry_correction": "ޑޭޓާ އެންޓްރީގެ ކުށެއް އިޞްލާޙުކުރުން",
        "duplicate_event": "ތަކުރާރު ހަރަކާތެއް",
        "not_payable_retrospectively": "ފަހަތަށް ފައިސާ ނުދެވޭ",
        "other": "އެހެނިހެން"
      },
      "dismissed": "ފަހުން ދޭ މުސާރައިގެ ހަރަކާތް ފޮރުވިއްޖެ",
      "emptyDescription": "މި ރަނުން ކުރީގެ މުއްދަތުތަކުގެ ތަފާތެއް ނުދެއެވެ.",
      "emptyTitle": "ފަހުން ދޭ މުސާރައިގެ ސަފުހާއެއް ނެތެވެ",
      "eventsEmptyDescription": "ޕޯސްޓްކުރެވިފައިވާ މުއްދަތަކަށް ފަހަތަށް ބަދަލެއް ގެނެވިފައެއް ނުވެއެވެ.",
      "eventsEmptyTitle": "ފަހުން ދޭ މުސާރައިގެ ހަރަކާތެއް ނެތެވެ",
      "kinds": {
        "assignment": "ވަޒީފާގެ ޝަރުޠު",
        "attendance": "ހާޒިރީ",
        "component": "މުސާރައިގެ ބައި",
        "leave": "ޗުއްޓީ",
        "statutory_rule": "ޤާނޫނީ ޤަވާޢިދު"
      },
      "loadFailed": "ފަހުން ދޭ މުސާރައިގެ ހަރަކާތްތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "openExplainer": "ހުޅުވިފައިވާ {count} ހަރަކާތެއް، އެ ކުންފުނީގެ ދެން އަންނަ މުސާރައިގެ ރަނުން ނަގާނެއެވެ.",
      "packRule": "ޕެކް ޤަވާޢިދު",
      "panelDescription": "މި ރަނުން ކުރީގެ މުއްދަތުތަކަށް ދޭ އެއްޗާއި، ދޭ ސަބަބެވެ.",
      "panelTitle": "ފަހުން ދޭ ސަފުހާތައް",
      "repairs": "ކުރީގެ {count} މުއްދަތެއް އިޞްލާޙުކުރަނީ",
      "statuses": {
        "applied": "ދެވިފައި",
        "dismissed": "ފޮރުވިފައި",
        "open": "ހުޅުވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "title": "ފަހުން ދޭ މުސާރަ"
    },
    "returns": {
      "actions": {
        "approve": "ފާސްކުރޭ",
        "confirmRemittance": "ކަށަވަރުކުރޭ",
        "export": "ފައިލް ޑައުންލޯޑްކުރޭ",
        "file": "ފައިލްކުރޭ",
        "new": "އައު ރިޓަރން",
        "prepare": "ތައްޔާރުކުރޭ",
        "prepareRemittance": "ފައިސާ ފޮނުވުން ތައްޔާރުކުރޭ",
        "reconcile": "ދިމާކުރޭ"
      },
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "approve": {
        "description": "ފާސްކުރުމުން ފައިލްގައި ދާނެ ޢަދަދުތައް ފައިނަލްވެއެވެ.",
        "noteLabel": "ނޯޓު",
        "title": "ރިޓަރން ފާސްކުރޭ"
      },
      "approved": "ރިޓަރން ފާސްކުރެވިއްޖެ",
      "codeHint": "މި ރިޓަރނުން ރިޕޯޓްކުރާ ޤަވާޢިދުގެ އާއިލާ: އެމްޕީއޭއޯ، އީޕީއެފް، އޭޕީއައިޓީ.",
      "columns": {
        "amount": "ޢަދަދު",
        "base": "އަސާސް",
        "code": "ރިޓަރންގެ ކޯޑު",
        "difference": "ތަފާތު",
        "dueOn": "ދޭން ޖެހޭ ތާރީޚު",
        "employeeAmount": "މުވައްޒަފު",
        "employees": "މުވައްޒަފުން",
        "employerAmount": "ވަޒީފާދޭ ފަރާތް",
        "paymentDate": "ފައިސާ ދޭ ތާރީޚު",
        "period": "މުއްދަތު",
        "reference": "ރިފަރެންސް",
        "returnNo": "ރިޓަރން ނަންބަރު",
        "statutoryId": "ޤާނޫނީ އައިޑީ",
        "total": "ޖުމުލަ"
      },
      "confirmRemittance": {
        "description": "ބޭންކް އެކައުންޓުން ފައިސާ ޙަޤީޤަތުގައި ދިއުމަށްފަހު އެކަނި ކަށަވަރުކުރާށެވެ.",
        "posts": "މިއިން ޖާނަލެއް ޕޯސްޓްވެއެވެ: ޤާނޫނީ ދޭން ޖެހޭ ފައިސާ ބޭންކާ އަޅައި ސާފުކުރެވެއެވެ.",
        "stepUp": "މި ޕޯސްޓްވުމުގެ ކުރިން އައު ދެވަނަ ފެކްޓަރެއް ބޭނުންވެއެވެ.",
        "title": "ފައިސާ ފޮނުވުން ކަށަވަރުކުރޭ"
      },
      "create": {
        "description": "ކޮންމެ ކުންފުންޏަކަށް ކޮންމެ މުއްދަތަކަށް ކޮންމެ ޤަވާޢިދުގެ އާއިލާއަކަށް އެއް ރިޓަރނެވެ.",
        "title": "އައު ޤާނޫނީ ރިޓަރން"
      },
      "created": "ރިޓަރން އުފެއްދިއްޖެ",
      "description": "ޕޯސްޓްކުރެވުނު ޕޭސްލިޕުތަކުން ތައްޔާރުކުރެވި، ލެޖަރާ ދިމާކުރެވި، ފާސްކުރެވި، ފައިލްކުރެވެއެވެ.",
      "detailDescription": "އޭގެ ސަފުހާތައް، ދިމާކުރުން، ފައިލް، އަދި ފައިސާ ދިނުމެވެ.",
      "detailTitle": "ޤާނޫނީ ރިޓަރން",
      "draftNo": "ދެލިކޮޕީ",
      "emptyDescription": "މުއްދަތަކަށް ރިޓަރނެއް އުފައްދާ، އެ މުއްދަތުގައި ޕޯސްޓްވި ޕޭސްލިޕުތަކުން ތައްޔާރުކުރާށެވެ.",
      "emptyTitle": "އަދި ރިޓަރނެއް ނެތެވެ",
      "file": {
        "description": "އިދާރާއިން ދިން ރިފަރެންސް ރެކޯޑްކުރާށެވެ.",
        "referenceLabel": "ފައިލްކުރުމުގެ ރިފަރެންސް",
        "title": "ރިޓަރން ފައިލްކުރޭ"
      },
      "fileDownloaded": "ފައިލް ތައްޔާރުކުރެވިއްޖެ: {rows} ސަފުހާ",
      "filed": "ރިޓަރން ފައިލްކުރެވިއްޖެ",
      "linesEmptyDescription": "ރިޓަރން ތައްޔާރުކުރާށެވެ، ދެން ޕޯސްޓްކުރެވުނު ޕޭސްލިޕް ސަފުހާތައް މިތާ ފެންނާނެއެވެ.",
      "linesEmptyTitle": "އަދި ސަފުހާއެއް ނެތެވެ",
      "linesTitle": "ރިޓަރންގެ ސަފުހާތައް",
      "loadFailed": "ރިޓަރންތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "prepared": "ރިޓަރން ތައްޔާރުކުރެވިއްޖެ",
      "reconciliation": {
        "blocked": "ރިޓަރން ލެޖަރާ ދިމައެއް ނުވެއެވެ",
        "blockedWhy": "ތަފާތު ސުމަކަށް ނުވަނީސް ފާސްކުރުން ބަލައެއް ނުގަނެވޭނެއެވެ. ރިޓަރން އަލުން ތައްޔާރުކުރާ، ނުވަތަ ނެތް ޖާނަލް ހޯދާށެވެ.",
        "clear": "ރިޓަރން ލެޖަރާ ދިމާވެއެވެ.",
        "controlAccount": "ކޮންޓްރޯލް އެކައުންޓް",
        "controlMovement": "ލެޖަރުގެ ހަރަކާތް",
        "description": "ކޮންޓްރޯލް އެކައުންޓުގެ ހަރަކާތް، ރިޓަރންގެ ޖުމުލަ، އަދި އެ ދެމެދުގެ ތަފާތެވެ.",
        "difference": "ތަފާތު",
        "returnTotal": "ރިޓަރންގެ ޖުމުލަ",
        "title": "ލެޖަރާ ދިމާކުރުން"
      },
      "remittance": {
        "bankAccountLabel": "ބޭންކް އެކައުންޓް އައިޑީ",
        "description": "ޢަދަދަކީ ރިޓަރންގެ އަމިއްލަ ޖުމުލަ، ބަދަލެއް ނުކުރެވި.",
        "title": "ފައިސާ ފޮނުވުމެއް ތައްޔާރުކުރޭ"
      },
      "remittanceConfirmed": "ފައިސާ ފޮނުވުން ކަށަވަރުކުރެވި ޕޯސްޓްކުރެވިއްޖެ",
      "remittanceDescription": "ފައިސާ ފޮނުވުން ކަށަވަރުކުރުމުން ޕޯސްޓްވެއެވެ: ޤާނޫނީ ދޭން ޖެހޭ ފައިސާ ބޭންކާ އަޅައި ސާފުކުރެވެއެވެ.",
      "remittancePrepared": "ފައިސާ ފޮނުވުން ތައްޔާރުކުރެވިއްޖެ",
      "remittanceStatuses": {
        "cancelled": "ކެންސަލްކޮށްފައި",
        "confirmed": "ކަށަވަރުކުރެވިފައި",
        "prepared": "ތައްޔާރުކުރެވިފައި"
      },
      "remittanceTitle": "ފައިސާ ފޮނުވުން",
      "statuses": {
        "approved": "ފާސްކުރެވިފައި",
        "draft": "ދެލިކޮޕީ",
        "filed": "ފައިލްކުރެވިފައި",
        "prepared": "ތައްޔާރުކުރެވިފައި",
        "reconciled": "ދިމާކުރެވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "summaryTitle": "ޚުލާޞާ",
      "title": "ޤާނޫނީ ރިޓަރންތައް",
      "unreconciledExplainer": "ތަފާތު ސުމަކަށް ނުވަނީސް ރިޓަރނެއް ފާސްކުރެވިދާނެ ގޮތެއް ނެތެވެ. އެއީ ޑޭޓާބޭސްގެ ޤަވާޢިދެއް، ސިޔާސަތެއް ނޫނެވެ.",
      "unreconciledHeadline": "{count} ރިޓަރނެއް ލެޖަރާ ދިމައެއް ނުވެއެވެ",
      "yearEndLink": "އަހަރު ނިމުމުގެ ބަޔާންތައް"
    },
    "serviceCharge": {
      "actions": {
        "allocate": "ބަހާ",
        "approve": "ފާސްކުރޭ",
        "collect": "އެއްކުރޭ",
        "distribute": "ބަހާ ދޫކުރޭ",
        "new": "އައު ޕޫލް",
        "newPoint": "އައު ޕޮއިންޓް ސަފުހާ",
        "newScheme": "އައު ސްކީމް"
      },
      "allocated": "ޕޫލް ބެހިއްޖެ",
      "allocationsDescription": "ބުރަދަން، ސާފު ބައި، ރައުންޑްކުރެވުނު ލާރި، އަދި ޢަދަދު — ބެހުމެއް އަލުން ނެގޭ ގޮތަށް ހަދާ ހަތަރު ޢަދަދެވެ.",
      "allocationsEmptyDescription": "ޕޫލް ބަހާށެވެ، ދެން ޤާބިލު ކޮންމެ މީހެއްގެ ބައި މިތާ ފެންނާނެއެވެ.",
      "allocationsEmptyTitle": "އަދި ބެހިފައެއް ނުވެއެވެ",
      "allocationsGatedExplainer": "މި ލިސްޓަކީ ކޮންމެ ބައިވެރިއެއްގެ ބައި، އެހެންކަމުން ޕޫލް ބަލަހައްޓާ ހުއްދަ ބޭނުންވެއެވެ — ކިޔާ ހުއްދައެއް ނޫނެވެ.",
      "allocationsGatedHeadline": "ބެހުންތައް ތިޔަ ފަރާތަށް ނުދައްކައެވެ",
      "allocationsTitle": "ބެހުންތައް",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "approve": {
        "description": "ފާސްކުރުމުން ބެހުން ފައިނަލްވެ، ދޫކުރެވޭ ގޮތް ވެއެވެ.",
        "explainer": "ބެހެން ޖެހޭ ކޮންމެ ލާރިއެއް މީހަކަށް ނުވަނީސް ފާސްކުރުން ބަލައެއް ނުގަނެވޭނެއެވެ.",
        "noteLabel": "ނޯޓު",
        "title": "ޕޫލް ފާސްކުރޭ"
      },
      "approved": "ޕޫލް ފާސްކުރެވިއްޖެ",
      "bases": {
        "hours": "ހާޒިރުވި ގަޑިއިރު",
        "points": "ޕޮއިންޓް"
      },
      "basisHint": "ޕޮއިންޓުން ބުރަދަން ދެނީ ދަރަޖަ ނުވަތަ މީހާއަށް؛ ގަޑިއިރުން ދެނީ ހާޒިރުވި ގަޑިއިރަށެވެ.",
      "collected": "ޕޫލް އެއްކުރެވިއްޖެ",
      "columns": {
        "allocated": "ބެހިފައި",
        "amount": "ޢަދަދު",
        "baseAmount": "އަސާސީ ޢަދަދު",
        "basis": "އަސާސް",
        "capturedAt": "ނެގުނު ވަގުތު",
        "code": "ކޯޑު",
        "component": "މުސާރައިގެ ބައި",
        "contributesTo": "ބައިވެރިވަނީ",
        "currency": "ފައިސާ",
        "distributable": "ބެހޭ",
        "documents": "ލިޔެކިޔުން",
        "eligibility": "ޤާބިލުކަން",
        "eligible": "ޤާބިލު",
        "eligibleDays": "ޤާބިލު ދުވަސް",
        "grade": "ދަރަޖަ",
        "gross": "އެއްކުރެވުނު",
        "hours": "ގަޑިއިރު",
        "lines": "ސަފުހާ",
        "period": "މުއްދަތު",
        "points": "ޕޮއިންޓް",
        "poolKey": "ޕޫލްގެ ކީ",
        "poolNo": "ޕޫލް ނަންބަރު",
        "rawShare": "ސާފު ބައި",
        "reason": "ސަބަބު",
        "retained": "ހިފެހެއްޓުނު",
        "retention": "ހިފެހެއްޓުން",
        "roundingCents": "ރައުންޑްކުރުން",
        "scheme": "ސްކީމް",
        "scope": "ދާއިރާ",
        "target": "އަމާޒު",
        "taxCode": "ޗާޖްގެ ކޯޑު",
        "topup": "ވަޒީފާދޭ ފަރާތުގެ އިތުރުކުރުން",
        "totalWeight": "ޖުމުލަ ބުރަދަން",
        "weight": "ބުރަދަން"
      },
      "componentHint": "ބައި ދެވޭ މުސާރައިގެ ބައެވެ. އެއީ ޕޫލް ބައިގެ ބައެއް ކަމުގައި ވާން ޖެހެއެވެ.",
      "contributesHint": "ބައެއް ބައިވެރިވުމުގެ އަސާސަކަށް ވަދޭތޯ — މިސާލަކަށް، އޭގެ މައްޗަށް ޕެންޝަން ނެގޭތޯއެވެ.",
      "contributesNothing": "އެއްވެސް އެއްޗެއް ނޫން",
      "contributesWarning": "ބައިވެރިވުމުގެ އަސާސަކަށް ބައެއް ވަނުމުން، އެއިން އުނިކުރެވޭ އެއްޗެއް ބަދަލުވެއެވެ. ރައްކާކުރުމުގެ ކުރިން ޤާނޫނީ ޤަވާޢިދު ބަލާށެވެ.",
      "create": {
        "description": "ޕޫލަކުން އެއް ތަނެއްގެ އެއް މުއްދަތުގެ ޗާޖްތައް ނަގައެވެ.",
        "title": "އައު ޚިދުމަތުގެ އަގުގެ ޕޫލް"
      },
      "created": "ޕޫލް އުފެއްދިއްޖެ",
      "description": "އެއް ތަނަކުން އެއް މުއްދަތަކަށް އެއްކުރެވުނު ފައިސާ، އެއްކުރެވުނު މުވައްޒަފުންނަށް ބެހުމެވެ.",
      "detailDescription": "މަޞްދަރުގެ ސްނެޕްޝޮޓް، ސްކީމް، ކޮންމެ ބައެއް، އަދި ކޮންމެ ގެއްލުމެކެވެ.",
      "detailTitle": "ޚިދުމަތުގެ އަގުގެ ޕޫލް",
      "distribute": {
        "description": "ކޮންމެ ބައެއް، ބުނާ ރަނުގައި ޕޭސްލިޕް ސަފުހާއަކަށް ބަދަލުވެއެވެ.",
        "explainer": "މިއިން ދަރަނީގެ އެކައުންޓުން ފައިސާ ނިކުމެއެވެ. ޕޫލެއް ދޫކުރެވެނީ ސީދާ އެއް ރަނުގެ ތެރެއިންނެވެ.",
        "runHint": "ހަމަ އެ ކުންފުނީގެ ދެލިކޮޕީ ނުވަތަ ހިސާބުކުރެވުނު ރަނެކެވެ.",
        "runLabel": "މުސާރައިގެ ރަން އައިޑީ",
        "title": "ޕޫލް ދޫކުރޭ"
      },
      "distributed": "ރަން {runNo} ގެ ތެރެއިން ބެހިއްޖެ: {count} ބައި",
      "draftNo": "ދެލިކޮޕީ",
      "eligibility": {
        "eligible": "ޤާބިލު",
        "forfeited": "ގެއްލުނު",
        "ineligible": "ޤާބިލެއް ނޫން"
      },
      "emptyDescription": "މުއްދަތަކަށް ޕޫލެއް އުފައްދާ، މެހުމާނުންގެ އަތުން ނެގުނު ފައިސާ އެއްކުރާ، ދެން އެ ބަހާށެވެ.",
      "emptyTitle": "އަދި ޕޫލެއް ނެތެވެ",
      "excludeOnProbation": "ޕްރޮބޭޝަނުގައި ތިބި މުވައްޒަފުން ބޭރުކުރޭ",
      "forfeitForCause": "ސަބަބަކާހުރެ ވަކިކުރުމުން ގެއްލޭ",
      "forfeituresTitle": "ބޭރުކުރެވުނު އަދި ގެއްލުނު ({count})",
      "liabilityExplainer": "ޚިދުމަތުގެ އަގަކީ މުވައްޒަފުންގެ ބަދަލުގައި މެހުމާނުންގެ އަތުން ނެގޭ ފައިސާއެވެ. އެ އޮންނަނީ ދަރަނީގެ އެކައުންޓެއްގައި، އަދި ބެހެނީއެވެ، ޚަރަދުކުރެވެނީއެއް ނޫނެވެ.",
      "loadFailed": "ޕޫލްތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "minDaysWorked": "މަސައްކަތްކުރި އެންމެ މަދު ދުވަސް",
      "moneyTitle": "ފައިސާ",
      "notFullyAllocated": "ބެހެން ޖެހޭ ކޮންމެ ލާރިއެއް ބެހިފައެއް ނުވެއެވެ. އެ ދެ ޢަދަދު ދިމާނުވަނީސް ފާސްކުރުން ބަލައެއް ނުގަނެވޭނެއެވެ.",
      "oneWindow": "ކޮންމެ ތަނަކަށް ކޮންމެ މުއްދަތަކަށް އެއް ދިރިހުރި ޕޫލެވެ. ހަމަ އެ މުއްދަތަށް ދެވަނަ ޕޫލަކުން އެއް ފައިސާއެއް ދެފަހަރު ބެހޭނެއެވެ.",
      "periodEnd": "މުއްދަތު ނިމޭ",
      "periodStart": "މުއްދަތު ފެށޭ",
      "point": {
        "description": "އެއް ދަރަޖައަކަށް، އެއް މަޤާމަކަށް ނުވަތަ އެކަކަށް ޕޮއިންޓް، ތާރީޚަކުން ފެށޭ ގޮތަށެވެ.",
        "targetIdHint": "މި ސަފުހާއިން ބުރަދަން ދޭ ދަރަޖަ، މަޤާމު ނުވަތަ މުވައްޒަފުގެ އައިޑީއެވެ.",
        "targetIdLabel": "އަމާޒުގެ އައިޑީ",
        "title": "އައު ޕޮއިންޓް ސަފުހާ"
      },
      "pointRemoved": "ޕޮއިންޓް ނަގައިފި",
      "pointSaved": "ޕޮއިންޓް ރައްކާކުރެވިއްޖެ",
      "pointTargets": {
        "employee": "މުވައްޒަފު",
        "grade": "ދަރަޖަ",
        "position": "މަޤާމު"
      },
      "pointsEmptyDescription": "ޕޮއިންޓް ނެތްނަމަ ޤާބިލު ކޮންމެ މީހެއްގެ ބުރަދަން އެއްވަރެވެ. މަދުވެގެން ކޮންމެ ދަރަޖައަކަށް ސަފުހާއެއް އިތުރުކުރާށެވެ.",
      "pointsEmptyTitle": "ޕޮއިންޓް ސަފުހާއެއް ނެތެވެ",
      "pointsResolutionOrder": "ޕޮއިންޓް ހޯދެނީ ފުރަތަމަ މުވައްޒަފު، ދެން މަޤާމު، ދެން ދަރަޖަ — އެންމެ ސީދާ އެއްޗެއް ކާމިޔާބުވެއެވެ.",
      "poolKeyHint": "ލިޔެކިޔުމުގެ ޚިދުމަތުން ލިޔުނު ޗާޖް ޕޫލްގެ ކީއެވެ. ހުހަށް ބެހެއްޓުމުން ނަން ނެތް ޕޫލް އެއްކުރެއެވެ.",
      "prorateByDays": "ޤާބިލު ދުވަހަށް ބައިކުޅަބައި",
      "prorateHint": "މުއްދަތުގެ ދެބައިކުޅަ އެއްބައި މަސައްކަތްކުރި މީހަކު އުފުލަނީ ދެބައިކުޅަ އެއްބައި ބުރަދަނެވެ.",
      "retentionHint": "ހިފެހެއްޓޭ ފައިސާ ދަރަނީގެ އެކައުންޓުގައި ބާކީ ހުރެއެވެ. މިތާ އެއީ އާމްދަނީއަކަށް ނުވެއެވެ.",
      "scheme": {
        "createTitle": "އައު ޚިދުމަތުގެ އަގުގެ ސްކީމް",
        "description": "ތާރީޚަކުން ފެށޭ: ސްކީމް ބަދަލުކުރުމުން ދޫކުރެވިފައިވާ ޕޫލެއް ދުވަހަކުވެސް އަލުން ނުބެހެއެވެ.",
        "editTitle": "ޚިދުމަތުގެ އަގުގެ ސްކީމް އެޑިޓްކުރޭ"
      },
      "schemeSaved": "ސްކީމް ރައްކާކުރެވިއްޖެ",
      "schemesDescription": "ޕޫލެއް ބެހޭ ގޮތާއި، ކޮންމެ ދަރަޖައެއް، މަޤާމެއް ނުވަތަ މީހަކު އުފުލާ ޕޮއިންޓެވެ.",
      "schemesEmptyDescription": "ސްކީމަކުން ޤާބިލުކަން، ބައިކުޅަބައި، ގެއްލުން، އަދި ބައި ދެވޭ މުސާރައިގެ ބައި ކަނޑައަޅައެވެ.",
      "schemesEmptyTitle": "ސްކީމެއް ނެތެވެ",
      "schemesLink": "ސްކީމްތަކާއި ޕޮއިންޓް",
      "schemesTitle": "ސްކީމްތަކާއި ޕޮއިންޓް",
      "sourceDescription": "މި ޕޫލް އެއްކުރެވުނު އިރު ޗާޖްގެ ސުވާލުން އައި ސީދާ އެއްޗެވެ. ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "sourceEmptyDescription": "މުއްދަތުގައި މެހުމާނުންގެ އަތުން ނެގުނު ފައިސާގެ ސްނެޕްޝޮޓް ނެގުމަށް ޕޫލް އެއްކުރާށެވެ.",
      "sourceEmptyTitle": "އަދި އެއްކުރެވިފައެއް ނުވެއެވެ",
      "sourceTitle": "މަޞްދަރުގެ ސްނެޕްޝޮޓް",
      "statuses": {
        "allocated": "ބެހިފައި",
        "approved": "ފާސްކުރެވިފައި",
        "cancelled": "ކެންސަލްކޮށްފައި",
        "collected": "އެއްކުރެވިފައި",
        "distributed": "ދޫކުރެވިފައި",
        "draft": "ދެލިކޮޕީ"
      },
      "tabs": {
        "points": "ޕޮއިންޓް",
        "schemes": "ސްކީމްތައް"
      },
      "title": "ޚިދުމަތުގެ އަގު",
      "topupHint": "ތަނުން އަމިއްލަ ޖީބުން އިތުރުކުރާ ފައިސާއެވެ. މި ބަޔަކީ ޚަރަދެކެވެ.",
      "unnamedPool": "ނަން ނެތް ޕޫލް",
      "collectDescription": "ޕޫލް އޭގެ މަޞްދަރުތަކުގެ މައްޗަށް ބަންދުކުރެއެވެ. ވަޒީފާދޭ ފަރާތުގެ އިތުރު އެއްޗެއް އޮތްނަމަ، މިހާރު ބަޔާންކުރެއެވެ."
    },
    "statutoryMappings": {
      "accountCodeHint": "މި ކުންފުނީގެ އެކައުންޓް ޗާޓުގެ ކޯޑެއް، ރަން ޕޯސްޓްކުރާއިރު ހޯދޭ ގޮތަށެވެ.",
      "actions": {
        "new": "އައު މެޕިން"
      },
      "columns": {
        "expense": "ޚަރަދުގެ އެކައުންޓް",
        "liability": "ދަރަނީގެ އެކައުންޓް"
      },
      "create": {
        "description": "ކޮންމެ ކުންފުންޏަކަށް ކޮންމެ ޤަވާޢިދަކަށް އެއް މެޕިން، ތާރީޚަކުން ފެށޭ ގޮތަށެވެ.",
        "title": "އައު ޤާނޫނީ މެޕިން"
      },
      "description": "މި ކުންފުނީގެ ޗާޓުގައި ކޮންމެ ޤާނޫނީ ޤަވާޢިދެއް ޕޯސްޓްކުރާ އެކައުންޓް ކޯޑުތަކެވެ.",
      "disableReasonLabel": "ނުހިނގާ ސަބަބު",
      "disableReasons": {
        "exempt_by_ruling": "ނިންމުމަކުން އިސްތިސްނާ",
        "no_eligible_staff": "ޤާބިލު މުވައްޒަފުން ނެތް",
        "not_applicable": "މިތާކަށް ނުހިނގާ",
        "other": "އެހެނިހެން"
      },
      "disabled": "ހުއްޓިފައި",
      "edit": {
        "title": "ޤާނޫނީ މެޕިން އެޑިޓްކުރޭ"
      },
      "emptyDescription": "މެޕިންއެއް ނެތްނަމަ ޤަވާޢިދަކަށް ޕޯސްޓްކުރާނެ އެކައުންޓެއް ނެތި، ޕޯސްޓްކުރާ އިރު ރަން ބަލައެއް ނުގަނެވޭނެއެވެ.",
      "emptyTitle": "އަދި މެޕިންއެއް ނެތެވެ",
      "enabled": "ހަރަކާތްތެރި",
      "enabledHint": "މި ކުންފުންޏަށް ޤަވާޢިދު އެއްވެސް ގޮތަކަށް ނުހިނގާނަމަ އެކަނި ހުއްޓާލާށެވެ.",
      "loadFailed": "މެޕިންތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "noRateExplainer": "މެޕިންއަކުން ޤަވާޢިދެއް ތިޔަ ފަރާތުގެ އެކައުންޓްތަކަށް އަމާޒުކުރެއެވެ. ޤަވާޢިދުން ހިސާބުކުރާ އެއްޗެއް ބަދަލެއް ނުކުރެވޭ، އަދި މިތާ އެފަދަ ގޮޅިއެއް ނެތެވެ.",
      "noRateHeadline": "ހަމައެކަނި އެކައުންޓް — ދުވަހަކުވެސް ރޭޓެއް ނޫން",
      "saved": "މެޕިން ރައްކާކުރެވިއްޖެ",
      "title": "ޤާނޫނީ މެޕިންތައް"
    },
    "statutoryRules": {
      "actions": {
        "history": "ތާރީޚު"
      },
      "columns": {
        "citation": "މަޞްދަރު",
        "code": "ޤަވާޢިދުގެ ކޯޑު",
        "effectiveFrom": "ފެށޭ ތާރީޚު",
        "jurisdiction": "ޖުރިސްޑިކްޝަން",
        "overridable": "ބަދަލުކުރެވޭ",
        "pack": "ޕެކް",
        "parameters": "ޕެރެމީޓަރތައް",
        "reviewDue": "މުރާޖަޢާގެ ތާރީޚު"
      },
      "description": "ކުންފުންޏަކަށް ހިނގާ ޤަވާޢިދުތައް، ކޮންމެ އެއްޗެއްގެ ފަހަތުގައިވާ ޕެކްގެ ވަރޝަނާއި މަޞްދަރާއެކުއެވެ.",
      "emptyDescription": "މި ކުންފުންޏަށް ޖުރިސްޑިކްޝަން ޕެކެއް ހަރަކާތްތެރިކުރާށެވެ، ދެން އޭގެ ޤަވާޢިދުތައް މިތާ ފެންނާނެއެވެ.",
      "emptyTitle": "ހިނގަމުންދާ ޤާނޫނީ ޤަވާޢިދެއް ނެތެވެ",
      "history": {
        "description": "މި ވޯކްސްޕޭސްގައި ހުރި ކޮންމެ ވަރޝަނެއް، އެ ގެނެސްދިން ޕެކްގެ ވަރޝަނާއެކުއެވެ.",
        "title": "{code} — ހުރިހާ ވަރޝަނެއް"
      },
      "loadFailed": "ޤާނޫނީ ޤަވާޢިދުތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "mappingsLink": "އެކައުންޓް މެޕިންތައް",
      "notOverridable": "ބަދަލެއް ނުކުރެވޭ",
      "onDate": "ހިނގާ ތާރީޚު",
      "onDateHint": "މިއަދަށް ހުހަށް ބާއްވާށެވެ.",
      "overdue": "މުރާޖަޢާ ލަސްވެފައި",
      "overdueExplainer": "{count} ޤަވާޢިދެއްގެ މުރާޖަޢާގެ ތާރީޚު ފަހަނައަޅައި ގޮސްފައިވެއެވެ. އަލުން ނުކިޔާ ރޭޓަކީ އެއްވެސް މީހަކު ފަހަތުގައި ނުހުންނަ ރޭޓެކެވެ.",
      "readOnlyExplainer": "ޤާނޫނީ ޤަވާޢިދެއް ވޯކްސްޕޭސްގެ އިދާރީ ފަރާތް ހިމެނޭ ގޮތުން، އެއްވެސް މީހަކަށް އަމިއްލައަށް ބަދަލެއް ނުކުރެވޭނެއެވެ. ބަދަލުކުރެވޭނީ އެ ޕޯސްޓްކުރާ އެކައުންޓްތަކެވެ.",
      "readOnlyHeadline": "މި ޤަވާޢިދުތަކަކީ ހަމައެކަނި ކިޔޭ އެއްޗެކެވެ",
      "title": "ޤާނޫނީ ޤަވާޢިދުތައް",
      "unverifiedExplainer": "ރޭޓުތައް އަޞްލު މަޞްދަރަކާ އަޅައި ސައްޙަކުރެވިފައެއް ނުވެއެވެ. ޢަދަދަކަށް ބަރޯސާވުމުގެ ކުރިން ބަލާށެވެ.",
      "unverifiedHeadline": "{count} ޤަވާޢިދެއްގައި ސައްޙަނުކުރެވޭ މަޞްދަރެއް ވެއެވެ"
    },
    "variances": {
      "actions": {
        "explain": "ބަޔާންކުރޭ",
        "explainSelected": "އިޚްތިޔާރުކުރެވުނު {count} ބަޔާންކުރޭ"
      },
      "blocking": "ހުއްޓުވާ",
      "blocksReview": "ބުރަދަން ހުރި {count} ތަފާތެއް ބަޔާންކުރެވިފައެއް ނުވެއެވެ",
      "blocksReviewWhy": "ކޮންމެ އެއްޗެއްގައި ބަޔާނެއް ނުވަނީސް މުރާޖަޢާ ބަލައެއް ނުގަނެވޭނެއެވެ. އިސްތިސްނާއެއް ނެތެވެ: ފާސްކުރުން ބިނާވެފައިވަނީ އެ ބަޔާނުގެ މައްޗަށެވެ.",
      "clear": "ބުރަދަން ހުރި ބަޔާންނުކުރެވޭ ތަފާތެއް ނެތެވެ. މުރާޖަޢާ ކުރިއަށް ގެންދެވިދާނެއެވެ.",
      "codes": {
        "bonus_paid": "ބޯނަސް ދެވުނު",
        "correction": "އިޞްލާޙު",
        "joiner": "އައު މުވައްޒަފު",
        "leaver": "ވަކިވި މުވައްޒަފު",
        "other": "އެހެނިހެން",
        "overtime_change": "އިތުރު ގަޑި ބަދަލުވި",
        "pay_review": "މުސާރައިގެ މުރާޖަޢާ",
        "retro_applied": "ފަހުން ދޭ މުސާރަ ދެވުނު",
        "statutory_rate_change": "ޤާނޫނީ ރޭޓް ބަދަލުވި",
        "unpaid_leave": "މުސާރަ ނުލިބޭ ޗުއްޓީ"
      },
      "columns": {
        "current": "މިހާރުގެ",
        "delta": "ތަފާތު",
        "deltaPercent": "ބަދަލު %",
        "employee": "މުވައްޒަފު",
        "explanation": "ބަޔާން",
        "measure": "މިންގަނޑު",
        "prior": "ކުރީގެ"
      },
      "companyRollup": "ކުންފުނީގެ ޖުމުލަ",
      "description": "މިދިޔަ މުއްދަތުން ފެށިގެން ބަދަލުވި އެއްޗާއި، އެ ބަޔާންކޮށްފައިވޭތޯއެވެ.",
      "emptyDescription": "ކުންފުނީގެ ބުރަދަނުގެ ހުދޫދަށްވުރެ ބޮޑަށް އެއްވެސް ޢަދަދެއް ބަދަލެއް ނުވެއެވެ.",
      "emptyTitle": "ބަޔާންކުރަން ޖެހޭ އެއްޗެއް ނެތެވެ",
      "explain": {
        "codeLabel": "ބަޔާނުގެ ކޯޑު",
        "description": "ޖުމުލައަށް ކޯޑެއް، އަދި މުހިއްމު އެއްޗަށް ޖުމުލައެކެވެ.",
        "humanNote": "މިއީ ތިޔަ ފަރާތުގެ ނަމާއި ވަގުތާއެކު، މީހަކު ދިން ބަޔާނެއްގެ ގޮތުގައި ރެކޯޑްކުރެވެއެވެ.",
        "noteHint": "ފާސްކުރާ ފަރާތުން ޢަދަދު އަލުން ނަގާ ބަދަލުގައި މި ކިޔާނެއެވެ.",
        "noteLabel": "ހިނގި ގޮތް",
        "title": "ތަފާތު ބަޔާންކުރޭ"
      },
      "explained": "ތަފާތު ބަޔާންކުރެވިއްޖެ",
      "explainedBulk": "{count} ތަފާތެއް ބަޔާންކުރެވިއްޖެ",
      "loadFailed": "ތަފާތުތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "materialHint": "ބުރަދަން ހުރި ކަމަށް ބެލެނީ ސީދާ ޢަދަދާއި އިންސައްތައިގެ ދެ ހުދޫދު ފަހަނައަޅައި ދިއުމުންނެވެ.",
      "materialOnly": "ހަމައެކަނި ބުރަދަން ހުރި",
      "measures": {
        "component": "ބައި",
        "deduction": "އުނިކުރުންތައް",
        "employer_cost": "ވަޒީފާދޭ ފަރާތުގެ ޚަރަދު",
        "gross": "ޖުމުލަ",
        "headcount": "މުވައްޒަފުންގެ ޢަދަދު",
        "net": "ސާފު"
      },
      "sources": {
        "auto": "އޮޓޯ",
        "human": "މީހަކު"
      },
      "title": "ކުރީގެ ރަނާ އަޅައި ތަފާތުތައް",
      "unexplained": "ބަޔާންނުކުރެވޭ",
      "unexplainedOnly": "ހަމައެކަނި ބަޔާންނުކުރެވޭ"
    },
    "wageBases": {
      "actions": {
        "new": "އައު މުސާރައިގެ އަސާސް"
      },
      "ceiling": "އެންމެ މަތި",
      "columns": {
        "bounds": "އެންމެ ދަށް / އެންމެ މަތި",
        "code": "ކޯޑު",
        "gate": "ގޭޓް",
        "includes": "ހިމަނާ ގިންތިތައް",
        "seed": "ފެށޭ ގޮތް",
        "source": "މަޞްދަރު"
      },
      "create": {
        "description": "އަސާސަކީ ކޮންފިގަރޭޝަނެއް، އެހެންކަމުން ތާރީޚަކުން ފެށޭ، އަދި ދުވަހަކުވެސް ހަމަ އެ ތަނުގައި އަލުން ނުލިޔެވެއެވެ.",
        "title": "އައު މުސާރައިގެ އަސާސް"
      },
      "description": "ޤާނޫނީ ޤަވާޢިދެއް ހިސާބުކުރެވޭ ނަން ދެވިފައިވާ ޖުމުލަތަކެވެ.",
      "edit": {
        "title": "މުސާރައިގެ އަސާސް އެޑިޓްކުރޭ"
      },
      "emptyDescription": "އަސާސީ މުސާރައާއި ޕެންޝަން ލިބޭ މުސާރަ ސީޑްކުރެވެނީ މައިގްރޭޝަނުންނެވެ؛ ޖުރިސްޑިކްޝަނަކަށް ބޭނުންވާ ކޮންމެ އަސާސަކަށް އެއް އަސާސް އިތުރުކުރާށެވެ.",
      "emptyTitle": "މުސާރައިގެ އަސާސެއް ނެތެވެ",
      "explainer": "އަސާސެއް ފެށެނީ ވަޒީފާގެ އަސާސީ މުސާރައިން، ބުނާ މުސާރައިގެ ގިންތިތައް ޖަމާކުރެއެވެ، އަދި ގޭޓް، އެންމެ ދަށް ނުވަތަ އެންމެ މަތި ކަނޑައެޅިދާނެއެވެ.",
      "floor": "އެންމެ ދަށް",
      "gateHint": "ގޭޓަކުން ނުހިނގާ މީހަކަށް އަސާސް ސުމަކަށް ބަދަލުކުރެއެވެ.",
      "gates": {
        "none": "ގޭޓެއް ނެތް",
        "pensionable": "ހަމައެކަނި ޕެންޝަން ސްކީމުގައި ބައިވެރިވެފައިވާނަމަ"
      },
      "includesHint": "މި ގިންތިތަކުގެ ބައިތަކުގެ ޢަދަދުތައް އަސާސަށް އިތުރުކުރެވެއެވެ.",
      "loadFailed": "މުސާރައިގެ އަސާސްތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "packReadOnly": "ޕެކަކުން",
      "saved": "މުސާރައިގެ އަސާސް ރައްކާކުރެވިއްޖެ",
      "seedHint": "ވަޒީފާގެ ބައިކުޅަބައި އަސާސީ މުސާރައިން އަސާސް ފަށާތޯއެވެ.",
      "seedSources": {
        "assignment_basic": "ވަޒީފާގެ އަސާސީ މުސާރަ",
        "none": "އެއްވެސް އެއްޗެއް ނޫން"
      },
      "title": "މުސާރައިގެ އަސާސްތައް"
    },
    "wageClasses": {
      "allowance": "އެލަވަންސް",
      "basic_salary": "އަސާސީ މުސާރަ",
      "benefit_in_kind": "ޢައިނީ މަންފާ",
      "bonus": "ބޯނަސް",
      "cost_of_living_allowance": "ދިރިއުޅުމުގެ ޚަރަދުގެ އެލަވަންސް",
      "other": "އެހެނިހެން",
      "overtime": "އިތުރު ގަޑި",
      "reimbursement": "އަނބުރާ ދިނުން",
      "service_charge": "ޚިދުމަތުގެ އަގު",
      "statutory": "ޤާނޫނީ"
    },
    "yearEnd": {
      "actions": {
        "issue": "ބަޔާން ދޫކުރޭ"
      },
      "columns": {
        "taxYear": "ޓެކްސް އަހަރު"
      },
      "description": "ކޮންމެ މުވައްޒަފަކަށް ކޮންމެ ޓެކްސް އަހަރަކަށް އެކެއް، ދޫކުރެވުނު ޕޭސްލިޕުތަކުން ޖުމުލަކުރެވިފައެވެ.",
      "draftExplainer": "{count} ބަޔާނަކީ އަދިވެސް ދެލިކޮޕީއެވެ. މުވައްޒަފަށް ފެންނަނީ ދޫކުރެވުނު ބަޔާންތައް އެކަންޏެވެ.",
      "emptyDescription": "ޓެކްސް އަހަރަކަށް ބަޔާން ދޫކުރާށެވެ، ދެން އެތަކެތި މިތާ ފެންނާނެއެވެ.",
      "emptyTitle": "ބަޔާނެއް ނެތެވެ",
      "issue": {
        "description": "އަހަރު ތެރޭ ފައިސާ ދެވުނު ކޮންމެ މުވައްޒަފަކަށް ބަޔާން އުފެއްދެއެވެ.",
        "explainer": "ދޫކުރުމުން ބަޔާން ސެލްފް ސާވިސްގައި ފެންނާނެއެވެ. ދެލިކޮޕީއެއް ސިއްރުވެފައި އޮވެއެވެ.",
        "title": "އަހަރު ނިމުމުގެ ބަޔާން ދޫކުރޭ"
      },
      "issued": "{issued} ދޫކުރެވި، {skipped} ދޫކޮށްލެވުނެވެ",
      "loadFailed": "ބަޔާންތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "issued": "ދޫކުރެވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "title": "އަހަރު ނިމުމުގެ ބަޔާންތައް",
      "issuedOne": "{year} ގެ ބަޔާން ދޫކުރެވިއްޖެ"
    },
    "statutory_review": {
      "summary": "ޕޭރޯލް ރަނެއްގައި ޤާނޫނީ ޤަވާޢިދެއްގެ ލޯކަލް އޯވަރައިޑެއް ބޭނުންކޮށްފައިވާތީ ރިވިއު ބޭނުންވޭ."
    }
  },
  "projects": {
    "routeTitles": {
      "projects": "ޕްރޮޖެކްޓްތައް",
      "project": "ޕްރޮޖެކްޓް",
      "gantt": "ތާވަލު",
      "profitability": "ފައިދާ",
      "billing": "ބިލްކުރުން",
      "timesheets": "ޓައިމްޝީޓްތައް",
      "timesheet": "ޓައިމްޝީޓް",
      "settings": "ޕްރޮޖެކްޓް ސެޓިންގތައް"
    },
    "nav": {
      "label": "ޕްރޮޖެކްޓްގެ ބައިތައް",
      "projects": "ޕްރޮޖެކްޓްތައް",
      "timesheets": "ޓައިމްޝީޓްތައް",
      "settings": "ސެޓިންގތައް"
    },
    "tabs": {
      "label": "ޕްރޮޖެކްޓް ބަލާނެ ގޮތްތައް",
      "overview": "ޚުލާޞާ",
      "gantt": "ތާވަލު",
      "profitability": "ފައިދާ",
      "billing": "ބިލްކުރުން"
    },
    "actions": {
      "remove": "ނަގާ"
    },
    "statuses": {
      "planning": "ރޭވުމުގެ މަރުޙަލާ",
      "active": "ހިނގަމުންދާ",
      "on_hold": "މަޑުޖައްސާލާފައި",
      "completed": "ނިމިފައި",
      "cancelled": "ކެންސަލްކޮށްފައި"
    },
    "fields": {
      "company": "ކުންފުނި",
      "companyPlaceholder": "ކުންފުންޏެއް ޚިޔާރުކުރައްވާ",
      "code": "ކޯޑް",
      "name": "ނަން",
      "description": "ތަފްޞީލު",
      "customer": "ކަސްޓަމަރު",
      "customerPlaceholder": "ކަސްޓަމަރެއް ޚިޔާރުކުރައްވާ",
      "manager": "މެނޭޖަރު",
      "managerPlaceholder": "މެނޭޖަރެއް ޚިޔާރުކުރައްވާ",
      "startDate": "ފެށޭ ތާރީޚް",
      "endDate": "ނިމޭ ތާރީޚް",
      "dates": "ތާރީޚްތައް",
      "currency": "ފައިސާގެ ބާވަތް",
      "contractValue": "އެއްބަސްވުމުގެ އަގު",
      "billingMethod": "ބިލްކުރާ ގޮތް",
      "revenueAccount": "އާމްދަނީ އެކައުންޓް",
      "revenueRecognized": "ބަލައިގަނެފައިވާ އާމްދަނީ",
      "phase": "މަރުޙަލާ",
      "task": "މަސައްކަތް",
      "project": "ޕްރޮޖެކްޓް",
      "assignee": "ޙަވާލުވެފައިވާ ފަރާތް"
    },
    "list": {
      "title": "ޕްރޮޖެކްޓްތައް",
      "description": "މަރުޙަލާތަކާއި މަސައްކަތްތަކަށް ބަހާލެވިފައިވާ މަސައްކަތް، ޓައިމްޝީޓުން ޚަރަދު ބެލެވި ކަސްޓަމަރަށް ބިލްކުރެވެއެވެ.",
      "filtersTitle": "ފިލްޓަރތައް",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން",
      "new": "އައު ޕްރޮޖެކްޓް",
      "loadFailed": "ޕްރޮޖެކްޓްތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ޕްރޮޖެކްޓެއް ނެތް",
      "emptyDescription": "ޕްރޮޖެކްޓެއް އުފައްދާ، ބަޖެޓާއެކު މަސައްކަތްތަކަށް ބަހާލާ، ދެން ޚަރަދުގެ ރޭޓާއެކު ޓީމު އެއަށް ލައްވާ."
    },
    "create": {
      "title": "އައު ޕްރޮޖެކްޓް",
      "description": "މަސައްކަތުގެ ނަމާއި އެއީ ކާކަށްކަން ލިޔުއްވާ. ބިލްކުރާ ގޮތާއި އެއްބަސްވުމުގެ އަގާއި އާމްދަނީ އެކައުންޓް ފަހުން ކަނޑައެޅޭނެއެވެ.",
      "codeHint": "ކުންފުނީގެ ތެރޭގައި ތަކުރާރު ނުވާ، އަދި ބަދަލު ނުކުރެވޭ ކޯޑެއް — މި ޕްރޮޖެކްޓުން ނެރޭ ކޮންމެ އިންވޮއިސްއެއްގައި ފެންނާނެއެވެ.",
      "customerHint": "ބިލްކުރުމުގެ ކުރިން ބޭނުންވާނެއެވެ. ފަހުންވެސް ކަނޑައެޅިދާނެއެވެ.",
      "contractValueHint": "އެއްބަސްވެފައިވާ އަގު. ޕަސެންޓް ކޮމްޕްލީޓް ބިލްކުރުމުގައި މި އަދަދުން ގުނަކުރެއެވެ.",
      "submit": "ޕްރޮޖެކްޓް އުފައްދާ",
      "doneTitle": "ޕްރޮޖެކްޓް އުފެއްދިއްޖެ",
      "failed": "ޕްރޮޖެކްޓް އުފެއްދޭގޮތެއް ނުވި"
    },
    "edit": {
      "title": "{code} އެޑިޓްކުރޭ",
      "description": "ކޯޑާއި ކުންފުނި ފިޔަވައި ޕްރޮޖެކްޓްގެ ހުރިހާ ކަމެއް.",
      "billingNote": "ބިލްކުރާ ގޮތުން ކަނޑައަޅަނީ މި ޕްރޮޖެކްޓަށް ހިންގޭނީ ކޮން ބިލްކުރުމެއްކަން. ސާވަރުން އެހެން ގޮތެއް ބަލައެއް ނުގަންނާނެއެވެ.",
      "contractValueHint": "ޕަސެންޓް ކޮމްޕްލީޓް ބިލްކުރުމުގައި މި އަދަދުން ގުނަކުރެއެވެ. އެ ގޮތުގައި މި އަދަދު ނެތްނަމަ ބިލެއް ނުކުރެވޭނެއެވެ.",
      "revenueAccountHint": "މި ޕްރޮޖެކްޓުން ނެރޭ ކޮންމެ އިންވޮއިސްއެއް ކްރެޑިޓްކުރާ އެކައުންޓް. މި ނެތި ތިން ގޮތުންވެސް ބިލެއް ނުކުރެވޭނެއެވެ.",
      "revenueAccountPlaceholder": "އާމްދަނީ އެކައުންޓެއް ޚިޔާރުކުރައްވާ",
      "doneTitle": "ޕްރޮޖެކްޓް ރައްކާކުރެވިއްޖެ",
      "failed": "ޕްރޮޖެކްޓް ރައްކާނުކުރެވުނު"
    },
    "detail": {
      "factsTitle": "ތަފްޞީލު",
      "openCustomer": "ކަސްޓަމަރު ހުޅުވާ",
      "noCustomer": "ކަސްޓަމަރެއް ކަނޑައަޅާފައެއް ނުވޭ",
      "noManager": "މެނޭޖަރެއް ކަނޑައަޅާފައެއް ނުވޭ",
      "openTimesheets": "މި ޕްރޮޖެކްޓްގައި ފާސްކުރެވިފައިވާ ވަގުތު",
      "loadFailed": "ޕްރޮޖެކްޓް ލޯޑެއް ނުކުރެވުނު"
    },
    "rail": {
      "created": "އުފެއްދި",
      "start": "ރޭވިފައިވާ ފެށުން",
      "end": "ރޭވިފައިވާ ނިމުން",
      "timesheets": "ފާސްކުރެވިފައިވާ ޓައިމްޝީޓްތައް",
      "profitability": "ފައިދާ",
      "customer": "ކަސްޓަމަރު"
    },
    "removedTitle": "ނަގައިފި",
    "removeFailed": "ނެގޭގޮތެއް ނުވި",
    "confirmRemoveTitle": "މި ނަގަންތޯ؟",
    "confirmRemoveDescription": "{label} މި ޕްރޮޖެކްޓުން ނެގޭނެއެވެ.",
    "confirmRemoveNote": "މަސައްކަތެއް ނެގުމުން އޭގެ ބަޖެޓް ޕްރޮޖެކްޓްގެ ޖުމްލައިން ވެސް ނެގޭނެއެވެ. ޕަސެންޓް ކޮމްޕްލީޓް ބިލްކުރުމުގައި ބަހާ އަދަދަކީ އެއީއެވެ.",
    "phases": {
      "new": "މަރުޙަލާއެއް އިތުރުކުރޭ",
      "createTitle": "އައު މަރުޙަލާ",
      "editTitle": "މަރުޙަލާ އެޑިޓްކުރޭ",
      "dialogDescription": "މަރުޙަލާއަކުން މަސައްކަތްތައް އެއްކުރެއެވެ. އޭގެ ބަޖެޓަކީ އެ މަސައްކަތްތަކުގެ ބަޖެޓްގެ ޖުމްލައެވެ.",
      "sequence": "ތަރުތީބު",
      "sequenceHint": "ރޭވުމުގައި މި މަރުޙަލާ އޮންނަ ތަން. ފުރިހަމަ ޢަދަދެއް.",
      "statuses": {
        "planned": "ރޭވިފައި",
        "active": "ހިނގަމުންދާ",
        "completed": "ނިމިފައި"
      },
      "createdTitle": "މަރުޙަލާ އިތުރުކުރެވިއްޖެ",
      "savedTitle": "މަރުޙަލާ ރައްކާކުރެވިއްޖެ",
      "saveFailed": "މަރުޙަލާ ރައްކާނުކުރެވުނު"
    },
    "tasks": {
      "panelTitle": "މަސައްކަތުގެ ބައިތައް",
      "new": "އައު މަސައްކަތް",
      "addHere": "މިތަނަށް މަސައްކަތެއް އިތުރުކުރޭ",
      "createTitle": "އައު މަސައްކަތް",
      "editTitle": "މަސައްކަތް އެޑިޓްކުރޭ",
      "dialogDescription": "މަސައްކަތުގައި ބަޖެޓާއި ތާރީޚްތަކާއި ބަރޯސާވުންތައް ހުރެއެވެ. ފައިދާ ބަލަނީ މި ބަޖެޓާ އަޅާކިޔައިގެންނެވެ.",
      "wbsCode": "ޑަބްލިއުބީއެސް",
      "wbsCodeHint": "ހުސްކޮށް ބެހެއްޓުމުން ސާވަރުން ދެން އޮތް ކޯޑް ދޭނެއެވެ. ފަހުން ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "budget": "ބަޖެޓް",
      "budgetHint": "މި ޕްރޮޖެކްޓްގެ ބަޖެޓަކީ އޭގެ މަސައްކަތްތަކުގެ ބަޖެޓްގެ ޖުމްލައެވެ. ޕަސެންޓް ކޮމްޕްލީޓް ބިލްކުރުމުގައި ބަހަނީ އެ ޖުމްލައިންނެވެ.",
      "budgetNote": "ފައިދާ ސްކްރީނުގައި ފެންނަ ބަޖެޓަކީ ކެންސަލްނުކުރާ މަސައްކަތްތަކުގެ ބަޖެޓްގެ ޖުމްލައެވެ. މަރުޙަލާއެއްގެ ބަޖެޓަކީ އޭގެ މަސައްކަތްތަކުގެ ޖުމްލައެވެ.",
      "isMilestone": "މިއީ މައިލްސްޓޯނެއް",
      "isMilestoneHint": "ތާވަލުގައި ފެންނަ ނުކުތާއެއް. ބިލްކުރާ މައިލްސްޓޯނެއް ނޫން — އެ ތަކެތި ހުންނާނީ ބިލްކުރުމުގެ ބައިގައި، އަދަދާއެކުއެވެ.",
      "milestoneBadge": "މައިލްސްޓޯން",
      "dependsOn": "މަޑުކުރަނީ",
      "noDependencies": "އެއްވެސް އެއްޗަކަށް މަޑެއް ނުކުރެއެވެ.",
      "dependencyNote": "ނިމުމުން ފެށޭ ގޮތަށް އެކަނި: ލިސްޓުކޮށްފައިވާ މަސައްކަތްތައް ނިމުމުން މި މަސައްކަތް ފެށެއެވެ. ބުރެއް އުފެދޭ ބަރޯސާވުމެއް ސާވަރުން ބަލައެއް ނުގަންނާނެއެވެ.",
      "addDependency": "ބަރޯސާވުމެއް އިތުރުކުރޭ",
      "dependencyPlaceholder": "މަސައްކަތެއް ޚިޔާރުކުރައްވާ",
      "dependenciesAfterSave": "މަސައްކަތް އުފެއްދުމަށްފަހު ބަރޯސާވުން އިތުރުކުރެވޭނެ",
      "dependencyAdded": "ބަރޯސާވުން އިތުރުކުރެވިއްޖެ",
      "dependencyFailed": "ބަރޯސާވުން ބަދަލެއް ނުކުރެވުނު",
      "cycleRefused": "{task} ކުރިންވެސް މި މަސައްކަތަށް ބަރޯސާވެއެވެ. މިކަން އިތުރުކުރުމުން ބުރެއް އުފެދޭނެއެވެ.",
      "noPhase": "މަރުޙަލާއެއް ނެތް",
      "unassigned": "ޙަވާލުކޮށްފައެއް ނުވޭ",
      "statuses": {
        "not_started": "ނުފެށޭ",
        "in_progress": "ކުރިއަށްދާ",
        "blocked": "ހުއްޓިފައި",
        "done": "ނިމިފައި",
        "cancelled": "ކެންސަލްކޮށްފައި"
      },
      "createdTitle": "މަސައްކަތް އިތުރުކުރެވިއްޖެ",
      "savedTitle": "މަސައްކަތް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "މަސައްކަތް ރައްކާނުކުރެވުނު",
      "emptyTitle": "އަދި ބައިތަކަށް ބަހާލާފައެއް ނުވޭ",
      "emptyDescription": "މަސައްކަތް އެއްކުރުމަށް މަރުޙަލާއެއް، ނުވަތަ ވަކިން މަސައްކަތެއް އިތުރުކުރައްވާ. ފައިދާ ބަލަނީ މަސައްކަތުގެ ބަޖެޓާ އަޅާކިޔައިގެންނެވެ."
    },
    "members": {
      "panelTitle": "ޓީމާއި ރޭޓްތައް",
      "add": "ފަރާތެއް އިތުރުކުރޭ",
      "addTitle": "ޕްރޮޖެކްޓަށް ފަރާތެއް އިތުރުކުރޭ",
      "editTitle": "ރޭޓްތައް އެޑިޓްކުރޭ",
      "dialogDescription": "ޚަރަދުގެ ރޭޓަކީ ޓައިމްޝީޓް ފާސްކުރުމުން ޑަބްލިއުއައިޕީއަށް ޖަހާ އަދަދެވެ. ބިލްރޭޓަކީ ވަގުތާއި ތަކެތީގެ ބިލްކުރުމުގައި އިންވޮއިސްކުރާ އަދަދެވެ.",
      "person": "ފަރާތް",
      "personPlaceholder": "ފަރާތެއް ޚިޔާރުކުރައްވާ",
      "role": "ދައުރު",
      "costRate": "ޚަރަދުގެ ރޭޓް (ގަޑިއަކަށް {currency})",
      "costRateHint": "ޓައިމްޝީޓް ފާސްކުރުމުން ގަޑިއިރުން މި ރޭޓް ގުނަކޮށް ޕްރޮޖެކްޓް ޑަބްލިއުއައިޕީ ޑެބިޓްކުރެއެވެ. މިތާ ރޯއެއް ނެތްނަމަ އެ ފަރާތުގެ ވަގުތުގެ ޚަރަދެއް ނުބެލޭނެއެވެ.",
      "costRateShort": "ޚަރަދުގެ ރޭޓް",
      "billRate": "ބިލްރޭޓް (ގަޑިއަކަށް {currency})",
      "billRateHint": "ވަގުތާއި ތަކެތީގެ ބިލްކުރުމުގައި ކަސްޓަމަރަށް އިންވޮއިސްކުރާ އަދަދު. ސުމެއް ބެހެއްޓިދާނެ، ނަމަވެސް އެ ގަޑިތައް ބިލެއް ނުކުރެވޭނެއެވެ.",
      "billRateShort": "ބިލްރޭޓް",
      "ratesNote": "ޓައިމްޝީޓް ފާސްކުރުމުން ކޮންމެ ސަޠުރެއްގެ ޚަރަދު ރޭޓް ނަގަނީ މި ތާވަލުންނެވެ. މިތާ ނެތް ފަރާތެއްގެ ވަގުތުގެ ޚަރަދު ނުބެލޭތީ ފާސްކުރުން ހުއްޓުވޭނެއެވެ.",
      "savedTitle": "ޓީމް އަޕްޑޭޓްވެއްޖެ",
      "savedDetail": "އައު ރޭޓް ހިނގާނީ މިހާރުން ފެށިގެން ފާސްކުރެވޭ ޓައިމްޝީޓްތަކަށެވެ.",
      "saveFailed": "ޓީމް އަޕްޑޭޓެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި މި ޕްރޮޖެކްޓްގައި ފަރާތެއް ނެތް",
      "emptyDescription": "ވަގުތު ލިޔާނެ ފަރާތްތައް، ކޮންމެ ފަރާތަކަށް ޚަރަދު ރޭޓަކާއެކު އިތުރުކުރައްވާ. މިތާ ނެތް ފަރާތެއްގެ ޓައިމްޝީޓް ފާސްކުރުން ހުއްޓުވޭނެއެވެ."
    },
    "gantt": {
      "title": "ތާވަލު",
      "chartTitle": "ވަގުތާއެކު މަރުޙަލާތަކާއި މަސައްކަތްތައް",
      "readOnlyNote": "ހަމައެކަނި ބެލުމަށް. ތާރީޚް ބަދަލުކުރެވެނީ މަސައްކަތުގެ ތެރެއިން ކަމަށްވާތީ، ނުފެންނަ ދެމުމަކުން ރޭވުމެއް ބަދަލެއް ނުވާނެއެވެ. ބަރޯސާވުންތައް ކުރެހުމުގެ ބަދަލުގައި ކޮންމެ ރޯއެއްގައި ލިޔެފައި ހުންނާނެއެވެ.",
      "columns": {
        "item": "މަރުޙަލާ ނުވަތަ މަސައްކަތް",
        "dates": "ތާރީޚްތައް",
        "chart": "ތާވަލު"
      },
      "spanLabel": "{from} އިން {to} އަށް",
      "noDates": "ތާރީޚެއް ނެތް",
      "someUndated": "{count} ރޯއެއްގައި ތާރީޚެއް ނެތުމުން ބާރއެއް ނުދެއްކޭނެއެވެ.",
      "undatedTitle": "މި ރޭވުމުގައި އަދި ތާރީޚެއް ނެތް",
      "undatedDescription": "މަރުޙަލާއަކަށް ނުވަތަ މަސައްކަތަކަށް ފެށޭ އަދި ނިމޭ ތާރީޚެއް ދެއްވުމުން މިތާ ފެންނާނެއެވެ.",
      "emptyTitle": "އަދި ތާވަލުކުރާނެ އެއްޗެއް ނެތް",
      "emptyDescription": "ޕްރޮޖެކްޓްގެ ޚުލާޞާގައި މަރުޙަލާތަކާއި މަސައްކަތްތައް އިތުރުކުރެއްވުމުން ތަރުތީބުން މިތާ ފެންނާނެއެވެ.",
      "loadFailed": "ތާވަލު ލޯޑެއް ނުކުރެވުނު"
    },
    "profitability": {
      "title": "ފައިދާ",
      "budget": "ބަޖެޓް",
      "budgetSource": "ކެންސަލްނުކުރާ މަސައްކަތްތަކުގެ ބަޖެޓްގެ ޖުމްލަ.",
      "budgetLink": "މަސައްކަތްތައް ބައްލަވާ",
      "commitment": "ކޮމިޓްމަންޓް",
      "commitmentSource": "މި ޕްރޮޖެކްޓަށް ކޯޑްކޮށްފައިވާ ގަތުމުގެ އޯޑަރު ސަޠުރުތަކުގެ އަދިވެސް ނުނިމޭ ބައި: އޯޑަރުކުރި އަދަދުން މެޗްކުރި އަދަދު އުނިކުރުމުން. މިއީ ޕްރޮކިއުމަންޓްގެ ހިސާބުތަކުން ނަގާ އަދަދެކެވެ، ބަޖެޓް މޮޑިއުލުން ނޫނެވެ.",
      "commitmentLink": "ހުޅުވިފައިވާ ގަތުމުގެ އޯޑަރުތައް",
      "actualTotal": "ޙަޤީޤީ",
      "actualSource": "ޚަރަދު ބެލެވިފައިވާ ޓައިމްޝީޓް ސަޠުރުތަކާއި މި ޕްރޮޖެކްޓަށް ކޯޑްކޮށްފައިވާ ޕޯސްޓްކުރި އޭޕީ އިންވޮއިސް ސަޠުރުތައް.",
      "actualTimesheet": "ވަގުތު",
      "actualTimesheetShort": "ވަގުތުގެ ޚަރަދު",
      "actualAp": "ގަނެފައިވާ ތަކެތި",
      "timesheetSource": "ޓައިމްޝީޓް ފާސްކުރި ވަގުތު ކޮންމެ ސަޠުރެއްގައި ލިޔެވުނު ޚަރަދު",
      "timesheetLink": "ފާސްކުރެވިފައިވާ ޓައިމްޝީޓްތައް",
      "journalLink": "ލެޖަރ ޕޯސްޓިންގތައް",
      "apSource": "މި ޕްރޮޖެކްޓަށް ކޯޑްކޮށްފައިވާ ޕޯސްޓްކުރި އޭޕީ އިންވޮއިސް ސަޠުރުތައް",
      "apLink": "ޕޯސްޓްކުރި ގަތުމުގެ އިންވޮއިސްތައް",
      "widerThanFigure": "އެ ލިސްޓް ޕްރޮޖެކްޓުން ފިލްޓަރެއް ނުކުރެވެއެވެ — ސަޠުރުގެ ޕްރޮޖެކްޓް ޓެގް ދޭ ލިސްޓް އެންޑްޕޮއިންޓެއް ނެތެވެ — އެހެންކަމުން މި އަދަދަށްވުރެ ފުޅާވާނެއެވެ.",
      "eac": "ނިމޭއިރު ލަފާކުރެވޭ ޚަރަދު",
      "eacSource": "ޚަރަދުކުރެވި ނުވަތަ ކޮމިޓްކުރެވިފައިވާ ބައި އޭގެ އަގުގައި، އަދި ބާކީ ބަޖެޓް ރޭވިފައިވާ ގޮތުގައި. ޚަރަދުކުރެވި ކޮމިޓްކުރެވިފައިވާ އަދަދަށްވުރެ ދަށެއް ނުވާނެއެވެ.",
      "variance": "ތަފާތު",
      "varianceSource": "ބަޖެޓުން ނިމޭއިރު ލަފާކުރެވޭ ޚަރަދު އުނިކުރުމުން. ޕޮޒިޓިވްވުމަކީ ބަޖެޓްގެ ތެރޭގައި ވުމެވެ.",
      "overBudget": "ބަޖެޓުން ބޭރު",
      "underBudget": "ބަޖެޓްގެ ތެރޭގައި",
      "consumedTitle": "ބޭނުންކުރެވުނު ބަޖެޓް",
      "consumed": "ނިމޭއިރު ލަފާކުރެވޭ ޚަރަދަކީ ބަޖެޓްގެ {percent}% އެވެ.",
      "noBudget": "މަސައްކަތުގެ ބަޖެޓެއް ކަނޑައަޅާފައި ނުވާތީ އަޅާކިޔާނެ އެއްޗެއް ނެތެވެ.",
      "actualBreakdownTitle": "ޙަޤީޤީ އަދަދު އައި ތަން",
      "columns": {
        "source": "މަޞްދަރު",
        "trace": "ދިރާސާ"
      },
      "revenueTitle": "އާމްދަނީ",
      "revenueNote": "މިހާތަނަށް ބިލްކުރި އަދަދަކީ މި ޕްރޮޖެކްޓްގެ ބިލްކުރުންތަކުގެ ޖުމްލައެވެ. ޕަސެންޓް ކޮމްޕްލީޓް ޕްރޮޖެކްޓްތަކުގައި ބަލައިގަނެވުނު އާމްދަނީއާއި ބިލްކުރި އާމްދަނީއަކީ އެއް އަދަދެކެވެ.",
      "billedToDate": "މިހާތަނަށް ބިލްކުރި",
      "billingLink": "ބިލްކުރުމުގެ ތާރީޚް",
      "byPhaseTitle": "މަރުޙަލާތަކުން",
      "byPhaseNote": "މަރުޙަލާއާއި މަސައްކަތުގެ ރޯތަކުގައި ހުންނަނީ ހަމައެކަނި ވަގުތުގެ ޚަރަދެވެ. ގަނެފައިވާ ތަކެއްޗާއި ކޮމިޓްމަންޓް ލިޔެވެނީ ޕްރޮޖެކްޓަށް ކަމަށްވާތީ، އެ ފެންނާނީ މަތީގައިވާ ޖުމްލަތަކުންނެވެ.",
      "ofBudget": "ބަޖެޓްގެ",
      "noPhasesTitle": "މަރުޙަލާއެއް ނެތް",
      "noPhasesDescription": "ޕްރޮޖެކްޓްގެ ޚުލާޞާގައި މަސައްކަތްތައް މަރުޙަލާތަކަށް އެއްކުރެއްވުމުން މިތާ ފެންނާނެއެވެ.",
      "byTaskTitle": "މަސައްކަތުން",
      "noTasksTitle": "މަސައްކަތެއް ނެތް",
      "noTasksDescription": "މަސައްކަތެއް ނެތް ޕްރޮޖެކްޓެއްގައި އަޅާކިޔާނެ ބަޖެޓެއް ނުހުންނާނެއެވެ.",
      "loadFailed": "ފައިދާ ލޯޑެއް ނުކުރެވުނު"
    },
    "billing": {
      "title": "ބިލްކުރުން",
      "methods": {
        "fixed_price_milestone": "ސާބިތު އަގު، މައިލްސްޓޯނުން",
        "time_and_materials": "ވަގުތާއި ތަކެތި",
        "percent_complete": "ޕަސެންޓް ކޮމްޕްލީޓް"
      },
      "methodHints": {
        "fixed_price_milestone": "އެއްބަސްވެފައިވާ އަދަދުތައް، ކޮންމެ މައިލްސްޓޯނެއް ފުއްދުމުން ވަކިވަކިން އިންވޮއިސްކުރެވެއެވެ.",
        "time_and_materials": "ފާސްކުރެވިފައިވާ، ބިލްކުރެވޭ ގަޑިއިރުތައް ކޮންމެ ފަރާތެއްގެ ބިލްރޭޓުން އިންވޮއިސްކުރެވެއެވެ.",
        "percent_complete": "ޚަރަދުން ޚަރަދަށް: ބަޖެޓުން ޚަރަދުކުރެވުނު ބައިން އެއްބަސްވުމުގެ އަގުން ލިބުނު ބައި ކަނޑައެޅި، ފަހު ފަހަރަށްފަހު އިތުރުވި މިންވަރު އިންވޮއިސްކުރެވެއެވެ."
      },
      "methodUnset": "ކަނޑައަޅާފައެއް ނުވޭ",
      "noMethod": "މި ޕްރޮޖެކްޓަށް ބިލްކުރާ ގޮތެއް ކަނޑައަޅާފައި ނުވާތީ ބިލްކުރުމުގެ ތިން ގޮތުންވެސް އެއްވެސް ކަމެއް ނުކުރެވޭނެއެވެ.",
      "setMethodLink": "ޕްރޮޖެކްޓްގައި ކަނޑައަޅުއްވާ",
      "noRevenueAccount": "މި ޕްރޮޖެކްޓަށް އާމްދަނީ އެކައުންޓެއް ނެތުމުން އިންވޮއިސެއް ނުނެރެވޭނެއެވެ.",
      "noRevenueAccountTitle": "އާމްދަނީ އެކައުންޓެއް ނެތް",
      "milestonesTitle": "ބިލްކުރާ މައިލްސްޓޯންތައް",
      "addMilestone": "މައިލްސްޓޯނެއް އިތުރުކުރޭ",
      "addMilestoneDescription": "އެއްބަސްވެފައިވާ އަދަދެއް، ފުއްދުމުން އިންވޮއިސްކުރެވެއެވެ.",
      "amount": "އަދަދު",
      "dueDate": "މުއްދަތު",
      "markReady": "ފުއްދިއްޖެކަމަށް ފާހަގަކުރޭ",
      "invoiceIt": "އިންވޮއިސްކުރޭ",
      "invoiceColumn": "އިންވޮއިސް",
      "openInvoice": "ހުޅުވާ",
      "milestoneStatuses": {
        "pending": "އިންތިޒާރުގައި",
        "ready": "ފުއްދިފައި",
        "invoiced": "އިންވޮއިސްކޮށްފައި",
        "cancelled": "ކެންސަލްކޮށްފައި"
      },
      "milestoneAdded": "މައިލްސްޓޯން އިތުރުކުރެވިއްޖެ",
      "readyTitle": "ފުއްދިއްޖެކަމަށް ފާހަގަކުރެވިއްޖެ",
      "noMilestonesTitle": "އަދި މައިލްސްޓޯނެއް ނެތް",
      "noMilestonesDescription": "އެއްބަސްވެފައިވާ އަދަދުތަކާއި އެއާ ގުޅޭ ކަންކަން އިތުރުކުރައްވާ. ފުރަތަމަ ފުއްދިއްޖެކަމަށް ފާހަގަކޮށް، ދެން އިންވޮއިސްކުރެވެއެވެ.",
      "tmTitle": "ވަގުތާއި ތަކެތި",
      "tmPreviewTitle": "މި ފަހަރު އިންވޮއިސްކުރެވޭނެ އެއްޗެއް",
      "tmPreviewNote": "ތިރީގައިވާ ތާރީޚާ ހަމައަށް މި ޕްރޮޖެކްޓްގައި ފާސްކުރެވި، ބިލްކުރެވޭ، އަދި ބިލްނުކުރާ ކޮންމެ ގަޑިއިރެއް، އިންވޮއިސްގައި އެއްކުރެވޭނެ ގޮތަށް މަސައްކަތުން އެއްކުރެވިފައި. ކޮންމެ އަދަދަކީ ޓައިމްޝީޓް ފާސްކުރި ވަގުތު އެ ސަޠުރުގައި ލިޔެވުނު އަދަދެވެ.",
      "through": "ހަމައަށް",
      "throughHint": "ހުސްކޮށް ބެހެއްޓުމުން ފާސްކުރެވި ބިލްނުކުރާ ހުރިހާ އެއްޗެއް ބިލްކުރެވޭނެއެވެ.",
      "invoiceLine": "އިންވޮއިސް ސަޠުރު",
      "hours": "ގަޑިއިރު",
      "netAmount": "ސާފު އަދަދު",
      "netTotal": "ސާފު ޖުމްލަ",
      "taxNote": "ޓެކްސް ނުލައި. އިންވޮއިސްގެ ޖުމްލައަކީ މިއާއެކު ރިސީވަބަލްސް މޮޑިއުލުން ކޮންމެ ސަޠުރަކަށް ކަނޑައަޅާ ޓެކްސްއެވެ.",
      "zeroRateLines": "މީގެ ތެރެއިން {count} ސަޠުރެއްގައި ބިލްކުރާނެ އަދަދެއް ނެތެވެ. ސަބަބަކީ ޓައިމްޝީޓް ފާސްކުރި ވަގުތު އެ ފަރާތުގެ ބިލްރޭޓެއް ނެތުމެވެ.",
      "runTm": "އިންވޮއިސް ނެރޭ",
      "tmEmptyTitle": "ބިލްކުރާނެ އެއްޗެއް ނެތް",
      "tmEmptyDescription": "އެ ތާރީޚާ ހަމައަށް މި ޕްރޮޖެކްޓްގައި ފާސްކުރެވި ބިލްނުކުރާ ވަގުތެއް ނެތެވެ. ޓައިމްޝީޓެއް ފާސްކުރެއްވުމުން މިތާ ފެންނާނެއެވެ.",
      "generalTime": "ޕްރޮޖެކްޓްގެ ޢާންމު ވަގުތު",
      "percentTitle": "ޕަސެންޓް ކޮމްޕްލީޓް",
      "percentPreviewNote": "ޚަރަދުން ޚަރަދަށް، ފައިދާގެ އަދަދުތަކުން ސާވަރު ހިސާބުކުރާ ގޮތަށް ހިސާބުކުރެވިފައި. މިއީ ލަފައެކެވެ: ބިލްކުރާ ވަގުތު ސާވަރުން އަލުން ޚަރަދާއި ބަޖެޓް ބަލާތީ، މެދުތެރެއިން ފާސްކުރެވޭ ޓައިމްޝީޓަކުން މި އަދަދު ބަދަލުވެއެވެ.",
      "percentComplete": "ފުރިހަމަވި ޕަސެންޓް",
      "earnedToDate": "މިހާތަނަށް ލިބުނު",
      "increment": "މި ފަހަރު އިންވޮއިސްކުރެވޭނެ",
      "percentCapped": "ޚަރަދު ބަޖެޓާ ހަމަވެ ނުވަތަ އިތުރުވެފައިވާތީ ނިސްބަތް 100% ގައި ހިފެހެއްޓިފައި.",
      "nothingToRecognise": "މިހާތަނަށް ލިބުނު ހުރިހާ އެއްޗެއް ބަލައިގަނެވިފައިވާތީ އައު އިންވޮއިސްކުރާނެ އެއްޗެއް ނެތެވެ.",
      "runPercent": "ބަލައިގަނެ އިންވޮއިސްކުރޭ",
      "percentBlockedTitle": "ޕަސެންޓް ކޮމްޕްލީޓް އަދި ހިސާބެއް ނުކުރެވޭނެ",
      "percentBlockedDescription": "މިއަށް ބޭނުންވަނީ ޕްރޮޖެކްޓްގެ އެއްބަސްވުމުގެ އަގާއި މަސައްކަތްތަކުގެ ބަޖެޓެވެ. އެއިން އެއްޗެއް ނެތްނަމަ ނިސްބަތެއް ނުނެރެވޭނެއެވެ.",
      "confirmTitle": "މި އިންވޮއިސް ނެރެންތޯ؟",
      "confirmDescription": "މިއިން އެއް ފިޔަވަޅުގައި ރިސީވަބަލްސް އިންވޮއިސެއް ނެރެ، ކަށަވަރުކޮށް، ޕޯސްޓްކުރެއެވެ.",
      "confirmIrreversible": "ފަހުން ބަލާނެ ދެލިކޮޕީއެއް ނުހުންނާނެއެވެ، އަދި މި ސްކްރީނުން އަނބުރާ ނުގެނެވޭނެއެވެ. ކުށެއް ރަނގަޅުކުރެވޭނީ ރިސީވަބަލްސްގައި ކްރެޑިޓް ނޯޓަކުންނެވެ.",
      "confirmSubmit": "ނެރެ ޕޯސްޓްކުރޭ",
      "linesToBill": "ޓައިމްޝީޓް ސަޠުރުތައް",
      "invoiceDate": "އިންވޮއިސް ތާރީޚް",
      "invoiceDateHint": "ޑިފޯލްޓަކީ ޓެނަންޓްގެ ޓައިމްޒޯނުގައި މިއަދު.",
      "invoicedTitle": "އިންވޮއިސް ނެރެވިއްޖެ",
      "failed": "އިންވޮއިސް ނުނެރެވުނު",
      "historyTitle": "ބިލްކުރުމުގެ ތާރީޚް",
      "billedOn": "ބިލްކުރި ތާރީޚް",
      "noHistoryTitle": "އަދި ބިލްކޮށްފައެއް ނުވޭ",
      "noHistoryDescription": "މި ޕްރޮޖެކްޓުން ކުރާ ކޮންމެ ބިލްކުރުމެއް، ނެރުނު އިންވޮއިސްއާއެކު މިތާ ލިޔެވޭނެއެވެ.",
      "loadFailed": "ބިލްކުރުން ލޯޑެއް ނުކުރެވުނު"
    },
    "timesheets": {
      "title": "ޓައިމްޝީޓްތައް",
      "description": "ކޮންމެ ފަރާތަކަށް ހަފްތާއެއްގެ ގަޑިއިރު. ފާސްކުރުމުން ލެޖަރަށް ޚަރަދު ޖެހެއެވެ.",
      "openWeekTitle": "ހަފްތާއެއް ހުޅުވާ",
      "openWeekNote": "ޓައިމްޝީޓް ހަފްތާ އަބަދުވެސް ފެށެނީ ޓެނަންޓްގެ ޓައިމްޒޯނުގައި ހޯމަ ދުވަހުންނެވެ. ޚިޔާރުކުރާ ކޮންމެ ތާރީޚެއް އެ ހަފްތާގެ ހޯމައަށް ބަދަލުކުރެވެއެވެ.",
      "weekOf": "ހަފްތާ",
      "weekHint": "ހަފްތާގެ ކޮންމެ ދުވަހެއްވެސް ރަނގަޅު.",
      "snappedTo": "އެ ހަފްތާ ފެށެނީ {date} ގައި.",
      "forEmployee": "ފަރާތް",
      "forEmployeeHint": "ތިޔަ ބޭފުޅާގެ ހަފްތާއަށް ހުސްކޮށް ބަހައްޓަވާ.",
      "myself": "އަޅުގަނޑު",
      "openWeek": "ހުޅުވާ",
      "ownOnly": "ދައްކަނީ ތިޔަ ބޭފުޅާގެ ޓައިމްޝީޓްތައް. އެންމެންގެ ބެލުމަށް ޓައިމްޝީޓް ކިޔުމުގެ ހުއްދަ ބޭނުންވެއެވެ.",
      "pageHours": "މި ޞަފުޙާގައި {hours} ގަޑިއިރު",
      "emptyTitle": "މިތާ ޓައިމްޝީޓެއް ނެތް",
      "emptyDescription": "މަތިން ހަފްތާއެއް ހުޅުވައި ގްރިޑް ފުރުއްވާ — ފަރާތުގައި ޕްރޮޖެކްޓާއި މަސައްކަތް، މަތީގައި ދުވަސްތައް.",
      "loadFailed": "ޓައިމްޝީޓްތައް ލޯޑެއް ނުކުރެވުނު"
    },
    "timesheet": {
      "title": "{week} ގެ ހަފްތާ",
      "railTitle": "{week} ގެ ހަފްތާ",
      "week": "ހަފްތާ",
      "employee": "ފަރާތް",
      "gridTitle": "ގަޑިއިރު",
      "gridCaption": "ފަރާތުގައި ޕްރޮޖެކްޓާއި މަސައްކަތް، މަތީގައި ހަފްތާގެ ދުވަސްތައް.",
      "pickProject": "ޕްރޮޖެކްޓެއް ޚިޔާރުކުރައްވާ",
      "noTask": "މަސައްކަތެއް ނެތް",
      "descriptionPlaceholder": "ކުރެވުނު ކަންތައް",
      "billable": "ބިލްކުރެވޭ",
      "cellLabel": "{day} ގެ ގަޑިއިރު",
      "rowTotal": "ޖުމްލަ",
      "dayTotals": "ދުވަހުގެ ޖުމްލަ",
      "addRow": "ރޯއެއް އިތުރުކުރޭ",
      "removeRow": "މި ރޯ ނަގާ",
      "keyboardHint": "އެންޓަރުން ކޮލަމުން ތިރިއަށް ދެއެވެ، އަދި އެންމެ ތިރީގައި އައު ރޯއެއް އިތުރުކުރެއެވެ. އޯލްޓް+ތިރި ރޯ ކޮޕީކުރެއެވެ، އޯލްޓް+ބެކްސްޕޭސް ރޯ ނަގައެވެ، އަދި އެރޯ ކީތަކުން ރޯތަކުގެ މެދުގައި ދެވެއެވެ.",
      "hoursScaleNote": "ގަޑިއިރު ލިޔެވެނީ ދިހަހުގެ {scale} ދަރަޖައަށް، ދުވާލަކަށް ގިނަވެގެން 24 އެވެ.",
      "weekTotal": "ހަފްތާ",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "ހުށަހަޅާފައި",
        "approved": "ފާސްކޮށް ޚަރަދު ބެލިފައި",
        "rejected": "ބޭރުކޮށްފައި"
      },
      "costColumn": "ޚަރަދު",
      "notCosted": "ޚަރަދު ބެލިފައެއް ނުވޭ",
      "incompleteRows": "{count} ރޯއެއްގައި ގަޑިއިރު ހުރި ނަމަވެސް ޕްރޮޖެކްޓެއް ނެތުމުން ދޫވެގެންދާނެއެވެ. ޕްރޮޖެކްޓެއް ޚިޔާރުކުރައްވާ ނުވަތަ ގަޑިއިރު ފުއްސަވާ.",
      "invalidCells": "{count} ގޮޅިއެއްގައި ސާވަރު ބަލައިގަންނަ ގަޑިއިރެއް ނެތެވެ. ކޮންމެ އަދަދެއް ސުމަށްވުރެ ބޮޑުވެ، ގިނަވެގެން 24 ވާންޖެހެއެވެ.",
      "strayLines": "މި ޓައިމްޝީޓްގެ {count} ސަޠުރެއް އޭގެ ހަފްތާއިން ބޭރުގައި ވާތީ ގްރިޑްގައި ނުދައްކައެވެ. ރައްކާކުރުމުން އެ ސަޠުރުތައް ނެގޭނެއެވެ.",
      "postingTitle": "ފާސްކުރުމުން ޕޯސްޓްވާނެ އެއްޗެއް",
      "postingNote": "ޓައިމްޝީޓެއްގެ ޚަރަދު ބެލެނީ ހަމައެކަނި ފާސްކުރުމުންނެވެ. އެއިރު ޕްރޮޖެކްޓް ޓީމުން ކޮންމެ ފަރާތެއްގެ ޚަރަދު ރޭޓް ނަގައި، ކޮންމެ ސަޠުރެއްގައި ޚަރަދު ލިޔެ، އެއް ޖާނަލް ޕޯސްޓްކުރެއެވެ: ކޮންމެ ޕްރޮޖެކްޓެއްގެ ގަޑިއިރަށް ޕްރޮޖެކްޓް ޑަބްލިއުއައިޕީ ޑެބިޓް، އަދި ހަފްތާގެ ޖުމްލައަށް ޕޭރޯލް ކްލިއަރިންގ ކްރެޑިޓް.",
      "wouldDebit": "ޑަބްލިއުއައިޕީ ޑެބިޓް",
      "wouldCredit": "ޕޭރޯލް ކްލިއަރިންގ ކްރެޑިޓް",
      "postingProjection": "މިއީ މިހާރު ހުރި ރޭޓްތަކުން ނެގޭ ލަފައެކެވެ. ފާސްކުރާ ވަގުތު ސާވަރުން އަލުން ރޭޓް ނަގައި، އޭރު ލިޔެވޭ އަދަދުތަކަކީ ބަލައިގަނެވޭ އަދަދުތަކެވެ.",
      "postingIncomplete": "މީގެ ތެރެއިން ޕްރޮޖެކްޓަކަށް މި ފަރާތުގެ ޚަރަދު ރޭޓެއް ނެތުމުން ފާސްކުރުން ހުއްޓުވޭނެއެވެ. ފުރަތަމަ އެ ޕްރޮޖެކްޓްގެ ޓީމަށް އެ ފަރާތް އިތުރުކުރައްވާ.",
      "noRate": "ރޭޓެއް ނެތް",
      "noRateBanner": "{project} ގައި މި ފަރާތުގެ ޚަރަދު ރޭޓެއް ނެތުމުން އެ ފަރާތުގެ ވަގުތުގެ ޚަރަދު ނުބެލޭނެއެވެ.",
      "noRateLink": "ޓީމަށް އިތުރުކުރޭ",
      "settingsMissing": "މި ކުންފުންޏަށް ޑަބްލިއުއައިޕީ ނުވަތަ ޕޭރޯލް ކްލިއަރިންގ އެކައުންޓެއް ކަނޑައަޅާފައި ނުވާތީ އެއްވެސް ޚަރަދެއް ނުބެލޭނެއެވެ.",
      "settingsLink": "އެކައުންޓްތައް ކަނޑައަޅުއްވާ",
      "costedTitle": "ޚަރަދު ބެލިފައި",
      "costedNote": "މިއީ ޓައިމްޝީޓް ފާސްކޮށް ޕޯސްޓްކުރި ވަގުތު ސާވަރުން ލިޔުނު އަދަދުތަކެވެ. މި ސްކްރީނުން އެއްވެސް އަދަދެއް އަލުން ހިސާބެއް ނުކުރެއެވެ.",
      "totalCost": "ޖުމްލަ ޚަރަދު",
      "journal": "ޖާނަލް އެންޓްރީ",
      "approveAndPost": "ފާސްކޮށް ޕޯސްޓްކުރޭ",
      "unsavedGuard": {
        "title": "ރައްކާނުކުރާ ބަދަލުތައް ދޫކޮށްލާނަންތޯ؟",
        "message": "މި ޓައިމްޝީޓުގައި ރައްކާނުކުރެވޭ ބަދަލުތަކެއް އެބަހުރި. މިހާރު ދޫކޮށްލައިފިނަމަ، އެ ބަދަލުތައް ގެއްލޭނެ.",
        "confirm": "ބަދަލުތައް ދޫކޮށްލާ",
        "cancel": "އިތުރަށް އެޑިޓްކުރޭ"
      },
      "saveBeforeSubmit": "ހުށަހެޅުމުގެ ކުރިން ގްރިޑް ރައްކާކުރައްވާ.",
      "savedTitle": "ޓައިމްޝީޓް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "ގްރިޑްގައި މިހާރު ހުރީ ފެންނަ އެއްޗެވެ.",
      "saveFailed": "ޓައިމްޝީޓް ރައްކާނުކުރެވުނު",
      "submittedTitle": "ފާސްކުރުމަށް ހުށަހެޅިއްޖެ",
      "submittedDetail": "އެންމެ ފަހު ފާސްކުރާ ފަރާތުން ނިންމުމުން ޚަރަދު ބެލޭނެއެވެ.",
      "submitFailed": "ޓައިމްޝީޓް ހުށަހެޅޭގޮތެއް ނުވި",
      "autoApprovedTitle": "ހުށަހެޅި، ފާސްވެ، ޚަރަދު ބެލިއްޖެ",
      "autoApprovedDetail": "ފާސްކުރުމުގެ އުޞޫލެއް ނުގުޅުނު ކަމަށްވާތީ އެއް ފިޔަވަޅުގައި ޚަރަދު ޕޯސްޓްކުރެވުނެވެ.",
      "approvedTitle": "ފާސްވެ ޚަރަދު ބެލިއްޖެ",
      "approvedDetail": "ޖާނަލް ޕޯސްޓްކުރެވިއްޖެ؛ ޓައިމްޝީޓްގައި މިހާރު ފެންނާނީ އޭގެ އަދަދުތަކެވެ.",
      "approveFailed": "ޓައިމްޝީޓް ފާސްކުރެވޭގޮތެއް ނުވި",
      "rejectTitle": "މި ޓައިމްޝީޓް ބޭރުކުރަންތޯ؟",
      "rejectDescription": "ރަނގަޅުކޮށް އަލުން ހުށަހެޅުމަށް އެ ފަރާތަށް އެނބުރި ދާނެއެވެ. އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުވާނެއެވެ.",
      "rejectReason": "ސަބަބު",
      "rejectedTitle": "ބޭރުކުރެވިއްޖެ",
      "rejectedDetail": "އެ ފަރާތަށް އެޑިޓްކޮށް އަލުން ހުށަހެޅޭނެއެވެ.",
      "rejectedBanner": "ބޭރުކުރެވިފައި: {reason}",
      "rejectFailed": "ޓައިމްޝީޓް ބޭރުކުރެވޭގޮތެއް ނުވި",
      "discard": "އުކާލާ",
      "discardTitle": "މި ޓައިމްޝީޓް އުކާލަންތޯ؟",
      "discardDescription": "ފާސްކުރުމުގެ ތާރީޚެއް ނެތް ދެލިކޮޕީއެއް. އަނބުރާ ނުގެނެވޭނެއެވެ.",
      "discardedTitle": "އުކާލެވިއްޖެ",
      "discardedDetail": "އެ ހަފްތާ އަލުން ހުޅުވޭނެއެވެ.",
      "discardFailed": "ޓައިމްޝީޓް އުކާލެވޭގޮތެއް ނުވި",
      "openFailed": "އެ ހަފްތާ ހުޅުވޭގޮތެއް ނުވި",
      "loadFailed": "ޓައިމްޝީޓް ލޯޑެއް ނުކުރެވުނު",
      "rail": {
        "week": "ހަފްތާ ފެށެނީ",
        "submitted": "ހުށަހެޅި",
        "approved": "ފާސްކުރި",
        "approvedDetail": "ލެޖަރަށް ޚަރަދު ޕޯސްޓްކުރެވުނު",
        "employeeSheets": "މި ފަރާތުގެ ޓައިމްޝީޓްތައް",
        "journal": "ޖާނަލް އެންޓްރީ"
      },
      "contractorOwner": "ކޮންޓްރެކްޓަރު #{id}",
      "unknownOwner": "ވެރިފަރާތް ނޭނގޭ",
      "postingContractor": "މި ހަފްތާ ނިސްބަތްވަނީ ކޮންޓްރެކްޓަރަކަށެވެ. އެ ފަރާތުގެ ރޭޓަކީ ޕްރޮޖެކްޓަކަށް ވަކިވަކިން ނޫން، ޕޯޓަލް ޔޫޒަރުގައި އޮންނަ އެއް ރޭޓެކެވެ. އެ ތާވަލަކީ ޕޯޓަލްގެ އެއްޗެއް ކަމަށްވެފައި، މި އެޕުން އެ ނުކިޔޭތީ ފާސްކުރުމުން ދާނެ ޚަރަދު މިތާ ނުދައްކައެވެ — ފާސްކޮށް ޕޯސްޓްކުރުމުން އަދަދުތައް ޓައިމްޝީޓްގައި ފެންނާނެއެވެ.",
      "noContractorRateBanner": "ކޮންޓްރެކްޓަރު #{id} އަށް ޚަރަދުގެ ރޭޓެއް ކަނޑައަޅާފައި ނުވާތީ އެ ފަރާތުގެ ވަގުތުގެ ޚަރަދު ނުބެލޭނެއެވެ. ރޭޓް ކަނޑައަޅަނީ ޕޯޓަލް ޔޫޒަރުގައެވެ، ޕްރޮޖެކްޓް ޓީމުގައެއް ނޫނެވެ."
    },
    "settings": {
      "title": "ޕްރޮޖެކްޓް ސެޓިންގތައް",
      "description": "ކޮންމެ ކުންފުންޏަކަށް، ޓައިމްޝީޓްގެ ޚަރަދު ޕޯސްޓްވާ ދެ އެކައުންޓް.",
      "companyTitle": "ކުންފުނި",
      "accountsTitle": "ޚަރަދުގެ އެކައުންޓްތައް",
      "postingNote": "ޓައިމްޝީޓެއް ފާސްކުރުމުން އެއް ޖާނަލް ޕޯސްޓްކުރެއެވެ: ކޮންމެ ޕްރޮޖެކްޓެއްގެ ޚަރަދު ބެލި ގަޑިއިރަށް ޑަބްލިއުއައިޕީ އެކައުންޓް ޑެބިޓް، އަދި ހަފްތާގެ ޖުމްލައަށް ޕޭރޯލް ކްލިއަރިންގ އެކައުންޓް ކްރެޑިޓް. ޑަބްލިއުއައިޕީއަކީ އެސެޓެކެވެ — ކުރެވިފައިވާ އަދި އަދި ބިލްނުކުރާ މަސައްކަތެވެ. ޕޭރޯލް ކްލިއަރިންގއަކީ ފަހުން ޕޭރޯލުން ފިލުވާލާ ދަރަންޏެވެ.",
      "incomplete": "ދެ އެކައުންޓްވެސް ބޭނުންވެއެވެ. އެ ކަނޑައެޅެންދެން ޓައިމްޝީޓް ފާސްކުރުން ހުއްޓުވޭނެއެވެ.",
      "wipAccount": "ކުރިއަށްދާ މަސައްކަތުގެ އެކައުންޓް",
      "wipAccountHint": "ކޮންމެ ޕްރޮޖެކްޓެއްގެ ޚަރަދު ބެލި ގަޑިއިރުން ޑެބިޓްކުރެވެއެވެ. އެސެޓް އެކައުންޓެއް.",
      "clearingAccount": "ޕޭރޯލް ކްލިއަރިންގ އެކައުންޓް",
      "clearingAccountHint": "ހަފްތާގެ ޖުމްލަ ޚަރަދުން ކްރެޑިޓްކުރެވެއެވެ. ދަރަނީގެ އެކައުންޓެއް.",
      "pickAccount": "އެކައުންޓެއް ޚިޔާރުކުރައްވާ",
      "saveHint": "މި ބަދަލު ހިނގާނީ މިހާރުން ފެށިގެން ފާސްކުރެވޭ ޓައިމްޝީޓްތަކަށެވެ، ކުރިން ޕޯސްޓްކުރި އެއްޗަކަށް ނޫނެވެ.",
      "savedTitle": "ސެޓިންގތައް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "މި ކުންފުނީގެ ޓައިމްޝީޓްތަކުގެ ޚަރަދު މިހާރު ބެލޭނެއެވެ.",
      "saveFailed": "ސެޓިންގތައް ރައްކާނުކުރެވުނު",
      "loadFailed": "ސެޓިންގތައް ލޯޑެއް ނުކުރެވުނު",
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި އެކައުންޓުތައް ބަދަލުކޮށްފި. ކަމެއް ނުފޮހެވޭ. ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކުރޭ"
    },
    "c11": {
      "routeTitles": {
        "wipRuns": "ޑަބްލިއުއައިޕީ ރަންތައް",
        "retentions": "ރިޓެންޝަން",
        "advances": "އެޑްވާންސް",
        "allocations": "ހަވާލުކުރުމުގެ ބޯޑް",
        "resources": "ޕްލޭނިން ރިސޯސް",
        "variations": "ވެރިއޭޝަން",
        "risks": "ރިސްކް ރަޖިސްޓަރީ",
        "subcontracts": "ސަބްކޮންޓްރެކްޓް",
        "contractSettings": "ކޮންޓްރެކްޓް އެކައުންޓް",
        "baselines": "ބޭސްލައިން",
        "schedule": "ޝެޑިއުލް",
        "evm": "އާން ވެލިއު",
        "contract": "ކޮންޓްރެކްޓް ޝަރުތު"
      },
      "nav": {
        "wipRuns": "ޑަބްލިއުއައިޕީ",
        "retentions": "ރިޓެންޝަން",
        "advances": "އެޑްވާންސް",
        "variations": "ވެރިއޭޝަން",
        "subcontracts": "ސަބްކޮންޓްރެކްޓް",
        "risks": "ރިސްކް",
        "resources": "ރިސޯސް",
        "allocations": "ހަވާލުކުރުން",
        "contractSettings": "ކޮންޓްރެކްޓް އެކައުންޓް"
      },
      "tabs": {
        "baselines": "ބޭސްލައިން",
        "schedule": "ޝެޑިއުލް",
        "evm": "އާން ވެލިއު",
        "contract": "ކޮންޓްރެކްޓް"
      },
      "project": "ޕްރޮޖެކްޓް",
      "status": "ސްޓޭޓަސް",
      "choose": "އެއް އިޚްތިޔާރު ކުރައްވާ",
      "optional": "އިޚްތިޔާރީ",
      "note": "ނޯޓް",
      "comment": "ކޮމެންޓް",
      "reasonCode": "ސަބަބުގެ ކޯޑް",
      "taxCode": "ޓެކްސް ކޯޑް",
      "currency": "ފައިސާގެ ބާވަތް",
      "costCategory": "ޚަރަދުގެ ބާވަތް",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "costCategories": {
        "labour": "ލޭބަރ",
        "material": "ތަކެތި",
        "subcontract": "ސަބްކޮންޓްރެކްޓް",
        "expense": "ޚަރަދު",
        "overhead": "އޯވަހެޑް"
      },
      "wip": {
        "title": "ޑަބްލިއުއައިޕީ ރަންތައް",
        "description": "މުއްދަތު ނިމޭއިރު ހުޅުވިފައިވާ ކޮންމެ ކޮންޓްރެކްޓެއްގެ އަގު: މިހާތަނަށް ކުރި މަސައްކަތުގެ އަގު، ބިލްކުރި މިންވަރު، އަދި ތަފާތު ދެނެގަންނަ ޖާނަލް.",
        "new": "އާ ރަން",
        "run": "ހިންގާ",
        "newDescription": "ރަން އަކުން އެއް ކުންފުނީގެ އެއް މާލީ މުއްދަތުގެ ހުޅުވިފައިވާ ހުރިހާ ކޮންޓްރެކްޓެއްގެ އަގު ބަލައެވެ.",
        "created": "ޑަބްލިއުއައިޕީ ރަން އުފެއްދިއްޖެ",
        "period": "މުއްދަތު",
        "periodHint": "އަގު ބެލޭނީ ހުޅުވިފައިވާ މުއްދަތުތަކަށް އެކަނި.",
        "periodRequired": "އަގު ބަލާނެ މުއްދަތު އިޚްތިޔާރު ކުރައްވާ.",
        "asOf": "ތާރީޚް",
        "projectCount": "ޕްރޮޖެކްޓް",
        "contractAsset": "ކޮންޓްރެކްޓް އެސެޓް ބަދަލު",
        "contractLiability": "ކޮންޓްރެކްޓް ލައިބިލިޓީ ބަދަލު",
        "lossProvision": "ގެއްލުމުގެ ޕްރޮވިޜަން ބަދަލު",
        "revenue": "އާމްދަނީގެ ބަދަލު",
        "loadFailed": "ޑަބްލިއުއައިޕީ ރަންތައް ލޯޑް ނުކުރެވުނު",
        "detailFailed": "މި ރަން ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "އަދި ޑަބްލިއުއައިޕީ ރަން އެއް ނެތް",
        "emptyDescription": "މުއްދަތެއްގެ އަގު ބައްލަވާ، އޭރުން ކޮންމެ ކޮންޓްރެކްޓެއްގެ އަގާއި ބިލްކުރި މިންވަރު އަޅާކިޔޭނެ.",
        "linesTitle": "ޕްރޮޖެކްޓަކަށް",
        "contractValue": "ކޮންޓްރެކްޓްގެ އަގު",
        "costToDate": "މިހާތަނަށް ޚަރަދު",
        "eac": "ނިމޭއިރު ލަފާކުރާ ޚަރަދު",
        "percentComplete": "ނިމުނު މިންވަރު",
        "revenueToDate": "މިހާތަނަށް އާމްދަނީ",
        "billedToDate": "މިހާތަނަށް ބިލްކުރި",
        "positionPrior": "ކުރީގެ ޕޮޒިޝަން",
        "positionNow": "މިހާރުގެ ޕޮޒިޝަން",
        "lossExpected": "ލަފާކުރާ ގެއްލުން",
        "post": "ޖާނަލް ޕޯސްޓް ކުރޭ",
        "posted": "ޑަބްލިއުއައިޕީ ރަން ޕޯސްޓް ކުރެވިއްޖެ",
        "postFailed": "ރަން ޕޯސްޓް ނުކުރެވުނު",
        "postedAt": "ޕޯސްޓް ކުރީ",
        "notPosted": "އަދި ޕޯސްޓް ނުކުރޭ",
        "journal": "ޖާނަލް އެންޓްރީ",
        "allProjects": "ހުރިހާ ޕްރޮޖެކްޓް",
        "reverse": "ރިވާސް",
        "reversed": "ޑަބްލިއުއައިޕީ ރަން ރިވާސް ކުރެވިއްޖެ",
        "reverseTitle": "މި ރަން ރިވާސް ކުރަންތޯ؟",
        "reverseDescription": "ރިވާސަލް އަކީ މި ރަން ގެ ލޯގަނޑު އާ ރަން އެކެވެ. ޕޯސްޓް ކުރި ޖާނަލް ދުވަހަކުވެސް ފޮހެއެއް ނުލެވޭ.",
        "reason": "ސަބަބު",
        "reasonRequired": "ޕޯސްޓް ކުރި ރަން އެއް ރިވާސް ކުރަން ސަބަބެއް ބޭނުންވޭ.",
        "reversalDate": "ރިވާސަލް ތާރީޚް",
        "statuses": {
          "draft": "ޑްރާފްޓް",
          "posted": "ޕޯސްޓް ކުރި",
          "reversed": "ރިވާސް ކުރި",
          "cancelled": "ކެންސަލް ކުރި"
        }
      },
      "retentions": {
        "title": "ރިޓެންޝަން ރަޖިސްޓަރީ",
        "description": "ވަކި ތާރީޚަކާ ހަމައަށް ކަސްޓަމަރު ކޮންމެ ކްލެއިމަކުން ހިފަހައްޓާ ފައިސާ، އަދި އޭގެ ފަހުން ދޫކުރި ނުވަތަ ގެއްލުނު މިންވަރު.",
        "new": "ރިޓެންޝަން ހިފަހައްޓާ",
        "newDescription": "ރިޓެންޝަން ހިފަހައްޓަނީ އެއް ކްލެއިމް އިންވޮއިސް އަކުން، އެއްބަސްވި އިންސައްތައަކުން.",
        "created": "ރިޓެންޝަން ހިފެހެއްޓިއްޖެ",
        "claim": "ކްލެއިމް އިންވޮއިސް",
        "claimInvoiceId": "ކްލެއިމް އިންވޮއިސް",
        "percent": "އިންސައްތަ",
        "withheld": "ހިފެހެއްޓި",
        "outstanding": "ބާކީ",
        "dueOn": "ދޫކުރަންޖެހޭ",
        "withheldOn": "ހިފެހެއްޓި ދުވަސް",
        "dueBefore": "މި ތާރީޚުގެ ކުރިން",
        "dueBeforeHint": "ދޫކުރުމުގެ ކަލަންޑަރު: މި ތާރީޚާ ހަމައަށް ދޫކުރަންޖެހޭ.",
        "fieldsRequired": "ޕްރޮޖެކްޓަކާއި، ކްލެއިމް އިންވޮއިސް އަކާއި، އިންސައްތައަކާއި، ދޫކުރާ ތާރީޚެއް ބޭނުންވޭ.",
        "loadFailed": "ރިޓެންޝަންތައް ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "ހިފަހައްޓާފައިވާ ރިޓެންޝަނެއް ނެތް",
        "emptyDescription": "ރިޓެންޝަން ހިފަހައްޓަނީ ކްލެއިމަކުން ކްލެއިމަކަށް. މި ފިލްޓަރުތަކުގައި ހިފަހައްޓާފައި އެއްވެސް އެއްޗެއް ނެތް.",
        "release": "ދޫކުރޭ",
        "released": "ރިޓެންޝަން ދޫކުރެވިއްޖެ",
        "releaseTitle": "މި ރިޓެންޝަން ދޫކުރަންތޯ؟",
        "releaseDescription": "ދޫކުރުމުން، އަބަދުވެސް ކޮންޓްރެކްޓަރުގެ ފައިސާއަށް އިންވޮއިސް އެއް އުފެދޭ.",
        "releaseDate": "ދޫކުރާ ތާރީޚް",
        "forfeit": "ގެއްލުވާލާ",
        "forfeited": "ރިޓެންޝަން ގެއްލުވާލެވިއްޖެ",
        "forfeitTitle": "މި ރިޓެންޝަން ގެއްލުވާލަންތޯ؟",
        "forfeitDescription": "ގެއްލުވާލުމަކީ ރައިޓް-އޮފް އެއް ނުވަތަ އަގުގެ އެޖަސްޓްމަންޓެއް، އަދި ޖާނަލް އެއް ޕޯސްޓް ކުރެވޭ. އަބަދުވެސް ސަބަބެއް އޮންނަންޖެހޭ.",
        "forfeitKind": "ބާވަތް",
        "forfeitAmount": "އަދަދު",
        "forfeitDate": "ތާރީޚް",
        "forfeitFieldsRequired": "ގެއްލުވާލަން އަދަދަކާއި ސަބަބުގެ ކޯޑެއް ބޭނުންވޭ.",
        "journal": "ޖާނަލް",
        "kinds": {
          "write_off": "ރައިޓް-އޮފް",
          "price_adjustment": "އަގުގެ އެޖަސްޓްމަންޓް"
        },
        "statuses": {
          "withheld": "ހިފެހެއްޓި",
          "part_released": "ބައެއް ދޫކުރި",
          "released": "ދޫކުރި",
          "forfeited": "ގެއްލުވާލި"
        }
      },
      "advances": {
        "title": "އެޑްވާންސް ރަޖިސްޓަރީ",
        "description": "މަސައްކަތުގެ ކުރިން ކަސްޓަމަރު ދެއްކި ފައިސާ، އަދި ކޮންމެ ކްލެއިމަކުން އަނބުރާ ހިފާ ބައި.",
        "new": "އާ އެޑްވާންސް",
        "newDescription": "އެޑްވާންސް އަކުން އަމިއްލަ އިންވޮއިސް އެއް އުފެދި، ފަހުގެ ކްލެއިމްތަކުން އެއްބަސްވި އިންސައްތައަކުން އަނބުރާ ހިފޭ.",
        "created": "އެޑްވާންސް އުފެއްދިއްޖެ",
        "advanceInvoice": "އެޑްވާންސް އިންވޮއިސް",
        "claimInvoice": "ކްލެއިމް އިންވޮއިސް",
        "claimInvoiceId": "ކްލެއިމް އިންވޮއިސް",
        "creditNote": "ކްރެޑިޓް ނޯޓް",
        "amount": "އަދަދު",
        "percent": "އަނބުރާ ހިފާ މިންވަރު",
        "recouped": "އަނބުރާ ހިފި",
        "outstanding": "ބާކީ",
        "tax": "ޓެކްސް",
        "recoupedOn": "ހިފި ތާރީޚް",
        "invoiceDate": "އިންވޮއިސް ތާރީޚް",
        "percentHint": "ކޮންމެ ކްލެއިމަކުން މި އެޑްވާންސް އަނބުރާ ހިފާ ބައި.",
        "amountHint": "ހުސްކޮށް ބާއްވައިފިނަމަ ކްލެއިމަށް އެ އިންސައްތަ ބޭނުންކުރެވޭނެ.",
        "fieldsRequired": "ޕްރޮޖެކްޓަކާއި، އަދަދަކާއި، އަނބުރާ ހިފާ އިންސައްތައެއް ބޭނުންވޭ.",
        "claimRequired": "މި އެޑްވާންސް އަނބުރާ ހިފާ ކްލެއިމް އިންވޮއިސް ބަޔާންކުރައްވާ.",
        "recoup": "އަނބުރާ ހިފާ",
        "recoupTitle": "ކްލެއިމަކުން އަނބުރާ ހިފުން",
        "recoupDescription": "އެޑްވާންސް އަނބުރާ ހިފެނީ އެއް ކްލެއިމް އިންވޮއިސް އަކުން، އަދި ކްރެޑިޓް ނޯޓަކުން އެކަން ރެކޯޑް ކުރެވޭ.",
        "scheduleTitle": "އަނބުރާ ހިފުމުގެ ޝެޑިއުލް",
        "scheduleFailed": "އަނބުރާ ހިފުމުގެ ޝެޑިއުލް ލޯޑް ނުކުރެވުނު",
        "noRecoupmentsTitle": "އަދި އެއްވެސް އެއްޗެއް އަނބުރާ ނުހިފާ",
        "noRecoupmentsDescription": "މި އެޑްވާންސް އަދިވެސް ފުރިހަމައަށް ބާކީ.",
        "loadFailed": "އެޑްވާންސްތައް ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "އެޑްވާންސް އެއް ނެތް",
        "emptyDescription": "އެޑްވާންސް އަކީ މަސައްކަތުގެ ކުރިން ނަގާ ފައިސާ. އުފައްދަވާ، އޭރުން ފަހުގެ ކްލެއިމްތަކުން އަމިއްލައަށް އަނބުރާ ހިފޭނެ.",
        "statuses": {
          "outstanding": "ބާކީ",
          "recouped": "އަނބުރާ ހިފި",
          "written_off": "ރައިޓް-އޮފް ކުރި"
        }
      },
      "allocations": {
        "title": "ހަވާލުކުރުމުގެ ބޯޑް",
        "description": "ކޮންމެ ރިސޯސް އަކަށް އެއް ރޯ، ކޮންމެ ހަފްތާއަކަށް އެއް ސެލް: ލިބެންހުރި ގަޑިއާ އަޅާކިޔާފައި ބުކްކުރި ގަޑި، އަދި ސާވަރު ހިސާބުކުރި ކޮންމެ ކޮންފްލިކްޓެއް.",
        "resource": "ރިސޯސް",
        "week": "ހަފްތާ",
        "hours": "ގަޑި",
        "taskId": "ޓާސްކް",
        "book": "ވަގުތު ބުކްކުރޭ",
        "booked": "ހަވާލުކުރެވިއްޖެ",
        "bookDescription": "ކެޕޭސިޓީއަށްވުރެ އިތުރަށް ބުކްކުރަން ސަބަބެއް ބޭނުންވޭ، އަދި އެ ސަބަބު ބުކިންއާއެކު ރައްކާކުރެވޭ.",
        "fieldsRequired": "ރިސޯސް އަކާއި، ޕްރޮޖެކްޓަކާއި، ހަފްތާއަކާއި، ގަޑީގެ އަދަދެއް ބޭނުންވޭ.",
        "overrideReason": "އޯވަރައިޑް ސަބަބު",
        "overrideHint": "ބޭނުންވަނީ ހަމައެކަނި ބުކިން ކެޕޭސިޓީއަށްވުރެ އިތުރުވާ ހާލަތުގައި.",
        "overAllocated": "ކެޕޭސިޓީއަށްވުރެ އިތުރު",
        "withinCapacity": "ކެޕޭސިޓީ ތެރޭގައި",
        "chooseWindowTitle": "ދައްކާނެ ހަފްތާތައް އިޚްތިޔާރު ކުރައްވާ",
        "chooseWindowDescription": "ބޯޑް ދައްކަނީ ތިޔަ އެދޭ ތާރީޚުތައް. ބްރައުޒަރުގެ ގަޑިން 'މި މަސް' ލަފައެއް ނުކުރޭ.",
        "loadFailed": "ހަވާލުކުރުމުގެ ބޯޑް ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "މި މުއްދަތުގައި ރިސޯސް އެއް ނެތް",
        "emptyDescription": "މި ކުންފުންޏަށް ޕްލޭނިން ރިސޯސް އެއް ހަމަޖައްސާފައި ނުވޭ، ނުވަތަ މި ހަފްތާތަކުގައި އެއްވެސް ކެޕޭސިޓީއެއް ނެތް.",
        "bookingsTitle": "މި މުއްދަތުގެ ބުކިންތައް",
        "bookingsFailed": "ބުކިންތައް ލޯޑް ނުކުރެވުނު",
        "noBookingsTitle": "މި ހަފްތާތަކުގައި ބުކްކޮށްފައި އެއްވެސް އެއްޗެއް ނެތް",
        "noBookingsDescription": "ކެޕޭސިޓީ އެބަހުރި، ނަމަވެސް އަދި އެއްވެސް ޕްރޮޖެކްޓަކުން ނަގާފައެއް ނުވޭ.",
        "remove": "ނަގާލާ",
        "removed": "ހަވާލުކުރުން ނަގާލެވިއްޖެ",
        "removeTitle": "މި ބުކިން ނަގާލަންތޯ؟",
        "removeDescription": "އެ ގަޑިތައް އެ ހަފްތާގެ ރިސޯސްގެ ހުސް ކެޕޭސިޓީއަށް އެނބުރި ދާނެ.",
        "removeFailed": "ބުކިން ނުނެގުނު",
        "utilisationTitle": "ބޭނުންކުރެވުނު މިންވަރު",
        "utilisationFailed": "ބޭނުންކުރެވުނު މިންވަރުގެ ރިޕޯޓް ލޯޑް ނުކުރެވުނު",
        "available": "ލިބެންހުރި",
        "planned": "ޕްލޭންކުރި",
        "actual": "ޙަޤީޤީ",
        "plannedPercent": "ޕްލޭން ބޭނުންކުރުން",
        "actualPercent": "ޙަޤީޤީ ބޭނުންކުރުން"
      },
      "resources": {
        "title": "ޕްލޭނިން ރިސޯސް",
        "description": "ޕްލޭނިންގެ ފަރާތުން މުވައްޒަފު: ޕްލޭނުން އެ މީހާގެ ވަގުތުގެ އަގު ބަލާ ރޭޓް، އަދި ކޮންމެ ހަފްތާއަކު ލިބެންހުރި ގަޑި.",
        "new": "ރިސޯސް އިތުރުކުރޭ",
        "edit": "ރިސޯސް އުނިއިތުރު",
        "editorDescription": "ރިސޯސް އުފެދުމުން މުވައްޒަފު ބަދަލެއް ނުކުރެވޭ — ހަވާލުކުރުމާއި، ކެޕޭސިޓީއާއި، ޕޯސްޓް ކުރި ޚަރަދުތައް އެއަށް ބިނާވެފައި.",
        "saved": "ރިސޯސް ރައްކާކުރެވިއްޖެ",
        "employee": "މުވައްޒަފު",
        "employeeNo": "މުވައްޒަފު ނަންބަރު",
        "rate": "ޕްލޭނިން ޚަރަދު ރޭޓް",
        "rateHint": "މިއިން އަގު ބަލަނީ ޕްލޭން. ޓައިމްޝީޓްގެ ޙަޤީޤީ ޚަރަދު ދެނެގަންނަނީ ޕްރޮޖެކްޓްގެ މެންބަރު ރޭޓުތަކުން.",
        "active": "ހަރަކާތްތެރި",
        "inactive": "ހަރަކާތްތެރި ނޫން",
        "activeOnly": "ހަމައެކަނި ހަރަކާތްތެރި",
        "fieldsRequired": "ކުންފުންޏަކާއި މުވައްޒަފެއް ބޭނުންވޭ.",
        "loadFailed": "ރިސޯސްތައް ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "އަދި ޕްލޭނިން ރިސޯސް އެއް ނެތް",
        "emptyDescription": "ވަގުތު ޕްލޭންކުރެވޭ މީހުން އިތުރުކުރައްވާ، އޭރުން ހަވާލުކުރުމުގެ ބޯޑުގައި ރޯތައް ހުންނާނެ.",
        "capacityTitle": "ހަފްތާގެ ކެޕޭސިޓީ",
        "capacityFailed": "ކެޕޭސިޓީ ލޯޑް ނުކުރެވުނު",
        "capacitySaved": "ކެޕޭސިޓީ ރައްކާކުރެވިއްޖެ",
        "capacitySavedDetail": "{count} ހަފްތާ ފޮނުވުނު.",
        "availableHours": "ލިބެންހުރި ގަޑި",
        "addWeek": "ހަފްތާ އިތުރުކުރޭ",
        "removeWeek": "ނަގާލާ",
        "saveCapacity": "ކެޕޭސިޓީ ރައްކާކުރޭ",
        "weeksInGrid": "ހަފްތާ ފޮނުވޭނެ",
        "weekFieldsRequired": "ހަފްތާއަކާއި ގަޑީގެ އަދަދެއް ބޭނުންވޭ.",
        "chooseWindowTitle": "އުނިއިތުރު ކުރާނެ ހަފްތާތައް އިޚްތިޔާރު ކުރައްވާ",
        "chooseWindowDescription": "ކެޕޭސިޓީ އުނިއިތުރު ކުރެވެނީ މުއްދަތަކުން މުއްދަތަކަށް؛ ރައްކާކުރާއިރު ދައްކާ ކޮންމެ ހަފްތާއެއް ފޮނުވޭ."
      },
      "baselines": {
        "title": "ބޭސްލައިން",
        "description": "މީހަކު އެއްބަސްވި ޕްލޭން، އޭގެ ވަރޝަންތައް، އަދި އޭގެ ފަހުން އޭގެ ދަށުން ބަދަލުވި ކަންކަން.",
        "new": "އާ ބޭސްލައިން",
        "newDescription": "ބޭސްލައިން އަކުން މިހާރުގެ ޑަބްލިއުބީއެސް، އޭގެ ތާރީޚުތަކާއި ބަޖެޓް ސްނެޕްޝޮޓް ކުރެވޭ.",
        "created": "ބޭސްލައިން އުފެއްދިއްޖެ",
        "nameRequired": "ނަމެއް ބޭނުންވޭ.",
        "name": "ނަން",
        "no": "ބޭސްލައިން ނަންބަރު",
        "version": "ވަރޝަން",
        "budget": "ބަޖެޓް",
        "contractValue": "ކޮންޓްރެކްޓްގެ އަގު",
        "variationId": "ވެރިއޭޝަނުން",
        "variationHint": "އާދައިގެ ރީބޭސްލައިން އަކަށް ހުސްކޮށް ބާއްވާ.",
        "loadFailed": "ބޭސްލައިންތައް ލޯޑް ނުކުރެވުނު",
        "detailFailed": "މި ބޭސްލައިން ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "އަދި ބޭސްލައިން އެއް ނެތް",
        "emptyDescription": "ޕްލޭން އެއްބަސްވުމުން ބޭސްލައިން އެއް ނަންގަވާ، އޭރުން މަސައްކަތް އަޅާކިޔޭނެ އެއްޗެއް އޮންނާނެ.",
        "linesTitle": "ބޭސްލައިން ރޮނގުތައް",
        "wbs": "ޑަބްލިއުބީއެސް",
        "lineName": "ނަން",
        "start": "ފެށޭ",
        "end": "ނިމޭ",
        "hours": "ގަޑި",
        "submit": "ފާސްކުރަން ފޮނުވާ",
        "submitted": "ބޭސްލައިން ފޮނުވިއްޖެ",
        "submitFailed": "ބޭސްލައިން ނުފޮނުވުނު",
        "approve": "ފާސްކުރޭ",
        "approved": "ބޭސްލައިން ފާސްކުރެވިއްޖެ",
        "approveTitle": "މި ބޭސްލައިން ފާސްކުރަންތޯ؟",
        "reject": "ރައްދުކުރޭ",
        "rejected": "ބޭސްލައިން ރައްދުކުރެވިއްޖެ",
        "rejectTitle": "މި ބޭސްލައިން ރައްދުކުރަންތޯ؟",
        "decideDescription": "ނިންމުމާއެކު ކޮމެންޓް ރެކޯޑްވެ، ޕްލޭން ކުރެހި ފަރާތަށް ފެންނާނެ.",
        "decideFailed": "ނިންމުން ރެކޯޑް ނުކުރެވުނު",
        "approvedAt": "ފާސްކުރީ",
        "supersededBy": "ބޭސްލައިން #{id} އިން ބަދަލުކުރެވިފައި",
        "delete": "ފޮހެލާ",
        "deleted": "ބޭސްލައިން ފޮހެލެވިއްޖެ",
        "deleteTitle": "މި ބޭސްލައިން ފޮހެލަންތޯ؟",
        "deleteDescription": "ފޮހެލެވޭނީ އެއްވެސް ފަރާތަކުން ފާސްނުކުރާ ބޭސްލައިން އެކަނި.",
        "deleteFailed": "ބޭސްލައިން ފޮހެއެއް ނުލެވުނު",
        "compare": "މިހާރާ އަޅާކިޔާ",
        "hideComparison": "އަޅާކިޔުން ފޮރުވާ",
        "comparisonTitle": "ބޭސްލައިން އަދި މިހާރު",
        "comparisonFailed": "އަޅާކިޔުން ލޯޑް ނުކުރެވުނު",
        "baselineBudget": "ބޭސްލައިން",
        "currentBudget": "މިހާރު",
        "delta": "ބަދަލު",
        "endDateDelta": "ލަސްވި ދުވަސް",
        "state": "ބަދަލު",
        "states": {
          "unchanged": "ބަދަލެއް ނުވޭ",
          "changed": "ބަދަލުވި",
          "added": "އިތުރުކުރި",
          "removed": "ނަގާލި"
        },
        "statuses": {
          "draft": "ޑްރާފްޓް",
          "submitted": "ފޮނުވި",
          "approved": "ފާސްކުރި",
          "rejected": "ރައްދުކުރި",
          "superseded": "ބަދަލުކުރި"
        }
      },
      "variations": {
        "title": "ވެރިއޭޝަން",
        "description": "ކޮންޓްރެކްޓަށް އަންނަ ބަދަލުތައް: ކޮންމެ އެއްޗެއްގެ ޚަރަދު، ލިބޭ އާމްދަނީ އަދި އިތުރުވާ ދުވަސް — އެތެރޭގެ ފާސްކުރުމާއި ކަސްޓަމަރުގެ ޤަބޫލުކުރުން ވަކިކޮށްފައި.",
        "new": "އާ ވެރިއޭޝަން",
        "edit": "ވެރިއޭޝަން އުނިއިތުރު",
        "editorDescription": "ވެރިއޭޝަން އުނިއިތުރު ކުރެވޭނީ ޑްރާފްޓް ހާލަތުގައި އެކަނި.",
        "saved": "ވެރިއޭޝަން ރައްކާކުރެވިއްޖެ",
        "no": "ވެރިއޭޝަން ނަންބަރު",
        "variationTitle": "ސުރުޚީ",
        "descriptionLabel": "ތަފްސީލް",
        "origin": "އަސްލު",
        "costImpact": "ޚަރަދަށް އަސަރު",
        "revenueImpact": "އާމްދަނީއަށް އަސަރު",
        "days": "ދުވަސް",
        "magnitude": "މިންވަރު",
        "impactNote": "އަސަރުގެ ނޯޓް",
        "titleRequired": "ސުރުޚީއެއް ބޭނުންވޭ.",
        "projectRequired": "މި ވެރިއޭޝަން ނިސްބަތްވާ ޕްރޮޖެކްޓް އިޚްތިޔާރު ކުރައްވާ.",
        "daysWhole": "ޝެޑިއުލްއަށް އަންނަ އަސަރު ވާންޖެހޭނީ ފުރިހަމަ ދުވަހުގެ އަދަދަކަށް.",
        "amendmentReason": "އިޞްލާޙުގެ ސަބަބު",
        "amendmentHint": "ބަދަލާއެކު ރެކޯޑްވެ، ތާރީޚީ ރެކޯޑް އަމިއްލައަށް ބަޔާންކޮށްދޭ.",
        "loadFailed": "ވެރިއޭޝަންތައް ލޯޑް ނުކުރެވުނު",
        "detailFailed": "މި ވެރިއޭޝަން ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "ވެރިއޭޝަނެއް ނެތް",
        "emptyDescription": "ސްކޯޕް ބަދަލުވާއިރު ވެރިއޭޝަނެއް އުފައްދަވާ، އޭރުން މަސައްކަތް ފެށުމުގެ ކުރިން އަގު ކަނޑައެޅޭނެ.",
        "submit": "ފާސްކުރަން ފޮނުވާ",
        "submitted": "ވެރިއޭޝަން ފޮނުވިއްޖެ",
        "submitFailed": "ވެރިއޭޝަން ނުފޮނުވުނު",
        "submittedAt": "ފޮނުވި",
        "accept": "ކަސްޓަމަރުގެ ޤަބޫލުކުރުން ރެކޯޑްކުރޭ",
        "accepted": "ކަސްޓަމަރުގެ ޤަބޫލުކުރުން ރެކޯޑްވެއްޖެ",
        "acceptTitle": "ކަސްޓަމަރުގެ ޤަބޫލުކުރުން ރެކޯޑްކުރުން",
        "acceptDescription": "ޤަބޫލުކުރުމަކީ ކަސްޓަމަރުގެ ނިންމުން، އެތެރޭގެ ދެވަނަ ފާސްކުރުމެއް ނޫން — އަދި އާ ބޭސްލައިން އުފެދެނީ އެއިން.",
        "acceptFailed": "ޤަބޫލުކުރުން ރެކޯޑް ނުކުރެވުނު",
        "customerReference": "ކަސްޓަމަރުގެ ރެފަރެންސް",
        "referenceHint": "އެ ފަރާތުގެ އޯޑަރު ނަންބަރު، ސިޓީގެ ރެފަރެންސް ނުވަތަ އީމެއިލްގެ ސުރުޚީ.",
        "referenceRequired": "ކަސްޓަމަރުގެ އަމިއްލަ ރެފަރެންސް ބޭނުންވޭ.",
        "attachmentId": "ސޮއިކުރި އިރުޝާދު",
        "acceptedOn": "ޤަބޫލުކުރި ތާރީޚް",
        "customerAcceptedAt": "ކަސްޓަމަރު ޤަބޫލުކުރީ",
        "baselineName": "އާ ބޭސްލައިންގެ ނަން",
        "baselineNameHint": "ސާވަރުން ވެރިއޭޝަނަށް ނިސްބަތްކޮށް ނަން ދޭން ހުސްކޮށް ބާއްވާ.",
        "resultingBaseline": "އުފެދުނު ބޭސްލައިން",
        "openBaseline": "ބޭސްލައިން #{id}",
        "reject": "ރައްދުކުރޭ",
        "rejected": "ވެރިއޭޝަން ރައްދުކުރެވިއްޖެ",
        "rejectTitle": "މި ވެރިއޭޝަން ރައްދުކުރަންތޯ؟",
        "rejectDescription": "ސަބަބު ވެރިއޭޝަނުގައި ރައްކާވެ، އުފެއްދި ފަރާތަށް ފެންނާނެ.",
        "rejectFailed": "ވެރިއޭޝަން ރައްދު ނުކުރެވުނު",
        "reason": "ސަބަބު",
        "reasonRequired": "ސަބަބެއް ބޭނުންވޭ.",
        "rejectedReason": "ރައްދުކުރި ސަބަބު",
        "origins": {
          "internal": "އެތެރޭގެ",
          "customer": "ކަސްޓަމަރު",
          "site": "ސައިޓް"
        },
        "statuses": {
          "draft": "ޑްރާފްޓް",
          "submitted": "ފޮނުވި",
          "approved": "ފާސްކުރި",
          "accepted": "ޤަބޫލުކުރި",
          "rejected": "ރައްދުކުރި",
          "withdrawn": "އަނބުރާ ނެގި"
        }
      },
      "risks": {
        "title": "ރިސްކް ރަޖިސްޓަރީ",
        "description": "ގޯސްވެދާނެ ކަންކަން، އެކަން ވުމުގެ ފުރުޞަތު، ވެއްޖެނަމަ ޚަރަދު، އަދި އެކަމަށް މަސައްކަތްކުރަނީ ކާކުކަން.",
        "new": "އާ ރިސްކް",
        "edit": "ރިސްކް އުނިއިތުރު",
        "saved": "ރިސްކް ރައްކާކުރެވިއްޖެ",
        "editorDescription": "ފުރުޞަތާއި އަސަރު ސްކޯރ ކުރެވެނީ 1 އިން 5 އަށް؛ ރަޖިސްޓަރީ ތަރުތީބުކުރާ އެކްސްޕޯޜަރ ސާވަރުން ހިސާބުކުރެވޭ.",
        "no": "ރިސްކް ނަންބަރު",
        "riskTitle": "ސުރުޚީ",
        "descriptionLabel": "ތަފްސީލް",
        "category": "ބާވަތް",
        "probability": "ފުރުޞަތު",
        "impact": "އަސަރު",
        "exposure": "އެކްސްޕޯޜަރ",
        "costImpact": "ޚަރަދަށް އަސަރު",
        "response": "ޖަވާބު",
        "mitigation": "ކުޑަކުރުން",
        "reviewOn": "މުރާޖަޢާ ތާރީޚް",
        "closedAt": "ބަންދުކުރީ",
        "minExposure": "އެންމެ ދަށް އެކްސްޕޯޜަރ",
        "exposureHint": "މި މިންވަރު ނުވަތަ އެއަށްވުރެ މަތީ ރިސްކްތައް އެކަނި ދައްކާ.",
        "scaleHint": "1 އިން 5 އަށް.",
        "scaleRange": "ފުރުޞަތާއި އަސަރު ވާންޖެހޭނީ 1 އިން 5 އަށް ފުރިހަމަ އަދަދަކަށް.",
        "titleRequired": "ސުރުޚީއެއް ބޭނުންވޭ.",
        "projectRequired": "މި ރިސްކް ނިސްބަތްވާ ޕްރޮޖެކްޓް އިޚްތިޔާރު ކުރައްވާ.",
        "matrixTitle": "ރިސްކް މެޓްރިކްސް",
        "probabilityN": "ފ{n}",
        "impactN": "އ{n}",
        "loadFailed": "ރިސްކް ރަޖިސްޓަރީ ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "ރަޖިސްޓަރީގައި ރިސްކެއް ނެތް",
        "emptyDescription": "ގޯސްވެދާނެ ކަންކަން، އެކަމަށް ފިޔަވަޅު އެޅޭނެ ވަގުތު އޮތްވާ ރެކޯޑް ކުރައްވާ.",
        "delete": "ފޮހެލާ",
        "deleted": "ރިސްކް ފޮހެލެވިއްޖެ",
        "deleteTitle": "މި ރިސްކް ފޮހެލަންތޯ؟",
        "deleteDescription": "{no} ރަޖިސްޓަރީން ނަގާލެވޭނެ.",
        "deleteFailed": "ރިސްކް ފޮހެއެއް ނުލެވުނު",
        "responses": {
          "avoid": "ދުރުހެލިވުން",
          "mitigate": "ކުޑަކުރުން",
          "transfer": "ބަދަލުކުރުން",
          "accept": "ޤަބޫލުކުރުން"
        },
        "statuses": {
          "open": "ހުޅުވިފައި",
          "mitigating": "ކުޑަކުރަނީ",
          "realised": "ދިމާވި",
          "closed": "ބަންދުކުރި"
        }
      },
      "subcontracts": {
        "title": "ސަބްކޮންޓްރެކްޓް",
        "description": "ޕްރޮޖެކްޓްގެ ކޮމިޓްމަންޓް ފަރާތް: މަސައްކަތްކުރަނީ ކާކުތޯ، ކިހާ އަގަކަށްތޯ، އަދި ކިހާ މިންވަރެއް ސެޓިފައި ކުރެވިއްޖެތޯ.",
        "new": "އާ ސަބްކޮންޓްރެކްޓް",
        "edit": "ސަބްކޮންޓްރެކްޓް އުނިއިތުރު",
        "saved": "ސަބްކޮންޓްރެކްޓް ރައްކާކުރެވިއްޖެ",
        "editorDescription": "ސަބްކޮންޓްރެކްޓް އުފެދުމުން ވެންޑަރު ބަދަލެއް ނުކުރެވޭ؛ ފައިސާ ހަރަކާތްކުރަނީ ޕަރޗޭސް އޯޑަރުން.",
        "no": "ސަބްކޮންޓްރެކްޓް ނަންބަރު",
        "subcontractTitle": "ސުރުޚީ",
        "vendor": "ސަބްކޮންޓްރެކްޓަރު",
        "contractValue": "ކޮންޓްރެކްޓްގެ އަގު",
        "retention": "ރިޓެންޝަން",
        "certified": "ސެޓިފައި ކުރި",
        "purchaseOrder": "ޕަރޗޭސް އޯޑަރު",
        "purchaseOrderId": "ޕަރޗޭސް އޯޑަރު",
        "noPurchaseOrder": "ޕަރޗޭސް އޯޑަރަކާ ގުޅުވާފައެއް ނުވޭ",
        "starts": "ފެށޭ",
        "ends": "ނިމޭ",
        "titleRequired": "ސުރުޚީއެއް ބޭނުންވޭ.",
        "partiesRequired": "ޕްރޮޖެކްޓަކާއި ސަބްކޮންޓްރެކްޓަރެއް ބޭނުންވޭ.",
        "loadFailed": "ސަބްކޮންޓްރެކްޓްތައް ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "ސަބްކޮންޓްރެކްޓެއް ނެތް",
        "emptyDescription": "މަސައްކަތްކުރާ ފަރާތް ރެކޯޑް ކުރައްވާ، އޭރުން ޕްރޮޖެކްޓްގެ ޚަރަދާ އެއްކޮށް ކޮމިޓްމަންޓް ފެންނާނެ.",
        "delete": "ފޮހެލާ",
        "deleted": "ސަބްކޮންޓްރެކްޓް ފޮހެލެވިއްޖެ",
        "deleteTitle": "މި ސަބްކޮންޓްރެކްޓް ފޮހެލަންތޯ؟",
        "deleteDescription": "{no} ނަގާލެވޭނެ.",
        "deleteFailed": "ސަބްކޮންޓްރެކްޓް ފޮހެއެއް ނުލެވުނު",
        "statuses": {
          "draft": "ޑްރާފްޓް",
          "active": "ހަރަކާތްތެރި",
          "completed": "ނިމުނު",
          "terminated": "ހުއްޓާލި"
        }
      },
      "schedule": {
        "title": "ޝެޑިއުލް",
        "description": "ސާވަރުގެ އަމިއްލަ ކްރިޓިކަލް ޕާތާއެކު ޑަބްލިއުބީއެސް، އެ އުފައްދާ ޑިޕެންޑެންސީތައް، އަދި ކޮންމެ ޓާސްކަކަށް ބޭނުންވާ ހުނަރު.",
        "recompute": "އަލުން ހިސާބުކުރޭ",
        "recomputed": "ޝެޑިއުލް އަލުން ހިސާބުކުރެވިއްޖެ",
        "recomputeFailed": "ޝެޑިއުލް އަލުން ހިސާބު ނުކުރެވުނު",
        "computedAt": "ހިސާބުކުރީ",
        "neverComputed": "ދުވަހަކުވެސް ހިސާބުކޮށްފައި ނުވޭ",
        "businessDays": "މަސައްކަތު ދުވަހުން ގުނާފައި",
        "calendarDays": "ކަލަންޑަރު ދުވަހުން ގުނާފައި",
        "criticalCount": "ކްރިޓިކަލް ޕާތުގައި {count} ޓާސްކް",
        "loadFailed": "ޝެޑިއުލް ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "މި ޕްރޮޖެކްޓްގައި ޓާސްކެއް ނެތް",
        "emptyDescription": "ޑަބްލިއުބީއެސް އަށް ޓާސްކް އިތުރުކުރައްވާ، އޭރުން ކްރިޓިކަލް ޕާތު ހިނގާނެ ތަނެއް އޮންނާނެ.",
        "earlyStart": "އަވަހަށް ފެށޭ",
        "earlyFinish": "އަވަހަށް ނިމޭ",
        "lateStart": "ލަހުން ފެށޭ",
        "lateFinish": "ލަހުން ނިމޭ",
        "float": "ފްލޯޓް (ދުވަސް)",
        "critical": "ކްރިޓިކަލް",
        "onCriticalPath": "ކްރިޓިކަލް ޕާތުގައި",
        "milestone": "މައިލްސްޓޯން",
        "plannedStart": "ޕްލޭންކުރި ފެށުން",
        "plannedEnd": "ޕްލޭންކުރި ނިމުން",
        "budget": "ބަޖެޓް",
        "budgetAvailable": "ބާކީ ބަޖެޓް",
        "budgetExceeded": "ބަޖެޓަށްވުރެ އިތުރު",
        "parent": "މައި ޓާސްކް",
        "noParent": "އެންމެ މަތީ ފަށަލަ",
        "parentHint": "މައި ޓާސްކް ބަދަލުކުރުމުން މި ޓާސްކްގެ ޚަރަދު އެއްވާ ތަންވެސް ކަނޑައެޅޭ.",
        "saveParent": "ތަން ރައްކާކުރޭ",
        "parentSaved": "ތަން ރައްކާކުރެވިއްޖެ",
        "selfParent": "ޓާސްކެއް އަމިއްލައަށް އޭގެ މައި ޓާސްކަކަށް ނުވެވޭނެ.",
        "dependencies": "ކުރީގެ ޓާސްކްތައް",
        "dependenciesNote": "ރައްކާކުރުމުން މުޅި ލިސްޓް ފޮނުވޭ: މިތަނުން ނަގާލާ ކޮންމެ އެއްޗެއް ސާވަރުންވެސް ފޮހެލެވޭ.",
        "dependenciesSaved": "ކުރީގެ ޓާސްކްތައް ރައްކާކުރެވިއްޖެ",
        "predecessor": "ކުރީގެ ޓާސްކް",
        "predecessorRequired": "ކުރީގެ ޓާސްކެއް އިޚްތިޔާރު ކުރައްވާ.",
        "selfDependency": "ޓާސްކެއް އަމިއްލައަށް އޭގެ މައްޗަށް ބިނާއެއް ނުވެވޭނެ.",
        "duplicateDependency": "އެ ޓާސްކް މިހާރުވެސް ކުރީގެ ޓާސްކެއްގެ ގޮތުގައި އެބައޮތް.",
        "kind": "ބާވަތް",
        "lag": "ލެގް (ދުވަސް)",
        "addDependency": "އިތުރުކުރޭ",
        "saveDependencies": "ކުރީގެ ޓާސްކްތައް ރައްކާކުރޭ",
        "remove": "ނަގާލާ",
        "skills": "ބޭނުންވާ ހުނަރު",
        "skillsNote": "ރައްކާކުރުމުން މުޅި ލިސްޓް ފޮނުވޭ، މަތީގައިވާ ޑިޕެންޑެންސީތަކެކޭ އެއްފަދައިން.",
        "skillsSaved": "ބޭނުންވާ ހުނަރު ރައްކާކުރެވިއްޖެ",
        "skill": "ހުނަރު",
        "skillId": "ހުނަރު",
        "minLevel": "އެންމެ ދަށް ފެންވަރު",
        "skillRequired": "އިތުރުކުރާނެ ހުނަރު ބަޔާންކުރައްވާ.",
        "duplicateSkill": "އެ ހުނަރު މިހާރުވެސް ބޭނުންވާ ގޮތުގައި އެބައޮތް.",
        "addSkill": "އިތުރުކުރޭ",
        "saveSkills": "ހުނަރު ރައްކާކުރޭ",
        "costTitle": "ޚަރަދުގެ ތަފްސީލް",
        "costFailed": "ޚަރަދުގެ ތަފްސީލް ލޯޑް ނުކުރެވުނު",
        "actualAp": "ޙަޤީޤީ (އޭޕީ)",
        "commitment": "ކޮމިޓްމަންޓް",
        "kinds": {
          "FS": "ނިމުމުން ފެށުން",
          "SS": "ފެށުމުން ފެށުން",
          "FF": "ނިމުމުން ނިމުން",
          "SF": "ފެށުމުން ނިމުން"
        }
      },
      "evm": {
        "title": "އާން ވެލިއު",
        "description": "ވަގުތާއެކު ޕްލޭންކުރި، ހޯދި އަދި ޙަޤީޤީ ޚަރަދު، އަދި އެއިން ސާވަރު ހިސާބުކުރި ޚަރަދާއި ޝެޑިއުލްގެ އިންޑެކްސްތައް.",
        "asOf": "ތާރީޚް",
        "bcws": "ޕްލޭންކުރި (ބީސީޑަބްލިއުއެސް)",
        "bcwp": "ހޯދި (ބީސީޑަބްލިއުޕީ)",
        "acwp": "ޙަޤީޤީ (އޭސީޑަބްލިއުޕީ)",
        "cpi": "ޚަރަދު އިންޑެކްސް (ސީޕީއައި)",
        "spi": "ޝެޑިއުލް އިންޑެކްސް (އެސްޕީއައި)",
        "eac": "ނިމޭއިރު ލަފާކުރާ ޚަރަދު",
        "chartAria": "ވަގުތާއެކު ޕްލޭންކުރި، ހޯދި އަދި ޙަޤީޤީ ޚަރަދު",
        "refresh": "މިހާރު އަލުން ހިސާބުކުރޭ",
        "refreshed": "އާން ވެލިއު އަލުން ހިސާބުކުރެވިއްޖެ",
        "refreshFailed": "އާން ވެލިއު އަލުން ހިސާބު ނުކުރެވުނު",
        "loadFailed": "އާން ވެލިއު ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "އަދި އާން ވެލިއު އެއް ނެތް",
        "emptyDescription": "އާން ވެލިއު ބަލަނީ ފާސްކުރި ބޭސްލައިނަކާ އަޅާކިޔައިގެން. އެއް ފާސްކުރައްވާ، ދެން އަލުން ހިސާބުކުރައްވާ.",
        "acwpFrom": "ޙަޤީޤީ ޚަރަދު އަންނަނީ",
        "approvedTimesheets": "ފާސްކުރި ޓައިމްޝީޓުން",
        "apCaveat": "އަދި މި ޕްރޮޖެކްޓަށް ކޯޑްކުރި ޕޯސްޓް ކުރި އޭޕީ އިންވޮއިސްތަކުން، ނަމަވެސް އެއްވެސް ލިސްޓް އެންޑްޕޮއިންޓަކުން ޕްރޮޖެކްޓުން ފިލްޓަރެއް ނުކުރެވޭ."
      },
      "contract": {
        "title": "ކޮންޓްރެކްޓް ޝަރުތު",
        "description": "ކޮންޓްރެކްޓަށް ލަފާކުރާ ޚަރަދު، ބިލްކުރާ ގޮތް، އަދި މިއަދު އެއަށް ވަގުތު ބުކްކުރެވޭތޯ.",
        "termsTitle": "ޝަރުތު",
        "eac": "ނިމޭއިރު ލަފާކުރާ ޚަރަދު",
        "eacHint": "ޑަބްލިއުއައިޕީ ރަން އަކުން މި ކޮންޓްރެކްޓްގެ އަގު ބަލާ މިންގަނޑު.",
        "costPlusPercent": "ކޮސްޓް-ޕްލަސް އިތުރުކުރުން",
        "retainerAmount": "ރިޓެއިނަރ",
        "editTitle": "ކޮންޓްރެކްޓް ޝަރުތު އުނިއިތުރު",
        "editDescription": "މި އަދަދުތަކަކީ ޑަބްލިއުއައިޕީ ރަން އަށާއި ތިރީގައިވާ ދެ ބިލިން ރަން އަށް ބޭނުންވާ އިންޕުޓް.",
        "saved": "ކޮންޓްރެކްޓް ޝަރުތު ރައްކާކުރެވިއްޖެ",
        "loadFailed": "ކޮންޓްރެކްޓް ޝަރުތު ލޯޑް ނުކުރެވުނު",
        "emptyTitle": "ކޮންޓްރެކްޓް ޝަރުތު ރެކޯޑް ކޮށްފައި ނުވޭ",
        "emptyDescription": "ނިމޭއިރު ލަފާކުރާ ޚަރަދު ކަނޑައަޅުއްވާ، އޭރުން ޑަބްލިއުއައިޕީ ރަން އަކުން އަގު ބެލޭނެ.",
        "gateFailed": "ޗާޖްކުރެވޭ ގޭޓް ކިޔޭ ގޮތެއް ނުވި",
        "chargeable": "ޗާޖްކުރެވޭ",
        "notChargeable": "ޗާޖެއް ނުކުރެވޭ",
        "gateOn": "ތާރީޚް",
        "override": "ގޭޓް އޯވަރައިޑް ކުރޭ",
        "overridden": "އޯވަރައިޑް ރެކޯޑްވެއްޖެ",
        "overrideTitle": "އެހެންނަމަވެސް ވަގުތު ބުކްކުރެވޭ ގޮތް ހަދާ",
        "overrideDescription": "އޯވަރައިޑް އަކުން ކޮންޓްރޯލެއް ވަކި މުއްދަތަކަށް ނިއްވާލެވޭ. އަބަދުވެސް ތާރީޚަކުން ނިމޭ.",
        "overrideExpires": "އޯވަރައިޑް ހަމަވަނީ",
        "overrideFieldsRequired": "ސަބަބުގެ ކޯޑަކާއި ހަމަވާ ތާރީޚެއް ބޭނުންވޭ.",
        "validTo": "ހަމަވަނީ",
        "validToHint": "ނިމުމެއް ނެތް އޯވަރައިޑަކީ އަނބުރާ ނުޖައްސާ ކޮންޓްރޯލެއް.",
        "revoke": "އުވާލާ",
        "revoked": "އޯވަރައިޑް އުވާލެވިއްޖެ",
        "revokeFailed": "އޯވަރައިޑް ނުއުވުނު",
        "billCostPlus": "ކޮސްޓް-ޕްލަސް ބިލްކުރޭ",
        "billRetainer": "ރިޓެއިނަރ ބިލްކުރޭ",
        "billDescription": "ދެ ރަން އިންވެސް ޙަޤީޤީ އޭއާރު އިންވޮއިސް އެއް އުފައްދައި ޕޯސްޓް ކުރެވޭ.",
        "billed": "އިންވޮއިސް އުފެއްދިއްޖެ",
        "raiseInvoice": "އިންވޮއިސް އުފައްދާ",
        "through": "ޚަރަދު ހަމައަށް",
        "throughHint": "މި ތާރީޚާ ހަމައަށް ރެކޯޑްކުރި ޚަރަދު ބިލްކުރޭ.",
        "uplift": "އިތުރުކުރުން",
        "upliftHint": "ކޮންޓްރެކްޓްގެ އަމިއްލަ ކޮސްޓް-ޕްލަސް އިންސައްތަ ބޭނުންކުރަން ހުސްކޮށް ބާއްވާ.",
        "periodStart": "މުއްދަތު ފެށޭ",
        "periodEnd": "މުއްދަތު ނިމޭ",
        "periodStartRequired": "ރިޓެއިނަރ މުއްދަތަކަށް ފެށޭ ތާރީޚެއް ބޭނުންވޭ.",
        "amount": "އަދަދު",
        "amountHint": "ކޮންޓްރެކްޓްގެ އަމިއްލަ ރިޓެއިނަރ އަދަދު ބިލްކުރަން ހުސްކޮށް ބާއްވާ.",
        "invoiceDate": "އިންވޮއިސް ތާރީޚް",
        "lastBillingTitle": "މިއިން އުފެއްދި އިންވޮއިސް",
        "invoice": "އިންވޮއިސް",
        "billedOn": "ބިލްކުރި ތާރީޚް",
        "reasons": {
          "gate_disabled": "މި ކުންފުންޏަށް ޗާޖްކުރެވޭ ގޭޓް ނިއްވާލެވިފައި",
          "baseline_approved": "ފާސްކުރި ބޭސްލައިނެއް ހިނގަނީ",
          "override": "އޯވަރައިޑެއް ހިނގަނީ",
          "no_approved_baseline": "އެއްވެސް ބޭސްލައިނެއް ފާސްކޮށްފައި ނުވޭ"
        }
      },
      "settings": {
        "title": "ކޮންޓްރެކްޓް އެކައުންޓް",
        "description": "ޑަބްލިއުއައިޕީ ރަން، ރިޓެންޝަން، އެޑްވާންސް އަދި ގެއްލުމުގެ ޕްރޮވިޜަން ޕޯސްޓް ކުރާ ހަ އެކައުންޓް. ކަނޑައެޅެންދެން އެ ޕޯސްޓިންތައް ލަފައެއް ނުކުރޭ، ދެކޮޅު ހަދާ.",
        "accountsTitle": "އެކައުންޓް މެޕިން",
        "chooseCompanyTitle": "ކުންފުންޏެއް އިޚްތިޔާރު ކުރައްވާ",
        "chooseCompanyDescription": "ކޮންޓްރެކްޓް އެކައުންޓް ކަނޑައެޅެނީ ކުންފުންޏަކަށް، ސަބަބަކީ ކޮންމެ ކުންފުންޏެއްގައި އަމިއްލަ ޗާޓް އޮފް އެކައުންޓްސް އޮންނާތީ.",
        "loadFailed": "ކޮންޓްރެކްޓް އެކައުންޓް ލޯޑް ނުކުރެވުނު",
        "saved": "ކޮންޓްރެކްޓް އެކައުންޓް ރައްކާކުރެވިއްޖެ",
        "notSet": "ކަނޑައަޅާފައި ނުވޭ",
        "unset": "{count} އެކައުންޓް ކަނޑައަޅާފައި ނުވޭ. ކަނޑައެޅެންދެން ޑަބްލިއުއައިޕީ ރަން ދެކޮޅު ހަދާނެ.",
        "fields": {
          "contractAssetAccountId": "ކޮންޓްރެކްޓް އެސެޓް",
          "contractLiabilityAccountId": "ކޮންޓްރެކްޓް ލައިބިލިޓީ",
          "retentionReceivableAccountId": "ރިޓެންޝަން ރިސީވަބަލް",
          "contractAdvanceAccountId": "ކޮންޓްރެކްޓް އެޑްވާންސް",
          "lossProvisionAccountId": "ގެއްލުމުގެ ޕްރޮވިޜަން",
          "contractLossAccountId": "ކޮންޓްރެކްޓް ގެއްލުން"
        },
        "hints": {
          "contractAssetAccountId": "ކޮށްފައި ބިލްނުކުރާ މަސައްކަތް.",
          "contractLiabilityAccountId": "މަސައްކަތުގެ ކުރިން ބިލްކުރި.",
          "retentionReceivableAccountId": "ކްލެއިމަކުން ހިފެހެއްޓި ރިޓެންޝަން.",
          "contractAdvanceAccountId": "މަސައްކަތުގެ ކުރިން ނެގި އެޑްވާންސް.",
          "lossProvisionAccountId": "ގެއްލުންވާ ކޮންޓްރެކްޓެއްގެ ޕްރޮވިޜަން.",
          "contractLossAccountId": "އެ ޕްރޮވިޜަން ޚަރަދުކުރެވޭ ތަން."
        },
        "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ސެޓިންގްސް ބަދަލުކޮށްފި. ކަމެއް ނުފޮހެވޭ. ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
        "reload": "ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކުރޭ"
      }
    }
  },
  "service": {
    "routeTitles": {
      "tickets": "ޚިދުމަތް ޓިކެޓްސް",
      "ticket": "ޓިކެޓް",
      "customerAssets": "ކަސްޓަމަރު މުދާ",
      "customerAsset": "ކަސްޓަމަރު އަސްސެޓް",
      "pmSchedules": "ޕްރެވެންޓިވް މައިންޓެނަންކް",
      "assignmentRules": "އަސްސިގްންމެންޓް ރުލެސް",
      "reports": "ޚިދުމަތް ރެޕޮރްޓްސް",
      "settings": "ޚިދުމަތް ސެޓިންގްސް",
      "workOrders": "މަސައްކަތް އޮރްޑެރްސް",
      "workOrder": "މަސައްކަތް ތަރުތީބު",
      "dispatch": "ޑިސްޕަޓްޗް ބޯރްޑް",
      "contracts": "ޚިދުމަތް ކޮންޓްރަކްޓްސް",
      "contract": "ކޮންޓްރަކްޓް",
      "rateCards": "ރަޓް ކަރްޑްސް",
      "rateCard": "ރަޓް ކަރްޑް",
      "vans": "ވަންސް",
      "problems": "ޕްރޮބްލެމްސް",
      "goodwill": "ގުޑްވިލް"
    },
    "nav": {
      "label": "ޚިދުމަތް ބައިތައް",
      "tickets": "ޓިކެޓްސް",
      "customerAssets": "ކަސްޓަމަރު މުދާ",
      "pmSchedules": "ޕްރެވެންޓިވް މައިންޓެނަންކް",
      "assignmentRules": "އަސްސިގްންމެންޓް ރުލެސް",
      "reports": "ރެޕޮރްޓްސް",
      "settings": "ސެޓިންގްސް",
      "slaPolicies": "SLA ޕޮލިކީސް"
    },
    "statuses": {
      "new": "އާ",
      "open": "ހުޅުވާ",
      "pending": "ޕެންޑިންގް",
      "resolved": "ރެސޮލްވެޑް",
      "closed": "ބަންދުކުރެވިފައި"
    },
    "priorities": {
      "low": "ލޯ",
      "medium": "މެޑިއުމް",
      "high": "ހިގް",
      "urgent": "އުރްގެންޓް"
    },
    "origins": {
      "manual": "ރައިސެޑް މިތާ",
      "portal": "ޕޮރްޓަލް",
      "email": "އީމެއިލް"
    },
    "invoiceStatuses": {
      "not_billable": "ނޫން ބިލްލަބްލް",
      "unbilled": "އުންބިލްލެޑް",
      "invoiced": "އިންވޮއިކެޑް"
    },
    "unassigned": "އުނަސްސިގްނެޑް",
    "fields": {
      "caseNo": "ޓިކެޓް",
      "subject": "ސުބްޖެކްޓް",
      "description": "ތަފްޞީލު",
      "name": "ނަން",
      "company": "ކޮމްޕަންޔް",
      "companyPlaceholder": "ހޮވާ ކޮމްޕަންޔް",
      "customer": "ކަސްޓަމަރު",
      "customerPlaceholder": "ހޮވާ ކަސްޓަމަރު",
      "customerAsset": "ކަސްޓަމަރު އަސްސެޓް",
      "customerAssetPlaceholder": "ހޮވާ އުނިޓް",
      "category": "ކަޓެގޮރްޔް",
      "causeCode": "ސަބަބު ކޯޑް",
      "priority": "ޕްރިއޮރިޓްޔް",
      "origin": "އޮރިގިން",
      "slaPolicy": "SLA ޕޮލިކްޔް",
      "assignee": "ހަވާލުކުރެވިފައި އަށް",
      "warehouse": "ވަރެހައުސް",
      "contactName": "ކޮންޓަކްޓް",
      "contactEmail": "ކޮންޓަކްޓް އީމެއިލް",
      "contactPhone": "ކޮންޓަކްޓް ފޮން",
      "billable": "ބިލްލަބްލް",
      "isRevisit": "މި އީ ރެވިސިޓް",
      "invoiceStatus": "ބިލިންގ",
      "code": "ކޯޑް",
      "title": "ޓިޓްލް",
      "summary": "ސުމްމަރްޔް",
      "workOrderNo": "މަސައްކަތް ތަރުތީބު",
      "kind": "ކިންޑް",
      "appointmentOn": "އަޕްޕޮއިންޓްމެންޓް",
      "amount": "އަދަދު",
      "billability": "ބިލްލަބްލް",
      "asset": "އަސްސެޓް",
      "totalCost": "ކޮސްޓް",
      "date": "ތާރީޚް",
      "reasonCode": "ސަބަބު ކޯޑް",
      "item": "ބައި",
      "quantity": "ކަންޓިޓްޔް",
      "unitCost": "އުނިޓް ކޮސްޓް",
      "billAmount": "ބިލްލް",
      "covered": "ކޮވެރެޑް",
      "chargeable": "ޗަރްގީބްލް",
      "technician": "ޓެޗްނިކިއަން",
      "taxCode": "ޓެކްސް ކޯޑް",
      "workDate": "މަސައްކަތް ތާރީޚް",
      "workOrder": "މަސައްކަތް ތަރުތީބު",
      "workPerformed": "ކުރެވުނު މަސައްކަތް ނުވަތަ ޙައްލު",
      "hours": "ގަޑިއިރު",
      "billRate": "ރަޓް",
      "contractNo": "ކޮންޓްރަކްޓް",
      "startsOn": "ފަށާ",
      "endsOn": "އެންޑްސް",
      "fee": "ފީ",
      "renewal": "ރެނެވަލް",
      "term": "ޓެރްމް",
      "ticket": "ޓިކެޓް",
      "rateCard": "ރަޓް ކަރްޑް",
      "scope": "ސްކޮޕް",
      "quotaHours": "ކޮޓަ (ހް)",
      "usedHours": "ބޭނުންކުރެވިފައި (ހް)",
      "remainingHours": "ރެމައިނިންގް (ހް)",
      "remaining": "ރެމައިނިންގް",
      "exhaustedPolicy": "ވަގުތު އެކްސްހައުސްޓެޑް",
      "currency": "ފައިސާ",
      "version": "ވަރޝަން",
      "effectiveFrom": "އެފްފެކްޓިވް އިން",
      "effectiveTo": "އެފްފެކްޓިވް އަށް",
      "travelRate": "ޓްރަވެލް",
      "minimumCharge": "މިނިމުމް",
      "preApproval": "ޕްރެއަޕްޕްރޮވަލް އަބޮވް",
      "skill": "ކޮމްޕެޓެންކްޔް",
      "overtime": "އޮވެރްޓިމް",
      "hourlyRate": "ހައުރްލްޔް ރަޓް",
      "registration": "ރެގިސްޓްރަޓިއޮން",
      "parQty": "ޕަރް",
      "minQty": "މިނިމުމް",
      "onHand": "މަތީގައި ހަންޑް",
      "proposed": "ޕްރޮޕޮސެޑް",
      "issued": "ދޫކުރެވިއްޖެ",
      "problemNo": "ޕްރޮބްލެމް",
      "linkedCases": "ލިންކެޑް ކަސެސް",
      "kbArticle": "ކްނޯން އެރްރޮރް",
      "article": "އަރްޓިކްލް",
      "views": "ވީވްސް",
      "resolved": "ރެސޮލްވެޑް",
      "deflectionRate": "ޑެފްލެކްޓިއޮން"
    },
    "list": {
      "title": "ޚިދުމަތް ޓިކެޓްސް",
      "description": "މަސައްކަތް ޑެސްކް އޯއެސް ކަސްޓަމަރު, އޮރްޑެރެޑް މެދުވެރިކޮށް ހޯ ބަންދުކުރޭ ކޮންމެ ޕްރޮމިސް އީ އަށް ވަމުން ބްރޮކެން.",
      "filtersTitle": "ފިލްޓަރތައް",
      "searchPlaceholder": "ޓިކެޓް ނަންބަރު ނުވަތަ ސުބްޖެކްޓް",
      "new": "އާ ޓިކެޓް",
      "resolutionClock": "ރެސޮލުޓިއޮން ކްލޮކް",
      "clockNote": " ޑީޑްލިން އެ އެބަހުރި ޕަސްސެޑް އީ ދެއްކިފައި ގޮތުގައި އޮވެރްޑުއެ ވަންދެން ބްރީޗް ސްވީޕް ރެކޯޑްތައް އެ; ހަމައެކަނި ދެން އީ އަސްސިގްނީ ނޮޓިފީޑް އަދި ޕޮލިކްޔްސް ކޮންޓަކްޓް އެސްކަލަޓެޑް އަށް.",
      "loadFailed": "ކުރެވުނު ނޫން ލޯޑް ޓިކެޓްސް",
      "emptyTitle": "ނެތް ޓިކެޓްސް މިތާ",
      "emptyDescription": "އުފުލާ އެއް އަގައިންސްޓް ކަސްޓަމަރު އަދި, ކޮންތާކު އެ އަޕްޕްލީސް, އުނިޓް އެ ކޮންކެރްންސް — SLA ކްލޮކް ފަށާ ވަގުތުކޮޅެއް އެ އެބައޮތް."
    },
    "create": {
      "title": "އާ ޚިދުމަތް ޓިކެޓް",
      "description": " ޓިކެޓް އީ އުފެއްދިއްޖެ އަދި އޭގެ SLA ޑީޑްލިނެސް ކޮމްޕުޓެޑް ގައި އެއް ފިޔަވަޅު. އެތާ އީ ނެތް ޑްރަފްޓް.",
      "clockNote": " ވަގުތުކޮޅެއް މި އީ ރައްކާކުރެވިއްޖެ, ކަސް ނަންބަރު އީ ހަވާލުކުރެވިފައި އަދި ދެބައި SLA ޑީޑްލިނެސް ވަނީ ކޮމްޕުޓެޑް އިން ހޮވިފައި ޕޮލިކްޔް. ޕްރިއޮރިޓްޔް އަދި ޕޮލިކްޔް ނުކުރެވޭނެ ވުން ބަދަލުކުރެވިއްޖެ އަފްޓެރްވަރްޑްސް.",
      "priorityHint": "ޑެކިޑެސް ކޮން SLA ޕޮލިކްޔް އަޕްޕްލީސް, އަދި ނުކުރެވޭނެ ވުން ބަދަލުކުރެވިއްޖެ ފަހުން.",
      "policyHint": "ދޫކުރޭ ހުސް އަށް ދޭ ސާވަރ ދިމާވުން އެއް މެދުވެރިކޮށް ޕްރިއޮރިޓްޔް.",
      "noPolicy": "ދިމާވުން މެދުވެރިކޮށް ޕްރިއޮރިޓްޔް",
      "assigneeHint": "ދޫކުރޭ ހުސް އަށް ދޭ އަސްސިގްންމެންޓް ރުލެސް ޑެކިޑް.",
      "byRules": "މެދުވެރިކޮށް ރުލެސް",
      "warehouseHint": "ކޮންތާކު ޕަރްޓްސް ވާނެ ވުން ދޫކުރެވިއްޖެ އިން. ހުސް ބޭނުންކުރޭ ކޮމްޕަންޔް ޑެފައުލްޓް.",
      "defaultWarehouse": "ކޮމްޕަންޔް ޑެފައުލްޓް",
      "assetHint": "ޕުޓްސް މި ޓިކެޓް ގައި އެ އުނިޓްސް ޚިދުމަތް ތާރީޚް.",
      "assetNeedsCustomer": "ހޮވާ ކަސްޓަމަރު ފުރަތަމަ — އަސްސެޓް ބެލޮންގްސް އަށް އެއް.",
      "billableHint": " ބިލްލަބްލް ޓިކެޓް ކުރެވޭނެ އުފުލާ ކަސްޓަމަރު އިންވޮއިސް ށްޓަކައި އޭގެ ޕަރްޓްސް އަދި ލަބައުރް.",
      "revisitHint": " ރެޓުރްން ވިސިޓް ށްޓަކައި އެއް ފައުލްޓް. އެކްސްކްލުޑެޑް އިން ފިރްސްޓްޓިމެފިކްސް ރަޓް.",
      "submit": "އުފުލާ ޓިކެޓް",
      "doneTitle": "ޓިކެޓް ރައިސެޑް",
      "failed": "ކުރެވުނު ނޫން އުފުލާ ޓިކެޓް"
    },
    "detail": {
      "factsTitle": "ތަފްޞީލު",
      "openCustomer": "ހުޅުވާ ކަސްޓަމަރު",
      "noCustomer": "ނެތް ކަސްޓަމަރު",
      "openAsset": "ހުޅުވާ އުނިޓް",
      "noAsset": "ނެތް އުނިޓް ނަމެޑް",
      "noPolicy": "ނެތް ޕޮލިކްޔް",
      "seePolicies": "ބަލާ ޕޮލިކީސް",
      "loadFailed": "ކުރެވުނު ނޫން ލޯޑް ޓިކެޓް"
    },
    "edit": {
      "title": "އެޑިޓްކުރޭ ޓިކެޓް",
      "description": " ފެވް ފީލްޑްސް ޚިދުމަތް ރެކޯޑް އޯންސް.",
      "scopeNote": " ސުބްޖެކްޓް, ޕްރިއޮރިޓްޔް, ސްޓޭޓަސް އަދި SLA ޕޮލިކްޔް ބެލޮންގް އަށް އުންޑެރްލްޔިންގް ކަސް އަދި ވަނީ ބަދަލުކުރެވިއްޖެ ތްރައުގް އޭގެ އަމިއްލަ އަމަލުތައް, ނޫން މިތާ.",
      "billableHint": "ވެތެރް މި ޓިކެޓްސް ޕަރްޓްސް އަދި ލަބައުރް ކުރެވޭނެ ވުން އިންވޮއިކެޑް އަށް ކަސްޓަމަރު."
    },
    "rail": {
      "raised": "ރައިސެޑް",
      "firstResponse": "ފުރަތަމަ ރެސްޕޮންސް",
      "escalated": "އެސްކަލަޓެޑް",
      "resolved": "ރެސޮލްވެޑް",
      "closed": "ބަންދުކުރެވިފައި",
      "customer": "ކަސްޓަމަރު",
      "otherTickets": "އެ ފަރާތްތަކުގެ އެހެން ޓިކެޓްސް",
      "assetHistory": "މި އުނިޓްސް ތާރީޚް",
      "invoice": "އިންވޮއިސް",
      "case": "ކަސް ވިއު"
    },
    "escalatedBanner": "އެސްކަލަޓެޑް ގައި",
    "reopenedBanner": "ރެއޮޕެނެޑް {count} ވަގުތު(ސް). އޮރިގިނަލް ޑީޑްލިނެސް އަދިވެސް ސްޓަންޑް.",
    "pmGenerated": "ރައިސެޑް އަމިއްލައަށް މެދުވެރިކޮށް ޕްރެވެންޓިވެމައިންޓެނަންކް ސްޗެޑުލް.",
    "replyTitle": "ރެޕްލްޔް އަށް ކަސްޓަމަރު",
    "replyNote": " ޕުބްލިކް ރެޕްލްޔް އީ ކޮންއެއްޗެއް ހުއްޓޭ ރެސްޕޮންސް ކްލޮކް. އިންޓެރްނަލް ނޯޓް މަތީގައި ޓިމެލިން ބެލޯ ހުއްޓޭ އެއްވެސްއެއްޗެއްނެތް.",
    "replyLabel": "ރެޕްލްޔް",
    "replyPublic": "ފޮނުވާ އަށް ކަސްޓަމަރު",
    "replyPublicHint": "ހަމައެކަނި ޕުބްލިކް, ސްޓަފްފްއައުތޮރެޑް ރެޕްލްޔް ސަޓިސްފީސް ރެސްޕޮންސް SLA.",
    "replyPrivateHint": "އުންޓިކެޑް, މި އީ ރެކޯޑްކުރެވިފައި ނަމަވެސް ކްލޮކް ބަހައްޓާ ހިނގަނީ.",
    "reply": "ފޮނުވާ",
    "repliedTitle": "ރެޕްލްޔް ރެކޯޑްކުރެވިފައި",
    "repliedDetail": "އެއްވެސްހާލެއްގައި އެ ވި ފުރަތަމަ ޕުބްލިކް އެއް, ރެސްޕޮންސް ކްލޮކް އެބަހުރި ހުއްޓިއްޖެ.",
    "replyFailed": "ކުރެވުނު ނޫން ރެކޯޑް ރެޕްލްޔް",
    "assign": "އަސްސިގްން",
    "assignedTitle": "ހަވާލުކުރެވިފައި",
    "assignFailed": "ކުރެވުނު ނޫން އަސްސިގްން ޓިކެޓް",
    "resolve": "ރެސޮލްވް",
    "resolveTitle": "ރެސޮލްވް މި ޓިކެޓް",
    "resolveDescription": "ހުއްޓޭ ރެސޮލުޓިއޮން ކްލޮކް. ޓިކެޓް ކުރެވޭނެ އަދިވެސް ވުން ރެއޮޕެނެޑް.",
    "resolutionLabel": "ކޮންއެއްޗެއް ވި ނިމިއްޖެ",
    "resolvedTitle": "ރެސޮލްވެޑް",
    "resolvedDetail": " ރެސޮލުޓިއޮން ކްލޮކް އެބަހުރި ހުއްޓިއްޖެ.",
    "resolveFailed": "ކުރެވުނު ނޫން ރެސޮލްވް ޓިކެޓް",
    "close": "ބަންދުކުރޭ",
    "closedTitle": "ބަންދުކުރެވިފައި",
    "closedDetail": "ނެތް ފުރްތެރް މަސައްކަތް އީ އެކްސްޕެކްޓެޑް.",
    "closeFailed": "ކުރެވުނު ނޫން ބަންދުކުރޭ ޓިކެޓް",
    "reopen": "ރެއޮޕެން",
    "reopenTitle": "ރެއޮޕެން މި ޓިކެޓް",
    "reopenDescription": "އެ ދޭ ފަހަތަށް އަށް ހުޅުވާ އަދި އަދަދުތައް އަގައިންސްޓް ފިރްސްޓްޓިމެފިކްސް ރަޓް.",
    "reopenKeepsDeadlines": " އޮރިގިނަލް ޑީޑްލިނެސް ވަނީ ބެހެއްޓިފައި. މިސްސެޑް SLA ސްޓޭސް މިސްސެޑް — ރެވްރިޓިންގް ޕްރޮމިސް އަފްޓެރްވަރްޑްސް ވީސް ލައުންޑެރް އެ.",
    "reopenReason": "ކީއްވެ",
    "reopenedTitle": "ރެއޮޕެނެޑް",
    "reopenedDetail": " އޮރިގިނަލް ޑީޑްލިނެސް ވަނީ އުންޗަންގެޑް.",
    "reopenFailed": "ކުރެވުނު ނޫން ރެއޮޕެން ޓިކެޓް",
    "updatedTitle": "ޓިކެޓް އަޕްޑޭޓްކުރެވިއްޖެ",
    "updatedDetail": " ޚިދުމަތް ރެކޯޑް އެބަހުރި ވެފައި ރައްކާކުރެވިއްޖެ.",
    "updateFailed": "ކުރެވުނު ނޫން އަޕްޑޭޓް ޓިކެޓް",
    "csatTitleSection": "ކަސްޓަމަރު ސަޓިސްފަކްޓިއޮން",
    "csatAsk": "ވި ކަސްޓަމަރު ސަޓިސްފީޑް?",
    "csatYes": "ސަޓިސްފީޑް",
    "csatNo": "ނޫން ސަޓިސްފީޑް",
    "csatOnce": "ރެކޯޑްކުރެވިފައި އެއްފަހަރު އަދި ދުވަހަކުވެސް އެޑިޓެޑް.",
    "csatSatisfied": " ކަސްޓަމަރު ވި ސަޓިސްފީޑް",
    "csatUnsatisfied": " ކަސްޓަމަރު ވި ނޫން ސަޓިސްފީޑް",
    "csatTitle": "ރަޓިންގް ރެކޯޑްކުރެވިފައި",
    "csatDetail": "އެ އަދަދުތައް ޓޯއަރްޑްސް CSAT ރެޕޮރްޓް.",
    "csatFailed": "ކުރެވުނު ނޫން ރެކޯޑް ރަޓިންގް",
    "parts": {
      "title": "ޕަރްޓްސް ކޮންސުމެޑް",
      "note": "ކޮންސުމިންގް ބައި ދޫކުރޭ ރީލް ސްޓޮކް: ލެޖަރ އެންޓްރީ އީ ވްރިޓްޓެން އަދި ޖާނަލް ޕޯސްޓްކުރެވިފައި ގައި ކޮސްޓް ސްޓޮކް އެންގިން އަކްޓުއަލްލްޔް ޗަރްގެސް. އެ ކޮސްޓް އީ ސާވަރުގެ, ދުވަހަކުވެސް ރެޑެރިވެޑް މިތާ.",
      "add": "ކޮންސުމް ބައި",
      "addTitle": "ކޮންސުމް ބައި",
      "addDescription": "ދޫކުރޭ ސްޓޮކް އަދި ރެކޯޑްތައް ކޮންއެއްޗެއް އެ ކޮސްޓް.",
      "addWarning": "މި މޮވެސް ސްޓޮކް އަދި ޕޮސްޓްސް އަށް ލެޖަރ ސްޓްރައިގްޓް އަވޭ. ވޮއިޑިންގް ރެސްޓޮކްސް އެ, ނަމަވެސް ހަމައެކަނި ވަންދެން ޓިކެޓް އެބަހުރި ވެފައި ބިލްކުރެވޭ.",
      "item": "އިޓެމް",
      "itemPlaceholder": "ހޮވާ ސްޓޮކެޑް އިޓެމް",
      "warehousePlaceholder": "ހޮވާ ވަރެހައުސް",
      "quantity": "ކަންޓިޓްޔް",
      "unitCost": "އުނިޓް ކޮސްޓް",
      "net": "ނެޓް",
      "consume": "ކޮންސުމް",
      "consumedTitle": "ބައި ކޮންސުމެޑް",
      "consumedDetail": "ސްޓޮކް އެބަހުރި ވެފައި ދޫކުރެވިއްޖެ އަދި ކޮސްޓް ރެކޯޑްކުރެވިފައި.",
      "consumeFailed": "ކުރެވުނު ނޫން ކޮންސުމް ބައި",
      "consumedCost": "ކޮސްޓް ގެ ޕަރްޓްސް ކޮންސުމެޑް",
      "billableHint": " ބިލްލަބްލް ބައި ބެކޮމެސް އިންވޮއިސް ލިން ވަގުތު ޓިކެޓް އީ ބިލްކުރެވޭ.",
      "notBillable": "ނޫން ބިލްލަބްލް",
      "void": "ވޮއިޑް",
      "voided": "ވޮއިޑެޑް",
      "voidTitle": "ވޮއިޑް މި ބައި",
      "voidDescription": "ރެސްޓޮކްސް އެ އަދި ރެވެރްސެސް ކޮސްޓް.",
      "voidNote": " ބައި އީ ލިބިއްޖެ ފަހަތަށް ގައި ސީދާ އުނިޓް ކޮސްޓް އެ ދޫކުރި ގައި. ރެސްޓޮކް ގައި ރެގުއެސްސެޑް ކޮސްޓް ވީސް ޑިސަގްރީ އާއެކު ލެޖަރ.",
      "voidReason": "ކީއްވެ",
      "voidedTitle": "ބައި ވޮއިޑެޑް",
      "voidedDetail": "އެ އެބަހުރި ވެފައި ރެސްޓޮކެޑް ގައި ކޮސްޓް އެ ވި ދޫކުރެވިއްޖެ ގައި.",
      "voidFailed": "ކުރެވުނު ނޫން ވޮއިޑް ބައި",
      "billedNote": "މި ޓިކެޓް އެބަހުރި ވެފައި އިންވޮއިކެޑް, އެހެންކަމުން އޭގެ ޕަރްޓްސް ކުރެވޭނެ ނެތް އިތުރަށް ވުން ވޮއިޑެޑް — އިންވޮއިސް ކުރިންވެސް ކަރްރީސް އެ ފަރާތްތަކަށް.",
      "emptyTitle": "ނެތް ޕަރްޓްސް ބޭނުންކުރެވިފައި",
      "emptyDescription": "ކޮންސުމިންގް ބައި ދޫކުރޭ ސްޓޮކް އިން ވަރެހައުސް އަދި ރެކޯޑްތައް ކޮންއެއްޗެއް އެ ކޮސްޓް.",
      "loadFailed": "ކުރެވުނު ނޫން ލޯޑް ޕަރްޓްސް"
    },
    "labour": {
      "title": "ލަބައުރް",
      "add": "ލޮގް ލަބައުރް",
      "addTitle": "ލޮގް ލަބައުރް",
      "addDescription": "ކާކު ވޮރްކެޑް, ށްޓަކައި ހޯ ލޮންގް, ގައި ކޮންއެއްޗެއް ރަޓް.",
      "date": "ތާރީޚް",
      "technician": "ޓެޗްނިކިއަން",
      "technicianPlaceholder": "ހޮވާ ޓެޗްނިކިއަން",
      "hours": "ގަޑިއިރު",
      "rate": "ރަޓް",
      "rateHint": "ކޮންއެއްޗެއް ކަސްޓަމަރު އީ ޗަރްގެޑް ކޮންމެ ހައުރް. އެތާ އީ ނެތް ޚިދުމަތް އަގު ލިސްޓް ގައި މި ބުއިލްޑް, އެހެންކަމުން އެ އީ އެންޓެރެޑް ކޮންމެ އެންޓްރީ.",
      "log": "ލޮގް",
      "loggedTitle": "ލަބައުރް ލޮގްކުރެވިއްޖެ",
      "loggedDetail": "އެ ވާނެ ފެންނާނެ ގޮތުގައި އިންވޮއިސް ލިން ވަގުތު ޓިކެޓް އީ ބިލްކުރެވޭ.",
      "loggedTotal": "ލޮގްކުރެވިއްޖެ",
      "logFailed": "ކުރެވުނު ނޫން ލޮގް ލަބައުރް",
      "voidedTitle": "އެންޓްރީ ވޮއިޑެޑް",
      "voidedDetail": "އެ ސްޓޭސް މަތީގައި ރެކޯޑް, ސްޓްރުކް ތްރައުގް.",
      "voidFailed": "ކުރެވުނު ނޫން ވޮއިޑް އެންޓްރީ",
      "emptyTitle": "ނެތް ލަބައުރް ލޮގްކުރެވިއްޖެ",
      "emptyDescription": "ލޮގް ވަގުތު ޓެޗްނިކިއަން ސްޕެންޓް, އާއެކު ރަޓް ކަސްޓަމަރު އީ ޗަރްގެޑް.",
      "loadFailed": "ކުރެވުނު ނޫން ލޯޑް ލަބައުރް"
    },
    "billing": {
      "title": "ބިލިންގ",
      "previewTitle": "ކޮންއެއްޗެއް މި ވާނެ އިންވޮއިސް",
      "previewNote": "ކޮންމެ ބިލްލަބްލް, އުންވޮއިޑެޑް ބައި އަދި ލަބައުރް ސަފު, އެއް އިންވޮއިސް ލިން ކޮންމެ. ޕަރްޓްސް ވަނީ ޕްރިކެޑް ގައި ކޮސްޓް ސްޓޮކް ޗަރްގެޑް; ލަބައުރް ގައި އޭގެ ލޮގްކުރެވިއްޖެ ރަޓް.",
      "line": "ލިން",
      "kinds": {
        "part": "ބައި",
        "labour": "ލަބައުރް"
      },
      "quantity": "ކަންޓިޓްޔް",
      "unitPrice": "އުނިޓް އަގު",
      "netTotal": "ނެޓް ޓޮޓަލް",
      "taxNote": "ނެޓް ގެ ޓަކްސް. އިންވޮއިކެސް ޓޮޓަލް އީ މި ޕްލުސް ކޮންމެ ގޮތެއްވިޔަސް ޓަކްސް ރެކެއިވަބްލެސް މޮޑިއުލް ރެސޮލްވެސް ކޮންމެ ލިން.",
      "excluded": "ދޫކުރި ބޭރަށް: {parts} ބައި(ސް) އަދި {labour} ލަބައުރް ސަފު(ސް) އެ ވަނީ ވޮއިޑެޑް ނުވަތަ ނޫން ބިލްލަބްލް.",
      "lineCount": "ލިނެސް",
      "raise": "އުފުލާ އިންވޮއިސް",
      "confirmTitle": "އުފުލާ މި އިންވޮއިސް?",
      "confirmDescription": "މި ރައިސެސް, ކޮންފިރްމްސް އަދި ޕޮސްޓްސް ރެކެއިވަބްލެސް އިންވޮއިސް ގައި އެއް ފިޔަވަޅު.",
      "confirmIrreversible": " ޓިކެޓް ބިލްލްސް ގައި އެންމެ އެއްފަހަރު. އެތާ އީ ނެތް ޑްރަފްޓް އަށް ރެވީވް އަފްޓެރްވަރްޑްސް, އަދި އެއްވެސްއެއްޗެއް އަޑްޑެޑް ފަހުން އީ ދޫކުރި ށްޓަކައި ފޮލްލޯއުޕް އެއަށްވުރެ ވުރެ ބަދަލުކުރުން އިންވޮއިސް އެ އެބަހުރި ކުރިންވެސް ޕޯސްޓްކުރެވިފައި.",
      "invoiceDate": "އިންވޮއިސް ތާރީޚް",
      "invoiceDateHint": "ޑެފައުލްޓްސް އަށް ޓޮޑޭ ގައި ޓެނަންޓްގެ ޓައިމްޒޯން.",
      "labourTaxCode": "ލަބައުރް ޓަކްސް ކޯޑް",
      "labourTaxCodeHint": "ޕަރްޓްސް އިންހެރިޓް އެ ފަރާތްތަކުގެ އިޓެމްސް ޓަކްސް ގްރައުޕް. ލަބައުރް އެބަހުރި އެއްވެސްއެއްޗެއްނެތް, އެހެންކަމުން ކޯޑް ކުރެވޭނެ ވުން ނަމެޑް މިތާ.",
      "doneTitle": "އިންވޮއިސް ރައިސެޑް",
      "doneDetail": " ރެކެއިވަބްލެސް އިންވޮއިސް އެބަހުރި ވެފައި ޔަގީންކުރެވިއްޖެ އަދި ޕޯސްޓްކުރެވިފައި.",
      "failed": "ކުރެވުނު ނޫން އުފުލާ އިންވޮއިސް",
      "openInvoice": "ހުޅުވާ އިންވޮއިސް",
      "alreadyInvoiced": "މި ޓިކެޓް އެބަހުރި ކުރިންވެސް ވެފައި އިންވޮއިކެޑް.",
      "nothingToBill": "އެތާ އީ އެއްވެސްއެއްޗެއްނެތް ބިލްލަބްލް މަތީގައި މި ޓިކެޓް އަދި — ލޮގް ލަބައުރް ނުވަތަ ކޮންސުމް ބައި ފުރަތަމަ.",
      "notBillable": "މި ޓިކެޓް އީ ނޫން މަރްކެޑް ބިލްލަބްލް, އެހެންކަމުން އެ ނުކުރެވޭނެ އުފުލާ އިންވޮއިސް.",
      "noCustomer": "މި ޓިކެޓް ނަމެސް ނެތް ކަސްޓަމަރު, އަދި ބިލްލަބްލް ޓިކެޓް ލާޒިމު އެބަހުރި އެއް."
    },
    "assets": {
      "listTitle": "ކަސްޓަމަރު މުދާ",
      "listDescription": "އެކިޕްމެންޓް ކަސްޓަމަރު އޯންސް އަދި މި ޑެސްކް ޚިދުމަތްތައް — ނޫން ކޮމްޕަންޔްސް އަމިއްލަ ފިކްސްޑް އެސެޓްތައް, އަދި ނޫން ސްޓޮކް ސެރިއަލްސް.",
      "new": "އާ އަސްސެޓް",
      "createTitle": "އާ ކަސްޓަމަރު އަސްސެޓް",
      "editTitle": "އެޑިޓްކުރޭ ކަސްޓަމަރު އަސްސެޓް",
      "dialogDescription": " އުނިޓް ބެލޮންގިންގް އަށް ކަސްޓަމަރު, އިޑެންޓިފީޑް މެދުވެރިކޮށް ކޮންމެ ގޮތެއްވިޔަސް އީ މަތީގައި އޭގެ ނަމެޕްލަޓް.",
      "searchPlaceholder": "ނަން, މޮޑެލް ނުވަތަ ސެރިއަލް",
      "category": "ކަޓެގޮރްޔް",
      "modelNo": "މޮޑެލް",
      "serialNo": "ސެރިއަލް",
      "serialNoHint": "ފްރީ ލިޔުން: ކޮންއެއްޗެއް ޓެޗްނިކިއަން ރީޑްސް ނިއްވާ ނަމެޕްލަޓް. އެންމެ އުނިޓްސް ވި ދުވަހަކުވެސް އައުރް ސްޓޮކް.",
      "location": "ލޮކަޓިއޮން",
      "purchasedAt": "ޕުރްޗަސެޑް",
      "warrantyExpiresAt": "ވަރްރަންޓްޔް ވަންދެން",
      "warrantyHint": "މަސައްކަތް މަތީގައި އުނިޓް އަދިވެސް ދަށުގައި ވަރްރަންޓްޔް އީ އުސުއަލްލްޔް ނޫން ބިލްލަބްލް.",
      "notes": "ނޮޓެސް",
      "detailsTitle": "ތަފްޞީލު",
      "noItemSerial": "މި އުނިޓް އީ ނޫން ކްރޮސްސްރެފެރެންކެޑް އަށް ސްޓޮކް ސެރިއަލް. އެ އީ ނޮރްމަލް — އެންމެ ވި ބައުގްޓް އެލްސެވެރް, ވަނީ ނޫން ސެރިއަލިސެޑް, ނުވަތަ ޕްރެޑަޓް މި ސްޔްސްޓެމް.",
      "raiseTicket": "އުފުލާ ޓިކެޓް",
      "historyTitle": "ޚިދުމަތް ތާރީޚް",
      "historyNote": "ކޮންމެ ޓިކެޓް އެވެރް ރައިސެޑް އަގައިންސްޓް މި އުނިޓް, ނެވެސްޓް ފުރަތަމަ. ފިރްސްޓްޓިމެފިކްސް ކޮލަމް ބޭނުންކުރޭ ރެޕޮރްޓްސް އަމިއްލަ ގަވާއިދު: ރެސޮލްވެޑް, ނޫން ރެވިސިޓް, ދުވަހަކުވެސް ރެއޮޕެނެޑް.",
      "raised": "ރައިސެޑް",
      "resolved": "ރެސޮލްވެޑް",
      "firstTimeFix": "ފިރްސްޓްޓިމް ފިކްސް",
      "ftfYes": "ފިކްސްޑް ފުރަތަމަ ވަގުތު",
      "revisit": "ރެވިސިޓް",
      "noHistoryTitle": "ދުވަހަކުވެސް ސެރްވިކެޑް",
      "noHistoryDescription": "ޓިކެޓްސް ނަމިންގް މި އުނިޓް ވާނެ ފެންނާނެ މިތާ.",
      "pmTitle": "ޕްރެވެންޓިވް މައިންޓެނަންކް",
      "noPmTitle": "ނެތް ސްޗެޑުލް",
      "noPmDescription": " ސްޗެޑުލް ރައިސެސް ޓިކެޓް ށްޓަކައި މި އުނިޓް މަތީގައި ފިކްސްޑް ކްޔްކްލް.",
      "createdTitle": "އަސްސެޓް އުފެއްދިއްޖެ",
      "savedTitle": "އަސްސެޓް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ކުރެވުނު ނޫން ރައްކާކުރޭ އަސްސެޓް",
      "emptyTitle": "ނެތް ކަސްޓަމަރު މުދާ އަދި",
      "emptyDescription": "ރެކޯޑް އުނިޓްސް މި ޑެސްކް ޚިދުމަތްތައް, އަދި ކޮންމެ ޓިކެޓް އަގައިންސްޓް އެ ފަރާތްތަކަށް ބުއިލްޑްސް ތާރީޚް.",
      "loadFailed": "ކުރެވުނު ނޫން ލޯޑް ކަސްޓަމަރު މުދާ"
    },
    "pm": {
      "title": "ޕްރެވެންޓިވް މައިންޓެނަންކް",
      "description": "ސްޗެޑުލެސް އެ އުފުލާ ޓިކެޓް ށްޓަކައި ކުސްޓޮމެރްސް އުނިޓް މަތީގައި ފިކްސްޑް ކްޔްކްލް.",
      "listTitle": "ސްޗެޑުލެސް",
      "new": "އާ ސްޗެޑުލް",
      "createTitle": "އާ ސްޗެޑުލް",
      "editTitle": "އެޑިޓްކުރޭ ސްޗެޑުލް",
      "dialogDescription": " އުނިޓް, ކްޔްކްލް, އަދި ޓިކެޓް އެ ޖެހޭ އުފުލާ.",
      "frequency": "ކޮންމެ",
      "frequencyHint": "ގައި ދުވަސްތައް. ނިނެޓްޔް ދުވަސްތައް އީ ކަރްޓެރްލްޔް ޚިދުމަތް.",
      "everyDays": "ކޮންމެ {days} ދުވަސްތައް",
      "nextDue": "ދެން ޑުއެ",
      "nextDueHint": " ވިޔަފާރި ތާރީޚް ގައި ޓެނަންޓްގެ ޓައިމްޒޯން.",
      "lastGenerated": "އެންމެފަހު އުފެއްދިފައި",
      "subjectTemplate": "ޓިކެޓް ސުބްޖެކްޓް",
      "subjectTemplateHint": "ކޮންއެއްޗެއް އުފެއްދިފައި ޓިކެޓް ވާނެ ވުން ކަލްލެޑް.",
      "active": "ހަރަކާތްތެރި",
      "activeHint": " އިނަކްޓިވް ސްޗެޑުލް ގެނެރަޓެސް އެއްވެސްއެއްޗެއްނެތް އަދި ބަހައްޓާ އޭގެ ތާރީޚް.",
      "inactive": "އިނަކްޓިވް",
      "runNow": "ގެނެރަޓް މިހާރު",
      "runTitle": "ގެނެރަޓް ޑުއެ ޓިކެޓްސް",
      "runDescription": "ހިންގާ އެއް ގެނެރަޓިއޮން ވޮރްކެރް ހިންގާ މަތީގައި ސްޗެޑުލް.",
      "runOn": "ގޮތުގައި ގެ",
      "runOnHint": "ދޫކުރޭ ހުސް ށްޓަކައި ޓޮޑޭ ގައި ޓެނަންޓްގެ ޓައިމްޒޯން. ސެޓް ތާރީޚް އަށް ކަޓްޗް މައްޗަށް ފަހުން އައުޓަގް.",
      "runDoneTitle": "ގެނެރަޓިއޮން ނިމިއްޖެ",
      "runDoneDetail": "{generated} ރައިސެޑް, {skipped} ކުރިންވެސް އެކްސިސްޓެޑް.",
      "runFailed": "ކުރެވުނު ނޫން ހިނގާ ގެނެރަޓިއޮން",
      "idempotentNote": "ހިނގަނީ މި ޓްވިކް އީ ރައްކާތެރި: ގެނެރަޓިއޮން އީ އުނިކެ ކޮންމެ ސްޗެޑުލް އަދި ޑުއެ ތާރީޚް ގައި ޑޭޓާބޭސް, އެހެންކަމުން ސެކޮންޑް ހިނގާ ފިންޑްސް އެއްވެސްއެއްޗެއްނެތް އާ އަދި ރެޕޮރްޓްސް އެ ގޮތުގައި ސްކިޕްޕެޑް އެއަށްވުރެ ވުރެ ރައިސިންގް ޑުޕްލިކަޓް.",
      "savedTitle": "ސްޗެޑުލް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ކުރެވުނު ނޫން ރައްކާކުރޭ ސްޗެޑުލް",
      "emptyTitle": "ނެތް ސްޗެޑުލެސް އަދި",
      "emptyDescription": "އިތުރުކުރޭ އެއް އަގައިންސްޓް ކަސްޓަމަރު އަސްސެޓް އަދި ވޮރްކެރް ވާނެ އުފުލާ އޭގެ ޓިކެޓްސް މަތީގައި ކްޔްކްލް ތިޔަ ފަރާތް ސެޓް.",
      "loadFailed": "ކުރެވުނު ނޫން ލޯޑް ސްޗެޑުލެސް"
    },
    "rules": {
      "title": "އަސްސިގްންމެންޓް ރުލެސް",
      "description": "ހޯ އާ ޓިކެޓް ފިންޑްސް ޓެޗްނިކިއަން.",
      "listTitle": "ރުލެސް, ގައި ތަރުތީބު އެ ފަރާތްތައް ވަނީ ވަލްކެޑް",
      "firstMatchNote": "ފުރަތަމަ ދިމާވުން ވިންސް. ރުލެސް ވަނީ ވަލްކެޑް ގައި ތަރުތީބު އަދި ފުރަތަމަ ކާގެ ކަޓެގޮރްޔް އަދި ޕްރިއޮރިޓްޔް ދެބައި ދިމާވުން ނަގާ ޓިކެޓް; އެމްޕްޓްޔް ކޮލަމް މަޓްޗެސް އެއްވެސްއެއްޗެއް. ރުލެސް ވަނީ ކޮންސުލްޓެޑް ހަމައެކަނި ވަގުތު ޓިކެޓް އީ ރައިސެޑް — ބަދަލުކުރުން އެއް ދުވަހަކުވެސް މޮވެސް މަސައްކަތް ކުރިންވެސް ހަންޑެޑް ބޭރަށް.",
      "new": "އާ ގަވާއިދު",
      "createTitle": "އާ އަސްސިގްންމެންޓް ގަވާއިދު",
      "editTitle": "އެޑިޓްކުރޭ އަސްސިގްންމެންޓް ގަވާއިދު",
      "dialogDescription": " ދިމާވުން މަތީގައި ކަޓެގޮރްޔް އަދި ޕްރިއޮރިޓްޔް, އަދި މީހާ ކާކު ގެޓްސް ޓިކެޓް.",
      "order": "ތަރުތީބު",
      "orderHint": "ދަށް ހިންގާ ފުރަތަމަ. ދޭއް ރުލެސް ށަރިންގް ނަންބަރު ރެސޮލްވް މެދުވެރިކޮށް އަގެ.",
      "matchCategory": "ކަޓެގޮރްޔް",
      "matchCategoryHint": "ދޫކުރޭ ހުސް އަށް ދިމާވުން ކޮންމެ ކަޓެގޮރްޔް.",
      "matchPriority": "ޕްރިއޮރިޓްޔް",
      "matchPriorityHint": "ކޮންމެ ޕްރިއޮރިޓްޔް މަޓްޗެސް ވަގުތު އެއްވެސްއެއްޗެއްނެތް އީ ހޮވިފައި.",
      "anyCategory": "ކޮންމެ ކަޓެގޮރްޔް",
      "anyPriority": "ކޮންމެ ޕްރިއޮރިޓްޔް",
      "assignTo": "އަސްސިގްން އަށް",
      "assignToPlaceholder": "ހޮވާ ޓެޗްނިކިއަން",
      "remove": "ނަގާ",
      "removeTitle": "ނަގާ މި ގަވާއިދު?",
      "removeDescription": "{name} ވާނެ ނެތް އިތުރަށް ރައުޓް އެއްވެސްއެއްޗެއް.",
      "removeNote": "ޓިކެޓްސް ކުރިންވެސް ހަވާލުކުރެވިފައި މެދުވެރިކޮށް އެ ބަހައްޓާ އެ ފަރާތްތަކުގެ އަސްސިގްނީ.",
      "removedTitle": "ގަވާއިދު ނަގައިފި",
      "removeFailed": "ކުރެވުނު ނޫން ނަގާ ގަވާއިދު",
      "savedTitle": "ގަވާއިދު ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ކުރެވުނު ނޫން ރައްކާކުރޭ ގަވާއިދު",
      "emptyTitle": "ނެތް އަސްސިގްންމެންޓް ރުލެސް",
      "emptyDescription": "ނެތި އެއް, އާ ޓިކެޓް އަރްރިވެސް އުނަސްސިގްނެޑް އުންލެސްސް ސޮމެބޮޑްޔް އީ ނަމެޑް މަތީގައި ފޯމް.",
      "loadFailed": "ކުރެވުނު ނޫން ލޯޑް ރުލެސް"
    },
    "reports": {
      "title": "ޚިދުމަތް ރެޕޮރްޓްސް",
      "description": "ފިރްސްޓްޓިމް ފިކްސް, SLA ކޮމްޕްލިއަންކް އަދި ކަސްޓަމަރު ސަޓިސްފަކްޓިއޮން.",
      "rangeTitle": "ރޭންޖް",
      "from": "އިން",
      "to": "އަށް",
      "firstTimeFix": "ފިރްސްޓްޓިމް ފިކްސް",
      "slaCompliance": "SLA ކޮމްޕްލިއަންކް",
      "csat": "ކަސްޓަމަރު ސަޓިސްފަކްޓިއޮން",
      "denominatorsTitle": "ކޮންއެއްޗެއް ކޮންމެ ފިގުރް އީ ބޭރަށް ގެ",
      "ftfDenominator": "{fixed} ގެ {resolved} ރެސޮލްވެޑް ޓިކެޓްސް",
      "slaDenominator": "{tickets} ޓިކެޓްސް އެ ހުރި ޑީޑްލިން",
      "csatDenominator": "{satisfied} ގެ {submitted} ރަޓިންގްސް ސުބްމިޓްޓެޑް",
      "readingTitle": "ހޯ އަށް ކިޔާ މިތަކެތި",
      "ftfMeaning": " ޓިކެޓް އަދަދުތައް ގޮތުގައި ފިކްސްޑް ފުރަތަމަ ވަގުތު ވަގުތު އެ އީ ރެސޮލްވެޑް, ވި ނޫން ފްލަގްގެޑް ރެވިސިޓް ވަގުތު އެ ވި ރައިސެޑް, އަދި ވި ދުވަހަކުވެސް ރެއޮޕެނެޑް. ރެވިސިޓް ފްލެގް އީ ސެޓް މެދުވެރިކޮށް މީހާ, ދުވަހަކުވެސް އިންފެރްރެޑް.",
      "slaMeaning": "މިނެކިރާފައި މަތިން ޓިކެޓްސް އެ ހުރި ޑީޑްލިން, ކައުންޓިންގް ބްރީޗެސް ސްވީޕް ރެކޯޑްކުރެވިފައި. ޓިކެޓް ފަހަނައަޅާ އޭގެ ޑީޑްލިން އެ ސްވީޕް އެބަހުރި ނޫން އަދި ރީޗެޑް އީ ނޫން ގުނިފައި ގޮތުގައި ބްރީޗް.",
      "csatMeaning": " ޑެނޮމިނަޓޮރް އީ ރަޓިންގްސް ސުބްމިޓްޓެޑް, ނޫން ޓިކެޓްސް. އެންމެ ޓިކެޓްސް ވަނީ ދުވަހަކުވެސް ރަޓެޑް, އަދި ޑިވިޑިންގް މެދުވެރިކޮށް ޓިކެޓްސް ވީސް ރެޕޮރްޓް ރެސްޕޮންސް ރަޓް ވީރިންގް ސަޓިސްފަކްޓިއޮން ލަބެލް.",
      "holidayCaveat": "ގައި މަދުވެގެން އެއް ހަރަކާތްތެރި ޕޮލިކްޔް އަދަދުތައް ވިޔަފާރި ގަޑިއިރު, އަދި އެތާ އީ ނެތް ހޮލިޑޭ ކަލެންޑަރް ގައި މި ބުއިލްޑް. ޑީޑްލިން ކާގެ ވިންޑޯ ސްޕަންނެޑް ޕުބްލިކް ހޮލިޑޭ ލަންޑެޑް އީރްލީރް ވުރެ މީހާ ކައުންޓިންގް މެދުވެރިކޮށް ހަންޑް ވީސް ލާ އެ, ކޮން މަކެސް ކޮމްޕްލިއަންކް މިނެކިރާފައި އަގައިންސްޓް އެ ޕެސްސިމިސްޓިކް.",
      "breachesTitle": "ބްރީޗެސް ރެކޯޑްކުރެވިފައި",
      "ticketsWithDeadline": "ޓިކެޓްސް އާއެކު ޑީޑްލިން",
      "responseBreaches": "ރެސްޕޮންސް ބްރީޗެސް",
      "resolutionBreaches": "ރެސޮލުޓިއޮން ބްރީޗެސް",
      "period": "މުއްދަތު",
      "sweepNote": "މިތަކެތި ވަނީ ބްރީޗެސް ސްވީޕް އެބަހުރި ސްޓަމްޕެޑް — ކޮންމެ އެއް ނޮޓިފީޑް އޭގެ އަސްސިގްނީ އަދި އެސްކަލަޓެޑް އަށް ޕޮލިކްޔްސް ކޮންޓަކްޓް.",
      "loadFailed": "ކުރެވުނު ނޫން ލޯޑް ރެޕޮރްޓްސް"
    },
    "settings": {
      "title": "ޚިދުމަތް ސެޓިންގްސް",
      "description": " ކޮމްޕަންޔްސް ޑެފައުލްޓް ވަރެހައުސް އަދި އަކްކައުންޓް އޭގެ ޚިދުމަތް އިންވޮއިކެސް ކްރެޑިޓް.",
      "defaultsTitle": "ޑެފައުލްޓްސް",
      "note": "ދެބައި ސެޓިންގްސް ބްލޮކް ކޮންމެވެސްއެއްޗެއް ވަގުތު މިސްސިންގް: ނެތި ޑެފައުލްޓް ވަރެހައުސް, ކޮންސުމިންގް ބައި މަތީގައި ޓިކެޓް އެ ނަމެސް އެއްވެސްއެއްޗެއްނެތް އީ ރެފުސެޑް; ނެތި އާމްދަނީ އަކްކައުންޓް, ބިލިންގ ޓިކެޓް އީ ރެފުސެޑް. އެތާ އީ އެއް އާމްދަނީ އަކްކައުންޓް, ނޫން އެއް ށްޓަކައި ޕަރްޓްސް އަދި އެއް ށްޓަކައި ލަބައުރް.",
      "defaultWarehouse": "ޑެފައުލްޓް ވަރެހައުސް",
      "defaultWarehouseHint": "ކޮންތާކު ޕަރްޓްސް ވަނީ ދޫކުރެވިއްޖެ އިން ވަގުތު ޓިކެޓް ކުރޭ ނޫން ނަން ވަރެހައުސް ގެ އޭގެ އަމިއްލަ.",
      "pickWarehouse": "ހޮވާ ވަރެހައުސް",
      "revenueAccount": "ޚިދުމަތް އާމްދަނީ އަކްކައުންޓް",
      "revenueAccountHint": "ކޮންއެއްޗެއް ކޮންމެ ޓިކެޓް އިންވޮއިސް ކްރެޑިޓްސް. އިންކޮމް އަކްކައުންޓް.",
      "pickAccount": "ހޮވާ އަކްކައުންޓް",
      "saveHint": "އަޕްޕްލީސް އަށް މަސައްކަތް ބިލްކުރެވޭ އިން މިހާރު މަތީގައި, ދުވަހަކުވެސް އަށް އިންވޮއިކެސް ކުރިންވެސް ޕޯސްޓްކުރެވިފައި.",
      "savedTitle": "ސެޓިންގްސް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "ޓިކެޓްސް ށްޓަކައި މި ކޮމްޕަންޔް ކުރެވޭނެ މިހާރު ކޮންސުމް ޕަރްޓްސް އަދި ވުން ބިލްކުރެވޭ.",
      "saveFailed": "ކުރެވުނު ނޫން ރައްކާކުރޭ ސެޓިންގްސް",
      "loadFailed": "ކުރެވުނު ނޫން ލޯޑް ސެޓިންގްސް",
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ސެޓިންގްސް ބަދަލުކޮށްފި. ކަމެއް ނުފޮހެވޭ. ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކުރޭ"
    },
    "filtersTitle": "ފިލްޓަރތައް",
    "goodwill": {
      "title": "ގުޑްވިލް",
      "description": "ސަބަބު-ކޯޑްކުރެވިފައި ރައިޓް-އޮފްސް ރައިޒްކުރެވިފައި ކަސްޓަމަރު އަކާ ދެކޮޅަށް, ޕޯސްޓްކުރެވިފައި އޭއާރް ކްރެޑިޓް ނޯޓް އަކަށް ފަހަރަކު ފާސްކުރެވިފައި.",
      "request": "ރިކުއެސްޓް ގުޑްވިލް",
      "requestTitle": "ރިކުއެސްޓް ގުޑްވިލް",
      "requestDescription": "ގުޑްވިލް ރިކުއެސްޓް އެއް ވެއިވްސް ނުވަތަ ރިޑިއުސެސް ޗާރޖް އެއް ސްޓޭޓެޑް ސަބަބަކަށް. ކޮމްޕަންޔް ގެ ޙައްދަށް މަތިން ބޭނުންވޭ އޯވަރައިޑް ސަބަބެއް; ފާސްކުރުމުން ޕޯސްޓްކުރޭ އޭއާރް ކްރެޑިޓް ނޯޓް އެއް.",
      "requested": "ގުޑްވިލް ރިކުއެސްޓްކުރެވިއްޖެ",
      "requestFailed": "އެ ގުޑްވިލް ރިކުއެސްޓް ކުރެވުނު ނޫން ވުން ރައިޒްޑް.",
      "approve": "ފާސްކުރޭ",
      "approveTitle": "ފާސްކުރޭ ގުޑްވިލް",
      "approveDescription": "ފާސްކުރުމުން ޕޯސްޓްކުރޭ އޭއާރް ކްރެޑިޓް ނޯޓް އެއް މި އަދަދަށް ކަސްޓަމަރު އަކާ ދެކޮޅަށް, އެއް ފިޔަވަޅުގައި.",
      "approved": "ގުޑްވިލް ފާސްކުރެވިއްޖެ",
      "approveFailed": "އެ ގުޑްވިލް ރިކުއެސްޓް ކުރެވުނު ނޫން ވުން ފާސްކުރެވިފައި.",
      "loadFailed": "ގުޑްވިލް ރެޖިސްޓަރ ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "empty": "ނެތް ގުޑްވިލް ރިކުއެސްޓްސް އަދި.",
      "idColumn": "އައިޑީ",
      "tableTitle": "ގުޑްވިލް ރިކުއެސްޓްސް",
      "caption": "ގުޑްވިލް ރިކުއެސްޓްސް, އޭގެ ސަބަބު, އަދަދު, ހާލަތު އަދި ކްރެޑިޓް ނޯޓް.",
      "creditNote": "ކްރެޑިޓް ނޯޓް",
      "overrideAction": "ރިކުއެސްޓިންގް ގުޑްވިލް ބިޔޮންޑް ކޮމްޕަންޔް ގެ ޙައްދު"
    },
    "goodwillStatus": {
      "requested": "ރިކުއެސްޓްކުރެވިފައި",
      "approved": "ފާސްކުރެވިފައި",
      "rejected": "ރިޖެކްޓްކުރެވިފައި",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "cancelled": "ކަންކެލްލެޑް"
    },
    "labels": {
      "yes": "ޔެސް",
      "no": "ނެތް",
      "active": "ހަރަކާތްތެރި",
      "inactive": "އިނަކްޓިވް"
    },
    "workOrderKind": {
      "customer": "ކަސްޓަމަރު",
      "internal": "އިންޓެރްނަލް"
    },
    "workOrderStatus": {
      "draft": "ޑްރަފްޓް",
      "scheduled": "ތާވަލުކުރެވިފައި",
      "dispatched": "ޑިސްޕަޓްޗެޑް",
      "in_progress": "ގައި ކުރިއެރުން",
      "incomplete": "އިންކޮމްޕްލެޓް",
      "completed": "ފުރިހަމަވެއްޖެ",
      "cancelled": "ކަންކެލްލެޑް",
      "closed": "ބަންދުކުރެވިފައި"
    },
    "priority": {
      "low": "ލޯ",
      "medium": "މެޑިއުމް",
      "high": "ހިގް",
      "urgent": "އުރްގެންޓް"
    },
    "billability": {
      "undecided": "ނޫން އަދި ޑެކިޑެޑް",
      "not_billable": "ނޫން ބިލްލަބްލް",
      "partially_billable": "ޕަރްޓްލްޔް ބިލްލަބްލް",
      "billable": "ބިލްލަބްލް"
    },
    "originKind": {
      "service.ticket": "ޓިކެޓް",
      "service.pm_schedule": "PM ސްޗެޑުލް",
      "eam.pm_plan": "ޕްރެވެންޓިވް ޕްލޭން",
      "eam.compliance": "ކޮމްޕްލިއަންކް",
      "pms.room_fault": "ރޫމް ފައުލްޓް"
    },
    "visitOutcome": {
      "completed": "ނިމިއްޖެ",
      "incomplete": "ނޫން ނިމިއްޖެ",
      "no_access": "ކުރެވުނު ނޫން ހޯދާ ގައި",
      "cancelled": "ކަންކެލްލެޑް މަތީގައި ސިޓް"
    },
    "contractStatus": {
      "draft": "ޑްރަފްޓް",
      "active": "ހަރަކާތްތެރި",
      "suspended": "ސަސްޕެންޑްކުރެވިފައި",
      "expired": "އެކްސްޕިރެޑް",
      "cancelled": "ކަންކެލްލެޑް"
    },
    "entitlementScope": {
      "labour": "ލަބައުރް",
      "parts": "ޕަރްޓްސް",
      "travel": "ޓްރަވެލް",
      "response": "ރެސްޕޮންސް"
    },
    "exhaustedPolicy": {
      "chargeable_overage": "ޗަރްގް އޮވެރަގް",
      "chargeable_all": "ޗަރްގް ހުރިހާއެއްޗެއް"
    },
    "entitlementDecision": {
      "covered": "ކޮވެރެޑް",
      "partially_covered": "ޕަރްޓްލްޔް ކޮވެރެޑް",
      "chargeable": "ޗަރްގީބްލް",
      "out_of_contract": "ބޭރަށް ގެ ކޮންޓްރަކްޓް"
    },
    "rateCardStatus": {
      "draft": "ޑްރަފްޓް",
      "published": "ޕުބްލިށެޑް",
      "superseded": "ސުޕެރްސެޑެޑް"
    },
    "problemStatus": {
      "open": "ހުޅުވާ",
      "known_error": "ކްނޯން އެރްރޮރް",
      "resolved": "ރެސޮލްވެޑް",
      "closed": "ބަންދުކުރެވިފައި"
    },
    "dispatchRefusal": {
      "service": {
        "workorder": {
          "statutory_skill_missing": " ސްޓަޓުޓޮރްޔް ކެރްޓިފިކަޓް މި ޖޮބް ބޭނުންވޭ އީ ނޫން ރެކޯޑްކުރެވިފައި އަގައިންސްޓް މި އެންގިނީރް. {detail}",
          "skill_not_held": "މި އެންގިނީރް އީ ށޮރްޓް ގެ ކޮމްޕެޓެންކްޔް ޖޮބް އަސްކްސް ށްޓަކައި. {detail}",
          "outside_working_time": "މި ފަލްލްސް އައުޓްސިޑް އެންގިނީރްސް މަސައްކަތްކުރަނީ ވަގުތު. {detail}",
          "close_unbilled": "ކްލޮސިންގް މި ނެތި އިންވޮއިސް ބޭނުން އޮވެރްރިޑް. {detail}"
        }
      }
    },
    "workOrders": {
      "title": "މަސައްކަތް އޮރްޑެރްސް",
      "description": "އެއް ޑޮކުމެންޓް ށްޓަކައި ކަސްޓަމަރު ޖޮބް އަދި އޯންއަސްސެޓް ޖޮބް އަލިކް. ބިލްލަބިލިޓްޔް އީ ޑެކިޑެޑް މެދުވެރިކޮށް ކުސްޓޮމެރްސް ކޮންޓްރަކްޓް, ނޫން ޓްޔްޕެޑް ގައި މިތާ.",
      "tableTitle": "މަސައްކަތް އޮރްޑެރްސް",
      "caption": "މަސައްކަތް އޮރްޑެރްސް އާއެކު އެ ފަރާތްތަކުގެ ސްޓޭޓަސް, ޕްރިއޮރިޓްޔް, އަސްސިގްނީ އަދި ބިލްލަބިލިޓްޔް.",
      "searchLabel": "ހޯދާ",
      "empty": "ނެތް މަސައްކަތް އޮރްޑެރްސް ދިމާވުން. ވިޑެން ފިލްޓަރތައް, ނުވަތަ އުފުލާ އެއް އިން ޓިކެޓް, ޕްރެވެންޓިވް ޕްލޭން ނުވަތަ ކޮމްޕްލިއަންކް ރެކިރެމެންޓް.",
      "loadFailed": " މަސައްކަތް އޮރްޑެރްސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "billabilityNote": "ބިލްލަބިލިޓްޔް އީ ނެގިފައި އިން ކުސްޓޮމެރްސް ކޮންޓްރަކްޓް އަދި އެ ފަރާތްތަކުގެ ރެމައިނިންގް ކޮޓަ, އަދި އީ ރެއެވަލުއަޓެޑް ވަގުތު ޖޮބް ކޮމްޕްލެޓެސް. އެ ނުކުރެވޭނެ ވުން ސެޓް މެދުވެރިކޮށް ހަންޑް އިން ކޮންމެ ސްކްރީން."
    },
    "workOrder": {
      "summary": "ސުމްމަރްޔް",
      "skills": "ކޮމްޕެޓެންކީސް ލާޒިމު",
      "visits": "ވިސިޓްސް",
      "parts": "ޕަރްޓްސް",
      "labour": "ލަބައުރް",
      "loadFailed": "އެ މަސައްކަތް ތަރުތީބު ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "noSkills": "މި ޖޮބް އަސްކްސް ށްޓަކައި ނެތް ޕަރްޓިކުލަރް ކޮމްޕެޓެންކްޔް.",
      "noVisits": "ނޮބޮޑްޔް އެބަހުރި ވިސިޓެޑް އަދި.",
      "noParts": "ނެތް ޕަރްޓްސް އެބަހުރި ވެފައި ފިޓްޓެޑް.",
      "noLabour": "ނެތް ލަބައުރް އެބަހުރި ވެފައި ލޮގްކުރެވިއްޖެ.",
      "minLevel": "ލެވެލް {level}+",
      "statutory": "ސްޓަޓުޓޮރްޔް",
      "visitNo": "ވިސިޓް {no}",
      "signedBy": "ސައިން ވެފައި މެދުވެރިކޮށް {name}",
      "start": "ފަށާ މަސައްކަތް",
      "started": "މަސައްކަތް ފެށިފައި",
      "startFailed": "މި ޖޮބް ކުރެވުނު ނޫން ވުން ފެށިފައި.",
      "complete": "ފުރިހަމަ",
      "completeTitle": "ފުރިހަމަ މަސައްކަތް ތަރުތީބު",
      "completeDescription": "ރެކޯރޑްކުރޭ ކުރެވުނު މަސައްކަތް ނުވަތަ ރީޗްޑް ޙައްލު ބިފޯރ ކްލޯޒިންގް މި ޖޮބް އައުޓް — ނޯޓް ވެއެއްޖެ ބައެއް މަސައްކަތް ތަރުތީބު ގެ އެވިޑެންސް.",
      "completed": "މަސައްކަތް ތަރުތީބު ފުރިހަމަވެއްޖެ",
      "completeFailed": "މި ޖޮބް ކުރެވުނު ނޫން ވުން ފުރިހަމަވެއްޖެ.",
      "invoice": "އިންވޮއިސް",
      "ticket": " ޓިކެޓް މި ކަމް އިން",
      "contract": " ކޮންޓްރަކްޓް އެ ކޮވެރްސް އެ"
    },
    "permit": {
      "missing": "މި ޖޮބް ބޭނުން ހުއްދަދޭ އަށް މަސައްކަތް އަދި އެއްވެސްއެއްޗެއްނެތް އެބަހުރި ވެފައި ދޫކުރެވިއްޖެ. އެ ނުކުރެވޭނެ ވުން ފެށިފައި ވަންދެން އެއް އީ.",
      "pending": "ހުއްދަދޭ {number} އެބަހުރި ވެފައި ރެކެސްޓެޑް ނަމަވެސް ނޫން ދޫކުރެވިއްޖެ. މަސައްކަތް ވެދާނެ ނޫން ފަށާ ވަންދެން ސޮމެބޮޑްޔް އާއެކު ބާރު ދޫކުރޭ އެ.",
      "held": "ހުއްދަދޭ {number} އީ ގައި މަޖުބޫރު ވަންދެން {validTo}.",
      "board": "ހުއްދަދޭ ބޯރްޑް"
    },
    "entitlement": {
      "title": "ހައްގުކުރުން",
      "none": "ނެތް ހައްގުކުރުން ޑެކިސިއޮން އެބަހުރި ވެފައި ރެކޯޑްކުރެވިފައި ށްޓަކައި މި ޖޮބް އަދި.",
      "coveredLabel": "ކޮވެރެޑް މެދުވެރިކޮށް ކޮންޓްރަކްޓް",
      "chargeableLabel": "ޗަރްގީބްލް އަށް ކަސްޓަމަރު",
      "decidedOn": "ޑެކިޑެޑް ށްޓަކައި މަސައްކަތް މަތީގައި {date}",
      "caption": "ކޮންމެ ކޮވެރަގް ސަފު ކޮންސިޑެރެޑް, އާއެކު ކޮންއެއްޗެއް އެ ޑްރެވް ޑޯން އަދި ކީއްވެ.",
      "scope": "ސްކޮޕް",
      "quota": "ކޮޓަ",
      "drawn": "ޑްރަވްން",
      "remaining": "ރެމައިނިންގް",
      "reason": "ސަބަބު",
      "noConsiderations": " ޑެކިސިއޮން ކޮންސިޑެރެޑް ނެތް ކޮވެރަގް ސަފުތައް.",
      "history": "{count} އީރްލީރް ޑެކިސިއޮން(ސް)",
      "superseded": "ސުޕެރްސެޑެޑް",
      "reevaluate": "ރެއެވަލުއަޓް",
      "reevaluated": " އާ ހައްގުކުރުން ޑެކިސިއޮން ވި ރެކޯޑްކުރެވިފައި",
      "reevaluateFailed": " ހައްގުކުރުން ކުރެވުނު ނޫން ވުން ރެއެވަލުއަޓެޑް.",
      "internal_work_order": " އިންޓެރްނަލް ޖޮބް: އެތާ އީ ނެތް ކަސްޓަމަރު އަށް ޗަރްގް.",
      "no_contract": "ނެތް ކޮންޓްރަކްޓް ކޮވެރްސް މި ކަސްޓަމަރު މަތީގައި މަސައްކަތް ތާރީޚް.",
      "contract_resolved": "ކޮވެރެޑް މެދުވެރިކޮށް މި ކޮންޓްރަކްޓް.",
      "shadowed": " އިތުރު ސްޕެކިފިކް ކޮވެރަގް ސަފު ބޭނުންކުރެވިފައި އިންސްޓީޑް.",
      "no_coverage": " ކޮންޓްރަކްޓް އެބަހުރި ނެތް ކޮވެރަގް ސަފު ށްޓަކައި މި ސްކޮޕް.",
      "covered": "ފުރިހަމައަށް ކޮވެރެޑް މެދުވެރިކޮށް ރެމައިނިންގް ކޮޓަ.",
      "quota_exhausted": " ކޮޓަ ވި އެކްސްހައުސްޓެޑް.",
      "quota_unit_mismatch": " ކޮޓަ އީ ހިފެހެއްޓިފައި ގައި ތަފާތު އުނިޓްސް އިން މި ޗަރްގް.",
      "no_rate_card": "ނެތް ރަޓް ކަރްޑް އީ ގައި މަޖުބޫރު, އެހެންކަމުން އެއްވެސްއެއްޗެއްނެތް ކުރެވޭނެ ވުން ޕްރިކެޑް.",
      "partially_covered": "ޕަރްޓްލްޔް ކޮވެރެޑް: ކޮޓަ ރަން ބޭރަށް ބައި ވޭ.",
      "chargeable": "ޗަރްގީބްލް ގައި ފުރިހަމަ.",
      "quota_taken_concurrently": " ކޮޓަ ވި ޓަކެން މެދުވެރިކޮށް އިތުރު ޖޮބް ދަނޑިވަޅުގައި މި އެއް ވި ވަމުން ޑެކިޑެޑް."
    },
    "dispatch": {
      "title": "ޑިސްޕަޓްޗް ބޯރްޑް",
      "description": " ދުވަހުގެ އުނަސްސިގްނެޑް ޖޮބްތައް, އަދި ކޮންމެ ޓެޗްނިކިއަން އާއެކު ރެފުސަލްސް ކުރިންވެސް ވޮރްކެޑް ބޭރަށް.",
      "chooseCompany": "ހޮވާ ކޮމްޕަންޔް އަށް ބަލާ އޭގެ ބޯރްޑް.",
      "queue": "އުނަސްސިގްނެޑް",
      "queueEmpty": "އެއްވެސްއެއްޗެއްނެތް އީ ވައިޓިންގް އަށް ވުން ހަވާލުކުރެވިފައި.",
      "slotsEmpty": "ނެތް ޓެޗްނިކިއަންސް ވަނީ ލިބެންހުރި ށްޓަކައި މި ދުވަސް.",
      "loadFailed": " ބޯރްޑް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "assignedCount": "{count} ހަވާލުކުރެވިފައި",
      "withinShift": "މަތީގައި ށިފްޓް",
      "assignHere": "އަސްސިގްން މިތާ",
      "assigned": "ހަވާލުކުރެވިފައި",
      "assignFailed": "އެ އަސްސިގްންމެންޓް ވި ރެފުސެޑް.",
      "noOverride": "މި ނުކުރެވޭނެ ވުން އޮވެރްރިޑްޑެން.",
      "statutoryRefused": " ސްޓަޓުޓޮރްޔް ކެރްޓިފިކަޓް އީ މިސްސިންގް. ނޮބޮޑްޔް ވެދާނެ އޮވެރްރިޑް މި.",
      "noRoster": "ނެތް ރޮސްޓެރް ޑޭޓާ ށްޓަކައި މި ދުވަސް, އެހެންކަމުން ވޮރްކިންގްޓިމް ބެލުންތައް ކުރެވުނު ނޫން ވުން ހެދި. ރެފުސަލްސް ބެލޯ ކޮވެރް ކޮމްޕެޓެންކީސް ހަމައެކަނި.",
      "overrideTitle": "އޮވެރްރިޑް މި ރެފުސަލް",
      "overrideNote": " ސަބަބު އީ ރެކޯޑްކުރެވިފައި އަގައިންސްޓް އަސްސިގްންމެންޓް އަދި އީ ފެންނަ މަތީގައި ޖޮބް.",
      "overrideConfirm": "އަސްސިގްން އާއެކު ސަބަބު"
    },
    "contracts": {
      "title": "ޚިދުމަތް ކޮންޓްރަކްޓްސް",
      "description": "ކޮންއެއްޗެއް ކޮންމެ ކަސްޓަމަރު އީ ހައްގުވެފައި އަށް, ކޮންއެއްޗެއް އެ ކޮސްޓްސް އެ ފަރާތްތަކަށް އަދި ވަގުތު އެ ރެނެވްސް.",
      "tableTitle": "ކޮންޓްރަކްޓްސް",
      "caption": "ޚިދުމަތް ކޮންޓްރަކްޓްސް އާއެކު އެ ފަރާތްތަކުގެ ޓެރްމް, ފީ އަދި ރެނެވަލް ޗައިން.",
      "searchLabel": "ހޯދާ",
      "expiringWithin": "އެކްސްޕިރިންގް ވިތިން (ދުވަސްތައް)",
      "renewalQueue": "ރެނެވަލް ކެއުއެ",
      "autoRenew": "އައުޓޮރެނެވްސް",
      "renewedTo": "ރެނެވެޑް",
      "empty": "ނެތް ކޮންޓްރަކްޓްސް ދިމާވުން.",
      "loadFailed": " ކޮންޓްރަކްޓްސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ."
    },
    "contract": {
      "summary": "ސުމްމަރްޔް",
      "coverage": "ކޮވެރަގް",
      "chain": "ރެނެވަލް ޗައިން",
      "loadFailed": "އެ ކޮންޓްރަކްޓް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "noEntitlements": "މި ކޮންޓްރަކްޓް ކަރްރީސް ނެތް ކޮވެރަގް ސަފުތައް, އެހެންކަމުން ކޮންމެ ޖޮބް ދަށުގައި އެ އީ ޗަރްގީބްލް.",
      "noRateCard": "އެއްވެސްއެއްޗެއްނެތް",
      "noSla": "އެއްވެސްއެއްޗެއްނެތް",
      "noChain": "މި ކޮންޓްރަކްޓް އީ ނެއިތެރް ރެނެވަލް ނޮރް ރެނެވެޑް.",
      "renewedFrom": "ރެނެވެޑް އިން ކުރީގެ ކޮންޓްރަކްޓް",
      "renewedTo": "ރެނެވެޑް ތެރެއަށް ދެން ކޮންޓްރަކްޓް",
      "activate": "ހަރަކާތްތެރިކުރޭ",
      "activated": "ކޮންޓްރަކްޓް ހަރަކާތްތެރިކުރެވިއްޖެ",
      "activateFailed": "އެ ކޮންޓްރަކްޓް ކުރެވުނު ނޫން ވުން ހަރަކާތްތެރިކުރެވިއްޖެ.",
      "renew": "ޕްރެޕަރް ރެނެވަލް",
      "renewed": " ޑްރަފްޓް ރެނެވަލް ވި ޕްރެޕަރެޑް",
      "renewFailed": "އެ ރެނެވަލް ކުރެވުނު ނޫން ވުން ޕްރެޕަރެޑް.",
      "renewNote": " ރެނެވަލް އީ އުފެއްދިއްޖެ ގޮތުގައި ޑްރަފްޓް. އެއްވެސްއެއްޗެއްނެތް އަބައުޓް އެ އަޕްޕްލީސް ވަންދެން ސޮމެބޮޑްޔް އަކްޓިވަޓެސް އެ."
    },
    "rateCards": {
      "title": "ރަޓް ކަރްޑްސް",
      "description": "ކޮންއެއްޗެއް ލަބައުރް, ޓްރަވެލް އަދި ޕަރްޓްސް ވަނީ ޗަރްގެޑް ގައި, އަދި އިން ވަގުތު.",
      "tableTitle": "ރަޓް ކަރްޑްސް",
      "empty": "ނެތް ރަޓް ކަރްޑްސް އަދި.",
      "loadFailed": " ރަޓް ކަރްޑްސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "versions": "ވެރްސިއޮންސް",
      "versionsEmpty": "މި ކަރްޑް އެބަހުރި ނެތް ވެރްސިއޮންސް އަދި.",
      "openVersion": "ހުޅުވާ",
      "lines": "ރަޓެސް",
      "linesEmpty": "މި ވަރޝަން ޕްރިކެސް އެއްވެސްއެއްޗެއްނެތް އަދި.",
      "defaultRate": "ޑެފައުލްޓް",
      "editLines": "އެޑިޓްކުރޭ ރަޓެސް",
      "linesSaved": "ރަޓެސް ރައްކާކުރެވިއްޖެ",
      "linesFailed": "އެތަކެތި ރަޓެސް ކުރެވުނު ނޫން ވުން ރައްކާކުރެވިއްޖެ.",
      "publish": "ޕުބްލިށް",
      "published": "ވަރޝަން ޕުބްލިށެޑް",
      "publishFailed": "އެ ވަރޝަން ކުރެވުނު ނޫން ވުން ޕުބްލިށެޑް.",
      "windowNote": " ޖޮބް އީ ޕްރިކެޑް މެދުވެރިކޮށް ވަރޝަން ގައި މަޖުބޫރު މަތީގައި އޭގެ މަސައްކަތް ތާރީޚް, ނޫން ޓޮޑޭސް. އެ އީ ކީއްވެ ވެރްސިއޮންސް ކަރްރްޔް ވިންޑޯސް އެއަށްވުރެ ވުރެ ސިންގްލް މިހާރުގެ ފްލެގް.",
      "frozenNote": "މި ވަރޝަން އީ ޕުބްލިށެޑް, އެހެންކަމުން އޭގެ ރަޓެސް ވަނީ ފިކްސްޑް. ޖޮބްތައް ކުރިންވެސް ޕްރިކެޑް އަގައިންސްޓް އެ ލާޒިމު ސްޓޭ ޕްރިކެޑް އަގައިންސްޓް އެ — އުފައްދާ އާ ވަރޝަން އަށް ބަދަލު ކޮންއެއްޗެއް އީ ޗަރްގެޑް އިން މިހާރު މަތީގައި."
    },
    "vans": {
      "title": "ވަންސް",
      "description": "ކޮންއެއްޗެއް ކޮންމެ ވަން އީ މީންޓް އަށް ކަރްރްޔް, ކޮންއެއްޗެއް އެ އީ ކަރްރްޔިންގް, އަދި ކޮންއެއްޗެއް އެ ބޭނުން.",
      "registerTitle": "ވަންސް",
      "empty": "ނެތް ވަންސް އަދި.",
      "open": "ހުޅުވާ",
      "loadFailed": " ވަންސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "parLevels": "ޕަރް ލެވެލްސް",
      "parLevelsEmpty": "ނެތް ޕަރް ލެވެލްސް ވަނީ ސެޓް ށްޓަކައި މި ވަން.",
      "stock": "މަތީގައި ވަން",
      "stockEmpty": "މި ވަން އީ ހޮލްޑިންގް އެއްވެސްއެއްޗެއްނެތް.",
      "replenishment": "ރެޕްލެނިށްމެންޓް",
      "propose": "ޕްރޮޕޮސް ރެޕްލެނިށްމެންޓް",
      "replenishmentProposed": "ރެޕްލެނިށްމެންޓް ޕްރޮޕޮސެޑް",
      "replenishFailed": "އެ ރެޕްލެނިށްމެންޓް ކުރެވުނު ނޫން ވުން ޕްރޮޕޮސެޑް.",
      "countNote": "ކައުންޓިންގް ވަން އީ ސްޓޮކް ކައުންޓް, އަދި ސްޓޮކް އޯންސް ކައުންޓް ސެޝަންތައް — އެތާ އީ ނެތް ސެކޮންޑް ކައުންޓިންގް ސްކްރީން މިތާ.",
      "countLink": "ހުޅުވާ ކައުންޓް ސެޝަން"
    },
    "problems": {
      "title": "ޕްރޮބްލެމްސް",
      "description": " އުންޑެރްލްޔިންގް ފައުލްޓްސް ސެވެރަލް ކަސެސް ށަރް, އަދި ކްނޯން އެރްރޮރްސް އެ ފަރާތްތައް ބެކަމް.",
      "tableTitle": "ޕްރޮބްލެމްސް",
      "empty": "ނެތް ޕްރޮބްލެމްސް ރެކޯޑްކުރެވިފައި.",
      "loadFailed": " ޕްރޮބްލެމްސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "create": "ރެކޯޑް ޕްރޮބްލެމް",
      "created": "ޕްރޮބްލެމް ރެކޯޑްކުރެވިފައި",
      "createFailed": "އެ ޕްރޮބްލެމް ކުރެވުނު ނޫން ވުން ރެކޯޑްކުރެވިފައި.",
      "noCases": "އެއްވެސްއެއްޗެއްނެތް ލިންކެޑް",
      "noArticle": "ނޫން ވްރިޓްޓެން މައްޗަށް",
      "knownError": "ކްނޯން އެރްރޮރް"
    },
    "kb": {
      "deflectionTitle": "ކްނޯލެޑްގެބަސް ޑެފްލެކްޓިއޮން",
      "deflectionNote": "ހޯ އޮފްޓެން އަރްޓިކްލް އަންސްވެރެޑް ކެސްޓިއޮން ކުރިން އެ ބެކަމް ކަސް. ޕެރްކެންޓަގް އީ ސާވަރުގެ.",
      "deflectionEmpty": "ނެތް އަރްޓިކްލެސް އެބަހުރި ވެފައި ކިޔާ އަދި."
    }
  },
  "ess": {
    "routeTitles": {
      "profile": "އަހަރެންގެ ޕްރޮފައިލް",
      "payslips": "އަހަރެންގެ ޕޭސްލިޕްތައް",
      "payslip": "އަހަރެންގެ ޕޭސްލިޕް",
      "leave": "އަހަރެންގެ ޗުއްޓީ",
      "attendance": "އަހަރެންގެ ހާޒިރީ",
      "documents": "އަހަރެންގެ ލިޔުންތައް",
      "clock": "ކްލޮކް އިން އަދި އައުޓް",
      "employment": "އަހަރެންގެ ވަޒީފާގެ ތާރީޚު",
      "roster": "އަހަރެންގެ ރޯސްޓަރ",
      "serviceCharge": "އަހަރެންގެ ޚިދުމަތުގެ އަގު",
      "yearEnd": "އަހަރެންގެ އަހަރު ނިމުމުގެ ބަޔާންތައް"
    },
    "tabs": {
      "label": "ސެލްފް ސާވިސް",
      "profile": "ޕްރޮފައިލް",
      "payslips": "ޕޭސްލިޕްތައް",
      "leave": "ޗުއްޓީ",
      "attendance": "ހާޒިރީ",
      "documents": "ލިޔުންތައް",
      "timesheets": "ޓައިމްޝީޓްތައް",
      "clock": "ކްލޮކް",
      "employment": "ވަޒީފާ",
      "roster": "ރޯސްޓަރ",
      "serviceCharge": "ޚިދުމަތުގެ އަގު",
      "yearEnd": "އަހަރު ނިމުން"
    },
    "profile": {
      "title": "އަހަރެންގެ ޕްރޮފައިލް",
      "description": "އެޗްއާރުގައި ތިޔަ ބޭފުޅާގެ ރެކޯޑްގައި ހުރި މަޢުލޫމާތު، އަދި މުސާރަ ހިސާބުކުރުމުގައި ބޭނުންކުރާ މަޢުލޫމާތު.",
      "loadFailed": "ތިޔަ ބޭފުޅާގެ ރެކޯޑް ލޯޑެއް ނުވި",
      "identityTitle": "ތިޔަ ބޭފުޅާ",
      "employmentTitle": "ވަޒީފާ",
      "payTitle": "މުސާރަ",
      "permitTitle": "ވޯކް ޕަރމިޓް",
      "privateTitle": "ބޭންކާއި ޤާނޫނީ ތަފްޞީލު",
      "enrolled": "ބައިވެރިވެފައި",
      "notEnrolled": "ބައިވެރިވެފައެއް ނުވޭ",
      "salaryExplainer": "މިއީ ފުރިހަމަ މަހެއްގެ އަސާސީ މުސާރައެވެ. ފުރިހަމައަށް މަސައްކަތް ނުކުރެވުނު މަހެއް — މެދުތެރެއިން ވަޒީފާއަށް ވަނުން، ނުވަތަ މުސާރަ ނުލިބޭ ޗުއްޓީ — ދުވަހަށް ބަހާލައިގެން ދެއްކޭނެއެވެ. ބޭނުންކުރި ދުވަހުގެ އަދަދު ޕޭސްލިޕުން ފެންނާނެއެވެ.",
      "pensionableExplainer": "ތިޔަ ބޭފުޅާ ޕެންޝަން ސްކީމުގައި ބައިވެރިވެފައިވާތީ، ޕެންޝަނަށް ބެލެވޭ މުސާރައިން އެމްޕީއޭއޯގެ ބައި ހިސާބުކުރެވި ކޮންމެ ޕޭސްލިޕަކުން ފެންނާނެއެވެ.",
      "notPensionableExplainer": "ތިޔަ ބޭފުޅާ ޕެންޝަން ސްކީމުގައި ބައިވެރިވެފައި ނުވާތީ، މުސާރައިން އެމްޕީއޭއޯގެ ބައެއް ހިސާބެއް ނުކުރެވެއެވެ.",
      "permitExpired": "{days} ދުވަސް ކުރިން މުއްދަތު ހަމަވެއްޖެ",
      "permitDaysLeft": "{days} ދުވަސް ބާކީ",
      "permitExplainer": "މި ތާރީޚު ކައިރިވަމުން އަންނަ ވަރަކަށް އެޗްއާރަށް އެންގޭނެއެވެ. މިތާ އޮތް އަދަދު ގޯސްކަމަށް ފެންނަނަމަ، މުއްދަތު ހަމަވުމުގެ ކުރިން އެފަރާތަށް އަންގަވާ.",
      "maskedHeadline": "މި މަޢުލޫމާތު ބައެއް ފޮރުވިފައި ދައްކަނީ ގަސްދުގައެވެ",
      "maskedExplainer": "ބޭންކާއި ޤާނޫނީ ނަންބަރުތައް ރައްކާކުރެވިފައި ހުންނަނީ އެންކްރިޕްޓްކޮށެވެ. ތިޔަ ބޭފުޅާ ހިމެނޭ ގޮތުން އެއްވެސް ފަރާތަކަށް މި ޞަފުޙާއިން އެ ނަންބަރުތައް ނުފެންނާނެއެވެ. އެ ފެންނަ ހަމައެކަނި މަގަށް ޚާއްޞަ ހުއްދައެއް ބޭނުންވެ، ބެލި ފަރާތުގެ ނަމާއެކު އޮޑިޓް ރެކޯޑެއް ލިޔެވެއެވެ.",
      "changeExplainer": "މީގެ ތެރެއިން އެއްވެސް އެއްޗެއް ރަނގަޅުކުރަން އެޗްއާރަށް އަންގަވާ. ބޭންކް އެކައުންޓް ބަދަލުކުރުމަށް ދެ ފާސްކުރުމެއް ބޭނުންވެއެވެ.",
      "fields": {
        "fullName": "ނަން",
        "preferredName": "ކިޔާ ނަން",
        "employeeNo": "މުވައްޒަފު ނަންބަރު",
        "jobTitle": "ވަޒީފާގެ ނަން",
        "manager": "މެނޭޖަރު",
        "workEmail": "މަސައްކަތުގެ އީމެއިލް",
        "personalEmail": "އަމިއްލަ އީމެއިލް",
        "phone": "ފޯނު",
        "employmentStatus": "ސްޓޭޓަސް",
        "employmentType": "ވަޒީފާގެ ބާވަތް",
        "joinedOn": "ވަޒީފާއަށް ވަން ތާރީޚު",
        "leftOn": "ވަޒީފާއިން ވަކިވި ތާރީޚު",
        "nationality": "ޤައުމިއްޔަތު",
        "basicSalary": "އަސާސީ މުސާރަ",
        "pensionable": "ޕެންޝަން ސްކީމް",
        "workPermitNo": "ޕަރމިޓް ނަންބަރު",
        "workPermitExpiry": "މުއްދަތު ހަމަވާ ތާރީޚު",
        "bankName": "ބޭންކް",
        "bankAccountName": "އެކައުންޓްގެ ނަން",
        "bankAccountNo": "އެކައުންޓް ނަންބަރު",
        "bankIban": "އައިބޭން ނަންބަރު",
        "nationalId": "ދިވެހި ރައްޔިތެއްކަން އަންގައިދޭ ނަންބަރު",
        "taxId": "ޓެކްސް ނަންބަރު"
      }
    },
    "payslips": {
      "title": "އަހަރެންގެ ޕޭސްލިޕްތައް",
      "description": "ތިޔަ ބޭފުޅާއަށް ހަދާފައިވާ ހުރިހާ ޕޭސްލިޕެއް، އެންމެ ފަހުގެ ފުރަތަމަ.",
      "loadFailed": "ތިޔަ ބޭފުޅާގެ ޕޭސްލިޕްތައް ލޯޑެއް ނުވި",
      "emptyTitle": "އަދި ޕޭސްލިޕެއް ނެތް",
      "emptyDescription": "ތިޔަ ބޭފުޅާ ހިމެނޭ މުސާރައިގެ ރަނެއް ހިސާބުކުރުމާއެކު މިތާ ފެންނާނެއެވެ. މަސައްކަތްކުރި މަހެއް ނުފެންނަނަމަ މުސާރައިގެ އޮފިސަރަށް އަންގަވާ.",
      "provisionalHeadline": "މިތާ ފެންނަ ޕޭސްލިޕް އަދިވެސް ބަދަލުވެދާނެ",
      "provisionalExplainer": "ޕޭސްލިޕް ފެންނަން ފަށަނީ މުސާރަ ހިސާބުކުރުމާއެކުއެވެ. އެއީ ރަން ފާސްކުރުމުގެ އަދި ދެއްކުމުގެ ކުރިންނެވެ. ރަން ޕޯސްޓްކުރުމުން އަދަދުތައް ފައިނަލްވާނެއެވެ. އޭގެ ކުރިން މިއީ ދެއްކޭނެ ކަމަށް ބެލެވޭ ދެލިކޮޕީއެއް ކަމުގައި ބައްލަވާ.",
      "orderNote": "އެންމެ ފަހުގެ ފުރަތަމަ. އަދަދުތައް ހުރީ ތިޔަ ބޭފުޅާގެ މުސާރަ ރެކޯޑްކޮށްފައިވާ ފައިސާއިންނެވެ.",
      "exception": "ބަލަން ޖެހޭ",
      "columns": {
        "period": "މުއްދަތު",
        "payableDays": "މުސާރަ ލިބޭ ދުވަސް",
        "gross": "ޖުމުލަ",
        "deductions": "އުނިކުރުން",
        "net": "ސާފު މުސާރަ",
        "flag": "ފާހަގަ"
      }
    },
    "payslip": {
      "title": "އަހަރެންގެ ޕޭސްލިޕް",
      "description": "ކޮންމެ ބައެއް، އެ ހިސާބުކުރި އަސްލު، އަދި ނިކުތް އަދަދު.",
      "loadFailed": "މި ޕޭސްލިޕް ލޯޑެއް ނުވި",
      "backToList": "އަހަރެންގެ ހުރިހާ ޕޭސްލިޕެއް",
      "pdf": "ޕީޑީއެފް ޑައުންލޯޑްކުރޭ",
      "pdfWorking": "ތައްޔާރުކުރަނީ",
      "pdfPending": "ތިޔަ ބޭފުޅާގެ ޕޭސްލިޕް ތައްޔާރުކުރެވެނީއެވެ. ނިމުމުން މި ޞަފުޙާ އަޕްޑޭޓްވާނެއެވެ.",
      "pdfReady": "ޕޭސްލިޕް ތައްޔާރު",
      "pdfReadyDetail": "ޕީޑީއެފް ހަދައި މި ޕޭސްލިޕާއެކު ރައްކާކުރެވިއްޖެ.",
      "pdfFailed": "ޕޭސްލިޕް ހެދޭ ގޮތެއް ނުވި.",
      "headerTitle": "މުއްދަތު",
      "totalsTitle": "ޖުމުލަތައް",
      "traceDescription": "މުސާރައިގެ އޮފިސަރަށް ފެންނަ ހަމަ އެ ހިސާބުކުރުން. މި ޞަފުޙާގައި އެއްވެސް އެއްޗެއް ބްރައުޒަރުގައި އަލުން ހިސާބެއް ނުކުރެއެވެ.",
      "prorationExplainer": "މުއްދަތުގެ އަސާސީ މުސާރައަކީ މަހުގެ މުސާރަ ގުނަ މުސާރަ ލިބޭ ދުވަސް، މުއްދަތުގެ ދުވަހުން ބަހާލެވިފައެވެ. މުސާރަ ނުލިބޭ ޗުއްޓީން މުސާރަ ލިބޭ ދުވަސް މަދުވެއެވެ.",
      "exceptionHeadline": "މުސާރައިގެ ފަރާތުން މި ޕޭސްލިޕުގައި ކަމެއް ފާހަގަކޮށްފައިވޭ",
      "exceptionNoDetail": "ތަފްޞީލެއް ލިޔެފައެއް ނުވޭ. ފާހަގަކުރީ ކޮން ކަމެއްކަން މުސާރައިގެ އޮފިސަރާ އައްސަވާ.",
      "employerCostExplainer": "ވަޒީފާދޭ ފަރާތުގެ ޚަރަދަކީ ތިޔަ ބޭފުޅާގެ ޖުމުލަ މުސާރައިގެ އިތުރުން އެފަރާތުން ދައްކާ އެއްޗެކެވެ. އެއިން ތިޔަ ބޭފުޅާއަށް ލިބޭ އެއްޗެއް ދުވަހަކުވެސް މަދެއް ނުވެއެވެ.",
      "reconciles": "ތިރީގައިވާ {count} ސަތުރު މަތީގައިވާ ޖުމުލަތަކާ އެއްވަރުވެއެވެ.",
      "reconcileFailedHeadline": "ސަތުރުތަކާއި ޖުމުލަތައް އެއްގޮތެއް ނުވޭ",
      "reconcileFailed": "ސަތުރުތަކުން އާމްދަނީގެ ގޮތުގައި {earnings} އަދި އުނިކުރުމުގެ ގޮތުގައި {deductions} އައިސް، ނަތީޖާއަކީ {net} އެވެ.",
      "reconcileAuthority": "ބަލައިގަނެވޭ އަދަދުތަކަކީ މަތީގައިވާ ޖުމުލަތަކެވެ — ލެޖަރަށް ޕޯސްޓްކުރެވުނީ އެ އަދަދުތަކުންނެވެ. މި ޞަފުޙާ މުސާރައިގެ އޮފިސަރަށް ދައްކަވާ.",
      "disputeExplainer": "އަދަދެއް ގޯސްކަމަށް ފެންނަނަމަ، މަތީގައިވާ ހިސާބުކުރުމަށް އިޝާރާތްކުރައްވާ: އޭގައި ބައިގެ ނަން، ހިސާބުކުރި އަދަދު އަދި ބޭނުންކުރި ރޭޓް ހުންނާނެއެވެ.",
      "fields": {
        "period": "މުއްދަތު",
        "periodDays": "މުއްދަތުގެ ދުވަސް",
        "payableDays": "މުސާރަ ލިބޭ ދުވަސް",
        "unpaidLeaveDays": "މުސާރަ ނުލިބޭ ޗުއްޓީގެ ދުވަސް",
        "runNo": "މުސާރައިގެ ރަން",
        "gross": "ޖުމުލަ",
        "deductions": "އުނިކުރުން",
        "net": "ސާފު މުސާރަ",
        "employerCost": "ވަޒީފާދޭ ފަރާތުގެ ޚަރަދު"
      }
    },
    "leave": {
      "title": "އަހަރެންގެ ޗުއްޓީ",
      "description": "ބާކީ ހުރި ވަރު، އެދިފައިވާ ޗުއްޓީ، އަދި ނިންމުނު ގޮތް.",
      "loadFailed": "ތިޔަ ބޭފުޅާގެ ޗުއްޓީގެ އެދުންތައް ލޯޑެއް ނުވި",
      "balancesTitle": "އަހަރެންގެ ބާކީތައް",
      "balancesDescription": "މަހަކު އެއްފަހަރު ޖަމާވުމުން ކްރެޑިޓްވެ، ޗުއްޓީ ފާސްކުރެވުމުން މަދުވެއެވެ.",
      "balancesFailed": "ތިޔަ ބޭފުޅާގެ ބާކީތައް ލޯޑެއް ނުވި",
      "noBalancesTitle": "އަދި ބާކީއެއް ނެތް",
      "noBalancesDescription": "މަހަކު އެއްފަހަރު ޖަމާވުމުން ޗުއްޓީގެ ބާވަތެއް ކްރެޑިޓްކުރުމުން ބާކީ ފެންނާނެއެވެ. އަލަށް ވަޒީފާއަށް ވަން ފަރާތްތަކަށް އާންމުކޮށް ފެންނަނީ ފުރަތަމަ ފުރިހަމަ މަހަށްފަހުއެވެ.",
      "daysUnit": "ދުވަސް",
      "balanceExplainer": "މިއީ މިހާރު ހުރި ބާކީއެވެ. ނިންމުމަކަށް އިންތިޒާރުކުރާ އެދުމެއް އަދި މީގެން އުނިކޮށްފައެއް ނުވެއެވެ.",
      "filtersTitle": "ފިލްޓަރު",
      "historyTitle": "އަހަރެންގެ ޗުއްޓީގެ އެދުންތައް",
      "emptyTitle": "އަދި ޗުއްޓީގެ އެދުމެއް ނެތް",
      "emptyDescription": "މަތީގައިވާ ބަޓަނުން ޗުއްޓީއަށް އެދިވަޑައިގަންނަވާ. ތިޔަ ބޭފުޅާގެ މެނޭޖަރަށް އެފަރާތުގެ ފާސްކުރުމުގެ އިންބޮކްސްއިން ފެންނާނެއެވެ.",
      "ownOnly": "ހަމައެކަނި ތިޔަ ބޭފުޅާގެ އަމިއްލަ އެދުންތައް.",
      "paid": "ދައްކާފައި",
      "unpaid": "މުސާރަ ނުލިބޭ",
      "cancelled": "އެދުން ކެންސަލްކުރެވިއްޖެ",
      "cancelledDetail": "{requestNo} ކެންސަލްކުރެވި، ދުވަސްތައް ބާކީއަށް އަނބުރާ ދެވިއްޖެ.",
      "actions": {
        "request": "ޗުއްޓީއަށް އެދޭ"
      },
      "columns": {
        "requestNo": "އެދުން",
        "type": "ބާވަތް",
        "dates": "ތާރީޚުތައް",
        "days": "ދުވަސް",
        "paid": "ދައްކާފައި"
      },
      "cancelDialog": {
        "title": "މި ޗުއްޓީގެ އެދުން ކެންސަލްކުރޭ",
        "consequence": "ކެންސަލްކުރުމުން ދުވަސްތައް ބާކީއަށް އަނބުރާ ދެވޭނެއެވެ. ފުރަތަމަ ދުވަސް ފާއިތުވެފައިވާ އެދުމެއް މިތަނުން ކެންސަލެއް ނުކުރެވޭނެއެވެ — އެޗްއާރަށް އަންގަވާ.",
        "confirm": "އެދުން ކެންސަލްކުރޭ",
        "keep": "ބާއްވާ"
      },
      "fields": {
        "type": "ޗުއްޓީގެ ބާވަތް",
        "typePlaceholder": "ޗުއްޓީގެ ބާވަތެއް އިޚްތިޔާރުކުރޭ",
        "balance": "މިހާރު ހުރި ބާކީ",
        "startDate": "ޗުއްޓީގެ ފުރަތަމަ ދުވަސް",
        "endDate": "ޗުއްޓީގެ އެންމެފަހު ދުވަސް",
        "unpaid": "މުސާރަ ނުލިބޭ ޗުއްޓީ",
        "unpaidLabel": "މިއީ މުސާރަ ނުލިބޭ ޗުއްޓީއެއްގެ ގޮތުގައި ނަގާ",
        "unpaidHint": "މުސާރަ ނުލިބޭ ދުވަސްތަކުން މުސާރަ ބަހާލެވޭ ދުވަހުގެ އަދަދު މަދުވެއެވެ.",
        "reason": "ސަބަބު"
      },
      "form": {
        "title": "ޗުއްޓީއަށް އެދޭ",
        "description": "ދުވަސް ގުނަނީ ބާކީން އުނިކުރާ ގޮތަށެވެ: ކަލަންޑަރު ދުވަސް، ދެކޮޅު ހިމަނައިގެން.",
        "rangeInvalid": "އެންމެފަހު ދުވަސް ފުރަތަމަ ދުވަހުގެ ކުރިއަކަށް ނުވެވޭނެއެވެ.",
        "typeRequired": "ޗުއްޓީގެ ބާވަތެއް އިޚްތިޔާރުކުރޭ.",
        "daysCount": "{days} ކަލަންޑަރު ދުވަސް",
        "daysUnknown": "ފެށޭ އަދި ނިމޭ ތާރީޚެއް އިޚްތިޔާރުކުރޭ",
        "calendarDaysExplainer": "ހަފުތާ ބަންދާއި ސަރުކާރު ބަންދު ދުވަސްތައްވެސް ގުނެއެވެ: މި ވޯކްސްޕޭސްގައި ބަންދު ދުވަހުގެ ކަލަންޑަރެއް ނެތުމުން، ހަފުތާ ބަންދު ހިމެނޭ އެދުމަކުން އަތުން ގުނާ އަދަދަށްވުރެ ގިނަ ދުވަސް ޚަރަދުވެއެވެ.",
        "typeUnpaidHint": "{name} އަކީ މުސާރަ ނުލިބޭ ޗުއްޓީގެ ބާވަތެކެވެ — މި ދުވަސްތަކުން މުސާރަ ބަހާލެވޭ ދުވަހުގެ އަދަދު މަދުވެއެވެ.",
        "reasonHint": "މި ނިންމާ ފަރާތުން މި ކިޔާނެއެވެ.",
        "submit": "އެދުން ހުށަހަޅާ",
        "created": "ޗުއްޓީއަށް އެދިއްޖެ",
        "createdDetail": "{days} ދުވަހަށް ހުށަހެޅި {requestNo} ނިންމުމަކަށް އިންތިޒާރުކުރަނީއެވެ."
      }
    },
    "attendance": {
      "title": "އަހަރެންގެ ހާޒިރީ",
      "description": "ތިޔަ ބޭފުޅާއަށް ރެކޯޑްކުރެވިފައިވާ ދުވަސްތަކާއި، އެ ދުވަސްތަކުގެ އިތުރުގަޑި.",
      "loadFailed": "ތިޔަ ބޭފުޅާގެ ހާޒިރީ ލޯޑެއް ނުވި",
      "emptyTitle": "މި މަހު އެއްވެސް އެއްޗެއް ރެކޯޑްކޮށްފައެއް ނުވޭ",
      "emptyDescription": "ހާޒިރީ ލިޔެ ނުވަތަ އިމްޕޯޓްކުރަނީ ތިޔަ ބޭފުޅާގެ މެނޭޖަރެވެ. މަސައްކަތްކުރި ދުވަހެއް ނުފެންނަނަމަ، މުސާރައިގެ ރަން ބަންދުވުމުގެ ކުރިން އެފަރާތަށް އަންގަވާ.",
      "previousMonth": "ކުރީގެ މަސް",
      "nextMonth": "ދެން އޮތް މަސް",
      "thisMonth": "މި މަސް",
      "approvedYes": "ފާސްކުރެވިއްޖެ",
      "approvedNo": "އަދި ފާސްކޮށްފައެއް ނުވޭ",
      "approvalExplainer": "ދެއްކެނީ ހަމައެކަނި ފާސްކުރެވިފައިވާ އިތުރުގަޑިއެވެ. ފާސްނުކުރެވޭ ސަތުރަކީ އެ ދުވަހުގެ ރެކޯޑެކެވެ، ޙައްޤެއް ނޫނެވެ.",
      "noTotalExplainer": "މިތާ މަހުގެ ޖުމުލައެއް ނުދައްކަނީ ގަސްދުގައެވެ: ދެއްކޭ ގަޑިއިރަކީ ޕޭސްލިޕުގައި ހުންނަ ގަޑިއިރެވެ، އަދި އެ ހިސާބުކުރި ގޮތްވެސް ޕޭސްލިޕުން ފެންނާނެއެވެ.",
      "columns": {
        "date": "ތާރީޚު",
        "hours": "ގަޑިއިރު",
        "overtime": "އިތުރުގަޑި",
        "rule": "އިތުރުގަޑީގެ ގަވާއިދު",
        "source": "ރެކޯޑްކުރި ފަރާތް",
        "approved": "ފާސްކުރެވިފައި",
        "notes": "ނޯޓްތައް"
      }
    },
    "documents": {
      "title": "އަހަރެންގެ ލިޔުންތައް",
      "description": "އެޗްއާރުން ތިޔަ ބޭފުޅާގެ ފައިލްގައި ބަހައްޓާފައިވާ ލިޔުންތައް.",
      "loadFailed": "ތިޔަ ބޭފުޅާގެ ލިޔުންތައް ލޯޑެއް ނުވި",
      "emptyTitle": "އަދި ފައިލްގައި އެއްވެސް އެއްޗެއް ނެތް",
      "emptyDescription": "އެއްބަސްވުންތަކާއި ސިޓީތަކާއި ސެޓްފިކެޓްތައް މިތާ ލަނީ އެޗްއާރެވެ. އަމިއްލަ ފައިލަށް އަޕްލޯޑެއް ނުކުރެވޭނެއެވެ — އައު ލިޔުމެއް އެޗްއާރަށް ފޮނުއްވުމުން އެފަރާތުން ފައިލްކުރާނެއެވެ.",
      "downloading": "ތައްޔާރުކުރަނީ",
      "downloadFailed": "އެ ލިޔުން ނުހުޅުވުނު",
      "auditExplainer": "ކޮންމެ ޑައުންލޯޑެއް، ތިޔަ ބޭފުޅާގެ އަމިއްލަ ޑައުންލޯޑްވެސް ހިމެނޭ ގޮތުން، ނަމާއެކު ރެކޯޑްކުރެވެއެވެ. މިއީ ތިޔަ ބޭފުޅާގެ ފައިލެވެ؛ މި ޞަފުޙާއިން އެހެން ފަރާތަކަށް މި ނުފެންނާނެއެވެ.",
      "linkExpiryNote": "ކޮންމެ ޑައުންލޯޑް ލިންކެއް ހެދެނީ އެވަގުތު، އަދި ފަނަރަ މިނެޓް ފަހުން މަސައްކަތެއް ނުކުރާނެއެވެ.",
      "columns": {
        "filename": "ފައިލް",
        "note": "ނޯޓް",
        "size": "ސައިޒް",
        "added": "އިތުރުކުރި ތާރީޚު"
      }
    },
    "clock": {
      "actions": {
        "break_end": "ބްރޭކް ނިންމާ",
        "break_start": "ބްރޭކް ފަށާ",
        "in": "ކްލޮކް އިން",
        "out": "ކްލޮކް އައުޓް"
      },
      "corrects": "#{id} އިޞްލާޙުކުރަނީ",
      "description": "އެއް ބަޓަނެވެ. ހާލަތު އަންނަނީ ސާވަރުން، އެހެންކަމުން ކިއޮސްކަކުން ކުރެވުނު ޕަންޗެއްވެސް ގުނެއެވެ.",
      "kinds": {
        "break_end": "ބްރޭކް ނިމުން",
        "break_start": "ބްރޭކް ފެށުން",
        "in": "އިން",
        "out": "އައުޓް"
      },
      "loadFailed": "ތިޔަ ފަރާތުގެ ކްލޮކްގެ ހާލަތު ލޯޑެއް ނުކުރެވުނެވެ",
      "lockedExplainer": "މުސާރައިން މި މުއްދަތު ތަޅުލައިފިއެވެ. ތިޔަ ފަރާތުގެ ޕަންޗް ރެކޯޑްވެ، ތަޅު ހުޅުވުމުން ނެގޭނެއެވެ.",
      "punchesDescription": "ކޮންމެ ހަރަކާތެއް، ތަރުތީބުންނެވެ. އިޞްލާޙަކީ އައު އެންޓްރީއެއް — އަޞްލު ބާކީ ހުރެއެވެ.",
      "punchesEmptyDescription": "މިއަދުގެ ފުރަތަމަ ޕަންޗް މިތާ ފެންނާނެއެވެ.",
      "punchesEmptyTitle": "މިއަދު އަދި އެއްވެސް އެއްޗެއް ނެތެވެ",
      "punchesTitle": "މިއަދުގެ ޕަންޗްތައް",
      "recorded": "ރެކޯޑްކުރެވިއްޖެ",
      "rosteredHours": "ރޯސްޓަރކުރެވުނު",
      "states": {
        "in": "ކްލޮކް އިން ވެފައި",
        "out": "ކްލޮކް އައުޓް ވެފައި"
      },
      "title": "ކްލޮކް އިން އަދި އައުޓް",
      "todayTitle": "މިއަދު",
      "workedHours": "މަސައްކަތްކުރި"
    },
    "employment": {
      "columns": {
        "from": "އިން",
        "fte": "އެފްޓީއީ",
        "reason": "ސަބަބު",
        "salary": "އަސާސީ މުސާރަ",
        "to": "އަށް",
        "type": "ބާވަތް"
      },
      "current": "މިހާރުގެ",
      "description": "ތިޔަ ފަރާތުގެ އަމިއްލަ ޝަރުޠުތަކުގެ ކޮންމެ ވަރޝަނެއް، އެންމެ ފަހުގެ ފުރަތަމައަށެވެ.",
      "emptyDescription": "ތިޔަ ފަރާތުގެ ރެކޯޑަށް އަދި އެއްވެސް އެއްޗެއް ރެކޯޑްވެފައެއް ނުވެއެވެ.",
      "historyTitle": "ވަޒީފާގެ ތާރީޚު",
      "loadFailed": "ތިޔަ ފަރާތުގެ ވަޒީފާގެ ތާރީޚު ލޯޑެއް ނުކުރެވުނެވެ",
      "ongoing": "ކުރިއަށްދާ",
      "title": "އަހަރެންގެ ވަޒީފާގެ ތާރީޚު"
    },
    "roster": {
      "description": "ހަމައެކަނި ކިޔޭ ގޮތަށެވެ. ހުސް ދުވަހެއް ދައްކަނީ ހުސް ދުވަހެއްގެ ގޮތުގައި؛ ހުހަށް އޮތުމުން ރޭވިފައި އެއްވެސް އެއްޗެއް ނެތްކަން އެނގެއެވެ.",
      "from": "އިން",
      "loadFailed": "ތިޔަ ފަރާތުގެ ރޯސްޓަރ ލޯޑެއް ނުކުރެވުނެވެ",
      "nothingPlanned": "ރޭވިފައި އެއްވެސް އެއްޗެއް ނެތް",
      "plannedHours": "މި މުއްދަތުގައި {hours} ގަޑިއިރު ރޭވިފައިވެއެވެ.",
      "restDay": "ހުސް ދުވަސް",
      "title": "އަހަރެންގެ ރޯސްޓަރ",
      "to": "އަށް",
      "windowTitle": "މުއްދަތު"
    },
    "serviceCharge": {
      "allocationsTitle": "އަހަރެންގެ ބައިތައް",
      "columns": {
        "amount": "ޢަދަދު",
        "eligibleDays": "ޤާބިލު ދުވަސް",
        "points": "ޕޮއިންޓް",
        "pool": "ޕޫލް",
        "rawShare": "ސާފު ބައި",
        "rounding": "ރައުންޑްކުރުން",
        "weight": "ބުރަދަން"
      },
      "description": "ދޫކުރެވުނު ކޮންމެ ޕޫލެއްގެ ތިޔަ ފަރާތުގެ ބައި، އަދި އެ ނެގުނު ގޮތެވެ.",
      "distributedOnly": "ދައްކަނީ ދޫކުރެވިފައިވާ ޕޫލްތައް އެކަންޏެވެ. މުރާޖަޢާގައި އޮތް ޕޫލެއް ފައިނަލެއް ނޫނެވެ.",
      "emptyDescription": "ތިޔަ ފަރާތުގެ މުއްދަތު ހިމެނޭ ޕޫލެއް ދޫކުރެވުމުން، ތިޔަ ފަރާތުގެ ބައި މިތާ ފެންނާނެއެވެ.",
      "emptyTitle": "އަދި ބައެއް ނެތެވެ",
      "forfeited": "އެއް ޕޫލެއްގައި ތިޔަ ފަރާތަށް ބައެއް ރެކޯޑްވެފައެއް ނުވެއެވެ: {reason}",
      "loadFailed": "ތިޔަ ފަރާތުގެ ބެހުންތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "rawShareExplainer": "ސާފު ބައި އަކީ ރައުންޑްކުރުމުގެ ކުރީގެ ސީދާ ބައެވެ. ރައުންޑްކުރުމުގެ ކޮލަމަކީ ބެހުމުން ދިން ނުވަތަ ނެގި ލާރި، އެއީ ޕޫލްގެ ކޮންމެ ލާރިއެއް މީހަކަށް ނިސްބަތްވާ ގޮތަށެވެ.",
      "title": "އަހަރެންގެ ޚިދުމަތުގެ އަގު"
    },
    "yearEnd": {
      "actions": {
        "download": "ޕީޑީއެފް ޑައުންލޯޑްކުރޭ"
      },
      "columns": {
        "deductions": "އުނިކުރުންތައް",
        "gross": "ޖުމުލަ",
        "net": "ސާފު",
        "period": "މުއްދަތު"
      },
      "description": "ދޫކުރެވިފައިވާ ބަޔާންތައް އެކަންޏެވެ. ދެލިކޮޕީއަކީ މުސާރައިގެ ޓީމުން އަދިވެސް ބަލަމުންދާ ޢަދަދެކެވެ.",
      "emptyDescription": "ތިޔަ ފަރާތަށް އަދި ބަޔާނެއް ދޫކުރެވިފައެއް ނުވެއެވެ.",
      "loadFailed": "ތިޔަ ފަރާތުގެ ބަޔާންތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "statementTitle": "ޓެކްސް އަހަރު {year}",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "issued": "ދޫކުރެވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "title": "އަހަރެންގެ އަހަރު ނިމުމުގެ ބަޔާންތައް"
    }
  },
  "consol": {
    "filtersTitle": "ފިލްޓަރުތައް",
    "unknownCompany": "ކުންފުނީގެ ނަން ނޭނގޭ",
    "routeTitles": {
      "groups": "ކޮންސޮލިޑޭޝަން ގްރޫޕުތައް",
      "group": "ކޮންސޮލިޑޭޝަން ގްރޫޕް",
      "runs": "ކޮންސޮލިޑޭޝަން ރަންތައް",
      "run": "ކޮންސޮލިޑޭޝަން ރަން",
      "trialBalance": "ކޮންސޮލިޑޭޓެޑް ޓްރަޔަލް ބެލެންސް",
      "incomeStatement": "ކޮންސޮލިޑޭޓެޑް އާމްދަނީގެ ބަޔާން",
      "balanceSheet": "ކޮންސޮލިޑޭޓެޑް ބެލެންސް ޝީޓް",
      "eliminations": "އިލިމިނޭޝަން ހުށަހެޅުންތައް",
      "mismatches": "ކުންފުނިތަކުގެ މެދުގައި ހުރި ތަފާތުތައް",
      "readiness": "ކޮންސޮލިޑޭޝަނަށް ތައްޔާރުކަން",
      "accountMaps": "އެކައުންޓް މެޕިންގ",
      "adjustments": "ގްރޫޕް އެޑްޖަސްޓްމަންޓްތައް",
      "adjustment": "ގްރޫޕް އެޑްޖަސްޓްމަންޓް",
      "adjustmentNew": "އާ ގްރޫޕް އެޑްޖަސްޓްމަންޓެއް",
      "adjustmentEdit": "ގްރޫޕް އެޑްޖަސްޓްމަންޓް އެޑިޓްކުރުން",
      "statements": "ކޮންސޮލިޑޭޓެޑް ސްޓޭޓްމަންޓްތައް",
      "currencyTranslation": "ފައިސާ ޓްރާންސްލޭޝަން ތަޙުލީލު",
      "minorityInterest": "މައިނޯރިޓީ އިންޓަރެސްޓް ޝެޑިއުލް",
      "entityContribution": "ކުންފުނިތަކުގެ ބައިވެރިވުމުގެ ތަޙުލީލު"
    },
    "tabs": {
      "label": "މި ކޮންސޮލިޑޭޝަން ރަން",
      "overview": "ޚުލާޞާ",
      "trialBalance": "ޓްރަޔަލް ބެލެންސް",
      "incomeStatement": "އާމްދަނީގެ ބަޔާން",
      "balanceSheet": "ބެލެންސް ޝީޓް",
      "eliminations": "އިލިމިނޭޝަންތައް",
      "mismatches": "ތަފާތުތައް",
      "statements": "ކޭޝް ފްލޯ އާއި އިކުއިޓީ",
      "translation": "ފައިސާ ޓްރާންސްލޭޝަން",
      "minority": "މައިނޯރިޓީ އިންޓަރެސްޓް",
      "contribution": "ކުންފުނިތަކުގެ ބައިވެރިވުން",
      "adjustments": "ގްރޫޕް އެޑްޖަސްޓްމަންޓްތައް"
    },
    "rateKinds": {
      "closing": "ބަންދު",
      "opening": "ހުޅުވުން",
      "average": "އެވަރެޖް",
      "identity": "އެއް ފައިސާ"
    },
    "check": {
      "balanced": "ބެލެންސްވޭ",
      "unbalanced": "ބެލެންސްއެއް ނުވޭ"
    },
    "export": {
      "done": "އެކްސްޕޯޓް ތައްޔާރު",
      "doneDetail": "{file} ޑައުންލޯޑްވެއްޖެ. މި އެކްސްޕޯޓް އޮޑިޓް ރެކޯޑްގައި ލިޔެވިއްޖެ.",
      "failed": "އެކްސްޕޯޓް ނުހިނގި"
    },
    "groups": {
      "title": "ކޮންސޮލިޑޭޝަން ގްރޫޕުތައް",
      "one": "ކޮންސޮލިޑޭޝަން ގްރޫޕް",
      "description": "މައި ކުންފުނި، ރިޕޯޓް ހުށަހަޅާ ފައިސާ، އަދި ކޮން ދުވަސްވަރެއްގައި ކޮން ބައެއް މިލްކުވެރިވިކަން.",
      "loadFailed": "ގްރޫޕުތައް ލޯޑެއް ނުވި",
      "emptyTitle": "އަދި ކޮންސޮލިޑޭޝަން ގްރޫޕެއް ނެތް",
      "emptyDescription": "މައި ކުންފުންޏަށް ގްރޫޕެއް ހަދާ، މިލްކުވެރި އިންސައްތައާއި ފެށުނު ތާރީޚާއެކު ދަށު ކުންފުނިތައް އިތުރުކުރައްވާ، އަދި ރަނެއް ހިންގަވާ.",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން",
      "footerNote": "ގްރޫޕަކީ އޮނިގަނޑެކެވެ، ރިޕޯޓެއް ނޫނެވެ. އޭގެ އަދަދުތައް ހުންނަނީ ރަންތަކުގައެވެ.",
      "active": "ހިނގާ",
      "inactive": "ހުއްޓާލާފައި",
      "created": "ގްރޫޕް ހެދިއްޖެ",
      "saved": "ގްރޫޕް ރައްކާކުރެވިއްޖެ",
      "actions": {
        "add": "އައު ގްރޫޕް"
      },
      "columns": {
        "code": "ކޯޑް",
        "parent": "މައި ކުންފުނި",
        "currency": "ހުށަހަޅާ ފައިސާ"
      },
      "fields": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "parent": "މައި ކުންފުނި",
        "parentPlaceholder": "ކޮންސޮލިޑޭޓްކުރާ މައި ކުންފުނި އިޚްތިޔާރުކުރޭ",
        "currency": "ހުށަހަޅާ ފައިސާ",
        "currencyPlaceholder": "ފައިސާއެއް އިޚްތިޔާރުކުރޭ",
        "active": "ސްޓޭޓަސް",
        "activeLabel": "މި ގްރޫޕް އަދިވެސް ކޮންސޮލިޑޭޓްކުރެވެއެވެ"
      },
      "form": {
        "createTitle": "އައު ކޮންސޮލިޑޭޝަން ގްރޫޕް",
        "editTitle": "ކޮންސޮލިޑޭޝަން ގްރޫޕް އެޑިޓްކުރޭ",
        "description": "ގްރޫޕް ހެދުމަށްފަހު މައި ކުންފުންޏާއި ހުށަހަޅާ ފައިސާ ބަދަލެއް ނުކުރެވޭނެއެވެ.",
        "codeRequired": "ގްރޫޕަށް ކުރު ކޯޑެއް ދެއްވާ.",
        "nameRequired": "ގްރޫޕަށް ނަމެއް ދެއްވާ.",
        "parentRequired": "ކޮންސޮލިޑޭޓްކުރާ މައި ކުންފުނި އިޚްތިޔާރުކުރޭ.",
        "currencyRequired": "ރަންތައް ހުށަހަޅާނެ ފައިސާ އިޚްތިޔާރުކުރޭ.",
        "currencyExplainer": "ކޮންމެ މެންބަރެއްގެ ލެޖަރު މި ފައިސާއަށް ބަދަލުކުރެވެއެވެ: ބެލެންސް ޝީޓަށް ބަންދު ރޭޓް، އާމްދަނީއާއި ޚަރަދަށް އެވަރެޖް ރޭޓް. މެންބަރެއްގެ ފައިސާ ނޫން، ގްރޫޕުން ރިޕޯޓްކުރާ ފައިސާ އިޚްތިޔާރުކުރޭ.",
        "immutableExplainer": "ކޯޑް، މައި ކުންފުނި އަދި ހުށަހަޅާ ފައިސާ ބަދަލެއް ނުކުރެވޭނެއެވެ. މި ގްރޫޕުގެ ދަށުން މިހާތަނަށް ހިންގި ކޮންމެ ރަނެއް ބަދަލުކުރެވުނީ އެ ފައިސާއަށެވެ. އެ ބަދަލުކުރުމުން ހުރިހާ ރަނެއްގެ އަދަދު ބަދަލުވެގެންދާނެއެވެ."
      }
    },
    "group": {
      "description": "މެންބަރުންނާއި، ރަނަކުން އިންސައްތަ ނަގާ މިލްކުވެރިކަމުގެ ތާރީޚު.",
      "loadFailed": "މި ގްރޫޕް ލޯޑެއް ނުވި",
      "backToList": "ހުރިހާ ގްރޫޕެއް",
      "viewRuns": "މި ގްރޫޕުގެ ރަންތައް",
      "headerTitle": "ގްރޫޕް",
      "membersTitle": "މިލްކުވެރިކަމުގެ ތާރީޚު",
      "membersFooter": "ކޮންމެ ސަތުރަކީ އެއް ކުންފުނީގެ މެންބަރުކަމުގެ އެއް މުއްދަތެވެ. ސަތުރުތައް ދުވަހަކުވެސް ފުހެވިގެނެއް ނުދެއެވެ.",
      "noMembersTitle": "އަދި ދަށު ކުންފުންޏެއް ނެތް",
      "noMembersDescription": "މި ގްރޫޕުން ކޮންސޮލިޑޭޓްކުރާ ކުންފުނިތައް، މިލްކުވެރި އިންސައްތައާއި އެ އިންސައްތަ ފެށުނު ތާރީޚާއެކު އިތުރުކުރައްވާ. ރަނުގެ ތާރީޚު ނުހިމެނޭ ކުންފުންޏެއް އެއްގޮތަކަށްވެސް ކޮންސޮލިޑޭޓެއް ނުކުރެވޭނެއެވެ.",
      "presentationExplainer": "މި ގްރޫޕުގެ ރަންތައް ހުށަހަޅަނީ {currency} އިންނެވެ. ކޮންމެ މެންބަރެއްގެ ލެޖަރު ހުންނާނީ އެ ކުންފުނީގެ އަމިއްލަ ފައިސާއިންނެވެ؛ ބަދަލުކުރުން ހިނގަނީ ރަން ހިންގާ ވަގުތުއެވެ.",
      "historyHeadline": "މިއީ ތާރީޚެކެވެ، މިހާރުގެ ހާލަތެއް ނޫނެވެ",
      "historyExplainer": "ރަނަކުން ކޮންމެ ދަށު ކުންފުންޏެއްގެ އިންސައްތަ ނަގަނީ އެ ރަނުގެ އަމިއްލަ ތާރީޚަށެވެ، މިއަދުގެ ތާރީޚަކަށް ނޫނެވެ. ބަންދުވެފައިވާ ސަތުރުތައް މިތާ ބާއްވަނީ އެހެންވެއެވެ: ފާއިތުވި ކުއާޓަރެއް އަލުން ހިންގުމުން ކުރިންވެސް ނިކުތް އަދަދުތައް ނިކުންނަން ޖެހެއެވެ.",
      "checkReadiness": "ތައްޔާރުކަން ބަލާ",
      "mapAccounts": "އެކައުންޓްތައް މެޕްކުރޭ"
    },
    "members": {
      "inForce": "ހިނގަނީ",
      "added": "ދަށު ކުންފުނި އިތުރުކުރެވިއްޖެ",
      "addedDetail": "މެންބަރުކަމުގެ މުއްދަތުގެ ތެރޭގައި ތާރީޚު ހިމެނޭ ރަންތަކުން ކޮންސޮލިޑޭޓްކުރެވޭނެއެވެ.",
      "ownershipChanged": "މިލްކުވެރިކަން ބަދަލުކުރެވިއްޖެ",
      "actions": {
        "add": "ދަށު ކުންފުނި އިތުރުކުރޭ",
        "change": "މިލްކުވެރިކަން ބަދަލުކުރޭ"
      },
      "columns": {
        "company": "ކުންފުނި",
        "code": "ކޯޑް",
        "ownershipPct": "މިލްކުވެރި",
        "effectiveFrom": "އިން",
        "effectiveTo": "އަށް",
        "note": "ނޯޓް",
        "method": "ގޮތް"
      },
      "fields": {
        "company": "ދަށު ކުންފުނި",
        "companyPlaceholder": "ކުންފުންޏެއް އިޚްތިޔާރުކުރޭ",
        "ownershipPct": "މިލްކުވެރި އިންސައްތަ",
        "ownershipPctHint": "ސުމަކަށްވުރެ ބޮޑު، އަދި ގިނަވެގެން ސަތޭކަ. ހަތަރު ދަޝްމަލް ރައްކާކުރެވެއެވެ.",
        "effectiveFrom": "މިލްކުވެރިވި ތާރީޚު",
        "effectiveTo": "މިލްކުވެރިކަން ނިމޭ ތާރީޚު",
        "effectiveToHint": "ނިމޭ ތާރީޚު އެއްބަސްވެފައި ނުވާނަމަ ހުސްކޮށް ބަހައްޓަވާ.",
        "method": "ކޮންސޮލިޑޭޝަން ގޮތް",
        "methodHint": "މި މެންބަރުކަމުގެ މުއްދަތުގައި ރަންތަކުން މި މެންބަރު ކޮންސޮލިޑޭޓްކުރާ ގޮތް."
      },
      "form": {
        "title": "ދަށު ކުންފުންޏެއް އިތުރުކުރޭ",
        "description": "އިންސައްތައާއި ތާރީޚުތައް އެއްކޮށް ނިންމައިދެނީ ރަނަކުން ކޮންސޮލިޑޭޓްކުރާ އެއްޗެވެ.",
        "companyRequired": "ކޮންސޮލިޑޭޓްކުރާނެ ކުންފުނި އިޚްތިޔާރުކުރޭ.",
        "pctRequired": "މިލްކުވެރި އިންސައްތަ ލިޔުއްވާ.",
        "currencyHint": "{company} ގެ ހިސާބުތައް ބަހައްޓަނީ {currency} އިންނެވެ. ރަނަކުން އެ ގްރޫޕުގެ ހުށަހަޅާ ފައިސާއަށް ބަދަލުކުރެއެވެ.",
        "datesExplainer": "ރަނަކުން އިންސައްތަ ނަގަނީ އެ ރަނުގެ އަމިއްލަ ތާރީޚަށް ހިނގަމުންދިޔަ އިންސައްތައެވެ. އެ ތާރީޚު ނުހިމެނޭ ކުންފުންޏެއް ކޮންސޮލިޑޭޓެއް ނުކުރެވެއެވެ، އަދި މުއްދަތުގެ މެދުތެރެއިން ބައިވެރިވި ކުންފުންޏަކުން ހިމެނޭނީ ބައިވެރިވި ތާރީޚުން ފެށިގެން ލިބުނު ފައިދާއެވެ.",
        "ownershipRegisterHint": "މިލްކުވެރިކަން ބެހެއްޓެނީ އެންޓަރޕްރައިޒް ← ޤާނޫނީ ވިޔަފާރިތައް ← މިލްކުވެރިކަން ގައެވެ. ރަނަކުން އިންސައްތަ ނަގަނީ އެތަނުން، އެ ރަނުގެ އަމިއްލަ ތާރީޚަށެވެ.",
        "submit": "ދަށު ކުންފުނި އިތުރުކުރޭ"
      },
      "change": {
        "title": "މިލްކުވެރި އިންސައްތަ ބަދަލުކުރޭ",
        "currentPct": "މިހާރު މިލްކުވެރި",
        "newPct": "އައު އިންސައްތަ",
        "effectiveFrom": "އައު އިންސައްތަ ފެށޭ ތާރީޚު",
        "historyHeadline": "މިއިން އިތުރުވަނީ މުއްދަތެކެވެ؛ ކުރީގެ މުއްދަތެއް އެޑިޓެއް ނުވެއެވެ",
        "historyExplainer": "މިހާރު ހިނގާ މެންބަރުކަމުގެ ރެކޯޑް ބަންދުވަނީ ދެއްވި ތާރީޚުގެ ކުރީ ދުވަހުއެވެ، އަދި އައު އިންސައްތައިގައި އައު ރެކޯޑެއް ހުޅުވެއެވެ. ކުރީގެ މުއްދަތުގެ ތެރޭގައި ތާރީޚު ހިމެނޭ ރަންތަކުން އަދިވެސް ނަގާނީ ކުރީގެ އިންސައްތައެވެ — ފާއިތުވި ކުއާޓަރެއް ބަދަލެއް ނުވެ އަލުން ހިންގޭ ސަބަބަކީ އެއީއެވެ.",
        "submit": "ބަދަލު ރެކޯޑްކުރޭ"
      },
      "edit": {
        "title": "މެންބަރުކަން އެޑިޓްކުރޭ: {company}",
        "description": "ފެށޭ ތާރީޚު ބަދަލެއް ނުކުރެވޭނެ؛ މެންބަރު ދޫކޮށްލާއިރު ނިމޭ ތާރީޚެއް ކަނޑައަޅާ، ނުވަތަ ގޮތް ނުވަތަ ނޯޓު ރަނގަޅުކުރޭ.",
        "methodHint": "މި މެންބަރުކަމުގެ މުޅި މުއްދަތަށް އަމަލުކުރެވޭ. ތާރީޚަކުން ގޮތް ބަދަލުކުރަން، މި މުއްދަތު ނިންމާފައި އައު މުއްދަތެއް އިތުރުކުރޭ.",
        "endHint": "މެންބަރުކަން ހުޅުވާލާފައި ބަހައްޓަން ހުސްކޮށް ބަހައްޓާ. ތާރީޚު ފޮހެލުމުން އަލުން ހުޅުވޭނެ.",
        "endBeforeStart": "ނިމޭ ތާރީޚު ފެށޭ ތާރީޚުގެ ކުރިން ނުވާނެ.",
        "reloaded": "ތިބާ ހުޅުވާފައި ތިއްބަވަނިކޮށް އެހެން މީހަކު މި މެންބަރުކަން ބަދަލުކޮށްފި. އަލުން ލޯޑްކުރެވިއްޖެ؛ ބައްލަވާފައި އަލުން ރައްކާކުރައްވާ.",
        "saved": "މެންބަރުކަން ރައްކާކުރެވިއްޖެ"
      }
    },
    "runs": {
      "title": "ކޮންސޮލިޑޭޝަން ރަންތައް",
      "description": "ކޮންމެ ރަނަކީ ގްރޫޕުގެ ލެޖަރުތަކުގެ ބަދަލުކުރެވި ރައްކާކުރެވިފައިވާ އެއް ސްނެޕްޝޮޓެވެ.",
      "loadFailed": "ރަންތައް ލޯޑެއް ނުވި",
      "emptyTitle": "އަދި ކޮންސޮލިޑޭޝަން ރަނެއް ނެތް",
      "emptyDescription": "ގްރޫޕަކާއި ރިޕޯޓިންގ މުއްދަތެއް ދީގެން ރަނެއް ހިންގަވާ. އެއިން ކޮންމެ މެންބަރެއްގެ ލެޖަރު ބަދަލުކޮށް، މުއްދަތު ނިމޭ ތާރީޚަށް މިލްކުވެރިކަން ނަގައި، ކުންފުނިތަކުގެ މެދުގައި އިލިމިނޭޝަން ހުށަހަޅައެވެ.",
      "allGroups": "ހުރިހާ ގްރޫޕެއް",
      "noCrossRunTotal": "ސަތުރުތަކުގެ އަދަދުތައް އެއްކޮށްފައެއް ނުވެއެވެ: ދެ ރަން ދެ ފައިސާއިން ހުށަހަޅާފައި ހުރެދާނެއެވެ، އަދި ފުށުއަރާ މުއްދަތުތަކުން އެއް ފައިސާ ދެ ފަހަރު ގުނޭނެއެވެ.",
      "generated": "ރަން ހިންގިއްޖެ",
      "generatedDetail": "ސްނެޕްޝޮޓް ރައްކާކުރެވިއްޖެ. އިލިމިނޭޝަން ހުށަހެޅުންތައް ނިންމުމަކަށް އިންތިޒާރުކުރަނީއެވެ.",
      "actions": {
        "generate": "ރަން ހިންގާ"
      },
      "columns": {
        "window": "މުއްދަތު",
        "group": "ގްރޫޕް",
        "currency": "ހުށަހަޅާ ފައިސާ",
        "totalAssets": "ޖުމުލަ މުދާ",
        "equityAttributable": "އިކުއިޓީ — މައި ކުންފުނީގެ ހިއްސާދާރުން",
        "minorityInterest": "މައިނޯރިޓީ އިންޓަރެސްޓް",
        "cta": "ފައިސާ ބަދަލުކުރުމުގެ އެޖަސްޓްމަންޓް",
        "check": "ޗެކް"
      },
      "fields": {
        "group": "ގްރޫޕް",
        "groupPlaceholder": "ގްރޫޕެއް އިޚްތިޔާރުކުރޭ",
        "fiscalYear": "ފިސްކަލް އަހަރު",
        "period": "ރިޕޯޓިންގ މުއްދަތު",
        "periodHint": "މައި ކުންފުނީގެ ފިސްކަލް މުއްދަތު. އޭގެ ތާރީޚުތަކުން ރަނުގެ މުއްދަތު ކަނޑައަޅައެވެ.",
        "periodPlaceholder": "މުއްދަތެއް ޚިޔާރުކުރައްވާ"
      },
      "form": {
        "title": "ކޮންސޮލިޑޭޝަން ރަނެއް ހިންގާ",
        "description": "ރަނަކުން ކޮންސޮލިޑޭޓްކުރަނީ އެއް ރިޕޯޓިންގ މުއްދަތު: މައި ކުންފުނީގެ ފިސްކަލް މުއްދަތު، އޭގެ ތާރީޚުތަކުން މުއްދަތު ކަނޑައަޅައެވެ.",
        "groupRequired": "ކޮންސޮލިޑޭޓްކުރާނެ ގްރޫޕް އިޚްތިޔާރުކުރޭ.",
        "presentationHint": "{group} ހުށަހަޅަނީ {currency} އިންނެވެ. ކޮންމެ މެންބަރެއްގެ އަދަދުތައް އެއަށް ބަދަލުކުރެވެއެވެ.",
        "whatHappensHeadline": "ރަން ހިންގުމުން ވާނެ ގޮތް",
        "whatHappensTranslation": "ކޮންމެ މެންބަރެއްގެ ލެޖަރު ބަދަލުކުރެއެވެ: މުދަލާއި ދަރަނި އަދި ޕޯސްޓްކުރެވިފައިވާ އިކުއިޓީއަށް ބަންދު ރޭޓް، އާމްދަނީއާއި ޚަރަދަށް ދުވަހަށް ބަހާލެވުނު އެވަރެޖް ރޭޓް، އަދި ފަރަގު އިކުއިޓީގައި ފައިސާ ބަދަލުކުރުމުގެ އެޖަސްޓްމަންޓެއްގެ ގޮތުގައި ލިޔެވެއެވެ.",
        "whatHappensOwnership": "ރިޕޯޓް ތާރީޚަށް ކޮންމެ ދަށު ކުންފުންޏެއްގެ މިލްކުވެރި އިންސައްތަ ނަގައި، މުއްދަތުގެ ތެރޭގައި މިލްކުވެރިކަން ބަދަލުވެފައިވާނަމަ މުއްދަތު ބައިކޮށް، އެއިން މައިނޯރިޓީ އިންޓަރެސްޓް ނަގައެވެ.",
        "whatHappensEliminations": "ސެޓްކުރެވިފައިވާ ކޮންމެ ކުންފުނި ޖޯޑަކަށް އިލިމިނޭޝަނެއް ހުށަހަޅައެވެ. ފަރާތެއް ފާސްކުރުމުގެ ނުވަތަ ބޭރުކުރުމުގެ ކުރިން އެއިން އެއްވެސް އެއްޗެއް ނުނިމެއެވެ.",
        "whatHappensSnapshot": "ނަތީޖާ ސްނެޕްޝޮޓެއްގެ ގޮތުގައި ރައްކާކުރެއެވެ. ފަހުން ލެޖަރަށް ގެނެވުނު ރަނގަޅުކުރުމެއް ދައްކަން ބޭނުންނަމަ އައު ރަނެއް ހިންގަވާ — މި ރަން އެޑިޓެއް ނުކުރެވެއެވެ.",
        "generating": "ކޮންސޮލިޑޭޓްކުރަނީ",
        "submit": "ހިންގާ",
        "periodRequired": "ކޮންސޮލިޑޭޓްކުރާނެ ރިޕޯޓިންގ މުއްދަތު ޚިޔާރުކުރައްވާ.",
        "openReadiness": "ތައްޔާރުނުވާ ކަންކަން ބަލާ",
        "openAccountMaps": "މި އެކައުންޓްތައް މެޕްކުރޭ",
        "noPeriodPermission": "ފިސްކަލް މުއްދަތުތައް ލިސްޓުކުރުމަށް ފިސްކަލް މުއްދަތުތައް ކިޔުމުގެ ހުއްދަ ބޭނުންވޭ.",
        "windowHint": "{from} އިން ފެށިގެން އާމްދަނީއާއި ޚަރަދު؛ {to} ގެ ބާކީތައް.",
        "whatHappensReadiness": "ފުރަތަމަ ތައްޔާރުކަން ބަލައެވެ: ކޮންމެ މެންބަރެއްގެ މުއްދަތު ބަންދުކުރެވި ސެޓްފައިކުރެވިފައި، ކުންފުނިތަކުގެ މެދު ތަފާތު ޓޮލަރެންސްގެ ތެރޭގައި، އަދި ބާކީއެއް ހުރި ކޮންމެ އެކައުންޓެއް ގްރޫޕް ޗާޓަށް މެޕްކުރެވިފައި."
      },
      "allStatuses": "ހުރިހާ ސްޓޭޓަސްތައް",
      "restates": "ރަން #{id} ރިސްޓޭޓްކުރެއްވި",
      "supersededBy": "ރަން #{id} އިން ބަދަލުކުރެވިފައި"
    },
    "run": {
      "title": "ކޮންސޮލިޑޭޝަން ރަން",
      "description": "މި ރަނުން ނިކުތް އެއްޗާއި، އެ ނިކުތް ރޭޓްތަކާއި އިންސައްތަތައް.",
      "loadFailed": "މި ރަން ލޯޑެއް ނުވި",
      "backToList": "ހުރިހާ ރަނެއް",
      "headerTitle": "ރަން",
      "totalsTitle": "ގްރޫޕުގެ ޖުމުލަތައް",
      "noEntities": "މި ރަނުގައި އެއްވެސް ކުންފުންޏެއް ނުހިމެނެއެވެ. އެއްވެސް މެންބަރެއްގެ މެންބަރުކަމުގެ މުއްދަތުގައި ރިޕޯޓް ތާރީޚު ނުހިމެނެއެވެ.",
      "snapshotHeadline": "ރަނަކީ ސްނެޕްޝޮޓެކެވެ، ދިރިހުރި ރިޕޯޓެއް ނޫނެވެ",
      "snapshotExplainer": "މި އަދަދުތައް ހިސާބުކުރެވުނީ ރަން ހިންގި ވަގުތު އެއް ފަހަރުއެވެ، އަދި ލެޖަރު ބަދަލުވުމުން މި ބަދަލެއް ނުވެއެވެ. ބަޔާންތަކުން ފެންނަ އެއްޗެއް ބަދަލުކުރަނީ ހަމައެކަނި އިލިމިނޭޝަން ނިންމުންތަކެވެ، އަދި އެއިން ބަދަލުވަނީ ބަޔާންތަކެވެ، މި ޖުމުލަތަކެއް ނޫނެވެ.",
      "ctaHeadline": "ފައިސާ ބަދަލުކުރުމުގެ އެޖަސްޓްމަންޓާ ބެހޭގޮތުން",
      "ctaExplainer": "ބެލެންސް ޝީޓް ބަދަލުކުރެވެނީ ބަންދު ރޭޓުން، އަދި އާމްދަނީ ބަދަލުކުރެވެނީ އެވަރެޖް ރޭޓުން ކަމަށްވާތީ، މެންބަރެއްގެ ބެލެންސްވެފައިވާ ޓްރަޔަލް ބެލެންސް ބަދަލުކުރުމަށްފަހު ބެލެންސްއެއް ނުވެއެވެ. އެ ފަރަގަކީ ފައިސާ ބަދަލުކުރުމުގެ ޖުމުލަ އެޖަސްޓްމަންޓެވެ، އަދި އެ ހިސާބުކުރެވެނީ ވަކިވަކި ހަތަރު އަދަދަކުން، ބެލެންސް ޝީޓް ބެލެންސްކުރުމަށް ހޮވައިގެންނެއް ނޫނެވެ.",
      "ctaRateExplainer": "ޕޯސްޓްކުރެވިފައިވާ އިކުއިޓީ — ހިއްސާގެ ރައުސުލްމާލު ފަދަ — ބަދަލުކުރެވެނީ ބަންދު ރޭޓުން ނޫން، ހުޅުވުމުގެ ރޭޓުންނެވެ: ތާރީޚީ ހިއްސާއެއް މިއަދުގެ ރޭޓަށް އަގު ބަދަލެއް ނުވެއެވެ. މި ރޭޓް ގޯސްވުން ބެލެންސް ޗެކުން ނުފެންނާނެއެވެ، ސަބަބަކީ ދެގޮތުންވެސް އެޖަސްޓްމަންޓުން އެ ފަރަގު ދަމައިގަންނާތީއެވެ.",
      "unbalancedHeadline": "މި ރަން ބެލެންސްއެއް ނުވެއެވެ",
      "unbalancedDetail": "މުދާ {debit}، ދަރަންޏާއި އިކުއިޓީ {credit}، ފަރަގަކީ {difference} އެވެ. ކޮންސޮލިޑޭޓެޑް ބެލެންސް ޝީޓުން ގޯސް އަދަދެއް ދެއްކުމުގެ ބަދަލުގައި ދެއްކުމަށް އިންކާރުކުރާނެއެވެ.",
      "fields": {
        "window": "މުއްދަތު",
        "currency": "ހުށަހަޅާ ފައިސާ",
        "generatedAt": "ހިންގި ވަގުތު",
        "check": "ޗެކް",
        "totalAssets": "ޖުމުލަ މުދާ",
        "totalLiabilities": "ޖުމުލަ ދަރަނި",
        "equityAttributable": "އިކުއިޓީ — މައި ކުންފުނީގެ ހިއްސާދާރުން",
        "minorityInterest": "މައިނޯރިޓީ އިންޓަރެސްޓް",
        "cta": "ފައިސާ ބަދަލުކުރުމުގެ އެޖަސްޓްމަންޓް",
        "netIncomeAttributable": "ސާފު އާމްދަނީ — މައި ކުންފުނީގެ ހިއްސާދާރުން",
        "netIncomeMinority": "ސާފު އާމްދަނީ — މައިނޯރިޓީ އިންޓަރެސްޓް"
      },
      "reportsTitle": "ރިޕޯޓްތަކާއި އެޑްޖަސްޓްމަންޓްތައް",
      "reports": {
        "statements": "ކޭޝް ފްލޯ ސްޓޭޓްމަންޓާއި އިކުއިޓީގެ ބަދަލުތަކުގެ ސްޓޭޓްމަންޓް، ކޮންމެއަކީވެސް ރީކޮންސައިލްކުރެވިފައި.",
        "translation": "ކޮންމެ ކުންފުނިއެއްގެ ރޭޓްތަކާއި ދެ ފައިސާގައިވެސް ބެލެންސްތަކާއި ޓްރާންސްލޭޝަން ރިޒަވް.",
        "minority": "ކޮންމެ މެންބަރެއްގެ ނެޓް މުދަލާއި ނަތީޖާގެ ކޮންޓްރޯލް ނުކުރާ ބައި.",
        "contribution": "ގްރޫޕްގެ އާމްދަނީއާއި ފައިދާއާއި ނެޓް މުދަލަށް ކޮންމެ ކުންފުނިއެއްގެ ބައިވެރިވުން.",
        "adjustments": "{approved} ފާސްކުރެވިފައި، {pending} އަދި ފާސްކުރެވިފައެއް ނުވޭ."
      }
    },
    "entity": {
      "parentSubtitle": "{code} — ކޮންސޮލިޑޭޓްކުރާ މައި ކުންފުނި",
      "subsidiarySubtitle": "{code} — ރިޕޯޓް ތާރީޚަށް {pct}% މިލްކުވެރި",
      "ctaIdentity": "ފައިސާ ބަދަލުކުރުމުގެ އެޖަސްޓްމަންޓަކީ ބަންދު ރޭޓުން ސާފު މުދާ، އެއިން ހުޅުވުމުގެ ރޭޓުން ޕޯސްޓްކުރެވިފައިވާ އިކުއިޓީ، އެއިން ހުޅުވުމުގެ ރޭޓުން ކުރިން ގެނެވުނު ފައިދާ، އަދި އެއިން އެވަރެޖް ރޭޓުން މި މުއްދަތުގެ ނަތީޖާ އުނިކުރުމުންނެވެ. މަތީގައިވާ ހަތަރު އަދަދަކީ އެ އަދަދުތަކެވެ؛ އެޖަސްޓްމަންޓަކީ ސާވަރުގެ އަމިއްލަ އަދަދެވެ.",
      "periodsExplainer": "މި މުއްދަތުގެ ތެރޭގައި މިލްކުވެރިކަން ބަދަލުވެފައިވާތީ، ބަދަލުވި ހިސާބުން ނަތީޖާ ބައިކުރެވި، މައިނޯރިޓީ ބައި މުއްދަތުން މުއްދަތަށް ބަހާލެވިފައިވެއެވެ.",
      "oneRateCaveat": "މުޅި މުއްދަތަށް އެއް އެވަރެޖް ރޭޓް ބޭނުންކުރެވެއެވެ، ކޮންމެ މުއްދަތަކަށް ވަކި ރޭޓެއް ނޫނެވެ. މިއީ ލިޔެވިފައިވާ ސާދާކުރުމެކެވެ، ރައުންޑިންގގެ ސަބަބުން ވާ ކަމެއް ނޫނެވެ.",
      "fields": {
        "baseCurrency": "ހިސާބު ބަހައްޓަނީ",
        "ownershipPct": "ރިޕޯޓް ތާރީޚަށް މިލްކުވެރި",
        "closingRate": "ބަންދު ރޭޓް",
        "averageRate": "އެވަރެޖް ރޭޓް",
        "openingRate": "ހުޅުވުމުގެ ރޭޓް"
      },
      "columns": {
        "figure": "އަދަދު",
        "rateUsed": "ބޭނުންކުރި ރޭޓް",
        "local": "އަމިއްލަ ({currency})",
        "translated": "ބަދަލުކުރެވިފައި ({currency})",
        "ownershipPct": "މިލްކުވެރި",
        "periodFrom": "އިން",
        "periodTo": "އަށް",
        "periodNetIncome": "ނަތީޖާ ({currency})",
        "periodMinority": "މައިނޯރިޓީ ބައި ({currency})"
      },
      "rows": {
        "assets": "މުދާ",
        "liabilities": "ދަރަނި",
        "netAssets": "ސާފު މުދާ",
        "equityPosted": "ޕޯސްޓްކުރެވިފައިވާ އިކުއިޓީ",
        "priorPnl": "ކުރިން ގެނެވުނު ފައިދާ",
        "netIncome": "މުއްދަތުގެ ނަތީޖާ",
        "cta": "ފައިސާ ބަދަލުކުރުމުގެ އެޖަސްޓްމަންޓް",
        "minorityEquity": "ސާފު މުދަލުން މައިނޯރިޓީ ބައި",
        "minorityIncome": "ނަތީޖާއިން މައިނޯރިޓީ ބައި"
      }
    },
    "statement": {
      "generatedAt": "ތައްޔާރުކުރި ވަގުތު",
      "emptySection": "މި ބައިގައި އެއްވެސް އެއްޗެއް ނެތް.",
      "groupingHeadline": "ހިސާބުތައް ކުންފުނިން ކުންފުންޏަށް ބަހާލެވިފައި، އެއްކޮށްފައެއް ނުވޭ",
      "groupingExplainer": "މި ވޯކްސްޕޭސްގައި ކުންފުނިތަކުގެ މެދުގައި ހިސާބުތަކުގެ މެޕިންގއެއް ނެތުމުން، ދެ މެންބަރެއްގެ އެއް ނަމެއް ކިޔާ ހިސާބުތަކަކީ ދެ ތަފާތު ހިސާބެވެ. އެ ދޭތި އެއްކުރުމަކީ އެއްވެސް ފަރާތަކުން ފާސްނުކުރާ މެޕިންގއެއް އުފެއްދުމެވެ.",
      "roundingHeadline": "ބައެއްގެ ޖުމުލައާއި އޭގެ ސަތުރުތަކާ ދެމެދު ލާރިއެއްގެ ފަރަގެއް ހުރެދާނެ",
      "roundingExplainer": "ބައެއްގެ ޖުމުލައަކީ ކޮންމެ ކުންފުންޏެއްގެ މުޅި ބާކީއަށް އެއް ފަހަރު ފައިސާ ބަދަލުކުރުމުން ނިކުންނަ އަދަދެވެ، ނަމަވެސް ކޮންމެ ސަތުރެއް ބަދަލުކުރެވި ރައުންޑްކުރެވިފައިވަނީ ވަކިވަކިންނެވެ. ގިނަ ފައިސާގެ ކޮންސޮލިޑޭޝަނުގައި މި ދެ މަގުން ލާރިއެއްގެ ފަރަގު އަތުވެދާނެއެވެ. މިއީ ޢާންމު އަދި ރަނގަޅު ކަމެކެވެ، އަދި އެ ފޮރުވުމަށް އެއްވެސް އަދަދެއް ބަދަލެއް ނުކުރެވެއެވެ.",
      "drillExplainer": "ހިސާބަކަށް ފިތާލުމުން ހުޅުވެނީ އެ ކުންފުނީގެ އަމިއްލަ ލެޖަރެވެ، އެ ކުންފުނީގެ އަމިއްލަ ފައިސާއިން، މި ރަނުން ބަދަލުކުރި މުއްދަތަށެވެ.",
      "columns": {
        "accountCode": "ކޯޑް",
        "account": "ހިސާބު",
        "amount": "އަދަދު ({currency})"
      }
    },
    "trialBalance": {
      "title": "ކޮންސޮލިޑޭޓެޑް ޓްރަޔަލް ބެލެންސް",
      "description": "ކޮންމެ މެންބަރެއްގެ ޕޯސްޓްކުރެވިފައިވާ ކޮންމެ ހިސާބެއް، މި ރަނުން ލިޔުނު ގޮތަށް ބަދަލުކުރެވިފައި.",
      "loadFailed": "ޓްރަޔަލް ބެލެންސް ލޯޑެއް ނުވި",
      "debit": "ޖުމުލަ ޑެބިޓް",
      "credit": "ޖުމުލަ ކްރެޑިޓް",
      "emptyExplainer": "މި ރަނުގައި ސަތުރެއް ނެތެވެ، އެއީ އެއްވެސް ކުންފުންޏެއް ނުހިމެނޭތީއެވެ.",
      "rateHeadline": "ރޭޓް ކޮލަމް ކިޔުއްވާ",
      "rateExplainer": "މުދަލާއި ދަރަނި ބޭނުންކުރަނީ ބަންދު ރޭޓެވެ؛ ޕޯސްޓްކުރެވިފައިވާ އިކުއިޓީ ބޭނުންކުރަނީ ހުޅުވުމުގެ ރޭޓެވެ؛ އާމްދަނީއާއި ޚަރަދު ބޭނުންކުރަނީ އެވަރެޖް ރޭޓެވެ. ގޯސް ރޭޓަކުން ބަދަލުކުރެވިފައިވާ ހިއްސާގެ ރައުސުލްމާލުގެ ސަތުރެއް ޖުމުލައިން ބަލާއިރު އާދައިގެ ގޮތަކަށް ފެންނާނެއެވެ، ސަބަބަކީ އެ ފަރަގު އެޖަސްޓްމަންޓުން ދަމައިގަންނާތީއެވެ — އެ ފެންނާނީ ރޭޓް ކޮލަމުންނެވެ.",
      "syntheticExplainer": "ކުރިން ގެނެވުނު ފައިދާއާއި ފައިސާ ބަދަލުކުރުމުގެ އެޖަސްޓްމަންޓް ސަތުރުތައް ހިސާބުކުރަނީ ރަނުންނެވެ، އެއްވެސް ލެޖަރަކުން ކިޔައިގެންނެއް ނޫނެވެ. ރިޕޯޓް ސުމަކަށް ދާން މެދުވެރިވަނީ އެ ދޭއްޗެވެ، އަދި އެއަށް ހުޅުވޭނެ ހިސާބެއް ނެތެވެ.",
      "drillCurrencyExplainer": "ހިސާބަކަށް ފިތާލުމުން ހުޅުވެނީ އެ ކުންފުނީގެ އަމިއްލަ ލެޖަރެވެ. އެ ހުންނާނީ ކުންފުނީގެ އަމިއްލަ ފައިސާއިން — މިތާ ހުރި އަމިއްލަ އަދަދުގެ ކޮލަމުން — ބަދަލުކުރެވިފައިވާ އަދަދުން ނޫނެވެ.",
      "columns": {
        "rateKind": "ރޭޓް",
        "rateUsed": "ބޭނުންކުރި ރޭޓް",
        "local": "އަމިއްލަ އަދަދު",
        "gross": "ބަދަލުކުރެވިފައި ({currency})",
        "elimination": "އުނިކުރެވުނު",
        "net": "ސާފު"
      }
    },
    "incomeStatement": {
      "title": "ކޮންސޮލިޑޭޓެޑް އާމްދަނީގެ ބަޔާން",
      "description": "ގްރޫޕުގެ އާމްދަނީއާއި ޚަރަދު، މުއްދަތުގެ އެވަރެޖް ރޭޓުން ބަދަލުކުރެވިފައި.",
      "loadFailed": "އާމްދަނީގެ ބަޔާން ލޯޑެއް ނުވި",
      "summaryTitle": "ނަތީޖާ",
      "detailTitle": "ތަފްޞީލު",
      "averageRateExplainer": "އާމްދަނީއާއި ޚަރަދު ބަދަލުކުރެވެނީ މުއްދަތުގެ ދުވަހަށް ބަހާލެވުނު އެވަރެޖް ރޭޓުންނެވެ. މި ބަޔާނުގައި މުއްދަތެއް އޮވެ، ބެލެންސް ޝީޓުގައި އެންމެ ތާރީޚެއް އޮންނަނީ އެހެންވެއެވެ.",
      "splitExplainer": "މައި ކުންފުނީގެ ހިއްސާދާރުންނާއި މައިނޯރިޓީ އިންޓަރެސްޓާ ދެމެދު ބެހިފައިވަނީ ރަނުގެ އަމިއްލަ އަދަދުންނެވެ، ކޮންމެ މެންބަރެއްގެ ނަތީޖާއާއި ހިނގަމުންދިޔަ މިލްކުވެރިކަމުންނެވެ. ތިރީގައިވާ ސަތުރުތަކުން އަލުން ހިސާބުކޮށްފައެއް ނުވެއެވެ."
    },
    "balanceSheet": {
      "title": "ކޮންސޮލިޑޭޓެޑް ބެލެންސް ޝީޓް",
      "description": "ރަނުގެ ރިޕޯޓް ތާރީޚަށް ގްރޫޕުގެ މުދަލާއި ދަރަންޏާއި އިކުއިޓީ.",
      "loadFailed": "ބެލެންސް ޝީޓް ލޯޑެއް ނުވި",
      "asOf": "ތާރީޚަށް",
      "summaryTitle": "ޖުމުލަތައް",
      "detailTitle": "ތަފްޞީލު",
      "checkHeadline": "ބެލެންސްވުމަކީ ބަދަލުކުރުން ރަނގަޅުކަމުގެ ހެއްކެއް ނޫން",
      "checkExplainer": "ފައިސާ ބަދަލުކުރުމުގެ އެޖަސްޓްމަންޓް އޮންނަނީ އިކުއިޓީގައި ކަމަށްވެފައި، ރޭޓްތަކުން ނިކުންނަ ކޮންމެ ފަރަގެއް އެއިން ދަމައިގަންނާތީ، ދެގޮތުންވެސް މި ޝީޓް ބެލެންސްވާނެއެވެ. ކޮންމެ އަދަދަކަށް ބޭނުންކުރި ރޭޓާއި، ކޮންމެ ކުންފުންޏެއްގެ އެޖަސްޓްމަންޓް ފަހަތުގައިވާ ހަތަރު އަދަދު ހުރީ ރަނުގެ ޚުލާޞާ ޞަފުޙާގައެވެ — ގޯސް ރޭޓެއް ފެންނާނީ އެތަނުންނެވެ.",
      "eliminationExplainer": "މުދަލާއި ދަރަނީގެ ސަތުރުތައް ދައްކަނީ މިހާތަނަށް ފާސްކުރެވިފައިވާ އިލިމިނޭޝަން ހުށަހެޅުންތައް އުނިކުރުމަށްފަހުއެވެ. އެއިން އެއްޗެއް ފާސްކުރުމުން ނުވަތަ ބޭރުކުރުމުން މި ޞަފުޙާ ވަގުތުން ބަދަލުވެއެވެ؛ ރަން އަލުން ހިންގާކަށް ނުޖެހެއެވެ.",
      "syntheticExplainer": "ބާކީ ފައިދާ، ފައިސާ ބަދަލުކުރުމުގެ އެޖަސްޓްމަންޓް އަދި މައިނޯރިޓީ އިންޓަރެސްޓް ހިސާބުކުރަނީ ރަނުންނެވެ، ލެޖަރަކުން ކިޔައިގެންނެއް ނޫނެވެ، އަދި ދައްކަނީ އަރިއަށް ލެނބިފައިވާ އަކުރުންނެވެ."
    },
    "eliminations": {
      "title": "އިލިމިނޭޝަން ހުށަހެޅުންތައް",
      "description": "ކޮންމެ ކުންފުންޏަކުން އަނެއް ކުންފުނިން ލިބެންޖެހޭ ކަމަށް ބުނާ އަދަދާއި، އުނިކުރަންވީ އަދަދު.",
      "loadFailed": "ހުށަހެޅުންތައް ލޯޑެއް ނުވި",
      "emptyTitle": "އިލިމިނޭޝަން ހުށަހެޅުމެއް ނެތް",
      "emptyDescription": "މި ރަނުގައި ދެ ކުންފުނިވެސް ހިމެނޭ، ސެޓްކުރެވިފައިވާ ކޮންމެ ހިސާބު ޖޯޑަކަށް ހުށަހެޅުމެއް އުފެދެއެވެ. އެއްވެސް އެއްޗެއް ނުފެންނަނަމަ، އަދި ކުންފުނި ޖޯޑެއް މެޕްކޮށްފައެއް ނުވެއެވެ.",
      "headline": "ހުށަހެޅުމަކީ ހަމައެކަނި ހުށަހެޅުމެކެވެ",
      "explainer": "ފަރާތެއް ފާސްކުރުމުގެ ކުރިން އެއްވެސް އެއްޗެއް އުނިއެއް ނުވެއެވެ. ފާސްކުރުމުން، ކޮންސޮލިޑޭޓެޑް ބަޔާންތަކުގައި ގުޅޭ މުދަލާއި ދަރަނީގެ ސަތުރުތަކުން އެއްބަސްވެވުނު އަދަދު ވަގުތުން އުނިވެއެވެ، ރަން އަލުން ހިންގާކަށް ނުޖެހެއެވެ.",
      "translationExplainer": "އަޅާކިޔުމުގެ ކުރިން ދެ ފަރާތްވެސް ރަނުގެ ހުށަހަޅާ ފައިސާއަށް ބަދަލުކުރެވެއެވެ: ދެ ތަފާތު ފައިސާއިން ހުރި ދެ އަދަދުގެ ފަރަގަކީ އަދަދެއް ނޫނެވެ.",
      "footerNote": "އުނިކުރެވޭ އަދަދަކީ ދެ ފަރާތުގެ ތެރެއިން ކުޑަ އަދަދެވެ — ދެ ފަރާތުގެ ހިސާބުތަކުންވެސް އެއްބަސްވާ މިންވަރެވެ.",
      "agrees": "ދެ ފަރާތް އެއްބަސް",
      "disagrees": "ދެ ފަރާތް ތަފާތު",
      "noMirror": "ގުޅޭ ހިސާބެއް ނެތް",
      "noMirrorExplainer": "އަނެއް ކުންފުނީގައި ގުޅޭ ދަރަނީގެ ހިސާބެއް މެޕްކޮށްފައި ނުވާތީ، މި ބާކީގެ އެއް ފަރާތް އެކަނި އެނގެއެވެ. ފާސްކުރުމުން މުދަލުގެ ފަރާތުން އުނިވެ، އޭގެ ބަދަލުގައި އުނިވާނެ އެއްޗެއް ނުހުންނާނެއެވެ.",
      "statuses": {
        "proposed": "ނިންމުމަކަށް އިންތިޒާރުކުރަނީ",
        "accepted": "ފާސްކުރެވިއްޖެ",
        "rejected": "ބޭރުކުރެވިއްޖެ"
      },
      "columns": {
        "company": "ކުންފުނި",
        "counterparty": "އަނެއް ފަރާތް",
        "accounts": "ހިސާބުތައް",
        "companySide": "ކުންފުނިން ބުނަނީ",
        "counterpartySide": "އަނެއް ފަރާތުން ބުނަނީ",
        "mismatch": "ފަރަގު",
        "eliminated": "އުނިކުރެވޭނެ",
        "agreement": "އެއްބަސްވުން"
      },
      "decide": {
        "acceptTitle": "މި އިލިމިނޭޝަން ފާސްކުރޭ",
        "rejectTitle": "މި އިލިމިނޭޝަން ބޭރުކުރޭ",
        "subject": "{company} އަދި {counterparty}",
        "claimsOwed": "{company} އިން ބުނަނީ ލިބެންޖެހެނީ",
        "claimsOwes": "{company} އިން ބުނަނީ ދޭންޖެހެނީ",
        "mismatchHint": "ދެ ފަރާތްވެސް ހުށަހަޅާ ފައިސާއަށް ބަދަލުކުރުމަށްފަހު އަޅާކިޔާފައި.",
        "eliminatedHint": "ދެ ފަރާތުގެ ތެރެއިން ކުޑަ އަދަދު — ދެ ފަރާތުގެ ހިސާބުތަކުންވެސް އެއްބަސްވާ މިންވަރު.",
        "acceptConsequence": "ފާސްކުރުމުން، ކޮންސޮލިޑޭޓެޑް ޓްރަޔަލް ބެލެންސާއި ބެލެންސް ޝީޓުން މުދަލުގެ ފަރާތުންނާއި ދަރަނީގެ ފަރާތުން މި އަދަދު މިހާރުން ފެށިގެން އުނިވާނެއެވެ.",
        "rejectConsequence": "ބޭރުކުރުމުން މި ބާކީ ފަރަގާއެކު ކޮންސޮލިޑޭޓެޑް ބަޔާންތަކުގައި ދެމިހުންނާނެއެވެ. ސަބަބު ލިޔުއްވާ: ދެން އަންނަ ކުއާޓަރުގައި ބަޔާން ކިޔާ ފަރާތަށް އެ އެނގެން ޖެހެއެވެ.",
        "finalExplainer": "ނިންމުމަކީ ފައިނަލް އެއްޗެކެވެ. އަލުން ބަލަން ބޭނުންނަމަ އައު ރަނެއް ހިންގަވާ — އެއިން އައު، ނުނިމޭ ސަތުރުތަކެއް ހުށަހަޅާނެއެވެ.",
        "noteLabel": "ސަބަބު",
        "noteHint": "ހުށަހެޅުމާއެކު އަދި އޮޑިޓް ރެކޯޑްގައި ބެހެއްޓޭނެއެވެ.",
        "reasonRequired": "މި ހުށަހެޅުން ބޭރުކުރާ ސަބަބު ލިޔުއްވާ.",
        "accepted": "އިލިމިނޭޝަން ފާސްކުރެވިއްޖެ",
        "rejected": "އިލިމިނޭޝަން ބޭރުކުރެވިއްޖެ"
      }
    },
    "mismatches": {
      "title": "ކުންފުނިތަކުގެ މެދުގައި ހުރި ތަފާތުތައް",
      "description": "އެއް ބާކީއަކާ މެދު ދެ މެންބަރެއްގެ ހިސާބުތައް އެއްބަސްނުވާ ތަންތަން.",
      "loadFailed": "ތަފާތުތަކުގެ ރިޕޯޓް ލޯޑެއް ނުވި",
      "emptyTitle": "ތަފާތެއް ނެތް",
      "emptyDescription": "ދެ ފަރާތްވެސް ހުށަހަޅާ ފައިސާއަށް ބަދަލުކުރުމަށްފަހު، މި ރަނުގެ ކޮންމެ ކުންފުނި ޖޯޑެއް ލާރިއަކާ ހަމައަށް އެއްބަސްވެއެވެ.",
      "count": "ތަފާތުތައް",
      "footerNote": "އަމިއްލަ އަދަދުތައް ހުރީ ކޮންމެ ކުންފުންޏެއްގެ އަމިއްލަ ފައިސާއިންނެވެ؛ ބަދަލުކުރެވިފައިވާ ކޮލަމްތައް ހުރީ ރަނުގެ ހުށަހަޅާ ފައިސާއިންނެވެ.",
      "scopeHeadline": "ނިންމިފައިވާ ހުށަހެޅުންތައްވެސް މި ރިޕޯޓުގައި ދެމިހުރެއެވެ",
      "scopeExplainer": "ފަރާތެއް ފާސްކުރި ތަފާތަކީވެސް ހިނގާފައިވާ ތަފާތެކެވެ. މިއީ މުއްދަތު ބަންދުކުރުމަށް ބޭނުންކުރާ ވޯކިންގ ޕޭޕަރެކެވެ، ކުރަންޖެހޭ ކަންކަމުގެ ލިސްޓެއް ނޫނެވެ — އެއީ އިލިމިނޭޝަން ޞަފުޙާއެވެ.",
      "translationExplainer": "ފަރަގު ނެގުމުގެ ކުރިން ދެ ފަރާތްވެސް ހުށަހަޅާ ފައިސާއަށް ބަދަލުކުރެވުނެވެ، ސަބަބަކީ ދެ ފައިސާއިން ހުރި ދެ އަދަދު އަޅާކިޔުމުން ނިކުންނަނީ އަދަދެއް ނޫން، ނުސާފު އެއްޗެއް ކަމަށްވާތީއެވެ.",
      "columns": {
        "companyLocal": "ކުންފުނި، އަމިއްލަ ފައިސާ",
        "counterpartyLocal": "އަނެއް ފަރާތް، އަމިއްލަ ފައިސާ",
        "decision": "ނިންމުން",
        "reason": "ދިން ސަބަބު"
      }
    },
    "methods": {
      "full": "ފުރިހަމަ",
      "proportional": "ނިސްބަތުން",
      "equity": "އިކުއިޓީ ގޮތް",
      "excluded": "ނުހިމެނޭ"
    },
    "methodHints": {
      "full": "ކޮންމެ ލައިނެއް ކޮންސޮލިޑޭޓްކުރެވި، މިލްކުނުވާ ބައިގެ މައިނޯރިޓީ އިންޓަރެސްޓާއެކު.",
      "proportional": "ކޮންމެ ލައިނެއް މިލްކުވެރި އިންސައްތައިން ކޮންސޮލިޑޭޓްކުރެވޭ.",
      "equity": "ނެޓް މުދަލުގެ ހިއްސާއިން އެއް އިންވެސްޓްމަންޓް ލައިން؛ ލައިނުން ލައިނަށް ކޮންސޮލިޑޭޝަނެއް ނެތް.",
      "excluded": "ކޮންސޮލިޑޭޓް ނުކުރެވޭ ގްރޫޕުގެ މެންބަރެއް."
    },
    "groupChart": {
      "title": "ގްރޫޕުގެ ޗާޓް އޮފް އެކައުންޓްސް",
      "assign": "ގްރޫޕް ޗާޓް ކަނޑައަޅާ",
      "change": "ބަދަލުކުރޭ",
      "missing": "މި ގްރޫޕަށް ގްރޫޕް ޗާޓެއް ނެތް. ރަންތަކުން ލޯކަލް އެކައުންޓްތައް ގްރޫޕް އެކައުންޓްތަކަށް ބަދަލުނުކޮށް ކޮންސޮލިޑޭޓްކުރާނެ، އަދި ތައްޔާރުކަމުން އިންޒާރުދޭނެ.",
      "field": "ގްރޫޕް ޗާޓް",
      "mapVersion": "އެކައުންޓް މެޕްގެ ވަރޝަން",
      "locked": "ގްރޫޕް ޗާޓް ބަދަލެއް ނުކުރެވޭނެ: އެކައުންޓް މެޕްތައް މިހާރުވެސް އޭގެ އެކައުންޓްތަކަށް އިޝާރާތްކުރޭ.",
      "chartId": "ޗާޓް {id}",
      "dialogTitle": "ގްރޫޕުގެ ޗާޓް އޮފް އެކައުންޓްސް",
      "dialogDescription": "ކޮންމެ މެންބަރެއްގެ ލޯކަލް އެކައުންޓްތައް މި ޗާޓުގެ އެކައުންޓްތަކަށް މެޕްކުރެވޭނެ.",
      "fieldHint": "ގްރޫޕް އެކައުންޓްތައް ހިމެނޭ އެކައުންޓް ސެގްމަންޓެއް ހުރި އެކްޓިވް ޗާޓް އޮފް އެކައުންޓްސްއެއް.",
      "none": "ގްރޫޕް ޗާޓެއް ނެތް",
      "placeholder": "ޗާޓް އޮފް އެކައުންޓްސްއެއް ޚިޔާރުކުރައްވާ",
      "fixedOnceMapped": "އެއްވެސް އެކައުންޓެއް މެޕްކުރުމަށްފަހު ގްރޫޕް ޗާޓް ބަދަލެއް ނުކުރެވޭނެ.",
      "noCharts": "ތިބާއަށް ލިބެން ހުރި އެކްޓިވް ޗާޓް އޮފް އެކައުންޓްސްއެއް ނެތް. ޗާޓްތައް ތައްޔާރުކުރެވެނީ އެންޓަރޕްރައިޒް، ފައިނޭންޝަލް ސްޓްރަކްޗަރސްގައި.",
      "saved": "ގްރޫޕް ޗާޓް ކަނޑައެޅިއްޖެ",
      "cleared": "ގްރޫޕް ޗާޓް ފޮހެލެވިއްޖެ",
      "savedDetail": "އެކައުންޓް މެޕިންގ ސްކްރީނުގައި ކޮންމެ މެންބަރެއްގެ އެކައުންޓްތައް އެއަށް މެޕްކުރައްވާ."
    },
    "readiness": {
      "title": "ކޮންސޮލިޑޭޝަނަށް ތައްޔާރުކަން",
      "description": "ރިޕޯޓިންގ މުއްދަތަކަށް ހިއްސާވާ ކޮންމެ ކުންފުންޏެއް ތައްޔާރުތޯ، އަދި ތައްޔާރުނުވާ ކުންފުނިތައް ހުއްޓުވާ ކަންކަން.",
      "recheck": "އަލުން ބަލާ",
      "emptyTitle": "ގްރޫޕަކާއި ރިޕޯޓިންގ މުއްދަތެއް ޚިޔާރުކުރައްވާ",
      "emptyDescription": "ތައްޔާރުކަން ބެލެނީ އެއް ގްރޫޕަކާއި އެއް މުއްދަތަކަށް: ކޮންމެ މެންބަރެއްގެ މުއްދަތުގެ ހާލަތު، ބަންދުކުރުމުގެ ސެޓްފިކޭޓް، ކުންފުނިތަކުގެ މެދު ތަފާތު އަދި މެޕްނުކުރާ ބާކީ.",
      "loadFailed": "ތައްޔާރުކަން ނުބެލުނު",
      "summaryTitle": "ތައްޔާރުކަން",
      "ready": "ކޮންސޮލިޑޭޓްކުރަން ތައްޔާރު",
      "notReady": "ތައްޔާރެއް ނޫން",
      "asOf": "މުއްދަތު ނިމޭ ތާރީޚު",
      "tolerance": "ކުންފުނިތަކުގެ މެދު ޓޮލަރެންސް",
      "unmappedTotal": "މެޕްނުކުރާ ބާކީއެއް ހުރި އެކައުންޓްތައް",
      "gateExplainer": "ތިރީގައިވާ އެއްވެސް ހުރަހެއް ހުރިހާ ހިނދަކު މި މުއްދަތަށް ރަނެއް ނުހިންގޭނެ.",
      "warningsTitle": "އިންޒާރުތައް",
      "assignChart": "ގްރޫޕް ޗާޓެއް ކަނޑައަޅާ",
      "membersTitle": "ހިއްސާވާ ކުންފުނިތައް",
      "noMembersTitle": "ހިއްސާވާ ކުންފުންޏެއް ނެތް",
      "noMembersDescription": "މި މުއްދަތު ނިމޭ ތާރީޚު އެއްވެސް މެންބަރެއްގެ މެންބަރުކަމުގައި ނުހިމެނޭ.",
      "blockersTitle": "ހުރަސްތައް",
      "noBlockers": "މި މުއްދަތު އެއްވެސް އެއްޗަކުން ހުއްޓުވާފައެއް ނެތް.",
      "periodStatusIs": "މުއްދަތުގެ ހާލަތު: {status}.",
      "intercoIs": "{tolerance} ގެ ޓޮލަރެންސްއާ ދެކޮޅަށް {amount} ގެ ރިކޮންސައިލް ނުކުރާ ތަފާތު.",
      "unmappedIs": "ބާކީއެއް ހުރި {count} ލޯކަލް އެކައުންޓަކަށް ގްރޫޕް އެކައުންޓެއް ނެތް.",
      "openUnmapped": "މެޕްނުކުރާ އެކައުންޓްތައް މެޕްކުރޭ",
      "unmappedMore": "އަދި {count} އިތުރު",
      "parent": "މައި ކުންފުނި",
      "yes": "އާއެކޭ",
      "no": "ނޫނެކޭ",
      "memberReady": "ތައްޔާރު",
      "columns": {
        "company": "ލީގަލް އެންޓިޓީ",
        "method": "ގޮތް",
        "periodStatus": "މުއްދަތު",
        "certified": "ބަންދުކުރުން ސެޓްފައިކުރެވިފައި",
        "interco": "ރިކޮންސައިލް ނުކުރާ އައިސީ",
        "unmapped": "މެޕްނުކުރާ",
        "blockers": "ހުރަސްތައް"
      },
      "blockers": {
        "no_fiscal_period": "ފިސްކަލް މުއްދަތެއް ނެތް",
        "period_not_closed": "މުއްދަތު ބަންދުކޮށްފައެއް ނުވޭ",
        "close_run_not_certified": "ބަންދުކުރުން ސެޓްފައިކޮށްފައެއް ނުވޭ",
        "interco_over_tolerance": "ކުންފުނިތަކުގެ މެދު ތަފާތު ޓޮލަރެންސަށްވުރެ ގިނަ",
        "interco_statement_missing": "ކުންފުނިތަކުގެ މެދު ސްޓޭޓްމަންޓެއް ނެތް",
        "unmapped_balances": "މެޕްނުކުރާ ބާކީ",
        "ic_differences_open": "ކުންފުނިތަކުގެ މެދު ތަފާތުތައް ތްރެޝޯލްޑްއަށްވުރެ މަތީގައި ހައްލުނުކުރެވި ހުރި",
        "ic_differences_no_rate": "ކުންފުނިތަކުގެ މެދު ތަފާތަކަށް ރަން ތާރީޚަށް ސަރފު ނިސްބަތެއް ނެތް"
      },
      "blockerDetails": {
        "no_fiscal_period": "ކުންފުނީގެ ކެލެންޑަރުގައި މުއްދަތު ނިމޭ ތާރީޚު ހިމެނޭ މުއްދަތެއް ނެތް.",
        "period_not_closed": "މި ތާރީޚުގެ ކުންފުނީގެ ފިސްކަލް މުއްދަތު ބަންދުކުރައްވާ.",
        "close_run_not_certified": "މުއްދަތަށް ކުންފުނީގެ ބަންދުކުރުމުގެ ރަން ސެޓްފައިކުރައްވާ.",
        "interco_over_tolerance": "ތަފާތު ޓޮލަރެންސްގެ ތެރެއަށް އަންނަންދެން ކުންފުނިތަކުގެ މެދު ސްޓޭޓްމަންޓްތައް ރިކޮންސައިލް ނުވަތަ ސެޓްފައިކުރައްވާ.",
        "interco_statement_missing": "ބަންދުކުރުން ހުއްޓުވާ ކުންފުނިތަކުގެ މެދު ޖޯޑަކަށް މި މުއްދަތުގެ ރިކޮންސިލިއޭޝަން ސްޓޭޓްމަންޓެއް ނެތް.",
        "unmapped_balances": "މި ކޮންމެ އެކައުންޓެއް މުއްދަތު ނިމޭ ތާރީޚު ނުވަތަ އޭގެ ކުރިން ފެށޭގޮތަށް ގްރޫޕް އެކައުންޓަކަށް މެޕްކުރައްވާ.",
        "ic_differences_open": "ގްރޫޕްގެ ތްރެޝޯލްޑްއަށްވުރެ މަތީގައިވާ ހުޅުވިފައިވާ ކުންފުނިތަކުގެ މެދު ތަފާތުތައް ހައްލުކުރޭ، ނުވަތަ ތްރެޝޯލްޑް އުފުއްލަވަން އެދިލާ."
      },
      "warnings": {
        "group_coa_missing": "ގްރޫޕުގެ ޗާޓް އޮފް އެކައުންޓްސްއެއް ނެތް"
      },
      "warningDetails": {
        "group_coa_missing": "ގްރޫޕް ޗާޓެއް ނެތިއްޖެނަމަ ރަންތަކުން ކޮންސޮލިޑޭޓްކުރަނީ ކޮންމެ ކުންފުންޏެއްގެ އަމިއްލަ އެކައުންޓްތަކުން، އަދި މެޕިންގ އެއްވެސް އެއްޗެއް ޗެކެއް ނުކުރެވޭ. ލޯކަލް އެކައުންޓްތައް މެޕްކުރުމަށް އެއް ކަނޑައަޅާ."
      },
      "periodStatuses": {
        "open": "ހުޅުވާލާފައި",
        "soft_closed": "ލުއިކޮށް ބަންދުކޮށްފައި",
        "closed": "ބަންދުކޮށްފައި",
        "permanently_closed": "ދާއިމީކޮށް ބަންދުކޮށްފައި",
        "none": "މުއްދަތެއް ނެތް"
      }
    },
    "accountMaps": {
      "title": "އެކައުންޓް މެޕިންގ",
      "description": "ކޮންމެ މެންބަރެއްގެ ލޯކަލް އެކައުންޓްތައް ގްރޫޕް ޗާޓަށް މެޕްކުރެވިފައި، ވަރޝަންތަކާއި އަމަލުކުރާ ތާރީޚުތަކާއެކު.",
      "loadFailed": "އެކައުންޓް މެޕް ލޯޑެއް ނުވި",
      "chooseGroupTitle": "ގްރޫޕެއް ޚިޔާރުކުރައްވާ",
      "chooseGroupDescription": "އެކައުންޓްތައް މެޕްކުރެވެނީ އެއް ކޮންސޮލިޑޭޝަން ގްރޫޕެއްގެ ގްރޫޕް ޗާޓަށް.",
      "chooseMemberTitle": "މެންބަރެއް ޚިޔާރުކުރައްވާ",
      "chooseMemberDescription": "އެއް ފަހަރާ އެއް ކުންފުންޏެއްގެ ލޯކަލް އެކައުންޓްތައް މެޕްކުރައްވާ: މައި ކުންފުނި ނުވަތަ އެއްވެސް މެންބަރެއް.",
      "noChartTitle": "މި ގްރޫޕަށް ގްރޫޕް ޗާޓެއް ނެތް",
      "noChartDescription": "ފުރަތަމަ ގްރޫޕުގައި ގްރޫޕް ޗާޓް އޮފް އެކައުންޓްސްއެއް ކަނޑައަޅާ. ލޯކަލް އެކައުންޓްތައް މެޕްކުރެވެނީ އޭގެ އެކައުންޓްތަކަށް.",
      "openGroup": "ގްރޫޕް ހުޅުވާ",
      "noAccountPermission": "މި ކުންފުނީގެ އެކައުންޓްތައް ލިސްޓުކުރުމަށް ޗާޓް އޮފް އެކައުންޓްސް ކިޔުމުގެ ހުއްދަ ބޭނުންވޭ.",
      "noGroupAccountPermission": "ގްރޫޕް އެކައުންޓްތައް ޚިޔާރުކުރުމަށް ޗާޓް އޮފް އެކައުންޓްސްއާއި އޭގެ އަގުތައް ކިޔުމުގެ ހުއްދަ ބޭނުންވޭ.",
      "reloaded": "ތިބާ އެޑިޓްކުރަމުން ގެންދަވަނިކޮށް އެހެން މީހަކު އެކައުންޓް މެޕް ބަދަލުކޮށްފި. އަލުން ލޯޑްކުރެވި، ތިބާގެ ބަދަލުތައް ރައްކާވެފައިވޭ؛ މިހާރުގެ މެޕިންގއާ ބައްލަވާފައި އަލުން ރައްކާކުރައްވާ.",
      "rowsRefused": "{count} ސަތުރު ބަލައިނުގަނެވުނު. އެއްވެސް އެއްޗެއް ރައްކާނުކުރެވުނު؛ ފާހަގަކުރެވިފައިވާ ސަތުރުތައް ރަނގަޅުކޮށް އަލުން ރައްކާކުރައްވާ.",
      "suggestSummary": "{proposals} ހުށަހެޅުން ފެނިއްޖެ؛ މެޕްނުކުރާ {unmatched} އެކައުންޓަކަށް އެއްވެސް ގުޅުމެއް ނުފެނުނު. ހުށަހެޅުމެއް އޭގެ ސަތުރުގައި ބަލައިގަންނަވާ؛ ރައްކާކުރަންދެން އެއްވެސް އެއްޗެއް ރައްކާނުވޭ.",
      "versionExplainer": "{date} ގައި އަމަލުކުރާ މެޕިންގ ދައްކަނީ. ރައްކާކުރާ ބަދަލުތައް އަމަލުކުރެވެނީ އެ ތާރީޚުން: ކުރީގެ ވަރޝަން ނިމެނީ އޭގެ ކުރީ ދުވަހު، އަދި އައު ވަރޝަނެއް ފެށޭ. އެއްވެސް ވަރޝަނެއް ދުވަހަކުވެސް މައްޗަށް ނުލިޔެވޭ.",
      "tableTitle": "ލޯކަލް އެކައުންޓްތައް (މެޕްނުކުރާ {unmapped})",
      "noUnmapped": "މި ތާރީޚުގައި ކޮންމެ ލޯކަލް އެކައުންޓެއް މެޕްކުރެވިފައިވޭ.",
      "noAccounts": "ގުޅޭ ޕޯސްޓްކުރެވޭ އެކައުންޓެއް ނެތް.",
      "versionFrom": "ވަރޝަން {version}، {from} އިން",
      "unmapped": "މެޕްނުކުރާ",
      "clearMapping": "މި ތާރީޚުން މެޕިންގ ނައްތާ",
      "choose": "ގްރޫޕް އެކައުންޓެއް ޚިޔާރުކުރައްވާ",
      "willRetire": "{date} އިން މެޕިންގ ނެތް",
      "suggested": "ހުށަހެޅުން: {account}",
      "byCode": "ކޯޑު ގުޅުން",
      "byName": "ނަމުގެ ގުޅުން {score}",
      "historyTitle": "ވަރޝަންތަކުގެ ތާރީޚު: {account}",
      "noHistory": "މި އެކައުންޓް ދުވަހަކުވެސް މެޕްކޮށްފައެއް ނުވޭ.",
      "historyExplainer": "ކޮންމެ ވަރޝަނެއް ރެކޯޑުގައި ހުންނާނެ. ރަނަކުން ބަދަލުކުރި މެޕް ވަރޝަން ރެކޯޑުކުރެވޭ.",
      "fields": {
        "member": "މެންބަރު",
        "memberPlaceholder": "ކުންފުންޏެއް ޚިޔާރުކުރައްވާ",
        "asOf": "އަމަލުކުރާ ތާރީޚު",
        "asOfHint": "ދައްކަނީ މި ތާރީޚުގައި އަމަލުކުރާ މެޕިންގ؛ ބަދަލުތައް އަމަލުކުރެވެނީ މި ތާރީޚުން.",
        "search": "އެކައުންޓެއް ހޯދާ",
        "show": "ދައްކާނީ"
      },
      "filters": {
        "none": "ހުރިހާ އެކައުންޓެއް",
        "balance": "ބާކީއެއް ހުރި މެޕްނުކުރާ",
        "all": "ހުރިހާ މެޕްނުކުރާ"
      },
      "balance": "ބާކީ",
      "balanceUnavailable": "ބާކީއެއް ހުރި މެޕްނުކުރާ އެކައުންޓްތައް އެނގެނީ ރިޕޯޓިންގ މުއްދަތަކަށް ތައްޔާރުކަން ބެލުމުން. އެ ފެންނަން ކޮންސޮލިޑޭޝަނަށް ތައްޔާރުކަމުން މި ސްކްރީން ހުޅުއްވާ؛ އެހާތަނަށް ހުރިހާ މެޕްނުކުރާ އެކައުންޓެއް ދައްކާނެ.",
      "balanceSource": "{date} ގެ ތައްޔާރުކަމުގެ ޗެކުގައި ބާކީއެއް ހުރި މެޕްނުކުރާ އެކައުންޓްތައް ދައްކަނީ. ބާކީ އެކައުންޓްތައް ބަލަން ހުރިހާ މެޕްނުކުރާ ޚިޔާރުކުރައްވާ.",
      "balanceSourceTruncated": "{date} ގެ ތައްޔާރުކަމުގެ ޗެކުގައި ބާކީއެއް ހުރި ފުރަތަމަ މެޕްނުކުރާ އެކައުންޓްތައް ދައްކަނީ؛ އިތުރު އެބަހުރި. މިއިން މެޕްކޮށް ތައްޔާރުކަން އަލުން ބައްލަވާ، ނުވަތަ ހުރިހާ މެޕްނުކުރާ ޚިޔާރުކުރައްވާ.",
      "noUnmappedWithBalance": "މި މެންބަރުގެ މެޕްނުކުރާ އެއްވެސް އެކައުންޓެއްގައި މި މުއްދަތަށް ބާކީއެއް ނެތް.",
      "columns": {
        "local": "ލޯކަލް އެކައުންޓް",
        "current": "މި ތާރީޚުގެ ގްރޫޕް އެކައުންޓް",
        "proposed": "ބަދަލުކުރާނީ",
        "version": "ވަރޝަން",
        "groupAccount": "ގްރޫޕް އެކައުންޓް",
        "from": "ފެށޭ",
        "to": "ނިމޭ"
      },
      "actions": {
        "suggest": "ހުށަހަޅާ",
        "discard": "ބަދަލުތައް ދޫކޮށްލާ",
        "save": "ބަދަލުތައް ރައްކާކުރޭ ({count})",
        "accept": "ބަލައިގަނޭ",
        "dismiss": "ދޫކޮށްލާ",
        "history": "ތާރީޚު"
      },
      "toasts": {
        "saved": "އެކައުންޓް މެޕް ރައްކާކުރެވިއްޖެ",
        "savedDetail": "{date} އިން: އައު ވަރޝަން {opened}، ނިމުނު {closed}، މިހާރުވެސް އެދުނު ގޮތަށް {unchanged}.",
        "suggestFailed": "އެއްވެސް ހުށަހެޅުމެއް ނުކުރެވުނު"
      }
    },
    "people": {
      "you": "ތިޔަބޭފުޅާ",
      "userId": "ޔޫޒަރ #{id}"
    },
    "runStatus": {
      "draft": "ޑްރާފްޓް",
      "ready": "ތައްޔާރު",
      "published": "ޝާއިޢުކުރެވިފައި",
      "superseded": "ބަދަލުކުރެވިފައި"
    },
    "runStatusHints": {
      "draft": "ތައްޔާރުކުރަމުންދަނީ: އިލިމިނޭޝަނެއް، ކުންފުނިތަކުގެ މެދުގައި ހުރި ޖޯޑެއް ނުވަތަ ގްރޫޕް އެޑްޖަސްޓްމަންޓެއް ނިންމާފައެއް ނުވޭ. އަދަދުތައް ކޮންމެ ފަހަރަކު ހިސާބުކުރެވޭތީ ބަދަލުވެވިދާނެ.",
      "ready": "އޭގެ އަމިއްލަ ތައްޔާރީ ފުރިހަމަ. ޝާއިޢުކުރާ ވަގުތު ކޮންމެ މެންބަރެއްގެ ތައްޔާރުކަން އަދިވެސް ބެލެވޭނެ.",
      "published": "ޝާއިޢުކޮށް ލޮކްކުރެވިފައި. އަދަދުތައް ސާބިތު؛ ރަނގަޅުކުރަން ޖެހިއްޖެނަމަ ރިސްޓޭޓްމަންޓެއް ކުރަންޖެހޭ، އެއީ އާ ރަނެއް ހަދައި މިއީ ހިފެހެއްޓޭނެ ގޮތެކެވެ.",
      "superseded": "ރިސްޓޭޓްމަންޓަކުން ބަދަލުކުރެވިފައި. ޝާއިޢުކުރި ތަކެތީގެ ހެކިގޮތުގައި ބާކީކުރެވިފައި؛ އަދި ބަދަލެއް ނުގެނެވޭނެ."
    },
    "source": {
      "frozen": {
        "headline": "ޝާއިޢުކުރުމުގައި ސާބިތުކުރެވިފައި",
        "detail": "މި އަދަދުތައް އައިސްފައިވަނީ ރަން ޝާއިޢުކުރި ވަގުތު ސާބިތުކުރެވުނު ސްނެޕްޝޮޓުން. އެއީ ބަދަލެއް ނުވާނެ."
      },
      "computed": {
        "headline": "ކޮންމެ ކިޔުމަކުން ހިސާބުކުރެވޭ",
        "detail": "މި ރަން އަދި ޝާއިޢުކުރެވިފައެއް ނުވޭ. އަދަދުތަކުން ދެއްކެނީ މިހާރު ހުރި އިލިމިނޭޝަންތަކާއި އެޑްޖަސްޓްމަންޓްތަކެވެ؛ ޝާއިޢުކުރަންދެން ބަދަލުވެވިދާނެ."
      },
      "generatedAt": "ކިޔާލި ވަގުތު"
    },
    "workbook": {
      "export": "ވަރކްބުކް އެކްސްޕޯޓްކުރޭ"
    },
    "publication": {
      "title": "ޝާއިޢުކުރުން",
      "publishedAt": "ޝާއިޢުކުރި ވަގުތު",
      "publishedBy": "ޝާއިޢުކުރި ފަރާތް",
      "generatedBy": "އުފެއްދި ފަރާތް",
      "chainTitle": "ރިސްޓޭޓްމަންޓް ސިލްސިލާ",
      "chainRun": "ރަން #{id}",
      "chainThis": "މި ރަން",
      "chainReason": "ސަބަބު: {reason}",
      "chainTruncated": "މި ސިލްސިލާގައި ހިމެނޭ ރަނެއް ކިޔަން ނުޖެހުނީތީ ކުރީގެ ނުވަތަ ފަހުގެ ރަންތަކެއް ވެދާނެ.",
      "gatesTitle": "މި ރަން ޝާއިޢުކުރުމުގެ މެދުގައި ހުރި ކަންތައްތައް",
      "gateStates": {
        "ok": "ސާފު",
        "blocked": "ހުރަސްކުރަނީ",
        "checked": "ޝާއިޢުކުރާ ވަގުތު ބެލޭނެ"
      },
      "gates": {
        "chart": {
          "title": "ގްރޫޕް ޗާޓް އޮފް އެކައުންޓްސް",
          "text": "ރަން ޓްރާންސްލޭޓްކުރެވިފައި ހުންނަންވާނީ ގްރޫޕް ޗާޓް އޮފް އެކައުންޓްސްއަކުން، ކޮންމެ ބެލެންސެއްވެސް ގްރޫޕް އެކައުންޓަކާ މެޕްކުރެވިފައި ހުންނާނެހެން.",
          "link": "ގްރޫޕް ހުޅުވާ"
        },
        "adjustments": {
          "title": "ގްރޫޕް އެޑްޖަސްޓްމަންޓްތައް",
          "text": "ޑްރާފްޓްކޮށްގެން ނުވަތަ ފާސްކުރުމަށް މަޑުކުރަމުންދާ ގްރޫޕް އެޑްޖަސްޓްމަންޓެއް ނުހުންނަންވާނެ. ނުބޭނުންވާ އެއްޗެއް ވިތްޑްރޯކުރޭ.",
          "pending": "{count} އެޑްޖަސްޓްމަންޓް އަދި ފާސްކުރެވިފައެއް ނުވޭ.",
          "approved": "ސްޓޭޓްމަންޓްތަކުގައި {count} ފާސްކުރެވުނު އެޑްޖަސްޓްމަންޓް ހިމެނޭ.",
          "link": "ރަނުގެ އެޑްޖަސްޓްމަންޓްތައް ހުޅުވާ"
        },
        "readiness": {
          "title": "ކޮންމެ މެންބަރެއްގެ ތައްޔާރުކަން",
          "text": "ކޮންމެ މެންބަރެއްގެ ފިސްކަލް މުއްދަތު ބަންދުކޮށް، ކްލޯޒް ސެޓިފައިކުރެވި، ބެލެންސް ހުރި ކޮންމެ އެކައުންޓެއްވެސް ގްރޫޕް ޗާޓާ މެޕްކުރެވިފައި ހުންނަންވާނެ.",
          "link": "ތައްޔާރުކަން ބަލާ"
        },
        "tolerance": {
          "title": "ކުންފުނިތަކުގެ މެދުގައި ހުރި ޖޯޑުތައް ޓޮލަރެންސް ތެރޭގައި",
          "text": "ކުންފުނިތަކުގެ މެދުގައި ހުރި ކޮންމެ ޖޯޑެއްވެސް ގްރޫޕުގެ ޓޮލަރެންސް ތެރޭގައި އެއްގޮތްވާންވާނެ.",
          "textWith": "ކުންފުނިތަކުގެ މެދުގައި ހުރި ކޮންމެ ޖޯޑެއްވެސް ގްރޫޕުގެ ޓޮލަރެންސް {tolerance} {currency} ތެރޭގައި އެއްގޮތްވާންވާނެ.",
          "value": "ޓޮލަރެންސް: {tolerance} {currency}.",
          "link": "ތަފާތުތައް ބަލާ"
        },
        "eliminations": {
          "title": "އިލިމިނޭޝަންތައް ނިންމާފައި",
          "text": "އަދަދެއް ބަދަލުކުރާ ކޮންމެ ހުށަހެޅިފައިވާ އިލިމިނޭޝަނެއްވެސް ގަބޫލުކުރުން ނުވަތަ ރަދުކުރުން ކުރަންވާނެ، ސަބަބަކީ ޝާއިޢުކުރި ރަނެއް ސާބިތުވާތީ.",
          "link": "އިލިމިނޭޝަންތައް ހުޅުވާ"
        },
        "period": {
          "title": "ކޮންމެ މުއްދަތަކަށް ޝާއިޢުކުރެވޭ އެއް ރަން",
          "text": "ގްރޫޕަކާއި މުއްދަތަކުގެ ޝާއިޢުކުރެވޭ ކޮންސޮލިޑޭޝަންއަކީ އެއް ރަން ހަމައެކަނި. އެއަށް ބަދަލުކުރުމަކީ ރިސްޓޭޓްމަންޓެއް، ދެވަނަ ޝާއިޢުކުރުމެއް ނޫން."
        },
        "secondPerson": {
          "title": "ދެވަނަ ފަރާތަކުން ޝާއިޢުކުރެވޭނެ",
          "text": "ޝާއިޢުކުރާ ފަރާތަކީ ރަން އުފެއްދި ފަރާތް، ނުވަތަ އޭގައި ފާސްކުރެވިފައިވާ އެޑްޖަސްޓްމަންޓެއް ތައްޔާރުކުރި ފަރާތް ނޫން."
        }
      },
      "barrier": {
        "generator": "މި ރަން އުފެއްދީ ތިޔަބޭފުޅާ، ސަބަބުން ޝާއިޢުކުރުމުގެ ހުއްދަ ހުރި އެހެން ފަރާތަކުން ޝާއިޢުކުރަންވާނެ.",
        "preparer": "މި ރަނުގައި ފާސްކުރެވިފައިވާ އެޑްޖަސްޓްމަންޓެއް ތައްޔާރުކުރީ ތިޔަބޭފުޅާ، ސަބަބުން ޝާއިޢުކުރުމުގެ ހުއްދަ ހުރި އެހެން ފަރާތަކުން ޝާއިޢުކުރަންވާނެ."
      },
      "withheld": {
        "chart": "ޝާއިޢުކުރުން ނުލިބެއެވެ: މި ރަން ޓްރާންސްލޭޓްކުރެވުނީ ގްރޫޕް ޗާޓް އޮފް އެކައުންޓްސް ނެތިއެވެ. ގްރޫޕަށް އެއް ދޭށެވެ، އެކައުންޓްތައް މެޕްކޮށް އާ ރަނެއް އުފައްދާ.",
        "adjustments": "{count} އެޑްޖަސްޓްމަންޓް ފާސްނުވަންދެން ޝާއިޢުކުރުން ނުލިބެއެވެ. ފުރަތަމަ ފާސްކުރުން ނުވަތަ ވިތްޑްރޯކުރުން ކުރޭ."
      },
      "publish": "ޝާއިޢުކުރޭ",
      "publishTitle": "ރަން #{id} ޝާއިޢުކުރޭ",
      "publishDescription": "ޝާއިޢުކުރުމުން މި ރަން އެ ގްރޫޕާއި މުއްދަތުގެ ރެކޯޑު ކޮންސޮލިޑޭޝަން ހުންނާނެ.",
      "lockHeadline": "ޝާއިޢުކުރުމުން މި ރަން ދުވަހަކުވެސް ލޮކްވެއްޖެ",
      "lockExplainer": "ޝާއިޢުކުރި ރަނެއް ދުވަހަކުވެސް ބަދަލެއް ނުގެނެވޭ: އޭގެ އިލިމިނޭޝަންތަކާއި އެޑްޖަސްޓްމަންޓްތަކާއި އަދަދުތައް ސާބިތު، އަދި ތަފާތު އަދަދުތަކަށް ދާނެ ހަމައެކަނި މަގަކީ އާ ރަނެއް އުފައްދައި މިއީ ބާކީކުރާ ރިސްޓޭޓްމަންޓެވެ.",
      "checksHeadline": "ޝާއިޢުކުރުމުގައި ބެލެވޭ ކަންތައްތައް",
      "publishing": "ޝާއިޢުކުރަނީ",
      "publishConfirm": "ޝާއިޢުކޮށް ލޮކްކުރޭ",
      "published": "ރަން ޝާއިޢުކުރެވުނު",
      "publishedDetail": "ރަން ލޮކްކުރެވިއްޖެ. އޭގެ ސްޓޭޓްމަންޓްތައް މިހާރު ސާބިތު.",
      "secondPersonHint": "ޝާއިޢުކުރުމުގެ ހުއްދަ ހުރި އެހެން ފަރާތަކުން މިކަން ކުރަންވާނެ. ޝާއިޢުކުރާ ފަރާތަކީ ރަން އުފެއްދި ފަރާތް، ނުވަތަ އޭގެ ފާސްކުރެވިފައިވާ އެޑްޖަސްޓްމަންޓެއް ތައްޔާރުކުރި ފަރާތް ނޫން.",
      "restate": "ރިސްޓޭޓްކުރޭ",
      "restateTitle": "ރަން #{id} ރިސްޓޭޓްކުރޭ",
      "restateDescription": "ރިސްޓޭޓްމަންޓަކުން ޝާއިޢުކުރި ކޮންސޮލިޑޭޝަނެއް ބަދަލު ނުކޮށް އޭގެ ބަދަލުގައި އާ އެއްޗެއް ޖައްސާ.",
      "restateHeadline": "ރިސްޓޭޓްކުރުމުން ކުރެވޭ ކަންތައްތައް",
      "restateNew": "އެ ގްރޫޕާއި މުއްދަތާއި ވިންޑޯގައި، މިހާރު ހުރި ލެޖަރުތަކާއި މިލްކުވެރިކަމާއި އެކައުންޓް މެޕުން، އެހެން ރަނެއްގައި ބެލޭ ކަންތައްތައް ހަމަ އެގޮތަށް ބަލައި، އާ ރަނެއް އުފައްދާ.",
      "restateKept": "މި ރަން ބަދަލުކުރެވިފައިކަމުގައި ފާހަގަކޮށް ދެ ރަނެއްވެސް ބާކީކުރޭ: ޝާއިޢުކުރި އަދަދުތަކާއި ރިސްޓޭޓްކުރި އަދަދުތައް އެއްކޮށް ރެކޯޑުގައި ހުރެއެވެ.",
      "restateAdjustments": "މި ރަނުގެ ފާސްކުރެވިފައިވާ އެޑްޖަސްޓްމަންޓްތައް ރިސްޓޭޓްމަންޓަށް ފާސްކުރެވިފައިވާ ކޮޕީތަކެއްގެ ގޮތުގައި ގެންދެވޭ، ގްރޫޕް އަދަދުތައް މަޑުމަޑުން ބަދަލެއް ނުވާނެހެން.",
      "restateSecondPerson": "ރިސްޓޭޓްމަންޓް ފެށެނީ ޑްރާފްޓެއްގެ ގޮތުގައި، އަދި އެހެން ރަނެއް ފަދައިން ދެވަނަ ފަރާތަކުން ޝާއިޢުކުރެވޭނެ.",
      "restateReason": "ރިސްޓޭޓްކުރުމުގެ ސަބަބު",
      "restateReasonHint": "އާ ރަނުގައި އަދި އޮޑިޓް ޓްރެއިލްގައި ބާކީކުރެވޭ.",
      "restateReasonRequired": "ޝާއިޢުކުރި ކޮންސޮލިޑޭޝަން ރިސްޓޭޓްކުރަނީ ކީއްވެގެންކަން ބުނޭ.",
      "restating": "ރިސްޓޭޓްކުރަނީ",
      "restateConfirm": "ރިސްޓޭޓްކުރޭ",
      "restated": "ރަން ރިސްޓޭޓްކުރެވުނު",
      "restatedDetail": "ރަން #{id} އަކީ ރިސްޓޭޓްމަންޓް. ދެވަނަ ފަރާތަކުން ޝާއިޢުނުކުރަންދެން އެއީ ޑްރާފްޓެއް.",
      "refusalLinks": {
        "accountMaps": "މި އެކައުންޓްތައް މެޕްކުރޭ",
        "readiness": "ތައްޔާރެއް ނޫން އެއްޗެހި ބަލާ",
        "mismatches": "ތަފާތުތައް ބަލާ",
        "eliminations": "އިލިމިނޭޝަންތައް ނިންމާ",
        "adjustments": "އެޑްޖަސްޓްމަންޓްތައް ހުޅުވާ",
        "group": "ގްރޫޕް ހުޅުވާ"
      }
    },
    "adjustments": {
      "title": "ގްރޫޕް އެޑްޖަސްޓްމަންޓްތައް",
      "one": "ގްރޫޕް އެޑްޖަސްޓްމަންޓް",
      "oneDescription": "ގްރޫޕް އެކައުންޓްތަކުގެ މައްޗަށް ބެލެންސްވާ ޖާނަލެއް، އެއް ރަނެއްގައި ރެކޯޑުކުރެވި، ފާސްކުރެވުނީމާ ހަމައެކަނި އޭގެ ސްޓޭޓްމަންޓްތަކަށް ހިމެނޭ.",
      "description": "ގްރޫޕް ޗާޓް އެކައުންޓްތަކުގެ މައްޗަށް، އެއްވެސް ކުންފުނިއެއްގެ ލެޖަރެއްގައި ނުހުރި ޖާނަލްތައް. ތައްޔާރުކުރަމުންދާ ނުވަތަ ފާސްކުރުމަށް މަޑުކުރަމުންދާ އެޑްޖަސްޓްމަންޓެއް ހުރި ރަނެއް ޝާއިޢުނުކުރެވޭނެ.",
      "draftNumber": "ޑްރާފްޓް #{id}",
      "allStatuses": "ހުރިހާ ސްޓޭޓަސްތައް",
      "loadFailed": "އެޑްޖަސްޓްމަންޓްތައް ލޯޑެއް ނުވި",
      "loadFailedOne": "މި އެޑްޖަސްޓްމަންޓް ލޯޑެއް ނުވި",
      "emptyTitle": "ގްރޫޕް އެޑްޖަސްޓްމަންޓެއް ނެތް",
      "emptyDescription": "ކުންފުނިއެއްގެ ލެޖަރަކަށް ނުނިސްބަތްވާ ކޮންސޮލިޑޭޝަން އެންޓްރީއެއް ރެކޯޑުކުރަން، ޑްރާފްޓް ނުވަތަ ތައްޔާރު ރަނެއްގައި، އޭގެ ޖަސްޓިފިކޭޝަންއާއެކު، އެއް ތައްޔާރުކުރޭ.",
      "noCrossRunTotal": "ސަތަރުތަކުގެ ދޭތެރޭ އަދަދުތައް ގުނާފައެއް ނުވޭ: ރަންތައް ތަފާތު ފައިސާގައި ހުށަހެޅިދާނެ.",
      "backToList": "ހުރިހާ އެޑްޖަސްޓްމަންޓްތައް",
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "submitted": "ފާސްކުރުމަށް މަޑުކުރަނީ",
        "approved": "ފާސްކުރެވިފައި",
        "rejected": "ރަދުކުރެވިފައި",
        "withdrawn": "ވިތްޑްރޯކުރެވިފައި"
      },
      "columns": {
        "number": "ނަންބަރު",
        "description": "ތަފްސީލް",
        "run": "ރަން",
        "total": "އަދަދު",
        "preparer": "ތައްޔާރުކުރި ފަރާތް",
        "created": "އުފެދުނު ވަގުތު"
      },
      "fields": {
        "run": "ރަން",
        "runPlaceholder": "ރަނެއް ޗޫޒްކުރޭ",
        "description": "ތަފްސީލް",
        "justification": "ޖަސްޓިފިކޭޝަން",
        "justificationHint": "ގްރޫޕް އަދަދުތަކަށް މި އެޑްޖަސްޓްމަންޓް ބޭނުންވާ ސަބަބު. ތައްޔާރުކުރާ ވަގުތުން ފެށިގެން ބޭނުންވޭ."
      },
      "actions": {
        "create": "އާ އެޑްޖަސްޓްމަންޓެއް",
        "edit": "އެޑިޓްކުރޭ",
        "submit": "ފާސްކުރުމަށް ހުށަހަޅާ",
        "withdraw": "ވިތްޑްރޯކުރޭ",
        "saveDraft": "ޑްރާފްޓް ސޭވްކުރޭ"
      },
      "lines": {
        "account": "ގްރޫޕް އެކައުންޓް",
        "accountPlaceholder": "ގްރޫޕް އެކައުންޓެއް ޗޫޒްކުރޭ",
        "debit": "ޑެބިޓް ({currency})",
        "credit": "ކްރެޑިޓް ({currency})",
        "description": "ލައިނުގެ ތަފްސީލް",
        "section": "ސްޓޭޓްމަންޓް ބައި",
        "remove": "ލައިން ފޮހެލާ",
        "totals": "ޖުމްލަ",
        "balanced": "ބެލެންސްވޭ",
        "difference": "{difference} {currency} ގެ ތަފާތެއް އުޅޭ",
        "add": "ލައިނެއް އިތުރުކުރޭ"
      },
      "accountTypes": {
        "ASSET": "މުދާ",
        "LIABILITY": "ޒިންމާތައް",
        "EQUITY": "އިކުއިޓީ",
        "INCOME": "އާމްދަނީ",
        "EXPENSE": "ޚަރަދު"
      },
      "form": {
        "createTitle": "އާ ގްރޫޕް އެޑްޖަސްޓްމަންޓެއް",
        "editTitle": "ގްރޫޕް އެޑްޖަސްޓްމަންޓް އެޑިޓްކުރޭ",
        "description": "ފުރަތަމަ ސޭވްކުރެވޭނީ ޑްރާފްޓެއްގެ ގޮތުގައި. ހުށަހަޅައި ފާސްކުރެވުނުފަހުން ހަމައެކަނި ރަނުގެ ސްޓޭޓްމަންޓްތަކަށް ހިމެނޭ.",
        "headerTitle": "އެޑްޖަސްޓްމަންޓް",
        "linesTitle": "ލައިންތައް",
        "whatHeadline": "ގްރޫޕް އެޑްޖަސްޓްމަންޓްތަކާ ބެހޭގޮތުން",
        "whatGroupAccounts": "ލައިންތައް ޕޯސްޓްކުރެވޭނީ ގްރޫޕް އެކައުންޓްތަކަށް، އެއީ ރަނުގެ ގްރޫޕް ޗާޓުގެ އެކައުންޓްތަކެވެ، ރަނުގެ ހުށަހަޅާ ފައިސާއިން. އެއްވެސް ލޯކަލް އެކައުންޓެއް މެޕްނުކުރެވޭ ގްރޫޕް އެކައުންޓެއް ބޭނުންކުރެވޭނެ ނޫން، ސަބަބަކީ އޭގެ ސްޓޭޓްމަންޓް ބައި ބުނެވޭނެ ގޮތެއް ނެތުން.",
        "whatApproval": "ގްރޫޕް ކޮންޓްރޮލަރުގެ ފިޔަވަޅުން އެޕްރޫވަލްސް އިންބޮކްސްގައި ފާސްކުރެވޭ. ތިޔަބޭފުޅާ ތައްޔާރުކުރި ނުވަތަ ހުށަހެޅި އެޑްޖަސްޓްމަންޓެއް ތިޔަބޭފުޅާ ފާސްކުރެވޭނެ ނޫން.",
        "runRequired": "މި އެޑްޖަސްޓްމަންޓް ހުރި ރަން ޗޫޒްކުރޭ.",
        "descriptionRequired": "އެޑްޖަސްޓްމަންޓަކީ ކޮބައިކަން ބުނޭ.",
        "justificationRequired": "ޖަސްޓިފިކޭޝަނެއް ބޭނުންވޭ.",
        "unbalanced": "ޑެބިޓާއި ކްރެޑިޓް {difference} {currency} އިން ތަފާތުވޭ. އެޑްޖަސްޓްމަންޓެއް ބެލެންސްވާންވާނެ.",
        "lineAccountRequired": "ގްރޫޕް އެކައުންޓެއް ޗޫޒްކުރޭ.",
        "lineAmountInvalid": "ދެ ދަހަކަ އިންސައްތައަށްވުރެ ގިނައިން ނުވާ އަދަދެއް ޖަހާ.",
        "lineOneSide": "ލައިނަކީ ޑެބިޓެއް ނުވަތަ ކްރެޑިޓެއް، ދެކޮޅެއް ނޫން.",
        "lineAmountRequired": "ސުން އިން ބޮޑު ޑެބިޓެއް ނުވަތަ ކްރެޑިޓެއް ޖަހާ.",
        "reloaded": "ތިޔަބޭފުޅުން ހުޅުވާފައި އޮތްއިރު އެހެން ފަރާތަކުން މި ޑްރާފްޓް ބަދަލުކުރި. އެ ރީލޯޑުކޮށްފި؛ ތިޔަބޭފުޅުންގެ އެންޓްރީތައް ބަލާ ދެން ސޭވްކުރޭ.",
        "runRefused": "ރަން #{id} އަށް އެޑްޖަސްޓްމަންޓެއް ނުލިބޭނެ: އެއީ ޝާއިޢުކުރެވިފައި، ބަދަލުކުރެވިފައި، ގްރޫޕް ޗާޓެއް ނެތް، ނުވަތަ ތިޔަބޭފުޅާއަށް ނުފެންނާ ރަނެއް.",
        "chooseRunFirst": "ރަނުގެ ގްރޫޕް އެކައުންޓްތައް ބަލަން ރަނެއް ޗޫޒްކުރޭ.",
        "noChartPermission": "ގްރޫޕް އެކައުންޓްތައް ލިސްޓްކުރަން ޗާޓް އޮފް އެކައުންޓްސް އަދި އޭގެ ވެލިއުތައް ބެލުމުގެ ހުއްދަ ބޭނުންވޭ.",
        "noGroupAccounts": "މި ރަނުގެ މުއްދަތު ނިމޭ ދުވަހު އެއްވެސް ގްރޫޕް އެކައުންޓެއް އެކްޓިވް ނުވޭ.",
        "notDraft": "އެޑިޓްކުރެވޭނީ ޑްރާފްޓް އެޑްޖަސްޓްމަންޓް ހަމައެކަނި.",
        "preparerOnly": "ޑްރާފްޓެއް އެޑިޓްކުރެވޭނީ އެ ތައްޔާރުކުރި ފަރާތަށް ހަމައެކަނި. އޭގެ ބަދަލުގައި އާ އެޑްޖަސްޓްމަންޓެއް ތައްޔާރުކުރޭ.",
        "backToAdjustment": "އެޑްޖަސްޓްމަންޓަށް ރުޖޫޢަވޭ"
      },
      "view": {
        "headerTitle": "އެޑްޖަސްޓްމަންޓް",
        "preparerOnly": "{name} މި ޑްރާފްޓް ތައްޔާރުކުރީތީ އެޑިޓްކުރެވޭނީ އެ ފަރާތަށް ހަމައެކަނި. ހުށަހެޅުން ނުވަތަ ވިތްޑްރޯކުރުން ތިޔަބޭފުޅާއަށް ކުރެވޭނެ.",
        "awaitingApproval": "އެޕްރޫވަލްސް އިންބޮކްސްގައި ގްރޫޕް ކޮންޓްރޮލަރުގެ ފިޔަވަޅަށް މަޑުކުރަނީ.",
        "youPrepared": "މި އެޑްޖަސްޓްމަންޓް ތައްޔާރުކުރީ ތިޔަބޭފުޅާ، ސަބަބުން ފާސްކުރުމަށް ތިޔަބޭފުޅާއާ ނުދެންނެވޭ.",
        "youSubmitted": "މި އެޑްޖަސްޓްމަންޓް ހުށަހެޅީ ތިޔަބޭފުޅާ، ސަބަބުން ފާސްކުރުމަށް ތިޔަބޭފުޅާއާ ނުދެންނެވޭ.",
        "openInbox": "އެޕްރޫވަލްސް އިންބޮކްސް ހުޅުވާ",
        "rejectedHeadline": "މި އެޑްޖަސްޓްމަންޓް ރަދުކުރެވުނު",
        "approvedExplainer": "ފާސްކުރެވިފައި. އެއީ ރަނުގެ ސްޓޭޓްމަންޓްތަކުގެ ބައެއް.",
        "submittedBy": "ހުށަހެޅި ފަރާތް",
        "approvedBy": "ފާސްކުރި ފަރާތް",
        "withdrawnBy": "ވިތްޑްރޯކުރި ފަރާތް",
        "carriedFrom": "ގެނެވުނީ",
        "decisionNote": "ނިންމުމުގެ ނޯޓް"
      },
      "toasts": {
        "saved": "ޑްރާފްޓް ސޭވްކުރެވުނު",
        "savedDetail": "ފާސްކުރެވެންދެން ރަނުގެ ސްޓޭޓްމަންޓްތަކުގައި ނުހިމެނޭ.",
        "submitted": "{no} ފާސްކުރުމަށް ހުށަހެޅުނު",
        "withdrawn": "{no} ވިތްޑްރޯކުރެވުނު"
      },
      "withdrawConfirm": {
        "title": "މި އެޑްޖަސްޓްމަންޓް ވިތްޑްރޯކުރަންތަ؟",
        "message": "އެއީ ރަން ޝާއިޢުކުރުމުން ހުރަސްކުރެއްވިޔަ ނުވާނެ، އަދި މަޑުކުރަމުންދާ އެޕްރޫވަލެއް ކެންސަލްވާނެ. ވިތްޑްރޯކުރެވުނު އެޑްޖަސްޓްމަންޓެއް އަނެއްކާވެސް ހުށަހެޅޭނެ ނޫން."
      }
    },
    "statementsPack": {
      "title": "ކޮންސޮލިޑޭޓެޑް ކޭޝް ފްލޯ އާއި އިކުއިޓީ",
      "description": "މި ރަނުގެ ކޭޝް ފްލޯ ސްޓޭޓްމަންޓާއި އިކުއިޓީގެ ބަދަލުތަކުގެ ސްޓޭޓްމަންޓް، ކޮންމެއަކީވެސް ރީކޮންސައިލްކުރެވިފައި.",
      "loadFailed": "ސްޓޭޓްމަންޓްތައް ލޯޑެއް ނުވި",
      "elsewhere": "ހަމަ އެ ޕެކްގެ އިންކަމް ސްޓޭޓްމަންޓާއި ބެލެންސް ޝީޓް އޮތީ އެމީހުންގެ އަމިއްލަ ޓެބްތަކުގައި.",
      "reconciles": "ރީކޮންސައިލްވޭ",
      "doesNotReconcile": "ރީކޮންސައިލްނުވޭ",
      "cashFlow": {
        "title": "ކޭޝް ފްލޯ ސްޓޭޓްމަންޓް",
        "line": "ލައިން",
        "entity": "ލީގަލް އެންޓިޓީ",
        "amount": "ކޭޝްގެ އަސަރު ({currency})",
        "netProfit": "ނެޓް ފައިދާ",
        "netChange": "ފައިސާ ބަދަލުގެ އަސަރުކުރުމުގެ ކުރިން ނެޓް ބަދަލު",
        "fxEffect": "ފައިސާ ރޭޓް ބަދަލުތަކުގެ ކޭޝަށް އަސަރު",
        "netChangeInCash": "ކޭޝްގެ ނެޓް ބަދަލު",
        "openingCash": "ފެށުމުގައި ހުރި ކޭޝް",
        "closingCash": "ނިމުމުގައި ހުރި ކޭޝް",
        "reconcileDetail": "ގްރޫޕް ކޭޝް {movement} {currency} އިން ބަދަލުވި. ސްޓޭޓްމަންޓާ ހުރި ތަފާތު: {difference} {currency} (ރައުންޑިންގ ހުއްދަ {allowance}).",
        "fxTitle": "ލީގަލް އެންޓިޓީ އާ ގުޅޭ ފައިސާ ރޭޓް އަސަރު",
        "baseCurrency": "ފައިސާ",
        "openingRate": "ފެށުމުގެ ރޭޓް",
        "closingRate": "ނިމުމުގެ ރޭޓް"
      },
      "equity": {
        "title": "އިކުއިޓީގެ ބަދަލުތަކުގެ ސްޓޭޓްމަންޓް",
        "row": "ބަދަލު",
        "posted": "ޕޯސްޓްކުރެވިފައިވާ އިކުއިޓީ",
        "retained": "ރިޓެއިންޑް އާނިންގްސް",
        "reserve": "ޓްރާންސްލޭޝަން ރިޒަވް",
        "entries": "ކޮންސޮލިޑޭޝަން އެންޓްރީތައް",
        "total": "ޖުމްލަ",
        "minority": "މައިނޯރިޓީ އިންޓަރެސްޓް",
        "owners": "މައި ކުންފުނީގެ މަޢުލޫމާތު ވެރިން",
        "reconcileDetail": "ނިމުމުގައި ހުރި އިކުއިޓީ {closing} {currency} ބެލެންސް ޝީޓުގެ {balanceSheet} {currency} އާ ދިމާކުރުން (ތަފާތު {balanceSheetDifference}). ނުވާހަކަދައްކާފައިވާ ބަދަލު: {difference} {currency} (ރައުންޑިންގ ހުއްދަ {allowance})."
      }
    },
    "translation": {
      "title": "ފައިސާ ޓްރާންސްލޭޝަން ތަޙުލީލު",
      "description": "ކޮންމެ ލީގަލް އެންޓިޓީއަކަށް، ރޭޓްތަކާއި ދެ ފައިސާގައިވެސް ކޮންމެ ބެލެންސެއްގެ އަދަދާއި ޓްރާންސްލޭޝަން ރިޒަވަށް ކޮންމެއެއްގެ ބައިވެރިވުން.",
      "loadFailed": "ޓްރާންސްލޭޝަން ތަޙުލީލު ލޯޑެއް ނުވި",
      "parent": "ކޮންސޮލިޑޭޓްކުރާ މައި ކުންފުނި",
      "rate": "ރޭޓް",
      "effect": "ރިޒަވް އަސަރު",
      "cta": "ޓްރާންސްލޭޝަން ރިޒަވް ބަދަލު (ރަން)",
      "ctaRecomputed": "ސަތަރުތަކުން އަލުން ހިސާބުކުރި",
      "ctaMatches": "އެއްގޮތްވުން",
      "matches": "އެއްގޮތްވޭ",
      "doesNotMatch": "އެއްގޮތެއް ނުވޭ",
      "effectsTotal": "ސަތަރުތަކުގެ އަސަރުގެ ޖުމްލަ",
      "residual": "ރައުންޑިންގ ބާކީ",
      "groupTitle": "ގްރޫޕުގެ ޓްރާންސްލޭޝަން ރިޒަވް",
      "balanceType": "ބެލެންސުގެ ބާވަތް",
      "reserveOpening": "ފެށުމުގައި ހުރި ރިޒަވް",
      "reserveMovement": "ބަދަލު",
      "reserveClosing": "ނިމުމުގައި ހުރި ރިޒަވް",
      "tbCheck": "ރިޒަވް ހިމެނިފައި ޓްރާންސްލޭޓްކުރެވުނު ޓްރަޔަލް ބެލެންސް {difference} {currency} އިން ތަފާތުވޭ."
    },
    "minority": {
      "title": "މައިނޯރިޓީ އިންޓަރެސްޓް ޝެޑިއުލް",
      "description": "ކޮންމެ މެންބަރެއްގެ ޓްރާންސްލޭޓްކުރެވުނު ނެޓް މުދަލާއި ނަތީޖާގެ ކޮންޓްރޯލް ނުކުރާ ބައި.",
      "loadFailed": "މައިނޯރިޓީ އިންޓަރެސްޓް ޝެޑިއުލް ލޯޑެއް ނުވި",
      "tableTitle": "ކޮންޓްރޯލް ނުކުރާ އިންޓަރެސްޓްތައް",
      "columns": {
        "entity": "ލީގަލް އެންޓިޓީ",
        "method": "ގޮތް",
        "ownership": "މިލްކުވެރިކަން",
        "minorityPct": "މައިނޯރިޓީ",
        "netAssets": "ނެޓް މުދާ ({currency})",
        "minorityEquity": "މައިނޯރިޓީ އިކުއިޓީ ({currency})",
        "netIncome": "ނެޓް އާމްދަނީ ({currency})",
        "minorityIncome": "މައިނޯރިޓީ އާމްދަނީ ({currency})",
        "ownersIncome": "މިލްކުވެރިންގެ އާމްދަނީ ({currency})",
        "reconciles": "ރީކޮންސައިލްވޭ"
      },
      "totals": "ޖުމްލަ",
      "reconcilesToRun": "ޖުމްލަ އަދަދުތައް ރަނުގެ އަމިއްލަ މައިނޯރިޓީ އިންޓަރެސްޓް އަދަދުތަކާ އެއްގޮތް.",
      "doesNotReconcileToRun": "ޖުމްލަ އަދަދުތައް ރަނުގެ އަމިއްލަ މައިނޯރިޓީ އިންޓަރެސްޓް އަދަދުތަކާ ތަފާތު.",
      "periodsTitle": "މިލްކުވެރިކަމުގެ މުއްދަތުތައް: {code}"
    },
    "contribution": {
      "title": "ކުންފުނިތަކުގެ ބައިވެރިވުމުގެ ތަޙުލީލު",
      "description": "މިހާތަނަށް ގަބޫލުކުރެވިފައިވާ އިލިމިނޭޝަންތަކަށްފަހު ގްރޫޕްގެ އާމްދަނީއާއި ފައިދާއާއި ނެޓް މުދަލަށް ކޮންމެ ލީގަލް އެންޓިޓީއެއްގެ ބައިވެރިވުން.",
      "loadFailed": "ބައިވެރިވުމުގެ ތަޙުލީލު ލޯޑެއް ނުވި",
      "tableTitle": "ލީގަލް އެންޓިޓީ އާ ގުޅޭ ބައިވެރިވުން",
      "adjustmentsRow": "ގްރޫޕް އެޑްޖަސްޓްމަންޓްތައް",
      "totalRow": "ގްރޫޕްގެ ޖުމްލަ",
      "columns": {
        "entity": "ލީގަލް އެންޓިޓީ",
        "ownership": "މިލްކުވެރިކަން",
        "revenue": "އާމްދަނީ ({currency})",
        "expenses": "ޚަރަދު ({currency})",
        "profit": "ފައިދާ ({currency})",
        "profitMinority": "މައިނޯރިޓީ ބައި ({currency})",
        "profitAttributable": "މިލްކުވެރިންގެ ބައި ({currency})",
        "assets": "އިލިމިނޭޝަންތަކަށްފަހު މުދާ ({currency})",
        "liabilities": "އިލިމިނޭޝަންތަކަށްފަހު ޒިންމާ ({currency})",
        "netAssets": "ނެޓް މުދާ ({currency})",
        "revenueShare": "އާމްދަނީގެ ބައި",
        "profitShare": "ފައިދާގެ ބައި",
        "netAssetsShare": "ނެޓް މުދަލުގެ ބައި"
      },
      "reconcileDetail": "ކޮންސޮލިޑޭޓެޑް ސްޓޭޓްމަންޓްތަކާ ހުރި ތަފާތު: {difference} {currency}."
    }
  },
  "mfg": {
    "bomStatuses": {
      "active": "ހަރަކާތްތެރި",
      "draft": "ދެލިކޮޕީ",
      "obsolete": "ބާވެފައި"
    },
    "boms": {
      "actions": {
        "activate": "ހަރަކާތްތެރިކުރޭ",
        "add": "އައު ތަކެތީގެ ލިސްޓު",
        "addAlternate": "އޯލްޓަނޭޓެއް އިތުރުކުރޭ",
        "addLine": "ބައެއް އިތުރުކުރޭ",
        "compare": "ވަރޝަންތައް އަޅާކިޔާ",
        "discard": "ދެލިކޮޕީ އުކާލާ"
      },
      "activateBlocked": {
        "empty": "ހަރަކާތްތެރިކުރެވޭނީ ތަކެތީގެ ލިސްޓުގައި މަދުވެގެން އެއް ބައި ހުރެގެން.",
        "notDraft": "ހަރަކާތްތެރިކުރެވޭނީ ދެލިކޮޕީއެއް އެކަނި.",
        "unsaved": "ފުރަތަމަ ބަދަލުތައް ރައްކާކުރައްވާ: ހަރަކާތްތެރިކުރުމުގައި ބޭނުންކުރެވޭނީ ރައްކާކުރެވުނު ބައިތައް، ސްކްރީނުގައި ހުރި ބައިތަކެއް ނޫން."
      },
      "activated": "ތަކެތީގެ ލިސްޓު ހަރަކާތްތެރިކުރެވިއްޖެ",
      "activatedDetail": "މި ތަކެއްޗަށް ކުރިން ހަރަކާތްތެރި ވަރޝަނެއް އޮތްނަމަ މިހާރު އެ ބާވެއްޖެ.",
      "alternateLine": "{item} — ޔުނިޓަކަށް {qty}، އިސްކަން {priority}",
      "alternateNotesAria": "ބައި {line} ގެ އޯލްޓަނޭޓް {alternate} ގެ ނޯޓްތައް",
      "alternatePriorityAria": "ބައި {line} ގެ އޯލްޓަނޭޓް {alternate} ގެ އިސްކަން",
      "alternateQtyAria": "ބައި {line} ގެ އޯލްޓަނޭޓް {alternate} ގެ ޔުނިޓަކަށްވާ ޢަދަދު",
      "alternatesCaption": "ބައި {line} ގެ އޯލްޓަނޭޓްތައް",
      "alternatesCount": "އޯލްޓަނޭޓް ({count})",
      "alternatesExplainer": "މިއީ މި ބަޔަށް ފާސްކުރެވިފައިވާ ދެވަނަ މަޞްދަރުތައް. އޭ.ޕީ.އައި އިން މި ރައްކާކޮށް ދިނަސް، އުފެއްދުމުގެ އޯޑަރެއްގައި ބައެއް އޯލްޓަނޭޓަކަށް ބަދަލުކުރާނެ ގޮތެއް ނެތުމުން، އެފަދަ ބަޓަނެއް ނުދައްކާ.",
      "alternatesHeadline": "އޯލްޓަނޭޓް ބަޔާންކުރެވޭ، ބަދަލެއް ނުކުރެވޭ",
      "backToList": "ހުރިހާ ތަކެތީގެ ލިސްޓުތައް",
      "collapse": "އޮނިގަނޑު ފޮރުވާ",
      "columns": {
        "alternateItem": "އޯލްޓަނޭޓް ތަކެތި",
        "component": "ބައި",
        "components": "ބައިތައް",
        "phantom": "ފެންޓަމް",
        "phantoms": "ފެންޓަމް",
        "priority": "އިސްކަން",
        "quantityPer": "ޔުނިޓަކަށް ޢަދަދު",
        "scrapPct": "ސްކްރެޕް %",
        "version": "ވަރޝަން"
      },
      "compare": {
        "against": "އަޅާކިޔާނީ",
        "caption": "ދެ ވަރޝަނުގެ ބައިތަކުގެ ލައިންތަކާއި، ކޮންމެއެއްގައި ތަފާތުވާ ތަކެތި.",
        "changes": {
          "added": "އިތުރުކުރެވުނު",
          "changed": "ބަދަލުވި",
          "removed": "ނަގާލެވުނު",
          "unchanged": "އެއްގޮތް"
        },
        "description": "އެ ބާވަތުގެ އެހެން ވަރޝަނަކާ ލައިން ބައި ލައިން.",
        "fields": {
          "alternates": "ބަދަލުތައް",
          "isPhantom": "ފެންޓަމް",
          "quantityPer": "ކޮންމެއަކަށް މިންވަރު",
          "scrapPct": "ސްކްރެޕް %",
          "uomCode": "ޔުނިޓް"
        },
        "headline": "{count} ބައިގެ ލައިން ތަފާތު",
        "hideSame": "ބަދަލުނުވާ ތަކެތި ފޮރުވާ",
        "identical": "ދެ ވަރޝަނުގައިވެސް ބައިތަކުގެ ކޮންމެ ލައިނެއް އެއްގޮތް.",
        "onlyVersion": "މި ބާވަތުގައި އަޅާކިޔޭނެ އެހެން ވަރޝަނެއް ނެތް.",
        "option": "ވަރޝަން {version} ({status})",
        "pairingRule": "ލައިންތައް ގުޅުވެނީ ބައިން، އަދި އެއް ބައެއް އެއްފަހަރަށްވުރެ ގިނައިން އޮތްނަމަ، އެ ލައިންތައް އޮތް ތަރުތީބުން — \"އެހެން ވަރޝަނެއްގެ އެއް ލައިން\" ދެނެގަނެވޭ އައިޑެންޓިޓީއެއް ބީއޯއެމްގައި ނުހުރޭ.",
        "placeholder": "ވަރޝަނެއް ހޮވާ",
        "showSame": "ބަދަލުނުވާ ތަކެތި ދައްކާ",
        "thatVersion": "ވަރޝަން {version}",
        "thisVersion": "ވަރޝަން {version}",
        "title": "ވަރޝަން {version} އަޅާކިޔާ",
        "whatMoved": "ބަދަލުވި އެއްޗެހި"
      },
      "componentsEditable": "އެއް ސޭވަކުން މުޅި ސެޓް ބަދަލުވާނެ. ހަމައެކަނި ދެލިކޮޕީއެއް އެޑިޓްކުރެވޭނެ.",
      "componentsReadOnly": "މި ވަރޝަން ދެލިކޮޕީއެއް ނޫން ކަމުން، ބައިތައް ބަދަލެއް ނުކުރެވޭނެ.",
      "componentsTitle": "ބައިތައް",
      "confirm": {
        "activate": {
          "label": "ހަރަކާތްތެރިކުރޭ",
          "title": "މި ތަކެތީގެ ލިސްޓު ހަރަކާތްތެރިކުރޭ",
          "willDo": "މުސްތަޤްބަލުގެ ކޮންމެ އުފެއްދުމުގެ އޯޑަރެއް ފުޅާކުރާނެ ވަރޝަނަކަށް މި ހަދާނެ، އަދި މި ތަކެއްޗަށް ކުރިން ހަރަކާތްތެރިކޮށް އޮތް ވަރޝަން ބާކޮށްލާނެ."
        },
        "discard": {
          "label": "އުކާލާ",
          "title": "މި ދެލިކޮޕީ އުކާލާ",
          "willDo": "މި ދެލިކޮޕީ ވަރޝަން ނަގާނެ. އުކާލެވޭނީ ދެލިކޮޕީއެއް ކަމުން، އުފެއްދުމުގެ އޯޑަރެއްގައި ބޭނުންކުރެވުނު އެއްޗެއް ގެއްލޭކަށް ނެތް."
        }
      },
      "conflictExplainer": "ޞަފްޙާ އަލުން ލޯޑްކުރައްވައި، ބަދަލުވީ ކޮންއެއްޗެއްތޯ ބައްލަވައި، ދެން އަލުން އެޑިޓްކުރައްވާ.",
      "conflictHeadline": "މިއަށް އެހެން ބޭފުޅަކު ބަދަލު ގެނެސްފި",
      "copyFrom": {
        "createdDetail": "ވަރޝަން {version}، ބައިތަކުގެ {count} ލައިން ކޮޕީކޮށްގެން.",
        "explainer": "ބައިތައް އަންނާނީ އެތަކެތީގެ މިންވަރާއި، ޔުނިޓާއި، ސްކްރެޕާއި، ފެންޓަމް ފްލެގާއި، ނޯޓުތަކާއި، ބަދަލުތަކާއެކު. ހިނގާ މުއްދަތުގެ ވިންޑޯތަކާއި، ކޯ-ޕްރޮޑަކްޓް އައުޓްޕުޓްތަކާއި، އުއްމީދުކުރެވޭ ޔީލްޑް ހުންނާނީ އަސްލު ބީއޯއެމްގައި — އެއީ އެ ބީއޯއެމްގެ ތާރީޚް، މި އުފެއްދުމުގެއެއް ނޫން.",
        "headline": "ބައިތަކުގެ {count} ލައިން ކޮޕީކުރެވޭނެ",
        "hint": "މިހާރު ހުރި ބީއޯއެމްއެއްގެ ބައިތައް އައު ބީއޯއެމްއަށް ކޮޕީކުރޭ.",
        "label": "ކޮޕީކުރާނީ",
        "loading": "އަސްލު ބީއޯއެމް ކިޔަނީ…",
        "option": "{item} — ވަރޝަން {version} ({status})",
        "placeholder": "ހުސްކޮށް ފަށާ"
      },
      "create": "އައު ތަކެތީގެ ލިސްޓު",
      "createDescription": "އުފައްދާ އެއް ތަކެއްޗަށް ދެލިކޮޕީއެއް ފައްޓަވާ.",
      "createExplainer": "އުފެދޭނީ ހުހަށް، ދެލިކޮޕީއެއްގެ ގޮތުގައި. ބައިތައް އިތުރުކުރެވޭނީ ދެން ހުޅުވޭ އެޑިޓަރުގައި، އެތަނުގައި ކޮންމެ ބައެއް އިތުރުކުރާއިރު ސައިކަލް ގާޑުން ބަލާނެ.",
      "createFailed": "ނުހެދުނު",
      "created": "ތަކެތީގެ ލިސްޓު ހެދިއްޖެ",
      "createdDetail": "ވަރޝަން {version}، ދެލިކޮޕީ.",
      "detailDescription": "އޮނިގަނޑު، ބައިތައް އަދި މަރުޙަލާތައް.",
      "discarded": "ދެލިކޮޕީ އުކާލެވިއްޖެ",
      "discardedDetail": "މިއަށް އެއްވެސް އެއްޗެއް ރިޢާޔަތްކޮށްފައެއް ނުވޭ.",
      "duplicateLine": "ބައި {line} ގެ ކޮޕީއެއް",
      "emptyDescription": "އުފައްދާ ތަކެއްޗަކަށް އެއް ހައްދަވާ. މިއެއް ނެތި އުފެއްދުމުގެ އޯޑަރެއް ދޫކޮށެއް ނުލެވޭނެ.",
      "emptyLinesDescription": "ބައިތަކުގެ ޓެބުން ބައިތައް އިތުރުކުރައްވާ. ބައެއް ނެތް ލިސްޓެއް ހަރަކާތްތެރިއެއް ނުކުރެވޭނެ.",
      "emptyLinesTitle": "މި ތަކެތީގެ ލިސްޓު ހުސް",
      "emptyTitle": "އަދި ތަކެތީގެ ލިސްޓެއް ނެތް",
      "expand": "އޮނިގަނޑު ދައްކާ",
      "expandAria": "{item} ގެ އޮނިގަނޑު ދައްކާ",
      "explosionExplainer": "ޙަޤީޤީ ބޭނުމަކީ ސްކްރެޕާއެކު އިތުރުކުރެވި، ފެންޓަމް އެއްކުރެވި، ހުރިހާ މަގަކުން ޖަމާކުރެވި، ސްޓޮކް ލެޖަރުގެ މިންވަރަށް ބައްޓަންކުރެވުނު ޢަދަދު. އެ ހިސާބުކުރަނީ ސާވަރުން ދޫކޮށްލާ ވަގުތު، އަދި ފެންނާނީ އުފެއްދުމުގެ އޯޑަރުގެ މެޓީރިއަލް ލިސްޓުގައި.",
      "explosionHeadline": "މިތާނގައި ހުރި ޢަދަދުތަކަކީ ލިޔުނު ގޮތަށް، ބެލެނިވެރި ބަޔަކަށް",
      "fields": {
        "producedItem": "އުފައްދާ ތަކެތި"
      },
      "incompleteLines": "ރައްކާކުރެވޭނީ ކޮންމެ ބައެއްގައި ތަކެއްޗެއް، ޔުނިޓަކަށްވާ ޢަދަދެއް އަދި ޔުނިޓެއް ހުރެގެން.",
      "listDescription": "ކޮންމެ އުފައްދާ ތަކެއްޗެއް ހެދިފައިވަނީ ކޯއްޗަކުންކަން — ވަރޝަންކުރެވި، ކޮންމެ ތަކެއްޗަކަށް އެއް ހަރަކާތްތެރި ވަރޝަން.",
      "listTitle": "ތަކެތީގެ ލިސްޓުތައް",
      "loadFailed": "ތަކެތީގެ ލިސްޓުތައް ލޯޑެއް ނުކުރެވުނު",
      "noAlternates": "އޯލްޓަނޭޓެއް ބަޔާންކޮށްފައެއް ނުވޭ.",
      "noSubAssembly": "މި ބައިގެ އަމިއްލަ ހަރަކާތްތެރި ތަކެތީގެ ލިސްޓެއް ނެތް؛ މިއީ ގަނެގެން ނުވަތަ އޮތްގޮތަށް ބަހައްޓާ އެއްޗެއް.",
      "notDraftExplainer": "އެޑިޓްކުރެވޭނީ ދެލިކޮޕީއެއް އެކަނި. އޮނިގަނޑު ބަދަލުކުރައްވަން އައު ވަރޝަނެއް ހައްދަވާ.",
      "notesAria": "ބައި {line} ގެ ނޯޓްތައް",
      "phantom": "ފެންޓަމް",
      "phantomNoBomExplainer": "ފެންޓަމް ބައެއްގައި އަމިއްލަ ހަރަކާތްތެރި ތަކެތީގެ ލިސްޓެއް އޮންނަން ޖެހޭނެ. އެ ހަމަނުވަނީސް މުޅި މި އޮނިގަނޑު ދޫކޮށްލުން ބަލައެއް ނުގަނެވޭނެ.",
      "phantomNoBomHeadline": "މި ފެންޓަމްގެ އޮނިގަނޑެއް ނެތް",
      "quantityAria": "ބައި {line} ގެ ޔުނިޓަކަށްވާ ޢަދަދު",
      "rail": {
        "orders": "މި ތަކެއްޗަށް އުފެއްދުމުގެ އޯޑަރުތައް"
      },
      "railTitle": "{item} ގެ ތަކެތީގެ ލިސްޓު، v{version}",
      "removeAlternate": "ބައި {line} ގެ އޯލްޓަނޭޓް {alternate} ނަގާ",
      "removeLine": "ބައި {line} ނަގާ",
      "saveFailed": "ބައިތައް ރައްކާނުކުރެވުނު",
      "saved": "ބައިތައް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "މުޅި ސެޓް ބަދަލުކުރެވިއްޖެ.",
      "scrapAria": "ބައި {line} ގެ ސްކްރެޕް އިންސައްތަ",
      "scrapOf": "{pct}% ސްކްރެޕް",
      "structureDescription": "ފެންޓަމް ލެވެލްތައް ފުޅާކޮށްފައި، ސަބަބަކީ ސާވަރުގެ ފުޅާކުރުން އެއިން ސީދާ ދާތީ. ސަބް-އެސެމްބްލީތަކުން ފުޅާކުރުން ހުއްޓޭ، އަދި އެ ހުޅުވޭނީ އެދުމުން.",
      "structureTitle": "އޮނިގަނޑު",
      "subAssemblyNote": "މިއީ ސަބް-އެސެމްބްލީއެއް. ފުޅާކުރުން މިތަނުން ހުއްޓޭ: މި އޯޑަރުން މިއީ ފުރިހަމަ ބައެއްގެ ގޮތުގައި ދޫކުރެވޭނެ، އަދި މި އުފެއްދުމަކީ ވަކި އުފެއްދުމުގެ އޯޑަރެއް.",
      "summaryTitle": "ތަކެތީގެ ލިސްޓު",
      "tabs": {
        "components": "ބައިތައް",
        "structure": "އޮނިގަނޑު"
      },
      "tabsLabel": "ތަކެތީގެ ލިސްޓުގެ ބައިތައް",
      "timeline": {
        "created": "ހެދުނު"
      },
      "unsaved": "ރައްކާނުކުރެވޭ ބަދަލުތައް",
      "unsavedGuard": {
        "title": "ރައްކާނުކުރާ ބަދަލުތައް ދޫކޮށްލާނަންތޯ؟",
        "message": "މި BOM ގައި ރައްކާނުކުރެވޭ ބަދަލުތަކެއް އެބަހުރި. މިހާރު ދޫކޮށްލައިފިނަމަ، އެ ބަދަލުތައް ގެއްލޭނެ.",
        "confirm": "ބަދަލުތައް ދޫކޮށްލާ",
        "cancel": "އިތުރަށް އެޑިޓްކުރޭ"
      },
      "uomAria": "ބައި {line} ގެ ޔުނިޓް",
      "versionLabel": "ވަރޝަން {version}"
    },
    "capacity": {
      "barAria": "{workCenter}، {week} ގެ ހަފްތާ: ކެޕޭސިޓީގެ {pct}%",
      "columns": {
        "capacity": "ކެޕޭސިޓީ ގަޑިއިރު / ހަފްތާ",
        "load": "ލޯޑް %",
        "planned": "ރޭވިފައިވާ ގަޑިއިރު"
      },
      "description": "ކޮންމެ މަސައްކަތު ސެންޓަރަކަށް ހަފްތާއަކަށް ރޭވިފައިވާ ލޯޑް، އެ ސެންޓަރުގެ ކެޕޭސިޓީއާ އަޅާކިޔައިގެން.",
      "emptyDescription": "ލޯޑް އަންނަނީ، މި ހަފްތާތަކުގައި ފެށުމަށް ރޭވިފައިވާ އުފެއްދުމުގެ އޯޑަރުތަކުގެ ނުނިމޭ އޮޕަރޭޝަންތަކުން.",
      "emptyTitle": "މި މުއްދަތުގައި ރޭވިފައިވާ ލޯޑެއް ނެތް",
      "fields": {
        "weekStart": "ހަފްތާ ފެށޭ",
        "weeks": "ހަފްތާ"
      },
      "loadFailed": "ކެޕޭސިޓީ ބައި ލޯޑެއް ނުކުރެވުނު",
      "loadPct": "ކެޕޭސިޓީގެ {pct}%",
      "loadTitle": "ހަފްތާއަކަށް ރޭވިފައިވާ ގަޑިއިރު",
      "methodExplainer": "ސެޓަޕް އެއްފަހަރު، އަދި އޯޑަރުގެ ޢަދަދުން ގުނަކުރެވިފައިވާ ހިންގާ ވަގުތު — ނުނިމޭ އޮޕަރޭޝަންތަކަށް، އޯޑަރު ފެށުމަށް ރޭވިފައިވާ ހަފްތާއިން ބަހައިގެން. އިންސައްތައަކީ ސާވަރުގެ ޢަދަދު؛ ހަމައެކަނި ބާރުގެ ފުޅާމިން ހިފެހެއްޓެނީ، އެހެންވެ ލޯޑް ބޮޑު ސެންޓަރެއްގައި 100% އަށްވުރެ މަތިން ފެންނާނެ.",
      "methodHeadline": "މި ލޯޑް ހިސާބުކުރެވޭ ގޮތް",
      "noCapacity": "ކެޕޭސިޓީއެއް ކަނޑައަޅާފައެއް ނުވޭ",
      "title": "ކެޕޭސިޓީ",
      "weekStartHint": "ހޯމަ ދުވަހެއް. ރިޕޯޓް ބަހަނީ އައި.އެސް.އޯ ހަފްތާއިން.",
      "weeksHint": "ދައްކާނެ ހަފްތާގެ ޢަދަދު، 26 އާ ހަމައަށް."
    },
    "costingModes": {
      "actual": "ޙަޤީޤީ އަގުގައި",
      "standard": "ސްޓޭންޑަޑް އަގުގައި"
    },
    "fields": {
      "bom": "ތަކެތީގެ ލިސްޓު",
      "company": "ކުންފުނި",
      "completion": "ނިންމުން",
      "description": "ތަފްޞީލު",
      "issueDate": "ދޫކުރި ތާރީޚް",
      "item": "ތަކެތި",
      "itemPlaceholder": "ތަކެއްޗެއް ޚިޔާރުކުރައްވާ",
      "laborMinutes": "މަސައްކަތުގެ މިނެޓް",
      "laborRate": "ގަޑިއިރަކަށް މަސައްކަތުގެ ރޭޓް",
      "lotNo": "ލޮޓް ނަންބަރު",
      "machineMinutes": "މެޝިނުގެ މިނެޓް",
      "materialHandling": "މެޓީރިއަލް ބެލެހެއްޓުން",
      "name": "ނަން",
      "notes": "ނޯޓްތައް",
      "operation": "އޮޕަރޭޝަން",
      "overheadRate": "ގަޑިއިރަކަށް އޯވަހެޑް ރޭޓް",
      "plannedEnd": "ރޭވިފައިވާ ނިމޭ ތާރީޚް",
      "plannedStart": "ރޭވިފައިވާ ފެށޭ ތާރީޚް",
      "quantityPlanned": "ރޭވިފައިވާ ޢަދަދު",
      "receiptDate": "ބަލައިގަތް ތާރީޚް",
      "routing": "ރޫޓިންގ",
      "standardUnitCost": "ސްޓޭންޑަޑް ޔުނިޓް އަގު",
      "uom": "ޔުނިޓް",
      "warehouse": "ގުދަން",
      "warehousePlaceholder": "ގުދަނެއް ޚިޔާރުކުރައްވާ",
      "workCenter": "މަސައްކަތު ސެންޓަރު",
      "workCenterPlaceholder": "މަސައްކަތު ސެންޓަރެއް ޚިޔާރުކުރައްވާ"
    },
    "filtersTitle": "ފިލްޓަރތައް",
    "issue": {
      "columns": {
        "include": "ދޫކުރޭ",
        "quantity": "ދޫކުރާނެ ޢަދަދު"
      },
      "dateHint": "ޑިފޯލްޓަކީ ކުންފުނީގެ ގަޑިން މިއަދު.",
      "description": "ސްޓޮކުން ނުކުންނާނެ ބައިތަކާއި، ކޮންމެއެއްޗެއްގެ ޢަދަދު ޚިޔާރުކުރައްވާ.",
      "done": "މެޓީރިއަލް ދޫކުރެވިއްޖެ",
      "doneDetail": "ސްޓޮކް ނުކުމެ، ވިޕް މައްޗަށް ގޮސްފި.",
      "failed": "މެޓީރިއަލް ދޫނުކުރެވުނު",
      "includeAria": "{item} ދޫކުރޭ",
      "linesCaption": "ދޫކުރާނެ ބައިތައް",
      "lotAria": "{item} ގެ ލޮޓް ނަންބަރު",
      "noValueNote": "ދޫކުރުމުގެ ކުރިން ވެލިއުއެއް ނުދައްކާނެ: ބައެއްގެ އަގަކީ އެ ބޭނުންކުރާ ފީފޯ ފަށަލަތައް ނުވަތަ އެވަގުތުގެ މޫވިންގ އެވަރެޖް. އެ ޢަދަދު ފަހުން މެޓީރިއަލް ސަޠުރުގައި ސާވަރުން ދޭނެ.",
      "overIssue": "ބޭނުންވާ މިންވަރަށްވުރެ ގިނަ",
      "overIssueExplainer": "މިއީ ހުއްދަ ކަމެއް. ހަލާކުވުމާއި، އަލުން ހެދުމާއި، ދަށްކޮށް ލަފާކުރެވުނު ރޫޓިންގއިން ސްޓޭންޑަޑަށްވުރެ ގިނައިން ބޭނުންވެދާނެ. ބަންދުކުރާއިރު މެޓީރިއަލް ބޭނުންކުރުމުގެ ތަފާތުން އެ މިނެވޭނެ.",
      "overIssueHeadline": "ސްޓޭންޑަޑް ބޭނުމަށްވުރެ ގިނަ",
      "postingExplainer": "ކޮންމެ ސަޠުރަކުން ގުދަނުން ސްޓޮކް ނުކުމެ، އެ ސްޓޮކްގެ ޙަޤީޤީ އަގަށް ޑރ ވިޕް / ކރ މުދާ ޕޯސްޓްކުރެވޭނެ.",
      "qtyAria": "ދޫކުރާނެ {item} ގެ ޢަދަދު",
      "title": "ވިޕަށް މެޓީރިއަލް ދޫކުރޭ"
    },
    "lifecycle": {
      "cancel": {
        "blocked": {
          "issued": "މި އޯޑަރުގެ ވިޕަށް މިހާރު މެޓީރިއަލް ދޫކޮށްފައި. މިހާރު ކުރެވޭނީ ބަންދުކުރުން، އޭރުން ތަފާތުތައް ޕޯސްޓްވާނެ — ކެންސަލެއް ނުކުރެވޭނެ."
        },
        "done": "އޯޑަރު ކެންސަލްކުރެވިއްޖެ",
        "doneDetail": "ރިޒަރވޭޝަންތައް ދޫކޮށްލެވިއްޖެ.",
        "label": "އޯޑަރު ކެންސަލްކުރޭ",
        "reasonHint": "އޮޑިޓް ރެކޯޑްގައި ތިޔަބޭފުޅާގެ ނަމުގައި ރައްކާކުރެވޭނެ.",
        "reasonLabel": "ސަބަބު",
        "reasonRequired": "ކެންސަލްކުރުމަށް ސަބަބެއް ބޭނުންވޭ.",
        "title": "މި އުފެއްދުމުގެ އޯޑަރު ކެންސަލްކުރޭ",
        "willDo": "މެޓީރިއަލްގެ ހުރިހާ ރިޒަރވޭޝަނެއް ދޫކޮށްލައި، އޯޑަރު ކެންސަލްކުރެވުނުކަމަށް ފާހަގަކުރާނެ. އެއްވެސް އެއްޗެއް ޕޯސްޓްކޮށްފައި ނުވާތީ، ބަދަލުކުރާނެ ލެޖަރ އެންޓްރީއެއް ނެތް."
      },
      "close": {
        "blocked": {
          "hold": "މި އޯޑަރު ކޮލިޓީ ހޯލްޑްގައި. ބަންދުކުރުމުގެ ކުރިން އެން.ސީ.އާރު ޙައްލުކުރައްވާ.",
          "operations": "{count} އޮޕަރޭޝަން އަދި ނުނިމޭ. އޯޑަރު ބަންދުކުރެވޭނީ ހުރިހާ އޮޕަރޭޝަނެއް ފުރިހަމަވުމުން."
        },
        "done": "އޯޑަރު ބަންދުކުރެވިއްޖެ",
        "doneDetail": "ތަފާތުތައް ޕޯސްޓްކުރެވި، ވިޕް ބެލެންސް ސުމަކަށް ވެއްޖެ.",
        "label": "ބަންދުކުރޭ",
        "title": "މި އުފެއްދުމުގެ އޯޑަރު ބަންދުކުރޭ",
        "variancesExplainer": "މި އޯޑަރުގެ އަމިއްލަ ސްޓޭންޑަޑްތަކުން ހަތަރު ތަފާތަކާއި ބާކީ ސާފުކުރުމެއް ހިސާބުކޮށް ޕޯސްޓްކުރެވޭނެ. މި ސްކްރީނުން އެ ބަދަލެއް ނުކުރެވޭނެ.",
        "variancesHeadline": "މިއިން ޖެނެރަލް ލެޖަރަށް ލިޔެވޭނެ",
        "willDo": "މެޓީރިއަލް އަދި މަސައްކަތުގެ ހުރިހާ ތަފާތެއް ހިސާބުކޮށް ޕޯސްޓްކުރުމަށްފަހު، ބާކީ ހުރި ވިޕް ބާކީ އެކައުންޓަށް ބަދަލުކޮށް، މި އޯޑަރު ސުމަކަށް ސާފުކުރާނެ."
      },
      "complete": "މި އޯޑަރު ބަންދުކުރެވިފައި. ވިޕް ބެލެންސް ސުމެއް، އަދި އުފެދުނު ހުރިހާ ތަފާތެއް ޕޯސްޓްކުރެވިފައި.",
      "edit": {
        "label": "އެޑިޓްކުރޭ",
        "willDo": "މި ދެލިކޮޕީގެ ޢަދަދު، ގުދަން، އޮނިގަނޑު ނުވަތަ ތާރީޚްތައް ބަދަލުކުރެވޭނެ. ހަމައެކަނި ދެލިކޮޕީއެއް އެޑިޓްކުރެވޭނެ."
      },
      "issue": {
        "blocked": {
          "backflush": "މި އޯޑަރަކީ ބެކްފްލަޝް އޯޑަރެއް: ކޮންމެ ފުރިހަމަ މުދަލެއް ބަލައިގަންނަ ވަގުތު ބޭނުންވާ މެޓީރިއަލް އަމިއްލައަށް ދޫކުރާތީ، އަތުން ދޫކުރެވޭކަށް ނެތް.",
          "noMaterials": "އަދި މެޓީރިއަލްގެ ބޭނުމެއް އުފެދިފައެއް ނުވޭ. އޯޑަރު ދޫކޮށްލުމުން ތަކެތީގެ ލިސްޓު ފުޅާވެ އެ އުފެދޭނެ."
        },
        "label": "މެޓީރިއަލް ދޫކުރޭ",
        "willDo": "ބައިތައް ސްޓޮކުން ނަގައި މި އޯޑަރުގެ ވިޕަށް ބަދަލުކޮށް، ސްޓޮކް ލެޖަރުގައިވާ އަގުގައި ޑރ ވިޕް / ކރ މުދާ ޕޯސްޓްކުރާނެ."
      },
      "nextStep": "ދެން: {step}",
      "nothingPermitted": "މި އޯޑަރު ބެއްލެވިދާނެ، އެކަމަކު އެއްވެސް ފިޔަވަޅެއް ނޭޅުއްވޭނެ.",
      "operation": {
        "blocked": {
          "allComplete": "މި އޯޑަރުގެ ހުރިހާ އޮޕަރޭޝަނެއް މިހާރު ފުރިހަމަވެފައި.",
          "noRouting": "މި އޯޑަރުގައި ރޫޓިންގއެއް ނެތުމުން، ލިޔާނެ އޮޕަރޭޝަނެއް ނެތް."
        },
        "label": "އޮޕަރޭޝަނެއް ލިޔޭ",
        "willDo": "އޮޕަރޭޝަންތަކުގެ ޓެބުން އޮޕަރޭޝަނެއް ފައްޓަވާ ނުވަތަ ހުއްޓަވާ. ކޮންމެ ހުއްޓުމަކުން އެ ބައިގެ މަސައްކަތާއި އޯވަހެޑް ވިޕަށް ޕޯސްޓްކުރެވޭނެ."
      },
      "qc": {
        "label": "ކޮލިޓީ ޗެކް ލިޔޭ",
        "willDo": "ބެލި، ފާސްވި އަދި ފެއިލްވި ޢަދަދު ލިޔެވޭނެ. ފެއިލްވެއްޖެނަމަ އެން.ސީ.އާރެއް އުފެދި އޯޑަރު ހޯލްޑަށް ދާނެ."
      },
      "receive": {
        "blocked": {
          "hold": "މި އޯޑަރު ކޮލިޓީ ހޯލްޑްގައި. ބަލައިގަތުމުގެ ކުރިން އެން.ސީ.އާރު ޙައްލުކުރައްވާ.",
          "nothingRemaining": "ރޭވިފައިވާ ޢަދަދު ފުރިހަމަވެފައި؛ ބަލައިގަންނާނެ އެއްޗެއް ބާކީ ނެތް."
        },
        "label": "ފުރިހަމަ މުދާ ބަލައިގަންނަވާ",
        "willDo": "ފުރިހަމަވި މުދާ ސްޓޮކަށް ވައްދައި، އޭގެ އަގު ވިޕުން ސާފުކުރާނެ — އޯޑަރުގައި ސްޓޭންޑަޑް އަގެއް އޮތްނަމަ އެ އަގުގައި، ނެތްނަމަ ޙަޤީޤީ އަގުގައި."
      },
      "release": {
        "blocked": {
          "noBom": "މި އޯޑަރުގައި ތަކެތީގެ ލިސްޓެއް ނެތުމުން، ފުޅާކުރާނެ ނުވަތަ ރިޒަރވްކުރާނެ އެއްޗެއް ނެތް. ފުރަތަމަ އޯޑަރުގައި އެއް ޚިޔާރުކުރައްވާ."
        },
        "done": "އޯޑަރު ދޫކޮށްލެވިއްޖެ",
        "doneDetail": "މެޓީރިއަލްގެ ބޭނުން ރިޒަރވްކުރެވި، ނަންބަރު ދެވިއްޖެ.",
        "label": "ދޫކޮށްލާ",
        "title": "މި އުފެއްދުމުގެ އޯޑަރު ދޫކޮށްލާ",
        "willDo": "ތަކެތީގެ ލިސްޓު ފުޅާކޮށް، ގުދަނުގައި ހުރި ކޮންމެ ބައެއް ރިޒަރވްކޮށް، ރޫޓިންގ އާއި ސްޓޭންޑަޑް އަގުތައް ރައްކާކޮށް، އޯޑަރަށް ނަންބަރެއް ދޭނެ."
      }
    },
    "materialStatuses": {
      "issued": "ދޫކޮށްފައި",
      "partially_issued": "ބައެއް ދޫކޮށްފައި",
      "pending": "ދޫކޮށްފައެއް ނުވޭ"
    },
    "materials": {
      "columns": {
        "issued": "ދޫކުރި",
        "outstanding": "ބާކީ",
        "required": "ބޭނުންވާ",
        "standardCost": "ސްޓޭންޑަޑް އަގު",
        "value": "ދޫކުރި ވެލިއު"
      },
      "description": "އޯޑަރު ދޫކޮށްލި ވަގުތު ތަކެތީގެ ލިސްޓުން ފުޅާކުރެވުނު — ފެންޓަމް ލެވެލްތައް އެއްކޮށް، ސްކްރެޕްވެސް ހިމަނައިގެން.",
      "emptyDescription": "އޯޑަރު ދޫކޮށްލުމުން ތަކެތީގެ ލިސްޓު ފުޅާވެ މި ލިސްޓު އުފެދި، ކޮންމެ ބައެއް ރިޒަރވްވާނެ.",
      "emptyTitle": "އަދި މެޓީރިއަލްގެ ބޭނުމެއް ނެތް",
      "explodedNote": "މި ޢަދަދުތަކަކީ ސާވަރުގެ އަމިއްލަ ފުޅާކުރުން، ސްޓޮކް ލެޖަރުގެ ހަތަރު ޑެސިމަލްގައި. ދޫކުރެވުނު ވެލިއުއަކީ ފީފޯ ފަށަލަތަކުން ނުވަތަ މޫވިންގ އެވަރެޖުން އައި ޙަޤީޤީ އަގު.",
      "substitute": "ބަދަލު ބައި",
      "title": "މެޓީރިއަލްގެ ބޭނުން"
    },
    "mrp": {
      "actionFailed": "ހުށަހެޅުމަށް ފިޔަވަޅު ނޭޅުނު",
      "actionedProduction": "ދެލިކޮޕީ އުފެއްދުމުގެ އޯޑަރު ހެދިއްޖެ",
      "actionedProductionDetail": "ތަކެތީގެ ހަރަކާތްތެރި ލިސްޓަށް ބަލައި، ހުށަހެޅުނު ޢަދަދަށް ހެދިފައި.",
      "actionedPurchase": "ފިޔަވަޅު އެޅުނުކަމަށް ފާހަގަކުރެވިއްޖެ",
      "actionedPurchaseDetail": "މި ބައިން ގަތުމުގެ ރިކުއިޒިޝަނެއް ނުހެދޭ؛ އެއީ ޕްރޮކިއުމަންޓްގެ ބައެއް. ހަމަ މި ޢަދަދުތަކުން ގަތުމުގެ ރިކުއިޒިޝަން ހައްދަވާ.",
      "actions": {
        "createOrder": "ދެލިކޮޕީ އޯޑަރު ހަދާ",
        "markActioned": "ފިޔަވަޅު އެޅުނުކަމަށް ފާހަގަކުރޭ",
        "run": "އެމް.އާރު.ޕީ ހިންގާ"
      },
      "bulk": {
        "action": "ހޮވިފައިވާ ތަކެތި ދޫކުރޭ",
        "confirm": "{count} ދޫކުރޭ",
        "description": "މި ދޫކުރުމުން އުފެދޭނެ އެއްޗެހި، އުފެދުމުގެ ކުރިން.",
        "done": "{count} ހުށަހެޅުން ދޫކޮށްފި",
        "notAtomic": "އެއްފަހަރާ ގިނަ ތަކެތި ދޫކުރާ އެންޑްޕޮއިންޓެއް ނެތް: ކޮންމެ ހުށަހެޅުމެއް ދޫކުރެވެނީ ވަކި ގޮވުމަކުން، ފަހަރަކު އެކަތި. އެކަތި ނާކާމިޔާބުވެއްޖެނަމަ އެހިސާބުން ހުއްޓި، ދިޔަ ހިސާބު ބުނެދޭނެ — މިހާރު ދޫކުރެވިފައިވާ ތަކެތި ދޫކުރެވިފައި ހުންނާނެ.",
        "productionHeadline": "{count} ޑްރާފްޓް އުފެއްދުމުގެ އޯޑަރު އުފެދޭނެ",
        "productionLabel": "އުފައްދާ",
        "purchaseHeadline": "{count} ގަތުމުގެ ހުށަހެޅުން ހަމައެކަނި ފިޔަވަޅުއެޅުނުކަމަށް ފާހަގަކުރެވޭނެ",
        "purchaseLabel": "ގަނޭ",
        "skipped": "ހޮވިފައިވާ ތަކެތީގެ ތެރެއިން {count} ހުޅުވިފައެއް ނުވޭ، އެއަށް ބަދަލެއް ނާންނާނެ.",
        "stopped": "{total} ގެ ތެރެއިން {done} އަށްފަހު ހުއްޓިއްޖެ.",
        "title": "{count} ހުށަހެޅުން ދޫކުރޭ"
      },
      "columns": {
        "needBy": "ބޭނުންވާ ތާރީޚް",
        "quantity": "މަދުވާ ޢަދަދު",
        "reason": "ސަބަބު",
        "run": "ހިންގުން",
        "type": "އުފައްދާ ނުވަތަ ގަނޭ"
      },
      "dismissDescription": "ލިސްޓުގައި ހުންނާނެ، ފޮރުވުނުކަމަށް ފާހަގަކޮށް.",
      "dismissExplainer": "ފޮރުވުމަކުން އެއްވެސް އެއްޗެއް ނުފޮހެވޭ. ހުށަހެޅުމާއި ތިޔަބޭފުޅާގެ ސަބަބު ރެކޯޑްގައި ހުންނާނެ، އަދި ދެން ހިންގާ ފަހަރު އަލުން އުފެދިދާނެ.",
      "dismissReasonHint": "އޮޑިޓް ރެކޯޑްގައި ރައްކާކުރެވޭނެ.",
      "dismissReasonRequired": "ސަބަބެއް ބޭނުންވޭ.",
      "dismissTitle": "މި ހުށަހެޅުން ފޮރުވާ",
      "dismissed": "ހުށަހެޅުން ފޮރުވިއްޖެ",
      "dismissedDetail": "ތިޔަބޭފުޅާގެ ސަބަބު އޮޑިޓް ރެކޯޑްގައި.",
      "emptyDescription": "ގުދަނަކަށް އެމް.އާރު.ޕީ ހިންގަވައި، ހުޅުވިފައިވާ ވިއްކުމުގެ ޑިމާންޑް، ހުރި އެއްޗިއްސާއި އަންނަން ހުރި އެއްޗިއްސާ އަޅާކިޔުއްވާ.",
      "emptyTitle": "ހުށަހެޅުމެއް ނެތް",
      "fields": {
        "dismissReason": "ސަބަބު",
        "horizon": "މުއްދަތު (ދުވަސް)"
      },
      "horizonHint": "ކުރިއަށް ރާވާނެ ދުވަސް. ޑިފޯލްޓަކީ 90.",
      "lastRunExplainer": "ހުށަހެޅުންތަކަކީ ހިންގުމުގެ އެއްބައި. އެމް.އާރު.ޕީއަށް އެއްގޮތަކަށްވެސް ޕްލޭން ނުކުރެވުނު ކަންކަން — ޕްލޭނިންގ ފެންސްގެ ތެރޭގައިވާ ޑިމާންޑް، ނުވަތަ ސޯސް ޕޮލިސީއެއް، ލީޑް ޓައިމެއް ނުވަތަ ބީއޯއެމްއެއް ނެތް އެއްޗެހި — ފާހަގަކުރެވެނީ އެކްސެޕްޝަނެއްގެ ގޮތުގައި، އަދި އެކްސެޕްޝަންތައް މި ލިސްޓުގައި ނުދައްކާ.",
      "lastRunHeadline": "ހިންގައި ނިމިއްޖެ — {count} ހުށަހެޅުން އުފައްދައިފި",
      "lastRunLink": "ހިންގުން #{id} ހުޅުވާ",
      "listDescription": "ހުޅުވިފައިވާ ވިއްކުމުގެ ޑިމާންޑުން ދައްކާ މަދުވާ ތަކެއްޗާއި، އެ އުފައްދަންވީތޯ ނުވަތަ ގަންނަންވީތޯ.",
      "listTitle": "އެމް.އާރު.ޕީ ހުށަހެޅުންތައް",
      "loadFailed": "އެމް.އާރު.ޕީ ހުށަހެޅުންތައް ލޯޑެއް ނުކުރެވުނު",
      "runDescription": "އެއް ކުންފުންޏަކަށް، އެއް ގުދަނަކަށް.",
      "runDone": "އެމް.އާރު.ޕީ ހިންގައި ނިމިއްޖެ",
      "runDoneDetail": "އައު {count} ހުށަހެޅުން.",
      "runExplainer": "ހިންގުމަކުން އައު ހުށަހެޅުންތައް އުފެދޭނެ؛ މިހާރު ހުޅުވިފައިވާ ހުށަހެޅުންތަކެއް ނުނަގާނެ.",
      "runTitle": "އެމް.އާރު.ޕީ ހިންގާ",
      "scopeExplainer": "އެއް ގުދަނަށް ހުޅުވިފައިވާ ވިއްކުމުގެ އޯޑަރުތަކުގެ ޑިމާންޑް، ހުރި ސްޓޮކާއި، ރިޒަރވޭޝަންތަކާއި، އަންނަން ހުރި ގަތުމުގެ އޯޑަރުތަކާ އަޅާކިޔާނެ — އަދި އުފެއްދުމަށް ހުށަހަޅާ ކޮންމެ އެއްޗެއްގެ ސީދާ ބައިތައްވެސް. މިއީ އެއް ލެވެލް، ފުލުފުލުގައި ދާ ގިނަ ފަހަރު ހިންގޭ ޕްލޭނެއް ނޫން.",
      "scopeHeadline": "ހިންގުމަކުން ބަލާ އެއްޗެއްސާއި ނުބަލާ އެއްޗެހި",
      "statuses": {
        "actioned": "ފިޔަވަޅު އެޅިފައި",
        "dismissed": "ފޮރުވިފައި",
        "open": "ހުޅުވިފައި"
      },
      "types": {
        "production": "އުފައްދާ",
        "purchase": "ގަނޭ"
      },
      "warehouseHint": "ޑިމާންޑް، ސްޓޮކް އަދި އަންނަން ހުރި ތަކެތި އަޅާކިޔޭނީ މި އެއް ގުދަނުގެ ތެރޭގައި."
    },
    "operationStatuses": {
      "complete": "ފުރިހަމަ",
      "in_progress": "ހިނގަމުންދާ",
      "pending": "ފަށާފައެއް ނުވޭ"
    },
    "operations": {
      "actions": {
        "start": "ފަށާ",
        "stop": "ހުއްޓާ"
      },
      "columns": {
        "actualLabour": "ޙަޤީޤީ މަސައްކަތް (މިނެޓް)",
        "actualMachine": "ޙަޤީޤީ މެޝިން (މިނެޓް)",
        "appliedLabour": "ހިމެނުނު މަސައްކަތް",
        "appliedOverhead": "ހިމެނުނު އޯވަހެޑް",
        "plannedRun": "ރޭވިފައިވާ ހިންގުން (މިނެޓް)",
        "plannedSetup": "ރޭވިފައިވާ ސެޓަޕް (މިނެޓް)",
        "seq": "ތަރުތީބު"
      },
      "description": "އޯޑަރު ދޫކޮށްލި ވަގުތު ރޫޓިންގއިން ރައްކާކުރެވުނު. ރޭވިފައިވާ ހިންގާ ވަގުތު މިހާރު އޯޑަރުގެ ޢަދަދުން ގުނަކުރެވިފައި.",
      "emptyDescription": "އޮޕަރޭޝަންގެ ވަގުތު ލިޔެ، މަސައްކަތާއި އޯވަހެޑް ވިޕަށް ހިމަނަން، ދެލިކޮޕީ އޯޑަރަކަށް ރޫޓިންގއެއް ގުޅުވާލައްވާ.",
      "emptyTitle": "މި އޯޑަރުގައި ރޫޓިންގއެއް ނެތް",
      "finalDescription": "އެއްވެސް އޮޕަރޭޝަނެއް ފުރިހަމަނުވަނީސް އޯޑަރު ބަންދެއް ނުކުރެވޭނެ.",
      "finalLabel": "މިއިން އޮޕަރޭޝަން ނިމުނީ",
      "logCount": "{count} ވަގުތު ރެކޯޑް",
      "machineHint": "މެޝިނުގެ ވަގުތެއް ނުހިމެނޭނަމަ ހުސްކޮށް ބާއްވަވާ.",
      "minutesHint": "ދެ ޑެސިމަލް",
      "overheadOnLabour": "މެޝިނުގެ ވަގުތެއް ނުލިޔެވޭތީ، އޯވަހެޑް ހިސާބުކުރެވޭނީ މަސައްކަތުގެ މިނެޓަށް.",
      "overheadOnMachine": "މެޝިނުގެ ވަގުތު ލިޔެފައިވާތީ، އޯވަހެޑް ހިސާބުކުރެވޭނީ މެޝިނުގެ މިނެޓަށް.",
      "postingNote": "ކޮންމެ ހުއްޓުމަކުން އަމިއްލަ ޖާނަލް އެންޓްރީއެއް ޕޯސްޓްވޭ: ހަމައެކަނި އެ ބައިގެ ޑރ ވިޕް، ކރ މަސައްކަތް އަދި ކރ އޯވަހެޑް.",
      "postsExplainer": "ލިޔުއްވާ މިނެޓްތައް ތިރީގައިވާ ރޭޓްތަކުގައި ހިސާބުކޮށް ވަގުތުން ވިޕަށް ޑެބިޓްކުރެވޭނެ — އޮޕަރޭޝަން ނިމެންދެން ބަހައްޓައެއް ނުލެވޭނެ.",
      "postsHeadline": "ހުއްޓާލުމުން ލެޖަރަށް ޕޯސްޓްވާނެ",
      "rateDefault": "މަސައްކަތު ސެންޓަރުގެ ރޭޓް {rate}",
      "rateHint": "މަސައްކަތު ސެންޓަރުގެ އަމިއްލަ ރޭޓް ބޭނުންކުރައްވަން ހުސްކޮށް ބާއްވަވާ.",
      "seqLabel": "އޮޕަރޭޝަން {seq}: {name}",
      "startFailed": "އޮޕަރޭޝަން ނުފެށުނު",
      "started": "އޮޕަރޭޝަން ފެށިއްޖެ",
      "startedDetail": "ވަގުތު ގުނަން ފަށައިފި.",
      "stopDescription": "މި ބައިގައި ހޭދަވި ވަގުތު ލިޔުއްވާ.",
      "stopFailed": "ވަގުތު ނުލިޔެވުނު",
      "stopSubject": "އޮޕަރޭޝަން {seq}: {name}",
      "stopTitle": "އޮޕަރޭޝަން ހުއްޓާ",
      "stopped": "ވަގުތު ލިޔެވިއްޖެ",
      "stoppedDetail": "މަސައްކަތާއި އޯވަހެޑް ވިޕަށް ޕޯސްޓްކުރެވިއްޖެ.",
      "title": "އޮޕަރޭޝަންތައް"
    },
    "orderSources": {
      "manual": "އަމިއްލައަށް",
      "mrp": "އެމް.އާރު.ޕީ"
    },
    "orderStatuses": {
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "closed": "ބަންދުކުރެވިފައި",
      "completed": "ނިމިފައި",
      "draft": "ދެލިކޮޕީ",
      "in_progress": "ކުރިއަށްދާ",
      "released": "ދޫކޮށްލެވިފައި"
    },
    "orders": {
      "actions": {
        "add": "އައު އޯޑަރު"
      },
      "backToList": "ހުރިހާ އުފެއްދުމުގެ އޯޑަރުތައް",
      "backflushDescription": "ނިއްވާލާފައިވާނަމަ، އުފެއްދުމުގެ ކުރިން ބައިތައް އަތުން ދޫކުރަން ޖެހޭނެ.",
      "backflushExplainer": "ކޮންމެ ފުރިހަމަ މުދާ ބަލައިގަތުމަކުން، އެ ޢަދަދަށް ބޭނުންވާ މެޓީރިއަލް އެވަގުތުގެ ތަކެތީގެ ލިސްޓުން ހިސާބުކޮށް ފުރަތަމަ ދޫކުރެވޭނެ. މި އޯޑަރުގައި އަތުން ދޫކުރުމުގެ ބަޓަން ބަލައެއް ނުގަނެވޭނެ.",
      "backflushLabel": "ބަލައިގަންނަ ވަގުތު މެޓީރިއަލް ބެކްފްލަޝްކުރޭ",
      "backflushOff": "އަތުން ދޫކުރެވޭ",
      "backflushOn": "ބަލައިގަންނަ ވަގުތު ބެކްފްލަޝް",
      "bomHint": "ޑިފޯލްޓަކީ ތަކެތީގެ ހަރަކާތްތެރި ވަރޝަން. މިއެއް ނެތި ދޫކޮށްލުމަކީ ނުވާނެ ކަމެއް.",
      "columns": {
        "completed": "ނިމިފައި",
        "orderNo": "އޯޑަރު ނަންބަރު",
        "planned": "ރޭވިފައި",
        "plannedStart": "ރޭވިފައިވާ ފެށުން",
        "source": "މަޞްދަރު",
        "wip": "ވިޕް ބެލެންސް"
      },
      "conflictExplainer": "އަލުން ލޯޑްކުރައްވައި، ބަދަލުވީ ކޮންއެއްޗެއްތޯ ބައްލަވައި، ދެން އަލުން އެޑިޓްކުރައްވާ.",
      "conflictHeadline": "މި އޯޑަރު އެހެން ބޭފުޅަކު ބަދަލުކޮށްފި",
      "create": "އައު އުފެއްދުމުގެ އޯޑަރު",
      "createDescription": "އުފައްދާނީ ކޯއްޗެއް، ކިތައް، އަދި ކޮން އޮނިގަނޑަކުންކަން.",
      "createFailed": "އޯޑަރު ހެދޭ ގޮތެއް ނުވި",
      "created": "އުފެއްދުމުގެ އޯޑަރު ހެދިއްޖެ",
      "createdDetail": "ދޫކޮށްލެއްވުމާ ހަމައަށް މިއީ ދެލިކޮޕީއެއް.",
      "detailDescription": "މެޓީރިއަލް، އޮޕަރޭޝަން، ބަލައިގަތުން އަދި ޕޯސްޓްކުރެވުނު ތަފާތުތައް.",
      "editDescription": "ދެލިކޮޕީއެއް ބަދަލުކުރެވޭނެ؛ ދޫކޮށްލެވިފައިވާ އޯޑަރެއް ބަދަލެއް ނުކުރެވޭނެ.",
      "editTitle": "ދެލިކޮޕީ އޯޑަރު އެޑިޓްކުރޭ",
      "emptyDescription": "އެއް އުފައްދަވާ، ނުވަތަ އެމް.އާރު.ޕީ ހިންގަވައި ވިއްކުމުގެ ޑިމާންޑުން އުފައްދަން ޖެހޭ އެއްޗެހި ބައްލަވާ.",
      "emptyTitle": "އަދި އުފެއްދުމުގެ އޯޑަރެއް ނެތް",
      "holdApiGap": "އޭ.ޕީ.އައި އިން އެން.ސީ.އާރު ލިސްޓެއް ނުލިބޭތީ، އެ ޙައްލުކުރެވޭނީ އެ އުފެއްދި އިންސްޕެކްޝަނުން، ކޮލިޓީ ޗެކްގެ ޑައިލޮގުގައި.",
      "holdExplainer": "ފެއިލްވި ކޮލިޓީ ޗެކަކުން މި އުފެދުނީ. އެ ޙައްލުވަންދެން ފުރިހަމަ މުދާ ބަލައިގަތުމާއި އޯޑަރު ބަންދުކުރުން ދެކަންތައްވެސް ބަލައެއް ނުގަނެވޭނެ.",
      "holdHeadline": "މި އޯޑަރު އެން.ސީ.އާރަކުން ހޯލްޑްގައި",
      "itemImmutable": "ތަކެތި ބަދަލެއް ނުކުރެވޭނެ: ތަކެތީގެ ލިސްޓާއި، ރޫޓިންގ އާއި، ސްޓޭންޑަޑް އަގު ކަނޑައެޅުނީ އެއަށް ބަލައިގެން. އެހެން ތަކެއްޗަކީ އެހެން އޯޑަރެއް.",
      "listDescription": "އުފައްދަނީ ކޯއްޗެއްކަން، އެ އޮތީ ކޮން މަރުޙަލާއެއްގައިކަން، އަދި ލެޖަރަށް ބާކީ އޮތީ ކޮންއެއްޗެއްކަން.",
      "listTitle": "އުފެއްދުމުގެ އޯޑަރުތައް",
      "loadFailed": "އުފެއްދުމުގެ އޯޑަރުތައް ލޯޑެއް ނުކުރެވުނު",
      "noBomExplainer": "ދޫކޮށްލުމުން ތަކެތީގެ ލިސްޓު ފުޅާވެ އޯޑަރުގެ މެޓީރިއަލްގެ ބޭނުން އުފެދޭތީ، މިއެއް ނެތް އޯޑަރެއްގައި ރިޒަރވްކުރާނެ އެއްޗެއް ނުހުންނާނެ.",
      "noBomHeadline": "މި އޯޑަރު އަދި ދޫކޮށެއް ނުލެވޭނެ",
      "noBomSelected": "ތަކެތީގެ ލިސްޓެއް ނެތް",
      "noCrossCompanyTotal": "ވިޕް ބެލެންސްތައް ޖުމްލަކޮށްފައެއް ނުވޭ: ކޮންމެ ކުންފުންޏެއްވެސް ބުނަނީ އަމިއްލަ ފައިސާއިން.",
      "noRoutingSelected": "ރޫޓިންގއެއް ނެތް",
      "onHold": "ކޮލިޓީ ހޯލްޑްގައި",
      "qtyHint": "ހަތަރު ޑެސިމަލް",
      "rail": {
        "bom": "ތަކެތީގެ ލިސްޓު",
        "item": "މުދަލުގެ ލިސްޓުގައިވާ ތަކެތި",
        "movements": "ސްޓޮކްގެ ހަރަކާތްތައް",
        "routing": "ރޫޓިންގ"
      },
      "railSubtitle": "{status} — އުފައްދަނީ {item}",
      "reload": "އޯޑަރު އަލުން ލޯޑްކުރޭ",
      "routingHint": "އިޚްތިޔާރީ. މިއެއް ނެތްނަމަ ލިޔާނެ ނުވަތަ އަގުކުރާނެ އޮޕަރޭޝަނެއް ނުހުންނާނެ.",
      "saveFailed": "އޯޑަރު ރައްކާނުކުރެވުނު",
      "saved": "އޯޑަރު ރައްކާކުރެވިއްޖެ",
      "savedDetail": "ބަދަލުތައް ރައްކާކުރެވިއްޖެ.",
      "standardCostExplainer": "އޯޑަރު ދޫކޮށްލި ވަގުތު ތަކެތީގެ މިހާރުގެ ސްޓޭންޑަޑް އަގުން ރައްކާކުރެވުނު ޢަދަދެއް. ފުރިހަމަ މުދާ ބަލައިގަނެވޭނީ މި އަގުގައި، އަދި ތަފާތުތައް މިނެވޭނީ މިއަށް ބަލައިގެން.",
      "standardCostHeadline": "ސްޓޭންޑަޑް ޔުނިޓް އަގު {cost}",
      "summaryTitle": "އޯޑަރު",
      "tabs": {
        "materials": "މެޓީރިއަލް",
        "operations": "އޮޕަރޭޝަންތައް",
        "receipts": "ބަލައިގަތުންތައް",
        "variances": "ތަފާތުތައް"
      },
      "tabsLabel": "އުފެއްދުމުގެ އޯޑަރުގެ ބައިތައް",
      "timeline": {
        "actualEnd": "އުފެއްދުން ފުރިހަމަވި",
        "actualStart": "ދޫކޮށްލި",
        "closed": "ބަންދުކުރި",
        "created": "ހެދުނު",
        "plannedStart": "ރޭވިފައިވާ ފެށުން"
      },
      "unnumbered": "ދެލިކޮޕީ (އަދި ނަންބަރު ނުދޭ)"
    },
    "qc": {
      "actions": {
        "record": "އިންސްޕެކްޝަން ލިޔޭ",
        "resolve": "ރިޕޯޓް ޙައްލުކުރޭ"
      },
      "cannotResolve": "ތިޔަބޭފުޅާއަށް ބެލެވޭނެ، އެކަމަކު ޙައްލުކުރާނެ ގޮތެއް ނުނިންމޭނެ. މިއީ ގަސްދުގައި: އިންސްޕެކްޓަރު އަމިއްލައަށް ފެއިލްކުރި އިންސްޕެކްޝަނެއް ޙައްލެއް ނުކުރާނެ.",
      "description": "ބެލީ ކިތައް ޔުނިޓް، އަދި އޭގެތެރެއިން ފާސްވީ ކިތައްކަން.",
      "dispositionNote": "އަލުން ހެދުން، ސްކްރެޕްކުރުން އަދި އެގޮތަށް ބޭނުންކުރުން — މި ތިން ގޮތުންވެސް ހޯލްޑް ނެގޭނެ. އެއިން އެއްވެސް ގޮތަކުން އޯޑަރުގެ ނިމުނު ނުވަތަ ސްކްރެޕްވި ޢަދަދު ބަދަލެއް ނުވޭ — އޭ.ޕީ.އައި އިން އެ ދޭއްޗެއް ބަދަލެއް ނުކުރޭ.",
      "dispositions": {
        "rework": "އަލުން ހަދާ",
        "scrap": "ސްކްރެޕްކުރޭ",
        "use_as_is": "އޮތްގޮތަށް ބޭނުންކުރޭ"
      },
      "failed": "އިންސްޕެކްޝަން ނުލިޔެވުނު",
      "fields": {
        "disposition": "ނިންމުން",
        "failed": "ފެއިލްވި",
        "inspected": "ބެލި ޢަދަދު",
        "passed": "ފާސްވި",
        "resolutionNote": "ޙައްލުގެ ނޯޓް",
        "type": "އިންސްޕެކްޝަން ޕޮއިންޓް"
      },
      "ncrExplainer": "މިހާރު އޯޑަރު ހޯލްޑްގައި. ހޯލްޑް ނަގަން، ޙައްލުކުރާނެ ގޮތެއް ޚިޔާރުކުރައްވާ.",
      "ncrOnlyHere": "ވެވޭނަމަ މިހާރު ޙައްލުކުރައްވާ: އޭ.ޕީ.އައި އިން އެން.ސީ.އާރު ލިސްޓެއް ނުލިބޭތީ، މި ޑައިލޮގު ބަންދުވުމުން މިއަށް ވާސިލުވެވޭނެ އެހެން ސްކްރީނެއް ނެތް.",
      "ncrRaised": "އެން.ސީ.އާރު #{id}",
      "ncrResolveFailed": "ރިޕޯޓް ޙައްލެއް ނުކުރެވުނު",
      "ncrResolved": "އެން.ސީ.އާރު ޙައްލުކުރެވިއްޖެ",
      "ncrResolvedDetail": "މި އޯޑަރުގައި ހުޅުވިފައިވާ ރިޕޯޓެއް ނެތްނަމަ ހޯލްޑް ނެގޭނެ.",
      "notesPlaceholder": "ގޯސްވީ ކޮންކަމެއްކަން. މިއީ އެން.ސީ.އާރުގެ ސަބަބަށްވާނެ.",
      "operationHint": "މުޅި އޯޑަރަށް ބަލާނަމަ ހުސްކޮށް ބާއްވަވާ.",
      "recorded": "އިންސްޕެކްޝަން ލިޔެވިއްޖެ",
      "results": {
        "fail": "ހުރިހާ ޔުނިޓެއް ފެއިލްވި.",
        "partial": "ބައެއް ޔުނިޓް ފެއިލްވި.",
        "pass": "ހުރިހާ ޔުނިޓެއް ފާސްވި."
      },
      "splitExceeds": "ފާސްވި އަދި ފެއިލްވި ޢަދަދު، ބެލި ޢަދަދަށްވުރެ ގިނަވެގެން ނުވާނެ.",
      "title": "ކޮލިޓީ ޗެކެއް ލިޔޭ",
      "types": {
        "final": "ފަހުގެ",
        "in_process": "މަސައްކަތުގެ ތެރޭގައި"
      },
      "wholeOrder": "މުޅި އޯޑަރު",
      "willHoldExplainer": "ފެއިލްވި ޔުނިޓަކުން އެން.ސީ.އާރެއް އުފެދޭނެ. އެ ޙައްލުވަންދެން ފުރިހަމަ މުދާ ބަލައިގަތުމާއި އޯޑަރު ބަންދުކުރުން ދެކަންތައްވެސް ބަލައެއް ނުގަނެވޭނެ.",
      "willHoldHeadline": "މިއިން އޯޑަރު ހޯލްޑަށް ދާނެ"
    },
    "receipts": {
      "columns": {
        "costingMode": "އަގުކުރުން",
        "quantity": "ޢަދަދު",
        "receivedAt": "ބަލައިގަތް",
        "unitCost": "ޔުނިޓް އަގު",
        "value": "ވެލިއު"
      },
      "description": "ނުކުތީ ކޯއްޗެއް، ކޮން އަގެއްގައި، އަދި ކޮން އުޞޫލަކުންކަން.",
      "emptyDescription": "ފުރިހަމަ މުދާ ބަލައިގަތުމުން އުފެއްދުން ސްޓޮކަށް ވަދެ، އޭގެ އަގު ވިޕުން ސާފުވާނެ.",
      "emptyTitle": "އަދި އެއްވެސް އެއްޗެއް ބަލައިގަނެފައެއް ނުވޭ",
      "title": "ފުރިހަމަ މުދާ ބަލައިގަތުންތައް"
    },
    "receive": {
      "actualCostingExplainer": "މި ތަކެއްޗަށް މިހާރު ސްޓޭންޑަޑް އަގެއް ނެތުމުން، އޯޑަރުގައި ބާކީ ހުރި ވިޕުން ސާވަރު ޔުނިޓް އަގު ނަގާނެ. މިއީ ގޯހެއް ނޫން؛ މިއީ ޙަޤީޤީ އަގުކުރުން.",
      "actualCostingHeadline": "ޙަޤީޤީ އަގުގައި ބަލައިގަނެވޭނެ",
      "backflushExplainer": "ހަމަ މި ޢަދަދަށް ތަކެތީގެ ލިސްޓު ފުޅާކޮށް، ކޮންމެ ބައެއްގެ އެ މިންވަރު ފުރަތަމަ ވިޕަށް ދޫކުރެވޭނެ.",
      "backflushHeadline": "މިއިން މެޓީރިއަލްވެސް ދޫކުރެވޭނެ",
      "dateHint": "ޑިފޯލްޓަކީ ކުންފުނީގެ ގަޑިން މިއަދު.",
      "description": "ފުރިހަމަވި އުފެއްދުން އޯޑަރުގެ ގުދަނަށް ވައްދަވާ.",
      "done": "ފުރިހަމަ މުދާ ބަލައިގަނެވިއްޖެ",
      "doneDetail": "ސްޓޮކް މައްޗަށް، ވިޕް ދަށަށް ގޮސްފި.",
      "exceedsRemaining": "ރޭވިފައިވާ ޢަދަދުން ބާކީ އޮތީ {remaining} އެކަނި؛ އެއަށްވުރެ ގިނަ ސާވަރުން ބަލައެއް ނުގަނޭ.",
      "failed": "ބަލައެއް ނުގަނެވުނު",
      "fields": {
        "quantity": "ބަލައިގަންނާނެ ޢަދަދު"
      },
      "remaining": "ބާކީ",
      "standardCostingExplainer": "އޯޑަރުގައި ރައްކާކުރެވުނު ސްޓޭންޑަޑް އަގެއް އޮތުމުން، ބަލައިގަތުން އަގުކުރެވޭނީ އެއިން. ޙަޤީޤީ އަގާ ހުރި ތަފާތު ބަންދުކުރާއިރު ތަފާތެއްގެ ގޮތުގައި ފެންނާނެ.",
      "standardCostingHeadline": "ސްޓޭންޑަޑް ޔުނިޓް އަގު {cost} ގައި ބަލައިގަނެވޭނެ",
      "title": "ފުރިހަމަ މުދާ ބަލައިގަންނަވާ"
    },
    "routeTitles": {
      "bom": "ތަކެތީގެ ލިސްޓު",
      "boms": "ތަކެތީގެ ލިސްޓުތައް",
      "capacity": "ކެޕޭސިޓީ",
      "mrp": "އެމް.އާރު.ޕީ ހުށަހެޅުންތައް",
      "productionOrder": "އުފެއްދުމުގެ އޯޑަރު",
      "productionOrders": "އުފެއްދުމުގެ އޯޑަރުތައް",
      "routing": "ރޫޓިންގ",
      "routings": "ރޫޓިންގތައް",
      "settings": "އުފެއްދުމުގެ ސެޓިންގތައް",
      "standardCosts": "ސްޓޭންޑަޑް އަގުތައް",
      "wipClearing": "ވިޕް ސާފުކުރުން",
      "workCenters": "މަސައްކަތު ސެންޓަރުތައް"
    },
    "routings": {
      "actions": {
        "activate": "ހަރަކާތްތެރިކުރޭ",
        "add": "އައު ރޫޓިންގ",
        "addOperation": "އޮޕަރޭޝަނެއް އިތުރުކުރޭ",
        "discard": "ދެލިކޮޕީ އުކާލާ"
      },
      "activateBlocked": {
        "notDraft": "ހަރަކާތްތެރިކުރެވޭނީ ދެލިކޮޕީއެއް އެކަނި.",
        "unsaved": "ފުރަތަމަ ބަދަލުތައް ރައްކާކުރައްވާ: ހަރަކާތްތެރިކުރުމުގައި ބޭނުންކުރެވޭނީ ރައްކާކުރެވުނު އޮޕަރޭޝަންތައް، ސްކްރީނުގައި ހުރި އެއްޗެއް ނޫން."
      },
      "activated": "ރޫޓިންގ ހަރަކާތްތެރިކުރެވިއްޖެ",
      "activatedDetail": "މި ތަކެއްޗަށް ކުރިން ހަރަކާތްތެރި ރޫޓިންގއެއް އޮތްނަމަ މިހާރު އެ ބާވެއްޖެ.",
      "backToList": "ހުރިހާ ރޫޓިންގތައް",
      "columns": {
        "operations": "އޮޕަރޭޝަންތައް",
        "runPerUnit": "ޔުނިޓަކަށް ހިންގުން (މިނެޓް)",
        "setup": "ސެޓަޕް (މިނެޓް)"
      },
      "confirm": {
        "activate": {
          "label": "ހަރަކާތްތެރިކުރޭ",
          "title": "މި ރޫޓިންގ ހަރަކާތްތެރިކުރޭ",
          "willDo": "މުސްތަޤްބަލުގެ ކޮންމެ އުފެއްދުމުގެ އޯޑަރެއް ދޫކޮށްލާއިރު ރައްކާކުރާނެ ރޫޓިންގއަކަށް މި ހަދާނެ، އަދި މި ތަކެއްޗަށް ކުރިން ހަރަކާތްތެރިކޮށް އޮތް ރޫޓިންގ ބާކޮށްލާނެ."
        },
        "discard": {
          "label": "އުކާލާ",
          "title": "މި ދެލިކޮޕީ އުކާލާ",
          "willDo": "މި ދެލިކޮޕީ ރޫޓިންގ ނަގާނެ. އުކާލެވޭނީ ދެލިކޮޕީއެއް ކަމުން، އޯޑަރެއްގައި ރައްކާކުރެވިފައިވާ ރޫޓިންގއަކަށް އަސަރެއް ނުކުރާނެ."
        }
      },
      "conflictExplainer": "ޞަފްޙާ އަލުން ލޯޑްކުރައްވައި، ބަދަލުވީ ކޮންއެއްޗެއްތޯ ބައްލަވައި، ދެން އަލުން އެޑިޓްކުރައްވާ.",
      "conflictHeadline": "މި ރޫޓިންގ އެހެން ބޭފުޅަކު ބަދަލުކޮށްފި",
      "create": "އައު ރޫޓިންގ",
      "createDescription": "އުފައްދާ އެއް ތަކެއްޗަށް ދެލިކޮޕީއެއް ފައްޓަވާ.",
      "createExplainer": "އުފެދޭނީ ހުހަށް، ދެލިކޮޕީއެއްގެ ގޮތުގައި. އޮޕަރޭޝަންތައް އިތުރުކުރެވޭނީ ދެން ހުޅުވޭ އެޑިޓަރުގައި.",
      "createFailed": "ރޫޓިންގ ނުހެދުނު",
      "created": "ރޫޓިންގ ހެދިއްޖެ",
      "createdDetail": "ވަރޝަން {version}، ދެލިކޮޕީ.",
      "descriptionAria": "އޮޕަރޭޝަން {line} ގެ ތަފްޞީލު",
      "detailDescription": "އޮޕަރޭޝަންތަކާއި މަރުޙަލާތައް.",
      "discarded": "ދެލިކޮޕީ އުކާލެވިއްޖެ",
      "discardedDetail": "މިއަށް އެއްވެސް އެއްޗެއް ރިޢާޔަތްކޮށްފައެއް ނުވޭ.",
      "duplicateSeq": "ދެ އޮޕަރޭޝަނެއްގައި އެއް ތަރުތީބު ނަންބަރެއް. ނަންބަރުގެ ބޭނުމަކީ ހިނގާ ތަރުތީބު ކަނޑައެޅުން ކަމުން، އެ ތަފާތުވާން ޖެހޭނެ.",
      "emptyDescription": "އޮޕަރޭޝަންގެ ވަގުތު ލިޔެ، އުފެއްދުމުގެ އޯޑަރަކަށް މަސައްކަތާއި އޯވަހެޑް ހިމަނަން އެއް ހައްދަވާ.",
      "emptyTitle": "އަދި ރޫޓިންގއެއް ނެތް",
      "incompleteOperations": "ރައްކާކުރެވޭނީ ކޮންމެ އޮޕަރޭޝަނެއްގައި ތަރުތީބު ނަންބަރެއް، މަސައްކަތު ސެންޓަރެއް އަދި ނަމެއް ހުރެގެން.",
      "listDescription": "ބައިތައް ތަކެއްޗަކަށް ބަދަލުކުރާ ތަރުތީބުކުރެވުނު އޮޕަރޭޝަންތައް — ކޮން މަސައްކަތު ސެންޓަރެއްގައި، ކޮން ސްޓޭންޑަޑް ވަގުތެއްގައިކަން.",
      "listTitle": "ރޫޓިންގތައް",
      "loadFailed": "ރޫޓިންގތައް ލޯޑެއް ނުކުރެވުނު",
      "nameAria": "އޮޕަރޭޝަން {line} ގެ ނަން",
      "noOperations": "އަދި އޮޕަރޭޝަނެއް ނެތް.",
      "notDraftExplainer": "އެޑިޓްކުރެވޭނީ ދެލިކޮޕީއެއް އެކަނި. އޮޕަރޭޝަންތައް ބަދަލުކުރައްވަން އައު ވަރޝަނެއް ހައްދަވާ.",
      "operationsEditable": "އެއް ސޭވަކުން މުޅި ސެޓް ބަދަލުވާނެ. ހަމައެކަނި ދެލިކޮޕީއެއް އެޑިޓްކުރެވޭނެ.",
      "operationsReadOnly": "މި ވަރޝަން ދެލިކޮޕީއެއް ނޫން ކަމުން، އޮޕަރޭޝަންތައް ބަދަލެއް ނުކުރެވޭނެ.",
      "operationsTitle": "އޮޕަރޭޝަންތައް",
      "rail": {
        "orders": "މި ތަކެއްޗަށް އުފެއްދުމުގެ އޯޑަރުތައް"
      },
      "railTitle": "{item} ގެ ރޫޓިންގ، v{version}",
      "removeOperation": "އޮޕަރޭޝަން {line} ނަގާ",
      "runAria": "އޮޕަރޭޝަން {line} ގެ ޔުނިޓަކަށް ހިންގާ މިނެޓް",
      "saveFailed": "އޮޕަރޭޝަންތައް ރައްކާނުކުރެވުނު",
      "saved": "އޮޕަރޭޝަންތައް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "މުޅި ސެޓް ބަދަލުކުރެވިއްޖެ.",
      "seqAria": "އޮޕަރޭޝަން {line} ގެ ތަރުތީބު ނަންބަރު",
      "setupAria": "އޮޕަރޭޝަން {line} ގެ ސެޓަޕް މިނެޓް",
      "summaryTitle": "ރޫޓިންގ",
      "timeline": {
        "created": "ހެދުނު"
      },
      "timesNote": "ސެޓަޕް ވަގުތު ނެގޭނީ އޯޑަރަކަށް އެއްފަހަރު؛ ހިންގާ ވަގުތަކީ ޔުނިޓަކަށް، އަދި ދޫކޮށްލާ ވަގުތު ރޫޓިންގ ރައްކާކުރެވޭއިރު އެ އޯޑަރުގެ ޢަދަދުން ގުނަކުރެވޭނެ. މި ދޭތި އެއްކޮށް މަސައްކަތުގެ ހަރުދަނާކަމުގެ ތަފާތު މިނާ ސްޓޭންޑަޑަށްވޭ.",
      "unsaved": "ރައްކާނުކުރެވޭ ބަދަލުތައް",
      "versionLabel": "ވަރޝަން {version}"
    },
    "settings": {
      "auditNote": "އެކައުންޓެއް ބަދަލުކުރުން އޮޑިޓްކުރެވޭ، އަދި އަސަރުކުރާނީ ކުރިއަށް އޮތް ޕޯސްޓްތަކަށް.",
      "description": "އުފެއްދުމުން ޕޯސްޓްކުރާ އެކައުންޓްތައް. މި ނެތްނަމަ ދޫކުރުމާއި، ބަލައިގަތުމާއި، ބަންދުކުރުން ބަލައެއް ނުގަނެވޭނެ.",
      "fields": {
        "appliedLabour": "ހިމެނުނު މަސައްކަތުގެ އެކައުންޓް",
        "appliedOverhead": "ހިމެނުނު އޯވަހެޑްގެ އެކައުންޓް",
        "wip": "ވިޕް އެކައުންޓް"
      },
      "hints": {
        "appliedLabour": "އޮޕަރޭޝަނެއްގެ މަސައްކަތުގެ ވަގުތުގެ ކްރެޑިޓް ފަރާތް.",
        "appliedOverhead": "އޮޕަރޭޝަނެއްގެ ހިމެނުނު އޯވަހެޑްގެ ކްރެޑިޓް ފަރާތް.",
        "labourEfficiency": "އޮޕަރޭޝަނަކަށް ޙަޤީޤަތުގައި ހޭދަވި ގަޑިއިރު، ރޭވިފައިވާ ސެޓަޕާއި ހިންގާ ވަގުތާ އަޅާކިޔައިގެން.",
        "labourRate": "އޮޕަރޭޝަނެއް ޙަޤީޤަތުގައި ހިސާބުކުރެވުނު ރޭޓް، މަސައްކަތު ސެންޓަރުގެ ސްޓޭންޑަޑާ އަޅާކިޔައިގެން.",
        "materialPrice": "ބައެއްގެ ޙަޤީޤީ އަގު، އޭގެ ސްޓޭންޑަޑް އަގާ އަޅާކިޔައިގެން.",
        "materialUsage": "ދޫކުރެވުނު މިންވަރު، ތަކެތީގެ ލިސްޓުން ބޭނުންވި މިންވަރާ އަޅާކިޔައިގެން.",
        "residual": "ބަންދުކުރާއިރުގެ ސާފުކުރުން: ހިމެނުނު އޯވަހެޑާއި ވިޕްގައި ބާކީވި ބައި. މިއީ ލާޒިމް — މިއެއް ނެތި ބަންދުކުރުން ބަލައެއް ނުގަނެވޭނެ.",
        "wip": "ކޮންމެ މެޓީރިއަލް ދޫކުރުމަކުންނާއި ލިޔެވޭ ކޮންމެ އޮޕަރޭޝަނަކުން ޑެބިޓްވޭ؛ ކޮންމެ ބަލައިގަތުމަކުން ކްރެޑިޓްވޭ."
      },
      "loadFailed": "ސެޓިންގތައް ލޯޑެއް ނުކުރެވުނު",
      "noResidualExplainer": "މިއީ ވިޕް ސީދާ ސުމަކަށް ސާފުކުރާ ބައި. މިއެއް ނެތްނަމަ، ބެލެންސެއް ބާކީ ބެހެއްޓުމުގެ ބަދަލުގައި ސާވަރުން އޯޑަރު ބަންދުކުރުން ބަލައެއް ނުގަނެވޭނެ.",
      "noResidualHeadline": "އޯވަހެޑް / ބާކީ އެކައުންޓެއް ކަނޑައަޅާފައެއް ނުވޭ",
      "noWipExplainer": "އެއް ކަނޑައެޅެންދެން، މި ކުންފުނީގައި މެޓީރިއަލް ދޫކުރުމާއި ފުރިހަމަ މުދާ ބަލައިގަތުން ދެކަންތައްވެސް ބަލައެއް ނުގަނެވޭނެ.",
      "noWipHeadline": "ވިޕް އެކައުންޓެއް ކަނޑައަޅާފައެއް ނުވޭ",
      "notConfigured": "ކަނޑައަޅާފައެއް ނުވޭ",
      "openChart": "އެކައުންޓްތަކުގެ ޗާޓް ހުޅުވާ",
      "readOnlyNote": "މި ކަނޑައެޅުން ބެއްލެވިދާނެ، އެކަމަކު ބަދަލެއް ނުކުރެއްވޭނެ. މިއީ ގަސްދުގައި: މިއީ އުފެއްދުމުގެ މުވައްޒަފުން މިނެވޭ މިންގަނޑު.",
      "saveFailed": "ސެޓިންގތައް ރައްކާނުކުރެވުނު",
      "saved": "ސެޓިންގތައް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "ކުރިއަށް އޮތް ޕޯސްޓްތަކުގައި މި އެކައުންޓްތައް ބޭނުންކުރެވޭނެ.",
      "title": "އުފެއްދުމުގެ ސެޓިންގތައް",
      "unpostedExplainer": "އެ ތަފާތުތައް އޯޑަރުގައި ހިސާބުކުރެވި، ބަޔާންކުރެވޭނެ؛ އެ ޢަދަދުތައް ބާކީ ސާފުކުރުމަށް ވިޕްގައި ބެހެއްޓޭނެ، އަދި އޯޑަރުގައި ޕޯސްޓްކޮށްފައި ނުވާކަމަށް ފާހަގަވާނެ.",
      "unpostedHeadline": "{count} ތަފާތުގެ އެކައުންޓް ކަނޑައަޅާފައެއް ނުވޭ",
      "varianceDescription": "ބަންދުކުރާއިރު ކޮންމެ ތަފާތެއް ދާނެ ތަން. ކަނޑައަޅާފައި ނުވާ އެއްޗަކުން ޕޯސްޓެއް އުފައްދާކަށް ނުޖެހޭ.",
      "varianceTitle": "ތަފާތުގެ އެކައުންޓްތައް",
      "wipDescription": "މުޅި ބައިގެ މައި ނުކުތާ: މެޓީރިއަލް ދޫކުރުމާއި ހިމެނުނު ވަގުތުން ޑެބިޓްވޭ، ބަލައިގަތުމުން ކްރެޑިޓްވޭ، އަދި ބަންދުކުރުމުން ސުމަކަށް ސާފުވޭ.",
      "wipTitle": "މަސައްކަތުގައި ހުރި (ވިޕް)",
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ސެޓިންގްސް ބަދަލުކޮށްފި. ކަމެއް ނުފޮހެވޭ. ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކުރޭ"
    },
    "standardCosts": {
      "actions": {
        "set": "ސްޓޭންޑަޑް އަގު ކަނޑައަޅާ"
      },
      "asEnteredExplainer": "މިތާނގައިވާ ސްޓޭންޑަޑް އަގަކީ ވަކި ތާރީޚެއްގައި ބޭފުޅަކު ނިންމި ނިންމުމެއް. ތަކެތީގެ ލިސްޓާއި ރޫޓިންގއިން މި އަގު އެއްކޮށްދޭ ގޮތެއް އޭ.ޕީ.އައި ގައި ނެތް، އަދި އެއްވެސް ސްކްރީނަކުން އެހެން ބުނާކަށްވެސް ނުވާނެ.",
      "asEnteredHeadline": "މިއީ ލިޔެވުނު އަގުތައް، އެއްކުރެވުނު އަގުތަކެއް ނޫން",
      "columns": {
        "cost": "ސްޓޭންޑަޑް އަގު",
        "effectiveFrom": "ޢަމަލުކުރަން ފަށާ"
      },
      "costHint": "ހަ ޑެސިމަލް",
      "costsIn": "އަގުތައް ބަޔާންކޮށްފައިވަނީ {currency} އިން.",
      "current": "މިހާރުގެ",
      "description": "ބަންދުކުރެވުނު އުފެއްދުމުގެ އޯޑަރެއްގެ ކޮންމެ ތަފާތެއް މިނެވޭ، ތާރީޚް ޖެހި ޢަދަދު.",
      "effectiveHint": "މި ޢަދަދު ޢަމަލުކުރަން ފަށާ ތާރީޚް.",
      "emptyDescription": "ސްޓޭންޑަޑް އަގެއް ނެތް ތަކެތި އަގުކުރެވޭނީ ޙަޤީޤީ އަގުން. ފުރިހަމަ މުދާ ސްޓޭންޑަޑްގައި ބަލައިގަނެ، ތަފާތުތަކަށް އަސާސެއް ދިނުމަށް އެއް ކަނޑައަޅުއްވާ.",
      "emptyTitle": "ސްޓޭންޑަޑް އަގެއް ކަނޑައަޅާފައެއް ނުވޭ",
      "loadFailed": "ސްޓޭންޑަޑް އަގުތައް ލޯޑެއް ނުކުރެވުނު",
      "saveFailed": "ސްޓޭންޑަޑް އަގު ކަނޑައެޅޭ ގޮތެއް ނުވި",
      "saved": "ސްޓޭންޑަޑް އަގު ކަނޑައެޅިއްޖެ",
      "savedDetail": "މިހާރު އެއީ އެ ތަކެތީގެ މިހާރުގެ ޢަދަދު.",
      "setDescription": "އެއް ތަކެއްޗަށް، އެއް ތާރީޚަކުން ފެށިގެން.",
      "setTitle": "ސްޓޭންޑަޑް އަގެއް ކަނޑައަޅާ",
      "supersedeExplainer": "މި ތަކެއްޗަށް މިހާރު އޮތް ސްޓޭންޑަޑް އަގު މިހާރުގެ އަގުކަމުގައި ނުވާނެ. ދޫކޮށްލެވިފައިވާ އުފެއްދުމުގެ އޯޑަރުތަކުގައި ހުންނާނީ އެ ރައްކާކުރި ޢަދަދު.",
      "supersedeHeadline": "މިއިން މިހާރުގެ ޢަދަދު ބާވެގެންދާނެ",
      "superseded": "ބަދަލުކުރެވިފައި",
      "title": "ސްޓޭންޑަޑް އަގުތައް"
    },
    "varianceTypes": {
      "labor_efficiency": "މަސައްކަތުގެ ހަރުދަނާކަމުގެ ތަފާތު",
      "labor_rate": "މަސައްކަތުގެ ރޭޓްގެ ތަފާތު",
      "material_price": "މެޓީރިއަލްގެ އަގުގެ ތަފާތު",
      "material_usage": "މެޓީރިއަލް ބޭނުންކުރުމުގެ ތަފާތު",
      "overhead": "އޯވަހެޑް އަދި ބާކީ"
    },
    "variances": {
      "authorityExplainer": "ކޮންމެ ތަފާތެއް ހިސާބުކުރެވެނީ ސާވަރުގައި، އަދި އެ އުފެއްދި ޖާނަލް އެންޓްރީ އޭގައި ހިމެނޭ. ޕޯސްޓްކޮށްފައި ނުވާކަމަށް ފާހަގަކޮށްފައިވާ ތަފާތަކަށް އެކައުންޓެއް ކަނޑައަޅާފައި ނުވާތީ، އެ ޢަދަދު ބާކީ ސާފުކުރުމަށް ވިޕްގައި ބެހެއްޓުނީ.",
      "authorityHeadline": "މި ޢަދަދުތަކަކީ ލެޖަރުގެ ޢަދަދުތައް",
      "columns": {
        "actualAmount": "ޙަޤީޤީ",
        "actualQty": "ޙަޤީޤީ ޢަދަދު",
        "expectedAmount": "ލަފާކުރި",
        "expectedQty": "ލަފާކުރި ޢަދަދު",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "subject": "އަޅާކިޔެނީ",
        "type": "ތަފާތު",
        "variance": "ތަފާތު"
      },
      "description": "އޯޑަރު ބަންދުކުރި ވަގުތު، އޯޑަރުގެ އަމިއްލަ ސްޓޭންޑަޑްތަކުން ހިސާބުކޮށް ޕޯސްޓްކުރެވުނު.",
      "emptyDescription": "ތަފާތުތައް ހިސާބުކުރެވެނީ އޯޑަރު ބަންދުކުރާއިރު. އެހާތަނަށް އަޅާކިޔާނެ އެއްޗެއް ނެތް.",
      "emptyTitle": "އަދި ތަފާތެއް ނެތް",
      "journal": "ޖާނަލް",
      "noPermissionDescription": "ޕޯސްޓްކުރެވުނު އަގުގެ ތަފާތުތައް ބެލުމަކީ، އޯޑަރު ބެލުމާ ވަކި ހުއްދައެއް.",
      "noPermissionTitle": "ތަފާތުތައް ބެއްލެވޭކަށް ނެތް",
      "notPosted": "ލިޔެފައި، ޕޯސްޓްކޮށްފައެއް ނުވޭ",
      "title": "އަގުގެ ތަފާތުތައް",
      "wholeOrder": "މުޅި އޯޑަރު"
    },
    "wip": {
      "closedBalanceExplainer": "ބަންދުކުރާއިރު ހުރިހާ ތަފާތެއް ޕޯސްޓްކޮށް، ދެން ބާކީ ސާފުކުރެވެނީ ވިޕް ސުމަކަށް ގެންދިއުމަށް. ބަންދުކުރެވުނު އޯޑަރެއްގައި ސުމަށްވުރެ މަތީގައި ހުރުމަކީ އެ ސާފުކުރުން ނުހިނގާކަން.",
      "closedBalanceHeadline": "ބަންދުކުރެވުނު {count} އޯޑަރުގައި އަދިވެސް ވިޕް",
      "columns": {
        "difference": "ތަފާތު",
        "ledger": "ލެޖަރ ބެލެންސް",
        "maintained": "އޯޑަރުގެ ބެލެންސް"
      },
      "description": "ކޮންމެ އޯޑަރެއްގެ އަމިއްލަ ވިޕް ބެލެންސް، ލެޖަރުން ވަކިން ނެގޭ ޖުމްލައާ އަޅާކިޔައިގެން. މި ދޭތި އެއްގޮތްވާން ޖެހޭނެ، އަދި ބަންދުކުރެވުނު އޯޑަރެއް ސުމަކަށްވާން ޖެހޭނެ.",
      "emptyDescription": "މި ކުންފުންޏަށް އަދި އުފެއްދުމުގެ އޯޑަރެއް ނެތް، ނުވަތަ ވިޕް އެކައުންޓެއް ކަނޑައަޅާފައެއް ނުވޭ.",
      "emptyTitle": "އަޅާކިޔާނެ އެއްޗެއް ނެތް",
      "loadFailed": "ވިޕް ސާފުކުރުމުގެ ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު",
      "methodExplainer": "ބެލެހެއްޓޭ ބެލެންސަކީ ކޮންމެ އޯޑަރެއްގައި އޮންނަ ޕްރޮޖެކްޝަން، އެ ބަދަލުކުރި ކޮންމެ ޕޯސްޓަކާ އެއް ޓްރާންސެކްޝަނުގައި ބަދަލުކުރެވޭ. ލެޖަރ ބެލެންސަކީ އެ އޯޑަރާއި ކުންފުނީގެ ވިޕް އެކައުންޓަށް ޖާނަލް ސަޠުރުތަކުން ވަކިން ނެގޭ ޖުމްލަ.",
      "methodHeadline": "ދެ ޢަދަދު، ވަކިވަކިން ހިސާބުކުރެވުނު",
      "mismatchExplainer": "ޕްރޮޖެކްޝަނާއި ލެޖަރު އެއްގޮތެއް ނުވޭ. މިއީ ދެއްކުމުގެ މައްސަލައެއް ނޫން، އަޅާކިޔުމުގެ ފެއިލްވުމެއް: މި ދޭތި ހިސާބުކުރެވެނީ ދެ ތަނަކުން، އެއީ އެއްޗެއްގައި ގޯހެއް ހުރިނަމަ ފޮރުވުނަނުދިނުމަށް.",
      "mismatchHeadline": "{count} އޯޑަރު އެއްގޮތެއް ނުވޭ",
      "reconcilesExplainer": "ކޮންމެ އޯޑަރެއްގެ ބެލެންސް، ލެޖަރުން ވަކިން ނެގޭ ޖުމްލައާ ލާރިއަކާ ހަމައަށް އެއްގޮތް.",
      "reconcilesHeadline": "ހުރިހާ {count} އޯޑަރެއް އެއްގޮތްވޭ",
      "tableTitle": "{asOf} ގެ ބެލެންސްތައް",
      "title": "ވިޕް ސާފުކުރުން"
    },
    "workCenters": {
      "actions": {
        "add": "އައު މަސައްކަތު ސެންޓަރު"
      },
      "active": "ހަރަކާތްތެރި",
      "activeLabel": "އައު ރޫޓިންގތަކަށް ލިބެންހުރި",
      "capacityHint": "ކެޕޭސިޓީ ރިޕޯޓްގެ ލޯޑް އިންސައްތަ ހިސާބުކުރާ ބައި.",
      "codeHint": "އެއްފަހަރު ހެދުމަށްފަހު ބަދަލެއް ނުކުރެވޭނެ.",
      "codeImmutable": "ކޯޑު ބަދަލެއް ނުކުރެވޭނެ: މަސައްކަތުތެރޭގަޔާއި، މިހާތަނަށް ޕްރިންޓްކުރެވުނު ކޮންމެ ކެޕޭސިޓީ ރިޕޯޓެއްގައި މި ސެންޓަރު އެނގެނީ އެ ކޯޑުން.",
      "columns": {
        "capacity": "ކެޕޭސިޓީ ގަޑިއިރު / ހަފްތާ",
        "costRate": "އަގުގެ ރޭޓް / ގަޑިއިރު",
        "overheadRate": "އޯވަހެޑް ރޭޓް / ގަޑިއިރު"
      },
      "conflictExplainer": "މި މަސައްކަތު ސެންޓަރު އެހެން ބޭފުޅަކު ބަދަލުކޮށްފި. މި ޑައިލޮގު ބަންދުކުރައްވައި، އަލުން ލޯޑްކުރައްވައި، އަލުން އެޑިޓްކުރައްވާ.",
      "costRateHint": "ލިޔެވޭ މަސައްކަތުގެ ވަގުތު ހިސާބުކުރެވޭނެ، ގަޑިއިރަކަށްވާ ރޭޓް.",
      "create": "އައު މަސައްކަތު ސެންޓަރު",
      "createDescription": "މީގެ ރޭޓްތަކަކީ ކޮންމެ އޮޕަރޭޝަނެއް އަގުކުރެވި، މިނެވޭ ސްޓޭންޑަޑް.",
      "created": "މަސައްކަތު ސެންޓަރު ހެދިއްޖެ",
      "editTitle": "މަސައްކަތު ސެންޓަރު އެޑިޓްކުރޭ",
      "emptyDescription": "ރޫޓިންގއެއް ހެއްދެވުމުގެ ކުރިން އެއް ހައްދަވާ: ކޮންމެ އޮޕަރޭޝަނެއް ހިނގަނީ މަސައްކަތު ސެންޓަރެއްގައި، އަދި އަގުކުރެވެނީ އޭގެ ރޭޓުން.",
      "emptyTitle": "އަދި މަސައްކަތު ސެންޓަރެއް ނެތް",
      "fields": {
        "capacity": "ހަފްތާއަކަށް ކެޕޭސިޓީ ގަޑިއިރު",
        "code": "ކޯޑު",
        "costRate": "ގަޑިއިރަކަށް އަގުގެ ރޭޓް",
        "overheadRate": "ގަޑިއިރަކަށް އޯވަހެޑް ރޭޓް"
      },
      "forwardOnly": "ރޭޓެއް ބަދަލުކުރުމުން އަސަރުކުރާނީ ކުރިއަށް އޮތް ޕޯސްޓްތަކަށް. ލިޔެވިފައިވާ ވަގުތުގައި ހުންނާނީ އެ ލިޔުނުއިރުގެ ރޭޓް، އަދި ދޫކޮށްލެވުނު އޯޑަރެއްގައި ރައްކާކުރެވިފައިވާ ރޫޓިންގއަށް އެއްވެސް އަސަރެއް ނުކުރާނެ.",
      "inactive": "ހަރަކާތެއް ނެތް",
      "listDescription": "އޮޕަރޭޝަން ހިންގަނީ ކޮންތާކު، ކޮން ރޭޓެއްގައި، އަދި ހަފްތާއަކަށް ކިހާ ކެޕޭސިޓީއެއް ހުރެގެންކަން.",
      "listTitle": "މަސައްކަތު ސެންޓަރުތައް",
      "loadFailed": "މަސައްކަތު ސެންޓަރުތައް ލޯޑެއް ނުކުރެވުނު",
      "noCapacityWarning": "ހަފްތާގެ ކެޕޭސިޓީއެއް ނެތްނަމަ، ކެޕޭސިޓީ ރިޕޯޓުން ރޭވިފައިވާ ގަޑިއިރު ފެންނާނެ، އެކަމަކު ލޯޑް އިންސައްތައެއް ނުފެންނާނެ: ބަހާނެ އެއްޗެއް ނެތް.",
      "overheadRateHint": "އޮޕަރޭޝަނެއްގައި މެޝިނުގެ ވަގުތު ލިޔެފިނަމަ އެއަށް، ނޫންނަމަ މަސައްކަތުގެ ވަގުތަށް.",
      "ratesIn": "ރޭޓްތަކާއި ކެޕޭސިޓީ ބަޔާންކޮށްފައިވަނީ {currency} އިން.",
      "saveFailed": "މަސައްކަތު ސެންޓަރު ރައްކާނުކުރެވުނު",
      "saved": "މަސައްކަތު ސެންޓަރު ރައްކާކުރެވިއްޖެ",
      "savedDetail": "ބަދަލުތައް ރައްކާކުރެވިއްޖެ.",
      "searchPlaceholder": "ކޯޑު ނުވަތަ ނަން"
    },
    "c7": {
      "filtersTitle": "ފިލްޓަރތައް",
      "common": {
        "remove": "ނަގާ"
      },
      "routeTitles": {
        "ecos": "ބަދަލުކުރުމުގެ އޯޑަރުތައް",
        "eco": "ބަދަލުކުރުމުގެ އޯޑަރު",
        "effectivity": "ބީއޯއެމް ލައިން ހިނގާ މުއްދަތު",
        "bomOutputs": "ބީއޯއެމް އައުޓްޕުޓްތައް",
        "substitutions": "ބަދަލުކުރުންތައް",
        "genealogy": "ދަރިފަސްކޮޅު",
        "calendar": "ވޯކް ސެންޓަރު ކަލަންޑަރު",
        "dispatch": "ޑިސްޕެޗް ލިސްޓް",
        "scheduleRuns": "ޝެޑިއުލިން",
        "bottlenecks": "ބޮޓްލްނެކްތައް",
        "tools": "ޓޫލިން",
        "planningParameters": "ޕްލޭނިން ޕެރެމިޓަރުތައް",
        "mrpRun": "އެމްއާރްޕީ ރަން",
        "pegging": "ޕެގިން",
        "settlement": "ސެޓްލްމަންޓް",
        "rollups": "ސްޓޭންޑަޑް ކޮސްޓް ރޯލްއަޕްތައް",
        "rollup": "ރޯލްއަޕް",
        "varianceAnalysis": "ވެރިއަންސް ދިރާސާ"
      },
      "fields": {
        "code": "ކޯޑް",
        "company": "ކުންފުނި",
        "detail": "ތަފްޞީލު",
        "documentNo": "ނަންބަރު",
        "effectivity": "ހިނގާ މުއްދަތު",
        "fromDate": "ފެށޭ",
        "item": "ބާވަތް",
        "kind": "ބާވަތް",
        "notes": "ނޯޓްތައް",
        "openEnded": "ހުޅުވިފައި",
        "quantity": "އަދަދު",
        "reason": "ސަބަބު",
        "title": "ސުރުޚީ",
        "toDate": "ނިމޭ",
        "urgency": "އަވަސްކަން",
        "value": "އަގު"
      },
      "ecoReason": {
        "design": "ފަރުމާ",
        "cost_reduction": "އަގު ކުޑަކުރުން",
        "quality": "ފެންވަރު",
        "obsolescence": "ބޭނުންނުކުރެވޭ ވަރަށް ބާވެފައި",
        "supplier_change": "ސަޕްލަޔަރު ބަދަލުވުން",
        "regulatory": "ޤާނޫނީ"
      },
      "ecoUrgency": {
        "routine": "އާދައިގެ",
        "expedited": "އަވަސްކުރެވިފައި",
        "emergency": "އެމަޖެންސީ"
      },
      "ecoStatus": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "ހުށަހެޅި",
        "approved": "ފާސްކުރެވިއްޖެ",
        "rejected": "ބޭރުކުރެވިއްޖެ",
        "effective": "ހިނގާ މުއްދަތު",
        "closed": "ބަންދުކުރެވިފައި",
        "cancelled": "ކެންސަލްކުރެވިފައި"
      },
      "ecoChangeKind": {
        "bom_line_add": "ބީއޯއެމް ލައިން އިތުރުކުރެވިއްޖެ",
        "bom_line_change": "ބީއޯއެމް ލައިން ބަދަލުކުރެވިއްޖެ",
        "bom_line_remove": "ބީއޯއެމް ލައިން ނަގައިފި",
        "routing_op_change": "އޮޕަރޭޝަން ބަދަލުކުރެވިއްޖެ",
        "item_attribute": "ތަކެތީގެ ސިފަ",
        "alternate_add": "ބަދަލު އެއްޗެއް އިތުރުކުރެވިއްޖެ",
        "alternate_remove": "ބަދަލު އެއްޗެއް ނަގައިފި"
      },
      "dispositionSubject": {
        "stock": "ގުދަނުގައި ހުރި ސްޓޮކް",
        "wip": "މަސައްކަތުގައި ހުރި (ވިޕް)",
        "production_order": "އުފެއްދުމުގެ އޯޑަރު",
        "purchase_order": "ގަތުމުގެ އޯޑަރު",
        "inspection_plan": "އިންސްޕެކްޝަން ޕްލޭން"
      },
      "dispositionAction": {
        "use_up": "ބޭނުންކޮށް ހުސްކުރޭ",
        "rework": "އަލުން ހަދާ",
        "scrap": "ސްކްރެޕްކުރޭ",
        "return": "ބަޔާން",
        "amend": "އިޞްލާޙުކުރޭ",
        "no_action": "ފިޔަވަޅެއް ނެތް"
      },
      "dispositionStatus": {
        "open": "ހުޅުވިފައި",
        "done": "ނިމިއްޖެ",
        "waived": "ދޫކޮށްލި"
      },
      "outputKind": {
        "primary": "މައި އައުޓްޕުޓް",
        "co_product": "ކޯ-ޕްރޮޑަކްޓް",
        "by_product": "ބައި-ޕްރޮޑަކްޓް",
        "scrap_output": "ސްކްރެޕް އައުޓްޕުޓް"
      },
      "splitBasis": {
        "physical_quantity": "ޢަދަދު",
        "relative_value": "ނިސްބަތުގެ އަގު",
        "fixed_percent": "ކަނޑައެޅިފައިވާ އިންސައްތަ"
      },
      "exceptionKind": {
        "closed": "ބަންދުކުރެވިފައި",
        "extra_shift": "އިތުރު ޝިފްޓް",
        "reduced": "ކުޑަކުރެވިފައި"
      },
      "scheduleDirection": {
        "forward": "ކުރިއަށް",
        "backward": "ފަހަތަށް"
      },
      "scheduleMode": {
        "finite": "ފިނައިޓް",
        "infinite": "އިންފިނައިޓް"
      },
      "toolStatus": {
        "available": "ލިބެންހުރި",
        "in_use": "ގައި use",
        "maintenance": "މެއިންޓަނަންސް",
        "retired": "ބޭނުންކުރުމުން ހުއްޓާލާފައި"
      },
      "weekday": {
        "0": "އާދިއްތަ",
        "1": "ހޯމަ",
        "2": "އަންގާރަ",
        "3": "ބުދަ",
        "4": "ބުރާސްފަތި",
        "5": "ހުކުރު",
        "6": "ހޮނިހިރު"
      },
      "lotSizing": {
        "lot_for_lot": "ލޮޓަކަށް ލޮޓެއް",
        "fixed_quantity": "ކަނޑައެޅިފައިވާ މިންވަރު",
        "min_max": "އެންމެ ދަށް އަދި އެންމެ މަތި",
        "period_of_supply": "ސަޕްލައިގެ މުއްދަތު",
        "eoq": "އިޤްތިޞާދީ އޯޑަރު މިންވަރު"
      },
      "sourcePolicy": {
        "make": "ހަދާ",
        "buy": "ގަނޭ",
        "either": "ދެގޮތުންވެސް"
      },
      "demandKind": {
        "sales_order": "ވިއްކުމުގެ އޯޑަރު",
        "production_order": "އުފެއްދުމުގެ އޯޑަރު",
        "forecast": "ފޯކާސްޓް",
        "safety_stock": "ރައްކާތެރި ސްޓޮކް",
        "transfer": "ޓްރާންސްފަރ",
        "min_max": "އެންމެ ދަށް ސްޓޮކް"
      },
      "mrpException": {
        "inside_time_fence": "ޓައިމް ފެންސްގެ ތެރޭގައި",
        "past_due_demand": "ބޭނުންވުމުގެ ތާރީޚު ފާއިތުވެއްޖެ",
        "no_source_policy": "ސޯސް ޕޮލިސީއެއް ނެތް",
        "no_lead_time": "ލީޑް ޓައިމެއް ނެތް",
        "no_bom_for_make": "ތަކެތީގެ ލިސްޓެއް ނެތް",
        "no_supplier_for_buy": "ސަޕްލަޔަރެއް ނެތް",
        "low_level_cap_reached": "ބިލް އޮފް މެޓީރިއަލްސްގެ ސައިކަލެއް",
        "negative_available": "ލިބެން ހުރި ސްޓޮކް މައިނަސްގައި"
      },
      "settlementStatus": {
        "preview": "ކުރިން ބަލާލުން",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "residualDisposition": {
        "write_off": "ރައިޓް-އޯފް",
        "reallocate_to_output": "އައުޓްޕުޓަށް ބަހާ",
        "carry_to_new_order": "އެހެން އޯޑަރަކަށް ގެންދޭ"
      },
      "rollupStatus": {
        "draft": "ދެލިކޮޕީ",
        "applied": "ބޭނުންކުރެވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "rollupBasis": {
        "standard": "ކޮމްޕޯނަންޓް ސްޓޭންޑަޑް",
        "moving_average": "މޫވިންގ އެވްރެޖް"
      },
      "costElement": {
        "material": "މާއްދާ",
        "labor": "މަސައްކަތު ވަގުތު",
        "overhead": "އޯވަހެޑް",
        "subcontract": "ސަބްކޮންޓްރެކްޓް",
        "by_product_credit": "ބައި-ޕްރޮޑަކްޓް ކްރެޑިޓް"
      },
      "costSource": {
        "component_standard": "ކޮމްޕޯނަންޓް ސްޓޭންޑަޑް",
        "component_moving_average": "ކޮމްޕޯނަންޓް މޫވިން އެވަރެޖް",
        "work_center_rate": "ވޯކް ސެންޓަރު ރޭޓް",
        "nested_rollup": "އެތެރޭގެ ރޯލްއަޕް",
        "manual": "އަތުން ކަނޑައެޅި"
      },
      "varianceType": {
        "material_price": "މެޓީރިއަލްގެ އަގުގެ ތަފާތު",
        "material_usage": "މެޓީރިއަލް ބޭނުންކުރުމުގެ ތަފާތު",
        "labor_rate": "މަސައްކަތުގެ ރޭޓްގެ ތަފާތު",
        "labor_efficiency": "މަސައްކަތުގެ ހަރުދަނާކަމުގެ ތަފާތު",
        "overhead": "އޯވަރހެޑް (ސީ7 ގެ ކުރީގެ ޕްލަގް)",
        "yield": "ޔީލްޑް",
        "overhead_spend": "އޯވަރހެޑް ޚަރަދު",
        "overhead_volume": "އޯވަރހެޑް މިންވަރު"
      },
      "blocker": {
        "operation_incomplete": "އޮޕަރޭޝަނެއް ނުނިމޭ",
        "open_ncr": "ނޮންކޮންފޯމަންސެއް އަދިވެސް ހުޅުވިފައި",
        "order_on_hold": "އޯޑަރު ހިފެހެއްޓިފައި",
        "open_inspection": "ބްލޮކްކުރާ އިންސްޕެކްޝަނެއް ފާސްވެފައެއް ނުވޭ",
        "missing_variance_account": "ސުމެއް ނޫން ވެރިއަންސަކަށް ވެރިއަންސް އެކައުންޓެއް ކަނޑައަޅާފައެއް ނުވޭ",
        "missing_overhead_account": "އޯވަރހެޑް ވެރިއަންސް އެކައުންޓް ކަނޑައަޅާފައެއް ނުވޭ، އަދި ބާކީއަކީ ސުމެއް ނޫން"
      },
      "eco": {
        "title": "އިންޖިނިއަރިން ބަދަލުކުރުމުގެ އޯޑަރުތައް",
        "description": "ބަދަލުވާ އެއްޗެއް، އެއިން އަސަރުކުރާ އެއްޗެއް، އަދި މިހާރު ޢިމާރާތުގައި ހުރި މާއްދާތަކާމެދު ކުރަން ޖެހޭ ކަންތައް.",
        "tableTitle": "ބަދަލުކުރުމުގެ އޯޑަރުތައް",
        "caption": "ބަދަލުކުރުމުގެ އޯޑަރުތަކާއި އޭގެ ސަބަބު، އަވަސްކަން، ހިނގާ މުއްދަތު އަދި ނުނިމި ހުރި ނިންމުންތައް.",
        "create": "އައު ބަދަލުކުރުމުގެ އޯޑަރު",
        "dialogDescription": "ބަދަލެއް ފެށޭނީ ތާރީޚަކުން ނުވަތަ އޯޑަރަކުން — ދެގޮތުން އެއްފަހަރާ ނުވޭ.",
        "searchLabel": "ހޯދާ",
        "searchPlaceholder": "ނަންބަރު ނުވަތަ ސުރުޚީ",
        "loadFailed": "ބަދަލުކުރުމުގެ އޯޑަރުތައް ލޯޑެއް ނުވި",
        "empty": "ބަދަލުކުރުމުގެ އޯޑަރެއް ނެތް. ފަރުމާއެއް، ސަޕްލަޔަރެއް ނުވަތަ މިންގަނޑެއް ބަދަލުވުމުން އެއް ހުށަހެޅޭ.",
        "emptyFiltered": "މި ފިލްޓަރުތަކާ ގުޅޭ ބަދަލުކުރުމުގެ އޯޑަރެއް ނެތް.",
        "draftNo": "ދެލިކޮޕީ",
        "effectiveFrom": "ފެށޭ ތާރީޚު",
        "effectiveFromOrder": "ފެށޭ އޯޑަރު",
        "fromOrder": "{no} އިން",
        "openDispositions": "ހުޅުވިފައި",
        "anchor": "ހިނގާ މުއްދަތުގެ އޭންކަރު",
        "anchorHint": "ބަދަލު ޖެހޭނެ ބިލްޑް.",
        "anchorDate": "ތާރީޚެއް",
        "anchorDateMeaning": "މި ތާރީޚުން ފެށިގެން ނުވަތަ އޭގެ ފަހުން ހަދާ ހުރިހާ އެއްޗަކަށް ހިނގާނެ",
        "anchorOrder": "ޕްރޮޑަކްޝަން އޯޑަރެއް",
        "anchorOrderMeaning": "ތާރީޚު ކޮންމެ އެއްޗެއް ކަމުގައި ވިޔަސް، މި އޯޑަރުން ފެށިގެން ހިނގާނެ",
        "noAnchor": "އަދި އޭންކަރުކުރެވިފައެއް ނުވޭ",
        "estimatedImpact": "އަގަށް އަންނާނެކަމަށް ލަފާކުރެވޭ އަސަރު",
        "realisedImpact": "އަގަށް ކުރި ޙަޤީޤީ އަސަރު",
        "urgencyMeaning": {
          "routine": "ދެން އަންނަ މުރާޖަޢާއާއެކު ތާވަލުކުރޭ",
          "expedited": "އަވަސްކުރޭ",
          "emergency": "އެމަޖެންސީ ބަދަލަކުން މިހާރު ލައިން ހުއްޓޭ. އުފެއްދުން ކުރިއަށް ނުގެންދެވޭނަމަ އެކަނި ހުށަހަޅާ."
        },
        "factsTitle": "ބަދަލުކުރުމުގެ އޯޑަރު",
        "itemsTitle": "ބަދަލުތައް",
        "itemsCaption": "ބަދަލުވާ އެއްޗެއް، ކުރިން އަދި ފަހުން.",
        "itemsEmpty": "އަދި ބަދަލުކުރުމުގެ އައިޓަމެއް ރެކޯޑްކުރެވިފައެއް ނުވޭ.",
        "changeKind": "ބަދަލުކުރޭ",
        "before": "ކުރިން",
        "after": "ފަހުން",
        "dispositionsTitle": "ނިންމުންތައް",
        "dispositionsCaption": "މި ބަދަލުން އަސަރުކުރާ ސްޓޮކް، ހިނގަމުންދާ މަސައްކަތް އަދި ހުޅުވިފައިވާ އޯޑަރުތައް.",
        "dispositionsMeaning": "މި ބަދަލު ބަންދުކުރެވޭނީ، މިހާރު ހިނގަމުންދާ މާއްދާތަކާއި އޯޑަރުތަކާމެދު ކުރަން ޖެހޭ ކަންތައް ކުރުމުން.",
        "notAnalysed": "މި ބަދަލު ދިރާސާކުރެވިފައެއް ނުވޭ. ދިރާސާކުރުމުން ބޭނުންކޮށް ހުސްކުރަން ޖެހޭ ސްޓޮކާއި، އަލުން ހަދަން ޖެހޭ ހިނގަމުންދާ މަސައްކަތާއި، އިޞްލާޙުކުރަން ޖެހޭ ހުޅުވިފައިވާ އޯޑަރުތައް ފެނޭ — އެއާ ނުލައި ފާސްކުރެވުނު ބަދަލަކީ މަސައްކަތެއް ނޫން، ލިޔުމެއް.",
        "analyse": "އަސަރު ދިރާސާކުރޭ",
        "analysed": "އަސަރު ދިރާސާކޮށްފި",
        "analyseFailed": "އަސަރު ދިރާސާއެއް ނުކުރެވުނު",
        "subject": "ބެހޭ",
        "action": "އެކްޝަން",
        "markDone": "ނިމުނުކަމަށް ފާހަގަކުރޭ",
        "dispositionCompleted": "ނިންމުން ފުރިހަމަކޮށްފި",
        "dispositionFailed": "ނިންމުން އަޕްޑޭޓެއް ނުކުރެވުނު",
        "openBlocksClose": "{count} ނިންމުމެއް އަދިވެސް ހުޅުވިފައި. އެ ސާފުކުރަންދެން ބަދަލު ބަންދެއް ނުކުރެވޭނެ.",
        "submitted": "ބަދަލުކުރުމުގެ އޯޑަރު ހުށަހަޅައިފި",
        "submitFailed": "ބަދަލުކުރުމުގެ އޯޑަރު ހުށަނޭޅުނު",
        "approved": "ބަދަލުކުރުމުގެ އޯޑަރު ފާސްކޮށްފި",
        "decideFailed": "ނިންމުން ވި ނޫން ރެކޯޑްކުރެވިފައި",
        "apply": "ހަމަޖައްސާ",
        "applied": "ބަދަލުކުރުމުގެ އޯޑަރު ހިންގައިފި",
        "applyFailed": "ބަދަލުކުރުމުގެ އޯޑަރު ނުހިންގުނު",
        "close": "ކައިރި",
        "closed": "ބަދަލުކުރުމުގެ އޯޑަރު ބަންދުކޮށްފި",
        "closeFailed": "ބަދަލުކުރުމުގެ އޯޑަރު ބަންދުނުކުރެވުނު",
        "saved": "ބަދަލުކުރުމުގެ އޯޑަރު ހުށަހަޅައިފި",
        "saveFailed": "ބަދަލުކުރުމުގެ އޯޑަރު ރައްކާނުކުރެވުނު",
        "backToList": "ބަދަލުކުރުމުގެ އޯޑަރުތަކަށް އެނބުރި"
      },
      "effectivity": {
        "title": "ބީއޯއެމް ލައިން ހިނގާ މުއްދަތު",
        "description": "މި ލައިން ހިނގާ ވަގުތާއި، އެއިން ބޭނުންވާ މިންވަރު.",
        "tableTitle": "ހިނގާ މުއްދަތުގެ ވިންޑޯތައް",
        "caption": "ހިނގާ މުއްދަތުގެ ވިންޑޯތަކާއި ކޮންމެއެއްގެ ތެރޭގައި ހިނގާ މިންވަރާއި ސްކްރެޕް.",
        "loadFailed": "ހިނގާ މުއްދަތު ލޯޑެއް ނުވި",
        "alwaysMeaning": "މި ލައިނުގައި ހިނގާ މުއްދަތުގެ ވިންޑޯއެއް ނެތް، އެއީ ދާއިމަށް ހިނގާ ކަމަށް. ވިންޑޯއެއް އިތުރުކުރުމުން، އެ ވިންޑޯއިން ބޭރު ކޮންމެ ތާރީޚަކަށް އެ ނިވޭ.",
        "from": "ފެށޭ",
        "to": "ނިމޭ",
        "fromOrder": "ފެށޭ އޯޑަރު",
        "quantityPer": "ކޮންމެއަކަށް މިންވަރު",
        "scrapPct": "ސްކްރެޕް %",
        "addRow": "ވިންޑޯއެއް އިތުރުކުރޭ",
        "saved": "ހިނގާ މުއްދަތު ރައްކާކޮށްފި",
        "saveFailed": "ހިނގާ މުއްދަތު ރައްކާނުކުރެވުނު",
        "lineLink": "ހިނގާ މުއްދަތު",
        "lineLinkAria": "{item}ގެ ހިނގާ މުއްދަތުގެ ވިންޑޯތައް"
      },
      "outputs": {
        "title": "ބީއޯއެމް އައުޓްޕުޓްތައް",
        "description": "މި ބިލުން ލިބޭ ކޯ-ޕްރޮޑަކްޓް، ބައި-ޕްރޮޑަކްޓް އަދި ސްކްރެޕް.",
        "tableTitle": "އައުޓްޕުޓްތައް",
        "caption": "އައުޓްޕުޓްތަކާއި އޭގެ ބާވަތް، އަގު ބެހުމުގެ އަސާސް އަދި ކްރެޑިޓް ރޭޓް.",
        "loadFailed": "އައުޓްޕުޓްތައް ލޯޑެއް ނުވި",
        "empty": "ދެވަނަ ދަރަޖައިގެ އައުޓްޕުޓެއް ނެތް. މި ބިލުން ހަދާ ހުރިހާ އެއްޗަކީ މައި އެއްޗެއް.",
        "quantityPer": "ކޮންމެއަކަށް މިންވަރު",
        "basis": "ބެހުމުގެ އަސާސް",
        "sharePercent": "ބައި %",
        "creditRate": "ކްރެޑިޓް ރޭޓް",
        "addRow": "އައުޓްޕުޓެއް އިތުރުކުރޭ",
        "splitMeaning": "މިތާ ހުރި ޕަސެންޓޭޖްތަކަކީ ސެޓިންގްސް. ފައިސާ ބަހަނީ ސާވަރުން، ޙަޤީޤަތުގައި ލިބުނު މިންވަރުތަކުން، އެންމެ ބޮޑު ބާކީގެ އުޞޫލުން، އެހެންވެ ހިނގަމުންދާ މަސައްކަތާ ސެންޓާ ހަމައަށް ދިމާވޭ.",
        "kindMeaning": {
          "co_product": "އޯޑަރުގެ އަގުން ބައެއް ނަގާ",
          "by_product": "ބައެއް ނުނަގާ؛ ސްޓޭންޑަޑް ރޭޓަކުން ޑަބްލިއުއައިޕީއަށް ކްރެޑިޓްކުރޭ",
          "scrap_output": "އަގެއް ނުނަގާ، އަދި ކްރެޑިޓެއްވެސް ނުދޭ"
        },
        "basisMeaning": {
          "physical_quantity": "އުފެއްދި ޔުނިޓުން ބަހާ",
          "relative_value": "ބާޒާރު އަގުން ބަހާ",
          "fixed_percent": "ތިޔަ ބޭފުޅާ ކަނޑައަޅާ ޕަސެންޓަކުން ބަހާ"
        },
        "saved": "އައުޓްޕުޓްތައް ރައްކާކޮށްފި",
        "saveFailed": "އައުޓްޕުޓްތައް ރައްކާނުކުރެވުނު"
      },
      "substitution": {
        "title": "ބަދަލުކުރުންތައް",
        "description": "ކޮން އެއްޗެއްގެ ބަދަލުގައި ކޮން އެއްޗެއް ބޭނުންކުރިކަން، އަދި އޭގެ އަގު.",
        "tableTitle": "ބަދަލުކުރުންތައް",
        "caption": "ބަދަލުކުރުންތަކާއި އޭގެ ބަދަލުކުރުމުގެ ނިސްބަތް، އަގުތައް އަދި އަގަށް އަންނަ އަސަރު.",
        "loadFailed": "ބަދަލުކުރުންތައް ލޯޑެއް ނުވި",
        "empty": "މި އޯޑަރުގައި އެއްވެސް އެއްޗެއް ބަދަލުކުރެވިފައެއް ނުވޭ.",
        "backToOrder": "އޯޑަރަށް އެނބުރި",
        "original": "ބޭނުންވޭ",
        "substitute": "ބޭނުންކުރި",
        "quantityOriginal": "ބޭނުންވާ މިންވަރު",
        "quantitySubstitute": "ދޫކުރި މިންވަރު",
        "conversion": "ބަދަލުކުރުމުގެ ނިސްބަތް",
        "originalStandard": "އަޞްލު ސްޓޭންޑަޑް",
        "substituteActual": "ބަދަލުގެ ޙަޤީޤީ އަގު",
        "costImpact": "އަގަށް އަންނަ އަސަރު",
        "planned": "ރޭވިފައި",
        "declaredAlternate": "ބަޔާންކޮށްފައިވާ ބަދަލު",
        "unplanned": "ނުރޭވި",
        "unplannedCount": "{count} ބަދަލުކުރުމަކީ ބަޔާންކޮށްފައިވާ ބަދަލެއް ނޫން. ކޮންމެއެއްގައި ސަބަބަކާއި އޯވަރައިޑެއް އޮވޭ.",
        "replacing": "{item} ގެ ބަދަލުގައި",
        "declared": "ބަޔާންކޮށްފައިވާ ބަދަލު",
        "declaredHint": "އިސްކަންދޭ ތަރުތީބުން، ކޮންމެއެއްގެ ބަދަލުކުރުމުގެ ނިސްބަތާއި ލިބެން ހުރި ސްޓޮކާއެކު.",
        "noneDeclared": "މި މާއްދާއަށް ބަޔާންކޮށްފައިވާ ބަދަލެއް ނެތް.",
        "available": "ލިބެންހުރި",
        "priority": "އިސްކަން",
        "optionHint": "×{factor} · ލިބެން ހުރީ {available}",
        "other": "އެހެން އެއްޗެއް",
        "otherHint": "ބަޔާންކޮށްފައިވާ ލިސްޓުގައި ނެތް ކޮންމެ އެއްޗަކަށް ސަބަބެއް ބޭނުންވޭ.",
        "undeclaredMeaning": "މިއީ ބަޔާންކޮށްފައިވާ ބަދަލެއް ނޫން. އަދިވެސް ސަބަބަކާއެކު ދޫކުރެވިދާނެ، އަދި ވެރިއަންސް ބަލާއިރު އިންޖިނިއަރު ކިޔާނީ އެ ސަބަބު.",
        "reasonHint": "ބަދަލުގައި މި ބޭނުންކުރި ސަބަބު.",
        "required": "ބޭނުންވޭ",
        "meterLabel": "ބޭނުންވި {required} އަށް، ދޫކުރެވުނީ {issued}",
        "warnMeaning": "ބޭނުންވާ މިންވަރަށްވުރެ {percent}% އަށްވުރެ ގިނަ. މިއިން ދޫކުރެވޭ، އަދި ބޭނުންކުރުމުގެ ވެރިއަންސެއްގެ ގޮތުގައި ރެކޯޑްކުރެވޭ.",
        "approveMeaning": "ބޭނުންވާ މިންވަރަށްވުރެ {percent}% އަށްވުރެ ގިނަ. ބާރު ލިބިފައިވާ މީހަކު އޯވަރައިޑްކުރަންދެން މިކަން ބަލައެއް ނުގަނެވޭނެ."
      },
      "genealogy": {
        "title": "ދަރިފަސްކޮޅު",
        "description": "ކޮން ރޯ ލޮޓެއް ކޮން ނިމުނު ލޮޓަކަށް ދިޔަކަން.",
        "treeTitle": "ބޭނުންކުރެވުނު އަދި އުފެއްދުނު",
        "loadFailed": "ޖެނިއޮލޮޖީ ލޯޑެއް ނުވި",
        "empty": "މި އޯޑަރުގައި ޖެނިއޮލޮޖީއެއް ނެތް. ލޮޓުން ޓްރެކްކުރެވޭ އެއްޗެއް ބޭނުމެއް ނުކުރެވޭ، އުފެއްދިފައެއްވެސް ނުވޭ، އެހެންވެ ގުޅުވާނެ އެއްޗެއް ނެތް.",
        "noConsumed": "ލޮޓުން ޓްރެކްކުރެވޭ މާއްދާއެއް ބޭނުމެއް ނުކުރެވޭ",
        "depthCapReached": "ޓްރޭސްގެ ފުންމިނުގެ ހަމައަށް ފޯރައިފި؛ ބައެއް ކުރީގެ ލޮޓްތައް ނުދައްކާ ހުރެދާނެ."
      },
      "calendar": {
        "title": "ވޯކް ސެންޓަރު ކަލަންޑަރު",
        "description": "މި ސެންޓަރު ހިނގާ ވަގުތާއި، އެއިން ނަތީޖާ ނެރެވޭ މިންވަރު.",
        "loadFailed": "ކަލަންޑަރު ލޯޑެއް ނުވި",
        "none": "މި ވޯކް ސެންޓަރުގައި ކަލަންޑަރެއް ނެތް. އެއް ލިބެންދެން ފިނައިޓް ޝެޑިއުލަރުން މި ބަލަނީ ލިބެން ނެތް ސެންޓަރެއްގެ ގޮތުގައި.",
        "opcalMeaning": "ސަރުކާރު ބަންދު ދުވަސްތައް އަންނަނީ ކުންފުނީގެ އޮޕަރޭޓިން ކަލަންޑަރުން، މިތަނުން ނޫން. ތިރީގައިވާ އެކްސެޕްޝަންތަކަކީ ހަމައެކަނި މި ސެންޓަރަށް ޚާއްޞަ ކަންކަން.",
        "factorsTitle": "ފެކްޓަރުތައް",
        "factorsMeaning": "ހަރުދަނާކަމުން މަސައްކަތަށް ނަގާ ވަގުތު ދިގުކުރޭ. ބޭނުންކުރެވޭ މިންވަރުން ލިބެން އޮތް ވަގުތު ކުޑަކުރޭ. މިއީ ދެ ޑައަލެއް، އަދި ޝެޑިއުލަރުން ދެވެސް ބޭނުންކުރޭ.",
        "efficiency": "ހަރުދަނާކަން %",
        "utilisation": "ބޭނުންކުރެވޭ މިންވަރު %",
        "parallelCapacity": "އެއްފަހަރާ ކުރެވޭ މަސައްކަތް",
        "shiftsTitle": "ޝިފްޓްތައް",
        "shiftsCaption": "ހަފުތާގެ ދުވަހުން ޝިފްޓްތައް، މެންދަމުން ފެށިގެން މިނެޓުން.",
        "weekday": "ދުވަސް",
        "shifts": "ޝިފްޓްތައް",
        "shiftCode": "ޝިފްޓް",
        "start": "ފަށާ",
        "end": "ނިންމާ",
        "closed": "ބަންދުކުރެވިފައި",
        "overnight": "މެންދަމު ފަހަނައަޅާ",
        "addShift": "ޝިފްޓެއް އިތުރުކުރޭ",
        "saved": "ޝިފްޓްތައް ރައްކާކުރެވިއްޖެ",
        "saveFailed": "ޝިފްޓްތައް ރައްކާނުކުރެވުނު",
        "exceptionsTitle": "އިސްތިސްނާތައް",
        "exceptionsCaption": "މި ސެންޓަރު އާދައިގެ ތާވަލަށް ނުހިނގާ ދުވަސްތައް.",
        "exceptionsMeaning": "ހަމައެކަނި މި ސެންޓަރު ތަފާތުވާ ދުވަސްތައް: އިތުރު ހޮނިހިރެއް، މެއިންޓަނަންސް ބަންދެއް، ކުޑަކުރެވުނު ޝިފްޓެއް.",
        "exceptionsEmpty": "އެކްސެޕްޝަނެއް ރެކޯޑްކުރެވިފައެއް ނުވޭ.",
        "exceptionMeaning": {
          "closed": "ސެންޓަރު މުޅިން ނުހިނގާ",
          "extra_shift": "އާދައިގެ ތާވަލުގެ މައްޗަށް އިތުރު ވިންޑޯއެއް",
          "reduced": "އާދައިގެ ތާވަލު، ކުޑަ ކެޕޭސިޓީއަކާއެކު"
        },
        "date": "ތާރީޚް",
        "blockedBy": "ހުއްޓުވީ",
        "exceptionSaved": "އެކްސެޕްޝަން ރެކޯޑްކޮށްފި",
        "exceptionFailed": "އެކްސެޕްޝަން ރެކޯޑެއް ނުކުރެވުނު"
      },
      "dispatch": {
        "title": "ޑިސްޕެޗް ލިސްޓް",
        "description": "މި ސެންޓަރުން ދެން ކުރާނެ ކަންތައް، ތަރުތީބުން.",
        "tableTitle": "ޑިސްޕެޗް",
        "caption": "ޑިސްޕެޗް ތަރުތީބުން ތާވަލުކުރެވިފައިވާ އޮޕަރޭޝަންތައް.",
        "loadFailed": "ޑިސްޕެޗް ލިސްޓް ލޯޑެއް ނުވި",
        "empty": "މި ވޯކް ސެންޓަރުގައި އެއްވެސް އެއްޗެއް ތާވަލުކުރެވިފައެއް ނުވޭ.",
        "seq": "ނޫން",
        "operation": "އޮޕަރޭޝަން",
        "start": "ފަށާ",
        "end": "ނިންމާ",
        "minutes": "މިނެޓް",
        "frozen": "ފެށިފައި",
        "moveUp": "ކުރިއަށް ޖައްސާ",
        "moveDown": "ފަހަތަށް ޖައްސާ",
        "save": "ތަރުތީބު ރައްކާކުރޭ",
        "saved": "ޑިސްޕެޗް ތަރުތީބު ރައްކާކޮށްފި",
        "saveFailed": "ޑިސްޕެޗް ތަރުތީބު ރައްކާނުކުރެވުނު"
      },
      "bottlenecks": {
        "title": "ބޮޓްލްނެކްތައް",
        "description": "ކެޕޭސިޓީއާ އަޅާކިޔޭ ބުރަ، އަދި ޙަޤީޤަތުގައި ޕްލޭން ހުއްޓުވާ ސެންޓަރު.",
        "tableTitle": "މަސައްކަތު ސެންޓަރުތައް",
        "caption": "ވޯކް ސެންޓަރުތަކާއި އޭގެ ރޭވިފައިވާ އަދި ލިބެން ހުރި މިނެޓް.",
        "loadFailed": "ބޮޓްލްނެކް ރިޕޯޓް ލޯޑެއް ނުވި",
        "empty": "މި މުއްދަތުގައި ބުރައެއް ނެތް.",
        "workCenter": "މަސައްކަތު ސެންޓަރު",
        "planned": "ރޭވިފައި",
        "available": "ލިބެންހުރި",
        "load": "ބުރަ",
        "firstOverloadOn": "ފުރަތަމަ ބުރަވި",
        "constraint": "ހުރަސް",
        "isConstraint": "ހުރަސް",
        "meterLabel": "ލިބެން ހުރި {available} އަށް، ރޭވިފައި {planned}",
        "week": "ހަފްތާ",
        "runnerUp": "ދެވަނަ"
      },
      "schedule": {
        "title": "ޝެޑިއުލިން",
        "description": "ފިނައިޓް ޝެޑިއުލިން ރަންތަކާއި އޭގެ ނަތީޖާ.",
        "runTitle": "ޝެޑިއުލަރު ހިންގާ",
        "tableTitle": "ރަންތައް",
        "caption": "ޝެޑިއުލިން ރަންތަކާއި އޭގެ ދިމާ، މޯޑް އަދި ނަތީޖާ.",
        "loadFailed": "ޝެޑިއުލިން ރަންތައް ލޯޑެއް ނުވި",
        "empty": "އަދި ޝެޑިއުލިން ރަނެއް ނުހިނގާ.",
        "direction": "ދިމާ",
        "directionMeaning": {
          "forward": "ފެށޭ ތާރީޚަކުން: ނިމޭނީ ކޮންއިރަކުތަ؟",
          "backward": "ސުންގަޑިއަކުން: ފަށަން ޖެހެނީ ކޮންއިރަކުތަ؟"
        },
        "mode": "ގޮތް",
        "modeMeaning": {
          "finite": "ކެޕޭސިޓީއަށް ބަލާ، އަދި ހުރި ބުރައިގެ ފަހަތުގައި ކިޔޫވޭ",
          "infinite": "ކެޕޭސިޓީއަށް ނުބަލާ؛ ނަޒަރީ ސިފަ"
        },
        "anchor": "އޭންކަރު ތާރީޚު",
        "horizon": "މުއްދަތު (ދުވަސް)",
        "run": "ރަން",
        "ran": "ޝެޑިއުލް ހިންގައިފި",
        "runFailed": "ޝެޑިއުލަރު ނުހިނގުނު",
        "runAt": "ހިންގި",
        "ordersScheduled": "އޯޑަރުތައް",
        "operationsScheduled": "އޮޕަރޭޝަންތައް",
        "operationsLate": "ލަސް",
        "persistMeaning": "ރަނަކުން އޮޕަރޭޝަންތަކަށް ފެށޭ އަދި ނިމޭ ވަގުތު ލިޔޭ. މިއީ ލިޔުނު މީހަކާއި ވަގުތެއް އޮތް ލިޔުމެއް، ޕްރިވިއުއެއް ނޫން."
      },
      "tools": {
        "title": "ޓޫލިން",
        "description": "ޓޫލްތަކާއި އޭގެ ބާކީ ޢުމުރު އަދި އެއިން ހުއްޓުވާ ކަންކަން.",
        "tableTitle": "ޓޫލްތައް",
        "caption": "ޓޫލްތަކާއި އޭގެ ވޯކް ސެންޓަރު، ޢުމުރު އަދި ސާވިސް ތާރީޚު.",
        "loadFailed": "ޓޫލިން ރަޖިސްޓަރީ ލޯޑެއް ނުވި",
        "empty": "ޓޫލެއް ރަޖިސްޓަރީކުރެވިފައެއް ނުވޭ.",
        "workCenter": "މަސައްކަތު ސެންޓަރު",
        "life": "މުއްދަތު",
        "lifeLabel": "{life} ސައިކަލުގެ ތެރެއިން {used} ބޭނުންކުރެވިއްޖެ",
        "noLifeLimit": "ޢުމުރުގެ ހައްދެއް ނެތް",
        "nextService": "ދެން އޮތް ސާވިސް",
        "blockingMeaning": "{count} ޓޫލެއް ބޭނުންކުރުން ހުއްޓާލެވިފައި ނުވަތަ މެއިންޓަނަންސްގައި. އޭގެ ތެރެއިން ޓޫލެއް ލާޒިމު އޯޑަރެއް، އޯވަރައިޑަކާ ނުލައި ދޫނުކުރެވޭނެ."
      },
      "planning": {
        "title": "ޕްލޭނިން ޕެރެމިޓަރުތައް",
        "description": "ކޮންމެ އެއްޗެއް އެމްއާރްޕީއަށް ރޭވޭނެ ގޮތް.",
        "tableTitle": "ޕެރެމިޓަރުތައް",
        "caption": "ޕްލޭނިން ޕެރެމިޓަރުތަކާއި އޭގެ ލޮޓް ސައިޒްކުރުމުގެ ޤަވާޢިދު، ފެންސްތައް އަދި ސޯސް ޕޮލިސީ.",
        "loadFailed": "ޕްލޭނިން ޕެރެމިޓަރުތައް ލޯޑެއް ނުވި",
        "empty": "ޕްލޭނިން ޕެރެމިޓަރެއް ކަނޑައަޅާފައެއް ނުވޭ. އެއްވެސް އެއްޗެއް ނެތް ތަކެތި ރޭވެނީ ލޮޓަކަށް ލޮޓެއްގެ ގޮތުގައި.",
        "rule": "ލޮޓް ސައިޒްކުރުން",
        "ruleMeaning": {
          "lot_for_lot": "މަދުވާ މިންވަރު ސީދާ އޯޑަރުކުރޭ",
          "fixed_quantity": "ދާއިމަށް އެއް މިންވަރެއް އޯޑަރުކުރޭ",
          "min_max": "އެންމެ ދަށް މިންވަރު ފަހަނައަޅައި ދިޔުމުން، އެންމެ މައްޗަށް ފުރާ",
          "period_of_supply": "ގިނަ ދުވަހުގެ ބޭނުންވުން އެއް އޯޑަރަކަށް އެއްކުރޭ",
          "eoq": "އިޤްތިޞާދީ އޯޑަރު މިންވަރު"
        },
        "fixedQuantity": "ކަނޑައެޅިފައިވާ މިންވަރު",
        "min": "އެންމެ ދަށް",
        "max": "އެންމެ މަތި",
        "planningFence": "ޕްލޭނިން ފެންސް",
        "demandFence": "ބޭނުންވުމުގެ ފެންސް",
        "fenceMeaning": "ޕްލޭނިން ފެންސަކީ އެމްއާރްޕީއަށް ހުށަހެޅުން އުފެއްދޭނެ ދުރުމިން. ބޭނުންވުމުގެ ފެންސަކީ، ރައްދުދޭން މާ ލަސްވެފައިވާތީ، އައު ބޭނުންވުމަކަށް ނުބަލާ ކައިރިމިން. ފެންސެއްގެ ތެރޭގައި ބޭނުންވުމެއް އޮތްނަމަ، ހުށަހެޅުމެއްގެ ބަދަލުގައި އެކްސެޕްޝަނެއް އުފެދޭ.",
        "source": "ސޯސް",
        "saved": "ޕްލޭނިން ޕެރެމިޓަރުތައް ރައްކާކޮށްފި",
        "saveFailed": "ޕްލޭނިން ޕެރެމިޓަރުތައް ރައްކާނުކުރެވުނު"
      },
      "mrp": {
        "title": "އެމްއާރްޕީ ރަން #{id}",
        "description": "ރަނުން ނުރޭވުނު އެއްޗެއް، އަދި އޭގެ ސަބަބު.",
        "loadFailed": "އެމްއާރްޕީ ރަން ލޯޑެއް ނުވި",
        "exceptionsFirstMeaning": "އެކްސެޕްޝަންތައް ހުށަހެޅުންތަކުގެ ކުރިއަށް. އެގާރަ އެކްސެޕްޝަން އޮތް ރަނެއްގެ ހުށަހެޅުންތައް އެގާރަ ތަނެއްގައި ގޯސްވާނެ، އަދި ހުށަހެޅުމުގެ ލިސްޓް މަތިން ތިރިއަށް މަސައްކަތްކުރުމުން އެކަން އެނގޭނީ އެގާރަވަނަ އޯޑަރުގައި.",
        "blockingTitle": "ރޭވޭގޮތެއް ނުވި",
        "blockingMeaning": "އަސާސީ ޑޭޓާ ރަނގަޅުކުރަންދެން މި ތަކެތި މުޅިންވެސް ނުރޭވޭނެ.",
        "blockingEmpty": "ނުރޭވޭ އެއްވެސް އެއްޗެއް ނެތް.",
        "advisoryTitle": "ރޭވިއްޖެ، އިންޒާރަކާއެކު",
        "advisoryMeaning": "މިއެއްޗެހި ރޭވި، އަދި ފާހަގަކުރެވުނު: ބޭނުންވުމުގެ ތާރީޚު ފާއިތުވެފައި، ނުވަތަ ފެންސެއްގެ ތެރޭގައި.",
        "advisoryEmpty": "އިންޒާރެއް ނެތް.",
        "kind": "އިސްތިސްނާ",
        "shortfall": "މަދުވި",
        "needBy": "ބޭނުންވާ ތާރީޚު",
        "earliest": "އެންމެ އަވަހަށް ވެދާނެ",
        "suggestions": "ހުށަހެޅުންތައް"
      },
      "pegging": {
        "title": "ޕެގިން",
        "description": "މި ހުށަހެޅުން އޮތް ސަބަބު.",
        "suggestionTitle": "ހުށަހެޅުން",
        "treeTitle": "ބޭނުންވުމުގެ ސިލްސިލާ",
        "loadFailed": "ޕެގިން ލޯޑެއް ނުވި",
        "empty": "މި ހުށަހެޅުން އެއްވެސް ބޭނުންވުމަކާ ނުގުޅޭ — މި އަންނަނީ އޯޑަރަކުން ނޫން، ސޭފްޓީ ސްޓޮކް ނުވަތަ އެންމެ ދަށް މިންވަރަކުން.",
        "suggestedQuantity": "ހުށަހެޅި",
        "netRequirement": "ސާފު ބޭނުންވުން",
        "releaseBy": "ދޫކުރަން ޖެހޭ",
        "level": "ދަރަޖަ {level}"
      },
      "settlement": {
        "title": "ސެޓްލްމަންޓް ޕްރިވިއު",
        "description": "މި އޯޑަރު ސެޓްލްވާނެ ގޮތާއި، އެކަން ހުއްޓުވާ ހުރިހާ ކަމެއް.",
        "loadFailed": "ސެޓްލްމަންޓް ޕްރިވިއު ލޯޑެއް ނުވި",
        "previewMeaning": "ޕްރިވިއުއަކުން ޖާނަލެއް ނުލިޔެވޭ. ޕޯސްޓްވަނީ އޯޑަރު ބަންދުކުރުމުން، އަދި ޕޯސްޓްވި ސެޓްލްމަންޓަކުން އޭގެ ކުރީގެ ހުރިހާ ޕްރިވިއުއެއް ބާޠިލުކުރޭ.",
        "backToOrder": "އޯޑަރަށް އެނބުރި",
        "blockersTitle": "ހުއްޓުވާ ކަންކަން",
        "blockersMeaning": "މި އޯޑަރު ބަންދު ނުކުރެވޭ ހުރިހާ ސަބަބެއް، އެއްފަހަރާ.",
        "noBlockers": "މި އޯޑަރު ބަންދުކުރުމަށް އެއްވެސް ހުރަހެއް ނެތް.",
        "quantitiesTitle": "އަދަދުތައް",
        "planned": "ރޭވިފައި",
        "completed": "ނިމިފައި",
        "scrapped": "ސްކްރެޕްކުރެވުނު",
        "wipBefore": "ވިޕް ބެލެންސް",
        "shortCloseMeaning": "މި އޯޑަރު ރޭވި މިންވަރަށްވުރެ {qty} މަދު. ބަންދުކުރުމަށް ބާކީ ދާނެ ތަނާމެދު ނިންމުމެއް ބޭނުންވޭ.",
        "variancesTitle": "ތަފާތުތައް",
        "variancesCaption": "މި ސެޓްލްމަންޓުން ޕޯސްޓްކުރާނެ ވެރިއަންސްތައް.",
        "varianceType": "ތަފާތު",
        "varianceMeaning": "ޔީލްޑާއި ބޭނުންކުރުމުން މިނެކިރެނީ ދެ ކަމެއް، އަދި އެއިން އެކަތި އަނެކަތީގައި ނުހިމެނޭ: ބޭނުންކުރުމަކީ ބޭނުންވި މާއްދާއާ އަޅާކިޔާ ބޭނުންކުރެވުނު މާއްދާ؛ ޔީލްޑަކީ ފެށި މިންވަރުން ލިބޭނެކަމަށް ބެލެވުނު އައުޓްޕުޓާ އަޅާކިޔާ އުފެއްދުނު އައުޓްޕުޓް.",
        "residual": "ބާކީ",
        "residualMeaning": "ވެރިއަންސްތަކުން ބަޔާންކުރާ ބައި ނެގުމަށްފަހު ހިނގަމުންދާ މަސައްކަތުން ބާކީވާ މިންވަރު. ހިސާބުކުރެވެނީ އެއާއެކު، އެއިން ނޫން.",
        "close": "އޯޑަރު ބަންދުކުރޭ",
        "closeMeaning": "ބަންދުކުރުމުން ޕޯސްޓްވޭ. މިއީ މި ޕްރިވިއު ހިސާބުކުރުމުގެ ބާރާ އެއް ބާރެއް ނޫން.",
        "historyTitle": "ސެޓްލްމަންޓްގެ ތާރީޚު",
        "historyCaption": "މި އޯޑަރުގެ ޕްރިވިއުތަކާއި ޕޯސްޓްކުރުންތައް.",
        "computedAt": "ހިސާބުކުރި",
        "disposition": "ޑިސްޕޮޒިޝަން"
      },
      "shortClose": {
        "title": "އޯޑަރު ބަންދުކުރޭ",
        "description": "ބާކީ ދާނެ ތަން.",
        "notShort": "މި އޯޑަރުން ރޭވި މިންވަރު ހެދިއްޖެ. ބަންދުކުރުމުން ވެރިއަންސްތައް ޕޯސްޓްވެ، ހިނގަމުންދާ މަސައްކަތް ސާފުވާނެ.",
        "shortMeaning": "ރޭވި މިންވަރަށްވުރެ {qty} މަދު.",
        "disposition": "ބާކީގެ ނިންމުން",
        "writeOffMeaning": "ބާކީ ބައި ދުވަހަކުވެސް ނުހެދޭނެ. ބާކީ ދާނީ އޯވަރހެޑް ވެރިއަންސް އެކައުންޓަށް، އަދި މި މުއްދަތުގައި ދެމިހުންނާނެ.",
        "reallocateMeaning": "ރަނގަޅު އައުޓްޕުޓުން ޙަޤީޤަތުގައި އަގު އުފުލި. ނިމުނު މުދާ ބަލައިގަތުން އަނބުރާލައި، ޙަޤީޤީ އަގުގައި އަލުން ޕޯސްޓްކުރެވޭ.",
        "carryMeaning": "ބާކީ ބައި ހިނގާނީ ފަހުގެ އޯޑަރެއްގައި، އަދި އަގުވެސް އެއާއެކު ދާނެ.",
        "carryToOrder": "ގެންދާނެ އޯޑަރު",
        "carryToOrderHint": "ބާކީ ބައި ހަދާނެ ފަހުގެ އޯޑަރު. އެއީ ބަންދުކުރެވިފައިވާ، ކެންސަލްކުރެވިފައިވާ، ނުވަތަ މި އޯޑަރަށް ވެގެން ނުވާނެ.",
        "reason": "މަދުވި ސަބަބު",
        "reasonHint": "ދާއިމަށް ބެހެއްޓޭ؛ އޮޑިޓަރު މިއާއި އޯވަރައިޑްގެ ސަބަބު ވަކިވަކިން ކިޔާނެ.",
        "overrideLabel": "ޝޯޓް-ކްލޯޒް ކޮންޓްރޯލް އޯވަރައިޑްކުރޭ",
        "overrideMeaning": "ތިޔަ ބޭފުޅާގެ ނަމާއެކު އޯވަރައިޑެއްގެ ގޮތުގައި ރެކޯޑްކުރެވޭ.",
        "confirm": "އޯޑަރު ބަންދުކުރޭ",
        "closed": "އޯޑަރު ބަންދުކުރެވިއްޖެ",
        "closeFailed": "އޯޑަރު ބަންދުނުކުރެވުނު",
        "overrideReason": "އޯވަރައިޑް ސަބަބު"
      },
      "rollup": {
        "title": "ސްޓޭންޑަޑް ކޮސްޓް ރޯލްއަޕްތައް",
        "description": "އަލުން ހިސާބުކުރެވުނު ސްޓޭންޑަޑްތައް، ބަދަލުވި މިންވަރުން ތަރުތީބުކުރެވިފައި.",
        "tableTitle": "ރޯލްއަޕްތައް",
        "caption": "ރޯލްއަޕް ޑްރާފްޓްތަކާއި އޭގެ ކުރީގެ އަދި އައު އަގު.",
        "loadFailed": "ރޯލްއަޕްތައް ލޯޑެއް ނުވި",
        "empty": "ރޯލްއަޕެއް ނެތް. އެއް ހިސާބުކުރުމުން ކޮންމެ އެއްޗަކަށް ޑްރާފްޓެއް އުފެދޭ؛ ޑްރާފްޓެއް ހިންގަންދެން އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވާނެ.",
        "scopeMeaning": "މުޅި ކުންފުންޏަށް ހިންގާ ރޯލްއަޕަކުން އެކްޓިވް ބިލެއް އޮތް ކޮންމެ އެއްޗެއް ހިސާބުކުރޭ، ދަރިން ފުރަތަމަ އަދި ބެލެނިވެރިން ފަހުން، އެހެންވެ ބެލެނިވެރިޔާ ކިޔަނީ ދަރިންގެ އައު ޑްރާފްޓް، ބާވެފައިވާ ސްޓޭންޑަޑެއް ނޫން.",
        "computeTitle": "ޑްރާފްޓް ހިސާބުކުރޭ",
        "basis": "ކޮމްޕޯނަންޓް އަސާސް",
        "basisMeaning": {
          "standard": "ކޮންމެ ކޮމްޕޯނަންޓެއްގެ އަމިއްލަ ސްޓޭންޑަޑް އަގު، ނުވަތަ މި ބެޗުން އޭގެ ޑްރާފްޓް",
          "moving_average": "ކޮންމެ ކޮމްޕޯނަންޓެއްގެ މޫވިން އެވަރެޖް؛ ސްޓޮކްގައި ނެތް އެއްޗަކުން ތެދުވެރި ސުމެއް ލިބޭ"
        },
        "effectiveDate": "ފެށޭ ތާރީޚު",
        "compute": "ހިސާބުކުރޭ",
        "computed": "ޑްރާފްޓްތައް ހިސާބުކޮށްފި",
        "computeFailed": "ރޯލްއަޕް ނުހިނގުނު",
        "select": "ޑްރާފްޓް ހޮވާ",
        "previousCost": "ކުރީގެ",
        "newCost": "އައު",
        "change": "ބަދަލު %",
        "material": "މާއްދާ",
        "labor": "މަސައްކަތު ވަގުތު",
        "overhead": "އޯވަހެޑް",
        "subcontract": "ސަބްކޮންޓްރެކްޓް",
        "byProductCredit": "ބައި-ޕްރޮޑަކްޓް ކްރެޑިޓް",
        "total": "ޖުމްލަ",
        "breakdown": "ތަފްޞީލު",
        "apply": "{count} ޑްރާފްޓް ހިންގާ",
        "applyMeaning": "ހިންގުމުން މިއީ ކުރިއަށް ހުރި ހުރިހާ ވެރިއަންސެއް މިނެކިރާ ސްޓޭންޑަޑް ކަމުގައި ވެގެންދާނެ. ސްޓޮކްގެ އަގު އަލުން ނުކިޔޭ، އަދި ދޫކޮށްފައިވާ އޯޑަރެއްގެ ސްޓޭންޑަޑަށް އަތެއް ނުލެވޭ.",
        "applied": "ޑްރާފްޓްތައް ހިންގައިފި",
        "applyFailed": "ޑްރާފްޓްތައް ނުހިންގުނު",
        "detailTitle": "{item} ގެ ރޯލްއަޕް",
        "detailDescription": "ހިނގާ ތާރީޚު {date}",
        "summaryTitle": "ޚުލާޞާ",
        "yield": "ޔީލްޑް %",
        "yieldMeaning": "ޖުމުލަ ބަހަނީ ޔީލްޑުން، އެހެންވެ ޕްރޮސެސްގައި 5% ގެއްލޭ ބިލެއްގައި އެ ގެއްލުން ހިމެނެނީ ކޮންމެ އޯޑަރެއްގެ ވެރިއަންސްގައި ނޫން، ސްޓޭންޑަޑްގައި.",
        "levels": "ބަލާލެވުނު ދަރަޖަތައް",
        "linesTitle": "ބައިތައް",
        "linesCaption": "ކޮންމެ ކޮމްޕޯނަންޓެއްގެ މިންވަރު، ޔުނިޓް އަގު އަދި އެ އަގު އައި ތަން.",
        "linesEmpty": "މި ރޯލްއަޕުގައި ކޮމްޕޯނަންޓް ލައިނެއް ނެތް.",
        "seq": "ނޫން",
        "element": "އެލެމަންޓް",
        "quantityPer": "ކޮންމެއަކަށް މިންވަރު",
        "unitCost": "ޔުނިޓް އަގު",
        "extendedCost": "ޖުމުލަ އަގު",
        "source": "އަގުގެ މަޞްދަރު",
        "level": "ލެވެލް",
        "noRevalueMeaning": "ރޯލްއަޕަކުން ސްޓޮކްގެ އަގު އަލުން ނުކިޔޭ، އަދި ދޫކޮށްފައިވާ އޯޑަރެއްގެ ސްޓޭންޑަޑް ބަދަލެއް ނުކުރެވޭ. ހިނގަމުންދާ އެއްޗެއް އަދިވެސް މިނެކިރެނީ ދޫކުރިއިރުގެ އަގުން.",
        "backToBoard": "ރޯލްއަޕް ބޯޑަށް އެނބުރި"
      },
      "variance": {
        "title": "ވެރިއަންސް ދިރާސާ",
        "description": "އުފެއްދުމުގެ އަގު ސްޓޭންޑަޑާ ތަފާތުވި ތަންތަން، ބާވަތުން.",
        "tableTitle": "ވެރިއަންސް ބާވަތުން",
        "caption": "ބާވަތުން ވެރިއަންސްގެ ޖުމުލަތަކާއި އޭގެ ޕޯސްޓްކުރާ އެކައުންޓް.",
        "loadFailed": "ވެރިއަންސް ދިރާސާ ލޯޑެއް ނުވި",
        "empty": "މި މުއްދަތުގައި ވެރިއަންސެއް ނެތް.",
        "typesMeaning": "ބާ `overhead` ބާވަތް އަދިވެސް މިތާ އެބައޮތް: ސީ7 ގެ ކުރީގެ ކޮންމެ އޯޑަރެއްގެ ބާކީ ދާއިމަށް ލިޔެވުނީ އޯވަރހެޑްގެ ގޮތުގައި، އަދި އެ ނަގާލައިފިނަމަ ކުންފުނީގެ ތާރީޚު ހުރި މިންވަރަށްވުރެ ކުޑަކޮށް ދައްކާނެ.",
        "orderCount": "އޯޑަރުތައް",
        "total": "ޖުމްލަ",
        "account": "އެކައުންޓް",
        "posted": "ޕޯސްޓްކުރެވިފައި"
      },
      "lotRelation": {
        "repack": "އަލުން ބަންދުކުރުން",
        "split": "ބައިކުރުން",
        "merge": "އެއްކުރުން",
        "transform": "ބަދަލުކުރުން",
        "production": "އުފެއްދުން",
        "rework": "އަލުން މަސައްކަތްކުރުން"
      }
    }
  },
  "attention": {
    "title": "ތިޔަ ސަމާލުކަން ބޭނުންވާ ކަންކަން",
    "description": "ތިޔަބޭފުޅާއަށް ހަވާލުކުރެވިފައިވާ ފާސްކުރުންތައް، އިސްތިސްނާތައް، މަސައްކަތްތައް އަދި އިންޒާރުތައް — މުހިންމުކަމުގެ ތަރުތީބުން.",
    "loadFailed": "ސަމާލުކަން ބޭނުންވާ ލިސްޓް ލޯޑެއް ނުވި",
    "emptyTitle": "ސަމާލުކަން ބޭނުންވާ އެއްވެސް ކަމެއް ނެތް",
    "emptyDescription": "ފާސްކުރުންތައް އަދިވެސް އިންބޮކްސްއަށް އާދެއެވެ، އަދި ނޯޓިފިކޭޝަންތައް ބެލްއަށް ލިބެއެވެ — މި ލިސްޓަކީ އެ ދެ ތަނުގެ ވިއު އެކެވެ، ވުމާއެކު ހުސްވުމުން މާނައަކީ އިންތިޒާރުގައި އެއްޗެއް ނެތުމެވެ.",
    "filteredEmptyTitle": "މި ފިލްޓަރުތަކާ ދިމާވާ އެއްޗެއް ނެތް",
    "filteredEmptyDescription": "ތިޔަބޭފުޅާއަށް ހަވާލުކުރެވިފައިވާ ހުރިހާ އެއްޗެއް ބެލުމަށް ފިލްޓަރުތައް ސާފުކުރައްވާ.",
    "routeTitles": {
      "list": "ސަމާލުކަން",
      "policies": "ނޯޓިފިކޭޝަން ސިޔާސަތުތައް"
    },
    "kinds": {
      "approval": "ފާސްކުރުން",
      "exception": "އިސްތިސްނާ",
      "task": "މަސައްކަތް",
      "alert": "އިންޒާރު"
    },
    "filters": {
      "kind": "ބާވަތް",
      "module": "މޮޑިއުލް",
      "overdueOnly": "މުއްދަތު ފާއިތުވީ އެކަނި",
      "total": "{count} ހުޅުވިފައި",
      "overdue": "{count} މުއްދަތު ފާއިތުވެފައި",
      "severity": "ސީރިއަސްކަން"
    },
    "item": {
      "untitled": "ނަމެއް ނެތް ކަމެއް",
      "age": "{days} ދުވަސް ކުރިން ހުޅުވިފައި",
      "overdue": "{hours} ގަޑިއިރު ފާއިތުވެފައި",
      "escalated": "މައްޗަށް ފޮނުވިފައި",
      "priorityHelp": "ސާވަރުން ނެރޭ ދަރަޖަ. ކުޑަވުމުން މާ އަވަހަށް ބޭނުންވެއެވެ.",
      "acknowledge": "ބަލައިގަންނަވާ",
      "acknowledged": "ބަލައިގަނެފައި",
      "acknowledgedToast": "އިންޒާރު ބަލައިގަނެވުނު",
      "acknowledgeFailed": "އިންޒާރު ބަލައިގަނެވޭނެ ނުވި",
      "resolve": "ހައްލުކުރޭ",
      "resolved": "ހައްލުކުރެވިއްޖެ",
      "resolveTitle": "މި ކަން ހައްލުކުރޭ",
      "resolveDescription": "ތިޔަބޭފުޅާގެ ލިސްޓުން ނައްޓާލެވޭނެއެވެ. އަސްލު ރެކޯޑަށް ބަދަލެއް ނާދެއެވެ. ކޯޑާއި ނަތީޖާ ރެކޯޑްކުރެވެއެވެ.",
      "resolveCode": "ހައްލު",
      "resolveCodePlaceholder": "ހައްލުކުރެވުނު ގޮތް ޚިޔާރުކުރައްވާ",
      "resolveOutcome": "ނަތީޖާ",
      "resolveOutcomeRequired": "ބޭނުންވެއެވެ: ކުރެވުނު ކަމެއް، ނުވަތަ ފިޔަވަޅެއް ނުބޭނުންވި ސަބަބު ލިޔުއްވާ.",
      "resolveOutcomeOptional": "ފޮރުވާލުމަށް އިޚްތިޔާރީ، އަދި ރެކޯޑްކުރެވެއެވެ.",
      "recommendedAction": "ހުށަހަޅާ ފިޔަވަޅު"
    },
    "policy": {
      "title": "ނޯޓިފިކޭޝަން ސިޔާސަތުތައް",
      "description": "ކޮންމެ ބާވަތެއްގެ ހާދިސާއަކަށް ބޭނުންކުރާ ޗެނަލް، ކިހާ ގިނައިން، އަދި ހަނުހުރުން މައްޗަށް ފޮނުވުމަކަށް ބަދަލުވާ ވަގުތު.",
      "explain": "ހާދިސާގެ ބާވަތަކީ ސޮފްޓްވެއަރ ޝާއިޢުކުރާ އައުޓްބޮކްސް ޓޮޕިކެވެ. އެއްވެސް އެއްޗެއް ޝާއިޢުނުކުރާ ޓޮޕިކަކަށް ހަދާ ސިޔާސަތެއް މަސައްކަތެއް ނުކުރާނެއެވެ — ގޯހެއް ނުދައްކާނެ، އެކަމަކު ދުވަހަކުވެސް ބޭނުމެއް ނުކުރެވޭނެއެވެ.",
      "eventKind": "ހާދިސާގެ ބާވަތް",
      "eventKindHint": "އައުޓްބޮކްސް ޓޮޕިކެއް، ނުވަތަ އެހެން ހުރިހާ އެއްޗަކަށް ބޭނުންވާ ޑިފޯލްޓަށް *.",
      "default": "ޑިފޯލްޓް (*)",
      "channels": "ޗެނަލްތައް",
      "channelsHint": "މަދުވެގެން އެކެއް. އިން-އެޕުން ސަމާލުކަމުގެ ލިސްޓަށް ލިޔެއެވެ؛ އީމެއިލުން ފޮނުވައެވެ.",
      "channelNames": {
        "inapp": "އެޕް ތެރޭގައި",
        "email": "އީމެއިލް"
      },
      "digest": "ފޮނުވާ ގޮތް",
      "digestHint": "މިހާރު ފިޔަވަޅު އަޅަންޖެހޭ ކަންކަމަށް ވަގުތުން؛ ބާކީ ކަންކަން އެއްކޮށްލައިގެން.",
      "digests": {
        "immediate": "ވަގުތުން",
        "hourly": "ކޮންމެ ގަޑިއިރަކުން",
        "daily": "ދުވާލަކު އެއްފަހަރު"
      },
      "digestHints": {
        "immediate": "ހިނގާއިރު ފޮނުވެއެވެ.",
        "hourly": "އެއްކޮށްލައި ގަޑިއިރަކުން އެއްފަހަރު ފޮނުވެއެވެ.",
        "daily": "އެއްކޮށްލައި ދުވާލަކު އެއްފަހަރު ފޮނުވެއެވެ."
      },
      "escalate": "މައްޗަށް ފޮނުވާ މުއްދަތު",
      "escalateHint": "ބަލާލާ މީހަކު އިތުރުކުރުމުގެ ކުރިން ހަނުހުންނަ ގަޑިއިރު. 0 ވުމުން ދުވަހަކުވެސް ނުފޮނުވާނެއެވެ.",
      "afterHours": "{hours} ގަޑިއިރު",
      "never": "ދުވަހަކުވެސް ނޫން",
      "suppress": "ތަކުރާރުވުން ހުއްޓުވާ",
      "suppressHint": "އެއް ކަމެއް ދެވަނަ ފަހަރު ނާންގާ ހުންނަ މިނެޓް. 0 ވުމުން ކޮންމެ ފަހަރަކުވެސް އަންގައެވެ.",
      "forMinutes": "{minutes} މިނެޓް",
      "noSuppression": "ނެތް",
      "isActive": "ހަރަކާތްތެރި",
      "create": "އައު ސިޔާސަތެއް",
      "editTitle": "ނޯޓިފިކޭޝަން ސިޔާސަތު",
      "editDescription": "މި ބާވަތުގެ ހާދިސާ ލިބޭ ޓެނަންޓްގެ ކޮންމެ މީހަކަށްވެސް ބޭނުންކުރެވެއެވެ.",
      "saved": "ސިޔާސަތު ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ސިޔާސަތު ރައްކާއެއް ނުކުރެވުނު",
      "tableLabel": "ނޯޓިފިކޭޝަން ސިޔާސަތުތައް",
      "emptyTitle": "އެއްވެސް ސިޔާސަތެއް ކަނޑައަޅާފައެއް ނެތް",
      "emptyDescription": "ސިޔާސަތެއް ނެތި ކޮންމެ ހާދިސާއެއްވެސް ދެ ޗެނަލަށް ވަގުތުން ފޮނުވެއެވެ. އެ ބަދަލުކުރުމަށް ޑިފޯލްޓް (*) އެއް އިތުރުކުރައްވާ.",
      "loadFailed": "ނޯޓިފިކޭޝަން ސިޔާސަތުތައް ލޯޑެއް ނުވި"
    },
    "budget": {
      "thresholdBreached": "{costCenterCode} {costCenterName} އިން {fiscalYear} ބަޖެޓުގެ {consumptionPct}% ބޭނުންކޮށްފިއެވެ (އިންޒާރު {thresholdPct}% ގައެވެ). އެކަށީގެންވާ އިތުރު ޚަރަދު {projectedOverspend}، ބާކީ މަސް {monthsRemaining}"
    },
    "sales": {
      "subscriptionOverdue": "ސަބްސްކްރިޕްޝަން {subscriptionNo} ގެ ބިލް {nextBillingDate} ގައި ހަދަން ޖެހުނު ނަމަވެސް ބިލް ނުހެދެއެވެ"
    },
    "projects": {
      "chargeabilityOverrideDue": "ޕްރޮޖެކްޓް {projectCode} — {projectName} ގެ ޗާޖަބިލިޓީ އޯވަރައިޑް {validTo} ގައި ހަމަވެއެވެ"
    },
    "severity": {
      "info": "މައުލޫމާތު",
      "warning": "އިންޒާރު",
      "critical": "ކްރިޓިކަލް"
    },
    "resolution": {
      "action_taken": "ފިޔަވަޅު އެޅުނު",
      "false_positive": "ބޭނުމެއް ނެތް އިންޒާރެއް",
      "no_action_needed": "ފިޔަވަޅެއް ނުބޭނުން",
      "duplicate": "ޑުޕްލިކޭޓް",
      "dismissed": "ފޮރުވާލެވުނު"
    },
    "treasury": {
      "liquidityBreach": {
        "title": "{positionDate} ގައި {companyCode} ގެ ލިކުއިޑިޓީ ދަށްވެއްޖެ",
        "explanation": "ލިބެންހުރި ލިކުއިޑިޓީ {availableLiquidity} {currency} (ނެޓް ކޭޝް {netCash}، ކެނޑޭ ޢަދަދު {totalDeductions})، މި ލީގަލް އެންޓިޓީއަށް ކަނޑައެޅިފައިވާ ހައްދަށް ވުރެ ދަށެވެ.",
        "action": "ޕޮޒިޝަން ބަލައި، ފަންޑިންގ ހަމަޖައްސަވާ ނުވަތަ ދައްކާ ޢަދަދު ފަހުރުވާ."
      },
      "shortfallPredicted": {
        "title": "{firstBreachOn} ގައި {currency} ކޭޝް ކުޑަވާނެކަން ލަފާކުރެވިފައި",
        "explanation": "ފޯކާސްޓުން ދައްކަނީ ކަނޑައެޅިފައިވާ މިނިމަމް {declaredMinimum} އަށް {leadDays} ދުވަސްތެރޭގައި {firstBreachShortfall} {currency} މަދުވާނެކަމެވެ. އެންމެ ބޮޑު ކުޑަވުން {deepestShortfall}؛ ފަންޑިންގ ފިޔަވަޅު {actionCount} އަށްފަހު {residualShortfall} ބާކީވެއެވެ.",
        "action": "ފޯކާސްޓު ހުޅުވާ، ފުރަތަމަ ކުޑަވާ ދުވަހުގެ ކުރިން ހުށަހަޅާފައިވާ ފަންޑިންގ ފިޔަވަޅުތައް ފާސްކުރައްވާ."
      },
      "reconException": {
        "title": "ރިކަންސިލިއޭޝަން އެކްސެޕްޝަން {exceptionNo}: {amount} {currency}",
        "explanation": "{itemDate} ގެ {kind} އައިޓަމެއް {ageDays} ދުވަހު ހައްލުނުކޮށް ހުޅުވިފައިވެއެވެ (އެސްކަލޭޝަން ލެވެލް {escalationLevel}).",
        "action": "ރިކަންސިލިއޭޝަން ސެޝަންގައި އެ އައިޓަމް މެޗްކުރައްވާ، ނުވަތަ ރައްދުވެވަޑައިގަންނަވާ."
      },
      "fundsInTransitAged": {
        "title": "ދަތުރުކުރަމުންދާ ފައިސާ {reference} ދިގުދުވަސްވެއްޖެ",
        "explanation": "{amount} {currency} އަކީ {ageDays} ދުވަހު ކަށަވަރުނުކޮށް ދަތުރުކުރަމުންދާ ފައިސާއެކެވެ.",
        "action": "ބޭންކާއެކު ލިބުނުކަން ކަށަވަރުކޮށް، ދެން އިންސްޓްރަކްޝަން ކަށަވަރުކުރައްވާ ނުވަތަ ފަހަތަށް ގެނެސްދެއްވާ."
      },
      "walletIdle": {
        "title": "ވޮލެޓް {walletCode} ގައި ބޭނުންނުކުރާ ފައިސާ ހުރެއެވެ",
        "explanation": "{floatBalance} {currency} އަކީ {idleDays} ދުވަސް ބޭނުންނުކުރެވި ހުރި ފައިސާއެވެ ({inactivityPeriodDays} ދުވަހުގެ މުއްދަތަށް ވުރެ ގިނަ)؛ ޢަމަލީ މިނިމަމަށްވުރެ މަތީގައި {recoverable} {currency} ގެނެވޭނެއެވެ.",
        "action": "ބާކީ ފައިސާ ކޭޝް ބުކަށް ރުޖޫޢަކުރައްވާ، ނުވަތަ ވޮލެޓް އަދިވެސް ބޭނުންކަން ކަށަވަރުކުރައްވާ."
      },
      "statementGap": {
        "title": "ބޭންކު ސްޓޭޓްމަންޓުގެ ހުސްތަނެއް ({kind})",
        "explanation": "މި ބޭންކު އެކައުންޓަށް {fromDate} އިން {toDate} އަށް ސްޓޭޓްމަންޓެއް ނެތެވެ. {detail}",
        "action": "ރިކަންސިލިއޭޝަން ކުރިއަށްގެންދިއުމަށް ނެތް ސްޓޭޓްމަންޓް ގެނެސް ނުވަތަ އިމްޕޯޓްކުރައްވާ."
      },
      "covenantBreach": {
        "title": "ފެސިލިޓީ {facilityCode} ގައި ކޮވެނަންޓް {covenantCode} ގަވާއިދުހުރަސްވެއްޖެ",
        "explanation": "{covenantName}: {testDate} ގައި {metricKey} އަކީ {actualValue} އެވެ، ބޭނުންވަނީ {operator} {threshold} އެވެ. ފެސިލިޓީ ޑިފޯލްޓްވެދާނެއެވެ.",
        "action": "ސީއެފްއޯއަށް އެސްކަލޭޓްކޮށް، ވެއިވަރެއް ނުވަތަ ހައްލެއްގެ ބަހުސްކުރަން ލޭންޑަރާ ގުޅުއްވާ."
      },
      "connectionFailed": {
        "title": "ބޭންކު ކަނެކްޝަން {name} ފެއިލްވެއްޖެ",
        "explanation": "{channel} ކަނެކްޝަން {source} ކުރަމުންދަނިކޮށް ދިގުކޮށް {consecutiveFailures} ފަހަރު ފެއިލްވެއްޖެ: {detail}",
        "action": "ކްރެޑެންޝަލްސް އަދި ބޭންކުގެ ލިބެންހުރިކަން ބަލާ، ދެން ކަނެކްޝަން އަލުން ޓެސްޓްކުރައްވާ."
      },
      "officerRoleDrift": {
        "title": "ޓްރެޒަރީ އޮފިސަރ ރޯލް {userCount} ބޭފުޅެއްގެ ކިބައިގައި އަދިވެސް މެއިންޓެނަންސް ހުއްދަތައް އޮވެއެވެ",
        "explanation": "ޓްރެޒަރީ އޮފިސަރ ރޯލް ލިބިފައިވާ ބޭފުޅުން ({users}) އަދިވެސް ފައިސާ ދާނެ ތަންތަން ބަދަލުކޮށް ފައިސާ ފޮނުވޭނެއެވެ. ކުރީގެ ހުއްދަތައް: {staleCodes}.",
        "action": "ޓްރެޒަރީ ރޯލް ބަހާލުން (erpxctl treasury split-roles --apply) ހިންގާ، ނުވަތަ މި ބޭފުޅުން ޓްރެޒަރީ މެނޭޖަރ ރޯލަށް ބަދަލުކުރައްވާ."
      },
      "connectionFailurePredicted": {
        "title": "{name} އިން ސްޓޭޓްމަންޓް ލިބެން ލަސްވުމުގެ ހާލު ޚަބަރު",
        "explanation": "{name} އަށް ފަހުން ސްޓޭޓްމަންޓް ލިބުނީ {lastArrivalOn} ގައި ({daysSinceLastArrival} ދުވަސް ކުރިން)؛ {expectedBy} ގެ ކުރިން ލިބެންޖެހޭ ހުއްޓެވެ. {basis}",
        "action": "ކަނެކްޝަން ބަލައި، އަދި ސްޓޭޓްމަންޓް ފޮނުވާފައިވޭތޯ ބޭންކުން ސުވާލުކުރައްވާ."
      },
      "movementAnomaly": {
        "title": "{bankAccount} ގައި އާދަޔާ ޚިލާފު ބޭންކް މޫވްމަންޓެއް",
        "explanation": "{movementDate} ގައި {amount} {currency} ގެ މޫވްމަންޓެއް އާދަޔާ ޚިލާފެވެ: {comparison}. މިއީ ސުވާލެއް، ކުށެއް ސާބިތުކުރުމެއް ނޫން.",
        "action": "މޫވްމަންޓް ބަލައި، ސަބަބު ބަޔާންކޮށްފައިވޭތޯ ނުވަތަ ގޯސް އިންޒާރެއްތޯ ރެކޯޑްކުރައްވާ. އެ ރެކޯޑްކުރި ފަރާތަށް އެ ކަމެއް ނުކުރެވޭނެ."
      }
    },
    "approvals": {
      "taskAssigned": "{docType} {docNo} ތިޔަބޭފުޅާގެ އެޕްރޫވަލަށް މަޑުކުރަނީ"
    },
    "rules": {
      "queueItemOpened": "{subjectType} {subjectNo} ކިއު {queueCode} ގައި ހުށަހަޅާފައިވޭ",
      "overrideRecorded": "{docNo} ގައި ކޮންޓްރޯލް {ruleCode} އޯވަރރައިޑްކޮށްފިއެވެ ({reasonCode})"
    },
    "notifications": {
      "mirrored": "{title}"
    },
    "pos": {
      "sessionStale": "ޕީއޯއެސް ސެޝަން {sessionNo} ކުރިއަށްދާނީ ޝިފްޓްގެ ދިގުމަށްވުރެ ދިގުކޮށެވެ",
      "depositAgeing": "ޑިޕޮޒިޓް {depositNo} ބޭންކުކޮށްފައިވީ ނަމަވެސް އައުޓްލެޓްގެ ހުއްދަ މުއްދަތުގެ ފަހުންވެސް ހަމަނުޖެހެއެވެ"
    },
    "procurement": {
      "contractExpired": "{vendorCode} އާއެކު ކޮންޓްރެކްޓް {contractNo} {endsOn} ގައި ހަމަވެއްޖެ",
      "contractExpiring": "{vendorCode} އާއެކު ކޮންޓްރެކްޓް {contractNo} {endsOn} ގައި ހަމަވާނެ",
      "contractRenewed": "{vendorCode} އާއެކު ކޮންޓްރެކްޓް {contractNo} {termMonths} މަސްދުވަހަށް، {endsOn} އަށް އާކުރެވިއްޖެ",
      "rebatePeriodClosed": "ކޮންޓްރެކްޓް {contractNo} ގެ ރިބޭޓް {rebate} އެކްރޫ ނުކުރެވުނު: މުއްދަތު ބަންދުކޮށްފައި ({asOf})",
      "documentExpired": "{vendorCode} ގެ {documentType} {expiresOn} ގައި ހަމަވެއްޖެ",
      "documentExpiring": "{vendorCode} ގެ {documentType} {expiresOn} ގައި ހަމަވާނެ",
      "screeningStale": "ސަޕްލައިޔަރ {vendorCode} ގެ ސްކްރީނިންގ ކުރިން ކުރެވިފައި ނުވެއެވެ",
      "screeningReviewOverdue": "ސަޕްލައިޔަރ {vendorCode} ގެ ސްކްރީނިންގ މެޗެއް ރިވިއުކުރުމަށް ދިގު މުއްދަތަކަށް މަޑުކުރަނީ",
      "matchExceptionOverdue": "މެޗް އެކްސެޕްޝަން ({causeCode}) ގެ ސްޓޭޓަސް {dueAt} ގައި ހަމަވާންޖެހުނު، މިހާރު ލަސްވެއްޖެ"
    }
  },
  "authority": {
    "nav": {
      "label": "ބާރުގެ ބައިތައް",
      "matrix": "މެޓްރިކްސް",
      "delegations": "ހަވާލުކުރުންތައް",
      "absences": "ޙާޟިރުނުވުންތައް",
      "materiality": "މުހިންމުކަން"
    },
    "routeTitles": {
      "matrix": "ބާރުގެ މެޓްރިކްސް",
      "version": "މެޓްރިކްސް ވަރޜަން",
      "delegations": "ހަވާލުކުރުންތައް",
      "absences": "ޙާޟިރުނުވުންތައް",
      "materiality": "މުހިންމުކަމުގެ ޙައްދުތައް"
    },
    "modes": {
      "sequential": "ތަރުތީބުން",
      "parallel_any": "އެއްވެސް އެކަކު"
    },
    "modeHints": {
      "sequential": "ކޮންމެ މީހަކުވެސް ބަރީގައި؛ ކުރީގެ މީހާ ސޮއިކުރުމުން އަނެކާއަށް އަންގައެވެ.",
      "parallel_any": "އެންމެންނަށް އެއްފަހަރާ އަންގައެވެ؛ ފުރަތަމަ ސޮއިކުރާ މީހާ އެ ފިޔަވަޅު ފުރިހަމަކުރެއެވެ."
    },
    "sources": {
      "position": "ނަން ދެވިފައިވާ މަޤާމެއް",
      "job": "މަސައްކަތުގެ އެއްވެސް މަޤާމެއް",
      "grade": "ދަރަޖައަކުން މަތީގެ އެއްވެސް މަޤާމެއް",
      "relative": "ރިޕޯޓިންގ ލައިން ހިނގާ",
      "role": "ރޯލެއް",
      "user": "ނަން ދެވިފައިވާ ބޭނުންކުރާ މީހެއް"
    },
    "sourceHints": {
      "position": "އެއް މަޤާމު. އެންމެ ރައްކާތެރި، އަދި އެންމެ ހަރުކަށި.",
      "job": "ރޫލްގެ ސްކޯޕް ތެރޭގައި މި މަސައްކަތް ކުރާ އެއްވެސް މަޤާމެއް.",
      "grade": "ރޫލްގެ ސްކޯޕް ތެރޭގައި މި ދަރަޖަ ނުވަތަ އެއަށްވުރެ މަތީ އެއްވެސް މަޤާމެއް.",
      "relative": "ހުށަހެޅި މީހާގެ ނުވަތަ ލިޔުން ނެގި މަޤާމުގެ މަތިން ހިނގައިގެން ނެރެއެވެ.",
      "role": "މެޓްރިކްސް ރޫލެއްގައި ނުހިމެނެއެވެ — ރޯލްތައް ދެމިއޮންނަނީ ފާސްކުރުމުގެ ސިޔާސަތުތަކުގައެވެ.",
      "user": "މެޓްރިކްސް ރޫލެއްގައި ނުހިމެނެއެވެ — ނަން ދެވިފައިވާ މީހަކު ބާވެއެވެ."
    },
    "relative": {
      "submitter_manager": "ހުށަހެޅި މީހާގެ މެނޭޖަރު",
      "position_parent": "ލިޔުން ނެގި މަޤާމުގެ މަތީ މަޤާމު"
    },
    "scopes": {
      "global": "ހުރިހާ ތަނެއްގައި",
      "company": "ކުންފުނި",
      "branch": "ބްރާންޗް",
      "department": "ޑިޕާޓްމަންޓް",
      "cost_center": "ކޮސްޓް ސެންޓަރު",
      "business_unit": "ބިޒްނަސް ޔުނިޓް",
      "division": "ޑިވިޜަން",
      "location": "ތަން"
    },
    "validation": {
      "title": "ބެލުން",
      "kinds": {
        "gap": "ފަޅުކަން",
        "overlap": "ފުށުއެރުން",
        "unreachable": "ނުފޯރާ ރޫލް",
        "vacant_position": "ހުސް މަޤާމު",
        "cycle": "ސައިކަލެއް",
        "no_steps": "ފިޔަވަޅެއް ނެތް",
        "invalid_step": "ސައްޙަނޫން ފިޔަވަޅު",
        "unresolvable": "ނުނެރެވޭ"
      }
    },
    "version": {
      "title": "ބާރުގެ މެޓްރިކްސް",
      "description": "ކާކު ކޮން އެއްޗެއް، ކޮން އަގެއްގެ ބޭންޑެއްގައި، ޖަމާޢަތުގެ ކޮން ބައެއްގައި ފާސްކުރެވިދާނެކަން — ވަރޜަންކުރެވިފައި، ސަބަބަކީ މިދިޔަ މާރޗްގައި ފާސްކުރެވުނު ލިޔުމެއް ފާސްވީ އޭރުގެ ޤަވާޢިދުތަކުގެ ދަށުންނެވެ.",
      "detailDescription": "ރޫލްތައް، އެ ރޫލްތަކުގެ ސިލްސިލާ، އަދި އެ ރޫލްތަކުން ޙަޤީޤަތުގައި ވާނެ ގޮތް.",
      "code": "ވަރޜަން",
      "name": "ނަން",
      "rules": "ރޫލްތައް",
      "ruleCount": "{count} ރޫލް",
      "inForce": "ބާރުގައި",
      "inForceFrom": "{date} އިން ފެށިގެން ބާރުގައި",
      "notInForce": "ބާރުގައެއް ނޫން",
      "dualControl": "ދެ މީހުންގެ ކޮންޓްރޯލް",
      "submittedBy": "#{id} ހުށަހަޅާފައި",
      "activatedBy": "#{id} ބާރުގައި ހިންގާފައި",
      "notSubmitted": "އަދި ހުށަހަޅާފައެއް ނުވޭ",
      "create": "އައު ވަރޜަނެއް",
      "createTitle": "އައު މެޓްރިކްސް ވަރޜަން",
      "createDescription": "ހުހަށް ފައްޓަވާ، ނުވަތަ މިހާރު ހުރި ވަރޜަނެއް ކޮޕީކޮށް ބަދަލުވި ތަންކޮޅު ބަދަލުކުރައްވާ.",
      "cloneFrom": "ކޮޕީކުރާ ވަރޜަން",
      "cloneHint": "އަންނަ އަހަރުގެ މެޓްރިކްސް އަކީ ޢާންމުކޮށް މި އަހަރުގެ މެޓްރިކްސް، ތިން ބޭންޑް ބަދަލުވެފައެވެ.",
      "startEmpty": "ހުހަށް ފައްޓާ",
      "created": "ވަރޜަން އުފެދިއްޖެ",
      "createFailed": "ވަރޜަން އުފެއްދޭ ގޮތެއް ނުވި",
      "submit": "ހުށަހަޅާ",
      "submitTitle": "މި ވަރޜަން ހުށަހަޅާ",
      "submitDescription": "ހުށަހެޅުމުން މި ރޫލްތައް ލިޔުނު މީހާ ރެކޯޑްވެ، ބާރުގައި ހިންގުމަށް އެހެން މީހަކު ބޭނުންވެއެވެ.",
      "submitExplain": "މި ވަރޜަން ތިޔަބޭފުޅާއަށް އަމިއްލައަށް ބާރުގައި ނުހިންގޭނެއެވެ — މިތާނގައި ދެ މީހުންގެ ކޮންޓްރޯލްގެ މާނައަކީ އެއީއެވެ.",
      "submitFirst": "ބާރުގައި ހިންގުމުގެ ކުރިން ވަރޜަން ހުށަހަޅުއްވާ. ދެ މީހުންގެ ކޮންޓްރޯލަށް ހުށަހަޅާ މީހަކާއި އެހެން ހިންގާ މީހަކު ބޭނުންވެއެވެ.",
      "submitted": "ވަރޜަން ހުށަހެޅިއްޖެ",
      "submitFailed": "ވަރޜަން ހުށަހެޅޭ ގޮތެއް ނުވި",
      "activate": "ބާރުގައި ހިންގާ",
      "activateTitle": "މި ވަރޜަން ބާރުގައި ހިންގާ",
      "activateDescription": "ތިޔަ ދެއްވާ ތާރީޚުން ފެށިގެން ހުށަހެޅޭ ކޮންމެ ލިޔުމެއްގެ ފާސްކުރާ މީހުން ނެރެވެނީ މި ރޫލްތަކުންނެވެ.",
      "activateConsequence": "މިއިން މުޅި ޓެނަންޓްގައި ކާކު ކޮން އެއްޗެއް ފާސްކުރެވިދާނެކަން ބަދަލުވެއެވެ. މިހާރު ބާރުގައި އޮތް ވަރޜަން ބަދަލުވެ، އަލުން އެޑިޓެއް ނުކުރެވޭނެއެވެ.",
      "activateWithErrors": "{count} ބެލުމުގެ ގޯސް ބާކީ އެބައޮތެވެ. ހުސް މަޤާމެއް ނުވަތަ ނުފޯރާ ރޫލެއްގެ މައްޗަށް ބާރުގައި ހިންގުމަކީ އެއްވެސް މީހަކު ނުބަލާ ކިޔޫއަކަށް ފާސްކުރުމެއް ވެއްޓޭ ގޮތެވެ.",
      "effectiveFrom": "ބާރުގައި ފެށޭ",
      "activated": "ވަރޜަން ބާރުގައި ހިނގައްޖެ",
      "activateFailed": "ވަރޜަން ބާރުގައި ނުހިންގުނު",
      "dualControlBlocked": "މި ވަރޜަން ހުށަހެޅީ ތިޔަބޭފުޅާ ކަމުން، ތިޔަބޭފުޅާއަށް މި ބާރުގައި ނުހިންގޭނެއެވެ. އެ ހުއްދަ އޮތް އެހެން މީހަކު ހިންގަންޖެހެއެވެ.",
      "backToList": "ހުރިހާ ވަރޜަނެއް",
      "tableLabel": "މެޓްރިކްސް ވަރޜަންތައް",
      "emptyTitle": "މެޓްރިކްސް ވަރޜަނެއް ނެތް",
      "emptyDescription": "މިހާރު ފާސްކުރުންތައް ދަނީ ފާސްކުރުމުގެ ސިޔާސަތުތަކުންނެވެ، އަދި އެ ސިޔާސަތުތައް ދެމިހުންނާނެއެވެ. ބޭންޑް، ސްކޯޕް އަދި މަޤާމުތައް ބޭނުންވާނަމަ ވަރޜަނެއް އުފައްދަވާ.",
      "loadFailed": "މެޓްރިކްސް ލޯޑެއް ނުވި",
      "statuses": {
        "draft": "ދެލި ކޮޕީ",
        "active": "ބާރުގައި",
        "superseded": "ބަދަލުވެފައި"
      }
    },
    "rule": {
      "title": "ރޫލްތައް",
      "description": "ތަރުތީބުކުރެވިފައިވަނީ ވަކިކަން ބޮޑުވުމުގެ ތަރުތީބުން — ރިޒޯލްވަރު ބޭނުންކުރާ ތަރުތީބު، ވުމާއެކު ކާމިޔާބުވާ ރޯ އޮންނާނީ ނުވާ ރޯތަކުގެ މަތީގައެވެ.",
      "docType": "ލިޔުމުގެ ބާވަތް",
      "docTypeHint": "މޮޑިއުލުން ހުށަހަޅާ ޑޮޓް ޖެހި ބާވަތް، މިސާލަކަށް ap.invoice.",
      "scope": "ސްކޯޕް",
      "scopeId": "ސްކޯޕް އައިޑީ",
      "scopeIdHint": "މި ރޫލް ހަނިކުރާ ކުންފުނި، ބްރާންޗް، ޑިޕާޓްމަންޓް، ޑިވިޜަން ނުވަތަ ތަނުގެ އައިޑީ.",
      "company": "ކުންފުނި",
      "anyCompany": "އެއްވެސް ކުންފުންޏެއް",
      "category": "ބައި",
      "categoryHint": "ހުށަހަޅާ މޮޑިއުލުން ފޮނުވާ އިޚްތިޔާރީ ބައެއް، މިސާލަކަށް capital.",
      "currency": "ފައިސާ",
      "currencyHint": "އެއްވެސް ފައިސާއަކާ ދިމާވުމަށް ހުހަށް ބާއްވަވާ.",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "toHint": "މަތީ ޙައްދެއް ނެތްނަމަ ހުހަށް ބާއްވަވާ — އެއަށްވުރެ މަތީ ހުރިހާ އެއްޗެއް ހިފާ ބޭންޑް.",
      "unbounded": "މަތީ ޙައްދެއް ނެތް",
      "priority": "އިސްކަން",
      "priorityHint": "އެއްވަރުގެ ވަކިކަން ހުރި ރޫލްތަކުގެ މެދުގައި ނިންމައެވެ. މަތިވުމުން ކާމިޔާބުވެއެވެ.",
      "specificity": "ވަކިކަން",
      "chain": "ސިލްސިލާ",
      "stepCount": "{count} ފިޔަވަޅު",
      "noSteps": "ފިޔަވަޅެއް ނެތް",
      "preview": "ކުރިން ބަލާ",
      "create": "އައު ރޫލެއް",
      "createTitle": "އައު ބާރުގެ ރޫލް",
      "editTitle": "ބާރުގެ ރޫލް އެޑިޓްކުރޭ",
      "editorDescription": "ހެޑަރުން ދިމާވާ ލިޔުންތައް ނިންމައެވެ؛ ފިޔަވަޅުތަކުން ސޮއިކުރާ މީހުން ނިންމައެވެ.",
      "remove": "ފޮހެލާ",
      "removeTitle": "މި ރޫލް ފޮހެލާ",
      "removeConsequence": "އެޑިޓްކުރެވެނީ ދެލި ކޮޕީ ވަރޜަނެއް އެކަނި ކަމުން، މިއިން ފޮހެލެވެނީ ދެލި ކޮޕީން ރޫލެވެ. ބާރުގައި ހިނގާފައިވާ ވަރޜަންތަކަށް ބަދަލެއް ނާދެއެވެ.",
      "removed": "ރޫލް ފޮހެލެވިއްޖެ",
      "removeFailed": "ރޫލް ފޮހެލޭ ގޮތެއް ނުވި",
      "saved": "ރޫލް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ރޫލް ރައްކާއެއް ނުކުރެވުނު",
      "tableCaption": "މި ވަރޜަންގެ ބާރުގެ ރޫލްތައް، އެންމެ ވަކިކަން ބޮޑު އެއްޗެއް ކުރިން",
      "emptyTitle": "މި ވަރޜަންގައި ރޫލެއް ނެތް",
      "emptyDescription": "ލިޔުމުގެ ބާވަތަކަށް ރޫލެއް އިތުރުކޮށް، ސިލްސިލާއެއް ދެއްވާ. އެ ވަންދެން ލިޔުންތައް ދާނީ ފާސްކުރުމުގެ ސިޔާސަތުތަކަށެވެ."
    },
    "step": {
      "title": "ސިލްސިލާ",
      "add": "ފިޔަވަޅެއް އިތުރުކުރޭ",
      "remove": "ފިޔަވަޅު ނަގާ",
      "moveUp": "މައްޗަށް ގެންދޭ",
      "moveDown": "ތިރިއަށް ގެންދޭ",
      "name": "ފިޔަވަޅުގެ ނަން",
      "mode": "ގޮތް",
      "source": "ފާސްކުރާ މީހާ",
      "sourceHint": "ކޮންމެ ފިޔަވަޅެއްގައި އޮންނަނީ އެންމެ މަޞްދަރެކެވެ. އެކަތި ހޮވުމުން އަނެއްތައް ސާފުވެއެވެ.",
      "sourceMissing": "މި ފިޔަވަޅުން ފާސްކުރާ މީހާ ނެރޭނެ ގޮތް ހޮއްވަވާ.",
      "jobHint": "ރޫލްގެ ސްކޯޕް ތެރޭގައި، މި މަސައްކަތުގެ އެއްވެސް މަޤާމެއް.",
      "gradeHint": "ރޫލްގެ ސްކޯޕް ތެރޭގައި، މި ދަރަޖަ ނުވަތަ އެއަށްވުރެ މަތީ އެއްވެސް މަޤާމެއް.",
      "gradeLevel": "ދަރަޖަ {level}",
      "relativeTo": "ހިނގާ ފެށޭ ތަން",
      "relativeLevels": "މައްޗަށް ދާ ދަރަޖަ",
      "relativeLevelsHint": "1 އަކީ މެނޭޖަރު، 2 އަކީ މެނޭޖަރުގެ މެނޭޖަރެވެ.",
      "sla": "އެސް.އެލް.އޭ ގަޑިއިރު",
      "slaHint": "ފިޔަވަޅު ލަސްވުމުގެ ކުރިން ހުރި ގަޑިއިރު. 0 ވުމުން މުއްދަތެއް ނެތެވެ.",
      "escalateTo": "މައްޗަށް ފޮނުވާ ތަން",
      "escalateHint": "މީހެއް ނޫން، މަޤާމެއް — ވަޒީފާ ބަދަލުވާ މީހަކީ ބަންދު މަގެކެވެ.",
      "noEscalation": "މައްޗަށް ފޮނުވުމެއް ނެތް",
      "allowSelfApproval": "އަމިއްލައަށް ފާސްކުރުމަށް ހުއްދަ",
      "allowSelfApprovalHint": "ޑިފޯލްޓްކޮށް ނިއްވާލެވިފައި. ދިއްލުމުން ރޫލްގައި އޮޑިޓް ރެކޯޑްވެއެވެ، އަދި ބައެއް ބާވަތްތަކުގައި އެކަނި ހުއްދައެވެ.",
      "emptyChain": "މި ރޫލްގައި ފިޔަވަޅެއް ނެތުމުން އެއްވެސް އެއްޗެއް ނުފޮނުވޭނެއެވެ. މަދުވެގެން އެކަތި އިތުރުކުރައްވާ."
    },
    "preview": {
      "title": "ނެރެވުނު ސިލްސިލާ",
      "description": "މި ރޫލުން ޙަޤީޤަތުގައި ވާނެ ގޮތް — ކާކާ ސުވާލުކުރެވޭނީ، ކޮން ތަރުތީބަކުން، އަދި ބަލިވަނީ ކާކުކަން.",
      "emptyTitle": "ރޫލެއް ހޮއްވަވާ",
      "emptyDescription": "ރޫލެއް ހޮއްވަވައި، އެއިން ނެރެވޭ ސިލްސިލާ އާއި އެ ސިލްސިލާ ދިއުމުގެ މީހުން ބައްލަވާ.",
      "failedTitle": "ސިލްސިލާ ނުނެރެވުނު",
      "failedDescription": "ކުރިން ބެލުމުގެ ކޯލް ފެއިލްވެއްޖެ. އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވޭ؛ އަލުން މަސައްކަތްކުރައްވާ.",
      "noMatch": "މެޓްރިކްސްގެ އެއްވެސް ރޫލެއް ދިމައެއް ނުވި",
      "fallbackExplain": "މެޓްރިކްސްގައި އެއްވެސް އެއްޗެއް ދިމާނުވުމުން، މި ލިޔުން ދާނީ ފާސްކުރުމުގެ ސިޔާސަތުތަކަށެވެ — އެއީ ސީ1 ގެ ކުރީގެ ޢަމަލެއް، ގޯހެއް ނޫނެވެ.",
      "sources": {
        "matrix": "މެޓްރިކްސް",
        "policy": "ފާސްކުރުމުގެ ސިޔާސަތު"
      },
      "rule": "ރޫލް #{id}",
      "specificity": "ވަކިކަން {value}",
      "on": "{date} ގައި",
      "sla": "{hours} ގަޑިއިރު އެސް.އެލް.އޭ",
      "unnamedStep": "ފިޔަވަޅު",
      "noHolders": "އެއްވެސް މީހަކަށް ނުނެރެވުނު.",
      "unresolved": "{count} ފިޔަވަޅަކުން އެއްވެސް މީހަކަށް ނުނެރެވުނެވެ. އެ ފިޔަވަޅަށް ދާ ލިޔުމެއް އެތާނގައި ހުއްޓޭނެއެވެ.",
      "noStepsTitle": "ފިޔަވަޅެއް ނެތް",
      "noStepsDescription": "ދިމާވި ރޫލްގައި ސިލްސިލާއެއް ނެތުމުން އެއްވެސް މީހަކާ ސުވާލެއް ނުކުރެވޭނެއެވެ.",
      "rejectedTitle": "ކާމިޔާބުނުވި ރޫލްތައް",
      "candidatesTitle": "ބެލެވުނު ރޫލްތައް"
    },
    "whatIf": {
      "title": "ލިޔުމެއް ބަލާ",
      "description": "ހޮވިފައިވާ ރޫލް ޙަޤީޤީ އަދަދަކާ، ކުންފުންޏަކާ އަދި ތާރީޚަކާ ދެކޮޅަށް ނެރެލާ.",
      "amount": "އަދަދު",
      "amountHint": "ބޭންޑާ ދިމާކުރެވޭ ލިޔުމުގެ ޖުމުލަ.",
      "currency": "ފައިސާ",
      "company": "ކުންފުނި",
      "on": "ތާރީޚް",
      "run": "ނެރެލާ",
      "chooseRule": "ނެރެލުމަށް މަތިން ރޫލެއް ހޮއްވަވާ."
    },
    "delegation": {
      "title": "ހަވާލުކުރުންތައް",
      "description": "އެއް މަޤާމުގެ ފާސްކުރުމުގެ ބާރު އަނެއް މަޤާމަށް، މުއްދަތަކަށް އަދި ޙައްދެއްގެ ތެރޭގައި ދިނުން.",
      "from": "ދޭ މަޤާމު",
      "to": "ލިބޭ މަޤާމު",
      "toEmployee": "މުވައްޒަފު #{id}",
      "delegator": "ބާރު ދޭ ފަރާތް",
      "scope": "ލިޔުމުގެ ބާވަތް",
      "scopeHint": "މި މަޤާމުން ފާސްކުރާ ހުރިހާ ބާވަތެއް ހަވާލުކުރުމަށް ހުހަށް ބާއްވަވާ.",
      "allDocTypes": "ހުރިހާ ބާވަތެއްގެ ލިޔުން",
      "limit": "ޙައްދު",
      "limitHint": "ބާރު ދޭ ފަރާތުގެ އަމިއްލަ ޙައްދު ފަހަނައެއް ނޭޅޭނެއެވެ — ސާވަރުން ދޫނުކުރެއެވެ.",
      "noLimit": "އިތުރު ޙައްދެއް ނެތް",
      "toDateHint": "ދެ ކޮޅުވެސް ބޭނުންވެއެވެ. ނިމުމެއް ނެތް ހަވާލުކުރުމަކީ ދެ މީހުންގެ ކޮންޓްރޯލެއް ނެތި މެޓްރިކްސް ބަދަލުކުރުމެވެ.",
      "reason": "ސަބަބު",
      "create": "އައު ހަވާލުކުރުމެއް",
      "createTitle": "ބާރު ހަވާލުކުރޭ",
      "createDescription": "ބާރު ލިބޭ މީހާ ފާސްކުރަނީ އަމިއްލަ ނަމުގައެވެ؛ ރެކޯޑުން ބުނަނީ ކާކުގެ ބާރެއްގެ ދަށުންކަމެވެ.",
      "created": "ހަވާލުކުރުން އުފެދިއްޖެ",
      "createFailed": "ހަވާލުކުރުން އުފެއްދޭ ގޮތެއް ނުވި",
      "exceeds": "މިއިން ބާރު ދޭ މަޤާމުގެ އަމިއްލަ ބާރު ފަހަނައަޅައެވެ. ހަވާލުކުރުމަކުން ބާރު ހަނިކުރެވިދާނެ، ފުޅައެއް ނުކުރެވޭނެއެވެ.",
      "revokeTitle": "މި ހަވާލުކުރުން ބާޠިލުކުރޭ",
      "revokeConsequence": "މިހާރު ފިޔަވަޅު އެޅިފައިވާ ކަންކަން ހުންނާނީ އެގޮތުގައެވެ. ބާކީ ހުޅުވިފައި ހުރި ކަންކަން އަނބުރާ ބާރު ދިން މަޤާމަށް ދާނެއެވެ.",
      "revokeReason": "ބާޠިލުކުރުމުގެ ސަބަބު",
      "revoked": "ހަވާލުކުރުން ބާޠިލުކުރެވިއްޖެ",
      "tableLabel": "ހަވާލުކުރުންތައް",
      "emptyTitle": "ހަވާލުކުރުމެއް ނެތް",
      "emptyDescription": "ފާސްކުރާ މީހަކު ނެތިގެން ކިޔޫ ހުއްޓޭ ގޮތް ނުވުމަށް ބާރު ހަވާލުކުރައްވާ.",
      "loadFailed": "ހަވާލުކުރުންތައް ލޯޑެއް ނުވި",
      "statuses": {
        "active": "ހަރަކާތްތެރި",
        "revoked": "ބާޠިލުކުރެވިފައި",
        "expired": "މުއްދަތު ހަމަވެފައި"
      }
    },
    "absence": {
      "title": "ޙާޟިރުނުވުންތައް",
      "description": "މީހަކު ނެތްއިރު ފާސްކުރުންތައް ދާ ތަން.",
      "employee": "މުވައްޒަފު",
      "kind": "ބާވަތް",
      "source": "މަޞްދަރު",
      "reassignTo": "އަލުން ހަވާލުކުރާ ތަން",
      "reassignHint": "ރިޕޯޓިންގ ލައިނަށް ދިއުމަށް ދޫކޮށްލުމަށް ހުހަށް ބާއްވަވާ.",
      "fallsThrough": "ރިޕޯޓިންގ ލައިނަށް ދޫވެއެވެ",
      "create": "ޙާޟިރުނުވުމެއް ރެކޯޑްކުރޭ",
      "createTitle": "ޙާޟިރުނުވުމެއް ރެކޯޑްކުރޭ",
      "createDescription": "ޗުއްޓީ ރިކުއެސްޓަކުން ނުހިމެނޭ ޙާޟިރުނުވުންތަކަށް، ނުވަތަ މަސައްކަތް ދާންވީ ތަން ކަނޑައެޅުމަށް.",
      "created": "ޙާޟިރުނުވުން ރެކޯޑްކުރެވިއްޖެ",
      "createFailed": "ޙާޟިރުނުވުން ރެކޯޑެއް ނުކުރެވުނު",
      "cancelTitle": "މި ޙާޟިރުނުވުން ކެންސަލްކުރޭ",
      "cancelConfirm": "ޙާޟިރުނުވުން ކެންސަލްކުރޭ",
      "cancelConsequence": "ކެންސަލްކުރާ ވަގުތުން ފެށިގެން ފާސްކުރުންތައް އަލުން ހަވާލުކުރުން ހުއްޓެއެވެ. މިހާރު ހަވާލުކުރެވިފައިވާ ކަންކަން ހުންނާނީ ދިޔަ ތަނުގައެވެ.",
      "cancelled": "ޙާޟިރުނުވުން ކެންސަލްކުރެވިއްޖެ",
      "tableLabel": "ޙާޟިރުނުވުންތައް",
      "emptyTitle": "ޙާޟިރުނުވާކަމަށް އެއްވެސް މީހަކު ރެކޯޑްކޮށްފައެއް ނެތް",
      "emptyDescription": "ފާސްކުރެވިފައިވާ ޗުއްޓީން މިތާނގައި ރޯތައް އަމިއްލައަށް އުފެދެއެވެ. ޗުއްޓީން ނުހިމެނޭ ޙާޟިރުނުވުމަކަށް އެކަތި އިތުރުކުރައްވާ.",
      "loadFailed": "ޙާޟިރުނުވުންތައް ލޯޑެއް ނުވި",
      "kinds": {
        "leave": "ޗުއްޓީ",
        "travel": "ދަތުރު",
        "suspension": "ސަސްޕެންޑްކުރުން",
        "other": "އެހެނިހެން"
      },
      "sources": {
        "manual": "އަތުން ލިޔެފައި",
        "hr_leave": "ފާސްކުރެވުނު ޗުއްޓީން"
      }
    },
    "materiality": {
      "title": "މުހިންމުކަމުގެ ޙައްދުތައް",
      "description": "ބަދަލެއް އެހާ ބޮޑުވެ، ދެވިފައިވާ ފާސްކުރުންތައް ދެމިނޯންނަ ހިސާބު.",
      "explain": "ސަތޭކަ ހާސް ރުފިޔާއަށް ފާސްކުރެވުނު ޕާޗޭސް އޯޑަރެއް ހަތަރު ލައްކައަށް ބަދަލުކުރުމުން، އެ ފާސްވެފައެއް ނުވެއެވެ — ފާސްވެފައިވަނީ އެހެން އެއްޗެކެވެ. މި ޙައްދުތަކުން ނިންމަނީ އެ ރޮނގު ދާ ތަނެވެ.",
      "docType": "ލިޔުމުގެ ބާވަތް",
      "pct": "އިންސައްތަ",
      "pctHint": "ފާސްކުރެވުނު އަގާ އަޅާބަލާއިރު ބަދަލު، އިންސައްތައިން.",
      "abs": "އަދަދު",
      "absHint": "ފައިސާއިން ބަދަލު، ދެއިން ކުރިން ދިމާވާ އެއްޗެއް.",
      "band": "ބޭންޑް ފަހަނައެޅުން",
      "bandOn": "އަބަދުވެސް މުހިންމު",
      "bandOff": "އެކަނި ނުފުދޭ",
      "bandLabel": "ބޭންޑް ފަހަނައެޅުމަކީ އަބަދުވެސް މުހިންމު ކަމެއް",
      "bandHint": "ކުޑަ ބަދަލަކުންވެސް ލިޔުން އެހެން ފާސްކުރާ މީހަކު އޮތް ބޭންޑަކަށް ދެވިދާނެއެވެ. ޙައްދުތަކުން އެކަން ބުނެނުދެވޭތީ، މިއީ ވަކި ސުވިޗެކެވެ.",
      "fields": "މުހިންމު ފީލްޑްތައް",
      "fieldsHint": "އަދަދު ކޮންމެ ގޮތެއް ވިޔަސް ބަދަލުވުމުން މުހިންމުވާ ފީލްޑްތައް، ކޮމާއިން ވަކިކޮށް، މިސާލަކަށް vendorId, currency.",
      "amountOnly": "އަދަދު އެކަނި",
      "isActive": "ހަރަކާތްތެރި",
      "create": "އައު ޙައްދެއް",
      "editTitle": "މުހިންމުކަމުގެ ޙައްދު",
      "editDescription": "ލިޔުމުގެ ބާވަތަކަށް، އަދި ބޭނުންނަމަ ކުންފުންޏަކަށް ކަނޑައެޅެއެވެ.",
      "saved": "ޙައްދު ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޙައްދު ރައްކާއެއް ނުކުރެވުނު",
      "tableLabel": "މުހިންމުކަމުގެ ސިޔާސަތުތައް",
      "emptyTitle": "ޙައްދެއް ކަނޑައަޅާފައެއް ނެތް",
      "emptyDescription": "ޙައްދެއް ނެތި، ބަދަލެއް ގެނައުމުން ފާސްކުރުމުގެ ސިލްސިލާ ބާޠިލެއް ނުވެއެވެ. މުހިންމު ބާވަތްތަކަށް ޙައްދު ކަނޑައަޅުއްވާ.",
      "loadFailed": "މުހިންމުކަމުގެ ޙައްދުތައް ލޯޑެއް ނުވި"
    },
    "queue": {
      "unratified": {
        "summary": "އަވަސްހާލަތުގެ ފާސްކުރުމެއް ތަސްދީޤުކުރުމަށް މަޑުކުރެވިފައި ވޭ."
      }
    }
  },
  "opcal": {
    "nav": {
      "label": "އޮޕަރޭޓިންގ ކަލަންޑަރުގެ ބައިތައް",
      "board": "ދުވަހުގެ ބޯޑް",
      "calendars": "ކަލަންޑަރުތައް"
    },
    "routeTitles": {
      "board": "ވިޔަފާރި ދުވަހުގެ ބޯޑް",
      "calendars": "އޮޕަރޭޓިންގ ކަލަންޑަރުތައް",
      "calendar": "އޮޕަރޭޓިންގ ކަލަންޑަރު"
    },
    "weekdays": {
      "mon": "ހޯމަ",
      "tue": "އަންގާރަ",
      "wed": "ބުދަ",
      "thu": "ބުރާސްފަތި",
      "fri": "ހުކުރު",
      "sat": "ހޮނިހިރު",
      "sun": "އާދިއްތަ"
    },
    "weekdayInitials": {
      "mon": "ހ",
      "tue": "އަ",
      "wed": "ބު",
      "thu": "ބް",
      "fri": "ހު",
      "sat": "ހޮ",
      "sun": "އާ"
    },
    "unitTypes": {
      "company": "ކުންފުނި",
      "branch": "ބްރާންޗް",
      "location": "ތަން"
    },
    "dayStatuses": {
      "scheduled": "ތާވަލުކުރެވިފައި",
      "open": "ހުޅުވިފައި",
      "closing": "ބަންދުކުރަނީ",
      "closed": "ބަންދު",
      "reopened": "އަލުން ހުޅުވިފައި"
    },
    "moduleStatuses": {
      "pending": "ބަލާފައެއް ނުވޭ",
      "ready": "ތައްޔާރު",
      "blocked": "ހުއްޓިފައި",
      "complete": "ފުރިހަމަ"
    },
    "holidayKinds": {
      "public": "ޢާންމު",
      "religious": "ދީނީ",
      "company": "ކުންފުނީގެ",
      "closure": "ބަންދު"
    },
    "board": {
      "title": "ވިޔަފާރި ދުވަހުގެ ބޯޑް",
      "description": "މިއަދު ކޮން ޔުނިޓްތަކެއް ހުޅުވައި ބަންދުކޮށްފައިވޭތޯ، އަދި ބާކީ ތިބި ޔުނިޓްތައް ހުއްޓުވަނީ ކޮން ކަމެއްތޯ.",
      "on": "ވިޔަފާރި ތާރީޚް",
      "noDay": "ދުވަހެއް ހުޅުވާފައެއް ނުވޭ",
      "notOpened": "{count} ޔުނިޓަކުން ދުވަހެއް ހުޅުވާފައެއް ނުވެއެވެ. އެ ޔުނިޓްތަކުގައި މައްސަލައެއް ނެތް — އެކަމަކު އެއްވެސް މީހަކު ދުވަހެއް ފަށާފައެއްވެސް ނުވެއެވެ.",
      "stillOpen": "{count} ޔުނިޓް އަދިވެސް ހުޅުވިފައި.",
      "forced": "ހުއްޓުވުންތައް ބާކީ ހުއްޓައި ބަންދުކުރެވިފައި ({code}).",
      "emptyTitle": "އޮޕަރޭޓިންގ ޔުނިޓެއް ނެތް",
      "emptyDescription": "ބޯޑުގައި ދައްކަނީ ކަލަންޑަރެއް ސްކޯޕްކުރެވިފައިވާ ޔުނިޓްތަކެވެ. ކުންފުންޏަކަށް، ބްރާންޗަކަށް ނުވަތަ ތަނަކަށް ކަލަންޑަރެއް ސްކޯޕްކުރައްވާ.",
      "loadFailed": "ބޯޑް ލޯޑެއް ނުވި"
    },
    "day": {
      "open": "ދުވަސް ހުޅުވާ",
      "opened": "ވިޔަފާރި ދުވަސް ހުޅުވިއްޖެ",
      "openFailed": "ދުވަސް ހުޅުވޭ ގޮތެއް ނުވި",
      "close": "ދުވަސް ބަންދުކުރޭ",
      "closeTitle": "ވިޔަފާރި ދުވަސް ބަންދުކުރޭ",
      "closeSubject": "ވިޔަފާރި ތާރީޚް {date}",
      "closed": "ވިޔަފާރި ދުވަސް ބަންދުކުރެވިއްޖެ",
      "recheck": "އަލުން ބަލާ",
      "allReady": "ހުރިހާ މޮޑިއުލެއްވެސް ތައްޔާރުކަމަށް ބުނެއެވެ.",
      "blocked": "{count} މޮޑިއުލެއް ތައްޔާރެއް ނޫން.",
      "blockingCount": "{count} ބާކީ",
      "forceToggle": "ސަބަބަކާއެކު ބާރުއަޅައިގެން ބަންދުކުރޭ",
      "forceClose": "ބާރުއަޅައިގެން ބަންދުކުރޭ",
      "forceReason": "ބާރުއެޅުމުގެ ސަބަބު",
      "forceConsequence": "ބާރުއެޅުމުން މަސައްކަތް ބާކީ ހުއްޓައި ދުވަސް ބަންދުވެއެވެ. އެކަން ރެކޯޑްކުރެވި، ރިކޮންސިލިއޭޝަން ކިޔޫ އައިޓަމެއް ހުޅުވި، މީހަކު އަލުން އެކަމަށް އަންނަންޖެހެއެވެ.",
      "reopen": "އަލުން ހުޅުވާ",
      "reopenTitle": "ބަންދުކުރެވިފައިވާ ދުވަހެއް އަލުން ހުޅުވާ",
      "reopenReason": "އަލުން ހުޅުވުމުގެ ސަބަބު",
      "reopenConsequence": "ބަންދުކުރެވިފައިވާ ދުވަހެއް އަލުން ހުޅުވުމަކީ މީހަކު ކުރިން ތަޞްދީޤުކޮށްފައިވާ ރެކޯޑެއް އަލުން ހުޅުވުމެވެ. މިއަށް ދެވަނަ ފެކްޓަރަކާއި ލިޔެފައިވާ ސަބަބެއް ބޭނުންވެއެވެ.",
      "reopened": "ވިޔަފާރި ދުވަސް އަލުން ހުޅުވިއްޖެ"
    },
    "calendar": {
      "title": "އޮޕަރޭޓިންގ ކަލަންޑަރުތައް",
      "description": "އޮޕަރޭޓިންގ ޔުނިޓެއް ހިނގާ މަސައްކަތު ހަފުތާ، ބަންދު ދުވަސްތައް އަދި ޝިފްޓްތައް. ހެޑް އޮފީހާއި ރިސޯޓް ފްރޮންޓް ޑެސްކަކީ އެއް ކަލަންޑަރެއް ނޫނެވެ.",
      "detailDescription": "މަސައްކަތު ހަފުތާ، ބަންދު ދުވަސްތައް، ދުވަހުގެ ބައިތައް އަދި ޝިފްޓްތައް.",
      "code": "ކޯޑް",
      "name": "ނަން",
      "timezone": "ޓައިމްޒޯން",
      "timezoneHint": "އައި.އޭ.އެން.އޭ ނަން، މިސާލަކަށް Indian/Maldives.",
      "dayStart": "ދުވަސް ފެށޭ ގަޑި",
      "dayStartHint": "މި ޔުނިޓްގެ ވިޔަފާރި ދުވަސް ފެށޭ ވަގުތު. 02:00 ގައި ބަންދުކުރާ ބާރެއްގައި މެންދަމު 12 ން އައު ދުވަހެއް ނުފެށެއެވެ.",
      "workingDays": "މަސައްކަތު ދުވަސްތައް",
      "workingDaysHint": "ވިޔަފާރި ދުވަހުގެ ހިސާބު، ޗުއްޓީ ޖަމާވުން އަދި ވެލިއު ޑޭޓިންގ ހުރިހާ އެއްޗެއްވެސް މިއިން ކިޔައެވެ.",
      "noWorkingDay": "ކަލަންޑަރެއްގައި މަދުވެގެން އެއް މަސައްކަތު ދުވަސް އޮންނަންޖެހެއެވެ.",
      "weekTitle": "މަސައްކަތު ހަފުތާ",
      "isDefault": "މި ކުންފުނީގެ ޑިފޯލްޓް",
      "default": "ޑިފޯލްޓް",
      "isActive": "ހަރަކާތްތެރި",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތެއް ނެތް",
      "create": "އައު ކަލަންޑަރެއް",
      "createTitle": "އައު އޮޕަރޭޓިންގ ކަލަންޑަރު",
      "createDescription": "ފެށެނީ ހޯމަ އިން ހުކުރަށް؛ އުފެއްދުމަށްފަހު ބަދަލުކުރެވޭނެއެވެ.",
      "createHint": "މަސައްކަތު ހަފުތާ، ބަންދު ދުވަސްތައް އަދި ޝިފްޓްތައް އެޑިޓްކުރެވެނީ ކަލަންޑަރުގެ ތެރެއިންނެވެ.",
      "created": "ކަލަންޑަރު އުފެދިއްޖެ",
      "saved": "ކަލަންޑަރު ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ކަލަންޑަރު ރައްކާއެއް ނުކުރެވުނު",
      "backToList": "ހުރިހާ ކަލަންޑަރެއް",
      "tabsLabel": "ކަލަންޑަރުގެ ބައިތައް",
      "tabs": {
        "week": "މަސައްކަތު ހަފުތާ",
        "holidays": "ބަންދު ދުވަސްތައް",
        "dayParts": "ދުވަހުގެ ބައިތައް",
        "shifts": "ޝިފްޓްތައް"
      },
      "probeTitle": "ތާރީޚެއް ބަލާ",
      "probeFrom": "ފެށޭ",
      "probeDays": "އިތުރުކުރާ ވިޔަފާރި ދުވަސް",
      "probeResult": "ދެން އަންނަ ވިޔަފާރި ދުވަހަކީ {next}؛ މަތީގައިވާ ދުވަސްތައް އިތުރުކުރުމުން {end} އަށް ދާނެއެވެ، {count} ވިޔަފާރި ދުވަސް ގުނައެވެ.",
      "isBusinessDay": "މަސައްކަތު ދުވަހެއް",
      "notBusinessDay": "މަސައްކަތު ދުވަހެއް ނޫން",
      "tableLabel": "އޮޕަރޭޓިންގ ކަލަންޑަރުތައް",
      "emptyTitle": "އަދި ކަލަންޑަރެއް ނެތް",
      "emptyDescription": "ކޮންމެ އޮޕަރޭޓިންގ ނަމޫނާއަކަށް އެއް ކަލަންޑަރު އުފައްދަވާ — ހެޑް އޮފީހަށް އެކަތި، ހަތް ދުވަހު ވިޔަފާރިކުރާ ޔުނިޓްތަކަށް އަނެކަތި.",
      "loadFailed": "ކަލަންޑަރުތައް ލޯޑެއް ނުވި"
    },
    "holiday": {
      "title": "ބަންދު ދުވަސްތައް",
      "description": "ޢާންމު، ދީނީ އަދި ކުންފުނީގެ ބަންދު ދުވަސްތައް، އަދި އެ ދުވަސްތަކުގައި ޔުނިޓް ވިޔަފާރިކުރޭތޯ.",
      "date": "ތާރީޚް",
      "name": "ނަން",
      "kind": "ބާވަތް",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "trading": "ވިޔަފާރި",
      "trades": "ވިޔަފާރިކުރޭ",
      "halfDay": "ބައި ދުވަސް",
      "closed": "ބަންދު",
      "source": "މަޞްދަރު",
      "isWorkingDay": "މި ދުވަހު ޔުނިޓް ވިޔަފާރިކުރެއެވެ",
      "isWorkingDayHint": "ރިސޯޓެއް ވިޔަފާރިކުރާ ޢާންމު ބަންދު ދުވަހަކީވެސް ޢާންމު ބަންދު ދުވަހެކެވެ — ބަދަލުވަނީ މުސާރަ، ހުޅުވުމެއް ނޫނެވެ.",
      "isHalfDay": "ބައި ދުވަސް",
      "create": "ބަންދު ދުވަހެއް އިތުރުކުރޭ",
      "createTitle": "ބަންދު ދުވަހެއް އިތުރުކުރޭ",
      "createDescription": "އެއް ތާރީޚް، އެއް ކަލަންޑަރު.",
      "saved": "ބަންދު ދުވަސް ރައްކާކުރެވިއްޖެ",
      "remove": "ނަގާ",
      "removed": "ބަންދު ދުވަސް ނެގިއްޖެ",
      "removeFailed": "ބަންދު ދުވަސް ނުނެގުނު",
      "import": "ސީއެސްވީ އިމްޕޯޓްކުރޭ",
      "importTitle": "އަހަރެއްގެ ބަންދު ދުވަސްތައް އިމްޕޯޓްކުރޭ",
      "importDescription": "އަހަރެއްގެ ޢާންމު ބަންދު ދުވަސްތައް އަންނަނީ ގެޒެޓެއްގެ ގޮތުގައި، ބާރަ ފޯމެއްގެ ގޮތުގައެއް ނޫނެވެ.",
      "year": "އަހަރު",
      "csv": "ސީއެސްވީ",
      "csvHint": "ކޮންމެ ބަންދު ދުވަހަކަށް އެއް ރޯ: date,name,kind. އަލުން ހިންގުމުން ކުރިން ހުރި ތާރީޚްތައް ދޫކޮށްލައެވެ.",
      "importResult": "{imported} އިމްޕޯޓްކުރެވިއްޖެ، {skipped} ކުރިންވެސް ހުއްޓެވެ.",
      "tableCaption": "މި ކަލަންޑަރުގެ ބަންދު ދުވަސްތައް",
      "empty": "މި ކަލަންޑަރުގައި ބަންދު ދުވަހެއް ނެތް."
    },
    "dayPart": {
      "title": "ދުވަހުގެ ބައިތައް",
      "description": "ވިޔަފާރި ދުވަހުގެ ނަން ދެވިފައިވާ ބައިތައް. ޕޮއިންޓް އޮފް ސޭލް އަދި ޕްރޮޕަޓީ މެނޭޖްމަންޓުން މިއަށް ރިޕޯޓްކުރެއެވެ.",
      "code": "ކޯޑް",
      "name": "ނަން",
      "start": "ފެށޭ",
      "end": "ނިމޭ",
      "crossesMidnight": "މެންދަމު ފަހަނައަޅާ",
      "add": "ބައެއް އިތުރުކުރޭ",
      "saved": "ދުވަހުގެ ބައިތައް ރައްކާކުރެވިއްޖެ",
      "tableCaption": "މި ކަލަންޑަރުގެ ދުވަހުގެ ބައިތައް",
      "empty": "ދުވަހުގެ ބައެއް ކަނޑައަޅާފައެއް ނެތް."
    },
    "shift": {
      "title": "ޝިފްޓްތައް",
      "description": "މި ކަލަންޑަރުން ދޭ މަސައްކަތުގެ ނަމޫނާތައް. ރޯސްޓަރިންގ އިން މިއަށް ބަރޯސާވެއެވެ؛ ސީ1 އިން ކަނޑައަޅައެވެ.",
      "code": "ކޯޑް",
      "name": "ނަން",
      "start": "ފެށޭ",
      "duration": "މިނެޓް",
      "break": "ބްރޭކް",
      "paid": "މުސާރަ ލިބޭ",
      "dayPart": "ދުވަހުގެ ބައި",
      "add": "ޝިފްޓެއް އިތުރުކުރޭ",
      "saved": "ޝިފްޓްތައް ރައްކާކުރެވިއްޖެ",
      "tableCaption": "މި ކަލަންޑަރުގެ ޝިފްޓްތައް",
      "empty": "ޝިފްޓެއް ކަނޑައަޅާފައެއް ނެތް."
    }
  },
  "rules": {
    "nav": {
      "label": "ކޮންޓްރޯލްގެ ބައިތައް",
      "controls": "ކޮންޓްރޯލް ރޫލްތައް",
      "reasons": "ސަބަބުގެ ކޯޑްތައް",
      "overrides": "ފަހަނައެޅުންތައް",
      "queues": "ކިޔޫތައް"
    },
    "routeTitles": {
      "controls": "ކޮންޓްރޯލް ރޫލްތައް",
      "reasons": "ސަބަބުގެ ކޯޑްތައް",
      "overrides": "ފަހަނައެޅުމުގެ ރިޕޯޓް",
      "queues": "ރިކޮންސިލިއޭޝަން ކިޔޫތައް",
      "queueItems": "ކިޔޫގެ ކަންކަން"
    },
    "classifications": {
      "absolute": "ފަހަނަނޭޅޭ",
      "overridable": "ފަހަނައެޅޭ"
    },
    "classificationHints": {
      "absolute": "އެއްވެސް މީހަކަށް ދުވަހަކުވެސް ފަހަނައެއް ނޭޅޭނެއެވެ.",
      "overridable": "ބާރު އޮތް މީހަކަށް، ކަނޑައެޅިފައިވާ ސަބަބަކާއެކު ފަހަނައެޅިދާނެއެވެ."
    },
    "severities": {
      "block": "ހުއްޓުވާ",
      "warn": "އިންޒާރުދޭ"
    },
    "severityHints": {
      "block": "ޢަމަލު ދޫނުކުރެވެއެވެ.",
      "warn": "ޢަމަލު ކުރިއަށްދެއެވެ، އަދި އިންޒާރެއް ރެކޯޑްވެއެވެ."
    },
    "control": {
      "title": "ކޮންޓްރޯލް ރޫލްތައް",
      "description": "ލިޔުމަކާއި ލެޖަރާ ދެމެދު ހުންނަ ބެލުންތައް، އަދި އޭގެ ތެރެއިން ސަބަބުގެ ކޯޑަކުން ފަހަނައެޅޭ ބެލުންތައް.",
      "explain": "ކޮންޓްރޯލް ރޫލަކީ ކޯޑެވެ: އެ ދިރިއުޅެނީ ބެލުން ހިނގާ ތަނުގައި، އަދި ޓެނަންޓަކަށް އައު ރޫލެއް ނުހެދޭނެއެވެ. ބަދަލުކުރެވެނީ ފަހަނައެޅޭ ރޫލެއް ދިއްލާފައިވޭތޯ، އަދި އިންޒާރެއް ހުއްޓުވުމަކަށް ބަދަލުކުރެވިފައިވޭތޯއެވެ.",
      "code": "ރޫލް",
      "module": "މޮޑިއުލް",
      "classification": "ބާވަތް",
      "severity": "ބާރުމިން",
      "registrySeverity": "ރަޖިސްޓްރީގެ ޑިފޯލްޓް",
      "severityHint": "އިންޒާރެއް ހުއްޓުވުމަކަށް ބަދަލުކުރެވިދާނެއެވެ. ހުއްޓުވުމެއް ދުވަހަކުވެސް އިންޒާރަކަށް ދޫކުރެވިގެންނުވާނެއެވެ.",
      "reasonSet": "ސަބަބުގެ ސެޓް",
      "noReasonSet": "ނެތް",
      "queue": "ކިޔޫ",
      "enabled": "ދިއްލިފައި",
      "enabledHint": "ފަހަނައެޅޭ ރޫލެއް ނިއްވާލުމުން އެއިން އެއްވެސް އެއްޗެއް ނުހުއްޓުވާނެއެވެ. ފަހަނަނޭޅޭ ރޫލްތައް ނުނިއްވޭނެއެވެ.",
      "enabledOnly": "ދިއްލިފައިވާ އެކަނި",
      "on": "ދިއްލިފައި",
      "off": "ނިއްވާލެވިފައި",
      "alwaysOn": "އަބަދުވެސް ދިއްލިފައި",
      "tightened": "މި ޓެނަންޓުން ހަރުކަށިކޮށްފައި",
      "orphaned": "ބިކަވެފައި",
      "orphanNotice": "{count} ރޫލެއް ސޮފްޓްވެއަރގެ ރަޖިސްޓްރީގައި މިހާރު ނެތެވެ. ފަހަނައެޅުމުގެ ރެކޯޑްތަކުން އެ ރޫލްތަކުގެ ނަން ބޭނުންކުރާތީ، ފޮހެލުމުގެ ބަދަލުގައި ބަހައްޓަނީއެވެ.",
      "configure": "ކަނޑައަޅާ",
      "configureTitle": "ކޮންޓްރޯލް ރޫލެއް ކަނޑައަޅާ",
      "absoluteRefusal": "މި ރޫލަކީ ފަހަނަނޭޅޭ ރޫލެކެވެ، އަދި އެއްވެސް ފަރާތަކަށް ފަހަނައެޅުމުގެ ފުރުޞަތެއް ނުދެއެވެ — ޓެނަންޓް އެޑްމިނިސްޓްރޭޓަރާއި ސަޕޯޓް ހިމެނޭ ގޮތުން. މި މަސައްކަތް ރެކޯޑްކުރެވިއްޖެއެވެ.",
      "saved": "ކޮންޓްރޯލް ރޫލް އަޕްޑޭޓްވެއްޖެ",
      "tableLabel": "ކޮންޓްރޯލް ރޫލްތައް",
      "emptyTitle": "ކޮންޓްރޯލް ރޫލެއް ނެތް",
      "emptyDescription": "ޓެނަންޓް ތައްޔާރުކުރެވޭއިރު ނުވަތަ އަޕްގްރޭޑްވާއިރު ސޮފްޓްވެއަރގެ ރަޖިސްޓްރީން ރޫލްތައް ކޮޕީވެއެވެ. ހުސްވުމުން މާނައަކީ އެ ކޮޕީކުރުން ހިންގިފައި ނުވުމެވެ.",
      "loadFailed": "ކޮންޓްރޯލް ރޫލްތައް ލޯޑެއް ނުވި"
    },
    "reason": {
      "label": "ސަބަބު",
      "placeholder": "ސަބަބެއް ހޮއްވަވާ",
      "hint": "އިސްތިސްނާއާއެކު ރެކޯޑްކުރެވެނީ ކިޔުމަށް އެކަނި ނޫން، ގުނުމަށެވެ.",
      "noteLabel": "ނޯޓް",
      "noteRequired": "މި ސަބަބަށް ނޯޓެއް ބޭނުންވެއެވެ.",
      "noteOptional": "އިޚްތިޔާރީ.",
      "noteRequiredHint": "ނޯޓެއް ބޭނުންވެއެވެ",
      "attachmentRequired": "މި ސަބަބަށް ލިޔުމުގައި ހެކި އެޓޭޗްކުރުން ބޭނުންވެއެވެ.",
      "loadFailed": "މި ރޫލްގެ ސަބަބުތައް ލޯޑްނުވުމުން ސަބަބެއް ނުހޮވޭނެއެވެ.",
      "org": {
        "period": {
          "reopen": {
            "correcting_entry": "ރަނގަޅުކުރުމުގެ އެންޓްރީ",
            "late_supplier_invoice": "ސަޕްލަޔަރުގެ ލަސް އިންވޮއިސް",
            "audit_adjustment": "އޮޑިޓް އެޖަސްޓްމަންޓް",
            "other": "އެހެނިހެން"
          }
        },
        "address": {
          "waiver": {
            "rural_no_formal_address": "މި ތަނުގައި ރަސްމީ އެޑްރެހެއް ނެތް",
            "pending_geo_registration": "ތަން ރަޖިސްޓްރީވުމުގެ އިންތިޒާރުގައި",
            "other": "އެހެނިހެން"
          }
        },
        "position": {
          "headcount": {
            "temporary_overlap_handover": "ހަވާލުކުރުމުގެ ވަގުތީ ފުށުއެރުން",
            "urgent_backfill": "އަވަސް ބަދަލެއް ހަމަޖެއްސުން",
            "restructure_in_progress": "އޮނިގަނޑު ބަދަލުކުރުން ކުރިއަށްދަނީ"
          }
        }
      },
      "authority": {
        "self_approval": {
          "sole_authorised_signatory": "ހަމައެކަނި ސޮއިކުރުމުގެ ބާރު ލިބިފައިވާ ފަރާތް",
          "emergency_cover": "ކުއްލި ބަދަލެއް"
        },
        "emergency": {
          "approver_unreachable": "ފާސްކުރާ މީހާއާ ނުގުޅޭ",
          "operational_deadline": "އޮޕަރޭޝަނަލް މުއްދަތެއް",
          "system_outage": "ސިސްޓަމް ހުއްޓުން"
        },
        "delegation": {
          "annual_leave": "އަހަރީ ޗުއްޓީ",
          "business_travel": "ވިޔަފާރި ދަތުރު",
          "medical_leave": "ބޭސްފަރުވާގެ ޗުއްޓީ",
          "secondment": "ވަގުތީ ބަދަލުކުރުން",
          "workload_cover": "މަސައްކަތުގެ ބުރަ ބެލެހެއްޓުން",
          "revoked_no_longer_needed": "މިހާރު ބޭނުމެއް ނުވޭ"
        }
      },
      "procurement": {
        "po": {
          "amendment": {
            "price_change": "އަގު ބަދަލުވުން",
            "quantity_change": "ޢަދަދު ބަދަލުވުން",
            "supplier_substitution": "ސަޕްލަޔަރު ބަދަލުކުރުން",
            "specification_change": "ސްޕެސިފިކޭޝަން ބަދަލުވުން"
          }
        }
      },
      "opcal": {
        "day": {
          "force_close": {
            "reconciled_offline": "އޮފްލައިންކޮށް ރިކޮންސައިލްކުރެވިފައި",
            "system_downtime": "ސިސްޓަމް ހުއްޓުން",
            "immaterial_variance": "މުހިންމުނޫން ތަފާތެއް"
          },
          "reopen": {
            "missed_transaction": "ދޫވެފައިވާ މުޢާމަލާތެއް",
            "correction": "ރަނގަޅުކުރުމެއް"
          }
        }
      },
      "fx": {
        "rate": {
          "hold": {
            "market_volatility_confirmed": "ބާޒާރުގެ ހަލަބޮލިކަން ކަށަވަރުކުރެވިފައި",
            "central_bank_devaluation": "މަރުކަޒީ ބޭންކުން އަގު ދަށްކުރުން",
            "provider_correction": "ފޯރުކޮށްދޭ ފަރާތުގެ ރަނގަޅުކުރުމެއް"
          }
        }
      },
      "gl": {
        "dimension": {
          "shared_cost_unallocated": "ޙިއްޞާކުރެވޭ ޚަރަދު، އަދި ބަހާލެވިފައެއް ނުވޭ",
          "pending_division_setup": "ޑިވިޜަން އަދި ތައްޔާރުކުރެވިފައެއް ނުވޭ"
        }
      }
    },
    "reasonCode": {
      "title": "ސަބަބުގެ ކޯޑްތައް",
      "description": "މި ނިޒާމުގެ ކޮންމެ އިސްތިސްނާއެއް ރެކޯޑްކުރެވޭ ކަނޑައެޅިފައިވާ ބަސްތައް.",
      "set": "ސަބަބުގެ ސެޓް",
      "code": "ކޯޑް",
      "label": "ލޭބަލް",
      "requires": "ބޭނުންވަނީ",
      "note": "ނޯޓް",
      "attachment": "އެޓޭޗްމަންޓް",
      "requiresNote": "ނޯޓެއް ބޭނުންވެއެވެ",
      "requiresNoteHint": "ތަފްޞީލެއް ނެތި މާނައެއް ނުކުރާ ސަބަބުތަކަށް.",
      "requiresAttachment": "އެޓޭޗްމަންޓެއް ބޭނުންވެއެވެ",
      "requiresAttachmentHint": "އެހެން މީހަކު ލިޔުނު ލިޔުމެއްގެ މައްޗަށް ބިނާވާ ސަބަބުތަކަށް.",
      "cause": "ސަބަބުގެ ބައި",
      "causeHint": "ތަޙުލީލަށް އިޚްތިޔާރީ ބައެއް، މިސާލަކަށް ސަޕްލަޔަރު، އެތެރޭގެ، ސިސްޓަމް.",
      "sortOrder": "ތަރުތީބު",
      "origin": "އަސްލު",
      "system": "ސޮފްޓްވެއަރ",
      "tenant": "މި ޓެނަންޓް",
      "activeOnly": "ހަރަކާތްތެރި އެކަނި",
      "create": "އައު ސަބަބުގެ ކޯޑެއް",
      "createTitle": "އައު ސަބަބުގެ ކޯޑް",
      "createDescription": "ހޮވިފައިވާ ސެޓަށް އިތުރުކުރެވި، ތިޔަ ދެއްވާ ތާރީޚުން ފެށިގެން ބާރުގައި.",
      "newVersion": "އައު ވަރޜަނެއް",
      "supersedeTitle": "ސަބަބުގެ ކޯޑްގެ އައު ވަރޜަން",
      "supersedeDescription": "ކޯޑެއް ދޫކޮށްލެވެނީ އައު ވަރޜަނަކުން، ފޮހެލައިގެންނެއް ނޫން — ދެ އަހަރު ކުރީގެ ފަހަނައެޅުމަކުންވެސް އެ ކޯޑްގެ ނަން ބޭނުންކުރެއެވެ.",
      "supersedeHint": "މިހާރު ބާރުގައި އޮތް ވަރޜަން ފެށުނު ތާރީޚަށްފަހު ވާންޖެހެއެވެ.",
      "saved": "ސަބަބުގެ ކޯޑް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ސަބަބުގެ ކޯޑް ރައްކާއެއް ނުކުރެވުނު",
      "tableLabel": "ސަބަބުގެ ކޯޑްތައް",
      "emptyTitle": "މި ސެޓްގައި ސަބަބުގެ ކޯޑެއް ނެތް",
      "emptyDescription": "ސޮފްޓްވެއަރއާއެކު އަންނަ ކޯޑްތައް ޓެނަންޓް ތައްޔާރުކުރުމަށްފަހު ފެންނާނެއެވެ. މި ޓެނަންޓަށް ޚާއްޞަ އިސްތިސްނާތަކަށް އަމިއްލަ ކޯޑް އިތުރުކުރައްވާ.",
      "loadFailed": "ސަބަބުގެ ކޯޑްތައް ލޯޑެއް ނުވި"
    },
    "override": {
      "title": "މި ކޮންޓްރޯލް ފަހަނައަޅާ",
      "title2": "ފަހަނައެޅުމުގެ ރިޕޯޓް",
      "description": "ފަހަނައެޅުނު ކޮންމެ ކޮންޓްރޯލް ރޫލެއް، ދެވުނު ސަބަބާއި އެކަން ކުރި މީހާއާއެކު.",
      "auditNote": "މި ރިޕޯޓަކީ އޮޑިޓް ހެއްކެކެވެ. އެކްސްޕޯޓްކުރުމުން، ފުރަތަމަ ބައިޓް ފޮނުވުމުގެ ކުރިން ތިޔަބޭފުޅާގެ ނަމުގައި އެކްސްޕޯޓް ހާދިސާއެއް ރެކޯޑްވެއެވެ.",
      "absoluteTitle": "މި ކޮންޓްރޯލް ފަހަނައެއް ނޭޅޭނެ",
      "absoluteExplain": "މި ރޫލަކީ ފަހަނަނޭޅޭ ރޫލެކެވެ: ޓެނަންޓް އެޑްމިނިސްޓްރޭޓަރާއި ސަޕޯޓް ހިމެނޭގޮތުން އެއްވެސް ފަރާތަކަށް ފަހަނައެޅުމުގެ ފުރުޞަތެއް ނުދެއެވެ. މި މަސައްކަތް ރެކޯޑްކުރެވިއްޖެއެވެ.",
      "requiredAuthority": "މި ފަހަނައެޅުމަށް ބޭނުންވަނީ: {authority}.",
      "noActiveCodes": "ސަބަބުގެ ސެޓް {set} ގައި ހަރަކާތްތެރި ކޯޑެއް ނެތުމުން، ކޯޑެއް ކަނޑައެޅެންދެން މި ކޮންޓްރޯލް ފަހަނައެއް ނޭޅޭނެއެވެ.",
      "reason": "ފަހަނައެޅުމުގެ ސަބަބު",
      "confirm": "ފަހަނައަޅާ",
      "rule": "ރޫލް",
      "document": "ލިޔުން",
      "amount": "އަދަދު",
      "by": "ފަހަނައެޅީ",
      "at": "ވަގުތު",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "total": "މުއްދަތުގެ ފަހަނައެޅުންތައް",
      "totalHelp": "ދެ ތާރީޚް ދެމެދު ސަބަބަކާއެކު ފަހަނައެޅުނު ކޮންމެ ކޮންޓްރޯލް ރޫލެއް.",
      "breakdowns": "ގިނަވަނީ ކޮންތާކު",
      "byRule": "ރޫލުން",
      "byReason": "ސަބަބުން",
      "byActor": "މީހުންގެ ގޮތުން",
      "none": "ނެތް",
      "sources": {
        "matrix": "ބާރުގެ މެޓްރިކްސް",
        "permission": "ހުއްދަ",
        "remote": "ދުރުން ހުއްދަ ދެވިފައި"
      },
      "tableLabel": "ރޫލް ފަހަނައެޅުންތައް",
      "emptyTitle": "މި މުއްދަތުގައި ފަހަނައެޅުމެއް ނެތް",
      "emptyDescription": "ނުވަތަ އެއްވެސް ކޮންޓްރޯލެއް ފަހަނައަޅާފައެއް ނުވެއެވެ، ނުވަތަ ފަހަނައެޅި ވަގުތު ތާރީޚްތަކުގެ ތެރޭގައި ނުހިމެނެއެވެ.",
      "loadFailed": "ފަހަނައެޅުންތައް ލޯޑެއް ނުވި",
      "exportFailed": "އެކްސްޕޯޓް ނުހެދުނު"
    },
    "queues": {
      "title": "ރިކޮންސިލިއޭޝަން ކިޔޫތައް",
      "description": "ފަހަނައެޅުމަކުން ފަހަތުގައި ދޫކުރާ އެއްޗެއް. އިސްތިސްނާ ހުއްދައެވެ؛ ހަނދާންނެތުމެއް ނޫނެވެ.",
      "sla": "ނިންމަން {hours} ގަޑިއިރު",
      "escalatesTo": "މަޤާމު #{id} އަށް މައްޗަށް ފޮނުވެއެވެ",
      "inactive": "ހަރަކާތެއް ނެތް",
      "emptyTitle": "ކިޔޫއެއް ނެތް",
      "emptyDescription": "ކިޔޫތައް ކަނޑައަޅަނީ ސޮފްޓްވެއަރ އިން، އަދި ޓެނަންޓް ތައްޔާރުކުރުމަށްފަހު ފެންނާނެއެވެ.",
      "loadFailed": "ކިޔޫތައް ލޯޑެއް ނުވި"
    },
    "queueItem": {
      "description": "އެންމެ ދުވަސްވީ ފަހަނައެޅުން ކުރިން — ކިޔޫގައި މަސައްކަތްކުރާ މީހަކަށް ބޭނުންވާ ތަރުތީބު.",
      "subject": "ކަން",
      "amount": "އަދަދު",
      "age": "ދުވަސް",
      "days": "{count} ދުވަސް",
      "due": "ދައްކަންޖެހޭ",
      "breached": "{count} ކަމެއް އެސް.އެލް.އޭ ފަހަނައަޅާފައި.",
      "olderThan": "މިއަށްވުރެ ދުވަސްވީ (ދުވަސް)",
      "olderThanHint": "މިއަށްވުރެ ގިނަ ދުވަހު ހުޅުވިފައި ހުރި ކަންކަން އެކަނި ދައްކާ.",
      "resolve": "ނިންމާ",
      "resolveTitle": "ކިޔޫގެ ކަމެއް ނިންމާ",
      "resolved": "ކަން ނިމިއްޖެ",
      "disposition": "ނިންމުން",
      "dispositionHint": "ރަނގަޅުކޮށް ބަންދުކުރެވުނީތޯ، ނުވަތަ އޮތްގޮތަށް ބަލައިގަނެވުނީތޯ. އޮޑިޓަރަކު މި ދޭތި ކިޔަނީ ދެގޮތަކަށެވެ.",
      "dispositions": {
        "resolved": "ނިމިއްޖެ",
        "written_off": "ދޫކޮށްލެވިއްޖެ"
      },
      "dispositionHints": {
        "resolved": "އަސްލު މައްސަލަ ރަނގަޅުކުރެވިއްޖެ.",
        "written_off": "އޮތްގޮތަށް ބަލައިގަނެވިއްޖެ؛ ރަނގަޅުކުރުމެއް ނުކުރެވެއެވެ."
      },
      "reason": "ސަބަބުގެ ކޯޑް",
      "reasonHint": "އިޚްތިޔާރީ. އެގޮތަށް ރެކޯޑްކުރެވެއެވެ — ނިންމުންތަކަށް އަދި ކަނޑައެޅިފައިވާ ސެޓެއް ނެތެވެ.",
      "noteHint": "ކުރެވުނު ކަންތައް، ފަހުން މި ކިޔާ މީހަކަށް.",
      "backToQueues": "ހުރިހާ ކިޔޫއެއް",
      "tableLabel": "ކިޔޫގެ ކަންކަން",
      "emptyTitle": "މި ކިޔޫގައި އެއްޗެއް ނެތް",
      "emptyDescription": "ކޮންޓްރޯލެއް ފަހަނައެޅުމުން ނުވަތަ މި ކިޔޫއަށް އިސްތިސްނާއެއް އުފެދުމުން ކަންކަން އާދެއެވެ.",
      "loadFailed": "ކިޔޫގެ ކަންކަން ލޯޑެއް ނުވި",
      "statuses": {
        "open": "ހުޅުވިފައި",
        "in_progress": "ކުރިއަށްދަނީ",
        "resolved": "ނިމިފައި",
        "written_off": "ދޫކޮށްލެވިފައި",
        "escalated": "މައްޗަށް ފޮނުވިފައި"
      }
    },
    "queue": {
      "opcal": {
        "forced_close": "ބާރުއަޅައިގެން ބަންދުކުރެވުނު ވިޔަފާރި ދުވަސްތައް"
      },
      "fx": {
        "rate_holds": "މުރާޖަޢާއަށް މަޑުޖައްސާލެވިފައިވާ އެފްއެކްސް ރޭޓްތައް"
      },
      "authority": {
        "unratified": "ތަޞްދީޤުނުވާ ކުއްލި ފާސްކުރުންތައް",
        "orphaned_tasks": "ހިފާނެ މީހަކު ނެތް ފާސްކުރުމުގެ މަސައްކަތްތައް"
      },
      "interco": {
        "transactions": "ކުންފުނިތަކާ ދެމެދު ދިގުދެމިފައިވާ ޓްރާންޒެކްޝަންތައް"
      },
      "close": {
        "overdue_tasks": "މުއްދަތު ބަންދުކުރުމުގެ ވަގުތު ހަމަވެފައިވާ މަސައްކަތްތައް"
      },
      "hr": {
        "exit_review": "ކްލިއަރެންސް ނުނިމި ވަކިވުންތައް"
      },
      "pms": {
        "oversell": "ބުކިންގ މިންވުރެ ބޮޑުކުރުމުގެ އޯވަރައިޑްތައް",
        "credit": "ކްރެޑިޓް ލިމިޓް އޯވަރައިޑްތައް",
        "allowance": "އެލަވަންސް އޯވަރައިޑްތައް",
        "checkout": "ޗެކްއައުޓް އޯވަރައިޑްތައް",
        "night_audit": "ނައިޓް އޯޑިޓްގެ އިސްތިސްނާތައް",
        "commission": "ކޮމިޝަން އޯވަރައިޑްތައް",
        "folio": {
          "unrouted": "ރައުޓު ނުކުރެވޭ ފޮލިއޯ ޗާޖުތައް"
        }
      },
      "procurement": {
        "match_exception": "އިންވޮއިސް މެޗްކުރުމުގެ އިސްތިސްނާތައް"
      },
      "pos": {
        "cash_variance": "ޓިލް ފައިސާގެ ތަފާތުތައް",
        "anomaly": "ޕޮއިންޓް އޮފް ސޭލްގެ ޒަހަމްތައް"
      },
      "gl": {
        "suspense": "ސަސްޕެންސްގައި ހުރި އައިޓަމްތައް",
        "accrual_reversal": "ސަމާލުކަމަށް ބޭނުންވާ އެކްރޫއަލް ރިވާސަލްތައް",
        "completeness": "ޕޯސްޓިންގ ފުރިހަމަކަން ފެއިލްވުންތައް"
      },
      "qms": {
        "quarantine_overdue": "ވަގުތު ހަމަވެފައިވާ ކުއަރެންޓިންތައް",
        "capa_overdue": "ވަގުތު ހަމަވެފައިވާ އިސްލާހީ އަމަލުތައް"
      },
      "ap": {
        "signals": "އިންވޮއިސްގެ ޒަހަމް ބަލާ ސިގްނަލްތައް",
        "payment_exceptions": "ޕޭމަންޓްގެ އިސްތިސްނާތައް"
      },
      "roster": {
        "working_time_review": "މަސައްކަތް ވަގުތު ރިވިއު ކުރުންތައް"
      },
      "treasury": {
        "wallet_funding": "ފަންޑިންގ ތްރެޝޯލްޑުގެ ދަށުގައި ހުރި ވޮލެޓްތައް",
        "mandate_panel": "މެންޑޭޓް ޤަވާޢިދު ފުރިހަމަނުކުރެވޭ ޕެނަލްތައް",
        "wallet_leaver": "ދޫކޮށްލި މީހަކު ހިފަހައްޓާ ވޮލެޓްތައް",
        "wallet_dormant": "ބޭކާރުވެފައިވާ ވޮލެޓްތައް"
      },
      "inventory": {
        "valuation_break": "އިންވެންޓަރީ ވެލިއުއޭޝަންގެ ބްރޭކްތައް"
      },
      "projects": {
        "chargeability": "ޗާޖްކުރެވޭ ވަގުތުގެ އޯވަރައިޑްތައް",
        "retention": "ރިޓެންޝަން އޯވަރައިޑްތައް"
      },
      "ai": {
        "routed_actions": "ރިވިއު ކުރުމަށް ފޮނުވާފައިވާ އޭއައި އަމަލުތައް"
      },
      "service": {
        "dispatch": "ޑިސްޕެޗް އޯވަރައިޑްތައް",
        "billing": "ސަރވިސް ބިލިންގ އޯވަރައިޑްތައް",
        "goodwill": "ގުޑްވިލް އޯވަރައިޑްތައް"
      },
      "payroll": {
        "statutory_review": "ޤާނޫނީ ޕޭރޯލް ރިވިއުތައް",
        "variance_review": "ޕޭރޯލް ތަފާތު ރިވިއުތައް",
        "anomaly_review": "ޕޭރޯލް ޒަހަމް ރިވިއުތައް"
      },
      "sales": {
        "discount_overrides": "ޑިސްކައުންޓް އޯވަރައިޑްތައް",
        "margin_overrides": "މާޖިން ފްލޯރ އޯވަރައިޑްތައް"
      }
    },
    "org": {
      "period": {
        "close_with_blockers": {
          "title": "ހުއްޓުވުންތައް ބާކީ ހުއްޓައި މުއްދަތު ބަންދުކުރުން",
          "desc": "ރަޖިސްޓްރީވެފައިވާ ބަންދުކުރުމުގެ ބެލުމަކުން މަސައްކަތް ބާކީ ހުރިކަމަށް ބުނާހާ ހިނދަކު މުއްދަތެއް ބަންދެއް ނުކުރެވޭނެއެވެ."
        },
        "permanent_close_is_final": {
          "title": "ދާއިމީ ބަންދުކުރުމަކީ ނިމުމެއް",
          "desc": "ދާއިމީކޮށް ބަންދުކުރެވިފައިވާ މުއްދަތެއް އެއްވެސް މީހަކަށް ދުވަހަކުވެސް އަލުން ނުހުޅުވޭނެއެވެ."
        },
        "reopen_authority": {
          "title": "މުއްދަތު އަލުން ހުޅުވުމުގެ ބާރު",
          "desc": "ބަންދުކުރެވިފައިވާ މުއްދަތެއް އަލުން ހުޅުވުމަށް ކަނޑައެޅިފައިވާ ބާރާއި ކަނޑައެޅިފައިވާ ސަބަބެއް ބޭނުންވެއެވެ."
        }
      },
      "location": {
        "address_invalid": {
          "title": "ޤައުމުގެ ޤަވާޢިދުތަކާ އެޑްރެސް ދިމާނުވުން",
          "desc": "ޤައުމުން އެޑްރެސް ބެލުން ލާޒިމުކުރެއެވެ. ދިމާނުވާ އެޑްރެހެއް ދޫކުރުމުގެ ސަބަބަކާއެކު ބަލައިގަނެވިދާނެއެވެ."
        }
      },
      "company": {
        "activate_without_pack": {
          "title": "ޤައުމުގެ ޕެކް ހަރަކާތްތެރި ނުވަނީސް ހަރަކާތްތެރިކުރުން",
          "desc": "ޤައުމުގެ ޕެކް ހަރަކާތްތެރި ނުވާ އިޚްތިޞާޞެއްގައި ކުންފުންޏެއް ހަރަކާތްތެރި ނުކުރެވޭނެއެވެ — އެއްވެސް އެއްޗަކުން އޭގެ ޓެކްސް ނުނެރެވޭނެއެވެ."
        },
        "post_after_dissolution": {
          "title": "އުވާލުމަށްފަހު ޕޯސްޓްކުރުން",
          "desc": "އުވާލެވިފައިވާ ކުންފުންޏަކުން އިތުރު ޕޯސްޓިންގއެއް ބަލައެއް ނުގަނެއެވެ."
        }
      },
      "position": {
        "headcount_exceeded": {
          "title": "ޢަދަދު ފަހަނައެޅުން",
          "desc": "އެދިފައިވާ މުއްދަތަށް މަޤާމު މިހާރުވެސް ފުރިފައެވެ."
        },
        "assign_to_frozen": {
          "title": "ހުއްޓިފައިވާ މަޤާމަކަށް ހަވާލުކުރުން",
          "desc": "ހުއްޓިފައިވާ މަޤާމަކުން މިހާރު ހުރި މީހާއަށް ބާރު ދެމިހުރެއެވެ، އެކަމަކު އައު ހަވާލުކުރުމެއް ބަލައެއް ނުގަނެއެވެ."
        },
        "cycle": {
          "title": "ރިޕޯޓިންގ ލައިންގެ ސައިކަލެއް",
          "desc": "މަޤާމަކުން އަމިއްލައަށް، ސީދާ ނުވަތަ ސިލްސިލާއަކުން، ރިޕޯޓެއް ނުކުރެވޭނެއެވެ."
        }
      },
      "assignment": {
        "multiple_primary": {
          "title": "އެކަކަށްވުރެ ގިނަ މައި މަޤާމު",
          "desc": "މުވައްޒަފަކު އެއްފަހަރާ ހިފަހައްޓަނީ އެއް އަޞްލު މަޤާމެވެ؛ ފުށުއަރާ މަޤާމުތަކަކީ ދެވަނަ ނުވަތަ ބަދަލުގައި ހުންނަ މަޤާމުތަކެވެ."
        }
      }
    },
    "authority": {
      "chain_unresolvable": {
        "title": "ފާސްކުރުމުގެ ސިލްސިލާ ނުނެރެވުން",
        "desc": "ފިޔަވަޅަކުން އެއްވެސް މީހަކަށް ނުނެރެވުމުން، ލިޔުން ހުއްޓޭނީ އެއްވެސް މީހަކު ނުހިފާ ކިޔޫއެއްގައެވެ."
      },
      "self_approval": {
        "title": "އަމިއްލައަށް ފާސްކުރުން",
        "desc": "ހުށަހެޅި މީހާއަކީ ފާސްކުރާ މީހާވެސްމެއެވެ. ހުއްދަވަނީ ރޫލުން ބުނާ ހާލަތުގައި އެކަނި، އަދި އަބަދުވެސް ސަބަބަކާއެކުއެވެ."
      },
      "delegation_exceeds": {
        "title": "ބާރު ދޭ ފަރާތުގެ ބާރު ފަހަނައަޅާ ހަވާލުކުރުން",
        "desc": "ހަވާލުކުރުމަކުން ބާރު ހަނިކުރެވިދާނެ؛ ދުވަހަކުވެސް ފުޅައެއް ނުކުރެވޭނެއެވެ."
      },
      "emergency_unratified": {
        "title": "ތަޞްދީޤުނުވާ ކުއްލި ފާސްކުރުމެއް ބާކީ",
        "desc": "ކުރީގެ ކުއްލި ފާސްކުރުމެއް ތަޞްދީޤުނުވާތީ، އިތުރު އެއްޗެއް ނުނެގޭނެއެވެ."
      },
      "matrix_dual_control": {
        "title": "މެޓްރިކްސްގެ ދެ މީހުންގެ ކޮންޓްރޯލް",
        "desc": "މެޓްރިކްސް ވަރޜަނެއް ހުށަހެޅި މީހާ، އެ ބާރުގައި ހިންގާ މީހަކަށް ވެގެންނުވާނެއެވެ."
      }
    },
    "opcal": {
      "day": {
        "close_with_blockers": {
          "title": "ހުއްޓުވުންތަކާއެކު ވިޔަފާރި ދުވަސް ބަންދުކުރުން",
          "desc": "މޮޑިއުލަކުން މަސައްކަތް ބާކީ ހުރިކަމަށް ބުނެއެވެ. އެހެންވިޔަސް ބަންދުކުރުން ރެކޯޑްވެ، ކިޔޫ އައިޓަމެއް ހުޅުވެއެވެ."
        },
        "reopen": {
          "title": "ވިޔަފާރި ދުވަސް އަލުން ހުޅުވުން",
          "desc": "ބަންދުކުރެވިފައިވާ ދުވަހެއް އަލުން ހުޅުވުމަކީ މީހަކު ކުރިން ތަޞްދީޤުކޮށްފައިވާ ރެކޯޑެއް އަލުން ހުޅުވުމެވެ."
        },
        "outside_period": {
          "title": "ފިސްކަލް މުއްދަތުން ބޭރު ވިޔަފާރި ދުވަސް",
          "desc": "ވިޔަފާރި ދުވަހެއް ނުހިމެނޭ ފިސްކަލް މުއްދަތަކަށް އެ ދުވަސް ނުހުޅުވޭނެއެވެ."
        }
      }
    },
    "fx": {
      "rate": {
        "tolerance_breach": {
          "title": "ޓޮލަރެންސުން ބޭރު ބަދަލު ރޭޓް",
          "desc": "މި ޖޯޑަށް ކަނޑައެޅިފައިވާ މިންވަރަށްވުރެ ބޮޑަށް ރޭޓް ބަދަލުވުމުން، ބޭނުންކުރުމުގެ ބަދަލުގައި މަޑުޖައްސާލެވެއެވެ."
        }
      }
    },
    "numbering": {
      "void_reason": {
        "title": "ކަނޑައެޅިފައިވާ ސަބަބަކާނުލައި ބާޠިލުކުރުން",
        "desc": "ލިޔުމުގެ ނަންބަރެއް ބާޠިލުކުރުމަށް ނަންބަރިންގގެ ސަބަބުގެ ސެޓުން ކޯޑެއް ބޭނުންވެއެވެ."
      },
      "gapless_breach": {
        "title": "ފަޅުނުޖެހޭ ސިލްސިލާއެއްގައި ފަޅުކަމެއް",
        "desc": "ފަޅުނުޖެހޭ ކަމަށް ކަނޑައެޅިފައިވާ ސިލްސިލާއަކުން ނަންބަރެއް ދޫކޮށްނުލެވޭނެއެވެ."
      }
    },
    "tax": {
      "jurisdiction_missing": {
        "title": "ޓެކްސް އިޚްތިޞާޞެއް ނެތް",
        "desc": "މި ލިޔުމަށް އެއްވެސް އެއްޗަކުން އިޚްތިޞާޞެއް ނުނެރެވޭތީ، ޓެކްސް ނުނެރެވޭނެއެވެ."
      }
    },
    "gl": {
      "division_required": {
        "title": "މި އެކައުންޓަށް ޑިވިޜަނެއް ބޭނުންވެއެވެ",
        "desc": "އެކައުންޓްގެ ބައިތަކުގެ ސިޔާސަތުން ކޮންމެ ލައިނަކަށް ޑިވިޜަނެއް ލާޒިމުކުރެއެވެ."
      },
      "suspense": {
        "write_off": {
          "title": "ސަސްޕެންސް ރައިޓްއޮފް"
        }
      }
    },
    "rules": {
      "override_without_authority": {
        "title": "ބާރެއް ނެތި ފަހަނައެޅުން",
        "desc": "ރޫލް ފަހަނައެޅުމަށް ބޭނުންވާ ބާރު އެ މީހެއްގެ އަތުގައި ނެތެވެ."
      }
    },
    "party": {
      "merge": {
        "cross_kind": {
          "title": "ޕާޓީ ބާވަތްތަކުގެ ދޭތެރެއިން މަރޖްކުރުން"
        },
        "both_have_customers": {
          "title": "ދެ ޕާޓީގައިވެސް ކަސްޓަމަރު ރެކޯޑް ހުރިއިރު މަރޖްކުރުން"
        },
        "low_confidence": {
          "title": "ޔަޤީންކަމުގެ ތްރެޝޯލްޑުގެ ދަށުން މަރޖްކުރުން"
        }
      },
      "consent": {
        "evidence_missing": {
          "title": "ހެކިނެތި ރެކޯޑްކުރެވޭ ރުހުން"
        },
        "purpose_inactive": {
          "title": "ބަންދުވެފައިވާ މަޤްޞަދަކަށް ރުހުން"
        }
      },
      "suppression": {
        "release": {
          "title": "ހުއްޓުވާފައިވާ ގުޅުމެއް ދޫކުރުން"
        }
      },
      "dsr": {
        "close_without_tasks": {
          "title": "ޓާސްކުތައް ނުނިމި ޑޭޓާ ސަބްޖެކްޓް އެދުން ބަންދުކުރުން"
        },
        "erasure_without_verification": {
          "title": "ދެނެގަތުމެއް ނެތި ފޮހެލުން"
        },
        "extension_beyond_policy": {
          "title": "ޕޮލިސީއަށްވުރެ ސުންގަޑި އިތުރުކުރުން"
        }
      }
    },
    "rvm": {
      "snapshotNotToday": {
        "title": "މިއަދަށް ސްނެޕްޝޮޓް ނަގާފައެއް ނުވޭ"
      },
      "forecastUnexplainedVariance": {
        "title": "ތަފްސީލެއް ނެތް ފޯކާސްޓް ތަފާތު"
      },
      "quoteBelowHurdle": {
        "title": "ހާޑަލް ރޭޓްގެ ދަށުން ކޯޓް"
      }
    },
    "qms": {
      "receipt": {
        "inspection_required": {
          "title": "ބޭނުންވާ އިންސްޕެކްޝަނެއް ނެތް ރިސީޓް"
        }
      },
      "inspection": {
        "inspector_independence": {
          "title": "އިންސްޕެކްޓަރު މަސައްކަތުން ވަކިއެއް ނޫން"
        },
        "concession_required": {
          "title": "ފެއިލްވި އިންސްޕެކްޝަން ކޮންސެޝަނުން ގަބޫލުކުރުން"
        }
      },
      "capa": {
        "effectiveness_required": {
          "title": "އަސަރުވެރިކަން ބެލުމެއް ނެތި އިސްލާހީ އަމަލު ބަންދުކުރުން"
        }
      }
    },
    "hr": {
      "assignment": {
        "without_permit": {
          "title": "ސައްހަ ވަޒީފާ ހުއްދައެއް ނެތި އެސައިންމަންޓް"
        }
      },
      "permit": {
        "quota_exceeded": {
          "title": "ވަޒީފާ ހުއްދައިގެ ކޯޓާއަށްވުރެ ގިނަ"
        },
        "medical_lapsed": {
          "title": "ހުއްދައިގެ މެޑިކަލް ކްލިއަރެންސް ހަމަވެފައި"
        }
      },
      "leave": {
        "blackout": {
          "title": "ބްލެކްއައުޓް މުއްދަތުގައި ލީވް"
        },
        "coverage_minimum": {
          "title": "މަދުވެގެންވާ ކަވަރުގެ ދަށުން ލީވް"
        },
        "below_statutory_minimum": {
          "title": "ޤާނޫނީ މަދުވެގެންވާ ލީވްގެ ދަށުން"
        }
      },
      "exit": {
        "clearance_incomplete": {
          "title": "ކްލިއަރެންސް ނުނިމި ވަކިވުން"
        }
      }
    },
    "reporting": {
      "outputUncertifiedCertifiedChannel": {
        "title": "ސެޓިފައިނުކުރެވޭ އައުޓްޕުޓް ސެޓިފައިކުރެވޭ ޗެނަލްއަކުން ފޮނުވުން"
      }
    },
    "cost": {
      "cycle": {
        "leakage_required": {
          "title": "ލީކޭޖް ބެލުމެއް ނެތް އެލޮކޭޝަން ސައިކަލް"
        }
      },
      "run": {
        "driver_quantity_required": {
          "title": "ޑްރައިވަރު ކޮންޓިޓީ ނެތް ކޮސްޓް ރަން"
        }
      }
    },
    "eam": {
      "permit": {
        "sod_breach": {
          "title": "ވަޒީފާ ހުއްދައިން ވާޖިބުތައް ވަކިކުރުމުގެ ޤަވާޢިދު ގެއްލުން"
        }
      },
      "asset": {
        "inspection_overdue": {
          "title": "އެސެޓް އިންސްޕެކްޝަންގެ ވަގުތު ހަމަވެފައި"
        }
      },
      "workorder": {
        "no_permit": {
          "title": "ހުއްދައެއް ނެތި ވޯކް އޯޑަރު ފެށުން"
        }
      },
      "meter": {
        "reading_regression": {
          "title": "މީޓަރ ރީޑިންގ ކުރީ ރީޑިންގއަށްވުރެ ދަށް"
        }
      }
    },
    "treasury": {
      "beneficiary": {
        "cooling_off": {
          "title": "ކޫލިންގ އޮފް މުއްދަތުގައިވާ ބެނެފިޝަރީއަކަށް ޕޭމަންޓް"
        },
        "unverified": {
          "title": "ވެރިފައިނުކުރެވޭ ބެނެފިޝަރީއަކަށް ޕޭމަންޓް"
        },
        "blocked": {
          "title": "ބްލޮކްކުރެވިފައިވާ ބެނެފިޝަރީއަކަށް ޕޭމަންޓް"
        }
      },
      "wallet": {
        "limit_exceeded": {
          "title": "ވޮލެޓް ލިމިޓް ހަމަވުން"
        },
        "evidence_required": {
          "title": "ހެކިނެތް ވޮލެޓް ޚަރަދު"
        },
        "category_blocked": {
          "title": "ބްލޮކްކުރެވިފައިވާ ކެޓަގަރީއެއްގައި ވޮލެޓް ޚަރަދު"
        },
        "count_overdue": {
          "title": "ވޮލެޓް ގުނުމުގެ ވަގުތު ހަމަވެފައި"
        },
        "recount_required": {
          "title": "ވޮލެޓް އަލުން ގުނަންޖެހޭ"
        }
      },
      "debt": {
        "limit_exceeded": {
          "title": "ދަރަނީގެ ލިމިޓް ހަމަވުން"
        },
        "covenant_breached": {
          "title": "ދަރަނީގެ ކޮވެނެންޓް ގެއްލުން"
        }
      },
      "transfer": {
        "duplicate_instruction": {
          "title": "ޓްރާންސްފަރު އިރުޝާދު ދެވަނަ ފަހަރަށް"
        },
        "no_mandate": {
          "title": "މެންޑޭޓެއް ނެތް ޓްރާންސްފަރު"
        },
        "insufficient_signatures": {
          "title": "ސޮއި ނުފުރޭ ޓްރާންސްފަރު"
        },
        "exceeds_available": {
          "title": "ޓްރާންސްފަރު ހުރި ބެލެންސްއަށްވުރެ ބޮޑު"
        }
      }
    },
    "pos": {
      "allergen": {
        "declared_conflict": {
          "title": "އިއުލާންކުރެވިފައިވާ އެލަރޖީއާ ދިމާނުވާ އޯޑަރު"
        }
      },
      "session": {
        "blind_count_witness": {
          "title": "ހެކިވެރިއެއް ނެތް ބްލައިންޑް ކައުންޓް"
        },
        "variance_beyond_tolerance": {
          "title": "ސެޝަން ތަފާތު ޓޮލަރެންސްއަށްވުރެ ބޮޑު"
        }
      },
      "day": {
        "open_check": {
          "title": "ދުވަހުގެ ނިމުމުގައި ހުޅުވިފައިވާ ޗެކް"
        },
        "open_drawer": {
          "title": "ދުވަހުގެ ނިމުމުގައި ހުޅުވިފައިވާ ކޭޝް ޑްރޯ"
        }
      },
      "menu": {
        "publish_incomplete": {
          "title": "ނުފުރިހަމަ މެނޫ ޕަބްލިޝްކުރުން"
        }
      },
      "sale": {
        "void_after_settlement": {
          "title": "ސެޓްލްމަންޓަށް ފަހު ވޮއިޑް"
        },
        "refund_without_original": {
          "title": "އަސްލު ވިއްކުމެއް ނެތް ރީފަންޑު"
        }
      },
      "discount": {
        "beyond_operator_limit": {
          "title": "އޮޕަރޭޓަރުގެ ލިމިޓަށްވުރެ ބޮޑު ޑިސްކައުންޓް"
        }
      },
      "price": {
        "manual_override": {
          "title": "އަތުން ކުރާ ޕްރައިސް އޯވަރައިޑް"
        }
      },
      "tender": {
        "credit_limit": {
          "title": "ކްރެޑިޓް ލިމިޓަށްވުރެ ބޮޑު ޓެންޑަރ"
        }
      },
      "instrument": {
        "balance_short": {
          "title": "އިންސްޓްރޫމަންޓް ބެލެންސް މަދު"
        }
      },
      "age": {
        "restricted_item": {
          "title": "އުމުރަށް ހުރަސްކުރެވިފައިވާ އައިޓަމް ވިއްކުން"
        }
      }
    },
    "sales": {
      "discount": {
        "over_policy": {
          "title": "ޕޮލިސީއަށްވުރެ ބޮޑު ޑިސްކައުންޓް"
        }
      },
      "margin": {
        "below_floor": {
          "title": "މާޖިން ފްލޯރގެ ދަށުން"
        }
      }
    },
    "assets": {
      "impairment": {
        "reversal_cap": {
          "title": "އިމްޕެއަރމަންޓް ރިވާސަލް ކެޕްއަށްވުރެ ބޮޑު"
        }
      }
    },
    "service": {
      "workorder": {
        "statutory_skill_missing": {
          "title": "ބޭނުންވާ ޤާނޫނީ ސްކިލެއް ނެތް ވޯކް އޯޑަރު"
        },
        "skill_not_held": {
          "title": "ޓެކްނިޝަނަށް ބޭނުންވާ ސްކިލް ނެތް"
        },
        "outside_working_time": {
          "title": "މަސައްކަތް ވަގުތުން ބޭރުގެ ވޯކް އޯޑަރު"
        },
        "close_unbilled": {
          "title": "ބިލްނުކުރެވި ވޯކް އޯޑަރު ބަންދުކުރުން"
        }
      },
      "goodwill": {
        "beyond_threshold": {
          "title": "ތްރެޝޯލްޑަށްވުރެ ބޮޑު ގުޑްވިލް"
        }
      }
    },
    "projects": {
      "baseline": {
        "immutable": {
          "title": "ފާސްކުރެވިފައިވާ ބޭސްލައިނަށް ބަދަލު"
        }
      },
      "cost": {
        "no_approved_baseline": {
          "title": "ފާސްކުރެވިފައިވާ ބޭސްލައިނެއް ނެތް ޚަރަދު"
        }
      },
      "variation": {
        "unapproved_scope": {
          "title": "ފާސްނުކުރެވޭ ވެރިއޭޝަނެއްގެ މަސައްކަތް"
        }
      },
      "retention": {
        "early_release": {
          "title": "ރިޓެންޝަން އަވަހަށް ދޫކުރުން"
        }
      },
      "allocation": {
        "over_capacity": {
          "title": "ކެޕޭސިޓީއަށްވުރެ ބޮޑު އެލޮކޭޝަން"
        }
      }
    },
    "device": {
      "content": {
        "stale": {
          "title": "ޑިވައިސްގެ ކޮންޓެންޓް ކުރީގެ"
        }
      },
      "enrolment": {
        "clone_detected": {
          "title": "ކްލޯންކުރެވިފައިވާ ޑިވައިސް ފެނުނު"
        }
      },
      "sync": {
        "operator_not_permitted": {
          "title": "ހުއްދައެއް ނެތް އޮޕަރޭޓަރެއްގެ ސިންކް"
        }
      },
      "offline": {
        "policy_refuses": {
          "title": "އޮފްލައިން ޕޮލިސީން އަމަލު ދެކޮޅުހެދި"
        }
      }
    },
    "pricing": {
      "precedence_dual_control": {
        "title": "ޕްރައިސް ޕްރެސިޑެންސްއަށް ދެ ފަރާތެއްގެ ކޮންޓްރޯލް ބޭނުން"
      }
    },
    "procurement": {
      "supplier": {
        "not_qualified": {
          "title": "ސަޕްލައަރ ކޮލިފައިނުވޭ"
        },
        "document_expired": {
          "title": "ސަޕްލައަރގެ ޑޮކިއުމަންޓް ހަމަވެފައި"
        },
        "screening_match": {
          "title": "ސަޕްލައަރ ސްކްރީނިންގ މެޗް"
        }
      },
      "contract": {
        "over_commitment": {
          "title": "ކޮންޓްރެކްޓް ކޮމިޓްމަންޓަށްވުރެ ބޮޑު އޯޑަރު"
        }
      },
      "match": {
        "cumulative_over_invoice": {
          "title": "އޯޑަރަށްވުރެ ބޮޑަށް ޖުމްލަ އިންވޮއިސް"
        },
        "duplicate_invoice": {
          "title": "ސަޕްލައަރ އިންވޮއިސް ދެވަނަ ފަހަރަށް"
        }
      },
      "grn": {
        "shelf_life_short": {
          "title": "ޝެލްފް ލައިފް ކުރު މުދާ ބަލައިގަތުން"
        }
      },
      "amendment": {
        "crosses_band": {
          "title": "ފާސްކުރުމުގެ ބޭންޑެއް ފަހަނައަޅާ އެމެންޑްމަންޓް"
        }
      },
      "rfq": {
        "evaluator_conflict": {
          "title": "ކޯޓް ބަލާ މީހާގެ މަސްލަހަތުގެ ކޮންފްލިކްޓް"
        },
        "sealed_before_deadline": {
          "title": "ސުންގަޑީގެ ކުރިން ސީލްކުރެވިފައިވާ ބިޑު ހުޅުވުން"
        }
      }
    },
    "bankrec": {
      "continuity": {
        "break": {
          "title": "ސްޓޭޓްމަންޓް ކޮންޓިނިއުޓީ ބްރޭކް"
        }
      },
      "match_set": {
        "unbalanced": {
          "title": "މެޗް ސެޓް ބެލެންސް ނުވޭ"
        }
      },
      "session": {
        "uncertified": {
          "title": "ރިކޮންސިލިއޭޝަން ސެޝަން ސެޓިފައިނުކުރެވޭ"
        },
        "certifier_is_matcher": {
          "title": "ސެޓިފައިކުރާ މީހާ މެޗްކުރި މީހާ"
        }
      }
    },
    "expense": {
      "claim": {
        "policy_breach": {
          "title": "ޚަރަދު ދައުވާ ޕޮލިސީ ގެއްލުވާ"
        }
      }
    },
    "payroll": {
      "varianceUnexplained": {
        "title": "ތަފްސީލެއް ނެތް ޕޭރޯލް ތަފާތު"
      },
      "statutoryRuleLocalOverride": {
        "title": "ޤާނޫނީ ޕޭރޯލް ޤަވާޢިދުގެ ލޯކަލް އޯވަރައިޑް"
      },
      "anomalyUnacknowledged": {
        "title": "ޕޭރޯލް ޒަހަމް އެކްނޮލެޖްނުކުރެވޭ"
      }
    },
    "mfg": {
      "eco": {
        "open_dispositions": {
          "title": "ހުޅުވިފައިވާ ޑިސްޕޮސިޝަންތަކާއެކު ބަދަލު އޯޑަރު"
        }
      },
      "order": {
        "tool_unavailable": {
          "title": "ޓޫލިންގ ނެތް ޕްރޮޑަކްޝަން އޯޑަރު"
        }
      },
      "settlement": {
        "short_close": {
          "title": "އައުޓްޕުޓްއަށް ކުރުކޮށް ސެޓްލްކުރެވޭ އޯޑަރު"
        }
      },
      "material": {
        "over_issue_warn": {
          "title": "ރޭވިފައިވާ ކޮންޓިޓީއަށްވުރެ ބޮޑަށް މެޓީރިއަލް ދިނުން (އިންޒާރު)"
        },
        "over_issue": {
          "title": "ރޭވިފައިވާ ކޮންޓިޓީއަށްވުރެ ބޮޑަށް މެޓީރިއަލް ދިނުން"
        },
        "substitute_undeclared": {
          "title": "އިއުލާނުނުކޮށް މެޓީރިއަލް ބަދަލުކުރުން"
        }
      }
    },
    "close": {
      "task": {
        "blocked": {
          "title": "ކްލޯޒް ޓާސްކް ބްލޮކްކުރެވިފައި"
        },
        "not_ready": {
          "title": "ކްލޯޒް ޓާސްކް ތައްޔާރެއް ނޫން"
        },
        "accept": {
          "title": "ހުޅުވިފައިވާ އައިޓަމްތަކާއެކު ކްލޯޒް ޓާސްކް ގަބޫލުކުރުން"
        }
      },
      "run": {
        "certifier_not_sole_preparer": {
          "title": "ސެޓިފައިކުރި މީހާ އެކަނި ތައްޔާރުކުރި މީހާ"
        }
      }
    },
    "ap": {
      "bank_detail": {
        "cooling_off": {
          "title": "ރަނގަޅުކުރެވިފައިވާ ބޭންކް ތަފްސީލަށް ޕޭމަންޓް"
        }
      },
      "invoice": {
        "fraud_signal": {
          "title": "ޖާލުސާޒީގެ ސިގްނަލް ހުރި އިންވޮއިސް"
        }
      }
    },
    "roster": {
      "working_time": {
        "statutory_breach": {
          "title": "ޤާނޫނީ މަސައްކަތް ވަގުތު ގެއްލުން"
        },
        "house_breach": {
          "title": "ކުންފުނީގެ މަސައްކަތް ވަގުތު ޤަވާޢިދު ގެއްލުން"
        }
      },
      "publish": {
        "unfilled_open_lines": {
          "title": "ފުރާފައިނުވާ ލައިންތަކާއެކު ރޮސްޓަރު ޕަބްލިޝްކުރުން"
        }
      }
    },
    "crm": {
      "campaign": {
        "send_without_purpose_consent": {
          "title": "މަޤްޞަދަށް ރުހުމެއް ނެތި ކެމްޕެއިން ފޮނުވުން"
        },
        "resend_within_window": {
          "title": "ހުއްޓުވުމުގެ މުއްދަތުގައި ކެމްޕެއިން އަލުން ފޮނުވުން"
        }
      }
    },
    "pms": {
      "guest": {
        "restricted": {
          "title": "ހުރަސްކުރެވިފައިވާ ގެސްޓް"
        }
      },
      "folio": {
        "charge_immutable": {
          "title": "ޕޯސްޓްކުރެވިފައިވާ ފޮލިއޯ ޗާޖަށް ބަދަލު"
        },
        "credit_limit": {
          "title": "ކްރެޑިޓް ލިމިޓަށްވުރެ ބޮޑު ފޮލިއޯ"
        },
        "allowance": {
          "title": "ފޮލިއޯ އެލަވަންސް އޯވަރައިޑް"
        },
        "late_charge": {
          "title": "ބަންދުކުރެވިފައިވާ ފޮލިއޯއަށް ލޭޓް ޗާޖު"
        }
      },
      "night_audit": {
        "unposted_nights": {
          "title": "ޕޯސްޓްނުކުރެވޭ ރޭތަކާއެކު ނައިޓް އޯޑިޓް"
        },
        "force": {
          "title": "ނައިޓް އޯޑިޓް ބާރުއަޅައިގެން"
        }
      },
      "settlement": {
        "window_not_zero": {
          "title": "ސެޓްލްމަންޓް ވިންޑޯ ޒީރޯ ނޫން"
        }
      },
      "board": {
        "no_transfer_price": {
          "title": "ޓްރާންސްފަރ ޕްރައިސް ނެތް ބޯޑް ބޭސިސް"
        }
      },
      "availability": {
        "oversell": {
          "title": "އޯވަރބުކިންގ"
        }
      },
      "rate": {
        "manual_override": {
          "title": "ރޫމް ރޭޓް އަތުން އޯވަރައިޑް"
        },
        "restricted": {
          "title": "ހުރަސްކުރެވިފައިވާ ރޭޓް ބޭނުންކުރުން"
        }
      },
      "reservation": {
        "amend_after_arrival": {
          "title": "އައިސްފަހު ރިޒަވޭޝަން އެމެންޑްކުރުން"
        }
      },
      "checkout": {
        "balance_outstanding": {
          "title": "ބާކީ ބެލެންސްއާއެކު ޗެކްއައުޓް"
        }
      },
      "housekeeping": {
        "inspect_own_clean": {
          "title": "ހައުސްކީޕަރު އަމިއްލަ ކްލީން ބެލުން"
        }
      },
      "commission": {
        "write_off": {
          "title": "ކޮމިޝަން ރައިޓްއޮފް"
        }
      }
    },
    "ai": {
      "capabilityDelegationWithoutEvidence": {
        "title": "ހެކިނެތި ކެޕަބިލިޓީ ޑެލިގޭޓްކުރުން"
      },
      "actionOutsideTolerance": {
        "title": "ޓޮލަރެންސްއިން ބޭރުގެ އޭއައި އަމަލު"
      }
    },
    "inventory": {
      "transfer": {
        "received_short": {
          "title": "ޓްރާންސްފަރު މަދުކޮށް ބަލައިގަތުން"
        }
      },
      "lot": {
        "not_available": {
          "title": "ލޮޓް ލިބެންނެތް"
        },
        "expired": {
          "title": "ދުވަސްހަމަވެފައިވާ ލޮޓް"
        },
        "shelf_life_short": {
          "title": "ޝެލްފް ލައިފް ބާކީ ކުރު ލޮޓް"
        }
      },
      "landed_cost": {
        "disbursement_recoverable_tax": {
          "title": "ރިކަވަރ ކުރެވޭ ޓެކުހާއެކު ޑިސްބާސްމަންޓް"
        },
        "duty_needs_classification": {
          "title": "ޓެރިފް ކްލެސިފިކޭޝަނެއް ނެތް ޑިއުޓީ"
        }
      },
      "count": {
        "recount_required": {
          "title": "އަލުން ގުނަންޖެހޭ"
        },
        "same_counter": {
          "title": "ގުނުމުގައި ވެސް ހަމަ ގުނާމީހާ"
        },
        "frozen_scope": {
          "title": "ފްރީޒުކުރެވިފައިވާ ގުނުމުގެ ސްކޯޕްގައި މޫވްމަންޓް"
        }
      },
      "adjustment": {
        "evidence_required": {
          "title": "ހެކިނެތް އެޑްޖަސްޓްމަންޓް"
        }
      }
    }
  },
  "pricing": {
    "filtersTitle": "ފިލްޓަރތައް",
    "allCompanies": "ހުރިހާ ކުންފުނިތައް",
    "chooseItem": "ޚިޔާރުކުރޭ ތަކެތި",
    "nav": {
      "label": "އަގު ކަނޑައެޅުން",
      "priceLists": "އަގުތަކުގެ ލިސްޓް",
      "promotions": "ޕްރޮމޯޝަންތައް",
      "itemSettings": "ތަކެތީގެ ސެޓިންގތައް",
      "categories": "ބައިތައް",
      "precedence": "ތަރުތީބު",
      "priceSets": "އަގު ސެޓްތައް",
      "explanations": "ތަފްޞީލު"
    },
    "routeTitles": {
      "priceLists": "އަގުތަކުގެ ލިސްޓް",
      "priceListNew": "އައު އަގުތަކުގެ ލިސްޓް",
      "priceList": "އަގުތަކުގެ ލިސްޓް",
      "promotions": "ޕްރޮމޯޝަންތައް",
      "itemSettings": "ތަކެތީގެ އަގުކުރުމުގެ ސެޓިންގތައް",
      "categories": "އަގުކުރުމުގެ ބާވަތްތައް",
      "precedence": "އަގު ކަނޑައެޅުމުގެ ތަރުތީބު",
      "precedenceVersion": "ތަރުތީބުގެ ވަރޝަން",
      "priceSets": "އަގު ސެޓްތައް",
      "priceSet": "އަގު ސެޓް",
      "explanations": "އަގުގެ ތަފްޞީލު"
    },
    "common": {
      "note": "ނޯޓް",
      "reasonCode": "ސަބަބުގެ ކޯޑް"
    },
    "fields": {
      "company": "ކުންފުނި",
      "customer": "ކަސްޓަމަރު",
      "item": "ތަކެތި",
      "currency": "ފައިސާގެ ބާވަތް",
      "quantity": "ޢަދަދު",
      "uom": "މިނާ ޔުނިޓް",
      "unitPrice": "ޔުނިޓް އަގު",
      "channel": "ޗެނަލް",
      "supplyType": "މުޢާމަލާތުގެ ބާވަތް",
      "dayPart": "ދުވަހުގެ ބައި",
      "segmentCode": "ސެގްމަންޓް",
      "location": "ތަން",
      "createdAt": "އުފެއްދި"
    },
    "sources": {
      "subscription_plan": "ސަބްސްކްރިޕްޝަން ޕްލޭން",
      "customer_contract": "ކަސްޓަމަރުގެ އެއްބަސްވުން",
      "contract_price_list": "އެއްބަސްވުމުގެ އަގުތަކުގެ ލިސްޓް",
      "trade_agreement": "ވިޔަފާރީގެ އެއްބަސްވުން",
      "tier_price_list": "ފަންތީގެ އަގުތަކުގެ ލިސްޓް",
      "segment_price_list": "ސެގްމަންޓް އަގުތަކުގެ ލިސްޓް",
      "channel_price_list": "ޗެނަލް އަގުތަކުގެ ލިސްޓް",
      "published_price_set": "ޝާއިޢުކޮށްފައިވާ އަގު ސެޓް",
      "base_price_list": "އަސާސީ އަގުތަކުގެ ލިސްޓް",
      "manual": "އަތުން ލިޔުނު އަގު"
    },
    "outcomes": {
      "won": "ކާމިޔާބު",
      "lost": "އަގުގައި ބަލިވި",
      "ineligible": "ޝަރުޠު ހަމަނުވޭ",
      "out_of_window": "މުއްދަތުން ބޭރު",
      "not_configured": "ކަނޑައަޅާފައެއް ނުވޭ",
      "disabled": "ނިއްވާލެވިފައި",
      "not_reached": "އެތާނގަށް ނުދޭ"
    },
    "outcomeHints": {
      "won": "މި މަޞްދަރުން އަގު ކަނޑައެޅިއެވެ.",
      "lost": "އަގެއް ދިން ނަމަވެސް، އެހެން މަޞްދަރަކުން އެއަށްވުރެ ދަށް އަގެއް ދިނެވެ.",
      "ineligible": "މި ތަކެއްޗަށް އަގެއް ދެވުނީސް، ނަމަވެސް މި ޝަރުޠުތަކުގައި ނޫން — ޢަދަދާއި ކަސްޓަމަރު ބައްލަވާ.",
      "out_of_window": "މިއެއް އެބައޮތް، ނަމަވެސް އޭގެ ތާރީޚުތަކުގެ ތެރެއަށް މި ސަޠުރު ނުވަދޭ. ބޭނުންނަމަ މުއްދަތު އިތުރުކުރައްވާ.",
      "not_configured": "މި މަޞްދަރަށް އެއްވެސް އެއްޗެއް ކަނޑައަޅާފައެއް ނެތް. ބޭނުންނަމަ އުފައްދަވާ.",
      "disabled": "ބާރުގައިވާ ތަރުތީބުގެ ވަރޜަނުގައި މި މަޞްދަރު ވަނީ ނިއްވާލާފައެވެ.",
      "not_reached": "ކުރީގެ މަޞްދަރަކުން ހޯދުން ނިމުނު ކަމުން، މިއެއް ބެލިފައެއް ނުވެއެވެ."
    },
    "margin": {
      "clear": "ފްލޯއަށްވުރެ މަތީގައި",
      "below": "ފްލޯއަށްވުރެ ދަށުގައި",
      "unconfigured": "ފްލޯއެއް ކަނޑައަޅާފައެއް ނެތް"
    },
    "basis": {
      "exclusive": "ޓެކްސް ނުހިމަނާ",
      "inclusive": "ޓެކްސް ހިމަނައިގެން"
    },
    "modifierKinds": {
      "promotion": "ޕްރޮމޯޝަން",
      "trade_discount": "ވިޔަފާރީގެ ޑިސްކައުންޓް",
      "unrecorded": "ރެކޯޑްކުރެވިފައެއް ނެތް"
    },
    "reason": {
      "beaten_by_price": "އެހެން މަޞްދަރަކުން {price} ގެ އަގެއް ދީގެން ކާމިޔާބުކުރިއެވެ.",
      "beaten_by_promotion": "މި ވިޔަފާރީގެ ޑިސްކައުންޓަށްވުރެ ރަނގަޅު އަގެއް ޕްރޮމޯޝަނުން ދިނެވެ.",
      "beaten_by_trade_discount": "މި ޕްރޮމޯޝަނަށްވުރެ ރަނގަޅު އަގެއް ވިޔަފާރީގެ ޑިސްކައުންޓުން ދިނެވެ.",
      "earlier_source_won": "ބެލިފައެއް ނުވެއެވެ: ތަރުތީބު {seq} ގައިވާ މަޞްދަރު ކާމިޔާބުކޮށް ހޯދުން ހުއްޓާލައިފިއެވެ.",
      "entry_disabled": "ބާރުގައިވާ ތަރުތީބުގެ ވަރޜަނުގައި ނިއްވާލާފައެވެ.",
      "item_not_in_list": "{code} ގައި މި ތަކެއްޗަށް އަގެއް ނެތެވެ.",
      "list_out_of_window": "މި ތާރީޚުގައި {code} ބާރުގައެއް ނުވެއެވެ.",
      "manual_override": "އިންޖީނުން ނޫން، އަތުން ދިން އަގެކެވެ.",
      "min_qty_not_met": "{code} ފެށެނީ {minQty} އިންނެވެ؛ މި ސަޠުރު އޮތީ {qty} އަށެވެ.",
      "no_channel": "މި ސަޠުރުގައި ޗެނަލެއް ނެތުމުން، ޗެނަލް ލިސްޓެއް ނުހިނގާނެއެވެ.",
      "no_customer": "މި ސަޠުރުގައި ކަސްޓަމަރެއް ނެތުމުން، ކަސްޓަމަރު ލިސްޓެއް ނުހިނގާނެއެވެ.",
      "no_segment": "މި ސަޠުރުގައި ސެގްމަންޓެއް ނެތުމުން، ސެގްމަންޓް ލިސްޓެއް ނުހިނގާނެއެވެ.",
      "not_configured": "މި މަޞްދަރަށް އެއްވެސް އެއްޗެއް ކަނޑައަޅާފައެއް ނެތެވެ.",
      "precedence_defaulted": "މި ތާރީޚް ހިމެނޭ ތަރުތީބުގެ ވަރޜަނެއް ނެތުމުން، ސިސްޓަމުގައި ހުރި ތަރުތީބު ބޭނުންކުރެވުނެވެ.",
      "promotion_applied": "ޕްރޮމޯޝަން {code} ބޭނުންކުރެވުނެވެ.",
      "qty_break": "{minQty} އިން މަތިން {code} އިން އަގު ދިނެވެ.",
      "set_out_of_window": "މި ތާރީޚުގައި އަގު ސެޓް {code} ބާރުގައެއް ނުވެއެވެ.",
      "set_scope_mismatch": "މި ސަޠުރުގެ ސްކޯޕް ނުވަތަ ފައިސާގެ ބާވަތް އަގު ސެޓުގައި ނުހިމެނެއެވެ.",
      "source_unavailable": "މި ބިލްޑްގައި {source} އަށް ބަލާނެ ގޮތެއް ނެތެވެ.",
      "trade_discount_applied": "ވިޔަފާރީގެ އެއްބަސްވުން {code} ބޭނުންކުރެވުނެވެ."
    },
    "waterfall": {
      "title": "މި އަގު މިހެން ވީ ސަބަބު",
      "none": "މި ސަޠުރުގެ އަގުގެ ތަފްޞީލެއް ނެތެވެ.",
      "listPrice": "ލިސްޓް އަގު",
      "decidedBy": "ކަނޑައެޅީ",
      "preview": "ކުރިން ބަލާލުން",
      "tableCaption": "އިންޖީނުން ބެލި ހުރިހާ އަގުގެ މަޞްދަރެއް، ބެލި ތަރުތީބުން.",
      "columns": {
        "seq": "ތަރުތީބު",
        "source": "މަޞްދަރު",
        "outcome": "ނަތީޖާ",
        "minQty": "ފެށޭ ޢަދަދު",
        "unitPrice": "ޔުނިޓް އަގު"
      },
      "deltaVsWinner": "ކާމިޔާބުކުރި އަގާ އަޅާބަލާއިރު {amount}",
      "modifiers": "މަޞްދަރު ކާމިޔާބުކުރި ފަހުން ބޭނުންކުރެވުނު",
      "modifierDerived": "ނެރެފައި، ރެކޯޑްކޮށްފައެއް ނޫން",
      "marginFloor": "މާރޖިން ފްލޯ",
      "floorPercent": "ފްލޯގެ އިންސައްތަ",
      "minPrice": "އެންމެ ދަށް އަގު",
      "standardCost": "ސްޓޭންޑަޑް އަގު",
      "precedenceVersion": "ތަރުތީބުގެ ވަރޝަން",
      "priceSetVersion": "އަގު ސެޓްގެ ވަރޜަން",
      "resolvedAt": "އަގު ނެރުނު ވަގުތު",
      "fingerprint": "ފިންގަރޕްރިންޓް",
      "fingerprintHint": "ސުވާލާއި، އެ ސުވާލަށް ޖަވާބުދިން ކޮންފިގަރޭޝަން ދެނެގަނެއެވެ. އެއް ފިންގަރޕްރިންޓެއް ހުރި ދެ ޖަވާބަކީ އެއް ޖަވާބެކެވެ.",
      "precedenceDefaulted": "މި ތާރީޚް ހިމެނޭ ބާރުގައިވާ ތަރުތީބުގެ ވަރޜަނެއް ނެތުމުން، ސިސްޓަމުގައި ހުރި ތަރުތީބު ބޭނުންކުރެވުނެވެ. erpxctl pricing sync ހިންގަވާ.",
      "setSuperseded": "އަގު ނެގީ އަގު ސެޓްގެ ވަރޜަން #{versionId} އިން، އެއީ މިހާރު ޝާއިޢުކޮށްފައިވާ ވަރޜަނެއް ނޫނެވެ.",
      "unknownOutcome": "މި ބިލްޑަށް ނޭނގޭ ނަތީޖާތަކެއް މީގައި ރެކޯޑްކުރެވިފައިވެއެވެ: {codes}. އެއީ ހަމަ އޭގެ ކޯޑުން ދައްކާފައެވެ."
    },
    "priceLists": {
      "listTitle": "އަގުތަކުގެ ލިސްޓް",
      "listDescription": "އަގުތައް ހިމެނޭ ލިސްޓުތައް، އިންޖީނުން ބަލާ އިސްކަމުގެ ތަރުތީބުން.",
      "new": "އައު އަގުތަކުގެ ލިސްޓް",
      "newTitle": "އައު އަގުތަކުގެ ލިސްޓް",
      "newDescription": "ކޯޑަކާއި، ބާވަތަކާއި، އަގު ދީފައިވާ މަދުވެގެން އެއް ތަކެތި.",
      "headerTitle": "އަގުތަކުގެ ލިސްޓް",
      "loadFailed": "އަގުތަކުގެ ލިސްޓުތައް ލޯޑެއް ނުކުރެވުނު",
      "saveFailed": "އަގުތަކުގެ ލިސްޓް ރައްކާނުކުރެވުނު",
      "saved": "އަގުތަކުގެ ލިސްޓް ރައްކާކުރެވިއްޖެ",
      "created": "{code} އަގުތަކުގެ ލިސްޓް އުފެދިއްޖެ",
      "emptyTitle": "އަދި އަގުތަކުގެ ލިސްޓެއް ނެތް",
      "emptyDescription": "ހުރިހާ ތަކެއްޗަކަށް އަގެއް ލިބޭނެހެން އަސާސީ ލިސްޓެއް އުފައްދަވާ، އެއަށްފަހު އޭގެ މަތިން ފަންތި އަދި އެއްބަސްވުމުގެ ލިސްޓުތައް އިތުރުކުރައްވާ.",
      "orderNote": "އެއް ބާވަތެއްގެ ތެރެއިން، އެ ދުވަހު އަމަލުކުރާ އެންމެ އިސް ލިސްޓް ކާމިޔާބުވެއެވެ.",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓާލެވިފައި",
      "inForce": "މިއަދު އަމަލުކުރޭ",
      "notInForce": "ބާރުގައެއް ނޫން",
      "columns": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "kind": "ބާވަތް",
        "tier": "ފަންތި",
        "priority": "އިސްކަން",
        "window": "މުއްދަތު",
        "lines": "ރޮނގުތައް",
        "inForce": "ބާރުގައި"
      },
      "kinds": {
        "base": "އަސާސީ",
        "tier": "ފަންތި",
        "contract": "ކޮންޓްރެކްޓް",
        "segment": "ސެގްމަންޓް",
        "channel": "ޗެނަލް"
      },
      "kindHints": {
        "base": "އެއްވެސް ފަރާތަކާ ވާހަކަ ދެކެވިފައި ނުވާ އަސާސީ އަގު. ކޮންމެ ކުންފުންޏަކަށްވެސް އެއް ބޭނުންވެއެވެ.",
        "tier": "އެއް އަގުގެ ފަންތީގައިވާ ކަސްޓަމަރުންނަށް ހިނގާނެއެވެ.",
        "contract": "އެއް ކަސްޓަމަރަކާއެކު އެއްބަސްވެފައިވާ އަގު، އަދި އަގުގެ މައްޗަށް އެންމެ ބާރުގަދަ ދަޢުވާ.",
        "segment": "އެއް ސެގްމަންޓް ކޯޑެއް ހުރި ކަސްޓަމަރުންނަށް ހިނގާނެއެވެ.",
        "channel": "އެއް ވިޔަފާރި ޗެނަލަކަށް ހިނގާނެއެވެ."
      },
      "fields": {
        "customerHint": "އެއްބަސްވުމުގެ ލިސްޓަކުން އަގު ދެނީ ހަމައެކަނި މި ކަސްޓަމަރަށެވެ.",
        "tierHint": "ކަސްޓަމަރުގެ އަގުގެ ފަންތިއާ ސީދާ ދިމާވާން ޖެހެއެވެ.",
        "segmentCode": "ސެގްމަންޓް",
        "segmentCodeHint": "ލާޒިމު: ސެގްމަންޓް ކޯޑެއް ނެތް ސެގްމަންޓް ލިސްޓަކުން އެއްވެސް އެއްޗަކާ ދިމައެއް ނުވާނެއެވެ.",
        "channel": "ޗެނަލް",
        "channelHint": "ލާޒިމު: ޗެނަލެއް ނެތް ޗެނަލް ލިސްޓަކުން އެއްވެސް އެއްޗަކާ ދިމައެއް ނުވާނެއެވެ.",
        "dayPart": "ދުވަހުގެ ބައި",
        "dayPartHint": "ދުވަހުގެ ކޮންމެ ވަގުތަކަށްވެސް އަގު ދޭން ބޭނުންނަމަ ހުސްކޮށް ބާއްވާ.",
        "priorityHint": "އެއް ބާވަތެއްގެ ތެރޭގައި އެންމެ މަތީ އިސްކަން ކާމިޔާބުކުރާނެއެވެ.",
        "validFrom": "ފެށޭ ތާރީޚް",
        "validTo": "ނިމޭ ތާރީޚް",
        "validToHint": "މި ތާރީޚް ހިމެނެއެވެ. ނިމުމެއް ނެތްނަމަ ހުސްކޮށް ބާއްވާ."
      },
      "laddersTitle": "އަގުތައް",
      "laddersDescription": "ކޮންމެ ތަކެއްޗަކަށް އެއް ސިޑި: ކޮންމެ ހަރުފަތަކީ އެ ޢަދަދުން މަތިން ދޭ އަގެވެ.",
      "laddersCaption": "އަގުތަކުގެ ލިސްޓުގެ ސަޠުރުތައް، ތަކެތި ބަހައިގެން، ކޮންމެ ހަރުފަތެއް ފެށޭ ޢަދަދުގެ ތަރުތީބުން.",
      "fromQty": "ފެށޭ ޢަދަދު",
      "sameItem": "ހަމަ އެ ތަކެތި",
      "addItem": "ތަކެތި އިތުރުކުރޭ",
      "addRung": "ހަރުފަތެއް އިތުރުކުރޭ",
      "chooseItem": "ޚިޔާރުކުރޭ ތަކެތި",
      "noLines": "އަދި ސަޠުރެއް ނެތް. އަގު ދިނުމަށް ތަކެއްޗެއް އިތުރުކުރައްވާ.",
      "startsAbove": "މި ސިޑި ފެށެނީ {qty} އިން ކަމުން، އެއަށްވުރެ ދަށަށް އެއްވެސް އަގެއް ނުދޭނެއެވެ.",
      "risesWithQty": "މީގެ ތިރީގައިވާ ހަރުފަތަށްވުރެ އަގުބޮޑު.",
      "ladderNote": "އޯޑަރުކުރި ޢަދަދަށްވުރެ މަތި ނުވާ އެންމެ މަތީ ހަރުފަތް އިންޖީނުން ނަގާނެއެވެ. ހުރިހާ ހަރުފަތަކަށްވުރެ ދަށް ޢަދަދަކަށް މި ލިސްޓުން އަގެއް ނުދޭނެއެވެ.",
      "aria": {
        "minQty": "{item} ފެށޭ ޢަދަދު",
        "unitPrice": "{item} ގެ ޔުނިޓް އަގު"
      }
    },
    "promotions": {
      "listTitle": "ޕްރޮމޯޝަންތައް",
      "listDescription": "ލިސްޓަކުން އަގު ކަނޑައެޅި ފަހުން، މުއްދަތެއްގެ ތެރޭގައި އަގު ބަދަލުކުރާ ކެމްޕޭންތައް.",
      "new": "އައު ޕްރޮމޯޝަން",
      "newTitle": "އައު ޕްރޮމޯޝަން",
      "editTitle": "ޕްރޮމޯޝަން",
      "dialogDescription": "ޕްރޮމޯޝަނުން ލިސްޓް އަގު ދަށްކުރެއެވެ؛ އެ އަގު ކަނޑައެޅި ލިސްޓް ބަދަލެއް ނުކުރެއެވެ.",
      "loadFailed": "ޕްރޮމޯޝަންތައް ލޯޑެއް ނުކުރެވުނު",
      "saveFailed": "ޕްރޮމޯޝަން ރައްކާނުކުރެވުނު",
      "saved": "ޕްރޮމޯޝަން ރައްކާކުރެވިއްޖެ",
      "created": "{code} ޕްރޮމޯޝަން އުފެދިއްޖެ",
      "emptyTitle": "ހިނގަމުންދާ ޕްރޮމޯޝަނެއް ނެތް",
      "emptyDescription": "މުއްދަތަކަށް، ކަސްޓަމަރު ފަންތިއަކަށް ނުވަތަ ތަކެތިތަކަކަށް އަގު ދަށްކުރުމަށް އެއް އުފައްދަވާ.",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓާލެވިފައި",
      "activeOn": "ހިނގާ ތާރީޚް",
      "activeOnHint": "ޕްރޮމޯޝަނެއް ހިނގާނީ އެ ހަރަކާތްތެރިވެފައި، މި ތާރީޚް އޭގެ މުއްދަތުގެ ތެރޭގައި ވާނަމައެވެ.",
      "everyone": "ހުރިހާ ފަރާތެއް",
      "restrictedTo": "{customers} ކަސްޓަމަރު، {tiers} ފަންތި، {items} ތަކެތި",
      "unrestricted": "ކަސްޓަމަރެއް، ފަންތިއެއް ނުވަތަ ތަކެއްޗެއް ބަޔާންކޮށްފައެއް ނެތް — މި ޕްރޮމޯޝަން ހުރިހާ ކެޓަލޮގަކަށް ހިނގާނެއެވެ.",
      "editLimits": "ނަން، ނިމޭ ތާރީޚް އަދި ދެ ސުވިޗް ބަދަލުކުރެވޭނެއެވެ. އަގު، ބާވަތް އަދި ޝަރުޠުތައް ބަދަލެއް ނުކުރެވޭނެއެވެ، ސަބަބަކީ އޭގެ ދަށުން އަގު ދީފައިވާ ސަޠުރުތައް ކޯޓޭޝަންތަކުގައި ހުރުމެވެ.",
      "stacksNote": "ޕްރޮމޯޝަން ހިނގަނީ ކާމިޔާބުކުރި ލިސްޓް އަގުގެ ފަހުންނެވެ.",
      "stackableOn": "ވިޔަފާރީގެ ޑިސްކައުންޓާއެކު ގުޅިގެން ހިނގާނެއެވެ.",
      "stackableOff": "ގުޅިގެނެއް ނުހިނގާނެއެވެ: ކަސްޓަމަރަށް ލިބޭނީ ދޭތިން ރަނގަޅު އެކެވެ.",
      "columns": {
        "eligibility": "އަޅާ ފަރާތްތައް"
      },
      "kinds": {
        "percent": "އިންސައްތަ",
        "amount": "އަދަދު",
        "bundle": "ބަނޑްލް"
      },
      "kindHints": {
        "percent": "ލިސްޓް އަގުން ކަނޑާ އިންސައްތައެއް.",
        "amount": "އެއް ފައިސާއަކުން ކަނޑައެޅިފައިވާ އަދަދެއް.",
        "bundle": "ވަކި ޢަދަދަކުން މަތިން އެކަނި ހިނގާ ޑިސްކައުންޓެއް."
      },
      "valueHints": {
        "percent": "ކަނޑާ އިންސައްތަ، މިސާލަކަށް ފަހެއް އިންސައްތައަށް 5.",
        "amount": "ކަނޑާ އަދަދު، ތިރީގައިވާ ފައިސާގެ ބާވަތުން.",
        "bundle": "ބަނޑްލްގެ ޢަދަދު ހަމަވުމުން ދޭ ޑިސްކައުންޓް."
      },
      "fields": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "kind": "ބާވަތް",
        "value": "ވެލިއު",
        "bundleMinQty": "ބަނޑްލްގެ ޢަދަދު",
        "bundleMinQtyHint": "ބަނޑްލް ހުޅުވާލާ ޢަދަދު.",
        "minQty": "އެންމެ ދަށް ޢަދަދު",
        "minQtyHint": "މި ޢަދަދަށްވުރެ ދަށްވެއްޖެނަމަ ޕްރޮމޯޝަން ނުހިނގާނެއެވެ.",
        "startDate": "ފެށޭ",
        "endDate": "ނިމޭ",
        "endDateHint": "މި ތާރީޚް ހިމެނެއެވެ. ޕްރޮމޯޝަނެއް ހުއްޓުވަނީ މި ތާރީޚް ކުރިއަށް ގެނެސްގެންނެވެ.",
        "customerIds": "ކަސްޓަމަރުގެ އައިޑީތައް",
        "customerTiers": "ކަސްޓަމަރުގެ ފަންތިތައް",
        "itemIds": "ތަކެތީގެ އައިޑީތައް",
        "idListHint": "ކޮމާއިން ވަކިކުރެވިފައިވާ އައިޑީތައް. ހުހަށް ބާއްވައިފިނަމަ ހުރިހާ އެއްޗެއް ހިމެނޭނެއެވެ.",
        "tierListHint": "ކޮމާއިން ވަކިކުރެވިފައިވާ ފަންތިތައް. ހުހަށް ބާއްވައިފިނަމަ ހުރިހާ ފަންތިއެއް ހިމެނޭނެއެވެ.",
        "channel": "ޗެނަލް",
        "channelHint": "ހުހަށް ބާއްވައިފިނަމަ ހުރިހާ ޗެނަލަކަށް ހިނގާނެއެވެ.",
        "dayPart": "ދުވަހުގެ ބައި",
        "dayPartHint": "ހުހަށް ބާއްވައިފިނަމަ ދުވަހުގެ ކޮންމެ ވަގުތަކުވެސް ހިނގާނެއެވެ.",
        "segmentCode": "ސެގްމަންޓް",
        "segmentCodeHint": "ހުހަށް ބާއްވައިފިނަމަ ހުރިހާ ސެގްމަންޓަކަށް ހިނގާނެއެވެ.",
        "isStackable": "ވިޔަފާރީގެ ޑިސްކައުންޓާއެކު ގުޅިގެން ހިނގާ",
        "isStackableHint": "ނިއްވާލައިފިނަމަ ކަސްޓަމަރަށް ލިބޭނީ ދޭތިން ރަނގަޅު އެއް، އަދި ބަލިވި އެތި ރެކޯޑްކުރެވޭނެއެވެ."
      }
    },
    "itemSettings": {
      "title": "ތަކެތީގެ އަގުކުރުމުގެ ސެޓިންގތައް",
      "description": "ތަކެއްޗެއް ކުންފުންޏަށް ޚަރަދުވާ މިންވަރާއި، އެއަށްވުރެ ދަށަށް ނުދެވޭ މާރޖިނާއި، ޑިސްކައުންޓްގެ ބާރު ބަލާ ބައި.",
      "formTitle": "މި ތަކެތީގެ އަގުކުރުން",
      "chooseFirst": "ތަކެތީގެ އަގުކުރުމުގެ ސެޓިންގތައް ބެއްލެވުމަށް ކުންފުންޏަކާއި ތަކެއްޗެއް ޚިޔާރުކުރައްވާ.",
      "loadFailed": "ތަކެތީގެ ސެޓިންގތައް ލޯޑެއް ނުކުރެވުނު",
      "saveFailed": "ތަކެތީގެ ސެޓިންގތައް ރައްކާނުކުރެވުނު",
      "saved": "ތަކެތީގެ އަގުކުރުމުގެ ސެޓިންގތައް ރައްކާކުރެވިއްޖެ",
      "standardCost": "ސްޓޭންޑަޑް އަގު",
      "standardCostHint": "މި ތަކެތި ކުންފުންޏަށް ޚަރަދުވާ މިންވަރު. މާރޖިން ފްލޯ ބަލަނީ މިއާ އަޅާކިޔައިގެންނެވެ.",
      "floorPercent": "މާރޖިން ފްލޯ",
      "floorPercentHint": "ވިއްކާ އަގުގެ އިންސައްތައެއްގެ ގޮތުގައި އެންމެ ދަށް މާރޖިން. ފްލޯއެއް ބާރުގައި ބާއްވަން ބޭނުން ނުވާނަމަ ހުސްކޮށް ބާއްވާ.",
      "category": "ބައި",
      "categoryHint": "ޑިސްކައުންޓްގެ ބާރުގެ މެޓްރިކްސް ބަލާ ބައި.",
      "noCategory": "ބައެއް ނެތް",
      "noCategories": "އަދި ބައިތަކެއް ކަނޑައަޅާފައެއް ނެތް",
      "unset": "މި ތަކެއްޗަށް އެއްވެސް އެއްޗެއް ކަނޑައަޅާފައި ނުވާތީ، މާރޖިން ފްލޯއެއް ބާރުގައެއް ނުވެއެވެ، އަދި ކޮންމެ އަގެއްގައިވެސް ވިއްކިދާނެއެވެ.",
      "zeroCost": "ސްޓޭންޑަޑް އަގަކީ ސުމެއް ކަމުން، މާރޖިން ފްލޯއެއް ބާރުގައެއް ނުވެއެވެ. ފްލޯ ބާރުގައި ބޭއްވުމަށް ތަކެއްޗަށް ޚަރަދުވާ މިންވަރު ލިޔުއްވާ.",
      "noFloor": "ސްޓޭންޑަޑް އަގު ރެކޯޑްކުރެވިފައިވީ ނަމަވެސް ފްލޯގެ އިންސައްތައެއް ނެތުމުން، އެއްވެސް އެއްޗެއް ބާރުގައެއް ނުވެއެވެ. ފްލޯގެ އިންސައްތައެއް ލިޔުއްވާ.",
      "enforced": "މި ތަކެއްޗަށް ފްލޯއެއް ބާރުގައިވެއެވެ."
    },
    "categories": {
      "title": "އަގުކުރުމުގެ ބާވަތްތައް",
      "description": "ޑިސްކައުންޓް ސިޔާސަތަކާއި ތަކެތީގެ ސެޓިންގއަކުން ބޭނުންކުރެވޭ ބައިތަކުގެ ކޯޑުތަކުގެ ލިސްޓް.",
      "create": "އައު ބައެއް",
      "createTitle": "އައު ބައެއް",
      "editTitle": "ބައި",
      "dialogDescription": "ކޯޑަކާއި ނަމެއް. އެހެން ރޯތަކުން ބޭނުންކުރަން ފެށުމުން ކޯޑް ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "code": "ކޯޑް",
      "codeHint": "ކުދި އިނގިރޭސި އަކުރު، ނަންބަރު އަދި އަންޑަރސްކޯ.",
      "codeInvalid": "ބޭނުންކުރެވޭނީ ކުދި އިނގިރޭސި އަކުރު، ނަންބަރު އަދި އަންޑަރސްކޯ އެކަންޏެވެ.",
      "parent": "މައި ބައި",
      "parentHint": "އިޚްތިޔާރީ. މައި ބައިން ރިޕޯޓްކުރުމަށް ބައިތައް އެއްކުރެއެވެ؛ މެޓްރިކްސް އަދިވެސް ބަލާނީ ސީދާ ކޯޑަށެވެ.",
      "noParent": "މައި ބައެއް ނެތް",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ބޭނުންކުރުމުން ހުއްޓާލާފައި",
      "activeHint": "ހުއްޓާލި ބައެއް، މިހާރުވެސް އެ ބޭނުންކުރާ ރޯތަކުގައި ދެމިއޮންނާނެއެވެ.",
      "activeOnly": "ހިނގަމުންދާ އެކަނި",
      "retire": "ހުއްޓާލާ",
      "retireTitle": "މި ބައި ހުއްޓާލަންތޯ؟",
      "retireDescription": "އައު ރޯތަކުގައި މިއެއް ދެން ނުދައްކާނެއެވެ.",
      "retireWarning": "މިހާރުވެސް މި ބައި ބޭނުންކުރާ ސިޔާސަތުތަކާއި ތަކެތީގެ ސެޓިންގތަކުގައި މިއެއް ދެމިއޮންނާނެއެވެ. މިހާރު އަގު ދީފައިވާ އެއްޗަކަށް ބަދަލެއް ނާންނާނެއެވެ.",
      "saved": "ބައި ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ބައި ރައްކާނުކުރެވުނު",
      "deleted": "ބައި ހުއްޓާލެވިއްޖެ",
      "deleteFailed": "ބައި ހުއްޓައެއް ނުލެވުނު",
      "loadFailed": "ބައިތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ބައިތަކެއް ނެތް",
      "emptyDescription": "ޑިސްކައުންޓް ސިޔާސަތުތައް ބަލާ ބައިތައް އުފައްދަވާ — ނެތް ބައެއްގެ ނަން ބޭނުންކުރާ ސިޔާސަތަކުން އެއްވެސް އެއްޗަކާ ދިމައެއް ނުވާނެއެވެ."
    },
    "precedence": {
      "title": "އަގު ކަނޑައެޅުމުގެ ތަރުތީބު",
      "description": "އިންޖީނުން އަގުގެ މަޞްދަރުތަކާ ސުވާލުކުރާ ތަރުތީބު، ސެޓިންގއެއްގެ ބަދަލުގައި ތާރީޚް ހިމެނޭ ވަރޜަންތަކެއްގެ ގޮތުގައި.",
      "tableLabel": "ތަރުތީބުގެ ވަރޜަންތައް",
      "create": "އައު ވަރޜަނެއް",
      "createTitle": "އައު ތަރުތީބުގެ ވަރޜަން",
      "createDescription": "ބާރުގައިވާ ތަރުތީބުން ފައްޓަވާ، އަދި ބަދަލުކުރަން ޖެހޭ އެއްޗެއް ބަދަލުކުރައްވާ.",
      "created": "ތަރުތީބުގެ ވަރޜަން އުފެދިއްޖެ",
      "createFailed": "ވަރޜަން އުފެއްދޭ ގޮތެއް ނުވި",
      "loadFailed": "ތަރުތީބުގެ ވަރޜަންތައް ލޯޑެއް ނުކުރެވުނު",
      "code": "ކޯޑް",
      "entryCount": "މަޞްދަރުތައް",
      "statusAny": "ކޮންމެ ސްޓޭޓަސްއެއް",
      "fromHint": "ބާރުގައި ހިންގުމުން، މި ތަރުތީބުން އަގު ކަނޑައަޅަން ފަށާ ތާރީޚް.",
      "cloneFrom": "ކޮޕީކުރާ ވަރޜަން",
      "cloneHint": "އެ ވަރޜަނުގެ ސިޑި ކޮޕީކުރެއެވެ، އަދި ގާތްގަނޑަކަށް އަބަދުވެސް ފަށަން ރަނގަޅު ގޮތަކީ އެއީއެވެ.",
      "cloneEmpty": "ހުސް ސިޑިއަކުން ފައްޓަވާ",
      "dualControl": "ދެ މީހުންގެ ކޮންޓްރޯލް",
      "notSubmitted": "ހުށަހަޅާފައެއް ނުވޭ",
      "submittedBy": "ހުށަހެޅީ ފަރާތް {user}",
      "notActivated": "ބާރުގައި ހިންގާފައެއް ނުވޭ",
      "activatedBy": "ބާރުގައި ހިންގީ ފަރާތް {user}",
      "emptyTitle": "ތަރުތީބުގެ ވަރޜަނެއް ނެތް",
      "emptyDescription": "ފެށޭ ތަރުތީބު ލުމަށް erpxctl pricing sync ހިންގަވާ، އެއަށްފަހު ބަދަލުކުރުމަށް އެ ކޮޕީކުރައްވާ.",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "submitted": "ހުށަހެޅި",
        "active": "ހަރަކާތްތެރި",
        "superseded": "ބަދަލުވެފައި"
      }
    },
    "editor": {
      "title": "ތަރުތީބުގެ ވަރޝަން",
      "description": "މި ސިޑީގެ ތަރުތީބު ބަދަލުކޮށްފިނަމަ، ބާރުގައި ހިނގާ ދުވަހުން ފެށިގެން އިންޖީނުން ދޭ ހުރިހާ އަގެއް ބަދަލުވާނެއެވެ.",
      "loadFailed": "ވަރޜަން ލޯޑެއް ނުކުރެވުނު",
      "ladderLabel": "އަގުގެ މަޞްދަރުތައް، ބަލާ ތަރުތީބުން",
      "draftNotice": "މިއީ ދެލިކޮޕީއެކެވެ. ހުށަހަޅާ، ސިމިއުލޭޓްކޮށް، ބާރުގައި ހިންގަންދެން މީގައި އޮތް އެއްވެސް އެއްޗަކުން އަގަކަށް އަސަރެއް ނުކުރާނެއެވެ.",
      "emptyLadder": "މި ސިޑީގައި އަދި މަޞްދަރެއް ނެތް. ތިރިން އެއް އިތުރުކުރައްވާ.",
      "addSource": "މަޞްދަރެއް އިތުރުކުރޭ",
      "addSourcePlaceholder": "މަޞްދަރެއް ޚިޔާރުކުރޭ",
      "removeSource": "{source} ނަގާ",
      "moveUp": "{source} މައްޗަށް ގެންދޭ",
      "moveDown": "{source} ތިރިއަށް ގެންދޭ",
      "enabled": "ހުޅުވާލެވިފައި",
      "stopOnMatch": "މިތަނުން ހުއްޓާ",
      "stopOnMatchHint": "މި މަޞްދަރުން އަގެއް ދީފިނަމަ ހޯދުން ނިމި، ފަހުން އަންނަ މަޞްދަރުތަކާ ސުވާލެއް ނުކުރެވޭނެއެވެ.",
      "allDisabled": "މި ސިޑީގައިވާ ހުރިހާ މަޞްދަރެއް ނިއްވާލެވިފައިވާތީ، އެއްވެސް އަގެއް ނުދޭނެއެވެ.",
      "bestPricePolicy": "އެއްވެސް މަޞްދަރަކުން ހޯދުން ނުހުއްޓާތީ، ހުރިހާ މަޞްދަރަކާ ސުވާލުކޮށް، އެންމެ ރަނގަޅު އަގު ކާމިޔާބުކުރާނެއެވެ. އެއީ ސިޔާސަތެއް، ނަމަވެސް ގިނަ ފަހަރު ބޭނުންވާ ސިޔާސަތެއް ނޫނެވެ.",
      "sourceUnavailable": "މި ބިލްޑްގައި މި މަޞްދަރުތަކަށް ބަލާނެ ގޮތެއް ނެތެވެ: {sources}. ސިޑީގައި އެ މަޞްދަރުތައް ހުރި ހާ ހިނދަކު، އަގު ދޭ ކޮންމެ ސަޠުރެއްގައި އެ ނުލިބޭ ކަމަށް ރެކޯޑްކުރެވޭނެއެވެ.",
      "saved": "ސިޑި ރައްކާކުރެވިއްޖެ",
      "savedHint": "މި ވަރޜަން ބާރުގައި ހިންގަންދެން އަގަކަށް ބަދަލެއް ނާންނާނެއެވެ.",
      "saveFailed": "ސިޑި ރައްކާނުކުރެވުނު",
      "simulate": "ސިމިއުލޭޓް ކުރައްވާ",
      "submit": "ހުށަހަޅާ",
      "submitTitle": "ބާރުގައި ހިންގުމަށް ހުށަހަޅާ",
      "submitDescription": "ސިޑި ފްރީޒްވެ، ބާރުގައި ހިންގާނީ އެހެން ފަރާތެކެވެ.",
      "submitted": "ހުށަހެޅި",
      "submittedHint": "މިހާރު ބާރުގައި ހިންގަން ޖެހޭނީ ތިޔަ ފަރާތް ނޫން އެހެން ފަރާތެކެވެ.",
      "submitFailed": "ވަރޜަން ހުށަހެޅޭ ގޮތެއް ނުވި",
      "activate": "ބާރުގައި ހިންގާ",
      "activateTitle": "މި ވަރޜަން ބާރުގައި ހިންގާ",
      "activateDescription": "ތިރީގައިވާ ތާރީޚުން ފެށިގެން، ހުރިހާ އަގެއް ކަނޑައަޅާނީ މި ތަރުތީބުންނެވެ.",
      "activateWarning": "މި ތާރީޚުން ފެށިގެން އިންޖީނުން ދޭ ހުރިހާ އަގެއް ކަނޑައަޅާނީ މި ތަރުތީބުންނެވެ. ސިމިއުލޭޝަން ނުހިންގާނަމަ، ފުރަތަމަ އެ ހިންގަވާ.",
      "activated": "ވަރޜަން ބާރުގައި ހިނގައްޖެ",
      "activatedHint": "މިހާރު އޭގެ ފެށޭ ތާރީޚުން ފެށިގެން އަގު ކަނޑައަޅާނެއެވެ.",
      "activateFailed": "ވަރޜަން ބާރުގައި ހިންގޭ ގޮތެއް ނުވި"
    },
    "simulate": {
      "title": "މި ތަރުތީބު ސިމިއުލޭޓްކުރޭ",
      "description": "ޙަޤީޤަތުގައި ދީފައިވާ އަގުތަކުގެ ސާމްޕަލެއް މި ދެލިކޮޕީއާ އަޅާކިޔައި އަލުން ހިންގައެވެ.",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "limit": "ސާމްޕަލްގެ ސައިޒް",
      "limitHint": "ގިނަވެގެން 500 ސަޠުރު.",
      "run": "ރަން",
      "running": "ހިންގުން",
      "idle": "ކުންފުންޏަކާއި މުއްދަތެއް ޚިޔާރުކުރައްވާ، އެއަށްފަހު ސިމިއުލޭޝަން ހިންގަވާ.",
      "sampled": "ސާމްޕަލްކުރި",
      "unchanged": "ބަދަލެއް ނާދޭ",
      "changed": "ބަދަލުވި",
      "failed": "އަގު އަލުން ނުދެވުނު",
      "totalDelta": "ޖުމްލަ ތަފާތު",
      "deltaHint": "ހަމައެކަނި ސާމްޕަލްގައި",
      "failedAlert": "މި ތަރުތީބުގެ ދަށުން ސާމްޕަލްގެ {count} ސަޠުރަކަށް އެއްވެސް އަގެއް ނުދެވުނެވެ. މިއީ މީގައި އެންމެ މުހިންމު ކަންތައް — ބާރުގައި ހިންގުމުގެ ކުރިން އެ ސަޠުރުތައް ބައްލަވާ.",
      "noChange": "ސާމްޕަލްކުރި {sampled} ސަޠުރުން އެއްވެސް ސަޠުރެއް ބަދަލެއް ނުވާނެއެވެ. މިއީ ސާމްޕަލެއް، މުޅި ތާރީޚެއް ނޫނެވެ.",
      "tableCaption": "މި ތަރުތީބުގެ ދަށުން ކާމިޔާބުކުރާ މަޞްދަރު ނުވަތަ އަގު ބަދަލުވާނެ ހުރިހާ ސާމްޕަލް ސަޠުރެއް.",
      "columns": {
        "document": "ލިޔުން",
        "was": "ކުރިން",
        "becomes": "ފަހުން",
        "oldPrice": "ކުރީގެ އަގު",
        "newPrice": "އައު އަގު",
        "delta": "ތަފާތު"
      }
    },
    "priceSets": {
      "title": "އަގު ސެޓްތައް",
      "description": "އިންޓަނެޓާ ނުގުޅި ހުންނަ ސަރފޭސްއަކުން ވިޔަފާރިކުރެވޭ، ވަރޜަނުން ބަޔާންކުރެވޭ ފްރީޒްކުރެވިފައިވާ އަގުތަކެއް.",
      "create": "އައު އަގު ސެޓް",
      "createTitle": "އައު އަގު ސެޓް",
      "editTitle": "އަގު ސެޓް",
      "dialogDescription": "ސްކޯޕަކާއި ފައިސާގެ ބާވަތެއް. އަގުތައް ހުންނާނީ ތިރީގައިވާ ވަރޜަންތަކުގައެވެ.",
      "code": "ކޯޑް",
      "scope": "ސްކޯޕް",
      "channel": "ޗެނަލް",
      "channelHint": "ޗެނަލުން ލިސްޓް ފިލްޓަރކުރައްވާ.",
      "channelScopeHint": "ހުހަށް ބާއްވައިފިނަމަ ހުރިހާ ޗެނަލެއް.",
      "channelIs": "ޗެނަލް {channel}",
      "everyChannel": "ހުރިހާ ޗެނަލެއް",
      "location": "ތަން",
      "locationHint": "ހުހަށް ބާއްވައިފިނަމަ ހުރިހާ ތަނެއް.",
      "locationIs": "ތަން {location}",
      "everyLocation": "ހުރިހާ ތަނެއް",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓާލެވިފައި",
      "activeOnly": "ހިނގަމުންދާ އެކަނި",
      "saved": "އަގު ސެޓް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "އަގު ސެޓް ރައްކާނުކުރެވުނު",
      "created": "އަގު ސެޓް އުފެދިއްޖެ",
      "loadFailed": "އަގު ސެޓްތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި އަގު ސެޓެއް ނެތް",
      "emptyDescription": "ޓިލްއަކުން ވިޔަފާރިކުރާ ޗެނަލާއި ތަނަށް އެއް އުފައްދަވާ، އެއަށްފަހު ވަރޜަނެއް ބިނާކޮށް ޝާއިޢުކުރައްވާ.",
      "backToSets": "ހުރިހާ އަގު ސެޓްތައް",
      "versionsTitle": "އަގު ސެޓް",
      "versionsDescription": "އޭގެ ވަރޜަންތަކާއި، ޚިޔާރުކުރި ވަރޜަނުގައި ހުރި އެއްޗެހި.",
      "versionsPanel": "ވަރޝަންތައް",
      "versionsCaption": "މި އަގު ސެޓްގެ ހުރިހާ ވަރޜަނެއް، އެންމެ ފަހުގެ އެންމެ ކުރީގައި.",
      "versionNo": "ވަރޜަން",
      "noVersions": "އަދި ވަރޜަނެއް ނެތް. އެއް އުފައްދަވާ، އިންޖީނުން ބިނާކުރައްވާ، އެއަށްފަހު ޝާއިޢުކުރައްވާ.",
      "newVersion": "އައު ވަރޜަނެއް",
      "newVersionTitle": "އައު ވަރޜަނެއް",
      "newVersionDescription": "ޝާއިޢުކޮށްފައިވާ ވަރޜަން ކޮޕީކުރުމަކީ އާންމުކޮށް ފަށާ ގޮތެވެ.",
      "versionCreated": "ވަރޜަން އުފެދިއްޖެ",
      "cloneFrom": "ކޮޕީކުރާ ވަރޜަން",
      "cloneHint": "އެ ވަރޜަނުގެ އެންޓްރީތައް އައު ދެލިކޮޕީއަށް ކޮޕީކުރެއެވެ.",
      "cloneEmpty": "ހުހަށް ފައްޓާ",
      "entriesTitle": "ވަރޜަން {versionNo} ގެ އެންޓްރީތައް",
      "entriesDescription": "މި ވަރޜަން ގެންގުޅޭ ސަރފޭސްއަކުން ނަގާނެ އަގުތައް.",
      "entriesCaption": "ޚިޔާރުކުރި ވަރޜަނުގައި އަގު ދީފައިވާ ހުރިހާ އެންޓްރީއެއް.",
      "entryCount": "އެންޓްރީތައް",
      "noEntries": "އަދި އެންޓްރީއެއް ނެތް. އިންޖީނުން ބިނާކުރައްވާ، އެއީ އަވަސް، އަދި ލެޖަރާ ތަފާތުވުމުގެ ފުރުޞަތެއް ނެތް ގޮތެވެ.",
      "build": "އިންޖީނުން ބިނާކުރޭ",
      "buildTitle": "މި ވަރޜަން ބިނާކުރޭ",
      "buildDescription": "ސްކޯޕްގައިވާ ކޮންމެ ތަކެއްޗަކަށް މިއަދުގެ އަގު އިންޖީނުން ހޯދައި، އެންޓްރީތަކެއްގެ ގޮތުގައި ލިޔެއެވެ.",
      "buildNote": "މި ދެލިކޮޕީގައި މިހާރު ހުރި އެންޓްރީތައް ބަދަލުވާނެއެވެ. ބިނާކުރެވޭނީ ދެލިކޮޕީއެއް އެކަންޏެވެ.",
      "buildCategory": "ބައި",
      "buildCategoryHint": "ބިނާކުރުން އެއް ބަޔަކަށް ހަނިކުރައްވާ.",
      "buildEveryItem": "ހުރިހާ ތަކެއްޗެއް",
      "built": "ވަރޜަން ބިނާކުރެވިއްޖެ",
      "buildFailed": "ވަރޜަން ބިނާނުކުރެވުނު",
      "uom": "ޔުނިޓް",
      "dayPart": "ދުވަހުގެ ބައި",
      "segment": "ސެގްމަންޓް",
      "taxClass": "ޓެކްސް ކްލާސް",
      "taxGroup": "ޓެކްސް ގްރޫޕް {id}",
      "noTaxClass": "ޓެކްސް ކްލާހެއް ނެތް",
      "basis": "ހިސާބުކުރާ ގޮތް",
      "untaxed": "މީގެ ތެރެއިން {count} އެންޓްރީގައި ޓެކްސް ކްލާހެއް ނެތެވެ. އިންޓަނެޓާ ނުގުޅި އެ ވިއްކޭކަށް ނެތް، އަދި ޝާއިޢުކުރުން ހުއްޓުވޭނެއެވެ.",
      "contentHash": "ކޮންޓެންޓް ހޭޝް",
      "notHashed": "ޝާއިޢުކޮށްފައެއް ނުވޭ",
      "publish": "ޝާއިޢުކުރޭ",
      "publishTitle": "މި ވަރޜަން ޝާއިޢުކުރޭ",
      "publishDescription": "ޝާއިޢުކުރުމުން އޭގައި ހުރި އެއްޗެހި ފްރީޒްވެ، އޭގެ ހޭޝް ސްޓޭމްޕްކުރެވެއެވެ.",
      "publishWarning": "ވަރޜަން {versionNo} އާއި އޭގެ {entryCount} އެންޓްރީ ދެން ބަދަލެއް ނުކުރެވޭނެއެވެ. ފަހުން އަގެއް ބަދަލުކުރަން ބޭނުންނަމަ އައު ވަރޜަނެއް އުފައްދަވާ.",
      "published": "ވަރޜަން ޝާއިޢުކުރެވިއްޖެ",
      "publishFailed": "ވަރޜަން ޝާއިޢުނުކުރެވުނު",
      "incomplete": "މީގެ ތެރެއިން {count} އެންޓްރީ ޝާއިޢެއް ނުކުރެވޭނެ:",
      "withdraw": "އަނބުރާ ނަގާ",
      "withdrawTitle": "މި ވަރޜަން އަނބުރާ ނަގާ",
      "withdrawDescription": "ދެން މިއީ ޝާއިޢުކޮށްފައިވާ ވަރޜަނަކަށް ނުވާނެއެވެ.",
      "withdrawWarning": "މި ވަރޜަން އަދިވެސް ސަރފޭސްއެއްގައި ހުރެދާނެއެވެ. އޭގެ ހޭޝް ދެމިއޮންނާނީ، ބަދަލުވުމުގެ ރިޕޯޓުން އެ ސަރފޭސްގައި ހުރި އެއްޗެއް ބުނެދިނުމަށެވެ.",
      "withdrawn": "ވަރޜަން އަނބުރާ ނެގިއްޖެ",
      "withdrawFailed": "ވަރޜަން އަނބުރާ ނުނެގުނު",
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "published": "ޝާއިޢުކޮށްފައި",
        "withdrawn": "އަނބުރާ ނަގާފައި"
      }
    },
    "explanations": {
      "title": "އަގުގެ ތަފްޞީލު",
      "description": "މި ކުންފުނިން ދިން ހުރިހާ އަގަކާއި، އެ އަގު ދިން މަޞްދަރު.",
      "loadFailed": "އަގުގެ ތަފްޞީލުތައް ލޯޑެއް ނުކުރެވުނު",
      "document": "ލިޔުން",
      "docType": "ލިޔުމުގެ ބާވަތް",
      "winner": "ކާމިޔާބުކުރި މަޞްދަރު",
      "listPrice": "ލިސްޓް އަގު",
      "margin": "މާރޖިން",
      "setState": "އަގު ސެޓް",
      "superseded": "ބަދަލުވެފައި",
      "supersededOnly": "ހަމައެކަނި ބަދަލުވެފައިވާ ސެޓްތައް",
      "preview": "ކުރިން ބަލާލުން، ލިޔުމެއް ނެތް",
      "previewOnly": "މި އަގު ނެރުނީ އޭގެ ލިޔުން އުފެދުމުގެ ކުރިން ކަމުން، ތަފްޞީލުދޭނެ ލިޔުމެއް ނެތެވެ. ސަޠުރަކާ ދެކޮޅަށް އެއްވެސް އެއްޗެއް ފައިލްކުރެވިފައެއް ނުވެއެވެ.",
      "drawerTitle": "މި އަގު މިހެން ވީ ސަބަބު",
      "drawerDescription": "މި ސަޠުރަށް އަގު ދިން ވަގުތު ރެކޯޑްކުރެވުނު ވޯޓަރފޯލް.",
      "exported": "ތަފްޞީލުތައް އެކްސްޕޯޓްކުރެވިއްޖެ",
      "exportFailed": "ތަފްޞީލުތައް އެކްސްޕޯޓެއް ނުކުރެވުނު",
      "emptyTitle": "އަގުގެ ތަފްޞީލެއް ނެތް",
      "emptyDescription": "އަގު ދޭ ކޮންމެ ލިޔުމުގެ ސަޠުރަކުން އެއް ފައިލްކުރެއެވެ. ތާރީޚުތައް ފުޅާކުރައްވާ، ނުވަތަ އެއްޗަކަށް އަގު ދެއްވާ."
    },
    "resolve": {
      "title": "އަގެއް ނެރޭ",
      "description": "އިންޖީނުން ނަގާނެ އަގު ސާފުކުރައްވާ، އަދި ބެލި ހުރިހާ މަޞްދަރެއް ބައްލަވާ.",
      "on": "ތާރީޚް",
      "onHint": "އަގު ހޯދާ ވިޔަފާރީގެ ތާރީޚް.",
      "customerHint": "ނަން ނޭނގޭ ކަސްޓަމަރެއްގެ ގޮތުގައި އަގު ނަގަން ބޭނުންނަމަ ހުސްކޮށް ބާއްވާ.",
      "anonymous": "ކަސްޓަމަރެއް ނެތް",
      "pinnedVersion": "ޕިންކުރި އަގު ސެޓްގެ ވަރޜަން",
      "pinnedVersionHint": "ކެޝްކޮށްފައިވާ ސެޓަކުން އަގު ނަގާއިރު، އިންޓަނެޓާ ނުގުޅި ހުންނަ ސަރފޭސްއަކުން ފޮނުވާ އެއްޗެއް.",
      "run": "ނެރެލާ",
      "running": "ހިސާބުކުރަނީ",
      "idle": "ތަކެއްޗަކާއި ޢަދަދެއް ޚިޔާރުކުރައްވާ، އެއަށްފަހު އަގު ނެރުއްވާ. އެއްވެސް އެއްޗަކަށް އަގު ދެވި، ރެކޯޑްކުރެވިގެނެއް ނުދާނެއެވެ."
    }
  },
  "close": {
    "nav": {
      "label": "ކްލޯޒް ކޮކްޕިޓްގެ ބައިތައް",
      "board": "ބޯޑް",
      "readiness": "ތައްޔާރީ",
      "runs": "ރަންތައް",
      "calendars": "ކަލަންޑަރުތައް"
    },
    "routeTitles": {
      "board": "ކްލޯޒް ބޯޑް",
      "readiness": "ކްލޯޒް ތައްޔާރީ",
      "runs": "ކްލޯޒް ރަންތައް",
      "cockpit": "ކްލޯޒް ކޮކްޕިޓް",
      "calendars": "ކްލޯޒް ކަލަންޑަރުތައް",
      "calendar": "ކްލޯޒް ކަލަންޑަރު"
    },
    "taskStatuses": {
      "pending": "މަޑުކުރެވިފައި",
      "blocked": "ހުއްޓިފައި",
      "ready": "ތައްޔާރު",
      "in_progress": "ކުރިއަށްދަނީ",
      "completed": "ނިމިފައި",
      "accepted": "ބަލައިގަނެފައި",
      "skipped": "ދޫކޮށްލެވިފައި",
      "failed": "ފެއިލްވެފައި"
    },
    "runStatuses": {
      "not_started": "ފެށިފައި ނުވޭ",
      "in_progress": "ކުރިއަށްދަނީ",
      "ready": "ސެޓިފައި ކުރަން ތައްޔާރު",
      "certified": "ސެޓިފައި ކުރެވިފައި",
      "closed": "ބަންދުކުރެވިފައި",
      "abandoned": "ދޫކޮށްލެވިފައި"
    },
    "taskKinds": {
      "manual": "މެނުއަލް",
      "readiness": "ތައްޔާރީ ޗެކް",
      "obligation": "ޒިންމާ",
      "action": "އެކްޝަން"
    },
    "scopes": {
      "monthly": "މަހުން މަހަށް",
      "quarterly": "ކުއާޓަރލީ",
      "annual": "އަހަރީ"
    },
    "severities": {
      "blocking": "ކްލޯޒް ހުއްޓުވާ",
      "advisory": "ލަފާ ދޭ"
    },
    "evidenceKinds": {
      "attachment": "އެޓޭޗްމަންޓް",
      "report": "ރިޕޯޓް",
      "reconciliation": "ރިކޮންސިލިއޭޝަން",
      "assertion": "އެސާޝަން",
      "certification": "ސެޓިފިކޭޝަން",
      "signoff": "ސޮއި",
      "trial_balance": "ޓްރަޔަލް ބެލެންސް"
    },
    "signoffKinds": {
      "task": "މަސައްކަތުގެ ސޮއި",
      "preparer": "ތައްޔާރުކުރި ފަރާތް",
      "reviewer": "ރިވިއު ކުރި ފަރާތް",
      "certifier": "ސެޓިފައި ކުރި ފަރާތް",
      "reconciliation": "ރިކޮންސިލިއޭޝަން ސެޓްފިކޭޝަން"
    },
    "board": {
      "title": "ކްލޯޒް ބޯޑް",
      "description": "ހުރިހާ ކުންފުންޏެއްގެ ކްލޯޒް އެއް ތަނެއްގައި. ހުއްޓިފައި އަދި ލަސްވެފައި ވަނީ ސަމާލުކަން ބޭނުންވާ ދެ އަދަދު.",
      "company": "ކުންފުނި",
      "period": "މުއްދަތު",
      "status": "ހާލަތު",
      "progress": "ކުރިއެރުން",
      "blocked": "ހުއްޓިފައި",
      "overdue": "ލަސްވެފައި",
      "target": "އަމާޒު",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "noCalendar": "ކްލޯޒް ކަލަންޑަރެއް ނެތް",
      "openRun": "ރަން އެއް ހުޅުވާ",
      "cockpit": "ކޮކްޕިޓް",
      "tableLabel": "ކުންފުނިތަކުގެ ކްލޯޒް ހާލަތު",
      "emptyTitle": "ބަންދުކުރަން ކުންފުންޏެއް ނެތް",
      "emptyDescription": "ފިސްކަލް ކަލަންޑަރެއް ލިބުމުން ކުންފުނި މިތާ ފެންނާނެ. ފުރަތަމަ އޯގަނައިޒޭޝަން ބައިން އެއް ހަދާ.",
      "loadFailed": "ކްލޯޒް ބޯޑް ލޯޑެއް ނުކުރެވުނު"
    },
    "readiness": {
      "title": "ކްލޯޒް ތައްޔާރީ",
      "description": "ރަން އެއް ހުޅުވުމުގެ ކުރިން، ކޮންމެ ސަބް-ލެޖަރެއް މުއްދަތާ މެދު ބުނާ އެއްޗެއް މިހާރު ހިސާބުކުރެވިފައި.",
      "loadFailed": "ތައްޔާރީ ބެލޭގޮތެއް ނުވި",
      "choosePeriod": "މުއްދަތެއް ހޮވާ",
      "chooseTitle": "ކުންފުންޏަކާއި މުއްދަތެއް ހޮވާ",
      "chooseDescription": "ތައްޔާރީ ބެލެނީ އެއް ކުންފުނީގެ އެއް ފިސްކަލް މުއްދަތަށް. ދެ އެތި ހޮވުމުން ހުރިހާ ޗެކެއް ހިނގާނެ.",
      "blockingCount": "ހުއްޓުވާ",
      "advisoryCount": "ލަފާ ދޭ",
      "evaluatedAt": "ބެލި ވަގުތު",
      "allClear": "މި މުއްދަތު ބަންދުކުރުމަށް ހުރަހެއް ނެތް. ރަންގެ މުހިންމު މަސައްކަތްތަކުގައި ސޮއިކުރުމުން ލެޖަރު ބަންދުކުރެވޭނެ.",
      "blockingTitle": "ހުއްޓުވާ ޗެކްތައް",
      "blockingDescription": "މީގެ ކޮންމެ އެއްޗެއް ސާފުކުރެވެންދެން، ނުވަތަ ސަބަބަކާއެކު ބަލައިގަނެވެންދެން، މުއްދަތު ބަންދެއް ނުކުރެވޭނެ.",
      "noBlockingTitle": "ހުއްޓުވާ ޗެކެއް ނެތް",
      "noBlockingDescription": "މި މުއްދަތުގެ ހުރިހާ ހުއްޓުވާ ޗެކެއް ފުރިހަމަ.",
      "advisoryTitle": "ލަފާ ދޭ ޗެކްތައް",
      "advisoryDescription": "ކުއްލި ސިހުމެއް ނާންނާނެހެން ދައްކާލެވިފައި. މީގެ އެއްވެސް އެއްޗެއް ކްލޯޒް ހުއްޓުވައެއް ނުލާނެ.",
      "noAdvisoryTitle": "ލަފާ ދޭ ޗެކެއް ނެތް",
      "noAdvisoryDescription": "މި މުއްދަތާ ބެހޭ ފާހަގައެއް ނެތް.",
      "failingTitle": "މި ރަންގައި ފެއިލްވެފައިވާ ޗެކްތައް",
      "failingDescription": "އެންމެ ފަހުގެ ރިފްރެޝްގައި ތައްޔާރު ނޫންކަމަށް ބުނި ހުރިހާ ޗެކެއް.",
      "ready": "ތައްޔާރު",
      "goClear": "ގޮސް ސާފުކުރޭ",
      "genericMessage": "{key} — ނުނިމި {count}",
      "providerError": "ޗެކް ނުހިންގުނު: {error}",
      "assets": {
        "controlReconciles": "ފިކްސްޑް އެސެޓް ރެޖިސްޓަރ ލެޖަރާ ހަމަވެއެވެ"
      },
      "gl": {
        "anomaliesDisposed": "ކްލޯޒް އެނޮމަލީ ފައިންޑިންގތަކަށް ހުރިހާ ގޮތަކުން ނިންމާފައި ({count} ހުޅުވިފައި)",
        "anomaliesNotScanned": "މި މުއްދަތަށް އެނޮމަލީ ސްކޭން ހިންގާ.",
        "anomaliesStale": "ފަހުގެ އެނޮމަލީ ސްކޭނަށް ފަހު އެންޓްރީތައް ޕޯސްޓް ކުރެވިފައިވޭ — އަނެއްކާ ހިންގާ."
      }
    },
    "lanes": {
      "title": "މަސައްކަތުގެ ގްރާފް",
      "description": "ބަރޯސާވުމުގެ ފުންމިނަށް ތަރުތީބުކުރެވިފައި. އެއް ލޭންގައިވާ ދެ މަސައްކަތް އެކަކު އަނެކަކު ހުއްޓުވައެއް ނުލާނެ.",
      "lane": "ލޭން {n}",
      "emptyTitle": "ގުޅޭ މަސައްކަތެއް ނެތް",
      "emptyDescription": "މަތީގައިވާ ހާލަތުގެ ފިލްޓަރު ސާފުކުރޭ، ނުވަތަ މި ރަންއަށް މަސައްކަތެއް އިތުރުކުރޭ."
    },
    "run": {
      "title": "ކްލޯޒް — {period}",
      "description": "{company} · {calendar}",
      "listTitle": "ކްލޯޒް ރަންތައް",
      "listDescription": "ކޮންމެ ކަލަންޑަރަކަށް ކޮންމެ ފިސްކަލް މުއްދަތަކަށް އެއް ރަން. އެއް ޖޯޑެއް ދެ ފަހަރު ހުޅުވުން ގަބޫލެއް ނުކުރެވޭނެ.",
      "loadFailed": "މި ކްލޯޒް ރަން ލޯޑެއް ނުކުރެވުނު",
      "company": "ކުންފުނި",
      "period": "މުއްދަތު",
      "calendar": "ކަލަންޑަރު",
      "progress": "ނިމިފައި",
      "blocked": "ހުއްޓިފައި",
      "overdue": "ލަސްވެފައި",
      "blockingChecks": "ހުއްޓުވާ ޗެކްތައް",
      "target": "އަމާޒު ތާރީޚު",
      "targetHint": "މުއްދަތު ނިމުމަށްފަހު ކަލަންޑަރުގެ މަސައްކަތު ދުވަހުގެ އަމާޒަށް ޑިފޯލްޓްވާނެ.",
      "certifiedAt": "ސެޓިފައި ކުރި",
      "tableLabel": "ކްލޯޒް ރަންތައް",
      "emptyTitle": "އަދި ކްލޯޒް ރަން އެއް ނެތް",
      "emptyDescription": "ބަންދުކުރާ މުއްދަތަށް އެއް ހުޅުވާ — އެއިރުން ކަލަންޑަރުގެ މަސައްކަތުގެ ގްރާފް އުފެދޭނެ.",
      "refresh": "ތައްޔާރީ ރިފްރެޝްކުރޭ",
      "refreshed": "ތައްޔާރީ އަލުން ބެލިއްޖެ",
      "refreshFailed": "ތައްޔާރީ އަލުން ބެލޭގޮތެއް ނުވި",
      "open": "ރަން އެއް ހުޅުވާ",
      "openTitle": "ކްލޯޒް ރަން އެއް ހުޅުވާ",
      "openDescription": "ކަލަންޑަރުގެ ޓެމްޕްލޭޓްތައް މި ރަންގެ މަސައްކަތްތަކަށް ބަދަލުވާނެ. ފަހުން ޓެމްޕްލޭޓް ބަދަލުކުރުމުން ރަން ބަދަލެއް ނުވާނެ.",
      "opened": "ކްލޯޒް ރަން ހުޅުވިއްޖެ",
      "openFailed": "ކްލޯޒް ރަން ނުހުޅުވުނު",
      "noCalendar": "މި ކުންފުނީގައި ހަރަކާތްތެރި ކްލޯޒް ކަލަންޑަރެއް ނެތް. ފުރަތަމަ އެއް ހަދާ.",
      "readyHint": "މުހިންމު ހުރިހާ މަސައްކަތެއް ފުރިހަމަ. މިހާރު ރަން ސެޓިފައި ކުރެވިދާނެ.",
      "solePreparer": "މި ރަންގެ ހުރިހާ މަސައްކަތެއްގައި ސޮއިކުރީ ތިޔަ ފަރާތުން ކަމުން، ސެޓިފައި ކުރެވޭކަށް ނެތް. އެހެން ފަރާތަކުން ސޮއިކުރަން ޖެހޭ.",
      "certify": "ސެޓިފައި ކުރޭ",
      "certifyTitle": "މި ކްލޯޒް ސެޓިފައި ކުރޭ",
      "certifyDescription": "ސެޓިފިކޭޝަން އަކީ ރެކޯޑަށް ދޭ ބަޔާނެއް. ދެވަނަ ފެކްޓަރު ބޭނުންވާނެ.",
      "certifyHint": "ސެޓިފައި ކުރާ ފަރާތަކީ ހަމައެކަނި ތައްޔާރުކުރި ފަރާތަށް ވެގެން ނުވާނެ.",
      "statement": "ސެޓިފިކޭޝަން ބަޔާން",
      "statementHint": "ތިޔަ ފަރާތުން ކަށަވަރުކޮށްދޭ އެއްޗެއް. މިއީ ރަންގައި ރައްކާކުރެވި، އެވިޑެންސް ޕެކްގެ ކަވަރުގައި ޗާޕުވާނެ އެއްޗެއް.",
      "certified": "ކްލޯޒް ސެޓިފައި ކުރެވިއްޖެ",
      "certifiedBy": "{at} ގައި {who} ސެޓިފައި ކުރި. އެވިޑެންސް ހޭޝް {hash}.",
      "certifyFailed": "މި ކްލޯޒް ސެޓިފައި ނުކުރެވުނު",
      "abandon": "ދޫކޮށްލާ",
      "abandonTitle": "މި ކްލޯޒް ރަން ދޫކޮށްލާ",
      "abandonDescription": "ރަންގެ މަސައްކަތް ހުއްޓޭނެ. މުއްދަތުގެ ހާލަތަށް ބަދަލެއް ނާންނާނެ.",
      "abandoned": "ކްލޯޒް ރަން ދޫކޮށްލެވިއްޖެ",
      "abandonFailed": "ކްލޯޒް ރަން ދޫކޮށެއް ނުލެވުނު"
    },
    "task": {
      "code": "ކޯޑް",
      "kind": "ބާވަތް",
      "due": "ސުންގަޑި",
      "noDue": "ސުންގަޑިއެއް ނެތް",
      "owner": "ވެރިފަރާތް",
      "unassigned": "ހަވާލުކުރެވިފައި ނުވޭ",
      "mandatory": "މަޖުބޫރު",
      "mandatoryYes": "ކްލޯޒް ހުއްޓުވާ",
      "mandatoryNo": "ލަފާ ދޭ",
      "advisoryTask": "ލަފާ ދޭ — ކްލޯޒް ހުއްޓުވައެއް ނުލާނެ",
      "signedOffBy": "ސޮއިކުރި ފަރާތް",
      "dueOn": "ސުންގަޑި {date}",
      "overdueOn": "{date} އިން ފެށިގެން ލަސްވެފައި",
      "blockedBy": "{tasks} އަށް އިންތިޒާރުކުރަނީ",
      "blockedDetail": "{tasks} ފުރިހަމަ ނުވަނީސް މި މަސައްކަތް ނުނިންމޭނެ.",
      "noForce": "މަޖުބޫރުކުރެވޭ ގޮތެއް ނެތް. ކުރީގެ މަސައްކަތް ސާފުކުރޭ، ނުވަތަ ސަބަބަކާއެކު ބަލައިގަނޭ.",
      "acceptedFor": "ބަލައިގަނެފައި — {reason}",
      "acceptedDetail": "{reason} ސަބަބާއެކު ބަލައިގަނެފައި. {note}",
      "skippedFor": "ދޫކޮށްލެވިފައި — {reason}",
      "skippedDetail": "ދޫކޮށްލެވިފައި: {reason}. ޗެކް ނުހިނގާތީ މިތާ އެއްވެސް އެއްޗެއް ކަށަވަރެއް ނުކުރެވޭ.",
      "failedDetail": "ޗެކް ނުހިންގުނު. ތައްޔާރީ ރިފްރެޝްކުރޭ؛ އަދިވެސް ފެއިލްވާނަމަ، އެއީ ޕްރޮވައިޑަރުގެ ކުށެއް.",
      "obligationCount": "{total} ން {done} ފުރިހަމަ",
      "satisfied": "ފުރިހަމަ",
      "outstanding": "ނުނިމި",
      "resultDoc": "{docType} #{docId} އުފެއްދި",
      "runAction": "ހިންގާ",
      "actionRan": "އެކްޝަން ނިމިއްޖެ",
      "actionFailed": "އެކްޝަން ނުހިންގުނު",
      "complete": "ނިންމާ",
      "completeTitle": "މި މަސައްކަތުގައި ސޮއިކުރޭ",
      "completed": "މަސައްކަތް ނިމިއްޖެ",
      "completeFailed": "މަސައްކަތް ނުނިންމުނު",
      "statement": "އެވިޑެންސް ބަޔާން",
      "statementHint": "މި ޓެމްޕްލޭޓަށް އެވިޑެންސް ބޭނުންވޭ. މިތާ ލިޔާ އެއްޗެއް ސޮއިގެ ގޮތުގައި ރައްކާވެ، އެވިޑެންސް ޕެކަށް ދާނެ.",
      "note": "ނޯޓް",
      "accept": "ފެއިލްވުން ބަލައިގަނޭ",
      "acceptTitle": "ފެއިލްވެފައިވާ ޗެކެއް ބަލައިގަނޭ",
      "acceptDescription": "ޗެކުން ނޫނެކޭ ބުނަނީ. ބަލައިގަތުމުން ކްލޯޒް ކުރިއަށްދާނެ، އަދި ސަބަބު ރެކޯޑަށް އަރާނެ.",
      "acceptWarning": "މިއިން އެއްވެސް އެއްޗެއް ރަނގަޅެއް ނުވާނެ. މިއިން ރެކޯޑުވަނީ ތިޔަ ފަރާތުން ކްލޯޒް ކުރިއަށް ގެންދަން ނިންމިކަން.",
      "accepted": "ފެއިލްވި ޗެކް ބަލައިގަނެވިއްޖެ",
      "acceptFailed": "ޗެކް ބަލައެއް ނުގަނެވުނު",
      "reopen": "އަލުން ހުޅުވާ",
      "reopenTitle": "މި މަސައްކަތް އަލުން ހުޅުވާ",
      "reopened": "މަސައްކަތް އަލުން ހުޅުވިއްޖެ",
      "reopenFailed": "މަސައްކަތް އަލުން ނުހުޅުވުނު",
      "assign": "ހަވާލުކުރޭ",
      "assignTitle": "މި މަސައްކަތް ހަވާލުކުރޭ",
      "assigneeUserId": "ހަވާލުވާ ފަރާތުގެ ޔޫޒަރ އައިޑީ",
      "assigneeHint": "ހުސްކޮށް ބެހެއްޓުމުން ހަވާލުކުރުން ނަގާ، ވެރި މަގާމަށް ރުޖޫއަވާނެ.",
      "assigned": "މަސައްކަތް ހަވާލުކުރެވިއްޖެ",
      "assignFailed": "މަސައްކަތް ހަވާލެއް ނުކުރެވުނު"
    },
    "evidence": {
      "title": "އެވިޑެންސް",
      "description": "އޮޑިޓަރަށް ދޭނެ އެއްޗެހި. ކޮންމެ އެއްޗެއް ހޭޝްކުރެވިފައި.",
      "build": "އެވިޑެންސް ޕެކް ހަދާ",
      "built": "އެވިޑެންސް ޕެކް ހެދިއްޖެ",
      "builtDetail": "{count} އެއްޗެއް",
      "buildFailed": "އެވިޑެންސް ޕެކް ނުހެދުނު",
      "hashChanged": "އަލުން ހެދިއްޖެ — މެނިފެސްޓް ހޭޝް ސެޓިފައި ކުރި ހޭޝްއާ ތަފާތު",
      "download": "ޕެކް ޑައުންލޯޑްކުރޭ",
      "downloadFailed": "އެވިޑެންސް ޕެކް ޑައުންލޯޑް ނުކުރެވުނު",
      "rows": "{count} ރޯ",
      "emptyTitle": "އަދި އެވިޑެންސް އެއް ނެތް",
      "emptyDescription": "ޕެކް ހަދާ — އެއިރުން ރަން މެނިފެސްޓާއި ސޮއިގެ ރަޖިސްޓަރީ އުފެދޭނެ."
    },
    "signoffs": {
      "title": "ސޮއިތައް",
      "description": "ކާކު ކޮންއެއްޗެއްގައި ސޮއިކުރިކަމާއި، އޭރު ހުރި މަގާމު.",
      "line": "{who} — {kind}"
    },
    "calendar": {
      "listTitle": "ކްލޯޒް ކަލަންޑަރުތައް",
      "listDescription": "ކަލަންޑަރަކީ ކްލޯޒް ޕްލޭނެއް: މަސައްކަތުގެ ގްރާފަކާއި މަސައްކަތު ދުވަހުގެ އަމާޒެއް.",
      "loadFailed": "ކްލޯޒް ކަލަންޑަރުތައް ލޯޑެއް ނުކުރެވުނު",
      "create": "އައު ކަލަންޑަރު",
      "createTitle": "އައު ކްލޯޒް ކަލަންޑަރު",
      "createDescription": "ކޯޑަކާއި ބާވަތެއް ދީ، ދެން މަސައްކަތުގެ ގްރާފް ހަދާ.",
      "created": "ކްލޯޒް ކަލަންޑަރު ހެދިއްޖެ",
      "createFailed": "ކްލޯޒް ކަލަންޑަރު ނުހެދުނު",
      "code": "ކޯޑް",
      "name": "ނަން",
      "scope": "ބާވަތް",
      "targetWorkingDays": "އަމާޒު ދުވަސް",
      "targetHint": "މުއްދަތު ނިމުމަށްފަހު މަސައްކަތު ދުވަސް، ބިޒްނަސް ކަލަންޑަރުން ގުނާ.",
      "templates": "މަސައްކަތްތައް",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓިފައި",
      "tableLabel": "ކްލޯޒް ކަލަންޑަރުތައް",
      "emptyTitle": "ކްލޯޒް ކަލަންޑަރެއް ނެތް",
      "emptyDescription": "އެއް ހަދާ، ދެން ޑިފޯލްޓް މަސައްކަތްތައް ސީޑްކުރޭ."
    },
    "templates": {
      "title": "މަސައްކަތު ޓެމްޕްލޭޓް — {code}",
      "description": "ރަން އެއް އުފައްދާ ޕްލޭން. މިތާ ކުރާ ބަދަލުތަކުން ހުޅުވިފައިވާ ރަން އެއް ބަދަލެއް ނުވާނެ.",
      "loadFailed": "ކަލަންޑަރު ލޯޑެއް ނުކުރެވުނު",
      "gridTitle": "ޓެމްޕްލޭޓްތައް",
      "gridDescription": "ސީކުއެންސް އަކީ ދެއްކުމުގެ ތަރުތީބު؛ ހިނގާ ތަރުތީބު ކަނޑައަޅަނީ ގްރާފުން.",
      "addRow": "މަސައްކަތެއް އިތުރުކުރޭ",
      "removeRow": "ނަގާ",
      "emptyTitle": "މި ކަލަންޑަރުގައި މަސައްކަތެއް ނެތް",
      "emptyDescription": "ޑިފޯލްޓް ޕްލޭން ސީޑްކުރޭ، ނުވަތަ އެކަކަށްފަހު އެކަކު އިތުރުކުރޭ.",
      "seedDefaults": "ޑިފޯލްޓް ޕްލޭން ސީޑްކުރޭ",
      "seeded": "ޑިފޯލްޓް ޕްލޭން ސީޑްކުރެވިއްޖެ",
      "seedFailed": "ޑިފޯލްޓް ޕްލޭން ސީޑެއް ނުކުރެވުނު",
      "saved": "މަސައްކަތު ޓެމްޕްލޭޓް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "މަސައްކަތު ޓެމްޕްލޭޓް ރައްކާއެއް ނުކުރެވުނު",
      "cycleDetected": "މި މަސައްކަތްތައް އެކަކު އަނެކަކަށް ބުރެއްގެ ގޮތުގައި ބަރޯސާވޭ: {codes}. ރައްކާކުރުމުގެ ކުރިން ބުރު ކަނޑާ.",
      "invalidRows": "ކޮންމެ މަސައްކަތަކަށް ކޯޑަކާއި ނަމެއް ބޭނުންވޭ، އަދި ބަނދެވޭ ކީ ވެސް ބޭނުންވޭ.",
      "seq": "ސީކް",
      "code": "ކޯޑް",
      "name": "ނަން",
      "kind": "ބާވަތް",
      "binding": "ބަނދެވިފައި",
      "dueOffset": "ސުންގަޑި +ދުވަސް",
      "flags": "ފްލެގްތައް",
      "dependsOn": "ބަރޯސާވަނީ",
      "mandatory": "މަޖުބޫރު",
      "evidence": "އެވިޑެންސް",
      "readinessKey": "ތައްޔާރީ ކީ",
      "actionKey": "އެކްޝަން ކީ",
      "obligationKind": "ޒިންމާގެ ބާވަތް",
      "manualBinding": "އަތުން ސޮއިކުރެވޭ",
      "addDependency": "ބަރޯސާވުމެއް އިތުރުކުރޭ",
      "removeDependency": "{code} އަށް ބަރޯސާވުން ނަގާ"
    },
    "anomaly": {
      "driver": {
        "balanceSpike": "{movement} ގެ ހަރަކާތަކީ އެކައުންޓުގެ އާދައިގެ {mean} އަށްވުރެ {direction} އެސްޓީޑީ {z} ގެ ތަފާތެއް.",
        "signFlip": "{stablePeriods} މުއްދަތު އެއް ފަރާތުގައި ހުރުމަށްފަހު {closingBalance} ގެ ބަންދު ބާކީ {from} އިން {to} އަށް ބަދަލުވެއްޖެ.",
        "dormantActivity": "{silentPeriods} މުއްދަތު އެކައުންޓުގައި ހަރަކާތެއް ނެތިއްޖެ، މިހާރު {grossActivity} އަށް {currentLines} ލައިން އެބަހުރި.",
        "roundAmountJournal": "ޖާނަލްގެ ޖުމްލަ {total} އަކީ {roundUnit} ގެ ސީދާ ގުނަވަނެއް.",
        "unusualPreparer": "މި ޖާނަލް ތައްޔާރުކުރި މީހަކު މީގެކުރިން މި އެކައުންޓަށް ތައްޔާރުކޮށްފައެއް ނުވޭ؛ އެހެން {distinctPreparers} މީހަކު {priorEntries} އެންޓްރީއަކުން ތައްޔާރުކޮށްފައި.",
        "weekendPost": "{weekday} {postedOn} ގައި {postedAt} ގައި ޕޯސްޓްކުރެވިފައި، އެއީ ވަޒީފާގެ ދުވަހެއް ނޫން."
      }
    },
    "ft13": {
      "common": {
        "legalEntity": "ޤާނޫނީ ފަރާތް",
        "allPeriods": "ހުރިހާ މުއްދަތެއް",
        "you": "ތިޔަބޭފުޅާ"
      },
      "routeTitles": {
        "certifications": "ކްލޯޒް ސެޓްފިކޭޝަންތައް",
        "reconciliation": "ސަބް-ލެޖަރ ރިކޮންސިލިއޭޝަން",
        "evidencePacks": "ކްލޯޒްގެ ހެކި ޕެކްތައް",
        "cycleAnalysis": "ކްލޯޒް ސައިކަލް ތަހުލީލު",
        "statements": "މާލީ ބަޔާންތައް",
        "statement": "މާލީ ބަޔާންތަކުގެ ސެޓް"
      },
      "reconTypes": {
        "bank": "ބޭންކް",
        "ap": "ދައްކަންޖެހޭ ފައިސާ",
        "ar": "ލިބެންޖެހޭ ފައިސާ",
        "inventory": "އިންވެންޓަރީ",
        "fixed_assets": "ފިކްސްޑް އެސެޓްސް",
        "run": "ކްލޯޒް ރަން"
      },
      "certify": {
        "action": "ރިކޮންސިލިއޭޝަނެއް ސެޓްފައިކުރޭ",
        "title": "ރިކޮންސިލިއޭޝަނެއް ސެޓްފައިކުރޭ",
        "description": "މި ރިކޮންސިލިއޭޝަން ފުރިހަމަ އަދި ރަނގަޅުކަމުގެ ޝަޚްސީ ޔަގީންކަން، ތިޔަބޭފުޅާގެ ނަމާއި ވަގުތާއި ބިނާކުރާ ހެއްކާއެކު ރެކޯޑުކުރެވޭ. ދެވަނަ ފެކްޓަރެއް ބޭނުންވޭ.",
        "hint": "ތިޔަބޭފުޅާ ތައްޔާރުކުރި ރިކޮންސިލިއޭޝަނެއް ސެޓްފައި ނުކުރެވޭނެ. ކޮންޓްރޯލް އެކައުންޓާ ދިމާނުވާ ސަބް-ލެޖަރެއް، ތަފާތު ސާފުކުރެވޭހާ ހިނދަކު ނުވަތަ ޓާސްކުގައި ގަބޫލުކުރެވޭހާ ހިނދަކު ސެޓްފައި ނުކުރެވޭނެ.",
        "type": "ރިކޮންސިލިއޭޝަން",
        "evidence": "ހެކި",
        "evidenceHint": "ޔަގީންކަމުގެ ބިންގާ: PDF، ފޮޓޯ، ސްޕްރެޑްޝީޓް، ވޯޑް ނުވަތަ CSV، {max} MB އަށް. ކްލޯޒް ރަނާއެކު ރައްކާކުރެވި ހެކި ޕެކަށް ވަންނާނެ.",
        "note": "ބަޔާން",
        "noteHint": "އިޚްތިޔާރީ. ތިޔަ ޗެކްކުރި ކަންތައް، ތިޔަބޭފުޅާގެ ބަހުން.",
        "confirm": "ސެޓްފައިކުރޭ",
        "certified": "ރިކޮންސިލިއޭޝަން ސެޓްފައިކުރެވިއްޖެ",
        "failed": "ރިކޮންސިލިއޭޝަން ސެޓްފައި ނުކުރެވުނު",
        "uploadFailed": "ހެކި ފައިލް ރައްކާ ނުކުރެވުނު",
        "unavailable": {
          "certified": "މި ކްލޯޒް ރަނުގައި ކުރިން ސެޓްފައިކުރެވިފައި.",
          "preparer": "މި ރިކޮންސިލިއޭޝަން ތައްޔާރުކުރީ ތިޔަބޭފުޅާ، އެހެންވީމާ އެހެން މީހަކު ސެޓްފައިކުރަން ޖެހޭ.",
          "sole_preparer": "މި ކްލޯޒްގެ ހުރިހާ ޓާސްކެއް ސައިން އޮފްކުރީ ތިޔަބޭފުޅާ، އެހެންވީމާ މި ރިކޮންސިލިއޭޝަން ސެޓްފައިކުރަން ދެވަނަ މީހަކު ބޭނުންވޭ.",
          "no_preparer": "މި ކްލޯޒްގައި އަދި އެއްވެސް ޓާސްކެއް ސައިން އޮފް ނުކުރޭ، އެހެންވީމާ ސެޓްފައިކުރާނެ ތައްޔާރުކުރެވުނު މަސައްކަތެއް ނެތް.",
          "not_reconciled": "ސަބް-ލެޖަރ އޭގެ ކޮންޓްރޯލް އެކައުންޓާ ދިމާއެއް ނުވޭ. ތަފާތު ސާފުކުރައްވާ، ނުވަތަ ކްލޯޒް ޓާސްކުގައި ސަބަބާއެކު ގަބޫލުކުރައްވާ.",
          "not_entitled": "މި ސަބް-ލެޖަރގެ މޮޑިއުލް ތިޔަ ޕްލޭނުގައި ނެތް، އެހެންވީމާ ސެޓްފައިކުރާނެ އެއްޗެއް ނެތް."
        },
        "errors": {
          "sod": "މި ރިކޮންސިލިއޭޝަން ތައްޔާރުކުރީ ތިޔަބޭފުޅާ، އެހެންވީމާ ސެޓްފައިވެސް ނުކުރެވޭނެ. އެހެން މީހަކު ކުރަން ޖެހޭ.",
          "notReady": "ސަބް-ލެޖަރ މިހާރު އޭގެ ކޮންޓްރޯލް އެކައުންޓާ ދިމާއެއް ނުވޭ، އެހެންވީމާ ފުރިހަމަ އަދި ރަނގަޅުކަމަށް ސެޓްފައި ނުކުރެވޭނެ. އަދަދުތައް އަލުން ބައްލަވައި ތަފާތު ސާފުކުރައްވާ.",
          "already": "މި ކްލޯޒް ރަނުގައި މި ރިކޮންސިލިއޭޝަން އެހެން މީހަކު ކުރިން ސެޓްފައިކޮށްފި. ސްކްރީން އަލުން ލޯޑުކުރެވިއްޖެ.",
          "uploadRefused": "ހެކި ފައިލް މި ކްލޯޒް ރަނާ ގުޅުވައެއް ނުލެވުނު. ސެޓްފިކޭޝަންގެ ހެކި އަޕްލޯޑުކުރެވޭތޯ ބައްލަވަން އެޑްމިނިސްޓްރޭޓަރަކަށް އެދިވަޑައިގަންނަވާ.",
          "evidenceInvalid": "ހެކި ފައިލް ގަބޫލެއް ނުކުރެވުނު. ފައިލް އަލުން ހޮވައި އަނެއްކާ މަސައްކަތްކުރައްވާ."
        }
      },
      "recon": {
        "title": "ސަބް-ލެޖަރ ރިކޮންސިލިއޭޝަން",
        "description": "ކޮންމެ ސަބް-ލެޖަރއެއް ޖެނެރަލް ލެޖަރގެ ކޮންޓްރޯލް އެކައުންޓްތަކާ އަޅާކިޔައި، ކޮންމެ ތަފާތެއް އެކައުންޓުން ވަކިވަކިން، އަދި އޭގެ ފަހަތުގައިވާ އެންޓްރީތަކަށް ޑްރިލް-ޑައުން.",
        "loadFailed": "ރިކޮންސިލިއޭޝަން ހިސާބު ނުކުރެވުނު",
        "chooseDescription": "ރިކޮންސިލިއޭޝަން ހިސާބުކުރަނީ އެއް ޤާނޫނީ ފަރާތެއްގެ މާލީ މުއްދަތަކަށް. ދެކަންތައް ހޮއްވަވާ، ދެން ކޮންމެ ސަބް-ލެޖަރއެއް އަޅާކިޔާނެ.",
        "state": "ހާލަތު",
        "reconciled": "ރިކޮންސައިލްވެފައި",
        "notReconciled": "ތަފާތުތައް",
        "differences": "ދިމާނުވާ ސަބް-ލެޖަރތައް",
        "blocksClose": "ސަބް-ލެޖަރ {count} ޖެނެރަލް ލެޖަރާ ދިމާއެއް ނުވޭ. ކޮންމެ އެއްޗެއް ސާފުކުރެވޭހާ ހިނދަކު ނުވަތަ ގަބޫލުކުރެވޭހާ ހިނދަކު މުއްދަތު ބަންދުކުރުން ދެކޮޅުޖަހާނެ.",
        "noRun": "މި މުއްދަތުގައި ހުޅުވިފައިވާ ކްލޯޒް ރަނެއް ނެތް، އެހެންވީމާ އަދި ސެޓްފިކޭޝަން ރެކޯޑެއް ނުކުރެވޭނެ.",
        "noRunLink": "ކްލޯޒް ރަނެއް ހުޅުއްވާ",
        "onRun": "ސެޓްފިކޭޝަންތައް ރެކޯޑުކުރެވެނީ ކްލޯޒް ރަން {run} ގައި.",
        "emptyTitle": "އަޅާކިޔާނެ ސަބް-ލެޖަރއެއް ނެތް",
        "emptyDescription": "ކޮންޓްރޯލް އެކައުންޓެއް ބަހައްޓާ އެއްވެސް ސަބް-ލެޖަރއެއް މި ޤާނޫނީ ފަރާތުގައި ބޭނުންނުކުރޭ.",
        "skipped": "ޕްލޭނުގައި ނެތް",
        "failed": "އަޅާނުކިޔެވުނު",
        "agrees": "ދިމާވޭ",
        "disagrees": "ދިމާނުވޭ",
        "skippedDetail": "މި ސަބް-ލެޖަރގެ މޮޑިއުލް ތިޔަ ޕްލޭނުގައި ނެތް. އެއްވެސް އެއްޗެއް ފޮރުވިފައި ނުވާތީ ރިޕޯޓުކުރެވޭ، އަދި ކްލޯޒް ދުވަހަކުވެސް ބްލޮކެއް ނުކުރާނެ.",
        "subLedgerBalance": "ސަބް-ލެޖަރ",
        "controlBalance": "ޖެނެރަލް ލެޖަރ",
        "difference": "ތަފާތު",
        "accountsDiffering": "ތަފާތުވާ އެކައުންޓްތައް",
        "basis": "އަޅާކިޔެވުނު ތާރީޚު",
        "basisNow": "މިހާރު (ސަބް-ލެޖަރގައި ތާރީޚެއް ނުބެހެއްޓޭ)",
        "basisAsOf": "{date}",
        "certifiedBy": "{who} {at} ގައި ސެޓްފައިކުރި. ހެކި: {file}.",
        "accountsCaption": "{subledger} ކޮންޓްރޯލް އެކައުންޓްތައް",
        "account": "އެކައުންޓް",
        "role": "ދައުރު",
        "drillDown": "އެންޓްރީތައް",
        "roles": {
          "control": "ކޮންޓްރޯލް",
          "cost": "ޚަރަދު",
          "accumulated_depreciation": "ޖަމާވެފައިވާ ޑިޕްރިސިއޭޝަން"
        }
      },
      "certifications": {
        "title": "ކްލޯޒް ސެޓްފިކޭޝަންތައް",
        "description": "ކޮންމެ ރިކޮންސިލިއޭޝަނާއި ކްލޯޒް ސެޓްފިކޭޝަނެއް: ޔަގީންކޮށްދިން މީހާ، އޭރު ހުރި މަޤާމު، ވަގުތު، އަދި ބިނާކުރާ ހެކި.",
        "anyType": "ކޮންމެ ބާވަތެއް",
        "type": "ބާވަތް",
        "loadFailed": "ސެޓްފިކޭޝަންތައް ލޯޑު ނުކުރެވުނު",
        "emptyTitle": "އަދި ސެޓްފިކޭޝަނެއް ނެތް",
        "emptyDescription": "ރިކޮންސިލިއޭޝަން ވެރިއަކު ރިކޮންސިލިއޭޝަނެއް ސެޓްފައިކުރުމުން ނުވަތަ ކްލޯޒް ރަނެއް ސެޓްފައިކުރުމުން މިތާ ފެންނާނެ.",
        "certifiedBy": "ސެޓްފައިކުރި މީހާ",
        "certifiedAt": "ސެޓްފައިކުރި ވަގުތު",
        "statement": "ބަޔާން",
        "evidence": "ހެކި",
        "run": "ކްލޯޒް ރަން",
        "packIsEvidence": "ހެކި ޕެކް"
      },
      "packs": {
        "title": "ކްލޯޒްގެ ހެކި ޕެކްތައް",
        "description": "ކޮންމެ ކްލޯޒެއްގެ އާކައިވްކުރެވިފައިވާ ހެކި: ސެޓްފިކޭޝަންތަކާއި ރިކޮންސިލިއޭޝަންތަކާއި އެޕްރޫވަލްތައް، ޔަގީންކަމަށް މާނައެއް ލިބޭނެހެން ހޭޝްކުރެވިފައި.",
        "loadFailed": "ހެކި ޕެކްތައް ލޯޑު ނުކުރެވުނު",
        "emptyTitle": "އަދި ހެކި ޕެކެއް ނެތް",
        "emptyDescription": "ކްލޯޒް ރަނެއް ސެޓްފައިކުރުމުން، ނުވަތަ ކްލޯޒް ކޮކްޕިޓުން އެކަކު ޕެކެއް ބިނާކުރުމުން ޕެކެއް އާކައިވްކުރެވޭ.",
        "register": "ހުރިހާ ހެކި ޕެކެއް",
        "run": "ކްލޯޒް ރަން",
        "certified": "ސެޓްފައިކުރި",
        "manifestHash": "ސެޓްފައިކުރި ހޭޝް",
        "archive": "އާކައިވް",
        "parts": "ބައިތައް",
        "reconCertifications": "ރިކޮންސިލިއޭޝަން ސެޓްފިކޭޝަންތައް",
        "match": "ސެޓްފިކޭޝަނާ ދިމާވޭ",
        "actions": "ޢަމަލުތައް",
        "noHash": "ސެޓްފައި ނުކުރޭ",
        "noArchive": "ރައްކާ ނުކުރޭ",
        "chainBroken": "އޮޑިޓް ޗެއިން ޔަގީން ނުކުރެވުނު",
        "verify": "ޔަގީންކުރޭ",
        "verifyHint": "ލެޖަރުން ޕެކް އަލުން ބިނާކޮށް، އޭގެ މެނިފެސްޓް ހޭޝް ސެޓްފިކޭޝަންގައި ރެކޯޑުކުރެވުނު ހޭޝާ އަޅާކިޔާ.",
        "verifyFailed": "ހެކި ޕެކް ޔަގީން ނުކުރެވުނު",
        "state": {
          "matches": "ދިމާވޭ",
          "differs": "ތަފާތު",
          "uncertified": "ސެޓްފައިކުރި ހޭޝެއް ނެތް",
          "notVerified": "ޔަގީން ނުކުރޭ"
        }
      },
      "cycle": {
        "title": "ކްލޯޒް ސައިކަލް ތަހުލީލު",
        "description": "މުއްދަތުން މުއްދަތަށް ކްލޯޒްކުރަން ނެގޭ ދުވަސް، ކޮންމެ ކްލޯޒެއްގެ އަމާޒާ އަޅާކިޔައި، ޓްރެންޑާއި އަބަދުވެސް ލަސްވާ ޓާސްކްތަކާއެކު.",
        "allYears": "ހުރިހާ އަހަރެއް",
        "fiscalYear": "މާލީ އަހަރު",
        "loadFailed": "ސައިކަލް ތަހުލީލު ހިސާބު ނުކުރެވުނު",
        "closedCount": "ސެޓްފައިކުރެވުނު ކްލޯޒްތައް",
        "onTargetCount": "އަމާޒުގައި",
        "averageDays": "ކްލޯޒްކުރަން ނެގޭ އެވްރެޖް ދުވަސް",
        "averageTarget": "އެވްރެޖް އަމާޒު ދުވަސް",
        "trendLabel": "ޓްރެންޑް",
        "trend": {
          "improving": "ރަނގަޅުވަމުންދޭ",
          "worsening": "ދަށްވަމުންދޭ",
          "flat": "ބަދަލެއްނެތް",
          "insufficient_data": "އަދި ފުދޭވަރަށް ކްލޯޒެއް ނެތް"
        },
        "trendDelta": "ކުރީގެ ކްލޯޒްތަކާ އަޅާބަލާއިރު {days} ދުވަސް",
        "peerNote": "އެހެން ޖަމްޢިއްޔާތަކާ އަޅާކިޔުން ނުދައްކާ: އެހެން ފަރާތްތަކާ އަޅާކިޔުމަކީ ޓެނަންޓް ހުދޫދު ހުރަސްކޮށް ޑޭޓާ ކިޔުން.",
        "periodsTitle": "މުއްދަތުން މުއްދަތަށް ކްލޯޒްކުރަން ނެގޭ ދުވަސް",
        "periodsDescription": "މުއްދަތު ނިމުމުން ސެޓްފިކޭޝަނާ ހަމައަށް ކެލެންޑަރު ދުވަސް، ތިޔަ ޖަމްޢިއްޔާގެ ގަޑީގައި. ހުޅުވިފައިވާ ކްލޯޒެއްގައި މިހާތަނަށް ފާއިތުވި ދުވަސް ފެންނާނެ.",
        "emptyTitle": "ތަހުލީލުކުރާނެ ކްލޯޒެއް ނެތް",
        "emptyDescription": "ކްލޯޒް ރަނެއް ހުޅުވައި ސެޓްފައިކުރައްވާ؛ ދެން އޭގެ ދުވަސް މިތާ ފެންނާނެ.",
        "periodEnd": "މުއްދަތު ނިމޭ ތާރީޚު",
        "days": "ކްލޯޒްކުރަން ނެގުނު ދުވަސް",
        "targetDays": "އަމާޒު ދުވަސް",
        "variance": "އަމާޒާ އަޅާބަލާއިރު",
        "overdueTasks": "ލަސްވެފައިވާ ޓާސްކްތައް",
        "bar": "ދުވަސް، ބާރެއްގެ ގޮތުގައި",
        "stillOpen": "މި ކްލޯޒް އަދި ސެޓްފައި ނުކުރޭ",
        "elapsedSoFar": "މިހާތަނަށް {days}",
        "late": "{days} ދުވަސް ލަސް",
        "early": "{days} ދުވަސް ކުރިން",
        "onTheDay": "އެ ދުވަހު",
        "bottlenecksTitle": "އަބަދުވެސް ހުރަސްވާ ތަންތަން",
        "bottlenecksDescription": "ތަހުލީލުކުރެވުނު ކްލޯޒްތަކުގައި އެންމެ ގިނައިން އަމިއްލަ ޑިއު ތާރީޚަށްފަހު ނިމުނު ޓާސްކްތައް.",
        "noBottlenecksTitle": "އަބަދުވެސް ލަސްވާ އެއްޗެއް ނެތް",
        "noBottlenecksDescription": "ހުރަސްވާ ތަނެކޭ ކިޔޭވަރަށް ގިނައިން އެއްވެސް ޓާސްކެއް ލަސްވެފައެއް ނުވޭ.",
        "task": "ޓާސްކް",
        "runs": "ކްލޯޒްތައް",
        "averageAfterEnd": "މުއްދަތު ނިމުމަށްފަހު އެވްރެޖް ދުވަސް",
        "lateCount": "ލަސްވި ފަހަރު",
        "averageLate": "އެވްރެޖް ލަސްވި ދުވަސް",
        "generatedAt": "{at} ގައި ހިސާބުކުރި"
      },
      "statements": {
        "title": "މާލީ ބަޔާންތައް",
        "description": "ކޮންމެ ޤާނޫނީ ފަރާތަކާއި މުއްދަތަކަށް ފައިދާއާއި ގެއްލުން، ބެލެންސް ޝީޓް، ކޭޝް ފްލޯ އަދި އިކުއިޓީ މޫވްމަންޓް، ނަންބަރު ޖަހާފައިވާ ވާޝަންތަކެއްގެ ގޮތުގައި. ޝާއިޢުކުރެވުނު ވާޝަނަކަށް ދުވަހަކުވެސް ބަދަލެއް ނުގެނެވޭ.",
        "generate": "ބަޔާންތައް ތައްޔާރުކުރޭ",
        "loadFailed": "ބަޔާންތަކުގެ ސެޓްތައް ލޯޑު ނުކުރެވުނު",
        "loadOneFailed": "މި ބަޔާންތަކުގެ ސެޓް ލޯޑު ނުކުރެވުނު",
        "emptyTitle": "އަދި އެއްވެސް ބަޔާނެއް ތައްޔާރު ނުކުރޭ",
        "emptyDescription": "ޕްރިވިއު ކުރުމަށް ކޮންމެ ވަގުތެއްގައިވެސް މުއްދަތަކަށް ސެޓެއް ތައްޔާރުކުރެވޭނެ. މުއްދަތު ބަންދުކުރުމަށްފަހު، ތައްޔާރުކުރި މީހާ ނޫން މީހަކަށް ޝާއިޢުކުރެވޭނެ.",
        "setNo": "ސެޓް",
        "version": "ވާޝަން",
        "compareLabel": "އަޅާކިޔުން",
        "compareHint": "ފައިދާއާއި ގެއްލުމާއި ބެލެންސް ޝީޓާއި ކޭޝް ފްލޯއަށް އަޅާކިޔާ ކޮލަމެއް އިތުރުކުރޭ.",
        "generatedAt": "ތައްޔާރުކުރި",
        "publishedAt": "ޝާއިޢުކުރި",
        "statuses": {
          "generated": "ތައްޔާރުކުރެވިފައި",
          "published": "ޝާއިޢުކުރެވިފައި",
          "superseded": "ބަދަލުކުރެވިފައި"
        },
        "compare": {
          "none": "ނެތް",
          "prior_period": "ކުރީގެ މުއްދަތު",
          "prior_year": "ކުރީގެ އަހަރު"
        },
        "generated": "ބަޔާންތައް ތައްޔާރުކުރެވިއްޖެ",
        "versionOf": "ވާޝަން {version} · {setNo}",
        "generateFailed": "ބަޔާންތައް ތައްޔާރު ނުކުރެވުނު",
        "generateTitle": "މާލީ ބަޔާންތައް ތައްޔާރުކުރޭ",
        "generateDescription": "ލެޖަރުން ހަތަރު ބަޔާން އާ ވާޝަނެއްގެ ގޮތުގައި ތައްޔާރުކުރޭ. ކުރީގެ ވާޝަނެއް ދުވަހަކުވެސް ބަދަލެއް ނުކުރެވޭ.",
        "generateHint": "ކޮންމެ ވަގުތެއްގައިވެސް ތައްޔާރުކުރެވޭނެ. ޝާއިޢުކުރުމަށް މުއްދަތު ބަންދުކޮށްފައި ހުންނަން ޖެހޭ، އަދި ތިޔަބޭފުޅާ ނޫން މީހަކު ބޭނުންވޭ.",
        "detailTitle": "ބަޔާންތައް {setNo}",
        "detailDescription": "{period} · {entity} · ވާޝަން {version}",
        "downloadPdf": "PDF ޑައުންލޯޑުކުރޭ",
        "downloadXlsx": "XLSX ޑައުންލޯޑުކުރޭ",
        "downloadFailed": "ބަޔާންތައް ޑައުންލޯޑު ނުކުރެވުނު",
        "newVersion": "އާ ވާޝަނެއް ތައްޔާރުކުރޭ",
        "publish": "ޝާއިޢުކުރޭ",
        "publishTitle": "މި ބަޔާންތައް ޝާއިޢުކުރޭ",
        "publishDescription": "ޝާއިޢުކުރުމުން މި ވާޝަން ނިމުނު އެއްޗަކަށް ވެ، މުއްދަތުގެ ކުރީގެ ޝާއިޢުކުރެވުނު ވާޝަނުގެ ބަދަލުގައި ވެ، ކްލޯޒް ހެކި ޕެކާއެކު އާކައިވްކުރެވި، އޯޑިއަންސަށް ފޮނުވޭ.",
        "publishHint": "ކޮންމެ ލިބޭ މީހަކަށް މި ޞަފްޙާއަށް ލިންކަކާއެކު ނޮޓިފައިކުރެވޭނެ.",
        "published": "ބަޔާންތައް ޝާއިޢުކުރެވިއްޖެ",
        "publishFailed": "ބަޔާންތައް ޝާއިޢު ނުކުރެވުނު",
        "audience": "އޯޑިއަންސް",
        "audiences": {
          "executive": "އެގްޒެކެޓިވް",
          "finance": "ފައިނޭންސް",
          "audit": "އޮޑިޓް"
        },
        "audienceHints": {
          "executive": "ސީއެފްއޯ އާއި ޓެނަންޓް އެޑްމިނިސްޓްރޭޓަރުން",
          "finance": "ސީއެފްއޯ، ފައިނޭންސް މެނޭޖަރުން އަދި އެކައުންޓެންޓުން",
          "audit": "އޮޑިޓަރުން"
        },
        "errors": {
          "sod": "މި ވާޝަން ތައްޔާރުކުރީ ތިޔަބޭފުޅާ، އެހެންވީމާ އެހެން މީހަކު ޝާއިޢުކުރަން ޖެހޭ.",
          "periodNotClosed": "ބަޔާންތައް ޝާއިޢުކުރެވެނީ މުއްދަތު ބަންދުކުރުމަށްފަހު. މި މުއްދަތު {status}. މުއްދަތު ބަންދުކުރުމަށްފަހު ޝާއިޢުކުރައްވާ.",
          "stale": "ލެޖަރުން މިހާރު މި އަދަދުތައް ނުލިބޭ، މިސާލަކަށް ލަސްވެގެން ޕޯސްޓުކުރެވުނު އެއްޗަކާހުރެ. އާ ވާޝަނެއް ތައްޔާރުކޮށް އެއީ ޝާއިޢުކުރައްވާ.",
          "illegalTransition": "މި ވާޝަން މިހާރު ޝާއިޢެއް ނުކުރެވޭނެ: ޝާއިޢުކުރެވިފައި ނުވަތަ ބަދަލުކުރެވިފައި، ނުވަތަ އާ ވާޝަނެއް ކުރިން ޝާއިޢުކުރެވިފައި. ޞަފްޙާ އަލުން ލޯޑުކުރެވިއްޖެ."
        },
        "notes": {
          "generator": "މި ވާޝަން ތައްޔާރުކުރީ ތިޔަބޭފުޅާ، އެހެންވީމާ ޝާއިޢުކުރުމަށް ދެވަނަ މީހަކު ބޭނުންވޭ.",
          "newerPublished": "މި މުއްދަތުގެ އާ ވާޝަނެއް ކުރިން ޝާއިޢުކުރެވިފައި. ތަފާތު އަދަދުތަކެއް ޝާއިޢުކުރުމަށް އާ ވާޝަނެއް ތައްޔާރުކުރައްވާ.",
          "periodOpen": "މި މުއްދަތު {status}. ބަޔާންތައް ޝާއިޢުކުރެވެނީ މުއްދަތު ބަންދުކުރުމަށްފަހު.",
          "published": "{who} {at} ގައި {audience} އަށް ޝާއިޢުކުރި؛ {count} މީހަކަށް ފޮނުވިއްޖެ.",
          "superseded": "{at} ގައި ފަހުން ޝާއިޢުކުރެވުނު ވާޝަނަކުން ބަދަލުކުރެވިއްޖެ.",
          "openLatest": "އެންމެ ފަހުގެ ވާޝަން ހުޅުވާ"
        },
        "factsTitle": "މި ވާޝަން",
        "basis": "ބިންގާ",
        "contentHash": "ކޮންޓެންޓް ހޭޝް",
        "evidence": "ހެކި ޕެކް",
        "historyTitle": "ވާޝަންތަކުގެ ތާރީޚު",
        "historyDescription": "މި ޤާނޫނީ ފަރާތުގެ މުއްދަތުގެ ކޮންމެ ވާޝަނެއް، އެންމެ އައުވާ އެއްޗެއް ފުރަތަމަ.",
        "historyFailed": "ވާޝަންތަކުގެ ތާރީޚު ލޯޑު ނުކުރެވުނު.",
        "kinds": {
          "income": "ފައިދާއާއި ގެއްލުން",
          "balance": "ބެލެންސް ޝީޓް",
          "cashFlow": "ކޭޝް ފްލޯ",
          "equity": "އިކުއިޓީ މޫވްމަންޓް"
        },
        "amount": "އަދަދު ({currency})",
        "comparative": "އަޅާކިޔުން",
        "variance": "ތަފާތު",
        "sectionTotal": "{section} ޖުމްލަ",
        "noStatementsTitle": "މި ސެޓުގައި އެއްވެސް ބަޔާނެއް ނެތް",
        "noStatementsDescription": "ސެޓް ރައްކާކުރެވިފައިވަނީ ބަޔާންތަކުގެ ޑޭޓާއެއް ނެތި. އާ ވާޝަނެއް ތައްޔާރުކުރައްވާ.",
        "equityUnreconciled": "އިކުއިޓީ މޫވްމަންޓް ބެލެންސް ޝީޓާ ދިމާއެއް ނުވޭ. ތަފާތު:",
        "equityColumns": {
          "opening": "ފެށުނު",
          "movement": "ބަދަލު",
          "yearEnd": "އަހަރު ނިމުމުގެ ޓްރާންސްފަރ",
          "closing": "ނިމުނު"
        },
        "equityTotals": {
          "opening": "ފެށުނު އިކުއިޓީ",
          "netProfit": "ސާފު ފައިދާ",
          "otherMovements": "އެހެނިހެން ބަދަލުތައް",
          "closing": "ނިމުނު އިކުއިޓީ"
        }
      }
    },
    "anomalyReview": {
      "routeTitle": "އަނޮމަލީ ރިވިއު",
      "nav": "އަނޮމަލީ ރިވިއު",
      "title": "އަނޮމަލީ ރިވިއު",
      "description": "މުއްދަތެއްގެ ނުވަތަ ޕީރިއަޑެއްގެ އާދަޔާ ޚިލާފު ބެލެންސްތަކާއި ޖާނަލްތައް ސްކޭންކޮށް، ކްލޯޒްކުރުމުގެ ކުރިން ކޮންމެ ފައިންޑިންގއެއް ބަޔާންކޮށް، ފްލެގްތަކާއެކު ޓްރަޔަލް ބެލެންސް ބަލާ. ފައިންޑިންގއަކީ އަޅާކިޔުމެއް، ތުހުމަތެއް ނޫން.",
      "chooseDescription": "ސްކޭނެއް އަދި އޭގެ ފައިންޑިންގތައް ނިސްބަތްވަނީ އެއް ލީގަލް އެންޓިޓީއަކާއި އެއް ފިސްކަލް ޕީރިއަޑަކަށް.",
      "loadFailed": "ފައިންޑިންގތައް ލޯޑެއް ނުވި",
      "emptyTitle": "ދިމާވާ ފައިންޑިންގއެއް ނެތް",
      "emptyDescription": "މި ޕީރިއަޑަށް ސްކޭން ހިންގާ، ނުވަތަ ޑިސްޕޮޒިޝަންކުރި ފައިންޑިންގތައް ހިމެނުމަށް ފިލްޓަރުތައް ފޮހެލާ.",
      "caption": "ޕީރިއަޑުގެ އަނޮމަލީ ފައިންޑިންގތައް",
      "journalRef": "ޖާނަލް #{id}",
      "tabs": {
        "findings": "ފައިންޑިންގތައް",
        "trialBalance": "ފްލެގްތަކާއެކު ޓްރަޔަލް ބެލެންސް"
      },
      "kinds": {
        "balance_spike": "ބެލެންސް އަވަހަށް މައްޗަށް",
        "sign_flip": "ސައިން ބަދަލުވުން",
        "dormant_activity": "ހަރަކާތެއް ނެތް އެކައުންޓެއްގައި ހަރަކާތް",
        "round_amount_journal": "ރައުންޑް ޢަދަދެއްގެ ޖާނަލް",
        "unusual_preparer": "އާދަޔާ ޚިލާފު ތައްޔާރުކުރި މީހާ",
        "weekend_post": "މަސައްކަތު ދުވަހެއް ނޫން ދުވަހެއްގައި ޕޯސްޓްކުރި"
      },
      "severities": {
        "high": "މަތި",
        "medium": "މެދު",
        "low": "ދަށް"
      },
      "states": {
        "open": "ހުޅުވިފައި",
        "dispositioned": "ޑިސްޕޮޒިޝަންކުރެވިފައި"
      },
      "outcomes": {
        "explained": "ބަޔާންކުރެވިފައި",
        "corrected": "ރަނގަޅުކުރެވިފައި",
        "false_positive": "ފޯލްސް ޕޮޒިޓިވް"
      },
      "outcomeHints": {
        "explained": "ޢަދަދު ރަނގަޅު؛ އާދަޔާ ޚިލާފުވީ ކީއްވެތޯ ސަބަބުގައި ބަޔާންކުރެއެވެ.",
        "corrected": "ޢަދަދު ނުބައި، ޖާނަލަކުން ރަނގަޅުކުރެވިފައި ނުވަތަ ރަނގަޅުކުރެވޭނެ.",
        "false_positive": "މި އަޅާކިޔުން މި އެކައުންޓަށް ނުވަތަ ޖާނަލަށް ނުގުޅޭ."
      },
      "columns": {
        "kind": "ފައިންޑިންގ",
        "severity": "ސީރިއަސްކަން",
        "account": "އެކައުންޓް ނުވަތަ ޖާނަލް",
        "amount": "ޢަދަދު",
        "state": "ހާލަތު",
        "preparer": "ތައްޔާރުކުރީ",
        "actions": "ޢަމަލުތައް"
      },
      "scan": {
        "action": "ސްކޭން ހިންގާ",
        "done": "ސްކޭން ނިމުނީ",
        "doneDetail": "{newFindings} އައު، {refreshed} އަޕްޑޭޓްކުރި، {open} ހުޅުވިފައި.",
        "failed": "ސްކޭން ނުހިނގި",
        "newFindings": "އައު ފައިންޑިންގ",
        "refreshed": "އަޕްޑޭޓްކުރި",
        "open": "ހުޅުވިފައިވާ ފައިންޑިންގ",
        "lastScannedAt": "އެންމެ ފަހުން ސްކޭންކުރީ"
      },
      "disposition": {
        "action": "ޑިސްޕޮޒިޝަން",
        "title": "ފައިންޑިންގ ޑިސްޕޮޒިޝަންކުރޭ",
        "description": "ނިންމި ނިންމުމާއި ސަބަބު ލިޔެލާ. ފްލެގްކުރި ކަންތައް ތައްޔާރުކުރި ނުވަތަ ޕޯސްޓްކުރި މީހަކަށް މިކަން ނުކުރެވޭނެ.",
        "outcome": "ނަތީޖާ",
        "reason": "ސަބަބު",
        "reasonHint": "ތިބާގެ އަމިއްލަ ބަހުން. ލާޒިމު.",
        "final": "ޑިސްޕޮޒިޝަނަކީ ފައިނަލް ނިންމުމެއް، އަދި އެ އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑުކުރެވޭނެ.",
        "confirm": "ޑިސްޕޮޒިޝަން ރެކޯޑުކުރޭ",
        "done": "ފައިންޑިންގ ޑިސްޕޮޒިޝަންކުރެވިއްޖެ",
        "failed": "ޑިސްޕޮޒިޝަން ރެކޯޑެއް ނުވި",
        "preparerBlocked": "މިއީ ތިބާ ތައްޔާރުކުރި ނުވަތަ ޕޯސްޓްކުރި ކަމެއް؛ އެހެން ރިވިއުވަރެއް ޑިސްޕޮޒިޝަންކުރަންވާނެ."
      },
      "errors": {
        "sod": "މި ފައިންޑިންގއިން ފްލެގްކުރާ ކަންތައް ތައްޔާރުކުރީ ނުވަތަ ޕޯސްޓްކުރީ ތިބާ، އެހެންކަމުން އެހެން ރިވިއުވަރެއް ޑިސްޕޮޒިޝަންކުރަންވާނެ.",
        "alreadyDispositioned": "މި ފައިންޑިންގ ކުރިން އެހެން މީހަކު ޑިސްޕޮޒިޝަންކޮށްފި. ލިސްޓު އަލުން ލޯޑުކުރެވިއްޖެ.",
        "stale": "ތިބާ މަސައްކަތްކުރަމުން ދަނިކޮށް ފައިންޑިންގއަށް ބަދަލު އައިސްފި. ލިސްޓު އަލުން ލޯޑުކުރެވިއްޖެ؛ ބަލައިފައި އަލުން މަސައްކަތްކުރޭ."
      },
      "tb": {
        "loadFailed": "ޓްރަޔަލް ބެލެންސް ލޯޑެއް ނުވި",
        "notScanned": "މި ޕީރިއަޑު ސްކޭންކުރެވިފައެއް ނެތް. މިތާ ފްލެގެއް ނެތުމަކީ ޕީރިއަޑު ސާފުކަން ނޫން، އަދި މީހަކު ބަލާފައި ނެތްކަން.",
        "dispositioned": "ޑިސްޕޮޒިޝަންކުރެވިފައި",
        "flaggedAccounts": "ފްލެގްކުރެވުނު އެކައުންޓްތައް",
        "caption": "އަނޮމަލީ ފްލެގްތަކާއެކު ޓްރަޔަލް ބެލެންސް",
        "opening": "އޯޕަނިންގ",
        "debit": "ޑެބިޓް",
        "credit": "ކްރެޑިޓް",
        "closing": "ކްލޯޒިންގ",
        "flags": "ފްލެގްތައް",
        "journalFindings": "ޖާނަލް ފައިންޑިންގތައް"
      }
    },
    "cockpit": {
      "assignee": "ޔޫޒަރ #{id} އަށް ހަވާލުކުރެވިފައި",
      "ownerPosition": "މަޤާމު #{id} ގެ ޒިންމާގައި",
      "userRef": "ޔޫޒަރ #{id}",
      "staleTitle": "މި ކްލޯޒްގައި ކުރިން އެހެން މީހަކު ބަދަލެއް ގެނެވިއްޖެ",
      "staleDetail": "އެމީހާގެ ބަދަލާއެކު ރަން އަލުން ލޯޑުކުރެވިއްޖެ. އެ ބަލާފައި ތިޔަ ކުރަން ބޭނުންވި ކަންތައް އަލުން ކުރައްވާ — ތިޔަ ބަދަލެއް އެމީހާގެ ބަދަލުގެ މަތިން ރައްކާއެއް ނުކުރެވޭ.",
      "period": {
        "title": "މުއްދަތު",
        "description": "ރަންގެ މާލީ މުއްދަތު ސޮފްޓް ކްލޯޒް، ކްލޯޒް ނުވަތަ ލޮކް ކުރޭ. ބްލޮކްކުރާ ޗެކެއް ހުރިހާ ހިނދަކު ކްލޯޒް ދެކޮޅުޖަހާނެ، އަދި އެ ޗެކްތައް ލިސްޓުކޮށްދޭނެ.",
        "status": "މުއްދަތުގެ ހާލަތު",
        "actions": {
          "soft_close": "ސޮފްޓް ކްލޯޒް",
          "close": "މުއްދަތު ބަންދުކުރޭ",
          "permanent_close": "މުއްދަތު ލޮކްކުރޭ"
        },
        "blockersHint": "މި ރަނުގައި ބްލޮކްކުރާ {count} ޗެކެއް ފެއިލްވެފައި. އެ ޗެކްތައް ސާފުކުރެވޭހާ ހިނދަކު ނުވަތަ ޓާސްކްތަކުގައި ގަބޫލުކުރެވޭހާ ހިނދަކު މުއްދަތު ބަންދުކުރުން ދެކޮޅުޖަހާނެ.",
        "locked": "މި މުއްދަތު ލޮކްކުރެވިފައި. އެއަށް އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެ، އަދި އަލުން ހުޅުވިދާނެ ނޫން.",
        "noAccess": "ތިޔަ ރަން ފެނޭ، ނަމަވެސް އޭގެ މުއްދަތުގެ ކޮންޓްރޯލްތައް ނުފެނޭ. މުއްދަތު ބަންދުކުރުމުގެ ބާރު ލިބިފައިވާ މީހަކަށް ބަންދުކުރަން އެދިވަޑައިގަންނަވާ."
      },
      "addTask": {
        "action": "ޓާސްކެއް އިތުރުކުރޭ",
        "title": "މި ރަނަށް ޓާސްކެއް އިތުރުކުރޭ",
        "description": "ކެލެންޑަރުގައި ރޭވިފައިނުވާ، މި މަހު ކުރަންޖެހޭ މަސައްކަތަށް. ކެލެންޑަރަށް ބަދަލެއް ނުގެނެވޭ.",
        "name": "ނަން",
        "module": "މޮޑިއުލް",
        "dueOffset": "ޑިއު + ދުވަސް",
        "dueOffsetHint": "މުއްދަތު ނިމުމަށްފަހު މަސައްކަތު ދުވަސްތައް. ޑިއު ތާރީޚެއް ނެތް ނަމަ ހުސްކޮށް ބާއްވާ.",
        "dueOffsetInvalid": "ދުވަހުގެ ފުރިހަމަ އަދަދެއް ޖައްސަވާ",
        "mandatoryHint": "ލާޒިމު ޓާސްކެއް ފުރިހަމަވާހާ ހިނދަކު ސެޓްފައިކުރުން ބްލޮކްވާނެ",
        "evidence": "ހެކި ބޭނުންވޭ",
        "evidenceHint": "ނިންމުމުގައި ހެއްކާބެހޭ ބަޔާނެއް ބޭނުންވާނެ",
        "dependsOn": "މަޑުކުރަނީ",
        "dependsOnHint": "މި ރަނުގައި ހުރި ޓާސްކްތައް އެކަނި. ލޫޕެއް ދެކޮޅުޖަހާނެ.",
        "noTasks": "މި ރަނުގައި އަދި ޓާސްކެއް ނެތުމުން، އާ ޓާސްކް އެއްވެސް އެއްޗަކަށް މަޑެއް ނުކުރާނެ.",
        "binding": {
          "readinessKey": "ރެޑީނަސް ކީ",
          "actionKey": "އެކްޝަން ކީ",
          "obligationKind": "ވާޖިބުގެ ބާވަތް"
        },
        "added": "ޓާސްކް އިތުރުކުރެވިއްޖެ",
        "failed": "ޓާސްކް އިތުރު ނުކުރެވުނު"
      },
      "board": {
        "blockingChecks": "ބްލޮކްކުރާ ޗެކްތައް",
        "nextTask": "ދެން ހުރި ޓާސްކް",
        "emptyTitle": "ހުޅުވިފައިވާ ކްލޯޒެއް ނެތް",
        "emptyDescription": "ކްލޯޒް ރަންސްގެ ދަށުން ބަންދުކުރާ މުއްދަތަށް ކްލޯޒް ރަނެއް ހުޅުއްވާ؛ ދެން ކޮންމެ އިންޓިޓީއެއްގެ ހުޅުވިފައިވާ ކްލޯޒް މިތާ ފެންނާނެ."
      }
    },
    "yearEnd": {
      "routeTitle": "އަހަރު ނިމުމުގެ ކްލޯޒް ޕްލޭން",
      "title": "އަހަރު ނިމުމުގެ ކްލޯޒް ޕްލޭން",
      "description": "މާލީ އަހަރެއްގެ އާމްދަނީއާއި ޚަރަދުގެ އެކައުންޓްތައް ރިޓެއިންޑް އަރނިންގްސްއަށް ބަންދުކުރާ އިންކަމް ސަމަރީ އެންޓްރީ.",
      "recompute": "އަލުން ހިސާބުކުރޭ",
      "scope": "ކުންފުނި އާއި މާލީ އަހަރު",
      "company": "ކުންފުނި",
      "companyPlaceholder": "ކުންފުންޏެއް ހޮވާ",
      "fiscalYear": "މާލީ އަހަރު",
      "fiscalYearPlaceholder": "މާލީ އަހަރެއް ހޮވާ",
      "yearAllClosed": "ހުރިހާ މުއްދަތެއް ބަންދުކުރެވިފައި",
      "yearOpen": "އަދިވެސް ހުޅުވިފައިވާ މުއްދަތު: {count}",
      "retainedEarnings": "ރިޓެއިންޑް އަރނިންގްސް އެކައުންޓް",
      "retainedEarningsHint": "ޗާޓުގައި ރިޓެއިންޑް އަރނިންގްސް ކަމަށް ނަންދީފައިވާ އިކުއިޓީ އެކައުންޓް ބޭނުންކުރުމަށް ހުސްކޮށް ބާއްވާ.",
      "retainedEarningsPlaceholder": "ޗާޓުން ހޯދާނެ",
      "noPeriods": "މި ކުންފުންޏަށް އަދި މާލީ މުއްދަތެއް ނެތް. އަހަރެއް ބަންދުކުރުމުގެ ކުރިން މާލީ ކެލެންޑަރު ޤާއިމުކުރޭ.",
      "chooseScope": "ކްލޯޒް ޕްލޭން ހިސާބުކުރުމަށް ކުންފުންޏަކާއި މާލީ އަހަރެއް ހޮވާ.",
      "notClosedTitle": "މާލީ އަހަރު ފުރިހަމައަށް ބަންދުކުރެވިފައެއް ނުވޭ",
      "notClosedBody": "ކްލޯޒް ޕްލޭން ހިސާބުކުރުމުގެ ކުރިން އަހަރުގެ ކޮންމެ މުއްދަތެއް ބަންދުކުރޭ.",
      "accountNeeded": "ރިޓެއިންޑް އަރނިންގްސް އެކައުންޓް ހޮވާ: ޗާޓުގައި އެއްވެސް އެކައުންޓެއް، ނުވަތަ އެއްއަށްވުރެ ގިނަ އެކައުންޓް ނަންދީފައިވާތީ ސާވަރ ބަލާނެ ނޫން.",
      "loadFailed": "ކްލޯޒް ޕްލޭން ހިސާބުނުކުރެވުނު",
      "facts": {
        "window": "މާލީ އަހަރުގެ މުއްދަތު",
        "entryDate": "އެންޓްރީގެ ތާރީޚު",
        "memo": "މެމޯ",
        "retainedEarnings": "ރިޓެއިންޑް އަރނިންގްސް",
        "totalIncome": "ޖުމްލަ އާމްދަނީ",
        "totalExpense": "ޖުމްލަ ޚަރަދު",
        "netIncome": "ސާފު އާމްދަނީ",
        "check": "ބެލެންސް ޗެކް"
      },
      "balanced": "ބެލެންސްވެއްޖެ",
      "unbalanced": "ބެލެންސް ނުވޭ",
      "computedNotPosted": "މި ޕްލޭން ހިސާބުކުރެވެނީ، ޕޯސްޓެއް ނުކުރެވޭ. ކޮންމެ އާމްދަނީއާއި ޚަރަދުގެ އެކައުންޓެއް އަހަރު ނިމޭއިރުގެ ބެލެންސުން ސުމެއްކޮށް ސާފު ނަތީޖާ ރިޓެއިންޑް އަރނިންގްސްއަށް ބަދަލުވޭ؛ ޖެނެރަލް ލެޖަރުން އެ ޖާނަލް އެންޓްރީއެއްގެ ގޮތުގައި ޕޯސްޓުކުރޭ.",
      "caption": "ހުށަހަޅާފައިވާ އަހަރު ނިމުމުގެ ކްލޯޒް އެންޓްރީގެ ލައިންތައް",
      "columns": {
        "line": "ލައިން",
        "account": "އެކައުންޓް",
        "description": "ތަފްސީލު",
        "debit": "ޑެބިޓް",
        "credit": "ކްރެޑިޓް"
      },
      "empty": "އަހަރު ނިމޭއިރު އެއްވެސް އާމްދަނީ ނުވަތަ ޚަރަދުގެ އެކައުންޓެއްގައި ބެލެންސެއް ނެތުމުން ބަންދުކުރާނެ އެއްޗެއް ނެތް.",
      "totals": "ޖުމްލަ",
      "generatedAt": "ހިސާބުކުރި ވަގުތު",
      "exportDone": "ކްލޯޒް ޕްލޭން އެކްސްޕޯޓްކުރެވިއްޖެ",
      "exportDoneDetail": "{filename} ޑައުންލޯޑްކުރެވިއްޖެ. އެކްސްޕޯޓް އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑުކުރެވިއްޖެ.",
      "exportFailed": "ކްލޯޒް ޕްލޭން އެކްސްޕޯޓް ނުކުރެވުނު"
    }
  },
  "cost": {
    "nav": {
      "label": "ކޮސްޓް އެކައުންޓިންގގެ ބައިތައް",
      "pools": "ޕޫލްތައް",
      "drivers": "ޑްރައިވަރުތައް",
      "cycles": "ސައިކަލްތައް",
      "runs": "ރަންތައް",
      "rates": "އެބްޒޯޕްޝަން ރޭޓްތައް",
      "reports": "ރިޕޯޓްތައް",
      "quantities": "ޑްރައިވަރ މިންވަރުތައް",
      "absorptionVariance": "އެބްސޯޕްޝަން ތަފާތު",
      "profitability": "ފައިދާ"
    },
    "routeTitles": {
      "pools": "ކޮސްޓް ޕޫލްތައް",
      "drivers": "އެލޮކޭޝަން ޑްރައިވަރުތައް",
      "quantities": "ޑްރައިވަރު އަދަދުތައް",
      "cycles": "އެލޮކޭޝަން ސައިކަލްތައް",
      "cycle": "އެލޮކޭޝަން ސައިކަލް",
      "runs": "އެލޮކޭޝަން ރަންތައް",
      "run": "އެލޮކޭޝަން ރަން",
      "rates": "އެބްޒޯޕްޝަން ރޭޓްތައް",
      "reports": "ކޮސްޓް ރިޕޯޓްތައް",
      "absorptionVariance": "އެބްސޯޕްޝަން ތަފާތު",
      "profitability": "ކޮސްޓް އޮބްޖެކްޓްގެ ފައިދާ"
    },
    "common": {
      "period": "މުއްދަތު",
      "delete": "ފޮހެލާ",
      "edit": "ބަދަލުކުރޭ",
      "actions": "ޢަމަލުތައް",
      "stale": "ތިޔަ ރެކޯޑު ހުޅުވިފައިވަނިކޮށް އެހެން މީހަކު އޭގައި ބަދަލެއް ގެނެވިއްޖެ. ރެކޯޑު އަލުން ލޯޑުކުރެވިއްޖެ — ބަދަލުވި ގޮތް ބަލާފައި ތިޔަ ބަދަލު އަލުން ގެންނަވާ."
    },
    "filters": {
      "anyKind": "ކޮންމެ ބާވަތެއް",
      "anyMethod": "ކޮންމެ ގޮތެއް",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "anyCycle": "ކޮންމެ ސައިކަލެއް",
      "anyPeriod": "ކޮންމެ މުއްދަތެއް",
      "anyObjectType": "ހުރިހާ ބާވަތެއް"
    },
    "poolKinds": {
      "service": "ޚިދުމަތް",
      "overhead": "އޯވަހެޑް",
      "primary": "އަސާސީ"
    },
    "methods": {
      "direct": "ސީދާ",
      "step_down": "ސްޓެޕް-ޑައުން",
      "reciprocal": "ރެސިޕްރޮކަލް"
    },
    "methodHints": {
      "direct": "ޚިދުމަތުގެ ޕޫލްތައް ސީދާ ފަހު އޮބްޖެކްޓްތަކަށް؛ އެއްބަޔަކު އަނެއްބަޔެއްގެ ބޭނުންކުރުން ނުބަލާ",
      "step_down": "ޕޫލްތައް ސްޓެޕް ތަރުތީބުން ބަހާ، ބެހުމަށްފަހު އަލުން ނުލިބޭ",
      "reciprocal": "އެއްބަޔަކު އަނެއްބަޔެއްގެ ބޭނުންކުރުން އެއްފަހަރާ ހައްލުކޮށް، އިޓަރޭޝަން ޓްރޭސް ދޫކުރޭ"
    },
    "cycleStatuses": {
      "draft": "ދެލިކޮޕީ",
      "active": "ހިނގަމުންދާ",
      "archived": "އަރުޝީފުކުރެވިފައި"
    },
    "runStatuses": {
      "draft": "ދެލިކޮޕީ",
      "calculated": "ހިސާބުކުރެވިފައި",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "reversed": "އަނބުރާލެވިފައި",
      "failed": "ނާކާމިޔާބު"
    },
    "rateStatuses": {
      "draft": "ދެލިކޮޕީ",
      "active": "ހިނގަމުންދާ",
      "superseded": "ބަދަލުކުރެވިފައި"
    },
    "objectTypes": {
      "cost_center": "ކޮސްޓް ސެންޓަރު",
      "profit_center": "ފައިދާ ސެންޓަރު",
      "department": "ޑިޕާޓްމަންޓް",
      "business_unit": "ވިޔަފާރި ޔުނިޓް",
      "division": "ޑިވިޜަން",
      "branch": "ގޮފި",
      "project": "މަޝްރޫޢު",
      "item": "ބާވަތް",
      "company": "ކުންފުނި",
      "pool": "ކޮސްޓް ޕޫލް"
    },
    "objectRef": {
      "type": "އޮބްޖެކްޓް ބާވަތް",
      "object": "އޮބްޖެކްޓް",
      "internalHint": "ޕޫލަކަށް ފޮނުވުމަކީ އެތެރޭގެ ދައުރުވުމެއް، ލެޖަރަށް ނުދާނެ",
      "idPlaceholder": "ރެކޯޑް އައިޑީ"
    },
    "pool": {
      "title": "ކޮސްޓް ޕޫލްތައް",
      "description": "ކޮން އޮބްޖެކްޓެއް ޚަރަދު އުފުލާނެކަން ނިންމުމުގެ ކުރިން ޚަރަދު ޖަމާވާ ތަން.",
      "code": "ޕޫލް",
      "name": "ނަން",
      "kind": "ބާވަތް",
      "kindHint": "ޚިދުމަތުގެ ޕޫލަކުން އެހެން ޕޫލަކަށް ފޮނުވިދާނެ؛ އޯވަހެޑް ޕޫލެއް އޮބްޖެކްޓްތަކަށް ބަހާ",
      "object": "ގުޅިފައިވާ އޮބްޖެކްޓް",
      "clearingAccount": "ކްލިއަރިންގ އެކައުންޓް",
      "clearingHint": "ޚަރަދު ޕޫލްގައި އޮންނަ ދުވަސްވަރު ޕޫލްގެ ބެލެންސް ޝީޓް މަޤާމު",
      "absorbedAccount": "އެބްޒޯބްޑް އެކައުންޓް",
      "absorbedHint": "ޚަރަދު ޕޫލުން ނުކުމެ ލިބޭ ފަރާތްތަކަށް ދާއިރު ކްރެޑިޓްކުރެވޭ",
      "active": "ހިނގަމުންދާ",
      "inactive": "ހުއްޓިފައި",
      "sources": "މަޞްދަރުތައް",
      "create": "އައު ޕޫލް",
      "createTitle": "ކޮސްޓް ޕޫލެއް އުފައްދާ",
      "createDescription": "ސައިކަލެއްގައި ބައިވެރިވުމުގެ ކުރިން ޕޫލަކަށް ކްލިއަރިންގ އަދި އެބްޒޯބްޑް އެކައުންޓް ބޭނުންވޭ.",
      "createHint": "ޕޫލް އުފެދުމަށްފަހު، އެ ރޯގެ މަޞްދަރު އަމުރުން ޕޫލަށް ފީޑްކުރާ އެކައުންޓްތައް އިތުރުކުރޭ.",
      "created": "ޕޫލް އުފެއްދިއްޖެ",
      "saveFailed": "ޕޫލް ރައްކާނުކުރެވުނު",
      "loadFailed": "ޕޫލް ލިސްޓް ނުލިބުނު",
      "searchHint": "ކޯޑް ނުވަތަ ނަން",
      "tableLabel": "ކޮސްޓް ޕޫލްތައް",
      "emptyTitle": "އަދި ކޮސްޓް ޕޫލެއް ނެތް",
      "emptyDescription": "ޚަރަދު ބަހަންޖެހޭ ކޮންމެ ޚިދުމަތުގެ ޑިޕާޓްމަންޓަކަށާއި އޯވަހެޑް ގްރޫޕަކަށް ޕޫލެއް އުފައްދާ.",
      "deleteTitle": "މި ޕޫލް ފޮހެލަންތޯ؟",
      "deleteDescription": "{code} ނަގާލެވޭނެ. ސައިކަލް ސްޓެޕެއްގައި ބޭނުންކުރާ ޕޫލެއް ނުފޮހެވޭނެ.",
      "deleteFailed": "ޕޫލް ނުފޮހެވުނު",
      "deleted": "ޕޫލް ފޮހެލެވިއްޖެ"
    },
    "sources": {
      "title": "{code} ގެ މަޞްދަރުތައް",
      "description": "މި ޕޫލަށް ޖަމާވަނީ ކޮން އެކައުންޓްތަކެއްގެ ހަރަކާތް، އަދި ކޮން ދިމާލަކަށްކަން.",
      "account": "އެކައުންޓް",
      "sign": "ދިމާ",
      "signAdd": "ޕޫލަށް އިތުރުކުރޭ",
      "signDeduct": "ޕޫލުން އުނިކުރޭ",
      "add": "މަޞްދަރެއް އިތުރުކުރޭ",
      "remove": "މި މަޞްދަރު ނަގާލާ",
      "duplicate": "ކުރިންވެސް ލިސްޓްކުރެވިފައި",
      "hint": "ޕޫލްގެ ބެލެންސަކީ އެ މުއްދަތުގައި މި އެކައުންޓްތަކުގެ ހަރަކާތް، ކިޔާ ވަގުތު ހިސާބުކުރެވޭ، ރައްކާނުކުރެވޭ.",
      "saved": "މަޞްދަރުތައް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "މަޞްދަރުތައް ރައްކާނުކުރެވުނު",
      "loadFailed": "މަޞްދަރުތައް ނުލިބުނު",
      "emptyTitle": "އަދި މަޞްދަރެއް ނެތް",
      "emptyDescription": "މަޞްދަރެއް ނެތް ޕޫލެއްގެ ބެލެންސް އަބަދުވެސް ސުމެއް، އަދި އެއަށް ހިންގާ ރަނަކުން އެއްވެސް އެއްޗެއް ނުބަހާނެ."
    },
    "balance": {
      "title": "{code} ގެ ބެލެންސް",
      "description": "ހޮވާފައިވާ މުއްދަތުގައި ޕޫލްގެ މަޞްދަރު އެކައުންޓްތަކުގެ ހަރަކާތް.",
      "account": "އެކައުންޓް",
      "sign": "ދިމާ",
      "debit": "އިތުރުކުރޭ",
      "credit": "އުނިކުރޭ",
      "movement": "އެކައުންޓް ހަރަކާތް",
      "contribution": "ޙިއްޞާ",
      "primaryCost": "އަސާސީ ޚަރަދު",
      "loadFailed": "ބެލެންސް ހިސާބުނުކުރެވުނު",
      "emptyTitle": "މި ޕޫލްގައި އެއްޗެއް ނެތް",
      "emptyDescription": "މި މުއްދަތުގައި ޕޫލްގެ މަޞްދަރު އެކައުންޓްތަކުގައި ހަރަކާތެއް ނެތް."
    },
    "driver": {
      "title": "އެލޮކޭޝަން ޑްރައިވަރުތައް",
      "description": "ޚަރަދު ބަހާ މިންގަނޑުތައް — މީޓަރު މުރައްބަޢު، ކޮޓަރި ރޭ، މުވައްޒަފުންގެ އަދަދު، މެޝިން ގަޑިއިރު.",
      "code": "ޑްރައިވަރު",
      "name": "ނަން",
      "uom": "ޔުނިޓް",
      "uomHint": "ރިޕޯޓްގައި އޮންނަ ލޭބަލެއް، ބަދަލުކުރެވޭ މިންގަނޑެއް ނޫން",
      "active": "ހިނގަމުންދާ",
      "inactive": "ހުއްޓިފައި",
      "quantities": "އަދަދުތައް",
      "create": "އައު ޑްރައިވަރު",
      "createTitle": "އެލޮކޭޝަން ޑްރައިވަރެއް އުފައްދާ",
      "createDescription": "ޑްރައިވަރެއްގައި އަމިއްލަ އަދަދެއް ނުހުރޭ؛ އަދަދުތައް ކޮންމެ މުއްދަތަކަށް ވަކިން ޖަހާ.",
      "created": "ޑްރައިވަރު އުފެއްދިއްޖެ",
      "saveFailed": "ޑްރައިވަރު ރައްކާނުކުރެވުނު",
      "loadFailed": "ޑްރައިވަރު ލިސްޓް ނުލިބުނު",
      "searchHint": "ކޯޑް ނުވަތަ ނަން",
      "tableLabel": "އެލޮކޭޝަން ޑްރައިވަރުތައް",
      "emptyTitle": "އަދި ޑްރައިވަރެއް ނެތް",
      "emptyDescription": "ޚަރަދު ބަހާ ކޮންމެ މިންގަނޑަކަށް ޑްރައިވަރެއް އުފައްދާ، އަދި ކޮންމެ މުއްދަތެއްގައި އޭގެ އަދަދުތައް ޖަހާ.",
      "deleteTitle": "މި ޑްރައިވަރު ފޮހެލަންތޯ؟",
      "deleteDescription": "{code} ނަގާލެވޭނެ.",
      "deleteHint": "ސައިކަލް ސްޓެޕެއްގައި ބޭނުންކުރާ ޑްރައިވަރެއް ނުފޮހެވޭނެ؛ އެ ސްޓެޕް ފުރަތަމަ ނަގާލާ.",
      "deleteFailed": "ޑްރައިވަރު ނުފޮހެވުނު",
      "deleted": "ޑްރައިވަރު ފޮހެލެވިއްޖެ"
    },
    "quantities": {
      "title": "{driver} ގެ އަދަދުތައް",
      "description": "ކޮންމެ ކޮސްޓް އޮބްޖެކްޓަކަށް ކޮންމެ މުއްދަތަކަށް އެއް އަދަދު. ބުނަންދެން އެއްވެސް އެއްޗެއް ރައްކާނުކުރެވޭ.",
      "objectType": "ޖަހާފައިވަނީ",
      "object": "އޮބްޖެކްޓް",
      "quantity": "އަދަދު",
      "note": "ނޯޓް",
      "entered": "ޖަހާފައި",
      "ofRows": "{total} އޮބްޖެކްޓުން",
      "save": "އަދަދުތައް ރައްކާކުރޭ",
      "saved": "އަދަދުތައް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{count} އަދަދު ރެކޯޑްކުރެވިއްޖެ",
      "saveFailed": "އަދަދުތައް ރައްކާނުކުރެވުނު",
      "loadFailed": "އަދަދުތައް ނުލިބުނު",
      "tableLabel": "ކޮސްޓް އޮބްޖެކްޓް ބަހާ ޑްރައިވަރު އަދަދުތައް",
      "cellLabel": "{object} ގެ އަދަދު",
      "noteLabel": "{object} ގެ ނޯޓް",
      "emptyTitle": "ޖަހާނެ ކޮސްޓް އޮބްޖެކްޓެއް ނެތް",
      "emptyDescription": "މި ކުންފުނީގައި ހޮވާފައިވާ ބާވަތުގެ ޔުނިޓެއް ނެތް. ފުރަތަމަ އޯގަނައިޒޭޝަން ބައިން އުފައްދާ.",
      "unsaved": "{count} ބަދަލެއް ރައްކާނުކުރެވި",
      "invalid": "{count} ގޮޅިއެއްގައި އޮތީ ޢަދަދެއް ނޫން",
      "keyboardHint": "އެންޓަރ ނުވަތަ ↓ އިން ތިރިއަށް، ↑ އިން މައްޗަށް، Ctrl+Home އަދި Ctrl+End އިން ކޮޅުތަކަށް.",
      "import": "ސީއެސްވީ އިމްޕޯޓް",
      "importTitle": "ޑްރައިވަރު އަދަދުތައް އިމްޕޯޓްކުރޭ",
      "importDescription": "އަތުން ޖަހަން ބޮޑުވެގެންދާ އޮބްޖެކްޓް ސެޓްތަކަށް — ބާވަތްތައް، މަޝްރޫޢުތައް، ފުރިހަމަ ރިޒޯޓެއް.",
      "importFormat": "ކޮންމެ އޮބްޖެކްޓަކަށް އެއް ރޯ: އޮބްޖެކްޓް ބާވަތް، ކޯޑް ނުވަތަ އައިޑީ، އަދަދު، އަދި އިޚްތިޔާރީ ނޯޓް.",
      "csv": "ސީއެސްވީ",
      "replace": "މުއްދަތު ބަދަލުކުރޭ",
      "replaceHint": "ޖައްސާފައި: އެ މުއްދަތުގެ ހުރިހާ އަދަދެއް ފުރަތަމަ ނަގާލެވޭ. ނިއްވާފައި: ރޯތައް އެއްކުރެވޭ.",
      "imported": "އަދަދުތައް އިމްޕޯޓްކުރެވިއްޖެ",
      "importedDetail": "{imported} އިމްޕޯޓްކުރެވި، {rejected} ބޭރުކުރެވިއްޖެ",
      "importFailed": "އިމްޕޯޓް ފުރިހަމަނުކުރެވުނު"
    },
    "cycle": {
      "title": "އެލޮކޭޝަން ސައިކަލްތައް",
      "description": "ތަރުތީބުކުރެވިފައިވާ ސްޓެޕްތަކަކާއި، ބަދަލުވުން ބަލާ ގޮތް ނިންމާ މެތަޑް.",
      "code": "ސައިކަލް",
      "name": "ނަން",
      "method": "ގޮތް",
      "steps": "ސްޓެޕްތައް",
      "journalType": "ޖާނަލް ބާވަތް",
      "journalTypeHint": "ރަން ޕޯސްޓްކުރާ ޖީއެލް ޖާނަލް ބާވަތް؛ ކޯޑުން ހޯދޭ",
      "convergence": "އެއްގޮތްވުން",
      "tolerance": "ޓޮލަރެންސް {value}",
      "maxIterations": "ގިނަވެގެން {count} ބުރު",
      "maxIterationsLabel": "އެންމެ ގިނަ ބުރު",
      "maxIterationsHint": "މި ޙައްދަށް ފޯރައިފިނަމަ، ހަމަނުޖެހޭ ޖަވާބެއް ޕޯސްޓްކުރުމުގެ ބަދަލުގައި ރަން ދޫކޮށްލެވޭ",
      "toleranceLabel": "ކޮންވަރޖަންސް ޓޮލަރެންސް",
      "toleranceHint": "ބުރެއްގައި އެންމެ ބޮޑު ބަދަލު މީގެ ދަށަށް ދިޔުމުން ހައްލުކުރުން ހުއްޓޭ",
      "postAutomatically": "އަމިއްލައަށް ޕޯސްޓްކުރޭ",
      "postAutomaticallyHint": "ތާވަލުކުރެވިފައިވާ ރަން، މީހަކު ކަށަވަރުކުރުމަށް ނުބަލައި ޕޯސްޓްކުރޭ",
      "create": "އައު ސައިކަލް",
      "createTitle": "އެލޮކޭޝަން ސައިކަލެއް އުފައްދާ",
      "createDescription": "މިހާރު ގޮތް ހޮވާ؛ އިޓަރޭޝަން ޓްރޭސެއް ލިބޭނެތޯ ނިންމަނީ އެއިން.",
      "createHint": "ސައިކަލް ފެށެނީ ދެލިކޮޕީއެއްގެ ގޮތުގައި. ސްޓެޕްތައް އިތުރުކޮށް، ޗެކްކޮށް، ދެން ހިންގާ.",
      "created": "ސައިކަލް އުފެއްދިއްޖެ",
      "activate": "ހިންގާ",
      "activated": "ސައިކަލް ހިނގަން ފަށައިފި",
      "activateFailed": "ސައިކަލް ނުހިންގުނު",
      "headerTitle": "ސައިކަލް",
      "headerSaved": "ސައިކަލް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ސައިކަލް ރައްކާނުކުރެވުނު",
      "loadFailed": "ސައިކަލް ނުލިބުނު",
      "tableLabel": "އެލޮކޭޝަން ސައިކަލްތައް",
      "emptyTitle": "އަދި އެލޮކޭޝަން ސައިކަލެއް ނެތް",
      "emptyDescription": "ސައިކަލަކުން ބުނެދެނީ ކޮން ޕޫލަކުން ކާކަށް، ކޮން ތަރުތީބަކުން، ކޮން ޑްރައިވަރެއްގެ މައްޗަށްކަން.",
      "editorTitle": "ސައިކަލް {code}",
      "editorDescription": "ސްޓެޕްތައް ހިނގަނީ ސީކުއެންސް ތަރުތީބުން؛ ސޯލްވަރު ކިޔަނީ ގްރާފް، ސީކުއެންސް ނަންބަރެއް ނޫން."
    },
    "steps": {
      "title": "ސްޓެޕްތައް",
      "description": "ކޮންމެ ސްޓެޕަކުން އެއް ޕޫލްގެ ޚަރަދު، ޑްރައިވަރުން ނުވަތަ ކަނޑައެޅިފައިވާ އިންސައްތައިން ލިބޭ ފަރާތްތަކަށް ފޮނުވޭ.",
      "pool": "ފޮނުވާ ޕޫލް",
      "basis": "އަސާސް",
      "basisDriver": "ޑްރައިވަރުން",
      "basisDriverHint": "ޙިއްޞާތައް ދަނީ އެ މުއްދަތަށް ޖަހާފައިވާ ޑްރައިވަރު އަދަދުތަކުގެ މައްޗަށް",
      "basisFixed": "ކަނޑައެޅިފައިވާ އިންސައްތަ",
      "basisFixedHint": "ޙިއްޞާތަކަކީ ކޮންމެ ލިބޭ ފަރާތަކަށް ޖަހާފައިވާ އިންސައްތަތައް",
      "driver": "ޑްރައިވަރު",
      "excludeSelf": "ފޮނުވާ ޕޫލް އުނިކުރޭ",
      "excludeSelfHint": "ޕޫލަކަށް އޭގެ އަމިއްލަ ޚަރަދު އަނބުރާ ނުލިބޭ",
      "fixedPercent": "އިންސައްތަ",
      "fixedPercentIgnored": "ޑްރައިވަރު އަސާސްގައި ނުބަލާ",
      "receiversDriver": "ލިބޭ ފަރާތްތައް — ކޮންމެ ޙިއްޞާއެއް ނިންމަނީ ޑްރައިވަރު",
      "receiversFixed": "ލިބޭ ފަރާތްތައް — އިންސައްތަތަކުގެ ޖުމުލަ 100 ވާންޖެހޭ",
      "addReceiver": "ލިބޭ ފަރާތެއް އިތުރުކުރޭ",
      "removeReceiver": "މި ލިބޭ ފަރާތް ނަގާލާ",
      "add": "ސްޓެޕެއް އިތުރުކުރޭ",
      "remove": "މި ސްޓެޕް ނަގާލާ",
      "moveUp": "މި ސްޓެޕް ކުރިއަށް ޖައްސާ",
      "moveDown": "މި ސްޓެޕް ފަހަތަށް ޖައްސާ",
      "empty": "މި ސައިކަލްގައި އަދި ސްޓެޕެއް ނެތް. ސްޓެޕެއް ނެތް ސައިކަލަކުން އެއްވެސް އެއްޗެއް ނުބަހާ.",
      "save": "ސްޓެޕްތައް ރައްކާކުރޭ",
      "saved": "ސްޓެޕްތައް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ސްޓެޕްތައް ރައްކާނުކުރެވުނު",
      "missingPool": "ސްޓެޕް {seq} ގައި ފޮނުވާ ޕޫލެއް ނެތް",
      "missingDriver": "ސްޓެޕް {seq} ހުރީ ޑްރައިވަރު އަސާސްގައި، އެކަމަކު ޑްރައިވަރެއް ނުބުނޭ",
      "missingReceivers": "ސްޓެޕް {seq} ހުރީ ކަނޑައެޅިފައިވާ އިންސައްތައިގައި، އެކަމަކު ލިބޭ ފަރާތެއް ނެތް",
      "missingReceiverObject": "ސްޓެޕް {seq} ގައި އޮބްޖެކްޓެއް ނުހޮވާ ލިބޭ ފަރާތެއް އެބައޮތް"
    },
    "validate": {
      "title": "ސައްޙަކަން ބެލުން",
      "description": "މަސް ނިމުމުގެ ކުރިން މި ހިންގާ، ނިމެމުންދާއިރު ނޫން.",
      "run": "ޗެކްކުރޭ",
      "periodHint": "މުއްދަތެއް ދިނުމުން ޑްރައިވަރު އަދަދުތައްވެސް ބެލޭ",
      "shapeOnly": "ބައްޓަން އެކަނި",
      "ok": "މި ސައިކަލް ސައްޙަ.",
      "notRun": "އަދި ޗެކްނުކުރެވޭ. މި ސައިކަލުން ބެހޭނެތޯ ބެލުމަށް ޗެކްކުރޭ.",
      "atStep": "ސްޓެޕް {seq} ގައި",
      "failed": "ޗެކްކުރުން ނުހިންގުނު"
    },
    "run": {
      "listTitle": "އެލޮކޭޝަން ރަންތައް",
      "listDescription": "ހިސާބުކުރުމަކީ އެކައުންޓެންޓަކު ތަކުރާރުކުރާ ބެލުމެއް؛ ޕޯސްޓްކުރުމަކީ ލެޖަރުގެ ޢަމަލެއް.",
      "title": "ރަން {runNo}",
      "description": "ސައިކަލް {cycle} · މުއްދަތު {period}",
      "runNo": "ރަން",
      "draftNo": "ނަންބަރު ނުދޭ",
      "cycle": "ސައިކަލް",
      "method": "ގޮތް",
      "converged": "އެއްގޮތްވި",
      "yes": "އާދެ",
      "no": "ނޫން",
      "notApplicable": "ނުހިނގާ",
      "roundsShort": "{count} ބުރު",
      "iterations": "ބުރު",
      "totalPrimary": "އަސާސީ ޚަރަދު",
      "totalAbsorbed": "ބެހިފައި",
      "residual": "ބާކީ",
      "residualBreach": "މި ރަންގެ ބާކީ ސުމެއް ނޫން. ޕޫލްތަކާއި ލިބޭ ފަރާތްތަކާ ދެމެދު ޚަރަދެއް ގެއްލިއްޖެ، އަދި މި ރަން ޕޯސްޓްކޮށްގެން ނުވާނެ.",
      "journal": "ޖާނަލް {entryNo} ގެ ގޮތުގައި ޕޯސްޓްކުރެވިފައި",
      "note": "ނޯޓް",
      "calculate": "ހިސާބުކުރޭ",
      "calculateTitle": "އެލޮކޭޝަން ރަނެއް ހިސާބުކުރޭ",
      "calculateDescription": "މިއިން ލިބެނީ ބަލާލަން އަދަދުތަކެއް. ޕޯސްޓްކުރަންދެން ލެޖަރަށް އެއްވެސް އެއްޗެއް ނުދާނެ.",
      "calculateHint": "އެއް ސައިކަލަކާއި އެއް މުއްދަތަކަށް އޮތް ރަނެއް އަލުން ހިސާބުކުރުމުން އޭގެ އަދަދުތައް ބަދަލުވޭ.",
      "calculated": "ރަން ހިސާބުކުރެވިއްޖެ",
      "calculateFailed": "ރަން ހިސާބުނުކުރެވުނު",
      "recalculate": "އޮތް ރަނެއް ބަދަލުކުރޭ",
      "recalculateHint": "މިއާ ނުލައި، އެއް ސައިކަލަކާއި މުއްދަތަކަށް ދެވަނަ ހިސާބުކުރުމެއް ދޫކޮށްލެވޭ",
      "noActiveCycle": "މި ކުންފުނީގައި ހިނގަމުންދާ ސައިކަލެއް ނެތް. ރަނެއް ހިސާބުކުރުމުގެ ކުރިން އެއް ސައިކަލް ހިންގާ.",
      "post": "ޕޯސްޓްކުރޭ",
      "postTitle": "މި އެލޮކޭޝަން ރަން ޕޯސްޓްކުރޭ",
      "postDescription": "ރަންގެ ބެހުންތައް ޢާންމު ލެޖަރުގައި ޖާނަލަކަށް ބަދަލުވޭ.",
      "postHint": "ޕޫލުން ޕޫލަށް ދާ އެތެރޭގެ ދައުރުވުންތައް ޕޯސްޓްނުކުރެވޭ؛ ޕޯސްޓްވަނީ ފަހު އޮބްޖެކްޓަކަށް ދާ ޚަރަދު އެކަނި.",
      "posted": "ރަން ޕޯސްޓްކުރެވިއްޖެ",
      "postFailed": "ރަން ޕޯސްޓްނުކުރެވުނު",
      "reverse": "އަނބުރާލާ",
      "reverseTitle": "މި އެލޮކޭޝަން ރަން އަނބުރާލާ",
      "reverseDescription": "ފުރަގަސް ޖާނަލެއް ޕޯސްޓްކުރެވޭ؛ ރަނެއް އޭގެ ޖާނަލެއް ނުފޮހެވޭ.",
      "reverseReason": "ސަބަބު",
      "reverseOn": "އަނބުރާލާ ތާރީޚު",
      "reverseOnHint": "ހުސްކޮށް ބެހެއްޓުމުން، މިއަދުގެ ވިޔަފާރި ތާރީޚުގައި އަނބުރާލެވޭ",
      "reversed": "ރަން އަނބުރާލެވިއްޖެ",
      "reverseFailed": "ރަން އަނބުރާނުލެވުނު",
      "alreadyPosted": "މި ރަން ކުރިންވެސް ލެޖަރުގައި އެބައޮތް.",
      "alreadyReversed": "މި ރަން އަނބުރާލެވިފައި.",
      "failed": "މި ރަން ހިސާބުކުރުމުގައި ނާކާމިޔާބުވެ، ޕޯސްޓެއް ނުކުރެވޭނެ.",
      "notCalculated": "މި ރަން އަދި ހިސާބުނުކުރެވޭ.",
      "blockedNotConverged": "މި ރަން، އޭގެ ސައިކަލްގެ ބުރު ޙައްދުގެ ތެރޭގައި އެއްގޮތްނުވި. އެހެންކަމުން އޭގެ އަދަދުތަކަކީ ހަމަޖެހުނު ޖަވާބެއް ނޫން، އަދި ޕޯސްޓެއް ނުކުރެވޭނެ.",
      "blockedResidual": "މި ރަންގެ ބާކީއަކީ {residual}. ސުމަކަށް ވަންދެން ޕޯސްޓްކުރުން ހިފެހެއްޓިފައި.",
      "blockedPermission": "އެލޮކޭޝަން ރަނެއް ޕޯސްޓްކުރުމުގެ ހުއްދަ ތިޔަބޭފުޅާއަށް ނެތް.",
      "exported": "ބެހުންތައް އެކްސްޕޯޓްކުރެވިއްޖެ",
      "tabsLabel": "ރަންގެ ބައިތައް",
      "tabTrace": "އިޓަރޭޝަން ޓްރޭސް",
      "tabMatrix": "ދައުރުވުމުގެ މެޓްރިކްސް",
      "tabAllocations": "ބެހުންތައް",
      "tabVariance": "އެބްޒޯޕްޝަން ތަފާތު",
      "tableLabel": "އެލޮކޭޝަން ރަންތައް",
      "loadFailed": "ރަން ނުލިބުނު",
      "emptyTitle": "އަދި އެލޮކޭޝަން ރަނެއް ނެތް",
      "emptyDescription": "ޚަރަދު ދާ ތަން ބެލުމަށް، ހިނގަމުންދާ ސައިކަލަކާއި މުއްދަތަކަށް ރަނެއް ހިސާބުކުރޭ."
    },
    "trace": {
      "title": "އިޓަރޭޝަން ޓްރޭސް",
      "description": "ކޮންމެ ބުރެއްގައި ކުރީ ބުރުގެ ޖުމުލަތަކުން ކޮންމެ ޚިދުމަތުގެ ޕޫލެއް އަލުން ހިސާބުކުރެވޭ. ރެސިޕްރޮކަލް ޖަވާބެއް ބަލައި ޗެކްކުރެވެނީ މި ޓްރޭސުން.",
      "round": "ބުރު",
      "worstDelta": "އެންމެ ބޮޑު ބަދަލު",
      "movement": "ހަމަޖެހުން",
      "rounds": "{count} ބުރު",
      "settledUnder": "ޓޮލަރެންސް {tolerance}",
      "finalDelta": "ފަހު ބަދަލު {delta}",
      "converged": "އެއްގޮތްވި",
      "notConverged": "އެއްގޮތްނުވި",
      "notConvergedHint": "ހައްލުކުރުން ސައިކަލްގެ ބުރު ޙައްދަށް ފޯރައިފި. ޙައްދު މަތިކުރޭ، ޓޮލަރެންސް ދޫކުރޭ، ނުވަތަ ނުކުމެވޭ ގޮތެއް ނެތް ޚިދުމަތުގެ ލޫޕެއް ހޯދާ.",
      "showEveryPool": "ހުރިހާ ޕޫލެއް",
      "hiddenPools": "އިތުރު {count} ޕޫލެއް ފޮރުވިފައި",
      "readingHint": "މިތާ ހުރި ކޮންމެ އަދަދަކީ އިންޖީނުގެ އަމިއްލަ އަދަދު. މި ސްކްރީނުގައި އެއްވެސް އެއްޗެއް ބްރައުޒަރުގައި އަލުން ހިސާބުނުކުރެވޭ.",
      "tableLabel": "ޕޫލް ބަހާ ސޯލްވަރު ބުރުތައް",
      "emptyTitle": "އިޓަރޭޝަން ޓްރޭސެއް ނެތް",
      "emptyDescription": "ބުރު ޖަހަނީ ރެސިޕްރޮކަލް ސައިކަލެއް އެކަނި. ސީދާ އަދި ސްޓެޕް-ޑައުން ބެހުން އެއް ފަހަރުން ނިމޭ."
    },
    "matrix": {
      "title": "ދައުރުވުމުގެ މެޓްރިކްސް",
      "description": "ފޮނުވާ ފަރާތްތައް ފަރާތުގައި، ލިބޭ ފަރާތްތައް މަތީގައި، ޕޯސްޓްކުރެވުނު އަދަދުތައް ގޮޅިތަކުގައި.",
      "sender": "ފޮނުވާ ފަރާތް",
      "counts": "{senders} ފޮނުވާ ފަރާތް · {receivers} ލިބޭ ފަރާތް",
      "showInternal": "އެތެރޭގެ ދައުރުވުންތައް ({count})",
      "internalHidden": "ޕޫލުން ޕޫލަށް ދާ ދައުރުވުންތައް ފޮރުވިފައި. އެއީ ޙަޤީޤީ ދައުރުވުންތަކެއް، އެކަމަކު ޢާންމު ލެޖަރަށް ނުދާނެ.",
      "tableLabel": "އެލޮކޭޝަން ދައުރުވުމުގެ މެޓްރިކްސް",
      "emptyTitle": "އެއްވެސް އެއްޗެއް ނުބެހޭ",
      "emptyDescription": "މި ރަނުން ޚަރަދެއް ނުގެންދޭ. އެ މުއްދަތުގެ ޕޫލް ބެލެންސްތަކާއި ޑްރައިވަރު އަދަދުތައް ބައްލަވާ."
    },
    "allocations": {
      "step": "ސްޓެޕް",
      "sender": "ފޮނުވާ ފަރާތް",
      "receiver": "ލިބޭ ފަރާތް",
      "receiverType": "ލިބޭ ފަރާތުގެ ބާވަތް",
      "internal": "އެތެރޭގެ",
      "driverQuantity": "ޑްރައިވަރު އަދަދު",
      "share": "ޙިއްޞާ",
      "exact": "ސީދާ",
      "amount": "ޕޯސްޓްކުރެވުނު",
      "tableLabel": "ރަންގެ ބެހުންތައް",
      "emptyTitle": "ބެހުމެއް ނެތް",
      "emptyDescription": "މި ރަނުން ބެހުމުގެ ރޯއެއް ނުއުފެދޭ."
    },
    "variance": {
      "title": "އެބްޒޯޕްޝަން ތަފާތު",
      "tab": "އެބްޒޯޕްޝަން ތަފާތު",
      "description": "ބަޖެޓް ރޭޓުން ބެހި ޚަރަދާއި، ޙަޤީޤަތުގައި ހިނގި ޚަރަދާ ދެމެދުގެ ތަފާތު.",
      "reportTitle": "އެބްޒޯޕްޝަން ތަފާތު",
      "reportDescription": "ސްޕެންޑަކީ ޕޫލަށް ބަޖެޓަށްވުރެ ބޮޑު ޚަރަދު ދިޔުން؛ ވޮލިއުމަކީ ޑްރައިވަރު އެހެން މިންވަރެއްގައި ހިނގުން.",
      "pool": "ޕޫލް",
      "applied": "ބެހި",
      "actual": "ޙަޤީޤީ",
      "spend": "ސްޕެންޑް",
      "volume": "ވޮލިއުމް",
      "total": "ޖުމުލަ",
      "totalRow": "ޖުމުލަ",
      "tableLabel": "ޕޫލް ބަހާ އެބްޒޯޕްޝަން ތަފާތު",
      "loadFailed": "ތަފާތު ރިޕޯޓް ނުލިބުނު",
      "emptyTitle": "އެބްޒޯޕްޝަން ތަފާތެއް ނެތް",
      "emptyDescription": "މި މުއްދަތުގައި އެއްވެސް ޕޫލަކަށް ހިނގަމުންދާ އެބްޒޯޕްޝަން ރޭޓެއް ނެތް."
    },
    "rates": {
      "title": "އެބްޒޯޕްޝަން ރޭޓްތައް",
      "description": "ޕޫލަކުން ޚަރަދު ބަހާ ބަޖެޓް ރޭޓް، މުއްދަތު ނިމުމުގެ ފަހުން ނޫނަސް ކުރިން ކަނޑައެޅޭ.",
      "pool": "ޕޫލް",
      "driver": "ޑްރައިވަރު",
      "budgetedCost": "ބަޖެޓް ޚަރަދު",
      "budgetedQuantity": "ބަޖެޓް އަދަދު",
      "rate": "ރޭޓް",
      "rateOverride": "ރޭޓް އޯވަރައިޑް",
      "rateOverrideHint": "ހުސްކޮށް ބެހެއްޓުމުން ސާވަރުން ރޭޓް ނެރެދޭ. ބޯޑުން ފާސްކުރި ރޭޓަކަށް އެކަނި ފުރާ.",
      "varianceAccount": "ތަފާތު އެކައުންޓް",
      "varianceAccountHint": "ސްޕެންޑް އަދި ވޮލިއުމް ތަފާތުތައް ޕޯސްޓްވާ ތަން",
      "activate": "މިހާރު ހިންގާ",
      "activateHint": "ހިނގަމުންދާ ރޭޓަކުން، އެ ޕޫލަކާއި މުއްދަތަކަށް އޮތް ކުރީގެ ރޭޓް ބަދަލުކުރެވޭ",
      "set": "ރޭޓެއް ކަނޑައަޅާ",
      "setTitle": "އެބްޒޯޕްޝަން ރޭޓެއް ކަނޑައަޅާ",
      "setDescription": "ބަޖެޓް ޖަހާ؛ ރޭޓް އަންނަނީ އެއިން.",
      "serverComputesHint": "ރޭޓް ހިސާބުކުރެވެނީ ސާވަރުގައި، ބަޖެޓް ޚަރަދާއި އަދަދުން، އެއީ ބެހި ކޮންމެ އަދަދެއް އެއާ އެއްގޮތްވުމަށްޓަކައި.",
      "saved": "ރޭޓް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ރޭޓް ރައްކާނުކުރެވުނު",
      "loadFailed": "ރޭޓްތައް ނުލިބުނު",
      "tableLabel": "އެބްޒޯޕްޝަން ރޭޓްތައް",
      "emptyTitle": "އެބްޒޯޕްޝަން ރޭޓެއް ނެތް",
      "emptyDescription": "ރޭޓަކާ ނުލައި ޕޫލްގެ ޚަރަދު ބެހެނީ ހިނގި ގޮތަށް، އަދި ރިޕޯޓްކުރާނެ ތަފާތެއް ނުއޮންނާނެ."
    },
    "profitability": {
      "tab": "ކޮސްޓް އޮބްޖެކްޓް ފައިދާ",
      "title": "ކޮސްޓް އޮބްޖެކްޓް ފައިދާ",
      "object": "އޮބްޖެކްޓް",
      "objectType": "އޮބްޖެކްޓް ބާވަތް",
      "revenue": "އާމްދަނީ",
      "directCost": "ސީދާ ޚަރަދު",
      "allocatedCost": "ބެހި ޚަރަދު",
      "totalCost": "ޖުމުލަ ޚަރަދު",
      "margin": "މާޖިން",
      "marginPercent": "މާޖިން %",
      "total": "ޖުމުލަ",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "pickRange": "ތާރީޚުގެ މުއްދަތެއް ހޮވާ",
      "pickRangeHint": "ފައިދާ ހިސާބުކުރެވެނީ ވިޔަފާރި ތާރީޚުތަކެއްގެ މައްޗަށް، މާލީ މުއްދަތެއްގެ މައްޗަށް ނޫން.",
      "exported": "ފައިދާ އެކްސްޕޯޓްކުރެވިއްޖެ",
      "tableLabel": "ކޮސްޓް އޮބްޖެކްޓް ބަހާ ފައިދާ",
      "loadFailed": "ފައިދާ ރިޕޯޓް ނުލިބުނު",
      "emptyTitle": "ރިޕޯޓްކުރާނެ އެއްޗެއް ނެތް",
      "emptyDescription": "މި މުއްދަތުގައި ކޮސްޓް އޮބްޖެކްޓަކަށް ޓެގްކުރެވިފައިވާ އާމްދަނީއެއް ނުވަތަ ޚަރަދެއް ނެތް."
    },
    "reports": {
      "title": "ކޮސްޓް ރިޕޯޓްތައް",
      "description": "ބެހުމުން ލިބުނު ނަތީޖާ، ދެ ގޮތަކުން.",
      "tabsLabel": "ކޮސްޓް ރިޕޯޓްގެ ބައިތައް"
    },
    "quantityReport": {
      "title": "ޑްރައިވަރ މިންވަރުތައް",
      "description": "ކޮންމެ ކޮސްޓް އޮބްޖެކްޓަކުން އެއް ޑްރައިވަރަކުން ބޭނުންކުރި މިންވަރު، މުއްދަތުން މުއްދަތަށް. މުއްދަތެއްގެ އަދަދުތައް ޖައްސަވަނީ ޑްރައިވަރުގެ ތެރެއިން.",
      "driver": "ޑްރައިވަރ",
      "driverPlaceholder": "ޑްރައިވަރެއް ހޮވާ",
      "periods": "ދައްކާ މުއްދަތުތައް",
      "periodsHint": "ކުންފުނީގެ މާލީ ކެލެންޑަރުގެ އެންމެ ފަހުގެ މުއްދަތުތައް، އެންމެ ކުރީގެ މުއްދަތު ފުރަތަމަ",
      "objectType": "އޮބްޖެކްޓްގެ ބާވަތް",
      "object": "ކޮސްޓް އޮބްޖެކްޓް",
      "change": "ކުރީގެ މުއްދަތާ ތަފާތު",
      "capture": "މިންވަރުތައް ޖައްސާ",
      "chooseTitle": "ކުންފުންޏަކާއި ޑްރައިވަރެއް ހޮވާ",
      "chooseDescription": "ރިޕޯޓުގައި ޑްރައިވަރު ޖެހިފައިވާ ކޮންމެ ކޮސްޓް އޮބްޖެކްޓެއް ދައްކާނެ، ކޮންމެ މުއްދަތަކަށް އެއް ކޮލަމެއް.",
      "noDriversTitle": "މި ކުންފުނީގައި ޑްރައިވަރެއް ނެތް",
      "noDriversDescription": "ފުރަތަމަ ޑްރައިވަރސްގެ ދަށުން ޑްރައިވަރެއް ހައްދަވާ، ދެން ކޮންމެ މުއްދަތަކު އޭގެ މިންވަރުތައް ޖައްސަވާ.",
      "noPeriodsTitle": "މާލީ މުއްދަތެއް ނެތް",
      "noPeriodsDescription": "މިންވަރުތައް ޖައްސަނީ މާލީ މުއްދަތަކަށް. ފުރަތަމަ ޕީރިއަޑް ކޮންޓްރޯލްގައި މި ކުންފުނީގެ މުއްދަތުތައް އުފައްދަވާ.",
      "emptyTitle": "އަދި މިންވަރެއް ޖައްސާފައެއް ނުވޭ",
      "emptyDescription": "މި މުއްދަތުތަކުގައި މި ޑްރައިވަރަށް އެއްވެސް އަދަދެއް ޖައްސާފައެއް ނުވޭ. އެންމެ ފަހުގެ މުއްދަތު ޖެއްސެވުމަށް މިންވަރުތައް ޖައްސާ ބޭނުންކުރައްވާ.",
      "loadFailed": "ޑްރައިވަރ މިންވަރުތައް ލޯޑު ނުކުރެވުނު",
      "tableLabel": "ކޮސްޓް އޮބްޖެކްޓާއި މުއްދަތުން ޑްރައިވަރ މިންވަރުތައް",
      "up": "{delta} އިތުރުވެއްޖެ",
      "down": "{delta} މަދުވެއްޖެ",
      "flat": "ބަދަލެއް ނުވޭ",
      "noPrior": "ކުރީގެ އަދަދެއް ނެތް"
    },
    "poolEdit": {
      "title": "{code} ބަދަލުކުރޭ",
      "description": "ޕޫލްގެ ކޯޑު ދުވަހަކުވެސް ބަދަލެއް ނުވޭ. އެކައުންޓެއް ބަދަލުކުރުމުން އަސަރުކުރަނީ މިހާރުން ފެށިގެން ހިސާބުކުރާ ރަންތަކަށް، ޕޯސްޓުކުރެވިފައިވާ ރަންތަކަކަށް ނޫން.",
      "active": "ހަރަކާތްތެރި",
      "activeHint": "ހަރަކާތްތެރި ނޫން ޕޫލެއް އާ ރަންތަކުން ބޭރުކުރެވޭ",
      "saved": "ޕޫލް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޕޫލް ރައްކާ ނުކުރެވުނު"
    },
    "driverEdit": {
      "title": "{code} ބަދަލުކުރޭ",
      "description": "ޑްރައިވަރުގެ ކޯޑު ދުވަހަކުވެސް ބަދަލެއް ނުވޭ. ކުރިން ޖައްސާފައިވާ މިންވަރުތައް އޮތް ގޮތަށް ހުންނާނެ.",
      "active": "ހަރަކާތްތެރި",
      "activeHint": "ހަރަކާތްތެރި ނޫން ޑްރައިވަރެއް އާ ސައިކަލް ސްޓެޕަކަށް ހޮވިދާނެ ނޫން",
      "saved": "ޑްރައިވަރ ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޑްރައިވަރ ރައްކާ ނުކުރެވުނު"
    },
    "cycleDelete": {
      "action": "ފޮހެލާ",
      "title": "މި ސައިކަލް ފޮހެލަންތަ؟",
      "description": "{code} އާއި އޭގެ ސްޓެޕްތައް ފޮހެވޭނެ.",
      "hint": "ދިރުހުރި ރަނެއް ހުރި ސައިކަލެއް ފޮހެލެވޭނެ ނޫން؛ ފުރަތަމަ ރަން ރިވާސްކޮށް ނުވަތަ ދޫކޮށްލާ. ޕޯސްޓުކުރެވިފައިވާ ރަންތަކުގެ އަދަދުތައް ކޮންމެ ގޮތެއްގައިވެސް ހުންނާނެ.",
      "deleted": "ސައިކަލް ފޮހެލެވިއްޖެ",
      "failed": "ސައިކަލް ފޮހެލެވެން ނެތް"
    },
    "runExport": {
      "action": "CSV އެކްސްޕޯޓްކުރޭ",
      "includeInternal": "ޕޫލުން ޕޫލަށް ދިޔަ ފްލޯތައް ހިމަނާ",
      "includeInternalHint": "އިންޓަރނަލް ފްލޯތައް ދުވަހަކުވެސް ޕޯސްޓެއް ނުކުރެވޭ؛ ލެޖަރާ އެއްގޮތްވާ ފައިލަކަށް މިއީ ނިއްވާލާ",
      "title": "މި ރަން އެކްސްޕޯޓްކުރޭ",
      "description": "ސާވަރުން ރަންގެ ފްލޯ މެޓްރިކްސް CSV ގޮތަށް ލިޔެ، އެކްސްޕޯޓް އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑުކުރާނެ.",
      "done": "ރަން އެކްސްޕޯޓްކުރެވިއްޖެ",
      "doneDetail": "{filename} ޑައުންލޯޑްކުރެވިއްޖެ",
      "failed": "ރަން އެކްސްޕޯޓް ނުކުރެވުނު"
    },
    "absorptionReport": {
      "title": "އެބްސޯޕްޝަން ތަފާތު",
      "description": "އެއް މުއްދަތަކަށް ޕޫލުން ޕޫލަށް، އެޕްލައިކުރި ޚަރަދާއި ހަގީގީ ޚަރަދު، ސްޕެންޑްއާއި ވޮލިއުމަށް ބަހާލައިގެން.",
      "pool": "ޕޫލް",
      "anyPool": "ހުރިހާ ޕޫލެއް",
      "chooseTitle": "ކުންފުންޏަކާއި މުއްދަތެއް ހޮވާ",
      "chooseDescription": "އެބްސޯޕްޝަން ތަފާތު ރިޕޯޓުކުރަނީ ފަހަރަކު އެއް މާލީ މުއްދަތަކަށް."
    },
    "profitabilityReport": {
      "title": "ކޮސްޓް އޮބްޖެކްޓްގެ ފައިދާ",
      "description": "ވިޔަފާރީގެ ތާރީޚުތަކުގެ ދައުރެއްގައި، ކޮންމެ ކޮސްޓް އޮބްޖެކްޓަކަށް، އާމްދަނީއިން ސީދާ ޚަރަދާއި ބަހާލި ޚަރަދު އުނިކުރުމަށްފަހު."
    }
  },
  "expense": {
    "nav": {
      "label": "ޚަރަދުގެ ބައިތައް",
      "claims": "ކްލެއިމްތައް",
      "approvals": "ހުއްދަތައް",
      "travel": "ދަތުރު",
      "advances": "އެޑްވާންސް",
      "cards": "ކާޑު",
      "policies": "ޕޮލިސީ",
      "cardAccounts": "ކާޑު އެކައުންޓުތައް",
      "settings": "ސެޓިންގްސް",
      "payrollInclusions": "ޕޭރޯލް އިންކްލޫޖަންތައް"
    },
    "routeTitles": {
      "claims": "ޚަރަދު ކްލެއިމްތައް",
      "claim": "ޚަރަދު ކްލެއިމް",
      "approvals": "ޚަރަދު ހުއްދަތައް",
      "travel": "ދަތުރުގެ ރިކުއެސްޓްތައް",
      "advances": "ދަތުރު އެޑްވާންސް",
      "cards": "ކާޑު ބަޔާންތައް",
      "cardStatement": "ކާޑު ބަޔާން",
      "policies": "ޚަރަދު ޕޮލިސީ",
      "cardAccounts": "ކޯޕަރޭޓް ކާޑު އެކައުންޓުތައް",
      "settings": "ޚަރަދުގެ ސެޓިންގްސް",
      "payrollInclusions": "ޕޭރޯލް އިންކްލޫޖަންތައް"
    },
    "claimStatuses": {
      "draft": "ދެލިކޮޕީ",
      "submitted": "ހުށަހަޅާފައި",
      "approved": "ހުއްދަ ދެވިފައި",
      "rejected": "ބޭރުކުރެވިފައި",
      "posted": "ޕޯސްޓްވެފައި",
      "cancelled": "ބާތިލްކުރެވިފައި"
    },
    "policyOutcomes": {
      "ok": "ޕޮލިސީގެ ތެރޭގައި",
      "warn": "މަތިވެފައި، އިންޒާރު",
      "breach": "ލިމިޓަށްވުރެ މަތި",
      "overridden": "އޯވަރައިޑް ކުރެވިފައި"
    },
    "paidBy": {
      "employee": "މުވައްޒަފު ދެއްކި",
      "card": "ކުންފުނީގެ ކާޑު",
      "advance": "އެޑްވާންސުން"
    },
    "paidByHint": {
      "employee": "މުވައްޒަފުގެ ވެންޑަރު ރެކޯޑަށް އޭޕީ އިންވޮއިސްއަކުން އަނބުރާ ދެވޭ.",
      "card": "ކުންފުނިން ކުރިންވެސް ދައްކައިފި. މިއީ ޚަރަދެއް، އަނބުރާ ދިނުމެއް ނޫން.",
      "advance": "ކުރިން ދިން އެޑްވާންސާ ދިމާކުރެވޭ."
    },
    "limitKinds": {
      "per_line": "ކޮންމެ ލައިނަކަށް",
      "per_day": "ކޮންމެ ދުވަހަކަށް",
      "per_claim": "ކޮންމެ ކްލެއިމަކަށް",
      "per_month": "ކޮންމެ މަހަކަށް"
    },
    "limitKindHints": {
      "per_line": "ލައިން އެކަނި ބަލައިގެން.",
      "per_day": "މި ކްލެއިމްގައި އެ ބާވަތުގެ އެއް ދުވަހުގެ ހުރިހާ ލައިނެއް.",
      "per_claim": "މި ބާވަތުގެ ކްލެއިމްގެ ޖުމްލަ.",
      "per_month": "މި މަހު ހުއްދަ ދެވުނު ކްލެއިމްތަކާއި މި ކްލެއިމް."
    },
    "breachActions": {
      "warn": "އިންޒާރު",
      "block": "ހުއްޓުވާ",
      "approve": "އޮތޯރިޓީއަށް"
    },
    "breachActionHints": {
      "warn": "ރެކޯޑްކޮށް ކްލެއިމް ކުރިއަށް ދޫކުރޭ.",
      "block": "ލައިން ސީދާ ބޭރުކުރޭ.",
      "approve": "ހުށަހެޅުމުގެ ކުރިން އިތުރުވި މިންވަރު ސާފުކުރަން އޮތޯރިޓީއަކަށް."
    },
    "travelStatuses": {
      "draft": "ދެލިކޮޕީ",
      "submitted": "ހުށަހަޅާފައި",
      "approved": "ހުއްދަ ދެވިފައި",
      "rejected": "ބޭރުކުރެވިފައި",
      "cancelled": "ބާތިލްކުރެވިފައި",
      "closed": "ބަންދުކުރެވިފައި"
    },
    "advanceStatuses": {
      "draft": "ދެލިކޮޕީ",
      "submitted": "ހުށަހަޅާފައި",
      "approved": "ހުއްދަ ދެވިފައި",
      "paid": "ދެއްކިފައި",
      "partially_settled": "ބައެއް ސެޓްލްވެފައި",
      "settled": "ސެޓްލްވެފައި",
      "cancelled": "ބާތިލްކުރެވިފައި"
    },
    "cardStatuses": {
      "open": "ހުޅުވިފައި",
      "reconciled": "ރިކޮންސައިލްވެފައި",
      "closed": "ބަންދުކުރެވިފައި"
    },
    "cardLineStatuses": {
      "unmatched": "މެޗްނުވާ",
      "matched": "މެޗްވެފައި",
      "disputed": "ދެބަސްވެފައި",
      "personal": "އަމިއްލަ",
      "written_off": "ރައިޓް-އޯފް ކުރެވިފައި"
    },
    "matchKinds": {
      "exact": "ސީދާ",
      "amount_date": "އަދަދާއި ތާރީޚު",
      "amount_merchant": "އަދަދާއި ވިޔަފާރިވެރިޔާ",
      "manual": "އަތުން"
    },
    "cardDispositions": {
      "personal": "އަމިއްލަ ޚަރަދެއް",
      "disputed": "ދެބަސްވުމެއް",
      "written_off": "ރައިޓް-އޯފް"
    },
    "cardDispositionHints": {
      "personal": "މުވައްޒަފު ކުންފުންޏަށް ދަރާ. މުވައްޒަފުގެ ރިސީވަބްލްއަށް ޕޯސްޓްވާނެ.",
      "disputed": "އިޝޫކުރި ފަރާތާ ދެބަސްވެފައި. އަދި އެއްޗެއް ޕޯސްޓެއް ނުވާނެ.",
      "written_off": "ސަބަބަކާއެކު ޚަރަދެއްގެ ގޮތުގައި ބަލައިގަނެފައި."
    },
    "uom": {
      "km": "ކިލޯމީޓަރު",
      "mi": "މޭލު"
    },
    "claims": {
      "title": "ޚަރަދު ކްލެއިމްތައް",
      "description": "މީހުން ކުރި ޚަރަދާއި، ކުންފުނިން ކުރިންވެސް ދެއްކި އަދަދާއި، އަނބުރާ ދޭންޖެހޭ އަދަދު.",
      "detailDescription": "{no} · {employee}",
      "loadFailed": "ޚަރަދު ކްލެއިމްތައް ލޯޑެއް ނުކުރެވުނު",
      "claim": "ކްލެއިމް",
      "claimTitle": "ސުރުޚީ",
      "claimDate": "ތާރީޚު",
      "employee": "މުވައްޒަފު",
      "draftNo": "އަދި ނަންބަރެއް ނުދެވޭ",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "subtotal": "ސަބްޓޯޓަލް",
      "taxTotal": "ޓެކްސް",
      "total": "ޖުމްލަ",
      "cardPaid": "ކާޑުން ދެއްކި",
      "advanceApplied": "އެޑްވާންސުން",
      "reimbursable": "އަނބުރާ ދޭންޖެހޭ",
      "splitHint": "މުވައްޒަފަށް ލިބޭނީ ހަމައެކަނި އަނބުރާ ދޭންޖެހޭ އަދަދު. ކާޑުން ދެއްކި ލައިންތަކަކީ ކުންފުނީގެ ޚަރަދު.",
      "ownOnly": "ފެންނަނީ ތިޔަ ފަރާތުގެ ކްލެއިމްތައް. ހުއްދަ ދޭ ފަރާތްތަކަށް ޓީމުގެ ކްލެއިމްތައް ފެންނާނެ.",
      "note": "ނޯޓް",
      "comment": "ކޮމެންޓް",
      "create": "އައު ކްލެއިމް",
      "createTitle": "އައު ޚަރަދު ކްލެއިމް",
      "createDescription": "ސުރުޚީއަކާއި ތާރީޚެއް ދީ، ދެން ލައިންތައް އިތުރުކުރޭ.",
      "created": "ކްލެއިމް ހެދިއްޖެ",
      "createFailed": "ކްލެއިމް ނުހެދުނު",
      "numberedAtSubmit": "ކްލެއިމަށް ނަންބަރު ލިބެނީ ހުށަހަޅާ ވަގުތު، ދެލިކޮޕީގައި ނޫން.",
      "submitTitle": "މި ކްލެއިމް ހުށަހަޅާ",
      "submitDescription": "ޕޮލިސީ އަލުން ބެލެވި ނަންބަރު ދެވޭނެ.",
      "submitted": "ކްލެއިމް ހުށަހެޅިއްޖެ",
      "submitFailed": "ކްލެއިމް ނުހުށަހެޅުނު",
      "overrideNeeded": "ބައެއް ލައިން ލިމިޓަށްވުރެ މަތި. ސަބަބެއް ދިނުމުން އިތުރުވި މިންވަރު ސާފުކުރެވޭ ފަރާތަކަށް ދާނެ.",
      "overrideReason": "އޯވަރައިޑް ސަބަބު",
      "breachBanner": "{count} ލައިން ލިމިޓަށްވުރެ މަތި. ކޮންމެ ލައިނެއްގެ ބެޖުން ދައްކާނެ.",
      "approveTitle": "މި ކްލެއިމަށް ހުއްދަ ދީ",
      "approved": "ކްލެއިމަށް ހުއްދަ ދެވިއްޖެ",
      "rejectTitle": "މި ކްލެއިމް ބޭރުކުރޭ",
      "rejected": "ކްލެއިމް ބޭރުކުރެވިއްޖެ",
      "decideFailed": "ނިންމުން ރެކޯޑެއް ނުކުރެވުނު",
      "post": "ޕޯސްޓްކުރޭ",
      "postTitle": "މި ކްލެއިމް ޕޯސްޓްކުރޭ",
      "postDescription": "ދޭންޖެހޭ ފައިސާ އުފައްދާ، ކާޑުގެ ބައި ޕޯސްޓްކުރާނެ.",
      "postHint": "އަނބުރާ ދޭންޖެހޭ އަދަދު މުވައްޒަފުގެ ވެންޑަރު ރެކޯޑަށް އޭޕީ އިންވޮއިސްއަކަށް ބަދަލުވާނެ.",
      "postingDate": "ޕޯސްޓިންގ ތާރީޚު",
      "postingDateHint": "ހުސްކޮށް ބެހެއްޓުމުން ކްލެއިމްގެ ތާރީޚު.",
      "posted": "ކްލެއިމް ޕޯސްޓްވެއްޖެ",
      "postFailed": "ކްލެއިމް ޕޯސްޓެއް ނުކުރެވުނު",
      "notPayable": "މި މުވައްޒަފުގެ ވެންޑަރު ރެކޯޑެއް ނެތުމުން ފައިސާ ދެއްކޭނެ ގޮތެއް ނެތް. މުވައްޒަފުގެ ޕްރޮފައިލުން އެއް ގުޅުވާ.",
      "becameInvoice": "ސަޕްލަޔަރ އިންވޮއިސް {invoiceNo} ގެ ގޮތުގައި ޕޯސްޓްވެފައި.",
      "tableLabel": "ޚަރަދު ކްލެއިމްތައް",
      "emptyTitle": "ޚަރަދު ކްލެއިމެއް ނެތް",
      "emptyDescription": "ކުރި ޚަރަދަށް އެއް ނަގާ. ލައިންތައް އިތުރުކޮށް، ދެން ހުށަހަޅާ."
    },
    "lines": {
      "title": "ލައިންތައް",
      "description": "ކޮންމެ ލައިނެއް ރައްކާކުރާ ވަގުތު ޕޮލިސީއާ އަޅާކިޔޭ، އެހެންވެ މިތާ ފެންނަ ބެޖަކީ ހުށަހަޅާއިރު ލިބޭނެ ނަތީޖާ.",
      "category": "ބާވަތް",
      "incurredOn": "ހިނގި ތާރީޚު",
      "merchant": "ވިޔަފާރިވެރިޔާ",
      "amount": "އަދަދު",
      "distance": "ދުރުމިން",
      "vehicleClass": "އުޅަނދު",
      "paidBy": "ދެއްކީ",
      "policy": "ޕޮލިސީ",
      "taxRecoverable": "ޓެކްސް އަނބުރާ ލިބޭ",
      "limitWas": "ލިމިޓް {limit}",
      "mileageCategory": "މައިލޭޖް — ދުރުމިނުން ހިސާބުކުރެވޭ",
      "mileagePreview": "≈ {amount}",
      "mileageHint": "މައިލޭޖް ލައިނުގެ އަދަދު ހިސާބުކުރަނީ ސާވަރުން، ޚަރަދު ހިނގި ދުވަހުގެ ރޭޓުން. މިތާ ފެންނަނީ މިއަދުގެ ރޭޓުގެ ލަފާއެއް.",
      "addRow": "ލައިނެއް އިތުރުކުރޭ",
      "removeRow": "ނަގާ",
      "saved": "ލައިންތައް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ލައިންތައް ރައްކާއެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ލައިނެއް ނެތް",
      "emptyDescription": "ކުރި ޚަރަދު، ކޮންމެ ރަސީދަކަށް އެއް ލައިން."
    },
    "approvals": {
      "title": "ޚަރަދު ހުއްދަތައް",
      "description": "ތިޔަ ފަރާތުގެ ނިންމުމަށް އިންތިޒާރުކުރާ ކްލެއިމްތައް، ލައިންތަކާއެކު.",
      "loadFailed": "ހުއްދައަށް އިންތިޒާރުކުރާ ކްލެއިމްތައް ލޯޑެއް ނުކުރެވުނު",
      "awaiting": "އިންތިޒާރުގައި",
      "preview": "ލައިންތައް",
      "chooseTitle": "ކްލެއިމެއް ހޮވާ",
      "chooseDescription": "ލައިންތަކާއި ޕޮލިސީގެ ނަތީޖާ މިތާ ފެންނާނެ، މި ސްކްރީނުން ދާން ނުޖެހި.",
      "breachBanner": "މި ކްލެއިމްގެ {count} ލައިން ލިމިޓަށްވުރެ މަތި.",
      "emptyTitle": "ހުއްދައަށް އިންތިޒާރުކުރާ އެއްޗެއް ނެތް",
      "open": "ކްލެއިމް ހުޅުވާ"
    },
    "travel": {
      "title": "ދަތުރުގެ ރިކުއެސްޓްތައް",
      "description": "އެޑްވާންސެއް ހަރުލާ ކުރީގެ ހުއްދަ: ކޮންތާކަށް، ކޮންއިރަކު، ގާތްގަނޑަކަށް ކިހާ ވަރެއް.",
      "loadFailed": "ދަތުރުގެ ރިކުއެސްޓްތައް ލޯޑެއް ނުކުރެވުނު",
      "request": "ރިކުއެސްޓް",
      "draftNo": "އަދި ނަންބަރެއް ނުދެވޭ",
      "destination": "މަންޒިލް",
      "purpose": "ބޭނުން",
      "dates": "ތާރީޚުތައް",
      "departOn": "ފުރާ",
      "returnOn": "އަނބުރާ އަންނަ",
      "returnBeforeDepart": "އަނބުރާ އަންނަ ތާރީޚު ފުރާ ތާރީޚަށްވުރެ ކުރިއަކަށް ނުވާނެ.",
      "estimate": "އަންދާޒާ ޚަރަދު",
      "estimateHint": "ދަތުރަށް ހިނގާނެ ކަމަށް ބެލެވޭ އަދަދު.",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "create": "އައު ރިކުއެސްޓް",
      "createTitle": "އައު ދަތުރު ރިކުއެސްޓް",
      "createDescription": "ހުށަހަޅާ ވަގުތު ނަންބަރު ލިބޭނެ.",
      "created": "ދަތުރު ރިކުއެސްޓް ހެދިއްޖެ",
      "createFailed": "ދަތުރު ރިކުއެސްޓް ނުހެދުނު",
      "submitted": "ދަތުރު ރިކުއެސްޓް ހުށަހެޅިއްޖެ",
      "submitFailed": "ދަތުރު ރިކުއެސްޓް ނުހުށަހެޅުނު",
      "tableLabel": "ދަތުރުގެ ރިކުއެސްޓްތައް",
      "emptyTitle": "ދަތުރު ރިކުއެސްޓެއް ނެތް",
      "emptyDescription": "ދަތުރުގެ ކުރިން އެއް ނަގާ، އެއިރުން އެޑްވާންސެއް ހަރުލާނެ."
    },
    "advances": {
      "title": "ދަތުރު އެޑްވާންސް",
      "description": "ދަތުރުގެ ކުރިން ދިން ފައިސާއާއި، ދަތުރަށްފަހު ބާކީ ހުރި އަދަދު.",
      "loadFailed": "ދަތުރު އެޑްވާންސްތައް ލޯޑެއް ނުކުރެވުނު",
      "advance": "އެޑްވާންސް",
      "draftNo": "އަދި ނަންބަރެއް ނުދެވޭ",
      "amount": "ދިން އަދަދު",
      "settled": "ސެޓްލްވި",
      "outstanding": "ބާކީ",
      "dueBy": "ސުންގަޑި",
      "dueByHint": "މިއަށްފަހު އެޑްވާންސް ހޯދަން ފެށޭނެ، އަދި ކްލޯޒް ކޮކްޕިޓުގައި ފެންނާނެ.",
      "overdue": "ލަސްވެފައި",
      "overdueBanner": "{count} އެޑްވާންސް ސުންގަޑި ފަހަނައަޅައި ބާކީ ހުރި.",
      "employeeId": "މުވައްޒަފުގެ އައިޑީ",
      "employeeIdHint": "ހުސްކޮށް ބެހެއްޓުމުން އަމިއްލައަށް.",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "create": "އައު އެޑްވާންސް",
      "createTitle": "އައު ދަތުރު އެޑްވާންސް",
      "createDescription": "ހުއްދަ ދިނުމުން އޭޕީ މެދުވެރިކޮށް ދެއްކޭނެ.",
      "created": "އެޑްވާންސް ހެދިއްޖެ",
      "createFailed": "އެޑްވާންސް ނުހެދުނު",
      "pay": "ދައްކާ",
      "payTitle": "މި އެޑްވާންސް ދައްކާ",
      "payDescription": "މުވައްޒަފުގެ އަތަށް ފައިސާ ދާ އޭޕީ އިންވޮއިސް އުފައްދާނެ.",
      "payHint": "ކްލެއިމަކުން ދިމާވަންދެން އެޑްވާންސް އެޑްވާންސް އެކައުންޓުގައި ހުންނާނެ.",
      "paymentDate": "ދެއްކި ތާރީޚު",
      "paymentDateHint": "ހުސްކޮށް ބެހެއްޓުމުން މިއަދު.",
      "paid": "އެޑްވާންސް ދެއްކިއްޖެ",
      "payFailed": "އެޑްވާންސް ނުދެއްކުނު",
      "tableLabel": "ދަތުރު އެޑްވާންސްތައް",
      "emptyTitle": "ދަތުރު އެޑްވާންސެއް ނެތް",
      "emptyDescription": "ދިއުމުގެ ކުރިން ފައިސާ ބޭނުންވާ ފަރާތަކަށް އެޑްވާންސެއް ދީ."
    },
    "cards": {
      "title": "ކާޑު ބަޔާންތައް",
      "description": "އިޝޫކުރި ފަރާތުން ބުނާ ޚަރަދާއި، އެ ޚަރަދު ބަޔާންކުރާ ކްލެއިމްތައް.",
      "loadFailed": "ކާޑު ބަޔާންތައް ލޯޑެއް ނުކުރެވުނު",
      "card": "ކާޑު",
      "opening": "ފެށޭ",
      "openingHint": "ކުރީގެ ބަޔާނުގެ ނިމޭ އަދަދާ ދިމާވާން ޖެހޭނެ — ފަރަގެއް ވާނަމަ ސާވަރުން ގަބޫލެއް ނުކުރާނެ.",
      "charges": "ޗާޖު",
      "credits": "ކްރެޑިޓް",
      "closing": "ނިމޭ",
      "matched": "މެޗްވި",
      "periodFrom": "މުއްދަތު ފެށޭ",
      "periodTo": "މުއްދަތު ނިމޭ",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "import": "ބަޔާނެއް އިމްޕޯޓްކުރޭ",
      "importTitle": "ކާޑު ބަޔާނެއް އިމްޕޯޓްކުރޭ",
      "importDescription": "ރޯތައް ޕޭސްޓްކުރޭ؛ މުއްދަތު ކުރީގެ ބަޔާނާ ގުޅޭތޯ ސާވަރުން ބަލާނެ.",
      "paste": "ރޯތައް",
      "pasteHint": "ކޮންމެ ލައިނަކަށް އެއް މުއާމަލާތް: ތާރީޚު (YYYY-MM-DD)، ވިޔަފާރިވެރިޔާ، ރެފަރެންސް، އަދަދު. ޗާޖު ޕޮޒިޓިވް، ރިފަންޑް ނެގެޓިވް.",
      "parsed": "{count} ރޯ ކިޔުނު.",
      "unreadable": "{count} ލައިން ނުކިޔުނު، އެހެންވެ އިމްޕޯޓެއް ނުވާނެ. ތާރީޚުގެ ފޯމެޓް ބަލާ.",
      "imported": "ބަޔާން އިމްޕޯޓްވެއްޖެ",
      "importFailed": "ބަޔާން އިމްޕޯޓެއް ނުކުރެވުނު",
      "tableLabel": "ކާޑު ބަޔާންތައް",
      "emptyTitle": "ކާޑު ބަޔާނެއް ނެތް",
      "emptyDescription": "މަހުގެ ބަޔާން އިމްޕޯޓްކޮށް، ދެން ލައިންތައް ކްލެއިމްތަކާ މެޗްކުރޭ."
    },
    "match": {
      "title": "ކާޑު ބަޔާން — {card}",
      "description": "{from} → {to}",
      "loadFailed": "މި ކާޑު ބަޔާން ލޯޑެއް ނުކުރެވުނު",
      "linesTitle": "ލައިންތައް",
      "linesDescription": "ކޮންމެ ޗާޖަކާއި، އެ ބަޔާންކުރާ އެއްޗެއް.",
      "emptyTitle": "ލައިނެއް ނެތް",
      "emptyDescription": "އިމްޕޯޓުން ކިޔޭ ރޯއެއް ނުއުފެދުނު.",
      "noMerchant": "ވިޔަފާރިވެރިޔެއް ނެތް",
      "unmatched": "މެޗްނުވާ",
      "autoMatch": "މެޗް ހުށަހަޅާ",
      "suggested": "ހުށަހެޅުންތައް ތައްޔާރު",
      "suggestedBanner": "{count} ހުށަހެޅުން. ބަލައިގަންނަންދެން އެއްވެސް އެއްޗެއް މެޗެއް ނުވާނެ.",
      "autoFailed": "ހުށަހެޅުންތައް ނުއުފެއްދުނު",
      "suggestion": "ކްލެއިމް ލައިން #{claimLine} — {kind}، {confidence}",
      "accept": "ބަލައިގަނޭ",
      "matched": "ލައިން މެޗްވެއްޖެ",
      "matchFailed": "ލައިން މެޗެއް ނުކުރެވުނު",
      "manual": "އަތުން މެޗްކުރޭ",
      "manualTitle": "ކާޑު ލައިނެއް އަތުން މެޗްކުރޭ",
      "manualDescription": "ހުށަހެޅުމެއް ރަނގަޅު ނޫންނަމަ، ކްލެއިމް ލައިން އަމިއްލައަށް ބުނޭ.",
      "claimLineId": "ކްލެއިމް ލައިން އައިޑީ",
      "claimLineHint": "މި ޗާޖު ބަޔާންކުރާ ޚަރަދު ކްލެއިމް ލައިނުގެ އައިޑީ.",
      "matchIt": "މެޗްކުރޭ",
      "dispose": "ނިންމާ",
      "disposeTitle": "ކާޑު ލައިނެއް ނިންމާ",
      "disposeDescription": "މި ޗާޖު ބަޔާންކުރާ ކްލެއިމެއް ނެތް. ކޮންއެއްޗެއްކަން ބުނޭ.",
      "disposition": "ނަތީޖާ",
      "personalPosting": "އަމިއްލަ ޚަރަދެއް މުވައްޒަފުގެ ރިސީވަބްލްއަށް ޕޯސްޓްވެ، ކުންފުންޏަށް ދޭންޖެހޭނެ.",
      "reason": "ސަބަބު",
      "disposed": "ލައިން ނިންމިއްޖެ",
      "disposeFailed": "ލައިން ނުނިންމުނު",
      "cannotClose": "{count} ލައިން އަދިވެސް މެޗްނުވޭ. ބަޔާން ބަންދުކުރެވޭނީ ހުރިހާ ލައިނެއް މެޗްވެ ނުވަތަ ނިންމިގެން.",
      "close": "ބަޔާން ބަންދުކުރޭ",
      "closeTitle": "މި ކާޑު ބަޔާން ބަންދުކުރޭ",
      "closeDescription": "އިޝޫކުރި ފަރާތުގެ ބިލް އުފައްދާނެ.",
      "closeHint": "ބަންދުކުރުމުން ޗާޖުން ކްރެޑިޓް އުނިކޮށް އޭޕީ އިންވޮއިސްއެއް އުފެދި، ކްލިއަރިންގ އެކައުންޓް ހުސްވާނެ.",
      "closed": "ބަޔާން ބަންދުކުރެވިއްޖެ",
      "closeFailed": "ބަޔާން ބަންދެއް ނުކުރެވުނު",
      "issuerInvoice": "އިޝޫކުރި ފަރާތަށް ސަޕްލަޔަރ އިންވޮއިސް #{id}."
    },
    "policies": {
      "title": "ބާވަތް، ލިމިޓް އަދި މައިލޭޖް",
      "description": "ކޮންއެއްޗަކަށް، ކިހާ ވަރެއް، ކޮން ރޭޓަކުން.",
      "loadFailed": "ޚަރަދުގެ ސެޓިންގ ލޯޑެއް ނުކުރެވުނު",
      "tabCategories": "ބާވަތްތައް",
      "tabLimits": "ލިމިޓްތައް",
      "tabMileage": "މައިލޭޖް",
      "tabsLabel": "ޚަރަދުގެ ސެޓިންގ",
      "asAt": "ހިނގާ ތާރީޚު",
      "asAtHint": "ތާރީޚަކަށް ހިނގި ވަރޜަން ދައްކާ. ހުސްކޮށް ބެހެއްޓުމުން ހުރިހާ ވަރޜަނެއް.",
      "category": "ބާވަތް",
      "code": "ކޯޑް",
      "expenseAccount": "ޚަރަދު އެކައުންޓް",
      "mileage": "މައިލޭޖް",
      "mileageYes": "މައިލޭޖް",
      "isMileage": "މިއީ މައިލޭޖް ބާވަތެއް",
      "mileageCategoryHint": "މައިލޭޖް ލައިނުގައި ދުރުމިނާއި އުޅަނދުގެ ބާވަތް ހުންނާނެ؛ އަދަދު ހިސާބުކުރެވެނީ ރޭޓުން.",
      "receiptAbove": "ރަސީދު ބޭނުންވާ",
      "receiptAboveHint": "މިއަށްވުރެ މަތީ ލައިނަކަށް ރަސީދު ބޭނުންވާނެ. ސުމެއް ދިނުމުން އަބަދުވެސް.",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓިފައި",
      "categoriesTitle": "ބާވަތްތައް",
      "categoriesDescription": "ޚަރަދަކީ ކޮންއެއްޗެއްކަން. ކޮންމެ އެއްޗެއް ޕޯސްޓްވާ އެކައުންޓް ބުނޭ.",
      "categoriesEmptyTitle": "ބާވަތެއް ނެތް",
      "categoriesEmptyDescription": "ކޮންމެ ބާވަތެއްގެ ޚަރަދަކަށް އެއް ހަދާ — ދަތުރު، ކެއުން، މައިލޭޖް.",
      "newCategory": "އައު ބާވަތެއް",
      "newCategoryDescription": "ކްލެއިމްތަކުގައި ބޭނުންކުރެވުމުން ޕޯސްޓްވާ އެކައުންޓް ބަދަލެއް ނުކުރެވޭނެ.",
      "categoryCreated": "ބާވަތް ހެދިއްޖެ",
      "categoryFailed": "ބާވަތް ނުހެދުނު",
      "limitKind": "ހިނގަނީ",
      "limit": "ލިމިޓް",
      "breachAction": "މަތިވުމުން",
      "authorityInMoney": "އޮތޯރިޓީއަށް އެހެނީ ފައިސާގެ އަދަދުން، ލިމިޓް ފަހަނައެޅި މިންވަރުން — ލައިނުގެ ޖުމްލައިން ނުވަތަ އިންސައްތައަކުން ނޫން.",
      "requiresPreApproval": "ކުރިން ހުއްދަ ބޭނުންވޭ",
      "effective": "ހިނގާ މުއްދަތު",
      "effectiveFrom": "ފެށޭ ތާރީޚު",
      "effectiveFromHint": "ލައިން ބެލެވެނީ ޚަރަދު ހިނގި ދުވަހު ހިނގި ޕޮލިސީން، ކްލެއިމްގެ ތާރީޚުން ނޫން.",
      "open": "ހުޅުވިފައި",
      "limitsTitle": "ލިމިޓްތައް",
      "limitsDescription": "ތާރީޚުން ފެށިގެން، އެހެންވެ ޖުލައިގެ ރޭޓް ބެލެވެނީ ޖުލައިގެ ޕޮލިސީން.",
      "limitsEmptyTitle": "ލިމިޓެއް ނެތް",
      "limitsEmptyDescription": "ލިމިޓެއް ނެތްނަމަ ހުރިހާ ކްލެއިމެއް ފާސްވާނެ.",
      "newPolicy": "އައު ލިމިޓް",
      "newPolicyDescription": "ހިނގަމުންދާ ކީއެއް އަލުން ހުށަހެޅުމުން ބަދަލުކުރެވޭނެ.",
      "policyCreated": "ލިމިޓް ހެދިއްޖެ",
      "policyFailed": "ލިމިޓް ނުހެދުނު",
      "vehicleClass": "އުޅަނދުގެ ބާވަތް",
      "ratePerUnit": "ޔުނިޓަކަށް ރޭޓް",
      "uom": "ޔުނިޓް",
      "mileageTitle": "މައިލޭޖް ރޭޓްތައް",
      "mileageDescription": "އުޅަނދުގެ ބާވަތުން، ކިލޯމީޓަރެއްގެ އަގު، ތާރީޚުން ފެށިގެން.",
      "mileageEmptyTitle": "މައިލޭޖް ރޭޓެއް ނެތް",
      "mileageEmptyDescription": "މައިލޭޖް ބާވަތަކަށް ރޭޓެއް ބޭނުންވާނެ.",
      "newRate": "އައު ރޭޓް",
      "newRateDescription": "ރޭޓް ބަދަލުވަނީ ބަދަލުކުރެވިގެން، ފޮހެވިގެން ނޫން.",
      "rateCreated": "މައިލޭޖް ރޭޓް ހެދިއްޖެ",
      "rateFailed": "މައިލޭޖް ރޭޓް ނުހެދުނު"
    },
    "claimEdit": {
      "edit": "ތަފްޞީލު ބަދަލުކުރޭ",
      "editTitle": "ކްލެއިމްގެ ތަފްޞީލު ބަދަލުކުރޭ",
      "editDescription": "ސުރުޚީ، ތާރީޚް، މުއްދަތު އަދި ނޯޓް. ލައިންތައް ބަދަލުކުރަނީ ގްރިޑުންނެވެ.",
      "periodFrom": "މުއްދަތު ފެށޭ",
      "periodTo": "މުއްދަތު ނިމޭ",
      "saved": "ކްލެއިމްގެ ތަފްޞީލު ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ކްލެއިމްގެ ތަފްޞީލު ރައްކާނުކުރެވުނު",
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ކްލެއިމް ބަދަލުކޮށްފި. އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "staleDelete": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ކްލެއިމް ބަދަލުކޮށްފި. އަލުން ލޯޑްކޮށް އަލުން ނިންމަވާ.",
      "reload": "އަލުން ލޯޑްކުރޭ",
      "delete": "ފޮހެލާ",
      "deleteTitle": "މި ކްލެއިމް ފޮހެލާ",
      "deleteWarning": "ކްލެއިމާއި އޭގެ ލައިންތައް ނައްތާލެވޭނެ. ފޮހެލެވޭނީ ޑްރާފްޓް ނުވަތަ ރިޖެކްޓްކުރެވިފައިވާ ކްލެއިމެއް އެކަންޏެވެ، އަދި ފޮހެލުން އޮޑިޓް ޓްރެއިލްގައި ރައްކާވޭ.",
      "deleted": "ކްލެއިމް ފޮހެލެވިއްޖެ",
      "deleteFailed": "ކްލެއިމް ފޮހެނުލެވުނު"
    },
    "cardAccounts": {
      "title": "ކޯޕަރޭޓް ކާޑު އެކައުންޓުތައް",
      "description": "ކޮންމެ ކުންފުނީގެ ކާޑެއް، އެ ކާޑު ހިފަހައްޓާ މީހާ، އަދި ދޫކުރާ ފަރާތުގެ ބިލު އަންނަންދެން ޗާޖުތައް ޕޯސްޓްވާ ކްލިއަރިންގ އެކައުންޓް.",
      "loadFailed": "ކާޑު އެކައުންޓުތައް ލޯޑްނުކުރެވުނު",
      "chooseCompanyTitle": "ޤާނޫނީ ފަރާތެއް ހޮވާ",
      "chooseCompanyDescription": "ކާޑު އެކައުންޓެއް ނިސްބަތްވަނީ އެއް ޤާނޫނީ ފަރާތަކަށް، އަދި ކްލިއަރިންގ އެކައުންޓް އަންނަނީ އޭގެ ޗާޓުންނެވެ.",
      "code": "ކޯޑް",
      "issuer": "ދޫކުރާ ފަރާތް",
      "maskedPan": "ކާޑު ނަންބަރު (ފޮރުވާފައި)",
      "maskedPanHint": "ފަހު ހަތަރު އަކުރު އެކަނި، މިސާލަކަށް **** **** **** 4821. ފުރިހަމަ ނަންބަރު ދުވަހަކުވެސް ރައްކާނުކުރެވޭ.",
      "maskedPanInvalid": "ހަތަރަށްވުރެ ގިނަ އަދަދެއް ނުފެންނަ ގޮތަށް ފޮރުވާފައިވާ ނަންބަރު ލިޔުއްވާ.",
      "holder": "ކާޑު ހިފަހައްޓާ މީހާ",
      "holderHint": "ކާޑު ދޫކުރެވިފައިވާ މުވައްޒަފު. ހިއްސާކުރާ ކާޑެއްނަމަ ހުސްކޮށް ބާއްވާ.",
      "noHolder": "ހިއްސާކުރާ ކާޑު",
      "currency": "ފައިސާ",
      "currencyInvalid": "ތިން އަކުރުގެ ފައިސާގެ ކޯޑެއް ބޭނުންކުރައްވާ.",
      "clearingAccount": "ކްލިއަރިންގ އެކައުންޓް",
      "clearingAccountHint": "މެޗްވުމުން ޗާޖުތައް ޕޯސްޓްވަނީ މިތަނަށް؛ ސްޓޭޓްމަންޓް ބަންދުކުރުމުން ދޫކުރާ ފަރާތުގެ ބިލުން މި އެކައުންޓް ހުސްކުރޭ.",
      "issuerVendor": "ދޫކުރާ ފަރާތް ސަޕްލަޔަރެއްގެ ގޮތުގައި",
      "issuerVendorHint": "ބަންދުކުރެވޭ ސްޓޭޓްމަންޓްގެ ބިލު ހެދޭ ސަޕްލަޔަރ ރެކޯޑް. އެއް ނެތިއްޔާ، ސްޓޭޓްމަންޓް ބިލަކަށް ބަންދެއް ނުކުރެވޭނެ.",
      "noIssuerVendor": "ގުޅުވާފައި ނެތް",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހަރަކާތްތެރި ނޫން",
      "status": "ހާލަތު",
      "create": "އައު ކާޑު އެކައުންޓެއް",
      "createTitle": "އައު ކޯޕަރޭޓް ކާޑު އެކައުންޓެއް",
      "createDescription": "ސްޓޭޓްމަންޓްތައް އިމްޕޯޓްކުރެވެނީ ކާޑު އެކައުންޓަކާ ދެކޮޅަށް، އެހެންކަމުން ފުރަތަމަ ސްޓޭޓްމަންޓް އައުމުގެ ކުރިން އެ އުފައްދަވާ.",
      "created": "ކާޑު އެކައުންޓް އުފެއްދިއްޖެ",
      "createFailed": "ކާޑު އެކައުންޓް ނުއުފެއްދުނު",
      "noChart": "މި ޤާނޫނީ ފަރާތުގެ އެކައުންޓުތަކުގެ ޗާޓު ތިބާއަށް ކިޔޭކަށް ނެތް، އެހެންކަމުން ކްލިއަރިންގ އެކައުންޓް މިތަނުން ނުހޮވޭނެ.",
      "tableLabel": "ކޯޕަރޭޓް ކާޑު އެކައުންޓުތައް",
      "emptyTitle": "ކާޑު އެކައުންޓެއް ނެތް",
      "emptyDescription": "ކޮންމެ ކުންފުނީގެ ކާޑަކަށް އެކައުންޓެއް އުފައްދަވާ، ދެން ކާޑުތަކުގެ ދަށުން އޭގެ ސްޓޭޓްމަންޓްތައް އިމްޕޯޓްކުރައްވާ.",
      "creditLimit": "ކްރެޑިޓް ލިމިޓް",
      "creditLimitHint": "{currency} ގައި ކާޑުގެ ޚަރަދު ކުރެވޭ ހައްދު. ރައްކާކުރެވިފައިވާ ހައްދު ބާކީ ބެހެއްޓުމަށް ހުސްކޮށް ބާއްވާ.",
      "creditLimitInvalid": "ސުން ނުވަތަ އެއަށްވުރެ ބޮޑު އަދަދެއް ޖައްސަވާ.",
      "noLimit": "ހައްދެއް ކަނޑައެޅިފައެއް ނުވޭ",
      "holderEditHint": "ކާޑު އެހެން މުވައްޒަފަކަށް ބަދަލުކުރޭ. ހޯލްޑަރު މިތަނުން ފުހެވޭކަށް ނެތް.",
      "actions": "އެކްޝަންތައް",
      "activate": "އެކްޓިވްކުރޭ",
      "deactivate": "ޑީއެކްޓިވްކުރޭ",
      "activated": "ކާޑު އެކައުންޓް އެކްޓިވްކުރެވިއްޖެ",
      "deactivated": "ކާޑު އެކައުންޓް ޑީއެކްޓިވްކުރެވިއްޖެ",
      "statusFailed": "ކާޑު އެކައުންޓުގެ ހާލަތު ބަދަލެއް ނުކުރެވުނު",
      "statusStale": "އެހެން މީހަކު ކުރިން މި ކާޑު އެކައުންޓް ބަދަލުކޮށްފި. ލިސްޓް އަލުން ލޯޑްކުރެވިއްޖެ. މިހާރުގެ ހާލަތު ބަލާ، ދެން ތިބާގެ ބަދަލު އަލުން ގެންނަވާ.",
      "editTitle": "ކާޑު އެކައުންޓް ބަދަލުކުރޭ",
      "edited": "ކާޑު އެކައުންޓް އައު ކުރެވިއްޖެ",
      "editFailed": "ކާޑު އެކައުންޓް އައު ނުކުރެވުނު",
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ކާޑު އެކައުންޓް ރައްކާކޮށްފި. ކަމެއް ނުފޮހެވޭ. އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ރައްކާކުރެވިފައިވާ ނުސްހާ އަލުން ލޯޑްކުރޭ"
    },
    "settings": {
      "title": "ޚަރަދުގެ ސެޓިންގްސް",
      "description": "އެޑްވާންސްތަކާއި ޒާތީ ކާޑު ޗާޖުތައް ޕޯސްޓްވާ ތަން، ކްލެއިމްގެ ޑީފޯލްޓް ފައިސާ، އަދި ރަސީދު ބޭނުންވާ ހިނދު.",
      "loadFailed": "ޚަރަދުގެ ސެޓިންގްސް ލޯޑްނުކުރެވުނު",
      "chooseCompanyTitle": "ޤާނޫނީ ފަރާތެއް ހޮވާ",
      "chooseCompanyDescription": "ޚަރަދުގެ ސެޓިންގްސް ބަހައްޓަނީ ކޮންމެ ޤާނޫނީ ފަރާތަކަށް ވަކިންނެވެ.",
      "notConfigured": "މި ޤާނޫނީ ފަރާތަށް އަދި ޚަރަދުގެ ސެޓިންގްސް ނެތް. އެ ރައްކާކުރެވެންދެން، ދަތުރުގެ އެޑްވާންސް ނުދެއްކޭނެ އަދި ޒާތީ ކާޑު ޗާޖުތައް ނިންމައެއް ނުލެވޭނެ.",
      "accountsTitle": "އެކައުންޓުތައް",
      "accountsDescription": "ދެ އެކައުންޓަކީވެސް މުވައްޒަފު ކުންފުންޏަށް ދައްކަންޖެހޭ ފައިސާ ހުންނަ ބެލެންސް ޝީޓް އެކައުންޓުތަކެވެ.",
      "advanceAccount": "ދަތުރުގެ އެޑްވާންސް އެކައުންޓް",
      "advanceAccountHint": "ދައްކާފައިވާ އެޑްވާންސްތައް ހުންނަނީ ކްލެއިމަކުން ނެޓްކުރެވެންދެން މިތާގައެވެ.",
      "receivableAccount": "މުވައްޒަފުންގެ ރިސީވަބަލް އެކައުންޓް",
      "receivableAccountHint": "ކުންފުނީގެ ކާޑުގައި ޖެހޭ ޒާތީ ޗާޖެއް ޕޯސްޓްވަނީ މިތަނަށް: މުވައްޒަފު އެ ފައިސާ އަނބުރާ ދައްކަންޖެހޭ.",
      "claimsTitle": "ކްލެއިމްތައް",
      "claimsDescription": "އައު ކްލެއިމަކަށް ޑީފޯލްޓްތަކާއި ރަސީދުގެ ޤަވާއިދު.",
      "defaultCurrency": "ކްލެއިމްގެ ޑީފޯލްޓް ފައިސާ",
      "defaultCurrencyHint": "އައު ކްލެއިމެއް ފެށެނީ މި ފައިސާއިން. ތިން އަކުރު، މިސާލަކަށް MVR.",
      "requireReceiptAbove": "މިއަށްވުރެ މަތީގައި ރަސީދު ބޭނުންވޭ",
      "requireReceiptAboveHint": "މި އަދަދަށްވުރެ ބޮޑު ލައިނަކަށް ރަސީދެއް ބޭނުންވޭ. ސުމެއް ކަމަކީ ކޮންމެ ލައިނެއް.",
      "advanceOverdueDays": "އެޑްވާންސް ލަސްވާނީ (ދުވަސް)",
      "advanceOverdueDaysHint": "ދަތުރަށްފަހު މިހާ ދުވަސް ވަންދެން ނުހަމަޖެހޭ އެޑްވާންސެއް ފަހަތުން ދުވެ، ކްލޯޒް ކޮކްޕިޓްގައި ފެންނާނެ. ހުސްނަމަ 30.",
      "saved": "ޚަރަދުގެ ސެޓިންގްސް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޚަރަދުގެ ސެޓިންގްސް ރައްކާނުކުރެވުނު",
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ސެޓިންގްސް ބަދަލުކޮށްފި. އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "އަލުން ލޯޑްކުރޭ",
      "noChart": "މި ޤާނޫނީ ފަރާތުގެ އެކައުންޓުތަކުގެ ޗާޓު ތިބާއަށް ކިޔޭކަށް ނެތް، އެހެންކަމުން އެކައުންޓުތައް މިތަނުން ނުހޮވޭނެ.",
      "readOnly": "ތިބާއަށް މި ސެޓިންގްސް ކިޔޭނެ ނަމަވެސް ބަދަލެއް ނުކުރެވޭނެ.",
      "errors": {
        "account": "އެކައުންޓެއް ހޮއްވަވާ.",
        "currency": "ތިން އަކުރުގެ ފައިސާގެ ކޯޑެއް ބޭނުންކުރައްވާ.",
        "receiptAbove": "ސުމެއް ނުވަތަ އެއަށްވުރެ ބޮޑު އަދަދެއް ލިޔުއްވާ.",
        "overdueDays": "1 އާއި 365 ދެމެދުގެ ފުރިހަމަ ދުވަސްތަކުގެ އަދަދެއް ލިޔުއްވާ."
      }
    },
    "settlement": {
      "method": "ސެޓްލްމަންޓް ޠަރީގާ",
      "methodHint": "ޕޭމަންޓުން ސަޕްލައިޔަރ އިންވޮއިސް ހަދައެވެ. ޕޭރޯލުން މުވައްޒަފު ދެއްކި ޚަރަދު އޭނާގެ އަންނަ ޕޭރޯލް ރަންއަށް އިތުރުކުރެއެވެ.",
      "methods": {
        "payment": "ޕޭމަންޓް (އޭޕީ އިންވޮއިސް)",
        "payroll": "ޕޭރޯލް"
      },
      "statuses": {
        "included": "ޕޭރޯލް ރަނެއްގައި",
        "settled": "ޕޭރޯލުން ސެޓްލްކުރެވިފައި"
      },
      "kinds": {
        "claim": "ކްލެއިމް",
        "advance": "އެޑްވާންސް ރިކަވަރީ"
      },
      "paidVia": "ދައްކާ ގޮތް: {method}",
      "run": "ޕޭރޯލް ރަން {id}",
      "settledAt": "ސެޓްލްކުރީ {at}",
      "viewInclusions": "ޕޭރޯލް އިންކްލޫޖަންތައް ބައްލަވާ",
      "routeToPayroll": "ޕޭރޯލަށް ފޮނުވާ",
      "routeToPayment": "ޕޭމަންޓަށް ފޮނުވާ",
      "routeTitle": "މި ކްލެއިމް ދައްކާނީ ކިހިނެއް",
      "routeHint": "ޕޭރޯލުން ކްލެއިމް ނުކިޔާތީ ހަމައަށް ހުއްދަ. ކްލެއިމް ހެދި، ކްލެއިމްކުރި، ނުވަތަ ހުއްދަދިނުމުގައި ބައިވެރިވި މީހަކަށް މިއީ ބަދަލުނުކުރެވޭނެ.",
      "routed": "ސެޓްލްމަންޓް ޠަރީގާ ބަދަލުވެއްޖެ",
      "routeFailed": "ސެޓްލްމަންޓް ޠަރީގާ ބަދަލުކުރެވިފައެއް ނުވޭ",
      "recovery": "ޕޭއިން ރިކަވަރީ",
      "recoveryMarked": "ޕޭރޯލަށް ފާހަގަކުރެވިފައި",
      "recoveryLocked": "ޕޭރޯލް ރަން {id} ގައި",
      "markRecovery": "ޕޭއިން ބަލައިގަނޭ",
      "unmarkRecovery": "ރިކަވަރީ ހުއްޓުވާ",
      "recoveryMarkedToast": "އެޑްވާންސް ޕޭއިން ބަލައިގަތުމަށް ފާހަގަކުރެވުނު",
      "recoveryUnmarked": "ޕޭއިން ބަލައިގަތުން ހުއްޓުވިއްޖެ",
      "recoveryFailed": "އެޑްވާންސް އައު ކުރެވިފައެއް ނުވޭ",
      "kind": "ބާވަތް",
      "anyKind": "ކޮންމެ ބާވަތެއް",
      "runColumn": "ރަން",
      "includedAt": "އިންކްލޫޑްކުރި / ސެޓްލްކުރި",
      "runFilter": "ޕޭރޯލް ރަން {id} ދެއްކެވިފައި.",
      "clearRun": "ހުރިހާ ރަންތައް ދައްކާ",
      "inclusionsTitle": "ޕޭރޯލް އިންކްލޫޖަންތައް",
      "inclusionsDescription": "ޕޭރޯލުން ކިޔާފައިވާ ކްލެއިމްތަކާއި އެޑްވާންސް ރިކަވަރީތަކާއި، ރަން ޕޯސްޓްވެފައިވޭތޯ.",
      "inclusionsLoadFailed": "ޕޭރޯލް އިންކްލޫޖަންތައް ލޯޑުކުރެވިފައެއް ނުވޭ",
      "inclusionsEmptyTitle": "އަދި އެއްވެސް އިންކްލޫޑެއް ނެތް",
      "inclusionsEmptyDescription": "ޕޭރޯލަށް ފޮނުއްވި ކްލެއިމެއް، ނުވަތަ ރިކަވަރީއަށް ފާހަގަކުރި އެޑްވާންސެއް، ޕޭރޯލް ރަނެއްގައި ކިޔުމުން މިތަނުގައި ފެނިގެންދާނެ."
    },
    "queue": {
      "advance_overdue": "ވަގުތު ހަމަވެފައިވާ ދަތުރުފުޅުގެ އެޑްވާންސްތައް",
      "policy_breach": "ޚަރަދު ޕޮލިސީ ގަވާއިދު ގެއްލުންތައް"
    }
  },
  "interco": {
    "nav": {
      "label": "އިންޓަރކޮމްޕެނީ ބައިތައް",
      "pairs": "ޖޯޑުތައް",
      "match": "މެޗް ބޯޑް",
      "statements": "ބަޔާންތައް",
      "ageing": "އޭޖިންގ"
    },
    "routeTitles": {
      "pairs": "އިންޓަރކޮމްޕެނީ ޖޯޑުތައް",
      "match": "އިންޓަރކޮމްޕެނީ މެޗް ބޯޑް",
      "statements": "އިންޓަރކޮމްޕެނީ ބަޔާންތައް",
      "ageing": "އިންޓަރކޮމްޕެނީ އޭޖިންގ"
    },
    "directions": {
      "due_from": "އަހަރެމެންނަށް ލިބެންޖެހޭ",
      "due_to": "އަހަރެމެން ދޭންޖެހޭ"
    },
    "statuses": {
      "open": "ހުޅުވިފައި",
      "matched": "މެޗްވެފައި",
      "disputed": "ދެބަސްވެފައި",
      "written_off": "ރައިޓް-އޯފް ކުރެވިފައި",
      "eliminated": "އެލިމިނޭޓްކުރެވިފައި"
    },
    "statementStatuses": {
      "open": "ހުޅުވިފައި",
      "reconciled": "ރިކޮންސައިލްވެފައި",
      "certified": "ސެޓިފައި ކުރެވިފައި"
    },
    "dispositions": {
      "disputed": "ދެބަސްވުމެއްގެ ގޮތުގައި",
      "written_off": "ރައިޓް-އޯފް ކުރޭ"
    },
    "dispositionHints": {
      "disputed": "ދެ ކުންފުނި އެއްބަހެއް ނުވޭ، ކޮންމެވެސް ފަރާތަކުން ނިންމަން ޖެހޭ.",
      "written_off": "ދުވަހަކުވެސް މެޗެއް ނުވާނެ، އަދި ތަފާތު ބަލައިގަނެވިއްޖެ."
    },
    "pairs": {
      "title": "އިންޓަރކޮމްޕެނީ ޖޯޑުތައް",
      "description": "ދެ ކުންފުނީގެ މެދުގައި ދާއިމީ ރިކޮންސިލިއޭޝަނެއް، ކޮންސޮލިޑޭޝަނުގައި ފެންނަންދެން މަޑުނުކޮށް މަހުން މަހަށް.",
      "loadFailed": "އިންޓަރކޮމްޕެނީ ޖޯޑުތައް ލޯޑެއް ނުކުރެވުނު",
      "pair": "ޖޯޑު",
      "pairLabel": "{company} ↔ {counterparty}",
      "counterparty": "ދެވަނަ ކުންފުނި",
      "tolerance": "ޓޮލަރެންސް",
      "toleranceHint": "މިއަށްވުރެ ކުޑަ ތަފާތަކީ އަޑުގަދަކުރުމެއް، ކްލޯޒް ހުއްޓުވައެއް ނުލާނެ.",
      "toleranceCurrency": "ޓޮލަރެންސް ފައިސާ",
      "maxAgeDays": "އެންމެ ގިނަ ދުވަސް",
      "maxAgeHint": "މިއަށްވުރެ ދުވަސްވީ އައިޓަމް އޭޖިންގ ރިޕޯޓުގައި ފާހަގަވާނެ.",
      "mirror": "މިރާ ޕޯސްޓިންގ",
      "mirrorOn": "އަމިއްލައަށް އުފެދޭ",
      "mirrorOff": "ސެޓްކުރެވިފައި ނުވޭ — އަނެއް ފަރާތް އަތުން ޕޯސްޓްކުރޭ",
      "mirrorHint": "މިރާ އުފެދޭނީ ދެ ކުންފުނީގެ ދެމެދު ދޭންޖެހޭ/ލިބެންޖެހޭ މެޕިންގ އޮތްނަމަ އެކަނި. މިކަން ދުވަހަކުވެސް ލަފާކުރެވިގެން ނުވާނެ.",
      "blocksClose": "ކްލޯޒް ހުއްޓުވާ",
      "blocksCloseYes": "ކްލޯޒް ހުއްޓުވާ",
      "blocksCloseHint": "ހުޅުވުމުން، ސެޓިފައި ނުކުރެވޭ ބަޔާނަކުން މަސް ހުއްޓޭނެ.",
      "active": "ހަރަކާތްތެރި",
      "inactive": "ހުއްޓިފައި",
      "create": "އައު ޖޯޑު",
      "createTitle": "އައު އިންޓަރކޮމްޕެނީ ޖޯޑު",
      "createDescription": "ދެ ކުންފުނީގެ ދެމެދު ދޭންޖެހޭ/ލިބެންޖެހޭ މެޕިންގ ކުރިން އޮންނަން ޖެހޭނެ.",
      "created": "އިންޓަރކޮމްޕެނީ ޖޯޑު ހެދިއްޖެ",
      "createFailed": "ޖޯޑު ނުހެދުނު",
      "noCompanyPair": "މި ދެ ކުންފުނީގެ ދެމެދު ދޭންޖެހޭ/ލިބެންޖެހޭ މެޕިންގއެއް ނެތް. ފުރަތަމަ އެންޓަރޕްރައިޒް → ލީގަލް އެންޓިޓީޒް → އިންޓަރކޮމްޕެނީ ގައި އިންޓަރކޮމްޕެނީ ރޫލެއް ކޮންފިގަރ ކުރާށެވެ — ރިކޮންސިލް ކުރާނެ އެކައުންޓެއް ނެތް ރިކޮންސިލިއޭޝަނަކީ ރިކޮންސިލިއޭޝަނެއް ނޫނެވެ.",
      "tableLabel": "އިންޓަރކޮމްޕެނީ ރިކޮންސިލިއޭޝަން ޖޯޑުތައް",
      "emptyTitle": "އިންޓަރކޮމްޕެނީ ޖޯޑެއް ނެތް",
      "emptyDescription": "އެތެރޭގައި ވިޔަފާރިކުރާ ކޮންމެ ދެ ކުންފުންޏަކަށް އެއް ހަދާ.",
      "edit": "ބަދަލުކުރޭ",
      "editTitle": "އިންޓަރކޮމްޕެނީ ޕެއަރ ބަދަލުކުރޭ",
      "editDescription": "ޕެއަރ ލޯޑްކުރަނީ…",
      "companiesFixed": "ޕެއަރެއްގެ ދެ ޤާނޫނީ ފަރާތް ބަދަލެއް ނުކުރެވޭ. އެ ފަރާތްތަކުގެ ޑިއު-ޓު/ޑިއު-ފްރޮމް އެކައުންޓުތައް އަންނަނީ އިންޓަރކޮމްޕެނީ ރޫލުންނެވެ.",
      "openRules": "އިންޓަރކޮމްޕެނީ ރޫލްތައް ހުޅުވާ",
      "isActive": "ހަރަކާތްތެރި",
      "isActiveHint": "ހަރަކާތްތެރި ނޫން ޕެއަރެއް ރިކޮންސައިލްއެއް ނުކުރެވޭނެ، އަދި ކްލޯޒް ހުއްޓުވައެއް ނުލާނެ.",
      "updated": "އިންޓަރކޮމްޕެނީ ޕެއަރ އަޕްޑޭޓްކުރެވިއްޖެ",
      "updateFailed": "ޕެއަރ އަޕްޑޭޓްނުކުރެވުނު",
      "loadPairFailed": "ޕެއަރ ލޯޑްނުކުރެވުނު",
      "stale": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ޕެއަރ ބަދަލުކޮށްފި. އަލުން ލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "އަލުން ލޯޑްކުރޭ"
    },
    "match": {
      "title": "މެޗް ބޯޑް",
      "description": "ދެ ފަރާތްވެސް އެއްފަހަރާ. ބްރޭކަކީ އެއް ރޯއަށް ވާންޖެހޭ ދެ ރޯ.",
      "loadFailed": "އިންޓަރކޮމްޕެނީ މުއާމަލާތްތައް ލޯޑެއް ނުކުރެވުނު",
      "pair": "ޖޯޑު",
      "choosePair": "ޖޯޑެއް ހޮވާ",
      "chooseTitle": "ޖޯޑެއް ހޮވާ",
      "chooseDescription": "ބޯޑުން އެއް ޖޯޑެއްގެ ހުޅުވިފައިވާ އައިޓަމްތައް ދައްކާނެ.",
      "sideEmpty": "މި ފަރާތުގައި ހުޅުވިފައި އެއްޗެއް ނެތް.",
      "noMirror": "މި ޖޯޑަށް މިރާއެއް ނުއުފެދޭ، އެހެންވެ އަނެއް ފަރާތް ފުރޭނީ އެތާ ޕޯސްޓްކުރުމުން.",
      "matchThem": "މި ދޭތި މެޗްކުރޭ",
      "matched": "މުއާމަލާތްތައް މެޗްކުރެވިއްޖެ",
      "matchFailed": "މުއާމަލާތްތައް މެޗެއް ނުކުރެވުނު",
      "unmatch": "މެޗް ނަގާ",
      "unmatched": "މުއާމަލާތުގެ މެޗް ނެގިއްޖެ",
      "unmatchFailed": "މެޗް ނުނެގުނު",
      "autoMatch": "އޮޓޯ-މެޗް",
      "autoMatched": "އޮޓޯ-މެޗް ނިމިއްޖެ",
      "autoFailed": "އޮޓޯ-މެޗް ނުހިންގުނު",
      "considered": "ބެލި",
      "byExactRef": "ރެފަރެންސުން",
      "byAmountDate": "އަދަދާއި ތާރީޚުން",
      "stillOpen": "އަދިވެސް ހުޅުވިފައި",
      "dispose": "ދެބަސްވުން ނުވަތަ ރައިޓް-އޯފް",
      "disposeTitle": "މުއާމަލާތެއް ނިންމާ",
      "disposeDescription": "މެޗެއް ނުކުރެވޭނެ. ކޮންގޮތަކަށްކަމާއި ސަބަބު ބުނޭ.",
      "disposition": "ނަތީޖާ",
      "reason": "ސަބަބު",
      "disposed": "މުއާމަލާތް ނިންމިއްޖެ",
      "disposeFailed": "މުއާމަލާތް ނުނިންމުނު"
    },
    "statements": {
      "title": "މުއްދަތުގެ ބަޔާންތައް",
      "description": "ކޮންމެ ޖޯޑަކަށް ކޮންމެ މުއްދަތަކަށް ސްނެޕްޝޮޓެއް، ފަހުން މެޗްކުރުމުން ބަދަލުނުވާ ގޮތަށް.",
      "loadFailed": "ބަޔާންތައް ލޯޑެއް ނުކުރެވުނު",
      "anyPair": "ކޮންމެ ޖޯޑެއް",
      "period": "މުއްދަތު",
      "dueFrom": "އަހަރެމެންނަށް ލިބެންޖެހޭ",
      "counterpartyDueTo": "އެމީހުން ބުނާ ދޭންޖެހޭ",
      "difference": "ތަފާތު",
      "openItems": "ހުޅުވިފައިވާ އައިޓަމް",
      "outsideTolerance": "ޓޮލަރެންސުން ބޭރު",
      "toleranceUnknown": "ޓޮލަރެންސް އެހެން ފައިސާއަކުން",
      "generate": "އުފައްދާ",
      "generateTitle": "ބަޔާނެއް އުފައްދާ",
      "generateDescription": "މުއްދަތު ނިމުމުގައި ދެ ބެލެންސާއި ތަފާތު ފްރީޒްކުރާނެ.",
      "generated": "ބަޔާން އުފެދިއްޖެ",
      "generateFailed": "ބަޔާން ނުއުފެއްދުނު",
      "certify": "ސެޓިފައި ކުރޭ",
      "certifyTitle": "ބަޔާނެއް ސެޓިފައި ކުރޭ",
      "certifyDescription": "މުއްދަތު ނިމުމުގައި މި ޖޯޑު ރިކޮންސައިލްވިކަން ކަށަވަރުކޮށްދޭ.",
      "certifyHint": "ސެޓިފައި ކުރުމަކީ ކްލޯޒް ބްލޮކަރު ސާފުކުރާ އަމަލު. ކްލޯޒް ހުއްޓުވާ ޖޯޑަކަށް ސެޓިފައި ކުރެވިފައިވާ ބަޔާނެއް ބޭނުންވާނެ.",
      "certifyUnblocks": "މިއިން މި ޖޯޑާއި މުއްދަތަށް ކްލޯޒް ކޮކްޕިޓްގެ އިންޓަރކޮމްޕެނީ ބްލޮކަރު ސާފުވާނެ.",
      "certifyBreachWarning": "ތަފާތު މި ޖޯޑުގެ ޓޮލަރެންސުން ބޭރު. ސެޓިފައި ކުރުމުން ބްރޭކް ފިލައިގެން ނުދާނެ — އެއިން ބުނެވެނީ ބަލައި ބަލައިގަނެފިކަން.",
      "certified": "ބަޔާން ސެޓިފައި ކުރެވިއްޖެ",
      "certifyFailed": "ބަޔާން ސެޓިފައި ނުކުރެވުނު",
      "note": "ނޯޓް",
      "emptyTitle": "ބަޔާނެއް ނެތް",
      "emptyDescription": "ބަންދުކުރާ މުއްދަތަށް އެއް އުފައްދާ. އެއާ ނުލައި ކްލޯޒް ކޮކްޕިޓަށް ބަލާނެ އެއްޗެއް ނޯންނާނެ."
    },
    "ageing": {
      "title": "އިންޓަރކޮމްޕެނީ އޭޖިންގ",
      "description": "ކޮންމެ ޖޯޑަކަށް ހުޅުވިފައިވާ އައިޓަމް ދުވަހުން. މެޗްނުވާ އައިޓަމަކީ އެލިމިނޭޓްނުވާ އެލިމިނޭޝަނެއް.",
      "loadFailed": "އޭޖިންގ ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު",
      "asOf": "ތާރީޚު",
      "panelTitle": "ޖޯޑުން",
      "panelDescription": "ދުވަސްވީ ފުރަތަމަ. ލިމިޓް ފަހަނައަޅާފައިވާ ޖޯޑަކީ ކްލޯޒް ހުއްޓުވާނެ އެއްޗެއް.",
      "emptyTitle": "ހުޅުވިފައި އެއްޗެއް ނެތް",
      "emptyDescription": "ހުރިހާ އިންޓަރކޮމްޕެނީ މުއާމަލާތެއް މެޗްވެފައި ނުވަތަ ނިންމިފައި.",
      "company": "ކުންފުނި",
      "counterparty": "ދެވަނަ ކުންފުނި",
      "openCount": "ހުޅުވިފައި",
      "current": "މިހާރު",
      "days30": "1–30",
      "days60": "31–60",
      "days90Plus": "90 އިން މަތި",
      "openAmount": "ޖުމްލަ ހުޅުވިފައި",
      "oldest": "އެންމެ ދުވަސްވީ (ދުވަސް)"
    },
    "differences": {
      "title": "އިންޓަރކޮމްޕެނީ ތަފާތުތައް",
      "description": "މެޗަރަށް ސާފުނުކުރެވުނު ކޮންމެ ތަފާތެއް، އޭގެ ވެރިފަރާތާއެކު. ތަފާތެއް ހައްލުކުރެވެނީ ނޯޓަކާއި ހެކިތަކާއެކު، އެ ތަފާތު ހަވާލުކުރި މީހާ ނޫން މީހަކު.",
      "loadFailed": "ތަފާތުތައް ލޯޑްނުކުރެވުނު",
      "loading": "ތަފާތުތައް ލޯޑްކުރަނީ…",
      "empty": "މި ފިލްޓަރުތަކާ ގުޅޭ ތަފާތެއް ނެތް.",
      "pageEmpty": "މި ޞަފްޙާގައި އެއްޗެއް ނެތް.",
      "open": "ހުޅުވާ",
      "days": "{days} ދުވަސް",
      "agedFrom": "{date} އިން ފެށިގެން ({days} ދުވަސް)",
      "evidenceRequirement": "ހައްލުކުރުމަށް ހައްލު ސާބިތުކޮށްދޭ އެންމެ ކުޑަމިނުން އެއް ލިޔުމެއް ބޭނުންވޭ. އަލުން ހުޅުވުނު ތަފާތެއްނަމަ، އަލުން ހުޅުވުމަށްފަހު އެ ލިޔުން ޖައްސަވާ.",
      "filters": {
        "unresolved": "އަދި ހައްލުނުވާ",
        "anyStatus": "ކޮންމެ ހާލަތެއް",
        "anyKind": "ކޮންމެ ބާވަތެއް",
        "mine": "އަހަރެންގެ"
      },
      "status": {
        "open": "ހުޅުވިފައި",
        "assigned": "ހަވާލުކުރެވިފައި",
        "investigating": "ތަހުގީގުކުރަމުން",
        "resolved": "ހައްލުކުރެވިފައި"
      },
      "kind": {
        "aged_item": "ދުވަސްވީ އައިޓަމް",
        "disputed_item": "ޚިލާފު އައިޓަމް",
        "statement_residual": "ސްޓޭޓްމަންޓްގެ ބާކީ"
      },
      "fields": {
        "kind": "ބާވަތް",
        "pair": "ޕެއަރ",
        "amount": "އަދަދު",
        "age": "ދުވަސް",
        "owner": "ވެރިފަރާތް",
        "evidence": "ހެކި"
      },
      "owner": {
        "none": "ހަވާލުނުކުރެވޭ",
        "you": "{name} (ތިބާ)",
        "byId": "ޔޫޒަރ {id}"
      },
      "detail": {
        "title": "ތަފާތު {id}",
        "description": "އޭގެ ވެރިފަރާތް، ހެކިތައް، އަދި އޭގައި ހިނގި ހުރިހާ ކަމެއް.",
        "loadFailed": "ތަފާތު ލޯޑްނުކުރެވުނު",
        "resolvedNote": "ހައްލުކުރެވިފައި: {note}"
      },
      "actions": {
        "assignTitle": "ވެރިފަރާތެއް ހަވާލުކުރޭ",
        "reassignTitle": "އަލުން ހަވާލުކުރޭ",
        "newOwner": "ވެރިފަރާތް",
        "newOwnerHint": "އިންޓަރކޮމްޕެނީ މުއާމަލާތް މެޗްކުރެވޭ، ހަރަކާތްތެރި މީހެއް.",
        "note": "ނޯޓު",
        "assign": "ހަވާލުކުރޭ",
        "reassign": "އަލުން ހަވާލުކުރޭ",
        "investigateTitle": "ތަހުގީގު ފަށާ",
        "investigate": "ތަހުގީގު ފަށާ",
        "assignerCannotResolve": "މި ތަފާތު ހަވާލުކުރީ ތިބާ، އެހެންކަމުން އެހެން މީހަކު އެ ހައްލުކުރަން ޖެހޭ.",
        "resolveTitle": "ހައްލުކުރޭ",
        "resolutionNote": "ހައްލުކުރެވުނު ގޮތް",
        "needsEvidence": "ހައްލުކުރުމުގެ ކުރިން މަތީގައި އެންމެ ކުޑަމިނުން އެއް ހެއްކެއް ޖައްސަވާ.",
        "resolve": "ހައްލުކުރޭ",
        "assignDone": "ވެރިފަރާތް ހަވާލުކުރެވިއްޖެ",
        "investigateDone": "ތަހުގީގު ފެށިއްޖެ",
        "resolveDone": "ތަފާތު ހައްލުކުރެވިއްޖެ",
        "reloaded": "ތިބާ ހުޅުވިފަހުން އެހެން މީހަކު މި ތަފާތު ބަދަލުކޮށްފި. ތިބާ ލިޔުއްވި އެއްޗެހި ބަހައްޓައިގެން އަލުން ލޯޑްކުރެވިއްޖެ؛ ބައްލަވާފައި އަލުން ކަން ކުރައްވާ."
      },
      "errors": {
        "sod": "ތަފާތެއް ހަވާލުކުރި މީހާއަށް އެ ހައްލެއް ނުކުރެވޭނެ. އެހެން މީހަކު އެ ހައްލުކުރަން ޖެހޭ.",
        "evidence": "މި ތަފާތު ހައްލުކުރުމުގެ ކުރިން ހައްލުގެ ހެކި ޖައްސަވާ."
      },
      "history": {
        "title": "ތާރީޚް",
        "system": "ސިސްޓަމް",
        "owner": "ވެރިފަރާތް {name}",
        "empty": "އަދި ތާރީޚެއް ނެތް.",
        "action": {
          "raised": "ފާހަގަކުރެވުނު",
          "assigned": "ހަވާލުކުރެވުނު",
          "reassigned": "އަލުން ހަވާލުކުރެވުނު",
          "investigating": "ތަހުގީގު ފެށުނު",
          "resolved": "ހައްލުކުރެވުނު",
          "reopened": "އަލުން ހުޅުވުނު"
        }
      }
    },
    "tp": {
      "routeTitle": "ޓްރާންސްފަރ ޕްރައިސިންގ",
      "title": "ޓްރާންސްފަރ ޕްރައިސިންގ",
      "description": "ކޮންމެ އިންޓަރކޮމްޕެނީ އަގެއް ކަނޑައަޅާ އެޕްރޫވްކުރެވިފައިވާ ގޮތް، ކުންފުނި ދެކޮޅަކާއި މުޢާމަލާތުގެ ބާވަތަކަށް، ނުފޫޒުވާ މުއްދަތަކަށް، ހެކި ހުށަހަޅައިގެން.",
      "navLabel": "ޓްރާންސްފަރ ޕްރައިސިންގ",
      "navDescription": "ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތުތައް، އަގު ބެލުމާއި ސިޔާސަތުން ބޭރުވުންތައް.",
      "tabsLabel": "ޓްރާންސްފަރ ޕްރައިސިންގ ބެލުންތައް",
      "tabs": {
        "policies": "ސިޔާސަތުތައް",
        "quote": "އަގު ބެލުން",
        "departures": "ބޭރުވުންތައް"
      },
      "allCategories": "ހުރިހާ ބާވަތެއް",
      "openEnded": "ނިމުމެއް ނެތް",
      "evidenceCount": "ހުށަހަޅާފައިވާ ހެކި: {count}",
      "methods": {
        "cup": "އަޅާކިޔޭ މިނިވަން އަގު",
        "cost_plus": "ޚަރަދާއި އިތުރު",
        "resale_minus": "ވިއްކާ އަގުން އުނި",
        "tnmm": "މުޢާމަލާތުގެ ނެޓް މާޖިން",
        "profit_split": "ފައިދާ ބެހުން"
      },
      "methodHints": {
        "cup": "އަގަކީ ބޭސްގެ ގޮތުގައި ޖަހާ އަޅާކިޔޭ މިނިވަން އަގު.",
        "cost_plus": "އަގު = ޚަރަދު x (1 + މާކަޕް %). ބޭސް އަކީ ޚަރަދު.",
        "resale_minus": "އަގު = ވިއްކާ އަގު x (1 - މާޖިން %). ބޭސް އަކީ ވިއްކާ އަގު.",
        "tnmm": "އަގު = ބޭސް x (1 + ޓާގެޓް %)، އާމްސް ލެންތު ރޭންޖާއެކު. ޓާގެޓަކީ ބުނެފައިވާ މާކަޕް ނުވަތަ ރޭންޖުގެ މެދު.",
        "profit_split": "އަގު = ފައިދާގެ ޖުމްލަ x ބައި %. ބޭސް އަކީ ފައިދާގެ ޖުމްލަ؛ ބައިއަކީ ދެވަނަ ފަރާތަށް ހަވާލުކުރާ ބައި."
      },
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "pending_approval": "އެޕްރޫވަލަށް މަޑުކުރަނީ",
        "approved": "އެޕްރޫވްކުރެވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި",
        "discarded": "ދޫކޮށްލެވިފައި"
      },
      "fields": {
        "legalEntity": "ޤާނޫނީ ފަރާތް",
        "status": "ހާލަތު",
        "method": "ގޮތް",
        "category": "ބާވަތް",
        "rule": "އިންޓަރކޮމްޕެނީ ގަވާއިދު",
        "policy": "ސިޔާސަތު",
        "pair": "ކުންފުނި ދެކޮޅު",
        "terms": "ޝަރުތުތައް",
        "window": "ނުފޫޒުވާ މުއްދަތު",
        "lineage": "ނިސްބަތް",
        "markupPct": "މާކަޕް",
        "rangeLow": "ރޭންޖުގެ ދަށް",
        "rangeHigh": "ރޭންޖުގެ މަތި",
        "basisNote": "ބިންގާ",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "effectiveTo": "ނިމޭ ތާރީޚް",
        "evidence": "ހެކި"
      },
      "summary": {
        "cup": "ޖަހާފައިވާ އަޅާކިޔޭ އަގު",
        "cost_plus": "ޚަރަދު + {value}",
        "resale_minus": "ވިއްކާ އަގު - {value}",
        "profit_split": "ބައި {value}",
        "range": "ރޭންޖު {low} އިން {high} އަށް",
        "target": "ޓާގެޓް {value}"
      },
      "form": {
        "categoryHint": "ދެކޮޅުގެ ހުރިހާ ބާވަތަކަށް ހުސްކޮށް ބާއްވާ، ނުވަތަ އަގު ކަނޑައަޅާ އިންޓަރކޮމްޕެނީ ޑޮކިއުމަންޓް ބާވަތް ޖަހާ (މިސާލު ap.invoice). ނަން ކިޔާފައިވާ ބާވަތަށް ހުސް ބާވަތަށްވުރެ އިސްކަން ދެވޭ.",
        "categoryFixed": "ބަދަލަށް އަންނަ ސިޔާސަތަކީ ކުރީގެ ސިޔާސަތުގެ ހަމަ އެ ދެކޮޅާއި ބާވަތުގެ އަގު ކަނޑައަޅާ ސިޔާސަތެއް.",
        "percentHint": "8.75% އަށް 8.75 ޖަހާ",
        "rangeHint": "އާމްސް ލެންތު ރޭންޖު. 8.75% އަށް 8.75 ޖަހާ؛ ރޭންޖުގެ ކޮޅެއް ނެގެޓިވް ވެދާނެ.",
        "toHint": "ނިމުމެއް ނެތް ސިޔާސަތަކަށް ހުސްކޮށް ބާއްވާ.",
        "basisHint": "މި ގޮތާއި މި އަދަދުތައް ނަގާ ސަބަބު (ބެންޗްމާކިންގ ދިރާސާ، އަޅާކިޔުންތައް، އެއްބަސްވުން). ބިންގާގެ ނޯޓެއް ނުވަތަ އެންމެ ކުޑަމިނުން ހެކި ފައިލެއް ނެތި ސިޔާސަތު ހުށަނާޅައެވެ.",
        "markupLabel": {
          "cup": "މާކަޕް",
          "cost_plus": "ޚަރަދުގެ މައްޗަށް މާކަޕް",
          "resale_minus": "ވިއްކާ މާޖިން",
          "tnmm": "ޓާގެޓް މާކަޕް (އިޚްތިޔާރީ)",
          "profit_split": "ދެވަނަ ފަރާތުގެ ބައި"
        },
        "errors": {
          "markupRequired": "މި ގޮތަށް ޕަސެންޓެއް ބޭނުންވޭ.",
          "percentFormat": "8.75 ފަދަ އަދަދެއް ޖަހާ (ޕަސެންޓެއް، ފްރެކްޝަނެއް ނޫން).",
          "markupNegative": "ޕަސެންޓް ނެގެޓިވް ނުވާނެ.",
          "markupOver100": "މި ގޮތަށް އެންމެ ގިނަވެގެން 100%.",
          "percentBound": "ޕަސެންޓް 1000% އަށްވުރެ ދަށްވާން ޖެހޭ.",
          "rangeRequired": "މި ގޮތަށް ރޭންޖުގެ ދެކޮޅުވެސް ބޭނުންވޭ.",
          "rangeOrder": "ދަށް ކޮޅު މަތި ކޮޅަށްވުރެ ބޮޑު ނުވާނެ.",
          "targetOutsideRange": "ޓާގެޓް ރޭންޖުގެ ތެރޭގައި ހުންނަން ޖެހޭ.",
          "dateRequired": "ސިޔާސަތު ފެށޭ ތާރީޚް ޖަހާ.",
          "toBeforeFrom": "ނިމޭ ތާރީޚް ފެށޭ ތާރީޚަށްވުރެ ކުރިން ނުވާނެ.",
          "categoryTooLong": "އެންމެ ގިނަވެގެން 60 އަކުރު.",
          "basisTooLong": "އެންމެ ގިނަވެގެން 1000 އަކުރު."
        }
      },
      "rule": {
        "label": "{company} → {counterparty}",
        "window": "{from} އިން {to} އަށް",
        "openWindow": "{from} އިން",
        "placeholder": "މި ދެކޮޅު ގުޅާ ގަވާއިދު ހޮވާ",
        "typedPlaceholder": "އިންޓަރކޮމްޕެނީ ގަވާއިދުގެ އައިޑީ",
        "hint": "ކުންފުނި ދެކޮޅު ނަގަނީ އެންޓަރޕްރައިޒް، ޤާނޫނީ ފަރާތްތައް، އިންޓަރކޮމްޕެނީގައި ސެޓްކޮށްފައިވާ ގަވާއިދުން."
      },
      "list": {
        "filters": "ފިލްޓަރުތައް",
        "anyStatus": "ކޮންމެ ހާލަތެއް",
        "anyMethod": "ކޮންމެ ގޮތެއް",
        "asAt": "ނުފޫޒުވާ ތާރީޚް",
        "asAtHint": "މި ތާރީޚް ހިމެނޭ ސިޔާސަތުތައް އެކަނި.",
        "create": "ސިޔާސަތު ޑްރާފްޓްކުރުން",
        "loadFailed": "ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތުތައް ލޯޑް ނުކުރެވުނު.",
        "emptyTitle": "ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތެއް ނެތް",
        "emptyDescription": "އިންޓަރކޮމްޕެނީ ދެކޮޅެއްގެ އަގު ކަނޑައަޅާ ގޮތް ނިންމުމަށް ސިޔާސަތެއް ޑްރާފްޓްކުރޭ. އެޕްރޫވްނުވާހާ ހިނދަކު ސިޔާސަތުން އެއްވެސް އަގެއް ނުކަނޑައަޅައެވެ.",
        "tableTitle": "ސިޔާސަތުތައް",
        "caption": "ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތުތައް",
        "supersedes": "{no} ގެ ބަދަލުގައި",
        "original": "އަސްލު",
        "createTitle": "ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތެއް ޑްރާފްޓްކުރުން",
        "createDescription": "ސިޔާސަތު ރައްކާވަނީ ޑްރާފްޓެއްގެ ގޮތުގައި؛ ހުށަހަޅައި، ލިޔުނު މީހުން ނޫން މީހަކު އެޕްރޫވްކުރުމަށް ފަހު މެނުވީ އަގެއް ނުކަނޑައަޅައެވެ.",
        "draftNote": "ހަމަ އެ ދެކޮޅާއި ބާވަތުގެ އެހެން ސިޔާސަތަކާ ފުށުއަރާ މުއްދަތެއް ބަލައެއް ނުގަނެވޭ: އަގު ބަދަލުކުރަނީ އެޕްރޫވްކުރެވިފައިވާ ސިޔާސަތު ބަދަލުކޮށްގެން.",
        "createSubmit": "ޑްރާފްޓް ރައްކާކުރުން",
        "created": "{no} ޑްރާފްޓްކުރެވިއްޖެ."
      },
      "quote": {
        "title": "އަގު ބެލުން",
        "description": "ތާރީޚެއްގައި ބޭސް އަދަދަކަށް އެޕްރޫވްކުރެވިފައިވާ ސިޔާސަތުން ދޭ އަގު. އަގު ބެލުމުން އެއްވެސް އެއްޗެއް ރެކޯޑެއް ނުކުރެއެވެ.",
        "date": "ތާރީޚް",
        "base": "ބޭސް އަދަދު",
        "baseHint": "ގޮތް ހިންގާ އަދަދު: ކޮސްޓް ޕްލަސް އަށް ޚަރަދު، ރީސޭލް މައިނަސް އަށް ވިއްކާ އަގު، ޕްރޮފިޓް ސްޕްލިޓް އަށް ފައިދާގެ ޖުމްލަ، CUP އަށް އަޅާކިޔޭ އަގު.",
        "baseFormat": "1250.00 ފަދަ ޑެސިމަލް އަދަދެއް ޖަހާ.",
        "categoryHint": "އަގު ބަލާ މުޢާމަލާތުގެ ބާވަތް؛ ހުސްނަމަ ދެކޮޅުގެ ޢާންމު ސިޔާސަތު.",
        "submit": "އަގު ބަލާ",
        "resultTitle": "ނިކުތް އަގު",
        "price": "އަގު",
        "armsLength": "އާމްސް ލެންތު ރޭންޖު",
        "policyApplied": "ހިންގި ސިޔާސަތު",
        "methodNote": "ހިސާބުގެ ބިންގާ: {method}"
      },
      "departures": {
        "title": "ސިޔާސަތުން ބޭރުވުންތައް",
        "description": "ޑޮކިއުމަންޓް ތާރީޚުގައި އެޕްރޫވްކުރެވިފައިވާ އެއްވެސް ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތެއް ނުހިމެނޭ އިންޓަރކޮމްޕެނީ މުޢާމަލާތްތައް.",
        "from": "ފެށޭ",
        "to": "ނިމޭ",
        "datesInvalid": "ރަނގަޅު މުއްދަތެއް ޖަހާ: ފެށުން ނިމުމަށްވުރެ ފަހު ނުވާނެ.",
        "reason": "ސަބަބު",
        "anyReason": "ކޮންމެ ސަބަބެއް",
        "scopeNote": "މި ރިޕޯޓުން ބަލަނީ ހިމެނުން: މުޢާމަލާތުގެ ތާރީޚުގައި ދެކޮޅާއި ޑޮކިއުމަންޓް ބާވަތަށް އެޕްރޫވްކުރެވިފައިވާ ސިޔާސަތެއް އޮތްތޯ. އަގު ސިޔާސަތުގެ ޝަރުތުތަކުގެ ތެރޭގައި ހުރިތޯ މިހާރު ނުބަލައެވެ، ސަބަބަކީ ރެކޯޑުކުރެވޭ އިންޓަރކޮމްޕެނީ މުޢާމަލާތްތަކުގައި އަގުގެ ބޭސްއެއް ނެތުން.",
        "loadFailed": "ބޭރުވުންތަކުގެ ރިޕޯޓު ލޯޑް ނުކުރެވުނު.",
        "examined": "{count} މުޢާމަލާތް ބަލައިފި، {found} ބޭރުވުން.",
        "truncated": "މި މުއްދަތުގައި ރިޕޯޓަކުން ބަލާ ވަރަށްވުރެ ގިނަ މުޢާމަލާތް ހުރި؛ ބެލީ ފުރަތަމަ {count} އެކަނި. ބާކީ ބެލުމަށް މުއްދަތު ކުޑަކުރޭ.",
        "emptyTitle": "ބޭރުވުމެއް ނެތް",
        "emptyDescription": "މި މުއްދަތުގެ ކޮންމެ އިންޓަރކޮމްޕެނީ މުޢާމަލާތެއް އެޕްރޫވްކުރެވިފައިވާ ސިޔާސަތެއްގައި ހިމެނިއްޖެ.",
        "tableTitle": "ބޭރުވުންތައް",
        "caption": "އެޕްރޫވްކުރެވިފައިވާ ސިޔާސަތުން ބޭރުން އަގުކުރެވުނު އިންޓަރކޮމްޕެނީ މުޢާމަލާތްތައް",
        "docDate": "ޑޮކިއުމަންޓް ތާރީޚް",
        "document": "ޑޮކިއުމަންޓް",
        "direction": "ދިމާ",
        "amount": "އަދަދު",
        "source": "މަސްދަރު",
        "openSource": "ޖާނަލް ހުޅުވާ",
        "openPolicies": "ސިޔާސަތުތައް ބަލާ",
        "reasons": {
          "no_policy": "ސިޔާސަތެއް ނެތް",
          "policy_not_approved": "ސިޔާސަތު އެޕްރޫވްވެފައެއް ނެތް"
        },
        "directions": {
          "due_from": "ލިބެންޖެހޭ",
          "due_to": "ދައްކަންޖެހޭ"
        },
        "sourceStates": {
          "missing": "ރެކޯޑުކުރެވުނު މުޢާމަލާތް ނުފެނުނު.",
          "noJournal": "މި މުޢާމަލާތަށް ހުޅުވާނެ ޖާނަލެއް ނެތް."
        }
      },
      "policy": {
        "routeTitle": "ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތު",
        "title": "ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތު {no}",
        "description": "ސިޔާސަތެއްގެ ޝަރުތުތަކާއި، ދައުރާއި، ހެކިތަކާއި ވާޝަންތަކުގެ ތާރީޚް.",
        "back": "ހުރިހާ ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތެއް",
        "loadFailed": "ސިޔާސަތު ލޯޑް ނުކުރެވުނު.",
        "versionOf": "{count} ގެ ތެރެއިން ވާޝަން {version}",
        "edit": "ޑްރާފްޓް އެޑިޓްކުރުން",
        "submit": "އެޕްރޫވަލަށް ހުށަހެޅުން",
        "supersede": "ބަދަލުކުރުން",
        "successorOpen": "ބަދަލަށް އަންނަ ސިޔާސަތެއް މިހާރުވެސް ހުޅުވިފައި ({status}):",
        "rejected": "އެޕްރޫވްކުރާ މީހާ ޑްރާފްޓަށް އަނބުރާ ފޮނުވި: {note}",
        "pendingNote": "އެޕްރޫވަލްސް އިންބޮކްސްގައި އެޕްރޫވަލަށް މަޑުކުރަނީ. ނިންމަންދެން ޝަރުތުތައް ބަދަލެއް ނުކުރެވޭނެ.",
        "terms": "ޝަރުތުތައް",
        "ruleNo": "ގަވާއިދު {id}",
        "createdBy": "ޑްރާފްޓްކުރީ",
        "submittedBy": "ހުށަހެޅީ",
        "approvedBy": "އެޕްރޫވްކުރީ",
        "editTitle": "ޑްރާފްޓް އެޑިޓްކުރުން",
        "stale": "މި ސިޔާސަތު އެހެން މީހަކު ބަދަލުކޮށްފި. އެމީހުންގެ ވާޝަން ނަގަން ރީލޯޑްކޮށް، ދެން ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
        "reload": "ރީލޯޑް",
        "saved": "ޑްރާފްޓް ރައްކާކުރެވިއްޖެ.",
        "submitted": "އެޕްރޫވަލަށް ހުށަހެޅިއްޖެ.",
        "you": "ތިބާ",
        "evidenceRequirement": "އަގުގެ ފަހަތުގައިވާ ބެންޗްމާކިންގ ދިރާސާ، އަޅާކިޔުންތައް ނުވަތަ އެއްބަސްވުން ގުޅާ. ހުށަހެޅުމަށް ބިންގާގެ ނޯޓެއް ނުވަތަ އެންމެ ކުޑަމިނުން ފައިލެއް ބޭނުންވޭ."
      },
      "changes": {
        "title": "ބަދަލުވާ ކަންކަން",
        "against": "ބަދަލުކުރާ ސިޔާސަތާ އަޅާކިޔާއިރު:",
        "loadFailed": "ބަދަލުކުރެވޭ ސިޔާސަތު ލޯޑް ނުކުރެވުނު.",
        "noChanges": "ބަދަލުކުރެވޭ ސިޔާސަތާ ތަފާތު ޝަރުތެއް ނެތް.",
        "term": "ޝަރުތު",
        "before": "ކުރިން",
        "after": "ފަހުން",
        "none": "ނެތް"
      },
      "versions": {
        "title": "ވާޝަންތަކުގެ ތާރީޚް",
        "loadFailed": "ވާޝަންތަކުގެ ތާރީޚް ލޯޑް ނުކުރެވުނު.",
        "version": "ވާޝަން"
      },
      "supersede": {
        "title": "ސިޔާސަތު ބަދަލުކުރުން",
        "description": "ބަދަލަށް އަންނަ ޑްރާފްޓެއް ހުޅުވާ. އެޕްރޫވްކުރެވިފައިވާ ސިޔާސަތު ނުފޫޒުވާނީ ބަދަލަށް އަންނަ ސިޔާސަތު އެޕްރޫވްވާންދެން، ދެން އެ ނިމޭނީ އާ ސިޔާސަތު ފެށޭ ދުވަހުގެ ކުރީ ދުވަހު.",
        "fromAfter": "ބަދަލަށް އަންނަ ސިޔާސަތު ފެށެންވާނީ {date} އަށް ފަހު.",
        "note": "ގޮތް ބަދަލުކުރުމުން ކުރީގެ ގޮތުގެ ޕަސެންޓްތައް ނުގެންދެވޭ: އާ ގޮތަށް ބޭނުންވާ ޕަސެންޓްތައް ބުނޭ.",
        "confirm": "ބަދަލަށް އަންނަ ޑްރާފްޓް ހުޅުވުން",
        "created": "{no} ބަދަލަށް އަންނަ ޑްރާފްޓެއްގެ ގޮތުގައި ހުޅުވިއްޖެ."
      },
      "discard": {
        "action": "ޑްރާފްޓް ދޫކޮށްލުން",
        "title": "{no} ދޫކޮށްލުން",
        "description": "ޑްރާފްޓް ބާތިލުކޮށް، ތިބާގެ ސަބަބާއެކު ތާރީޚެއްގެ ގޮތުގައި ރައްކާކުރެވޭނެ. އެއިން އެއްވެސް އަގެއް ނުކަނޑައަޅާ، މުއްދަތެއް ނުހިފާ، އަދި އެ ހުޅުވުނު ސިޔާސަތު ބަދަލުކުރުމަށް ހުރަސެއް ނާޅާ.",
        "reason": "ސަބަބު",
        "reasonTooLong": "ގިނަވެގެން {max} އަކުރު.",
        "confirm": "ޑްރާފްޓް ދޫކޮށްލުން",
        "stale": "މި ޑައިލޮގް ހުޅުވުމަށްފަހު އެހެން މީހަކު މި ސިޔާސަތު ބަދަލުކޮށްފި. ރީލޯޑްކޮށް، ދޫކޮށްލަން ބޭނުންވާ ޑްރާފްޓަކީ މިއީކަން ބަލާފައި އަލުން ކަށަވަރުކުރައްވާ.",
        "done": "{no} ދޫކޮށްލެވިއްޖެ.",
        "discardedNote": "{at} ގައި {who} ދޫކޮށްލި: {reason}",
        "predecessor": "މިއީ މި ސިޔާސަތުގެ ބަދަލަށް ހުޅުވުނު ޑްރާފްޓެކެވެ:"
      },
      "preview": {
        "heading": "ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތު",
        "noAccess": "މި ސިޔާސަތުގެ ޝަރުތުތައް ބެލުމަށް ޓްރާންސްފަރ ޕްރައިސިންގ ސިޔާސަތު ކިޔުމުގެ ހުއްދަ ބޭނުންވޭ.",
        "loadFailed": "ސިޔާސަތު ލޯޑް ނުކުރެވުނު.",
        "replaces": "ބަދަލުކުރާ އެޕްރޫވްކުރެވިފައިވާ ސިޔާސަތު",
        "newPolicy": "އާ ސިޔާސަތެއް: އެއްވެސް ސިޔާސަތެއް ބަދަލެއް ނުކުރޭ.",
        "open": "ސިޔާސަތު ހުޅުވާ"
      }
    }
  },
  "party": {
    "routeTitles": {
      "parties": "ފަރާތްތައް",
      "party": "ފަރާތް",
      "matrix": "ރުހުމުގެ މެޓްރިކްސް",
      "merges": "އެއްކުރުންތައް",
      "merge": "އެއްކުރުމުގެ މޭޒު",
      "catalogues": "ރުހުމުގެ ކެޓަލޮގްތައް",
      "consents": "ރުހުމުގެ ރެކޯޑްތައް",
      "suppressions": "ހުއްޓުވުންތައް",
      "dsrBoard": "މަޢުލޫމާތުގެ ވެރިންގެ އެދުންތައް",
      "dsr": "މަޢުލޫމާތުގެ ވެރިޔާގެ އެދުން",
      "retention": "ބެހެއްޓުމުގެ ކެޓަލޮގް",
      "loyaltyPrograms": "ވަފާތެރިކަމުގެ ޕްރޮގްރާމްތައް",
      "loyaltyProgram": "ވަފާތެރިކަމުގެ ޕްރޮގްރާމް",
      "loyaltyMembers": "ވަފާތެރިކަމުގެ މެންބަރުން",
      "loyaltyMember": "ވަފާތެރިކަމުގެ މެންބަރު"
    },
    "nav": {
      "label": "ފަރާތްތަކުގެ ބައިތައް",
      "parties": "ފަރާތްތައް",
      "merges": "އެއްކުރުންތައް",
      "consent": "ރުހުން",
      "catalogues": "ކެޓަލޮގްތައް",
      "suppressions": "ހުއްޓުވުންތައް",
      "dsr": "އެދުންތައް",
      "retention": "ބެހެއްޓުން",
      "loyalty": "ވަފާތެރިކަން"
    },
    "kind": {
      "person": "މީހެއް",
      "organisation": "ޖަމާޢަތެއް"
    },
    "status": {
      "active": "ހިނގަމުންދާ",
      "inactive": "ނުހިނގާ",
      "blocked": "ބްލޮކްކުރެވިފައި"
    },
    "identifierKind": {
      "national_id": "ދިވެހި ރައްޔިތެއްކަން އަންގައިދޭ ކާޑު",
      "passport": "ޕާސްޕޯޓް",
      "tax_id": "ޓެކްސް ނަންބަރު",
      "driving_licence": "ލައިސަންސް",
      "company_registration": "ކުންފުނި ރަޖިސްޓްރީ",
      "loyalty_number": "ވަފާތެރިކަމުގެ ނަންބަރު",
      "external_key": "ބޭރު ތަޅުދަނޑި"
    },
    "linkRule": {
      "manual": "އަތުން ގުޅުވާލެވުނު",
      "convert": "ބަދަލުކުރުމަކުން އުފެދުނު",
      "backfill": "ފަހުން ފުރައިލެވުނު",
      "merge": "އެއްކުރުމަކުން ބަދަލުވި",
      "auto_exact": "ވަނަވަރެއްގެ ސަބަބުން ދިމާވި",
      "import": "އިމްޕޯޓްކުރެވުނު"
    },
    "matchMethod": {
      "identifier": "އެއް ވަނަވަރެއް",
      "email": "އެއް އީމެއިލެއް",
      "phone": "އެއް ފޯނު ނަންބަރެއް",
      "name_address": "ވައްތަރު ނަމަކާއި އެޑްރެހެއް"
    },
    "consentState": {
      "granted": "ދީފައި",
      "withdrawn": "އަނބުރާ ގެންގޮސްފައި",
      "pending": "ޔަޤީންކުރުމަށް އިންތިޒާރުގައި",
      "expired": "މުއްދަތު ހަމަވެފައި",
      "not_asked": "އަހާފައެއް ނުވޭ"
    },
    "consentBasis": {
      "consent": "ރުހުން",
      "contract": "އެއްބަސްވުން",
      "legal_obligation": "ޤާނޫނީ ވާޖިބު",
      "legitimate_interest": "ޞައްޙަ މަޞްލަޙަތު",
      "vital_interest": "ދިރިއުޅުމުގެ މަޞްލަޙަތު",
      "public_task": "ޢާންމު ވާޖިބު"
    },
    "consentSource": {
      "portal": "ޕޯޓަލް",
      "web_form": "ވެބް ފޯމް",
      "import": "އިމްޕޯޓް",
      "verbal": "ބަހުން",
      "contract": "އެއްބަސްވުން",
      "api": "އޭޕީއައި",
      "staff": "މުވައްޒަފަކު ރެކޯޑްކުރި",
      "merge": "އެއްކުރުމަކުން ލިޔެވުނު",
      "system": "ނިޒާމު"
    },
    "medium": {
      "email": "އީމެއިލް",
      "sms": "އެސްއެމްއެސް",
      "voice": "ފޯނު ކޯލް",
      "whatsapp": "ވަޓްސްއެޕް",
      "postal": "ޕޯސްޓް",
      "in_app": "އެޕްގެ ތެރެއިން"
    },
    "suppressionReason": {
      "unsubscribe": "ސަބްސްކްރިޕްޝަން ހުއްޓާލައިފި",
      "hard_bounce": "އެޑްރެސް ނުފޯރި",
      "spam_complaint": "ސްޕޭމް ޝަކުވާ",
      "manual": "އަތުން އިތުރުކުރި",
      "dsr_objection": "މާކެޓިންއަށް ދެކޮޅު ހެދުން",
      "invalid": "ޞައްޙަ ނޫން އެޑްރެސް"
    },
    "mergeStatus": {
      "draft": "ދެލިކޮޕީ",
      "submitted": "ހުށަހަޅާފައި",
      "approved": "ފާސްކުރެވިފައި",
      "committed": "ފުރިހަމަކުރެވިފައި",
      "rejected": "ބަލައިނުގަނެވުނު",
      "cancelled": "ބާޠިލުކުރެވިފައި",
      "reversed": "އަނބުރާ ގެނެވިފައި"
    },
    "mergeField": {
      "display_name": "ދައްކާ ނަން",
      "email": "އީމެއިލް",
      "phone": "ފޯނު",
      "country_code": "ޤައުމު"
    },
    "mergeRule": {
      "S1": "އަނބުރާ ގެންދިއުން ހުރިހާ އެއްޗެއްގެ މައްޗަށް ކުރި ހޯދާ",
      "S2": "ހަރުކަށި ޙާލަތު ކުރި ހޯދާ",
      "S2prime": "ޙާލަތު އެއްވަރު — ފަހުން ނެގުނު ރެކޯޑް ކުރި ހޯދާ",
      "S3": "އަވަހަށް މުއްދަތު ހަމަވާ ރެކޯޑް ކުރި ހޯދާ",
      "R2": "އެއް ފަރާތުގައި ރެކޯޑެއް ނެތް، އެހެންވެ ނިންމުމެއް ނުނިންމުނު",
      "unknown": "މި ސްކްރީނަށް ނޭނގޭ ޤަވާޢިދެއް"
    },
    "mergeAction": {
      "unchanged": "ބަދަލެއް ނުވޭ",
      "written": "އައު ރެކޯޑެއް ލިޔެވުނު"
    },
    "mergeOutcome": {
      "moved": "ބަދަލުކުރެވުނު",
      "collided": "ޖެހި، ދަރަޖަ ދަށްކުރެވުނު",
      "skipped": "ދޫކޮށްލެވުނު"
    },
    "dsrKind": {
      "access": "ބެލުން",
      "portability": "ގެންދިއުން",
      "rectification": "ރަނގަޅުކުރުން",
      "erasure": "ފޮހެލުން",
      "restriction": "ހިފެހެއްޓުން",
      "objection": "ދެކޮޅު ހެދުން"
    },
    "dsrStatus": {
      "received": "ލިބިފައި",
      "awaiting_identity": "ވަނަވަރު ޔަޤީންކުރުމަށް އިންތިޒާރުގައި",
      "in_progress": "ކުރިއަށްދަނީ",
      "awaiting_extension": "މުއްދަތު އިތުރުކުރުމަށް އިންތިޒާރުގައި",
      "fulfilled": "ފުއްދިފައި",
      "refused": "ދޮގުކުރެވިފައި",
      "withdrawn": "އަނބުރާ ގެންގޮސްފައި"
    },
    "dsrChannel": {
      "email": "އީމެއިލް",
      "portal": "ޕޯޓަލް",
      "post": "ޕޯސްޓް",
      "phone": "ފޯނު",
      "in_person": "ސީދާ ބައްދަލުވުމުން",
      "api": "އޭޕީއައި"
    },
    "dsrLane": {
      "overdue": "މުއްދަތު ފަހަނައަޅާފައި",
      "today": "މިއަދު ހަމަވާ",
      "soon": "7 ދުވަހުގެ ތެރޭގައި ހަމަވާ",
      "later": "ފަހުން",
      "closed": "ބަންދުކުރެވިފައި"
    },
    "dsrTaskStatus": {
      "open": "ހުޅުވިފައި",
      "done": "ނިމިފައި",
      "not_applicable": "ނުހިނގާ"
    },
    "treatment": {
      "erase": "ފޮހެލުން",
      "pseudonymise": "ނަން ބަދަލުކުރުން",
      "retain_statutory": "ބެހެއްޓުން — ޤާނޫނީ",
      "retain_contract": "ބެހެއްޓުން — އެއްބަސްވުން",
      "retain_legitimate": "ބެހެއްޓުން — ޞައްޙަ މަޞްލަޙަތު",
      "retain_dispute": "ބެހެއްޓުން — ދެބަސްވުން"
    },
    "anchor": {
      "last_transaction": "އެންމެ ފަހު މުޢާމަލާތު",
      "relationship_end": "ގުޅުން ނިމުނު ދުވަސް",
      "record_created": "ރެކޯޑް އުފެއްދި ދުވަސް",
      "erasure_request": "ފޮހެލުމަށް އެދުނު ދުވަސް"
    },
    "register": {
      "title": "ފަރާތްތައް",
      "description": "ކޮންމެ މީހަކަށާއި ޖަމާޢަތަކަށް އެއް ވަނަވަރު. ކަސްޓަމަރުން، ވިއްކާ ފަރާތްތައް، މުވައްޒަފުން އަދި ޕޯޓަލް ޔޫޒަރުންނަކީ އެ ވަނަވަރަށް އިޝާރާތްކުރާ ރެކޯޑްތަކެވެ.",
      "create": "އައު ފަރާތެއް",
      "createTitle": "އައު ފަރާތެއް",
      "createDescription": "ފުރަތަމަ ކުރިން އޮތް ވަނަވަރެއް ހުރިތޯ ބައްލަވާ — މިތަނުން އުފައްދާ ދެވަނަ ރެކޯޑަކީ ފަހުން މީހަކު އެއްކުރަން ޖެހޭ ކަމެކެވެ.",
      "created": "ފަރާތް އުފެއްދިއްޖެ",
      "searchPlaceholder": "ނަން، އީމެއިލް ނުވަތަ ފޯނު",
      "anyKind": "ކޮންމެ ބާވަތެއް",
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "anyLinkType": "ކޮންމެ ގުޅުވިފައިވާ ރެކޯޑެއް",
      "linkTypeHint": "{count} ގުޅުވިފައި",
      "linked": "މި ގުޅުން އެބައޮތް",
      "notLinked": "މިފަދަ ގުޅުމެއް ނެތް",
      "name": "ނަން",
      "kind": "ބާވަތް",
      "status": "ޙާލަތު",
      "country": "ޤައުމު",
      "links": "ގުޅުންތައް",
      "flags": "ފްލެގްތައް",
      "erased": "ފޮހެލެވިފައި",
      "merged": "އެއްކުރެވިފައި",
      "email": "އީމެއިލް",
      "phone": "ފޯނު",
      "countryHint": "ދެ އަކުރުގެ އައިއެސްއޯ ކޯޑް. މިއިން ބެހެއްޓުމުގެ ސިޔާސަތު ކަނޑައެޅެއެވެ.",
      "checkDuplicates": "ދެފަހަރު އޮތްތޯ ބައްލަވާ",
      "exactMatch": "މި ފަރާތުގެ ވަނަވަރެއް މިހާރުވެސް އެހެން ފަރާތަކަށް ނިސްބަތްވެއެވެ. ދެވަނަ ރެކޯޑެއް އުފެއްދުމުގެ ބަދަލުގައި އެ ފަރާތް ހުޅުއްވާ.",
      "noCandidates": "ވައްތަރު އެއްޗެއް ނުފެނުނު. މި ފަރާތް އުފެއްދުން ރައްކާތެރި.",
      "candidatesFound": "ވައްތަރު {count} ފަރާތެއް މިހާރުވެސް އެބައޮތެވެ. އެއިން އެއް ފަރާތް ހުޅުއްވާ، ނުވަތަ ކުރިއަށް ގެންދަވާ.",
      "openExisting": "ކުރިން އޮތް ފަރާތް ހުޅުވާ",
      "emptyTitle": "އަދި ފަރާތެއް ނެތް",
      "emptyDescription": "ފަރާތްތައް އުފެދެނީ ފަހުން ފުރައިލުމުން، ލީޑެއް ބަދަލުކުރުމުން، އަދި މިތަނުން އަތުން."
    },
    "detail": {
      "tabsLabel": "ފަރާތުގެ ބައިތައް",
      "tabProfile": "360",
      "tabLinks": "ގުޅުވިފައިވާ ރެކޯޑްތައް",
      "tabIdentifiers": "ވަނަވަރުތައް",
      "tabTimeline": "ޓައިމްލައިން",
      "tabMerges": "އެއްކުރުންތައް",
      "openConsent": "ރުހުމުގެ މެޓްރިކްސް",
      "erasedBanner": "މަޢުލޫމާތުގެ ވެރިޔާގެ އެދުމަކާ ގުޅިގެން މި ފަރާތް ފޮހެލެވިފައިވެއެވެ. ގިނަ ދާނަތައް ފޮހެވިފައި، ބާކީ ހުރި ދާނަތައް ބެހެއްޓިފައި ވަނީ ބަޔާންކުރެވިފައިވާ ޤާނޫނީ ސަބަބަކާ ހެދިއެވެ.",
      "mergedBanner": "މި ފަރާތް އެއްކުރުމަކުން އެހެން ފަރާތެއްގެ ތެރެއަށް ވެއްދިފައިވެއެވެ.",
      "openSurvivor": "ބާކީ ހުރި ފަރާތް ހުޅުވާ"
    },
    "profile": {
      "consentTitle": "ރުހުން",
      "consentAsOf": "{date} އާ ހަމައަށް",
      "granted": "{count} ދީފައި",
      "pending": "{count} އިންތިޒާރުގައި",
      "withdrawn": "{count} އަނބުރާ ގެންގޮސްފައި",
      "openDsrTitle": "ހުޅުވިފައިވާ އެދުންތައް",
      "noSectionsTitle": "އަދި އެއްވެސް އެއްޗެއް ގުޅުވިފައި ނެތް",
      "noSectionsDescription": "މޮޑިއުލްތަކުން މި ވަނަވަރަށް ރެކޯޑްތައް ގުޅުވާލުމުން ބައިތައް ފެންނާނެއެވެ.",
      "sectionCount": "{count} ރެކޯޑް",
      "sectionEmpty": "ފަހުގެ އެއްޗެއް ނެތް.",
      "timelineNote": "ޙަރަކާތް، ރުހުން، ކެމްޕޭން، ވަފާތެރިކަން އަދި އެއްކުރުންތައް ސާވަރުން އެއްކޮށް ތަރުތީބުކުރެއެވެ.",
      "timelineEmptyTitle": "އަދި އެއްވެސް ކަމެއް ހިނގާފައެއް ނުވޭ",
      "timelineEmptyDescription": "މި ވަނަވަރާ ދެކޮޅަށް ރެކޯޑްކުރެވޭ ޙަރަކާތްތައް މިތާނގައި ފެންނާނެއެވެ."
    },
    "link": {
      "primary": "މައިގަނޑު",
      "orphaned": "މި ބާވަތުގެ ގުޅުމުގެ ވެރި މޮޑިއުލެއް ނެތް",
      "makePrimary": "މައިގަނޑަކަށް ހަދާ",
      "primarySet": "މައިގަނޑު ގުޅުން ކަނޑައެޅިއްޖެ",
      "emptyTitle": "ރެކޯޑެއް ގުޅުވިފައި ނެތް",
      "emptyDescription": "މި ވަނަވަރާ ގުޅުވިފައިވާ ކަސްޓަމަރެއް، ވިއްކާ ފަރާތެއް، މުވައްޒަފެއް ނުވަތަ ޕޯޓަލް ޔޫޒަރެއް މިތާނގައި ފެންނާނެއެވެ."
    },
    "identifier": {
      "add": "ވަނަވަރު އިތުރުކުރޭ",
      "added": "ވަނަވަރު އިތުރުކުރެވިއްޖެ",
      "addTitle": "ވަނަވަރެއް އިތުރުކުރުން",
      "addDescription": "އަގު ރައްކާކުރެވެނީ ސިއްރުކޮށްފައެވެ އަދި ދައްކަނީ ފޮރުވިފައެވެ. ފަހުން އެ ދެއްކުމަކީ ވަކި، އޮޑިޓްކުރެވޭ ޢަމަލެކެވެ.",
      "kind": "ބާވަތް",
      "issuingCountry": "ދޫކުރި ޤައުމު",
      "value": "އަގު",
      "verification": "ޔަޤީންކުރުން",
      "verificationHint": "މީހަކު ލިޔުން ބެލިކަން ރެކޯޑްކުރޭ. ފޮހެލުމުގެ ވަނަވަރު ޔަޤީންކުރުމުގެ ގޭޓުން މި ބޭނުންކުރެއެވެ.",
      "notVerified": "ބަލާފައެއް ނުވޭ",
      "verifiedNow": "ލިޔުމާ އަޅާކިޔައި ބެލިފައި",
      "verified": "ޔަޤީންކުރެވިފައި",
      "maskedNote": "ވަނަވަރުތައް ރައްކާކުރެވެނީ ސިއްރުކޮށްފައި އަދި ދައްކަނީ ފޮރުވިފައެވެ. އެ ދެއްކުމަށް ދެވަނަ ފަށަލައެއް، ސަބަބެއް ބޭނުންވެ، އަދި އޮޑިޓް ރެކޯޑެއް ލިޔެވެއެވެ.",
      "reveal": "ދައްކާ",
      "revealTitle": "މި ވަނަވަރު ދެއްކުން",
      "revealDescription": "ތިޔަ ބޭފުޅާ މިހާރު ފުރިހަމަ {kind} ބައްލަވަން އުޅުއްވަނީއެވެ.",
      "revealConsequence": "މިއިން ތިޔަ ބޭފުޅާގެ ނަމާއި، ވަނަވަރާއި، ދެއްކުމުގެ ސަބަބު ބަޔާންކުރާ ރެކޯޑެއް ލިޔެވެއެވެ، އަދި ދެވަނަ ފަށަލައަކަށް އެދެވޭނެއެވެ. އަގު ދެއްކެނީ އެންމެ ފަހަރަކު އަދި މި ސްކްރީނުން ރައްކާނުކުރެއެވެ.",
      "reason": "ދައްކަނީ ކީއްވެގެންތޯ؟",
      "reasonHint": "މި ޖުމުލައިން އަހަރެއް ފަހުން އޮޑިޓް ރެކޯޑަށް ޖަވާބު ދެވެއެވެ.",
      "revealConfirm": "ދައްކާ",
      "revealedNote": "ދެއްކުނީ އެއްފަހަރު. މި ފޮށި ބަންދުކުރުމުން ފޮހެވޭނެ.",
      "emptyTitle": "ވަނަވަރެއް ރެކޯޑްކުރެވިފައި ނެތް",
      "emptyDescription": "މިތާނގައި ރެކޯޑްކުރެވޭ ޕާސްޕޯޓެއް، ދިވެހި ރައްޔިތެއްކަން އަންގައިދޭ ކާޑެއް ނުވަތަ ޓެކްސް ނަންބަރަކުން، ދެ ރެކޯޑަކީ އެއް މީހެއްކަން ދެނެގަނެވެއެވެ."
    },
    "match": {
      "railTitle": "ދެފަހަރު އޮވެދާނެ ފަރާތްތައް",
      "railDescription": "މިއީ ހުށަހެޅުންތަކެއް، އަމުރުތަކެއް ނޫން. މީހަކު ފުރިހަމަކުރަންދެން އެއްވެސް އެއްޗެއް އެއްނުކުރެވެއެވެ.",
      "queueTitle": "ހުށަހެޅިފައިވާ ދެފަހަރު ރެކޯޑްތައް",
      "queueDescription": "ސްކޯރުން ތަރުތީބުކުރެވިފައި. ސްކޯރަކީ ބަލައިލަން ޖެހޭ ސަބަބެއް، ޖަވާބެއް ނޫން.",
      "queueEmptyTitle": "ހުށަހެޅިފައި އެއްވެސް އެއްޗެއް ނެތް",
      "queueEmptyDescription": "ކޮންމެ ހަފުތާއަކު ހިނގާ ބެލުމަކުން ދެފަހަރު ރެކޯޑްތައް ހުށަހަޅައެވެ. ދާދި ފަހުން މަޢުލޫމާތު އިމްޕޯޓްކުރެއްވި ނަމަ މިހާރު ހިންގަވާ.",
      "emptyTitle": "ދެފަހަރު ރެކޯޑެއް ހުށަހެޅިފައި ނެތް",
      "emptyDescription": "މި ފަރާތާ ވައްތަރު އެހެން ފަރާތެއް ބެލުމަކުން ނުފެނުނެވެ.",
      "pair": "ދެ ފަރާތް",
      "method": "ދިމާވީ",
      "score": "ސްކޯރ",
      "signals": "ނިޝާންތައް",
      "status": "ޙާލަތު",
      "statusOpen": "ހުޅުވިފައި",
      "statusDismissed": "ދޫކޮށްލެވިފައި",
      "statusMerged": "އެއްކުރެވިފައި",
      "propose": "އެއްކުރުމަކަށް ހުށަހަޅާ",
      "dismiss": "ދޫކޮށްލާ",
      "dismissed": "ދޫކޮށްލެވިއްޖެ",
      "dismissTitle": "މި ހުށަހެޅުން ދޫކޮށްލުން",
      "dismissDescription": "ސަބަބުން ދޫކޮށްލުން ދެމިއޮވެއެވެ — ދެން ހިނގާ ބެލުމަކުން މި ދެ ފަރާތް އަލުން ހުށަހެއް ނާޅާނެއެވެ.",
      "dismissReason": "މި ދޭތި އެއް ފަރާތަކަށް ނުވަނީ ކީއްވެގެންތޯ؟",
      "runSweep": "ބެލުން ހިންގާ",
      "sweepTitle": "ދެފަހަރު ރެކޯޑްތައް ބެލުން ހިންގުން",
      "sweepDescription": "ތާވަލަކީ ކޮންޓްރޯލެއް ނޫނެވެ. ތިޔަ ބޭފުޅާ ޚިޔާރުކުރައްވާ ތާރީޚަކާ ދެކޮޅަށް މިހާރު ހިންގަވާ.",
      "sweepOn": "މި ތާރީޚަށް",
      "sweepOnHint": "ހުސްކޮށް ބެހެއްޓުމުން ޓެނަންޓްގެ ގަޑިން މިއަދު.",
      "sweepResult": "{scanned} ބެލެވުނު. އައު {proposed} ހުށަހެޅުނު. {open} މިހާރުވެސް ކިޔޫގައި އޮތް؛ {suppressed} ކުރިން ދޫކޮށްލެވިފައިވާތީ އަލުން ހުށަހަޅާފައެއް ނުވޭ."
    },
    "merge": {
      "inboxTitle": "އެއްކުރުންތައް",
      "inboxDescription": "ހުށަހެޅިފައިވާ ދެފަހަރު ރެކޯޑްތަކާއި، އެ ޙައްލުކުރާ އެއްކުރުމުގެ ލިޔުންތައް.",
      "documentsTitle": "އެއްކުރުމުގެ ލިޔުންތައް",
      "documentsEmptyTitle": "އަދި އެއްކުރުމެއް ނެތް",
      "documentsEmptyDescription": "އެއްކުރުމެއް ފެށެނީ ހުށަހެޅިފައިވާ ދެފަހަރު ރެކޯޑަކުން، ނުވަތަ ފަރާތުގެ ސްކްރީނުން.",
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "no": "ނަންބަރު",
      "parties": "ފަރާތްތައް",
      "status": "ޙާލަތު",
      "linksMoved": "ބަދަލުކުރެވުނު",
      "reversibleUntil": "އަނބުރާ ގެނެވޭނީ",
      "survivorIs": "ބާކީ ހުންނަނީ: {name}",
      "sourceIs": "ވެއްދެނީ: {name}",
      "workbenchDescription": "ދާނަ ދާނައިން ޚިޔާރުކުރައްވާ، ރުހުމުގެ ނަތީޖާ ބައްލަވާ، އަދި ފުރިހަމަކުރައްވާ.",
      "fieldsTitle": "ދާނަތައް",
      "fieldsDescription": "ތިޔަ ބޭފުޅާ ވެއްދޭ ފަރާތުގެ އަގު ޚިޔާރުނުކުރައްވާހާ ހިނދަކު، ބާކީ ހުންނަ ފަރާތުގެ އަގު ދެމިއޮންނާނެއެވެ.",
      "field": "ދާނަ",
      "survivorValue": "ބާކީ ހުންނަ ފަރާތް",
      "sourceValue": "ވެއްދޭ ފަރާތް",
      "saveChoices": "ޚިޔާރުކުރުންތައް ރައްކާކުރޭ",
      "choicesSaved": "ޚިޔާރުކުރުންތައް ރައްކާކުރެވިއްޖެ",
      "consentTitle": "ރުހުމުގެ ނަތީޖާ",
      "consentDescription": "ޙައްލުކުރީ ސާވަރުންނެވެ. މި ތާވަލަކީ ކޮންމެ ގޮޅިއެއް ނިންމި ޤަވާޢިދު ބަޔާންކުރާ ރެކޯޑެވެ — މިތަނުން އެއްވެސް އެއްޗެއް ބްރައުޒަރުގައި އަލުން ހިސާބެއް ނުކުރެއެވެ.",
      "consentCaption": "ދެ ފަރާތުގެ ދެމެދުގައި އޮތް ކޮންމެ ޗެނަލަކާއި މަޤުޞަދަކަށް އެއް ސަޠުރު.",
      "consentEmptyTitle": "ދެ ފަރާތުގައިވެސް ރުހުމުގެ ރެކޯޑެއް ނެތް",
      "consentEmptyDescription": "ޙައްލުކުރާނެ އެއްޗެއް ނެތް، އަދި އެއްކުރުމުން ރުހުމުގެ ސަޠުރެއް ނުލިޔެއެވެ.",
      "inputSurvivor": "ބާކީ ހުންނަ ފަރާތުގައި",
      "inputSource": "ވެއްދޭ ފަރާތުގައި",
      "winner": "ކުރި ހޯދީ",
      "winner_survivor": "ބާކީ ހުންނަ ފަރާތް",
      "winner_source": "ވެއްދޭ ފަރާތް",
      "decidingRule": "ނިންމި ޤަވާޢިދު",
      "action": "ޢަމަލު",
      "noRecord": "ރެކޯޑެއް ނެތް",
      "movePreviewTitle": "ބަދަލުވާނެ އެއްޗެހި",
      "movePreviewDescription": "މިއަދު ވެއްދޭ ފަރާތުގެ މިލްކުގައިވާ ކޮންމެ ރެކޯޑެއް.",
      "movePreviewEmptyTitle": "ބަދަލުވާނެ އެއްޗެއް ނެތް",
      "movePreviewEmptyDescription": "ވެއްދޭ ފަރާތުގެ ގުޅުވިފައިވާ ރެކޯޑެއް ނެތެވެ.",
      "wouldCollide": "ޖެހޭނެ",
      "lineageTitle": "ބަދަލުވި އެއްޗެހި",
      "lineageDescription": "މި އެއްކުރުމުން ދޫކުރި ސިލްސިލާ، ރެކޯޑަކުން ރެކޯޑަކަށް.",
      "lineageEmptyTitle": "އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވި",
      "lineageEmptyDescription": "ފުރިހަމަކުރިއިރު ވެއްދި ފަރާތުގެ ގުޅުވިފައިވާ ރެކޯޑެއް ނެތެވެ.",
      "movedFromTo": "ފަރާތް {from} → {to}",
      "submitTitle": "ފާސްކުރުމަށް ހުށަހެޅުން",
      "submitDescription": "އެއްކުރުމަކުން މާލީ ރެކޯޑްތައް އަލުން ގުޅުވެއެވެ، އެހެންކަމުން ހުށަހެޅި މީހާ އެ ފާސްކުރާކަށް ނުޖެހެއެވެ.",
      "submitted": "އެއްކުރުން ހުށަހެޅިއްޖެ",
      "reasonCode": "ސަބަބު",
      "reasonNote": "ނޯޓް",
      "approve": "ފާސްކުރޭ",
      "approved": "އެއްކުރުން ފާސްކުރެވިއްޖެ",
      "rejectTitle": "މި އެއްކުރުން ބަލައިނުގަތުން",
      "rejectReason": "ކީއްވެގެންތޯ؟",
      "rejected": "އެއްކުރުން ބަލައިނުގަނެވުނު",
      "commit": "އެއްކުރުން ފުރިހަމަކުރޭ",
      "commitTitle": "އެއްކުރުން ފުރިހަމަކުރުން",
      "commitDescription": "ގުޅުންތައް ބަދަލުވެ، ރުހުން ޙައްލުވެ، ވެއްދޭ ފަރާތް ބަންދުވެއެވެ.",
      "commitWarning": "ފުރިހަމަކުރުމުން މާލީ ރެކޯޑްތައް އަލުން ގުޅުވެއެވެ. މުއްދަތުގެ ތެރޭގައި އަނބުރާ ގެނެވިދާނެ، އަދި އަނބުރާ ގެނައުމަކުން ހުރިހާ އެއްޗެއް ނުލިބޭނެއެވެ.",
      "commitOverrideNote": "މި ދޮގުކުރުން ފަހަނައަޅައި ދެވިދާނެ، އަދި ފަހަނައަޅައި ދެވެނީ އެއްކުރުން ހުށަހެޅި ސަބަބުންނެވެ. އިތުރު އެއްޗެއް ނާހައެވެ — ރެކޯޑްގައިވާ ސަބަބުން ނުފުދޭ ނަމަ ފުދޭ ސަބަބަކާއެކު އަލުން ހުށަހަޅުއްވާ.",
      "committed": "އެއްކުރުން ފުރިހަމަކުރެވިއްޖެ",
      "reverse": "އެއްކުރުން އަނބުރާ ގެންނަވާ",
      "reverseTitle": "މި އެއްކުރުން އަނބުރާ ގެނައުން",
      "reverseDescription": "ޔަޤީންކުރެއްވުމުގެ ކުރިން، އަނބުރާ ގެނައުމަކުން ނުލިބޭނެ އެއްޗެހި ބައްލަވާ.",
      "reverseLimitations": "އަނބުރާ ގެނައުމަކުން އެއްކުރުމުން ބަދަލުކުރި އެއްޗެހި އިޢާދަކުރެއެވެ. އޭގެ ފަހުން ހިނގި ކަންކަން އިޢާދައެއް ނުކުރެއެވެ.",
      "reverseLimitPostMerge": "އެއްކުރުމަށްފަހު އުފެއްދި ރެކޯޑްތައް ބާކީ ހުންނަ ފަރާތާއެކު ދެމިއޮންނާނެއެވެ — އެ ރެކޯޑްތައް ނިސްބަތްވާނެ ފަރާތް ބުނުމަކީ ލަފާކުރުމެކެވެ.",
      "reverseLimitEdited": "އެއްކުރުމަށްފަހު އެޑިޓްކުރި ދާނަތައް އިޢާދަނުކޮށް ދޫކޮށްލެވެއެވެ.",
      "reverseLimitWindow": "އަނބުރާ ގެނައުމުގެ މުއްދަތު ފަހަނައަޅާފައިވާ އެއްކުރުމެއް އަނބުރައެއް ނުގެނެވޭނެއެވެ.",
      "reverseLimitErased": "ފަރާތް ފޮހެލެވިފައިވާ، ނުވަތަ އަލުން އެއްކުރެވިފައިވާ އެއްކުރުމެއް އަނބުރައެއް ނުގެނެވޭނެއެވެ.",
      "reverseReason": "އަނބުރާ ގެންނަވަނީ ކީއްވެގެންތޯ؟",
      "reversed": "އެއްކުރުން އަނބުރާ ގެނެވިއްޖެ",
      "reverseRestored": "{links} ގުޅުމާއި، {consents} ރުހުމުގެ ރެކޯޑާއި، {fields} ދާނަ އިޢާދަކުރެވިއްޖެ.",
      "reverseRetainedTitle": "ބާކީ ހުންނަ ފަރާތާއެކު ދޫކުރެވުނު — އެއްކުރުމަށްފަހު އުފެދުނު:",
      "reverseEditedTitle": "ދޫކޮށްލެވުނު — އެއްކުރުމަށްފަހު އެޑިޓްކުރެވުނު:",
      "cancelTitle": "މި އެއްކުރުން ބާޠިލުކުރުން",
      "cancelReason": "ކީއްވެގެންތޯ؟",
      "cancelMerge": "އެއްކުރުން ބާޠިލުކުރޭ",
      "cancelled": "އެއްކުރުން ބާޠިލުކުރެވިއްޖެ",
      "emptyTitle": "މި ފަރާތުގެ އެއްކުރުމުގެ ތާރީޚެއް ނެތް",
      "emptyDescription": "މި ވަނަވަރު ހިމެނޭ އެއްކުރުންތައް، ދެ ފަރާތުންވެސް، މިތާނގައި ފެންނާނެއެވެ."
    },
    "consent": {
      "matrixTitle": "ރުހުމުގެ މެޓްރިކްސް",
      "matrixCaption": "މަޤުޞަދުތައް ތިރިއަށް، ޗެނަލްތައް ހުރަހަށް. ޙާލަތަކީ ރެކޯޑްކުރެވިފައިވާ އެއްޗެއް؛ ގުޅޭނެތޯ ނިންމަނީ ސާވަރެވެ.",
      "matrixEmptyTitle": "ޗެނަލެއް ނުވަތަ މަޤުޞަދެއް ކަނޑައެޅިފައި ނެތް",
      "matrixEmptyDescription": "ރުހުން ނެގުމުގެ ކުރިން ކެޓަލޮގުން ޗެނަލަކާއި މަޤުޞަދެއް އިތުރުކުރައްވާ.",
      "backToParty": "ފަރާތަށް އެނބުރި",
      "asOf": "މި ތާރީޚަށް",
      "asOfHint": "ހުސްކޮށް ބެހެއްޓުމުން މިހާރު ހިނގާ ރެކޯޑް. ތާރީޚަކުން އެ ދުވަހުގެ ޙާލަތު ބުނެދެއެވެ.",
      "purpose": "މަޤުޞަދު",
      "cell": "މަޤުޞަދާއި ޗެނަލް",
      "party": "ފަރާތް",
      "state": "ޙާލަތު",
      "basis": "ޤާނޫނީ އަސާސް",
      "source": "މަޞްދަރު",
      "window": "ހިނގާ މުއްދަތު",
      "evidence": "ހެކި",
      "permitted": "ގުޅިދާނެ",
      "blocked": "ހުއްޓުވިފައި",
      "expiresOn": "{date} ގައި ހަމަވޭ",
      "historyTitle": "ރުހުމުގެ ތާރީޚު",
      "historyEmptyTitle": "މި ގޮޅިއަށް ރެކޯޑެއް ނެތް",
      "historyEmptyDescription": "މި ޗެނަލުން މި މަޤުޞަދަށް އެއްވެސް އެއްޗެއް ނަގާފައެއް ނުވެއެވެ.",
      "capture": "ރުހުން ނަގާ",
      "captured": "ރުހުން ނެގިއްޖެ",
      "captureTitle": "ރުހުން ނެގުން",
      "captureDescription": "ފަރާތުން ނިންމި ގޮތާއި، ވަގުތާއި، ހެކީގެ ރެކޯޑެއް.",
      "effectiveFrom": "ހިނގަން ފަށާ",
      "effectiveFromHint": "ހުސްކޮށް ބެހެއްޓުމުން ޓެނަންޓްގެ ގަޑިން މިއަދު.",
      "evidenceRef": "ހެކީގެ ރިފަރެންސް",
      "evidenceText": "ހެކި",
      "evidenceHint": "ފަރާތުން ޙަޤީޤަތުގައި ކުރި ކަންތައް — ފޯމުގައި އޮތް ޢިބާރާތް، ފޯނުކޯލުގައި ބުނި ބަސް.",
      "evidenceRequired": "ރުހުމުގެ އަސާސުގައި ދޭ ރުހުމަކަށް ހެއްކެއް ބޭނުންވެއެވެ. ސާވަރުން އެއާ ނުލައި ދޮގުކުރެއެވެ، އަދި މި ފޯމުންވެސް ދޮގުކުރެއެވެ.",
      "overlapExplained": "ހަމަ އެ ތާރީޚުތަކުގައި މި ގޮޅި ފޫބައްދާ އެހެން ރެކޯޑެއް އެބައޮތެވެ. ފުރަތަމަ އެ ރެކޯޑް އަނބުރާ ގެންދަވާ ނުވަތަ ބަދަލުކުރައްވާ.",
      "withdraw": "އަނބުރާ ގެންދޭ",
      "withdrawn": "ރުހުން އަނބުރާ ގެންދެވިއްޖެ",
      "withdrawTitle": "މި ރުހުން އަނބުރާ ގެންދިއުން",
      "withdrawDescription": "ރެކޯޑް ބަންދުވެ، އޭގެ ބަދަލުގައި އަނބުރާ ގެންދިއުމުގެ ރެކޯޑެއް ލިޔެވެއެވެ.",
      "withdrawWarning": "އަނބުރާ ގެންދިއުމަކީ އެއްކުރުމަކުން ގެންނަ ފަހުގެ ކޮންމެ ރުހުމެއްގެ މައްޗަށް ކުރި ހޯދާ ޙާލަތެވެ. އެއީ އެންމެ ހަރުކަށި ޙާލަތެވެ.",
      "withdrawReason": "ސަބަބު",
      "withdrawFromHint": "ހުސްކޮށް ބެހެއްޓުމުން މިއަދު. ކުރީގެ ތާރީޚެއްގައި ހިނގި އަނބުރާ ގެންދިއުމެއް ރެކޯޑްކުރުމަށް އެ ތާރީޚު ދެއްވާ.",
      "recordsTitle": "ރުހުމުގެ ރެކޯޑްތައް",
      "recordsDescription": "ޓެނަންޓްގައިވާ ކޮންމެ ރުހުމުގެ ހެއްކެއް، ކޮންމެ ތާރީޚަކާ ހަމައަށް ޖަވާބުދެވޭ ގޮތަށް.",
      "recordsEmptyTitle": "ރުހުމުގެ ރެކޯޑެއް ނެތް",
      "recordsEmptyDescription": "ރުހުން ނެގެނީ ފަރާތުގެ މެޓްރިކްސުން، ކުރީގެ ނިޒާމަކުން އިމްޕޯޓްކޮށްގެން، ނުވަތަ ޕޯޓަލް ފޯމަކުން.",
      "anyChannel": "ކޮންމެ ޗެނަލެއް",
      "anyPurpose": "ކޮންމެ މަޤުޞަދެއް",
      "anyState": "ކޮންމެ ޙާލަތެއް",
      "exportEvidence": "ހެކި އެކްސްޕޯޓްކުރޭ",
      "exported": "ހެކި އެކްސްޕޯޓްކުރެވިއްޖެ",
      "import": "އިމްޕޯޓް",
      "importTitle": "ރުހުމުގެ ތާރީޚެއް އިމްޕޯޓްކުރުން",
      "importDescription": "މި ޓެނަންޓް ދޫކޮށްލާ ނިޒާމަކުން ނެގި ސީއެސްވީއެއް.",
      "importEpochNote": "ހިނގަން ފަށާ ތާރީޚެއް ނެތް ސަޠުރެއް ފެށެނީ އެންމެ ކުރީގެ ތާރީޚުން، މިއަދަކުން ނޫނެވެ. އިމްޕޯޓްކުރެވޭ ތާރީޚަކީ ކުރިން ހިނގާފައިވާ ކަންކަމުގެ ހެއްކެވެ؛ މިއަދުން ފެށިގެން ކަމަށް ބެލުމުން ކުރިން އޮތް ކޮންމެ ރުހުމެއް އައު އެއްޗެއް ކަމަށް ބަދަލުވެއެވެ.",
      "importFile": "ސީއެސްވީ ފައިލް",
      "importFileHint": "ކޮންމެ ފަރާތަކަށް، ޗެނަލަކަށް އަދި މަޤުޞަދަކަށް އެއް ސަޠުރު.",
      "importSummary": "{rows} ސަޠުރު ކިޔުނު · {imported} އިމްޕޯޓްކުރެވުނު · {errors} ބަލައިނުގަނެވުނު.",
      "importLine": "ސަޠުރު {line}",
      "importCleanTitle": "ކޮންމެ ސަޠުރެއް އިމްޕޯޓްކުރެވިއްޖެ",
      "importCleanDescription": "އެއްވެސް އެއްޗެއް ބަލައިނުގަނެ ދޫކޮށްލާފައެއް ނުވެއެވެ."
    },
    "catalogue": {
      "title": "ރުހުމުގެ ކެޓަލޮގްތައް",
      "description": "މެސެޖެއް ދަތުރުކުރެވޭ ޗެނަލްތަކާއި، ފަރާތަކުން ރުހުން ދެވިދާނެ މަޤުޞަދުތައް.",
      "channels": "ޗެނަލްތައް",
      "purposes": "މަޤުޞަދުތައް",
      "code": "ކޯޑް",
      "name": "ނަން",
      "medium": "ވަޞީލަތް",
      "doubleOptIn": "ދެފަހަރު ޔަޤީންކުރުން",
      "doubleOptInHint": "މި ޗެނަލުން ދޭ ރުހުމެއް، ފަރާތުން ޔަޤީންކުރަންދެން އިންތިޒާރުގައި ފެށެއެވެ.",
      "required": "ބޭނުންވޭ",
      "active": "ހިނގަމުންދާ",
      "activate": "ހިންގާ",
      "deactivate": "ހުއްޓާލާ",
      "yes": "އާނ",
      "no": "ނޫން",
      "showInactive": "ނުހިނގާ ތަކެތި ދައްކާ",
      "addChannel": "ޗެނަލް އިތުރުކުރޭ",
      "channelAdded": "ޗެނަލް އިތުރުކުރެވިއްޖެ",
      "channelCodeNote": "ރުހުމުގެ އެއްވެސް ރެކޯޑަކުން މި ކޯޑަށް އިޝާރާތްކުރާ ފަހުން ކޯޑް ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "addPurpose": "މަޤުޞަދު އިތުރުކުރޭ",
      "purposeAdded": "މަޤުޞަދު އިތުރުކުރެވިއްޖެ",
      "purposeDescription": "ތަފުޞީލު",
      "purposeEssentialNote": "ކޮންމެހެން ބޭނުންވާ މަޤުޞަދެއް ރުހުމަކާ ނުލައި ހުއްދަވަނީ އޭގެ ޤާނޫނީ އަސާސަކީ ރުހުން ނޫން ކަމަށްވާތީއެވެ. ފޮނުވުމެއް ހިނގުމަށްޓަކައި މާކެޓިން މަޤުޞަދެއް ކޮންމެހެން ބޭނުންވާ މަޤުޞަދަކަށް ނުހައްދަވާ.",
      "defaultBasis": "ފެށޭ އަސާސް",
      "essential": "ކޮންމެހެން ބޭނުންވާ",
      "essentialYes": "ކޮންމެހެން ބޭނުންވާ",
      "essentialHint": "ރުހުމަކާ ނުލައި ހުއްދަ — ޤާނޫނީ އަސާސަކީ ރުހުމެއް ނޫން.",
      "validityDays": "ހިނގާ މުއްދަތު (ދުވަސް)",
      "validityHint": "މި ދުވަސްތަކަށްފަހު ދީފައިވާ ރުހުމުގެ މުއްދަތު ހަމަވެއެވެ. ހުސްކޮށް ބެހެއްޓުމުން މުއްދަތު ހަމައެއް ނުވެއެވެ.",
      "codeInUse": "ރުހުމުގެ ރެކޯޑަކުން އެ ކޯޑަށް އިޝާރާތްކުރާތީ ބަދަލެއް ނުކުރެވޭނެއެވެ. އޭގެ ބަދަލުގައި ހުއްޓާލައި އައު އެއްޗެއް އިތުރުކުރައްވާ.",
      "channelsEmptyTitle": "ޗެނަލެއް ނެތް",
      "channelsEmptyDescription": "އީމެއިލް، އެސްއެމްއެސް އަދި ޕޯސްޓަކީ އާންމު ތިނެއް.",
      "purposesEmptyTitle": "މަޤުޞަދެއް ނެތް",
      "purposesEmptyDescription": "މާކެޓިން، ޚިދުމަތުގެ އެންގުންތައް އަދި ޕްރޮފައިލްކުރުމަކީ އާންމު ފެށުމެއް."
    },
    "suppression": {
      "title": "ހުއްޓުވުންތައް",
      "description": "ކޮންމެ މީހަކަށް ނިސްބަތްވި ނަމަވެސް، ގުޅިގެން ނުވާނެ އެޑްރެސްތައް.",
      "addressNote": "ހުއްޓުވުމެއް ބިނާވަނީ އެޑްރެހަށެވެ، ފަރާތަކަށް ނޫނެވެ. ނުފޯރުމަކީ މެއިލްބޮކްސްއަކާ ބެހޭ ޙަޤީޤަތެއް، އަދި އެ މެއިލްބޮކްސް ދެ ފަރާތަކަށް ނުވަތަ އަޅުގަނޑުމެންނަށް ނޭނގޭ ފަރާތަކަށް ނިސްބަތްވެދާނެއެވެ.",
      "add": "ހުއްޓުވުމެއް އިތުރުކުރޭ",
      "added": "ހުއްޓުވުން އިތުރުކުރެވިއްޖެ",
      "addTitle": "އެޑްރެހެއް ހުއްޓުވުން",
      "addDescription": "އެޑްރެސް ރައްކާކުރެވެނީ ދިމާކުރުމަށެވެ އަދި ދައްކަނީ ފޮރުވިފައެވެ.",
      "destination": "މަންޒިލް",
      "destinationHint": "ސީދާ އެޑްރެސް. ދައްކާ ކޮންމެ ތަނެއްގައި ފޮރުވެއެވެ.",
      "channel": "ޗެނަލް",
      "reason": "ސަބަބު",
      "scope": "ދާއިރާ",
      "scopeGlobal": "ހުރިހާ މަޤުޞަދެއް",
      "scopePurpose": "ހަމައެކަނި {purpose}",
      "status": "ޙާލަތު",
      "inForce": "ހިނގަމުންދާ",
      "released": "ދޫކޮށްލެވިފައި",
      "releasedToast": "ހުއްޓުވުން ދޫކޮށްލެވިއްޖެ",
      "note": "ނޯޓް",
      "anyChannel": "ކޮންމެ ޗެނަލެއް",
      "anyReason": "ކޮންމެ ސަބަބެއް",
      "showReleased": "ދޫކޮށްލެވުނު ތަކެތިވެސް",
      "release": "ދޫކޮށްލާ",
      "releaseTitle": "މި ހުއްޓުވުން ދޫކޮށްލުން",
      "releaseDescription": "ރުހުމަށް ބަލައި، އެޑްރެހަށް އަލުން ގުޅެވޭނެއެވެ.",
      "releaseReason": "ކީއްވެގެންތޯ؟",
      "releaseGoverned": "މި ހުއްޓުވުމަކީ އަތުން އިތުރުކުރި އެއްޗެއް ނޫނެވެ، އެހެންކަމުން ދޫކޮށްލުމަށް ޚާއްޞަ ސަބަބުގެ ކޯޑެއް ބޭނުންވެއެވެ.",
      "releaseGovernedNote": "މި ހުއްޓުވުން އައީ ނުފޯރުމަކުން، ޝަކުވާއަކުން ނުވަތަ ދެކޮޅު ހެދުމަކުންނެވެ. ދޫކޮށްލުމަކީ ޚާއްޞަ އިސްތިސްނާއެއް، އަދި ރެކޯޑްގައި ސަބަބުގެ ކޯޑެއް ބޭނުންވެއެވެ.",
      "overrideCode": "ފަހަނައަޅާ ސަބަބު",
      "overrideNote": "ފަހަނައަޅާ ނޯޓް",
      "emptyTitle": "ހުއްޓުވިފައި އެއްވެސް އެއްޗެއް ނެތް",
      "emptyDescription": "ސަބްސްކްރިޕްޝަން ހުއްޓާލުންތައް، ނުފޯރުންތައް އަދި ޝަކުވާތައް އަމިއްލައަށް މިތަނަށް އާދެއެވެ. އަތުންވެސް އިތުރުކުރެވިދާނެއެވެ.",
      "import": "ނުފޯރުންތައް އިމްޕޯޓްކުރޭ",
      "importTitle": "ނުފޯރުމުގެ ފައިލެއް އިމްޕޯޓްކުރުން",
      "importDescription": "ކޮންމެ ސަޠުރަކުން، އެޑްރެހަށް ބިނާވާ ހުއްޓުވުމެއް އުފެދެއެވެ.",
      "importFile": "ސީއެސްވީ ފައިލް",
      "importFileHint": "ކޮންމެ އެޑްރެހަކަށް އެއް ސަޠުރު، އޭގެ ޗެނަލާއި ސަބަބާއެކު.",
      "importSummary": "{rows} ސަޠުރު ކިޔުނު · {imported} ހުއްޓުވުނު · {errors} ބަލައިނުގަނެވުނު.",
      "importLine": "ސަޠުރު {line}"
    },
    "dsr": {
      "boardTitle": "މަޢުލޫމާތުގެ ވެރިންގެ އެދުންތައް",
      "boardDescription": "ޓެނަންޓްގެ ގަޑިން، ބާކީ އޮތް ދުވަހުން ބަހާލެވިފައި.",
      "tenantClockNote": "މުއްދަތުތައް ގުނަނީ ޓެނަންޓްގެ ވިޔަފާރީގެ ތާރީޚުން، ތިޔަ ބްރައުޒަރުގެ ގަޑިން ނޫނެވެ.",
      "emptyTitle": "އެދުމެއް ނެތް",
      "emptyDescription": "ފަރާތަކުން އެ މީހުންގެ މަޢުލޫމާތު، އެ ރަނގަޅުކުރުން، ނުވަތަ ފޮހެލުމަށް އެދޭއިރު އެދުމެއް އުފައްދަވާ.",
      "laneEmpty": "މިތާނގައި އެއްވެސް އެއްޗެއް ނެތް.",
      "anyKind": "ކޮންމެ ބާވަތެއް",
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "create": "އައު އެދުމެއް",
      "created": "އެދުން ރެކޯޑްކުރެވިއްޖެ",
      "createTitle": "މަޢުލޫމާތުގެ ވެރިޔާގެ އެދުމެއް ރެކޯޑްކުރުން",
      "createDescription": "ގަޑި ފެށެނީ އެދުން ލިބުނު ވަގުތުންނެވެ.",
      "clockStartsNote": "ޖަވާބުދިނުމުގެ މުއްދަތު ހިނގަނީ ލިބުނު ވަގުތުން ފެށިގެންނެވެ، ޓައިޕްކުރި ވަގުތުން ނުވަތަ ވަނަވަރު ޔަޤީންކުރި ވަގުތުން ނޫނެވެ.",
      "findParty": "ފަރާތް ހޯދާ",
      "subject": "ފަރާތް",
      "kind": "ބާވަތް",
      "channel": "އައި ގޮތް",
      "receivedAt": "ލިބުނު ތާރީޚު",
      "receivedAtHint": "ހުސްކޮށް ބެހެއްޓުމުން މިއަދު. އިންބޮކްސްގައި މަޑުކޮށްފައި އޮތް ނަމަ ޙަޤީޤީ ތާރީޚު ދެއްވާ.",
      "requesterName": "އެދުނު ފަރާތުގެ ނަން",
      "requesterEmail": "އެދުނު ފަރާތުގެ އީމެއިލް",
      "requesterRelationship": "އެދުނު ފަރާތް",
      "requesterRelationshipHint": "ވަކީލެއް ނުވަތަ ބެލެނިވެރިއަކު އެހެން މީހެއްގެ ފަރާތުން ހުށަހަޅާ ނަމަ ޔަޤީންކުރުމުގެ ބުރަ ތަފާތެވެ. މިއީ ރެކޯޑްކުރެވޭ އެއްޗެއް، ބާރުއަޅާ އެއްޗެއް ނޫނެވެ.",
      "requesterIsSubject": "އަމިއްލައަށް ފަރާތް",
      "requesterIsAgent": "އެ މީހުންގެ ފަރާތުން ވަކީލެއް",
      "requestText": "އެދުނު ކަންތައް",
      "dueOn": "{date} ގައި ހަމަވޭ",
      "daysRemaining": "{days} ދުވަސް ބާކީ",
      "overdueBy": "{days} ދުވަހަށް މުއްދަތު ފަހަނައަޅާފައި",
      "clockPanelTitle": "ގަޑި",
      "receivedOn": "ލިބުނު",
      "responseDays": "މުއްދަތު (ދުވަސް)",
      "dueOnLabel": "ހަމަވާ",
      "extension": "އިތުރުކުރި",
      "effectiveDueOn": "ޙަޤީޤީ ހަމަވާ",
      "remaining": "ބާކީ ދުވަސް",
      "extensionReasonIs": "އިތުރުކުރި ސަބަބު: {reason}",
      "policyIs": "{jurisdiction} އަށް ސިޔާސަތު: {days} ދުވަސް",
      "breached": "މި އެދުމުގެ މުއްދަތު ފަހަނައަޅާފައިވެއެވެ. އެކަން ރެކޯޑްކުރެވިފައިވެއެވެ.",
      "warned": "މި އެދުމުގެ މުއްދަތު ކައިރިވަނީއެވެ.",
      "identityTitle": "ވަނަވަރު",
      "identityVerified": "ވަނަވަރު ޔަޤީންކުރެވިއްޖެ",
      "identityVerifiedOn": "ވަނަވަރު ޔަޤީންކުރެވުނީ {at} ގައެވެ.",
      "identityUnverified": "ވަނަވަރު ޔަޤީންކުރެވިފައެއް ނުވެއެވެ. އެކަން ވަންދެން އެކްސްޕޯޓާއި ފޮހެލުން ދޮގުކުރެވެއެވެ.",
      "clockRunsAnyway": "ވަނަވަރު ބަލަމުންދާއިރުވެސް ގަޑި ހިނގައެވެ — ޖަވާބުދިނުމުގެ މުއްދަތު ފެށެނީ ލިބުނު ވަގުތުންނެވެ.",
      "verifyIdentity": "ވަނަވަރު ޔަޤީންކުރޭ",
      "verifyTitle": "ފަރާތުގެ ވަނަވަރު ޔަޤީންކުރުން",
      "verifyDescription": "މީހަކު ލިޔުމަކާ އަޅާކިޔައި ބެލި ވަނަވަރު ބަޔާންކުރައްވާ.",
      "evidenceIdentifier": "ހެކި",
      "verifyNote": "ނޯޓް",
      "noIdentifiersTitle": "މި ފަރާތުގެ ވަނަވަރެއް ނެތް",
      "noIdentifiersDescription": "ފުރަތަމަ ފަރާތުގައި ވަނަވަރެއް ރެކޯޑްކުރައްވާ — ޔަޤީންކުރުމުގައި ބެލި ވަނަވަރު ބަޔާންކުރެއެވެ.",
      "extend": "މުއްދަތު އިތުރުކުރޭ",
      "extended": "މުއްދަތު އިތުރުކުރެވިއްޖެ",
      "extendTitle": "މުއްދަތު އިތުރުކުރުން",
      "extendDescription": "އިތުރުކުރުމެއް ލިޔެކިޔުމުން ރެކޯޑްކުރެވި، ސިޔާސަތުން ކަނޑައެޅިފައިވާ ޙައްދެއްގައި ބެހެއްޓެއެވެ.",
      "extendDays": "އިތުރު ދުވަސް",
      "extendReason": "ކީއްވެގެންތޯ؟",
      "extensionAllowance": "ސިޔާސަތުން އިތުރު {days} ދުވަހަށް ފުރުޞަތު ދެއެވެ.",
      "extensionLimit": "ސިޔާސަތުން ދެނީ ގިނަވެގެން އިތުރު {days} ދުވަހެވެ.",
      "tasksTitle": "މަސައްކަތްތައް",
      "tasksDescription": "މި ފަރާތުގެ މަޢުލޫމާތު ގެންގުޅޭ ކޮންމެ މޮޑިއުލަކަށް އެއް މަސައްކަތް.",
      "tasksEmptyTitle": "މަސައްކަތެއް ނެތް",
      "tasksEmptyDescription": "އެދުން ރެކޯޑްކުރެވޭއިރު ރަޖިސްޓްރީން މަސައްކަތްތައް އުފެދެއެވެ.",
      "tasksRegenerated": "{count} މަސައްކަތް އިތުރުކުރެވިއްޖެ",
      "regenerateTasks": "ނެތް މަސައްކަތްތައް އިތުރުކުރޭ",
      "notApplicable": "ނުހިނގާ",
      "tasksStillOpen": "މަސައްކަތްތައް އަދިވެސް ހުޅުވިފައި އެބަހުއްޓެވެ. އެ ނިންމަވާ، ނުވަތަ ޚާއްޞަ ސަބަބުގެ ކޯޑަކާއެކު ފުއްދަވާ.",
      "coverageTitle": "ފުރިހަމަކަން",
      "coverageDescription": "ރަޖިސްޓްރީކުރެވިފައިވާ ކޮންމެ ގުޅުމުގެ ބާވަތަކާއި، މި އެދުމުން އެއަށް މަސައްކަތްކުރެވިފައިވޭތޯ.",
      "coverageEmptyTitle": "ރަޖިސްޓްރީކުރެވިފައި އެއްވެސް އެއްޗެއް ނެތް",
      "coverageEmptyDescription": "ފަރާތަކާ ބެހޭ މަޢުލޫމާތު ގެންގުޅޭކަން އެއްވެސް މޮޑިއުލަކުން ބަޔާންކޮށްފައެއް ނުވެއެވެ.",
      "noTask": "މަސައްކަތެއް ނެތް",
      "exportTitle": "އެކްސްޕޯޓް ބަންޑަލް",
      "exportDescription": "ރަޖިސްޓްރީން ބަޔާންކުރާ ހުރިހާ އެއްޗެއް، މެނިފެސްޓް ހޭޝްއަކާއެކު.",
      "exportWithheld": "ބަންޑަލް ބިނާކުރުމާއި ޑައުންލޯޑްކުރުމަކީ އެދުން ކިޔުމާ ވަކި ހުއްދައެކެވެ. ތިޔަ ބޭފުޅާ އެ ހުއްދަ ނުހިއްޕަވައެވެ.",
      "exportNeedsIdentity": "ވަނަވަރު ޔަޤީންކުރެވެންދެން ބަންޑަލް ދޮގުކުރެވެއެވެ — އޮޅުވާލާ މީހަކަށް ދެވޭ އެކްސްޕޯޓަކީ އެދިގެން ކުރެވޭ މަޢުލޫމާތު ބޭރުވުމެކެވެ.",
      "buildBundle": "ބަންޑަލް ބިނާކުރޭ",
      "bundleBuilt": "ބަންޑަލް ބިނާކުރެވިއްޖެ",
      "bundleHash": "މެނިފެސްޓް ހޭޝް: {hash}",
      "bundleSections": "ބަންޑަލްގައިވާ ބައިތައް",
      "bundleRows": "{count} ސަޠުރު",
      "fulfil": "ފުއްދާ",
      "fulfilled": "އެދުން ފުއްދިއްޖެ",
      "fulfilTitle": "މި އެދުން ފުއްދުން",
      "fulfilDescription": "ޖަވާބުދެވިފައިވާ ކަމަށް އެދުން ބަންދުކުރޭ.",
      "fulfilNote": "ނޯޓް",
      "overrideCode": "ފަހަނައަޅާ ސަބަބު",
      "overrideHint": "މަސައްކަތްތައް ހުޅުވިފައި ހުއްޓައި ފުއްދުމަކީ ޚާއްޞަ އިސްތިސްނާއެކެވެ.",
      "refuse": "ދޮގުކުރޭ",
      "refused": "އެދުން ދޮގުކުރެވިއްޖެ",
      "refuseTitle": "މި އެދުން ދޮގުކުރުން",
      "refuseDescription": "ދޮގުކުރުމަކަށް، ފަރާތަށް ބުނެދެވޭނެ ސަބަބުގެ ކޯޑެއް ބޭނުންވެއެވެ.",
      "refuseCode": "ދޮގުކުރުމުގެ ސަބަބު",
      "runClock": "ގަޑި ހިންގާ",
      "clockTitle": "މުއްދަތު ބެލުން ހިންގުން",
      "clockDescription": "ތިޔަ ބޭފުޅާ ޚިޔާރުކުރައްވާ ތާރީޚަކާ ހަމައަށް އިންޒާރުތަކާއި ފަހަނައެޅުންތައް އުފައްދައެވެ. ތާވަލަކީ ކޮންޓްރޯލެއް ނޫނެވެ.",
      "clockOn": "މި ތާރީޚަށް",
      "clockOnHint": "ހުސްކޮށް ބެހެއްޓުމުން ޓެނަންޓްގެ ގަޑިން މިއަދު.",
      "clockResult": "{on} އަށް: {scanned} ބެލެވުނު، {warned} އިންޒާރު، {breached} ފަހަނައެޅި.",
      "due_soon": "ޑޭޓާ ސަބްޖެކްޓްގެ އެދުމެއްގެ ސުންގަޑި ކައިރިވެފައި ވޭ."
    },
    "erasure": {
      "panelTitle": "ފޮހެލުން",
      "panelDescription": "ދާނީ ކޯއްޗެއް، ދެމިހުންނާނީ ކޯއްޗެއް، އަދި އެކަން ބުނާ ޤާނޫނު.",
      "withheld": "ފޮހެލުން ހިންގުމަކީ ވަކި ހުއްދައެކެވެ. ތިޔަ ބޭފުޅާ އެ ހުއްދަ ނުހިއްޕަވައެވެ.",
      "blockedUnverified": "ވަނަވަރު ޔަޤީންކުރެވިފައެއް ނުވެއެވެ. ފޮހެލުން މުޅިން ދޮގުކުރެވެއެވެ — މިކަމަށް ފަހަނައަޅާ ދިއުމުގެ ފުރުޞަތެއް ނެތެވެ.",
      "preview": "ފޮހެލުން ކުރިން ބައްލަވާ",
      "title": "ފޮހެލުމުގެ ކުރީގެ ބެލުން",
      "description": "{name} އަށް މި ފޮހެލުމުން ކުރާނެ ހުރިހާ ކަމެއް. ޔަޤީންކުރެއްވުމަށްދާނދެން އެއްވެސް އެއްޗެއް ނުލިޔެވެއެވެ.",
      "identityGate": "ވަނަވަރު ޔަޤީންކުރެވިފައި ނުވާތީ މި ފޮހެލުން ނުހިންގޭނެއެވެ. ފަހަނައަޅާ ދިއުމުގެ ފުރުޞަތެއް ނެތެވެ — ޓެނަންޓް އެޑްމިނަކަށްވެސް، ސަބަބުގެ ކޯޑަކުންވެސް.",
      "uncovered": "މި އެދުން ރެކޯޑްކުރި ފަހުން މި މޮޑިއުލްތައް ރަޖިސްޓްރީވެ، އަދި މަސައްކަތެއް ނެތެވެ: {types}. ފޮހެލެއްވުމުގެ ކުރިން ނެތް މަސައްކަތްތައް އިތުރުކުރައްވާ.",
      "willErase": "{columns} ކޮލަމް ފޮހެވޭނެ · {records} ރެކޯޑް",
      "willRetain": "{columns} ކޮލަމް ދެމިހުންނާނެ · {records} ރެކޯޑް",
      "unruledCount": "ޤަވާޢިދެއް ނެތް {count} ކޮލަމް",
      "eraseHeading": "ފޮހެވޭނެ",
      "eraseNote": "ހުސް އަގަކުން، ނުވަތަ ކޮލަމް ތަފާތުވާން ޖެހޭ ތަނުގައި ދާއިމީ ޓޯކަނަކުން ބަދަލުކުރެވެއެވެ.",
      "noneToErase": "ފޮހެލާނެ އެއްޗެއް ނެތް.",
      "retainHeading": "ދެމިހުންނާނެ",
      "retainNote": "ޤާނޫނަކުން، އެއްބަސްވުމަކުން ނުވަތަ ހިނގަމުންދާ ދެބަސްވުމަކުން ބޭނުންވާތީ ބެހެއްޓެއެވެ. ކޮންމެ އެއްޗެއްގައި އޭގެ ސަބަބު ބަޔާންކުރެއެވެ.",
      "noneRetained": "ދެމިހުންނާނެ އެއްޗެއް ނެތް.",
      "records": "{count} ރެކޯޑް",
      "retainYears": "{years} އަހަރު",
      "noStatuteCited": "ޤާނޫނެއް ބަޔާންކޮށްފައެއް ނުވޭ — މި ޤަވާޢިދު އަލުން ބަލަން ޖެހޭ.",
      "unruledField": "މި ކޮލަމް ފޫބައްދާ ބެހެއްޓުމުގެ ޤަވާޢިދެއް ނެތެވެ. ފޮހެވި، ރިޕޯޓްކުރެވޭނެއެވެ.",
      "attachmentNote": "ރައްކާކުރެވިފައިވާ {count} ފައިލެއް، ޓްރާންޒެކްޝަން ފުރިހަމަވުމަށްފަހު ފޮހެލުމަށް ކިޔޫކުރެވޭނެއެވެ. ސްޓޯރޭޖުން ފޮހެލުމެއް އަނބުރައެއް ނުގެނެވޭނެތީ، އެކަން ޓްރާންޒެކްޝަނުގެ ތެރޭގައި ނުކުރެއެވެ.",
      "confirmLabel": "ޔަޤީންކުރެއްވުމަށް {name} ޓައިޕްކުރައްވާ",
      "confirmHint": "އެއް ކްލިކުން ފޯރޭ އަނބުރާ ނުގެނެވޭ ޢަމަލަކީ މީހަކު ނޭނގުމުގައި ކޮށްފާނެ ޢަމަލެކެވެ.",
      "note": "ނޯޓް",
      "execute": "ފޮހެލާ",
      "done": "ފޮހެލުން ފުރިހަމަވެއްޖެ",
      "unverifiedAbsolute": "ވަނަވަރު ޔަޤީންކުރެވިފައި ނުވާތީ މި ފޮހެލުން ދޮގުކުރެވިއްޖެއެވެ. މި ޤަވާޢިދު ފަހަނައަޅާ ދިއުމުގެ ފުރުޞަތެއް ނެތެވެ.",
      "receipt": "{records} ރެކޯޑްގައި، {erased} ކޮލަމް ފޮހެވި، {pseudonymised} ނަން ބަދަލުކުރެވި، {retained} ދެމިހުއްޓެވެ.",
      "attachmentsQueued": "ރައްކާކުރެވިފައިވާ {count} ފައިލެއް ފޮހެލުމަށް ކިޔޫކުރެވިއްޖެއެވެ. ފުރިހަމަވުމަށްފަހު، އަލުން މަސައްކަތްކުރާ ގޮތަށް ފޮހެލެވެއެވެ.",
      "unruledErased": "މި ކޮލަމްތަކުގައި ބެހެއްޓުމުގެ ޤަވާޢިދެއް ނެތި ފޮހެވިއްޖެއެވެ: {columns}. މިއަށް ޤަވާޢިދު އިތުރުކުރައްވާ."
    },
    "retention": {
      "title": "ބެހެއްޓުމުގެ ކެޓަލޮގް",
      "description": "ފޮހެލުމެއް ހިނގަނީ މި ތާވަލުންނެވެ. އެހެން އެއްވެސް ތަނެއްގައި ކޮލަމް ލިސްޓެއް ނެތެވެ.",
      "column": "ކޮލަމް",
      "treatment": "ޢަމަލުކުރާ ގޮތް",
      "basis": "ޤާނޫނީ އަސާސް",
      "statute": "ޤާނޫނު ނުވަތަ އެއްބަސްވުން",
      "noStatute": "އެއްވެސް އެއްޗެއް ބަޔާންކޮށްފައެއް ނުވޭ — ބެހެއްޓުމުގެ ޤަވާޢިދެއްގައި ސަބަބު ބަޔާންކުރަން ޖެހޭ",
      "retainYears": "އަހަރު",
      "anchor": "ގުނަން ފަށާ",
      "source": "މަޞްދަރު",
      "source_system": "ނިޒާމު",
      "source_tenant": "ޓެނަންޓް",
      "orphaned": "ވެރިޔަކު ނެތް",
      "anyLinkType": "ކޮންމެ ގުޅުމުގެ ބާވަތެއް",
      "unruledOnly": "ހަމައެކަނި ޤަވާޢިދެއް ނެތް ކޮލަމްތައް",
      "emptyTitle": "ބެހެއްޓުމުގެ ޤަވާޢިދެއް ނެތް",
      "emptyDescription": "ކޮންމެ މޮޑިއުލަކުން ބަޔާންކުރާ ޤަވާޢިދުތައް ލިޔުމަށް އެއްގޮތްކުރުމެއް ހިންގަވާ.",
      "zeroRuleTitle": "އަމިއްލަ މަޢުލޫމާތެއް ނެތްކަމަށް ބުނާ ގުޅުމުގެ ބާވަތްތައް",
      "zeroRuleDescription": "މި މޮޑިއުލްތަކުން ބެހެއްޓުމުގެ ސުމެއް ޤަވާޢިދު ބަޔާންކުރެއެވެ. އެއީ ޞައްޙަ ބަޔާނެއް — “އަޅުގަނޑުމެންގެ އަތުގައި އަމިއްލަ މަޢުލޫމާތެއް ނެތެވެ” — އަދި ބަޔާންކުރަން ހަނދާން ނެތުނު މޮޑިއުލެއްވެސް ހަމަ މިހެން ފެންނާނެއެވެ. ކޮންމެ އެއްޗެއް ބައްލަވާ.",
      "reconcile": "އެއްގޮތްކުރޭ",
      "reconciled": "ކެޓަލޮގް އެއްގޮތްކުރެވިއްޖެ",
      "reconcileTitle": "ރަޖިސްޓްރީއާ އެއްގޮތްކުރުން",
      "reconcileDescription": "މޮޑިއުލަކުން ބަޔާންކުރާ، މިތާނގައި ނެތް ކޮންމެ ޤަވާޢިދެއް ލިޔެއެވެ.",
      "reconcileExplains": "ނެތް ޤަވާޢިދުތައް ލިޔެވެއެވެ. ތިޔަ ބޭފުޅާ ހަރުކަށިކުރެއްވި ޤަވާޢިދެއް ދޫކޮށްލެވެއެވެ. މޮޑިއުލްގެ އަސްލަށްވުރެ ދޫ ޤަވާޢިދެއް ދޫކޮށްލައި، ރިޕޯޓްކުރެވެއެވެ — ތިޔަ ބޭފުޅާގެ ޤަޞްދީ ކޮންފިގަރޭޝަން ހިމޭނުން ހަރުކަށިކުރުމަކީ އޭގެ އަމިއްލަ ނުބައެކެވެ. އެއްވެސް އެއްޗެއް ފޮހެއެއް ނުލެވެއެވެ.",
      "reconcileSummary": "{inserted} ޤަވާޢިދު ލިޔެވިއްޖެ؛ {unchanged} ކުރިންވެސް ރަނގަޅު.",
      "looserTitle": "މޮޑިއުލްގެ ބަޔާނަށްވުރެ ދޫ — މި ބައްލަވާ:",
      "orphanedTitle": "މި ގުޅުމުގެ ބާވަތްތަކުގެ ވެރި މޮޑިއުލެއް މިހާރު ނެތް:",
      "unruledTitle": "ބަޔާންކުރެވިފައިވާ، ޤަވާޢިދެއް ނެތް ކޮލަމްތައް:",
      "reconcileCleanTitle": "ރިޕޯޓްކުރާނެ އެއްޗެއް ނެތް",
      "reconcileCleanDescription": "ބަޔާންކުރެވިފައިވާ ކޮންމެ ކޮލަމަކަށް ޤަވާޢިދެއް އެބައޮތް، އަދި އެއިން އެއްވެސް އެއްޗެއް މޮޑިއުލްގެ އަސްލަށްވުރެ ދޫވެފައެއް ނުވެއެވެ."
    },
    "loyalty": {
      "programsTitle": "ވަފާތެރިކަމުގެ ޕްރޮގްރާމްތައް",
      "programsDescription": "ޕޮއިންޓް ހޯދާ ޤަވާޢިދުތަކާއި ދަރަޖަތައް. ޕޮއިންޓަކީ ފައިސާއެއް ނޫން، ޢަދަދެކެވެ.",
      "noLedgerNote": "ޕޮއިންޓުން ޢާންމު ލެޖަރަށް އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެއެވެ. ޕޮއިންޓްގެ ދަރަންޏަކަށް، ބަދަލުކުރެވޭ އަގަކާއި ބޭނުންނުކުރެވި ދާނެ މިންވަރެއް ބޭނުންވެއެވެ، އަދި ޕޮއިންޓް ޚަރަދުކުރެވެންދެން އެ ދޭތި ނުހުރެއެވެ.",
      "programsEmptyTitle": "ޕްރޮގްރާމެއް ނެތް",
      "programsEmptyDescription": "ޕްރޮގްރާމަކުން ޕޮއިންޓް ހޯދާ ރޭޓާއި، އެ ހިނގާ ފައިސާ ކަނޑައަޅައެވެ.",
      "createProgram": "އައު ޕްރޮގްރާމް",
      "createProgramDescription": "ފައިސާ ފަހުން ބަދަލެއް ނުކުރެވޭނެ — ކޮންމެ ޕޮއިންޓް ހޯދުމެއްގައި، ހޯދި ފައިސާ ރެކޯޑްކުރެވެއެވެ.",
      "programCreated": "ޕްރޮގްރާމް އުފެއްދިއްޖެ",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން",
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "code": "ކޯޑް",
      "name": "ނަން",
      "currency": "ފައިސާ",
      "currencyHint": "ތިން އަކުރުގެ އައިއެސްއޯ ކޯޑް.",
      "pointsPerUnit": "ޔުނިޓަކަށް ޕޮއިންޓް",
      "pointsPerUnitHint": "ޤާބިލު ޚަރަދުގެ އެއް ޔުނިޓަކަށް ލިބޭ ޕޮއިންޓް.",
      "rounding": "ބުރުކުރުން",
      "rounding_down": "ތިރިއަށް",
      "rounding_nearest": "އެންމެ ކައިރިއަށް",
      "tiers": "ދަރަޖަތައް",
      "status": "ޙާލަތު",
      "status_draft": "ދެލިކޮޕީ",
      "status_active": "ހިނގަމުންދާ",
      "status_closed": "ބަންދުކުރެވިފައި",
      "rateIs": "{currency} އަކަށް {rate} ޕޮއިންޓް",
      "viewMembers": "މެންބަރުން",
      "tiersTitle": "ދަރަޖަތައް",
      "tiersDescription": "ދަރަޖައަކުން ޕޮއިންޓް ހޯދާ ރޭޓް އިތުރުކުރެއެވެ. ކޮންމެ ދަރަޖައަކަށް މަދުވެގެން އެއް ޙައްދު ބޭނުންވެއެވެ.",
      "tiersEmptyTitle": "ދަރަޖައެއް ނެތް",
      "tiersEmptyDescription": "ދަރަޖައެއް ނެތް ޕްރޮގްރާމަކުން ހުރިހާ އެންމެންނަށް އަސާސީ ރޭޓުން ޕޮއިންޓް ލިބެއެވެ.",
      "addTier": "ދަރަޖަ އިތުރުކުރޭ",
      "addTierDescription": "ދަރަޖައަކަށް ޕޮއިންޓްގެ ޙައްދެއް، ޚަރަދުގެ ޙައްދެއް، ނުވަތަ ދޭތިވެސް ބޭނުންވެއެވެ.",
      "tierAdded": "ދަރަޖަ އިތުރުކުރެވިއްޖެ",
      "sortOrder": "ތަރުތީބު",
      "minPoints": "އެންމެ މަދު ޕޮއިންޓް",
      "minPointsIs": "{points} ޕޮއިންޓް",
      "minSpend": "އެންމެ މަދު ޚަރަދު",
      "earnMultiplier": "ޕޮއިންޓް ގުނަކުރާ މިންވަރު",
      "earnMultiplierHint": "1 އަކުން އަސާސީ ރޭޓް؛ 1.5 އަކުން އޭގެ ދެބައިކުޅަ އެއްބައި އިތުރަށް.",
      "thresholdRequired": "ދަރަޖައަކަށް މަދުވެގެން އެއް ޙައްދު ބޭނުންވެއެވެ — ޕޮއިންޓް، ޚަރަދު، ނުވަތަ ދޭތި. އެ ނެތި، އެއަކަށް އެއްވެސް މީހަކަށް ނުފޯރޭނެއެވެ.",
      "membersTitle": "ވަފާތެރިކަމުގެ މެންބަރުން",
      "membersDescription": "މެންބަރުކަން ނިސްބަތްވަނީ ފަރާތަކަށެވެ، އެހެންކަމުން އެއް މީހެއްގެ ހުރުންތަކާއި، އޯޑަރުތަކާއި، ޓިކެޓްތަކުން އެއް ބެލެންސަކަށް ޕޮއިންޓް ލިބެއެވެ.",
      "membersEmptyTitle": "މެންބަރެއް ނެތް",
      "membersEmptyDescription": "ޕޮއިންޓް ލިބެން ފެށުމަށް ފަރާތެއް ޕްރޮގްރާމަކަށް ވައްދާ.",
      "memberSearchPlaceholder": "މެންބަރު ނަންބަރު ނުވަތަ ނަން",
      "anyProgram": "ކޮންމެ ޕްރޮގްރާމެއް",
      "anyMemberStatus": "ކޮންމެ ޙާލަތެއް",
      "membershipNo": "މެންބަރުކަން",
      "membershipNoHint": "ހުސްކޮށް ބެހެއްޓުމުން ނަންބަރެއް ދޫކުރެވެއެވެ. އަގެއް ދޭނީ ކުރިން އޮތް ޕްރޮގްރާމެއްގެ ނަންބަރުތައް އިމްޕޯޓްކުރާއިރު އެކަންޏެވެ.",
      "program": "ޕްރޮގްރާމް",
      "party": "ފަރާތް",
      "findParty": "ފަރާތް ހޯދާ",
      "tier": "ދަރަޖަ",
      "pointsBalance": "ޕޮއިންޓް ބެލެންސް",
      "pointsLifetime": "ޢުމުރު ދުވަހުގެ ޕޮއިންޓް",
      "spendRolling12": "ފާއިތުވި 12 މަހުގެ ޚަރަދު",
      "memberStatus_active": "ހިނގަމުންދާ",
      "memberStatus_suspended": "ސަސްޕެންޑްކުރެވިފައި",
      "memberStatus_closed": "ބަންދުކުރެވިފައި",
      "enrol": "ވައްދާ",
      "enrolled": "މެންބަރު ވެއްދިއްޖެ",
      "enrolTitle": "ފަރާތެއް ވެއްދުން",
      "enrolDescription": "މެންބަރުކަން ނިސްބަތްވަނީ ވަނަވަރަށެވެ، ކަސްޓަމަރު ރެކޯޑަކަށް ނޫނެވެ.",
      "enrolledOn": "ވެއްދީ {date}",
      "tierReviewedOn": "ދަރަޖަ ބެލީ {date}",
      "openParty": "ފަރާތް ހުޅުވާ",
      "reviewTier": "ދަރަޖަ ބައްލަވާ",
      "tierChanged": "ދަރަޖަ {from} އިން {to} އަށް ބަދަލުވެއްޖެ — {reason}",
      "tierUnchanged": "ބެލެވިއްޖެ؛ ދަރަޖަ ބަދަލެއް ނުވި — {reason}",
      "ledgerTitle": "ޕޮއިންޓް ލެޖަރ",
      "ledgerDescription": "އިތުރުކުރުން އެކަނި. މަތީގައިވާ ބެލެންސަކީ ސާވަރުން މި ލެޖަރުން ނެރޭ އަދަދެކެވެ، މި ޞަފުޙާގެ ޖުމުލައެއް ނޫނެވެ.",
      "ledgerEmptyTitle": "އަދި އެއްވެސް ޕޮއިންޓެއް ނުލިބޭ",
      "ledgerEmptyDescription": "ޕޮއިންޓް އަންނަނީ އިންވޮއިސްތަކުން، އޯޑަރުތަކުން އަދި ފޯލިއޯތަކުން، ނުވަތަ މިތަނުން އަތުން އިތުރުކުރެވެއެވެ.",
      "businessOn": "ތާރީޚު",
      "source": "މަޞްދަރު",
      "accrualSource_ar_invoice": "ވިއްކުމުގެ އިންވޮއިސް",
      "accrualSource_sales_order": "ވިއްކުމުގެ އޯޑަރު",
      "accrualSource_pos_sale": "ޕީއޯއެސް ވިއްކުން",
      "accrualSource_pms_folio": "ފޯލިއޯ",
      "accrualSource_manual": "އަތުން އިތުރުކުރި",
      "eligibleAmount": "ޤާބިލު އަދަދު",
      "eligibleAmountHint": "ޕޮއިންޓް ހިސާބުކުރެވެނީ މި އަދަދުންނެވެ. ޤާބިލުކަން ނިންމަނީ ލިޔުން އުފެއްދި މޮޑިއުލުން، ދުވަހަކުވެސް މިތަނުން ނޫނެވެ.",
      "rateApplied": "ރޭޓް",
      "multiplierApplied": "ގުނަކުރި މިންވަރު",
      "points": "ޕޮއިންޓް",
      "addAccrual": "ޕޮއިންޓް އިތުރުކުރޭ",
      "addAccrualDescription": "ހެޔޮއެދުމުގެ އިނާމެއް ނުވަތަ ރަނގަޅުކުރުމެއް. އާންމު މަގަކީ ޕޮއިންޓް ހޯދި ލިޔުމެވެ.",
      "accrualAdded": "ޕޮއިންޓް އިތުރުކުރެވިއްޖެ",
      "sourceKey": "ރިފަރެންސް",
      "sourceKeyHint": "ކޮންމެ މެންބަރަކަށް ތަފާތު. ތަކުރާރުވާ ރިފަރެންސަކުން ދެވަނަ އެއްޗެއް އިތުރުކުރުމުގެ ބަދަލުގައި، ކުރީގެ ރެކޯޑް އަނބުރާ ދެއެވެ.",
      "note": "ނޯޓް"
    },
    "queue": {
      "dsr_overdue": "ސުންގަޑި ކައިރިވެފައިވާ ނުވަތަ ހަމަވެފައިވާ ޑޭޓާ ސަބްޖެކްޓްގެ އެދުންތައް"
    }
  },
  "treasury": {
    "accountType": {
      "collection": "ފައިސާ ބަލައިގަތުން",
      "deposit": "މުއްދަތު ޑިޕޮސިޓް",
      "disbursement": "ފައިސާ ދޫކުރުން",
      "escrow": "އެސްކްރޯ",
      "operating": "ޢާންމު ހިންގުން",
      "payroll": "މުސާރަ",
      "pool_header": "ޕޫލްގެ މައި އެކައުންޓް"
    },
    "accuracy": {
      "absoluteError": "ސީދާ ކުށުގެ ނިސްބަތް",
      "actualClosing": "ޙަޤީޤީ",
      "actualFrom": "ޙަޤީޤީ އަދަދު ނެގުނު",
      "bandsCaption": "މުއްދަތުގެ ބޭންޑުން މެދު ސީދާނުވުމުގެ ނިސްބަތް",
      "bandsTitle": "މުއްދަތުން",
      "breachedBuckets": "{count} ބައި އެންމެ ދަށް ބާކީއަށްވުރެ ދަށް",
      "description": "ޝާއިޢުކުރެވުނު ލަފާކުރުންތައް، ފަހުން ޝާއިޢުކުރެވުނު ޕޮޒިޝަންތަކާ ކިހާ ގާތްވިތޯ.",
      "empty": "އަދި އެއްވެސް އެއްޗެއް މިނާފައެއް ނުވެއެވެ.",
      "error": "ކުށް",
      "forecastClosing": "ލަފާކުރި",
      "horizon": "މުއްދަތު",
      "horizonDays": "ކުރިއަށް ދުވަސް",
      "loadFailed": "އެ ރިޕޯޓް ނުލޯޑްވި",
      "mape": "އެމްއޭޕީއީ",
      "mapeNote": "{measured} މިނުމެއް ގުނާފައި؛ ޙަޤީޤީ އަދަދު ސުމެއް ކަމަށްވާތީ {undefinedCount} ނުމިނުނެވެ. ސުމަކާ އަޅާކިޔައި ނިސްބަތެއް ނުނެރެވޭނެއެވެ.",
      "meanError": "މެދު ކުށް",
      "measuredOn": "މިނުނު ތާރީޚު",
      "measurements": "މިނުންތައް",
      "measurementsCaption": "ކޮންމެ ބައެއް، އޭގެ ފަހުން އައި ޕޮޒިޝަނާ އަޅާކިޔައި",
      "measurementsTitle": "މިނުންތައް",
      "notMeasurable": "ނުމިނޭ",
      "openRun": "ރަން ހުޅުވާ",
      "overall": "ޖުމްލަ",
      "publishedPosition": "ޝާއިޢުކުރެވުނު ޕޮޒިޝަން",
      "title": "ލަފާކުރުމުގެ ސީދާކަން"
    },
    "actions": {
      "confirm": "ކަށަވަރުކުރޭ"
    },
    "approvals": {
      "approveDescription": "ފާސްކުރުމުން ޚަރަދު ފޮތުގައި ޖެހި، ޓެކްސް އިންވޮއިސްއެއް އޮތްނަމަ އަނބުރާ ލިބޭ ޓެކްސް ދޫކުރެވެއެވެ.",
      "approveTitle": "ޚަރަދު ފާސްކުރުން",
      "caption": "ނިންމުމަކަށް އިންތިޒާރުކުރާ ޚަރަދުތައް",
      "decided": "ޚަރަދާމެދު ގޮތެއް ނިންމިއްޖެ.",
      "description": "ނިންމުމަކަށް އިންތިޒާރުކުރާ ޚަރަދުތައް — އަދި އަނބުރާ ލިބޭ ޓެކްސް ދޫކުރެވޭ ހަމައެކަނި ތަން.",
      "emptyDescription": "މި ވޮލެޓުން ނިންމުމަކަށް އިންތިޒާރުކުރާ ޚަރަދެއް ނެތެވެ.",
      "emptyTitle": "އިންތިޒާރުގައި އެއްޗެއް ނެތް",
      "loadFailed": "އެ ޚަރަދުތައް ނުލޯޑްވި",
      "noInvoiceNote": "މި ޚަރަދުގައި ޓެކްސް އިންވޮއިސްއެއް ނެތުމުން، މިއިން ޓެކްސްއެއް އަނބުރާ ނުލިބޭނެއެވެ.",
      "openWallet": "ވޮލެޓް ހުޅުވާ",
      "receiptOnly": "ހަމައެކަނި ރަސީދު",
      "recoverableHint": "ރަސީދުގައި ދައްކަނީ {tax} ގެ ޓެކްސް. އެއަށްވުރެ ގިނައިން ސާވަރުން ޤަބޫލެއް ނުކުރާނެއެވެ.",
      "rejectDescription": "ރައްދުކުރުމުން ފައިސާ ބަލަހައްޓާ ފަރާތުން އަނބުރާ ހޯދޭނެއެވެ، އެހެންވެ ސަބަބެއް ބޭނުންވެއެވެ.",
      "rejectNote": "މިއިން އެ އަދަދު ބަލަހައްޓާ ފަރާތުން އަނބުރާ ހޯދޭނެއެވެ.",
      "rejectTitle": "ޚަރަދު ރައްދުކުރުން",
      "releaseTax": "އަނބުރާ ލިބޭ ޓެކްސް ދޫކުރޭ",
      "tableTitle": "ފާސްކުރުމަށް",
      "taxInvoice": "ޓެކްސް އިންވޮއިސް",
      "title": "ވޮލެޓް ފާސްކުރުން",
      "walletLink": "ކޮންމެ ޚަރަދެއް ނިސްބަތްވަނީ ވޮލެޓަކަށެވެ."
    },
    "basis": {
      "available": "ބޭނުންކުރެވޭ",
      "bankBooked": "ބޭންކުން ބުކްކުރި",
      "ledger": "ލެޖަރ",
      "valueDated": "ވެލިއު ތާރީޚް"
    },
    "beneficiaries": {
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "caption": "ފައިސާ ދާ ފަރާތްތަކާއި އެ ފަރާތްތައް ކަށަވަރުކުރެވިފައިވާ ޙާލަތު",
      "coolingUntil": "{at} އާ ހަމައަށް",
      "description": "މި ކުންފުނިން ފައިސާ ފޮނުވަން އެދެވިދާނެ ފަރާތްތަކާއި، ކޮންމެ ފަރާތެއް ކަށަވަރުކުރެވިފައިވާ މިންވަރު.",
      "detailWithheld": "ދޫކޮށްފައެއް ނުވޭ",
      "emptyDescription": "ފުރަތަމަ ފައިސާ ދާ ފަރާތަށް ހުށަހެޅުމެއް ފޮނުއްވާ. އެ ފާސްކުރާނީ އެހެން ފަރާތަކުންނެވެ، އަދި ފައިސާ ފޮނުވުމުގެ ކުރިން މަޑުކުރުމުގެ މުއްދަތެއް ހަމަވާން ޖެހޭނެއެވެ.",
      "emptyTitle": "އަދި ފައިސާ ދާ ފަރާތެއް ނެތް",
      "loadFailed": "އެ ފައިސާ ދާ ފަރާތްތައް ނުލޯޑްވި",
      "openChanges": "ބަދަލުކުރުމަށް އެދޭ ހުށަހެޅުންތައް",
      "request": "އައު ފައިސާ ދާ ފަރާތެއް",
      "requestConfirm": "ހުށަހެޅުން ފޮނުވާ",
      "requestDescription": "މިއިން އުފެދޭނީ ބަދަލުކުރުމަށް އެދޭ ހުށަހެޅުމެކެވެ. ފައިސާ ދާ ފަރާތް އުފެދޭނީ ފާސްކުރުމުންނެވެ — އެކަކަށް އެކަނި ފައިސާ ދާ ފަރާތެއް އިތުރެއް ނުކުރެވޭނެއެވެ.",
      "requestNote": "މި ހުށަހެޅުން ފާސްވެ، މަޑުކުރުމުގެ މުއްދަތު ހަމަވަންދެން މި ފަރާތަށް ފައިސާއެއް ނުފޮނުވޭނެއެވެ.",
      "requestTitle": "އައު ފައިސާ ދާ ފަރާތަކަށް އެދުން",
      "requested": "ބަދަލުކުރުމަށް އެދޭ ހުށަހެޅުން ފޮނުވިއްޖެ.",
      "searchHint": "ނަން، ކޯޑް އަދި ބޭންކާ ދިމާވެއެވެ.",
      "tableTitle": "ރަޖިސްޓަރީ",
      "title": "ފައިސާ ދާ ފަރާތްތައް"
    },
    "beneficiary": {
      "blockAction": "ހުއްޓުވާ",
      "blockDescription": "ހުއްޓުވާފައިވާ ފަރާތަކަށް އެއްވެސް ގޮތަކުން ފައިސާއެއް ނުފޮނުވޭނެއެވެ، އަދި އެ ދެކޮޅުހެދުން ފަހަނައެއް ނޭޅޭނެއެވެ.",
      "blockTitle": "ހުއްޓުވުން ނުވަތަ ހުއްޓުވުން ނެގުން",
      "blockUpdated": "ފައިސާ ދާ ފަރާތް އަޕްޑޭޓްކުރެވިއްޖެ.",
      "blockedBanner": "މި ފައިސާ ދާ ފަރާތް ހުއްޓުވާފައިވެއެވެ. މިއަށް އެއްވެސް އިރުޝާދެއް ހުށަހެއް ނޭޅޭނެއެވެ، އަދި ފަހަނައަޅާ ދިޔުމުގެ ގޮތެއްވެސް ނެތެވެ.",
      "changeAction": "ބޭންކްގެ ތަފްޞީލު ބަދަލުކުރޭ",
      "changeConfirm": "ބަދަލުކުރުމަށް ހުށަހަޅާ",
      "changeDescription": "ފައިސާ ދާ ތަން ބަދަލުކުރުމަކީ އެންމެ ދުވަސްވީ ފައިސާގެ މަކަރެވެ، އެހެންކަމުން ބަދަލަކީ ހުށަހެޅުމެކެވެ.",
      "changeNote": "މި ފާސްކުރާނީ އެހެން ފަރާތަކުންނެވެ، އަދި ފައިސާއެއް ފޮނުވުމުގެ ކުރިން މަޑުކުރުމުގެ މުއްދަތެއް ހަމަވާން ޖެހޭނެއެވެ.",
      "changeRaised": "ބަދަލުކުރުމަށް އެދޭ ހުށަހެޅުން ފޮނުވިއްޖެ.",
      "changeTitle": "ބަދަލެއް ގެނައުމަށް އެދުން",
      "coolingOffBanner": "{at} އާ ހަމައަށް މި ފަރާތް މަޑުކުރުމުގެ މުއްދަތުގައެވެ. އޭގެ ކުރިން ފައިސާއެއް ނުފޮނުވޭނެއެވެ.",
      "description": "ފައިސާ ލިބޭ ފަރާތާއި، އޭގެ ބޭންކްގެ ތަފްޞީލާއި، އެ ކަށަވަރުކުރުމަށް މިހާތަނަށް ކުރެވުނު ހުރިހާ ކަމެއް.",
      "detailsTitle": "ތަފްޞީލު",
      "independentSourceHint": "ނަންބަރު ލިބުނު ތަން — ކޮންޓްރެކްޓެއް، ކުރީގެ ސްޓޭޓްމަންޓެއް، ނުވަތަ އެ ފަރާތުގެ ޢާންމުކޮށްފައިވާ ނަންބަރެއް. ބަދަލުކުރުމަށް އެދޭ ހުށަހެޅުމުން ނަގައިގެން ނުވާނެއެވެ.",
      "loadFailed": "އެ ފައިސާ ދާ ފަރާތް ނުލޯޑްވި",
      "pennyAmount": "ފޮނުވާ ކުޑަ އަދަދު",
      "pennyAmountHint": "އެ ފަރާތުން އަނބުރާ ބުނަންޖެހޭ ކުޑަ އަދަދެއް.",
      "pennyReference": "އަނބުރާ ބުނި ރެފަރެންސް",
      "revealAction": "އެކައުންޓް ނަންބަރު ދައްކާ",
      "revealAudited": "މި ދެއްކުން އޮޑިޓް ލޮގުގައި ރެކޯޑްކުރެވިއްޖެއެވެ.",
      "revealConfirm": "ދައްކާ",
      "revealDescription": "ނަންބަރު އެއްފަހަރު ޑިކްރިޕްޓްކޮށް، އެއްފަހަރު ދައްކާ، ރައްކާނުކުރެއެވެ.",
      "revealReasonHint": "ބޭނުންވި ސަބަބު. ސަބަބު ތިޔަ ބޭފުޅާގެ ނަމާއެކު ރައްކާކުރެވެއެވެ.",
      "revealTitle": "އެކައުންޓް ނަންބަރު ދެއްކުން",
      "title": "ފައިސާ ދާ ފަރާތް",
      "unblockAction": "ހުއްޓުވުން ނަގާ",
      "verificationRecorded": "ކަށަވަރުކުރުން ރެކޯޑްކުރެވިއްޖެ.",
      "verificationsCaption": "ކަށަވަރުކުރުމަށް ކުރެވުނު މަސައްކަތްތައް",
      "verificationsDescription": "ފަހު ފަހަރު އެކަނި ނޫން، ކުރެވުނު ކޮންމެ މަސައްކަތެއް. ތަޙުޤީޤުކުރާ ފަރާތުން ބަލަން ބޭނުންވަނީ ދެވަނަ ފަހަރެވެ.",
      "verificationsEmpty": "މި ފަރާތް ދުވަހަކުވެސް ކަށަވަރުކޮށްފައެއް ނުވެއެވެ.",
      "verificationsTitle": "ކަށަވަރުކުރުމުގެ ތާރީޚު",
      "verifyAction": "ކަށަވަރުކުރޭ",
      "verifyComplete": "ނަތީޖާ ރެކޯޑްކުރޭ",
      "verifyDescription": "އެ އެކައުންޓަކީ ތިޔަ ހީކުރާ ފަރާތުގެ އެކައުންޓްކަން ސާބިތުކުރައްވާ.",
      "verifyStart": "ފަށާ",
      "verifyTitle": "ފައިސާ ދާ ފަރާތް ކަށަވަރުކުރުން",
      "withheldNote": "ހަމައެކަނި ކިޔޭ ހުއްދަ އޮތް ފަރާތަކަށް ބޭންކްގެ ތަފްޞީލެއް ނުދައްކާނެއެވެ. ފޮރުވިފައިވާ ނަންބަރެއްގައިވެސް ޙަޤީޤީ ހަތަރު ޢަދަދު ހުރެއެވެ."
    },
    "blockReasons": {
      "dispute": "ދެބަސްވުމެއް",
      "dormant": "ބޭނުންނުކުރާތާ ގިނަދުވަސް",
      "fraud_suspicion": "މަކަރުހެދުމުގެ ޝައްކު",
      "other": "އެހެނިހެން",
      "sanctions_hit": "ސެންކްޝަން ލިސްޓުގައި"
    },
    "certificate": {
      "actionsTitle": "ޢަމަލުތައް",
      "addUnrecorded": "އިތުރު: ފޮތުގައި ނުޖަހާ ބައިތައް",
      "authorise": "ހުއްދަދޭ",
      "backToSession": "ސެޝަނަށް އެނބުރި",
      "balancePerBank": "ބޭންކް ސްޓޭޓްމަންޓްގެ ބާކީ",
      "balancePerLedger": "ލެޖަރގެ ބާކީ",
      "certified": "ސެޓްފިކެޓް {no} ދޫކުރެވިއްޖެ.",
      "certifiedBy": "ސެޓްފިކެޓް ދިން ފަރާތް",
      "certify": "ސެޓްފިކެޓް ދޭ",
      "certifyWithOverride": "އެހެންނަމަވެސް ސެޓްފިކެޓް ދޭ",
      "decline": "ދެކޮޅުހަދާ",
      "description": "ސެޝަނެއް ބަންދުކުރުމުގެ ކުރިން ބޭނުންވާ ހެކިކަމުގެ ލިޔުމާއި، އެ ބާޠިލްކުރާ އަލުން ހުޅުވުން.",
      "download": "ސެޓްފިކެޓް ޑައުންލޯޑްކުރޭ",
      "downloaded": "ސެޓްފިކެޓް ޑައުންލޯޑްކުރެވިއްޖެ.",
      "gateNote": "ސެޓްފިކެޓަކީ ދިމާވުމުގެ ކުރިމަތީގައި އޮންނަ ދެވަނަ ދޮރެކެވެ، އޭގެ ބަދަލެއް ނޫނެވެ. ދިމާނުވާ ސެޝަނަކަށް ސެޓްފިކެޓެއް ނުދެވޭނެއެވެ.",
      "hash": "މެނިފެސްޓް ހޭޝް",
      "ledgerClosing": "ލެޖަރގެ ބާކީ",
      "lessUnpresented": "އުނި: ބޭންކަށް ނުދާ ފައިސާ",
      "loadFailed": "އެ ސެޝަން ނުލޯޑްވި",
      "matcherWarning": "މި ސެޝަނުގައި މެޗްތައް ކަށަވަރުކުރީ ތިޔަ ބޭފުޅާއެވެ. ސެޓްފިކެޓް ދޭ ފަރާތުން ހެކިވަނީ މެޗްތައް ރަނގަޅުކަމަށެވެ؛ އެ މެޗްތައް ހެދީ އެހެން ފަރާތެކެވެ. ފަހަނައެޅުން ލޮގްކޮށް ރިޕޯޓްކުރެވެއެވެ.",
      "number": "ސެޓްފިކެޓް ނަންބަރު",
      "openLink": "ސެޓްފިކެޓް",
      "override": "ފަހަނައެޅުން",
      "overrideAcknowledge": "އަމިއްލައަށް ހެދި މެޗްތަކަށް ސެޓްފިކެޓް ދެނީ",
      "overrideHint": "އަމިއްލައަށް ހެދި މެޗްތަކެއްގެ ސެޝަނަކަށް ސެޓްފިކެޓް ދޭ ސަބަބު.",
      "reopenDecided": "އަލުން ހުޅުވަން އެދުނު އެދުމާމެދު ގޮތެއް ނިންމިއްޖެ.",
      "reopenDescription": "މި ހުއްދަދޭން ޖެހޭނީ އެހެން ފަރާތަކުންނެވެ.",
      "reopenPending": "އަލުން ހުޅުވަން އެދިފައިވެއެވެ، އަދި ދެވަނަ ފަރާތެއްގެ ހުއްދައަށް އިންތިޒާރުކުރެއެވެ.",
      "reopenRequested": "އަލުން ހުޅުވަން އެދިއްޖެ.",
      "reopenSod": "މި އަލުން ހުޅުވަން އެދުނީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ، ހުއްދައެއް ނުދެއްވޭނެއެވެ.",
      "reopenTitle": "އަލުން ހުޅުވަން އެދުން",
      "reopenWarning": "އަލުން ހުޅުވުމުން ސެޓްފިކެޓް ބާޠިލްވެއެވެ. ސެޓްފިކެޓް ދީ، އަލުން ހުޅުވައި، ބަދަލުކޮށް، ކުރީގެ ހެކިކަމުގެ މައްޗަށް ބަންދުކުރުމުން، އެ ހެކިކަމުގެ އަގު ގެއްލޭނެއެވެ.",
      "requestReopen": "އަލުން ހުޅުވަން އެދޭ",
      "sessionTitle": "ސެޝަން",
      "statementClosing": "ބޭންކުގެ ބާކީ",
      "statementTitle": "ބޭންކް ރިކޮންސިލިއޭޝަން ބަޔާން",
      "title": "ރިކޮންސިލިއޭޝަން ސެޓްފިކެޓް",
      "unmatched": "މެޗްނުވާ ސްޓޭޓްމަންޓް ސަފު"
    },
    "changeAction": {
      "create": "އުފެއްދުން",
      "deactivate": "ހުއްޓާލުން",
      "update": "ބަދަލުކުރުން"
    },
    "changeStatus": {
      "applied": "ތަންފީޒުކުރެވިފައި",
      "approved": "ފާސްވެ، މަޑުކުރުމުގައި",
      "pending": "ފާސްކުރުމަށް",
      "rejected": "ރައްދުކުރެވިފައި"
    },
    "changes": {
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "approveTitle": "ބަދަލު ފާސްކުރުން",
      "caption": "ބަދަލުކުރުމަށް އެދޭ ހުށަހެޅުންތަކާއި އެ ތަކެތީގެ މަޑުކުރުމުގެ ޙާލަތު",
      "decideDescription": "ފާސްކުރުމުން މަޑުކުރުމުގެ މުއްދަތު ފެށޭނެއެވެ؛ އެ ނިމުމުގެ ކުރިން ފައިސާއެއް ނުފޮނުވޭނެއެވެ.",
      "decided": "ހުށަހެޅުމާމެދު ގޮތެއް ނިންމިއްޖެ.",
      "description": "ފާސްކުރުމަށް އިންތިޒާރުގައިވާ ކަންކަމާއި، ފާސްވެ މަޑުކުރުމުގެ މުއްދަތުގައިވާ ކަންކަން.",
      "effectiveAt": "{at} ގައި ޢަމަލުކުރެވޭ",
      "emptyDescription": "މި ފިލްޓަރތަކާ ދިމާވާ ހުށަހެޅުމެއް ނެތެވެ.",
      "emptyTitle": "އިންތިޒާރުގައި އެއްޗެއް ނެތް",
      "hours": "{hours} ގަޑިއިރު",
      "loadFailed": "އެ ހުށަހެޅުންތައް ނުލޯޑްވި",
      "openRegister": "ފައިސާ ދާ ފަރާތްތަކުގެ ރަޖިސްޓަރީ",
      "rejectTitle": "ބަދަލު ރައްދުކުރުން",
      "releaseConfirm": "މިހާރު ދޫކުރޭ",
      "releaseDescription": "މަޑުކުރުމުގެ މުއްދަތު އޮންނަނީ މަކަރެއް ފާހަގަކުރުމަށް ވަގުތު ދިނުމަށެވެ. އެ ކުރުކުރުން ތިޔަ ބޭފުޅާގެ ނަމުގައި ރެކޯޑްކުރެވެއެވެ.",
      "releaseEarly": "ކުރިން ދޫކުރޭ",
      "releaseTitle": "މަޑުކުރުމުގެ މުއްދަތު ކުރުކުރުން",
      "releaseWarning": "މި ބަދަލު ފާސްކުރި ފަރާތަށް މި ދޫކުރުމުގެ ހުއްދައެއް ނެތެވެ. އެއީ ކޮންޓްރޯލެވެ، އަދި ސާވަރުން އެ ތަންފީޒުކުރެއެވެ.",
      "released": "މަޑުކުރުމުގެ މުއްދަތު ދޫކުރެވިއްޖެ.",
      "releasedEarly": "ކުރިން ދޫކުރެވުނު — {code}",
      "sodBlocked": "މި ފާސްކުރީ ތިޔަ ބޭފުޅާ",
      "tableTitle": "ބަދަލުކުރުމަށް އެދޭ ހުށަހެޅުންތައް",
      "title": "ފައިސާ ދާ ފަރާތުގެ ބަދަލުތައް"
    },
    "clearingPolicy": {
      "immediate": "ވަގުތުން",
      "manual": "އަތުން",
      "next_day": "ޖެހިގެން އަންނަ ދުވަހު",
      "value_date": "ވެލިއު ތާރީޚުގައި"
    },
    "continuity": {
      "acknowledge": "ފުނޑުވުން ޤަބޫލުކުރޭ",
      "acknowledgeDescription": "ސްޓޭޓްމަންޓްތައް ނުގުޅޭ ސަބަބު ބަޔާންކުރައްވާ. ސަބަބެއް ނުދީ ފަހަނައަޅާ ދިޔުމަކީ މި ކޮންޓްރޯލް އޮންނަ ސަބަބެވެ.",
      "acknowledgeTitle": "ގުޅުން ފުނޑުވުން ޤަބޫލުކުރުން",
      "acknowledged": "ފުނޑުވުން ޤަބޫލުކުރެވިއްޖެ.",
      "acknowledgedBy": "{at} ގައި {who} ޤަބޫލުކުރި — {code}",
      "breakBody": "ކުރީގެ ސްޓޭޓްމަންޓް ނިމުނީ {prior} ގައި، މި ފެށެނީ {opening} ގައި. ފަރަޤަކީ",
      "okBody": "މި ސްޓޭޓްމަންޓް ކުރީގެ ސްޓޭޓްމަންޓާ ގުޅެއެވެ."
    },
    "continuityReasons": {
      "account_opened_mid_period": "މުއްދަތު މެދުތެރެއިން އެކައުންޓް ހުޅުވުނު",
      "bank_reissued_statement": "ބޭންކުން ސްޓޭޓްމަންޓް އަލުން ދޫކުރި",
      "known_bank_error": "ބޭންކުގެ އެނގޭ ކުށެއް",
      "other": "އެހެނިހެން",
      "statement_out_of_order": "ސްޓޭޓްމަންޓް ތަރުތީބުން ނޫން"
    },
    "continuityStatus": {
      "balance_break": "ފެށޭ ބާކީ ދިމައެއް ނުވޭ",
      "first": "ފުރަތަމަ ސްޓޭޓްމަންޓް",
      "ok": "ގުޅިފައި",
      "overlap": "މުއްދަތު އެއްވެފައި",
      "sequence_gap": "ސްޓޭޓްމަންޓް ނަންބަރު ފުނޑުވެފައި",
      "unchecked": "ބަލާފައެއް ނުވޭ"
    },
    "count": {
      "blindNotice": "މިއީ ފޮރުވިފައިވާ ގުނުމެކެވެ. ނިޒާމުގެ އަދަދު ޖަވާބުގައި ނުހިމެނޭތީ، ޕޯސްޓްކުރުމުގެ ކުރިން މި ޞަފުޙާއިން އެ އަދަދެއް ނުދެއްކޭނެއެވެ.",
      "cancel": "ގުނުން ބާތިލްކުރޭ",
      "cancelConfirm": "ގުނުން ބާތިލްކުރޭ",
      "cancelDescription": "ޝީޓް ބަހައްޓައި، ޕޯސްޓްނުކޮށް ގުނުން ބަންދުކުރެވެއެވެ.",
      "cancelTitle": "ގުނުން ބާތިލްކުރުން",
      "cancelled": "ގުނުން ބާތިލްކުރެވިއްޖެ.",
      "caption": "ގުނުނު ފައިސާގެ ބާވަތްތައް",
      "countedTotal": "ގުނުނު ޖުމްލަ",
      "description": "ފޮށި ގުނާ، ޝީޓް ރައްކާކޮށް، ޕޯސްޓްކުރައްވާ. ނިޒާމުގެ އަދަދު ފެންނާނީ ޕޯސްޓްކުރުމުންނެވެ.",
      "loadFailed": "އެ ގުނުމުގެ ޝީޓް ނުލޯޑްވި",
      "post": "ގުނުން ޕޯސްޓްކުރޭ",
      "postDescription": "ޕޯސްޓްކުރުމުން ނިޒާމުގެ އަދަދު ސްނެޕްޝޮޓްކޮށް ފަރަޤު ހިސާބުކުރެއެވެ. އަނބުރައެއް ނުގެނެވޭނެއެވެ.",
      "postTitle": "ގުނުން ޕޯސްޓްކުރުން",
      "posted": "ގުނުން ޕޯސްޓްކުރެވިއްޖެ.",
      "resultTitle": "ނަތީޖާ",
      "save": "ޝީޓް ރައްކާކުރޭ",
      "saved": "ޝީޓް ރައްކާކޮށް ޖުމްލަކުރެވިއްޖެ.",
      "sheetTitle": "ގުނުމުގެ ޝީޓް",
      "systemTotal": "ނިޒާމުގެ ޖުމްލަ",
      "title": "ފައިސާ ގުނުން {no}",
      "unapprovedCaptures": "ފާސްނުކުރެވި ހުރި ޚަރަދު",
      "unapprovedNote": "ފޮށީގައި ހުރި ރަސީދުތަކުގެ އަދަދަށް މަދުވުމަކީ ފައިސާ މަދުވުމެއް ނޫނެވެ. އެހެންވެ ފާސްނުކުރެވޭ ޚަރަދު ދައްކައެވެ.",
      "variance": "ފަރަޤު",
      "witnessHint": "ދެވަނަ ފަރާތެއް، އަދި ގުނި ފަރާތް ނޫން ފަރާތެއް.",
      "witnessSame": "ހެކިވެރިޔާ ވާންޖެހޭނީ ގުނި ފަރާތް ނޫން އެހެން ފަރާތެކެވެ.",
      "varianceOwner": "ފަރަޤުގެ ވެރިފަރާތް",
      "varianceOwnerHint": "މި ފަރަޤަށް ޖަވާބުދާރީވާ ފަރާތް. ސަބަބާއި ވެރިފަރާތެއް ނެތި ފަރަޤެއް ނުކެނޑޭނެއެވެ."
    },
    "countKind": {
      "closing": "ބަންދުކުރުމުގައި",
      "handover": "ހަވާލުކުރުމުގައި",
      "periodic": "ކަނޑައެޅިފައިވާ މުއްދަތުން",
      "surprise": "ކުއްލި"
    },
    "countStatus": {
      "cancelled": "ބާތިލްކުރެވިފައި",
      "counted": "ގުނާފައި",
      "draft": "ދެލިކޮޕީ",
      "posted": "ޕޯސްޓްކުރެވިފައި"
    },
    "counterpartyKind": {
      "customer": "ކަސްޓަމަރ",
      "employee": "މުވައްޒަފު",
      "other": "އެހެނިހެން",
      "related_company": "ގުޅުންހުރި ކުންފުނި",
      "tax_authority": "ޓެކްސް އިދާރާ",
      "vendor": "ސަޕްލަޔަރ"
    },
    "covenantKind": {
      "affirmative": "ކުރަންޖެހޭ",
      "financial": "މާލީ",
      "information": "މަޢުލޫމާތު",
      "negative": "ނުކުރެވޭނެ"
    },
    "covenantOutcome": {
      "fail": "ފުރިހަމައެއް ނުވި",
      "not_tested": "ބަލާފައެއް ނުވޭ",
      "pass": "ފުރިހަމަވި",
      "pending": "އަދި ބަލާފައެއް ނުވޭ",
      "waived": "މާފުކުރެވިފައި"
    },
    "covenants": {
      "caption": "ކޮވިނަންޓްތަކާއި އެންމެފަހުން ބެލި ބެލުން",
      "computationTitle": "ހިސާބުކުރި ގޮތް",
      "computationWithheld": "ހިސާބު ދޫކޮށްފައެއް ނުވޭ",
      "create": "އައު ކޮވިނަންޓް",
      "createDescription": "މާލީ ކޮވިނަންޓަކުން ބަޔާންކުރަނީ ރަޖިސްޓަރީކުރެވިފައިވާ މިންގަނޑަކާއި، އަޅާކިޔުމަކާއި، ޙައްދެކެވެ.",
      "createTitle": "ކޮވިނަންޓެއް އުފެއްދުން",
      "created": "ކޮވިނަންޓް އުފެއްދިއްޖެ.",
      "description": "ކޮންމެ ފެސިލިޓީއަކުން ވެފައިވާ ވަޢުދާއި، އެ ފުއްދޭތޯ.",
      "emptyDescription": "ދަރަނި ދޫކުރި ފަރާތުން އެދުނު ކަންކަން ރެކޯޑްކުރައްވާ، އެއިރުން ފުރިހަމަނުވުމެއް ސިޓީއަކުން ނޫނީ މިތަނުން ފެންނާނެއެވެ.",
      "emptyTitle": "މި ފެސިލިޓީގައި ކޮވިނަންޓެއް ނެތް",
      "loadFailed": "އެ ކޮވިނަންޓްތައް ނުލޯޑްވި",
      "metricHint": "ރަޖިސްޓަރީކުރެވިފައިވާ މިންގަނޑެއްގެ ކީ. ހިސާބުކުރާނީ ނިޒާމުންނެވެ؛ އަތުން ލިޔެވޭ ހިސާބަކުން ހަދާ ކޮވިނަންޓެއް އޮޑިޓެއް ނުކުރެވޭނެއެވެ.",
      "openFacilities": "ފެސިލިޓީތައް",
      "record": "ބެލުން ރެކޯޑްކުރޭ",
      "recordDescription": "ބަލާ މުއްދަތުގެ ޙަޤީޤީ އަދަދާއި ނަތީޖާ ބަޔާންކުރައްވާ.",
      "recordTitle": "ކޮވިނަންޓް ބެލުމެއް ރެކޯޑްކުރުން",
      "recorded": "ބެލުން ރެކޯޑްކުރެވިއްޖެ.",
      "showComputation": "ހިސާބު",
      "tableTitle": "ކޮވިނަންޓް ބޯޑް",
      "title": "ކޮވިނަންޓްތައް",
      "waive": "މާފުކުރޭ",
      "waiveDescription": "މާފުކުރުމުގައި، ދަރަނި ދޫކުރި ފަރާތުން އެ ދިން ލިޔުން ބަޔާންކުރަން ޖެހެއެވެ.",
      "waiveTitle": "ފުރިހަމަނުވުމެއް މާފުކުރުން",
      "waived": "ފުރިހަމަނުވުން މާފުކުރެވިއްޖެ.",
      "waiverRefHint": "ރެފަރެންސްއަކާ ނުލައި މާފުކުރުމަކީ ދަޢުވާއެކެވެ، ހެއްކެއް ނޫނެވެ."
    },
    "dayCount": {
      "act_360": "އެކްޗުއަލް / 360",
      "act_365": "އެކްޗުއަލް / 365",
      "thirty_360": "ތިރީސް / 360"
    },
    "diff": {
      "availableDelta": "ބޭނުންކުރެވޭ އަދަދުގެ ބަދަލު",
      "caption": "ފައިސާ ހުރި ކޮންމެ ތަނެއްގެ ތަފާތު",
      "change": "ބަދަލު",
      "changes": {
        "added": "އިތުރުކުރެވުނު",
        "changed": "ބަދަލުވި",
        "removed": "ނެގުނު",
        "unchanged": "ބަދަލެއް ނުވޭ"
      },
      "description": "އެއް ތާރީޚެއްގެ ދެ ވަރޝަން، އަދި އޭގެ ދެމެދުގައި ބަދަލުވި ކޮންމެ އަދަދެއް.",
      "empty": "މި ދެ ވަރޝަނުގެ ދެމެދުގައި އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވެއެވެ.",
      "fromLedger": "ކުރިން",
      "linesTitle": "ފައިސާ ހުރި ތަނުން",
      "loadFailed": "އެ އަޅާކިޔުން ނުލޯޑްވި",
      "summaryTitle": "ޖުމްލަ",
      "title": "އިޞްލާޙުން ބަދަލުވި ތަންތަން",
      "toLedger": "މިހާރު"
    },
    "exceptionReasons": {
      "account_closed": "އެކައުންޓް ބަންދު",
      "bank_refused": "ބޭންކުން ޤަބޫލެއް ނުކުރި",
      "duplicate": "ދެފަހަރު",
      "entered_in_error": "ކުށަކުން ލިޔެވުނު",
      "fraud": "މަކަރު",
      "insufficient_funds": "ފައިސާ ނުފުދޭ",
      "invalid_details": "ތަފްޞީލު ރަނގަޅެއް ނޫން",
      "no_longer_needed": "މިހާރު ބޭނުމެއް ނުވޭ",
      "other": "އެހެނިހެން",
      "superseded": "ބަދަލުގައި އެހެން އެއްޗެއް",
      "wrong_amount": "އަދަދު ގޯސް",
      "wrong_beneficiary": "ފައިސާ ދާ ފަރާތް ގޯސް"
    },
    "facilities": {
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "caption": "ދަރަނީގެ ފެސިލިޓީތައް، ނަގާފައިވާ އަދި ދައްކަން ބާކީ",
      "commitmentHint": "ނަގާ ފީއަކީ ރިވޮލްވިންގ ފެސިލިޓީއެއްގެ ނުނަގާ ބާކީގެ މައްޗަށް އެކަންޏެވެ.",
      "create": "އައު ފެސިލިޓީ",
      "createDescription": "ފަހުން ހިސާބުކުރެވޭ ކޮންމެ އިންޓަރެސްޓެއް ބިނާވަނީ ރޭޓް، ދުވަސް ގުނާ ގޮތް އަދި ނިމޭ ތާރީޚުގެ މައްޗަށެވެ.",
      "createTitle": "ފެސިލިޓީއެއް އުފެއްދުން",
      "created": "ފެސިލިޓީ އުފެއްދިއްޖެ.",
      "dayCountHint": "މިއީ މާކެޓްގެ އުޞޫލެކެވެ، ޓެކްސް ޤަވާޢިދެއް ނޫނެވެ. މިއިން އިންޓަރެސްޓަށް ޙަޤީޤީ ބަދަލެއް އާދެއެވެ.",
      "description": "ދަރަނި ދޫކުރި ފަރާތުން ކަނޑައެޅި އަދަދާއި، ނަގާފައިވާ އަދަދާއި، ބާކީ އޮތް އަދަދު.",
      "emptyDescription": "ކުންފުނީގައި އޮތް ލޯނު، އޯވަޑްރާފްޓް ނުވަތަ ރިވޮލްވިންގ ފެސިލިޓީ ރެކޯޑްކުރައްވާ، އެއިރުން އިންޓަރެސްޓް ހަނދާނުގައި ބެހެއްޓުމުގެ ބަދަލުގައި ހިސާބުކުރެވޭނެއެވެ.",
      "emptyTitle": "އަދި ފެސިލިޓީއެއް ނެތް",
      "loadFailed": "އެ ފެސިލިޓީތައް ނުލޯޑްވި",
      "openCovenants": "ކޮވިނަންޓްތައް",
      "openMaturity": "ހަމަވާ މުއްދަތުގެ ސިޑި",
      "tableTitle": "ފެސިލިޓީތައް",
      "title": "ދަރަނީގެ ފެސިލިޓީތައް"
    },
    "facility": {
      "accrualsCaption": "ކޮންމެ މުއްދަތެއްގައި އެކުވި އިންޓަރެސްޓާއި ފީ",
      "accrualsDescription": "ކޮންމެ ހިސާބުކުރުމެއް، އެ ހިސާބުކުރެވުނު ބައިތަކަށް ބަހާލެވެއެވެ — ސީދާ އަދަދުތައް، ޖަމާކޮށް އެއްފަހަރު ރައުންޑްކުރެވެއެވެ.",
      "accrualsEmpty": "މި ފެސިލިޓީގައި އިންޓަރެސްޓެއް ހިސާބުކޮށްފައެއް ނުވެއެވެ.",
      "accrualsTitle": "އިންޓަރެސްޓް ހިސާބުކުރުން",
      "activate": "ހިންގަން ފަށާ",
      "activated": "ފެސިލިޓީ ހިނގަން ފަށައިފި.",
      "commitSchedule": "ތާވަލު ކޮމިޓްކުރޭ",
      "covenantsTitle": "ކޮވިނަންޓްތައް",
      "currentPortionHint": "ބަދަލުވަނީ ރިޕޯޓް ތާރީޚުގައި، ފައިސާ ނެގި ދުވަހަކު ނޫން",
      "description": "އޭގެ ޝަރުޠުތަކާއި، ތާވަލާއި، ދިޔަ ފައިސާއާއި، އެކުވެފައިވާ އިންޓަރެސްޓް.",
      "drawdown": "ފައިސާ ނެގުން",
      "drawdownConfirm": "ފައިސާ ނެގުން ޕޯސްޓްކުރޭ",
      "drawdownDescription": "ފައިސާ ވަދެ، ދަރަންޏެއް އުފެދޭނީ އެއް ޕޯސްޓިންގއަކުންނެވެ.",
      "drawdownPosted": "ފައިސާ ނެގުން ޕޯސްޓްކުރެވިއްޖެ.",
      "drawdownTitle": "ފައިސާ ނެގުމެއް ޕޯސްޓްކުރުން",
      "generateSchedule": "ތާވަލު",
      "loadFailed": "އެ ފެސިލިޓީ ނުލޯޑްވި",
      "movementsCaption": "މި ފެސިލިޓީއަށް ވަދެ ނުކުތް ފައިސާ",
      "movementsEmpty": "މި ފެސިލިޓީން ފައިސާ ނަގާ ނުވަތަ އަނބުރާ ދައްކާފައެއް ނުވެއެވެ.",
      "movementsTitle": "ފައިސާ ނެގުމާއި އަނބުރާ ދެއްކުން",
      "overrideAcknowledge": "ނިޒާމުން ދެކޮޅުހެދި ޙައްދެއް ފަހަނައަޅައި ޕޯސްޓްކުރަނީ",
      "overrideHint": "ޙައްދު ފަހަނައަޅާ ދިޔުމަށް ހުއްދަދޭ ސަބަބު. މި ލޮގްކޮށް ރިޕޯޓްކުރެވެއެވެ.",
      "previewCaption": "ހުށަހަޅާ ޤިސްތުތައް",
      "previewNote": "މިއީ ހަމައެކަނި ދެއްކުމެކެވެ. އެއްވެސް އެއްޗެއް ލިޔެފައެއް ނުވެއެވެ.",
      "previewSchedule": "ބައްލަވާ",
      "repayment": "އަނބުރާ ދެއްކުން",
      "repaymentConfirm": "އަނބުރާ ދެއްކުން ޕޯސްޓްކުރޭ",
      "repaymentDescription": "އަސްލު ފައިސާގެ ކުރިން އެކުވެފައިވާ އިންޓަރެސްޓް އަދާކުރެވެއެވެ.",
      "repaymentPosted": "އަނބުރާ ދެއްކުން ޕޯސްޓްކުރެވިއްޖެ.",
      "repaymentTitle": "އަނބުރާ ދެއްކުމެއް ޕޯސްޓްކުރުން",
      "roundedOnce": "ސީދާ ބައިތަކުގެ ޖުމްލަ، އެއްފަހަރު ރައުންޑްކުރެވިފައި",
      "scheduleCaption": "ކޮންޓްރެކްޓްގެ ޤިސްތުތައް",
      "scheduleCommitted": "ތާވަލު ކޮމިޓްކުރެވިއްޖެ.",
      "scheduleDialogDescription": "ފުރަތަމަ ބައްލަވާ. ކޮމިޓްކުރުމުން މިހާރުގެ ތާވަލު ބަދަލުވެ، ކުރީގެ ތާވަލު ކިޔޭގޮތަށް ދެމިހުންނާނެއެވެ.",
      "scheduleDialogTitle": "ތާވަލެއް ހެދުން",
      "scheduleEmpty": "މި ފެސިލިޓީއަށް ތާވަލެއް ހަދާފައެއް ނުވެއެވެ.",
      "scheduleTitle": "އަނބުރާ ދެއްކުމުގެ ތާވަލު (ވަރޝަން {version})",
      "scheduleTotals": "ޖުމްލަ",
      "segmentsCaption": "ހިސާބުކުރެވުނު ބާކީގެ ބައިތައް",
      "termsTitle": "ޝަރުޠުތައް",
      "title": "ފެސިލިޓީ"
    },
    "facilityKind": {
      "guarantee": "ގެރެންޓީ",
      "overdraft": "އޯވަޑްރާފްޓް",
      "revolving": "ރިވޮލްވިން",
      "term_loan": "މުއްދަތު ލޯނު",
      "bond": "ބޮންޑް",
      "demand_loan": "ޑިމާންޑް ލޯން",
      "intercompany_loan": "އިންޓަރކޮމްޕެނީ ލޯން",
      "lease_liability": "ލީސް ލަޔަބިލިޓީ"
    },
    "facilityStatus": {
      "active": "ހިނގަމުންދާ",
      "cancelled": "ބާތިލްކުރެވިފައި",
      "defaulted": "ޑިފޯލްޓްވެފައި",
      "draft": "ދެލިކޮޕީ",
      "repaid": "އަދާކުރެވިފައި",
      "closed": "ބަންދުކުރެވިފައި",
      "in_default": "ޑިފޯލްޓްވެފައި",
      "matured": "މެޗުއަރ ވެފައި",
      "pending_approval": "ތާއީދަށް މަޑުކުރަނީ"
    },
    "fields": {
      "accountName": "އެކައުންޓްގެ ނަން",
      "accountNumber": "އެކައުންޓް ނަންބަރު",
      "accountNumberHint": "އެންކްރިޕްޓްކޮށް ރައްކާކުރެވެއެވެ. އަލުން ދައްކާނީ ފަހު އަކުރުތައް އެކަންޏެވެ.",
      "accountType": "އެކައުންޓްގެ ބާވަތް",
      "accruedInterest": "އެކުވެފައިވާ އިންޓަރެސްޓް",
      "action": "ޢަމަލު",
      "actual": "ޙަޤީޤީ",
      "amount": "އަދަދު",
      "asOf": "ތާރީޚަށް",
      "averagePrincipal": "މެދު އަސްލު ފައިސާ",
      "balance": "ބާކީ",
      "band": "ބޭންޑް",
      "bankAccount": "ބޭންކް އެކައުންޓް",
      "bankDetail": "ބޭންކްގެ ތަފްޞީލު",
      "bankName": "ބޭންކް",
      "bankReference": "ބޭންކްގެ ރެފަރެންސް",
      "baseRateCode": "އަސާސީ ރޭޓް ސީރީޒް",
      "basis": "އަސާސް",
      "beneficiary": "ފައިސާ ދާ ފަރާތް",
      "blocked": "ހިފެހެއްޓިފައި",
      "blockedNote": "ހިފެހެއްޓި ސަބަބު",
      "canSignInApp": "އެޕުން ސޮއިކުރެވޭ",
      "category": "ބައި",
      "ceiling": "މަތީ ޙައްދު",
      "clearingAccount": "ކްލިއަރިން އެކައުންޓް",
      "clearingPolicy": "ކްލިއަރ ކުރާ ގޮތް",
      "closing": "ނިމޭ ބާކީ",
      "code": "ކޯޑް",
      "commitmentFeeRate": "ކޮމިޓްމަންޓް ފީ ރޭޓް",
      "company": "ކުންފުނި",
      "connector": "ކަނެކްޓަރ",
      "contactName": "ގުޅުނު ފަރާތުގެ ނަން",
      "contactNumber": "ގުޅި ނަންބަރު",
      "coolingOff": "މަޑުކުރުމުގެ މުއްދަތު",
      "countKind": "ގުނުމުގެ ބާވަތް",
      "countedBy": "ގުނީ",
      "counterparty": "އަނެއް ފަރާތް",
      "counterpartyKind": "ބާވަތް",
      "covenant": "ކޮވިނަންޓް",
      "covenantKind": "ކޮވިނަންޓްގެ ބާވަތް",
      "currency": "ފައިސާ",
      "currentPortion": "މިއަހަރު އަދާކުރަންޖެހޭ",
      "custodian": "ބަލަހައްޓާ ފަރާތް",
      "dailyDays": "ދުވަހުން ދުވަހަށް ދައްކާ ދުވަސް",
      "date": "ތާރީޚު",
      "dayCount": "ދުވަސް ގުނާ ގޮތް",
      "days": "ދުވަސް",
      "delta": "ބަދަލު",
      "denomination": "ފައިސާގެ އަދަދު",
      "description": "ތަފްޞީލު",
      "document": "ލިޔުން",
      "documentNo": "ލިޔުމުގެ ނަންބަރު",
      "documentRef": "ލިޔުމުގެ ރެފަރެންސް",
      "drawn": "ނަގާފައި / ނުނަގާ",
      "dueDate": "ދައްކަންޖެހޭ ތާރީޚު",
      "effective": "ޢަމަލުކުރާ",
      "effectiveFrom": "ޢަމަލުކުރަން ފަށާ",
      "effectiveOn": "ޢަމަލުކުރާ ތާރީޚު",
      "effectiveTo": "ޢަމަލުކުރުން ނިމޭ",
      "eligible": "ޝަރުޠު ފުރިހަމަވޭ",
      "evidence": "ހެކި",
      "exactInterest": "ސީދާ އިންޓަރެސްޓް",
      "facility": "ފެސިލިޓީ",
      "facilityKind": "ފެސިލިޓީގެ ބާވަތް",
      "fee": "ފީ",
      "firstDueDate": "ފުރަތަމަ ދައްކަންޖެހޭ ތާރީޚު",
      "fixedRate": "ފިކްސްޑް ރޭޓް",
      "rateFloor": "ރޭޓް ފްލޯ",
      "rateCap": "ރޭޓް ކެޕް",
      "float": "ފްލޯޓް",
      "frequency": "ތަކުރާރުވާ މިންވަރު",
      "from": "ފެށޭ",
      "fromAccount": "ފައިސާ ނަގާ އެކައުންޓް",
      "fundingAccount": "ފައިސާ ދޭ އެކައުންޓް",
      "glAccount": "ލެޖަރ އެކައުންޓް",
      "graceDays": "ލުއި ދުވަސް",
      "granularity": "ބައިކުރެވިފައިވާ ގޮތް",
      "handoverCountId": "ހަވާލުކުރުމުގެ ގުނުމުގެ އައިޑީ",
      "heldReceipts": "ފޮށީގައި ހުރި ރަސީދު",
      "holder": "ފައިސާ ހުރި ތަން",
      "holders": "ފައިސާ ހުރި ތަންތަން",
      "horizonWeeks": "މުއްދަތު (ހަފުތާ)",
      "hours": "ގަޑިއިރު",
      "iban": "އައިބޭން",
      "independentSource": "މިނިވަން މަޞްދަރު",
      "instalments": "ޤިސްތު",
      "interest": "އިންޓަރެސްޓް",
      "journal": "ޖާނަލް",
      "kind": "ބާވަތް",
      "lastCounted": "އެންމެފަހުން ގުނި",
      "lender": "ދަރަނި ދޫކުރި ފަރާތް",
      "limit": "ޙައްދު",
      "lineTotal": "ސަފުގެ ޖުމްލަ",
      "mandate": "މެންޑޭޓް",
      "marginRate": "މާރޖިން",
      "maturity": "ނިމޭ ތާރީޚު",
      "maxAmount": "އެންމެ މަތީ އަދަދު",
      "memo": "މެމޯ",
      "method": "ގޮތް",
      "metricKey": "މިންގަނޑު",
      "minAmount": "އެންމެ ދަށް އަދަދު",
      "minimumBalance": "އެންމެ ދަށް ބާކީ",
      "module": "މޮޑިއުލް",
      "name": "ނަން",
      "newCustodianUserId": "އައު ބަލަހައްޓާ ފަރާތް (ޔޫޒަރ އައިޑީ)",
      "nonCurrentPortion": "ފަހުން އަދާކުރަންޖެހޭ",
      "note": "ނޯޓު",
      "onDate": "ތާރީޚުގައި",
      "operator": "ނިސްބަތް",
      "origin": "އުފެދުނު ގޮތް",
      "outcome": "ނަތީޖާ",
      "outstanding": "ދައްކަން ބާކީ",
      "overdraftLimit": "އޯވަޑްރާފްޓް ޙައްދު",
      "overrideReasonCode": "ފަހަނައަޅާ ދިޔުމުގެ ސަބަބު ކޯޑް",
      "panel": "ޕެނަލް",
      "payableDelayDays": "ދައްކާ ފައިސާ ލަސްވާ ދުވަސް",
      "payee": "ފައިސާ ލިބޭ ފަރާތް",
      "performedAt": "ކުރި ވަގުތު",
      "performedBy": "ކުރި ފަރާތް",
      "period": "މުއްދަތު",
      "poolRole": "ޕޫލްގައި ދައުރު",
      "positionDate": "ޕޮޒިޝަން ތާރީޚު",
      "principal": "އަސްލު ފައިސާ",
      "purposeCode": "ބޭނުމުގެ ކޯޑް",
      "quantity": "ޢަދަދު",
      "rate": "ރޭޓް",
      "rateKind": "ރޭޓްގެ ބާވަތް",
      "reason": "ސަބަބު",
      "reasonCode": "ސަބަބުގެ ކޯޑް",
      "reasonCodePlaceholder": "ސަބަބެއް ޚިޔާރުކުރޭ",
      "receiptDate": "ލިބޭ ތާރީޚު",
      "receivableDelayDays": "ލިބޭ ފައިސާ ލަސްވާ ދުވަސް",
      "receivableHaircutPct": "ލިބޭ ފައިސާއިން އުނިކުރާ ބައި",
      "recoverable": "އަނބުރާ ލިބޭ ޓެކްސް",
      "recurringMultiplierPct": "ތަކުރާރު ބައިތަކުގެ ނިސްބަތް",
      "reference": "ރެފަރެންސް",
      "requestedBy": "އެދުނު ފަރާތް",
      "requiredSignatures": "ބޭނުންވާ ސޮއިގެ ޢަދަދު",
      "restrictionNote": "ހުރި ހުރަސް",
      "rule": "ޤަވާޢިދު",
      "scenario": "ސިނާރިއޯ",
      "search": "ހޯދާ",
      "segment": "ބައި",
      "sendDate": "ފޮނުވާ ތާރީޚު",
      "shortfall": "މަދުވާ އަދަދު",
      "signatory": "ސޮއިކުރާ ފަރާތް",
      "signatures": "ސޮއި",
      "signingRule": "ސޮއިކުރާ ޤަވާޢިދު",
      "source": "މަޞްދަރު",
      "sourceRef": "މަޞްދަރުގެ ރެފަރެންސް",
      "startDate": "ފެށޭ ތާރީޚު",
      "subject": "މައުޟޫޢު",
      "supplierTaxId": "ސަޕްލަޔަރގެ ޓިން",
      "swift": "ސްވިފްޓް / ބީއައިސީ",
      "tax": "ޓެކްސް",
      "taxCode": "ޓެކްސް ކޯޑް",
      "test": "ބެލުން",
      "threshold": "ޙައްދު",
      "to": "ނިމޭ",
      "toAccount": "ފައިސާ ދާ އެކައުންޓް",
      "txnNo": "މުޢާމަލާތު ނަންބަރު",
      "undrawn": "ނުނަގާ",
      "valueDate": "ވެލިއު ތާރީޚު",
      "varianceAccount": "ފަރަޤުގެ އެކައުންޓް",
      "verificationMethod": "ކަށަވަރުކުރި ގޮތް",
      "verificationStatus": "ކަށަވަރުކުރުން",
      "version": "ވަރޝަން",
      "waiverExpires": "މާފުކުރުން ހަމަވާ",
      "waiverRef": "މާފުކުރި ލިޔުމުގެ ރެފަރެންސް",
      "wallet": "ވޮލެޓް",
      "walletKind": "ވޮލެޓްގެ ބާވަތް",
      "witnessUserId": "ހެކިވެރިޔާ (ޔޫޒަރ އައިޑީ)",
      "witnessedBy": "ހެކިވީ",
      "workings": "ހިސާބުކުރި ގޮތް"
    },
    "filtersTitle": "ފިލްޓަރތައް",
    "forecast": {
      "adjustedDate": "ލަފާކުރާ ތާރީޚު",
      "adjustment": "އިޞްލާޙު",
      "against": "{minimum} ގެ އެންމެ ދަށް ބާކީއާ އަޅާކިޔައި",
      "alreadyPublished": "{date} މިހާރުވެސް ޝާއިޢުކުރެވިފައިވެއެވެ. ދައްކާފައި މިވަނީ އެ ރަން އެވެ.",
      "belowMinimum": "އެންމެ ދަށް ބާކީއަށްވުރެ ދަށް",
      "bucketsCaption": "މުއްދަތުގެ ތެރޭގައި ލަފާކުރުމުގެ ބައިތައް",
      "bucketsDescription": "ފުރަތަމަ ހަފުތާއަކީ ދުވަހުން ދުވަހަށް ހަތް ބައެކެވެ، ދެވަނަ ހަފުތާއަކީ އެއް ބައެކެވެ؛ ކޮންމެ ސަފަކުން އެކަން ބުނެދެއެވެ.",
      "bucketsTitle": "ބައިތައް",
      "chartAria": "{buckets} ބައި، އޭގެތެރެއިން {daily} ދުވަހުން ދުވަހަށް، {currency} އިން",
      "chartTitle": "މުއްދަތު",
      "closing": "ނިމޭ ބާކީ",
      "description": "މުއްދަތާއި، ބައިތަކާއި، ކޮންމެ ބައެއްގެ ފަހަތުގައިވާ އައިޓަމްތައް.",
      "drill": "އައިޓަމް ދައްކާ",
      "fromPosition": "ޝާއިޢުކުރެވުނު ޕޮޒިޝަނަކުން",
      "frozenNote": "ޝާއިޢުކުރެވުނު ލަފާކުރުމެއް ފްރީޒްވަނީ ޕޮޒިޝަނެއް ފްރީޒްވާ ހަމަ އެ ޔަޤީންކަމުންނެވެ. ބަދަލުކުރަން ރިވިޜަނެއް ޝާއިޢުކުރައްވާ.",
      "inflows": "ވަންނަ ފައިސާ",
      "items": "އައިޓަމް",
      "itemsCaption": "މި ބައިގެ ފަހަތުގައިވާ ލިޔުންތައް",
      "itemsEmpty": "މި ބައިގައި އެއްވެސް އެއްޗެއް ނެތެވެ.",
      "liquidityGap": "ފައިސާގެ ދަތިކަން",
      "loadFailed": "އެ ލަފާކުރުން ނުލޯޑްވި",
      "minClosing": "އެންމެ ދަށް ނިމޭ ބާކީ",
      "minimum": "އެންމެ ދަށް ބާކީ",
      "noPosition": "ފެށޭ ބާކީ ނަގާނެ ޝާއިޢުކުރެވުނު ޕޮޒިޝަނެއް ނެތް",
      "opening": "ފެށޭ ބާކީ",
      "outflows": "ނުކުންނަ ފައިސާ",
      "partial": "މި ރަން ހެދިއިރު ބައެއް މަޞްދަރުތައް ނުލިބުނެވެ:",
      "publish": "ލަފާކުރުން ޝާއިޢުކުރޭ",
      "published": "{date} ގެ ލަފާކުރުން ޝާއިޢުކުރެވިއްޖެ.",
      "revise": "ރިވިޜަނެއް ޝާއިޢުކުރޭ",
      "reviseConfirm": "ރިވިޜަން ޝާއިޢުކުރޭ",
      "reviseDescription": "މިއިން އައު ވަރޝަނެއް އުފެދޭނެއެވެ. ސްކްރީނުގައިވާ ރަން ބަދަލުނުވެ ދެމިހުންނާނެއެވެ.",
      "reviseTitle": "ރިވިޜަނެއް ޝާއިޢުކުރުން",
      "revised": "ވަރޝަން {version} ޝާއިޢުކުރެވިއްޖެ.",
      "title": "{date} ގެ ލަފާކުރުން"
    },
    "forecastSource": {
      "ap": "ސަޕްލަޔަރ އިންވޮއިސް",
      "ar": "ކަސްޓަމަރ އިންވޮއިސް",
      "debt": "ދަރަނީގެ ތާވަލު",
      "manual": "އަތުން އިޞްލާޙުކުރި",
      "recurring": "ތަކުރާރު ބައިތައް",
      "transfer": "ފައިސާ ބަދަލުކުރުން"
    },
    "forecasts": {
      "baseScenario": "އަސާސީ",
      "caption": "ޝާއިޢުކުރެވުނު ލަފާކުރުމުގެ ރަންތައް",
      "dailyHint": "ފުރަތަމަ ހަފުތާގެ ކިތައް ދުވަސް ދުވަހުން ދުވަހަށް ދައްކާނީ. 0 އިން ނިއްވާލެވެއެވެ.",
      "description": "ޝާއިޢުކުރެވުނު ގޮތަށް ލަފާކުރުމުގެ ރަންތައް، އެއިރުން ސީދާކަން މިނެވޭނީ ބަދަލުނުވާ އެއްޗަކާ އަޅާކިޔައެވެ.",
      "emptyDescription": "ތާރީޚަކަށް ލަފާކުރުމެއް ޝާއިޢުކުރައްވާ. އޭގެ ކުރިން ސީދާކަމުގެ ރިޕޯޓަށް އަޅާކިޔާނެ އެއްޗެއް ނުހުންނާނެއެވެ.",
      "emptyTitle": "އަދި އެއްވެސް އެއްޗެއް ޝާއިޢުކޮށްފައެއް ނުވޭ",
      "includeSuperseded": "ބަދަލުކުރެވުނު ވަރޝަންތައްވެސް ދައްކާ",
      "loadFailed": "އެ ލަފާކުރުންތައް ނުލޯޑްވި",
      "openAccuracy": "ސީދާކަން",
      "openScenarios": "ސިނާރިއޯތައް",
      "publishDescription": "ފުރަތަމަ ހަފުތާ ދުވަހުން ދުވަހަށް ބައިކުރެވެއެވެ؛ ބާކީ ބައި ހަފުތާއިންނެވެ.",
      "publishTitle": "ލަފާކުރުމެއް ޝާއިޢުކުރުން",
      "publishedNote": "ލައިވް 13 ހަފުތާގެ ލަފާކުރުން ހުންނާނީ ފައިސާގެ ބައިގައެވެ. މި ޞަފުޙާއަކީ ޝާއިޢުކުރެވުނު އެއްޗެވެ — ސީދާކަން ބަލަނީ ޝާއިޢުކުރެވުނު ލަފާކުރުމާއި ޕޮޒިޝަން އަޅާކިޔައެވެ.",
      "tableTitle": "ރަންތައް",
      "title": "ޝާއިޢުކުރެވުނު ލަފާކުރުންތައް"
    },
    "frequency": {
      "annual": "އަހަރަކު އެއްފަހަރު",
      "monthly": "މަހަކު އެއްފަހަރު",
      "quarterly": "ކުއަރޓަރަކު އެއްފަހަރު",
      "semiannual": "ހަ މަހުން",
      "at_maturity": "މެޗުއަރިޓީގައި"
    },
    "granularity": {
      "day": "ދުވަސް",
      "week": "ހަފުތާ"
    },
    "holderKind": {
      "bank_account": "ބޭންކް އެކައުންޓް",
      "wallet": "ވޮލެޓް"
    },
    "instruction": {
      "alreadySigned": "ތިޔަ ބޭފުޅާ މި އިރުޝާދުގައި ސޮއިކުރައްވައިފިއެވެ. ދެވަނަ ފަހަރު ފިއްތުމަކުން ދެ ސޮއި ބޭނުންވާ މެންޑޭޓެއް ފުރިހަމައެއް ނުވާނެއެވެ.",
      "approved": "އިރުޝާދު ފާސްކުރެވިއްޖެ.",
      "arrives": "ލިބޭ އަދަދު",
      "beneficiaryBlocked": "މި ފައިސާ ދާ ފަރާތް ހުއްޓުވާފައިވެއެވެ. ފަހަނައަޅާ ދިޔުމުގެ ގޮތެއް ނެތެވެ — ފުރަތަމަ ހުއްޓުވުން ނަގަން ޖެހޭނެއެވެ.",
      "beneficiaryCoolingOff": "މި ފަރާތް އަދިވެސް މަޑުކުރުމުގެ މުއްދަތުގައެވެ. މުއްދަތު އޮންނަނީ މަކަރެއް ފާހަގަކުރެވުމަށެވެ؛ ފާސްނުކުރާ ފަރާތަކަށް، ސަބަބަކާއެކު ކުރިން ދޫކުރެވިދާނެއެވެ.",
      "beneficiaryUnverified": "މި ފަރާތް ކަށަވަރުކޮށްފައެއް ނުވެއެވެ. ފައިސާ ފޮނުވުމުގެ ކުރިން، އެ އެކައުންޓަކީ އެ ފަރާތުގެ އެކައުންޓްކަން ސާބިތުކުރައްވާ.",
      "cancel": "ބާތިލްކުރޭ",
      "cancelTitle": "އިރުޝާދު ބާތިލްކުރުން",
      "confirm": "ލިބުނުކަން ކަށަވަރުކުރޭ",
      "confirmDescription": "ކަށަވަރުކުރުމުން މަގުމަތީގައިވާ ފައިސާ ސާފުވެ، ލިބުނު ފަޅި ޕޯސްޓްވެއެވެ.",
      "confirmTitle": "ފައިސާ ފޮނުވުން ކަށަވަރުކުރުން",
      "confirmed": "ފައިސާ ފޮނުވުން ކަށަވަރުކުރެވިއްޖެ.",
      "description": "ފައިސާ ލިބޭ ފަރާތާއި، ނަގާ އެކައުންޓާއި، ސޮއިކުރި ފަރާތާއި، މިހާރު އޮތް ޙާލަތު.",
      "duplicateAcknowledge": "ނިޒާމުން ދެފަހަރު ކަމަށް ދެކޭ ފައިސާއެއް ހުށަހަޅަނީ",
      "duplicateSubmit": "އެހެންނަމަވެސް ހުށަހަޅާ",
      "duplicateTitle": "މިއީ މީގެކުރިން ފޮނުވާފައިވާ އިރުޝާދެއް ކަހަލައެވެ",
      "duplicateWarning": "އެއް ފަރާތަކަށް، އެއް އަދަދެއް، އެއް އެކައުންޓަކުން، ދެފަހަރު ބަލާ މުއްދަތުގެ ތެރޭގައެވެ. ޙަޤީޤީ ދެވަނަ ފައިސާއެއް ފޮނުވިދާނެއެވެ، ސަބަބު ރެކޯޑްކޮށްފައެވެ.",
      "exceptionDescription": "ހަމައެކަނި ކަނޑައެޅިފައިވާ ސަބަބުތައް. ރިޕޯޓްތައް ބައިކުރަނީ ކޯޑުންނެވެ.",
      "exceptionRecorded": "ނަތީޖާ ރެކޯޑްކުރެވިއްޖެ.",
      "from": "{status} ން",
      "headerTitle": "އިރުޝާދު",
      "inTransitBanner": "ފައިސާ ނުކުމެ، އަދި ކަށަވަރުވެފައެއް ނުވެއެވެ. އެ އޮތީ މަގުމަތީގައިވާ ފައިސާގެ ތެރޭގައެވެ.",
      "loadFailed": "އެ އިރުޝާދު ނުލޯޑްވި",
      "noMandate": "މެންޑޭޓެއް ނުހޯދުނު",
      "panelLabel": "ޕެނަލް {panel}",
      "recall": "އަނބުރާ ހޯދަން އެދޭ",
      "recallFailed": "ބޭންކުން އަނބުރާ ފޮނުވަން ދެކޮޅުހެދި",
      "recallNote": "އަނބުރާ ހޯދަން އެދުމުން ލެޖަރަށް ބަދަލެއް ނާދެއެވެ. ފައިސާ ދިޔައީއެވެ؛ ތިޔަ އެދެނީ ބޭންކުން އެ އަނބުރާ ފޮނުވުމަށެވެ، އަދި ބޭންކުން ދެކޮޅުހަދައިފާނެއެވެ.",
      "recallOutcome": "އަނބުރާ ހޯދުމުގެ ނަތީޖާ ރެކޯޑްކުރޭ",
      "recallOutcomeTitle": "އަނބުރާ ހޯދުމުގެ ނަތީޖާ ރެކޯޑްކުރުން",
      "recallSucceeded": "ބޭންކުން ފައިސާ އަނބުރާ ފޮނުވި",
      "recallTitle": "އަނބުރާ ހޯދަން އެދުން",
      "receiptLeg": "ލިބުނު ޖާނަލް",
      "reject": "ބޭންކުން ދެކޮޅުހެދިކަން ރެކޯޑްކުރޭ",
      "rejectTitle": "ބޭންކުން ދެކޮޅުހެދި",
      "release": "ބޭންކަށް ދޫކުރޭ",
      "releaseDescription": "މިއީ ބޭންކަށް އިރުޝާދު ދޭ ޢަމަލެވެ.",
      "releaseTitle": "އިރުޝާދު ދޫކުރުން",
      "releaseWarning": "ދޫކުރުމުން ފައިސާ ބޭންކް އެކައުންޓުން ނުކުމެ، މަގުމަތީގައިވާ ފައިސާއަށް ދާނެއެވެ. އަނބުރައެއް ނުގެނެވޭނެ — ހަމައެކަނި އެދެވިދާނެ، އަދި ބޭންކުން ދެކޮޅުހަދައިފާނެއެވެ.",
      "released": "އިރުޝާދު ދޫކުރެވިއްޖެ.",
      "reversalLeg": "އަނބުރާ ރައްދުކުރި ޖާނަލް",
      "sendLeg": "ފޮނުވި ޖާނަލް",
      "sign": "ސޮއިކުރޭ",
      "signaturesDescription": "ބޭނުންވާ {required} ގެ ތެރެއިން {applied}.",
      "signaturesEmpty": "މި އިރުޝާދުގައި އެއްވެސް ފަރާތަކުން ސޮއިކޮށްފައެއް ނުވެއެވެ.",
      "signaturesTitle": "ސޮއިތައް",
      "signed": "ތިޔަ ބޭފުޅާގެ ސޮއި ލެވިއްޖެ.",
      "submitted": "އިރުޝާދު ހުށަހެޅިއްޖެ.",
      "timelineEmpty": "މި އިރުޝާދަށް އަދި އެއްވެސް ކަމެއް ނުހިނގައެވެ.",
      "timelineTitle": "މަރުޙަލާތައް",
      "title": "އިރުޝާދު"
    },
    "instructionStatus": {
      "approved": "ފާސްކޮށްފައި",
      "cancelled": "ބާތިލްކުރެވިފައި",
      "confirmed": "ކަށަވަރުކުރެވިފައި",
      "draft": "ދެލިކޮޕީ",
      "recall_requested": "އަނބުރާ ހޯދަން އެދިފައި",
      "recalled": "އަނބުރާ ލިބިފައި",
      "rejected": "ބޭންކުން ރައްދުކުރި",
      "released": "ބޭންކަށް ފޮނުވިފައި",
      "returned": "އަނބުރާ އައިސްފައި",
      "submitted": "ހުށަހަޅާފައި",
      "screening_hold": "ސްކްރީނިންއަށް ހިފަހައްޓާފައި"
    },
    "instructions": {
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "beneficiaryHint": "ބޭރު ފަރާތެއް. އެ ފަރާތް ކަށަވަރުކުރެވިފައިވާ ޙާލަތު ނަމުގެ ކައިރީގައި ދައްކައެވެ.",
      "caption": "ފައިސާ ފޮނުވުމުގެ އިރުޝާދުތަކާއި ކޮންމެ އެއްޗެއް އޮތް ޙާލަތު",
      "description": "ހުއްދަ މަރުޙަލާގެ ފައިސާ ފޮނުވުންތައް، ޕޯސްޓިންގތަކެއްގެ ބަދަލުގައި މަރުޙަލާތަކެއް ހުރި ލިޔުންތަކެއްގެ ގޮތުގައި.",
      "draft": "އައު އިރުޝާދު",
      "draftConfirm": "ދެލިކޮޕީ ހަދާ",
      "draftDescription": "އިރުޝާދު ދޫކުރެވެންދެން އެއްވެސް އެއްޗެއް ޕޯސްޓްނުވެ، ފައިސާވެސް ނުދާނެއެވެ.",
      "draftNote": "ދެލިކޮޕީއަކުން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުވެއެވެ. ހުށަހަޅައި، ފާސްކޮށް، ބޭންކް މެންޑޭޓަށް ސޮއިކޮށް، އެއަށްފަހު ދޫކުރެވެއެވެ.",
      "draftTitle": "އިރުޝާދެއް ދެލިކޮޕީކުރުން",
      "drafted": "އިރުޝާދު {no} ދެލިކޮޕީކުރެވިއްޖެ.",
      "emptyDescription": "ފުރަތަމަ އިރުޝާދު ދެލިކޮޕީކުރައްވާ. އެ ފާސްކޮށް، ބޭންކް މެންޑޭޓަށް ސޮއިކޮށް، ދޫކުރާނީ އެހެން ފަރާތަކުންނެވެ.",
      "emptyTitle": "އަދި އިރުޝާދެއް ނެތް",
      "loadFailed": "އެ އިރުޝާދުތައް ނުލޯޑްވި",
      "openTransit": "މަގުމަތީގައިވާ ފައިސާ",
      "tableTitle": "އިރުޝާދުތައް",
      "title": "ފައިސާ ފޮނުވުމުގެ އިރުޝާދުތައް",
      "toAccountHint": "ނުވަތަ މި ކުންފުނީގެ އެހެން އެކައުންޓެއް، އެތެރޭގެ ފައިސާ ބަދަލުކުރުމަކަށް."
    },
    "lineKind": {
      "coin": "ފައިސާ ފޮތި",
      "note": "ނޫޓު",
      "other": "އެހެނިހެން",
      "receipt_held": "ފޮށީގައި އޮތް ރަސީދު",
      "voucher": "ވައުޗަރ"
    },
    "mandate": {
      "addSignatory": "ސޮއިކުރާ ފަރާތެއް އިތުރުކުރޭ",
      "addSignatoryDescription": "ސޮއިކުރާ ފަރާތަކީ މި ނިޒާމުގެ ބޭނުންކުރާ ފަރާތެއް، ނުވަތަ ހަމައެކަނި ބޭންކުގެ ލިޔުމުގައި އޮތް ފަރާތެއް ކަމުގައިވެދާނެއެވެ.",
      "addSignatoryTitle": "ސޮއިކުރާ ފަރާތެއް އިތުރުކުރުން",
      "ceilingHint": "މެންޑޭޓްގެ ޙައްދަށްވުރެ ދަށް ޙައްދެއް. ނެތްނަމަ ހުސްކޮށް ބާއްވާ.",
      "description": "ބަލަހައްޓާ އަދަދު ބޭންޑާއި، ހިންގާ ޤަވާޢިދާއި، ސޮއި ނަގާ ޕެނަލްތައް.",
      "effectiveBar": "ޢަމަލުކުރެވޭ {from} → {to}",
      "endSignatory": "ނިންމާ",
      "endSignatoryDescription": "މިއިން ނިމޭ ތާރީޚެއް ކަނޑައެޅެއެވެ. ސަފު ދުވަހަކުވެސް ނުފުހެއެވެ — އެ ފަރާތުން ސޮއިކުރި ކަންކަން ރަޖިސްޓަރީން އެނގެން ޖެހޭނެއެވެ.",
      "endSignatoryTitle": "ސޮއިކުރާ ފަރާތުގެ ބާރު ނިންމުން",
      "loadFailed": "އެ މެންޑޭޓް ނުލޯޑްވި",
      "noCeiling": "މަތީ ޙައްދެއް ނެތް",
      "noSignatories": "މި މެންޑޭޓްގައި ސޮއިކުރާ ފަރާތެއް ނެތެވެ، އެހެންކަމުން މިއިން ފައިސާއެއް ނުފޮނުވޭނެއެވެ.",
      "openEnded": "ނިމުމެއް ނެތް",
      "panelLabel": "ޕެނަލް {panel}",
      "panelsDescription": "ކޮންމެ ފަރާތެއްގެ މަތީ ޙައްދު އެ ނަމުގެ ކައިރީގައި ދައްކައެވެ؛ އެ ސަބަބުން ދެކޮޅުހެދޭ ފައިސާ ފޮނުވުމެއް، އެ ނެތި ދޭހައެއް ނުވާނެއެވެ.",
      "panelsTitle": "ސޮއިކުރާ ޕެނަލްތައް",
      "signatoryAdded": "ސޮއިކުރާ ފަރާތް އިތުރުކުރެވިއްޖެ.",
      "signatoryEnded": "ސޮއިކުރާ ފަރާތުގެ ބާރު ނިމިއްޖެ.",
      "supersede": "ބަދަލުކުރޭ",
      "supersedeDescription": "ތިޔަ ޚިޔާރުކުރާ ތާރީޚުން ފެށިގެން އައު ވަރޝަނަކަށް ޢަމަލުކުރެވޭނެއެވެ. މި ވަރޝަން އޭގެ މުއްދަތާއެކު ކިޔޭގޮތަށް ދެމިހުންނާނެއެވެ.",
      "supersedeNote": "މެންޑޭޓެއް އެޑިޓެއް ނުކުރެއެވެ؛ ބަދަލުކުރެއެވެ — އެއިރުން \"14 މާރޗްގައި ސޮއިކުރެވެނީ ކާކަށްކަން\" ފަހުންވެސް އެނގޭނެއެވެ.",
      "supersedeTitle": "މި މެންޑޭޓް ބަދަލުކުރުން",
      "superseded": "މެންޑޭޓް ބަދަލުކުރެވިއްޖެ.",
      "termsTitle": "ޝަރުޠުތައް",
      "title": "މެންޑޭޓް"
    },
    "mandates": {
      "asOfHint": "މި ތާރީޚުގައި ޢަމަލުކުރެވުނު މެންޑޭޓްތައް ދައްކާ.",
      "canSignInApp": "އެޕުގައި",
      "caption": "އެކައުންޓާއި ޢަމަލުކުރާ މުއްދަތުން ބޭންކް މެންޑޭޓްތައް",
      "create": "އައު މެންޑޭޓް",
      "createDescription": "މެންޑޭޓަކުން ބަލަހައްޓަނީ އެއް އެކައުންޓެއްގެ، އެއް އަދަދު ބޭންޑެއް، އެއް ތާރީޚަކުން ފެށިގެންނެވެ.",
      "createTitle": "މެންޑޭޓެއް އުފެއްދުން",
      "created": "މެންޑޭޓް އުފެއްދިއްޖެ.",
      "description": "ކޮންމެ އެކައުންޓެއްގައި ބޭންކުން ޤަބޫލުކުރާ ސޮއިކުރާ ފަރާތްތަކާއި، ކިހާ އަދަދަކަށްކަން.",
      "eligibleNo": "ސޮއިއެއް ނުކުރެވޭ",
      "eligibleYes": "ސޮއިކުރެވޭ",
      "emptyDescription": "މި އެކައުންޓަށް ބޭންކުގެ މެންޑޭޓް ރެކޯޑްކުރައްވާ، އެއިރުން ފައިސާ ފޮނުވުން ބެލޭނީ މީހެއްގެ ހަނދާނަށް ނޫނެވެ.",
      "emptyTitle": "އަދި މެންޑޭޓެއް ނެތް",
      "loadFailed": "އެ މެންޑޭޓްތައް ނުލޯޑްވި",
      "maxHint": "މަތީ ޙައްދެއް ނެތްނަމަ ހުސްކޮށް ބާއްވާ.",
      "noMandate": "އެ އިރުޝާދު ބަލަހައްޓާ މެންޑޭޓެއް ނެތް",
      "paperOnly": "ހަމައެކަނި ކަރުދާސް",
      "requires": "{count} ސޮއި",
      "resolveAction": "ބަލާ",
      "resolveCaption": "އެ ތާރީޚުގައި ސޮއިކުރެވޭ ފަރާތްތައް",
      "resolveDescription": "އަދަދަކާއި، އެކައުންޓަކާއި، ތާރީޚެއް. މިއީ ހަމައެކަނި ކިޔުމެކެވެ؛ އެއްވެސް އެއްޗެއް ނުލިޔެއެވެ.",
      "resolveTitle": "މިއަށް ސޮއިކުރެވޭނީ ކާކަށް؟",
      "tableTitle": "މެންޑޭޓްތައް",
      "title": "ބޭންކް މެންޑޭޓްތައް"
    },
    "matchSetStatus": {
      "active": "ހިނގަމުންދާ",
      "released": "ދޫކޮށްލެވިފައި"
    },
    "matchSets": {
      "activate": "ސެޓް ހިންގާ",
      "activated": "ސެޓް {no} ހިނގަން ފަށައިފި.",
      "backToSession": "ސެޝަނަށް އެނބުރި",
      "description": "ތިން ސްޓޭޓްމަންޓް ސަފު، އެއް ޖާނަލް ސަފާ، ނުވަތަ އެކެއް ފަހަކާ. ސެޓެއް ހިނގަން ފަށާނީ ދިމާވުމުންނެވެ.",
      "difference": "ފަރަޤު",
      "empty": "މި ސެޝަނުގައި މެޗް ސެޓެއް ނެތެވެ.",
      "existingCaption": "މި ސެޝަނުގެ މެޗް ސެޓްތައް",
      "existingTitle": "މިހާރު ހުރި ސެޓްތައް",
      "ledgerCaption": "މި ސެޝަނުގައި މެޗްނުވާ ލެޖަރ ސަފުތައް",
      "ledgerEmpty": "މެޗްނުވާ ލެޖަރ ސަފެއް ނެތެވެ.",
      "ledgerSide": "ލެޖަރ ސަފުތައް",
      "ledgerTotal": "ލެޖަރ",
      "loadFailed": "އެ ސެޝަން ނުލޯޑްވި",
      "openLink": "މެޗް ސެޓްތައް",
      "pick": "ޚިޔާރުކުރޭ",
      "release": "ސެޓް ދޫކޮށްލާ",
      "releaseNote": "ސެޓްގެ ކޮންމެ ބައެއް ދޫކޮށްލުމުން މުޅި ސެޓް ދޫވެއެވެ — އެއް ސަފު މަދުވެއްޖެނަމަ ސެޓް ދިމައެއް ނުވާނެއެވެ.",
      "released": "ސެޓް ދޫކޮށްލެވިއްޖެ.",
      "setNo": "ސެޓް",
      "shape": "ބައްޓަން",
      "sides": "ސްޓޭޓްމަންޓް {statement}، {statementCount} ސަފު · ލެޖަރ {ledger}، {ledgerCount} ސަފު",
      "statementCaption": "މި ސެޝަނުގައި މެޗްނުވާ ސްޓޭޓްމަންޓް ސަފުތައް",
      "statementEmpty": "މެޗްނުވާ ސްޓޭޓްމަންޓް ސަފެއް ނެތެވެ.",
      "statementSide": "ސްޓޭޓްމަންޓް ސަފުތައް",
      "statementTotal": "ސްޓޭޓްމަންޓް",
      "title": "މެޗް ސެޓްތައް"
    },
    "maturity": {
      "asOfHint": "ބައިކުރެވެނީ މި ތާރީޚަށެވެ، ފައިސާ ނެގި ދުވަހަކަށް ނޫނެވެ.",
      "description": "ބެލެންސް ޝީޓަށް ބޭނުންވާ މިއަހަރު އަދި ފަހުން އަދާކުރަންޖެހޭ ބައިކުރުމާއި، އޭގެ ފަހަތުގައިވާ ސިޑި.",
      "empty": "މި ތާރީޚުގައި ދައްކަން ބާކީ ދަރަންޏެއް ނެތެވެ.",
      "facilitiesCaption": "ދައްކަން ބާކީ އަސްލު ފައިސާ، މިއަހަރާއި ފަހުގެ ބަޔަށް",
      "facilitiesTitle": "ފެސިލިޓީން",
      "inBase": "{currency} އިން",
      "ladderCaption": "ބޭންޑުން ދައްކަންޖެހޭ އަސްލު ފައިސާއާއި އިންޓަރެސްޓް",
      "ladderTitle": "ހަމަވާ މުއްދަތުގެ ސިޑި",
      "loadFailed": "އެ ރިޕޯޓް ނުލޯޑްވި",
      "splitNote": "{asOf} ން ފެށިގެން ބާރަ މަސް ތެރޭ ދައްކަންޖެހޭ ޤިސްތަކީ މިއަހަރުގެ ބައެވެ. އެ ޤިސްތު އަހަރެއް ކުރިން ވީ ފަހުގެ ބައެއް ކަމުގައެވެ.",
      "title": "ދަރަނި ހަމަވާ މުއްދަތު"
    },
    "maturityBands": {
      "months0to3": "3 މަސް ތެރޭ",
      "months3to12": "3 އިން 12 މަހަށް",
      "over5": "5 އަހަރަށްވުރެ ދިގު",
      "years1to2": "1 އިން 2 އަހަރަށް",
      "years2to5": "2 އިން 5 އަހަރަށް"
    },
    "poolRole": {
      "header": "ޕޫލްގެ މައި",
      "none": "ޕޫލްކޮށްފައެއް ނުވޭ",
      "participant": "ޕޫލްގައި ބައިވެރި"
    },
    "position": {
      "alreadyPublished": "{date} މިހާރުވެސް ޝާއިޢުކުރެވިފައިވެއެވެ. ދައްކާފައި މިވަނީ އެ ރަން އެވެ.",
      "blocked": "އުނި: ހިފެހެއްޓިފައި",
      "bridgeAction": "ބްރިޖް",
      "bridgeTitle": "ލެޖަރުން ބޭންކަށް",
      "correctionCodes": {
        "backdated_journal": "ފަހަތުގެ ތާރީޚަކަށް ޖާނަލެއް ޕޯސްޓްކުރެވުނު",
        "corrected_fx_rate": "ބަދަލުކުރާ ރޭޓެއް އިޞްލާޙުކުރެވުނު",
        "late_statement": "ފަހުން ސްޓޭޓްމަންޓެއް ލިބުނު",
        "observation_restated": "ބޭންކުގެ އޮބްޒަވޭޝަނެއް އަލުން ބަޔާންކުރެވުނު",
        "other": "އެހެނިހެން"
      },
      "currencyCaption": "ފައިސާގެ ބާވަތުން ޖުމްލަ",
      "currentVersion": "މިހާރުގެ",
      "description": "ޝާއިޢުކުރި ވަގުތުގައި ފްރީޒްކުރެވިފައިވާ ފައިސާގެ ޙާލަތު.",
      "export": "ސީއެސްވީ އެކްސްޕޯޓް",
      "exported": "ޕޮޒިޝަން ފައިލަކަށް ލިޔެވިއްޖެ.",
      "headlineTitle": "އަސާސް ބަހާލައިގެން ޖުމްލަ",
      "holdersCaption": "ފައިސާ ހުރި ކޮންމެ ތަނެއްގެ ބާކީ، އަސާސުން",
      "holdersDescription": "ކޮންމެ ބޭންކް އެކައުންޓަކާއި ވޮލެޓެއް، ހަތަރު އަސާސާއި ކޮންމެ އަސާސެއްގެ މަޞްދަރާއެކު.",
      "holdersEmpty": "މި ރަންގައި ފައިސާ ހުރި ތަނެއް ނެތެވެ.",
      "holdersTitle": "ފައިސާ ހުރި ތަންތަން",
      "immutableNote": "ޝާއިޢުކުރެވިފައިވާ ޕޮޒިޝަނެއް އެޑިޓެއް ނުކުރެވޭނެއެވެ. އިޞްލާޙުކުރަން އައު ވަރޝަނެއް ޝާއިޢުކުރައްވާ — ކުރީގެ ވަރޝަން ކިޔޭގޮތަށް ދެމިހުންނާނެއެވެ.",
      "inBase": "{currency} އިން",
      "loadFailed": "އެ ޕޮޒިޝަން ނުލޯޑްވި",
      "origin": {
        "manual": "އަތުން",
        "scheduled": "ތާވަލުކުރެވިފައި"
      },
      "overdraftLimit": "އިތުރު: އޯވަޑްރާފްޓް ޙައްދު",
      "partial": "މި ހިސާބުކުރި ވަގުތު ބައެއް މަޞްދަރުތައް ނުލިބުނު ކަމަށްވާތީ އަދަދުތައް ފުރިހަމައެއް ނޫނެވެ:",
      "previewBanner": "މިއީ ލައިވް އަދަދެކެވެ؛ ބަދަލުވެދާނެއެވެ. ޝާއިޢުކުރެވުނު ޕޮޒިޝަނެއްގެ ގޮތުގައި ބޭނުމެއް ނުކުރެވޭނެ — ފުރަތަމަ ޝާއިޢުކުރައްވާ.",
      "previewDescription": "މިހާރުގެ މަޢުލޫމާތުން ހިސާބުކުރެވިފައި. މީގެ އެއްވެސް އެއްޗެއް ޝާއިޢުކޮށްފައެއް ނުވޭ.",
      "previewTitle": "ފައިސާގެ ޙާލަތު — ލައިވް",
      "publish": "ޝާއިޢުކުރޭ",
      "published": "{date} ގެ ޕޮޒިޝަން ޝާއިޢުކުރެވިއްޖެ.",
      "publishedBy": "{at} ގައި {who} ޝާއިޢުކުރި",
      "publishedValue": "ޝާއިޢުކުރި",
      "recomputedValue": "އަލުން ހިސާބުކުރި",
      "republish": "އިޞްލާޙެއް ޝާއިޢުކުރޭ",
      "republishConfirm": "ވަރޝަން ޝާއިޢުކުރޭ",
      "republishDescription": "މިއިން އައު ވަރޝަނެއް އުފެދޭނެއެވެ. ސްކްރީނުގައިވާ ވަރޝަން ބަދަލުނުވެ ކިޔޭގޮތަށް ދެމިހުންނާނެއެވެ.",
      "republishTitle": "އިޞްލާޙުކުރާ ވަރޝަނެއް ޝާއިޢުކުރުން",
      "republished": "{date} ގެ ވަރޝަން {version} ޝާއިޢުކުރެވިއްޖެ.",
      "status": {
        "draft": "ދެލިކޮޕީ",
        "live": "ލައިވް",
        "published": "ޝާއިޢުކުރެވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "supersededVersion": "ބަދަލުކުރެވިފައި",
      "title": "{date} ގެ ފައިސާގެ ޙާލަތު",
      "uncleared": "ކްލިއަރ ނުވާ ފައިސާ",
      "unpresented": "އިތުރު: ބޭންކަށް ނުދާ",
      "unrecorded": "އުނި: ފޮތުގައި ނުޖަހާ",
      "verify": "ކަށަވަރުކުރޭ",
      "verifyCaption": "އަލުން ހިސާބުކުރުމުން ފެނުނު ތަފާތުތައް",
      "verifyHashes": "ޝާއިޢުކުރި {published} · އަލުން ހިސާބުކުރި {recomputed}",
      "verifyOutcome": {
        "matched": "ރަން، އޭގެ އަމިއްލަ ވޯޓަރމާކްގެ ތެރޭގައި ސީދާ ހަމަ އެގޮތަށް ލިބިއްޖެއެވެ.",
        "mismatch": "ރަން އަލުން ހަމަ އެގޮތަށް ނުލިބުނެވެ. މިއަށް ބިނާވި އެއްޗެއް ފަހުން ބަދަލުވެފައިވެއެވެ.",
        "unverifiable": "ރަން ކަށަވަރެއް ނުކުރެވޭނެއެވެ — ބޭނުންކުރި މަޞްދަރެއް މިހާރު ނުލިބެއެވެ."
      },
      "verifyTitle": "ކަށަވަރުކުރުމުގެ ރިޕޯޓް",
      "versionLabel": "ވަރޝަން {version}",
      "versionsDescription": "އިޞްލާޙަކީ އައު ވަރޝަނެކެވެ. ފުރަތަމަ ވަރޝަން ޝާއިޢުކުރި ގޮތަށް ދެމިއޮންނާނެއެވެ.",
      "versionsTitle": "ވަރޝަންތައް",
      "viewDiff": "ބަދަލުވި ތަންތަން"
    },
    "positions": {
      "currentFailed": "މިހާރުގެ ޕޮޒިޝަން ނުލޯޑްވި",
      "currentTitle": "މިހާރު ޝާއިޢުކުރެވިފައިވާ ޕޮޒިޝަން",
      "description": "ކޮންމެ ތާރީޚެއްގައި ފައިސާގެ ޙާލަތު ހުރި ގޮތް، އަދި އޭގެ ފަހުން އަލުން ހިސާބުކޮށްފައެއް ނުވެއެވެ.",
      "empty": "މި ފިލްޓަރތަކާ ދިމާވާ ޕޮޒިޝަނެއް ނެތެވެ.",
      "historyCaption": "ޝާއިޢުކުރެވުނު ޕޮޒިޝަން ރަންތައް",
      "historyTitle": "ތާރީޚު",
      "includeSuperseded": "ބަދަލުކުރެވުނު ވަރޝަންތައްވެސް ދައްކާ",
      "loadFailed": "އެ ޕޮޒިޝަންތައް ނުލޯޑްވި",
      "neverPublishedDescription": "ތިރީގައިވާ ތާރީޚަކަށް ޕޮޒިޝަނެއް ޝާއިޢުކުރައްވާ، ނުވަތަ މިވަގުތުގެ ޙާލަތު ބެލުމަށް ލައިވް ޕޮޒިޝަން ހުޅުއްވާ.",
      "neverPublishedTitle": "އަދި އެއްވެސް އެއްޗެއް ޝާއިޢުކޮށްފައެއް ނުވޭ",
      "openPreview": "ލައިވް ޕޮޒިޝަން",
      "publishDescription": "ޝާއިޢުކުރެވުނު ތާރީޚެއް ދާއިމަށް ފްރީޒްވެއެވެ. އެއް ތާރީޚެއް ދެފަހަރު ޝާއިޢުކުރުމުން ލިބޭނީ މިހާރުވެސް އޮތް ރަން އެވެ.",
      "publishTitle": "ޕޮޒިޝަނެއް ޝާއިޢުކުރުން",
      "title": "ޝާއިޢުކުރެވުނު ޕޮޒިޝަންތައް"
    },
    "postingStatus": {
      "draft": "ދެލިކޮޕީ",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "reversed": "އަނބުރާ ރައްދުކުރެވިފައި",
      "cancelled": "ކެންސަލް ކުރެވިފައި",
      "in_transit": "ޓްރާންސިޓުގައި",
      "pending_approval": "ތާއީދަށް މަޑުކުރަނީ"
    },
    "provenance": {
      "derived": "ނެގުނު",
      "ledger": "ލެޖަރުން",
      "observation": "އޮބްޒަވޭޝަނަކުން",
      "statement": "ސްޓޭޓްމަންޓުން",
      "unavailable": "މަޞްދަރެއް ނެތް"
    },
    "rateKind": {
      "fixed": "ފިކްސްޑް",
      "floating": "ފްލޯޓިން"
    },
    "rejectReasons": {
      "duplicate": "ދެފަހަރު",
      "no_evidence": "ހެއްކެއް ނެތް",
      "not_business_expense": "ވިޔަފާރީގެ ޚަރަދެއް ނޫން",
      "other": "އެހެނިހެން",
      "over_limit": "ލިމިޓަށްވުރެ މަތި"
    },
    "releaseReasons": {
      "contract_signed": "ކޮންޓްރެކްޓްގައި ސޮއިކުރެވިފައި",
      "other": "އެހެނިހެން",
      "payroll_deadline": "މުސާރައިގެ މުއްދަތު",
      "statutory_deadline": "ޤާނޫނީ މުއްދަތު",
      "verified_by_callback": "ގުޅައިގެން ކަށަވަރުކުރެވިފައި"
    },
    "reopenReasons": {
      "audit_finding": "އޮޑިޓް ފާހަގައެއް",
      "late_statement": "ފަހުން ސްޓޭޓްމަންޓެއް ލިބުނު",
      "mismatched_match": "މެޗެއް ގޯސްވި",
      "other": "އެހެނިހެން",
      "wrong_period": "މުއްދަތު ގޯސް"
    },
    "replenishmentStatus": {
      "approved": "ފާސްކޮށްފައި",
      "draft": "ދެލިކޮޕީ",
      "funded": "ފައިސާ ދެވިފައި",
      "rejected": "ރައްދުކުރެވިފައި",
      "submitted": "ހުށަހަޅާފައި"
    },
    "routeTitles": {
      "beneficiaries": "ފައިސާ ދާ ފަރާތްތައް",
      "beneficiary": "ފައިސާ ދާ ފަރާތް",
      "beneficiaryChanges": "ފައިސާ ދާ ފަރާތުގެ ބަދަލުތައް",
      "certificate": "ރިކޮންސިލިއޭޝަން ސެޓްފިކެޓް",
      "covenants": "ކޮވިނަންޓްތައް",
      "debtMaturity": "ދަރަނި ހަމަވާ މުއްދަތު",
      "facilities": "ދަރަނީގެ ފެސިލިޓީތައް",
      "facility": "ދަރަނީގެ ފެސިލިޓީ",
      "forecast": "ލަފާކުރުން",
      "forecastAccuracy": "ލަފާކުރުމުގެ ސީދާކަން",
      "forecasts": "ޝާއިޢުކުރެވުނު ލަފާކުރުންތައް",
      "fundsInTransit": "މަގުމަތީގައިވާ ފައިސާ",
      "instruction": "ފައިސާ ފޮނުވުމުގެ އިރުޝާދު",
      "instructions": "ފައިސާ ފޮނުވުމުގެ އިރުޝާދުތައް",
      "mandate": "ބޭންކް މެންޑޭޓް",
      "mandates": "ބޭންކް މެންޑޭޓްތައް",
      "matchSets": "މެޗް ސެޓްތައް",
      "position": "ޕޮޒިޝަން",
      "positionDiff": "ޕޮޒިޝަންގެ ތަފާތު",
      "positionPreview": "ފައިސާގެ ޙާލަތު (ލައިވް)",
      "positions": "ޝާއިޢުކުރެވުނު ޕޮޒިޝަންތައް",
      "scenarios": "ލަފާކުރުމުގެ ސިނާރިއޯތައް",
      "settings": "ޓްރެޜަރީ ސެޓިންގްސް",
      "standingRules": "ދާއިމީ ޤަވާޢިދުތައް",
      "wallet": "ވޮލެޓް",
      "walletApprovals": "ވޮލެޓް ފާސްކުރުން",
      "walletBalances": "ވޮލެޓް ބާކީ",
      "walletCount": "ފައިސާ ގުނުން",
      "wallets": "ވޮލެޓްތައް",
      "concentration": "ކޭޝް ކޮންސެންޓްރޭޝަން",
      "accrualRun": "އެކުލެވުމުގެ ރަން",
      "accrualRuns": "އިންޓަރެސްޓް އެކުލެވުން",
      "positionGroup": "ގްރޫޕްގެ ނަގުދު ހާލަތު",
      "liquidity": "ލިކުއިޑިޓީ ދިރާސާ",
      "liquidityGap": "ލިކުއިޑިޓީ ހުސްކަން",
      "walletFunding": "ވޮލެޓަށް ފައިސާ ލިބުން",
      "bankConnections": "ބޭންކް ކަނެކްޝަންތައް",
      "intercompanyInstruments": "އިންޓަރކޮމްޕެނީ ފަންޑިންގ",
      "screeningLists": "ސްކްރީނިންގ ލިސްޓްތައް",
      "reconciliationExceptions": "ރިކޮންސިލިއޭޝަން އިސްތިސްނާތައް",
      "walletCounts": "ފައިސާ ގުނުން",
      "walletExpenditure": "ޚަރަދު ރެކޯޑްކުރުން"
    },
    "scenarios": {
      "assumptionNote": "ސިނާރިއޯއަކީ ލަފައެކެވެ، މަޢުލޫމާތުގެ ދެވަނަ ކޮޕީއެއް ނޫނެވެ. އެހެންވެ އަސާސީއާއި ދަތި ސިނާރިއޯ އަޅާކިޔޭނެއެވެ.",
      "assumptions": "ލަފާކުރުންތައް",
      "caption": "ސިނާރިއޯތަކާއި ކޮންމެ އެއްޗެއް ބޭނުންކުރާ ލަފާކުރުންތައް",
      "create": "އައު ސިނާރިއޯ",
      "createTitle": "ސިނާރިއޯއެއް އުފެއްދުން",
      "default": "ޑިފޯލްޓް",
      "description": "އެއް ދައްކަންޖެހޭ ތާވަލުތަކަކަށް ބޭނުންކުރެވޭ، ނަން ދެވިފައިވާ ލަފާކުރުންތަކެއް.",
      "dialogDescription": "ފަސް ލަފައެއް. މިތަނުން އިންވޮއިސްއެއް އެޑިޓްކުރެވޭ ގޮތެއް ގަސްދުގައި ނުބާއްވަމެވެ.",
      "editTitle": "ސިނާރިއޯ އެޑިޓްކުރުން",
      "emptyDescription": "އަސާސީ ސިނާރިއޯގެ ކައިރީގައި ދަތި ސިނާރިއޯއެއް ހައްދަވާ، އެއިރުން އެއް ޙަޤީޤަތްތަކަކުން ދެ ގޮތްވެސް ފެންނާނެއެވެ.",
      "emptyTitle": "އަދި ސިނާރިއޯއެއް ނެތް",
      "haircut": "ލިބޭ ފައިސާއިން އުނިކުރެވެނީ",
      "haircutHint": "ލިބޭ ފައިސާގެ ބައެއް އެކަނި ލިބޭނެ ކަމަށް ލަފާކުރޭ. 10% އަށް 10 ލިޔުއްވާ.",
      "haircutRange": "އިންސައްތަ 0 އާއި 100 އާ ދެމެދު ހުންނަންވާނެއެވެ.",
      "includeOverdue": "މުއްދަތު ފަހަނައަޅާފައިވާ ފައިސާ އަދިވެސް ލިބޭނެ",
      "loadFailed": "އެ ސިނާރިއޯތައް ނުލޯޑްވި",
      "makeDefault": "މިއީ ޑިފޯލްޓް ސިނާރިއޯ ކަމުގައި ހަދާ",
      "multiplierHint": "100 އިން ތަކުރާރު ޚަރަދު ބަދަލެއް ނުވާނެއެވެ؛ 110 އިން 10% އިތުރުވާނެއެވެ.",
      "multiplierRange": "އިންސައްތަ 0 އާއި 500 އާ ދެމެދު ހުންނަންވާނެއެވެ.",
      "overdue": "މުއްދަތު ފަހަނައަޅާފައިވާ ފައިސާ",
      "overdueExcluded": "ނުލިބޭނެ ކަމަށް",
      "overdueIncluded": "އަދިވެސް ލިބޭނެ",
      "payableDelay": "އަހަރެމެން {days} ދުވަސް ފަހުން ދައްކާ",
      "receivableDelay": "ކަސްޓަމަރުން ޝަރުޠަށްވުރެ {days} ދުވަސް ފަހުން ދައްކާ",
      "receivableDelayHint": "ކަސްޓަމަރުން އެ ފަރާތްތަކުގެ ޝަރުޠަށްވުރެ މިވަރަށް ފަހުން ދައްކާނެ ކަމަށް ލަފާކުރޭ.",
      "recurringMultiplier": "ތަކުރާރު ޚަރަދު ބަދަލުކުރެވެނީ",
      "saved": "ސިނާރިއޯ ރައްކާކުރެވިއްޖެ.",
      "tableTitle": "ސިނާރިއޯތައް",
      "title": "ލަފާކުރުމުގެ ސިނާރިއޯތައް",
      "type": "ބާވަތް",
      "typeHint": "އަސާސީ ސިނާރިއޯ މިތަނުން ނުހޮވޭ: ސިނާރިއޯއެއް އަސާސީ ކަމަށް ވާނީ ހުއްދަދެވުނު ޕްރޮމޯޝަނަކުންނެވެ.",
      "types": {
        "base": "އަސާސީ",
        "upside": "އަޕްސައިޑް",
        "downside": "ޑައުންސައިޑް",
        "stress": "ސްޓްރެސް",
        "what_if": "ވަޓް-އިފް"
      },
      "baseByPromotion": "ސިނާރިއޯއެއް ހުއްދަދެވުނު އަސާސީ ކަމަށް ވާނީ ޕްރޮމޯޓްކުރުމުންނެވެ. އެކަމަށް ދެވަނަ މީހެއްގެ ހުއްދަ ބޭނުންވެއެވެ.",
      "awaitingApproval": "ޕްރޮމޯޝަން ހުއްދަ ލިބުމަށް މަޑުކުރަނީ",
      "superseded": "ބަދަލުކުރެވުނު އަސާސީ",
      "frozen": "މި ސިނާރިއޯގެ ޕްރޮމޯޝަނެއް ނިންމުމަށް މަޑުކުރާތީ އެ އެޑިޓްކުރެވޭކަށް ނެތް.",
      "pendingBanner": "{name} އަސާސީ ސިނާރިއޯގެ ބަދަލުގައި ބެހެއްޓުމަށް މަޑުކުރަނީ. {by} އެދުނު. ދެވަނަ މީހަކު ހުއްދަ ނުދެއްވަންދެން މިހާރުގެ އަސާސީ ބަދަލެއް ނުވޭ.",
      "toApprovals": "އެޕްރޫވަލް އިންބޮކްސް ހުޅުވާ",
      "promote": "އަސާސީއަށް ޕްރޮމޯޓްކުރޭ",
      "promoteTitle": "{name} އަސާސީއަށް ޕްރޮމޯޓްކުރޭ",
      "promoteDescription": "މިއީ ސިނާރިއޯ ޕްލޭނިންގ އަސާސީގެ ބަދަލުގައި ބެހެއްޓުމަށް އެދުމެވެ. ދެވަނަ މީހަކު ހުއްދަ ނުދެއްވަންދެން އެއްވެސް ބަދަލެއް ނުވާނެ، މިހާރުގެ އަސާސީ ބާކީ ހުންނާނެ.",
      "promoteRequest": "ޕްރޮމޯޝަނަށް އެދޭ",
      "promoteRequested": "ޕްރޮމޯޝަނަށް އެދިފައިވާއިރު ހުއްދަ ލިބުމަށް މަޑުކުރަނީ.",
      "withdraw": "ޕްރޮމޯޝަން ނަގާ",
      "withdrawTitle": "{name} ގެ ޕްރޮމޯޝަން ނަގާ",
      "withdrawDescription": "އެދުން ބާތިލްވެ ސިނާރިއޯ އަލުން އެޑިޓްކުރެވޭނެ.",
      "withdrawNote": "ކީއްވެގެން ނަގަނީ",
      "promotionWithdrawn": "ޕްރޮމޯޝަން ނެގި.",
      "historyTitle": "ޕްރޮމޯޝަން ތާރީޚު",
      "historyDescription": "ޕްލޭނިންގ އަސާސީ ބަދަލުކުރުމަށް އެދުނު ކޮންމެ އެދުމެއް، ނިންމި ނުވަތަ ނުނިންމި.",
      "historyLoadFailed": "ޕްރޮމޯޝަން ތާރީޚު ލޯޑުނުވި",
      "historyEmpty": "އަދި އެއްވެސް ސިނާރިއޯއެއް އަސާސީގެ ގޮތުގައި ހުށަހަޅާފައެއް ނުވޭ.",
      "requested": "އެދުނު",
      "decided": "ނިންމި",
      "promotionStatuses": {
        "pending": "މަޑުކުރަނީ",
        "approved": "ހުއްދަ ދެވުނު",
        "rejected": "ރަދުކުރި",
        "cancelled": "ނެގި"
      }
    },
    "scheduleMethod": {
      "annuity": "އެއްވަރު ޤިސްތު",
      "bullet": "ނިމޭ ދުވަހު އެއްކޮށް",
      "equal_principal": "އެއްވަރު އަސްލު ފައިސާ"
    },
    "scheduleStatus": {
      "paid": "ދައްކާފައި",
      "partly_paid": "ބައެއް ދައްކާފައި",
      "scheduled": "ތާވަލުކުރެވިފައި",
      "superseded": "ބަދަލުކުރެވިފައި",
      "waived": "މާފުކުރެވިފައި"
    },
    "sessionStatus": {
      "closed": "ބަންދުކުރެވިފައި",
      "open": "ހުޅުވިފައި"
    },
    "settings": {
      "accountsFooter": "ބޭނުންވާ އެކައުންޓެއް ނެތްނަމަ ޕޯސްޓްކުރުން ދެކޮޅުހަދާ، އެ އެކައުންޓް ބުނެދޭނެއެވެ.",
      "accountsTitle": "ލެޖަރ އެކައުންޓާއި ޢަމަލުކުރާ ގޮތް",
      "autoPublish": "ކޮންމެ ރެއަކު އަމިއްލައަށް ޕޮޒިޝަނެއް ޝާއިޢުކުރޭ",
      "borrowings": "ނަގާފައިވާ ދަރަނި",
      "borrowingsCurrent": "ދަރަނީގެ މިއަހަރު އަދާކުރަންޖެހޭ ބައި",
      "coolingActive": "ހިނގާ",
      "coolingActiveLabel": "މި ސިޔާސަތު ހިނގަމުންދޭ",
      "coolingCaption": "ކޮންމެ މައުޟޫޢަކަށް މަޑުކުރުމުގެ ސިޔާސަތު",
      "coolingDescription": "އެއް ޓައިމަރ، ސަޕްލަޔަރގެ ބޭންކް ތަފްޞީލާއި، ފައިސާ ދާ ފަރާތްތަކާއި، ކުންފުނީގެ އަމިއްލަ އެކައުންޓްތަކަށްވެސް.",
      "coolingEditDescription": "ފާސްވި ބަދަލެއް މެދުވެރިކޮށް ފައިސާ ދިޔުމުގެ ކުރިން މަޑުކުރާނެ މުއްދަތު.",
      "coolingEditTitle": "މަޑުކުރުމުގެ މުއްދަތު ބަދަލުކުރުން",
      "coolingEmpty": "މަޑުކުރުމުގެ މައުޟޫޢެއް ރަޖިސްޓަރީކޮށްފައެއް ނުވެއެވެ.",
      "coolingOff": "ނިއްވާފައި",
      "coolingSaved": "ސިޔާސަތު ރައްކާކުރެވިއްޖެ.",
      "coolingTitle": "މަޑުކުރުމުގެ ސިޔާސަތުތައް",
      "coolingZero": "ސިޔާސަތު ހިނގާއިރު ސުން ގަޑިއިރަކީ، ހިނގާކަމަށް ދައްކާ ނަމަވެސް ޙަޤީޤަތުގައި ނުހިނގާ ކޮންޓްރޯލެކެވެ. އޭގެ ބަދަލުގައި ސިޔާސަތު ނިއްވާލައްވާ.",
      "description": "ޓްރެޜަރީން ޕޯސްޓްކުރާ އެކައުންޓްތަކާއި، ފައިސާ ފޮނުވުން ބަލަހައްޓާ ގޮތާއި، އެ ދޭއްޗަށްވެސް ހިނގާ ކޮންޓްރޯލްތައް.",
      "duplicateWindow": "ދެފަހަރު ބަލާ މުއްދަތު (ގަޑިއިރު)",
      "duplicateWindowHint": "މި މުއްދަތުގެ ތެރޭގައި އެއްގޮތް އިރުޝާދެއް ދެކޮޅުހެދޭނެއެވެ، ސަބަބަކާއެކު ފަހަނައެޅޭ ގޮތަށެވެ. 0 އިން ނިއްވާލެވެއެވެ.",
      "escrowHint": "އެސްކްރޯ އެކައުންޓަކީ އެހެން ފަރާތަކަށްޓަކައި ބަހައްޓާ ފައިސާއެވެ.",
      "escrowWarning": "އެސްކްރޯ އެކައުންޓެއްގެ ބާކީ ކިތަންމެ ބޮޑަސް، ބޭނުންކުރެވޭ ފައިސާގެ ތެރެއަކަށް ނުހިމެނޭނެއެވެ.",
      "facilityFee": "ފެސިލިޓީ އަދި ކޮމިޓްމަންޓް ފީ",
      "fundsInTransit": "މަގުމަތީގައިވާ ފައިސާ",
      "fundsInTransitHint": "ފޮނުވިފައި ކަށަވަރުނުވާ ފައިސާ ހުންނަ އެކައުންޓް.",
      "inTransitAlert": "މަގުމަތީގައި އިންޒާރު (ދުވަސް)",
      "interestExpense": "އިންޓަރެސްޓް ޚަރަދު",
      "interestPayable": "ދައްކަންޖެހޭ އިންޓަރެސްޓް",
      "loadFailed": "އެ ސެޓިންގްސް ނުލޯޑްވި",
      "observationDescription": "އެއް އެކައުންޓަކާއި ތާރީޚަކަށް އަލުން ބެލުމުން ކުރީގެ ކިޔުން އިޞްލާޙުވެއެވެ؛ ދެވަނަ އެއްޗެއް އިތުރެއް ނުވެއެވެ.",
      "observationRecorded": "އޮބްޒަވޭޝަން ރެކޯޑްކުރެވިއްޖެ.",
      "observationTitle": "ބޭންކް ބާކީއެއް ރެކޯޑްކުރުން",
      "observationsCaption": "ތާރީޚުން ރެކޯޑްކުރެވިފައިވާ ބޭންކް ބާކީ",
      "observationsDescription": "ބޭންކުން ބުނާ ބާކީ. އޮބްޒަވޭޝަނަކުން ލެޖަރަށް އަސަރެއް ނުކުރެއެވެ؛ ޕޮޒިޝަނުން ބޭނުންކުރި އޮބްޒަވޭޝަން ބުނެދެއެވެ.",
      "observationsEmpty": "އޮބްޒަވޭޝަނެއް ރެކޯޑްކޮށްފައެއް ނުވެއެވެ.",
      "observationsTitle": "ބޭންކް ބާކީގެ އޮބްޒަވޭޝަން",
      "recordObservation": "އޮބްޒަވޭޝަނެއް ރެކޯޑްކުރޭ",
      "saved": "ޓްރެޜަރީ ސެޓިންގްސް ރައްކާކުރެވިއްޖެ.",
      "sourceRefHint": "އަދަދު ލިބުނު ތަން — ޕޯޓަލްގެ ސްކްރީންޝޮޓެއް، ފޯނު ކޯލެއް، ސްޓޭޓްމަންޓް ނަންބަރެއް.",
      "tabs": {
        "accounts": "އެކައުންޓާއި ގޮތްތައް",
        "coolingOff": "މަޑުކުރުމުގެ ސިޔާސަތުތައް",
        "observations": "ބާކީގެ އޮބްޒަވޭޝަން",
        "profiles": "ބޭންކް އެކައުންޓް ޕްރޮފައިލް"
      },
      "title": "ޓްރެޜަރީ ސެޓިންގްސް",
      "walletClearing": "ވޮލެޓް ކްލިއަރިން",
      "walletCountInterval": "ވޮލެޓް ގުނާ މުއްދަތު (ދުވަސް)",
      "walletFloat": "ވޮލެޓް ފްލޯޓް",
      "walletVariance": "ފައިސާ ގުނުމުގެ ފަރަޤު"
    },
    "signingRule": {
      "a_plus_b": "އޭ އިން އެކަކު، ބީ އިން އެކަކު",
      "all": "ހުރިހާ ސޮއިކުރާ ފަރާތްތައް",
      "any": "ކޮންމެ ސޮއިކުރާ ފަރާތްތަކެއް"
    },
    "standingRules": {
      "accountHint": "ކުންފުނީގެ ހުރިހާ ބޭންކް އެކައުންޓަކަށް ހިންގުމަށް ހުސްކޮށް ބާއްވާ.",
      "anyDirection": "ކޮންމެ މިސްރާބެއް",
      "autoWarning": "މީހަކާ ނުލައި ޕޯސްޓްކުރާ ޤަވާޢިދަކުން، މީހަކު ނުބަލާ ލެޖަރަށް ޕޯސްޓްކުރެއެވެ. މަތީ ޙައްދެއް ބޭނުންވެއެވެ، އަދި ގުޅުމާމެދު ޝައްކުހުރި ސްޓޭޓްމަންޓަކަށް ނުހިނގާނެއެވެ.",
      "caption": "ދާއިމީ ޤަވާޢިދުތަކާއި ކޮންމެ އެއްޗެއް ޕޯސްޓްކުރާ ގޮތް",
      "ceiling": "މަތީ ޙައްދު",
      "ceilingHint": "މީހަކާ ނުލައި މި ޤަވާޢިދުން އެއް ސަފަކަށް ޕޯސްޓްކުރެވޭނެ އެންމެ މަތީ އަދަދު.",
      "create": "އައު ޤަވާޢިދު",
      "createDescription": "ހުސްނޫން ހުރިހާ ޝަރުޠެއް ފުރިހަމަވާން ޖެހެއެވެ. ޝަރުޠެއް ނެތް ޤަވާޢިދަކުން ކޮންމެ ސަފެއް އެއް އެކައުންޓަކަށް ޕޯސްޓްވާނެއެވެ.",
      "createTitle": "ދާއިމީ ޤަވާޢިދެއް އުފެއްދުން",
      "description": "ތަކުރާރުވާ ބޭންކް ސަފެއް ޕޯސްޓިންގއަކަށް ބަދަލުކުރޭ، ޓެކްސްގެ ގޮތް ލަފާކުރުމުގެ ބަދަލުގައި ބަޔާންކޮށްފައި.",
      "descriptionPattern": "ތަފްޞީލުގައި ހިމެނޭ",
      "direction": "މިސްރާބު",
      "directionIn": "ވަންނަ ފައިސާ",
      "directionOut": "ނުކުންނަ ފައިސާ",
      "dryRun": "ޓެސްޓް ރަން",
      "dryRunCaption": "މި ޤަވާޢިދާ ދިމާވާނެ ސްޓޭޓްމަންޓް ސަފުތައް",
      "dryRunDescription": "އެންމެފަހުގެ ސްޓޭޓްމަންޓްތަކުގައި. އެއްވެސް އެއްޗެއް ނުލިޔެ، ޕޯސްޓްވެސް ނުކުރެއެވެ.",
      "dryRunEmpty": "ބެލި ސްޓޭޓްމަންޓްތަކުން މި ޤަވާޢިދާ އެއްވެސް އެއްޗެއް ދިމައެއް ނުވެއެވެ.",
      "dryRunSummary": "{statements} ސްޓޭޓްމަންޓް، {lines} ސަފު ބެލި، {hits} ދިމާވި.",
      "dryRunTitle": "މި ޤަވާޢިދާ ދިމާވީސް ސަފުތައް",
      "dryRunTotals": "ޖުމްލަ",
      "dryRunWritesNothing": "މިއީ ރިޕޯޓެކެވެ. އެއްވެސް އެއްޗެއް ނުލިޔެއެވެ.",
      "emptyDescription": "ކޮންމެ މަހަކު އަންނަ ބޭންކް ފީއަށް ޤަވާޢިދެއް ހައްދަވާ، އެއިރުން ކޮންމެ މަހަކު އެކައުންޓެއް ޖަހާކަށް ނުޖެހޭނެއެވެ.",
      "emptyTitle": "އަދި ދާއިމީ ޤަވާޢިދެއް ނެތް",
      "gross": "ޖުމްލަ",
      "grossToOffset": "ޖުމްލަ އަދަދު އޮފްސެޓް އެކައުންޓަށް",
      "hits": "ދިމާވި",
      "lines": "ބަލާނެ ލައިންތައް",
      "loadFailed": "އެ ޤަވާޢިދުތައް ނުލޯޑްވި",
      "match": "ދިމާވާ ގޮތް",
      "mode": "ގޮތް",
      "modeAuto": "މީހަކާ ނުލައި ޕޯސްޓްކުރޭ",
      "modeSuggest": "ހުށަހަޅާ",
      "net": "ސާފު",
      "noCeiling": "މީހަކާ ނުލައި ޕޯސްޓްކުރާ ޤަވާޢިދަކަށް މަތީ ޙައްދެއް ބޭނުންވެއެވެ. ޙައްދެއް ނެތްނަމަ، ޙައްދެއް ނެތެވެ.",
      "noCondition": "ޤަވާޢިދަކަށް މަދުވެގެން އެއް ޝަރުޠު ބޭނުންވެއެވެ، ނޫންނަމަ ކޮންމެ ސަފަކާ ދިމާވާނެއެވެ.",
      "offsetAccount": "އޮފްސެޓް އެކައުންޓް",
      "patternHint": "ބޭންކުގެ ލިޔުމާ އަޅާކިޔެއެވެ، އެހެންވެ ކުރު އަދި ބަދަލުނުވާ އެއްޗެއް ބޭނުންކުރައްވާ.",
      "posting": "ޕޯސްޓިންގ",
      "priority": "އިސްކަން",
      "referencePattern": "ރެފަރެންސްގައި ހިމެނޭ",
      "saved": "ޤަވާޢިދު ރައްކާކުރެވިއްޖެ.",
      "statements": "ބަލާނެ ސްޓޭޓްމަންޓް",
      "supersede": "ބަދަލުކުރޭ",
      "supersedeDescription": "ތާރީޚަކުން ފެށިގެން އައު ވަރޝަނަކަށް ޢަމަލުކުރެވެއެވެ. ތާރީޚު އަލުން ލިޔާ ޤަވާޢިދަކުން، ކުރިން ޕޯސްޓްކުރި އެއްޗެހި ބަދަލުވާނެއެވެ.",
      "supersedeTitle": "ޤަވާޢިދު ބަދަލުކުރުން",
      "tableTitle": "ޤަވާޢިދުތައް",
      "taxCodeHint": "ޖުމްލަ އަދަދު ޕޯސްޓްކުރުމަށް ހުސްކޮށް ބާއްވާ؛ އިންޓަރެސްޓް ލިބުން ފަދަ މާފުކުރެވިފައިވާ ސަފުތަކަށް އެއީ ރަނގަޅު ގޮތެވެ.",
      "taxExclusive": "ޓެކްސް ނުހިމެނޭ",
      "taxInclusive": "ޓެކްސް ހިމެނޭ",
      "taxInclusiveHint": "ރަޖިސްޓަރީކުރެވިފައިވާ ބޭންކެއްގެ ފީގައި ޓެކްސް ހިމެނެއެވެ: ސްޓޭޓްމަންޓްގައި 108.00 އަކީ 100.00 ފީއާއި 8.00 ޓެކްސްއެވެ. ހުރިހާ 108.00 ޕޯސްޓްކުރުމުން ކޮންމެ މަހަކުވެސް ޚަރަދު އިތުރުވެގެންދާނެއެވެ.",
      "taxInclusiveLabel": "ސްޓޭޓްމަންޓްގެ އަދަދުގައި ޓެކްސް ހިމެނޭ",
      "title": "ދާއިމީ ޤަވާޢިދުތައް",
      "transactionCode": "ބޭންކް މުޢާމަލާތު ކޯޑް",
      "wouldAutoPost": "މީހަކާ ނުލައި ޕޯސްޓްވާނެ",
      "wouldPost": "ވާނެ ގޮތް",
      "wouldSuggest": "ހަމައެކަނި ހުށަހަޅާނެ"
    },
    "transit": {
      "age": "ދުވަސް",
      "alerted": "އިންޒާރު ދެވިފައި",
      "anyBucket": "ކޮންމެ ބޭންޑެއް",
      "bandsCaption": "ދުވަސްވުމުގެ ބޭންޑުން މަގުމަތީގައިވާ ފައިސާ",
      "bandsTitle": "ދުވަސްވުން",
      "breakBody": "ރަޖިސްޓަރީ {register}، ކޮންޓްރޯލް އެކައުންޓް {control}، ފަރަޤު {difference}. އެއިން އެއްޗެއްގައި އަނެއް އެއްޗަށް ނުފެންނަ ޕޯސްޓިންގއެއް ވެއެވެ.",
      "breakTitle": "ރަޖިސްޓަރީއާއި ލެޖަރ ދިމައެއް ނުވޭ",
      "controlBalance": "ކޮންޓްރޯލް އެކައުންޓް ބާކީ",
      "count": "ޢަދަދު",
      "description": "ނުކުމެ އަދި ނުލިބޭ ފައިސާ — އަދި އެއާ ދިމާވާން ޖެހޭ ލެޖަރ އެކައުންޓް.",
      "empty": "މަގުމަތީގައި އެއްވެސް އެއްޗެއް ނެތެވެ.",
      "laneCaption": "ކަށަވަރުވުމަށް އިންތިޒާރުކުރާ ދޫކުރެވިފައިވާ އިރުޝާދުތައް",
      "laneTitle": "މަގުމަތީގައި",
      "loadFailed": "އެ ރިޕޯޓް ނުލޯޑްވި",
      "openInstructions": "އިރުޝާދުތައް",
      "reconciled": "ރަޖިސްޓަރީއާއި ލެޖަރ {total} ގައި ދިމާވެއެވެ.",
      "registerTotal": "ރަޖިސްޓަރީގެ ޖުމްލަ",
      "released": "ދޫކުރެވުނު",
      "title": "މަގުމަތީގައިވާ ފައިސާ"
    },
    "transitBuckets": {
      "days0to2": "0–2 ދުވަސް",
      "days11to20": "11–20 ދުވަސް",
      "days3to5": "3–5 ދުވަސް",
      "days6to10": "6–10 ދުވަސް",
      "over20": "20 ދުވަހަށްވުރެ ގިނަ"
    },
    "txnKind": {
      "approval": "ފާސްކުރުން",
      "count_variance": "ގުނުމުގެ ފަރަޤު",
      "rejection": "ރައްދުކުރުން",
      "replenish": "އަލުން ފުރާލުން",
      "return": "ބޭންކަށް އަނބުރާ",
      "reversal": "އަނބުރާ ރައްދުކުރުން",
      "spend": "ޚަރަދު",
      "transfer_in": "ވަން ފައިސާ",
      "transfer_out": "ނުކުތް ފައިސާ"
    },
    "txnStatus": {
      "approved": "ފާސްކޮށްފައި",
      "captured": "ރެކޯޑްކުރެވިފައި",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "rejected": "ރައްދުކުރެވިފައި",
      "submitted": "ހުށަހަޅާފައި"
    },
    "varianceReasons": {
      "change_given": "ބާކީ ދެވިފައި",
      "other": "އެހެނިހެން",
      "rounding": "ރައުންޑްކުރުން",
      "theft_suspected": "ވަގަށް ނެގުމުގެ ޝައްކު",
      "till_error": "ފޮށީގެ ކުށެއް",
      "unrecorded_spend": "ރެކޯޑްނުކުރެވޭ ޚަރަދެއް"
    },
    "verificationMethod": {
      "callback": "ގުޅައިގެން ކަށަވަރުކުރުން",
      "document": "ލިޔުމަކުން",
      "existing_relationship": "ކުރިން އޮތް ގުޅުމަކުން",
      "manual": "އަތުން",
      "penny": "ކުޑަ އަދަދެއް ފޮނުވުން"
    },
    "verificationOutcome": {
      "failed": "ފެއިލްވި",
      "passed": "ފާސްވި",
      "pending": "އިންތިޒާރުގައި"
    },
    "verificationStatus": {
      "blocked": "ހުއްޓުވާފައި",
      "failed": "ކަށަވަރުކުރެވޭގޮތެއް ނުވި",
      "pending": "ކަށަވަރުކުރުން ކުރިއަށްދަނީ",
      "unverified": "ކަށަވަރުކޮށްފައެއް ނުވޭ",
      "verified": "ކަށަވަރުކުރެވިފައި"
    },
    "wallet": {
      "blind": "ފޮރުވިފައިވާ ގުނުން",
      "blindHint": "ގުނާ ފަރާތަށް ނިޒާމުގެ އަދަދު ނުދައްކާނެއެވެ — ސްކްރީނުން ފޮރުވަނީއެއް ނޫން، ޖަވާބުގައި ނުހިމެނެނީއެވެ.",
      "capture": "ޚަރަދެއް ރެކޯޑްކުރޭ",
      "captureConfirm": "ޚަރަދު ރެކޯޑްކުރޭ",
      "captureDescription": "ފައިސާ ފޮށިން ނުކުތެވެ. ފާސްކުރެވެންދެން އެ ޚަރަދު ފޮތުގައި ނުޖެހޭނެއެވެ.",
      "captureTaxNote": "ރަސީދުގައި ދައްކާ ޓެކްސް ރެކޯޑްކުރައްވާ. އޭގެން އަނބުރާ ލިބޭނެ ބައެއް ނިންމާނީ ފާސްކުރާއިރު، އަދި ސައްޙަ ޓެކްސް އިންވޮއިސްއެއް އޮވެގެންނެވެ.",
      "captureTitle": "ފޮށިން ކުރި ޚަރަދެއް ރެކޯޑްކުރުން",
      "captured": "ޚަރަދު ރެކޯޑްކުރެވިއްޖެ.",
      "countConfirm": "ގުނުން ހުޅުވާ",
      "countDescription": "ކޮންމެ ވޮލެޓަކަށް ހުޅުވިފައި ބެހެއްޓޭނީ އެއް ގުނުމެކެވެ، އެއިރުން ފަރަޤު ނިސްބަތްކުރެވޭނެއެވެ.",
      "countTitle": "ފައިސާ ގުނުމެއް ހުޅުވުން",
      "custodyOpened": "ހަވާލުކުރުން ހުޅުވިއްޖެ.",
      "custodyPending": "{on} ން ފެށިގެން ބެލެހެއްޓުން {to} އަށް ހަވާލުކުރެވެނީ.",
      "description": "ފޮށީގައި ހުރި އެއްޗެއް، އޭގެ ތެރެއިން ދިޔަ އެއްޗެއް، އަދި އަނބުރާ ދޭން ޖެހޭ އެއްޗެއް.",
      "evidenceRequired": "{ceiling} އަށްވުރެ މަތިވާނަމަ ހެކި ބޭނުންވާނެއެވެ.",
      "handover": "ބެލެހެއްޓުން ހަވާލުކުރޭ",
      "handoverConfirm": "ހަވާލުކުރުން ހުޅުވާ",
      "handoverDescription": "ދެ ފަރާތުންވެސް ސޮއިކުރެއެވެ، އަދި ހަވާލުވާ ފަރާތުން ޤަބޫލުކުރުމުގެ ކުރިން ގުނަން ޖެހޭނެއެވެ.",
      "handoverTitle": "ފޮށި ހަވާލުކުރުން",
      "hasTaxInvoice": "ރަސީދަކީ ސައްޙަ ޓެކްސް އިންވޮއިސްއެއް",
      "loadFailed": "އެ ވޮލެޓް ނުލޯޑްވި",
      "noTaxInvoice": "ޓެކްސް އިންވޮއިސްއެއް ނެތް",
      "openCount": "ގުނުމެއް ހުޅުވާ",
      "openCountBanner": "މި ވޮލެޓްގައި ގުނުން {no} ހުޅުވިފައިވެއެވެ.",
      "openCountLink": "ޝީޓް ހުޅުވާ",
      "policyHint": "ކޮންމެ ޚަރަދަކަށް {perTxn} · ދުވާލަކަށް {daily} · މަހަކަށް {monthly}",
      "replenish": "އަލުން ފުރާލުމަށް އެދޭ",
      "replenishConfirm": "އެދޭ",
      "replenishDescription": "ފައިސާ ދަތުރުކުރާނީ ހުއްދަ މަރުޙަލާގެ ބޭންކް ޓްރާންސްފަރެއް މެދުވެރިކޮށެވެ؛ މިތަނުން ބޭންކް މުޢާމަލާތެއް ޕޯސްޓެއް ނުކުރެއެވެ.",
      "replenishHint": "އިމްޕްރެސްޓް ވޮލެޓަކަށް އަނބުރާ އަންނާނީ ފާސްވެ ޚަރަދުކުރެވުނު އަދަދެވެ.",
      "replenishRequested": "އަލުން ފުރާލުމަށް އެދިއްޖެ.",
      "replenishTitle": "އަލުން ފުރާލުމަށް އެދުން",
      "replenishmentPending": "އަލުން ފުރާލުން {no} — {status}.",
      "shortfallHint": "އަލުން ފުރާލުމުން އަނބުރާ އަންނާނެ އަދަދު",
      "taxHint": "ރަސީދުގައި ދައްކާ ޓެކްސް.",
      "title": "ވޮލެޓް",
      "transactionsCaption": "މި ވޮލެޓް މެދުވެރިކޮށް ދިޔަ ފައިސާ",
      "transactionsEmpty": "އަދި މި ވޮލެޓް މެދުވެރިކޮށް އެއްވެސް އެއްޗެއް ދަތުރެއް ނުކުރެއެވެ.",
      "transactionsTitle": "މުޢާމަލާތްތައް"
    },
    "walletKind": {
      "fluctuating": "ބަދަލުވާ ފްލޯޓް",
      "imprest": "ކަނޑައެޅިފައިވާ ފްލޯޓް"
    },
    "walletReport": {
      "breakBody": "ސަބް-ލެޖަރ {subledger}، ކޮންޓްރޯލް އެކައުންޓް {control}، ފަރަޤު {difference}. އެއިން އެއްޗެއްގައި އަނެއް އެއްޗަށް ނުފެންނަ ޕޯސްޓިންގއެއް ވެއެވެ.",
      "breakTitle": "ވޮލެޓްތަކާއި ލެޖަރ ދިމައެއް ނުވޭ",
      "caption": "ކޮންޓްރޯލް އެކައުންޓާ އަޅާކިޔައި ވޮލެޓް ބާކީ",
      "control": "ކޮންޓްރޯލް އެކައުންޓް ބާކީ",
      "description": "ކޮންމެ ފްލޯޓަކާއި، އޭގައި ހުރި އެއްޗަކާއި، ސަބް-ލެޖަރާއި ލެޖަރ ދިމާވޭތޯ.",
      "difference": "ފަރަޤު",
      "empty": "ރިޕޯޓްކުރާނެ ވޮލެޓެއް ނެތެވެ.",
      "inBase": "{currency} އިން",
      "loadFailed": "އެ ރިޕޯޓް ނުލޯޑްވި",
      "reconciled": "ވޮލެޓްތަކާއި ލެޖަރ {total} ގައި ދިމާވެއެވެ.",
      "subledger": "ސަބް-ލެޖަރ ޖުމްލަ",
      "tableTitle": "ވޮލެޓުން",
      "title": "ވޮލެޓް ބާކީ"
    },
    "walletStatus": {
      "active": "ބޭނުންކުރެވޭ",
      "closed": "ބަންދުކުރެވިފައި",
      "suspended": "ހުއްޓާލެވިފައި",
      "closing": "ބަންދުވަނީ",
      "dormant": "ހަރަކާތެއް ނެތް",
      "in_handover": "ހަވާލުކުރަމުންދަނީ"
    },
    "wallets": {
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "caption": "ވޮލެޓްތަކާއި، އެ ތަކެތީގެ ފްލޯޓާއި ބާކީ",
      "clearingHint": "ފާސްނުކުރެވި ރެކޯޑްކުރެވިފައިވާ ޚަރަދު ބާއްވާ އެކައުންޓް.",
      "countOverdue": "ގުނަން ޖެހިފައި",
      "create": "އައު ވޮލެޓް",
      "createDescription": "ވޮލެޓަކަށް އޭގެ އަމިއްލަ ސަބް-ލެޖަރެއް އޮވެއެވެ، އެހެންވެ ގިނަ ފްލޯޓްތަކެއް އެއް ލެޖަރ އެކައުންޓެއް ބޭނުންކުރިޔަސް ދިމާވެއެވެ.",
      "createTitle": "ވޮލެޓެއް އުފެއްދުން",
      "created": "ވޮލެޓް އުފެއްދިއްޖެ.",
      "description": "ޕެޓީ ކޭޝް ފޮށިތަކާއި ފްލޯޓްތައް، އަދި ކޮންމެ އެއްޗަކަށް ޒިންމާވާ ފަރާތް.",
      "emptyDescription": "ވޮލެޓެއް ފެންނާނީ އެ ބަލަހައްޓާ ފަރާތަށާއި، އެ ހިންގާ ނުވަތަ ފާސްކުރާ ފަރާތަށާއި، ހުޅުވިފައިވާ ގުނުމެއްގައި ނަން ހިމެނޭ ފަރާތަށެވެ. ފްލޯޓެއް ނުހިފަހައްޓާނަމަ ހުސް ލިސްޓަކީ ރަނގަޅު ޖަވާބެވެ.",
      "emptyTitle": "ތިޔަ ބޭފުޅާއަށް ފެންނަ ވޮލެޓެއް ނެތް",
      "floatHint": "އިމްޕްރެސްޓް ވޮލެޓެއް އަނބުރާ ގެނެވޭ އަދަދު.",
      "kindHint": "ފްލޯޓް އިމްޕްރެސްޓް ނަމަ ކަނޑައެޅިފައިވާ އަދަދަކަށް އަނބުރާ ގެނެވެއެވެ؛ ބަދަލުވާ ފްލޯޓަކަށް ވަކި އަދަދެއް ނޯވެއެވެ.",
      "loadFailed": "އެ ވޮލެޓްތައް ނުލޯޑްވި",
      "openCaptures": "ފާސްކުރުމަށް {count}",
      "openReport": "ބާކީގެ ރިޕޯޓް",
      "sameAccount": "ފްލޯޓާއި ކްލިއަރިން އެކައުންޓް ތަފާތުވާން ޖެހެއެވެ، ނޫންނަމަ ޚަރަދު ސުމަކަށް ދާނެއެވެ.",
      "tableTitle": "ވޮލެޓްތައް",
      "title": "ވޮލެޓްތައް"
    },
    "aiSurfaces": {
      "receipt": {
        "title": "ރިސީޓު ކިޔުން",
        "aiBadge": "އޭއައި",
        "fileLabel": "ރިސީޓުގެ ފޮޓޯ ނުވަތަ ޕީޑީއެފް",
        "fileHint": "ޕީއެންޖީ، ޖޭޕެގް ނުވަތަ ޕީޑީއެފް. ތަފްޞީލުތައް ކަށަވަރުކުރަންދެން އެއީ ހަމައެކަނި ހުށަހެޅުންތަކެވެ.",
        "read": "ރިސީޓު ކިޔާ",
        "reading": "ރިސީޓު ކިޔަނީ…",
        "tooLarge": "މާ ކުޑަ ފައިލެއް ނުވަތަ ރިސީޓުގެ ފޮޓޯއެއް ފޮނުވާ.",
        "overall": "ޖުމްލަ ޔަޤީންކަން {confidence}%",
        "currencyMismatch": "ރިސީޓު އޮތީ {read} އިން، ނަމަވެސް މި ވޮލެޓުން ޚަރަދުކުރަނީ {wallet} އިން. އަދަދުތައް ފުރިފައެއް ނުވޭ؛ ވޮލެޓުގެ ފައިސާއިން ޚަރަދު ތިޔަބޭފުޅާ ރެކޯޑުކުރައްވާ.",
        "lowNote": "ދަށް ޔަޤީންކަމާއެކު ކިޔުނު {count} އަގު ޓިކް ނުކޮށް ބާއްވާފައި. ރިސީޓާ އަޅާކިޔާ ބައްލަވާ.",
        "tableLabel": "ރިސީޓުން ކިޔުނު އަގުތައް",
        "columns": {
          "use": "ބޭނުންކުރޭ",
          "field": "ފީލްޑު",
          "value": "ކިޔުނު ގޮތް",
          "confidence": "ޔަޤީންކަން"
        },
        "fields": {
          "merchantName": "ވިޔަފާރިވެރިޔާ",
          "receiptDate": "ތާރީޚު",
          "totalAmount": "އަދަދު",
          "taxAmount": "ޓެކްސް",
          "merchantTaxId": "ވިޔަފާރިވެރިޔާގެ ޓެކްސް ނަންބަރު",
          "expenseCategory": "ބާވަތުގެ އިޝާރާތް",
          "currency": "ފައިސާ",
          "receiptNumber": "ރިސީޓު ނަންބަރު"
        },
        "useField": "{field} ބޭނުންކުރޭ",
        "checkOnly": "ބަލާ",
        "unusable": {
          "shape": "ބޭނުންކުރެވޭ އަގެއް ނޫން",
          "currency": "ވޮލެޓުގެ ފައިސާއިން ނޫން",
          "category": "މި ވޮލެޓުގެ ބާވަތެއް ނޫން"
        },
        "percentTitle": "ޔަޤީންކަން {value}%",
        "nothingRead": "މި ރިސީޓުން ބޭނުންކުރެވޭ އެއްވެސް އަގެއް ނުކިޔުނު.",
        "status": {
          "pending": "ކަށަވަރުކުރުމަށް މަޑުކުރަނީ",
          "confirmed": "ކަށަވަރުކުރެވިއްޖެ",
          "discarded": "ދޫކޮށްލެވިއްޖެ"
        },
        "confirmNote": "ކަށަވަރުކުރަންދެން އެއްވެސް ތަފްޞީލެއް ނުފުރޭ. ޚަރަދު ރެކޯޑުވަނީ ތިރީގައި ރެކޯޑުކުރެއްވުމުންނެވެ.",
        "applied": "ކަށަވަރުކުރެވުނު އަގުތައް ފޯމުގައި ހުރި. ބައްލަވާފައި ޚަރަދު ރެކޯޑުކުރައްވާ.",
        "discard": "ދޫކޮށްލާ",
        "confirm": "ކަށަވަރުކޮށް ފޯމު ފުރާ"
      },
      "covenantPrediction": {
        "title": "ލަފާކުރެވޭ ކޮވެނަންޓް ތަބާވުން",
        "description": "ކުރިއަށް އޮތް ޓެސްޓް މުއްދަތުތަކުގައި ކޮންމެ ކޮވެނަންޓެއް ވާނެ ގޮތުގެ ސާވަރުގެ ލަފާ. މިއީ ޓެސްޓެއްގެ ނަތީޖާއެއް ނޫން.",
        "loadFailed": "ކޮވެނަންޓް ލަފާ ލޯޑެއް ނުކުރެވުނު.",
        "empty": "މި ފެސިލިޓީގެ އެއްވެސް ކޮވެނަންޓަކަށް ލަފާއެއް ނެތް.",
        "projected": "ލަފާކުރެވޭ",
        "latest": "އެންމެ ފަހުގެ ހަގީގީ އަގު {value}، ޓެސްޓުކުރީ {date}",
        "noLatest": "އަދި ޓެސްޓެއް ނުކުރޭ",
        "firstBreach": "{period} ގައި ނިމޭ މުއްދަތުގައި ޚިލާފުވުމެއް ލަފާކުރެވޭ",
        "leadTime": "މިއަދުން ފެށިގެން {days} ދުވަސް",
        "noBreach": "ދައްކާފައިވާ މުއްދަތުތަކުގައި ޚިލާފުވުމެއް ލަފާއެއް ނުކުރެވޭ.",
        "unprojected": "މި ކޮވެނަންޓަށް އެއްވެސް އަދަދެއް ލަފާއެއް ނުކުރެވޭ.",
        "basisCaption": "ބިންގާ: {basis} · ޔަޤީންކަން: {confidence}",
        "basisOnly": "ބިންގާ: {basis}",
        "confidenceLevel": {
          "high": "މަތި",
          "medium": "މެދު",
          "low": "ދަށް",
          "none": "ނެތް"
        },
        "tableCaption": "{covenant} ގެ ލަފާކުރެވޭ އަގުތައް",
        "periodEnd": "މުއްދަތު ނިމޭ ތާރީޚު",
        "projectedValue": "ލަފާކުރެވޭ އަގު",
        "headroom": "ލަފާކުރެވޭ ހެޑްރޫމް",
        "outcome": "ލަފާކުރެވޭ ނަތީޖާ",
        "breach": "ޚިލާފުވުން",
        "within": "ކޮވެނަންޓާ އެއްގޮތަށް"
      }
    },
    "alertConsole": {
      "routeTitle": "ޓްރެޜަރީ އެލަރޓްތައް",
      "title": "ޓްރެޜަރީ އެލަރޓްތައް",
      "description": "ތިބާއަށް ފޮނުވާފައިވާ ލިކުއިޑިޓީ، ފޯކާސްޓް، ރިކޮންސިލިއޭޝަން، ވޯލެޓް، ކޮވެނަންޓް އަދި ބޭންކް ކަނެކްޝަންގެ އެލަރޓްތައް، ނަތީޖާގެ މުހިންމުކަމުގެ ތަރުތީބުން. އެލަރޓެއް ބަލައިގަތުމަށް އެކްނޮލެޖް ކުރައްވާ؛ ބަންދުކުރުމަށް ކޯޑަކާއި ނަތީޖާއާއެކު ހައްލުކުރައްވާ.",
      "filters": {
        "legalEntity": "ލީގަލް އެންޓިޓީ",
        "severity": "ސީރިއަސްކަން",
        "sourceType": "މަސްދަރު",
        "status": "ހާލަތު"
      },
      "statuses": {
        "awaiting": "އެކްނޮލެޖް ކުރަން ބާކީ",
        "acknowledged": "އެކްނޮލެޖް ކުރެވިފައި",
        "resolved": "ހައްލުކުރެވިފައި",
        "allOpen": "ހުރިހާ ހުޅުވާފައިވާ"
      },
      "tally": "{severity}: {count}",
      "openOnly": "ލިސްޓުކުރެވެނީ ހައްލުނުކުރެވޭ އެލަރޓްތައެވެ. ހައްލުކުރެވުނު އެލަރޓްތައް އޭގެ ކޯޑާއި ނަތީޖާއާއި ހައްލުކުރި ފަރާތާއެކު ބެލުމަށް \"ހައްލުކުރެވިފައި\" ހޮވާ.",
      "entityNote": "އެއްވެސް ލީގަލް އެންޓިޓީއަކަށް ނުނިސްބަތްވާ އެލަރޓްތައް، މިސާލަކަށް ފެއިލްވާ ބޭންކް ސްޓޭޓްމަންޓް ކަނެކްޝަނެއް، ފެންނާނީ ހުރިހާ ލީގަލް އެންޓިޓީގެ ދަށުން އެކަނި.",
      "truncated": "ދައްކަނީ ފުރަތަމަ {count} އެލަރޓް. ބާކީ ތައް ބެލުމަށް ސީރިއަސްކަމާއި ލީގަލް އެންޓިޓީއިން ފިލްޓަރ ކުރައްވާ.",
      "loadFailed": "ޓްރެޜަރީ އެލަރޓްތައް ލޯޑު ނުކުރެވުނު",
      "emptyTitle": "ހުޅުވާފައިވާ ޓްރެޜަރީ އެލަރޓެއް ނެތް",
      "emptyDescription": "މިހާރު ޓްރެޜަރީގައި ތިބާގެ ސަމާލުކަން ބޭނުންވާ އެއްޗެއް ނެތް. ލިކުއިޑިޓީ ހައްދު ފަހަނައަޅައިފިނަމަ، ކުޑަކަމެއް ލަފާކުރެވިއްޖެނަމަ، ރިކޮންސިލިއޭޝަން އައިޓަމެއް ދިގުލައިފިނަމަ، ވޯލެޓެއް ބޭނުންނުކުރެވި ހުރިނަމަ، ކޮވެނަންޓެއް ފަހަނައަޅައިފިނަމަ ނުވަތަ ބޭންކް ކަނެކްޝަނެއް ފެއިލްވެއްޖެނަމަ އެލަރޓްތައް މިތާ ފެންނާނެއެވެ.",
      "filteredEmptyTitle": "މި ފިލްޓަރުތަކާ ގުޅޭ އެލަރޓެއް ނެތް",
      "filteredEmptyDescription": "ހުރިހާ ހުޅުވާފައިވާ ޓްރެޜަރީ އެލަރޓެއް ބެލުމަށް ފިލްޓަރުތައް ފޮހެލައްވާ.",
      "resolve": {
        "title": "އެލަރޓް ހައްލުކުރުން",
        "description": "ހައްލުކުރި ކޯޑެއް ހޮވައި ނަތީޖާ ލިޔުއްވާ. ޑިސްމިސްޑަށް ނަތީޖާއެއް ބޭނުމެއް ނުވޭ؛ އެހެން ހުރިހާ ކޯޑަކަށް ބޭނުންވޭ."
      },
      "sourceTypes": {
        "liquidityBreach": "ލިކުއިޑިޓީ ހައްދަށްވުރެ ދަށް",
        "shortfallPredicted": "ފައިސާ ކުޑަވާނެކަމަށް ލަފާކުރެވިފައި",
        "reconException": "ރިކޮންސިލިއޭޝަން އެކްސެޕްޝަން",
        "fundsInTransitAged": "ދަތުރުގައިވާ ފައިސާ ދިގުލައިފި",
        "walletIdle": "ބޭނުންނުކުރެވޭ ވޯލެޓް",
        "statementGap": "ބޭންކް ސްޓޭޓްމަންޓް ހުސްކަން",
        "covenantBreach": "ކޮވެނަންޓް ފަހަނައެޅުން",
        "connectionFailed": "ބޭންކް ކަނެކްޝަން ފެއިލްވެއްޖެ",
        "connectionFailurePredicted": "ބޭންކް ކަނެކްޝަން ފެއިލްވާނެކަމަށް ލަފާކުރެވިފައި",
        "movementAnomaly": "އާދަޔާ ހިލާފު ބޭންކް މޫވްމަންޓް"
      }
    },
    "kpis": {
      "routeTitle": "ޓްރެޜަރީ ކޭޕީއައިތައް",
      "title": "ޓްރެޜަރީ ކޭޕީއައިތައް",
      "description": "އެއް ލީގަލް އެންޓިޓީއެއްގެ އޮޓޯ-މެޗް ރޭޓް، ރިކޮންސައިލް ކުރަން ނަގާ ދުވަސް، ފޯކާސްޓް ދަގީގުކަން، ބޭނުންނުކުރެވޭ ބެލެންސް އަދި ފްލޯޓް ބޭނުންކުރުން — ކޮންމެ އެއްޗެއްގެ ފޯމިއުލާއާއި ހިސާބާއި ލިސްޓާއެކު.",
      "filters": {
        "legalEntity": "ލީގަލް އެންޓިޓީ",
        "window": "މުއްދަތު"
      },
      "window": {
        "option": "ފަހު {days} ދުވަސް",
        "hint": "އޮޓޯ-މެޗް ރޭޓް، ރިކޮންސައިލް ކުރަން ނަގާ ދުވަސް އަދި ފޯކާސްޓް ދަގީގުކަމުގެ މުއްދަތު ކަނޑައަޅައެވެ. ބޭނުންނުކުރެވޭ ބެލެންސް އަދި ފްލޯޓް ބޭނުންކުރުމަކީ މިއަދުގެ ހާލަތު."
      },
      "facts": {
        "window": "މުއްދަތު",
        "windowRange": "{from} އިން {to} އަށް",
        "asOf": "މި ތާރީޚަށް",
        "baseCurrency": "ބޭސް ކަރަންސީ",
        "cycle": "ޝާއިއުކުރެވޭ",
        "formula": "ފޯމިއުލާ",
        "arithmetic": "ހިސާބު",
        "sample": "ސާމްޕަލް ސައިޒް"
      },
      "units": {
        "days": "ދުވަސް"
      },
      "cycles": {
        "daily": "ކޮންމެ ދުވަހަކު"
      },
      "loadFailed": "ޓްރެޜަރީ ކޭޕީއައިތައް ލޯޑު ނުކުރެވުނު",
      "noEntityTitle": "ލީގަލް އެންޓިޓީއެއް ހޮއްވަވާ",
      "noEntityDescription": "ޓްރެޜަރީ ކޭޕީއައިތައް މިންކުރެވެނީ އެއް ފަހަރާ އެއް ލީގަލް އެންޓިޓީއަށް.",
      "emptyTitle": "ދައްކާނެ ކޭޕީއައިއެއް ނެތް",
      "emptyDescription": "މި ލީގަލް އެންޓިޓީއަށް ރިޕޯޓުން އެއްވެސް މިންވަރެއް ނުދެއްވައެވެ.",
      "nothingToMeasure": "މި މުއްދަތުގައި މިންކުރާނެ އެއްޗެއް ނެތުމުން، ސުމެއް ނޫން، އެއްވެސް އަގެއް ނުދައްކަމެވެ.",
      "drill": {
        "open": "{label} ގެ ފަހަތުގައިވާ ލިސްޓު ހުޅުވާ",
        "link": "މި އަދަދުގެ ފަހަތުގައިވާ ލިސްޓު ބައްލަވާ",
        "unavailable": "މި އަދަދަށް ލިސްޓު ސްކްރީނެއް ނެތް",
        "inexact": "އެ ލިސްޓު އެއް ލީގަލް އެންޓިޓީއަކަށް ހަނި ނުކުރެވޭތީ، ހުރިހާ ލީގަލް އެންޓިޓީގެ ރެކޯޑްތައް ދައްކައެވެ."
      }
    },
    "idleCash": {
      "title": "ހަރަކާތެއް ނެތް ފައިސާ",
      "description": "ކަނޑައަޅާފައިވާ މުއްދަތަށްވުރެ ގިނަ ދުވަހު ހަރަކާތެއް ނެތި ފައިސާ ހުރި ބޭންކް އެކައުންޓްތަކާއި ވޮލެޓްތައް، ވަޢުދުތައް ކަނޑާފައި އަނބުރާ ލިބެން ހުރި އަދަދު، އަދި އެކަމުގައި ކުރަންވީ ކަންތައް.",
      "routeTitle": "ހަރަކާތެއް ނެތް ފައިސާ",
      "nav": {
        "label": "ހަރަކާތެއް ނެތް ފައިސާ",
        "description": "ހަރަކާތެއް ނުވާ ފައިސާ: ބޭންކުގައި ހުރި ބާކީ ބަހައްޓާ، ވޮލެޓްތަކުން އަނބުރާ ނަގާ."
      },
      "filtersTitle": "ފިލްޓަރުތައް",
      "fields": {
        "entity": "ޤާނޫނީ ފަރާތް",
        "minIdleDays": "މަދުވެގެން ހަރަކާތެއް ނެތް ދުވަސް",
        "asOf": "މި ތާރީޚަށް",
        "source": "އެކައުންޓް ނުވަތަ ވޮލެޓް",
        "kind": "ބާވަތް",
        "status": "ހާލަތު",
        "currency": "ފައިސާ",
        "balance": "ބާކީ",
        "commitments": "ވަޢުދުތައް",
        "recoverable": "އަނބުރާ ލިބެން ހުރި",
        "baseRecoverable": "އަނބުރާ ލިބެން ހުރި ({currency})",
        "idleDays": "ހަރަކާތެއް ނެތް",
        "lastMovementOn": "އެންމެ ފަހުގެ ހަރަކާތް",
        "proposal": "ހުށަހަޅާ ކަންތައް"
      },
      "minIdleDaysHint": "ކޮންމެ އެކައުންޓަކާއި ވޮލެޓެއް އޭގެ މުއްދަތާ އަޅާކިޔުމަށް ހުސްކޮށް ބަހައްޓާ.",
      "minIdleDaysError": "1 އިން 3660 އަށް ފުރިހަމަ ދުވަހެއްގެ އަދަދު ލިޔުއްވާ.",
      "noEntityTitle": "ރިޕޯޓް ކުރާނެ ޤާނޫނީ ފަރާތެއް ނެތް",
      "noEntityDescription": "މި ރިޕޯޓް ދައްކަނީ އެއް ޤާނޫނީ ފަރާތެއްގެ ބޭސް ފައިސާއިން. ފުރަތަމަ ޤާނޫނީ ފަރާތެއް ހަދާ ނުވަތަ އެކްޓިވް ކުރައްވާ.",
      "loadFailed": "ހަރަކާތެއް ނެތް ފައިސާގެ ރިޕޯޓް ލޯޑް ނުކުރެވުނެވެ.",
      "summaryTitle": "ޚުލާޞާ",
      "totalRecoverable": "ޖުމްލަ އަނބުރާ ލިބެން ހުރި ({currency})",
      "bankAccounts": "ބޭންކް އެކައުންޓްތައް",
      "wallets": "ވޮލެޓްތައް",
      "emptyTitle": "ހަރަކާތެއް ނެތް ފައިސާއެއް ނެތް",
      "emptyDescription": "މި ޤާނޫނީ ފަރާތުގެ ހުރިހާ ބޭންކް އެކައުންޓަކާއި ވޮލެޓެއްގައި މުއްދަތުގެ ތެރޭގައި ހަރަކާތް ހިނގައިފި.",
      "tableTitle": "ހަރަކާތެއް ނެތް ބާކީތައް",
      "caption": "ހަރަކާތެއް ނެތް ފައިސާ ހުރި ބޭންކް އެކައުންޓްތަކާއި ވޮލެޓްތައް، ހުށަހަޅާ ކަންތައްތަކާއެކު",
      "idleOf": "{period} ދުވަހުގެ ތެރެއިން {days} ދުވަސް",
      "neverMoved": "ހަރަކާތެއް ނެތް",
      "kind": {
        "bank_account": "ބޭންކް އެކައުންޓް",
        "wallet": "ވޮލެޓް"
      },
      "proposal": {
        "place": "ބަހައްޓާ",
        "recover": "އަނބުރާ ނަގާ",
        "none": "ކަމެއް ނުކުރެ"
      },
      "status": {
        "active": "އެކްޓިވް",
        "inactive": "އިނެކްޓިވް",
        "pending_approval": "ހުއްދައަށް މަޑުކުރަނީ",
        "suspended": "ހުއްޓާލާފައި",
        "in_handover": "ހަވާލުކުރަމުން",
        "dormant": "ނިދާފައި",
        "closing": "ބަންދުކުރަމުން",
        "closed": "ބަންދު"
      }
    },
    "walletAnalytics": {
      "title": "ވޮލެޓް އެނަލިޓިކްސް",
      "description": "ފްލޯޓް ބޭނުންކުރާ މިންވަރާއި ކަވަރު ދުވަސް، ހުއްދައަށް މަޑުކުރާ ޚަރަދު، ގުނުމުގެ ތަފާތު، ހަރަކާތެއް ނެތް ބާކީ، ބާވަތުން ޚަރަދު އަދި މަގުމަތީގައި ހުރި ފައިސާ.",
      "routeTitle": "ވޮލެޓް އެނަލިޓިކްސް",
      "nav": {
        "label": "ވޮލެޓް އެނަލިޓިކްސް",
        "description": "ކޮންމެ ފްލޯޓެއް ބޭނުންކުރާ ގޮތް، މަޑުކުރަމުންދާ އެއްޗެހި، އަދި ތަފާތުވާ ތަންތަން."
      },
      "filtersTitle": "ފިލްޓަރުތައް",
      "fields": {
        "entity": "ޤާނޫނީ ފަރާތް",
        "wallet": "ވޮލެޓް",
        "from": "ފެށޭ",
        "to": "ނިމޭ",
        "kind": "ބާވަތް",
        "currency": "ފައިސާ",
        "wallets": "ވޮލެޓްތައް",
        "total": "ޖުމްލަ",
        "entries": "އެންޓްރީ",
        "date": "ތާރީޚް",
        "category": "ބާވަތް",
        "amount": "އަދަދު",
        "age": "ޢުމުރު",
        "band": "ބޭންޑް",
        "custodian": "ބެލެހެއްޓުންތެރިޔާ",
        "status": "ހާލަތު"
      },
      "allWallets": "ހުރިހާ ވޮލެޓެއް",
      "rangeHint": "ކޮންމެ ރިޕޯޓެއްގެ ޑިފޯލްޓް މުއްދަތަށް ތާރީޚްތައް ހުސްކޮށް ބަހައްޓާ. ހުއްދައަށް މަޑުކުރާ ޚަރަދު ހިސާބުކުރަނީ ނިމޭ ތާރީޚަށް.",
      "rangeInverted": "ފެށޭ ތާރީޚަކީ ނިމޭ ތާރީޚަށްވުރެ ފަހުގެ ތާރީޚެކެވެ.",
      "loadFailed": "މި ރިޕޯޓް ލޯޑް ނުކުރެވުނެވެ.",
      "emptyTitle": "ރިޕޯޓް ކުރާނެ ވޮލެޓެއް ނެތް",
      "emptyDescription": "ތިބާއަށް ފެންނަ އެއްވެސް ވޮލެޓެއް މި ފިލްޓަރުތަކާ ނުގުޅެއެވެ.",
      "totalsCaption": "ފައިސާއިން ޖުމްލަ",
      "asOf": "{asOf} ގެ ނިޔަލަށް.",
      "days": "{days} ދުވަސް",
      "tabs": {
        "float": "ފްލޯޓް ބޭނުންކުރުން",
        "ageing": "ހުއްދައަށް މަޑުކުރަނީ",
        "variance": "ގުނުމުގެ ތަފާތު",
        "idle": "ހަރަކާތެއް ނެތް ބާކީ",
        "expenditure": "ބާވަތުން",
        "transit": "މަގުމަތީގައި"
      },
      "level": {
        "above": "މަތީގައި",
        "within": "ތެރޭގައި",
        "below": "ދަށުގައި"
      },
      "walletKind": {
        "imprest": "އިމްޕްރެސްޓް",
        "fluctuating": "ބަދަލުވާ"
      },
      "walletStatus": {
        "active": "އެކްޓިވް",
        "suspended": "ހުއްޓާލާފައި",
        "in_handover": "ހަވާލުކުރަމުން",
        "dormant": "ނިދާފައި",
        "closing": "ބަންދުކުރަމުން",
        "closed": "ބަންދު"
      },
      "proposal": {
        "recover": "އަނބުރާ ނަގާ",
        "none": "ކަމެއް ނުކުރެ"
      },
      "float": {
        "windowDays": "ޚަރަދު ބަލާ މުއްދަތު (ދުވަސް)",
        "windowDaysHint": "ޚަރަދު ކިޔާނީ ކިހާ ދުރަށް ފަހަތަށް. ހުސްނަމަ 90.",
        "windowDaysError": "1 އިން 366 އަށް ފުރިހަމަ ދުވަހެއްގެ އަދަދު ލިޔުއްވާ.",
        "targetCoverDays": "ލަނޑުދަނޑި ކަވަރު (ދުވަސް)",
        "targetCoverDaysHint": "ފްލޯޓަކުން ކަވަރުކުރަންވީ ޚަރަދުގެ ދުވަސް. ހުސްނަމަ 30.",
        "targetCoverDaysError": "1 އިން 365 އަށް ފުރިހަމަ ދުވަހެއްގެ އަދަދު ލިޔުއްވާ.",
        "tolerancePercent": "ކެތްކުރެވޭ މިންވަރު",
        "toleranceHint": "25% އަށް 25 ލިޔުއްވާ. ހުސްނަމަ 25%.",
        "toleranceError": "0 އިން 100 އަށް ޕަސެންޓެއް ލިޔުއްވާ.",
        "paramsInvalid": "ރިޕޯޓް ހިންގުމަށް ފާހަގަކޮށްފައިވާ ޕެރެމީޓަރުތައް ރަނގަޅު ކުރައްވާ.",
        "basis": "{asOf} ގެ ނިޔަލަށް: ފަހުގެ {window} ދުވަހުގެ ޚަރަދު، {cover} ދުވަހުގެ ލަނޑުދަނޑި ކަވަރު، އަދި {tolerance}% ގެ ކެތްކުރެވޭ މިންވަރު.",
        "authorisedFloat": "ހުއްދަ ފްލޯޓް",
        "confirmedBalance": "ކަށަވަރު ބާކީ",
        "utilisation": "ބޭނުންކުރުން",
        "windowSpend": "މުއްދަތުގެ ޚަރަދު",
        "avgDailySpend": "ދުވާލެއްގެ އެވްރެޖް ޚަރަދު",
        "daysOfCover": "ކަވަރު ދުވަސް",
        "justifiedFloat": "ހުށަހަޅާ ފްލޯޓް",
        "level": "ހުށަހަޅާ ފްލޯޓާ އަޅާބަލާއިރު",
        "gap": "ތަފާތު",
        "excess": "އިތުރު",
        "shortfall": "މަދު",
        "aboveCount": "މަތީގައި",
        "belowCount": "ދަށުގައި"
      },
      "ageing": {
        "asOf": "{asOf} ގެ ނިޔަލަށް ރެކޯޑްކޮށް ހުއްދަ ނުދީ ހުރި.",
        "emptyTitle": "ހުއްދައަށް މަޑުކުރާ އެއްޗެއް ނެތް",
        "emptyDescription": "މި ތާރީޚަށް ރެކޯޑްކުރި އެއްވެސް ޚަރަދެއް ނިންމުމަކަށް މަޑުކުރަމުން ނުދެއެވެ.",
        "recordedBy": "ރެކޯޑްކުރީ",
        "oldest": "އެންމެ ބާ",
        "itemsTitle": "ހުއްދައަށް މަޑުކުރާ އެންޓްރީތައް",
        "txnNo": "އެންޓްރީ"
      },
      "variance": {
        "summary": "{from} އިން {to} އަށް: {posted} ގުނުން ޕޯސްޓްކޮށް، {withVariance} ގައި ތަފާތު.",
        "emptyTitle": "އެއްވެސް ގުނުމެއް ޕޯސްޓް ނުކުރޭ",
        "emptyDescription": "މި މުއްދަތުގައި އެއްވެސް ވޮލެޓް ގުނުމެއް ޕޯސްޓް ނުކުރެވެއެވެ.",
        "byWallet": "ވޮލެޓުން",
        "countsPosted": "ޕޯސްޓްކުރި ގުނުން",
        "withVariance": "ތަފާތު ހުރި",
        "net": "ނެޓް ތަފާތު",
        "abs": "ޖުމްލަ ތަފާތު",
        "lastCountOn": "އެންމެ ފަހުގެ ގުނުން",
        "byCause": "ސަބަބުން",
        "cause": "ސަބަބު",
        "itemsTitle": "ތަފާތު ހުރި ގުނުންތައް",
        "countNo": "ގުނުން",
        "systemTotal": "ސިސްޓަމް",
        "countedTotal": "ގުނި",
        "variance": "ތަފާތު",
        "owner": "ވެރިފަރާތް",
        "countedBy": "ގުނީ"
      },
      "idle": {
        "minIdleDays": "މަދުވެގެން ހަރަކާތެއް ނެތް ދުވަސް",
        "minIdleDaysHint": "ކޮންމެ ވޮލެޓެއް އޭގެ މުއްދަތާ އަޅާކިޔުމަށް ހުސްކޮށް ބަހައްޓާ.",
        "minIdleDaysError": "1 އިން 3660 އަށް ފުރިހަމަ ދުވަހެއްގެ އަދަދު ލިޔުއްވާ.",
        "emptyTitle": "ހަރަކާތެއް ނެތް ވޮލެޓެއް ނެތް",
        "emptyDescription": "ތިބާއަށް ފެންނަ ހުރިހާ ވޮލެޓެއްގައި މުއްދަތުގެ ތެރޭގައި ހަރަކާތް ހިނގައިފި.",
        "balance": "ކަށަވަރު ބާކީ",
        "commitments": "މަދުވެގެން ބަހައްޓަންޖެހޭ",
        "recoverable": "އަނބުރާ ލިބެން ހުރި",
        "idleDays": "ހަރަކާތެއް ނެތް",
        "lastMovementOn": "އެންމެ ފަހުގެ ހަރަކާތް",
        "proposal": "ހުށަހަޅާ ކަންތައް",
        "idleOf": "{period} ދުވަހުގެ ތެރެއިން {days} ދުވަސް",
        "neverMoved": "ހަރަކާތެއް ނެތް"
      },
      "expenditure": {
        "chooseEntityTitle": "ޤާނޫނީ ފަރާތެއް ހޮވާ",
        "chooseEntityDescription": "ޚަރަދު ޕްރޮކިއުމަންޓާ އަޅާކިޔަނީ އެއް ޤާނޫނީ ފަރާތެއްގެ ތެރޭގައި، އޭގެ ބޭސް ފައިސާއިން.",
        "window": "{from} އިން {to} އަށް، {currency} އިން.",
        "procurementWithheld": "ޕްރޮކިއުމަންޓް އަޅާކިޔުން ދައްކަނީ ވޮލެޓް މެނޭޖަރުންނާއި ހުއްދަދޭ ފަރާތްތަކަށް އެކަނި.",
        "emptyTitle": "ވޮލެޓް ޚަރަދެއް ނެތް",
        "emptyDescription": "މި މުއްދަތުގައި އެއްވެސް ޚަރަދެއް ރެކޯޑް ނުކުރެވެއެވެ.",
        "costCenter": "ކޮސްޓް ސެންޓަރު",
        "expenseAccount": "ޚަރަދުގެ އެކައުންޓް",
        "recorded": "ރެކޯޑްކުރި",
        "approved": "ހުއްދަދިން",
        "procurement": "ޕްރޮކިއުމަންޓް މެދުވެރިކޮށް",
        "walletShare": "ވޮލެޓްގެ ހިއްސާ"
      },
      "transit": {
        "liveNote": "{asOf} ގެ ނިޔަލަށް ވޮލެޓަށް ނުވަދެ ހުރި ހުއްދަދީފައިވާ ރީޕްލެނިޝްމަންޓްތައް. ތާރީޚުގެ ފިލްޓަރު މިއަށް ނުހިނގައެވެ.",
        "emptyTitle": "މަގުމަތީގައި އެއްވެސް އެއްޗެއް ނެތް",
        "emptyDescription": "ހުއްދަދީފައިވާ ހުރިހާ ރީޕްލެނިޝްމަންޓެއް ވޮލެޓަށް ވަދެއްޖެ.",
        "requestNo": "އެދުން",
        "approvedOn": "ހުއްދަދިން ތާރީޚް",
        "transfer": "ޓްރާންސްފަރ",
        "position": "ހާލަތު",
        "leftBank": "ބޭންކުން ނުކުމެއްޖެ",
        "awaitingRelease": "ރިލީޒަށް މަޑުކުރަނީ"
      }
    },
    "bankRelationships": {
      "title": "ބޭންކް ގުޅުންތައް",
      "description": "ފައިސާ ބަހައްޓާ ނުވަތަ ލޯނު ނަގާ ކޮންމެ ބޭންކެއް: އެ ބޭންކުގައި ހުރި ބާކީ އާއި އޭގެ ހިއްސާ، ދީފައިވާ ފެސިލިޓީތައް، ކައުންޓަރޕާޓީ ލިމިޓް އަދި ބާކީ ލިމިޓް.",
      "detailDescription": "މި ބޭންކުގައި ހުރި ބާކީ، ދީފައިވާ ފެސިލިޓީތައް، ކައުންޓަރޕާޓީ ލިމިޓް، އަދި ގުޅުމުގެ ކޮންޓެކްޓްތަކާއި ޓެރިފްތަކާއި ޗާޖުތައް.",
      "detailFailed": "މި ބޭންކް ގުޅުން ލޯޑް ނުކުރެވުނެވެ.",
      "back": "ހުރިހާ ބޭންކް ގުޅުމެއް",
      "summaryTitle": "ގުޅުން ({currency} އިން ހިސާބު)",
      "you": "ތިބާ",
      "reloaded": "ތިބާ އެޑިޓް ކުރަމުންދަނިކޮށް އެހެން މީހަކު މިއަށް ބަދަލު ގެނެސްފިއެވެ. އަލުން ލޯޑް ކުރެވިއްޖެ؛ ބަލާފައި އަލުން ސޭވް ކުރައްވާ.",
      "unconverted": "{currencies} އަށް ރޭޓެއް ނެތް: އެ ފައިސާތަކުގެ ބާކީ ހިސާބުތަކުގައި ނުހިމެނެއެވެ.",
      "facilitiesUnavailable": "ފެސިލިޓީގެ ހިސާބުތައް މިތާނގައި ނުދައްކައެވެ: ފެސިލިޓީ ސޯސެއް ރަޖިސްޓަރެއް ނުކުރެވޭ، އެހެންކަމުން ސުމެއް މާނައަކީ ބޭންކުން އެއްވެސް ލޯނެއް ނުދީ ކަމެއް ނޫނެވެ.",
      "primaryContact": "މައި ކޮންޓެކްޓް: {name}",
      "accountCount": "{total} ގެ ތެރެއިން {active} އެކްޓިވް",
      "ofFacilityLimit": "ނަގާފައި، ފެސިލިޓީ {count}، ލިމިޓް",
      "drawnOfLimit": "ނަގާފައި، ލިމިޓަކީ",
      "utilisation": "{pct} ބޭނުންކޮށްފައި",
      "noRate": "ރޭޓެއް ނެތް",
      "nav": {
        "label": "ބޭންކް ގުޅުންތައް",
        "description": "ބޭންކުތައް، ބާކީ، ފެސިލިޓީ، ކައުންޓަރޕާޓީ ލިމިޓް، ކޮންޓެކްޓް، ޓެރިފް އަދި ޗާޖު."
      },
      "routeTitles": {
        "register": "ބޭންކް ގުޅުންތައް",
        "detail": "ބޭންކް ގުޅުން"
      },
      "tabs": {
        "register": "ރަޖިސްޓަރު",
        "concentration": "ކޮންސެންޓްރޭޝަން",
        "variance": "ޓެރިފާ ޚިލާފު ޗާޖު",
        "accounts": "އެކައުންޓްތައް",
        "facilities": "ފެސިލިޓީތައް",
        "contacts": "ކޮންޓެކްޓްތައް",
        "tariffs": "ޓެރިފްތައް",
        "charges": "ޗާޖުތައް"
      },
      "filters": {
        "title": "ފިލްޓަރު",
        "search": "ބޭންކް",
        "currency": "ރިޕޯޓިންގ ފައިސާ",
        "currencyHint": "ތިން އަކުރު؛ ހުސްކޮށް ބަހައްޓައިފިނަމަ ފުރަތަމަ ލީގަލް އެންޓިޓީގެ ބޭސް ފައިސާ.",
        "asOf": "މި ތާރީޚަށް"
      },
      "register": {
        "loadFailed": "ބޭންކް ގުޅުންތައް ލޯޑް ނުކުރެވުނެވެ.",
        "emptyTitle": "އަދި ބޭންކެއް ނެތް",
        "emptyDescription": "ބޭންކް އެކައުންޓަކުން ރަޖިސްޓަރަށް ބޭންކެއް އިތުރުކުރުމުން އޭގެ ގުޅުން މިތާނގައި ފެންނާނެއެވެ.",
        "tableTitle": "ބޭންކުތައް"
      },
      "columns": {
        "bank": "ބޭންކް",
        "accounts": "އެކައުންޓް",
        "balance": "ހުރި ބާކީ",
        "balanceShare": "ބާކީގެ ހިއްސާ",
        "facilityExposure": "ފެސިލިޓީ އެކްސްޕޯޝަރ",
        "facilityShare": "ފެސިލިޓީގެ ހިއްސާ",
        "facilityLimit": "ފެސިލިޓީ ލިމިޓް",
        "limit": "ކައުންޓަރޕާޓީ ލިމިޓް",
        "headroom": "ބާކީ ލިމިޓް",
        "limitUtilisation": "ލިމިޓުން ބޭނުންކުރި",
        "actions": "ޢަމަލުތައް"
      },
      "fields": {
        "currency": "ފައިސާ",
        "feeType": "ފީގެ ބާވަތް",
        "account": "އެކައުންޓް",
        "bic": "ބީއައިސީ އަދި ޤައުމު"
      },
      "accountStatus": {
        "draft": "ޑްރާފްޓް",
        "pending_approval": "އެޕްރޫވަލަށް މަޑުކުރަނީ",
        "active": "އެކްޓިވް",
        "suspended": "ހުއްޓާލާފައި",
        "dormant": "ޑޯމަންޓް",
        "closing": "ބަންދުކުރަމުން",
        "closed": "ބަންދު"
      },
      "errors": {
        "required": "ލާޒިމް.",
        "currency": "ތިން އަކުރުގެ ފައިސާ ކޯޑެއް ޖައްސަވާ.",
        "money": "125.50 ފަދަ އަދަދެއް ޖައްސަވާ.",
        "percentRange": "0 އާއި 100 ދެމެދުގެ ޕަސެންޓެއް ޖައްސަވާ (1.5% އަށް 1.5)."
      },
      "limit": {
        "title": "ކައުންޓަރޕާޓީ ލިމިޓް",
        "set": "ލިމިޓެއް ކަނޑައަޅާ",
        "change": "ލިމިޓް ބަދަލުކުރޭ",
        "changeColumn": "ބަދަލު",
        "amount": "ލިމިޓް",
        "balance": "ހުރި ބާކީ (ލިމިޓުގެ ފައިސާއިން)",
        "breached": "ލިމިޓަށް ވުރެ މަތި",
        "breachedSince": "{date} އިން ފެށިގެން ލިމިޓަށް ވުރެ މަތި.",
        "unconverted": "{currencies} އަށް ރޭޓެއް ނެތް: އެ ބާކީތައް ހުރި ބާކީގައި ނުހިމެނޭ، އެހެންކަމުން ލިމިޓަށް ވުރެ ދަށް އަދަދަކީ ބޭންކު ލިމިޓުގެ ތެރޭގައިވާކަމުގެ ހެކިއެއް ނޫނެވެ.",
        "none": "ލިމިޓެއް ނެތް",
        "noneExplained": "މި ބޭންކަށް ކައުންޓަރޕާޓީ ލިމިޓެއް ކަނޑައަޅާފައެއް ނުވޭ، އެހެންކަމުން އެތާ ބަހައްޓާ ފައިސާއަށް ހަދެއް ނެތެވެ.",
        "noLimit": "ލިމިޓެއް ނެތް",
        "pendingBadge": {
          "set": "ކަނޑައެޅުން މަޑުކުރަނީ",
          "lower": "ދަށްކުރުން މަޑުކުރަނީ",
          "raise": "މަތިކުރުން މަޑުކުރަނީ",
          "clear": "ނައްތާލުން މަޑުކުރަނީ"
        },
        "pendingTitle": {
          "set": "ފުރަތަމަ ލިމިޓެއް އެޕްރޫވަލަށް މަޑުކުރަނީ",
          "lower": "ދަށް ލިމިޓެއް އެޕްރޫވަލަށް މަޑުކުރަނީ",
          "raise": "މަތިކުރުމެއް ދެވަނަ މީހަކަށް މަޑުކުރަނީ",
          "clear": "ލިމިޓް ނައްތާލުން ދެވަނަ މީހަކަށް މަޑުކުރަނީ"
        },
        "fromTo": "{from} އިން {to} {currency} އަށް",
        "reasonLine": "ސަބަބު: {reason}",
        "reason": "ސަބަބު",
        "requestedBy": "އެދުނީ {name}",
        "ownRequest": "މި ބަދަލަށް އެދުނީ ތިބާ، އެހެންކަމުން ތިބާއަށް އެޕްރޫވް ނުކުރެވޭނެއެވެ. އެޕްރޫވަލްސް އިންބޮކްސްގައި އެހެން މީހަކު ނިންމާނެއެވެ.",
        "decideInInbox": "މިކަން ނިންމަނީ އެޕްރޫވަލްސް އިންބޮކްސްގައި، އެދުނު މީހާ ނޫން މީހެކެވެ.",
        "openInbox": "އެޕްރޫވަލްސް އިންބޮކްސް ހުޅުވާ",
        "withdraw": "ދޫކޮށްލާ",
        "withdrawTitle": "މަޑުކުރާ ބަދަލު ދޫކޮށްލާ",
        "withdrawDescription": "އެޕްރޫވަލް ރިކުއެސްޓް ކެންސަލް ކުރެވޭނެ. ހިނގާ ލިމިޓަށް ބަދަލެއް ނާދޭނެއެވެ.",
        "withdrawNote": "ދޫކޮށްލާ ސަބަބު",
        "withdrawNoteRequired": "ބަދަލު ދޫކޮށްލާ ސަބަބު ބުނެދެއްވާ.",
        "withdrawn": "ބަދަލު ދޫކޮށްލެވިއްޖެ",
        "requested": "ބަދަލަށް އެދިއްޖެ",
        "requestedDetail": "މިއީ ދެވަނަ މީހަކަށް މަޑުކުރާ ބަދަލެއް (އެޕްރޫވަލް ރިކުއެސްޓް {request})؛ ހިނގާ ލިމިޓް ނުބަދަލުވެއެވެ.",
        "applied": "ލިމިޓް ހިންގައިފި",
        "historyTitle": "ލިމިޓުގެ ތާރީޚު",
        "historyFailed": "ލިމިޓުގެ ތާރީޚު ލޯޑް ނުކުރެވުނެވެ.",
        "historyEmpty": "މި ލިމިޓަށް އަދި އެއްވެސް ބަދަލެއް ނައެވެ.",
        "when": "އެދުނު ތާރީޚު",
        "direction": "ބާވަތް",
        "status": "ހާލަތު",
        "people": "މީހުން",
        "approvedBy": "އެޕްރޫވް ކުރީ {names}",
        "decidedBy": "ނިންމީ {name}",
        "directions": {
          "set": "ކަނޑައެޅުން",
          "lower": "ދަށްކުރުން",
          "raise": "މަތިކުރުން",
          "clear": "ނައްތާލުން"
        },
        "statuses": {
          "pending": "އެޕްރޫވަލަށް މަޑުކުރަނީ",
          "applied": "ހިންގައިފި",
          "rejected": "ރިޖެކްޓްކޮށްފި",
          "cancelled": "ދޫކޮށްލައިފި"
        }
      },
      "limitDialog": {
        "title": "ކައުންޓަރޕާޓީ ލިމިޓް: {bank}",
        "description": "މި ބޭންކުގައި ޖުމްލަކޮށް ބަހައްޓަން ބޭނުންވާ އެންމެ ގިނަ އަދަދު.",
        "current": "ހިނގާ ލިމިޓް:",
        "noCurrent": "އަދި ލިމިޓެއް ނުހިނގައެވެ.",
        "clear": "ލިމިޓް ނައްތާލާ",
        "clearHint": "ލިމިޓް ނައްތާލުމަކީ ލުއިކުރުމެއް، އެހެންކަމުން ދެވަނަ މީހަކު އެޕްރޫވް ކުރަން ޖެހޭނެއެވެ.",
        "amount": "އާ ލިމިޓް",
        "currencyFixed": "ލިމިޓެއް ހުރިހާ ހިނދަކު ބަދަލެއް ނުކުރެވޭނެ؛ ފައިސާ ބަދަލުކުރަން ފުރަތަމަ ލިމިޓް ނައްތާލާ.",
        "reason": "ސަބަބު",
        "submitRequest": "އެޕްރޫވަލަށް އެދޭ",
        "submitApply": "ހިންގާ",
        "intent": {
          "set": "ފުރަތަމަ ލިމިޓަކީ ދަތިކުރުމެއް، އެހެންކަމުން އެ ވަގުތުން ހިނގާނެއެވެ.",
          "lower": "ލިމިޓް ދަށްކުރުމަކީ ދަތިކުރުމެއް، އެހެންކަމުން އެ ވަގުތުން ހިނގާނެއެވެ.",
          "lowerWithdraws": "ލިމިޓް ދަށްކުރުން އެ ވަގުތުން ހިނގާނެ، އަދި އެޕްރޫވަލަށް މަޑުކުރާ މަތިކުރުން ނުވަތަ ނައްތާލުން ދޫކޮށްލެވޭނެއެވެ.",
          "raise": "ލިމިޓް މަތިކުރުމަކީ ލުއިކުރުމެއް: ދެވަނަ މީހަކަށް މަޑުކުރާނެ، އަދި އެމީހަކު އެޕްރޫވް ކުރަންދެން ހިނގާ ލިމިޓް ނުބަދަލުވާނެއެވެ.",
          "clear": "ލިމިޓް ނައްތާލުމަކީ ލުއިކުރުމެއް: ދެވަނަ މީހަކަށް މަޑުކުރާނެ، އަދި އެމީހަކު އެޕްރޫވް ކުރަންދެން ލިމިޓް ހިނގާނެއެވެ."
        },
        "blocked": {
          "pending": "މަތިކުރުމެއް ނުވަތަ ނައްތާލުމެއް އެޕްރޫވަލަށް މިހާރުވެސް މަޑުކުރަނީ. ފުރަތަމަ އެކަން ނިންމަން ނުވަތަ ދޫކޮށްލަން ޖެހޭނެ، ނުވަތަ ލިމިޓް ދަށްކުރެވިދާނެއެވެ.",
          "unchanged": "އެއީ މިހާރު ހިނގާ ލިމިޓެވެ."
        },
        "errors": {
          "invalid": "5000000.00 ފަދަ އަދަދެއް ޖައްސަވާ.",
          "zero": "ލިމިޓަކީ ސުމަށް ވުރެ މަތީ އަދަދެއް؛ ސުމަކަށް ހެދުމުގެ ބަދަލުގައި ނައްތާލާ.",
          "currency": "ފުރަތަމަ ލިމިޓަކަށް ތިން އަކުރުގެ ފައިސާއެއް ބޭނުންވެއެވެ.",
          "reason": "ލިމިޓް ބަދަލުވާ ސަބަބު ބުނެދެއްވާ.",
          "unresolvable": "ބޭންކް ލިމިޓް ލުއިކުރުމަށް ތިބާ ނޫން އެޕްރޫވަރެއް ކަނޑައަޅާފައެއް ނުވާތީ ރިކުއެސްޓް ފޮނުވޭކަށް ނެތެވެ."
        }
      },
      "contacts": {
        "add": "ކޮންޓެކްޓެއް އިތުރުކުރޭ",
        "loadFailed": "ކޮންޓެކްޓްތައް ލޯޑް ނުކުރެވުނެވެ.",
        "emptyTitle": "އަދި ކޮންޓެކްޓެއް ނެތް",
        "emptyDescription": "ރިލޭޝަންޝިޕް މެނޭޖަރާއި މި ބޭންކުގައި ގުޅާ މީހުން އިތުރުކުރައްވާ.",
        "name": "ނަން",
        "role": "މަޤާމު",
        "email": "އީމެއިލް",
        "phone": "ފޯނު",
        "notes": "ނޯޓު",
        "primary": "މައި",
        "makePrimary": "މައި ކޮންޓެކްޓް",
        "makePrimaryHint": "މި ކޮންޓެކްޓް މައި ކޮންޓެކްޓަށް ހެދުމުން މިހާރުގެ މައި ކޮންޓެކްޓް ބަދަލުވާނެއެވެ.",
        "editTitle": "ކޮންޓެކްޓް އެޑިޓްކުރޭ",
        "addTitle": "ކޮންޓެކްޓެއް އިތުރުކުރޭ",
        "nameRequired": "ކޮންޓެކްޓަކަށް ނަމެއް ބޭނުންވެއެވެ.",
        "saved": "ކޮންޓެކްޓް ސޭވްކުރެވިއްޖެ",
        "deleted": "ކޮންޓެކްޓް ފޮހެލެވިއްޖެ",
        "deleteFailed": "ކޮންޓެކްޓް ނުފޮހެލެވުނެވެ",
        "deleteTitle": "ކޮންޓެކްޓް ފޮހެލާ",
        "deleteMessage": "{name} މި ބޭންކުގެ ކޮންޓެކްޓްތަކުން ފޮހެލަންތަ؟"
      },
      "tariffs": {
        "add": "ޓެރިފް ލައިނެއް ފައިލްކުރޭ",
        "loadFailed": "ޓެރިފްތައް ލޯޑް ނުކުރެވުނެވެ.",
        "emptyTitle": "ޓެރިފެއް ނެތް",
        "emptyDescription": "ބޭންކުން ނަގާ ޗާޖުތައް ބަލައިލެވޭތޯ، އެއްބަސްވި ފީތައް ފައިލްކުރައްވާ.",
        "basis": "ބިންގާ",
        "fee": "ފީ",
        "bounds": "މަދުވެގެން އިން ގިނަވެގެން",
        "effective": "ހިނގާ މުއްދަތު",
        "description": "ތަފްސީލު",
        "bases": {
          "flat": "ފްލެޓް ފީ",
          "per_item": "ކޮންމެ އައިޓަމަކަށް",
          "percent": "އަދަދުގެ ޕަސެންޓް"
        },
        "fromTo": "{from} އިން {to} އަށް",
        "fromOpen": "{from} އިން ފެށިގެން",
        "inForce": "ހިނގަމުންދާ",
        "addTitle": "ޓެރިފް ލައިނެއް ފައިލްކުރޭ",
        "addDescription": "ފީގެ އެއް ބާވަތަކަށް ބޭންކުން ނަގަން އެއްބަސްވި އަދަދު، ތާރީޚަކުން ފެށިގެން.",
        "amountPerItem": "ކޮންމެ އައިޓަމަކަށް ފީ",
        "amountFlat": "ފީ",
        "ratePercent": "ރޭޓް",
        "ratePercentHint": "1.5% އަށް 1.5 ޖައްސަވާ.",
        "minAmount": "މަދުވެގެން ފީ",
        "maxAmount": "ގިނަވެގެން ފީ",
        "effectiveFrom": "ހިނގާ ތާރީޚު",
        "effectiveTo": "ނިމޭ ތާރީޚު",
        "effectiveToHint": "ނިމުމެއް ނެތް ލައިނަކަށް ހުސްކޮށް ބަހައްޓާ.",
        "supersedeNote": "އަދަދުތައް ދުވަހަކުވެސް އެޑިޓެއް ނުކުރެވޭ. އާ ލައިނަކުން ކުރީގެ ލައިން ބަދަލުކުރޭ: ނިމުމެއް ނެތް ކުރީގެ ލައިން މި ލައިން ފެށުމުގެ ކުރީ ދުވަހު ނިމޭނެ؛ އެހެން ބާވަތެއްގެ އޯވަރލެޕެއް ނުބައްލަވާނެއެވެ.",
        "file": "ލައިން ފައިލްކުރޭ",
        "editTitle": "ޓެރިފް ލައިން {feeType}",
        "editDescription": "ތަފްސީލު ބަދަލުކުރުން ނުވަތަ ނިމޭ ތާރީޚު ކުރިއަށް ގެނައުން. ފީ ބަދަލުކުރަން އާ ލައިނެއް ފައިލްކުރޭ.",
        "bringForwardHint": "ނިމޭ ތާރީޚު ކުރިއަށް ގެނެވިދާނެ، ފަހަތަށް ނުދެވޭނެއެވެ.",
        "toBeforeFrom": "ނިމޭ ތާރީޚު ފެށޭ ތާރީޚުގެ ކުރިން ނުވާނެއެވެ.",
        "cannotExtend": "ނިމޭ ތާރީޚު ކުރިއަށް ގެނެވިދާނެ ނަމަވެސް ދިގު ނުކުރެވޭނެ: ފަހުގެ މުއްދަތަށް އާ ލައިނެއް ފައިލްކުރޭ.",
        "created": "ޓެރިފް ލައިން ފައިލްކުރެވިއްޖެ",
        "updated": "ޓެރިފް ލައިން އަޕްޑޭޓްކުރެވިއްޖެ"
      },
      "charges": {
        "add": "ޗާޖެއް ރެކޯޑްކުރޭ",
        "loadFailed": "ޗާޖުތައް ލޯޑް ނުކުރެވުނެވެ.",
        "emptyTitle": "ޗާޖެއް ރެކޯޑްކޮށްފައެއް ނެތް",
        "emptyDescription": "ބޭންކުން ނެގި ފީތައް ޓެރިފާ އަޅާކިޔޭތޯ ރެކޯޑްކުރައްވާ.",
        "date": "ޗާޖުކުރި ތާރީޚު",
        "quantity": "އައިޓަމް",
        "basisAmount": "ޗާޖުކުރި އަދަދު",
        "basisAmountHint": "ޕަސެންޓް ޓެރިފަކަށް، ފީ ނެގި އަދަދު.",
        "amount": "ނެގި ފީ",
        "reference": "ރެފަރެންސް",
        "note": "ނޯޓު",
        "noTariffShort": "ޓެރިފެއް ނެތް",
        "void": "ބާތިލްކުރޭ",
        "addTitle": "ބޭންކް ޗާޖެއް ރެކޯޑްކުރޭ",
        "addDescription": "އެ ބޭންކުގައި ހުރި އެކައުންޓަކުން ބޭންކުން ނެގި ފީއެއް.",
        "pickAccount": "އެކައުންޓެއް ޚިޔާރުކުރޭ",
        "postsNothing": "ޗާޖެއް ރެކޯޑްކުރުމުން އެއްވެސް ޕޯސްޓިންގއެއް ނުވޭ. ބޭންކް ޗާޖުގެ ލެޖަރ އެންޓްރީ ހަދަނީ ރިކޮންސިލިއޭޝަނުންނެވެ.",
        "record": "ޗާޖު ރެކޯޑްކުރޭ",
        "voidTitle": "ޗާޖު ބާތިލްކުރޭ",
        "voidMessage": "{date} ގެ {feeType} ޗާޖު ބާތިލްކުރަންތަ؟ ވެރިއަންސް ރިޕޯޓުގައި އެ ނުގުނޭނެ؛ އޮޑިޓް ޓްރެއިލްގައި ހުންނާނެއެވެ.",
        "recorded": "ޗާޖު ރެކޯޑްކުރެވިއްޖެ",
        "noTariff": "އެ ތާރީޚަށް މި ފީގެ ބާވަތަށް ޓެރިފެއް ނެތެވެ.",
        "expectedWas": "ޓެރިފުން ބޭނުންވީ {expected} {currency}.",
        "voided": "ޗާޖު ބާތިލްކުރެވިއްޖެ",
        "voidFailed": "ޗާޖު ބާތިލް ނުކުރެވުނެވެ",
        "futureDate": "ބޭންކް ޗާޖަކަށް މުސްތަޤްބަލުގެ ތާރީޚެއް ނުޖެހޭނެއެވެ.",
        "quantityMin": "މަދުވެގެން 1 އައިޓަމް."
      },
      "accounts": {
        "loadFailed": "އެކައުންޓްތައް ލޯޑް ނުކުރެވުނެވެ.",
        "emptyTitle": "ހިނގާ އެކައުންޓެއް ނެތް",
        "emptyDescription": "މި ބޭންކުގައި ހިނގާ ބޭންކް އެކައުންޓެއް ނެތެވެ.",
        "status": "ހާލަތު",
        "balance": "ބާކީ",
        "balanceReporting": "{currency} އިން ބާކީ"
      },
      "facilities": {
        "loadFailed": "ފެސިލިޓީތައް ލޯޑް ނުކުރެވުނެވެ.",
        "emptyTitle": "ހިނގާ ފެސިލިޓީއެއް ނެތް",
        "emptyDescription": "މި ބޭންކުން ހިނގާ ފެސިލިޓީއެއް ދީފައެއް ނުވެއެވެ.",
        "code": "ފެސިލިޓީ",
        "limit": "ލިމިޓް",
        "drawn": "ނަގާފައި",
        "undrawn": "ނުނަގާ",
        "drawnReporting": "{currency} އިން ނަގާފައި"
      },
      "concentration": {
        "loadFailed": "ކޮންސެންޓްރޭޝަން ރިޕޯޓް ލޯޑް ނުކުރެވުނެވެ.",
        "title": "{asOf} ގެ ކޮންސެންޓްރޭޝަން ({currency})",
        "totalBalance": "ހުރި ޖުމްލަ ބާކީ",
        "totalFacilityLimit": "ޖުމްލަ ފެސިލިޓީ ލިމިޓް",
        "totalFacilityDrawn": "ޖުމްލަ ނަގާފައިވާ ފެސިލިޓީ"
      },
      "variance": {
        "title": "ޓެރިފާ ޚިލާފު ޗާޖު",
        "from": "ފެށޭ",
        "to": "ނިމޭ",
        "allBanks": "ހުރިހާ ބޭންކެއް",
        "loadFailed": "ޗާޖު ވެރިއަންސް ރިޕޯޓް ލޯޑް ނުކުރެވުނެވެ.",
        "emptyTitle": "މި މުއްދަތުގައި ޗާޖެއް ނެތް",
        "emptyDescription": "މި ތާރީޚުތަކުގެ ދެމެދުގައި ބޭންކް ޗާޖެއް ރެކޯޑްކޮށްފައެއް ނުވެއެވެ.",
        "count": "ޗާޖު",
        "charged": "ނެގި",
        "expected": "ބޭނުންވީ",
        "variance": "ތަފާތު",
        "untariffed": "ޓެރިފެއް ނެތް ޗާޖު",
        "untariffedCount": "ޗާޖު {n}",
        "status": "ނަތީޖާ",
        "statuses": {
          "over": "ގިނައިން ނަގާފައި",
          "under": "މަދުން ނަގާފައި",
          "match": "އެއްބަސްވި ގޮތަށް",
          "no_tariff": "ޓެރިފެއް ނެތް"
        },
        "total": "ޖުމްލަ {currency}",
        "rangeRequired": "ދެ ތާރީޚުވެސް ޚިޔާރުކުރޭ.",
        "rangeOrder": "ފެށޭ ތާރީޚު ނިމޭ ތާރީޚުގެ ފަހުގައި.",
        "rangeTooLong": "މުއްދަތު ގިނަވެގެން {days} ދުވަސް."
      },
      "preview": {
        "heading": "ކައުންޓަރޕާޓީ ލިމިޓް ބަދަލު",
        "noAccess": "ތިބާއަށް ބޭންކް ގުޅުންތައް ނުކިޔޭތީ ބަދަލު މިތާނގައި ނުދެއްކޭނެއެވެ.",
        "loadFailed": "ލިމިޓް ބަދަލު ލޯޑް ނުކުރެވުނެވެ.",
        "notFound": "މި ލިމިޓް ބަދަލު އޭގެ ބޭންކުގައި މަޑުކުރަމުނެއް ނުދޭ. ތާރީޚު ބަލަން ބޭންކް ގުޅުން ހުޅުވާ.",
        "current": "ހިނގާ ލިމިޓް",
        "proposed": "އެދުނު",
        "cleared": "ލިމިޓެއް ނެތް",
        "headroomNow": "މިހާރުގެ ބާކީ ލިމިޓް",
        "headroomAfter": "އެޕްރޫވް ކުރިއްޔާ ބާކީ ލިމިޓް",
        "unlimited": "ހަދެއް ނެތް",
        "requested": "އެދުނު ތާރީޚު",
        "open": "ބޭންކް ގުޅުން ހުޅުވާ"
      }
    },
    "capturePolicies": {
      "allWallets": "ހުރިހާ ވޮލެޓެއް",
      "approval": "ފާސްކުރުން",
      "approvalNotRequired": "ބޭނުމެއް ނުވޭ",
      "approvalRequired": "ބޭނުންވޭ",
      "blockCategory": "މި ބާވަތް މުޅިން މަނާކުރޭ",
      "blockedNote": "މަނާކުރެވިފައިވާ ބާވަތަކަށް ކޮންމެ ޚަރަދެއް، ކޮންމެ މީހަކަށް، އިސްތިސްނާއަކާ ނުލައި ރައްދުކުރެވޭނެއެވެ.",
      "caption": "ޚަރަދުގެ ބާވަތުން ރެކޯޑްކުރުމުގެ ސިޔާސަތުގެ ވަރޝަންތައް",
      "create": "އާ ސިޔާސަތެއް",
      "createDescription": "ކޮންމެ ބާވަތަކަށް: އެއް ފަހަރާ، ދުވާލަކަށް އަދި މަހަކަށް ޚަރަދުކުރެވޭނެ އަދަދު، އަދި ހެކި ބޭނުންވާ ވަގުތު.",
      "createTitle": "ރެކޯޑްކުރުމުގެ ސިޔާސަތެއް ހެދުން",
      "created": "ރެކޯޑްކުރުމުގެ ސިޔާސަތު ހެދިއްޖެ.",
      "currentOnly": "މިހާރުގެ ވަރޝަންތައް އެކަނި",
      "daily": "ދުވާލަކަށް",
      "defaultTaxCode": "ޑިފޯލްޓް ޓެކްސް ކޯޑު",
      "description": "ބަލަހައްޓާ ފަރާތުން ޚަރަދުކުރަން ޖެހޭ ލިމިޓްތައް، ޚަރަދުގެ ބާވަތުން. ސިޔާސަތެއް ބަދަލުކުރަނީ ތާރީޚަކުން ފެށިގެން އާ ވަރޝަނަކުންނެވެ، އެޑިޓެއް ނުކުރެވޭނެއެވެ.",
      "empty": "މި ޤާނޫނީ ފަރާތަށް ރެކޯޑްކުރުމުގެ ސިޔާސަތެއް ނެތް. ސިޔާސަތެއް ނެތި އެއްވެސް ބާވަތަކަށް ޚަރަދެއް ނުކުރެވޭނެއެވެ.",
      "evidenceAbove": "{ceiling} އަށްވުރެ މަތިން",
      "evidenceCeiling": "ހެކި ނުބޭނުންވާ ލިމިޓު",
      "evidenceCeilingHint": "މި އަދަދު ނުވަތަ މީގެ ދަށުގެ ޚަރަދުތަކަށް ރަސީދެއް ނުބޭނުންވާނެއެވެ.",
      "expenseAccount": "ޚަރަދުގެ އެކައުންޓް",
      "limitHint": "ލިމިޓެއް ނެތްނަމަ ހުސްކޮށް ބާއްވާ.",
      "loadFailed": "އެ ސިޔާސަތުތައް ނުލޯޑްވި",
      "monthly": "މަހަކަށް",
      "noEvidence": "ބޭނުމެއް ނުވޭ",
      "openEnded": "ނިމުމެއް ނެތް",
      "perTxn": "ކޮންމެ ޚަރަދަކަށް",
      "requiresApproval": "ޚަރަދަށް ފާސްކުރުން ބޭނުންވޭ",
      "requiresEvidence": "ލިމިޓަށްވުރެ މަތީގެ ޚަރަދަށް ހެކި ބޭނުންވޭ",
      "supersede": "އާ ވަރޝަނެއް",
      "supersedeConfirm": "އާ ވަރޝަނެއް ހަދާ",
      "supersedeDescription": "އާ ވަރޝަން ފެށޭނީ ތިޔަ ބޭފުޅާ ކަނޑައަޅާ ތާރީޚުންނެވެ؛ މިހާރުގެ ވަރޝަން ނިމޭނީ އޭގެ ކުރީ ދުވަހުއެވެ، އަދި ކިޔޭނެ ގޮތަށް ބާކީ ހުންނާނެއެވެ.",
      "supersedeFromHint": "މިހާރުގެ ވަރޝަން ފެށުނު ތާރީޚަށްވުރެ ފަހުން ވާން ޖެހޭނެއެވެ.",
      "supersedeNote": "{from} އިން ފެށިގެން ޢަމަލުކުރާ {code} ގެ އާ ވަރޝަނެއް.",
      "supersedeTitle": "ސިޔާސަތުގެ އާ ވަރޝަނެއް",
      "superseded": "ސިޔާސަތުގެ އާ ވަރޝަނެއް ހެދިއްޖެ.",
      "tab": "ރެކޯޑްކުރުމުގެ ސިޔާސަތު",
      "title": "ރެކޯޑްކުރުމުގެ ސިޔާސަތު",
      "walletHint": "މި ޤާނޫނީ ފަރާތުގެ ހުރިހާ ވޮލެޓަކަށް ހިނގުމަށް ހުސްކޮށް ބާއްވާ."
    },
    "concentration": {
      "title": "ކޭޝް ކޮންސެންޓްރޭޝަން",
      "description": "ބާކީތައް ހެޑަރ އެކައުންޓަށް ގެނައުމާއި، އެއިން ފަންޑް ދިނުމާއި، ނޮޝަނަލް ޕޫލެއް ނެޓް ކުރުމުގެ ސްވީޕް ސްޓްރަކްޗަރު. ސްޓްރަކްޗަރު ތައްޔާރުކުރަނީ އެކަކު، އެކްޓިވޭޓް ކުރަނީ އެހެން ފަރާތެއް. ސްވީޕް ފުރަތަމަ ސިމިއުލޭޓް ކުރެވި، އެ ސިމިއުލޭޝަން ހިންގެވޭނެ.",
      "create": "އައު ސްޓްރަކްޗަރ",
      "createTitle": "އައު ސްވީޕް ސްޓްރަކްޗަރ",
      "editTitle": "ސްވީޕް ސްޓްރަކްޗަރ އެޑިޓް ކުރޭ",
      "formDescription": "ހެޑަރ އެކައުންޓް، ބައިވެރިން، ކެލެންޑަރ އާއި ކަޓްއޮފް. ބަދަލެއް އަލުން ހުއްދަ ދޭނީ ދެވަނަ ފަރާތެކެވެ.",
      "reauthoriseNote": "މި ސްޓްރަކްޗަރ ސަސްޕެންޑް ކޮށްފައި. ބަދަލެއް ރައްކާކޮށްފިނަމަ ޑްރާފްޓަށް އެނބުރި، ދެވަނަ ފަރާތަކުން އަލުން އެކްޓިވޭޓް ކުރަންޖެހޭ.",
      "reloaded": "މި ސްޓްރަކްޗަރ އެހެން ފަރާތަކުން ބަދަލުކޮށް އަލުން ލޯޑް ކުރެވިއްޖެ. ތިޔަ ލިޔުންތައް ބާކީ. ބަލާ އަލުން ސޭވް ކުރޭ.",
      "saved": "ސްޓްރަކްޗަރ ސޭވް ކުރެވިއްޖެ.",
      "created": "ސްޓްރަކްޗަރ {code} ތައްޔާރުކުރެވިއްޖެ. ދެވަނަ ފަރާތަކުން އެކްޓިވޭޓް ކުރަންޖެހޭ.",
      "anyKind": "ކޮންމެ ބާވަތެއް",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "loadFailed": "ސްވީޕް ސްޓްރަކްޗަރުތައް ލޯޑް ނުކުރެވުނު.",
      "emptyTitle": "ސްވީޕް ސްޓްރަކްޗަރެއް ނެތް",
      "emptyDescription": "ކޭޝް ހެޑަރ އެކައުންޓަށް ކޮންސެންޓްރޭޓް ކުރުމަށް ސްޓްރަކްޗަރެއް ތައްޔާރުކުރޭ. ދެން ތައްޔާރުކުރި މީހާ ނޫން ފަރާތަކުން އެކްޓިވޭޓް ކުރޭ.",
      "tableTitle": "ސްވީޕް ސްޓްރަކްޗަރުތައް",
      "detailTitle": "ސްވީޕް ސްޓްރަކްޗަރ",
      "detailFailed": "ސްވީޕް ސްޓްރަކްޗަރ ލޯޑް ނުކުރެވުނު.",
      "crossEntity": "ލީގަލް އެންޓިޓީތަކުގެ މެދު",
      "activate": "އެކްޓިވޭޓް",
      "activateTitle": "މި ސްޓްރަކްޗަރ އެކްޓިވޭޓް ކުރޭ",
      "activateDescription": "ކޮންސެންޓްރޭޓް ކުރެވޭ ފައިސާ ދާންވީ ތަނަށް ހުއްދަ ދޭ ދެވަނަ ފަރާތަކީ ތިޔަ. ތިޔަ ތައްޔާރުކުރި ނުވަތަ ފަހުން ޝަރުތު ބަދަލުކުރި މީހަކަށް ނުވެވޭނެ.",
      "activated": "ސްޓްރަކްޗަރ އެކްޓިވޭޓް ކުރެވިއްޖެ.",
      "activatedAt": "އެކްޓިވޭޓް ކުރި ވަގުތު",
      "activationNote": "އެކްޓިވޭޝަން ނޯޓް",
      "suspend": "ސަސްޕެންޑް",
      "suspendTitle": "މި ސްޓްރަކްޗަރ ސަސްޕެންޑް ކުރޭ",
      "suspendDescription": "ސަސްޕެންޑް ކުރެވިފައިވާ ސްޓްރަކްޗަރ ސިމިއުލޭޓް ނުވަތަ އެގްޒެކިއުޓް ނުކުރެވޭނެ. އަލުން އެކްޓިވޭޓް ކުރުމަށް ދެވަނަ ފަރާތެއް ބޭނުން.",
      "suspendReason": "ސަސްޕެންޑް ކުރުމުގެ ސަބަބު",
      "suspended": "ސްޓްރަކްޗަރ ސަސްޕެންޑް ކުރެވިއްޖެ.",
      "deleted": "ސްޓްރަކްޗަރ ފޮހެލެވިއްޖެ.",
      "deleteTitle": "މި ޑްރާފްޓް ފޮހެލާ",
      "deleteMessage": "ޑްރާފްޓް ނައްތާލެވޭނެ. ސިމިއުލޭޝަނެއް ރެކޯޑުކޮށްފައިވާ ސްޓްރަކްޗަރެއް ސަސްޕެންޑް ކުރެވޭނެ.",
      "awaitingSecondPerson": "މި ސްޓްރަކްޗަރ އެކްޓިވޭޓް ކުރަންވީ ދެވަނަ ފަރާތަކުން. ތިޔަ ތައްޔާރުކުރި ނުވަތަ ފަހުން ޝަރުތު ބަދަލުކުރީމާ ތިޔަ އެކްޓިވޭޓް ނުކުރެވޭނެ.",
      "faultsTitle": "ސްޓްރަކްޗަރ އެކްޓިވޭޓް، ސިމިއުލޭޓް ނުވަތަ އެގްޒެކިއުޓް ކުރުމަށް ހުރަސްކުރާ ކަންތައްތައް:",
      "entityHint": "ހެޑަރ އެކައުންޓްތައް ކުޑަކުރޭ. ބައިވެރިން އެހެން ލީގަލް އެންޓިޓީއަކަށް ވެސް ނިސްބަތްވެދާނެ.",
      "headerHint": "ފައިސާ ކޮންސެންޓްރޭޓް ކުރެވޭ ނުވަތަ ފަންޑް ދެވޭ އެކައުންޓް. ސްޓްރަކްޗަރު އޭގެ ލީގަލް އެންޓިޓީ އާއި ކަރަންސީ ނަގާނެ.",
      "cutoffHint": "އޮޕަރޭޓިންގ ކެލެންޑަރުގެ ޓައިމްޒޯނުގައި HH:MM. އޭގެ ފަހުން އެގްޒެކިއުޓް ކުރެވޭ ސްވީޕް ދެން އަންނަ ބިޒްނަސް ދުވަހަށް ފަހުނަވާ.",
      "tabs": {
        "terms": "ޝަރުތުތައް",
        "simulation": "ސިމިއުލޭޓް އަދި އެގްޒެކިއުޓް",
        "history": "ހިސްޓްރީ"
      },
      "kind": {
        "zero_balance": "ޒީރޯ ބެލެންސް",
        "target_balance": "ޓާގެޓް ބެލެންސް",
        "threshold": "ތްރެޝޯލްޑް",
        "notional": "ނޮޝަނަލް ޕޫލް"
      },
      "kindHint": {
        "zero_balance": "ކޮންމެ ބައިވެރިއެއްގެ ބާކީ ސުން ކޮށް ހެޑަރަށް ގެނެސްދޭ.",
        "target_balance": "ކޮންމެ ބައިވެރިއަކު އޭގެ ޓާގެޓް ބެލެންސަށް ގެނެސްދޭ، ދެފަރާތަށްވެސް.",
        "threshold": "ތްރެޝޯލްޑްއަށް ވުރެ މައްޗަށް ހުރި ބައިވެރިއެއް، ޓާގެޓެއް ހުރިނަމަ އެއަށް ކުޑަކުރެވޭ.",
        "notional": "ކޭޝް ހަރަކާތެއް ނުވޭ. ޕޫލްގެ ޕޮޒިޝަން ނެޓް ކޮށް ރެކޯޑް ކުރެވޭ."
      },
      "status": {
        "draft": "ޑްރާފްޓް",
        "active": "އެކްޓިވް",
        "suspended": "ސަސްޕެންޑް ކުރެވިފައި"
      },
      "runStatus": {
        "simulated": "ސިމިއުލޭޓް ކުރެވިފައި",
        "executed": "އެގްޒެކިއުޓް ކުރެވިފައި",
        "recorded": "ރެކޯޑް ކުރެވިފައި",
        "deferred": "ފަސްކުރެވިފައި"
      },
      "fields": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "kind": "ބާވަތް",
        "entity": "ލީގަލް އެންޓިޓީ",
        "headerAccount": "ހެޑަރ އެކައުންޓް",
        "calendar": "އޮޕަރޭޓިންގ ކެލެންޑަރ",
        "cutoffTime": "ކަޓްއޮފް",
        "notes": "ނޯޓްތައް",
        "account": "ބޭންކް އެކައުންޓް",
        "target": "ޓާގެޓް ބެލެންސް",
        "threshold": "ތްރެޝޯލްޑް",
        "instrument": "އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓް"
      },
      "participants": {
        "title": "ބައިވެރިން",
        "hint": "ހެޑަރަށް ސްވީޕް ކުރެވޭ ނުވަތަ ހެޑަރުން ފަންޑް ލިބޭ އެކައުންޓްތައް. ޒީރޯ ބެލެންސް ނުވަތަ ނޮޝަނަލް ބައިވެރިއަކަށް ޓާގެޓެއް ނެތް. ލީގަލް އެންޓިޓީތަކުގެ މެދު ހަރަކާތަކަށް އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓެއް ބޭނުން.",
        "add": "ބައިވެރިއެއް އިތުރުކުރޭ",
        "instrumentHint": "މި އެކައުންޓުގެ ލީގަލް އެންޓިޓީ އާއި ހެޑަރުގެ ލީގަލް އެންޓިޓީގެ މެދުގައި، ސްޓްރަކްޗަރުގެ ކަރަންސީގައި ހުރި އިންސްޓްރުމެންޓްތައް."
      },
      "evidence": {
        "title": "ސެޓްއޮފްގެ ޙައްޤުގެ ހެކި",
        "required": "މި ޕޫލް ލީގަލް އެންޓިޓީތަކުގެ މެދުގައި ހުރި. އެ އެންޓިޓީތަކުގެ މެދު ސެޓްއޮފްގެ ޙައްޤުގެ ހެކިނެތި އެކްޓިވޭޓް، ސިމިއުލޭޓް ނުވަތަ ނެޓް ނުކުރެވޭނެ.",
        "optional": "ބައިވެރިއަކު ހެޑަރަށް ވުރެ އެހެން ލީގަލް އެންޓިޓީއަކަށް ނިސްބަތްވާނަމައެކަނި ބޭނުންވާނެ.",
        "current": "ހެކި ފައިލުކޮށްފައި (އެޓޭޗްމަންޓް {id}). ބަދަލުކުރަން ފައިލެއް ޚިޔާރުކުރޭ.",
        "file": "ހެކީގެ ފައިލް",
        "fileHint": "PDF، ފޮޓޯ، ސްޕްރެޑްޝީޓް ނުވަތަ ޑޮކިއުމަންޓް، {mb} އެމްބީ އަށް ވަންދެން.",
        "clear": "ފައިލުކޮށްފައިވާ ހެކި ނައްތާލާ",
        "savedButNotAttached": "ސްޓްރަކްޗަރ ސޭވް ކުރެވުނު، ނަމަވެސް ހެކި އެޓޭޗް ނުކުރެވުނު.",
        "retry": "ހެކި އެޓޭޗް ކުރޭ"
      },
      "errors": {
        "stale": "ސިމިއުލޭޓް ކުރެވުނުފަހުން ބެލެންސް ނުވަތަ ޝަރުތު ބަދަލުވެއްޖެ. އަލުން ސިމިއުލޭޓް ކުރޭ.",
        "expired": "މި ސިމިއުލޭޝަން ހަމަވެއްޖެ. އަލުން ސިމިއުލޭޓް ކުރޭ.",
        "mandateMissing": "މި ސްވީޕުން އިންސްޓްރަކްޓް ކުރާ ހަރަކާތަކަށް ހުއްދަ ދޭ ބޭންކް މެންޑޭޓެއް ނެތް.",
        "notConfigured": "ސްޓްރަކްޗަރު ފުރިހަމައަށް ކޮންފިގަރ ކުރެވިފައެއް ނުވޭ.",
        "secondPerson": "މި ސްޓްރަކްޗަރ އެކްޓިވޭޓް ކުރަންވީ ދެވަނަ ފަރާތަކުން: ތައްޔާރުކުރި މީހާ ނޫން، ފަހުން ޝަރުތު ބަދަލުކުރި މީހާވެސް ނޫން."
      },
      "direction": {
        "to_header": "ހެޑަރަށް",
        "from_header": "ހެޑަރުން",
        "none": "ހަރަކާތެއް ނެތް"
      },
      "movementOutcome": {
        "planned": "ރޭވިފައި",
        "instructed": "އިންސްޓްރަކްޓް ކުރެވިފައި",
        "none": "ނެތް",
        "skipped": "ދޫކޮށްލެވިފައި",
        "blocked": "ބްލޮކް ކުރެވިފައި",
        "deferred": "ފަސްކުރެވިފައި"
      },
      "execution": {
        "instructed": "އެގްޒެކިއުޓް ކުރެވިއްޖެ. ހަރަކާތްތައް ޓްރާންސްފަރ އިންސްޓްރަކްޝަންތަކަށް ވެ، ކޭޝް މޮޑިއުލްގެ އަމިއްލަ ހުއްދަ، ސޮއި އާއި ރިލީޒް އަށް ދަނީ.",
        "recorded": "ރެކޯޑް ކުރެވިއްޖެ. ނޮޝަނަލް ޕޫލްގެ ޕޮޒިޝަން ރެކޯޑްކޮށް ކޭޝް ހަރަކާތެއް ނުވޭ.",
        "deferred": "ކަޓްއޮފް ފާއިތުވެފައި. އެއްވެސް އިންސްޓްރަކްޝަނެއް ނުކުރެވުނު.",
        "deferredDetail": "ސްވީޕް {date} އަށް ފަސްކުރެވި ފަސްކުރުން ރެކޯޑް ކުރެވިއްޖެ.",
        "simulateDeferred": "{date} ސިމިއުލޭޓް ކުރޭ"
      },
      "simulation": {
        "title": "ސިމިއުލޭޝަން {id}",
        "date": "ބިޒްނަސް ތާރީޚް",
        "dateHint": "ކެލެންޑަރުގެ ދަށުން ވިޔަފާރި ނުކުރެވޭ ތާރީޚެއް ދެން އަންނަ ބިޒްނަސް ދުވަހަށް ބަދަލުވޭ.",
        "run": "ސިމިއުލޭޓް",
        "suspendedNote": "މި ސްޓްރަކްޗަރ ސަސްޕެންޑް ކުރެވިފައި ހުރީމަ ސިމިއުލޭޓް ނުކުރެވޭ.",
        "loadFailed": "ސިމިއުލޭޝަން ލޯޑް ނުކުރެވުނު.",
        "emptyTitle": "ސިމިއުލޭޝަނެއް ޚިޔާރުކޮށްފައެއް ނުވޭ",
        "emptyDescription": "އެއްވެސް ކަމެއް އެގްޒެކިއުޓް ކުރުމުގެ ކުރިން ކޮންމެ ބައިވެރިއެއްގެ ހަރަކާތް ބެލުމަށް ބިޒްނަސް ތާރީޚެއް ސިމިއުލޭޓް ކުރޭ، ނުވަތަ ހިސްޓްރީއިން އެއް ހުޅުވާލާ.",
        "valueDate": "ވެލިއު ތާރީޚް",
        "effectiveDate": "އަމަލުވާ ތާރީޚް",
        "cutoffAt": "ކަޓްއޮފް",
        "expiresAt": "ވަނަ ވަގުތާ ހަމައަށް",
        "header": "ހެޑަރ",
        "headerBefore": "ހެޑަރު ބެލެންސް (ކުރިން)",
        "headerAfter": "ހެޑަރު ބެލެންސް (ފަހުން)",
        "totalToHeader": "ހެޑަރަށް ގެންދިޔަ",
        "totalFromHeader": "ހެޑަރުން ގެންދިޔަ",
        "shifted": "{date} އަށް ބަދަލުވި: {reason}",
        "cutoffWarning": "މި ތާރީޚަށް ކަޓްއޮފް ފާއިތުވެފައި. މިހާރު އެގްޒެކިއުޓް ކޮށްފިނަމަ ސްވީޕް {date} އަށް ފަސްކޮށް ފަސްކުރުން ރެކޯޑް ކުރެވޭ.",
        "deferred": "{date} އަށް ފަސްކުރެވިފައި.",
        "deferralRecorded": "ރެކޯޑް ކުރެވުނު ވަގުތު",
        "poolTitle": "ނޮޝަނަލް ޕޫލް",
        "poolNet": "ނެޓް ޕޮޒިޝަން",
        "poolEvidence": "އެޓޭޗްމަންޓް {id} ގައި ހުރި ސެޓްއޮފްގެ ހެކީގެ މައްޗަށް ލީގަލް އެންޓިޓީތަކުގެ މެދު ނެޓް ކުރެވިފައި.",
        "poolNoEvidence": "ސެޓްއޮފްގެ ޙައްޤުގެ ހެކި ފައިލުކޮށްފައެއް ނެތް.",
        "poolEntityNet": "ނެޓް",
        "movements": "ހަރަކާތްތައް",
        "before": "ކުރިން ބެލެންސް",
        "direction": "ދިމާލު",
        "amount": "އަދަދު",
        "after": "ފަހުން ބެލެންސް",
        "outcome": "ނަތީޖާ",
        "movementDeferredTo": "{date} އަށް ފަސްކުރެވިފައި",
        "instruction": "އިންސްޓްރަކްޝަން {id}",
        "execute": "މި ސިމިއުލޭޝަން އެގްޒެކިއުޓް ކުރޭ",
        "resimulate": "އަލުން ސިމިއުލޭޓް ކުރޭ",
        "blocked": {
          "structureNotActive": "ސްޓްރަކްޗަރު އެކްޓިވް ނޫން، ފަހެ މި ސިމިއުލޭޝަން އެގްޒެކިއުޓް ނުކުރެވޭ.",
          "executed": "މި ސިމިއުލޭޝަން އެގްޒެކިއުޓް ކުރެވިފައި.",
          "recorded": "މި ސިމިއުލޭޝަން ރެކޯޑް ކުރެވިފައި. އެއްވެސް ހަރަކާތެއް ނުވޭ.",
          "deferred": "މި ސްވީޕް {date} އަށް ފަސްކުރެވިފައި. އެ ތާރީޚް އަލުން ސިމިއުލޭޓް ކޮށް ހިންގާ.",
          "expired": "މި ސިމިއުލޭޝަން ހަމަވެއްޖެ. އަލުން ސިމިއުލޭޓް ކުރޭ.",
          "blocked": "މި ސިމިއުލޭޝަންގެ ހަރަކާތެއް ބްލޮކް ކުރެވިފައި ހުރީމަ އެގްޒެކިއުޓް ނުކުރެވޭ. ސަބަބު ހަރަކާތުގައި ދައްކާ."
        }
      },
      "history": {
        "loadFailed": "ސިމިއުލޭޝަންތައް ލޯޑް ނުކުރެވުނު.",
        "emptyTitle": "ސިމިއުލޭޝަނެއް ނެތް",
        "emptyDescription": "މި ސްޓްރަކްޗަރަށް އަދި އެއްވެސް ސިމިއުލޭޝަނެއް ނުކުރެވޭ.",
        "simulated": "ސިމިއުލޭޓް ކުރި ވަގުތު",
        "executed": "އެގްޒެކިއުޓް ކުރި ވަގުތު",
        "deferredTo": "{date} އަށް ފަސްކުރެވިފައި"
      }
    },
    "accrualRun": {
      "accrualsCaption": "މި ރަންގައި ކޮންމެ ފެސިލިޓީއަކަށް އެކުލެވުނު އިންޓަރެސްޓާއި ފީ",
      "accrualsEmpty": "މި ރަނުން އެއްވެސް އެއްޗެއް އެކުލެއްވިފައެއް ނުވެއެވެ. ބެލި ހުރިހާ ފެސިލިޓީއެއް ދޫކޮށްލެވިފައިވެއެވެ؛ ސަބަބުތައް ތިރީގައި.",
      "accrualsTitle": "އެކުލެވުންތައް",
      "backToRuns": "އެކުލެވުމުގެ ރަންތައް",
      "description": "މި ރަނުން ޕޯސްޓްކުރި ޖާނަލް، ހިސާބުތަކާއެކު އެކުލެވުނު ކޮންމެ ފެސިލިޓީއެއް، އަދި ދޫކޮށްލެވުނު ކޮންމެ ފެސިލިޓީއެއް.",
      "factsTitle": "ރަން",
      "loadFailed": "އެ އެކުލެވުމުގެ ރަން ނުލޯޑްވި",
      "skippedDescription": "ދޫކޮށްލެވުނު ފެސިލިޓީއެއް މި މުއްދަތަށް އެކުލެވިފައެއް ނުވެއެވެ. ސަބަބު ހައްލުކޮށް، މުއްދަތު އަލުން ރަންކުރައްވާ؛ ކުރިން އެކުލެވުނު ފެސިލިޓީތައް ދެވަނަ ފަހަރަކަށް ނުބެލޭނެއެވެ.",
      "title": "އެކުލެވުމުގެ ރަން: {period}"
    },
    "accrualRuns": {
      "caption": "އިންޓަރެސްޓް އެކުލެވުމުގެ ރަންތަކާއި ކޮންމެ ރަނަކުން ޕޯސްޓްކުރި ޖާނަލް",
      "description": "ކޮންމެ ޤާނޫނީ ފަރާތަކަށް ކޮންމެ މާލީ މުއްދަތަކަށް އެއް ރަނުން، ހުރިހާ އެކްޓިވް ފެސިލިޓީއަކަށް އެއް ޖާނަލް ޕޯސްޓްކުރެއެވެ. އާ ރަންތައް ކުރިއަށް.",
      "emptyDescription": "މި ޤާނޫނީ ފަރާތުގެ ހުރިހާ އެކްޓިވް ފެސިލިޓީއެއްގެ އިންޓަރެސްޓާއި ކޮމިޓްމަންޓް ފީ ޕޯސްޓްކުރުމަށް މުއްދަތަކަށް އެކުލެވުން ރަންކުރައްވާ.",
      "emptyTitle": "އަދި އެއްވެސް އެކުލެވުމުގެ ރަނެއް ނެތް",
      "facilitiesFailed": "މި ރަނުން ބަލާނެ ފެސިލިޓީތައް ނުލޯޑްވި",
      "facilityCount": "ފެސިލިޓީތައް",
      "loadFailed": "އެ އެކުލެވުމުގެ ރަންތައް ނުލޯޑްވި",
      "needsObservation": "ރޭޓް އޮބްޒަވޭޝަނެއް ބޭނުންވޭ",
      "noActiveFacilities": "މި ޤާނޫނީ ފަރާތުގައި އެކްޓިވް ފެސިލިޓީއެއް ނެތެވެ. މިހާރު ރަންކުރިޔަސް އެއްވެސް އެއްޗެއް ނުއެކުލެވޭނެއެވެ.",
      "noJournal": "ޖާނަލެއް ނެތް",
      "nothingPosted": "އެއްވެސް އެއްޗެއް ޕޯސްޓްނުކުރެވުނެވެ. {period} އަށް ހުރިހާ އެކްޓިވް ފެސިލިޓީއަކަށް ވަނީ އެކުލެވުމެއް ނުވަތަ ރެކޯޑްކުރެވިފައިވާ ދޫކޮށްލުމެއް.",
      "onDate": "މި ތާރީޚު ހިމެނޭ މުއްދަތު އެކުލައްވާ",
      "onDateHint": "މިއަދަށް ހުސްކޮށް ބާއްވާ (ތިޔަ ޖަމްޢިއްޔާގެ ޓައިމްޒޯން). މި ތާރީޚު ވެއްޓޭ މުޅި މާލީ މުއްދަތު އެކުލެވޭނެއެވެ.",
      "openFacilities": "ދަރަނީގެ ފެސިލިޓީތައް",
      "openRun": "ރަން ހުޅުއްވާ",
      "processed": "އެކުލެވުނު ފެސިލިޓީތައް",
      "reviewCaption": "މި ރަނުން ބަލާނެ އެކްޓިވް ފެސިލިޓީތައް",
      "reviewNote": "ރަނުން ބަލާނެ އެއްޗެހި ރިވިއުކުރައްވާ. މިތާގައި އެއްވެސް އިންޓަރެސްޓެއް އަންދާޒާ ނުކުރެއެވެ: ރަން ޕޯސްޓްކުރާއިރު ހުރިހާ އަދަދެއް ސަރވަރު ހިސާބުކުރެއެވެ، އަދި މުއްދަތު ފެށުމުގެ ކުރިން ރޭޓް އޮބްޒަވޭޝަނެއް ނެތް ފްލޯޓިންގ ފެސިލިޓީއެއް ދޫކޮށްލެވޭނެއެވެ، ސުމެއްގައި ނޫނެވެ.",
      "run": "އެކުލެވުން ރަންކުރައްވާ",
      "runConfirm": "އެކުލެވުން ޕޯސްޓްކުރައްވާ",
      "runDate": "ރަންކުރި ތާރީޚު",
      "runDescription": "މި ޤާނޫނީ ފަރާތާއި މުއްދަތަށް އެއް ޖާނަލް ޕޯސްޓްކުރެއެވެ: ޑރ އިންޓަރެސްޓް ޚަރަދު، ކރ ދައްކަންޖެހޭ އިންޓަރެސްޓް.",
      "runTitle": "އިންޓަރެސްޓް އެކުލެވުން ރަންކުރުން",
      "skipped": "ދޫކޮށްލެވުނު",
      "skippedTitle": "ދޫކޮށްލެވުނު ފެސިލިޓީތައް",
      "tableTitle": "ރަންތައް",
      "title": "އިންޓަރެސްޓް އެކުލެވުން"
    },
    "debtMaturity": {
      "allEntities": "ހުރިހާ ޤާނޫނީ ފަރާތެއް",
      "noEntities": "ތިޔަ ބޭފުޅާއަށް އެއްވެސް ޤާނޫނީ ފަރާތެއް ނުފެނޭތީ، ދެއްކޭނެ ލެޑަރެއް ނެތެވެ.",
      "showAll": "ހުރިހާ ޤާނޫނީ ފަރާތެއް ދައްކާ"
    },
    "debtOps": {
      "agreementRef": "އެގްރީމެންޓް ރެފަރެންސް",
      "editDescription": "ފެސިލިޓީ އަދި ޑްރާފްޓްކޮށް ހުއްޓައި ޝަރުޠުތައް ރަނގަޅުކުރައްވާ. ބަދަލުކުރައްވާ ފީލްޑްތައް އެކަނި ފޮނުވޭނެއެވެ.",
      "editDraftNote": "ޝަރުޠުތައް ބަދަލުކުރެވޭނީ ފެސިލިޓީ ޑްރާފްޓްކޮށް ހުރިއިރު އެކަންޏެވެ. އެކްޓިވްވުމަށްފަހު ބަދަލަކީ އިސްލާޙެއް، ނުވަތަ އެޑިޓެއް ނޫނެވެ.",
      "editTitle": "ފެސިލިޓީގެ ޝަރުޠުތައް އެޑިޓްކުރުން",
      "edited": "ފެސިލިޓީ {code} އަޕްޑޭޓްކުރެވިއްޖެ.",
      "errors": {
        "ERR_DEBT_LIMIT_EXCEEDED": "އެއީ ފެސިލިޓީގެ ލިމިޓް ފަހަނައަޅާ ގޮތެވެ.",
        "ERR_PERIOD_CLOSED": "އެ ތާރީޚު ވެއްޓެނީ ބަންދުކުރެވިފައިވާ މުއްދަތެއްގައެވެ. ހުޅުވިފައިވާ މުއްދަތެއްގެ ތާރީޚެއް ޚިޔާރުކުރައްވާ.",
        "ERR_ROW_VERSION": "މި ރެކޯޑު ކުރިން އެހެން މީހަކު ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑްކުރެވިއްޖެ؛ ބައްލަވާފައި ތިޔަ ބަދަލު އަލުން ކުރައްވާ."
      },
      "limitHint": "{currency} އިން. ކުރިން ނަގާފައިވާ އަދަދަށްވުރެ ދަށަކަށް ނުކުރެވޭނެއެވެ.",
      "noLongerReversible": "އެ އެންޓްރީ މިހާރު ޕޯސްޓްކުރެވިފައެއް ނުވާތީ، ރިވާސްކުރާނެ އެއްޗެއް ނެތެވެ.",
      "notes": "ނޯޓްތައް",
      "capBelowFloor": "ރޭޓް ކެޕް ރޭޓް ފްލޯއަށްވުރެ ދަށްވެގެން ނުވާނެއެވެ.",
      "rateHint": "8.75% އަށް 8.75 ލިޔުއްވާ.",
      "rateRange": "އިންސައްތަ 0 އާއި 100 އާ ދެމެދު ހުންނަންވާނެއެވެ.",
      "reasonHint": "ލާޒިމު. ރިވާސަލް ޖާނަލާއި އޮޑިޓް ޓްރެއިލްގައި ލިޔެވޭނެއެވެ.",
      "reloaded": "މި ރެކޯޑު ކުރިން އެހެން މީހަކު ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑްކުރެވިއްޖެ؛ ބައްލަވާފައި ތިޔަ ބަދަލު އަލުން ކުރައްވާ.",
      "reversalDate": "ރިވާސަލްގެ ތާރީޚު",
      "reversalDateHint": "މިއަދަށް ހުސްކޮށް ބާއްވާ. ތާރީޚު ހުޅުވިފައިވާ މުއްދަތެއްގައި ވާންޖެހޭނެއެވެ.",
      "reverse": "ރިވާސްކުރައްވާ",
      "reverseConfirm": "ރިވާސަލް ޕޯސްޓްކުރައްވާ",
      "reverseDescription": "އަސްލު ޖާނަލްގެ އިދިކޮޅު ޖާނަލް ޕޯސްޓްކުރެއެވެ. އަސްލު ރެކޯޑު ބާކީ ހުންނާނެއެވެ.",
      "reverseDrawdownTitle": "ޑްރޯޑައުނެއް ރިވާސްކުރުން",
      "reverseNote": "ރިވާސަލެއް މިތާނގައި އަނބުރާ ނުކުރެވޭނެއެވެ. އަސްލު ރަނގަޅުނަމަ، ކެންސަލްކުރައްވާ.",
      "reverseRepaymentTitle": "އަނބުރާ ދެއްކުމެއް ރިވާސްކުރުން",
      "reversed": "ރިވާސަލް ޕޯސްޓްކުރެވިއްޖެ.",
      "reversedBy": "ރިވާސްކުރީ"
    },
    "rateObservations": {
      "caption": "ރެފަރެންސް ރޭޓްގެ އޮބްޒަވޭޝަންތައް",
      "description": "ފްލޯޓިންގ ފެސިލިޓީއެއް އެކުލެވެނީ ކޮންމެ މުއްދަތެއް ފެށުމުގެ ކުރިން ނުވަތަ އެދުވަހު، އޭގެ ރެފަރެންސް ރޭޓްގެ އެންމެ ފަހުގެ އޮބްޒަވޭޝަނާއި މާޖިނުގެ މައްޗަށެވެ.",
      "empty": "{code} ގެ އެއްވެސް އޮބްޒަވޭޝަނެއް ރެކޯޑުކުރެވިފައެއް ނުވެއެވެ. އެއް ރެކޯޑުކުރެވެންދެން، މި ރޭޓްގެ ފްލޯޓިންގ ފެސިލިޓީއެއް އެކުލެވުމުގެ ރަނުން ދޫކޮށްލެވޭނެއެވެ.",
      "loadFailed": "އެ ރޭޓް އޮބްޒަވޭޝަންތައް ނުލޯޑްވި",
      "noFloating": "މި ޤާނޫނީ ފަރާތުގެ އެއްވެސް އެކްޓިވް ފެސިލިޓީއެއްގައި ފްލޯޓިންގ ރޭޓެއް ނެތީތީ، ބަލަންޖެހޭ ރެފަރެންސް ރޭޓެއް ނެތެވެ.",
      "record": "އޮބްޒަވޭޝަން ރެކޯޑުކުރައްވާ",
      "recorded": "ރޭޓް އޮބްޒަވޭޝަން ރެކޯޑުކުރެވިއްޖެ.",
      "sourceHint": "ރޭޓް ޝާއިޢުކުރި ތަން. މެނުއަލަށް ހުސްކޮށް ބާއްވާ.",
      "title": "ރެފަރެންސް ރޭޓްތައް"
    },
    "debtFt10": {
      "breach": {
        "line": "{covenant}: {date} ގައި {metric} ހުރީ {actual}، ހަދު ހުރީ {operator} {threshold}.",
        "notified": "ފެސިލިޓީ ޑިފޯލްޓްވެފައި. ޚިލާފުވުން ރެކޯޑުކުރިއިރު ސީއެފްއޯ، ރިސްކް އަދި އޮޑިޓަށް އެންގިއްޖެ.",
        "title": "ކޮވެނަންޓާ ޚިލާފުވެއްޖެ",
        "waiveHint": "ޚިލާފުވުމެއް ފިލުވެނީ ލޯނުދޭ ފަރާތުގެ ލިޔުން ބަޔާންކޮށް، ސަބަބު ލިޔެފައިވާ ވޭވަރަކުން އެކަންޏެވެ."
      },
      "covenantTabs": {
        "compliance": "ތަބާވުން",
        "interestExpense": "އިންޓަރެސްޓް ޚަރަދު",
        "label": "ކޮވެނަންޓަށް ތަބާވުން"
      },
      "errors": {
        "ERR_CASH_ACCOUNT_NOT_PLEDGED": "އެ އެކައުންޓް މިހާރު ރަހުނުކޮށްފައެއް ނެތް. އެހެން މީހަކު ރިލީސްކޮށްފާނެ.",
        "ERR_CASH_ACCOUNT_PLEDGED": "އެ ބޭންކް އެކައުންޓް ކުރިން ރަހުނުކޮށްފައި. ފުރަތަމަ އަނެއް ރަހުނު ރިލީސްކުރޭ.",
        "ERR_COVENANT_WAIVER_REF": "ވޭވަރެއްގައި ލޯނުދޭ ފަރާތުގެ ވޭވަރ ލިޔުން ބަޔާންކުރަން ޖެހޭ.",
        "ERR_ILLEGAL_TRANSITION": "މިހާރުގެ ހާލަތުގައި މިކަން ނުކުރެވޭނެ."
      },
      "filters": {
        "anyKind": "ކޮންމެ ބާވަތެއް",
        "anyLender": "ކޮންމެ ލޯނުދޭ ފަރާތެއް",
        "currencyHint": "ތިން އަކުރުގެ ކޯޑެއް، މިސާލަކަށް MVR.",
        "kind": "އިންސްޓްރޫމަންޓްގެ ބާވަތް",
        "lender": "ލޯނުދޭ ފަރާތް"
      },
      "inDefault": {
        "description": "ކޮވެނަންޓާ ޚިލާފުވުމުން ފެސިލިޓީ ޑިފޯލްޓްވެއެވެ. އޭގެ ކޮވެނަންޓުތައް ބެލުމަށް އެއްޗެއް ދައްކާ.",
        "show": "ކޮވެނަންޓުތައް ދައްކާ",
        "title": "ޑިފޯލްޓްވެފައިވާ ފެސިލިޓީތައް"
      },
      "interestFrequency": "އިންޓަރެސްޓްގެ ދައުރު",
      "lenderFromRegister": "ބޭންކް ރަޖިސްޓަރުން",
      "lenderLegalName": "ލޯނުދޭ ފަރާތް (ޤާނޫނީ ނަން)",
      "lenderLegalNameHint": "އެގްރީމަންޓްގައިވާ ގޮތަށް، ފަރާތުގެ ރަޖިސްޓަރީކުރެވިފައިވާ ޤާނޫނީ ނަން.",
      "noFacility": {
        "description": "މި ޤާނޫނީ ފަރާތުގައި ހުޅުވިފައިވާ ފެސިލިޓީއެއް ނެތީތީ ޓެސްޓުކުރާނެ ކޮވެނަންޓެއް ނެތް. ފުރަތަމަ ފެސިލިޓީއެއް ރަޖިސްޓަރީކުރޭ.",
        "title": "ހުޅުވިފައިވާ ފެސިލިޓީއެއް ނެތް"
      },
      "noSettlementAccount": "ސެޓްލްމަންޓް އެކައުންޓެއް ނެތް",
      "secondPrincipal": {
        "covenantAuthor": "މި ފެސިލިޓީއާއެކު ތާއީދަށް މަޑުކުރާ ކޮވެނަންޓެއް އިތުރުކުރީ ނުވަތަ އެންމެ ފަހުން ބަދަލުކުރީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ، އެކްޓިވްކުރަންވާނީ އެހެން މީހެކެވެ.",
        "covenantAuthorChange": "މި ކޮވެނަންޓް އިތުރުކުރީ ނުވަތަ އެންމެ ފަހުން ބަދަލުކުރީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ، ނިންމަންވާނީ އެހެން މީހެކެވެ.",
        "editedTerms": "މި ފެސިލިޓީގެ ޝަރުތުތައް އެންމެ ފަހުން ބަދަލުކުރީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ، އެކްޓިވްކުރަންވާނީ އެހެން މީހެކެވެ.",
        "ownMovement": "މިއީ ތިޔަ ބޭފުޅާ ތައްޔާރުކުރި އެއްޗެއް ކަމަށްވާތީ، ތާއީދު ނުވަތަ ރިޖެކްޓްކުރަންވާނީ އެހެން މީހެކެވެ.",
        "ownChange": "މި ބަދަލަށް އެދުނީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ، މިކަން ނިންމަންވާނީ އެހެން މީހެކެވެ.",
        "prepared": "މި ފެސިލިޓީ ރަޖިސްޓަރީކުރީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ، އެކްޓިވްކުރަންވާނީ އެހެން މީހެކެވެ.",
        "requestedClose": "މި ބަންދުކުރުމަށް އެދުނީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ، ނިންމަންވާނީ އެހެން މީހެކެވެ. އެދުން އަނބުރާ ގެންދެވިދާނެއެވެ.",
        "submitted": "މި ފެސިލިޓީ ހުށަހެޅީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ، އެކްޓިވް ނުވަތަ ރިޖެކްޓްކުރަންވާނީ އެހެން މީހެކެވެ."
      },
      "settlementAccount": "ސެޓްލްމަންޓް ބޭންކް އެކައުންޓް",
      "settlementAccountHint": "އިޚްތިޔާރީ. ޑްރޯޑައުން ލިބޭ އަދި ރީޕޭމަންޓް ދައްކާ ތަން؛ ދެކަންވެސް ޑިފޯލްޓްކޮށް މިއަށް.",
      "testedBy": "{name} ގެ ފަރާތުން",
      "waiver": {
        "ref": "{ref} ގެ ދަށުން ވޭވްކުރެވިފައި",
        "until": "{date} އާ ހަމައަށް"
      }
    },
    "positionsFt11": {
      "calcVersion": "ހިސާބު",
      "calcVersionLabel": "ހިސާބު v{version}",
      "calcVersionHint": {
        "v1": "ހިސާބުގެ 1 ވަނަ ވާޝަނުން ހަދާފައި. އެ ވާޝަނުގައި އޯވަރޑްރާފްޓް ލިމިޓް އެވެއިލަބަލް ބޭސިސްއަށް ގުނާފައިވޭ. އެ ފޯމިއުލާއިން ތަސްދީގުކުރެވޭ، އަލުން ހިސާބު ނުކުރެވޭ.",
        "current": "މިހާރުގެ ހިސާބުން ހަދާފައި: އޯވަރޑްރާފްޓް ލިމިޓަކީ ކެޕޭސިޓީ، ނަގުދެއް ނޫން."
      },
      "rate": {
        "identity": "އެއް ފައިސާ: ބަދަލުކުރުމެއް ނެތް",
        "facts": "{type} · {date} · {source} · {age} ދުވަސް ކުރީގެ",
        "inverted": "ކޯޓްކުރި ޕެއަރގެ އިންވާސް",
        "stale": "ބާވެފައި: {tolerance} ދުވަހަށްވުރެ ބާ"
      },
      "tolerance": {
        "title": "ރޭޓް ޓޮލެރެންސް — {entity}",
        "description": "ޕޮޒިޝަން ތާރީޚާ އަޅާކިޔާއިރު ބަދަލުކުރާ ރޭޓަކަށް ވެވޭނެ އެންމެ ގިނަ ފުރިހަމަ ދުވަސް. އެއަށްވުރެ ބާ ރޭޓަކުން ބަދަލުކުރި ޕޮޒިޝަނެއް ޝާއިޢު ނުކުރެވޭނެ.",
        "current": "މިހާރު {days} ދުވަސް.",
        "days": "ޓޮލެރެންސް (ފުރިހަމަ ދުވަސް)",
        "daysHint": "0 އިން 90 ދުވަހާ ހަމައަށް. ދުވަސްތަކުގެ އަދަދެއް، ރޭޓެއް ނުވަތަ އިންސައްތައެއް ނޫން.",
        "invalid": "0 އިން 90 އާ ހަމައަށް ފުރިހަމަ ދުވަސްތަކުގެ އަދަދެއް ޖަހާ.",
        "raiseNeedsApproval": "ޓޮލެރެންސް މައްޗަށް ބޭނުމުން ޝާއިޢުކުރުމުގެ ކޮންޓްރޯލެއް ލުއިވާތީ، މިއީ ދެވަނަ މީހެއްގެ ހުއްދައަށް ހުށަހަޅާ އެދުމެއް. ހުއްދަ ލިބެންދެން {days} ދުވަސް ނާފިޒުވެ، ޝާއިޢުކުރުން ދެކޮޅުހެދިފައި ހުންނާނެ.",
        "raiseBlocked": "{proposed} ދުވަހަށް މައްޗަށް ބޭނުމުގެ އެދުމެއް ހުއްދައަށް މަޑުކުރަމުން ދަނީ. އިތުރު އެދުމެއް ހުށަހެޅުމުގެ ކުރިން އެ ނިންމަން ނުވަތަ ޓޮލެރެންސް ދަށްކުރަން ޖެހޭ.",
        "raiseFiled": "{proposed} ދުވަހަށް މައްޗަށް ބޭނުމުގެ އެދުން ހުއްދައަށް ހުށަހަޅައިފި. ހުއްދަ ލިބެންދެން {days} ދުވަސް ނާފިޒުވާނެ.",
        "lowerApplies": "ދަށް ޓޮލެރެންސަކީ ހަރުކަށި އެއްޗަކަށް ވާތީ، އެ ވަގުތުން ނާފިޒުވާނެ.",
        "lowerWithdraws": "ދަށް ޓޮލެރެންސް ވަގުތުން ނާފިޒުވެ، {proposed} ދުވަހަށް މައްޗަށް ބޭނުމުގެ މަޑުކުރާ އެދުން ބާތިލުވާނެ.",
        "requestRaise": "މައްޗަށް ބޭނުމަށް އެދޭ",
        "withdraw": "މަޑުކުރާ އެދުން ބާތިލުކުރޭ",
        "withdrawNote": "{days} ދުވަސް ބެހެއްޓުމުން {proposed} ދުވަހަށް މައްޗަށް ބޭނުމުގެ މަޑުކުރާ އެދުން ބާތިލުވާނެ. އެހެން އެއްވެސް ބަދަލެއް ނާދޭ.",
        "withdrawn": "މަޑުކުރާ އެދުން ބާތިލުކުރެވިއްޖެ. {days} ދުވަސް ނާފިޒުވެފައި ހުންނާނެ.",
        "reloaded": "ޓްރެޜަރީ ސެޓިންގްސް ކުރިން އެހެން މީހަކު ބަދަލުކޮށްފި. އަލުން ލޯޑުކުރެވިއްޖެ؛ އަގު ބަލާފައި އަލުން ސޭވްކުރޭ.",
        "settingsMissing": "މި ލީގަލް އެންޓިޓީގެ ޓްރެޜަރީ ސެޓިންގްސް އަދި ނެތް، އެހެންކަމުން ޓޮލެރެންސް މިތާނގައި ބަދަލެއް ނުކުރެވޭނެ. ފުރަތަމަ ޓްރެޜަރީ ސެޓިންގްސް ހަދާ.",
        "save": "ޓޮލެރެންސް ސޭވްކުރޭ",
        "saved": "ރޭޓް ޓޮލެރެންސް {days} ދުވަހަށް ކަނޑައަޅައިފި."
      },
      "pending": {
        "title": "{days} ދުވަހަށް މައްޗަށް ބޭނުން ހުއްދައަށް މަޑުކުރަނީ",
        "requested": "{at} ގައި ޔޫޒަރ #{user} އެދުނު.",
        "awaiting": "އެޕްރޫވަލް އިންބޮކްސްގައި އެހެން މީހަކު އެޕްރޫވަލް ރިކުއެސްޓް #{request} ހުއްދަ ދެންދެން ނާފިޒެއް ނުވާނެ."
      },
      "stale": {
        "title": "ޝާއިޢު ނުކުރެވުނު: ބަދަލުކުރާ ރޭޓެއް ބާވެފައި",
        "explain": "ކަނޑައަޅާފައިވާ ޓޮލެރެންސަށްވުރެ ބާ ރޭޓަކުން ބަދަލުކުރި ޕޮޒިޝަނެއް ޝާއިޢު ނުކުރެވޭނެ، އެހެންކަމުން ބާވެފައިވާ ރޭޓަކުން އެއްވެސް އަދަދެއް ހެކިއެއްގެ ގޮތުގައި ހިފެހެއްޓިފައެއް ނުވޭ.",
        "waysOut": "މި ޕެއަރއަށް މިހާރުގެ ރޭޓެއް ފައިލްކޮށް އަލުން ޝާއިޢުކުރޭ، ނުވަތަ ކަނޑައަޅާފައިވާ ޓޮލެރެންސް ބަދަލުކުރޭ.",
        "askHolder": "ޓޮލެރެންސް ބަދަލުކުރެވޭނީ ޓްރެޜަރީ ސެޓިންގްސް ހިންގާ މީހަކަށް.",
        "changeTolerance": "ރޭޓް ޓޮލެރެންސް ބަދަލުކުރޭ"
      },
      "list": {
        "openGroup": "ގްރޫޕް ޕޮޒިޝަން",
        "entitiesFailed": "ލީގަލް އެންޓިޓީތައް ލޯޑެއް ނުވި",
        "noEntityTitle": "ދައްކާނެ ލީގަލް އެންޓިޓީއެއް ނެތް",
        "noEntityDescription": "ހަރަކާތްތެރި އެއްވެސް ލީގަލް އެންޓިޓީއެއް ތިބާއަށް ނުފެނޭ. އެއްގޮތެއްގެ އެކްސެސް ދިނުމަށް އެޑްމިނިސްޓްރޭޓަރަކާ ގުޅާ، ދެން އޭގެ ޝާއިޢުކުރި ޕޮޒިޝަންތައް މިތާނގައި ފެންނާނެ.",
        "restatement": "އަލުން ބަޔާންކުރި ސަބަބު"
      },
      "group": {
        "title": "ގްރޫޕްގެ ނަގުދު ހާލަތު",
        "description": "ކަނޑައަޅާފައިވާ ޕެރިމީޓަރގެ ތެރޭގައިވާ ކޮންމެ ލީގަލް އެންޓިޓީއެއްގެ ނަގުދު، އެއް ރިޕޯޓިންގ ފައިސާއިން، ބަދަލުކުރި ކޮންމެ އަދަދެއްގެ ރޭޓާއެކު.",
        "openPublished": "ޝާއިޢުކުރި ޕޮޒިޝަންތައް",
        "openLiquidity": "ލިކުއިޑިޓީ ދިރާސާ",
        "deniedTitle": "ގްރޫޕް ޕޮޒިޝަން ތިބާއަށް ނުކިޔޭނެ",
        "deniedDescription": "ގްރޫޕް ޕޮޒިޝަނަށް ބޭނުންވަނީ ޓްރެޜަރީ ގްރޫޕް-ޕޮޒިޝަން ކިޔުމުގެ ހުއްދަ. ބޭނުންނަމަ އެޑްމިނިސްޓްރޭޓަރަކާ ގުޅާ.",
        "perimeterTitle": "ޕެރިމީޓަރ",
        "declareBy": "ޕެރިމީޓަރ ކަނޑައަޅާނީ",
        "modePerimeter": "ކޮންސޮލިޑޭޝަން ގްރޫޕް",
        "modeEntities": "ލީގަލް އެންޓިޓީތައް",
        "perimeter": "ކޮންސޮލިޑޭޝަން ގްރޫޕް",
        "reportingCurrency": "ރިޕޯޓިންގ ފައިސާ",
        "reportingCurrencyHint": "ކޮންމެ އަދަދެއް މި ފައިސާއަށް ބަދަލުކުރެވޭ.",
        "reportingDefault": "ޕެރިމީޓަރގެ ޕްރެޒެންޓޭޝަން ފައިސާ",
        "sourceLive": "ލައިވް",
        "sourceLiveHint": "މިހާރު، އެއް ވޯޓަރމާކަކުން ހިސާބުކުރެވޭ",
        "sourcePublished": "ޝާއިޢުކުރި",
        "sourcePublishedHint": "ތާރީޚަށް ކޮންމެ ލީގަލް އެންޓިޓީއެއްގެ މިހާރުގެ ޝާއިޢުކުރި ރަން",
        "inTransaction": "މުޢާމަލާތުގެ ފައިސާ",
        "inFunctional": "ފަންކްޝަނަލް ފައިސާ",
        "inReporting": "ރިޕޯޓިންގ ފައިސާ",
        "entitiesLegend": "އެއްކުރާނެ ލީގަލް އެންޓިޓީތައް",
        "entitiesFailed": "ލީގަލް އެންޓިޓީތައް ލޯޑެއް ނުވި",
        "noScopeTitle": "ޕެރިމީޓަރއެއް ކަނޑައަޅާ",
        "noScopeDescription": "ކޮންސޮލިޑޭޝަން ގްރޫޕެއް ހޮވާ، ނުވަތަ އެއްކުރާނެ ލީގަލް އެންޓިޓީތައް ޓިކްކުރޭ. ޖުމްލަކުރެވޭނީ ޕެރިމީޓަރގެ ތެރޭގައިވާ އެންޓިޓީތައް އެކަނި؛ އެހެން ކޮންމެ އެއްޗެއް ވަކިން ނަންދެވޭ.",
        "filterRefused": "މަތީގައިވާ ފިލްޓަރުތަކުގެ ތެރެއިން އެއްޗެއް ސާވަރ ދެކޮޅުހަދައިފި. ސަބަބު އޭގެ ދަށުގައި ދައްކާފައި.",
        "loadFailed": "ގްރޫޕް ޕޮޒިޝަން ލޯޑެއް ނުވި",
        "headlineTitle": "ގްރޫޕްގެ ޖުމްލަތައް",
        "source": {
          "live": "ލައިވް — ޝާއިޢު ނުކުރެވޭ",
          "published": "ޝާއިޢުކުރި ރަންތައް"
        },
        "asOfAt": "{date} ގެ ހާލަތު، {at} ގެ އަދަދުތައް",
        "declaredEntities": "ކަނޑައަޅާފައިވާ ލީގަލް އެންޓިޓީތައް",
        "tolerance": "ރޭޓް ޓޮލެރެންސް: {days} ދުވަސް",
        "liveBanner": "މި އަދަދުތައް މިހާރު ހިސާބުކުރެވިފައި، ޝާއިޢެއް ނުކުރެވޭ. ހެކިއަކަށް ޝާއިޢުކުރި ޕޮޒިޝަނެއް ބޭނުންކުރޭ.",
        "staleWarning": "ކަނޑައަޅާފައިވާ {days} ދުވަހުގެ ޓޮލެރެންސަށްވުރެ ބާ ބަދަލުކުރާ ރޭޓެއް މަދުވެގެން އެކެއް އެބައޮތް. އަދަދުތައް ދައްކާ، އެކަމަކު އެ ރޭޓުން ބަދަލުކުރި ޕޮޒިޝަނެއް ޝާއިޢު ނުކުރެވޭނެ.",
        "entitiesTitle": "އެއްކުރި ލީގަލް އެންޓިޓީތައް",
        "entitiesDescription": "ކޮންމެ ލީގަލް އެންޓިޓީއެއް 100% ގައި. ޕްރޮޕޯޝަނަލްކޮށް ކޮންސޮލިޑޭޓްކުރާ އެއްޗެއްގައި ގްރޫޕް އެއްކުރާ ބައިވެސް ދައްކާ.",
        "showLinesIn": "ލައިންތައް ދައްކާނީ",
        "entitiesCaption": "ގްރޫޕް ޕޮޒިޝަނަށް އެއްކުރި ލީގަލް އެންޓިޓީތައް",
        "method": "ގޮތް",
        "ownership": "މިލްކުވެރިކަން",
        "functionalCurrency": "ފަންކްޝަނަލް ފައިސާ",
        "publishedRun": "ޝާއިޢުކުރި ރަން",
        "notPublished": "މި ތާރީޚަށް ޝާއިޢު ނުކުރެވޭ",
        "groupShare": "ގްރޫޕްގެ ބައި",
        "hideLines": "އެކައުންޓްތައް ފޮރުވާ",
        "showLines": "{count} އެކައުންޓް ދައްކާ",
        "publish": "{currency} އިން ޝާއިޢުކުރޭ",
        "changeTolerance": "ރޭޓް ޓޮލެރެންސް",
        "liquidity": "ލިކުއިޑިޓީ",
        "linesCaption": "{entity} ގެ އެކައުންޓްތައް",
        "reportingRate": "ރިޕޯޓިންގ ރޭޓް",
        "functionalRate": "ފަންކްޝަނަލް ރޭޓް",
        "entitiesEmpty": "މި ތާރީޚުގައި މި ޕެރިމީޓަރގެ ތެރޭގައި އެއްވެސް ލީގަލް އެންޓިޓީއެއް ނެތް.",
        "excludedTitle": "އެއްނުކުރެވޭ",
        "excludedDescription": "މި ލީގަލް އެންޓިޓީތަކަށް ނަންދެވޭ ނަމަވެސް ގްރޫޕްގެ އަދަދަށް ޖުމްލައެއް ނުކުރެވޭ.",
        "byCurrencyTitle": "މުޢާމަލާތުގެ ފައިސާއިން",
        "ratesTitle": "ބޭނުންކުރި ބަދަލުކުރާ ރޭޓްތައް",
        "ratesDescription": "ބަދަލުކުރި ކޮންމެ އަދަދެއްގެ ފަހަތުގައިވާ ރޭޓް: ބާވަތް، ތާރީޚް، މަސްދަރު އަދި ޢުމުރު.",
        "ratesEmpty": "އެއްވެސް ބަދަލުކުރުމެއް ނުލާޒިމްވި.",
        "liquidityTitle": "ގްރޫޕްގެ ލިކުއިޑިޓީ",
        "liquidityDescription": "އެއްކުރި ލީގަލް އެންޓިޓީތައް ގްރޫޕްގެ ބައިން ޖުމްލަކޮށްފައި.",
        "notesTitle": "ނޯޓުތައް"
      },
      "method": {
        "parent": "ޕޭރެންޓް",
        "full": "ފުރިހަމަ",
        "proportional": "ނިސްބަތުން",
        "declared": "ކަނޑައަޅާފައި"
      },
      "reason": {
        "not_in_perimeter": "ޕެރިމީޓަރުން ބޭރު",
        "method_equity": "އިކުއިޓީ ގޮތުން ހިސާބުކުރާ",
        "method_proportional": "ރެކޯޑުކުރި ހިއްސާއެއް ނެތް",
        "method_excluded": "ނުހިމެނޭ",
        "not_published": "ޝާއިޢު ނުކުރެވޭ"
      }
    },
    "liquidityFt11": {
      "title": "ލިކުއިޑިޓީ ދިރާސާ",
      "description": "ލީގަލް އެންޓިޓީއެއްގެ ލިބެން ހުރި ލިކުއިޑިޓީ: ނަންދީފައިވާ ކޮންމެ ކެނޑުމެއް ކަނޑާފައި ވާސިލުވެވޭ ނަގުދު، އަދި ކެޕޭސިޓީގެ ގޮތުގައި ދައްކާ ނުނަގާ ކޮމިޓެޑް ފެސިލިޓީތައް.",
      "openPositions": "ޝާއިޢުކުރި ޕޮޒިޝަންތައް",
      "openGroup": "ގްރޫޕް ޕޮޒިޝަން",
      "deniedTitle": "ލިކުއިޑިޓީ ތިބާއަށް ނުކިޔޭނެ",
      "deniedDescription": "ލިކުއިޑިޓީ ދިރާސާއަށް ބޭނުންވަނީ ޓްރެޜަރީ ޕޮޒިޝަން ކިޔުމުގެ ހުއްދަ. ބޭނުންނަމަ އެޑްމިނިސްޓްރޭޓަރަކާ ގުޅާ.",
      "reportingHint": "ބަދަލުކުރި ކޮންމެ އަދަދެއް މި ފައިސާއިން ބަޔާންކުރެވޭ.",
      "reportingDefault": "ލީގަލް އެންޓިޓީގެ ބޭސް ފައިސާ",
      "asOfHint": "ހުސްކޮށް ބާއްވައިފިނަމަ މިއަދު.",
      "entitiesFailed": "ލީގަލް އެންޓިޓީތައް ލޯޑެއް ނުވި",
      "noEntityTitle": "ދިރާސާކުރާނެ ލީގަލް އެންޓިޓީއެއް ނެތް",
      "noEntityDescription": "ހަރަކާތްތެރި އެއްވެސް ލީގަލް އެންޓިޓީއެއް ތިބާއަށް ނުފެނޭ. އެކްސެސް ދިނުމަށް އެޑްމިނިސްޓްރޭޓަރަކާ ގުޅާ.",
      "loadFailed": "ލިކުއިޑިޓީ ލޯޑެއް ނުވި",
      "headlineTitle": "ލިބެން ހުރި ލިކުއިޑިޓީ",
      "linesTitle": "އެކައުންޓުން ކެނޑުންތައް",
      "linesDescription": "ކޮންމެ އެކައުންޓެއްގެ ނަގުދާއި ހަ ކެނޑުން، {currency} އިން. ކޮންމެ ކެނޑުމެއް ހިނގާ ސަބަބު ބަޔާންކުރޭ.",
      "unavailable": "{count} އެކައުންޓަކަށް އެވެއިލަބަލް ބޭސިސްއެއް ނެތް. އެތަކެތި ވާސިލުވެވޭ ނަގުދަށް އެއްވެސް އެއްޗެއް އިތުރެއް ނުކުރޭ، އެއިން އެއްވެސް އެއްޗެއް ނުކެނޑޭ.",
      "liquidityClass": "ލިކުއިޑިޓީ ކްލާސް",
      "gross": "ކެނޑުމުގެ ކުރީގެ ނަގުދު",
      "net": "ނެޓް ނަގުދު",
      "overdraftHeadroom": "އޯވަރޑްރާފްޓް ހެޑްރޫމް",
      "noBasis": "އެވެއިލަބަލް ބޭސިސްއެއް ނެތް",
      "overdraftOf": "ލިމިޓް {limit}، ނަގާފައި {drawn}",
      "linesEmpty": "މި ލީގަލް އެންޓިޓީގައި އެއްވެސް އެކައުންޓެއް ނެތް.",
      "total": "ޖުމްލަ",
      "facilitiesTitle": "ނުނަގާ ކޮމިޓެޑް ފެސިލިޓީތައް",
      "facilitiesDescription": "ދަރަނި ނެގުމުގެ ކެޕޭސިޓީ، ނަގުދެއް ނޫން. ނެޓް ނަގުދަށް އިތުރުކުރެވެނީ ވަކި ލައިނެއްގައި، އަދި ދުވަހަކުވެސް ނަގުދު ބެލެންސަކަށް ޖުމްލައެއް ނުކުރެވޭ.",
      "drawn": "ނަގާފައި",
      "drawdownsInTransit": "ރާސްތާގައިވާ ޑްރޯޑައުންތައް",
      "awaitingApproval": "ހުއްދައަށް މަޑުކުރަނީ",
      "inReporting": "{currency} އިން",
      "facilitiesEmpty": "މި ތާރީޚުގައި އެއްވެސް ކޮމިޓެޑް ފެސިލިޓީއެއް ހަރަކާތްތެރިއެއް ނޫން.",
      "kind": {
        "restricted": "ހަނިކުރެވިފައި",
        "pledged": "ރަހުނުކުރެވިފައި",
        "escrowed": "އެސްކްރޯގައި",
        "in_transit": "ރާސްތާގައި",
        "blocked": "ބްލޮކްކުރެވިފައި",
        "minimum": "މަދުވެގެން ބެލެންސް"
      },
      "bridge": {
        "caption": "ވާސިލުވެވޭ ނަގުދުން ލިބެން ހުރި ލިކުއިޑިޓީއަށް",
        "line": "ލައިން",
        "accessible": "ވާސިލުވެވޭ ނަގުދު",
        "less": "ކަނޑާ: {what}",
        "totalDeductions": "ޖުމްލަ ކެނޑުން",
        "netCash": "ނެޓް ނަގުދު",
        "plusUndrawn": "އިތުރުކުރޭ: ނުނަގާ ކޮމިޓެޑް ފެސިލިޓީތައް",
        "capacityNotCash": "ކެޕޭސިޓީ، ނަގުދެއް ނޫން",
        "available": "ލިބެން ހުރި ލިކުއިޑިޓީ",
        "undrawnShort": "ނުނަގާ ކޮމިޓެޑް ފެސިލިޓީތައް",
        "overdraftHeadroom": "އޯވަރޑްރާފްޓް ހެޑްރޫމް",
        "overdraftNote": "ކޮމިޓް ނުކުރެވޭ ކެޕޭސިޓީ: ދައްކާ، ލިބެން ހުރި ލިކުއިޑިޓީއަށް އިތުރެއް ނުކުރެވޭ.",
        "inTransitTotal": "ރާސްތާގައިވާ ރަޖިސްޓަރ",
        "inTransitNote": "ތަސްދީގުކުރެވެންދެން ފޮނުވާ ނުވަތަ ލިބޭ ބެލެންސަކަށް ނިސްބަތެއް ނުކުރެވޭ.",
        "breached": "ލިބެން ހުރި ލިކުއިޑިޓީ ކަނޑައަޅާފައިވާ މަދުވެގެން ބެލެންސްތަކަށްވުރެ ދަށް."
      },
      "inTransit": {
        "title": "ރާސްތާގައިވާ ރަޖިސްޓަރ",
        "description": "ރިލީޒްކުރި ނުވަތަ އެދުނު، އަދި ތަސްދީގު ނުކުރެވޭ އަގު. ފޮނުވާ ނުވަތަ ލިބޭ ބެލެންސްގެ ބަޔެއް ނޫން؛ އެ ފެންނަނީ މި ރަޖިސްޓަރގައި އެކަނި.",
        "caption": "ރާސްތާގައިވާ އަގު",
        "direction": "ދިމާ",
        "age": "ޢުމުރު",
        "kind": {
          "transfer": "ޓްރާންސްފަރ",
          "debt_drawdown": "ދަރަނީގެ ޑްރޯޑައުން",
          "other": "އެހެނިހެން"
        },
        "fromTo": "އެކައުންޓް {from} އިން {to} އަށް",
        "wallet": "ވޮލެޓަކަށް",
        "into": "އެކައުންޓް {to} އަށް",
        "days": "{days} ދުވަސް",
        "empty": "މި ތާރީޚުގައި އެއްވެސް އެއްޗެއް ރާސްތާގައެއް ނެތް.",
        "total": "ރާސްތާގައިވާ ޖުމްލަ"
      }
    },
    "forecastFt13": {
      "horizon": {
        "label": "ހޮރައިޒަން",
        "operational": "އޮޕަރޭޝަނަލް (13 ހަފްތާ އަށް)",
        "strategic": "ސްޓްރެޓީޖިކް (24 މަސް)"
      },
      "granularity": {
        "day": "ދުވަސް",
        "week": "ހަފްތާ",
        "month": "މަސް"
      },
      "sourceClass": {
        "open_item": "ހުޅުވިފައިވާ އައިޓަމް",
        "commitment": "ކޮމިޓްމަންޓް",
        "calendar": "ކެލެންޑަރު",
        "contract": "ކޮންޓްރެކްޓް",
        "modelled": "މޮޑެލް ކުރެވިފައި"
      },
      "lineClass": {
        "label": "ލިއުންތަކުގެ އަސާސް",
        "modelledCount": "މޮޑެލް ކުރެވުނު ލިއުން {count}",
        "overriddenCount": "އޯވަރރައިޑް ކުރެވުނު ލިއުން {count}",
        "sourced": "ސޯސް ކުރެވިފައި",
        "modelled": "މޮޑެލް ކުރެވިފައި",
        "override": "އޯވަރރައިޑް"
      },
      "degraded": {
        "badge": "ދަށްވެފައި",
        "note": "މި ފޮރކާސްޓް ނުފުރިހަމައެވެ. އިންޕުޓެއް ނުލިބުނެވެ. ފުރިހަމަ ހާލަތެއްގެ ގޮތުގައި ނުވިދާޅުވާށެވެ.",
        "input": {
          "ap": "ސަޕްލައަރ އިންވޮއިސް",
          "ar": "ކަސްޓަމަރ އިންވޮއިސް",
          "recurring": "ތަކުރާރު އައިޓަމް",
          "debt": "ދަރަނީގެ ޝެޑިއުލް"
        }
      },
      "item": {
        "sourceClass": "އަސާސް",
        "confidence": "ކޮންފިޑެންސް",
        "actions": "އަމަލުތައް",
        "was": "ކުރިން",
        "override": "އޯވަރރައިޑް"
      },
      "override": {
        "title": "މި ލިއުން އޯވަރރައިޑް ކުރޭ",
        "description": "މި ލިއުން ހިމެނޭ ޚަބަރު ފޮރކާސްޓް ތިޔަބޮޑު ޢަދަދު ބޭނުންކުރާނެއެވެ. ފެންނަ ޝާއިޢުކުރެވިފައިވާ ރަން ބަދަލެއް ނުވާނެއެވެ. މުއްދަތު ހަމަވުމުން ހުއްޓޭނެއެވެ.",
        "amount": "އޯވަރރައިޑް ޢަދަދު",
        "amountHint": "{currency} ގައި، ނެގެޓިވް ނޫން. ލިއުމުގެ ދިމާލުން ސައިން ކަނޑައެޅެއެވެ. ސުން ނަގުދު ފޮރކާސްޓުން ނައްތާލައެވެ.",
        "amountInvalid": "ނެގެޓިވް ނޫން ނަންބަރެއް ލިޔުއްވާ، މިސާލު 1500.00.",
        "expiresOn": "ހަމަވާ ތާރީޚް",
        "confirm": "އޯވަރރައިޑް ރެކޯޑްކުރޭ",
        "saved": "އޯވަރރައިޑް ރެކޯޑްކުރެވުނު."
      },
      "series": {
        "title": "ސޯސް ކްލާސް މަތިން ސީރީޒް",
        "description": "މި ރަން ހަމައެކަނި، ކޮންމެ ލިއުމެއް އައިސްފައިވާ ތަނުން ބައިކޮށް، ކްލޯޒިންގ ބެލެންސްގެ ވަށައިގެން ކޮންފިޑެންސް ބޭންޑާއެކު.",
        "loadFailed": "އެ ސީރީޒް ލޯޑެއް ނުވި",
        "separateNote": "އޮޕަރޭޝަނަލް އާއި ސްޓްރެޓީޖިކް ފޮރކާސްޓްތަކަކީ ވަކި ރަންތަކެކެވެ، އެއްކޮށް ނުބަލާނެއެވެ.",
        "emptyTitle": "މި ރަނުގައި ބަކެޓެއް ނެތް",
        "emptyDescription": "ދައްކާނެ ސީރީޒެއް ރަނުގައި ނެތެވެ.",
        "chartAria": "ސޯސް ކްލާސް މަތިން ބަކެޓް {buckets}، ކޮންފިޑެންސް ބޭންޑާއެކު، {currency} ގައި",
        "caption": "ކްލޯޒިންގ ބެލެންސް، ކޮންފިޑެންސް ބޭންޑް އަދި ބަކެޓް މަތިން ސޯސް ކްލާސް ބައިކުރުން",
        "bandLow": "ބޭންޑް ދަށް",
        "bandHigh": "ބޭންޑް މަތި",
        "bySourceClass": "ސޯސް ކްލާސް މަތިން (އިން / އައުޓް)",
        "overrides": "އޯވަރރައިޑްތައް"
      },
      "overrides": {
        "title": "މެނުއަލް އޯވަރރައިޑްތައް",
        "description": "ސޯސް އަދި މޮޑެލް ލިއުންތަކުން ވަކިން، ހެދި މީހާ، ސަބަބު އަދި މުއްދަތާއެކު.",
        "loadFailed": "އޯވަރރައިޑްތައް ލޯޑެއް ނުވި",
        "applied": "މި ރަނުގެ ލިއުން {count} ގައި އޯވަރރައިޑް ހުރެއެވެ.",
        "emptyTitle": "އޯވަރރައިޑެއް ނެތް",
        "emptyDescription": "މި ފޮރކާސްޓުގެ ލިއުމެއް އެއްވެސް މީހަކު އޯވަރރައިޑް ނުކުރެއެވެ.",
        "caption": "ފޮރކާސްޓް ލިއުންތަކުގެ މެނުއަލް އޯވަރރައިޑްތައް",
        "original": "ކުރިން",
        "override": "އޯވަރރައިޑް",
        "expiresOn": "ހަމަވާ",
        "by": "ހެދީ",
        "notYetApplied": "ދެންމެ ރަނުން ފެށިގެން ހިނގާނެ",
        "status": {
          "active": "ހިނގަމުންދާ",
          "expired": "ހަމަވެފައި",
          "superseded": "ބަދަލުވެފައި"
        }
      },
      "publish": {
        "weeksMin": "ހަފްތާގެ ޢަދަދު 1 ނުވަތަ އެއަށްވުރެ ގިނަ ޢަދަދެއް ލިޔުއްވާ.",
        "weeksCap": "އޮޕަރޭޝަނަލް ފޮރކާސްޓަކީ އެންމެ ގިނައިން {max} ހަފްތާއެވެ. ދިގު ބެލުމަކަށް ސްޓްރެޓީޖިކް ބޭނުންކުރައްވާ.",
        "weeksHint": "އެންމެ ގިނައިން {max} ހަފްތާ.",
        "dailyRange": "ދުވަހުން ދައްކާ ދުވަސްގެ ޢަދަދު 0 އިން {max} އަށް ލިޔުއްވާ.",
        "strategicNote": "ސްޓްރެޓީޖިކް ފޮރކާސްޓް ކަވަރުކުރަނީ 24 މަސް، މަހަކަށް ބަކެޓެއް. އެއީ ވަކިން ޝާއިޢުކުރެވޭ، އޮޕަރޭޝަނަލް އާއި އެއްކޮށް ނުބަލާނެއެވެ."
      }
    },
    "forecastFt18": {
      "compare": {
        "title": "ސިނެރިއޯތައް އަޅާކިޔުން",
        "description": "ޚިޔާރުކުރި ކޮންމެ ސިނެރިއޯއެއް ހަމަ އެއް ބޭސްއާ، ދުވަހާއި ފައިސާގެ ބާވަތުން، ލިކުއިޑިޓީގެ ނަތީޖާއާއި ތަފާތު ފަރުޟުތަކާއެކު. ކޮންމެ ލައިނެއްގެ އަދަދު އެ ލައިނުގެ ފައިސާއިން، ތަފާތު ފައިސާ ދުވަހަކުވެސް ޖުމްލަ ނުކުރެވޭ.",
        "base": "ބޭސް",
        "baseHint": "އެހެން ސިނެރިއޯއެއް ނަންނުކިޔައިފިނަމަ އެޕްރޫވްކުރެވިފައިވާ ބޭސް.",
        "approvedBase": "އެޕްރޫވްކުރެވިފައިވާ ބޭސް",
        "asOfHint": "މިހާރުގެ ފޯކާސްޓްތައް އަޅާކިޔުމަށް ހުސްކޮށް ބާއްވާ.",
        "candidates": "އަޅާކިޔާނީ",
        "candidatesHint": "އެއް ނުވަތަ ގިނަ ސިނެރިއޯ ޚިޔާރުކުރޭ. ކޮންމެ އެއްޗަކަށް ޝާއިޢުކުރެވިފައިވާ އޮޕަރޭޝަނަލް ފޯކާސްޓެއް ބޭނުންވޭ.",
        "noCandidates": "ބޭސްއާ އަޅާކިޔާނެ އެހެން އެކްޓިވް ސިނެރިއޯއެއް ނެތް.",
        "run": "އަޅާކިޔާ",
        "loadFailed": "އަޅާކިޔުން ލޯޑު ނުވި",
        "candidate": "ސިނެރިއޯ",
        "scenarioLessRun": "ސިނެރިއޯއެއް ނެތް ފޯކާސްޓް",
        "baseNoRun": "ބޭސްއަށް މިހާރުގެ ފޯކާސްޓެއް ނެތުމުން، ކޮންމެ ސިނެރިއޯއެއްގެ ހުރިހާ ފްލޯއެއް ތަފާތެއްގެ ގޮތުގައި ފެންނާނެ.",
        "outcomeTitle": "ފައިސާގެ ބާވަތުން ލިކުއިޑިޓީގެ ނަތީޖާ",
        "baseColumn": "ބޭސް ({name})",
        "breachOn": "{date} ގައި ހަދު ފަހަނައަޅާ",
        "noBreach": "ހަދު ފަހަނައެއް ނާޅާ",
        "outcomeEmpty": "އަޅާކިޔާނެ ފައިސާއެއް ނެތް.",
        "daysTitle": "ސިނެރިއޯއެއް ބޭސްއާ ތަފާތުވާ ދުވަސްތަކުގެ ނެޓް ފްލޯ",
        "baseNet": "ބޭސް ނެޓް",
        "candidateNet": "{name} ނެޓް",
        "difference": "ތަފާތު",
        "same": "ބޭސްއާ އެއްގޮތް",
        "daysEmpty": "އެއްވެސް ދުވަހެއްގައި ސިނެރިއޯތައް ބޭސްއާ ތަފާތެއް ނުވޭ.",
        "driversTitle": "ތަފާތު ފަރުޟުތައް",
        "inherited": "ބޭސްއިން ލިބިފައި",
        "driversSame": "ބޭސްގެ ހަމަ ފަރުޟުތައް.",
        "drivers": {
          "receivableDelayDays": "ލިބެންޖެހޭ ފައިސާ ލަސްވުން (ދުވަސް)",
          "receivableHaircutPct": "ލިބެންޖެހޭ ފައިސާގެ ހެއާކަޓް (%)",
          "payableDelayDays": "ދައްކަންޖެހޭ ފައިސާ ލަސްވުން (ދުވަސް)",
          "recurringMultiplierPct": "ތަކުރާރުވާ ޚަރަދުގެ މަލްޓިޕްލަޔަރ (%)",
          "includeOverdue": "ފަހަނައެޅި އައިޓަމްތައް ހިމަނާ"
        }
      },
      "tabs": {
        "operational": "އޮޕަރޭޝަނަލް",
        "strategic": "ސްޓްރެޓެޖިކް",
        "thisRunOperational": "މި ރަން: އޮޕަރޭޝަނަލް، {weeks} ހަފްތާ.",
        "thisRunStrategic": "މި ރަން: ސްޓްރެޓެޖިކް، {months} މަސް.",
        "opening": "އަނެއް ހޮރައިޒަންގެ ފޯކާސްޓް ހުޅުވަނީ.",
        "loadFailed": "އަނެއް ހޮރައިޒަންގެ ފޯކާސްޓް ނުފެނުނު",
        "noCounterpart": "މި ލީގަލް އެންޓިޓީއާއި ސިނެރިއޯއަށް މިހާރުގެ {horizon} ފޯކާސްޓެއް ޝާއިޢުކޮށްފައެއް ނެތް.",
        "counterpart": "{date} ގެ {horizon} ފޯކާސްޓް ހުރީ އަނެއް ޓެބުގައި."
      },
      "accuracy": {
        "label": "ފޯކާސްޓްގެ ދިމާކަން",
        "loadFailed": "ދިމާކަން ލޯޑު ނުވި",
        "measured": "އެންމެ ފަހުން މިނީ {date} ގައި، {days} ދުވަސް ކުރިއަށް",
        "none": "މި ހޮރައިޒަންގައި އަދި ނުމިނޭ",
        "open": "ދިމާކަމުގެ ރިޕޯޓް"
      },
      "minimums": {
        "title": "އިޢުލާންކުރެވިފައިވާ މަދުވެގެން ބެލެންސް",
        "description": "ކޮންމެ ފައިސާއަކުން މި ލީގަލް އެންޓިޓީ ބަހައްޓާ މަދުވެގެން ބެލެންސް. މައްޗަށް ބޮޑުކުރުން ވަގުތުން ހިނގާ؛ ދަށްކުރުން ދެވަނަ މީހަކު އެޕްރޫވްކުރަންދެން މަޑުކުރާ.",
        "proposeNew": "މަދުވެގެން ބެލެންސެއް ހުށަހަޅާ",
        "loadFailed": "މަދުވެގެން ބެލެންސްތައް ލޯޑު ނުވި",
        "caption": "ފައިސާގެ ބާވަތުން އިޢުލާންކުރެވިފައިވާ މަދުވެގެން ބެލެންސް، މަޑުކުރާ ބަދަލުތަކާއެކު",
        "inForce": "ހިނގަމުންދާ",
        "source": "މަސްދަރު",
        "pending": "މަޑުކުރާ ބަދަލު",
        "sources": {
          "declared": "އިޢުލާންކުރެވިފައި",
          "account_profiles": "އެކައުންޓުގެ މަދުވެގެން",
          "none": "ނެތް"
        },
        "awaitingSecond": "ދެވަނަ މީހަކަށް މަޑުކުރަނީ",
        "requestedBy": "{name} {at} ގައި އެދިފައި",
        "ownRequest": "މިއީ ތިބާ އެދުނު އެއްޗެއް. އެހެން މީހަކު އެޕްރޫވްކުރަން ޖެހޭ.",
        "decideInApprovals": "އެޕްރޫވަލްސްގައި ނިންމާ",
        "change": "ބަދަލުކުރޭ",
        "withdraw": "ނަގާލާ",
        "empty": "މި ލީގަލް އެންޓިޓީއަށް މަދުވެގެން ބެލެންސެއް އިޢުލާންކޮށްފައެއް ނެތް.",
        "proposeTitle": "މަދުވެގެން ބެލެންސެއް ހުށަހަޅާ",
        "proposeDescription": "އާ މަދުވެގެން ބެލެންސާއި ސަބަބު ބަޔާންކުރޭ. މައްޗަށް ބޮޑުކުރުން ވަގުތުން ހިނގާ. ދަށްކުރުމުގައި ދެވަނަ މީހަކު އެޕްރޫވްކުރަންދެން މިހާރުގެ އަދަދު ހިނގާ.",
        "proposed": "އާ މަދުވެގެން",
        "inForceHint": "މިހާރު ހިނގަމުންދަނީ: {amount}",
        "noneInForce": "މި ފައިސާއަށް ހިނގަމުންދާ މަދުވެގެން ބެލެންސެއް ނެތް.",
        "lowerNote": "މިއީ މަދުވެގެން ބެލެންސް ދަށްކުރުން. އެޕްރޫވަލްސްގައި ދެވަނަ މީހަކު އެޕްރޫވްކުރަންދެން މިއީ ހިނގާ އެއްޗެއް ނޫން.",
        "raiseNote": "މިއީ މަދުވެގެން ބެލެންސް މައްޗަށް ބޮޑުކުރުން. ހުށަހެޅުމާއެކު ހިނގާނެ.",
        "sameNote": "މިއީ މިހާރުވެސް އިޢުލާންކުރެވިފައިވާ އަދަދު.",
        "proposeConfirm": "ހުށަހަޅާ",
        "withdrawTitle": "މަޑުކުރާ ބަދަލު ނަގާލާ ({currency})",
        "withdrawDescription": "އެޕްރޫވަލް ރިކުއެސްޓް ކެންސަލްވާނެ. ހިނގަމުންދާ މަދުވެގެން ބެލެންސަށް ބަދަލެއް ނާދޭ.",
        "withdrawNote": "ނަގާލަނީ ކީއްވެ؟",
        "lowerRequested": "{currency} ގެ މަދުވެގެން ބެލެންސް ދަށްކުރުން އެޕްރޫވަލަށް ފޮނުވިއްޖެ.",
        "raised": "{currency} ގެ މަދުވެގެން ބެލެންސް މައްޗަށް ބޮޑުކުރެވިއްޖެ.",
        "withdrawn": "މަޑުކުރާ ބަދަލު ނަގާލެވިއްޖެ."
      },
      "shortfalls": {
        "title": "ލަފާކުރާ އުނިތަކާއި ފަންޑިންގ ފިޔަވަޅުތައް",
        "description": "މިހާރުގެ ފޯކާސްޓް އިޢުލާންކުރެވިފައިވާ މަދުވެގެން ބެލެންސަށްވުރެ ދަށަށް ދާ ތަންތަން، އެކަމަށް ލިބޭ ވަގުތު، އަދި ޚަރަދާއި ނިމުމަށް ނަގާ ވަގުތުން ތަރުތީބުކުރެވިފައިވާ ފަންޑިންގ ފިޔަވަޅުތައް.",
        "loadFailed": "އުނިތައް ލޯޑު ނުވި",
        "empty": "އިޢުލާންކުރެވިފައިވާ މަދުވެގެން ބެލެންސް ފަހަނައެޅުމެއް ލަފާއެއް ނުކުރެވޭ.",
        "firstBreach": "{currency}: ފުރަތަމަ ފަހަނައެޅުމަކީ {date}، މިއަދުން ފެށިގެން {days} ދުވަސް",
        "mitigated": "ތިރީގައިވާ ފިޔަވަޅުތަކުން ފުރިހަމަވޭ",
        "notMitigated": "ފުރިހަމައަކަށް ނުފުރޭ",
        "atFirstBreach": "ފުރަތަމަ ފަހަނައެޅުމުގެ އުނި",
        "deepest": "އެންމެ ބޮޑު އުނި",
        "residual": "ފިޔަވަޅުތަކަށް ފަހުވެސް އުނި",
        "stillBreaches": "{date} ގައިވެސް ފަހަނައަޅާ",
        "unfunded": "ފަންޑު ނުކުރެވޭ",
        "actionsCaption": "{currency} ގެ ފަންޑިންގ ފިޔަވަޅުތައް، ތަރުތީބުން",
        "rank": "ތަރުތީބު",
        "action": "ފިޔަވަޅު",
        "capacity": "ކެޕޭސިޓީ",
        "covers": "ފުރިހަމަކުރާ",
        "cost": "ޚަރަދު",
        "time": "ނިމުމަށް ނަގާ ވަގުތު",
        "kinds": {
          "overdraft": "އޯވަރޑްރާފްޓް",
          "committed_facility": "ކޮމިޓްކުރެވިފައިވާ ފެސިލިޓީ"
        },
        "settleDays": "{days} ދުވަސް",
        "inTime": "ވަގުތުން",
        "tooLate": "ލަސްވެފައި",
        "availableOn": "{date} ގައި ލިބޭނެ",
        "noActions": "މި ފައިސާއަށް ފަންޑިންގ ފިޔަވަޅެއް ނެތް."
      }
    },
    "custodyHistory": {
      "title": "ބެލެހެއްޓުން ބަދަލުކުރުންތައް",
      "description": "މި ވޮލެޓް ހަވާލުކުރި ކޮންމެ ފަހަރެއް، ދެ ބެލެހެއްޓުންތެރިންގެ ޤަބޫލުކުރުމާއި އެ ދިން ވަގުތާއެކު.",
      "loadFailed": "ބެލެހެއްޓުން ބަދަލުކުރުންތައް ލޯޑު ނުވި",
      "caption": "މި ވޮލެޓްގެ ބެލެހެއްޓުން ބަދަލުކުރުންތައް",
      "parties": "އިން → އަށް",
      "outgoingAck": "ދޫކޮށްލާ ބެލެހެއްޓުންތެރިޔާ",
      "incomingAck": "ބަލައިގަންނަ ބެލެހެއްޓުންތެރިޔާ",
      "count": "ގުނުން",
      "reason": "ސަބަބު",
      "opened": "{at} ގައި ހުޅުވި",
      "status": {
        "draft": "ދޫކޮށްލާ ބެލެހެއްޓުންތެރިޔާއަށް މަޑުކުރަނީ",
        "outgoing_signed": "ބަލައިގަންނަ ބެލެހެއްޓުންތެރިޔާއަށް މަޑުކުރަނީ",
        "accepted": "ނިމިއްޖެ",
        "declined": "ދެކޮޅު ހަދައިފި"
      },
      "notYet": "އަދި ނޫން",
      "declined": "ދެކޮޅު ހަދައިފި",
      "declinedReason": "ދެކޮޅު ހެދީ: {reason}",
      "empty": "މި ވޮލެޓް އެއްފަހަރުވެސް ހަވާލުކޮށްފައެއް ނެތް."
    },
    "splitFlag": {
      "title": "ބައިކޮށްފައިވާ ޚަރަދެއް ކަމަށް ވެދާނެ",
      "summary": "{category} ގައި {payee} އަށް {count} ޚަރަދު، {from} އިން {to} އަށް ({days} ދުވަހުގެ ތެރޭގައި)، ކޮންމެ ޚަރަދެއް އެކަނި ހައްދުގެ ތެރޭގައި، ޖުމްލަކޮށް ހައްދަށް ވުރެ ގިނަ.",
      "anyPayee": "އެއް ފަރާތް",
      "limit": "އެއް ޚަރަދުގެ ހައްދު",
      "total": "ގްރޫޕުގެ ޖުމްލަ",
      "excess": "ހައްދަށް ވުރެ އިތުރު",
      "membersCaption": "ބައިކޮށްފައިވާ ކަމަށް ވެދާނެ ޚަރަދުތައް",
      "entry": "ޚަރަދު",
      "status": "ހާލަތު",
      "thisEntry": "(މި ޚަރަދު)",
      "notBlocking": "މިއީ އެޕްރޫވްކުރާ މީހާއަށް ދޭ އިންޒާރެއް. މިއީ އެޕްރޫވަލް ހުއްޓުވާ ކަމެއް ނޫން.",
      "statuses": {
        "captured": "ރެކޯޑުކުރެވިފައި",
        "submitted": "ހުށަހަޅާފައި",
        "approved": "އެޕްރޫވްކުރެވިފައި",
        "rejected": "ރިޖެކްޓްކުރެވިފައި",
        "posted": "ޕޯސްޓްކުރެވިފައި"
      }
    },
    "minimumPreview": {
      "heading": "ކަނޑައަޅާފައިވާ މަދުވެގެން ބެލެންސް",
      "noAccess": "ކަނޑައަޅާފައިވާ މަދުވެގެން ބެލެންސްތައް ބެލުމުގެ ހުއްދައެއް ތިބާއަކަށް ނެތް.",
      "noCompany": "މި ރިކުއެސްޓުގައި ޤާނޫނީ ފަރާތެއް ނުބުނޭތީ މަދުވެގެން ބެލެންސް ނުދައްކޭނެ.",
      "loadFailed": "ކަނޑައަޅާފައިވާ މަދުވެގެން ބެލެންސްތައް ލޯޑެއް ނުކުރެވުނު",
      "notPending": "މި ބަދަލު މިހާރު މަޑުކުރަމުން ނުދޭ: ނިންމާފައި ނުވަތަ ބާޠިލުކޮށްފައި. މިހާރު ހިނގާ މަދުވެގެން ބެލެންސް ބެލުމަށް ލިކުއިޑިޓީ ގެޕް ރިޕޯޓު ހުޅުވާ.",
      "currency": "ފައިސާ",
      "current": "މިހާރު ހިނގާ މަދުވެގެން ބެލެންސް",
      "atRequest": "ރިކުއެސްޓްކުރިއިރު މަދުވެގެން ބެލެންސް",
      "proposed": "ހުށަހަޅާ މަދުވެގެން ބެލެންސް",
      "reason": "ސަބަބު",
      "requestedBy": "ރިކުއެސްޓްކުރީ",
      "requested": "ރިކުއެސްޓްކުރި ވަގުތު",
      "userRef": "ޔޫޒަރ #{id}",
      "ownRequest": "މި ބަދަލަށް އެދުނީ ތިބާ ކަމުން އެހެން މީހަކު ނިންމަން ޖެހޭ.",
      "open": "ލިކުއިޑިޓީ ގެޕް ރިޕޯޓު ހުޅުވާ",
      "directions": {
        "raise": "މަތިކުރުން",
        "lower": "ދަށްކުރުން (ދެވަނަ މީހަކު ބޭނުންވޭ)"
      }
    },
    "liquidityGap": {
      "title": "ލިކުއިޑިޓީ ހުސްކަން",
      "description": "ޤާނޫނީ ފަރާތެއްގެ މިހާރުގެ ފޯކާސްޓް އޭގެ މަދުވެގެން ހުންނަންޖެހޭ ބެލެންސަށްވުރެ ފުރަތަމަ ދަށަށް ދާ ދުވަހާއި، ދާ މިންވަރު.",
      "openForecasts": "ފައިސާގެ ފޯކާސްޓްތައް",
      "deniedTitle": "ލިކުއިޑިޓީ ހުސްކަން ތިޔަ ބޭފުޅާއަށް ނުފެންނާނެ",
      "deniedDescription": "އެ ކިޔުމަށް ފޯކާސްޓް ކިޔުމުގެ ހުއްދަ ބޭނުންވެއެވެ.",
      "currencyHint": "މި ފައިސާއިން ރިޕޯޓުކުރާ ޤާނޫނީ ފަރާތްތަކަށް ހުށަހަޅާ ފަރާތްތައް ކުޑަކުރެއެވެ. އެއްވެސް އެއްޗެއް ބަދަލެއް ނުކުރެއެވެ.",
      "anyCurrency": "ކޮންމެ ފައިސާއެއް",
      "scenarioHint": "ހުސްކޮށް ބޭއްވުމުން ޤާނޫނީ ފަރާތުގެ އަސާސީ ފޯކާސްޓް ރިޕޯޓުކުރެއެވެ.",
      "baseScenario": "އަސާސީ ފޯކާސްޓް",
      "asOfHint": "ހުސްކޮށް ބޭއްވުމުން މިހާރުގެ ފޯކާސްޓް ރިޕޯޓުކުރެއެވެ.",
      "entitiesFailed": "ޤާނޫނީ ފަރާތްތައް ނުލޯޑްވި",
      "noEntityTitle": "ޤާނޫނީ ފަރާތެއް ޚިޔާރުކުރައްވާ",
      "noEntityDescription": "ހުސްކަން ހިސާބުކުރަނީ ކޮންމެ ޤާނޫނީ ފަރާތަކަށް ވަކިންނެވެ. މައްޗުން އެއް ފަރާތެއް ޚިޔާރުކުރައްވާ، ނުވަތަ އެ ފައިސާއިން އެއްވެސް ފަރާތެއް ރިޕޯޓު ނުކުރާނަމަ ފައިސާގެ ފިލްޓަރު ފޮހެލައްވާ.",
      "loadFailed": "ލިކުއިޑިޓީ ހުސްކަން ނުލޯޑްވި",
      "noRunTitle": "އަދި އެއްވެސް ފޯކާސްޓެއް ޝާއިޢުނުކުރޭ",
      "noRunDescription": "ހުސްކަން ކިޔަނީ ޝާއިޢުކުރެވިފައިވާ ފައިސާގެ ފޯކާސްޓަކުންނެވެ. ފައިސާގެ ފޯކާސްޓްތަކުގެ ސްކްރީނުން މި ޤާނޫނީ ފަރާތަށް އެއް ފޯކާސްޓެއް ޝާއިޢުކުރެއްވުމުން މިތާ ފެންނާނެއެވެ.",
      "headlineTitle": "ފުރަތަމަ ފަހަނައަޅައިގަތުން",
      "headlineDescription": "{date} ގެ ގޮތުން މިހާރުގެ ޝާއިޢުކުރެވިފައިވާ ފޯކާސްޓުން، {currency} އިން.",
      "firstBreachOn": "ފުރަތަމަ ފަހަނައަޅައިގަތީ {date}",
      "noBreach": "ހޮރައިޒަނުގައި އެއްވެސް ފަހަނައަޅައިގަތުމެއް ނެތް",
      "bucketsFailed": "ފޯކާސްޓުގެ ބަކެޓްތައް ނުލޯޑްވި",
      "bucketsDescription": "ޝާއިޢުކުރެވުނު ރަނުގެ އަމިއްލަ ބަކެޓްތައް. މަދުވެގެން ހުންނަންޖެހޭ ބެލެންސަށްވުރެ ދަށުން ނިމޭ ކަމަށް ސާވަރު ފާހަގަކުރި ބަކެޓް ފާހަގަކުރެވިފައިވެއެވެ.",
      "bucketsEmpty": "މި ފޯކާސްޓުގައި އެއްވެސް ބަކެޓެއް ނެތް."
    },
    "walletFunding": {
      "anyEntity": "ހުރިހާ ޤާނޫނީ ފަރާތެއް",
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "anyWallet": "ތިޔަ ބޭފުޅާއަށް ފެންނަ ހުރިހާ ވޮލެޓެއް",
      "approved": "ހުއްދަދެވިފައި",
      "caption": "ވޮލެޓަށް ފައިސާ ލިބުމުގެ އެދުންތަކާއި ކޮންމެ އެދުމެއް ހުރި ޙާލަތު",
      "decide": {
        "approve": "ފައިސާ ދިނުމަށް ހުއްދަދޭ",
        "approved": "އެދުން {no} ހުއްދަދެވި، ޓްރާންސްފަރ އިރުޝާދު {transfer} ހެދިއްޖެ. ވޮލެޓަށް ފައިސާ ޖަމާވާނީ އެ ޓްރާންސްފަރ ކަށަވަރުކުރުމުން އެކަނިއެވެ.",
        "ownRequest": "މި ފައިސާއަށް އެދުނީ ތިޔަ ބޭފުޅާ، ނުވަތަ މި ވޮލެޓް ބަލަހައްޓަނީ ތިޔަ ބޭފުޅާއެވެ. މިކަން ނިންމަންވާނީ އެހެން މީހަކު؛ ތިޔަ ބޭފުޅާގެ ނިންމުން ސާވަރު ރަދުކުރާނެއެވެ.",
        "reason": "ސަބަބު",
        "reasonHint": "ހުއްދަދިނުމަށާއި ރަދުކުރުމަށް ލާޒިމު. ނިންމުމާއެކު ރެކޯޑުކުރެވޭނެއެވެ.",
        "reject": "ރަދުކުރޭ",
        "rejected": "އެދުން {no} ރަދުކުރެވިއްޖެ.",
        "reloaded": "މި އެދުމަށް ކުރިން އެހެން މީހަކު ބަދަލެއް ގެނެސްފި. އަލުން ލޯޑުކުރެވިއްޖެ؛ ބައްލަވާފައި އަލުން ނިންމަވާ.",
        "title": "ނިންމުން"
      },
      "decideAction": "ނިންމާ",
      "description": "ތިޔަ ބޭފުޅާއަށް ފެންނަ ހުރިހާ ވޮލެޓް ފައިސާ އެދުމެއް. އެއްޗެއް ހުއްދަދިނުމުން ބޭންކް ޓްރާންސްފަރ އިރުޝާދެއް ހެދޭނެ؛ ވޮލެޓަށް ފައިސާ ޖަމާވާނީ އެ ޓްރާންސްފަރ ބޭންކް ސްޓޭޓްމަންޓާ ޚިލާފުނުވާކަން ކަށަވަރުކުރުމުން އެކަނިއެވެ.",
      "dialog": {
        "atMax": "ދަތުރުގައިވާ ފައިސާއާއެކު، މި ވޮލެޓް އޮތީ އެންމެ ގިނަ ބެލެންސްގައެވެ. މިހާރު ކުރާ އެދުމެއް ރަދުކުރެވޭނެއެވެ.",
        "creditOnConfirm": "އެދުމުންނާއި އެދުން ހުއްދަދިނުމުން އެއްވެސް ފައިސާއެއް ޖަމާނުވާނެއެވެ. ވޮލެޓަށް ފައިސާ ޖަމާވާނީ އޭގެ ބޭންކް ޓްރާންސްފަރ ސްޓޭޓްމަންޓާ އެއްގޮތްވާކަން ކަށަވަރުކުރުމުންނެވެ.",
        "firstLoadRule": "މި ވޮލެޓަށް އަދި ފައިސާ ލިބިފައެއް ނުވާތީ، އަދަދަކީ ފްލޯޓުގެ އުނިކަމެވެ.",
        "float": "ހުއްދަދެވިފައިވާ ފްލޯޓް",
        "nothingToRestore": "އަނބުރާ ފުރިހަމަކުރަންޖެހޭ އެއްޗެއް ނެތް: ވޮލެޓުގައި އޭގެ ފްލޯޓް ހުރި.",
        "openRequest": "ރީޕްލެނިޝްމަންޓް {no} އަދިވެސް އޮތީ {status}. އެ ނިމެންދެން އިތުރު އެދުމެއް ރަދުކުރެވޭނެއެވެ.",
        "overMaxTitle": "އެންމެ ގިނަ ބެލެންސަށްވުރެ މަތީ"
      },
      "emptyDescription": "ފައިސާއަށް އެދެނީ ވޮލެޓުންނެވެ، ނުވަތަ ވޮލެޓް ރީޕްލެނިޝްމަންޓް ހައްދަށް ދަށްވުމުން އަމިއްލައަށް ހުށަހެޅެއެވެ.",
      "emptyTitle": "ވޮލެޓް ފައިސާ އެދުމެއް ނެތް",
      "entityHint": "ހުށަހަޅާ ވޮލެޓްތަކާއި، ކޮންމެ ޞަފްޙާއެއްގައި ދައްކާ އެދުންތައް، އެ ޤާނޫނީ ފަރާތުގެ ވޮލެޓްތަކަށް ކުޑަކުރެއެވެ.",
      "errors": {
        "ERR_ILLEGAL_TRANSITION": "މި އެދުން ކުރިންވެސް ނިންމިފައިވެއެވެ.",
        "ERR_PERIOD_CLOSED": "މި ޤާނޫނީ ފަރާތަށް މިއަދުގެ މުއްދަތު ބަންދުކުރެވިފައިވާތީ ފައިސާއެއް ނުހުށަހެޅޭނެއެވެ.",
        "ERR_ROW_VERSION": "މި އެދުމަށް ކުރިން އެހެން މީހަކު ބަދަލެއް ގެނެސްފި. އަލުން ލޯޑުކުރެވިއްޖެ؛ ބައްލަވާފައި އަލުން ނިންމަވާ.",
        "ERR_SOD_VIOLATION": "މި ފައިސާ ނިންމޭކަށް ނުވާނެ: އެދުނު މީހާއާއި ވޮލެޓް ބަލަހައްޓާ މީހާ މިކަން ނިންމޭކަށް ނުވާނެއެވެ.",
        "ERR_WALLET_MAX_BALANCE": "މި ފައިސާއިން ވޮލެޓް އޭގެ އެންމެ ގިނަ ބެލެންސަށްވުރެ މައްޗަށް ދާނެއެވެ."
      },
      "facts": {
        "approvedSpendTotal": "ހިމެނޭ ހުއްދަދެވިފައިވާ ޚަރަދު",
        "decidedBy": "ނިންމި މީހާ",
        "failedReason": "ނާކާމިޔާބުވި ސަބަބު",
        "floatShortfall": "އެދުނުއިރު ފްލޯޓުގެ އުނިކަން",
        "fundingAccount": "ފައިސާ ދޭ އެކައުންޓް",
        "justification": "ސަބަބު ބަޔާންކުރުން",
        "note": "ނޯޓް"
      },
      "fundedNote": "{at} ގައި ފައިސާ ލިބިއްޖެ: ޓްރާންސްފަރ ކަށަވަރުކުރެވި ވޮލެޓަށް ޖަމާކުރެވިއްޖެ.",
      "inTransitNote": "ހުއްދަދެވި ދަތުރުގައި. ފައިސާ ގެންދަނީ ޓްރާންސްފަރ އިރުޝާދު {no}؛ ވޮލެޓަށް ޖަމާވާނީ އެ ކަށަވަރުކުރުމުން އެކަނިއެވެ.",
      "instruction": "ޓްރާންސްފަރ އިރުޝާދު",
      "legalEntity": "ޤާނޫނީ ފަރާތް",
      "loadFailed": "އެ ފައިސާ އެދުންތައް ނުލޯޑްވި",
      "noInstruction": "އަދި ނުހެދޭ",
      "openInstruction": "ޓްރާންސްފަރ އިރުޝާދު {no} ހުޅުވާ",
      "openWallets": "ވޮލެޓްތައް",
      "pageEmpty": "މި ޞަފްޙާގައި މި ޤާނޫނީ ފަރާތަށް އެއްވެސް އެއްޗެއް ނެތް. ދެން އޮތް ޞަފްޙާ ބައްލަވާ.",
      "position": {
        "confirmed": "ކަށަވަރުކުރެވިފައިވާ ބެލެންސް",
        "headroom": "އަދިވެސް ލޯޑުކުރެވޭނެ",
        "inTransit": "ދަތުރުގައި",
        "loadFailed": "ފައިސާގެ ޙާލަތު ނުލޯޑްވި",
        "maxBalance": "އެންމެ ގިނަ ބެލެންސް",
        "noMax": "އެންމެ ގިނަ ބެލެންސެއް ކަނޑައަޅާފައެއް ނުވޭ",
        "note": "ކަށަވަރުކުރެވިފައިވާ ބެލެންސް ބަދަލުވަނީ ކަށަވަރުކުރެވުނު ޓްރާންސްފަރަކުން އެކަނިއެވެ. ހުއްދަދެވިފައިވާ އެދުމެއް ދަތުރުގައި ހުންނާނީ އޭގެ ޓްރާންސްފަރ އިރުޝާދު ބޭންކް ސްޓޭޓްމަންޓާ އެއްގޮތްވާކަން ކަށަވަރުކުރެވެންދެނެވެ.",
        "refresh": "އަލުން ކިޔާ",
        "resulting": "ދަތުރުގައިވާ ހުރިހާ އެއްޗެއް ކަށަވަރުވުމުން",
        "title": "ފައިސާގެ ޙާލަތު"
      },
      "previewTitle": "އެދުން {no}",
      "requestNo": "އެދުން",
      "requested": "އެދުނު އަދަދު",
      "requestedOn": "އެދުނު ތާރީޚު",
      "review": "ބަލާ",
      "status": {
        "approved": "ހުއްދަދެވި، ދަތުރުގައި",
        "draft": "ޑްރާފްޓް",
        "failed": "ނާކާމިޔާބު",
        "funded": "ފައިސާ ލިބިފައި",
        "proposed": "ހުށަހަޅާފައި",
        "rejected": "ރަދުކުރެވިފައި",
        "submitted": "ނިންމުމަށް އިންތިޒާރުގައި"
      },
      "tableTitle": "ފައިސާ އެދުންތައް",
      "title": "ވޮލެޓަށް ފައިސާ ލިބުން",
      "walletBanner": {
        "inTransit": "މިއީ ދަތުރުގައިވާ ފައިސާ: ވޮލެޓަށް ޖަމާވާނީ އޭގެ ޓްރާންސްފަރ ކަށަވަރުކުރުމުންނެވެ.",
        "open": "ވޮލެޓް ފައިސާގައި ހުޅުވާ"
      }
    },
    "instructionFt6": {
      "approvalStepRecorded": "ތިޔަ ބޭފުޅާގެ ހުއްދަ ރެކޯޑުކުރެވިއްޖެ. ޗޭނުގައި ދެން ހުރި ހުއްދަދޭ މީހާ ނިންމަންދެން އިރުޝާދު ހުށަހަޅާފައިވާ ޙާލަތުގައި ހުންނާނެއެވެ.",
      "awaitingApproval": "ހުއްދައަށް ހުށަހަޅާފައި. މިހާރު މިއޮތީ ކަނޑައަޅާފައިވާ ހުއްދަދޭ މީހާގެ އިންބޮކްސްގައެވެ؛ ހުއްދަދެވޭނީ މިކަމުގެ ހުއްދަ މަސައްކަތެއް ލިބިފައިވާ މީހަކަށް އެކަނިއެވެ.",
      "errors": {
        "approvalUnresolvable": "މި ޓްރާންސްފަރ އިރުޝާދަށް ހުއްދަދޭނެ މީހަކު ކަނޑައަޅާފައެއް ނުވެއެވެ. ތިޔަ ބޭފުޅާ ނޫން މީހަކު ކަނޑައަޅާ ހުއްދަ ސިޔާސަތެއް ނުވަތަ ބާރުގެ ޖަދުވަލުގެ ޤަވާއިދެއް އެޑްމިނިސްޓްރޭޓަރަކު ހަދަންވާނެއެވެ.",
        "noApprovalTask": "މި އިރުޝާދަށް ތިޔަ ބޭފުޅާއަށް ހުއްދަ މަސައްކަތެއް ނެތެވެ — މިއޮތީ ކަނޑައަޅާފައިވާ ހުއްދަދޭ މީހާގެ އިންބޮކްސްގައެވެ.",
        "screeningResultChanged": "މިއީ ހުޅުވިފަހުން ސްކްރީނިންގެ ނަތީޖާ ބަދަލުވެއްޖެއެވެ. އެއްވެސް އެއްޗެއް ނައްތާލެވިފައެއް ނުވެއެވެ. މިހާރު ހުރި ފެނުންތައް ބައްލަވައި، އެއީ ގޯސް ދިމާވުންތަކެއްނަމަ އަލުން ނައްތާލައްވާ.",
        "sod": {
          "approve": "މި އިރުޝާދު ހުށަހެޅީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ ހުއްދަ ނުދެވޭނެއެވެ. އެހެން މީހަކު ހުއްދަދޭންވާނެއެވެ.",
          "clear": "މި އިރުޝާދު ހެދީ ނުވަތަ ހިފަހައްޓާލި ރިލީޒް މަސައްކަތް ކުރީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ ހިފެހެއްޓުން ނުނައްތާލެވޭނެއެވެ. އެހެން ކޮމްޕްލަޔަންސް އޮފިސަރަކު ނައްތާލަންވާނެއެވެ.",
          "release": "މި އިރުޝާދު ހެދީ، ހުށަހެޅީ، ނުވަތަ މިއީގެ ސްކްރީނިން ހިފެހެއްޓުން ނައްތާލީ ތިޔަ ބޭފުޅާ ކަމަށްވާތީ ރިލީޒް ނުކުރެވޭނެއެވެ. އެހެން މީހަކު ރިލީޒް ކުރަންވާނެއެވެ.",
          "submit": "މި ކަމަށް ދެވަނަ މީހަކު ބޭނުންވެއެވެ: މި އިރުޝާދު ހެދުމާއި ނިންމުން ވެސް އެއް މީހަކަށް ނުކުރެވޭނެއެވެ."
        }
      },
      "screening": {
        "clear": "ސްކްރީނިން ހިފެހެއްޓުން ނައްތާލާ",
        "clearDescription": "ނައްތާލުމުން އިރުޝާދު އަނބުރާ ހުއްދަދެވިފައިވާ ޙާލަތަށް ދާނެއެވެ. އަދިވެސް ރިލީޒް ކުރަންޖެހޭނެއެވެ؛ ރިލީޒްކުރާއިރު އެހެން އެއްޗެއް ފެނިއްޖެނަމަ އަލުން ހިފަހައްޓާނެއެވެ.",
        "clearTitle": "ސްކްރީނިން ހިފެހެއްޓުން ނައްތާލުން",
        "cleared": "ސްކްރީނިން ހިފެހެއްޓުން ނައްތާލެވިއްޖެ. އިރުޝާދު އަލުން ހުއްދަދެވިފައި ވާތީ ރިލީޒް ކުރެވޭނެއެވެ.",
        "heldNotice": "ސޭންކްޝަންސް/ބޭރުފައިސާގެ ކޮންޓްރޯލް ސްކްރީނިންއަށް ހިފަހައްޓާފައި — ކޮމްޕްލަޔަންސް އޮފިސަރަކު ނައްތާލަންވާނެއެވެ. ބޭންކަށް އެއްވެސް އެއްޗެއް ފޮނުވާފައެއް ނުވާއިރު، އެއްވެސް ޕޯސްޓިންއެއް ވެސް ނުކުރެއެވެ.",
        "matched": "“{value}” އާ ދިމާވި",
        "reason": "ނައްތާލާ ސަބަބު",
        "resultChanged": "އިރުޝާދު އަލުން ސްކްރީން ކުރުމުން ނަތީޖާ ބަދަލުވީއެވެ. އެހެންކަމުން އެއްވެސް އެއްޗެއް ނައްތާލެވިފައެއް ނުވާއިރު ހިފެހެއްޓުން ދެމިއޮވެއެވެ. ނައްތާލުމުގެ ކުރިން ތިރީގައިވާ އާ ފެނުންތައް ބައްލަވާ."
      }
    },
    "bankConnections": {
      "title": "ބޭންކް ކަނެކްޝަންތައް",
      "description": "މީހަކު އަޕްލޯޑް ނުކޮށް ސްޓޭޓްމަންޓްތައް ސިސްޓަމަށް ލިބޭ ގޮތް. ކަނެކްޝަނެއް ދުވަނީ ސާވިސް ޕްރިންސިޕަލެއްގެ ގޮތުގައި، ދުވަހަކުވެސް މީހެއްގެ ގޮތުގައެއް ނޫން.",
      "create": "އައު ކަނެކްޝަން",
      "newTitle": "އައު ބޭންކް ކަނެކްޝަން",
      "editTitle": "ބޭންކް ކަނެކްޝަން އެޑިޓްކުރޭ",
      "formDescription": "ކަނެކްޝަނެއް ރައްކާކުރެވެނީ ޑްރާފްޓެއްގެ ގޮތުގައި، އެކްޓިވޭޓްކުރުމާއި ހަމައަށް އެއްވެސް ކަމެއް ނުކުރާނެ.",
      "created": "ކަނެކްޝަން އުފެއްދިއްޖެ",
      "saved": "ކަނެކްޝަން ރައްކާކުރެވިއްޖެ",
      "reloaded": "ތިބާ މަސައްކަތްކުރަމުންދަނިކޮށް އެހެން މީހަކު މި ކަނެކްޝަން ބަދަލުކޮށްފި. އަލުން ލޯޑްކުރެވިއްޖެ. ޗެކްކޮށް، ބަދަލު އަލުން ހައްދަވާ.",
      "loadFailed": "ބޭންކް ކަނެކްޝަންތައް ލޯޑް ނުކުރެވުނު",
      "healthFailed": "ކަނެކްޝަނުގެ ހާލަތު ލޯޑް ނުކުރެވުނު",
      "healthTitle": "ހާލަތު",
      "tableTitle": "ކަނެކްޝަންތައް",
      "emptyTitle": "އަދި ބޭންކް ކަނެކްޝަނެއް ނެތް",
      "emptyDescription": "ސްޓޭޓްމަންޓްތައް އަބަދުވެސް އަތުން އަޕްލޯޑްކުރެވޭނެ. ސްޓޯރޭޖް އިންބޮކްސެއް ޝެޑިއުލްގައި ހުސްކުރުމަށް ކަނެކްޝަނެއް އިތުރުކުރޭ.",
      "statusFilter": {
        "label": "ސްޓޭޓަސް",
        "all": "ހުރިހާ ސްޓޭޓަސްއެއް"
      },
      "status": {
        "draft": "ޑްރާފްޓް",
        "active": "އެކްޓިވް",
        "disabled": "ޑިސޭބަލްކޮށްފައި"
      },
      "health": {
        "total": "ކަނެކްޝަންތައް",
        "healthy": "ރަނގަޅު",
        "degraded": "ދަށްވެފައި",
        "failing": "ފެއިލްވަމުން",
        "rotation_due": "ރޮޓޭޝަން ޖެހިއްޖެ",
        "inactive": "އިނެކްޓިވް"
      },
      "channel": {
        "manual_upload": "އަތުން އަޕްލޯޑް",
        "storage_inbox": "ސްޓޯރޭޖް އިންބޮކްސް"
      },
      "channelHint": {
        "manual_upload": "ސްޓޭޓްމަންޓްތައް އަޕްލޯޑްކުރެވެނީ އަތުން. އެއްވެސް އެއްޗެއް ފެޗެއް ނުކުރެވޭ.",
        "storage_inbox": "މި ކަނެކްޝަނުގެ އިންބޮކްސަށް ލާ ފައިލުތައް ޝެޑިއުލްގައި އިމްޕޯޓްކުރެވޭނެ."
      },
      "columns": {
        "state": "ހާލަތު",
        "lastRun": "ފަހު ޓެސްޓާއި ފެޗް",
        "rotation": "ކްރެޑެންޝަލް ރޮޓޭޝަން",
        "actions": "ޢަމަލުތައް"
      },
      "fields": {
        "name": "ނަން",
        "bank": "ބޭންކް",
        "bankFixed": "ކަނެކްޝަން އުފެއްދުމަށްފަހު ބޭންކް ބަދަލެއް ނުކުރެވޭނެ.",
        "channel": "ޗެނަލް",
        "channelHint": "ލައިވް ބޭންކް ލިންކްތައް (ހޯސްޓް-ޓު-ހޯސްޓް، އޭޕީއައި، ނެޓްވޯކް) ހުށަނޭޅޭ. އުފެއްދުމަށްފަހު ބަދަލެއް ނުކުރެވޭނެ.",
        "endpoint": "އެންޑްޕޮއިންޓް",
        "endpointHint": "އިޚްތިޔާރީ. ޗެނަލް ކިޔާ އެޑްރެސް، އެއްޗެއް ހުރިނަމަ.",
        "credentialRef": "ކްރެޑެންޝަލް ރެފަރެންސް",
        "credentialRefHint": "ކްރެޑެންޝަލް ހިފަހައްޓާ ސީކްރެޓްގެ ނަން، ދުވަހަކުވެސް ސީކްރެޓް އަމިއްލައެއް ނޫން.",
        "rotatesOn": "ކްރެޑެންޝަލް ރޮޓޭޓްކުރާ ތާރީޚު",
        "rotatesOnHint": "ކްރެޑެންޝަލް ރޮޓޭޓްކުރަން ޖެހޭ ތާރީޚު. އޭގެ ކުރިން އިންޒާރެއް ދެވޭނެ.",
        "principal": "ސާވިސް ޕްރިންސިޕަލް",
        "principalHint": "ސްޓޭޓްމަންޓްތައް ހޯދާ ސާވިސް ޕްރިންސިޕަލްގެ ޔޫޒަރ އައިޑީ. މީހެއްގެ އެކައުންޓެއް އެކްޓިވޭޓްކުރާއިރު ރިޖެކްޓްކުރެވޭނެ.",
        "principalActive": "އެކްޓިވް ކަނެކްޝަނެއްގެ ޕްރިންސިޕަލް ބަދަލެއް ނުކުރެވޭނެ. ފުރަތަމަ ކަނެކްޝަން ޑިސޭބަލްކުރޭ.",
        "accounts": "ޚިދުމަތްދޭ ބޭންކް އެކައުންޓްތައް",
        "accountsHint": "މި ބޭންކުގައި ހުރި އެކައުންޓްތައް. އެއް އެކައުންޓަށް ޚިދުމަތްދޭ ކަނެކްޝަންތައް ތަރުތީބުކުރަނީ ޕްރިސީޑެންސް؛ ދެން ހުސް އަދަދު ނަގަން ހުސްކޮށް ބަހައްޓާ.",
        "precedence": "ޕްރިސީޑެންސް",
        "precedenceAuto": "ދެން ހުސް",
        "precedenceInvalid": "ޕްރިސީޑެންސް އަކީ 1 އިން ފެށޭ ފުރިހަމަ އަދަދެއް.",
        "noAccounts": "މި ބޭންކުގައި ހުރި އެއްވެސް ބޭންކް އެކައުންޓެއް ތިބާއަށް ނުފެނޭ."
      },
      "rotation": {
        "title": "ކްރެޑެންޝަލް ރޮޓޭޓްކުރަން ޖެހޭ",
        "due": "{date} އަށް ރޮޓޭޓްކުރަން ޖެހޭ، {days} ދުވަހުން",
        "overdue": "ރޮޓޭޝަން ތާރީޚު {date} ފާއިތުވީ {days} ދުވަސް ކުރިން",
        "ok": "{date} އަށް ރޮޓޭޓްކުރަން ޖެހޭ",
        "none": "ރޮޓޭޝަން ތާރީޚެއް ނެތް"
      },
      "consecutiveFailures": "ކައިރިކައިރީގައި {n} ފެއިލިއަރ",
      "namedUserWarning": "މީހެއްގެ އެކައުންޓެއް: އެކްޓިވޭޓްކުރުން ރިޖެކްޓްކުރެވޭނެ",
      "noPrincipal": "ސާވިސް ޕްރިންސިޕަލެއް ނެތް",
      "unassignedFiles": "އިންބޮކްސްގައި އެސައިން ނުކުރެވިފައިވާ {n} ފައިލު",
      "lastTest": "ޓެސްޓްކުރީ {at}: {result}",
      "lastFetch": "ފެޗްކުރީ {at}: {result}",
      "test": "ޓެސްޓް",
      "fetch": "މިހާރު ފެޗްކުރޭ",
      "activate": "އެކްޓިވޭޓްކުރޭ",
      "disable": "ޑިސޭބަލްކުރޭ",
      "testOk": "ކަނެކްޝަން ޓެސްޓް ފާސްވެއްޖެ",
      "testFailed": "ކަނެކްޝަން ޓެސްޓް ފެއިލްވެއްޖެ",
      "testFiles": "{waiting} ފައިލު އިންތިޒާރުގައި، {unassigned} އެސައިން ނުކުރެވި.",
      "fetched": "ފެޗް ނިމުނީ",
      "fetchCounts": "{imported} އިމްޕޯޓްކުރެވި، {duplicates} ޑުޕްލިކޭޓް، {rejected} ރިޖެކްޓްކުރެވި، {failed} ފެއިލްވެ، {unassigned} އެސައިން ނުކުރެވި.",
      "openImports": "ސްޓޭޓްމަންޓް އިމްޕޯޓްތައް ހުޅުވާ",
      "actionFailed": "އެކަން ރިޖެކްޓްކުރެވުނު",
      "activateTitle": "މި ކަނެކްޝަން އެކްޓިވޭޓްކުރޭ",
      "activateDescription": "ކަނެކްޝަނުގެ ސާވިސް ޕްރިންސިޕަލްގެ ގޮތުގައި، ޝެޑިއުލްގައި ސްޓޭޓްމަންޓްތައް ލިބެން ފަށާނެ.",
      "disableTitle": "މި ކަނެކްޝަން ޑިސޭބަލްކުރޭ",
      "disableDescription": "އިތުރަށް އެއްވެސް އެއްޗެއް ފެޗެއް ނުކުރެވޭނެ. ސްޓޭޓްމަންޓްތައް އަދިވެސް އަތުން އަޕްލޯޑްކުރެވޭނެ.",
      "reasonLabel": "ސަބަބު",
      "reasonRequired": "ކަނެކްޝަނެއް ޑިސޭބަލްކުރުމަށް ސަބަބެއް ބޭނުންވޭ.",
      "activated": "ކަނެކްޝަން އެކްޓިވޭޓްކުރެވިއްޖެ",
      "disabled": "ކަނެކްޝަން ޑިސޭބަލްކުރެވިއްޖެ",
      "errors": {
        "namedUser": "މި ކަނެކްޝަން ދުވަނީ މީހެއްގެ އެކައުންޓެއްގެ ގޮތުގައި. ސްޓޭޓްމަންޓް ހޯދުން ދުވަންޖެހޭނީ ސާވިސް ޕްރިންސިޕަލެއްގެ ގޮތުގައި. ސާވިސް ޕްރިންސިޕަލެއް ކަނޑައަޅައި، ދެން އެކްޓިވޭޓްކުރޭ.",
        "principalUnauthorised": "ސާވިސް ޕްރިންސިޕަލް ޑިސޭބަލްކޮށްފައި، ނުވަތަ ސްޓޭޓްމަންޓް އިމްޕޯޓް ނުކުރެވޭ.",
        "noPrincipal": "އެކްޓިވޭޓްކުރުމުގެ ކުރިން ސާވިސް ޕްރިންސިޕަލެއް ކަނޑައަޅާ.",
        "noAccounts": "ކަނެކްޝަނުން މަދުވެގެން އެއް ބޭންކް އެކައުންޓަށް ޚިދުމަތްދޭން ޖެހޭ.",
        "active": "އެކްޓިވް ކަނެކްޝަނެއްގެ ސާވިސް ޕްރިންސިޕަލް ބަދަލެއް ނުކުރެވޭނެ. ކަނެކްޝަން ޑިސޭބަލްކޮށް، ބަދަލުކޮށް، އަލުން އެކްޓިވޭޓްކުރޭ."
      }
    },
    "debtLifecycle": {
      "activate": {
        "confirm": "ފެސިލިޓީ އެކްޓިވް ކުރޭ",
        "description": "މި ފެސިލިޓީއިން ފައިސާ ނެގޭނެހެން ހުއްދަ ދޭށެވެ. މިއީ ރަޖިސްޓަރީ ކުރި ނުވަތަ ހުށަހެޅި މީހަކަށް ނުވާން ޖެހެއެވެ.",
        "title": "ފެސިލިޓީ އެކްޓިވް ކުރުން"
      },
      "amend": {
        "action": "ޝަރުތުތައް ބަދަލުކުރޭ",
        "confirm": "ބަދަލަށް އެދޭ",
        "description": "މި ކޮވެނަންޓުން ޓެސްޓު ކުރާ ކަންތައް ބަދަލުކުރޭ. ފޮނުވެނީ ބަދަލުކުރާ ބައިތައް އެކަނިއެވެ.",
        "done": "ކޮވެނަންޓު ބަދަލުކުރެވިއްޖެ.",
        "note": "ހިނގަމުންދާ ކޮވެނަންޓެއްގައި ބަދަލު އަދި ނުގެނެވޭނެއެވެ. ދެވަނަ މީހަކު އެކަން ތާއީދު ކުރަންދެން މަޑުކުރާނެއެވެ.",
        "pending": "ބަދަލަށް ދެވަނަ މީހެއްގެ ތާއީދަށް މަޑުކުރަނީ.",
        "title": "ކޮވެނަންޓުގެ ޝަރުތުތައް ބަދަލުކުރުން"
      },
      "approvedAt": "ހުއްދަ ދިން",
      "awaitingApproval": "ތާއީދަށް މަޑުކުރަނީ",
      "cancelDrawdown": {
        "action": "ކެންސަލް",
        "confirm": "ޑްރޯޑައުން ކެންސަލް ކުރޭ",
        "description": "މި ޑްރޯޑައުން އަދި ޕޯސްޓް ނުވާތީ ރިވާސް ނުކޮށް ކެންސަލް ކުރެވޭނެއެވެ. ޖާރނަލެއް ނުލިޔެވޭނެއެވެ.",
        "done": "ޑްރޯޑައުން ކެންސަލް ކުރެވިއްޖެ.",
        "note": "ކެންސަލް ކުރުމުން ބަހައްޓާފައިވާ ކޮމިޓްމަންޓް ދޫކޮށްލެވޭނެއެވެ. ޑްރޯޑައުން ރެކޯޑުގައި ކެންސަލް ކުރެވިފައިވާ ގޮތަށް ހުންނާނެއެވެ.",
        "title": "ޑްރޯޑައުނެއް ކެންސަލް ކުރުން"
      },
      "changePending": "ބަދަލަށް މަޑުކުރަނީ",
      "changes": {
        "approveTitle": "ބަދަލަށް ތާއީދުކުރުން",
        "approved": "ބަދަލަށް ތާއީދުކޮށް ހިންގައިފި.",
        "decideDescription": "މި ބަދަލަށް އެދުނު މީހަކަށް ނުވާން ޖެހެއެވެ.",
        "description": "ލިމިޓް އިތުރުކުރުމާއި ކޮވެނަންޓު ބަދަލުތައް މިތާނގައި ދެވަނަ މީހެއްގެ ނިންމުމަށް މަޑުކުރާނެއެވެ.",
        "empty": "ބަދަލަށް އެދުމެއް ނެތް. ލިމިޓް އިތުރުކުރުމެއް ނުވަތަ ކޮވެނަންޓު ބަދަލެއް މިތާނގައި ދެވަނަ ތާއީދުކުރާ މީހަކަށް މަޑުކުރާނެ.",
        "kind": {
          "covenant_add": "އައު ކޮވެނަންޓެއް",
          "covenant_amend": "ކޮވެނަންޓު ބަދަލެއް",
          "limit_increase": "ލިމިޓް އިތުރުކުރުން"
        },
        "rejectTitle": "ބަދަލު ރިޖެކްޓް ކުރުން",
        "rejected": "ބަދަލު ރިޖެކްޓް ކުރެވިއްޖެ.",
        "status": {
          "approved": "ތާއީދުކުރެވިފައި",
          "pending": "މަޑުކުރަނީ",
          "rejected": "ރިޖެކްޓް ކުރެވިފައި"
        },
        "title": "ބަދަލަށް އެދުންތައް"
      },
      "close": {
        "completeAction": "ބަންދުކުރުން ނިންމާ",
        "completeConfirm": "ފެސިލިޓީ ބަންދުކުރޭ",
        "completeDescription": "މި ބަންދުކުރުމަށް އެދުނީ އެހެން މުވައްޒަފެކެވެ. ބަންދުކުރުމުން އެކަން ނިމޭނެއެވެ؛ ތާރީޚު ރައްކާވާނެއެވެ.",
        "completeTitle": "ބަންދުކުރުން ނިންމުން",
        "completed": "ފެސިލިޓީ {code} ބަންދުކުރެވިއްޖެ.",
        "requestAction": "ފެސިލިޓީ ބަންދުކުރޭ",
        "requestConfirm": "ބަންދުކުރަން އެދޭ",
        "requestDescription": "ފެސިލިޓީ ބަންދުކުރާ ސަބަބު ބަޔާންކުރޭ. ބަންދުކުރުން ނިންމާނީ ދެވަނަ މީހެކެވެ.",
        "requestTitle": "ފެސިލިޓީ ބަންދުކުރަން އެދުން",
        "requested": "{code} ބަންދުކުރަން އެދިއްޖެ. ދެވަނަ މީހަކު އެކަން ނިންމަން ޖެހޭ.",
        "requestedReason": "ދެއްވި ސަބަބު"
      },
      "closeRequestedNote": "{at} ގައި ބަންދުކުރަން އެދިފައިވޭ: {reason}. ދެވަނަ މީހަކު އެކަން ނިންމަން ޖެހޭ، އަދި އެއާހަމައަށް އައު ޑްރޯޑައުނަކަށް އެދިނުވާނެ.",
      "confirm": {
        "action": "ކަށަވަރުކުރޭ",
        "confirm": "ކަށަވަރުކޮށް ޕޯސްޓްކުރޭ",
        "description": "ފައިސާ ލިބުނުކަން ދައްކާ ބޭންކް ސްޓޭޓްމަންޓް ލައިން ބަޔާންކުރޭ.",
        "done": "ޑްރޯޑައުން {no} ކަށަވަރުކޮށް ޕޯސްޓްކުރެވިއްޖެ.",
        "note": "ކަށަވަރު ކުރެވެންދެން ޑްރޯޑައުން އޮންނަނީ ޓްރާންސިޓުގައެވެ: އެއީ ފެސިލިޓީގެ ބެލެންސްގެ ބައެއް ނޫން، އަދި އެއްވެސް އެއްޗެއް ޕޯސްޓް ވެފައެއް ނުވޭ.",
        "title": "ޑްރޯޑައުނެއް ކަށަވަރުކުރުން"
      },
      "covenantApproval": {
        "approved": "ތާއީދުކުރެވިފައި",
        "pending_approval": "ތާއީދަށް މަޑުކުރަނީ",
        "rejected": "ރިޖެކްޓް ކުރެވިފައި"
      },
      "covenantDualNote": "ހިނގަމުންދާ ފެސިލިޓީއެއްގައި އައު ކޮވެނަންޓެއް ޓެސްޓު ކުރުމުގެ ކުރިން ދެވަނަ މީހެއްގެ ތާއީދަށް މަޑުކުރާނެ.",
      "covenantPendingApproval": "ކޮވެނަންޓު އިތުރުކޮށް ދެވަނަ މީހެއްގެ ތާއީދަށް މަޑުކުރަނީ.",
      "decision": {
        "approve": "ތާއީދުކުރޭ",
        "approveDrawdown": "ޑްރޯޑައުނަކަށް ތާއީދުކުރުން",
        "approveDrawdownNote": "ތާއީދުކުރުމުން ޑްރޯޑައުން ޓްރާންސިޓަށް ދޫކުރެވޭނެ. އަދިވެސް އެ ބޭންކް ސްޓޭޓްމަންޓާ ދިމާކޮށް ކަށަވަރުކުރަން ޖެހޭ.",
        "approveRepayment": "ރީޕޭމަންޓަކަށް ތާއީދުކުރުން",
        "approveRepaymentNote": "ތާއީދުކުރުމުން ރީޕޭމަންޓް އޭގެ ސްޓޭޓްމަންޓް ލައިނާ ދިމާކޮށް ޕޯސްޓްވާނެ.",
        "description": "މި މޫވްމަންޓް އޮތީ ބާރުގެ ހަދަށް ވުރެ މަތީގައި. އެ ތައްޔާރުކުރި މީހަކަށް ނުވާން ޖެހޭ.",
        "done": "ނިންމުން ރެކޯޑުކުރެވިއްޖެ.",
        "reject": "ރިޖެކްޓް",
        "rejectDrawdown": "ޑްރޯޑައުނެއް ރިޖެކްޓް ކުރުން",
        "rejectNote": "ރިޖެކްޓް ކުރުމުން މޫވްމަންޓް ކެންސަލް ވާނެ. ސަބަބު ބުނޭ.",
        "rejectRepayment": "ރީޕޭމަންޓެއް ރިޖެކްޓް ކުރުން"
      },
      "degraded": "ނުފުރިހަމަ",
      "degradedNote": "{periods} އަށް އިންޓަރެސްޓް އެކްރޫ ނުކުރެވޭ. އެ މުއްދަތުތައް އެކްރޫ ކުރެވެންދެން މި ފެސިލިޓީގެ އަދަދުތައް ނުފުރިހަމަ.",
      "drawdown": {
        "awaitingApproval": "ޑްރޯޑައުން {no} އަށް އެދިފައި ތާއީދަށް މަޑުކުރަނީ.",
        "confirm": "ޑްރޯޑައުނަކަށް އެދޭ",
        "description": "ބޭންކް ސްޓޭޓްމަންޓާ ދިމާކޮށް ކަށަވަރު ކުރެވެންދެން ޑްރޯޑައުން ޓްރާންސިޓުގައި ހުންނާނެ. އެއީ ފެސިލިޓީގެ ލިމިޓް ފަހަނައަޅައި ނުދެވޭނެ ކަމެއް.",
        "inTransit": "ޑްރޯޑައުން {no} އަށް އެދިފައި، ބޭންކް ސްޓޭޓްމަންޓުން ކަށަވަރުކުރަންދެން ޓްރާންސިޓުގައި."
      },
      "errors": {
        "ERR_COVENANT_ALREADY_TESTED": "މި ކޮވެނަންޓަށް އެ ތާރީޚުގައި ނަތީޖާއެއް އެބައޮތް. ރެކޯޑުކުރެވިފައިވާ ނަތީޖާ ބަދަލެއް ނުވޭ؛ ޚިލާފުވުމެއް ފޮހެވޭނީ ވޭވަރަކުން އެކަނި.",
        "ERR_COVENANT_BREACHED": "މި ފެސިލިޓީގައި ވޭވް ނުކުރެވޭ ކޮވެނަންޓު ޚިލާފުވުމެއް އެބައޮތް.",
        "ERR_DEBT_APPROVAL_PENDING": "ދެވަނަ މީހަކު އަދި މިއަށް ތާއީދެއް ނުކުރޭ.",
        "ERR_DEBT_EVIDENCE_MISMATCH": "އެ ސްޓޭޓްމަންޓް ލައިނަކީ މި މޫވްމަންޓުގެ ހެކި ނޫން.",
        "ERR_DEBT_TERMS_CHANGED": "މި ހުށަހެޅުމަށްފަހު ޝަރުތުތައް ބަދަލުވެއްޖެ. އަލުން ލޯޑުކުރެވިއްޖެ؛ ނިންމުމުގެ ކުރިން އައު ޝަރުތުތައް ބަލާ.",
        "ERR_FACILITY_AUTHORISATION_REQUIRED": "މި ބަދަލަށް ދެވަނަ މީހަކު ބޭނުންވޭ. އޭގެ ބަދަލުގައި އެކަމަށް އެދޭ.",
        "ERR_FACILITY_CLOSE_BLOCKED": "މި ފެސިލިޓީގައި އަދިވެސް ޒިންމާތައް އޮތުމުން އަދި ބަންދެއް ނުކުރެވޭނެ.",
        "ERR_FACILITY_IC_INSTRUMENT_REQUIRED": "އިންޓަރކޮމްޕެނީ ލޯނަކަށް އަގު ކަނޑައަޅާފައިވާ އިންޓަރކޮމްޕެނީ އިންސްޓްރުމަންޓެއް ބޭނުންވޭ.",
        "ERR_FACILITY_ROLLOVER_BLOCKED": "މި ފެސިލިޓީގެ ބަދަލުގައި އަދި އެހެން އެއްޗެއް ނުބެހެއްޓޭނެ.",
        "ERR_SCHEDULE_SUM_MISMATCH": "ޝެޑިއުލުން މެޗުއަރިޓީ ވާއިރަށް ނަގާފައިވާ ޕްރިންސިޕަލް އަނބުރާ ނުދައްކޭ.",
        "ERR_SOD_VIOLATION": "މިކަން ކުރަން ޖެހޭނީ އެހެން މީހެކެވެ."
      },
      "evidence": {
        "choose": "ސްޓޭޓްމަންޓް ލައިނެއް ޚިޔާރުކުރޭ",
        "empty": "މި އެކައުންޓުގައި މިކަމުގެ ހެކި ދެވޭނެ މެޗު ނުކުރެވޭ ސްޓޭޓްމަންޓް ލައިނެއް ނެތް. ފުރަތަމަ ސްޓޭޓްމަންޓް އިމްޕޯޓް ކުރޭ.",
        "hintIn": "މި ބޭންކް އެކައުންޓަށް ވަދެފައިވާ، މެޗު ނުކުރެވޭ ފައިސާ. އަދަދު ދިމާވާން ޖެހޭ.",
        "hintOut": "މި ބޭންކް އެކައުންޓުން ނިކުމެފައިވާ، މެޗު ނުކުރެވޭ ފައިސާ، ރީޕޭމަންޓުގެ ޖުމްލަ އަދަދަށް.",
        "line": "ބޭންކް ސްޓޭޓްމަންޓް ލައިން",
        "lineId": "ސްޓޭޓްމަންޓް ލައިން އައިޑީ",
        "lineRef": "ލައިން {id}",
        "loadFailed": "ސްޓޭޓްމަންޓް ލައިންތައް ލޯޑެއް ނުވި. އަލުން މަސައްކަތްކުރޭ، ނުވަތަ މި ޑައިލޮގް ބަންދުކޮށް އަލުން ހުޅުވާ.",
        "noAccount": "ފުރަތަމަ ބޭންކް އެކައުންޓް ޚިޔާރުކުރޭ.",
        "typedHint": "މި އެކައުންޓް ރިކޮންސައިލް ކުރާ މީހާއާ ލައިން އައިޑީ ސުވާލުކުރޭ."
      },
      "expenseReport": {
        "accrued": "އެކްރޫ ކުރެވުނު",
        "atRepayment": "ރީޕޭމަންޓުގައި",
        "caption": "ފެސިލިޓީ އަށް ބަލާ އިންޓަރެސްޓް ޚަރަދާއި އިފެކްޓިވް ރޭޓް",
        "chooseRange": "މުއްދަތަށް އިންޓަރެސްޓް ޚަރަދު ބެލުމަށް ފެށޭ ތާރީޚާއި ނިމޭ ތާރީޚު ޚިޔާރުކުރޭ.",
        "description": "ފެސިލިޓީއަށް ބަލާ އެކްރޫ ކުރެވުނު އަދި ދެއްކި އިންޓަރެސްޓް، ހާސިލުވި އިފެކްޓިވް ރޭޓާއެކު. ކޮންމެ ލައިނެއް ހުންނަނީ އޭގެ ފެސިލިޓީގެ ފައިސާއިން.",
        "effectiveRate": "އިފެކްޓިވް ރޭޓް",
        "empty": "މި މުއްދަތުގައި މި ޤާނޫނީ ފަރާތުގެ އެއްވެސް ފެސިލިޓީއެއްގައި އިންޓަރެސްޓެއް އެކްރޫ ނުވަތަ ދައްކާފައެއް ނުވޭ.",
        "from": "ފެށޭ",
        "loadFailed": "އިންޓަރެސްޓް ޚަރަދުގެ ރިޕޯޓް ލޯޑެއް ނުވި",
        "paid": "ދެއްކި",
        "title": "އިންޓަރެސްޓް ޚަރަދާއި އިފެކްޓިވް ރޭޓް",
        "to": "ނިމޭ"
      },
      "headroom": "ހެޑްރޫމް",
      "icInstrument": "އިންޓަރކޮމްޕެނީ އިންސްޓްރުމަންޓް",
      "icInstrumentHint": "މި ފެސިލިޓީ ބިނާވާ، އަގު ކަނޑައަޅާފައިވާ ލޯން އިންސްޓްރުމަންޓް. އެ ނެތި އެއްވެސް ޑްރޯޑައުނެއް ދޫނުކުރެވޭނެ.",
      "icInstrumentId": "އިންޓަރކޮމްޕެނީ އިންސްޓްރުމަންޓް އައިޑީ",
      "inTransit": "ޓްރާންސިޓުގައި",
      "inTransitHint": "ބޭންކުން އަދި ކަށަވަރު ނުކުރޭ",
      "interestExpense": "އިންޓަރެސްޓް ޚަރަދު",
      "ladderDegradedNote": "މަދުވެގެން އެއް ފެސިލިޓީއެއްގެ އެކްރޫއަލް ރަން ފަހަނައަޅާފައިވާތީ، މި ލެޑަރުގައި އެކްރޫ ނުކުރެވުނު އިންޓަރެސްޓް ނުހިމެނޭ.",
      "lender": {
        "bankHint": "ބޭންކް ގުޅުންތަކުގެ ރަޖިސްޓަރިން.",
        "bankId": "ލޯނު ދޭ ބޭންކުގެ އައިޑީ",
        "counterparty": "ލޯނު ދޭ ފަރާތް ނުވަތަ ކައުންޓަރޕާޓީ"
      },
      "limit": {
        "action": "ލިމިޓް އިތުރުކުރޭ",
        "confirm": "އިތުރުކުރަން އެދޭ",
        "current": "މިހާރުގެ ލިމިޓް",
        "description": "ހުއްދަ ދެވިފައިވާ ފެސިލިޓީއެއްގެ ލިމިޓް އިތުރުކުރުމަށް ދެވަނަ މީހެއްގެ ތާއީދު ބޭނުންވޭ.",
        "hint": "{currency} އިން އައު ލިމިޓް. ތާއީދު ކުރެވެންދެން އެއްވެސް ބަދަލެއް ނާދޭ.",
        "proposed": "އައު ލިމިޓް",
        "requested": "{code} ގެ ލިމިޓް އިތުރުކުރުމަށް ދެވަނަ މީހަކަށް މަޑުކުރަނީ.",
        "title": "ލިމިޓް އިތުރުކުރަން އެދުން"
      },
      "metricHint": "ރަޖިސްޓަރީ ކުރެވިފައިވާ މެޓްރިކް ކީއެއް، މިސާލަކަށް treasury.net_debt_to_ebitda. ހިސާބު ކުރެވޭ މެޓްރިކެއް ޓެސްޓު ކުރާއިރު ސިސްޓަމުން ހިސާބުކުރާނެ.",
      "openFacility": "ފެސިލިޓީ ހުޅުވާ",
      "pendingApprovalNote": "މި ފެސިލިޓީ އެކްޓިވް ކުރުމަށް ދެވަނަ މީހަކަށް މަޑުކުރަނީ. އެކްޓިވް ކުރެވެންދެން ނުވަތަ ޑްރާފްޓަށް އަނބުރާ ފޮނުވެންދެން އޭގެ ޝަރުތުތައް ބަދަލެއް ނުކުރެވޭނެ.",
      "registerNote": "ފެސިލިޓީ ރަޖިސްޓަރީ ކުރެވެނީ ޑްރާފްޓެއްގެ ގޮތުގައި. ފެސިލިޓީ ސްކްރީނުން އެ ހުށަހަޅާ؛ އެކްޓިވް ކުރާނީ ދެވަނަ މީހެކެވެ.",
      "registered": "ފެސިލިޓީ ޑްރާފްޓެއްގެ ގޮތުގައި ރަޖިސްޓަރީ ކުރެވިއްޖެ.",
      "reject": {
        "action": "ރިޖެކްޓް",
        "confirm": "ފެސިލިޓީ ރިޖެކްޓް ކުރޭ",
        "description": "ފެސިލިޓީ ޑްރާފްޓަށް އަނބުރާ ފޮނުވާ. ބަދަލުކުރަން ޖެހޭ ކަންތައް ބުނޭ.",
        "done": "ފެސިލިޓީ {code} ޑްރާފްޓަށް އަނބުރާ ފޮނުވިއްޖެ.",
        "title": "ފެސިލިޓީ ރިޖެކްޓް ކުރުން"
      },
      "rejectedNote": "މި ފެސިލިޓީ އަނބުރާ ފޮނުވިފައިވޭ: {note}",
      "repayment": {
        "awaitingApproval": "ރީޕޭމަންޓް {no} ރެކޯޑުކޮށް ތާއީދަށް މަޑުކުރަނީ.",
        "description": "ރީޕޭމަންޓް ދިމާކުރެވެނީ އެ ދެއްކި ބޭންކް ސްޓޭޓްމަންޓް ލައިނާއި، އަދި ޕޯސްޓްވަނީ އެ ލައިނުގެ ތާރީޚުގައި.",
        "interestHint": "މިހާތަނަށް އެކްރޫ ކުރެވުނު އިންޓަރެސްޓް ފިޔަވަން ހުސްކޮށް ބަހައްޓާ.",
        "penalty": "ޖޫރިމަނާ",
        "valueDateHint": "އިޚްތިޔާރީ. ރީޕޭމަންޓުގެ ތާރީޚަކީ އޭގެ ބޭންކް ސްޓޭޓްމަންޓް ލައިނުގެ ތާރީޚު."
      },
      "rollover": {
        "action": "ރޯލް އޯވަރ",
        "confirm": "ފަހުން އަންނަ ފެސިލިޓީ ޑްރާފްޓްކުރޭ",
        "description": "މި ފެސިލިޓީގެ ބަދަލުގައި އަންނަ ފެސިލިޓީ ޑްރާފްޓްކުރޭ. ދެވަނަ މީހަކު އެކްޓިވް ކުރަންދެން އެއްވެސް އެއްޗެއް ނުހިނގާނެ.",
        "drafted": "ފަހުން އަންނަ {code} ޑްރާފްޓްކުރެވިއްޖެ. އެކްޓިވް ކުރުމަށް ހުށަހަޅާ.",
        "inheritHint": "މި ފެސިލިޓީގެ ޝަރުތު ބަހައްޓަން ހުސްކޮށް ބަހައްޓާ.",
        "note": "އެކްޓިވް ކުރުމުން {code} ގެ ބާކީ ބެލެންސް ފަހުން އަންނަ ފެސިލިޓީއަށް ދާނެ، އަދި {code} ބަންދުވާނީ ބަދަލުކުރެވުނު ގޮތަށް. އެ ދުވަހަކުވެސް ފޮހެނުލެވޭނެ.",
        "title": "ރޯލް އޯވަރ ނުވަތަ ރީފައިނޭންސް"
      },
      "rolloverReason": "ރޯލް އޯވަރގެ ސަބަބު",
      "schedulePrincipalHint": "ނަގާފައިވާ ޕްރިންސިޕަލް ޝެޑިއުލް ކުރަން ހުސްކޮށް ބަހައްޓާ. މެޗުއަރިޓީ ވާއިރަށް ޝެޑިއުލުން އެ ފުރިހަމައަށް އަނބުރާ ދައްކަން ޖެހޭ.",
      "secondPrincipalNote": "މިއީ ތައްޔާރުކުރި މީހަކަށް ނުވާން ޖެހޭ. ސިސްޓަމުން ޗެކްކޮށް، އެހެން ނޫނީ ދެކޮޅު ހަދާނެ.",
      "securities": {
        "accountHint": "ރަހުނުކުރެވިފައިވާ އެކައުންޓެއްގެ ބެލެންސް ލިބެން ހުރި ލިކުއިޑިޓީއިން އުނިކުރެވޭނެ.",
        "accountWithheld": "ބޭންކް އެކައުންޓެއް ރަހުނުކުރުމަށް ބޭންކް އެކައުންޓް އަޕްޑޭޓް ކުރުމުގެ ހުއްދަ ބޭނުންވޭ. ބަޔާންކުރެވޭ ސެކިއުރިޓީއެއް އަދިވެސް ރެކޯޑުކުރެވޭނެ.",
        "description": "މި ފެސިލިޓީއާ ދެކޮޅަށް ރަހުނުކުރެވިފައިވާ މުދަލާއި އެކައުންޓުތައް.",
        "empty": "މި ފެސިލިޓީއާ ދެކޮޅަށް އެއްވެސް އެއްޗެއް ރަހުނުކުރެވިފައެއް ނުވޭ.",
        "noAccount": "ބޭންކް އެކައުންޓެއް ނޫން",
        "pledge": "ސެކިއުރިޓީ ރަހުނުކުރޭ",
        "pledgeDescription": "ރަހުނުކުރާ އެއްޗެއްގެ ނަން ބުނޭ. ރަހުނުކުރާ ބޭންކް އެކައުންޓެއް ވާނީ ރަހުނުކުރެވިފައިވާ ލިކުއިޑިޓީއަކަށް.",
        "pledgeTitle": "ސެކިއުރިޓީ ރަހުނުކުރުން",
        "pledged": "ސެކިއުރިޓީ ރެކޯޑުކުރެވިއްޖެ.",
        "release": "ދޫކޮށްލާ",
        "releaseDescription": "މި ސެކިއުރިޓީ ދޫކޮށްލާ. ބޭންކް އެކައުންޓެއް އެނބުރި ދާނީ ކުރިން އޮތް ލިކުއިޑިޓީ ކްލާހަށް.",
        "releaseTitle": "ސެކިއުރިޓީ ދޫކޮށްލުން",
        "released": "ސެކިއުރިޓީ ދޫކޮށްލެވިއްޖެ.",
        "status": {
          "pledged": "ރަހުނުކުރެވިފައި",
          "released": "ދޫކޮށްލެވިފައި"
        },
        "title": "ސެކިއުރިޓީ އަދި ކޮލެޓަރަލް"
      },
      "securityDescription": "ސެކިއުރިޓީ ނުވަތަ ކޮލެޓަރަލް",
      "securityDescriptionHint": "އިޚްތިޔާރީ. ލިކުއިޑިޓީއިން އުނިކުރެވޭނެހެން ރަހުނުކުރާ އެކައުންޓެއް ފެސިލިޓީ ސްކްރީނުން ރެކޯޑުކުރޭ.",
      "submit": {
        "action": "ތާއީދަށް ހުށަހަޅާ",
        "confirm": "ހުށަހަޅާ",
        "description": "މި ޑްރާފްޓް އެކްޓިވް ކުރުމަށް ދެވަނަ މީހަކަށް ފޮނުވާ.",
        "done": "ފެސިލިޓީ {code} ތާއީދަށް ހުށަހެޅިއްޖެ.",
        "title": "ފެސިލިޓީ ހުށަހެޅުން"
      },
      "supersededBy": "ބަދަލުގައި އައީ",
      "supersedes": "ބަދަލުގައި އަންނަނީ",
      "test": {
        "action": "ޓެސްޓު",
        "breached": "ކޮވެނަންޓާ ޚިލާފުވެއްޖެ. ސީއެފްއޯ، ރިސްކް އަދި އޮޑިޓަށް އަންގާފައިވޭ.",
        "computable": "ހިސާބުކުރެވޭ",
        "computedDescription": "ކޮވެނަންޓުގެ މެޓްރިކުން އަދަދު ހިސާބުކުރަނީ ސިސްޓަމުން.",
        "computedNote": "{metric} ހިސާބުކުރަނީ ސިސްޓަމުން. ތިބާ ޚިޔާރުކުރަނީ ޓެސްޓުގެ ތާރީޚު އެކަނި.",
        "confirm": "ޓެސްޓު ރެކޯޑުކުރޭ",
        "date": "ޓެސްޓުގެ ތާރީޚު",
        "dateHint": "އެންމެ ކުރީގައި ޖެހޭ ޓެސްޓަށް ނުވަތަ މިއަދަށް ހުސްކޮށް ބަހައްޓާ.",
        "derive": "ތްރެޝޯލްޑާ އަޅާކިޔާ",
        "manualDescription": "މި އަދަދަށް މަސްދަރެއް ނެތުމުން އެ ލިޔުއްވާ. ޓެސްޓު ރެކޯޑުކުރެވޭނީ މެނުއަލް ގޮތަށް.",
        "manualNote": "{metric} އަށް ހިސާބުކުރެވޭ މަސްދަރެއް ނެތް. އަސްލު އަދަދު ލިޔުއްވާ؛ އެ ރެކޯޑުކުރެވޭނީ މެނުއަލް ގޮތަށް.",
        "manualOnly": "މެނުއަލް އެންޓްރީ",
        "title": "ކޮވެނަންޓު ޓެސްޓުކުރުން"
      },
      "valueSource": {
        "computed": "ހިސާބުކުރެވިފައި",
        "manual": "މެނުއަލް"
      },
      "waiveReasonHint": "ލާޒިމު. ޚިލާފުވުމެއް ފޮހެވޭނީ ސަބަބަކާއެކު އެކަނި.",
      "withdraw": {
        "action": "ނަގާލާ",
        "closeAction": "ބަންދުކުރަން އެދުން ނަގާލާ",
        "closeNote": "ނަގާލުމުން ފެސިލިޓީ ހުންނާނީ އޮތް ގޮތަށް ހުޅުވިފައި. ފަހުން އަލުން ބަންދުކުރަން އެދިދާނެ.",
        "closeTitle": "ބަންދުކުރަން އެދުން ނަގާލުން",
        "confirm": "ނަގާލާ",
        "description": "މިކަން ނަގާލެވޭނީ މި ތައްޔާރުކުރި ނުވަތަ މިއަށް އެދުނު މީހަކަށް، ނުވަތަ ތާއީދުކުރާ މީހަކަށް. ސަބަބު ބުނޭ.",
        "done": "ނަގާލެވިއްޖެ.",
        "drawdownTitle": "ތާއީދަށް މަޑުކުރާ ޑްރޯޑައުނެއް ނަގާލުން",
        "movementNote": "ނަގާލުމުން ތާއީދަށް އެދުން ކެންސަލްވެ، ބަހައްޓާފައިވާ އެއްޗެއް ދޫކޮށްލެވޭނެ. އެއްވެސް އެއްޗެއް ޕޯސްޓް ނުވާތީ ރިވާސް ކުރާނެ އެއްޗެއް ނެތް.",
        "repaymentTitle": "ތާއީދަށް މަޑުކުރާ ރީޕޭމަންޓެއް ނަގާލުން"
      }
    },
    "transferIc": {
      "destinationEntity": "ފައިސާ ދާ ލީގަލް އެންޓިޓީ",
      "destinationEntityHint": "ފައިސާ ދަނީ ކާކުގެ އެކައުންޓަކަށް. އެހެން ލީގަލް އެންޓިޓީއެއްގެ އެކައުންޓެއް ނަމަ މިއީ އިންޓަރކޮމްޕެނީ ޓްރާންސްފަރއެކެވެ.",
      "instrument": "އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓް",
      "instrumentHint": "މި ޓްރާންސްފަރ ބިނާވާ ލޯނު، އެޑްވާންސް ނުވަތަ ކަރަންޓް އެކައުންޓް. އެކްޓިވް އިންސްޓްރުމެންޓެއް ނެތި ރިލީސް ނުކުރެވޭނެއެވެ.",
      "instrumentOption": "{no} — {kind}، {direction} — ބާކީ ލިމިޓް {headroom} {currency}",
      "advance": "އެޑްވާންސް",
      "repayment": "އަނބުރާ ދެއްކުން",
      "headroom": "ބާކީ ލިމިޓް",
      "toEntity": "{entity} އަށް",
      "noInstrument": "މި ލީގަލް އެންޓިޓީތަކުގެ މެދުގައި މި ފައިސާއިން އެކްޓިވް އިންސްޓްރުމެންޓެއް ނެތެވެ. ފުރަތަމަ އިންޓަރކޮމްޕެނީ ފަންޑިންގގައި އެއް ކަނޑައަޅާށެވެ.",
      "noInstrumentRead": "އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓްތައް ތިބާއަށް ނުފެނެއެވެ. ޓްރެޜަރީއަށް އެއް ކަނޑައަޅަން އެދޭށެވެ.",
      "instrumentMissing": "މި ޓްރާންސްފަރ ދަނީ އެހެން ލީގަލް އެންޓިޓީއަކަށް، އަދި އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓެއް ކަނޑައަޅާފައެއް ނުވެއެވެ. އެއް ކަނޑައަޅަންދެން ރިލީސް ނުކުރެވޭނެއެވެ.",
      "counterpartyLeg": "ފައިސާ ލިބޭ އެންޓިޓީގެ ޖާނަލް",
      "errors": {
        "instrumentRequired": "އެހެން ލީގަލް އެންޓިޓީއަކަށް ކުރާ ޓްރާންސްފަރއަކަށް، ދެ އެންޓިޓީގެ މެދުގައި އެކްޓިވް އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓެއް ބޭނުންވެއެވެ."
      }
    },
    "transferRoute": {
      "title": "އެޕްރޫވަލް މަގު",
      "previewDescription": "މިހާރު ސަބްމިޓް ކުރިނަމަ މި އިންސްޓްރަކްޝަން އެޕްރޫވް ކުރާނީ ކާކު. އަދި އެއްވެސް މީހަކަށް އެއްޗެއް ފޮނުވިފައެއް ނުވެއެވެ.",
      "liveDescription": "މި އިންސްޓްރަކްޝަނުން ހެދުނު އެޕްރޫވަލް ރިކުއެސްޓް، އަދި ކޮންމެ ފިޔަވަޅެއްގެ ހާލަތު.",
      "loadFailed": "އެޕްރޫވަލް މަގު ލޯޑް ނުކުރެވުނެވެ",
      "band": "ބާރުގެ ބޭންޑް:",
      "preview": "ޕްރިވިއު",
      "unresolvable": "ތިބާ ފިޔަވައި މި އިންސްޓްރަކްޝަން އެޕްރޫވް ކުރެވޭނެ މީހަކު ނެތެވެ، އެހެންވެ ސަބްމިޓް ކުރުން ރިޖެކްޓް ކުރެވޭނެއެވެ. އެޑްމިނިސްޓްރޭޓަރަކު އެޕްރޫވަރަކު ކަނޑައަޅަން ޖެހެއެވެ.",
      "step": "ފިޔަވަޅު {n}",
      "anyoneInRole": "{role} ލިބިފައިވާ ކޮންމެ މީހަކު",
      "noSteps": "މި އިންސްޓްރަކްޝަނަށް އެޕްރޫވަލް ފިޔަވަޅެއް ނުގުޅެއެވެ.",
      "mode": {
        "sequential": "ތަރުތީބުން",
        "parallel_any": "މީގެން ކޮންމެ އެކަކު"
      }
    },
    "transferEdit": {
      "title": "ޑްރާފްޓް އިންސްޓްރަކްޝަން އެޑިޓް ކުރުން",
      "description": "ޑްރާފްޓެއް މިނިވަންކަމާއެކު ބަދަލުކުރެވޭނެއެވެ. ސަބްމިޓް ކުރުމަށްފަހު ބަދަލަކީ އައު އިންސްޓްރަކްޝަނެކެވެ.",
      "beneficiaryHint": "މިތާނގައި ބެނެފިޝަރީ ބަދަލުކުރެވޭނެ ނަމަވެސް ނައްތާލެވޭކަށް ނެތެވެ. އިންޓަރނަލް އެކައުންޓަކަށް ދައްކަން ޑްރާފްޓް ކެންސަލް ކޮށް އައު އެއް ހަދާށެވެ.",
      "saved": "ޑްރާފްޓް ސޭވް ކުރެވިއްޖެ",
      "reloaded": "ތިބާ އެޑިޓް ކުރަމުން ދަނިކޮށް އެހެން މީހަކު މި އިންސްޓްރަކްޝަން ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑް ކުރެވިއްޖެ؛ ބަލާފައި ތިބާގެ ބަދަލުތައް އަލުން ސޭވް ކުރާށެވެ."
    },
    "transferConfirm": {
      "creditedAmount": "ކްރެޑިޓް ވި އަދަދު",
      "creditedAmountHint": "ފައިސާ ދިޔަ ތަނަށް ހަގީގަތުގައި ލިބުނު އަދަދު، އެތަނުގެ ފައިސާއިން. ލަފާކުރި އަދަދު ބެހެއްޓުމަށް ހުސްކޮށް ބާއްވާށެވެ.",
      "debitLine": "ފައިސާ ފޮނުވި ސްޓޭޓްމަންޓް ލައިން",
      "debitLineHint": "ފޮނުވި އެކައުންޓުގެ ސްޓޭޓްމަންޓްގައިވާ ޑެބިޓް.",
      "creditLine": "ފައިސާ ލިބުނު ސްޓޭޓްމަންޓް ލައިން",
      "creditLineHint": "ލިބުނު އެކައުންޓުގެ ސްޓޭޓްމަންޓްގައިވާ ކްރެޑިޓް.",
      "evidenceRequired": "ލީގަލް އެންޓިޓީތަކުގެ މެދުގައި ކުރާ ޓްރާންސްފަރއެއް ފުރިހަމަވަނީ ދެ ކޮޅުވެސް ސާބިތުވުމުންނެވެ: ފޮނުވި ސްޓޭޓްމަންޓްގެ ޑެބިޓާއި ލިބުނު ސްޓޭޓްމަންޓްގެ ކްރެޑިޓް ކަނޑައަޅާށެވެ.",
      "evidenceOptional": "މި އެންޓިޓީގެ އަމިއްލަ އެކައުންޓްތަކުގެ މެދުގައި ކުރާ ޓްރާންސްފަރއަކަށް ސްޓޭޓްމަންޓް ހެކި ލާޒިމެއް ނޫނެވެ. ދެ ލައިންވެސް ނުވަތަ އެއްވެސް ނޫން.",
      "bothRequired": "ދެ ސްޓޭޓްމަންޓް ލައިންވެސް ކަނޑައަޅާށެވެ: ލީގަލް އެންޓިޓީތަކުގެ މެދުގެ ޓްރާންސްފަރ ކޮންފަރމް ވަނީ ދެ ކޮޅުގެ ހެކިން.",
      "bothOrNeither": "ދެ ސްޓޭޓްމަންޓް ލައިންވެސް ނުވަތަ އެއްވެސް ނޫން ކަނޑައަޅާށެވެ.",
      "noLines": "ފޮނުވި ތާރީޚުން ފެށިގެން އެއް އެކައުންޓުގައި މެޗް ނުވާ ސްޓޭޓްމަންޓް ލައިނެއް ނުފެނުނެވެ. ފުރަތަމަ ސްޓޭޓްމަންޓް އިމްޕޯޓް ކުރާށެވެ.",
      "errors": {
        "evidenceMismatch": "ކަނޑައެޅި ސްޓޭޓްމަންޓް ލައިންތަކުން މި ޓްރާންސްފަރ ސާބިތެއް ނުވެއެވެ."
      }
    },
    "transferReport": {
      "pending": "ރިލީސް ކުރުމުގެ ކުރިން ރެގިއުލޭޓަރީ ރިޕޯޓެއް ރެކޯޑް ކުރަން ޖެހޭ: {countries}.",
      "clearBlocked": "ކޮމްޕްލަޔަންސް ކްލިއަރެންސަކުން ރެގިއުލޭޓަރީ ރިޕޯޓެއް މާފެއް ނުވެއެވެ. ފުރަތަމަ ރިޕޯޓް ރެކޯޑް ކުރާށެވެ؛ ދެން ކްލިއަރ ކުރުމަކީ އިންސްޓްރަކްޝަން ހިފަހައްޓާފައިވާ އެހެން ކަންކަމުގެ ޖަވާބެވެ.",
      "record": "ރެގިއުލޭޓަރީ ރިޕޯޓް ރެކޯޑް ކުރުން ({countries})",
      "listTitle": "ރެގިއުލޭޓަރީ ރިޕޯޓްތައް",
      "reportedOn": "ރިޕޯޓް ކުރެވުނީ {date}",
      "round": "ރައުންޑް {n}",
      "dialogTitle": "ރެގިއުލޭޓަރީ ރިޕޯޓް ރެކޯޑް ކުރުން ({countries})",
      "dialogDescription": "މި ހޯލްޑްގައި ބުނާ ހުރިހާ ޖުރިސްޑިކްޝަނަކަށް އެއް ރެފަރެންސް ފުދެއެވެ. އެހެން އެއްވެސް އެއްޗަކުން ހިފަހައްޓާފައި ނުވާނަމަ އިންސްޓްރަކްޝަން އެޕްރޫވްޑަށް އެނބުރޭނެއެވެ.",
      "sodNote": "ރިލީސް ކުރަން އުޅެގެން މި ހޯލްޑް ޖެހުނު މީހާއަށް އޭގެ ރިޕޯޓް ރެކޯޑް ނުކުރެވޭނެއެވެ، އަދި ރެކޯޑް ކުރާ މީހާއަށް ދެން ޓްރާންސްފަރ ރިލީސް ނުކުރެވޭނެއެވެ.",
      "reference": "ރެގިއުލޭޓަރުގެ ރެފަރެންސް",
      "reportedOnLabel": "ރިޕޯޓް ކުރި ތާރީޚް",
      "submit": "ރިޕޯޓް ރެކޯޑް ކުރުން",
      "reloaded": "ފުރަތަމަ އެހެން މީހަކު މި އިންސްޓްރަކްޝަން ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑް ކުރެވިއްޖެ؛ ބަލާފައި ރިޕޯޓް އަލުން ރެކޯޑް ކުރާށެވެ.",
      "recordedReleasable": "ރިޕޯޓް ރެކޯޑް ކުރެވިއްޖެ. ތިބާ ފިޔަވައި އެހެން މީހަކަށް މިހާރު އިންސްޓްރަކްޝަން ރިލީސް ކުރެވޭނެއެވެ.",
      "recordedStillHeld": "ރިޕޯޓް ރެކޯޑް ކުރެވިއްޖެ. އިންސްޓްރަކްޝަނުގެ އެހެން ފައިންޑިންގްތަކަށް ކޮމްޕްލަޔަންސް ކްލިއަރެންސަށް އަދިވެސް ހިފަހައްޓާފައިވެއެވެ.",
      "errors": {
        "sodRecord": "ތިބާގެ ރިލީސް މަސައްކަތުން މި އިންސްޓްރަކްޝަން ހިފެހެއްޓުނީ، އެހެންވެ ތިބާއަށް އޭގެ ރިޕޯޓް ރެކޯޑް ނުކުރެވޭނެއެވެ. އެހެން މީހަކު ކުރަން ޖެހެއެވެ.",
        "sodRelease": "މި އިންސްޓްރަކްޝަނުގެ ރެގިއުލޭޓަރީ ރިޕޯޓް ރެކޯޑް ކުރީ ތިބާ، އެހެންވެ ތިބާއަށް އެ ރިލީސް ނުކުރެވޭނެއެވެ. އެހެން މީހަކު ކުރަން ޖެހެއެވެ.",
        "pending": "ރެގިއުލޭޓަރީ ރިޕޯޓެއް ބާކީ ހުރިހާ ހިނދަކު ހޯލްޑް ކްލިއަރ ނުކުރެވޭނެއެވެ. ފުރަތަމަ ރިޕޯޓް ރެކޯޑް ކުރާށެވެ؛ ކްލިއަރެންސަކުން އެކަން މާފެއް ނުވެއެވެ.",
        "notRequired": "މި އިންސްޓްރަކްޝަން މިހާރު ރިޕޯޓިންގ ލާޒިމަކަށް ހިފަހައްޓާފައެއް ނުވެއެވެ، އެހެންވެ ރެކޯޑް ކުރާނެ ރިޕޯޓެއް ނެތެވެ. އަލުން ލޯޑް ކުރެވިއްޖެ."
      }
    },
    "transferScreening": {
      "clearedRecord": "ސްކްރީނިންގ ހޯލްޑް ކްލިއަރ ކުރެވުނީ {at}: {reason}"
    },
    "icInstruments": {
      "title": "އިންޓަރކޮމްޕެނީ ފަންޑިންގ",
      "description": "ދެ ލީގަލް އެންޓިޓީއެއްގެ މެދުގައިވާ ހުރިހާ ލޯނު، އެޑްވާންސް އަދި ކަރަންޓް އެކައުންޓެއް. އެހެން ލީގަލް އެންޓިޓީއަކަށް ކުރާ ޓްރާންސްފަރއެއް ބިނާވަނީ މީގެން އެއްގައި، އަދި އެ ނެތި ރިޖެކްޓް ކުރެވެއެވެ.",
      "create": "އައު އިންސްޓްރުމެންޓް",
      "createTitle": "އައު އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓް",
      "editTitle": "އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓް އެޑިޓް ކުރުން",
      "formDescription": "ޑްރާފްޓެއްގެ ގޮތުގައި ސޭވް ކުރެވޭނެއެވެ. ސަބްމިޓް ކޮށް އެޕްރޫވް ކުރަންދެން އެއްވެސް ޓްރާންސްފަރއެއް ނުބަލައިގަނެއެވެ.",
      "created": "އިންސްޓްރުމެންޓް {no} ޑްރާފްޓް ކުރެވިއްޖެ",
      "saved": "އިންސްޓްރުމެންޓް ސޭވް ކުރެވިއްޖެ",
      "submitted": "އިންސްޓްރުމެންޓް އެޕްރޫވަލަށް ސަބްމިޓް ކުރެވިއްޖެ",
      "closed": "އިންސްޓްރުމެންޓް ބަންދު ކުރެވިއްޖެ",
      "close": "އިންސްޓްރުމެންޓް ބަންދު ކުރުން",
      "closeTitle": "މި އިންސްޓްރުމެންޓް ބަންދު ކުރުން",
      "closeDescription": "ބެލެންސް ސުމެއްކަމުގައިވެ، ދަތުރުގައި އެއްވެސް އެއްޗެއް ނެތްނަމަ އެކަނި. ބަންދު ކުރާ ސަބަބު ބަޔާން ކުރާށެވެ.",
      "reloaded": "ފުރަތަމަ އެހެން މީހަކު މި އިންސްޓްރުމެންޓް ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑް ކުރެވިއްޖެ؛ ބަލާފައި ތިބާގެ ބަދަލު އަލުން ކުރާށެވެ.",
      "loadFailed": "އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓްތައް ލޯޑް ނުކުރެވުނެވެ",
      "detailFailed": "އިންސްޓްރުމެންޓް ލޯޑް ނުކުރެވުނެވެ",
      "detailTitle": "އިންސްޓްރުމެންޓް",
      "tableTitle": "އިންސްޓްރުމެންޓްތައް",
      "emptyTitle": "އަދި އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓެއް ނެތް",
      "emptyDescription": "ލީގަލް އެންޓިޓީތަކުގެ މެދުގައި ފައިސާ ހަރަކާތްކުރަނީ ކަނޑައެޅިފައިވާ އިންސްޓްރުމެންޓެއްގެ ދަށުން އެކަނި. ކޮންމެ ލޯނު ގުޅުމަކަށް އެއް ހަދާށެވެ.",
      "anyEntity": "ކޮންމެ ލީގަލް އެންޓިޓީއެއް",
      "anyKind": "ކޮންމެ ބާވަތެއް",
      "anyStatus": "ކޮންމެ ހާލަތެއް",
      "awaitingApproval": "އެޕްރޫވަލް އިންބޮކްސްގައި އެޕްރޫވަލަށް އިންތިޒާރުކުރަނީ. ޑްރާފްޓް ނުވަތަ ސަބްމިޓް ކުރި މީހާ ފިޔަވައި އެހެން މީހަކު ނިންމަން ޖެހެއެވެ.",
      "rejected": "ރިޖެކްޓް ކުރެވިފައި: {note}",
      "pairFixed": "ދެ ލީގަލް އެންޓިޓީ ހަރުކޮށްފައިވެއެވެ. އެހެން ދެ އެންޓިޓީއަކީ އައު އިންސްޓްރުމެންޓެކެވެ.",
      "basisHint": "ޓްރާންސްފަރ ޕްރައިސިންގ ޕޮލިސީ: ރިލީސް ކުރުމުގެ ކުރިން މި ދެ އެންޓިޓީއަށް އެޕްރޫވްވެފައިވާ ޕޮލިސީއެއް ބޭނުންވެއެވެ.",
      "maturityHint": "އިޚްތިޔާރީ. އޭގެ ފަހުން އެޑްވާންސެއް ރިލީސް ނުކުރެވޭނެ؛ އަނބުރާ ދެއްކުން ކުރެވޭނެއެވެ.",
      "descriptionHint": "ސެޓްލްމަންޓް އުންމީދު: ބޮރޯވަރ އަނބުރާ ދައްކާނީ ކިހިނެއް އަދި ކޮން އިރަކު.",
      "noMaturity": "މެޗުއަރިޓީއެއް ނެތް",
      "tpPolicy": "ޕޮލިސީ #{id}",
      "tabs": {
        "instruments": "އިންސްޓްރުމެންޓްތައް",
        "loans": "ލޯނު ރަޖިސްޓަރު"
      },
      "fields": {
        "instrumentNo": "އިންސްޓްރުމެންޓް",
        "lender": "ލޯނު ދޭ ފަރާތް",
        "borrower": "ލޯނު ނަގާ ފަރާތް",
        "kind": "ބާވަތް",
        "pricingBasis": "އަގު ކަނޑައަޅާ ބިންގާ",
        "principalLimit": "ޕްރިންސިޕަލް ލިމިޓް",
        "outstanding": "ބާކީ",
        "inFlight": "ދަތުރުގައި",
        "headroom": "ބާކީ ލިމިޓް",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "maturityDate": "މެޗުއަރިޓީ",
        "description": "ސެޓްލްމަންޓް އުންމީދު",
        "closeNote": "ބަންދު ކުރި ނޯޓް"
      },
      "kind": {
        "loan": "ލޯނު",
        "advance": "އެޑްވާންސް",
        "current_account": "ކަރަންޓް އެކައުންޓް"
      },
      "status": {
        "draft": "ޑްރާފްޓް",
        "pending_approval": "އެޕްރޫވަލަށް އިންތިޒާރުގައި",
        "active": "އެކްޓިވް",
        "matured": "މެޗުއަރ ވެފައި",
        "closed": "ބަންދު"
      },
      "basis": {
        "tp_policy": "ޓްރާންސްފަރ ޕްރައިސިންގ ޕޮލިސީ",
        "at_cost": "ކޮސްޓަށް",
        "interest_free": "އިންޓަރެސްޓް ނުނަގާ"
      },
      "evidence": {
        "policy": "އަގު ކަނޑައަޅާ ބިންގާ: {basis}. ސަބްމިޓް ކުރުމަށް، ފެށޭ ތާރީޚުގައި ހިނގަމުންދާ، މި ލީގަލް އެންޓިޓީތަކަށް އެޕްރޫވްވެފައިވާ ޓްރާންސްފަރ ޕްރައިސިންގ ޕޮލިސީއެއް ބޭނުންވެއެވެ. އޭގައި ބޭސިސް ނޯޓެއް ނުވަތަ އެޓޭޗްމަންޓެއް ހުންނަން ޖެހެއެވެ. މިކަން ބަލަނީ ސަބްމިޓް ކުރާއިރުއެވެ.",
        "attachmentMissing": "އަގު ކަނޑައަޅާ ބިންގާ: {basis}. ސަބްމިޓް ކުރުމުގެ ކުރިން މި ބިންގާގެ ހެކި ތިރީގައި އެޓޭޗް ކުރާށެވެ: އެއްވެސް އެޓޭޗްމަންޓެއް ނެތި ސަބްމިޓް ކުރުން ރިޖެކްޓް ކުރެވޭނެއެވެ.",
        "attachmentPresent": "އަގު ކަނޑައަޅާ ބިންގާ: {basis}. ހެކި އެޓޭޗް ކޮށްފައިވެއެވެ؛ ސަބްމިޓް ކުރުމުން އިންސްޓްރުމެންޓާއެކު ހަރުވާނެއެވެ.",
        "attachmentUnknown": "އަގު ކަނޑައަޅާ ބިންގާ: {basis}. ސަބްމިޓް ކުރުމަށް ބިންގާގެ ހެކި ދައްކާ މަދުވެގެން އެއް އެޓޭޗްމަންޓް ބޭނުންވެއެވެ. މި އިންސްޓްރުމެންޓްގެ އެޓޭޗްމަންޓްތައް ތިބާއަށް ނުފެނޭތީ، މިކަން ބަލަނީ ސަބްމިޓް ކުރާއިރުއެވެ.",
        "methodLabel": "އަގު ކަނޑައަޅާ ގޮތް",
        "evidenceLabel": "ހެކި",
        "requirement": "އަގު ކަނޑައަޅާ ބިންގާގެ ހެކި އެޓޭޗް ކުރާށެވެ (މިސާލަކަށް ކޮސްޓް ހިސާބު، ނުވަތަ އިންޓަރެސްޓް ނުނަގާ ލޯނަކަށް ބޯޑުގެ އެޕްރޫވަލް). އެޓޭޗްމަންޓްތައް ބަދަލުކުރެވެނީ އިންސްޓްރުމެންޓް ޑްރާފްޓްކަމުގައި ހުރިއިރު އެކަނި."
      },
      "errors": {
        "pricingEvidence": "އަގު ކަނޑައަޅާ ގޮތާއި އޭގެ ހެކި ނެތި އިންސްޓްރުމެންޓް ސަބްމިޓް ނުކުރެވޭނެއެވެ.",
        "ruleMissing": "މި ލީގަލް އެންޓިޓީތަކުގެ މެދުގައި އިންޓަރކޮމްޕެނީ ރޫލެއް ނެތެވެ، އެހެންވެ ޕޯސްޓް ކުރާނެ ޑިއު-ޓު އަދި ޑިއު-ފްރޮމް އެކައުންޓެއް ނެތެވެ. ފުރަތަމަ އެންޓަރޕްރައިޒްގައި ރޫލް ކަނޑައަޅާށެވެ.",
        "approvalUnresolvable": "އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓްތަކަށް ތިބާ ފިޔަވައި އެޕްރޫވަރަކު ކަނޑައަޅާފައެއް ނުވެއެވެ. އެޑްމިނިސްޓްރޭޓަރަކު އެއް ކަނޑައަޅަން ޖެހެއެވެ.",
        "outstanding": "މި އިންސްޓްރުމެންޓްގައި އަދިވެސް ބެލެންސް އޮވެއެވެ. ފުރަތަމަ ބާކީ އަދި ދަތުރުގައިވާ އަދަދުތައް ސެޓަލް ކުރާށެވެ.",
        "samePair": "ލޯނު ދޭ ފަރާތާއި ނަގާ ފަރާތަކީ ދެ ތަފާތު ލީގަލް އެންޓިޓީ ކަމުގައި ވާން ޖެހެއެވެ."
      },
      "report": {
        "title": "އިންޓަރކޮމްޕެނީ ލޯނު ރަޖިސްޓަރު",
        "asOf": "ތާރީޚަށް",
        "asOfLabel": "{date} ގެ ހާލަތު",
        "scope": "ދައްކާ",
        "scopeLoans": "ލޯނު އެކަނި",
        "scopeAll": "ހުރިހާ ބާވަތެއް",
        "includeClosed": "ބަންދު އިންސްޓްރުމެންޓްތައް ހިމަނާ",
        "advanced": "ދެވުނު",
        "repaid": "އަނބުރާ ދެއްކުނު",
        "total": "ޖުމްލަ {currency}",
        "totalsNote": "ކޮންމެ ފައިސާއެއްގެ ޖުމްލައިގައި ހުރިހާ ބާވަތެއްގެ އިންސްޓްރުމެންޓް ހިމެނެއެވެ. އެ ފެނުމަށް ހުރިހާ ބާވަތެއް ދައްކާށެވެ.",
        "loadFailed": "ލޯނު ރަޖިސްޓަރު ލޯޑް ނުކުރެވުނެވެ",
        "emptyTitle": "ރަޖިސްޓަރުގައި އެއްވެސް އެއްޗެއް ނެތް",
        "emptyDescription": "މެޗްވާ ލައިވް އިންޓަރކޮމްޕެނީ އިންސްޓްރުމެންޓެއް ނެތެވެ. އެޕްރޫވްވެފައިވާ އިންސްޓްރުމެންޓްތައް، ދެވުނު، އަނބުރާ ދެއްކުނު އަދި ބާކީ އަދަދާއެކު މިތާ ފެނޭނެއެވެ."
      }
    },
    "exchangeControls": {
      "intro": "ކޮންމެ ކޮރިޑޯއެއްގެ އެކްސްޗޭންޖް ކޮންޓްރޯލް ލާޒިމުތައް. މީގެން އެއް ފަޅާލާ ބޯޑަރު ހުރަސްކުރާ ރިލީސްއެއް ސްކްރީނިންގއަށް ހިފަހައްޓައި، ސޭންކްޝަން ހިޓެއް ފަދައިން ކޮމްޕްލަޔަންސުން ކްލިއަރ ކުރަން ޖެހެއެވެ.",
      "loadFailed": "އެކްސްޗޭންޖް ކޮންޓްރޯލް ރޫލްތައް ލޯޑް ނުކުރެވުނެވެ",
      "currentTitle": "ހިނގަމުންދާ ރޫލްތައް",
      "emptyTitle": "އެކްސްޗޭންޖް ކޮންޓްރޯލް ރޫލެއް ނެތް",
      "emptyDescription": "ރޫލް ނެތްނަމަ އެއްވެސް ކޮރިޑޯއެއް ބަންދެއް، ލިމިޓެއް، ނުވަތަ މަޤްޞަދު ބަޔާންކުރުން ލާޒިމެއް ނުވެއެވެ. ކޮންމެ ޖުރިސްޑިކްޝަނެއް ކަނޑައަޅާ ލާޒިމުތައް އިތުރުކުރާށެވެ.",
      "edit": "ރޫލްތައް އެޑިޓް ކުރުން",
      "draftTitle": "ޑްރާފްޓް ރޫލް ސެޓް",
      "draftDescription": "ރިވިއުކޮށް މުޅި ސެޓް ބަދަލުކުރަންދެން އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވާނެއެވެ.",
      "draftEmpty": "ޑްރާފްޓްގައި ރޫލެއް ނެތެވެ. މިއާއި ބަދަލުކުރުމުން ހުރިހާ ރޫލެއް ފުހެވޭނެއެވެ.",
      "add": "ރޫލް އިތުރުކުރުން",
      "remove": "ފުހެލުން",
      "review": "ބަދަލުތައް ރިވިއު ކުރުން",
      "reviewTitle": "އެކްސްޗޭންޖް ކޮންޓްރޯލް ރޫލްތައް ބަދަލުކުރުން",
      "reviewDescription": "މި ޑްރާފްޓް ސޭވްކުރުމުން ބަދަލުވާ ގޮތް، ރޫލަކުން ރޫލަކަށް.",
      "reviewWarning": "މުޅި ސެޓް އެއްފަހަރާ ބަދަލުވެ، ސްކްރީން ކުރެވޭ ދެން އަންނަ ރިލީސްއިން ފެށިގެން ހިނގާނެއެވެ.",
      "backToDraft": "ޑްރާފްޓަށް އެނބުރި",
      "replace": "ރޫލް ސެޓް ބަދަލުކުރުން",
      "saved": "އެކްސްޗޭންޖް ކޮންޓްރޯލް ރޫލްތައް ބަދަލުކުރެވިއްޖެ",
      "reloaded": "ތިބާ އެޑިޓް ކުރަމުން ދަނިކޮށް އެހެން މީހަކު ރޫލްތައް ބަދަލުކޮށްފިއެވެ. އެއްވެސް އެއްޗެއް ސޭވެއް ނުވިއެވެ. ތިބާގެ ބަދަލުތައް މިހާރު ބަލަނީ އެމީހުންގެ ސެޓާއި އަޅާކިޔައިގެން؛ ރިވިއުކޮށް އަލުން ބަދަލުކުރާށެވެ.",
      "anyCurrency": "ކޮންމެ ފައިސާއެއް",
      "active": "އެކްޓިވް",
      "inactive": "އިނެކްޓިވް",
      "fields": {
        "countryCode": "ޤައުމު",
        "currency": "ފައިސާ",
        "rule": "ރޫލް",
        "threshold": "ހަދު",
        "description": "ތަފްޞީލު",
        "status": "ހާލަތު"
      },
      "rule": {
        "prohibited": "މަނާ",
        "limit": "އިންސްޓްރަކްޝަނަކަށް ލިމިޓް",
        "purpose_required": "މަޤްޞަދު ކޯޑު ލާޒިމް",
        "report_required": "ރެގިއުލޭޓަރީ ރިޕޯޓް ލާޒިމް"
      },
      "thresholdHint": {
        "prohibited": "ކޮރިޑޯއަށް ކުރާ ހުރިހާ ޕޭމަންޓެއް ހިފަހައްޓައެވެ.",
        "limit": "ލާޒިމް. މިއަށްވުރެ ބޮޑު ޕޭމަންޓެއް ހިފަހައްޓައެވެ.",
        "purpose_required": "މި އަދަދުން ފެށިގެން (ހުސްނަމަ ކޮންމެ އަދަދެއް) މަޤްޞަދު ކޯޑު ނެތް ޕޭމަންޓެއް ހިފަހައްޓައެވެ.",
        "report_required": "މި އަދަދުން ފެށިގެން (ހުސްނަމަ ކޮންމެ އަދަދެއް) ރެގިއުލޭޓަރުގެ ރިޕޯޓް ރެފަރެންސް ރެކޯޑް ކުރަންދެން ރިލީސްގައި ޕޭމަންޓް ހިފަހައްޓައެވެ. ކޮމްޕްލަޔަންސް ކްލިއަރެންސަކުން މިކަން މާފެއް ނުވެއެވެ."
      },
      "change": {
        "added": "އިތުރުކުރެވުނު",
        "removed": "ފުހެވުނު",
        "changed": "ބަދަލުވި",
        "field": "{field}: {before} → {after}"
      }
    },
    "screeningLists": {
      "tabs": {
        "entries": "ފަރާތްތަކާއި ޖުރިސްޑިކްޝަންތައް",
        "exchangeControls": "އެކްސްޗޭންޖް ކޮންޓްރޯލް"
      },
      "title": "ސްކްރީނިންގ ލިސްޓްތައް",
      "description": "ކޮންމެ ޓްރާންސްފަރ ރިލީސްއެއް ސްކްރީން ކުރެވޭ ފަރާތްތަކާއި ޖުރިސްޑިކްޝަންތައް. ބޭރުގެ ފީޑެއް ނެތެވެ: މިތާ ނެތް އެންޓްރީއަކީ އެއްވެސް މީހަކު ނުހުއްޓުވާނެ ޕޭމަންޓެކެވެ.",
      "create": "އައު އެންޓްރީ",
      "createTitle": "އައު ސްކްރީނިންގ އެންޓްރީ",
      "editTitle": "ސްކްރީނިންގ އެންޓްރީ އެޑިޓް ކުރުން",
      "formDescription": "ސްކްރީން ކުރެވޭ ދެން އަންނަ ރިލީސްއިން ފެށިގެން ހިނގާނެއެވެ.",
      "created": "އެންޓްރީ ސްކްރީނިންގ ލިސްޓަށް އިތުރުކުރެވިއްޖެ",
      "saved": "އެންޓްރީ ސޭވް ކުރެވިއްޖެ",
      "retire": "ރިޓަޔަރ ކުރުން",
      "reactivate": "އަލުން އެކްޓިވް ކުރުން",
      "retired": "އެންޓްރީ ރިޓަޔަރ ކުރެވިއްޖެ",
      "reactivated": "އެންޓްރީ އަލުން އެކްޓިވް ކުރެވިއްޖެ",
      "reloaded": "ފުރަތަމަ އެހެން މީހަކު މި އެންޓްރީ ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑް ކުރެވިއްޖެ؛ ތިބާގެ ބަދަލު އަލުން ކުރާށެވެ.",
      "loadFailed": "ސްކްރީނިންގ ލިސްޓް ލޯޑް ނުކުރެވުނެވެ",
      "tableTitle": "އެންޓްރީތައް",
      "emptyTitle": "ސްކްރީނިންގ ލިސްޓް ހުސް",
      "emptyDescription": "ސޭންކްޝަން ކުރެވިފައިވާ ފަރާތްތަކާއި ޖުރިސްޑިކްޝަންތައް އިތުރުކުރާށެވެ، ނުވަތަ CSV އިން ލިސްޓެއް އިމްޕޯޓް ކުރާށެވެ. އެހާތަނަށް ރިލީސްތައް ސްކްރީން ކުރެވެނީ އެއްވެސް އެއްޗަކާ ނޫނެވެ.",
      "anyType": "ކޮންމެ ބާވަތެއް",
      "actionsColumn": "ޢަމަލުތައް",
      "typeFixed": "އެންޓްރީ ހެދުމަށްފަހު ބާވަތް ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "aliasesHint": "ފަރާތް އެނގިފައިވާ އެހެން ނަންތައް، ކޮންމެ ލައިނެއްގައި އެއް ނުވަތަ ; އިން ވަކިކޮށް",
      "countryHint": "ދެ އަކުރުގެ ISO ކޯޑް. ޖުރިސްޑިކްޝަނަކަށް ލާޒިމް.",
      "sourceHint": "އެންޓްރީ އައި ތަން، މިސާލަކަށް ލިސްޓް ޝާއިޢު ކުރާ ފަރާތް.",
      "type": {
        "party": "ފަރާތް",
        "country": "ޖުރިސްޑިކްޝަން"
      },
      "state": {
        "active": "އެކްޓިވް",
        "retired": "ރިޓަޔަރ ކުރެވިފައި"
      },
      "activeFilter": {
        "active": "އެކްޓިވް އެކަނި",
        "retired": "ރިޓަޔަރ ކުރެވިފައިވާ އެކަނި",
        "all": "އެކްޓިވް އަދި ރިޓަޔަރ ކުރެވިފައިވާ"
      },
      "fields": {
        "entryType": "ބާވަތް",
        "name": "ނަން",
        "aliases": "އެހެން ނަންތައް",
        "bic": "BIC",
        "countryCode": "ޤައުމު",
        "listName": "ލިސްޓް",
        "source": "މަސްދަރު"
      },
      "import": {
        "open": "CSV އިމްޕޯޓް",
        "title": "ސްކްރީނިންގ ލިސްޓް އިމްޕޯޓް ކުރުން",
        "description": "ހެޑަރ ރޯ ލާޒިމް: name؛ އިޚްތިޔާރީ entryType (party ނުވަތަ country)، aliases (; އިން ވަކިކޮށް)، bic، countryCode، listName، source. އެއް ގޯސް ރޯއަކުން އެއްވެސް އެއްޗެއް އިމްޕޯޓް ނުކުރެވޭނެއެވެ.",
        "file": "CSV ފައިލް",
        "submit": "އިމްޕޯޓް",
        "done": "{n} އެންޓްރީ އިމްޕޯޓް ކުރެވިއްޖެ",
        "refused": "އެއްވެސް އެއްޗެއް އިމްޕޯޓް ނުކުރެވުނު: {n} ރޯ އެރަރ.",
        "rowError": "ލައިން {row}، {field}: {code}"
      }
    },
    "wallet_funding": {
      "below_threshold": "ވޮލެޓެއް އޭގެ ފަންޑިންގ ތްރެޝޯލްޑުގެ ދަށަށް ވެއްޓިފައި ވޭ.",
      "credited_closed_wallet": "ފަންޑިންގ ޓްރާންސްފަރެއް ކްލޯޒްކުރެވިފައިވާ ވޮލެޓަކަށް ކްރެޑިޓްކުރެވިފައި ވޭ."
    },
    "mandate_panel": {
      "cannot_meet_rule": "ފާސްކުރާ ޕެނަލަށް މެންޑޭޓްގެ ޤަވާޢިދު ފުރިހަމަކުރެވެން ނެތް."
    },
    "queue": {
      "transit_break": "ޓްރާންސިޓްގައި ހުއްޓިފައިވާ ޓްރާންސްފަރުތައް",
      "wallet_variance": "ވޮލެޓް ގުނުމުގެ ތަފާތުތައް",
      "bank_limit_breach": "ބޭންކުގެ ކައުންޓަރޕާޓީ ހައްދަށް ވުރެ ގިނަ ފައިސާ ހުރި ބޭންކުތައް"
    },
    "wallet_leaver": {
      "holder_gone": "މި ވޮލެޓް ހިފަހައްޓާ މީހާ ދޫކޮށްލައިފިއެވެ. އެ ހަވާލުކުރުމުގެ ޙާލަތަށް ބަދަލުވެފައިވާތީ އާ ކަސްޓޯޑިއަނަކު ނުވަތަ ރިކަވަރީއެއް ބޭނުންވެއެވެ."
    },
    "wallet_dormant": {
      "idle": "މި ވޮލެޓް ބޭކާރުވެފައި އޮތީ އޭގެ ޑޯމެންސީ މުއްދަތުގެ މައްޗަށެވެ. އަލުން އެކްޓިވޭޓްކުރުން، ބެލެންސް ރިކަވަރ ކުރުން ނުވަތަ ބަންދުކުރުން ކުރައްވާ."
    },
    "wallet_variance": {
      "unreconciled": "މި ވޮލެޓްގެ ކޭޝް ބުކްތައް ރީކޮންސައިލްކުރުމުން ތަފާތެއް ބާކީ އޮވެއެވެ. ސަބަބު ހޯދާ އަލުން ރީކޮންސައިލްކުރައްވާ."
    },
    "reconExceptions": {
      "title": "ރިކޮންސިލިއޭޝަން އިސްތިސްނާތައް",
      "description": "އުމުރުގެ ޙައްދު ފަހަނައަޅާފައިވާ ކޮންމެ މެޗްނުވާ އައިޓަމެއް، ނަން ކަނޑައަޅާފައިވާ ވެރިއަކާއި، އުމުރާއި، އެސްކަލޭޓްކުރެވިފައިވާ މިންވަރާއެކު.",
      "openSessions": "ރިކޮންސިލިއޭޝަން ސެޝަންތައް",
      "tabs": {
        "label": "ރިކޮންސިލިއޭޝަން އިސްތިސްނާގެ ވިއުތައް",
        "exceptions": "އިސްތިސްނާތައް",
        "dashboard": "ޑޭޝްބޯޑު"
      },
      "fields": {
        "legalEntity": "ޤާނޫނީ ފަރާތް",
        "bankAccount": "ބޭންކް އެކައުންޓް",
        "kind": "ބާވަތް",
        "owner": "ވެރިފަރާތް",
        "escalation": "އެސްކަލޭޝަން",
        "item": "އައިޓަމް",
        "itemDate": "އައިޓަމުގެ ތާރީޚު",
        "age": "އުމުރު",
        "amount": "އަދަދު",
        "journal": "ޖާރނަލް",
        "description": "ތަފްސީލު",
        "resolution": "ހައްލު"
      },
      "filters": {
        "anyEntity": "ކޮންމެ ޤާނޫނީ ފަރާތެއް",
        "anyAccount": "ކޮންމެ ބޭންކް އެކައުންޓެއް",
        "anyStatus": "ކޮންމެ ހާލަތެއް",
        "anyKind": "ކޮންމެ ބާވަތެއް",
        "anyOwner": "ކޮންމެ ވެރިއެއް",
        "anyEscalation": "ކޮންމެ އެސްކަލޭޝަނެއް",
        "unowned": "ވެރިއަކު ނެތް އައިޓަމްތައް ހަމައެކަނި"
      },
      "status": {
        "open": "ހުޅުވާލެވިފައި",
        "investigating": "ތަހުގީގުކުރަމުންދާ",
        "resolved": "ހައްލުކުރެވިފައި",
        "written_off": "ރައިޓްއޮފް ކުރެވިފައި"
      },
      "kind": {
        "unmatched_bank": "މެޗްނުވާ ބޭންކް ލައިން",
        "unmatched_ledger": "މެޗްނުވާ ލެޖަރ އައިޓަމް",
        "unpresented_payment": "ބޭންކަށް ނުދެވޭ ޕޭމަންޓް",
        "stale_deposit": "ބޭންކަށް ނުވަންނަ ޑިޕޮސިޓް"
      },
      "escalation": {
        "atLeast": "ލެވެލް {level} ނުވަތަ މަތި",
        "level": "އެސްކަލޭޝަން ލެވެލް {level}"
      },
      "accountById": "ބޭންކް އެކައުންޓް #{id}",
      "owner": {
        "none": "އެއްވެސް މީހެއް ނޫން",
        "byId": "ޔޫޒަރ #{id}"
      },
      "ownerSource": {
        "declared": "ކަނޑައަޅާފައިވާ އެކައުންޓް ވެރިފަރާތް",
        "account": "އެކައުންޓް ވެރިފަރާތް",
        "assigned": "ހަވާލުކުރެވިފައި",
        "none": "ވެރިއަކު ނުފެނުނު؛ ކޮންޓްރޯލަރަށް އަންގާނެ"
      },
      "loadFailed": "ރިކޮންސިލިއޭޝަން އިސްތިސްނާތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އެއްވެސް އިސްތިސްނާއެއް ނެތް",
      "emptyDescription": "މި ވިއުގައި އެއްވެސް އައިޓަމެއް މެޗްނުވެ އޭގެ ޙައްދު ފަހަނައަޅާފައެއް ނުވޭ. އެގޮތަށް ވުމުން ދުވަހުގެ ސްވީޕުން ވެރިއަކާއެކު އިސްތިސްނާއެއް ހުޅުވާނެ.",
      "tableTitle": "އިސްތިސްނާތައް",
      "pageEmpty": "މި ސަފްހާގައި ފިލްޓަރާ ދިމާވާ އެއްވެސް އެއްޗެއް ނެތް.",
      "days": "{days} ދުވަސް",
      "staleSince": "{date} އިން ފެށިގެން ބާވެފައި",
      "work": "މަސައްކަތްކުރޭ",
      "view": "ބަލާ",
      "detail": {
        "title": "އިސްތިސްނާ #{id}",
        "loadFailed": "މި އިސްތިސްނާ ލޯޑެއް ނުކުރެވުނު",
        "openWorkspace": "މި އެކައުންޓުގެ ރިކޮންސިލިއޭޝަން ސެޝަންތައް ހުޅުވާ",
        "staleNote": {
          "unpresented_payment": "މި ޕޭމަންޓް ބާވާ މުއްދަތު ފަހަނައަޅައިގެން ބޭންކަށް ނުދެވިއްޖެ. އޭގެ އަމިއްލަ ސަބް ލެޖަރުން ރައިޓްބެކް ނުވަތަ ބަދަލު ކުރުމުން ސާފުވެ، ރިވާސްޑް އެޓް ސޯސް ގޮތުގައި ހައްލުކުރެވޭނެ.",
          "stale_deposit": "މި ޑިޕޮސިޓް ބާވާ މުއްދަތު ފަހަނައަޅައިގެން ބޭންކަށް ނުވަދެއްޖެ. އޭގެ އަމިއްލަ ސަބް ލެޖަރުން ކެންސަލް ނުވަތަ ބަދަލު ކުރުމުން ސާފުވެ، ރިވާސްޑް އެޓް ސޯސް ގޮތުގައި ހައްލުކުރެވޭނެ."
        },
        "candidates": "މެޗްވެދާނެ އައިޓަމްތައް",
        "noCandidates": "މި އައިޓަމުގެ ތާރީޚާ ކައިރީގައި ހަމަ އެ އަދަދާއި ދިމާގެ އެއްވެސް އެއްޗެއް ނެތް.",
        "trail": "ތަހުގީގުގެ ތާރީޚު",
        "noTrail": "އަދި އެއްވެސް އެއްޗެއް ރެކޯޑުކުރެވިފައެއް ނުވޭ."
      },
      "resolution": {
        "matched": "މެޗްކުރެވިފައި",
        "written_off": "ނެތް އެންޓްރީގެ ޕޯސްޓިންއިން ރައިޓްއޮފް ކުރެވިފައި",
        "reversed_at_source": "އަސްލުން ރިވާސް ކުރެވިފައި",
        "no_longer_outstanding": "މިހާރު ބާކީއެއް ނޫން"
      },
      "actions": {
        "assignTitle": "ހަވާލުކުރުން",
        "newOwner": "އާ ވެރިފަރާތް",
        "newOwnerHint": "އެމީހަކަށް ރިކޮންސިލިއޭޝަން އިސްތިސްނާތައް މެނޭޖްކުރެވެން ޖެހޭނެ.",
        "note": "ނޯޓް",
        "assign": "ހަވާލުކުރޭ",
        "assignDone": "އިސްތިސްނާ ހަވާލުކުރެވިއްޖެ",
        "investigateTitle": "ތަހުގީގުކުރުން",
        "investigationNote": "ފެނުނު ނުވަތަ ކުރި ކަންތައް",
        "investigationHint": "ތާރީޚަށް އިތުރުކުރެވޭނެ. އިސްތިސްނާއަށް ވެރިއަކު ނެތްނަމަ އެ ތިޔަބޭފުޅާގެ ވާނެ.",
        "investigate": "ތަހުގީގު ރެކޯޑުކުރޭ",
        "investigateDone": "ތަހުގީގު ރެކޯޑުކުރެވިއްޖެ",
        "resolveTitle": "ހައްލުކުރުން",
        "resolveHintBank": "ފުރަތަމަ ރިކޮންސިލިއޭޝަން ވޯކްސްޕޭސްގައި ލައިން ސާފުކުރައްވާ: މެޗްކުރައްވާ، ނުވަތަ ނެތް އެންޓްރީ ޕޯސްޓްކުރައްވާ. ދެން އެ މެޗް މިތާނގައި ބުނެދެއްވާ.",
        "resolveHintLedger": "ރިކޮންސިލިއޭޝަން ވޯކްސްޕޭސްގައި އައިޓަމް މެޗްކުރައްވާ، ނުވަތަ އޭގެ އަމިއްލަ ސަބް ލެޖަރުން ރިވާސްކުރުވާ. ލެޖަރ އައިޓަމެއް މިތާނގައި ދުވަހަކުވެސް ރައިޓްއޮފް ނުކުރެވޭނެ.",
        "matchId": "މެޗް ނަންބަރު",
        "matchIdHint": "މި އައިޓަމް ސާފުކުރި މެޗުގެ ނަންބަރު.",
        "resolutionNote": "ހައްލުގެ ނޯޓް",
        "resolve": "ހައްލުކުރޭ",
        "resolveDone": "އިސްތިސްނާ ހައްލުކުރެވިއްޖެ",
        "reloaded": "ތިޔަބޭފުޅާ މަސައްކަތްކުރައްވަމުން ދަނިކޮށް އެހެން މީހަކު މި އިސްތިސްނާ ބަދަލުކޮށްފި. އަލުން ލޯޑުކޮށްފި؛ ބައްލަވައި ބަދަލު އަލުން ކުރައްވާ."
      },
      "errors": {
        "ERR_RECON_EXCEPTION_CLOSED": "މި އިސްތިސްނާ މިހާރުވެސް ބަންދުކުރެވިފައި؛ އަލުން ހުޅުވަނީ ހަމައެކަނި ދުވަހުގެ ސްވީޕުން.",
        "ERR_RECON_EXCEPTION_OUTSTANDING": "އައިޓަމް އަދިވެސް މެޗްނުވެ، އެކަން ބަޔާންކުރާ އެއްވެސް އެއްޗެއް ނެތް.",
        "ERR_RECON_EXCEPTION_MATCH_INVALID": "އެ މެޗަކުން މި އައިޓަމް ސާފެއް ނުވޭ.",
        "ERR_RECON_EXCEPTION_WRITE_OFF_REFUSED": "މި އައިޓަމް މިތާނގައި ރައިޓްއޮފް ނުކުރެވޭނެ."
      },
      "trail": {
        "actor": {
          "system": "ދުވަހުގެ ސްވީޕް",
          "other": "އެހެން ފަރާތެއް"
        }
      },
      "dashboard": {
        "loadFailed": "ރިކޮންސިލިއޭޝަން ޑޭޝްބޯޑު ލޯޑެއް ނުކުރެވުނު",
        "inProgress": "ރިކޮންސައިލް ކުރަމުންދާ އެކައުންޓްތައް",
        "neverReconciled": "ދުވަހަކުވެސް ރިކޮންސައިލް ނުކުރާ އެކައުންޓްތައް",
        "openExceptions": "ހުޅުވާލެވިފައިވާ އިސްތިސްނާތައް",
        "escalated": "އެސްކަލޭޓް ކުރެވިފައި",
        "unowned": "ވެރިއަކު ނެތް",
        "stale": "ބާވެފައިވާ އައިޓަމްތައް",
        "asOfSwept": "{asOf} ގެ ހާލަތު. އިސްތިސްނާތައް އެންމެ ފަހުން ސްވީޕް ކުރީ {sweep}.",
        "asOfNoSweep": "{asOf} ގެ ހާލަތު. އިސްތިސްނާ ސްވީޕް އަދި ނުހިނގާ.",
        "emptyTitle": "އެއްވެސް ބޭންކް އެކައުންޓެއް ނެތް",
        "emptyDescription": "ޑޭޝްބޯޑުގައި މި ވިއުގެ ކޮންމެ އެކްޓިވް ބޭންކް އެކައުންޓެއް ރިޕޯޓުކުރާނެ.",
        "byAccount": "ބޭންކް އެކައުންޓުން",
        "state": "ރިކޮންސިލިއޭޝަން",
        "states": {
          "reconciled": "ރިކޮންސައިލް ކުރެވިފައި",
          "in_progress": "ކުރަމުންދާ",
          "never_reconciled": "ދުވަހަކުވެސް ރިކޮންސައިލް ނުކުރޭ"
        },
        "openSession": "ސެޝަން ހުޅުވާ",
        "lastReconciled": "ރިކޮންސައިލް ކުރެވުނީ",
        "daysAgo": "{days} ދުވަސް ކުރިން",
        "daysToReconcile": "ރިކޮންސައިލް ކުރަން ނަގާ ދުވަސް",
        "sample": "ނިމުނު {count} ސެޝަނުން",
        "unmatchedStatement": "މެޗްނުވާ ބޭންކް ލައިންތައް",
        "unmatchedLedger": "މެޗްނުވާ ލެޖަރ އައިޓަމްތައް",
        "items": "{count} އައިޓަމް",
        "exceptions": "އިސްތިސްނާތައް",
        "liveExceptions": "{count} ހުޅުވާލެވިފައި",
        "breakdown": "{escalated} އެސްކަލޭޓް · {unowned} ވެރިއަކު ނެތް · {stale} ބާވެފައި"
      }
    },
    "walletCounts": {
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "anyWallet": "ތިޔަ ބޭފުޅާއަށް ފެންނަ ހުރިހާ ވޮލެޓެއް",
      "caption": "ފައިސާ ގުނުންތަކާއި ކޮންމެ ގުނުމެއް ހުރި ޙާލަތު",
      "countNo": "ގުނުން",
      "description": "ތިޔަ ބޭފުޅާއަށް ފެންނަ ހުރިހާ ފައިސާ ގުނުމެއް، އާ ގުނުން ކުރިއަށް. ފޮރުވިފައިވާ ގުނުމެއްގެ ނިޒާމުގެ އަދަދު ޕޯސްޓްކުރެވެންދެން ނުދައްކާނެއެވެ.",
      "emptyDescription": "ގުނުން ހުޅުވަނީ ވޮލެޓުންނެވެ، ކޮންމެ ވޮލެޓަކަށް އެއް ފަހަރާ އެއް ގުނުމެވެ. ތިޔަ ބޭފުޅާ ބަލަހައްޓާ ވޮލެޓުން ގުނުމެއް ހުޅުއްވާ.",
      "emptyTitle": "އަދި އެއްވެސް ގުނުމެއް ނެތް",
      "entityHint": "ހުށަހަޅާ ވޮލެޓްތައް ކުޑަކުރެއެވެ. ވޮލެޓެއް ޚިޔާރުނުކުރެއްވިނަމަ، ތިޔަ ބޭފުޅާއަށް ފެންނަ ހުރިހާ ގުނުމެއް ދައްކާނެއެވެ.",
      "loadFailed": "އެ ގުނުންތައް ނުލޯޑްވި",
      "openWallets": "ވޮލެޓްތައް",
      "tableTitle": "ގުނުންތައް",
      "title": "ފައިސާ ގުނުން"
    },
    "walletDepth": {
      "capture": {
        "bookHint": "މި ވޮލެޓް ހެދިފައިވަނީ ގިނަ ކޭޝް ބުކުންނެވެ. ފައިސާ ނެރުނު ކޭޝް ބުކް ބުނޭ."
      },
      "clearDeputy": "ނާއިބު {name} ނައްތާލާ",
      "composition": {
        "addBook": "ކޭޝް ބުކެއް އިތުރުކުރޭ",
        "book": "ކޭޝް ބުކް",
        "caption": "މި ވޮލެޓް ހެދިފައިވާ ކޭޝް ބުކްތައް",
        "createHint": "ވޮލެޓްގެ ކޭޝް ބުކްތައް ކަނޑައެޅެނީ ވޮލެޓް ހަދާއިރުއެވެ. ކޭޝް ބުކެއް ނިސްބަތްވަނީ އެއް ވޮލެޓަކަށެވެ. ވޮލެޓްގެ ނަމުގައި އެއް ކޭޝް ބުކެއް ބޭނުންނަމަ މިތަން ހުސްކޮށް ބާއްވާ.",
        "description": "މި ވޮލެޓް ހެދިފައިވާ ކޭޝް ބުކްތަކާއި، ކޮންމެ ބުކެއްގައި ރެކޯޑުވެފައިވާ ބާކީ.",
        "duplicate": "ދެ ކޭޝް ބުކެއްގެ ކޯޑު އެއްގޮތެވެ. ކޮންމެ ކޭޝް ބުކެއްގެ ނަން ޖަހަނީ އެއްފަހަރުއެވެ.",
        "empty": "މި ވޮލެޓްގައި ކޭޝް ބުކެއް ނެތް.",
        "fixedAtCreation": "ހަދާއިރު ކަނޑައެޅިފައި",
        "missingCode": "އިތުރުކުރާ ކޮންމެ ކޭޝް ބުކަކަށް ކޯޑެއް ބޭނުންވޭ. ކޯޑު ޖައްސާ، ނުވަތަ އެ ލައިން ނައްތާލާ.",
        "kind": {
          "group": "ގިނަ ކޭޝް ބުކް",
          "single": "އެއް ކޭޝް ބުކް"
        },
        "primary": "މައި",
        "recorded": "ރެކޯޑުވެފައިވާ ބާކީ",
        "removeBook": "ނައްތާލާ",
        "title": "ބިނާވެފައިވާ ގޮތް"
      },
      "deputyHint": "ނާއިބަށް ހޭދަ ރެކޯޑުކުރެވޭނެ، އެކަމަކު ހަމަޖައްސައެއް ނުދެވޭނެ. ބެލެހެއްޓުންތެރިޔާއާ ތަފާތު މީހަކަށް ވާން ޖެހޭ.",
      "dormancyDays": "ހަރަކާތެއް ނެތް މުއްދަތު (ދުވަސް)",
      "dormancyHint": "މިހާ ދުވަހު ހަރަކާތެއް ނެތް ވޮލެޓެއް ހަރަކާތެއް ނެތް ވޮލެޓަކަށް ވެއެވެ. 1 އާއި 3650 ދެމެދު.",
      "funding": {
        "accountOnFile": "އެކައުންޓެއް ރެކޯޑުގައި އެބައޮތް (ތިޔަ ބޭފުޅާއަށް ފެންނަ އެކްޓިވް އެކައުންޓެއް ނޫން)",
        "createHint": "މި ވޮލެޓަށް ފައިސާ ލިބޭ އަދި ފައިސާ އަނބުރާ ދާ ބޭންކް އެކައުންޓް. ވޮލެޓްގެ ފައިސާއިން ހުރި އެކްޓިވް އެކައުންޓްތައް އެކަނި ދައްކަނީ.",
        "description": "ވޮލެޓަށް ފައިސާ ލިބޭ ތަނާއި އަނބުރާ ދާ ތަން، އަދި އޭގައި ބެހެއްޓޭނެ ހައްދު.",
        "editDescription": "ތިން ޝަރުތު އެކުގައި ރައްކާކުރެވޭ. ހައްދެއް ނައްތާލަން އަދަދު ހުސްކޮށް ބާއްވާ.",
        "editTitle": "ފައިސާ ލިބޭ ޝަރުތުތައް ބަދަލުކުރޭ",
        "maxHint": "ވޮލެޓްގައި ބެހެއްޓޭނެ އެންމެ ގިނަ އަދަދު، ދަތުރުގައި ހުރި ފައިސާއާއެކު. އިމްޕްރެސްޓް ވޮލެޓެއްގެ ފްލޯޓަށްވުރެ ދަށަކަށް ނުވާނެ.",
        "noAccount": "ފައިސާ ލިބޭ އެކައުންޓެއް ނެތް",
        "noLimit": "އެންމެ މަތީ ހައްދެއް ނެތް",
        "noThreshold": "ހައްދެއް ނެތް",
        "saved": "ފައިސާ ލިބޭ ޝަރުތުތައް ރައްކާކުރެވިއްޖެ.",
        "threshold": "ފުރިހަމަކުރުމުގެ ހައްދު",
        "thresholdHint": "ބާކީ މި އަދަދަށް ދަށްވުމުން ފުރިހަމަކުރުމެއް ހުށަހެޅޭނެ.",
        "title": "ފައިސާ ލިބުން"
      },
      "handover": {
        "count": "ހަވާލުކުރުމުގެ ގުނުން",
        "incoming": "ލިބޭ ބެލެހެއްޓުންތެރިޔާ",
        "outgoing": "ދޫކުރާ ބެލެހެއްޓުންތެރިޔާ",
        "pending": "އަދި ޤަބޫލެއް ނުކުރޭ",
        "signed": "{name} ޤަބޫލުކުރި، {at}"
      },
      "reconcile": {
        "caption": "ކޮންމެ ކޭޝް ބުކެއްގައި ފެނުނު ބާކީ",
        "cause": "ސަބަބު",
        "confirm": "ރިކަންސައިލް ކުރުން ރެކޯޑުކުރޭ",
        "description": "ކޮންމެ ކޭޝް ބުކެއްގައި ފެންނަ ބާކީ ބުނޭ. ތަފާތު ބުކަކަށް ސަބަބަކާއި ވެރިފަރާތެއް ބޭނުންވޭ.",
        "difference": "ތަފާތު",
        "differs": "ރެކޯޑުވެފައިވާ ބާކީއާ ތަފާތު",
        "doneReconciled": "ވޮލެޓް ރިކަންސައިލް ކުރެވިއްޖެ. ހުރިހާ ކޭޝް ބުކެއް އެއްގޮތް.",
        "doneUnreconciled": "ރިކަންސައިލް ނުވާ ގޮތަށް ރެކޯޑުވެއްޖެ: {books} ކޭޝް ބުކް ތަފާތު.",
        "everyBook": "ހުރިހާ ކޭޝް ބުކެއް ބުނަން ޖެހޭ. ޖުމްލަ އެއްގޮތްވިޔަސް ތަފާތު ބުކެއް ފޮރުވިދާނެ.",
        "historyEmpty": "މި ވޮލެޓް އެއްފަހަރުވެސް ރިކަންސައިލް ކޮށްފައެއް ނުވޭ.",
        "historyLoadFailed": "ރިކަންސައިލް ކުރުންތައް ލޯޑެއް ނުވި",
        "historyTitle": "ރިކަންސައިލް ކުރުންތައް",
        "linesCaption": "މި ރިކަންސައިލް ކުރުމުގައިވާ ކޮންމެ ކޭޝް ބުކެއް",
        "maskedByAggregate": "ޖުމްލަ އެއްގޮތް، އެކަމަކު ކޭޝް ބުކެއް ތަފާތު",
        "observed": "ފެނުނު ބާކީ",
        "open": "ކޭޝް ބުކް ވަކިވަކިން ރިކަންސައިލް ކުރޭ",
        "owner": "ވެރިފަރާތް",
        "status": {
          "reconciled": "ރިކަންސައިލް ކުރެވިފައި",
          "unreconciled": "ރިކަންސައިލް ނުވޭ"
        },
        "title": "ވޮލެޓް ރިކަންސައިލް ކުރޭ",
        "total": "ޖުމްލަ"
      },
      "recover": {
        "amountHint": "ވޮލެޓްގައި (ނުވަތަ އިޚްތިޔާރުކުރި ކޭޝް ބުކުގައި) ހުރި ހުރިހާ ފައިސާ އަނބުރާ ގެންނަން ހުސްކޮށް ބާއްވާ.",
        "bookHint": "ގިނަ ކޭޝް ބުކް ހުރި ވޮލެޓަކަށް ލާޒިމު. އެ ކޭޝް ބުކުން، އޭގައި ހުރި އަދަދަށްވުރެ ގިނައެއް ނޫން.",
        "confirm": "ބާކީ އަނބުރާ ގެންނަ",
        "description": "ޓްރެޜަރީގެ ބާރުން މި ވޮލެޓުން ފައިސާ ލިބޭ އެކައުންޓަށް ފައިސާ އަނބުރާ ގެނެސްދޭ.",
        "done": "{amount} {currency} އަނބުރާ ގެނެވިއްޖެ. ވޮލެޓްގައި މިހާރު {balance} އެބަހުރި.",
        "fundingHint": "ވޮލެޓްގެ ފައިސާ ލިބޭ އެކައުންޓް. ވޮލެޓްގެ ފައިސާއިން ހުރި އެކްޓިވް އެކައުންޓްތައް އެކަނި ދައްކަނީ.",
        "notifyNotAsk": "ބެލެހެއްޓުންތެރިޔާއަށް އަންގާނެ، އެކަމަކު ހުއްދައެއް ނުހޯދާނެ. ތިޔަ ބޭފުޅާ ދޭ ސަބަބު ރެކޯޑުކޮށް އެ ފަރާތަށް ފޮނުވޭނެ.",
        "open": "ބާކީ އަނބުރާ ގެންނަ",
        "reasons": {
          "custodian_left": "ބެލެހެއްޓުންތެރިޔާ ދޫކޮށްފި",
          "dormant": "ހަރަކާތެއް ނެތް ވޮލެޓް",
          "excess_float": "ބޭނުމަށްވުރެ ގިނަ ފައިސާ",
          "investigation": "ތަޙުޤީޤެއްގެ ދަށުގައި",
          "other": "އެހެނިހެން"
        },
        "title": "ވޮލެޓްގެ ބާކީ އަނބުރާ ގެންނަ"
      },
      "unresolved": "ފަހުން ހުށަހެޅުމަށް ޖަވާބެއް ނުލިބުނު، އެހެންވީމާ އެ ކަން ވެސް ނިމިފައިވެދާނެ. ފޮނުވި ގޮތަށް ދައްކަނީ: ނަތީޖާ ހޯދަން އަލުން ފޮނުވާ. ދެފަހަރު ނުކުރެވޭނެ.",
      "varianceCauseOwner": "ސަބަބާއި ވެރިފަރާތް",
      "varianceOwner": "ފަރަޤުގެ ވެރިފަރާތް"
    },
    "walletOps": {
      "errors": {
        "ERR_WALLET_CASH_BOOK_HELD": "އެ ކޭޝް ބުކް އެހެން ވޮލެޓަކަށް ނިސްބަތްވޭ.",
        "ERR_WALLET_RECOVERY_EXCEEDS_BALANCE": "އެއީ ވޮލެޓްގައި ހުރި އަދަދަށްވުރެ ގިނަ.",
        "ERR_ILLEGAL_TRANSITION": "ރެކޯޑުގެ މިހާރުގެ ޙާލަތުން އެ ފިޔަވަޅު ނާޅޭނެއެވެ.",
        "ERR_PERIOD_CLOSED": "އެ ތާރީޚުގެ މުއްދަތު ބަންދުކުރެވިފައިވެއެވެ.",
        "ERR_ROW_VERSION": "މި ރެކޯޑު ކުރިން އެހެން މީހަކު ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑްކުރެވިއްޖެ؛ ތިޔަ ބަދަލު އަލުން ގެންނަވާ.",
        "ERR_SOD_VIOLATION": "ތިޔަ ބޭފުޅާ ބަލަހައްޓާ ވޮލެޓެއްގެ ނުވަތަ ތިޔަ ބޭފުޅާ ރެކޯޑްކުރި ޚަރަދެއް ނިންމެވޭކަށް ނުޖެހޭނެއެވެ.",
        "ERR_WALLET_CATEGORY_BLOCKED": "މި ވޮލެޓުން މި ބާވަތަށް ޚަރަދުކުރުން މަނާކުރެވިފައިވެއެވެ.",
        "ERR_WALLET_CUSTODY_COUNT_REQUIRED": "ހަވާލުކުރުމުގެ ކުރިން ޕޯސްޓްކުރެވިފައިވާ ގުނުމެއް ބޭނުންވެއެވެ.",
        "ERR_WALLET_EVIDENCE_REQUIRED": "މި ޚަރަދަށް ހެކި ހިމަނަން ޖެހެއެވެ.",
        "ERR_WALLET_HANDOVER_NOT_A_PARTY": "ތިޔަ ބޭފުޅާ މި ހަވާލުކުރުމުގެ ދޫކުރާ ނުވަތަ ލިބޭ ބެލެހެއްޓުންތެރިޔާއެއް ނޫނެވެ.",
        "ERR_WALLET_LIMIT": "މި ޚަރަދު އޭގެ ބާވަތުގެ ލިމިޓަށްވުރެ މަތިވެއެވެ.",
        "ERR_WALLET_NOT_RECONCILED": "މި ވޮލެޓްގެ ފަހުގެ ރީކޮންސައިލް ކުރުމުގައި ފަރަޤެއް ބާކީވެއެވެ. ހަވާލުކުރުމުގެ ކުރިން ރީކޮންސައިލް ކުރައްވާ.",
        "ERR_WALLET_TAX_WITHOUT_INVOICE": "ސައްޙަ ޓެކްސް އިންވޮއިސްއެއް ނެތި ޓެކްސް އަނބުރާ ނުލިބޭނެއެވެ.",
        "ERR_WALLET_VARIANCE_UNEXPLAINED": "ގުނުމުގައި ފަރަޤެއް އެބައޮތް، އަދި ސަބަބެއް ބޭނުންވެއެވެ.",
        "ERR_WALLET_WITNESS_REQUIRED": "މި ގުނުމަށް ހެއްކެއް ބޭނުންވެއެވެ."
      },
      "captureAndSubmit": "ރެކޯޑްކޮށް ހުށަހަޅާ",
      "captureNotSubmitted": "ޚަރަދު ރެކޯޑްކުރެވުނު ނަމަވެސް ފާސްކުރުމަށް ހުށަނާޅުނު: {reason} ލިސްޓުން ހުށަހަޅުއްވާ.",
      "captureSubmitDescription": "ފައިސާ ފޮށިން ނުކުތެވެ. ރެކޯޑްކުރުމާއެކު ފާސްކުރާ ފަރާތަށް ހުށަހެޅޭނެއެވެ؛ ފާސްކުރެވެންދެން ޚަރަދު ފޮތުގައި ނުޖެހޭނެއެވެ.",
      "captureSubmitted": "ޚަރަދު ރެކޯޑްކޮށް ފާސްކުރުމަށް ހުށަހެޅިއްޖެ.",
      "close": "ވޮލެޓް ބަންދުކުރޭ",
      "closeBlocked": "މި ވޮލެޓްގައި އަދިވެސް ފައިސާ އެބައޮތެވެ. ކްލިއަރިންގގައި ހުރި ޚަރަދުތައް ފާސްކޮށް ނުވަތަ ރައްދުކޮށް، ފޮށި ސުމެއް ކުރާ ބަންދުކުރުމުގެ ގުނުމެއް ޕޯސްޓްކުރައްވާ؛ ބާކީ ހުރި ވޮލެޓެއް ބަންދެއް ނުކުރެވޭނެއެވެ.",
      "closeConfirm": "ވޮލެޓް ބަންދުކުރޭ",
      "closeDescription": "ބަންދުކުރެވިފައިވާ ވޮލެޓަކަށް އިތުރު ޚަރަދެއް، ގުނުމެއް ނުވަތަ އަލުން ފުރާލުމެއް ނުކުރެވޭނެއެވެ. އޭގެ ތާރީޚު ކިޔޭނެ ގޮތަށް ބާކީ ހުންނާނެއެވެ.",
      "closeReasons": {
        "consolidated": "އެހެން ވޮލެޓަކާ ގުޅުވިއްޖެ",
        "custodian_left": "ބެލެހެއްޓި ފަރާތް ދޫކޮށްލައިފި",
        "no_longer_required": "މިހާރު ބޭނުމެއް ނުވޭ",
        "other": "އެހެނިހެން"
      },
      "closeTitle": "ވޮލެޓް ބަންދުކުރުން",
      "closed": "ވޮލެޓް ބަންދުކުރެވިއްޖެ.",
      "closedBanner": "މި ވޮލެޓް ބަންދުކުރެވުނީ {at} ގައެވެ. ތާރީޚު ރައްކާކުރެވިފައިވާނެއެވެ؛ އިތުރު އެއްވެސް އެއްޗެއް ރެކޯޑެއް ނުކުރެވޭނެއެވެ.",
      "countsCaption": "މި ވޮލެޓްގެ ފައިސާ ގުނުންތައް",
      "countsDescription": "އެންމެ ފަހުގެ ގުނުންތައް، އާ ގުނުން ކުރިއަށް. ފޮރުވިފައިވާ ގުނުމެއްގެ ފަރަޤު ޕޯސްޓްކުރެވެންދެން ނުދައްކާނެއެވެ.",
      "countsEmpty": "މި ވޮލެޓް އަދި ގުނާފައެއް ނުވެއެވެ.",
      "countsTitle": "ގުނުމުގެ ތާރީޚު",
      "editDescription": "ފޮނުވާނީ ބަދަލުކުރާ އެއްޗެހި އެކަންޏެވެ. ބަންދުކުރުމަކީ ވަކި ޢަމަލެކެވެ.",
      "editTitle": "ވޮލެޓް ބަދަލުކުރުން",
      "ownCapture": "މިއީ ތިޔަ ބޭފުޅާ ރެކޯޑްކުރި ނުވަތަ ބަލަހައްޓާ ވޮލެޓެއް — ނިންމާނީ އެހެން މީހެކެވެ",
      "reloaded": "މި ރެކޯޑު ކުރިން އެހެން މީހަކު ބަދަލުކޮށްފިއެވެ. އަލުން ލޯޑްކުރެވިއްޖެ؛ ތިޔަ ބަދަލު އަލުން ގެންނަވާ.",
      "reverse": "އަނބުރާ ޖައްސާ",
      "reverseConfirm": "އަނބުރާ ޖެއްސުން ޕޯސްޓްކުރޭ",
      "reverseDescription": "މިއަދުގެ ތާރީޚުގައި މުޢާމަލާތުގެ ދިމާ ޚިލާފު ޕޯސްޓްކުރެވޭނެއެވެ. އަސްލު ރައްކާވާނެއެވެ.",
      "reverseNote": "އަނބުރާ ޖެއްސުމެއް މިތަނުން އަނބުރާ ނުޖެހޭނެއެވެ. ޕޯސްޓްކުރުމުގެ ކުރިން މުޢާމަލާތު ޔަޤީންކުރައްވާ.",
      "reverseReasons": {
        "duplicate": "ދެފަހަރު",
        "entered_in_error": "ގޯހުން ޖެހިފައި",
        "other": "އެހެނިހެން",
        "wrong_amount": "ގޯސް އަދަދު"
      },
      "reverseTitle": "މުޢާމަލާތު އަނބުރާ ޖެއްސުން",
      "reversed": "އަނބުރާ ޖެއްސުން ޕޯސްޓްކުރެވިއްޖެ.",
      "saved": "ވޮލެޓް ރައްކާކުރެވިއްޖެ.",
      "statusHint": "މަޢުޠަލުކުރެވިފައިވާ ވޮލެޓަކުން، އަލުން ހަރަކާތްތެރިކުރެވެންދެން ޚަރަދެއް ނުކުރެވޭނެއެވެ.",
      "submitted": "ޚަރަދު ފާސްކުރުމަށް ހުށަހެޅިއްޖެ.",
      "suspendNote": "މަޢުޠަލުކުރުމުން މި ވޮލެޓުން އާ ޚަރަދު ހުއްޓޭނެއެވެ. ގުނުމާއި ހަވާލުކުރުން ކުރެވޭނެއެވެ.",
      "txnsLoadFailed": "އެ މުޢާމަލާތްތައް ނުލޯޑްވި"
    },
    "walletExpenditure": {
      "anyKind": "ކޮންމެ ބާވަތެއް",
      "anyStatus": "ކޮންމެ ޙާލަތެއް",
      "caption": "ޚިޔާރުކުރި ވޮލެޓުގައި ރެކޯޑްކުރެވުނު މުޢާމަލާތްތައް",
      "description": "ވޮލެޓަކުން ކުރި ޚަރަދުތައް، ކޮންމެ ޚަރަދެއް ހުރި ޙާލަތު، އަދި އަނބުރާ ޖެއްސޭނެ މުޢާމަލާތްތައް.",
      "emptyDescription": "މި ވޮލެޓުގައި މި ފިލްޓަރުތަކާ ދިމާވާ އެއްވެސް އެއްޗެއް ނެތް. ފޮށިން ފައިސާ ނުކުތުމުން ޚަރަދު ރެކޯޑްކުރައްވާ؛ ރެކޯޑްކުރުމާއެކު ފާސްކުރާ ފަރާތަށް ދާނެއެވެ.",
      "emptyTitle": "މިތާ އެއްވެސް މުޢާމަލާތެއް ނެތް",
      "loadFailed": "އެ މުޢާމަލާތްތައް ނުލޯޑްވި",
      "noWalletsDescription": "ވޮލެޓެއް ފެންނާނީ އެ ވޮލެޓް ބަލަހައްޓާ ފަރާތަށާއި، އެ ވޮލެޓް މެނޭޖްކުރާ ނުވަތަ ފާސްކުރާ ފަރާތަށެވެ. މި ޤާނޫނީ ފަރާތުގައި ތިޔަ ބޭފުޅާގެ ފްލޯޓެއް ނެތްނަމަ، ރެކޯޑްކުރާނެ އެއްޗެއް ނެތެވެ.",
      "noWalletsTitle": "ތިޔަ ބޭފުޅާއަށް ފެންނަ ވޮލެޓެއް ނެތް",
      "openApprovals": "ފާސްކުރުމުގެ ލިސްޓު",
      "tableTitle": "މުޢާމަލާތްތައް",
      "title": "ޚަރަދު ރެކޯޑްކުރުން"
    },
    "walletCustody": {
      "countCycle": "ގުނުމުގެ ދައުރު",
      "everyDays": "ކޮންމެ {days} ދުވަހަކުން",
      "since": "ބެލެހެއްޓި ފެށި ތާރީޚު"
    },
    "walletHandover": {
      "acknowledgeIncoming": "ލިބޭ ފަރާތެއްގެ ގޮތުން ޤަބޫލުކުރޭ",
      "acknowledgeOutgoing": "ދޫކުރާ ފަރާތެއްގެ ގޮތުން ޤަބޫލުކުރޭ",
      "awaitingIncoming": "ދޫކުރާ ބެލެހެއްޓުންތެރިޔާ ޤަބޫލުކޮށްފިއެވެ. ލިބޭ ބެލެހެއްޓުންތެރިޔާ ޕޯސްޓްކުރެވިފައިވާ ހަވާލުގެ ގުނުމާއެކު ޤަބޫލުކުރަން ޖެހެއެވެ.",
      "awaitingOutgoing": "ދޫކުރާ ބެލެހެއްޓުންތެރިޔާގެ ޤަބޫލުކުރުމަށް މަޑުކުރަނީ.",
      "completed": "ހަވާލުކުރުން ނިމިއްޖެ. ބެލެހެއްޓުން ބަދަލުވެއްޖެ.",
      "confirm": {
        "decline": "ހަވާލުކުރުން ދެކޮޅުހަދާ",
        "incoming": "ޤަބޫލުކޮށް ބެލެހެއްޓުން ގަނޭ",
        "outgoing": "ޤަބޫލުކުރޭ"
      },
      "countRequired": "މި ވޮލެޓްގެ ޕޯސްޓްކުރެވިފައިވާ ގުނުމެއް ނެތި ލިބޭ ބެލެހެއްޓުންތެރިޔާއަށް ޤަބޫލެއް ނުކުރެވޭނެއެވެ. ނުގުނާ ފޮށްޓެއް ގަތުމުން މަދުވާ އަދަދު ތިޔަ ބޭފުޅާގެ މައްޗަށް އެޅޭނެއެވެ.",
      "custodian": "ބެލެހެއްޓުންތެރިޔާ",
      "decline": "ދެކޮޅުހަދާ",
      "declineReason": "ދެކޮޅުހެދުމުގެ ސަބަބު",
      "declined": "ހަވާލުކުރުން ދެކޮޅުހެދިއްޖެ. ބެލެހެއްޓުން ދޫކުރާ ފަރާތުގެ އަތުގައި ހުންނާނެއެވެ.",
      "deputy": "ނާއިބު",
      "description": {
        "decline": "ވޮލެޓް ކުރިން ހުރި ގޮތަށް އެނބުރި، ޒިންމާ ދޫކުރާ ފަރާތުގެ އަތުގައި ހުންނާނެއެވެ.",
        "incoming": "ހަވާލުވިއިރު ކުރި ގުނުން ބަޔާންކުރައްވާ. ތިޔަ ބޭފުޅާ ޤަބޫލުކުރުމުން ބެލެހެއްޓުން ބަދަލުވާނެއެވެ.",
        "outgoing": "މި ވޮލެޓް ހަވާލުކުރާކަން ޔަޤީންކުރައްވާ. ދެން ލިބޭ ބެލެހެއްޓުންތެރިޔާ ޤަބޫލުކުރާނެއެވެ."
      },
      "hide": "ފޮރުވާ",
      "masked": "ފޮރުވިފައި",
      "outgoingAcknowledged": "ތިޔަ ބޭފުޅާ ހަވާލުކުރުން ޤަބޫލުކުރެއްވިއެވެ. ދެން ލިބޭ ބެލެހެއްޓުންތެރިޔާގެ ފަހަރެވެ.",
      "reveal": "ފާހަގަކުރޭ",
      "revealDescription": "ބެލެހެއްޓުންތެރިޔާ އާއި ނާއިބުގެ މަޢުލޫމާތު ފޮރުވިފައިވެއެވެ. ފާހަގަކުރުމަށް ތިޔަ ބޭފުޅާގެ އޮތެންޓިކޭޓަރ ކޯޑު ބޭނުންވެ، ބުނާ މަޤްޞަދާއެކު ތިޔަ ނަމުގައި ރެކޯޑްކުރެވޭނެއެވެ.",
      "revealReason": "މަޤްޞަދު",
      "revealTitle": "ބެލެހެއްޓުންތެރިޔާ އާއި ނާއިބު ފާހަގަކުރުން",
      "revealedContact": "ގުޅޭނެ ގޮތް",
      "title": {
        "decline": "ހަވާލުކުރުން ދެކޮޅުހެދުން",
        "incoming": "ލިބޭ ބެލެހެއްޓުންތެރިޔާގެ ގޮތުން ޤަބޫލުކުރުން",
        "outgoing": "ދޫކުރާ ބެލެހެއްޓުންތެރިޔާގެ ގޮތުން ޤަބޫލުކުރުން"
      }
    },
    "walletReplenish": {
      "currentShortfall": "މިހާރުގެ ކުޑަވުން، މަޢުލޫމާތަށް",
      "derivedLabel": "އަދަދު",
      "derivedRule": "ހުށަހަޅާއިރު ހިސާބުކުރެވޭނެއެވެ: ފަހުން އަލުން ފުރާލިފަހުން ފާސްވި ޚަރަދު، ނުވަތަ މި ވޮލެޓް އަދި ފުރާލާފައި ނުވާނަމަ ފްލޯޓްގެ ކުޑަވުން. އަދި ފާސްނުވާ ޚަރަދުތައް ނުހިމެނޭނެއެވެ.",
      "justification": "ސަބަބު",
      "justificationOptionalHint": "އިމްޕްރެސްޓް ވޮލެޓަކަށް އިޚްތިޔާރީ.",
      "justificationRequiredHint": "މި ވޮލެޓަށް ފައިސާ ބޭނުންވާ ސަބަބު. ވޭރިއަބަލް ވޮލެޓަކަށް ލާޒިމު.",
      "requested": "އަލުން ފުރާލުން {no} އަށް {amount} {currency} އެދިއްޖެ.",
      "variableAmountHint": "ވޭރިއަބަލް ވޮލެޓަކަށް އަނބުރާ ފުރާލާނެ ފްލޯޓެއް ނެތުމުން، ބޭނުންވާ އަދަދު ބުނެދެއްވާ."
    }
  },
  "qms": {
    "filtersTitle": "ފިލްޓަރތައް",
    "common": {
      "yes": "އާދެ",
      "no": "ނޫން",
      "remove": "ނަގާ"
    },
    "routeTitles": {
      "plans": "އިންސްޕެކްޝަން ޕްލޭންތައް",
      "plan": "އިންސްޕެކްޝަން ޕްލޭން",
      "samplingPlans": "ސާމްޕްލިން ޕްލޭންތައް",
      "worklist": "އިންސްޕެކްޝަންތައް",
      "inspection": "އިންސްޕެކްޝަން",
      "capaBoard": "އިޞްލާޙީ ފިޔަވަޅުތައް",
      "capa": "އިސްލާހީ ފިޔަވަޅު",
      "qualitySummary": "ކޮލިޓީ ޚުލާޞާ",
      "settings": "ކޮލިޓީ ސެޓިންގްސް"
    },
    "origin": {
      "goods_receipt": "މުދާ ލިބުނު ރަސީދު",
      "production": "އުފެއްދުން",
      "shipment": "ޝިޕްމަންޓް"
    },
    "planStatus": {
      "draft": "ދެލިކޮޕީ",
      "active": "ހަރަކާތްތެރި",
      "obsolete": "ބޭނުންނުކުރާ"
    },
    "characteristicKind": {
      "numeric": "ނަންބަރު",
      "attribute": "ސިފަ",
      "visual": "ލޮލުން ބެލުން"
    },
    "severity": {
      "critical": "ކްރިޓިކަލް",
      "major": "ބޮޑު",
      "minor": "ކުޑަ"
    },
    "samplingMethod": {
      "fixed_percent": "ކަނޑައެޅިފައިވާ އިންސައްތަ",
      "aql_table": "އޭކިއުއެލް ތާވަލު",
      "hundred_percent": "ކޮންމެ ޔުނިޓެއް"
    },
    "inspectionStatus": {
      "pending": "މަޑުކުރެވިފައި",
      "in_progress": "ކުރިއަށްދަނީ",
      "passed": "ފާސް",
      "failed": "ފެއިލްވެފައި",
      "waived": "ދޫކޮށްލި"
    },
    "dispositionKind": {
      "accept": "ބަލައިގަނޭ",
      "accept_with_concession": "ލުޔަކާއެކު ބަލައިގަނޭ",
      "rework": "އަލުން ހަދާ",
      "reject_return": "ބޭރުކޮށް އަނބުރާ ފޮނުވާ",
      "reject_scrap": "ބޭރުކޮށް ސްކްރެޕްކުރޭ",
      "hold": "ހިފަހައްޓާ"
    },
    "capaKind": {
      "corrective": "އިޞްލާޙީ",
      "preventive": "ރައްކާތެރިކުރުމުގެ"
    },
    "capaStatus": {
      "open": "ހުޅުވިފައި",
      "investigating": "ބަލަނީ",
      "actions_planned": "ފިޔަވަޅުތައް ރޭވިއްޖެ",
      "actions_complete": "ފިޔަވަޅުތައް ނިމިއްޖެ",
      "verifying": "ޔަގީންކުރަނީ",
      "closed": "ބަންދުކުރެވިފައި",
      "cancelled": "ކެންސަލްކުރެވިފައި"
    },
    "capaActionStatus": {
      "open": "ހުޅުވިފައި",
      "done": "ނިމިއްޖެ",
      "cancelled": "ކެންސަލްކުރެވިފައި"
    },
    "capaSource": {
      "inspection": "އިންސްޕެކްޝަން",
      "ncr": "ނޮންކޮންފޯމަންސް ރިޕޯޓް",
      "supplier_scorecard": "ސަޕްލަޔަރ ސްކޯރކާޑް",
      "recall": "ރީކޯލް",
      "audit": "އޮޑިޓް",
      "customer_complaint": "ކަސްޓަމަރުގެ ޝަކުވާ",
      "manual": "މީހަކު ހުށަހެޅި"
    },
    "receiptPolicy": {
      "none": "ސީދާ ސްޓޮކަށް ބަލައިގަނޭ",
      "quarantine": "ލިބުމުން ކަރަންޓީނުކުރޭ"
    },
    "sla": {
      "ok": "އެސްއެލްއޭގެ ތެރޭގައި",
      "due_soon": "އަވަހަށް ސުންގަޑި ޖެހެނީ",
      "overdue": "މުއްދަތު ފަހަނައަޅާފައި",
      "unknown": "އެސްއެލްއޭއެއް ކަނޑައަޅާފައެއް ނުވޭ"
    },
    "fields": {
      "acceptNumber": "އެކްސެޕްޓް ނަންބަރު",
      "allowedValues": "ހުއްދަ އަގުތައް",
      "code": "ކޯޑް",
      "company": "ކުންފުނި",
      "controls": "ކޮންޓްރޯލްތައް",
      "critical": "ކްރިޓިކަލް",
      "decidedAt": "ނިންމި",
      "decimals": "ދިހަގުނަ ޖާގަ",
      "defects": "ޢައިބުތައް",
      "dueOn": "މުއްދަތު",
      "effectiveFrom": "ފެށޭ ތާރީޚު",
      "effectiveTo": "ބާރުގައި ނިމޭ",
      "effectiveness": "އަސަރުކުރުން",
      "effectivenessDueOn": "އަސަރު ބެލުމުގެ ސުންގަޑި",
      "effectivenessNote": "އަސަރުކުރުމުގެ ނޯޓް",
      "effectivity": "ހިނގާ މުއްދަތު",
      "fromDate": "ފެށޭ",
      "item": "ބާވަތް",
      "kind": "ބާވަތް",
      "lotNo": "ލޮޓު",
      "lotQuantity": "ލޮޓުގެ މިންވަރު",
      "lotSizeFrom": "ލޮޓް ސައިޒް ފެށޭ",
      "lotSizeTo": "ލޮޓް ސައިޒް ނިމޭ",
      "mandatory": "މަޖުބޫރު",
      "maxSampleSize": "އެންމެ ބޮޑު ސާމްޕަލް ސައިޒް",
      "method": "ގޮތް",
      "minSampleSize": "އެންމެ ދަށް ސާމްޕަލް ސައިޒް",
      "openEnded": "ހުޅުވިފައި",
      "origin": "އަސްލު",
      "originDoc": "މަޞްދަރު ލިޔުން",
      "quantity": "އަދަދު",
      "reason": "ސަބަބު",
      "reasonCode": "ސަބަބުގެ ކޯޑް",
      "recordedDefects": "ރެކޯޑްކުރެވުނު ޢައިބުތައް",
      "rejected": "ބޭރުކުރެވިއްޖެ",
      "rejectNumber": "ބޭރުކުރާ ނަންބަރު",
      "samplePercent": "ސާމްޕަލް ޕަސެންޓޭޖް",
      "sampleSize": "ސާމްޕަލްގެ ސައިޒް",
      "sampling": "ސާމްޕްލިން ޕްލޭން",
      "scope": "ދާއިރާ",
      "seqNo": "ސީކް",
      "severity": "ބާރުމިން",
      "source": "ސޯސް",
      "specMax": "އެންމެ މަތި",
      "specMin": "އެންމެ ދަށް",
      "specTarget": "އަމާޒު",
      "specification": "މިންގަނޑު",
      "title": "ސުރުޚީ",
      "toDate": "ނިމޭ",
      "uom": "ޔުނިޓް",
      "vendor": "ސަޕްލަޔަރ",
      "waiting": "އިންތިޒާރުގައި"
    },
    "plans": {
      "title": "އިންސްޕެކްޝަން ޕްލޭންތައް",
      "description": "ބަލާ އެއްޗެއް، އެއިން ބަލާ މިންވަރު، އަދި ފެއިލްވުމުން ވާނެ ގޮތް.",
      "tableTitle": "ޕްލޭންތައް",
      "caption": "އިންސްޕެކްޝަން ޕްލޭންތަކާއި އޭގެ އޮރިޖިން، ސްކޯޕް، ސާމްޕްލިން ޕްލޭން އަދި ހިނގާ މުއްދަތު.",
      "create": "އައު ޕްލޭން",
      "edit": "ޕްލޭން އެޑިޓްކުރޭ",
      "dialogDescription": "ޕްލޭނެއް ހިނގާނީ އެއް އޮރިޖިންއަށް. ހޮވުން ހިނގަނީ ފުރަތަމަ ތަކެތި، ދެން ބައި، ދެން ސަޕްލަޔަރ، ދެން ހުރިހާ އެއްޗެއް.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ކޯޑް ނަން",
      "loadFailed": "އިންސްޕެކްޝަން ޕްލޭންތައް ލޯޑެއް ނުވި",
      "empty": "އަދި އިންސްޕެކްޝަން ޕްލޭނެއް ނެތް. ޑެލިވަރީ، އުފެއްދުމުގެ ނަތީޖާ ނުވަތަ ފޮނުވުންތައް ބަލަން ފެށުމަށް އެއް އުފައްދާ.",
      "emptyFiltered": "މި ފިލްޓަރުތަކާ ގުޅޭ އިންސްޕެކްޝަން ޕްލޭނެއް ނެތް.",
      "scopeAll": "ހުރިހާ ތަކެއްޗެއް",
      "scopeHint": "އެއް ސްކޯޕް، ގިނަ ސްކޯޕެއް ނޫން. ތަކެއްޗާއި ބާވަތް ދެވެސް ބަޔާންކުރާ ޕްލޭނަކީ ދެ ޕްލޭން.",
      "scopePanel": "ސްކޯޕާއި ހިނގާ މުއްދަތު",
      "scopeKind": {
        "all": "މި އޮރިޖިންގެ ހުރިހާ ތަކެއްޗެއް",
        "item": "އެއް އެއްޗެއް",
        "category": "އެއް ބާވަތެއް",
        "vendor": "އެއް ސަޕްލަޔަރެއް"
      },
      "originHint": "ބަލައިގަތުމަށް ލިޔެފައިވާ ޕްލޭނެއް ޕްރޮޑަކްޝަން އޮޕަރޭޝަނަކަށް ދުވަހަކުވެސް ނުހޮވޭނެ.",
      "samplingHint": "މުޅި ލޮޓް ބެލުމަށް ހުސްކޮށް ދޫކުރޭ.",
      "noSampling": "މުޅި ލޮޓް",
      "quarantines": "ކަރަންޓީނުކުރޭ",
      "blocking": "ހުއްޓުވާ",
      "independent": "މުސްތަޤިއްލު އިންސްޕެކްޓަރު",
      "quarantineLabel": "ޑެލިވަރީ ލިބުމުން ކަރަންޓީނުކުރޭ",
      "quarantineMeaning": "ބަލައިގަނެފައިވާ ސްޓޮކް ހިފެހެއްޓިފައި: އެއީ ބެލެންސް ޝީޓުގައި، ޖީއާރު-އައިއާރުގައި، އަދި އިންސްޕެކްޝަނަށް ނިންމުމެއް އަންނަންދެން ނުދޫކުރެވޭނެ.",
      "blockingLabel": "ފެއިލްވި އިންސްޕެކްޝަނަކުން ދެން އޮތް ފިޔަވަޅު ހުއްޓުވާ",
      "blockingMeaning": "ފެއިލްވުމަކުން ހަމައެކަނި ރެކޯޑްކުރުމުގެ ބަދަލުގައި، ސްޓޮކަށް ދޫކުރުން، ނިމުނު މުދާ ބަލައިގަތުން ނުވަތަ ފޮނުވުން ބަލައެއް ނުގަނެވޭނެ.",
      "advisoryMeaning": "ހަމައެކަނި އިރުޝާދު: ފެއިލްވުން ރެކޯޑްކުރެވޭ، އަދި ފަހުން އަންނަ އެއްވެސް ކަމެއް ނުހުއްޓުވޭ.",
      "independentLabel": "އިންސްޕެކްޓަރަކީ ލިޔުން ހެދި މީހާއަށް ވެގެން ނުވާނެ",
      "independentMeaning": "އަޞްލު ލިޔުން ހެދި މީހާ ރެކޯޑްކުރާ އިންސްޕެކްޝަނެއް ބަލައެއް ނުގަނެވޭނެ، ސާވިސްގައި އަދި ޑޭޓާބޭސް ކޮންސްޓްރެއިންޓަކުންވެސް.",
      "activate": "ހަރަކާތްތެރިކުރޭ",
      "activated": "ޕްލޭން އެކްޓިވޭޓްކޮށްފި",
      "activateFailed": "ޕްލޭން އެކްޓިވޭޓެއް ނުކުރެވުނު",
      "draftMeaning": "ޑްރާފްޓް ޕްލޭނަކުން އެއްވެސް އެއްޗެއް ނުހޮވޭނެ. އެކްޓިވޭޓްކުރުމުން ދެން ލިބޭ ޑެލިވަރީތަކުން ފެށިގެން ކަރަންޓީނުކުރަން ފަށާނެ.",
      "saved": "ޕްލޭން ރައްކާކޮށްފި",
      "saveFailed": "ޕްލޭން ރައްކާނުކުރެވުނު",
      "backToList": "އިންސްޕެކްޝަން ޕްލޭންތަކަށް އެނބުރި"
    },
    "characteristics": {
      "title": "ސިފަތައް",
      "caption": "އިންސްޕެކްޓަރު ރެކޯޑްކުރާ ތަރުތީބުން މިނެކިރެވޭ ސިފަތައް.",
      "add": "ސިފައެއް އިތުރުކުރޭ",
      "edit": "ސިފަ އެޑިޓްކުރޭ",
      "dialogDescription": "ބާވަތުން ކޮން ފީލްޑަކަށް މާނައެއް އޮތްކަން ނިންމޭ، އަދި ދަރަޖައިން ޢައިބެއް ގުނާނެ ގޮތް ނިންމޭ.",
      "empty": "އަދި ސިފައެއް ނެތް. ސިފައެއް ނެތް ޕްލޭނެއް އެކްޓިވޭޓެއް ނުކުރެވޭނެ.",
      "saved": "ސިފަ ރައްކާކޮށްފި",
      "saveFailed": "ސިފަ ރައްކާނުކުރެވުނު",
      "removed": "ސިފަ ނަގައިފި",
      "removeFailed": "ސިފަ ނުނެގުނު",
      "kindHint": {
        "numeric": "ކިޔުމަކީ ހައްދުތަކާ އަޅާކިޔޭ ނަންބަރެއް",
        "attribute": "ކިޔުމަކީ ކަނޑައެޅިފައިވާ ލިސްޓަކުން އެއް އަގު",
        "visual": "ކިޔުމަކީ ފާސް ނުވަތަ ފެއިލް، ނޯޓަކާއެކު"
      },
      "severityHint": {
        "critical": "އެއް ޢައިބުން މުޅި ލޮޓް ފެއިލްވޭ",
        "major": "އެކްސެޕްޓް ނަންބަރާ އަޅާ ގުނޭ",
        "minor": "އެކްސެޕްޓް ނަންބަރާ އަޅާ ގުނޭ"
      },
      "severityMeaning": "ކްރިޓިކަލް ޢައިބެއް ފެނިއްޖެނަމަ، އެކްސެޕްޓް ނަންބަރު ކޮންމެ އެއްޗެއް ބުންޏަސް މުޅި ލޮޓް ފެއިލްވާނެ.",
      "unbounded": "ހައްދެއް ނެތް",
      "unboundedHint": "މި ފަރާތުގައި ހައްދެއް ނެތްނަމަ ހުސްކޮށް ދޫކުރޭ.",
      "needsBound": "ނަންބަރު ބާވަތުގެ ސިފައަކަށް މަދުވެގެން އެއް ހައްދު ބޭނުންވޭ. އެއާ ނުލައި އެއްވެސް ކިޔުމެއް ފާސްވެސް ފެއިލްވެސް ނުވާނެ.",
      "visualSpec": "ފާސް ނުވަތަ ފެއިލް",
      "noAllowedValues": "އަގެއް ކަނޑައަޅާފައެއް ނުވޭ",
      "allowedValuesHint": "ކޮންމެ ރޮނގަކަށް އެއް އަގު.",
      "target": "އަމާޒު {value}",
      "decimalsMeaning": "އަޅާކިޔުމުގެ ކުރިން ކިޔުމެއް ބުރެއް ޖަހާނެ ދަރަޖަ.",
      "mandatoryLabel": "މަޖުބޫރު",
      "mandatoryMeaning": "މި ސިފަ ރެކޯޑްކުރަންދެން ލޮޓް ފާހެއް ނުވާނެ.",
      "codeFixedOnceCreated": "އުފެއްދިފަހުން ބަދަލެއް ނުކުރެވޭނެ"
    },
    "samplingPlans": {
      "title": "ސާމްޕްލިން ޕްލޭންތައް",
      "description": "ޑެލިވަރީއަކުން ބަލާނީ ކިތައް، އަދި ކިތައް ޢައިބު ބަލައިގަނެވޭނެ.",
      "tableTitle": "ޕްލޭންތައް",
      "caption": "ސާމްޕްލިން ޕްލޭންތަކާއި އޭގެ ގޮތް، ޕަސެންޓޭޖް، އެންމެ ދަށް މިންވަރު އަދި އެކްސެޕްޓް ނަންބަރު.",
      "create": "އައު ސާމްޕްލިން ޕްލޭން",
      "dialogDescription": "ގޮތުން ކޮން ފީލްޑެއް އޮންނާނެކަން ނިންމޭ. އޭކިއުއެލް ބޭންޑްތައް ލިޔެވެނީ ޕްލޭން އުފެއްދުމަށްފަހު.",
      "empty": "އަދި ސާމްޕްލިން ޕްލޭނެއް ނެތް. އެއް އުފައްދާ، ނުވަތަ މުޅި ލޮޓް ބެލުމަށް ޕްލޭނަކަށް އެއް ނުދީ ދޫކުރޭ.",
      "loadFailed": "ސާމްޕްލިން ޕްލޭންތައް ލޯޑެއް ނުވި",
      "saved": "ސާމްޕްލިން ޕްލޭން ރައްކާކޮށްފި",
      "saveFailed": "ސާމްޕްލިން ޕްލޭން ރައްކާނުކުރެވުނު",
      "selectFirst": "ޕްރިވިއުކުރުމަށް ނުވަތަ ބޭންޑްތައް އެޑިޓްކުރުމަށް ސާމްޕްލިން ޕްލޭނެއް ހޮވާ.",
      "methodHint": {
        "fixed_percent": "ލޮޓުގެ ޕަސެންޓެއް ބަލާ، އެންމެ ދަށް މިންވަރަށްވުރެ ދަށެއް ނުވާނެ",
        "aql_table": "މި ލޮޓް ސައިޒަށް ތިޔަ ބޭފުޅުންގެ ބޭންޑް ތާވަލުން ބުނާ މިންވަރު ބަލާ",
        "hundred_percent": "ކޮންމެ ޔުނިޓެއް ބަލާ؛ އެކްސެޕްޓް ނަންބަރަކީ ސުމެއް"
      },
      "floorMeaning": "ދިހަ ޔުނިޓުގެ ޑެލިވަރީއެއްގައި 2% ޕްލޭނަކުން އެއްވެސް އެއްޗެއް ނުބެލުން ހުއްޓުވާ.",
      "acceptMeaning": "މި ނަންބަރާ ހަމައަށް، އެ ނަންބަރުވެސް ހިމެނޭގޮތަށް، ޢައިބު ހުއްޓަސް ލޮޓް ފާސްވާނެ.",
      "aqlNote": "އޭކިއުއެލް ޕްލޭންތަކުން ސާމްޕަލް ސައިޒާއި އެކްސެޕްޓް ނަންބަރު ނަގަނީ ބޭންޑް ތާވަލުން. މި ޕްލޭން ބޭނުންކުރާ ޕްލޭނެއް އެކްޓިވޭޓްކުރުމުގެ ކުރިން ބޭންޑްތައް ލިޔޭ.",
      "hundredNote": "ކޮންމެ ޔުނިޓެއް ބެލޭ، އަދި އެކްސެޕްޓް ނަންބަރަކީ ސުމެއް.",
      "previewTitle": "ކުރިން ބަލާލުން",
      "previewDescription": "ކަނޑައެޅޭ ސައިޒެއްގެ ޑެލިވަރީއަކަށް މި ޕްލޭނުން ކުރާނެ ކަންތައް. ޢަދަދުތަކަކީ ސާވަރުގެ އަމިއްލަ ހިސާބު.",
      "previewAction": "ކުރިން ބަލާލުން",
      "bandsTitle": "އޭކިއުއެލް ބޭންޑްތައް",
      "bandsDescription": "ލޮޓް ސައިޒް ބޭންޑްތަކާއި އޭގެ ސާމްޕަލް ސައިޒާއި އެކްސެޕްޓް ނަންބަރު. ހުރިހާ ބޭންޑަކުން ބޭރު ލޮޓެއް 100% އަށް ބަދަލުކުރުމުގެ ބަދަލުގައި ބަލައެއް ނުގަނެވޭނެ.",
      "bandsCaption": "ހޮވިފައިވާ ސާމްޕްލިން ޕްލޭނުގެ އޭކިއުއެލް ބޭންޑްތައް.",
      "bandsEmpty": "އަދި ބޭންޑެއް ނެތް. އޭކިއުއެލް ގޮތް ބޭނުންކުރާ ޕްލޭނެއް އެއާ ނުލައި އެކްޓިވޭޓެއް ނުކުރެވޭނެ.",
      "addBand": "ބޭންޑެއް އިތުރުކުރޭ",
      "saveBands": "ބޭންޑްތައް ރައްކާކުރޭ",
      "bandsSaved": "ބޭންޑްތައް ރައްކާކޮށްފި",
      "bandsFailed": "ބޭންޑްތައް ރައްކާނުކުރެވުނު"
    },
    "worklist": {
      "title": "އިންސްޕެކްޝަންތައް",
      "description": "ބެލުމަށް މަޑުކޮށްފައި ހުރި އެއްޗެހި، އައި ތަނުން ބަހާލެވިފައި.",
      "tableTitle": "އިންސްޕެކްޝަން ލޮޓްތައް",
      "caption": "ހުޅުވިފައިވާ އިންސްޕެކްޝަން ލޮޓްތަކާއި އޭގެ އަޞްލު ލިޔުން، ސާމްޕަލް ސައިޒް އަދި ފެނުނު ޢައިބުތައް.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ލޮޓް ނުވަތަ ލިޔުމުގެ ނަންބަރު",
      "loadFailed": "އިންސްޕެކްޝަންތައް ލޯޑެއް ނުވި",
      "empty": "އިންސްޕެކްޝަނެއް ނެތް. ޕްލޭނަކާ ގުޅޭނަމަ ބަލައިގަތުމަކުން، އުފެއްދުމުގެ ބަލައިގަތުމަކުން ނުވަތަ ފޮނުވުމަކުން އުފެދޭ.",
      "emptyOpen": "ބެލުމަށް އެއްވެސް އެއްޗެއް މަޑުކޮށްފައެއް ނެތް.",
      "showOpen": "ހަމައެކަނި ހުޅުވިފައި",
      "showAll": "ހުރިހާ އެންމެން",
      "openCount": "މި ޞަފުޙާގައި {count} ހުޅުވިފައި",
      "critical": "{count} ކްރިޓިކަލް",
      "noSla": "މި ކުންފުންޏަށް ކަރަންޓީނުގެ އެސްއެލްއޭއެއް ކަނޑައަޅާފައެއް ނުވޭ، އެހެންވެ އެއްވެސް ލޮޓެއް ލަސްވެފައިވާކަމަށް ނުދައްކާ. ކޮލިޓީ ސެޓިންގްސްގައި އެއް ކަނޑައަޅާ.",
      "backToList": "އިންސްޕެކްޝަންތަކަށް އެނބުރި"
    },
    "inspection": {
      "untitled": "އިންސްޕެކްޝަން #{id}",
      "subtitle": "{doc} އިން",
      "factsTitle": "ލޮޓު",
      "sheetTitle": "ރެކޯޑްކުރާ ޝީޓް",
      "sheetHelp": "އެންޓަރ ނުވަތަ ތިރިއަށް ދާ ދުނިން ދެން އޮތް ސާމްޕަލަށް؛ ކަނާތަށް ދާ ދުނިން ދެން އޮތް ސިފައަށް.",
      "sheetCaption": "ކޮންމެ ސިފައަކަށް އެއް ރޯ، ކޮންމެ ސާމްޕަލަކަށް އެއް ކޮލަމް.",
      "sample": "އެސް{no}",
      "cellLabel": "{name}، ސާމްޕަލް {no}",
      "pass": "ފާސް",
      "fail": "ފެއިލް",
      "noCharacteristics": "މި ޕްލޭނުގައި ސިފައެއް ނެތް، އެހެންވެ ރެކޯޑްކުރާނެ އެއްޗެއް ނެތް.",
      "record": "ކިޔުންތައް ރެކޯޑްކުރޭ",
      "recorded": "ކިޔުންތައް ރެކޯޑްކޮށްފި",
      "recordedCount": "{count} ކިޔުން",
      "recordFailed": "ކިޔުންތައް ރެކޯޑެއް ނުކުރެވުނު",
      "readingCount": "{count} ކިޔުން ލިޔެވިއްޖެ",
      "loadFailed": "އިންސްޕެކްޝަން ލޯޑެއް ނުވި",
      "notIndependent": "އަޞްލު ލިޔުން ހެއްދެވީ ތިޔަ ބޭފުޅާ، އަދި މި ޕްލޭނަށް މުސްތަޤިއްލު އިންސްޕެކްޓަރެއް ބޭނުންވޭ. މި ކިޔުންތައް ރެކޯޑްކުރަން ޖެހޭނީ އެހެން މީހަކު.",
      "provisionalCritical": "ކްރިޓިކަލް ޢައިބެއް ރެކޯޑްކޮށްފި. ކްރިޓިކަލް ޢައިބެއް ފެނިއްޖެނަމަ، އެކްސެޕްޓް ނަންބަރު ކޮންމެ އެއްޗެއް ބުންޏަސް މުޅި ލޮޓް ފެއިލްވާނެ.",
      "provisionalOverAccept": "އެކްސެޕްޓް ނަންބަރު {accept} އަށް، {defects} ޢައިބު ލިޔެވިއްޖެ. މި ކިޔުންތަކުން ލޮޓް ފެއިލްވާނެ.",
      "waive": "ދޫކުރޭ",
      "waiveConfirm": "އިންސްޕެކްޝަން ދޫކޮށްލާ",
      "waiveDescription": "ނުބަލައި މި ލޮޓް ދޫކުރޭ.",
      "waiveMeaning": "މުދާ ކުރިއަށްދާނެ، އަދި މި ލޮޓަށް ދުވަހަކުވެސް ކިޔުމެއް ރެކޯޑެއް ނުކުރެވޭނެ. ސަބަބު ދާއިމަށް ބެހެއްޓޭ، އަދި އޮޑިޓަރު ކިޔާނީ އެއެއް.",
      "waived": "އިންސްޕެކްޝަން ދޫކޮށްލައިފި",
      "waiveFailed": "އިންސްޕެކްޝަން ދޫކޮށްނުލެވުނު"
    },
    "disposition": {
      "title": "ނިންމުންތައް",
      "caption": "ލޮޓާމެދު ނިންމުނު ގޮތާއި، އެއިން ކިތައް.",
      "decide": "ޑިސްޕޮޒިޝަން",
      "confirm": "ނިންމުން ރެކޯޑްކުރޭ",
      "dialogDescription": "މުދަލަށް ވާނެ ގޮތާއި، އެއިން ކިތައް އެއްޗަށްކަން.",
      "saved": "ނިންމުން ރެކޯޑްކޮށްފި",
      "saveFailed": "ނިންމުން ރެކޯޑެއް ނުކުރެވުނު",
      "concessionRequired": "މި ލޮޓް ފެއިލްވެއްޖެ. ބަލައިގަތުމަށް ސަބަބެއް ބޭނުންވޭ، އަދި އެ ރެކޯޑްކުރެވެނީ ލުޔެއްގެ ގޮތުގައި.",
      "returnMeaning": "މުދާ އަނބުރާ ދާނީ ސަޕްލަޔަރަށް: މިއިން ރިޓާނެއް ފެށޭ، އަދި ރިޓާން ފޮނުވުމުން ޑެބިޓް ނޯޓެއް.",
      "scrapMeaning": "އަގު ލިޔެލެވެނީ ކުންފުނީގެ ބަލައިގަތުމުގެ ސްކްރެޕް އެކައުންޓަށް. ސަޕްލަޔަރު މުދާ އަނބުރާ ނުނަގާތީ، ޑެބިޓް ނޯޓެއް ނުނަގާ.",
      "kindMeaning": {
        "accept": "ސްޓޮކަށް، އަދި ދޫކުރެވެން ހުރި",
        "accept_with_concession": "ފެއިލްވިޔަސް ސްޓޮކަށް، ރެކޯޑްކުރެވިފައިވާ ސަބަބަކާއެކު",
        "rework": "ދޫކުރުމުގެ ބަދަލުގައި އަލުން ހެދުމަށް ހިފެހެއްޓިފައި",
        "reject_return": "ސަޕްލަޔަރަށް އަނބުރާ ފޮނުވިފައި",
        "reject_scrap": "ފައިދާ-ގެއްލުމުގެ ބަޔާނަށް ލިޔެލެވިފައި",
        "hold": "ނިންމުމެއް ލިބެންދެން ކަރަންޓީނުގައި"
      }
    },
    "capa": {
      "title": "އިޞްލާޙީ ފިޔަވަޅުތައް",
      "description": "ގޯސްވި ކަމަކާއި، އެކަމާމެދު ކުރި ކަމަކާއި، އެކަން ކާމިޔާބުވިތޯ.",
      "create": "އައު ސީއޭޕީއޭ",
      "dialogDescription": "އިޞްލާޙީ ފިޔަވަޅަކީ ހިނގައިފައިވާ ކަމަކަށް ދޭ ޖަވާބެއް؛ ރައްކާތެރިކުރުމުގެ ފިޔަވަޅަކީ އަދި ނުހިނގާ ކަމަކަށް.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ނަންބަރު ނުވަތަ ސުރުޚީ",
      "loadFailed": "އިޞްލާޙީ ފިޔަވަޅުތައް ލޯޑެއް ނުވި",
      "empty": "އިޞްލާޙީ ފިޔަވަޅެއް ނެތް. ފެއިލްވި އިންސްޕެކްޝަނަކުން، ނޮންކޮންފޯމަންސަކުން ނުވަތަ އޮޑިޓް ފާހަގަކުރުމަކުން އެއް ހުށަހަޅާ.",
      "columnEmpty": "މިތާ އެއްޗެއް ނެތް",
      "truncated": "ދައްކަނީ ފުރަތަމަ ޞަފުޙާ. ކޮލަމްތަކުން ގުނަނީ ސްކްރީނުގައި ހުރި އެއްޗެއް، މުޅި ރަޖިސްޓަރީއެއް ނޫން.",
      "showMine": "ހަމައެކަނި އަހަރެންގެ",
      "showAll": "ހުރިހާ އެންމެން",
      "dueOn": "{date} ގައި ހަމަވޭ",
      "saved": "ސީއޭޕީއޭ ހުށަހަޅައިފި",
      "saveFailed": "ސީއޭޕީއޭ ރައްކާނުކުރެވުނު",
      "kindHint": {
        "corrective": "މިހާރު ކަމެއް ގޯސްވެއްޖެ",
        "preventive": "އަދި ކަމެއް ގޯހެއް ނުވޭ"
      },
      "sourceHint": "މި ކަން ފާހަގަވި ގޮތް.",
      "factsTitle": "ތަފްޞީލު",
      "rootCauseTitle": "އަސްލު ސަބަބު",
      "rootCausePlaceholder": "ޙަޤީޤަތުގައި މިކަން ދިމާވި ސަބަބަކީ ކޮބާ؟",
      "rootCauseSaved": "އަޞްލު ސަބަބު ރައްކާކޮށްފި",
      "actionsTitle": "ޢަމަލުތައް",
      "actionsCaption": "ރޭވިފައިވާ ފިޔަވަޅުތަކާއި އޭގެ ވެރިފަރާތް، ސުންގަޑި އަދި ފުރިހަމަކުރުން.",
      "actionsEmpty": "އަދި ފިޔަވަޅެއް ރޭވިފައެއް ނުވޭ.",
      "newAction": "އައު ފިޔަވަޅު",
      "completeAction": "ނިމުނުކަމަށް ފާހަގަކުރޭ",
      "actionAdded": "ކަން އިތުރުކުރެވިއްޖެ",
      "actionCompleted": "އެކްޝަން ނިމިއްޖެ",
      "actionFailed": "ފިޔަވަޅު ރައްކާނުކުރެވުނު",
      "verifyTitle": "އަސަރުކުރުން",
      "verifyDescription": "ފިޔަވަޅުތައް ކާމިޔާބުވިތަ؟ މިއީ އެ ފިޔަވަޅުތައް ހިންގުމުގެ ބާރާ ވަކި ބާރެއް.",
      "verifyingMeaning": "ނިންމުމަކަށް މަޑުކޮށްފައި. އަސަރު ނުކުރިކަމަށް ނިންމުމުން ސީއޭޕީއޭ އަނބުރާ ފިޔަވަޅު ރޭވުމަށް ދާނެ.",
      "verifyNotPermitted": "މި ސީއޭޕީއޭ މަޑުކޮށްފައި ވަނީ އަސަރުކުރުމުގެ ނިންމުމަކަށް. އެ ރެކޯޑްކުރުމަށް ޔަގީންކުރުމުގެ ބާރު ބޭނުންވޭ، އެއީ ފިޔަވަޅުތައް ހިންގުމުގެ ބާރާ ވަކިން ދެވޭ ބާރެއް.",
      "effective": "ހިނގާ މުއްދަތު",
      "effectiveMeaning": "މައްސަލަ ތަކުރާރުވެފައެއް ނުވޭ، އަދި ސީއޭޕީއޭ ބަންދުވޭ.",
      "notEffective": "އަސަރެއް ނުކުރި",
      "notEffectiveMeaning": "ސީއޭޕީއޭ އަނބުރާ ދާނީ ފިޔަވަޅު ރޭވުމުގެ މަރުޙަލާއަށް. ކާމިޔާބު ނުވި އިޞްލާޙީ ފިޔަވަޅެއް ނުނިމޭ.",
      "recordVerdict": "ނިންމުން ރެކޯޑްކުރޭ",
      "verifiedClosed": "ސީއޭޕީއޭ ބަންދުކޮށްފި",
      "verifiedReopened": "ސީއޭޕީއޭ ފިޔަވަޅު ރޭވުމުގެ މަރުޙަލާއަށް އަނބުރާ ފޮނުވައިފި",
      "verifyFailed": "ނިންމުން ރެކޯޑެއް ނުކުރެވުނު",
      "backToBoard": "އިޞްލާޙީ ފިޔަވަޅުތަކަށް އެނބުރި"
    },
    "qualitySummary": {
      "title": "ކޮލިޓީ ޚުލާޞާ",
      "description": "ފާސްވުމުގެ ނިސްބަތާއި ޢައިބުގެ ނިސްބަތް، ސިފައިން، ސަޕްލަޔަރުން އަދި ތަކެތިން.",
      "pickCompany": "ޚުލާޞާ ހިންގުމަށް ކުންފުންޏެއް ހޮވާ.",
      "loadFailed": "ކޮލިޓީ ޚުލާޞާ ލޯޑެއް ނުވި",
      "passRate": "ފާސްވުމުގެ ނިސްބަތް",
      "inspected": "ބެލެވިފައި",
      "failed": "ފެއިލްވެފައި",
      "waived": "ދޫކޮށްލި",
      "defectRate": "ޢައިބުގެ ނިސްބަތް",
      "byCharacteristic": "ސިފައިން",
      "byVendor": "ސަޕްލަޔަރުން",
      "byItem": "ތަކެތިން",
      "empty": "މި މުއްދަތުގައި އެއްވެސް އެއްޗެއް ނެތް.",
      "readings": "ކިޔުންތައް",
      "critical": "ސީރިއަސް"
    },
    "settings": {
      "title": "ކޮލިޓީ ސެޓިންގްސް",
      "description": "ކަރަންޓީނުކުރެވިފައިވާ ސްޓޮކް ހުންނަ ތަނާއި، ސްކްރެޕް ޕޯސްޓްވާ ތަނާއި، ލޮޓެއް މަޑުކުރެވޭނެ މުއްދަތު.",
      "panelTitle": "ކުންފުނީގެ ސެޓިންގްސް",
      "pickCompany": "ކޮލިޓީ ސެޓިންގްސް ބެލުމަށް ކުންފުންޏެއް ހޮވާ.",
      "loadFailed": "ކޮލިޓީ ސެޓިންގްސް ލޯޑެއް ނުވި",
      "saved": "ކޮލިޓީ ސެޓިންގްސް ރައްކާކޮށްފި",
      "saveFailed": "ކޮލިޓީ ސެޓިންގްސް ރައްކާނުކުރެވުނު",
      "readOnly": "މި ސެޓިންގްސް ބެލޭނެ، އެކަމަކު ބަދަލެއް ނުކުރެވޭނެ.",
      "quarantineWarehouse": "ކަރަންޓީނު ގުދަން",
      "quarantineWarehouseMeaning": "ހިފެހެއްޓިފައިވާ ސްޓޮކް ޙަޤީޤަތުގައި ހުންނަ ތަން. އެއީ ބެލެންސް ޝީޓުގައި ހިމެނޭ، އަދި ދޫނުކުރެވޭނެ.",
      "scrapAccount": "ބަލައިގަތުމުގެ ސްކްރެޕް އެކައުންޓް",
      "scrapAccountMeaning": "ބޭރުކޮށް ސްކްރެޕްކުރުމުގެ ނިންމުމަކުން އަގު ލިޔެލެވޭ ތަން.",
      "receiptPolicy": "ބަލައިގަތުމުގެ ޑިފޯލްޓް ޕޮލިސީ",
      "policyHint": {
        "none": "ގުޅޭ ޕްލޭނެއް ނެތް ޑެލިވަރީތައް ސީދާ ސްޓޮކަށް ދޭ",
        "quarantine": "ގުޅޭ ޕްލޭނެއް ނެތް ޑެލިވަރީތައް ދޫކުރަންދެން ހިފެހެއްޓޭ"
      },
      "slaDays": "ކަރަންޓީނު އެސްއެލްއޭ (ދުވަސް)",
      "slaDaysMeaning": "ވޯކްލިސްޓުން ލަސްވެއްޖެކަމަށް ބުނުމުގެ ކުރިން ލޮޓެއް މަޑުކުރެވޭނެ މުއްދަތު.",
      "noSlaMeaning": "އެސްއެލްއޭއެއް ކަނޑައަޅާފައި ނުވާނަމަ ވޯކްލިސްޓުން އެއްވެސް ޔަގީންކަމެއް ނުދޭ، އެއީ ތެދުވެރި ގޮތެއް، އެކަމަކު ބާ ލޮޓެއް ފަހަތުން އަރާނެ އެއްޗެއް ނުހުންނާނެ.",
      "capaDueDays": "ސީއޭޕީއޭގެ ޑިފޯލްޓް މުއްދަތު (ދުވަސް)"
    },
    "quarantine_overdue": {
      "summary": "ސްޓޮކް ކުންފުނީގެ ހުއްދަ ދުވަސްތަކަށްވުރެ ގިނަ ދުވަހު ކުއަރެންޓިންގައި ހުރި."
    },
    "capa_overdue": {
      "summary": "އިސްލާހީ އަމަލެއްގެ ވަގުތު ހަމަވެފައި ވޭ."
    }
  },
  "pos": {
    "filtersTitle": "ފިލްޓަރތައް",
    "routeTitles": {
      "outlets": "އައުޓްލެޓްތައް",
      "outlet": "އައުޓްލެޓް",
      "settings": "ޕީއޯއެސް ސެޓިންގްސް",
      "devices": "ޑިވައިސް ފްލީޓް",
      "device": "ޑިވައިސް",
      "contentSets": "ކޮންޓެންޓް ސެޓްތައް",
      "contentSet": "ކޮންޓެންޓް ސެޓް",
      "menus": "މެނޫތައް",
      "menuVersion": "މެނޫ ވަރޝަން",
      "availability": "86 ބޯޑް",
      "sales": "ޕީއޯއެސް ވިޔަފާރި",
      "sale": "ޕީއޯއެސް ވިޔަފާރި",
      "cashSessions": "ކޭޝް ސެޝަންތައް",
      "cashSession": "ކޭޝް ސެޝަން",
      "dayCloseBoard": "ދުވަސް ބަންދުކުރުން",
      "dayClose": "ދުވަސް ބަންދު ޕެކް",
      "anomalies": "އޮޕަރޭޓަރ އެނޯމަލީ",
      "conflicts": "ސިންކް ކޮންފްލިކްޓް",
      "ratifications": "ފަސްކުރެވުނު ހުއްދަތައް",
      "operatorPins": "އޮޕަރޭޓަރ ޕިން",
      "supersededPricing": "ބަދަލުވެފައިވާ އަގު",
      "floorPlan": "ފްލޯ ޕްލޭން",
      "retailLedgers": "ރީޓެއިލް ލެޖަރ"
    },
    "fields": {
      "businessDate": "ވިޔަފާރި ތާރީޚް",
      "cashAccount": "ޑްރޯވަރ ޖީއެލް އެކައުންޓް",
      "cashRounding": "ކޭޝް ރައުންޑިން",
      "channel": "ޗެނަލް",
      "channelDefault": "ކުންފުނީގެ ޑިފޯލްޓް",
      "code": "ކޯޑް",
      "company": "ކުންފުނި",
      "currency": "ފައިސާ",
      "dayUnit": "އޮޕަރޭޓިން ދުވަހުގެ ޔުނިޓް",
      "docKind": "ލިޔުން",
      "effectivity": "އަމަލުކުރާ މުއްދަތު",
      "kind": "ބާވަތް",
      "location": "ތަން",
      "openEnded": "ނިމުމެއް ނެތް",
      "outlet": "އައުޓްލެޓް",
      "priceSet": "އަގު ސެޓް",
      "state": "ހާލަތު",
      "supplyType": "ސަޕްލައި ބާވަތް",
      "taxChannel": "ޓެކްސް ޗެނަލް",
      "terminal": "ޓާމިނަލް",
      "warehouse": "ގުދަން"
    },
    "outletKind": {
      "retail": "ރީޓެއިލް",
      "hospitality": "ހޮސްޕިޓަލިޓީ",
      "wholesale": "ހޯލްސޭލް"
    },
    "supplyType": {
      "goods": "މުދާ",
      "services": "ޚިދުމަތް",
      "accommodation": "އެކޮމޮޑޭޝަން",
      "fnb": "ކާނާއާއި ބުއިން",
      "digital": "ޑިޖިޓަލް",
      "transport": "ދަތުރުފަތުރު",
      "other": "އެހެނިހެން"
    },
    "terminalStatus": {
      "active": "ހަރަކާތްތެރި",
      "suspended": "މަޑުޖައްސާލެވިފައި",
      "retired": "ބޭނުންކުރުން ހުއްޓާލެވިފައި"
    },
    "tenderKind": {
      "cash": "ފައިސާ",
      "card": "ކާޑް",
      "gift_card": "ގިފްޓް ކާޑް",
      "store_credit": "ސްޓޯ ކްރެޑިޓް",
      "account": "އެކައުންޓަށް",
      "room_charge": "ކޮޓަރި ޗާޖް"
    },
    "denominationKind": {
      "note": "ނޫޓް",
      "coin": "ފައިސާ ފޮތި"
    },
    "saleStatus": {
      "open": "ހުޅުވިފައި",
      "settled": "ސެޓްލްކުރެވިފައި",
      "voided": "ބާޠިލްކުރެވިފައި",
      "abandoned": "ދޫކޮށްލެވިފައި"
    },
    "saleDocKind": {
      "sale": "ވިޔަފާރި",
      "refund": "ފައިސާ އަނބުރާ"
    },
    "channelMode": {
      "dine_in": "ތަނުގައި ކެއުން",
      "takeaway": "ޓޭކްއަވޭ",
      "delivery": "ޑެލިވަރީ",
      "room_charge": "ކޮޓަރި ޗާޖް",
      "counter": "ކައުންޓަރ"
    },
    "priceBasis": {
      "exclusive": "ޓެކްސް ނުހިމަނާ",
      "inclusive": "ޓެކްސް ހިމަނައިގެން"
    },
    "discountKind": {
      "percent": "އިންސައްތަ",
      "amount": "އަދަދު",
      "promotion": "ޕްރޮމޯޝަން"
    },
    "sessionStatus": {
      "open": "ހުޅުވިފައި",
      "counting": "ގުނަމުން",
      "closed": "ބަންދުކުރެވިފައި",
      "reconciled": "ރިކޮންސައިލްކުރެވިފައި"
    },
    "cashMovementKind": {
      "float_in": "ފްލޯޓް އެތެރެއަށް",
      "float_out": "ފްލޯޓް ބޭރަށް",
      "drop": "ސޭފަށް ޑްރޮޕް",
      "paid_in": "އެތެރެއަށް ދެއްކުނު",
      "paid_out": "ބޭރަށް ދެއްކުނު",
      "no_sale": "ނޯ ސޭލް"
    },
    "depositStatus": {
      "draft": "ތައްޔާރުކުރެވިފައި",
      "banked": "ބޭންކަށް ޖަމާކުރެވިފައި",
      "confirmed": "ބޭންކުން ކަށަވަރުކުރެވިފައި"
    },
    "dayCloseStatus": {
      "draft": "ދެލިކޮޕީ",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "reversed": "އަނބުރާލެވިފައި"
    },
    "dayCloseLineKind": {
      "revenue": "އާމްދަނީ",
      "tax": "ޓެކްސް",
      "service_charge": "ސާވިސް ޗާޖް",
      "tender": "ޓެންޑަރ",
      "instrument_issue": "އިންސްޓްރޫމަންޓް ދޫކުރުން",
      "instrument_redeem": "އިންސްޓްރޫމަންޓް ބޭނުންކުރުން",
      "tip": "ޓިޕް",
      "rounding": "ކޭޝް ރައުންޑިން",
      "cash_variance": "ފައިސާ އިތުރު ނުވަތަ މަދު",
      "paid_in": "އެތެރެއަށް ދެއްކުނު",
      "paid_out": "ބޭރަށް ދެއްކުނު"
    },
    "dayCloseBlocker": {
      "check": "ހުޅުވިފައިވާ ޗެކް",
      "session": "ހުޅުވިފައިވާ ޑްރޯވަރ",
      "sale": "ސެޓްލްނުކުރެވޭ ވިޔަފާރި",
      "period": "އެކައުންޓިން މުއްދަތު",
      "day": "އޮޕަރޭޓިން ދުވަސް"
    },
    "publicationStatus": {
      "draft": "ދެލިކޮޕީ",
      "published": "ޝާއިޢުކުރެވިފައި",
      "withdrawn": "އަނބުރާ ގެނެވިފައި"
    },
    "availabilityState": {
      "available": "ލިބެން ހުރި",
      "eighty_six": "86 ކުރެވިފައި",
      "limited": "މަދުން"
    },
    "deviceStatus": {
      "pending": "އެންރޯލްކުރުމަށް އިންތިޒާރުގައި",
      "active": "އެންރޯލްކުރެވިފައި",
      "suspended": "މަޑުޖައްސާލެވިފައި",
      "revoked": "ބާޠިލްކުރެވިފައި"
    },
    "partKind": {
      "price_set_version": "އަގު ސެޓް ވަރޝަން",
      "tax_pack": "ޓެކްސް ޕެކް",
      "menu_version": "މެނޫ ވަރޝަން",
      "operator_roster": "އޮޕަރޭޓަރ ރޯސްޓަރ",
      "terminal_policy": "ޓާމިނަލް ޕޮލިސީ"
    },
    "syncBatchStatus": {
      "received": "ލިބިފައި",
      "applying": "ހިންގަމުން",
      "completed": "ނިމިފައި",
      "failed": "ފެއިލްވެފައި"
    },
    "conflictRule": {
      "queued_for_review": "ބެލުމަށް ކިޔޫގައި",
      "server_wins_config": "ސާވަރގެ އަގު ބެހެއްޓުނު (ކޮންފިގަރޭޝަން)",
      "client_wins_completed": "ޓާމިނަލްގެ އަގު ބެހެއްޓުނު (ނިމިފައިވާ އަމަލެއް)"
    },
    "conflictRuleHint": {
      "queued_for_review": "މިއަށް އަދި އެއްވެސް މީހަކު ގޮތެއް ނުނިންމާ. މި ސްކްރީން އޮތީ މިކަމަށްޓަކައި.",
      "server_wins_config": "ޓާމިނަލްގައި ހުރީ ބާވެފައިވާ ކޮންފިގަރޭޝަނެއް، އެހެންކަމުން ސާވަރގެ އަގު ދެމިއޮތީ. މިއީ ބަޔާންކުރެވޭނެ ގޮތަށް ރެކޯޑްކުރެވިފައި.",
      "client_wins_completed": "އެ އަމަލު ޓާމިނަލްގައި ނިމިފައިވާތީ ސާވަރ އެ ބަލައިގަތީ. މިވެސް ރެކޯޑްކުރެވެނީ އެ ސަބަބަށްޓަކައި."
    },
    "conflictStatus": {
      "open": "ހުޅުވިފައި",
      "resolved": "ހައްލުކުރެވިފައި",
      "dismissed": "ދޫކޮށްލެވިފައި"
    },
    "ratificationStatus": {
      "pending": "ނިންމުމަކަށް އިންތިޒާރުގައި",
      "ratified": "ތަޞްދީޤުކުރެވިފައި",
      "refused": "ދޫކޮށްލެވިފައި"
    },
    "offlinePolicy": {
      "permit_within_limit": "ލިމިޓެއްގެ ތެރޭގައި ހުއްދަ",
      "defer_ratification": "ހުއްދަ، ފަހުން ތަޞްދީޤު",
      "refuse": "އޮފްލައިންގައި ހުއްދަ ނުދިނުން"
    },
    "offlinePolicyHint": {
      "permit_within_limit": "ޓާމިނަލް ސީލިންގެއްގެ ތެރޭގައި ނިންމާނެ، އަދި ފަހުން އެއްވެސް މީހަކު އެ ނުބަލާނެ. އެ ސީލިންގަކީ މުޅި ކޮންޓްރޯލް.",
      "defer_ratification": "ޓާމިނަލް ނިންމައި، ފަހުން މީހަކު ތަޞްދީޤުކުރާނެ. ދޫކޮށްލުމަކުން އަނބުރާ ނުދާނެ، އޭގެ ބަދަލުގައި ކޮމްޕެންސޭޓިން އަމަލެއް ހިނގާނެ.",
      "refuse": "ޓާމިނަލަށް ނިންމުމުގެ ހުއްދައެއް ނެތް. ކަސްޓަމަރު އެހެން ގޮތަކުން ފައިސާ ދައްކާނެ."
    },
    "anomalyStatus": {
      "open": "ހުޅުވިފައި",
      "investigating": "ބަލަމުން",
      "resolved": "ހައްލުކުރެވިފައި",
      "dismissed": "ދޫކޮށްލެވިފައި"
    },
    "anomalyCode": {
      "void_rate": "ބާޠިލްކުރުމުގެ ރޭޓް",
      "discount_rate": "ޑިސްކައުންޓް ރޭޓް",
      "refund_rate": "ފައިސާ އަނބުރާ ދިނުމުގެ ރޭޓް",
      "no_sale_count": "ނޯ ސޭލް އަދަދު",
      "cash_variance": "ފައިސާގެ ތަފާތު"
    },
    "contentCheck": {
      "referents": "ކޮންމެ ބައެއް ޝާއިޢުކުރެވި ހޭޝްކުރެވިފައިވާ އެއްޗަކަށް އިޝާރާތްކުރޭ",
      "oneEach": "ކޮންމެ ބާވަތަކުން ގިނަވެގެން އެއް ބައި",
      "required": "މި ސަރފޭސްއަށް ބޭނުންވާ ހުރިހާ ބާވަތެއް ހިމެނޭ",
      "crossChecks": "ވެރި މޮޑިއުލްގެ އަމިއްލަ ކްރޮސް-ޗެކްތައް"
    },
    "contentCheckHint": {
      "referents": "ސެޓެއްގައި ހިމެނޭނީ ޝާއިޢުކުރެވިފައިވާ އަގު ލިސްޓް، ޓެކްސް ޕެކް ނުވަތަ މެނޫ އެކަނި، ޓާމިނަލަށް އެ ކަށަވަރުކުރެވޭ ގޮތަށް.",
      "oneEach": "ދެ އަގު ސެޓުން ކުރެ ކޮންއެއްޗެއްކަން ޓާމިނަލް ދިމާކުރަން ޖެހިގެން ނުވާނެ.",
      "required": "އަގު، ޓެކްސް ގަވާއިދު ނުވަތަ ކެޓަލޮގް ނެތް ޕީއޯއެސް ސެޓަކީ ވިއްކޭނެ ޓިލްއެއް ނޫން.",
      "crossChecks": "މެނޫ އެ ވިއްކާ އަގު ސެޓާ އަޅާކިޔެނީ މިތާ — ޚިދުމަތް ފެށުމުގެ ކުރިން އަގު ނެތް ކާނާ ހޯދާ ޗެކް."
    },
    "menuCheck": {
      "no_price": "ކޮންމެ އައިޓަމަކަށް އަގެއް",
      "no_tax_class": "ކޮންމެ އައިޓަމެއް ޓެކްސް ކްލެސިފައިކުރެވިފައި",
      "unknown_item": "ކޮންމެ އައިޓަމެއް ވުޖޫދުގައި ވެފައި ވިއްކޭ",
      "empty_section": "ހުސް ސެކްޝަނެއް ނެތް",
      "empty_modifier_group": "ހުސް މޮޑިފަޔަރ ގްރޫޕެއް ނެތް",
      "insufficient_modifiers": "ކޮންމެ ލާޒިމް ގްރޫޕެއްގައި ފުދޭވަރަށް ޚިޔާރު"
    },
    "outlets": {
      "title": "އައުޓްލެޓްތައް",
      "description": "ވިޔަފާރި ހިނގާ ތަން. އައުޓްލެޓްގެ ޓެކްސް ޗެނަލް، އަގު ސެޓް، ގުދަން އަދި ރައުންޑިން އިން ކޮންމެ ވިޔަފާރިއެއްގެ އަގު ކަނޑައެޅޭ.",
      "tableTitle": "އައުޓްލެޓްތައް",
      "caption": "އައުޓްލެޓްތަކާއި އޭގެ ޓެކްސް ޗެނަލް، ފައިސާ، ގުދަން، އަގު ސެޓް އަދި ކޭޝް ރައުންޑިން.",
      "detailDescription": "ކޮންފިގަރޭޝަން، ޓާމިނަލްތައް އަދި މި އައުޓްލެޓްގެ ޓިލްތައް ތަބާވާ އޮފްލައިން ޕޮލިސީ.",
      "factsTitle": "ކޮންފިގަރޭޝަން",
      "create": "އައު އައުޓްލެޓް",
      "dialogDescription": "މީގެ ތެރެއިން ހަތަރު ފީލްޑަކުން ކުރިއަށް އޮތް ކޮންމެ ވިޔަފާރިއެއްގެ އަގު ކަނޑައެޅޭ. ކޮންއެއްޗެއްކަމާއި ސަބަބު ހިންޓްތަކުގައި.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން",
      "chooseCompany": "އައުޓްލެޓްތައް ބެލުމަށް ކުންފުންޏެއް ޚިޔާރުކުރައްވާ. ކޮންމެ އައުޓްލެޓެއް ނިސްބަތްވަނީ އެއް ކުންފުންޏަކަށް.",
      "empty": "އަދި އައުޓްލެޓެއް ނެތް. ޓާމިނަލަކަށް ވިޔަފާރިކުރެވޭނެ ތަނެއް ދިނުމަށް އެއް އުފައްދަވާ.",
      "loadFailed": "އައުޓްލެޓްތައް ލޯޑެއް ނުކުރެވުނު.",
      "saved": "އައުޓްލެޓް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "އައުޓްލެޓް ރައްކާއެއް ނުކުރެވުނު.",
      "noWarehouse": "ނެތް",
      "noPriceSet": "ނެތް",
      "noWarehouseWarning": "މި އައުޓްލެޓަށް ގުދަނެއް ނެތުމުން ސެޓްލްކުރެވޭ ވިޔަފާރިއަކުން ސްޓޮކް ނުއުޅޭ. ޚިދުމަތް އެކަނި ދޭ ކައުންޓަރަކަށް އެއީ ރަނގަޅު، އެހެން ތަނަކަށް އެއީ ސްޓޮކް މަދުވުމުގެ ސިއްރު މައްސަލައެއް.",
      "locationHint": "އައުޓްލެޓަކީ ތަނެއް: ތަނުން އޭގެ ޓެކްސް ސަރަޙައްދު ކަނޑައެޅި، އޮޕަރޭޓިން ދުވަސް ގުޅުވޭ.",
      "channelHint": "ދިވެހިރާއްޖޭގެ ޕެކުން pos ޗެނަލް ހަދަނީ ޓެކްސް ހިމެނޭ ގޮތަށް. ކުންފުނީގެ ޑިފޯލްޓްގައި ހުންނަ އައުޓްލެޓަކުން ކޮންމެ ލައިނެއްގައި އަގު ތަފާތުވާނެ.",
      "warehouseHint": "ސެޓްލްކުރެވޭ ވިޔަފާރިއަކުން މަދުވާ ސްޓޮކް. ސްޓޮކް ނުވިއްކާ ކައުންޓަރަކަށް އެކަނި ހުސްކޮށް ބަހައްޓަވާ.",
      "roundingHint": "ސުމެއް ދިނުމުން ރައުންޑިން ނުހިނގާ. ރައުންޑްކުރަނީ ސާވަރ، މި ފޯމަކުން ނޫން."
    },
    "terminals": {
      "title": "ޓާމިނަލްތައް",
      "description": "މި އައުޓްލެޓްގެ ދަށުގައިވާ ޓިލް މަގާމުތަކާއި، ކޮންމެއަކާ ގުޅިފައިވާ ޑިވައިސް.",
      "caption": "ޓާމިނަލްތަކާއި އޭގެ އޮފްލައިން ޕޮލިސީ، ކޮންޓެންޓް އުމުރު ލިމިޓް އަދި އެންރޯލްކުރެވިފައިވާ ޑިވައިސް.",
      "create": "އައު ޓާމިނަލް",
      "edit": "ޓާމިނަލް އިސްލާޙުކުރުން",
      "dialogDescription": "އޮފްލައިން ދެ ފީލްޑުން މި ޓިލްއަށް ސާވަރ ނެތި ވިޔަފާރިކުރެވޭނެތޯއާއި ކިހާ ވަގުތެއްކަން ކަނޑައެޅޭ.",
      "empty": "އަދި ޓާމިނަލެއް ނެތް. ޓާމިނަލަކީ ޓިލް މަގާމެއް، ޑިވައިސްއަކީ ކައުންޓަރުގައި ހުންނަ ޓެބްލެޓް.",
      "loadFailed": "ޓާމިނަލްތައް ލޯޑެއް ނުކުރެވުނު.",
      "saved": "ޓާމިނަލް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޓާމިނަލް ރައްކާއެއް ނުކުރެވުނު.",
      "offlineEnabled": "އޮފްލައިންގައި ވިޔަފާރިކުރެވޭ",
      "offlineHint": "މި ނިއްވާލެވިފައިވާނަމަ، ސާވަރއާ ގުޅުން ކެނޑޭ ޓާމިނަލުން ވިއްކުމުގެ ބަދަލުގައި ބްލޮކިން ސްކްރީން ދައްކާނެ.",
      "contentMaxAge": "ކޮންޓެންޓް އުމުރު ލިމިޓް (ގަޑިއިރު)",
      "contentMaxAgeHint": "މި އުމުރު ފަހަނައަޅައި ދިއުމުން ކޭޝްކުރެވިފައިވާ ކޮންޓެންޓް މުއްދަތު ހަމަވެ، ޓާމިނަލް ވިޔަފާރި ހުއްޓާލާނެ.",
      "cashAccountHint": "ޑްރޯވަރގެ އަމިއްލަ ޖީއެލް އެކައުންޓް. ހުސްކޮށް ބެހެއްޓުމުން ކުންފުނީގެ ކޭޝް-އޮން-ހޭންޑް އެކައުންޓަށް ރުޖޫޢަވޭ.",
      "device": "ޑިވައިސް",
      "noDevice": "އެންރޯލްނުކުރެވޭ",
      "lastSeen": "އެންމެ ފަހުން ފެނުނީ",
      "highWater": "ސިންކް ހައި-ވޯޓަރ",
      "fleetNote": "އޮފްލައިން ހުއްދަ ދެވިފައިވާ ޓާމިނަލެއްގެ ޑިވައިސް ދުވަސްތަކެއް ވަންދެން ނުފެންނަނަމަ، އެ ވިއްކަނީ މުއްދަތު ހަމަވެފައިވާ ކޮންޓެންޓުން."
    },
    "settings": {
      "title": "ޕީއޯއެސް ސެޓިންގްސް",
      "description": "ދުވަސް ބަންދުކުރުމުން ޕޯސްޓްކުރެވޭ އެކައުންޓްތަކާއި، އޮޕަރޭޓަރެއްގެ ދުވަސް މިނާ ތްރެޝްހޯލްޑްތައް.",
      "accountsTitle": "އެކައުންޓްތައް",
      "accountsDescription": "މީގެ ކޮންމެއެއްޗަކީ ނެތިއްޔާ ފެއިލްވާ ޕޯސްޓިންގއެއް. ދުވަސް ބަންދުކުރުމުން ނަން ބުނެ ދޫކޮށްލާނެ.",
      "thresholdsTitle": "ވިންޑޯތަކާއި ތްރެޝްހޯލްޑްތައް",
      "thresholdsDescription": "ކޮންފިގަރޭޝަން މިތާ، ފެނުނު ކަންކަން އެނޯމަލީ ބޯޑްގައި. ބޯޑް ކިޔާ މީހަކަށް އެ މީހާ މިނާ ރޮނގު ބަދަލުކުރެވިގެން ނުވާނެ.",
      "chooseCompany": "ކުންފުންޏެއް ޚިޔާރުކުރައްވާ. ޕީއޯއެސް ސެޓިންގްސް ހުންނަނީ ކުންފުނިން ކުންފުންޏަށް.",
      "loadFailed": "ސެޓިންގްސް ލޯޑެއް ނުކުރެވުނު.",
      "saved": "ސެޓިންގްސް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ސެޓިންގްސް ރައްކާއެއް ނުކުރެވުނު.",
      "missingAccounts": "ދުވަސް ބަންދުކުރުމަށް ބޭނުންވާ {count} އެކައުންޓް އަދި ކަނޑައެޅިފައި ނުވޭ.",
      "rowVersionNote": "ރައްކާކުރުމުގައި ރޯ ވަރޝަން ގެންދާތީ، އެއްފަހަރާ ދެ މީހަކު އިސްލާޙުކުރުމުން ސިއްރު ބަދަލެއްގެ ބަދަލުގައި ކޮންފްލިކްޓެއް އަންނާނެ.",
      "cashOnHand": "ކޭޝް އޮން ހޭންޑް",
      "cashOnHandHint": "ޓިލްއާއި ބޭންކާ ދެމެދު ޑްރޯވަރ ފައިސާ ހުންނަ ތަން.",
      "cashOverShort": "ފައިސާ އިތުރު އަދި މަދު",
      "cashOverShortHint": "ބަލައިގަނެވުނު ގުނުމުގެ ތަފާތު ޕޯސްޓްވާ ތަން.",
      "defaultRevenue": "ޑިފޯލްޓް އާމްދަނީ",
      "defaultRevenueHint": "ރެވެނިއު ސެންޓަރަކަށް އަމިއްލަ އެކައުންޓެއް ނުލިބޭ ހާލަތުގައި ބޭނުންކުރެވޭ.",
      "cardClearing": "ކާޑް ކްލިއަރިން",
      "giftCardLiability": "ގިފްޓް ކާޑް ލައިބިލިޓީ",
      "storeCreditLiability": "ސްޓޯ ކްރެޑިޓް ލައިބިލިޓީ",
      "customerDepositLiability": "ކަސްޓަމަރ ޑިޕޮސިޓް ލައިބިލިޓީ",
      "tipPayable": "ޓިޕް ދައްކަންޖެހޭ",
      "cashRoundingAccount": "ކޭޝް ރައުންޑިން",
      "defaultRounding": "ޑިފޯލްޓް ކޭޝް ރައުންޑިން",
      "defaultRoundingHint": "އައުޓްލެޓަށް މި ބަދަލުކުރެވޭ. ސުމަކުން ރައުންޑިން ނުހިނގާ.",
      "voidWindow": "ބާޠިލްކުރުމުގެ ވިންޑޯ (މިނެޓް)",
      "voidWindowHint": "ސެޓްލްކުރުމަށްފަހު ވިޔަފާރިއެއް ބާޠިލްކުރެވޭނެ މުއްދަތު. އެއަށްފަހު ދޫކޮށްލެވެނީ ERR_POS_VOID_WINDOW_ELAPSED އިން.",
      "voidRate": "ބާޠިލްކުރުމުގެ ރޭޓް ތްރެޝްހޯލްޑް (%)",
      "discountRate": "ޑިސްކައުންޓް ރޭޓް ތްރެޝްހޯލްޑް (%)",
      "refundRate": "ފައިސާ އަނބުރާ ރޭޓް ތްރެޝްހޯލްޑް (%)",
      "noSaleCount": "ނޯ ސޭލް އަދަދު ތްރެޝްހޯލްޑް",
      "noLegalEntity": "ތިބާއަށް ލީގަލް އެންޓިޓީއެއް ލިބިފައިނުވާތީ، ދައްކާނެ ޕޮއިންޓް އޮފް ސޭލް ސެޓިންގްސެއް ނެތް. އެޑްމިނިސްޓްރޭޓަރަކާ ގުޅުއްވާ."
    },
    "tenderTypes": {
      "title": "ޓެންޑަރ ބާވަތްތައް",
      "description": "ކަސްޓަމަރަށް ފައިސާ ދެއްކޭނެ ގޮތްތަކާއި، ކޮންމެ ބާވަތެއް ކްލިއަރވާ ތަން.",
      "caption": "ޓެންޑަރ ބާވަތްތަކާއި އޭގެ ބާވަތް، ކްލިއަރިން އެކައުންޓް އަދި ސާޗާޖް.",
      "create": "އައު ޓެންޑަރ ބާވަތް",
      "edit": "ޓެންޑަރ ބާވަތް އިސްލާޙުކުރުން",
      "dialogDescription": "ކްލިއަރިން އެކައުންޓަކީ ނެތިއްޔާ ދުވަސް ބަންދުކުރުން ފެއިލްވާ ފީލްޑް.",
      "empty": "އަދި ޓެންޑަރ ބާވަތެއް ނެތް. އެއްވެސް ބާވަތެއް ނެތް ޓިލްއަކަށް ފައިސާ ނުނެގޭނެ.",
      "saved": "ޓެންޑަރ ބާވަތް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޓެންޑަރ ބާވަތް ރައްކާއެއް ނުކުރެވުނު.",
      "clearingAccount": "ކްލިއަރިން އެކައުންޓް",
      "clearingAccountHint": "ދުވަސް ބަންދުކުރުމުން މި ޓެންޑަރ ކްލިއަރވާ ތަން. ފައިސާ ޑްރޯވަރއަށް، އެހެން ކޮންމެ ބާވަތަކަށް އެކައުންޓެއް ބޭނުންވޭ.",
      "noClearingAccount": "ކަނޑައެޅިފައި ނުވޭ",
      "clearingNote": "ކްލިއަރިން އެކައުންޓެއް ނެތް ޓެންޑަރ ބާވަތަކުން މުޅި ދުވަސް ބަންދުކުރުން ދޫކޮށްލާނެ.",
      "clearingWarning": "މި ބާވަތް ކްލިއަރވަނީ ޑްރޯވަރއަށް ނޫން، އެކައުންޓަކަށް. އެއް ނެތްނަމަ ދުވަސް ބަންދުކުރުން ދޫކޮށްލެވެނީ ERR_POS_TENDER_ACCOUNT_UNSET އިން.",
      "surcharge": "ސާޗާޖް (%)",
      "surchargeHint": "ދެއްކުނު އަދަދުގެ މައްޗަށް، ކަސްޓަމަރަށް ފެންނަ ލައިނެއްގެ ގޮތުގައި.",
      "opensDrawer": "ކޭޝް ޑްރޯވަރ ހުޅުވާ",
      "allowsChange": "ބާކީ ދެވޭ",
      "allowsPartial": "ވިޔަފާރިއެއްގެ ބައެއް ދެއްކޭ",
      "allowsRefund": "މިއަށް ފައިސާ އަނބުރާ ދެވޭ"
    },
    "denominations": {
      "title": "ފައިސާގެ ބާވަތްތައް",
      "description": "ބްލައިންޑް ކައުންޓް ޝީޓް ބިނާވާ ނޫޓާއި ފައިސާ ފޮތި.",
      "caption": "ފައިސާގެ ބާވަތްތަކާއި އޭގެ އަގު، ބާވަތް އަދި ޝީޓް ތަރުތީބު.",
      "faceValue": "ފޭސް ވެލިއު",
      "sortOrder": "ޝީޓް ތަރުތީބު",
      "add": "ބާވަތެއް އިތުރުކުރުން",
      "none": "ބާވަތްތަކެއް ކަނޑައެޅިފައި ނުވޭ.",
      "emptyWarning": "ބާވަތްތަކެއް ކަނޑައެޅިފައި ނުވާތީ ކައުންޓް ޝީޓަކީ ހަމައެކަނި ލިޔާ ފޮއްޓެއް — އަދި އެއީ ގުނުމެއް ނޫން.",
      "note": "ގުނާ މީހާ ބުނަނީ ފަންސާހުގެ ނަވާރަ ނޫޓް، ނުވަ ސަތޭކަ ފަންސާހެއް ނޫން. ފުރަތަމަ ބުނުން ޑްރޯވަރއާ އަޅާކިޔޭ.",
      "loadFailed": "ބާވަތްތައް ލޯޑެއް ނުކުރެވުނު.",
      "saved": "ބާވަތްތައް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ބާވަތްތައް ރައްކާއެއް ނުކުރެވުނު."
    },
    "policies": {
      "title": "އޮފްލައިން ހުއްދައިގެ ޕޮލިސީ",
      "description": "ސުވާލުކުރެވެން ނެތް ވަގުތު ޓާމިނަލަށް ނިންމިދާނެ ކަންކަން.",
      "caption": "އޮފްލައިން ޕޮލިސީތަކާއި އޭގެ ލިމިޓާއި އަމަލުކުރަން ފަށާ ތާރީޚް.",
      "control": "ކޮންޓްރޯލް",
      "policy": "ޕޮލިސީ",
      "limitAmount": "އަދަދުގެ ލިމިޓް",
      "limitPercent": "އިންސައްތަ ލިމިޓް",
      "limitCount": "ޢަދަދު ލިމިޓް",
      "effectiveFrom": "އަމަލުކުރަން ފަށާ ތާރީޚް",
      "effectiveFromHint": "މި ސެޓް ފެށޭ ތާރީޚް ޚިޔާރުކުރައްވާ. މިއަދުން ފެށޭ ސެޓެއް ރައްކާކުރުމުން ޝިފްޓް މެދުތެރެއިން ހިނގަމުންދާ ސެޓް ބަދަލުވާނެ.",
      "appliesFromBelow": "ތިރީގައިވާ ތާރީޚުން ފެށިގެން",
      "notConfigured": "ކަނޑައެޅިފައި ނުވޭ",
      "unconfiguredMeansRefuse": "ރޯއެއް ނެތް ކޮންޓްރޯލެއް ދޫކޮށްލެވޭ. އޮފްލައިންގައި ކަނޑައެޅިފައި ނުވާ ކޮންޓްރޯލަކީ އެއްވެސް މީހަކު ގޮތެއް ނުނިންމާ ކޮންޓްރޯލެއް.",
      "absolute": "ބަދަލުނުކުރެވޭ",
      "absoluteLocked": "ބަދަލުނުކުރެވޭ — މިތާނގައި ބަދަލެއް ނުކުރެވޭނެ",
      "bindingNote": "މި ބައިންޑިންގއަށް ހުރި ރޯއަކުން ކުންފުނީގެ ޑިފޯލްޓް ބަދަލުކުރެވޭ، ހަނިވެގެންވާ ރޯ ކުރި ހޯދާ.",
      "reason": "ސަބަބު",
      "edit": "ޕޮލިސީ ބަދަލުކުރުން",
      "noPermission": "ތިޔަބޭފުޅާއަށް device.policy.manage ނެތުމުން އޮފްލައިން ޕޮލިސީ މިތާ ނުދައްކާ.",
      "loadFailed": "އޮފްލައިން ޕޮލިސީތައް ލޯޑެއް ނުކުރެވުނު.",
      "saved": "އޮފްލައިން ޕޮލިސީ ރައްކާކުރެވިއްޖެ",
      "saveFailed": "އޮފްލައިން ޕޮލިސީ ރައްކާއެއް ނުކުރެވުނު."
    },
    "devices": {
      "title": "ޑިވައިސް ފްލީޓް",
      "description": "އެންރޯލްކުރެވިފައިވާ ކޮންމެ ޑިވައިސްއެއް، އޭގައި ހުރި ކޮންޓެންޓް އަދި އެންމެ ފަހުން ޚަބަރު ލިބުނު ވަގުތު.",
      "tableTitle": "ޑިވައިސްތައް",
      "caption": "ޑިވައިސްތަކާއި އޭގެ ހާލަތު، ހުރި އަދި ޝާއިޢުކުރެވިފައިވާ ކޮންޓެންޓް ވަރޝަން، އަދި އެންމެ ފަހުގެ ގުޅުން.",
      "detailDescription": "އައިޑެންޓިޓީ، ވިޔަފާރީގެ ހާލަތު، ކޮންޓެންޓް އެސައިންމަންޓް އަދި ސިންކް ތާރީޚް.",
      "identityTitle": "އައިޑެންޓިޓީ",
      "tradingTitle": "މި ޑިވައިސްއަށް ވިޔަފާރިކުރެވޭތަ؟",
      "assignmentsTitle": "ކޮންޓެންޓް އެސައިންމަންޓް",
      "assignmentsCaption": "މި ޑިވައިސްއަށް ދެވިފައިވާ ކޮންޓެންޓް ސެޓްތަކާއި، އޭގައި ހުރި ވަރޝަނާއި ޝާއިޢުކުރެވިފައިވާ ވަރޝަން.",
      "assignmentsEmpty": "މި ޑިވައިސްއަށް ކޮންޓެންޓެއް ދެވިފައި ނުވާތީ ވިޔަފާރިއެއް ނުކުރެވޭނެ.",
      "batchesTitle": "ސިންކް ތާރީޚް",
      "batchesCaption": "މި ޑިވައިސްއިން ފޮނުވި ސިންކް ބެޗްތަކާއި، ހިނގި، އަލުން ހިނގި، ކޮންފްލިކްޓްވި އަދި ފެއިލްވި އަދަދު.",
      "batchesEmpty": "މި ޑިވައިސް އަދި ސިންކްކޮށްފައި ނުވޭ.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން",
      "empty": "އަދި ޑިވައިސްއެއް ނެތް. އެއް އުފައްދަވައި، އެއަށް އެންރޯލްމަންޓް ކޯޑެއް ދޫކުރައްވާ.",
      "loadFailed": "ޑިވައިސްތައް ލޯޑެއް ނުކުރެވުނު.",
      "legend": "ފަހަތުގައި ވުމުގެ މާނައަކީ އަދި ނުނަގާކަން. ހޭޝް ދިމާނުވުން މާ ނުރައްކާ: އޭގައި ހުރީ އެ ހޭޝް ބުނާ ޕޭލޯޑް ނޫން އެއްޗެއް.",
      "surface": "ސަރފޭސް",
      "binding": "ގުޅިފައިވަނީ",
      "held": "ހުރީ",
      "published": "ޝާއިޢުކުރެވުނު",
      "heldHash": "ހުރި ހޭޝް",
      "contentState": "ކޮންޓެންޓް",
      "reportedAt": "ރިޕޯޓްކުރި",
      "current": "މިހާރުގެ",
      "stale": "ބާވެފައި",
      "hashMismatch": "ހޭޝް ދިމައެއް ނުވޭ",
      "noContent": "ދެވިފައި ނުވޭ",
      "lastSeen": "އެންމެ ފަހުން ފެނުނީ",
      "lastSync": "އެންމެ ފަހު ސިންކް",
      "neverSeen": "ދުވަހަކުވެސް ނުފެނޭ",
      "queueDepth": "ކިޔޫގައިވާ މިއުޓޭޝަން",
      "hasActiveVersion": "ހަރަކާތްތެރި ކޮންޓެންޓް ވަރޝަނެއް އެބައޮތް",
      "hashVerified": "ހޭޝް ކަށަވަރުކުރެވިފައި",
      "validUntil": "ކޮންޓެންޓް ސައްޙަ މުއްދަތު",
      "contentMaxAge": "ކޮންޓެންޓް އުމުރު ލިމިޓް (ގަޑިއިރު)",
      "mayTrade": "މި ޑިވައިސްއަށް ވިޔަފާރިކުރެވޭނެ.",
      "mayNotTrade": "މި ޑިވައިސްއަށް ވިޔަފާރިއެއް ނުކުރެވޭނެ.",
      "installationId": "އިންސްޓޮލޭޝަން އައިޑީ",
      "attested": "އެޓެސްޓްކުރެވުނު ޕްލެޓްފޯމް",
      "mint": "އެންރޯލްމަންޓް ކޯޑް ދޫކުރުން",
      "mintFailed": "އެންރޯލްމަންޓް ކޯޑް ދޫނުކުރެވުނު.",
      "enrolTitle": "{code} އަށް އެންރޯލްމަންޓް ކޯޑް",
      "enrolDescription": "ޑިވައިސްއިން އެއްފަހަރު ދައްކާ، އޭގެ އަމިއްލަ ސިއްރު ހޯދާ ކޯޑެއް.",
      "enrolOnceWarning": "ކޯޑް ދައްކާނީ އެންމެ ފަހަރަކު، އަދި އަލުން ނުލިބޭނެ. ގެއްލިއްޖެނަމަ އައު ކޯޑެއް ދޫކުރައްވާ — އެއިން މި ކޯޑް ބާޠިލްވާނެ.",
      "enrolShownOnce": "މިއީ މި ކޯޑް ދައްކާ ހަމައެކަނި ފަހަރު. މިހާރު ޑިވައިސްއަށް ޖައްސަވާ.",
      "enrolExpires": "މުއްދަތު ހަމަވަނީ {at}",
      "suspend": "މަޑުޖައްސާލުން",
      "suspended": "ޑިވައިސް މަޑުޖައްސާލެވިއްޖެ",
      "revoke": "ބާޠިލްކުރުން",
      "revoked": "ޑިވައިސް ބާޠިލްކުރެވިއްޖެ",
      "revokeTitle": "މި ޑިވައިސް ބާޠިލްކުރުން",
      "revokeDescription": "ބާޠިލްކުރުމުން ގުޅުން ނިމޭ. މިއީ ޓެބްލެޓެއް އިމާރާތުން ބޭރުވުމުން ކުރާ ކަމެއް.",
      "revokeReason": "ސަބަބު",
      "revokedAt": "ބާޠިލްކުރި",
      "actionFailed": "ޑިވައިސް އަޕްޑޭޓެއް ނުކުރެވުނު.",
      "create": "އައު ޑިވައިސް",
      "createDescription": "ޑިވައިސްއެއް ރަޖިސްޓަރކުރައްވާ، އަދި އެ ޑިވައިސް އެންރޯލްވުމަށް ބޭނުންވާ އެއްފަހަރު ބޭނުންކުރެވޭ ކޯޑް ދޫކުރައްވާ.",
      "createPendingNote": "އައު ޑިވައިސްއެއް އުފެދެނީ 'ހުއްޓިފައި' ހާލަތުގައި: އެންރޯލްމަންޓް ކޯޑެއް ދޫކޮށް އެ ޑިވައިސްއަށް ޖަހަންދެން އެއަކަށް އެއްވެސް ކަމެއް ނުކުރެވޭނެ. މި ރައްކާކުރުމާއެކު ކޯޑް ދޫކުރުން ހުޅުވޭނެ.",
      "created": "ޑިވައިސް ރަޖިސްޓަރކުރެވިއްޖެ",
      "createFailed": "ޑިވައިސް ރަޖިސްޓަރއެއް ނުކުރެވުނު.",
      "companyPlaceholder": "ކުންފުންޏެއް ޚިޔާރުކުރައްވާ",
      "outletPlaceholder": "އައުޓްލެޓެއް ޚިޔާރުކުރައްވާ",
      "terminalPlaceholder": "ޓާމިނަލެއް ޚިޔާރުކުރައްވާ",
      "codeHint": "ކުންފުނީގެ ތެރޭގައި ތަފާތު ކޯޑެއް. ރައްކާކުރެވެނީ ބޮޑު އަކުރުން.",
      "surfaceHint": "ޕީއޯއެސް ބެކް އޮފީހުން ރަޖިސްޓަރކުރަނީ ޕީއޯއެސް ޑިވައިސްތައް. ހައުސްކީޕިން އަދި ފީލްޑް ސާވިސް ޑިވައިސްތައް ރަޖިސްޓަރކުރަނީ އެ މޮޑިއުލްތަކުން.",
      "bindingHint": "މި ޑިވައިސް ގުޅިފައިވާ އެއްޗެއް. ޓާމިނަލަކީ އެއް ކޭޝް ޕޮޒިޝަން؛ އައުޓްލެޓަކުން މުޅި ފްލޯ ހިމެނޭ.",
      "noTerminals": "މި އައުޓްލެޓްގައި އަދި ޓާމިނަލެއް ނެތް. އައުޓްލެޓް ޞަފްޙާއިން ޓާމިނަލެއް ހުޅުއްވާ، ނުވަތަ ޑިވައިސް އައުޓްލެޓާ ގުޅުއްވާ."
    },
    "roster": {
      "title": "{code} ގެ އޮޕަރޭޓަރ ރޯސްޓަރ",
      "description": "ސާވަރާ ގުޅުން ކެނޑިފައިވާއިރު މި ޓާމިނަލުން ސައިން އިން ކުރެވޭނެ މީހުންނާއި، ކިހާ ވަގުތަކަށްކަން.",
      "scopeNote": "ރޯސްޓަރ ޝާއިޢުކުރެވެނީ އެންމެ ޑިވައިސްއަކަށް. އޭގެ ވެރިފަޔަރ މަސައްކަތްކުރާނީ މި ޓާމިނަލުގައި އެކަނި.",
      "deviceScope": "ޑިވައިސް {code}",
      "operators": "އޮޕަރޭޓަރުން",
      "searchPlaceholder": "ނަން ނުވަތަ އީމެއިލް",
      "usersEmpty": "މި ހޯދުމާ ދިމާވާ ހަރަކާތްތެރި ބޭނުންވެރިއެއް ނެތް.",
      "validHours": "މުއްދަތު (ގަޑިއިރު)",
      "validHoursHint": "1 އާއި 168 އާ ދެމެދު. އޭގެ ފަހުން ރޯސްޓަރގެ މުއްދަތު ހަމަވެ، އޮފްލައިންކޮށް އެއްވެސް މީހަކު ސައިން އިން ނުކުރެވޭނެ.",
      "credentialWarning": "ޝާއިޢުކުރުމުން މި ޓާމިނަލަށް ސާވަރެއް ނެތި މި އޮޕަރޭޓަރުންގެ ޕިން ޗެކްކުރެވޭނެ ގޮތް ލިބޭ. ހަމައެކަނި މިތާ މަސައްކަތްކުރާ މީހުން ހިމަނުއްވާ.",
      "publish": "އޮޕަރޭޓަރ ރޯސްޓަރ ޝާއިޢުކުރުން",
      "published": "އޮޕަރޭޓަރ ރޯސްޓަރ ޝާއިޢުކުރެވިއްޖެ",
      "publishedNote": "ޝާއިޢުކުރެވިއްޖެ. ޕިން ވެރިފަޔަރތައް ދިޔައީ ހަމައެކަނި އެ ޑިވައިސްއަށް — މި ޖަވާބުގައި އެއެއް ނުހިމެނޭ، އަދި އަލުން ނުލިބޭނެ.",
      "publishFailed": "އޮޕަރޭޓަރ ރޯސްޓަރ ޝާއިޢެއް ނުކުރެވުނު.",
      "setPinsLink": "އޮޕަރޭޓަރ ޕިން ކަނޑައެޅުން",
      "rosterId": "ރޯސްޓަރ އައިޑީ",
      "versionNo": "ވަރޝަން",
      "contentHash": "ކޮންޓެންޓް ހޭޝް",
      "validUntil": "މުއްދަތު ހަމަވަނީ",
      "entryCount": "ހިމެނޭ އޮޕަރޭޓަރުން",
      "pinPartHint": "މަތީގައިވާ ރޯސްޓަރ އައިޑީ ބޭނުންކުރައްވައި، މި ރޯސްޓަރ ކޮންޓެންޓް ސެޓް ވަރޝަނެއްގައި operator_roster ބައެއްގެ ގޮތުގައި ހިމަނުއްވާ، އަދި އެ ވަރޝަން ޝާއިޢުކުރައްވާ.",
      "operator": "އޮޕަރޭޓަރ",
      "supervisor": "އޯވަރައިޑް ހުއްދަދެވޭ",
      "entriesCaption": "ޝާއިޢުކުރެވުނު ރޯސްޓަރގައި ހިމެނޭ އޮޕަރޭޓަރުންނާއި، އޯވަރައިޑް ހުއްދަދެވޭތޯ، އަދި ކޮންމެ މީހަކަށް ލިބިފައިވާ ހުއްދަތަކުގެ ޢަދަދު.",
      "entriesEmpty": "ޝާއިޢުކުރެވުނު ރޯސްޓަރގައި އޮޕަރޭޓަރެއް ނެތް."
    },
    "pins": {
      "title": "އޮޕަރޭޓަރ ޕިން",
      "description": "އޮފްލައިން ޓާމިނަލެއްގައި ވެސް މީހަކު ޖަހާ ޕިން ކަނޑައެޅުމާއި ފޮހެލުން.",
      "tableTitle": "ބޭނުންވެރިން",
      "caption": "ޓެނަންޓްގެ ބޭނުންވެރިންނާއި، ޕީއޯއެސް ޕިން ކަނޑައެޅުމާއި ފޮހެލުމުގެ ފިޔަވަޅުތައް.",
      "noStateNote": "މީހަކަށް ކުރިން ޕިނެއް ދެވިފައިވޭތޯ މިތަނުން ނުފެންނާނެ: އޭޕީއައި އިން ކްރެޑެންޝަލަކާ ބެހޭ އެއްވެސް އެއްޗެއް ނުދޭ. އޮޕަރޭޓަރ ރޯސްޓަރ ޝާއިޢުކުރާއިރު ޕިން ނެތް މީހުންގެ ނަން ބުނެދޭނެ.",
      "searchPlaceholder": "ނަން ނުވަތަ އީމެއިލް",
      "empty": "މި ހޯދުމާ ދިމާވާ ހަރަކާތްތެރި ބޭނުންވެރިއެއް ނެތް.",
      "loadFailed": "ބޭނުންވެރިން ލޯޑެއް ނުކުރެވުނު.",
      "setAction": "ޕިން ކަނޑައެޅުން",
      "clearAction": "ޕިން ފޮހެލުން",
      "setTitle": "{name} އަށް ޕިނެއް ކަނޑައަޅުއްވާ",
      "setDescription": "ދެ ފަހަރު ޖަހާ، އެއްފަހަރު ފޮނުވާ، އަދި ދެން ދުވަހަކުވެސް ނުދައްކާ.",
      "pinLabel": "އައު ޕިން",
      "pinHint": "{min} އާއި {max} ޢަދަދުގެ ދެމެދު. ހަމައެކަނި ޢަދަދު.",
      "confirmLabel": "ޕިން ޔަޤީންކުރައްވާ",
      "credentialWarning": "ވެވެންޏާ ޕިން ޖަހަންވާނީ އޮޕަރޭޓަރ އަމިއްލައަށް. އެހެން މީހަކު ޚިޔާރުކުރި ޕިނަކީ އެހެން މީހަކަށް އެނގޭ ޕިނެއް.",
      "digitsOnly": "ޕިނަކީ ހަމައެކަނި ޢަދަދު.",
      "tooShort": "ޕިނުގައި މަދުވެގެން {min} ޢަދަދު ހުންނަންވާނެ.",
      "tooLong": "ޕިނުގައި ގިނަވެގެން {max} ޢަދަދު ހުންނަންވާނެ.",
      "mismatch": "ދެ ޕިން އެއްގޮތެއް ނޫން.",
      "set": "ޕިން ކަނޑައެޅިއްޖެ",
      "setFailed": "ޕިން ކަނޑައެއް ނޭޅުނު.",
      "clearTitle": "{name} ގެ ޕިން ފޮހެލުން",
      "clearDescription": "ޕިން ފޮހެލެވެނީ، އެހެން ޕިނަކުން ބަދަލެއް ނުކުރެވޭ.",
      "clearWarning": "އައު ޕިނެއް ކަނޑައަޅަންދެން މި އޮޕަރޭޓަރަށް ޓާމިނަލަކުން ސައިން އިން ނުކުރެވޭނެ.",
      "cleared": "ޕިން ފޮހެލެވިއްޖެ",
      "clearFailed": "ޕިން ފޮހެއެއް ނުލެވުނު."
    },
    "contentSets": {
      "title": "ކޮންޓެންޓް ސެޓްތައް",
      "description": "ޓާމިނަލަކަށް ވިޔަފާރިކުރެވޭ، ނަން ދެވި، ވަރޝަންކުރެވި، ހޭޝްކުރެވިފައިވާ ބަންޑަލް.",
      "tableTitle": "ކޮންޓެންޓް ސެޓްތައް",
      "caption": "ކޮންޓެންޓް ސެޓްތަކާއި އޭގެ ސަރފޭސް އަދި ބައިންޑިން.",
      "detailTitle": "ކޮންޓެންޓް ސެޓް #{id}",
      "detailDescription": "ވަރޝަންތައް، ބައިތައް، ޝާއިޢުކުރުމުގެ ޗެކްތައް އަދި އެ ހިފަހައްޓާ ފްލީޓް.",
      "create": "އައު ކޮންޓެންޓް ސެޓް",
      "dialogDescription": "ސެޓަކުން އަގު ސެޓް ވަރޝަން، ޓެކްސް ޕެކް، މެނޫ ވަރޝަން އަދި ރޯސްޓަރ އެއްކުރެވޭ. ބައިންޑިންގއިން ކާކަށްކަން ބުނެދޭ.",
      "empty": "އަދި ކޮންޓެންޓް ސެޓެއް ނެތް. އެއްވެސް ސެޓެއް ނެތް ޓާމިނަލަކަށް ވިޔަފާރިއެއް ނުކުރެވޭނެ.",
      "loadFailed": "ކޮންޓެންޓް ސެޓްތައް ލޯޑެއް ނުކުރެވުނު.",
      "saved": "ކޮންޓެންޓް ސެޓް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ކޮންޓެންޓް ސެޓް ރައްކާއެއް ނުކުރެވުނު.",
      "actionFailed": "މި ޢަމަލު ފުރިހަމައެއް ނުކުރެވުނު.",
      "binding": "ބައިންޑިން",
      "bindingCompany": "މުޅި ކުންފުނި",
      "bindingOutlet": "އެއް އައުޓްލެޓް",
      "bindingTerminal": "އެއް ޓާމިނަލް",
      "bindingId": "ބައިންޑިން އައިޑީ",
      "bindingHint": "އައުޓްލެޓަކަށް ނުވަތަ ޓާމިނަލަކަށް ގުޅިފައިވާ ސެޓަކުން ކުންފުނީގެ ސެޓް ބަދަލުކުރެވޭ. ހަނިވެގެންވާ ސެޓް ކުރި ހޯދާ.",
      "set": "ސެޓް",
      "versionsTitle": "ވަރޝަންތައް",
      "version": "ވަރޝަން",
      "versionLabel": "ވަރޝަން {no} — {status}",
      "newVersion": "އައު ދެލިކޮޕީ ވަރޝަން",
      "versionCreated": "ދެލިކޮޕީ ވަރޝަން އުފެދިއްޖެ",
      "noVersions": "މި ސެޓަށް އަދި ވަރޝަނެއް ނެތް. ދެލިކޮޕީއެއް އުފައްދައި، ބައިތައް ލައި، ދެން ޝާއިޢުކުރައްވާ.",
      "hash": "ކޮންޓެންޓް ހޭޝް",
      "noHashYet": "އަދި ހޭޝްކުރެވިފައި ނުވޭ",
      "validity": "ސައްޙަ",
      "publishedAt": "ޝާއިޢުކުރި",
      "partsTitle": "ބައިތައް",
      "partsCaption": "މި ވަރޝަނުގައިވާ ބައިތަކާއި، ކޮންމެ އެއްޗެއްގެ ވަރޝަނާއި ހޭޝް.",
      "partsEmpty": "މި ވަރޝަނުގައި ބައެއް ނެތް. ބައިތަކެއް ނެތް ކޮންޓެންޓް ސެޓަކީ ކޮންޓެންޓް ސެޓެއް ނޫން.",
      "partsSaved": "ބައިތައް ރައްކާކުރެވިއްޖެ",
      "partKind": "ބައިގެ ބާވަތް",
      "addPart": "ބައެއް އިތުރުކުރުން",
      "refId": "ރެފަރެންސް",
      "refVersion": "ރެފަރެންޓް ވަރޝަން",
      "refHash": "ރެފަރެންޓް ހޭޝް",
      "seq": "ނަންބަރު",
      "checksTitle": "ޝާއިޢުކުރުމުގެ ޗެކްތައް",
      "checksDescription": "ޝާއިޢުނުކޮށް ހިންގޭ، އެއިން ހުރިހާ މައްސަލައެއް އެއްފަހަރާ ހައްލުކުރެވޭ ގޮތަށް.",
      "checkOk": "ހަތަރު ޗެކްވެސް ފާސްވެއްޖެ. މި ވަރޝަން ޝާއިޢުކުރެވިދާނެ.",
      "checkNotOk": "މި ވަރޝަން އަދި ޝާއިޢެއް ނުކުރެވޭނެ. ހުރިހާ ކަމެއް ތިރީގައި.",
      "checkFailed": "ޝާއިޢުކުރުމުގެ ޗެކްތައް ނުހިންގުނު.",
      "crossChecksSkipped": "ނުހިނގާ: ކްރޮސް-ޗެކްތައް ހިނގަނީ ބިނާގެ ޗެކްތައް ފާސްވުމުން.",
      "missingKinds": "ބޭނުންވާ އަދި ނެތް ބައިގެ ބާވަތްތައް:",
      "findingsCaption": "ޝާއިޢުކުރުމުގެ ހުރިހާ ފެނުމަކާއި، އެ ފެނުނު ޗެކަރ.",
      "checker": "ޗެކަރ",
      "findingCode": "ކޯޑް",
      "findingRef": "ރެފަރެންސް",
      "noFindings": "އެއްވެސް ކަމެއް ނުފެނުނު.",
      "publishTitle": "ޝާއިޢުކުރުން",
      "publish": "ޝާއިޢުކުރުން",
      "published": "ވަރޝަން ޝާއިޢުކުރެވިއްޖެ",
      "publishNote": "ޝާއިޢުކުރުމުން ކޮންޓެންޓް ހޭޝް ސްޓޭމްޕްކުރެވޭ. ޓާމިނަލުން ވިޔަފާރިކުރުމުގެ ކުރިން އެ ހޭޝް ކަށަވަރުކުރޭ.",
      "publishHashNote": "ހޭޝް ހިސާބުކުރެވެނީ ޝާއިޢުކުރާއިރު، ރެފަރެންޓްތަކުގެ އަމިއްލަ ވަރޝަނުން — ކްލައިންޓް ފޮނުވި އެއްޗަކުން ނޫން.",
      "validFrom": "ސައްޙަވާ ފެށޭ",
      "validUntil": "ސައްޙަވާ ނިމޭ",
      "validUntilHint": "މި ވަގުތަށްފަހު ކޮންޓެންޓް މުއްދަތު ހަމަވެ، އެ ހިފަހައްޓާ ޓާމިނަލްތައް ވިޔަފާރި ހުއްޓާލާނެ.",
      "withdraw": "އަނބުރާ ގެނައުން",
      "withdrawn": "ވަރޝަން އަނބުރާ ގެނެވިއްޖެ",
      "matrixTitle": "އެސައިންމަންޓް މެޓްރިކްސް",
      "matrixDescription": "މި ސެޓްގެ ކޮން ވަރޝަނެއް ކޮން ޑިވައިސްއެއްގައިކަން.",
      "matrixCaption": "މި ސެޓް ދެވިފައިވާ ޑިވައިސްތަކާއި، ކޮންމެއެއްގައި ހުރި ވަރޝަން.",
      "matrixEmpty": "މި ސެޓް އެއްވެސް ޑިވައިސްއަކަށް ދެވިފައި ނުވޭ."
    },
    "menus": {
      "title": "މެނޫތައް",
      "description": "ދުވަހުގެ ބަޔަކާއެކު ކެޓަލޮގެއް. ހެނދުނުގެ ނާސްތާއާއި ރޭގަނޑުގެ ކެއުމަކީ ދެ މެނޫ.",
      "tableTitle": "މެނޫތައް",
      "caption": "މެނޫތަކާއި މިހާރު ޝާއިޢުކުރެވިފައިވާ ވަރޝަނާއި އޭގެ މުއްދަތު.",
      "create": "އައު މެނޫ",
      "dialogDescription": "މެނޫ ނިސްބަތްވަނީ އެއް އައުޓްލެޓަށް، އަގު ސެޓާއި ޓެކްސް ޗެނަލާއި ގުދަން އެ އައުޓްލެޓްގެ ކަމަށްވާތީ.",
      "chooseOutlet": "މެނޫތައް ބެލުމަށް އައުޓްލެޓެއް ޚިޔާރުކުރައްވާ.",
      "empty": "މި އައުޓްލެޓަށް އަދި މެނޫއެއް ނެތް.",
      "loadFailed": "މެނޫތައް ލޯޑެއް ނުކުރެވުނު.",
      "saved": "މެނޫ ރައްކާކުރެވިއްޖެ",
      "saveFailed": "މެނޫ ރައްކާއެއް ނުކުރެވުނު.",
      "actionFailed": "މި ޢަމަލު ފުރިހަމައެއް ނުކުރެވުނު.",
      "dayPart": "ދުވަހުގެ ބައި",
      "dayPartHint": "މި މެނޫ ނިސްބަތްވާ އޮޕަރޭޓިން ދުވަހުގެ ބައި، އޮތްނަމަ.",
      "channelHint": "އައުޓްލެޓްގެ ޗެނަލް ބޭނުންކުރުމަށް ހުސްކޮށް ބަހައްޓަވާ.",
      "publishedVersion": "ޝާއިޢުކުރެވުނު ވަރޝަން",
      "noPublishedVersion": "ނެތް",
      "draftOnly": "ދެލިކޮޕީ އެކަނި",
      "versionTitle": "މެނޫ ވަރޝަން {no}",
      "versionDescription": "ސެކްޝަން، އައިޓަމް، މޮޑިފަޔަރ ގްރޫޕް، އަދި ފުރިހަމައަށް ޝާއިޢުކުރުމުގެ ގޭޓް.",
      "itemCount": "އައިޓަމް",
      "gateTitle": "ޝާއިޢުކުރުމުގެ ގޭޓް",
      "gateDescription": "ޝާއިޢުނުކޮށް ހިންގޭ. ހުރިހާ މައްސަލައެއް ދައްކާތީ މެނޫ އެއްފަހަރާ ރަނގަޅުކުރެވޭ.",
      "gateReady": "މި ވަރޝަން ޝާއިޢުކުރެވިދާނެ.",
      "gateNotReady": "މި ވަރޝަން ޝާއިޢެއް ނުކުރެވޭނެ: ތިރީގައި {count} މައްސަލަ.",
      "checkFailed": "ޝާއިޢުކުރުމުގެ ގޭޓް ނުހިންގުނު.",
      "checkPassed": "ރަނގަޅުކުރަން ޖެހޭ އެއްޗެއް ނެތް.",
      "checkOffenders": "ރަނގަޅުކުރަން {count}",
      "unpricedHeading": "{count} އައިޓަމަށް އަގެއް ނެތް",
      "unpricedExplanation": "އަގު ނެތް އައިޓަމަކީ ޓިލްގައި އެއްވެސް ކަމެއް ނުކުރާ ބަޓަނެއް. ހުރިހާއެއްޗެއް ދައްކަނީ، އެގާރައިން އެކަތި ބުނުމަކީ ޚިދުމަތުގެ ކުރިން ނެތް ވަގުތެއް ބޭކާރުކުރުމަށްވާތީ.",
      "unpricedCaption": "އަގެއް ނުލިބޭ މެނޫ އައިޓަމްތައް.",
      "offendersCaption": "މި ވަރޝަނުގެ ޝާއިޢުކުރުމުގެ ގޭޓުން ފެނުނު ހުރިހާ ކަމެއް.",
      "noOffenders": "އެއްވެސް ކަމެއް ނުފެނުނު.",
      "check": "ޗެކް",
      "section": "ސެކްޝަން",
      "menuItem": "މެނޫ އައިޓަމް",
      "itemId": "އައިޓަމް",
      "group": "ގްރޫޕް",
      "publish": "ޝާއިޢުކުރުން",
      "published": "މެނޫ ވަރޝަން ޝާއިޢުކުރެވިއްޖެ",
      "withdraw": "އަނބުރާ ގެނައުން",
      "withdrawn": "މެނޫ ވަރޝަން އަނބުރާ ގެނެވިއްޖެ",
      "contentTitle": "ސެކްޝަނާއި އައިޓަމް",
      "sectionCaption": "{name} ގައިވާ އައިޓަމްތައް.",
      "sectionsEmpty": "މި ވަރޝަނުގައި އަދި ސެކްޝަނެއް ނެތް.",
      "seq": "ނަންބަރު",
      "displayName": "ދައްކާ ނަން",
      "qtyPerPress": "ފިއްތުމަކަށް ޢަދަދު",
      "flags": "ފްލެގް",
      "modifierGroups": "މޮޑިފަޔަރ ގްރޫޕް",
      "ageCheck": "އުމުރު {age}+",
      "serial": "ސީރިއަލް",
      "unavailable": "ނުލިބޭ"
    },
    "availability": {
      "title": "86 ބޯޑް",
      "description": "ބަދިގެއިން ހުސްވެފައިވާ އެއްޗެއްސާއި، އަލުން ލިބޭނެ ވަގުތު.",
      "tableTitle": "ލިބުން",
      "caption": "އައިޓަމް ލިބުމާއި، ބާކީ ޢަދަދާއި، ސަބަބާއި ވިންޑޯ.",
      "chooseOutlet": "86 ބޯޑް ބެލުމަށް އައުޓްލެޓެއް ޚިޔާރުކުރައްވާ.",
      "empty": "މި އައުޓްލެޓްގައި 86 ކުރެވިފައި ނުވަތަ މަދުވެފައި އެއްޗެއް ނެތް.",
      "loadFailed": "86 ބޯޑް ލޯޑެއް ނުކުރެވުނު.",
      "set": "ލިބުން ކަނޑައެޅުން",
      "dialogDescription": "86 ގެ މާނައަކީ ބަދިގެއިން ހުސްވުން. ވިންޑޯއަކީ އަމިއްލައަށް އަލުން ލިބޭ ވަގުތު.",
      "saved": "ލިބުން ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ލިބުން ރައްކާއެއް ނުކުރެވުނު.",
      "restore": "އަނބުރާ ގެނައުން",
      "restored": "އައިޓަމް އަލުން ލިބެން ފަށައިފި",
      "remaining": "ބާކީ",
      "reason": "ސަބަބު",
      "window": "ވިންޑޯ",
      "until": "އަލުން ލިބޭނީ",
      "untilHint": "ހުސްކޮށް ބެހެއްޓުމުން، މީހަކު އަނބުރާ ގެންނަންދެން އައިޓަމް ނިވިފައި ހުންނާނެ.",
      "untilRestored": "އަތުން އަނބުރާ ގެންނަންދެން",
      "openEndedWarning": "{count} އައިޓަމް 86 ކުރެވިފައި ވިންޑޯއެއް ނެތި، އެހެންކަމުން މީހަކު އަނބުރާ ގެންނަންދެން ނިވިފައި ހުންނާނެ.",
      "untilTime": "ވަގުތު"
    },
    "sales": {
      "title": "ޕީއޯއެސް ވިޔަފާރި",
      "description": "ކޮންމެ ވިޔަފާރިއަކާއި ފައިސާ އަނބުރާ ދިނުމެއް، އޭގެ ފަހަތުގައިވާ އަގާއި ސްޓޮކް ހަރަކާތާއެކު.",
      "tableTitle": "ވިޔަފާރި",
      "caption": "ޕީއޯއެސް ވިޔަފާރިތަކާއި ސާވަރުން ހިސާބުކުރި ނެޓް، ޓެކްސް އަދި ޖުމުލަ.",
      "detailDescription": "ހެޑަރ، ލައިންތައް، އަގުގެ ވޯޓަރފޯލް އަދި ސްޓޮކް މަދުވުމުގެ ރަން.",
      "headerTitle": "ވިޔަފާރި",
      "totalsTitle": "ޖުމުލަ",
      "totalsAreServerFigures": "މިތާނގައިވާ ކޮންމެ ޢަދަދެއް ހިސާބުކުރީ ސާވަރުން، ޕޯސްޓިން ޓްރާންސެކްޝަނުގެ ތެރޭގައި. މި ސްކްރީނުން އެއްވެސް އެއްޗެއް އެއްނުކުރޭ.",
      "chooseCompany": "ވިޔަފާރިތައް ބެލުމަށް ކުންފުންޏެއް ޚިޔާރުކުރައްވާ.",
      "empty": "މި ފިލްޓަރތަކާ ދިމާވާ ވިޔަފާރިއެއް ނެތް.",
      "loadFailed": "ވިޔަފާރިތައް ލޯޑެއް ނުކުރެވުނު.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ވިޔަފާރި ނުވަތަ ރަސީދު ނަންބަރު",
      "unclosedOnly": "ޕޯސްޓްކުރެވުނު ދުވަސް ބަންދުގެ ތެރޭގައި އަދި ނުހިމެނޭ ވިޔަފާރި އެކަނި",
      "saleNo": "ވިޔަފާރި",
      "receiptNo": "ރަސީދު",
      "operator": "އޮޕަރޭޓަރ",
      "device": "ޑިވައިސް",
      "localSeq": "ލޯކަލް ތަރުތީބު {seq}",
      "unnumbered": "ވިޔަފާރި #{id}",
      "channelMode": "ޗެނަލް",
      "priceBasis": "އަގުގެ ބިނާ",
      "superseded": "ބަދަލުވެފައިވާ ސެޓް",
      "currentPricing": "މިހާރުގެ",
      "supersededExplanation": "މި ވިޔަފާރީގެ އަގު ނެގުނީ ފަހުން ބަދަލުކުރެވުނު އަގު ސެޓަކުން. އެއީ ގޯހެއް ނޫން — އެއީ ބަޔާންކުރެވޭ ކަމެއް، އަދި މިއީ އެ ބަޔާން.",
      "voidReason": "ބާޠިލްކުރި ސަބަބު",
      "voidedLine": "ބާޠިލްކުރެވިފައި",
      "net": "ނެޓް",
      "tax": "ޓެކްސް",
      "gross": "ޖުމުލަ",
      "discount": "ޑިސްކައުންޓް",
      "serviceCharge": "ސާވިސް ޗާޖް",
      "tip": "ޓިޕް",
      "rounding": "ރައުންޑިން",
      "tendered": "ދެއްކުނު",
      "change": "ބާކީ",
      "pricing": "އަގު",
      "dayCloseLink": "ދުވަސް ބަންދު",
      "sessionLink": "ކޭޝް ސެޝަން",
      "linesTab": "ލައިންތައް",
      "pricingTab": "އަގުގެ ވޯޓަރފޯލް",
      "depletionTab": "ސްޓޮކް މަދުވުން",
      "linesCaption": "ސާވަރުން ހިސާބުކުރި ޢަދަދުތަކާއެކު ވިޔަފާރީގެ ލައިންތައް.",
      "linesEmpty": "މި ވިޔަފާރީގައި ލައިނެއް ނެތް.",
      "lineNo": "ނަންބަރު",
      "lineGross": "ޖުމުލަ",
      "quantity": "ޢަދަދު",
      "unitPrice": "ޔުނިޓް އަގު",
      "taxCode": "ޓެކްސް ކޯޑް",
      "priceSource": "އަގުގެ މަޞްދަރު",
      "discountsTitle": "ޑިސްކައުންޓް",
      "discountsCaption": "މި ވިޔަފާރިއަށް ދެވުނު ޑިސްކައުންޓް.",
      "percent": "އިންސައްތަ",
      "amount": "އަދަދު",
      "reason": "ސަބަބު",
      "authorisedBy": "ހުއްދަ ދިނީ",
      "waterfallNote": "މިއީ ވިޔަފާރީގެ އަގު ނެގުނުއިރު އަގު އިންޖީނުން ރައްކާކުރި ބަޔާން — ދެވަނަ ފަހަރަށް ހިސާބުކުރުމެއް ނޫން.",
      "waterfallFailed": "އަގުގެ ވޯޓަރފޯލް ލޯޑެއް ނުކުރެވުނު.",
      "waterfallEmpty": "މި ވިޔަފާރިއަށް އަގުގެ ބަޔާނެއް ރެކޯޑްކުރެވިފައި ނުވޭ.",
      "waterfallLine": "ލައިން {no} — އައިޓަމް {item}",
      "listPrice": "ލިސްޓް އަގު",
      "winner": "ކުރި ހޯދި ގަވާއިދު",
      "marginOutcome": "މާޖިން",
      "resolvedAt": "ހިސާބުކުރި ވަގުތު",
      "considerationsCaption": "ލައިން {no} ގެ އަގު ނަގާއިރު ބެލުނު ކަންކަން.",
      "seq": "ނަންބަރު",
      "source": "މަޞްދަރު",
      "outcome": "ނަތީޖާ",
      "depletionFailed": "ސްޓޮކް މަދުވުމުގެ ރަން ލޯޑެއް ނުކުރެވުނު.",
      "depletionCaption": "ކޮންމެ ލައިނަކުން ހަރުގަނޑުން ނެގުނު އެއްޗެހި.",
      "depletionEmpty": "މި ވިޔަފާރިއަކުން ސްޓޮކެއް މަދެއް ނުވޭ.",
      "depletionRun": "ރަން",
      "depletionValue": "މަދުވި އަގު",
      "unresolvedLines": "ހައްލުނުވާ ލައިން",
      "journal": "ޖާނަލް",
      "resolution": "ހައްލު",
      "theoretical": "ނަޒަރީ",
      "actual": "ޙަޤީޤީ",
      "shortfallsNote": "{count} ލައިން ފުރިހަމައަށް މަދެއް ނުކުރެވުނު. ވިޔަފާރި ނިމުނު، ސްޓޮކުން ނުފުދުނު.",
      "shortfallsCaption": "މަދުކުރުން ފުރިހަމަނުވި ލައިންތައް.",
      "required": "ބޭނުންވި",
      "shortfall": "މަދުވި",
      "noLegalEntity": "ތިބާއަށް ލީގަލް އެންޓިޓީއެއް ލިބިފައިނުވާތީ، ދައްކާނެ ވިއްކުމެއް ނެތް. އެޑްމިނިސްޓްރޭޓަރަކާ ގުޅުއްވާ."
    },
    "sessions": {
      "title": "ކޭޝް ސެޝަންތައް",
      "description": "ޑްރޯވަރތަކާއި، އޭގެ ގުނުމާއި، މީހަކު ބަލައިގަތް ތަފާތުތައް.",
      "boardTitle": "ސެޝަންތައް",
      "caption": "ކޭޝް ސެޝަންތަކާއި އޭގެ ފްލޯޓް، ހުޅުވި އަދި ބަންދުކުރި ވަގުތު.",
      "detailDescription": "ހަރަކާތްތައް، ކައުންޓް ޝީޓް އަދި — ބަންދުކުރެވުމުން — ތަފާތު.",
      "headerTitle": "ސެޝަން",
      "balancesTitle": "ބެލެންސް",
      "chooseOutlet": "ޑްރޯވަރތައް ބެލުމަށް އައުޓްލެޓެއް ޚިޔާރުކުރައްވާ.",
      "empty": "މި ފިލްޓަރތަކާ ދިމާވާ ކޭޝް ސެޝަނެއް ނެތް.",
      "loadFailed": "ކޭޝް ސެޝަންތައް ލޯޑެއް ނުކުރެވުނު.",
      "sessionNo": "ސެޝަން",
      "unnumbered": "ސެޝަން #{id}",
      "operator": "އޮޕަރޭޓަރ",
      "openingFloat": "ފެށޭ ފްލޯޓް",
      "openedAt": "ހުޅުވި",
      "closedAt": "ބަންދުކުރި",
      "countedBy": "ގުނީ",
      "witnessedBy": "ހެކިވީ",
      "countedBalance": "ގުނުނު",
      "expectedBalance": "ހުންނަންޖެހޭ",
      "variance": "ތަފާތު",
      "varianceReason": "ތަފާތުގެ ސަބަބު",
      "varianceIsServerComputed": "ތަފާތަކީ ސާވަރގެ އަމިއްލަ ޢަދަދު. މި ސްކްރީނުން ދެ ބެލެންސް އުނިއެއް ނުކުރޭ.",
      "blindNote": "ސެޝަން ހުޅުވިފައި ނުވަތަ ގުނަމުންދާއިރު ހުންނަންޖެހޭ ބެލެންސް ޕޭލޯޑްގައި ނުހިމެނޭ. އެއީ ބްލައިންޑް ކްލޯސް، އަދި އެ ބަލަހައްޓަނީ ސާވަރ.",
      "blindUntilCounted": "ގުނަންދެން ބްލައިންޑް",
      "blindExplanation": "ހުންނަންޖެހޭ ބެލެންސާއި ތަފާތު ފެންނާނީ ގުނުން ހުށަހެޅުމުން. އޭގެ ކުރިން ސާވަރުން އެ ނުފޮނުވާ — ބްލައިންޑް ގުނުމެއް ބްލައިންޑްވަނީ އެ ޢަދަދު ޙަޤީޤަތުގައި ނެތުމުން.",
      "varianceQueueTitle": "ތަފާތުގެ ކިޔޫ",
      "varianceQueueDescription": "ހުށަހެޅި އަދި ބަލައިނުގަނެވޭ ގުނުންތަކާއި، ބަލައިގަނެވުނު ތަފާތުތަކާއި އޭގެ ސަބަބު.",
      "varianceQueueCaption": "ބަލައިގަތުމަށް އިންތިޒާރުގައިވާ ސެޝަންތަކާއި، ތަފާތުގެ ސަބަބެއް ހިމެނޭ ބަންދުކުރެވުނު ސެޝަންތައް.",
      "varianceQueueEmpty": "އިންތިޒާރުގައި އެއްޗެއް ނެތް. ކޮންމެ ގުނުމެއް ބަލައިގަނެވިފައި.",
      "movementsTitle": "ހަރަކާތްތައް",
      "movementsCaption": "މި ސެޝަނުގެ ޑްރޮޕް، އެތެރެއަށް، ބޭރަށް އަދި ނޯ ސޭލް.",
      "movementsEmpty": "މި ޑްރޯވަރގައި ހަރަކާތެއް ރެކޯޑްކުރެވިފައި ނުވޭ.",
      "seq": "ނަންބަރު",
      "amount": "އަދަދު",
      "reason": "ސަބަބު",
      "occurredAt": "ވަގުތު"
    },
    "count": {
      "title": "ކައުންޓް ޝީޓް",
      "description": "ގުނާ މީހާ ބުނި އެއްޗެހި، ބާވަތުން ބާވަތަށް.",
      "caption": "ހުށަހެޅުނު ގޮތަށް ކައުންޓް ޝީޓް.",
      "faceValue": "ފޭސް ވެލިއު",
      "unitCount": "ޢަދަދު",
      "lineTotal": "ލައިން ޖުމުލަ",
      "empty": "މި ސެޝަނަށް ގުނުމެއް ހުށަހެޅިފައި ނުވޭ.",
      "readOnly": "މި ސެޝަން ބަންދުކުރެވިފައިވާތީ، ޝީޓަކީ ފޯމެއް ނޫން، ހެއްކެއް. ތަފާތު ބަލައިގަތުމަށްފަހު އަލުން ޖެއްސުމުން ބްލައިންޑް ގުނުމުގެ އަގު ގެއްލޭ.",
      "noTotalHere": "މިތާ ޖުމުލައެއް ނުދައްކަނީ ގަސްދުގައި: ގުނުނު ބެލެންސަކީ ސާވަރގެ އަމިއްލަ ޢަދަދު، އަދި އެހެން ގޮތަކުން ހޯދާ ދެވަނަ ޢަދަދަކީ މި ޝީޓް ނައްތާލަން އޮތް ތަފާތު."
    },
    "deposits": {
      "title": "ޑިޕޮސިޓް",
      "description": "ސެޝަނަކުން ގުނުނު ފައިސާއަށް ވީގޮތް.",
      "caption": "ޑިޕޮސިޓްތަކާއި އޭގައި ބޭންކްކުރެވުނު ސެޝަންތަކާއި ބޭންކް ރެފަރެންސް.",
      "empty": "މި އައުޓްލެޓަށް ޑިޕޮސިޓެއް ތައްޔާރުކުރެވިފައި ނުވޭ.",
      "depositNo": "ޑިޕޮސިޓް",
      "amount": "އަދަދު",
      "sessions": "ސެޝަން",
      "bankReference": "ބޭންކް ރެފަރެންސް",
      "bankReferenceHint": "ސްލިޕް ނުވަތަ ޓްރާންސްފަރ ރެފަރެންސް. ބޭންކް ރިކޮންސިލިއޭޝަނުން މިއާ އަޅާކިޔާ.",
      "journal": "ޖާނަލް",
      "bank": "ބޭންކަށް ޖަމާކުރުން",
      "bankTitle": "މި ޑިޕޮސިޓް ބޭންކަށް ޖަމާކުރުން",
      "bankDescription": "މިއިން ބޭންކް ހަރަކާތެއް ޕޯސްޓްވޭ. ބޭންކް ރިކޮންސިލިއޭޝަނުން ފަހުން ކަށަވަރުކުރޭ.",
      "banked": "ޑިޕޮސިޓް ބޭންކަށް ޖަމާކުރެވިއްޖެ",
      "bankFailed": "ޑިޕޮސިޓް ބޭންކަށް ޖަމާނުކުރެވުނު."
    },
    "dayClose": {
      "boardTitle": "ދުވަސް ބަންދުކުރުން",
      "boardDescription": "ކޮންމެ އައުޓްލެޓެއްގެ ދުވަސް، ހުރަސްތައް އެންމެ ކުރީގައި.",
      "boardEmpty": "މި ތާރީޚަށް ބަންދުކުރާނެ އައުޓްލެޓެއް ނެތް.",
      "chooseCompany": "ދުވަސް ބަންދުކުރުމުގެ ބޯޑް ބެލުމަށް ކުންފުންޏެއް ޚިޔާރުކުރައްވާ.",
      "outletsTitle": "{date} ގެ އައުޓްލެޓްތައް",
      "dateHint": "މިހާރުގެ އޮޕަރޭޓިން ދުވަހަށް ހުސްކޮށް ބަހައްޓަވާ.",
      "dayStatus": "އޮޕަރޭޓިން ދުވަސް",
      "unpostedSales": "ޕޯސްޓްނުކުރެވޭ ވިޔަފާރި",
      "unpostedGross": "ޕޯސްޓްނުކުރެވޭ ޖުމުލަ",
      "postedClose": "ޕޯސްޓްކުރެވުނު ބަންދު",
      "blockersHeading": "މި ދުވަސް ބަންދުކުރުމުގެ ކުރިން {count} ހުރަސް ފިލުވަން ޖެހޭ:",
      "blockersRecorded": "މި ބަންދުކުރި ވަގުތު ރެކޯޑްކުރެވުނު ހުރަސްތައް:",
      "preview": "ޖާނަލް ކުރިން ބެލުން",
      "previewTitle": "މި ބަންދުކުރުމުން ޕޯސްޓްވާނެ ޖާނަލް",
      "previewWritesNothing": "މި ޕްރިވިއުއިން ޖާނަލެއް، ބަންދު ރޯއެއް، އެއްވެސް އެއްޗެއް ނުލިޔޭ. ފްލޯ ސާފުވަމުންދާއިރު ތަކުރާރުކޮށް ހިންގިދާނެ.",
      "previewFailed": "ޕްރިވިއު ހިސާބެއް ނުކުރެވުނު.",
      "post": "ދުވަސް ޕޯސްޓްކުރުން",
      "posted": "ދުވަސް ބަންދުކުރެވި ޕޯސްޓްކުރެވިއްޖެ",
      "postFailed": "ދުވަސް ބަންދެއް ނުކުރެވުނު.",
      "journalTitle": "ޖާނަލް",
      "journalDescription": "ސާވަރުން ބިނާކުރި ގޮތަށް، މި ބަންދުކުރުމުން ޕޯސްޓްކުރެވުނު ލައިންތައް.",
      "journalLink": "ޖާނަލް #{id}",
      "serverFigures": "މި ޕެކްގައިވާ ކޮންމެ ޢަދަދަކީ ސާވަރގެ. މި ސްކްރީނުން އެއްވެސް އެއްޗެއް އެއްނުކުރޭ، ސަބަބަކީ ޖާނަލާ ދިމާނުވާ ޢަދަދެއް ދެއްކުމުން އެ ޤަބޫލުކުރެވޭނެތީ.",
      "doesNotBalance": "ސާވަރުން ފޮނުވި ޑެބިޓާއި ކްރެޑިޓް ދިމައެއް ނުވޭ. އެއީ ސާވަރ ފަރާތުގެ މައްސަލައެއް، އަދި އެ ފޮރުވުމުގެ ބަދަލުގައި ދައްކަނީ.",
      "linesCaption": "ދުވަސް ބަންދުކުރުމުގެ ޖާނަލް ލައިންތަކާއި އޭގެ އެކައުންޓާއި ޑައިމެންޝަން.",
      "linesEmpty": "މި ބަންދުކުރުމުގައި ޖާނަލް ލައިނެއް ނެތް.",
      "seq": "ނަންބަރު",
      "key": "ކީ",
      "account": "އެކައުންޓް",
      "debit": "ޑެބިޓް",
      "credit": "ކްރެޑިޓް",
      "dimensions": "ޑައިމެންޝަން",
      "totals": "ޖުމުލަ",
      "saleCount": "ވިޔަފާރި",
      "voidCount": "ބާޠިލްކުރުން",
      "refundCount": "ފައިސާ އަނބުރާ",
      "grossSales": "ޖުމުލަ ވިޔަފާރި",
      "discountTotal": "ޑިސްކައުންޓް",
      "netRevenue": "ނެޓް އާމްދަނީ",
      "taxTotal": "ޓެކްސް",
      "serviceChargeTotal": "ސާވިސް ޗާޖް",
      "tipTotal": "ޓިޕް",
      "roundingTotal": "ރައުންޑިން",
      "cashVariance": "ފައިސާ އިތުރު/މަދު",
      "accountGross": "އެކައުންޓަށް (ޖުމުލަ)",
      "instrumentIssued": "ދޫކުރެވުނު އިންސްޓްރޫމަންޓް",
      "instrumentRedeemed": "ބޭނުންކުރެވުނު އިންސްޓްރޫމަންޓް",
      "headerTitle": "ބަންދު",
      "detailDescription": "ޕޯސްޓްކުރެވުނު ބަންދާއި، އޭގެ ޖާނަލާއި، ފަހަތުގައިވާ ތިން ގޮތުގެ ރިކޮންސިލިއޭޝަން.",
      "unnumbered": "ބަންދު #{id}",
      "closedAt": "ބަންދުކުރި",
      "closedBy": "ބަންދުކުރީ",
      "reopenedAt": "އަލުން ހުޅުވި",
      "reopenReason": "އަލުން ހުޅުވި ސަބަބު",
      "reversalEntry": "އަނބުރާލި ޖާނަލް",
      "reopenElsewhere": "އޮޕަރޭޓިން ދުވަހުގެ ބޯޑުން އަލުން ހުޅުވުން",
      "operatingDayBoard": "އޮޕަރޭޓިން ދުވަހުގެ ބޯޑް",
      "reconciliationTitle": "ތިން ގޮތުގެ ރިކޮންސިލިއޭޝަން",
      "reconciliationDescription": "އައުޓްލެޓް ޖުމުލައާއި ޖާނަލާއި ސަބް-ލެޖަރ.",
      "reconciliationFailed": "ރިކޮންސިލިއޭޝަން ލޯޑެއް ނުކުރެވުނު.",
      "threeWayNote": "ތިން ފަރާތް ހިސާބުކުރެވެނީ ތިން ގޮތަކަށް، އެއިން މިއީ ހެއްކަކަށްވަނީ. ޓެކްސް އެސާޝަނުން ދުވަސް ގުޅުވެނީ ޓެކްސް ރިޓާން ބިނާވާ ހަމަ އެ ޓެކްސް ލައިންތަކާ.",
      "tiesOut": "ހުރިހާ އެސާޝަނެއް ދިމާވޭ.",
      "doesNotTie": "{count} އެސާޝަން ދިމައެއް ނުވޭ.",
      "assertionsCaption": "ރިކޮންސިލިއޭޝަން އެސާޝަންތަކާއި އޭގެ ހުންނަންޖެހޭ އަދި ޙަޤީޤީ ޢަދަދު.",
      "assertion": "އެސާޝަން",
      "expected": "ހުންނަންޖެހޭ",
      "actual": "ޙަޤީޤީ",
      "difference": "ތަފާތު",
      "passed": "ދިމާވޭ",
      "failed": "ދިމައެއް ނުވޭ",
      "assertionsEmpty": "މި ބަންދުކުރުމަށް އެސާޝަނެއް ހިސާބުކުރެވިފައި ނުވޭ.",
      "loadFailed": "ދުވަސް ބަންދުކުރުން ލޯޑެއް ނުކުރެވުނު.",
      "pack": "ދުވަހުގެ ޕެކް ޑައުންލޯޑްކުރޭ",
      "packFailed": "ދުވަހުގެ ޕެކް ޑައުންލޯޑެއް ނުކުރެވުނު."
    },
    "anomaly": {
      "title": "އޮޕަރޭޓަރ އެނޯމަލީ",
      "description": "މި ކުންފުނިން ކަނޑައެޅި ތްރެޝްހޯލްޑްތަކާ އަޅާކިޔާ ބާޠިލްކުރުމާއި ޑިސްކައުންޓާއި ފައިސާ އަނބުރާ ދިނުމުގެ ރޭޓް.",
      "operatorsTitle": "އޮޕަރޭޓަރުން",
      "operatorsDescription": "އެންމެ ގޯސް ފުރަތަމަ: ނަމަކުން ނޫން، ފަހަނައަޅާފައިވާ މިންގަނޑުތަކުގެ ޢަދަދުން.",
      "operatorsCaption": "އޮޕަރޭޓަރުންގެ ދުވަހުގެ ތަފާސްހިސާބާއި، ރޭޓާއި، ފަހަނައަޅާފައިވާ މިންގަނޑުތައް.",
      "operatorsEmpty": "މި ފިލްޓަރތަކަށް އޮޕަރޭޓަރ ތަފާސްހިސާބެއް ނެތް.",
      "loadFailed": "އޮޕަރޭޓަރ ތަފާސްހިސާބު ލޯޑެއް ނުކުރެވުނު.",
      "breachedOnly": "ފަހަނައަޅާފައިވާ އޮޕަރޭޓަރުން އެކަނި",
      "operator": "އޮޕަރޭޓަރ",
      "sales": "ވިޔަފާރި",
      "grossSales": "ޖުމުލަ",
      "voidRate": "ބާޠިލް %",
      "discountRate": "ޑިސްކައުންޓް %",
      "refundRate": "އަނބުރާ %",
      "noSales": "ނޯ ސޭލް",
      "cashVariance": "ފައިސާގެ ތަފާތު",
      "breached": "ފަހަނައެޅި",
      "drillThrough": "މީގެ ފަހަތުގައިވާ ވިޔަފާރި",
      "thresholdsLink": "ތްރެޝްހޯލްޑް",
      "exceptionsTitle": "އެކްސެޕްޝަން ކިޔޫ",
      "exceptionsDescription": "މީހަކު ބަލަންޖެހޭ ފަހަނައެޅުންތަކާއި، އެ މީހަކަށް ފެނުނު އެއްޗެއް.",
      "exceptionsCaption": "އެނޯމަލީ އެކްސެޕްޝަންތަކާއި އޭގެ ފެނުނު އަދި ތްރެޝްހޯލްޑް ޢަދަދު.",
      "exceptionsEmpty": "މި ފިލްޓަރތަކާ ދިމާވާ އެކްސެޕްޝަނެއް ނެތް.",
      "code": "މިންގަނޑު",
      "observed": "ފެނުނު",
      "threshold": "ތްރެޝްހޯލްޑް",
      "resolution": "ހައްލު",
      "resolve": "ފެނުނު ކަން ރެކޯޑްކުރުން",
      "resolveTitle": "ފެނުނު ކަން ރެކޯޑްކުރައްވާ",
      "resolveDescription": "އެކްސެޕްޝަނެއް ބަންދުވަނީ ފެނުނު ކަމަކުން، ކްލިކަކުން ނޫން.",
      "resolved": "އެކްސެޕްޝަން ހައްލުކުރެވިއްޖެ",
      "resolveFailed": "އެކްސެޕްޝަން ހައްލެއް ނުކުރެވުނު.",
      "dismiss": "ހައްލުކުރުމުގެ ބަދަލުގައި ދޫކޮށްލުން",
      "dismissHint": "ދޫކޮށްލުމުން ރެކޯޑްވަނީ އެ ފަހަނައެޅުމަށް ފިޔަވަޅެއް ބޭނުންނުވިކަން. އެއީވެސް ފެނުމެއް، އަދި ނޯޓަކީ އޭގެ ހެކި."
    },
    "superseded": {
      "title": "ބަދަލުވެފައިވާ ސެޓުން ނެގުނު އަގު",
      "description": "ވިޔަފާރިކުރި ދުވަހު ޝާއިޢުކުރެވިފައިވާ ސެޓް ނޫން، ބަދަލުވެފައިވާ އަގު ސެޓް ވަރޝަނަކުން އަގު ނެގުނު ލައިންތައް.",
      "legend": "އޮފްލައިންކޮށް ވިޔަފާރިކުރާ ޓާމިނަލަކުން ވިއްކަނީ އެންމެ ފަހުން ޑައުންލޯޑްކުރި ކޮންޓެންޓުން. މިއީ އެކަމުން އުފެދުނު ލައިންތައް — ނެގުނު އަގާއި، އޭރު ޝާއިޢުކުރެވިފައިވާ އަގާއި، ސާވަރުން ހިސާބުކުރި ތަފާތު.",
      "tableTitle": "ލައިންތައް",
      "caption": "ބަދަލުވެފައިވާ އަގު ސެޓް ވަރޝަނަކުން އަގު ނެގުނު ވިޔަފާރި ލައިންތަކާއި، ނެގުނު އަގާއި، ޝާއިޢުކުރެވުނު އަގާއި، ޖުމުލަ ތަފާތު.",
      "companyPlaceholder": "ކުންފުންޏެއް ޚިޔާރުކުރައްވާ",
      "outletPlaceholder": "އައުޓްލެޓެއް ޚިޔާރުކުރައްވާ",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "run": "ރިޕޯޓް ހިންގާ",
      "rangeInverted": "މުއްދަތުގެ ނިމުން އޮތީ ފެށުމުގެ ކުރިން.",
      "rangeRequired": "ފުރަތަމަ އައުޓްލެޓަކާއި ތާރީޚް މުއްދަތެއް ޚިޔާރުކުރައްވާ.",
      "chooseRange": "އައުޓްލެޓަކާއި ތާރީޚް މުއްދަތެއް ޚިޔާރުކުރައްވާ، އަދި ރިޕޯޓް ހިންގަވާ.",
      "empty": "މި މުއްދަތުގައި ބަދަލުވެފައިވާ ވަރޝަނަކުން އަގު ނެގުނު ލައިނެއް ނެތް.",
      "loadFailed": "ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު.",
      "lineCount": "ލައިން: {count}",
      "saleNo": "ވިޔަފާރި",
      "item": "މުދާ",
      "priceSetVersion": "އަގު ސެޓް ވަރޝަން",
      "charged": "ނެގުނު އަގު",
      "current": "ޝާއިޢުކުރެވުނު އަގު",
      "variance": "ޖުމުލަ ތަފާތު"
    },
    "conflicts": {
      "title": "ސިންކް ކޮންފްލިކްޓް",
      "description": "ޓާމިނަލާއި ސާވަރ ދިމާނުވި ތަންތަނާއި، އެކަމަށް ކުރެވުނު ކަންތައް.",
      "notApprovals": "މިއީ އެޕްރޫވަލް އިންބޮކްސްއެއް ނޫން. ކޮންފްލިކްޓަކަށް އޮންނަނީ ވެރިއެއް، އެޕްރޫވަރެއް ނޫން: ހައްލުކުރުމުން ރެކޯޑްވަނީ މީހަކަށް ފެނުނު އެއްޗެއް.",
      "empty": "ސިންކް ކޮންފްލިކްޓެއް ނެތް. ފްލީޓުން ފޮނުވި ކޮންމެ މިއުޓޭޝަނެއް ސާފުކޮށް ހިނގައިފި.",
      "groupCaption": "{rule} ގަވާއިދުގެ ދަށުގައިވާ ކޮންފްލިކްޓް.",
      "groupEmpty": "މި ގަވާއިދުގެ ދަށުގައި އެއްޗެއް ނެތް.",
      "loadFailed": "ސިންކް ކޮންފްލިކްޓް ލޯޑެއް ނުކުރެވުނު.",
      "rule": "ގަވާއިދު",
      "device": "ޑިވައިސް",
      "localSeq": "ލޯކަލް ތަރުތީބު",
      "mutationKind": "މިއުޓޭޝަން",
      "field": "ފީލްޑް",
      "ageHours": "އުމުރު (ގަޑި)",
      "owner": "ވެރިޔާ",
      "noOwner": "ދެވިފައި ނުވޭ",
      "createdAt": "ފެންމަތިވި",
      "inspect": "ބެލުން",
      "previewTitle": "ކޮންފްލިކްޓްގެ ތަފްޞީލް",
      "previewDescription": "ދެ އަގު، ކައިރި ކައިރީގައި، އެކަތިވެސް ބޮޑުކޮށް ނުދައްކާ.",
      "clientValue": "ޓާމިނަލް ބުނީ",
      "serverValue": "ސާވަރގައި ހުރީ",
      "resolution": "ކުރެވުނު ކަންތައް",
      "resolve": "ރެކޯޑްކުރުން",
      "resolved": "ކޮންފްލިކްޓް ހައްލުކުރެވިއްޖެ",
      "resolveFailed": "ކޮންފްލިކްޓް ހައްލެއް ނުކުރެވުނު.",
      "dismiss": "ހައްލުކުރުމުގެ ބަދަލުގައި ދޫކޮށްލުން",
      "dismissHint": "ދޫކޮށްލުމުން ރެކޯޑްވަނީ ޓާމިނަލްގެ އަގަށް ފިޔަވަޅެއް ބޭނުންނުވިކަން. އެއީވެސް ފެނުމެއް.",
      "readOnly": "މި ކޮންފްލިކްޓަށް ފިޔަވަޅު އެޅިފައި، ނުވަތަ ތިޔަބޭފުޅާއަށް device.conflict.resolve ނެތް."
    },
    "ratifications": {
      "title": "ފަސްކުރެވުނު ހުއްދަތައް",
      "description": "ސުވާލުކުރެވެން ނެތް ވަގުތު ޓާމިނަލުން ހުއްދަދިން ކަންކަން، ނިންމުމަކަށް އިންތިޒާރުގައި.",
      "tableTitle": "ތަޞްދީޤަށް އިންތިޒާރުގައި",
      "caption": "ފަސްކުރެވުނު އޮފްލައިން ހުއްދަތަކާއި އޭގެ ކޮންޓްރޯލް، އަދަދު އަދި މުއްދަތު.",
      "empty": "ތަޞްދީޤަށް އިންތިޒާރުގައި އެއްޗެއް ނެތް.",
      "loadFailed": "ފަސްކުރެވުނު ހުއްދަތައް ލޯޑެއް ނުކުރެވުނު.",
      "refusalIsNotAnUndo": "ދޫކޮށްލުމަކީ އަނބުރާ ގެނައުމެއް ނޫން. އެ ޢަމަލު ހިނގައިފި؛ ދޫކޮށްލުމުން ކޮންޓްރޯލްގެ އަމިއްލަ ކޮމްޕެންސޭޓިން ޢަމަލު ހިނގާ.",
      "overdueOnly": "މުއްދަތު ފަހަނައަޅާފައިވާ އެކަނި",
      "control": "ކޮންޓްރޯލް",
      "amount": "އަދަދު",
      "reason": "ސަބަބު",
      "dueAt": "މުއްދަތު",
      "compensating": "ކޮމްޕެންސޭޓިން ލިޔުން",
      "ratify": "ތަޞްދީޤުކުރުން",
      "ratified": "ހުއްދަ ތަޞްދީޤުކުރެވިއްޖެ",
      "ratifyTitle": "މި ހުއްދަ ތަޞްދީޤުކުރުން",
      "ratifyConsequence": "ތަޞްދީޤުކުރުމުން ރެކޯޑްވަނީ {control} އިން އޮފްލައިންގައި ދިން ހުއްދައިގެ ފަހަތުގައި ވިޔަފާރި ހުރިކަން. އެހެން އެއްވެސް ބަދަލެއް ނާދޭ.",
      "refuse": "ދޫކޮށްލުން",
      "refused": "ހުއްދަ ދޫކޮށްލެވިއްޖެ",
      "refuseTitle": "މި ހުއްދަ ދޫކޮށްލުން",
      "refuseConsequence": "ދޫކޮށްލުމުން {control} ކަނޑައަޅާ ކޮމްޕެންސޭޓިން ޢަމަލު ހިނގާނެ — ބާޠިލްކުރުމެއްނަމަ އެ އަނބުރާލެވި އޮޕަރޭޓަރާ ދެކޮޅަށް އެކްސެޕްޝަނެއް ހުޅުވޭ؛ އެކައުންޓް ޓެންޑަރއެއްނަމަ އިންވޮއިސް ދޫކުރެވޭ، މުދާ ގޮސްފައިވާތީ.",
      "noteHint": "ތިޔަބޭފުޅާ ނިންމެވި ގޮތާއި ސަބަބު. މިއީ ހަ މަސް ފަހުން މީހަކު ކިޔާނެ ރެކޯޑް.",
      "decideFailed": "ނިންމުން ރެކޯޑެއް ނުކުރެވުނު."
    },
    "sync": {
      "batch": "ބެޗް",
      "receivedAt": "ލިބުނު",
      "mutations": "ފޮނުވުނު",
      "applied": "ހިނގި",
      "replayed": "އަލުން ހިނގި",
      "conflicts": "ކޮންފްލިކްޓް",
      "failed": "ފެއިލްވި",
      "clockSkew": "ގަޑީގެ ތަފާތު (ސ)"
    },
    "assign": {
      "action": "ޑްރޯވަރ ހަވާލުކުރުން",
      "title": "ޑްރޯވަރެއް ހަވާލުކުރުން",
      "description": "ޓާމިނަލެއްގައި އޮޕަރޭޓަރަކަށް، ގުނާފައިވާ ފެށޭ ފްލޯޓަކާއެކު ޑްރޯވަރެއް ހުޅުވާ.",
      "operator": "ހަވާލުކުރެވޭ އޮޕަރޭޓަރ",
      "operatorHint": "މި ޝިފްޓްގައި މި ޑްރޯވަރަށް ޒިންމާވާ ފަރާތް.",
      "openingFloat": "ފެށޭ ފްލޯޓް ({currency})",
      "openingFloatHint": "ވިޔަފާރި ފެށުމުގެ ކުރިން ޑްރޯވަރަށް ގުނާފައި ލެވޭ ފައިސާ.",
      "confirmedBy": "ކަށަވަރުކުރި ފަރާތް",
      "confirmedByHint": "ސައިން އިން ވެފައިވާ ފަރާތް، ހުޅުވި ސުޕަވައިޒަރުގެ ގޮތުގައި ސާވަރުން ރައްކާކުރޭ.",
      "breakdownNote": "ފްލޯޓް ރައްކާކުރެވެނީ އެއް އަދަދެއްގެ ގޮތުގައި. ޑިނޮމިނޭޝަން ބްރޭކްޑައުން ރެކޯޑްކުރެވެނީ ބްލައިންޑް ކައުންޓްގައި، ހަވާލުކުރާ ވަގުތަކު ނޫން — ހުޅުވާ ރިކުއެސްޓްގައި ކައުންޓް ލައިންތަކެއް ނުދޭ.",
      "samePartyWarning": "އޮޕަރޭޓަރާއި ކަށަވަރުކުރާ ސުޕަވައިޒަރަކީ އެއް މީހެއް. POS-F07-V02 ބުނަނީ ފެށޭ ފްލޯޓް ދެ ފަރާތުން ކަށަވަރުކުރަން ޖެހޭ ކަމަށް.",
      "submit": "ޑްރޯވަރ ހަވާލުކުރޭ",
      "opened": "ޑްރޯވަރ ހަވާލުކުރެވިއްޖެ",
      "failed": "ޑްރޯވަރ ހަވާލެއް ނުކުރެވުނު."
    },
    "variance": {
      "action": "މުރާޖައާ",
      "title": "މި ވޭރިއަންސް މުރާޖައާކުރުން",
      "description": "ގުނުމަށް ހެކިވެ، ތަފާތެއް ވާނަމަ ސަބަބު ދީ، ޑްރޯވަރ ބަންދުކުރޭ.",
      "acceptedBy": "ގަބޫލުކުރާ ފަރާތް",
      "blindNote": "ބެލެވޭ ބެލެންސާއި ވޭރިއަންސް ލިބެނީ ބަންދުކުރެވުނު ސެޝަނާއެކު. ގުނަމުންދާއިރު ސާވަރުން އެ އަދަދުތައް ނުފޮނުވާ، އެހެންކަމުން ގަބޫލުކުރުމުގެ ކުރިން މި ސްކްރީނަށް ތަފާތު ދެއްކޭކަށް ނެތް.",
      "witnessHint": "ގުނި ފަރާތް ނޫން އެހެން މީހަކަށް ވާން ޖެހޭ. އެ ޖޯޑު ޑޭޓާބޭސްއިން ގަބޫލެއް ނުކުރޭ.",
      "reasonHint": "ތަފާތު ސުމެއް ނޫންނަމަ ލާޒިމު؛ ނެތްނަމަ ސާވަރުން އެ ފީލްޑް ބުނެދޭ.",
      "authorisedBy": "ހުއްދަ ދިން ފަރާތް",
      "authorisedByHint": "އައުޓްލެޓްގެ ޓޮލަރެންސްއަށްވުރެ ބޮޑު ތަފާތަކަށް އޮތޯރިޓީ ބޭންޑް އޯވަރައިޑެއް ބޭނުންވެދާނެ.",
      "note": "ނޯޓް",
      "noteHint": "ސަބަބު ކޯޑުން ނުބުނެވޭ އެއްޗެހި. މިއީ ހެއްކެއް، އެހެންކަމުން އަހަރެއް ފަހުން ކިޔާ މީހަކަށް ލިޔޭ.",
      "escalationNote": "ސެޝަނަކަށް \"ތަހުގީގުކުރެވެނީ\" ހާލަތެއް ނެތް. ކޭޝް ވޭރިއަންސެއް އެސްކަލޭޓްކުރެވެނީ އޮޕަރޭޓަރ އެނޮމަލީ ބޯޑުގައި، އެތަނުގައި އޭގެ އަމިއްލަ ހާލަތެއް އޮވޭ.",
      "submit": "ގަބޫލުކޮށް ބަންދުކުރޭ",
      "accepted": "ޑްރޯވަރ ބަންދުކުރެވިއްޖެ",
      "failed": "ޑްރޯވަރ ބަންދެއް ނުކުރެވުނު."
    },
    "banking": {
      "action": "ބޭންކިން ތައްޔާރުކުރުން",
      "title": "ބޭންކިން ޑިޕޮސިޓެއް ތައްޔާރުކުރުން",
      "description": "ބޭންކަށް ގެންދެވޭ ފައިސާގެ ޑްރޯވަރތަކުން ޑިޕޮސިޓެއް އެއްކުރޭ.",
      "bankAccount": "ބޭންކް އެކައުންޓް",
      "bankAccountHint": "އައުޓްލެޓްގެ ކުންފުންޏަށް ނިސްބަތްވާ ހަރަކާތްތެރި ބޭންކް އެކައުންޓެއް.",
      "witnessHint": "ތައްޔާރުކުރާ ފަރާތް ނޫން އެހެން މީހަކަށް ވާން ޖެހޭ. އެ ޖޯޑު ޑޭޓާބޭސްއިން ގަބޫލެއް ނުކުރޭ.",
      "note": "ނޯޓް",
      "caption": "ބަންދުކުރެވިފައިވާ ޑްރޯވަރތަކާއި، ކޮންމެ ޑްރޯވަރަކުން މި ޑިޕޮސިޓަށް ނެގޭ އަދަދު.",
      "include": "ހިމަނާ",
      "includeSession": "މި ޑިޕޮސިޓްގައި {session} ހިމަނާ",
      "allocation": "ނެގޭ އަދަދު",
      "allocationFor": "{session} އިން ނެގޭ އަދަދު",
      "total": "ޑިޕޮސިޓްގެ ޖުމުލަ",
      "noBankableSessions": "މިތާ އަދި ބަންދުކުރެވިފައިވާ ޑްރޯވަރެއް ނެތް. ބޭންކަށް ގެންދެވެނީ ގުނާ ބަންދުކުރެވިފައިވާ ޑްރޯވަރެއްގެ ފައިސާ އެކަނި.",
      "safeNote": "ސޭފް ރިކޮންސައިލްކުރުން މި ސްކްރީނުގައި ނެތީ ސޭފް ބެލެންސެއް ނުވަތަ ރިކޮންސައިލް އެންޑްޕޮއިންޓެއް ކިޔާނެ ގޮތެއް ނެތުމުން: POS-F07-V09 ގެ ގޭޓުގެ ފަހަތުގައި އަދި އެއްޗެއް ނެތް.",
      "submit": "ޑިޕޮސިޓް ތައްޔާރުކުރޭ",
      "prepared": "ޑިޕޮސިޓް ތައްޔާރުކުރެވިއްޖެ",
      "failed": "ޑިޕޮސިޓް ތައްޔާރެއް ނުކުރެވުނު."
    },
    "tableShape": {
      "square": "އަކަ",
      "round": "ވަށް",
      "rect": "ދިގުކޮށް އަކަ",
      "bar": "ބާ"
    },
    "tableStatus": {
      "free": "ހުސް",
      "seated": "ބޭތިއްބިފައި",
      "ordered": "އޯޑަރުކޮށްފައި",
      "printed": "ޗާޕުކޮށްފައި",
      "paid": "ފައިސާ ދައްކާފައި",
      "dirty": "ސާފުކުރަން ޖެހޭ"
    },
    "floorPlan": {
      "title": "ފްލޯ ޕްލޭން",
      "description": "އައުޓްލެޓްގެ ބައިތަކާއި، ކޮންމެ ބައެއްގައި ހުރި މޭޒުތަކާއި، ޓިކެޓް ދާ ސްޓޭޝަންތައް.",
      "chooseOutlet": "ފްލޯ ބަލާ އަދި އިސްލާހުކުރުމަށް އައުޓްލެޓެއް ހޮވާ.",
      "loadFailed": "ފްލޯ ޕްލޭން ލޯޑެއް ނުކުރެވުނު.",
      "sectionsTitle": "ބައިތައް",
      "sectionsDescription": "ޚިދުމަތަށްޓަކައި ކޮޓަރި ބަހާލެވިފައިވާ ގޮތް. ޗެކެއް ބެހެއްޓެނީ މީގެ ތެރެއިން ބައެއްގައި ހުރި މޭޒަކާ.",
      "sectionsCaption": "ފްލޯ ބައިތަކާއެކު އެ ބައިތަކުގެ ކޯޑް، ނަން އަދި ދައްކާ ތަރުތީބު.",
      "sectionsEmpty": "މި އައުޓްލެޓްގައި އަދި ބައެއް ނެތް. ޗެކެއް މޭޒަކާ ގުޅުމުގެ ކުރިން ހޮސްޕިޓަލިޓީ އައުޓްލެޓަކަށް މަދުވެގެން އެއް ބައި ބޭނުންވޭ.",
      "addSection": "ބައެއް އިތުރުކުރޭ",
      "openSection": "ހުޅުވާ",
      "sectionDialogDescription": "ކޯޑެއް، ނަމެއް، އަދި ލިސްޓުގައި އޮންނަ ތަން.",
      "areaSaved": "ބައި އިތުރުކުރެވިއްޖެ",
      "areaSaveFailed": "ބައި އިތުރެއް ނުކުރެވުނު.",
      "seqNo": "ތަރުތީބު",
      "seqNoHint": "ލިސްޓުގައި ފެންނަ ތަން. ކުޑަ އަދަދު ކުރިއަށް.",
      "tablesTitle": "މޭޒުތައް",
      "tablesDescription": "ހޮވާފައިވާ ބައިގައި ހުރި މޭޒުތަކާއި، އެ މޭޒުތަކުގެ ގޮނޑިއާއި، ޕްލޭނުގައި އޮންނަ ތަން.",
      "tablesCaption": "މޭޒުތަކާއެކު އެ މޭޒުތަކުގެ ކޯޑް، ގޮނޑި، ތަން، ބައްޓަން އަދި މިހާރުގެ ހާލަތު.",
      "tablesEmpty": "މި ބައިގައި އަދި މޭޒެއް ނެތް.",
      "editTables": "މޭޒުތައް އިސްލާހުކުރޭ",
      "addTable": "މޭޒެއް އިތުރުކުރޭ",
      "tablesSaved": "މޭޒުތައް ރައްކާކުރެވިއްޖެ",
      "tablesSaveFailed": "މޭޒުތައް ރައްކާއެއް ނުކުރެވުނު.",
      "wholeSetNote": "ރައްކާކުރުމުން މި ބައިގެ މުޅި މޭޒު ސެޓް ބަދަލުވޭ: ނަގާލާ ކޯޑެއް ފްލޯއިން ނެގޭ، ބާއްވާ ކޯޑެއް އެތަނުގައި އަޕްޑޭޓްވޭ.",
      "seats": "ގޮނޑި",
      "gridX": "އެކްސް",
      "gridY": "ވައި",
      "shape": "ބައްޓަން",
      "statusFromFloor": "ފްލޯއިން ކަނޑައަޅާ",
      "statusNote": "ޗެކެއް ކުރިއަށްދާވަރަކަށް މޭޒުގެ ހާލަތު ބަދަލުވޭ، އަދި ކޮންމެ ފިޔަވަޅެއް ހިންގަނީ ޓިލްއިން. މިތާނގައި ދެވެނީ މޭޒު ސާފުކުރި ކަމަށް ހެދުމުގެ ފުރުސަތު އެކަނި.",
      "clearTable": "ހުސްކަމަށް ފާހަގަކުރޭ",
      "tableCleared": "މޭޒު ހުސްކުރެވިއްޖެ",
      "tableClearFailed": "މޭޒު ހުހެއް ނުކުރެވުނު.",
      "stationsTitle": "ތައްޔާރުކުރާ ސްޓޭޝަންތައް",
      "stationsDescription": "ބަދިގޭ ޓިކެޓް ޗާޕުވެ، ވަގުތު ގުނަން ފަށާ ތަން.",
      "stationsCaption": "ސްޓޭޝަންތަކާއެކު އެތަންތަނުގެ ކޯޑް، ދައްކާ ތަރުތީބު އަދި ތައްޔާރުކުރުމުގެ އަމާޒު މިނެޓް.",
      "stationsEmpty": "މި އައުޓްލެޓްގައި އަދި ސްޓޭޝަނެއް ނެތް. ސްޓޭޝަނެއް ނެތް މެނޫ އައިޓަމެއް ދާނެ ތަނެއް ނެތް.",
      "addStation": "ސްޓޭޝަނެއް އިތުރުކުރޭ",
      "stationDialogDescription": "ކޯޑެއް، ނަމެއް، އަދި މި ސްޓޭޝަނުގައި ޓިކެޓަކަށް ނަގާނެކަމަށް ބެލެވޭ މިނެޓް.",
      "stationSaved": "ސްޓޭޝަން އިތުރުކުރެވިއްޖެ",
      "stationSaveFailed": "ސްޓޭޝަން އިތުރެއް ނުކުރެވުނު.",
      "targetMinutes": "އަމާޒު މިނެޓް",
      "targetMinutesHint": "މި ސްޓޭޝަނުގައި ޓިކެޓަކަށް ނަގަންވީ ވަގުތު. އެއަށްވުރެ ދިގުވެއްޖެނަމަ އިސްކަން މައްޗަށްދޭ.",
      "routingNote": "އައިޓަމެއް ދާނެ ސްޓޭޝަން ކަނޑައަޅަނީ އައިޓަމުގައި، މެނޫ ވާޝަން އެޑިޓަރުގައި — ވަކި ރޫޓިން ރޫލް ޓޭބަލެއް ނެތް.",
      "assignServerNote": "ސާވަރ ހަވާލުކުރުމުގެ ފުރުސަތެއް ނުދެވޭ: ޗެކެއްގެ ސާވަރަކީ އެ ހުޅުވި ފަރާތް، އަދި އެ ބަދަލުކުރާނެ ނުވަތަ ޝިފްޓަކަށް ބަޔަކާ ސާވަރަކު ގުޅުވާނެ އެންޑްޕޮއިންޓެއް ނެތް."
    },
    "allergenSeverity": {
      "contains": "ހިމެނޭ",
      "may_contain": "ހިމެނިދާނެ"
    },
    "menuEditor": {
      "sectionsTitle": "ބައިތައް",
      "sectionsDescription": "ޓިލްގައި މެނޫ ބަހާލެވިފައިވާ ގޮތް. އައިޓަމަކުން ބައެއް ދައްކަނީ ކޯޑުން.",
      "sectionsCaption": "މެނޫ ބައިތަކާއެކު އެ ބައިތަކުގެ ކޯޑް، ނަން، ތަރުތީބު، ރެވެނިއު ސެންޓަރު އަދި ކުލަ.",
      "sectionsEmpty": "މި ވާޝަނުގައި އަދި ބައެއް ނެތް. ބައެއް ނެތި އައިޓަމެއް އިތުރެއް ނުކުރެވޭ.",
      "addSection": "ބައެއް އިތުރުކުރޭ",
      "saveSections": "ބައިތައް ރައްކާކުރޭ",
      "sectionsSaved": "ބައިތައް ރައްކާކުރެވިއްޖެ",
      "sectionsSaveFailed": "ބައިތައް ރައްކާއެއް ނުކުރެވުނު.",
      "revenueCentre": "ރެވެނިއު ސެންޓަރު",
      "colour": "ކުލަ",
      "wholeSetNote": "ކޮންމެ ރައްކާކުރުމަކުން މި ވާޝަނުގެ އެ މުޅި ސެޓް ބަދަލުވޭ: ދޫކޮށްލާ ކޯޑެއް ނެގޭ، ބާއްވާ ކޯޑެއް އެތަނުގައި އަޕްޑޭޓްވޭ.",
      "groupsTitle": "މޮޑިފަޔަރ ގްރޫޕްތައް",
      "groupsDescription": "އައިޓަމަކުން ދޭ ޗޮއިސްތަކާއި، މެހެމާނަކު އޭގެ ތެރެއިން ނަގަން ޖެހޭ އަދަދު.",
      "groupsEmpty": "މި ވާޝަނުގައި މޮޑިފަޔަރ ގްރޫޕެއް ނެތް.",
      "addGroup": "ގްރޫޕެއް އިތުރުކުރޭ",
      "removeGroup": "ގްރޫޕް ނަގާ",
      "saveGroups": "މޮޑިފަޔަރ ގްރޫޕްތައް ރައްކާކުރޭ",
      "groupsSaved": "މޮޑިފަޔަރ ގްރޫޕްތައް ރައްކާކުރެވިއްޖެ",
      "groupsSaveFailed": "މޮޑިފަޔަރ ގްރޫޕްތައް ރައްކާއެއް ނުކުރެވުނު.",
      "minSelect": "އެންމެ މަދުވެގެން",
      "minSelectHint": "މެހެމާނަކު ނަގަން ޖެހޭ އެންމެ މަދު އަދަދު. ސުމަކުން ގްރޫޕަކީ އިޚްތިޔާރީއެއް.",
      "maxSelect": "އެންމެ ގިނަވެގެން",
      "maxSelectHint": "ހައްދެއް ނެތްނަމަ ހުސްކޮށް ބާއްވާ.",
      "addModifier": "މޮޑިފަޔަރ އިތުރުކުރޭ",
      "modifiersEmpty": "މި ގްރޫޕުން އަދި ދޭ އެއްޗެއް ނެތް.",
      "modifiersCaption": "{group} ގްރޫޕުގައި ހިމެނޭ މޮޑިފަޔަރތައް.",
      "isDefault": "ޑިފޯލްޓް",
      "itemsTitle": "އައިޓަމްތައް",
      "itemsDescription": "ޓިލްއިން ވިއްކާ އެއްޗެހި، އެ އޮންނަ ތަން، ތައްޔާރުކުރާ ތަން، އަދި އެ އަހާ އެއްޗެހި.",
      "itemsCaption": "މެނޫ އައިޓަމްތަކާއެކު އެއިގެ ބައި، އިންވެންޓްރީ އައިޓަމް، ސްޓޭޝަން، ކޯސް އަދި ފްލޭގްތައް.",
      "itemsEmpty": "މި ވާޝަނުން އަދި ވިއްކާ އެއްޗެއް ނެތް.",
      "addItem": "އައިޓަމެއް އިތުރުކުރޭ",
      "saveItems": "އައިޓަމްތައް ރައްކާކުރޭ",
      "itemsSaved": "އައިޓަމްތައް ރައްކާކުރެވިއްޖެ",
      "itemsSaveFailed": "އައިޓަމްތައް ރައްކާއެއް ނުކުރެވުނު.",
      "item": "އިންވެންޓްރީ އައިޓަމް",
      "station": "ސްޓޭޝަން",
      "courseNo": "ކޯސް",
      "ageCheck": "އުމުރު ބެލުން",
      "minimumAge": "އެންމެ ކުޑަ އުމުރު",
      "allergens": "އެލަރޖަން",
      "sectionCodeNote": "އައިޓަމަކުން އޭގެ ބައި ދައްކަނީ ކޯޑުން، އެހެންވެ އައު ބައެއް އަދި އޭގައި ހިމެނޭ އައިޓަމްތައް އެއްފަހަރާ ރައްކާކުރެވޭ — ފުރަތަމަ ބައިތައް ރައްކާކުރޭ.",
      "nutritionNote": "ނިއުޓްރިޝަން ޑިކްލެއަރއެއް ނުކުރެވޭ: ބިލްޑްގެ އެއްވެސް ތަނެއްގައި ނިއުޓްރިޝަން ޓޭބަލެއް، ކޮލަމެއް ނުވަތަ އެންޑްޕޮއިންޓެއް ނެތުމުން، §10.2.5 ގެ ނިއުޓްރިޝަން ބަޔަށް ލިޔާނެ ތަނެއް ނެތް.",
      "publishedLocked": "މި ވާޝަން ޝާއިއުކޮށްފައިވާތީ އޭގެ ތެރޭގައިވާ އެއްޗެހި އިސްލާހެއް ނުކުރެވޭ. ޓާމިނަލްތަކުގައި މީގެ ކޮންޓެންޓް ހޭޝް އޮވޭ؛ މެނޫ ބަދަލުކުރަން އައު ޑްރާފްޓް ވާޝަނެއް ހަދާ."
    },
    "allergens": {
      "title": "އެލަރޖަން ޑިކްލެއަރކުރުން",
      "description": "މި އައިޓަމުގައި ހިމެނޭ އެއްޗެއްސާއި، ބަދިގެއިން ނަފީނުކުރެވޭ އެއްޗެހި.",
      "caption": "މި އައިޓަމަށް ޑިކްލެއަރކޮށްފައިވާ އެލަރޖަން ލައިންތައް.",
      "allergen": "އެލަރޖަން",
      "severity": "ދަރަޖަ",
      "add": "ލައިނެއް އިތުރުކުރޭ",
      "empty": "މި އައިޓަމަށް ޑިކްލެއަރކޮށްފައި އެއްޗެއް ނެތް.",
      "loadFailed": "އެލަރޖަން ލިސްޓް ލޯޑެއް ނުކުރެވުނު.",
      "noVocabulary": "މި ކުންފުނީގައި އަދި އެލަރޖަން ކޯޑެއް ނެތުމުން، ޑިކްލެއަރކުރެވޭނެ އެއްޗެއް ނެތް. ފުރަތަމަ ލޯކަލައިޒޭޝަން ޕެކް ސީޑްކުރޭ ނުވަތަ ކޯޑް އިތުރުކުރޭ.",
      "withdrawTitle": "މި ރައްކާކުރެވޭ ގޮތް",
      "wholeSetNote": "ރައްކާކުރުމުން މި އައިޓަމުގެ މުޅި ޑިކްލެރޭޝަން ބަދަލުވޭ. ލައިނެއް ނެގުމުން އެ އެލަރޖަން ދޫކޮށްލެވޭ؛ ލައިނަކަށް ވަކިން ޑިލީޓެއް ނެތް.",
      "nutritionNote": "ނިއުޓްރިޝަން މި ޑިކްލެރޭޝަނުގައި ނުހިމެނޭ އަދި މޮޑެލްގައި އޭގެ ތަނެއް ނެތް — ބިލްޑްގެ އެއްވެސް ތަނެއްގައި ނިއުޓްރިޝަން ފީލްޑެއް ނެތް.",
      "saved": "އެލަރޖަން ޑިކްލެއަރކުރެވިއްޖެ",
      "saveFailed": "ޑިކްލެރޭޝަން ރައްކާއެއް ނުކުރެވުނު."
    },
    "customerDepositStatus": {
      "open": "ހިފަހައްޓާފައި",
      "applied": "ބޭނުންކޮށްފައި",
      "refunded": "އަނބުރާ ދީފައި",
      "expired": "މުއްދަތު ހަމަވެފައި"
    },
    "employeePurchaseStatus": {
      "pending": "ދައްކަން ޖެހޭ",
      "deducted": "އުނިކޮށްފައި",
      "waived": "މާފުކޮށްފައި",
      "cancelled": "ކެންސަލްކޮށްފައި"
    },
    "retail": {
      "title": "ރީޓެއިލް ލެޖަރ",
      "description": "އައުޓްލެޓުން ކަސްޓަމަރުންނަށްޓަކައި ހިފަހައްޓާފައިވާ ޑިޕޮސިޓާއި، މުވައްޒަފުން ޕޭރޯލަށް ދައްކަން ޖެހޭ ވިޔަފާރި.",
      "chooseOutlet": "އައުޓްލެޓުން ހިފަހައްޓާފައިވާ ޑިޕޮސިޓް ބެލުމަށް އައުޓްލެޓެއް ހޮވާ.",
      "depositsTitle": "ކަސްޓަމަރ ޑިޕޮސިޓް",
      "depositsDescription": "އޯޑަރަކަށްޓަކައި ނަގާފައި، އަދި ބޭނުންނުކުރެވި ނުވަތަ އަނބުރާ ނުދެވި ހުރި ފައިސާ.",
      "depositsCaption": "ކަސްޓަމަރ ޑިޕޮސިޓާއެކު ބޭނުންކުރެވުނު، އަނބުރާ ދެވުނު އަދި ބާކީ ހުރި އަދަދު.",
      "depositsEmpty": "މި އައުޓްލެޓުން ޑިޕޮސިޓެއް ހިފަހައްޓާފައި ނެތް.",
      "depositsLoadFailed": "ޑިޕޮސިޓްތައް ލޯޑެއް ނުކުރެވުނު.",
      "depositStatusFilter": "ޑިޕޮސިޓް ހާލަތު",
      "purchaseStatusFilter": "ވިޔަފާރީގެ ހާލަތު",
      "customer": "ކަސްޓަމަރ",
      "applied": "ބޭނުންކުރެވުނު",
      "refunded": "އަނބުރާ ދެވުނު",
      "remaining": "ބާކީ ހިފަހައްޓާފައި",
      "expiresOn": "މުއްދަތު ހަމަވަނީ",
      "expiresOnHint": "މި ތާރީޚަށްފަހު ޖޮބުން މުއްދަތު ހަމަވެއްޖެކަމަށް ފާހަގަކުރޭ. މުއްދަތެއް ނެތްނަމަ ހުސްކޮށް ބާއްވާ.",
      "liabilityNote": "ޑިޕޮސިޓަކީ ނަގާ ވަގުތުން ފެށިގެން ދަރަންޏެއް: ބާކީ ހިފަހައްޓާފައިވާ އަދަދަކީ އައުޓްލެޓުން ދޭން ޖެހޭ އަދަދު، އަދި ހިފަހައްޓާފައިވާ ރޯއެއްގެ ދުވަސްވުމަކީ ނުނަގާ މުދަލުގެ ކޮންޓްރޯލް.",
      "applyNote": "ޑިޕޮސިޓް ބޭނުންކުރެވެނީ ކައުންޓަރުގައި، އެއިން ދައްކާ ވިޔަފާރިއާ ދެކޮޅަށް. މި ސްކްރީނުން އަނބުރާ ދެވޭ، ލިސްޓަކުން އެހެން މީހެއްގެ މުއާމަލާތެއް ނުނިންމޭ.",
      "takeDeposit": "ޑިޕޮސިޓް ނަގާ",
      "takeDescription": "ކަސްޓަމަރު ނުނަގާ އޯޑަރަކަށްޓަކައި ލިބުނު ފައިސާ.",
      "amountIn": "އަދަދު ({currency})",
      "depositTaken": "ޑިޕޮސިޓް ނެގިއްޖެ",
      "depositTakeFailed": "ޑިޕޮސިޓް ނުނެގުނު.",
      "customerPermissionNote": "ކަސްޓަމަރ ލިސްޓް ކިޔޭކަށް ނެތް، އެހެންވެ ހޮވާނެ މީހަކު ނެތް. ar.customer.read އެދޭ.",
      "refund": "އަނބުރާ ދޭ",
      "refundTitle": "މި ޑިޕޮސިޓް އަނބުރާ ދިނުން",
      "refundDescription": "ހިފަހައްޓާފައިވާ ފައިސާ އަނބުރާ ދޭ. އަނބުރާ ދޭ އަދަދުން ދަރަނި ލުއިވޭ.",
      "refundAmountHint": "ޑިފޯލްޓަކީ ބާކީ ހިފަހައްޓާފައިވާ ހުރިހާ އެއްޗެއް. ކުޑަ އަދަދަކުން އޭގެ ބައެއް އަނބުރާ ދެވޭ.",
      "depositRefunded": "ޑިޕޮސިޓް އަނބުރާ ދެވިއްޖެ",
      "depositRefundFailed": "ޑިޕޮސިޓް އަނބުރާ ނުދެވުނު.",
      "purchasesTitle": "މުވައްޒަފުންގެ ވިޔަފާރި",
      "purchasesDescription": "ޕޭރޯލުން އުނިކުރުމަށް، ވިޔަފާރިއަކާ ދެކޮޅަށް ރެކޯޑްކުރެވިފައިވާ މުވައްޒަފުންގެ ވިޔަފާރި.",
      "purchasesCaption": "މުވައްޒަފުންގެ ވިޔަފާރިއާއެކު އެއިން އައި ވިޔަފާރިއާއި، އުނިކުރި ޕޭރޯލް ރަންއާއެކު.",
      "purchasesEmpty": "މި ކުންފުންޏަށް މުވައްޒަފުންގެ ވިޔަފާރިއެއް ރެކޯޑްކޮށްފައި ނެތް.",
      "purchaseNote": "މުވައްޒަފެއްގެ ވިޔަފާރި ރެކޯޑްކުރެވެނީ ޓިލްގައި، ނިމިފައިވާ ވިޔަފާރިއަކާ ދެކޮޅަށް، އެހެންވެ މިތާ ހެދުމެއް ނެތް — އެއާއެކު ވިޔަފާރިވެސް ހަދަން ޖެހޭނެ.",
      "employee": "މުވައްޒަފު",
      "sale": "ވިޔަފާރި",
      "payrollRun": "ޕޭރޯލް ރަން"
    },
    "queue": {
      "sync_conflict": "ޑިވައިސް ސިންކް ކޮންފްލިކްޓްތައް"
    },
    "sync_conflict": {
      "server_wins_config": "ސާވަރގެ ކޮންފިގްރޭޝަން ޑިވައިސްގައި ހުރި ތަފާތު އަގެއް ބަދަލުކުރެއްވި.",
      "client_wins_completed": "ޑިވައިސްގައި ނިމިފައިވާ އަމަލެއް ސާވަރގެ ތަފާތު ބަދަލެއްގެ މައްޗަށް ބަހައްޓާފައި ވޭ.",
      "queued_for_review": "ޑިވައިސްގެ ބަދަލު ސާވަރއާ ދިމާނުވާތީ ރިވިއުއަށް މަޑުކޮށްފައި ވޭ."
    }
  },
  "pms": {
    "filtersTitle": "ފިލްޓަރތައް",
    "routeTitles": {
      "properties": "ޕްރޮޕަޓީތައް",
      "property": "ޕްރޮޕަޓީ",
      "settings": "ޕްރޮޕަޓީ މެނޭޖްމަންޓް ސެޓިންގްސް",
      "ratePlans": "ރޭޓް ޕްލޭންތައް",
      "ratePlan": "ރޭޓް ޕްލޭން",
      "restrictions": "ހިފެހެއްޓުމުގެ ކަލަންޑަރު",
      "availability": "ލިބެންހުރި މިންވަރު",
      "reservations": "ރިޒަވޭޝަންތައް",
      "reservation": "ރިޒަވޭޝަން",
      "groupBlocks": "ގްރޫޕް ބްލޮކްތައް",
      "groupBlock": "ގްރޫޕް ބްލޮކް",
      "guests": "މެހްމާނުން",
      "guest": "މެހްމާން"
    },
    "fields": {
      "adults": "ބޮޑެތި މީހުން",
      "advanceLimits": "ކުރިއަށް ދުވަސް",
      "arrival": "އައުން",
      "arrivalFrom": "އަންނަނީ މިއިން",
      "arrivalTo": "އަންނަނީ މިއަށް",
      "attritionPercent": "އެޓްރިޝަން %",
      "available": "ލިބެންހުރި",
      "baseOccupancy": "އަސާސީ އޮކިއުޕެންސީ",
      "blockNo": "ބްލޮކް",
      "cancellationCharge": "ކެންސަލްކުރުމުގެ ޗާޖް",
      "cancellationPolicy": "ކެންސަލްކުރުމުގެ ސިޔާސަތު",
      "channelDefault": "ކުންފުނީގެ ޑިފޯލްޓް",
      "channels": "ޗެނަލްތައް",
      "chargeKind": "ޗާޖް",
      "checkInTime": "ޗެކް-އިން ގަޑި",
      "checkOutTime": "ޗެކް-އައުޓް ގަޑި",
      "checkTimes": "ޗެކް-އިން / އައުޓް",
      "children": "ކުޑަކުދިން",
      "cleanDeparture": "ފުރުމުގެ ކްރެޑިޓް",
      "cleanStayover": "ސްޓޭއޯވަރ ކްރެޑިޓް",
      "code": "ކޯޑް",
      "commissionable": "ކޮމިޝަން ލިބޭ",
      "company": "ކުންފުނި",
      "costCenter": "ކޮސްޓް ސެންޓަރު",
      "currency": "ފައިސާ",
      "cutoffApplied": "ކަޓް-އޮފް ބޭނުންކުރި",
      "cutoffDays": "ކަޓް-އޮފް ދުވަސް",
      "dateOfBirth": "އުފަން ތާރީޚް",
      "departure": "ފުރުން",
      "document": "ދަތުރުފަތުރުގެ ލިޔުން",
      "documentCountry": "ދޫކުރި ޤައުމު",
      "documentExpires": "ލިޔުން ހަމަވާ ތާރީޚް",
      "documentKind": "ލިޔުމުގެ ބާވަތް",
      "documentNumber": "ލިޔުމުގެ ނަންބަރު",
      "effectiveFrom": "ޢަމަލުކުރަން ފަށާ",
      "effectiveTo": "ޢަމަލުކުރުން ނިމޭ",
      "effectivity": "ޢަމަލުކުރެވޭ",
      "familyName": "ޢާއިލީ ނަން",
      "floor": "ފަންގިފިލާ",
      "from": "އިން",
      "givenName": "ދެވިފައިވާ ނަން",
      "gross": "ޖުމްލަ",
      "guarantee": "ގެރެންޓީ",
      "guaranteeReference": "ގެރެންޓީ ރެފަރެންސް",
      "guest": "މެހްމާން",
      "guests": "މެހްމާނުން",
      "heldUntil": "ހިފެހެއްޓޭ މުއްދަތު",
      "hoursBefore": "އައުމުގެ ކުރީގެ ގަޑިއިރު",
      "housekeeping": "ހައުސްކީޕިން",
      "item": "ވިއްކާ އައިޓަމް",
      "itemClass": "އެކޮމޮޑޭޝަން އައިޓަމް ކްލާސް",
      "kind": "ބާވަތް",
      "location": "ތަން",
      "maxAdults": "އެންމެ ގިނަ ބޮޑެތި މީހުން",
      "maxAdvance": "އެންމެ ގިނަ ކުރިއަށް ދުވަސް",
      "maxChildren": "އެންމެ ގިނަ ކުޑަކުދިން",
      "maxNights": "އެންމެ ގިނަ ރޭ",
      "maxOccupancy": "އެންމެ ގިނަ އޮކިއުޕެންސީ",
      "minAdvance": "އެންމެ މަދު ކުރިއަށް ދުވަސް",
      "minNights": "އެންމެ މަދު ރޭ",
      "nationality": "ޤައުމިއްޔަތު",
      "net": "ނެޓް",
      "nights": "ރޭ",
      "note": "ނޯޓް",
      "notes": "ނޯޓްތައް",
      "occupancy": "އޮކިއުޕެންސީ",
      "offerExpires": "ހުށަހެޅުން ހަމަވާ",
      "openEnded": "ނިމުމެއް ނެތް",
      "outcome": "ނަތީޖާ",
      "overbooking": "އޯވަރބުކިން ކޮޓަރި",
      "package": "ޕެކޭޖް",
      "policy": "ސިޔާސަތު",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "priceBasis": "އަގުގެ އަސާސް",
      "priority": "އިސްކަން",
      "profitCenter": "ފައިދާ ސެންޓަރު",
      "property": "ޕްރޮޕަޓީ",
      "rateGross": "ރޭޓް ޖުމްލަ",
      "ratePlan": "ރޭޓް ޕްލޭން",
      "reason": "ސަބަބު",
      "reservationNo": "ރިޒަވޭޝަން",
      "restricted": "ހިފެހެއްޓިފައި",
      "revenueAccount": "އާމްދަނީ އެކައުންޓް",
      "revenueCenter": "އާމްދަނީ ސެންޓަރު",
      "roomNumber": "ކޮޓަރި",
      "roomType": "ކޮޓަރީގެ ބާވަތް",
      "rooms": "ކޮޓަރި",
      "scope": "ދާއިރާ",
      "section": "ހައުސްކީޕިން ސެކްޝަން",
      "segment": "ސެގްމަންޓް",
      "segments": "ސެގްމަންޓްތައް",
      "sortOrder": "ތަރުތީބު",
      "stay": "ހުރުން",
      "stayDate": "ހުންނަ ތާރީޚް",
      "stayLimits": "ރޭ",
      "tax": "ޓެކްސް",
      "taxChannel": "ޓެކްސް ޗެނަލް",
      "to": "އަށް",
      "unitPrice": "ޔުނިޓް އަގު",
      "vip": "ވީއައިޕީ",
      "wing": "ވިންގް"
    },
    "propertyKind": {
      "resort": "ރިޒޯޓް",
      "hotel": "ހޮޓާ",
      "guesthouse": "ގެސްޓްހައުސް",
      "vessel": "އުޅަނދު",
      "villa": "ވިލާ"
    },
    "propertyStatus": {
      "active": "ޙަރަކާތްތެރި",
      "suspended": "ސަސްޕެންޑްކުރެވިފައި"
    },
    "roomStatus": {
      "active": "ޙަރަކާތްތެރި",
      "retired": "ބޭނުންކުރުން ހުއްޓާލެވިފައި"
    },
    "housekeepingStatus": {
      "dirty": "މުޑުދާރު",
      "cleaning": "ސާފުކުރަނީ",
      "clean": "ސާފު",
      "inspected": "ބަލައި ފާސްކުރެވިފައި"
    },
    "occupancyStatus": {
      "vacant": "ހުސް",
      "occupied": "ބޭނުންކުރެވެމުންދާ"
    },
    "outOfOrderKind": {
      "out_of_order": "ބޭނުންނުކުރެވޭ",
      "out_of_service": "ޚިދުމަތުން ބޭރު"
    },
    "revenueCenterKind": {
      "rooms": "ކޮޓަރި",
      "fnb": "ކާނާއާއި ބުއިން",
      "spa": "ސްޕާ",
      "activities": "ޙަރަކާތްތައް",
      "transfers": "ދަތުރުފަތުރު",
      "minibar": "މިނިބާ",
      "other": "އެހެނިހެން"
    },
    "taxChannel": {
      "accommodation": "އެކޮމޮޑޭޝަން",
      "guesthouse": "ގެސްޓްހައުސް"
    },
    "noShowPolicy": {
      "charge_first_night": "ފުރަތަމަ ރެއަށް ޗާޖްކުރޭ",
      "charge_full_stay": "ހުރިހާ ރެއަކަށް ޗާޖްކުރޭ",
      "no_charge": "ޗާޖެއް ނެތް"
    },
    "chargeKind": {
      "none": "ޗާޖެއް ނެތް",
      "first_night": "ފުރަތަމަ ރޭ",
      "full_stay": "ހުރިހާ ރެއެއް",
      "charge_first_night": "ފުރަތަމަ ރެއަށް ޗާޖްކުރޭ",
      "charge_full_stay": "ހުރިހާ ރެއަކަށް ޗާޖްކުރޭ",
      "no_charge": "ޗާޖެއް ނެތް"
    },
    "ratePlanStatus": {
      "draft": "ދެލިކޮޕީ",
      "active": "ޙަރަކާތްތެރި",
      "closed": "ބަންދު"
    },
    "guaranteeKind": {
      "none": "ނެތް",
      "token": "ކާޑް ޓޯކަން",
      "deposit": "ޑިޕޮސިޓް",
      "company": "ކުންފުނި",
      "travel_agent": "ޓްރެވަލް އެޖެންޓް"
    },
    "priceBasis": {
      "inclusive": "ޓެކްސް ހިމަނައިގެން",
      "exclusive": "ޓެކްސް ނުހިމަނާ"
    },
    "reservationStatus": {
      "quote": "ކޯޓް",
      "held": "ހިފެހެއްޓިފައި",
      "confirmed": "ޔަޤީންކުރެވިފައި",
      "checked_in": "ޗެކް-އިން ވެފައި",
      "checked_out": "ޗެކް-އައުޓް ވެފައި",
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "no_show": "ނާދޭ",
      "waitlisted": "ވެއިޓް ލިސްޓްގައި"
    },
    "waitlistStatus": {
      "waiting": "އިންތިޒާރުގައި",
      "offered": "ހުށަހެޅިފައި",
      "converted": "ބަދަލުކުރެވިފައި",
      "expired": "މުއްދަތު ހަމަވެފައި",
      "withdrawn": "އަނބުރާ ނަގާފައި"
    },
    "groupBlockStatus": {
      "tentative": "ވަގުތީ",
      "definite": "ޔަޤީން",
      "cancelled": "ކެންސަލްކުރެވިފައި",
      "closed": "ބަންދު"
    },
    "roomingStatus": {
      "draft": "ދެލިކޮޕީ",
      "validated": "ސައްޙަކަން ބެލިފައި",
      "applied": "ބޭނުންކުރެވިއްޖެ",
      "failed": "ނާކާމިޔާބު"
    },
    "roomingOutcome": {
      "pending": "އިންތިޒާރުގައި",
      "accepted": "ބަލައިގަނެފި",
      "rejected": "ބޭރުކުރެވިއްޖެ"
    },
    "quoteOutcome": {
      "available": "ލިބެންހުރި",
      "unavailable": "ނުލިބޭ",
      "restricted": "ހިފެހެއްޓިފައި",
      "no_rate": "ރޭޓެއް ނެތް"
    },
    "documentKind": {
      "passport": "ޕާސްޕޯޓް",
      "national_id": "ދިވެހި ރައްޔިތެއްކަން އަންގައިދޭ ކާޑް",
      "driving_licence": "ޑްރައިވިން ލައިސަންސް",
      "unknown": "ރެކޯޑްކުރެވިފައި ނެތް"
    },
    "restrictionReason": {
      "non_payment": "ފައިސާ ނުދެއްކުން",
      "property_damage": "ތަކެއްޗަށް ގެއްލުންދިނުން",
      "abusive_behaviour": "ހަޑިހުތުރު ޢަމަލު",
      "security_concern": "ސަލާމަތީ ކަންބޮޑުވުން",
      "fraud": "މަކަރު",
      "health_and_safety": "ޞިއްޙަތާއި ސަލާމަތް",
      "other": "އެހެނިހެން"
    },
    "preferenceCategory": {
      "room": "ކޮޓަރި",
      "housekeeping": "ހައުސްކީޕިން",
      "dining": "ކެއުން",
      "transport": "ދަތުރުފަތުރު",
      "other": "އެހެނިހެން"
    },
    "outcome": {
      "won": "ބޭނުންކުރެވިއްޖެ",
      "lost": "ބަލިވެއްޖެ",
      "ineligible": "ޙައްޤުނުވާ",
      "out_of_window": "ވިންޑޯއިން ބޭރު",
      "not_configured": "ސެޓްކުރެވިފައި ނެތް",
      "disabled": "ނިއްވާލެވިފައި",
      "not_reached": "ހަމައަށް ނުދޭ"
    },
    "priceSource": {
      "rate_plan": "ރޭޓް ޕްލޭން",
      "derived_rate": "ޑިރައިވްކުރެވުނު ރޭޓް",
      "manual": "އަތުން",
      "published_price_set": "ޝާއިޢުކުރެވުނު އަގުތަކުގެ ސެޓް",
      "base_price_list": "އަސާސީ އަގުތަކުގެ ލިސްޓް",
      "channel_price_list": "ޗެނަލް އަގުތަކުގެ ލިސްޓް",
      "segment_price_list": "ސެގްމަންޓް އަގުތަކުގެ ލިސްޓް",
      "tier_price_list": "ޓިއަރ އަގުތަކުގެ ލިސްޓް",
      "customer_contract": "ކަސްޓަމަރ ކޮންޓްރެކްޓް",
      "contract_price_list": "ކޮންޓްރެކްޓް އަގުތަކުގެ ލިސްޓް",
      "trade_agreement": "ވިޔަފާރި އެއްބަސްވުން",
      "subscription_plan": "ސަބްސްކްރިޕްޝަން ޕްލޭން"
    },
    "reason": {
      "no_rate": "މި ޕްލޭންގައި މި ރެއަށް ރޭޓެއް ޝާއިޢުކުރެވިފައި ނުވޭ.",
      "no_rate_plan": "މި ލައިންގައި ރޭޓް ޕްލޭނެއް ބުނެފައި ނުވޭ، އެހެންވެ ރޭޓް ޕްލޭނަކުން މި އަގުނުކުރެވޭނެ.",
      "rate_plan_posted": "މި ރެއަށް {code} ގައި ޕޯސްޓްކުރެވިފައިވާ ރޭޓުން އަގުކުރެވިފައި.",
      "rate_plan_channel": "{code} ވިއްކަނީ {channel} ޗެނަލްގައެއް ނޫން.",
      "derived_rate": "{code} އެއްވެސް މައި ޕްލޭނަކުން ޑިރައިވްނުކުރޭ، އެހެންވެ ޑިރައިވްކުރާނެ އެއްޗެއް ނެތް.",
      "derived_rate_too_deep": "{code} ން ފެށޭ ޑެރިވޭޝަން ޗެއިން، އިންޖީނުން ހިނގާ މިންވަރަށްވުރެ ފުން.",
      "rate_closed": "މި ޕްލޭންގައި {date} ބަންދު.",
      "rate_cta": "{date} އައުމަށް ބަންދު، އެހެންވެ ހުރުމަކަށް އެ ހިމެނިދާނެ، އެކަމަކު އެއިން ފެށިގެންނުވާނެ.",
      "rate_ctd": "{date} ފުރުމަށް ބަންދު، އެހެންވެ ހުރުމަކަށް އެ ހިމެނިދާނެ، އެކަމަކު އެއިން ނިމިގެންނުވާނެ.",
      "rate_minlos": "{date} ގައި އެންމެ ކުރު ހުރުމަކީ {minLengthOfStay} ރޭ.",
      "rate_maxlos": "{date} ގައި އެންމެ ދިގު ހުރުމަކީ {maxLengthOfStay} ރޭ."
    },
    "waterfall": {
      "title": "މި އަގު މިހެން ހުރީ ކީއްވެ",
      "none": "މި ރެއަށް ސާވަރުން އެއްވެސް ވިސްނުމެއް ރެކޯޑްކޮށްފައި ނުވޭ."
    },
    "properties": {
      "title": "ޕްރޮޕަޓީތައް",
      "description": "ކުންފުނިން ހިންގާ ކޮންމެ ޕްރޮޕަޓީއެއް، އަދި އޭގެ ކޮޓަރީގެ ރޭތަކުގެ އަގު ކަނޑައަޅާ ހަތަރު ފީލްޑް.",
      "tableTitle": "ޕްރޮޕަޓީ ރަޖިސްޓަރީ",
      "caption": "ޚިޔާރުކުރެވުނު ކުންފުނީގެ ޕްރޮޕަޓީތައް، ބާވަތާއި، ޓެކްސް ޗެނަލާއި، ފައިސާއާއި، ޗެކް-އިން އަދި ޗެކް-އައުޓް ގަޑިއާއި، އޯވަރބުކިން އެލަވަންސްއާއެކު.",
      "create": "އައު ޕްރޮޕަޓީ",
      "dialogDescription": "ޕްރޮޕަޓީއަކީ ކޮޓަރީގެ ބާވަތްތަކާއި، ކޮޓަރިތަކާއި، ރޭޓް ޕްލޭންތަކާއި، ލިބެންހުރި މިންވަރާއި، ނައިޓް އޮޑިޓް ގުޅިފައިވާ އަސާސް.",
      "chooseCompany": "ޕްރޮޕަޓީތައް ބެލުމަށް ކުންފުންޏެއް ޚިޔާރުކުރޭ. ކޮންމެ ޕްރޮޕަޓީއެއް ނިސްބަތްވަނީ ހަމައެކަނި އެއް ކުންފުންޏަކަށް، އަދި ރަޖިސްޓަރީ ބެހިފައިވަނީ ތިބާއަށް ހުއްދަ ކުންފުނިތަކަށް.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން",
      "empty": "އަދި ޕްރޮޕަޓީއެއް ނެތް — ކޮޓަރީގެ ބާވަތްތަކާއި، ރޭޓްތަކާއި، ރިޒަވޭޝަންތަކަށް ތަނެއް ދިނުމަށް އެއް އުފައްދާ.",
      "loadFailed": "ޕްރޮޕަޓީ ރަޖިސްޓަރީ ނުލޯޑްކުރެވުނު.",
      "saved": "ޕްރޮޕަޓީ އުފެއްދިއްޖެ",
      "saveFailed": "ޕްރޮޕަޓީ ނުއުފެއްދުނު.",
      "kindHint": "މިއީ ހަމައެކަނި ދެއްކުމަކަށް ނޫން: ދިވެހިރާއްޖޭގެ ޕެކުން ރެއަކަށް ނަގާ ގްރީން ޓެކްސް ކަނޑައަޅަނީ ބާވަތުން ދޭހަވާ ޓެކްސް ޗެނަލުން، ގެސްޓްހައުސްއަކަށް ރިޒޯޓަކާ ތަފާތު ރޭޓެއްގައި.",
      "locationHint": "ޕްރޮޕަޓީ ހުންނަ ތަން. އެއީ ޓެކްސް އިންޖީނުން ދާއިރާ ކަނޑައަޅާ އަސާސް، އަދި އޮޕަރޭޓިން ކަލަންޑަރުން ވިޔަފާރި ދުވަސް ގުޅުވާ ތަން.",
      "channelHint": "ހުހަށް ބެހެއްޓުމުން، އެކޮމޮޑޭޝަން އަގުކުރެވެނީ ކުންފުނީގެ ޑިފޯލްޓް ޗެނަލްގައި، އެއީ ބެކް-އޮފީސް ޗެނަލް، އަދި ޓެކްސް ނުހިމަނާ. ގަސްދުގައި ކަނޑައަޅާ.",
      "itemClassHint": "ޕްރޮޕަޓީން ޕެކްގެ ޑިފޯލްޓް ބޭނުންނުކުރާނަމަ، ކޮޓަރީގެ ރޭތައް ވިއްކާ އައިޓަމް ކްލާސް.",
      "overbookingHint": "ޙަޤީޤީ ޢަދަދަށްވުރެ އިތުރަށް ލިބެންހުރި މިންވަރުގެ އިންޖީނަށް ވިއްކޭނެ ކޮޓަރީގެ ޢަދަދު. ސުމަކީ ޙަޤީޤީ ޖަވާބެއް، އަދި ތިނަކާ ތަފާތު ޖަވާބެއް."
    },
    "property": {
      "description": "އެއް ޕްރޮޕަޓީއަކަށް ނިސްބަތްވާ ހުރިހާ އެއްޗެއް: އެއީ ކޮބައިކަން، ވިއްކަނީ ކޮންއެއްޗެއްކަން، ހުރީ ކޯއްޗެއްކަން، ފައިސާ ދަނީ ކޮންތާކަށްކަން، އަދި ނުވިއްކޭ އެއްޗެހި.",
      "link": "ޕްރޮޕަޓީ",
      "loadFailed": "ޕްރޮޕަޓީ ނުލޯޑްކުރެވުނު.",
      "saved": "ޕްރޮޕަޓީ ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޕްރޮޕަޓީ ރައްކާނުކުރެވުނު.",
      "statusHint": "ސަސްޕެންޑްކުރެވިފައިވާ ޕްރޮޕަޓީގެ ތާރީޚް ބާކީވެ، އެއްވެސް އެއްޗެއް ނުވިއްކާ.",
      "tabsLabel": "ޕްރޮޕަޓީގެ ބައިތައް",
      "tabs": {
        "overview": "ޚުލާޞާ",
        "roomTypes": "ކޮޓަރީގެ ބާވަތްތައް",
        "rooms": "ކޮޓަރި",
        "revenueCenters": "އާމްދަނީ ސެންޓަރުތައް",
        "outOfOrder": "ބޭނުންނުކުރެވޭ"
      }
    },
    "roomTypes": {
      "title": "ކޮޓަރީގެ ބާވަތްތައް",
      "description": "ޕްރޮޕަޓީން ވިއްކާ އެއްޗާއި، ލިބެންހުރި މިންވަރު ގުނާ އަސާސް. ރޭޓް ޕްލޭނަކުން އަގުކުރަނީ ކޮޓަރީގެ ބާވަތެއް، ދުވަހަކުވެސް ކޮޓަރިއެއް ނޫން.",
      "caption": "މި ޕްރޮޕަޓީގެ ކޮޓަރީގެ ބާވަތްތައް، އޮކިއުޕެންސީ ޙައްދުތަކާއި، ހައުސްކީޕިން ކްރެޑިޓާއި، އޯވަރބުކިން އޯވަރައިޑާއެކު.",
      "create": "އައު ކޮޓަރީގެ ބާވަތް",
      "dialogDescription": "ކޮޓަރީގެ ބާވަތުގައި ހިމެނެނީ އޭގެ ރޭތައް ވިއްކާ އައިޓަމާއި، ރޭޓުން ހިމަނާ އޮކިއުޕެންސީއާއި، ސާފުކުރުމަށް ހައުސްކީޕިން ބޯޑަށް ހިނގާ ކްރެޑިޓް.",
      "empty": "އަދި ކޮޓަރީގެ ބާވަތެއް ނެތް — ރޭޓެއް ޝާއިޢުކުރުމުގެ ކުރިން އެއް އިތުރުކުރޭ، ސަބަބަކީ ރޭޓަކުން އަގުކުރަނީ ކޮޓަރީގެ ބާވަތެއް.",
      "saved": "ކޮޓަރީގެ ބާވަތް އުފެއްދިއްޖެ",
      "saveFailed": "ކޮޓަރީގެ ބާވަތް ނުއުފެއްދުނު.",
      "itemHint": "ކޮޓަރީގެ ރެއެއް ވިއްކާ އައިޓަމް. އޭގެ ޓެކްސް ގްރޫޕުން އެކޮމޮޑޭޝަން ޖީއެސްޓީއާއި ރެއަކަށް ނަގާ ލެވީ ކަނޑައަޅާ؛ އެއާ ނުލައި ފޯލިއޯ ޗާޖެއް ނައިޓް އޮޑިޓްގައި ބައިނުކުރެވި ހުންނާނެ.",
      "cleanHint": "ސާފުކުރުމަކަށް ހައުސްކީޕިން ބޯޑަށް ކްރެޑިޓުން ހިނގާ ޚަރަދު. ލިޔުނު ގޮތަށް ފޮނުވޭ — ބޯޑް ބެލެންސްކުރަނީ ސާވަރުން.",
      "overbookingHint": "ޕްރޮޕަޓީގެ އެލަވަންސް ބޭނުންކުރުމަށް ހުހަށް ބާއްވާ.",
      "inheritsOverbooking": "ޕްރޮޕަޓީން ނަގާ"
    },
    "rooms": {
      "title": "ކޮޓަރި",
      "description": "ޙަޤީޤީ ކޮޓަރިތަކާއި، އެ ކޮޓަރީގެ ބާވަތާއި، ހައުސްކީޕިންއަށް އެ ފެންނާނެ ތަން.",
      "caption": "މި ޕްރޮޕަޓީގެ ކޮޓަރިތައް، ކޮޓަރީގެ ބާވަތާއި، ފަންގިފިލާއާއި، ވިންގާއި، ހައުސްކީޕިން ސެކްޝަނާއި، މިހާރުގެ ހައުސްކީޕިން އަދި އޮކިއުޕެންސީ ސްޓޭޓަސްއާއެކު.",
      "create": "އައު ކޮޓަރި",
      "dialogDescription": "ކޮޓަރިއެއް ނިސްބަތްވަނީ ހަމައެކަނި އެއް ބާވަތަކަށް، އަދި ފައިސާ ކަނޑައަޅަނީ އެއިން: ލިބެންހުރި މިންވަރު ގުނަނީ ކޮޓަރީގެ ބާވަތުން.",
      "empty": "އަދި ކޮޓަރިއެއް ނެތް — ލިބެންހުރި މިންވަރު ގުނާނެ އެއްޗެއް ދިނުމަށް ކޮޓަރި އިތުރުކުރޭ.",
      "saved": "ކޮޓަރި އުފެއްދިއްޖެ",
      "saveFailed": "ކޮޓަރި ނުއުފެއްދުނު.",
      "sectionHint": "މި ކޮޓަރި ޙަވާލުކުރެވިފައިވާ ހައުސްކީޕިން ސެކްޝަން. ބޯޑުތައް ބިނާވަނީ ސެކްޝަންތަކުން.",
      "connectTo": "ގުޅުވާ ކޮޓަރި",
      "connectHint": "ގުޅުވާ ދޮރެއް. ގުޅުވުން ދެފަރާތަށްވެސް އެއްގޮތް؛ ސާވަރުން ރައްކާކުރަނީ ކުޑަ އައިޑީ ކުރިއަށްލައިގެން.",
      "connected": "ކޮޓަރިތައް ގުޅުވިއްޖެ",
      "connectFailed": "ކޮޓަރިތައް ނުގުޅުވުނު.",
      "disconnect": "ގުޅުން ކަނޑާލާ",
      "disconnectFrom": "ގުޅުން ކަނޑާލާ ކޮޓަރި",
      "disconnectTo": "…މި ކޮޓަރިން",
      "disconnected": "ކޮޓަރިތަކުގެ ގުޅުން ކެނޑިއްޖެ",
      "disconnectFailed": "ކޮޓަރިތަކުގެ ގުޅުން ނުކެނޑުނު.",
      "connectionsNote": "ގުޅުންތައް މިތަނުން އުފެއްދުމާއި ފޮހެލެވޭނެ، އެކަމަކު ލިސްޓެއް ނުދެއްކޭ: ކޮޓަރިއެއްގެ މިހާރުގެ ގުޅުންތައް ކިޔޭނެ އޭޕީއައި އެއް ނެތް، އެހެންވެ ތާވަލެއް ދެއްކިނަމަ މި ސްކްރީނުން ކުރާނީ ހީކުރުމެއް."
    },
    "outOfOrder": {
      "title": "ބޭނުންނުކުރެވޭ",
      "description": "ނުވިއްކޭ ކޮޓަރިތަކާއި، ވިއްކޭ ނަމަވެސް ފާހަގަކުރެވިފައިވާ ކޮޓަރިތައް. ހަމައެކަނި ހުޅުވިފައިވާ ރެކޯޑްތައް.",
      "caption": "މި ޕްރޮޕަޓީގެ ކޮޓަރިތަކުގެ ބޭނުންނުކުރެވޭ އަދި ޚިދުމަތުން ބޭރު ހުޅުވިފައިވާ ރެކޯޑްތައް، އެ ހިމެނޭ ތާރީޚްތަކާއި ދެވިފައިވާ ސަބަބާއެކު.",
      "create": "ކޮޓަރިއެއް ބޭރުކުރޭ",
      "dialogDescription": "ބޭނުންނުކުރެވޭ ކަމުގައި ހެދުމުން ކޮޓަރި ލިބެންހުރި މިންވަރުން ނަގާ. ޚިދުމަތުން ބޭރުކުރުމުން ވިއްކޭގޮތަށް ބާއްވާ ފާހަގަކުރޭ. ޚިޔާރުކުރުމަކީ އެ ނިންމުން.",
      "empty": "ހުރިހާ ކޮޓަރިއެއް ލިބެން ހުރި. މިއަދު އެއްވެސް ކޮޓަރިއެއް ބޭނުންނުކުރެވޭ ނުވަތަ ޚިދުމަތުން ބޭރު ނުވޭ.",
      "release": "ދޫކޮށްލާ",
      "released": "ކޮޓަރި ދޫކޮށްލެވިއްޖެ",
      "releaseFailed": "ކޮޓަރި ދޫނުކުރެވުނު.",
      "saved": "ކޮޓަރި ބޭރުކުރެވިއްޖެ",
      "saveFailed": "ކޮޓަރި ބޭރުނުކުރެވުނު.",
      "reasonHint": "ލާޒިމް. ސަބަބެއް ނެތް ރެކޯޑަކީ، ގޯހީ ކޮންކަމެއްކަން ނޭނގި މީހަކު އަލުން ބޭނުންކުރަން ފަށާނެ ކޮޓަރިއެއް.",
      "consequenceOutOfOrder": "ބޭނުންނުކުރެވޭ ކަމުގައި ހެދުމުން މި ކޮޓަރި، ރޭންޖުގެ ކޮންމެ ތާރީޚަކުންވެސް ލިބެންހުރި މިންވަރުގެ ޢަދަދުން ނަގާ. އެއްވެސް މީހަކަށް އެ ނުވިއްކޭނެ، އަދި އޭގައި ހިމެނޭ ކޮންމެ ރެއަކީ ޕްރޮޕަޓީން ނުވިއްކަން ނިންމި ރެއެއް.",
      "consequenceOutOfService": "ޚިދުމަތުން ބޭރުކުރުމުން މި ކޮޓަރި ވިއްކޭގޮތަށް ބާއްވާ ފާހަގަކުރޭ. ޚިޔާރުކުރާނީ ހަމައެކަނި މެހްމާނަކު ބަލައިގަންނާނެ މަސައްކަތަކަށް."
    },
    "revenueCenters": {
      "title": "އާމްދަނީ ސެންޓަރުތައް",
      "description": "ޗާޖެއްގެ އާމްދަނީ ދާ ތަން. ސެންޓަރެއްގެ އެކައުންޓުން، އެއިން ޕޯސްޓްކުރެވޭ ކޮންމެ އެއްޗަކަށް ކުންފުނީގެ ޑިފޯލްޓް އޯވަރައިޑްކުރޭ.",
      "caption": "މި ޕްރޮޕަޓީގެ އާމްދަނީ ސެންޓަރުތައް، ކޮންމެ އެއްޗެއް ޕޯސްޓްކުރާ އާމްދަނީ އެކައުންޓާއި، ކޮސްޓް ސެންޓަރާއި، ފައިދާ ސެންޓަރާއެކު.",
      "create": "އައު އާމްދަނީ ސެންޓަރު",
      "dialogDescription": "ހަމައެކަނި ޕޯސްޓްކުރެވޭ އެކައުންޓް: މިތާ ހެޑަރ އެކައުންޓެއް ދިނުމުން އެނގޭނީ ނައިޓް އޮޑިޓް ޕޯސްޓްކުރަން ދެކޮޅު ހަދާ ހިސާބުން.",
      "empty": "އަދި އާމްދަނީ ސެންޓަރެއް ނެތް — ދެވަނަ ޗާޓް އޮފް އެކައުންޓްސްއެއް ނެތި ސްޕާ ކޮޓަރިތަކާ ވަކިން ރިޕޯޓްކުރުމަށް އެއް އިތުރުކުރޭ.",
      "saved": "އާމްދަނީ ސެންޓަރު އުފެއްދިއްޖެ",
      "saveFailed": "އާމްދަނީ ސެންޓަރު ނުއުފެއްދުނު.",
      "accountHint": "ޕްރޮޕަޓީ މެނޭޖްމަންޓް ސެޓިންގްސްގައިވާ ކުންފުނީގެ ޑިފޯލްޓް އާމްދަނީ އެކައުންޓް ބޭނުންކުރުމަށް ހުހަށް ބާއްވާ.",
      "usesDefault": "ކުންފުނީގެ ޑިފޯލްޓް"
    },
    "settings": {
      "title": "ޕްރޮޕަޓީ މެނޭޖްމަންޓް ސެޓިންގްސް",
      "description": "ނައިޓް އޮޑިޓުން ޕޯސްޓްކުރާ އަށް އެކައުންޓް، އަދި ރޯލް ބިނާވެފައިވާ ދެ ނިންމުން.",
      "accountsTitle": "އެކައުންޓް މެޕް",
      "chooseCompany": "ކުންފުންޏެއް ޚިޔާރުކުރޭ. އެކައުންޓް މެޕަކީ ކުންފުންޏަކަށް އެއް މެޕް، ސަބަބަކީ ޗާޓް އޮފް އެކައުންޓްސްވެސް އެގޮތަށްވާތީ.",
      "loadFailed": "ސެޓިންގްސް ނުލޯޑްކުރެވުނު.",
      "saved": "ސެޓިންގްސް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ސެޓިންގްސް ރައްކާނުކުރެވުނު.",
      "unset": "އަދި ސެޓްކުރެވިފައި ނުވޭ: {accounts}. އެއާ ނުލައި ނައިޓް އޮޑިޓަށް ޕޯސްޓެއް ނުކުރެވޭނެ.",
      "guestLedger": "މެހްމާނުންގެ ލެޖަރު",
      "guestLedgerHint": "މެހްމާން ތަނުގައި ހުންނައިރު ފޯލިއޯ ބެލެންސްއަކީ ލިބެންޖެހޭ ފައިސާ. ކޮންމެ ކޮޓަރީގެ ރެއެއްގެ ޗާޖަކުން އެއަށް ޑެބިޓްކުރެވޭ.",
      "depositLiability": "ޑިޕޮސިޓް ލައިބިލިޓީ",
      "depositLiabilityHint": "ހުރުމުގެ ކުރިން ނަގާ ފައިސާއަކީ އާމްދަނީއެއް ނޫން، އަދި މެހްމާނުންގެ ލެޖަރެއްވެސް ނޫން. ހުރުމުން އެ ބޭނުންކުރެވެންދެން އެއީ ލައިބިލިޓީއެއް.",
      "packageLedger": "ޕެކޭޖް ލެޖަރު",
      "packageLedgerHint": "ބޯޑް ބޭސިސް ކާވް-އައުޓް، ޗާޖްކުރެވޭ ރެއާއި އެ ހޯދާ އައުޓްލެޓާ ދެމެދު ބާއްވާ ތަން. ބޯޑް ޕްލޭން ނެތް ޕްރޮޕަޓީއަކުން ބޭނުމެއް ނުކުރޭ.",
      "allowance": "އެލަވަންސް",
      "allowanceHint": "ރައިޓް-އޮފްކުރެވޭ ޗާޖެއް ދާ ތަން. ވަކި ހުއްދައެއްގެ ދަށުން، ވަކިން ޕޯސްޓްކުރެވޭ، މީހަކަށް އެ ބެލޭގޮތަށް.",
      "commissionExpense": "ކޮމިޝަން ޚަރަދު",
      "commissionPayable": "ދައްކަންޖެހޭ ކޮމިޝަން",
      "defaultRevenue": "ޑިފޯލްޓް އާމްދަނީ",
      "defaultRevenueHint": "އާމްދަނީ ސެންޓަރެއް ނެތް ޗާޖެއް ދާ ތަން. އާމްދަނީ ސެންޓަރެއްގެ އަމިއްލަ އެކައުންޓުން މި އޯވަރައިޑްކުރޭ.",
      "cashRounding": "ފައިސާ ރައުންޑްކުރުން",
      "noShowPolicy": "ނާންނަ ފަރާތުގެ ސިޔާސަތު",
      "noShowPolicyHint": "ކެންސަލްކުރުމުގެ ސިޔާސަތަކުން އެހެން ނުބުނާނަމަ، ނާންނަ ރިޒަވޭޝަނަކަށް ރޯލުން ބޭނުންކުރާ އެއްޗެއް.",
      "resumeWindow": "އޮޑިޓް އަލުން ފެށޭ ވިންޑޯ (ގަޑިއިރު)",
      "resumeWindowHint": "މިވަރު ގަޑިއިރު ފަހުން، ދޫކޮށްލެވިފައިވާ ނައިޓް އޮޑިޓް ރަންއެއް ކުރިއަށް ގެންދިއުމުގެ ބަދަލުގައި އަލުން ފަށަންޖެހޭ.",
      "noLegalEntity": "ތިބާއަށް ލީގަލް އެންޓިޓީއެއް ލިބިފައިނުވާތީ، ދައްކާނެ އެކައުންޓް މެޕެއް ނެތް. އެޑްމިނިސްޓްރޭޓަރަކާ ގުޅުއްވާ."
    },
    "ratePlans": {
      "title": "ރޭޓް ޕްލޭންތައް",
      "description": "ޕްރޮޕަޓީން ރެއެއް ވިއްކާ އަގާއި، ވިއްކާ ފަރާތާއި، ޝަރުޠުތައް.",
      "tableTitle": "ރޭޓް ޕްލޭންތައް",
      "caption": "މި ޕްރޮޕަޓީގެ ރޭޓް ޕްލޭންތައް، ފައިސާއާއި، ޢަމަލުކުރެވޭ މުއްދަތާއި، ހުރުމާއި ކުރިއަށް ދުވަހުގެ ޙައްދުތަކާއި، ޗެނަލްތަކާއި، ގެރެންޓީއާއި، ސްޓޭޓަސްއާއެކު.",
      "create": "އައު ރޭޓް ޕްލޭން",
      "dialogDescription": "ޕްލޭން އުފެދެނީ ދެލިކޮޕީއެއްގެ ގޮތުގައި، ޙަރަކާތްތެރިކުރެވެންދެން އެއްވެސް އެއްޗެއް އަގުނުކުރޭ. ޙަރަކާތްތެރިކުރުމަކީ ވަކި ހުއްދައެއްގެ ދަށުން ކުރެވޭ ވަކި ޢަމަލެއް.",
      "chooseProperty": "ކުންފުންޏަކާއި ޕްރޮޕަޓީއެއް ޚިޔާރުކުރޭ. ރޭޓް ޕްލޭނެއް ނިސްބަތްވަނީ އެއް ޕްރޮޕަޓީއަކަށް، އަދި ޝާއިޢުކުރަނީ އެ ޕްރޮޕަޓީގެ ފައިސާއިން.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ނަން",
      "empty": "އަދި ރޭޓް ޕްލޭނެއް ނެތް — އެއް އުފައްދާ، ގްރިޑް ފުރާ، ދެން ވިއްކަން ފެށުމަށް ޙަރަކާތްތެރިކުރޭ.",
      "loadFailed": "ރޭޓް ޕްލޭންތައް ނުލޯޑްކުރެވުނު.",
      "saved": "ރޭޓް ޕްލޭން އުފެއްދިއްޖެ",
      "saveFailed": "ރޭޓް ޕްލޭން ނުއުފެއްދުނު.",
      "capped": "ދައްކަނީ ފުރަތަމަ {limit}. މި އެންޑްޕޮއިންޓުން ޖަވާބުދެނީ އާދައިގެ އެރޭއަކުން، ކާސާއެއް ނުދޭ، އެހެންވެ އެއްލާނެ ޞަފްޙާއެއް ނެތް — ބާކީ ބެލުމަށް ފިލްޓަރ ހަނިކުރޭ.",
      "allChannels": "ހުރިހާ ޗެނަލެއް",
      "allSegments": "ހުރިހާ ސެގްމަންޓެއް",
      "commissionable": "އާދެ",
      "commissionableLabel": "މި ޕްލޭނަށް ކޮމިޝަން ދައްކަންޖެހޭ",
      "commissionableHint": "ޗެނަލް ކޮމިޝަން ޖަމާވަނީ މި ޕްލޭންގައި ހުރުމެއް ޕޯސްޓްކުރެވުމުން، ސްޓޭޓްމަންޓް އައުމަކުން ނޫން.",
      "channelsHint": "ކޮމާއިން ވަކިކުރެވިފައިވާ ކޯޑްތައް. ހުހަށް ބެހެއްޓުމުން ހުރިހާ ޗެނަލެއް.",
      "segmentsHint": "ކޮމާއިން ވަކިކުރެވިފައިވާ ކޯޑްތައް. ހުހަށް ބެހެއްޓުމުން ހުރިހާ ސެގްމަންޓެއް.",
      "guaranteeHint": "ނާންނަ ފަރާތަކާ ދެކޮޅަށް ޕްރޮޕަޓީން ހިފަހައްޓާ އެއްޗެއް. ކޮންމެ ރިޒަވޭޝަނަކަށް ސްނެޕްޝޮޓްކުރެވޭ، އެހެންކަމުން ފަހުން ބަދަލުކުރުމުން މިހާރު ނަގާފައިވާ ބުކިންތައް ބަދަލެއް ނުވޭ.",
      "policyHint": "ޔަޤީންކުރާއިރު ރިޒަވޭޝަނަށް ސްނެޕްޝޮޓްކުރެވޭ. ޕްރޮޕަޓީގެ ޑިފޯލްޓް ބޭނުންކުރުމަށް ހުހަށް ބާއްވާ.",
      "openEndedHint": "ނިމުމެއް ނެތް ޕްލޭނަކަށް ހުސްކޮށް ބާއްވާ.",
      "draftNote": "ޕްލޭން އުފެދެނީ ޕްރޮޕަޓީގެ ފައިސާ {currency} އިން ދެލިކޮޕީއެއްގެ ގޮތުގައި، އަދި ޝާއިޢުކުރުމުގެ ބާރު ލިބިފައިވާ މީހަކު ޙަރަކާތްތެރިކުރަންދެން އެއްވެސް އެއްޗެއް އަގުނުކުރޭ."
    },
    "ratePlan": {
      "description": "ޝަރުޠުތަކާއި، ގްރިޑާއި، ޑެރިވޭޝަން. ގްރިޑް ރައްކާކުރުމާއި ޕްލޭން ލައިވްކުރުމަކީ ދެ ބާރެއް.",
      "loadFailed": "ރޭޓް ޕްލޭން ނުލޯޑްކުރެވުނު.",
      "tabsLabel": "ރޭޓް ޕްލޭންގެ ބައިތައް",
      "tabs": {
        "grid": "ރޭޓް ގްރިޑް",
        "terms": "ޝަރުޠުތައް",
        "derivation": "ޑެރިވޭޝަން"
      },
      "activate": "ޙަރަކާތްތެރިކުރޭ",
      "activated": "ރޭޓް ޕްލޭން ޙަރަކާތްތެރިކުރުމަށް ހުށަހެޅިއްޖެ",
      "activateFailed": "ރޭޓް ޕްލޭން ޙަރަކާތްތެރިނުކުރެވުނު.",
      "draftWarning": "މި ޕްލޭނަކީ ދެލިކޮޕީއެއް. އެއްވެސް އެއްޗެއް އަގުނުކުރޭ: އަގުކުރުމުގެ ހިނގުމުން ބަލަނީ އެ ތާރީޚުގައި ޕްލޭން ޙަރަކާތްތެރިތޯ، އަދި ދެލިކޮޕީއެއް ޙަރަކާތްތެރިއެއް ނޫން.",
      "basisFromPack": "ޓެކްސް ޕެކުން",
      "basisNote": "ޕްލޭންގައި އަގުގެ އަސާސް ކަނޑައަޅާފައި ނުވާނަމަ، ޕްރޮޕަޓީގެ ޗެނަލަށް ޝާއިޢުކުރެވިފައިވާ ރޭޓަކީ ޓެކްސް ހިމަނައިގެންތޯ ނުވަތަ ނުހިމަނާތޯ ކަނޑައަޅަނީ ޓެކްސް ޕެކުން. މިތާ ދުވަހަކުވެސް ހީއެއް ނުކުރެވޭ."
    },
    "rateGrid": {
      "title": "ރޭޓް ގްރިޑް",
      "description": "ހުންނަ ތާރީޚުން ކޮޓަރީގެ ބާވަތް. އެރޯ ކީތަކުން ހަރަކާތްކުރޭ، އެންޓަރއިން ތިރިއަށް، އެސްކޭޕުން ސެލް އަނބުރާ، އަދި ސެލްއަކަށް ޕޭސްޓްކުރާ ސްޕްރެޑްޝީޓް ބްލޮކަކުން ކަނާތަށާއި ތިރިއަށް ފުރޭ.",
      "caption": "ޚިޔާރުކުރެވުނު ވިންޑޯގައި މި ޕްލޭނަށް ޝާއިޢުކުރެވިފައިވާ ރޭޓްތައް، ކޮޓަރީގެ ބާވަތަކަށް އެއް ރޯ އަދި ހުންނަ ތާރީޚަކަށް އެއް ކޮލަމް.",
      "empty": "މި ޕްރޮޕަޓީގައި ކޮޓަރީގެ ބާވަތެއް ނެތް، އެހެންވެ ގްރިޑްގައި ރޯއެއް ނެތް. ފުރަތަމަ ކޮޓަރީގެ ބާވަތެއް އިތުރުކުރޭ.",
      "amount": "ރޭޓް",
      "extraAdult": "އިތުރު ބޮޑު މީހާ",
      "extraChild": "އިތުރު ކުޑަކުއްޖާ",
      "showSupplements": "ސަޕްލިމަންޓްތައް ދައްކާ",
      "currencyNote": "ޢަދަދުތައް ހުރީ ޝާއިޢުކުރެވިފައިވާ ގޮތަށް {currency} އިން. ސަޕްލިމަންޓްތައް ބޭނުންކުރަނީ ސާވަރުން، ކޮޓަރީގެ ބާވަތުގެ އަސާސީ އޮކިއުޕެންސީން މަތިން، އަދި މިތާ ދުވަހަކުވެސް އިތުރެއް ނުކުރޭ.",
      "save": "ވިންޑޯ ރައްކާކުރޭ",
      "saved": "ރޭޓްތައް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{count} ރޯ ލިޔެވިއްޖެ",
      "saveFailed": "ރޭޓްތައް ރައްކާނުކުރެވުނު.",
      "loadFailed": "ރޭޓްތައް ނުލޯޑްކުރެވުނު.",
      "unsaved": "ރައްކާނުކުރެވޭ {count} ބަދަލު",
      "previousWindow": "ކުރީގެ ދެ ހަފްތާ",
      "nextWindow": "ދެން އޮތް ދެ ހަފްތާ",
      "badWindow": "ނިމޭ ތާރީޚަށްވުރެ ކުރީގެ ނުވަތަ ހަމަ އެ ފެށޭ ތާރީޚެއް ދޭށެވެ.",
      "truncated": "ވިންޑޯ ދިގުވެފައި، ގްރިޑުން އެ ނުދެއްކޭނެ. ހަނިކުރޭ، ނުވަތަ އެއްފަހަރާ އެއް ވިންޑޯ ބަލަމުން ދޭ.",
      "passthrough": "މި ވިންޑޯގައި އޮކިއުޕެންސީއަށް ޚާއްޞަ {count} ރޭޓް ނުދައްކާ، އަދި ބަދަލެއް ނުކޮށް އަނބުރާ ފޮނުވޭ، އެހެންވެ ރައްކާކުރުމުން އެ ނެތިގެންނުދާނެ.",
      "replaceNote": "ރައްކާކުރުމުން، ދައްކާ ވިންޑޯގައި މި ޕްލޭންގައި ހުރި ކޮންމެ ރޭޓެއް ބަދަލުކުރެވޭ. ހުހަށް ބާއްވާ ސެލްއަކީ އެ ތާރީޚަށް ޕްރޮޕަޓީން ދެން ޝާއިޢުނުކުރާ ރޭޓެއް.",
      "cellLabel": "{date} ގައި {roomType} ގެ {measure}"
    },
    "derivation": {
      "title": "ޑެރިވޭޝަން",
      "description": "މި ޕްލޭން އެހެން ޕްލޭނަކުން، ޑެލްޓާއަކުން، ރައުންޑްކޮށް ޙައްދުކޮށް އަގުކުރޭ. ޗެއިން ހިނގަނީ ރެއަކަށް ކޯޓް ނަގާއިރު، ދުވަހަކުވެސް ރައްކާނުކުރެވޭ.",
      "none": "މި ޕްލޭން އެއްވެސް ތަނަކުން ޑިރައިވްނުކުރޭ، އަގުކުރަނީ އޭގެ އަމިއްލަ ގްރިޑުން. އޭގެ ބަދަލުގައި ޑިރައިވްކުރުމަށް ތިރީގައި މައި ޕްލޭނެއް ބުނޭ.",
      "parent": "މައި ޕްލޭން",
      "parentHint": "މި ޕްލޭން ފެށޭ ޕޯސްޓްކުރެވިފައިވާ ރޭޓް ހުރި ޕްލޭން.",
      "deltaAmount": "ޑެލްޓާ ޢަދަދު",
      "deltaAmountHint": "އިންސައްތައަށްފަހު، މައި ޕްލޭންގެ ރޭޓަށް އިތުރުކުރެވޭ.",
      "deltaPercent": "ޑެލްޓާ އިންސައްތަ",
      "deltaPercentHint": "ޢަދަދުގެ ކުރިން، މައި ޕްލޭންގެ ރޭޓަށް ބޭނުންކުރެވޭ.",
      "rounding": "ރައުންޑްކުރާ މިންވަރު",
      "roundingHint": "ޑިރައިވްކުރެވުނު ރޭޓް ރައުންޑްކުރެވެނީ މި މިންވަރަށް. ސުމެއްނަމަ ފައިސާގެ އަމިއްލަ ސްކޭލަށް ރައުންޑްކުރެވޭ.",
      "floor": "ފަންގިފިލާ",
      "ceiling": "އެންމެ މަތީ ޙައްދު",
      "saved": "ޑެރިވޭޝަން ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ޑެރިވޭޝަން ރައްކާނުކުރެވުނު.",
      "previewTitle": "ޗެއިން ކުރިން ބަލާ",
      "previewDescription": "މިއީ ޙަޤީޤީ ކޯޓެއް، ސިމިއުލޭޝަނެއް ނޫން. އެއްވެސް އެއްޗެއް ނުލިޔޭ، ލިބެންހުރި މިންވަރެއް ނުހިފަހައްޓާ، ނަންބަރެއް ބޭނުމެއް ނުކުރޭ — އަދި މިއީ މެހްމާނަކަށްވެސް ދެވޭނެ ހަމަ އެ ޖަވާބު.",
      "previewCaption": "ކުރިން ބެލުނު ހުރުމަށް އިންޖީނުން ނެރުނު ރެއަކަށް އަގުތައް.",
      "preview": "ކުރިން ބެލުން ހިންގާ",
      "previewEmpty": "ކޮޓަރީގެ ބާވަތަކާއި ހުރުމެއް ޚިޔާރުކުރުމަށްފަހު، އިންޖީނުން ޙަޤީޤަތުގައި ނެރޭ އަގު ބެލުމަށް ކުރިން ބެލުން ހިންގާ.",
      "previewFailed": "ކުރިން ބެލުން ނުހިންގުނު.",
      "waterfallLabel": "ފުރަތަމަ ރޭ އެ އަގުގައި ހުރީ ކީއްވެ"
    },
    "restrictions": {
      "title": "ހިފެހެއްޓުމުގެ ކަލަންޑަރު",
      "description": "ތާރީޚެއް ވިއްކިދާނެތޯ، އަދި ކޮން ޝަރުޠަކާއެކުތޯ. އެއްފަހަރާ އެއް މަސް، ކޮންމެ ދާއިރާއަކަށް އެއް ރޯ.",
      "gridTitle": "މަހުގެ ގްރިޑް",
      "caption": "މަހުގެ ތެރޭގައި މި ޕްރޮޕަޓީގެ ހިފެހެއްޓުންތައް، މުޅި ޕްރޮޕަޓީއަށް އެއް ރޯ އަދި ކޮޓަރީގެ ބާވަތަކަށް އެއް ރޯ.",
      "chooseProperty": "ހިފެހެއްޓުމުގެ ކަލަންޑަރު ބެލުމަށް ކުންފުންޏަކާއި ޕްރޮޕަޓީއެއް ޚިޔާރުކުރޭ.",
      "allRoomTypes": "ހުރިހާ ކޮޓަރީގެ ބާވަތެއް",
      "legend": "C ބަންދު · A އައުމަށް ބަންދު · D ފުރުމަށް ބަންދު · ޢަދަދުތަކަކީ އެންމެ ކުރު އަދި އެންމެ ދިގު ހުރުން. އެރޯތަކުން ހަރަކާތްކުރޭ، ސްޕޭސްއިން ބަންދު ބަދަލުކުރޭ، A އާއި D އިން އައުމާއި ފުރުން ބަދަލުކުރޭ.",
      "previousMonth": "ކުރީގެ މަސް",
      "nextMonth": "ދެން އޮތް މަސް",
      "loadFailed": "ހިފެހެއްޓުމުގެ ކަލަންޑަރު ނުލޯޑްކުރެވުނު.",
      "save": "މަސް ރައްކާކުރޭ",
      "saved": "ހިފެހެއްޓުންތައް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ހިފެހެއްޓުންތައް ރައްކާނުކުރެވުނު.",
      "unsaved": "ރައްކާނުކުރެވޭ ބަދަލުތައް",
      "passthrough": "މި މަހު ރޭޓް ޕްލޭނަށް ޚާއްޞަ {count} ހިފެހެއްޓުން މިތާ އެޑިޓްނުކުރެވޭ، އަދި ބަދަލެއް ނުކޮށް އަނބުރާ ފޮނުވޭ، އެހެންވެ ރައްކާކުރުމުން އެ ނެތިގެންނުދާނެ.",
      "editorTitle": "{date} ގައި {scope}",
      "editorDescription": "ޚިޔާރުކުރެވުނު ސެލްގެ ފަސް ޓޮގުލް. މުޅި ސީޒަނެއް އެކުގައި ބަންދުވާނަމަ ރޭންޖަކަށް ބޭނުންކުރޭ.",
      "cellLabel": "{date} ގައި {scope} ގެ ހިފެހެއްޓުންތައް",
      "closed": "ބަންދު",
      "closedLabel": "މި ތާރީޚް ނުވިއްކޭނެ",
      "closedHint": "ފަހެއްގެ ތެރެއިން އެންމެ ބާރުގަދަ: އެއްވެސް ހުރުމަކަށް މި ތާރީޚް ހިމެނިގެންނުވާނެ.",
      "closedToArrival": "އައުމަށް ބަންދު",
      "ctaLabel": "ހުރުމަކަށް މި ތާރީޚް ހިމެނިދާނެ، އެކަމަކު މި ތާރީޚުން ފެށިގެންނުވާނެ",
      "ctaHint": "ހޮނިހިރު ދުވަހު އައުމުގެ ޤަވާޢިދު، ކޮންމެ ތާރީޚަކަށް ވަކިން ބަޔާންކުރެވިފައި.",
      "closedToDeparture": "ފުރުމަށް ބަންދު",
      "ctdLabel": "ހުރުމަކަށް މި ތާރީޚް ހިމެނިދާނެ، އެކަމަކު މި ތާރީޚުން ނިމިގެންނުވާނެ",
      "ctdHint": "ބާރުބޮޑު ބަދަލުވުމުގެ ދުވަހަކުން ފުރުމެއް ދުރުކުރޭ.",
      "minLos": "އެންމެ ކުރު ހުރުން",
      "maxLos": "އެންމެ ދިގު ހުރުން",
      "bulkFrom": "ފެށޭ ތާރީޚް",
      "bulkTo": "ނިމޭ ތާރީޚް",
      "applyToRange": "ރޭންޖަށް ބޭނުންކުރޭ",
      "applied": "ރޭންޖަށް ބޭނުންކުރެވިއްޖެ",
      "appliedDetail": "{count} ތާރީޚް އަޕްޑޭޓްކުރެވިއްޖެ — އަދި ރައްކާނުކުރެވޭ"
    },
    "availability": {
      "title": "ލިބެންހުރި މިންވަރު",
      "description": "ތާރީޚުން ކޮޓަރީގެ ބާވަތް، ކޮންމެ ޖަވާބެއްގެ ފަހަތުގައިވާ ފަސް ޢަދަދު އެއް ފިތުމަކުން.",
      "gridTitle": "ލިބެންހުރި މިންވަރުގެ ކަލަންޑަރު",
      "caption": "ލިބެންހުރި މިންވަރުގެ އިންޖީނުން ހިސާބުކުރާ ގޮތަށް، ހުންނަ ކޮންމެ ތާރީޚަކަށް ކޮންމެ ބާވަތަކުން ލިބެންހުރި ކޮޓަރި.",
      "chooseProperty": "ލިބެންހުރި މިންވަރު ބެލުމަށް ކުންފުންޏަކާއި ޕްރޮޕަޓީއެއް ޚިޔާރުކުރޭ.",
      "empty": "މި ޕްރޮޕަޓީގައި ކޮޓަރީގެ ބާވަތެއް ނެތް، އެހެންވެ ގުނާނެ އެއްޗެއް ނެތް. ފުރަތަމަ ކޮޓަރީގެ ބާވަތެއް އިތުރުކުރޭ.",
      "loadFailed": "ލިބެންހުރި މިންވަރުގެ ކަލަންޑަރު ނުލޯޑްކުރެވުނު.",
      "previousWindow": "ކުރީގެ ދެ ހަފްތާ",
      "nextWindow": "ދެން އޮތް ދެ ހަފްތާ",
      "showBlocks": "ގްރޫޕް ބްލޮކްތައް ދައްކާ",
      "legend": "ކޮންމެ ސެލްއަކީ އިންޖީނުން ވިއްކާނެ ކޮޓަރި. ރަތް ސެލްއަކީ ނެތުން ނުވަތަ އޯވަރސެލް، އޮރެންޖް ސެލްއަކީ ދޭއް ނުވަތަ އެއަށްވުރެ މަދު، އަދި +n އަކީ ގްރޫޕް ބްލޮކަކުން ހިފެހެއްޓިފައިވާ ކޮޓަރި. ފަހަތުގައިވާ ޢަދަދުތަކަށް ސެލްއަކަށް ފިތާ.",
      "cellLabel": "{date} ގައި {roomType} ލިބެންހުރި މިންވަރު",
      "whyTitle": "{date} ގައި {roomType}",
      "whyDescription": "އިންޖީނުން ބޭނުންކުރި ފަސް އިންޕުޓް، އަދި އެއިން ނެރުނު ޖަވާބު.",
      "whyNote": "ލިބެންހުރި މިންވަރަކީ އިންޖީނުގެ އަމިއްލަ ޢަދަދު، މި ފަހެއް އުނިކޮށްގެން ނެރޭ ޢަދަދެއް ނޫން. އެއީ ކޮންޑިޝަނަލް އަޕްޑޭޓުން ބަލައިގަންނާނެ ޢަދަދު، އޯވަރސެލްއެއް ދޫނުކުރާ ހަމަ އެ ކޯޑުން ހިސާބުކުރެވިފައި — އެހެންވެ އެ ދައްކަނީ އިންޕުޓްތަކުގެ ކައިރީގައި، އެއިން ނެރެގެންނެއް ނޫން.",
      "physicalRooms": "ޙަޤީޤީ ކޮޓަރި",
      "outOfOrder": "ބޭނުންނުކުރެވޭ",
      "committed": "ކޮމިޓްކުރެވިފައި",
      "blocked": "ބްލޮކްތަކުން ހިފެހެއްޓިފައި",
      "overbooking": "އޯވަރބުކިން އެލަވަންސް",
      "available": "ލިބެންހުރި"
    },
    "reservations": {
      "title": "ރިޒަވޭޝަންތައް",
      "description": "ޕްރޮޕަޓީގެ ކޮންމެ ބުކިންއެއް، އަދި އޭގެ ކައިރީގައި ވެއިޓް ލިސްޓް.",
      "tableTitle": "ރިޒަވޭޝަންތައް",
      "caption": "މި ޕްރޮޕަޓީގެ ރިޒަވޭޝަންތައް، ހުރުމާއި، ކޮޓަރީގެ ބާވަތާއި، މެހްމާނުންނާއި، ކޯޓްކުރެވުނު ޖުމްލައާއި، ސްޓޭޓަސްއާއެކު.",
      "create": "އައު ރިޒަވޭޝަން",
      "createFromQuote": "މި ކޯޓް ބުކްކުރޭ",
      "dialogDescription": "ފުރަތަމަ ހުރުމަށް ކޯޓް ނަގާ. ކޮންމެ ރެއެއްގެ އަގާއި، ޓެކުހާއި، ސަބަބު އަންނަނީ އިންޖީނުން، މި ސްކްރީނަކުން ނޫން.",
      "chooseProperty": "ކުންފުންޏަކާއި ޕްރޮޕަޓީއެއް ޚިޔާރުކުރޭ. ރިޒަވޭޝަންތައް ބެހިފައިވަނީ ޕްރޮޕަޓީން، އަދި އެހެން ޕްރޮޕަޓީއެއްގެ ބުކިންއެއް ތިބާއަށް ފެންނާކަށް ނުޖެހޭ.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ރިޒަވޭޝަން ނަންބަރު ނުވަތަ މެހްމާން",
      "empty": "ގުޅޭ ރިޒަވޭޝަނެއް ނެތް. ބުކިންއެއް ނަގާ، ނުވަތަ އައުމުގެ ތާރީޚްތައް ފުޅާކުރޭ.",
      "loadFailed": "ރިޒަވޭޝަންތައް ނުލޯޑްކުރެވުނު.",
      "saved": "ރިޒަވޭޝަން އުފެއްދިއްޖެ",
      "saveFailed": "ރިޒަވޭޝަން ނުއުފެއްދުނު.",
      "unnumbered": "އަދި ނަންބަރު ދެވިފައި ނުވޭ",
      "quote": "ހުރުމަށް ކޯޓް ނަގާ",
      "quoteFailed": "ހުރުމަށް ކޯޓް ނުނެގުނު.",
      "quoteFirst": "އެއްވެސް އެއްޗެއް ބުކްކުރުމުގެ ކުރިން، އަގާއި، ޓެކުހާއި، ކޮންމެ ރެއެއްގެ ލިބެންހުރި މިންވަރު ބެލުމަށް ހުރުމަށް ކޯޓް ނަގާ.",
      "quoteCaption": "މި ހުރުމަށް އިންޖީނުން ނެރުނު ރެއަކަށް އަގުތަކާއި ލިބެންހުރި މިންވަރު.",
      "quoteTotal": "ކޯޓްކުރެވުނު",
      "notSellable": "މި ހުރުމުގެ މަދުވެގެން އެއް ރޭ ނުވިއްކޭ. ނަތީޖާ ކޮލަމުން ކޮން ރެއެއްކަމާއި ސަބަބު ބުނެދޭ؛ އެކަން ޙައްލުވަންދެން ބުކިންއެއް ނުހެދޭނެ.",
      "planHint": "ދެއްކެނީ ހަމައެކަނި ޙަރަކާތްތެރި ޕްލޭންތައް. ދެލިކޮޕީ ޕްލޭނަކުން އެއްވެސް އެއްޗެއް އަގުނުކުރޭ.",
      "waterfallLabel": "ފުރަތަމަ ރޭ އެ އަގުގައި ހުރީ ކީއްވެ",
      "tabsLabel": "ރިޒަވޭޝަން ލިސްޓްތައް",
      "tabsReservations": "ރިޒަވޭޝަންތައް",
      "tabsWaitlist": "ވެއިޓް ލިސްޓް"
    },
    "reservation": {
      "description": "ވަޢުދުވި ގޮތަށް ހުރުން: އޭގެ ރޭތަކާއި، އަގުތަކާއި، ގެރެންޓީއާއި، ބުކްކުރެވުނު ޝަރުޠުތައް.",
      "loadFailed": "ރިޒަވޭޝަން ނުލޯޑްކުރެވުނު.",
      "tabsLabel": "ރިޒަވޭޝަންގެ ބައިތައް",
      "tabs": {
        "nights": "ރޭ",
        "terms": "ޝަރުޠުތައް"
      },
      "nightsTitle": "ރޭ",
      "nightsDescription": "ރިޒަވޭޝަނުގައި ރައްކާކުރެވިފައިވާ އަގުތައް — ޕްރޮޕަޓީން މި މެހްމާނަށް ވަޢުދުވި އެއްޗެއް، ވަޢުދުވި ވަގުތުގައި.",
      "nightsCaption": "ހުރުމުގެ ކޮންމެ ރެއެއް، އޭގެ ޔުނިޓް އަގާއި، ރޭޓާއި، ޕެކޭޖް ޢަދަދާއި، ނެޓާއި، ޓެކުހާއި، ޖުމްލައާއެކު، އަދި ފޯލިއޯއަކަށް ޕޯސްޓްކުރެވިފައިވޭތޯ.",
      "nightsEmpty": "މި ރިޒަވޭޝަންގައި އަގުކުރެވިފައިވާ ރެއެއް ނެތް.",
      "posted": "ޕޯސްޓްކުރެވިފައި",
      "why": "ކީއްވެ",
      "explainNote": "މިއީ ހަމަ އެ އަގުކުރުމުގެ ހިނގުމުގެ މިއަދުގެ ތަފްޞީލު، މި އެއް ރެއަށް ހިންގާފައި. މަތީ ރޯގައިވާ އަގުތަކަކީ މެހްމާނަށް ވަޢުދުވެވުނު އަގުތައް؛ ދޭތި ތަފާތުވާނަމަ، އެ ތަފާތަކީ ޖަވާބު.",
      "explainFailed": "ތަފްޞީލު ނުލޯޑްކުރެވުނު.",
      "waterfallLabel": "{date} އެ އަގުގައި ހުރީ ކީއްވެ",
      "hold": "ހިފަހައްޓާ",
      "held": "ރިޒަވޭޝަން ހިފެހެއްޓިއްޖެ",
      "holdFailed": "ރިޒަވޭޝަން ނުހިފެހެއްޓުނު.",
      "holdNote": "މި ހިފެހެއްޓުމުން {until} އާ ހަމައަށް ލިބެންހުރި މިންވަރު ނަގާފައިވޭ. ކޮޓަރިތައް އާންމު ވިއްކުމުން ބޭރުވެފައި، އަދި އެއަށް އެއްވެސް މީހަކު ފައިސާ ދައްކާފައި ނުވޭ.",
      "confirm": "ޔަޤީންކުރޭ",
      "confirmed": "ރިޒަވޭޝަން ޔަޤީންކުރެވިއްޖެ",
      "confirmFailed": "ރިޒަވޭޝަން ޔަޤީންނުކުރެވުނު.",
      "amend": "އިޞްލާޙުކުރޭ",
      "cancel": "ކެންސަލްކުރޭ",
      "termsTitle": "ކެންސަލްކުރުމުގެ ޝަރުޠުތައް",
      "termsDescription": "ޔަޤީންކުރި އިރު މި ރިޒަވޭޝަނަށް ސްނެޕްޝޮޓްކުރެވުނު ޓިއަރތައް — މިއަދު އޮތް ސިޔާސަތެއް ނޫން.",
      "snapshotCaption": "މި ރިޒަވޭޝަން ބުކްކުރެވުނު ކެންސަލްކުރުމުގެ ޓިއަރތައް.",
      "snapshotEmpty": "މި ރިޒަވޭޝަނަށް ކެންސަލްކުރުމުގެ ޓިއަރއެއް ސްނެޕްޝޮޓްކުރެވިފައި ނުވޭ.",
      "snapshotNote": "މި ބުކިންގެ ފަހުން ޝަރުޠުތައް ބަދަލުކުރި ޕްރޮޕަޓީއަކަށް އެ ޝަރުޠުތައް މި ބުކިންއަށް ބޭނުމެއް ނުކުރެވޭނެ. ކެންސަލްކުރުމުގެ ޗާޖް ހިސާބުކުރަނީ ސާވަރުން، މި ޓިއަރތަކާ އަޅާކިޔައިގެން."
    },
    "waitlist": {
      "title": "ވެއިޓް ލިސްޓް",
      "description": "ޕްރޮޕަޓީއަށް އަދި ނުވިއްކޭ ހުރުމެއް ބޭނުންވާ މެހްމާނުން. އެމީހުންގެ ރިޒަވޭޝަނެއް، ކޮޓަރިއެއް ނުވަތަ އަގެއް ނެތް.",
      "caption": "މި ޕްރޮޕަޓީގެ ވެއިޓް ލިސްޓް އެންޓްރީތައް، ބޭނުންވާ ހުރުމާއި، އިސްކަމާއި، ހުށަހެޅުމުގެ ވިންޑޯއާއެކު.",
      "empty": "މި ޕްރޮޕަޓީއަށް އެއްވެސް މީހަކު އިންތިޒާރުކުރަމުންނުދޭ.",
      "loadFailed": "ވެއިޓް ލިސްޓް ނުލޯޑްކުރެވުނު.",
      "offer": "ހުށަހަޅާ",
      "offered": "ހުށަހެޅުން ފޮނުވިއްޖެ",
      "offerFailed": "ހުށަހެޅުން ނުހުށަހެޅުނު."
    },
    "amend": {
      "title": "ރިޒަވޭޝަން އިޞްލާޙުކުރޭ",
      "description": "ސާވަރުން ކުރީގެ ރޭތައް ދޫކޮށްލައި އައު ރޭތައް ނަގަނީ އެއް ޓްރާންސެކްޝަނުގައި، ހުރުމަށް އަލުން ކޯޓް ނަގާ، އަދި ދެކޮޅު ހެދިދާނެ.",
      "currentStay": "މިހާރުގެ ހުރުން",
      "currentGross": "މިހާރުގެ ޖުމްލަ",
      "submit": "އިޞްލާޙުކުރޭ",
      "saved": "ރިޒަވޭޝަން އިޞްލާޙުކުރެވިއްޖެ",
      "savedDetail": "{released} ރޭ ދޫކޮށްލެވިއްޖެ، {committed} ނެގިއްޖެ",
      "failed": "ރިޒަވޭޝަން އިޞްލާޙުނުކުރެވުނު.",
      "unchanged": "އަދި އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވޭ. ބުކިން އިޞްލާޙުކުރުމަށް ތާރީޚެއް، ކޮޓަރީގެ ބާވަތެއް ނުވަތަ ޢަދަދެއް ބަދަލުކުރޭ.",
      "postedWarning": "މި ހުރުމުގެ {count} ރޭ މިހާރު ފޯލިއޯއަކަށް ޕޯސްޓްކުރެވިފައި. ޕޯސްޓްކުރެވިފައިވާ ރެއެއް ބަދަލުކުރާނެ އިޞްލާޙެއް އަބަދުވެސް ދޫކޮށްލެވޭ.",
      "overrideReason": "އޯވަރައިޑް ސަބަބު",
      "overrideHint": "ބޭނުންވަނީ ހަމައެކަނި، ޕްރޮޕަޓީން އޯވަރައިޑްކުރެވޭގޮތަށް ސެޓްކޮށްފައިވާ ކޮންޓްރޯލެއް އިޞްލާޙުން ހުރަސްކުރާނަމަ."
    },
    "cancel": {
      "title": "ރިޒަވޭޝަން ކެންސަލްކުރޭ",
      "description": "ބުކްކުރެވުނު ޝަރުޠުތަކުގެ ދަށުން، މިއަދު ޢަމަލުކުރެވޭ ޝަރުޠުތަކުން ނޫން.",
      "snapshotCaption": "މި ރިޒަވޭޝަނަށް ސްނެޕްޝޮޓްކުރެވިފައިވާ ކެންސަލްކުރުމުގެ ޓިއަރތައް.",
      "snapshotEmpty": "ޓިއަރއެއް ސްނެޕްޝޮޓްކުރެވިފައި ނުވޭ، އެހެންކަމުން ޕްރޮޕަޓީގެ ޑިފޯލްޓް ނާންނަ ފަރާތުގެ ސިޔާސަތު ބޭނުންކުރެވޭ.",
      "chargeNote": "ޗާޖް ހިސާބުކުރަނީ ސާވަރުން، މި ޓިއަރތަކާއި އައުމުގެ ކުރިން ބާކީ ގަޑިއިރާ އަޅާކިޔައިގެން، ޕްރޮޕަޓީގެ އަމިއްލަ ޓައިމްޒޯނުގައި. ދައްކާނީ ކެންސަލްކުރުމަށްފަހު.",
      "reasonLabel": "ސަބަބު",
      "reasonHint": "ރިޒަވޭޝަނުގައާއި އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑްކުރެވޭ.",
      "submit": "ރިޒަވޭޝަން ކެންސަލްކުރޭ",
      "done": "ރިޒަވޭޝަން ކެންސަލްކުރެވިއްޖެ",
      "failed": "ރިޒަވޭޝަން ކެންސަލްނުކުރެވުނު."
    },
    "groupBlocks": {
      "title": "ގްރޫޕް ބްލޮކްތައް",
      "description": "ގްރޫޕަކަށް ކޮންޓްރެކްޓްކުރެވިފައިވާ ކޮޓަރި، އެއިން ނަގާފައިވާ މިންވަރު، އަދި ބާކީ އަލުން ވިއްކަން ފަށާ ވަގުތު.",
      "tableTitle": "ގްރޫޕް ބްލޮކްތައް",
      "caption": "މި ޕްރޮޕަޓީގެ ގްރޫޕް ބްލޮކްތައް، ހުރުމާއި، ކަޓް-އޮފްއާއި، އެޓްރިޝަން އިންސައްތައާއި، ސްޓޭޓަސްއާއެކު.",
      "create": "އައު ގްރޫޕް ބްލޮކް",
      "dialogDescription": "ބްލޮކް އުފެދެނީ ވަގުތީގޮތުން، ޔަޤީންކުރެވެންދެން އެއްވެސް ކޮޓަރިއެއް ނުހިފަހައްޓާ.",
      "chooseProperty": "ގްރޫޕް ބްލޮކްތައް ބެލުމަށް ކުންފުންޏަކާއި ޕްރޮޕަޓީއެއް ޚިޔާރުކުރޭ.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "ބްލޮކް ނަންބަރު ނުވަތަ ނަން",
      "empty": "އަދި ގްރޫޕް ބްލޮކެއް ނެތް — ބުކްކުރުމުގެ ކުރިން ގްރޫޕަކަށް ކޮޓަރި ކޮންޓްރެކްޓްކުރުމަށް އެއް އުފައްދާ.",
      "loadFailed": "ގްރޫޕް ބްލޮކްތައް ނުލޯޑްކުރެވުނު.",
      "saved": "ގްރޫޕް ބްލޮކް އުފެއްދިއްޖެ",
      "saveFailed": "ގްރޫޕް ބްލޮކް ނުއުފެއްދުނު.",
      "unnumbered": "އަދި ނަންބަރު ދެވިފައި ނުވޭ",
      "cutoffPending": "އަދި ނުވޭ",
      "tentativeNote": "ބްލޮކް އުފެދެނީ ވަގުތީގޮތުން. ޔަޤީންކުރުމުގެ ބާރު ލިބިފައިވާ މީހަކު އެ ޔަޤީނަށް ބަދަލުކުރަންދެން އެއްވެސް ކޮޓަރިއެއް ނުހިފަހައްޓާ، އަދި އެއީ ޕްރޮޕަޓީން އިންވެންޓަރީ ދޫކޮށްލާ ވަގުތު.",
      "cutoffHint": "ނުނަގާ އޮތް އެލޮޓްމަންޓް އަލުން ވިއްކަން ފަށާނީ އައުމުގެ ކިތައް ދުވަސް ކުރިންކަން.",
      "attritionHint": "ކޮންޓްރެކްޓުން މާފުކުރާ އުނިކަން. ސާވަރުން ހުއްދަ ދެވޭ އުނިކަމާއި ޗާޖްކުރެވޭ ކޮޓަރި ހިސާބުކުރަނީ އެއިން، ޙަޤީޤީ ނެގުމާ އަޅާކިޔައިގެން.",
      "planHint": "ގްރޫޕްގެ ބުކިންތައް އަގުކުރެވޭ ރޭޓް ޕްލޭން."
    },
    "groupBlock": {
      "description": "އެލޮޓްމަންޓާއި، ނެގުމާއި، އެޓްރިޝަނާއި، ރޫމިން ލިސްޓް.",
      "loadFailed": "ގްރޫޕް ބްލޮކް ނުލޯޑްކުރެވުނު.",
      "tabsLabel": "ގްރޫޕް ބްލޮކްގެ ބައިތައް",
      "tabs": {
        "allotment": "އެލޮޓްމަންޓް",
        "rooming": "ރޫމިން ލިސްޓް"
      },
      "confirm": "ބްލޮކް ޔަޤީންކުރޭ",
      "confirmed": "ގްރޫޕް ބްލޮކް ޔަޤީންކުރުމަށް ހުށަހެޅިއްޖެ",
      "confirmFailed": "ގްރޫޕް ބްލޮކް ޔަޤީންނުކުރެވުނު.",
      "cutoff": "ކަޓް-އޮފް ބޭނުންކުރޭ",
      "cutoffDone": "ކަޓް-އޮފް ބޭނުންކުރި",
      "cutoffFailed": "ކަޓް-އޮފް ބޭނުންނުކުރެވުނު.",
      "tentativeWarning": "މި ބްލޮކަކީ ވަގުތީ އެއްޗެއް، އަދި އެއްވެސް ކޮޓަރިއެއް ނުހިފަހައްޓާ. ޔަޤީންކުރެވެންދެން އޭގެ އެލޮޓްމަންޓް އެއްވެސް ލިބެންހުރި މިންވަރުގެ ޢަދަދެއްގައި ނުފެންނާނެ.",
      "attritionTitle": "ނެގުމާއި އެޓްރިޝަން",
      "attritionDescription": "ކޮންޓްރެކްޓްކުރެވުނު މިންވަރާއި، ގްރޫޕުން ނެގި މިންވަރާއި، ކޮންޓްރެކްޓުން މާފުކުރާ މިންވަރު.",
      "attritionNote": "ހުއްދަ ދެވޭ އުނިކަމާއި ޗާޖްކުރެވޭ ކޮޓަރި ހިސާބުކުރަނީ ސާވަރުން، ކޮންޓްރެކްޓްކުރެވިފައިވާ ކޮޓަރިއާއި އެޓްރިޝަން އިންސައްތައިން. އެއީ ޑެސިމަލް ޢަދަދުތަކެއް، އަދި މިތާ ދުވަހަކުވެސް އަލުން ނުނެރެވޭ.",
      "totalContracted": "ކޮންޓްރެކްޓްކުރެވިފައި",
      "totalPickedUp": "ނަގާފައި",
      "totalReleased": "ދޫކޮށްލެވިފައި",
      "allowedShortfall": "ހުއްދަ ދެވޭ އުނިކަން",
      "attritionRooms": "ޗާޖްކުރެވޭ އެޓްރިޝަން"
    },
    "allotments": {
      "title": "އެލޮޓްމަންޓް",
      "description": "ހުންނަ ރެއިން ކޮޓަރީގެ ބާވަތް. ކޮންޓްރެކްޓްކުރެވިފައިވާ ޢަދަދު އެޑިޓްކުރެވޭ؛ ނަގާފައި، ދޫކޮށްލެވިފައި އަދި ބާކީއަކީ ސާވަރުގެ.",
      "caption": "ކޮންމެ ރެއަކަށް ކޮންމެ ބާވަތަކުން ކޮންޓްރެކްޓްކުރެވިފައިވާ ކޮޓަރި، އަދި ސާވަރުން ހިސާބުކުރި ނެގުމާއި، ދޫކޮށްލުމާއި، ބާކީ ކޮޓަރި.",
      "legend": "ކޮންމެ ދެ ރޯއެއްގެ މަތީ ރޯއަކީ ކޮންޓްރެކްޓްކުރެވިފައިވާ ޢަދަދު، އަދި އެ އެޑިޓްކުރެވޭ. ތިރީ ރޯއަކީ ސާވަރުން ހިސާބުކުރި ނަގާފައި / ދޫކޮށްލެވިފައި / ބާކީ. އެރޯތަކާއި އެންޓަރއިން ސެލްތަކުގެ މެދުގައި ހަރަކާތްކުރެވޭ.",
      "contracted": "ކޮންޓްރެކްޓްކުރެވިފައި",
      "pickedUpReleasedRemaining": "ނަގާފައި / ދޫކޮށްލެވިފައި / ބާކީ",
      "cellLabel": "{date} ގައި {roomType} ގެ ކޮންޓްރެކްޓްކުރެވިފައިވާ ކޮޓަރި",
      "empty": "މި ޕްރޮޕަޓީގައި ކޮޓަރީގެ ބާވަތެއް ނެތް، އެހެންވެ އެލޮޓްމަންޓް ގްރިޑްގައި ރޯއެއް ނެތް.",
      "save": "އެލޮޓްމަންޓް ރައްކާކުރޭ",
      "saved": "އެލޮޓްމަންޓް ރައްކާކުރެވިއްޖެ",
      "savedDetail": "{count} ސެލް ލިޔެވިއްޖެ",
      "saveFailed": "އެލޮޓްމަންޓް ރައްކާނުކުރެވުނު.",
      "unsaved": "ރައްކާނުކުރެވޭ {count} ބަދަލު",
      "stranded": "ގްރޫޕުން މިހާރު ނަގާފައިވާ ނުވަތަ ދޫކޮށްލާފައިވާ މިންވަރަށްވުރެ ދަށަށް {count} ސެލް ކުޑަކުރެވިފައި. ސާވަރުން އެ ދޫކޮށްލައި، ކޮން ސެލްއެއްކަން ބުނާނެ.",
      "wash": "ވޮޝް",
      "washAll": "ބްލޮކް ވޮޝްކުރޭ",
      "washRow": "{roomType} ވޮޝްކުރޭ",
      "washHint": "ގްރޫޕުން މިހާރު ނަގާފައިވާ މިންވަރަށް ކޮންމެ ރެއެއް ކުޑަކޮށް، ބާކީ އާންމު ވިޔަފާރިއަށް ދޫކޮށްލާ. ގްރިޑްގައި ސްޓޭޖްކުރެވޭ؛ ރައްކާކުރުމުން ލިޔެވޭ.",
      "washStaged": "ދޫކޮށްލުމަށް {rooms} ކޮޓަރި ސްޓޭޖްކުރެވިފައި. އާންމު ވިޔަފާރިއަށް ދޫކޮށްލުމަށް އެލޮޓްމަންޓް ރައްކާކުރޭ.",
      "washNothing": "ވޮޝްކުރާނެ އެއްޗެއް ނެތް — މި ގްރިޑްގެ ކޮންޓްރެކްޓްކުރެވިފައިވާ ހުރިހާ ކޮޓަރިއެއް މިހާރު ނަގާފައި ނުވަތަ ދޫކޮށްލެވިފައި."
    },
    "rooming": {
      "title": "ރޫމިން ލިސްޓް",
      "description": "ލިސްޓް ޕޭސްޓްކުރޭ، ކޮންމެ ރޯއެއްގެ ނަތީޖާ ކިޔާ، ދެން ބޭނުންކުރޭ. ސައްޙަކަން ބެލުމުން އެއްވެސް އެއްޗެއް ނުލިޔޭ.",
      "caption": "ރޫމިން ލިސްޓްގެ ކޮންމެ ރޯއެއް، ސާވަރުން ދިން ނަތީޖާއާއެކު، އަދި ބޭރުކުރެވުނުނަމަ އޭގެ ސަބަބު.",
      "format": "ކޮލަމްތައް، ތަރުތީބުން: ދެވިފައިވާ ނަން، ޢާއިލީ ނަން، އީމެއިލް، ކޮޓަރީގެ ބާވަތުގެ ކޯޑް، އައުން، ފުރުން، ބޮޑެތި މީހުން، ކުޑަކުދިން. ޓެބް ނުވަތަ ކޮމާއިން ވަކިކުރެވިފައި؛ ހެޑަރ ރޯއެއް ދޫކުރެވޭ.",
      "filename": "ފައިލްގެ ނަން",
      "filenamePlaceholder": "އެޖެންސީން ފޮނުވި ގޮތަށް",
      "pasteLabel": "ރޫމިން ލިސްޓް",
      "pasteHint": "ސްޕްރެޑްޝީޓުން ސީދާ ޕޭސްޓްކުރޭ. މިތާ އެއްވެސް ކަމެއް ނުނިންމޭ — ކޮންމެ ޗެކަކީ ސާވަރުގެ.",
      "pastePlaceholder": "ދެވިފައިވާ ނަން\tޢާއިލީ ނަން\tއީމެއިލް\tކޮޓަރީގެ ބާވަތް\tއައުން\tފުރުން\tބޮޑެތި މީހުން\tކުޑަކުދިން",
      "parsed": "{count} ރޯ ކިޔައިފި",
      "validate": "ސައްޙަކަން ބަލާ",
      "apply": "ބަލައިގަނެވުނު ރޯތައް ބޭނުންކުރޭ",
      "applied": "ރޫމިން ލިސްޓް ބޭނުންކުރެވިއްޖެ",
      "appliedDetail": "{accepted} ބަލައިގަނެފި، {rejected} ބޭރުކުރެވިއްޖެ",
      "failed": "ރޫމިން ލިސްޓް ޕްރޮސެސްނުކުރެވުނު.",
      "summary": "{rows} ރޯ: {accepted} ބަލައިގަނެފި، {rejected} ބޭރުކުރެވިއްޖެ. ސްޓޭޓަސް {status}.",
      "lineNo": "ލައިން",
      "guest": "މެހްމާން",
      "outcome": "ނަތީޖާ",
      "reason": "ސަބަބު",
      "empty": "މި ލިސްޓަށް ސާވަރުން އެއްވެސް ރޯއެއް އަނބުރާ ނުދޭ."
    },
    "guests": {
      "title": "މެހްމާނުން",
      "description": "ހުންނަ މީހުން. ކޮންމެ މީހަކަށް އެއް ދިރުން، ޕާޓީ ސްޕައިނާ ޙިއްޞާކުރެވިފައި.",
      "tableTitle": "މެހްމާނުންގެ ރަޖިސްޓަރީ",
      "caption": "ޚިޔާރުކުރެވުނު ކުންފުނީގެ މެހްމާނުން، ގުޅޭނެ މަޢުލޫމާތާއި، ފޮރުވިފައިވާ ދަތުރުފަތުރުގެ ލިޔުމާއި، ހިފެހެއްޓުމެއް ވާނަމަ އެއާއެކު.",
      "create": "އައު މެހްމާން",
      "dialogDescription": "މެހްމާނަކު އުފެއްދުމުން ހަމަ އެ ޓްރާންސެކްޝަނުގައި ޕާޓީ ހޯދާ ނުވަތަ އުފައްދާ، އެހެންކަމުން ހަމަ އެ އީމެއިލްގެ ދެވަނަ ބުކިންއަކީ ކޮންމެ ތަނެއްގައިވެސް ހަމަ އެ މީހާ.",
      "chooseCompany": "ކުންފުންޏެއް ޚިޔާރުކުރޭ. މެހްމާނަކު ނިސްބަތްވަނީ އެއް ކުންފުންޏަކަށް، އަދި ރަޖިސްޓަރީ ބެހިފައިވަނީ ތިބާއަށް ހުއްދަ ކުންފުނިތަކަށް.",
      "searchLabel": "ހޯދާ",
      "searchHint": "ޓްރައިގްރާމް އިންޑެކްސް މެދުވެރިކޮށް ނަން، އީމެއިލް އަދި ފޯނުން ހޯދާ.",
      "searchPlaceholder": "ނަން، އީމެއިލް ނުވަތަ ފޯނު",
      "restrictedFilter": "ހިފެހެއްޓިފައި",
      "restrictedOnly": "ހިފެހެއްޓިފައިވާ މެހްމާނުން އެކަނި",
      "restricted": "ހިފެހެއްޓިފައި",
      "empty": "ގުޅޭ މެހްމާނަކު ނެތް. މެހްމާނަކު ރަޖިސްޓަރީކުރޭ، ނުވަތަ ހޯދުން ފުޅާކުރޭ.",
      "loadFailed": "މެހްމާނުންގެ ރަޖިސްޓަރީ ނުލޯޑްކުރެވުނު.",
      "saved": "މެހްމާން ރަޖިސްޓަރީކުރެވިއްޖެ",
      "saveFailed": "މެހްމާން ރަޖިސްޓަރީނުކުރެވުނު.",
      "noDocument": "ރެކޯޑްކުރެވިފައި ނެތް",
      "emailHint": "ޕާޓީ ހޯދުމަށް ބޭނުންކުރެވޭ، އަދި އެއިން އަނބުރާ އަންނަ މެހްމާނަކީ މުޅި ނިޒާމުގައިވެސް ހަމަ އެ މީހާކަމުގައި ވެއެވެ.",
      "documentHint": "ނަންބަރު ރައްކާކުރެވިފައިވަނީ އެންކްރިޕްޓްކޮށް، އަދި ލިސްޓެއްގައި ދުވަހަކުވެސް އަނބުރާ ނުދޭ.",
      "documentNote": "ލިޔުމުގެ ނަންބަރު މިތަނުން ހަމައެކަނި ލިޔެވޭ. އަނބުރާ އަންނަނީ ފަހު ހަތަރު ފޮރުވިފައިވާ ގޮތަށް، އަދި އަލުން ބެލުމަކީ އޭގެ އަމިއްލަ ހުއްދައިގެ ދަށުން ކުރެވޭ އޮޑިޓްކުރެވޭ ދެއްކުމެއް."
    },
    "guest": {
      "description": "ޕްރޮފައިލް، އިސްކަންދޭ ކަންތައް، ދަތުރުފަތުރުގެ ލިޔުން އަދި ހުރުމުގެ ތާރީޚް.",
      "loadFailed": "މެހްމާން ނުލޯޑްކުރެވުނު.",
      "tabsLabel": "މެހްމާނުގެ ބައިތައް",
      "tabs": {
        "profile": "ޕްރޮފައިލް",
        "preferences": "އިސްކަންދޭ ކަންތައް",
        "stays": "ހުރުންތައް",
        "messages": "މެސެޖްތައް"
      },
      "partyLink": "ޕާޓީ ޕްރޮފައިލް",
      "restrictedNote": "މި މެހްމާން ވަނީ ހިފެހެއްޓިފައިވާ ލިސްޓްގައި: {reason}. {note} ޗެކް-އިން ސީދާ ދޫކޮށްލެވޭނެ، އަދި އޯވަރައިޑެއް ނެތް.",
      "noRestrictedNote": "އެއްވެސް ނޯޓެއް ރެކޯޑްކުރެވިފައި ނެތް.",
      "documentTitle": "ދަތުރުފަތުރުގެ ލިޔުން",
      "documentDescription": "ފޮރުވިފައި. ނަންބަރު ރައްކާކުރެވިފައިވަނީ AES-GCM އެންކްރިޕްޓްކޮށް، އަދި މި ޕޭލޯޑްގައި ނުހިމެނޭ.",
      "documentNote": "ނަންބަރު ދެއްކުމުން ތިބާއާއި، މެހްމާނާއި، ތިބާގެ ސަބަބު ހިމެނޭ އޮޑިޓް ރޯއެއް ލިޔެވޭ، އަދި އެއްފަހަރު ބޭނުންކުރެވޭ ކޯޑަކުން ސްޓެޕް-އަޕް ކުރެވޭ.",
      "staysTitle": "ހުރުމުގެ ތާރީޚް",
      "staysDescription": "މެހްމާނުގެ ރިޒަވޭޝަންތަކުގެ މި ޕްރޮޕަޓީގެ އަމިއްލަ ރެކޯޑް.",
      "staysCaption": "ޚިޔާރުކުރެވުނު ޕްރޮޕަޓީގައި މި މެހްމާނުގެ ރިޒަވޭޝަންތައް.",
      "staysChooseProperty": "ޕްރޮޕަޓީއެއް ޚިޔާރުކުރޭ. ރިޒަވޭޝަންތައް ބެހިފައިވަނީ ޕްރޮޕަޓީން، އެހެންކަމުން ގްރޫޕެއްގެ ތިން ޕްރޮޕަޓީގައި ހުރި މެހްމާނަކަށް ތިން ތާރީޚް އޮވެއެވެ.",
      "staysEmpty": "މި ޕްރޮޕަޓީގައި މި މެހްމާނުގެ ރިޒަވޭޝަނެއް ނެތް."
    },
    "preferences": {
      "title": "އިސްކަންދޭ ކަންތައް",
      "description": "މި މެހްމާން އެދޭ ކަންތައް، ޑެސްކަށް ދެފަހަރު ބުނަން ނުޖެހޭގޮތަށް.",
      "caption": "މި މެހްމާނަށް ރެކޯޑްކުރެވިފައިވާ އިސްކަންދޭ ކަންތައް، ބައިން ބައިން.",
      "category": "ބައި",
      "value": "އަގު",
      "codeHint": "ޕްރޮޕަޓީން ބޭނުންކުރާ ކުރު ކޯޑެއް، މިސާލަކަށް HIGH_FLOOR ނުވަތަ FEATHER_FREE.",
      "empty": "އިސްކަންދޭ ކަމެއް ރެކޯޑްކުރެވިފައި ނެތް. ދެން އަންނަ ހުރުން ކުރީގެއަށްވުރެ ރަނގަޅަށް ފެށުމަށް އެއް އިތުރުކުރޭ.",
      "remove": "ފޮހެލާ",
      "removed": "އިސްކަންދޭ ކަންތައް ފޮހެލެވިއްޖެ",
      "removeFailed": "އިސްކަންދޭ ކަންތައް ނުފޮހެވުނު.",
      "saved": "އިސްކަންދޭ ކަންތައް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "އިސްކަންދޭ ކަންތައް ރައްކާނުކުރެވުނު."
    },
    "reveal": {
      "title": "{guest} ގެ ލިޔުން ދައްކާ",
      "description": "މިއީ އޮޑިޓްކުރެވޭ ޢަމަލެއް، ދެއްކުމުގެ ޓޮގުލްއެއް ނޫން.",
      "auditNote": "މިއިން ތިބާއާއި، މެހްމާނާއި، ތިބާގެ ސަބަބު ހިމެނޭ އޮޑިޓް ރޯއެއް ލިޔެވޭ، އަދި އެއްފަހަރު ބޭނުންކުރެވޭ ކޯޑަކުން ސްޓެޕް-އަޕް ކުރެވޭ. ނަންބަރު ދައްކާނީ އެއްފަހަރު، އަދި ރައްކާނުކުރެވޭ.",
      "reasonLabel": "ސަބަބު",
      "reasonHint": "އޮޑިޓް ޓްރެއިލްގައި ހަމަ އެގޮތަށް ރެކޯޑްކުރެވޭ. ބޭނުންވަނީ ކޮންކަމަކަށްކަން ބުނޭ.",
      "submit": "ދައްކާ",
      "failed": "ލިޔުން ނުދެއްކުނު.",
      "revealedAt": "ދެއްކި ވަގުތު",
      "onceNote": "މި ޑައިލޮގް ބަންދުކުރުމުން ނަންބަރު ހަނދާން ނެތޭ. އަލުން ބެލުމަކީ އިތުރު ދެއްކުމަކާއި އިތުރު އޮޑިޓް ރޯއެއް."
    },
    "restrict": {
      "title": "މެހްމާން ހިފަހައްޓާ",
      "description": "ހިފެހެއްޓިފައިވާ މެހްމާނަކު ޗެކް-އިން ނުކުރެވޭނެ. އޯވަރައިޑެއް ނެތް.",
      "consequence": "ކުންފުނީގެ ކޮންމެ ޕްރޮޕަޓީއެއްގައިވެސް މި މެހްމާނުގެ ޗެކް-އިން ސީދާ ދޫކޮށްލެވޭނެ، އޯވަރައިޑެއް ނުވަތަ ފާސްކުރުމުގެ މަގެއް ނެތި.",
      "reasonLabel": "ސަބަބު",
      "reasonHint": "މީހަކު އަނބުރާ ފޮނުވާލާ ޑެސްކް އޭޖެންޓަށް، ތަންފީޛުކުރަނީ ކޮން ނިންމުމެއްކަން އެނގެންޖެހޭ.",
      "noteHint": "ވީ ކިހިނެއްކަން، އަހަރެއް ފަހުން މި ކިޔާ މީހަކަށް ފުދޭވަރުގެ ތަފްޞީލާއެކު.",
      "submit": "ހިފަހައްޓާ",
      "applied": "މެހްމާން ހިފެހެއްޓިއްޖެ",
      "liftTitle": "ހިފެހެއްޓުން އުވާލާ",
      "liftDescription": "މެހްމާން ވަގުތުން އަލުން ޗެކް-އިން ކުރެވޭގޮތް ވާނެ.",
      "liftConsequence": "ހިފެހެއްޓުން އުވާލުމުން މި މެހްމާން ވަގުތުން އަލުން ޗެކް-އިން ކުރެވޭނެ. އަސްލު ސަބަބު އޮޑިޓް ޓްރެއިލްގައި ބާކީވާނެ.",
      "lift": "ހިފެހެއްޓުން އުވާލާ",
      "lifted": "ހިފެހެއްޓުން އުވާލެވިއްޖެ",
      "liftNoteHint": "ލާޒިމް. ހިފެހެއްޓުމެއް އިތުރުކުރުމަކީ މީހެއްގެ ނިންމުމެއް؛ އުވާލުމަކީ އެހެން މީހަކާ ސުވާލުކުރެވޭނެ ނިންމުމެއް.",
      "failed": "ހިފެހެއްޓިފައިވާ ލިސްޓް އަޕްޑޭޓްނުކުރެވުނު."
    },
    "ops": {
      "routeTitles": {
        "frontDesk": "ފްރޮންޓް ޑެސްކް",
        "folios": "ފޮލިއޮސް",
        "folio": "ފޮލިއޮ",
        "deposits": "ޑެޕޮސިޓްސް",
        "nightAudit": "ރޭ އައުޑިޓް",
        "nightAuditRun": "ރޭ އައުޑިޓް ރުން",
        "channels": "ޗަނެލްސް",
        "channel": "ޗަނެލް",
        "parity": "ރަޓް ޕަރިޓި",
        "agreements": "ކޮމިސިއޮން އަގްރީމެންޓްސް",
        "agreement": "ކޮމިސިއޮން އަގްރީމެންޓް",
        "accruals": "ކޮމިސިއޮން އަކްރުއަލްސް",
        "statements": "ކޮމިސިއޮން ސްޓަޓެމެންޓްސް",
        "statement": "ކޮމިސިއޮން ސްޓަޓެމެންޓް",
        "services": "ސެރްވިސެސް",
        "schedule": "ސެރްވިސް ސްޗެޑުލް",
        "boardPlans": "ބޯރްޑް ޕްލަންސް",
        "unconsumed": "އުންކޮންސުމެޑް އަލޮވަންސެސް",
        "transfers": "ޓްރަންސްފެރްސް",
        "guestRequests": "މެހެމާން ރެކްވެސްޓްސް",
        "reports": "ރެޕޮރްޓްސް"
      },
      "fields": {
        "accepted": "އަކްސެޕްޓެޑް",
        "account": "އަކައުންޓް",
        "accrued": "އަކްރުއެޑް",
        "adapter": "އަޑަޕްޓެރް",
        "adr": "އޭޑީއާރް",
        "allowanceCap": "އަލޮވަންސް ކަޕް",
        "amount": "އަދަދު",
        "applied": "އަޕްލީޑް",
        "approvalCode": "އަޕްރޮވަލް ކޯޑު",
        "arrivals": "އަރިވަލްސް",
        "arriveAt": "އަރިވެސް",
        "assignmentReason": "ކީއްވެ މި ކޮޓަރި",
        "balance": "ބާކީ",
        "basisAmount": "ބަސިސް",
        "bookedPax": "ބޫކެޑް ޕަކްސް",
        "businessDate": "ބުސިނެސް ތާރީޚު",
        "cancelWindowHours": "ކަންސެލަޓިއޮން ވިންޑޮވް (ހައުރްސް)",
        "cap": "ކަޕް",
        "capacityPax": "ކަޕަސިޓި (ޕަކްސް)",
        "capacityPerSlot": "ކަޕަސިޓި ކޮންމެ ސްލޮޓް",
        "card": "ކަރްޑް",
        "cardLast4": "ފަހު 4 ޑިޖިޓްސް",
        "cardScheme": "ކަރްޑް ސްޗެމް",
        "category": "ކަޓެގޮރި",
        "channel": "ޗަނެލް",
        "channelKind": "ޗަނެލް ބާވަތް",
        "channelReference": "ޗަނެލް ރެފެރެންސް",
        "charge": "ޗާޖު",
        "chargeKind": "ޗާޖު ބާވަތް",
        "charges": "ޗާޖު",
        "chargesPosted": "ޗާޖުތައް ޕޮސްޓެޑް",
        "closing": "ނިމޭ",
        "code": "ކޯޑު",
        "commissionBasis": "ކޮމިސިއޮން ބަސިސް",
        "confidence": "ކޮންފިޑެންސް",
        "consumed": "ކޮންސުމެޑް",
        "covers": "ކޮވެރްސް ކޮންމެ ޕެރްސޮން ކޮންމެ ރޭ",
        "createdAt": "ރެކޮރްޑެޑް",
        "credit": "ކްރެޑިޓް",
        "currency": "ކުރެންސި",
        "currentStep": "ކުރެންޓް ސްޓެޕް",
        "dateDistance": "ތާރީޚު ގަޕް (ޑަޔްސް)",
        "debit": "ޑެބިޓް",
        "declaredTotal": "ޑެކްލަރެޑް ޖުމްލަ",
        "departAt": "ޑެޕަރްޓްސް",
        "departures": "ޑެޕަރްޓުރެސް",
        "depositNo": "ޑެޕޮސިޓް ނެތް.",
        "description": "ޑެސްކްރިޕްޓިއޮން",
        "destination": "ޑެސްޓިނަޓިއޮން",
        "deviation": "ޑެވިއަޓިއޮން %",
        "direction": "ޑިރެކްޓިއޮން",
        "drawnCovers": "ޑްރަވްން ކޮވެރްސް",
        "drawnValue": "ޑްރަވްން އަގު",
        "dueDate": "ޑުއެ ތާރީޚު",
        "durationMinutes": "ޑުރަޓިއޮން (މިނުޓެސް)",
        "effectiveFrom": "އެފެކްޓިވް ން",
        "effectiveTo": "އެފެކްޓިވް އަށް",
        "entitlements": "އެންޓިޓްލެމެންޓްސް",
        "expiresAt": "އެކްސްޕިރެސް",
        "filename": "ފިލް ނަން",
        "flatAmount": "ފްލަޓް އަދަދު",
        "flatPerBooking": "ފްލަޓް ކޮންމެ ބޫކިންގް",
        "flatPerNight": "ފްލަޓް ކޮންމެ ރޭ",
        "folioKind": "ފޮލިއޮ ބާވަތް",
        "folioNo": "ފޮލިއޮ ނެތް.",
        "forced": "ފޮރްސެޑް",
        "from": "ން",
        "grantedCovers": "ގްރަންޓެޑް ކޮވެރްސް",
        "grantedValue": "ގްރަންޓެޑް އަގު",
        "gross": "ގްރޮސް",
        "guest": "މެހެމާން",
        "heldAt": "ހެލްޑް ގައި",
        "invoiceNo": "އިންވޮއިސް ނެތް.",
        "item": "އިޓެމް އިޑް",
        "journal": "ޖައުރްނަލް",
        "keyKind": "ކޭ ބާވަތް",
        "leadTimeHours": "ލީޑް ވަގުތު (ހައުރްސް)",
        "legNo": "ލެގް ނެތް.",
        "lineKind": "ލިން ބާވަތް",
        "lineNo": "ލިން",
        "marketCode": "ޑެފައުލްޓް މަރްކެޓް",
        "matchType": "މަޓްޗް ބާވަތް",
        "matchedTotal": "މަޓްޗެޑް ޖުމްލަ",
        "mealPeriod": "މީލް ޕެރިއޮޑް",
        "memo": "މެމޮ",
        "method": "މެތޮޑް",
        "net": "ނެޓް",
        "nextBusinessDate": "ދެން ބުސިނެސް ތާރީޚު",
        "nightPosted": "ރޭ ޕޯސްޓްކުރެވިފައި",
        "noShows": "ނެތް-ށޮވްސް ޕްރޮސެސެޑް",
        "note": "ނޯޓު",
        "observedAmount": "އޮބްސެރްވެޑް",
        "observedOn": "އޮބްސެރްވެޑް ގައި",
        "occupancyPercent": "އޮކިއުޕެންސީ %",
        "openedAt": "އޮޕެނެޑް",
        "opening": "ފެށޭ",
        "order": "އޮރްޑެރް",
        "origin": "އޮރިޖިން",
        "outlet": "އައުޓްލެޓް އިޑް",
        "parityTolerance": "ޕަރިޓި ޓޮލެރަންސް %",
        "partyKey": "ޕަރްޓި",
        "pax": "ޕަކްސް",
        "payloadKind": "ޕަޔްލޯޑް",
        "percent": "ޕެރްސެންޓް",
        "period": "ޕެރިއޮޑް",
        "periodFrom": "ޕެރިއޮޑް ން",
        "periodTo": "ޕެރިއޮޑް އަށް",
        "quantity": "ކްވަންޓިޓި",
        "reason": "ސަބަބު",
        "reasonCode": "ސަބަބު ކޯޑު",
        "receivedOn": "ރެސެއިވެޑް ގައި",
        "recoveryKind": "ރެކޮވެރި",
        "recoveryValue": "ރެކޮވެރި އަގު",
        "reference": "ރެފެރެންސް",
        "referenceAmount": "ރެފެރެންސް",
        "refunded": "ރެފުންޑެޑް",
        "rejected": "ރެޖެކްޓެޑް",
        "remaining": "ރެމައިނިންގް",
        "remainingCovers": "ރެމައިނިންގް ކޮވެރްސް",
        "remainingValue": "ރެމައިނިންގް އަގު",
        "requestKind": "ބާވަތް",
        "requestNo": "ރެކްވެސްޓް ނެތް.",
        "reservation": "ރެސެރްވަޓިއޮން",
        "resolutionNote": "ރެސޮލުޓިއޮން ނޯޓު",
        "revenueCenter": "ރެވެނުއެ ސެންޓްރް",
        "revenueGross": "ރެވެނުއެ (ގްރޮސް)",
        "revpar": "ރެވްޕާރ",
        "room": "ކޮޓަރި",
        "roomRevenue": "ކޮޓަރި ރެވެނުއެ",
        "roomState": "ކޮޓަރި ސްޓަޓް",
        "roomsAvailable": "ލިބެންހުރި ކޮޓަރި",
        "roomsOccupied": "ބޭނުންކުރެވުނު ކޮޓަރި",
        "roomsOutOfOrder": "ބޭނުންނުކުރެވޭ ކޮޓަރި",
        "roomsPosted": "ކޮޓަރިތައް ޕޮސްޓެޑް",
        "rowCount": "ރޮވްސް",
        "runNo": "ރުން ނެތް.",
        "scheduledAt": "ސްޗެޑުލެޑް",
        "scheduledDate": "ތާރީޚު",
        "segmentCode": "ޑެފައުލްޓް ސެގްމެންޓް",
        "seq": "ސެކް.",
        "service": "ސެރްވިސް",
        "serviceKind": "ސެރްވިސް ބާވަތް",
        "settleThis": "ސެޓްލް",
        "settlementMode": "ސެޓްލެމެންޓް މޮޑް",
        "settlements": "ސެޓްލެމެންޓްސް",
        "severity": "ސެވެރިޓި",
        "source": "ސައުރްސް",
        "sourceCode": "ޑެފައުލްޓް ސައުރްސް",
        "splitReason": "ސަބަބު އަށް ސްޕްލިޓިންގް ޕަރްޓި",
        "statementNo": "ސްޓަޓެމެންޓް ނެތް.",
        "stayDate": "ސްޓަޔް ތާރީޚު",
        "stayovers": "ހުރުން ދިގުކުރި",
        "targetFolio": "ޓަރްޖެޓް ފޮލިއޮ އިޑް",
        "targetWindow": "ޓަރްޖެޓް ވިންޑޮވް",
        "tax": "ޓެކްސް",
        "taxCode": "ޓެކްސް ކޯޑު",
        "theirCommission": "އެމީހުންގެ ކޮމިސިއޮން",
        "to": "އަށް",
        "transferPrice": "ޓްރަންސްފެރް އަގު",
        "unitPrice": "އުނިޓް އަގު",
        "validFrom": "ވަލިޑް ން",
        "validTo": "ވަލިޑް އަށް",
        "variance": "ވަރިއަންސް",
        "versionNo": "ވެރްސިއޮން",
        "window": "ވިންޑޮވް",
        "windowName": "ވިންޑޮވް ނަން",
        "sourceRow": "ރޯ",
        "exceptionReason": "ޤަބޫލުނުކުރި ސަބަބު",
        "resolutionStatus": "ނަތީޖާ"
      },
      "chargeKind": {
        "room": "ކޮޓަރި",
        "tax": "ޓެކްސް",
        "service_charge": "ސެރްވިސް ޗާޖު",
        "levy": "ލެވި",
        "ancillary": "އަންސިލަރި",
        "pos": "ޕޮއިންޓް ސަލް",
        "deposit": "ޑެޕޮސިޓް",
        "payment": "ފައިސާ ދެއްކުން",
        "allowance": "އަލޮވަންސް",
        "transfer_in": "ޓްރަންސްފެރް ގައި",
        "transfer_out": "ޓްރަންސްފެރް ބޭރު",
        "package_draw": "ޕަކަޖް ޑްރަވް",
        "package_relief": "ޕަކަޖް ރެލީފް"
      },
      "chargeStatus": {
        "posted": "ޕޮސްޓެޑް",
        "reversed": "ރެވެރްސެޑް",
        "reversal": "ރެވެރްސަލް"
      },
      "postingSource": {
        "pms": "ފްރޮންޓް އޮފިސް",
        "pos": "ޕޮއިންޓް ސަލް",
        "channel": "ޗަނެލް",
        "import": "އިމްޕޮރްޓް"
      },
      "folioKind": {
        "guest": "މެހެމާން",
        "group_master": "ގްރައުޕް މަސްޓެރް",
        "house": "ހައުސް",
        "walk_in": "ވަލްކް-ގައި"
      },
      "folioStatus": {
        "open": "ހުޅުވިފައި",
        "settled": "ސެޓްލެޑް",
        "transferred": "ޓްރަންސްފެރެޑް",
        "disputed": "ޑިސްޕުޓެޑް"
      },
      "windowStatus": {
        "open": "ހުޅުވިފައި",
        "settled": "ސެޓްލެޑް",
        "transferred": "ޓްރަންސްފެރެޑް"
      },
      "settlementMethod": {
        "cash": "ކަށް",
        "card": "ކަރްޑް",
        "bank_transfer": "ބަންކް ޓްރަންސްފެރް",
        "deposit_applied": "އަޕްލި ޑެޕޮސިޓް",
        "city_ledger": "އަށް ސިޓި ލެޑްޖެރް",
        "allowance": "އަލޮވަންސް",
        "transfer_to_folio": "ޓްރަންސްފެރް އަށް އަނޮތެރް ފޮލިއޮ"
      },
      "depositMethod": {
        "cash": "ކަށް",
        "card": "ކަރްޑް",
        "bank_transfer": "ބަންކް ޓްރަންސްފެރް"
      },
      "depositStatus": {
        "held": "ހެލްޑް",
        "applied": "އަޕްލީޑް",
        "refunded": "ރެފުންޑެޑް",
        "forfeited": "ފޮރްފެއިޓެޑް"
      },
      "assignmentReason": {
        "requested": "މެހެމާން ރެކްވެސްޓެޑް އެ",
        "upgrade": "އުޕްގްރަޑް",
        "accessible": "އަކްސެސިބްލް ކޮޓަރި ނީޑެޑް",
        "connecting": "ކޮނެކްޓިންގް ކޮޓަރިތައް",
        "only_available": "ހަމައެކަނި ކޮޓަރި އަވައިލަބްލް",
        "room_move": "ކޮޓަރި މޮވް"
      },
      "holdStatus": {
        "held": "ހެލްޑް",
        "captured": "ކަޕްޓުރެޑް",
        "released": "ރެލީސެޑް",
        "expired": "އެކްސްޕިރެޑް",
        "failed": "ނާކާމިޔާބު"
      },
      "keyKind": {
        "guest": "މެހެމާން",
        "duplicate": "ޑުޕްލިކަޓް",
        "staff": "ސްޓަފް",
        "master": "މަސްޓެރް"
      },
      "keyStatus": {
        "issued": "އިސުއެޑް",
        "cancelled": "ކެންސަލްކޮށްފި",
        "expired": "އެކްސްޕިރެޑް"
      },
      "step": {
        "readiness": "ރީޑިނެސް ޗެކްސް",
        "no_show": "ރެސޮލްވް ނެތް-ށޮވްސް",
        "post_room_and_tax": "ޕޮސްޓް ކޮޓަރި އަދި ޓެކްސް",
        "board_allowances": "ގްރަންޓް ބޯރްޑް އަލޮވަންސެސް",
        "package_relief": "ސްޓަމްޕް ޕަކަޖް ރެލީފް",
        "commission": "އަކްރުއެ ކޮމިސިއޮން",
        "build_lines": "ބުއިލްޑް ޖައުރްނަލް ލިނެސް",
        "post_journal": "ޕޮސްޓް ޖައުރްނަލް",
        "day_pack": "ބުއިލްޑް ދުވަސް ޕަކް",
        "roll": "ރޮލް ތާރީޚު"
      },
      "stepStatus": {
        "pending": "ޕެންޑިންގް",
        "running": "ރުނިންގް",
        "done": "ޑޮން",
        "skipped": "ސްކިޕެޑް",
        "failed": "ނާކާމިޔާބު"
      },
      "runStatus": {
        "pending": "ޕެންޑިންގް",
        "running": "ރުނިންގް",
        "blocked": "ބްލޮކެޑް",
        "completed": "ކޮމްޕްލެޓެޑް",
        "abandoned": "އަބަންޑޮނެޑް",
        "reversed": "ރެވެރްސެޑް"
      },
      "lineKind": {
        "guest_ledger": "މެހެމާން ލެޑްޖެރް",
        "revenue": "ރެވެނުއެ",
        "tax": "ޓެކްސް",
        "service_charge": "ސެރްވިސް ޗާޖު",
        "levy": "ލެވި",
        "package_ledger": "ޕަކަޖް ލެޑްޖެރް",
        "package_relief": "ޕަކަޖް ރެލީފް",
        "allowance": "އަލޮވަންސް",
        "rounding": "ރައުންޑިންގް"
      },
      "channelKind": {
        "ota": "އޮންލިން ޓްރަވެލް އަޖެންޓް",
        "wholesaler": "ވްހޮލެސަލެރް",
        "tour_operator": "ޓައުރް އޮޕެރަޓޮރް",
        "direct": "ޑިރެކްޓް",
        "gds": "ގްޑްސް",
        "corporate": "ކޮރްޕޮރަޓް"
      },
      "channelStatus": {
        "active": "އަކްޓިވް",
        "suspended": "ސުސްޕެންޑެޑް"
      },
      "direction": {
        "push": "ޕުށް",
        "pull": "ޕުލް"
      },
      "payloadKind": {
        "rates": "ރަޓެސް",
        "restrictions": "ރެސްޓްރިކްޓިއޮންސް",
        "availability": "އަވައިލަބިލިޓި",
        "bookings": "ބޫކިންގްސް",
        "commission": "ކޮމިސިއޮން"
      },
      "exchangeStatus": {
        "pending": "ޕެންޑިންގް",
        "complete": "ކޮމްޕްލެޓް",
        "failed": "ނާކާމިޔާބު"
      },
      "paritySource": {
        "manual": "ސްޕޮޓް ޗެކް",
        "import": "ފީޑް"
      },
      "agreementStatus": {
        "draft": "ޑްރަފްޓް",
        "active": "އަކްޓިވް",
        "closed": "ބަންދު"
      },
      "versionStatus": {
        "draft": "ޑްރަފްޓް",
        "published": "ޕުބްލިށެޑް (ފްރޮޒެން)",
        "superseded": "ސުޕެރްސެޑެޑް"
      },
      "commissionBasis": {
        "room_net": "ކޮޓަރި ރެވެނުއެ, ނެޓް ޓެކްސް",
        "room_gross": "ކޮޓަރި ރެވެނުއެ, ގްރޮސް",
        "stay_net": "ވްހޮލް ސްޓަޔް, ނެޓް ޓެކްސް"
      },
      "settlementMode": {
        "invoiced": "އަޅުގަނޑުމެން އިންވޮއިސް ތެމް",
        "net_remittance": "އެމީހުން ރެމިޓް ނެޓް"
      },
      "accrualStatus": {
        "accrued": "އަކްރުއެޑް",
        "matched": "މަޓްޗެޑް",
        "disputed": "ޑިސްޕުޓެޑް",
        "settled": "ސެޓްލެޑް",
        "reversed": "ރެވެރްސެޑް"
      },
      "statementStatus": {
        "imported": "އިމްޕޮރްޓެޑް",
        "matching": "މަޓްޗިންގް",
        "reconciled": "ރެކޮންސިލެޑް",
        "disputed": "ޑިސްޕުޓެޑް",
        "closed": "ބަންދު"
      },
      "statementLineStatus": {
        "unmatched": "އުންމަޓްޗެޑް",
        "matched": "މަޓްޗެޑް",
        "disputed": "ޑިސްޕުޓެޑް",
        "written_off": "ވްރިޓެން އޮފް"
      },
      "serviceKind": {
        "activity": "އަކްޓިވިޓި",
        "spa": "ސްޕަ",
        "dining": "ޑިނިންގް",
        "transfer": "ޓްރަންސްފެރް",
        "rental": "ރެންޓަލް",
        "other": "އޮތެރް"
      },
      "bookingStatus": {
        "booked": "ބޫކެޑް",
        "confirmed": "ކޮންފިރްމެޑް",
        "delivered": "ޑެލިވެރެޑް",
        "cancelled": "ކެންސަލްކޮށްފި",
        "no_show": "ނެތް-ށޮވް"
      },
      "mealPeriod": {
        "breakfast": "ބްރީކްފަސްޓް",
        "lunch": "ލުންޗް",
        "dinner": "ޑިނެރް",
        "snack": "ސްނަކް"
      },
      "boardPlanStatus": {
        "draft": "ޑްރަފްޓް",
        "active": "އަކްޓިވް",
        "closed": "ބަންދު"
      },
      "transferDirection": {
        "arrival": "އަރިވަލް",
        "departure": "ޑެޕަރްޓުރް",
        "internal": "އިންޓެރްނަލް"
      },
      "transferLegStatus": {
        "planned": "ޕްލަނެޑް",
        "confirmed": "ކޮންފިރްމެޑް",
        "departed": "ޑެޕަރްޓެޑް",
        "completed": "ކޮމްޕްލެޓެޑް",
        "cancelled": "ކެންސަލްކޮށްފި"
      },
      "requestKind": {
        "request": "ރެކްވެސްޓް",
        "complaint": "ކޮމްޕްލައިންޓް"
      },
      "requestStatus": {
        "open": "ހުޅުވިފައި",
        "assigned": "އަސިގްނެޑް",
        "resolved": "ރެސޮލްވެޑް",
        "escalated": "އެސްކަލަޓެޑް",
        "closed": "ބަންދު"
      },
      "severity": {
        "low": "ލޮވް",
        "medium": "މެޑިއުމް",
        "high": "ހިގް"
      },
      "recoveryKind": {
        "none": "ނެތް — އަކްނޮވްލެޑްޖެޑް, އެއްވެސް އެއްޗެއް ނެތް ޖިވެން",
        "allowance": "ފޮލިއޮ އަލޮވަންސް",
        "comp_service": "ކޮމްޕްލިމެންޓަރި ސެރްވިސް",
        "points": "ލޮޔަލްޓި ޕޮއިންޓްސް",
        "gift": "ޖިފްޓް"
      },
      "frontDesk": {
        "title": "ފްރޮންޓް ޑެސްކް",
        "description": "އަރިވަލްސް, ޑެޕަރްޓުރެސް އަދި ކާކު އަކީ ގައި ހައުސް.",
        "tabsLabel": "ފްރޮންޓް ޑެސްކް ބޯރްޑްސް",
        "tabArrivals": "އަރިވަލްސް",
        "tabDepartures": "ޑެޕަރްޓުރެސް",
        "tabInHouse": "ގައި ހައުސް",
        "arrivalsCaption": "ރެސެރްވަޓިއޮންސް އަރިވިންގް މިއަދު",
        "departuresCaption": "ރެސެރްވަޓިއޮންސް ޑެޕަރްޓިންގް މިއަދު",
        "inHouseCaption": "ކޮޓަރިތައް އޮކުޕީޑް ޓޮނިގްޓް",
        "arrivalsEmpty": "ނޮބޮޑި އަކީ އަރިވިންގް ގައި މި ތާރީޚު. ޚިޔާރުކުރައްވާ އަނޮތެރް ތާރީޚު, ނުވަތަ ޓަކް ބޫކިންގް ން ރެސެރްވަޓިއޮންސް ސްކްރީން.",
        "departuresEmpty": "ނޮބޮޑި އަކީ ޑެޕަރްޓިންގް ގައި މި ތާރީޚު.",
        "inHouseEmpty": "ނޮބޮޑި އަކީ ގައި ހައުސް ގައި މި ތާރީޚު.",
        "loadFailed": "ބޯރްޑް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ވޮރްކް ޑެސްކް.",
        "dateHint": "ބްލަންކް މީންސް ޕްރޮޕެރްޓިސް އޮވްން ބުސިނެސް ތާރީޚު.",
        "restricted": "ރެސްޓްރިކްޓެޑް މެހެމާން"
      },
      "checkIn": {
        "title": "ޗެކް ގައި",
        "action": "ޗެކް ގައި",
        "description": "އަސިގްންސް ކޮޓަރި, އޮޕެންސް ފޮލިއޮ, ވްރިޓެސް ރެޖިސްޓްރަޓިއޮން ކަރްޑް, ޓަކެސް އައުތޮރިސަޓިއޮން އަދި އިސުއެސް ކޭ — ގައި އެއް ޓްރަންސަކްޓިއޮން.",
        "submit": "ޗެކް ގައި",
        "done": "ޗެކެޑް ގައި",
        "failed": "ޗެކް-ގައި ވި ބަލައިނުގަތް",
        "restricted": "މި މެހެމާން އަކީ ގައި ރެސްޓްރިކްޓެޑް ލިސްޓް. ޗެކް-ގައި އަކީ ބަލައިނުގަތް އަދި އެތާ އަކީ ނެތް އޮވެރިޑް — އަށް އަނިއޮން. ޓަކް އެ އަށް މަނަޖެރް.",
        "roomHint": "ލީވް ބްލަންކް އިފް ކޮޓަރި އަކީ އަލްރީޑި އަސިގްނެޑް.",
        "reasonHint": "ރެކޮރްޑެޑް އަގައިންސްޓް އަސިގްންމެންޓް, ސޮ އެ ކަން އެކްސްޕްލައިނެޑް ލަޓެރް.",
        "issueKeyLabel": "އިސުއެ ކޭ",
        "issueKeyHint": "މެހެމާން ކާކު އަކީ ޗެކެޑް ގައި އަދި ކަނޮޓް ހުޅުވިފައި ޑޫރް އަކީ ނޫން ޗެކެޑް ގައި.",
        "holdLabel": "ޓަކް ކަރްޑް އައުތޮރިސަޓިއޮން",
        "holdHint": "ރެކޮރްޑްސް ކޮން ޓެރްމިނަލް ރެޓުރްނެޑް. ނެތް ކަރްޑް ނުމްބެރް އަކީ އަކްސެޕްޓެޑް ނުވަތަ ސްޓޮރެޑް.",
        "panHint": "ފައުރް ޑިޖިޓްސް ހަމައެކަނި — ދުވަހަކުވެސ ފުލް ކަރްޑް ނުމްބެރް."
      },
      "checkOut": {
        "title": "ޗެކް ބޭރު",
        "action": "ޗެކް ބޭރު",
        "description": "ސެޓްލެސް ސްޓަޔް, ކަންސެލްސް ކޭސް އަދި ރެލީސެސް ހޮލްޑްސް.",
        "submit": "ޗެކް ބޭރު",
        "done": "ޗެކެޑް ބޭރު",
        "failed": "ޗެކް-ބޭރު ވި ބަލައިނުގަތް",
        "summary": "{keys} ކޭ(ސް) ކެންސަލްކޮށްފި, {holds} ހޮލްޑް(ސް) ރެލީސެޑް",
        "outstandingNote": "މި ފޮލިއޮ ސްޓިލް ބާކީ. ޗެކިންގް ބޭރު މަތިން އެ ނީޑްސް ސަބަބު އަދި އޮޕެންސް ކްވެއުއެ އިޓެމް އަށް ސޮމެބޮޑި އަށް ޗަސް."
      },
      "assign": {
        "title": "އަސިގްން ކޮޓަރި",
        "action": "އަސިގްން",
        "description": "ޕްރް-އަސިގްން ކޮޓަރި ކުރިން މެހެމާން އަރިވެސް.",
        "submit": "އަސިގްން",
        "done": "ކޮޓަރި އަސިގްނެޑް",
        "failed": "އަސިގްންމެންޓް ވި ބަލައިނުގަތް",
        "reasonHint": "ކީއްވެ މި ކޮޓަރި އަދި ނޫން އަނޮތެރް އެއް.",
        "rationaleNote": "ރަޓިއޮނަލް އަކީ ސްޓޮރެޑް ގައި އަސިގްންމެންޓް. \"ކީއްވެ ޑިޑް މި މެހެމާން ޖެޓް މި ކޮޓަރި\" އަކީ ކްވެސްޓިއޮން އަސްކެޑް ޑަޔްސް ލަޓެރް."
      },
      "roomMove": {
        "title": "މޮވް ކޮޓަރި",
        "action": "މޮވް",
        "description": "މޮވެސް މެހެމާން މިޑް-ސްޓަޔް, އަޓޮމިކަލި.",
        "submit": "މޮވް",
        "done": "މޮވެޑް ން {from} އަށް {to}",
        "summary": "{repriced} ރޭ(ސް) ރެޕްރިސެޑް, {untouched} ލެފްޓް އަލޮން",
        "failed": "މޮވް ވި ބަލައިނުގަތް",
        "fromRoom": "ން",
        "toRoom": "އަށް",
        "repriceLabel": "ރެޕްރިސް ރެމައިނިންގް ނިގްޓްސް",
        "repriceHint": "އޮފް ލީވެސް ރަޓް ގޮތުގައި ބޫކެޑް — ޕްރޮޕަޓީ އަބްސޮރްބްސް ޑިފެރެންސް.",
        "postedNote": "ނިގްޓްސް އެ އަލްރީޑި ޕޮސްޓެޑް ނަމަ ދުވަހަކުވެސ ރެޕްރިސެޑް. ކޮރެކްޓް އެއް އެ ން ރެވެރްސިންގް އޭގެ ޗާޖު."
      },
      "registration": {
        "title": "ރެޖިސްޓްރަޓިއޮން ކަރްޑް",
        "description": "ރީޑް ޓްރަވެލް ޑޮކުމެންޓް, ތެން ކޮންފިރްމް ކޮންމެ ފީލްޑް.",
        "uploadLabel": "ޑޮކުމެންޓް އިމަޖް ނުވަތަ ޕްޑްފް",
        "uploadHint": "އެކްސްޓްރަކްޓިއޮން ރީޑްސް އެ އަދި ވްރިޓެސް އެއްވެސް އެއްޗެއް ނެތް. ތިޔަ ކޮންފިރްމް ކޮން އެ ރީޑް.",
        "extracting": "ރީޑިންގް ޑޮކުމެންޓް…",
        "empty": "ނެތް ޑޮކުމެންޓް ރީޑް ޔެޓް. އުޕްލޯޑް އެއް, ނުވަތަ ބާވަތް ކަރްޑް ން ހަންޑް.",
        "noGuest": "މި ރެސެރްވަޓިއޮން ނެތް މެހެމާން އަޓަޗެޑް, ސޮ އެތާ އަކީ ނެތް ޕްރޮފިލް އަށް ރީޑް ޑޮކުމެންޓް ތެރެއަށް. އަޓަޗް މެހެމާން ފުރަތަމަ.",
        "confirmNote": "އެއްވެސް އެއްޗެއް ނެތް ބެލޮވް އަކީ ކޮންފިރްމެޑް ވަންދެން ތިޔަ ޓިކް އެ. ފީލްޑް މޮޑެލް ވި އުންސުރް އަބައުޓް އަކީ ހިގްލިގްޓެޑް — ޗެކް އެ އަގައިންސްޓް ޑޮކުމެންޓް ގައި ޔައުރް ހަންޑް.",
        "confirm": "ކޮންފިރްމެޑް",
        "confidenceFor": "ކޮންފިޑެންސް އަށް {field}",
        "overall": "އޮވެރަލް ކޮންފިޑެންސް",
        "lowCount": "{count} ފީލްޑް(ސް) ރީޑް އާއެކު ލޮވް ކޮންފިޑެންސް",
        "extractFailed": "ޑޮކުމެންޓް ނޫން ރީޑް",
        "signatureLabel": "ސިގްނަޓުރް ކަޕްޓުރެޑް",
        "signatureHint": "ރެކޮރްޑްސް އެ މެހެމާން ސިގްނެޑް ކަރްޑް."
      },
      "holds": {
        "title": "އައުތޮރިސަޓިއޮން ހޮލްޑްސް",
        "description": "ކަރްޑް އައުތޮރިސަޓިއޮންސް ޓަކެން އަގައިންސްޓް މި ފޮލިއޮ.",
        "caption": "އައުތޮރިސަޓިއޮން ހޮލްޑްސް ގައި މި ފޮލިއޮ",
        "empty": "ނެތް އައުތޮރިސަޓިއޮން ޓަކެން ގައި މި ފޮލިއޮ.",
        "loadFailed": "ހޮލްޑްސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "release": "ރެލީސް",
        "released": "ހޮލްޑް ރެލީސެޑް",
        "releaseFailed": "ހޮލްޑް ނޫން ރެލީސެޑް"
      },
      "keys": {
        "title": "ކޭސް",
        "description": "ކޭސް އިސުއެޑް އަށް މި ސްޓަޔް. ކޭ އަކީ އެވެންޓް, ނޫން ލޮކް.",
        "caption": "ކޭސް އިސުއެޑް އަށް މި ސްޓަޔް",
        "empty": "ނެތް ކޭ އިސުއެޑް އަށް މި ސްޓަޔް.",
        "noStay": "މި ފޮލިއޮ ނެތް ރެސެރްވަޓިއޮން ބެހިންޑް އެ, ސޮ އެ ނެތް ކޭސް.",
        "loadFailed": "ކޭސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "cancel": "ކެންސަލް",
        "cancelled": "ކޭ ކެންސަލްކޮށްފި",
        "cancelFailed": "ކޭ ނޫން ކެންސަލްކޮށްފި"
      },
      "folios": {
        "title": "ފޮލިއޮސް",
        "description": "ކޮންމެ މެހެމާން ބިލް ގައި ޕްރޮޕަޓީ, ހުޅުވިފައި އަދި ސެޓްލެޑް.",
        "tableTitle": "ފޮލިއޮސް",
        "caption": "ފޮލިއޮސް އަށް ޗޮސެން ޕްރޮޕަޓީ",
        "empty": "ނެތް ފޮލިއޮ މަޓްޗެސް މި ފިލްޓެރްސް. ސްޓަޔްސް ފޮލިއޮ އޮޕެންސް ގައި ޗެކް-ގައި; ވަލްކް-ގައި ނުވަތަ ހައުސް ފޮލިއޮ އަކީ އުފައްދައިފި މިތާ.",
        "loadFailed": "ފޮލިއޮސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ސީ އޭގެ ފޮލިއޮސް.",
        "searchLabel": "ހޯދާ",
        "searchPlaceholder": "ފޮލިއޮ ނުމްބެރް ނުވަތަ މެހެމާން",
        "create": "އައު ފޮލިއޮ",
        "createDescription": "ވަލްކް-ގައި ނުވަތަ ހައުސް ފޮލިއޮ — އެއް އާއެކު ނެތް ރެސެރްވަޓިއޮން ބެހިންޑް އެ.",
        "created": "ފޮލިއޮ އޮޕެނެޑް",
        "createFailed": "ފޮލިއޮ ނޫން އޮޕެނެޑް"
      },
      "folio": {
        "description": "ގުއެސްޓްސް ބިލް. ޗާޖުތައް ނަމަ އަޕެންޑް-ހަމައެކަނި; ކޮރެކްޓިއޮން އަކީ ރެވެރްސަލް.",
        "summary": "ފޮލިއޮ",
        "loadFailed": "ފޮލިއޮ ނޫން ލޯޑުކުރެވިއްޖެ",
        "tabsLabel": "ފޮލިއޮ ވިންޑޮވްސް އަދި ޕަނެލްސް",
        "tabRouting": "ރައުޓިންގް",
        "tabDeposits": "ޑެޕޮސިޓްސް އަދި ސެޓްލެމެންޓްސް",
        "tabDesk": "ކޭސް އަދި ހޮލްޑްސް",
        "postCharge": "ޕޮސްޓް ޗާޖު",
        "settle": "ސެޓްލް",
        "cityLedger": "އަށް ސިޓި ލެޑްޖެރް",
        "allowance": "އަލޮވަންސް",
        "transfer": "ޓްރަންސްފެރް",
        "addWindow": "އިތުރުކުރައްވާ ވިންޑޮވް",
        "addWindowDescription": "ވިންޑޮވް އަކީ ސެޕަރަޓް ބާކީ އޮވެޑް ން ސެޕަރަޓް ޕަރްޓި.",
        "windowAdded": "ވިންޑޮވް އަޑެޑް",
        "windowFailed": "ވިންޑޮވް ނޫން އަޑެޑް",
        "invoice": "އިންވޮއިސް ޕްޑްފް",
        "invoiceFailed": "އިންވޮއިސް ނޫން ޕްރޮޑުސެޑް",
        "closedNote": "މި ފޮލިއޮ އަކީ ބަންދު. ޗާޖުތައް އަދި ސެޓްލެމެންޓްސް ނަމަ ރީޑް-ހަމައެކަނި; ޗާޖު އަރިވިންގް ނޮވް އަކީ ލަޓް ޗާޖު އަދި އޮޕެންސް އައު ވިންޑޮވް."
      },
      "ledger": {
        "caption": "ޗާޖުތައް ގައި {window} ވިންޑޮވް",
        "empty": "އެއްވެސް އެއްޗެއް ނެތް ޗަރްޖެޑް އަށް މި ވިންޑޮވް ޔެޓް.",
        "reverse": "ރެވެރްސް",
        "windowBalance": "ވިންޑޮވް ބާކީ"
      },
      "postCharge": {
        "title": "ޕޮސްޓް ޗާޖު",
        "description": "އަޑްސް އެއް ޗާޖު އަށް ފޮލިއޮ ވިންޑޮވް.",
        "submit": "ޕޮސްޓް",
        "done": "ޗާޖު ޕޮސްޓެޑް",
        "split": "ރައުޓިންގް ރުލެސް ސްޕްލިޓް އެ އަކްރޮސް {count} ވިންޑޮވްސް.",
        "failed": "ޗާޖު ވި ބަލައިނުގަތް",
        "dateHint": "ބްލަންކް މީންސް ޕްރޮޕެރްޓިސް އޮވްން ބުސިނެސް ތާރީޚު.",
        "netHint": "އަދަދު ކުރިން ޓެކްސް, ގޮތުގައި ޑެސިމަލް ސްޓްރިންގް.",
        "taxHint": "ލީވް ބްލަންކް އަދި ޓެކްސް އެންޖިން ސޮލްވެސް އެ ން ޓެކްސް ކޯޑު.",
        "taxCodeHint": "ކޮންމެ ޗާޖު ކަރީސް ޓެކްސް ކޯޑު ނުވަތަ އިޓެމް ޓެކްސް ގްރައުޕް. އެތާ އަކީ ނެތް އުންކްލަސިފީޑް ޗާޖު.",
        "routingNote": "ރައުޓިންގް ރުލެސް ޑެސިޑް ކޮން ވިންޑޮވް މި ލަންޑްސް ގައި, އަދި މަޔް ސްޕްލިޓް އެ އިފް ކަޕް މަދު ހީޑްރޫމް ވުރެ އަދަދު.",
        "lateNote": "މި ފޮލިއޮ ސެޓްލެޑް, ސޮ މި އަކީ ލަޓް ޗާޖު."
      },
      "reverse": {
        "title": "ރެވެރްސް ޗާޖު",
        "description": "ހަމައެކަނި ވަޔް އަށް ކޮރެކްޓް ޕޮސްޓެޑް ޗާޖު. އެ ވްރިޓެސް މިރޮރް ރޮވް; އޮރިޖިނަލް ސްޓަޔްސް.",
        "submit": "ރެވެރްސް",
        "done": "ޗާޖު ރެވެރްސެޑް",
        "failed": "ރެވެރްސަލް ވި ބަލައިނުގަތް",
        "reasonLabel": "ކީއްވެ އަކީ މި ބެއިންގް ރެވެރްސެޑް",
        "exactNote": "ރެވެރްސަލް އަކީ އެކްސަކްޓް ނެގަޓިއޮން ޗާޖު އަބޮވް. އެތާ އަކީ ނެތް ޕަރްޓިއަލް ރެވެރްސަލް — އަށް ޕަރްޓް ޗާޖު, ރެވެރްސް އެ އަދި ޕޮސްޓް ކޮރެކްޓް އަދަދު."
      },
      "settle": {
        "title": "ސެޓްލް ފޮލިއޮ",
        "description": "އެއް ލިން ކޮންމެ ވިންޑޮވް އެ ސްޓިލް ބާކީ.",
        "caption": "ވިންޑޮވްސް އަށް ސެޓްލް",
        "submit": "ސެޓްލް",
        "done": "ފޮލިއޮ ސެޓްލެޑް",
        "failed": "ސެޓްލެމެންޓް ވި ބަލައިނުގަތް",
        "empty": "ކޮންމެ ވިންޑޮވް ގައި މި ފޮލިއޮ އަކީ އަލްރީޑި ސެޓްލެޑް.",
        "includeLabel": "ސެޓްލް {window} ވިންޑޮވް",
        "accountPlaceholder": "ވްހެރް ޑިޑް ފައިސާ ލަންޑް",
        "dateHint": "ބްލަންކް މީންސް ޕްރޮޕެރްޓިސް އޮވްން ބުސިނެސް ތާރީޚު.",
        "keepOpenLabel": "ކީޕް ފޮލިއޮ ހުޅުވިފައި",
        "keepOpenHint": "އަށް ޑެޕަރްޓިންގް މެހެމާން ވްހޮސް ކުންފުނި އަކީ ބެއިންގް އިންވޮއިސެޑް އަދި ވްހޮސް ލަޓް ޗާޖުތައް ނަމަ ސްޓިލް އަށް ކޮމް.",
        "routedNote": "ތިން މެތޮޑްސް ޑޮ ސޮމެތިންގް ސެޓްލެމެންޓް ޑޮއެސް ނޫން, އަދި ކޮންމެ އޭގެ އޮވްން އަކްޓިއޮން:",
        "settledTitle": "ސެޓްލެމެންޓްސް",
        "settledCaption": "ސެޓްލެމެންޓްސް އަލްރީޑި ޕޮސްޓެޑް އަށް މި ފޮލިއޮ",
        "settledEmpty": "އެއްވެސް އެއްޗެއް ނެތް ސެޓްލެޑް ގައި މި ފޮލިއޮ ޔެޓް."
      },
      "cityLedger": {
        "title": "ޓްރަންސްފެރް އަށް ސިޓި ލެޑްޖެރް",
        "description": "ރައިސެސް ރީލް ރެސެއިވަބްލް އަގައިންސްޓް ކުންފުނި ވިންޑޮވް އަކީ ބިލެޑް އަށް.",
        "submit": "ޓްރަންސްފެރް",
        "done": "ޓްރަންސްފެރެޑް އަށް ސިޓި ލެޑްޖެރް",
        "failed": "ޓްރަންސްފެރް ވި ބަލައިނުގަތް",
        "amountHint": "ބްލަންކް ޓްރަންސްފެރްސް ވްހޮލް ވިންޑޮވް ބާކީ.",
        "receivableNote": "މި ރައިސެސް އަކައުންޓްސް-ރެސެއިވަބްލް އިންވޮއިސް. އެ އަކީ ނޫން ބޫކީޕިންގް ޖެސްޓުރް އިންސިޑް ޕްރޮޕަޓީ — ކުންފުނި ވާނެ ޗަސެޑް އަށް އެ."
      },
      "allowance": {
        "title": "ޕޮސްޓް އަލޮވަންސް",
        "description": "ވްރިޓެސް އަދަދު އޮފް ފޮލިއޮ ވިންޑޮވް.",
        "submit": "ޕޮސްޓް އަލޮވަންސް",
        "done": "އަލޮވަންސް ޕޮސްޓެޑް",
        "failed": "އަލޮވަންސް ވި ބަލައިނުގަތް",
        "reasonLabel": "ކީއްވެ އަކީ މި ބެއިންގް ވްރިޓެން އޮފް",
        "taxCodeHint": "ބްލަންކް ރެވެރްސެސް ޓެކްސް ސަމް ވަޔް އޮރިޖިނަލް ޗާޖު ކަރީޑް އެ.",
        "controlNote": "އަލޮވަންސް އަކީ ފައިސާ ޕްރޮޕަޓީ ޖިވެސް މައްޗަށް. އެ އަކީ އަޕްރޮވެޑް, އެ އޮޕެންސް ކްވެއުއެ އިޓެމް, އަދި ވްހޮއެވެރް ޕޮސްޓްސް އެ މުސްޓް ނޫން ޕެރްސޮން ކާކު ތެން ކްލޮސެސް ދުވަސް."
      },
      "transfer": {
        "title": "ޓްރަންސްފެރް އަށް އަނޮތެރް ފޮލިއޮ",
        "description": "މޮވެސް ވިންޑޮވްސް ބާކީ އަށް ޑިފެރެންޓް ފޮލިއޮ — ގްރައުޕް މަސްޓެރް, އުސުއަލި.",
        "submit": "ޓްރަންސްފެރް",
        "done": "ބާކީ ޓްރަންސްފެރެޑް",
        "failed": "ޓްރަންސްފެރް ވި ބަލައިނުގަތް",
        "targetHint": "ފޮލިއޮ އިޑް އެ އަކީ މޮވިންގް އަށް. ޓަކް އެ ން ޕަޕެރްވޮރްކް, ނޫން ން ގުއެސް.",
        "amountHint": "ބްލަންކް މޮވެސް ވްހޮލް ވިންޑޮވް ބާކީ.",
        "pairNote": "މި ވްރިޓެސް ދެ ޗާޖުތައް — އެއް ބޭރު މި ފޮލިއޮ އަދި އެއް ތެރެއަށް އޮތެރް — އަދި ބޮތް ސްޓަޔް ވިސިބްލް ގައި ބޮތް."
      },
      "routing": {
        "title": "ރައުޓިންގް ރުލެސް",
        "description": "ކޮން ލަންޑްސް ގައި ކޮން ވިންޑޮވް, ގައި އޮރްޑެރް, އަދި މައްޗަށް އަށް ކިހިނެއް ގިނަ.",
        "caption": "ރައުޓިންގް ރުލެސް އަށް މި ފޮލިއޮ",
        "empty": "ނެތް ރައުޓިންގް ރުލް. ކޮންމެ ޗާޖު ލަންޑްސް ގައި މެހެމާން ވިންޑޮވް.",
        "add": "އިތުރުކުރައްވާ ރުލް",
        "remove": "ނަގާ",
        "moveUp": "މޮވް އީރްލީރް",
        "moveDown": "މޮވް ލަޓެރް",
        "saved": "ރައުޓިންގް ރުލެސް ސޭވްކޮށްފި",
        "failed": "ރައުޓިންގް ރުލެސް ވި ބަލައިނުގަތް",
        "loadFailed": "ރައުޓިންގް ރުލެސް ނޫން ލޯޑުކުރެވިއްޖެ"
      },
      "deposits": {
        "title": "ޑެޕޮސިޓްސް",
        "description": "ފައިސާ ޓަކެން ކުރިން ސްޓަޔް, އަދި ކޮން ބެކަމް އެ.",
        "tableTitle": "ޑެޕޮސިޓްސް",
        "caption": "ޑެޕޮސިޓްސް އަށް ޗޮސެން ޕްރޮޕަޓީ",
        "folioDescription": "ޑެޕޮސިޓްސް ހެލްޑް އަގައިންސްޓް މި ފޮލިއޮ.",
        "empty": "ނެތް ޑެޕޮސިޓް އަކީ ހެލްޑް އަގައިންސްޓް މި ފޮލިއޮ.",
        "emptyList": "ނެތް ޑެޕޮސިޓް މަޓްޗެސް މި ފިލްޓެރްސް.",
        "goToRegister": "ހުޅުވިފައި ޑެޕޮސިޓް ރެޖިސްޓެރް",
        "loadFailed": "ޑެޕޮސިޓްސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ސީ އޭގެ ޑެޕޮސިޓްސް.",
        "searchLabel": "ހޯދާ",
        "take": "ޓަކް ޑެޕޮސިޓް",
        "takeDescription": "ރެކޮރްޑްސް ފައިސާ އަކްޓުއަލި ރެސެއިވެޑް. އެ ޕޮސްޓްސް އަށް ބަންކް އަދި އަށް ޑެޕޮސިޓްސް-ހެލްޑް ލިއަބިލިޓި.",
        "taken": "ޑެޕޮސިޓް ރެކޮރްޑެޑް",
        "apply": "އަޕްލި",
        "applyTitle": "އަޕްލި ޑެޕޮސިޓް",
        "applyDescription": "މޮވެސް ޑެޕޮސިޓް އޮންޓޮ ފޮލިއޮ ވިންޑޮވް.",
        "applied": "ޑެޕޮސިޓް އަޕްލީޑް",
        "refund": "ރެފުންޑް",
        "refundTitle": "ރެފުންޑް ޑެޕޮސިޓް",
        "refundDescription": "ރެޓުރްންސް ކޮން އަކީ ލެފްޓް ޑެޕޮސިޓް އަށް މެހެމާން.",
        "refunded": "ޑެޕޮސިޓް ރެފުންޑެޑް",
        "failed": "ޑެޕޮސިޓް ނޫން އުޕްޑަޓެޑް",
        "amountHint": "ބްލަންކް މީންސް ހުރިހާ ކޮން އަކީ ލެފްޓް.",
        "wholeNote": "ލީވިންގް އަދަދު ބްލަންކް އަޕްލީސް ނުވަތަ ރެފުންޑްސް އެވެރިތިންގް ރެމައިނިންގް. ސެރްވެރް ރެފުސެސް އިތުރު ވުރެ ޑެޕޮސިޓް ސްޓިލް ހޮލްޑްސް."
      },
      "nightAudit": {
        "title": "ރޭ އައުޑިޓް",
        "description": "ޕޮސްޓް ދުވަސް, ރޮލް ތާރީޚު, އަދި ޕްރޮޑުސް ޕަކް އައުޑިޓޮރް ރީޑްސް.",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ސީ ވްހެތެރް އެ ކަން ރޮލް.",
        "dateHint": "ބްލަންކް މީންސް ޕްރޮޕެރްޓިސް އޮވްން ބުސިނެސް ތާރީޚު.",
        "readinessTitle": "ރީޑިނެސް",
        "readinessDescription": "ކޮންމެ ޗެކް ރޮލް މަކެސް, ބްލޮކެރްސް ފުރަތަމަ.",
        "readinessFailed": "ރީޑިނެސް ޗެކްސް ނޫން ރުން",
        "ready": "ރީޑި އަށް ރޮލް.",
        "blocked": "{count} ބްލޮކިންގް ޗެކް(ސް) މުސްޓް ކްލީރެޑް, ނުވަތަ ރޮލް މުސްޓް ފޮރްސެޑް.",
        "checkBlocking": "ބްލޮކިންގް",
        "checkAdvisory": "އަޑްވިސޮރި",
        "checkPassed": "ޕަސެޑް",
        "checksEmpty": "ނެތް ރީޑިނެސް ޗެކް ރަން.",
        "start": "ސްޓަރްޓް ރޭ",
        "startHint": "އިޑެމްޕޮޓެންޓް — ސެކޮންޑް ސްޓަރްޓް ރެޓުރްންސް ރުން އަލްރީޑި ގައި ފްލިގްޓް.",
        "started": "ރޭ އައުޑިޓް ސްޓަރްޓެޑް",
        "startFailed": "ރޭ އައުޑިޓް ނޫން ސްޓަރްޓެޑް",
        "runsTitle": "ރުންސް",
        "runsDescription": "ކޮންމެ ރޭ މި ކުންފުނި ރޮލެޑް.",
        "runsCaption": "ރޭ އައުޑިޓް ރުންސް",
        "runsEmpty": "ނެތް ރޭ ރޮލެޑް އަށް މި ކުންފުނި ޔެޓް.",
        "runsFailed": "ރުންސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "runFailed": "ރުން ނޫން ލޯޑުކުރެވިއްޖެ",
        "runDescription": "ދިހަ ސްޓެޕްސް, ޖައުރްނަލް އެމީހުން ޕޮސްޓެޑް, އަދި ދުވަސް ޕަކް.",
        "runSummary": "ރުން",
        "backToBoard": "އަނބުރާ އަށް ބޯރްޑް",
        "advance": "ރުން ދެން ސްޓެޕް",
        "advancing": "ރުނިންގް ސްޓެޕް",
        "advanceFailed": "ސްޓެޕް ވި ބަލައިނުގަތް",
        "stepsTitle": "ސްޓެޕްސް",
        "stepsDescription": "ކޮންމެ ސްޓެޕް އަކީ ކޮމިޓެޑް ސެޕަރަޓެލި, ސޮ ރުން އެ ޑީސް ރެސުމެސް ވްހެރް އެ ސްޓޮޕެޑް.",
        "durationMs": "{ms} މްސް",
        "force": "ފޮރްސް",
        "forceTitle": "ފޮރްސް ރޮލް",
        "forceDescription": "ޕްރޮސީޑްސް ޕަސްޓް ބްލޮކިންގް ރީޑިނެސް ޗެކް.",
        "forceSubmit": "ފޮރްސް ރޮލް",
        "forceWarning": "ފޮރްސިންގް ޕޮސްޓްސް ދުވަސް މަތިން ކޮންޓްރޮލް އެ ބަލައިނުގަތް. ރުން އަކީ ސްޓަމްޕެޑް ގޮތުގައި ފޮރްސެޑް އަށް ގޮތުގައި ލޮންގް ގޮތުގައި އެ އެކްސިސްޓްސް, އަދި ކްވެއުއެ އިޓެމް އޮޕެންސް އަށް ސޮމެބޮޑި އަށް އަންސްވެރް އަށް އެ.",
        "forceReasonLabel": "ކީއްވެ އަކީ ރޮލް ބެއިންގް ފޮރްސެޑް",
        "forceNoBlockers": "އެއްވެސް އެއްޗެއް ނެތް އަކީ ބްލޮކިންގް މި ރުން.",
        "forced": "ރުން ފޮރްސެޑް",
        "forceFailed": "ރޮލް ނޫން ފޮރްސެޑް",
        "forcedBadge": "ފޮރްސެޑް",
        "forcedNote": "މި ރުން ވި ފޮރްސެޑް: {reason}.",
        "forcedQueueLink": "ހުޅުވިފައި ކްވެއުއެ އިޓެމް",
        "abandon": "އަބަންޑޮން",
        "abandonTitle": "އަބަންޑޮން މި ރުން",
        "abandonDescription": "ސްޓޮޕްސް ރުން. އައު އެއް އަށް ސްޓަރްޓެޑް އަށް މި ތާރީޚު.",
        "abandoned": "ރުން އަބަންޑޮނެޑް",
        "abandonFailed": "ރުން ނޫން އަބަންޑޮނެޑް",
        "abandonedNote": "މި ރުން ވި އަބަންޑޮނެޑް: {reason}. ސްޓަރްޓް އައު ރުން އަށް މި ތާރީޚު.",
        "journalTitle": "ޖައުރްނަލް އެ ޕޮސްޓެޑް",
        "journalDescription": "ލިނެސް ގޮތުގައި ރުން ބުއިލްޓް ތެމް, އަދި އެންޓްރި އެމީހުން ބެކަމް.",
        "journalCaption": "ރޭ އައުޑިޓް ޖައުރްނަލް ލިނެސް",
        "journalEmpty": "މި ރުން ނޫން ބުއިލްޓް އޭގެ ޖައުރްނަލް ލިނެސް ޔެޓް.",
        "journalLink": "ހުޅުވިފައި ޖައުރްނަލް އެންޓްރި #{id}",
        "revenueTotals": "ރެވެނުއެ ރެކޮރްޑެޑް ން ރުން (ނެޓް, ގްރޮސް)",
        "checks": {
          "unpostedNights": "ގައި-ހައުސް ކޮޓަރިތައް އާއެކު އުންޕޮސްޓެޑް ރޭ",
          "arrivalsPending": "ކޮންފިރްމެޑް އަރިވަލްސް އެ ނޫން ޗެކެޑް ގައި",
          "departuresDue": "ޑެޕަރްޓުރެސް ސްޓިލް ގައި ހައުސް",
          "departedOpenFolios": "ޑެޕަރްޓެޑް މެހެމާނުން އާއެކު ހުޅުވިފައި ފޮލިއޮ",
          "posDayUnswept": "ޕޮއިންޓް--ސަލް ޑަޔްސް ނޫން ޔެޓް ބަންދު",
          "unroutedCharges": "ޗާޖުތައް އެ މަޓްޗެޑް ނެތް ރައުޓިންގް ރުލް",
          "outOfOrderExpired": "ބޭރު--އޮރްޑެރް ކޮޓަރިތައް ޕަސްޓް އެމީހުންގެ ރެލީސް ތާރީޚު",
          "periodOpen": "އަކައުންޓިންގް ޕެރިއޮޑް އަކީ ހުޅުވިފައި"
        }
      },
      "dayPack": {
        "title": "ދުވަސް ޕަކް",
        "description": "އެވިޑެންސް ބުންޑްލް, އަދި ހަށް އެ މަކެސް އެ އެވިޑެންސް.",
        "caption": "ޕަރްޓްސް ދުވަސް ޕަކް",
        "manifestHash": "މަނިފެސްޓް ހަށް",
        "downloadedHash": "ހަށް ފިލް ތިޔަ ޑޮވްންލޯޑެޑް",
        "part": "ޕަރްޓް",
        "contentType": "ބާވަތް",
        "rows": "ރޮވްސް",
        "bytes": "ބިޓެސް",
        "sha256": "ށަ-256",
        "partsEmpty": "ޕަކް ނެތް ޕަރްޓްސް ރެކޮރްޑެޑް.",
        "pending": "ދުވަސް ޕަކް އަކީ ބުއިލްޓް ގައި ސްޓެޕް 9. އެ އަކީ ނޫން އަވައިލަބްލް ޔެޓް.",
        "download": "ޑޮވްންލޯޑް ޕަކް",
        "downloadFailed": "ޕަކް ނޫން ޑޮވްންލޯޑެޑް",
        "noHash": "ޑޮވްންލޯޑް ޑިޑް ނޫން ރެޓުރްން އޭގެ އަޓެސްޓަޓިއޮން ހަށް. ކޮމްޕަރް އެ އަގައިންސްޓް މަނިފެސްޓް އަބޮވް ކުރިން ރެލިއިންގް ގައި ފިލް."
      },
      "channels": {
        "title": "ޗަނެލްސް",
        "description": "ޑިސްޓްރިބުޓިއޮން ޗަނެލްސް މި ކުންފުނި ސެލްސް ތްރައުގް.",
        "tableTitle": "ޗަނެލްސް",
        "caption": "ޑިސްޓްރިބުޓިއޮން ޗަނެލްސް",
        "empty": "ނެތް ޗަނެލް އަކީ ކޮންފިގުރެޑް އަށް މި ކުންފުނި.",
        "loadFailed": "ޗަނެލްސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseCompany": "ޚިޔާރުކުރައްވާ ކުންފުނި އަށް ސީ އޭގެ ޗަނެލްސް.",
        "searchLabel": "ހޯދާ",
        "create": "އައު ޗަނެލް",
        "createTitle": "އައު ޗަނެލް",
        "editTitle": "އެޑިޓް ޗަނެލް",
        "dialogDescription": "ކާކު ސެލްސް ކޮޓަރިތައް, އަދި ކިހިނެއް އެކްސްޗަންޖް ހަޕެންސް.",
        "saved": "ޗަނެލް ސޭވްކޮށްފި",
        "saveFailed": "ޗަނެލް ނޫން ސޭވްކޮށްފި",
        "adapterManual": "މަނުއަލް — ސޮމެބޮޑި ޕަސްޓެސް އެކްސްޗަންޖް ގައި",
        "adapterFile": "ފިލް — އެކްސްޗަންޖް ފިލް އަކީ ޕިކެޑް މައްޗަށް ން ސްޓޮރަޖް",
        "adapterHint": "ހަމައެކަނި ރެޖިސްޓެރެޑް އަޑަޕްޓެރްސް ނަމަ އޮފެރެޑް; އުންކްނޮވްން އެއް ސްޓޮޕްސް ސެރްވެރް ގައި ބޫޓް.",
        "adapterNote": "އަޑަޕްޓެރް އަކީ ފުރަތަމަ ތިންގް އަށް ޗެކް ކޮންއިރަކު އެއްވެސް އެއްޗެއް ނެތް އަރިވެޑް: މަނުއަލް ވައިޓްސް އަށް ޕެރްސޮން, ފިލް ވައިޓްސް އަށް ފިލް.",
        "toleranceHint": "ކިހިނެއް ފަރް ޗަނެލްސް އަގު މަޔް ޑްރިފްޓް ން ރެފެރެންސް ޕްލަން ކުރިން އެ ކައުންޓްސް ގޮތުގައި ބްރީޗް.",
        "detailDescription": "ކޮން އެ އަކީ, ކޮން އެ ފަހު އެކްސްޗަންޖެޑް, އަދި ކިހިނެއް އަށް އެކްސްޗަންޖް އަގައިން.",
        "summary": "ޗަނެލް",
        "backToList": "އަނބުރާ އަށް ޗަނެލްސް",
        "exchangeTitle": "އެކްސްޗަންޖް",
        "exchangeDescription": "ޕުށް ރަޓެސް ބޭރު, ނުވަތަ ޕުލް ބޫކިންގްސް އަދި ކޮމިސިއޮން ގައި.",
        "exchangeSummary": "{rows} ރޮވް(ސް): {accepted} އަކްސެޕްޓެޑް, {rejected} ރެޖެކްޓެޑް",
        "push": "ޕުށް",
        "pushed": "ޕުށެޑް",
        "pushFailed": "ޕުށް ނާކާމިޔާބު",
        "pull": "ޕުލް",
        "pulled": "ޕުލެޑް",
        "pullFailed": "ޕުލް ނާކާމިޔާބު",
        "directionNote": "ޕުށް ސެންޑްސް ރަޓެސް, ރެސްޓްރިކްޓިއޮންސް ނުވަތަ އަވައިލަބިލިޓި ބޭރު. ޕުލް ބްރިންގްސް ބޫކިންގްސް އަދި ކޮމިސިއޮން ގައި. ބޫކިންގް އަކީ ދުވަހަކުވެސ ޕުށެޑް.",
        "exchangesTitle": "އެކްސްޗަންޖް ލޮގް",
        "exchangesCaption": "އެކްސްޗަންޖެސް އާއެކު މި ޗަނެލް",
        "exchangesEmpty": "އެއްވެސް އެއްޗެއް ނެތް އެކްސްޗަންޖެޑް އާއެކު މި ޗަނެލް ޔެޓް.",
        "exchangesFailed": "އެކްސްޗަންޖް ލޮގް ނޫން ލޯޑުކުރެވިއްޖެ",
        "ingestionTitle": "އިންޖެސްޝަން ކިއު",
        "ingestionDescription": "މި ޗެނަލުން ފޮނުވި ބުކިންތަކުގެ ތެރެއިން އިންޖެސްޓުން ޤަބޫލުނުކުރި ބުކިންތައް، އެންމެ ފަހުގެ އެކްސްޗޭންޖް ފުރަތަމަ.",
        "ingestionCaption": "ޤަބޫލުނުކުރެވުނު އިންބައުންޑް ބުކިންތައް، ޗެނަލްގެ އަމިއްލަ ރެފަރެންސާއި ކޮންމެ އެއްޗެއް ޤަބޫލުނުކުރި ސަބަބާއެކު.",
        "ingestionNote": "ޗެނަލްގައި ރޯ ރަނގަޅުކޮށް އަލުން ޕުލްކުރޭ. އިންޖެސްޓަކީ ޗެނަލް ރެފަރެންސްގެ މައްޗަށް އައިޑެމްޕޮޓެންޓް އެއްޗެއް، އެހެންވެ މިހާރު އައިސްފައިވާ ބުކިންއެއް ދެވަނަ ފަހަރަށް ނުއުފެދޭނެ."
      },
      "parity": {
        "title": "ރަޓް ޕަރިޓި",
        "description": "ކޮން ޗަނެލް އަކީ ށޮވިންގް, އަގައިންސްޓް ކޮން އެ ށައުލްޑް.",
        "tableTitle": "އޮބްސެރްވަޓިއޮންސް",
        "caption": "ރަޓް ޕަރިޓި އޮބްސެރްވަޓިއޮންސް",
        "empty": "ނެތް އޮބްސެރްވަޓިއޮން ރެކޮރްޑެޑް.",
        "loadFailed": "އޮބްސެރްވަޓިއޮންސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "recordTitle": "ރެކޮރްޑް އޮބްސެރްވަޓިއޮން",
        "recordDescription": "ކޮން ތިޔަ ސަވް ގައި ޗަނެލް, އަދި ކޮންއިރަކު ތިޔަ ސަވް އެ.",
        "record": "ރެކޮރްޑް",
        "recorded": "އޮބްސެރްވަޓިއޮން ރެކޮރްޑެޑް",
        "recordFailed": "އޮބްސެރްވަޓިއޮން ވި ބަލައިނުގަތް",
        "breachedOnly": "ބްރީޗެސް ހަމައެކަނި",
        "breach": "ޕަރިޓި",
        "breached": "ބްރީޗެޑް",
        "withinTolerance": "ވިތިން ޓޮލެރަންސް",
        "serverNote": "ޑެވިއަޓިއޮން އަދި ބްރީޗް ނަމަ ކޮމްޕުޓެޑް އަގައިންސްޓް ޗަނެލްސް ރެފެރެންސް ޕްލަން އަދި އޭގެ އޮވްން ޓޮލެރަންސް. ނެއިތެރް އަކީ ވޮރްކެޑް ބޭރު ގައި ބްރޮވްސެރް."
      },
      "agreements": {
        "title": "ކޮމިސިއޮން އަގްރީމެންޓްސް",
        "description": "އެއް އަގްރީމެންޓް ކޮންމެ ޗަނެލް, އަދި ޓެރްމްސް އެ ނަމަ ވެރްސިއޮނެޑް ރަތެރް ވުރެ އެޑިޓެޑް.",
        "tableTitle": "އަގްރީމެންޓްސް",
        "caption": "ކޮމިސިއޮން އަގްރީމެންޓްސް",
        "empty": "ނެތް އަގްރީމެންޓް އަކީ ރެކޮރްޑެޑް އަށް މި ކުންފުނި.",
        "loadFailed": "އަގްރީމެންޓްސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseCompany": "ޚިޔާރުކުރައްވާ ކުންފުނި އަށް ސީ އޭގެ އަގްރީމެންޓްސް.",
        "create": "އައު އަގްރީމެންޓް",
        "createDescription": "ކޯޑު އަދި ނަން. ޓެރްމްސް ލިވް ގައި އޭގެ ވެރްސިއޮންސް.",
        "created": "އަގްރީމެންޓް އުފައްދައިފި",
        "createFailed": "އަގްރީމެންޓް ނޫން އުފައްދައިފި",
        "statusVocab": "އަގްރީމެންޓް ސްޓަޓުސެސް: {statuses}",
        "detailDescription": "އަގްރީމެންޓް, އަދި ކޮންމެ ވެރްސިއޮން އޭގެ ޓެރްމްސް.",
        "backToList": "އަނބުރާ އަށް އަގްރީމެންޓްސް",
        "frozenNote": "ޕުބްލިށެޑް ވެރްސިއޮން އަކީ ފްރޮޒެން. ކޮންމެ އަކްރުއަލް ރެކޮރްޑްސް ވެރްސިއޮން އެ ވި ކޮމްޕުޓެޑް ދަށުން, ސޮ ޗަންޖިންގް ޓެރްމްސް މީންސް އަޑިންގް ވެރްސިއޮން — ދުވަހަކުވެސ އެޑިޓިންގް އެއް.",
        "newVersion": "އައު ވެރްސިއޮން",
        "newVersionDescription": "ޓެރްމްސް އެފެކްޓިވް ން ތާރީޚު. ސޭވްކުރައްވާ އެ ގޮތުގައި ޑްރަފްޓް, ތެން ޕުބްލިށް އެ.",
        "versionCreated": "ވެރްސިއޮން އުފައްދައިފި",
        "versionFailed": "ވެރްސިއޮން ވި ބަލައިނުގަތް",
        "versionsTitle": "ވެރްސިއޮން ހިސްޓޮރި",
        "versionsDescription": "ނެވެސްޓް ފުރަތަމަ. ޕުބްލިށެޑް ވެރްސިއޮން ނެތް އެޑިޓަބްލް ފީލްޑް.",
        "versionsCaption": "ކޮމިސިއޮން އަގްރީމެންޓް ވެރްސިއޮންސް",
        "versionsEmpty": "މި އަގްރީމެންޓް ނެތް ވެރްސިއޮން ޔެޓް, ސޮ އެއްވެސް އެއްޗެއް ނެތް އަކްރުއެސް އަގައިންސްޓް އެ.",
        "versionsFailed": "ވެރްސިއޮންސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "publish": "ޕުބްލިށް",
        "published": "ވެރްސިއޮން ޕުބްލިށެޑް",
        "publishFailed": "ވެރްސިއޮން ނޫން ޕުބްލިށެޑް"
      },
      "accruals": {
        "title": "ކޮމިސިއޮން އަކްރުއަލްސް",
        "description": "ކޮން ރޭ އައުޑިޓް އަކްރުއެޑް, ކޮންމެ ރެސެރްވަޓިއޮން.",
        "tableTitle": "އަކްރުއަލްސް",
        "caption": "ކޮމިސިއޮން އަކްރުއަލްސް",
        "empty": "ނެތް ކޮމިސިއޮން އަކްރުއެޑް އަށް މި ފިލްޓެރްސް.",
        "loadFailed": "އަކްރުއަލްސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "serverNote": "ކޮންމެ ފިގުރް އަކީ އެއް އަކްރުއަލް ޕޮސްޓެޑް އާއެކު. ވަރިއަންސް އަކީ ސެޓް ން ސްޓަޓެމެންޓް މަޓްޗް, ގައި އޮތެރް ސިޑް."
      },
      "statements": {
        "title": "ކޮމިސިއޮން ސްޓަޓެމެންޓްސް",
        "description": "ކޮން ޗަނެލްސް ސަޔް އެމީހުން ނަމަ އޮވެޑް, އަދި ކޮން އަޅުގަނޑުމެން ސަޔް.",
        "tableTitle": "ސްޓަޓެމެންޓްސް",
        "caption": "ކޮމިސިއޮން ސްޓަޓެމެންޓްސް",
        "empty": "ނެތް ސްޓަޓެމެންޓް އިމްޕޮރްޓެޑް.",
        "loadFailed": "ސްޓަޓެމެންޓްސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "import": "އިމްޕޮރްޓް ސްޓަޓެމެންޓް",
        "importTitle": "އިމްޕޮރްޓް ސްޓަޓެމެންޓް",
        "importDescription": "ޕަސްޓް ސްޓަޓެމެންޓްސް ލިނެސް. ޓަބް-ސެޕަރަޓެޑް, ގޮތުގައި ސްޕްރީޑްށީޓް ކޮޕީސް ތެމް.",
        "imported": "ސްޓަޓެމެންޓް އިމްޕޮރްޓެޑް",
        "importFailed": "އިމްޕޮރްޓް ވި ބަލައިނުގަތް",
        "declaredHint": "ޖުމްލަ ޗަނެލް ސްޓަޓެސް. އެ އަކީ ކޮމްޕަރެޑް އާއެކު ކޮން އަޅުގަނޑުމެން މަޓްޗް, ދުވަހަކުވެސ ރެ-އަޑެޑް މިތާ.",
        "pasteLabel": "ސްޓަޓެމެންޓް ލިނެސް",
        "pasteHint": "ރެފެރެންސް, މެހެމާން, އަރިވަލް, ޑެޕަރްޓުރް, ކޮޓަރި ރެވެނުއެ, ކޮމިސިއޮން — އެއް ލިން ކޮންމެ, ސެޕަރަޓެޑް ން ޓަބްސް.",
        "parsedCount": "{count} ލިން(ސް) ވާނެ އިމްޕޮރްޓެޑް.",
        "detailDescription": "ސްޓަޓެމެންޓްސް ލިނެސް, އަދި މަޓްޗެސް ސްކޮރެރް ސުގްޖެސްޓްސް.",
        "backToList": "އަނބުރާ އަށް ސްޓަޓެމެންޓްސް",
        "summary": "ސްޓަޓެމެންޓް",
        "linesTitle": "ލިނެސް",
        "linesCaption": "ސްޓަޓެމެންޓް ލިނެސް",
        "linesEmpty": "މި ސްޓަޓެމެންޓް ނެތް ލިނެސް."
      },
      "match": {
        "title": "މަޓްޗް ރެވީވް",
        "description": "ސެރްވެރްސް ރަންކެޑް ކަންޑިޑަޓެސް އަށް ޗޮސެން ލިން.",
        "caption": "ސުގްޖެސްޓެޑް މަޓްޗެސް",
        "chooseLine": "ޚިޔާރުކުރައްވާ ލިން އަށް ރެވީވް އޭގެ ކަންޑިޑަޓެސް.",
        "noSuggestions": "ސްކޮރެރް ފައުންޑް ނެތް ކަންޑިޑަޓް އަށް މި ލިން. ޗެކް ޗަނެލް ރެފެރެންސް, ނުވަތަ ވްރިޓް ލިން އޮފް އާއެކު ސަބަބު.",
        "review": "ރެވީވް",
        "accept": "މަޓްޗް",
        "matched": "ލިން މަޓްޗެޑް",
        "matchFailed": "މަޓްޗް ވި ބަލައިނުގަތް",
        "scorerNote": "ކޮންފިޑެންސް, މަޓްޗް ބާވަތް އަދި ވަރިއަންސް ނަމަ ރެކޮންސިލިއަޓިއޮން އެންޖިނެސް އޮވްން އައުޓްޕުޓް, ށޮވްން އެކްސަކްޓްލި ގޮތުގައި އެ ޕްރޮޑުސެޑް ތެމް.",
        "writeOff": "ވްރިޓް އޮފް",
        "writeOffTitle": "ވްރިޓް އޮފް މި ލިން",
        "writeOffDescription": "އަކްސެޕްޓްސް ޗަނެލްސް ފިގުރް އަދި ކްލޮސެސް ޑިފެރެންސް.",
        "writeOffReasonLabel": "ކީއްވެ އަކީ މި ބެއިންގް ވްރިޓެން އޮފް",
        "writeOffHint": "ހަމައެކަނި ކޮންއިރަކު އެތާ އަކީ ޖެނުއިނެލި އެއްވެސް އެއްޗެއް ނެތް އަށް މަޓްޗް އެ އަށް.",
        "writtenOff": "ލިން ވްރިޓެން އޮފް",
        "writeOffFailed": "ވްރިޓް-އޮފް ވި ބަލައިނުގަތް",
        "noPermission": "ތިޔަ މަޔް ސީ ސްޓަޓެމެންޓް ބުޓް ނޫން ސްކޮރެރްސް ކަންޑިޑަޓެސް. އެ ނީޑްސް ޕްމްސް.ކޮމިސިއޮން.މަޓްޗް."
      },
      "services": {
        "title": "ސެރްވިސެސް",
        "description": "ކޮން ޕްރޮޕަޓީ ސެލްސް ބެސިޑެސް ކޮޓަރި.",
        "tableTitle": "ސެރްވިސް ކަޓަލޮގުއެ",
        "caption": "އަންސިލަރި ސެރްވިސެސް",
        "empty": "ނެތް ސެރްވިސް އަކީ ގައި މި ޕްރޮޕެރްޓިސް ކަޓަލޮގުއެ.",
        "loadFailed": "ސެރްވިސެސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ސީ އޭގެ ކަޓަލޮގުއެ.",
        "searchLabel": "ހޯދާ",
        "create": "އައު ސެރްވިސް",
        "createTitle": "އައު ސެރްވިސް",
        "editTitle": "އެޑިޓް ސެރްވިސް",
        "dialogDescription": "ކޮން އެ އަކީ, ކިހިނެއް ލޮންގް އެ ޓަކެސް, އަދި ކިހިނެއް އެ އަކީ ބިލެޑް.",
        "saved": "ސެރްވިސް ސޭވްކޮށްފި",
        "saveFailed": "ސެރްވިސް ނޫން ސޭވްކޮށްފި",
        "itemHint": "އިންވެންޓޮރި އިޓެމް އެ ސެލްސް ގޮތުގައި. އެ އަކީ ވްހެރް އޭގެ ޓެކްސް ގްރައުޕް ލިވެސް.",
        "leadHint": "ކިހިނެއް ފަރް އަހީޑް އެ އަށް ބޫކެޑް.",
        "cancelHint": "ކިހިނެއް ލަޓް އެ ކަން ކެންސަލްކޮށްފި ވިތައުޓް ޗާޖު.",
        "mealHint": "ސެޓް އެ އަދި މެހެމާން ގައި ބޯރްޑް ކަން އީޓް އެ އަގައިންސްޓް އެމީހުންގެ އަލޮވަންސް.",
        "noMealPeriod": "ނޫން ކޮވެރެޑް ން ބޯރްޑް",
        "boardNote": "ސެރްވިސް އާއެކު މީލް ޕެރިއޮޑް ޑްރަވްސް ބޯރްޑް އަލޮވަންސް ކޮންއިރަކު އެ އަކީ ޑެލިވެރެޑް އަށް މެހެމާން ކާކު އެއް, އިންސްޓީޑް ބިލިންގް ތެމް."
      },
      "schedule": {
        "title": "ސެރްވިސް ސްޗެޑުލް",
        "description": "ދުވަސް, ގްރައުޕެޑް ން ރެސައުރްސް އެ އަށް އެތާ.",
        "caption": "ބޫކިންގްސް ގައި {resource}",
        "empty": "އެއްވެސް އެއްޗެއް ނެތް އަކީ ސްޗެޑުލެޑް ގައި މި ތާރީޚު.",
        "loadFailed": "ސްޗެޑުލް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ސީ އޭގެ ސްޗެޑުލް.",
        "unassigned": "ނޫން އަސިގްނެޑް އަށް ރެސައުރްސް"
      },
      "bookings": {
        "title": "ބޫކް ސެރްވިސް",
        "description": "ރެސެރްވެސް ސްލޮޓް. އެއްވެސް އެއްޗެއް ނެތް އަކީ ޗަރްޖެޑް ވަންދެން އެ އަކީ ޑެލިވެރެޑް.",
        "submit": "ބޫކް",
        "created": "ބޫކިންގް އުފައްދައިފި",
        "failed": "ބޫކިންގް ވި ބަލައިނުގަތް",
        "reservationHint": "ވިތައުޓް ސްޓަޔް, ޗާޖު ނެތް ފޮލިއޮ އަށް ރައުޓް އަށް.",
        "priceHint": "ބްލަންކް އުސެސް ސެރްވިސެސް އޮވްން އަގު.",
        "deliveryNote": "ޑެލިވެރިންގް ބޫކިންގް ޕޮސްޓްސް ފޮލިއޮ ޗާޖު, ޑްރަވްސް އެއްވެސް ބޯރްޑް އަލޮވަންސް އަދި ޑެޕްލެޓެސް ސްޓޮކް — ހުރިހާ ގައި އޮންސް.",
        "deliver": "ޑެލިވެރް",
        "delivered": "ޑެލިވެރެޑް",
        "deliverFailed": "ޑެލިވެރި ވި ބަލައިނުގަތް",
        "cancelled": "ބޫކިންގް ކެންސަލްކޮށްފި",
        "cancelFailed": "ބޫކިންގް ނޫން ކެންސަލްކޮށްފި"
      },
      "itinerary": {
        "title": "އިޓިނެރަރި",
        "description": "ކޮން މި މެހެމާން ބޫކެޑް, އަދި އަނިތިންގް އެ ކްލަށެސް.",
        "caption": "އިޓިނެރަރި އަށް ސްޓަޔް",
        "empty": "މި ސްޓަޔް އެއްވެސް އެއްޗެއް ނެތް ބޫކެޑް.",
        "chooseStay": "އެންޓެރް ރެސެރްވަޓިއޮން އިޑް އަށް ސީ އޭގެ އިޓިނެރަރި.",
        "loadFailed": "އިޓިނެރަރި ނޫން ލޯޑުކުރެވިއްޖެ",
        "lookupTitle": "ލޫކް މައްޗަށް އިޓިނެރަރި",
        "lookupDescription": "ން ރެސެރްވަޓިއޮން."
      },
      "boardPlans": {
        "title": "ބޯރްޑް ޕްލަންސް",
        "description": "ހަލްފް ބޯރްޑް, ފުލް ބޯރްޑް, ހުރިހާ އިންކްލުސިވް — އަދި ކޮން ކޮންމެ އެންޓިޓްލެސް މެހެމާން އަށް.",
        "tableTitle": "ބޯރްޑް ޕްލަންސް",
        "caption": "ބޯރްޑް ޕްލަންސް",
        "empty": "މި ޕްރޮޕަޓީ ނެތް ބޯރްޑް ޕްލަން.",
        "loadFailed": "ބޯރްޑް ޕްލަންސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ސީ އޭގެ ބޯރްޑް ޕްލަންސް.",
        "create": "އައު ބޯރްޑް ޕްލަން",
        "createDescription": "ކޯޑު އަދި ނަން. އިތުރުކުރައްވާ އޭގެ އެންޓިޓްލެމެންޓްސް ދެން.",
        "created": "ބޯރްޑް ޕްލަން އުފައްދައިފި",
        "createFailed": "ބޯރްޑް ޕްލަން ނޫން އުފައްދައިފި",
        "editEntitlements": "އެންޓިޓްލެމެންޓްސް",
        "entitlementsTitle": "އެންޓިޓްލެމެންޓްސް — {plan}",
        "entitlementsDescription": "ކޮން މެހެމާން ޖެޓްސް ކޮންމެ ޕެރްސޮން ކޮންމެ ރޭ, އަދި ކޮން އެ އަކީ ވޮރްތް އަށް ފް&ބް.",
        "entitlementsCaption": "ބޯރްޑް ޕްލަން އެންޓިޓްލެމެންޓްސް",
        "entitlementsEmpty": "މި ޕްލަން އެންޓިޓްލެސް މެހެމާން އަށް އެއްވެސް އެއްޗެއް ނެތް ޔެޓް.",
        "entitlementsSaved": "އެންޓިޓްލެމެންޓްސް ސޭވްކޮށްފި",
        "entitlementsFailed": "އެންޓިޓްލެމެންޓްސް ވި ބަލައިނުގަތް",
        "addEntitlement": "އިތުރުކުރައްވާ އެންޓިޓްލެމެންޓް",
        "transferPriceNote": "ކޮންމެ އެންޓިޓްލެމެންޓް ނީޑްސް ޓްރަންސްފެރް އަގު. އެ އަކީ އަދަދު ކަރްވެޑް ބޭރު ކޮޓަރި ރަޓް އަދި ކްރެޑިޓެޑް އަށް ފް&ބް ކޮންއިރަކު މެހެމާން އީޓްސް — ވިތައުޓް އެ, ޑެޕަރްޓްމެންޓް އެ ސެރްވެޑް މީލް އަކީ ޕައިޑް އެއްވެސް އެއްޗެއް ނެތް އަށް އެ.",
        "activate": "އަކްޓިވަޓް",
        "activated": "ބޯރްޑް ޕްލަން އަކްޓިވަޓެޑް",
        "activateFailed": "ބޯރްޑް ޕްލަން ނޫން އަކްޓިވަޓެޑް",
        "unpricedHint": "ކޮންމެ އެންޓިޓްލެމެންޓް ނީޑްސް ޓްރަންސްފެރް އަގު ކުރިން މި ޕްލަން ކަން ގޮ ލިވް."
      },
      "unconsumed": {
        "title": "އުންކޮންސުމެޑް އަލޮވަންސެސް",
        "description": "ބޯރްޑް އެ ވި ގްރަންޓެޑް އަދި ދުވަހަކުވެސ އީޓެން — ބްރީކަޖް.",
        "tableTitle": "އުންކޮންސުމެޑް އަލޮވަންސެސް",
        "caption": "ބޯރްޑް އަލޮވަންސެސް ގްރަންޓެޑް އަދި ނޫން ޑްރަވްން",
        "empty": "ކޮންމެ އަލޮވަންސް ގްރަންޓެޑް ޑްރަވްން.",
        "loadFailed": "ރެޕޮރްޓް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ރުން ރެޕޮރްޓް.",
        "breakageNote": "ކަރްވް-ބޭރު އަލްރީޑި މޮވެޑް ން ކޮޓަރިތައް އަށް ފް&ބް ގައި ޓްރަންސްފެރް އަގު. ކޮން އަކީ ލެފްޓް މިތާ އަކީ ކޮން ފް&ބް ވި ޕައިޑް އަށް އަދި ޑިޑް ނޫން ސެރްވް."
      },
      "transfers": {
        "title": "ޓްރަންސްފެރްސް",
        "description": "ބޯޓްސް, ސީޕްލަނެސް އަދި ވަންސް — ލެގްސް އަދި ކާކު އަކީ ގައި ތެމް.",
        "tableTitle": "ޓްރަންސްފެރް ލެގްސް",
        "caption": "ޓްރަންސްފެރް ލެގްސް",
        "empty": "ނެތް ޓްރަންސްފެރް ލެގް އަކީ ޕްލަނެޑް އަށް މި ޕްރޮޕަޓީ.",
        "loadFailed": "ލެގްސް ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ސީ އޭގެ ޓްރަންސްފެރްސް.",
        "create": "އައު ލެގް",
        "createDescription": "ކޮންއިރަކު އެ ލީވެސް, ކޮންއިރަކު އެ އަރިވެސް, އަދި ކިހިނެއް ގިނަ އެ ޓަކެސް.",
        "created": "ލެގް އުފައްދައިފި",
        "createFailed": "ލެގް ވި ބަލައިނުގަތް",
        "addBooking": "އިތުރުކުރައްވާ މެހެމާން",
        "addBookingDescription": "ޕުޓްސް ރެސެރްވަޓިއޮންސް ޕަރްޓި ގައި މި ލެގް.",
        "added": "އަޑެޑް އަށް ލެގް",
        "addFailed": "ބޫކިންގް ވި ބަލައިނުގަތް",
        "partyHint": "މެހެމާނުން ށަރިންގް ޕަރްޓި ކޭ ޓްރަވެލް ޓޮޖެތެރް.",
        "splitHint": "ހަމައެކަނި ނީޑެޑް ކޮންއިރަކު މި ސްޕްލިޓްސް ޕަރްޓި އެ އަކީ ޓްރަވެލިންގް ޓޮޖެތެރް.",
        "manifest": "މަނިފެސްޓް",
        "manifestTitle": "މަނިފެސްޓް — {leg}",
        "manifestDescription": "ކާކު އަކީ ގައި މި ލެގް. މި އަކީ ކޮން ސްކިޕެރް ކަރީސް.",
        "manifestCaption": "ޓްރަންސްފެރް މަނިފެސްޓް",
        "manifestEmpty": "ނޮބޮޑި އަކީ ބޫކެޑް ގައި މި ލެގް.",
        "manifestFailed": "މަނިފެސްޓް ނޫން ލޯޑުކުރެވިއްޖެ"
      },
      "requests": {
        "title": "މެހެމާން ރެކްވެސްޓްސް",
        "description": "ރެކްވެސްޓްސް އަދި ކޮމްޕްލައިންޓްސް, ވޮރްސްޓް އަދި އޮލްޑެސްޓް ފުރަތަމަ.",
        "tableTitle": "ކްވެއުއެ",
        "caption": "މެހެމާން ރެކްވެސްޓްސް އަދި ކޮމްޕްލައިންޓްސް",
        "empty": "އެއްވެސް އެއްޗެއް ނެތް އަކީ ގައި ކްވެއުއެ އަށް މި ފިލްޓެރްސް.",
        "loadFailed": "ކްވެއުއެ ނޫން ލޯޑުކުރެވިއްޖެ",
        "chooseProperty": "ޚިޔާރުކުރައްވާ ކުންފުނި އަދި ޕްރޮޕަޓީ އަށް ވޮރްކް ކްވެއުއެ.",
        "log": "ލޮގް ރެކްވެސްޓް",
        "logDescription": "ކޮން މެހެމާން އަސްކެޑް އަށް, ނުވަތަ ކޮން ވެންޓް ވްރޮންގް.",
        "logged": "ރެކްވެސްޓް ލޮގްޖެޑް",
        "logFailed": "ރެކްވެސްޓް ނޫން ލޮގްޖެޑް",
        "escalate": "އެސްކަލޭޓްކުރޭ",
        "escalated": "ރެކްވެސްޓް އެސްކަލޭޓްކުރެވިއްޖެ",
        "escalateTitle": "ރެކްވެސްޓް އެސްކަލޭޓްކުރޭ",
        "escalateDescription": "މިތާ ނިންމާނުލެވުނު ސަބަބާއި، ޑިއުޓީ މެނޭޖަރަށް ދެވޭ މަޢުލޫމާތު.",
        "close": "ބަންދުކުރޭ",
        "closed": "ރެކްވެސްޓް ބަންދުކުރެވިއްޖެ",
        "closeTitle": "ރެކްވެސްޓް ބަންދުކުރޭ",
        "closeDescription": "ނިމުނު ގޮތް، އަދި — ޚިދުމަތުގެ އުނިކަމެއް ނަމަ — އެކަން ދިމާވި ސަބަބު.",
        "statusFailed": "ނަތީޖާ ރެކޯޑްނުކުރެވުނު",
        "closeNeedsCause": "ޚިދުމަތުގެ އުނިކަމެއް ބަންދުކުރަނީ އޭގެ ސަބަބު ރެކޯޑްކޮށްފައި، ދިމާވި ކަންތައް ގުނޭނެ ގޮތަށް.",
        "recoveredLocked": "މި ރެކްވެސްޓްގައި މިހާރު ރިކަވަރީއެއް އެބައޮތް. އޭގެ ނަތީޖާ ރިކަވަރީގެ ތެރެއިން ރެކޯޑްކުރޭ — މިތާ ސެޓްކުރުމުން ދޫކޮށްލެވުނު އެއްޗެއް ފޮހެވިދާނެ."
      },
      "recovery": {
        "title": "ސެރްވިސް ރެކޮވެރި",
        "action": "ރެކޮވެރް",
        "description": "ކޮން ވި ޑޮން އަށް ޕުޓް އެ ރިގްޓް, އަދި ކީއްވެ އެ ވެންޓް ވްރޮންގް.",
        "submit": "ރެކޮރްޑް ރެކޮވެރި",
        "done": "ރެކޮވެރި ރެކޮރްޑެޑް",
        "failed": "ރެކޮވެރި ވި ބަލައިނުގަތް",
        "causeLabel": "ކޮން ކައުސެޑް މި",
        "folioHint": "ކޮން ފޮލިއޮ އަލޮވަންސް ލަންޑްސް ގައި. ބްލަންކް އުސެސް ސްޓަޔްސް އޮވްން.",
        "allowanceNote": "އަލޮވަންސް އަކީ ރީލް ފައިސާ. އެ އަކީ ޗެކެޑް އަގައިންސްޓް ޔައުރް އައުތޮރިޓި އަދި ޕޮސްޓްސް އަށް ގުއެސްޓްސް ފޮލިއޮ.",
        "outcomeUnchanged": "ސްޓޭޓަސް ހުރިގޮތަށް ބަހައްޓާ",
        "outcomeHint": "ރިކަވަރީއެއް އޮތް ރެކްވެސްޓެއް ނިންމާލެވޭ ހަމައެކަނި ގޮތަކީ މިތާ ނަތީޖާ ރެކޯޑްކުރުން."
      },
      "reports": {
        "title": "ޕްރޮޕަޓީގެ ރިޕޯޓްތައް",
        "description": "އޮކިއުޕެންސީ، ރޭޓް މެޓްރިކްސް، ގައި ހައުސްގައި ތިބީ ކޮންބައެއްކަން، މެހްމާނުންގެ ލެޖަރު އަދި އެ ދުވަހު ޕޯސްޓްކުރެވުނު ރެވެނުއެ.",
        "chooseProperty": "މި ރިޕޯޓްތައް ހިންގުމަށް ކުންފުންޏަކާއި ޕްރޮޕަޓީއެއް ހޮވާ.",
        "dateHint": "ހުސްކޮށް ބެހެއްޓުމުން ވޯކްސްޕޭސްގެ ޓައިމް ޒޯނުގައި ޕްރޮޕަޓީގެ މިހާރުގެ ވިޔަފާރި ތާރީޚު ބޭނުންކުރެވޭނެއެވެ.",
        "tabsLabel": "ޕްރޮޕަޓީގެ ރިޕޯޓްތައް",
        "tabOccupancy": "އޮކިއުޕެންސީ",
        "tabAdrRevpar": "އޭޑީއާރް އަދި ރެވްޕާރ",
        "tabInHouse": "ގައި ހައުސް",
        "tabLedger": "މެހްމާނުންގެ ލެޖަރު",
        "tabDaily": "ދުވަހުގެ އޮޕަރޭޓިން",
        "loadFailed": "ރިޕޯޓް ވެދާނެ ލޯޑްކުރެވުނު",
        "exported": "ރިޕޯޓް ނަގައިފި",
        "exportFailed": "އެ ރިޕޯޓް ނުނެގުނު",
        "occupancyCaption": "ކޮޓަރީގެ ބާވަތަކަށް ކޮޓަރި، ހަރަކާތް އަދި އޮކިއުޕެންސީ",
        "occupancyEmpty": "މި ޕްރޮޕަޓީއަށް އަދި ކޮޓަރީގެ ބާވަތެއް ކަނޑައަޅާފައެއް ނުވެއެވެ.",
        "adrCaption": "ކޮޓަރީގެ ބާވަތަކަށް، ދުވަހުގެ އެވްރެޖް ރޭޓާއި ލިބެންހުރި ކޮޓަރިއަކަށް ޖެހޭ ރެވެނުއެ",
        "postedNote": "އޭޑީއާރް އަދި ރެވްޕާރ ބިނާވަނީ ޕޯސްޓްކުރެވުނު އެއްޗެއްގެ މައްޗަށެވެ، ރޭޓް ޕްލޭންގެ މައްޗަކަށް ނޫނެވެ — ތަފާތަކީ އެލަވަންސްތަކާއި ބޯޑްގެ ބައި އަދި ރޭޓް އޯވަރައިޑްތަކެވެ.",
        "inHouseCaption": "މިރޭ ހުރި ކޮންމެ ހުރުމަކާއި އޭގެ ފޮލިއޮ ބާކީ",
        "inHouseEmpty": "ނޮބޮޑި އަކީ ގައި ހައުސް ގައި މި ތާރީޚު.",
        "posted": "ޕޯސްޓްކުރެވިފައި",
        "notPosted": "ޕޯސްޓްވެފައި ނުވޭ",
        "ledgerDescription": "އެ ތާރީޚަށް ފޮލިއޮއަކަށް ފެށޭ، ޗާޖު، ސެޓްލެމެންޓްސް އަދި ނިމޭ ބާކީ.",
        "ledgerCaption": "ފޮލިއޮއަކަށް މެހްމާނުންގެ ލެޖަރުގެ ރޯލް-ފޯވާޑް",
        "ledgerEmpty": "މި ތާރީޚުގައި އެއްވެސް ފޮލިއޮއެއް ހަރަކާތްކޮށްފައެއް ނުވެއެވެ.",
        "ledgerNote": "ކޮންމެ އަދަދަކީ ސާވަރުން ގެނައި ބާކީއެވެ؛ މި ސްކްރީނުގައި އެއްވެސް އެއްޗެއް ބްރައުޒަރުގައި އެއްކޮށްފައެއް ނުވެއެވެ.",
        "dailyCaption": "ރޭ އައުޑިޓުން ޕޯސްޓްކުރި ގޮތަށް އެ ދުވަހުގެ ރެވެނުއެ",
        "dailyEmpty": "މި ތާރީޚަށް ރޭ އައުޑިޓުން ރެވެނުއެ ޕޯސްޓްކޮށްފައެއް ނުވެއެވެ.",
        "dailyNote": "މިއީ ރޭ އައުޑިޓުން އޭގެ ޖައުރްނަލް ބިނާކުރި ރޯތަކެވެ، އެހެންކަމުން މި ރިޕޯޓާއި ޖެނެރަލް ލެޖަރ ތަފާތުވުމަކީ ވާނެ ކަމެއް ނޫނެވެ.",
        "noRunNote": "މި ތާރީޚަށް ރޭ އައުޑިޓެއް ހިންގާފައި ނުވާތީ އަދި އެއްވެސް އެއްޗެއް ޕޯސްޓްކުރެވިފައެއް ނުވެއެވެ.",
        "openRun": "ރޭ އައުޑިޓް ރަން ހުޅުވާ"
      },
      "channelPull": {
        "title": "{channel} އިން ގެނައުން",
        "description": "މި ޗެނަލްގެ ފައިލުން ބުކިންތައް ނުވަތަ ކޮމިޝަން ސްޓޭޓްމަންޓެއް ގެނައުން.",
        "what": "ގެންނަންވީ ކަމެއް",
        "commissionStatement": "ކޮމިޝަން ސްޓޭޓްމަންޓް",
        "file": "CSV ފައިލް",
        "fileHintBookings": "ޗެނަލްގެ ބުކިން އެކްސްޕޯޓް، ކޮންމެ ރޯއެއްގައި އެއް ބުކިން.",
        "fileHintCommission": "ޗެނަލްގެ ކޮމިޝަން ސްޓޭޓްމަންޓް، ކޮންމެ ރޯއެއްގައި އެއް ހުރުން.",
        "statementNo": "ސްޓޭޓްމަންޓް ނަންބަރު",
        "periodFrom": "މުއްދަތު ފެށޭ",
        "periodTo": "މުއްދަތު ނިމޭ",
        "currency": "ފައިސާ",
        "currencyHint": "ސްޓޭޓްމަންޓްގައިވާ ފައިސާގެ ތިން އަކުރުގެ ކޯޑް، މިސާލަކަށް MVR ނުވަތަ USD.",
        "failedNote": "ފައިލް ރެކޯޑްކުރެވުނު ނަމަވެސް ކިޔައިނުލެވުނު. ރަނގަޅުކޮށް އަލުން ގެންނަވާ.",
        "done": "ނިމުނީ",
        "manualNote": "މި ޗެނަލް ބޭނުންކުރަނީ މެނުއަލް އެޑަޕްޓަރު، އެހެންވީމާ ގެންނާނެ ފައިލެއް ނެތް. ބުކިންތައް ރިޒަވޭޝަނެއްގެ ގޮތުގައި، އަދި ކޮމިޝަން ސްޓޭޓްމަންޓްތައް ކޮމިޝަން ސްކްރީނުގައި ލިޔުއްވާ، ނުވަތަ ޗެނަލް ފައިލް އެޑަޕްޓަރަށް ބަދަލުކުރައްވާ."
      }
    },
    "housekeeping": {
      "routeTitles": {
        "boards": "ހައުސްކީޕިން ބޯޑުތައް",
        "rooms": "ކޮޓަރީގެ ހާލަތު",
        "faults": "ޚަރާބުތަކުގެ ކިޔޫ",
        "outOfOrder": "ބޭނުންނުކުރެވޭ"
      },
      "fields": {
        "property": "ޕްރޮޕަޓީ",
        "businessDate": "ވިޔަފާރީގެ ތާރީޚު",
        "attendant": "ސާފުކުރާ މުވައްޒަފު",
        "attendantId": "މުވައްޒަފުގެ އައިޑީ",
        "attendantIdHint": "ލިސްޓް ދެއްކުމަށް hr.employee.read ބޭނުންވޭ، އަދި މި އެކައުންޓުގައި އެ ނެތް. އޭގެ ބަދަލުގައި މުވައްޒަފުގެ އައިޑީ ލިޔޭ.",
        "section": "ސެކްޝަން",
        "noSection": "ސެކްޝަނެއް ނެތް",
        "creditTarget": "ކްރެޑިޓް ޓާގެޓް",
        "creditTargetHint": "ހަތަރު ދަޝްމަލަ ޖާގައާ ހަމައަށް ނަންބަރެއް، މިސާލަކަށް 10.0000. ހުސްކޮށް ބެހެއްޓުމުން ޕްރޮޕަޓީގެ ޑިފޯލްޓް ބޭނުންކުރެވޭނެ.",
        "creditShape": "ހަތަރު ދަޝްމަލަ ޖާގައާ ހަމައަށް ނަންބަރެއް ލިޔޭ، މިސާލަކަށް 10.0000.",
        "assignedCredit": "ދެވިފައިވާ ކްރެޑިޓް",
        "completedCredit": "ނިމުނު ކްރެޑިޓް",
        "category": "ބާވަތް",
        "severity": "ކިހާ ބޮޑު",
        "description": "ތަފްޞީލު",
        "reportedOn": "ރިޕޯޓްކުރި",
        "guestMove": "މެހެމާނު",
        "resolutionNote": "ކުރެވުނު ކަންތައް",
        "outcome": "ނަތީޖާ",
        "source": "ހުޅުވި ފަރާތް"
      },
      "boardStatus": {
        "planned": "ރޭވިފައި",
        "released": "ދޫކުރެވިފައި",
        "in_progress": "ކުރިއަށްދަނީ",
        "complete": "ނިމިއްޖެ"
      },
      "taskKind": {
        "departure": "ފުރުމުގެ ސާފުކުރުން",
        "stayover": "މަޑުކުރުން",
        "turndown": "ޓާންޑައުން",
        "deep_clean": "ފުން ސާފުކުރުން",
        "inspection": "ބެލުން"
      },
      "taskStatus": {
        "pending": "ނުފަށާ",
        "in_progress": "ކުރިއަށްދަނީ",
        "done": "ނިމިއްޖެ",
        "skipped": "ދޫކޮށްލެވުނު"
      },
      "roomStatus": {
        "dirty": "ހަޑި",
        "cleaning": "ސާފުކުރަނީ",
        "clean": "ސާފުކޮށްފި",
        "inspected": "ބެލިއްޖެ"
      },
      "roomStatusHelp": {
        "dirty": "މި ކޮޓަރި އަދި އެއްވެސް މީހަކު ފަށާފައެއް ނުވޭ.",
        "cleaning": "މެދުތެރޭގައި. މެހެމާނަކަށް ތައްޔާރެއް ނޫން.",
        "clean": "ސާފުކުރުން ނިމިއްޖެ؛ އަދި ބަލަންޖެހޭ.",
        "inspected": "ސުޕަވައިޒަރު ބަލައިފި. ވިއްކޭނެ."
      },
      "occupancy": {
        "vacant": "ހުސް",
        "occupied": "މީހުން އުޅޭ"
      },
      "faultCategory": {
        "plumbing": "ފެން ހޮޅި",
        "electrical": "ކަރަންޓު",
        "hvac": "އޭސީ",
        "furniture": "ފަރުނީޗަރު",
        "appliance": "ސާމާނު",
        "structural": "އިމާރާތް",
        "safety": "ސަލާމަތް",
        "other": "އެހެން ކަމެއް"
      },
      "faultSeverity": {
        "minor": "ކުޑަ",
        "major": "ބޮޑު",
        "blocking": "ކޮޓަރި ބޭނުމެއް ނުކުރެވޭ"
      },
      "faultStatus": {
        "open": "ހުޅުވިފައި",
        "triaged": "ބެލިއްޖެ",
        "in_repair": "މަރާމާތުގައި",
        "resolved": "ޙައްލުކުރެވިއްޖެ",
        "rejected": "ބަލައިނުގަނެވުނު"
      },
      "outOfOrderSource": {
        "manual": "މީހަކު",
        "housekeeping": "ހައުސްކީޕިން ޚަރާބެއް",
        "eam": "މަރާމާތު"
      },
      "boards": {
        "title": "ހައުސްކީޕިން ބޯޑުތައް",
        "description": "އެއް ދުވަހުގެ ސާފުކުރުން، ކޮޓަރީގެ އަދަދުން ނޫން، ކްރެޑިޓުން ބަހާލައިގެން — ވިލާއެއްގެ ފުރުމުގެ ސާފުކުރުން، ސްޓޭންޑަޑް ކޮޓަރިއެއްގެ މަޑުކުރުމަށްވުރެ ބޮޑު.",
        "chooseProperty": "ބޯޑުތައް ދެއްކުމަށް ޕްރޮޕަޓީއަކާއި ތާރީޚެއް އިޚްތިޔާރުކުރޭ.",
        "loadFailed": "ބޯޑުތައް ނުލިބުނު.",
        "empty": "މި ތާރީޚުގައި މި ޕްރޮޕަޓީއަށް ބޯޑެއް ނެތް. ދުވަހުގެ ޖެނެރޭޝަން ޖޮބުން ބަހާލާނެ؛ އޭގެ ކުރިން ބޯޑެއް ހަދާލެވިދާނެ.",
        "attendant": "މުވައްޒަފު {id}",
        "noTasks": "މި ބޯޑުގައި އަދި އެއްޗެއް ނެތް.",
        "create": "އައު ބޯޑު",
        "createDescription": "ދުވަހުގެ ޖެނެރޭޝަން ޖޮބުގެ ކުރިން، އެއް މުވައްޒަފަކަށް ބޯޑެއް.",
        "created": "ބޯޑު ހެދިއްޖެ.",
        "createFailed": "ބޯޑު ނުހެދުނު.",
        "release": "މުވައްޒަފަށް ދޫކުރޭ",
        "released": "ބޯޑު ދޫކުރެވިއްޖެ.",
        "releaseFailed": "ބޯޑު ދޫނުކުރެވުނު.",
        "moveTo": "ބަދަލުކުރޭ…",
        "moveTaskTo": "މަސައްކަތް {id} އެހެން ބޯޑަކަށް ބަދަލުކުރޭ",
        "moved": "މަސައްކަތް ބަދަލުކުރެވިއްޖެ.",
        "moveFailed": "އެ މަސައްކަތް ބަދަލެއް ނުކުރެވުނު.",
        "unassignedTitle": "އެއްވެސް ބޯޑެއްގައި ނެތް",
        "unassignedLead": "މިއަށް ކްރެޑިޓް ޖާގަ އެއްވެސް މީހަކަށް ނެތުމުން، ބަޔަކަށް ބާރު ބޮޑުކުރުމުގެ ބަދަލުގައި މިތައް ބަހާނުލައި ދޫކޮށްލެވުނު. ޓާގެޓް މަތިކުރޭ ނުވަތަ ބޯޑެއް އިތުރުކުރޭ."
      },
      "rooms": {
        "title": "ކޮޓަރީގެ ހާލަތު",
        "description": "ފްލޯރގެ މިހާރުގެ ހާލަތު: ހަޑި، ސާފުކުރަނީ، ސާފުކޮށްފި، ބެލިއްޖެ. ސާފުކުރަމުންދާ ކޮޓަރިއެއް މެހެމާނަކަށް ތައްޔާރެއް ނޫން.",
        "chooseProperty": "ކޮޓަރިތައް ދެއްކުމަށް ޕްރޮޕަޓީއެއް އިޚްތިޔާރުކުރޭ.",
        "loadFailed": "ކޮޓަރިތައް ނުލިބުނު.",
        "empty": "މި ފިލްޓަރާ ގުޅޭ ކޮޓަރިއެއް ނެތް.",
        "legendTitle": "ހަތަރު ހާލަތުގެ މާނަ",
        "allStatuses": "ހުރިހާ ހާލަތެއް",
        "filterByStatus": "ހައުސްކީޕިން ހާލަތުން ފިލްޓަރކުރޭ",
        "setTo": {
          "dirty": "ހަޑިކަމަށް ފާހަގަކުރޭ",
          "cleaning": "ސާފުކުރަން ފަށާ",
          "clean": "ސާފުކުރުން ނިންމާ"
        },
        "statusSet": "ކޮޓަރި {room} މިހާރު {status}.",
        "statusFailed": "އެ ހާލަތު ސެޓެއް ނުކުރެވުނު.",
        "inspect": "ބަލާ",
        "inspected": "ކޮޓަރި {room} ބެލިއްޖެ.",
        "inspectFailed": "އެ ކޮޓަރި ނުބެލުނު.",
        "inspectSeparate": "ކޮޓަރިއެއް ބެލުމަކީ ސާފުކުރުމާ ވަކި ބާރެއް، އަދި މި އެކައުންޓުގައި އެ ނެތް. ސާފުކުރި މީހާ އެ ކޮޓަރި ބަލައިގެން ނުވާނެ."
      },
      "faults": {
        "title": "ޚަރާބުތަކުގެ ކިޔޫ",
        "description": "ކޮޓަރީގައި ހުރި ޓެބްލެޓުން، ޑެސްކުން، އަދި ފަހުން މަރާމާތު ބައިން ރިޕޯޓްކުރެވޭ ޚަރާބުތައް. ޚަރާބަކަށް އޮންނާނީ ވެރިއެއް، ފާސްކުރާ މީހެއް ނޫން.",
        "chooseProperty": "ޚަރާބުތައް ދެއްކުމަށް ޕްރޮޕަޓީއެއް އިޚްތިޔާރުކުރޭ.",
        "loadFailed": "ކިޔޫ ނުލިބުނު.",
        "empty": "މި ފިލްޓަރާ ގުޅޭ ޚަރާބެއް ނެތް.",
        "tableTitle": "ޚަރާބުތައް ({count} ހުޅުވިފައި)",
        "caption": "މި ޕްރޮޕަޓީގެ ކޮޓަރީގެ ޚަރާބުތައް",
        "allStatuses": "ހުރިހާ ހާލަތެއް",
        "allSeverities": "ހުރިހާ ދަރަޖައެއް",
        "filterByStatus": "ޚަރާބުގެ ހާލަތުން ފިލްޓަރކުރޭ",
        "filterBySeverity": "ދަރަޖައިން ފިލްޓަރކުރޭ",
        "guestMove": "މެހެމާނު ބަދަލުކުރޭ",
        "attachment": "ފޮޓޯ",
        "attachmentFailed": "އެ ފޮޓޯ ނުހުޅުވުނު.",
        "report": "ޚަރާބެއް ރިޕޯޓްކުރޭ",
        "reportDescription": "ޓެބްލެޓް ނެތް ވަގުތުތަކަށް، ޓެބްލެޓުން ފޮނުވާ ހަމަ އެ ރިޕޯޓް.",
        "reported": "ޚަރާބު ރިޕޯޓްކުރެވިއްޖެ.",
        "reportFailed": "އެ ޚަރާބު ރިޕޯޓެއް ނުކުރެވުނު.",
        "blockingOnReport": "ބްލޮކިން ޚަރާބެއް ބެލުމާއެކު ކޮޓަރި ބޭނުންނުކުރެވޭގޮތް ވާނެ. މެހެމާނަކު އުޅޭނަމަ ފްރަންޓް ޑެސްކުން ބަދަލުކުރަންޖެހޭނެ.",
        "triage": "ބަލާ",
        "triageTitle": "ކޮޓަރި {room} ގެ ޚަރާބު ބަލާ",
        "triageDescription": "ގޯސްވެފައިވަނީ ކޮންކަމެއްކަމާއި ކިހާ ބޮޑުކަން ކަށަވަރުކުރޭ، ނުވަތަ ރިޕޯޓް ބަލައިނުގަނޭ.",
        "triaged": "ކޮޓަރި {room} ގެ ޚަރާބު ބެލިއްޖެ.",
        "outcomeTriage": "ބަލައިގަނޭ",
        "outcomeReject": "ރިޕޯޓް ބަލައިނުގަނޭ",
        "blockingConsequence": "މިކަން ކަށަވަރުކުރުމުން ޚަރާބު ޙައްލުވަންދެން ކޮޓަރި ބޭނުންނުކުރެވޭގޮތް ވާނެ. ނުވިއްކޭނެ، އަދި މެހެމާނަކު އުޅޭނަމަ ބަދަލުކުރަންޖެހޭނެ.",
        "rejectConsequence": "ބަލައިނުގަތުމުން ރިޕޯޓަކީ ޢަމަލުކުރެވޭ އެއްޗެއް ނޫންކަން ރެކޯޑްވާނެ. އެއްވެސް އޯއޯއޯ ރެކޯޑެއް ނުހުޅުވޭނެ.",
        "resolve": "ޙައްލުކުރޭ",
        "resolveTitle": "ކޮޓަރި {room} ގެ ޚަރާބު ޙައްލުކުރޭ",
        "resolveDescription": "މަރާމާތު ނިމިއްޖެ، ކޮޓަރި އަލުން ބޭނުންކުރެވޭނެ.",
        "resolveConsequence": "ޙައްލުކުރުމުން މި ޚަރާބުން ހުޅުވުނު އޯއޯއޯ ރެކޯޑް ދޫވެ، އެ ރޭތައް އަލުން ވިއްކޭގޮތް ވާނެ.",
        "resolved": "ކޮޓަރި {room} ގެ ޚަރާބު ޙައްލުކުރެވިއްޖެ.",
        "actionFailed": "އެކަން ރައްކާއެއް ނުކުރެވުނު."
      },
      "outOfOrder": {
        "title": "ބޭނުންނުކުރެވޭ",
        "description": "ކޮޓަރި × ތާރީޚު: ޕްރޮޕަޓީން ނުވިއްކަން ނިންމި ރޭތަކާއި، ހަމައެކަނި ފާހަގަކުރެވިފައިވާ ކޮޓަރިތައް.",
        "chooseProperty": "ކަލަންޑަރު ދެއްކުމަށް ޕްރޮޕަޓީއެއް އިޚްތިޔާރުކުރޭ.",
        "loadFailed": "ރެކޯޑްތައް ނުލިބުނު.",
        "empty": "މި މުއްދަތުގައި ބޭނުންނުކުރެވޭ ކޮޓަރިއެއް ނެތް.",
        "calendarTitle": "ކަލަންޑަރު",
        "caption": "ތާރީޚުން، ބޭނުންނުކުރެވޭ ނުވަތަ ޚިދުމަތުން ބޭރު ކޮޓަރިތައް",
        "recordsTitle": "ހުޅުވިފައިވާ ރެކޯޑްތައް",
        "recordsCaption": "މި ޕްރޮޕަޓީގެ ހުޅުވިފައިވާ ރެކޯޑްތައް",
        "legendTitle": "ދެ ބާވަތުގެ ތަފާތު",
        "consequenceOutOfOrder": "ކޮޓަރި ލިބެންހުރި އަދަދުން ނަގާލާނެ. އެއްވެސް މީހަކަށް ނުވިއްކޭނެ، އަދި އެ ކޮންމެ ރެއަކީ ޕްރޮޕަޓީން ގެއްލުވާލަން ނިންމި ރެއެއް.",
        "consequenceOutOfService": "ކޮޓަރި ވިއްކޭގޮތަށް ބާއްވައި ފާހަގަކުރާނެ. ބޭރުފުށުގެ މަސައްކަތަށް ރަނގަޅު؛ ފެން ނެތް ކޮޓަރިއަކަށް ގޯސް.",
        "shortOutOfOrder": "OOO",
        "shortOutOfService": "OOS",
        "create": "ކޮޓަރިއެއް ނަގާ",
        "previous": "ކުރީގެ",
        "next": "ފަހުގެ",
        "release": "ދޫކުރޭ",
        "released": "ކޮޓަރި އަލުން ވިއްކޭގޮތް ވެއްޖެ.",
        "releaseFailed": "އެ ރެކޯޑް ދޫނުކުރެވުނު."
      }
    },
    "messageChannel": {
      "email": "އީމެއިލް",
      "sms": "އެސްއެމްއެސް",
      "in_app": "އެޕްގައި",
      "print": "ޕްރިންޓްކުރެވިފައި"
    },
    "messagePurpose": {
      "confirmation": "ޔަޤީންކުރުން",
      "pre_arrival": "އައުމުގެ ކުރިން",
      "in_stay": "ހުރުމުގެ ތެރޭގައި",
      "departure": "ފުރުން",
      "marketing": "މާކެޓިން"
    },
    "messageStatus": {
      "pending": "އިންތިޒާރުގައި",
      "rendered": "ތައްޔާރުކުރެވިފައި",
      "sent": "ފޮނުވިފައި",
      "suppressed": "ހިފެހެއްޓިފައި",
      "failed": "ފެއިލް"
    },
    "messages": {
      "title": "މެސެޖްތައް",
      "description": "މި ޕްރޮޕަޓީން މި މެހްމާނަށް ލިޔެފައިވާ އެއްޗެއްސާއި ރުހުމުން ހުއްދަކުރި އެއްޗެހި.",
      "caption": "މި މެހްމާނަށް ރެކޯޑްކުރެވިފައިވާ ފޮނުވާ މެސެޖްތައް",
      "empty": "މި މެހްމާނަށް އަދި އެއްވެސް އެއްޗެއް ލިޔެފައެއް ނުވެއެވެ.",
      "loadFailed": "މެސެޖްތައް ނުނެގުނު",
      "composeTitle": "މެސެޖެއް ރެކޯޑްކުރޭ",
      "composeDescription": "މެސެޖެއް ރެކޯޑްކުރުމުގެ ކުރިން ރުހުމުގެ ގޭޓުން ސުވާލުކުރެއެވެ؛ ދެކޮޅު ހެދުމެއް ރައްކާކުރެވެއެވެ، ދުވަހަކުވެސް އުކާނުލައެވެ.",
      "channel": "ޗަނެލް",
      "purpose": "ބޭނުން",
      "subject": "ކަން",
      "body": "މެސެޖް",
      "bodyHint": "މެހްމާނަށް ފޮނުވި، ނުވަތަ ފޮނުވަން އޮތް އެއްޗެއް.",
      "consentNote": "މި ރެކޯޑްކުރެވޭއިރު ރުހުން ބަލައެވެ. މެހްމާނު ރުހުން ދީފައި ނުވާ މެސެޖެއް، ސަބަބާއެކު، ހިފެހެއްޓިފައި ބެހެއްޓެއެވެ.",
      "record": "މެސެޖް ރެކޯޑްކުރޭ",
      "recorded": "މެސެޖް ރެކޯޑްކުރެވިއްޖެ",
      "suppressed": "ރެކޯޑްކުރެވިއްޖެ، އެކަމަކު ނުފޮނުވޭ",
      "suppressedNoReason": "No ސަބަބު was recorded",
      "failed": "އެ މެސެޖް ރެކޯޑެއް ނުކުރެވުނު",
      "sentAt": "ފޮނުވި ވަގުތު",
      "markSent": "ފޮނުވިކަމަށް ފާހަގަކުރޭ",
      "markedSent": "ފޮނުވިކަމަށް ފާހަގަކުރެވިއްޖެ",
      "markFailed": "އެ މެސެޖް ފޮނުވިކަމަށް ފާހަގައެއް ނުކުރެވުނު"
    },
    "queue": {
      "availability_drift": "ރޫމް އެވެއިލަބިލިޓީ ރިކޯޑުގައި ހުރި ރިޒަވޭޝަންތަކާ ދިމާނުވޭ.",
      "folio_unrouted": "ޗާޖެއް ރައުޓިންގ ޤަވާޢިދަކާ ނުދިމާވެ ރައުޓު ނުކުރެވި ހުރި.",
      "commission_variance": "ކޮމިޝަން ސްޓޭޓްމަންޓް ހިސާބުކުރި ކޮމިޝަނާ ތަފާތު."
    }
  },
  "roster": {
    "allCompanies": "ހުރިހާ ކުންފުނިތައް",
    "anyStatus": "ކޮންމެ ހާލަތެއް",
    "cancel": {
      "confirm": "ރޯސްޓަރ ކެންސަލްކުރޭ",
      "description": "ކެންސަލްކުރެވުނު ރޯސްޓަރެއްގެ ސަފުހާތައް ބާކީ ހުރެއެވެ: ރޭވުނު ގޮތާއި ދޫކޮށްލެވުނު ގޮތަކީ މަސައްކަތުގެ ޚަރަދުން ކުރާ ސުވާލެކެވެ.",
      "noteLabel": "ނޯޓު",
      "reasonLabel": "ސަބަބު ކޯޑު",
      "title": "ރޯސްޓަރ ކެންސަލްކުރޭ"
    },
    "clock": {
      "kinds": {
        "break_end": "ބްރޭކް ނިމުން",
        "break_start": "ބްރޭކް ފެށުން",
        "in": "އިން",
        "out": "އައުޓް"
      }
    },
    "demand": {
      "actions": {
        "import": "ސީއެސްވީ އިމްޕޯޓްކުރޭ",
        "new": "ޢަދަދު އިތުރުކުރޭ"
      },
      "columns": {
        "date": "ތާރީޚު",
        "dayPart": "ދުވަހުގެ ބައި",
        "location": "ލޮކޭޝަން",
        "metric": "މިންގަނޑު",
        "source": "މަޞްދަރު",
        "value": "އަދަދު"
      },
      "dayPartHint": "ތިޔަ ވޯކްސްޕޭސްއިން ކަނޑައަޅާ ދުވަހުގެ ބައެއްގެ ކޯޑު، ނުވަތަ މުޅި ދުވަހަށް ހުހަށެވެ.",
      "description": "ޓައިޕްކުރެވުނު ނުވަތަ އިމްޕޯޓްކުރެވުނު ޑިމާންޑް، އަދި ޢަދަދެއް މުވައްޒަފުންގެ ޢަދަދަކަށް ބަދަލުކުރާ ޤަވާޢިދުތަކެވެ.",
      "emptyDescription": "މިދިޔަ އަހަރުގެ ފުރިހަމަވުން ޓައިޕްކުރާ، ނުވަތަ ސީއެސްވީއެއް އިމްޕޯޓްކުރާ، ދެން އެއިން ރޯސްޓަރެއް ހުށަހެޅިދާނެއެވެ.",
      "emptyTitle": "ޑިމާންޑެއް ރެކޯޑްކުރެވިފައެއް ނެތެވެ",
      "entry": {
        "description": "ކޮންމެ ލޮކޭޝަން، ތާރީޚު، ދުވަހުގެ ބައި އަދި މިންގަނޑަކަށް އެއް ޢަދަދެވެ. އަލުން ވެއްދުމުން ބަދަލުވެއެވެ.",
        "title": "ޑިމާންޑްގެ ޢަދަދެއް އިތުރުކުރޭ"
      },
      "import": {
        "confirm": "އިމްޕޯޓްކުރޭ",
        "csvLabel": "ސީއެސްވީ",
        "description": "ފޮތިގަނޑުތައް މިތަނުގައި ކިޔައި، އެއިން އެއްވެސް އެއްޗެއް ލިޔުމުގެ ކުރިން ސާވަރުން ކޮންމެ ފޮތިގަނޑެއް ޗެކްކުރެއެވެ. ނުކިޔޭ ފޮތިގަނޑެއް ދޮގު ލަފާކުރުމުގެ ބަދަލުގައި ރިޕޯޓްކުރެވެއެވެ.",
        "format": "ކޮންމެ ޢަދަދަކަށް އެއް ސަފުހާ: ތާރީޚު، ދުވަހުގެ ބައި، މިންގަނޑު، ޢަދަދު.",
        "rowUnreadable": "ސަތުރު {line} ނުކިޔުނެވެ: {text}",
        "title": "ސީއެސްވީއިން ޑިމާންޑް އިމްޕޯޓްކުރޭ"
      },
      "imported": "{imported} އިމްޕޯޓްކުރެވި، {skipped} ދޫކޮށްލެވުނެވެ",
      "loadFailed": "ޑިމާންޑްގެ ޢަދަދުތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "locationHint": "ޑިމާންޑް ރެކޯޑްކުރެވެނީ ލޮކޭޝަނަކަށެވެ.",
      "metrics": {
        "arrivals": "އަންނަ ފަރާތްތައް",
        "covers": "ކަވަރު",
        "departures": "ފުރާ ފަރާތްތައް",
        "headcount": "މުވައްޒަފުންގެ ޢަދަދު",
        "occupied_rooms": "ފުރިފައިވާ ކޮޓަރި",
        "revenue": "އާމްދަނީ",
        "transactions": "މުޢާމަލާތްތައް"
      },
      "noSignal": "{metrics} އަށް އެއްވެސް ޢަދަދެއް ނެތެވެ. ޑިމާންޑްގެ މައްޗަށް ހުށަހެޅުމުން އެއަށް ސަފުހާއެއް ނުއުފެދޭނެއެވެ.",
      "removed": "ޑިމާންޑްގެ ޢަދަދު ނަގައިފި",
      "rules": {
        "actions": {
          "new": "އައު މުވައްޒަފުންގެ ޤަވާޢިދު"
        },
        "columns": {
          "effectiveFrom": "ފެށޭ ތާރީޚު",
          "max": "އެންމެ ގިނަ",
          "min": "އެންމެ މަދު",
          "shift": "ޝިފްޓް",
          "unitsPerHead": "ބޮލަކަށް ޔުނިޓް"
        },
        "create": {
          "description": "މުވައްޒަފުންގެ ޢަދަދަކީ ceil(ޑިމާންޑް ÷ ބޮލަކަށް ޔުނިޓް)، އެންމެ މަދު ޢަދަދުން ފެށި، އެންމެ ގިނަ ޢަދަދުން ހުއްޓޭ ގޮތަށެވެ.",
          "title": "އައު މުވައްޒަފުންގެ ޤަވާޢިދު"
        },
        "emptyDescription": "ޤަވާޢިދަކުން ޑިމާންޑްގެ ޢަދަދެއް މުވައްޒަފުންގެ ޢަދަދަކަށް ބަދަލުކުރެއެވެ: ފުރިފައިވާ ކޮންމެ 14 ކޮޓަރިއަކަށް އެއް ހައުސްކީޕަރ، އެންމެ މަދުވެގެން 2.",
        "emptyTitle": "މުވައްޒަފުންގެ ޤަވާޢިދެއް ނެތެވެ",
        "saved": "މުވައްޒަފުންގެ ޤަވާޢިދު ރައްކާކުރެވިއްޖެ",
        "title": "މުވައްޒަފުންގެ ޤަވާޢިދު",
        "unitsHint": "އެކަކު ބަލަހައްޓާ މިންގަނޑުގެ ޔުނިޓްތަކެވެ."
      },
      "saved": "ޑިމާންޑްގެ ޢަދަދު ރައްކާކުރެވިއްޖެ",
      "sources": {
        "import": "އިމްޕޯޓްކުރެވުނު",
        "manual": "ޓައިޕްކުރެވުނު"
      },
      "tabs": {
        "demand": "ޑިމާންޑް",
        "rules": "މުވައްޒަފުންގެ ޤަވާޢިދު"
      },
      "title": "ޑިމާންޑާއި މުވައްޒަފުން",
      "wholeDay": "މުޅި ދުވަސް"
    },
    "exceptions": {
      "actions": {
        "correct": "އިޞްލާޙުކުރޭ",
        "resolve": "ހައްލުކުރޭ"
      },
      "anyKind": "ކޮންމެ ބާވަތެއް",
      "columns": {
        "channel": "ޗެނަލް",
        "corrects": "އިޞްލާޙުކުރަނީ",
        "date": "ތާރީޚު",
        "employee": "މުވައްޒަފު",
        "expected": "އުއްމީދުކުރެވުނު ގަޑިއިރު",
        "happenedAt": "ހިނގި ވަގުތު",
        "kind": "އިސްތިސްނާ",
        "observed": "ފެނުނު ގަޑިއިރު",
        "punchKind": "ޕަންޗް",
        "reason": "ސަބަބު"
      },
      "correct": {
        "atLabel": "އިޞްލާޙުކުރެވުނު ވަގުތު",
        "description": "އަސްލު ޕަންޗް ބާކީ ހުރެއެވެ. އިޞްލާޙަކީ ސަބަބަކާއެކު ގުޅިފައިވާ އައު ހަރަކާތެކެވެ.",
        "newEventNote": "ކްލޮކް ހަރަކާތެއް ދުވަހަކުވެސް އެޑިޓެއް ނުކުރެވެއެވެ — ޕޯސްޓްކުރެވުނު ޖާނަލެއް ރިވާސްކުރާ ފަދައިން، ދެވަނަ ހަރަކާތަކުން އިޞްލާޙުކުރެވެއެވެ.",
        "reasonLabel": "ސަބަބު ކޯޑު",
        "title": "ޕަންޗެއް އިޞްލާޙުކުރޭ"
      },
      "corrected": "އިޞްލާޙު ރެކޯޑްކުރެވިއްޖެ",
      "description": "ރޯސްޓަރާއި ޕަންޗްތައް ދިމާނުވާ ތަންތަނެވެ. އެއް އިސްތިސްނާ ބަންދުކުރުމުން އަބަދުވެސް ސަބަބެއް ރެކޯޑްކުރެވެއެވެ.",
      "dismissed": "އިސްތިސްނާ ފޮރުވިއްޖެ",
      "employeeIdHint": "ޕަންޗް ލިސްޓް އެކަކަށް ހަނިކުރާށެވެ.",
      "employeeIdLabel": "މުވައްޒަފުގެ އައިޑީ",
      "emptyDescription": "ރޯސްޓަރކުރެވުނު ކޮންމެ ދުވަހެއްގައި މަސައްކަތްކުރެވި، ކޮންމެ ޕަންޗެއް ދިމާވެފައިވެއެވެ.",
      "emptyTitle": "އިސްތިސްނާއެއް ނެތެވެ",
      "kinds": {
        "early_out": "އަވަހަށް ދިޔަ",
        "late_in": "ލަހުން އައި",
        "long_hours": "ގަޑިއިރު ގިނަ",
        "missing_in": "ކްލޮކް-އިން ނެތް",
        "missing_out": "ކްލޮކް-އައުޓް ނެތް",
        "no_show": "ހާޒިރުނުވި",
        "overlapping_shift": "ފުށުއަރާ ޝިފްޓްތައް",
        "short_hours": "ގަޑިއިރު މަދު",
        "unrostered_work": "ރޯސްޓަރ ސަފުހާއެއް ނެތި މަސައްކަތްކުރި"
      },
      "loadFailed": "އިސްތިސްނާތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "openCount": "ހުޅުވިފައިވާ {count} އިސްތިސްނާއެއް މީހަކަށް އިންތިޒާރުކުރެއެވެ.",
      "punchFilters": "ޕަންޗް ފިލްޓަރތައް",
      "punchesEmptyDescription": "މި މުއްދަތުގައި ކްލޮކްކުރެވިފައެއް ނުވެއެވެ.",
      "punchesEmptyTitle": "ޕަންޗެއް ނެތެވެ",
      "reasons": {
        "approved_absence_retrospective": "ފަހުން ފާސްކުރެވުނު ޣައިރު ހާޒިރީ",
        "device_failure": "ކްލޮކްކުރާ ޑިވައިސް ފެއިލްވި",
        "other": "އެހެނިހެން",
        "overtime_approved": "އިތުރު ގަޑި ފާސްކުރެވުނު",
        "rostered_in_error": "ކުށަކުން ރޯސްޓަރކުރެވުނު",
        "shift_swapped": "އެހެން މުވައްޒަފަކާ ޝިފްޓް ބަދަލުކުރެވުނު",
        "worked_no_punch": "މަސައްކަތްކުރި، ޕަންޗެއް ރެކޯޑްވެފައެއް ނެތް"
      },
      "resolve": {
        "description": "ސަބަބުގެ ކޯޑަކީ ލާޒިމު އެއްޗެކެވެ: ޖުމުލަކޮށް ބަލާއިރު ކިޔޫއަށް ޖަވާބުދެވެނީ އެއިންނެވެ.",
        "noteLabel": "ނޯޓު",
        "reasonLabel": "ސަބަބު ކޯޑު",
        "subject": "{name}، {date} ގައި — {kind}",
        "title": "އިސްތިސްނާ ހައްލުކުރޭ",
        "writesAttendance": "މި ސަބަބުން ރޯސްޓަރކުރެވުނު ގަޑިއިރު ހާޒިރީގެ ގޮތުގައި ލިޔެވި، މުސާރައިން އެއަށް ފައިސާ ދެވޭނެއެވެ."
      },
      "resolved": "އިސްތިސްނާ ހައްލުކުރެވިއްޖެ",
      "statuses": {
        "dismissed": "ފޮރުވިފައި",
        "open": "ހުޅުވިފައި",
        "resolved": "ހައްލުކުރެވިފައި"
      },
      "tabs": {
        "exceptions": "އިސްތިސްނާތައް",
        "punches": "ޕަންޗްތައް"
      },
      "title": "ހާޒިރީގެ އިސްތިސްނާތައް"
    },
    "fields": {
      "company": "ކުންފުނި",
      "fromDate": "އިން",
      "locationId": "ލޮކޭޝަން އައިޑީ",
      "toDate": "އަށް"
    },
    "grid": {
      "actions": {
        "cancel": "ރޯސްޓަރ ކެންސަލްކުރޭ",
        "lock": "ތަޅުލާ",
        "propose": "ހުށަހަޅާ",
        "publish": "ޝާއިޢުކުރޭ",
        "save": "ރައްކާކުރޭ ({count})",
        "unlock": "ތަޅު ހުޅުވާ"
      },
      "basis": {
        "demand": "ޑިމާންޑް ސިގްނަލްތަކުން",
        "pattern": "ޝިފްޓް ޕެޓަރންތަކުން"
      },
      "blockedBanner": "ޝާއިޢުކުރުން ބަލައެއް ނުގަނެވޭ: ފުރަތަމަ މަސައްކަތު ވަގުތުގެ {count} މައްސަލަ ހައްލުކުރަން ޖެހެއެވެ.",
      "cancelled": "ރޯސްޓަރ ކެންސަލްކުރެވިއްޖެ",
      "cellLabel": "{name}، {date}، ޝިފްޓް {shift}",
      "coverageGap": "{dates} ތާރީޚަކަށް {metrics} ގެ ޑިމާންޑް ސިގްނަލެއް ނުލިބުނެވެ. އެ ތާރީޚުތަކަށް ސަފުހާއެއް އުފެއްދިފައެއް ނުވެއެވެ.",
      "description": "މުވައްޒަފުން ތިރިއަށް، ތާރީޚުތައް ހުރަހަށެވެ. އެރޯ ކީތަކުން ހަރަކާތްކުރެވޭ، 1–9 އިން ޝިފްޓް ދެވޭ، R އިން ހުސް ދުވަސް، O އިން ފުރިހަމަނުވާ ސްލޮޓް ފާހަގަކުރެވެއެވެ.",
      "draftNo": "ދެލިކޮޕީ",
      "employee": "މުވައްޒަފު",
      "empty": "އެއްވެސް އެއްޗެއް ނެތް",
      "emptyDescription": "ޕެޓަރނަކުން ނުވަތަ ޑިމާންޑުން ހުށަހަޅާ، ނުވަތަ އަތުން ސަފުހާ އިތުރުކުރާށެވެ.",
      "emptyTitle": "މި ރޯސްޓަރުގައި އަދި މީހަކު ނެތެވެ",
      "legend": {
        "keys": "ކީބޯޑް: އެރޯ ހަރަކާތް · 1–9 ޝިފްޓް · R ހުސް · O ހުސްކޮށް · ބެކްސްޕޭސް ސާފު · ⌘S ރައްކާ"
      },
      "loadFailed": "ރޯސްޓަރ ލޯޑެއް ނުކުރެވުނެވެ",
      "locked": "މުސާރައަށްޓަކައި ރޯސްޓަރ ތަޅުލެވިއްޖެ",
      "open": "ހުސްކޮށް",
      "plannedCost": "ރޭވިފައިވާ ޚަރަދު",
      "plannedHours": "ރޭވިފައި {hours} ގަޑިއިރު",
      "proposed": "{count} ސަފުހާ ހުށަހެޅިއްޖެ",
      "published": "ރޯސްޓަރ {no} ޝާއިޢުކުރެވިއްޖެ",
      "rest": "ހުސް",
      "saved": "ރޯސްޓަރ ރައްކާކުރެވިއްޖެ",
      "tableCaption": "ރޯސްޓަރ ގްރިޑް: ތާރީޚުން މުވައްޒަފުން",
      "title": "ރޯސްޓަރ",
      "titleFor": "{no} · {from} އިން {to} އަށް",
      "unlocked": "ރޯސްޓަރުގެ ތަޅު ހުޅުވިއްޖެ"
    },
    "labour": {
      "chooseScope": "ކުންފުންޏަކާއި މުއްދަތެއް އިޚްތިޔާރުކުރާށެވެ.",
      "columns": {
        "actual": "ޙަޤީޤީ ގަޑިއިރު",
        "bucket": "ބައި",
        "cost": "މަސައްކަތުގެ ޚަރަދު",
        "costBasis": "ޚަރަދުގެ އަސާސް",
        "costPercent": "ޚަރަދު %",
        "headcount": "މުވައްޒަފުންގެ ޢަދަދު",
        "overtime": "އިތުރު ގަޑިއިރު",
        "revenue": "އާމްދަނީ",
        "revenueBasis": "އާމްދަނީގެ އަސާސް",
        "rostered": "ރޯސްޓަރ ގަޑިއިރު",
        "spmh": "މީހަކަށް ގަޑިއިރަކަށް ވިއްކުން"
      },
      "costBasis": {
        "estimate": "ރޯސްޓަރުން ލަފާކުރެވުނު",
        "mixed": "ބައެއް ޕޯސްޓްކުރެވިފައި",
        "posted": "ޕޯސްޓްކުރެވުނު މުސާރަ"
      },
      "description": "ރޯސްޓަރކުރެވުނު މިންވަރު ޙަޤީޤަތާ، އަދި އާމްދަނީއެއް ވާނަމަ އެއާ އަޅައި ބެލުމެވެ.",
      "emptyDescription": "ރޯސްޓަރެއް ޝާއިޢުކުރާ ނުވަތަ ހާޒިރީއެއް ފާސްކުރާށެވެ، ދެން ޢަދަދުތައް މިތާ ފެންނާނެއެވެ.",
      "emptyTitle": "މި މުއްދަތުގައި އެއްވެސް އެއްޗެއް ނެތެވެ",
      "groupBy": {
        "day": "ދުވަސް",
        "department": "ޑިޕާޓްމަންޓް",
        "location": "ލޮކޭޝަން",
        "week": "ހަފުތާ"
      },
      "groupByLabel": "ގްރޫޕްކުރާ ގޮތް",
      "kpi": {
        "actualHours": "ޙަޤީޤީ ގަޑިއިރު",
        "actualHoursHelp": "ފާސްކުރެވުނު ހާޒިރީ، ރޯސްޓަރެއް ނޫނެވެ.",
        "cost": "މަސައްކަތުގެ ޚަރަދު",
        "costPercent": "ވިއްކުމުގެ ޚަރަދު %"
      },
      "loadFailed": "މަސައްކަތުގެ ޚަރަދު ލޯޑެއް ނުކުރެވުނެވެ",
      "noRevenueBasis": "އާމްދަނީގެ އަސާސެއް ނެތް",
      "revenueBasis": {
        "none": "އާމްދަނީގެ މަޞްދަރެއް ނެތް",
        "pms": "ޕްރޮޕަޓީ މެނޭޖްމަންޓުން",
        "pos": "ޕޮއިންޓް އޮފް ސޭލްއިން",
        "tax_lines": "ޓެކްސް ސަފުހާތަކުން"
      },
      "revenueGap": "{count} ބައެއްގައި އާމްދަނީގެ މަޞްދަރެއް ނެތުމުން، އެއަށް ޚަރަދުގެ އިންސައްތައެއް ނުދައްކައެވެ.",
      "title": "މަސައްކަތުގެ ޚަރަދު"
    },
    "list": {
      "actions": {
        "new": "އައު ރޯސްޓަރ"
      },
      "columns": {
        "cost": "ރޭވިފައިވާ ޚަރަދު",
        "hours": "ރޭވިފައިވާ ގަޑިއިރު",
        "location": "ލޮކޭޝަން",
        "no": "ރޯސްޓަރ ނަންބަރު",
        "open": "ފުރިހަމަނުވާ ސަފުހާތައް",
        "window": "މުއްދަތު"
      },
      "create": {
        "confirm": "ރޯސްޓަރ އުފައްދާ",
        "description": "ރޯސްޓަރެއް ހިމަނަނީ އެއް ކުންފުންޏާއި އެއް މުއްދަތެކެވެ. ހަމަ އެ މުއްދަތަށް ދެވަނަ ރޯސްޓަރެއް ބަލައެއް ނުގަނެވޭނެއެވެ.",
        "spanHint": "ގިނަވެގެން 92 ދުވަހެވެ.",
        "title": "އައު ރޯސްޓަރ"
      },
      "created": "ރޯސްޓަރ އުފެއްދިއްޖެ",
      "description": "ކޮންމެ ރޯސްޓަރަކީ އެއް ކުންފުނި، އެއް ލޮކޭޝަން އަދި އެއް މުއްދަތެއް، އެއްކޮށް ޝާއިޢުކުރެވޭ ގޮތަށެވެ.",
      "emptyDescription": "ދެ ހަފުތާއަކަށް ރޯސްޓަރެއް އުފައްދާ، ދެން ޕެޓަރނަކުން ނުވަތަ ޑިމާންޑުން ގްރިޑް ފުރާށެވެ.",
      "emptyTitle": "އަދި ރޯސްޓަރެއް ނެތެވެ",
      "filtersTitle": "ފިލްޓަރތައް",
      "loadFailed": "ރޯސްޓަރތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "title": "ރޯސްޓަރތައް"
    },
    "patterns": {
      "actions": {
        "new": "އައު ޕެޓަރން"
      },
      "columns": {
        "calendar": "ކަލަންޑަރު",
        "code": "ކޯޑު",
        "cycle": "ސައިކަލް ދުވަސް",
        "name": "ނަން",
        "shape": "ބައްޓަން"
      },
      "create": {
        "description": "ސްލޮޓްތައް އެޑިޓްކުރެވެނީ އެއްކޮށެވެ. ސައިކަލްގެ ދިގުމިން ބަދަލުކުރުމުން އެތަކެތި ބަދަލުވެއެވެ.",
        "title": "އައު ޝިފްޓް ޕެޓަރން"
      },
      "dayLabel": "ދުވަސް {day}",
      "description": "ރޮޓޭޝަނެއްގެ ތަކުރާރުވާ ބައްޓަމެވެ. މިއީ ނަމޫނާއެއް — ފައިސާއެއް ނުދޭ، އަދި މަސައްކަތުގެ ހެއްކެއް ނޫނެވެ.",
      "edit": {
        "title": "ޝިފްޓް ޕެޓަރން އެޑިޓްކުރޭ"
      },
      "emptyDescription": "ޕެޓަރނަކީ ކޮންމެ ދުވަހެއް ޓައިޕްނުކޮށް ރޯސްޓަރެއް ހުށަހެޅޭ ގޮތެވެ.",
      "emptyTitle": "އަދި ޝިފްޓް ޕެޓަރނެއް ނެތެވެ",
      "everyDayWorkable": "ކޮންމެ ދުވަހަކީ މަސައްކަތު ދުވަހެއް",
      "fields": {
        "code": "ކޯޑު",
        "cycle": "ސައިކަލް ދުވަސް",
        "cycleHint": "އާދައިގެ ހަފުތާއަކަށް 7؛ ހަތަރު ދުވަސް މަސައްކަތާއި ދެ ދުވަސް ހުހަށް 6.",
        "name": "ނަން"
      },
      "loadFailed": "ޝިފްޓް ޕެޓަރންތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "restSlot": "ހުސް ދުވަސް",
      "saved": "ޕެޓަރން ރައްކާކުރެވިއްޖެ",
      "slotsNote": "ޝިފްޓެއް ނެތް ސްލޮޓަކީ ސާފުކޮށް ހުސް ދުވަހެއް، އަދި ހަފުތާގެ އަރާމުގެ ޤަވާޢިދުތަކުން ގުނަނީ އެއެވެ.",
      "title": "ޝިފްޓް ޕެޓަރންތައް"
    },
    "propose": {
      "basisHint": "ޑިމާންޑް ސިގްނަލެއް ނެތް ތާރީޚަކުން ސަފުހާއެއް ނުއުފެދޭނެއެވެ — މުވައްޒަފެއް ނެތް ސަފުހާއެއް ދުވަހަކުވެސް ނުއުފެއްދޭނެއެވެ.",
      "basisLabel": "އަސާސް",
      "confirm": "ހުށަހަޅާ",
      "description": "ޝިފްޓް ޕެޓަރންތަކުން، ނުވަތަ ޑިމާންޑް ސިގްނަލްތަކާއި މުވައްޒަފުންގެ ޤަވާޢިދުތަކުން ސަފުހާތައް އުފައްދާށެވެ.",
      "title": "ރޯސްޓަރެއް ހުށަހަޅާ"
    },
    "publish": {
      "blocked": "ޤާނޫނީ ހުދޫދެއް ފަހަނައަޅައި ގޮސްފައިވެއެވެ. ވޯކްސްޕޭސްގެ އިދާރީ ފަރާތް ހިމެނޭ ގޮތުން، އެއްވެސް މީހަކަށް މިއިން އިސްތިސްނާއެއް ނެތެވެ.",
      "clear": "މައްސަލައެއް ނެތެވެ. މި ރޯސްޓަރ ޝާއިޢުކުރެވިދާނެއެވެ.",
      "confirm": "ޝާއިޢުކުރޭ",
      "description": "ޝާއިޢުކުރުމުން އޭގައި ހިމެނޭ އެންމެންނަށް އަންގައެވެ. ފުރަތަމަ މަސައްކަތު ވަގުތުގެ ޤަވާޢިދުތައް ބެލެއެވެ.",
      "needsOverride": "މައްސަލަ ޖެހިފައިވަނީ ހަމައެކަނި އަމިއްލަ ޤަވާޢިދުތަކަށެވެ. ޝާއިޢުކުރުމަށް ސަބަބެއް ބޭނުންވެ، އެ ރެކޯޑްކުރެވެއެވެ.",
      "noteLabel": "ނިންމުނު ގޮތާއި ނިންމީ ކާކުކަން",
      "openLines": "{count} ފޮތިގަނޑެއް އަދިވެސް ފުރިހަމަނުވެއެވެ. އެއިން މައްޗަށް ޝާއިޢުކުރުމަށް ސަބަބެއް ބޭނުންވެ، އެ ރެކޯޑްކުރެވެއެވެ.",
      "openLinesNoteLabel": "ހުސްތަންތަކާއެކު ރޯސްޓަރ ނެރެނީ ކީއްވެގެންކަން",
      "openLinesReasonLabel": "ފުރިހަމަނުވާ ފޮތިގަނޑުގެ އިސްތިސްނާގެ ސަބަބު ކޯޑު",
      "reasonLabel": "އިސްތިސްނާގެ ސަބަބު ކޯޑު",
      "title": "ރޯސްޓަރ ޝާއިޢުކުރޭ"
    },
    "routeTitles": {
      "demand": "ޑިމާންޑާއި މުވައްޒަފުން ބޭނުންވާ މިންވަރު",
      "exceptions": "ހާޒިރީގެ އިސްތިސްނާތައް",
      "labourCost": "މަސައްކަތުގެ ޚަރަދު",
      "roster": "ރޯސްޓަރ",
      "rosters": "ރޯސްޓަރތައް",
      "shiftDefinitions": "ޝިފްޓް ތަޢާރަފުތައް",
      "shiftPatterns": "ޝިފްޓް ޕެޓަރންތައް",
      "workingTimeRules": "މަސައްކަތު ވަގުތުގެ ޤަވާޢިދުތައް"
    },
    "rules": {
      "actions": {
        "new": "އައު އަމިއްލަ ޤަވާޢިދު"
      },
      "anyKind": "ކޮންމެ ބާވަތެއް",
      "clear": "މައްސަލައެއް ނުވަތަ އިންޒާރެއް ނެތެވެ.",
      "columns": {
        "code": "ކޯޑު",
        "kind": "ޤަވާޢިދު",
        "severity": "ބުރަދަން",
        "source": "މަޞްދަރު",
        "threshold": "ހުދޫދު",
        "window": "މުއްދަތު"
      },
      "create": {
        "description": "ތިޔަ ފަރާތުގެ އަމިއްލަ ޤަވާޢިދެކެވެ. ޤާނޫނީ ޤަވާޢިދުތައް އަންނަނީ ޖުރިސްޑިކްޝަން ޕެކުން، އަދި އެއީ ހަމައެކަނި ކިޔޭ ގޮތަށެވެ.",
        "title": "އައު މަސައްކަތު ވަގުތުގެ ޤަވާޢިދު"
      },
      "description": "ހިނގާ ކޮންމެ ޤަވާޢިދަކާއި ބާކީ އޮތް މިންވަރެވެ. މި ރޯސްޓަރާއި ވަށައިގެންވާ ރޯސްޓަރތަކުގެ މައްޗަށް ސާވަރުން ބަލައެވެ.",
      "edit": {
        "title": "މަސައްކަތު ވަގުތުގެ ޤަވާޢިދު އެޑިޓްކުރޭ"
      },
      "emptyDescription": "ޤާނޫނީ ހުދޫދުތަކަށް ޖުރިސްޑިކްޝަން ޕެކެއް ހަރަކާތްތެރިކުރާ، ނުވަތަ އަމިއްލަ ޤަވާޢިދެއް އިތުރުކުރާށެވެ.",
      "emptyTitle": "މަސައްކަތު ވަގުތުގެ ޤަވާޢިދެއް ނެތެވެ",
      "fields": {
        "code": "ކޯޑު",
        "effectiveFrom": "ފެށޭ ތާރީޚު",
        "name": "ނަން",
        "severityHint": "އަމިއްލަ ޤަވާޢިދަކުން ހުއްޓުވުމުގެ ބަދަލުގައި އިންޒާރު ދެވިދާނެއެވެ. ޕެކް ޤަވާޢިދެއް އަބަދުވެސް ހުއްޓުވައެވެ.",
        "threshold": "ހުދޫދު",
        "thresholdHint": "ޤަވާޢިދަށް ބަލައި ގަޑިއިރު، މިނެޓް ނުވަތަ ދުވަހުގެ ޢަދަދެވެ.",
        "window": "މުއްދަތުގެ ޔުނިޓް",
        "windowHint": "ހަފުތާގެ ހުދޫދު އެވްރެޖްކުރާ ހަފުތާތައް، ނުވަތަ ރޭގަނޑު ޝިފްޓް މުއްދަތުގެ ދުވަސްތަކެވެ."
      },
      "house": "އަމިއްލަ ޤަވާޢިދު",
      "houseBadge": "އަމިއްލަ",
      "kinds": {
        "max_consecutive_days": "ވިދިވިދިގެން އެންމެ ގިނަ ދުވަސް",
        "max_hours_per_day": "ދުވާލަކަށް އެންމެ ގިނަ ގަޑިއިރު",
        "max_hours_per_week": "ހަފުތާއަކަށް އެންމެ ގިނަ ގަޑިއިރު",
        "max_night_shifts_per_period": "މުއްދަތަކަށް އެންމެ ގިނަ ރޭގަނޑު ޝިފްޓް",
        "min_break_minutes_per_shift": "ޝިފްޓަކަށް އެންމެ މަދު ބްރޭކް",
        "min_rest_hours_between_shifts": "ޝިފްޓްތަކުގެ ދެމެދު އެންމެ މަދު އަރާމު",
        "min_weekly_rest_hours": "ހަފުތާއަކަށް އެންމެ މަދު އަރާމު"
      },
      "loadFailed": "މަސައްކަތު ވަގުތުގެ ޤަވާޢިދުތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "notOverridable": "ބަދަލެއް ނުކުރެވޭ",
      "packBadge": "ޕެކް v{version}",
      "packExplainer": "{count} ޤަވާޢިދު އައިސްފައިވަނީ ޖުރިސްޑިކްޝަން ޕެކަކުންނެވެ. ޕެކް ޤަވާޢިދެއް އަބަދުވެސް ހުއްޓުވާ، އެއްވެސް މީހަކަށް އެޑިޓް ނުވަތަ ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "pageDescription": "ރޯސްޓަރ ޝާއިޢުކުރުމާއި ހާޒިރީ ފާސްކުރުން ބެލެވޭ ހުދޫދުތަކެވެ.",
      "pageTitle": "މަސައްކަތު ވަގުތުގެ ޤަވާޢިދުތައް",
      "recheck": "މިހާރު އަލުން ބަލާ",
      "remaining": "ބާކީ {remaining}",
      "saved": "ޤަވާޢިދު ރައްކާކުރެވިއްޖެ",
      "severity": {
        "block": "ހުއްޓުވާ",
        "warn": "އިންޒާރު"
      },
      "stale": "ރައްކާނުކުރެވޭ {count} ބަދަލެވެ. ޤަވާޢިދުތައް އަލުން ބެލުމަށް ރައްކާކުރާށެވެ.",
      "statutory": "ޤާނޫނީ",
      "title": "މަސައްކަތު ވަގުތު"
    },
    "shifts": {
      "actions": {
        "new": "އައު ޝިފްޓް"
      },
      "columns": {
        "break": "ބްރޭކް (މިނެޓް)",
        "code": "ކޯޑު",
        "name": "ނަން",
        "night": "ރޭގަނޑު ޝިފްޓް",
        "paidHours": "ފައިސާ ދެވޭ ގަޑިއިރު",
        "times": "ވަގުތުތައް"
      },
      "companyHint": "ޝިފްޓް ތަޢާރަފުތައް ނިސްބަތްވަނީ އެއް ކުންފުންޏަކަށެވެ.",
      "create": {
        "description": "ފައިސާ ދެވޭ ގަޑިއިރު ނަގަނީ ވަގުތުތަކާއި ބްރޭކުން، އަދި ދެން ރައްކާކުރެވެއެވެ.",
        "title": "އައު ޝިފްޓް ތަޢާރަފު"
      },
      "description": "ރޯސްޓަރ ސަފުހާއަކުން އިޝާރާތްކުރާ ނަން ދެވިފައިވާ ވަގުތުތަކެވެ.",
      "edit": {
        "title": "ޝިފްޓް ތަޢާރަފު އެޑިޓްކުރޭ"
      },
      "emptyDescription": "ރޯސްޓަރެއް ހެދުމުގެ ކުރިން، މި ކުންފުނިން މަސައްކަތްކުރާ ޝިފްޓްތައް — ހެނދުނު، ހަވީރު، ރޭގަނޑު — ތަޢާރަފުކުރާށެވެ.",
      "emptyTitle": "އަދި ޝިފްޓް ތަޢާރަފެއް ނެތެވެ",
      "fields": {
        "break": "ފައިސާ ނުދެވޭ ބްރޭކް (މިނެޓް)",
        "code": "ކޯޑު",
        "colour": "ކުލަ",
        "colourHint": "ރޯސްޓަރ ގްރިޑްގެ ޗިޕަށް ބޭނުންކުރެވެއެވެ.",
        "crossesMidnight": "ނިމެނީ ޖެހިގެން އަންނަ ދުވަހު",
        "crossesMidnightHint": "ސާފުކޮށް ކަނޑައަޅާށެވެ: 24 ގަޑިއިރުގެ ޝިފްޓެއް ނިމެނީ ފެށި ހަމަ އެ ގަޑިއަށެވެ.",
        "endsAt": "ނިމޭ ގަޑި",
        "isNight": "ރޭގަނޑު ޝިފްޓެއްގެ ގޮތުގައި ގުނާ",
        "name": "ނަން",
        "startsAt": "ފެށޭ ގަޑި"
      },
      "loadFailed": "ޝިފްޓް ތަޢާރަފުތައް ލޯޑެއް ނުކުރެވުނެވެ",
      "night": "ރޭގަނޑު",
      "paidHoursNote": "މި ޝިފްޓުގެ އަގަކީ ފައިސާ ދެވޭ {hours} ގަޑިއިރެވެ. ވަގުތުތައް ބަދަލުކުރުމުން ބަދަލުވަނީ ކުރިއަށް އޮތް ސަފުހާތަކުގެ އަގު، ޝާއިޢުކުރެވިފައިވާ ސަފުހާއެއްގެ އަގެއް ނޫނެވެ.",
      "saved": "ޝިފްޓް ރައްކާކުރެވިއްޖެ",
      "title": "ޝިފްޓް ތަޢާރަފުތައް"
    },
    "statuses": {
      "cancelled": "ކެންސަލްކޮށްފައި",
      "draft": "ދެލިކޮޕީ",
      "locked": "ތަޅުލާފައި",
      "proposed": "ހުށަހެޅިފައި",
      "published": "ޝާއިޢުކޮށްފައި"
    },
    "unlock": {
      "confirm": "ތަޅު ހުޅުވާ",
      "description": "މި ތަޅު ހިފަހައްޓަނީ މުސާރައިންނެވެ. ތަޅު ހުޅުވުން އޮޑިޓްކުރެވޭ، އަދި ރަން ޕޯސްޓްކޮށްފައިވާނަމަ ފަހުން ދޭ މުސާރަ އުފެދެއެވެ.",
      "noteLabel": "ނޯޓު",
      "reasonLabel": "ސަބަބު ކޯޑު",
      "title": "ރޯސްޓަރުގެ ތަޅު ހުޅުވާ"
    }
  },
  "ai": {
    "nav": {
      "label": "AI ބައިތައް",
      "briefings": "ބްރީފިންތައް",
      "autonomy": "މިނިވަންކަން",
      "ledger": "ލަފާގެ ލެޖަރ",
      "anomalies": "ކޮންފިގް ތަފާތުތައް"
    },
    "routeTitles": {
      "briefings": "AI ބްރީފިންތައް",
      "briefing": "ބްރީފިން",
      "autonomy": "AI މިނިވަންކަން",
      "ledger": "ލަފާގެ ލެޖަރ",
      "anomalies": "ކޮންފިގް ތަފާތުތައް"
    },
    "priorities": {
      "info": "މަޢުލޫމާތު",
      "attention": "ސަމާލުކަން",
      "urgent": "އަވަސް"
    },
    "kinds": {
      "advice": "ލަފާ",
      "draft": "ދެލިކޮޕީ",
      "action": "ޢަމަލު"
    },
    "fallbacks": {
      "figures_only": "ހަމައެކަނި އަދަދުތައް",
      "skip": "ދޫކޮށްލާ",
      "queue": "ކިޔޫއަށް"
    },
    "runStatuses": {
      "running": "ހިނގަނީ",
      "complete": "ފުރިހަމަ",
      "degraded": "އުނިވެފައި",
      "failed": "ފެއިލްވެފައި"
    },
    "dispositions": {
      "pending": "މަޑުކުރެވިފައި",
      "accepted": "ބަލައިގަނެފައި",
      "rejected": "ރައްދުކުރެވިފައި",
      "expired": "މުއްދަތު ހަމަވެފައި",
      "auto_confirmed": "މީހަކާ ނުލައި ކަށަވަރުކުރެވިފައި",
      "routed": "މީހަކަށް ފޮނުވިފައި"
    },
    "outcomes": {
      "realised": "ޙަޤީޤަތަކަށްވި",
      "not_realised": "ޙަޤީޤަތަކަށް ނުވި",
      "not_taken": "ބަލައިނުގަތް",
      "unmeasurable": "މިނެއް ނުކުރެވޭ"
    },
    "anomalyStatuses": {
      "open": "ހުޅުވިފައި",
      "acknowledged": "ބަލައިގަނެފައި",
      "dismissed": "ދޫކޮށްލެވިފައި"
    },
    "commands": {
      "group": "އެސިސްޓަންޓް",
      "keywords": "އެސިސްޓަންޓް ސުވާލު އޭއައި ޗެޓް",
      "open": "އެސިސްޓަންޓާ ސުވާލުކުރައްވާ",
      "openDescription": "ބައްލަވަމުންދާ އެއްޗާ ޖެހިގެން، ކަނާތްފަރާތު ބައިގައި އެސިސްޓަންޓް ހުޅުވާ.",
      "cash": "ފައިސާއާ ބެހޭގޮތުން ސުވާލުކުރައްވާ",
      "cashDescription": "ފައިސާގެ ޙާލަތާ ބެހޭ ސުވާލެއް ތައްޔާރުކޮށްފައި އެސިސްޓަންޓް ހުޅުވާ.",
      "cashPrompt": "13 ހަފުތާގެ ފައިސާގެ ލަފާކުރުން ކިހިނެއްތޯ، އަދި މިދިޔަ ހަފުތާއިން ފެށިގެން އެ ބަދަލުކުރީ ކޮން ކަމެއްތޯ؟",
      "aging": "ލިބެންހުރި ފައިސާއާ ބެހޭގޮތުން ސުވާލުކުރައްވާ",
      "agingDescription": "ލިބެންހުރި ފައިސާގެ ދުވަސްވުމާ ބެހޭ ސުވާލެއް ތައްޔާރުކޮށްފައި އެސިސްޓަންޓް ހުޅުވާ.",
      "agingPrompt": "AR ދުވަސްވުން ދައްކާ، އަދި 90 ދުވަހަށްވުރެ ގިނަ ބައި ބޮޑުކުރާ ތިން ކަސްޓަމަރު ބުނެދީ."
    },
    "assistant": {
      "tabLabel": "އެސިސްޓަންޓް",
      "forbiddenTitle": "މި އެކައުންޓަށް އެސިސްޓަންޓް ބޭނުމެއް ނުކުރެވޭ",
      "forbiddenDescription": "އެސިސްޓަންޓް ބޭނުންކުރުމަށް ai.assistant.use ހުއްދަ ބޭނުންވެއެވެ، މި އެކައުންޓުގައި އެ ހުއްދައެއް ނެތެވެ.",
      "loadFailed": "މުޢާމަލާތު ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އެސިސްޓަންޓާ ސުވާލެއް ކުރައްވާ",
      "emptyDescription": "މި ހިނގަނީ ތިޔަ ބޭފުޅާގެ ހުއްދަތަކުގެ ދަށުން، އަދި ފެންނާނީ ތިޔަ ބޭފުޅާއަށް ފެންނަ އެއްޗެއް އެކަނި. އުފައްދާ ކޮންމެ އެއްޗެއް އަންނާނީ ކަށަވަރުކުރަން ޕްރިވިއުއެއްގެ ގޮތުގައި.",
      "placeholder": "އަދަދަކާ، ލިޔުމަކާ، ނުވަތަ ރިޕޯޓަކާ ބެހޭގޮތުން ސުވާލުކުރައްވާ…",
      "send": "ފޮނުވާ",
      "confirm": "ކަށަވަރުކުރައްވާ",
      "discard": "ދޫކޮށްލައްވާ",
      "confirmed": "އުފެއްދިއްޖެ",
      "confirmFailed": "އެއްވެސް އެއްޗެއް ނުއުފެއްދުނު",
      "discarded": "ދޫކޮށްލެވިއްޖެ",
      "discardFailed": "ޕްރިވިއު ދޫކޮށެއް ނުލެވުނު",
      "previewTitle": "{tool} — އަދި އެއްވެސް އެއްޗެއް ނުއުފައްދާ",
      "previewNote": "މި ބައްލަވައި ކަށަވަރުކުރެއްވުމުން އުފެދޭނެއެވެ. ދޫކޮށްލެއްވުމުން އެއްވެސް އެއްޗެއް ނުހުންނާނެއެވެ.",
      "tokens": "{input} ވަން / {output} ނުކުތް",
      "roles": {
        "user": "ތިޔަ ބޭފުޅާ",
        "assistant": "އެސިސްޓަންޓް",
        "system": "ސިސްޓަމް",
        "tool": "ޓޫލް"
      }
    },
    "briefings": {
      "title": "ބްރީފިންތައް",
      "description": "ކޮންމެ އޭޖެންޓަކަށް ފެނުނު އެއްޗެއް، ދުވަހުން ދުވަހަށް. އަދަދުތައް ހިސާބުކުރެވެނީ މިތާނގައި، މޮޑެލްގެ ދައުރަކީ ހަމައެކަނި ބަޔާންކުރުން.",
      "agent": "އޭޖެންޓް",
      "briefing": "ބްރީފިން",
      "priority": "އިސްކަން",
      "sections": "ބައިތައް",
      "businessDate": "ވިޔަފާރީގެ ތާރީޚް",
      "unreadOnly": "ނުކިޔާ ތަކެތި އެކަނި",
      "unread": "ނުކިޔާ",
      "withheld": "{count} ހިފެހެއްޓިފައި",
      "loadFailed": "ބްރީފިންތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ބްރީފިންއެއް ނެތް",
      "emptyDescription": "އޭޖެންޓްތައް ޝެޑިއުލަކަށް ހިނގައި ކޮންމެ ފަހަރަކު ބްރީފިންއެއް ލިޔެއެވެ. މިހާރު އެއް ހިންގަވާ، ނުވަތަ މިރޭގެ ޝެޑިއުލަށް މަޑުކުރައްވާ.",
      "runTitle": "މިހާރު އޭޖެންޓެއް ހިންގަވާ",
      "runDescription": "ނުހިނގި ޝެޑިއުލަކަށް އޮޕަރޭޓަރު ކުރާ ކަމެއް. ކުރިން ހިނގާފައިވާ ތާރީޚަކަށް ދޭނީ ކޮންފްލިކްޓެއް، މިހާރު އޮތް ރަން ބުނެދެމުން.",
      "run": "ހިންގަވާ",
      "ran": "{title}",
      "runFailed": "އޭޖެންޓް ނުހިނގި",
      "chooseAgent": "އޭޖެންޓެއް ޚިޔާރުކުރައްވާ"
    },
    "briefing": {
      "title": "ބްރީފިން",
      "backToFeed": "ބްރީފިންތަކަށް އެނބުރި",
      "loadFailed": "މި ބްރީފިން ލޯޑެއް ނުކުރެވުނު",
      "markRead": "ކީކަމަށް ފާހަގަކުރައްވާ",
      "marked": "ކީކަމަށް ފާހަގަކުރެވިއްޖެ",
      "tokens": "{input} ޓޯކަން ވަން / {output} ނުކުތް",
      "degraded": "މި ރަންގައި މޮޑެލްއާ ގުޅޭ ގޮތެއް ނުވި. ތިރީގައިވާ އަދަދުތައް ފުރިހަމަ — އެއީ މިތާނގައި ހިސާބުކުރެވުނު އެއްޗެއް، މޮޑެލްގެ އެއްޗެއް ނޫން — ނެތީ ހަމައެކަނި ބަޔާން.",
      "withheld": "{count} ބައެއް ނުދައްކަނީ އެ ބައިތަކުގެ ފަހަތުގައިވާ މޮޑިއުލް މި އެކައުންޓަށް ނުކިޔޭތީ.",
      "figuresLabel": "ހިސާބުކުރެވުނު އަދަދުތައް",
      "figuresOnly": "މި ބަޔަށް ބަޔާނެއް ނެތް."
    },
    "autonomy": {
      "title": "މިނިވަންކަން",
      "description": "ކޮންމެ AI ކުޅަދާނަކަމަކަށް އަމިއްލައަށް ކުރެވޭނީ ކިހާވަރެއް، އެއަށް ބޭނުންވާ ހެކި، އަދި އެ ނުފުދޭ ހިނދު ވާނެ ގޮތް.",
      "loadFailed": "ކުޅަދާނަކަންތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "ރަޖިސްޓްރީވެފައިވާ ކުޅަދާނަކަމެއް ނެތް",
      "emptyDescription": "ކުޅަދާނަކަންތައް ބަޔާންކުރެވެނީ ކޯޑުގައި، އަދި މި ޓެނަންޓަށް ގެނެވެއެވެ. އެއްވެސް އެއްޗެއް ނުގެނެވެއެވެ.",
      "capability": "ކުޅަދާނަކަން",
      "kind": "ބާވަތް",
      "level": "މިންވަރު",
      "ceiling": "ރަޖިސްޓްރީގެ އެންމެ މަތި",
      "threshold": "އިތުބާރުގެ މިންގަނޑު",
      "tolerance": "ތަޙައްމަލު %",
      "tolerancePct": "ތަޙައްމަލު %",
      "toleranceAbs": "ތަޙައްމަލު މިންވަރު",
      "percentHint": "10% އަށް 10 ލިޔުއްވާ.",
      "percentRange": "އިންސައްތަ 0 އާއި 100 އާ ދެމެދު ހުންނަންވާނެއެވެ.",
      "fallback": "ފޯލްބެކް",
      "detailDescription": "ކޮންމެ މިންވަރެއް، އަދި ޚިޔާރު ނުކުރެވޭ ތަކެއްޗަށް، ސީދާ ސަބަބު.",
      "choose": "މި މިންވަރު ބޭނުންކުރައްވާ",
      "levelSet": "މިންވަރު ބަދަލުކުރެވިއްޖެ",
      "tuned": "ރައްކާކުރެވިއްޖެ",
      "note": "ނޯޓް",
      "delegatedOn": "{samples} މިނެކުރެވުނު ނަތީޖާ {accuracy} ގައި ހުރުމުން ދޫކުރެވުނީ",
      "sodNote": "ތަޙައްމަލުގެ މިންގަނޑު ކަނޑައެޅުމާއި، އެ މިންގަނޑުގައި މީހަކާ ނުލައި ޢަމަލުކުރެވިދާނެކަން ނިންމުން ވަކިކުރެވިފައިވެއެވެ. މި އެކައުންޓަށް މިންގަނޑު ބަދަލުކުރެވުނަސް މިންވަރެއް ބަދަލެއް ނުކުރެވޭނެއެވެ.",
      "levels": {
        "assistive": "އެހީތެރި",
        "supervised": "ބެލުމުގެ ދަށުން",
        "delegated": "ދޫކުރެވިފައި"
      },
      "levelDescriptions": {
        "assistive": "ވާނެ ގޮތް ބުނެދެއެވެ. އެއްވެސް އެއްޗެއް ތައްޔާރެއް ނުކުރެއެވެ.",
        "supervised": "ޕްރިވިއުއެއް ތައްޔާރުކުރެއެވެ. އެއްޗެއް އުފެދޭނީ މީހަކު ކަށަވަރުކުރުމުން.",
        "delegated": "ހަމަ އެ ޕްރިވިއު މީހަކާ ނުލައި، ޕްރިންސިޕަލްގެ ނަމުގައި ކަށަވަރުކުރެއެވެ، އަދި ގޭޓެއް ފެއިލްވާ ހިނދު މީހަކަށް ފޮނުވައެވެ."
      },
      "reasons": {
        "kind": "ދޫކުރެވޭނީ ޢަމަލުކުރާ ކުޅަދާނަކަމަކަށެވެ. މިއީ ލަފާދޭ އެއްޗެކެވެ.",
        "registry_ceiling": "ރަޖިސްޓްރީން މި ކުޅަދާނަކަން އެ މިންވަރަށްވުރެ ދަށުގައި ހިފަހައްޓައެވެ، އަދި ޓެނަންޓަކަށް އެ މަތިއެއް ނުކުރެވޭނެއެވެ.",
        "company_ceiling": "މި ކުންފުނީގެ އެންމެ މަތި ކޮންމެ ކުޅަދާނަކަމެއް އެ މިންވަރަށްވުރެ ދަށުގައި ހިފަހައްޓައެވެ.",
        "insufficient_evidence": "ދޫކުރުމަށް {needed} މިނެކުރެވުނު ނަތީޖާ {neededAccuracy} ގައި ބޭނުންވެއެވެ؛ މި ކުޅަދާނަކަމުގައި ހުރީ {have}، {haveAccuracy} ގައި."
      }
    },
    "ledger": {
      "title": "ލަފާގެ ލެޖަރ",
      "description": "AI އިން ހުށަހެޅި ހުރިހާ އެއްޗެއް، ނިންމުނު ގޮތް، އަދި މުއްދަތު ފާއިތުވުމުން ރަނގަޅުތޯ. މިއީ ރެކޯޑެއް، މަސައްކަތު ލިސްޓެއް ނޫން.",
      "loadFailed": "ލެޖަރ ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި އެއްވެސް ލަފައެއް ނުދޭ",
      "emptyDescription": "ކުޅަދާނަކަމަކުން އެއްޗެއް ހުށަހަޅާ ކޮންމެ ފަހަރަކު ލަފައެއް ލިޔެވެއެވެ. އަދި އެއްވެސް އެއްޗެއް ނުލިޔެވެއެވެ.",
      "capability": "ކުޅަދާނަކަން",
      "type": "ބާވަތް",
      "disposition": "ނިންމުން",
      "subject": "މައުޟޫޢު",
      "amount": "މިންވަރު",
      "issued": "ދޫކުރެވުނީ",
      "autonomyAtIssue": "ދޫކުރި އިރުގެ މިންވަރު",
      "work": "މަސައްކަތް އޮތީ",
      "inApprovals": "އެޕްރޫވަލް އިންބޮކްސް",
      "inAttention": "އެޓެންޝަން ލިސްޓް",
      "accuracyTitle": "ލަފާގެ ބާވަތުން ސީދާކަން",
      "accuracyDescription": "ރައްދުކުރުމަކީ ކުށެއް ނޫނެވެ: ސީދާކަން ހިސާބުކުރެވެނީ ޙަޤީޤަތަކަށްވި، ޙަޤީޤަތަކަށްވި އަދި ނުވި ދެބައިގެ މައްޗަށެވެ، އަދި ހަތަރު ޢަދަދު ދައްކަނީ ބައިކުރި ޢަދަދު ފޮރުވިފައި ނުބޭއްވުމަށެވެ.",
      "noAccuracyTitle": "އަދި އެއްވެސް އެއްޗެއް މިނެއް ނުކުރެވޭ",
      "noAccuracyDescription": "ލަފާތައް މިނެކުރާ މުއްދަތަށް ފޯރުމުން ސީދާކަން ފެންނާނެއެވެ.",
      "samples": "މިނެކުރެވުނު",
      "accuracy": "ސީދާކަން",
      "coverage": {
        "realised": "ޙަޤީޤަތަކަށްވި",
        "notRealised": "ޙަޤީޤަތަކަށް ނުވި",
        "notTaken": "ބަލައިނުގަތް",
        "unmeasurable": "މިނެއް ނުކުރެވޭ",
        "measuredRatio": "މިނެކުރެވުނު ބައި"
      },
      "detailTitle": "ލަފާ",
      "figuresLabel": "ހިސާބުކުރެވުނު އަދަދުތައް",
      "outcome": "{result} — ލަފާކުރީ {predicted}، ޙަޤީޤަތުގައި {actual}",
      "accept": "ބަލައިގަންނަވާ",
      "accepted": "ބަލައިގަނެވިއްޖެ",
      "acceptFailed": "އެއްވެސް އެއްޗެއް ނުއުފެއްދުނު",
      "reject": "ރައްދުކުރައްވާ",
      "rejected": "ރައްދުކުރެވިއްޖެ",
      "rejectTitle": "މި ލަފާ ރައްދުކުރައްވާ",
      "rejectDescription": "ރައްދުކުރުން ރެކޯޑުވެއެވެ، އަދި ކުޅަދާނަކަމުގެ ސީދާކަމަށް ނުބައި ނުޖެހެއެވެ. ސަބަބު ލިޔުއްވާ، ލެޖަރ ފަހުން ކިޔާލެވޭ އެއްޗަކަށް ވުމަށް.",
      "reason": "ސަބަބު",
      "reasonRequired": "ސަބަބެއް ބޭނުންވެއެވެ."
    },
    "anomalies": {
      "title": "ކޮންފިގް ތަފާތުތައް",
      "description": "ކޮންފިގަރޭޝަން ބަދަލުތަކުގެ އޯޑިޓް ރެކޯޑުގެ މައްޗަށް ހިނގާ ސީދާ ޤަވާޢިދުތަކެއް. AI ހުޅުވިފައި ހުއްޓަސް ނެތަސް ހިނގައެވެ؛ މޮޑެލް ބޭނުންވަނީ ހަމައެކަނި ބަޔާން ލިޔުމަށެވެ.",
      "loadFailed": "ތަފާތުތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "ކޮންފިގަރޭޝަން ރެކޯޑުގައި ތަފާތު އެއްޗެއް ނެތް",
      "emptyDescription": "ހަތް ޤަވާޢިދަކުން ބަލަނީ ތަކުރާރު ބަދަލު، އަނބުރާ ބަދަލު، ވަގުތު ނޫން ވަގުތުގެ ބަދަލު، ފުރަތަމަ ފަހަރު ބަދަލުކުރާ މީހުން، ބަލިކުރެވުނު ކޮންޓްރޯލް، ލިޔުމެއްގެ ކުރިން ބަދަލު، އަދި ގިނަ ބަދަލު.",
      "severity": "ބުރަދަން",
      "status": "ޙާލަތު",
      "sweep": "މިހާރު ބައްލަވާ",
      "swept": "{scanned} އޯޑިޓް ސަޠުރު ބެލުނު، {detected} ފެނުނު، {known} ކުރިންވެސް އެނގޭ.",
      "sweepFailed": "ބެލުން ނުހިނގި",
      "coverageIntro": "{rules} ޤަވާޢިދު ރަޖިސްޓްރީވެފައި. މިހާރު އޯޑިޓް ރެކޯޑުގައި ހުރި ކޮންފިގަރޭޝަން ތަންތަން:",
      "coverageNone": "އަދި އެއްވެސް ކޮންފިގަރޭޝަން ބަދަލެއް އޯޑިޓްކުރެވިފައެއް ނެތެވެ، އެހެންވެ ބަލާނެ އެއްޗެއް ނެތެވެ. މިއީ ފުރިހަމަކަމެއް ނޫން، ބެލުމުގެ ދޯހަޅިކަމެކެވެ.",
      "occurrences": "{count} ބަދަލު",
      "impacted": "{count} ލިޔުމަށް އަސަރުކުރި",
      "evidence": "އޯޑިޓް ސަޠުރުތައް:",
      "figuresLabel": "ހިސާބުކުރެވުނު އަދަދުތައް",
      "acknowledge": "ބަލައިގަންނަވާ",
      "acknowledgeTitle": "މި ތަފާތު ބަލައިގަންނަވާ",
      "dismiss": "ދޫކޮށްލައްވާ",
      "dismissTitle": "މި ތަފާތު ދޫކޮށްލައްވާ",
      "actionDescription": "ސަބަބުގެ ކޯޑެއް ތިޔަ ބޭފުޅާގެ ނަމުގައި ރެކޯޑުވާނެއެވެ. ބަލައިގަތުމުން ސަޠުރު ދެމިހުންނާނެ؛ ދޫކޮށްލުމުން ބުނަނީ ޢަމަލެއް ބޭނުންނުވިކަމަށެވެ.",
      "actioned": "ރެކޯޑުކުރެވިއްޖެ",
      "reasonCode": "ސަބަބުގެ ކޯޑް",
      "reasonRequired": "ސަބަބުގެ ކޯޑެއް ބޭނުންވެއެވެ.",
      "note": "ނޯޓް"
    },
    "agent": {
      "cfo": {
        "label": "ސީއެފްއޯ",
        "description": "ފައިސާ، ޖަރނަލްގެ ތަފާތުތައް، ކްލޯޒް ތައްޔާރީ، އަދި ދުވަހުގެ އޮޕަރޭޓިން ގުޅުންތައް."
      },
      "procurement": {
        "label": "ޕްރޮކިއުމަންޓް",
        "description": "އަގުގެ ތަފާތު، ސަޕްލަޔަރ ނުރައްކާ، އެއްކޮށްލެވިދާނެ ތަކެތި، އަދި މެޗް އެކްސެޕްޝަން ދުވަސްވުން."
      },
      "sales": {
        "label": "ސޭލްސް",
        "description": "ޕައިޕްލައިން ނުރައްކާ، ހުއްޓިފައިވާ ޑީލް، ލަފާގެ ބަޔާން، އަދި ރިބޭޓް ހުށަހެޅުން."
      },
      "inventory": {
        "label": "ސްޓޮކް",
        "description": "ސްޓޮކް ހުސްވުމުގެ ނުރައްކާ، ލަހުން ހިނގާ ތަކެތި، އަދި މުއްދަތު ހަމަވުމުގެ ނުރައްކާ."
      },
      "revenue": {
        "label": "އާމްދަނީ",
        "description": "ޕޭސް، ޕިކަޕް، ލަފާގެ ސީދާކަން، ހުޅުވިފައިވާ ޑިސްޕްލޭސްމަންޓް ނިންމުންތައް، އަދި ހޯދުމުގެ އަގު."
      },
      "maintenance": {
        "label": "މެއިންޓަނަންސް އަދި އިތުބާރު",
        "description": "އެސެޓް މޮޑިއުލްތަކުން ރަޖިސްޓްރީކުރާ އިތުބާރުގެ މެޓްރިކްތައް، އަދި އެއްވެސް އެއްޗެއް ނެތްނަމަ އުފައްދާ އެއްޗެއް ނެތް."
      },
      "workforce": {
        "label": "މުވައްޒަފުން",
        "description": "ރޯސްޓަރުގެ ދޯހަޅިކަން، އިތުރުގަޑީގެ ބުރަ، ޗުއްޓީގެ ދަރަނި، އަދި މުއްދަތު ހަމަވާ ހުއްދަތައް."
      }
    },
    "capability": {
      "queryArAging": {
        "label": "AR ދުވަސްވުން ބައްލަވާ",
        "description": "ތިޔަ ބޭފުޅާއަށް ފެންނަ ލިބެންހުރި ފައިސާގެ ދުވަސްވުން ކިޔައެވެ."
      },
      "treasuryForecast": {
        "label": "ޓްރެޒަރީ ލަފާކުރުން",
        "description": "މިހާރުގެ އޮޕަރޭޝަނަލް ޓްރެޒަރީ ފައިސާގެ ލަފާކުރުން ކިޔައެވެ."
      },
      "explainVariance": {
        "label": "ތަފާތު ބަޔާންކުރުން",
        "description": "ބަޖެޓާއި އެކްޗުއަލް ކިޔައި، ބަދަލު ބަޔާންކުރެއެވެ."
      },
      "runReport": {
        "label": "ރިޕޯޓެއް ހިންގުން",
        "description": "ތިޔަ ބޭފުޅާއަށް ކުރިންވެސް ހިންގޭ ރިޕޯޓެއް ހިންގައެވެ."
      },
      "draftPo": {
        "label": "ޕަރޗޭސް އޯޑަރ ދެލިކޮޕީ",
        "description": "މީހަކު ފާސްކޮށް ޕޯސްޓްކުރަންޖެހޭ ދެލިކޮޕީއެއް އުފައްދައެވެ."
      },
      "anomalyTriage": {
        "label": "ތަފާތެއް ބަލައި ނިންމުން",
        "description": "ކޮންފިގަރޭޝަން ތަފާތަކަށް ނިންމުމެއް ހުށަހަޅައެވެ، ދުވަހަކުވެސް ތަންފީޒެއް ނުކުރެއެވެ."
      }
    },
    "anomalyRule": {
      "churn": {
        "label": "ތަކުރާރު ބަދަލުތައް",
        "description": "އެއް ސެޓިންއެއް އެއް ދުވަހުގެ ތެރޭގައި ގިނަ ފަހަރު ބަދަލުވެފައި."
      },
      "flip": {
        "label": "ބަދަލުކޮށް އަނބުރާ ބަދަލުކުރުން",
        "description": "އަގެއް ބަދަލުވެ، ދުވަސްކޮޅެއްގެ ތެރޭގައި ކުރީގެ އަގަށް އެނބުރުން."
      },
      "offHours": {
        "label": "ވަގުތު ނޫން ވަގުތުގައި",
        "description": "ކުންފުނީގެ މަސައްކަތު ވަގުތުން ބޭރުގައި ކުރެވުނު ބަދަލެއް."
      },
      "firstTime": {
        "label": "ފުރަތަމަ ފަހަރު ބަދަލުކުރާ މީހެއް",
        "description": "ދުވަހަކުވެސް އަތްނުލާ ސެޓިންއެއް މީހަކު ބަދަލުކުރުން."
      },
      "controlWeaken": {
        "label": "ކޮންޓްރޯލް ބަލިކުރެވިފައި",
        "description": "ކޮންޓްރޯލެއް ދޫކޮށްލެވޭ ދިމާލަށް ކުރެވުނު ބަދަލެއް."
      },
      "preDocument": {
        "label": "ލިޔުމެއްގެ ކުރިން ބަދަލުކުރުން",
        "description": "މިންގަނޑެއް ބަދަލުވެ، ދެން ކުރީގެ ބޭންޑުގައި ލިޔުމެއް އައުން."
      },
      "bulk": {
        "label": "ގިނަ ބަދަލު",
        "description": "އެކަކު ކުރު ވަގުތެއްގެ ތެރޭގައި ގިނަ ސެޓިންތަކެއް ބަދަލުކުރުން."
      }
    }
  },
  "eam": {
    "routeTitles": {
      "locations": "ފުންކްޓިއޮނަލް ލޮކަޓިއޮންސް",
      "assets": "އަސްސެޓް ރެގިސްޓެރް",
      "asset": "އަސްސެޓް",
      "reconciliation": "އަސްސެޓް ރިކޮންސިލިއޭޝަން",
      "maintenance": "މައިންޓެނަންކް",
      "taskList": "ޓަސްކް ލިސްޓް",
      "meters": "މެޓެރްސް",
      "failures": "ފައިލުރެސް",
      "compliance": "ކޮމްޕްލިއަންކް ކަލެންޑަރް",
      "permits": "ޕެރްމިޓްސް އަށް މަސައްކަތް",
      "downtime": "ޑޯންޓިމް"
    },
    "filtersTitle": "ފިލްޓަރތައް",
    "chooseCompany": "ހޮވާ ކޮމްޕަންޔް އަށް ބަލާ އޭގެ މުދާ. ކޮންމެ ސަފު އީ ސްކޮޕެޑް އަށް ކޮމްޕަނީސް ތިޔަ ފަރާތް ވަނީ ޕެރްމިޓްޓެޑް, އެހެންކަމުން އެތާ އީ އެއްވެސްއެއްޗެއްނެތް ސެންސިބްލް އަށް ދައްކާ ވަންދެން އެއް އީ ހޮވިފައި.",
    "actions": {
      "remove": "ނަގާ"
    },
    "labels": {
      "yes": "ޔެސް",
      "no": "ނެތް",
      "active": "ހަރަކާތްތެރި",
      "inactive": "އިނަކްޓިވް"
    },
    "fields": {
      "company": "ކޮމްޕަންޔް",
      "code": "ކޯޑް",
      "assetId": "އަސްސެޓް",
      "assetNo": "އަސްސެޓް ނެތް.",
      "classCode": "ކްލަސްސް",
      "criticality": "ކްރިޓިކަލިޓްޔް",
      "ownership": "އޯނެރްށިޕް",
      "lifecycleState": "ލައިފްސައިކަލް",
      "location": "ފުންކްޓިއޮނަލް ލޮކަޓިއޮން",
      "financeAsset": "ފިނަންކިއަލް އަސްސެޓް",
      "manufacturer": "މަނުފަކްޓުރެރް",
      "modelNo": "މޮޑެލް",
      "serialNo": "ސެރިއަލް ނެތް.",
      "meter": "މެޓެރް",
      "unit": "އުނިޓް",
      "currentReading": "މިހާރުގެ ރީޑިންގް",
      "cumulative": "ކުމުލަޓިވް",
      "readAt": "ކިޔާ ގައި",
      "readOn": "ކިޔާ މަތީގައި",
      "reading": "ރީޑިންގް",
      "delta": "ބަދަލު",
      "source": "ސައުރްކް",
      "rollsOver": "ރޮލްލްސް މަތިން",
      "overrideReason": "ރެގްރެސްސިއޮން ސަބަބު",
      "failureNo": "ފައިލުރް ނެތް.",
      "failureMode": "ފައިލުރް މޮޑް",
      "severity": "ސެވެރިޓްޔް",
      "detectedAt": "ޑެޓެކްޓެޑް",
      "restoredAt": "ރެސްޓޮރެޑް",
      "workOrder": "މަސައްކަތް ތަރުތީބު",
      "windowDays": "ވިންޑޯ (ދުވަސްތައް)",
      "failures": "ފައިލުރެސް",
      "mtbf": "MTBF (ހް)",
      "mttr": "MTTR (ހް)",
      "downtimeHours": "ޑޯންޓިމް (ހް)",
      "availability": "އަވައިލަބިލިޓްޔް %",
      "intervalDays": "ކޮންމެ (ދުވަސްތައް)",
      "intervalMeter": "ކޮންމެ (މެޓެރް އުނިޓްސް)",
      "nextDue": "ދެން ޑުއެ",
      "lastCompleted": "އެންމެފަހު ފުރިހަމަވެއްޖެ",
      "strategyKind": "ސްޓްރަޓެގްޔް",
      "estimatedHours": "އެސްޓިމަޓެޑް ގަޑިއިރު",
      "requiresPermit": "ހުއްދަދޭ ލާޒިމު",
      "stepNo": "ފިޔަވަޅު",
      "instruction": "އިންސްޓްރުކްޓިއޮން",
      "measurementUnit": "މިނެކިރާފައި ގައި",
      "minValue": "މިން",
      "maxValue": "މަކްސް",
      "standing": "ސްޓަންޑިންގް",
      "daysUntilDue": "ދުވަސްތައް ވަންދެން ޑުއެ",
      "certificateRef": "ކެރްޓިފިކަޓް ރެފް.",
      "validUntil": "ސައްހަ ވަންދެން",
      "inspectedOn": "އިންސްޕެކްޓެޑް މަތީގައި",
      "result": "ރެސުލްޓް",
      "findings": "ފިންޑިންގްސް",
      "from": "އިން",
      "to": "އަށް",
      "hazards": "ހަޒަރްޑްސް",
      "precautions": "ޕްރެކައުޓިއޮންސް",
      "isolationRef": "އިސޮލަޓިއޮން ރެފް.",
      "downtimeKind": "ކިންޑް",
      "state": "ސްޓަޓް",
      "reasonCode": "ސަބަބު",
      "startedAt": "ފެށިފައި",
      "endedAt": "ނިމިއްޖެ",
      "releaseNote": "ރެލީސް ނޯޓް"
    },
    "criticality": {
      "1": "1 — ވިޔަފާރި ހުއްޓޭ",
      "2": "2 — ށިފްޓް އީ ލޮސްޓް",
      "3": "3 — ނޮޓިކީބްލް",
      "4": "4 — ޓޮލެރަބްލް",
      "5": "5 — ކޮސްމެޓިކް"
    },
    "ownership": {
      "owned": "އޯނެޑް",
      "leased": "ލީސެޑް",
      "customer": "ކުސްޓޮމެރްސް"
    },
    "lifecycleState": {
      "planned": "ޕްލަންނެޑް",
      "commissioned": "ކޮމްމިސްސިއޮނެޑް",
      "in_service": "ގައި ޚިދުމަތް",
      "standby": "ސްޓަންޑްބްޔް",
      "decommissioned": "ޑެކޮމްމިސްސިއޮނެޑް"
    },
    "lifecycleEvent": {
      "commissioned": "ކޮމްމިސްސިއޮނެޑް",
      "baselined": "ބަސެލިނެޑް",
      "modified": "މޮޑިފީޑް",
      "relocated": "ރެލޮކަޓެޑް",
      "decommissioned": "ޑެކޮމްމިސްސިއޮނެޑް"
    },
    "linkKind": {
      "pms": {
        "room": "ރޫމް"
      },
      "mfg": {
        "work_center": "މަސައްކަތް ކެންޓްރް"
      },
      "service": {
        "resource": "ޚިދުމަތް ރެސައުރްކް"
      },
      "inventory": {
        "warehouse": "ވަރެހައުސް"
      }
    },
    "strategyKind": {
      "run_to_failure": "ހިނގާ އަށް ފައިލުރް",
      "time_based": "ވަގުތު ބަސެޑް",
      "usage_based": "ބޭނުންކުރުން ބަސެޑް",
      "condition_based": "ކޮންޑިޓިއޮން ބަސެޑް"
    },
    "severity": {
      "minor": "މިނޮރް",
      "major": "މަޖޮރް",
      "critical": "ކްރިޓިކަލް"
    },
    "standing": {
      "current": "މިހާރުގެ",
      "due_soon": "ޑުއެ ސޫން",
      "overdue": "އޮވެރްޑުއެ"
    },
    "inspectionResult": {
      "pass": "ޕަސްސް",
      "pass_with_conditions": "ޕަސްސް އާއެކު ކޮންޑިޓިއޮންސް",
      "fail": "ފައިލް"
    },
    "permitKind": {
      "hot_work": "ހޮޓް މަސައްކަތް",
      "confined_space": "ކޮންފިނެޑް ސްޕަކް",
      "electrical": "އެލެކްޓްރިކަލް",
      "height": "މަސައްކަތްކުރަނީ ގައި ހެއިގްޓް",
      "lifting": "ލިފްޓިންގް",
      "general": "އާންމު"
    },
    "permitStatus": {
      "requested": "ރެކެސްޓެޑް",
      "issued": "ދޫކުރެވިއްޖެ",
      "active": "ހަރަކާތްތެރި",
      "returned": "ރެޓުރްނެޑް",
      "closed": "ބަންދުކުރެވިފައި",
      "cancelled": "ކަންކެލްލެޑް",
      "expired": "އެކްސްޕިރެޑް"
    },
    "downtimeKind": {
      "planned": "ޕްލަންނެޑް",
      "unplanned": "އުންޕްލަންނެޑް",
      "compliance": "ކޮމްޕްލިއަންކް"
    },
    "downtimeState": {
      "unavailable": "އުނަވައިލަބްލް",
      "degraded": "ޑެގްރަޑެޑް"
    },
    "downtimeSource": {
      "manual": "ރެކޯޑްކުރެވިފައި މެދުވެރިކޮށް ހަންޑް",
      "compliance": "ކޮމްޕްލިއަންކް",
      "work_order": "މަސައްކަތް ތަރުތީބު",
      "failure": "ފައިލުރް"
    },
    "availabilityState": {
      "unavailable": "ދިޔަ އުނަވައިލަބްލް",
      "available": "ކަމް ފަހަތަށް"
    },
    "differenceClass": {
      "matched": "މަޓްޗެޑް",
      "unlinked_operational": "ހަމައެކަނި ގައި މައިންޓެނަންކް",
      "unlinked_financial": "ހަމައެކަނި ގައި މާލީ",
      "state_divergent": "ސްޓަޓެސް ޑިސަގްރީ",
      "company_divergent": "ކޮމްޕަނީސް ޑިސަގްރީ"
    },
    "locations": {
      "title": "ފުންކްޓިއޮނަލް ލޮކަޓިއޮންސް",
      "description": "ކޮންތާކު ތިންގް އީ, ގޮތުގައި ޑިސްޓިންކްޓް އިން ކޮންއެއްޗެއް އެ އީ. ޑްރަގް ލޮކަޓިއޮން އޮންޓޮ އިތުރު އަށް ރެޕަރެންޓް އެ, ނުވަތަ ބޭނުންކުރޭ ޕަރެންޓް ޕިކެރް މަތީގައި ސަފު.",
      "treeTitle": "ހީރަރްޗްޔް",
      "create": "އާ ލޮކަޓިއޮން",
      "createFailed": "އެ ލޮކަޓިއޮން ކުރެވުނު ނޫން ވުން އުފެއްދިއްޖެ.",
      "parent": "ޕަރެންޓް",
      "noParent": "ނެތް ޕަރެންޓް",
      "dragHint": "ޑްރަގް ސަފު އޮންޓޮ އިތުރު އަށް ރެޕަރެންޓް އެ. ޕަރެންޓް ޕިކެރް ކުރޭ އެއް ތިންގް އިން ކީބޯޑް. މޮވް އެ ވީސް ހަދާ ލޫޕް އީ ރެފުސެޑް މެދުވެރިކޮށް ސާވަރ އަދި ސަބަބު ފެންނާނެ މިތާ.",
      "moved": "ބަދަލުވެފައި",
      "moveFailed": "އެ ލޮކަޓިއޮން ކުރެވުނު ނޫން ވުން ބަދަލުވެފައި.",
      "loadFailed": " ހީރަރްޗްޔް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "empty": "ނެތް ފުންކްޓިއޮނަލް ލޮކަޓިއޮންސް އަދި. އުފައްދާ އެއް ށްޓަކައި ކޮންމެ ސިޓް, ބުއިލްޑިންގް ނުވަތަ ލިން އެހެންކަމުން މުދާ އެބަހުރި ކޮންމެވެސް ތާކު އަށް ލައިވް."
    },
    "assets": {
      "title": "އަސްސެޓް ރެގިސްޓެރް",
      "description": " އޮޕެރަޓިއޮނަލް ރެގިސްޓެރް: ކޮންތާކު މަޗިން އީ, ހޯ ކްރިޓިކަލް އެ އީ އަދި ވެތެރް އެ އީ ގައި ޚިދުމަތް. ފިނަންކިއަލް ރެގިސްޓެރް އީ ސެޕަރަޓް އަދި ދޭއް ވަނީ ރެކޮންކިލެޑް މެދުވެރިކޮށް އެ ފަރާތްތަކުގެ އަމިއްލަ ރެޕޮރްޓް.",
      "tableTitle": "މުދާ",
      "caption": "އޮޕެރަޓިއޮނަލް މުދާ އާއެކު އެ ފަރާތްތަކުގެ ކްރިޓިކަލިޓްޔް, ލައިފްސައިކަލް ސްޓަޓް އަދި ފިނަންކިއަލް ކައުންޓެރްޕަރްޓް.",
      "create": "އާ އަސްސެޓް",
      "dialogDescription": " އަސްސެޓް ނަންބަރު އީ ހަވާލުކުރެވިފައި ވަގުތު އެ އީ ރައްކާކުރެވިއްޖެ.",
      "criticalityHint": "1 އީ “ ވިޔަފާރި ހުއްޓޭ”, 5 އީ “ސޮމެބޮޑްޔް ނޮޓިކެސް އެވެންޓުއަލްލްޔް”. އެ އޮރްޑެރްސް ޕްރެވެންޓިވް މައިންޓެނަންކް އަދި ޑެކިޑެސް ކޮން ފައިލުރެސް އެސްކަލަޓް.",
      "locationHint": " އަސްސެޓް އާއެކު ނެތް ލޮކަޓިއޮން ދުވަހަކުވެސް ފެންނާނެ މަތީގައި ސިޓެސް ކޮމްޕްލިއަންކް ކަލެންޑަރް.",
      "searchLabel": "ހޯދާ",
      "searchPlaceholder": "އަސްސެޓް ނަންބަރު, ނަން ނުވަތަ ސެރިއަލް",
      "empty": "ނެތް މުދާ ދިމާވުން. އުފައްދާ އެއް, ނުވަތަ ވިޑެން ފިލްޓަރތައް.",
      "loadFailed": " އަސްސެޓް ރެގިސްޓެރް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "saved": "އަސްސެޓް އުފެއްދިއްޖެ",
      "saveFailed": "އެ އަސްސެޓް ކުރެވުނު ނޫން ވުން އުފެއްދިއްޖެ.",
      "criticalityValue": "ކް{value}",
      "noFinanceAsset": "ނޫން ލިންކެޑް",
      "identity": "ވަނަވަރު",
      "availability": "އަވައިލަބިލިޓްޔް",
      "available": "ލިބެންހުރި",
      "unavailable": "އުނަވައިލަބްލް",
      "availableOn": "ލިބެންހުރި މަތީގައި {date}",
      "unavailableOn": "އުނަވައިލަބްލް މަތީގައި {date}",
      "availabilityUnknown": "އަވައިލަބިލިޓްޔް އެބަހުރި ނޫން ވެފައި އަންސްވެރެޑް ށްޓަކައި މި އަސްސެޓް އަދި.",
      "degraded": "ޑެގްރަޑެޑް",
      "meters": "މެޓެރްސް",
      "failures": "ފައިލުރެސް",
      "openDowntime": "ހުޅުވާ ޑޯންޓިމް",
      "compliance": "ކޮމްޕްލިއަންކް",
      "lifecycle": "ލައިފްސައިކަލް",
      "links": "ލިންކެޑް އަށް",
      "noLifecycleEvents": "އެއްވެސްއެއްޗެއްނެތް އެބަހުރި ހަޕްޕެނެޑް އަށް މި އަސްސެޓް އަދި.",
      "commission": "ކޮމްމިސްސިއޮން",
      "commissionHint": "ކޮމްމިސްސިއޮނިންގް އީ ޑަޓެޑް ގައި ކޮމްޕަންޔްސް އަމިއްލަ ޓައިމްޒޯން މެދުވެރިކޮށް ސާވަރ.",
      "commissioned": "އަސްސެޓް ކޮމްމިސްސިއޮނެޑް",
      "commissionFailed": "އެ އަސްސެޓް ކުރެވުނު ނޫން ވުން ކޮމްމިސްސިއޮނެޑް.",
      "decommissionNote": "ޑެކޮމްމިސްސިއޮނިންގް އީ ނިމިއްޖެ އިން އަސްސެޓްސް އަމިއްލަ ޑިސްޕޮސަލް ޕަޕެރްވޮރްކް: އެ ބޭނުންވޭ އެވިޑެންކް އަޓްޓަޗްމެންޓް, އެހެންކަމުން އެ އީ ނޫން އޮފްފެރެޑް ގޮތުގައި ބުޓްޓޮން މިތާ."
    },
    "reconciliation": {
      "title": "އަސްސެޓް ރިކޮންސިލިއޭޝަން",
      "description": "ދެބައި ޑިރެކްޓިއޮންސް: މުދާ މައިންޓެނަންކް ރެގިސްޓެރް ހޮލްޑްސް އެ މާލީ ކުރޭ ނޫން, މުދާ މާލީ ހޮލްޑްސް އެ އެއްވެސްއެއްޗެއްނެތް މައިންޓައިންސް, އަދި ޕައިރްސް ކާގެ ސްޓަޓެސް އެބަހުރި ޑްރިފްޓެޑް އަޕަރްޓް.",
      "summary": "ޑިފްފެރެންކެސް",
      "tableTitle": "ސަފުތައް",
      "caption": "އޮޕެރަޓިއޮނަލް އަދި ފިނަންކިއަލް އަސްސެޓް ރެގިސްޓެރްސް, ސިޑް މެދުވެރިކޮށް ސިޑް, އާއެކު ޑިފްފެރެންކް ސާވަރ ކްލަސްސިފީޑް.",
      "eamName": "މައިންޓެނަންކް ނަން",
      "financeNo": "ފިނަންކިއަލް ނެތް.",
      "financeName": "ފިނަންކިއަލް ނަން",
      "financeStatus": "ފިނަންކިއަލް ސްޓޭޓަސް",
      "differenceClass": "ޑިފްފެރެންކް",
      "notInEam": "ނޫން ގައި މައިންޓެނަންކް",
      "notInFinance": "ނޫން ގައި މާލީ",
      "balanced": "އެއްވެސްއެއްޗެއްނެތް އަށް ރެކޮންކިލް.",
      "empty": "ނެތް ސަފުތައް. އެއިތެރް ރެގިސްޓެރް ވެދާނެ އަދިވެސް ވުން އެމްޕްޓްޔް.",
      "loadFailed": " ރިކޮންސިލިއޭޝަން ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ."
    },
    "maintenance": {
      "title": "މައިންޓެނަންކް",
      "description": "ސްޓްރަޓެގީސް, ޕްރެވެންޓިވް ޕްލޭންތައް އަދި ޓަސްކް ލިސްޓްތައް އެ ފަރާތްތައް ހިނގާ."
    },
    "strategies": {
      "title": "ސްޓްރަޓެގީސް",
      "empty": "ނެތް ސްޓްރަޓެގީސް އަދި.",
      "saveFailed": "އެ ސްޓްރަޓެގްޔް ކުރެވުނު ނޫން ވުން ރައްކާކުރެވިއްޖެ."
    },
    "taskLists": {
      "title": "ޓަސްކް ލިސްޓްތައް",
      "empty": "ނެތް ޓަސްކް ލިސްޓްތައް އަދި.",
      "saveFailed": "އެ ޓަސްކް ލިސްޓް ކުރެވުނު ނޫން ވުން ރައްކާކުރެވިއްޖެ.",
      "summary": "ސުމްމަރްޔް",
      "steps": "ފިޔަވަޅުތައް",
      "stepsEmpty": "ނެތް ފިޔަވަޅުތައް އަދި. އިތުރުކުރޭ ފުރަތަމަ އެއް.",
      "addStep": "އިތުރުކުރޭ ފިޔަވަޅު",
      "stepsSaved": "ފިޔަވަޅުތައް ރައްކާކުރެވިއްޖެ",
      "stepsFailed": "އެތަކެތި ފިޔަވަޅުތައް ކުރެވުނު ނޫން ވުން ރައްކާކުރެވިއްޖެ.",
      "loadFailed": "އެ ޓަސްކް ލިސްޓް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "skills": "ކޮމްޕެޓެންކީސް ލާޒިމު",
      "skillsEmpty": "ނެތް ކޮމްޕެޓެންކީސް ވަނީ ލާޒިމު ށްޓަކައި މި ޓަސްކް ލިސްޓް.",
      "skillsNote": "ކޮމްޕެޓެންކީސް ކޮމް އިން ށަރެޑް އެޗްއާރް ރެގިސްޓެރް. އެ ފަރާތްތައް ވަނީ އަޑްޑެޑް އެތާ, ނޫން އިންވެންޓެޑް މިތާ, އެހެންކަމުން ޑިސްޕަޓްޗް އަދި މުސާރަ އަގްރީ އަބައުޓް ކާކު ހޮލްޑްސް ކޮންއެއްޗެއް.",
      "minLevel": "ލެވެލް {level}+",
      "statutory": "ސްޓަޓުޓޮރްޔް"
    },
    "pmPlans": {
      "title": "ޕްރެވެންޓިވް ޕްލޭންތައް",
      "empty": "ނެތް ޕްރެވެންޓިވް ޕްލޭންތައް އަދި.",
      "loadFailed": " ޕްރެވެންޓިވް ޕްލޭންތައް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "twoTriggers": " ޕްލޭން ކުރެވޭނެ ފިރް މަތީގައި ކަލެންޑަރް އަދި މަތީގައި މެޓެރް. ވިޗެވެރް ކޮމެސް ފުރަތަމަ ރައިސެސް މަސައްކަތް ތަރުތީބު, ކޮން އީ ކީއްވެ ދެބައި ކޮލަމްތައް ވަނީ ދެއްކިފައި.",
      "preview": "ޕްރެވީވް",
      "previewLoading": "މަސައްކަތްކުރަނީ ބޭރަށް ކޮންއެއްޗެއް ގެނެރަޓޮރް ވީސް ކުރޭ…",
      "previewDue": "ޑުއެ މިހާރު — {reason}, ގޮތުގައި ގެ {asOf}. ގެނެރަޓޮރް ވީސް އުފުލާ މަސައްކަތް ތަރުތީބު.",
      "previewNotDue": "ނޫން ޑުއެ. ދެން ޑުއެ {nextDue}, އުފެއްދިފައި {lead} ދުވަސްތައް އަހީޑް.",
      "generateNow": "ގެނެރަޓް މިހާރު",
      "generated": "ގެނެރަޓިއޮން ނިމިއްޖެ — {count} ޕްލޭން(ސް) ކޮންސިޑެރެޑް",
      "generateFailed": "ގެނެރަޓިއޮން ނާކާމިޔާބު."
    },
    "meters": {
      "title": "މެޓެރްސް",
      "description": "ހިނގަނީ ގަޑިއިރު, ކްޔްކްލެސް އަދި ކައުންޓެރްސް. ކޮންމެ ރީޑިންގް އީ ސާވަރުގެ ފިގުރް; ބަދަލު ބެޓްވީން ރީޑިންގްސް އީ އޭގެ ސުބްޓްރަކްޓިއޮން, ނޫން މި ސްކްރީނުގެ.",
      "registerTitle": "މެޓެރްސް",
      "empty": "ނެތް މެޓެރްސް އަދި.",
      "loadFailed": " މެޓެރްސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "readingsTitle": "ރީޑިންގްސް",
      "readingsEmpty": "ނެތް ރީޑިންގްސް ށްޓަކައި މި މެޓެރް އަދި.",
      "recordReading": "ރެކޯޑް ރީޑިންގް",
      "readingRecorded": "ރީޑިންގް ރެކޯޑްކުރެވިފައި",
      "readingFailed": "އެ ރީޑިންގް ކުރެވުނު ނޫން ވުން ރެކޯޑްކުރެވިފައި.",
      "regressionHint": "ހަމައެކަނި ނީޑެޑް ވަގުތު ރީޑިންގް އީ ދަށް ވުރެ އެންމެފަހު އެއް — ރެޕްލަކެޑް މެޓެރް, ނުވަތަ ކޮރްރެކްޓިއޮން.",
      "importTitle": "އިމްޕޯޓް ރީޑިންގްސް",
      "importHint": "CSV ހަމައެކަނި. އެއް ސަފު ކޮންމެ ރީޑިންގް; ސާވަރ ރެޕޮރްޓްސް ކޮންމެ ސަފު އެ ސްކިޕްޕެޑް އަދި ކީއްވެ.",
      "import": "އިމްޕޯޓް",
      "imported": "{count} ރީޑިންގް(ސް) އިމްޕޮރްޓެޑް",
      "importFailed": " އިމްޕޯޓް ނާކާމިޔާބު.",
      "skippedRow": "ސަފު {line}: {reason}"
    },
    "failures": {
      "title": "ފައިލުރެސް",
      "description": "ކޮންއެއްޗެއް ބްރޮކް, ވަގުތު, އަދި ހޯ ރެލިއަބްލް ފްލީޓް އެބަހުރި ވެފައި ފަހުން. ރެލިއަބިލިޓްޔް ފިގުރެސް ވަނީ ސާވަރުގެ.",
      "tableTitle": "ފައިލުރެސް",
      "empty": "ނެތް ފައިލުރެސް ރެކޯޑްކުރެވިފައި.",
      "loadFailed": " ފައިލުރެސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "open": "ހުޅުވާ",
      "openOnly": "ދައްކާ",
      "openOnlyYes": "ހުޅުވާ ހަމައެކަނި",
      "openOnlyNo": "ހުރިހާ",
      "record": "ރެކޯޑް ފައިލުރް",
      "recorded": "ފައިލުރް ރެކޯޑްކުރެވިފައި",
      "recordFailed": "އެ ފައިލުރް ކުރެވުނު ނޫން ވުން ރެކޯޑްކުރެވިފައި.",
      "restore": "މަރްކް ރެސްޓޮރެޑް",
      "restored": "ފައިލުރް މަރްކެޑް ރެސްޓޮރެޑް",
      "restoreFailed": "އެ ފައިލުރް ކުރެވުނު ނޫން ވުން މަރްކެޑް ރެސްޓޮރެޑް.",
      "reliabilityTitle": "ރެލިއަބިލިޓްޔް",
      "reliabilityEmpty": "ނެތް ރެލިއަބިލިޓްޔް ފިގުރެސް ށްޓަކައި މި ވިންޑޯ."
    },
    "compliance": {
      "title": "ކޮމްޕްލިއަންކް ކަލެންޑަރް",
      "description": "ސްޓަޓުޓޮރްޔް އިންސްޕެކްޓިއޮންސް މެދުވެރިކޮށް ޑުއެ ތާރީޚް. ރެކިރެމެންޓް އެ ބްލޮކްސް އޮޕެރަޓިއޮން ނަގާ އަސްސެޓް ބޭރަށް ގެ ޚިދުމަތް ވަގުތު އެ ދޭ އޮވެރްޑުއެ.",
      "calendarTitle": "މެދުވެރިކޮށް ޑުއެ ތާރީޚް",
      "summary": "ސްޓަންޑިންގް",
      "overdueCount": "{count} އޮވެރްޑުއެ",
      "dueSoonCount": "{count} ޑުއެ ސޫން",
      "asOf": "ގޮތުގައި ގެ {date}",
      "blocksOperation": "ބްލޮކްސް އޮޕެރަޓިއޮން",
      "assetUnavailable": "އަސްސެޓް އުނަވައިލަބްލް",
      "empty": "އެއްވެސްއެއްޗެއްނެތް ޑުއެ ގައި މި ވިންޑޯ.",
      "loadFailed": " ކޮމްޕްލިއަންކް ކަލެންޑަރް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "recordInspection": "ރެކޯޑް އިންސްޕެކްޓިއޮން",
      "inspectionTitle": "ރެކޯޑް އިންސްޕެކްޓިއޮން",
      "inspectionRecorded": "އިންސްޕެކްޓިއޮން ރެކޯޑްކުރެވިފައި",
      "inspectionFailed": "އެ އިންސްޕެކްޓިއޮން ކުރެވުނު ނޫން ވުން ރެކޯޑްކުރެވިފައި.",
      "passReleasesNote": " ޕަސްސް ސެޓްކުރޭ ދެން ޑުއެ ތާރީޚް އަދި ރެލީސެސް ކޮމްޕްލިއަންކް ޑޯންޓިމް ގައި އެއް ޓްރަންސަކްޓިއޮން, އެހެންކަމުން އަސްސެޓް ބެކޮމެސް ލިބެންހުރި އަލުން ވަގުތުން."
    },
    "permits": {
      "title": "ޕެރްމިޓްސް އަށް މަސައްކަތް",
      "description": "ކާކު އެދޭނެ, ކާކު ދޫކުރެވިއްޖެ, ކާކު ކުރި މަސައްކަތް އަދި ކާކު ބަލައިގަނެވިއްޖެ އެ ފަހަތަށް. ތިނެއް ސިގްނަޓުރެސް, ތިނެއް ތަފާތު މުވައްޒަފުން.",
      "empty": "ނެތް ޕެރްމިޓްސް ދިމާވުން.",
      "loadFailed": " ޕެރްމިޓްސް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "sodNote": "ރެކެސްޓިންގް, އިސްސުއިންގް އަދި އަކްކެޕްޓިންގް ރެޓުރްން ވަނީ ހިފެހެއްޓިފައި މެދުވެރިކޮށް ތަފާތު މުވައްޒަފުން. ކޮންޓްރޯލް ތިޔަ ފަރާތް ނުކުރެވޭނެ ސައިން އީ ނޫން ދެއްކިފައި, ބެކައުސް ހުއްދަދޭ އީ ސަފެޓްޔް ޑޮކުމެންޓް އަދި ނޫން ފޯމް.",
      "stepRequested": "ރެކެސްޓެޑް",
      "stepIssued": "ދޫކުރެވިއްޖެ",
      "stepExecuted": "އެކްސެކުޓެޑް",
      "stepAccepted": "ރެޓުރްން ބަލައިގަނެވިއްޖެ",
      "requested": "ރެކެސްޓެޑް",
      "notSigned": "ނޫން ސައިން ވެފައި",
      "signedBy": "މެދުވެރިކޮށް {user}",
      "executedByStart": "ސްޓަމްޕެޑް ވަގުތު މަސައްކަތް ތަރުތީބު އީ ފެށިފައި, މެދުވެރިކޮށް ވޮއެވެރް ފަށާ އެ.",
      "issue": "އިސްސުއެ ހުއްދަދޭ",
      "issued": "ހުއްދަދޭ ދޫކުރެވިއްޖެ",
      "issueFailed": "އެ ހުއްދަދޭ ކުރެވުނު ނޫން ވުން ދޫކުރެވިއްޖެ.",
      "acceptReturn": "އަކްކެޕްޓް ރެޓުރްން",
      "returnAccepted": "ރެޓުރްން ބަލައިގަނެވިއްޖެ",
      "acceptFailed": "އެ ރެޓުރްން ކުރެވުނު ނޫން ވުން ބަލައިގަނެވިއްޖެ."
    },
    "downtime": {
      "title": "ޑޯންޓިމް",
      "description": "ވަގުތު މުދާ ވި އުނަވައިލަބްލް, ކީއްވެ, އަދި ވެތެރް މޮޑިއުލްތައް އެ ކަރް އަކްނޯލެޑްގެޑް އެ.",
      "tableTitle": "ޑޯންޓިމް",
      "empty": "ނެތް ޑޯންޓިމް ގައި މި ވިންޑޯ.",
      "loadFailed": " ޑޯންޓިމް ކުރެވުނު ނޫން ވުން ލޯޑްކުރެވިއްޖެ.",
      "openOnly": "ދައްކާ",
      "openOnlyYes": "ހުޅުވާ ހަމައެކަނި",
      "openOnlyNo": "ހުރިހާ",
      "release": "ރެލީސް",
      "released": "ޑޯންޓިމް ރެލީސެޑް",
      "releaseFailed": "އެ ޑޯންޓިމް ކުރެވުނު ނޫން ވުން ރެލީސެޑް.",
      "complianceReleaseNote": "ރެލީސެޑް މެދުވެރިކޮށް ރެކޮރްޑިންގް ޕަސްސިންގް އިންސްޕެކްޓިއޮން",
      "eventsTitle": "އަވައިލަބިލިޓްޔް އެވެންޓްސް",
      "eventsEmpty": "ނެތް އަވައިލަބިލިޓްޔް އެވެންޓްސް އަދި.",
      "receiptsNote": "ކޮންމެ އެވެންޓް ލިސްޓްތައް ކޮންއެއްޗެއް އަކްނޯލެޑްގެޑް އެ. އެވެންޓް އާއެކު ނެތް ރެކެއިޕްޓް އަގައިންސްޓް ލިންކެޑް ރޫމް ނުވަތަ މަސައްކަތް ކެންޓްރް އީ ރީލް ޕްރޮބްލެމް, އަދި މި އީ ކޮންތާކު އެ އީ ފެންނަ.",
      "noReceipts": "އެއްވެސްއެއްޗެއްނެތް އަކްނޯލެޑްގެޑް މި އެވެންޓް."
    },
    "noLegalEntity": "ތިބާއަށް ލީގަލް އެންޓިޓީއެއް ލިބިފައިނުވާތީ، ދައްކާނެ އެސެޓެއް ނެތް. އެޑްމިނިސްޓްރޭޓަރަކާ ގުޅުއްވާ."
  },
  "reporting": {
    "nav": {
      "label": "ރިޕޯޓިން ގަވަރނަންސްގެ ބައިތައް",
      "dailyOperating": "ދުވަހުގެ އޮޕަރޭޓިން",
      "board": "މަހުގެ ބޯޑް",
      "dictionary": "މެޓްރިކް ޑިކްޝަނަރީ",
      "exceptionViews": "އެކްސެޕްޝަން ވިއުތައް",
      "dashboards": "ޑޭޝްބޯޑްތައް",
      "savedFilters": "ރައްކާކުރި ފިލްޓަރު"
    },
    "routeTitles": {
      "dictionary": "މެޓްރިކް ޑިކްޝަނަރީ",
      "metric": "މެޓްރިކް",
      "dailyOperating": "ދުވަހުގެ އޮޕަރޭޓިން ރިޕޯޓް",
      "board": "ދުވަހުގެ އޮޕަރޭޓިން ބޯޑް",
      "exceptionViews": "އެކްސެޕްޝަން ވިއުތައް",
      "dashboards": "ރޯލް ޑޭޝްބޯޑްތައް",
      "drill": "ކޭޕީއައި ޑްރިލް",
      "savedFilters": "ރައްކާކުރި ފިލްޓަރު ސެޓްތައް"
    },
    "dictionary": {
      "title": "މެޓްރިކް ޑިކްޝަނަރީ",
      "description": "މި ޕްރޮޑަކްޓުން ރިޕޯޓުކުރާ ކޮންމެ އަދަދެއް، އޭގެ މާނަ، ވެރިފަރާތް، އަދި އެ އަދަދަށް ޒިންމާވާ ފަރާތެއް ވޭތޯ.",
      "search": "މި ޞަފުޙާ ހަނިކުރައްވާ",
      "searchPlaceholder": "ކޯޑް ނުވަތަ ލޭބަލް",
      "module": "މޮޑިއުލް",
      "certification": "ސެޓްފިކޭޝަން",
      "includeOrphaned": "މިހާރު ނުއުފައްދާ މެޓްރިކްތައް ވެސް ދައްކާ",
      "sync": "ރަޖިސްޓްރީން ސިންކްކުރައްވާ",
      "synced": "{metrics} މެޓްރިކް ޕްރޮޖެކްޓްކުރެވިއްޖެ، {orphaned} މިހާރު ނުއުފައްދާ ކަމަށް ފާހަގަކުރެވިއްޖެ.",
      "syncFailed": "ސިންކް ނުހިނގި",
      "chooseCompanyTitle": "ކުންފުންޏެއް ޚިޔާރުކުރައްވާ",
      "chooseCompanyDescription": "ސެޓްފިކޭޝަނާއި ވެރިފަރާތް ރެކޯޑުކުރެވެނީ ކުންފުނިން ކުންފުންޏަށް، އެހެންވެ ކިޔަނީ ކޮން ކުންފުންޏެއްކަން ޑިކްޝަނަރީއަށް އެނގެންޖެހޭ.",
      "loadFailed": "ޑިކްޝަނަރީ ލޯޑެއް ނުކުރެވުނު",
      "filteredEmptyTitle": "މި ފިލްޓަރުތަކާ ގުޅޭ މެޓްރިކެއް ނެތް",
      "filteredEmptyDescription": "ފިލްޓަރުތައް ސާފުކުރެއްވުމުން ކިޔުމުގެ ހުއްދަ އޮތް ހުރިހާ މެޓްރިކެއް ފެންނާނެ.",
      "emptyTitle": "މި ޓެނަންޓަށް އަދި މެޓްރިކެއް ޕްރޮޖެކްޓްކުރެވިފައެއް ނެތް",
      "emptyDescription": "މޮޑިއުލްތަކުން ކޯޑުގައި މެޓްރިކްތައް ބަޔާންކުރެއެވެ، އަދި ސިންކަކުން އެތަކެތި މިތަނަށް ގެނެއެވެ. ސިންކް ހިންގަވާ، ނުވަތަ އެޑްމިނިސްޓްރޭޓަރަކަށް ދަންނަވާ.",
      "tableLabel": "މެޓްރިކް ޑިކްޝަނަރީ",
      "orphanReason": "މިހާރު ނުއުފައްދާ",
      "noOwner": "ވެރިފަރާތެއް ނެތް",
      "states": {
        "certified": "ސެޓްފައިކުރެވިފައި",
        "adHoc": "އެޑް ހޮކް",
        "stale": "ސެޓްފައިކުރެވިފައި (ބާވެފައި)"
      },
      "sourceKinds": {
        "module_function": "މޮޑިއުލް ފަންކްޝަން",
        "read_model": "ރީޑް މޮޑެލް",
        "ledger": "ލެޖަރ",
        "derived": "އުފެއްދި"
      },
      "columns": {
        "code": "ކޯޑް",
        "label": "ލޭބަލް",
        "formula": "ފޯމިއުލާ",
        "source": "މަޞްދަރު",
        "grain": "ގްރެއިން",
        "unit": "ޔުނިޓް",
        "refresh": "ރިފްރެޝް",
        "owner": "ވެރިފަރާތް",
        "certification": "ސެޓްފިކޭޝަން"
      },
      "minutesUnit": "މިނެޓް"
    },
    "metric": {
      "description": "މި އަދަދުގެ މާނަ، ވެރިފަރާތް، އަދި މި އަދަދު ހިމެނިގެން ނެރެވިފައިވާ ތަކެތި.",
      "loadFailed": "މި މެޓްރިކް ލޯޑެއް ނުކުރެވުނު",
      "orphanedNote": "މިހާރު އެއްވެސް މޮޑިއުލަކުން މި މެޓްރިކް ނުއުފައްދައެވެ. ސެޓްފިކޭޝަންތަކާއި މި ހިމެނުނު ނެރުންތައް ބެހެއްޓެނީ އޯޑިޓް ފައިލަކަށް ސެޓްފައިކުރި އެއްޗެއް ބުނެދެވޭނެ ގޮތަށެވެ.",
      "definitionTitle": "މާނަ",
      "permission": "ކިޔުމުގެ ހުއްދަ",
      "contentHash": "މާނައިގެ ހޭޝް",
      "tenantTitle": "ތިޔަ ބޭފުޅުންގެ ސެޓިންގްސް",
      "tenantDescription": "ހަތަރު ކަމެއް މި ޓެނަންޓަށް ނިސްބަތްވެއެވެ. މަތީގައިވާ ހުރިހާ އެއްޗެއް ނިސްބަތްވަނީ އެ އަދަދު އުފައްދާ ކޯޑަށެވެ، އެހެންވެ ދައްކަނީ ބަދަލުކުރެވޭ ގޮތަކަށް ނޫނެވެ.",
      "refreshMinutes": "ރިފްރެޝް މުއްދަތު (މިނެޓް)",
      "refreshHint": "ދިގުކުރެވިދާނެ، ކުރެއް ނުކުރެވޭނެ. ރަޖިސްޓްރީގައި ބުނަނީ {current} މިނެޓް.",
      "published": "މި މެޓްރިކް ބޭނުންކުރާ ފަރާތްތަކަށް ދައްކާ",
      "note": "ނޯޓް",
      "saved": "ރައްކާކުރެވިއްޖެ",
      "ownershipTitle": "ވެރިކަން",
      "ownershipDescription": "މެޓްރިކެއްގެ ވެރިއަކީ މަޤާމެއް، ފަރުދެއް ނޫން، އެހެންވެ މީހަކު ދިޔަޔަސް ވެރިކަން ދެމިއޮވެއެވެ.",
      "noOwnerTitle": "މި މެޓްރިކްގެ ވެރިއަކު ނެތް",
      "noOwnerDescription": "ވެރިއެއް ނެތް އަދަދަކީ ޒިންމާވާ ފަރާތެއް ނެތް އަދަދެކެވެ. މެޓްރިކް މެނޭޖަރަކަށް ދަންނަވައި މަޤާމެއް ކަނޑައަޅުއްވާ.",
      "position": "މަޤާމް",
      "from": "އިން",
      "to": "އަށް",
      "current": "މިހާރު",
      "newOwner": "އައު ވެރިފަރާތް",
      "choosePosition": "މަޤާމެއް ޚިޔާރުކުރައްވާ",
      "assignOwner": "ވެރިފަރާތް ކަނޑައަޅުއްވާ",
      "ownerSet": "ވެރިފަރާތް ކަނޑައެޅިއްޖެ",
      "positionsUnreadable": "ވެރިފަރާތެއް ކަނޑައެޅުމަށް މަޤާމުތައް ކިޔުމުގެ ހުއްދަ ބޭނުންވެއެވެ، މި އެކައުންޓުގައި އެ ހުއްދައެއް ނެތެވެ.",
      "certificationTitle": "ސެޓްފިކޭޝަން",
      "notCertifiable": "މި މެޓްރިކަކީ އިޝާރީ އަދަދެއް ކަމުން ސެޓްފައެއް ނުކުރެވޭނެއެވެ. ރަޖިސްޓްރީގައި އެހެން ބުނެފައިވެއެވެ، އަދި ސާވަރުން ވެސް ޤަބޫލެއް ނުކުރެއެވެ.",
      "sodNote": "ސެޓްފައިކުރުމާއި މެނޭޖްކުރުން ވަކިކުރެވިފައިވެއެވެ: މެޓްރިކެއްގެ މާނަ ބަދަލުކުރެވޭ ފަރާތަކީ އެ މާނަ ރަނގަޅުކަމަށް ސެޓްފައިކުރާ ފަރާތަށް ވެގެން ނުވާނެއެވެ. މި އެކައުންޓުން މެޓްރިކްތައް މެނޭޖްކުރާތީ ސެޓްފައެއް ނުކުރެވޭނެއެވެ.",
      "staleNote": "މި ސެޓްފިކޭޝަން ސޮއިކުރި ފަހުން މާނަ ބަދަލުވެފައިވާތީ މިހާރު އެއިން ސެޓްފައެއް ނުކުރެއެވެ. މިހާރުން ފެށިގެން ނެރެވޭ ކޮންމެ ނެރުމެއްގައި މި މެޓްރިކް އެޑް ހޮކް ކަމަށް ރެކޯޑުވާނެއެވެ.",
      "status": "ޙާލަތު",
      "basis": "އަސާސް",
      "certifiedBy": "ސެޓްފައިކުރި ފަރާތް",
      "certifiedAt": "ސެޓްފައިކުރި ވަގުތު",
      "revoke": "ބާޠިލުކުރައްވާ",
      "certify": "ސެޓްފައިކުރައްވާ",
      "certifyTitle": "މި މެޓްރިކް ސެޓްފައިކުރައްވާ",
      "certifyDescription": "ބެއްލެވި ކަންކަން ލިޔުއްވާ. އަސާސަކީ ބޭރުގެ އޯޑިޓަރު ކިޔާނެ އެއްޗެވެ.",
      "basisHint": "މިސާލަކަށް: FY2026 Q3 ގެ AR ކޮންޓްރޯލް އެކައުންޓާ ރިކޮންސައިލްކުރެވިއްޖެ؛ މުއްދަތަކީ ފަހަތުން 90 ދުވަސް ކަމާއި އިންޓަކޮމްޕެނީ ނުހިމެނޭކަން ކަށަވަރުކުރެވިއްޖެ.",
      "basisRequired": "އަސާސެއް ބޭނުންވެއެވެ.",
      "certified": "ސެޓްފައިކުރެވިއްޖެ",
      "revokeTitle": "މި ސެޓްފިކޭޝަން ބާޠިލުކުރައްވާ",
      "revokeDescription": "ކުރިން ނެރެވިފައިވާ ތަކެތީގައި ސެޓްފައިކުރެވިފައިވާ އަދަދެއް ހިމެނުނުކަމަށް އަދިވެސް ބުނާނެއެވެ، ސަބަބަކީ އެއީ ޙަޤީޤަތެވެ. ބާޠިލުކުރުމުން ބަދަލުވަނީ ކުރިއަށް އޮތްތަނެވެ.",
      "reasonCode": "ސަބަބުގެ ކޯޑް",
      "reasonRequired": "ސަބަބުގެ ކޯޑެއް ބޭނުންވެއެވެ.",
      "revoked": "ސެޓްފިކޭޝަން ބާޠިލުކުރެވިއްޖެ",
      "outputsTitle": "މި މެޓްރިކް ހިމެނުނު ނެރުންތައް",
      "outputsDescription": "މި އަދަދު ހިމެނުނު ކޮންމެ އެކްސްޕޯޓެއް، ޝެޑިއުލެއް އަދި PDF އެއް، އަދި ނެރުނު ވަގުތު ސެޓްފައިކުރެވިފައިވޭތޯ.",
      "noOutputsTitle": "މި މެޓްރިކް ހިމެނިގެން އެއްވެސް އެއްޗެއް ނުނެރެވޭ",
      "noOutputsDescription": "އެކްސްޕޯޓް، ޝެޑިއުލްކުރެވުނު ރިޕޯޓް އަދި PDF ތަކުގައި ހިމެނުނު މެޓްރިކްތައް ރެކޯޑުވެއެވެ. އަދި އެއްވެސް އެއްޗެއް ނުނެރެވެއެވެ.",
      "report": "ރިޕޯޓް",
      "format": "ފޯމެޓް",
      "certificationState": "ނެރުނު އިރުގެ ޙާލަތު",
      "emittedAt": "ނެރުނު ވަގުތު",
      "certificationStatuses": {
        "active": "ހިނގަމުންދާ",
        "revoked": "ބާޠިލުކުރެވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      }
    },
    "dailyOps": {
      "title": "ދުވަހުގެ އޮޕަރޭޓިން ރިޕޯޓް",
      "description": "އެއް ޔުނިޓެއްގެ އެއް ދުވަސް: އާމްދަނީ، ކޮންޓްރޯލްކުރެވޭ ޚަރަދު، މަސައްކަތުގެ އަގު، ފައިސާ، އަދި ސާފުކުރަންޖެހޭ އެކްސެޕްޝަންތައް.",
      "build": "ދުވަހެއް ބިލްޑްކުރައްވާ",
      "built": "ރިޕޯޓް ބިލްޑްކުރެވިއްޖެ",
      "buildFieldsRequired": "ޔުނިޓަކާއި ވިޔަފާރީގެ ތާރީޚެއް ބޭނުންވެއެވެ.",
      "unitType": "ޔުނިޓްގެ ބާވަތް",
      "unitId": "ޔުނިޓް",
      "businessDate": "ވިޔަފާރީގެ ތާރީޚް",
      "force": "ޝާއިޢުކުރެވުނު ދުވަހެއް އަލުން ބިލްޑްކުރައްވާ",
      "from": "އިން",
      "to": "އަށް",
      "lateOnly": "ލަސްވި ތަކެތި އެކަނި",
      "loadFailed": "ރިޕޯޓްތައް ލޯޑެއް ނުކުރެވުނު",
      "detailFailed": "މި ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "މި މުއްދަތުގައި ދުވަހުގެ އޮޕަރޭޓިން ރިޕޯޓެއް ނެތް",
      "emptyDescription": "ރިޕޯޓްތައް ބިލްޑްވަނީ ރޭގަނޑު، ކުރީ ދުވަހަށެވެ. ދުވަހެއް ބިލްޑްކުރައްވާ، ނުވަތަ ތާރީޚްތައް ފުޅާކުރައްވާ.",
      "tableLabel": "ދުވަހުގެ އޮޕަރޭޓިން ރިޕޯޓްތައް",
      "unit": "ޔުނިޓް",
      "status": "ޙާލަތު",
      "revenue": "އާމްދަނީ",
      "exceptions": "އެކްސެޕްޝަން",
      "ledgerTie": "ލެޖަރ ގުޅުން",
      "ties": "ގުޅޭ",
      "doesNotTie": "ނުގުޅޭ",
      "reportRevenue": "ރިޕޯޓްގެ އާމްދަނީ",
      "ledgerRevenue": "ލެޖަރަށް ޕޯސްޓްކުރެވުނު",
      "difference": "ތަފާތު",
      "ledgerScope": "ލެޖަރ ސްކޯޕް",
      "failedSections": "{count} ބައެއް ފެއިލްވެ، އެ ބައިތަކުގެ ސަޠުރުތައް މި ރިޕޯޓުގައި ނުހިމެނެއެވެ:",
      "publishedAtLabel": "ޝާއިޢުކުރެވުނީ",
      "aheadOfDue": "· ސުންގަޑިއަށްވުރެ {ahead} ކުރިން، ސުންގަޑިއަކީ",
      "lateBy": "· ސުންގަޑިއަށްވުރެ {late} ލަހުން، ސުންގަޑިއަކީ",
      "notPublished": "އަދި ޝާއިޢުނުކުރެވޭ",
      "dueAtLabel": "· ސުންގަޑި",
      "publish": "ޝާއިޢުކުރައްވާ",
      "published": "ރިޕޯޓް ޝާއިޢުކުރެވިއްޖެ",
      "publishFailed": "ރިޕޯޓް ޝާއިޢެއް ނުކުރެވުނު",
      "familyEmptyTitle": "މިއަދު މި ބާވަތުގައި އެއްވެސް އެއްޗެއް ނެތް",
      "familyEmptyDescription": "މި ޔުނިޓާއި ތާރީޚަށް އެއްވެސް ބައަކުން ސަޠުރެއް ނުއުފެއްދި.",
      "line": "ސަޠުރު",
      "stream": "ސްޓްރީމް",
      "quantity": "އަދަދު",
      "amount": "މިންވަރު",
      "memo": "މެމޯ",
      "unitTypes": {
        "company": "ކުންފުނި",
        "branch": "ބްރާންޗް",
        "location": "ތަން"
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "published": "ޝާއިޢުކުރެވިފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "families": {
        "revenue": "އާމްދަނީ",
        "controllable_cost": "ކޮންޓްރޯލްކުރެވޭ ޚަރަދު",
        "labour": "މަސައްކަތުގެ އަގު",
        "cash": "ފައިސާ",
        "exception": "އެކްސެޕްޝަން"
      },
      "sectionStatuses": {
        "ok": "ހިނގައިފި",
        "empty": "ހުސް",
        "skipped": "ދޫކޮށްލެވިފައި",
        "failed": "ފެއިލްވެފައި"
      },
      "outcomesTitle": "ބައިތަކުގެ ނަތީޖާ",
      "outcomesShow": "ދައްކާ",
      "outcomesHide": "ފޮރުވާ",
      "outcomesHint": "ރިޕޯޓްގެ ކޮން ބައިތަކެއް ހިނގައި، ކޮން ބައިތަކެއް ދޫކޮށްލައި، ކޮން ބައިތަކެއް ނާކާމިޔާބުވިތޯ.",
      "outcomesFailed": "ބައިތަކުގެ ނަތީޖާ ލޯޑް ނުކުރެވުނު",
      "section": "ބައި",
      "module": "މޮޑިއުލް",
      "lineCount": "ރޮނގުތައް",
      "durationMs": "ނެގި (މިލިސިކުންތު)",
      "outcomeNote": "ނޯޓް",
      "outcomeNoLines": "ހިނގައި، އެއްވެސް އެއްޗެއް ނުފެނުނު."
    },
    "dailyOperating": {
      "section": {
        "revenuePos": "ޕޮއިންޓް އޮފް ސޭލް",
        "revenuePms": "ކޮޓަރިއާއި ޕްރޮޕަޓީ",
        "revenueAr": "އިންވޮއިސްކުރެވުނު އާމްދަނީ",
        "controllableCostInventory": "ސްޓޮކުން ނެރުނު ތަކެތި",
        "labourRoster": "މަސައްކަތްތެރިން",
        "cashSessions": "ފައިސާގެ ސެޝަންތައް",
        "exceptions": "އެކްސެޕްޝަން",
        "exceptionAttention": "އެކްސެޕްޝަން"
      },
      "line": {
        "posOutlet": "އައުޓްލެޓް",
        "posAccountTendered": "ކޮޓަރިއަށް ޗާޖުކުރެވުނު",
        "pmsRevenueCentre": "އާމްދަނީގެ މަރުކަޒު",
        "pmsBoardPackage": "ބޯޑް ޕެކޭޖުން ވަކިކުރެވުނު",
        "arRevenueAccount": "އާމްދަނީގެ އެކައުންޓް",
        "inventoryIssues": "އަގާއެކު ނެރުނު ސްޓޮކް",
        "labourCosted": "އަގު ހިސާބުކުރެވުނު މަސައްކަތް",
        "labourUncosted": "ރޯސްޓަރުގައި އޮތަސް އަގު ނުކުރެވޭ",
        "cashPaidIn": "ވަން ފައިސާ",
        "cashPaidOut": "ނުކުތް ފައިސާ",
        "cashVariance": "ފައިސާގެ ތަފާތު",
        "reconciliation": "ރިކޮންސިލިއޭޝަން ބައި"
      }
    },
    "board": {
      "title": "ދުވަހުގެ އޮޕަރޭޓިން ބޯޑް",
      "description": "ކޮންމެ ޔުނިޓަކާއި ދުވަހަކަށް އެއް ގޮޅި: ވަގުތަށް ފައިލްކުރެވިފައި، ލަހުން ފައިލްކުރެވިފައި، ނުވަތަ ފައިލްނުކުރެވި.",
      "chooseWindowTitle": "ކުންފުންޏަކާއި މުއްދަތެއް ޚިޔާރުކުރައްވާ",
      "chooseWindowDescription": "ބޯޑުން ދައްކަނީ އެއްފަހަރާ އެއް މަހެވެ. ބްރައުޒަރުގެ ގަޑިއަށް ދޫކޮށްލުމުގެ ބަދަލުގައި ބޭނުންވާ ތާރީޚްތައް ޚިޔާރުކުރައްވާ.",
      "loadFailed": "ބޯޑް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "މި މުއްދަތުގައި ރިޕޯޓެއް ނެތް",
      "emptyDescription": "މި ތާރީޚްތަކަށް އެއްވެސް އެއްޗެއް ބިލްޑްކުރެވިފައެއް ނެތެވެ. ދުވަހުގެ އޮޕަރޭޓިން ސްކްރީނުން ދުވަހެއް ބިލްޑްކުރައްވާ.",
      "lateCount": "ލަހުން ފައިލްކުރެވުނު",
      "missingCount": "ފައިލްނުކުރެވޭ",
      "dueHour": "ސުންގަޑީގެ ގަޑި",
      "dueHourHelp": "ޓެނަންޓްގެ ޓައިމްޒޯނުގައި، ޖެހިގެން އަންނަ ވިޔަފާރީގެ ދުވަހުގެ ކޮން ގަޑިއަކަށް ރިޕޯޓް ބޭނުންވޭތޯ.",
      "late": "ލަސް"
    },
    "exceptions": {
      "title": "އެކްސެޕްޝަން ވިއުތައް",
      "description": "ތިބާގެ ރޯލާ ގުޅޭ އެކްސެޕްޝަންތައް، ނަތީޖާގެ ބޮޑުމިނަށް ތަރުތީބުކޮށް، ކޮންމެ ވިއުއެއްގެ މުއްދަތަކަށް އަލުން ލޯޑުވާ.",
      "loadFailed": "އެކްސެޕްޝަން ވިއުތައް ލޯޑެއް ނުކުރެވުނު",
      "rowsFailed": "މި ވިއުގެ ސަޠުރުތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "މި ކުންފުންޏަށް އެކްސެޕްޝަން ވިއުއެއް ނެތް",
      "emptyDescription": "ވިއުއަކީ ރޯލެއް، މަޞްދަރުތަކެއް އަދި ރިފްރެޝް މުއްދަތެކެވެ. ތިޔަ ބޭފުޅުންގެ ރޯލަށް އެއް އުފެއްދުމަށް އެޑްމިނިސްޓްރޭޓަރަކަށް ދަންނަވާ.",
      "noRowsTitle": "މި ވިއުގައި ހުޅުވިފައި އެއްވެސް އެއްޗެއް ނެތް",
      "noRowsDescription": "މި ވިއުއިން އަހާ ކޮންމެ ސުވާލެއްގެ ޖަވާބު މިހާރު ބާކީ ނެތެވެ.",
      "tabsLabel": "އެކްސެޕްޝަން ވިއުތައް",
      "asAt": "ވަގުތަކީ",
      "live": "ލައިވް",
      "refreshEvery": "ކޮންމެ {minutes} މިނެޓަކުން ރިފްރެޝްވޭ",
      "ageIs": "{age} ވެއްޖެ",
      "source": "މަޞްދަރު",
      "document": "ލިޔުން",
      "opened": "ހުޅުވުނީ",
      "age": "ދުވަސް",
      "amount": "މިންވަރު",
      "sources": {
        "attention": "އެޓެންޝަން",
        "recon_queue": "ރިކޮންސިލިއޭޝަން ކިޔޫ",
        "approvals": "އެޕްރޫވަލް",
        "ai_recommendations": "AI ލަފާ"
      },
      "newTitle": "އާ އެކްސެޕްޝަން ވިއު",
      "editTitle": "އެކްސެޕްޝަން ވިއު އުނިއިތުރު",
      "editorDescription": "ވިއު އެކީ ރޯލެއް، އެ ނަގާ ސޯސްތައް، އަދި އޭގެ ޖަވާބު އަލުން ބޭނުންކުރެވޭ މިންވަރު.",
      "code": "ކޯޑް",
      "codeHint": "ވިއު އުފެދުމުން ބަދަލެއް ނުކުރެވޭ؛ ލިންކުތައް އެއަށް ރިޢާޔަތްކުރޭ.",
      "name": "ނަން",
      "roleCode": "ރޯލް",
      "roleHint": "މި ވިއު ހުށަހަޅާ ރޯލް.",
      "sourcesLabel": "ސޯސްތައް",
      "sourceRequired": "މަދުވެގެން އެއް ސޯސް އިޚްތިޔާރު ކުރައްވާ.",
      "fieldsRequired": "ކޯޑަކާއި، ނަމަކާއި، ރޯލެއް ބޭނުންވޭ.",
      "refreshMinutes": "ކޮންމެ (މިނެޓް) އަކުން އާކުރޭ",
      "refreshHint": "ސުމެއް ނަމަ ކޮންމެ ފަހަރަކު ހުޅުވާއިރު ލައިވްކޮށް ހިސާބުކުރެވޭ.",
      "refreshRange": "އާކުރާ މުއްދަތު ވާންޖެހޭނީ ސުމެއް ނުވަތަ އެއަށްވުރެ ގިނަ ފުރިހަމަ މިނެޓް.",
      "sortOrder": "ތަރުތީބު",
      "sortRange": "ތަރުތީބު ވާންޖެހޭނީ ސުމެއް ނުވަތަ އެއަށްވުރެ ބޮޑު.",
      "active": "ރޯލަށް ހުށަހަޅާ",
      "inactive": "ހުށަހަޅާފައި ނުވޭ",
      "saved": "އެކްސެޕްޝަން ވިއު ރައްކާކުރެވިއްޖެ",
      "deleted": "އެކްސެޕްޝަން ވިއު ފޮހެލެވިއްޖެ",
      "deleteFailed": "އެކްސެޕްޝަން ވިއު ފޮހެއެއް ނުލެވުނު",
      "deleteTitle": "މި އެކްސެޕްޝަން ވިއު ފޮހެލަންތޯ؟",
      "deleteDescription": "{name} ދެން އޭގެ ރޯލަށް ހުށަހަޅާފައެއް ނުހުންނާނެ."
    },
    "metricCatalogue": {
      "ar": {
        "dso": {
          "label": "ބަލައިގަންނަން ހުރި ދުވަސް (DSO)",
          "formula": "ނިމޭ AR ބާކީ ÷ މުއްދަތުގެ ކްރެޑިޓް ވިޔަފާރި × މުއްދަތުގެ ދުވަސް."
        },
        "unposted_invoices": {
          "label": "ޕޯސްޓްނުކުރެވޭ ކަސްޓަމަރ އިންވޮއިސް",
          "formula": "މުއްދަތުގައި ފާސްވެފައި އޮތަސް ޕޯސްޓްނުކުރެވޭ ކަސްޓަމަރ އިންވޮއިސް."
        }
      },
      "ap": {
        "dpo": {
          "label": "ދައްކަން ހުރި ދުވަސް (DPO)",
          "formula": "ނިމޭ AP ބާކީ ÷ މުއްދަތުގެ ގަތުންތައް × މުއްދަތުގެ ދުވަސް."
        },
        "unposted_invoices": {
          "label": "ޕޯސްޓްނުކުރެވޭ ސަޕްލަޔަރ އިންވޮއިސް",
          "formula": "މުއްދަތުގައި ފާސްވެފައި އޮތަސް ޕޯސްޓްނުކުރެވޭ ސަޕްލަޔަރ އިންވޮއިސް."
        }
      },
      "gl": {
        "gross_margin": {
          "label": "ޖުމްލަ މާޖިން",
          "formula": "މުއްދަތުގެ އާމްދަނީން ވިއްކި ތަކެތީގެ އަގު އުނިކުރުމަށްފަހު، އާމްދަނީއަށް ބަލައި."
        },
        "suspense_balance": {
          "label": "ސަސްޕެންސް ބާކީ",
          "formula": "މުއްދަތު ނިމޭއިރު ސަސްޕެންސް އެކައުންޓްތަކުގެ ބާކީ."
        },
        "unposted_journals": {
          "label": "ޕޯސްޓްނުކުރެވޭ ޖަރނަލް",
          "formula": "މުއްދަތުގައި ދެލިކޮޕީ ނުވަތަ ހުށަހެޅިފައި އޮތަސް ޕޯސްޓްނުކުރެވޭ ޖަރނަލް އެންޓްރީ."
        }
      },
      "budget": {
        "headroom_fytd": {
          "label": "ބަޖެޓް ބާކީ، އަހަރު ފެށިގެން",
          "formula": "ފާސްކުރެވުނު ބަޖެޓުން ކޮމިޓްމަންޓާއި އެކްޗުއަލް އުނިކުރުމަށްފަހު، މާލީ އަހަރު ފެށިގެން."
        }
      },
      "org": {
        "open_periods": {
          "label": "ހުޅުވިފައިވާ މާލީ މުއްދަތު",
          "formula": "މާލީ އަހަރުގައި ހުޅުވިފައި ނުވަތަ ސޮފްޓް ކްލޯޒް ޙާލަތުގައިވާ މުއްދަތުތަކުގެ ޢަދަދު."
        }
      },
      "inventory": {
        "value": {
          "label": "ސްޓޮކްގެ އަގު",
          "formula": "އެ ވަގުތު ހުރިހާ އައިޓަމަކާއި ގުދަނެއްގެ ސްޓޮކް ލެޖަރ އަގުގެ ޖުމްލަ."
        },
        "turns": {
          "label": "ސްޓޮކް އެނބުރުން",
          "formula": "މުއްދަތުގެ COGS ÷ މުއްދަތުގެ ސްޓޮކްގެ އެވްރެޖް އަގު."
        }
      },
      "procurement": {
        "grir_open": {
          "label": "ހުޅުވިފައިވާ GR-IR",
          "formula": "ލިބިފައި އިންވޮއިސް ނުކުރެވޭ ތަކެތި، އަގުގައި، ހުރިހާ PO ސަޠުރެއްގައި."
        },
        "vendor_otif": {
          "label": "ސަޕްލަޔަރ ވަގުތަށް ފުރިހަމައަށް",
          "formula": "ވަޢުދުވި ތާރީޚަށް ފުރިހަމައަށް ލިބުނު ތަކެތި، މުއްދަތުގެ ހުރިހާ ލިބުމަކަށް ބަލައި."
        }
      },
      "crm": {
        "open_pipeline": {
          "label": "ހުޅުވިފައިވާ ޕައިޕްލައިން",
          "formula": "އެ ވަގުތު ކާމިޔާބު ނުވަތަ ނާކާމިޔާބު ނުވެ ހުރި ފުރުޞަތުތަކުގެ އަގު."
        }
      },
      "sales": {
        "mrr": {
          "label": "މަހުން މަހަށް ތަކުރާރު އާމްދަނީ",
          "formula": "އެ މަހުގައި ހިނގަމުންދާ ސަބްސްކްރިޕްޝަންތަކުގެ މަހު އަގު."
        }
      },
      "hr": {
        "headcount": {
          "label": "މުވައްޒަފުންގެ ޢަދަދު",
          "formula": "އެ ވަގުތު ހިނގަމުންދާ ވަޒީފާއެއް އޮތް މުވައްޒަފުން."
        },
        "attrition": {
          "label": "ވަޒީފާއިން ވަކިވުން",
          "formula": "މުއްދަތުގައި ވަކިވި މީހުން، މުއްދަތުގެ އެވްރެޖް މުވައްޒަފުންގެ ޢަދަދަށް ބަލައި."
        }
      },
      "projects": {
        "open_projects": {
          "label": "ހުޅުވިފައިވާ މަޝްރޫޢު",
          "formula": "އެ ވަގުތު ބަންދު ނުވަތަ ކެންސަލް ނުވެ ހުރި މަޝްރޫޢުތައް."
        }
      },
      "reporting": {
        "posted_revenue_by_date": {
          "label": "ވިޔަފާރީގެ ތާރީޚުން ޕޯސްޓްވި އާމްދަނީ",
          "formula": "އެއް ދުވަހަށް ޔުނިޓްގެ އާމްދަނީ އެކައުންޓްތަކުގެ ކްރެޑިޓުން ޑެބިޓް އުނިކުރުމަށްފަހުގެ ޖުމްލަ."
        },
        "daily_revenue_by_stream": {
          "label": "ދުވަހުގެ އާމްދަނީ، ސްޓްރީމުން",
          "formula": "ޔުނިޓްގެ އެ ދުވަހުގެ މެމޯ ނޫން އާމްދަނީ ސަޠުރުތަކުގެ ޖުމްލަ، ސްޓްރީމުން."
        },
        "daily_controllable_cost": {
          "label": "ދުވަހުގެ ކޮންޓްރޯލްކުރެވޭ ޚަރަދު",
          "formula": "ޔުނިޓްގެ އެ ދުވަހުގެ މެމޯ ނޫން ކޮންޓްރޯލްކުރެވޭ ޚަރަދު ސަޠުރުތަކުގެ ޖުމްލަ."
        },
        "daily_labour_cost": {
          "label": "ދުވަހުގެ މަސައްކަތުގެ އަގު",
          "formula": "ޔުނިޓްގެ އެ ދުވަހުގެ އަގު ހިސާބުކުރެވުނު މަސައްކަތުގެ ސަޠުރުތަކުގެ ޖުމްލަ."
        },
        "daily_cash_variance": {
          "label": "ދުވަހުގެ ފައިސާގެ ތަފާތު",
          "formula": "އެ ދުވަހުގެ ބަންދުކުރެވުނު ސެޝަންތަކުގައި ގުނުނު ފައިސާއިން އުއްމީދުކުރި ފައިސާ އުނިކުރުމަށްފަހު."
        },
        "daily_exception_count": {
          "label": "ދުވަހުގެ އެކްސެޕްޝަން ޢަދަދު",
          "formula": "ޔުނިޓްގެ އެ ދުވަހަށް ނިސްބަތްވާ ހުޅުވިފައިވާ އެޓެންޝަން އަދި ރިކޮންސިލިއޭޝަން ބައިތައް."
        }
      },
      "close": {
        "blocking_readiness_count": {
          "label": "ކްލޯޒް ހުއްޓުވާ ޗެކްތައް",
          "formula": "މުއްދަތު ބަންދުކުރުން ހުއްޓުވާނެ ތައްޔާރީ ޗެކްތައް."
        }
      }
    },
    "dashboards": {
      "title": "ޑޭޝްބޯޑްތައް",
      "description": "ރޯލް ޑޭޝްބޯޑްތައް، ކޮންމެ އަދަދެއް ރިޕޯޓިން ރީޑް މޮޑެލްތަކުން ހިސާބުކޮށް، ކޮންމެ އަދަދެއްގެ ފަހަތުގައިވާ ރޯތަކަށް ވަދެވޭ ގޮތަށް.",
      "tabsLabel": "ރޯލް ޑޭޝްބޯޑްތައް",
      "loadFailed": "މި ޑޭޝްބޯޑް ލޯޑް ނުކުރެވުނު",
      "catalogueFailed": "ކޭޕީއައި ކެޓަލޮގް ލޯޑް ނުކުރެވުނު",
      "emptyTitle": "މި ޑޭޝްބޯޑްގައި އަދި ދައްކާނެ އެއްޗެއް ނެތް",
      "emptyDescription": "މި ކުންފުންޏަށް އެއްވެސް ކޭޕީއައި އެއް ހިސާބުކޮށްފައި ނުވޭ. މިހާރު ހިސާބުކުރަން ރީބިލްޑް ކުރައްވާ، ނުވަތަ މިރޭގެ ރަނަށް މަޑުކުރައްވާ.",
      "generatedAt": "އުފެއްދި",
      "hidden": "ތިޔަ ހުއްދަތަކުގެ ސަބަބުން {count} ކޭޕީއައި ފޮރުވިފައި",
      "cardCount": "{count} ކާޑް",
      "computedAt": "ހިސާބުކުރީ {at} · {period} އާ ހަމައަށް",
      "cardHelp": "{unit}، {source} ޕްރޮޖެކްޝަނުން.",
      "drill": "{label} ގެ ފަހަތުގައިވާ ރޯތައް ހުޅުވާ",
      "unitDays": "ދުވަސް",
      "export": "އެކްސްޕޯޓް",
      "exportGroup": "މި ޑޭޝްބޯޑް އެކްސްޕޯޓް ކުރައްވާ",
      "exported": "އެކްސްޕޯޓް ޑައުންލޯޑް ކުރެވިއްޖެ",
      "exportFailed": "އެކްސްޕޯޓް އުފެއްދޭ ގޮތެއް ނުވި",
      "rebuild": "ރީބިލްޑް",
      "rebuilt": "ޑޭޝްބޯޑްތައް ރީބިލްޑް ކުރެވިއްޖެ",
      "rebuiltDetail": "{count} ކާޑް އަލުން ހިސާބުކުރެވިއްޖެ.",
      "rebuildFailed": "ރީބިލްޑް ނުހިނގި",
      "names": {
        "executive": "އެގްޒެކެޓިވް",
        "finance": "ފައިނޭންސް",
        "sales": "ސޭލްސް",
        "inventory": "އިންވެންޓަރީ",
        "procurement": "ޕްރޮކިއުމަންޓް",
        "hr": "މުވައްޒަފުން",
        "project": "ޕްރޮޖެކްޓްތައް",
        "commercial": "ކޮމަރޝަލް"
      },
      "units": {
        "money": "އަދަދެއް",
        "percent": "އިންސައްތައެއް",
        "count": "ގުނުމެއް",
        "days": "ދުވަހުގެ އަދަދެއް",
        "ratio": "ރޭޝިއޯއެއް"
      },
      "sources": {
        "incremental": "ދޭތެރެ ދޭތެރެއިން ބަލަހައްޓާ",
        "rebuild": "އަލުން ބިނާކުރި"
      },
      "formats": {
        "csv": "ސީއެސްވީ ފައިލް",
        "xlsx": "އެކްސެލް ވޯކްބުކް",
        "pdf": "ޕީޑީއެފް ލިޔުން"
      }
    },
    "kpiCatalogue": {
      "dso": "ވިއްކުމުން ލިބެންޖެހޭ ފައިސާގެ ދުވަސް",
      "dpo": "ދައްކަންޖެހޭ ފައިސާގެ ދުވަސް",
      "margin": "ގްރޮސް މާޖިން",
      "variance": "ބަޖެޓްގައި ބާކީ (އަހަރު ފެށުނީއްސުރެ)",
      "close_status": "ހުޅުވިފައިވާ މާލީ މުއްދަތުތައް",
      "inventory_value": "އިންވެންޓަރީގެ އަގު",
      "turns": "އިންވެންޓަރީ ޓަރން (އަހަރީ)",
      "grir_open": "ހުޅުވިފައިވާ ޖީއާރު-އައިއާރު ބެލެންސް",
      "vendor_otif": "ސަޕްލަޔަރު ވަގުތަށް ފުރިހަމައަށް (90 ދުވަސް)",
      "pipeline": "ހުޅުވިފައިވާ ޕައިޕްލައިން",
      "mrr": "މަހުން މަހަށް ތަކުރާރުވާ އާމްދަނީ",
      "headcount": "ހަރަކާތްތެރި މުވައްޒަފުންގެ އަދަދު",
      "attrition": "މުވައްޒަފުން ދިއުން (ފާއިތުވި 12 މަސް)",
      "open_projects": "ހުޅުވިފައިވާ ޕްރޮޖެކްޓްތައް"
    },
    "drill": {
      "title": "{label} — ފަހަތުގައިވާ ރޯތައް",
      "description": "ކާޑް އެކުލެވިގެންވާ ރޯތައް ސީދާ، ސާވަރުގެ އަމިއްލަ ބަހާއި އަދަދުތަކުން. މިތާ އެއްވެސް އެއްޗެއް އަލުން ހިސާބެއް ނުކުރެވޭ.",
      "back": "ޑޭޝްބޯޑަށް އެނބުރި",
      "generatedAt": "އުފެއްދީ {at}",
      "loadFailed": "މި އަދަދުގެ ފަހަތުގައިވާ ރޯތައް ލޯޑް ނުކުރެވުނު",
      "emptyTitle": "މި އަދަދުގެ ފަހަތުގައި ރޯއެއް ނެތް",
      "emptyDescription": "މި އަދަދު މިހާރު އެއްވެސް އެއްޗަކުން އެކުލެވިގެންނުވޭ — ލިސްޓްކުރާނެ ބާކީއެއް، އޯޑަރެއް ނުވަތަ ރެކޯޑެއް ނެތް.",
      "noCompanyTitle": "މިއީ ޑޭޝްބޯޑް ކާޑަކުން ހުޅުވާ ތަނެއް",
      "noCompanyDescription": "ޑްރިލް އެއް ނިސްބަތްވަނީ އެއް ކުންފުންޏަށް. ޑޭޝްބޯޑް ހުޅުވައި، ފަހަތުގައިވާ އެއްޗެހި ބަލަން ބޭނުންވާ އަދަދަށް ފިއްތަވާ."
    },
    "savedFilters": {
      "title": "ރައްކާކުރި ފިލްޓަރު ސެޓްތައް",
      "description": "ސުވާލަކަށް ދެވޭ ނަމެއް: ނިސްބަތްވާ ރިޕޯޓް، ހަނިކުރާ ޕެރެމިޓަރުތައް، އަދި އެހެން މުވައްޒަފުންނަށް ބޭނުންކުރެވޭތޯ.",
      "new": "އާ ފިލްޓަރު ސެޓް",
      "edit": "ފިލްޓަރު ސެޓް އުނިއިތުރު",
      "editorDescription": "ސެޓެއް ނިސްބަތްވާ ރިޕޯޓް އުފެދުމުން ބަދަލެއް ނުކުރެވޭ، ސަބަބަކީ ލިންކުތަކާއި ޝެޑިއުލްތައް އެއަށް ރިޢާޔަތްކުރާތީ.",
      "name": "ނަން",
      "report": "ރިޕޯޓް",
      "reportKey": "ރިޕޯޓް ކީ",
      "reportKeyHint": "dashboard:finance ނުވަތަ kpi:dso",
      "params": "ޕެރެމިޓަރުތައް",
      "paramsHint": "މި ސެޓް ބޭނުންކުރާ ފިލްޓަރުތަކުގެ ޖޭސަން އޮބްޖެކްޓެއް.",
      "paramsInvalid": "ޕެރެމިޓަރުތަކަކީ ސައްޙަ ޖޭސަން އެއް ނޫން.",
      "paramsNotObject": "ޕެރެމިޓަރުތައް ވާންޖެހޭނީ ޖޭސަން އޮބްޖެކްޓަކަށް، ލިސްޓަކަށް ނުވަތަ އަގަކަށް ނޫން.",
      "fieldsRequired": "ނަމަކާއި ރިޕޯޓް ކީއެއް ބޭނުންވޭ.",
      "shareWithColleagues": "މި ސެޓް އެހެން މުވައްޒަފުންނާ ހިއްސާކުރޭ",
      "shared": "ހިއްސާކުރެވިފައި",
      "private": "ހަމައެކަނި ތިޔަބޭފުޅާއަށް",
      "visibility": "ފެންނަ މިންވަރު",
      "updated": "އެންމެފަހުން ބަދަލުކުރި",
      "saved": "ފިލްޓަރު ސެޓް ރައްކާކުރެވިއްޖެ",
      "delete": "ފޮހެލާ",
      "deleteTitle": "މި ފިލްޓަރު ސެޓް ފޮހެލަންތޯ؟",
      "deleteDescription": "{name} ނަގާލެވޭނެ. މިހާތަނަށް ބޭނުންކުރި ފަރާތްތަކަށް އެ ގެއްލޭނެ.",
      "deleted": "ފިލްޓަރު ސެޓް ފޮހެލެވިއްޖެ",
      "deleteFailed": "ފިލްޓަރު ސެޓް ފޮހެއެއް ނުލެވުނު",
      "loadFailed": "ރައްކާކުރި ފިލްޓަރު ސެޓްތައް ލޯޑް ނުކުރެވުނު",
      "emptyTitle": "އަދި ރައްކާކުރި ފިލްޓަރު ސެޓެއް ނެތް",
      "emptyDescription": "ގިނައިން ހިންގާ ރިޕޯޓެއްގެ ޕެރެމިޓަރުތައް ރައްކާކުރައްވާ، އޭރުން ކޮންމެ ފަހަރަކު އެއްގޮތަކަށް އެނބުރި އަންނާނެ."
    }
  },
  "rvm": {
    "nav": {
      "label": "ރެވެނިއު މެނޭޖްމަންޓްގެ ބައިތައް",
      "onTheBooks": "އޮން ދަ ބުކްސް",
      "pace": "ޕޭސް",
      "commercial": "ކޮމަރޝަލް ރިޕޯޓް",
      "forecasts": "ލަފާކުރުންތައް",
      "accuracy": "ސައްޙަކަން",
      "displacements": "ޑިސްޕްލޭސްމަންޓް",
      "hurdles": "ހަރޑްލް ރޭޓްތައް",
      "competitorRates": "ވާދަވެރިންގެ ރޭޓްތައް",
      "settings": "ސެޓިންގްސް",
      "dimensions": "ޑައިމެންޝަންތައް"
    },
    "routeTitles": {
      "onTheBooks": "އޮން ދަ ބުކްސް",
      "pace": "ޕޭސް އަދި ޕިކްއަޕް",
      "commercial": "ދުވަހުގެ ކޮމަރޝަލް ރިޕޯޓް",
      "forecasts": "ލަފާކުރުންތައް",
      "forecast": "ލަފާކުރުން",
      "accuracy": "ލަފާކުރުމުގެ ސައްޙަކަން",
      "displacements": "ޑިސްޕްލޭސްމަންޓް ވަޒަންކުރުންތައް",
      "displacement": "ޑިސްޕްލޭސްމަންޓް ވަޒަންކުރުން",
      "hurdles": "ހަރޑްލް ރޭޓްތައް",
      "competitorRates": "ވާދަވެރިންގެ ރޭޓްތައް",
      "settings": "ރެވެނިއު ސެޓިންގްސް",
      "dimensions": "ސެގްމަންޓް އަދި ސްޓްރީމް"
    },
    "common": {
      "stayDate": "ހުންނަ ތާރީޚް",
      "segment": "ސެގްމަންޓް",
      "stream": "ސްޓްރީމް",
      "roomType": "ކޮޓަރީގެ ބާވަތް",
      "allSegments": "ހުރިހާ ސެގްމަންޓެއް",
      "allRoomTypes": "ހުރިހާ ބާވަތެއް",
      "remove": "ނަގާ",
      "yes": "އާދެ",
      "no": "ނޫން",
      "active": "ހިނގަމުންދާ",
      "inactive": "ހުއްޓިފައި",
      "channel": "ޗެނަލް",
      "allChannels": "ހުރިހާ ޗެނަލެއް"
    },
    "picker": {
      "property": "ޕްރޮޕަޓީ",
      "placeholder": "ޕްރޮޕަޓީއެއް ހޮވާ",
      "idPlaceholder": "ޕްރޮޕަޓީ އައިޑީ",
      "chooseTitle": "ޕްރޮޕަޓީއެއް ހޮވާ",
      "chooseDescription": "ކޮންމެ ރެވެނިއު އަދަދެއް ނިސްބަތްވަނީ އެއް ޕްރޮޕަޓީއަކަށް ކަމުން، ޕްރޮޕަޓީއެއް ހޮވަންދެން އެއްވެސް އެއްޗެއް ދެއްކޭކަށް ނެތެވެ.",
      "unnamedProperty": "ޕްރޮޕަޓީ #{id}",
      "unnamedHint": "ޕްރޮޕަޓީތައް ދައްކާފައިވަނީ އައިޑީއިންނެވެ. ނަން ދެއްކުމަށް ބޭނުންވަނީ pms.property.read އަދި org.company.read ހުއްދަ ކަމަށްވެފައި، މި އެކައުންޓުގައި އެ ހުއްދަ ނެތެވެ.",
      "unnamedRoomTypes": "ކޮޓަރީގެ ބާވަތްތައް ދައްކާފައިވަނީ އައިޑީއިންނެވެ. ނަން ދެއްކުމަށް ބޭނުންވަނީ pms.property.read ހުއްދަ ކަމަށްވެފައި، މި އެކައުންޓުގައި އެ ހުއްދަ ނެތެވެ."
    },
    "onTheBooks": {
      "title": "އޮން ދަ ބުކްސް",
      "description": "ވަކި ރެއެއްގެ ނިޔަލަށް ވިކިފައިވާ މިންވަރު، އެ ރޭ ނަގާފައިވާ ސްނެޕްޝޮޓުންނެވެ. ސްނެޕްޝޮޓެއް ފަހުން އަލުން ބިނާއެއް ނުކުރެވެއެވެ.",
      "asOf": "މި ތާރީޚާ ހަމައަށް",
      "asOfHint": "ސްނެޕްޝޮޓް ސިލްސިލާގައި ހިނގާ",
      "latest": "އެންމެ ފަހު ސްނެޕްޝޮޓް",
      "older": "ކުރީގެ ސްނެޕްޝޮޓް",
      "newer": "ފަހުގެ ސްނެޕްޝޮޓް",
      "linesTaken": "{count} ލައިން",
      "stayFrom": "ހުންނަ ތާރީޚް: ފެށޭ",
      "stayTo": "ހުންނަ ތާރީޚް: ނިމޭ",
      "wholeHorizon": "މުޅި ހޮރައިޒަން",
      "window": "މުއްދަތު",
      "horizonTo": "ހޮރައިޒަން ނިމޭ",
      "takenAt": "ނެގި ވަގުތު",
      "basis": "ގުނާފައިވާ ރިޒަވޭޝަން ސްޓޭޓަސްތައް",
      "take": "މިއަދުގެ ސްނެޕްޝޮޓް ނަގާ",
      "taken": "{date} އަށް ސްނެޕްޝޮޓް ނަގައިފި.",
      "alreadyTaken": "މި ވިޔަފާރި ތާރީޚަށް ސްނެޕްޝޮޓެއް މިހާރުވެސް އެބައޮތެވެ. ސްނެޕްޝޮޓެއް ދެވަނަ ފަހަރު ނުނެގޭނެއެވެ.",
      "takeFailed": "ސްނެޕްޝޮޓް ނުނެގުނު",
      "loadFailed": "އޮން ދަ ބުކްސް ލޯޑެއް ނުކުރެވުނު",
      "noSnapshotEverTitle": "މި ޕްރޮޕަޓީއަށް އެއްވެސް ސްނެޕްޝޮޓެއް މިހާތަނަށް ނަގާފައެއް ނުވެއެވެ",
      "noSnapshotEverDescription": "މިއީ އެއްވެސް ބުކިންއެއް ނެތުމެއް ނޫނެވެ. ސްނެޕްޝޮޓް ނަގަނީ ކޮންމެ ރެއަކު ޕްރޮޕަޓީގެ އަމިއްލަ ވިޔަފާރި ތާރީޚުގައެވެ، އަދި ފަހުން ފުރައެއް ނުލެވެއެވެ. އެހެންކަމުން ފުރަތަމަ ސްނެޕްޝޮޓް ނަގަންދެން ދެއްކޭނެ އަދަދެއް ނެތެވެ.",
      "noSnapshotForTitle": "{date} އާ ހަމައަށް ސްނެޕްޝޮޓެއް ނެތް",
      "noSnapshotForDescription": "އެ ރޭގެ ސްނެޕްޝޮޓް ނަގާފައެއް ނުވެއެވެ، އަދި ފަހުން އަލުން ބިނާއެއް ނުކުރެވޭނެއެވެ. ސިލްސިލާއިން އެހެން ތާރީޚެއް ހޮވާ.",
      "noBookingsTitle": "{date} އާ ހަމައަށް ފޮތުގައި އެއްވެސް އެއްޗެއް ނެތް",
      "noBookingsDescription": "ސްނެޕްޝޮޓް ނަގާފައިވެއެވެ، ނަމަވެސް މި މުއްދަތަށް އެއީ ހުސްކޮށެވެ: މި ތާރީޚުތަކަށް އެއްވެސް ކޮޓަރިއެއް ވިކިފައެއް ނުވެއެވެ. މިއީ ސްނެޕްޝޮޓެއް ނެތުމާ ތަފާތު ކަމެކެވެ.",
      "roomsOtb": "ފޮތުގައިވާ ކޮޓަރި",
      "roomsOtbHelp": "ސްނެޕްޝޮޓް ތާރީޚާ ހަމައަށް ވިކިފައިވާ ރޫމް ނައިޓްސް.",
      "capacity": "ޖާގަ",
      "arrivals": "އަރައިވަލްސް",
      "cancellations": "ކެންސަލްކުރުންތައް",
      "occupancy": "އޮކިއުޕަންސީ",
      "occupancyHelp": "ޖާގައާ އަޅާބަލާއިރު ވިކިފައިވާ ކޮޓަރި، ސާވަރުން ހިސާބުކޮށްފައި.",
      "adr": "އޭޑީއާރް",
      "adrHelp": "ވިކުނު ކޮޓަރިއާ އަޅާބަލާއިރު އާމްދަނީ، ސާވަރުން ހިސާބުކޮށްފައި.",
      "revpar": "ރެވްޕާރ",
      "revparHelp": "ޖާގައާ އަޅާބަލާއިރު އާމްދަނީ — އޭޑީއާރް އާއި އޮކިއުޕަންސީ ގުނަކޮށްގެނެއް ނޫން، އެއީ ދެ ފަހަރު ރައުންޑްވާތީ.",
      "revenue": "ސާފު އާމްދަނީ",
      "revenueHelp": "ސްނެޕްޝޮޓުގައި ބަޔާންކުރާ ގޮތަށް، ޕެކޭޖް ބެހުމުން ސާފުކޮށް.",
      "linesTitle": "ސްނެޕްޝޮޓްގެ ލައިންތައް",
      "linesDescription": "ސްނެޕްޝޮޓުގައި ރައްކާކުރި ގޮތަށް، ކޮންމެ ތާރީޚް، ސެގްމަންޓް، ކޮޓަރީގެ ބާވަތް އަދި ޗެނަލަކަށް އެއް ލައިން.",
      "focusDate": "މި ތާރީޚް އެކަނި ދައްކާ",
      "noArithmetic": "މަތީގައިވާ އޮކިއުޕަންސީ، އޭޑީއާރް އަދި ރެވްޕާރ ހިސާބުކުރަނީ ދެއްކިފައިވާ މުއްދަތަށް ސާވަރުންނެވެ. އެއް ތާރީޚުގެ އަދަދުތައް ބެލުމަށް މުއްދަތު އެ ތާރީޚަށް ހަނިކުރައްވާ.",
      "definitionTitle": "މި ސްނެޕްޝޮޓުން ގުނީ ކޮންއެއްޗެއް",
      "defStatuses": "ރިޒަވޭޝަން ސްޓޭޓަސްތައް",
      "defHeld": "ހިފަހައްޓާފައިވާ ރިޒަވޭޝަން ހިމަނާފައި",
      "defUnpicked": "ނުނަގާ ގްރޫޕް ބްލޮކް ކޮޓަރި ހިމަނާފައި",
      "defComplimentary": "ހިލޭ ކޮޓަރި ހިމަނާފައި",
      "defRevenueBasis": "އާމްދަނީގެ އަސާސް"
    },
    "pace": {
      "title": "ޕޭސް އަދި ޕިކްއަޕް",
      "description": "މިއަދުގެ އޮން ދަ ބުކްސް، މިދިޔަ އަހަރުގެ އެ ލީޑް ޓައިމާއި ޝާއިޢުކުރެވުނު ލަފާކުރުމާ އަޅާކިޔުން.",
      "asOf": "މި ތާރީޚާ ހަމައަށް",
      "asOfPlaceholder": "ސްނެޕްޝޮޓް ތާރީޚެއް ހޮވާ",
      "breakdownHint": "މުޅި ޞަފުޙާ އެއް ސެގްމަންޓަށް ހަނިކުރޭ",
      "thisYearAsOf": "މި އަހަރު، މި ތާރީޚާ ހަމައަށް",
      "priorYearAsOf": "މިދިޔަ އަހަރު، އެއް ލީޑް ޓައިމް",
      "snapshotId": "ސްނެޕްޝޮޓް {id}",
      "snapshotPair": "ސްނެޕްޝޮޓް {from} އަދި {to}",
      "chartTitle": "ތިން ރޮނގު",
      "chartAria": "ތާރީޚުތަކުން ފޮތުގައިވާ ސާފު އާމްދަނީ، މިދިޔަ އަހަރު އަދި ލަފާކުރުން",
      "seriesOtb": "އޮން ދަ ބުކްސް",
      "seriesPriorYear": "މިދިޔަ އަހަރުގެ އެ ލީޑް ޓައިމް",
      "seriesForecast": "ޝާއިޢުކުރެވުނު ލަފާކުރުން",
      "noPublishedForecast": "މި ޕްރޮޕަޓީގައި ޝާއިޢުކުރެވުނު ލަފާކުރުމުގެ ވަރޝަނެއް ނެތުމުން، ތިންވަނަ ރޮނގު ނުކުރެހެއެވެ.",
      "noPublishedBudget": "މި ޕްރޮޕަޓީގައި ޝާއިޢުކުރެވުނު ބަޖެޓުގެ ވަރޝަނެއް ނެތުމުން، ތިންވަނަ ރޮނގު ނުކުރެހެއެވެ.",
      "noVersionChosen": "ތިންވަނަ ރޮނގު ކުރަހަން ކޮންޓެއިނަރަކާއި ވަރޝަނެއް ހޮވާ.",
      "comparisonBasis": "އަޅާކިޔުމުގެ އަސާސް",
      "basisOptions": {
        "forecast": "ލަފާކުރުން",
        "budget": "ބަޖެޓް",
        "version": "ކަނޑައަޅާފައިވާ ވަރޝަން"
      },
      "basisContainer": "ކޮންޓެއިނަރ",
      "basisContainerPlaceholder": "ލަފާކުރުމެއް ނުވަތަ ބަޖެޓެއް ހޮވާ",
      "basisVersion": "ވަރޝަން",
      "basisVersionPlaceholder": "ވަރޝަނެއް ހޮވާ",
      "tableTitle": "ތާރީޚުން ޕޭސް",
      "priorYearStayDate": "މިދިޔަ އަހަރުގެ ތާރީޚް",
      "rooms": "ކޮޓަރި",
      "roomsPriorYear": "މިދިޔަ އަހަރުގެ ކޮޓަރި",
      "roomsVariance": "ކޮޓަރީގެ ތަފާތު",
      "revenue": "އާމްދަނީ",
      "revenuePriorYear": "މިދިޔަ އަހަރުގެ އާމްދަނީ",
      "revenueVariance": "އާމްދަނީގެ ތަފާތު",
      "adrVariance": "އޭޑީއާރް ތަފާތު",
      "emptyTitle": "ދިމާވާ ތާރީޚެއް ނެތް",
      "emptyDescription": "މި މުއްދަތުގައި ދެ ސްނެޕްޝޮޓުގައި ދިމާވާ ތާރީޚެއް ނެތެވެ. މުއްދަތު ފުޅާކުރައްވާ ނުވަތަ އެހެން ތާރީޚެއް ހޮވާ.",
      "loadFailed": "ޕޭސް ލޯޑެއް ނުކުރެވުނު",
      "needsTwoSnapshots": "ޕޭސް އަޅާކިޔަނީ ދެ ސްނެޕްޝޮޓް ކަމުން، މަދުވެގެން އެއް ސްނެޕްޝޮޓް ނަގާފައި އޮންނަން ޖެހެއެވެ. ސްނެޕްޝޮޓް ނަގަނީ ކޮންމެ ރެއަކުއެވެ.",
      "missingDescription": "ޕޭސް އަށް އެ ތާރީޚުގެ ސްނެޕްޝޮޓާއި، އަހަރެއް ކުރީގެ އެ ލީޑް ޓައިމްގެ ސްނެޕްޝޮޓް ބޭނުންވެއެވެ. އޭގެ ތެރެއިން އެއް ސްނެޕްޝޮޓް ނަގާފައެއް ނުވެއެވެ، އަދި އަލުން ބިނާއެއް ނުކުރެވޭނެއެވެ.",
      "pickupTitle": "ޕިކްއަޕް",
      "pickupDescription": "އެއް ތާރީޚުތަކަކަށް، ދެ ސްނެޕްޝޮޓް ދެމެދު އިތުރުވި މިންވަރު.",
      "pickupFrom": "ފެށޭ ސްނެޕްޝޮޓް",
      "pickupTo": "ނިމޭ ސްނެޕްޝޮޓް",
      "pickupRooms": "އިތުރުވި ކޮޓަރި",
      "pickupRoomsHelp": "ދެ ސްނެޕްޝޮޓް ދެމެދު ކޮޓަރީގެ ތަފާތު.",
      "pickupRevenue": "އިތުރުވި އާމްދަނީ",
      "pickupAdr": "ޕިކްއަޕް އޭޑީއާރް",
      "pickupAdrHelp": "އިތުރުވި ކޮޓަރިއާ އަޅާބަލާއިރު އިތުރުވި އާމްދަނީ، ސާވަރުން ހިސާބުކޮށްފައި.",
      "pickupBetween": "ދެމެދު",
      "pickupRoomsFromTo": "ކޮޓަރި، ކުރިން އަދި ފަހުން",
      "pickupRevenueFromTo": "އާމްދަނީ، ކުރިން އަދި ފަހުން",
      "pickupFailed": "ޕިކްއަޕް ލޯޑެއް ނުކުރެވުނު",
      "pickupMissingDescription": "ޕިކްއަޕަށް ދެ ސްނެޕްޝޮޓް ބޭނުންވެއެވެ. ދެ ތާރީޚުގެ ތެރެއިން އެއް ތާރީޚަށް ސްނެޕްޝޮޓެއް ނެތެވެ، އަދި ސްނެޕްޝޮޓް އަލުން ބިނާއެއް ނުކުރެވޭނެއެވެ.",
      "channelHint": "އަޅާކިޔުން އެއް ޗެނަލަކަށް ހަނިކުރޭ. ފްރަންޓް ޑެސްކުން ނަގާ ބުކިންގަށް ޗެނަލެއް ނުހުންނާނެ، އަދި އެ ނުހިމެނޭނެ."
    },
    "forecasts": {
      "title": "ލަފާކުރުންތައް",
      "description": "ލަފާކުރުމަކީ ކޮންޓޭނަރެކެވެ؛ ޕްރޮޕަޓީ ހިންގާ އަދަދަކީ އޭގެ ޝާއިޢުކުރެވުނު ވަރޝަނެކެވެ.",
      "new": "އައު ލަފާކުރުމެއް",
      "code": "ކޯޑް",
      "name": "ނަން",
      "kind": "ބާވަތް",
      "kinds": {
        "forecast": "ލަފާކުރުން",
        "budget": "ބަޖެޓް"
      },
      "period": "މުއްދަތު",
      "periodFrom": "މުއްދަތު ފެށޭ",
      "periodTo": "މުއްދަތު ނިމޭ",
      "currency": "ފައިސާ",
      "currencyHint": "ޚާލީނަމަ ޕްރޮޕަޓީގެ ފައިސާ",
      "published": "ޝާއިޢުކުރެވުނު ވަރޝަން",
      "noPublished": "ޝާއިޢުކުރެވިފައި ނެތް",
      "versionRef": "ވަރޝަން {id}",
      "status": "ސްޓޭޓަސް",
      "created": "ލަފާކުރުން އުފެއްދިއްޖެ.",
      "fieldsRequired": "ކޯޑް، ނަން އަދި މުއްދަތުގެ ދެ ތާރީޚް ބޭނުންވެއެވެ.",
      "loadFailed": "ލަފާކުރުންތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "މި ޕްރޮޕަޓީއަށް އަދި ލަފާކުރުމެއް ނެތް",
      "emptyDescription": "އެއް ލަފާކުރުމެއް އުފައްދާ، ދެން ޑްރާފްޓް ވަރޝަނަކާއި އޭގެ ލައިންތައް އިތުރުކުރައްވާ. ވަރޝަނެއް ފާސްވަންދެން އެއްވެސް އެއްޗެއް ޝާއިޢެއް ނުކުރެވެއެވެ."
    },
    "forecast": {
      "subtitle": "{kind}، {from} އިން {to} އަށް",
      "loadFailed": "ލަފާކުރުން ލޯޑެއް ނުކުރެވުނު",
      "versionsTitle": "ވަރޝަންތައް",
      "versionNo": "ވަރޝަން",
      "versionName": "ނަން",
      "versionLabel": "ވ{no}",
      "versionRef": "ވަރޝަން {id}",
      "newVersion": "އައު ވަރޝަން",
      "status": "ސްޓޭޓަސް",
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "submitted": "ހުށަހަޅާފައި",
        "approved": "ފާސްކޮށްފައި",
        "rejected": "ބޭރުކޮށްފައި",
        "published": "ޝާއިޢުކޮށްފައި",
        "locked": "ތަޅުލާފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "submitted": "ހުށަހެޅި ވަގުތު",
      "approved": "ފާސްކުރި ވަގުތު",
      "publishedAt": "ޝާއިޢުކުރި ވަގުތު",
      "roomNights": "ރޫމް ނައިޓްސް",
      "revenue": "ސާފު އާމްދަނީ",
      "submit": "ފާސްކުރުމަށް ހުށަހަޅާ",
      "approve": "ފާސްކުރޭ",
      "reject": "ބޭރުކުރޭ",
      "publish": "ޝާއިޢުކުރޭ",
      "lock": "ތަޅުލާ",
      "done": {
        "newVersion": "ވަރޝަން އުފެއްދިއްޖެ.",
        "submit": "ފާސްކުރުމަށް ހުށަހަޅައިފި.",
        "approve": "ވަރޝަން ފާސްކޮށްފި.",
        "reject": "ވަރޝަން ބޭރުކޮށްފި.",
        "publish": "ވަރޝަން ޝާއިޢުކޮށްފި.",
        "lock": "ވަރޝަން ތަޅުލައިފި.",
        "explain": "ތަފްޞީލު ރައްކާކޮށްފި.",
        "lines": "ލައިންތައް ރައްކާކޮށްފި."
      },
      "failed": {
        "newVersion": "ވަރޝަން ނުއުފެއްދުނު",
        "submit": "ވަރޝަން ހުށަނޭޅުނު",
        "approve": "ވަރޝަން ފާހެއް ނުކުރެވުނު",
        "reject": "ވަރޝަން ބޭރެއް ނުކުރެވުނު",
        "publish": "ވަރޝަން ޝާއިޢެއް ނުކުރެވުނު",
        "lock": "ވަރޝަން ތަޅެއް ނުލެވުނު"
      },
      "varianceTitle": "ފަހުގެ ޝާއިޢުކުރެވުނު ވަރޝަނާ އަޅާބަލާއިރު ބަދަލު",
      "varianceDescription": "ބަދަލެއް މުހިއްމުވަނީ ޕްރޮޕަޓީން ކަނޑައަޅާފައިވާ ޢަދަދުގެ އަދި އިންސައްތައިގެ ދެ ބޯޑަރު ވެސް ފަހަނައަޅާ ދިޔައީމައެވެ.",
      "unexplained": "{count} މުހިއްމު ބަދަލަކަށް އަދިވެސް ތަފްޞީލެއް ބޭނުންވެއެވެ:",
      "allExplained": "މުހިއްމު {count} ބަދަލަށް ތަފްޞީލު ދެވިފައިވެއެވެ.",
      "noMaterialMovement": "ފަހުގެ ޝާއިޢުކުރެވުނު ވަރޝަނާ އަޅާބަލާއިރު މުހިއްމު ބަދަލެއް އައިސްފައެއް ނުވެއެވެ.",
      "bandAbs": "މުހިއްމުވާ ޢަދަދު",
      "bandPct": "އަދި ބަދަލުގެ ނިސްބަތް",
      "priorRevenue": "ކުރީގެ އާމްދަނީ",
      "newRevenue": "އައު އާމްދަނީ",
      "delta": "ބަދަލު",
      "explanation": "ތަފްޞީލު",
      "explain": "ތަފްޞީލު ދޭ",
      "explainNotPermitted": "ވަރިއަންސް ބަޔާންކުރުމުގެ ހުއްދަ ތިޔަ އެކައުންޓަށް ނެތެވެ",
      "explainTitle": "މި ބަދަލުގެ ތަފްޞީލު",
      "reason": "ސަބަބު",
      "reasonRequired": "ސަބަބުގެ ކޯޑެއް ހޮވާ.",
      "recordExplanation": "ތަފްޞީލު ރައްކާކުރޭ",
      "publishBlocked": "ކޮންމެ މުހިއްމު ބަދަލަކަށް ތަފްޞީލު ދެވެންދެން ޝާއިޢުކުރެވޭކަށް ނެތެވެ: {count} ބާކީ.",
      "linesTitle": "ލައިންތައް",
      "linesEditable": "މި ވަރޝަނަކީ ޑްރާފްޓެއް ކަމުން، ލައިންތައް އަދިވެސް ބަދަލުކުރެވޭނެއެވެ.",
      "linesFrozen": "މި ވަރޝަން ފްރީޒްކޮށްފައި: އޭގެ ލައިންތަކަކީ ޝާއިޢުކުރެވުނު އެއްޗެއްގެ ރެކޯޑެވެ.",
      "editLines": "ލައިންތައް އުނިއިތުރުކުރޭ",
      "addLine": "ލައިނެއް އިތުރުކުރޭ",
      "lineFieldsRequired": "ކޮންމެ ލައިނަކަށް ތާރީޚަކާއި، ސެގްމަންޓަކާއި، ސްޓްރީމެއް ބޭނުންވެއެވެ.",
      "adrServerSide": "ހިސާބުކުރެވޭ",
      "noLinesTitle": "މި ވަރޝަނުގައި ލައިނެއް ނެތް",
      "noLinesDescription": "ޑްރާފްޓް ވަރޝަނަކަށް ލައިން އިތުރުކޮށް، ދެން ފާސްކުރުމަށް ހުށަހަޅާ.",
      "editHeader": "ލަފާކުރުން އުނިއިތުރުކުރޭ",
      "headerSaved": "ލަފާކުރުން އަޕްޑޭޓްކުރެވިއްޖެ",
      "headerSaveFailed": "ލަފާކުރުން އަޕްޑޭޓެއް ނުކުރެވުނު",
      "nameRequired": "ލަފާކުރުމަކަށް ނަމެއް ބޭނުންވޭ.",
      "retire": "ރިޓަޔަރކުރޭ",
      "reactivate": "އަލުން ހިންގާ",
      "retired": "ލަފާކުރުން ރިޓަޔަރކުރެވިއްޖެ",
      "reactivated": "ލަފާކުރުން އަލުން ހިނގަން ފަށައިފި",
      "retiredNote": "މި ލަފާކުރުން ރިޓަޔަރކުރެވިފައި. ޝާއިޢުކުރި ވަރޝަންތައް ކިޔޭނެ އަދި ސައްޙަކަން ބެލި ހިސާބުތައް ބަދަލެއް ނުވާނެ، އެކަމަކު ކޮމަރޝަލް ރިޕޯޓަށް ދެން ނުދާނެ."
    },
    "accuracy": {
      "title": "ލަފާކުރުމުގެ ސައްޙަކަން",
      "description": "ކޮންމެ ޕޮއިންޓެއް ވަޒަންކުރެވެނީ ޝާއިޢުކުރި ވަގުތު ހުރި ލަފާކުރުމާ އަޅާބަލައިގެންނެވެ. މިހާރުގެ ވަރޝަނާ އަޅާބަލައިގެނެއް ނޫނެވެ.",
      "run": "ސައްޙަކަން ހިސާބުކުރޭ",
      "ran": "ސައްޙަކަން ހިސާބުކޮށް ނިމިއްޖެ.",
      "rangeRequired": "ވަޒަންކުރާ ދެ ތާރީޚް ބޭނުންވެއެވެ.",
      "forecast": "ލަފާކުރުން",
      "actual": "ޙަޤީޤީ",
      "scored": "ވަޒަންކުރި މުއްދަތު",
      "scoredFrom": "ވަޒަންކުރުން ފެށޭ",
      "scoredTo": "ވަޒަންކުރުން ނިމޭ",
      "startedAt": "ފެށި ވަގުތު",
      "lineCount": "ލައިން",
      "runsTitle": "ރަންތައް",
      "byHorizonTitle": "ހޮރައިޒަން އިން",
      "byHorizonDescription": "ކޮންމެ ލީޑް ޓައިމަކަށް އެއް ރޯ، އެއީ 30 ދުވަހުގައި ރަނގަޅު އަދި 90 ދުވަހުގައި ދޯދިޔާ ލަފާކުރުމެއް އެވްރެޖެއްގެ ފުރަގަހުގައި ނުފޮރުވޭނެ ގޮތަށެވެ.",
      "horizon": "ހޮރައިޒަން",
      "horizonDays": "{days} ދުވަސް ކުރިން",
      "n": "ވަޒަންކުރި ޕޮއިންޓް",
      "mapeN": "އިންސައްތަ ހުރި ޕޮއިންޓް",
      "mape": "އެމްއޭޕީއީ",
      "mae": "އެމްއޭއީ",
      "bias": "ބަޔަސް",
      "nNote": "އެ ލީޑް ޓައިމުގައި ޝާއިޢުކުރެވުނު ވަރޝަނެއް ނެތް ތާރީޚެއް ދޫކޮށްލެވި، ގުނާލެވެއެވެ. އެހެންކަމުން ދެ ޢަދަދު ތަފާތުވަނީ ގަސްދުގައެވެ.",
      "chartTitle": "ލަފާކުރުމާއި ޙަޤީޤަތް",
      "chartAria": "ތާރީޚުން ލަފާކުރި އަދި ޙަޤީޤީ ސާފު އާމްދަނީ",
      "pointStamp": "{date} ގެ ލަފާކުރުން، {horizon} ދުވަސް ކުރިން، ވަރޝަން {version} — ލަފާ {forecast}، ޙަޤީޤަތް {actual}",
      "linesTitle": "ވަޒަންކުރި ލައިންތައް",
      "asPublished": "ޝާއިޢުކުރި ގޮތަށް",
      "absoluteError": "އެބްސޮލިއުޓް އެރަރ",
      "ape": "އިންސައްތަ އެރަރ",
      "noLinesTitle": "މި ހޮރައިޒަނުގައި ވަޒަންކުރި ލައިނެއް ނެތް",
      "noLinesDescription": "އެހެން ހޮރައިޒަނެއް ހޮވާ، ނުވަތަ ފުޅާ މުއްދަތެއް ވަޒަންކުރައްވާ.",
      "loadFailed": "ސައްޙަކަމުގެ ރަންތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ސައްޙަކަމުގެ ރަނެއް ނެތް",
      "emptyDescription": "ސައްޙަކަން ވަޒަންކުރެވެނީ އެދުމުން ނުވަތަ ކޮންމެ ރެއަކު، މާޒީވެފައިވާ ތާރީޚުތަކެއްގެ މައްޗަށެވެ."
    },
    "hurdles": {
      "title": "ހަރޑްލް ރޭޓްތައް",
      "description": "ހަރޑްލްއަކީ ޕްރައިސިން އިންޖީނުން އުފެއްދި އަގަކަށް ދެވޭ ޓެސްޓެކެވެ. އެއީ އަގެއް ނޫނެވެ، އަދި އެއިން އެއްވެސް އަގެއް ނުދެއެވެ.",
      "new": "އައު ހަރޑްލް",
      "activeOnly": "ހިނގަމުންދާ އެކަނި",
      "narrowing": "ހިނގާ ދާއިރާ",
      "narrowHint": "ހުރިހާ އެއްޗަކަށް ހިނގުމަށް ހުސްކޮށް ބާއްވާ",
      "anySegment": "ކޮންމެ ސެގްމަންޓެއް",
      "anyRoomType": "ކޮންމެ ބާވަތެއް",
      "anyDate": "ކޮންމެ ތާރީޚެއް",
      "dateFrom": "ފެށޭ",
      "dateTo": "ނިމޭ",
      "minAdr": "އެންމެ ދަށް އޭޑީއާރް",
      "minAdrRequired": "އެންމެ ދަށް އޭޑީއާރް ބޭނުންވެއެވެ.",
      "minContribution": "އެންމެ ދަށް ކޮންޓްރިބިއުޝަން",
      "tier": "ޓިއަރ",
      "note": "ނޯޓް",
      "everyDay": "ކޮންމެ ދުވަހަކު",
      "days": {
        "legend": "ހަފުތާގެ ދުވަސްތައް",
        "sun": "އާދިއްތަ",
        "mon": "ހޯމަ",
        "tue": "އަންގާރަ",
        "wed": "ބުދަ",
        "thu": "ބުރާސްފަތި",
        "fri": "ހުކުރު",
        "sat": "ހޮނިހިރު"
      },
      "noDays": "އެއްވެސް ދުވަހަކަށް ނުހިނގާ ހަރޑްލްއެއް އެއްވެސް އެއްޗަކަށް ނުހިނގާނެއެވެ. އޭގެ ބަދަލުގައި ހުއްޓާލައްވާ.",
      "created": "ހަރޑްލް އުފެއްދިއްޖެ.",
      "removed": "ހަރޑްލް ނަގައިފި.",
      "removeFailed": "ހަރޑްލް ނުނެގުނު",
      "loadFailed": "ހަރޑްލްތައް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "މި ޕްރޮޕަޓީއަށް ހަރޑްލްއެއް ނެތް",
      "emptyDescription": "ހަރޑްލްއެއް ނެތި، ޑިސްޕްލޭސްމަންޓް ވަޒަންކުރުމުން ސާފު ފައިދާ ދައްކާނެ ނަމަވެސް ރޭޓަށް އެއްވެސް ފްލޯއެއް ނުހިނގާނެއެވެ.",
      "testerTitle": "ހިނގަނީ ކޮން ހަރޑްލްއެއް؟",
      "testerDescription": "ހޮވުން ހިނގަނީ ހަތް ޓިއަރގައި އެންމެ ޚާއްޞަ އެއްޗެއް ފުރަތަމަ، އަދި އެއްވަރުވެއްޖެނަމަ އައިޑީއިންނެވެ. އެހެންވެ ހަމަ އެކަނި އެއް ހަރޑްލްއެއް ކާމިޔާބުކުރެއެވެ.",
      "testerFailed": "ޓެސްޓަރަށް ހަރޑްލްއެއް ނުހޮވުނު",
      "winner": "{narrowing} ކާމިޔާބުކުރެއެވެ، ޓިއަރ {tier} ގައި.",
      "noWinner": "މި ތާރީޚަށް އެއްވެސް ހަރޑްލްއެއް ނުހިނގައެވެ.",
      "candidates": "ދިމާވި ހުރިހާ ހަރޑްލްއެއް",
      "outcome": "ނަތީޖާ",
      "wins": "ކާމިޔާބު",
      "lessSpecific": "ޢާއްމު"
    },
    "displacements": {
      "title": "ޑިސްޕްލޭސްމަންޓް ވަޒަންކުރުންތައް",
      "description": "މި ގްރޫޕުން ބޭރުކުރާ ޓްރާންޒިއަންޓް ވިޔަފާރިއަށްވުރެ އެ ގްރޫޕުގެ އަގު ބޮޑުތޯ. ސާވަރުން ދެ ފަރާތުގެ ސާފު ފައިދާއިން ޖަວާބުދެއެވެ.",
      "evaluate": "ގްރޫޕެއް ވަޒަންކުރޭ",
      "evaluateDescription": "ވަޒަންކުރުމަކީ ނިންމުމެއް ނޫނެވެ: އެއީ ދެ ހުއްދައެކެވެ، އަދި އެއް މީހަކު ދެ ކަންތައް ކުރާކަށް ނުޖެހެއެވެ.",
      "enquiry": "އެދުން",
      "arrival": "އަރައިވަލް",
      "departure": "ފުރާ ދުވަސް",
      "arrivalFrom": "އަރައިވަލް ފެށޭ",
      "arrivalTo": "އަރައިވަލް ނިމޭ",
      "offeredAdr": "ހުށަހެޅި އޭޑީއާރް",
      "rooms": "ކޮޓަރި",
      "roomsRequested": "އެދިފައިވާ ކޮޓަރި",
      "addRoomType": "ކޮޓަރީގެ ބާވަތެއް އިތުރުކުރޭ",
      "groupAncillaryRate": "ގްރޫޕުގެ އެންސިލަރީ، ރޫމް އާމްދަނީގެ %",
      "groupDirectCostRate": "ގްރޫޕުގެ ސީދާ ޚަރަދު، ރޫމް އާމްދަނީގެ %",
      "displacedAncillaryRate": "ބޭރުވާ އެންސިލަރީ، ރޫމް އާމްދަނީގެ %",
      "displacedDirectCostRate": "ބޭރުވާ ސީދާ ޚަރަދު، ރޫމް އާމްދަނީގެ %",
      "rateHint": "8.75% އަށް 8.75 ލިޔުއްވާ. ހުސްކޮށް ބާއްވައިފިނަމަ ޕްރޮޕަޓީގެ ޑިފޯލްޓް ބޭނުންކުރެވެއެވެ.",
      "rateRange": "އިންސައްތަ 0 އާއި 500 އާ ދެމެދު ހުންނަންވާނެއެވެ.",
      "fieldsRequired": "ސެގްމަންޓަކާއި، ދެ ތާރީޚާއި، ހުށަހެޅި އޭޑީއާރަކާއި، މަދުވެގެން އެއް ބާވަތުގެ ކޮޓަރި ބޭނުންވެއެވެ.",
      "evaluationNo": "ވަޒަންކުރުން",
      "draftRef": "ޑްރާފްޓް #{id}",
      "stay": "ހުންނަ މުއްދަތު",
      "groupRoomNights": "ގްރޫޕުގެ ރޫމް ނައިޓްސް",
      "netBenefit": "ސާފު ފައިދާ",
      "hurdle": "ހަރޑްލް",
      "hurdleMet": "ހަރޑްލް ފުރިހަމަ",
      "hurdleMissed": "ހަރޑްލްއަށްވުރެ ދަށް",
      "noHurdle": "ހަރޑްލްއެއް ނުހިނގާ",
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "evaluated": "ވަޒަންކޮށްފައި",
        "accepted": "ޤަބޫލުކޮށްފައި",
        "declined": "ދޫކޮށްލާފައި",
        "countered": "ކައުންޓަރކޮށްފައި",
        "withdrawn": "އަނބުރާ ގެންގޮސްފައި",
        "lapsed": "މުއްދަތު ހަމަވެފައި"
      },
      "loadFailed": "ވަޒަންކުރުންތައް ލޯޑެއް ނުކުރެވުނު",
      "detailFailed": "ވަޒަންކުރުން ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ޑިސްޕްލޭސްމަންޓް ވަޒަންކުރުމެއް ނެތް",
      "emptyDescription": "ގްރޫޕުގެ އެދުމެއް ވަޒަންކޮށް، އެއިން ބޭރުކުރާ ވިޔަފާރިއާ އަޅާބަލާއިރު އޭގެ އަގު ބައްލަވާ.",
      "measureOutcomes": "ނަތީޖާ މިނާ",
      "measured": "{considered} ގެ ތެރެއިން {measured} މިނައިފި، {skipped} ދޫކޮށްލައިފި.",
      "measureFailed": "ނަތީޖާ ނުމިނުނު",
      "detailSubtitle": "{enquiry}، {from} އިން {to} އަށް",
      "basisSnapshot": "އަޅާބެލި އެއްޗެއް",
      "snapshotRef": "ސްނެޕްޝޮޓް {id}",
      "noSnapshotBasis": "ސްނެޕްޝޮޓެއް ނެތް",
      "outcomeDue": "ނަތީޖާ ބަލާ ތާރީޚް",
      "summaryTitle": "ދެ ފަރާތް",
      "measure": "މިނުން",
      "groupArm": "ގްރޫޕް",
      "displacedArm": "ބޭރުވާ ވިޔަފާރި",
      "roomNights": "ރޫމް ނައިޓްސް",
      "roomRevenue": "ކޮޓަރީގެ އާމްދަނީ",
      "ancillaryRevenue": "އެންސިލަރީ އާމްދަނީ",
      "directCost": "ސީދާ ޚަރަދު",
      "netValue": "ސާފު އަގު",
      "nightsTitle": "ރެއަކުން ރެއަކަށް",
      "nightsDescription": "ގްރޫޕުން ނަގާ އެއްޗަކާއި ބޭރުކުރާ އެއްޗެއް، އަދި ބޭރުވާ ކޮންމެ ރޭޓެއްގެ އަސާސް އޭގެ ރޯގައި.",
      "requested": "އެދިފައި",
      "accommodated": "ދެވުނު",
      "displaced": "ބޭރުވި",
      "displacedAdr": "ބޭރުވި އޭޑީއާރް",
      "basis": "އަސާސް",
      "bases": {
        "otb": "މިނެފައި (ފޮތުގައި)",
        "forecast": "ލަފާކުރުން",
        "rate_plan": "ބެލެވިފައި (ރޭޓް ޕްލޭން)"
      },
      "reEvaluate": "މިއަދާ އަޅާބަލައި އަލުން ވަޒަންކުރޭ",
      "reEvaluated": "މިއަދުގެ ސްނެޕްޝޮޓާ އަޅާބަލައި އަލުން ވަޒަންކޮށްފި.",
      "reEvaluateFailed": "ވަޒަންކުރުން އަލުން ނުހިންގުނު",
      "outcomeTitle": "ލަފާކުރުމާއި ނަތީޖާ",
      "result": "ނަތީޖާ",
      "results": {
        "materialised": "ފުރިހަމަވި",
        "partly_materialised": "ބައެއް ފުރިހަމަވި",
        "no_show": "ނާދޭ",
        "declined_and_filled": "ދޫކޮށްލައި ފުރުނު",
        "declined_and_unsold": "ދޫކޮށްލައި ނުވިކުނު",
        "unmeasurable": "ނުމިނޭ"
      },
      "unmeasurableExplained": "ގްރޫޕް ބްލޮކަކަށް ނުވި އެދުމެއް ވަޒަނެއް ނުކުރެވޭނެއެވެ. އެހެންކަމުން މި ނަތީޖާ ކުށެއްގެ ގޮތުގައި ނުގުނައި، ސައްޙަކަމުގެ ހުރިހާ ޢަދަދަކުން ބާކީކުރެވެއެވެ.",
      "predicted": "ލަފާކުރި ސާފު ފައިދާ",
      "realised": "ލިބުނު ސާފު ފައިދާ",
      "outcomeVariance": "ތަފާތު",
      "measuredOn": "މިނި ތާރީޚް",
      "noOutcomeTitle": "އަދި ނަތީޖާ ނުމިނޭ",
      "noOutcomeDescription": "ނަތީޖާ މިނެވޭނީ {date} ގެ ފަހުންނެވެ.",
      "decisionTitle": "ނިންމުން",
      "decisionDescription": "ޤަބޫލުކުރޭ، ދޫކޮށްލާ ނުވަތަ ކައުންޓަރކުރޭ. ސަބަބެއް ނެތް ނިންމުމަކީ އެއްވެސް މީހަކަށް މުރާޖަޢާ ނުކުރެވޭނެ ނިންމުމެކެވެ.",
      "decision": "ނިންމުން",
      "decisionStatus": "ނިންމުނު ގޮތް",
      "reason": "ސަބަބު",
      "reasonRequired": "ސަބަބުގެ ކޯޑެއް ހޮވާ.",
      "counteredAdr": "ކައުންޓަރކުރި އަގު",
      "counterRequired": "ކައުންޓަރކުރާއިރު، ކައުންޓަރކުރި ރޭޓް ބަޔާންކުރަން ޖެހެއެވެ.",
      "note": "ނޯޓް",
      "decidedAt": "ނިންމި ވަގުތު",
      "recordDecision": "ނިންމުން ރައްކާކުރޭ",
      "decided": "ނިންމުން ރައްކާކޮށްފި.",
      "overrideNeeded": "މި ރޭޓް ހަރޑްލްއަށްވުރެ ދަށެވެ. އެހެންވިޔަސް ޤަބޫލުކުރުމަކީ ކޮންޓްރޯލެއް އޯވަރައިޑްކުރުމެވެ، އަދި އޭގެ އަމިއްލަ ސަބަބެއް ބޭނުންވެއެވެ.",
      "overrideReason": "އޯވަރައިޑްގެ ސަބަބު",
      "decideNotPermitted": "ޑިސްޕްލޭސްމަންޓް ވަޒަންކުރުމެއް ނިންމުމަށް rvm.displacement.decide ބޭނުންވެއެވެ. އެ ހުއްދަ ވަޒަންކުރުމުގެ ހުއްދައާ ވަކިކޮށްފައިވަނީ ގަސްދުގައެވެ."
    },
    "competitors": {
      "title": "ވާދަވެރިންގެ ރޭޓްތައް",
      "description": "މީހަކު ދުށް ރޭޓްތައް، ދުށް ދުވަހުގައި.",
      "provenance": "ރޭޓްތައް ވެއްދެނީ އަތުން، ނުވަތަ ޝީޓަކުން އިމްޕޯޓްކޮށްގެންނެވެ. މި ޕްރޮޑަކްޓުން އެއްވެސް ތަނަކުން ވާދަވެރިންގެ ރޭޓް ނުނަގަނީ ގަސްދުގައެވެ.",
      "record": "ރޭޓެއް ރައްކާކުރޭ",
      "competitor": "ވާދަވެރިޔާ",
      "roomTypeLabel": "އެމީހުން ކިޔާ ކޮޓަރީގެ ބާވަތް",
      "rate": "ރޭޓް",
      "observedOn": "ދުށް ތާރީޚް",
      "observedHint": "ޚާލީނަމަ ޕްރޮޕަޓީގެ ގަޑިން މިއަދު",
      "source": "މަޞްދަރު",
      "sources": {
        "manual": "އަތުން",
        "csv": "އިމްޕޯޓް"
      },
      "fieldsRequired": "ވާދަވެރިޔަކާއި، ތާރީޚަކާއި، ރޭޓެއް ބޭނުންވެއެވެ.",
      "recorded": "ރޭޓް ރައްކާކޮށްފި.",
      "removed": "ރޭޓް ނަގައިފި.",
      "removeFailed": "ރޭޓް ނުނެގުނު",
      "loadFailed": "ވާދަވެރިންގެ ރޭޓް ލޯޑެއް ނުކުރެވުނު",
      "emptyTitle": "އަދި ވާދަވެރިއެއްގެ ރޭޓް ފެނިފައެއް ނެތް",
      "emptyDescription": "އަތުން އެއް ރޭޓް ރައްކާކުރައްވާ، ނުވަތަ ރޭޓް ޝީޓެއް ތަތްކޮށް، އޭގެ ކޮލަމްތައް މެޕްކުރައްވާ.",
      "import": "ޝީޓެއް އިމްޕޯޓްކުރޭ",
      "importDescription": "ކޮލަމް ނަންބަރު ފެށެނީ ސުމަކުންނެވެ. މެޕިން މި ޑިވައިސްގައި ހަނދާން ބެހެއްޓެއެވެ، އެއީ އެއް މަޞްދަރެއްގެ ޝީޓުގައި ކޮންމެ ހަފުތާއަކު އެއް ކޮލަމްތަކެއް ހުންނާތީއެވެ.",
      "colCompetitor": "ވާދަވެރިޔާގެ ކޮލަމް",
      "colStayDate": "ތާރީޚުގެ ކޮލަމް",
      "colRate": "ރޭޓްގެ ކޮލަމް",
      "colRoomType": "ކޮޓަރީގެ ބާވަތުގެ ކޮލަމް",
      "colCurrency": "ފައިސާގެ ކޮލަމް",
      "colObservedOn": "ދުށް ތާރީޚުގެ ކޮލަމް",
      "colOmit": "ދޫކޮށްލުމަށް -1",
      "delimiter": "ވަކިކުރާ ފާހަގަ",
      "hasHeader": "ފުރަތަމަ ރޯއަކީ ސުރުޚީ",
      "csv": "ޝީޓް ތަތްކުރައްވާ",
      "csvHint": "ސްޕްރެޑްޝީޓަކުން ނެގި ގޮތަށް، ކޮމާއިން ވަކިކުރެވިފައިވާ ރޯތައް",
      "csvRequired": "ފުރަތަމަ ޝީޓް ތަތްކުރައްވާ.",
      "preview": "ކުރިން ބަލާ",
      "commit": "{count} ރޯ އިމްޕޯޓްކުރޭ",
      "previewSummary": "{read} ރޯ ކިޔައިފި، {valid} ސައްޙަ، {duplicate} ކުރިންވެސް ރައްކާކުރެވިފައި. ބެޗް:",
      "imported": "{count} ރޯ އިމްޕޯޓްކޮށްފި.",
      "errors": "ބަލައިނުގަނެވޭނެ ރޯތައް",
      "line": "ލައިން",
      "column": "ކޮލަމް",
      "problem": "މައްސަލަ",
      "chartTitle": "ރޭޓްތައް އަޅާކިޔުން",
      "chartAria": "ތާރީޚުން ފެނިފައިވާ ވާދަވެރިންގެ ރޭޓް"
    },
    "commercial": {
      "title": "ދުވަހުގެ ކޮމަރޝަލް ރިޕޯޓް",
      "description": "އެއް ޕްރޮޕަޓީ، އެއް ވިޔަފާރި ތާރީޚް: ޙަޤީޤަތުގައި ވީ ކަންތައް، ކުރިއަށް ފޮތުގައިވާ މިންވަރު، އަދި ހޯދުމަށް ހިނގި ޚަރަދު.",
      "businessDate": "ވިޔަފާރި ތާރީޚް",
      "dateHint": "ތާރީޚުތައް ލިބެނީ ޕްރޮޕަޓީގެ އަމިއްލަ ސްނެޕްޝޮޓް ސިލްސިލާއިންނެވެ",
      "loadFailed": "ކޮމަރޝަލް ރިޕޯޓް ލޯޑެއް ނުކުރެވުނު",
      "noSnapshotDescription": "މި ރިޕޯޓުން ފޮތުގައިވާ އަދަދުތައް ނަގަނީ އެންމެ ފަހު ސްނެޕްޝޮޓުންނެވެ، އަދި މި ޕްރޮޕަޓީގައި އަދި ސްނެޕްޝޮޓެއް ނެތެވެ.",
      "actualOccupancy": "އޮކިއުޕަންސީ",
      "actualOccupancyHelp": "ވިޔަފާރި ތާރީޚުގައި ޙަޤީޤަތުގައި ބޭނުންކުރެވުނު ކޮޓަރި.",
      "actualAdr": "އޭޑީއާރް",
      "actualRevpar": "ރެވްޕާރ",
      "acquisitionCost": "ހޯދުމުގެ ޚަރަދު",
      "acquisitionHelp": "މި ވިޔަފާރި ތާރީޚުގައި އެކްރޫވި ކޮމިޝަން.",
      "netAdr": "ސާފު އޭޑީއާރް",
      "netAdrHelp": "ހޯދުމުގެ ޚަރަދު ކެނޑުމަށްފަހު އޭޑީއާރް، ސާވަރުން ހިސާބުކޮށްފައި.",
      "roomsOccupied": "ބޭނުންކުރެވުނު ކޮޓަރި",
      "ofCapacity": "ގެ ތެރެއިން",
      "onTheBooksTitle": "ކުރިއަށް ފޮތުގައި",
      "onTheBooksDescription": "އެންމެ ފަހު ސްނެޕްޝޮޓުން، ކުރިއަށް އޮތް ހަތް، ތިރީސް އަދި ނުވަދިހަ ރޭ.",
      "horizon": "ހޮރައިޒަން",
      "noHorizonsTitle": "މި ސްނެޕްޝޮޓުގައި ކުރިއަށް މުއްދަތެއް ނެތް",
      "noHorizonsDescription": "ސްނެޕްޝޮޓުގެ ހޮރައިޒަން ނިމެނީ ކުރިއަށް އޮތް ހަތް ރޭގެ ކުރިންނެވެ.",
      "segmentTitle": "ސެގްމަންޓުން އާމްދަނީ",
      "noSegmentsTitle": "ސެގްމަންޓުން އާމްދަނީއެއް ނެތް",
      "noSegmentsDescription": "މި ޕްރޮޕަޓީގައި ކަނޑައަޅާފައިވާ ސެގްމަންޓްތަކަށް ފޮތުގައި އެއްވެސް އެއްޗެއް ނެތެވެ.",
      "againstTitle": "މިދިޔަ އަހަރާއި ލަފާކުރުމާ އަޅާބަލައި",
      "priorYear": "މިދިޔަ އަހަރުގެ އެ ލީޑް ޓައިމް",
      "noPriorYear": "އަހަރެއް ކުރީގެ އެ ލީޑް ޓައިމަށް ސްނެޕްޝޮޓެއް ނެތެވެ.",
      "forecast": "ޝާއިޢުކުރެވުނު ލަފާކުރުން",
      "noForecast": "މި ތާރީޚް ހިމެނޭ ޝާއިޢުކުރެވުނު ލަފާކުރުމެއް ނެތެވެ.",
      "varianceVsForecast": "ލަފާކުރުމާ އަޅާބަލައި",
      "streamTitle": "ސްޓްރީމް ބައިވަރު އާމްދަނީ",
      "streamDescription": "މި ވިޔަފާރި ތާރީޚުގައި ލިބުނު ސާފު އާމްދަނީ، ކޮންމެ ސްޓްރީމެއްގެ އަމިއްލަ ރެވެނިއު ސެންޓަރު އަދި އައުޓްލެޓް މެދުވެރިކޮށް — އަދި އެ ސްޓްރީމަށް ޝާއިޢުކުރި ލަފާކުރުމާ އެކުގައި.",
      "actualRevenue": "އަސްލު އާމްދަނީ",
      "sources": "މަޞްދަރުތައް",
      "streamSources": "{centres} ރެވެނިއު ސެންޓަރު، {outlets} އައުޓްލެޓް",
      "streamUnmapped": "މަޞްދަރެއް ކަނޑައަޅާފައެއް ނުވޭ",
      "noStreamForecast": "ޝާއިޢުކުރި ލަފާކުރުމެއް ނެތް",
      "noStreamsTitle": "އަދި އާމްދަނީ ސްޓްރީމެއް ނެތް",
      "noStreamsDescription": "ސެގްމަންޓް އަދި ސްޓްރީމް ސްކްރީނުން ސްޓްރީމެއް އިތުރުކުރޭ، އަދި އޭގެ ތެރެއަށް އަންނަ ރެވެނިއު ސެންޓަރު އަދި އައުޓްލެޓް ކަނޑައަޅާ."
    },
    "settings": {
      "title": "ރެވެނިއު މެނޭޖްމަންޓް ސެޓިންގްސް",
      "description": "މި ޕްރޮޕަޓީގެ ސްނެޕްޝޮޓާއި ލަފާކުރުން ކުރިއަށް ދާ މުއްދަތު، މުހިންމު ބަދަލެއް ކަމަށް ބަލާ މިންވަރު، އަދި ހަރޑްލްއަށްވުރެ ދަށް ރޭޓެއް ދޫކުރެވޭނެތޯ.",
      "loadFailed": "ސެޓިންގްސް ނުލިބުނު",
      "saved": "ސެޓިންގްސް ރައްކާކުރެވިއްޖެ",
      "saveFailed": "ސެޓިންގްސް ރައްކާނުކުރެވުނު",
      "readOnly": "މި ސެޓިންގްސް ކިޔޭނެ، އެކަމަކު ބަދަލެއް ނުކުރެވޭނެ. ބަދަލުކުރަން rvm.settings.manage ބޭނުންވޭ.",
      "currentTitle": "މިހާރުގެ ސެޓިންގްސް",
      "horizonsTitle": "ހޮރައިޒަންތައް",
      "horizonsDescription": "ދެބައިވެސް 1,095 ދުވަހަށް (ތިން އަހަރު) ހަނިކުރެވިފައި. ހޮރައިޒަން ދިގުކުރުމުން ކުރީގެ ސްނެޕްޝޮޓް ބަދަލެއް ނުވާނެ، އަދި ޕޭސް އަޅާކިޔަނީ ދެ ސްނެޕްޝޮޓްގައިވެސް ހުރި ތާރީޚުތައް އެކަނި.",
      "snapshotHorizon": "ސްނެޕްޝޮޓް ހޮރައިޒަން",
      "snapshotHorizonHint": "މިރޭގެ ސްނެޕްޝޮޓް ކުރިއަށް ނަގާ ދުވަސްތަކުގެ އަދަދު.",
      "forecastHorizon": "ލަފާކުރުމުގެ ހޮރައިޒަން",
      "forecastHorizonHint": "ލަފާކުރުމުގެ ލައިނެއް ކުރިއަށް ލިޔެވޭނެ އެންމެ ދުރު މުއްދަތު.",
      "accuracyHorizons": "ސައްޙަކަން ބަލާ ހޮރައިޒަންތައް",
      "accuracyHorizonsHint": "ސައްޙަކަން ބަލާ ލީޑް ޓައިމްތައް، ދުވަހުން. ކޮމާއިން ވަކިކުރޭ.",
      "accuracyHorizonsNumber": "ކޮންމެ ހޮރައިޒަނަކީ ފުރިހަމަ އަދަދެއް ކަމުގައި ވާންޖެހޭ.",
      "horizonNumber": "ހޮރައިޒަނަކީ ފުރިހަމަ އަދަދެއް ކަމުގައި ވާންޖެހޭ.",
      "materialityTitle": "މުހިންމުކަން",
      "materialityDescription": "ލަފާކުރުމުގެ ބަދަލެއް މުހިންމުވަނީ ދެ މިންވަރުވެސް ފަހަނައަޅާ ދިޔައީމަ އެކަނި. އިންސައްތަ އެކަނި ބޭނުންކުރުމުން 40.00 ގެ 100% ބަދަލެއް މުހިންމުވެ، އަދަދު އެކަނި ބޭނުންކުރުމުން 3,000,000.00 ގެ 6,000.00 މުހިންމުވޭ.",
      "materialPct": "މުހިންމު ބަދަލު، އިންސައްތައިން",
      "materialPctHint": "10% އަށް 10 ލިޔުއްވާ.",
      "materialPctRange": "އިންސައްތަ 0 އާއި 100 އާ ދެމެދު ހުންނަންވާނެއެވެ.",
      "materialAbs": "މުހިންމު ބަދަލު، އަދަދުން",
      "materialAbsHint": "ޕްރޮޕަޓީގެ އަމިއްލަ ފައިސާއިން.",
      "behaviourTitle": "ގިންތިކުރުމާއި ތަންފީޒުކުރުން",
      "behaviourDescription": "ގިންތިނުކުރެވޭ ޑިމާންޑް ދާނެ ތަން، އަދި ރޭޓެއް ހަރޑްލްއަށްވުރެ ދަށްވެއްޖެނަމަ ވާނެ ގޮތް.",
      "unmappedSegment": "މެޕްނުކުރެވޭ ސެގްމަންޓް ކޯޑް",
      "unmappedSegmentHint": "އެއްވެސް ރޫލަކާ ނުގުޅޭ ބުކިން ގުނާ ތަން. އެއްވެސް އިރެއްގައި ދޫކޮށެއް ނުލެވޭ. މި ބަދަލުކުރުމުން ސެގްމަންޓް ވަގުތުން އުފެދޭނެ.",
      "unmappedRequired": "މެޕްނުކުރެވޭ ޑިމާންޑަށް ތަނެއް ބޭނުންވޭ — ސެގްމަންޓް ކޯޑެއް ދީ.",
      "hurdleEnforcement": "ހަރޑްލްއަށްވުރެ ދަށް ރޭޓްތައް",
      "hurdleEnforcementHint": "އިންޒާރު ދިނުމުން ނިންމުން ރެކޯޑްކޮށް، ސަބަބަކާއެކު ދޫކުރެވޭ. ހުއްޓުވުމުން މުޅިން ދޫނުކުރެވޭ.",
      "enforcement": {
        "warn": "އިންޒާރު ދީ ސަބަބު ރެކޯޑްކުރޭ",
        "block": "ރޭޓް ދޫނުކުރޭ"
      },
      "days": "{days} ދުވަސް"
    },
    "dimensions": {
      "title": "ސެގްމަންޓް އަދި ސްޓްރީމް",
      "description": "މި ކުންފުނިން ރިޕޯޓްކުރާ މާކެޓް ސެގްމަންޓްތައް، ބުކިންއެއް އެއަށް ގިންތިކުރާ ރޫލްތައް، އަދި ލަފާކުރުން ލިޔެވޭ އާމްދަނީ ސްޓްރީމްތައް.",
      "loadFailed": "ޑައިމެންޝަންތައް ނުލިބުނު",
      "readOnly": "މި ކިޔޭނެ، އެކަމަކު ބަދަލެއް ނުކުރެވޭނެ. ބަދަލުކުރަން rvm.dimension.manage ބޭނުންވޭ.",
      "code": "ކޯޑް",
      "name": "ނަން",
      "family": "ފެމިލީ",
      "families": {
        "transient": "ޓްރާންޒިއަންޓް",
        "group": "ގްރޫޕް",
        "contract": "ކޮންޓްރެކްޓް",
        "wholesale": "ހޯލްސޭލް",
        "complimentary": "ހިލޭ",
        "house": "ހައުސް"
      },
      "displacementRank": "ޑިސްޕްލޭސްމަންޓް ރޭންކް",
      "displacementRankHint": "އެންމެ ފުރަތަމަ ދޫކޮށްލާނެ ޑިމާންޑް. ދަށް އާމްދަނީ ފުރަތަމަ؛ އެއްވަރުވެއްޖެނަމަ ކޯޑުން ވަކިކުރެވޭ.",
      "rankNumber": "ޑިސްޕްލޭސްމަންޓް ރޭންކަކީ ފުރިހަމަ އަދަދެއް ކަމުގައި ވާންޖެހޭ.",
      "activate": "ހިންގާ",
      "deactivate": "ހުއްޓާލާ",
      "segmentsTitle": "މާކެޓް ސެގްމަންޓްތައް",
      "segmentsDescription": "ބުކިންގެ ސެގްމަންޓް ކޯޑަކީ ރިޒަވޭޝަނުގައި މިނިވަން ލިޔުމެއް؛ މިއީ ހުރިހާ RVM އަދަދެއް ގުނާ ރަސްމީ ސެގްމަންޓްތައް.",
      "newSegment": "އައު ސެގްމަންޓް",
      "segmentRequired": "ސެގްމަންޓަކަށް ކޯޑަކާއި ނަމެއް ބޭނުންވޭ.",
      "segmentCreated": "ސެގްމަންޓް އުފެއްދިއްޖެ",
      "segmentRemoved": "ސެގްމަންޓް ނަގައިފި",
      "segmentRemoveFailed": "ސެގްމަންޓް ނުނެގުނު",
      "segmentUpdateFailed": "ސެގްމަންޓް ބަދަލެއް ނުކުރެވުނު",
      "noSegmentsTitle": "އަދި ސެގްމަންޓެއް ނެތް",
      "noSegmentsDescription": "މި ކުންފުނިން ވިއްކާ ސެގްމަންޓްތައް އިތުރުކުރޭ — ޓްރާންޒިއަންޓް، ގްރޫޕް، ކޮންޓްރެކްޓް — އަދި ތިރީގައި ބުކިންތައް އެއަށް މެޕްކުރޭ.",
      "mappingsTitle": "މެޕިން ރޫލްތައް",
      "mappingsDescription": "ދައްކާފައިވާ ތަރުތީބުން، ބުކިންއަކާ ގުޅޭ ފުރަތަމަ ހިނގާ ރޫލް ކާމިޔާބުވޭ. އެއްވެސް ރޫލަކާ ނުގުޅޭ ބުކިން ދޫކޮށެއް ނުލެވޭ: އެ ދަނީ ރެވެނިއު ސެޓިންގްސްގައި ބުނާ މެޕްނުކުރެވޭ ސެގްމަންޓަށް.",
      "newMapping": "އައު ރޫލް",
      "targetSegment": "މެޕްކުރަނީ",
      "chooseSegment": "ސެގްމަންޓެއް ހޮވާ",
      "priority": "އިސްކަން",
      "priorityHint": "ދަށް އަދަދު ފުރަތަމަ ހިނގާ. އެއްވަރުވެއްޖެނަމަ އުފެއްދި ތަރުތީބުން ވަކިކުރެވޭ.",
      "priorityNumber": "އިސްކަމަކީ ފުރިހަމަ އަދަދެއް ކަމުގައި ވާންޖެހޭ.",
      "matches": "ގުޅެނީ",
      "matchHint": "ބޭނުންނުވާ ޝަރުޠެއް ހުސްކޮށް ބާއްވާ. މަދުވެގެން އެއް ޝަރުޠު ދޭންޖެހޭ.",
      "matchSegmentCode": "ރިޒަވޭޝަން ސެގްމަންޓް ކޯޑް",
      "matchMarketCode": "މާކެޓް ކޯޑް",
      "matchSourceCode": "ސޯސް ކޯޑް",
      "matchChannel": "ޗެނަލް",
      "anyChannel": "ކޮންމެ ޗެނަލެއް",
      "channelIdHint": "ޗެނަލް އައިޑީ ލިޔޭ. ނަމުން ހޮވަން pms.channel.read ދޭންޖެހޭ.",
      "mappingSegmentRequired": "ރޫލެއް މެޕްކުރާ ސެގްމަންޓް ބުނަންޖެހޭ.",
      "mappingCriterionRequired": "ރޫލަކަށް މަދުވެގެން އެއް ޝަރުޠު ބޭނުންވޭ، ނޫންނަމަ ހުރިހާ ބުކިންއެއް އެއަށް ދާނެ.",
      "mappingCreated": "ރޫލް އުފެއްދިއްޖެ",
      "mappingRemoved": "ރޫލް ނަގައިފި",
      "mappingRemoveFailed": "ރޫލް ނުނެގުނު",
      "mappingUpdateFailed": "ރޫލް ބަދަލެއް ނުކުރެވުނު",
      "noMappingsTitle": "އަދި މެޕިން ރޫލެއް ނެތް",
      "noMappingsDescription": "ރޫލެއް ނެތްނަމަ ހުރިހާ ބުކިންއެއް ދާނީ މެޕްނުކުރެވޭ ސެގްމަންޓަށް. ޗެނަލްތަކުން ފޮނުވާ ކޮންމެ ކޯޑަކަށް ރޫލެއް އިތުރުކުރޭ.",
      "criterion": {
        "segmentCode": "ސެގްމަންޓް {value}",
        "marketCode": "މާކެޓް {value}",
        "sourceCode": "ސޯސް {value}",
        "channel": "ޗެނަލް {value}"
      },
      "testerTitle": "މެޕިން ޓެސްޓަރ",
      "testerDescription": "ބުކިންއެއްގައި ހުންނާނެ ކޯޑްތައް ލިޔެ، އެ ދާނެ ސެގްމަންޓާއި، ރޫލަކުން އެ ހޮވިތޯ ބަލާ.",
      "testerFailed": "އެ ކޯޑްތައް ޓެސްޓަރަށް ނުހޮވުނު",
      "matched": "ރޫލަކާ ގުޅިއްޖެ: މި ބުކިން ގުނަނީ {code} — {name} ގައި.",
      "unmatched": "އެއްވެސް ރޫލަކާ ނުގުޅުނު. މި ބުކިން ގުނަނީ މެޕްނުކުރެވޭ ސެގްމަންޓް {code} — {name} ގައި. އެއްވެސް އެއްޗެއް ދޫކޮށެއް ނުލެވޭ، އެކަމަކު ރޫލެއް އުފައްދަންދެން އަދަދުތައް ފެންނާނީ ގިންތިނުކުރެވި.",
      "streamsTitle": "އާމްދަނީ ސްޓްރީމްތައް",
      "streamsDescription": "ލަފާކުރުމުގެ ލައިނެއް ލިޔެވޭ އަސާސް. ހަތަރު ކޯޑް އެކަނި؛ ސްޓްރީމެއްގެ އަސްލު މަޞްދަރުތަކުން އޭގެ ތެރެއަށް އަންނަ ރެވެނިއު ސެންޓަރާއި އައުޓްލެޓް ކަނޑައަޅާ.",
      "newStream": "އައު ސްޓްރީމް",
      "streamCodes": {
        "room": "ކޮޓަރި",
        "fnb": "ކެއުމާއި ބުއިން",
        "ancillary": "އިތުރު ޚިދުމަތް",
        "other": "އެހެނިހެން"
      },
      "streamCodeHint": "ހަތަރެއްގެ ތެރެއިން އެކެއް. ފަސްވަނަ އެއް ނެތް، އަދި ޓެނަންޓަކަށް އިތުރެއް ނުކުރެވޭ.",
      "streamRequired": "ސްޓްރީމަކަށް ނަމެއް ބޭނުންވޭ.",
      "streamCreated": "ސްޓްރީމް އުފެއްދިއްޖެ",
      "streamUpdateFailed": "ސްޓްރީމް ބަދަލެއް ނުކުރެވުނު",
      "actualSources": "އަސްލު މަޞްދަރުތައް",
      "noActualSources": "މެޕްކޮށްފައެއް ނުވޭ",
      "noStreamsTitle": "އަދި އާމްދަނީ ސްޓްރީމެއް ނެތް",
      "noStreamsDescription": "މަދުވެގެން ކޮޓަރީގެ ސްޓްރީމެއް އިތުރުކުރޭ. އެއާ ނުލައި ލަފާކުރުމަކަށް ލިޔެވޭނެ އަސާސެއް ނެތް."
    }
  },
  "notifications": {
    "routeTitles": {
      "inbox": "ނޯޓިފިކޭޝަންތައް"
    },
    "nav": {
      "description": "ސިސްޓަމުން ތިޔަބޭފުޅާއަށް އަންގާފައިވާ ހުރިހާ އެއްޗެއް، އެންމެ ފަހުގެ ފުރަތަމަ.",
      "keywords": "ނޯޓިފިކޭޝަން ބެލް އިންޒާރު މެސެޖް އިންބޮކްސް ނުކިޔާ"
    },
    "loadFailed": "ތިޔަބޭފުޅާގެ ނޯޓިފިކޭޝަންތައް ލޯޑެއް ނުވި",
    "markAllRead": "ހުރިހާ އެއްޗެއް ކިޔައިފިކަމަށް ފާހަގަކުރޭ",
    "allMarkedRead": "ހުރިހާ ނޯޓިފިކޭޝަނެއް ކިޔައިފިކަމަށް ފާހަގަކުރެވިއްޖެ",
    "dismissed": "ނޯޓިފިކޭޝަން ފޮރުވިއްޖެ",
    "actionFailed": "އެކަން ސޭވެއް ނުވި",
    "bell": {
      "label": "ނޯޓިފިކޭޝަންތައް، ނުކިޔާ {count}",
      "labelNone": "ނޯޓިފިކޭޝަންތައް، ނުކިޔާ އެއްޗެއް ނެތް",
      "status": "ނުކިޔާ {count} ނޯޓިފިކޭޝަން",
      "statusNone": "ނުކިޔާ ނޯޓިފިކޭޝަނެއް ނެތް"
    },
    "panel": {
      "title": "ނޯޓިފިކޭޝަންތައް",
      "label": "އެންމެ ފަހުގެ ނޯޓިފިކޭޝަންތައް",
      "close": "ނޯޓިފިކޭޝަންތައް ބަންދުކުރޭ",
      "viewAll": "ހުރިހާ ނޯޓިފިކޭޝަނެއް ބައްލަވާ",
      "emptyTitle": "އަދި އެއްވެސް އެއްޗެއް ނެތް",
      "emptyDescription": "ތިޔަބޭފުޅާއަށް ހަވާލުކުރެވޭ ފާސްކުރުންތައް، ޕޯސްޓްކުރެވޭ ލިޔުންތައް އަދި އިންޒާރުތައް މިތަނުގައި ފެންނާނެއެވެ."
    },
    "inbox": {
      "title": "ނޯޓިފިކޭޝަންތައް",
      "description": "ސިސްޓަމުން ތިޔަބޭފުޅާއަށް އަންގާފައިވާ ހުރިހާ އެއްޗެއް، އެންމެ ފަހުގެ ފުރަތަމަ. ނޯޓިފިކޭޝަނެއް ފޮރުވުމުން ފޮރުވެނީ މެސެޖެވެ، އެ އިޝާރާތްކުރާ ލިޔުމެއް ނޫނެވެ.",
      "filterLabel": "ދައްކާ",
      "filterAll": "ހުރިހާ",
      "filterUnread": "ނުކިޔާ އެކަނި",
      "emptyTitle": "އަދި ނޯޓިފިކޭޝަނެއް ނެތް",
      "emptyDescription": "ފާސްކުރުމެއް ތިޔަބޭފުޅާއަށް ލިބުމުން، ތިޔަބޭފުޅާ ބައްލަވާ ލިޔުމެއް ޕޯސްޓްކުރެވުމުން، ނުވަތަ ކަނޑައެޅި މިންވަރެއް ފަހަނައަޅައި ދިއުމުން މިތަނުގައި އެންގޭނެއެވެ. އީމެއިލުން ވެސް ލިބޭނެ ކަންކަން ކަނޑައަޅަނީ ނޯޓިފިކޭޝަން ސިޔާސަތުތަކުންނެވެ.",
      "unreadEmptyTitle": "ނުކިޔާ އެއްޗެއް ނެތް",
      "unreadEmptyDescription": "ހުރިހާ އެއްޗެއް ކިޔުއްވައިފިއެވެ. ތާރީޚު ބެއްލެވުމަށް ހުރިހާ އަށް އެނބުރި ވަޑައިގަންނަވާ."
    },
    "item": {
      "unread": "ނުކިޔާ",
      "noLink": "ގުޅިފައިވާ ރެކޯޑެއް ނެތް",
      "markReadFor": "“{title}” ކިޔައިފިކަމަށް ފާހަގަކުރޭ",
      "dismissFor": "“{title}” ފޮރުވާ"
    },
    "kinds": {
      "approvalAssigned": "ފާސްކުރުން ހަވާލުކުރެވިއްޖެ",
      "approvalReminded": "ފާސްކުރުމުގެ ހަނދާންކޮށްދިނުން",
      "approvalEscalated": "ފާސްކުރުން މައްޗަށް ފޮނުވިއްޖެ",
      "mention": "ނަން ގެނެވިއްޖެ",
      "system": "ސިސްޓަމް"
    },
    "severities": {
      "info": "މަޢުލޫމާތު",
      "success": "ކާމިޔާބު",
      "warning": "އިންޒާރު",
      "danger": "އަވަސް"
    }
  },
  "enterprise": {
    "businessUnits": {
      "title": "ބިޒްނަސް ޔުނިޓްތައް",
      "description": "މުޢާމަލާތްތައް ޕްރޮސެސްކޮށް ޑޭޓާ ސެކިއުރ ކުރާ އޮޕަރޭޝަނަލް ލެވެލް.",
      "create": "އައު ބިޒްނަސް ޔުނިޓް",
      "tableLabel": "ބިޒްނަސް ޔުނިޓް ރަޖިސްޓަރީ",
      "emptyTitle": "ގުޅޭ ބިޒްނަސް ޔުނިޓެއް ނެތް",
      "emptyDescription": "ބިޒްނަސް ޔުނިޓެއް ހައްދަވާ، ނުވަތަ ހުރިހާ ޔުނިޓެއް ފެނުމަށް ފިލްޓަރުތައް ފުހެލައްވާ.",
      "loadFailed": "ބިޒްނަސް ޔުނިޓްތައް ލޯޑެއް ނުކުރެވުނު",
      "search": "ހޯދާ",
      "searchHint": "ކޯޑް ނުވަތަ ނަން",
      "functionCount": "ފަންކްޝަން 0 | ފަންކްޝަން 1 | {count} ފަންކްޝަން",
      "columns": {
        "code": "ކޯޑް / ނަން",
        "legalEntity": "ޤާނޫނީ ފަރާތް",
        "functions": "ފަންކްޝަންތައް"
      },
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "pending": "ހިނގަމުންދާ",
        "active": "އެކްޓިވް",
        "inactive": "އިންއެކްޓިވް"
      },
      "fields": {
        "company": "ކުންފުނި",
        "code": "ކޯޑް",
        "name": "ނަން",
        "primaryLegalEntity": "މައިގަނޑު ޤާނޫނީ ފަރާތް",
        "defaultLocation": "ޑިފޯލްޓް ލޮކޭޝަން",
        "manager": "މެނޭޖަރ / ޖެނެރަލް މެނޭޖަރ",
        "division": "ޑިވިޜަން",
        "divisionHint": "މެނޭޖްމަންޓް ރޯލްއަޕަށް އެކަނި — ޕޯސްޓިންގ ނުވަތަ ސެކިއުރިޓީއަށް އަސަރެއް ނުކުރެއެވެ.",
        "ledger": "ލެޖަރ",
        "ledgerHint": "ޔުނިޓްގައި ސީދާ ބަނދެފައިވާ ލެޖަރ. ޑޮކިއުމަންޓް ބާވަތުން ސީކުއެންސިންގ ކަނޑައަޅަނީ ލެޖަރ އެލައިންމަންޓް ޓެބުންނެވެ."
      },
      "form": {
        "createTitle": "އައު ބިޒްނަސް ޔުނިޓް",
        "createDescription": "ކޯޑް، ނަން، ޤާނޫނީ ފަރާތުގެ ބައިންޑިންގ އަދި ޑިފޯލްޓް ލޮކޭޝަނާއެކު ބިޒްނަސް ޔުނިޓެއް ރަޖިސްޓަރ ކުރައްވާ (FSD 1.2.4.4).",
        "created": "ބިޒްނަސް ޔުނިޓް ހެދިއްޖެ",
        "createFailed": "ބިޒްނަސް ޔުނިޓް ހެދޭގޮތެއް ނުވިއެވެ"
      },
      "tabs": {
        "profile": "ޕްރޮފައިލް",
        "functions": "ބިޒްނަސް ފަންކްޝަންތައް",
        "serviceProviders": "ސަރވިސް ޕްރޮވައިޑަރުން",
        "referenceSets": "ރެފަރެންސް ސެޓްތައް",
        "ledgerAlignment": "ލެޖަރ އެލައިންމަންޓް",
        "securityScope": "ސެކިއުރިޓީ ސްކޯޕް"
      },
      "detail": {
        "oneTitle": "ބިޒްނަސް ޔުނިޓް",
        "oneDescription": "ޕްރޮފައިލް، ފަންކްޝަންތައް، ސަރވިސް ޕްރޮވައިޑަރ ގުޅުންތައް، ރެފަރެންސް ސެޓްތައް، ލެޖަރ އެލައިންމަންޓް އަދި ސެކިއުރިޓީ ސްކޯޕް.",
        "oneLoadFailed": "މި ބިޒްނަސް ޔުނިޓް ލޯޑެއް ނުކުރެވުނު",
        "tabsLabel": "ބިޒްނަސް ޔުނިޓް ތަފްޞީލު",
        "notFound": "މި ބިޒްނަސް ޔުނިޓް ނުފެނުނެވެ.",
        "backToList": "ބިޒްނަސް ޔުނިޓްތަކަށް އަނބުރާ",
        "activate": "އެކްޓިވޭޓް",
        "activated": "ބިޒްނަސް ޔުނިޓް އެކްޓިވޭޓްވެއްޖެ",
        "activateFailed": "ބިޒްނަސް ޔުނިޓް އެކްޓިވޭޓް ކުރެވޭގޮތެއް ނުވިއެވެ",
        "deactivate": "ޑިއެކްޓިވޭޓް",
        "deactivated": "ބިޒްނަސް ޔުނިޓް ޑިއެކްޓިވޭޓްވެއްޖެ",
        "deactivateTitle": "ބިޒްނަސް ޔުނިޓް ޑިއެކްޓިވޭޓް ކުރައްވާ",
        "deactivateDescription": "ހަވާލުކުރެވިފައިވާ ފަންކްޝަނެއްގައި ހުޅުވިފައިވާ މުޢާމަލާތެއް ހުރިނަމަ ހުއްޓުވޭނެ (F-BU.005). ހުއްޓުވިއްޖެނަމަ، ފަންކްޝަނާއި މޮޑިއުލް އަދި ޢަދަދު ދައްކައިދޭނެއެވެ.",
        "effectiveTo": "މުއްދަތު ހަމަވާ ތާރީޚް"
      },
      "rail": {
        "activated": "އެކްޓިވޭޓްކުރި",
        "deactivated": "ޑިއެކްޓިވޭޓްކުރި",
        "registerLink": "ބިޒްނަސް ޔުނިޓްތައް",
        "subtitle": "ފަންކްޝަން 0 ހަވާލުކޮށްފައި | ފަންކްޝަން 1 ހަވާލުކޮށްފައި | {functions} ފަންކްޝަން ހަވާލުކޮށްފައި"
      },
      "functions": {
        "title": "ބިޒްނަސް ފަންކްޝަންތައް",
        "description": "ޔުނިޓަކުން ބަޔާންކުރާ ފަންކްޝަންތަކުގެ މުޢާމަލާތްތައް އެކަނި ކުރެވޭނެ (F-BU.002).",
        "emptyTitle": "އަދި ފަންކްޝަނެއް ހަވާލުކޮށްފައެއް ނެތް",
        "emptyDescription": "މަދުވެގެން އެއް ބިޒްނަސް ފަންކްޝަން ހަވާލުނުކޮށް އެކްޓިވޭޓް ނުކުރެވޭނެއެވެ.",
        "assignTitle": "ފަންކްޝަނެއް ހަވާލުކުރައްވާ",
        "function": "ފަންކްޝަން",
        "selectFunction": "ފަންކްޝަނެއް ހޮއްވަވާ",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "effectiveTo": "މުއްދަތު ހަމަވާ ތާރީޚް",
        "assign": "ހަވާލުކުރައްވާ",
        "assigned": "ފަންކްޝަން ހަވާލުކުރެވިއްޖެ",
        "assignFailed": "ފަންކްޝަން ހަވާލުކުރެވޭގޮތެއް ނުވިއެވެ",
        "removeConfirm": "{code} މި ޔުނިޓުން ނަގާލަންތޯ؟ މި ފަންކްޝަނަށް ހުޅުވިފައިވާ މުޢާމަލާތެއް ހުރިނަމަ ހުއްޓުވޭނެ (F-BU.006).",
        "removed": "ފަންކްޝަން ނަގާލެވިއްޖެ",
        "removeFailed": "ފަންކްޝަން ނަގާލެވޭގޮތެއް ނުވިއެވެ"
      },
      "serviceProviders": {
        "title": "ސަރވިސް ޕްރޮވައިޑަރ ގުޅުންތައް",
        "description": "ޝެއަރޑް-ސަރވިސް ޔުނިޓަކުން ކްލައިންޓް ޔުނިޓަކަށް ފަންކްޝަނެއް ފޯރުކޮށްދެވޭނީ ފުރިހަމަ ގުޅުމެއް އޮވެގެންނެވެ (F-BU.003).",
        "emptyTitle": "ސަރވިސް ޕްރޮވައިޑަރ ގުޅުމެއް ނެތް",
        "emptyDescription": "ގުޅޭ ގުޅުމެއް ނެތް. ޝެއަރޑް-ސަރވިސް ޔުނިޓަކަށް އޭގެ ކްލައިންޓުންނަށް މަސައްކަތްކުރެވޭނެގޮތަށް ގުޅުމެއް ބަޔާންކުރައްވާ.",
        "loadFailed": "ސަރވިސް ޕްރޮވައިޑަރ ގުޅުންތައް ލޯޑެއް ނުކުރެވުނު",
        "registerTitle": "ސަރވިސް ޕްރޮވައިޑަރުން",
        "registerDescription": "ހުރިހާ ޝެއަރޑް-ސަރވިސް ގުޅުމެއް: ކޮން ޔުނިޓަކުން، ކޮން ކްލައިންޓް ޔުނިޓަކަށް، ކޮން ބިޒްނަސް ފަންކްޝަނެއް، ކޮން އިރަކު ފޯރުކޮށްދޭތޯ.",
        "businessUnit": "ބިޒްނަސް ޔުނިޓް (ދެފަރާތުން ކޮންމެ ފަރާތެއް)",
        "asOfHint": "މި ތާރީޚުގައި ހިނގަމުންދާ ގުޅުންތައް އެކަނި ދައްކައެވެ.",
        "effectiveDates": "ހިނގާ މުއްދަތު",
        "effective": "ހިނގަމުންދާ",
        "notEffective": "ނުހިނގާ",
        "defineTitle": "ގުޅުމެއް ބަޔާންކުރައްވާ",
        "provider": "ފޯރުކޮށްދޭ ޔުނިޓް",
        "client": "ކްލައިންޓް ޔުނިޓް",
        "function": "ފޯރުކޮށްދޭ ފަންކްޝަން",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "effectiveTo": "މުއްދަތު ހަމަވާ ތާރީޚް",
        "saved": "ސަރވިސް ޕްރޮވައިޑަރ ގުޅުން ރެކޯޑްކުރެވިއްޖެ",
        "saveFailed": "ގުޅުން ރެކޯޑްކުރެވޭގޮތެއް ނުވިއެވެ",
        "asProvider": "ޕްރޮވައިޑަރ",
        "asClient": "ކްލައިންޓް",
        "resolveTitle": "ކްލައިންޓް ރިޒޯލްވް",
        "resolveDescription": "ފުރިހަމަ ގުޅުމެއްގެ ދަށުން ކްލައިންޓް ޔުނިޓަކަށް މަސައްކަތްކުރެވޭނެތޯ ބަލައިދެއެވެ (F-BU.003) — ސީދާ ސަރވަރަށް ގުޅާލައެވެ.",
        "asOf": "ތާރީޚުގެ ހިސާބުން",
        "resolve": "ރިޒޯލްވް",
        "resolveAllowed": "ހުއްދަ — ގުޅުން #{relationshipId}.",
        "resolveDenied": "ދެކޮޅު — މި ފަންކްޝަނަށް މި ޔުނިޓް ބަޔާންކުރާ ފުރިހަމަ ސަރވިސް ޕްރޮވައިޑަރ ގުޅުމެއް ނެތް."
      },
      "referenceSets": {
        "title": "ރެފަރެންސް ޑޭޓާ ސެޓް ހަވާލުކުރުން",
        "description": "ކޮންމެ ޑިޓަރމިނަންޓް ބާވަތަކަށް، ކޮންމެ ވަގުތެއްގައިވެސް، ސީދާ އެއް ރެފަރެންސް ސެޓް (F-BU.008).",
        "emptyTitle": "ރެފަރެންސް ސެޓެއް ހަވާލުކޮށްފައެއް ނެތް",
        "emptyDescription": "އެކްޓިވޭޓް ކުރުމުގެ ކުރިން މަދުވެގެން އެއް ޑިޓަރމިނަންޓް ބާވަތަކަށް ސެޓެއް ހަވާލުކުރައްވާ.",
        "assignTitle": "ސެޓެއް ހަވާލުކުރައްވާ",
        "determinantType": "ޑިޓަރމިނަންޓް ބާވަތް",
        "setId": "ރެފަރެންސް ސެޓް އައިޑީ",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "effectiveTo": "މުއްދަތު ހަމަވާ ތާރީޚް",
        "saved": "ރެފަރެންސް ސެޓް ހަވާލުކުރެވިއްޖެ",
        "saveFailed": "ރެފަރެންސް ސެޓް ހަވާލުކުރެވޭގޮތެއް ނުވިއެވެ",
        "determinants": {
          "common": "ކޮމަން",
          "region": "ސަރަޙައްދު",
          "legal_entity": "ޤާނޫނީ ފަރާތް",
          "business_unit": "ބިޒްނަސް ޔުނިޓް"
        }
      },
      "ledgerAlignment": {
        "title": "ލެޖަރ އެލައިންމަންޓް",
        "description": "ފަރަގެއްނެތް ޑޮކިއުމަންޓް ސީކުއެންސިންގއަށް ބޭނުންވަނީ ޑޮކިއުމަންޓް ބާވަތަކަށް ސީދާ އެއް ލެޖަރ ބައިންޑިންގ (F-BU.004).",
        "emptyTitle": "ލެޖަރ އެލައިންމަންޓެއް ރެކޯޑްކޮށްފައެއް ނެތް",
        "emptyDescription": "ފަރަގެއްނެތް ސީކުއެންސިންގ ބޭނުންވާ ސަރަޙައްދެއްގައި ޑޮކިއުމަންޓް ބާވަތެއް ލެޖަރއަކާ އެލައިންކުރައްވާ.",
        "alignTitle": "ޑޮކިއުމަންޓް ބާވަތެއް އެލައިންކުރައްވާ",
        "ledger": "ލެޖަރ",
        "documentType": "ޑޮކިއުމަންޓް ބާވަތް",
        "jurisdiction": "ޖުރިސްޑިކްޝަން އައިޑީ",
        "sequence": "ސީކުއެންސް އައިޑީ",
        "saved": "ލެޖަރ އެލައިންމަންޓް ރައްކާކުރެވިއްޖެ",
        "saveFailed": "ލެޖަރ އެލައިންމަންޓް ރައްކާކުރެވޭގޮތެއް ނުވިއެވެ"
      },
      "securityScope": {
        "title": "ސެކިއުރިޓީ ސްކޯޕް ޕްރިވިއު",
        "description": "އެކްޓިވޭޓްކުރުމުން އުފެދޭނެ ޑޭޓާ-ސެކިއުރިޓީ ސްކޯޕް، ސަރވިސް ޕްރޮވައިޑަރ ގުޅުންތަކުން ވާރުތަވާ ސްކޯޕްތަކާއެކު — މިތަނުން އަދި އެއްވެސް އެއްޗެއް ދީފައެއް ނުވެއެވެ.",
        "noPermission": "މި ޔުނިޓްގެ ސެކިއުރިޓީ ސްކޯޕް ޕްރިވިއު ބެއްލެވުމުގެ ހުއްދަ ތިޔަ ފަރާތުގައި ނެތެވެ.",
        "loadFailed": "ސެކިއުރިޓީ ސްކޯޕް ޕްރިވިއު ލޯޑެއް ނުކުރެވުނު",
        "tableLabel": "ސެކިއުރިޓީ ސްކޯޕް ޕްރިވިއު",
        "emptyTitle": "އެއްވެސް ސްކޯޕެއް އުފެދޭކަށް ނެތް",
        "emptyDescription": "މަދުވެގެން އެއް ބިޒްނަސް ފަންކްޝަން ހަވާލުކުރައްވާ، އަދި މި ޔުނިޓަކީ ޝެއަރޑް-ސަރވިސް ޕްރޮވައިޑަރއެއް ނަމަ ސަރވިސް ޕްރޮވައިޑަރ ގުޅުމެއްވެސް ބަޔާންކުރައްވާ.",
        "principal": "ޕްރިންސިޕަލް",
        "scopeType": "ސްކޯޕް ބާވަތް",
        "source": "މަސްދަރު",
        "expiresAt": "މުއްދަތު ހަމަވަނީ"
      },
      "securityScopes": {
        "title": "ސެކިއުރިޓީ ސްކޯޕްތައް",
        "description": "ކޮންމެ ބިޒްނަސް ޔުނިޓެއްގެ ޑޭޓާއަށް ވާސިލުވެވޭނީ ކާކަށްތޯ، ސީދާ ދީފައިވާ ނުވަތަ ހިނގަމުންދާ ސަރވިސް ޕްރޮވައިޑަރ ގުޅުމަކުން ލިބޭ. މުއްދަތު ހަމަވާ ހުއްދަތައް އަމިއްލައަށް ހުއްޓިގެންދެއެވެ.",
        "noPermission": "ސެކިއުރިޓީ ސްކޯޕްތައް ބެއްލެވުމުގެ ހުއްދަ ތިޔަ ފަރާތުގައި ނެތެވެ.",
        "loadFailed": "ސެކިއުރިޓީ ސްކޯޕްތައް ލޯޑެއް ނުކުރެވުނު",
        "tableLabel": "ސެކިއުރިޓީ ސްކޯޕް ހުއްދަތައް",
        "emptyTitle": "ގުޅޭ ހުއްދައެއް ނެތް",
        "emptyDescription": "މި ތާރީޚުގައި މި ފިލްޓަރުތަކާ ގުޅޭ ވާސިލުވުމެއް އެއްވެސް ބިޒްނަސް ޔުނިޓަކުން ނުދެއެވެ.",
        "businessUnit": "ބިޒްނަސް ޔުނިޓް",
        "userId": "ޔޫޒަރ އައިޑީ",
        "asAt": "ތާރީޚުގެ ހިސާބުން",
        "derivation": "ލިބުނުގޮތް",
        "direct": "ސީދާ",
        "derived": "ނަގާފައިވާ",
        "open": "މުއްދަތެއް ނެތް",
        "effectiveOn": "މި ތާރީޚުގައި",
        "effective": "ހިނގަމުންދާ",
        "notEffective": "ނުހިނގާ",
        "grantedAt": "ދިން ތާރީޚު",
        "regenerationNote": "ބިޒްނަސް ޔުނިޓެއް އެކްޓިވޭޓްކުރާއިރު ނުވަތަ ސަރވިސް ޕްރޮވައިޑަރ ގުޅުމެއް ބަދަލުވާއިރު ގްރާންޓްތައް އަލުން އުފައްދައެވެ، އަދި ކޮންމެ ގްރާންޓެއްގެ ތާރީޚަކީ އެ އަލުން އުފެއްދި ތާރީޚެވެ. އެހެންކަމުން، އެންމެ ފަހުން އަލުން އުފެއްދުމުގެ ކުރީގެ ތާރީޚެއް ހޮވައިފިނަމަ ފެންނާނީ މިއަދުގެ ގްރާންޓްތަކެވެ، އެ ތާރީޚުގައި ހުރި ގޮތެއް ނޫނެވެ.",
        "previewHint": "އެކްޓިވޭޓްކުރުމުން މިހާރު އުފެދޭނެ ސްކޯޕްވެސް ފެނުމަށް އެއް ބިޒްނަސް ޔުނިޓެއް ހޮއްވަވާ."
      },
      "routeTitles": {
        "list": "ބިޒްނަސް ޔުނިޓްތައް",
        "detail": "ބިޒްނަސް ޔުނިޓް",
        "serviceProviders": "ސަރވިސް ޕްރޮވައިޑަރުން",
        "securityScopes": "ސެކިއުރިޓީ ސްކޯޕްތައް"
      }
    },
    "currencyRates": {
      "title": "ފައިސާގެ ރޭޓްތައް",
      "description": "ބުކަށް ބަލައި (ސްޕޮޓް، ކޯޕަރޭޓް، ހިސްޓޮރިކަލް) ރެކޯޑްކުރެވިފައިވާ ބަދަލުކުރާ ރޭޓްތައް، ކޮންމެ ތާރީޚެއްގައި އަމަލުކުރާ ރޭޓް، އަދި ކޮންޓްރޯލްކުރެވިފައިވާ ފަހަތަށް ރީވެލުއޭޝަން.",
      "routeTitles": {
        "list": "ފައިސާގެ ރޭޓްތައް"
      },
      "record": "ރޭޓެއް ރެކޯޑްކުރޭ",
      "recordFirst": "ފުރަތަމަ ރޭޓް ރެކޯޑްކުރޭ",
      "loadFailed": "ރޭޓްތައް ލޯޑެއް ނުވި",
      "tableLabel": "ބަދަލުކުރާ ރޭޓްތައް",
      "emptyTitle": "އަދި ބަދަލުކުރާ ރޭޓެއް ނެތް",
      "emptyDescription": "ރޭޓެއް ރެކޯޑްކުރޭ، ނުވަތަ ފިލްޓަރުތައް ފުޅާކުރޭ.",
      "anyRateType": "ކޮންމެ ބުކެއް",
      "anyBase": "ކޮންމެ ބޭސްއެއް",
      "anyQuote": "ކޮންމެ ކޯޓެއް",
      "fromLabel": "ފެށޭ",
      "toLabel": "ނިމޭ",
      "exportDone": "ރޭޓްތައް އެކްސްޕޯޓްކުރެވިއްޖެ",
      "exportFailed": "އެކްސްޕޯޓް ނުކުރެވުނު",
      "columns": {
        "pair": "ޖޯޑު",
        "rateType": "ބުކް",
        "rate": "ރޭޓް",
        "asOf": "ތާރީޚު",
        "source": "މަސްދަރު",
        "note": "ނޯޓް"
      },
      "rateTypes": {
        "spot": "ސްޕޮޓް",
        "corporate": "ކޯޕަރޭޓް",
        "historical": "ހިސްޓޮރިކަލް"
      },
      "sources": {
        "manual": "އަތުން",
        "api": "ފީޑް"
      },
      "fields": {
        "base": "ބޭސް ފައިސާ",
        "quote": "ކޯޓް ފައިސާ",
        "rate": "ރޭޓް",
        "rateHint": "ބޭސްގެ އެއް ޔުނިޓުން ގަނެވޭ ކޯޓްގެ ޔުނިޓުތައް، {decimals} ޑެސިމަލް ތަނަށް.",
        "asOf": "ތާރީޚު",
        "note": "ނޯޓް"
      },
      "editor": {
        "title": "ބަދަލުކުރާ ރޭޓެއް ރެކޯޑްކުރޭ",
        "description": "އެއް ދުވަހެއްގައި އެއް ޖޯޑާއި ބުކް އަލުން ރެކޯޑްކުރުމުން، ދެވަނަ އެއްޗެއް ނުއިތުރުކޮށް އެ ރެކޯޑް އިޞްލާޙުކުރެއެވެ.",
        "correctTitle": "މި ރޭޓް އިޞްލާޙުކުރޭ",
        "correctDescription": "ޖޯޑާއި ބުކާއި ތާރީޚުން ރެކޯޑް ފާހަގަކުރެވޭތީ، ބަދަލުކުރެވޭނީ ރޭޓާއި ނޯޓް އެކަންޏެވެ.",
        "correct": "އިޞްލާޙު ރައްކާކުރޭ",
        "sameCurrency": "ފައިސާއެއް އޭގެ އަމިއްލަ ނަފްސާ އަޅާކިޔުމުން އަބަދުވެސް 1 އެވެ. އެހެންކަމުން ރެކޯޑްކުރާނެ އެއްޗެއް ނެތެވެ.",
        "reading": "1 {base} އިން {rate} {quote} ގަނެވެއެވެ.",
        "recorded": "ރޭޓް ރެކޯޑްކުރެވިއްޖެ",
        "corrected": "ރޭޓް އިޞްލާޙުކުރެވިއްޖެ",
        "savedDetail": "{asOf} ގައި {base} އިން {quote} އަށް.",
        "saveFailed": "ރޭޓް ރައްކާއެއް ނުކުރެވުނެވެ",
        "heldTitle": "ރޭޓް މަޑުޖައްސާލެވިއްޖެ",
        "heldDetail": "{base}/{quote} {movePct}% ބަދަލުވެއްޖެ، ކަނޑައެޅިފައިވާ ޓޮލަރެންސަށްވުރެ ބޮޑަށް. އެހެންކަމުން ބޭނުމެއް ނުކުރެވެއެވެ.",
        "heldExplain": "އެއްވެސް ކަމެއް ފެއިލެއް ނުވޭ، އަދި އެއްވެސް އެއްޗެއް ރައްކާވެސް ނުވެއެވެ: މި ރެކޯޑް އިންތިޒާރުކުރަނީ ޤަބޫލުކުރާނެ ނުވަތަ ބޭރުކުރާނެ މީހަކަށެވެ.",
        "heldLink": "މަޑުޖައްސާލެވިފައިވާ ރޭޓްތައް ހުޅުވާ"
      },
      "revalue": {
        "open": "ރީވެލިއު",
        "title": "ފަހަތަށް ރީވެލުއޭޝަން",
        "description": "ލިޔެކިޔުންތަކުގައި ބޭނުންކުރެވިފައިވާ ރޭޓެއް އަލުން ކަނޑައަޅާ. މި ބަދަލު ދެ މީހުން ފާސްކުރަންޖެހޭއިރު، ކުރިން/ފަހުން ބަލާ އަސަރުގެ ބަޔާނަކާއެކު އަނބުރާ އަންނާނެއެވެ.",
        "dualControl": "އާ ރޭޓް ބޭނުންކުރެވުމުގެ ކުރިން، ތަފާތު ދެ ފާސްކުރާ މީހުން ރިކުއެސްޓުގައި ސޮއިކުރަންވާނެއެވެ.",
        "asOf": "ރޭޓްގެ ތާރީޚު",
        "reasonCode": "ސަބަބުގެ ކޯޑް",
        "stepRequest": "1. ފާސްކުރުމަށް އެދޭ",
        "stepRequestHint": "ޖޯޑާއި، ބުކާއި، ތާރީޚާއި ސަބަބު ދެ މީހުންގެ ފާސްކުރުމަށް ފޮނުވާ. އަދި އެއްވެސް ބަދަލެއް ނުވެއެވެ.",
        "request": "ފާސްކުރުމަށް އެދޭ",
        "requested": "ރީވެލުއޭޝަން ފާސްކުރުމަށް ފޮނުވިއްޖެ",
        "requestedDetail": "ފާސްކުރުމުގެ ރިކުއެސްޓް #{id}.",
        "submittedNote": "ފާސްކުރުމުގެ ރިކުއެސްޓް #{id} ގެ ހާލަތަކީ {status}. ދެ ފާސްކުރާ މީހުން ސޮއިކުރުމުން އެކްސިކިއުޓްކުރޭ.",
        "stepExecute": "2. އެކްސިކިއުޓްކުރޭ",
        "stepExecuteHint": "ފާސްކުރެވިފައިވާ ރިކުއެސްޓެއްގެ ދަށުން އާ ރޭޓް ބޭނުންކޮށް، އަސަރު ރެކޯޑްކުރޭ.",
        "approvalRequestId": "ފާސްކުރުމުގެ ރިކުއެސްޓް",
        "newRate": "އާ ރޭޓް",
        "execute": "ރީވެލުއޭޝަން އެކްސިކިއުޓްކުރޭ",
        "executed": "ރީވެލުއޭޝަން އެކްސިކިއުޓްކުރެވިއްޖެ",
        "failed": "ރީވެލުއޭޝަން ނިމިއެއް ނުދިޔަ",
        "resultTitle": "ރީވެލުއޭޝަން ރަން #{id}",
        "result": {
          "pair": "ޖޯޑާއި ބުކް",
          "window": "އަލުން ކަނޑައެޅުނު ތާރީޚުތައް",
          "priorRate": "ކުރީގެ ރޭޓް",
          "newRate": "އާ ރޭޓް",
          "approvers": "ފާސްކުރި މީހުން",
          "executedAt": "އެކްސިކިއުޓްކުރި ވަގުތު",
          "impact": "އަސަރުގެ ބަޔާން"
        }
      }
    },
    "divisions": {
      "title": "ޑިވިޜަންތައް",
      "description": "އެންޓަޕްރައިޒްގެ މެނޭޖްމަންޓް ވިއު. ޑިވިޜަނަކީ ޕްރޮޑަކްޓް ލައިނެއް، ބްރޭންޑެއް ނުވަތަ ޖިއޮގްރަފީއެއް، ބައިވަރު ޤާނޫނީ ފަރާތްތަކާއި ޤައުމުތަކަށް ފެތުރިފައި ހުރެދާނެ، ޤާނޫނީ ސްޓްރަކްޗަރއިން ވަކިން ބަހައްޓައިގެން، ރީއޯގަނައިޒޭޝަނަކުން ޤާނޫނީ ބަދަލެއް ބޭނުންނުވާ ގޮތަށެވެ.",
      "tableLabel": "ޑިވިޜަންތައް",
      "searchPlaceholder": "ކޯޑް، ނަން ހޯދާ…",
      "searchLabel": "ޑިވިޜަންތައް ހޯދާ",
      "createTitle": "އައު ޑިވިޜަނެއް",
      "createFirst": "ފުރަތަމަ ޑިވިޜަން ހަދާ",
      "emptyTitle": "އަދި އެއްވެސް ޑިވިޜަނެއް ނެތް",
      "emptyDescription": "ޤައުމުތަކާއި ޤާނޫނީ ފަރާތްތަކާއި ޗާޓް އޮފް އެކައުންޓްސް ސެގްމަންޓް މެޕްކުރަން ފެށުމަށް ޑިވިޜަނެއް ހަދާ.",
      "loadFailed": "ޑިވިޜަންތަކުގެ ރަޖިސްޓަރީ ލޯޑެއް ނުވި.",
      "exported": "އެއް ޑިވިޜަން އެކްސްޕޯޓްކުރެވިއްޖެ | {count} ޑިވިޜަން އެކްސްޕޯޓްކުރެވިއްޖެ",
      "columns": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "owner": "ވެރިޔާ",
        "defaultCurrency": "ފައިސާ"
      },
      "fields": {
        "code": "ޑިވިޜަން ކޯޑް",
        "name": "ޑިވިޜަން ނަން",
        "company": "ކުންފުނި",
        "purpose": "މަޤްޞަދު / ޗާޓަރ",
        "owner": "ޒިންމާވާ ވެރިޔާ",
        "ownerIdHint": "މުވައްޒަފުގެ ID — މުވައްޒަފުންގެ ލިސްޓް ބްރައުޒްކުރެވޭ ހުއްދައެއް ނެތް",
        "defaultCurrency": "ޑިފޯލްޓް ފައިސާ",
        "parent": "މައި ޑިވިޜަން",
        "parentHint": "އިޚްތިޔާރީ، ބައިވަރު ލެވެލްގެ ޑިވިޜަން ސްޓްރަކްޗަރއަކަށް. ސައިކަލެއް ނުހެދޭނެ.",
        "approvalStatus": "ހުއްދައިގެ ހާލަތު"
      },
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "submitted": "ހުށަހެޅިފައި",
        "approved": "ހުއްދަދެވިފައި",
        "rejected": "ރައްދުކުރެވިފައި",
        "ended": "ނިމިފައި"
      },
      "form": {
        "createTitle": "ޑިވިޜަނެއް ހަދާ",
        "createDescription": "ޑިވިޜަން ޑްރާފްޓް ހާލަތުގައި ހެދޭނެ. ހުށަހެޅުމުގެ ކުރިން މަދުވެގެން އެއް ޤައުމެއް އެއްކުރޭ.",
        "editTitle": "ޑިވިޜަން އެޑިޓްކުރޭ",
        "editDescription": "މިތަނުން އެޑިޓްކުރެވެނީ މަޤްޞަދާއި ވެރިޔާއާއި ޑިފޯލްޓް ފައިސާ އެކަނި — ކޯޑާއި ނަމާއި ކުންފުނި ހެދި ފަހުން ބަދަލެއް ނުކުރެވޭނެ (FSD 1.2.2.3).",
        "readOnlyHint": "ކޯޑާއި ނަން މިސްކްރީނުގައި ބަދަލެއް ނުކުރެވޭނެ.",
        "created": "ޑިވިޜަން ހެދިއްޖެ",
        "createdDetail": "{name} ޑްރާފްޓް ހާލަތުގައި ހެދިއްޖެ.",
        "createFailed": "ޑިވިޜަން ނުހެދުނު.",
        "saved": "ޑިވިޜަން ސޭވްކުރެވިއްޖެ",
        "savedDetail": "{name} އަޕްޑޭޓްކުރެވިއްޖެ.",
        "saveFailed": "ޑިވިޜަން ސޭވްނުކުރެވުނު."
      },
      "tabs": {
        "profile": "ޕްރޮފައިލް",
        "countries": "ޤައުމުތައް",
        "legalEntities": "ޤާނޫނީ ފަރާތްތައް",
        "segmentMap": "ސެގްމަންޓް މެޕިންގ",
        "crossCharging": "ކްރޮސް-ޗާޖިންގ",
        "rollup": "ރޯލްއަޕް"
      },
      "detail": {
        "oneTitle": "ޑިވިޜަން",
        "oneDescription": "ޕްރޮފައިލް، ޤައުމުތައް، ޤާނޫނީ ފަރާތްތައް، ޗާޓް އޮފް އެކައުންޓްސް ސެގްމަންޓް މެޕިންގ، ކްރޮސް-ޗާޖިންގ އަދި ރޯލްއަޕް.",
        "oneLoadFailed": "މި ޑިވިޜަން ލޯޑެއް ނުވި.",
        "notFound": "މި ޑިވިޜަނެއް ނުފެނުނު.",
        "tabsLabel": "ޑިވިޜަންގެ ބައިތައް",
        "backToList": "ރަޖިސްޓަރީއަށް އަނބުރާ",
        "submit": "ހުއްދައަށް ހުށަހަޅާ",
        "submitted": "ހުއްދައަށް ހުށަހެޅިއްޖެ",
        "submitFailed": "ހުށަހެޅުނު ނުކުރެވުނު.",
        "activate": "އެކްޓިވޭޓްކުރޭ",
        "activated": "ޑިވިޜަން އެކްޓިވޭޓްކުރެވިއްޖެ",
        "activateFailed": "އެކްޓިވޭޓްނުކުރެވުނު.",
        "reorganise": "ރީއޯގަނައިޒްކުރޭ…",
        "endDate": "ނިމުމަކަށް ގެނޭ…"
      },
      "rail": {
        "registerLink": "ޑިވިޜަން ރަޖިސްޓަރީ"
      },
      "countries": {
        "title": "ހިންގާ ޤައުމުތައް",
        "description": "F-3.001: ޑިވިޜަނަކަށް އެއް ޤައުމަށްވުރެ ގިނަ ޤައުމުގައި ހިންގިދާނެ. ހުއްދައަށް ހުށަހެޅުމުގެ ކުރިން މަދުވެގެން އެއް ޤައުމެއް ބޭނުންވާނެ (FND-F02-V02).",
        "add": "ޤައުމެއް އިތުރުކުރޭ",
        "emptyTitle": "އަދި ހިންގާ ޤައުމެއް ނެތް",
        "emptyDescription": "ހުއްދައަށް ހުށަހެޅުމުގެ ކުރިން މަދުވެގެން އެއް ޤައުމެއް އިތުރުކުރޭ.",
        "saved": "ޤައުމު އިތުރުކުރެވިއްޖެ",
        "saveFailed": "ޤައުމު އިތުރުނުކުރެވުނު.",
        "terminate": "ނިމުން…",
        "confirmEnd": "ޔަޤީންކުރޭ",
        "terminated": "ޤައުމުގެ ގުޅުން ނިމިއްޖެ",
        "terminateFailed": "ޤައުމުގެ ގުޅުން ނިމުމެއް ނުކުރެވުނު.",
        "fields": {
          "countryCode": "ޤައުމުގެ ކޯޑް",
          "effectiveFrom": "ފެށޭ ތާރީޚު"
        }
      },
      "legalEntities": {
        "title": "ޤާނޫނީ ފަރާތްތައް",
        "description": "1.2.2.4: ގުޅުވުމަކީ ބައިވަރު-ބައިވަރަށް ހުންނަ ގުޅުމެއް، ފަރާތުގެ އަމިއްލަ ސްޓްރަކްޗަރއަށް ބަދަލެއް ނުގެންނާނެ. ޤާނޫނީ ފަރާތެއް އެއް ޑިވިޜަނަށްވުރެ ގިނަ ޑިވިޜަނަށް ބައިވެރިވެދާނެ.",
        "associate": "ފަރާތެއް ގުޅުވާ",
        "emptyTitle": "އަދި ޤާނޫނީ ފަރާތެއް ގުޅުވިފައެއް ނުވޭ",
        "emptyDescription": "މެނޭޖްމަންޓް ރިޕޯޓިންގއަށްޓަކައި ޤާނޫނީ ފަރާތެއް މި ޑިވިޜަނާ ގުޅުވާ.",
        "saved": "ޤާނޫނީ ފަރާތް ގުޅުވިއްޖެ",
        "saveFailed": "ޤާނޫނީ ފަރާތް ނުގުޅުވުނު.",
        "terminate": "ނިމުން…",
        "confirmEnd": "ޔަޤީންކުރޭ",
        "terminated": "ޤާނޫނީ ފަރާތުގެ ގުޅުން ނިމިއްޖެ",
        "terminateFailed": "ޤާނޫނީ ފަރާތުގެ ގުޅުން ނިމުމެއް ނުކުރެވުނު.",
        "fields": {
          "company": "ޤާނޫނީ ފަރާތް",
          "effectiveFrom": "ފެށޭ ތާރީޚު"
        }
      },
      "segmentMap": {
        "title": "ޗާޓް އޮފް އެކައުންޓްސް ސެގްމަންޓް މެޕިންގ",
        "description": "F-3.006: ޑިވިޜަނަކީ މެނޭޖްމަންޓް ސެގްމަންޓެއްގައިވާ ވެލިއުއެއްގެ ގޮތުގައި ދައްކާނެ. ބެލެންސިންގ ސެގްމަންޓެއް އިޚްތިޔާރުކުރުމުން ފައިނޭންސްގެ ޔަޤީންކުރުން ބޭނުންވާ ވޯނިންގއެއް ދައްކާނެ (FND-F02-V04).",
        "noneYet": "އަދި ސެގްމަންޓް މެޕިންގއެއް ނެތް.",
        "saved": "ސެގްމަންޓް މެޕިންގ ސޭވްކުރެވިއްޖެ",
        "saveFailed": "ސެގްމަންޓް މެޕިންގ ސޭވްނުކުރެވުނު.",
        "confirmBalancing": "ބެލެންސިންގ ސެގްމަންޓް ޔަޤީންކުރޭ",
        "needsFinanceConfirm": "ފައިނޭންސް މެނޭޖަރގެ ބެލެންސިންގ-ސެގްމަންޓް ޔަޤީންކުރުމުގެ ހުއްދަ ބޭނުންވޭ.",
        "fields": {
          "structure": "ޗާޓް އޮފް އެކައުންޓްސް",
          "segment": "ސެގްމަންޓް",
          "segmentValue": "ސެގްމަންޓް ވެލިއު",
          "isBalancing": "ބެލެންސިންގ ސެގްމަންޓް",
          "effectiveFrom": "ފެށޭ ތާރީޚު"
        }
      },
      "crossCharging": {
        "title": "ކްރޮސް-ޗާޖިންގ",
        "description": "F-3.004: ކްރޮސް-ޗާޖިންގ ރޫލްތަކުން ހުރިހާ ލެޖަރ ބައުންޑްރީއެއްގައި ބެލެންސްވާ އެންޓްރީ އުފައްދަންޖެހޭނެ، އެކްޓިވޭޓްކުރުމުގެ ކުރިން ސިމިއުލޭޓްކޮށް ޔަޤީންކުރެވިފައި. އެކްޓިވޭޓްކުރުމަށް ދެ ފަރާތެއްގެ ހުއްދަ ބޭނުންވޭ — ޑިވިޜަނަލް އޯނަރ އަދި ފައިނޭންސް މެނޭޖަރ (1.2.2.10).",
        "define": "އެރޭންޖްމަންޓް ބަޔާންކުރޭ",
        "emptyTitle": "އަދި ކްރޮސް-ޗާޖިންގ އެރޭންޖްމަންޓެއް ނެތް",
        "emptyDescription": "މި ޑިވިޜަނާއި އަނެއް ޑިވިޜަނާ ދެމެދު ޚަރަދު ހޯދުމަށް ކްރޮސް-ޗާޖިންގ އެރޭންޖްމަންޓެއް ބަޔާންކުރޭ.",
        "created": "ކްރޮސް-ޗާޖް ރޫލް ހެދިއްޖެ",
        "createFailed": "ކްރޮސް-ޗާޖް ރޫލް ނުހެދުނު.",
        "simulate": "ސިމިއުލޭޓް…",
        "runSimulation": "ސިމިއުލޭޝަން ހިންގާ",
        "balanced": "ހުރިހާ ލެޖަރ ބައުންޑްރީއެއްގައި ބެލެންސްވެފައި.",
        "unbalanced": "ބެލެންސްނުވޭ — ރެސިޑިއުލް {residual}. މިކަން ހައްލުނުވަނީސް އެކްޓިވޭޓެއް ނުކުރެވޭނެ.",
        "activate": "އެކްޓިވޭޓްކުރޭ",
        "activated": "ކްރޮސް-ޗާޖް ރޫލް އެކްޓިވޭޓްކުރެވިއްޖެ",
        "activateFailed": "ކްރޮސް-ޗާޖް ރޫލް އެކްޓިވޭޓްނުކުރެވުނު.",
        "needsApprovePermission": "އެކްޓިވޭޓްކުރުމަށް ފައިނޭންސް މެނޭޖަރގެ ކްރޮސް-ޗާޖް ހުއްދަދިނުމުގެ ހުއްދަ ބޭނުންވޭ.",
        "pricingMethods": {
          "cost": "ކޮސްޓް",
          "cost_plus": "ކޮސްޓް-ޕްލަސް",
          "market": "މާކެޓް",
          "fixed_rate": "ފިކްސްޑް ރޭޓް"
        },
        "statuses": {
          "draft": "ޑްރާފްޓް",
          "active": "އެކްޓިވް"
        },
        "fields": {
          "toDivision": "ހޯދާ ޑިވިޜަން",
          "pricingMethod": "ޕްރައިސިންގ މެތަޑް",
          "rate": "ރޭޓް",
          "rateHint": "ކޮސްޓް-ޕްލަސްއަށް މާކްއަޕް އިންސައްތައެއް: 10% އަށް 10 ލިޔުއްވާ. މާކެޓް/ފިކްސްޑް ރޭޓްއަށް ބަޔާންކުރެވިފައިވާ އަދަދެއް.",
          "rateRange": "ކޮސްޓް-ޕްލަސް މާކްއަޕް 0 އާއި 1000 އާ ދެމެދު އިންސައްތައެއް ކަމުގައި ވާންވާނެއެވެ.",
          "effectiveFrom": "ފެށޭ ތާރީޚު",
          "baseAmount": "ސިމިއުލޭޓްކުރާ ބޭސް އަދަދު",
          "debit": "ޑެބިޓް",
          "credit": "ކްރެޑިޓް"
        }
      },
      "rollup": {
        "title": "މެނޭޖްމަންޓް ރޯލްއަޕް",
        "description": "F-3.002: ކޮސްޓް ސެންޓަރތަކާއި ފަރާތްތަކާއި ޤައުމުތައް — ކޮންމެ ތާރީޚެއްގައިވެސް ރިޒޯލްކުރެވޭ ރޯލްއަޕް.",
        "loadFailed": "ރޯލްއަޕް ލޯޑެއް ނުވި.",
        "countries": "ޤައުމުތައް",
        "legalEntities": "ޤާނޫނީ ފަރާތްތައް",
        "costCentres": "ކޮސްޓް ސެންޓަރތައް",
        "none": "މި ތާރީޚުގައި ނެތް.",
        "fields": {
          "asAt": "މިތާރީޚުގައި"
        }
      },
      "reorganise": {
        "title": "ޑިވިޜަން ރީއޯގަނައިޒްކުރޭ",
        "subject": "{name} ރީއޯގަނައިޒްކުރަނީ",
        "consequence": "އިޚްތިޔާރުކުރެވުނު ޤާނޫނީ ފަރާތުގެ ގުޅުންތައް އެއް ފިއުޗަރ-ޑޭޓެޑް ތާރީޚެއްގައި، އެއް ހުއްދައެއްގެ ދަށުން އަނެއް ޑިވިޜަނަށް ބަދަލުކުރޭ، ބައި ރީއޯގަނައިޒޭޝަނެއް ދުވަހަކުވެސް އެކްޓިވޭޓް ނުކުރެވޭ ގޮތަށް (1.2.2.10).",
        "confirm": "ރީއޯގަނައިޒްކުރޭ",
        "done": "ރީއޯގަނައިޒޭޝަން ފުރިހަމަވެއްޖެ",
        "doneDetail": "{count} ގުޅުން ބަދަލުކުރެވިއްޖެ.",
        "failed": "ޑިވިޜަން ރީއޯގަނައިޒް ނުކުރެވުނު.",
        "noEntities": "މި ޑިވިޜަނުގައި ބަދަލުކުރެވޭ ޤާނޫނީ ފަރާތެއް ނެތް.",
        "fields": {
          "toDivision": "ބަދަލުކުރާ ޑިވިޜަން",
          "entities": "ބަދަލުކުރާ ޤާނޫނީ ފަރާތްތައް",
          "effectiveOn": "ފެށޭ ތާރީޚު",
          "effectiveOnHint": "ކުރިއަށް އޮތް ތާރީޚަކަށްވާންޖެހޭނެ — މިއީ ފިއުޗަރ-ޑޭޓެޑް ރީސްޓްރަކްޗަރއެއް.",
          "reasonCode": "ސަބަބު"
        }
      },
      "endDate": {
        "title": "ޑިވިޜަން ނިމުމަކަށް ގެނޭ",
        "subject": "{name} ނިމުމަކަށް ގެންނަނީ",
        "consequence": "ހިނގަމުންދާ ކޮސްޓް ސެންޓަރތަކާއި ހުޅުވިފައިވާ ކްރޮސް-ޗާޖްތަކާއި ހަޔރާކީ މެމްބަރޝިޕްތައް ހުރެއްޖެނަމަ ނިމުމަކަށް ގެނައުން ހުއްޓުވާނެ (F-3.007). ތާރީޚީ ގޮތުން ފުރިހަމައަށް ރިޕޯޓްކުރެވޭނެ.",
        "fields": {
          "reasonCode": "ސަބަބު ކޯޑް"
        },
        "confirm": "ނިމުމަކަށް ގެނޭ",
        "done": "ޑިވިޜަން ނިމުމަކަށް ގެނެވިއްޖެ",
        "doneDetail": "{name} ނިމުމަކަށް ގެނެވި، ތާރީޚީ ގޮތުން ފުރިހަމައަށް ރިޕޯޓްކުރެވޭނެ.",
        "failed": "ޑިވިޜަން ނިމުމަކަށް ނުގެނެވުނު."
      },
      "crossCharges": {
        "title": "ކްރޮސް-ޗާޖިންގ",
        "loadFailed": "ކްރޮސް-ޗާޖިންގ ރަޖިސްޓަރ ލޯޑެއް ނުވި.",
        "emptyTitle": "ކްރޮސް-ޗާޖިންގ އެރޭންޖްމަންޓެއް ނެތް",
        "emptyDescription": "ގުޅޭ އެރޭންޖްމަންޓެއް ނެތް. އެއް ޑިވިޜަނުން އަނެއް ޑިވިޜަނަށް ޚަރަދު ހޯދުމަށް އެއްޗެއް ބަޔާންކުރޭ.",
        "anyStatus": "ކޮންމެ ހާލަތެއް",
        "anyDivision": "ކޮންމެ ޑިވިޜަނެއް",
        "simulateTitle": "ރިކަވަރީ ސިމިއުލޭޓްކުރޭ",
        "columns": {
          "from": "ޚިދުމަތްދޭ ޑިވިޜަން",
          "to": "ހޯދާ ޑިވިޜަން",
          "effective": "ހިނގާ މުއްދަތު"
        },
        "fields": {
          "fromDivision": "ޚިދުމަތްދޭ ޑިވިޜަން",
          "division": "ޑިވިޜަން"
        }
      },
      "costCentres": {
        "title": "ކޮސްޓް ސެންޓަރތައް",
        "description": "ޤާނޫނީ ފަރާތެއްގެ ކޮސްޓް ސެންޓަރ ރަޖިސްޓަރ. ކޮސްޓް ސެންޓަރެއް ޑިވިޜަނަކަށް ރޯލްއަޕްވަނީ ޝާއިޢުކުރެވިފައިވާ މެނޭޖްމަންޓް ހަޔރާކީއިން، ޤާނޫނީ އޮނިގަނޑުން ނޫން.",
        "createTitle": "އައު ކޮސްޓް ސެންޓަރ",
        "editTitle": "ކޮސްޓް ސެންޓަރ ބަދަލުކުރޭ",
        "formDescription": "ކޯޑާއި ނަމުން ޤާނޫނީ ފަރާތުގެ ތެރޭގައި ކޮސްޓް ސެންޓަރ ވަކިކުރެވޭ.",
        "loadFailed": "ކޮސްޓް ސެންޓަރތައް ލޯޑެއް ނުވި.",
        "emptyTitle": "އަދި ކޮސްޓް ސެންޓަރެއް ނެތް",
        "emptyDescription": "މި ޤާނޫނީ ފަރާތަށް ފުރަތަމަ ކޮސްޓް ސެންޓަރ ހަދާ.",
        "pickCompany": "ކޮސްޓް ސެންޓަރތައް ދެއްކުމަށް ޤާނޫނީ ފަރާތެއް ޚިޔާރުކުރޭ",
        "searchPlaceholder": "ކޯޑު، ނަން ހޯދާ…",
        "searchLabel": "ކޮސްޓް ސެންޓަރ ހޯދާ",
        "managerPosition": "މަޤާމު #{id}",
        "created": "ކޮސްޓް ސެންޓަރ ހެދިއްޖެ",
        "saved": "ކޮސްޓް ސެންޓަރ ސޭވްކުރެވިއްޖެ",
        "saveFailed": "ކޮސްޓް ސެންޓަރ ސޭވެއް ނުކުރެވުނު.",
        "stale": "ތިބާ ހުޅުވިފަހުން މި ކޮސްޓް ސެންޓަރ އެހެން މީހަކު ބަދަލުކޮށްފި. ރީލޯޑްކޮށް، ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
        "reload": "ރީލޯޑްކުރޭ",
        "reloadFailed": "ކޮސްޓް ސެންޓަރ ރީލޯޑެއް ނުކުރެވުނު.",
        "deleted": "ކޮސްޓް ސެންޓަރ ފޮހެލެވިއްޖެ",
        "deleteFailed": "ކޮސްޓް ސެންޓަރ ފޮހެލެއް ނުވި.",
        "deleteStale": "މި ކޮސްޓް ސެންޓަރ އެހެން މީހަކު ބަދަލުކުރީމާ ފޮހެލެއް ނުވި. ލިސްޓު ރީލޯޑްކުރެވިއްޖެ — ބައްލަވައިގެން އަލުން މަސައްކަތްކުރައްވާ.",
        "deleteTitle": "ކޮސްޓް ސެންޓަރ ފޮހެލާ",
        "deleteMessage": "ކޮސްޓް ސެންޓަރ {name} ފޮހެލަންތަ؟",
        "columns": {
          "code": "ކޯޑު",
          "name": "ނަން",
          "manager": "މެނޭޖަރ"
        },
        "statuses": {
          "active": "އެކްޓިވް",
          "inactive": "އިންއެކްޓިވް"
        },
        "fields": {
          "company": "ޤާނޫނީ ފަރާތް",
          "code": "ކޮސްޓް ސެންޓަރ ކޯޑު",
          "name": "ކޮސްޓް ސެންޓަރގެ ނަން",
          "active": "އެކްޓިވް"
        }
      },
      "rollupScreen": {
        "title": "ރޯލްއަޕް އަދި ރީއޯގަނައިޒް",
        "description": "F-3.002: ޑިވިޜަނަކަށް ރޯލްއަޕްވާ ކޮސްޓް ސެންޓަރތަކާއި ޤާނޫނީ ފަރާތްތަކާއި ޤައުމުތައް، ކޮންމެ ތާރީޚެއްގައިވެސް. ރީއޯގަނައިޒްކުރުމުން ޤާނޫނީ އޮނިގަނޑަށް ނުބެލި، އެއް ތާރީޚެއްގައި ޑިވިޜަންތަކުގެ މެދުގައި ގުޅުންތައް ބަދަލުކުރޭ (F-3.003).",
        "openDivision": "ޑިވިޜަން ހުޅުވާ",
        "noDivisions": "އަދި ޑިވިޜަނެއް ނެތް. ފުރަތަމަ ޑިވިޜަނެއް ހަދާ.",
        "fields": {
          "division": "ޑިވިޜަން"
        }
      },
      "routeTitles": {
        "list": "ޑިވިޜަންތައް",
        "detail": "ޑިވިޜަން",
        "costCentres": "ކޮސްޓް ސެންޓަރތައް",
        "crossCharges": "ކްރޮސް-ޗާޖިންގ",
        "rollup": "ރޯލްއަޕް އަދި ރީއޯގަނައިޒް"
      }
    },
    "financialStructures": {
      "title": "ފައިނޭންޝަލް ސްޓްރަކްޗަރތައް",
      "description": "ކޮންމެ މުޢާމަލާތެއް ހައްލުކުރާ މަލްޓި-ސެގްމަންޓް ޗާޓް އޮފް އެކައުންޓްސް ފަރުމާކުރުން: ސެގްމަންޓްތައް، ވެލިއު ސެޓްތައް، ކްރޮސް-ވެލިޑޭޝަން ރޫލްތައް އަދި ސެގްމަންޓް ސެކިއުރިޓީ.",
      "routeTitles": {
        "list": "ޗާޓް އޮފް އެކައުންޓްސްތައް",
        "detail": "ޗާޓް އޮފް އެކައުންޓްސް",
        "valueSetsList": "ވެލިއު ސެޓްތައް",
        "valueSetDetail": "ވެލިއު ސެޓް",
        "cvrRegister": "ކްރޮސް-ވެލިޑޭޝަން ރޫލްތައް"
      },
      "cvrRegister": {
        "title": "ކްރޮސް-ވެލިޑޭޝަން ރޫލްތައް",
        "description": "ހުރިހާ ޗާޓް އޮފް އެކައުންޓްސްއެއްގައިވާ ހުރިހާ ކްރޮސް-ވެލިޑޭޝަން ރޫލެއް: އޭގެ ދަށަށް ވަންނަ އެއްޗެއް، މަނާކުރާ އެއްޗެއް، އަދި މިއަދު އަމަލުކުރަމުންދޭތޯ.",
        "tableLabel": "ކްރޮސް-ވެލިޑޭޝަން ރޫލްތައް",
        "loadFailed": "ކްރޮސް-ވެލިޑޭޝަން ރޫލްތައް ލޯޑެއް ނުވި",
        "emptyTitle": "އަދި ކްރޮސް-ވެލިޑޭޝަން ރޫލެއް ނެތް",
        "emptyDescription": "ފުރަތަމަ ރޫލް އިތުރުކުރުމަށް ތިރީގައިވާ ޗާޓް އޮފް އެކައުންޓްސްއެއް ހޮވާ.",
        "structureFilter": "ޗާޓް އޮފް އެކައުންޓްސް",
        "allStructures": "ހުރިހާ ޗާޓް އޮފް އެކައުންޓްސްއެއް",
        "manage": "މެނޭޖްކުރޭ",
        "manageHint": "ރޫލެއް އިތުރުކުރުމަށް ނުވަތަ ރޫލެއްގެ އަސަރު ސްކޭން އަލުން ހިންގުމަށް ޗާޓް އޮފް އެކައުންޓްސްއެއް ހޮވާ.",
        "truncated": "ޗާޓް އޮފް އެކައުންޓްސްއެއްގައި {limit} އަށްވުރެ ގިނަ ރޫލް އެބަހުއްޓެވެ؛ މިތާގައި ދައްކަނީ ފުރަތަމަ {limit} އެވެ.",
        "when": "ހާލަތު: {list}",
        "columns": {
          "structure": "ޗާޓް އޮފް އެކައުންޓްސް",
          "rule": "ރޫލް",
          "condition": "ޝަރުތު",
          "effective": "އަމަލުކުރާ"
        },
        "statuses": {
          "active": "އެކްޓިވް",
          "scheduled": "ރާވާފައި",
          "ended": "ނިމިފައި"
        }
      },
      "create": "އައު ޗާޓް އޮފް އެކައުންޓްސް",
      "createFirst": "ފުރަތަމަ ޗާޓް އޮފް އެކައުންޓްސް އުފައްދާ",
      "createTitle": "އައު ޗާޓް އޮފް އެކައުންޓްސް",
      "createDescription": "ޗާޓް ޑްރާފްޓް ސްޓޭޓަސްގައި އުފައްދާ. އުފެއްދުމަށްފަހު އޭގެ ސެގްމަންޓްތައް އިތުރުކުރޭ.",
      "createSegmentsHint": "ސެގްމަންޓްތައް އިތުރުކުރެވެނީ ޗާޓް އުފެއްދުމަށްފަހު، އޭގެ އަމިއްލަ ސަފްޙާގައެވެ.",
      "saved": "ޗާޓް އޮފް އެކައުންޓްސް އުފެއްދިއްޖެ",
      "saveFailed": "ޗާޓް އޮފް އެކައުންޓްސް އުފެއްދިފައެއް ނުވޭ",
      "loadFailed": "ޗާޓް އޮފް އެކައުންޓްސްތައް ލޯޑްކުރެވިފައެއް ނުވޭ",
      "tableLabel": "ޗާޓް އޮފް އެކައުންޓްސްތައް",
      "emptyTitle": "އަދި ޗާޓް އޮފް އެކައުންޓްސްއެއް ނެތް",
      "emptyDescription": "އޭގެ ސެގްމަންޓްތައް ފަރުމާކުރަން ފެށުމަށް އައު ޗާޓެއް އުފައްދާ.",
      "statusFilterPlaceholder": "ސްޓޭޓަސް އިން ފިލްޓަރކުރޭ",
      "valueSetsLink": "ވެލިއު ސެޓްތައް",
      "notFrozen": "ފްރީޒްކޮށްފައެއް ނުވޭ",
      "frozenBadge": "ފްރީޒްކޮށްފައި",
      "frozenSince": "{date} އިން ފެށިގެން ފްރީޒްކޮށްފައި",
      "columns": {
        "name": "ނަން",
        "segmentCount": "ސެގްމަންޓްތައް",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "frozen": "ސްޓްރަކްޗަރ"
      },
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "active": "އެކްޓިވް",
        "inactive": "އިންއެކްޓިވް"
      },
      "fields": {
        "name": "ނަން",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "effectiveFromHint": "މި ޗާޓް އޮފް އެކައުންޓްސް ބޭނުންކުރެވެން ފަށާ ތާރީޚް."
      },
      "bindings": {
        "company": "ކުންފުނި",
        "natural_account": "ނެޗުރަލް އެކައުންޓް",
        "division": "ޑިވިޜަން",
        "cost_center": "ކޮސްޓް ސެންޓަރ",
        "profit_center": "ޕްރޮފިޓް ސެންޓަރ",
        "branch": "ބްރާންޗް",
        "department": "ޑިޕާޓްމަންޓް",
        "business_unit": "ބިޒްނަސް ޔުނިޓް",
        "project": "ޕްރޮޖެކްޓް",
        "intercompany": "އިންޓަރ-ކުންފުނި",
        "value_set": "ވެލިއު ސެޓް (ފިޒިކަލް ކޮލަމެއް ނުހިމެނޭ)"
      },
      "qualifiers": {
        "none": "ނެތް",
        "primary_balancing": "ޕްރައިމަރީ ބެލެންސިންގ",
        "natural_account": "ނެޗުރަލް އެކައުންޓް",
        "cost_center": "ކޮސްޓް ސެންޓަރ",
        "intercompany": "އިންޓަރ-ކުންފުނި",
        "management": "މެނޭޖްމަންޓް"
      },
      "detail": {
        "oneTitle": "ޗާޓް އޮފް އެކައުންޓްސް",
        "oneDescription": "މި ޗާޓަށް ނިސްބަތްވާ ސެގްމަންޓްތަކާއި، ކްރޮސް-ވެލިޑޭޝަން ރޫލްތަކާއި، ސެގްމަންޓް ސެކިއުރިޓީ.",
        "oneLoadFailed": "މި ޗާޓް އޮފް އެކައުންޓްސް ލޯޑްކުރެވިފައެއް ނުވޭ",
        "notFound": "މި ޗާޓް އޮފް އެކައުންޓްސް ފެނިފައެއް ނުވޭ.",
        "backToList": "ޗާޓް އޮފް އެކައުންޓްސްތަކަށް ރުޖޫޢަވޭ",
        "tabsLabel": "ޗާޓް އޮފް އެކައުންޓްސް ބައިތައް",
        "editTitle": "ޗާޓް އޮފް އެކައުންޓްސް އެޑިޓްކުރޭ",
        "saved": "ޗާޓް އޮފް އެކައުންޓްސް އަޕްޑޭޓްކުރެވިއްޖެ",
        "saveFailed": "ޗާޓް އޮފް އެކައުންޓްސް އަޕްޑޭޓްކުރެވިފައެއް ނުވޭ",
        "activate": "އެކްޓިވޭޓްކުރޭ",
        "activated": "ޗާޓް އޮފް އެކައުންޓްސް އެކްޓިވޭޓްކުރެވިއްޖެ",
        "activateFailed": "ޗާޓް އޮފް އެކައުންޓްސް އެކްޓިވޭޓްކުރެވިފައެއް ނުވޭ",
        "frozenNote": "މި ސްޓްރަކްޗަރ ފްރީޒްކޮށްފައިވަނީ: {date} ގައި މީގެ މައްޗަށް މުޢާމަލާތެއް ޕޯސްޓްކުރެވިފައިވާތީ، އޭގެ ސެގްމަންޓްތަކާއި ނަމާއި ފެށޭ ތާރީޚް ބަދަލުނުކުރެވޭނެ (FSD F-6.009). ސްޓްރަކްޗަރަލް ބަދަލެއް ބޭނުންނަމަ އައު ޗާޓް އޮފް އެކައުންޓްސްއެއް ފަރުމާކުރޭ.",
        "frozenFieldHint": "{date} އިން ފެށިގެން ފްރީޒްކޮށްފައި — މި ފީލްޑް ބަދަލެއް ނުކުރެވޭނެ؛ ނަމަވެސް ސްޓޭޓަސް ބަދަލުކުރެވިދާނެ."
      },
      "tabs": {
        "segments": "ސެގްމަންޓްތައް",
        "crossValidation": "ކްރޮސް-ވެލިޑޭޝަން ރޫލްތައް",
        "segmentSecurity": "ސެގްމަންޓް ސެކިއުރިޓީ"
      },
      "segments": {
        "title": "ސެގްމަންޓްތައް",
        "description": "ކޮންމެ ސެގްމަންޓަކުން ނިސްބަތްކުރަނީ ސްކީމާގައި މިހާރުވެސް ހުރި ކޮލަމަކަށެވެ — ބައިންޑިންގ — އައު ސްޓޯރޭޖެއް ބައިންޑިންގ އެއް ނުއުފައްދާނެ.",
        "add": "ސެގްމަންޓް އިތުރުކުރޭ",
        "emptyTitle": "އަދި ސެގްމަންޓެއް ނެތް",
        "emptyDescription": "މި ޗާޓް އޮފް އެކައުންޓްސް ފަރުމާކުރަން ފެށުމަށް ސެގްމަންޓެއް އިތުރުކުރޭ.",
        "created": "ސެގްމަންޓް އިތުރުކުރެވިއްޖެ",
        "saved": "ސެގްމަންޓް އަޕްޑޭޓްކުރެވިއްޖެ",
        "saveFailed": "ސެގްމަންޓް ސޭވްކުރެވިފައެއް ނުވޭ",
        "deleted": "ސެގްމަންޓް ނައްތާލެވިއްޖެ",
        "deleteFailed": "ސެގްމަންޓް ނައްތާލެވިފައެއް ނުވޭ",
        "deleteTitle": "ސެގްމަންޓް ނައްތާލާ",
        "deleteMessage": "\"{prompt}\" ސެގްމަންޓް ނައްތާލަން ބޭނުންތަ؟ މި ޗާޓް އޮފް އެކައުންޓްސްގެ މައްޗަށް އަދި މުޢާމަލާތެއް ޕޯސްޓްނުކުރެވެނިކޮށް ނޫނީ މިކަން ނުކުރެވޭނެ.",
        "frozenHint": "މި ޗާޓް އޮފް އެކައުންޓްސް ފްރީޒްކޮށްފައި ({date} ގައި ފުރަތަމަ ޕޯސްޓްކުރެވުނު) — ސެގްމަންޓް އިތުރުކުރުމާއި ބަދަލުކުރުމާއި ނައްތާލުން ފަހެއް ނުކުރެވޭނެ.",
        "secured": "ސެކިއުރ",
        "length": "{length} އަކުރު",
        "fields": {
          "prompt": "ޕްރޮމްޕްޓް",
          "sequence": "ސީކުއެންސް",
          "displayOrder": "ދައްކާ ތަރުތީބު",
          "binding": "ބައިންޑިންގ",
          "bindingHint": "މި ސެގްމަންޓުން ކިޔަނީ ކޮންމެ ކޮލަމަކުންތޯ — ބައިންޑިންގ ހޮވުމަކީ މިހާރުވެސް ހުރި ޑޭޓާއަކަށް ނިސްބަތްކުރުމެވެ، އައު ކޮލަމެއް ދުވަހަކުވެސް ނުއުފައްދާނެ.",
          "valueSet": "ވެލިއު ސެޓް",
          "qualifier": "ކޮލިފަޔަރ",
          "length": "ދިގުމިން",
          "isSecured": "މި ސެގްމަންޓަށް ސެގްމަންޓް ސެކިއުރިޓީ ހިނގާނެ"
        }
      },
      "cvr": {
        "title": "ކްރޮސް-ވެލިޑޭޝަން ރޫލްތައް",
        "description": "އެންޓްރީގައާއި ޕޯސްޓިންގގައި ބާޠިލު އެކައުންޓް ކޮމްބިނޭޝަންތައް ހުއްޓުވާ (F-6.002). ރޫލެއް އުފެއްދުމުން ނުވަތަ އަލުން ސްކޭންކުރުމުން، އެ ބާޠިލުކުރާ ކޮމްބިނޭޝަންތައް ދައްކާނެ.",
        "add": "އައު ރޫލް",
        "emptyTitle": "އަދި ކްރޮސް-ވެލިޑޭޝަން ރޫލެއް ނެތް",
        "emptyDescription": "ބާޠިލު ސެގްމަންޓް ކޮމްބިނޭޝަންތައް ހުއްޓުވުމަށް ރޫލެއް އިތުރުކުރޭ.",
        "created": "ކްރޮސް-ވެލިޑޭޝަން ރޫލް އުފެއްދިއްޖެ",
        "saveFailed": "ކްރޮސް-ވެލިޑޭޝަން ރޫލް އުފެއްދިފައެއް ނުވޭ",
        "scan": "ސްކޭންކުރޭ",
        "scanning": "ސްކޭންކުރަނީ…",
        "scanFailed": "ސްކޭން ހިންގޭގޮތެއް ނުވިއެވެ",
        "excludeHeading": "އެކްސްކްލޫޑް ކޮންޑިޝަންތައް (މަޖުބޫރު)",
        "excludeHint": "ކޮންމެ އެކްސްކްލޫޑް ކޮންޑިޝަނަކާއި ދިމާވާ ކޮމްބިނޭޝަނެއް ބާޠިލުކުރެވޭނެ.",
        "excludes": "އެކްސްކްލޫޑްކުރަނީ: {list}",
        "includeHeading": "އިންކްލޫޑް ކޮންޑިޝަންތައް (އިޚްތިޔާރީ)",
        "includeHint": "އެކްސްކްލޫޑް ކޮންޑިޝަންތައް، ކޮންމެ އިންކްލޫޑް ކޮންޑިޝަނަކާވެސް ދިމާވާ ކޮމްބިނޭޝަންތަކަށް ހަނިކުރޭ.",
        "addRow": "ކޮންޑިޝަން ރޯއެއް އިތުރުކުރޭ",
        "anyCombination": "ކޮންމެވެސް ކޮމްބިނޭޝަނެއް",
        "fields": {
          "ruleName": "ރޫލްގެ ނަން",
          "effectiveFrom": "ފެށޭ ތާރީޚް",
          "effectiveTo": "ނިމޭ ތާރީޚް",
          "from": "އިން",
          "to": "އަށް"
        },
        "saveAndScan": "ސޭވްކޮށް ސްކޭންކުރޭ",
        "scanResultsTitle": "ސްކޭން ނަތީޖާ — {name}",
        "scanResultsDescription": "މި ރޫލް ބާޠިލުކުރާނެ މިހާރު ހުރި ކޮމްބިނޭޝަންތަކާއި، އެ ބޭނުންކުރި ޖާނަލް ލައިންތަކުގެ ޢަދަދު.",
        "scanned": "ސްކޭންކުރެވުނު ކޮމްބިނޭޝަންތައް",
        "violatingCombinations": "ބާޠިލުވާ ކޮމްބިނޭޝަންތައް",
        "affectedLines": "އަސަރުކުރާ ލައިންތައް",
        "scanTruncated": "ސްކޭން ހުއްޓުނީ {limit} ކޮމްބިނޭޝަންގެ މަތީ ހައްދުގައި — ތިރީގައިވަނީ ސާމްޕަލެއް، ފުރިހަމަ ނަތީޖާއެއް ނޫން.",
        "scanClean": "މި ރޫލް ބާޠިލުކުރާ ކޮމްބިނޭޝަނެއް މިހާރު ނެތް.",
        "lineCount": "ލައިނެއް ނެތް | 1 ލައިން | {count} ލައިން"
      },
      "segmentSecurity": {
        "title": "ސެގްމަންޓް ސެކިއުރިޓީ",
        "description": "ރޯލެއް ނުވަތަ ބިޒްނަސް ޔުނިޓަކަށް ފެންނަ ނުވަތަ ބޭނުންކުރެވޭ ސެގްމަންޓް ވެލިއުތައް ހަނިކުރޭ (F-6.003). \"ސެކިއުރ\" ކަމަށް ފާހަގަކޮށްފައިވާ ސެގްމަންޓްތަކަށް އެކަނި ރޫލެއް ބެހެއްޓޭނެ.",
        "add": "އައު ރޫލް",
        "emptyTitle": "އަދި ސެގްމަންޓް ސެކިއުރިޓީ ރޫލެއް ނެތް",
        "emptyDescription": "ސެކިއުރ ސެގްމަންޓެއްގެ ވެލިއުތައް ހަނިކުރުމަށް ރޫލެއް އިތުރުކުރޭ.",
        "created": "ސެގްމަންޓް ސެކިއުރިޓީ ރޫލް އުފެއްދިއްޖެ",
        "saveFailed": "ސެގްމަންޓް ސެކިއުރިޓީ ރޫލް އުފެއްދިފައެއް ނުވޭ",
        "noSecuredSegments": "މި ޗާޓް އޮފް އެކައުންޓްސްގައި \"ސެކިއުރ\" ކަމަށް ފާހަގަކޮށްފައިވާ ސެގްމަންޓެއް އަދި ނެތް — ފުރަތަމަ ސެގްމަންޓްސް ޓެބުން އެއް ފާހަގަކުރޭ.",
        "previewLabel": "ޕްރިވިއު:",
        "previewFailed": "ޕްރިވިއު ލޯޑްކުރެވިފައެއް ނުވޭ",
        "previewTitle": "ސެގްމަންޓް ސެކިއުރިޓީ ޕްރިވިއު — {segment}",
        "previewEmpty": "މި ސެގްމަންޓަށް ހިނގާ ސެކިއުރިޓީ ރޫލެއް ނެތް — މިހާރު ކޮންމެ ރޯލަކަށްވެސް ކޮންމެ ވެލިއުއެއް ފެންނާނެ.",
        "previewTruncated": "ލިސްޓް ކުރުކޮށްފައި",
        "everyone": "ހުރިހާ ރޯލެއް (ރޯލް ހަނިކުރުމެއް ނެތް)",
        "visibleCount": "ފެންނަ ވެލިއުއެއް ނެތް | 1 ފެންނަ ވެލިއު | {count} ފެންނަ ވެލިއު",
        "hiddenCount": "ފޮރުވިފައިވާ ވެލިއުއެއް ނެތް | 1 ފޮރުވިފައިވާ ވެލިއު | {count} ފޮރުވިފައިވާ ވެލިއު",
        "role": "ރޯލް: {role}",
        "businessUnit": "ބިޒްނަސް ޔުނިޓް: {bu}",
        "saveAndPreview": "ސޭވްކޮށް ޕްރިވިއުކުރޭ",
        "access": {
          "view": "ބެލުން",
          "use": "ބޭނުންކުރުން",
          "both": "ބެލުމާއި ބޭނުންކުރުން"
        },
        "fields": {
          "segment": "ސެގްމަންޓް",
          "valueRange": "ވެލިއު ރޭންޖް",
          "valueRangeHint": "ހަމައެކަނި ވެލިއުއެއް ނުވަތަ ރޭންޖެއް، މިސާލަކަށް \"1000..1999\".",
          "accessType": "އެކްސެސް ބާވަތް",
          "roleId": "ރޯލް އައިޑީ",
          "roleIdHint": "ބިޒްނަސް ޔުނިޓަކުން އެކަނި ހަނިކުރަން ބޭނުންނަމަ ހުހަށް ބަހައްޓާ.",
          "businessUnitId": "ބިޒްނަސް ޔުނިޓް އައިޑީ",
          "businessUnitIdHint": "ރޯލަކުން އެކަނި ހަނިކުރަން ބޭނުންނަމަ ހުހަށް ބަހައްޓާ."
        }
      },
      "valueSets": {
        "title": "ވެލިއު ސެޓްތައް",
        "description": "ސެގްމަންޓް ވެލިއުތަކުގެ އަލުން ބޭނުންކުރެވޭ، ނަންދެވިފައިވާ ސެޓްތައް (FSD 1.2.7.5) — އެއް ސެޓަކުން އެއަށްވުރެ ގިނަ ޗާޓް އޮފް އެކައުންޓްސްގައިވާ ސެގްމަންޓަކަށް ހިދުމަތްދެވިދާނެ.",
        "backToStructures": "ޗާޓް އޮފް އެކައުންޓްސްތަކަށް ރުޖޫޢަވޭ",
        "create": "އައު ވެލިއު ސެޓް",
        "createFirst": "ފުރަތަމަ ވެލިއު ސެޓް އުފައްދާ",
        "createTitle": "އައު ވެލިއު ސެޓް",
        "saved": "ވެލިއު ސެޓް އުފެއްދިއްޖެ",
        "saveFailed": "ވެލިއު ސެޓް އުފެއްދިފައެއް ނުވޭ",
        "loadFailed": "ވެލިއު ސެޓްތައް ލޯޑްކުރެވިފައެއް ނުވޭ",
        "tableLabel": "ވެލިއު ސެޓްތައް",
        "emptyTitle": "އަދި ވެލިއު ސެޓެއް ނެތް",
        "emptyDescription": "އޭގެ ވެލިއުތައް އިތުރުކުރަން ފެށުމަށް ސެޓެއް އުފައްދާ.",
        "kindFilterPlaceholder": "ބާވަތުން ފިލްޓަރކުރޭ",
        "columns": {
          "code": "ކޯޑް",
          "name": "ނަން",
          "kind": "ބާވަތް",
          "parent": "ބެލެނިވެރި ސެޓް"
        },
        "kinds": {
          "independent": "މިނިވަން",
          "dependent": "ބަރޯސާވާ"
        },
        "fields": {
          "code": "ކޯޑް",
          "name": "ނަން",
          "kind": "ބާވަތް",
          "parentValueSetId": "ބެލެނިވެރި ވެލިއު ސެޓް އައިޑީ",
          "parentValueSetIdHint": "ބަރޯސާވާ ސެޓަކަށް މަޖުބޫރު — މި ސެޓުގެ ކޮންމެ ވެލިއުއަކުން ބެލެނިވެރި ސެޓުގެ ވެލިއުއެއް ކޮލިފައިކުރާނެ."
        },
        "detail": {
          "oneTitle": "ވެލިއު ސެޓް",
          "oneDescription": "މި ސެޓަށް ބައިންޑްކުރެވިފައިވާ ކޮންމެ ސެގްމަންޓަކަށް ލިބިދޭ ވެލިއުތައް.",
          "oneLoadFailed": "މި ވެލިއު ސެޓް ލޯޑްކުރެވިފައެއް ނުވޭ",
          "notFound": "މި ވެލިއު ސެޓް ފެނިފައެއް ނުވޭ.",
          "backToList": "ވެލިއު ސެޓްތަކަށް ރުޖޫޢަވޭ",
          "profile": "ޕްރޮފައިލް"
        }
      },
      "segmentValues": {
        "title": "ވެލިއުތައް",
        "description": "ވެލިއުއެއް އުފެއްދުމަށްފަހު ދުވަހަކުވެސް ސީދާ އެޑިޓެއް ނުކުރެވޭނެ — ބަދަލުކުރެވެނީ ނިމޭ ތާރީޚެއް ދީފައި އައު ވެލިއުއެއް ހުޅުވާލައިގެންނެވެ، ސަބަބަކީ މުޢާމަލާތެއްގައި މިހާރުވެސް އެ ވެލިއު ބޭނުންކޮށްފައި ހުރެދާނެތީއެވެ.",
        "add": "ވެލިއު އިތުރުކުރޭ",
        "emptyTitle": "އަދި ވެލިއުއެއް ނެތް",
        "emptyDescription": "މި ސެޓަށް ފުރަތަމަ ވެލިއު އިތުރުކުރޭ.",
        "created": "ވެލިއު އިތުރުކުރެވިއްޖެ",
        "saveFailed": "ވެލިއު އިތުރުކުރެވިފައެއް ނުވޭ",
        "active": "އެކްޓިވް",
        "inactive": "އިންއެކްޓިވް",
        "activate": "އަލުން އެކްޓިވޭޓްކުރޭ",
        "deactivate": "ޑިއެކްޓިވޭޓްކުރޭ",
        "endDate": "ނިމޭ ތާރީޚް ދީ",
        "endDated": "ވެލިއު ނިމޭ ތާރީޚް ދެވިއްޖެ",
        "endDateFailed": "ވެލިއުއަށް ނިމޭ ތާރީޚް ދެވިފައެއް ނުވޭ",
        "endDateTitle": "\"{value}\" އަށް ނިމޭ ތާރީޚް ދީ",
        "fields": {
          "value": "ވެލިއު",
          "description": "ތަފްޞީލް",
          "effectiveFrom": "ފެށޭ ތާރީޚް",
          "effectiveTo": "ނިމޭ ތާރީޚް",
          "parentValueId": "ބެލެނިވެރި ވެލިއު އައިޑީ",
          "parentValueIdHint": "ބަރޯސާވާ ސެޓަކަށް މަޖުބޫރު — މި ވެލިއު ކޮލިފައިކުރާ ބެލެނިވެރި ސެޓުގެ ވެލިއު."
        }
      }
    },
    "geographies": {
      "title": "ޖިއޮގްރަފީ އަދި އެޑްރެސްތައް",
      "description": "މި ޓެނަންޓްގެ އެޑްރެސްތަކާއި ޓެކްސް ޖޫރިސްޑިކްޝަންތައް ރިޒޮލްވްވާ ތަންތަނާއި، ކޮންމެ ޤައުމެއްގައި އެޑްރެސްއެއް ވެލިޑޭޓްވާ ގޮތުގެ ޗެކެއް.",
      "routeTitles": {
        "geographies": "ޖިއޮގްރަފީ އަދި އެޑްރެސްތައް"
      },
      "levels": {
        "country": "ޤައުމު",
        "subdivision": "ސަރަޙައްދު / އަތޮޅު",
        "locality": "ރަށް / ތަން"
      },
      "tree": {
        "title": "ޖިއޮގްރަފީގެ ހައިރާކީ",
        "description": "ޤައުމު، ދެން ސަރަޙައްދު ނުވަތަ އަތޮޅު، ދެން ރަށް ނުވަތަ ތަން، ޤައުމުގެ ޕެކުގައި ތަރުތީބުކޮށްފައިވާ ގޮތަށް.",
        "country": "ޤައުމު",
        "search": "ތަންތަން ހޯދާ",
        "searchPlaceholder": "ނަން ނުވަތަ ކޯޑު",
        "countryInvalid": "ޖިއޮގްރަފީ ބެއްލެވުމަށް ދެ އަކުރުގެ ޤައުމީ ކޯޑެއް ލިޔުއްވާ.",
        "loadFailed": "ޖިއޮގްރަފީ ލޯޑެއް ނުވި",
        "empty": "{country} އަށް އަދި ޖިއޮގްރަފީއެއް ތައްޔާރުކޮށްފައެއް ނުވޭ. އެ ލިބޭނީ ޤައުމުގެ ލޯކަލައިޒޭޝަން ޕެކާއެކުގައެވެ.",
        "count": "{total} ތަން",
        "matching": "{total} ތަނުން {shown} ދައްކާފައި",
        "noMatch": "“{query}” އާ ދިމާވާ އެއްވެސް ތަނެއް ނެތް.",
        "label": "{country} ގެ ޖިއޮގްރަފީ",
        "expand": "{name} ފުޅާކުރޭ",
        "collapse": "{name} ހަނިކުރޭ",
        "inactive": "އިނެކްޓިވް"
      },
      "address": {
        "title": "އެޑްރެސް ޗެކް",
        "description": "ލޮކޭޝަނެއްގައި ރެކޯޑުކުރާ ގޮތަށް އެޑްރެސްއެއް ލިޔުއްވާފައި، އެއީ ވެލިޑް އެޑްރެސްއެއްތޯއާއި ކޮން ތަނަކަށްތޯ ބައްލަވާ. އެއްވެސް އެއްޗެއް ސޭވެއް ނުކުރެވޭނެ.",
        "rulesTitle": "މި ޤައުމުގެ އެޑްރެސް ޤަވާޢިދުތައް",
        "chooseCountry": "ޤަވާޢިދުތައް ބެއްލެވުމަށް ދެ އަކުރުގެ ޤައުމީ ކޯޑެއް ލިޔުއްވާ.",
        "rulesFailed": "އެޑްރެސް ޤަވާޢިދުތައް ލޯޑެއް ނުވި",
        "validationLevel": "ވެލިޑޭޝަން",
        "geoLocality": "ރަޖިސްޓަރީކުރެވިފައިވާ ތަން",
        "required": "ލާޒިމު",
        "notRequired": "ލާޒިމެއް ނޫން",
        "postalCode": "ޕޯސްޓަލް ކޯޑުގެ ނަމޫނާ",
        "noPostalSystem": "ޕޯސްޓަލް ކޯޑެއް ނެތް",
        "resultTitle": "ނަތީޖާ",
        "valid": "ވެލިޑް",
        "invalid": "ވެލިޑެއް ނޫން",
        "checkedAt": "ޗެކްކުރި ފެންވަރު",
        "jurisdiction": "ރިޒޮލްވްވި ތަން",
        "jurisdictionId": "ޖޫރިސްޑިކްޝަން #{id}",
        "missing": "ނެތް ބައިތައް"
      }
    },
    "governance": {
      "routeTitles": {
        "mastership": "މާސްޓަރޝިޕް ރަޖިސްޓްރީ",
        "dependencyPostures": "ބަރޯސާވުމުގެ ހާލަތު",
        "classifications": "ޑޭޓާ ކްލެސިފިކޭޝަން"
      },
      "mastership": {
        "title": "މާސްޓަރޝިޕް ރަޖިސްޓްރީ",
        "description": "ކޮންމެ ޑޭޓާ ދާއިރާއެއްގެ އެންމެ ޞައްޙަ ރެކޯޑް ގެންގުޅޭ ސިސްޓަމް ކަނޑައަޅާ (FND-FR-086).",
        "emptyTitle": "އަދި މާސްޓަރޝިޕް އެންޓްރީއެއް ނެތް",
        "emptyDescription": "މާސްޓަރ ސިސްޓަމާއެކު އެއްވެސް ޑޭޓާ ދާއިރާއެއް ރަޖިސްޓަރ ކުރެވިފައެއް ނުވޭ."
      },
      "dependencyPosture": {
        "title": "ބަރޯސާވުމުގެ ހާލަތު",
        "description": "މޮޑިއުލްތަކުގެ ދެމެދު ބަރޯސާވުމުގެ މުހިންމުކަމާއި ވިޔަފާރީގެ ދެމިއޮތުމަށް ކުރާ އަސަރު (FND-FR-089). ބަރޯސާވާ ކަމެއް ފެއިލްވިޔަސް ދެމިއޮވޭތޯ ބަޔާންކުރޭ.",
        "emptyTitle": "އަދި ބަރޯސާވުމެއް ރަޖިސްޓަރ ކުރެވިފައެއް ނުވޭ",
        "emptyDescription": "މޮޑިއުލްތަކުގެ ދެމެދު ބަރޯސާވުމެއް ބަޔާންކުރެވިފައެއް ނުވޭ."
      },
      "classification": {
        "title": "ޑޭޓާ ކްލެސިފިކޭޝަން",
        "description": "ޑޭޓާ ދާއިރާތަކުގެ ސެންސިޓިވިޓީ ކްލެސިފިކޭޝަނާއި ހޭންޑްލިންގ ބޭނުންވުންތައް: އޮޑިޓް ޓްރެއިލް، ރައްކާކުރާ މުއްދަތު، ރެޒިޑެންސީ ހުރަސްތައް، މާސްކިންގ ގަވާއިދު (FND-FR-090).",
        "emptyTitle": "އަދި ކްލެސިފިކޭޝަނެއް ކަނޑައެޅިފައެއް ނުވޭ",
        "emptyDescription": "އެއްވެސް ޑޭޓާ ދާއިރާއެއް ސެންސިޓިވިޓީއަށް ކްލެސިފައި ކުރެވިފައެއް ނުވޭ."
      },
      "columns": {
        "dataDomain": "ޑޭޓާ ދާއިރާ",
        "masteringModule": "މާސްޓަރިންގ މޮޑިއުލް",
        "enforcement": "ތަންފީޒުކުރުން",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "fromModule": "ފެށޭ މޮޑިއުލް",
        "toModule": "ނިމޭ މޮޑިއުލް",
        "posture": "ހާލަތު",
        "continuesDuringOutage": "ހުއްޓުމެއްގައި ދެމިއޮތުން",
        "note": "ނޯޓް",
        "sensitivity": "ސެންސިޓިވިޓީ",
        "readAuditRequired": "ކިޔުމުގެ އޮޑިޓް",
        "retentionYears": "ރައްކާކުރާ މުއްދަތު (އަހަރު)",
        "residencyConstraint": "ރެޒިޑެންސީ ހުރަސް",
        "maskingRule": "މާސްކިންގ ގަވާއިދު"
      },
      "enforcement": {
        "strict": "ހަރުދަނާ",
        "advisory": "މަޝްވަރާދޭ"
      },
      "posture": {
        "critical": "ކްރިޓިކަލް",
        "important": "މުހިންމު",
        "optional": "އިޚްތިޔާރީ"
      },
      "outage": {
        "continues": "ދެމިއޮވޭ",
        "halts": "ހުއްޓޭ"
      },
      "sensitivity": {
        "public": "ޢާންމު",
        "internal": "އެތެރޭގެ",
        "confidential": "ސިއްރު",
        "restricted": "ހިފެހެއްޓިފައި"
      },
      "audit": {
        "required": "ބޭނުންވޭ",
        "notRequired": "ބޭނުމެއް ނުވޭ"
      }
    },
    "hierarchies": {
      "title": "އޯގަނައިޒޭޝަން ހަޔަރާކީތައް",
      "description": "އެއް އޮގަނައިޒޭޝަންތައް ތަފާތު ބޭނުންތަކަށް ނަން ދެވިފައިވާ، ތާރީޚަށް ބިނާވެފައިވާ އޮނިގަނޑުތަކަކަށް އަތުރާލާށެވެ — މެނޭޖްމަންޓް ރޯލްއަޕް، ޤާނޫނީ މިލްކުވެރިކަން، ޚަރަދު އެއްކުރުން، ސެކިއުރިޓީ ސްކޯޕް އަދި ކޮންސޮލިޑޭޝަން.",
      "tableLabel": "އޯގަނައިޒޭޝަން ހަޔަރާކީތައް",
      "loadFailed": "ހަޔަރާކީ ރަޖިސްޓަރު ލޯޑެއް ނުވި",
      "filters": {
        "anyPurpose": "ކޮންމެ ބޭނުމެއް",
        "anyStatus": "ކޮންމެ ހާލަތެއް",
        "search": "ހޯދާ",
        "searchHint": "ކޯޑު ނުވަތަ ނަން"
      },
      "emptyTitle": "އަދި ހަޔަރާކީއެއް ނެތެވެ",
      "emptyDescription": "އޮނިގަނޑަކަށް ނަމަކާއި އޭގައި ހިމެނޭނެ އޯގަނައިޒޭޝަން ބާވަތްތައް ކަނޑައެޅުމަށް ހަޔަރާކީއެއް އުފައްދާށެވެ. އެއަށްފަހު ވާޝަނެއް އުފައްދައި ނޯޑްތައް އަތުރާލާށެވެ.",
      "created": "ހަޔަރާކީ އުފެއްދިއްޖެ",
      "versionCreated": "ޑްރާފްޓް ވާޝަން އުފެއްދިއްޖެ",
      "versionCreatedDetail": "ވާޝަން {versionNo} ފެށެނީ {nodeCount} ނޯޑާއެކުއެވެ.",
      "defaultBadge": "މި ބޭނުމަށް ޑިފޯލްޓް",
      "openById": "އައިޑީ މެދުވެރިކޮށް ހުޅުވާ",
      "openByIdHint": "ވާޝަނުގެ އައިޑީ އެނގޭނަމަ އެ ވާޝަން ސީދާ ހުޅުވާލެވޭނެއެވެ. ރިޒޯލްވް އަދި ކޮމްޕެއަރއަށް ބޭނުންވަނީ ހަޔަރާކީ އައިޑީ އެކަންޏެވެ.",
      "openVersion": "ވާޝަން ހުޅުވާ",
      "routeTitles": {
        "register": "އޯގަނައިޒޭޝަން ހަޔަރާކީތައް",
        "version": "ހަޔަރާކީ ވާޝަން",
        "compare": "ހަޔަރާކީ ވާޝަންތައް އަޅާކިޔާ",
        "resolve": "ތާރީޚަކަށް ހަޔަރާކީ ރިޒޯލްވްކުރޭ"
      },
      "fields": {
        "code": "ހަޔަރާކީ ކޯޑް",
        "name": "ހަޔަރާކީ ނަން",
        "purpose": "ބޭނުން",
        "permittedNodeTypes": "ހުއްދަ ނޯޑް ބާވަތްތައް",
        "depthLimit": "ފުންމިނުގެ ލިމިޓް",
        "isDefault": "މި ބޭނުމަށް ޑިފޯލްޓް",
        "effectiveFrom": "ފެށޭ ތާރީޚް",
        "effectiveTo": "ނިމޭ ތާރީޚް",
        "effectiveToHint": "ނިމުމެއް ނެތް މުއްދަތަކަށް ހުސްކޮށް ބާއްވާށެވެ.",
        "changeSummary": "ބަދަލުގެ ޚުލާސާ",
        "seedFromActive": "ހިނގަމުންދާ ވާޝަނުން ފަށާ",
        "hierarchyId": "ހަޔަރާކީ އައިޑީ",
        "versionId": "ވާޝަން އައިޑީ",
        "orgType": "އޯގަނައިޒޭޝަން ބާވަތް",
        "orgId": "އޯގަނައިޒޭޝަން އައިޑީ",
        "nodeCount": "ނޯޑްތައް",
        "maxDepth": "އެންމެ ފުން މަގު",
        "blockingFindings": "ހުއްޓުވާ ކަންކަން"
      },
      "purposes": {
        "management": "މެނޭޖްމަންޓް",
        "legal": "ޤާނޫނީ",
        "cost": "ޚަރަދު",
        "security": "ސެކިއުރިޓީ",
        "consolidation": "ކޮންސޮލިޑޭޝަން",
        "reporting": "ރިޕޯޓިންގ"
      },
      "nodeTypes": {
        "division": "ޑިވިޜަން",
        "legal_entity": "ޤާނޫނީ ފަރާތް",
        "business_unit": "ބިޒްނަސް ޔުނިޓް",
        "department": "ޑިޕާޓްމަންޓް",
        "cost_center": "ކޮސްޓް ސެންޓަރ",
        "position": "މަޤާމް"
      },
      "status": {
        "draft": "ޑްރާފްޓް",
        "pending": "ފާސްކުރުމަށް ބަލަހައްޓަނީ",
        "published": "ޝާއިޢުކޮށްފައި",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "hierarchyStatus": {
        "active": "ހިނގަމުންދާ",
        "archived": "އަރުޝީފުކޮށްފައި"
      },
      "routing": {
        "finance": "ފައިނޭންސް",
        "security": "ސެކިއުރިޓީ",
        "hr": "އެޗްއާރ",
        "enterprise": "އެންޓަރޕްރައިޒް ޑޭޓާ އޯނަރ"
      },
      "create": {
        "action": "އާ ހަޔަރާކީ",
        "title": "އާ އޯގަނައިޒޭޝަން ހަޔަރާކީ",
        "description": "އޮނިގަނޑަކަށް ނަމަކާއި އޭގައި ހިމެނޭނެ އޯގަނައިޒޭޝަން ބާވަތްތައް ކަނޑައަޅައެވެ. އޮނިގަނޑު ބިނާކުރެވެނީ އޭގެ ފަހުން، ވާޝަނެއްގެ މަތީގައެވެ.",
        "purposeHint": "ސެކިއުރިޓީ ހަޔަރާކީއެއް ޝާއިޢުކުރުމުން ރޯ ލެވެލް އެކްސެސް ސްކޯޕްތައް އުފައްދައެވެ. އެހެންކަމުން އެފަދަ ހަޔަރާކީއެއް ޝާއިޢުކުރުމަށް ސެކިއުރިޓީ އެޑްމިނިސްޓްރޭޓަރުގެ ހުއްދަވެސް ބޭނުންވެއެވެ.",
        "purposePlaceholder": "ބޭނުމެއް ޚިޔާރުކުރައްވާ",
        "nodeTypesHint": "މި ހަޔަރާކީގައި ބެހެއްޓޭނީ މި ބާވަތްތައް އެކަންޏެވެ. އެހެން ބާވަތެއްގެ ނޯޑެއް ބަލައިނުގަނެ، ހުއްދަ ބާވަތްތައް ދައްކާނެއެވެ.",
        "depthLimitHint": "ޑިފޯލްޓަކީ 8 އެވެ، އަދި {max} އަށްވުރެ އިތުރުވެގެން ނުވާނެއެވެ.",
        "isDefaultHint": "މި ބޭނުމަށް އެހެން މޮޑިއުލްތައް ބަރޯސާވާ ހަޔަރާކީއެވެ."
      },
      "newVersion": {
        "action": "އާ ވާޝަން",
        "title": "އާ ޑްރާފްޓް ވާޝަން",
        "description": "އަތުރާލެވޭ ޑްރާފްޓެއް އުފައްދައެވެ. ޝާއިޢުކުރެވެންދެން އެހެން އެއްވެސް މޮޑިއުލަކަށް މިއެއް ނުފެންނާނެއެވެ.",
        "confirm": "ޑްރާފްޓް އުފައްދާ",
        "overlapNote": "އެއް ހަޔަރާކީގެ ވާޝަންތަކުގެ މުއްދަތު އޯވަރލެޕް ވެގެން ނުވާނެއެވެ. މިކަން ބަލަނީ ޝާއިޢުކުރާ ވަގުތުއެވެ، އަދި ބަލައިނުގަނެވިއްޖެނަމަ އޯވަރލެޕްވާ ވާޝަނާއި އޭގެ މުއްދަތު ދައްކާނެއެވެ.",
        "seedHint": "އޮން ކުރުމުން، ފެށޭ ތާރީޚުގައި ހިނގަމުންދާ ވާޝަނުގެ ކޮޕީއަކުން ޑްރާފްޓް ފަށާނެއެވެ. އޮފް ކުރުމުން ހުސްކޮށް ފަށާނެއެވެ.",
        "changeSummaryHint": "މިތާނގައި އިޚްތިޔާރީ، ނަމަވެސް ފާސްކުރުމަށް ހުށަހަޅާއިރު ލާޒިމެވެ."
      },
      "canvas": {
        "title": "ނޯޑް އެތުރުން",
        "addRoot": "ރޫޓް ނޯޑެއް އިތުރުކުރޭ",
        "addChildOf": "{name} ގެ ދަށުގައި ނޯޑެއް އިތުރުކުރޭ",
        "retimeOf": "{name} ގެ މުއްދަތު ބަދަލުކުރޭ",
        "removeOf": "މި ޑްރާފްޓުން {name} ނަގާ",
        "nodeLabel": "{type} ނަންބަރު {id}",
        "windowOpen": "{from} އިން ފެށިގެން، ނިމުމެއް ނެތި",
        "windowClosed": "{from} އިން {to} އަށް",
        "depthOf": "ފުންމިން {depth}، ލިމިޓް {limit}",
        "detached": "ރޫޓަކުން ނުފޯރާ",
        "empty": "މި ވާޝަނުގައި އަދި ނޯޑެއް ނެތެވެ. އޮނިގަނޑު ބިނާކުރަން ފެށުމަށް ރޫޓް ނޯޑެއް އިތުރުކުރާށެވެ.",
        "arrangeFailed": "އެތުރުން ބަލައިނުގަނެވުނެވެ"
      },
      "a11y": {
        "help": "ނޯޑްތަކުގެ މެދުގައި ދިއުމަށް އެރޯ ކީތައް ބޭނުންކުރާށެވެ. ނޯޑެއް ނެގުމަށް ސްޕޭސް ފިއްތުމަށްފަހު، އެރޯ ކީތަކުން ތަރުތީބުކުރުން، މަތީ ނޯޑްގެ ދަށަށް ލުން ނުވަތަ ބޭރަށް ނެރުން ކުރެވިދާނެއެވެ. ބޭއްވުމަށް އެސްކޭޕް ފިއްތާށެވެ. ނޯޑް ނުނަގާ ހަމަ އެ ހަރަކާތް ކުރުމަށް އޯލްޓާއެކު އެރޯ ކީ ފިއްތާށެވެ.",
        "helpReadOnly": "ނޯޑްތަކުގެ މެދުގައި ދިއުމަށާއި ގޮފިތައް ހުޅުވާ ލެއްޕުމަށް އެރޯ ކީތައް ބޭނުންކުރާށެވެ. މި ވާޝަނަކީ ޑްރާފްޓެއް ނޫން ކަމުން އޭގެ އޮނިގަނޑު ބަދަލެއް ނުކުރެވޭނެއެވެ.",
        "expand": "{name} ހުޅުވާ",
        "collapse": "{name} ލައްޕާ",
        "movingStart": "{name} ނަގައިފިން. ބެހެއްޓުމަށް އެރޯ ކީތައް ބޭނުންކުރާށެވެ.",
        "movingStop": "{name} ބާއްވައިފިން.",
        "movingBadge": "ގެންދަނީ",
        "moveUnavailable": "މިތަނުން އެ ހަރަކާތް ނުކުރެވޭނެއެވެ.",
        "dropRefused": "އެ ނޯޑް އެތަނަށް ނުލެވޭނެއެވެ.",
        "arrangedClean": "{count} ބަދަލު ހިންގައިފިއެވެ. އޮނިގަނޑު ރަނގަޅެވެ.",
        "arrangedWithFindings": "{count} ބަދަލު ހިންގައިފިއެވެ. {findings} ކަމަކަށް ސަމާލުކަން ބޭނުމެވެ.",
        "arrangeRefused": "ބަދަލު ބަލައިނުގަނެވުނެވެ، އަދި އޮނިގަނޑަށް ބަދަލެއް ނާދެއެވެ."
      },
      "addNode": {
        "title": "އޯގަނައިޒޭޝަނެއް ބަހައްޓާ",
        "asRoot": "އޮނިގަނޑުގެ އެންމެ މަތީގައި، ބެލެނިވެރިއެއް ނެތިއެވެ.",
        "underParent": "{parent} ގެ ދަށުގައި ބެހެއްޓިއްޖެއެވެ.",
        "confirm": "ނޯޑް ބަހައްޓާ",
        "typePlaceholder": "ބާވަތެއް ޚިޔާރުކުރައްވާ",
        "typesUnknown": "މި ސެޝަނުގައި މި ހަޔަރާކީގެ ހުއްދަ ނޯޑް ބާވަތްތައް ނެތުމުން ހުރިހާ ބާވަތެއް ދައްކައެވެ. ހަޔަރާކީ ހުއްދަ ނުކުރާ ބާވަތެއް ސާވަރުން ބަލައިނުގަނެ، ހުއްދަ ބާވަތްތައް ދައްކާނެއެވެ.",
        "orgIdHint": "ބަހައްޓާ އޯގަނައިޒޭޝަނުގެ ނަންބަރު އައިޑީއެވެ.",
        "windowHint": "ދެ ގޮޅިވެސް ހުސްކޮށް ބޭއްވުމުން ވާޝަނުގެ މުއްދަތު ވާރުތަވެ، ބެލެނިވެރިޔާގެ މުއްދަތުގެ ތެރޭގައި ނޯޑް ހިފެހެއްޓޭނެއެވެ."
      },
      "retime": {
        "title": "މުއްދަތު",
        "description": "{name} މިހާރު ހުރި ތަނުގައި ހުންނާނެ މުއްދަތު ބަދަލުކުރެއެވެ.",
        "containment": "ނޯޑެއްގެ މުއްދަތު އޮންނަންވާނީ އޭގެ ބެލެނިވެރިޔާގެ މުއްދަތުގެ ތެރޭގައެވެ. ބެލެނިވެރިޔާއަށްވުރެ ދަރިފުޅު ހަނިކޮށްފިނަމަ ދެ ފަރާތުގައިވެސް އެކަން ފާހަގަކުރެވޭނެއެވެ.",
        "openEndedHint": "ނިމުމެއް ނެތް މުއްދަތަކަށް މި ހުސްކުރާށެވެ."
      },
      "validate": {
        "action": "ވެލިޑޭޓް",
        "failed": "މި ވާޝަން ވެލިޑޭޓް ނުކުރެވުނެވެ",
        "findingsTitle": "ވެލިޑޭޝަން ނަތީޖާތައް",
        "clean": "އެއްވެސް މައްސަލައެއް ނެތެވެ. ސައިކަލް، ފުންމިން، ތާރީޚް ހިފެހެއްޓުން އަދި ނޯޑް ބާވަތް ހުރިހާ ޗެކެއް ފާސްވެއްޖެއެވެ."
      },
      "submit": {
        "action": "ފާސްކުރުމަށް ހުށަހަޅާ",
        "title": "ފާސްކުރުމަށް ހުށަހެޅުން",
        "description": "ވާޝަން {versionNo} ހުށަހަޅައި، އިތުރަށް އަތުރާލުން ބަންދުކުރެއެވެ.",
        "confirm": "ހުށަހަޅާ",
        "working": "ހުށަހަޅަނީ",
        "locksDraft": "ފާސްކުރުމުގެ މަރުހަލާގައި މި ޑްރާފްޓުގެ {nodeCount} ނޯޑް ހިފެހެއްޓޭނެއެވެ. އެއީ ފާސްކުރާ ފަރާތް ބަލަމުންދާ އޮނިގަނޑު ބަދަލުވިޔަނުދިނުމަށެވެ.",
        "routedTo": "މިއީ {queue} އަށް ފޮނުވޭނެއެވެ.",
        "routedUnknown": "ހަޔަރާކީގެ ބޭނުމަށް ބަލައި ފޮނުވޭނެއެވެ.",
        "changeSummaryHint": "ލާޒިމެވެ. މިއީ ވާޝަން ތާރީޚާއި އޮޑިޓް ލޮގުގައި ފެންނާނެ، އަދި ފާސްކުރާ ފަރާތް އެންމެ ފުރަތަމަ ކިޔާނެ ބަޔާނެވެ.",
        "done": "ފާސްކުރުމަށް ހުށަހަޅައިފި",
        "doneRouted": "{queue} އަށް ފޮނުވިއްޖެއެވެ.",
        "doneNoQueue": "ޑްރާފްޓް މިހާރު ފާސްކުރުމަށް ބަލަހައްޓަނީއެވެ."
      },
      "publish": {
        "action": "ޝާއިޢުކުރޭ",
        "title": "މި ވާޝަން ޝާއިޢުކުރުން",
        "subject": "{code}، ވާޝަން {versionNo}",
        "subjectVersionOnly": "ވާޝަން {versionNo}",
        "headline": "މިކަން އަނބުރާ ނުގެނެވޭނެއެވެ.",
        "consequence": "ޝާއިޢުކުރުމުން މި ވާޝަން ދާއިމަށް ހިފެހެއްޓޭނެއެވެ. އަލުން އުނިއިތުރެއް ނުވަތަ އަލުން ޝާއިޢުކުރުމެއް ނުކުރެވޭނެއެވެ — ފަހުން އޮނިގަނޑު ބަދަލުކުރެވޭނެ ހަމައެކަނި ގޮތަކީ އާ ޑްރާފްޓެކެވެ، އެއީ ރޯލްބެކް މެދުވެރިކޮށް މި ވާޝަނުން ފެށިދާނެއެވެ.",
        "supersedes": "މިހާރު ހިނގަމުންދާ ވާޝަން، މި ވާޝަން ފެށޭ ތާރީޚުގައި ބަންދުކުރެވޭނެއެވެ، އަދި އޭގެ އޮނިގަނޑު އޭގެ އަމިއްލަ ތާރީޚުތަކަށް ކިޔޭގޮތަށް ދެމިއޮންނާނެއެވެ. އެހެން މޮޑިއުލްތަކަށް ބަދަލު ފެންނަން ކުރިން، ކްލޯޝަރ ކޭޝް އަދި ހުރިހާ އެކްސެސް ސްކޯޕެއް އަލުން އުފައްދާނެއެވެ.",
        "securityPurpose": "މިއީ ސެކިއުރިޓީ ހަޔަރާކީއެކެވެ: ޝާއިޢުކުރުމުން ރޯ ލެވެލް އެކްސެސް ސްކޯޕްތައް އަލުން އުފައްދާތީ، ސެކިއުރިޓީ އެޑްމިނިސްޓްރޭޓަރުގެ ހުއްދަވެސް ބޭނުންވެއެވެ.",
        "securityCaveat": "މި ސެޝަނުގައި މި ހަޔަރާކީގެ ބޭނުން ނެތެވެ. މިއީ ސެކިއުރިޓީ ހަޔަރާކީއެއް ނަމަ، ޝާއިޢުކުރުމަށް ސެކިއުރިޓީ އެޑްމިނިސްޓްރޭޓަރުގެ ހުއްދަވެސް ބޭނުންވެ، އެ ނެތްނަމަ ބަލައިނުގަނެވޭނެއެވެ.",
        "noteLabel": "ފާސްކުރާ ފަރާތުގެ ނޯޓް",
        "noteHint": "އިޚްތިޔާރީއެވެ. ހުށަހެޅި ބަދަލުގެ ޚުލާސާއާއެކު ޝާއިޢުކުރުމުގެ އޮޑިޓް ރޯގައި ރައްކާކުރެވެއެވެ.",
        "confirmLabel": "ކަށަވަރުކުރުމަށް {versionNo} ލިޔުއްވާ",
        "confirmHint": "ވާޝަން ނަންބަރު އަލުން ލިޔުމުން، މިއީ ހަމައެކަނި ކްލިކެއް ނޫން، ގަސްދުގައި ކުރާ ކަމަކަށް ވެއެވެ.",
        "confirm": "ވާޝަން ޝާއިޢުކުރޭ",
        "working": "ޝާއިޢުކުރަނީ",
        "done": "ވާޝަން {versionNo} ޝާއިޢުކޮށްފި",
        "doneDetail": "{closure} ކްލޯޝަރ ރޯ އަދި {scopes} ސްކޯޕް ރޯ އަލުން އުފައްދައިފިއެވެ."
      },
      "rollback": {
        "action": "ރޯލްބެކް",
        "title": "ކުރީގެ ވާޝަނަކުން ޑްރާފްޓެއް އުފައްދާ",
        "description": "ކުރީގެ އޮނިގަނޑެއް، އުނިއިތުރު ގެނެވޭ އާ ޑްރާފްޓެއްގެ ގޮތުގައި އަލުން ބަޔާންކުރެއެވެ.",
        "headline": "ޝާއިޢުކޮށްފައިވާ އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވާނެއެވެ.",
        "consequence": "ތިޔަ ކަނޑައަޅާ ވާޝަނުގެ ނޯޑްތަކާއެކު އާ ޑްރާފްޓް ވާޝަނެއް އުފެދޭނެއެވެ. މިހާރު ހުރި އެއްވެސް ވާޝަނަކަށް އުނިއިތުރެއް، ފޮހެލުމެއް ނުވަތަ ތަރުތީބު ބަދަލުކުރުމެއް ނާންނާނެއެވެ، އަދި މިހާރު ހިނގަމުންދާ ވާޝަން، އާ ޑްރާފްޓް ޝާއިޢުކުރެވެންދެން ހިނގަމުންދާނެއެވެ.",
        "pickVersion": "މި ސެޝަނުގައި ފެނުނު ވާޝަންތައް",
        "pickVersionHint": "އަލުން ބަޔާންކުރެވޭނީ ހަޤީޤަތުގައި ހިނގާފައިވާ ވާޝަންތައް އެކަންޏެވެ. އެއް ޚިޔާރުކުރުމުން ތިރީގައިވާ އައިޑީ ގޮޅި ފުރޭނެއެވެ.",
        "pickVersionPlaceholder": "ވާޝަނެއް ޚިޔާރުކުރައްވާ",
        "versionOption": "ވާޝަން {versionNo}، {status}، {from} އިން",
        "versionId": "އަލުން ބަޔާންކުރާ ވާޝަން އައިޑީ",
        "versionIdHint": "އޭޕީއައި އިން ވާޝަން ލިސްޓެއް ނުދޭތީ، މި ސެޝަނުގައި ނުފެންނަ ވާޝަނެއް ލިޔެވެނީ އޭގެ އައިޑީއިންނެވެ.",
        "changeSummaryHint": "އާ ޑްރާފްޓަށް ގެންދެވޭނެއެވެ، އެއީ ފަހުން ހުށަހަޅާއިރު ބޭނުންވާ ޚުލާސާ ތައްޔާރަށް އޮތުމަށެވެ.",
        "confirm": "ޑްރާފްޓް އުފައްދާ",
        "working": "ޑްރާފްޓް އުފައްދަނީ",
        "done": "ކުރީގެ ވާޝަނުން ޑްރާފްޓް އުފެއްދިއްޖެ",
        "doneDetail": "ވާޝަން {versionNo} އަކީ {nodeCount} ނޯޑް ހިމެނޭ ޑްރާފްޓެކެވެ. ޝާއިޢުކޮށްފައިވާ އެއްވެސް އެއްޗެއް ބަދަލެއް ނުވެއެވެ."
      },
      "compare": {
        "action": "އަޅާކިޔާ",
        "title": "ވާޝަންތައް އަޅާކިޔުން",
        "description": "މި ހަޔަރާކީގެ ކޮންމެ ދެ ވާޝަނެއްގެ މެދުގައި އިތުރުވި، ބަދަލުވި އަދި ނެގުނު އޯގަނައިޒޭޝަންތައް، ޢަދަދާއެކު ދައްކައެވެ.",
        "fromVersionId": "ފެށޭ ވާޝަން އައިޑީ",
        "toVersionId": "ނިމޭ ވާޝަން އައިޑީ",
        "run": "އަޅާކިޔާ",
        "failed": "މި ވާޝަންތައް އަޅާނުކިޔުނެވެ",
        "idHint": "އަޅާކިޔެނީ އޯގަނައިޒޭޝަނަށް ބަލައިގެންނެވެ، ނޯޑް އައިޑީއަށް ބަލައިގެން ނޫނެވެ. އެއީ ނޯޑް އައިޑީ ވާޝަންތަކުގެ މެދުގައި ހިއްސާނުވާތީއެވެ.",
        "knownVersions": "މި ސެޝަނުގައި ފެނުނު ވާޝަންތައް: {list}",
        "added": "އިތުރުވި",
        "moved": "ބަދަލުވި",
        "removed": "ނެގުނު",
        "unchanged": "ބަދަލެއް ނުވާ",
        "none": "އެއްވެސް އެއްޗެއް ނެތް",
        "between": "ވާޝަން {from} އާއި ވާޝަން {to} އާ ދެމެދުއެވެ.",
        "movedDetail": "{from} އިން {to} އަށް",
        "rootParent": "އޮނިގަނޑުގެ އެންމެ މަތި"
      },
      "resolve": {
        "action": "ތާރީޚަކަށް ރިޒޯލްވްކުރޭ",
        "title": "ތާރީޚަކަށް ރިޒޯލްވްކުރުން",
        "description": "ކޮންމެ ތާރީޚެއްގައިވެސް އޮނިގަނޑު އޮތްގޮތަށް، އޯގަނައިޒޭޝަނެއްގެ މަތީ ފަރާތްތަކާއި ދަށު ފަރާތްތަކާއި ރޯލްއަޕް މަގު ދައްކައެވެ. ބަދަލުކުރެވިފައިވާ ވާޝަންތަކުގެ ތާރީޚުތައްވެސް ހިމެނެއެވެ.",
        "asAt": "ތާރީޚް",
        "asAtHint": "ކޮންމެ ތާރީޚެކެވެ. ފާއިތުވި ތާރީޚަކަށް ޖަވާބުދެނީ އެ ދުވަހު ހިނގަމުންދިޔަ ވާޝަނުންނެވެ.",
        "run": "ރިޒޯލްވްކުރޭ",
        "failed": "އެ އޯގަނައިޒޭޝަން ރިޒޯލްވް ނުކުރެވުނެވެ",
        "answeredBy": "ޖަވާބުދިނީ ވާޝަން {versionNo}، ތާރީޚް {asAt}",
        "answeredByCurrent": "މިއީ އެ ތާރީޚަށް މިހާރު ހިނގަމުންދާ ވާޝަނެވެ.",
        "answeredBySuperseded": "މި ވާޝަން މިހާރު ބަދަލުކުރެވިފައިވެއެވެ. ތިޔަ އެދުނު ތާރީޚުގައި ހިނގަމުންދިޔައީ މި އޮނިގަނޑެވެ، އަދި ފާއިތުވި ތާރީޚުތަކަށް ޖަވާބުދެވެނީ އެހެންވެގެންނެވެ.",
        "versionBadge": "ވާޝަން {versionNo}",
        "rollupPath": "ރޯލްއަޕް މަގު",
        "rollupPathHint": "ރޫޓުން ފެށިގެން އެ އޯގަނައިޒޭޝަނާ ހަމައަށް — މި ހަޔަރާކީގައި ޢަދަދެއް މައްޗަށް ދަތުރުކުރާ މަގެވެ.",
        "ancestors": "މަތީ ފަރާތްތައް",
        "descendants": "ދަށު ފަރާތްތައް",
        "isRoot": "މި ތާރީޚުގައި މި އޯގަނައިޒޭޝަން ހުރީ އޮނިގަނޑުގެ އެންމެ މަތީގައެވެ.",
        "isLeaf": "މި ތާރީޚުގައި މި އޯގަނައިޒޭޝަނަށް އެއްވެސް އެއްޗެއް ރޯލްއަޕް ނުވެއެވެ."
      },
      "version": {
        "title": "ވާޝަން {versionNo}",
        "titleById": "ވާޝަން ނަންބަރު {versionId}",
        "subtitle": "{name}، {purpose} ހަޔަރާކީއެއް",
        "subtitleUnknown": "ހަޔަރާކީ ނަންބަރު {hierarchyId}",
        "readOnlyTitle": "މި ވާޝަނަށް އުނިއިތުރެއް ނުގެނެވޭނެ",
        "readOnly": {
          "pending": "މިއޮތީ ފާސްކުރުމުގެ މަރުހަލާގައެވެ. ބަލަމުންދާ ވަގުތު ބަދަލުވެދާނެ އޮނިގަނޑަކީ އެއްވެސް މީހަކު ފާސްކުރި އޮނިގަނޑެއް ނޫނެވެ. ބަދަލެއް ބޭނުންނަމަ އާ ޑްރާފްޓަކަށް ރޯލްބެކް ކުރާށެވެ.",
          "published": "ޝާއިޢުކޮށްފައިވާ ވާޝަނަކީ ދާއިމީ އެއްޗެކެވެ: އެއީ އޭގެ ތާރީޚުތަކަށް ހިނގަމުންދިޔަ އޮނިގަނޑުގެ ރެކޯޑެވެ، އަދި ރިޕޯޓިންގ އަދިވެސް އެއަށް ބަރޯސާވެއެވެ. އާ ވާޝަނެއް އުފައްދާށެވެ، ނުވަތަ މިއިން އާ ޑްރާފްޓެއް އުފައްދާށެވެ.",
          "superseded": "ފަހުގެ ވާޝަނެއް ހިނގަން ފަށައިފިއެވެ. މި ވާޝަން އޮތްގޮތަށް ދެމިއޮންނަނީ އޭގެ މުއްދަތުގެ ތާރީޚުތައް ރަނގަޅަށް ރިޒޯލްވްވުމަށްޓަކައެވެ. އަލުން ބަޔާންކުރުމަށް އާ ޑްރާފްޓަކަށް ރޯލްބެކް ކުރާށެވެ."
        },
        "statusUnknownTitle": "މި ވާޝަނުގެ ޝާއިޢުކުރުމުގެ ހާލަތު މިތަނުން ނުލިބެއެވެ",
        "statusUnknown": "އޭޕީއައި އިން ވާޝަން ރީޑެއް ނުދޭތީ، ހަމައެކަނި އައިޑީއިން ހުޅުވި ވާޝަނެއް މި ސްކްރީނުން ހުށަހެޅުމެއް ނުވަތަ ޝާއިޢުކުރުމެއް ނުކުރެވޭނެއެވެ. ރަޖިސްޓަރުން ހުޅުވާށެވެ، ނުވަތަ އެތަނުން އާ ވާޝަނެއް އުފައްދާށެވެ.",
        "structureUnavailableTitle": "މި ވާޝަނުގައި މިތަނުން ނުދެއްކޭ {count} ނޯޑް އެބަހުއްޓެވެ",
        "structureUnavailable": "ވާޝަނެއްގެ ނޯޑްތައް ކިޔާ އޭޕީއައި އެއް ނެތެވެ، އަދި މި ބްރައުޒާ ސެޝަނަށް އެ ނޯޑްތައް ދީފައެއް ނުވެއެވެ. ކެންވަސް ހުސްކޮށް ދެއްކުމުގެ ބަދަލުގައި ނުދައްކަނީ، ހުސް ކެންވަހެއް ފެނިއްޖެނަމަ މިހާރުވެސް ބެހެއްޓިފައިވާ އޯގަނައިޒޭޝަންތައް އަލުން އިތުރުކުރެވިދާނެތީއެވެ.",
        "whatYouCanDo": "މޭގެ ބަދަލުގައި ކުރެވިދާނެ ކަންކަން",
        "optionResolve": "ޝާއިޢުކޮށްފައިވާ އޮނިގަނޑު ކިޔުމަށް، ތާރީޚަކަށް އޯގަނައިޒޭޝަނެއް ރިޒޯލްވްކުރާށެވެ.",
        "optionCompare": "ތަފާތު ބެލުމަށް، މި ވާޝަން އެހެން ވާޝަނަކާ އަޅާކިޔާށެވެ.",
        "optionRollback": "މި ވާޝަނުން އާ ޑްރާފްޓެއް އުފައްދައި، އެ ޑްރާފްޓް އަތުރާލާށެވެ."
      }
    },
    "ledgers": {
      "routeTitles": {
        "ledgers": "ލެޖަރުތައް",
        "ledgerSets": "ލެޖަރު ސެޓްތައް",
        "accountingMethods": "އެކައުންޓިންގ ގޮތްތައް",
        "accountingCalendars": "އެކައުންޓިންގ ކަލަންޑަރުތައް"
      },
      "title": "ލެޖަރުތައް",
      "description": "ކޮންމެ ލެޖަރެއް، އޭގެ ޤާނޫނީ ފަރާތާއި ދައުރާއި ފަންކްޝަނަލް ފައިސާއާއެކު. ލެޖަރެއް ފުޅާކޮށް، އެ ލެޖަރު ރިޕޯޓްކުރާ އެހެން ފައިސާތައް ބަލާ.",
      "loadFailed": "ލެޖަރުތައް ލޯޑެއް ނުވި.",
      "tableLabel": "ލެޖަރުތައް",
      "emptyTitle": "އަދި އެއްވެސް ލެޖަރެއް ނެތް",
      "emptyDescription": "ކޮންމެ ޤާނޫނީ ފަރާތަކަށް އޭގެ ޕްރައިމަރީ ލެޖަރު ލިބެނީ އެ ފަރާތް އުފައްދާއިރުއެވެ.",
      "filterLegalEntity": "ޤާނޫނީ ފަރާތުން ފިލްޓަރކުރޭ",
      "activeOnly": "އެކްޓިވް އެކަނި",
      "idHint": "ރެކޯޑް އައިޑީ",
      "columns": {
        "ledger": "ލެޖަރު",
        "legalEntity": "ޤާނޫނީ ފަރާތް",
        "coaStructure": "ހިސާބުތަކުގެ ޗާޓުގެ ބިނާ",
        "calendar": "އެކައުންޓިންގ ކަލަންޑަރު",
        "accountingMethod": "އެކައުންޓިންގ ގޮތް",
        "role": "ދައުރު",
        "currency": "ފައިސާ"
      },
      "notAttached": "ގުޅާފައެއް ނުވޭ",
      "roles": {
        "primary": "ޕްރައިމަރީ",
        "secondary": "ސެކަންޑަރީ",
        "reporting": "ރިޕޯޓިންގ"
      },
      "statuses": {
        "active": "އެކްޓިވް",
        "inactive": "އިނެކްޓިވް"
      },
      "periodStatuses": {
        "open": "ހުޅުވާލާފައި",
        "soft_closed": "ލުއިކޮށް ބަންދުކޮށްފައި",
        "closed": "ބަންދުކޮށްފައި",
        "permanently_closed": "ދާއިމީކޮށް ބަންދުކޮށްފައި"
      },
      "reportingCurrencies": {
        "title": "ރިޕޯޓިންގ ފައިސާ — {ledger}",
        "description": "މި ލެޖަރުގެ ފަންކްޝަނަލް ފައިސާ {currency} އަށް އިތުރަށް ރިޕޯޓްކުރާ ފައިސާތައް.",
        "add": "ރިޕޯޓިންގ ފައިސާއެއް އިތުރުކުރޭ",
        "noAccess": "ރިޕޯޓިންގ ފައިސާ ބެލުމުގެ ހުއްދައެއް ނެތް.",
        "loadFailed": "ރިޕޯޓިންގ ފައިސާ ލޯޑެއް ނުވި.",
        "empty": "މި ލެޖަރު ރިޕޯޓްކުރަނީ އޭގެ ފަންކްޝަނަލް ފައިސާއިން އެކަނި.",
        "current": "މިހާރު",
        "ended": "ނިމިފައި",
        "saved": "{currency} އަކީ {ledger} ގެ ރިޕޯޓިންގ ފައިސާއެއްގެ ގޮތުގައި އިތުރުކުރެވިއްޖެ",
        "saveFailed": "ރިޕޯޓިންގ ފައިސާ އިތުރެއް ނުކުރެވުނު.",
        "toggle": "ރިޕޯޓިންގ ފައިސާ",
        "show": "ރިޕޯޓިންގ ފައިސާ",
        "hide": "ފައިސާ ފޮރުވާ",
        "bases": {
          "spot": "ސްޕޮޓް ރޭޓް",
          "average": "އެވްރެޖް ރޭޓް",
          "historical": "ހިސްޓޯރިކަލް ރޭޓް",
          "closing": "ކްލޯޒިންގ ރޭޓް"
        },
        "fields": {
          "currency": "ފައިސާ",
          "effectiveFrom": "ފެށޭ ތާރީޚް",
          "basis": "ބަދަލުކުރާ ގޮތް"
        }
      },
      "resolve": {
        "title": "ލެޖަރު ސެލެކްޓަރ",
        "description": "މި ޤާނޫނީ ފަރާތަށް މި ތާރީޚުގައި ކުރާ ޕޯސްޓިންގއެއް ދާނީ ކޮން ލެޖަރަކާއި ކޮން މުއްދަތަކަށް؟ މި ޖަވާބަކީ ކޮންމެ ޕޯސްޓިންގއެއް ބޭނުންކުރާ ޖަވާބެވެ.",
        "legalEntity": "ޤާނޫނީ ފަރާތް",
        "legalEntityIdHint": "ޤާނޫނީ ފަރާތުގެ އައިޑީ",
        "on": "ތާރީޚް",
        "onHint": "މިއަދަށް ހުސްކޮށް ދޫކޮށްލާ.",
        "run": "ހޯދާ",
        "resolving": "ހޯދަނީ",
        "ledger": "ލެޖަރު",
        "onDate": "ތާރީޚަށް",
        "period": "މުއްދަތު",
        "periodStatus": "މުއްދަތުގެ ހާލަތު",
        "allowed": "ޕޯސްޓްކުރެވޭނެ",
        "warning": "އިންޒާރަކާއެކު ޕޯސްޓްކުރެވޭނެ",
        "blocked": "ޕޯސްޓްކުރުން މަނާ",
        "noPeriod": "މި ތާރީޚް ހިމެނޭ މުއްދަތެއް ނެތް"
      },
      "methods": {
        "title": "އެކައުންޓިންގ ގޮތްތައް",
        "description": "ލެޖަރެއް ބިނާކުރެވޭ އެކައުންޓިންގ ގޮތްތައް. ސިސްޓަމް ގޮތްތައް އަންނަނީ ޕްރޮޑަކްޓާއެކު؛ ޤާނޫނީ ނުވަތަ މެނޭޖްމަންޓް ބާވަތްތަކަށް ތިމާގެ ގޮތްތައް އިތުރުކުރޭ.",
        "loadFailed": "އެކައުންޓިންގ ގޮތްތައް ލޯޑެއް ނުވި.",
        "tableLabel": "އެކައުންޓިންގ ގޮތްތައް",
        "emptyTitle": "އަދި އެއްވެސް އެކައުންޓިންގ ގޮތެއް ނެތް",
        "emptyDescription": "ލެޖަރެއް ބިނާކުރާއިރު ބޭނުންކުރުމަށް އެކައުންޓިންގ ގޮތެއް އިތުރުކުރޭ.",
        "create": "އައު އެކައުންޓިންގ ގޮތެއް",
        "createTitle": "އައު އެކައުންޓިންގ ގޮތެއް",
        "createDescription": "ލެޖަރުތަކުން މި ގޮތަށް ރިފަރކުރަނީ ކޯޑުންނެވެ.",
        "created": "އެކައުންޓިންގ ގޮތް {code} އިތުރުކުރެވިއްޖެ",
        "createFailed": "އެކައުންޓިންގ ގޮތް އިތުރެއް ނުކުރެވުނު.",
        "system": "ސިސްޓަމް",
        "tenant": "ތިމާގެ",
        "columns": {
          "code": "ކޯޑް",
          "name": "ނަން",
          "origin": "މަސްދަރު"
        },
        "fields": {
          "description": "ތަފްސީލު"
        }
      },
      "sets": {
        "title": "ލެޖަރު ސެޓްތައް",
        "description": "ޗާޓް އޮފް އެކައުންޓްސް ސްޓްރަކްޗަރެއް ހިއްސާކުރާ ލެޖަރުތަކުގެ ނަން ދީފައިވާ ގްރޫޕްތައް، ގުޅުވައިގެން ރިޕޯޓްކުރުމަށާއި މުއްދަތުތައް އެކުގައި ބަންދުކުރުމަށް.",
        "loadFailed": "ލެޖަރު ސެޓްތައް ލޯޑެއް ނުވި.",
        "tableLabel": "ލެޖަރު ސެޓްތައް",
        "emptyTitle": "އަދި އެއްވެސް ލެޖަރު ސެޓެއް ނެތް",
        "emptyDescription": "ގިނަ ލެޖަރުތަކެއްގެ ރިޕޯޓް އެކުގައި ނެގުމަށް ނުވަތަ މުއްދަތުތައް އެއްފަހަރާ ބަންދުކުރުމަށް ލެޖަރު ސެޓެއް ހަދާ.",
        "create": "އައު ލެޖަރު ސެޓެއް",
        "createTitle": "އައު ލެޖަރު ސެޓެއް",
        "createDescription": "އިތުރުކުރާ ކޮންމެ ލެޖަރެއް ބޭނުންކުރަން ޖެހޭނީ އެއް ޗާޓް އޮފް އެކައުންޓްސް ސްޓްރަކްޗަރެވެ.",
        "created": "ލެޖަރު ސެޓް {code} ހެދިއްޖެ",
        "createFailed": "ލެޖަރު ސެޓް ނުހެދުނު.",
        "columns": {
          "set": "ލެޖަރު ސެޓް",
          "structure": "ޗާޓް އޮފް އެކައުންޓްސް ސްޓްރަކްޗަރ",
          "calendar": "ކަލަންޑަރު"
        },
        "fields": {
          "code": "ކޯޑް",
          "name": "ނަން",
          "calendarHint": "އިޚްތިޔާރީ. ދެން ސެޓުގެ ލެޖަރުތައް ބަންދުކުރާނީ އެއް ކަލަންޑަރަކަށް."
        },
        "members": {
          "show": "މެމްބަރުން",
          "title": "{code} ގެ މެމްބަރުން",
          "titlePlain": "ލެޖަރު ސެޓުގެ މެމްބަރުން",
          "description": "މި ސެޓުގައިވާ ލެޖަރުތަކާއި، ކޮންމެ މެމްބަރޝިޕެއް ހިނގާ ތާރީޚްތައް.",
          "add": "ލެޖަރެއް އިތުރުކުރޭ",
          "loadFailed": "މި ލެޖަރު ސެޓް ލޯޑެއް ނުވި.",
          "empty": "މި ސެޓުގައި އަދި އެއްވެސް ލެޖަރެއް ނެތް.",
          "current": "މިހާރު",
          "ended": "ނިމިފައި",
          "ledger": "ލެޖަރު",
          "effectiveFrom": "ފެށޭ ތާރީޚް",
          "added": "ލެޖަރު ސެޓަށް އިތުރުކުރެވިއްޖެ",
          "addFailed": "ލެޖަރު ސެޓަށް އިތުރެއް ނުކުރެވުނު."
        }
      },
      "calendars": {
        "title": "އެކައުންޓިންގ ކަލަންޑަރުތައް",
        "description": "ކަލަންޑަރުތަކުން ކޮންމެ ޤާނޫނީ ފަރާތެއްގެ މާލީ އަހަރުގެ އެކައުންޓިންގ މުއްދަތުތައް ކަނޑައަޅައެވެ. މުއްދަތުތައް ބެލުމަށް ކަލަންޑަރެއް ހޮވާ.",
        "loadFailed": "އެކައުންޓިންގ ކަލަންޑަރުތައް ލޯޑެއް ނުވި.",
        "tableLabel": "އެކައުންޓިންގ ކަލަންޑަރުތައް",
        "emptyTitle": "އަދި އެއްވެސް އެކައުންޓިންގ ކަލަންޑަރެއް ނެތް",
        "emptyDescription": "މާލީ އަހަރެއްގެ އެކައުންޓިންގ މުއްދަތުތައް ހެދުމަށް ކަލަންޑަރެއް ކަނޑައަޅާ.",
        "create": "ކަލަންޑަރު ކަނޑައަޅާ",
        "createTitle": "އެކައުންޓިންގ ކަލަންޑަރު ކަނޑައަޅާ",
        "createDescription": "މަހުން މަހަށާއި ޤުއާޓަރުން ޤުއާޓަރަށް ހުންނަ ކަލަންޑަރުތަކުގެ މުއްދަތުތައް އޮޓޮމެޓިކުން ހެދޭނެ. ހަފްތާއަށް، 4-4-5 އަދި ކަސްޓަމް ކަލަންޑަރުތަކަށް ކޮންމެ މުއްދަތެއްގެ ތާރީޚްތައް ޖައްސަން ޖެހޭނެ.",
        "created": "ކަލަންޑަރު {name} ކަނޑައެޅިއްޖެ",
        "createdDetail": "އެއްވެސް މުއްދަތެއް ނުހެދުނު. | 1 މުއްދަތެއް ހެދިއްޖެ. | {count} މުއްދަތު ހެދިއްޖެ.",
        "createFailed": "ކަލަންޑަރު ކަނޑައެއް ނުޅެވުނު.",
        "showPeriods": "މުއްދަތުތައް",
        "columns": {
          "name": "ކަލަންޑަރު",
          "anchor": "މާލީ އަހަރު ފެށޭ",
          "frequency": "ފްރީކުއެންސީ",
          "adjusting": "އެޑްޖަސްޓިންގ މުއްދަތުތައް"
        },
        "fields": {
          "name": "ނަން",
          "anchor": "މާލީ އަހަރު ފެށޭ މަސް",
          "anchorHint": "މާލީ އަހަރު ހުޅުވޭ މަސް.",
          "adjusting": "އެޑްޖަސްޓިންގ މުއްދަތުތައް",
          "adjustingHint": "0 އިން 6 އަށް. މަހުން މަހަށާއި ޤުއާޓަރުން ޤުއާޓަރަށް ހުންނަ ކަލަންޑަރުތަކުގައި އެ މުއްދަތުތައް ވަނީ އަހަރުގެ ފަހު ދުވަސްތަކުގެ ތެރޭގައެވެ.",
          "generateYear": "މާލީ އަހަރު ހަދާ",
          "generateYearHint": "އިޚްތިޔާރީ. އެ އަހަރުގެ މުއްދަތުތައް މިހާރު ހަދައެވެ.",
          "frequency": "ފްރިކުއެންސީ"
        },
        "frequencies": {
          "monthly": "މަހުން މަހަށް",
          "quarterly": "ޤުއާޓަރުން ޤުއާޓަރަށް",
          "weekly": "ހަފްތާއަށް",
          "fourFourFive": "4-4-5 ހަފްތާ",
          "custom": "ކަސްޓަމް"
        },
        "frequencyHints": {
          "monthly": "12 މުއްދަތު، އޮޓޮމެޓިކުން ހެދޭ",
          "quarterly": "4 މުއްދަތު، އޮޓޮމެޓިކުން ހެދޭ",
          "weekly": "ކޮންމެ މުއްދަތެއްގެ ތާރީޚްތައް ޖައްސާ",
          "fourFourFive": "ކޮންމެ ޤުއާޓަރަކު 4، 4 އަދި 5 ހަފްތާ",
          "custom": "ކޮންމެ މުއްދަތެއްގެ ތާރީޚްތައް ޖައްސާ"
        },
        "explicitNoYear": "މާލީ އަހަރެއް ޖައްސައިގެން އޭގެ މުއްދަތުތައް ކަނޑައަޅާ، ނުވަތަ ކަލަންޑަރު އެކަނި ކަނޑައެޅުމަށް ހުސްކޮށް ދޫކޮށްލާ.",
        "explicitHint": "މުއްދަތުތައް ހުންނަން ޖެހޭނީ ދުވަހެއް ނުހުސްވެ، އެއްބައި އަނެއްބަޔާ ނުތަޅައިގެން، އެއްގޮތަކަށް. އެޑްޖަސްޓިންގ މުއްދަތުތައް ފާހަގަކުރޭ.",
        "layout445": "4-4-5 ފުރާ",
        "addPeriod": "މުއްދަތެއް އިތުރުކުރޭ",
        "remove": "ފުހެލާ",
        "removePeriod": "މުއްދަތު {no} ފުހެލާ",
        "explicitSummary": "{days} ދުވަސް ހިމެނޭ {count} މުއްދަތު.",
        "seamGap": "{name} ގެ ކުރިން {days} ދުވަހުގެ ހުސްކަމެއް.",
        "seamOverlap": "{name} ކުރީގެ މުއްދަތާ {days} ދުވަހަށް ތަޅާލައެވެ.",
        "seamOk": "ގުޅިފައި",
        "seamGapShort": "{days} ދުވަހުގެ ހުސްކަން",
        "seamOverlapShort": "{days} ދުވަހުގެ ތަޅާލުން",
        "periodFields": {
          "no": "ނަންބަރު",
          "name": "މުއްދަތު",
          "start": "ފެށުން",
          "end": "ނިމުން",
          "quarter": "ޤުއާޓަރ",
          "adjusting": "އެޑްޖަސްޓިންގ",
          "days": "ދުވަސް",
          "seam": "ކުރީގެ މުއްދަތާ ގުޅުން"
        },
        "timeline": {
          "title": "މުއްދަތުތައް — {name}",
          "description": "މާލީ އަހަރެއްގެ މުއްދަތުތައް ހުންނަން ޖެހޭނީ ދުވަހެއް ނުހުސްވެ، އެއްބައި އަނެއްބަޔާ ނުތަޅައިގެން، އެއްގޮތަކަށް.",
          "emptyTitle": "އަދި އެއްވެސް މުއްދަތެއް ނުހަދާ",
          "emptyDescription": "މި ކަލަންޑަރުގެ މުއްދަތުތައް ހެދުމަށް މާލީ އަހަރެއް ހަދާ.",
          "year": "މާލީ އަހަރު",
          "loadFailed": "މި ކަލަންޑަރުގެ މުއްދަތުތައް ލޯޑެއް ނުވި.",
          "stripLabel": "މާލީ އަހަރު {year} ގައި {count} މުއްދަތު",
          "summary": "{days} ދުވަސް ހިމެނޭ {count} މުއްދަތު.",
          "breaks": "އެއްވެސް ހުސްކަމެއް ނެތް. | 1 ތަނެއްގައި ގުޅުން ކެނޑިފައި. | {count} ތަނެއްގައި ގުޅުން ކެނޑިފައި.",
          "tableLabel": "މާލީ އަހަރު {year} ގެ މުއްދަތުތައް",
          "quarterHeading": "ކުއާޓަރ {quarter}",
          "noQuarter": "އެއްވެސް ކުއާޓަރަކަށް ނުވަންނަ",
          "adjustingBadge": "އެޑްޖަސްޓިންގ"
        }
      }
    },
    "legalEntities": {
      "title": "ޤާނޫނީ ފަރާތްތައް",
      "description": "އެންޓަޕްރައިޒްގެ ޤާނޫނީ ފަރާތްތަކުގެ ރަޖިސްޓަރީ. ކޮންމެ ފަރާތެއްގައި އަމިއްލަ އެސެޓްތަކާއި، ފައިލިންގްތަކާއި، ޒިންމާތައް ހުރެއެވެ، އަދި ކޮންމެ މުޢާމަލާތެއްގެ ކޮންޓްރެކްޓިންގ ޕާޓީއަކީ މިއީއެވެ.",
      "tableLabel": "ޤާނޫނީ ފަރާތްތައް",
      "searchPlaceholder": "ކޯޑް، ނަން ހޯދާ…",
      "searchLabel": "ޤާނޫނީ ފަރާތްތައް ހޯދާ",
      "entityTypeFilterPlaceholder": "ހުރިހާ ބާވަތެއް",
      "createTitle": "އައު ޤާނޫނީ ފަރާތެއް",
      "createFirst": "ފުރަތަމަ ޤާނޫނީ ފަރާތް ރަޖިސްޓްރީކުރޭ",
      "emptyTitle": "އަދި އެއްވެސް ޤާނޫނީ ފަރާތެއް ނެތް",
      "emptyDescription": "ލެޖަރަކަށް މެޕްކޮށް، ޑިޒިގްނޭޓްކޮށް، ކޮންސޮލިޑޭޝަން ސްޓްރަކްޗަރއަށް ގެނައުމަށް ޤާނޫނީ ފަރާތެއް ރަޖިސްޓްރީކުރޭ.",
      "loadFailed": "ޤާނޫނީ ފަރާތްތަކުގެ ރަޖިސްޓަރީ ލޯޑެއް ނުވި.",
      "exported": "އެއް ޤާނޫނީ ފަރާތް އެކްސްޕޯޓްކުރެވިއްޖެ | {count} ޤާނޫނީ ފަރާތް އެކްސްޕޯޓްކުރެވިއްޖެ",
      "columns": {
        "code": "ކޯޑް",
        "name": "ނަން",
        "entityType": "ބާވަތް",
        "country": "ޤައުމު",
        "baseCurrency": "ފައިސާ"
      },
      "fields": {
        "code": "ޤާނޫނީ ފަރާތުގެ ކޯޑް",
        "legalName": "ރަޖިސްޓަރީކުރެވިފައިވާ ޤާނޫނީ ނަން",
        "name": "ދައްކާ ނަން",
        "country": "ޤައުމު",
        "baseCurrency": "ފަންކްޝަނަލް ފައިސާ",
        "entityType": "ފަރާތުގެ ބާވަތް",
        "incorporationDate": "އުފެއްދެވި ތާރީޚު",
        "dissolvedOn": "އުވާލެވުނު ތާރީޚު",
        "approvalStatus": "ހުއްދައިގެ ހާލަތު",
        "phone": "ފޯން",
        "email": "އީމެއިލް"
      },
      "entityTypes": {
        "limited_company": "ލިމިޓެޑް ކުންފުނި",
        "branch": "ބްރާންޗް",
        "partnership": "ޕާޓްނަރޝިޕް",
        "representative_office": "ރެޕްރެޒެންޓޭޓިވް އޮފީސް",
        "joint_venture": "ޖޮއިންޓް ވެންޗަރ",
        "trust": "ޓްރަސްޓް",
        "other": "އެހެނިހެން"
      },
      "statuses": {
        "draft": "ޑްރާފްޓް",
        "submitted": "ހުށަހެޅިފައި",
        "approved": "ހުއްދަދެވިފައި",
        "rejected": "ރައްދުކުރެވިފައި",
        "active": "އެކްޓިވް",
        "dissolved": "އުވާލެވިފައި"
      },
      "form": {
        "createTitle": "ޤާނޫނީ ފަރާތެއް ރަޖިސްޓްރީކުރޭ",
        "createDescription": "ފަރާތް ޑްރާފްޓް ހާލަތުގައި ރަޖިސްޓްރީކުރެވޭނެ (FSD 1.2.3.9). ހުށަހެޅުމުގެ ކުރިން ލެޖަރަކަށް މެޕްކޮށް ބެލެންސިންގ ސެގްމަންޓް ވެލިއުއެއް ދޭށެވެ.",
        "editTitle": "ޤާނޫނީ ފަރާތް އެޑިޓްކުރޭ",
        "editDescription": "މިތަނުން އެޑިޓްކުރެވެނީ ފަރާތުގެ ބާވަތާއި އުފެއްދެވި ތާރީޚު އެކަނި — ރަޖިސްޓަރީކުރެވިފައިވާ ނަމާއި ޤައުމާއި ފައިސާއަކީ ކުންފުނީގެ ރެކޯޑްގެ ބައެކެވެ.",
        "readOnlyHint": "ކޯޑް، ނަން، ޤައުމު އަދި ފައިސާ މިސްކްރީނުގައި ބަދަލެއް ނުކުރެވޭނެ.",
        "created": "ޤާނޫނީ ފަރާތް ރަޖިސްޓްރީކުރެވިއްޖެ",
        "createdDetail": "{name} ޑްރާފްޓް ހާލަތުގައި ރަޖިސްޓްރީކުރެވިއްޖެ.",
        "createFailed": "ޤާނޫނީ ފަރާތް ރަޖިސްޓްރީނުކުރެވުނު.",
        "saved": "ޤާނޫނީ ފަރާތް ސޭވްކުރެވިއްޖެ",
        "savedDetail": "{name} އަޕްޑޭޓްކުރެވިއްޖެ.",
        "saveFailed": "ޤާނޫނީ ފަރާތް ސޭވްނުކުރެވުނު."
      },
      "tabs": {
        "profile": "ޕްރޮފައިލް",
        "ledgers": "ލެޖަރތައް",
        "balancing": "ބެލެންސިންގ ސެގްމަންޓްތައް",
        "designations": "ޑިޒިގްނޭޝަންތައް",
        "consolidation": "ކޮންސޮލިޑޭޝަން މަގު"
      },
      "detail": {
        "oneTitle": "ޤާނޫނީ ފަރާތް",
        "oneDescription": "ޕްރޮފައިލް، ލެޖަރ މެޕިންގ، ބެލެންސިންގ ސެގްމަންޓްތައް، ޑިޒިގްނޭޝަންތައް އަދި ކޮންސޮލިޑޭޝަން މަގު.",
        "oneLoadFailed": "މި ޤާނޫނީ ފަރާތް ލޯޑެއް ނުވި.",
        "notFound": "މި ޤާނޫނީ ފަރާތެއް ނުފެނުނު.",
        "tabsLabel": "ޤާނޫނީ ފަރާތުގެ ބައިތައް",
        "backToList": "ރަޖިސްޓަރީއަށް އަނބުރާ",
        "submit": "ހުއްދައަށް ހުށަހަޅާ",
        "submitted": "ހުއްދައަށް ހުށަހެޅިއްޖެ",
        "submitFailed": "ހުށަހެޅުނު ނުކުރެވުނު.",
        "activate": "އެކްޓިވޭޓްކުރޭ",
        "activated": "ޤާނޫނީ ފަރާތް އެކްޓިވޭޓްކުރެވިއްޖެ",
        "activateFailed": "އެކްޓިވޭޓްނުކުރެވުނު.",
        "dissolve": "އުވާލާ…"
      },
      "rail": {
        "subtitle": "{entityType} · {currency}",
        "incorporated": "އުފެއްދެވި",
        "activated": "އެކްޓިވޭޓްކުރެވުނު",
        "dissolved": "އުވާލެވުނު",
        "registerLink": "ޤާނޫނީ ފަރާތްތަކުގެ ރަޖިސްޓަރީ"
      },
      "ledgers": {
        "title": "ލެޖަރ މެޕިންގ",
        "description": "F-7.001: އެކްޓިވޭޓްވުމުގެ ކުރިން ޤާނޫނީ ފަރާތެއް މަދުވެގެން އެއް ލެޖަރަކަށް މެޕްކުރެވެންޖެހޭނެ.",
        "map": "ލެޖަރަކަށް މެޕްކުރޭ",
        "emptyTitle": "އަދި ލެޖަރެއް މެޕްކޮށްފައެއް ނުވޭ",
        "emptyDescription": "ބެލެންސިންގ ސެގްމަންޓް ވެލިއުއެއް ގެންގުޅެވި، އެކްޓިވޭޓްވެވޭނެހެން، މި ފަރާތް އޭގެ ލެޖަރަކަށް މެޕްކުރޭ.",
        "saved": "ލެޖަރ މެޕިންގ ސޭވްކުރެވިއްޖެ",
        "saveFailed": "ލެޖަރ މެޕްނުކުރެވުނު.",
        "roles": {
          "primary": "ޕްރައިމަރީ",
          "secondary": "ސެކަންޑަރީ"
        },
        "fields": {
          "ledger": "ލެޖަރ",
          "role": "ރޯލް",
          "effectiveFrom": "ފެށޭ ތާރީޚު"
        }
      },
      "balancing": {
        "title": "ބެލެންސިންގ ސެގްމަންޓް ވެލިއުތައް",
        "description": "F-7.009: ބެލެންސިންގ ސެގްމަންޓް ވެލިއުއެއް އެ ލެޖަރެއްގައި މި ފަރާތަށް ޚާއްޞަކުރެވިފައިވޭ — މީގެ ކުރިން ދީފައިވާ ވެލިއުއެއް ދިނުމުން ރައްދުކުރެވި، ގެންގުޅޭ ފަރާތް ބަޔާންކުރެވޭނެ.",
        "assign": "ވެލިއު ދޭ",
        "emptyTitle": "ބެލެންސިންގ ސެގްމަންޓް ވެލިއުއެއް ދީފައެއް ނުވޭ",
        "emptyDescription": "މި ފަރާތް އެކްޓިވޭޓްކުރެވޭނެހެން (F-7.001) މެޕްކުރެވިފައިވާ ލެޖަރެއްގައި މަދުވެގެން އެއް ބެލެންސިންގ ސެގްމަންޓް ވެލިއުއެއް ދޭށެވެ.",
        "saved": "ބެލެންސިންގ ސެގްމަންޓް ވެލިއު ދެވިއްޖެ",
        "saveFailed": "ބެލެންސިންގ ސެގްމަންޓް ވެލިއު ނުދެވުނު.",
        "derived": "ޑިރައިވްޑް",
        "fields": {
          "ledger": "ލެޖަރ",
          "coaSegmentValueId": "COA ސެގްމަންޓް ވެލިއު ID",
          "coaSegmentValueIdHint": "ޗާޓް އޮފް އެކައުންޓްސްގެ ސެގްމަންޓް ވެލިއުގެ ނަންބަރު ID (Foundation → Chart of Accounts → Value Sets).",
          "isDerived": "ބެލެންސިންގ ޕޭރަންޓް ވެލިއުއަކުން ޑިރައިވްކުރެވިފައި",
          "effectiveFrom": "ފެށޭ ތާރީޚު"
        }
      },
      "designations": {
        "title": "ޑިޒިގްނޭޝަންތައް",
        "description": "F-7.007/F-7.008: ލީގަލް އެމްޕްލޯޔަރ އަދި ޕޭރޯލް ސްޓެޓިއުޓަރީ ޔުނިޓް ޑިޒިގްނޭޝަންތައް، އެކުގައި ނުވަތަ ވަކިވަކިން ދެވިދާނެ.",
        "designate": "ޑިޒިގްނޭޝަން ދޭ",
        "emptyTitle": "އަދި ޑިޒިގްނޭޝަނެއް ނެތް",
        "emptyDescription": "ވަޒީފާދޭ ނުވަތަ ޕޭރޯލް ހިންގާ ފަރާތެއްނަމަ، މި ފަރާތް ލީގަލް އެމްޕްލޯޔަރ ނުވަތަ ޕޭރޯލް ސްޓެޓިއުޓަރީ ޔުނިޓެއްކަމުގައި ޑިޒިގްނޭޓްކުރޭ.",
        "saved": "ޑިޒިގްނޭޝަން ސޭވްކުރެވިއްޖެ",
        "saveFailed": "ޑިޒިގްނޭޝަން ސޭވްނުކުރެވުނު.",
        "kinds": {
          "PSU": "ޕޭރޯލް ސްޓެޓިއުޓަރީ ޔުނިޓް",
          "TRU": "ޓެކްސް ރިޕޯޓިންގ ޔުނިޓް",
          "LE": "ލީގަލް އެމްޕްލޯޔަރ"
        },
        "fields": {
          "isLegalEmployer": "ލީގަލް އެމްޕްލޯޔަރ",
          "isPsu": "ޕޭރޯލް ސްޓެޓިއުޓަރީ ޔުނިޓް",
          "jurisdiction": "ޖުރިސްޑިކްޝަން",
          "ldg": "ލެޖިސްލޭޓިވް ޑޭޓާ ގްރޫޕް",
          "effectiveFrom": "ފެށޭ ތާރީޚު",
          "note": "ނޯޓް"
        }
      },
      "consolidation": {
        "title": "ކޮންސޮލިޑޭޝަން މަގު",
        "description": "F-7.004: ބަޔާންކުރެވިފައިވާ ޕޭރަންޓަކަށް ދެވޭ މަގު — ބެލެންސިންގ ސެގްމަންޓާއެކު ހިއްސާވެފައިވާ ލެޖަރެއް، ނުވަތަ އެލިމިނޭޝަނާއެކު އޯނަރޝިޕް މަގެއް.",
        "fields": {
          "parent": "ބަޔާންކުރެވިފައިވާ ޕޭރަންޓް"
        },
        "parentPlaceholder": "ޤާނޫނީ ފަރާތެއް އިޚްތިޔާރުކުރޭ",
        "check": "މަގު ބަލާ",
        "noAccessTitle": "ހުއްދަ ނެތް",
        "noAccessDescription": "ކޮންސޮލިޑޭޝަން މަގު ފެންނަނީ ފައިނޭންސް، ލީގަލް، ކޮމްޕްލަޔަންސް އަދި އިންޓަރނަލް އޮޑިޓް ރޯލްތަކަށް އެކަނި (1.2.3.11).",
        "routes": {
          "balancing_segment": "ބެލެންސިންގ ސެގްމަންޓް",
          "ownership_and_elimination": "އޯނަރޝިޕް + އެލިމިނޭޝަން",
          "ownership_only": "އޯނަރޝިޕް އެކަނި — އެލިމިނޭޝަން ރޫލެއް އަދި ނެތް",
          "none": "ކޮންސޮލިޑޭޝަން މަގެއް ނެތް"
        }
      },
      "dissolve": {
        "title": "ޤާނޫނީ ފަރާތް އުވާލާ",
        "subject": "{name} އުވާލަނީ",
        "consequence": "އުވާލުމުން ފަރާތް ނިމުމަކަށް ގެނެވޭނެ. ތާރީޚީ ގޮތުން ފުރިހަމައަށް ރިޕޯޓްކުރެވޭނެ ނަމަވެސް، ނިމުނު ތާރީޚަށްފަހު އައު މުޢާމަލާތެއް ނުފެށޭނެ (F-7.006). މިކަން ފަހަތަށް ބަދަލެއް ނުކުރެވޭނެ.",
        "blockedTitle": "އަދި އުވާނުލެވޭނެ:",
        "fields": {
          "dissolvedOn": "އުވާލެވުނު ތާރީޚު",
          "reasonCode": "ސަބަބު ކޯޑް",
          "reasonCodeHint": "ފައިނަލް އޮޑިޓް އެންޓްރީގައި ރެކޯޑްކުރެވޭ ކުރު ކޯޑެއް."
        },
        "confirm": "އުވާލާ",
        "done": "ޤާނޫނީ ފަރާތް އުވާލެވިއްޖެ",
        "doneDetail": "{name} ނިމުމަކަށް ގެނެވި، ތާރީޚީ ގޮތުން ފުރިހަމައަށް ރިޕޯޓްކުރެވޭނެ.",
        "failed": "ޤާނޫނީ ފަރާތް އުވާނުލެވުނު."
      },
      "routeTitles": {
        "list": "ޤާނޫނީ ފަރާތްތައް",
        "detail": "ޤާނޫނީ ފަރާތް",
        "ownership": "މިލްކުވެރިކަމުގެ ގްރާފް",
        "intercompany": "ކުންފުނިތަކުގެ މެދު",
        "eliminationRules": "އިލިމިނޭޝަން ޤަވާޢިދު"
      },
      "accountPicker": {
        "placeholder": "އެކައުންޓެއް ހޮވާ",
        "chooseEntityFirst": "ފުރަތަމަ ފަރާތް ހޮވާ",
        "idPlaceholder": "އެކައުންޓް އައިޑީ"
      },
      "ownership": {
        "title": "މިލްކުވެރިކަމުގެ ގްރާފް",
        "description": "ގްރޫޕުގެ ތެރޭގައި ކާކު ކާކުގެ މިލްކުވެރިވެފައިވޭތޯ، ތާރީޚަކަށް. ކޮންމެ ގުޅުމަކީ ޤާނޫނީ ފަރާތެއްގައި ބެލެނިވެރި ފަރާތުގެ ސީދާ ނުވަތަ ނުސީދާ ހިއްސާ. އެއް ފަރާތެއްގައި ސީދާ ހިއްސާ 100% އިން މައްޗަށް ނުދެވޭނެ (F-7.011).",
        "record": "މިލްކުވެރިކަން ރެކޯޑުކުރޭ",
        "recordFirst": "ފުރަތަމަ ހިއްސާ ރެކޯޑުކުރޭ",
        "loadFailed": "މިލްކުވެރިކަމުގެ ރަޖިސްޓަރު ލޯޑު ނުކުރެވުނު.",
        "asAt": "ތާރީޚަށް",
        "graphTitle": "{date} ގެ މިލްކުވެރިކަން",
        "graphDescription": "މި ތާރީޚުގައި ހިނގަމުންދާ ހިއްސާތަކުން ބިނާކޮށްފައި. ކޮންމެ ލައިނެއްގެ % އަކީ ތިރީގައިވާ ފަރާތުގައި ބެލެނިވެރި ފަރާތުގެ ހިއްސާ.",
        "emptyTitle": "މިލްކުވެރިކަމެއް ރެކޯޑުކުރެވިފައެއް ނެތް",
        "emptyDescription": "ގްރޫޕުގެ މިލްކުވެރިކަން ބަލަހައްޓާނީ މި ރަޖިސްޓަރުގައި އެކަނި — ކޮންސޮލިޑޭޝަން ގްރޫޕުތަކުގައި މިހާރު ވަކި މިލްކުވެރިކަމުގެ % އެއް ނެތް، ކޮންސޮލިޑޭޝަން ހިއްސާތައް ކިޔަނީ މިތަނުން. ގްރާފް ބިނާކުރުމަށް ކޮންމެ ހިއްސާއެއް ރެކޯޑުކުރޭ.",
        "treeLabel": "ޤާނޫނީ މިލްކުވެރިކަން",
        "cycle": "ވަށައިގެންވާ ހިއްސާ",
        "selectHint": "ކޮންސޮލިޑޭޝަން މަގު ބެލުމަށް ފަރާތެއް ހޮވާ.",
        "openEntity": "ޤާނޫނީ ފަރާތް ހުޅުވާ",
        "noSelectionTitle": "ފަރާތެއް ހޮވިފައެއް ނެތް",
        "noSelectionDescription": "ބެލެނިވެރި ފަރާތަކަށް ކޮންސޮލިޑޭޓްވާ ގޮތް ބެލުމަށް ގްރާފުން ފަރާތެއް ހޮވާ.",
        "registerTitle": "މިލްކުވެރިކަމުގެ ރަޖިސްޓަރު",
        "registerLabel": "މިލްކުވެރިކަމުގެ ރަޖިސްޓަރު",
        "includeHistory": "ބަދަލުކުރެވިފައިވާ ވަރޝަންތައް ހިމަނާ",
        "open": "ހިނގަމުންދާ",
        "amend": "އިޞްލާޙުކުރޭ",
        "fields": {
          "parent": "ބެލެނިވެރި ފަރާތް",
          "child": "މިލްކުވެރިވެފައިވާ ފަރާތް",
          "holdingPct": "ހިއްސާ %",
          "holdingType": "ހިއްސާގެ ބާވަތް",
          "effectiveFrom": "ފެށޭ ތާރީޚު",
          "effectiveTo": "ނިމޭ ތާރީޚު",
          "note": "ނޯޓު"
        },
        "holdingTypes": {
          "direct": "ސީދާ",
          "indirect": "ނުސީދާ"
        },
        "form": {
          "title": "މިލްކުވެރިކަން ރެކޯޑުކުރޭ",
          "amendTitle": "މިލްކުވެރިކަން އިޞްލާޙުކުރޭ",
          "description": "ފެށޭ ތާރީޚުން ފެށިގެން ހިއްސާއެއް ރެކޯޑުކުރޭ. އެއް ބެލެނިވެރި ފަރާތާއި ފަރާތާއި ހިއްސާގެ ބާވަތަށް ފަހުގެ ތާރީޚަކުން ހިނގަމުންދާ ވަރޝަން ބަދަލުކުރެވޭ.",
          "entityPlaceholder": "ޤާނޫނީ ފަރާތެއް ހޮވާ",
          "selfOwned": "ފަރާތަކަށް އަމިއްލައަށް އަމިއްލަ ނަފްސުގެ މިލްކުވެރިއެއް ނުވެވޭނެ.",
          "holdingPctHint": "0 އަށް ވުރެ ބޮޑު، 100 އަށް ވުރެ ބޮޑުނޫން، ހަތަރު ޑެސިމަލް އަށް. ހިއްސާގެ ރަޖިސްޓަރާ އަޅާކިޔާ.",
          "noteHint": "ބަދަލާއެކު އޮޑިޓް ޓްރެއިލްގައި ރެކޯޑުކުރެވޭ.",
          "contributorsTitle": "މި ފަރާތުގައި މިހާރު ސީދާ ހިއްސާ ހުރި ފަރާތްތައް:",
          "save": "ރެކޯޑުކުރޭ",
          "saved": "މިލްކުވެރިކަން ރެކޯޑުކުރެވިއްޖެ",
          "saveFailed": "މިލްކުވެރިކަން ރެކޯޑު ނުކުރެވުނު."
        }
      },
      "intercompany": {
        "title": "ކުންފުނިތަކުގެ މެދު",
        "description": "ފަރާތްތަކުގެ ޖޯޑަކަށް އޮޓޮމެޓިކް އިންޓަރކޮމްޕެނީ ބެލެންސްކުރުން (F-7.002): ކޮންމެ ފަރާތަކުން ޕޯސްޓުކުރާ ލިބެންޖެހޭ އަދި ދައްކަންޖެހޭ އެކައުންޓުތައް. ކޮންމެ ސެޓިންއެއް ސޭވުކުރުމުގެ ކުރިން ސިމިއުލޭޓުކުރެވޭ (FND-F03-V09).",
        "toElimination": "އިލިމިނޭޝަން ޤަވާޢިދު",
        "create": "އައު އިންޓަރކޮމްޕެނީ ޤަވާޢިދެއް",
        "createFirst": "ފުރަތަމަ ފަރާތްތަކުގެ ޖޯޑު ސެޓްކުރޭ",
        "loadFailed": "އިންޓަރކޮމްޕެނީ ޤަވާޢިދުތައް ލޯޑު ނުކުރެވުނު.",
        "tableLabel": "އިންޓަރކޮމްޕެނީ ޤަވާޢިދުތައް",
        "emptyTitle": "އަދި އިންޓަރކޮމްޕެނީ ޤަވާޢިދެއް ނެތް",
        "emptyDescription": "ފަރާތްތަކުގެ ޖޯޑެއް ސެޓްކުރޭ، އެމީހުންގެ މެދުގެ މުޢާމަލާތްތައް އިންޓަރކޮމްޕެނީ ލިބެންޖެހޭ އަދި ދައްކަންޖެހޭ އެކައުންޓުތަކުން އޮޓޮމެޓިކުން ބެލެންސްވާނެ.",
        "asAt": "ތާރީޚަށް",
        "asAtHint": "ހުރިހާ ވަރޝަނެއް ބެލުމަށް ހުސްކޮށް ބާއްވާ.",
        "inForce": "ހިނގަމުންދާ",
        "amend": "އިޞްލާޙުކުރޭ",
        "simulateRule": "ސިމިއުލޭޓުކުރޭ",
        "segmentValueShort": "ސެގްމަންޓް {value}",
        "fields": {
          "company": "ފަރާތް",
          "counterparty": "ދެވަނަ ފަރާތް",
          "receivable": "IC ލިބެންޖެހޭ (ލިބެންޖެހޭ)",
          "payable": "IC ދައްކަންޖެހޭ (ދައްކަންޖެހޭ)",
          "counterpartySegmentValue": "ދެވަނަ ފަރާތުގެ ސެގްމަންޓް ވެލިއު",
          "balancingRule": "ބެލެންސްކުރުމުގެ ޤަވާޢިދު",
          "effectiveFrom": "ފެށޭ ތާރީޚު",
          "effective": "ހިނގާ މުއްދަތު"
        },
        "form": {
          "title": "އިންޓަރކޮމްޕެނީ ޤަވާޢިދު ސެޓްކުރޭ",
          "amendTitle": "އިންޓަރކޮމްޕެނީ ޤަވާޢިދު އިޞްލާޙުކުރޭ",
          "description": "ދެ އެކައުންޓުވެސް ނިސްބަތްވަނީ ފަށާ ފަރާތަށް. ސޭވުކުރުމުގެ ކުރިން ސެޓިން ސިމިއުލޭޓުކުރެވޭ؛ ބެލެންސްނުވާ ސެޓިންއެއް ފައިންޑިންގްސްއާއެކު ރިޖެކްޓުކުރެވޭ.",
          "entityPlaceholder": "ޤާނޫނީ ފަރާތެއް ހޮވާ",
          "samePair": "ދެވަނަ ފަރާތަކީ އެހެން ފަރާތަކަށް ވާންޖެހޭ.",
          "receivableHint": "ފަރާތުގެ ޕޯސްޓުކުރެވޭ އެސެޓް އެކައުންޓެއް.",
          "payableHint": "ފަރާތުގެ ޕޯސްޓުކުރެވޭ ލައިބިލިޓީ އެކައުންޓެއް.",
          "segmentValueHint": "އިޚްތިޔާރީ: ދެވަނަ ފަރާތް ދައްކާ އިންޓަރކޮމްޕެނީ ސެގްމަންޓް ވެލިއު.",
          "balancingRuleHint": "ޑިފޯލްޓަކީ auto.",
          "save": "ސިމިއުލޭޓުކޮށް ސޭވުކުރޭ",
          "saved": "އިންޓަރކޮމްޕެނީ ޤަވާޢިދު ސޭވުކުރެވިއްޖެ",
          "saveFailed": "އިންޓަރކޮމްޕެނީ ޤަވާޢިދު ސޭވު ނުކުރެވުނު."
        },
        "simulate": {
          "title": "ބެލެންސް ސިމިއުލޭޝަން",
          "description": "ސެޓިންއެއްގެ ލިބެންޖެހޭ އަދި ދައްކަންޖެހޭ އެކައުންޓުތައް އޮތްތޯ، ފަށާ ފަރާތަށް ނިސްބަތްވޭތޯ، ޕޯސްޓުކުރެވޭތޯ އަދި ރަނގަޅު ބާވަތުގެ ތޯ ބަލާ. ފާސްވާ ސެޓިންއެއް ކޮންމެ އަދަދަކަށް ބެލެންސްވޭ.",
          "seeded": "ޤަވާޢިދު #{id} ސިމިއުލޭޓުކުރަނީ؛ މި ރަން އެ ޤަވާޢިދާ ގުޅުވައި ލޮގުކުރެވޭ.",
          "from": "ފަށާ ފަރާތް",
          "to": "ލިބޭ ފަރާތް",
          "dueFrom": "ލިބެންޖެހޭ އެކައުންޓް (IC ލިބެންޖެހޭ)",
          "dueTo": "ދައްކަންޖެހޭ އެކައުންޓް (IC ދައްކަންޖެހޭ)",
          "run": "ސިމިއުލޭޓުކުރޭ",
          "balanced": "ބެލެންސްވޭ",
          "unbalanced": "ބެލެންސް ނުވޭ",
          "residual": "ބާކީ"
        }
      },
      "elimination": {
        "title": "އިލިމިނޭޝަން ޤަވާޢިދު",
        "description": "ކޮންސޮލިޑޭޓްކުރި ރިޕޯޓިންގައި ފަރާތްތަކުގެ ޖޯޑަކަށް ހިންގާ އިލިމިނޭޝަން އެންޓްރީތައް (LE-08)، އިޚްތިޔާރީ ގޮތުން އެއް ކޮންސޮލިޑޭޝަން ގްރޫޕަކަށް ހަމަޔަށް.",
        "toIntercompany": "އިންޓަރކޮމްޕެނީ ޤަވާޢިދު",
        "create": "އައު އިލިމިނޭޝަން ޤަވާޢިދެއް",
        "createFirst": "ފުރަތަމަ އިލިމިނޭޝަން ޤަވާޢިދު ސެޓްކުރޭ",
        "loadFailed": "އިލިމިނޭޝަން ޤަވާޢިދުތައް ލޯޑު ނުކުރެވުނު.",
        "tableLabel": "އިލިމިނޭޝަން ޤަވާޢިދުތައް",
        "emptyTitle": "އަދި އިލިމިނޭޝަން ޤަވާޢިދެއް ނެތް",
        "emptyDescription": "ފަރާތްތަކުގެ ޖޯޑެއް ކޮންސޮލިޑޭޓްކުރާއިރު އިލިމިނޭޓްކުރެވޭ އެކައުންޓުތައް، ޑެބިޓް އަދި ކްރެޑިޓް، ބަޔާންކުރޭ.",
        "asAt": "ތާރީޚަށް",
        "asAtHint": "ހުރިހާ ވަރޝަނެއް ބެލުމަށް ހުސްކޮށް ބާއްވާ.",
        "inForce": "ހިނގަމުންދާ",
        "amend": "އިޞްލާޙުކުރޭ",
        "fields": {
          "company": "ފަރާތް",
          "counterparty": "ދެވަނަ ފަރާތް",
          "ruleType": "ޤަވާޢިދުގެ ބާވަތް",
          "consolGroup": "ކޮންސޮލިޑޭޝަން ގްރޫޕް",
          "accounts": "އިލިމިނޭޝަން އެންޓްރީތައް",
          "account": "އެކައުންޓް",
          "side": "ފަރާތް",
          "effectiveFrom": "ފެށޭ ތާރީޚު",
          "effective": "ހިނގާ މުއްދަތު"
        },
        "sides": {
          "dr": "ޑެބިޓް",
          "cr": "ކްރެޑިޓް"
        },
        "ruleTypes": {
          "intercompany_balance": "އިންޓަރކޮމްޕެނީ ބެލެންސްތައް"
        },
        "form": {
          "title": "އިލިމިނޭޝަން ޤަވާޢިދު ސެޓްކުރޭ",
          "amendTitle": "އިލިމިނޭޝަން ޤަވާޢިދު އިޞްލާޙުކުރޭ",
          "description": "ސޭވުކުރުމުގެ ކުރިން ސިމިއުލޭޝަނުން ޔަގީންކުރެވޭ: ކޮންމެ އެކައުންޓެއް ދެ ފަރާތުން އެއް ފަރާތަކަށް ނިސްބަތްވާންޖެހޭ، އަދި ޑެބިޓް އަދި ކްރެޑިޓް އެންޓްރީ ދެކަމުވެސް ބޭނުންވޭ. އެއް ޖޯޑާއި ޤަވާޢިދުގެ ބާވަތަށް ފަހުގެ ތާރީޚަކުން ހިނގަމުންދާ ވަރޝަން ބަދަލުކުރެވޭ.",
          "entityPlaceholder": "ޤާނޫނީ ފަރާތެއް ހޮވާ",
          "samePair": "ދެވަނަ ފަރާތަކީ އެހެން ފަރާތަކަށް ވާންޖެހޭ.",
          "ruleTypeHint": "އިލިމިނޭޓްކުރާ އެއްޗެއް. މިހާރު ކޮންސޮލިޑޭޝަނުގައި ބޭނުންކުރާ ހަމައެކަނި ޤަވާޢިދުގެ ބާވަތަކީ އިންޓަރކޮމްޕެނީ ބެލެންސްތަކެވެ.",
          "ruleTypePlaceholder": "ޤަވާޢިދުގެ ބާވަތެއް ހޮވާ",
          "consolGroupHint": "އިޚްތިޔާރީ: ޤަވާޢިދު އެއް ކޮންސޮލިޑޭޝަން ގްރޫޕަކަށް ހަމަޔަށް.",
          "anyGroup": "ހުރިހާ ގްރޫޕެއް",
          "accountsHint": "ކޮންމެ އެކައުންޓެއް ޖޯޑުގެ ދެ ފަރާތުން ކޮންމެވެސް ފަރާތަކުން ހޮވާ.",
          "needBothSides": "މަދުވެގެން އެއް ޑެބިޓް އަދި އެއް ކްރެޑިޓް އެންޓްރީ އިތުރުކުރޭ.",
          "owner": "ފަރާތުން",
          "ownerCompany": "ފަރާތް",
          "ownerCounterparty": "ދެވަނަ ފަރާތް",
          "removeEntry": "އެންޓްރީ {n} ނައްތާލާ",
          "addEntry": "އެންޓްރީއެއް އިތުރުކުރޭ",
          "save": "ސިމިއުލޭޓުކޮށް ސޭވުކުރޭ",
          "saved": "އިލިމިނޭޝަން ޤަވާޢިދު ސޭވުކުރެވިއްޖެ",
          "saveFailed": "އިލިމިނޭޝަން ޤަވާޢިދު ސޭވު ނުކުރެވުނު."
        }
      }
    },
    "localisation": {
      "routeTitles": {
        "einvoicing": "e-Invoicing ކޮންފިގަރޭޝަން",
        "sandboxRuns": "ޕެކް ވެލިޑޭޝަން ރަންތައް",
        "sandboxRunDetail": "ވެލިޑޭޝަން ރަން",
        "statutoryLanguages": "ސްޓެޓިއުޓަރީ ޑޮކިއުމަންޓް ބަސްބަސް"
      },
      "einvoicing": {
        "title": "e-Invoicing ކޮންފިގަރޭޝަން",
        "description": "ޖުރިސްޑިކްޝަނެއްގެ e-invoicing މެންޑޭޓް ސަބްމިޓް ކުރާ ގޭޓްވޭ ކޮންފިގަރ ކޮށް، ލައިވް ސަބްމިޝަން އެނޭބަލްކުރުމުގެ ކުރިން ފޯރުކޮށްދެވޭކަން ސާބިތުކުރޭ (FND-F08-V07).",
        "create": "އައު ކޮންފިގަރޭޝަން",
        "createTitle": "އައު e-Invoicing ކޮންފިގަރޭޝަން",
        "editTitle": "e-Invoicing ކޮންފިގަރޭޝަން އުނިއިތުރުކުރޭ",
        "country": "ޤައުމު",
        "gateway": "ގޭޓްވޭ",
        "endpoint": "އެންޑްޕޮއިންޓް",
        "credential": "ކްރެޑެންޝަލް",
        "credentialHint": "މިހާރު ހުރި ކްރެޑެންޝަލް ބަހައްޓަން ހުސްކޮށް ބަހައްޓާ. ސޭވްކުރުމަށްފަހު ދެނެއް ނުދައްކާނެ.",
        "currentCredential": "މިހާރުގެ ކްރެޑެންޝަލް: {masked}",
        "pollInterval": "ސްޓޭޓަސް ޕޯލް އިންޓަވަލް (ސިކުންތު)",
        "pollIntervalHint": "ސަބްމިޝަން ސްޓޭޓަސް ޗެކްކުރާ ދޭތެރެ. ޑިފޯލްޓް 300 ސިކުންތު.",
        "saved": "e-Invoicing ކޮންފިގަރޭޝަން ސޭވްކުރެވިއްޖެ",
        "saveFailed": "e-Invoicing ކޮންފިގަރޭޝަން ސޭވްނުކުރެވުނު",
        "tableLabel": "e-Invoicing ކޮންފިގަރޭޝަންތައް",
        "emptyTitle": "e-invoicing ގޭޓްވޭއެއް ކޮންފިގަރ ކުރެވިފައެއް ނެތް",
        "emptyDescription": "e-invoicing މެންޑޭޓް ކުރާ ޖުރިސްޑިކްޝަނަކަށް ގޭޓްވޭއެއް ކޮންފިގަރކޮށް، ލައިވް ސަބްމިޝަން އެނޭބަލްކުރުމުގެ ކުރިން ކަނެކްޓިވިޓީ ޓެސްޓްކުރޭ.",
        "loadFailed": "e-Invoicing ކޮންފިގަރޭޝަންތައް ލޯޑްނުކުރެވުނު",
        "status": {
          "draft": "ޑްރާފްޓް",
          "testing": "ޓެސްޓިންގ",
          "active": "އެކްޓިވް",
          "failed": "ފެއިލް",
          "disabled": "ޑިސޭބަލްޑް"
        },
        "lastTest": "އެންމެ ފަހު ކަނެކްޓިވިޓީ ޓެސްޓް",
        "neverTested": "ދުވަހަކުވެސް ޓެސްޓްކޮށްފައެއް ނެތް",
        "pass": "ޕާސް",
        "fail": "ފެއިލް",
        "testConnectivity": "ކަނެކްޓިވިޓީ ޓެސްޓްކުރޭ",
        "resultTitle": "ކަނެކްޓިވިޓީ ޓެސްޓް ނަތީޖާ",
        "detail": "ތަފްޞީލު",
        "statusCode": "HTTP ސްޓޭޓަސް",
        "testedAt": "ޓެސްޓްކުރި ވަގުތު",
        "resultConsequence": "ފެއިލްވާ ނަތީޖާއަކުން ކޮންފިގަރޭޝަން Failed ސްޓޭޓަސްގައި ބެހެއްޓޭ؛ ޓެސްޓެއް ޕާސްވަންދެން ލައިވް ސަބްމިޝަން ލިބޭކަށް ނޯންނާނެ (FND-F08-V07)."
      },
      "sandboxRuns": {
        "title": "ޕެކް ވެލިޑޭޝަން ރަންތައް",
        "description": "F-8.008: ޕެންޑިންގ ޓެކްސް ޕެކް އަޕްޑޭޓެއް، ޕްރޮޑަކްޝަނަށް ގަބޫލުކުރުމުގެ ކުރިން ނޮން-ޕްރޮޑަކްޝަން އެންޓަޕްރައިޒެއްގައި ހިސްޓޮރިކަލް ޓްރާންސެކްޝަންތަކުގެ ސާމްޕަލަކާ ދެކޮޅަށް ވެލިޑޭޓްކުރަންޖެހެއެވެ. ހިންގި ކޮންމެ ރަނެއް މިތާ، އެޕެންޑް-އޯންލީކޮށް ބަހައްޓައެވެ.",
        "run": "ވެލިޑޭޝަން ހިންގާ",
        "runTitle": "ސޭންޑްބޮކްސް ވެލިޑޭޝަން ހިންގާ",
        "runDescription": "ޤައުމުގެ ޕެންޑިންގ ޕެކް ވަރޝަންގެ ދަށުން ހަގީގީ ސާމްޕަލްކުރެވުނު ޓެކްސް ލައިންތަކެއް ރީޕްލޭކޮށް، ބަދަލުވާނެ ކޮންމެ ލައިނެއް ރިޕޯޓްކުރޭ.",
        "country": "ޤައުމު",
        "filterCountry": "ޤައުމުން ފިލްޓަރކުރޭ",
        "version": "ޕެކް ވަރޝަން",
        "sampleSize": "ސާމްޕަލް ސައިޒް",
        "sampleSizeHint": "ރީޕްލޭކުރާ ސާމްޕަލްކުރެވުނު ޓެކްސް ލައިންގެ ޢަދަދު. ޑިފޯލްޓް 200.",
        "nonProductionEnterpriseId": "ނޮން-ޕްރޮޑަކްޝަން އެންޓަޕްރައިޒް id",
        "nonProductionEnterpriseIdHint": "އިޚްތިޔާރީ. ދީފިނަމަ ނޮން-ޕްރޮޑަކްޝަން އެންޓަޕްރައިޒަކަށްވާންޖެހޭ (F-8.008).",
        "status": {
          "completed": "ފުރިހަމަވެއްޖެ",
          "failed": "ފެއިލް"
        },
        "differences": "ތަފާތުތައް",
        "noDifferences": "ތަފާތެއް ނެތް",
        "differenceCount": "{count} ތަފާތު",
        "executedAt": "ހިންގި ވަގުތު",
        "executed": "ވެލިޑޭޝަން ރަން ހިންގިއްޖެ",
        "executeFailed": "ވެލިޑޭޝަން ރަން ހިންގައެއް ނުކުރެވުނު",
        "tableLabel": "ޕެކް ވެލިޑޭޝަން ރަންތައް",
        "emptyTitle": "އަދި ވެލިޑޭޝަން ރަންއެއް ނެތް",
        "emptyDescription": "ޕްރޮޑަކްޝަނަށް ގަބޫލުކުރުމުގެ ކުރިން ޤައުމުގެ ޕެންޑިންގ ޕެކް އަޕްޑޭޓާ ދެކޮޅަށް ސޭންޑްބޮކްސް ވެލިޑޭޝަނެއް ހިންގާ.",
        "loadFailed": "ޕެކް ވެލިޑޭޝަން ރަންތައް ލޯޑްނުކުރެވުނު"
      },
      "sandboxRunDetail": {
        "title": "ވެލިޑޭޝަން ރަން",
        "backToList": "ވެލިޑޭޝަން ރަންތަކަށް އަނބުރާ",
        "loadFailed": "މި ވެލިޑޭޝަން ރަން ލޯޑްނުކުރެވުނު",
        "executedBy": "ހިންގި ފަރާތް (user id)",
        "nonProductionEnterprise": "ނޮން-ޕްރޮޑަކްޝަން އެންޓަޕްރައިޒް",
        "summaryUnavailable": "މި ރަންގެ ނަތީޖާ ސަމަރީ ބަލައިގަންނަ ސިފައިގައި ނެތުމުން ދެއްކޭކަށް ނެތް.",
        "noDifferences": "ތަފާތެއް ނެތް — ސާމްޕަލްކުރެވުނު ކޮންމެ ލައިނަކާ ޕެންޑިންގ ޕެކް ވަރޝަން އެއްބަސްވޭ.",
        "differencesHeading": "{count} ތަފާތު ފެނުނު",
        "differencesTableLabel": "ސާމްޕަލްކުރެވުނު ތަފާތުތައް",
        "columns": {
          "document": "ޑޮކިއުމަންޓް",
          "taxCode": "ޓެކްސް ކޯޑް",
          "treatment": "ޓްރީޓްމަންޓް",
          "taxAmount": "ޓެކްސް ޢަދަދު",
          "reason": "ސަބަބު"
        }
      },
      "statutoryLanguages": {
        "title": "ސްޓެޓިއުޓަރީ ޑޮކިއުމަންޓް ބަސްބަސް",
        "description": "F-8.004: ސްޓެޓިއުޓަރީ ޑޮކިއުމަންޓެއް ތައްޔާރުކުރެވޭ ބަސް ކަނޑައެޅެނީ ދޫކުރާ ޖުރިސްޑިކްޝަނުންނެވެ، ބޭނުންކުރާ ފަރާތުގެ ބަސް އިޚްތިޔާރަކުން ނޫނެވެ. މި ރަޖިސްޓަރ ޤައުމަކާއި ޑޮކިއުމަންޓް ކްލާހަކަށް، ތާރީޚް-އެފެކްޓިވްކޮށް، މި ބޭނުން ކަނޑައަޅައެވެ.",
        "create": "އައު ރިކުއަރމަންޓް",
        "createTitle": "އައު ސްޓެޓިއުޓަރީ ބަސް ރިކުއަރމަންޓް",
        "reviseTitle": "ސްޓެޓިއުޓަރީ ބަސް ރިކުއަރމަންޓް އިސްލާހުކުރޭ",
        "formDescription": "ޤައުމަކަށް ޑޮކިއުމަންޓް ކްލާހެއް ދައްކާނެ ބަސް ކަނޑައަޅާ ނުވަތަ އިސްލާހުކުރޭ.",
        "country": "ޤައުމު",
        "documentClass": "ޑޮކިއުމަންޓް ކްލާސް",
        "documentClassHint": "މިސާލު: invoice, payslip, tax_return, statement",
        "language": "ބަސް",
        "languageHint": "ISO 639-1 ކޯޑް، މިސާލު: en, dv, ar",
        "effectiveFrom": "އަމަލުކުރަން ފަށާ ތާރީޚް",
        "effective": "އަމަލުކުރާ މުއްދަތު",
        "openEnded": "ނިމުމެއް ނެތް",
        "revise": "އިސްލާހުކުރޭ",
        "reviseNote": "އިސްލާހުކުރުމުން މަތީގައިވާ ތާރީޚުން ފަށައިގެން އައު ވަރޝަނެއް އުފެދޭނެ؛ މިހާރުގެ ވަރޝަންގެ ހިސްޓްރީ ބަހައްޓާނެ، ފޮހެއެއް ނުލާނެ.",
        "saved": "ސްޓެޓިއުޓަރީ ބަސް ރިކުއަރމަންޓް ސޭވްކުރެވިއްޖެ",
        "saveFailed": "ސްޓެޓިއުޓަރީ ބަސް ރިކުއަރމަންޓް ސޭވްނުކުރެވުނު",
        "tableLabel": "ސްޓެޓިއުޓަރީ ޑޮކިއުމަންޓް ބަސްބަސް",
        "emptyTitle": "ސްޓެޓިއުޓަރީ ބަސް ރިކުއަރމަންޓެއް ކަނޑައެޅިފައެއް ނެތް",
        "emptyDescription": "ޤައުމަކަށް ޑޮކިއުމަންޓް ކްލާހެއް ދައްކަންޖެހޭ ބަސް ކަނޑައަޅާ.",
        "loadFailed": "ސްޓެޓިއުޓަރީ ޑޮކިއުމަންޓް ބަސްބަސް ލޯޑްނުކުރެވުނު"
      }
    },
    "overview": {
      "title": "އެންޓަޕްރައިޒް ޑޭޝްބޯޑް އަދި އިންބޮކްސް",
      "description": "އެންޓަޕްރައިޒްގެ ކޮންފިގަރޭޝަން ފުރިހަމަވެފައިވާ މިންވަރު، އޭގައި ހިމެނޭ އެއްޗެހި، އަދި ތިބާއަށް އިންތިޒާރުކުރާ ކަންކަން.",
      "navLabel": "ޑޭޝްބޯޑް އަދި އިންބޮކްސް",
      "routeTitles": {
        "overview": "އެންޓަޕްރައިޒް ޑޭޝްބޯޑް"
      },
      "checklist": {
        "title": "ކޮންފިގަރޭޝަން ފުރިހަމަކަން",
        "description": "ޑޭޓާބޭސްގައި ޙަޤީޤަތުގައި ހުރި އެއްޗެހިން ގުނާފައި — ސާބިތުކުރާ ރެކޯޑްތަކެއް ނެތި އެއްވެސް ކަމެއް ނިމިއްޖެކަމަށް ނުދައްކާނެއެވެ.",
        "loadFailed": "ކޮންފިގަރޭޝަން ޗެކްލިސްޓް ލޯޑެއް ނުވި",
        "requiredCounted": "ލާޒިމު ކަންކަމުން ނިމުނު",
        "progressLabel": "ކޮންފިގަރޭޝަންގެ ކުރިއެރުން",
        "ready": "ލައިވްވާން ތައްޔާރު",
        "notReady": "އަދި ތައްޔާރެއް ނޫން",
        "optional": "އިޚްތިޔާރީ",
        "itemDone": "ނިމިއްޖެ",
        "itemToDo": "އަދި ކުރަންޖެހޭ",
        "review": "ބައްލަވާ",
        "fix": "ސެޓަޕްކުރޭ"
      },
      "structure": {
        "title": "އެންޓަޕްރައިޒްގެ ބިނާ",
        "description": "ކޮންމެ ރަޖިސްޓަރަކުން ގުނާފައި. ރެކޯޑްތައް ބެއްލެވުމަށް ނުވަތަ ބަދަލުކުރުމަށް ރަޖިސްޓަރެއް ހުޅުއްވާ.",
        "registers": {
          "legalEntities": "ލީގަލް އެންޓިޓީތައް (އެކްޓިވް)",
          "divisions": "ޑިވިޜަންތައް",
          "businessUnits": "ބިޒްނަސް ޔުނިޓްތައް",
          "costCentres": "ކޮސްޓް ސެންޓަރުތައް (އެކްޓިވް)",
          "positions": "މަޤާމުތައް",
          "ledgers": "ލެޖަރުތައް"
        },
        "atLeast": "{count} ނުވަތަ އިތުރު",
        "capped": "ގުނާފައިވަނީ ފުރަތަމަ {pages} ޞަފްޙާ އެކަންޏެވެ؛ ރަޖިސްޓަރުގައި އިތުރަށް ހުރި.",
        "openRegister": "ރަޖިސްޓަރު ހުޅުވާ"
      },
      "approvals": {
        "title": "އަހަރެންގެ އެޕްރޫވަލަށް އިންތިޒާރުކުރާ",
        "description": "ތިބާގެ އެޕްރޫވަލް އިންބޮކްސްގެ ފުރަތަމަ ޓާސްކުތައް، ހުރިހާ ޑޮކިއުމެންޓް ބާވަތްތަކުން.",
        "openInbox": "އެޕްރޫވަލް އިންބޮކްސް ހުޅުވާ",
        "loadFailed": "ތިބާގެ އެޕްރޫވަލް ޓާސްކުތައް ލޯޑެއް ނުވި",
        "empty": "ތިބާގެ އެޕްރޫވަލަށް އެއްވެސް ކަމެއް އިންތިޒާރެއް ނުކުރޭ.",
        "unknownSubmitter": "ހުށަހެޅި ފަރާތް ރެކޯޑުކޮށްފައެއް ނުވޭ",
        "overdue": "ވަގުތު ފަހަނައަޅާފައި",
        "more": "އިތުރު ޓާސްކުތައް އިންތިޒާރުކުރޭ — ހުރިހާ އެއްޗެއް ބެއްލެވުމަށް އިންބޮކްސް ހުޅުއްވާ."
      },
      "attention": {
        "title": "އަހަރެންގެ ސަމާލުކަން ބޭނުންވާ",
        "description": "ތިބާއަށް ރައިޒްކުރެވިފައިވާ ހުޅުވިފައިވާ އެކްސެޕްޝަންތަކާއި ޓާސްކުތަކާއި އެލަޓްތައް.",
        "openList": "ސަމާލުކަމުގެ ލިސްޓު ހުޅުވާ",
        "loadFailed": "ތިބާގެ ސަމާލުކަމުގެ ކަންކަން ލޯޑެއް ނުވި",
        "empty": "ތިބާގެ ސަމާލުކަން ބޭނުންވާ އެއްވެސް ކަމެއް ނެތް.",
        "untitled": "ސުރުޚީ ނެތް ކަމެއް",
        "more": "އިތުރު ކަންކަން ހުޅުވިފައި — ހުރިހާ އެއްޗެއް ބެއްލެވުމަށް ސަމާލުކަމުގެ ލިސްޓު ހުޅުއްވާ."
      },
      "activity": {
        "title": "އެންޓަޕްރައިޒްގެ ފަހުގެ ހަރަކާތްތައް",
        "description": "ލީގަލް އެންޓިޓީތަކާއި ޑިވިޜަންތަކާއި ބިޒްނަސް ޔުނިޓްތަކާއި ލެޖަރުތަކާއި މަޤާމުތަކާއި އޯޕަނިންގ ބެލެންސްތަކަށް ގެނެވުނު އެންމެ ފަހުގެ އޮޑިޓްކުރެވުނު ބަދަލުތައް.",
        "openAudit": "އޮޑިޓް އެކްސްޕްލޯރަރ ހުޅުވާ",
        "loadFailed": "ފަހުގެ ހަރަކާތްތައް ލޯޑެއް ނުވި",
        "empty": "އެންޓަޕްރައިޒަށް އަދި އެއްވެސް ބަދަލެއް ރެކޯޑުކުރެވިފައެއް ނުވޭ.",
        "caption": "އެންޓަޕްރައިޒްގެ އެންމެ ފަހުގެ އޮޑިޓް އެންޓްރީތައް",
        "columns": {
          "when": "ވަގުތު",
          "object": "އެއްޗެއް",
          "action": "ހަރަކާތް",
          "actor": "ކުރި ފަރާތް"
        },
        "actor": "{type} ނަންބަރު {id}",
        "entities": {
          "org_company": "ލީގަލް އެންޓިޓީ",
          "org_division": "ޑިވިޜަން",
          "business_units": "ބިޒްނަސް ޔުނިޓް",
          "org_ledger": "ލެޖަރު",
          "org_position": "މަޤާމު",
          "org_opening_balance": "އޯޕަނިންގ ބެލެންސްތައް"
        },
        "actions": {
          "create": "އުފެއްދި",
          "update": "އަޕްޑޭޓްކުރި",
          "delete": "ފޮހެލި",
          "restore": "އަނބުރާ ގެނައި",
          "status_change": "ސްޓޭޓަސް ބަދަލުކުރި",
          "submit": "ހުށަހެޅި",
          "post": "ޕޯސްޓްކުރި",
          "reverse": "ރިވާސްކުރި",
          "approve": "އެޕްރޫވްކުރި",
          "reject": "ރިޖެކްޓްކުރި",
          "config_change": "ކޮންފިގަރޭޝަން ބަދަލުކުރި"
        }
      }
    },
    "periods": {
      "title": "މުއްދަތު ކޮންޓްރޯލް",
      "description": "ކޮންމެ އެކައުންޓިންގ މުއްދަތެއްގެ ހާލަތު، ލެޖަރ އަށް ބަލައި. މުއްދަތެއް ބަންދުކުރުމުން އެހެން އެންމެންނަށް އެ މުއްދަތަށް ޕޯސްޓެއް ނުކުރެވޭނެއެވެ؛ ދާއިމީކޮށް ބަންދުކުރެވިފައިވާ މުއްދަތެއް ދުވަހަކުވެސް އަލުން ނުހުޅުވޭނެއެވެ.",
      "routeTitles": {
        "control": "މުއްދަތު ކޮންޓްރޯލް"
      },
      "ledgerLabel": "ލެޖަރ",
      "ledgerPlaceholder": "ކޮންމެ ލެޖަރއެއް",
      "ledgerNote": "ލެޖަރ {ledger} ޕޯސްޓްކުރަނީ އޭގެ ކުންފުނީގެ ފިސްކަލް ކަލަންޑަރުން، އެހެންކަމުން އެ ކުންފުނީގެ ހުރިހާ ލެޖަރއަކަށް މި މުއްދަތުތަކުގެ ހާލަތު ހިއްސާވެއެވެ.",
      "ledgerRoles": {
        "primary": "މައި",
        "secondary": "ދެވަނަ"
      },
      "calendarLabel": "ކަލަންޑަރު",
      "yearLabel": "ފިސްކަލް އަހަރު",
      "allYears": "ހުރިހާ އަހަރެއް",
      "chooseTitle": "ލެޖަރއެއް ނުވަތަ ކުންފުންޏެއް ހޮވާ",
      "chooseDescription": "މުއްދަތުތައް ނިސްބަތްވަނީ ކުންފުނީގެ ފިސްކަލް ކަލަންޑަރަށެވެ. އެތައް ބެލުމަށް ލެޖަރއެއް، ނުވަތަ އޭގެ ކުންފުނި ހޮވާ.",
      "loadFailed": "މުއްދަތުތައް ލޯޑެއް ނުވި",
      "noCalendarTitle": "އަދި ފިސްކަލް ކަލަންޑަރެއް ނެތް",
      "noCalendarDescription": "މި ކުންފުންޏަށް އެކައުންޓިންގ ކަލަންޑަރެއް ނެތް. އެކައުންޓިންގ ކަލަންޑަރުތަކުގެ ދަށުން އެއެއް ކަނޑައަޅާފައި، އޭގެ މުއްދަތުތައް ކޮންޓްރޯލްކުރަން އަނބުރާ އަންނަވާ.",
      "noPeriodsTitle": "މި ކަލަންޑަރުގައި އަދި މުއްދަތެއް ނެތް",
      "noPeriodsDescription": "މުއްދަތުތައް އުފެއްދުމަށް ފިސްކަލް އަހަރެއް ޖެނެރޭޓްކުރޭ.",
      "yearHeading": "ފިސްކަލް އަހަރު {year}",
      "tableCaption": "ފިސްކަލް އަހަރު {year} ގެ މުއްދަތުތައް",
      "columns": {
        "no": "ނަންބަރު",
        "name": "މުއްދަތު",
        "quarter": "ކުއާޓަރ",
        "start": "ފެށޭ",
        "end": "ނިމޭ",
        "reason": "ސަބަބު"
      },
      "status": {
        "open": "ހުޅުވިފައި",
        "soft_closed": "މަޑުމަޑުން ބަންދު",
        "closed": "ބަންދު",
        "permanently_closed": "ދާއިމީކޮށް ބަންދު"
      },
      "statusMeaning": {
        "open": "ޕޯސްޓިންގތައް ބަލައިގަނެވޭ",
        "soft_closed": "ޕޯސްޓިންގތަކުން އިންޒާރު ދެވޭ، ނަމަވެސް ބަލައިގަނެވޭ",
        "closed": "ޕޯސްޓިންގތައް ބަލައެއް ނުގަނެވޭ؛ އަލުން ހުޅުވިދާނެ",
        "permanently_closed": "ޕޯސްޓިންގ ދޫނުކުރެވޭ؛ ދުވަހަކުވެސް އަލުން ނުހުޅުވޭނެ"
      },
      "actions": {
        "softClose": "މަޑުމަޑުން ބަންދުކުރޭ",
        "close": "ބަންދުކުރޭ",
        "reopen": "އަލުން ހުޅުވާ",
        "permanentClose": "ދާއިމީކޮށް ބަންދުކުރޭ"
      },
      "adjusting": "އެޑްޖަސްޓިންގ",
      "quarterShort": "ކުއާޓަރ {quarter}",
      "frequency": {
        "monthly": "މަހުން މަހަށް",
        "quarterly": "ކުއާޓަރުން ކުއާޓަރަށް",
        "weekly": "ހަފްތާއިން ހަފްތާއަށް",
        "445": "4-4-5 ހަފްތާ",
        "custom": "ޚާއްޞަ"
      },
      "terminal": "ބަންދުކުރެވިފައި",
      "reopenedWith": "އަލުން ހުޅުވިފައި: {code}",
      "permanentPending": "ދާއިމީ ބަންދުކުރުން ފާސްކުރުމަށް އިންތިޒާރުގައި (ރިކުއެސްޓް #{id})",
      "blockers": {
        "title": "މި މުއްދަތު އަދި ބަންދެއް ނުކުރެވޭނެ",
        "hint": "ކޮންމެ ހުރަހެއް ނައްތާލާފައި (މިސާލަކަށް ކްލޯޒް ޗެކްލިސްޓް ނުވަތަ ބޭންކް ރިކޮންސިލިއޭޝަންގައި)، މުއްދަތު އަލުން ބަންދުކުރޭ.",
        "count": "({count} ބާކީ)",
        "open": "ލިސްޓު ހުޅުވާ",
        "unknown": "ހުރަސް {code}",
        "byCode": {
          "CLOSE_READINESS": "ކްލޯޒް ޗެކްލިސްޓުގެ ކަންތައްތައް ނުނިމޭ",
          "BUSINESS_DAY_OPEN": "ބިޒްނަސް ދުވަސްތައް އަދިވެސް ހުޅުވިފައި"
        }
      },
      "generate": {
        "title": "އަހަރެއް ޖެނެރޭޓްކުރޭ",
        "description": "{calendar} ގައި އިތުރު ފިސްކަލް އަހަރެއް އެކުލަވާލާ.",
        "fiscalYear": "ފިސްކަލް އަހަރު",
        "shape": "ކަލަންޑަރުން އެކުލަވާލެވޭ: {frequency}، {adjusting} އެޑްޖަސްޓިންގ މުއްދަތާއެކު.",
        "confirm": "ޖެނެރޭޓްކުރޭ",
        "done": "މުއްދަތުތައް ޖެނެރޭޓްކުރެވިއްޖެ",
        "doneDetail": "{year} އަށް {count} މުއްދަތު.",
        "failed": "މުއްދަތުތައް ޖެނެރޭޓެއް ނުކުރެވުނު"
      },
      "transitions": {
        "subject": "މުއްދަތު {period}",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "ލާޒިމު. މިއީ އޮޑިޓް ރެކޯޑަށް އަރާ އެއްޗެކެވެ، އަދި ފަހުން ސުވާލުކުރާ ފަރާތުން ކިޔާނެއެވެ.",
        "reasonRequired": "ސަބަބެއް ލާޒިމު: މުއްދަތެއް ބަންދުކުރުމުން ނުވަތަ އަލުން ހުޅުވުމުން އެހެން އެންމެންނަށް ޕޯސްޓްކުރެވޭ ގޮތް ބަދަލުވެއެވެ.",
        "codeRequired": "ދާއިމީ ބަންދުކުރުމަކަށް ސަބަބުގެ ކޯޑެއް ލާޒިމު.",
        "mfaNotEnrolled": "މުއްދަތެއް ބަންދުކުރުމަށް ދެވަނަ ފެކްޓަރެއް ބޭނުންވެއެވެ، އަދި މި އެކައުންޓުގައި އަދި އެއެއް ނެތެވެ.",
        "mfaLink": "އޮތެންޓިކޭޓަރެއް ސެޓަޕްކުރޭ",
        "stepUpRequired": "މިކަން ހުއްދަކުރުމުގެ ކުރިން ސާވަރުން ތިޔައީ ތިޔަ ފަރާތްކަން އަލުން ސާބިތުކުރަން އެދިއްޖެއެވެ. ދެވަނަ ފެކްޓަރު ޔަޤީންކޮށް، އަލުން މަސައްކަތްކުރޭ.",
        "failed": "އެކަން ނުކުރެވުނު",
        "doneDetail": "މުއްދަތު {period}.",
        "close": {
          "title": "މި މުއްދަތު ބަންދުކުރޭ",
          "consequence": "މި މުއްދަތަށް އިތުރު ޕޯސްޓިންގއެއް ނުކުރެވޭނެއެވެ. އިޞްލާޙުތައް ދާންޖެހޭނީ ހުޅުވިފައިވާ މުއްދަތަކަށެވެ.",
          "confirm": "މުއްދަތު ބަންދުކުރޭ",
          "done": "މުއްދަތު ބަންދުކުރެވިއްޖެ"
        },
        "soft_close": {
          "title": "މި މުއްދަތު މަޑުމަޑުން ބަންދުކުރޭ",
          "consequence": "ޕޯސްޓިންގތަކުން އިންޒާރު ދޭނެއެވެ، ނަމަވެސް ބަލައިގަނެވޭނެއެވެ. މަސް ރިވިއުކުރެވެމުންދާއިރު މި ބޭނުންކުރޭ.",
          "confirm": "މަޑުމަޑުން ބަންދުކުރޭ",
          "done": "މުއްދަތު މަޑުމަޑުން ބަންދުކުރެވިއްޖެ"
        },
        "reopen": {
          "title": "މި މުއްދަތު އަލުން ހުޅުވާ",
          "consequence": "މި މުއްދަތުން އަލުން ޕޯސްޓިންގތައް ބަލައިގަންނާނެއެވެ، އެހެންކަމުން ކުރިން ރިޕޯޓްކުރެވިފައިވާ އަދަދުތައް ބަދަލުވެދާނެއެވެ.",
          "confirm": "މުއްދަތު އަލުން ހުޅުވާ",
          "done": "މުއްދަތު އަލުން ހުޅުވިއްޖެ"
        },
        "permanent_close": {
          "title": "މި މުއްދަތު ދާއިމީކޮށް ބަންދުކުރޭ",
          "consequence": "މިއިން ދެ ފާސްކުރާ މީހަކަށް މުއްދަތު އަބަދަށް ބަންދުކުރުމަށް އެދެއެވެ.",
          "irreversible": "ފާސްވުމަށްފަހު، މި މުއްދަތު ދުވަހަކުވެސް އެއްވެސް މީހަކަށް އަލުން ނުހުޅުވޭނެއެވެ: އެޑްމިނިސްޓްރޭޓަރަކަށްވެސް، ސަޕޯޓަށްވެސް.",
          "confirm": "ދާއިމީ ބަންދުކުރުމަށް އެދޭ",
          "done": "ދާއިމީ ބަންދުކުރުމަށް އެދިއްޖެ",
          "codeLabel": "ސަބަބުގެ ކޯޑް",
          "codeHint": "މުއްދަތުގައި ރެކޯޑްވާ ކުރު ކޯޑެއް، މިސާލަކަށް year_end_signed_off.",
          "dualControl": "ދެ މީހުންގެ ފާސްކުރުމަށް ފޮނުވިއްޖެ. ހުރިހާ ފާސްކުރާ މީހުން ސޮއިކުރަންދެން މުއްދަތު ބަންދެއް ނުވެއެވެ."
        }
      }
    },
    "referenceSets": {
      "title": "ރިފަރެންސް ޑޭޓާ ސެޓްތައް",
      "description": "ރަށު/ސަރަހައްދު، ޤާނޫނީ ފަރާތް ނުވަތަ ބިޒްނަސް ޔުނިޓަކުން ބައިކުރެވޭ ސެޓިންގތަކާއި، ހުރިހާ އެންޓަޕްރައިޒަށް ހިއްސާވާ ސެޓިންގތައް ކަނޑައެޅުން.",
      "create": "އައު ރިފަރެންސް ޑޭޓާ ސެޓް",
      "tableLabel": "ރިފަރެންސް ޑޭޓާ ސެޓްތައް",
      "loadFailed": "ރިފަރެންސް ޑޭޓާ ސެޓްތައް ލޯޑެއް ނުވި",
      "filters": {
        "anyStatus": "ކޮންމެ ހާލަތެއް",
        "search": "ހޯދާ",
        "searchHint": "ކޯޑު ނުވަތަ ނަން"
      },
      "emptyTitle": "އަދި ރިފަރެންސް ޑޭޓާ ސެޓެއް ނެތް",
      "emptyDescription": "ރަށު/ސަރަހައްދު، ޤާނޫނީ ފަރާތް ނުވަތަ ބިޒްނަސް ޔުނިޓަކުން ސެޓިންގތައް ބައިކުރުމަށް ސެޓެއް އުފައްދާ.",
      "openById": "id އިން ސެޓެއް ހުޅުވާ",
      "setId": "ސެޓް id",
      "open": "ހުޅުވާ",
      "openByIdHint": "ވަރޝަން، އެސައިންމަންޓް އަދި އެންޑް-ޑޭޓް ކުރުމުގެ ހުރިހާ ކަމެއް id އިން ކުރެވޭނެ، މަތީ ލިސްޓުގައި ނެތަސް.",
      "createTitle": "އައު ރިފަރެންސް ޑޭޓާ ސެޓް",
      "createDescription": "އޯނަރަކާއި ބޭނުމަކާއެކު DRAFT ސްޓޭޓަސްގައި ސެޓެއް އުފައްދައެވެ.",
      "code": "ކޯޑް",
      "name": "ނަން",
      "purpose": "ބޭނުން",
      "ownerPosition": "އޯނަރ މަޤާމުގެ id",
      "ownerPositionHint": "ސެޓުގެ ތެރޭގައިވާ ބައިތަކަށް ޒިންމާވާ ޑޭޓާ އޯނަރ.",
      "effectiveFrom": "ފެށޭ ތާރީޚް",
      "effectiveTo": "ނިމޭ ތާރީޚް",
      "effectiveToHint": "ނިމުމެއް ނެތްނަމަ ހުސްކޮށް ބަހައްޓާ.",
      "regionsScope": "ސަރަހައްދު / ޤާނޫނީ ފަރާތުގެ ދާއިރާ",
      "regionsScopeHint": "ޑިޓަރމިނަންޓް Region ނުވަތަ Legal Entity ކަމުގައިވާނަމަ މަޖުބޫރު.",
      "regionCode": "ސަރަހައްދުގެ ކޯޑް",
      "companyId": "ކުންފުނީގެ id",
      "addRegionRow": "ދާއިރާ ރޯވެއް އިތުރުކުރޭ",
      "saved": "ރިފަރެންސް ޑޭޓާ ސެޓް އުފެއްދިއްޖެ",
      "saveFailed": "ރިފަރެންސް ޑޭޓާ ސެޓް އުފެއްދޭގޮތެއް ނުވި",
      "manage": "މެނޭޖްކުރޭ",
      "compare": "އަޅާކިޔާ",
      "visibility": "ފެންނަމިން",
      "status": {
        "draft": "ޑްރާފްޓް",
        "active": "ހަރަކާތްތެރި",
        "retired": "ވަކިކުރެވިފައި"
      },
      "system": "ސިސްޓަމް",
      "systemBadge": "ކޮމަން (ސިސްޓަމް)",
      "effective": "ހިނގާ މުއްދަތު",
      "openEnded": "ނިމުމެއް ނެތް",
      "manageUntitled": "ސެޓް #{id} މެނޭޖްކުރޭ",
      "manageTitled": "{code} · {name}",
      "manageDescription": "މި ސެޓް ވަރޝަންކޮށް ފާސްކުރޭ، ބިޒްނަސް ޔުނިޓްތައް އެސައިންކުރޭ، ނުވަތަ އެންޑް-ޑޭޓް ކުރޭ.",
      "unknownSetNote": "މި ސެޓުގެ މިހާރުގެ ތަފްޞީލެއް ނުލިބެއެވެ — މިހާރު ހުރި ސެޓަކަށް ލުކްއަޕް އެންޑްޕޮއިންޓެއް ނެތެވެ. ތިރީގައިވާ ކަންތައްތައް ސެޓް id އަށް ހަގީގީ API އަށް ގުޅައެވެ.",
      "currentStatus": "މިހާރުގެ ސްޓޭޓަސް",
      "tabsLabel": "ރިފަރެންސް ސެޓް ހަރަކާތްތައް",
      "tabs": {
        "version": "ވަރޝަން & އެކްޓިވޭޓް",
        "assign": "ބިޒްނަސް ޔުނިޓްތައް އެސައިންކުރޭ",
        "endDate": "އެންޑް-ޑޭޓް"
      },
      "versionHelp": "ފާސްކުރުމަށް ސެޓް ބަދަލެއް ހުށަހަޅައެވެ. ފާއިތުވި ތާރީޚަކަށް ބަދަލުކުރާނަމަ ސަބަބަކާއި އިތުރު ފާސްކުރުމެއް ބޭނުންވެއެވެ.",
      "effectiveDate": "ހިނގާ ތާރީޚް",
      "approvedBy": "ފާސްކުރީ (މަޤާމުގެ id)",
      "approvedByHint": "ފާއިތުވި ތާރީޚަކަށް ބަދަލެއްނަމަ މަޖުބޫރު.",
      "retroactiveWarning": "މި ހިނގާ ތާރީޚަކީ މާޒީގެ ތާރީޚެކެވެ — ބަދަލުކުރުމުގެ ސަބަބެއް މަޖުބޫރުވެ، ފާސްކުރުމަށް ފޮނުވޭނެއެވެ.",
      "changeReason": "ބަދަލުކުރުމުގެ ސަބަބު",
      "activateSwitch": "އެކްޓިވޭޓް — މި ސެޓް DRAFT އިން ACTIVE އަށް ބަދަލުކުރޭ",
      "submitVersion": "ވަރޝަން ހުށަހަޅާ",
      "noManagePermission": "ރިފަރެންސް ޑޭޓާ ސެޓްތައް މެނޭޖްކުރުމުގެ ހުއްދަ ތިޔަ ފަރާތަށް ލިބިފައެއް ނުވެއެވެ.",
      "versionSaved": "ވަރޝަން ހުށަހެޅިއްޖެ",
      "versionSavedDetail": "ވަރޝަން {no} ރެކޯޑްކުރެވިއްޖެ",
      "versionFailed": "ވަރޝަން ހުށަހެޅޭގޮތެއް ނުވި",
      "assignHelp": "މި ސެޓަށް އެއް ޑިޓަރމިނަންޓަކަށް ބިޒްނަސް ޔުނިޓްތައް އެސައިންކުރެއެވެ. ހަމަ އެ ޑިޓަރމިނަންޓަށް، ހަމަ މުއްދަތެއްގައި، އެހެން ސެޓަކަށް ކުރިން އެސައިންކޮށްފައިވާ ޔުނިޓެއް reassign ނުކުރާނަމަ ބަލައެއް ނުގަނެވޭނެއެވެ.",
      "determinantType": "ޑިޓަރމިނަންޓް ބާވަތް",
      "determinants": {
        "common": "ކޮމަން",
        "region": "ސަރަހައްދު",
        "legalEntity": "ޤާނޫނީ ފަރާތް",
        "businessUnit": "ބިޒްނަސް ޔުނިޓް"
      },
      "businessUnits": "ބިޒްނަސް ޔުނިޓްތައް",
      "businessUnitId": "ބިޒްނަސް ޔުނިޓް id",
      "confirmedBy": "ކަށަވަރުކުރީ (މަޤާމުގެ id)",
      "confirmedByHint": "މި ބަދަލު ކަށަވަރުކުރާ ޒިންމާދާރު ބިޒްނަސް ޔުނިޓް މެނޭޖަރ.",
      "reassignSwitch": "Reassign — ކުރިން އެހެން ސެޓަކަށް އެސައިންކޮށްފައިވާ ޔުނިޓެއް ބަދަލުކުރޭ",
      "assignResultLine": "ޔުނިޓް #{id}: {gained} ލިބުނު، {lost} ގެއްލުނު ސެޓިންގ ވެލިއު(ތައް)",
      "submitAssign": "އެސައިންމަންޓް ހުށަހަޅާ",
      "noAssignPermission": "ރިފަރެންސް ޑޭޓާ ސެޓްތަކަށް ބިޒްނަސް ޔުނިޓްތައް އެސައިންކުރުމުގެ ހުއްދަ ތިޔަ ފަރާތަށް ލިބިފައެއް ނުވެއެވެ.",
      "assignSaved": "އެސައިންމަންޓް ރައްކާކުރެވިއްޖެ",
      "assignSavedDetail": "{count} ބިޒްނަސް ޔުނިޓް އެސައިންކުރެވިއްޖެ",
      "assignFailed": "ބިޒްނަސް ޔުނިޓްތައް އެސައިންކުރެވޭގޮތެއް ނުވި",
      "commonSetGuard": "ކޮމަން ސެޓް އެންޑް-ޑޭޓް ނުކުރެވޭނެ — ސިސްޓަމް އެޑްމިނިސްޓްރޭޓަރ ހިމެނޭހެން ހުރިހާ ރޯލަކަށް ވެސް މި ހަރަކާތެއް ނުކުރެވޭނެއެވެ.",
      "endDateHelp": "ބޭނުންކުރަމުންދާ ރިފަރެންސްތަކެއް ހުރިނަމަ ބްލޮކް ކުރެވޭނެއެވެ. ކާމިޔާބުވެއްޖެނަމަ ސެޓުގެ މެމްބަރޝިޕްތަކާއި އެސައިންމަންޓްތައް ސެޓާއެކު އަރކައިވްކުރެވޭނެއެވެ.",
      "retirementReason": "ވަކިކުރުމުގެ ސަބަބު",
      "submitEndDate": "ސެޓް އެންޑް-ޑޭޓް ކުރޭ",
      "endDateSaved": "ސެޓް އެންޑް-ޑޭޓް ކުރެވިއްޖެ",
      "endDateSavedDetail": "{count} ވެލިއު އަރކައިވްކުރެވިއްޖެ",
      "endDateFailed": "ސެޓް އެންޑް-ޑޭޓް ކުރެވޭގޮތެއް ނުވި",
      "compareTitle": "ސެޓްތައް އަޅާކިޔާ",
      "compareDescription": "ދެ ސެޓެއް އެއްފަހަރާ ދައްކައި، ކޮންމެ ސެޓަކަށް ޚާއްޞަ ވެލިއުތަކާއި ހިއްސާވާ ވެލިއުތައް ދައްކައިދޭ — ސެޓްތައް އެއްކުރުމުގެ ކުރިން ބޭނުންކުރެވޭ.",
      "leftSetId": "ވම ސެޓް id",
      "rightSetId": "ކަނާތު ސެޓް id",
      "configurationType": "ސެޓިންގ ބާވަތް",
      "asOf": "ތާރީޚަށް",
      "compareRun": "އަޅާކިޔާ",
      "compareFailed": "ސެޓްތައް އަޅާކިޔޭގޮތެއް ނުވި",
      "overlapRatio": "{ratio}% ހިއްސާވެއެވެ",
      "uniqueToLeft": "{code} އަށް ޚާއްޞަ",
      "uniqueToRight": "{code} އަށް ޚާއްޞަ",
      "none": "ނެތް",
      "inCommon": "ހިއްސާވާ",
      "visibilityTitle": "ފެންނަމިން ބަލާ",
      "visibilityDescription": "ޚިޔާރުކުރެވޭ ސެޓިންގ ވެލިއުއެއް، މިހާރުގެ އެސައިންމަންޓްތަކުގެ ދަށުން ފެންނާނެ ބިޒްނަސް ޔުނިޓްތައް ދައްކައިދޭ.",
      "valueId": "ވެލިއު id",
      "visibilityRun": "ބަލާ",
      "visibilityFailed": "ފެންނަމިން ބަލޭގޮތެއް ނުވި",
      "inSet": "މި ސެޓުގައި",
      "notInSet": "މި ސެޓުގައި ނެތް",
      "visibilitySummary": "{code} · ޑިޓަރމިނަންޓް: {determinant}",
      "noUnits": "މިހާރު މި ވެލިއު ފެންނަ ބިޒްނަސް ޔުނިޓެއް ނެތް.",
      "viaAssignment": "އެސައިންމަންޓް މެދުވެރިކޮށް",
      "viaCommonFallback": "ކޮމަން ފޯލްބެކް މެދުވެރިކޮށް",
      "determinantsTitle": "ޑިޓަރމިނަންޓްތައް",
      "determinantsDescription": "ކޮންމެ ސެޓިންގ ބާވަތެއް ބައިކުރެވޭ ޑިޓަރމިނަންޓް ކަނޑައަޅައެވެ — ކޮމަން، ސަރަހައްދު، ޤާނޫނީ ފަރާތް ނުވަތަ ބިޒްނަސް ޔުނިޓް. އެއްވެސް ބާވަތެއް ސާފުނުކޮށެއް ނުބެހެއްޓޭނެއެވެ.",
      "noDeterminantPermission": "ޑިޓަރމިނަންޓް ސާފުކުރުމުގެ ހުއްދަ ތިޔަ ފަރާތަށް ލިބިފައެއް ނުވެއެވެ.",
      "note": "ނޯޓް",
      "declareDeterminant": "ޑިޓަރމިނަންޓް ސާފުކުރޭ",
      "determinantSaved": "ޑިޓަރމިނަންޓް ސާފުކުރެވިއްޖެ",
      "determinantFailed": "ޑިޓަރމިނަންޓް ސާފުކުރެވޭގޮތެއް ނުވި",
      "determinantsRegistryNote": "މި ލިސްޓުގައި ދައްކަނީ މި ބްރައުޒަރ ސެޝަންގައި ސާފުކުރެވުނު ޑިޓަރމިނަންޓްތަކެވެ — ކުރިން ސާފުކުރި ޑިޓަރމިނަންޓްތަކަށް ލިސްޓް އެންޑްޕޮއިންޓެއް ނެތެވެ.",
      "determinantsTableLabel": "ސާފުކުރެވުނު ޑިޓަރމިނަންޓްތައް",
      "determinantsEmptyTitle": "މި ސެޝަންގައި ޑިޓަރމިނަންޓެއް ސާފުކޮށްފައެއް ނުވެއެވެ",
      "determinantsEmptyDescription": "ކޮންމެ ސެޓިންގ ބާވަތަކަށް މަތީގައި ޑިޓަރމިނަންޓެއް ސާފުކުރޭ.",
      "superseded": "ބަދަލުކުރެވިފައި",
      "current": "މިހާރުގެ",
      "browserTitle": "ރިފަރެންސް ޑޭޓާ ބްރައުޒްކުރޭ",
      "browserDescription": "ރިފަރެންސް-ޑޭޓާ ކުއަރީ ސަރވިސް: ބިޒްނަސް ޔުނިޓެއްގެ ޑިޓަރމިނަންޓަށް ބައްލަވައިގެން ލިބޭ ސެޓިންގ ބާވަތެއްގެ ވެލިއުތައް. އެ ޔުނިޓަށް ބައްލަވައި ފެންނަ ވެލިއުތައް އެކަނި ދައްކައިދޭ.",
      "browserHint": "ސެޓިންގ ބާވަތަކާއި ބިޒްނަސް ޔުނިޓް id އެއް ޖައްސަވައިގެން ބައްލަވައިގެން ލިބޭ ވެލިއުތައް ބްރައުޒްކުރޭ.",
      "browserFailed": "ރިފަރެންސް ޑޭޓާ ލޯޑްކުރެވޭގޮތެއް ނުވި",
      "browserTableLabel": "ރިފަރެންސް ޑޭޓާ ވެލިއުތައް",
      "browserEmptyTitle": "އެއްވެސް ވެލިއުއެއް ނުފެނުނު",
      "browserEmptyDescription": "ޚިޔާރުކުރެވުނު ތާރީޚާއި ބިޒްނަސް ޔުނިޓަށް، ސެޓިންގ ބާވަތަށް، ބައްލަވައިގެން ލިބޭ އެއްޗެއް ނެތެވެ.",
      "routeTitles": {
        "catalogue": "ރިފަރެންސް ޑޭޓާ ސެޓްތައް",
        "compare": "ރިފަރެންސް ސެޓްތައް އަޅާކިޔާ",
        "visibility": "ފެންނަމިން ބަލާ",
        "determinants": "ޑިޓަރމިނަންޓްތައް",
        "browse": "ރިފަރެންސް ޑޭޓާ ބްރައުޒްކުރޭ"
      }
    },
    "setup": {
      "title": "އެންޓަރޕްރައިޒް ސެޓަޕް",
      "description": "އެންޓަރޕްރައިޒް ކަނޑައަޅައި، އެއްފަހަރު ހިންގޭ ގައިޑެޑް ކޮންފިގަރޭޝަން ހިންގާށެވެ. އޭގެ ދަށުގައިވާ ކޮންމެ އޮނިގަނޑެއް މިތަނުން ނަގައިދޭ ވެލިއުތައް ވާރުތަކުރެއެވެ.",
      "loadFailed": "އެންޓަރޕްރައިޒް ކޮންފިގަރޭޝަން ލޯޑް ނުކުރެވުނެވެ",
      "nonProduction": "ނޮން-ޕްރޮޑަކްޝަން އެންޓަރޕްރައިޒް",
      "routeTitles": {
        "workspace": "އެންޓަރޕްރައިޒް",
        "wizard": "އެންޓަރޕްރައިޒް ސެޓަޕް"
      },
      "intro": {
        "title": "އައު ޓެނަންޓެއްގައި އެންމެ ފުރަތަމަ ކުރެވޭ ކޮންފިގަރޭޝަން",
        "body": "އެންޓަރޕްރައިޒް އެކްޓިވް ނުވަނީސް އިތުރު އެއްޗެއް ސެޓަޕް ނުކުރެވޭނެއެވެ: ލީގަލް އެންޓިޓީއެއް، ލެޖަރެއް، ޗާޓް އޮފް އެކައުންޓްސްއެއް ނުހެދޭނެއެވެ. އައިޑެންޓިޓީ ނަގައި، ގައިޑެޑް ޕާސް ހުށަހަޅާ ތަކެތި ބަލައި، އެޕްރޫވަރަކު ލައްވާ އެޕްލައި ކުރުވާށެވެ."
      },
      "denied": {
        "title": "އެންޓަރޕްރައިޒް ކޮންފިގަރ ނުކުރެވޭނެއެވެ",
        "body": "އެންޓަރޕްރައިޒް ސެޓަޕަށް ބޭނުންވަނީ އެންޓަރޕްރައިޒް އެޑްމިނިސްޓްރޭޓަރ ހުއްދައެވެ. foundation.enterprise.manage ދިނުމަށް ޓެނަންޓް އެޑްމިނިސްޓްރޭޓަރަކަށް ދަންނަވައި، މި ޞަފްޙާ އަލުން ހުޅުވާށެވެ."
      },
      "statuses": {
        "draft": "ދެލިކޮޕީ",
        "pending": "ފާސްކުރުމަށް އިންތިޒާރުގައި",
        "active": "އެކްޓިވް",
        "inactive": "ނުހިނގާ"
      },
      "versionStatuses": {
        "draft": "ދެލިކޮޕީ",
        "pending": "ފާސްކުރުމަށް އިންތިޒާރުގައި",
        "active": "އެކްޓިވް",
        "superseded": "ބަދަލުކުރެވިފައި"
      },
      "types": {
        "production": "ޕްރޮޑަކްޝަން",
        "non_production": "ނޮން-ޕްރޮޑަކްޝަން"
      },
      "levels": {
        "enterprise": "އެންޓަރޕްރައިޒް",
        "division": "ޑިވިޜަން",
        "legal_entity": "ލީގަލް އެންޓިޓީ",
        "business_unit": "ބިޒްނަސް ޔުނިޓް"
      },
      "weekStart": {
        "monday": "ހޯމަ",
        "sunday": "އާދިއްތަ",
        "saturday": "ހޮނިހިރު"
      },
      "months": {
        "1": "ޖެނުއަރީ",
        "2": "ފެބްރުއަރީ",
        "3": "މާރިޗު",
        "4": "އޭޕްރީލް",
        "5": "މޭ",
        "6": "ޖޫން",
        "7": "ޖުލައި",
        "8": "އޯގަސްޓު",
        "9": "ސެޕްޓެމްބަރު",
        "10": "އޮކްޓޫބަރު",
        "11": "ނޮވެމްބަރު",
        "12": "ޑިސެމްބަރު"
      },
      "entityTypes": {
        "limited_company": "ލިމިޓެޑް ކުންފުނި",
        "branch": "ބްރާންޗް",
        "partnership": "ޕާޓްނަރޝިޕް",
        "representative_office": "ރެޕްރެޒެންޓެޓިވް އޮފީސް",
        "joint_venture": "ޖޮއިންޓް ވެންޗަރ",
        "trust": "ޓްރަސްޓް",
        "other": "އެހެނިހެން"
      },
      "stepKinds": {
        "create_legal_entity": "ލީގަލް އެންޓިޓީ",
        "ensure_primary_ledger": "ޕްރައިމަރީ ލެޖަރ",
        "create_calendar": "ފިސްކަލް ކަލަންޑަރު",
        "create_division": "ޑިވިޜަން",
        "create_business_unit": "ބިޒްނަސް ޔުނިޓް",
        "create_coa_structure": "ޗާޓް އޮފް އެކައުންޓްސް"
      },
      "validation": {
        "codeFormat": "ޖާގައެއް ނުވަތަ ފޫޅުމަދު ނުލައި، ބޮޑު އަކުރު ނުވަތަ ޢަދަދުން 2 އާއި 10 އާ ދެމެދު ބޭނުންކުރާށެވެ."
      },
      "fields": {
        "enterpriseCode": "އެންޓަރޕްރައިޒް ކޯޑު",
        "enterpriseCodeHint": "ބޮޑު އަކުރު ނުވަތަ ޢަދަދުން 2–10. އެންޓަރޕްރައިޒް އެކްޓިވް ކުރުމަށްފަހު ބަދަލެއް ނުކުރެވޭނެއެވެ.",
        "enterpriseType": "އެންޓަރޕްރައިޒް ބާވަތް",
        "enterpriseTypeHint": "ޓެނަންޓަކަށް އެކްޓިވް ޕްރޮޑަކްޝަން އެންޓަރޕްރައިޒް އެއް އެކަނި ބެހެއްޓޭނެއެވެ. ޓެސްޓް ނުވަތަ ތަމްރީނަށް ނޮން-ޕްރޮޑަކްޝަން ބޭނުންކުރާށެވެ.",
        "residencyRegion": "ރެޒިޑެންސީ ސަރަޙައްދު",
        "residencyRegionHint": "ޤާނޫނީ ބެލެހެއްޓުމުގެ ދަށުގައިވާ ޑޭޓާ ރައްކާކޮށް ޕްރޮސެސްކުރާ ތަން. ރެގިއުލޭޓެޑް ސަރަޙައްދެއްގައި PII އެންކްރިޕްޝަން ނިއްވާ ނުލެވޭނެއެވެ.",
        "legalName": "ޤާނޫނީ ނަން",
        "legalNameHint": "ރަޖިސްޓަރީކޮށްފައިވާ ނަން. ޤާނޫނީ ލިޔުންތަކުގައި ފެންނާނެއެވެ، އަދި ތާރީޚަށް ބަހާލެވިފައި ބެލެހެއްޓެއެވެ.",
        "brandName": "ބްރޭންޑް / ވިޔަފާރި ނަން",
        "brandNameHint": "ޤާނޫނީ ނަން ބޭނުންކުރަން ހުސްކޮށް ބާއްވާށެވެ.",
        "primaryCountry": "މައިގަނޑު ޤައުމު",
        "primaryCountryHint": "ދެ އަކުރުގެ ISO ކޯޑު. ޤައުމުގެ ޕެކް، ބަންދު ދުވަސްތަކުގެ ކަލަންޑަރު އަދި އެޑްރެސް ޗެކްކުރުން ކަނޑައަޅައެވެ.",
        "otherCountries": "ހިންގާ އެހެން ޤައުމުތައް",
        "otherCountriesHint": "ކޮމާއިން ވަކިކުރެވިފައިވާ ދެ އަކުރުގެ ISO ކޯޑުތައް، މިސާލަކަށް LK, IN.",
        "countries": "ހިންގާ ޤައުމުތައް",
        "defaultCurrency": "ޑިފޯލްޓް ފައިސާ",
        "defaultCurrencyHint": "ތިން އަކުރުގެ ISO 4217 ކޯޑު. އެއްވެސް އެއްޗެއް ޕޯސްޓްކުރުމަށްފަހު ބަދަލެއް ނުކުރެވޭނެއެވެ.",
        "timezone": "ޑިފޯލްޓް ޓައިމް ޒޯން",
        "timezoneHint": "IANA ނަން، މިސާލަކަށް Indian/Maldives. ތާރީޚުގެ ސަރަޙައްދުތަކާއި ޕީރިއަޑް ކަޓް-އޮފް ކަނޑައަޅައެވެ.",
        "language": "ޑިފޯލްޓް ބަސް",
        "dateFormat": "ތާރީޚު ފޯމެޓް",
        "numberFormat": "ޢަދަދު ފޯމެޓް",
        "weekStart": "ހަފްތާ ފެށޭ ދުވަސް",
        "weekStartHint": "ހަފްތާ އަދި 4-4-5 ކަލަންޑަރުތަކުގެ ބިންގަލެވެ.",
        "fiscalAnchor": "ފިސްކަލް އަހަރު ފެށޭ މަސް",
        "fiscalAnchorHint": "މާލީ އަހަރު ފެށޭ މަހެވެ.",
        "effectiveFrom": "ޢަމަލުކުރަން ފަށާ ތާރީޚު",
        "effectiveFromHint": "އައިޑެންޓިޓީގެ މި ވަރޝަނަށް ޢަމަލުކުރަން ފަށާ ތާރީޚެވެ.",
        "effectivePeriod": "ޢަމަލުކުރާ މުއްދަތު",
        "changeSummary": "ބަދަލުގެ ޚުލާޞާ",
        "changeSummaryHint": "ކޮންފިގަރޭޝަން ބަދަލުތަކުގެ ލޮގަށް މި ވަރޝަނާއެކު ރެކޯޑްކުރެވެއެވެ.",
        "changes": "ކުރިން → ފަހުން",
        "version": "ވަރޝަން",
        "versionHint": "އިޚްތިޔާރީ ޕެކް ވަރޝަން، މިސާލަކަށް 2026.1.",
        "versionNo": "ވަރޝަން",
        "status": "ޙާލަތު",
        "code": "ކޯޑު",
        "name": "ނަން",
        "entity": "ޓޭބަލް",
        "id": "އައިޑީ",
        "entityCode": "އެންޓިޓީ ކޯޑު",
        "tradingName": "ވިޔަފާރި ނަން",
        "country": "ޤައުމު",
        "countryHint": "ދެ އަކުރުގެ ISO ކޯޑު.",
        "currencyHint": "ތިން އަކުރުގެ ISO 4217 ކޯޑު.",
        "baseCurrency": "އަސާސީ ފައިސާ",
        "entityType": "އެންޓިޓީ ބާވަތް",
        "incorporationDate": "ރަޖިސްޓަރީކުރި ތާރީޚު",
        "legalEntity": "ލީގަލް އެންޓިޓީ",
        "startMonth": "ފެށޭ މަސް",
        "generateYear": "އުފައްދާ އަހަރު",
        "generateYearHint": "މިހާރު ޕީރިއަޑްތަކެއް ނުއުފެއްދުމަށް ހުސްކޮށް ބާއްވާށެވެ.",
        "periodCount": "ޕީރިއަޑްތައް",
        "periodCountHint": "1 އިން 13 އަށް. ބާރަ ބޭނުންވާނަމަ ހުސްކޮށް ބާއްވާށެވެ.",
        "coaName": "ޗާޓް އޮފް އެކައުންޓްސްގެ ނަން",
        "sequence": "ތަރުތީބު",
        "prompt": "ޕްރޮމްޕްޓް",
        "qualifier": "ކޮލިފަޔަރ",
        "binding": "ބައިންޑިންގ",
        "length": "ދިގުމިން",
        "stepKind": "އުފައްދަނީ",
        "industry": "ޞިނާޢަތް",
        "industryHint": "ހުށަހެޅުމާއި ކޮންމެ ފިޔަވަޅެއްގެ ތަފްޞީލު ބައްޓަންކުރެއެވެ.",
        "legalEntities": "ލީގަލް އެންޓިޓީތައް",
        "footprintHint": "އެންޓަރޕްރައިޒް ހިންގާ ޢަދަދު، އެންޓިޓީއަކަށް ޖެހޭ ޢަދަދެއް ނޫނެވެ.",
        "divisions": "ޑިވިޜަންތައް",
        "businessUnits": "ބިޒްނަސް ޔުނިޓްތައް",
        "defaultKey": "ކީ",
        "defaultKeyHint": "ޑިފޯލްޓްގެ ނަން، މިސާލަކަށް workforce_model.",
        "defaultValue": "ވެލިއު",
        "defaultValueHint": "ލިޔުނު ގޮތަށް ރައްކާކުރެވެއެވެ. ކޮންމެ ބަދަލެއްގައި ޢަމަލުކުރި މީހާއާއި ކުރީގެ ވެލިއު ރެކޯޑްކުރެވެއެވެ.",
        "level": "ދިން ދަރަޖަ",
        "source": "މަޞްދަރު",
        "structureType": "އޮނިގަނޑު",
        "inherits": "ގުޅުން",
        "packCode": "ޕެކް ކޯޑު",
        "packCodeHint": "ޚިޔާރުކުރުމަށް ދޫކުރާ ޞިނާޢީ ޕެކެވެ.",
        "activatedAt": "އެކްޓިވް ކުރި"
      },
      "identity": {
        "title": "އެންޓަރޕްރައިޒް އައިޑެންޓިޓީ އަދި ޢާންމު ޑިފޯލްޓްތައް",
        "description": "އެންޓަރޕްރައިޒްގެ ދަށުގައިވާ ހުރިހާ އެއްޗެއް، އަމިއްލައަށް ބަދަލުނުކުރާހާ ހިނދަކު، މިތަކެތި ވާރުތަކުރެއެވެ.",
        "summaryTitle": "އެންޓަރޕްރައިޒް އައިޑެންޓިޓީ",
        "summaryDescription": "އެންޓަރޕްރައިޒް ހެދިއިރު ނެގުނު މަޢުލޫމާތު. އެންޓަރޕްރައިޒް ވޯކްސްޕޭސް އިން އެޑިޓްކުރެވޭނެއެވެ.",
        "create": "އެންޓަރޕްރައިޒް އުފައްދާ",
        "saving": "ރައްކާކުރަނީ",
        "saved": "އައިޑެންޓިޓީ އަޕްޑޭޓްކުރެވިއްޖެ",
        "savedDetail": "ތާރީޚަށް ބަހާލެވިފައިވާ އައު ވަރޝަނެއް އުފެދިއްޖެ. ކުރީގެ ވަރޝަން އޭގެ މުއްދަތާއެކު ރައްކާކުރެވިފައި ހުންނާނެއެވެ."
      },
      "copilot": {
        "title": "ސެޓަޕް ކޯޕައިލެޓް",
        "description": "ޞިނާޢަތް، ޤައުމު އަދި ހިންގާ ފުޅާމިނުން ފެށޭ ކޮންފިގަރޭޝަނެއް ހުށަހަޅާ — ނުވަތަ ހުސް ފަތްފުށަކުން ފަށައި އަމިއްލައަށް އޮބްޖެކްޓްތައް އިތުރުކުރާށެވެ.",
        "assistive": "ކޯޕައިލެޓް ހުށަހަޅަނީއެވެ؛ ނިންމައި ކޮމިޓްކުރަނީ ތިބާއެވެ. އެންޓަރޕްރައިޒް އެކްޓިވް ކުރުމެއް، ޕްލެޓްފޯމް ފްލެގެއް ބަދަލުކުރުމެއް، ގައިޑެޑް ކޮންފިގަރޭޝަން ބޭނުންކުރުމެއް އޭގެ ބާރެއް ނެތެވެ.",
        "propose": "ކޮންފިގަރޭޝަނެއް ހުށަހަޅާ",
        "repropose": "އަލުން ހުށަހަޅާ",
        "startBlank": "ހުހަށް ފަށާ",
        "working": "ހުށަހަޅަނީ"
      },
      "plan": {
        "title": "މި ޕާސް އުފައްދާނެ ތަކެތި",
        "description": "އެއް ޕާހުން އުފައްދާ ކޮންމެ އޮބްޖެކްޓެއް، އުފައްދާ ތަރުތީބުން. ހުށަހެޅުމުގެ ކުރިން ބޭނުން އެއްޗެއް ބަދަލުކުރެވޭނެއެވެ.",
        "emptyTitle": "އަދި އެއްވެސް އެއްޗެއް ހުށަހަޅާފައި ނުވޭ",
        "emptyDescription": "ކޯޕައިލެޓް ލައްވާ ފެށޭ ކޮންފިގަރޭޝަނެއް ހުށަހަޅުވާ، ނުވަތަ ހުހަށް ފަށައި އަމިއްލައަށް ޑިވިޜަންތަކާއި ބިޒްނަސް ޔުނިޓްތައް އިތުރުކުރާށެވެ.",
        "totalObjects": "ޖުމްލަ އޮބްޖެކްޓް",
        "stepToggle": "{kind}: {subject}",
        "blockingBadge": "{count} ރަނގަޅުކުރަންޖެހޭ",
        "blockingTitle": "{count} ހުއްޓުވާ ކަންތައް",
        "blockingHelp": "ކޮންމެ ކަމެއް ވެސް ދައްކާނީ އޭގެ ފީލްޑްގައެވެ. ރަނގަޅުކޮށް އަލުން ވެލިޑޭޓްކުރާށެވެ؛ އެއިން އެއްވެސް ކަމެއް ހުއްޓައި ހުށަހެއް ނޭޅޭނެއެވެ.",
        "validatedHelp": "ހުއްޓުވާ ކަމެއް ނެތި ވެލިޑޭޓްކުރެވިއްޖެ. އަދި އެއްވެސް އެއްޗެއް އުފެދިފައެއް ނުވެއެވެ — ހުށަހެޅުމުން ފާސްކުރުމަށް ދާނެއެވެ.",
        "removeStep": "ޕްލޭނުން ނަގާ",
        "addKind": "އިތުރުކުރާ",
        "addParent": "ލީގަލް އެންޓިޓީގެ ދަށުން",
        "addNeedsEntity": "ފުރަތަމަ ލީގަލް އެންޓިޓީއެއް އިތުރުކުރާށެވެ — ކޮންމެ ޑިވިޜަނަކާއި ބިޒްނަސް ޔުނިޓެއް ވެސް އެއްޗަކަށް ނިސްބަތްވެއެވެ.",
        "addStep": "ޕްލޭނަށް އިތުރުކުރާ",
        "readOnly": "ހުށަހަޅާފައި — ހަމައެކަނި ކިޔޭނެ",
        "segmentsFixed": "ސެގްމަންޓްތައް ހުށަހަޅަނީ ޕްލެޓްފޯމުން، އަދި މި ޕާހަށް ބަދަލެއް ނުކުރެވޭނެއެވެ. ސެޓަޕަށްފަހު ޗާޓް އޮފް އެކައުންޓްސް އޭގެ އަމިއްލަ ބައިން ބަދަލުކުރާށެވެ.",
        "noSegments": "ސެގްމަންޓެއް ހުށަހަޅާފައި ނުވެއެވެ."
      },
      "bar": {
        "noPlan": "އަދި ކޮންފިގަރޭޝަނެއް ހުށަހަޅާފައި ނުވެއެވެ.",
        "blocking": "{count} ހުއްޓުވާ ކަންތައް — ހުށަހެޅުމުގެ ކުރިން ރަނގަޅުކުރާށެވެ.",
        "validated": "ވެލިޑޭޓްކުރެވިއްޖެ. އަދި އެއްވެސް އެއްޗެއް އުފެދިފައެއް ނުވެއެވެ.",
        "unvalidated": "{count} އޮބްޖެކްޓް ރޭވިފައި. ހުށަހެޅުމުގެ ކުރިން ވެލިޑޭޓްކުރާށެވެ.",
        "validate": "ވެލިޑޭޓްކުރޭ",
        "validating": "ވެލިޑޭޓްކުރަނީ",
        "submit": "ފާސްކުރުމަށް ހުށަހަޅާ",
        "submitting": "ހުށަހަޅަނީ"
      },
      "approval": {
        "title": "ފާސްކުރުމަށް އިންތިޒާރުގައި",
        "body": "ތިރީގައިވާ ކޮންފިގަރޭޝަން ހުށަހަޅާފައިވެއެވެ. އެޕްރޫވަރަކު އެޕްލައިކުރާނެ — އެއިރުން ހުރިހާ އޮބްޖެކްޓެއް އެއް ޓްރާންސެކްޝަނެއްގައި އުފެދޭނެ — ނުވަތަ ސަބަބަކާއެކު ރިޖެކްޓްކުރާނެއެވެ.",
        "sod": "މި ކޮންފިގަރޭޝަން ހުށަހެޅީ ތިބާ ކަމުން، ތިބާއަށް އެ ފާހެއް ނުކުރެވޭނެއެވެ. ވަކިވަކި ޒިންމާތަކުގެ ހަމައިން އެހެން އެޕްރޫވަރަކު ބޭނުންވެއެވެ.",
        "waiting": "ފާސްކުރުމުގެ ހުއްދަ ތިބާގެ އަތުގައި ނެތެވެ. އެޕްރޫވަރަކު މި ކޮންފިގަރޭޝަން އެޕްލައި ނުވަތަ ރިޖެކްޓް ކުރާނެއެވެ.",
        "pendingSince": "ހުށަހެޅީ {at}"
      },
      "apply": {
        "open": "ކޮންފިގަރޭޝަން އެޕްލައިކުރޭ",
        "title": "ގައިޑެޑް ކޮންފިގަރޭޝަން އެޕްލައިކުރޭ",
        "subject": "އެންޓަރޕްރައިޒް {code}",
        "headline": "މިކަން އަނބުރާ ނުގެނެވޭނެއެވެ.",
        "consequence": "ތިރީގައިވާ ކޮންމެ އޮބްޖެކްޓެއް އެއް ޓްރާންސެކްޝަނެއްގައި އުފެދި، އެންޓަރޕްރައިޒް އެކްޓިވްވެ، ގައިޑެޑް ކޮންފިގަރޭޝަން ބޭނުންކުރެވިފައިވާ ކަމަށް ފާހަގަކުރެވޭނެއެވެ. އެއްވެސް ފިޔަވަޅެއް ނާކާމިޔާބުވެއްޖެނަމަ، އެއްވެސް އެއްޗެއް ނުއުފެދޭނެއެވެ.",
        "oneShot": "އެންޓަރޕްރައިޒަކަށް ގައިޑެޑް ކޮންފިގަރޭޝަން ހިންގޭނީ ހަމަ އެންމެ ފަހަރަކުއެވެ. މިއަށްފަހު ކޮންމެ އޮނިގަނޑުގެ ބަދަލެއް ދާނީ ވަކިވަކި މެނޭޖްމަންޓް ބައިތަކުންނެވެ.",
        "confirmLabel": "ކަށަވަރުކުރުމަށް {code} ލިޔެލާ",
        "confirmHint": "އެންޓަރޕްރައިޒް ކޯޑު އަލުން ލިޔުމުން ބަޓަން ހުޅުވޭނެއެވެ. މި ޞަފްޙާގައި އަނބުރާ ނުގެނެވޭ ހަމައެކަނި ކަމަކީ މިއެވެ.",
        "confirm": "ކޮންފިގަރޭޝަން އެޕްލައިކުރޭ",
        "working": "އެޕްލައިކުރަނީ"
      },
      "applied": {
        "title": "{count} އޮބްޖެކްޓް އުފެދިއްޖެ",
        "body": "އެންޓަރޕްރައިޒް އެކްޓިވްވެ، ގައިޑެޑް ކޮންފިގަރޭޝަން ބޭނުންކުރެވިއްޖެއެވެ. މިއަށްފަހު ކޮންމެ އޮނިގަނޑުގެ ބަދަލެއް ދާނީ ވަކިވަކި މެނޭޖްމަންޓް ބައިތަކުންނެވެ.",
        "objectsTitle": "އުފެދުނު ތަކެތި",
        "objectsDescription": "ތިރީގައިވާ ކޮންމެ ރޯއެއް މިހާރު ޑޭޓާބޭސްގައި އެބައޮތެވެ، މި ޕާސް އެޕްލައިކުރި އެއް ޓްރާންސެކްޝަނުގައި އުފެދިފައެވެ.",
        "noObjects": "މި ޕާހުން އެއްވެސް އޮބްޖެކްޓެއް ނުއުފެދެއެވެ.",
        "toWorkspace": "އެންޓަރޕްރައިޒް ވޯކްސްޕޭސް ހުޅުވާ"
      },
      "reject": {
        "title": "މި ކޮންފިގަރޭޝަން ރިޖެކްޓްކުރޭ",
        "description": "ދެލިކޮޕީއަށް އަނބުރާ ދާނެ، އަދި ހުށަހެޅި މީހާއަށް ސަބަބު އެނގޭނެއެވެ.",
        "consequence": "ކޮންފިގަރޭޝަނާއެކު އެންޓަރޕްރައިޒް ވެސް ދެލިކޮޕީއަށް އަނބުރާ ދާނެއެވެ. ޕްލޭން ރައްކާކުރެވިފައި ހުންނާނެ ކަމުން، ބަދަލުކޮށް އަލުން ހުށަހެޅޭނެއެވެ.",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "ލާޒިމެވެ. ހުށަހެޅި މީހާ ވޯކްސްޕޭސް އަލުން ހުޅުވާއިރު މި ކިޔާނެއެވެ.",
        "working": "ރިޖެކްޓްކުރަނީ"
      },
      "consumed": {
        "title": "ގައިޑެޑް ކޮންފިގަރޭޝަން މިހާރު ބޭނުންކުރެވިފައި",
        "body": "އެންޓަރޕްރައިޒަކަށް ގައިޑެޑް ކޮންފިގަރޭޝަން ހިންގޭނީ ހަމަ އެންމެ ފަހަރަކު، އަދި މިއީ ބޭނުންކުރެވިފައެވެ.",
        "onward": "ޑިވިޜަންތައް، ލީގަލް އެންޓިޓީތައް، ބިޒްނަސް ޔުނިޓްތައް، މަސައްކަތްތެރިންގެ އޮނިގަނޑުތައް، ރެފަރެންސް ޑޭޓާ ސެޓްތައް، ޗާޓް އޮފް އެކައުންޓްސް، ލޮކޭޝަންތައް އަދި ހައިރާކީތައް ބަލަހައްޓަނީ ކޮންމެ އެއްޗެއް އޭގެ އަމިއްލަ ޞަފްޙާއިންނެވެ.",
        "workspaceLink": "އެންޓަރޕްރައިޒް ވޯކްސްޕޭސް ހުޅުވާ"
      },
      "closed": {
        "title": "ގައިޑެޑް ކޮންފިގަރޭޝަން މިހާރު ނުލިބޭނެ",
        "body": "މި އެންޓަރޕްރައިޒް މިހާރު ހިނގަނީއެވެ. ގައިޑެޑް ޕާސް ލިބެނީ އެކްޓިވް ކުރުމުގެ ކުރިން އެކަނިއެވެ؛ މިހާރުން ފެށިގެން ކޮންމެ އޮނިގަނޑުގެ ބަދަލެއް ދާނީ ވަކިވަކި މެނޭޖްމަންޓް ބައިތަކުންނެވެ."
      },
      "toasts": {
        "created": "އެންޓަރޕްރައިޒް {code} އުފެދިއްޖެ",
        "createdDetail": "މިއީ ދެލިކޮޕީއެކެވެ. އެކްޓިވް ނުކުރަނީސް އެއްވެސް އެއްޗެއް މި ބޭނުމެއް ނުކުރާނެއެވެ.",
        "proposed": "{count} އޮބްޖެކްޓް ހުށަހަޅައިފި",
        "proposedDetail": "އެއްވެސް އެއްޗެއް އުފެދިފައެއް ނުވެއެވެ. ކޮންމެ އެއްޗެއް ބަލައި، ބޭނުން ބަދަލެއް ގެނެސް، ދެން ވެލިޑޭޓްކުރާށެވެ.",
        "proposeFailed": "ކޮންފިގަރޭޝަނެއް ހުށަހެޅިފައެއް ނުވެއެވެ",
        "validated": "{count} އޮބްޖެކްޓް ވެލިޑޭޓްކުރެވިއްޖެ",
        "validatedDetail": "ހުއްޓުވާ ކަމެއް ނެތެވެ. މި ޗެކުން އެއްވެސް އެއްޗެއް އުފެދި ނުވަތަ ރައްކާކުރެވިފައެއް ނުވެއެވެ.",
        "validateFailed": "ކޮންފިގަރޭޝަން ވެލިޑޭޓް ނުކުރެވުނެވެ",
        "submitted": "ފާސްކުރުމަށް ހުށަހަޅައިފި",
        "submittedDetail": "މިހާރު އެޕްރޫވަރަކު އެޕްލައި ނުވަތަ ރިޖެކްޓް ކުރާނެއެވެ. އަމިއްލަ ހުށަހެޅުމެއް ފާހެއް ނުކުރެވޭނެއެވެ.",
        "submitFailed": "ކޮންފިގަރޭޝަން ހުށަހެޅިފައެއް ނުވެއެވެ",
        "submitBlocked": "{count} ހުއްޓުވާ ކަންތައް",
        "submitBlockedDetail": "ކޮންމެ ކަމެއް ދައްކާނީ އޭގެ ފިޔަވަޅާއި ފީލްޑްގައެވެ.",
        "applied": "{count} އޮބްޖެކްޓް އުފެދިއްޖެ",
        "appliedDetail": "އެންޓަރޕްރައިޒް އެކްޓިވްވެ، ގައިޑެޑް ކޮންފިގަރޭޝަން ބޭނުންކުރެވިއްޖެއެވެ.",
        "rejected": "ކޮންފިގަރޭޝަން ރިޖެކްޓްކުރެވިއްޖެ",
        "rejectedDetail": "ތިބާގެ ސަބަބާއެކު އަނބުރާ ދެލިކޮޕީގައި އެބައޮތެވެ."
      },
      "workspace": {
        "title": "އެންޓަރޕްރައިޒް",
        "description": "އައިޑެންޓިޓީ، ޢާންމު ޑިފޯލްޓްތައް، ޕްލެޓްފޯމް ފްލެގްތައް، ޞިނާޢީ ޕެކްތައް އަދި ކޮންފިގަރޭޝަން ބަދަލުތަކުގެ ލޮގް.",
        "summaryTitle": "އެންޓަރޕްރައިޒް އެއް ނަޒަރުން",
        "summaryDescription": "އެންޓަރޕްރައިޒްގެ ދަށުގައިވާ ކޮންމެ އޮނިގަނޑެއް، އަމިއްލައަށް ބަދަލުނުކުރާހާ ހިނދަކު، ވާރުތަކުރާ ވެލިއުތަކެވެ.",
        "tabsLabel": "އެންޓަރޕްރައިޒް ކޮންފިގަރޭޝަންގެ ބައިތައް",
        "noneTitle": "އަދި އެންޓަރޕްރައިޒެއް އުފައްދާފައި ނުވޭ",
        "noneBody": "އެންޓަރޕްރައިޒަކީ ކޮންމެ ޑިވިޜަނެއް، ލީގަލް އެންޓިޓީއެއް އަދި ބިޒްނަސް ޔުނިޓެއް އުފައްދާ ހިޔާވައްސެވެ. އެއް އެކްޓިވް ނުވަނީސް އިތުރު އެއްޗެއް ކޮންފިގަރ ނުކުރެވޭނެއެވެ.",
        "startWizard": "އެންޓަރޕްރައިޒް ސެޓަޕް ފަށާ",
        "openWizard": "ގައިޑެޑް ސެޓަޕް ހުޅުވާ",
        "draftHint": "މި އެންޓަރޕްރައިޒަކީ ދެލިކޮޕީއެކެވެ. އައިޑެންޓިޓީ ރަނގަޅުވުމުން ފާސްކުރުމަށް ހުށަހަޅާށެވެ.",
        "pendingHint": "ފާސްކުރުމަށް އިންތިޒާރުގައި. އެޕްރޫވަރަކު އެކްޓިވް ކުރާނެ ނުވަތަ ސަބަބަކާއެކު ރިޖެކްޓްކުރާނެއެވެ.",
        "activate": "އެކްޓިވްކުރޭ",
        "activated": "އެންޓަރޕްރައިޒް އެކްޓިވްކުރެވިއްޖެ",
        "activatedDetail": "މިހާރު މިއީ ޓެނަންޓްގެ އެކްޓިވް އެންޓަރޕްރައިޒެވެ.",
        "activateFailed": "އެންޓަރޕްރައިޒް އެކްޓިވް ނުކުރެވުނެވެ",
        "submitted": "ފާސްކުރުމަށް ހުށަހަޅައިފި",
        "submittedDetail": "މިހާރު އެޕްރޫވަރަކު އެކްޓިވް ނުވަތަ ރިޖެކްޓް ކުރާނެއެވެ. އަމިއްލަ ހުށަހެޅުމެއް ފާހެއް ނުކުރެވޭނެއެވެ.",
        "submitFailed": "އެންޓަރޕްރައިޒް ހުށަހެޅިފައެއް ނުވެއެވެ",
        "rejected": "އެންޓަރޕްރައިޒް ރިޖެކްޓްކުރެވިއްޖެ",
        "rejectedDetail": "ތިބާގެ ސަބަބާއެކު އަނބުރާ ދެލިކޮޕީގައި އެބައޮތެވެ."
      },
      "tabs": {
        "identity": "އައިޑެންޓިޓީ",
        "defaults": "ޢާންމު ޑިފޯލްޓް",
        "flags": "ޕްލެޓްފޯމް ފްލެގް",
        "packs": "ޞިނާޢީ ޕެކް",
        "versions": "ބަދަލުތަކުގެ ލޮގް"
      },
      "defaults": {
        "title": "ޢާންމު ޑިފޯލްޓްތައް",
        "description": "އައު ކޮންމެ އޮނިގަނޑެއް، އަމިއްލައަށް ބަދަލުނުކުރާހާ ހިނދަކު، ވާރުތަކުރާ ވެލިއުތައް، އަދި ކޮންމެ އެއްޗެއް ދިން ދަރަޖައާއެކު.",
        "empty": "އައިޑެންޓިޓީގެ އަމިއްލަ ވެލިއުތަކުގެ އިތުރުން ޢާންމު ޑިފޯލްޓެއް ކަނޑައަޅާފައި ނުވެއެވެ.",
        "saving": "ރައްކާކުރަނީ",
        "saved": "ޑިފޯލްޓް ރައްކާކުރެވިއްޖެ",
        "savedDetail": "މި ބަދަލުގައި ޢަމަލުކުރި މީހާ، ވަގުތު އަދި ކުރީގެ ވެލިއު ރެކޯޑްކުރެވެއެވެ.",
        "inherits": "ވާރުތަކުރޭ",
        "overrides": "ބަދަލުކުރޭ"
      },
      "flags": {
        "title": "ޕްލެޓްފޯމް ފްލެގްތައް",
        "description": "މުޅި އެންޓަރޕްރައިޒަށް ހިނގާ ސްވިޗްތަކެވެ. ކޮންމެ ބަދަލެއް ކުރީގެ ވެލިއުއާއެކު އޮޑިޓްކުރެވެއެވެ، އަދި ރައްކާތެރިކަން ދަށްކުރާ ބަދަލަކަށް ދެވަނަ އެޕްރޫވަރަކު ބޭނުންވެއެވެ.",
        "empty": "ޕްލެޓްފޯމް ފްލެގެއް ރިޕޯޓްކޮށްފައި ނުވެއެވެ.",
        "on": "ދިއްލާފައި",
        "off": "ނިއްވާފައި",
        "changedAt": "އެންމެފަހުން ބަދަލުކުރީ {at}",
        "confirmTitle": "ޕްލެޓްފޯމް ފްލެގެއް ބަދަލުކުރޭ",
        "confirmSubject": "{flag} {state} ކުރޭ",
        "confirm": "ފްލެގް ބަދަލުކުރޭ",
        "saving": "ހިންގަނީ",
        "reducesTitle": "މިއިން ރައްކާތެރިކަން ދަށްވެއެވެ.",
        "reducesBody": "ނަން ބުނެވޭ ދެވަނަ އެޕްރޫވަރަކު ބޭނުންވެއެވެ، އަދި މި ބަދަލު ރިސްކް އެންޑް ކޮމްޕްލަޔަންސް ކޮމިޓީއަށް ރިޕޯޓްކުރެވެއެވެ.",
        "secondApprover": "ދެވަނަ އެޕްރޫވަރ (ޔޫޒަރ އައިޑީ)",
        "secondApproverHint": "ތިބާ ނޫން އެހެން މީހަކަށް ވާންޖެހޭނެއެވެ.",
        "reasonLabel": "ސަބަބު",
        "reasonHint": "މި ބަދަލާއެކު ރެކޯޑްކުރެވެއެވެ.",
        "toggled": "{flag} ބަދަލުކުރެވިއްޖެ",
        "toggledDetail": "ކުރީގެ ވެލިއުއާއި އެޕްރޫވަރ ރެކޯޑްކުރެވިފައިވެއެވެ.",
        "pii_encryption": {
          "name": "PII އެންކްރިޕްޝަން",
          "help": "ޒާތީ އަދި ޤާނޫނީ ފީލްޑްތައް ރައްކާކުރެވިފައި ހުންނައިރު އެންކްރިޕްޓްކުރެއެވެ. ޑިފޯލްޓަށް ދިއްލާފައި؛ ރެޒިޑެންސީ ސަރަޙައްދު ރެގިއުލޭޓެޑްވާހާ ހިނދަކު ނިއްވާ ނުލެވޭނެއެވެ."
        },
        "ai_assistance": {
          "name": "އޭއައި އެހީތެރިކަން",
          "help": "އެމްބެޑެޑް އޭއައިގެ މައި ސްވިޗެވެ. ނިއްވާލުމުން ކޮންމެ އޭޖެންޓެއް ވަގުތުން ހުއްޓެއެވެ؛ ރަޖިސްޓްރޭޝަނާއި ތާރީޚު ފޮހެނުލައި ބަހައްޓައެވެ."
        },
        "telemetry": {
          "name": "ޓެލެމެޓްރީގައި ބައިވެރިވުން",
          "help": "ނަން ނޭނގޭ ގޮތަށް ޕްރޮޑަކްޓް ބޭނުންކުރާ މިންވަރު ޙިއްޞާކުރެއެވެ. ބަދަލުތައް އަލުން ޑިޕްލޯއި ނުކޮށް ހިނގާ، އަދި އޮޑިޓްކުރެވެއެވެ."
        }
      },
      "packs": {
        "title": "ޞިނާޢީ ޕެކްތައް",
        "description": "އެކްޓިވް ކުރެވުނު ޕެކެއްގެ އޮނިގަނޑުތަކާއި ބަސްމަގު ޚިޔާރުކުރުމަށް ދޫވެއެވެ. މިހާރު ބޭނުންކުރެވެމުންދާ އޮނިގަނޑުތަކަށް އެއްވެސް ބަދަލެއް ނުގެނެއެވެ.",
        "empty": "ޞިނާޢީ ޕެކެއް އެކްޓިވް ކޮށްފައި ނުވެއެވެ.",
        "activate": "ޕެކް އެކްޓިވްކުރޭ",
        "activating": "އެކްޓިވްކުރަނީ",
        "activated": "ޕެކް {code} އެކްޓިވްކުރެވިއްޖެ",
        "activatedDetail": "އޭގެ އޮނިގަނޑުތަކާއި ބަސްމަގު މިހާރު ޚިޔާރުކުރުމަށް ލިބޭނެއެވެ.",
        "deactivate": "ނުހިނގާގޮތް ހަދާ",
        "deactivated": "ޕެކް {code} ނުހިނގާގޮތް ހެދިއްޖެ",
        "deactivatedDetail": "އޭގެ ތެރެއިން ކުރިން އުފެދިފައިވާ އޮނިގަނޑުތަކަށް ބަދަލެއް ނާދެއެވެ.",
        "statuses": {
          "active": "އެކްޓިވް",
          "inactive": "ނުހިނގާ"
        }
      },
      "versions": {
        "title": "ކޮންފިގަރޭޝަން ބަދަލުތަކުގެ ލޮގް",
        "description": "ކޮންމެ އައިޑެންޓިޓީ ވަރޝަނެއް، އޭގެ ލިޔުންތެރިޔާ، ފާސްކުރި މީހާ، ޢަމަލުކުރާ މުއްދަތު އަދި ބަދަލުވި ތަކެއްޗާއެކު.",
        "empty": "އަދި ވަރޝަނެއް ރެކޯޑްކޮށްފައި ނުވެއެވެ."
      }
    },
    "simulator": {
      "title": "ޑިޓަމިނޭޝަން ސިމިއުލޭޓަރ",
      "description": "ޙަޤީޤީ ޕޯސްޓިންގއެއް ދިމާވާ ޗެކްތަކުގެ ތެރެއިން މުޢާމަލާތެއް ހިނގާލާ — ބިޒްނަސް ޔުނިޓް، އެކްސެސް، އޯޕަނިންގ ބެލެންސް، ލެޖަރު، ޕީރިއަޑް، އެކައުންޓް ކޮމްބިނޭޝަން އަދި އިންޓަކޮމްޕެނީ — އަދި މަނާވާނީ ކޮންތާކުންކަމާއި ކީއްވެކަން ބައްލަވާ.",
      "routeTitles": {
        "simulator": "ޑިޓަމިނޭޝަން ސިމިއުލޭޓަރ"
      },
      "run": "ޑިޓަމިނޭޝަން ހިންގާ",
      "running": "ޑިޓަމިނޭޝަން ހިންގަނީ",
      "inputs": {
        "title": "މުޢާމަލާތުގެ މަޢުލޫމާތު",
        "description": "އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުވަތަ ސޭވެއް ނުކުރެވޭނެ. ކޮންމެ ސްޓެޕަކުން ސާވަރާ ސުވާލުކުރަނީ ޙަޤީޤީ ޕޯސްޓިންގއެއް ކުރާ ހަމަ އެ ސުވާލެވެ.",
        "pickersFailed": "ބައެއް އިޚްތިޔާރުތައް ލޯޑެއް ނުވި: {message}",
        "user": "ޔޫޒަރ",
        "me": "އަހަރެން ({name})",
        "businessUnit": "ބިޒްނަސް ޔުނިޓް",
        "choose": "އިޚްތިޔާރުކުރޭ…",
        "provider": "ޝެއާޑް ސާވިސް ޕްރޮވައިޑަރއެއްގެ ތެރެއިން",
        "providerHint": "މަތީގައިވާ ޔުނިޓަށް މި ފަންކްޝަން އަދާކުރަނީ އެހެން ޔުނިޓެއް ނަމަ، ޕްރޮވައިޑަރ ބިޒްނަސް ޔުނިޓް އިޚްތިޔާރުކުރޭ.",
        "none": "ނެތް",
        "function": "ބިޒްނަސް ފަންކްޝަން",
        "date": "މުޢާމަލާތުގެ ތާރީޚު",
        "structure": "ޗާޓް އޮފް އެކައުންޓްސް",
        "structureHint": "އެކައުންޓް ކޮމްބިނޭޝަން ޗެކްކުރުމަށް ބޭނުންވޭ.",
        "combination": "އެކައުންޓް ކޮމްބިނޭޝަން",
        "combinationHint": "ޗާޓްގެ ތަރުތީބާއި ވަކިކުރާ އަކުރުން ސެގްމަންޓް އަގުތައް، މިސާލަކަށް 1005.0000.0000.411001.",
        "counterparty": "ކައުންޓަރޕާޓީ ލީގަލް އެންޓިޓީ",
        "counterpartyHint": "އަނެއް ފަރާތަކީ އެހެން ލީގަލް އެންޓިޓީއެއް ނަމަ، އިންޓަކޮމްޕެނީ ބެލެންސިންގ ޗެކްކުރުމަށް މިތަން ފުރުއްވާ."
      },
      "path": {
        "title": "ޑިޓަމިނޭޝަންގެ މަގު",
        "description": "ޕޯސްޓިންގއަކަށް ދިމާވާ ތަރުތީބުން ކޮންމެ ސްޓެޕެއް. ފުރަތަމަ ފެއިލްވުމުން ޗޭން ހުއްޓޭ.",
        "idle": "މަޢުލޫމާތު ލިޔުއްވާފައި، ޑިޓަމިނޭޝަން ހިންގަވާ."
      },
      "verdicts": {
        "passed": "ހުރިހާ ޗެކެއް ފާސްވެއްޖެ — މި މުޢާމަލާތު ގަބޫލުކުރެވޭނެ.",
        "passedWithWarnings": "ހުރިހާ ޗެކެއް ފާސްވެއްޖެ، ބައްލަވަންޖެހޭ އިންޒާރުތަކާއެކު.",
        "incomplete": "އެއްވެސް ޗެކެއް ފެއިލެއް ނުވި، ނަމަވެސް ބައެއް ޗެކްތައް ހިންގިފައެއް ނުވޭ. މިއަށް ބަރޯސާވުމުގެ ކުރިން ޗެކް ނުކުރެވުނު ސްޓެޕްތައް ކިޔުއްވާ.",
        "failed": "މި މުޢާމަލާތު މަނާވާނެ. ފެއިލްވި ސްޓެޕުގައި ސަބަބު ބުނެދޭ."
      },
      "outcomes": {
        "pass": "ފާސް",
        "warn": "އިންޒާރު",
        "fail": "ފެއިލް",
        "skipped": "ޗެކް ނުކުރެވުނު",
        "notRun": "ނުހިންގުނު",
        "pending": "އިންތިޒާރުގައި"
      },
      "steps": {
        "businessUnit": {
          "title": "ބިޒްނަސް ޔުނިޓް އަދި ލީގަލް އެންޓިޓީ",
          "checks": "ބިޒްނަސް ޔުނިޓް އެކްޓިވްވުން، ފަންކްޝަން އަދާކުރުން (ނުވަތަ އެކަން ކުރުމަށް ޕްރޮވައިޑަރަކަށް ހުއްދަ ލިބިފައިވުން)، އަދި ލީގަލް އެންޓިޓީއެއް ބަޔާންކޮށްފައިވުން."
        },
        "securityScope": {
          "title": "ޑޭޓާ އެކްސެސް",
          "checks": "ބިޒްނަސް ޔުނިޓަށް ޔޫޒަރަށް ސެކިއުރިޓީ ސްކޯޕެއް ލިބިފައިވުން. ސާވަރުން މިކަން ހިސާބުކުރަނީ މިއަދުގެ ތާރީޚަށެވެ."
        },
        "openingBalances": {
          "title": "އޯޕަނިންގ ބެލެންސްތައް",
          "checks": "ލީގަލް އެންޓިޓީގެ އެންމެ ފަހުގެ އޯޕަނިންގ ބެލެންސް ބެޗް ސައިން އޮފްކޮށްފައިވުން."
        },
        "ledger": {
          "title": "ލެޖަރު",
          "checks": "ލެޖަރ ސެލެކްޓަރ ރިޒޮލްވްކުރާ ގޮތަށް ލީގަލް އެންޓިޓީގެ ޕްރައިމަރީ ލެޖަރު."
        },
        "period": {
          "title": "އެކައުންޓިންގ ޕީރިއަޑް",
          "checks": "މުޢާމަލާތުގެ ތާރީޚު ހިމެނޭ ޕީރިއަޑް ހުޅުވިފައިވުން."
        },
        "accountCombination": {
          "title": "އެކައުންޓް ކޮމްބިނޭޝަން",
          "checks": "އެ ތާރީޚުގައި ޗާޓްގެ ކްރޮސް-ވެލިޑޭޝަން ޤަވާޢިދުތަކުން ކޮމްބިނޭޝަން ފާސްވުން."
        },
        "intercompany": {
          "title": "އިންޓަކޮމްޕެނީ",
          "checks": "ކައުންޓަރޕާޓީއަކީ އެހެން ލީގަލް އެންޓިޓީއެއް ނަމަ، އެ ދެފަރާތަށް ޤަވާޢިދެއް އޮތުމާއި އޭގެ އެކައުންޓްތައް ބެލެންސްވުން."
        }
      },
      "reasons": {
        "refused": "ސާވަރުން ދެކޮޅު ހެދި: {message}",
        "stoppedAfter": "“{step}” ފެއިލްވީތީ ނުހިންގުނު.",
        "notPermitted": "ޗެކް ނުކުރެވުނު: މި ޗެކަށް ބޭނުންވާ {permission} ތިބާއަށް ލިބިފައެއް ނުވޭ.",
        "buNotActive": "ބިޒްނަސް ޔުނިޓް {unit} އަކީ {status}، އެކްޓިވެއް ނޫން.",
        "providerRefused": "{unit} އަށް {function} އަދާކުރުމަށް ޕްރޮވައިޑަރަށް ހުއްދަދޭ ފައިދާ ހުރި ގުޅުމެއް ނެތް.",
        "noLegalEntity": "ބިޒްނަސް ޔުނިޓް {unit} އަށް ޕޯސްޓްކުރެވޭނެ ޕްރައިމަރީ ލީގަލް އެންޓިޓީއެއް ނެތް.",
        "viaProvider": "{unit} އަށް {function} ލިބެނީ ގުޅުން {relationship} ގެ ތެރެއިން؛ ޕޯސްޓްކުރެވެނީ {entity} އަށް.",
        "functionNotAssigned": "ބިޒްނަސް ޔުނިޓް {unit} އިން {function} އަދާއެއް ނުކުރޭ. ފަންކްޝަން ހަވާލުކުރައްވާ، ނުވަތަ އެކަން ކުރާ ޕްރޮވައިޑަރ ބަޔާންކުރައްވާ.",
        "buResolved": "{unit} އިން {function} އަދާކުރެއް، އަދި ޕޯސްޓްކުރެވެނީ {entity} އަށް.",
        "noBusinessUnit": "ޗެކް ނުކުރެވުނު: ބިޒްނަސް ޔުނިޓް ރިޒޮލްވެއް ނުވި.",
        "scopeExpired": "{unit} އަށް ޔޫޒަރ {user} ގެ އެކްސެސް {date} ވާއިރު ހަމަވެފައި.",
        "noScope": "{unit} އަށް ޔޫޒަރ {user} އަށް ސެކިއުރިޓީ ސްކޯޕެއް ނެތް.",
        "scopeFound": "{unit} އަށް ޔޫޒަރ {user} އަށް {scope} އެކްސެސް ލިބިފައި ({source}).",
        "noLegalEntityResolved": "ޗެކް ނުކުރެވުނު: އެއްވެސް ލީގަލް އެންޓިޓީއެއް ރިޒޮލްވެއް ނުވި.",
        "noOpeningBalances": "ޗެކް ނުކުރެވުނު: {entity} އަށް އޯޕަނިންގ ބެލެންސް ބެޗެއް ނެތް.",
        "signedOff": "{entity} ގެ އޯޕަނިންގ ބެލެންސްތައް (ބެޗް {batch}) {date} ގައި ސައިން އޮފްކުރެވިފައި.",
        "noSignedOffBatch": "{entity} އަށް ސައިން އޮފްކުރެވިފައިވާ އޯޕަނިންގ ބެލެންސް ބެޗެއް ނެތް: ބެޗް {count} އޮތް، އެއްވެސް އެއްޗެއް ސައިން އޮފްކޮށްފައެއް ނުވޭ.",
        "ledgerResolved": "{entity} ޕޯސްޓްކުރަނީ {currency} ގައި ލެޖަރު {ledger} އަށް.",
        "noLedgerResolved": "ޗެކް ނުކުރެވުނު: އެއްވެސް ލެޖަރެއް ރިޒޮލްވެއް ނުވި، އެހެންކަމުން ޕީރިއަޑްތައް ކިޔާނެ ލެޖަރ ކަލަންޑަރެއް ނެތް.",
        "ledgerNoCalendar": "ލެޖަރު {ledger} އަށް އެކައުންޓިންގ ކަލަންޑަރެއް ގުޅާފައެއް ނުވޭ.",
        "noPeriod": "ލެޖަރު {ledger} ގެ ކަލަންޑަރު {calendar} ގައި {date} ހިމެނޭ އާންމު (އެޑްޖަސްޓިންގ ނޫން) ޕީރިއަޑެއް ނެތް.",
        "periodOpen": "{date} ގައި ޕީރިއަޑް {period} ހުޅުވިފައި.",
        "periodSoftClosed": "{date} ގައި ޕީރިއަޑް {period} ސޮފްޓް-ކްލޯޒްކޮށްފައި: އިންޒާރަކާއެކު ޕޯސްޓްކުރެވޭނެ.",
        "periodClosed": "{date} ގައި ޕީރިއަޑް {period} އަކީ {status}: ޕޯސްޓްކުރުން މަނާ.",
        "noCombination": "ޗެކް ނުކުރެވުނު: ޗާޓް އޮފް އެކައުންޓްސް އިޚްތިޔާރުކޮށް، އެކައުންޓް ކޮމްބިނޭޝަން ލިޔުއްވާ.",
        "combinationValid": "ކޮމްބިނޭޝަން {values} ރަނގަޅު.",
        "combinationInvalid": "ކޮމްބިނޭޝަން {values} އިން އަގުތައް {offending} ގައި ޤަވާޢިދު “{rule}” ފުށުއަރާ.",
        "noCounterparty": "ޗެކް ނުކުރެވުނު: ކައުންޓަރޕާޓީ ލީގަލް އެންޓިޓީއެއް ދީފައެއް ނުވޭ.",
        "sameEntity": "ޗެކް ނުކުރެވުނު: ކައުންޓަރޕާޓީއަކީ {entity} އަމިއްލައަށް، އެހެންކަމުން އިންޓަކޮމްޕެނީއެއް ނެތް.",
        "noIntercompanyRule": "މި ތާރީޚުގައި {entity} އާއި {counterparty} ދެމެދު އިންޓަކޮމްޕެނީ ޤަވާޢިދެއް ކޮންފިގަރކޮށްފައެއް ނުވޭ.",
        "intercompanyBalanced": "{entity} އާއި {counterparty} ދެމެދުގެ އިންޓަކޮމްޕެނީ އެކައުންޓްތައް ބެލެންސްވޭ.",
        "intercompanyUnbalanced": "އިންޓަކޮމްޕެނީ އެކައުންޓްތައް ބެލެންސެއް ނުވޭ — ބާކީ {residual}. {findings}"
      }
    },
    "workforce": {
      "routeTitles": {
        "namingTemplates": "ނޭމިންގ ޓެމްޕްލޭޓްތައް",
        "headcount": "ހެޑްކައުންޓް",
        "reorganisations": "ރީއޯގަނައިޒޭޝަންތައް",
        "reorganisation": "ރީއޯގަނައިޒޭޝަން",
        "model": "މޮޑެލް، ނަން ދިނުމާއި ހެޑްކައުންޓް",
        "departments": "ޑިޕާޓްމަންޓްތައް",
        "assignmentValidator": "އެސައިންމަންޓް ވެލިޑޭޓަރ"
      },
      "model": {
        "title": "މޮޑެލް، ނަން ދިނުމާއި ހެޑްކައުންޓް",
        "description": "ޑޭޓާއިން ފެންނަ ވޯކްފޯސް މޮޑެލް، ވަޒީފާއާއި މަޤާމުގެ ނަންތައް ތައްޔާރުކުރާ ނޭމިންގ ޓެމްޕްލޭޓްތައް، އަދި ހުއްދަކުރެވިފައިވާ ހެޑްކައުންޓާއި ފުރިފައިވާ ހެޑްކައުންޓް.",
        "tabsLabel": "ވޯކްފޯސް މޮޑެލްގެ ބައިތައް",
        "tabs": {
          "model": "މޮޑެލް އަދި ހެޑްކައުންޓް",
          "naming": "ނޭމިންގ ޓެމްޕްލޭޓްތައް",
          "headcount": "ހެޑްކައުންޓް އިވެންޓްތައް"
        },
        "modelTitle": "ވޯކްފޯސް މޮޑެލް",
        "modelLabel": "ބޭނުންކުރާ މޮޑެލް",
        "derived": {
          "positions": "މަޤާމުތަކަށް ބިނާކޮށްފައި",
          "jobs": "ވަޒީފާތަކަށް ބިނާކޮށްފައި"
        },
        "modelHint": "މިއީ ސެޓިންގއެއް ނޫން، ޑޭޓާއިން ކިޔާލެވޭ ގޮތެވެ: މަޤާމުތައް ކަނޑައަޅާފައިވާނަމަ މަޤާމުތަކަށް ބިނާކޮށްފައިވާ މޮޑެލެކެވެ؛ މަޤާމު ނެތި ވަޒީފާތައް ހުރިނަމަ ވަޒީފާތަކަށް ބިނާކޮށްފައިވާ މޮޑެލެކެވެ. ދެބައިން އެއްވެސް ބައެއް ނެތްނަމަ އެއްވެސް އެއްޗެއް ނުދައްކައެވެ.",
        "headcountTitle": "ހެޑްކައުންޓް — ހުއްދަކުރެވިފައިވާ އަދި ފުރިފައިވާ",
        "headcountDescription": "މިއަދުގެ ހިސާބުން މަޤާމުތައް: ހުއްދަކުރެވިފައިވާ ހެޑްކައުންޓް، މިހާރު ހިފަހައްޓާ މީހުން، އަދި އަދިވެސް ހުސް ތަންތަން.",
        "positionsLoadFailed": "މަޤާމުތައް ލޯޑެއް ނުކުރެވުނު",
        "noPositionsTitle": "އަދި މަޤާމެއް ނެތް",
        "noPositionsDescription": "ކޮންމެ ތަނަކަށް ހުއްދަކުރެވޭ ހެޑްކައުންޓް ހިންގުމަށް މަޤާމުތައް ކަނޑައަޅުއްވާ.",
        "firstPageOnly": "ފުރަތަމަ 50 މަޤާމު ދައްކަނީ. ހުރިހާ މަޤާމެއް ބެއްލެވުމަށް މަޤާމުތަކުގެ ސްކްރީން ބޭނުންކުރައްވާ.",
        "overFilled": "{count} އިތުރު",
        "namingNoPermission": "ނޭމިންގ ޓެމްޕްލޭޓްތައް ކިޔުމުގެ ހުއްދަ ތިޔަ ފަރާތުގައި ނެތެވެ."
      },
      "departments": {
        "title": "ޑިޕާޓްމަންޓްތައް",
        "description": "ކުންފުންޏެއްގެ ޑިޕާޓްމަންޓްތައް: މަޤާމުތައް ހިމެނޭ އަދި ރީއޯގަނައިޒޭޝަން އިންޖިނުން ބަދަލުކުރާ ޔުނިޓްތައް.",
        "create": "އައު ޑިޕާޓްމަންޓް",
        "company": "ކުންފުނި",
        "companiesFailed": "ކުންފުނިތައް ލޯޑެއް ނުކުރެވުނު",
        "search": "ހޯދާ",
        "searchHint": "ކޯޑް ނުވަތަ ނަން",
        "loadFailed": "ޑިޕާޓްމަންޓްތައް ލޯޑެއް ނުކުރެވުނު",
        "tableLabel": "ޑިޕާޓްމަންޓްތައް",
        "emptyTitle": "ޑިޕާޓްމަންޓެއް ނެތް",
        "emptyDescription": "މި ކުންފުންޏަށް ފުރަތަމަ ޑިޕާޓްމަންޓް ހައްދަވާ، ނުވަތަ ހޯދުން ފުހެލައްވާ.",
        "columns": {
          "department": "ޑިޕާޓްމަންޓް",
          "parent": "މައި ޑިޕާޓްމަންޓް",
          "actions": "ޢަމަލުތައް"
        },
        "active": "ހަރަކާތްތެރި",
        "inactive": "ހަރަކާތްތެރި ނޫން",
        "deleteTitle": "ޑިޕާޓްމަންޓް ފޮހެލާ",
        "deleteMessage": "{name} ފޮހެލަންވީތޯ؟ މަޤާމުތަކާއި ކުދި ޑިޕާޓްމަންޓްތައް މިއާ ގުޅިފައި ހުރިހާ ހިނދަކު ފޮހެލެވޭކަށް ނެތް.",
        "deleted": "ޑިޕާޓްމަންޓް ފޮހެލެވިއްޖެ",
        "deleteFailed": "ޑިޕާޓްމަންޓް ފޮހެލެވޭގޮތެއް ނުވިއެވެ",
        "conflict": "އެހެން ފަރާތަކުން މި ޑިޕާޓްމަންޓަށް ބަދަލު ގެނެސްފި — ލިސްޓު އަލުން ލޯޑްކުރެވިއްޖެ. ބައްލަވާފައި އަލުން މަސައްކަތްކުރައްވާ."
      },
      "validator": {
        "title": "އެސައިންމަންޓް ވެލިޑޭޓަރ",
        "description": "އެސައިންމަންޓެއް ހެދުމުގެ ކުރިން ޑިޕާޓްމަންޓް، މަޤާމުގެ ހެޑްކައުންޓް، ގްރޭޑްގެ މުސާރަ ރޭންޖް އަދި ޤާނޫނީ މުވައްޒަފު ދޭ ފަރާތާ ދިމާވޭތޯ ބަލާ. އެއްވެސް އެއްޗެއް ރައްކާއެއް ނުކުރެއެވެ.",
        "formTitle": "އެސައިންމަންޓެއް ބަލާ",
        "fields": {
          "position": "މަޤާމު",
          "department": "ޑިޕާޓްމަންޓް",
          "legalEmployer": "ޤާނޫނީ މުވައްޒަފު ދޭ ފަރާތް",
          "grade": "ގްރޭޑް",
          "salary": "މުސާރަ",
          "salaryHint": "އިޚްތިޔާރީ — ގްރޭޑްގެ މުސާރަ ރޭންޖާ ދިމާވޭތޯ ބަލާނެ.",
          "effectiveFrom": "ފެށޭ ތާރީޚް",
          "effectiveTo": "ނިމޭ ތާރީޚް",
          "employee": "މުވައްޒަފުގެ ނަންބަރު",
          "employeeHint": "އިޚްތިޔާރީ — އެ މީހަކަށް އެސައިންމަންޓް ބެލުމަށް މުވައްޒަފުގެ ރެކޯޑް ނަންބަރު.",
          "employeeInvalid": "މުވައްޒަފުގެ ރެކޯޑް ނަންބަރު ޖައްސަވާ (އަދަދު އެކަނި).",
          "assignmentType": "އެސައިންމަންޓްގެ ބާވަތް",
          "overrideReason": "އޯވަރައިޑްކުރާ ސަބަބު",
          "overrideReasonHint": "އިޚްތިޔާރީ — މި އެސައިންމަންޓަށް ޤަވާޢިދެއް އޯވަރައިޑްކުރަންޖެހޭ ސަބަބު.",
          "intendedHint": "އެސައިންމަންޓްގައި ބޭނުންވާ އަގު ބަޔާންކުރައްވާ. އެ އަގު މަޤާމުގެ އަގާ އަޅާކިޔާނެއެވެ؛ ހުސްކޮށް ބާއްވައިފިނަމަ ނުބަލާނެއެވެ."
        },
        "assignmentTypes": {
          "primary": "މައި",
          "secondary": "ދެވަނަ"
        },
        "fieldNames": {
          "positionId": "މަޤާމު",
          "departmentId": "ޑިޕާޓްމަންޓް",
          "legalEmployerId": "ޤާނޫނީ މުވައްޒަފު ދޭ ފަރާތް",
          "gradeId": "ގްރޭޑް",
          "salary": "މުސާރަ",
          "effectiveFrom": "ފެށޭ ތާރީޚް",
          "effectiveTo": "ނިމޭ ތާރީޚް",
          "employeeId": "މުވައްޒަފު",
          "assignmentType": "އެސައިންމަންޓްގެ ބާވަތް",
          "overrideReason": "އޯވަރައިޑްކުރާ ސަބަބު"
        },
        "validate": "ވެލިޑޭޓްކުރޭ",
        "pass": "ރަނގަޅު — މި އެސައިންމަންޓް ހުރިހާ ޑިޕާޓްމަންޓް، ހެޑްކައުންޓް، ގްރޭޑް ރޭންޖް އަދި ޤާނޫނީ މުވައްޒަފު ދޭ ފަރާތުގެ ޤަވާޢިދުތަކާ ދިމާވެއެވެ.",
        "failed": "އެއްވެސް ޚިލާފެއް ނެތް | ޚިލާފު 1 ފެނިއްޖެ | ޚިލާފު {count} ފެނިއްޖެ",
        "assignmentsTitle": "މިހާރުގެ އެސައިންމަންޓްތައް",
        "assignmentsDescription": "މިއަދު ހިނގަމުންދާ އެސައިންމަންޓްތައް. މިއަދުގެ ޤަވާޢިދުތަކާ ދިމާވޭތޯ ބެލުމަށް އެއްޗެއް އަލުން ވެލިޑޭޓްކުރައްވާ.",
        "assignmentsLoadFailed": "އެސައިންމަންޓްތައް ލޯޑެއް ނުކުރެވުނު",
        "noAssignmentsTitle": "މިހާރު ހިނގާ އެސައިންމަންޓެއް ނެތް",
        "noAssignmentsDescription": "މީހުން މަޤާމުތަކަށް ހަވާލުކުރުމުން އެސައިންމަންޓްތައް މިތާ ފެންނާނެއެވެ.",
        "firstPageOnly": "ފުރަތަމަ 50 އެސައިންމަންޓް ދައްކަނީ.",
        "revalidate": "އަލުން ވެލިޑޭޓްކުރޭ",
        "columns": {
          "employee": "މުވައްޒަފު",
          "type": "ބާވަތް · FTE",
          "lastCheck": "އެންމެ ފަހުން ބެލި"
        },
        "outcome": {
          "valid": "ރަނގަޅު",
          "invalid": "ޚިލާފުތައް",
          "failed": "ނުބެލުނު"
        }
      },
      "namingTemplates": {
        "title": "ނޭމިންގ ޓެމްޕްލޭޓްތައް",
        "description": "އެންޓަޕްރައިޒް، ބިޒްނަސް ޔުނިޓް ނުވަތަ ރިފަރެންސް ޑޭޓާ ސެޓް ލެވެލްގައި ކަނޑައެޅޭ އެޓްރިބިއުޓްތަކުން ވަޒީފާ އަދި މަޤާމުގެ ނަންތައް ތައްޔާރުކުރޭ.",
        "create": "އައު ނޭމިންގ ޓެމްޕްލޭޓް",
        "scope": {
          "label": "ސްކޯޕް",
          "enterprise": "އެންޓަޕްރައިޒް",
          "business_unit": "ބިޒްނަސް ޔުނިޓް",
          "reference_set": "ރިފަރެންސް ޑޭޓާ ސެޓް"
        },
        "object": {
          "label": "ބޭނުންކުރެވޭ ބާވަތް",
          "job": "ވަޒީފާ",
          "position": "މަޤާމު"
        },
        "attributeSequence": "އެޓްރިބިއުޓް ތަރުތީބު",
        "active": "ހަރަކާތްތެރި",
        "inactive": "ހަރަކާތްތެރިނޫން",
        "loadFailed": "ނޭމިންގ ޓެމްޕްލޭޓްތައް ލޯޑްކުރެވޭގޮތެއް ނުވި",
        "tableLabel": "ނޭމިންގ ޓެމްޕްލޭޓްތައް",
        "emptyTitle": "އަދި ނޭމިންގ ޓެމްޕްލޭޓެއް ނެތް",
        "emptyDescription": "ކަނޑައެޅިފައިވާ އެޓްރިބިއުޓް ތަރުތީބަކުން ވަޒީފާ ނުވަތަ މަޤާމުގެ ނަންތައް އަމިއްލައަށް ލިޔުމުގެ ބަދަލުގައި ތައްޔާރުކުރުމަށް އައު ޓެމްޕްލޭޓެއް އުފައްދާ.",
        "createTitle": "އައު ނޭމިންގ ޓެމްޕްލޭޓް",
        "editTitle": "ނޭމިންގ ޓެމްޕްލޭޓް އެޑިޓްކުރޭ",
        "editorDescription": "އެޓްރިބިއުޓް ތަރުތީބާއި ސެޕަރޭޓަރ އިން ނަން ތައްޔާރުކުރެއެވެ؛ ކަނާތުގައިވާ ލައިވް ޕްރިވިއުއިން ސުންޕަލް ވެލިއުތަކަކުން ލިބޭނެ ނަން ދައްކައިދެއެވެ.",
        "scopeId": "ސްކޯޕް id",
        "attributeSequenceHint": "މި އެޓްރިބިއުޓް ކީތައް ތަރުތީބުކުރެވޭ ގޮތް، ތިރީގައިވާ ސެޕަރޭޓަރުން ގުޅުވާފައި.",
        "attribute": "އެޓްރިބިއުޓް {n}",
        "addAttribute": "އެޓްރިބިއުޓެއް އިތުރުކުރޭ",
        "separator": "ސެޕަރޭޓަރ",
        "isActive": "ހަރަކާތްތެރި",
        "isActiveHint": "ހަރަކާތްތެރިނޫން ޓެމްޕްލޭޓްތައް ތާރީޚަށްޓަކައި ބަހައްޓައެވެ، ނަމަވެސް އައު ނަމެއް ތައްޔާރުކުރާއިރު ދެން ހުށަނާޅާނެއެވެ.",
        "previewTitle": "ލައިވް ޕްރިވިއު",
        "previewLocked": "ފުރަތަމަ މި ޓެމްޕްލޭޓް ރައްކާކުރޭ — ޕްރިވިއުއިން ނަން ތައްޔާރުކުރަނީ ރައްކާކުރެވިފައިވާ ޓެމްޕްލޭޓެއްގެ އަމިއްލަ އެޓްރިބިއުޓް ތަރުތީބުންނެވެ.",
        "previewHint": "މި ޓެމްޕްލޭޓުން ތައްޔާރުކުރާނެ ނަން ބެލުމަށް ކޮންމެ އެޓްރިބިއުޓަކަށް ސުންޕަލް ވެލިއުއެއް ޖައްސަވާ.",
        "collides": "މި ނަން މިހާރުވެސް ހުރި ރެކޯޑަކާއި ({code}) ދިމާވެއެވެ.",
        "saved": "ނޭމިންގ ޓެމްޕްލޭޓް ރައްކާކުރެވިއްޖެ",
        "saveFailed": "ނޭމިންގ ޓެމްޕްލޭޓް ރައްކާކުރެވޭގޮތެއް ނުވި"
      },
      "headcount": {
        "title": "ހެޑްކައުންޓް",
        "description": "މަޤާމަކަށް ފާސްކުރެވިފައިވާ، ފުރިފައިވާ އަދި ލިބެންހުރި ހެޑްކައުންޓް، އަދި އެ މަޤާމަށް ހުށަހެޅިފައިވާ ރިކުއިޒިޝަން، އޯވަރައިޑް އަދި ކުޑަކުރުންތައް.",
        "position": "މަޤާމު",
        "approvedColumn": "ފާސްކުރެވިފައި",
        "search": "މަޤާމުތައް ހޯދާ",
        "searchHint": "މަޤާމުގެ ކޯޑް ނުވަތަ ނަން",
        "searchFailed": "މަޤާމުތައް ހޯދޭގޮތެއް ނުވި",
        "resultsLabel": "ދިމާވި މަޤާމުތައް",
        "noResultsTitle": "މަޤާމެއް ނުފެނުނު",
        "noResultsDescription": "ތަފާތު ކޯޑެއް ނުވަތަ ނަމެއް ބައްލަވާ.",
        "loadFailed": "މި މަޤާމުގެ ހެޑްކައުންޓް ލޯޑްކުރެވޭގޮތެއް ނުވި",
        "asAt": "ތާރީޚަށް",
        "raiseEvent": "ހެޑްކައުންޓް އިވެންޓެއް ހުށަހަޅާ",
        "approved": "ފާސްކުރެވިފައި",
        "filled": "ފުރިފައި",
        "available": "ލިބެންހުރި",
        "sessionLogTitle": "މި ސެޝަންގައި ހުށަހެޅި އިވެންޓްތައް",
        "sessionLogHint": "ހިސްޓްރީ އެންޑްޕޮއިންޓެއް އަދި ނެތް — މި ލިސްޓަކީ މި ބްރައުޒަރ ސެޝަންގައި ރެކޯޑްކުރެވުނު ތަކެތި، މަޤާމުގެ ފުރިހަމަ ހިސްޓްރީއެއް ނޫން.",
        "effectiveFromLabel": "ފެށޭ ތާރީޚް",
        "newApproved": "އައު ފާސްކުރެވިފައިވާ",
        "eventType": {
          "requisition": "ރިކުއިޒިޝަން",
          "override": "އޯވަރައިޑް",
          "reduction": "ކުޑަކުރުން"
        },
        "raiseTitle": "ހެޑްކައުންޓް އިވެންޓެއް ހުށަހަޅާ",
        "raiseDescription": "ރިކުއިޒިޝަނަކުން ނުވަތަ އޯވަރައިޑަކުން ފާސްކުރެވިފައިވާ ހެޑްކައުންޓް އިތުރުކުރެއެވެ؛ ކުޑަކުރުމަކުން ދަށްކުރެއެވެ، އަދި މަޤާމުގެ މިހާރު ހިއްސާވާ ފަރާތްތަކުގެ އަދަދަށްވުރެ ދަށަށް ނުދެވޭނެއެވެ.",
        "eventTypeLabel": "އިވެންޓް ބާވަތް",
        "magnitude": "FTE ބަދަލު",
        "requisitionRef": "ރިކުއިޒިޝަން ރެފަރެންސް",
        "overrideReasonCode": "އޯވަރައިޑް ސަބަބުގެ ކޯޑް",
        "overrideReason": "އޯވަރައިޑް ސަބަބު",
        "overrideConsequence": "އޯވަރައިޑެއް ރެކޯޑްކުރެވި، HR ގަވަރނަންސަށް އިސްތިސްނާއެއްގެ ގޮތުގައި ރިޕޯޓްކުރެވޭނެއެވެ (FSD 1.2.5.11).",
        "reductionHint": "މަޤާމު މިހާރު ހިއްސާވާ ފަރާތްތަކުގެ އަދަދަށްވުރެ ފާސްކުރެވިފައިވާ ހެޑްކައުންޓް ދަށަށް ނުކުރެވޭނެއެވެ.",
        "approverId": "އެޕްރޫވަރ (ޔޫޒަރ id)",
        "eventSaved": "ހެޑްކައުންޓް އިވެންޓް ރެކޯޑްކުރެވިއްޖެ",
        "eventSaveFailed": "ހެޑްކައުންޓް އިވެންޓް ރެކޯޑްކުރެވޭގޮތެއް ނުވި"
      },
      "reorganisations": {
        "title": "ވަރކްފޯސް ރީއޯގަނައިޒޭޝަންތައް",
        "description": "މަޤާމުތަކާއި ޑިޕާޓްމަންޓްތަކަށް ގެންނަ ބަދަލުތަކުގެ ތާރީޚަށް ފަސްކުރެވިފައިވާ ބަޗްތައް، ހުށަހެޅުމުގެ ކުރިން ސިމިއުލޭޓްކުރެވި، ހިނގާ ތާރީޚުގައި އަމިއްލައަށް ހިންގައެވެ.",
        "create": "އައު ރީއޯގަނައިޒޭޝަން",
        "registryNote": "މި ލިސްޓުގައި ދައްކަނީ މި ބްރައުޒަރ ސެޝަންގައި އުފެއްދި ނުވަތަ ހުޅުވި ރީއޯގަނައިޒޭޝަންތަކެވެ — ރީއޯގަނައިޒޭޝަން ކެޓަލޮގް ލިސްޓް އެންޑްޕޮއިންޓެއް އަދި ނެތް (ރީލޯޑަކަށްފަހު ވެސް ކުރިއަށް ދިއުމަށް ތިރީގައިވާ id ލުކްއަޕް ބޭނުންކުރޭ).",
        "tableLabel": "ރީއޯގަނައިޒޭޝަންތައް",
        "emptyTitle": "މި ސެޝަންގައި ރީއޯގަނައިޒޭޝަނެއް ނެތް",
        "emptyDescription": "އައު ރީއޯގަނައިޒޭޝަނެއް އުފައްދާ، ނުވަތަ id އެނގޭނަމަ ތިރީގައި ހުޅުވާ.",
        "code": "ކޯޑް",
        "status": {
          "draft": "ޑްރާފްޓް",
          "pending": "ފާސްކުރުމަށް އިންތިޒާރުގައި",
          "approved": "ފާސްކުރެވިފައި",
          "applied": "ހިންގިފައި",
          "reversed": "ބާތިލްކުރެވިފައި"
        },
        "effectiveOn": "ހިނގާ ތާރީޚް",
        "effectiveOnHint": "މިއަދަށްފަހު ތާރީޚަކަށްވާންޖެހޭ — ވަގުތުން ގެންނަ ބަދަލެއްނަމަ އާދައިގެ ސުޕަރސީޑް ހަރަކާތް ބޭނުންކުރޭ.",
        "changeSummary": "ބަދަލުގެ ޚުލާސާ",
        "openById": "id އިން ރީއޯގަނައިޒޭޝަނެއް ހުޅުވާ",
        "reorgId": "ރީއޯގަނައިޒޭޝަން id",
        "open": "ހުޅުވާ",
        "createTitle": "އައު ރީއޯގަނައިޒޭޝަން",
        "createDescription": "ފާސްކުރުމަށް ހުށަހެޅުމުގެ ކުރިން ބަދަލުގެ އަސަރު ބެލުމަށް ސިމިއުލޭޓްކުރޭ.",
        "items": "ފީލްޑް ބަދަލުތައް",
        "objectType": "އޮބްޖެކްޓް",
        "objectId": "އޮބްޖެކްޓް id",
        "fieldLabel": "ފީލްޑް",
        "toValue": "އައު ވެލިއު",
        "addItem": "ފީލްޑް ބަދަލެއް އިތުރުކުރޭ",
        "simulate": "ސިމިއުލޭޓްކުރޭ",
        "simulationStale": "މި ސިމިއުލޭޝަނަށްފަހު ފޯމަށް ބަދަލު އައިސްފިއެވެ — ކަށަވަރުކުރުމުގެ ކުރިން އަލުން ސިމިއުލޭޓްކުރޭ.",
        "simulationReady": "ސިމިއުލޭޝަން ތައްޔާރު — ތިރީގައިވާ އަސަރު ބައްލަވައި، ދެން ކަށަވަރުކުރައްވާ.",
        "resolvedItems": "ހައްލުކުރެވުނު ބަދަލުތައް",
        "affectedAssignments": "އަސަރުކުރާ އެސައިންމަންޓްތައް",
        "noAffectedAssignments": "މި ބަދަލުން އެއްވެސް މުވައްޒަފެއްގެ އެސައިންމަންޓަކަށް އަސަރެއް ނުކުރެއެވެ.",
        "employee": "މުވައްޒަފު",
        "costCentreImpact": "ކޯސްޓް ސެންޓަރ އަސަރު",
        "confirmCreate": "ކަށަވަރުކޮށް ހުށަހަޅާ",
        "saved": "ރީއޯގަނައިޒޭޝަން ހުށަހެޅިއްޖެ",
        "saveFailed": "ރީއޯގަނައިޒޭޝަން ހުށަހެޅޭގޮތެއް ނުވި",
        "simulateFailed": "ރީއޯގަނައިޒޭޝަން ސިމިއުލޭޓްކުރެވޭގޮތެއް ނުވި",
        "object": {
          "position": "މަޤާމު",
          "department": "ޑިޕާޓްމަންޓް"
        },
        "field": {
          "reportsToPositionId": "ރިޕޯޓްކުރަނީ (މަޤާމުގެ id)",
          "departmentId": "ޑިޕާޓްމަންޓް id",
          "businessUnitId": "ބިޒްނަސް ޔުނިޓް id",
          "costCenterId": "ކޯސްޓް ސެންޓަރ id",
          "headcount": "ފާސްކުރެވިފައިވާ ހެޑްކައުންޓް",
          "managerPositionId": "މެނޭޖަރ (މަޤާމުގެ id)",
          "parentId": "ބެލެނިވެރި ޑިޕާޓްމަންޓް id"
        },
        "detailTitle": "ރީއޯގަނައިޒޭޝަން {code}",
        "loadFailed": "މި ރީއޯގަނައިޒޭޝަން ލޯޑްކުރެވޭގޮތެއް ނުވި",
        "reverse": "ބާތިލްކުރޭ",
        "reverseBlockedApplied": "މި ރީއޯގަނައިޒޭޝަން މިހާރުވަނީ {date} ގައި ހިންގިފައެވެ؛ ބާތިލްކުރުމަށް އައު ރީއޯގަނައިޒޭޝަނެއް ހުށަހަޅާ.",
        "reverseBlockedReversed": "މި ރީއޯގަނައިޒޭޝަން މިހާރުވަނީ ބާތިލްކުރެވިފައެވެ.",
        "appliedAt": "ހިންގުނު ތާރީޚް",
        "reverseTitle": "މި ރީއޯގަނައިޒޭޝަން ބާތިލްކުރޭ",
        "reverseDescription": "ހިނގަން ފެށިފައިނުވާ ރީއޯގަނައިޒޭޝަނެއް އެކަނި މިގޮތަށް ބާތިލްކުރެވޭނެއެވެ.",
        "reverseConsequence": "މިއިން ހިނގާ ތާރީޚުގެ ކުރިން ރީއޯގަނައިޒޭޝަން ކެންސަލްކުރެވޭނެއެވެ. މިކަން ބަދަލުނުކުރެވޭނެއެވެ — ކެންސަލްކުރެވުނު ރީއޯގަނައިޒޭޝަނެއް އަލުން ފެށުނުން ހުށަހަޅަންޖެހޭނެއެވެ.",
        "reverseReason": "ސަބަބު (އިޚްތިޔާރީ)",
        "reversed": "ރީއޯގަނައިޒޭޝަން ބާތިލްކުރެވިއްޖެ",
        "reverseFailed": "ރީއޯގަނައިޒޭޝަން ބާތިލްކުރެވޭގޮތެއް ނުވި"
      }
    }
  },
  "home": {
    "hero": {
      "workspace": "ވޯކްސްޕޭސް {slug}",
      "search": "ސްކްރީން، ރެކޯޑް އަދި ޢަމަލުތައް ހޯދާ",
      "mfaFix": "ތިބާގެ އެކައުންޓަށް ޓޫ-ފެކްޓަރ ސައިން އިން ގާއިމުކުރައްވާ"
    },
    "role": {
      "eyebrow": "މިތަނުން ފަށާ",
      "title": "ތިބާގެ {name} ޑޭޝްބޯޑު",
      "description": "ތިބާގެ ރޯލު ޒިންމާވާ އަދަދުތައް، ކޮންމެ އަދަދަކުން ވެސް އޭގެ ފަހަތުގައިވާ ރޯތައް ހުޅުވޭ.",
      "open": "ޑޭޝްބޯޑު ހުޅުވާ"
    },
    "today": {
      "title": "މިއަދު",
      "description": "ހުރިހާ އެޕްތަކުން ތިބާއަށް އިންތިޒާރުކުރާ ގުޅިގެން ކުރާ މަސައްކަތް.",
      "attentionOpen": "{count} ހުޅުވިފައި",
      "attentionOverdue": "{count} ފަސްވެފައި",
      "notificationsUnread": "{count} ނުކިޔާ",
      "countLoading": "އަދަދު ލޯޑުވަނީ"
    },
    "apps": {
      "title": "އެޕްތައް",
      "description": "ތިބާއަށް ހުޅުވޭ ޕްރޮޑަކްޓްގެ ކޮންމެ ބައެއް. ކޮންމެ އެޕެއް ހުޅުވެނީ އޭގެ ފުރަތަމަ ސްކްރީނުންނެވެ.",
      "part": "ބައި {n}",
      "emptyTitle": "އަދި ތިބާއަށް އެއްވެސް އެޕެއް ހުޅުވިފައެއް ނެތް",
      "emptyDescription": "ތިބާގެ ރޯލުތަކުން އެއްވެސް އެޕެއްގެ ސްކްރީނަކަށް ނުވަދެވޭ. ރޯލެއް ދެއްވުމަށް ޓެނަންޓް އެޑްމިނަށް އެދިވަޑައިގަންނަވާ."
    },
    "pinned": {
      "title": "ޕިން ކުރެވިފައި",
      "emptyTitle": "އަދި އެއްވެސް އެއްޗެއް ޕިން ކުރެވިފައެއް ނުވޭ",
      "emptyDescription": "މިތަނަށް ޕިން ކުރުމަށް، ކޮންމެ އެޕެއްގެ މެނިއުގައިވާ ސްކްރީނަކަށް ތަރި ޖައްސަވާ.",
      "unpin": "{label} ޕިން ނައްތާލާ"
    },
    "recent": {
      "title": "ފަހުގެ",
      "emptyTitle": "ފަހުން ބެލި ސްކްރީނެއް ނެތް",
      "emptyDescription": "ތިބާ ހުޅުވާ ސްކްރީންތައް މިތަނުގައި ފެނޭނެ، ދެން ހުއްޓާލި ތަނުން ކުރިއަށް ގެންދެވޭނެ."
    },
    "setup": {
      "title": "ވޯކްސްޕޭސް ސެޓަޕް",
      "description": "ސައިން އިން ވެވޭނީ ކާކަށް، ހުރި ރޯލުތައް، އަދި އެކައުންޓްތައް ރައްކާތެރިކުރެވިފައިވާ ގޮތް.",
      "accountTitle": "ތިބާގެ އެކައުންޓް",
      "accountDescription": "ތިބާގެ ސައިން އިން ރައްކާތެރިކުރެވިފައިވާ ގޮތް، އަދި ތިބާ ސައިން އިން ވެފައިވާ ތަންތަން."
    }
  },
  "lease": {
    "draftLabel": "ޑްރާފްޓް ލީސް",
    "percentValue": "{value}%",
    "routeTitles": {
      "list": "ލީސް އެގްރީމެންޓްތައް",
      "reports": "ލީސް ރިޕޯޓްތައް",
      "runs": "ލީސް މުއްދަތުގެ ރަންތައް",
      "contract": "ލީސް އެގްރީމެންޓް"
    },
    "statuses": {
      "draft": "ޑްރާފްޓް",
      "pending_approval": "އެޕްރޫވަލަށް އިންތިޒާރުގައި",
      "active": "ހިނގަމުންދާ",
      "rejected": "ރިޖެކްޓްކުރެވިފަ",
      "lapsed": "މުއްދަތު ހަމަވެފަ",
      "ended": "ނިމިފަ",
      "terminated": "ބާތިލްކުރެވިފަ"
    },
    "kinds": {
      "capitalised": "ހިސާބަށް ނެގިފައިވާ",
      "exempt": "އިސްތިސްނާ"
    },
    "frequencies": {
      "monthly": "މަހުން މަހަށް",
      "quarterly": "ތިން މަހުން ތިން މަހަށް",
      "semi_annual": "ހަ މަހުން ހަ މަހަށް",
      "annual": "އަހަރުން އަހަރަށް"
    },
    "timings": {
      "advance": "ކުރިން",
      "arrears": "ފަހުން"
    },
    "changeKinds": {
      "remeasure": "އަލުން މިނުން",
      "terminate": "ބާތިލްކުރުން"
    },
    "changeStatuses": {
      "pending_approval": "އެޕްރޫވަލަށް އިންތިޒާރުގައި",
      "applied": "ހިންގިފަ",
      "rejected": "ރިޖެކްޓްކުރެވިފަ",
      "cancelled": "ކެންސަލްކުރެވިފަ",
      "lapsed": "މުއްދަތު ހަމަވެފަ"
    },
    "fields": {
      "company": "ޤާނޫނީ ފަރާތް",
      "name": "ނަން",
      "description": "ތަފްސީލް",
      "lessor": "ލީސްދޭ ފަރާތް",
      "assetClass": "ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލުގެ ބާވަތް",
      "commencementDate": "ފެށޭ ތާރީޚް",
      "endDate": "ނިމޭ ތާރީޚް",
      "term": "މުއްދަތު",
      "paymentAmount": "ފައިސާ ދައްކާ މިންވަރު",
      "frequency": "ފައިސާ ދައްކާ ދައުރު",
      "timing": "ފައިސާ ދައްކާ ވަގުތު",
      "discountRate": "ޑިސްކައުންޓް ރޭޓް",
      "escalationPercent": "އަހަރީ އިތުރުވުން",
      "exemption": "ހިސާބަށް ނުނެގުމުގެ އިސްތިސްނާ",
      "shortTerm": "ކުރު މުއްދަތު (12 މަސް ނުވަތަ ދަށް)",
      "lowValue": "އަގު ދަށް މުދާ",
      "liabilityAccount": "ލީސް ލަޔަބިލިޓީ އެކައުންޓް",
      "accrualAccount": "ކުރިން ދައްކާ ނުވަތަ އެކްރޫއަލް އެކައުންޓް",
      "interestExpenseAccount": "އިންޓެރެސްޓް ޚަރަދު އެކައުންޓް",
      "rentExpenseAccount": "ކުލީގެ ޚަރަދު އެކައުންޓް",
      "costCenter": "ކޮސްޓް ސެންޓަރ",
      "branch": "ބްރާންޗް",
      "notes": "ނޯޓް",
      "status": "ހާލަތު",
      "kind": "ބާވަތް",
      "presentValue": "މިހާރުގެ އަގު",
      "totalPayments": "ޖުމްލަ ފައިސާ",
      "periods": "މުއްދަތުތައް",
      "rouAsset": "ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދާ",
      "activationJournal": "ފެށުމުގެ ޖާނަލް",
      "terminatedOn": "ބާތިލްކުރި ތާރީޚް"
    },
    "errors": {
      "boundary": "ތާރީޚަކީ ހިނގަމުންދާ ޝެޑިއުލްގެ ފައިސާ ދައްކާ މުއްދަތެއްގެ ފުރަތަމަ ދުވަސް ކަމުގައި ވާން ޖެހޭ.",
      "posted": "މި ތާރީޚުން ފެށިގެން މުއްދަތެއް ޕޯސްޓްކުރެވިފައިވޭ؛ ބަދަލެއް ފެށޭނީ ޕޯސްޓް ނުކުރާ މުއްދަތަކުން.",
      "payable": "މި މުއްދަތުން ފެށިގެން ފައިސާއަކަށް AP ގައި ޕޭއަބަލް ހުރޭ؛ ފުރަތަމަ އެ ޑްރާފްޓް ޕޭއަބަލް ރިޖެކްޓް ނުވަތަ ކެންސަލްކުރޭ.",
      "order": "ކުރީގެ ބަދަލެއް މި ތާރީޚަށް ފަހުން ފެށިފައިވޭ؛ އޭގެ ކުރިން ބަދަލެއް ނުފެށޭނެ.",
      "future": "ތާރީޚަކީ މިއަދަށް ފަހުގެ ތާރީޚަކަށް ނުވާނެ.",
      "stale": "މި ރިކުއެސްޓް ކުރުމަށް ފަހު ޝެޑިއުލް ބަދަލުވެއްޖެ؛ މިހާރު މިގޮތަށް ނުހިންގޭނެ.",
      "exceeds_rou": "ކުޑަކުރާ މިންވަރަކީ ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލުގައި ހުރި މިންވަރަށްވުރެ ގިނަ މިންވަރެއް.",
      "disposal_threshold": "ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލުގައި ހުރީ މުދާ ނައްތާލުމުގެ އެޕްރޫވަލް ހައްދަށްވުރެ ގިނައިން؛ ފުރަތަމަ އެސެޓް ސެޓިންގްސް އިން ހައްދު މައްޗަށް ޖައްސަވާ.",
      "no_asset": "މި ލީހަށް ބަދަލުކުރެވޭނެ ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލެއް ނެތް.",
      "account": "މި ލީހަށް ބޭނުންވާ އެކައުންޓެއް ނެތް.",
      "exists": "މިއީ ކުރިން ވެސް ހުރި އެއްޗެއް.",
      "unprocessed": "މި ތާރީޚުގެ ކުރީގެ މުއްދަތުތައް އަދި ޕޯސްޓެއް އިންވޮއިސެއް ނުކުރޭ؛ ފުރަތަމަ ލީސް މުއްދަތުގެ ރަން ހިންގާ.",
      "short_term": "މި ބަދަލުން ކުރު މުއްދަތުގެ ލީހެއް ބާރަ މަހަށްވުރެ ދިގުވާނެ، އެހެންވީމާ އެ ލީސް ހިސާބަށް ނަގަން ޖެހޭނެ."
    },
    "list": {
      "title": "ލީސް އެގްރީމެންޓްތައް",
      "description": "ލީސް ނަގާ ފަރާތެއްގެ ގޮތުގައި ހިފާފައިވާ ހުރިހާ ލީހެއް: ހިސާބަށް ނެގިފައިވާ ލީސްތަކުގައި ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލާއި ލީސް ލަޔަބިލިޓީ ހުރޭ؛ ކުރު މުއްދަތާއި އަގު ދަށް ލީސްތައް އިސްތިސްނާ.",
      "toReports": "ރިޕޯޓްތައް",
      "toRuns": "މުއްދަތުގެ ރަންތައް",
      "toRunsPost": "މުއްދަތުގެ ރަންތައް",
      "new": "އައު ލީސް",
      "filtersTitle": "ފިލްޓަރުތައް",
      "allStatuses": "ހުރިހާ ހާލަތެއް",
      "allKinds": "ހުރިހާ ބާވަތެއް",
      "search": "ހޯދާ",
      "searchPlaceholder": "ލީސް ނަންބަރު ނުވަތަ ނަން",
      "tableTitle": "ލީސްތައް",
      "loadFailed": "ލީސް އެގްރީމެންޓްތައް ލޯޑް ނުކުރެވުނު",
      "empty": "މި ފިލްޓަރުތަކާ ގުޅޭ ލީސް އެގްރީމެންޓެއް ނެތް.",
      "emptyCanCreate": "އަދި ލީސް އެގްރީމެންޓެއް ނެތް. އައު ލީސް އިން ޑްރާފްޓެއް ހަދާ؛ ދެވަނަ މީހަކު އެޕްރޫވްކުރުމުން އެ ހިސާބަށް ނެގޭނެ.",
      "caption": "ލީސް އެގްރީމެންޓްތައް",
      "columns": {
        "no": "ލީސް"
      },
      "pending": {
        "remeasure": "އަލުން މިނުން އިންތިޒާރުގައި",
        "terminate": "ބާތިލްކުރުން އިންތިޒާރުގައި"
      }
    },
    "form": {
      "createTitle": "އައު ލީސް އެގްރީމެންޓް",
      "editTitle": "ޑްރާފްޓް ލީސް އެޑިޓްކުރުން",
      "description": "މި ޑްރާފްޓް އެޑިޓް ނުވަތަ ސަބްމިޓް ކުރެވޭނީ ތައްޔާރުކުރި ފަރާތަށް އެކަނި. ހިސާބަށް ނެގުން އެޕްރޫވްކުރަނީ ދެވަނަ މީހެއް.",
      "redraftNote": "މި އެގްރީމެންޓް ރިޖެކްޓް ނުވަތަ މުއްދަތު ހަމަވެފައިވޭ. ސޭވްކުރުމުން އެނބުރި ޑްރާފްޓަށް ދާނެ؛ އަލުން އެޕްރޫވަލަށް ސަބްމިޓްކުރޭ.",
      "endDateHint": "ލީހުގެ އެންމެ ފަހު ދުވަސް: ފެށޭ ތާރީޚުގެ އަހަރީ ދުވަހުގެ ކުރީ ދުވަސް.",
      "paymentHint": "ފުރަތަމަ މުއްދަތުގެ ފައިސާ، {currency} އިން.",
      "paymentHintNoCurrency": "ފުރަތަމަ މުއްދަތުގެ ފައިސާ.",
      "percentHint": "8.75% އަށް 8.75 ޖައްސަވާ.",
      "percentRange": "0 އާއި 100 ގެ ދެމެދުގެ ޕަސެންޓެއް ޖައްސަވާ.",
      "exemptionHint": "އިސްތިސްނާ ލީހެއްގައި ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލެއް ލަޔަބިލިޓީއެއް ނެތް؛ ފައިސާ ޚަރަދުގެ ގޮތުގައި ހަމަހަމައަށް ނެގޭ.",
      "assetClassHint": "ލީސް އެޕްރޫވްކުރުމުން ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދާ ރަޖިސްޓަރީކުރެވޭ ބާވަތް.",
      "create": "ޑްރާފްޓް ހަދާ",
      "save": "ބަދަލުތައް ސޭވްކުރޭ",
      "blockers": {
        "company": "ޤާނޫނީ ފަރާތެއް ހޮވާ.",
        "name": "ނަމެއް ޖައްސަވާ.",
        "vendor": "ލީސްދޭ ފަރާތް ހޮވާ.",
        "dates": "ފެށޭ އަދި ނިމޭ ތާރީޚު ޖައްސަވާ.",
        "endBeforeStart": "ނިމޭ ތާރީޚަކީ ފެށޭ ތާރީޚުގެ ކުރީގެ ތާރީޚަކަށް ނުވާނެ.",
        "payment": "ސުމެއްގެ މައްޗަށް ފައިސާ ޖައްސަވާ.",
        "percent": "ރޭޓްތަކަކީ 0 އާއި 100 ގެ ދެމެދުގެ ޕަސެންޓެއް.",
        "liabilityAccount": "ލަޔަބިލިޓީ (ނުވަތަ ކުރިން ދައްކާ) އެކައުންޓް ހޮވާ.",
        "assetClass": "ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލުގެ ބާވަތް ހޮވާ.",
        "interestAccount": "އިންޓެރެސްޓް ޚަރަދު އެކައުންޓް ހޮވާ.",
        "rentAccount": "ކުލީގެ ޚަރަދު އެކައުންޓް ހޮވާ.",
        "noChanges": "އެއްވެސް ބަދަލެއް ނުވޭ."
      }
    },
    "detail": {
      "title": "{no} · {name}",
      "loadingTitle": "ލީސް އެގްރީމެންޓް",
      "description": "ލީހުގެ ޝަރުތުތަކާއި، އޭގެ ދައުރާއި، އަމޯޓައިޒޭޝަން ޝެޑިއުލާއި، ހުރިހާ އަލުން މިނުމާއި ބާތިލްކުރުމެއް.",
      "backToList": "ލީސްތަކަށް އެނބުރި",
      "notFound": "މި ލީސް އެގްރީމެންޓެއް ނެތް",
      "loadFailed": "ލީސް އެގްރީމެންޓް ލޯޑް ނުކުރެވުނު",
      "stale": "މި ލީސް އެހެން މީހަކު ބަދަލުކޮށްފި. އެމީހުންގެ ބަދަލުތައް ބެލުމަށް ރީލޯޑްކޮށް، ދެން ތިބާގެ ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "ރީލޯޑް",
      "awaitingApproval": "ސަބްމިޓްކޮށް އެޕްރޫވަލަށް އިންތިޒާރުގައި. އެޕްރޫވަލްސް އިންބޮކްސް އިން ދެވަނަ މީހަކު އެޕްރޫވްކުރުމުން، ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލާއި ފެށުމުގެ ޖާނަލާއެކު ހިނގަން ފަށާނެ.",
      "toApprovals": "އެޕްރޫވަލްސް އިންބޮކްސް ހުޅުވާ",
      "rejectedNote": "އެޕްރޫވަލް ރިޖެކްޓްކުރެވިއްޖެ. ތައްޔާރުކުރި ފަރާތަށް އެގްރީމެންޓް އެޑިޓްކުރެވޭނެ، އޭރުން އެނބުރި ޑްރާފްޓަށް ދާނެ.",
      "lapsedNote": "އެޕްރޫވަލްގެ މުއްދަތު ހަމަވެއްޖެ: މުދަލެއް ނުވަތަ ޖާނަލެއް ޕޯސްޓް ނުކުރެވުނު. ތައްޔާރުކުރި ފަރާތަށް އެގްރީމެންޓް އެޑިޓްކުރެވޭނެ، އޭރުން އެނބުރި ޑްރާފްޓަށް ދާނެ.",
      "notPreparer": "މި ޑްރާފްޓް އެޑިޓް ނުވަތަ ސަބްމިޓް ކުރެވޭނީ ތައްޔާރުކުރި {name} އަށް އެކަނި.",
      "pendingTermination": "ބާތިލްކުރުމެއް އެޕްރޫވަލަށް އިންތިޒާރުގައި؛ އެ ނިންމަންދެން އެހެން ބަދަލެއް ރިކުއެސްޓް ނުކުރެވޭނެ.",
      "pendingRemeasurement": "އަލުން މިނުމެއް އެޕްރޫވަލަށް އިންތިޒާރުގައި؛ އެ ނިންމަންދެން އެހެން ބަދަލެއް ރިކުއެސްޓް ނުކުރެވޭނެ.",
      "lifecycle": "ދައުރު",
      "terms": "ޝަރުތުތައް",
      "months": "{count} މަސް",
      "periodsPosted": "{total} ން {posted} ޕޯސްޓްކުރެވިފަ",
      "openAsset": "މުދާ ހުޅުވާ",
      "openJournal": "ޖާނަލް ހުޅުވާ",
      "actions": "ލީސް ޢަމަލުތައް",
      "submitHint": "ސަބްމިޓްކުރުމުން މިހާރުގެ އަގާއި ޝެޑިއުލް ހަރުލައި، ލީސް އެޕްރޫވަލަށް ފޮނުވޭނެ."
    },
    "timeline": {
      "drafted": "ޑްރާފްޓްކުރެވުނު",
      "submitted": "ސަބްމިޓްކުރެވުނު",
      "awaiting": "އެޕްރޫވަލަށް އިންތިޒާރުގައި",
      "activated": "އެޕްރޫވްކޮށް ހިނގަމުންދާ",
      "rejected": "ރިޖެކްޓްކުރެވުނު",
      "lapsed": "މުއްދަތު ހަމަވި",
      "ended": "ނިމުނު",
      "terminated": "ބާތިލްކުރެވުނު"
    },
    "actions": {
      "edit": "ޑްރާފްޓް އެޑިޓްކުރޭ",
      "submit": "އެޕްރޫވަލަށް ސަބްމިޓްކުރޭ",
      "remeasure": "އަލުން މިނާ",
      "terminate": "ބާތިލްކުރޭ"
    },
    "toasts": {
      "saved": "ލީސް ސޭވްކުރެވިއްޖެ",
      "submitted": "ލީސް {no} ސަބްމިޓްކުރެވިއްޖެ",
      "submittedDetail": "ދެވަނަ މީހަކު އެޕްރޫވްކުރުމުން ހިނގަން ފަށާނެ.",
      "submitFailed": "ލީސް ސަބްމިޓް ނުކުރެވުނު",
      "remeasureRequested": "އަލުން މިނުމަށް ރިކުއެސްޓްކުރެވިއްޖެ",
      "terminateRequested": "ބާތިލްކުރުމަށް ރިކުއެސްޓްކުރެވިއްޖެ",
      "changeRequestedDetail": "ދެވަނަ މީހަކު އެޕްރޫވްކުރަންދެން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެ."
    },
    "schedule": {
      "title": "އަމޯޓައިޒޭޝަން ޝެޑިއުލް",
      "description": "ސަބްމިޓްކުރުމުން ހަރުލެވޭ؛ އަލުން މިނުމަކުން ނުވަތަ ބާތިލްކުރުމަކުން އައު ވަރޝަނެއް އިތުރުކުރޭ، ކުރީގެ ވަރޝަނެއް ބަދަލެއް ނުކުރޭ.",
      "inForce": "ހިނގަމުންދާ ޝެޑިއުލް",
      "versionLabel": "ވަރޝަން {version} · {kind} · {from} އިން",
      "current": "ހިނގަމުންދާ",
      "versionKinds": {
        "original": "އަސްލު",
        "remeasure": "އަލުން މިނުން",
        "terminate": "ބާތިލްކުރުން"
      },
      "versionPicker": "ޝެޑިއުލް ވަރޝަން",
      "preview": "ޕްރީވިއު: މި ޑްރާފްޓަށް ހިސާބުކުރެވިފައި، އަދި ހަރުނުލާ",
      "versionShown": "ވަރޝަން {version}",
      "loadFailed": "ޝެޑިއުލް ލޯޑް ނުކުރެވުނު",
      "empty": "މި ޝެޑިއުލްގައި އެއްވެސް މުއްދަތެއް ނެތް.",
      "caption": "ލީސް ޝެޑިއުލް",
      "columns": {
        "period": "މުއްދަތު",
        "dates": "ތާރީޚުތައް",
        "paymentDate": "ފައިސާ ދައްކާ ތާރީޚް",
        "payment": "ފައިސާ",
        "opening": "ފެށުމުގެ ލަޔަބިލިޓީ",
        "interest": "އިންޓެރެސްޓް",
        "principal": "އަސްލު ފައިސާ",
        "closing": "ނިމުމުގެ ލަޔަބިލިޓީ",
        "expense": "ޚަރަދު",
        "state": "ހާލަތު"
      },
      "posted": "ޕޯސްޓްކުރެވިފަ",
      "journal": "ޖާނަލް",
      "payable": "ޕޭއަބަލް",
      "totals": "ޖުމްލަ"
    },
    "changes": {
      "title": "އަލުން މިނުމާއި ބާތިލްކުރުން",
      "description": "ރިކުއެސްޓްކުރި ކޮންމެ ބަދަލެއް، އެޕްރޫވްކުރާ ފަރާތަށް ހަރުލި އަދަދުތަކާއި ހިންގުމުން ޕޯސްޓްކުރި އެއްޗަކާއެކު.",
      "loadFailed": "ބަދަލުތައް ލޯޑް ނުކުރެވުނު",
      "empty": "އަދި އަލުން މިނުމަކަށް ނުވަތަ ބާތިލްކުރުމަކަށް ރިކުއެސްޓެއް ނުކުރޭ.",
      "caption": "ލީސް ބަދަލުތައް",
      "columns": {
        "kind": "ބަދަލު",
        "effective": "ފެށޭ ތާރީޚް",
        "status": "ހާލަތު",
        "terms": "ޝަރުތުތައް",
        "carrying": "ކުރީގެ ލަޔަބިލިޓީ",
        "newLiability": "ފަހުގެ ލަޔަބިލިޓީ",
        "adjustment": "އެޑްޖަސްޓްމަންޓް",
        "rouCarrying": "ބޭނުންކުރުމުގެ ޙައްޤުގެ ބާކީ އަގު",
        "gainLoss": "ފައިދާ ނުވަތަ ގެއްލުން",
        "people": "މީހުން"
      },
      "newPayment": "ފައިސާ",
      "newEnd": "{date} ގައި ނިމޭ",
      "newRate": "ރޭޓް {value}%",
      "newEscalation": "އިތުރުވުން {value}%",
      "penalty": "ޖޫރިމަނާ",
      "requestedBy": "ރިކުއެސްޓްކުރީ {name}",
      "approvedBy": "އެޕްރޫވްކުރީ {name}",
      "pendingNote": "ބަދަލު {id} އެޕްރޫވަލްސް އިންބޮކްސް ގައި އެޕްރޫވަލަށް އިންތިޒާރުގައި."
    },
    "figures": {
      "liabilityBefore": "ކުރީގެ ލަޔަބިލިޓީ",
      "liabilityAfter": "ފަހުގެ ލަޔަބިލިޓީ",
      "adjustment": "އެޑްޖަސްޓްމަންޓް",
      "adjustmentNote": "ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދާ ވެސް އެ މިންވަރަށް ބަދަލުވޭ.",
      "rouCarrying": "ހިސާބުން ނެރުނު ބޭނުންކުރުމުގެ ޙައްޤުގެ ބާކީ އަގު",
      "rouAssetCarrying": "ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލުގެ ބާކީ އަގު",
      "rouAtApproval": "ބާތިލްކުރުން އެޕްރޫވްކުރާ ވަގުތު މުދަލުގެ ރަޖިސްޓަރުން ނެގޭނެ.",
      "gainLoss": "ފައިދާ (ގެއްލުން)"
    },
    "changeForm": {
      "periodHint": "މުއްދަތު {period}، {end} އަށް",
      "noDates": "މިއަދު އެއްވެސް މުއްދަތަކަށް ބަދަލެއް ނުގެނެވޭނެ: ފެށިފައިވާ ހުރިހާ މުއްދަތެއް ޕޯސްޓްކުރެވިފައި، ނުވަތަ އަދި އެއްވެސް މުއްދަތެއް ނުފެށޭ.",
      "effectiveDate": "ފެށޭ ތާރީޚް",
      "effectiveDateHint": "ޕޯސްޓް ނުކުރާ ފައިސާ ދައްކާ މުއްދަތެއްގެ ފުރަތަމަ ދުވަސް، މިއަދަށް ވުރެ ފަހު ނޫން.",
      "carryingAtDate": "އެ ތާރީޚުގެ ލަޔަބިލިޓީ",
      "pickDate": "ބެލުމަށް ތާރީޚެއް ހޮވާ.",
      "reason": "ސަބަބު",
      "done": "ނިމުނީ"
    },
    "remeasure": {
      "title": "އަލުން މިނުމަށް ރިކުއެސްޓްކުރުން",
      "description": "ލީސް {no}: މުއްދަތެއްގެ ފެށުމުން ފައިސާ، ނިމޭ ތާރީޚް، ޑިސްކައުންޓް ރޭޓް ނުވަތަ އިތުރުވުން ބަދަލުކުރޭ.",
      "requested": "ރިކުއެސްޓްކުރެވިއްޖެ. މި އަދަދުތައް އެޕްރޫވްކުރާ ފަރާތަށް ހަރުލެވިފައި؛ ދެވަނަ މީހަކު އެޕްރޫވްކުރަންދެން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރެވޭނެ.",
      "twoPerson": "މިއީ ރިކުއެސްޓެއް: އެޕްރޫވަލް ހުއްދަ ލިބިފައިވާ ދެވަނަ މީހެއް މި ހިންގާނެ. ތިބާގެ އަމިއްލަ ރިކުއެސްޓެއް ތިބާއަށް އެޕްރޫވެއް ނުކުރެވޭނެ.",
      "newPayment": "އައު ފައިސާ",
      "newEnd": "އައު ނިމޭ ތާރީޚް",
      "newRate": "އައު ޑިސްކައުންޓް ރޭޓް",
      "newEscalation": "އައު އަހަރީ އިތުރުވުން",
      "keepHint": "{value} ބަހައްޓަން ހުސްކޮށް ބަހައްޓާ.",
      "keepPercentHint": "{value}% ބަހައްޓަން ހުސްކޮށް ބަހައްޓާ. 8.75% އަށް 8.75 ޖައްސަވާ.",
      "reasonHint": "ލީސް އަލުން މިނާ ސަބަބު؛ އެޕްރޫވްކުރާ ފަރާތުން މި ކިޔާނެ.",
      "action": "އަލުން މިނުމަށް ރިކުއެސްޓްކުރޭ",
      "blockers": {
        "date": "ފެށޭ ތާރީޚް ހޮވާ.",
        "term": "ފައިސާ، ނިމޭ ތާރީޚް، ޑިސްކައުންޓް ރޭޓް ނުވަތަ އިތުރުވުމުން އެއްޗެއް ބަދަލުކުރޭ.",
        "payment": "ސުމެއްގެ މައްޗަށް ފައިސާ ޖައްސަވާ.",
        "percent": "ރޭޓްތަކަކީ 0 އާއި 100 ގެ ދެމެދުގެ ޕަސެންޓެއް.",
        "reason": "ސަބަބެއް ޖައްސަވާ."
      }
    },
    "terminate": {
      "title": "ބާތިލްކުރުމަށް ރިކުއެސްޓްކުރުން",
      "description": "ލީސް {no}: މުއްދަތެއްގެ ފެށުމުން ލީސް ނިންމާ.",
      "requested": "ރިކުއެސްޓްކުރެވިއްޖެ. ދެވަނަ މީހަކު އެޕްރޫވްކުރުމުން ލަޔަބިލިޓީ ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލާ ދެކޮޅަށް ދޫކޮށްލެވި، ޖޫރިމަނާ ޑްރާފްޓް ޕޭއަބަލެއްގެ ގޮތުގައި ހެދޭނެ.",
      "twoPerson": "މިއީ ރިކުއެސްޓެއް: އެޕްރޫވަލް ހުއްދަ ލިބިފައިވާ ދެވަނަ މީހެއް މި ހިންގާނެ. ތިބާގެ އަމިއްލަ ރިކުއެސްޓެއް ތިބާއަށް އެޕްރޫވެއް ނުކުރެވޭނެ.",
      "date": "ބާތިލްކުރާ ތާރީޚް",
      "released": "ދޫކޮށްލެވޭ ލަޔަބިލިޓީ",
      "penalty": "ޖޫރިމަނާ",
      "penaltyHint": "ބާތިލްކުރުމުން ލީސްދޭ ފަރާތަށް ދައްކަން ޖެހޭ މިންވަރު؛ ނެތްނަމަ ހުސްކޮށް ބަހައްޓާ.",
      "action": "ބާތިލްކުރުމަށް ރިކުއެސްޓްކުރޭ",
      "blockers": {
        "date": "ބާތިލްކުރާ ތާރީޚް ހޮވާ.",
        "penalty": "ސުމެއް ނުވަތަ އެއަށްވުރެ ބޮޑު ޖޫރިމަނާއެއް ޖައްސަވާ.",
        "reason": "ސަބަބެއް ޖައްސަވާ."
      }
    },
    "reports": {
      "title": "ލީސް ރިޕޯޓްތައް",
      "description": "ލީސް ލަޔަބިލިޓީގެ މެޗުއަރިޓީ ތަހުލީލާއި ލަޔަބިލިޓީ ރޯލް-ފޯވާޑް، ކޮންމެ ތާރީޚެއްގައި ހިނގަމުންދިޔަ ޝެޑިއުލުން.",
      "asOf": "ތާރީޚަށް",
      "todayHint": "މިއަދަށް ހުސްކޮށް ބަހައްޓާ.",
      "from": "ފެށޭ",
      "fromHint": "ނިމޭ އަހަރުގެ 1 ޖަނަވަރީއަށް ހުސްކޮށް ބަހައްޓާ.",
      "to": "ނިމޭ",
      "toBeforeFrom": "ނިމޭ ތާރީޚަކީ ފެށޭ ތާރީޚުގެ ކުރީގެ ތާރީޚަކަށް ނުވާނެ.",
      "tabs": {
        "maturity": "ލަޔަބިލިޓީ މެޗުއަރިޓީ",
        "rollForward": "ރޯލް-ފޯވާޑް"
      },
      "pickEntity": "ލީސް ރިޕޯޓްތައް ބެލުމަށް ޤާނޫނީ ފަރާތެއް ހޮވާ.",
      "export": "CSV އެކްސްޕޯޓް",
      "loadFailed": "ރިޕޯޓް ލޯޑް ނުކުރެވުނު",
      "empty": "މި ޤާނޫނީ ފަރާތަށް މި މުއްދަތުގައި ހިސާބަށް ނެގިފައިވާ ލީހެއް ނެތް.",
      "totals": "ޖުމްލަ",
      "columns": {
        "lease": "ލީސް"
      },
      "maturity": {
        "title": "ލީސް ލަޔަބިލިޓީ މެޗުއަރިޓީ",
        "asAt": "{date} ގެ ނިޔަލަށް",
        "within1Y": "1 އަހަރުގެ ތެރޭގައި",
        "y1To2": "1 އިން 2 އަހަރު",
        "y2To5": "2 އިން 5 އަހަރު",
        "over5Y": "5 އަހަރަށްވުރެ ގިނަ",
        "totalUndiscounted": "ޑިސްކައުންޓް ނުކޮށް ޖުމްލަ",
        "liability": "ލަޔަބިލިޓީ",
        "current": "ކަރަންޓް",
        "nonCurrent": "ނޮން-ކަރަންޓް"
      },
      "roll": {
        "title": "ލީސް ލަޔަބިލިޓީ ރޯލް-ފޯވާޑް",
        "between": "{from} އިން {to} އަށް",
        "opening": "ފެށުން",
        "additions": "އިތުރުކުރުން",
        "interest": "އިންޓެރެސްޓް",
        "remeasurements": "އަލުން މިނުން",
        "payments": "ފައިސާ ދެއްކުން",
        "terminations": "ބާތިލްކުރުން",
        "closing": "ނިމުން",
        "difference": "ބަޔާން ނުކުރެވޭ",
        "note": "އަދަދުތައް {currency} އިން. ހަރަކާތްތަކުން ބާކީ ބަޔާންކުރާއިރު ބަޔާން ނުކުރެވޭ އަދަދަކީ ސުމެއް."
      }
    },
    "runs": {
      "title": "ލީސް މުއްދަތުގެ ރަންތައް",
      "description": "ކޮންމެ ރަނަކުން ނިމިފައިވާ ކޮންމެ މުއްދަތެއްގެ އިންޓެރެސްޓް (ނުވަތަ އިސްތިސްނާ ލީހެއްގެ ހަމަހަމަ ޚަރަދު) ޕޯސްޓްކޮށް، ދައްކަން ޖެހޭ ކޮންމެ ފައިސާއަކަށް ޑްރާފްޓް ޕޭއަބަލެއް ހަދައި، ބޭނުންކުރުމުގެ ޙައްޤުގެ ޑިޕްރިސިއޭޝަން ހިންގާ.",
      "postTitle": "މުއްދަތުގެ ރަން ހިންގުން",
      "postDescription": "އަލުން ހިންގިޔަސް ރައްކާތެރި: ޕޯސްޓްކުރެވިފައިވާ މުއްދަތެއް ދެފަހަރު ޕޯސްޓެއް ނުކުރެވޭނެ.",
      "pickEntity": "ލީސްތައް ހިންގުމަށް ޤާނޫނީ ފަރާތެއް ހޮވާ.",
      "asOf": "ތާރީޚަށް",
      "post": "މިހާރު ހިންގާ",
      "nothingToDo": "އެއްވެސް އެއްޗެއް ޖެހިފައެއް ނުވޭ: އެ ތާރީޚާ ހަމައަށް ހުރިހާ މުއްދަތެއް ޕޯސްޓްކުރެވިފައިވޭ.",
      "posted": "ލީސް ރަން ޕޯސްޓްކުރެވިއްޖެ",
      "postedDetail": "{processed} މުއްދަތު ޕޯސްޓްކުރެވި، {drafted} ޕޭއަބަލް ޑްރާފްޓްކުރެވިއްޖެ.",
      "skippedTitle": "{count} ލައިން ޕޯސްޓް ނުކުރެވުނު:",
      "period": "މުއްދަތު {period}",
      "historyTitle": "ރަންތަކުގެ ތާރީޚް",
      "loadFailed": "ރަންތައް ލޯޑް ނުކުރެވުނު",
      "empty": "އަދި އެއްވެސް ލީސް ރަނަކުން އެއްވެސް އެއްޗެއް ޕޯސްޓެއް ނުކުރޭ.",
      "columns": {
        "asOf": "ތާރީޚަށް",
        "processed": "ޕޯސްޓްކުރެވުނު",
        "drafted": "ޑްރާފްޓްކުރެވުނު ޕޭއަބަލް",
        "interest": "އިންޓެރެސްޓް",
        "expense": "އިސްތިސްނާ ޚަރަދު",
        "depreciation": "ބޭނުންކުރުމުގެ ޙައްޤުގެ ޑިޕްރިސިއޭޝަން",
        "skipped": "ދޫކޮށްލެވުނު",
        "by": "ކުރީ"
      },
      "triggers": {
        "manual": "ޔޫޒަރެއް",
        "job": "ޝެޑިއުލްކުރެވިފައިވާ ރަން"
      }
    },
    "preview": {
      "contractHeading": "ލީސް އެގްރީމެންޓް",
      "changeHeading": "ލީސް ބަދަލު",
      "noAccess": "ތިބާއަށް ލީސް އެގްރީމެންޓްތައް ކިޔުމުގެ ހުއްދަ ނެތުމުން ލީހުގެ ތަފްސީލު ނުދައްކާ.",
      "loadFailed": "ލީސް ލޯޑް ނުކުރެވުނު",
      "open": "ލީސް ހުޅުވާ",
      "exemptEffect": "އެޕްރޫވްކުރުމުން އިސްތިސްނާ ލީހެއް ހިނގަން ފަށާނެ: އެއްވެސް މުދަލެއް ލަޔަބިލިޓީއެއް ހިސާބަށް ނުނެގޭ؛ މުއްދަތުގެ ރަނުން ހަމަހަމައަށް ޚަރަދު ނަގާނެ.",
      "recogniseEffect": "އެޕްރޫވްކުރުމުން ލީސް ހިސާބަށް ނެގޭނެ: ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދާ ރަޖިސްޓަރީކުރެވި، މިހާރުގެ އަގުން ފެށުމުގެ ޖާނަލް ޕޯސްޓްކުރެވޭނެ.",
      "changeDecided": "މި ބަދަލަކީ އަދި ނިންމުމަކަށް އިންތިޒާރުކުރާ ބަދަލެއް ނޫން؛ ނިންމި ގޮތް މަތީގައިވާ ރިކުއެސްޓްގެ ތާރީޚުގައި ލިޔެވިފައިވޭ.",
      "terminateEffect": "އެޕްރޫވްކުރުމުން ލަޔަބިލިޓީ ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދަލާ ދެކޮޅަށް ދޫކޮށްލައި، ޖޫރިމަނާ އުނިކޮށް ތަފާތު ފައިދާ ނުވަތަ ގެއްލުމެއްގެ ގޮތުގައި ހިސާބަށް ނަގައި، ޝެޑިއުލް ނިންމައި، ޖޫރިމަނާ ޑްރާފްޓް ޕޭއަބަލެއްގެ ގޮތުގައި ހެދޭނެ.",
      "terminateExemptEffect": "އެޕްރޫވްކުރުމުން މި އިސްތިސްނާ ލީހުގެ ޝެޑިއުލް ނިންމައި، ޖޫރިމަނާ ޑްރާފްޓް ޕޭއަބަލެއްގެ ގޮތުގައި ހެދޭނެ.",
      "remeasureEffect": "އެޕްރޫވްކުރުމުން އައު ޝެޑިއުލް ވަރޝަނެއް ލިޔެވި، ލީސް ލަޔަބިލިޓީއާއި ބޭނުންކުރުމުގެ ޙައްޤުގެ މުދާ އެއް މިންވަރަކަށް އެޑްޖަސްޓްކުރެވޭނެ."
    }
  },
  "revpolicy": {
    "nav": {
      "label": "އާމްދަނީގެ ސިޔާސަތު",
      "description": "އާމްދަނީ ގުނުމުގެ ސިޔާސަތު، އޭގެ ވާޝަންތައް އަދި ސިޔާސަތާ ޚިލާފު ގުނުންތައް"
    },
    "routeTitles": {
      "policy": "އާމްދަނީގެ ސިޔާސަތު"
    },
    "title": "އާމްދަނީ ގުނުމުގެ ސިޔާސަތު",
    "description": "ކޮންމެ މޮޑިއުލް ބާވަތަކަށް ބޭނުންކުރެވޭނެ ގުނުމުގެ ގޮތް، ދެވަނަ މީހަކު ތައްގަނޑު ޖަހާފައި. ކޮންމެ ގުނުމެއް ބަލަނީ އޭގެ ތާރީޚުގައި ހިނގި ސިޔާސަތާ އަޅައިގެން.",
    "scopes": {
      "sales": "ވިއްކުން",
      "subscription": "ސަބްސްކްރިޕްޝަން",
      "projects": "ޕްރޮޖެކްޓުތައް",
      "service": "ޚިދުމަތް",
      "pos": "ވިއްކާ ތަން",
      "pms": "ޕްރޮޕަޓީ މެނޭޖްމަންޓް"
    },
    "recognitions": {
      "point_in_time": "އެއް ވަގުތެއްގައި",
      "over_time": "މުއްދަތަކަށް",
      "milestone": "މައިލްސްޓޯން",
      "as_billed": "ބިލުކުރާ ގޮތަށް"
    },
    "triggers": {
      "control_transfer": "ކޮންޓްރޯލް ބަދަލުވުން",
      "service_completed": "ޚިދުމަތް ނިމުން",
      "day_close": "ވިޔަފާރި ދުވަސް ބަންދުވުން",
      "night_audit": "ރޭގަނޑުގެ އޮޑިޓް",
      "invoice": "އިންވޮއިސް ހެދުން",
      "time_incurred": "ވަގުތު ހޭދަވުން",
      "period_elapsed": "މުއްދަތު ފާއިތުވުން",
      "progress_measured": "ކުރިއެރުން މިނުން",
      "milestone_certified": "މައިލްސްޓޯން ޔަޤީންކުރުން"
    },
    "ssp": {
      "observable": "ފެންނަ އަގު",
      "adjusted_market": "ބާޒާރަށް ބަލައި ބަދަލުކުރި އަގު",
      "expected_cost_plus": "ލަފާކުރާ ޚަރަދާއި ފައިދާ",
      "residual": "ބާކީ",
      "not_applicable": "ނުގުޅޭ"
    },
    "statuses": {
      "draft": "ޑްރާފްޓް",
      "submitted": "ތައްގަނޑަށް އިންތިޒާރުގައި",
      "in_force": "ހިނގަމުންދާ",
      "superseded": "ބަދަލުކުރެވިފައި",
      "discarded": "ދޫކޮށްލެވިފައި"
    },
    "fields": {
      "name": "ނަން",
      "description": "ތަފްސީލް",
      "requestedEffectiveFrom": "ފެށޭ ތާރީޚް",
      "firstDateHint": "ފުރަތަމަ ސިޔާސަތު ފެށިދާނީ އެ ސިޔާސަތު ބޭނުންކުރާ މުއްދަތުގެ ފެށުމުން.",
      "successorDateHint": "މިއަދު ނުވަތަ އޭގެ ފަހުން، އަދި ހިނގަމުންދާ ސިޔާސަތު ފެށުމަށް ފަހު. ހިނގަމުންދާ ސިޔާސަތު ނިމޭނީ އޭގެ ކުރީ ދުވަހު."
    },
    "grid": {
      "title": "ގަވާއިދުތައް",
      "help": "ކޮންމެ ގަވާއިދަކުން މޮޑިއުލް ބާވަތަކަށް އެއް ގުނުމުގެ ގޮތެއް ހުއްދަކޮށް، އެ ގުނޭ ހާދިސާ ބަޔާންކުރެއެވެ. އެއް ބާވަތަކަށް އެއް ގޮތަށްވުރެ ގިނަ ގޮތް ހުއްދަ ކުރެވޭނެ، ނަމަވެސް ކޮންމެ ގޮތެއް އެއް ފަހަރު.",
      "scope": "މޮޑިއުލް ބާވަތް",
      "recognition": "ގުނުން",
      "trigger": "ގުނޭ ހާދިސާ",
      "ssp": "ވަކިން ވިއްކާ އަގު",
      "note": "ނޯޓް",
      "change": "ބަދަލު",
      "empty": "މި ވާޝަނުގައި ގަވާއިދެއް ނެތް.",
      "emptyEditable": "އަދި ގަވާއިދެއް ނެތް. ފުރަތަމަ ގަވާއިދު އިތުރުކުރައްވާ.",
      "was": "ކުރިން {value}",
      "noNote": "ނޯޓެއް ނެތް",
      "choose": "ހޮވާ",
      "moveUp": "ގަވާއިދު {row} މައްޗަށް",
      "moveDown": "ގަވާއިދު {row} ތިރިއަށް",
      "remove": "ނައްތާލާ",
      "add": "ގަވާއިދު އިތުރުކުރޭ",
      "diff": {
        "added": "އިތުރުކުރެވިފައި",
        "removed": "ނައްތާލެވިފައި",
        "changed": "ބަދަލުކުރެވިފައި",
        "unchanged": "ބަދަލެއް ނެތް"
      }
    },
    "problems": {
      "required": "އަގެއް ހޮއްވަވާ.",
      "fits": "މި ހާދިސާ ހޮވި ގުނުމާ ނުގުޅޭ.",
      "not_allowed": "ވަކިން ވިއްކާ އަގުގެ ގޮތް ގުޅެނީ ވިއްކުމުގެ ގަވާއިދުތަކާ އެކަނި.",
      "max": "ނޯޓެއްގައި ގިނަވެގެން {max} އަކުރު.",
      "unique": "ގަވާއިދު {row} ން މި ބާވަތަށް މި ގުނުން ހުއްދަކޮށްފައިވޭ."
    },
    "inForce": {
      "title": "ހިނގަމުންދާ ސިޔާސަތު",
      "loadFailed": "އާމްދަނީގެ ސިޔާސަތު ލޯޑް ނުކުރެވުނު.",
      "none": "އަދި އާމްދަނީގެ ސިޔާސަތެއް ހިނގަމުން ނުދޭ.",
      "noneCanCreate": "އަދި އާމްދަނީގެ ސިޔާސަތެއް ހިނގަމުން ނުދޭ. ފުރަތަމަ ސިޔާސަތު ތިރީގައި ޑްރާފްޓް ކުރައްވާ.",
      "effectiveFrom": "ހިނގަން ފެށި ތާރީޚް",
      "effectiveTo": "ހިނގާނެ ތާރީޚާ ހަމައަށް",
      "preparedBy": "ތައްޔާރުކުރީ",
      "approvedBy": "ތައްގަނޑު ޖެހީ"
    },
    "draft": {
      "createTitle": "ފުރަތަމަ އާމްދަނީގެ ސިޔާސަތު ޑްރާފްޓް ކުރުން",
      "title": "ހުޅުވިފައިވާ ވާޝަން {no}",
      "preparedBy": "ތައްޔާރުކުރީ {name}",
      "successorOf": "ވާޝަން އައިޑީ {id} ގެ ބަދަލުގައި",
      "returned": "ޑްރާފްޓަށް އަނބުރާލެވުނު: {note}",
      "awaiting": "މި ވާޝަން އިންތިޒާރު ކުރަނީ ދެވަނަ މީހަކު ތައްގަނޑު ޖެހުމަށް.",
      "toApprovals": "އެޕްރޫވަލް އިންބޮކްސް ހުޅުވާ",
      "preparerOnly": "މި ޑްރާފްޓް ބަދަލުކުރުމާއި ހުށަހެޅުމާއި ދޫކޮށްލެވޭނީ އެ ތައްޔާރުކުރި މީހާއަށް އެކަނި.",
      "stale": "ތިބާ ހުޅުވި ފަހުން މި ޑްރާފްޓް ބަދަލުވެއްޖެ. އަލުން ލޯޑްކޮށް، ބަދަލުތައް އަލުން ގެންނަވާ.",
      "reload": "އަލުން ލޯޑްކުރޭ",
      "actionsLabel": "ޑްރާފްޓްގެ ޢަމަލުތައް",
      "discard": "ޑްރާފްޓް ދޫކޮށްލާ",
      "save": "ޑްރާފްޓް ސޭވްކުރޭ",
      "create": "ޑްރާފްޓް ހަދާ",
      "submit": "ތައްގަނޑަށް ހުށަހަޅާ",
      "discardTitle": "މި ޑްރާފްޓް ދޫކޮށްލަންތޯ؟",
      "discardMessage": "ޑްރާފްޓް ރިކޯޑުގައި ދޫކޮށްލެވިފައިވާ ގޮތަށް ބެހެއްޓޭނެ، އަދި އާ ވާޝަނެއް ހުޅުވޭނެ.",
      "blockers": {
        "name": "ނަމެއް ލިޔުއްވާ.",
        "date": "ސިޔާސަތު ފެށޭ ތާރީޚް ލިޔުއްވާ.",
        "rules": "ތިރީގައި ފާހަގަކޮށްފައިވާ ގަވާއިދުތައް ރަނގަޅުކުރައްވާ.",
        "nothing": "އެއްވެސް ބަދަލެއް ނެތް."
      },
      "submitBlockers": {
        "unsaved": "ހުށަހެޅުމުގެ ކުރިން ބަދަލުތައް ސޭވްކުރައްވާ.",
        "noRules": "ހުށަހެޅުމުގެ ކުރިން މަދުވެގެން އެއް ގަވާއިދު އިތުރުކުރައްވާ."
      }
    },
    "toasts": {
      "created": "ޑްރާފްޓް ހެދިއްޖެ",
      "saved": "ޑްރާފްޓް ސޭވްވެއްޖެ",
      "saveFailed": "ޑްރާފްޓް ސޭވް ނުކުރެވުނު",
      "submitted": "ތައްގަނޑަށް ހުށަހެޅިއްޖެ",
      "submittedDetail": "ދެވަނަ މީހަކު ތައްގަނޑު ޖެހުމުން ވާޝަން ހިނގަން ފަށާނެ.",
      "submitFailed": "ޑްރާފްޓް ހުށަނާޅުނު",
      "discarded": "ޑްރާފްޓް ދޫކޮށްލެވިއްޖެ",
      "discardFailed": "ޑްރާފްޓް ދޫކޮށް ނުލެވުނު"
    },
    "supersede": {
      "start": "އާ ވާޝަނެއް ހުޅުވާ",
      "help": "އާ ވާޝަން ފެށޭނީ {no} ގެ ގަވާއިދުތަކުގެ ކޮޕީއަކުން. އެ ތައްޔާރުކުރާނީ ތިބާ؛ އާ ވާޝަން ތައްގަނޑު ޖެހެންދެން {no} ހިނގަމުންދާނެ.",
      "stale": "ތިބާ މި ފޯމު ހުޅުވި ފަހުން ހިނގަމުންދާ ސިޔާސަތު ބަދަލުވެއްޖެ. އަލުން ލޯޑްކޮށް އަނެއްކާ މަސައްކަތްކުރައްވާ.",
      "open": "އާ ވާޝަން ހުޅުވާ",
      "opened": "އާ ވާޝަން ހުޅުވިއްޖެ",
      "failed": "އާ ވާޝަން ނުހުޅުވުނު"
    },
    "history": {
      "title": "ވާޝަންތައް",
      "description": "ސިޔާސަތުގެ ހުރިހާ ވާޝަނެއް، އެންމެ އާ އެއް ފުރަތަމަ.",
      "status": "ހާލަތު",
      "allStatuses": "ހުރިހާ ހާލަތެއް",
      "loadFailed": "ސިޔާސަތުގެ ވާޝަންތައް ލޯޑް ނުކުރެވުނު.",
      "empty": "އަދި ވާޝަނެއް ނެތް.",
      "version": "ވާޝަން",
      "inForce": "ހިނގި މުއްދަތު",
      "preparedBy": "ތައްޔާރުކުރީ",
      "approvedBy": "ތައްގަނޑު ޖެހީ",
      "openEnded": "ހުޅުވިފައި",
      "showRules": "ގަވާއިދުތައް ދައްކާ",
      "hideRules": "ގަވާއިދުތައް ފޮރުވާ",
      "rejectionNote": "އެންމެ ފަހުން އަނބުރާލެވުނީ: {note}"
    },
    "departures": {
      "title": "ސިޔާސަތާ ޚިލާފު ގުނުންތައް",
      "description": "މި މުއްދަތުގައި، އެ ތާރީޚުގައި ހިނގި ސިޔާސަތު ހުއްދަ ނުކުރާ ގުނުންތައް.",
      "entity": "ޤާނޫނީ ފަރާތް",
      "from": "ފެށޭ",
      "to": "ނިމޭ",
      "scope": "މޮޑިއުލް ބާވަތް",
      "allScopes": "ހުރިހާ ބާވަތެއް",
      "range": {
        "dates": "ދެ ތާރީޚުވެސް ލިޔުއްވާ.",
        "order": "ނިމޭ ތާރީޚް ފެށޭ ތާރީޚުގެ ކުރިން ނުވާނެ."
      },
      "loadFailed": "ޚިލާފު ގުނުންތަކުގެ ރިޕޯޓް ލޯޑް ނުކުރެވުނު.",
      "truncated": "ބައެއް ބާވަތްތަކުގައި އެއް ރިޕޯޓަކުން ބަލާ އަދަދަށްވުރެ ގިނަ ލިޔުންތައް އޮތް. ހުރިހާ އެއްޗެއް ފެނުމަށް މުއްދަތު ކުޑަކުރައްވާ.",
      "examined": "ބެލި ލިޔުންތައް",
      "count": "ޚިލާފު ގުނުންތައް",
      "partial": "ބައެއް",
      "none": "ބެލި {count} ލިޔުމުގެ ތެރޭގައި ޚިލާފު ގުނުމެއް ނެތް.",
      "docDate": "ތާރީޚް",
      "document": "ލިޔުން",
      "actual": "ގުނުނު ގޮތް",
      "policy": "ސިޔާސަތު",
      "permitted": "ސިޔާސަތު ހުއްދަކުރާ",
      "reason": "ޚިލާފުވާ ސަބަބު",
      "amount": "އަދަދު",
      "version": "RVP-{no}",
      "noPolicy": "އެއްވެސް ސިޔާސަތެއް ނުހިނގާ",
      "reasons": {
        "no_policy_in_force": "މި ތާރީޚުގައި އެއްވެސް ސިޔާސަތެއް ނުހިނގާ",
        "scope_not_covered": "ސިޔާސަތުގައި މި ބާވަތަށް ގަވާއިދެއް ނެތް",
        "recognition_not_permitted": "ގުނުން ހުއްދައެއް ނޫން",
        "trigger_differs": "އެހެން ހާދިސާއަކުން ގުނިފައި",
        "ssp_method_differs": "ވިއްކާ އަގުގެ އެހެން ގޮތެއް"
      }
    },
    "preview": {
      "heading": "އާމްދަނީގެ ސިޔާސަތުގެ ވާޝަން",
      "noAccess": "މި ވާޝަން ފެނުމަށް އާމްދަނީގެ ސިޔާސަތު ކިޔުމުގެ ހުއްދަ ބޭނުންވޭ.",
      "loadFailed": "ސިޔާސަތުގެ ވާޝަން ލޯޑް ނުކުރެވުނު.",
      "baseLoadFailed": "މި ވާޝަނުން ބަދަލުކުރާ ސިޔާސަތު ލޯޑް ނުކުރެވުނު.",
      "version": "ވާޝަން",
      "preparedBy": "ތައްޔާރުކުރީ",
      "replaces": "ބަދަލުކުރަނީ",
      "firstPolicy": "އެއްވެސް އެއްޗެއް ނޫން: މިއީ ފުރަތަމަ ސިޔާސަތު",
      "changes": "ބަދަލުކުރާ ސިޔާސަތާ އަޅާބަލާއިރު ގަވާއިދުގެ ބަދަލުތައް: {count}",
      "open": "އާމްދަނީގެ ސިޔާސަތު ހުޅުވާ"
    }
  },
  "liability": {
    "nav": {
      "label": "ކަސްޓަމަރުންނަށް ދައްކަންޖެހޭ ވަސީލަތްތައް",
      "description": "ގިފްޓް ކާޑު، ސްޓޯރ ކްރެޑިޓް، މެހެމާނުންގެ ޑިޕޮޒިޓް އަދި އޮން-އެކައުންޓް ރިސީޓް، ބްރޭކޭޖާއެކު"
    },
    "routeTitles": {
      "instruments": "ކަސްޓަމަރުންނަށް ދައްކަންޖެހޭ ވަސީލަތްތައް"
    },
    "title": "ކަސްޓަމަރުންނަށް ދައްކަންޖެހޭ ވަސީލަތްތައް",
    "description": "ކަސްޓަމަރުންނަށް ދައްކަންޖެހޭ އަގު: ގިފްޓް ކާޑު، ސްޓޯރ ކްރެޑިޓް، މެހެމާނުންގެ ޑިޕޮޒިޓް އަދި އޮން-އެކައުންޓް ރިސީޓް. ކޮންމެ ލައިނެއްގައި ދޫކުރި، ބޭނުންކުރި، މުއްދަތު ހަމަވި އަދި ބްރޭކޭޖްގެ ގޮތުގައި ގުނުނު އަދަދު، ވަސީލަތުގެ ފައިސާއިން.",
    "entitiesFailed": "ޤާނޫނީ ފަރާތްތައް ލޯޑް ނުވި",
    "tabs": {
      "register": "ރަޖިސްޓަރީ",
      "breakage": "ބްރޭކޭޖް",
      "settings": "ސެޓިންގްސް"
    },
    "fields": {
      "entity": "ޤާނޫނީ ފަރާތް",
      "kind": "ބާވަތް",
      "allKinds": "ހުރިހާ ބާވަތެއް",
      "status": "ހާލަތު",
      "allStatuses": "ހުރިހާ ހާލަތެއް",
      "currency": "ފައިސާ",
      "anyCurrency": "ކޮންމެ ފައިސާއެއް"
    },
    "kinds": {
      "gift_card": "ގިފްޓް ކާޑު",
      "store_credit": "ސްޓޯރ ކްރެޑިޓް",
      "guest_deposit": "މެހެމާނުގެ ޑިޕޮޒިޓް",
      "ar_on_account": "އޮން-އެކައުންޓް ރިސީޓް"
    },
    "statuses": {
      "active": "ހަރަކާތްތެރި",
      "exhausted": "ހުސްވެފައި",
      "expired": "މުއްދަތު ހަމަވެފައި",
      "void": "ބާޠިލް"
    },
    "policies": {
      "none": "ބްރޭކޭޖް ނުގުނާ",
      "at_expiry": "މުއްދަތު ހަމަވާއިރު ގުނާ"
    },
    "policyHints": {
      "none": "މުއްދަތު ހަމަވި ބާކީ ލަޔަބިލިޓީއެއްގެ ގޮތުގައި ފޮތުގައި ބާކީ ހުންނާނެ.",
      "at_expiry": "މުއްދަތު ހަމަވި ބާކީ އެކްސްޕަޔަރީ ސްވީޕުން އާމްދަނީގެ ގޮތުގައި ގުނާނީ، ތިރީގައިވާ އެކައުންޓަށް ކްރެޑިޓްކޮށް."
    },
    "columns": {
      "reference": "ރެފަރެންސް",
      "kind": "ބާވަތް",
      "entity": "ޤާނޫނީ ފަރާތް",
      "issuedOn": "ދޫކުރި ތާރީޚު",
      "expiresOn": "މުއްދަތު ހަމަވާ ތާރީޚު",
      "status": "ހާލަތު",
      "issued": "ދޫކުރި",
      "adjusted": "އިސްލާހުކުރި",
      "redeemed": "ބޭނުންކުރި",
      "refunded": "އަނބުރާ ދިން",
      "expired": "މުއްދަތު ހަމަވި",
      "breakage": "ބްރޭކޭޖް",
      "unrecognised": "ނުގުނާ ބްރޭކޭޖް",
      "outstanding": "ބާކީ",
      "currency": "ފައިސާ",
      "count": "ވަސީލަތްތައް",
      "rate": "ބްރޭކޭޖް ރޭޓް",
      "issuePeriod": "ދޫކުރި މަސް"
    },
    "register": {
      "title": "ރަޖިސްޓަރީ",
      "description": "ކަސްޓަމަރުންނަށް ދައްކަންޖެހޭ ކޮންމެ ވަސީލަތެއް، އެންމެ އާ އެއްޗެއް ފުރަތަމަ. ރިސީޓެއް ހުޅުވޭނީ އޭގެ ޑޮކިއުމަންޓަށް؛ ގިފްޓް ކާޑު، ސްޓޯރ ކްރެޑިޓް އަދި ޑިޕޮޒިޓަށް ވަކި ޞަފްޙާއެއް ނެތް.",
      "currencyInvalid": "3 އަކުރުގެ ފައިސާގެ ކޯޑެއް ޖައްސަވާ",
      "clearFilters": "ފިލްޓަރުތައް ފޮހެލާ",
      "loadFailed": "ރަޖިސްޓަރީ ލޯޑް ނުވި",
      "emptyTitle": "އަދި ކަސްޓަމަރުންނަށް ދައްކަންޖެހޭ އެއްވެސް ވަސީލަތެއް ނެތް",
      "emptyDescription": "ޕީއޯއެސްގައި ދޫކުރާ ގިފްޓް ކާޑާއި ސްޓޯރ ކްރެޑިޓް، ޕީއެމްއެސްގައި ނަގާ ޑިޕޮޒިޓް އަދި ނުބެހޭ ކަސްޓަމަރ ރިސީޓް މިތާ ފެންނާނެ.",
      "emptyFilteredTitle": "މި ފިލްޓަރުތަކާ ގުޅޭ އެއްޗެއް ނެތް",
      "emptyFilteredDescription": "ފިލްޓަރެއް ފޮހެލާ ނުވަތަ އެހެން ޤާނޫނީ ފަރާތެއް ހޮވާ.",
      "unrecognised": "{amount} އަދި ނުގުނާ",
      "unrecognisedHint": "އެއްވެސް ބްރޭކޭޖް ސިޔާސަތެއް ނުގުނާތީ، މުއްދަތު ހަމަވި އަގު އަދިވެސް ލަޔަބިލިޓީއެއްގެ ގޮތުގައި"
    },
    "breakage": {
      "title": "ބްރޭކޭޖް ތަޙުލީލު",
      "description": "ދޫކުރި މަސް، ބާވަތް އަދި ފައިސާއިން ވަސީލަތްތައް، ބޭނުންކުރި، މުއްދަތު ހަމަވި އަދި ބްރޭކޭޖްގެ ގޮތުގައި ގުނުނު އަދަދާއެކު. ރޭންޖަކީ ދޫކުރި ތާރީޚުގެ ހަދު؛ ހަދެއް ނެތްނަމަ ހުސްކޮށް ބާއްވާ.",
      "from": "ދޫކުރި ތާރީޚު (ފެށުން)",
      "to": "ދޫކުރި ތާރީޚު (ނިމުން)",
      "range": {
        "dates": "ތާރީޚު ޖައްސަވާ YYYY-MM-DD ގޮތަށް",
        "order": "ރޭންޖުގެ ނިމުމަކީ ފެށުމުގެ ކުރީ ތާރީޚެއް"
      },
      "loadFailed": "ބްރޭކޭޖް ތަޙުލީލު ލޯޑް ނުވި",
      "policyLine": "ބްރޭކޭޖް ސިޔާސަތު: {policy}. އާމްދަނީގެ އެކައުންޓް: {account}.",
      "emptyTitle": "މި ރޭންޖުގައި އެއްވެސް ވަސީލަތެއް ދޫކޮށްފައެއް ނެތް",
      "emptyDescription": "ދޫކުރި ތާރީޚުގެ ރޭންޖު ފުޅާކުރައްވާ ނުވަތަ އެހެން ޤާނޫނީ ފަރާތެއް ހޮވާ.",
      "totals": "ބާވަތާއި ފައިސާއިން ޖުމްލަ",
      "byPeriod": "ދޫކުރި މަހުން",
      "openRegister": "ރަޖިސްޓަރީގައި ހުޅުވާ"
    },
    "settings": {
      "title": "ބްރޭކޭޖް ސިޔާސަތު",
      "description": "މުއްދަތު ހަމަވި ގިފްޓް ކާޑާއި ސްޓޯރ ކްރެޑިޓް އާމްދަނީއަކަށް ވާނަމަ، އަދި އެ ކްރެޑިޓްކުރާ އާމްދަނީގެ އެކައުންޓް.",
      "noAccount": "ކަނޑައަޅާފައެއް ނެތް",
      "noEntityTitle": "ސެޓްކުރާނެ ޤާނޫނީ ފަރާތެއް ނެތް",
      "noEntityDescription": "ފުރަތަމަ ޤާނޫނީ ފަރާތެއް ހައްދަވާ؛ ބްރޭކޭޖް ސިޔާސަތު ކަނޑައަޅަނީ ކޮންމެ ފަރާތަކަށް ވަކިން.",
      "loadFailed": "ބްރޭކޭޖް ސިޔާސަތު ލޯޑް ނުވި",
      "neverSaved": "މި ޤާނޫނީ ފަރާތުން އަދި ބްރޭކޭޖް ސިޔާސަތެއް ކަނޑައަޅާފައެއް ނެތް؛ އެ ކަނޑައަޅަންދެން މުއްދަތު ހަމަވި ބާކީ ފޮތުގައި ހުންނާނެ.",
      "lastChangedBy": "އެންމެ ފަހުން ބަދަލުކުރީ {name}",
      "staleHint": "މި ސިޔާސަތު އެހެން މީހަކު ބަދަލުކޮށްފި. އަލުން ލޯޑްކޮށް ތިބާގެ ބަދަލު އަލުން ގެންނަވާ.",
      "reload": "އަލުން ލޯޑްކުރޭ",
      "policy": "ސިޔާސަތު",
      "noAccountPermission": "އެކައުންޓުތަކުގެ ޗާޓު ކިޔުމުގެ ހުއްދައެއް ނެތީތީ، އާމްދަނީގެ އެކައުންޓް މިތާނގައި ހޮވޭކަށް ނެތް.",
      "account": "ބްރޭކޭޖް އާމްދަނީގެ އެކައުންޓް",
      "accountHint": "މި ޤާނޫނީ ފަރާތުގެ، ހަރަކާތްތެރި، ޕޯސްޓްކުރެވޭ އާމްދަނީގެ އެކައުންޓެއް.",
      "accountRequired": "ބްރޭކޭޖް ގުނުމަށް، އެ ކްރެޑިޓްކުރާ އާމްދަނީގެ އެކައުންޓް ބޭނުންވޭ",
      "save": "ސިޔާސަތު ރައްކާކުރޭ",
      "saved": "ބްރޭކޭޖް ސިޔާސަތު ރައްކާކުރެވިއްޖެ",
      "submit": "ރުހުމަށް ހުށަހަޅާ",
      "submitted": "ރުހުމަށް ހުށަހެޅިއްޖެ. ހިނގަމުންދާ ސިޔާސަތު އަދި ބަދަލެއް ނުވޭ.",
      "needsApproval": "ބްރޭކޭޖް ގުނަން ފެށުމާއި ނުވަތަ އާމްދަނީގެ އެކައުންޓް ބަދަލުކުރުމަކީ އާމްދަނީ ފެށުން ނުވަތަ ބަދަލުކުރުމަކަށް ވާތީ، ދެވަނަ މީހެއްގެ ރުހުން ބޭނުންވޭ. ރައްކާކުރުމުން ރުހުމަށް ހުށަހެޅޭ؛ އެ ހަމަވަންދެން ހިނގަމުންދާ ސިޔާސަތު ބަދަލެއް ނުވޭ.",
      "blockedByPending": "ބަދަލެއް ކުރިން ރުހުމަށް މަޑުކުރަމުންދޭ. އެހެން ބަދަލެއް ހުށަހަޅުއްވުމުގެ ކުރިން އެ ފަހަތަށް ގެންގޮސް ނުވަތަ ނިންމާކަށް މަޑުކުރައްވާ.",
      "tightensPending": "މިކަން ރައްކާކުރުމުން ބްރޭކޭޖް ގުނުން ވަގުތުން ހުއްޓުވާ، އަދި ރުހުމަށް މަޑުކުރާ ބަދަލު ފަހަތަށް ގެންގޮސްދޭނެ.",
      "withdrawn": "ބަދަލު ފަހަތަށް ގެންގޮސްފި",
      "pending": {
        "title": "ރުހުމަށް މަޑުކުރަނީ",
        "description": "މަތީގައިވާ ސިޔާސަތަކީ ކުރިއަށްދާ ސިޔާސަތު. މި ބަދަލު އަމަލުވާނީ އެ އެދުނު މީހާ ނޫން އެހެން މީހަކު ރުހުންތަކުގެ އިންބޮކްސްގައި ރުހުން ދެއްވައިފިނަމައެވެ.",
        "requestedBy": "އެދުނީ",
        "requestedAt": "އެދުނު ވަގުތު",
        "withdraw": "އެދުން ފަހަތަށް ގެންގުޅޭ",
        "waiting": "އެ ފަހަތަށް ގެންދެވޭނީ އެދުނު {name} އަށް ކުރިއަށް. އެހެން އެންމެން ނިންމާނީ ރުހުންތަކުގެ އިންބޮކްސްގައި."
      }
    },
    "preview": {
      "heading": "ބްރޭކޭޖް ސިޔާސަތުގެ ބަދަލު",
      "noAccess": "ލައިބިލިޓީ ސެޓިންގްސް ކިޔުމުގެ ހުއްދައެއް ނެތީތީ، މި ބަދަލު މިތާނގައި ދައްކާކަށް ނެތް.",
      "loadFailed": "ބްރޭކޭޖް ސިޔާސަތުގެ ބަދަލު ލޯޑް ނުވި",
      "notFound": "މި ބަދަލު މިހާރު ނެތް.",
      "entity": "ޤާނޫނީ ފަރާތް",
      "inForce": "ކުރިއަށްދާ",
      "proposed": "އެދުނު",
      "account": "އާމްދަނީގެ އެކައުންޓް",
      "requestedBy": "އެދުނީ",
      "requestedAt": "އެދުނު ވަގުތު",
      "decision": "ނިންމުން",
      "ownRequest": "މި ބަދަލަށް އެދުނީ ތިބާ؛ އެހެން މީހަކު ނިންމަންވާނެ.",
      "consequenceStart": "ރުހުން ދިނުމުން މުއްދަތު ހަމަވި ގިފްޓް ކާޑާއި ސްޓޯރ ކްރެޑިޓްގެ ބާކީ އެކްސްޕަޔަރީގައި އާމްދަނީއަކަށް ގުނަން ފެށޭ، އެދުނު އެކައުންޓަށް ކްރެޑިޓްކުރެވޭ.",
      "consequenceMove": "ރުހުން ދިނުމުން ބްރޭކޭޖް އާމްދަނީ ކްރެޑިޓްކުރާ އެކައުންޓް ބަދަލުވޭ.",
      "open": "ލައިބިލިޓީ ސެޓިންގްސް ހުޅުވާ",
      "statuses": {
        "pending": "ރުހުމަށް މަޑުކުރަނީ",
        "applied": "އަމަލުކުރެވިފި",
        "rejected": "ބާތިލުކުރެވިފި",
        "cancelled": "ފަހަތަށް ގެންގޮސްފި"
      }
    }
  }
}
